/**
 * Provides functionality for forms in Zuant
 * @module forms
 */

(function () {
  'use strict';

  angular
    .module('forms', ['ui.router', 'common', 'zp.api', 'zp.message', 'chart.js']);

})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('RemoveUnwantedColumns', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    return function (formColumns, columnsToKeep) {

      const columnsToDownload = formColumns
        .sort(function(a, b) {
          const indexA = columnsToKeep.indexOf(a.databasefieldname);
          const indexB = columnsToKeep.indexOf(b.databasefieldname);
        
          const indexOfA = indexA === -1 ? Infinity : indexA;
          const indexOfB = indexB === -1 ? Infinity : indexB;
    
          return indexOfA - indexOfB;
        })
        .filter(function (e) {
          return this.indexOf(e.databasefieldname) != -1;
        }, columnsToKeep);

      return columnsToDownload;
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('MoveImagesColumnToTheEnd', factory);

  factory.$inject = ['ArrayMove'];
  /* ng-inject */
  function factory(ArrayMove) {

    return function (formColumns) {
      const index = formColumns.findIndex(col => col.databasefieldname === '_images');
      return ArrayMove(formColumns, index, formColumns.length - 1);
    };

  }
})();
(function () {
  'use strict';

  angular
    .module('forms')
    .factory('ColumnsHelperFactory', factory);

  factory.$inject = ['FormMetadataFactory', 'RemoveUnwantedColumns', 'MoveImagesColumnToTheEnd', 'AddLitBreakoutColumns'];
  /* ng-inject */
  function factory(FormMetadataFactory, RemoveUnwantedColumns, MoveImagesColumnToTheEnd, AddLitBreakoutColumns) {

    return {
      getFormMetadata: getFormMetadata,
      moveImagesColumnToTheEnd: MoveImagesColumnToTheEnd,
      addLatestEmailActivtyColumn: addLatestEmailActivtyColumn,
      removeUnwantedColumns: RemoveUnwantedColumns,
      addLitBreakoutColumns: AddLitBreakoutColumns
    };

    function getFormMetadata() {
      return angular.copy(FormMetadataFactory.getData()).columnsData.items;
    }

    function addLatestEmailActivtyColumn(formColumns) {
      const colToAdd = {
        databasefieldname: 'latestEmailEvent',
        label: 'Most recent email activity',
        object: 'response'
      };
      const index = formColumns.findIndex(col => col.databasefieldname === 'emailEvents');
      if (index != -1) formColumns.splice(index + 1, 0, colToAdd);
    }


  }
})();
(function () {
  'use strict';

  angular
    .module('forms')
    .factory('AddLitBreakoutColumns', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    return function (formColumns) {
      // add literature columns to formColumns
      formColumns.push({
        label: 'Title',
        databasefieldname: 'littitle',
        object: 'response'
      });
      formColumns.push({
        label: 'Category',
        databasefieldname: 'tagcategory',
        object: 'response'
      });
      formColumns.push({
        label: 'Tag',
        databasefieldname: 'tagname',
        object: 'response'
      });
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('AddLatestEmailActivtyColumn', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    return function addLatestEmailActivtyColumn(formColumns) {
      // want to add this column just after the 'emailEvents' column
      const insertIndex = formColumns.findIndex(isEmailEventsColumn);
      if (insertIndex !== -1) {

        const columnToAdd = {
          databasefieldname: 'latestEmailEvent',
          label: 'Most recent email activity',
          object: 'response'
        };

        formColumns.splice(insertIndex + 1, 0, columnToAdd);
      }
    };

    function isEmailEventsColumn(column) {
      return column.databasefieldname === 'emailEvents';
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('forms')
    .factory('ColumnsForDownload', factory);

  factory.$inject = ['ColumnsHelperFactory'];
  /* ng-inject */
  function factory(ColumnsHelperFactory) {

    return function (downloadOptions) {

      let formColumns = ColumnsHelperFactory.getFormMetadata();

      ColumnsHelperFactory.moveImagesColumnToTheEnd(formColumns);
      ColumnsHelperFactory.addLatestEmailActivtyColumn(formColumns);

      formColumns = ColumnsHelperFactory.removeUnwantedColumns(formColumns, downloadOptions.columns);

      if (downloadOptions.literatureBreakout) {
        ColumnsHelperFactory.addLitBreakoutColumns(formColumns);
      }
      return formColumns;
    };
   
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .controller('FilenameDialog', ctrl);

  ctrl.$inject = ['locals', 'MessageService'];
  /* ng-inject */
  function ctrl(locals, MessageService) {

    var vm = this;

    vm.$onInit = function () {
      vm.filename = locals.filename;
      vm.toolbarTitle = locals.toolbarTitle;
    };

    vm.closeDialog = function () {
      MessageService.cancelDialog();
    };

    vm.done = function () {
      MessageService.closeDialog(vm.filename);
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('RemoveArchivedLeadsFromRawData', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    return function (rawLeadDataWithArchives, data) {

      const filteredLeads = [];

      _.each(rawLeadDataWithArchives, function (lead) {
        _.each(data.items, function (item) {
          if (item.response._id === lead.response._id) {
            filteredLeads.push(lead);
          }
        });
      });
      return filteredLeads;
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('BreakoutLeadData', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    return function (rawLeadData, data, formColumns) {

      const breakoutLookups = data.breakoutLookups;
      const literature = data.relatedLiteratures;
      const subresponses = data.subresponses;
      const tags = data.relatedTags;

      const breakoutColumnsAdded = [];

      for (let b = 0; b < breakoutLookups.length; b++) {
        for (const bkey in breakoutLookups[b]) {
          switch (bkey) {
            case 'lookupkeys':
            case 'lookupname':
            case '_id':
            case '_lastmodifieddatelocalutc':
            case '_lastmodifiedonservertime':
            case 'lookupobject':
            case '_uw':
            case 'artefactType':
            case '_uwArray':
              break;
            default:
              if (breakoutColumnsAdded.indexOf(bkey) === -1 && breakoutLookups[b].lookupkeys.indexOf(bkey) === -1) {
                breakoutColumnsAdded.push(bkey);
                formColumns.push({
                  label: bkey,
                  databasefieldname: bkey,
                  object: breakoutLookups[b].lookupobject || 'response'
                });
              }
              break;
          }
        }
      }

      const subresponseColumnsAdded = [];

      for (let s = 0; s < subresponses.length; s++) {
        for (const skey in subresponses[s]) {
          if (skey[0] !== '_' && subresponseColumnsAdded.indexOf(skey) === -1) {
            subresponseColumnsAdded.push(skey);
            formColumns.push({
              label: skey,
              databasefieldname: skey,
              object: 'response'
            });
          }
        }
      }

      const rawLeadDataWithLiterature = [];

      for (let i = 0; i < rawLeadData.length; i++) {
        for (const key in rawLeadData[i]) {
          if (key === 'response') {
            if (rawLeadData[i][key]._literature && rawLeadData[i][key]._literature.length > 0) {
              for (let j = 0; j < rawLeadData[i][key]._literature.length; j++) {
                const newRawLeadData = angular.copy(rawLeadData[i]);
                const litid = newRawLeadData[key]._literature[j];

                const lititem = getLiteratureById(litid, literature);
                //lit shouldn't be deleted but if it is then handle it...
                if (lititem) {
                  newRawLeadData[key].littitle = lititem.title;

                  //added this 1/5/24 because of support issue from DON lead breakout report not downloading
                  if (lititem.tags && lititem.tags.length > 0) {
                    const tag = getTagById(lititem.tags[0], tags);
                    if (tag) {
                      newRawLeadData[key].tagcategory = tag.category;
                      newRawLeadData[key].tagname = tag.name;
                    }
                  }
                } else {
                  newRawLeadData[key].littitle = 'Missing literature';
                }

                for (let b = 0; b < breakoutLookups.length; b++) {
                  const objectkey = breakoutLookups[b].lookupobject || key;
                  let validValues = true;
                  for (let k = 0; k < breakoutLookups[b].lookupkeys.length; k++) {
                    const lookupkey = breakoutLookups[b].lookupkeys[k];
                    if (!newRawLeadData[objectkey][lookupkey] || breakoutLookups[b][lookupkey] !== newRawLeadData[objectkey][lookupkey]) {
                      validValues = false;
                    }
                  }

                  if (validValues) {
                    for (const lkey in breakoutLookups[b]) {
                      switch (lkey) {
                        case 'lookupkeys':
                        case 'lookupname':
                        case '_id':
                        case '_lastmodifieddatelocalutc':
                        case '_lastmodifiedonservertime':
                        case '_uw':
                        case 'artefactType':
                        case '_uwArray':
                        case 'lookupobject':
                          break;
                        default:
                          if (breakoutLookups[b].lookupkeys.indexOf(lkey) === -1) {
                            newRawLeadData[objectkey][lkey] = breakoutLookups[b][lkey];
                          }
                          break;
                      }
                    }
                  }
                }

                if (newRawLeadData[key]._subresponses && newRawLeadData[key]._subresponses.length > 0) {
                  let subresponseid;
                  for (let sr = 0; sr < newRawLeadData[key]._subresponses.length; sr++) {
                    if (newRawLeadData[key]._subresponses[sr]._literatureid === litid) {
                      subresponseid = newRawLeadData[key]._subresponses[sr]._responseid;
                      break;
                    }
                  }

                  for (let s = 0; s < subresponses.length; s++) {
                    if (subresponseid === subresponses[s]._id) {
                      for (const srkey in subresponses[s]) {
                        newRawLeadData[key][srkey] = subresponses[s][srkey];
                      }
                      break;
                    }
                  }
                }

                rawLeadDataWithLiterature.push(newRawLeadData);
              }
            } else {
              rawLeadDataWithLiterature.push(rawLeadData[i]);
            }
          }
        }
      }
      return rawLeadDataWithLiterature;
    };

    function getLiteratureById(id, literature) {

      for (let i = 0; i < literature.length; i++) {
        if (literature[i]._id === id) {
          return literature[i];
        }
      }
    }

    function getTagById(id, tags) {

      for (let i = 0; i < tags.length; i++) {
        for (let j = 0; j < tags[i].tags.length; j++) {
          if (tags[i].tags[j]._id === id) {
            return {
              category: tags[i].category,
              name: tags[i].tags[j].title
            };
          }
        }
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('LeadDataToDownload', factory);

  factory.$inject = ['RemoveArchivedLeadsFromRawData', 'BreakoutLeadData'];
  /* ng-inject */
  function factory(RemoveArchivedLeadsFromRawData, BreakoutLeadData) {

    return function (downloadOptions, formColumns, data) {

      const focusedData = downloadOptions.parked ? data.parkedLeadData : data.leadData;
      const rawLeadDataWithArchives = focusedData.rawData;
      const rawLeadData = RemoveArchivedLeadsFromRawData(rawLeadDataWithArchives, focusedData);

      if (downloadOptions.literatureBreakout) {
        const rawLeadDataWithLiterature = BreakoutLeadData(rawLeadData, data, formColumns);
        return rawLeadDataWithLiterature;
      } else {
        return rawLeadData;
      }
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('HydratePrivacyStatements', factory);

  factory.$inject = ['PrivacyStatementsViewModel'];
  /* ng-inject */
  function factory(PrivacyStatementsViewModel) {

    return function () {

      const params = {
        options: {
          includeVersionHistory: 0
        },
        queryObj: {
          parameters: {
            artefactType: 'PrivacyStatement'
          },
          fields: {
            isPrimaryStatement: 1,
            title: 1
          }
        }
      };

      return PrivacyStatementsViewModel.hydrateFactoryWithPrivacyStatements(params);
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('HydrateModelsForDownload', factory);

  factory.$inject = ['ListsGeneralFactory', 'HydratePrivacyStatements', 'ColumnsForDownload', 'LeadDataFactory'];
  /* ng-inject */
  function factory(ListsGeneralFactory, HydratePrivacyStatements, ColumnsForDownload, LeadDataFactory) {

    return function hydrateModels(downloadOptions) {

      return Promise.all([
        HydratePrivacyStatements(),
        ListsGeneralFactory.ensureListCacheIsHydratedWithLists()
      ])
        .then(function () {
          return {
            formColumns: ColumnsForDownload(downloadOptions),
            leadData: LeadDataFactory.getData(downloadOptions)
          };
        })
        .catch(function (err) {
          throw err;
        });
    };
  }

}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('ResolveCellValue', factory);

  factory.$inject = ['ImagesFactory', 'LiteratureNamesFactory', 'ListsGeneralFactory', '$filter'];
  /* ng-inject */
  function factory(ImagesFactory, LiteratureNamesFactory, ListsGeneralFactory, $filter) {

    return function (object, column, privacyStatementModel, formTimezoneOffset) {
      try {
        if ((typeof object[column.databasefieldname]) == 'undefined') {
          if (column.databasefieldname === '_latestDetailedReleaseAttempt') return 'N/A';
          return '';
        } else {
          const rawValue = object[column.databasefieldname];
          if (rawValue.constructor === Array) {
            return arrayValue(rawValue, column, privacyStatementModel, formTimezoneOffset);
          } else if (column.type === 'Drawing') {
            return ImagesFactory.getImageUrl(rawValue);
          } else if (column.databasefieldname === '_latestDetailedReleaseAttempt'){
            return rawValue.narrative;
          } else {
            return stringValue(rawValue, column, formTimezoneOffset);
          }
        }
      } catch (e) {
        // $log.info('resolveCellValue .catch: ' + e);
      }
    };

    function stringValue(rawValue, column, formTimezoneOffset) {
      if (column.databasefieldname == 'thankYouEmailSentForThisForm' ||
        column.databasefieldname == '_lastmodifiedonservertime' ||
        column.databasefieldname == '_lastmodifieddatelocalutc' ||
        column.databasefieldname == '_initialcreatedatelocalutc') {
        return dateOffsetString(rawValue, formTimezoneOffset);
      } else {
        return rawValue;
      }
    }

    function dateOffsetString(rawValue, formTimezoneOffset) {
      return $filter('zpDateOffset')(rawValue, formTimezoneOffset); // put date in same format as other dates
    }

    function arrayValue(rawValue, column, privacyStatementModel, formTimezoneOffset) {
      let valString = '';
      for (let i = 0, j = rawValue.length; i < j; i++) {

        if (column.customListId) {
          if (_.includes(rawValue[i], ':')) {
            //lookup existing list to see if full string matches first use raw value here

            const rawListLookupResult = ListsGeneralFactory.resolveCellValue(column.customListId, rawValue[i]);
            if (rawListLookupResult){
              valString += rawListLookupResult + '; ';
            } else {
              // we've got a custom list with some 'show more info' data. Strip the answer back to a matchable value, grab the code/caption from the relevant list, then slap the more info back in place.
              const stringToMatch = rawValue[i].substring(0, rawValue[i].indexOf(':'));
              const postColonAnswerData = rawValue[i].substring(rawValue[i].indexOf(':'), rawValue[i].length);
              valString += ListsGeneralFactory.resolveCellValue(column.customListId, stringToMatch);
              valString += postColonAnswerData + '; ';
            }
          } else if (column.databasefieldname !== '_literature') {
            valString += ListsGeneralFactory.resolveCellValue(column.customListId, rawValue[i]) + '; ';
          } else {
            const litDocTitle = LiteratureNamesFactory.getLiteratureDocById(rawValue[i]).title;
            valString += litDocTitle + '; ';
          }

        } else if (column.databasefieldname == '_literature') {
          valString += LiteratureNamesFactory.getLiteratureDocById(rawValue[i]).title + '; ';

        } else if (column.databasefieldname == '_images') {
          valString += ImagesFactory.getImageUrl(rawValue[i]) + '; ';

        } else if (column.databasefieldname == '_messageComposerMessages') {
          valString += rawValue[i].dateSent + '; ';

        } else if (column.databasefieldname == '_grantedConsents') {
          const dateAcquired = $filter('zpDateOffset')(rawValue[i].dateAcquired, formTimezoneOffset); // put date in same format as other dates
          const tokenName = rawValue[i].token || 'Unknown Token';
          valString += tokenName + ' (' + dateAcquired + '); ';

        } else if (column.databasefieldname == '_readPrivacyStatements') {
          const dateRead = $filter('zpDateOffset')(rawValue[i].dateRead, formTimezoneOffset); // put date in same format as other dates
          try {
            valString += privacyStatementModel[rawValue[i].id].title + ' (' + dateRead + '); ';
          } catch (e) {
            if (rawValue[i].id === 'p9Jt1Z/iR2W4iCeKIebxPw==') {
              valString += 'Verbal privacy statement given (' + dateRead + '); ';
            } else {
              valString += 'Unknown Statement (' + dateRead + '); ';
            }
          }
        } else if (column.databasefieldname === 'emailEvents') {
          const eventDate = $filter('zpDateOffset')(rawValue[i].dt, formTimezoneOffset); // put date in same format as other dates
          valString += rawValue[i].event + ' @ ' + eventDate + '; ';
        } else if (column.databasefieldname === 'latestEmailEvent') {
          valString += rawValue + '; ';
        } else if (column.databasefieldname === 'templatesSentForForm') {
          valString += $filter('zpEmailTemplateTitle')(rawValue[i]._emailTemplateId) + ' @ ' + rawValue[i]._initialcreatedatelocalutc + '; ';
        } else {
          valString += rawValue[i] + '; ';
        }
      }
      return valString.slice(0, -2); // chop the trailing ; off the end
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('MapLeadData', factory);

  factory.$inject = ['ResolveCellValue'];
  /* ng-inject */
  function factory(ResolveCellValue) {

    return function mapLeadData(formColumns, leadData, privacyStatementModel, formTimezoneOffset) {
      return _.map(leadData, function (leadItem) {
        const rowData = [];
        _.each(formColumns, function (column) {
          _.each(leadItem, function (companyContactResponse, leadObjectKey) {
            if (leadObjectKey === column.object) {
              const cellValue = ResolveCellValue(companyContactResponse, column, privacyStatementModel, formTimezoneOffset);
              rowData.push(cellValue);
            }
          });
        });
        return rowData;
      });
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('SetFilename', factory);

  factory.$inject = ['FormMetadataFactory', 'MessageService'];
  /* ng-inject */
  function factory(FormMetadataFactory, MessageService) {

    return function (ev, label, extension) {
      const formname = FormMetadataFactory.getData().formProperties.formname;
      const currentDT = moment().format('MM-DD-YYYY_HH:mm:ss');
      const fileExtension = extension || 'csv';
      let filename;
      let toolbarTitle;

      if (label) {
        toolbarTitle = 'Custom Data Download';
        filename = `${formname}_${label}_${currentDT}`;
      } else {
        toolbarTitle = 'Download Leads';
        filename = `${formname}_${currentDT}`;
      }

      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
      if (filename.length >= 175 && !isMac) {
        const config = {
          controller: 'FilenameDialog as vm',
          templateUrl: 'app/forms/grid-page/downloads/json-to-csv/getDataReadyForCSV/PrepareModelsForDownload/filename-dialog/filename-dialog.tmpl.html',
          locals: {
            filename: filename,
            toolbarTitle: toolbarTitle
          }
        };
        return MessageService.showDialog(ev, config)
          .then(function (res) {
            return res + '.' + fileExtension;
          })
          .catch(function (err) {
            throw err;
          });
      } else {
        return Promise.resolve(filename + '.' + fileExtension);
      }
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('CalcFormTimezoneOffset', factory);

  factory.$inject = ['FormMetadataFactory', 'stringHelper'];
  /* ng-inject */
  function factory(FormMetadataFactory, stringHelper) {

    return function () {
      const formTimezone = FormMetadataFactory.getData().formProperties.formTimezone;
      return stringHelper.calcTimezoneOffset(formTimezone);
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('PrepareModelsForDownload', factory);

  factory.$inject = ['HydrateModelsForDownload', 'LeadDataToDownload', 'PrivacyStatementsViewModel', 'CalcFormTimezoneOffset'];
  /* ng-inject */
  function factory(HydrateModelsForDownload, LeadDataToDownload, PrivacyStatementsViewModel, CalcFormTimezoneOffset) {

    return function (downloadOptions) {

      return HydrateModelsForDownload(downloadOptions)
        .then(function (res) {
          return {
            formColumns: res.formColumns,
            leadData: LeadDataToDownload(downloadOptions, res.formColumns, res.leadData),
            privacyStatementModel: PrivacyStatementsViewModel.factoryData.privacyStatementsFastLookup,
            formTimezoneOffset: CalcFormTimezoneOffset(),
            filename: downloadOptions.filename
          };
        })
        .catch(function (err) {
          throw err;
        });

    };
  }
}());

/**
 * Created by davidhickson on 17/11/2016.
 */
/**
  * Provides functionality for administering the Zuant showroom
  * @module showroom
  */
(function () {
  angular
    .module('showroom', [
      'ui.router',
      'ngMaterial',
      'common',
      'artefacts'
    ]);
})();

/**
 * Created by davidhickson on 06/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('blockTree', {
      templateUrl: 'app/showroom/blocks/main/sidebar/tree/block-tree.tmpl.html',
      controllerAs: 'vm',
      bindings: {
        blocks: '<',
        deselectAllBlocks: '&',
        updateCurrentBlock: '&',
        refreshTree: '&'
      },
      controller: ['$scope', 'blocksManager', 'MessageService', 'literatureManager', 'MasterPermissionsDefinitionFactory', function ($scope, blocksManager, MessageService, literatureManager, MasterPermissionsDefinitionFactory) {

        var vm = this;
        vm.blockssvcreference = blocksManager;
        vm.permissions = MasterPermissionsDefinitionFactory;
        
        vm.toggleExpanded = function (block) {
          if (block.blocks && block.blocks.length > 0) {
            block.isExpanded = block.isExpanded === false;
          }
        };

        vm.removeRootBlock = function (block, $event) {
          var wasSelected = block.isSelected;
          blocksManager.archiveBlock(block).then(function () {
            MessageService.showMessage('Block removed');
            if (wasSelected && blocksManager.blocks && blocksManager.blocks.length > 0) {
              vm.selectBlock(blocksManager.blocks[0], $event);
            }
            vm.refreshTree();
          });
          $event.stopPropagation();
        };

        vm.selectBlock = function (block, $event) {
          vm.deselectAllBlocks();
          literatureManager.deselectAllLit();
          block.isSelected = true;
          vm.updateCurrentBlock();
          $event.stopPropagation();
        };

      }]
    });
})();

/**
 * Provides integration services for the application
 * @module integration
 */

(function () {
  'use strict';

  angular
    .module('integration', ['ui.router', 'common', 'zp.api', 'zp.message']);

})();

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('UpdateMapping', factory);

  factory.$inject = ['ChangeDelta', 'AdjustZuantFieldMappingCount'];
  /* ng-inject */
  function factory(ChangeDelta, AdjustZuantFieldMappingCount) {

    // the function will update the proxyMappings entry to reflect the dropped cell
    return function (targetRowIndex, itemBeingDropped, thirdPartyFieldIdentifier, viewModel, sourceCellConfig, unmappingField) {
      if (sourceCellConfig.sourceColumn === 'A') {
        mapColumnAField(targetRowIndex, viewModel, itemBeingDropped, thirdPartyFieldIdentifier);
      } else if (sourceCellConfig.sourceColumn === 'Z' && unmappingField) {
        mapColumnZField(targetRowIndex, viewModel, sourceCellConfig, itemBeingDropped, thirdPartyFieldIdentifier, unmappingField);
      }
    };

    function mapColumnAField(targetRowIndex, viewModel, itemBeingDropped, thirdPartyFieldIdentifier) {
      try {
        if (viewModel.proxyMappings[targetRowIndex].mapping[0].hps.element) {
          // mapping to a previously mapped field (blasts target)
          const zuantField = viewModel.proxyMappings[targetRowIndex].mapping[0].hps;
          AdjustZuantFieldMappingCount(zuantField, 'decrease', viewModel);
        }
        // this nukes the target mapping (if there is one) with the dropped field
        updateProxyMapping(viewModel, targetRowIndex, itemBeingDropped);
        const databasefieldname = viewModel.proxyMappings[targetRowIndex].mapping[0][viewModel.thirdPartyMappingKey].field;
        const oldval = viewModel.mappingFastLookup[viewModel.proxyMappings[targetRowIndex].mapping[0][viewModel.thirdPartyMappingKey].field];
        const newval = viewModel.proxyMappings[targetRowIndex].mapping[0].hps.element;
        recordDelta(viewModel, targetRowIndex, databasefieldname, oldval, newval);
        viewModel.mappedFields[thirdPartyFieldIdentifier] = true;
        AdjustZuantFieldMappingCount({
          collection: itemBeingDropped.collection,
          element: itemBeingDropped.element
        }, 'increase', viewModel);
        updateMappingFastLookupField(viewModel, thirdPartyFieldIdentifier, itemBeingDropped.element);
      } catch (e) {
        throw e;
      }
    }

    function mapColumnZField(targetRowIndex, viewModel, sourceCellConfig, itemBeingDropped, thirdPartyFieldIdentifier, unmappingField) {
      if (viewModel.proxyMappings[targetRowIndex].mapping[0].hps.element && !unmappingField) {
        swapMappedFields(viewModel, targetRowIndex, sourceCellConfig, itemBeingDropped, thirdPartyFieldIdentifier);
      } else if (!unmappingField) {
        moveMappedField(viewModel, targetRowIndex, sourceCellConfig, itemBeingDropped, thirdPartyFieldIdentifier);
      } else {
        removeMappedField(viewModel, thirdPartyFieldIdentifier, sourceCellConfig);
      }
    }

    function swapMappedFields(viewModel, targetRowIndex, sourceCellConfig, itemBeingDropped, thirdPartyFieldIdentifier) {
      // console.log('Z to Z: swap cells');
      const bullyThirdPartyFieldIdentifier = thirdPartyFieldIdentifier;
      const victimThirdPartyFieldIdentifier = viewModel.proxyMappings[sourceCellConfig.index].mapping[0][viewModel.thirdPartyMappingKey].field;
      const bullyElementValue = itemBeingDropped.element;
      const victimElementValue = viewModel.proxyMappings[targetRowIndex].mapping[0].hps.element;
      delete viewModel.mappedFields[thirdPartyFieldIdentifier];
      viewModel.mappedFields[viewModel.proxyMappings[targetRowIndex].mapping[0][viewModel.thirdPartyMappingKey].field] = true;

      placeTargetCellDataInSourceCell(viewModel, targetRowIndex, sourceCellConfig);
      updateProxyMapping(viewModel, targetRowIndex, itemBeingDropped);
      const databasefieldname = viewModel.proxyMappings[targetRowIndex].mapping[0][viewModel.thirdPartyMappingKey].field;
      const oldval = viewModel.mappingFastLookup[viewModel.proxyMappings[targetRowIndex].mapping[0][viewModel.thirdPartyMappingKey].field];
      const newval = viewModel.proxyMappings[targetRowIndex].mapping[0].hps.element;
      recordDelta(viewModel, targetRowIndex, databasefieldname, oldval, newval);
      updateMappingFastLookupField(viewModel, bullyThirdPartyFieldIdentifier, bullyElementValue);
      updateMappingFastLookupField(viewModel, victimThirdPartyFieldIdentifier, victimElementValue);
    }

    function moveMappedField(viewModel, targetRowIndex, sourceCellConfig, itemBeingDropped, thirdPartyFieldIdentifier) {
      // console.log('Z to Z: no swap');
      if (viewModel.mappedFields[viewModel.proxyMappings[sourceCellConfig.index].mapping[0][viewModel.thirdPartyMappingKey].field]) {
        delete viewModel.mappedFields[viewModel.proxyMappings[sourceCellConfig.index].mapping[0][viewModel.thirdPartyMappingKey].field];
      }
      viewModel.mappedFields[thirdPartyFieldIdentifier] = true;
      updateProxyMapping(viewModel, sourceCellConfig.index, {
        collection: '',
        element: ''
      });
      const sourcedatabasefieldname = viewModel.proxyMappings[sourceCellConfig.index].mapping[0][viewModel.thirdPartyMappingKey].field;
      recordDelta(viewModel, sourceCellConfig.index, sourcedatabasefieldname, '', '');
      updateProxyMapping(viewModel, targetRowIndex, itemBeingDropped);
      const targetdatabasefieldname = viewModel.proxyMappings[targetRowIndex].mapping[0][viewModel.thirdPartyMappingKey].field;
      const oldval = viewModel.mappingFastLookup[viewModel.proxyMappings[targetRowIndex].mapping[0][viewModel.thirdPartyMappingKey].field];
      const newval = viewModel.proxyMappings[targetRowIndex].mapping[0].hps.element;
      recordDelta(viewModel, targetRowIndex, targetdatabasefieldname, oldval, newval);
      updateMappingFastLookupField(viewModel, thirdPartyFieldIdentifier, itemBeingDropped.element);
      const sourceFieldIdentifier = viewModel.proxyMappings[sourceCellConfig.index].mapping[0][viewModel.thirdPartyMappingKey].field;
      updateMappingFastLookupField(viewModel, sourceFieldIdentifier, '');
    }

    function removeMappedField(viewModel, thirdPartyFieldIdentifier, sourceCellConfig) {
      // console.log('Z to A');
      delete viewModel.mappedFields[thirdPartyFieldIdentifier];
      const zuantField = viewModel.proxyMappings[sourceCellConfig.index].mapping[0].hps;
      AdjustZuantFieldMappingCount(zuantField, 'decrease', viewModel);
      updateProxyMapping(viewModel, sourceCellConfig.index, {
        collection: '',
        element: ''
      });
      const databasefieldname = viewModel.proxyMappings[sourceCellConfig.index].mapping[0][viewModel.thirdPartyMappingKey].field;
      const oldval = viewModel.mappingFastLookup[viewModel.proxyMappings[sourceCellConfig.index].mapping[0][viewModel.thirdPartyMappingKey].field];
      const newval = viewModel.proxyMappings[sourceCellConfig.index].mapping[0].hps.element;
      recordDelta(viewModel, sourceCellConfig.index, databasefieldname, oldval, newval);
      updateMappingFastLookupField(viewModel, thirdPartyFieldIdentifier, '');
    }

    function placeTargetCellDataInSourceCell(viewModel, targetRowIndex, sourceCellConfig) {
      const targetCell = viewModel.proxyMappings[targetRowIndex].mapping[0].hps;
      // updates source cell mapping with targetCell data // SWAPSIES
      updateProxyMapping(viewModel, sourceCellConfig.index, targetCell);
    }

    function updateMappingFastLookupField(viewModel, thirdPartyFieldIdentifier, newValue) {
      viewModel.mappingFastLookup[thirdPartyFieldIdentifier] = newValue;
    }

    function recordDelta(viewModel, targetRowIndex, databasefieldname, oldval, newval) {
      const deltaConfig = {
        collection: 'machines',
        objectid: 'mappings',
        databasefieldname: databasefieldname,
        oldval: oldval,
        newval: newval
      };

      ChangeDelta.recordValueChange(deltaConfig);
      const rowIsDirty = (deltaConfig.oldval !== deltaConfig.newval);
      viewModel.proxyMappings[targetRowIndex].isDirty = rowIsDirty;
    }

    function updateProxyMapping(viewModel, targetRowIndex, itemBeingDropped) {
      viewModel.proxyMappings[targetRowIndex].mapping[0].hps = {
        collection: itemBeingDropped.collection,
        element: itemBeingDropped.element
      };
    }

  }
}());

/**
 * Created by davidhickson on 06/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('blockOptions', {
      templateUrl: 'app/showroom/blocks/main/sidebar/options/block-options.tmpl.html',
      controllerAs: 'vm',
      bindings: {
        currentBlock: '='
      },
      controller: ['blocksManager', 'uuidService', 'ImagesApiFactory', '$timeout', 'ImageMetadataFactory', 'MessageService', function (blocksManager, uuidService, ImagesApiFactory, $timeout, ImageMetadataFactory, MessageService) {

        var vm = this;
        var promise = null;

        vm.blockssvcreference = blocksManager;
        vm.listOfImages = [];

        vm.$onInit = function () {
          vm.listOfImages = ImagesApiFactory.factoryData.arrayOfImageItems;
          vm.originalBlock = angular.copy(vm.currentBlock);
        };

        vm.imageChanged = function (type) {
          var val;
          switch (type) {
            case 'nameplate':
              val = vm.currentBlock.nameplateImage;
              break;
            case 'background':
              val = vm.currentBlock.backgroundImage;
              break;
          }

          if (val === '0_new') {
            var dialogConfig = angular.copy(ImageMetadataFactory.getData().fabDialogConfig);
            MessageService.showDialog({}, dialogConfig)
              .then(function (newId) {
                switch (type) {
                  case 'nameplate':
                    vm.currentBlock.nameplateImage = newId;
                    break;
                  case 'background':
                    vm.currentBlock.backgroundImage = newId;
                    break;
                }
                ingestBlockDelta();
              }).catch(function () {
                switch (type) {
                  case 'nameplate':
                    vm.currentBlock.nameplateImage = vm.originalBlock.nameplateImage;
                    break;
                  case 'background':
                    vm.currentBlock.backgroundImage = vm.originalBlock.backgroundImage;
                    break;
                }
              });
          } else {
            vm.modelChanged();
          }
        };

        vm.modelChanged = function () {
          if (promise) {
            $timeout.cancel(promise);
          }
          promise = $timeout(function () {
            ingestBlockDelta();
          }, 500);
        };

        function ingestBlockDelta() {
          var delta = blocksManager.getDelta(vm.currentBlock);
          blocksManager.ingestBlockDelta(delta);
          vm.originalBlock = angular.copy(vm.currentBlock);
        }

        return vm;
      }]
    });
})();

/**
 * Created by davidhickson on 06/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('addLiterature', {
      templateUrl: 'app/showroom/blocks/main/sidebar/literature/add-literature.tmpl.html',
      controllerAs: 'vm',
      bindings: {
        currentBlock: '<'
      },
      controller: ['$scope', 'blocksManager', 'blocksXrefLiteratureManager', 'literatureManager', 'tagsManager', function ($scope, blocksManager, blocksXrefLiteratureManager, literatureManager, tagsManager) {

        var vm = this;
        vm.blockssvcreference = blocksManager;
        vm.literaturesvc = literatureManager;
        vm.selectAll = false;

        vm.toggleSelectAll = function () {
          if (vm.selectAll) {
            literatureManager.selectAllVisibleLit();
          } else {
            literatureManager.deselectAllLit();
          }
        };

        vm.getTagTitle = function (tagId) {
          return tagsManager.tagTitle(tagId);
        };

        vm.requestLitStatsUpdate = function () {
          literatureManager.requestLitStatsUpdate();
        };

        vm.searchTextChanged = function () {
          literatureManager.literatureTextSearchTermChanged(vm.searchTerm);
        };

        vm.toggleLitLibraryLitItemSelection = function (litItem) {
          literatureManager.toggleItemSelection(litItem);
        };

        vm.applySelectedItemsToCurrentBlockClicked = function () {
          blocksXrefLiteratureManager.applySelectedLiteratureToCurrentBlock(vm.currentBlock);
        };

        return vm;
      }]
    });
})();

/**
 * Created by davidhickson on 06/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('addBlocks', {
      templateUrl: 'app/showroom/blocks/main/sidebar/blocks/add-blocks.tmpl.html',
      controllerAs: 'vm',
      bindings: {
        currentBlock: '<'
      },
      controller: ['$scope', 'blocksManager', 'blocksXrefLiteratureManager', 'literatureManager', 'tagsManager', 'MessageService', 'BlocksMetadataFactory', function ($scope, blocksManager, blocksXrefLiteratureManager, literatureManager, tagsManager, MessageService, BlocksMetadataFactory) {

        var vm = this;
        vm.blockssvcreference = blocksManager;
        vm.literaturesvc = literatureManager;
        vm.blockList = [];

        vm.getTagTitle = function (tagId) {
          return tagsManager.tagTitle(tagId);
        };

        vm.searchTextChanged = function () {
          blocksManager.blocksTextSearchTermChanged(vm.searchTerm);
        };

        vm.toggleBlockSelection = function (block) {
          block.selectedForPush = !block.selectedForPush;
          blocksManager.requestBlockStatsUpdate();
        };

        vm.applySelectedItemsToCurrentBlockClicked = function () {
          blocksManager.applySelectedBlockToCurrentBlock(vm.currentBlock).then(vm.currentBlockChanged);
        };

        vm.requestBlockStatsUpdate = function () {
          blocksManager.requestBlockStatsUpdate();
        };

        vm.addNewBlock = function () {
          var dialogConfig = angular.copy(BlocksMetadataFactory.getData().addDialogConfig);
          dialogConfig.locals.parentBlockDoc = vm.currentBlock;

          MessageService.showDialog({}, dialogConfig);
        };

        function checkIfBlockIsParent(parentBlocks, block) {
          var i = 0;
          var len = parentBlocks.length;
          var ret = true;

          for (i; i < len; i++) {
            if (parentBlocks[i]._id === block._id) {
              ret = false;
            } else if (parentBlocks[i].arrayOfParentBlocks.length > 0) {
              ret = checkIfBlockIsParent(parentBlocks[i].arrayOfParentBlocks, block);
            }
          }

          return ret;
        }

        function hasNoCircularDependencies(block) {
          var ret = true;

          if (vm.currentBlock._id === block._id) {
            ret = false;
          } else if (vm.currentBlock.arrayOfParentBlocks.length > 0) {
            ret = checkIfBlockIsParent(vm.currentBlock.arrayOfParentBlocks, block);
          }

          return ret;
        }

        function inList(block) {
          var i = 0;
          var len = vm.blockList.length;
          var found = false;

          for (i; i < len; i++) {
            if (block._id === vm.blockList[i]._id) {
              found = true;
            }
          }

          return found;
        }

        $scope.$watch('[vm.currentBlock._id, vm.blockssvcreference.blocks.length]', function () {
          vm.$onInit();
        });

        vm.$onInit = function () {
          // Prevent circular references by removing any parent blocks from list of blocks
          var i = 0;
          var len = blocksManager.blocks.length;
          vm.blockList = [];

          for (i; i < len; i++) {
            if (hasNoCircularDependencies(blocksManager.blocks[i]) && !inList(blocksManager.blocks[i])) {
              vm.blockList.push(blocksManager.blocks[i]);
            }
          }
        };

        return vm;
      }]
    });
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('GetDataReadyForCSV', factory);

  factory.$inject = ['PrepareModelsForDownload', 'MapLeadData'];
  /* ng-inject */
  function factory(PrepareModelsForDownload, MapLeadData) {

    return function (downloadOptions) {
      return PrepareModelsForDownload(downloadOptions)
        .then(function (res) {
          return {
            columns: _.map(res.formColumns, 'label'), // returns an array of column label strings
            leads: MapLeadData(res.formColumns, res.leadData, res.privacyStatementModel, res.formTimezoneOffset),
            filename: res.filename
          };
        })
        .catch(function (err) {
          throw err;
        });
    };
  }
})();

/**
 * Created by davidbeazer on 27/09/2016.
 */
/**
 * Provides functionality for administering Zuant client accounts
 * @module clients
 */

(function () {
  'use strict';

  angular
    .module('clients', [
      'ui.router',
      'common',
      'md-steppers',
      'zp.api',
      'zp.auth',
      'zp.encoding',
      'data'
    ]);
})();

'use strict';

angular
  .module('clients')
  .controller('SwitchDropboxAccountDialogController', SwitchDropboxAccountDialogController);

SwitchDropboxAccountDialogController.$inject = ['MessageService', '$window', 'hotkeys', 'SessionService', 'dropboxApiService', 'localStorageService'];
/* ng-inject */
function SwitchDropboxAccountDialogController(MessageService, $window, hotkeys, SessionService, dropboxApiService, localStorageService) {

  var vm = this;
  vm.cancelDialog = cancelDialog;
  vm.hide = hide;

  function init() {
    vm.account = {
      selectedAccount: {}
    };
    var userData = SessionService.getUserData();
    vm.existingAccounts = localStorageService.get('dropbox-accounts-' + userData.databasename);

    if (!vm.existingAccounts) {
      vm.existingAccounts = [];
    }

    vm.existingAccounts.sort(function (a, b) {
      if (a.display_name > b.display_name) return 1;
      if (a.display_name < b.display_name) return -1;
      return 0;
    });

    var currentToken = dropboxApiService.getBearerToken();
    vm.existingAccounts.forEach(function(account) {
      if ('Bearer ' + account.token === currentToken) {
        vm.account.selectedAccount = account.token;
      }
    });
    vm.existingAccounts.push({ token: 'new', display_name: 'Link new account...' });
  }

  init();

  vm.onSelectionChange = function () {
    if (vm.account.selectedAccount === 'new') {
      vm.showLinkNewAccountText = true;
    } else {
      vm.showLinkNewAccountText = false;
    }
  };

  vm.switchAccount = function () {
    vm.disableSaveButton = true;

    if (vm.account.selectedAccount === 'new') {
      $window.location = dropboxApiService.connectLocation;
    } else {
      dropboxApiService.setBearerToken(vm.account.selectedAccount);

      return dropboxApiService.hydrateService()
        .then(function () {
          MessageService.showMessage('Switched dropbox accounts');
          vm.disableSaveButton = false;
          hide(true);
        })
        .catch(function (err) {
          vm.disableSaveButton = false;
          $log.error(err);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
          MessageService.showMessage(err.data.data.message);
        });
    }
  };

  // modal dismiss functions
  function hide(answer) {
    MessageService.closeDialog(answer);
  }

  function cancelDialog() {
    MessageService.cancelDialog();
  }
  return vm;
}

/**
 * Created by davidhickson on 15/02/2017.
 */
(function () {
  'use strict';
  angular
    .module('showroom')
    .component('dropboxActions', {
      templateUrl: 'app/showroom/third-party/main/actions/dropbox-actions.tmpl.html',
      controller: ['$location', '$log', 'dropboxApiService', 'literatureIngestorService', 'MasterPermissionsDefinitionFactory', function ($location, $log, dropboxApiService, literatureIngestorService, MasterPermissionsDefinitionFactory) {

        this.dropboxApiService = dropboxApiService;
        this.permissions = MasterPermissionsDefinitionFactory;

        this.addToShowroomClicked = function () {
          $log.info('addToShowroomClicked starting');

          var filesAsExportPackage = dropboxApiService.getCurrentlySelectedFilesAsExportPackage();
          literatureIngestorService.addExternalFiles(filesAsExportPackage, dropboxApiService.getImportOptions());
        };
      }],
      bindings: {
        dropboxzuantsvcreference: '<',
        litsvcreference: '<'
      }
    });
})();

/**
 * Created by davidhickson on 22/03/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').component('dropboxToolbar', {
    templateUrl: 'app/showroom/third-party/main/toolbar/dropbox-toolbar.tmpl.html',
    controller: ['DropboxMetadataFactory', 'MessageService', 'dropboxApiService', function (DropboxMetadataFactory, MessageService, dropboxApiService) {

      var vm = this;

      vm.switchAccounts = function () {
        var dialogConfig = angular.copy(DropboxMetadataFactory.getData().fabDialogConfig);
        MessageService.showDialog({}, dialogConfig);
      };

      vm.share = function () {
        dropboxApiService.toggleShareForSelectedNodes(true);
      };

      vm.unshare = function () {
        dropboxApiService.toggleShareForSelectedNodes(false);
      };

      vm.filterButtonClicked = function () {
        dropboxApiService.showFilterBar = !dropboxApiService.showFilterBar;
      };

      vm.selectAllVisibleClicked = function () {
        dropboxApiService.switchAllNodes(true);
      };

      vm.deselectAllClicked = function () {
        dropboxApiService.switchAllNodes(false);
      };

      vm.expand = function () {
        dropboxApiService.toggleExpandSelectedNodes(true);
      };

      vm.shrink = function () {
        dropboxApiService.toggleExpandSelectedNodes(false);
      };

      return vm;
    }],
    bindings: {}
  });
})();

/**
 * Created by davidhickson on 02/02/2017.
 */
(function () {
  'use strict';
  angular.module('showroom')
    .component('dropboxNode', {
      templateUrl: 'app/showroom/third-party/main/list/dropbox-node.tmpl.html',
      controller: ['$log', '$scope', 'dropboxApiService', function ($log, $scope, dropboxApiService) {

        this.selectNodeChanged = function (node) {
          $log.info('selectNodeChanged isSelected = ' + node.isSelected);
          dropboxApiService.propagateNodeSelectionState(node);
        };

        this.toggleNodeExpanded = function (node) {
          dropboxApiService.toggleNodeExpansion(node, false);
        };

        this.toggleNodeSelected = function (node) {
          node.isSelected = !node.isSelected;
          $log.info('toggle selectNodeChanged isSelected = ' + node.isSelected);
          dropboxApiService.propagateNodeSelectionState(node);
        };

        this.fullyShrinkNodeClicked = function (node) {
          dropboxApiService.expandOrShrinkNode(node, false, true);
        };

        this.fullyExpandNodeClicked = function (node) {
          dropboxApiService.expandOrShrinkNode(node, true, true);
        };

      }],
      bindings: {
        node: '<'
      }
    });
})();

/**
 * Created by davidhickson on 31/01/2017.
 */
(function () {
  'use strict';
  angular.module('showroom')
    .component('dropboxList', {
      templateUrl: 'app/showroom/third-party/main/list/dropbox-list.tmpl.html',
      controller: 'dropboxListCtrl',
      bindings: {}
    })
    .controller('dropboxListCtrl', ctrl);

  ctrl.$inject = ['$window', '$log', 'dropboxApiService', 'MessageService', 'localStorageService'];
  /* ng-inject */
  function ctrl($window, $log, dropboxApiService, MessageService, localStorageService) {

    var vm = this;

    vm.$onInit = function () {
      vm.dropboxzuantsvcreference = dropboxApiService;

      if (dropboxApiService.getBearerToken() === 'Bearer null') {
        vm.showConnectLink = true;
        dropboxApiService.resetNodes();
      } else {
        vm.busy = true;
        dropboxApiService.stopLoading = false;
        dropboxApiService.hydrateService()
          .then(function () {
            vm.busy = false;
          })
          .catch(function (err) {
            MessageService.writeLog({
              level: 'error',
              msg: 'Error: ' + JSON.stringify(err)
            });
          });
      }
    };

    vm.connectToDropbox = function () {
      localStorageService.set('dropboxRedirectPath', {
        state: 'app.oldshowroom.showroom.dropbox'
      });
      dropboxApiService.connectToDropbox();
    };

    vm.stopLoading = function () {
      dropboxApiService.stopLoading = true;
    };

  }
})();

/**
 * Created by davidhickson on 26/01/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').component('dropboxFilter', {
    templateUrl: 'app/showroom/third-party/main/filter/dropbox-filter.tmpl.html',
    controller: ['dropboxApiService', function (dropboxApiService) {

      var vm = this;
      vm.dropboxsvcreference = dropboxApiService;

      vm.toggleUnshare = function () {
        vm.dropboxsvcreference.hideUnshared = !vm.dropboxsvcreference.hideUnshared;
        vm.dropboxsvcreference.refreshDisplay();
      };

      vm.toggleShare = function () {
        vm.dropboxsvcreference.hideShared = !vm.dropboxsvcreference.hideShared;
        vm.dropboxsvcreference.refreshDisplay();
      };

      return vm;
    }],
    bindings: {}
  });
})();

/**
 * Created by davidhickson on 28/02/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').component('tagActions', {
    templateUrl: 'app/showroom/tags/main/actions/tag-actions.tmpl.html',
    controller: ['$log', 'literatureManager', 'tagsManager', 'literatureXrefTagsManager', 'MasterPermissionsDefinitionFactory', function ($log, literatureManager, tagsManager, literatureXrefTagsManager, MasterPermissionsDefinitionFactory) {

      var vm = this;
      vm.litsvc = literatureManager;
      vm.tagssvc = tagsManager;
      vm.permissions = MasterPermissionsDefinitionFactory;

      vm.applySelectedTagsToSelectedLiteratureClicked = function () {
        $log.info('applySelectedTagsToSelectedLiteratureClicked starting');
        literatureXrefTagsManager.applySelectedTagsToSelectedLiterature();
      };

      vm.removeSelectedTagsFromLiteratureClicked = function () {
        $log.info('applySelectedTagsToSelectedLiteratureClicked starting');
        literatureXrefTagsManager.removeSelectedTagsFromLiterature();
      };

      return vm;
    }],
    bindings: {}
  });
})();

/**
 * Created by davidhickson on 29/03/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').component('tagsToolbar', {
    templateUrl: 'app/showroom/tags/main/toolbar/tags-toolbar.tmpl.html',
    controller: ['$log', 'tagsManager', 'viewStateNotificationService', 'MasterPermissionsDefinitionFactory', function ($log, tagsManager, viewStateNotificationService, MasterPermissionsDefinitionFactory) {

      var vm = this;
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.viewStateNotificationService = viewStateNotificationService;
      vm.tagsManager = tagsManager;

      vm.settingsButtonClicked = function () {
        $log.info('tag toolbar edit clicked');

        if (viewStateNotificationService.viewState.tagblocksMode == 'edit') {
          viewStateNotificationService.transitionToViewState({
            'tagblocksMode': 'select'
          });
        } else {
          viewStateNotificationService.transitionToViewState({
            'tagblocksMode': 'edit'
          });
        }
      };

      vm.dragDropButtonClicked = function () {
        $log.info('tag toolbar drag clicked');

        if (viewStateNotificationService.viewState.tagblocksMode == 'drag') {
          viewStateNotificationService.transitionToViewState({
            'tagblocksMode': 'select'
          });
        } else {
          viewStateNotificationService.transitionToViewState({
            'tagblocksMode': 'drag'
          });
        }
      };

      vm.deselectAllTagsClicked = function () {
        tagsManager.factoryData.tagSelectedCount = 0;
        tagsManager.deselectAllTagBlockTags();
      };

      return vm;
    }]
  });
})();

/**
 * Created by davidhickson on 23/01/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').component('tagsList', {
    templateUrl: 'app/showroom/tags/main/list/tags-list.tmpl.html',
    controller: ['$scope', '$q', '$log', 'tagsManager', 'stringHelper', 'viewStateNotificationService', 'MasterPermissionsDefinitionFactory', function ($scope, $q, $log, tagsManager, stringHelper, viewStateNotificationService, MasterPermissionsDefinitionFactory) {

      var vm = this;
      vm.tagssvc = tagsManager;
      vm.viewstatesvc = viewStateNotificationService;
      vm.permissions = MasterPermissionsDefinitionFactory;

      vm.$onInit = function () {
        $log.info('tagBlocksComponent $onInit starting');
        grabAndPrepareAllRequiredData();
        viewStateNotificationService.registerForViewStateNotifications(this.delegateForViewStateNotification);
        vm.refreshUISortables();
      };

      function grabAndPrepareAllRequiredData() {
        $q.all([tagsManager.hydrateOrRefresh()])
          .then(function () {
            $log.info('tagBlocksComponent server grab done happily, ready to build enhanced models');
          }, function (err) {
            $log.info('tagBlocksComponent server grab done with nasty');
            $log.info(err);
          });
      }

      vm.delegateForViewStateNotification = function () {
        $log.info('tagBlocksComponent delegateForViewStateNotification just got called');
        vm.refreshUISortables();
      };

      vm.newCategoryTitle = '';

      vm.toggleTagSelection = function (tag) {
        tagsManager.toggleTag(tag);
      };

      vm.onCategoryBlur = function (tagcategory) {
        var spanContainingCategoryText = document.getElementById('l2_' + tagcategory._id);
        var newTitle = stringHelper.clean(spanContainingCategoryText.innerText);
        var oldTitle = tagcategory.category;

        $log.info('tagBlocksComponent onCategoryBlur finishing: oldTitle=' + oldTitle + ', newTitle=' + tagcategory.category + ', and innerText was ' + newTitle);

        if (oldTitle != newTitle) {
          tagcategory.category = newTitle;
          tagsManager.applyTagCategoryTitleChange(tagcategory, newTitle);
        }
      };

      vm.onCategoryEnter = function (event, tagCategory) {
        $log.info('tagBlocksComponent onCategoryEnter here');
        vm.onCategoryBlur(tagCategory);
        event.preventDefault();
      };

      vm.deleteCategoryClicked = function (event, tagCategory) {
        tagsManager.archiveTagCategory(tagCategory);
        event.preventDefault();
      };

      vm.onNewChipBlur = function (tagCategory, event) {
        $log.info('tagBlocksComponent onNewChipBlur for ' + tagCategory.category + ' with ' + vm.newTagTitle);
        $log.info(event.target.value);
        vm.handleNewChip(tagCategory, event);

      };

      vm.onNewChipEnter = function (tagCategory, event) {
        $log.info('tagBlocksComponent onNewChipEnter for ' + tagCategory.category + ' with ' + vm.newTagTitle);
        $log.info(event.target.value);
        vm.handleNewChip(tagCategory, event);

      };

      vm.handleNewChip = function (tagCategory, ev) {
        var newTagTitle = ev.target.value;
        if (newTagTitle.length > 0) {
          tagsManager.addTagToCategory(tagCategory, newTagTitle)
            .then(function () {
              ev.target.value = '';
            });
        }
      };

      vm.onNewCategoryBlur = function () {
        $log.info('tagBlocksComponent onNewCategoryBlur with ' + vm.newCategoryTitle);
        vm.handleNewCategory(vm.newCategoryTitle);
        this.newCategoryTitle = '';

      };

      vm.onNewCategoryEnter = function () {
        $log.info('tagBlocksComponent onNewCategoryEnter with ' + vm.newCategoryTitle);
        vm.handleNewCategory(vm.newCategoryTitle);
        vm.newCategoryTitle = '';
      };

      vm.handleNewCategory = function (newCategoryTitle) {

        if (newCategoryTitle.length > 0) {

          tagsManager.addTagCategory(newCategoryTitle);

        }

      };

      this.refreshUISortables = function () {
        var allowDrag = viewStateNotificationService.viewState.tagblocksMode == 'drag';
        $log.info('tagBlocksComponent refreshUISortables has allowDrag = ' + allowDrag);
        $scope.sortableOptionsForTags.disabled = !allowDrag;
        $scope.sortableOptionsForTagCategories.disabled = !allowDrag;
      };

      $scope.sortableOptionsForTags = {
        items: '> editable-tag-chip',
        cursor: 'move',
        tolerance: 'pointer',
        disabled: false,
        connectWith: '.chipTagContainer', // this allows tags to be dragged between different categories
        update: function (e, ui) {
          if (ui.item.sortable._isCanceled) return; // Required because the update() function fires TWICE if moving BETWEEN categories

          var idOfSourceCategory = ui.item.sortable.source[0].id.replace('ctc_','');
          var idOfTargetCategory = ui.item.sortable.droptarget[0].id.replace('ctc_','');
          var sourceIndex = ui.item.sortable.index;
          var dropIndex = ui.item.sortable.dropindex;

          $log.info('tagBlocksComponent sortable update event here, ' + ui.item.sortable.index + ' is moving to ' + ui.item.sortable.dropindex + ', source[0].id=' + ui.item.sortable.source[0].id + ', droptarget[0].id=' + ui.item.sortable.droptarget[0].id);
          ui.item.sortable.cancel();
          tagsManager.tagWasDragDropped(idOfSourceCategory, idOfTargetCategory, sourceIndex, dropIndex);
        }
      };

      $scope.sortableOptionsForTagCategories = {
        items: '> div',
        cursor: 'move',
        update: function (e, ui) {
          if (ui.item.sortable._isCanceled) return; // Required because the update() function fires TWICE if moving BETWEEN categories

          var startIndex = ui.item.sortable.index;
          var dropIndex = ui.item.sortable.dropindex;

          $log.info('tagBlocksComponent sortable2 update event here, ' + ui.item.sortable.index + ' is moving to ' + ui.item.sortable.dropindex);
          ui.item.sortable.cancel();
          tagsManager.tagCategoryWasDragDropped(startIndex, dropIndex);
        }
      };
      return vm;
    }],
    bindings: {}
  });
})();

/**
 * Created by davidhickson on 22/02/2017.
 */
(function () {
  'use strict';
  angular.module('showroom')
    .component('editableTagChip', {
      templateUrl: 'app/showroom/tags/main/list/editable-tag-chip.tmpl.html',
      controller: ['$scope', '$element', '$log', 'tagsManager', 'literatureXrefTagsManager', 'stringHelper', 'viewStateNotificationService', function ($scope, $element, $log, tagsManager, literatureXrefTagsManager, stringHelper, viewStateNotificationService) {

        var vm = this;

        vm.viewstatesvc = viewStateNotificationService;

        vm.$onInit = function () {
          $log.info('editableChipComponent has $element:' + $element + ' and tag:' + vm.tag.title);
        };

        vm.onToggleTagSelection = function (tag) {
          if (tag._id) {
            $log.info('editableChipComponent onToggleTagSelection has ' + tag._id);
            vm.bluemoon(tag); // Tell parent that chip has been toggled
          }
        };

        vm.onChipClick = function (tag) {
          $log.info('editableChipComponent onChipClick for tag ' + tag.title);
          if (!tag.isSelected) {
            tagsManager.factoryData.tagSelectedCount++;
          } else {
            tagsManager.factoryData.tagSelectedCount--;
          }

          if (viewStateNotificationService.viewState.tagblocksMode == 'select') {
            if (tag._id) {
              $log.info('editableChipComponent onToggleTagSelection has ' + tag._id);
              vm.bluemoon(tag); // Tell parent that chip has been toggled
            }
          }
        };

        vm.onChipFocus = function (tag) {
          $log.info('editableChipComponent onChipFocus for new tag');
          if (tag.isNew) {
            $log.info('editableChipComponent onChipFocus has detected NEW tag');
            tag.title = '';
          }
        };

        vm.onChipChange = function (tag) {
          $log.info('editableChipComponent onChipChange has ' + tag.title);
        };

        vm.onChipBlur = function (tag) {
          var newTitle = stringHelper.clean($element[0].innerText);
          var oldTitle = tag.title;
          $log.info('editableChipComponent onChipBlur finishing: oldTitle=' + oldTitle + ' and innerText was ' + newTitle);

          if (oldTitle != newTitle) {
            tag.title = newTitle;
            tagsManager.applyTagCaptionChange(tag, newTitle, vm.tagcategory);
          }
        };

        vm.onChipEnter = function (event) {
          $log.info('editableChipComponent onChipEnter here');
          event.preventDefault();
        };

        vm.deleteButtonClicked = function (event) {
          $log.info('editableChipComponent deleteButtonClicked here');
          $log.info(vm.tag);

          if (literatureXrefTagsManager.assertTagIsBeingReferencedByAtLeastOneLiteratureItem(vm.tag) == false) {
            tagsManager.deleteTag(vm.tag, vm.tagcategory);
          } else {
            alert('No can do, tag is referenced by at least one literature item');
          }

          event.preventDefault();
        };

      }],
      bindings: {
        tag: '<',
        tagcategory: '<',
        bluemoon: '&'
      }
    });
})();

/**
 * Created by davidhickson on 23/01/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').component('literatureTree', {
    templateUrl: 'app/showroom/literature/main/tree/literature-tree.tmpl.html',
    controller: ['$scope', '$q', '$log', 'literatureManager', 'literatureHelperService', 'tagsManager', 'MessageService', 'LiteratureMetadataFactory', 'MasterPermissionsDefinitionFactory', 'literatureXrefTagsManager', function ($scope, $q, $log, literatureManager, literatureHelperService, tagsManager, MessageService, LiteratureMetadataFactory, MasterPermissionsDefinitionFactory, literatureXrefTagsManager) {

      this.literaturesvc = literatureManager;
      this.permissions = MasterPermissionsDefinitionFactory;
      this.tagssvcreference = tagsManager;

      this.getTagTitle = function (tagId) {
        return tagsManager.tagTitleWithCategory(tagId);
      };

      this.isTagSelected = function (tag) {
        return literatureXrefTagsManager.isTagSelected(tag);
      };

      this.onToggleFilterTagSelection = function (tag) {
        literatureXrefTagsManager.deselectAllTagsExcept(tag);
        literatureXrefTagsManager.toggleFilterTagSelection(tag);
      };
    }],
    bindings: {}
  });
})();

/**
 * Created by davidhickson on 23/01/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').component('literatureTreeBlocks', {
    templateUrl: 'app/showroom/literature/main/tree/literature-tree-blocks.tmpl.html',
    controllerAs: 'vm',
    controller: ['$scope', '$q', '$log', 'literatureManager', 'literatureHelperService', 'blocksManager', 'MessageService', 'LiteratureMetadataFactory', 'MasterPermissionsDefinitionFactory', function ($scope, $q, $log, literatureManager, literatureHelperService, blocksManager, MessageService, LiteratureMetadataFactory, MasterPermissionsDefinitionFactory) {

      var vm = this;
      vm.literaturesvc = literatureManager;
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.blocks = [];

      vm.refreshTree = function () {
        vm.blocks = [];
        blocksManager.blocks.forEach(function (block) {
          if (block.isRootBlock) {
            vm.blocks.push(block);
          }
        });
      };

      vm.deselectAllBlocks = function (clickedBlock) {
        blocksManager.blocks.forEach(function (block) {
          if (clickedBlock._id !== block._id) {
            block.isSelected = false;
          }
        });
      };

      vm.toggleExpanded = function (block) {
        if (block.blocks && block.blocks.length > 0) {
          block.isExpanded = !block.isExpanded;
        } else if (block.literatures) {
          vm.deselectAllBlocks(block);
          block.isSelected = !block.isSelected;
          if (block.isSelected) {
            literatureManager.triggerDisplayRefresh(block);
          } else {
            literatureManager.triggerDisplayRefresh();
          }
        }
      };

      vm.$onInit = function () {
        vm.refreshTree();
      };

      return vm;
    }],
    bindings: {}
  });
})();

/**
 * Created by davidhickson on 23/01/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').component('litBlockTree', {
    templateUrl: 'app/showroom/literature/main/tree/literature-block-tree.tmpl.html',
    controllerAs: 'vm',
    controller: ['$scope', '$q', '$log', 'literatureManager', 'literatureHelperService', 'blocksManager', 'MessageService', 'LiteratureMetadataFactory', 'MasterPermissionsDefinitionFactory', function ($scope, $q, $log, literatureManager, literatureHelperService, blocksManager, MessageService, LiteratureMetadataFactory, MasterPermissionsDefinitionFactory) {

      var vm = this;
      vm.literaturesvc = literatureManager;
      vm.permissions = MasterPermissionsDefinitionFactory;

      vm.toggleExpanded = function (block) {
        if (block.blocks && block.blocks.length > 0) {
          block.isExpanded = !block.isExpanded;
        } else if (block.literatures) {
          vm.deselectAllBlocks(block);
          block.isSelected = !block.isSelected;
          if (block.isSelected) {
            literatureManager.triggerDisplayRefresh(block);
          } else {
            literatureManager.triggerDisplayRefresh();
          }
        }
      };

      vm.deselectAllBlocks = function (clickedBlock) {
        blocksManager.blocks.forEach(function (block) {
          if (clickedBlock._id !== block._id) {
            block.isSelected = false;
          }
        });
      };


      return vm;
    }],
    bindings: {
      blocks: '='
    }
  });
})();

/**
 * Created by davidhickson on 22/03/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').component('literatureTreeToolbar', {
    templateUrl: 'app/showroom/literature/main/toolbar/literature-tree-toolbar.tmpl.html',
    controller: ['literatureManager', 'literatureXrefTagsManager', 'LiteratureMetadataFactory', 'MessageService', 'MasterPermissionsDefinitionFactory', function (literatureManager, literatureXrefTagsManager, LiteratureMetadataFactory, MessageService, MasterPermissionsDefinitionFactory) {

      var vm = this;
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.litsvcreference = literatureManager;

      vm.toggleTreeView = function () {
        literatureManager.treeInLitMode = !literatureManager.treeInLitMode;
      };

      return vm;
    }],
    bindings: {}
  });
})();

/**
 * Created by davidhickson on 22/03/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').component('literatureToolbar', {
    templateUrl: 'app/showroom/literature/main/toolbar/literature-toolbar.tmpl.html',
    bindings: {},
    controller: ctrl
  });

  ctrl.$inject = ['literatureManager', 'literatureXrefTagsManager', 'LiteratureMetadataFactory', 'MessageService', 'MasterPermissionsDefinitionFactory', 'literatureModel'];
  /* ng-inject */
  function ctrl(literatureManager, literatureXrefTagsManager, LiteratureMetadataFactory, MessageService, MasterPermissionsDefinitionFactory, literatureModel) {

    var vm = this;
    vm.searchtext = '';
    vm.permissions = MasterPermissionsDefinitionFactory;
    vm.literatureManager = literatureManager;
    vm.$onInit = function () {

    };
    vm.filterButtonClicked = function () {
      literatureManager.shouldTagFilterBeDisplayed = !literatureManager.shouldTagFilterBeDisplayed;
    };

    vm.toggleLibraryView = function () {
      literatureManager.factoryData.inCardView = !literatureManager.factoryData.inCardView;
    };

    vm.addButtonClicked = function () {
      var dialogConfig = angular.copy(LiteratureMetadataFactory.getData().fabDialogConfig);
      MessageService.showDialog({}, dialogConfig);
    };

    vm.selectAllVisibleClicked = function () {
      literatureManager.selectAllVisibleLit();
    };

    vm.deselectAllClicked = function () {
      literatureManager.deselectAllLit();
    };

    vm.invertCurrentLitSelectionClicked = function () {
      literatureManager.invertCurrentLitSelection();
    };

    vm.searchTextChanged = function () {
      literatureManager.literatureTextSearchTermChanged(vm.searchtext);
    };

    vm.deselectAllTagsClicked = function () {
      literatureManager.factoryData.litTagSelectedCount = 0;
      literatureXrefTagsManager.deselectAllLiteratureTags();
    };

    vm.archiveClicked = function () {
      MessageService.confirm().delete('Delete selected items').then(function () {
        literatureManager.archiveSelectedLiterature();
      }).catch(function () {});
    };

    vm.anythingSelected = function () {
      var selected = _.find(literatureModel.literatureItems, function (litItm){
        return litItm.selected;
      });
      return selected;
    };

  }
})();

/**
 * Created by davidhickson on 02/03/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').component('fileImportList', {
    templateUrl: 'app/showroom/import/main/list/file-import-list.tmpl.html',
    controller: ['$log', 'fileImportService', function ($log, fileImportService) {
      this.importFileListSvc = fileImportService;

      this.toggleImportListItemSelection = function (item) {
        $log.info('importFileListTree controller toggleImportListItemSelection with ' + item.title);
        this.importFileListSvc.toggleImportListItemSelection(item);
      };

      this.requestListStatsUpdate = function (item) {
        $log.info('importFileListTree controller requestListStatsUpdate with ' + item.title);
        this.importFileListSvc.requestListStatsUpdate();
      };

      this.onToggleTagForImportItem = function (item) {
        $log.info('importFileListTree controller onToggleTagForImportItem with ' + item.title);
        this.importFileListSvc.toggleTagForImportItem(item);
      };
    }],
    bindings: {
      creep: '<'
    }
  });
})();
// /**
//  * Created by davidhickson on 23/01/2017.
//  */
//
// (function () {
//   'use strict';
//   angular.module('showroom').component('literatureList', {
//     templateUrl: 'app/showroom/literature/main/list/literature-list.tmpl.html',
//     controller: function ($scope, $q, $log, literatureManager, literatureHelperService, tagsManager, MessageService, LiteratureMetadataFactory, MasterPermissionsDefinitionFactory) {
//
//       this.literaturesvc = literatureManager;
//       this.permissions = MasterPermissionsDefinitionFactory;
//
//       this.getTagTitle = function (tagId) {
//         return tagsManager.tagTitleWithCategory(tagId);
//       };
//
//       this.requestLitStatsUpdate = function () {
//         $log.info('literatureTreeComponent requestLitStatsUpdate HERE');
//         literatureManager.requestLitStatsUpdate();
//       };
//
//       this.toggleLitLibraryLitItemSelection = function (litItem) {
//         $log.info('toggleLitLibraryLitItemSelection running');
//         literatureManager.toggleItemSelection(litItem);
//       };
//
//       this.onToggleTagForLitItem = function (extendedTag, litItem) {
//         literatureManager.tagWasToggledForLitItem(extendedTag, litItem);
//       };
//
//       this.editButtonClicked = function (litItem) {
//         $log.info('editButtonClicked had ' + JSON.stringify(litItem));
//         var dialogConfig = angular.copy(LiteratureMetadataFactory.getData().fabDialogConfig);
//         dialogConfig.locals.litDoc = litItem;
//         MessageService.showDialog({}, dialogConfig);
//       };
//
//       this.isVideo = function (weburi) {
//         var val = literatureHelperService.getContentTypeForItem({ url: weburi });
//         return (val === 'application/mov' || val === 'application/mp4');
//       };
//
//       this.isPdf = function (weburi) {
//         return literatureHelperService.getContentTypeForItem({ url: weburi }) === 'application/pdf';
//       };
//
//       this.isImage = function (weburi) {
//         return literatureHelperService.getContentTypeForItem({ url: weburi }).indexOf('image') > -1;
//       };
//
//       this.isUnknown = function (weburi) {
//         return literatureHelperService.getContentTypeForItem({ url: weburi }) === 'unknown';
//       };
//     },
//     bindings: {}
//   });
// })();

/**
 * Created by davidhickson on 26/01/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').component('literatureFilter', {
    templateUrl: 'app/showroom/literature/main/filter/literature-filter.tmpl.html',
    controller: ['tagsManager', 'literatureXrefTagsManager', function (tagsManager, literatureXrefTagsManager) {

      this.tagssvcreference = tagsManager;
      this.litxreftagssvc = literatureXrefTagsManager;

      this.isTagSelected = function (tag) {
        return literatureXrefTagsManager.isTagSelected(tag);
      };

      this.onToggleFilterTagSelection = function (tag) {
        literatureXrefTagsManager.toggleFilterTagSelection(tag);
      };

    }],
    bindings: {}
  });
})();

/**
 * Created by davidbeazer on 02/08/2017.
 */
/**
 * Provides functionality for administering Zuant client account users
 * @module users
 */

(function() {
  'use strict';

  angular
    .module('users', ['ui.router', 'common', 'zp.api', 'zp.encoding', 'clients']);
})();

(function () {
  'use strict';

  angular
    .module('users')
    .component('zpAddLiteratureFab', {
      templateUrl: 'app/showroom/literature/main/fab/fab.tmpl.html',
      controller: 'zpLiteratureMainFabController'
    })
    .controller('zpLiteratureMainFabController', zpLiteratureMainFabController);

  zpLiteratureMainFabController.$inject = ['literatureManager', 'LiteratureMetadataFactory', 'MasterPermissionsDefinitionFactory'];

  function zpLiteratureMainFabController(literatureManager, LiteratureMetadataFactory, MasterPermissionsDefinitionFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.metadata = LiteratureMetadataFactory.getData();
      vm.data = literatureManager.literatureItems;
      vm.blankSlate = vm.data.length == 0;
    };
  }
})();

/**
 * Created by davidhickson on 23/01/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').component('literatureCardList', {
    templateUrl: 'app/showroom/literature/main/card-list/literature-card-list.tmpl.html',
    bindings: {},
    controller: ctrl
  });

  ctrl.$inject = ['$scope', '$q', '$log', 'literatureManager', 'literatureHelperService', 'tagsManager', 'MessageService', 'LiteratureMetadataFactory', 'MasterPermissionsDefinitionFactory', 'literatureXrefTagsManager'];
  /* ng-inject */
  function ctrl($scope, $q, $log, literatureManager, literatureHelperService, tagsManager, MessageService, LiteratureMetadataFactory, MasterPermissionsDefinitionFactory, literatureXrefTagsManager) {

    var vm = this;
    vm.literaturesvc = literatureManager;
    vm.permissions = MasterPermissionsDefinitionFactory;
    vm.tagssvcreference = tagsManager;
    vm.rows = [];


    vm.createVirtualRows = function () {
      vm.rows = [];
      var newRow = [];
      literatureManager.literatureItems.forEach(function (item) {
        if (newRow.length === 4) {
          vm.rows.push(newRow);
          newRow = [];
        }

        if (item.isShouldBeDisplayed) {
          newRow.push(item);
        }
      });

      if (newRow.length > 0) {
        vm.rows.push(newRow);
      }
    };

    // Need to watch service array but referencing it as a return from a function is the only way
    // I can get it to trigger. Having it as quotes doesn't work for some reason (I guess because it's out of scope)
    $scope.$watch(function () {
      return literatureManager.literatureItems.length + Object.keys(literatureXrefTagsManager.tags).length;
    }, function () {
      vm.createVirtualRows();
    });

    vm.getTagTitle = function (tagId) {
      return tagsManager.tagTitleWithCategory(tagId);
    };

    vm.isTagSelected = function (tag) {
      return literatureXrefTagsManager.isTagSelected(tag);
    };

    vm.onToggleFilterTagSelection = function (tag) {
      literatureXrefTagsManager.toggleFilterTagSelection(tag);
    };

    vm.requestLitStatsUpdate = function () {
      $log.info('literatureTreeComponent requestLitStatsUpdate HERE');
      literatureManager.requestLitStatsUpdate();
    };

    vm.toggleLitLibraryLitItemSelection = function (litItem) {
      $log.info('toggleLitLibraryLitItemSelection running');
      literatureManager.toggleItemSelection(litItem);
    };

    vm.onToggleTagForLitItem = function (extendedTag, litItem) {
      if (!extendedTag.isSelected) {
        literatureManager.factoryData.litTagSelectedCount++;
      } else {
        literatureManager.factoryData.litTagSelectedCount--;
      }
      literatureManager.tagWasToggledForLitItem(extendedTag, litItem);
    };

    vm.editButtonClicked = function (litItem, $event) {
      $log.info('editButtonClicked had ' + JSON.stringify(litItem));
      var dialogConfig = angular.copy(LiteratureMetadataFactory.getData().fabDialogConfig);
      dialogConfig.locals.litDoc = litItem;
      MessageService.showDialog($event, dialogConfig);
    };

    vm.isVideo = function (weburi) {
      var val = literatureHelperService.getContentTypeForItem({
        url: weburi
      });
      return (val === 'application/mov' || val === 'application/mp4');
    };

    vm.isPdf = function (weburi) {
      return literatureHelperService.getContentTypeForItem({
        url: weburi
      }) === 'application/pdf';
    };

    vm.isImage = function (weburi) {
      return literatureHelperService.getContentTypeForItem({
        url: weburi
      }).indexOf('image') > -1;
    };

    vm.isUnknown = function (weburi) {
      return literatureHelperService.getContentTypeForItem({
        url: weburi
      }) === 'unknown';
    };

  }

})();

/**
 * Created by davidhickson on 10/04/2017.
 */

(function () {
  'use strict';

  angular.module('showroom')
    .component('zpLiteratureForm', {
      controller: 'ZPLiteratureFormController',
      controllerAs: 'vm',
      templateUrl: 'app/showroom/literature/add-or-edit-literature/zp-literature-form/zp-literature-form.tmpl.html',
      bindings: {
        litDoc: '=',
        litForm: '='
      }
    })
    .controller('ZPLiteratureFormController', ZPLiteratureFormController);

  ZPLiteratureFormController.$inject = ['ChangeDelta'];
  /* ng-inject */
  function ZPLiteratureFormController(ChangeDelta) {
    var vm = this;

    vm.$onInit = function () {
      ChangeDelta.clear();
      vm.validObj = {};
      if (vm.litDoc.allowAddToBasket == undefined) {
        vm.litDoc.allowAddToBasket = 1;
      }
    };

    vm.updateChangeDelta = function (property, newValue) {
      var oldValue = vm.copyOfLiteratureForm[property];
      ChangeDelta.recordValueChange({
        oldval: oldValue,
        newval: newValue,
        collection: 'forms',
        objectid: vm.litDoc._id,
        databasefieldname: property
      });
    };
    /* eslint no-useless-escape:0 */
    vm.weburiregexp = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/i;

  }
})();

'use strict';

angular
  .module('clients')
  .controller('AddLiteratureDialogController', AddLiteratureDialogController);

AddLiteratureDialogController.$inject = ['litDoc', 'MessageService', 'literatureManager', 'hotkeys', 'ChangeDelta', 'uuidService'];
/* ng-inject */
function AddLiteratureDialogController(litDoc, MessageService, literatureManager, hotkeys, ChangeDelta, uuidService) {

  var vm = this;
  vm.cancelDialog = cancelDialog;
  vm.hide = hide;

  function init() {
    vm.litDoc = angular.copy(litDoc);
    if (vm.litDoc.keywords) {
      vm.litDoc.keywordsAsSingleString = vm.litDoc.keywords.join(', ');
    }

    vm.litForm = {
      $invalid: true
    };
  }

  init();

  vm.submitLiteratureForm = function (formData) {
    if (!formData._id) {
      formData._id = uuidService.getSingleNewBase64Key();
    }

    if (formData.keywordsAsSingleString) {
      var arrayOfCommaSeparatedTerms = formData.keywordsAsSingleString.split(',');
      formData.keywords = arrayOfCommaSeparatedTerms.reduce(function (rollingArray, iteratee) {
        if (iteratee.trim().length > 0) {
          rollingArray.push(iteratee.trim().toLowerCase());
        }
        return rollingArray;
      }, []);
    } else {
      formData.keywords = [];
    }
    delete formData.keywordsAsSingleString;

    vm.disableSaveButton = true;
    return literatureManager.ingestChangedLiteratureItem(formData)
      .then(function () {
        MessageService.showMessage('Literature Item saved');
        vm.disableSaveButton = false;
        ChangeDelta.clear();
        hide(true);
      })
      .catch(function (err) {
        vm.disableSaveButton = false;
        $log.error(err);
        MessageService.writeLog({
          level: 'error',
          msg: err
        });
        MessageService.showMessage(err.data.data.message);
      });
  };

  // modal dismiss functions
  function hide(answer) {
    hotkeys.del('enter');
    MessageService.closeDialog(answer);
  }

  function cancelDialog() {
    hotkeys.del('enter');
    MessageService.cancelDialog();
  }

}

/**
 * Created by davidhickson on 10/04/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').component('fileImportToolbar', {
    templateUrl: 'app/showroom/import/main/toolbar/file-import-toolbar.tmpl.html',
    controller: function () {}
  });
})();
/**
 * Created by davidhickson on 11/04/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').component('fileImportSelector', {
    templateUrl: 'app/showroom/import/main/selector/file-import-selector.tmpl.html',
    controller: ['$scope', 'fileImportService', 'MasterPermissionsDefinitionFactory', function ($scope, fileImportService, MasterPermissionsDefinitionFactory) {

      this.permissions = MasterPermissionsDefinitionFactory;

      $scope.fileChanged = function ($event) {
        var fileReference = $event.target.files[0];

        Papa.parse(fileReference, {
          complete: function (results) {
            //Papaparse seems to operate such that Angular does not see the changes when applied here, hence wrap the update in $scope.$apply:
            $scope.$apply(function () {
              fileImportService.hydrateWithCSVObject(results);
            });
          }
        });
      };
    }]
  });
})();

/**
 * Created by davidhickson on 02/05/2017.
 */
(function () {
  'use strict';
  angular
    .module('showroom')
    .component('imagesToolbar', {
      templateUrl: 'app/showroom/images/main/toolbar/images-toolbar.tmpl.html',
      controller: ['ImagesApiFactory', 'ImageMetadataFactory', 'MessageService', 'MasterPermissionsDefinitionFactory', function (ImagesApiFactory, ImageMetadataFactory, MessageService, MasterPermissionsDefinitionFactory) {

        this.ImagesApiFactory = ImagesApiFactory;
        this.permissions = MasterPermissionsDefinitionFactory;

        this.addButtonClicked = function () {
          var dialogConfig = angular.copy(ImageMetadataFactory.getData().fabDialogConfig);
          MessageService.showDialog({}, dialogConfig);
        };

        this.archiveClicked = function () {
          MessageService.confirm().delete('Delete selected items').then(function () {
            ImagesApiFactory.removeSelectedImages();
          }).catch(function () {});
        };

        this.searchTextChanged = function () {
          ImagesApiFactory.searchTermChanged();
        };
      }]
    });
})();

/**
 * Created by davidhickson on 28/02/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').component('fileImportActions', {
    templateUrl: 'app/showroom/import/main/actions/file-import-actions.tmpl.html',
    controller: ['fileImportService', function (fileImportService) {

      this.countOfSelectedItemsPhrase = fileImportService.countOfSelectedItemsPhrase;
      this.mappedImportListSvc = fileImportService;

      this.importSelectedItemsToLiteratureLibrary = function () {
        fileImportService.importSelectedItemsToLiteratureLibrary();
      };
    }],
    bindings: {}
  });
})();
(function () {
  'use strict';

  angular
    .module('showroom')
    .component('zpAddImageFab', {
      templateUrl: 'app/showroom/images/main/fab-add/fab.tmpl.html',
      controller: 'zpAddImageFabCtrl',
      bindings: {
        clientId: '<'
      }
    })
    .controller('zpAddImageFabCtrl', ctrl);

  ctrl.$inject = ['MasterPermissionsDefinitionFactory', 'ImageMetadataFactory', 'MessageService', 'ImagesApiFactory'];
  /* nj-inject */
  function ctrl(MasterPermissionsDefinitionFactory, ImageMetadataFactory, MessageService, ImagesApiFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.permissions = MasterPermissionsDefinitionFactory;

      vm.metadata = {
        fabAddDialogConfig: ImageMetadataFactory.getData().fabDialogConfig
      };
      vm.metadata.fabAddDialogConfig.locals.formType = 'new';
      vm.metadata.fabAddDialogConfig.locals.dropboxCallbackLocation = {
        state: 'app.oldshowroom.showroom.images',
        params: {}
      };

      vm.data = {
        items: ImagesApiFactory.factoryData.arrayOfImageItems
      };
    };

  }
})();

/**
 * Created by davidhickson on 02/05/2017.
 */

(function () {
  'use strict';
  angular
    .module('showroom')
    .component('imagesList', {
      templateUrl: 'app/showroom/images/main/list/images-list.tmpl.html',
      controller: 'ImagesListCtrl',
      bindings: {}
    })
    .controller('ImagesListCtrl', ctrl);

  ctrl.$inject = ['ImagesApiFactory', 'ImageMetadataFactory', 'MessageService', 'MasterPermissionsDefinitionFactory', '$timeout', 'AWS_STORAGE_REGION', 'AWS_STORAGE_BUCKET_NAME'];
  /* ng-inject */
  function ctrl(ImagesApiFactory, ImageMetadataFactory, MessageService, MasterPermissionsDefinitionFactory, $timeout, awsStorageRegion, awsStorageBucketName) {

    var vm = this;

    vm.$onInit = function () {
      vm.imgsvcreference = ImagesApiFactory;
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.layout = 'cards';
      vm.s3BaseUrl = 'https://s3.' + awsStorageRegion + '.amazonaws.com/' + awsStorageBucketName;

      ImagesApiFactory.grabImageBase64ValuesFromServer();
    };

    vm.toggleLayout = function () {
      vm.layout = vm.layout === 'list' ? 'cards' : 'list';
    };

    vm.editButtonClicked = function (imgItem, ev) {
      var dialogConfig = angular.copy(ImageMetadataFactory.getData().fabDialogConfig);
      dialogConfig.locals.imageDoc = imgItem;
      dialogConfig.locals.formType = 'edit';
      MessageService.showDialog(ev, dialogConfig)
        .then(function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'image dialog closed'
          });
        })
        .catch(function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'image dialog cancelled'
          });
        });
    };

    vm.toggleImageItemSelection = function (imgItem) {
      imgItem.selected = !imgItem.selected;
    };

    vm.archiveClicked = function (imgItem) {
      vm.toggleImageItemSelection(imgItem);
      MessageService.confirm()
        .delete('Delete this image?')
        .then(function () {
          ImagesApiFactory.removeSelectedImages();
        })
        .catch(function () {
          vm.toggleImageItemSelection(imgItem);
          MessageService.writeLog({
            level: 'info',
            msg: 'user cancelled delete image dialog'
          });
        });
    };

    vm.migrateImageToDropboxStorage = function (imageObject) {
      imageObject.loading = true;
      imageObject.showMigrateText = false;
      ImagesApiFactory.migrateImageToDropboxStorage(imageObject)
        .then(function () {
          imageObject.loading = false;
          imageObject.imageMigratedToDropbox = true;
          imageObject.icon = 'cloud_done';
          delete imageObject.imagebase64;
          $timeout(function (){
            imageObject.showMigrateToDropboxBtn = false;
          }, 3000);
        })
        .catch(function () {
          imageObject.imageMigratedToDropbox = false;
        });
    };

  }
})();

/**
 * Created by davidhickson on 06/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('blocksScreen', {
      templateUrl: 'app/showroom/blocks/main/screen/blocks-screen.tmpl.html',
      controllerAs: 'vm',
      controller: 'blocksScreenCtrl',
      bindings: {
        block: '=',
        tabInfo: '=',
        refreshTree: '&',
        updateCurrentBlock: '&',
        deselectAllBlocks: '&'
      }
    })
    .controller('blocksScreenCtrl', ctrl);

  ctrl.$inject = ['$scope', '$window', '$q', '$timeout', 'blocksManager', 'blocksXrefLiteratureManager', 'BlocksMetadataFactory', 'ImagesApiFactory', 'MessageService', 'MasterPermissionsDefinitionFactory', '$filter'];
  /* ng-inject */
  function ctrl($scope, $window, $q, $timeout, blocksManager, blocksXrefLiteratureManager, BlocksMetadataFactory, ImagesApiFactory, MessageService, MasterPermissionsDefinitionFactory, $filter) {

    var vm = this;

    vm.$onInit = function () {
      vm.blockssvcreference = blocksManager;
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.displayBlocks = [];
      vm.nameplateBlockStyle = {};
      vm.nameplateStyle = {};
      vm.backStyle = {};
      vm.captionStyle = {};
      vm.style = {};
      vm.imageStyle = {};
      vm.ipadScreenWidth = 1024;
      vm.ipadScreenHeight = 768;
      vm.innerScreenStyle = {};
      vm.overlay = {
        position: 'absolute',
        'min-height': '100%',
        'min-width': '100%',
        'z-index': 10,
        top: 0,
        left: 0,
        'background-color': '#fff'
      };

      vm.imageWidth = 1280; // width of the actual png
      vm.imageHeight = 985; // height of the actual png

      vm.iPadScreenImageUrl = $filter('cdnAssets')('/images/pngs/devices/ipad-1280.png');

    };

    $scope.$on('$destroy', function () {
      angular.element($window).off('resize');
    });

    $scope.$watch('$viewContentLoaded', function () {

      $timeout(function (){
        recalculatePixelRatio();
        angular.element($window).on('resize', recalculatePixelRatio);
      }, 100);
    });

    $scope.$watch('[vm.block._id, vm.block.backgroundImage, vm.block.heightOfBlocks, vm.block.padding, vm.block.nameplateHidden, vm.block.blocksPerRow, vm.block.literatures.length, vm.block.blocks.length]', function (newVal, oldVal) {
      if (newVal[0] !== oldVal[0]) { // Id changed

        vm.selectedBlock = null;
        getSubBlockImages()
          .then(recalculateDisplay)
          .then(recalculateHeight)
          .then(recalculateWidth)
          .then(recalculatePadding)
          .then(recalculateFontSize)
          .then(function () {
            vm.backgroundImageDimensions = null;
          })
          .then(setBackgroundImageSize);
      } else if (newVal[1] !== oldVal[1]) { // background image changed
        vm.backgroundImageDimensions = null;
        setBackgroundImageSize();
      } else if (newVal[2] !== oldVal[2]) { // height of blocks changed
        recalculateHeight();
      } else if (newVal[3] !== oldVal[3]) { // padding changed
        recalculateWidth();
        recalculatePadding();
        recalculateFontSize();
      } else if (newVal[4] !== oldVal[4]) { // nameplate hidden changed
        recalculateHeight();
      } else { // any of the others have changed
        getSubBlockImages()
          .then(recalculateDisplay)
          .then(recalculateWidth)
          .then(recalculateFontSize);
      }
    });

    vm.getSelectedNameplate = function () {
      if (vm.selectedBlock) {
        return vm.selectedBlock.nameplate;
      } else {
        return vm.block.nameplate;
      }
    };

    vm.getKnownImageUri = function (imageId) {
      var ret = $filter('cdnAssets')('/images/pngs/gradients/1024x768_white_grad_circular.png');

      ImagesApiFactory.factoryData.arrayOfImageItems.forEach(function (image) {
        if (image._id === imageId) {
          ret = $filter('zpDropboxRaw')(image.weburi);
        }
      });
      return ret;
    };

    vm.getImageUri = function (imageId) {
      var defer = $q.defer();
      var ret = $filter('cdnAssets')('/images/pngs/gradients/1024x768_white_grad_circular.png'); // TODO placeholder background image for showroom (plain white to match the app?)
      var found = false;

      ImagesApiFactory.factoryData.arrayOfImageItems.forEach(function (image) {
        if (image._id === imageId) {
          found = true;
          if (image.weburi) {
            ret = $filter('zpDropboxRaw')(image.weburi);
            defer.resolve(ret);
          } else {
            ImagesApiFactory.getImage(imageId).then(function (response) {
              image.weburi = response.data.data.weburi;
              ret = $filter('zpDropboxRaw')(image.weburi);
              defer.resolve(ret);
            });
          }
        }
      });

      if (!found) {
        defer.resolve(ret);
      }
      return defer.promise;
    };

    function getSubBlockImages() {
      var i = 0;
      var len = (vm.block.blocks || []).length;
      var pArr = [];

      for (i; i < len; i++) {
        if (vm.block.blocks[i].nameplateImage) {
          pArr.push(vm.getImageUri(vm.block.blocks[i].nameplateImage));
        }
      }

      return $q.all(pArr);
    }

    vm.editBlock = function ($event) {
      var dialogConfig = angular.copy(BlocksMetadataFactory.getData().addDialogConfig);
      dialogConfig.locals.parentBlockDoc = vm.block;
      dialogConfig.locals.blockDoc = vm.selectedBlock;
      dialogConfig.locals.formType = 'new'; // image form
      MessageService.showDialog($event, dialogConfig).then(function (editedBlock) {
        vm.block.blocks.forEach(function (sharedBlock) {
          if (sharedBlock._id === editedBlock._id) {
            sharedBlock.nameplateImage = editedBlock.nameplateImage;
            sharedBlock.nameplate = editedBlock.nameplate;
            sharedBlock.description = editedBlock.description;
            sharedBlock.nameplateHidden = editedBlock.nameplateHidden;
          }
        });
        vm.selectedBlock.nameplateImage = editedBlock.nameplateImage;
        vm.selectedBlock.nameplate = editedBlock.nameplate;
        vm.selectedBlock.description = editedBlock.description;
        vm.selectedBlock.nameplateHidden = editedBlock.nameplateHidden;
        getSubBlockImages();
      }).catch(function () {});
      $event.stopPropagation();
    };

    vm.removeBlock = function ($event) {
      var dialogConfig = angular.copy(BlocksMetadataFactory.getData().removeDialogConfig);
      dialogConfig.locals.blockDoc = vm.selectedBlock;
      dialogConfig.locals.parentBlockDoc = vm.block;
      MessageService.showDialog($event, dialogConfig)
        .then(function () {
          recalculateDisplay();
          vm.refreshTree();
          vm.selectedBlock = null;
        }).catch(function () {});
      $event.stopPropagation();
    };

    vm.removeLiterature = function ($event, literature) {
      blocksXrefLiteratureManager.removeLitFromBlock(literature, vm.block)
        .then(function () {
          MessageService.showMessage('Literature item removed');
          recalculateDisplay();
        }).catch(function () {});
      $event.stopPropagation();
    };

    vm.addNewBlock = function ($event) {
      var dialogConfig = angular.copy(BlocksMetadataFactory.getData().addDialogConfig);
      dialogConfig.locals.parentBlockDoc = vm.block;
      dialogConfig.locals.formType = 'new';
      MessageService.showDialog($event, dialogConfig);
    };

    vm.addBlock = function ($event) {
      var dialogConfig = angular.copy(BlocksMetadataFactory.getData().addSubBlocksDialogConfig);
      dialogConfig.locals.blockDoc = vm.block;
      dialogConfig.locals.formType = 'new';
      MessageService.showDialog($event, dialogConfig)
        .then(function () {}).catch(function () {});
    };

    vm.addLiterature = function ($event) {
      var dialogConfig = angular.copy(BlocksMetadataFactory.getData().addLiteratureDialogConfig);
      dialogConfig.locals.blockDoc = vm.block;
      MessageService.showDialog($event, dialogConfig)
        .then(function () {}).catch(function () {});
    };

    vm.editCurrentBlock = function ($event) {
      var dialogConfig = angular.copy(BlocksMetadataFactory.getData().editParentDialogConfig);
      dialogConfig.locals.blockDoc = vm.block;
      dialogConfig.locals.formType = 'new'; // for the image form
      MessageService.showDialog($event, dialogConfig).then(function (editedBlock) {
        vm.block.blocks.forEach(function (sharedBlock) {
          if (sharedBlock._id === editedBlock._id) {
            sharedBlock.backgroundImage = editedBlock.backgroundImage;
            sharedBlock.nameplate = editedBlock.nameplate;
            sharedBlock.description = editedBlock.description;
            sharedBlock.caption = editedBlock.caption;
          }
        });
        vm.block.backgroundImage = editedBlock.backgroundImage;
        vm.block.nameplate = editedBlock.nameplate;
        vm.block.description = editedBlock.description;
        vm.block.caption = editedBlock.caption;
      }).catch(function () {});
    };

    vm.editVisuals = function ($event) {
      var dialogConfig = angular.copy(BlocksMetadataFactory.getData().editParentVisualsDialogConfig);
      dialogConfig.locals.blockDoc = vm.block;
      MessageService.showDialog($event, dialogConfig).then(function (editedBlock) {
        vm.block.blocks.forEach(function (sharedBlock) {
          if (sharedBlock._id === editedBlock._id) {
            sharedBlock.heightOfBlocks = editedBlock.heightOfBlocks;
            sharedBlock.padding = editedBlock.padding;
            sharedBlock.blocksPerRow = editedBlock.blocksPerRow;
          }
        });
        vm.block.heightOfBlocks = editedBlock.heightOfBlocks;
        vm.block.padding = editedBlock.padding;
        vm.block.blocksPerRow = editedBlock.blocksPerRow;
      }).catch(function () {});
    };

    vm.goToBlock = function () {
      if (vm.type === 'block') {
        vm.deselectAllBlocks();
        vm.block.blocks.forEach(function (block) {
          if (block._id === vm.selectedBlock._id) {
            block.isSelected = true;
          }
        });
        vm.block.lastSelected = true;
        vm.updateCurrentBlock();
        vm.selectedBlock = null;
      }
    };

    vm.selectBlock = function (chosenBlock) {
      if (vm.selectedBlock && chosenBlock._id === vm.selectedBlock._id) {
        vm.selectedBlock = null;
      } else if (vm.tabInfo.blocks) {
        vm.selectedBlock = chosenBlock;
      }
    };

    vm.goToParentBlock = function () {
      var parentToSelect;
      // vm.selectedBlock = null;
      vm.block.arrayOfParentBlocks.forEach(function (parent) {
        if (parent.lastSelected) {
          parentToSelect = parent;
        }
      });

      // This can occur when navigating via tree view and selected a random child
      if (!parentToSelect) {
        parentToSelect = vm.block.arrayOfParentBlocks[0];
        parentToSelect.lastSelected = true;
      }

      vm.deselectAllBlocks();
      parentToSelect.isSelected = true;
      vm.block.lastSelected = false;
      vm.updateCurrentBlock();
      vm.selectedBlock = null;
    };

    function recalculateDisplay() {
      vm.displayBlocks = [];
      var blocksPerRow = vm.block.blocksPerRow || 3;
      var row = [];
      var j = 0;
      vm.type = 'block';
      var childBlocksArr = angular.copy(vm.block.blocks) || [];
      var literatureArr = angular.copy(vm.block.literatures) || [];
      var blockLen;
      var len;
      var i;
      var showLiteratureTab = false;
      var showBlockTab = false;

      if (childBlocksArr.length === 0 && literatureArr.length === 0) {
        showLiteratureTab = true;
        showBlockTab = true;
      }

      if (childBlocksArr.length > 0) {
        showBlockTab = true;
        blockLen = childBlocksArr.length;
        len = blockLen * blocksPerRow;
        i = 0;

        // Extra conditions on loop to stop loop once we've run out of blocks
        for (i; i < len && i < blockLen; i += blocksPerRow) {
          row = [];
          j = 0;

          // Extra condition on loop to pull out exactly when we run out of
          // available blocks so that the extra 'add' block is put in the correct array
          for (j; j < blocksPerRow && i + j < blockLen; j++) {
            if (childBlocksArr[i + j]) {
              row.push(childBlocksArr[i + j]);
            }
          }
          vm.displayBlocks.push(row);
        }
      } else if (literatureArr.length > 0) {
        vm.type = 'literature';
        showLiteratureTab = true;

        blockLen = literatureArr.length;
        len = blockLen * blocksPerRow;
        i = 0;

        // Extra conditions on loop to stop loop once we've run out of blocks
        for (i; i < len && i < blockLen; i += blocksPerRow) {
          row = [];
          j = 0;

          // Extra condition on loop to pull out exactly when we run out of
          // available blocks so that the extra 'add' block is put in the correct array
          for (j; j < blocksPerRow && i + j < blockLen; j++) {
            if (literatureArr[i + j]) {
              row.push(literatureArr[i + j]);
            }
          }
          vm.displayBlocks.push(row);
        }
      }

      vm.tabInfo.literature = showLiteratureTab;
      vm.tabInfo.blocks = showBlockTab;
    }

    function recalculateWidth() {
      vm.style.width = ((vm.ipadScreenWidth - (vm.block.padding * (vm.block.blocksPerRow + 1))) / vm.block.blocksPerRow) * vm.pixelRatio;
      recalculateImageSize();
    }

    function recalculateImageSize() {
      vm.imageStyle['max-width'] = vm.style.width;
      vm.imageStyle['max-height'] = vm.style.height - vm.nameplateBlockStyle.height;
    }

    function recalculateFontSize() {
      var initialSize = Math.max(45 - (5 * vm.block.blocksPerRow), 15);
      vm.nameplateStyle['font-size'] = initialSize * vm.pixelRatio;
      vm.captionStyle['font-size'] = 60 * vm.pixelRatio;
    }

    function recalculatePadding() {
      vm.style['margin-left'] = (vm.block.padding / 2) * vm.pixelRatio;
      vm.style['margin-right'] = (vm.block.padding / 2) * vm.pixelRatio;
      vm.style['margin-bottom'] = vm.block.padding * vm.pixelRatio;
    }

    function recalculateHeight() {
      vm.style.height = vm.block.heightOfBlocks * vm.pixelRatio;
      if (vm.block.heightOfBlocks > 80) {
        vm.nameplateBlockStyle.height = 80 * vm.pixelRatio;
      } else {
        vm.nameplateBlockStyle.height = vm.block.heightOfBlocks * vm.pixelRatio;
      }

      vm.backStyle.width = 70 * vm.pixelRatio;
      vm.backStyle.height = 70 * vm.pixelRatio;
      recalculateImageSize();
    }

    function getImageSize(imgSrc, callback) {
      if (!vm.backgroundImageDimensions) {
        var newImg = new Image();
        newImg.onload = function () {
          if (callback) {
            vm.backgroundImageDimensions = {
              width: newImg.width,
              height: newImg.height
            };
            $timeout(function () {
              // I do the timeout so that the digest cycle is properly registered but if the user is updating
              // values too quickly, this property can be wiped by the time we get here.
              // This does not matter as we only care about the last event anyway
              if (vm.backgroundImageDimensions) {
                callback(vm.backgroundImageDimensions);
              }
            }, 0);
          }
        };
        newImg.src = imgSrc;
      } else {
        callback(vm.backgroundImageDimensions);
      }
    }

    function setBackgroundImageSize() {
      vm.getImageUri(vm.block.backgroundImage).then(function (imageUri) {
        getImageSize(imageUri, function (backgroundImageSize) {
          var backgroundImageHeight;
          var backgroundImageWidth;

          if (vm.ipadScreenWidth / vm.ipadScreenHeight < backgroundImageSize.width / backgroundImageSize.height) {
            backgroundImageHeight = vm.innerScreenStyle.height;
            backgroundImageWidth = backgroundImageSize.width / (backgroundImageSize.height / vm.innerScreenStyle.height);
          } else {
            backgroundImageHeight = backgroundImageSize.height / (backgroundImageSize.width / vm.innerScreenStyle.width);
            backgroundImageWidth = vm.innerScreenStyle.width;
          }
          vm.innerScreenStyle['background-size'] = backgroundImageWidth + 'px ' + backgroundImageHeight + 'px';
          vm.innerScreenStyle['background-image'] = 'url(' + imageUri + ')';
          vm.overlay['z-index'] = 0;
          vm.overlay['background-color'] = 'none';
          vm.overlay['min-height'] = 0;
          vm.overlay['min-width'] = 0;
        });
      });
    }

    function recalculatePixelRatio() {
      var ipadScreen = angular.element(document).find('#ipad-screen')[0];
      ipadScreen.style.backgroundImage= 'url("' + vm.iPadScreenImageUrl + '")';
      
      var screenWidth = ipadScreen.clientWidth;
      var screenHeight = ipadScreen.clientHeight;

      var currentAspectRatio = screenWidth / screenHeight;
      var actualHeight;
      var actualWidth;

      if (currentAspectRatio > vm.imageWidth / vm.imageHeight) {
        // Larger width means ipad image is at full height and a reduced width
        actualHeight = screenHeight;
        vm.pixelRatio = screenHeight / vm.imageHeight;
        actualWidth = vm.pixelRatio * vm.imageWidth;
      } else {
        // Larger height means ipad image is at full width and a reduced height
        vm.pixelRatio = screenWidth / vm.imageWidth;
        actualHeight = vm.pixelRatio * vm.imageHeight;
        actualWidth = screenWidth;
      }

      var topBottomScreenMargin = ((vm.imageHeight - vm.ipadScreenHeight) * vm.pixelRatio / 2) + ((screenHeight - actualHeight) / 2);
      var leftRightScreenMargin = ((vm.imageWidth - vm.ipadScreenWidth) * vm.pixelRatio / 2) + ((screenWidth - actualWidth) / 2);

      vm.innerScreenStyle.width = vm.ipadScreenWidth * vm.pixelRatio;
      vm.innerScreenStyle.height = vm.ipadScreenHeight * vm.pixelRatio;
      vm.innerScreenStyle['margin-top'] = topBottomScreenMargin;
      vm.innerScreenStyle['margin-bottom'] = topBottomScreenMargin;
      vm.innerScreenStyle['margin-left'] = leftRightScreenMargin;
      vm.innerScreenStyle['margin-right'] = leftRightScreenMargin;
      vm.innerScreenStyle['overflow'] = 'hidden';

      vm.nameplateStyle = {
        'line-height': 40 * vm.pixelRatio + 'px'
      };

      recalculateWidth();
      recalculatePadding();
      recalculateHeight();
      recalculateFontSize();
      setBackgroundImageSize();
    }
  }

})();

/**
 * Created by davidhickson on 06/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('blocksSidebar', {
      templateUrl: 'app/showroom/blocks/main/sidebar/blocks-sidebar.tmpl.html',
      controllerAs: 'vm',
      bindings: {
        blocks: '=',
        deselectAllBlocks: '&',
        updateCurrentBlock: '&',
        refreshTree: '&',
        currentBlock: '=',
        tabInfo: '='
      },
      controller: ['$scope', 'blocksManager', 'BlocksMetadataFactory', 'MessageService', 'SessionService', 'MasterPermissionsDefinitionFactory', function ($scope, blocksManager, BlocksMetadataFactory, MessageService, SessionService, MasterPermissionsDefinitionFactory) {

        var vm = this;
        vm.blockssvcreference = blocksManager;
        vm.selectedTab = 0;
        vm.permissions = MasterPermissionsDefinitionFactory;
        var userData = SessionService.getUserData();
        vm.hasShowroomEdit = userData.permissions.boltOns.showroom.basic.indexOf('edit') > -1;

        $scope.$watch('vm.tabInfo.selectedTab', function () {
          switch (vm.tabInfo.selectedTab) {
            case 'block':
              vm.selectedTab = 3;
              break;
            case 'literature':
              vm.selectedTab = 2;
              break;
          }
        });

        vm.setSelectedTab = function (val) {
          vm.selectedTab = val;
          vm.tabInfo.selectedTab = val;
        };

        vm.addNewBlock = function ($event) {
          var dialogConfig = angular.copy(BlocksMetadataFactory.getData().addDialogConfig);
          dialogConfig.locals.parentBlockDoc = null;
          dialogConfig.locals.formType = 'new';

          MessageService.showDialog($event, dialogConfig).then(vm.refreshTree);
        };

        vm.deleteAllBlocks = function ($event) {
          MessageService.confirm($event).archive('Archive all blocks?')
            .then(function (){
              blocksManager.archiveBlock(null, true)
                .then(function (){
                  vm.blocks.length = 0;
                  MessageService.showMessage('All blocks have been archived');
                });
            });
        };

        return vm;
      }]
    });
})();

(function () {
  'use strict';
  angular
    .module('integration')
    .component('zpThirdPartyMappingField', {
      controller: 'ThirdPartyMappingFieldCtrl',
      templateUrl: 'app/integration/field-mappings-page/spof/zp-third-party-mapping-field/tmpl.html',
      bindings: {
        fieldInfo: '<',
        index: '<'
      }
    })
    .controller('ThirdPartyMappingFieldCtrl', controller);

  controller.$inject = ['MachineMappingsViewModel'];
  /* ng-inject */
  function controller(MachineMappingsViewModel) {

    var vm = this;

    vm.$onInit = function () {
      vm.mdata = MachineMappingsViewModel.viewModel.proxyMappings[vm.index].mdata;
      vm.viewModel = MachineMappingsViewModel.viewModel;
    };

    /**
     * looks at a 3rd party datatype and returns an icon string
     */
    vm.buildIcon = function() {
      switch (MachineMappingsViewModel.viewModel.proxyMappings[vm.index].mdata.datatype) {
        case 'Text':
          return 'zmdi-text-format';

        case 'text':
          return 'zmdi-text-format';

        case 'string':
          return 'zmdi-text-format';

        case 'textarea':
          return 'zmdi-format-align-left';

        case 'date':
          return 'zmdi-calendar';

        case 'Date':
          return 'zmdi-calendar';

        case 'datetime':
          return 'zmdi-calendar';

        case 'Number':
          return 'zmdi-zero';

        case 'number':
          return 'zmdi-zero';

        case 'numeric':
          return 'zmdi-zero';

        case 'int':
          return 'zmdi-zero';

        case 'boolean':
          return 'zmdi-dot-circle';

        case 'reference':
          return 'zmdi-zero';

        case 'id':
          return 'zmdi-key';

        case 'picklist':
          return 'zmdi-check-square';

        case 'phone':
          return 'zmdi-phone';

        case 'email':
          return 'zmdi-mail-send';

        case 'url':
          return 'zmdi-http';

        case 'currency':
          return 'zmdi-money';
      }
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpMappingsToolbarComponent', {
      templateUrl: 'app/integration/field-mappings-page/spof/zp-mappings-toolbar/tmpl.html',
      controller: 'mappingsToolbarCtrl',
      bindings: {
        currentMachine: '<'
      }
    })
    .controller('mappingsToolbarCtrl', controller);

  controller.$inject = ['$state', 'MachineMappingsViewModel', 'MasterPermissionsDefinitionFactory'];
  /* ng-inject */
  function controller($state, MachineMappingsViewModel, MasterPermissionsDefinitionFactory) {

    var vm = this;
    vm.showMachineInfo = false;

    vm.$onInit = function () {
      vm.viewModel = MachineMappingsViewModel.viewModel;
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.copyOfMachine = angular.copy(vm.currentMachine);
      vm.changeDelta = MachineMappingsViewModel.changeDelta;
    };

    vm.deleteMachine = function (ev) {
      MachineMappingsViewModel.deleteMachine(ev, vm.currentMachine._machineid)
        .then(function (){
          $state.go('app.homescreen_app_framework.integration-home');
        })
        .catch(function (){
        //
        });
    };

    vm.updateChangeDelta = function (newVal, prop) {
      MachineMappingsViewModel.updateChangeDelta({
        collection: 'clients',
        objectid: vm.currentMachine._id,
        databasefieldname: prop,
        oldval: vm.copyOfMachine[prop],
        newval: newVal
      });
    };

    vm.sourceFormConfig = MachineMappingsViewModel.sourceFormConfig;

    vm.grabSourceForm = function (item) {
      MachineMappingsViewModel.grabSourceFormFields(item);
    };

    vm.deleteMappings = function (ev){
      MachineMappingsViewModel.deleteMappings(ev);
    };

    vm.clearUnmappedFields = function(ev){
      MachineMappingsViewModel.clearUnmappedFieldsPrompt(ev);
    };

    vm.showMachineSettingsDialog = function (ev) {
      const config = {
        ev: ev,
        controller: 'MachineSettingsDialogCtrl',
        controllerAs: '$ctrl',
        templateUrl: 'app/integration/dialogs/zp-machine-info-dialog/tmpl.html'
      };
      MachineMappingsViewModel.showMachineSettingsDialog(config)
        .then(function (){})
        .catch(function (){});
    };

    vm.showMachineJSON = function (ev) {
      const config = {
        ev: ev,
        controller: 'MachineJSONDialogCtrl',
        controllerAs: '$ctrl',
        templateUrl: 'app/integration/dialogs/zp-machine-json-dialog/tmpl.html'
      };
      MachineMappingsViewModel.showMachineJSONDialog(config)
        .then(function (){})
        .catch(function (){});
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpMappingsComponent', {
      templateUrl: 'app/integration/field-mappings-page/spof/zp-mappings/tmpl.html',
      controller: 'MappingsController',
      bindings: {
        currentMachine: '<'
      }
    })
    .controller('MappingsController', MappingsController);

  MappingsController.$inject = ['MachineMappingsViewModel', 'PermPermissionStore', 'MasterPermissionsDefinitionFactory'];
  /* @ngInject */
  function MappingsController(MachineMappingsViewModel, PermPermissionStore, MasterPermissionsDefinitionFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.canDrag();
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.columnZ = MachineMappingsViewModel.viewModel.columnZ;
      vm.newColumnAIcon = {
        icn: 'add',
        fill: {
          fill: '#949ca1'
        }
      };
      vm.newFieldName = '';
      vm.showNewMappingForm = false;
      vm.mappingsShell = MachineMappingsViewModel.viewModel.mappingsShell;
      vm.viewModel = MachineMappingsViewModel.viewModel;
      vm.copyOfMachine = angular.copy(vm.currentMachine);
      vm.changeDelta = MachineMappingsViewModel.changeDelta;
      if (vm.currentMachine.actuator.system !== 'HttpPost') {
        MachineMappingsViewModel.grabThirdPartyFields();
      } else {
        MachineMappingsViewModel.checkForCachedFields();
      }
      vm.draggedListModel = [];
      vm.viewModel = MachineMappingsViewModel.viewModel;
      vm.proxyMappings = MachineMappingsViewModel.viewModel.proxyMappings;
    };

    vm.manageMappingTransforms = function (ev, item) {
      vm.transformInEdit = item.mapping[0][vm.viewModel.thirdPartyMappingKey].field;

      const config = {
        ev: ev,
        controller: 'ManageFieldMappingDialogCtrl as $ctrl',
        templateUrl: 'app/integration/dialogs/zp-manage-field-mapping-dialog/tmpl.html',
        locals: item.mapping[0]
      };

      MachineMappingsViewModel.manageMappingTransforms(config)
        .then(function () {
          vm.transformInEdit = '';
        })
        .catch(function () {
          vm.transformInEdit = '';
        });
    };

    vm.deleteMachine = function (ev) {
      MachineMappingsViewModel.deleteMachine(ev, vm.currentMachine);
    };

    vm.updateChangeDelta = function (newVal, prop) {
      MachineMappingsViewModel.updateChangeDelta({
        collection: 'clients',
        objectid: vm.currentMachine._id,
        databasefieldname: prop,
        oldval: vm.copyOfMachine[prop],
        newval: newVal
      });
    };

    vm.dragStart = function (ev, ix) {
      MachineMappingsViewModel.viewModel.showDropArea = true;
      vm.dragStartIndex = ix;
    };

    vm.dragEnd = function () {
      MachineMappingsViewModel.viewModel.showDropArea = false;
      vm.dragStartIndex = null;
    };

    vm.dropped = function (ix, itm) {
      // a cell has been dropped from either columnA or columnZ
      const sourceCellConfig = {
        index: vm.dragStartIndex,
        sourceColumn: MachineMappingsViewModel.viewModel.showDropArea ? 'Z' : 'A' // AWFUL brittle way of distinguishing if source column is A or Z
      };
      MachineMappingsViewModel.updateMapping(ix, itm, sourceCellConfig);
    };

    vm.unmapField = function (ix) {
      MachineMappingsViewModel.updateMapping(ix, {
        object: '',
        dbname: ''
      }, {
        index: ix,
        sourceColumn: 'Z'
      },
      true);
    };

    vm.canDrag = function () {
      const permission = PermPermissionStore.getPermissionDefinition('INTEGRATION_MACHINES_EDIT');
      permission.validatePermission()
        .then(function () {
          vm.dndDisabled = false;
        })
        .catch(function () {
          vm.dndDisabled = true;
        });
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpAddMappingRow', {
      templateUrl: 'app/integration/field-mappings-page/spof/zp-add-mapping-row/tmpl.html',
      controller: 'AddMappingRowCtrl',
      bindings: {}
    })
    .controller('AddMappingRowCtrl', controller);

  controller.$inject = ['MachineMappingsViewModel'];
  /* ng-inject */
  function controller(MachineMappingsViewModel) {

    var vm = this;

    vm.$onInit = function () {
      vm.formObj = {
        newField: ''
      };
    };

    vm.addRow = function () {
      const newFieldIsValid = MachineMappingsViewModel.addNewMappingRow(vm.formObj.newField);
      if (newFieldIsValid) {
        // Reset the form model.
        vm.formObj = {};
        // Set back to pristine.
        vm.form.$setPristine();
        // Since Angular 1.3, set back to untouched state.
        vm.form.$setUntouched();
      }
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpZuantFieldsList', {
      templateUrl: 'app/integration/field-mappings-page/left-sidebar/zp-zuant-fields-list/tmpl.html',
      controller: 'zuantFieldsListCtrl',
      bindings: {
        items: '<',
        collection: '<',
        icon: '<'
      }
    })
    .controller('zuantFieldsListCtrl', controller);

  controller.$inject = ['MachineMappingsViewModel'];
  /* ng-inject */
  function controller(MachineMappingsViewModel) {

    var vm = this;

    vm.$onInit = function () {
      vm.viewModel = MachineMappingsViewModel.viewModel;
      vm.showNewFieldForm = false;
      vm.newField = {
        dbname: '',
        object: vm.collection
      };
      vm.showList = true;  
      vm.newFieldIcon = 'add';
      vm.changeDelta = MachineMappingsViewModel.changeDelta;
    };

    vm.toggleShowNewFieldForm = function () {
      vm.newFieldIcon = vm.showNewFieldForm ? 'add' : 'edit';
      vm.showNewFieldForm = !vm.showNewFieldForm;
      vm.resetNewField();
    };

    vm.submitAddFieldForm = function () {
      MachineMappingsViewModel.addNewZuantField(vm.newField);
      vm.resetNewField();
    };

    vm.resetNewField = function () {
      vm.newField.dbname = '';
      vm.newField.object = vm.collection;
    };


  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpMappingScreenSidebar', {
      templateUrl: 'app/integration/field-mappings-page/left-sidebar/zp-sidebar/tmpl.html',
      controller: 'MappingScreenSidebarCtrl',
      bindings: {
        currentMachine: '<',
        viewModel: '<'
      }
    })
    .controller('MappingScreenSidebarCtrl', controller);

  controller.$inject = ['MachineMappingsViewModel'];
  /* ng-inject */
  function controller(MachineMappingsViewModel) {

    var vm = this;

    vm.$onInit = function () {
      vm.viewModel = MachineMappingsViewModel.viewModel;
      vm.copyOfMachine = angular.copy(vm.currentMachine);
      vm.changeDelta = MachineMappingsViewModel.changeDelta;
      vm.thirdPartySystemName = userFriendlyThirdPartyName(vm.currentMachine.actuator.system);
      vm.trash = [];
    };

    function userFriendlyThirdPartyName(systemName) {
      if (systemName === 'SFDC') return 'Salesforce';
      if (systemName === 'Eloqua') return 'Eloqua';
      if (systemName === 'HttpPost') return 'http post';
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpEloquaLoginForm', {
      templateUrl: 'app/integration/dialogs/manage-logins-dialog/eloqua/tmpl.html',
      controller: 'EloquaLoginFormCtrl',
      bindings: {
        formname: '=',
        loginCredentials: '<',
        errorMessage: '<',
        connectionStatusMessage: '<',
        connectionErrorMessage: '<'
      }
    })
    .controller('EloquaLoginFormCtrl', controller);

  controller.$inject = ['ZuantAccountManagersFactory', '$filter'];
  /* ng-inject */
  function controller(ZuantAccountManagersFactory, $filter) {

    var vm = this;

    vm.$onInit = function () {};
    vm.passwordFieldTypeIsPassword = true;
    vm.userIsAZam = ZuantAccountManagersFactory.loggedInUserIsAZam();

    vm.zuantToEloquaSVG = $filter('cdnAssets')('/images/svgs/placeholders/integration/zuant_to_eloqua.svg');
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpSfdcLoginForm', {
      templateUrl: 'app/integration/dialogs/manage-logins-dialog/sfdc/tmpl.html',
      controller: 'SfdcLoginFormCtrl',
      bindings: {
        formname: '=',
        loginCredentials: '<',
        errorMessage: '<',
        connectionStatusMessage: '<',
        connectionErrorMessage: '<'
      }
    })
    .controller('SfdcLoginFormCtrl', controller);

  controller.$inject = ['ZuantAccountManagersFactory', '$filter'];
  /* ng-inject */
  function controller(ZuantAccountManagersFactory, $filter) {

    var vm = this;

    vm.$onInit = function () {
      vm.svg = {
        width: '100%',
        height: '100%'
      };
      vm.passwordFieldTypeIsPassword = true;
      vm.userIsAZam = ZuantAccountManagersFactory.loggedInUserIsAZam();

      vm.zuantToSfdcSVG = $filter('cdnAssets')('/images/svgs/placeholders/integration/zuant_to_sfdc2.svg');
    };
  }
}());


angular
  .module('forms')
  .controller('CameraModesCtrl', CameraModesCtrl);

CameraModesCtrl.$inject = ['MessageService', 'locals'];
/* ng-inject */
function CameraModesCtrl(MessageService, locals) {

  var vm = this;

  vm.cameraModes = _.clone(locals);
  vm.done = function () {
    MessageService.closeDialog(vm.cameraModes);
  };

  vm.cancel = function () {
    MessageService.cancelDialog();
  };

}

/**
* Provides app wide lists functionality for use in the Zuant app
* @module lists
*/

(function() {
  'use strict';

  angular
    .module('lists', ['ui.router', 'common', 'zp.api', 'zp.message']);
})();

/**
 * Created by davidbeazer on 14/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('lists')
    .factory('ShowroomBlocksFactory', ShowroomBlocksFactory);

  ShowroomBlocksFactory.$inject = ['$q', 'ListApiFactory'];

  function ShowroomBlocksFactory($q, ListApiFactory) {

    var factoryData = {
      cacheValid: false,
      items: []
    };

    return {
      getShowroomBlocks: getShowroomBlocks,
      getData: getData,
      invalidateCache: invalidateCache
    };

    function getShowroomBlocks() {
      return $q(function q(resolve, reject) {
        if (factoryData.cacheValid) {
          resolve(factoryData);
        } else {
          return ListApiFactory.getArtefactsByQuery({
            artefactType: 'Block',
            _deletedatelocalutc: {
              $exists: false
            }
          }, {
            _id: 1,
            nameplate: 1,
            _lastmodifiedonservertime: 1,
            _lastmodifieddatelocalutc: 1
          })
            .then(function (res) {
              factoryData.items = res.data.data;
              factoryData.cacheValid = true;
              resolve(factoryData);
            })
            .catch(function (err) {
              reject(err);
            });
        }
      });
    }

    function getData() {
      return factoryData;
    }

    function invalidateCache() {
      factoryData.cacheValid = false;
    }

  }

})();

angular
  .module('forms')
  .controller('EntryBlockDialogCtrl', EntryBlockDialogCtrl);

EntryBlockDialogCtrl.$inject = ['MessageService', 'entryBlock', 'ShowroomBlocksFactory'];
/* ng-inject */
function EntryBlockDialogCtrl(MessageService, entryBlock, ShowroomBlocksFactory) {

  var vm = this;
  vm.loading = true;
  vm.selectedEntryBlock = entryBlock;

  ShowroomBlocksFactory.getShowroomBlocks()
    .then(function (res) {
      vm.blocks = res.items;
      vm.loading = false;
    });

  vm.setEntryBlock = function (block) {
    vm.selectedEntryBlock = block._id;
  };

  vm.done = function () {
    MessageService.closeDialog(vm.selectedEntryBlock);
  };

  vm.cancel = function () {
    MessageService.cancelDialog();
  };

}


angular
  .module('forms')
  .controller('ScanLookupProvidersCtrl', ScanLookupProvidersCtrl);

ScanLookupProvidersCtrl.$inject = ['MessageService', 'locals'];
/* ng-inject */
function ScanLookupProvidersCtrl(MessageService, locals) {

  var vm = this;
  vm.scanSettings = _.clone(locals);

  vm.done = function () {
    MessageService.closeDialog(vm.scanSettings);
  };

  vm.cancel = function () {
    MessageService.cancelDialog();
  };

}


angular
  .module('forms')
  .controller('ScanAutoSubmitDialogCtrl', ScanAutoSubmitDialogCtrl);

ScanAutoSubmitDialogCtrl.$inject = ['MessageService', 'locals'];
/* ng-inject */
function ScanAutoSubmitDialogCtrl(MessageService, locals) {

  var vm = this;
  vm.scanAutoSubmitSettings = _.clone(locals);
  
  vm.done = function () {
    MessageService.closeDialog(vm.scanAutoSubmitSettings);
  };

  vm.cancel = function () {
    MessageService.cancelDialog();
  };

}

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('PostShowEmailFactory', Factory);

  Factory.$inject = ['GridAPI', 'EmailAPI', 'SingleFormFactory', 'MessageService', 'ClientsAPI', 'SessionService', 'LeadDataFactory', '$timeout', '$interval', 'APIService', 'EncodingService'];
  /** @ngInject */
  function Factory(GridAPI, EmailAPI, SingleFormFactory, MessageService, ClientsAPI, SessionService, LeadDataFactory, $timeout, $interval, api, encoder) {

    var factoryData = {
      loadingText: ''
    };

    return {
      send: send,
      aggregateEmailsSentForForm: aggregateEmailsSentForForm,
      simulateEmailSend: simulateEmailSend,
      getBatchValues: getBatchValues,
      pollForAtomicResponse: pollForAtomicResponse,
      factoryData: factoryData
    };

    function send(param) {

      MessageService.writeLog({
        level: 'info',
        msg: 'Saving ' + param.emailTemplateId + ' email template to form: ' + param.formId,
        tags: ['email_template', 'post_show_email_send']
      });
      MessageService.pushEventToIntercom('post_show_email_send', {
        triggeredForForm: param.formId
      });

      factoryData.jobProcessing = true;
      factoryData.broadcast = undefined;

      return SingleFormFactory.saveForm({
        _id: param.formId,
        emailTemplate: param.emailTemplateId
      })
        .then(function (res) {
          MessageService.writeLog({
            level: 'info',
            msg: res,
            tags: ['post_show_email_send', 'update_template']
          });
          return EmailAPI.triggerAtomicEmailSend(param);
        })
        .then(function (res) {
          LeadDataFactory.invalidateFactoryCache();
          return res.data.response;
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: err,
            tags: ['post_show_email_send']
          });
        });
    }

    function aggregateEmailsSentForForm(_formid) {

      return GridAPI.aggregateEmailsSentBySingleForm({
        match: {
          _formid: _formid
        }
      })
        .then(function (res) {
          return {
            templatesSent: res
          };
        })
        .catch(function (err) {
          throw err;
        });
    }

    function simulateEmailSend(_formId, templateId, batch, props) {
      if (!_formId || !templateId) Promise.reject('err!');
      return ClientsAPI.getConsentModel(SessionService.getUserData().clientId)
        .then(function (res) {
          const waiveGDPRCompliance = props.waiveGDPRCompliance;
          return GridAPI.aggregateMatchedPotentialRecipients({
            match: {
              _formid: _formId,
              emailTemplateId: templateId,
              emailConsentMechanism: workoutEmailConsentMechanism(res, waiveGDPRCompliance),
              batch: batch
            }
          });
        })
        .then(function (res) {
          return res;
        })
        .catch(function (err) {
          throw err;
        });
    }

    function workoutEmailConsentMechanism(clientDoc, waiveGDPRCompliance) {
      if (clientDoc.GDPR && clientDoc.GDPR.enabled && waiveGDPRCompliance !== 1) {
        return {
          arrayOfEmailConsentTokens: buildArrayOfEmailConsentTokens(clientDoc.consentModel)
        };
      } else {
        return {
          checkContactMethodsForEmail: true
        };
      }

    }

    function buildArrayOfEmailConsentTokens(consentModel) {
      var tokensToTarget = _.filter(consentModel, function (token) {
        return token.symbols.indexOf('Send Email') > -1;
      });
      return _.map(tokensToTarget, 'token');
    }

    function getBatchValues(params) {
      return GridAPI.getBatchValues(params)
        .then(function (res) {
          return res;
        })
        .catch(function (err) {
          throw err;
        });
    }

    function pollForAtomicResponse(atomicJobId) {
      return new Promise(function (resolve, reject) {
        var intervalReference;
        var intervalVal = 2000;
        var idx = 0;
        var dots = ['.', '..', '...'];
        intervalReference = $interval(function () {
          factoryData.loadingText = 'Batch Send Processing ' + dots[idx % 3];
          ++idx;
          api.get('broadcasts/' + encoder.encode(atomicJobId))
            .then(function (res) {
              $interval.cancel(intervalReference);
              factoryData.broadcast = res.data.data.broadcast;
              factoryData.jobProcessing = false;
              MessageService.writeLog({
                level: 'info',
                msg: res.data.data.broadcast.message,
                tags: ['post_show_email_send', 'atomic_success']
              });
              resolve(res.data.data.broadcast);
            })
            .catch(function () {
              if (idx === 40) {
                $interval.cancel(intervalReference);
                factoryData.loadingText = '';
                factoryData.jobProcessing = false;
                return reject({ message: 'Batch results not found after ' + idx + ' attempts. Check past activity tab.' });
              }
            });
        }, intervalVal);

      });
    }

  }

}());

'use strict';

angular
  .module('forms')
  .controller('PostShowEmailSendDialogCtrl', PostShowEmailSendDialogCtrl);

PostShowEmailSendDialogCtrl.$inject = ['MessageService', 'locals', 'SingleFormFactory', 'PostShowEmailFactory', 'SessionService', 'localStorageService', '$timeout'];
/** @ngInject */
function PostShowEmailSendDialogCtrl(MessageService, locals, SingleFormFactory, PostShowEmailFactory, SessionService, localStorage, $timeout) {

  var vm = this;

  vm.tabInView = 'changeTemplate';
  vm.hideBlurb = localStorage.get('hidePSESblurb') || false;
  vm.showDoneBtn = false;
  vm.batchValue = '';
  vm.emailTemplate = locals.emailTemplate;
  vm.emailTemplateTitle = locals.emailTemplateTitle;
  vm.formId = locals.formId;
  vm.waiveGDPRCompliance = locals.waiveGDPRCompliance;
  vm.qualifiedRecipientsLength = 0;
  vm.showPrevSendsInfo = true;
  vm.showEmailBatchField = false;
  vm.emailSendFactoryData = PostShowEmailFactory.factoryData;
  vm.jobProcessing = PostShowEmailFactory.factoryData.jobProcessing;
  vm.menuOptions = [{
    onClick: 'sendEmailBatch',
    ariaLabel: function () {
      return 'Send email batch';
    },
    icon: function () {
      return 'zmdi zmdi-layers';
    },
    label: function () {
      return 'Send email batch';
    }
  }];

  const clientId = SessionService.getUserData().clientId;

  vm.$onInit = function () {
    aggregateEmailSendForThisForm();
    vm.simulateEmailSend();
  };

  vm.onMenuClick = function (params) {
    if (params.action === 'sendEmailBatch') {
      vm.showEmailBatchField = !vm.showEmailBatchField;
      if (!vm.showEmailBatchField) return;
      PostShowEmailFactory.getBatchValues({
        _formid: vm.formId
      })
        .then(function (res) {
          vm.batchSendValues = res;
          vm.showNoBatchValuesWarningMessage = (res.length == 0);
          MessageService.writeLog({
            level: 'info',
            msg: res,
            tags: ['batch_send_values']
          });
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: err,
            tags: ['batch_send']
          });
        });
    }
  };

  vm.send = function () {
    vm.sending = true;
    vm.disableSendButton = true;
    vm.showSendBtn = false;
    vm.showSendPreviewCounts = false;

    MessageService.writeLog({
      level: 'info',
      msg: 'about to send post show email for formId ' + vm.formId + ', clientId: ' + clientId + ' emailTemplate ' + vm.emailTemplate,
      tags: ['post_show_email_send']
    });

    PostShowEmailFactory.send({
      clientId: clientId,
      formId: vm.formId,
      emailTemplateId: vm.emailTemplate,
      batch: vm.batchValue ? vm.batchValue.trim() : undefined
    })
      .then(function (res) {
        return PostShowEmailFactory.pollForAtomicResponse(res.atomicJobId);
      })
      .then(function (res) {
        vm.psesResponse = res;
        vm.disableSendButton = false;
        vm.showDoneBtn = true;
        vm.sending = false;
        sendCountIntegrityCheck(res.recipients);
        MessageService.showMessage('📧 ' + res.message);
        $timeout(function () { // wrapped in a timeout to give db time to update before aggregating sends again (previously sent list updates after this runs)
          aggregateEmailSendForThisForm();
        }, 1500);
      })
      .catch(function (err) {
        vm.response = err;
        MessageService.showMessage(err.message);
        MessageService.writeLog({
          level: 'error',
          msg: err,
          tags: ['post_show_email_send', 'atomic_error']
        });
      });

    vm.sent = true;
  };

  function sendCountIntegrityCheck(recipients) {
    if (recipients.length && recipients.length != vm.countOfContactsThatWillReceiveEmail) {
      vm.invalidEmails = _.difference(_.map(vm.countOfContactsThatWillReceiveEmail, 'email'), recipients);
      MessageService.writeLog({
        level: 'info',
        msg: 'recipients length (' + recipients.length + ') != preview recipients length (' + vm.countOfContactsThatWillReceiveEmail.length + ') the following peeps did not get sent an email: ' + JSON.stringify(vm.invalidEmails),
        tags: ['post_show_email_send']
      });
    }
  }

  vm.emailTemplateConfig = {
    placeholder: 'Pick an email template for this form',
    floatingLabel: 'Email template title',
    label: 'Pick an email template for this form'
  };

  vm.updateSelectControl = function (params) {
    vm.psesResponse = undefined;
    PostShowEmailFactory.factoryData.broadcast = undefined;
    const selected = params.item || { title: '', _id: null };

    if (selected._id === vm.emailTemplate || !selected._id && vm.emailTemplate === '') return;

    vm.emailTemplate = selected._id || '';
    vm.emailTemplateTitle = selected.title;

    if (selected._id) {
      vm.showSendPreviewCounts = true;
      vm.simulateEmailSend();
    }

    return SingleFormFactory.saveForm(vm.formId, { emailTemplate: vm.emailTemplate }).then(function (){
      vm.showDoneBtn = true;
    });

  };

  vm.cancelDialog = function () {
    MessageService.closeDialog({
      id: vm.emailTemplate,
      title: vm.emailTemplateTitle
    });
  };

  vm.setHideBlurb = function () {
    vm.hideBlurb = true;
    localStorage.set('hidePSESblurb', true);
  };

  vm.openMenu = function (func, ev) {
    func(ev);
  };

  vm.simulateEmailSend = function () {

    vm.showSendPreviewCounts = true;
    vm.simulating = true;
    vm.countOfContactsThatWillReceiveEmail = 0;
    vm.countOfContactsAlreadyReceivedThisTemplate = 0;
    vm.countOfContactsWithoutEmailConsentToken = 0;
    vm.response = null;
    vm.showSendBtn = true;

    PostShowEmailFactory.simulateEmailSend(vm.formId, vm.emailTemplate, vm.batchValue.trim(), { waiveGDPRCompliance: vm.waiveGDPRCompliance })
      .then(function (res) {
        vm.countOfContactsThatWillReceiveEmail = res.countOfContactsThatWillReceiveEmail;
        vm.countOfContactsAlreadyReceivedThisTemplate = res.countOfContactsAlreadyReceivedThisTemplate;
        vm.countOfContactsWithoutEmailConsentToken = res.countOfContactsWithoutEmailConsentToken;
        vm.disableSendButton = vm.countOfContactsThatWillReceiveEmail.length == 0;
        vm.simulating = false;
        checkFactoryForProcessedJob();
        MessageService.writeLog({
          level: 'info',
          msg: res,
          tags: ['post_show_email_send']
        });
      })
      .catch(function (err) {
        vm.simulating = false;
        MessageService.showMessage(err);
        MessageService.writeLog({
          level: 'error',
          msg: err,
          tags: ['post_show_email_send', 'simulate_email_send']
        });
      });
  };

  function checkFactoryForProcessedJob() {
    if (PostShowEmailFactory.factoryData.broadcast) {
      vm.psesResponse = PostShowEmailFactory.factoryData.broadcast;
      sendCountIntegrityCheck(vm.psesResponse.recipients);
    }
  }

  function aggregateEmailSendForThisForm() {
    MessageService.writeLog({
      level: 'info',
      msg: 'aggregating emails sent for formId ' + vm.formId,
      tags: ['post_show_email_send']
    });
    const timestart = moment();
    PostShowEmailFactory.aggregateEmailsSentForForm(vm.formId)
      .then(function (res) {
        const timeend = moment();
        const duration = timeend.diff(timestart);
        MessageService.writeLog({
          level: 'info',
          msg: 'aggregation complete. it took ' + duration + ' milliseconds to complete',
          tags: ['post_show_email_send']
        });
        vm.templatesSentInfo = res;
        vm.initialised = true;
      })
      .catch(function (err) {
        vm.aggregationErr = err;
      });
  }
}


angular
  .module('forms')
  .controller('FormSettingsHelpDialogCtrl', FormSettingsHelpDialogCtrl);

FormSettingsHelpDialogCtrl.$inject = ['MessageService', 'locals', 'FormPropertyHelpersFactory'];
/* ng-inject */
function FormSettingsHelpDialogCtrl(MessageService, locals, FormPropertyHelpersFactory) {

  var vm = this;
  vm.topic = locals.topic; // the topic user needs help on
  vm.formPropertyHelpers = FormPropertyHelpersFactory;
  
  vm.done = function () {
    MessageService.closeDialog();
  };

  vm.cancel = function () {
    MessageService.cancelDialog();
  };

}

angular
  .module('forms')
  .controller('FormContactFiltersDialogCtrl', FormContactFiltersDialogCtrl);

FormContactFiltersDialogCtrl.$inject = ['MessageService', 'locals', 'FormsFactory'];
/* ng-inject */
function FormContactFiltersDialogCtrl(MessageService, locals, FormsFactory) {

  var vm = this;
  vm.selectedFilterSetting = 'no_filters';
  vm.selectedFormIds = [];

  vm.$onInit = function (){
    vm.selectedFormIds = locals.contactFilterForms;

    const currentFormId = locals.formId;
    if (vm.selectedFormIds.indexOf(currentFormId) === -1){
      vm.selectedFormIds.unshift(currentFormId);
      vm.selectedFilterSetting = 'no_filters';
    } else if (vm.selectedFormIds.length === 1) {
      vm.selectedFilterSetting = 'current_form_only';
    } else {
      vm.selectedFilterSetting = 'current_and_additional_forms';
    }

    FormsFactory.getAllForms()
      .then(function (resp){
        vm.forms = _.chain(resp.items)
          .map(function (obj) {
            const id = obj.form._id;
            return {
              _id: id,
              title: obj.form.formname.raw,
              responseCount: obj.form.responsecount.raw,
              startdate: obj.form.startdate.raw,
              enddate: obj.form.enddate.raw,
              disabled: id === currentFormId ? true : false,
              isSelected: vm.selectedFormIds.indexOf(id) > -1 ? 1 : 0
            };
          })
          .sortBy(function (form) {
            return form.title.toLowerCase();
          })
          .sortBy(function (form) {
            return -form.isSelected;
          })
          .value();
      });
  };

  vm.selectedFilterSettingChanged = function (value) {
    if (value) vm.selectedFilterSetting = value;
    if (vm.selectedFilterSetting === 'current_and_additional_forms') return;
    const currentFormId = locals.formId;
    vm.forms = _.map(vm.forms, function (form){
      if (form._id !== currentFormId) form.isSelected = false;
      return form;
    });
  };

  vm.done = function () {

    vm.selectedFormIds = _.chain(vm.forms)
      .filter(function (form){
        if (!form.isSelected) return false;
        return true;
      })
      .map(function (form){
        return form._id;
      })
      .value();

    if (vm.selectedFilterSetting === 'no_filters'){
      vm.selectedFormIds = [];
    }

    MessageService.closeDialog(vm.selectedFormIds);
  };

  vm.cancel = function () {
    MessageService.cancelDialog();
  };

}


angular
  .module('forms')
  .controller('DataLoadContactFiltersDialogCtrl', DataLoadContactFiltersDialogCtrl);

DataLoadContactFiltersDialogCtrl.$inject = ['MessageService', 'locals', 'DataLoadsFactory'];
/* ng-inject */
function DataLoadContactFiltersDialogCtrl(MessageService, locals, DataLoadsFactory) {

  var vm = this;
  vm.dataLoads = [];
  vm.selectedDataloadIds = [];

  vm.$onInit = function (){
    
    vm.selectedDataloadIds = locals.contactFilterDataLoads;

    DataLoadsFactory.getDataLoads()
      .then(function (resp){
        vm.dataLoads = _.chain(resp.items)
          .map(function (obj) {
            const id = obj.dataload._id;
            return {
              _id: id,
              fileName: obj.dataload.fileName,
              createdOn: obj.dataload.createdOn,
              completedOn: obj.dataload.completedOn,
              zubotName: obj.dataload.zubotName,
              totalContacts: obj.dataload.totalContacts,
              isSelected: vm.selectedDataloadIds.indexOf(id) > -1 ? 1 : 0
            };
          })
          .sortBy(function (dataload) {
            return dataload.fileName.toLowerCase();
          })
          .sortBy(function (dataload) {
            return -dataload.isSelected;
          })
          .value();
      });
  };

  vm.done = function () {
    vm.selectedDataloadIds = _.chain(vm.dataLoads)
      .filter(function (load){
        if (!load.isSelected) return false;
        return true;
      })
      .map(function (load){
        return load._id;
      })
      .value();

    MessageService.closeDialog(vm.selectedDataloadIds);
  };

  vm.cancel = function () {
    MessageService.cancelDialog();
  };

}

angular
  .module('forms')
  .controller('BarcodeFieldsDialogCtrl', BarcodeFieldsDialogCtrl);

BarcodeFieldsDialogCtrl.$inject = ['MessageService', 'locals'];
/* ng-inject */
function BarcodeFieldsDialogCtrl(MessageService, locals) {

  var vm = this;

  vm.editingList = false;

  vm.presetConfig = {
    sort: false,
    group: {
      name: 'presets',
      pull: 'clone',
      put: ['mappings']
    }
  };

  vm.mappingsConfig = {
    sort: true,
    group: {
      name: 'mappings',
      put: ['presets'],
      pull: ['presets']
    }
  };

  // vm.mappingsConfig2 = {
  //   sort: true,
  //   group: {
  //     name: 'mappings2',
  //     put: ['presets', 'mappings'],
  //     pull: 'true'
  //   },
  //   onRemove: function () {
  //     $log.info('item onRemove mappings2');
  //   }
  // };

  vm.barcodePresetFields = [{
    dbElementName: 'ignore field placeholder',
    dbObjectName: 'ignore this',
    count: 0
  }, {
    dbElementName: 'barcode',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'salutation',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'firstname',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'lastname',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'name',
    dbObjectName: 'company',
    count: 0
  }, {
    dbElementName: 'jobtitle',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'mobile',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'phone',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'email',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'address1',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'address2',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'address3',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'city',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'state',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'country',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'zipcode',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'contactmethods',
    dbObjectName: 'contact',
    count: 0
  }, {
    dbElementName: 'Follow-up Required?',
    dbObjectName: 'response',
    count: 0
  }, {
    dbElementName: 'bureaustatus',
    dbObjectName: 'response',
    count: 0
  }];

  vm.barcodeFieldMappings = processExistingMappings(locals.barcodeMappings);

  function processExistingMappings(existingMappings) {
    _.each(existingMappings, function (mapping) {
      _.each(vm.barcodePresetFields, function (preset) {
        if (mapping.dbElementName == preset.dbElementName && mapping.dbObjectName == preset.dbObjectName) preset.count++;
      });
    });
    return existingMappings;
  }

  vm.removeMapping = function (item, i) {
    vm.barcodeFieldMappings.splice(i, 1);
    var presetItem = _.find(vm.barcodePresetFields, function (preset) {
      return preset.dbElementName == item.dbElementName && preset.dbObjectName == item.dbObjectName;
    });
    presetItem.count--;
  };

  vm.addFieldToMappings = function (item) {
    item.count++;
    vm.barcodeFieldMappings.push(item);
  };

  vm.done = function () {
    MessageService.closeDialog(vm.barcodeFieldMappings);
  };

  vm.cancel = function () {
    MessageService.cancelDialog();
  };

}


angular
  .module('forms')
  .controller('AdvancedScannerSettingsDialogCtrl', AdvancedScannerSettingsDialogCtrl);

AdvancedScannerSettingsDialogCtrl.$inject = ['MessageService', 'locals'];
/* ng-inject */
function AdvancedScannerSettingsDialogCtrl(MessageService, locals) {

  var vm = this;

  vm.advancedScannerSettings = _.clone(locals);
  vm.done = function () {
    MessageService.closeDialog(vm.advancedScannerSettings);
  };

  vm.cancel = function () {
    MessageService.cancelDialog();
  };

}

(function () {
  'use strict';

  angular
    .module('forms')
    .component('formSettingsTeamTreeElement', {
      templateUrl: 'app/forms/settings-page/cards/team-tree-element/view.tmpl.html',
      controller: 'FormSettingsTeamsTreeElementCtrl',
      bindings: {
        teams: '<',
        selectTeam: '&',
        toggleChevron: '&',
        parent: '<',
        level: '<',
        indexesToMiss: '<',
        parentSelected: '<'
      },
      controllerAs: 'vm'
    })
    .controller('FormSettingsTeamsTreeElementCtrl', ctrl);

  ctrl.$inject = [];
  /* ng-inject */
  function ctrl() {

    var vm = this;

    vm.myLevel = 0;
    vm.loopArray = [];
    vm.chevronMargin = 0;
    vm.indexesToMissArr = [];

    vm.$onInit = () => {
      vm.myLevel = parseInt(vm.level, 10) + 1;
      vm.chevronMargin = (parseInt(vm.level, 10) * 24) + 'px';
      vm.loopArray = new Array(vm.level);
      vm.indexesToMissArr = vm.indexesToMiss ? vm.indexesToMiss.split(',') : [];
    };

    vm.calculateMargin = index => {
      return (parseInt(index + 1, 10) * 24) + 'px';
    };

    vm.calculateMaxWidth = index => {
      return 'calc(100% - ' + (parseInt(index + 1, 10) * 24) + 'px)';
    };

    vm.subTeamShouldShow = subteams => {
      subteams = subteams || [];
      var shouldShow = false;

      for (const subteam of subteams) {
        shouldShow = subteam.shouldShow || vm.subTeamShouldShow(subteam.treeSubteams);
        if (shouldShow) {
          break;
        }
      }
      return shouldShow;
    };

    vm.calculateIndexesToMiss = (last, index) => {
      let subIndexesToMiss = [];
      subIndexesToMiss.push.apply(subIndexesToMiss, vm.indexesToMissArr);
      if (last) {
        subIndexesToMiss.push(index);
      }
      return subIndexesToMiss.toString();
    };

    vm.shouldVerticalLineShow = (index) => {
      return vm.level > 0 && vm.indexesToMissArr.indexOf((index + 2).toString()) === -1;
    };

    vm.isSubChildSelected = (teams) => {
      let selected = false;
      if (teams) {
        for (const team of teams) {
          if (team.selected) {
            selected = true;
          } else {
            selected = vm.isSubChildSelected(team.treeSubteams);
          }

          if (selected) {
            break;
          }
        }
      }
      return selected;
    };

    vm.isChildSelected = (team) => {
      if (team.selected || vm.parentSelected) {
        return false;
      } else {
        return vm.isSubChildSelected(team.treeSubteams);
      }
    };

    return vm;
  }

})();

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpTimeReportWidget', {
      controller: 'zpTimeReportWidgetCtrl',
      templateUrl: 'app/forms/reporting/time-reports/time-report-widget/zp-time-report-widget.tmpl.html',
      bindings: {
        widgetData: '<',
        formId: '<'
      }
    })
    .controller('zpTimeReportWidgetCtrl', zpTimeReportWidgetCtrl);

  zpTimeReportWidgetCtrl.$inject = ['ResponseAggregationModel', '$state'];
  /* ng-inject */
  function zpTimeReportWidgetCtrl(ResponseAggregationModel, state) {

    var vm = this;

    vm.$onInit = function () {
      ResponseAggregationModel.bindWidgetToFactory(vm.widgetData);
    };

    vm.goTo = function () {
      state.go('app.single_view_framework.forms_reporting_dashboard', { navigationArray: 'widgetsArray', _id: vm.formId, columnid: vm.widgetData.id, chartcolumnid: null, chartdatasetid: null });
    };

    vm.chartClicked = function(chartEl){
      state.go('app.single_view_framework.forms_reporting_dashboard', { navigationArray: 'widgetsArray', _id: vm.formId, columnid: vm.widgetData.id, chartcolumnid: chartEl._index, chartdatasetid: chartEl._datasetIndex });
    };

    vm.changeChartType = function (ev, type) {
      vm.widgetData.chart.type = type;
    };
    
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpWidgetContextMenu', {
      templateUrl: 'app/forms/reporting/column-summary-widget-component/widget-context-menu-component/zp-widget-context-menu.tmpl.html',
      bindings: {
        menuItemClicked: '&',
        menuOptions: '<',
        selectedItem: '<'
      },
      controller: 'zpWidgetContextMenuCtrl'
    })
    .controller('zpWidgetContextMenuCtrl', zpWidgetContextMenuCtrl);

  zpWidgetContextMenuCtrl.$inject = [];
  /* ng-inject */
  function zpWidgetContextMenuCtrl() {

    var vm = this;
    vm.openMenu = function (func, ev) {
      func(ev);
    };

  }
})();

(function () {
  'use strict';
  
  angular
    .module('forms')
    .factory('AggregationBuilderHelperFactory', factory);
  
  factory.$inject = ['CurrencyHelperService'];
  
  function factory(CurrencyHelperService) {
  
    var factoryData;
  
    return {
      sliceAndDiceRelevantPresetAndBuildWorkingObject: sliceAndDiceRelevantPresetAndBuildWorkingObject,
      sliceAndDiceRelevantPresetAndBuildWorkingRevenueObject: sliceAndDiceRelevantPresetAndBuildWorkingRevenueObject,
      findEnumerationKey: findEnumerationKey,
      buildSeriesChartData: buildSeriesChartData,
      buildSingleSeriesChartData: buildSingleSeriesChartData
    };


    function sliceAndDiceRelevantPresetAndBuildWorkingObject(factoryDataParam, metric, enumerationKey) {
      factoryData = factoryDataParam;
      return _.reduce(factoryData[enumerationKey], function (rollingObject, obj, presetKey) {
        var resolvedKey = findResolvedKey(metric, presetKey);
        if (!rollingObject[resolvedKey]) {
          rollingObject[resolvedKey] = {
            caption: resolvedKey,
            count: 0,
            arrayOfResponseIds: []
          };
        }
        if (typeof obj.count === 'number') {
          rollingObject[resolvedKey].count += obj.count;
        }
        if (obj.arrayOfResponseIds) {
          rollingObject[resolvedKey].arrayOfResponseIds = rollingObject[resolvedKey].arrayOfResponseIds.concat(obj.arrayOfResponseIds);
        }
        return rollingObject;
      }, {});
    }

    function sliceAndDiceRelevantPresetAndBuildWorkingRevenueObject(factoryDataParam, metric, enumerationKey) {
      factoryData = factoryDataParam;
      return _.reduce(factoryData[enumerationKey], function (rollingObject, obj, presetKey) {
        const resolvedKey = findResolvedKey(metric, presetKey);
        
        if (!rollingObject[resolvedKey]) {
          rollingObject[resolvedKey] = {
            caption: resolvedKey,
            count: 0,
            arrayOfResponseIds: []
          };
        }
        if (factoryData.estimatedRevenue && !_.isEqual(factoryData.estimatedRevenue, {})){
          const revenue = pluckRevenueFromResponseID(factoryData, obj.arrayOfResponseIds);
          if (typeof obj.count === 'number') {
            rollingObject[resolvedKey].count += revenue;
          }
          if (obj.arrayOfResponseIds) {
            rollingObject[resolvedKey].arrayOfResponseIds = rollingObject[resolvedKey].arrayOfResponseIds.concat(obj.arrayOfResponseIds);
          }
          return rollingObject;
        } else {
          return {};
        }

      }, {});
    }

    function pluckRevenueFromResponseID(factoryData, responseIDs) {
      var totalRevenue = 0;
      const keys = Object.keys(factoryData.estimatedRevenue);
      for (const key of keys){
        for (const responseID of factoryData.estimatedRevenue[key].arrayOfResponseIds){
          if (responseIDs.indexOf(responseID) > -1){
            const numericValue = CurrencyHelperService.convertStringToNumber(key);
            if (numericValue){
              totalRevenue += numericValue;
            } else {
              totalRevenue += 0;
            }
          }
        }
      }

      return totalRevenue;
    }
  
    function findEnumerationKey(metric) {

      var enumerationKey = 'mmddyy_user'; // default
  
      if (metric.groupBy == 'mmddyyhh') enumerationKey = 'mmddyyhh';
      if (metric.groupBy == '_formid') enumerationKey = '_formid';
      if (metric.groupBy == '_literature') enumerationKey = '_literature';
      if (metric.groupBy == '_initialcreatedate') enumerationKey = '_initialcreatedate';
      if (metric.groupBy == 'mmddyy_event') enumerationKey = 'emailEventsGroupedByDay';
      if (metric.groupBy == 'mmddyy_template') enumerationKey = 'mmddyy_template';
      if (metric.groupBy == 'eventName') enumerationKey = 'emailEventsGroupedByEvent';
      if (metric.groupBy == 'mmddyy_email_sends') enumerationKey = 'mmddyy_email_sends';
      if (metric.groupBy == 'emailSendsForForm') enumerationKey = 'mmddyy_template';
      if (metric.groupBy == 'template_event') enumerationKey = 'template_event';
      if (metric.groupBy == 'estimatedRevenue') enumerationKey = 'estimatedRevenue';
  
      return enumerationKey;
    }
  
    function findResolvedKey(metric, presetkey) {
      // don't understand
      var resolvedkey;
      if (metric.groupBy == 'mmddyy_user') {
        resolvedkey = presetkey;
      } else if (metric.groupBy == 'mmddyyhh' ||
          metric.groupBy == '_formid' ||
          metric.groupBy == '_literature' ||
          metric.groupBy == '_initialcreatedate' ||
          metric.groupBy == 'mmddyy_event' ||
          metric.groupBy == 'mmddyy_email_sends' ||
          metric.groupBy == 'emailSendsForForm' ||
          metric.groupBy == 'template_event' ||
          metric.groupBy == 'eventName' ||
          metric.groupBy == 'estimatedRevenue') {
        resolvedkey = presetkey;
      } else if (metric.groupBy == 'mmddyy' || metric.groupBy == 'mmddyy_event') {
        resolvedkey = presetkey.substring(0, 8);
      } else if (metric.groupBy == 'user') {
        resolvedkey = presetkey.substring(9, presetkey.length);
      } else if (metric.groupBy == 'mmddyy_template') {
        resolvedkey = presetkey;
      }
      return resolvedkey;
    }
  }

  function buildSingleSeriesChartData(arr, metric) {
    // no outerarray, data is in single array
    var returnObject = {};
    returnObject.data = _.map(arr, function (item) {
      return item.members.count;
    });
    returnObject.labels = _.map(arr, 'primaryLabel');
    returnObject.linkedResponseIds = _.map(arr, function (item) {
      return item.members.arrayOfResponseIds;
    });
    if (metric.limit) {
      returnObject.data = trimArrayToLength(returnObject.data, metric);
      returnObject.labels = trimArrayToLength(returnObject.labels, metric, returnObject.data.length);
      returnObject.linkedResponseIds = trimArrayToLength(returnObject.linkedResponseIds, metric, returnObject.data.length);
    }
    return returnObject;
  }
  
  function trimArrayToLength(arrayToTrim, metric, limit) {
    if (!limit && metric.limit == 1 && metric.sortBy == 'count' && metric.sortDirection == 'desc') {
      var returnArray = [],
        rollingHighest = 0;
      _.each(arrayToTrim, function (arrayItem) {
        if (arrayItem >= rollingHighest) {
          rollingHighest = arrayItem;
          returnArray.push(arrayItem);
        }
      });
      return returnArray;
    } else {
      return arrayToTrim.slice(0, limit || metric.limit);
    }
  }

  function buildSeriesChartData(arr) {
    // charts with series can show multiple series of data in 1 chart. e.g. users daily totals. leads by hour where each day is a new line
  
    // loop array to find the unique keys for the series data.
    var uniqueInnerKeys = {};
    _.each(arr, function (obj) {
      _.each(obj.members, function (value, key) {
        uniqueInnerKeys[key] = 1;
      });
    });
  
    // build empty buckets where necessary (data needs to be in specific order/structure for it all to work!)
    _.each(arr, function (obj) {
      _.each(uniqueInnerKeys, function (value, key) {
        if (!obj.members[key]) {
          obj.members[key] = {
            caption: key,
            count: 0,
            arrayOfResponseIds: []
          };
        }
      });
    });
  
    // an array of the unique keys. 1 label per series of data
    var uniqueInnerKeysArray = _.map(uniqueInnerKeys, function (value, key) {
      return key;
    });
  
    // sort them alphabetically
    uniqueInnerKeysArray.sort();
  
    var outerDataArray = [],
      arrayOfArrayOfResponseIds = [],
      innerArray,
      arrayOfResponseIds = [];
  
    _.each(uniqueInnerKeysArray, function (innerKey) {
      innerArray = [];
      arrayOfResponseIds = [];
      _.each(arr, function (outer) {
        var count = outer.members[innerKey].count;
        var arrRespIds = outer.members[innerKey].arrayOfResponseIds;
        innerArray.push(count);
        arrayOfResponseIds.push(arrRespIds);
      });
      outerDataArray.push(innerArray);
      arrayOfArrayOfResponseIds.push(arrayOfResponseIds);
    });
  
    return {
      data: outerDataArray,
      labels: _.map(arr, 'primaryLabel'),
      series: uniqueInnerKeysArray,
      linkedResponseIds: arrayOfArrayOfResponseIds
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('forms')
    .factory('ValidateAction', factory);

  factory.$inject = ['MessageService', '$mdMedia'];
  /* ng-inject */
  function factory(MessageService, $mdMedia) {

    return function (ev, selectedLeads, actionToValidate) {
      return new Promise(function (resolve, reject) {
        if (actionToValidate === 'releaseLeads') {
          const leadStats = selectedLeadStats(selectedLeads);
          if (leadStats.notifyUser) {
            showUserDialogToConfirmIntendedAction(ev, leadStats.counts)
              .then(function (confirmedReleaseActions) {
                const filteredLeadsForRelease = applyFilterToSelectedLeads(selectedLeads, confirmedReleaseActions);
                resolve(filteredLeadsForRelease);
              })
              .catch(function (err) {
                reject(err);
              });
          } else {
            resolve(selectedLeads);
          }
        } else {
          resolve(selectedLeads);
        }
      });
    };

    function applyFilterToSelectedLeads(selectedLeads, confirmedReleaseActions) {
      const filteredLeadsForRelease = [];
      _.each(selectedLeads, function (lead) {
        const pushLead = workOutIfLeadIsForRelease(lead, confirmedReleaseActions);
        if (pushLead) filteredLeadsForRelease.push(pushLead);
      });
      return filteredLeadsForRelease;
    }

    function workOutIfLeadIsForRelease(lead, confirmedReleaseActions) {
      const integrationState = lead.response._integrationState;
      if ((integrationState === 'processed' || integrationState === 'released' || integrationState === 'success') && confirmedReleaseActions.includeReleased) {
        return lead;
      } else if ((integrationState === 'failed' || integrationState === 'mixed') && confirmedReleaseActions.includeFailed) {
        return lead;
      } else if (integrationState === 'unreleased' && confirmedReleaseActions.includeUnreleased) {
        return lead;
      }
      return false;
    }

    function selectedLeadStats(selectedLeads) {
      const counts = {
        lockedCount: 0,
        releasedCount: 0,
        failedCount: 0,
        unreleasedCount: 0,
        totalSelected: selectedLeads.length
      };
      let notifyUser = false;

      _.each(selectedLeads, function (lead) {
        if (lead.response._integrationState == 'processed' || lead.response._integrationState == 'released' || lead.response._integrationState == 'success') {
          notifyUser = true;
          counts.releasedCount++;
        } else if (lead.response._integrationState == 'failed' || lead.response._integrationState == 'mixed' || lead.response._integrationState == 'timedOut') {
          notifyUser = true;
          counts.failedCount++;
        } else {
          counts.unreleasedCount++;
        }
      });
      return {
        notifyUser: notifyUser,
        counts: counts
      };
    }

    function showUserDialogToConfirmIntendedAction(ev, leadStats) {
      const useFullScreen = ($mdMedia('sm') || $mdMedia('xs'));
      return MessageService.showDialog(ev, {
        controller: 'ReleaseLeadConfirmationPrompt as $ctrl',
        templateUrl: 'app/forms/lead-release-grid/dialogs/release-confirmation/release-lead-confirmation-prompt.tmpl.html',
        fullscreen: useFullScreen,
        locals: leadStats
      })
        .then(function (options) {
          return options;
        })
        .catch(function () {
          throw {
            errorMessage: 'At ease 💂'
          };
        });
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('UpdateUiAndTriggerDownstreamProcesses', factory);

  factory.$inject = ['PostReleaseMessaging', 'UpdateRowsWithReleaseState', 'SyncReleasePushAttemptsToGrid', 'IntegrationHeadlineWidgetsData', 'GridDataFactory'];
  /* ng-inject */
  function factory(PostReleaseMessaging, UpdateRowsWithReleaseState, SyncReleasePushAttemptsToGrid, IntegrationHeadlineWidgetsData, GridDataFactory) {

    return function (serverResponse, shuttleResponse, action, rowCount, srcEv) {
      updateReleaseStateIconsInUI(serverResponse);
      PostReleaseMessaging.success(action, rowCount);
      if (serverResponse.recalls.length) {
        return triggerDownstreamProcess(serverResponse.recalls, srcEv);
      } else {
        return;
      }
    };

    function updateReleaseStateIconsInUI(serverResponse) {
      var concatResponses = serverResponse.docs.concat(serverResponse.recalls);
      UpdateRowsWithReleaseState(concatResponses);
      var leadReleaseGridData = GridDataFactory.getDataForGrid('lead_release');
      IntegrationHeadlineWidgetsData.updateIntegrationWidgetCounts(leadReleaseGridData.rawData);
    }

    function triggerDownstreamProcess(responsesRequiringRecall, srcEv) {
      if (!responsesRequiringRecall) return;
      return SyncReleasePushAttemptsToGrid.fetchPushDocs(responsesRequiringRecall, srcEv);
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('ProcessShuttleResponse', factory);

  factory.$inject = ['MessageService', '$timeout', 'PollServerForPushDocs', 'LEAD_RELEASE_API_CALL_BASE_TIMEOUT'];
  /* ng-inject */
  function factory(MessageService, $timeout, PollServerForPushDocs, LEAD_RELEASE_API_CALL_BASE_TIMEOUT) {

    return function (shuttleResponse, action, actionedRows) {
      if (shuttleResponse.nutshell === 'yes') {
        if (action === 'lockLeads') {
          const mappedDocs = _.map(actionedRows, function (leadObj) {
            const ro = {
              _id: leadObj.response._id,
              _integrationState: 'locked'
            };
            ro._distilledIntegrationState = leadObj.response._distilledIntegrationState;
            ro._distilledIntegrationState.locked = true;
            return ro;
          });
          return Promise.resolve({
            docs: mappedDocs,
            recalls: []
          });
        }
        return processSuccessfulResponse(shuttleResponse);
      } else {
        return processErrorResponse(shuttleResponse);
      }
    };

    function processSuccessfulResponse(shuttleResponse) {
      MessageService.writeLog({
        level: 'info',
        msg: 'Lead release success: ' + JSON.stringify(shuttleResponse),
        tags: ['integration', 'lead_release_success']
      });
      return processReleasedLeadsResponse(shuttleResponse);
    }

    function processErrorResponse(shuttleResponse) {
      MessageService.writeLog({
        level: 'error',
        msg: 'Lead release error: ' + JSON.stringify(shuttleResponse),
        tags: ['integration', 'lead_release_error']
      });
      return Promise.reject(shuttleResponse);
    }

    function processReleasedLeadsResponse(shuttleResponse) {
      // set a timeout here to give the async HPSSyncService process a chance to process the queue!
      return new Promise(function (resolve, reject) {
        try {
          $timeout(function () {
            const options = {
              responseIdKey: 'zuantid'
            };
            return resolve(PollServerForPushDocs(shuttleResponse.actionResults, options));
          }, LEAD_RELEASE_API_CALL_BASE_TIMEOUT);
        } catch (e) {
          reject(e);
        }
      });
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('LaunchShuttle', factory);

  factory.$inject = ['GridDataFactory', 'DotNetCommands', 'DotNetShuttleService'];
  /* ng-inject */
  function factory(GridDataFactory, DotNetCommands, DotNetShuttleService) {

    return function LaunchShuttle(selectedRows, actionToPerform) {
      return new Promise(function (resolve, reject) {
        try {
          const shuttle = {
            command: DotNetCommands.shuttleCommands.leadRelease,
            actionToPerform: DotNetCommands.integrationActions[actionToPerform],
            actions: []
          }; 
          let rowData;
          let actionObj;

          _.each(selectedRows, function (row) {
            rowData = GridDataFactory.locateCellRowDataById(row.response._id, 'lead_release');
            if (actionToPerform === 'lockLeads') {
              rowData.response._integrationState = 'locked';
            } else if (actionToPerform === 'unlockLeads') {
              rowData.response._integrationState = 'unlockLeads';
            } else {
              rowData.response._integrationState = 'queued';
            }
            actionObj = {
              zuantid: rowData.response._id,
              info: rowData.response
            };
            shuttle.actions.push(actionObj);
          });

          // the dot Net service is the single gateway from Cloud to Machines service. All _integrationState updates run through this endpoint
          resolve(DotNetShuttleService.launchShuttle(shuttle));

        } catch (e) {
          reject(e);
        }
      });
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('ReleaseLeadsFactory', factory);

  factory.$inject = ['ValidateAction', 'LaunchShuttle', 'ProcessShuttleResponse', 'UpdateUiAndTriggerDownstreamProcesses', 'PostReleaseMessaging'];
  /* ng-inject */
  function factory(ValidateAction, LaunchShuttle, ProcessShuttleResponse, UpdateUiAndTriggerDownstreamProcesses, PostReleaseMessaging) {

    return function (ev, params) {
      let shuttleResponse;
      let rowCount;
      let validatedRowsClosure;
      return ValidateAction(ev, params.selectedRows, params.action)
        .then(function (validatedRows) {
          rowCount = validatedRows.length;
          validatedRowsClosure = validatedRows;
          return LaunchShuttle(validatedRows, params.action);
        })
        .then(function (sResponse) {
          shuttleResponse = sResponse;
          return ProcessShuttleResponse(shuttleResponse, params.action, validatedRowsClosure);
        })
        .then(function (serverResponse) {
          return UpdateUiAndTriggerDownstreamProcesses(serverResponse, shuttleResponse, params.action, rowCount, ev);
        })
        .catch(function (err) {
          PostReleaseMessaging.error(err);
          throw err;
        });
    };
  }
}());

'use strict';

angular
  .module('forms')
  .controller('ExportCSVDialogCtrl', ExportCSVDialogCtrl);

ExportCSVDialogCtrl.$inject = ['MessageService', 'EventsLeadsExportsFactory', 'EventsExportDataFactory'];
/** @ngInject */
function ExportCSVDialogCtrl(MessageService, EventsLeadsExportsFactory, EventsExportDataFactory) {

  var vm = this;

  vm.$onInit = function () {
    vm.loading = false;
    vm.showFilters = false;

    vm.firstleadreceived = 'N/A';
    vm.lastleadreceived= 'N/A';
    vm.leadcount = 0;
    vm.parkedcount = 0;
    vm.formscount = 0;
    vm.activeformscount = 0;

    EventsExportDataFactory.GetExportStats()
      .then(function(resp){
        vm.minDate = moment(resp.Firstleadreceived).set({h:0, m:0, s:0, ms:0}).toDate();
        vm.maxDate = moment(resp.Lastleadreceived).set({h:0, m:0, s:0, ms:0}).toDate();
        vm.firstleadreceived= moment(resp.Firstleadreceived).format('MM/DD/YYYY');
        vm.lastleadreceived= moment(resp.Lastleadreceived).format('MM/DD/YYYY');
        vm.leadcount = resp.Totalresponsecount;
        vm.parkedcount = resp.Totalparkedcount;
        vm.formscount = resp.Totalformcount;
        vm.activeformscount = resp.Activeformcount;
        vm.getAllExportDataStats();
      });
  };

  vm.cancel = function(){
    MessageService.cancelDialog();
  };

  vm.updateChangeDelta = function(ev, value){
    vm[ev]=value;
    if (vm.enddate && vm.startdate){
      vm.getExportDataStats(vm.startdate, vm.enddate);
    }
  };

  vm.getExportDataStats = function(startdate, enddate){
    vm.loading = true;
    vm.filtered_formcount=0;
    vm.filtered_totalformcount=0;
    vm.filtered_totalleads=0;
    vm.filtered_totalparkedleads=0;
    EventsExportDataFactory.getData(startdate, enddate)
      .then(function (resp){
        resp.data.forEach(element => {
          vm.filtered_totalformcount++;
          vm.filtered_totalparkedleads +=element.parkedcount;
          vm.filtered_totalleads +=element.leadcount;
          if (element.totalresponses>0){
            vm.filtered_formcount++;
          }
        });
        vm.loading = false;
      });
  };

  vm.getAllExportDataStats = function(){
    vm.getExportDataStats(vm.minDate, vm.maxDate);
  };

  vm.export = function(){
    vm.loading = true;
    let startdate, enddate;
    if (vm.showFilters == false)
    {
      startdate = vm.minDate;
      enddate = vm.maxDate;
    }
    else
    {
      startdate = vm.startdate;
      enddate = vm.enddate;
    }

    EventsLeadsExportsFactory.downloadFormExport(startdate, enddate)
      .then(csv => {
        vm.csv = csv;
        vm.loading = false;
      })
      .catch(() => vm.loading = false);
  };

  vm.showFiltersEvent = function(){
    vm.showFilters = !vm.showFilters;
    if (vm.showFilters == false && vm.startdate && vm.enddate)
      vm.getAllExportDataStats();
    else
      vm.updateChangeDelta();
  };
}

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('UpdateRowsWithReleaseState', factory);

  factory.$inject = ['GridDataFactory', 'BuildCellParams'];
  /* ng-inject */
  function factory(GridDataFactory, BuildCellParams) {

    //  receives an array of docs and updates the
    // _integrationState column to latest state
    return function updateGridCellsWithNewStatus(arrayOfResponses) {
      _.each(arrayOfResponses, function (responseDoc) {

        const paramsObj = BuildCellParams.integrationState(responseDoc);
        GridDataFactory.updateCellValue(paramsObj); // updates the _integrationState locally for selected rows

        const paramsObj2 = BuildCellParams.distilledIntegrationState(responseDoc);
        GridDataFactory.updateCellValue(paramsObj2); // updates the _distilledIntegrationState locally for selected rows
      });
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('SyncReleasePushAttemptsToGrid', factory);

  /** @description will continue to poll zuant_back_end api until all push attempt docs are fetched or timeouts lapse
   */
  factory.$inject = ['$timeout', 'PollServerForPushDocs', 'LEAD_RELEASE_API_CALL_BASE_TIMEOUT', 'UpdateRowsWithReleaseState', 'IntegrationHeadlineWidgetsData', 'GridDataFactory', 'MessageService'];
  /* ng-inject */
  function factory($timeout, PollServerForPushDocs, LEAD_RELEASE_API_CALL_BASE_TIMEOUT, UpdateRowsWithReleaseState, IntegrationHeadlineWidgetsData, GridDataFactory, MessageService) {

    const factoryData = {
      apiCallTimeout: Number(LEAD_RELEASE_API_CALL_BASE_TIMEOUT),
      callCount: 0 // sole purpose is for animating the status icon in the ui between queued state and waiting state
    };

    return {
      fetchPushDocs: fetchPushDocs
    };

    function fetchPushDocs(pushAttemptsRequiringRecall, srcEv) {
      // console.log('attempting to resolve ' + pushAttemptsRequiringRecall.length + ' responses');
      toggleLoadingIcon(pushAttemptsRequiringRecall);
      $timeout(function () {
        const options = {
          responseIdKey: '_id'
        };
        return PollServerForPushDocs(pushAttemptsRequiringRecall, options)
          .then(function (res) {
            updateUi(res);
            return processResponse(res, srcEv);
          })
          .catch(function (err) {
            factoryData.callCount = 0;
            throw err;
          });
      }, factoryData.apiCallTimeout);
    }

    function toggleLoadingIcon(recalls) {
      factoryData.callCount++;
      if (factoryData.callCount % 2 !== 0) {
        // flipping the leads requiring a recall to queued so as to animate the status icon
        _.each(recalls, function (doc) {
          doc._integrationState = 'queued';
        });
        // console.log('_integrationState = queued');
      }
      UpdateRowsWithReleaseState(recalls);
    }

    function updateUi(res) {
      const allResponsesFromServer = res.docs.concat(res.recalls);
      UpdateRowsWithReleaseState(allResponsesFromServer);
      const leadReleaseGridData = GridDataFactory.getDataForGrid('lead_release');
      IntegrationHeadlineWidgetsData.updateIntegrationWidgetCounts(leadReleaseGridData.rawData);
    }

    function processResponse(serverResponse, srcEv) {
      return new Promise(function (resolve) {
        if (serverResponse.recalls.length) {
          factoryData.apiCallTimeout = Number(factoryData.apiCallTimeout) + Number(1000); // add an extra second onto the apiCallTimeout
          resolve(fetchPushDocs(serverResponse.recalls));
        } else {
          // console.log('processing done! 💂');
          factoryData.callCount = 0;
          factoryData.apiCallTimeout = Number(LEAD_RELEASE_API_CALL_BASE_TIMEOUT);
          tellUserProcessingFinished(srcEv);
          resolve(serverResponse);
        }
      });
    }

    function tellUserProcessingFinished(srcEv) {
      const leadsWithIssues = IntegrationHeadlineWidgetsData.factoryData.leadsWithIssues.count;
      let userMessage = 'Finished processing released leads';
      if (leadsWithIssues > 0) {
        userMessage += '. ' + leadsWithIssues + ' leads currently have issues.  Click the lead status button for more info.';
        MessageService.confirm(srcEv).showInfoDialog(userMessage, 'Processing complete');
      } else {
        MessageService.showMessage(userMessage);
      }
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('PostReleaseMessaging', factory);

  factory.$inject = ['MessageService'];
  /* ng-inject */
  function factory(MessageService) {

    return {
      success: successMessages,
      error: errorMessages
    };

    function successMessages(action, rowCount) {
      pingIntercom(action, rowCount);
      displayMessage(action, rowCount);
    }

    function errorMessages(err) {
      if (err.errorMessage) {
        MessageService.showMessage(err.errorMessage);
      }
    }


    // PRIVATE success helpers
    function pingIntercom(action, rowCount) {
      MessageService.pushEventToIntercom('lead_release_action_complete', {
        action: action,
        numberOfLeads: rowCount
      });
      MessageService.updateIntercom();
    }

    function displayMessage(action, rowCount) {
      const messageToShowUser = rowCount + (rowCount > 1 ? ' leads ' : ' lead ') + translateActionToUserFriendly(action);
      MessageService.showMessage(messageToShowUser);
    }

    function translateActionToUserFriendly(action) {
      if (action === 'releaseLeads') {
        return 'released';
      }
      if (action === 'lockLeads') {
        return 'locked';
      }
      if (action === 'resetLeads') {
        return 'reset';
      }
      if (action === 'unlockLeads') {
        return 'unlocked';
      }
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('BuildCellParams', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    return {
      integrationState: integrationState,
      distilledIntegrationState: distilledIntegrationState
    };

    function integrationState (responseDoc) {
      return {
        widgetId: 'lead_release',
        objectId: responseDoc._id,
        metadata: {
          object: 'response',
          databasefieldname: '_integrationState'
        },
        newValue: responseDoc._integrationState
      };
    }

    function distilledIntegrationState (responseDoc) {
      return {
        widgetId: 'lead_release',
        objectId: responseDoc._id,
        metadata: {
          object: 'response',
          databasefieldname: '_distilledIntegrationState'
        },
        newValue: responseDoc._distilledIntegrationState
      };
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .controller('ReleaseLeadConfirmationPrompt', controller);

  controller.$inject = ['locals', 'MessageService'];
  /* ng-inject */
  function controller(locals, MessageService) {

    var vm = this;

    vm.stats = locals;
    vm.actionsToPerform = {
      includeFailed: false,
      includeUnreleased: false,
      includeReleased: false
    };
    vm.actionOptions = [{
      value: 'releaseAllSelected',
      icon: 'zmdi zmdi-cloud-upload',
      label: 'Release all selected leads'
    }];
    if (locals.releasedCount) {
      vm.actionOptions.push({
        value: 'releaseReleasedOnly',
        icon: 'zmdi zmdi-cloud-done',
        label: 'Only release previously released leads'
      });
    }
    if (locals.unreleasedCount) {
      vm.actionOptions.push({
        value: 'releaseUnreleasedOnly',
        icon: 'zmdi zmdi-cloud-off',
        label: 'Release unreleased leads only'
      });
    }

    vm.cancelDialog = function () {
      MessageService.cancelDialog();
    };

    vm.submit = function () {
      MessageService.closeDialog(vm.actionsToPerform);
    };

  }
}());

/**
 * Created by davidbeazer on 21/11/2016.
 */
'use strict';

angular
  .module('forms')
  .controller('PushHistoryDialogCtrl', PushHistoryDialogCtrl);

PushHistoryDialogCtrl.$inject = ['locals', 'MessageService', 'EmbellishReleaseAttempts', '$state'];
/* ng-inject */
function PushHistoryDialogCtrl(locals, MessageService, EmbellishReleaseAttempts, $state) {

  var vm = this;

  function init() {
    vm.locals = locals;

    EmbellishReleaseAttempts(locals.res)
      .then(function (res) {
        vm.orderedArrayOfReleaseAttempts = res.embellishedReleaseAttempts;
        vm.showJson = false;
        const contactData = locals.leadData.contact;
        vm.title = (contactData.firstname ? contactData.firstname : '(no first name)') + ' ' + (contactData.lastname ? contactData.lastname : '(no surname)');
      });
  }

  init();

  vm.goToMachinesPage = function () {
    $state.go('app.homescreen_app_framework.integration-home');
    MessageService.cancelDialog('cancel dialog');
  };

  vm.cancelDialog = function () {
    MessageService.cancelDialog('cancel dialog');
  };

  vm.closeDialog = function () {
    MessageService.closeDialog('close dialog');
  };

}

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('DownloadXLSX', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    return function (filename, xlsxData) {

      if (xlsxData == null) return;

      const link = document.createElement('a');
      const data = new Blob([xlsxData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      link.setAttribute('href', window.URL.createObjectURL(data));
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('DownloadLeadDataToXLSX', factory);

  factory.$inject = ['GetDataReadyForCSV', 'XLSX', 'DownloadXLSX'];
  /* ng-inject */
  function factory(GetDataReadyForCSV, XLSX, DownloadXLSX) {

    return function (downloadOptions) {
      return GetDataReadyForCSV(downloadOptions)
        .then(function (data) {
          const worksheetData = [data.columns].concat(data.leads);
          const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
          const workbook = XLSX.utils.book_new();

          XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads');

          const xlsxData = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
          });

          DownloadXLSX(data.filename, xlsxData);
          return;
        })
        .catch(function (err) {
          throw err;
        });
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('UnparseData', factory);

  factory.$inject = ['Papa'];
  /* ng-inject */
  function factory(Papa) {

    return function (arrayOfColumns, arrayOfLeadData) {
      // papa unparses it all to csv.  http://papaparse.com/docs#json-to-csv

      return Papa.unparse({
        fields: arrayOfColumns,
        data: arrayOfLeadData
      }, {
        quotes: true,
        quoteChar: '"',
        delimiter: ',',
        header: true,
        newline: '\r\n'
      });
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('DownloadCSV', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    return function (filename, csv) {

      let data;
      let csvData;
      const byteOrderMark = '\ufeff'; // byteOrderMark to get Excel to understand encoding when foreign chars in data

      if (csv == null) return;

      if (typeof (Blob) != 'undefined') { // using Blob
        csvData = new Blob([byteOrderMark + csv], {
          type: 'text/csv;charset=utf-8;'
        });
        data = window.URL.createObjectURL(csvData);

      } else {
        if (!csv.match(/^data:text\/csv/i)) {
          csv = 'data:text/csv;charset=utf-8,' + byteOrderMark + csv;
        }
        data = encodeURI(csv);
      }

      const link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', filename);
      document.body.appendChild(link); // Required for FF
      link.click();

    };

  }

})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('DownloadLeadDataToCSV', factory);

  factory.$inject = ['GetDataReadyForCSV', 'UnparseData', 'DownloadCSV'];
  /* ng-inject */
  function factory(GetDataReadyForCSV, UnparseData, DownloadCSV) {

    return function (downloadOptions) {
      return GetDataReadyForCSV(downloadOptions)
        .then(function (data) {
          const csv = UnparseData(data.columns, data.leads);
          DownloadCSV(data.filename, csv);
          return;
        })
        .catch(function (err) {
          throw err;
        });
    };
  }
}());

/**
 * @module common
 * Created by davidbeazer on 19/08/2016.
 */
(function () {
  angular
    .module('common', [
      'cfp.hotkeys',
      'ngMaterial',
      'md.table.templates',
      'ui.sortable',
      'angular-uuid',
      'ngPapaParse',
      'ngXLSX'
    ]);

})();

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpFilterToolbar', {
      templateUrl: 'app/common/tables/toolbars/filter/zp-filter-toolbar.tmpl.html',
      controller: ['$scope', componentController],
      controllerAs: 'vm',
      bindings: {
        onUpdate: '&'
      }
    });

  function componentController() {

    var vm = this;
    vm.showSearch = true;
    vm.updateSearch = updateSearch;

    function updateSearch(val) {
      this.onUpdate(val);
    }

    this.$onChanges = function () {
      // `changes` is a special instance of a constructor Object,
      // it contains a hash of a change Object and
      // also contains a function called `isFirstChange()`
      // it's implemented in the source code using a constructor Object
      // and prototype method to create the function `isFirstChange()`
    };
  }

})();

/**
 * Created by davidbeazer on 19/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('common')
    .component('zpSelectionManager', {
      templateUrl: 'app/common/tables/toolbars/selection-manager/zp-selection-manager.tmpl.html',
      controller: SelectionController,
      bindings: {
        toolbarButtons: '<',
        widgetId: '<'
      }
    });

  SelectionController.$inject = ['$scope', 'MessageService', 'hotkeys', 'GridDataFactory', 'LeadDataFactory'];
  /* ng-inject */
  function SelectionController($scope, MessageService, hotkeys, GridDataFactory, LeadDataFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.factoryData = GridDataFactory.factoryData;

      hotkeys.bindTo($scope)
        .add({
          combo: 'ctrl+d',
          description: 'Delete selected items',
          callback: function () {
            vm.deleteButtonClicked();
          }
        });

      hotkeys.bindTo($scope)
        .add({
          combo: 'ctrl+e',
          description: 'Edit selected items',
          callback: function () {
            vm.editButtonClicked();
          }
        });

      hotkeys.bindTo($scope)
        .add({
          combo: 'ctrl+c',
          description: 'Clear selected items',
          callback: function () {
            vm.clearSelectedCheckboxClicked();
          }
        });
    };

    vm.itemsSelected = function (){
      return GridDataFactory.factoryData[vm.widgetId].selectedItems.length;
    };

    vm.deleteButtonClicked = function (ev) {
      hotkeys.del('enter');
      LeadDataFactory.archiveLeads(ev, vm.widgetId);
    };
    
    vm.unarchiveButtonClicked = function (ev) {
      LeadDataFactory.unarchiveLeads(ev, vm.widgetId);
    };

    vm.editButtonClicked = function (ev) {
      hotkeys.del('enter');
      startMultiEditSession(ev);
    };

    vm.clearSelectedCheckboxClicked = function () {
      GridDataFactory.clearSelectedArray(vm.widgetId);
    };

    vm.unparkLeadsButtonClicked = function (ev) {
      LeadDataFactory.unparkLeads(ev);
    };

    function startMultiEditSession(srcEvent) {
      /*eslint-disable */
      MessageService.showDialog(srcEvent, {
        controller: 'MultiEditCtrl',
        controllerAs: 'ctrl',
        templateUrl: 'app/common/editor/multi-edit/dialog.tmpl.html',
        locals: {
          selected: GridDataFactory.getSelectedRows(vm.widgetId),
          widgetId: vm.widgetId
        }
      })
        .then(
          function (success, data) { },
          function (err) { }
        );
      /*eslint-enable */
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpGridToolbar', {
      templateUrl: 'app/common/tables/toolbars/grid/tmpl.html',
      controller: 'GridToolbarCtrl',
      bindings: {
        buttons: '<',
        searchValue: '=',
        widgetId: '<',
        metadata: '<',
        refreshGridData: '&'
      }
    })
    .controller('GridToolbarCtrl', controller)
    .directive('inputClear', inputClear);

  controller.$inject = ['$scope', 'ColumnSelectionSvc', 'SetFilename', 'ChangeDelta', '$state', 'EncodingService', 'DownloadsFactory', 'MessageService', 'LeadDataFactory', 'GridDataFactory', 'MasterPermissionsDefinitionFactory'];
  /* ng-inject */
  function controller($scope, ColumnSelectionSvc, SetFilename, ChangeDelta, $state, encoder, DownloadsFactory, MessageService, LeadDataFactory, GridDataFactory, MasterPermissionsDefinitionFactory) {

    var vm = this;
    vm.columnSelectionSvc = ColumnSelectionSvc;

    vm.$onInit = function () {
      ColumnSelectionSvc.hydrateFactoryWithColumns(vm.metadata);
      vm.formId = vm.metadata.formProperties._id;
      vm.formname = vm.metadata.formProperties.formname;
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.changeDeltaFactory = ChangeDelta;
      vm.leadGridFactoryData = GridDataFactory.factoryData;

      $scope.$on('$mdMenuClose', function(func, $event) {
        const menuElement = $event[0];
        if (menuElement && menuElement.id === 'colum-select-menu' && ColumnSelectionSvc.factoryData.reorderModeEnabled) ColumnSelectionSvc.toggleReorderColumns();
      });

    };

    vm.toggleShowSearch = function () {
      vm.showSearch = !vm.showSearch;
      vm.searchValue = '';
    };

    // COLUMNS MANAGEMENT
    vm.toggleColumnVisibility = function (colData) {
      ColumnSelectionSvc.toggleColumnVisibility([{
        dbfield: colData.databasefieldname,
        object: colData.object,
        showCol: colData.showCol
      }]);
    };

    vm.toggleAllColsVisible = function () {
      ColumnSelectionSvc.toggleAllColsVisible();
    };

    // MENU FUNCTIONS
    vm.openMenu = function (func, ev) {
      func(ev);
    };

    vm.openParkedLeadsDialog = function () {
      $state.go('app.single_view_framework.full_screen_grid', {
        _id: encoder.encode(vm.formId)
      });
    };

    vm.updateTitle = function (newval) {
      if (vm.formname == newval) return;
      ChangeDelta.recordValueChange({
        oldval: vm.formname,
        newval: newval,
        objectid: 'form_formname',
        collection: 'form',
        databasefieldname: 'formname'
      });
      if (newval != vm.formname) {
        vm.formname = newval;
      }
    };

    vm.downloadLeads = function ($event) {
      SetFilename($event, vm.metadata.csvFileLabel)
        .then(function (filename) {
          const parked = vm.widgetId === 'parked_leads';
          const downloadSubset = vm.widgetId === 'full_page_widget_grid';
          return DownloadsFactory.downloadLeads({
            literatureBreakout: false,
            columns: visibleColumns(),
            filename,
            parked,
            downloadSubset,
            selectedRows: GridDataFactory.getSelectedRows(vm.widgetId) || []
          });
        })
        .then(function () {
          MessageService.showMessage('CSV File Downloaded');
          MessageService.pushEventToIntercom('csv_download_success', {
            _formid: vm.formId,
            formname: vm.formname
          });
        });
    };

    vm.downloadLeadsAsExcel = function ($event) {
      SetFilename($event, vm.metadata.csvFileLabel, 'xlsx')
        .then(function (filename) {
          const parked = vm.widgetId === 'parked_leads';
          const downloadSubset = vm.widgetId === 'full_page_widget_grid';
          return DownloadsFactory.downloadLeadsAsExcel({
            literatureBreakout: false,
            columns: visibleColumns(),
            filename,
            parked,
            downloadSubset,
            selectedRows: GridDataFactory.getSelectedRows(vm.widgetId) || []
          });
        })
        .then(function () {
          MessageService.showMessage('Excel File Downloaded');
          MessageService.pushEventToIntercom('xlsx_download_success', {
            _formid: vm.formId,
            formname: vm.formname
          });
        });
    };

    function visibleColumns() {
      const hiddenFromExport = [{
        dbfield: '_aiProfile',
        object: 'contact'
      }];

      const colsToDownload = [];
      for (const col of ColumnSelectionSvc.factoryData.columnsData.items) {
        const isHiddenFromExport = hiddenFromExport.findIndex(function (itm) {
          return itm.dbfield === col.databasefieldname && itm.object === col.object;
        }) > -1;

        if (col.showCol && !isHiddenFromExport) {
          colsToDownload.push(col.databasefieldname);
          if (col.databasefieldname === 'emailEvents') {
            colsToDownload.push('latestEmailEvent');
          }
        }
      }
      return colsToDownload;
    }

    vm.downloadLeadBreakoutReport = function ($event) {
      const parked = vm.widgetId === 'parked_leads';

      SetFilename($event, 'submitted_leads_breakout_report')
        .then(function (filename) {
          return DownloadsFactory.downloadLeadBreakoutReport({
            literatureBreakout: true,
            columns: visibleColumns(),
            filename,
            parked,
            selectedRows: GridDataFactory.getSelectedRows(vm.widgetId) || []
          });
        })
        .then(function () {
          MessageService.showMessage('CSV File Downloaded');
          MessageService.pushEventToIntercom('csv_download_success', {
            _formid: vm.formId,
            formname: vm.formname
          });
        });
    };

    vm.downloadLeadBreakoutReportAsExcel = function ($event) {
      const parked = vm.widgetId === 'parked_leads';

      SetFilename($event, 'submitted_leads_breakout_report', 'xlsx')
        .then(function (filename) {
          return DownloadsFactory.downloadLeadBreakoutReportAsExcel({
            literatureBreakout: true,
            columns: visibleColumns(),
            filename,
            parked,
            selectedRows: GridDataFactory.getSelectedRows(vm.widgetId) || []
          });
        })
        .then(function () {
          MessageService.showMessage('Excel File Downloaded');
          MessageService.pushEventToIntercom('xlsx_download_success', {
            _formid: vm.formId,
            formname: vm.formname
          });
        });
    };

    vm.saveGridChanges = function () {
      const changeDeltas = ChangeDelta.getDeltaObject();
      if (_.isEmpty(changeDeltas)) return;
      LeadDataFactory.saveGridChanges(changeDeltas)
        .then(function () {
          ChangeDelta.clear();
          GridDataFactory.removeDirtyFlagFromAllRows(vm.widgetId);
          vm.isdirty = false;
          MessageService.showMessage('Grid changes saved');
        })
        .catch(function (err) {

          // TODO ensure there is err.data.data.message as grid failed save doesn't and the user never sees this message cos it bombs out
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });

        });
    };
  }

  function inputClear() {
    return {
      restrict: 'A',
      compile: function (element, attrs) {
        const color = attrs.inputClear;
        const style = color ? 'color:' + color + ';' : '';
        const action = attrs.ngModel + ' = \'\'';
        element.after(
          '<md-button class="animate-show md-icon-button md-accent"' +
          'ng-show="' + attrs.ngModel + '" ng-click="' + action + '"' +
          'style="position: absolute; top: -4px; right: 10px; margin: 0px 0px;">' +
          '<div style="' + style + '"><md-icon md-font-icon="zmdi zmdi-close"></md-icon></div>' +
          '</md-button>');
      }
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .service('ColumnSelectionSvc', service);

  service.$inject = ['localStorageService'];
  /* ng-inject */
  function service(localStorage) {

    const factoryData = {
      columnsData: {},
      allColumnsVisibleValue: false,
      reorderModeEnabled: false,
      staticColumns: [
        {
          dbfield: '_aiProfile',
          object: 'contact',
          index: 0,
          widgetId: 'submitted_leads'
        },
        {
          dbfield: '_integrationState',
          object: 'response',
          index: 0,
          widgetId: 'lead_release'
        }
      ]
    };

    return {
      hydrateFactoryWithColumns: hydrateFactoryWithColumns,
      fetchColumsVisibilityList: fetchColumsVisibilityList,
      toggleColumnVisibility: toggleColumnVisibility,
      toggleAllColsVisible: toggleAllColsVisible,
      getVisibleColumns: getVisibleColumns,
      toggleReorderColumns: toggleReorderColumns,
      fetchReorderColumsList: fetchReorderColumsList,
      resetColumnOrder: resetColumnOrder,
      reorderColumns: reorderColumns,
      factoryData: factoryData
    };

    function hydrateFactoryWithColumns(metadata) {

      factoryData.widgetId = metadata.id;
      factoryData.formId = metadata.formProperties._id;
      factoryData.columnsData = metadata.columnsData;
      factoryData.columnsData.orginialOrder = angular.copy(factoryData.columnsData.items);
      mergeColsVisibleFromLocalStorage();
      mergeColsOrderFromLocalStorage();
    }

    function fetchColumsVisibilityList() {
      if (!factoryData.columnsData.columnsVisibilityItems || factoryData.columnsData.columnsVisibilityItems.length === 0){
        factoryData.columnsData.columnsVisibilityItems = angular.copy(factoryData.columnsData.items).filter(function (colData) {
          return factoryData.staticColumns.findIndex(function (staticColData){
            return staticColData.dbfield === colData.databasefieldname && staticColData.object === colData.object;
          }) === -1;
        });
      }

      return factoryData.columnsData.columnsVisibilityItems;
    }

    function toggleColumnVisibility(arrayOfColsData) {

      let storedHiddenColumns = JSON.parse(localStorage.get(`grid_cols_visible_${factoryData.formId}_${factoryData.widgetId}`)) || [];
      if (storedHiddenColumns.length) {
        // there are some cols that have been set to hide for this form
        _.each(arrayOfColsData, function (incomingCol) {
          if (incomingCol.showCol) {
            const matchedColumn = _.find(storedHiddenColumns, function (storedCol) {
              return (incomingCol.dbfield == storedCol.dbfield && incomingCol.object == storedCol.object);
            });
            if (matchedColumn) {
              // column is now set to show and is in the array of hidden columns
              // reject it from the stored array!
              storedHiddenColumns = _.reject(storedHiddenColumns, function (col) {
                return (incomingCol.dbfield === col.dbfield && incomingCol.object === col.object);
              });
            }
          } else {
            // column is now set to be hidden, ensure it is saved to array of hidden columns in LS
            storedHiddenColumns.push(incomingCol);
          }
        });
        // store updated array of hidden columns
        localStorage.set(`grid_cols_visible_${factoryData.formId}_${factoryData.widgetId}`, JSON.stringify(storedHiddenColumns));
      } else {
        // no hidden cols found for this form, save this array!
        localStorage.set(`grid_cols_visible_${factoryData.formId}_${factoryData.widgetId}`, JSON.stringify(arrayOfColsData));
      }
      setAllColumnsVisibleValue();
      mergeColsVisibleFromLocalStorage();
    }

    function toggleAllColsVisible() {
      const toggledCols = _.chain(fetchColumsVisibilityList())
        .each(function (col) {
          col.showCol = factoryData.allColumnsVisibleValue;
        })
        .map(function (col) {
          // return a stripped down obj of the column for storage purposes
          return {
            dbfield: col.databasefieldname,
            object: col.object,
            showCol: col.showCol
          };
        })
        .value();

      toggleColumnVisibility(toggledCols);
    }

    function mergeColsVisibleFromLocalStorage() {
      const localStorageColsVisibleForThisForm = JSON.parse(localStorage.get(`grid_cols_visible_${factoryData.formId}_${factoryData.widgetId}`)) || [];
      for (const col of factoryData.columnsData.items) {

        const colIsHidden = localStorageColsVisibleForThisForm.findIndex( function (storedCol) {
          return (col.databasefieldname === storedCol.dbfield && col.object === storedCol.object);
        }) > -1;
        if (colIsHidden) {
          col.showCol = false;
          continue;
        }

        col.showCol = true;
      }
      
      setAllColumnsVisibleValue();
    }

    function setAllColumnsVisibleValue() {
      const columnsFromLocalStorage = JSON.parse(localStorage.get(`grid_cols_visible_${factoryData.formId}_${factoryData.widgetId}`)) || [];
      if (columnsFromLocalStorage) {
        factoryData.allColumnsVisibleValue = !columnsFromLocalStorage.length;
      } else {
        factoryData.allColumnsVisibleValue = true;
      }
    }

    function getVisibleColumns() {
      return _.chain(factoryData.columnsData.items)
        .filter(function (column) {
          return column.showCol;
        })
        .map('databasefieldname')
        .value();
    }

    function mergeColsOrderFromLocalStorage() {
      const savedColumnOrder = JSON.parse(localStorage.get(`grid_cols_order_${factoryData.formId}_${factoryData.widgetId}`));
      if (!savedColumnOrder) return;

      for (const staticColData of factoryData.staticColumns){
        const existingColumnIndex = savedColumnOrder.findIndex(function (colData) {
          return colData.dbfield === staticColData.dbfield && colData.object === staticColData.object;
        });
        
        if (existingColumnIndex > -1) savedColumnOrder.splice(existingColumnIndex, 1);

        if (staticColData.widgetId === factoryData.widgetId) savedColumnOrder.splice(staticColData.index, 0, { dbfield: staticColData.dbfield, object: staticColData.object });
      }

      localStorage.set(`grid_cols_order_${factoryData.formId}_${factoryData.widgetId}`, JSON.stringify(savedColumnOrder));

      const columnOrderMap = savedColumnOrder.reduce(function (map, col, index) {
        map[col.dbfield] = index;
        return map;
      }, {});

      factoryData.columnsData.items = factoryData.columnsData.items.sort(function (a, b) {
        const orderA = columnOrderMap[a.databasefieldname] !== undefined ? columnOrderMap[a.databasefieldname] : Number.MAX_SAFE_INTEGER;
        const orderB = columnOrderMap[b.databasefieldname] !== undefined ? columnOrderMap[b.databasefieldname] : Number.MAX_SAFE_INTEGER;
        return orderA - orderB;
      });
    }

    function resetColumnOrder() {
      localStorage.remove(`grid_cols_order_${factoryData.formId}_${factoryData.widgetId}`);
      factoryData.columnsData.items = angular.copy(factoryData.columnsData.orginialOrder);
      factoryData.columnsData.reorderColumnsItems = [];
    }

    function toggleReorderColumns() {
      factoryData.reorderModeEnabled = !factoryData.reorderModeEnabled;
      factoryData.columnsData.reorderColumnsItems = [];
      factoryData.columnsData.columnsVisibilityItems = [];
    }

    function fetchReorderColumsList() {
      if (!factoryData.columnsData.reorderColumnsItems || factoryData.columnsData.reorderColumnsItems.length === 0){
        factoryData.columnsData.reorderColumnsItems = angular.copy(factoryData.columnsData.items).filter(function (colData) {
          return factoryData.staticColumns.findIndex(function (staticColData){
            return staticColData.dbfield === colData.databasefieldname && staticColData.object === colData.object;
          }) === -1;
        });
      }

      return factoryData.columnsData.reorderColumnsItems;
    }

    function reorderColumns($event, ui) {
      const sourceIndex = ui.item.sortable.index;
      const dropIndex = ui.item.sortable.dropindex;

      factoryData.columnsData.reorderColumnsItems.splice(dropIndex, 0, factoryData.columnsData.reorderColumnsItems.splice(sourceIndex, 1)[0]);
      saveColumns();
      mergeColsOrderFromLocalStorage();
      ui.item.sortable.cancel();
    }

    function saveColumns(){
      const columnsToSave = factoryData.columnsData.reorderColumnsItems.map(function (colData) {
        return {
          dbfield: colData.databasefieldname,
          object: colData.object
        };
      });

      localStorage.set(`grid_cols_order_${factoryData.formId}_${factoryData.widgetId}`, JSON.stringify(columnsToSave));
    }

  }
}());

'use strict';
/* eslint no-undef: 0 */
angular.module('zp.message', []);

(function () {
  'use strict';
    
  angular
    .module('zp.message')
    .directive('zpConfirmationTextValidator', ConfirmationTextValidator);

  ConfirmationTextValidator.$inject = [];

  function ConfirmationTextValidator() {
    return {
      require: 'ngModel',
      scope: {
        targetConfirmationText: '@'
      },
      link: function(scope, element, attr, mCtrl) {
        function myValidation(value) {
          if (value === scope.targetConfirmationText) {
            mCtrl.$setValidity('confirmationText', true);
          } else {
            mCtrl.$setValidity('confirmationText', false);
          }
          return value;
        }
        mCtrl.$parsers.push(myValidation);
      }
    };
  }

})();
(function () {
  'use strict';

  angular
    .module('common')
    .factory('EndCellEditSessionFunctionHelpers', factory);

  factory.$inject = ['GridDataFactory', 'ChangeDelta', 'MessageService', 'CurrentListModel', 'LeadValidationFactory', '$log'];
  /* ng-inject */
  function factory(GridDataFactory, ChangeDelta, MessageService, CurrentListModel, LeadValidationFactory, $log) {

    var services = {
      grabCellIdentifiers: grabCellIdentifiers,
      buildValidationObj: buildValidationObj,
      removeEditorElementFromDOMIfNecessary: removeEditorElementFromDOMIfNecessary,
      updateModelsWithChanges: updateModelsWithChanges
    };

    return services;

    function grabCellIdentifiers(factoryData) {
      return {
        widgetId: factoryData.tableCellInFocus.attributes['zp-widget-id'].value,
        objectId: factoryData.scopeProps.zpRowData[factoryData.scopeProps.zpMetadata.object]['_id'],
        metadata: factoryData.scopeProps.zpMetadata,
        databasefieldname: factoryData.scopeProps.zpMetadata.databasefieldname,
        originalValue: factoryData.scopeProps.originalValue
      };
    }

    function buildValidationObj(cellIdentifiers, newValue) {
      var validationObj = {
          valid: true,
          errors: []
        },
        objectToValidate = {
          newValue: newValue,
          objectId: cellIdentifiers.objectId,
          metadata: cellIdentifiers.metadata,
          widgetId: cellIdentifiers.widgetId
        };
      if (cellIdentifiers.widgetId === 'parked_leads' || cellIdentifiers.widgetId === 'submitted_leads' || cellIdentifiers.widgetId === 'lead_release') {
        validationObj = LeadValidationFactory.validateCell(objectToValidate);
      } else if (cellIdentifiers.widgetId === 'list_detail') {
        validationObj = CurrentListModel.validateCell(objectToValidate);
      }
      return validationObj;
    }

    function removeEditorElementFromDOMIfNecessary(params) {

      if (params.validationObj.valid || (!params.validationObj.valid && !params.saveChanges)) {
        try {
          angular.element(params.factoryData.cellEditorElement).remove();
          params.factoryData.cellEditorElement = undefined;
        } catch (e) {
          $log.error(e);
        }
      }
    }

    function updateModelsWithChanges(paramsObj) {
      var saveChanges = paramsObj.saveChanges,
        cellIdentifiers = paramsObj.cellIdentifiers,
        validationObj = paramsObj.validationObj,
        newValue = paramsObj.newValue,
        factoryData = paramsObj.factoryData;

      if (!validationObj.valid) return false;
      if (!saveChanges) return false;
      if (JSON.stringify(factoryData.scopeProps.originalValue) !== JSON.stringify(newValue)) {

        if (cellIdentifiers.databasefieldname === '_grantedConsents') {
          newValue = updateConsentValues(newValue, factoryData);
        }

        GridDataFactory.updateCellValue({
          newValue: newValue,
          objectId: cellIdentifiers.objectId,
          metadata: cellIdentifiers.metadata,
          widgetId: cellIdentifiers.widgetId
        });

        ChangeDelta.recordValueChange({
          oldval: cellIdentifiers.originalValue,
          newval: newValue,
          objectid: cellIdentifiers.objectId,
          collection: cellIdentifiers.metadata.object,
          databasefieldname: cellIdentifiers.databasefieldname
        });

        if (cellIdentifiers.widgetId === 'parked_leads' || cellIdentifiers.widgetId === 'submitted_leads' || cellIdentifiers.widgetId === 'lead_release') {
          validateRow(cellIdentifiers.widgetId, factoryData);
          dirtyFlagCheck(cellIdentifiers.widgetId, cellIdentifiers.objectId, cellIdentifiers.metadata.object, factoryData);
        }
        MessageService.writeLog({
          level: 'info',
          msg: 'endEditSession; cell value is being updated; object.dbfieldname: ' + cellIdentifiers.metadata.object + '.' + cellIdentifiers.databasefieldname + ' oldValue: ' + factoryData.scopeProps.originalValue + ', newValue: ' + newValue
        });
        return true;
      }
    }

    //PRIVATE FUNCTIONS
    function validateRow(widgetId, factoryData) {
      var rowToValidate = GridDataFactory.locateCellRowDataById(factoryData.tableCellInFocus.attributes['zp-row-id'].value, widgetId);
      var validationErrors = LeadValidationFactory.validateRows({
        rowsData: [rowToValidate],
        widgetId: widgetId
      });

      if (_.isEmpty(validationErrors)) {
        GridDataFactory.leadIsValid(widgetId, rowToValidate.response._id); // updates _leadIsValid value for items, itemsObject and rawData (so check icon appears in the validation column)
      } else {
        loopAndValidateRowCells(validationErrors, widgetId, rowToValidate.response._id);
      }
    }

    function loopAndValidateRowCells(validationErrors, widgetId, rowToValidateResponseId) {
      var rowErrors = GridDataFactory.factoryData[widgetId].validation[rowToValidateResponseId].errors;
      _.each(rowErrors, function (error, k) {
        _.each(validationErrors, function (e) {
          if (e.errors[k]) {
            MessageService.writeLog({
              level: 'error',
              msg: 'error still exists',
              tags: ['cell-editing']
            });
          } else {
            delete GridDataFactory.factoryData[widgetId].validation[rowToValidateResponseId].errors[k];
            MessageService.writeLog({
              level: 'info',
              msg: 'error resolved for ' + k,
              tags: ['cell-editing']
            });
          }
        });
      });
    }

    function dirtyFlagCheck(widgetId, objectId, collection) {
      var deltas = ChangeDelta.getDeltaObject();
      var findLead = _.find(GridDataFactory.factoryData[widgetId].items, function (item) {
        return item[collection]._id == objectId;
      });
      if (findLead) {
        var findCompany = _.find(deltas.company, function (c, key) {
          return key === findLead.company._id;
        });
        var findContact = _.find(deltas.contact, function (c, key) {
          return key === findLead.contact._id;
        });
        var findResponse = _.find(deltas.response, function (c, key) {
          return key === findLead.response._id;
        });
        if (findCompany || findContact || findResponse) {
          findLead.dirty = true;
        } else {
          findLead.dirty = false;
        }
      }
    }

    function updateConsentValues(newValue, factoryData) {
      var valuesDiff = _.difference(newValue, factoryData.scopeProps.originalValue);
      // build object for each token containing the dateAcquired value
      var updatedConsentModel = [];

      _.each(newValue, function (val) {
        var tokenStillPresent = _.find(factoryData.scopeProps.zpModel, function (mod) {
          return mod.token === val;
        });
        if (tokenStillPresent) {
          updatedConsentModel.push(tokenStillPresent);
        }
      });
      _.each(valuesDiff, function (tokenName) {
        updatedConsentModel.push({
          token: tokenName,
          dateAcquired: moment().format('YYYY-MM-DD HH:mm:ss.S') // creates a correctly formatted new dateAcquired
        });
      });
      return updatedConsentModel;
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .factory('EndCellEditSessionFunction', factory);

  factory.$inject = ['EndCellEditSessionFunctionHelpers'];
  /* ng-inject */
  function factory(EndCellEditSessionFunctionHelpers) {

    return runFunction;

    function runFunction(saveChanges, newValue, factoryData) {
      var validationObj, cellIdentifiers;

      if (factoryData.cellEditorElement) {
        cellIdentifiers = EndCellEditSessionFunctionHelpers.grabCellIdentifiers(factoryData);
        validationObj = EndCellEditSessionFunctionHelpers.buildValidationObj(cellIdentifiers, newValue);

        EndCellEditSessionFunctionHelpers.removeEditorElementFromDOMIfNecessary({
          saveChanges: saveChanges,
          validationObj: validationObj,
          factoryData: factoryData
        });

        EndCellEditSessionFunctionHelpers.updateModelsWithChanges({
          saveChanges: saveChanges,
          cellIdentifiers: cellIdentifiers,
          validationObj: validationObj,
          newValue: newValue,
          factoryData: factoryData
        });
      }
      return validationObj;
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpRadioButtonCellEditor', {
      controller: 'SelectionCellEditorController',
      controllerAs: 'ctrl',
      templateUrl: 'app/common/editor/select-controls/radio-button-cell/radio-button-cell-editor.tmpl.html',
      bindings: {}
    });

})();

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpCheckboxCellEditor', {
      controller: 'SelectionCellEditorController',
      controllerAs: 'ctrl',
      templateUrl: 'app/common/editor/select-controls/checkbox-cell/checkbox-cell-editor.tmpl.html',
      bindings: {}
    });

})();

(function () {
  'use strict';
  angular
    .module('clients')
    .controller('ImageSelectionDialogCtrl', ctrl);

  ctrl.$inject = ['$scope', 'MessageService', 'locals', 'ImagesApiFactory', 'CurrentThemeFactory', 'AWS_STORAGE_REGION', 'AWS_STORAGE_BUCKET_NAME', '$filter'];
  /* ng-inject */
  function ctrl($scope, MessageService, locals, ImagesApiFactory, CurrentThemeFactory, awsStorageRegion, awsStorageBucketName, $filter) {

    var vm = this;

    const webUriDialogConfig = {
      controller: 'WeburiImageFormDialogCtrl',
      controllerAs: 'vm',
      templateUrl: 'app/clients/theming/images/weburi-image-form-dialog/weburi-image-form-dialog.tmpl.html',
      allowMultiple: true,
      locals: {}
    };

    vm.loading = true;
    vm.groupedImages = [];
    vm.selectedImageId = null;
    vm.selectionDirty = false;
    vm.initialSelectedImageId = null;
    vm.fileCurrentlyUploading = false;
    vm.fileUploadProgress = 0;

    let coreImages = [];

    vm.$onInit = function() {
      vm.skinName = locals.imageObj.skinName;
      if (locals.imageObj._id && locals.imageObj._id.length > 0){
        vm.initialSelectedImageId = locals.imageObj._id;
        vm.selectedImageId = vm.initialSelectedImageId;
      }

      saturateImages();

      $scope.$on('s3upload.progress', function ($event, progressPercentage){
        $scope.$applyAsync(function () {
          if (progressPercentage >= 100) vm.fileCurrentlyUploading = false;
          vm.fileUploadProgress = progressPercentage;
        });
      });
    };


    vm.fileChanged = function ($event){
      const file = $event.target.files[0];

      return MessageService
        .confirm($event)
        .createItemWithInput({
          title: 'Add Image Title',
          inputLabel: 'Image Title',
          userInput: file.name,
          okBtn: 'UPLOAD',
          cancelBtn: 'CANCEL'
        })
        .then(function (imageName) {
          vm.fileCurrentlyUploading = true;
          vm.fileUploadProgress = 0;
          return ImagesApiFactory.uploadImageToS3(imageName, file)
            .then(function (){
              return refreshImages();
            });
        })
        .catch(function () {});
    };

    vm.openFileSelector = function() {
      angular.element(document).find('#imageUploadInput').val(null);
      angular.element(document).find('#imageUploadInput').trigger('click');
    };

    vm.showCreateImageDialog = function ($event) {
      delete webUriDialogConfig.locals.image;

      MessageService.showDialog($event, webUriDialogConfig)
        .then(function (res) {
          if (res && res.triggerUpdate){
            return refreshImages();
          }
        });
    };

    vm.onEditImage = function ($event) {
      const image = coreImages.find(function (img) {
        return img._id === vm.selectedImageId;
      });

      webUriDialogConfig.locals.image = image;

      MessageService.showDialog($event, webUriDialogConfig)
        .then(function (res) {
          if (res && res.triggerUpdate){
            refreshImages();
            $scope.$applyAsync();
          }
        });
    };

    vm.onDeleteImage = function ($event) {

      const image = vm.getImageById(vm.selectedImageId);

      if (!image.inUseByThemes) image.inUseByThemes = [];

      const currentInUseByThemes = image.inUseByThemes;

      const buildReadableImageKeyName = function (key) {
       
        switch (key){
          case 'cloudDashboardBackgroundImage':{
            return 'Cloud Dashboard Background';
          }
          case 'mainMenuImageiPadLandscape': {
            return 'iPad Landscape Background';
          }
          case 'mainMenuImageiPadPortrait':{
            return 'iPad Portrait Background';
          }
          case 'mainMenuImageiPhone': {
            return 'iPhone 5 - 8 Plus Portrait Background';
          }
          case 'mainMenuImageiPhone67': {
            return 'iPhone X - 15 Pro Max Portrait Background';
          }
        }
      };

      if (currentInUseByThemes.length > 1){
        return MessageService
          .confirm($event)
          .confirmAction({
            title: 'You Cannot Delete This Image!',
            htmlContent: `This image cannot be deleted due to it still being asociated to the following themes: 
            <ul>${currentInUseByThemes.map((theme)=> `<li><b>"${theme.name}"</b> - 
            ${theme.usedin.map((key)=> buildReadableImageKeyName(key)).join(', ')} ${theme.usedin.length > 1 ? 'images' : 'image'}</li>`)}
            </ul>. Please remove it from the themes listed above. You will then be able to delete it.`,
            okBtn: 'OKAY',
            cancelBtn: 'CLOSE'
          })
          .then(function () {
         
          })
          .catch(function () {});
      }

      const imageDeletionAndRemovalFromTheme = function () {
        return ImagesApiFactory.deleteImage(vm.selectedImageId)
          .then(function (refreshedImages){
            MessageService.showMessage('Image Item deleted');
            CurrentThemeFactory.removeImageReferenceFromCurrentTheme(vm.selectedImageId);
            vm.selectedImageId = null;
            $scope.$parent.$broadcast('zpSaveTheme');
            coreImages = refreshedImages;
            return refreshImages();
          });
      };

      if (currentInUseByThemes.length > 0){
        //used in current theme
        return MessageService
          .confirm($event)
          .confirmAction({
            title: 'Are you sure you wish to delete this image',
            htmlContent: `This image is still in use in the current theme -
            <b>"${CurrentThemeFactory.factoryData.currentThemeDoc.name}"</b>:<ul>
            ${currentInUseByThemes[0].usedin.map((key)=> `<li>${buildReadableImageKeyName(key)} image</li>`)}</ul>. 
            If you continue, all the references of the image above will be removed from the current theme`,
            okBtn: 'YES',
            cancelBtn: 'CANCEL'
          })
          .then(function () {
            return imageDeletionAndRemovalFromTheme();
          })
          .catch(function () {});
      }

      return MessageService
        .confirm($event)
        .delete('Are you sure you want to delete this image?')
        .then(function () {
          return imageDeletionAndRemovalFromTheme();
        })
        .catch(function () {});
    };

    vm.selectImage = function(image) {
      if (image._id === vm.selectedImageId) {
        vm.selectedImageId = null;
      } else {
        vm.selectedImageId = image._id;
      }

      if (vm.selectedImageId !== vm.initialSelectedImageId) {
        vm.selectionDirty = true;
      } else {
        vm.selectionDirty = false;
      }
    };

    vm.getImageById = function (imageId) {
      return coreImages.find(function (img) {
        return img._id === imageId;
      });
    };

    vm.applySelection = function () {
      const selectedImage = vm.getImageById(vm.selectedImageId);
      MessageService.closeDialog({
        selectedImage: selectedImage,
        themeImage: locals.imageObj
      });
    };

    vm.searchForImage = function () {
      const filteredImages = filterImages(coreImages, vm.imageSearchValue);
      const groupedImages = groupImagesForUI(filteredImages);
      vm.groupedImages = groupedImages;
    };

    vm.cancelDialog = function () {
      MessageService.cancelDialog();
    };

    vm.closeDialog = function () {
      MessageService.closeDialog();
    };

    //PRIVATE

    function saturateImages() {
      return ImagesApiFactory.getImageArtefactsForAccount()
        .then(function (imageDocs) {
          coreImages = imageDocs;

          return refreshImages();

        })
        .catch(function (err) {
          MessageService.showMessage(err);
        });
    }

    function refreshImages() {

      const filteredImages = filterImages(coreImages);
      const groupedImages = groupImagesForUI(filteredImages);

      const queuedImages = filteredImages.filter(function (image){
        return !image.loaded;
      });

      vm.groupedImages = groupedImages;

      // cross reference image id's with images in use elsewhere to notify user of dependencies. We don't want them deleting images blindly
      ImagesApiFactory.markImagesInUse(filteredImages);

      const promises = [];
      for (const image of queuedImages){
        const prom = new Promise(function (resolve){
          const img = new Image();
        
          img.onload = function () {
            image.width = img.width;
            image.height = img.height;
            image.loaded = true;
            resolve();
          };

          img.onerror = function () {
            img.src = $filter('cdnAssets')('/images/svgs/utilities/404/image-404.svg');
            image.src = img.src;
            image.loaded = true;
            resolve();
          };
  
          if (image._s3key){
            image.src = `https://s3.${awsStorageRegion}.amazonaws.com/${awsStorageBucketName}/${image._s3key}`;
          } else {
            image.src = image.weburi;
          }
  
          img.src = image.src;
        });

        promises.push(prom);
      }

      return Promise.all(promises)
        .then(function () {
          $scope.$applyAsync(function () {
            vm.loading = false;
          });
        });
    }

    function filterImages(images, searchTerm) {
      return _.chain(images)
        .filter(function(image) {
          if (!searchTerm) return true;
          return image.title.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
        })
        .sortBy('title')
        .value();
    }

    function groupImagesForUI(images) {
      const groupedImages = [];
      for (let i = 0; i < images.length; i += 3) {
        groupedImages.push(images.slice(i, i + 3));
      }
      return groupedImages;
    }

  }
}());

(function () {
  'use strict';
  angular
    .module('clients')
    .controller('WeburiImageFormDialogCtrl', ctrl);
  
  ctrl.$inject = ['MessageService', 'locals', 'uuidService', 'ImagesApiFactory'];
  /* ng-inject */
  function ctrl(MessageService, locals, uuidService, ImagesApiFactory) {
    var vm = this;

    vm.$onInit = function () {
      vm.locals = locals;
      if (vm.locals.image) {
        vm.imageTitle = vm.locals.image.title;
        vm.imageURL = vm.locals.image.weburi || null;
      }
    };

    vm.checkFormForDeltas = function () {
      if (!vm.locals.image) return true;
      //careful use of '===' because undefined is not the same as null with exact comparitor
      if (vm.imageTitle === vm.locals.image.title && vm.imageURL == vm.locals.image.weburi ) return false;
      return true;
    };

    vm.imageURLChanged = function () {
      const validURL = checkForURL(vm.imageURL);
      if (!validURL){
        vm.weburiImageForm.imageURL.$setValidity('invalid_url', false);
        return;
      }
      vm.weburiImageForm.imageURL.$setValidity('invalid_url', true);
      
      const validExtension = checkFileType(vm.imageURL);
      if (!validExtension){
        vm.weburiImageForm.imageURL.$setValidity('invalid_extension', false);
        return;
      }
      vm.weburiImageForm.imageURL.$setValidity('invalid_extension', true);
    };

    vm.saveForm = function (){
      vm.disableWebUriImageForm = true;

      let id = uuidService.getSingleNewBase64Key();
      if (vm.locals.image) id = vm.locals.image._id;

      const formData = {
        _id: id ,
        title: vm.imageTitle,
        weburi: vm.imageURL
      };

      ImagesApiFactory.ingestChangedImageItem(formData, 'weburi')
        .then(function () {
          if (vm.locals.image){
            MessageService.showMessage('Image Item updated');
          } else {
            MessageService.showMessage('Image Item added');
          }

          vm.locals.image.loaded = false;
          vm.closeDialog({
            triggerUpdate: true
          });
        })
        .catch(function (err) {
          vm.disableWebUriImageForm = false;
        });
    };

    vm.closeDialog = function (obj) {
      MessageService.closeDialog(obj);
    };


    //PRIVATE

    function checkForURL(value) {  
      try {
        new URL(value);
        return true;
      } catch (err) {
        if (value && value.length >= 1) {
          return false;
        }
      }
    }
  
    function checkFileType(value) {
  
      if (value && value.length >= 1) {
        const extension = getUrlExtension(value, ['jpg', 'jpeg', 'png', 'gif', 'bmp']);
        if (!extension || extension.length === 0) {
          return false;
        }

        return true;
      }

      function getUrlExtension(value, types) {
        const extension = value.split(/[#?]/)[0].split('.').pop().trim();

        if (extension && extension.length > 0) {
          for (const type of types) {
            if (type === extension) {
              return type;
            }
          }
        }

        return '';
      }
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('clients')
    .component('teamTreeElement', {
      templateUrl: 'app/clients/teams/tree/team-tree-element/view.tmpl.html',
      controller: 'TeamsTreeElementCtrl',
      bindings: {
        teams: '<',
        selectTeam: '&',
        toggleChevron: '&',
        parent: '<',
        level: '<',
        indexesToMiss: '<'
      },
      controllerAs: 'vm'
    })
    .controller('TeamsTreeElementCtrl', ctrl);

  ctrl.$inject = ['PermPermissionStore'];
  /* ng-inject */
  function ctrl(PermPermissionStore) {

    var vm = this;

    vm.myLevel = 0;
    vm.loopArray = [];
    vm.chevronMargin = 0;
    vm.indexesToMissArr = [];
    vm.isZuantAdmin = false;

    vm.$onInit = () => {
      vm.myLevel = parseInt(vm.level, 10) + 1;
      vm.chevronMargin = (parseInt(vm.level, 10) * 24) + 'px';
      vm.loopArray = new Array(vm.level);
      vm.indexesToMissArr = vm.indexesToMiss ? vm.indexesToMiss.split(',') : [];

      const isZuantAdminPermissionPromise = PermPermissionStore.getPermissionDefinition('ZUANT_ADMIN');
      isZuantAdminPermissionPromise.validatePermission()
        .then(() => vm.isZuantAdmin = true)
        .catch(() => vm.isZuantAdmin = false);
    };

    vm.calculateMargin = (index) => {
      return (parseInt(index + 1, 10) * 24) + 'px';
    };

    vm.calculateTeamMembersCount = (team) => {
      if (vm.isZuantAdmin) return team.members.length;
      return team.members.filter((member) => !member.staffUser).length;
    };

    vm.subTeamShouldShow = (subteams) => {
      subteams = subteams || [];
      let shouldShow = false;

      for (const subteam of subteams) {
        shouldShow = subteam.shouldShow || vm.subTeamShouldShow(subteam.treeSubteams);
        if (shouldShow) break;
      }
      return shouldShow;
    };

    vm.calculateIndexesToMiss = (last, index) => {
      const subIndexesToMiss = [];
      subIndexesToMiss.push.apply(subIndexesToMiss, vm.indexesToMissArr);
      if (last) subIndexesToMiss.push(index);
      return subIndexesToMiss.toString();
    };

    vm.shouldVerticalLineShow = (index) => {
      return vm.level > 0 && vm.indexesToMissArr.indexOf((index + 2).toString()) === -1;
    };

    return vm;
  }

})();


angular
  .module('clients')
  .controller('AddTeamCtrl', AddTeamCtrl);

AddTeamCtrl.$inject = ['MessageService', '$scope', 'hotkeys', 'team', 'parentTeam', 'teams'];
/* ng-inject */
function AddTeamCtrl(MessageService, $scope, hotkeys, team, parentTeam, teams) {

  var vm = this;

  vm.team = team;
  vm.parent = parentTeam || {};
  vm.teams = teams;

  vm.$onInit = () => {
    hotkeys.bindTo($scope)
      .add({
        combo: 'enter',
        description: 'Save',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: () => {
          vm.done(vm.editTeamForm);
        }
      });
  };

  vm.querySearch = (query) => {
    return query ? vm.teams.filter(team => team.name.toLowerCase().indexOf(query.toLowerCase()) > -1) : vm.teams;
  };

  vm.checkName = (form) => {
    let valid = true;
    if (vm.parent && vm.parent.subteams) {
      for (const team of vm.parent.subteams) {
        if (team.name !== vm.team.name) continue;

        valid = false;
        break;
      }
    } else {
      for (const team of vm.teams) {
        if (team._id !== vm.team._id) continue;

        valid = false;
        break;
      }
    }

    form.teamname.$setValidity('name', valid);
  };

  vm.selectedItemChange = (team) => {
    vm.team.name = team.name + ' copy';
  };

  vm.done = (form) => {
    if (!form.$valid) return;
    
    hotkeys.del('enter');
    MessageService.closeDialog({ team: vm.team, copy: vm.copy });
  };

  vm.cancel = () => {
    hotkeys.del('enter');
    MessageService.cancelDialog();
  };

}


angular
  .module('clients')
  .controller('RemoveTeamCtrl', RemoveTeamCtrl);

RemoveTeamCtrl.$inject = ['MessageService', '$scope', 'hotkeys', 'team'];
/* ng-inject */
function RemoveTeamCtrl(MessageService, $scope, hotkeys, team) {

  var vm = this;

  vm.team = team;
  vm.removalOption = 'removeall';

  vm.$onInit = () => {
    hotkeys.bindTo($scope)
      .add({
        combo: 'enter',
        description: 'Save',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: () => {
          vm.done();
        }
      });
  };

  vm.done = () => {
    hotkeys.del('enter');
    MessageService.closeDialog(vm.removalOption === 'removeall');
  };

  vm.cancel = () => {
    hotkeys.del('enter');
    MessageService.cancelDialog();
  };

}


angular
  .module('clients')
  .controller('RemoveSelectedTeamsCtrl', RemoveSelectedTeamsCtrl);

RemoveSelectedTeamsCtrl.$inject = ['MessageService', '$scope', 'hotkeys', 'team'];
/* ng-inject */
function RemoveSelectedTeamsCtrl(MessageService, $scope, hotkeys, team) {

  var vm = this;

  vm.team = team;
  vm.removalOption = 'removeall';

  vm.$onInit = () => {
    hotkeys.bindTo($scope)
      .add({
        combo: 'enter',
        description: 'Save',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: () => {
          vm.done();
        }
      });
  };

  vm.done = () => {
    hotkeys.del('enter');
    MessageService.closeDialog(vm.removalOption === 'removeall');
  };

  vm.cancel = () => {
    hotkeys.del('enter');
    MessageService.cancelDialog();
  };

}


angular
  .module('clients')
  .controller('EditTeamCtrl', EditTeamCtrl);

EditTeamCtrl.$inject = ['MessageService', '$scope', 'hotkeys', 'team', 'teams'];
/* ng-inject */
function EditTeamCtrl(MessageService, $scope, hotkeys, team, teams) {

  var vm = this;

  vm.team = angular.copy(team);
  vm.originalName = team.name;
  vm.teams = angular.copy(teams);
  vm.parent = null;

  vm.$onInit = () => {
    hotkeys.bindTo($scope)
      .add({
        combo: 'enter',
        description: 'Save',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: () => {
          vm.done();
        }
      });

    for (const t of teams) {
      if (t.subteams.indexOf(team._id) > -1) {
        vm.parent = t;
        break;
      }
    }

    const indexesToSplice = [];
    getIndexesToSplice(indexesToSplice, team._id);

    indexesToSplice.sort((a, b) => {
      return b - a;
    });

    for (const i of indexesToSplice) {
      vm.teams.splice(i, 1);
    }
  };

  const getIndexesToSplice = (indexesToSplice, id) => {

    for (let i = 0; i < vm.teams.length; i++) {
      if (vm.teams[i]._id !== id) continue;

      indexesToSplice.push(i);

      for (const subteam of vm.teams[i].subteams) {
        getIndexesToSplice(indexesToSplice, subteam);
      }
    }
  };

  vm.querySearch = (query) => {
    return query ? vm.teams.filter(team => team.name.toLowerCase().indexOf(query.toLowerCase()) > -1) : vm.teams;
  };

  vm.done = () => {
    if (vm.team.name.length === 0) return;
    
    hotkeys.del('enter');
    if (vm.parent) vm.team.parentId = vm.parent._id;
    MessageService.closeDialog(vm.team);
  };

  vm.cancel = () => {
    hotkeys.del('enter');
    MessageService.cancelDialog();
  };

}


angular
  .module('clients')
  .controller('AddUsersCtrl', AddUsersCtrl);

AddUsersCtrl.$inject = ['MessageService', '$scope', 'hotkeys', 'PermPermissionStore', 'UserFactory', 'team'];
/* ng-inject */
function AddUsersCtrl(MessageService, $scope, hotkeys, PermPermissionStore, UserFactory, team) {

  var vm = this;

  vm.team = angular.copy(team);
  vm.users = [];
  vm.filter = '';

  vm.userSelectAll = false;
  vm.privateSelectAll = false;
  vm.managerSelectAll = false;

  vm.$onInit = () => {

    hotkeys.bindTo($scope)
      .add({
        combo: 'enter',
        description: 'Save',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: () => {
          vm.done();
        }
      });

    const isZuantAdminPermissionPromise = PermPermissionStore.getPermissionDefinition('ZUANT_ADMIN');
    return isZuantAdminPermissionPromise.validatePermission()
      .then(() => true)
      .catch(() => false)
      .then((isZuantAdmin) => {
        return UserFactory.getUserList()
          .then((factoryData) => {
            const users = _.chain(factoryData)
              .thru((data) => {
                return isZuantAdmin ? _.get(data, 'combinedUsers', []) : _.get(data, 'items', []);
              })
              .map(itm => itm.user)
              .value();

            vm.users = _.map(users, (user) => {
              return {
                _id: user._id,
                name: user.firstname.raw + ' ' + user.surname.raw,
                selected: false,
                disabled: false
              };
            });

            markPreselectedUsersAsDisabled();
          });
      });
  };


  vm.checkSelectAllState = user => {
    if (!user.selected) {
      vm.userSelectAll = false;
      return;
    }


    // check if everyone that can be selected is selected to toggle the select all button
    let canTurnOnSelectAll = true;
    for (const user of vm.users) {
      if (user.disabled || user.selected) continue;
      
      canTurnOnSelectAll = false;
      break;
    }

    if (canTurnOnSelectAll) {
      vm.userSelectAll = true;
    }
  };

  vm.selectUser = (user) => {
    if (user.disabled) return;

    user.selected = !user.selected;
    vm.checkSelectAllState(user);
  };

  vm.done = () => {
    hotkeys.del('enter');

    const users = [];
    for (const user of vm.users) {
      if (!user.selected || user.disabled) continue;

      users.push({ id: user._id, name: user.name, private: user.private, manager: user.manager });
    }

    MessageService.closeDialog(users);
  };

  vm.cancel = () => {
    hotkeys.del('enter');
    MessageService.cancelDialog();
  };

  vm.selectAllUsers = () => {
    for (const user of vm.users) {
      if (!user.disabled && (vm.filter === '' || user.name.toLowerCase().indexOf(vm.filter.toLowerCase()) > -1)) {
        user.selected = vm.userSelectAll;
      }
    }
  };

  vm.setAllMembersFlag = (flag, value) => {
    for (const user of vm.users) {
      if (!user.disabled && (vm.filter === '' || user.name.toLowerCase().indexOf(vm.filter.toLowerCase()) > -1)) {
        user[flag] = value;
      }
    }
  };

  const markPreselectedUsersAsDisabled = () => {
    for (const user of vm.users) {
      for (const existingUser of vm.team.members) {
        if (user._id !== existingUser.userid) continue;
        
        user.disabled = true;
        user.selected = true;
        user.private = existingUser.private;
        user.manager = existingUser.manager;
        break;
      }
    }
  };

}

(function () {
  'use strict';
  
  angular
    .module('clients')
    .component('zpClientEmailTemplateNavigation', {
      controller: 'ClientEmailTemplateNavigationCtrl',
      templateUrl: 'app/clients/email-templates/detail/zp-client-email-template/zp-client-email-template.tmpl.html',
      bindings: {
        rootStatePath: '@'
      }
    })
    .controller('ClientEmailTemplateNavigationCtrl', ctrl);
  
  ctrl.$inject = ['$state'];
  /* ng-inject */
  function ctrl($state) {
    var vm = this;

    vm.goBack = function () {
      $state.go(`${vm.rootStatePath}.home`);
    };
  }
})();
  
(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpClientEmailTemplateSettings', {
      controller: 'ClientEmailTemplateSettingsController',
      templateUrl: 'app/clients/email-templates/detail/zp-client-email-template-settings/zp-client-email-template-settings.tmpl.html',
      bindings: {
        rootStatePath: '@'
      }
    })
    .controller('ClientEmailTemplateSettingsController', ctrl);

  ctrl.$inject = ['$scope', 'CurrentClientEmailTemplateFactory', 'MessageService', 'hotkeys', 'ChangeDelta', '$state', 'UserService'];
  /* ng-inject */
  function ctrl($scope, CurrentClientEmailTemplateFactory, MessageService, hotkeys, ChangeDelta, $state, UserService) {
    var vm = this;
    
    vm.copyOfEditorText = '';
    vm.isClientMarketpoint = false;

    vm.changes = ChangeDelta.getDeltaObject();

    // INSTANCE TOOLBAR CONFIG
    vm.menuOptions = [{
      onClick: 'deleteTemplate',
      ariaLabel: function () {
        return 'Delete Template';
      },
      icon: function () {
        return 'zmdi zmdi-delete';
      },
      label: function () {
        return 'Delete Template';
      }
    }];

    vm.$onInit = function () {

      $scope.$watch(ChangeDelta.getDeltaObject, function (newDeltaObj) {
        vm.changes = newDeltaObj;
      }, true);

      vm.clientEmailTemplate = CurrentClientEmailTemplateFactory.getCurrentTemplateCache();
      vm.isClientMarketpoint = UserService.isClientMarketpoint();

      //setup Ui strings
      vm.prettyTemplateName = derrivePrettyTemplateName(vm.clientEmailTemplate.type, vm.clientEmailTemplate.global);
      vm.prettyTemplateLogo = derrivePrettyTemplateLogo(vm.clientEmailTemplate.type, vm.clientEmailTemplate.global);

      // setup change delta
      ChangeDelta.clear();
      vm.changeDelta = ChangeDelta;
      vm.lastSavedStateOfEmailTemplate = angular.copy(vm.clientEmailTemplate);
      $scope.$on('deleteTemplate', vm.deleteTemplate);
      $scope.$on('zpSaveClientEmailTemplate', vm.save);

      hotkeys.bindTo($scope)
        .add({
          combo: 'ctrl+s',
          description: 'Save template',
          allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
          callback: function () {
            vm.save();
          }
        });

    };

    vm.save = function(ev) {
      CurrentClientEmailTemplateFactory.updateData(ev)
        .then(function () {
          vm.copyOfEditorText = vm.clientEmailTemplate.emailtemplatetext;
          vm.lastSavedStateOfEmailTemplate = angular.copy(vm.clientEmailTemplate);
        })
        .catch(function (err) {
          if (err.saveCancelled) MessageService.showMessage('Save cancelled');
        });
    };

    vm.updateChangeDelta = function (property, newValue) {
      var oldValue = vm.lastSavedStateOfEmailTemplate[property];
      ChangeDelta.recordValueChange({
        oldval: oldValue,
        newval: newValue,
        objectid: vm.clientEmailTemplate._id,
        collection: 'emailtemplates',
        databasefieldname: property
      });
    };

    vm.deleteTemplate = function (zpEvent, srcEvent) {
      MessageService
        .confirm(srcEvent)
        .delete('Are you sure you want to delete this template?')
        .then(function () {
          CurrentClientEmailTemplateFactory.deleteTemplate(vm.clientEmailTemplate._id)
            .then(function () {
              $state.go(`${vm.rootStatePath}.home`);
            });
        })
        .catch(function () {
          //dialog canceled no worries
        });
    };

    vm.sendTestEmail = function () {
      vm.clientEmailTemplate._lastTestEmailSentDate = new Date();
      var dataToSave = {
        _id: vm.clientEmailTemplate._id,
        _lastTestEmailSentDate: vm.clientEmailTemplate._lastTestEmailSentDate
      };
      CurrentClientEmailTemplateFactory
        .sendTestEmail(dataToSave)
        .then(function () {
          MessageService.showMessage('Test email sent');
        })
        .catch(function (err) {
          MessageService.showMessage('Error sending test email: ' + err);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };
    
  }

  function derrivePrettyTemplateName(templateStr, global){

    switch (templateStr){
      case 'welcome_template':{
        if (!global) return 'Welcome Email Template';
        return 'Global Welcome Email Template';
      }
      case 'password_reset_template':{
        if (!global) return 'Password Reset Email Template';
        return 'Global Password Reset Email Template';
      }
    }
  }

  function derrivePrettyTemplateLogo(templateStr, global){
    switch (templateStr){
      case 'welcome_template':{
        if (!global) return 'contact_mail';
        return 'public';
      }
      case 'password_reset_template':{
        if (!global) return 'password';
        return 'vpn_lock';
      }
    }
  }
})();

(function () {

  'use strict';

  angular
    .module('clients')
    .component('zpClientEmailTemplateInsights', {
      templateUrl: 'app/clients/email-templates/detail/zp-client-email-template-insights/zp-client-email-template-insights.tmpl.html',
      controller: 'ClientEmailTemplateInsightsCtrl',
      bindings: {
        emailTemplateId: '<',
        rootStatePath: '@'
      }
    })
    .controller('ClientEmailTemplateInsightsCtrl', controller);

  controller.$inject = ['ChartsFactory', 'ChartsExportFactory', 'CurrentClientEmailTemplateFactory', 'MessageService', 'localStorageService'];
  /* ng-inject */
  function controller(ChartsFactory, ChartsExportFactory, CurrentClientEmailTemplateFactory, MessageService, localStorage) {

    var vm = this;
    vm.loading = true;

    vm.showTitle = true;
    vm.currentSchema = 'Days';
    vm.pickerSchema = 'day';

    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    vm.customRange = {
      startdate: new Date(),
      enddate: new Date(),
      maxdate: tomorrow
    };

    vm.mindate = new Date(moment('01/01/2000'));

    vm.chartInfo = {
      total: 0,
      events: {
        delivered: 0,
        opened: 0,
        clicked: 0,
        unsubscribed: 0,
        permanent_fail: 0,
        temporary_fail: 0,
        complained: 0,
        failed: 0
      },
      chartOptions: {
        legend: { display: true }

      }
    };

    vm.$onInit = function () {
      MessageService.pushEventToIntercom('email_insights_tab', {
        emailTemplateId: vm.emailTemplateId
      });
      vm.aggregatedResponses = ChartsFactory.getChartOptions();
      getChartData();
    };

    function getChartData() {
      const chartParams = localStorage.get('individual_client_email_template_sends');
      if (chartParams) {
        if (!chartParams.currentSchema) chartParams.currentSchema = vm.currentSchema;
        return getChartDataFor(chartParams.chartId, new Date(chartParams.rangeStart), new Date(chartParams.rangeEnd), chartParams.currentSchema);
      }
      const initParams = {
        chartId: 'individual_client_email_template_sends',
        rangeStart: getPreviousMonthDate(),
        rangeEnd: daysAgoToDate(0),
        currentSchema: vm.currentSchema
      };
      vm.showTitle = true;
      return getChartDataFor(initParams.chartId, new Date(initParams.rangeStart), new Date(initParams.rangeEnd), initParams.currentSchema);
    }

    function getChartDataFor(chartId, rangeStart, rangeEnd, schema) {
      vm.currentSchema = schema;
      ChartsFactory.getChartData(chartId, rangeStart, rangeEnd, vm.emailTemplateId, schema)
        .then(function (res) {
          setLocalStorage(chartId, rangeStart, rangeEnd, schema);
          vm.customRange.startdate = rangeStart;
          vm.customRange.enddate = rangeEnd;
          vm.chartInfo = _.extend(vm.chartInfo, res);
          vm.chartInfo.metadata.title = 'Total emails sent with this template for past ' + vm.chartInfo.metadata.title + ' days';
          vm.loading = false;
          vm.bucketLoading = false;
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    }

    vm.changeChartRange = function (parameters) {

      // menu callback function
      if (parameters.selectedMenuItem.menuCommand == 'Export') {
        //get chart title from cache
        const template_name = (CurrentClientEmailTemplateFactory.getCurrentTemplateCache().title).replace(' ', '_');
        //export here
        ChartsExportFactory.downloadChartExport(vm.customRange.startdate, vm.customRange.enddate, vm.emailTemplateId, vm.currentSchema, 'individual_client_email_template_sends', 'Emails sent for template ' + template_name);
      }
      else {
        vm.bucketLoading = true;
        vm.showCustomDates = true;
        vm.showTitle = true;
        vm.currentSchema = parameters.selectedMenuItem.menuCommand;
        getChartDataFor('individual_client_email_template_sends', vm.customRange.startdate, vm.customRange.enddate, vm.currentSchema);
        if (vm.currentSchema == 'Months' || vm.currentSchema == 'Quarters' || vm.currentSchema == 'Years') {
          vm.pickerSchema = 'month';
        }
        else {
          vm.pickerSchema = 'day';
        }
      }

    };

    vm.applyCustomDates = function () {
      vm.bucketLoading = true;
      vm.customRange.startdate = new Date(moment(vm.customRange.startdate).startOf('day').toISOString());
      vm.customRange.enddate = new Date(moment(vm.customRange.enddate).endOf('day').toISOString());
      getChartDataFor('individual_client_email_template_sends', vm.customRange.startdate, vm.customRange.enddate, vm.currentSchema);
    };

    function daysAgoToDate(days) {
      const date = moment().subtract(days, 'days').startOf('day');
      return new Date(date);
    }

    function getPreviousMonthDate() {
      const date = moment().subtract(1, 'months').add(1, 'days').startOf('day');
      return new Date(date);
    }

    function setLocalStorage(chartId, rangeStart, rangeEnd, scheme) {
      localStorage.set(chartId, { chartId: chartId, rangeStart: rangeStart, rangeEnd: rangeEnd, currentSchema: scheme });
    }
  }

})();
(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpClientEmailTemplateEditor', {
      controller: 'ClientEmailTemplateEditorCtrl',
      templateUrl: 'app/clients/email-templates/detail/zp-client-email-template-editor/zp-client-email-template-editor.tmpl.html',
      bindings: {
        rootStatePath: '@'
      }
    })
    .controller('ClientEmailTemplateEditorCtrl', ctrl);

  ctrl.$inject = ['$sce', '$scope', 'CurrentClientEmailTemplateFactory', 'hotkeys', 'ChangeDelta', '$timeout', 'UserService'];
  /* ng-inject */
  function ctrl($sce, $scope, CurrentClientEmailTemplateFactory, hotkeys, ChangeDelta, $timeout, UserService) {

    var vm = this;

    vm.isClientMarketpoint = false;

    var ckEditorDirtyFlag = false;
    var copyOfEditorText;

    vm.editorPlugins = ['logo','autogrow','placeholder','font','colorbutton','stickyToolbar','contentEditable'];

    vm.$onInit = function () {
      vm.isClientMarketpoint = UserService.isClientMarketpoint();
      vm.emailTemplate = CurrentClientEmailTemplateFactory.getCurrentTemplateCache();
      vm.templateAsHtml = $sce.trustAsHtml(vm.emailTemplate.emailtemplatetext);
      // setup change delta
      ChangeDelta.clear();
      vm.changeDelta = ChangeDelta;
      vm.lastSavedStateOfEmailTemplate = angular.copy(vm.emailTemplate);

      hotkeys.bindTo($scope)
        .add({
          combo: 'ctrl+s',
          description: 'Save template',
          allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
          callback: function () {
            vm.save();
          }
        });
    };

    vm.editorChange = function() {
      if (!ckEditorDirtyFlag) {
        copyOfEditorText = angular.copy(vm.emailTemplate.emailtemplatetext);
        ckEditorDirtyFlag = true;
        return;
      }
      const oldValue = copyOfEditorText;

      ChangeDelta.recordValueChange({
        oldval: oldValue,
        newval: vm.emailTemplate.emailtemplatetext,
        objectid: vm.emailTemplate._id,
        collection: 'emailtemplates',
        databasefieldname: 'emailtemplatetext'
      });
    };

    $scope.$on('zp.ckEditorMode', function (e, params) {
      $timeout(function () {
        vm.saveDisabled = params.message == 'source' ? true : false;
      }, 50);
    });

    vm.save = function () {
      CurrentClientEmailTemplateFactory.updateData()
        .then(function () {
          copyOfEditorText = vm.emailTemplate.emailtemplatetext;
          vm.lastSavedStateOfEmailTemplate = angular.copy(vm.emailTemplate);
        });
    };

    $scope.$on('zpSaveClientEmailTemplate', vm.save);

  }
})();

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpSaveClientEmailTemplateFab', {
      templateUrl: 'app/clients/email-templates/detail/fab/fab.tmpl.html',
      controller: 'zpSaveClientEmailTemplateFabCtrl'
    })
    .controller('zpSaveClientEmailTemplateFabCtrl', ctrl);

  ctrl.$inject = ['$scope', 'ChangeDelta'];
  /* nj-inject */
  function ctrl($scope, ChangeDelta) {

    var vm = this;

    vm.$onInit = function () {
      vm.changeDelta = ChangeDelta;
    };

    vm.save = function (){
      $scope.$emit('zp.message', {
        level: 'broadcast',
        page: 'foo',
        eventName: 'zpSaveClientEmailTemplate'
      });
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpClientEmailTemplatesWidgetContainer', {
      templateUrl: 'app/clients/email-templates/main/zp-client-email-templates-widget-container/zp-client-email-templates-widget-container.tmpl.html',
      controller: 'ClientEmailTemplatesWidgetContainerCtrl',
      bindings: {}
    })
    .controller('ClientEmailTemplatesWidgetContainerCtrl', controller);

  controller.$inject = ['ClientEmailTemplatesFactory', 'ChartsFactory', 'ChartsExportFactory', 'MessageService', 'localStorageService'];
  /* ng-inject */
  function controller(ClientEmailTemplatesFactory, ChartsFactory, ChartsExportFactory, MessageService, localStorage) {

    var vm = this;
    vm.loading = true;
    vm.showTitle = true;
    vm.chartInfo = {
      total: 0,
      weektotal: 0,
      chartOptions: {
        legend: {}
      }
    };

    vm.weekTotalWidgetTitle = 'TOTAL EMAILS SENT THIS WEEK';
    vm.currentSchema = 'Days';
    vm.pickerSchema = 'day';
    vm.currentlySelectedChartType = 'global';

    let today = new Date();
    let tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const avaliableChartTypes = ['global', 'welcome_template', 'password_reset_template'];

    vm.customRange = {
      startdate: new Date(),
      enddate: new Date(),
      maxdate: tomorrow
    };

    vm.mindate = new Date(moment('01/01/2000'));

    vm.$onInit = function () {
      vm.data = ClientEmailTemplatesFactory.getData();
      vm.aggregatedResponses = ChartsFactory.getChartOptions();
      getChartData();
    };

    function getChartData() {
      let chartParams = localStorage.get('aggregated_client_email_template_sends');
      if (!chartParams) {
        vm.showTitle = true;

        chartParams = {
          chartId: 'aggregated_client_email_template_sends',
          rangeStart: getPreviousMonthDate(),
          rangeEnd: daysAgoToDate(0),
          currentSchema: vm.currentSchema,
          selectedChartType: vm.currentlySelectedChartType
        };
      }

      getChartDataFor(chartParams.chartId, new Date(chartParams.rangeStart), new Date(chartParams.rangeEnd), chartParams.selectedChartType, chartParams.currentSchema);
    }
    
    function getChartDataFor(chartId, rangeStart, rangeEnd, selectedChartType, schema) {
      vm.currentSchema = schema;
      ChartsFactory.getChartData(chartId, rangeStart, rangeEnd, selectedChartType, schema)
        .then(function (res) {
          setLocalStorage(chartId, rangeStart, rangeEnd, selectedChartType, schema);
          vm.currentlySelectedChartType = selectedChartType;
          vm.customRange.startdate = rangeStart;
          vm.customRange.enddate = rangeEnd;
          vm.chartInfo = _.extend(vm.chartInfo, res);
          vm.chartInfo.metadata.title = buildChartTitle();
          vm.weekTotalWidgetTitle = buildWidgetTitle();
          vm.leadTotalForQuery = res.total;
          vm.loading = false;
          vm.bucketLoading = false;
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    }

    function buildChartTitle() {
      let correctSchemaTense = vm.currentSchema.toLowerCase();
      if (vm.chartInfo.labels.length == 1) correctSchemaTense = correctSchemaTense.substring(0, correctSchemaTense.length - 1);

      let headline = '';
      if (vm.currentlySelectedChartType === 'welcome_template'){
        headline = 'welcome ';
      } else if (vm.currentlySelectedChartType === 'password_reset_template'){
        headline = 'password ';
      }

      return 'Total ' + headline + 'emails sent for past ' + vm.chartInfo.labels.length + ' ' + correctSchemaTense;
    }

    function buildWidgetTitle() {
      if (vm.currentlySelectedChartType === 'welcome_template'){
        return 'WELCOME EMAILS SENT THIS WEEK';
      } else if (vm.currentlySelectedChartType === 'password_reset_template'){
        return 'PASSWORD RESET EMAILS SENT THIS WEEK';
      }

      return 'TOTAL EMAILS SENT THIS WEEK';
    }

    vm.changeChartRange = function (parameters) {
      // menu callback function
      if (parameters.selectedMenuItem.menuCommand == 'Export') {
        //export here
        ChartsExportFactory.downloadChartExport(vm.customRange.startdate, vm.customRange.enddate, null, vm.currentSchema, 'aggregated_client_email_template_sends', 'Emails');
      }
      else {
        vm.bucketLoading = true;
        vm.showCustomDates = true;
        vm.showTitle = true;
        vm.currentSchema = parameters.selectedMenuItem.menuCommand;
        getChartDataFor('aggregated_client_email_template_sends', vm.customRange.startdate, vm.customRange.enddate, vm.currentlySelectedChartType, vm.currentSchema);
        if (vm.currentSchema == 'Months' || vm.currentSchema == 'Quarters' || vm.currentSchema == 'Years') {
          vm.pickerSchema = 'month';
        }
        else {
          vm.pickerSchema = 'day';
        }
      }
    };

    vm.applyCustomDates = function () {
      if (moment(vm.customRange.startdate, 'MM/DD/YYYY', true).isValid() && moment(vm.customRange.enddate, 'MM/DD/YYYY', true).isValid())
        vm.bucketLoading = true;
      vm.customRange.startdate = new Date(moment(vm.customRange.startdate).startOf('day').toISOString());
      vm.customRange.enddate = new Date(moment(vm.customRange.enddate).endOf('day').toISOString());

      getChartDataFor('aggregated_client_email_template_sends', vm.customRange.startdate, vm.customRange.enddate, vm.currentlySelectedChartType, vm.currentSchema);
    };

    vm.toggleReportSize = function () {
      const currentlySelectedChartTypeIndex = avaliableChartTypes.indexOf(vm.currentlySelectedChartType);
      const newSelectedChartTypeIndex = ((currentlySelectedChartTypeIndex + 1) > avaliableChartTypes.length -1) ? 0 : (currentlySelectedChartTypeIndex + 1);
      vm.currentlySelectedChartType = avaliableChartTypes[newSelectedChartTypeIndex];

      getChartDataFor('aggregated_client_email_template_sends', vm.customRange.startdate, vm.customRange.enddate, vm.currentlySelectedChartType, vm.currentSchema);
    };

    function daysAgoToDate(days) {
      const date = moment().subtract(days, 'days').startOf('day');
      return new Date(date);
    }

    function getPreviousMonthDate() {
      const date = moment().subtract(1, 'months').add(1, 'days').startOf('day');
      return new Date(date);
    }

    function setLocalStorage(chartId, rangeStart, rangeEnd, selectedChartType, schema) {
      localStorage.set(chartId, { chartId: chartId, rangeStart: rangeStart, rangeEnd: rangeEnd, selectedChartType: selectedChartType, currentSchema: schema });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpClientEmailTemplatesSearchToolbar', {
      templateUrl: 'app/clients/email-templates/main/zp-client-email-templates-search-toolbar/zp-client-email-templates-search-toolbar.component.tmpl.html',
      controller: 'ClientsEmailTemplatesSearchToolbarCtrl',
      bindings: {}
    })
    .controller('ClientsEmailTemplatesSearchToolbarCtrl', controller);

  controller.$inject = ['ClientEmailTemplatesMainMetadata'];
  /* ng-inject */
  function controller(ClientEmailTemplatesMainMetadata) {

    var vm = this;

    vm.$onInit = function () {
      vm.metadata = ClientEmailTemplatesMainMetadata.getData();
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpClientEmailTemplateSelectControl', {
      templateUrl: 'app/clients/email-templates/main/zp-client-email-template-select-control/zp-client-email-template-select-control.tmpl.html',
      controller: 'ClientEmailTemplateSelectCtrl',
      bindings: {
        model: '<',
        onChange: '&',
        config: '<',
        disabled: '<',
        context: '<',
        items: '<'
      }
    })
    .controller('ClientEmailTemplateSelectCtrl', controller);

  controller.$inject = ['ClientEmailTemplatesFactory', 'MessageService', 'SessionService'];
  /* ng-inject */
  function controller(ClientEmailTemplatesFactory, MessageService, SessionService) {

    var vm = this;
    vm.searchText = '';
    vm.searchText = '';
    vm.selectedItem;

    vm.$onInit = function () {
      vm.session = SessionService;

      if (vm.items) return;

      ClientEmailTemplatesFactory.getTemplatesList()
        .then(function (resp) {
          vm.items = _.extend(vm.items, _.chain(resp.items)
            .map(function (obj) {
              return {
                _id: obj.emailtemplate._id,
                type: obj.emailtemplate.type.raw,
                title: obj.emailtemplate.title.raw
              };
            })
            .sortBy('type')
            .reverse()
            .value());
          locateSelectedItem();
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };

    vm.$onChanges = function (changes) {
      if (changes.model && changes.model.isFirstChange()) {
        return;
      }
      if (changes.model) {
        vm.model = changes.model.currentValue;
        locateSelectedItem();
      }
    };

    vm.onChangeLocal = function (item) {
      vm.onChange(item);
    };

    function locateSelectedItem() {
      var selectedItem = _.filter(vm.items, function (o) {
        return o._id == vm.model;
      });
      vm.selectedItem = selectedItem[0];

    }

    // md-autocomplete function
    vm.querySearch = function (query) {
      return query ? vm.items.filter(createFilter(query)) : vm.items;
    };

    /**
     * Create filter function for a query string
     */
    function createFilter(query) {
      const lowercaseQuery = query.toLowerCase();
      return function filterFn(item) {
        return (item.title.toLowerCase().search(lowercaseQuery) != -1);
      };
    }
  }
}());

/**
 * Created by davidbeazer on 21/11s/2016.
 */
(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpClientEmailTemplateList', {
      controller: 'ClientEmailTemplateListController',
      templateUrl: 'app/clients/email-templates/main/zp-client-email-template-list/zp-client-email-template-list.tmpl.html',
      bindings: {
        rootStatePath: '@'
      }
    })
    .controller('ClientEmailTemplateListController', ctrl);

  ctrl.$inject = ['$state', 'ClientEmailTemplatesFactory', 'ClientEmailTemplatesMainMetadata', 'PaginationManager', 'GridDataFactory', 'localStorageService', 'SearchValFactory'];
  /* ng-inject */
  function ctrl($state, ClientEmailTemplatesFactory, ClientEmailTemplatesMainMetadata, PaginationManager, GridDataFactory, localStorageService, SearchValFactory) {

    var vm = this;

    vm.data = {
      items: []
    };

    vm.$onInit = function () {
      vm.data = _.extend({}, vm.data, ClientEmailTemplatesFactory.getData());
      vm.blankSlate = !vm.data.items.length;
      vm.totalRows = vm.data.items.length;
      vm.hideArchivedTemplates = localStorageService.get('hideArchivedTemplates');
      vm.metadata = ClientEmailTemplatesMainMetadata.getData();
      vm.search = SearchValFactory.get(vm.metadata.id);
      GridDataFactory.hydrateData(ClientEmailTemplatesFactory.factoryData, vm.metadata.id);
      PaginationManager.setQuery(vm.metadata.query, vm.metadata.id);
    };

    vm.goto = function (_id) {
      $state.go(`${vm.rootStatePath}.email_edit.settings`, { _emailid: _id});
    };

    // PAGINATION
    vm.logPagination = function (page, limit) {
      vm.metadata.query.page = page;
      vm.metadata.query.limit = limit;
      PaginationManager.setQuery(vm.metadata.query, vm.metadata.id);
      $('md-content').animate({ scrollTop: 0 }, 0);
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpAddClientEmailTemplateFab', {
      templateUrl: 'app/clients/email-templates/main/zp-add-client-email-template-fab/zp-add-client-email-template-fab.tmpl.html',
      controller: 'zpAddClientEmailTemplateFabCtrl',
      bindings: {
        rootStatePath: '@'
      }
    })
    .controller('zpAddClientEmailTemplateFabCtrl', ctrl);

  ctrl.$inject = ['ClientEmailTemplatesFactory', 'ClientEmailTemplatesMainMetadata', 'MasterPermissionsDefinitionFactory'];
  /* nj-inject */
  function ctrl(ClientEmailTemplatesFactory, ClientEmailTemplatesMainMetadata, MasterPermissionsDefinitionFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.data = ClientEmailTemplatesFactory.getData();
      vm.metadata = ClientEmailTemplatesMainMetadata.getData();
      vm.permissions = MasterPermissionsDefinitionFactory;
      
      vm.metadata.fabDialogConfig.locals.rootStatePath = vm.rootStatePath;
    };
  }

})();

/**
 * Created by davidbeazer on 21/11/2016.
 */
'use strict';

angular
  .module('clients')
  .controller('AddClientEmailTemplateDialogController', AddClientEmailTemplateDialogController);

AddClientEmailTemplateDialogController.$inject = ['$scope', 'locals', 'ClientEmailTemplatesFactory', 'MessageService', 'uuidService', 'hotkeys', '$state'];
/* ng-inject */
function AddClientEmailTemplateDialogController($scope, locals, ClientEmailTemplatesFactory, MessageService, uuid, hotkeys, $state) {

  var vm = this;

  vm.clientEmailTemplates = [];

  vm.templateOptionTypes = [
    {
      name: 'Welcome Template',
      value: 'welcome_template'
    },
    {
      name: 'Password Reset Template',
      value: 'password_reset_template'
    }
  ];

  vm.emailTemplateConfig = {
    placeholder: 'Pick an email template for this form',
    floatingLabel: 'Email template',
    required: true
  };

  vm.$onInit = function() {
    initialiseNewEmailTemplateObject();
    bindhotkeys();

    vm.clientEmailTemplates = _.chain(ClientEmailTemplatesFactory.getData().itemsObject)
      .map(function (item) {
        return {
          _id: item.emailtemplate._id,
          title: item.emailtemplate.title,
          type: item.emailtemplate.type
        };
      })
      .sortBy('type')
      .reverse()
      .value();
  };

  function initialiseNewEmailTemplateObject() {
    const newId = uuid.getSingleNewBase64Key();
    vm.templateDoc = {
      _id: newId,
      title: '',
      emailtemplatesubject: '',
      emailtemplatetext: '',
      active: 0,
      type: ''
    };
    vm.templateSource = 'new';
  }

  function bindhotkeys() {
    hotkeys.bindTo($scope)
      .add({
        combo: 'enter',
        description: 'Save',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function () {
          vm.submit();
        }
      });
  }

  vm.setCloneTemplateId = function (selected) {
    vm.templateDoc._cloneSourceTemplateId = selected.item._id;
  };

  vm.templateTitleChanged = function() {
    if (!vm.templateDoc.title) {
      vm.emailTemplateForm.title.$setValidity('templateTitleExists', false);
      return;
    }

    for (const templateItm of vm.clientEmailTemplates) {
      if (templateItm.title.toLowerCase() === vm.templateDoc.title.toLowerCase()) {
        vm.emailTemplateForm.title.$setValidity('templateTitleExists', false);
        return;
      }
    }

    vm.emailTemplateForm.title.$setValidity('templateTitleExists', true);

  };

  vm.submit = function () {
    vm.submitBtnDisabled = true;

    if (vm.templateSource === 'new') {
      delete vm.templateDoc._cloneSourceTemplateId;
    } else {
      vm.templateDoc.emailtemplatesubject = '';
    }

    ClientEmailTemplatesFactory.createNewTemplate(vm.templateDoc)
      .then(function () {
        MessageService.showMessage('Welcome Email Template added');
        vm.submitBtnDisabled = false;
        $state.go(`${locals.rootStatePath}.email_edit.settings`, {
          _emailid: vm.templateDoc._id
        });
        vm.hide();
      })
      .catch(function (err) {
        MessageService.showMessage(err.data.data.message);
        MessageService.writeLog({
          level: 'error',
          msg: err
        });

      });
  };

  // modal dismiss functions
  vm.hide = function () {
    MessageService.closeDialog();
  };

  vm.cancelDialog = function () {
    MessageService.cancelDialog();
  };

}

/**
 * Created by davidfm on 13/03/2018.
 */

(function () {
  'use strict';
  angular.module('clients')
    .component('zpDataWorkflow', {
      templateUrl: 'app/clients/dialogs/client-operations-dialog/data-workflow/data-workflow.component.tmpl.html',
      controller: 'dataWorkFlowCtrl',
      bindings: {
      }
    })
    .controller('dataWorkFlowCtrl', ctrl);
  
  ctrl.$inject = ['workflowFactory', 'MessageService', '$document'];
  /* ng-inject */
  function ctrl(workflowFactory, MessageService, $document) {
  
    var vm = this;
  
    vm.workflowFactory = workflowFactory;
  
    vm.$onInit = function () {
      workflowFactory.setTasks(vm.tasks);
    };

    vm.onCardPopulated = function (){
      MessageService.showDialog(null, {
        controller: 'zpDataWorkflowFieldMapping as $ctrl',
        templateUrl: 'app/clients/dialogs/client-operations-dialog/data-workflow/data-workflow-field-mapping.component.tmpl.html',
        parent: angular.element($document.body),
        locals: {},
        clickOutsideToClose: false,
        useFullScreen: true,
        allowMultiple: true
      });
    };
  
    vm.tasks = [{
      mission: {
        type: 'compliance',
        subType: 'redact',
        activationRules: {
          remoteNodesShouldWaitForServerCompletion: true,
          remoteNodesShouldWaitForSyncCompletion: false
        }
      },
      steps: [
        {
          title: 'Choose Field Mapping',
          description: 'Create new Field Mapping card',
          colour: 'green',
          newText: 'Choose a MAPPING',
          cardName: 'Field Mapping',
          cardType: 'redactionmapping',
          fetchCards: false,
          singleCard: true,
          data: {
            systemA: 'form',
            systemB: 'redact'
          },
          cardOptional: false
        }]
    }];
  
  
  }
})();
  
/**
 * Created by davidfm on 13/03/2018.
 */

(function () {
  'use strict';
  angular.module('clients')
    .controller('zpDataWorkflowFieldMapping', ctrl);
    
  ctrl.$inject = ['workflowFactory', 'MessageService'];
  /* ng-inject */
  function ctrl(workflowFactory, MessageService) {
    
    var vm = this;
    vm.$onInit = function () {
      vm.workflowFactory = workflowFactory;
    };

    vm.cancelDialog = function () {
      MessageService.closeDialog();
    };

    vm.saveMapping = function () {
      vm.workflowFactory.saveMapping()
        .then(function () {
          MessageService.closeDialog();
        });
    };
    
  }
})();
    
/**
 * Created by davidbeazer on 05/11/2016.
 */
(function () {
  'use strict';

  angular
    .module('users')
    .component('zpUserList', {
      controller: 'ZPUserListController',
      templateUrl: 'app/users/main/zp-user-list/zp-user-list.tmpl.html',
      bindings: {
        data: '<',
        metadata: '<',
        title: '<'
      }
    })
    .controller('ZPUserListController', ZPUserListController);

  ZPUserListController.$inject = ['EncodingService', '$location', 'UserFactory', 'PaginationManager', 'MessageService', 'SessionService', 'MasterPermissionsDefinitionFactory', 'IsSubsetFactory', 'GridDataFactory', 'SearchValFactory'];
  /* ng-inject*/
  function ZPUserListController(encoder, location, UserFactory, PaginationManager, MessageService, SessionService, MasterPermissionsDefinitionFactory, IsSubsetFactory, GridDataFactory, SearchValFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.totalRows = vm.data.items.length;
      vm.search = SearchValFactory.get(vm.metadata.id);
      GridDataFactory.hydrateData(vm.data, vm.metadata.id);
      vm.metadata.paginationOptions.limit = vm.metadata.query.limit; // these two must remain in sync // HACK!!
      PaginationManager.setQuery(vm.metadata.query, vm.metadata.id);
      vm.permissions = MasterPermissionsDefinitionFactory;
    };

    // PAGINATION
    vm.logPagination = function (page, limit) {
      vm.metadata.query.page = page;
      vm.metadata.query.limit = limit;
      PaginationManager.setQuery(vm.metadata.query, vm.metadata.id);
      $('md-content').animate({ scrollTop: 0 }, 0);
    };

    vm.primaryAction = function (userId) {
      if (userPermittedToManageSelectedUser(userId)) {
        location.path('/users/' + encoder.encode(SessionService.getUserData().clientId) + '/user/' + encoder.encode(userId));
      } else {
        MessageService.showMessage('You don\'t have sufficient permissions to manage this user');
      }
    };

    function userPermittedToManageSelectedUser(userId) {
      const targetUser = UserFactory.factoryData.itemsObject[userId];
      const loggedInUser = SessionService.getUserData();
      let isSubset = false;
      try {
        if (loggedInUser.permissions.trump) return true;
      } catch (e) {
        // no catch required
      }
      // isSubset = IsSubsetFactory.isSubset(loggedInUser.permissions, targetUser.user.permissions);

      // DF - If user has a greater preset then that's all that should matter. No need to make things 
      // overly complex otherwise users will be throwing support requests at us all day
      if (targetUser.user.roleorcustom && targetUser.user.roleorcustom.toLowerCase().indexOf('standard') > -1) {
        isSubset = true;
      }
      if (targetUser.user.roleorcustom && targetUser.user.roleorcustom.toLowerCase().indexOf('power') > -1 && loggedInUser.role && (loggedInUser.role.toLowerCase().indexOf('power') > -1 || loggedInUser.role.toLowerCase().indexOf('admin') > -1)) {
        isSubset = true;
      }
      if (targetUser.user.roleorcustom && targetUser.user.roleorcustom.toLowerCase().indexOf('admin') > -1 && loggedInUser.role && loggedInUser.role.toLowerCase().indexOf('admin') > -1) {
        isSubset = true;
      }


      return isSubset;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('users')
    .component('zpUsersWidgetContainer', {
      templateUrl: 'app/users/main/widget-container/widget-container.tmpl.html',
      controller: 'UsersWidgetContainerCtrl',
      bindings: {}
    })
    .controller('UsersWidgetContainerCtrl', controller);

  controller.$inject = ['UserFactory'];
  /* ng-inject */
  function controller(UserFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.data = UserFactory.getData();
      // vm.archivedUserCount = UserFactory.getArchivedUserList();
      vm.blankSlate = UserFactory;
    };

    vm.inactiveUsersCount = function (){
      return UserFactory.getArchivedUserList();
    };

    vm.clientId = function () {
      if (vm.data.dataCache && vm.data.dataCache.clientId) {
        return vm.data.dataCache.clientId;
      }
      return '';
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('users')
    .component('zpUserSearchToolbar', {
      templateUrl: 'app/users/main/search-toolbar/tmpl.html',
      controller: 'UserSearchToolbarCtrl',
      bindings: {}
    })
    .controller('UserSearchToolbarCtrl', controller);

  controller.$inject = ['UserMetadataFactory', 'UserFactory', 'UserExportFactory', 'MessageService'];
  /* ng-inject */
  function controller(UserMetadataFactory,UserFactory, UserExportFactory, MessageService) {

    var vm = this;

    vm.$onInit = function () {
      vm.metadata = UserMetadataFactory.getData();
    };

    vm.onMenuClick = function(event){
      return vm[event.action](event.ev);
    };

    vm.viewArchivedUsers = function (srcEvent) {
      const userFactory = UserFactory.getData();
      const users = _.get(userFactory, 'items', []);

      openArchiveDialog(srcEvent, users);
    };

    vm.viewArchivedStaffUsers = function (srcEvent) {
      const userFactory = UserFactory.getData();
      const users = _.get(userFactory, 'staffUsers', []);

      openArchiveDialog(srcEvent, users);
    };

    vm.exportUsersAsCSV = function () {
      UserExportFactory.exportUsersCSV();
    };

    // PRIVATE HELPER FUNCTIONS

    function openArchiveDialog(srcEvent, users) {
      const config = {
        controller: 'ArchivedUserDialogController as vm',
        templateUrl: 'app/users/main/archived-users/archived-users.dialog.tmpl.html',
        locals: { users },
      };

      MessageService.showDialog(srcEvent, config)
        .then(function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'User closed manage archive users dialog'
          });
        })
        .catch(function () {
          /* cancelled */
        });
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('users')
    .component('zpAddUserFab', {
      templateUrl: 'app/users/main/fab/fab.tmpl.html',
      controller: 'zpUsersAppController'
    });

})();

'use strict';

angular
  .module('users')
  .controller('ArchivedUserDialogController', ArchivedUserDialogController);

ArchivedUserDialogController.$inject = ['locals', 'UserFactory', 'MessageService'];
/* ng-inject */
function ArchivedUserDialogController(locals, UserFactory, MessageService) {

  var vm = this;

  vm.showSearch = true;
  vm.users = locals.users;

  vm.iconCheck = function (user) {
    return user.inactive.raw ? 'close' : 'check';
  };

  vm.toggleArchiveUser = function (user) {
    const updateUserPayload = {
      _id: user._id,
      inactive: user.inactive.raw
    };
    
    UserFactory.toggleArchiveUser(updateUserPayload)
      .then(function () {
        const msg = user.inactive.raw ? 'archived' : 'unarchived';
        MessageService.showMessage(user.firstname.filtered + ' ' + msg);
        MessageService.pushEventToIntercom('toggle_archive_user', {
          archived: user.inactive.raw ? 'archived' : 'unarchived',
          email: user.email.raw
        });
      })
      .catch(function (err) {
        MessageService.showMessage(err.data.data.message);
        MessageService.writeLog({
          level: 'error',
          msg: err
        });
      });
  };

  vm.hide = function (answer) {
    MessageService.closeDialog(answer);
  };
}

(function () {
  'use strict';

  angular
    .module('users')
    .component('zpUserForm', {
      controller: 'ZPUserFormController',
      controllerAs: 'vm',
      templateUrl: 'app/users/detail/zp-user-form/zp-user-form.tmpl.html',
      bindings: {
        id: '<',
        userDoc: '<',
        clientDoc: '<',
        passwordFields: '@',
        onSave: '&',
        formDisabled: '<',
        userFormObj: '='
      }
    })
    .controller('ZPUserFormController', controller);

  controller.$inject = ['$scope', 'ChangeDelta', 'UserFactory', 'UserPermissionsHelperFactory', 'SessionService', 'EnvService', 'SessionService'];
  /* ng-inject */
  function controller($scope, ChangeDelta, UserFactory, UserPermissionsHelperFactory, session, EnvService, SessionService) {

    var vm = this;
    vm.isPasswordPolicyEnabled = false;
    vm.activePolicy = {};

    vm.passwordFieldIcon = 'zmdi-eye-off';
    vm.passwordFieldType = 'password';
    vm.passwordFieldTooltip = 'Show password';

    vm.confirmPasswordFieldIcon = 'zmdi-eye-off';
    vm.confirmPasswordFieldType = 'password';
    vm.confirmPasswordFieldTooltip = 'Show password';

    vm.$onInit = function () {
      vm.session = session;
      ChangeDelta.clear();
      vm.copyOfUserForm = angular.copy(vm.userDoc);
      vm.isDev = EnvService.isDev;
      vm.availableUserPermissionsPresets = UserPermissionsHelperFactory.permittedPresetsUserCanAdminister(session.getUserData());

      if (SessionService.getUserData().permissions.trump){
        vm.showTrumpPermissionsControl = true;
      }

      $scope.$watch('vm.clientDoc', function (newValue, oldValue){
        vm.activePolicy = {};
        vm.isPasswordPolicyEnabled = vm.clientDoc.ispasswordpolicyenabled || false;
        const passwordPolicy = vm.isPasswordPolicyEnabled ? vm.clientDoc.passwordPolicy : {};
        for (const key of Object.keys(passwordPolicy)){
  
          if (passwordPolicy[key] > 0){
  
            let label = null;
            let regex = null;
            switch (key){
              case 'minLength':
                label = 'Minimum Password Length:';
                break;
              case 'maxLength':
                label = 'Maximum Password Length';
                break;
              case 'minUppercase':
                label = 'Minimum Number Of Upercase Characters:';
                regex = `^(?=(?:.*[A-Z]){${passwordPolicy[key]},}).*$`;
                break;
              case 'minLowercase':
                label = 'Minimum Number Of Lowercase Characters:';
                regex = `^(?=(?:.*[a-z]){${passwordPolicy[key]},}).*$`;
                break;
              case 'minNumeric':
                label = 'Minimum Number Of Numeric Characters ([0-9]):';
                // eslint-disable-next-line no-useless-escape
                regex = `^(?=(?:.*\\d){${passwordPolicy[key]},}).*$`;
                break;
              case 'minSymbols':
                label = 'Minimum Number Of Symbol Characters (!@#$%^&*-):';
                regex = `^(?=(?:.*[!@#$%^&*-]){${passwordPolicy[key]},}).*$`;
                break;
              default:
                throw new Error('Invalid Policy');
            }
  
            vm.activePolicy[key] = {
              key,
              label,
              regex,
              value: passwordPolicy[key]
            };
          }
        }

        if (newValue === oldValue || !oldValue) return;
        vm.checkAgainstPasswordPolicy('password');
        vm.checkAgainstPasswordPolicy('confirmPassword');

      }, true);

    };

    vm.toggleViewPasswordField = function (field){
      vm[`${field}FieldIcon`] = vm[`${field}FieldIcon`] === 'zmdi-eye-off' ? 'zmdi-eye' : 'zmdi-eye-off';
      vm[`${field}FieldType`] = vm[`${field}FieldType`] === 'password' ? 'text' : 'password';
      vm[`${field}FieldTooltip `] = vm[`${field}FieldTooltip `] === 'Show password' ? 'Hide password' : 'Show password';
    };

    vm.checkAgainstPasswordPolicy = function (field){

      vm.userFormObj.confirmpassword.$setValidity('nonMatch', true);
      vm.userFormObj.password.$setValidity('nonMatch', true);
      vm.userFormObj.password.$setValidity('invalidCharacters', true);

      if (field === 'confirmPassword'){
        if (vm.userDoc.repeatpassword !== vm.userDoc.password && (!!vm.userDoc.password && vm.userDoc.password.length > 0)){
          vm.userFormObj.confirmpassword.$setValidity('nonMatch', false);
        }
        return;
      }

      if (vm.userDoc.password !== vm.userDoc.repeatpassword && (!!vm.userDoc.repeatpassword && vm.userDoc.repeatpassword.length > 0)){
        vm.userFormObj.password.$setValidity('nonMatch', false);
        return;
      }

      const recognisedCharactersRegex = new RegExp(/^[A-Za-z\d!@#$%^&*-]*$/);

      if (!(recognisedCharactersRegex.test(vm.userDoc.password))){
        vm.userFormObj.password.$setValidity('invalidCharacters', false);
        return;
      }

      for (const key of Object.keys(vm.activePolicy)){
        const policy = vm.activePolicy[key];
        vm.userFormObj.password.$setValidity(key, false);

        if (!policy.regex){
          switch (key){
            case 'minLength':
              if (vm.userDoc.password && vm.userDoc.password.length >= policy.value){
                vm.userFormObj.password.$setValidity(key, true);
              }
              break;
            case 'maxLength':
              if (vm.userDoc.password && vm.userDoc.password.length <= policy.value){
                vm.userFormObj.password.$setValidity(key, true);
              }
              break;
          }
          continue;
        }

        const regex = new RegExp(policy.regex);
        const valid = regex.test(vm.userDoc.password);
        vm.userFormObj.password.$setValidity(key, valid);
      }
    };

    vm.updateChangeDelta = function (property, newValue) {
      if (property === 'typeofuser') {
        UserFactory.setPermissions(vm.userDoc);
      }
      const oldValue = vm.copyOfUserForm[property];
      ChangeDelta.recordValueChange({
        oldval: oldValue,
        newval: newValue,
        collection: 'clients',
        objectid: vm.id,
        databasefieldname: property
      });
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('users')
    .controller('SetPasswordController', SetPasswordController);

  SetPasswordController.$inject = ['CurrentClientModelFactory', 'MessageService', 'UserFactory', 'userEmail', 'hotkeys'];
  /* ng-inject */
  function SetPasswordController (CurrentClientModelFactory, MessageService, UserFactory, userEmail, hotkeys) {

    var vm = this;
    vm.isPasswordPolicyEnabled = false;
    vm.activePolicy = {};

    vm.passwordFieldIcon = 'zmdi-eye-off';
    vm.passwordFieldType = 'password';
    vm.passwordFieldTooltip = 'Show password';
    vm.passwordFormFieldValue = null;

    vm.confirmPasswordFieldIcon = 'zmdi-eye-off';
    vm.confirmPasswordFieldType = 'password';
    vm.confirmPasswordFieldTooltip = 'Show password';
    vm.confirmPasswordFormFieldValue = null;

    vm.$onInit = function () {
      vm.isPasswordPolicyEnabled = CurrentClientModelFactory.factoryData.currentClient.ispasswordpolicyenabled || false;
      const passwordPolicy = vm.isPasswordPolicyEnabled ? CurrentClientModelFactory.factoryData.currentClient.passwordPolicy : {};
      for (const key of Object.keys(passwordPolicy)){

        if (passwordPolicy[key] > 0){

          let label = null;
          let regex = null;
          switch (key){
            case 'minLength':
              label = 'Minimum Password Length:';
              break;
            case 'maxLength':
              label = 'Maximum Password Length';
              break;
            case 'minUppercase':
              label = 'Minimum Number Of Upercase Characters:';
              regex = `^(?=(?:.*[A-Z]){${passwordPolicy[key]},}).*$`;
              break;
            case 'minLowercase':
              label = 'Minimum Number Of Lowercase Characters:';
              regex = `^(?=(?:.*[a-z]){${passwordPolicy[key]},}).*$`;
              break;
            case 'minNumeric':
              label = 'Minimum Number Of Numeric Characters ([0-9]):';
              // eslint-disable-next-line no-useless-escape
              regex = `^(?=(?:.*\\d){${passwordPolicy[key]},}).*$`;
              break;
            case 'minSymbols':
              label = 'Minimum Number Of Symbol Characters (!@#$%^&*-):';
              regex = `^(?=(?:.*[!@#$%^&*-]){${passwordPolicy[key]},}).*$`;
              break;
            default:
              throw new Error('Invalid Policy');
          }

          vm.activePolicy[key] = {
            key,
            label,
            regex,
            value: passwordPolicy[key]
          };
        }
      }
    };


    vm.toggleViewPasswordField = function (field){
      vm[`${field}FieldIcon`] = vm[`${field}FieldIcon`] === 'zmdi-eye-off' ? 'zmdi-eye' : 'zmdi-eye-off';
      vm[`${field}FieldType`] = vm[`${field}FieldType`] === 'password' ? 'text' : 'password';
      vm[`${field}FieldTooltip `] = vm[`${field}FieldTooltip `] === 'Show password' ? 'Hide password' : 'Show password';
    };

    vm.checkAgainstPasswordPolicy = function (field){

      vm.passwordSetFormObj.confirmpassword.$setValidity('nonMatch', true);
      vm.passwordSetFormObj.password.$setValidity('nonMatch', true);
      vm.passwordSetFormObj.password.$setValidity('invalidCharacters', true);

      if (field === 'confirmPassword'){
        if (vm.confirmPasswordFormFieldValue !== vm.passwordFormFieldValue && (!!vm.passwordFormFieldValue && vm.passwordFormFieldValue.length > 0)){
          vm.passwordSetFormObj.confirmpassword.$setValidity('nonMatch', false);
        }
        return;
      }

      if (vm.passwordFormFieldValue !== vm.confirmPasswordFormFieldValue && (!!vm.confirmPasswordFormFieldValue && vm.confirmPasswordFormFieldValue.length > 0)){
        vm.passwordSetFormObj.password.$setValidity('nonMatch', false);
        return;
      }

      const recognisedCharactersRegex = new RegExp(/^[A-Za-z\d!@#$%^&*-]*$/);

      if (!(recognisedCharactersRegex.test(vm.passwordFormFieldValue))){
        vm.passwordSetFormObj.password.$setValidity('invalidCharacters', false);
        return;
      }

      for (const key of Object.keys(vm.activePolicy)){
        const policy = vm.activePolicy[key];
        vm.passwordSetFormObj.password.$setValidity(key, false);

        if (!policy.regex){
          switch (key){
            case 'minLength':
              if (vm.passwordFormFieldValue && vm.passwordFormFieldValue.length >= policy.value){
                vm.passwordSetFormObj.password.$setValidity(key, true);
              }
              break;
            case 'maxLength':
              if (vm.passwordFormFieldValue && vm.passwordFormFieldValue.length <= policy.value){
                vm.passwordSetFormObj.password.$setValidity(key, true);
              }
              break;
          }
          continue;
        }

        const regex = new RegExp(policy.regex);
        const valid = regex.test(vm.passwordFormFieldValue);
        vm.passwordSetFormObj.password.$setValidity(key, valid);
      }
    };

    // modal dismiss functions
    vm.submitForm = function () {
      UserFactory.changePassword(userEmail, vm.passwordFormFieldValue, vm.confirmPasswordFormFieldValue)
        .then(function () {
          vm.hide(true);
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
          MessageService.showMessage(err.data.data.message);
        });
    };

    vm.hide = function(answer) {
      MessageService.closeDialog(answer);
    };

    vm.cancelDialog = function () {
      MessageService.cancelDialog();
    };

    hotkeys.add({
      combo: 'enter',
      description: 'save new password',
      callback: function () {
        // $log.info('escape key pressed whilst edit dialog open. close dialog without saving');
        vm.submitForm();
      }
    });

  }
})();

(function () {

  'use strict';

  angular
    .module('users')
    .controller('AddUserDialogController', controller);

  controller.$inject = ['$rootScope', 'CurrentClientModelFactory', 'MessageService', 'UserFactory', 'ChangeDelta', 'hotkeys'];
  /* ng-inject */
  function controller ($rootScope, CurrentClientModelFactory, MessageService, UserFactory, ChangeDelta, hotkeys) {

    var vm = this;
    vm.loading = false;
    vm.source = 'new';
    vm.isPasswordPolicyEnabled = false;
    vm.activePolicy = {};

    vm.passwordFieldIcon = 'zmdi-eye-off';
    vm.passwordFieldType = 'password';
    vm.passwordFieldTooltip = 'Show password';
    vm.passwordFormFieldValue = null;

    vm.confirmPasswordFieldIcon = 'zmdi-eye-off';
    vm.confirmPasswordFieldType = 'password';
    vm.confirmPasswordFieldTooltip = 'Show password';
    vm.confirmPasswordFormFieldValue = null;

    vm.fileName = '';
    vm.fileEncoding = '';
    vm.fileUploaded = false;

    vm.avaliableCsvHeaders = [
      { name: 'firstname', required: true, description: '' }, 
      { name: 'surname', required: true, description: '' },
      { name: 'email', required: true, description: '' },
      { name: 'typeofuser', required: true, description: '(standard_user, power_user, administrator)' },
      { name: 'password', required: false, description: '(optional)' },
      { name: 'confirm_password', required: false, description: '(optional)' }
    ];

    vm.recognisedCsvHeaders = [];
    vm.fileErrors = [];
    vm.fileWarnings = [];
    vm.fileItems = [];
    vm.processErrors = [];

    vm.$onInit = function() {
      vm.userDoc = UserFactory.newUserModel();
      vm.clientDoc = CurrentClientModelFactory.factoryData.currentClient;
      vm.isPasswordPolicyEnabled = vm.clientDoc.ispasswordpolicyenabled || false;
      
      const passwordPolicy = vm.isPasswordPolicyEnabled ? vm.clientDoc.passwordPolicy : {};
      for (const key of Object.keys(passwordPolicy)){

        if (passwordPolicy[key] > 0){

          let label = null;
          let regex = null;
          switch (key){
            case 'minLength':
              label = 'Minimum Password Length:';
              break;
            case 'maxLength':
              label = 'Maximum Password Length';
              break;
            case 'minUppercase':
              label = 'Minimum Number Of Upercase Characters:';
              regex = `^(?=(?:.*[A-Z]){${passwordPolicy[key]},}).*$`;
              break;
            case 'minLowercase':
              label = 'Minimum Number Of Lowercase Characters:';
              regex = `^(?=(?:.*[a-z]){${passwordPolicy[key]},}).*$`;
              break;
            case 'minNumeric':
              label = 'Minimum Number Of Numeric Characters ([0-9]):';
              // eslint-disable-next-line no-useless-escape
              regex = `^(?=(?:.*\\d){${passwordPolicy[key]},}).*$`;
              break;
            case 'minSymbols':
              label = 'Minimum Number Of Symbol Characters (!@#$%^&*-):';
              regex = `^(?=(?:.*[!@#$%^&*-]){${passwordPolicy[key]},}).*$`;
              break;
            default:
              throw new Error('Invalid Policy');
          }

          vm.activePolicy[key] = {
            key,
            label,
            regex,
            value: passwordPolicy[key]
          };
        }
      }

      hotkeys.add({
        combo: 'enter',
        description: 'Add user',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (ev) {
          if (ev.srcElement.nodeName !== 'BUTTON') {
            vm.submitUserForm(vm.userDoc);
          }
        }
      });
    };

    vm.setSource = function (source) {
      vm.source = source;
    };

    vm.toggleViewPasswordField = function (field){
      vm[`${field}FieldIcon`] = vm[`${field}FieldIcon`] === 'zmdi-eye-off' ? 'zmdi-eye' : 'zmdi-eye-off';
      vm[`${field}FieldType`] = vm[`${field}FieldType`] === 'password' ? 'text' : 'password';
      vm[`${field}FieldTooltip `] = vm[`${field}FieldTooltip `] === 'Show password' ? 'Hide password' : 'Show password';
    };

    vm.checkAgainstPasswordPolicy = function (field){

      vm.passwordSetFormObj.confirmpassword.$setValidity('nonMatch', true);
      vm.passwordSetFormObj.password.$setValidity('nonMatch', true);
      vm.passwordSetFormObj.password.$setValidity('invalidCharacters', true);

      if (field === 'confirmPassword'){
        if (vm.confirmPasswordFormFieldValue !== vm.passwordFormFieldValue && (!!vm.passwordFormFieldValue && vm.passwordFormFieldValue.length > 0)){
          vm.passwordSetFormObj.confirmpassword.$setValidity('nonMatch', false);
        }
        return;
      }

      if (vm.passwordFormFieldValue !== vm.confirmPasswordFormFieldValue && (!!vm.confirmPasswordFormFieldValue && vm.confirmPasswordFormFieldValue.length > 0)){
        vm.passwordSetFormObj.password.$setValidity('nonMatch', false);
        return;
      }

      const recognisedCharactersRegex = new RegExp(/^[A-Za-z\d!@#$%^&*-]*$/);

      if (!(recognisedCharactersRegex.test(vm.passwordFormFieldValue))){
        vm.passwordSetFormObj.password.$setValidity('invalidCharacters', false);
        return;
      }

      for (const key of Object.keys(vm.activePolicy)){
        const policy = vm.activePolicy[key];
        vm.passwordSetFormObj.password.$setValidity(key, false);

        if (!policy.regex){
          switch (key){
            case 'minLength':
              if (vm.passwordFormFieldValue && vm.passwordFormFieldValue.length >= policy.value){
                vm.passwordSetFormObj.password.$setValidity(key, true);
              }
              break;
            case 'maxLength':
              if (vm.passwordFormFieldValue && vm.passwordFormFieldValue.length <= policy.value){
                vm.passwordSetFormObj.password.$setValidity(key, true);
              }
              break;
          }
          continue;
        }

        const regex = new RegExp(policy.regex);
        const valid = regex.test(vm.passwordFormFieldValue);
        vm.passwordSetFormObj.password.$setValidity(key, valid);
      }
    };

    vm.fileChanged = function ($event) {
      const file = $event.target.files[0];
      vm.fileName = file.name;
      const splits = vm.fileName.split('.');
  
      if (splits.pop() !== 'csv') {
        return MessageService.showMessage('Invalid file type. Please select a CSV.');
      }
  
      return getFileEncoding(file)
        .then(function (meta){
          vm.fileEncoding = meta.encoding;
          if (vm.fileEncoding !== 'UTF-8'){
            vm.fileWarnings.push({
              type: 'fileType',
              message: 'Non-UTF-8 encoded file detected. We recommend saving your CSV file with UTF-8 encoding to support extended Unicode character sets. If you continue, non-ASCII characters (such as letters with accents) may not be processed correctly.'
            });
          }
          Papa.parse(file, {
            delimiter: ',',
            newline: '',// auto detect
            skipEmptyLines: true,
            encoding: meta.encoding,
            complete: function (results) {
              if (results.data && results.data.length > 0) {
                const columns = results.data[0];
            
                for (const column of columns){
                  if (vm.avaliableCsvHeaders.findIndex((header)=> header.name === column) > -1){
                    vm.recognisedCsvHeaders.push(column);
                  } else {
                    const existingErrorIndex = vm.fileErrors.findIndex((err)=> err.type === 'unknown_csv_header');

                    if (existingErrorIndex === -1){
                      vm.fileErrors.push({
                        type: 'unknown_csv_header',
                        error: 'Unknown CSV Headers: ' + `"${column}"`,
                      });
                    } else {
                      vm.fileErrors[existingErrorIndex].error += `, "${column}"`;
                    }
                
                  }
                }

                for (const avaliableCsvHeader of vm.avaliableCsvHeaders){

                  if (avaliableCsvHeader.name === 'password' || avaliableCsvHeader.name === 'confirm_password'){
                    if (vm.recognisedCsvHeaders.indexOf(avaliableCsvHeader.name) > -1){
                      const otherHeaderToCheck = avaliableCsvHeader.name === 'password' ? 'confirm_password' : 'password';

                      const existingErrorIndex = vm.fileErrors.findIndex((err)=> err.type === 'missing_optional_csv_header');

                      if (vm.recognisedCsvHeaders.indexOf(otherHeaderToCheck) === -1 && existingErrorIndex === -1){
                        vm.fileErrors.push({
                          type: 'missing_optional_csv_header',
                          error: `Missing "${otherHeaderToCheck}" optional CSV header due to the fact you are using the header "${avaliableCsvHeader.name}".`,
                        });
                      }
                    }
                  }

                  if (vm.recognisedCsvHeaders.indexOf(avaliableCsvHeader.name) === -1 && avaliableCsvHeader.required){
                    const existingErrorIndex = vm.fileErrors.findIndex((err)=> err.type === 'missing_required_csv_header');

                    if (existingErrorIndex === -1){
                      vm.fileErrors.push({
                        type: 'missing_required_csv_header',
                        error: 'Missing CSV Headers: ' + `"${avaliableCsvHeader.name}"`,
                      });
                    } else {
                      vm.fileErrors[existingErrorIndex].error += `, "${avaliableCsvHeader.name}"`;
                    }
                  }
                }
  
                //row
                for (let i = 1; i < results.data.length; i++) {
                  const item = {};
                  //column
                  for (let j = 0; j < results.data[i].length; j++) {
                    let value = results.data[i][j];
              
                    if (typeof(value) === 'string'){
                      //this basically removes any extra new line or return Carriage characters
                      value = value.replace(/[\r\n]/g, '');
                    }

                    item[results.data[0][j]] = value;
                  }

                  vm.fileItems.push(item);
                }

                for (const recognisedCsvHeader of vm.recognisedCsvHeaders){
                  for (const [rowNum, rawItm] of vm.fileItems.entries()){
                    if (!rawItm[recognisedCsvHeader] || rawItm[recognisedCsvHeader].length === 0){
                      vm.fileErrors.push({
                        type: 'missing_data_for_csv_header',
                        error: 'Missing Data For Header: ' + `"${recognisedCsvHeader}" at row ${rowNum}.`,
                      });
                    } else if (recognisedCsvHeader === 'email'){
                      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                      const validEmail = emailRegex.test(rawItm[recognisedCsvHeader]);

                      if (!validEmail){
                        vm.fileErrors.push({
                          type: 'invalid_email_within_csv_data',
                          error: 'Invalid Email Address: ' + `"${rawItm[recognisedCsvHeader]}" at row ${rowNum}.`,
                        });
                      }

                      const dupeEmailAddressIndex = vm.fileItems.filter((itm, index)=> index > rowNum).findIndex((itm) => itm[recognisedCsvHeader] === rawItm[recognisedCsvHeader]);
                      if (dupeEmailAddressIndex > -1){
                        vm.fileErrors.push({
                          type: 'dupe_email_within_csv_data',
                          error: 'Duplicate Email Address: ' + `"${rawItm[recognisedCsvHeader]}" at row ${rowNum + dupeEmailAddressIndex}.`,
                        });
                      }

                    } else if (recognisedCsvHeader === 'typeofuser'){
                      if (rawItm[recognisedCsvHeader] !== 'standard_user' && rawItm[recognisedCsvHeader] !== 'power_user' && rawItm[recognisedCsvHeader] !== 'administrator'){
                        vm.fileErrors.push({
                          type: 'invalid_typeofuser_within_csv_data',
                          error: 'Invalid "typeofuser": ' + `"${rawItm[recognisedCsvHeader]}" at row ${rowNum}.`
                        });
                      }
                    } else if (recognisedCsvHeader === 'password'){
                      if (rawItm['confirm_password'] && rawItm[recognisedCsvHeader] !== rawItm['confirm_password']){
                        vm.fileErrors.push({
                          type: 'invalid_confirm_password_within_csv_data',
                          error: 'Password does not match confirmation: ' + `Password - "${rawItm[recognisedCsvHeader]}" Confirm Password - "${rawItm['confirm_password']}" at row ${rowNum}.`,
                        });
                      }

                      if (vm.isPasswordPolicyEnabled){
                        const recognisedCharactersRegex = new RegExp(/^[A-Za-z\d!@#$%^&*-]*$/);

                        if (!(recognisedCharactersRegex.test(rawItm[recognisedCsvHeader]))){
                          vm.fileErrors.push({
                            type: 'invalid_password_within_csv_data',
                            error: 'Password has invalid characters: ' + `Password - "${rawItm[recognisedCsvHeader]}" at row ${rowNum} does not conform to supported characters "A-Z, a-z, 0-9, symbols(!@#$%^&*-)".`,
                          });
                        }

                        for (const key of Object.keys(vm.activePolicy)){
                          const policy = vm.activePolicy[key];

                          if (!policy.regex){
                            switch (key){
                              case 'minLength':
                                if (rawItm[recognisedCsvHeader] && rawItm[recognisedCsvHeader].length < policy.value){
                                  vm.fileErrors.push({
                                    type: 'invalid_password_within_csv_data',
                                    error: 'Password does not reach minimum length of characters: ' + `Password - "${rawItm[recognisedCsvHeader]}" at row ${rowNum} does not reach password policy minimum length of ${policy.value} character.`,
                                  });
                                }
                                break;
                              case 'maxLength':
                                if (rawItm[recognisedCsvHeader] && rawItm[recognisedCsvHeader].length > policy.value){
                                  vm.fileErrors.push({
                                    type: 'invalid_password_within_csv_data',
                                    error: 'Password exceeds maximum length of characters: ' + `Password - "${rawItm[recognisedCsvHeader]}" at row ${rowNum} exceeds password policy maximum length of ${policy.value} character.`,
                                  });
                                }
                                break;
                            }
                            continue;
                          }

                          const regex = new RegExp(policy.regex);
                          const valid = regex.test(rawItm[recognisedCsvHeader]);
                          if (valid) continue;

                          let shortLabel = '';
                          switch (policy.key){
                            case 'minUppercase':
                              shortLabel = 'Upercase characters';
                              break;
                            case 'minLowercase':
                              shortLabel = 'Lowercase characters';
                              break;
                            case 'minNumeric':
                              shortLabel = 'Numeric characters ([0-9]):';
                              break;
                            case 'minSymbols':
                              shortLabel = 'Symbol characters (!@#$%^&*-):';
                              break;
                            default:
                              throw new Error('Invalid Policy');
                          }

                          vm.fileErrors.push({
                            type: 'invalid_password_within_csv_data',
                            error: `Password does not reach minimum length of ${shortLabel} : ` + `Password - "${rawItm[recognisedCsvHeader]}" at row ${rowNum} does not reach password policy minimum length of ${policy.value} ${shortLabel}.`,
                          }); 
                        }
                      }
                    }
                  }
                }

                vm.fileUploaded = true;

              } else {
                vm.fileUploaded = false;
                MessageService.showMessage(vm.fileName + ' has no data');
              }

              //Papaparse seems to operate such that Angular does not see the changes when applied here, hence wrap the update in $scope.$apply:
              $rootScope.$digest();
            }
          });
        });
    };

    vm.selectFile = function() {
      if (vm.fileUploaded) {
        vm.fileName = '';
        vm.fileUploaded = false;
        vm.recognisedCsvHeaders = [];
        vm.fileErrors = [];
        vm.fileWarnings = [];
        vm.processErrors = [];
        vm.fileItems = [];
        vm.passwordFormFieldValue = '';
        vm.confirmPasswordFormFieldValue = '';
        angular.element(document).find('#userUploadInput').val(null);
        return;
      }
      
      angular.element(document).find('#userUploadInput').click();
    };

    vm.submitUploadUsers = function ($event) {


      if (vm.recognisedCsvHeaders.indexOf('password') === -1) {
        for (const field of Object.keys(vm.passwordSetFormObj)){
          if (field[0] === '$') continue;

          vm.passwordSetFormObj[field].$setTouched();
        }

        if (vm.passwordSetFormObj.$invalid) {
          return MessageService.showMessage('Passwords are not valid');
        }
      }

      if (vm.recognisedCsvHeaders.indexOf('password') === -1) {
        for (const itm of vm.fileItems){
          itm.password = vm.passwordFormFieldValue;
          itm['confirm_password'] = vm.confirmPasswordFieldIcon;
        }
      }

      if (vm.fileWarnings.length === 0) return createUsers();
      //if we have warning we want to make 100% sure the user is aware so it's on their head if they continue...
      return MessageService.confirm($event)
        .confirmAction({
          title: 'Confirm Users Creation',
          htmlContent: '<p>Are you sure you want to continue with user creation?</p> <p> There are warnings present, and continuing may result in incorrect processing of the CSV file.</p>',
          okBtn: 'YES',
          cancelBtn: 'NO'
        })
        .then(function () {
          return createUsers();
        })
        .catch(function () {
          return;
        });
    };

    vm.submitUserForm = function (formData) {
      vm.loading = true;
      if (UserFactory.userDocValid(formData)) {

        return UserFactory.postNewUser(formData)
          .then(function () {
            ChangeDelta.clear();
            MessageService.showMessage('User added');
            MessageService.pushEventToIntercom('created_user', {
              email: formData.email
            });
            vm.loading = false;
            vm.hide(true);
          })
          .catch(function (err) {
            vm.loading = false;
            MessageService.writeLog({
              level: 'error',
              msg: err
            });
            MessageService.showMessage(err.data.data.message);
          });

      } else {
        MessageService.showMessage('Form invalid. Please fill out required fields');
        vm.loading = false;
      }
    };

    // modal dismiss functions
    vm.hide = function (answer) {
      hotkeys.del('enter');
      MessageService.closeDialog(answer);
    };

    vm.cancelDialog = function() {
      hotkeys.del('enter');
      MessageService.cancelDialog();
    };

    function getFileEncoding(file) {
      const reader = new FileReader();
  
      return new Promise(function (resolve){
        reader.onload = function(event) {
          const arrayBuffer = new Uint8Array(event.target.result);
          let binaryString = '';
          for (let i = 0; i < arrayBuffer.byteLength; i++) {
            binaryString += String.fromCharCode(arrayBuffer[i]);
          }
          const detectedEncoding = jschardet.detect(binaryString);
          resolve(detectedEncoding);
        };
  
        // Read the file as a binary string
        reader.readAsArrayBuffer(file);
      });
  
    }

    function createUsers() {
      vm.loading = true;
      vm.fileErrors = [];
      vm.processErrors = [];

      const csvHasPasswords = vm.recognisedCsvHeaders.indexOf('password') > -1;
      const postObj = {
        users: vm.fileItems,
        csvHasPasswords: csvHasPasswords
      };

      return UserFactory.postUsersImport(postObj)
        .then(function () {
          MessageService.showMessage('Users successfully imported');
          vm.loading = false;
          vm.hide(true);
        })
        .catch(function (err){
          vm.loading = false;

          if (err.status === 409){
            //conflict
            vm.processErrors.push(err.data.data.error);
          }

          MessageService.writeLog({
            level: 'error',
            msg: err
          });
          MessageService.showMessage(err.data.data.message);
        });
    }
  }
}());

/**
 * Created by tom on 10/01/2023.
 */
/**
  * Provides functionality for thirdparty connections
  * @module thirdparty
  */
(function () {
  angular
    .module('thirdparty', [
      'ui.router',
      'ngMaterial',
      'common'
    ]);
})();
  
/**
 * Created by tom on 10/01/2023.
 */
(function () {
  'use strict';
  
  angular
    .module('thirdparty')
    .component('zpThirdPartyDropboxCallback', zpDropboxCallback())
    .controller('DropboxCallbackController', DropboxCallbackController);
  
  function zpDropboxCallback() {
    return {
      controller: 'DropboxCallbackController',
      templateUrl: 'app/thirdparty/dropbox/callback/dropbox-callback.tmpl.html',
      bindings: {}
    };
  }
  
  DropboxCallbackController.$inject = ['$location', 'localStorageService', 'SessionService', '$state', '$log', 'dropboxApiService'];
  
  function DropboxCallbackController($location, localStorageService, SessionService, $state, $log, dropboxApiService) {
    var vm = this;
  
    vm.$onInit = function () {
      var hash = $location.hash();
      if (hash && hash.length > 0) {
        var segments = hash.split('&');
        segments.forEach(function (segment) {
          var kvp = segment.split('=');
          if (kvp[0] && kvp[0] === 'access_token') {
            dropboxApiService.setBearerToken(kvp[1]);
            // $log.info('BEARER TOKEN IDENTIFIED:' + kvp[1]);
            storeAccountInfo(kvp[1]);
          } else if (kvp[0] === 'error_description' && kvp[1] === 'The+user+chose+not+to+give+your+app+access+to+their+Dropbox+account.') {
            vm.userDeniedAccess = true;
          }
        });
      } else {
        callback();
      }
    };
  
    function storeAccountInfo(bearerToken) {
      dropboxApiService.getCurrentAccount(bearerToken).then(function (response) {
        var userData = SessionService.getUserData();
        var existingAccounts = localStorageService.get('dropbox-accounts-' + userData.databasename);
        $log.info(existingAccounts);
        if (!Array.isArray(existingAccounts)) {
          existingAccounts = [];
        }
  
        // If user signs in with an account that already is stored, we remove it and readd it with new info
        var filteredAccounts = existingAccounts.filter(function (account) {
          return account.account_id != response.data.account_id;
        });
  
        filteredAccounts.push({
          account_id: response.data.account_id,
          token: bearerToken,
          display_name: response.data.name.display_name,
          email: response.data.email
        });
  
        localStorageService.set('dropbox-accounts-' + userData.databasename, filteredAccounts);
        callback();
      });
    }
  
    function callback() {
      dropboxApiService.setShowConnectedMessage(true);
      var transitionTo = localStorageService.get('dropboxRedirectPath');
      $state.go(transitionTo.state, transitionTo.params);
    }
  
    vm.connectToDropbox = function () {
      dropboxApiService.connectToDropbox();
    };
  
    vm.navBack = function (){
      var transitionTo = localStorageService.get('dropboxRedirectPath');
      $state.go(transitionTo.state, transitionTo.params);
    };
  
  }
  
})();
  
/**
 * Created by davidhickson on 10/04/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('dropboxMain', {
      templateUrl: 'app/showroom/third-party/main/dropbox-main.tmpl.html',
      controllerAs: 'vm',
      bindings: {
        message: '<'
      },
      controller: 'dropboxMainCtrl'
    })
    .controller('dropboxMainCtrl', ctrl);

  ctrl.$inject = ['dropboxApiService'];
  /* ng-inject */
  function ctrl(dropboxApiService) {

    var vm = this;
    vm.$onInit = function () {
      vm.dropboxsvcreference = dropboxApiService;
    };

    vm.$onDestroy = function () {
      if (dropboxApiService.connectionMessage.showMessage) {
        // hide the connection message after initial show.
        dropboxApiService.setShowConnectedMessage(false);
      }
    };
  }
})();

/**
 * Created by davidfm on 08/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('showroom')
    .component('zpDropboxCallback', zpDropboxCallback())
    .controller('DropboxCallbackController', DropboxCallbackController);

  function zpDropboxCallback() {
    return {
      controller: 'DropboxCallbackController',
      templateUrl: 'app/showroom/third-party/callback/dropbox-callback.tmpl.html',
      bindings: {}
    };
  }

  DropboxCallbackController.$inject = ['$location', 'localStorageService', 'SessionService', '$state', '$log', 'dropboxApiService'];

  function DropboxCallbackController($location, localStorageService, SessionService, $state, $log, dropboxApiService) {
    var vm = this;

    vm.$onInit = function () {
      var hash = $location.hash();
      if (hash && hash.length > 0) {
        var segments = hash.split('&');
        segments.forEach(function (segment) {
          var kvp = segment.split('=');
          if (kvp[0] && kvp[0] === 'access_token') {
            dropboxApiService.setBearerToken(kvp[1]);
            // $log.info('BEARER TOKEN IDENTIFIED:' + kvp[1]);
            storeAccountInfo(kvp[1]);
          } else if (kvp[0] === 'error_description' && kvp[1] === 'The+user+chose+not+to+give+your+app+access+to+their+Dropbox+account.') {
            vm.userDeniedAccess = true;
          }
        });
      } else {
        callback();
      }
    };

    function storeAccountInfo(bearerToken) {
      dropboxApiService.getCurrentAccount(bearerToken).then(function (response) {
        var userData = SessionService.getUserData();
        var existingAccounts = localStorageService.get('dropbox-accounts-' + userData.databasename);
        $log.info(existingAccounts);
        if (!Array.isArray(existingAccounts)) {
          existingAccounts = [];
        }

        // If user signs in with an account that already is stored, we remove it and readd it with new info
        var filteredAccounts = existingAccounts.filter(function (account) {
          return account.account_id != response.data.account_id;
        });

        filteredAccounts.push({
          account_id: response.data.account_id,
          token: bearerToken,
          display_name: response.data.name.display_name,
          email: response.data.email
        });

        localStorageService.set('dropbox-accounts-' + userData.databasename, filteredAccounts);
        callback();
      });
    }

    function callback() {
      dropboxApiService.setShowConnectedMessage(true);
      var transitionTo = localStorageService.get('dropboxRedirectPath');
      $state.go(transitionTo.state, transitionTo.params);
    }

    vm.connectToDropbox = function () {
      dropboxApiService.connectToDropbox();
    };

    vm.navBack = function (){
      var transitionTo = localStorageService.get('dropboxRedirectPath');
      $state.go(transitionTo.state, transitionTo.params);
    };

  }

})();

/**
 * Created by davidhickson on 13/06/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('toggleTagSelectionState', toggleTagSelectionState);

  toggleTagSelectionState.$inject = [];

  function toggleTagSelectionState() {
    return function (arrayOfTagCategories, toggledTag) {
      return arrayOfTagCategories.map(function (tagCategory) {
        tagCategory.tags.forEach(function (tag) {
          if (toggledTag._id === tag._id) {
            tag.isSelected = !tag.isSelected;
          }
        });
        return tagCategory;
      });
    };
  }
}());

/**
 * Created by davidhickson on 21/06/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('ingestTagCategoryArchiveDelta', ingestTagCategoryArchiveDelta);

  ingestTagCategoryArchiveDelta.$inject = [];

  function ingestTagCategoryArchiveDelta() {
    return function (arrayOfExistingTagCategoryItems, archiveDelta) {
      /*
          This is an IMPURE function that modifies the current literature model by removing all the items with _id values in the archiveDelta array.
       */
      archiveDelta.forEach(function (delta) {
        for (var i = arrayOfExistingTagCategoryItems.length - 1; i > -1; i--) {
          if (arrayOfExistingTagCategoryItems[i]._id === delta._id) {
            arrayOfExistingTagCategoryItems.splice(i, 1);
          }
        }
      });
    };
  }
})();

/**
 * Created by davidhickson on 20/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('ingestArrayOfTagXrefLiteratureDeltas', ingestArrayOfTagXrefLiteratureDeltas);

  ingestArrayOfTagXrefLiteratureDeltas.$inject = ['$log'];

  function ingestArrayOfTagXrefLiteratureDeltas($log) {
    return function (literatureItems, arrayOfDeltas) {
      $log.info('LITERATURE.XREF.TAGS ingest.array.of.deltas has been passed the following arrayOfDeltas');
      $log.info(arrayOfDeltas);

      literatureItems.forEach(function (literatureItem) {
        arrayOfDeltas.forEach(function (delta) {
          if (delta._id === literatureItem._id) {
            literatureItem.tags = delta.tags.map(function (itm) {
              return itm;
            });

            literatureItem.extendedTags = delta.tags.map(function (itm) {
              return {
                '_id': itm,
                'isSelected': false
              };
            });
          }
        });
      });
    };
  }
}());

/**
 * Created by davidhickson on 21/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('ingestArrayOfTagDeltas', ingestArrayOfTagDeltas);

  ingestArrayOfTagDeltas.$inject = [];

  function ingestArrayOfTagDeltas() {
    return function (arrayOfExistingTagCategories, arrayOfTagCategoryDeltas) {

      arrayOfTagCategoryDeltas.forEach(function (inboundTagCategoryDelta) {
        var found = false;
        var requiresSort = false;

        arrayOfExistingTagCategories.forEach(function (existingTagCategory) {
          if (inboundTagCategoryDelta._id == existingTagCategory._id) {
            found = true;
            Object.getOwnPropertyNames(inboundTagCategoryDelta).forEach(function (propertyName) {
              existingTagCategory[propertyName] = inboundTagCategoryDelta[propertyName];

              if (propertyName === 'sortorder') {
                requiresSort = true;
              }
            });
          }
        });

        if (!found) {
          arrayOfExistingTagCategories.push(inboundTagCategoryDelta);
        }

        if (requiresSort) {
          arrayOfExistingTagCategories.sort(function (a, b) {
            return a.sortorder - b.sortorder;
          });
        }
      });
    };
  }
}());

/**
 * Created by davidhickson on 21/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('deselectLiteratureTags', deselectLiteratureTags);

  deselectLiteratureTags.$inject = [];

  function deselectLiteratureTags() {
    return function (existingLiteratureItems) {
      existingLiteratureItems.forEach(function (literatureItem) {
        if (literatureItem.extendedTags) {
          literatureItem.extendedTags.forEach(function (extendedTag) {
            extendedTag.isSelected = false;
          });
        }
      });
    };
  }
}());

/**
 * Created by davidhickson on 21/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('createNewTagCategory', createNewTagCategory);

  createNewTagCategory.$inject = ['uuidService'];

  function createNewTagCategory(uuidService) {
    return function (newTagCategoryTitle, model) {
      var sortOrder = model.tagCategories.length;
      var newId = uuidService.getSingleNewBase64Key();

      return {
        '_id': newId,
        'category': newTagCategoryTitle,
        'sortorder': sortOrder,
        'tags': []
      };
    };
  }
}());

(function () {
  'use strict';
  angular.module('showroom').factory('createDeltaFromTagCategoryReordering', createDeltaFromTagCategoryReordering);

  createDeltaFromTagCategoryReordering.$inject = ['$log'];

  function createDeltaFromTagCategoryReordering($log) {
    return function (existingTagCategories, startIndex, dropIndex) {

      $log.info('TagsManager tagCATEGORY WasDragDropped:' + startIndex + ',' + dropIndex);
      $log.info('THIS IS IMPURE AND WRONG!! - THIS NEEDS TO SIMPLY RETURN AN ARRAY OF DELTAS DEFINING THE CORRECT ORDER!!!');

      var arrayOfPartialUpdates = [];
      var i;

      if (dropIndex < startIndex) {
        arrayOfPartialUpdates.push({
          '_id': existingTagCategories[startIndex]._id,
          'sortorder': dropIndex
        });

        for (i = dropIndex; i < startIndex; i++) {
          arrayOfPartialUpdates.push({
            '_id': existingTagCategories[i]._id,
            'sortorder': i + 1
          });
        }

      } else {
        arrayOfPartialUpdates.push({
          '_id': existingTagCategories[startIndex]._id,
          'sortorder': dropIndex
        });

        for (i = startIndex + 1; i <= dropIndex; i++) {
          arrayOfPartialUpdates.push({
            '_id': existingTagCategories[i]._id,
            'sortorder': i - 1
          });
        }
      }

      $log.info('tagcategory reordering arrayOfPartialUpdates follows ');
      $log.info(arrayOfPartialUpdates);

      return arrayOfPartialUpdates;
    };
  }
}());

(function () {
  'use strict';
  angular.module('showroom').factory('createDeltaFromTagReordering', createDeltaFromTagReordering);

  createDeltaFromTagReordering.$inject = [];

  function createDeltaFromTagReordering() {
    return function (existingTagCategories, idOfSourceCategory, idOfTargetCategory, startIndex, dropIndex) {

      var arrayOfPartialUpdates = [];

      existingTagCategories.forEach(function (tagCategory) {
        if (tagCategory._id === idOfSourceCategory) {
          var entireSourceCopy, entireDestCopy;

          if (idOfSourceCategory === idOfTargetCategory) {
            // Dragged WITHIN a single category
            entireSourceCopy = tagCategory.tags.slice(0);
            var arrayContainingObjectBeingMoved = entireSourceCopy.splice(startIndex, 1);
            entireSourceCopy.splice(dropIndex, 0, arrayContainingObjectBeingMoved[0]);

            arrayOfPartialUpdates.push({
              '_id': tagCategory._id,
              'tags': entireSourceCopy
            });
          } else {
            // Dragged BETWEEN categories
            existingTagCategories.forEach(function (tagCategory2) {
              if (tagCategory2._id === idOfTargetCategory) {
                entireSourceCopy = tagCategory.tags.slice(0);
                entireDestCopy = tagCategory2.tags.slice(0);

                var arrayContainingObjectBeingMoved = entireSourceCopy.splice(startIndex, 1);
                entireDestCopy.splice(dropIndex, 0, arrayContainingObjectBeingMoved[0]);

                arrayOfPartialUpdates.push({
                  '_id': tagCategory._id,
                  'tags': entireSourceCopy
                });
                arrayOfPartialUpdates.push({
                  '_id': tagCategory2._id,
                  'tags': entireDestCopy
                });
              }
            });
          }
        }
      });

      return arrayOfPartialUpdates;
    };
  }
}());

/**
 * Created by davidhickson on 13/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('createDeltasFromSelectedItems', createDeltasFromSelectedItems);

  createDeltasFromSelectedItems.$inject = [];

  function createDeltasFromSelectedItems() {
    return function (tagCategories, literatureItems) {
      var arrayOfSelectedTagIds = [];
      var changeDeltaPackage = [];

      tagCategories.forEach(function (tagCategory) {
        tagCategory.tags.forEach(function (tag) {
          if (tag.isSelected) {
            arrayOfSelectedTagIds.push(tag._id);
          }
        });
      });

      literatureItems.forEach(function (literatureItem) {
        if (literatureItem.selected) {
          var tagIdsToBeAdded = [];

          arrayOfSelectedTagIds.forEach(function (tagId) {
            var alreadyPresent = false;

            literatureItem.tags.forEach(function (tagIdWithinLitItem) {
              if (tagId === tagIdWithinLitItem) {
                alreadyPresent = true;
              }
            });

            if (!alreadyPresent) {
              tagIdsToBeAdded.push(tagId);
            }
          });

          if (tagIdsToBeAdded.length > 0) {
            var newArrayOfTags = literatureItem.tags.concat(tagIdsToBeAdded);
            changeDeltaPackage.push({
              '_id': literatureItem._id,
              'tags': newArrayOfTags
            });
          }
        }
      });

      return changeDeltaPackage;

    };
  }
}());

/**
 * Created by davidhickson on 26/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('createDeltasFromDeselectedItems', createDeltasFromDeselectedItems);

  createDeltasFromDeselectedItems.$inject = [];

  function createDeltasFromDeselectedItems() {
    return function (literatureItems) {

      var changeDeltaPackage = [];

      literatureItems.forEach(function (literatureItem) {
        var atLeastOneTagBeingRemoved = false;

        literatureItem.extendedTags.forEach(function (extendedTag) {
          if (extendedTag.isSelected) {
            atLeastOneTagBeingRemoved = true;
          }
        });

        if (atLeastOneTagBeingRemoved) {
          var wantedTags = [];

          literatureItem.extendedTags.forEach(function (extendedTag) {
            if (!extendedTag.isSelected) {
              wantedTags.push(extendedTag._id);
            }
          });

          changeDeltaPackage.push({
            '_id': literatureItem._id,
            'tags': wantedTags
          });
        }
      });

      return changeDeltaPackage;
    };
  }
}());

/**
 * Created by davidhickson on 21/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('createDeltaFromTagCategoryTitleChange', createDeltaFromTagCategoryTitleChange);

  createDeltaFromTagCategoryTitleChange.$inject = [];

  function createDeltaFromTagCategoryTitleChange() {
    return function (tagcategory, newTitle) {
      var delta = {
        '_id': tagcategory._id,
        'category': newTitle
      };

      return delta;
    };
  }
}());

/**
 * Created by davidhickson on 27/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('createDeltaFromTagCaptionChange', createDeltaFromTagCaptionChange);

  createDeltaFromTagCaptionChange.$inject = ['$log'];

  function createDeltaFromTagCaptionChange($log) {
    return function (tagToModify, newTagTitle, tagCategory) {

      var tagsClone = tagCategory.tags.map(function (existingTag) {
        if (existingTag._id === tagToModify._id) {
          var replacementTag = {};
          Object.getOwnPropertyNames(existingTag).forEach(function (pname) {
            replacementTag[pname] = existingTag[pname];
          });
          replacementTag.title = newTagTitle;
          return replacementTag;
        } else {
          return existingTag;
        }
      });

      $log.info('tags>processes> create.delta.from.tag.caption.change NEEDS TO WORRY ABOUT tagFastLookup');

      return {
        '_id': tagCategory._id,
        'tags': tagsClone
      };
    };
  }
}());

/**
 * Created by davidhickson on 21/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('createDeltaFromDeleteTag', createDeltaFromDeleteTag);

  createDeltaFromDeleteTag.$inject = [];

  function createDeltaFromDeleteTag() {
    return function (tagToDelete, tagCategory) {
      var tagsClone = tagCategory.tags.filter(function (tag) {
        return tag._id != tagToDelete._id;
      });

      return {
        '_id': tagCategory._id,
        'tags': tagsClone
      };
    };
  }
}());

/**
 * Created by davidhickson on 21/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('createDeltaFromAddTag', createDeltaFromAddTag);

  createDeltaFromAddTag.$inject = ['uuidService'];

  function createDeltaFromAddTag(uuidService) {
    return function (tagcategory, newTagTitle) {
      var tagsClone = tagcategory.tags.map(function (tag) {
        return tag;
      });

      var newId = uuidService.getSingleNewBase64Key();
      var newTag = {
        '_id': newId,
        'title': newTagTitle
      };

      tagsClone.push(newTag);

      return {
        '_id': tagcategory._id,
        'tags': tagsClone
      };
    };
  }
}());

/**
 * Created by davidhickson on 21/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('assertTagReferencedByLiteratureItem', assertTagReferencedByLiteratureItem);

  assertTagReferencedByLiteratureItem.$inject = [];

  function assertTagReferencedByLiteratureItem() {
    return function (literatureModel, tag) {

      var rc = false;

      literatureModel.literatureItems.forEach(function (literatureItem) {
        literatureItem.tags.forEach(function (tagId) {
          if (tag._id == tagId) {
            rc = true;
          }
        });
      });

      return rc;
    };
  }
}());

/**
 * Created by davidhickson on 13/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('tagsStatsCreator', tagsStatsCreator);

  tagsStatsCreator.$inject = [];

  function tagsStatsCreator() {
    return function (arrayOfTagCategories) {

      var stats = {
        countOfSelectedTags: 0
      };

      arrayOfTagCategories.forEach(function (tagCategory) {
        tagCategory.tags.forEach(function (tag) {
          if (tag.isSelected) stats.countOfSelectedTags++;
        });
      });

      return stats;

    };
  }
}());

/**
 * Created by davidhickson on 13/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('tagsPhrasesCreator', tagsPhrasesCreator);

  tagsPhrasesCreator.$inject = [];

  function tagsPhrasesCreator() {
    return function (tagStats) {

      var phrases = {};

      if (tagStats.countOfSelectedTags === 0) phrases.countOfSelectedTagsPhrase = 'No tags selected';
      else if (tagStats.countOfSelectedTags === 1) phrases.countOfSelectedTagsPhrase = '1 tag is selected';
      else phrases.countOfSelectedTagsPhrase = '' + tagStats.countOfSelectedTags + ' tags are selected';

      return phrases;

    };
  }
}());

/**
 * Created by davidhickson on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('tagsModel', tagsModel);

  tagsModel.$inject = ['tagsStatsCreator', 'tagsPhrasesCreator'];

  function tagsModel(statsCreator, phrasesCreator) {
    var tagCategories = [];
    var stats = {};

    var replaceEntireTagCategoriesArrayWith = function (newArray) {
      // It is essential that we MODIFY the EXISTING array, rather than simply assigning a brand-new array
      // This is because we may have other references elsewhere (via require(./data/xxxxxxx.model) that are pointing to the CURRENT model array, and these will be nuked if we say tagCategories = New Array() or similar

      tagCategories.length = 0; // Clear the array, but leave the existing reference in place

      newArray.forEach(function (item) {
        tagCategories.push(item);
      });

      updateStats();
    };

    var updateStats = function () {
      var newStats = statsCreator(tagCategories);
      var newPhrases = phrasesCreator(newStats);

      Object.getOwnPropertyNames(newStats).forEach(function (propertyName) {
        stats[propertyName] = newStats[propertyName];
      });

      Object.getOwnPropertyNames(newPhrases).forEach(function (propertyName) {
        stats[propertyName] = newPhrases[propertyName];
      });
    };

    var tagTitle = function (tagId) {
      for (var i = 0; i < tagCategories.length; i++) {
        var cat = tagCategories[i];
        for (var j = 0; j < cat.tags.length; j++) {
          if (cat.tags[j]._id === tagId) return cat.tags[j].title;
        }
      }

      return 'could not locate title';
    };
    
    var tagTitleWithCategory = function (tagId) {
      for (var i = 0; i < tagCategories.length; i++) {
        var cat = tagCategories[i];
        for (var j = 0; j < cat.tags.length; j++) {
          if (cat.tags[j]._id === tagId) return cat.category + ' - ' + cat.tags[j].title;
        }
      }

      return 'could not locate title';
    };

    return {
      tagCategories: tagCategories,
      stats: stats,
      replaceEntireTagCategoriesArrayWith: replaceEntireTagCategoriesArrayWith,
      tagTitle: tagTitle,
      tagTitleWithCategory: tagTitleWithCategory,
      updateStats: updateStats
    };
  }
}());

/**
 * Created by davidhickson on 26/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('literatureTagFilter', literatureTagFilter);

  literatureTagFilter.$inject = [];

  function literatureTagFilter() {

    var tags = {}; // An object used to hold all the 'active' tags that comprise the current literature view filter

    var toggleTagInFilter = function (tag) {

      if (tags[tag._id]) {
        delete tags[tag._id];
      } else {
        tags[tag._id] = 1;
      }

    };

    var isTagSelected = function (tag) {
      return tags[tag._id] == 1;
    };

    return {
      tags: tags,
      toggleTagInFilter: toggleTagInFilter,
      isTagSelected: isTagSelected
    };
  }
}());

/**
 * Created by davidhickson on 10/04/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('tagsMain', {
      templateUrl: 'app/showroom/tags/main/tags-main.tmpl.html',
      controllerAs: 'vm',
      controller: ['tagsManager', function (tagsManager) {

        // var vm = this;
        tagsManager.factoryData.tagSelectedCount = 0;
      }]
    });
})();

/**
 * Created by davidhickson on 12/06/2017.
 */

// Returns an almost exact copy of the literatureItems array, but with a toggled tag.
(function () {
  'use strict';
  angular.module('showroom').factory('toggleLitItemTagSelectionState', toggleLitItemTagSelectionState);

  toggleLitItemTagSelectionState.$inject = [];

  function toggleLitItemTagSelectionState() {
    return function (arrayOfLiteratureItems, toggledLitItem, toggledTag) {
      return arrayOfLiteratureItems.map(function (item) {
        if (toggledLitItem._id === item._id) {
          toggledLitItem.extendedTags.forEach(function (extendedTag) {
            if (extendedTag._id === toggledTag._id) {
              extendedTag.isSelected = !extendedTag.isSelected;
            }
          });
        }
        return item;
      });
    };
  }
})();

/**
 * Created by davidhickson on 12/06/2017.
 */

// This seems incredibly wasteful, but returns a copy of the original literatureItems array with a single item having had its selection flag toggled.
(function () {
  'use strict';
  angular.module('showroom').factory('toggleLitItemSelectionState', toggleLitItemSelectionState);

  toggleLitItemSelectionState.$inject = [];

  function toggleLitItemSelectionState() {
    return function (arrayOfLiteratureItems, toggledLitItem) {
      return arrayOfLiteratureItems.map(function (item) {
        if (toggledLitItem._id === item._id) {
          item.selected = !item.selected;
        }
        return item;
      });
    };
  }
})();

/**
 * Created by davidhickson on 08/06/2017.
 */

/*
    A pure function to set the isShouldBeDisplayed flag on all literatureItems
 */

(function () {
  'use strict';
  angular.module('showroom').factory('stampViewAttributes', stampViewAttributes);

  stampViewAttributes.$inject = [];

  function stampViewAttributes() {
    return function (literatureItems) {
      return literatureItems.map(function (item) {
        item.isShouldBeDisplayed = true;
        return item;
      });
    };
  }
})();

/**
 * Created by davidhickson on 08/06/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('stampTagInfo', stampTagInfo);

  stampTagInfo.$inject = [];

  function stampTagInfo() {
    return function (literatureItems) {
      return literatureItems.map(function (literatureItem) {
        literatureItem.extendedTags = [];
        if (!literatureItem.tags) {
          literatureItem.tags = [];
        }

        literatureItem.tags.forEach(function (tagId) {
          literatureItem.extendedTags.push({
            '_id': tagId,
            'isSelected': false
          });
        });

        return literatureItem;
      });
    };
  }
})();

/**
 * Created by davidhickson on 13/06/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('ingestArrayOfDeltas', ingestArrayOfDeltas);

  ingestArrayOfDeltas.$inject = ['$log'];

  function ingestArrayOfDeltas($log) {
    return function (existingModelLiteratureItems, arrayOfDeltas) {
      /*
          This is an impure function that modifies the existing literature model (which is passed in).
          This function takes the inbound array of literature deltas and merges it with the current literature model.
       */
      $log.info('LITERATURE ingest.array.of.deltas has been passed the following arrayOfDeltas');
      $log.info(arrayOfDeltas);

      arrayOfDeltas.forEach(function (inboundLiteratureDelta) {
        var found = false;
        existingModelLiteratureItems.forEach(function (existingLiteratureItem) {
          if (inboundLiteratureDelta._id == existingLiteratureItem._id) {
            found = true;
            Object.getOwnPropertyNames(inboundLiteratureDelta).forEach(function (propertyName) {
              existingLiteratureItem[propertyName] = inboundLiteratureDelta[propertyName];
            });
          }
        });

        if (!found) {
          existingModelLiteratureItems.push(inboundLiteratureDelta);
        }
      });
    };
  }
})();

/**
 * Created by davidhickson on 21/06/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('ingestArchiveDelta', ingestArchiveDelta);

  ingestArchiveDelta.$inject = [];

  function ingestArchiveDelta() {
    return function (arrayOfExistingLiteratureItems, archiveDelta) {
      /*
          This is an IMPURE function that modifies the current literature model by removing all the items with _id values in the archiveDelta array.
       */
      archiveDelta.forEach(function (delta) {
        for (var i = arrayOfExistingLiteratureItems.length - 1; i > -1; i--) {
          if (arrayOfExistingLiteratureItems[i]._id === delta._id) {
            arrayOfExistingLiteratureItems.splice(i, 1);
          }
        }
      });
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('showroom')
    .factory('stampDropboxThumbs', stampDropboxThumbs);

  stampDropboxThumbs.$inject = ['dropboxApiService', 'MessageService'];

  function stampDropboxThumbs(dropboxApiService, MessageService) {
    return function (literatureItems) {
      var arrayOfPaths = [];
      _.each(literatureItems, function (item) {
        if(item.dropboxPath) {
          arrayOfPaths.push({
            path: item.dropboxPath
          });
        }
      });

      return dropboxApiService.getThumbnailBatch(arrayOfPaths)
        .then(function (res) {
          MessageService.writeLog({
            level: 'info',
            msg: 'got thumbs' + JSON.stringify(res)
          });

        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: 'dont got thumbs' + JSON.stringify(err)
          });
        });
    };
  }
})();

/**
 * Created by davidhickson on 21/06/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('getSelectedLiteratureIds', getSelectedLiteratureIds);

  getSelectedLiteratureIds.$inject = [];

  function getSelectedLiteratureIds() {
    return function (existingLiteratureItems) {
      var arrayOfIdObjects = [];

      existingLiteratureItems.forEach(function (literatureItem) {
        if (literatureItem.selected) {
          arrayOfIdObjects.push({
            '_id': literatureItem._id
          });
        }
      });

      return arrayOfIdObjects;
    };
  }
})();

/**
 * Created by davidhickson on 26/06/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('getLitIdsSatisfyingDisplayFilters', getLitIdsSatisfyingDisplayFilters);

  getLitIdsSatisfyingDisplayFilters.$inject = [];

  function getLitIdsSatisfyingDisplayFilters() {
    return function (literatureItems, selectedTagIdsObject, currentSearchTerm, block) {
      var litIdDisplayObject = {};

      literatureItems.forEach(function (literatureItem) {
        var isShouldBeDisplayed = false;
        var i = 0;

        if (Object.keys(selectedTagIdsObject).length == 0) {
          isShouldBeDisplayed = true;
        } else {
          if (literatureItem.tags && literatureItem.tags.length > 0) {
            literatureItem.tags.forEach(function (tagIdWithinLitItem) {
              if (selectedTagIdsObject[tagIdWithinLitItem]) {
                isShouldBeDisplayed = true;
              }
            });
          } else if (selectedTagIdsObject.hasOwnProperty('NoTag')) {
            isShouldBeDisplayed = true;
          }
        }

        if (isShouldBeDisplayed) {
          if (currentSearchTerm.length > 0) {
            isShouldBeDisplayed = false;

            if (literatureItem.title.toLowerCase().indexOf(currentSearchTerm) > -1) {
              isShouldBeDisplayed = true;
            } else {
              if (typeof literatureItem.keywords !== 'undefined') {
                for (i = 0; i < literatureItem.keywords.length; i++) {
                  if (literatureItem.keywords[i].indexOf(currentSearchTerm) > -1) {
                    i = literatureItem.keywords.length;
                    isShouldBeDisplayed = true;
                  }
                }
              }
            }
          }
        }

        if (isShouldBeDisplayed && block && block.literatures) {
          i = 0;
          var len = block.literatures.length;
          var found = false;
          for (i; i < len; i++) {
            if (block.literatures[i]._id === literatureItem._id) {
              found = true;
            }
          }

          if (!found) {
            isShouldBeDisplayed = false;
          }
        }

        if (isShouldBeDisplayed) {
          litIdDisplayObject[literatureItem._id] = 1;
        }
      });

      return litIdDisplayObject;
    };
  }
})();

/**
 * Created by davidhickson on 21/06/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('createDeltasFromLiteratureItems', createDeltasFromLiteratureItems);

  createDeltasFromLiteratureItems.$inject = ['$log', 'literatureHelperService'];

  function createDeltasFromLiteratureItems($log, literatureHelperService) {
    return function (arrayOfExistingLiteratureItems, arrayOfInboundLiteratureItems) {
      /*
          This function returns an array of literature change deltas.
          In a nutshell it essentially just returns the original arrayOfInboundLiteratureItems, but it will embellish any NEW items with some default values.
       */
      $log.info('LITERATURE create.deltas.from.literature.items has arrayOfInboundLiteratureItems as follows:');
      $log.info(arrayOfInboundLiteratureItems);

      return arrayOfInboundLiteratureItems.map(function (inboundLiteratureItem) {
        var alreadyExists = false;
        arrayOfExistingLiteratureItems.forEach(function (existingLiteratureItem) {
          if (inboundLiteratureItem._id == existingLiteratureItem._id) {
            alreadyExists = true;
          }
        });

        if (!alreadyExists) {
          // We must embellish NEW items with some default properties
          inboundLiteratureItem.tags = [];
          // inboundLiteratureItem.extendedTags = [];
          // inboundLiteratureItem.isShouldBeDisplayed = true;
        }
        inboundLiteratureItem.contenttype = literatureHelperService.getContentTypeForItem({
          url: inboundLiteratureItem.weburi
        });
        inboundLiteratureItem.mediatype = 'url';

        // delete client side application props
        delete inboundLiteratureItem.extendedTags;
        delete inboundLiteratureItem.isShouldBeDisplayed;
        delete inboundLiteratureItem.selected;

        return inboundLiteratureItem;
      });
    };
  }
})();

/**
 * Created by davidhickson on 12/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('literatureStatsCreator', literatureStatsCreator);

  literatureStatsCreator.$inject = [];

  function literatureStatsCreator() {
    return function (arrayOfLiteratureItems) {

      var stats = {
        countOfSelectedLiteratureItems: 0,
        countOfSelectedLitItemTags: 0,
        countOfLitItemsWithNoTag: 0
      };

      arrayOfLiteratureItems.forEach(function (litItem) {
        if (litItem.selected) stats.countOfSelectedLiteratureItems++;

        if (litItem.extendedTags) {
          litItem.extendedTags.forEach(function (extendedTag) {
            if (extendedTag.isSelected) stats.countOfSelectedLitItemTags++;
          });
        }
        
        if (!litItem.tags || litItem.tags.length === 0) {
          stats.countOfLitItemsWithNoTag++;
        }
      });

      return stats;
    };
  }
}());

/**
 * Created by davidhickson on 13/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('literaturePhrasesCreator', literaturePhrasesCreator);

  literaturePhrasesCreator.$inject = [];

  function literaturePhrasesCreator() {
    return function (literatureStats) {

      var phrases = {};

      if (literatureStats.countOfSelectedLiteratureItems === 0) phrases.countOfSelectedLiteratureItemsPhrase = 'kNo lit selected';
      else if (literatureStats.countOfSelectedLiteratureItems === 1) phrases.countOfSelectedLiteratureItemsPhrase = 'k1 lit item is selected';
      else phrases.countOfSelectedLiteratureItemsPhrase = '' + literatureStats.countOfSelectedLiteratureItems + ' klit items are selected';

      if (literatureStats.countOfSelectedLitItemTags === 0) phrases.countOfSelectedLitItemTagsPhrase = 'kNo lit tags selected';
      else if (literatureStats.countOfSelectedLitItemTags === 1) phrases.countOfSelectedLitItemTagsPhrase = 'k1 lit tag is selected';
      else phrases.countOfSelectedLitItemTagsPhrase = '' + literatureStats.countOfSelectedLitItemTags + ' klit tags are selected';

      var tagToken = '';
      var litToken = '';
      var litTagToken = '';

      if (literatureStats.countOfSelectedTags === 0) tagToken = '0';
      else if (literatureStats.countOfSelectedTags === 1) tagToken = '1';
      else tagToken = '+';

      if (literatureStats.countOfSelectedLiteratureItems === 0) litToken = '0';
      else if (literatureStats.countOfSelectedLiteratureItems === 1) litToken = '1';
      else litToken = '+';

      if (literatureStats.countOfSelectedLitItemTags === 0) litTagToken = '0';
      else if (literatureStats.countOfSelectedLitItemTags === 1) litTagToken = '1';
      else litTagToken = '+';

      var token = tagToken + ':' + litToken;
      switch (token) {
        case '0:0':
          phrases.applyTagsToLitPhrase = 'To tag literature you must select at least one tag from the Available Tags area and one item of literature from the Literature Library';
          break;
        case '1:0':
          phrases.applyTagsToLitPhrase = 'To apply the selected tag you must select at least one item of literature from the Literature Library';
          break;
        case '+:0':
          phrases.applyTagsToLitPhrase = 'To apply the selected tags you must select at least one item of literature from the Literature Library';
          break;
        case '0:1':
        case '0:+':
          phrases.applyTagsToLitPhrase = 'To tag the selected literature you must select at least one tag from the Available Tags';
          break;
        case '1:1':
        case '1:+':
          phrases.applyTagsToLitPhrase = 'Please click the button below to apply the selected tag to the selected literature';
          break;
        case '+:1':
        case '+:+':
          phrases.applyTagsToLitPhrase = 'Please click the button below to apply the selected tags to the selected literature';
          break;
      }

      switch (litTagToken) {
        case '0':
          phrases.removeTagsFromLitPhrase = 'To disconnect tags from literature please see the literature section on the right and click the tags you wish to disconnect';
          break;
        case '1':
          phrases.removeTagsFromLitPhrase = 'To disconnect the selected tag please click the button below';
          break;
        case '+':
          phrases.removeTagsFromLitPhrase = 'To disconnect the selected tags please click the button below';
          break;
      }

      return phrases;
    };
  }
}());

/**
 * Created by davidhickson on 24/05/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('literatureModel', literatureModel);

  literatureModel.$inject = ['literatureStatsCreator', 'literaturePhrasesCreator', '$log'];

  function literatureModel(statsCreator, phrasesCreator, $log) {

    var literatureItems = []; // This is the central data structure for literature - an array of literature items
    var stats = {};
    var currentSearchTerm = '';

    var replaceEntireLiteratureItemsArrayWith = function (newArray) {
      // It is essential that we MODIFY the EXISTING model.literatureItems array, rather than simply assigning a brand-new array to model.literatureItems.
      // This is because we may have other references elsewhere (via require(./model/literature.model) that are pointing to the CURRENT model.literatureItems array, and these will be nuked if we did literatureItems = New Array() or similar

      literatureItems.length = 0; // Clear the array, but leave the existing reference in place

      newArray.forEach(function (item) {
        literatureItems.push(item);
      });

      requestLitStatsUpdate();
    };

    var requestLitStatsUpdate = function () {
      var newStats = statsCreator(literatureItems);
      var newPhrases = phrasesCreator(newStats);

      Object.getOwnPropertyNames(newStats).forEach(function (propertyName) {
        stats[propertyName] = newStats[propertyName];
      });

      Object.getOwnPropertyNames(newPhrases).forEach(function (propertyName) {
        stats[propertyName] = newPhrases[propertyName];
      });
    };

    var adjustDisplayedItems = function (litIdDisplayObject) {
      $log.info('literature.model adjustDisplayedItems running, litIdDisplayObject follows');
      $log.info(litIdDisplayObject);

      literatureItems.forEach(function (literatureItem) {
        literatureItem.isShouldBeDisplayed = litIdDisplayObject[literatureItem._id] === 1;

        if (literatureItem.selected && !literatureItem.isShouldBeDisplayed) {
          literatureItem.selected = false;
        }

        if (literatureItem.extendedTags && !literatureItem.isShouldBeDisplayed) {
          literatureItem.extendedTags.forEach(function (extendedTag) {
            extendedTag.isSelected = false;
          });
        }

      });
      requestLitStatsUpdate();
    };

    return {
      literatureItems: literatureItems,
      currentSearchTerm: currentSearchTerm,
      stats: stats,
      replaceEntireLiteratureItemsArrayWith: replaceEntireLiteratureItemsArrayWith,
      requestLitStatsUpdate: requestLitStatsUpdate,
      adjustDisplayedItems: adjustDisplayedItems
    };
  }
}());

/**
 * Created by davidhickson on 10/04/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('literatureMain', {
      templateUrl: 'app/showroom/literature/main/literature-main.tmpl.html',
      controllerAs: 'vm',
      controller: ['$scope', 'literatureManager', 'literatureXrefTagsManager', 'MasterPermissionsDefinitionFactory', function ($scope, literatureManager, literatureXrefTagsManager, MasterPermissionsDefinitionFactory) {

        var vm = this;

        vm.litsvcreference = literatureManager;
        vm.litxrefsvcreference = literatureXrefTagsManager;
        vm.selectAll = false;
        vm.permissions = MasterPermissionsDefinitionFactory;
        
        vm.onToggleFilterTagSelection = function (showUntagged) {
          if (showUntagged && !literatureXrefTagsManager.isTagSelected({ _id: 'NoTag' })) {
            literatureXrefTagsManager.toggleFilterTagSelection({ _id: 'NoTag' });
          } else if (!showUntagged && literatureXrefTagsManager.isTagSelected({ _id: 'NoTag' })) {
            literatureXrefTagsManager.toggleFilterTagSelection({ _id: 'NoTag' });
          }
        };

        vm.toggleSelectAll = function () {
          if (vm.selectAll) {
            literatureManager.selectAllVisibleLit();
          } else {
            literatureManager.deselectAllLit();
          }
        };

        vm.hasTagsSelected = function () {
          return Object.keys(literatureXrefTagsManager.tags).length > 0;
        };

        vm.removeFilters = function () {
          literatureXrefTagsManager.deselectAllTagsExcept({ _id: 'NoTag' });
          if (vm.showUntagged === true) {
            vm.showUntagged = false;
          }
        };

        $scope.$watch('vm.showUntagged', function (newVal) {
          vm.onToggleFilterTagSelection(newVal);
        });

        return vm;
      }]
    });
})();

/**
 * Created by davidhickson on 10/04/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('literatureCards', {
      templateUrl: 'app/showroom/literature/main/literature-cards.tmpl.html',
      controllerAs: 'vm',
      controller: ['literatureManager', 'literatureXrefTagsManager', 'tagsManager', '$scope', 'MasterPermissionsDefinitionFactory', function (literatureManager, literatureXrefTagsManager, tagsManager, $scope, MasterPermissionsDefinitionFactory) {

        var vm = this;

        vm.litsvcreference = literatureManager;
        vm.tagssvcreference = tagsManager;
        vm.selectAll = false;
        vm.permissions = MasterPermissionsDefinitionFactory;

        vm.$onInit = function () {
          // literatureManager.factoryData.inCardView = true;
        };

        vm.onToggleFilterTagSelection = function (showUntagged) {
          if (showUntagged && !literatureXrefTagsManager.isTagSelected({ _id: 'NoTag' })) {
            literatureXrefTagsManager.toggleFilterTagSelection({ _id: 'NoTag' });
          } else if (!showUntagged && literatureXrefTagsManager.isTagSelected({ _id: 'NoTag' })) {
            literatureXrefTagsManager.toggleFilterTagSelection({ _id: 'NoTag' });
          }
        };

        vm.toggleSelectAll = function () {
          if (vm.selectAll) {
            literatureManager.selectAllVisibleLit();
          } else {
            literatureManager.deselectAllLit();
          }
        };


        vm.hasTagsSelected = function () {
          return Object.keys(literatureXrefTagsManager.tags).length > 0;
        };

        vm.removeFilters = function () {
          literatureXrefTagsManager.deselectAllTagsExcept({ _id: 'NoTag' });
          if (vm.showUntagged === true) {
            vm.showUntagged = false;
          }


        };

        $scope.$watch('vm.showUntagged', function (newVal) {
          vm.onToggleFilterTagSelection(newVal);
        });

        return vm;
      }]
    });
})();

/**
 * Created by davidhickson on 10/04/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('fileImportMain', {
      templateUrl: 'app/showroom/import/main/file-import-main.tmpl.html',
      controller: ['literatureManager', 'blocksManager', function (literatureManager, blocksManager) {

        this.litsvcreference = literatureManager;
        this.blockssvcreference = blocksManager;
      }]
    });
})();
/**
 * Created by davidhickson on 10/04/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('imagesMain', {
      templateUrl: 'app/showroom/images/main/images-main.tmpl.html',
      controllerAs: 'vm',
      controller: function () {

        var vm = this;

        return vm;
      }
    });
})();

/**
 * Created by davidhickson on 26/04/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .controller('RemoveLiteratureFromBlockDialogController', ['litDoc', 'parentBlockDoc', '$log', 'blocksXrefLiteratureManager', 'MessageService', 'ChangeDelta', 'hotkeys', function (litDoc, parentBlockDoc, $log, blocksXrefLiteratureManager, MessageService, ChangeDelta, hotkeys) {

      var vm = this;
      vm.cancelDialog = cancelDialog;
      vm.hide = hide;

      function init() {
        vm.litDoc = angular.copy(litDoc);
      }

      init();

      vm.removeLiterature = function () {
        vm.disableSaveButton = true;

        blocksXrefLiteratureManager.removeLitFromBlock(vm.litDoc, parentBlockDoc)
          .then(function () {
            MessageService.showMessage('Literature item removed');
            vm.disableSaveButton = false;
            ChangeDelta.clear();
            hide();
          })
          .catch(function (err) {
            vm.disableSaveButton = false;
            $log.error(err);
            MessageService.writeLog({
              level: 'error',
              msg: err
            });
            MessageService.showMessage(err.data.data.message);
          });
      };

      // modal dismiss functions
      function hide(answer) {
        hotkeys.del('enter');
        MessageService.closeDialog(answer);
      }

      function cancelDialog() {
        hotkeys.del('enter');
        MessageService.cancelDialog();
      }

    }]);
})();

/**
 * Created by davidhickson on 26/04/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .controller('RemoveBlockDialogController', ['blockDoc', 'parentBlockDoc', '$log', 'blocksManager', 'MessageService', 'ChangeDelta', 'hotkeys', function (blockDoc, parentBlockDoc, $log, blocksManager, MessageService, ChangeDelta, hotkeys) {

      var vm = this;
      vm.cancelDialog = cancelDialog;
      vm.hide = hide;
      vm.removalOption = 'root';

      function init() {
        vm.blockDoc = angular.copy(blockDoc);
      }

      init();

      vm.removeBlock = function () {
        vm.disableSaveButton = true;
        var func;

        switch (vm.removalOption) {
          case 'archive':
            func = vm.archiveBlock;
            break;
          case 'root':
            func = vm.removeBlockFromParent;
            break;
        }

        func()
          .then(function () {
            MessageService.showMessage('Block removed');
            vm.disableSaveButton = false;
            ChangeDelta.clear();
            hide();
          })
          .catch(function (err) {
            vm.disableSaveButton = false;
            $log.error(err);
            MessageService.writeLog({
              level: 'error',
              msg: err
            });
            MessageService.showMessage(err.data.data.message);
          });
      };

      vm.archiveBlock = function () {
        return blocksManager.archiveBlock(vm.blockDoc);
      };

      vm.removeBlockFromParent = function () {
        return blocksManager.removeBlockFromBlock(vm.blockDoc, parentBlockDoc);
      };

      // modal dismiss functions
      function hide(answer) {
        hotkeys.del('enter');
        MessageService.closeDialog(answer);
      }

      function cancelDialog() {
        hotkeys.del('enter');
        MessageService.cancelDialog();
      }

    }]);
})();

/**
 * Created by davidhickson on 26/04/2017.
 */

(function () {
  'use strict';
  angular
    .module('showroom')
    .controller('AddLiteratureBlockDialogController', controller);

  controller.$inject = ['blockDoc', '$scope', '$log', 'blocksManager', 'literatureManager', 'blocksXrefLiteratureManager', 'tagsManager', 'MessageService', 'uuidService', 'ChangeDelta', 'hotkeys', '$state'];
  /* ng-inject */
  function controller(blockDoc, $scope, $log, blocksManager, literatureManager, blocksXrefLiteratureManager, tagsManager, MessageService, uuidService, ChangeDelta, hotkeys, $state) {

    var vm = this;
    vm.cancelDialog = cancelDialog;
    vm.hide = hide;

    function init() {
      vm.block = angular.copy(blockDoc);
    }

    init();

    vm.blockssvcreference = blocksManager;
    vm.literaturesvc = literatureManager;
    vm.selectAll = false;

    vm.toggleSelectAll = function () {
      if (vm.selectAll) {
        literatureManager.selectAllVisibleLit();
      } else {
        literatureManager.deselectAllLit();
      }
    };

    vm.getTagTitle = function (tagId) {
      return tagsManager.tagTitle(tagId);
    };

    vm.requestLitStatsUpdate = function () {
      literatureManager.requestLitStatsUpdate();
    };

    vm.searchTextChanged = function () {
      literatureManager.literatureTextSearchTermChanged(vm.searchTerm);
    };

    vm.toggleLitLibraryLitItemSelection = function (litItem) {
      literatureManager.toggleItemSelection(litItem);
    };

    vm.applySelectedItemsToCurrentBlockClicked = function () {
      return blocksXrefLiteratureManager.applySelectedLiteratureToCurrentBlock(vm.block)
        .then(function () {
          MessageService.showMessage('Literature added');
          vm.disableSaveButton = false;
          ChangeDelta.clear();
          hide(vm.block);
        })
        .catch(function (err) {
          vm.disableSaveButton = false;
          $log.error(err);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
          MessageService.showMessage(err.data.data.message);
        });
    };

    vm.goToLiterature = function () {
      $state.go('app.oldshowroom.showroom.literature');
      cancelDialog();
    };

    // modal dismiss functions
    function hide(answer) {
      hotkeys.del('enter');
      MessageService.closeDialog(answer);
    }

    function cancelDialog() {
      hotkeys.del('enter');
      MessageService.cancelDialog();
    }

  }

})();

/**
 * Created by davidhickson on 26/04/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .controller('AddExistingBlocksBlockDialogController', ['blockDoc', '$scope', '$log', 'blocksManager', 'literatureManager', 'tagsManager', 'MessageService', 'ChangeDelta', 'hotkeys', function (blockDoc, $scope, $log, blocksManager, literatureManager, tagsManager, MessageService, ChangeDelta, hotkeys) {

      var vm = this;

      function init() {
        vm.cancelDialog = cancelDialog;
        vm.hide = hide;
        vm.searchTerm = '';
        vm.blockssvcreference = blocksManager;
        vm.literaturesvc = literatureManager;
        vm.block = blockDoc;
        vm.blockList = [];
        vm.hydrateBlockList = hydrateBlockList;

        vm.hydrateBlockList();
      }

      init();

      function hydrateBlockList() {
        // Prevent circular references by removing any parent blocks from list of blocks
        var i = 0;
        var len = blocksManager.blocks.length;

        for (i; i < len; i++) {
          if (hasNoCircularDependencies(blocksManager.blocks[i]) && !inList(blocksManager.blocks[i])) {
            vm.blockList.push(blocksManager.blocks[i]);
          }
        }
      }

      vm.getTagTitle = function (tagId) {
        return tagsManager.tagTitle(tagId);
      };

      vm.searchTextChanged = function () {
        blocksManager.blocksTextSearchTermChanged(vm.searchTerm);
      };

      vm.toggleBlockSelection = function (block) {
        block.selectedForPush = !block.selectedForPush;
        blocksManager.requestBlockStatsUpdate();
      };

      vm.requestBlockStatsUpdate = function () {
        blocksManager.requestBlockStatsUpdate();
      };

      vm.addNewBlock = function () {
        var dialogConfig = angular.copy(BlocksMetadataFactory.getData().addDialogConfig);
        dialogConfig.locals.parentBlockDoc = vm.block;

        MessageService.showDialog({}, dialogConfig);
      };

      function checkIfBlockIsParent(parentBlocks, block) {
        var i = 0;
        var len = parentBlocks.length;
        var ret = true;

        for (i; i < len; i++) {
          if (parentBlocks[i]._id === block._id) {
            ret = false;
          } else if (parentBlocks[i].arrayOfParentBlocks.length > 0) {
            ret = checkIfBlockIsParent(parentBlocks[i].arrayOfParentBlocks, block);
          }
        }

        return ret;
      }

      function hasNoCircularDependencies(block) {
        var ret = true;

        if (vm.block._id === block._id) {
          ret = false;
        } else if (vm.block.arrayOfParentBlocks.length > 0) {
          ret = checkIfBlockIsParent(vm.block.arrayOfParentBlocks, block);
        }

        return ret;
      }

      function inList(block) {
        var i = 0;
        var len = vm.blockList.length;
        var found = false;

        for (i; i < len; i++) {
          if (block._id === vm.blockList[i]._id) {
            found = true;
          }
        }

        return found;
      }

      vm.applySelectedItemsToCurrentBlockClicked = function () {
        return blocksManager.applySelectedBlockToCurrentBlock(vm.block)
          .then(function () {
            MessageService.showMessage('Blocks added');
            vm.disableSaveButton = false;
            ChangeDelta.clear();
            vm.blockssvcreference.deselectAllBlocksForPush();
            hide(vm.block);
          })
          .catch(function (err) {
            vm.disableSaveButton = false;
            $log.error(err);
            MessageService.writeLog({
              level: 'error',
              msg: err
            });
            MessageService.showMessage(err.data.data.message);
          });
      };

      // modal dismiss functions
      function hide(answer) {
        hotkeys.del('enter');
        MessageService.closeDialog(answer);
      }

      function cancelDialog() {
        hotkeys.del('enter');
        MessageService.cancelDialog();
      }

    }]);
})();

/**
 * Created by davidhickson on 26/04/2017.
 */

(function () {
  'use strict';
  angular
    .module('showroom')
    .controller('EditParentBlockDialogController', ctrl);

  ctrl.$inject = ['blockDoc', '$scope', '$log', 'blocksManager', 'ImagesApiFactory', 'MessageService', 'uuidService', 'ChangeDelta', 'hotkeys', 'locals'];
  /* ng-inject */
  function ctrl(blockDoc, $scope, $log, blocksManager, ImagesApiFactory, MessageService, uuidService, ChangeDelta, hotkeys, locals) {

    var vm = this;
    vm.cancelDialog = cancelDialog;
    vm.logoReady = false;
    vm.loading = false;
    vm.hide = hide;
    vm.formType = locals.formType;
    vm.imageType = '';
    vm.imageDoc = {
      title: '',
      weburi: ''
    };
    vm.showHints = false;

    vm.setLogoReady = function (val, filename) {
      vm.logoReady = val;
      vm.imageDoc.filename = filename;
      $scope.$digest();
    };

    function init() {
      vm.listOfImages = ImagesApiFactory.factoryData.arrayOfImageItems;
      vm.block = angular.copy(blockDoc);
      vm.blockForm = {
        $invalid: true
      };
    }

    init();

    vm.setImageType = function (type) {
      vm.imageType = type;
      if (type === 'weburi') {
        delete vm.filename;
      }
    };

    vm.saveBlock = function () {
      if (vm.block.backgroundImage == '0_new') {
        vm.uploadImage();
      } else {
        vm.addBlock();
      }
    };

    vm.addBlock = function () {

      var block = blocksManager.getDelta(vm.block);

      return blocksManager.ingestBlockDelta(block)
        .then(function () {
          MessageService.showMessage('Block edited');
          vm.disableSaveButton = false;
          ChangeDelta.clear();
          hide(block);
        })
        .catch(function (err) {
          vm.disableSaveButton = false;
          $log.error(err);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
          MessageService.showMessage(err.data.data.message);
        });
    };

    vm.uploadImage = function () {
      if (!vm.imageDoc._id) {
        vm.imageDoc._id = uuidService.getSingleNewBase64Key();
      }

      ImagesApiFactory.ingestChangedImageItem(vm.imageDoc, vm.imageType)
        .then(function () {
          vm.block.backgroundImage = vm.imageDoc._id;
          vm.addBlock();
        })
        .catch(function (err) {
          vm.disableSaveButton = false;
          $log.error(err);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
          MessageService.showMessage(err.data.data.message);
        });
    };

    // modal dismiss functions
    function hide(answer) {
      hotkeys.del('enter');
      MessageService.closeDialog(answer);
    }

    function cancelDialog() {
      hotkeys.del('enter');
      MessageService.cancelDialog();
    }

  }
})();

/**
 * Created by davidhickson on 26/04/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .controller('EditParentBlockVisualsDialogController', ['blockDoc', '$scope', '$log', 'blocksManager', 'ImagesApiFactory', 'MessageService', 'uuidService', 'ChangeDelta', 'hotkeys', function (blockDoc, $scope, $log, blocksManager, ImagesApiFactory, MessageService, uuidService, ChangeDelta, hotkeys) {

      var vm = this;
      vm.cancelDialog = cancelDialog;
      vm.logoReady = false;
      vm.hide = hide;

      vm.setLogoReady = function (val, filename) {
        vm.logoReady = val;
        vm.imageDoc.filename = filename;
        $scope.$digest();
      };

      function init() {
        vm.listOfImages = ImagesApiFactory.factoryData.arrayOfImageItems;
        vm.block = blockDoc; // don't copy because we want to see changes
        vm.blockForm = {
          $invalid: true
        };
      }

      init();

      vm.saveBlock = function () {

        var block = blocksManager.getDelta(vm.block);

        return blocksManager.ingestBlockDelta(block)
          .then(function () {
            MessageService.showMessage('Block edited');
            vm.disableSaveButton = false;
            ChangeDelta.clear();
            hide(block);
          })
          .catch(function (err) {
            vm.disableSaveButton = false;
            $log.error(err);
            MessageService.writeLog({
              level: 'error',
              msg: err
            });
            MessageService.showMessage(err.data.data.message);
          });
      };

      vm.uploadImage = function () {
        if (!vm.imageDoc._id) {
          vm.imageDoc._id = uuidService.getSingleNewBase64Key();
        }
        // TODO imageUpload
        ImagesApiFactory.ingestChangedImageItem(vm.imageDoc, vm.imageType)
          .then(function () {
            vm.block.backgroundImage = vm.imageDoc._id;
            vm.addBlock();
          })
          .catch(function (err) {
            vm.disableSaveButton = false;
            $log.error(err);
            MessageService.writeLog({
              level: 'error',
              msg: err
            });
            MessageService.showMessage(err.data.data.message);
          });
      };

      // modal dismiss functions
      function hide(answer) {
        hotkeys.del('enter');
        MessageService.closeDialog(answer);
      }

      function cancelDialog() {
        hotkeys.del('enter');
        MessageService.cancelDialog();
      }

    }]);
})();

/**
 * Created by davidhickson on 26/04/2017.
 */

(function () {
  'use strict';
  angular
    .module('showroom')
    .controller('AddBlockDialogController', ctrl);

  ctrl.$inject = ['blockDoc', 'parentBlockDoc', '$scope', '$log', 'blocksManager', 'ImagesApiFactory', 'MessageService', 'uuidService', 'ChangeDelta', 'hotkeys', 'locals'];
  /* ng-inject */
  function ctrl(blockDoc, parentBlockDoc, $scope, $log, blocksManager, ImagesApiFactory, MessageService, uuidService, ChangeDelta, hotkeys, locals) {

    var vm = this;
    vm.cancelDialog = cancelDialog;
    vm.logoReady = false;
    vm.loading = false;
    vm.hide = hide;
    vm.formType = locals.formType;
    vm.imageType = '';
    vm.imageDoc = {
      title: '',
      weburi: ''
    };
    vm.showHints = false;

    vm.setLogoReady = function (val, filename) {
      vm.logoReady = val;
      vm.imageDoc.filename = filename;
      $scope.$digest();
    };

    function init() {
      vm.listOfImages = ImagesApiFactory.factoryData.arrayOfImageItems;
      vm.block = angular.copy(blockDoc);
      vm.blockForm = {
        $invalid: true
      };
    }

    init();

    vm.setImageType = function (type) {
      vm.imageType = type;
      if (type === 'weburi') {
        delete vm.filename;
      }
    };

    function convertBlocksToIds(blocks) {
      var ret = [];

      if (blocks) {
        blocks.forEach(function (block) {
          ret.push(block._id);
        });
      }

      return ret;
    }

    vm.saveBlock = function () {
      vm.loading = true;
      if (vm.block.nameplateImage == '0_new') {
        vm.uploadImage();
      } else {
        vm.addBlock();
      }
    };

    vm.addBlock = function () {

      var block = blocksManager.getDelta(vm.block),
        delta = [block];

      if (parentBlockDoc !== null) {
        var parent = {};
        parent._id = parentBlockDoc._id || uuidService.getSingleNewBase64Key();
        parent.blocks = convertBlocksToIds(parentBlockDoc.blocks);

        if (parent.blocks.indexOf(block._id) < 0) {
          parent.blocks.push(block._id);
        }

        delta.push(parent);
      }

      if (block.blocks) {
        block.blocks = convertBlocksToIds(block.blocks);
      }

      return blocksManager.addBlockWithParent(delta)
        .then(function () {
          MessageService.showMessage('Block added');
          vm.disableSaveButton = false;
          ChangeDelta.clear();
          vm.loading = false;
          hide(block);
        })
        .catch(function (err) {
          vm.disableSaveButton = false;
          vm.loading = false;
          $log.error(err);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
          MessageService.showMessage(err.data.data.message);
        });
    };

    vm.uploadImage = function () {
      if (!vm.imageDoc._id) {
        vm.imageDoc._id = uuidService.getSingleNewBase64Key();
      }
      // TODO imageUpload
      ImagesApiFactory.ingestChangedImageItem(vm.imageDoc, vm.imageType)
        .then(function () {
          vm.block.nameplateImage = vm.imageDoc._id;
          vm.addBlock();
        })
        .catch(function (err) {
          vm.disableSaveButton = false;
          $log.error(err);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
          MessageService.showMessage(err.data.data.message);
        });
    };

    vm.removeBlock = function () {
      vm.disableSaveButton = true;

      if (block.nameplateImage === '0_new') {
        vm.uploadImage();
      } else {
        vm.addBlock();
      }

    };

    // modal dismiss functions
    function hide(answer) {
      hotkeys.del('enter');
      MessageService.closeDialog(answer);
    }

    function cancelDialog() {
      hotkeys.del('enter');
      MessageService.cancelDialog();
    }

  }
})();

/**
 * Created by davidhickson on 05/06/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('selectionProcesses', selectionProcesses);

  selectionProcesses.$inject = ['$log'];

  function selectionProcesses($log) {
    var deselectAllBlocksForPush = function (blocks) {
      $log.info('lieutenant will deselect all blocks!!!!!!!!!!!!!!!!!!!!!!');

      blocks.forEach(function (block) {
        block.selectedForPush = false;
      });
    };

    return {
      deselectAllBlocksForPush: deselectAllBlocksForPush
    };
  }
})();

/**
 * Created by davidhickson on 07/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('refreshDerivedProperties', refreshDerivedProperties);

  refreshDerivedProperties.$inject = [];

  function refreshDerivedProperties() {
    return function (blocks) {

      blocks.forEach(function (block) {
        block.isRootBlock = true;
        block.arrayOfParentBlocks = [];
      });

      blocks.forEach(function (block) {
        if (block.blocks) {
          block.blocks.forEach(function (innerBlock) {
            if (!innerBlock.arrayOfParentBlocks) {
              innerBlock.arrayOfParentBlocks = [];
            }
            innerBlock.arrayOfParentBlocks.push(block);
            innerBlock.isRootBlock = false;
          });
        }
      });
    };
  }
})();

/**
 * Created by davidhickson on 07/07/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('ingestArrayOfBlockLiteratureDeltas', ingestArrayOfBlockLiteratureDeltas);

  ingestArrayOfBlockLiteratureDeltas.$inject = ['$log'];

  function ingestArrayOfBlockLiteratureDeltas($log) {
    return function (arrayOfExistingBlocks, arrayOfBlockDeltas, existingLiteratureItems) {

      arrayOfBlockDeltas.forEach(function (inboundBlockDelta) {
        arrayOfExistingBlocks.forEach(function (existingBlock) {
          if (inboundBlockDelta._id == existingBlock._id) {
            var ary = [];
            inboundBlockDelta.literatures.forEach(function (litId) {
              existingLiteratureItems.forEach(function (literatureItem) {
                if (litId == literatureItem._id) {
                  ary.push(literatureItem);
                }
              });
            });
            existingBlock.literatures = ary;
          }
        });
      });

      $log.info('ingest.array.of.block.deltas ending, existing blocks logged below');
      $log.info(arrayOfExistingBlocks);

    };
  }
})();

/**
 * Created by davidhickson on 06/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('ingestArchiveBlockDelta', ingestArchiveBlockDelta);

  ingestArchiveBlockDelta.$inject = [];

  function ingestArchiveBlockDelta() {
    return function (arrayOfExistingBlocks, blockId) {
      for (var i = arrayOfExistingBlocks.length - 1; i > -1; i--) {
        if (arrayOfExistingBlocks[i].blocks) {
          var len = arrayOfExistingBlocks[i].blocks.length;

          for (len; len > 0; len--) {
            if (arrayOfExistingBlocks[i].blocks[len - 1]._id === blockId) {
              arrayOfExistingBlocks[i].blocks.splice(len - 1, 1);
            }
          }
        }

        if (arrayOfExistingBlocks[i]._id === blockId) {
          arrayOfExistingBlocks.splice(i, 1);
        }
      }
    };
  }
})();

/**
 * Created by davidhickson on 06/07/2017.
 */

(function () {
  'use strict';
  angular
    .module('showroom')
    .factory('ingestArrayOfBlockDeltas', ingestArrayOfBlockDeltas);

  ingestArrayOfBlockDeltas.$inject = ['$log'];

  function ingestArrayOfBlockDeltas($log) {
    return function (arrayOfExistingBlocks, arrayOfBlockDeltas) {
      arrayOfBlockDeltas.forEach(function (inboundBlockDelta) {
        var found = false;

        arrayOfExistingBlocks.forEach(function (existingBlock) {
          if (inboundBlockDelta._id == existingBlock._id) {
            found = true;
            existingBlock.blocks = []; // Clear the current blocks array.  We'll insert everything again.

            inboundBlockDelta.blocks.forEach(function (idOfInnerBlockWithinDelta) {
              arrayOfExistingBlocks.forEach(function (existingBlockForPossiblePush) {
                if (existingBlockForPossiblePush._id === idOfInnerBlockWithinDelta) {
                  existingBlock.blocks.push(existingBlockForPossiblePush);
                }
              });
            });
          }
        });

        if (!found) {
          // The inbound block delta entry must represent a brand new block - just add it to the array of existing blocks
          inboundBlockDelta.isShouldBeDisplayed = true;
          inboundBlockDelta.isRootBlock = true;
          arrayOfExistingBlocks.push(inboundBlockDelta);
        }
      });

      $log.info('ingest.array.of.block.deltas ending, existing blocks logged below');
      $log.info(arrayOfExistingBlocks);

    };
  }
})();

/**
 * Created by davidhickson on 05/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('hydrateBlockLiteraturesArray', hydrateBlockLiteraturesArray);

  hydrateBlockLiteraturesArray.$inject = [];

  function hydrateBlockLiteraturesArray() {

    function arrayToObj(array, fn) {
      var obj = {};
      var len = array.length;
      for (var i = 0; i < len; i++) {
        var curVal = array[i];
        var key = fn(curVal, i, array);
        obj[key] = curVal;
      }
      return obj;
    }

    return function (blocks, literatureItems) {

      var litObjects = arrayToObj(literatureItems, function (item) {
        return item._id;
      });

      blocks.forEach(function (block) {
        if (block.literatures) {
          var ary = [];
          block.literatures.forEach(function (litId) {
            if(_.isUndefined(litObjects[litId])) return;
            // console.log('!!!!!!!! pUSHING !!!!!!!!');
            ary.push(litObjects[litId]);
          });
          block.literatures = ary;
        }
      });
    };
  }
}());

/**
 * Created by davidhickson on 05/07/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('hydrateBlockBlocksArray', hydrateBlockBlocksArray);

  hydrateBlockBlocksArray.$inject = ['$log'];

  function hydrateBlockBlocksArray($log) {
    return function (blocks) {
      blocks.forEach(function (block) {
        if (block.blocks) {
          var ary = [];

          block.blocks.forEach(function (blockId) {
            blocks.forEach(function (innerBlock) {
              if (blockId == innerBlock._id) {
                $log.info('hydrate.block.blocks found match');
                Array.isArray(innerBlock.arrayOfParentBlocks) ? innerBlock.arrayOfParentBlocks.push(block) : innerBlock.arrayOfParentBlocks = [block];
                ary.push(innerBlock);
                innerBlock.isRootBlock = false;
              }
            });
          });

          block.blocks = ary;

          if (ary.length > 0) {
            $log.info('Populated block');
            $log.info(block);
            $log.info(ary);
          }
        }
      });
    };
  }
})();

/**
 * Created by davidhickson on 25/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('deselectSelectedBlocks', deselectSelectedBlocks);

  deselectSelectedBlocks.$inject = [];

  function deselectSelectedBlocks() {
    return function (blocks, options) {
      // options will look like this: {"modeToDeselect":"receive" | "push"};
      if (options.modeToDeselect === 'receive') {
        blocks.forEach(function (block) {
          block.selectedAsRecipient = false;
        });
      }

      if (options.modeToDeselect === 'push') {
        blocks.forEach(function (block) {
          block.selectedForPush = false;
        });
      }
    };
  }
})();

/**
 * Created by davidhickson on 07/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('createNewBlock', createNewBlock);

  createNewBlock.$inject = ['uuidService'];

  function createNewBlock(uuidService) {
    return function (newBlockNameplate, model) {

      var sortOrder = model.blocks.length;
      var newId = uuidService.getSingleNewBase64Key();

      return {
        '_id': newId,
        'nameplate': newBlockNameplate,
        'sortorder': sortOrder,
        'artefactType': 'Block'
      };
    };
  }
})();

/**
 * Created by davidhickson on 07/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('createDeltasByApplyingLiteratureToCurrentBlock', createDeltasByApplyingLiteratureToCurrentBlock);

  createDeltasByApplyingLiteratureToCurrentBlock.$inject = [];

  function createDeltasByApplyingLiteratureToCurrentBlock() {
    return function (currentBlock, existingLiteratureItems) {

      var arrayOfUpdateDeltas = [];

      var blockWasModified = false;
      var literatureIdsRequiringInsertion = [];

      existingLiteratureItems.forEach(function (literatureItem) {
        if (literatureItem.selected) {
          var alreadyPresent = false;

          if (currentBlock.literatures) {
            currentBlock.literatures.forEach(function (litWithinBlock) {
              if (literatureItem._id === litWithinBlock._id) {
                alreadyPresent = true;
              }
            });
          }

          if (!alreadyPresent) {
            literatureIdsRequiringInsertion.push(literatureItem._id);
            blockWasModified = true;
          }
        }
      });

      if (blockWasModified) {
        var arrayOfLitForBlock = [];
        if (currentBlock.literatures) {
          arrayOfLitForBlock =
            currentBlock.literatures
              .map(function (literatureItem) {
                return literatureItem._id;
              })
              .concat(literatureIdsRequiringInsertion);
        } else {
          arrayOfLitForBlock = literatureIdsRequiringInsertion;
        }
        arrayOfUpdateDeltas.push({
          '_id': currentBlock._id,
          'literatures': arrayOfLitForBlock,
          'blocks': false
        });
      }
      return arrayOfUpdateDeltas;
    };
  }
}());

/**
 * Created by davidhickson on 07/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('createDeltasByApplyingSelectedLit', createDeltasByApplyingSelectedLit);

  createDeltasByApplyingSelectedLit.$inject = [];

  function createDeltasByApplyingSelectedLit() {
    return function (existingBlocks, existingLiteratureItems) {

      var arrayOfUpdateDeltas = [];

      existingBlocks.forEach(function (block) {
        if (block.selectedAsRecipient) {
          var blockWasModified = false;
          var literatureIdsRequiringInsertion = [];

          existingLiteratureItems.forEach(function (literatureItem) {
            if (literatureItem.selected) {
              var alreadyPresent = false;

              if (block.literatures) {
                block.literatures.forEach(function (litWithinBlock) {
                  if (literatureItem._id === litWithinBlock._id) {
                    alreadyPresent = true;
                  }
                });
              }

              if (!alreadyPresent) {
                literatureIdsRequiringInsertion.push(literatureItem._id);
                blockWasModified = true;
              }
            }
          });

          if (blockWasModified) {
            var arrayOfLitForBlock = [];
            if (block.literatures) {
              arrayOfLitForBlock =
                block.literatures
                  .map(function (literatureItem) {
                    return literatureItem._id;
                  })
                  .concat(literatureIdsRequiringInsertion);
            } else {
              arrayOfLitForBlock = literatureIdsRequiringInsertion;
            }
            arrayOfUpdateDeltas.push({
              '_id': block._id,
              'literatures': arrayOfLitForBlock
            });
          }
        }
      });

      return arrayOfUpdateDeltas;
    };
  }
}());

/**
 * Created by davidhickson on 06/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('createDeltasByApplyingBlockSelectionsToBlock', createDeltasByApplyingBlockSelectionsToBlock);

  createDeltasByApplyingBlockSelectionsToBlock.$inject = [];

  function createDeltasByApplyingBlockSelectionsToBlock() {
    return function (blocks, toBlock) {
      var arrayOfDeltas = [];
      var blockIdsToBeAdded = [];

      blocks.forEach(function (blockBeingPushed) {
        if (blockBeingPushed.selectedForPush) {
          var alreadyPresent = false;

          if (toBlock.blocks) {
            toBlock.blocks.forEach(function (blockWithinBlock) {
              if (blockBeingPushed._id === blockWithinBlock._id) {
                alreadyPresent = true;
              }
            });
          }

          if (!alreadyPresent && blockBeingPushed._id !== toBlock._id) {
            blockIdsToBeAdded.push(blockBeingPushed._id);
          }
        }
      });

      if (blockIdsToBeAdded.length > 0) {
        var arrayOfExistingBlockIds = [];
        if (toBlock.blocks) {
          arrayOfExistingBlockIds = toBlock.blocks.map(function (existingBlock) {
            return existingBlock._id;
          });
        }

        var newArrayOfBlockIds = arrayOfExistingBlockIds.concat(blockIdsToBeAdded);
        arrayOfDeltas.push({
          '_id': toBlock._id,
          'blocks': newArrayOfBlockIds
        });
      }

      return arrayOfDeltas;
    };
  }
})();

/**
 * Created by davidhickson on 07/07/2017.
 */

(function () {
  'use strict';
  angular
    .module('showroom')
    .factory('createDeltaByRemovingLitFromBlock', createDeltaByRemovingLitFromBlock);

  createDeltaByRemovingLitFromBlock.$inject = [];

  function createDeltaByRemovingLitFromBlock() {
    return function (litItemToRemove, blockToRemoveItemFrom) {

      var arrayOfLitIdsToKeep = [];
      if (blockToRemoveItemFrom.literatures) {
        blockToRemoveItemFrom.literatures.forEach(function (literatureItem) {
          if (literatureItem._id !== litItemToRemove._id) {
            arrayOfLitIdsToKeep.push(literatureItem._id);
          }
        });
      }
      return {
        '_id': blockToRemoveItemFrom._id,
        'literatures': arrayOfLitIdsToKeep
      };
    };
  }
})();

/**
 * Created by davidhickson on 07/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('createDeltaByRemovingChildBlock', createDeltaByRemovingChildBlock);

  createDeltaByRemovingChildBlock.$inject = [];

  function createDeltaByRemovingChildBlock() {
    return function (blockToRemove, parentBlock) {
      var arrayOfWantedBlockIds = [];

      parentBlock.blocks.forEach(function (existingInnerBlock) {
        if (existingInnerBlock._id !== blockToRemove._id) {
          arrayOfWantedBlockIds.push(existingInnerBlock._id);
        }
      });

      return {
        '_id': parentBlock._id,
        'blocks': arrayOfWantedBlockIds
      };
    };
  }
})();

/**
 * Created by davidhickson on 06/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('createDeltasByApplyingBlockSelections', createDeltasByApplyingBlockSelections);

  createDeltasByApplyingBlockSelections.$inject = [];

  function createDeltasByApplyingBlockSelections() {
    return function (blocks) {
      var arrayOfDeltas = [];

      blocks.forEach(function (receivingBlock) {
        if (receivingBlock.selectedAsRecipient) {
          var blockIdsToBeAdded = [];

          blocks.forEach(function (blockBeingPushed) {
            if (blockBeingPushed.selectedForPush) {
              var alreadyPresent = false;

              if (receivingBlock.blocks) {
                receivingBlock.blocks.forEach(function (blockWithinBlock) {
                  if (blockBeingPushed._id === blockWithinBlock._id) {
                    alreadyPresent = true;
                  }
                });
              }

              if (!alreadyPresent) {
                blockIdsToBeAdded.push(blockBeingPushed._id);
              }
            }
          });

          if (blockIdsToBeAdded.length > 0) {
            var arrayOfExistingBlockIds = [];
            if (receivingBlock.blocks) {
              arrayOfExistingBlockIds = receivingBlock.blocks.map(function (existingBlock) {
                return existingBlock._id;
              });
            }

            var newArrayOfBlockIds = arrayOfExistingBlockIds.concat(blockIdsToBeAdded);
            arrayOfDeltas.push({
              '_id': receivingBlock._id,
              'blocks': newArrayOfBlockIds
            });
          }
        }
      });

      return arrayOfDeltas;
    };
  }
})();

(function () {
  'use strict';
  angular.module('showroom').factory('applySearchTermToBlocks', applySearchTermToBlocks);

  applySearchTermToBlocks.$inject = ['$log'];

  function applySearchTermToBlocks($log) {
    return function (searchTerm, existingBlocks) {

      searchTerm = searchTerm.toLowerCase();
      $log.info('apply.search.term.to.blocks running2 with ' + searchTerm);

      existingBlocks.forEach(function (block) {
        var isShouldBeDisplayed = true;

        if (searchTerm.length > 0) {
          if (block.nameplate.toLowerCase().indexOf(searchTerm) == -1) {
            isShouldBeDisplayed = false;
          }
        } else {
          isShouldBeDisplayed = true;
        }

        block.isShouldBeDisplayed = isShouldBeDisplayed;
      });
    };
  }
})();

/**
 * Created by davidhickson on 07/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('blockStatsGenerator', blockStatsGenerator);

  blockStatsGenerator.$inject = [];

  function blockStatsGenerator() {
    return function (blocks) {
      var stats = {
        countOfBlocksSelectedAsRecipient: 0,
        countOfBlocksSelectedForPush: 0
      };

      blocks.forEach(function (block) {
        if (block.selectedAsRecipient) {
          stats.countOfBlocksSelectedAsRecipient++;
        }

        if (block.selectedForPush) {
          stats.countOfBlocksSelectedForPush++;
        }
      });
      
      return stats;
    };
  }
})();

/*
The blocks model consists solely of an array.
The array should only ever be populated with objects that are block objects.
The blocks.model can then be required within any other modules that wish to manipulate blocks.
Various block object properties are interesting:
*/

(function () {
  'use strict';
  angular
    .module('showroom')
    .factory('blockModel', blockModel);

  blockModel.$inject = ['blockStatsGenerator'];

  function blockModel(statsGenerator) {
    var blocks = [];
    var stats = {};

    var requestStatsUpdate = function () {
      var newStats = statsGenerator(blocks);

      // Note we move the properties across because we can't just assign the new stats object - that would break our angular references elsewhere
      Object.getOwnPropertyNames(newStats).forEach(function (propertyName) {
        stats[propertyName] = newStats[propertyName];
      });
    };

    return {
      blocks: blocks,
      stats: stats,
      requestStatsUpdate: requestStatsUpdate
    };
  }
})();

/**
 * Created by davidhickson on 06/07/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('blocksMain', {
      templateUrl: 'app/showroom/blocks/main/blocks-main.tmpl.html',
      controllerAs: 'vm',
      controller: ['$scope', 'blocksManager', 'uuidService', function ($scope, blocksManager, uuidService) {

        var vm = this;

        vm.blocks = [];
        vm.currentBlock = {};
        vm.blockssvcreference = blocksManager;
        vm.tabInfo = {
          literature: true,
          blocks: true
        };

        vm.$onInit = function () {
          vm.refreshTree();

          if (vm.blocks.length > 0) {
            vm.currentBlock = vm.blocks[0];
          } else {
            vm.blocks.push({
              _id: uuidService.getSingleNewBase64Key(),
              title: 'few',
              nameplate: 'nameplate'
            });
            blocksManager.addBlockWithParent([vm.blocks[0]]);
          }

          vm.currentBlock = vm.blocks[0];
          vm.blocks[0].isSelected = true;
          setDefaultParameters(vm.currentBlock);
        };

        vm.refreshTree = function () {
          vm.blocks = [];
          blocksManager.blocks.forEach(function (block) {
            if (block.isRootBlock) {
              vm.blocks.push(block);
            }
          });
        };

        vm.deselectAllBlocks = function () {
          vm.blocks.forEach(function (block) {
            block.isSelected = false;
            deselectSubBlocks(block);
          });
        };

        function deselectSubBlocks(block) {
          if (block.blocks) {
            block.blocks.forEach(function (subBlock) {
              subBlock.isSelected = false;
              deselectSubBlocks(subBlock);
            });
          }
        }

        vm.updateCurrentBlock = function () {
          updateCurrentBlock(vm.blocks);
        };

        function updateCurrentBlock(blocks) {
          blocks.forEach(function (block) {
            if (block.isSelected) {
              vm.currentBlock = block;
              setDefaultParameters(vm.currentBlock);
            } else if (block.blocks && block.blocks.length > 0) {
              updateCurrentBlock(block.blocks);
            }
          });
        }

        function setDefaultParameters(block) {
          if (!block.heightOfBlocks) {
            block.heightOfBlocks = 200;
          }
          if (!block.padding) {
            block.padding = 50;
          }
          if (!block.blocksPerRow) {
            block.blocksPerRow = 3;
          }
          if (!block.artefactType) {
            block.artefactType = 'Block';
          }
        }

        return vm;
      }]
    });
})();

/**
 * Created by davidbeazer on 21/11/2016.
 */
'use strict';

angular
  .module('forms')
  .controller('FullScreenGrid', FullScreenGrid);

FullScreenGrid.$inject = [];
/* ng-inject */
function FullScreenGrid() {

}

/**
 * Created by davidfm on 17/08/2018.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('artefactsMain', {
      templateUrl: 'app/showroom/artefacts/main/artefacts-main.tmpl.html',
      controller: ['$scope', 'APIService', 'MessageService', function ($scope, APIService, MessageService) {
        var vm = this;

        vm.state = {
          fileBusy: false
        };
        vm.columns = null;
        vm.existingLookups = [];
        vm.lookupname = {};
        vm.lookupoverride = true;
        vm.lookupobject = 'response';
        vm.newlookupname = '';
        vm.data = [];

        vm.$onInit = function () {
          APIService.get('showroom/artefacts?t=BreakoutReportLookup')
            .then(function (response) {
              var lookupnames = [];
              if (response.data && response.data.data) {
                var i = 0;
                var len = response.data.data.length;
                for (i; i < len; i++) {
                  if (lookupnames.indexOf(response.data.data[i].lookupname) === -1) {
                    lookupnames.push(response.data.data[i].lookupname);
                    vm.existingLookups.push(response.data.data[i]);
                  }
                }
                vm.existingLookups.unshift({ lookupname: 'Create new lookup' });
              }
            });
        };

        $scope.fileChanged = function ($event) {
          var fileReference = $event.target.files[0];
          Papa.parse(fileReference, {
            complete: function (results) {
              if (results.data && results.data.length > 0) {
                vm.columns = {};
                var first = true;
                var i = 0;
                var len = results.data[0].length;
                for (i; i < len; i++) {
                  vm.columns[results.data[0][i]] = first;
                  first = false;
                }
                vm.data.splice(0);
                vm.data.push.apply(vm.data, results.data);
              }
              vm.state.fileBusy = false;
              //Papaparse seems to operate such that Angular does not see the changes when applied here, hence wrap the update in $scope.$apply:
              $scope.$apply();
            }
          });
        };

        vm.activateFileInput = function () {
          vm.state.fileBusy = true;
          angular.element(document).find('#importArtefactInput').val('').click();
        };

        vm.uploadLookup = function () {
          vm.state.fileBusy = true;
          APIService.postToDataApi('showroom/artefacts/lookups', {
            data: vm.data,
            columns: vm.columns,
            lookupname: vm.lookupname.lookupname,
            lookupobject: vm.lookupobject,
            newname: vm.newlookupname,
            override: vm.lookupoverride
          }).then(function (response) {
            vm.state.fileBusy = false;
            if (response.data && response.data.success) {
              MessageService.showMessage('Lookups successfully created.');
            } else {
              MessageService.showMessage('Something went wrong and the lookups weren\'t created correctly.');
            }

            if (vm.lookupname.lookupname === 'Create new lookup') {
              vm.existingLookups.push({ lookupname: vm.newlookupname });
            }
          }).catch(function (err) {
            vm.state.fileBusy = false;
            $log.error('Upload artefact lookup error: ', err);
            MessageService.showMessage('An error occured trying to contact the server. Please try again later.');
          });
        };

        return vm;
      }]
    });
})();

(function () {
  'use strict';

  angular
    .module('lists')
    .component('zpListsWidgetContainer', {
      templateUrl: 'app/lists/main/widget-container/widget-container.tmpl.html',
      controller: 'ListsWidgetContainerCtrl',
      bindings: {}
    })
    .controller('ListsWidgetContainerCtrl', controller);

  controller.$inject = ['ListOfListsFactory' ];
  /* ng-inject */
  function controller(ListOfListsFactory) {

    var vm = this;

    vm.data = {
      items: []
    };
    
    vm.$onInit = function () {
      vm.data = ListOfListsFactory.getData();
      vm.blankSlate = !vm.data.items.length;
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('lists')
    .component('zpListSearchToolbar', {
      templateUrl: 'app/lists/main/search-toolbar/tmpl.html',
      controller: 'ListsSearchToolbarCtrl',
      bindings: {}
    })
    .controller('ListsSearchToolbarCtrl', controller);

  controller.$inject = ['ListMainMetadata', 'ListOfListsFactory'];
  /* ng-inject */
  function controller(ListMainMetadata, ListOfListsFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.metadata = ListMainMetadata.getData();
    };

    vm.onMenuClick = function (args) {
      if (args.action === 'toggleShowArchived') {
        vm.hideArchived = !vm.hideArchived;
        ListOfListsFactory.toggleShowArchivedSwitch(vm.hideArchived);
      }
    };

  }
}());

/**
 * Created by davidbeazer on 10/10/2016.
 */
(function () {
  'use strict';

  angular
    .module('lists')
    .factory('OCRMetadata', OCRMetadata);

  OCRMetadata.$inject = ['localStorageService'];

  function OCRMetadata(localStorage) {

    var factoryData = {};
    buildFactory();

    return {
      getData: getData
    };

    function getData() {
      return factoryData;
    }

    // PRIVATE

    function buildFactory() {

      var defaultSort = {
        id: 'list._lastmodifiedonservertime',
        expression: '-list._lastmodifiedonservertime.raw'
      };

      factoryData = {
        title: {},
        columnsData: buildColumnsData(),
        query: {
          order: localStorage.get('ocr_main_sort') || defaultSort,
          limit: localStorage.get('ocr_main_limit') || 20,
          page: 1
        },
        paginationOptions: {
          boundaryLinks: true,
          limitSelect: true,
          pageSelect: true,
          pagination: true,
          limitOptions: [5, 10, 20, 50, 75, 100],
          limit: localStorage.get('ocr_main_limit') || 20,
          page: 1
        },
        gridOptions: {
          rowSelection: false,
          multiSelect: false,
          sortable: true,
          interactive: false
        },
        fabDialogConfig: {
          description: 'New OCR Template',
          controller: AddListDialogController,
          templateUrl: 'app/lists/main/_lists.add-list-dialog.tmpl.html',
          locals: {},
          ariaLabel: 'Create new list'
        }
      };
    }

    function buildColumnsData() {

      return {
        primaryIdentifier: {
          object: 'list',
          field: '_id'
        },
        items: [{
          object: 'list',
          databasefieldname: 'title',
          name: 'title',
          label: 'OCR Template title',
          type: 'Textfield',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: ''
        }, {
          object: 'list',
          databasefieldname: 'items',
          name: 'title',
          label: 'Items',
          type: 'Textfield',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: ''
        },{
          object: 'list',
          databasefieldname: '_lastmodifiedonservertime',
          name: 'Modified date',
          label: 'Last modified',
          type: 'Textfield',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: '',
          cellFilter: 'zpDateMedium'
        }]
      };
    }
  }
})();

/**
 * Created by davidbeazer on 14/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('lists')
    .factory('OCRTemplatesFactory', OCRTemplatesFactory);

  OCRTemplatesFactory.$inject = ['ListApiFactory', '$filter', 'OCRMetadata'];

  function OCRTemplatesFactory(ListApiFactory, $filter, OCRMetadata) {

    var factoryData = {
      items: [],
      itemsObject: {}
    };

    return {
      getOCRtemplates: getOCRtemplates,
      getData: getData
    };

    function getOCRtemplates() {
      return ListApiFactory.getArtefactsByQuery({
        artefactType: 'OCRTemplate',
        _deletedatelocalutc: {
          $exists: false
        }
      }, {
        _id: 1,
        title: 1,
        artefactType: 1,
        _lastmodifiedonservertime: 1,
        _lastmodifieddatelocalutc: 1
      })
        .then(function (res) {
          factoryData.items = res.data.data;
          var shapedItemsArray = shapeDataForGrid(factoryData.items);
          var arrayToMap = angular.copy(shapedItemsArray);
          factoryData.items = $filter('enhancedTableCells')(OCRMetadata.getData(), shapedItemsArray);

          var listsObject = _.reduce(arrayToMap, function (listsObject, v) {
            listsObject[v.list._id] = v;
            return listsObject;
          }, {});
          factoryData.itemsObject = listsObject;
          return factoryData;
        });
    }

    function getData() {
      return factoryData;
    }

    function shapeDataForGrid(arrayOfUnprocessedItems) {
      return _.map(arrayOfUnprocessedItems, function (item) {
        return {
          list: {
            _id: item._id,
            title: item.title || '',
            // items: item.items.length || 0,
            _lastmodifiedonservertime: item._lastmodifiedonservertime || ''
          }
        };
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('lists')
    .component('zpOcrTemplates', {
      templateUrl: 'app/lists/main/ocr-list-component/ocr-templates-list.tmpl.html',
      controller: 'zpOcrTemplatesController',
      bindings: {}
    })
    .controller('zpOcrTemplatesController', controller);

  controller.$inject = ['$state', 'OCRMetadata', 'OCRTemplatesFactory', 'localStorageService', 'PaginationManager'];
  /* ng-inject */
  function controller($state, OCRMetadata, OCRTemplatesFactory, localStorage, PaginationManager) {

    var vm = this;

    vm.$onInit = function () {
      vm.data = OCRTemplatesFactory.getData();
      vm.metadata = OCRMetadata.getData();
      vm.totalRows = vm.data.items.length;
    };

    vm.goto = function (listid) {
      $state.go('app.ocr_template', { _id: listid });
    };

    // PAGINATION
    vm.logPagination = function (page, limit) {
      // $log.info('logging pagination for ocr template widget');
      vm.metadata.query.page = page;
      vm.metadata.query.limit = limit;
      PaginationManager.setQuery(vm.metadata.query, 'ocr_main_page_size');
      $('md-content').animate({ scrollTop: 0 }, 0);
    };


  }
}());

(function () {
  'use strict';

  angular
    .module('lists')
    .component('zpListsPage', {
      controller: 'ListsMainController',
      templateUrl: 'app/lists/main/lists-main-page/lists-main-page.tmpl.html',
      bindings: {}
    })
    .controller('ListsMainController', ListsMainController);

  ListsMainController.$inject = [];

  function ListsMainController() {

    var vm = this;

    vm.$onInit = function () {};
  }
})();

(function () {
  'use strict';

  angular
    .module('lists')
    .component('zpLists', {
      templateUrl: 'app/lists/main/lists-list-component/lists.tmpl.html',
      controller: 'zpListsController',
      bindings: {}
    })
    .controller('zpListsController', controller);

  controller.$inject = ['$state', 'ListMainMetadata', 'ListOfListsFactory', 'PaginationManager', 'MasterPermissionsDefinitionFactory', 'GridDataFactory', 'localStorageService', 'SearchValFactory'];
  /* ng-inject */
  function controller($state, ListMainMetadata, ListOfListsFactory, PaginationManager, MasterPermissionsDefinitionFactory, GridDataFactory, localStorageService, SearchValFactory) {

    var vm = this;

    vm.data = {
      items: []
    };

    vm.$onInit = function () {
      vm.hideArchived = localStorageService.get('hideArchivedLists');
      vm.metadata = ListMainMetadata.getData();
      vm.search = SearchValFactory.get(vm.metadata.id);
      vm.data = ListOfListsFactory.getData();
      GridDataFactory.hydrateData(vm.data, vm.metadata.id);
      vm.blankSlate = !vm.data.items.length;
      vm.totalRows = vm.data.items.length;
      PaginationManager.setQuery(vm.metadata.query, vm.metadata.id);
      vm.permissions = MasterPermissionsDefinitionFactory;
    };

    vm.goto = function (listid) {
      $state.go('app.toolbar_app_framework.list_detail', { _id: listid });
    };

    // PAGINATION
    vm.logPagination = function(page, limit) {
      vm.metadata.query.page = page;
      vm.metadata.query.limit = limit;
      PaginationManager.setQuery(vm.metadata.query, vm.metadata.id);
      $('md-content').animate({ scrollTop: 0 }, 0);
    };



  }
}());

/**
 * Created by davidbeazer on 10/10/2016.
 */
(function () {
  'use strict';

  angular
    .module('lists')
    .factory('ListMainMetadata', ListMainMetadata);

  ListMainMetadata.$inject = ['localStorageService'];

  function ListMainMetadata(localStorage) {

    var factoryData = {};
    buildFactory();

    return {
      getData: getData
    };

    function getData() {
      return factoryData;
    }

    // PRIVATE

    function buildFactory() {

      factoryData = {
        id: 'lists_main',
        title: {
          label: 'Lists',
          filterLabel: 'Search lists'
        },
        columnsData: buildColumnsData(),
        query: {
          order: {
            id: 'list._lastmodifiedonservertime',
            expression: '-list._lastmodifiedonservertime.raw'
          },
          limit: localStorage.get('lists_main') || 20,
          page: 1
        },
        paginationOptions: {
          boundaryLinks: true,
          limitSelect: true,
          pageSelect: true,
          pagination: true,
          limitOptions: [5, 10, 20, 50, 75, 100],
          limit: localStorage.get('lists_main') || 20,
          page: 1
        },
        gridOptions: {
          rowSelection: false,
          multiSelect: false,
          sortable: true,
          interactive: false
        },
        fabDialogConfig: {
          description: 'New list',
          controller: 'AddListDialogController as vm',
          templateUrl: 'app/lists/main/_lists.add-list-dialog.tmpl.html',
          locals: {},
          ariaLabel: 'Create new list'
        },
        menuOptions: [{
          onClick: 'toggleShowArchived',
          ariaLabel: function () {
            return 'Toggle Archived Lists';
          },
          icon: function () {
            return localStorage.get('hideArchivedLists') ? 'zmdi zmdi-eye' : 'zmdi zmdi-eye-off';
          },
          label: function () {
            return localStorage.get('hideArchivedLists') ? 'Show Archived Lists' : 'Hide Archived Lists';
          }
        }]
      };
    }

    function buildColumnsData() {
      return {
        primaryIdentifier: {
          object: 'list',
          field: '_id'
        },
        items: [{
          object: 'list',
          databasefieldname: 'icn',
          label: 'Status',
          showCol: true,
          type: 'Status',
          cellFilter: 'gridButton',
          sortOn: 'rawValue'
        }, {
          object: 'list',
          databasefieldname: 'title',
          name: 'title',
          label: 'List title',
          type: 'Textfield',
          placeholder: 'Add a reporting label',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: ''
        }, {
          object: 'list',
          databasefieldname: 'items',
          name: 'items',
          label: 'Items',
          type: 'Textfield',
          placeholder: 'Add a reporting label',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: 0
        }, {
          object: 'list',
          databasefieldname: '_lastmodifiedonservertime',
          name: 'Modified date',
          label: 'Last modified',
          type: 'Textfield',
          placeholder: '',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: '',
          cellFilter: 'zpDateMedium'
        }]
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('lists')
    .component('zpAddListFab', {
      templateUrl: 'app/lists/main/fab/fab.tmpl.html',
      controller: 'zpListsController'
    });

})();

(function () {
  'use strict';

  angular
    .module('lists')
    .factory('OCRTemplateEditorMetadataFactory', OCRTemplateEditorMetadataFactory);

  OCRTemplateEditorMetadataFactory.$inject = ['localStorageService'];
  /* ng-inject */
  function OCRTemplateEditorMetadataFactory(localStorage) {

    // hydrate the factory at birth
    var factoryData = {};
    buildFactory();

    return {
      getFactoryData: getFactoryData,
      locateCellMetaDataById: locateCellMetaDataById
    };

    function getFactoryData() {
      return factoryData;
    }

    function locateCellMetaDataById(targetColumnId) {
      return factoryData.columnsData.itemsObject[targetColumnId];
    }

    // PRIVATE FUNCTIONS

    function buildFactory() {

      var defaultSort = {
        id: 'list._lastmodifiedonservertime',
        expression: '-list._lastmodifiedonservertime.raw'
      };

      factoryData = {
        title: buildWidgetTitleObj(),
        columnsData: buildColumnsData(),
        query: {
          order: localStorage.get('list_main_sort') || defaultSort,
          limit: localStorage.get('list_main_limit') || 20,
          page: 1
        },
        toolbarButtons: {
          showDelete: true,
          showEdit: false
        },
        gridOptions: {
          rowSelection: true,
          multiSelect: true,
          sortable: false,
          interactive: true
        },
        fabDialogConfig: {
          description: 'New item',
          controller: OCRAddItemsController,
          templateUrl: 'app/lists/detail/ocr-template-editor-component/ocr.add-items-dialog.tmpl.html',
          locals: {
            showHints: false // show input hints
          },
          ariaLabel: 'Add list item'
        },
        reorderItems: false

      };

      factoryData.columnsData.items.map(function (col) {
        factoryData.columnsData.itemsObject[col.object + '_' + col.databasefieldname] = col;
      });
    }

    // buildFactory helpers

    function buildWidgetTitleObj() {
      return {
        name: 'title',
        label: 'List title',
        type: 'Text',
        placeholder: 'List title',
        editable: true,
        required: true
      };
    }

    function buildColumnsData() {
      return {
        primaryIdentifier: {
          object: 'list',
          field: '_id'
        },
        itemsObject: {},
        items: [{
          object: 'list',
          databasefieldname: 'OCRFieldName',
          name: 'OCRFieldName',
          label: 'OCRFieldName',
          type: 'Textfield',
          placeholder: 'Add a OCRFieldName',
          showCol: true,
          editable: true,
          unique: true,
          sortOn: 'rawValue'
        }, {
          object: 'list',
          databasefieldname: 'zuantFieldName',
          name: 'zuantFieldName',
          label: 'zuantFieldName label',
          type: 'Textfield',
          placeholder: 'Add a zuantFieldName label',
          showCol: true,
          unique: true,
          editable: true,
          sortOn: 'rawValue'
        }, {
          object: 'list',
          databasefieldname: 'isImportant',
          name: 'isImportant',
          label: 'Mark as Important',
          type: 'OCRisImportant',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellFilter: 'gridButton',
          boolean: true,
          cellDefaultValue: false
        }, {
          object: 'list',
          databasefieldname: 'requiresVerification',
          label: 'requiresVerification',
          type: 'OCRrequiresVerification',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellFilter: 'gridButton',
          boolean: true,
          cellDefaultValue: false
        }]
      };
    }



  }
})();

/**
 * Created by davidbeazer on 25/08/2016.
 */
(function () {
  'use strict';

  angular
    .module('lists')
    .factory('OCRTemplateEditorDataFactory', OCRTemplateEditorDataFactory);

  OCRTemplateEditorDataFactory.$inject = ['$q', 'ListApiFactory', 'ZPModel', 'OCRTemplateEditorMetadataFactory', '$filter'];

  function OCRTemplateEditorDataFactory($q, ListApiFactory, ZPModel, OCRTemplateEditorMetadataFactory, $filter) {

    var factoryData = {
      artefactType: '',
      title: '',
      color: '',
      languages: [],
      items: [],
      showBusinessCardByDefault: false,
      itemsObject: {}
    };

    /* this factory inherits from ZPModel */
    var services = Object.create(ZPModel);

    services.fetchDataForComponent = fetchDataForComponent;
    services.getFactoryData = getFactoryData;
    // services.editItem = editItem;
    services.save = saveList;
    services.deleteList = deleteList;
    services.addItemToList = addItemToList;
    services.locateRowDataById = locateRowDataById;
    services.updateCellValue = updateCellValue;

    return services;
    /////////////////////

    function getFactoryData() {
      return factoryData;
    }

    function fetchDataForComponent(id) {
      return ListApiFactory.getArtefactById(id)
        .then(function (resp) {
          _.extend(factoryData, resp.data.data); // _.extend puts the server response into the model without overwriting factory defaults.
          var shapedItemsArray = shapeDataForGrid(factoryData.items);
          var arrayToMap = angular.copy(shapedItemsArray);
          factoryData.items = $filter('enhancedTableCells')(OCRTemplateEditorMetadataFactory.getFactoryData(), shapedItemsArray);

          var itemsObject = _.reduce(arrayToMap, function (itemsObject, v) {
            itemsObject[v.list._id] = v;
            return itemsObject;
          }, {});

          factoryData.itemsObject = itemsObject;
          return factoryData;
        });
    }

    function shapeDataForGrid(arrayOfUnprocessedListItems) {
      return _.map(arrayOfUnprocessedListItems, function (item) {
        return {
          list: {
            _id: item.OCRFieldName,
            OCRFieldName: item.OCRFieldName || '',
            zuantFieldName: item.zuantFieldName || '',
            requiresVerification: item.requiresVerification || false,
            isImportant: item.isImportant || false
          }
        };
      });
    }

    function addItemToList(item) {

      return ListApiFactory.addNewListItem(factoryData._id, item)
        .then(function (resp) {
          if (resp) {
            item._id = item.OCRFieldName;
            var itemReadyForGrid = shapeDataForGrid([item]);
            var itemToPush = $filter('enhancedTableCells')(OCRTemplateEditorMetadataFactory.getFactoryData(), itemReadyForGrid);
            factoryData.items.push(itemToPush[0]);
            factoryData.itemsObject[item._id] = {
              list: item
            };
            return true;
          }
        })
        .catch(function () {
          return false;
        });
    }

    function prepareListForSaving() {
      var list = _.pick(factoryData, '_id', 'artefactType', 'title', 'items', 'color', 'languages', 'showBusinessCardByDefault');
      var mappedItems = _.map(list.items, function (item) {
        return {
          OCRFieldName: item.list.OCRFieldName.raw,
          zuantFieldName: item.list.zuantFieldName.raw,
          requiresVerification: item.list.requiresVerification.raw,
          isImportant: item.list.isImportant.raw
        };
      });
      list.items = mappedItems;
      return list;
    }

    function saveList() {
      var list = prepareListForSaving();
      return ListApiFactory.saveList(list)
        .then(function (resp) {
          if (resp.statusText === 'OK') {
            return true;
          } else {
            return false;
          }
        });
    }

    function deleteList(listId) {
      // THIS WILL DELETE THE DOCUMENT. ONLY USE FOR DEV!
      return ListApiFactory.deleteList(listId)
        .then(function (res) {
          if (res.status === 200) {
            return true;
          } else {
            return false;
          }
        });
    }

    function locateRowDataById(rowId) {
      return factoryData.itemsObject[rowId];
    }

    function updateCellValue(newValue, objectId, metadata) {
      for (var i = 0, j = factoryData.items.length; i < j; i++) {
        if (factoryData.items[i][metadata.object]['_id'] == objectId) {
          // $log.info('match');
          factoryData.items[i][metadata.object][metadata.databasefieldname].raw = newValue;
          if (metadata.cellFilter) {
            factoryData.items[i][metadata.object][metadata.databasefieldname].filtered = $filter(metadata.cellFilter)(newValue, metadata.type);
          } else {
            factoryData.items[i][metadata.object][metadata.databasefieldname].filtered = newValue;
          }
          // update the value in the itemsObject too
          factoryData.itemsObject[factoryData.items[i].list._id][metadata.object][metadata.databasefieldname] = newValue;
        }
      }
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('lists')
    .component('zpOcrTemplateEditor', {
      templateUrl: 'app/lists/detail/ocr-template-editor-component/ocr.template-editor.tmpl.html',
      controller: 'zpOcrEditorController',
      bindings: {}
    })
    .controller('zpOcrEditorController', controller);

  controller.$inject = ['OCRTemplateEditorMetadataFactory', 'OCRTemplateEditorDataFactory', 'ProxyFactory', 'ChangeDelta', 'MessageService'];
  /* ng-inject */
  function controller(OCRTemplateEditorMetadataFactory, OCRTemplateEditorDataFactory, ProxyFactory, ChangeDelta, MessageService) {

    var vm = this;

    vm.$onInit = function () {
      vm.data = OCRTemplateEditorDataFactory.getFactoryData();
      vm.metadata = OCRTemplateEditorMetadataFactory.getFactoryData();
      vm.totalRows = vm.data.items.length;
      ProxyFactory.setDataFactoryToUse(OCRTemplateEditorDataFactory);
      ProxyFactory.setMetadataFactoryToUse(OCRTemplateEditorMetadataFactory);
      vm.changeDeltaFactory = ChangeDelta;
      ChangeDelta.clear();
    };

    vm.updateTitle = function (newval) {
      // $log.info('updatetitle to ' + newval);
      ChangeDelta.recordValueChange({
        oldval: vm.data.title,
        newval: newval,
        objectid: 'list_title',
        collection: 'list',
        databasefieldname: 'title'
      });
      if (newval != vm.data.title) {
        vm.data.title = newval;
      }
    };

    vm.saveChanges = function () {
      OCRTemplateEditorDataFactory.save()
        .then(function () {
          ChangeDelta.clear();
          MessageService.showMessage('Template changes saved');
        })
        .catch(function (err) {
          MessageService.showMessage('Error: ' + err);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });

        });
    };

  }
}());

/**
 * Created by davidbeazer on 25/08/2016.
 */

'use strict';
// TODO de $scope
angular
  .module('lists')
  .controller('OCRAddItemsController', OCRAddItemsController);

OCRAddItemsController.$inject = ['$scope', '$mdDialog', 'OCRTemplateEditorDataFactory', 'hotkeys', 'locals', 'MessageService'];
/* ng-inject */
function OCRAddItemsController($scope, $mdDialog, OCRTemplateEditorDataFactory, hotkeys, locals, MessageService) {

  $scope.showHints = locals.showHints;
  $scope.currentList = OCRTemplateEditorDataFactory.getFactoryData();
  $scope.newItem = {
    OCRFieldName: '',
    zuantFieldName: '',
    isImportant: false,
    requiresVerification: false
  };
  $scope.listId = $scope.currentList._id;
  $scope.submitForm = submitForm;

  activate();

  function activate() {
    unbindHotkeys();
    bindHotkeys();
  }

  function submitForm(andClose) {
    // $log.info('submitting new item form');
    // $scope.itemAlreadyExists = CurrentListModel.getItemAlreadyExistsValue();
    $scope.blankcaptionError = false;
    var valid = validateCaption();
    if (!valid) {
      // $log.info('item already exists, error message will be displayed under input ($scope.blankcaptionError = true;)');
      return false;
    } else {
      OCRTemplateEditorDataFactory.addItemToList($scope.newItem)
        .then(function (response) {
          if (response) {
            MessageService.showMessage('List item added');
            $scope.newItem = {
              caption: ''
            };
            if (andClose) {
              hotkeys.del('shift+enter');
              $scope.hide();
            }
          }
        });
    }
  }

  function validateCaption() {
    var valid = true;
    if ($scope.newItem.OCRFieldName === '') {
      $scope.blankcaptionError = true;
      valid = false;
      return valid;
    }
    /**
    does a check in the model for no matching captions or codes
     */
    // valid = CurrentListModel.validateItemInputValue($scope.newItem.OCRFieldName);

    return valid;
  }

  function bindHotkeys() {
    hotkeys.add({
      combo: 'shift+enter',
      description: 'Add item and close',
      allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
      callback: function () {
        submitForm(true);
      }
    });
    hotkeys.add({
      combo: 'enter',
      description: 'Add item',
      allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
      callback: function () {
        submitForm(false);
      }
    });
  }

  function unbindHotkeys() {
    hotkeys.del('enter');
    hotkeys.del('shift+enter');
    hotkeys.del('ctrl+a');
    hotkeys.del('ctrl+d');
    // hotkeys.del('ctrl+n');
    hotkeys.del('ctrl+s');
  }

  $scope.hide = function () {
    unbindHotkeys();
    $mdDialog.hide();
  };

  $scope.cancel = function () {
    unbindHotkeys();
    $mdDialog.cancel();
  };

  $scope.answer = function () {
    unbindHotkeys();
    $mdDialog.hide(true);
  };
}

(function () {
  'use strict';

  angular
    .module('lists')
    .component('zpOcrTemplateDetailPage', {
      templateUrl: 'app/lists/detail/ocr-detail-page-component/ocr-detail-page.tmpl.html',
      controller: 'zpOcrDetailPageController',
      bindings: {}
    })
    .controller('zpOcrDetailPageController', controller);

  controller.$inject = [];
  /* ng-inject */
  function controller() {

    var vm = this;

    vm.$onInit = function () {

    };

  }
}());

(function () {
  'use strict';

  angular
    .module('lists')
    .factory('ListDetailMetadataFactory', ListMetadata);

  ListMetadata.$inject = [];
  /* ng-inject */
  function ListMetadata() {

    // hydrate the factory at birth
    var factoryData = {};
    buildFactory();

    return {
      getData: getData,
      locateCellMetaDataById: locateCellMetaDataById
    };

    function getData() {
      return factoryData;
    }

    function locateCellMetaDataById(targetColumnId) {
      return factoryData.columnsData.itemsObject[targetColumnId];
    }

    // PRIVATE FUNCTIONS
    function buildFactory() {

      factoryData = {
        id: 'list_detail',
        title: buildWidgetTitleObj(),
        columnsData: buildColumnsData(),
        query: {
          order: {
            id: '',
            expression: ''
          },
          limit: 9999,
          page: 1
        },
        toolbarButtons: {
          showDelete: true,
          showEdit: false
        },
        gridOptions: {
          rowSelection: null,
          multiSelect: true,
          sortable: true,
          interactive: null
        },
        fabDialogConfig: {
          description: 'New item',
          controller: 'ListsAddItemsController as vm',
          templateUrl: 'app/lists/detail/list-detail-page-component/list.add-items.dialog.tmpl.html',
          locals: {
            showHints: false // show input hints
          },
          ariaLabel: 'Add list item'
        },
        reorderItems: false
      };

      factoryData
        .columnsData
        .items
        .map(function (col) {
          factoryData.columnsData.itemsObject[col.object + '_' + col.databasefieldname] = col;
        });

    }

    function buildWidgetTitleObj() {
      return {
        name: 'title',
        label: 'List title',
        type: 'Text',
        placeholder: 'List title',
        editable: true,
        required: true
      };
    }

    function buildColumnsData() {
      return {
        primaryIdentifier: {
          object: 'list',
          field: '_id'
        },
        itemsObject: {},
        items: [{
          object: 'list',
          databasefieldname: 'caption',
          label: 'Caption',
          type: 'Textfield',
          placeholder: 'Add a caption',
          showCol: true,
          editable: true,
          sortOn: 'rawValue',
          cellDefaultValue: '',
          validation: {
            type: 'text',
            unique: true
            // pattern: /[^a-zA-Z\d\s:]/
          }
        }, {
          object: 'list',
          databasefieldname: 'code',
          name: 'code',
          label: 'Code',
          type: 'Textfield',
          placeholder: 'Add a code',
          showCol: true,
          editable: true,
          sortOn: 'rawValue',
          cellDefaultValue: '',
          validation: {
            type: 'text',
            unique: true
            // pattern: /[^a-zA-Z\d\s:]/
          }
        }, {
          object: 'list',
          databasefieldname: 'reportingLabel',
          name: 'reportingLabel',
          label: 'Reporting label',
          type: 'Textfield',
          placeholder: 'Add a reporting label',
          showCol: true,
          editable: true,
          sortOn: 'rawValue',
          cellDefaultValue: '',
          validation: {
            type: 'text',
            unique: true
          }
        }, {
          object: 'list',
          databasefieldname: 'points',
          name: 'points',
          label: 'Points',
          type: 'Textfield',
          placeholder: 'Add a points value',
          showCol: true,
          editable: true,
          sortOn: 'rawValue',
          validation: {
            type: 'number'
          }
        }, {
          object: 'list',
          databasefieldname: 'showMoreInfoTextfield',
          name: 'showMoreInfoTextfield',
          label: 'Show more info',
          type: 'showMoreInfo',
          placeholder: '',
          showCol: true,
          editable: false,
          boolean: true,
          sortOn: 'rawValue',
          cellFilter: 'gridButton',
          cellDefaultValue: false
        }]
      };
    }

  }
})();

/**
 * Created by davidbeazer on 25/08/2016.
 */
(function () {
  'use strict';

  angular
    .module('lists')
    .factory('CurrentListModel', CurrentListModel);

  CurrentListModel.$inject = ['$q', 'ListApiFactory', 'ZPModel', 'ListDetailMetadataFactory', '$filter', 'MessageService', 'ListOfListsFactory', '$log', 'SortingFactory', 'ChangeDelta'];

  function CurrentListModel($q, ListApiFactory, ZPModel, ListDetailMetadataFactory, $filter, MessageService, ListOfListsFactory, $log, SortingFactory, ChangeDelta) {

    let factoryData = {
      artefactType: '',
      title: '',
      items: [],
      itemsObject: {},
      selectedItems: []
    };

    /* this factory inherits from ZPModel */
    const services = Object.create(ZPModel);

    services.hydrateWithCurrentList = hydrateWithCurrentList;
    services.getData = getData;
    services.save = saveList;
    services.archiveList = archiveList;
    services.unarchiveList = unarchiveList;
    services.deleteList = deleteList;
    services.addItemToList = addItemToList;
    services.removeItemsFromList = removeItemsFromList;
    // services.locateCellRowDataById = locateCellRowDataById;
    // services.updateCellValue = updateCellValue;
    services.validateCell = validateCell;
    services.validateNewListItem = validateNewListItem;
    services.changeSortOrder = changeSortOrder;
    services.clearSelectedArray = clearSelectedArray;

    return services;
    /////////////////////

    function getData() {
      return factoryData;
    }

    function hydrateWithCurrentList(listId) {
      return ListApiFactory.getArtefactById(listId)
        .then(function (resp) {
          buildItemsArrayAndObject(resp.data.data);
          return factoryData;
        });
    }

    function buildItemsArrayAndObject(rawData) {

      factoryData = rawData;

      const shapedItemsArray = shapeDataForGrid(factoryData.items);

      const arrayToMap = angular.copy(shapedItemsArray);
      factoryData.items = $filter('enhancedTableCells')(ListDetailMetadataFactory.getData(), shapedItemsArray);

      const itemsObject = _.reduce(arrayToMap, function (itemsObject, v) {
        itemsObject[v.list._id] = v;
        return itemsObject;
      }, {});
      factoryData.itemsObject = itemsObject;
      factoryData.selectedItems = [];
    }

    function shapeDataForGrid(arrayOfUnprocessedListItems) {
      return _.map(arrayOfUnprocessedListItems, function (item) {
        return {
          list: {
            _id: (item.code || '') + '_' + item.caption,
            caption: item.caption || '',
            code: item.code || '',
            reportingLabel: item.reportingLabel || '',
            showMoreInfoTextfield: item.showMoreInfoTextfield || 0,
            points: item.points || 0
          }
        };
      });
    }

    function addItemToList(item) {
      if (item.code.trim() === '') delete item.code;
      return ListApiFactory.addNewListItem(factoryData._id, item)
        .then(function (resp) {
          if (resp) {
            item._id = (item.code || '') + '_' + item.caption;
            const itemReadyForGrid = shapeDataForGrid([item]);
            const itemToPush = $filter('enhancedTableCells')(ListDetailMetadataFactory.getData(), itemReadyForGrid);
            factoryData.items.push(itemToPush[0]);
            factoryData.itemsObject[item._id] = {
              list: item
            };
            return true;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function saveList() {
      const list = prepareListForSaving();
      return ListApiFactory.saveList(list)
        .then(function (resp) {
          if (resp.statusText === 'OK') {
            return true;
          } else {
            return false;
          }
        });
    }

    function deleteList(listId) {
      // THIS WILL DELETE THE DOCUMENT. ONLY USE FOR DEV!
      return ListApiFactory.deleteList(listId)
        .then(function (res) {
          if (res.status === 200) {
            return true;
          } else {
            return false;
          }
        });
    }

    function archiveList(listId) {
      const list = {
        _id: listId,
        archived: 1
      };
      return ListApiFactory.saveList(list)
        .then(function (res) {
          if (res.status === 200) {
            return true;
          } else {
            return false;
          }
        });
    }

    function unarchiveList(listId) {
      const list = {
        _id: listId,
        archived: 0
      };
      return ListApiFactory.saveList(list)
        .then(function (res) {
          if (res.status === 200) {
            return true;
          } else {
            return false;
          }
        });
    }

    function removeItemsFromList(ev) {

      MessageService
        .confirm(ev)
        .delete('Sure to delete these list items?')
        .then(function () {

          factoryData.items = factoryData.items.filter(function (item) {
            return !item.selected;
          });

          const list = prepareListForSaving();

          return ListApiFactory.saveList(list)
            .then(function () {
              MessageService.showMessage(factoryData.selectedItems.length + ' items deleted');
              ListOfListsFactory.invalidateCache();
              factoryData.selectedItems = [];
              ChangeDelta.clear(); // ZP-1023
              return;
            })
            .catch(function (err) {
              $log.error(err);
              MessageService.showMessage(err.data.data.message);
              MessageService.writeLog({
                level: 'error',
                msg: err
              });
            });
        });
    }

    function prepareListForSaving() {
      const list = _.pick(factoryData, '_id', 'artefactType', 'title', 'items', 'clone', 'cloneId');
      const mappedItems = _.map(list.items, function (item) {
        const i = {
          caption: item.list.caption.raw,
          reportingLabel: item.list.reportingLabel.raw,
          points: item.list.points.raw,
          showMoreInfoTextfield: item.list.showMoreInfoTextfield.raw || 0
        };
        if (item.list.code.raw.trim() !== '') {
          i.code = item.list.code.raw;
        }
        return i;
      });
      list.items = mappedItems;
      return list;
    }

    function validateCell(paramsObj) {
      const validationObj = {
        label: paramsObj.metadata.label,
        valid: true,
        errors: []
      };

      if ((typeof paramsObj.newValue === 'string') && (paramsObj.newValue.indexOf(':') > -1)) {
        validationObj.valid = false;
        validationObj.errors.push({
          type: 'required',
          message: 'Colons aren\'t allowed!'
        });
      }
      if (!!paramsObj.metadata.validation && paramsObj.metadata.validation.unique) {
        const duplicate = _.find(factoryData.items, function (item) {
          if (item[paramsObj.metadata.object]['_id'] != paramsObj.objectId && !!paramsObj.newValue) {
            return item[paramsObj.metadata.object][paramsObj.metadata.databasefieldname].raw.toLowerCase() == paramsObj.newValue.toLowerCase();
          }
        });

        if (duplicate) {
          validationObj.valid = false;
          validationObj.errors.push({
            type: 'required',
            message: 'Value already in use. (' + duplicate[paramsObj.metadata.object].caption.raw + ')'
          });
        }
      }
      if (!!paramsObj.metadata.validation && paramsObj.metadata.validation.required && paramsObj.newValue === '') {
        validationObj.valid = falsee;
        validationObj.errors.push({
          type: 'required',
          message: 'This field is required'
        });
      }
      return validationObj;
    }

    function validateNewListItem(newItem, formErrorsObj) {
      let valid = true;
      let relevantValueToValidate = newItem.code || newItem.caption;
      let storableValue;

      if (newItem.code.indexOf(':') > -1 || newItem.caption.indexOf(':') > -1) {
        formErrorsObj.colon_char_Error = true;
        valid = false;
      }
      for (let i = 0, j = factoryData.items.length; i < j; i++) {
        storableValue = factoryData.items[i].list.code.raw || factoryData.items[i].list.caption.raw;
        if (relevantValueToValidate.toLowerCase() == storableValue.toLowerCase()) {
          const incomingFieldType = newItem.code ? 'code' : 'caption';
          const existingFieldType = factoryData.items[i].list.code.raw ? 'code' : 'caption';
          const existingFieldTypeValue = factoryData.items[i].list.caption.raw;
          formErrorsObj.storable_value_exists_ErrorMessage = 'The requested ' + incomingFieldType + ' (' + relevantValueToValidate + ') already exists as the ' + existingFieldType + ' within item ' + (i + 1) + ' (' + existingFieldTypeValue + ')';
          valid = false;
        }
        if (factoryData.items[i].list.caption.raw && !newItem.code) {
          if (factoryData.items[i].list.caption.raw.toLowerCase() === newItem.caption.toLowerCase()) {
            formErrorsObj.caption_label_exists_Error = true;
            valid = false;
          }
        }
        if (factoryData.items[i].list.reportingLabel.raw) {
          if (factoryData.items[i].list.reportingLabel.raw.toLowerCase() === newItem.reportingLabel.toLowerCase()) {
            formErrorsObj.reporting_label_exists_Error = true;
            valid = false;
          }
        }
      }
      return valid;
    }

    function changeSortOrder(orderObj) {
      const oldOrder = angular.copy(factoryData.items);
      const newOrder = SortingFactory.sortEntireArray(orderObj, factoryData.items)||[];

      factoryData.items = newOrder;
      ChangeDelta.recordValueChange(oldOrder, newOrder, 'listOrder', 'foo', 'bar');
    }

    function clearSelectedArray(){
      _.each(factoryData.items, function (itm){
        itm.selected = false;
      });

      factoryData.allItemsSelected = false;
      factoryData.selectedItems.length = 0;
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('lists')
    .component('zpListDetailPage', {
      templateUrl: 'app/lists/detail/list-detail-page-component/list.detail-page.tmpl.html',
      controller: 'ListDetailController'
    })
    .controller('ListDetailController', ListDetailController);

  ListDetailController.$inject = ['$scope', 'MessageService', 'CurrentListModel', 'ListDetailMetadataFactory', 'ChangeDelta', 'PaginationManager', '$log', 'EnvService', 'ListOfListsFactory', 'MasterPermissionsDefinitionFactory', 'PermPermissionStore', 'GridDataFactory', 'GridMetaDataFactory', 'ToolbarFactory'];
  /* ng-inject */
  function ListDetailController($scope, MessageService, CurrentListModel, ListDetailMetadataFactory, ChangeDelta, PaginationManager, $log, EnvService, ListOfListsFactory, MasterPermissionsDefinitionFactory, PermPermissionStore, GridDataFactory, GridMetaDataFactory, ToolbarFactory) {

    var vm = this;

    vm.$onChanges = function (changes) {
      if (changes.clearSelectedArray) {
        vm.clearSelectedArray();
      }
    };

    vm.clearSelectedArray = false;
    vm.showHints = false;

    vm.$onInit = function () {
      vm.data = CurrentListModel.getData();
      vm.metadata = ListDetailMetadataFactory.getData();
      vm.metadata.reorderItems = false; // set this manually here so the user always starts at the add list items screen
      GridDataFactory.hydrateData(vm.data, vm.metadata.id);
      GridMetaDataFactory.hydrateData(vm.metadata.columnsData, vm.metadata.id);
      vm.permissions = MasterPermissionsDefinitionFactory;
      permissionsCheck();
      PaginationManager.setQuery(vm.metadata.query, vm.metadata.id);

      vm.changeDeltaFactory = ChangeDelta;
      ChangeDelta.clear();

      vm.menuOptions = [{
        onClick: 'archiveList',
        ariaLabel: function () {
          return 'Archive list';
        },
        icon: function () {
          return 'zmdi zmdi-archive';
        },
        label: function () {
          return 'Archive List';
        },
        permissions: MasterPermissionsDefinitionFactory.boltOns.formManagement.predefinedLists.archive
      }, {
        onClick: 'showHints',
        ariaLabel: function () {
          return vm.showHints ? 'Hide hints' : 'Show hints';
        },
        icon: function () {
          return vm.showHints ? 'zmdi zmdi-eye-off' : 'zmdi zmdi-eye';
        },
        label: function () {
          return vm.showHints ? 'Hide hints' : 'Show hints';
        }
      }];
      if (EnvService.isDev) {
        vm.menuOptions.push({
          onClick: 'deleteList',
          ariaLabel: function () {
            return 'Delete list';
          },
          icon: function () {
            return 'zmdi zmdi-delete';
          },
          label: function () {
            return 'Delete List';
          }
        });
      }
    };

    vm.clearSelectedCheckboxClicked = function (){
      CurrentListModel.clearSelectedArray();
    };

    vm.updateTitle = function (newval) {
      if (vm.data.title == newval) return;
      ChangeDelta.recordValueChange({
        oldval: vm.data.title,
        newval: newval,
        objectid: 'list_title',
        collection: 'lists',
        databasefieldname: 'title'
      });
      if (newval != vm.data.title) {
        vm.data.title = newval;
      }
    };

    $scope.$on('zp.table.queueForSaving', function () {
      vm.saveChanges();
    });

    vm.saveChanges = function () {

      CurrentListModel.save()
        .then(function () {
          ToolbarFactory.set({
            title: vm.data.title,
          });

          ChangeDelta.clear();
          MessageService.showMessage('Changes saved');
          ListOfListsFactory.invalidateCache();
        })
        .catch(function (err) {
          $log.error(err);
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };

    vm.deleteList = function (zpEvent, srcEvent) {
      MessageService
        .confirm(srcEvent)
        .delete('Are you sure you want to delete this list?')
        .then(function () {
          CurrentListModel.deleteList(vm.data._id)
            .then(function () {
              MessageService.showMessage('List deleted');
              ListOfListsFactory.invalidateCache();
              $scope.$emit('zp.list-deleted');
            });
        }, function (err) {
          MessageService.showMessage(err);
        })
        .catch(function (err) {
          $log.error(err);
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };

    vm.archiveList = function (zpEvent, srcEvent) {
      MessageService
        .confirm(srcEvent)
        .confirmAction({
          title: 'Are you sure you want to archive this list?',
          htmlContent: ChangeDelta.isDirty() ? ' You have unsaved changes. These changes will not be saved if you continue.' : '',
          okBtn: 'Yes, archive',
          cancelBtn: 'Cancel'
        })
        .then(function () {
          CurrentListModel.archiveList(vm.data._id)
            .then(function () {
              MessageService.showMessage('List archived');
              ListOfListsFactory.invalidateCache();
              $scope.$emit('zp.list-deleted');
            });
        })
        .catch(function (err) {
          if (!err) return;
          $log.error(err);
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };

    vm.unarchiveList = function () {
      CurrentListModel.unarchiveList(vm.data._id)
        .then(function () {
          MessageService.showMessage('List unarchived');
          ListOfListsFactory.invalidateCache();
          vm.data._deletedatelocalutc = 0; // to hide button in view
        });
    };

    vm.onMenuClick = function (ev) {
      if (ev.action == 'deleteList') vm.deleteList();
      if (ev.action == 'archiveList') vm.archiveList();
      if (ev.action == 'showHints') vm.toggleHints();
    };

    $scope.$on('deleteList', vm.deleteList);
    $scope.$on('archiveList', vm.archiveList);

    vm.archiveItems = function (ev) {
      CurrentListModel.removeItemsFromList(ev);
    };

    vm.toggleHints = function () {
      vm.showHints = !vm.showHints;
      vm.metadata.fabDialogConfig.locals.showHints = !vm.metadata.fabDialogConfig.locals.showHints;
    };

    function permissionsCheck() {
      const isTrump = PermPermissionStore.getPermissionDefinition('TRUMP');
      const permission = PermPermissionStore.getPermissionDefinition('LISTS_EDIT');

      isTrump.validatePermission()
        .then(function () {
          // user is trump, they can select rows and interact with the list widget
          setGridOptions(true);
        })
        .catch(function () {
          // user isn't trump, check if they have edit lists permissions
          permission.validatePermission()
            .then(function () {
              // they do
              setGridOptions(true);
            })
            .catch(function () {
              // they don't
              setGridOptions(false);
            });
        });

    }

    function setGridOptions(value) {
      vm.metadata.gridOptions.rowSelection = value;
      vm.metadata.gridOptions.interactive = value;
    }

    vm.onSortChange = function (order) {
      CurrentListModel.changeSortOrder(order);
    };

    vm.reorderButtonClicked = function () {
      vm.showSearch = false;
      // we clear the column ordering because the user has broken into manual sort. we must show that custom order in the UI
      vm.metadata.reorderItems = !vm.metadata.reorderItems;
      vm.metadata.query.order = {
        id: '',
        expression: ''
      };
    };

    vm.toggleSearch = function (){
      if (vm.metadata.reorderItems){
        vm.searchValue = '';
        return;
      }
      vm.showSearch = !vm.showSearch;
      vm.searchValue = '';
    };
  }
})();

/**
 * Created by davidbeazer on 25/08/2016.
 */

'use strict';

angular
  .module('lists')
  .controller('ListsAddItemsController', ListsAddItemsController);

ListsAddItemsController.$inject = ['$scope', 'CurrentListModel', 'hotkeys', 'locals', 'MessageService', '$log', 'ListOfListsFactory'];
/* ng-inject */
function ListsAddItemsController($scope, CurrentListModel, hotkeys, locals, MessageService, $log, ListOfListsFactory) {

  var vm = this;  

  vm.showHints = locals.showHints;
  vm.currentList = CurrentListModel.getData();
  vm.newItem = listItemDefaults();
  vm.storedValue = function () {
    return vm.newItem.code || vm.newItem.caption;
  };
  vm.listId = vm.currentList._id;
  // vm.submitForm = submitForm;
  vm.formErrors = formErrorsDefaults();

  activate();

  function activate() {
    unbindHotkeys();
    bindHotkeys();
  }

  vm.submitForm = function submitForm(closeDialog) {
    $log.info('submitForm new list item');
    vm.disableSave = true;
    vm.validateForm(true);
    if (!vm.valid) {
      $log.info('item invalid, not saving');
      return false;
    } else {
      $log.info('item is valid: ' + JSON.stringify(vm.newItem));
      CurrentListModel.addItemToList(vm.newItem)
        .then(function (response) {
          if (response) {
            MessageService.showMessage('List item added');
            vm.newItem = listItemDefaults();
            vm.formErrors = formErrorsDefaults();
            vm.disableSave = false;
            ListOfListsFactory.invalidateCache();
            if (closeDialog) {
              hotkeys.del('shift+enter');
              vm.hide();
            }
          }
        })
        .catch(function (err) {
          $log.error(err);
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    }
  };

  vm.validateForm = function (saving) {
    vm.valid = true;
    vm.formErrors = formErrorsDefaults();

    if (vm.newItem.caption === '' && vm.newItem.code === '') {
      if (vm.addItemsForm.code.$untouched && !saving) return;
      vm.formErrors.blank_code_blank_caption_Error = true;
      vm.valid = false;
      return;
    } else {
      vm.formErrors.blank_code_blank_caption_Error = false;
    }
    /**
    does a check in the model for no matching captions or codes
     */
    vm.valid = CurrentListModel.validateNewListItem(vm.newItem, vm.formErrors);
    vm.disableSave = !vm.valid;
  };

  vm.hide = function () {
    unbindHotkeys();
    MessageService.closeDialog();
  };

  vm.cancel = function () {
    unbindHotkeys();
    MessageService.cancelDialog();
  };

  vm.answer = function () {
    unbindHotkeys();
    MessageService.closeDialog(true);
  };

  function bindHotkeys() {
    hotkeys.bindTo($scope)
      .add({
        combo: 'shift+enter',
        description: 'Add item and close',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function () {
          vm.submitForm(true);
        }
      })
      .add({
        combo: 'enter',
        description: 'Add item',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (ev) {
          if (ev.srcElement.nodeName !== 'BUTTON') {
            vm.submitForm(false);
          }
        }
      });
  }

  function unbindHotkeys() {
    // hotkeys.del('enter');
    // hotkeys.del('shift+enter');
    // hotkeys.del('ctrl+a');
    // hotkeys.del('ctrl+d');
    // hotkeys.del('ctrl+s');
  }

  function listItemDefaults() {
    return {
      caption: '',
      code: '',
      reportingLabel: '',
      points: '',
      showMoreInfoTextfield: 0
    };
  }

  function formErrorsDefaults() {
    return {
      blank_code_blank_caption_Error: false,
      reporting_label_exists_Error: false,
      caption_label_exists_Error: false,
      storable_value_exists_ErrorMessage: '',
      colon_char_Error: false
    };
  }

  vm.preventKeyStrokes =function(event) {
    event = event || window.event;
    var key = event.keyCode || event.which;
    key = String.fromCharCode(key);
    if (key == '.' || key =='-'){
      event.preventDefault();    
      return false;
    }
  }; 
}

(function () {
  'use strict';

  angular
    .module('lists')
    .component('zpAddListItemFab', {
      templateUrl: 'app/lists/detail/fab/fab.tmpl.html',
      controller: 'zpAddListItemFabCtrl'
    })
    .controller('zpAddListItemFabCtrl', ctrl);

  ctrl.$inject = ['CurrentListModel', 'ListDetailMetadataFactory', 'MasterPermissionsDefinitionFactory'];
  /* nj-inject */
  function ctrl(CurrentListModel, ListDetailMetadataFactory, MasterPermissionsDefinitionFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.data = CurrentListModel.getData();
      vm.metadata = ListDetailMetadataFactory.getData();
      vm.permissions = MasterPermissionsDefinitionFactory;
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpMachinesListView', {
      templateUrl: 'app/integration/home-page/zp-machines-list-view-shell/tmpl.html',
      controller: 'integrationMachinesListPageCtrl',
      bindings: {
        machines: '<',
        metadata: '<'
      }
    })
    .controller('integrationMachinesListPageCtrl', controller);

  controller.$inject = ['MessageService', 'DotNetShuttleService', 'ConnectionStatusService', 'GlobalAccessFactory', 'MachinesMetadata', 'SearchValFactory', '$filter', 'MasterPermissionsDefinitionFactory'];
  /* ng-inject */
  function controller(MessageService, DotNetShuttleService, ConnectionStatusService, GlobalAccessFactory, MachinesMetadata, SearchValFactory, $filter, MasterPermissionsDefinitionFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.factoryData = MachinesMetadata.getData().orderBy;
      vm.search = SearchValFactory.get(vm.metadata.id);
      vm.connectionStatusFactoryData = ConnectionStatusService.getData();

      vm.integrationHubOverviewImageSvg = $filter('cdnAssets')('/images/svgs/placeholders/integration/integration-external-connections-overview.svg');
      authenticateViaJwt();
    };

    vm.launchConnectionDialog = function (ev, action) {
      ConnectionStatusService.showDialog({
        ev: ev,
        action: action
      });
    };

    vm.openNewMachineDialog = function (ev) {
      MessageService.showDialog(ev, {
        description: 'New Machine',
        controller: 'AddMachineDialogController as $ctrl',
        templateUrl: 'app/integration/dialogs/zp-add-machine-dialog/tmpl.html',
        ariaLabel: 'Create new machine',
        locals: {}
      });
    };

    function authenticateViaJwt() {
      DotNetShuttleService.authenticateViaJwt()
        .then(function (res) {
          vm.serviceUnavailable = res.xhrStatus === 'error';
          const requests = [];
          vm.configuredPlatforms = GlobalAccessFactory.getListOfConfiguredIntegrations();
          if (!vm.configuredPlatforms.length) return;

          _.each(vm.configuredPlatforms, function (platform) {
            if (platform.name === 'sfdc' || platform.name === 'eloqua') {
              requests.push(ConnectionStatusService.testConnectionIfNecessary(platform.name));
            }
          });

          return Promise.all(requests);
        })
        .catch(function (err) {
          vm.serviceUnavailable = true; // triggers showing the user a service unavailable notice with any error message received. TODO: // what possible errors would this return? Authentication to .NET && testing connections to SFDC and Eloqua
          MessageService.showMessage(err);
          MessageService.writeLog({
            level: 'error',
            msg: JSON.stringify(err),
            tags: ['integration']
          });
        });
    }

  }

}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpMachinesListSearchToolbar', {
      templateUrl: 'app/integration/home-page/zp-machines-list-search-toolbar/tmpl.html',
      controller: 'MachinesListSearchToolbarCtrl',
      bindings: {}
    })
    .controller('MachinesListSearchToolbarCtrl', controller);

  controller.$inject = ['MachinesFactory'];
  /* ng-inject */
  function controller(MachinesFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.factoryData = MachinesFactory.factoryData;

      vm.metadata = {
        title: {
          label: 'Integration Machines',
          editable: false,
          filterLabel: 'Filter machines'
        }
      };
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpMachineListPageSideContainer', {
      templateUrl: 'app/integration/home-page/zp-machine-list-page-side-shell/tmpl.html',
      controller: 'MachineSidebarContainerCtrl',
      bindings: {
        machines: '<'
      }
    })
    .controller('MachineSidebarContainerCtrl', controller);

  controller.$inject = ['ConnectionStatusService'];
  /* ng-inject */
  function controller(ConnectionStatusService) {

    var vm = this;

    vm.$onInit = function () {
      vm.configuredIntegrations = ConnectionStatusService.updatePropsBoundToViewModel();
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpMachineListItem', {
      controller: 'MachineListItemCtrl',
      templateUrl: 'app/integration/home-page/zp-machine-list-item/tmpl.html',
      bindings: {
        machine: '<'
      }
    })
    .controller('MachineListItemCtrl', controller);

  controller.$inject = ['MessageService', '$state', 'MachinesFactory', '$filter'];
  /* ng-inject */
  function controller(MessageService, $state, MachinesFactory, $filter) {

    var vm = this;

    vm.$onInit = function () {
      vm.imgSrc = setImgSrc(vm.machine.actuator.system);
    };

    function setImgSrc(system) {
      if (system === 'SFDC') {
        return $filter('cdnAssets')('/images/pngs/icons/third-party/salesforce-square.png');
      } else if (system === 'Eloqua') {
        return $filter('cdnAssets')('/images/pngs/icons/third-party/eloqua-square.png');
      } else if (system === 'HttpPost') {
        return $filter('cdnAssets')('/images/pngs/icons/third-party/http.png');
      }
    }

    vm.manageMachineFormFilters = function (ev) {
      var config = {
        ev: ev,
        controller: 'MachineFormFiltersDialogCtrl',
        controllerAs: '$ctrl',
        templateUrl: 'app/integration/dialogs/zp-machine-form-filters-dialog/tmpl.html',
        locals: vm.machine
      };
      MessageService.showDialog(config.ev, config)
        .then(function () {
          // TODO
        })
        .catch(function () {
          // TODO
        });
    };

    vm.manageMachineSettings = function (ev) {
      var config = {
          ev: ev,
          controller: 'WildcardMappingDialogCtrl',
          controllerAs: '$ctrl',
          templateUrl: 'app/integration/dialogs/zp-wildcard-mapping-dialog/tmpl.html',
          locals: vm.machine
        },
        copyOfMachine = angular.copy(vm.machine);

      MessageService.showDialog(config.ev, config)
        .then(function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'changes to machine settings saved',
            tags: ['machine_settings']
          });
        })
        .catch(function () {
          vm.machine = copyOfMachine;
        });
    };

    vm.manageMappings = function () {
      $state.go('app.custom_toolbar_app_framework.mappings-view', {
        _machineid: vm.machine._machineid
      });
    };

    vm.setAction = function (ev, action) {
      MachinesFactory.setMachineAction(vm.machine, action);
    };

    vm.openMenu = function (func, ev) {
      func(ev);
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpEloquaFormSelect', {
      controller: 'EloquaFormSelectCtrl',
      templateUrl: 'app/integration/home-page/zp-eloqua-form-select/tmpl.html',
      bindings: {
        model: '<',
        onChange: '&',
        config: '<'
      }
    })
    .controller('EloquaFormSelectCtrl', controller);

  controller.$inject = ['EloquaConnectionService', '$timeout'];
  /* ng-inject */
  function controller(EloquaConnectionService, $timeout) {

    var vm = this;
    vm.items = [];

    vm.$onInit = function () {
      vm.searchText = '';
      vm.querySearch = querySearch;
      vm.selectedItem;
      buildAnswerItems();
    };

    function buildAnswerItems() {
      vm.loading = true;
      EloquaConnectionService.getEloquaForms()
        .then(function (res) {
          vm.items = _.extend(vm.items, res);
          locateSelectedItem();
          $timeout(function () {
            vm.loading = false;
            vm.errorMessage = '';
          }, 300);
        })
        .catch(function (err) {
          $timeout(function () {
            vm.loading = false;
            vm.errorMessage = err.message;
          }, 300);
        });
    }

    function locateSelectedItem() {
      if (!vm.model) return;
      var selectedItem = _.filter(vm.items, function (o) {
        return o.id == vm.model;
      });
      vm.selectedItem = selectedItem[0];
    }

    // md-autocomplete function
    function querySearch(query) {
      var results = query ? getFormList(query) : vm.items;
      return results;
    }

    function getFormList(query) {
      var localMatch = vm.items.filter(createFilter(query));
      if (localMatch.length) {
        return localMatch;
      } else {
        return queryEloquaApi(query)
          .then(function (res) {
            var matchingForms = res || [];
            return matchingForms;
          })
          .catch(function (err) {
            return err;
          });
      }
    }

    /**
     * Create filter function for a query string
     */
    function createFilter(query) {
      var lowercaseQuery = query.toLowerCase();
      return function filterFn(item) {
        return (item.name.toLowerCase().search(lowercaseQuery) != -1);
      };
    }

    function queryEloquaApi(query) {
      return EloquaConnectionService.queryEloquaForms(query)
        .then(function (res) {
          return res;
        })
        .catch(function (err) {
          throw err;
        });
    }

  }


}());

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('HydrateZuantFieldsColumn', factory);

  factory.$inject = ['FormMetadataFactory', 'MessageService', 'BuildZuantFieldStore'];
  /* ng-inject */
  function factory(FormMetadataFactory, MessageService, BuildZuantFieldStore) {

    // builds the lefthand sidebar that contains zuant fields available for mapping
    return function fillColumnA(sourceZuantFormId, viewModel, factoryData) {
      return FormMetadataFactory.buildGridColumns(sourceZuantFormId)
        .then(function (res) {
          resetZuantFieldsStore(viewModel);
          // pushDefaultStaticFieldsOntoStaticFieldsArray(viewModel);
          BuildZuantFieldStore(res.columnsData.items, viewModel, factoryData);
          addDefaultResponseFields(viewModel);
          return 'column A done';
        })
        .catch(function (err) {
          handleSourceFormFetchError(err, viewModel);
        });
    };


    function resetZuantFieldsStore(viewModel) {
      viewModel.zuantFields.companies.length = 0;
      viewModel.zuantFields.contacts.length = 0;
      viewModel.zuantFields.responses.length = 0;
      viewModel.zuantFields.static.length = 0;
    }

    function addDefaultResponseFields(viewModel) {
      viewModel.zuantFields.responses.push({
        element: '_imageUrl_1',
        label: 'Image URL 1',
        collection: 'responses'
      });
      viewModel.zuantFields.responses.push({
        element: '_imageUrl_2',
        label: 'Image URL 2',
        collection: 'responses'
      });
      viewModel.zuantFields.responses.push({
        element: '_imageUrl_3',
        label: 'Image URL 1',
        collection: 'responses'
      });
      viewModel.zuantFields.responses.push({
        collection: 'responses',
        element: '{{formname}}',
        label: 'Form name'
      });
      viewModel.zuantFields.responses.push({
        collection: 'responses',
        element: '{{formid}}',
        label: 'Form ID'
      });
  
    }

    // function pushDefaultStaticFieldsOntoStaticFieldsArray(viewModel) {
    //   viewModel.zuantFields.static.push({
    //     collection: 'responses',
    //     element: '{{formname}}'
    //   });
    //   viewModel.zuantFields.static.push({
    //     collection: 'responses',
    //     element: '{{formid}}'
    //   });
    // }


    function handleSourceFormFetchError(err, viewModel) {
      viewModel.showFormSelect = true;
      if (err.status === 404) {
        viewModel.errorMessage = 'The source Zuant form for this machine is missing. You can assign a new one below if you wish.';
      } else {
        viewModel.errorMessage = 'There was a problem fetching the Zuant source form';
      }
      MessageService.writeLog({
        level: 'error',
        msg: err,
        tags: ['integration', '404']
      });
      viewModel.zuantFieldsLoading = false;
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('HydrateColumnZ', factory);

  factory.$inject = ['AdjustZuantFieldMappingCount'];
  /* ng-inject */
  function factory(AdjustZuantFieldMappingCount) {

    // builds column Z objects from existing mappings. third party fields aren't here yet, those will be added once they arrive
    return function buildProxyMappings(machine, viewModel) {
      return new Promise(function (resolve) {
        _.each(machine.mappings, function (mapping) {
          // do these two after fetched 3rd party fields. it is only then that we will know the htmlName
          const mappedField = mapping[viewModel.thirdPartyMappingKey].field;
          addCaptionToField(mapping[viewModel.thirdPartyMappingKey], mappedField);
          adjustMappedFieldsLookup(mapping[viewModel.thirdPartyMappingKey].field, 'add', viewModel);
          adjustTransformsExistLookup(mapping, viewModel);
          AdjustZuantFieldMappingCount({
            collection: mapping.hps.collection,
            element: mapping.hps.element
          }, 'increase', viewModel);

          viewModel.proxyMappings.push({
            isDirty: false,
            mapping: [mapping],
            mdata: {
              required: false,
              datatype: ''
            }
          });
        });
        resolve();
      });
    };

    function addCaptionToField(mapping, mappedField){
      return mapping.caption = mappedField;
    }

    function adjustMappedFieldsLookup(field, action, viewModel) {
      if (action === 'add') {
        viewModel.mappedFields[field] = true;
      } else if (action === 'delete') {
        delete viewModel.mappedFields[field];
      }
    }

    function adjustTransformsExistLookup(mapping, viewModel) {
      if (!_.isEmpty(mapping.transform)) {
        viewModel.transformsExist[mapping[viewModel.thirdPartyMappingKey].field] = true;
      }
      if (_.isEmpty(mapping.transform) && viewModel.transformsExist[mapping[viewModel.thirdPartyMappingKey].field]) {
        delete viewModel.transformsExist[mapping[viewModel.thirdPartyMappingKey].field];
      }
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('GrabThirdPartyFieldsSvc', factory);

  factory.$inject = ['MessageService', 'GetThirdPartyObjects', 'localStorageService', 'FinishBuildingMappingModel'];
  /* ng-inject */
  function factory(MessageService, GetThirdPartyObjects, localStorage, FinishBuildingMappingModel) {

    return function grabThirdPartyFields(factoryData, viewModel) {
      viewModel.loadingForeignFieldsIndicator = true;
      return GetThirdPartyObjects(buildQueryForFetchingThirdPartyFields(factoryData.currentMachine))
        .then(function (foreignFields) {
          localStorage.set('foreignFields_' + factoryData.currentMachine._machineid, {
            timestamp: new Date(),
            fields: foreignFields
          });
          FinishBuildingMappingModel(foreignFields, viewModel, factoryData);
          MessageService.writeLog({
            level: 'info',
            msg: 'successfully grabbed fields from ' + factoryData.currentMachine.actuator.system,
            tags: ['integration']
          });
        })
        .catch(function (err) {
          const localCopyOfForeignFields = localStorage.get('foreignFields_' + factoryData.currentMachine._machineid);
          if (localCopyOfForeignFields) {
            FinishBuildingMappingModel(localCopyOfForeignFields.fields, viewModel, factoryData);
          }
          viewModel.loadedFromCache = false;
          viewModel.loadingForeignFieldsIndicator = false;
          viewModel.showThirdPartyConnectionError = true;
          viewModel.connectionError = err.message;
          if (localCopyOfForeignFields) {
            viewModel.loadedFromCache = true;
            viewModel.cachedFieldsTimestamp = localCopyOfForeignFields.timestamp;
            MessageService.showMessage('Failed to load. Loaded from cache');
          } else {
            MessageService.showMessage('Failed to load foreign fields');
          }
          MessageService.writeLog({
            level: 'error',
            msg: 'unsuccessfully grabbed fields from ' + factoryData.currentMachine.actuator.system,
            tags: ['integration']
          });
        });
    };

    function buildQueryForFetchingThirdPartyFields(machineInfo) {
      const ro = {
        platform: machineInfo.actuator.system,
        id: ''
      };
      if (machineInfo.actuator.system === 'Eloqua') {
        ro.id = machineInfo.actuator.typeid;
      } else if (machineInfo.actuator.system === 'SFDC') {
        ro.id = 'Lead';
      } else if (machineInfo.actuator.system === 'HttpPost') {
        ro.id = '';
      }
      return ro;
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .service('GetThirdPartyObjects', service);

  service.$inject = ['DotNetCommands', 'DotNetShuttleService', 'ConnectionStatusService', 'EloquaConnectionService'];
  /* ng-inject */
  function service(DotNetCommands, DotNetShuttleService, ConnectionStatusService, EloquaConnectionService) {

    return function (options) {
      if (options.platform == 'SFDC') {
        return new Promise(function (resolve, reject) {
          const myShuttle = {
            command: DotNetCommands.shuttleCommands.visitEmbassy,
            enquiry: 'getmeta',
            system: options.platform
          };
          if (options.id) {
            myShuttle.id = options.id;
          }

          return DotNetShuttleService.launchShuttle(myShuttle)
            .then(function (response) {
              resolve(normaliseResponse(options, response));
            })
            .catch(function (err) {
              reject(err);
            });
        });
      } else if (options.platform === 'Eloqua') {
        return EloquaConnectionService.getEloquaFormById(options.id)
          .then(function (res) {
            return res;
          })
          .catch(function (err) {
            throw new Error(err);
          });
      }
    };

    function normaliseResponse(options, serverResponse) {
      ConnectionStatusService.setConnectionStatus(options.platform, serverResponse);
      if (serverResponse.nutshell === 'yes') {
        // happy response
        return serverResponse.fields;
      } else {
        // error
        throw new Error(serverResponse.errorMessage);
      }
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('FinishBuildingMappingModel', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    return function finishBuildingMappingModel(foreignFields, viewModel, factoryData) {
      // call to fetch 3rd party fields has returned. we now go back through the mappings to fill in any blanks (basically hydrate the rest of the fields that aren't mapped)
      foreignFields = rejectFieldsAlreadyInMapping(foreignFields, viewModel, factoryData);
      finishBuildingMappingFastLookupShell(foreignFields, viewModel, factoryData);
      viewModel.loadingForeignFieldsIndicator = false;
      finishBuildingMappingShell(foreignFields, viewModel, factoryData);
    };

    function rejectFieldsAlreadyInMapping(foreignFields, viewModel, factoryData) {
      // TODO someday soon. rename/refactor as this is doing several things
      // filters out fields already mapped
      // when encountering a field that has already been mapped..
      // set the fast lookup object for mapping - this is used for tracking what the original mapping was when adding deltas to ChangeDelta factory.
      // - add in the field metatdata (which wasn't available til now)

      const filteredFields = _.reject(foreignFields, function (field) {

        const foreignFieldKey = viewModel.thirdPartyMappingKey === 'eloqua' ? 'htmlName' : 'name';

        return _.some(viewModel.proxyMappings, function (row) {
          if (field[foreignFieldKey] === row.mapping[0][viewModel.thirdPartyMappingKey].field) {
            // here we have a field that has been mapped.
            // add it to mapping fast lookup object and set metadata to 3rd party field
            
            setMetadataForField(row, field, viewModel, factoryData);
            setFieldValue(viewModel, row, field);
            setFieldCaption(viewModel, row, field);
            setMappingFastLookup(row, viewModel);
            
            return true;
          }
        });
      });
      // returns remaining foreign fields that aren't mapped
      return filteredFields;
    }

    function setFieldValue(viewModel, row, field) {
      row.mapping[0][viewModel.thirdPartyMappingKey].field = (viewModel.thirdPartyMappingKey === 'eloqua') ? field.htmlName : field.name;
    }

    function setFieldCaption(viewModel, row, field) {
      row.mapping[0][viewModel.thirdPartyMappingKey].caption = (viewModel.thirdPartyMappingKey === 'eloqua' || viewModel.thirdPartyMappingKey === 'foreign') ? field.name : field.label;
    }

    function setMappingFastLookup(row, viewModel) {
      // assigning hps element to key of third party field so view knows it has been mapped and can style accordingly
      viewModel.mappingFastLookup[row.mapping[0][viewModel.thirdPartyMappingKey].field] = row.mapping[0].hps.element;
    }

    function setMetadataForField(row, field) {
      row.mdata.required = deduceFieldIsRequired(field);
      row.mdata.datatype = field.datatype || field.dataType, // sfdc = datatype | eloqua = datatType
      row.mdata.id = field.id;
    }

    function finishBuildingMappingFastLookupShell(foreignFields, viewModel) {
      _.each(foreignFields, function (item) {
        const itemKey = viewModel.thirdPartyMappingKey === 'eloqua' ? 'htmlName' : 'name';
        viewModel.mappingFastLookup[item[itemKey]] = '';
      });
    }

    function finishBuildingMappingShell(foreignFields, viewModel, factoryData) {
      _.each(foreignFields, function (foreignfield) {
        const fieldMappingShell = {};
        fieldMappingShell.isDirty = false;
        fieldMappingShell.hps = {
          collection: '',
          element: ''
        }; // this has yet to be mapped, if ever!
        fieldMappingShell[viewModel.thirdPartyMappingKey] = {
          caption: workOutCaption(foreignfield, factoryData),
          field: workOutFieldValue(foreignfield, factoryData), // REST use name prop, soap machines reference the htmlName
          object: set3rdPartyObjectKey(viewModel, factoryData)
        };
        if (viewModel.thirdPartyMappingKey === 'eloqua') {
          fieldMappingShell.eloqua.fieldReference = foreignfield.id;
        }
        fieldMappingShell.transform = {};
        viewModel.proxyMappings.push({
          mapping: [fieldMappingShell],
          mdata: {
            // TODO account for other types of validation. i.e: must be a data, number, etc etc
            required: deduceFieldIsRequired(foreignfield),
            datatype: foreignfield.datatype || foreignfield.dataType, // sfdc = datatype | eloqua = datatType
            id: foreignfield.id
          }
        });
      });
    }

    function workOutFieldValue(fieldData, factoryData) {
      if (factoryData.currentMachine.actuator.system == 'Eloqua') {
        return fieldData.htmlName;
      } else { // SFDC || HttpPost
        return fieldData.name;
      }
    }

    function workOutCaption(fieldData, factoryData) {
      if (factoryData.currentMachine.actuator.system == 'Eloqua') {
        return fieldData.name;
      } else if (factoryData.currentMachine.actuator.system == 'HttpPost') {
        return fieldData.caption;
      } else if (factoryData.currentMachine.actuator.system == 'SFDC') {
        return fieldData.label;
      }
    }

    function deduceFieldIsRequired(foreignfield) {
      if (foreignfield.required) return true;
      if (foreignfield.validations) {
        // TODO account for other types of validation
        let required;
        _.each(foreignfield.validations, function (validation) {
          if (validation.condition.type === 'IsRequiredCondition') required = true;
        });
        return required;
      }
    }

    function set3rdPartyObjectKey(viewModel, factoryData) {
      if (viewModel.thirdPartyMappingKey === 'sfdc' || viewModel.thirdPartyMappingKey === 'httppost' || viewModel.thirdPartyMappingKey === 'foreign') {
        return 'Lead';
      } else if (viewModel.thirdPartyMappingKey === 'eloqua') {
        return factoryData.currentMachine.actuator.typename;
      }
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('BuildZuantFieldStore', factory);

  factory.$inject = ['AdjustZuantFieldMappingCount', 'localStorageService'];
  /* ng-inject */
  function factory(AdjustZuantFieldMappingCount, localStorage) {

    return function buildZuantFieldStore(fields, viewModel, factoryData) {

      const allFields = addExtraFieldsFromLocalStorage(fields, factoryData);

      _.each(allFields, function (colData) {
        const pluralCollectionName = pluraliseCollection(colData.object);
        
        viewModel.zuantFields[pluralCollectionName].push({
          element: colData.databasefieldname,
          label: colData.label,
          collection: pluralCollectionName
        });

        AdjustZuantFieldMappingCount({
          collection: pluralCollectionName,
          element: colData.databasefieldname
        }, null, viewModel);
      });
    };

    function addExtraFieldsFromLocalStorage(fieldsFromServer, factoryData) {
      const extraFields = localStorage.get('extraFields_' + factoryData.currentMachine._machineid) || [];
      if (!extraFields.length) return fieldsFromServer;

      const extraFieldsMapped = _.map(extraFields, function (field) {
        return {
          databasefieldname: field.dbname,
          label: field.dbname, // no label created when user adds a db field via the sidebar,
          caption: field.dbname,
          object: pluraliseCollection(field.object)
        };
      });
      return extraFieldsMapped.concat(fieldsFromServer);
    }

    function pluraliseCollection(collection) {
      if (collection === 'company') return 'companies';
      if (collection === 'contact') return 'contacts';
      if (collection === 'response') return 'responses';
      return collection; // if collection is already plural just return it
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('BuildMachineViewModel', factory);

  factory.$inject = ['HydrateColumnZ', 'HydrateZuantFieldsColumn'];
  /* ng-inject */
  function factory(HydrateColumnZ, HydrateZuantFieldsColumn) {

    /**
     * @module integration
     * @function BuildMachineViewModel
     * @description this function is called when the machine mappings page loads.
        It sets up the machine-mappings-view-model factory by first binding the machine to the factory,
        then it calls the HydrateZuantFieldsColumn function to grab the zuant fields for the source form
        and finally it calls HydrateColumnZ to build the proxyMappings for the machine
     * @param {object} machine the machine being managed in the view
     * @param {object} viewModel is an object containing view helper properties
     * @param {object} factoryData pertains to the actual machine data
     * @returns this function returns a promise which resolves fully hydrated viewModel and factoryData objects
     */

    return function buildMachineModelForView(machine, viewModel, factoryData) {
      setFactoryDataProperties(machine, factoryData);
      setViewModelProperties(machine, viewModel);

      return new Promise(function (resolve, reject) {
        if (!machine.sourceZuantFormId) {
          // console.log('TODO. need to provide a default set of fields for Zuant fields sidebar');
        }
        return HydrateZuantFieldsColumn(machine.sourceZuantFormId, viewModel, factoryData)
          .then(function (res) {
            factoryData.columnAResponse = res;
            return resolve(HydrateColumnZ(machine, viewModel));
          })
          .catch(function (err) {
            return reject(err);
          });
      });
    };

    function setFactoryDataProperties(machine, factoryData) {
      factoryData.currentMachine = machine;
      factoryData.currentMachineCopy = angular.copy(machine);
    }

    function setViewModelProperties(machine, viewModel) {
      workOutThirdPartyMappingKey(machine.actuator.system, viewModel);
      viewModel.showThirdPartyConnectionError = false;
      viewModel.proxyMappings.length = 0;
      viewModel.mappedFields = {};
      viewModel.transformsExist = {};
      viewModel.zuantFieldMappingCounts = {};
      viewModel.mappingFastLookup = {};
    }

    function workOutThirdPartyMappingKey(system, viewModel) {
      if (system == 'HttpPost') viewModel.thirdPartyMappingKey = 'foreign';
      if (system == 'SFDC') viewModel.thirdPartyMappingKey = 'sfdc';
      if (system == 'Eloqua') viewModel.thirdPartyMappingKey = 'eloqua';
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('AdjustZuantFieldMappingCount', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    /**
     * keeps track of the number of zuant fields in the left hand toolbar have been mapped to the machine mappings
     */
    return function adjustZuantFieldMappingCount(fieldInfo, operation, viewModel) {
      if (!operation) viewModel.zuantFieldMappingCounts[[fieldInfo.collection] + '_' + [fieldInfo.element]] = 0;
      if (!viewModel.zuantFieldMappingCounts[[fieldInfo.collection] + '_' + [fieldInfo.element]]) viewModel.zuantFieldMappingCounts[[fieldInfo.collection] + '_' + [fieldInfo.element]] = 0;

      if (operation === 'increase') {
        viewModel.zuantFieldMappingCounts[[fieldInfo.collection] + '_' + [fieldInfo.element]] += 1;
      } else if (operation === 'decrease') {
        viewModel.zuantFieldMappingCounts[[fieldInfo.collection] + '_' + [fieldInfo.element]] -= 1;
      }
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('saveMachineFab', {
      controller: 'saveMachineFabCtrl',
      templateUrl: 'app/integration/fabs/save-machine/tmpl.html',
      bindings: {}
    })
    .controller('saveMachineFabCtrl', controller);

  controller.$inject = ['ChangeDelta', 'MachineMappingsViewModel'];
  /* ng-inject */
  function controller(ChangeDelta, MachineMappingsViewModel) {

    var vm = this;

    vm.$onInit = function () {
      vm.changeDelta = ChangeDelta;
    };

    vm.onSave = function (){
      MachineMappingsViewModel.saveMachine();
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpAddMachineFab', {
      templateUrl: 'app/integration/fabs/add-machine/tmpl.html',
      controller: 'AddMachineFabCtrl',
      bindings: {
        machines: '<',
        metadata: '<'
      }
    })
    .controller('AddMachineFabCtrl', controller);

  controller.$inject = [];
  /* ng-inject */
  function controller() {

    var vm = this;

    vm.$onInit = function (){};

  }

})();

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpWildcardMappingDialog', {
      templateUrl: 'app/integration/dialogs/zp-wildcard-mapping-dialog/tmpl.html',
      controller: 'WildcardMappingDialogCtrl',
      bindings: {
        locals: '<'
      }
    })
    .controller('WildcardMappingDialogCtrl', controller);

  controller.$inject = ['MessageService', '$log', 'locals', 'ChangeDelta', 'MachinesFactory'];
  /* ng-inject */
  function controller(MessageService, $log, locals, ChangeDelta, MachinesFactory) {

    var vm = this;

    vm.currentMachine = locals;
    vm.machineCopy = angular.copy(locals);
    vm.changeDelta = ChangeDelta;

    vm.updateChangeDelta = function (prop1, prop2) {
      let newVal = vm.currentMachine[prop1],
        oldval = vm.machineCopy[prop1],
        prop = prop1;

      if (prop2) {
        newVal = vm.currentMachine[prop1][prop2];
        oldval = vm.machineCopy[prop1][prop2];
        prop = prop1 + '.' + prop2;
      }
      ChangeDelta.recordValueChange({
        oldval: oldval,
        newval: newVal,
        collection: 'machines',
        objectid: locals._machineid,
        databasefieldname: prop
      });
    };

    vm.saveAndCloseDialog = function () {
      MachinesFactory.saveMachine(vm.currentMachine)
        .then(function () {
          MessageService.closeDialog('saved');
          ChangeDelta.clear();
        })
        .catch(function (err) {
          vm.error = err;
        });

    };

    vm.cancelDialog = function () {
      ChangeDelta.clear();
      MessageService.cancelDialog();
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpManageMappingDialog', {
      templateUrl: 'app/integration/dialogs/zp-manage-field-mapping-dialog/tmpl.html',
      controller: 'ManageFieldMappingDialogCtrl',
      bindings: {}
    })
    .controller('ManageFieldMappingDialogCtrl', controller);

  controller.$inject = ['MessageService', 'locals', 'MachineMappingsViewModel', '$timeout', 'FormMetadataFactory'];
  /* ng-inject */
  function controller(MessageService, locals, MachineMappingsViewModel, $timeout, FormMetadataFactory) {

    var vm = this;

    vm.answerDelimiters = [
      { label: 'comma - \',\'', value: ',' }, 
      { label: 'semicolon - \';\'', value: ';' }
    ];
    vm.selectedItem;

    vm.$onInit = function () {
      vm.mapping = locals;

      const mdata = FormMetadataFactory.getData();
      const widgetKey = collectionAsSingular(vm.mapping.hps.collection) + '_' + vm.mapping.hps.element;
      if (!mdata.columnsData.itemsObject[widgetKey]) {
        mdata.columnsData.itemsObject[widgetKey] = {
          databasefieldname: vm.mapping.hps.element,
          object: vm.mapping.hps.collection
        };
      }
      const widget = mdata.columnsData.itemsObject[widgetKey];
      if (widget.answers || widget.requiresCustomList) vm.showInputControls = true;
      vm.oldValInput = 'freeForm';
      // if (!vm.mapping.transform.special && !_.isEmpty(vm.mapping.transform)) {
      // vm.mapping.transform.special = 'transformValues';
      // }
      resetNewTransformField();
      buildConfigForAnswerWidget();
    };


    function buildConfigForAnswerWidget() {
      vm.answerListConfig = {};
      vm.answerListConfig.formId = MachineMappingsViewModel.factoryData.currentMachine.sourceZuantFormId;
      vm.answerListConfig.widgetId = {
        collection: collectionAsSingular(locals.hps.collection),
        element: locals.hps.element
      };
    }

    function collectionAsSingular(collection) {
      if (collection === 'companies') return 'company';
      if (collection === 'contacts') return 'contact';
      if (collection === 'responses') return 'response';
    }

    vm.addNewTransform = function () {
      if (_.isUndefined(vm.mapping.transform.valuetranslations)) {
        vm.mapping.transform.valuetranslations = [];
      }
      if (!vm.newTransform.old || !vm.newTransform.new) return MessageService.showMessage('Transform isn\'t valid');
      vm.mapping.transform.valuetranslations.unshift(vm.newTransform);
      resetNewTransformField();
      $timeout(function () {
        document.getElementById('focusMe')
          .focus();
      }, 100);
    };

    function resetNewTransformField() {
      vm.newTransform = {
        old: '',
        new: ''
      };
      vm.selectedItem = [];
    }

    vm.freeFormClicked = function () {
      vm.oldValInput = 'freeForm';
    };

    vm.answerListClicked = function () {
      vm.oldValInput = 'answerList';
    };

    vm.answerChange = function (item) {
      vm.newTransform.old = item;
    };

    vm.deleteTransform = function (index) {
      vm.mapping.transform.valuetranslations.splice(index, 1);
    };

    vm.closeDialog = function () {
      if (!vm.mapping.transform.delimiter) delete vm.mapping.transform.delimiter;
      MessageService.closeDialog(vm.mapping);
    };

    vm.cancelDialog = function () {
      if (!vm.mapping.transform.delimiter) delete vm.mapping.transform.delimiter;
      MessageService.cancelDialog(vm.mapping);
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpMachineJSONDialog', {
      templateUrl: 'app/integration/dialogs/zp-machine-json-dialog/tmpl.html',
      controller: 'MachineJSONDialogCtrl',
      bindings: {
        locals: '<'
      }
    })
    .controller('MachineJSONDialogCtrl', controller);

  controller.$inject = ['MessageService', 'MachineMappingsViewModel'];
  /* ng-inject */
  function controller(MessageService, MachineMappingsViewModel) {

    var vm = this;

    vm.$onInit = function () {
      vm.currentMachine = _.omit(MachineMappingsViewModel.factoryData.currentMachine, 'sourceZuantFormname');
    };

    vm.closeDialog = function () {
      MessageService.closeDialog();
    };

    vm.cancelDialog = function () {
      MessageService.cancelDialog();
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpMachineInfoDialog', {
      templateUrl: 'app/integration/dialogs/zp-machine-info-dialog/tmpl.html',
      controller: 'MachineSettingsDialogCtrl',
      bindings: {
        locals: '<'
      }
    })
    .controller('MachineSettingsDialogCtrl', controller);

  controller.$inject = ['MessageService', 'MachineMappingsViewModel'];
  /* ng-inject */
  function controller(MessageService, MachineMappingsViewModel) {

    var vm = this;

    vm.$onInit = function () {
      vm.currentMachine = MachineMappingsViewModel.factoryData.currentMachine;
      vm.sourceFormConfig = MachineMappingsViewModel.sourceFormConfig;
      vm.eloquaActions = [{
        name: '💤 REST',
        value: 'replicateViaREST'
      }, {
        name: '🧼 SOAP',
        value: 'replicate'
      }];
    };

    vm.grabSourceForm = function (item) {
      MachineMappingsViewModel.grabSourceFormFields(item);
    };

    vm.closeDialog = function () {
      MessageService.closeDialog({
        name: vm.currentMachine.name,
        sourceZuantFormId: vm.currentMachine.sourceZuantFormId,
        machineInfo: vm.currentMachine.machineInfo,
        actuator: vm.currentMachine.actuator,
        useWildcardMapping: vm.currentMachine.useWildcardMapping,
        filters: vm.currentMachine.sensor.filters
      });
    };

    vm.cancelDialog = function () {
      MessageService.cancelDialog();
    };

    vm.onFilterChange = function (filters) {
      vm.currentMachine.sensor.filters = [{
        formids: filters.filters
      }];
    };

  }
}());

(function () {

  'use strict';

  angular
    .module('integration')
    .component('zpMachineFormFiltersDialog', {
      templateUrl: 'app/integration/dialogs/zp-machine-form-filters-dialog/tmpl.html',
      controller: 'MachineFormFiltersDialogCtrl'
    })
    .controller('MachineFormFiltersDialogCtrl', controller);

  controller.$inject = ['MessageService', 'MachineMappingsViewModel', 'MachinesFactory', 'locals'];
  /* ng-inject */
  function controller(MessageService, MachineMappingsViewModel, MachinesFactory, locals) {

    var vm = this;

    vm.$onInit = function () {
      vm.selectedMachine = locals;
      vm.dirty = false;
      vm.clearedFlag = false;
    };

    vm.closeDialog = function () {
      if (!vm.clearedFlag && vm.dirty) MessageService.showMessage('Form filters updated');
      MessageService.closeDialog();
    };

    vm.onFilterChange = function () {
      vm.dirty = true;
      vm.clearedFlag = false;
      const machineToSave = angular.copy(vm.selectedMachine);
      MachinesFactory.saveMachine(machineToSave);
    };

    vm.onClearFilters = function () {
      vm.clearedFlag = true;
      vm.dirty = true;
      vm.selectedMachine.sensor.filters[0].formids.length = 0;
      const machineToSave = angular.copy(vm.selectedMachine);
      machineToSave.sensor.filters = [];
      MachinesFactory.saveMachine(machineToSave, 'Form filters cleared');
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('ManageConnectionsService', factory);

  factory.$inject = ['GlobalAccessFactory', 'ConnectionStatusService'];
  /* ng-inject */
  function factory(GlobalAccessFactory, ConnectionStatusService) {

    return {
      getLoginCredentials: GlobalAccessFactory.getLoginCredentials,
      getConnectionStatusMessage: ConnectionStatusService.getConnectionStatusMessage,
      getConnectionErrorMessage: ConnectionStatusService.getConnectionErrorMessage,
      saveAndTestConnection: saveAndTestConnection,
      deleteLogin: deleteLogin
    };

    function saveAndTestConnection(platform) {
      const connectionConfig = buildConnectionConfig(platform);
      return ConnectionStatusService.testConnection(connectionConfig)
        .then(function (res) {

          return GlobalAccessFactory.saveConnection(platform)
            .then(function () {
              return res;
            })
            .catch(function (err) {
              throw err;
            });
        
        })
        .then(function (res) {
          GlobalAccessFactory.updatePlatformConnectedValue(platform);
          ConnectionStatusService.updatePropsBoundToViewModel();
          return res;
        })
        .catch(function (err) {
          throw err;
        });
    }

    function buildConnectionConfig(platform) {
      const config = { platform: platform.toLowerCase() };
      if (platform === 'Eloqua') {
        // we test these creds in zuant_back_end. SFDC creds are tested in shuttle api
        config.creds = GlobalAccessFactory.getLoginCredentials(platform);
      }
      return config;
    }

    function deleteLogin(platform) {
      return GlobalAccessFactory.deleteLogin(platform)
        .then(function () {
          return ConnectionStatusService.updatePropsBoundToViewModel();
        })
        .catch(function (err) {
          throw err;
        });
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpAddMachineDialog', {
      templateUrl: 'app/integration/dialogs/zp-add-machine-dialog/tmpl.html',
      controller: 'AddMachineDialogController',
      bindings: {
        locals: '<'
      }
    })
    .controller('AddMachineDialogController', controller);

  controller.$inject = ['MessageService', 'MachinesFactory', 'GlobalAccessFactory', '$state', '$timeout'];
  /* ng-inject */
  function controller(MessageService, MachinesFactory, GlobalAccessFactory, $state, $timeout) {

    var vm = this;

    function init() {
      vm.loading = true;
      vm.newMachinForm = {};
      vm.seed = 'new';
      vm.newMachine = MachinesFactory.newMachineShell();
      vm.integrationPlatforms = _.filter(GlobalAccessFactory.getListOfAvailableIntegrations(), function (platform) {
        return platform.hasMachines && platform.configured;
      });
      vm.machineToClone = {};

      vm.availableMachines = MachinesFactory.factoryData.rawMachinesData;

      vm.sourceZuantFormConfig = {
        placeholder: 'Source Zuant form',
        floatingLabel: 'Source Zuant form',
        title: 'sourceZuantFormId',
        required: true
      };

      vm.eloquaFormsConfig = {
        required: true,
        placeholder: 'Choose an Eloqua form',
        floatingLabel: 'Choose an Eloqua form',
        title: 'eloquaFormConfig'
      };

      $timeout(function () {
        vm.loading = false;
      }, 500);
    }

    init();

    vm.closeDialog = function () {
      MessageService.closeDialog();
    };

    vm.cancelDialog = function () {
      MessageService.cancelDialog();
    };

    vm.setSourceZuantForm = function (itm) {
      if (!itm.item) return;
      vm.newMachine.sourceZuantFormId = itm.item._id;
    };

    vm.eloquaFormSelectChange = function (itm) {
      vm.newMachine.actuator.typeid = itm.id;
      vm.newMachine.actuator.typename = itm.name;
    };

    vm.submitForm = function () {
      if (vm.newMachine.actuator.system === 'Eloqua') vm.newMachine.actuator.action = 'replicateViaREST';
      MachinesFactory.saveMachine(vm.newMachine)
        .then(function () {
          $state.go('app.custom_toolbar_app_framework.mappings-view', {
            _machineid: vm.newMachine._machineid
          });
          MessageService.pushEventToIntercom('integration_machine_created');
          MessageService.closeDialog();
        })
        .catch(function () {
          //console.error(err);
        });
    };

    vm.cloneMachine = function () {
      const clone = vm.availableMachines.find(m => m._machineid == vm.machineToClone);
      if (clone) {
        vm.newMachine.actuator = clone.actuator;
        vm.newMachine.machineInfo = clone.machineInfo;
        vm.newMachine.sensor = clone.sensor;
        vm.newMachine.mappings = clone.mappings;
        vm.newMachine.sourceZuantFormId = clone.sourceZuantFormId;
        vm.newMachine.useWildcardMapping = clone.useWildcardMapping;
        vm.newMachine.machinetype = clone.machinetype;
        MachinesFactory.saveMachine(vm.newMachine)
          .then(function () {
            $state.go('app.custom_toolbar_app_framework.mappings-view', {
              _machineid: vm.newMachine._machineid
            });
            MessageService.pushEventToIntercom('integration_machine_created');
            MessageService.closeDialog();
          })
          .catch(function () {
            //console.error(err);
          });
      }
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .controller('ManageLoginsDialogCtrl', controller);

  controller.$inject = ['MessageService', 'ManageConnectionsService', 'locals'];
  /* ng-inject */
  function controller(MessageService, ManageConnectionsService, locals) {

    var vm = this;
    vm.saveBtnText = 'Save & Test Connection';
    vm.testConnectionSuccess = false;
    vm.disabledSaveBtn = false;

    vm.$onInit = function () {
      vm.platform = locals.platform;
      vm.toolbarTitle = 'Manage connection to ' + vm.platform.name;
      vm.loginCredentials = ManageConnectionsService.getLoginCredentials(vm.platform.value);
      vm.connectionStatusMessage = ManageConnectionsService.getConnectionStatusMessage(vm.platform);
      vm.connectionErrorMessage = ManageConnectionsService.getConnectionErrorMessage(vm.platform);
    };

    vm.cancelDialog = function () {
      MessageService.cancelDialog();
    };

    vm.deleteLogin = function (ev) {
      return MessageService.confirm(ev)
        .delete()
        .then(function () {
          return ManageConnectionsService.deleteLogin(vm.platform);
        })
        .catch(function (err) {
          MessageService.showMessage(err);
        });
    };

    vm.saveAndTestConnection = function () {
      vm.disabledSaveBtn = true;
      vm.saveBtnText = 'Please Wait';
      ManageConnectionsService.saveAndTestConnection(vm.platform.value)
        .then(updateViewWithConnectionResult)
        .catch(updateViewForError);
    };

    function updateViewWithConnectionResult(res) {
      vm.disabledSaveBtn = false;
      if (res.nutshell === 'no') {
        vm.connectionStatusMessage = 'Not Authenticated';
        vm.connectionErrorMessage = res.errorMessage;
      } else if (res.nutshell === 'not auth') {
        vm.connectionStatusMessage = 'Not Authenticated';
        vm.connectionErrorMessage = res.errorMessage;
      } else {
        vm.testConnectionSuccess = true;
        vm.connectionStatusMessage = 'Connected';
        vm.connectionErrorMessage = '';
      }
      vm.saveBtnText = 'Save & Test Connection';
      MessageService.writeLog({
        level: 'info',
        msg: res,
        tags: ['save_3rd_party_connection', 'integration']
      });
    }

    function updateViewForError(err) {
      vm.saveBtnText = 'Save & Test Connection';
      vm.disabledSaveBtn = false;
      vm.testConnectionSuccess = false;
      vm.connectionStatusMessage = 'Connection Failed';
      vm.connectionErrorMessage = err;
      MessageService.writeLog({
        level: 'error',
        msg: JSON.stringify(err),
        tags: ['save_3rd_party_connection', 'integration']
      });
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .service('ConnectionStatusService', ConnectionStatusService);

  ConnectionStatusService.$inject = ['MessageService', 'DotNetShuttleService', 'DotNetCommands', 'GlobalAccessFactory', 'EloquaConnectionService'];

  function ConnectionStatusService(MessageService, DotNetShuttleService, DotNetCommands, GlobalAccessFactory, EloquaConnectionService) {

    const defaultPlatformState = () => ({
      validConnection: false,
      testingConnection: true,
      connectionStatusMessage: 'connecting...',
      timestamp: ''
    });

    const factoryData = {
      eloqua: defaultPlatformState(),
      sfdc: defaultPlatformState(),
      configuredConnections: [],
      menuOptions: []
    };

    return {
      hydrateFactory,
      testConnection,
      setConnectionStatus,
      testConnectionIfNecessary,
      showDialog,
      factoryData,
      updatePropsBoundToViewModel,
      getData,
      getConnectionStatusMessage,
      getConnectionErrorMessage
    };

    function hydrateFactory() {
      factoryData.eloqua = defaultPlatformState();
      factoryData.sfdc = defaultPlatformState();
      factoryData.configuredConnections = [];
      factoryData.menuOptions = [];
      updateMenuOptions();
    }

    function testConnection({ platform, creds }) {
      const key = platform.toLowerCase();
      Object.assign(factoryData[key], {
        testingConnection: true,
        connectionStatusMessage: 'connecting...',
        timestamp: new Date()
      });
      delete factoryData[key].connectionErrorMessage;

      MessageService.writeLog({
        level: 'info',
        msg: `🚀 Testing connection to ${platform}`,
        tags: ['integration']
      });

      if (platform === 'sfdc') {
        return DotNetShuttleService.launchShuttle({
          command: DotNetCommands.shuttleCommands.visitEmbassy,
          enquiry: 'getmeta',
          system: platform
        })
          .then(response => {
            setConnectionStatus(platform, response);
            return response;
          })
          .catch(err => { throw err; });

      } else if (platform === 'eloqua') {
        return EloquaConnectionService.testConnection(creds)
          .then(response => {
            setConnectionStatus(platform, response);
            GlobalAccessFactory.updateEloquaBaseUrl(response.baseUrl);
            
            return response;
          })
          .catch(err => {
            setConnectionStatus(platform, {
              nutshell: 'no',
              errorMessage: err
            });
            throw err;
          });
      }
    }

    function setConnectionStatus(platformName, response) {
      const key = platformName.toLowerCase();
      const platformData = factoryData[key];
      platformData.testingConnection = false;

      const timestamp = new Date();
      platformData.timestamp = timestamp;

      if (response === 'unauthorized') {
        MessageService.writeLog({
          level: 'error',
          msg: 'not authorised by .NET service',
          tags: ['integration', '.NET_connection_test']
        });
        return;
      }

      if (response.xhrStatus === 'error') {
        MessageService.writeLog({
          level: 'error',
          msg: JSON.stringify(response),
          tags: ['integration', 'shuttle_error']
        });
        MessageService.showMessage('Error connecting to Integration Service');
        return;
      }

      const logConnectionResult = (level, msg) => {
        MessageService.writeLog({
          level,
          msg,
          tags: ['integration', platformName.toLowerCase()]
        });
      };

      const setFailure = () => {
        platformData.validConnection = false;
        platformData.connectionStatusMessage = 'Not Authenticated';
        platformData.connectionErrorMessage = response.errorMessage;
        GlobalAccessFactory.setConnectionResult(key, { status: 'failure', timestamp });
        logConnectionResult('error', `message: ${response.message}, errorMessage: ${response.errorMessage}`);
      };

      const setSuccess = () => {
        platformData.validConnection = true;
        platformData.connectionStatusMessage = response.message || 'Connected';
        delete platformData.connectionErrorMessage;
        GlobalAccessFactory.setConnectionResult(key, { status: 'success', timestamp });
        GlobalAccessFactory.saveSuccessfulConnectionTimestamp(key);
        logConnectionResult('info', `successfully connected to ${key}`);
      };

      if (response.status === 'ok') {
        platformData.validConnection = true;
        platformData.connectionStatusMessage = 'Connected';
        delete platformData.connectionErrorMessage;
        logConnectionResult('info', `connected to ${key} API successfully`);
        return;
      }

      if (response.nutshell === 'no' || response.nutshell === 'not auth') {
        setFailure();
      } else if (response.nutshell === 'yes') {
        setSuccess();
      }
    }

    function testConnectionIfNecessary(platformName) {
      const key = platformName.toLowerCase();
      if (workOutUpdateRequired(platformName)) {
        const creds = key === 'eloqua' ? GlobalAccessFactory.getLoginCredentials('Eloqua') : undefined;
        return testConnection({ platform: platformName, creds });
      }

      factoryData[key].testingConnection = false;
      factoryData[key].validConnection = true;
      factoryData[key].connectionStatusMessage = 'Connection Test Not Required';

      MessageService.writeLog({
        level: 'info',
        msg: `connection test to ${platformName} is not required at this time`,
        tags: ['integration', 'connection_test']
      });

      return Promise.resolve('connection test not required at this time');
    }

    function workOutUpdateRequired(platformName) {
      const timeout = 1000 * 60 * 2; // 2 minutes
      const now = new Date();
      const expiry = new Date(now - timeout);

      const globalData = GlobalAccessFactory.factoryData.globalAccessObjects;
      const lastSuccessKey = platformName === 'eloqua'
        ? globalData.eloquaGlobalAccess._lastSuccessfulConnection
        : globalData.sfdcglobalaccess._lastSuccessfulConnection;

      if (!lastSuccessKey || new Date(lastSuccessKey) < expiry) {
        MessageService.writeLog({
          level: 'info',
          msg: `_lastSuccessfulConnection to ${platformName} was ${lastSuccessKey}, test required`,
          tags: ['integration', 'connection_test']
        });
        return true;
      }

      return false;
    }

    function showDialog(args) {
      const platform = _.find(GlobalAccessFactory.getListOfAvailableIntegrations(), sys =>
        sys.value.toLowerCase() === args.action
      );

      MessageService.showDialog(args.ev, {
        templateUrl: 'app/integration/dialogs/manage-logins-dialog/tmpl.html',
        controller: 'ManageLoginsDialogCtrl as $ctrl',
        locals: { platform }
      }).catch(() => {});
    }

    function getData() {
      return factoryData;
    }

    function getConnectionStatusMessage(platform) {
      return factoryData[platform.value.toLowerCase()].connectionStatusMessage;
    }

    function getConnectionErrorMessage(platform) {
      return factoryData[platform.value.toLowerCase()].connectionErrorMessage;
    }

    function updatePropsBoundToViewModel() {
      try {
        factoryData.configuredConnections = GlobalAccessFactory.getListOfConfiguredIntegrations();
        return factoryData;
      } catch (e) {
        return Promise.reject(e);
      }
    }

    function updateMenuOptions() {
      return new Promise((resolve, reject) => {
        try {
          factoryData.menuOptions = GlobalAccessFactory.getListOfAvailableIntegrations()
            .filter(sys => sys.value !== 'HttpPost' && sys.value !== 'shuttle')
            .map(sys => ({
              onClick: sys.value.toLowerCase(),
              ariaLabel: () => `Manage ${sys.value.toLowerCase()}`,
              icon: () => 'zmdi zmdi-settings',
              label: () => `Manage ${sys.value}`
            }));

          resolve();
        } catch (e) {
          reject(e);
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpConnectionStatus', {
      templateUrl: 'app/integration/connections/zp-connection-status-widget/tmpl.html',
      controller: 'ConnectionStatusWidgetController',
      bindings: {}
    })
    .controller('ConnectionStatusWidgetController', controller);

  controller.$inject = ['ConnectionStatusService'];
  /* ng-inject */
  function controller(ConnectionStatusService) {

    var vm = this;

    vm.$onInit = function () {
      vm.factoryData = ConnectionStatusService.getData();
    };

    vm.onMenuClick = function (args) {
      ConnectionStatusService.showDialog(args);
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .service('DotNetShuttleService', DotNetShuttleService);

  DotNetShuttleService.$inject = ['$http', 'DOT_NET_API_CONFIG', 'SessionService', 'MessageService'];

  function DotNetShuttleService($http, DOT_NET_API_CONFIG, SessionService, MessageService) {
    const baseUrl = DOT_NET_API_CONFIG.url;

    return {
      authenticateViaJwt,
      launchShuttle
    };

    function authenticateViaJwt() {
      const token = SessionService.getToken();

      return $http.post(`${baseUrl}/ask/AuthenticateViaJWT`, { token })
        .then(handleJwtSuccess)
        .catch(handleError);
    }

    function handleJwtSuccess(response) {
      if (response.data.status === 'ok') {
        response.data.shuttleAuthentication = true;
        log('info', 'User is authenticateViaJwt');
        return handleSuccess(response);
      } else {
        log('error', 'User is NOT authenticateViaJwt');
        throw { shuttleAuthentication: false };
      }
    }

    function launchShuttle(shuttle) {
      shuttle.clientId = SessionService.getUserData().clientId;

      const dataToSend = {
        jsonPost: angular.toJson(shuttle)
      };

      log('info', `🚀 launching .NET shuttle: ${JSON.stringify(shuttle)}`);

      return $http.post(`${baseUrl}/Ask/Execute`, dataToSend)
        .then(handleSuccess)
        .catch(handleError);
    }

    function handleSuccess(response) {
      log('info', 'shuttle success');
      return response.data;
    }

    function handleError(error) {
      log('error', 'shuttle error: ' + JSON.stringify(error));
      throw error;
    }

    function log(level, msg) {
      MessageService.writeLog({
        level,
        msg,
        tags: ['integration', 'dot_net_shuttle']
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('DotNetCommands', factory);
  /* ng-inject */
  function factory() {

    return {
      shuttleCommands: {
        saveThirdPartyLoginCredentials: 'saveThirdPartyLoginCredentials',
        deleteThirdPartyLoginCredentials: 'deleteThirdPartyLoginCredentials',
        saveMachine: 'saveMachine',
        getExistingMachinesDocument: 'getExistingMachinesDocument',
        toggleArchiveMachine: 'toggleArchiveMachine',
        visitEmbassy: 'visitEmbassy',
        getThirdPartyObject: 'getThirdPartyObject',
        leadRelease: 'leadRelease'
      },
      integrationActions: {
        releaseLeads: 'release',
        lockLeads: 'lock',
        resetLeads: 'reset',
        unlockLeads: 'unlock'
      }
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpSaveSettingsFab', {
      templateUrl: 'app/forms/settings-page/fab/fab.tmpl.html',
      controller: 'zpSaveFormSettingsFabCtrl'
    })
    .controller('zpSaveFormSettingsFabCtrl', ctrl);

  ctrl.$inject = ['$scope', 'ChangeDelta', 'SingleFormFactory'];
  /* ng-inject */
  function ctrl($scope, ChangeDelta, SingleFormFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.singleFormFactory = SingleFormFactory.factoryData;
    };

    vm.changeDelta = ChangeDelta;

    vm.onSave = function () {
      $scope.$emit('zp.message', {
        level: 'broadcast',
        page: 'foo',
        eventName: 'zpSaveFormSettings'
      });
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('EZMenuItems', EZMenuItems);

  EZMenuItems.$inject = ['MasterPermissionsDefinitionFactory'];
  /* ng-inject */
  function EZMenuItems(MasterPermissionsDefinitionFactory) {

    return [{
      name: 'New Contact',
      action: 'newContactButtonTapped',
      icon: 'zmdi-account-add',
      inMenu: false
    },{
      name: 'Submit',
      action: 'submitButtonTapped',
      icon: 'zmdi-check',
      inMenu: false
    }, {
      name: 'Email',
      action: 'messageComposerButtonTapped',
      icon: 'zmdi-mail-send',
      inMenu: false,
      permissions: MasterPermissionsDefinitionFactory.boltOns.emails.thankYouEmails.enabled,
      isBoltOn: true
    }, {
      name: 'Notes',
      action: 'notesButtonTapped',
      icon: 'zmdi-edit',
      inMenu: false
    }, {
      name: 'Showroom',
      action: 'showroomButtonTapped',
      icon: 'zmdi-image-o',
      inMenu: false,
      permissions: MasterPermissionsDefinitionFactory.boltOns.showroom.enabled,
      isBoltOn: true
    }, {
      name: 'Park Lead',
      action: 'parkLeadButtonTapped',
      icon: 'zmdi-parking',
      inMenu: false
    }, {
      name: 'Capture Image',
      action: 'photoButtonTapped',
      icon: 'zmdi-camera',
      inMenu: false
    }, {
      name: 'Scan Card',
      action: 'scanBusinessCardWithOCRButtonTapped',
      icon: 'zmdi-account-box-mail',
      inMenu: false,
      permissions: MasterPermissionsDefinitionFactory.boltOns.ocr.enabled,
      isBoltOn: true
    }, {
      name: 'Scan Badge',
      action: 'scanButtonTapped',
      icon: 'zmdi-nfc',
      inMenu: false
    }, {
      name: 'Pick A Winner',
      action: 'pickAWinnerButtonTapped',
      icon: 'zmdi-ticket-star',
      inMenu: false,
      permissions: MasterPermissionsDefinitionFactory.liteFeatures.pickAWinner.enabled
    }, {
      name: 'Consent',
      action: 'consentButtonTapped',
      icon: 'zmdi-shield-check',
      inMenu: false
    }, {
      name: 'Privacy',
      action: 'privacyStatementButtonTapped',
      icon: 'zmdi-lock-outline',
      inMenu: false
    }];
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpWidgetCategoryHeader', {
      templateUrl: 'app/forms/reporting/widget-category-header-component/zp-widget-category-header.tmpl.html',
      controller: 'zpWidgetCategoryHeaderCtrl',
      bindings: {
        title: '<',
        icon: '<',
        onClick: '&'
      }
    })
    .controller('zpWidgetCategoryHeaderCtrl', controller);

  controller.$inject = [];
  /* ng-inject */
  function controller() {
    var vm = this;

    vm.$onInit = function () {
      // vm.icon = 'add';
      vm.metadata = {
        // icon: 'add',
        iconColor: '#949ca1',
        tooltip: 'Add all items to report'
      };
    };


    vm.toggleAllWidgets = function () {
      vm.onClick();
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpTopPerformerWidget', {
      templateUrl: 'app/forms/reporting/top-performer-component/zp-top-performer.tmpl.html',
      controller: 'zpTopPerformerCtrl',
      bindings: {
        widgetData: '<'
      }
    })
    .controller('zpTopPerformerCtrl', topPerformerCtrl);

  topPerformerCtrl.$inject = ['ResponseAggregationModel'];
  /* ng-inject */
  function topPerformerCtrl(ResponseAggregationModel) {

    var vm = this;

    vm.$onInit = function () {
      ResponseAggregationModel.bindWidgetToFactory(vm.widgetData);
      // ResponseAggregationModel.hydrateWidgetData(vm.widgetData);
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('TimeReportsMetadataFactory', TimeReportsMetadata);

  TimeReportsMetadata.$inject = [];
  /* ng-inject */
  function TimeReportsMetadata() {

    var factoryData = {
      category: 'timeWidgets',
      items: [],
      itemsObject: {}
    };

    buildFactory();

    return {
      getData: getData,
      resetFactory: buildFactory
    };

    function getData() {
      return factoryData;
    }

    function buildFactory() {

      factoryData.items.length = 0; // set length to zero so as to not break any references to these here widgets!

      /***
       * LEADS TOP PERFORMER CHART BORN
       */

      factoryData.items.push({
        id: 'leadsTopPerformer',
        title: 'Leads Top Performer',
        subtitle: 'High five',
        metadata: {
          category: 'timeWidgets',
          icon: 'star',
          object: 'response',
          databasefieldname: '_initialuser'
        },
        hiddenCount: 0,
        query: {
          metrics: [{
            groupBy: 'user',
            limit: 1,
            countUpToProperty: true,
            // setWidgetProperty: true,
            // propertyToSet: 'name',
            sortBy: 'count',
            sortDirection: 'desc'
          }]
        },
        chart: {
          data: [],
          labels: [],
          legend: {}
        },
        header: {
          label: 'User',
          countAlias: 'Count'
        },
        hidePercentageAnsweredChart: true,
        inReport: true
      });

      /***
       * USER LEADS PERFORMANCE TABLE BORN
       */
      factoryData.items.push({
        id: 'leadsTeamPerformance',
        title: 'Team Performance',
        subtitle: 'All users',
        metadata: {
          category: 'timeWidgets',
          icon: 'group',
          tooltip: 'Add chart to report',
          object: 'response',
          databasefieldname: '_initialuser'
        },
        query: {
          metrics: [{
            groupBy: 'user',
            sortBy: 'count',
            sortDirection: 'desc',
            limit: null
          }]
        },
        chart: {
          type: 'bar',
          data: [],
          labels: [],
          options: {
            legend: {
              display: false
            }
          }
        },
        tableData: [],
        header: {
          label: 'User',
          countAlias: 'Count'
        },
        limitTableSize: false,
        hidePercentageAnsweredChart: true,
        inReport: true
      });

      /***
       * LEADS PER DAY CHART BORN
       */

      factoryData.items.push({
        id: 'leadsByDay',
        title: 'Leads per day',
        subtitle: 'All Users',
        metadata: {
          category: 'timeWidgets',
          icon: 'today',
          object: 'response',
          databasefieldname: '_initialcreatedateadjusted'
        },
        query: {
          metrics: [{
            groupBy: '_initialcreatedate',
            sortBy: 'groupedObjectKey'
          }]
        },
        chart: {
          type: 'bar',
          labels: [],
          data: [],
          series: [],
          options: {
            legend: {
              display: true
            },
            availableChartTypes: [{
              chart: 'bar',
              icon: 'insert_chart'
            }, {
              chart: 'line',
              icon: 'show_chart'
            }]
          }
        },
        tableData: [],
        header: {
          label: 'Day'
        },
        limitTableSize: false,
        hidePercentageAnsweredChart: true,
        inReport: true
      });

      /***
       * LEADS BY DAY BY USER CHART BORN
       */

      factoryData.items.push({
        id: 'leadsByDayByUser',
        title: 'User daily performance',
        subtitle: 'User Breakout',
        metadata: {
          category: 'timeWidgets',
          icon: 'perm_contact_calendar',
          object: 'response',
          databasefieldname: '_initialcreatedateadjusted'
        },
        query: {
          metrics: [{
            groupBy: 'mmddyy_user',
            sortBy: 'groupedObjectKey',
            limit: 10
          }]
        },
        chart: {
          type: 'bar',
          labels: [],
          data: [],
          series: [],
          options: {
            legend: {
              display: true
            },
            availableChartTypes: [{
              chart: 'bar',
              icon: 'insert_chart'
            }, {
              chart: 'line',
              icon: 'show_chart'
            }]
          }
        },
        tableData: [],
        header: {
          label: 'Day & User'
        },
        limitTableSize: false,
        hidePercentageAnsweredChart: true,
        inReport: true
      });

      /***
       * LEADS BY HOUR CHART BORN
       */
      factoryData.items.push({
        id: 'leadsByHour',
        title: 'Lead captured detail',
        subtitle: 'By hour',
        metadata: {
          category: 'timeWidgets',
          icon: 'access_time',
          object: 'response',
          databasefieldname: '_initialcreatedateadjusted'
        },
        query: {
          metrics: [{
            groupBy: 'mmddyyhh',
            rangeFill: {
              min: 8, // hour of day to start from (think chart x axis start)
              max: 19
            },
            sortBy: 'groupedObjectKey'
          }]
        },
        chart: {
          type: 'line',
          labels: [],
          data: [],
          series: [],
          options: {
            legend: {
              display: true
            },
            availableChartTypes: [{
              chart: 'bar',
              icon: 'insert_chart'
            }, {
              chart: 'line',
              icon: 'show_chart'
            }]
          }
        },
        tableData: [],
        header: {
          label: 'Day & Hour'
        },
        limitTableSize: 0,
        hidePercentageAnsweredChart: true,
        inReport: true
      });

      _.map(factoryData.items, function (o) {
        return factoryData.itemsObject[o.id] = o;
      });
    }
  }
}());

(function () {
  'use strict';
  
  angular
    .module('forms')
    .factory('RevenueReportsMetadataFactory', RevenueReportsMetadataFactory);
  
  RevenueReportsMetadataFactory.$inject = ['FormMetadataFactory', 'CurrencyHelperService'];
  /* ng-inject */
  function RevenueReportsMetadataFactory(FormMetadataFactory, CurrencyHelperService) {
  
    var factoryData = {
      category: 'revenueWidgets',
      items: [],
      itemsObject: {}
    };
  
    buildFactory();
  
    return {
      getData: getData,
      resetFactory: buildFactory
    };
  
    function getData() {
      return factoryData;
    }
  
    function buildFactory() {
      var formMetadata = FormMetadataFactory.getData();
      var currencyCode = 'USD'; //set default to US Dollar
  
      if (formMetadata.formProperties && formMetadata.formProperties.currencyCode){
        currencyCode = formMetadata.formProperties.currencyCode;
      }
  
      factoryData.items.length = 0; // set length to zero so as to not break any references to these here widgets!

  
      //if (formMetadata.estimatedRevenueEnabledForForm){
  
      /***
         * REVENUE TOP PERFORMER CHART BORN
        */
  
      factoryData.items.push({
        id: 'revenueTopPerformer',
        title: 'Revenue Top Performer',
        subtitle: 'High five',
        metadata: {
          category: 'timeWidgets',
          icon: 'star',
          object: 'response',
          databasefieldname: 'estimatedRevenue'
        },
        hiddenCount: 0,
        query: {
          metrics: [{
            groupBy: 'user',
            limit: 1,
            countUpToProperty: true,
            sortBy: 'count',
            sortDirection: 'desc'
          }]
        },
        chart: {
          data: [],
          labels: [],
          legend: {}
        },
        header: {
          label: 'User',
          countAlias: 'Revenue'
        },
        hidePercentageAnsweredChart: true,
        inReport: true
      });
  
      /***
         * USER PERFORMANCE BY REVENUE TABLE BORN
         */
      factoryData.items.push({
        id: 'revenueTeamPerformance',
        title: 'Team Revenue Performance',
        subtitle: 'All users',
        metadata: {
          category: 'timeWidgets',
          icon: 'group',
          tooltip: 'Add chart to report',
          object: 'response',
          databasefieldname: 'estimatedRevenue'
        },
        query: {
          metrics: [{
            groupBy: 'user',
            sortBy: 'count',
            sortDirection: 'desc',
            limit: null
          }]
        },
        chart: {
          type: 'bar',
          data: [],
          labels: [],
          options: {
            legend: {
              display: false
            }
          }
        },
        tableData: [],
        header: {
          label: 'User',
          countAlias: 'Revenue'
        },
        limitTableSize: false,
        hidePercentageAnsweredChart: true,
        inReport: true
      });
  
      /***
         * REVENUE PER DAY CHART BORN
         */
  
      factoryData.items.push({
        id: 'revenueByDay',
        title: 'Revenue per day',
        subtitle: 'All Users',
        metadata: {
          category: 'timeWidgets',
          icon: 'today',
          object: 'response',
          databasefieldname: 'estimatedRevenue'
        },
        query: {
          metrics: [{
            groupBy: '_initialcreatedate',
            sortBy: 'groupedObjectKey'
          }]
        },
        chart: {
          type: 'bar',
          labels: [],
          data: [],
          series: [],
          options: {
            legend: {
              display: true
            },
            availableChartTypes: [{
              chart: 'bar',
              icon: 'insert_chart'
            }, {
              chart: 'line',
              icon: 'show_chart'
            }],
            tooltips: {
              enabled: true,
              callbacks: {
                label: function(context) {
                  return CurrencyHelperService.formatViaCurrencyCode(context.value, currencyCode);
                }
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  callback: function(value) {
                    return CurrencyHelperService.formatViaCurrencyCode(value, currencyCode, { maximumFractionDigits: 0 });
                  }
                }
              }]
            }
          }
        },
        tableData: [],
        header: {
          label: 'Day'
        },
        limitTableSize: false,
        hidePercentageAnsweredChart: true,
        inReport: true
      });
  
      /***
         * REVENUE BY DAY BY USER CHART BORN
        */
  
      factoryData.items.push({
        id: 'revenueByDayByUser',
        title: 'User daily revenue performance',
        subtitle: 'User Breakout',
        metadata: {
          category: 'timeWidgets',
          icon: 'perm_contact_calendar',
          object: 'response',
          databasefieldname: 'estimatedRevenue'
        },
        query: {
          metrics: [{
            groupBy: 'mmddyy_user',
            sortBy: 'groupedObjectKey',
            limit: 10
          }]
        },
        chart: {
          type: 'bar',
          labels: [],
          data: [],
          series: [],
          options: {
            legend: {
              display: true
            },
            availableChartTypes: [{
              chart: 'bar',
              icon: 'insert_chart'
            }, {
              chart: 'line',
              icon: 'show_chart'
            }],
            tooltips: {
              enabled: true,
              callbacks: {
                label: function(context) {
                  return CurrencyHelperService.formatViaCurrencyCode(context.value, currencyCode);
                }
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  callback: function(value) {
                    return CurrencyHelperService.formatViaCurrencyCode(value, currencyCode, { maximumFractionDigits: 0 });
                  }
                }
              }]
            }
          }
        },
        tableData: [],
        header: {
          label: 'Day & User'
        },
        limitTableSize: false,
        hidePercentageAnsweredChart: true,
        inReport: true
      });
  
      /***
         * REVENUE BY HOUR CHART BORN
         */
      factoryData.items.push({
        id: 'revenueByHour',
        title: 'Revenue captured detail',
        subtitle: 'By hour',
        metadata: {
          category: 'timeWidgets',
          icon: 'access_time',
          object: 'response',
          databasefieldname: 'estimatedRevenue'
        },
        query: {
          metrics: [{
            groupBy: 'mmddyyhh',
            rangeFill: {
              min: 8, // hour of day to start from (think chart x axis start)
              max: 19
            },
            sortBy: 'groupedObjectKey'
          }]
        },
        chart: {
          type: 'line',
          labels: [],
          data: [],
          series: [],
          options: {
            legend: {
              display: true
            },
            availableChartTypes: [{
              chart: 'bar',
              icon: 'insert_chart'
            }, {
              chart: 'line',
              icon: 'show_chart'
            }],
            tooltips: {
              enabled: true,
              callbacks: {
                label: function(context) {
                  return CurrencyHelperService.formatViaCurrencyCode(context.value, currencyCode);
                }
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  callback: function(value) {
                    return CurrencyHelperService.formatViaCurrencyCode(value, currencyCode, { maximumFractionDigits: 0 });
                  }
                }
              }]
            }
          }
        },
        tableData: [],
        header: {
          label: 'Day & Hour'
        },
        limitTableSize: 0,
        hidePercentageAnsweredChart: true,
        inReport: true
      });
      //}
  
      _.map(factoryData.items, function (o) {
        return factoryData.itemsObject[o.id] = o;
      });
    }
  }
}());
  
(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpTeamPerformanceWidget', {
      templateUrl: 'app/forms/reporting/team-performance-component/zp-team-performance.tmpl.html',
      controller: 'teamPerformanceCtrl',
      bindings: {
        id: '@',
        widgetData: '<',
        metaData: '<'
      }
    })
    .controller('teamPerformanceCtrl', teamPerformanceCtrl);

  teamPerformanceCtrl.$inject = ['ResponseAggregationModel'];
  /* ng-inject */
  function teamPerformanceCtrl(ResponseAggregationModel) {

    var vm = this;

    vm.$onInit = function () {
      ResponseAggregationModel.bindWidgetToFactory(vm.widgetData);
    };


  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpShowroomReportWidget', {
      templateUrl: 'app/forms/reporting/showroom-reports/zp-showroom-report.tmpl.html',
      controller: 'ShowroomReportsCtrl',
      bindings: {
        formId: '<',
        widgetData: '<'
      }
    })
    .controller('ShowroomReportsCtrl', ShowroomReportsCtrl);

  ShowroomReportsCtrl.$inject = ['ResponseAggregationModel', '$state'];
  /* ng-inject */
  function ShowroomReportsCtrl(ResponseAggregationModel, state){

    var vm = this;

    vm.$onInit = function () {
      ResponseAggregationModel.bindWidgetToFactory(vm.widgetData);
      vm.widgetData.showChart = false;
    };

    vm.changeChartType = function (type) {
      vm.widgetData.chart.type = type;
      vm.widgetData.chart.options = {
        maintainAspectRatio: true
      };
    };

    vm.goTo = function () {
      var columnid = vm.widgetData.id;
      state.go('app.single_view_framework.forms_reporting_dashboard', { navigationArray: 'widgetsArray', _id: vm.formId, columnid: columnid, chartcolumnid: null, chartdatasetid: null });
    };

    vm.chartClicked = function(chartEl){
      state.go('app.single_view_framework.forms_reporting_dashboard', { navigationArray: 'widgetsArray', _id: vm.formId, columnid: vm.widgetData.id, chartcolumnid: chartEl._index, chartdatasetid: chartEl._datasetIndex });
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('ShowroomWidgetsMetadataFactory', ShowroomWidgetsMetadataFactory);

  ShowroomWidgetsMetadataFactory.$inject = ['LiteratureNamesFactory'];
  /* ng-inject */
  function ShowroomWidgetsMetadataFactory(LiteratureNamesFactory) {

    var factoryData = {};
    buildFactory();

    return {
      getData: getData,
      buildShowroomWidgets: buildShowroomWidgets,
      getWidgetById: getWidgetById,
      resetFactory: buildFactory
    };

    function getData() {

      return factoryData;
    }

    function buildFactory() {
      factoryData.category = 'showroomWidgets';
      factoryData.items = [];
      factoryData.itemsObject = {};
      factoryData.metadata = {
        title: 'Showroom Widgets',
        tooltip: 'Add all to report',
        icon: 'add',
        iconColor: '#949ca1'
      };
    }

    function getWidgetById(id) {
      return factoryData.itemsObject[id];
    }

    function buildShowroomWidgets() {

      var litDocs = LiteratureNamesFactory.getDocsObject();
      var tagDocs = LiteratureNamesFactory.fillTagsLiteratureArray();

      factoryData.items.push({
        id: '_tagCategories',
        title: 'Tag Category Totals',
        chart: {
          labels: [],
          data: [],
          type: 'bar',
          options: {
            /*availableChartTypes: [{
              chart: 'bar',
              icon: 'insert_chart'
            }, {
              chart: 'line',
              icon: 'show_chart'
            }, {
              chart: 'pie',
              icon: 'pie_chart'
            }]*/
            legend: {}
          }
        },
        tagDocs: tagDocs,
        answerCount: 0,
        linkedResponseIds: [],
        metadata: {
          allowMultiple: true,
          icon: 'attach_file',
          category: 'showroomWidgets',
          object: 'response',
          databasefieldname: '_literature'
        },
        query: {
          metrics: [{
            groupBy: 'tagCategory',
            sortBy: 'count',
            sortDirection: 'desc',
            limit: null
          }]
        },
        header: {
          label: 'Title'
        },
        tableData: [],
        limitTableSize: false,
        hidePercentageAnsweredChart: true,
        inReport: true,
        showTable: true,
        showChart: true
      });

      factoryData.items.push({
        id: '_tags',
        title: 'Tag Totals',
        chart: {
          labels: [],
          data: [],
          type: 'bar',
          options: {
            legend: {}
          }
        },
        tagDocs: tagDocs,
        answerCount: 0,
        linkedResponseIds: [],
        metadata: {
          allowMultiple: true,
          icon: 'attach_file',
          category: 'showroomWidgets',
          object: 'response',
          databasefieldname: '_literature'
        },
        query: {
          metrics: [{
            groupBy: 'tagTitle',
            sortBy: 'count',
            sortDirection: 'desc',
            limit: null
          }]
        },
        header: {
          label: 'Title'
        },
        tableData: [],
        limitTableSize: false,
        hidePercentageAnsweredChart: true,
        inReport: true,
        showTable: true,
        showChart: true
      });

      factoryData.items.push({
        id: '_literature',
        title: 'Lit Totals',
        chart: {
          labels: litDocs,
          data: null,
          type: 'bar',
          options: {
            legend: {}
          }
        },
        labels: litDocs,
        answerCount: 0,
        linkedResponseIds: [],
        metadata: {
          allowMultiple: true,
          icon: 'attach_file',
          category: 'showroomWidgets',
          object: 'response',
          databasefieldname: '_literature'
        },
        query: {
          metrics: [{
            groupBy: '_literature',
            sortBy: 'count',
            sortDirection: 'desc',
            limit: null
          }]
        },
        header: {
          label: 'Title'
        },
        tableData: [],
        limitTableSize: false,
        hidePercentageAnsweredChart: true,
        inReport: true,
        showTable: true,
        showChart: true
      });

      _.map(factoryData.items, function (o) {
        return factoryData.itemsObject[o.id] = o;
      });

    }
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpQuestionChartWidget', {
      bindings: {
        formId: '<',
        widgetData: '<'
      },
      controller: 'zpQuestionChartsWidgetCtrl',
      templateUrl: 'app/forms/reporting/question-chart-widget/zp-question-chart.tmpl.html'
    })
    .controller('zpQuestionChartsWidgetCtrl', zpQuestionChartsWidgetCtrl);

  zpQuestionChartsWidgetCtrl.$inject = ['$state', 'ResponseAggregationModel', 'MessageService', 'localStorageService'];
  /* ng-inject */
  function zpQuestionChartsWidgetCtrl(state, ResponseAggregationModel, MessageService, localStorage) {

    var vm = this;

    vm.$onInit = function () {
      var storedModel = localStorage.get('widget_report_definition_question_' + vm.widgetData.id);
      if (storedModel) {
        var modelObj = JSON.parse(storedModel);
        vm.changeChartType(modelObj.type);
      }
      ResponseAggregationModel.bindWidgetToFactory(vm.widgetData);
    };

    vm.goTo = function () {
      MessageService.pushEventToIntercom('view_charts_button_clicked', {
        widgetid: vm.widgetData.id
      });

      state.go('app.single_view_framework.forms_reporting_dashboard', {
        navigationArray: 'widgetsArray',
        _id: vm.formId,
        columnid: vm.widgetData.id,
        chartcolumnid: null, 
        chartdatasetid: null
      });
    };

    function calculateStepSize(widgetData) {
      var stepVal;
      var maxVal = _.max(_.flatten(widgetData));
      if (maxVal < 10) {
        stepVal = 1;
      } else if (maxVal > 10 && maxVal < 50) {
        stepVal = 5;
      } else if (maxVal > 51 && maxVal < 100) {
        stepVal = 10;
      } else if (maxVal > 100 && maxVal < 250) {
        stepVal = 25;
      } else if (maxVal > 251 && maxVal < 1000) {
        stepVal = 100;
      } else if (maxVal > 1001 && maxVal<3000) {
        stepVal = 250;
      }
      else if (maxVal > 3001 && maxVal<5000) {
        stepVal = 500;
      }
      else if (maxVal > 5001 && maxVal<8000) {
        stepVal = 1000;
      }
      else if (maxVal > 8001 && maxVal<10000) {
        stepVal = 2000;
      }
      else if (maxVal > 10001 && maxVal<100000) {
        stepVal = 5000;
      }
      else if (maxVal > 100001) {
        stepVal = 10000;
      }
      return stepVal;
    }

    vm.changeChartType = function (type) {
      vm.widgetData.chart.type = type;
      vm.widgetData.chart.options = {
        maintainAspectRatio: true,
        legend: {}
      };

      if (type === 'bar' || type === 'line') {
        vm.widgetData.chart.options.scales = {
          yAxes: [{
            type:'linear',
            ticks: {
              beginAtZero: true,
              stepSize: calculateStepSize(vm.widgetData.chart.data)
            }
          }],
          xAxes: [{
          }]
        };
      } else if (type === 'radar' || type === 'polarArea') {
        vm.widgetData.chart.options.scale = {
          ticks: {
            beginAtZero: true,
            stepSize: calculateStepSize(vm.widgetData.chart.data)
          },
        };
      } else {
        vm.widgetData.chart.options.scales = {};
      }

      if (type === 'pie' || type === 'doughnut' || type === 'polarArea') {
        vm.widgetData.chart.options.legend = {
          display: true
        };
      }

      localStorage.set('widget_report_definition_question_' + vm.widgetData.id, JSON.stringify({ type: type }));
    };

    vm.chartClicked = function(chartEl){
      state.go('app.single_view_framework.forms_reporting_dashboard', { navigationArray: 'widgetsArray', _id: vm.formId, columnid: vm.widgetData.id, chartcolumnid: chartEl._index, chartdatasetid: chartEl._datasetIndex });
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpPrintablePage', {
      templateUrl: 'app/forms/reporting/printable-page-component/zp-printable-page.tmpl.html',
      controller: 'zpPrintablePageCtrl',
      bindings: {
        formid: '<',
        userData: '<',
        clientDoc: '<'
      }
    })
    .controller('zpPrintablePageCtrl', zpPrintablePageCtrl);

  zpPrintablePageCtrl.$inject = ['MessageService', 'AllReportWidgetsMetadataCombined', '$timeout', 'ReportModel', 'EncodingService', 'ResponseAggregationModel', 'AWS_STORAGE_REGION', 'AWS_STORAGE_BUCKET_NAME', '$filter'];
  /* ng-inject */
  function zpPrintablePageCtrl(MessageService, AllReportWidgetsMetadataCombined, $timeout, ReportModel, encoder, ResponseAggregationModel, awsStorageRegion, awsStorageBucketName, $filter) {

    var vm = this;

    vm.zuantLogoFill = '#f0f0f0';
    vm.twoBoxImageSvg = $filter('cdnAssets')('/images/svgs/utilities/theme/2_box_l.svg');
    vm.twoBoxAlternateImageSvg = $filter('cdnAssets')('/images/svgs/utilities/theme/2_box_r.svg');
    vm.zuantFillColour = '#FEC353';
    vm.cloudFillColour = '#CED8DD';
    vm.poweredByZuantLogoURL = $filter('cdnAssets')('/images/svgs/logos/zuant/thank_you_powered_by_zuant.svg');

    vm.title = {
      name: 'title',
      label: 'Report title',
      type: 'Text',
      placeholder: 'Report title',
      editable: true,
      required: false
    };

    vm.$onInit = function () {

      vm.clientLogoImage = buildLogoSrcObj();

      vm.report = ReportModel.factoryData;

      const allWidgets = AllReportWidgetsMetadataCombined.getData();

      vm.headlineWidgets = _.filter(allWidgets.headlineWidgets.items, function (item) {
        return item.inReport;
      });

      vm.timeWidgets = _.filter(allWidgets.timeWidgets.items, function (item) {
        return item.inReport;
      });

      vm.revenueWidgets = _.filter(allWidgets.revenueWidgets.items, function (item) {
        return item.inReport;
      });

      vm.columnSummaryWidgets = _.filter(allWidgets.columnSummaryWidgets.items, function (item) {
        return item.inReport;
      });

      vm.showroomWidgets = _.filter(allWidgets.showroomWidgets.items, function (item) {
        return item.inReport;
      });

      vm.emailHeadlineWidgets = _.filter(allWidgets.emailHeadlinePerformanceWidgets.items, function (item) {
        return item.inReport;
      });

      vm.emailWidgets = _.filter(allWidgets.emailPerformanceWidgets.items, function (item) {
        return item.inReport;
      });

      ResponseAggregationModel.changeDate(vm.report.metadata.startDate.value, vm.report.metadata.endDate.value, 'mmddyy');

      $timeout(function () {
        if (vm.report.metadata.limitAnswers) {
          ResponseAggregationModel.trimAnswers(10);
          vm.top10Answers = true;
        }
      }, 500);

    };
    // end onInit

    vm.updateTitle = function (value) {
      vm.report.metadata.title = value;
      ReportModel.saveReport(vm.formid, vm.report.metadata);
    };

    vm.trackingFunction = function (chartItem) {
      return chartItem.id;
    };

    vm.printReport = function () {
      document.title = vm.userData.company + '_' + vm.report.metadata.title;
      window.print();
      MessageService.pushEventToIntercom('pdf_report_printed', {
        _formid: encoder.decode($transition$.params()._formid),
        formname: vm.report.metadata.title
      });
    };

    function buildLogoSrcObj() {
      const obj = {
        type: 'default',
        url: $filter('cdnAssets')('/images/svgs/logos/zuant/ZUANT_CUSTOM_FILL.svg')
      };
      
      if (vm.clientDoc.clientLogoImage && (vm.clientDoc.clientLogoImage._s3key || vm.clientDoc.clientLogoImage.base64)){
        obj.type = 'custom';
        obj.url = 'data:image/jpeg;base64,' + vm.clientDoc.clientLogoImage.base64;

        if (vm.clientDoc.clientLogoImage._s3key) {
          obj.url = `https://s3.${awsStorageRegion}.amazonaws.com/${awsStorageBucketName}/${vm.clientDoc.clientLogoImage._s3key}?timestamp=${vm.clientDoc.clientLogoImage._lastmodifiedonservertime}`;
        }
      }
      
      return obj;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpPrintableChart', {
      bindings: {
        widgetData: '<'
      },
      controller: 'zpPrintableChartWidgetCtrl',
      templateUrl: 'app/forms/reporting/printable-chart-widget/zp-printable-chart.tmpl.html'
    })
    .controller('zpPrintableChartWidgetCtrl', zpPrintableChartWidgetCtrl);

  zpPrintableChartWidgetCtrl.$inject = ['ResponseAggregationModel', 'localStorageService'];
  /* ng-inject */
  function zpPrintableChartWidgetCtrl(ResponseAggregationModel, localStorage) {

    var vm = this;

    vm.$onInit = function () {
      ResponseAggregationModel.bindWidgetToFactory(vm.widgetData);
      vm.chartOptions = {};

      const storedModel = localStorage.get('widget_report_definition_question_' + vm.widgetData.id);
      if (storedModel) {
        const modelObj = JSON.parse(storedModel);
        vm.changeChartType(modelObj.type);
      } else {
        vm.changeChartType('bar');
      }

      if (vm.widgetData.chart.series) {
        vm.chartOptions.legend = {
          display: true
        };
      }
    };

    vm.changeChartType = function (type) {
      vm.widgetData.chart.type = type;

      if (type === 'bar' || type === 'line') {
        vm.chartOptions.scales = {
          yAxes: [{
            type:'linear',
            ticks: {
              beginAtZero: true,
              stepSize: calculateStepSize(vm.widgetData)
            }
          }],
          xAxes: [{
          }]
        };
      } else if (type === 'radar' || type === 'polarArea') {
        vm.chartOptions.scale = {
          ticks: {
            beginAtZero: true,
            stepSize: calculateStepSize(vm.widgetData)
          },
        };
      } else {
        vm.chartOptions.scales = {};
      }

      if (type === 'pie' || type === 'doughnut' || type === 'polarArea') {
        vm.chartOptions.legend = {
          display: true
        };
        vm.chartOptions.totalsTable = {
          display: true
        };
      }

      localStorage.set('widget_report_definition_question_' + vm.widgetData.id, JSON.stringify({ type: type }));
    };

    vm.chartClicked = function(){
      //DO NOTHING
    };

    function calculateStepSize(widgetData) {
      if (!widgetData.chart.data[0]) return;
      if (widgetData.chart.data[0].count <= 20) {
        return 1;
      } else if (widgetData.chart.data[0].count <= 30) {
        return 5;
      } else if (widgetData.chart.data[0].count <= 100) {
        return 20;
      } else if (widgetData.chart.data[0].count > 101) {
        return 25;
      }
    }

  }
}());

(function () {

  'use strict';

  angular
    .module('forms')
    .component('zpPdfBuilderSidebar', {
      controller: 'zpPdfBuilderSidebarCtrl',
      templateUrl: 'app/forms/reporting/pdf-builder-sidebar/zp-pdf-builder-sidebar.tmpl.html',
      bindings: {
        formid: '<'
      }
    })
    .controller('zpPdfBuilderSidebarCtrl', zpPdfBuilderSidebarCtrl);

  zpPdfBuilderSidebarCtrl.$inject = ['ResponseAggregationModel', 'AllReportWidgetsMetadataCombined', 'ReportModel', 'MessageService', 'FormMetadataFactory', 'ZuantAccountManagersFactory'];
  /* ng-inject */
  function zpPdfBuilderSidebarCtrl(ResponseAggregationModel, AllReportWidgetsMetadataCombined, ReportModel, MessageService, FormMetadataFactory, ZuantAccountManagersFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.userIsZAM = ZuantAccountManagersFactory.loggedInUserIsAZam();
      vm.reportWidgets = AllReportWidgetsMetadataCombined.getData();
      vm.report = ReportModel.factoryData;
      ReportModel.clearChangeDelta();
      vm.formname = FormMetadataFactory.getData().formProperties.formname;
      vm.report.metadata.title = vm.formname;

      var sortedDates = _.map(ResponseAggregationModel.factoryData.timeIndeces.mmddyy, function (a, b) {
        return {
          value: b,
          dt: new Date(b),
          caption: moment(b).format('MMM Do YYYY')
        };
      })
        .sort((a, b) => {
          return a.dt > b.dt ? -1 : a.dt < b.dt ? 1 : 0;
        });

      vm.startDateObjectsArr = _.clone(sortedDates).reverse();
      vm.endDateObjectsArr = _.clone(sortedDates);

      if (!vm.report.id || !vm.report.metadata.startDate.value && !vm.report.metadata.endDate.value) {
        // default report range to outer extremes if not already set
        vm.report.metadata.startDate = angular.copy(vm.startDateObjectsArr[0]);
        vm.report.metadata.endDate = angular.copy(vm.endDateObjectsArr[0]);
      } else {
        vm.report.metadata.startDate = angular.copy(_.find(vm.startDateObjectsArr, function (date) {
          return date.value == vm.report.metadata.startDate.value;
        }));
        vm.report.metadata.endDate = angular.copy(_.find(vm.endDateObjectsArr, function (date) {
          return date.value == vm.report.metadata.endDate.value;
        }));
      }
      ResponseAggregationModel.changeDate(vm.report.metadata.startDate.value, vm.report.metadata.endDate.value, 'mmddyy');
      if (vm.report.metadata.limitAnswers) {
        ResponseAggregationModel.trimAnswers(10);
      }
    };

    vm.toggleWidgetInReport = function (widget) {
      ReportModel.toggleWidgetInReport(widget);
      vm.saveReport();
    };

    vm.toggleAllWidgetsInReport = function (widgetCategory) {
      var addAllWidgets = _.find(vm.reportWidgets[widgetCategory].items, function (item) {
        return !item.inReport;
      });
      ReportModel.toggleAllWidgetsInReport(vm.reportWidgets[widgetCategory].items, addAllWidgets);
      vm.saveReport();
    };

    vm.iconCheck = function (widgetCategory) {
      return _.find(vm.reportWidgets[widgetCategory].items, function (item) {
        return !item.inReport;
      }) ? 'add' : 'remove';
    };

    vm.saveReport = function () {
      ReportModel.saveReport(vm.formid, vm.report.metadata);
      MessageService.writeLog({
        level: 'info',
        msg: 'Report definition saved for ' + vm.formid
      });
      ReportModel.clearChangeDelta();
    };

    vm.updateRange = function (dateToUpdate) {
      vm.report.metadata[dateToUpdate].caption = moment(vm.report.metadata[dateToUpdate].dt).format('MMM Do YYYY');
      vm.report.metadata[dateToUpdate].value = moment(vm.report.metadata[dateToUpdate].dt).format('MM/DD/YY');

      if (vm.report.metadata.startDate.value) {
        if (moment(vm.report.metadata.startDate.value).isAfter(vm.report.metadata.endDate.value)) {
          vm.report.metadata.endDate = angular.copy(vm.report.metadata.startDate);
        }
      }

      ResponseAggregationModel.changeDate(vm.report.metadata.startDate.value, vm.report.metadata.endDate.value, 'mmddyy');
      vm.saveReport();
    };

    vm.trimAnswers = function () {
      var trimLength = vm.report.metadata.limitAnswers ? 10 : null;
      ResponseAggregationModel.trimAnswers(trimLength);
      vm.saveReport();
    };

    vm.onlyActiveDaysPredicate = function (date) {
      return _.find(vm.startDateObjectsArr, day => moment(day.dt).isSame(date, 'day'));
    };


    vm.resetStartDate = function () {
      // start date
      vm.report.metadata.startDate.dt = angular.copy(vm.startDateObjectsArr[0].dt);
      vm.report.metadata.startDate.value = angular.copy(vm.startDateObjectsArr[0].value);
      vm.report.metadata.startDate.caption = angular.copy(vm.startDateObjectsArr[0].caption);
      
      ResponseAggregationModel.changeDate(vm.report.metadata.startDate.value, vm.report.metadata.endDate.value, 'mmddyy');
      vm.saveReport();
    };

    vm.resetEndDate = function () {
      // end date
      vm.report.metadata.endDate.dt = angular.copy(vm.endDateObjectsArr[0].dt);
      vm.report.metadata.endDate.value = angular.copy(vm.endDateObjectsArr[0].value);
      vm.report.metadata.endDate.caption = angular.copy(vm.endDateObjectsArr[0].caption);

      ResponseAggregationModel.changeDate(vm.report.metadata.startDate.value, vm.report.metadata.endDate.value, 'mmddyy');
      vm.saveReport();
    };

  }

}());

(function() {
  'use strict';
  
  angular
    .module('forms')
    .component('zpHeadlineWidget', {
      templateUrl: 'app/forms/reporting/headline-widget/zp-headline-widget.tmpl.html',
      controller: 'zpHeadlineWidgetCtrl',
      bindings: {
        widgetData: '<',
        metaData: '<'
      }
    })
    .controller('zpHeadlineWidgetCtrl', zpHeadlineWidgetCtrl);

  zpHeadlineWidgetCtrl.$inject = ['ResponseAggregationModel'];
  /* ng-inject */
  function zpHeadlineWidgetCtrl(ResponseAggregationModel) {

    var vm = this;

    vm.$onInit = function () {
      ResponseAggregationModel.bindWidgetToFactory(vm.widgetData);
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('HeadlinesMetadataFactory', HeadlinesMetadataFactory);

  HeadlinesMetadataFactory.$inject = ['FormMetadataFactory'];
  /* ng-inject */
  function HeadlinesMetadataFactory(/*FormMetadataFactory*/) {

    var factoryData = {};
    buildFactory();

    return {
      getData: getData,
      resetFactory: buildFactory
    };

    function getData() {
      return factoryData;
    }

    function buildFactory() {
      //var formMetadata = FormMetadataFactory.getData();

      factoryData = {
        category: 'headlineWidgets',
        metadata: {
          title: 'The Headlines',
          tooltip: 'Add all to report',
          icon: 'add',
          iconColor: '#5b88b5'
        },
        hiddenCount: 0,
        items: [{
          id: 'totalLeads',
          title: 'TOTAL LEADS',
          subtitle: 'LEADS',
          metadata: {
            category: '',
            icon: 'create',
            iconColor: '#5b88b5'
          },
          query: {
            metrics: [{
              groupBy: '_formid',
              countUpToProperty: true
            }]
          },
          countupto: 0,
          chart: {
            data: [],
            labels: [],
            legend: {}
          },
          inReport: true
        }, {
          id: 'busiestDay',
          title: 'BUSIEST DAY',
          subtitle: 'foo',
          metadata: {
            category: 'headlineWidgets',
            icon: 'whatshot',
            iconColor: '#5b88b5'
          },
          query: {
            metrics: [{
              groupBy: '_initialcreatedate',
              sortBy: 'count',
              sortDirection: 'desc',
              limit: 1,
              countUpToProperty: true,
              setWidgetProperty: true,
              propertyToSet: 'subtitle',
              sortMetric: {
                prop: 'members',
                sortDescending: true
              }
            }, {
              groupBy: '_formid',
              sortDirection: 'desc',
              limit: 1
            }]
          },
          chart: {
            data: [],
            labels: [],
            legend: {}
          },
          countupto: 0,
          inReport: true
        }, {
          id: 'showroomItemsSelected',
          title: 'LITERATURE',
          subtitle: 'ITEMS ATTACHED',
          metadata: {
            category: 'headlineWidgets',
            icon: 'attach_file',
            iconColor: '#5b88b5',
            object: 'response',
            databasefieldname: '_literature'
          },
          labels: {},
          query: {
            metrics: [{
              groupBy: '_literature',
              sortBy: 'count',
              sortDirection: 'desc',
              limit: 5,
              reduceTotalsToSingleValue: true,
              countUpToProperty: true,
              sortMetric: {
                prop: 'members',
                sortDescending: true
              }
            }]
          },
          countupto: 0,
          inReport: true
        }, {
          id: 'emailsSentTotal',
          title: 'THANK YOU EMAIL',
          subtitle: 'EMAILS SENT',
          metadata: {
            category: 'headlineWidgets',
            icon: 'send',
            iconColor: '#5b88b5',
            object: 'response',
            databasefieldname: 'templatesSentForForm'
          },
          labels: {},
          query: {
            metrics: [{
              groupBy: 'emailSendsForForm',
              reduceTotalsToSingleValue: true,
              countUpToProperty: true
            }]
          },
          countupto: 0,
          inReport: true
        }, {
          id: '_parkedLeadsWidget',
          title: 'PARKED LEADS',
          metadata: {
            category: 'headlineWidgets',
            icon: 'local_parking',
            iconColor: '#5b88b5',
            object: 'contact',
            databasefieldname: '_parkedlead'
          },
          labels: {},
          query: {},
          countupto: 0,
          inReport: true
        }]
      };

      //if (formMetadata.estimatedRevenueEnabledForForm) {
      factoryData.items.splice(2 , 0, {
        id: 'totalEstimatedRevenue',
        title: 'TOTAL ESTIMATED REVENUE',
        metadata: {
          category: 'headlineWidgets',
          icon: 'attach_money',
          iconColor: '#5b88b5',
          object: 'response',
          databasefieldname: 'estimatedRevenue'
        },
        query: {
          metrics: [{
            groupBy: '_formid',
            countUpToProperty: true
          }]
        },
        countupto: 0,
        chart: {
          data: [],
          labels: [],
          legend: {}
        },
        inReport: true
      });
      //}

      /*if (formMetadata.pickAWinnerEnabledForForm) {
        factoryData.items.push({
          id: 'prizeDrawStatus',
          title: 'Prize Winner',
          subtitle: 'WIN!',
          metadata: {
            category: 'headlineWidgets',
            icon: 'local_parking',
            iconColor: '#5b88b5',
            object: 'response',
            databasefieldname: '_parkedlead'
          },
          labels: {},
          query: {
            metrics: [{
              groupBy: '_parkedlead',
              sortBy: 'count',
              sortDirection: 'desc',
              limit: 5,
              reduceTotalsToSingleValue: true,
              countUpToProperty: true,
              sortMetric: {
                prop: 'members',
                sortDescending: true
              }
            }]
          },
          countupto: 0,
          inReport: true
        });
      }*/
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpQuestionReportingDashboard', {
      templateUrl: 'app/forms/reporting/full-screen-report-component/zp-full-screen-report.tmpl.html',
      bindings: {
        widgetData: '<',
        metadata: '<',
        navInfo: '<',
        formId: '<',
        filter: '<'
      },
      controller: 'zpQuestionReportingDashboardCtrl'
    })
    .controller('zpQuestionReportingDashboardCtrl', zpQuestionReportingDashboardCtrl);

  zpQuestionReportingDashboardCtrl.$inject = ['$scope', 'LeadDataFactory', 'PaginationManager', 'ResponseAggregationModel', '$timeout', '$state', 'FormMetadataFactory', 'GridDataFactory', 'GridMetaDataFactory', 'MessageService', 'DeleteAResponseColumn'];
  /* ng-inject */
  function zpQuestionReportingDashboardCtrl($scope, LeadDataFactory, PaginationManager, ResponseAggregationModel, $timeout, $state, FormMetadataFactory, GridDataFactory, GridMetaDataFactory, MessageService, DeleteAResponseColumn) {

    var vm = this;

    vm.$onInit = function () {
      MessageService.pushEventToIntercom('viewing_widget_grid', {
        widgetTitle: vm.widgetData.title
      });

      vm.gridFilter = [];
      ResponseAggregationModel.bindWidgetToFactory(vm.widgetData);
      ResponseAggregationModel.updateWidgets();

      vm.metadata = angular.copy(FormMetadataFactory.getData());

      vm.metadata.id = 'full_page_widget_grid';
      vm.metadata.toolbarButtons.showEdit = false;
      vm.metadata.toolbarButtons.showSave = false;
      vm.metadata.toolbarButtons.showUnpark = false;
      vm.metadata.toolbarButtons.showParkedLeads = false;
      vm.metadata.toolbarButtons.showDataRefreshButton = false;
      vm.metadata.csvFileLabel = `widgetDrilldown:${vm.widgetData.title}_report`;

      vm.metadata.gridOptions = {
        rowSelection: false,
        multiSelect: false,
        sortable: true,
        interactive: false
      };

      vm.metadata.query = {
        order: {
          id: 'contact.lastname',
          expression: 'contact.lastname.raw'
        },
        limit: 20,
        page: 1
      };

      vm.metadata.paginationOptions = {
        boundaryLinks: true,
        limitSelect: true,
        pageSelect: true,
        pagination: true,
        limitOptions: [
          5,
          10,
          20,
          50,
          75,
          100
        ],
        limit: 20,
        page: 1
      };

      GridMetaDataFactory.hydrateData(vm.metadata.columnsData, vm.metadata.id);
      vm.data = GridDataFactory.getDataForGrid(vm.metadata.id);

      columnsTidyUp();

      vm.percentageAnsweredChart = {
        data: [Math.round(vm.widgetData.percentageAnswered), (100 - Math.round(vm.widgetData.percentageAnswered))],
        labels: ['Y', 'N'],
        metadata: {
          title: '% Answered',
          countUpTo: Math.round(vm.widgetData.percentageAnswered)
        },
        chartOptions: {
          cutoutPercentage: 90,
          legend: {
            display: false,
            labels: {
              fontColor: 'rgb(255, 99, 132)'
            }
          }
        }
      };

      vm.widgetData.chart.options.legend.interactive = true;

      vm.mainChart = {
        metadata: {
          title: 'Title!',
          subtitle: 'subtitle'
        },
        data: vm.widgetData.chart.data,
        labels: vm.widgetData.chart.labels,
        series: vm.widgetData.chart.series,
        chart_type: vm.widgetData.chart.type || 'bar',
        chartOptions: vm.widgetData.chart.options
      };

      PaginationManager.setQuery(vm.metadata.query, 'full_page_widget_grid');

      loadSubGrid();
      if (vm.filter._index !== undefined) vm.chartClick(vm.filter);
    };

    function columnsTidyUp() {
      DeleteAResponseColumn(vm.metadata.columnsData, '_aiProfile');
      DeleteAResponseColumn(vm.metadata.columnsData, '_leadIsValid');
      DeleteAResponseColumn(vm.metadata.columnsData, '_parkedlead');
      DeleteAResponseColumn(vm.metadata.columnsData, '_integrationState');
      DeleteAResponseColumn(vm.metadata.columnsData, '_distilledIntegrationState');
    }

    vm.logPagination = function (page, limit) {
      PaginationManager.setQuery({
        page: page,
        limit: limit
      }, 'full_page_widget_grid');
      $('md-content').animate({ scrollTop: 0 }, 0);
    };

    // TODO: out of control!
    vm.menuOptions = [{
      chart_type: 'bar',
      icon: function () {
        return 'bar';
      },
      label: function () {
        return 'Bar Chart';
      },
      ariaLabel: function () {
        return 'bar chart';
      }
    }, {
      chart_type: 'doughnut',
      icon: function () {
        return 'add';
      },
      label: function () {
        return 'Doughnut Chart';
      },
      ariaLabel: function () {
        return 'Doughnut chart';
      }
    }, {
      chart_type: 'pie',
      icon: function () {
        return 'create';
      },
      label: function () {
        return 'Pie Chart';
      },
      ariaLabel: function () {
        return 'Pie chart';
      }
    }, {
      chart_type: 'radar',
      icon: function () {
        return 'add';
      },
      label: function () {
        return 'Radar Chart';
      },
      ariaLabel: function () {
        return 'Radar chart';
      }
    }, {
      chart_type: 'polar',
      icon: function () {
        return 'create';
      },
      label: function () {
        return 'Polar Chart';
      },
      ariaLabel: function () {
        return 'Polar chart';
      }
    }, {
      chart_type: 'line',
      icon: function () {
        return '';
      },
      label: function () {
        return 'Line Chart';
      },
      ariaLabel: function () {
        return 'Line Chart';
      }
    }];

    vm.chartOptionDefaults = {
      tooltips: {
        enabled: true
      },
      hover: {
        animationDuration: 1
      },
      animation: {
        duration: 1500,
        onComplete: function () {
          $scope.$emit('chartAnimation_onComplete');
        }
      }
    };

    function loadSubGrid() {
      const flattenedArray = LeadDataFactory.flattenArraysOfResponseIds(vm.widgetData.linkedResponseIds);
      const result = LeadDataFactory.hydrateLeadsSubsetFilteredByResponseId(flattenedArray);
      vm.totalRows = result.items.length;
      sortColumnsToShow();
    }

    vm.legendClick = function (legendIx) {
      const ixObj = {
        id: legendIx.text,
        linkId: legendIx.datasetIndex,
        label: legendIx.text,
        chartEl: {
          _datasetIndex: legendIx.datasetIndex
        },
        type: 'series'
      };
      updateGridFilter(ixObj);
      refreshGrid();
    };

    vm.chartClick = function (chartEl) {
      const ixObj = {
        id: chartEl._index,
        linkId: chartEl._index,
        chartEl: {
          _index: chartEl._index,
          _datasetIndex: chartEl._datasetIndex
        },
        label: vm.widgetData.chart.series ? vm.widgetData.chart.labels[chartEl._index] + ' - ' + vm.widgetData.chart.series[chartEl._datasetIndex] : vm.widgetData.chart.labels[chartEl._index],
        type: 'column'
      };

      updateGridFilter(ixObj);

      refreshGrid();
    };

    function updateGridFilter(ixObj) {
      const itemAlreadyInFilter = _.find(vm.gridFilter, function (item) {
        return item.chartEl._index == ixObj.chartEl._index && item.chartEl._datasetIndex == ixObj.chartEl._datasetIndex;
      });
      if (!itemAlreadyInFilter) {
        // adding item to grid filter
        let responseIdsArray;
        if (vm.widgetData.chart.series) {
          if (ixObj.type == 'series') {
            responseIdsArray = _.flatten(vm.widgetData.linkedResponseIds[ixObj.chartEl._datasetIndex]);
          } else if (ixObj.type === 'column') {
            responseIdsArray = vm.widgetData.linkedResponseIds[ixObj.chartEl._datasetIndex][ixObj.chartEl._index];
          }
        } else {
          responseIdsArray = vm.widgetData.linkedResponseIds[ixObj.linkId];
        }
        vm.gridFilter.push({
          id: ixObj.id,
          chartEl: ixObj.chartEl,
          label: ixObj.label,
          responseIdsArray: responseIdsArray,
          type: ixObj.type
        });
      } else {
        // removing item from grid filter
        removeFilter(ixObj);
      }
    }

    function refreshGrid() {
      const arrRespIds = _.chain(vm.gridFilter)
        .map('responseIdsArray')
        .flatten()
        .uniq()
        .value(); // get a unique + flattened array of response Ids
      if (arrRespIds.length) {
        LeadDataFactory.hydrateLeadsSubsetFilteredByResponseId(arrRespIds);
        $timeout(function () {
          $scope.$apply();
        }, 0);
      } else {
        LeadDataFactory.hydrateLeadsSubsetFilteredByResponseId(_.uniq(_.flatten(vm.widgetData.linkedResponseIds)));
        $timeout(function () {
          $scope.$apply();
        }, 0);
      }
    }

    vm.removeFilterAndRefresh = function (filterIndex) {
      removeFilter(filterIndex);
      refreshGrid();
    };

    function removeFilter(filterIndexObj) {
      vm.gridFilter = _.filter(vm.gridFilter, function (filterItem) {
        return (filterItem.chartEl._index !== filterIndexObj.chartEl._index || filterItem.chartEl._datasetIndex !== filterIndexObj.chartEl._datasetIndex);
      });
    }

    vm.changeChartType = function (ev, type) {
      vm.mainChart.chart_type = type;
    };

    vm.menuItemClicked = function (command) {
      if (command.selectedMenuItem.chart_type) {
        vm.mainChart.chart_type = command.selectedMenuItem.chart_type;
        vm.mainChart.icon = command.selectedMenuItem.icon;
        vm.mainChart.chartOptions = {
          scales: {
            xAxes: [],
            yAxes: []
          }
        };
      }
    };

    vm.closeDialog = function () {
      $state.go('app.tabbed_app_framework.single_form.dashboard', {
        _id: vm.formId
      });
    };

    function sortColumnsToShow() {
      for (const obj of vm.metadata.columnsData.items) {

        if ((vm.widgetData.metadata.object + '_' + vm.widgetData.metadata.databasefieldname) == (obj.object + '_' + obj.databasefieldname) ||
          (obj.object == 'company' && obj.databasefieldname == 'name') ||
          (obj.object == 'contact' && obj.databasefieldname == 'firstname') ||
          (obj.object == 'contact' && obj.databasefieldname == 'lastname') ||
          (obj.object == 'contact' && obj.databasefieldname == 'email') ||
          (obj.object === 'response' && obj.databasefieldname === '_initialcreatedatelocalutc' && (vm.widgetData.id === 'leadsByDay' || vm.widgetData.id === 'leadsByDayByUser')) ||
          (obj.object === 'response' && obj.databasefieldname === '_initialuser' && vm.widgetData.id === 'leadsByDayByUser') ||
          (obj.object === 'response' && obj.databasefieldname === 'templatesSentForForm' && vm.widgetData.id === 'emailEventsGrouped') ||
          (obj.object === 'response' && obj.databasefieldname === 'emailEvents' && vm.widgetData.id === 'emailEventsGroupedByTemplate') ||
          (obj.object === 'response' && obj.databasefieldname === 'templatesSentForForm' && vm.widgetData.id === 'emailEvents')
        ) {
          obj.showCol = true;
          continue;
        }
        
        obj.showCol = false;
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpPrintReportFab', {
      templateUrl: 'app/forms/reporting/fab/fab.tmpl.html',
      controller: 'zpPrintReportFabCtrl'
    })
    .controller('zpPrintReportFabCtrl', ctrl);

  ctrl.$inject = ['FormMetadataFactory', '$mdSidenav', '$timeout', 'MasterPermissionsDefinitionFactory'];
  /* nj-inject */
  function ctrl(FormMetadataFactory, $mdSidenav, $timeout, MasterPermissionsDefinitionFactory) {

    var vm = this;
    vm.isOpen = true;

    vm.$onInit = function () {
      vm.permissions = MasterPermissionsDefinitionFactory;
      $timeout(function () {
        vm.isOpen = false;
      }, 4000);

      vm.formid = FormMetadataFactory.getData().formProperties._id;
    };

    vm.toggleBuilderSidebar = function () {
      $mdSidenav('reportBuilderSideNav')
        .toggle();
    };

  }

})();

(function () {

  'strict mode';

  angular
    .module('forms')
    .component('zpEmailReportWidget', {
      templateUrl: 'app/forms/reporting/email-performance/zp-email-report-widget.tmpl.html',
      controller: 'EmailReportWidgetCtrl as $ctrl',
      bindings: {
        widgetData: '<',
        formId: '<'
      }
    })
    .controller('EmailReportWidgetCtrl', controller);

  controller.$inject = ['ResponseAggregationModel', '$state'];
  /* ng-inject */
  function controller(ResponseAggregationModel, state) {

    var vm = this;

    vm.$onInit = function () {
      ResponseAggregationModel.bindWidgetToFactory(vm.widgetData);
    };

    vm.changeChartType = function (ev, type) {
      vm.widgetData.chart.type = type;
    };

    vm.goTo = function () {
      var columnid = vm.widgetData.id;
      state.go('app.single_view_framework.forms_reporting_dashboard', { navigationArray: 'widgetsArray', _id: vm.formId, columnid: columnid, chartcolumnid: null, chartdatasetid: null });
    };

    vm.chartClicked = function (chartEl) {
      state.go('app.single_view_framework.forms_reporting_dashboard', { navigationArray: 'widgetsArray', _id: vm.formId, columnid: vm.widgetData.id, chartcolumnid: chartEl._index, chartdatasetid: chartEl._datasetIndex });
    };

  }
})();
(function () {
  'use strict';
  
  angular
    .module('forms')
    .factory('EmailPerformanceWidgetsMetadataFactory', EmailPerformanceWidgetsMetadataFactory);

  EmailPerformanceWidgetsMetadataFactory.$inject = [];
  /* ng-inject */
  function EmailPerformanceWidgetsMetadataFactory() {

    var factoryData = {};
    buildFactory();

    return {
      getData: getData,
      setData: buildFactory
    };

    function getData() {
      return factoryData;
    }

    function buildFactory() {
      factoryData = {
        category: 'emailPerformanceWidgets',
        metadata: {
          title: 'Email Performance',
          tooltip: 'Add all to report',
          icon: 'add',
          iconColor: '#5b88b5'
        },
        hiddenCount: 0,
        items: [{
          id: 'emailsSentDailyTotal',
          title: 'Emails Sent Total',
          subtitle: 'How many emails went out each day total',
          metadata: {
            category: '',
            icon: 'send',
            iconColor: '#5b88b5',
            object: 'response',
            databasefieldname: 'thankYouEmailSent'
          },
          query: {
            metrics: [{
              groupBy: 'mmddyy_email_sends',
              sortBy: 'mmddyy',
              limit: null
            }]
          },
          // countupto: 0,
          header: {
            label: 'Sent'
          },
          chart: {
            type: 'bar',
            data: [],
            labels: [],
            series: [],
            options: {
              legend: {
                display: true
              },
              availableChartTypes: [{
                chart: 'bar',
                icon: 'insert_chart'
              }, {
                chart: 'line',
                icon: 'show_chart'
              }]
            }
          },
          // hidePercentageAnsweredChart: true,
          inReport: true
        }, {
          id: 'emailSendsByTemplate',
          title: 'Daily Email Sends By Template',
          subtitle: 'What template have been used over time',
          metadata: {
            category: '',
            icon: 'send',
            iconColor: '#5b88b5',
            object: 'response',
            databasefieldname: 'templatesSentForForm'
          },
          query: {
            metrics: [{
              groupBy: 'mmddyy_template',
              sortBy: 'mmddyy'
            }]
          },
          // countupto: 0,
          header: {
            label: 'Activity'
          },
          chart: {
            type: 'bar',
            data: [],
            labels: [],
            series: [],
            options: {
              legend: {
                display: true
              },
              availableChartTypes: [{
                chart: 'bar',
                icon: 'insert_chart'
              }, {
                chart: 'line',
                icon: 'show_chart'
              }]
            }
          },
          // hidePercentageAnsweredChart: true,
          inReport: true
        }, {
          id: 'emailEventsGrouped',
          title: 'Email Activity Grouped By Day',
          subtitle: 'How your follow-up email is performing',
          metadata: {
            category: '',
            icon: 'rss_feed',
            iconColor: '#5b88b5',
            object: 'response',
            databasefieldname: 'emailEvents'
          },
          query: {
            metrics: [{
              groupBy: 'mmddyy_event',
              sortBy: 'mmddyy',
              limit: null
            }]
          },
          // countupto: 0,
          header: {
            label: 'Activity'
          },
          chart: {
            type: 'bar',
            data: [],
            labels: [],
            series: [],
            options: {
              legend: {
                display: true
              },
              availableChartTypes: [{
                chart: 'bar',
                icon: 'insert_chart'
              }, {
                chart: 'line',
                icon: 'show_chart'
              }]
            }
          },
          // hidePercentageAnsweredChart: true,
          inReport: true
        }, {
          id: 'emailEvents',
          title: 'Email Activity',
          subtitle: 'Totals grouped by event',
          metadata: {
            category: '',
            icon: 'rss_feed',
            iconColor: '#5b88b5',
            object: 'response',
            databasefieldname: 'emailEvents'
          },
          query: {
            metrics: [{
              groupBy: 'eventName',
              countupto: true
            }]
          },
          // countupto: 0,
          header: {
            label: 'Activity'
          },
          chart: {
            type: 'bar',
            data: [],
            labels: [],
            series: [],
            options: {
              legend: {
                display: true
              },
              availableChartTypes: [{
                chart: 'bar',
                icon: 'insert_chart'
              }, {
                chart: 'line',
                icon: 'show_chart'
              }]
            }
          },
          // hidePercentageAnsweredChart: true,
          inReport: true
        }, {
          id: 'emailEventsGroupedByTemplate',
          title: 'Email Activity By Template',
          subtitle: 'How are your templates doing out there?',
          metadata: {
            category: '',
            icon: 'rss_feed',
            iconColor: '#5b88b5',
            object: 'response',
            databasefieldname: 'templatesSentForForm'
          },
          query: {
            metrics: [{
              groupBy: 'template_event',
              sortBy: 'mmddyy'
            }]
          },
          // countupto: 0,
          header: {
            label: 'Activity'
          },
          chart: {
            type: 'bar',
            data: [],
            labels: [],
            series: [],
            options: {
              legend: {
                display: true
              },
              availableChartTypes: [{
                chart: 'bar',
                icon: 'insert_chart'
              }, {
                chart: 'line',
                icon: 'show_chart'
              }]
            }
          },
          // hidePercentageAnsweredChart: true,
          inReport: true
        }]
      };
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpEmailHeadlineWidget', {
      templateUrl: 'app/forms/reporting/email-headline-widget/zp-email-headline-widget.tmpl.html',
      controller: 'zpEmailHeadlineWidgetCtrl',
      bindings: {
        widgetData: '<',
        formId: '<'
      }
    })
    .controller('zpEmailHeadlineWidgetCtrl', controller);

  controller.$inject = ['ResponseAggregationModel', '$state'];
  /* ng-inject */
  function controller(ResponseAggregationModel, state) {

    var vm = this;

    vm.$onInit = function () {
      ResponseAggregationModel.bindWidgetToFactory(vm.widgetData);
      vm.originalIcon = angular.copy(vm.widgetData.metadata.icon);
      vm.originalIconFill = angular.copy(vm.widgetData.metadata.iconColor);
    };

    vm.mouseEnter = function (){
      vm.widgetData.metadata.icon = 'visibility';
      vm.widgetData.metadata.iconColor = '#fff';
    };

    vm.mouseLeave = function (){
      vm.widgetData.metadata.icon = vm.originalIcon;
      vm.widgetData.metadata.iconColor = vm.originalIconFill;
    };

    vm.goToCharts = function (){
      var columnid = vm.widgetData.id;
      state.go('app.single_view_framework.forms_reporting_dashboard', { navigationArray: 'widgetsArray', _id: vm.formId, columnid: columnid });
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('forms')
    .factory('EmailHeadlinesMetadataFactory', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    var factoryData = {};
    buildFactory();

    return {
      getData: getData,
      resetFactory: buildFactory
    };

    function getData() {
      return factoryData;
    }

    function buildFactory() {
      factoryData = {
        category: 'emailHeadlineWidgets',
        metadata: {
          title: 'The Headlines',
          tooltip: 'Add all to report',
          icon: 'add',
          iconColor: '#5b88b5'
        },
        hiddenCount: 0,
        items: [{
          id: 'emailsSentTotal',
          title: 'SENT',
          subtitle: 'Total',
          metadata: {
            category: 'headlineWidgets',
            subCategory: 'total',
            icon: 'send',
            iconColor: '#5b88b5',
            object: 'response',
            databasefieldname: 'templatesSentForForm'
          },
          labels: {},
          query: {
            metrics: [{
              groupBy: 'emailSendsForForm',
              sortBy: 'count',
              sortDirection: 'desc',
              limit: 5,
              reduceTotalsToSingleValue: true,
              countUpToProperty: true,
              sortMetric: {
                prop: 'members',
                sortDescending: true
              }
            }]
          },
          comparison: {},
          chart: {
            data: [],
            labels: []
          },
          countupto: 0,
          inReport: true
        }, {
          id: 'deliveredVsOpened',
          title: 'OPENED',
          // subtitle: 'Unique',
          metadata: {
            category: 'headlineWidgets',
            subCategory: 'comparison',
            icon: 'drafts',
            iconColor: '#5b88b5',
            object: 'response',
            databasefieldname: 'emailEvents'
          },
          comparison: {
            // grouping: 'emailEventsGroupedByEvent',
            grouping: 'template_event_combined_totals',
            figure1Field: 'Opened',
            figure2Field: 'Delivered',
            figure1: 0,
            figure2: 0,
            percentage: 0
          },
          query: {
            metrics: [{
              groupBy: 'eventName'
            }]
          },
          countupto: 0,
          chart: {
            data: [],
            labels: []
          },
          inReport: true
        }, {
          id: 'openedVsClicked',
          title: 'CLICKED',
          // subtitle: 'Unique',
          metadata: {
            category: 'headlineWidgets',
            subCategory: 'comparison',
            icon: 'mouse',
            iconColor: '#5b88b5',
            object: 'response',
            databasefieldname: 'emailEvents'
          },
          comparison: {
            grouping: 'template_event_combined_totals',
            figure1Field: 'Clicked',
            figure2Field: 'Opened',
            figure1: 0,
            figure2: 0,
            percentage: 0
          },
          labels: {},
          query: {
            metrics: [{
              groupBy: 'eventName'
            }]
          },
          chart: {
            data: [],
            labels: []
          },
          countupto: 0,
          inReport: true
        }, {
          id: 'failedTotal',
          title: 'FAILED',
          subtitle: 'Total',
          metadata: {
            category: 'headlineWidgets',
            icon: 'warning',
            iconColor: '#5b88b5',
            object: 'response',
            databasefieldname: 'failedEmails'
          },
          labels: {},
          query: {
            metrics: [{
              groupBy: 'eventName'
            }]
          },
          countupto: 0,
          inReport: true
        }]
      };
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpColumnSummaryWidget', {
      controller: 'ColumnSummaryWidgetComponentController',
      templateUrl: 'app/forms/reporting/column-summary-widget-component/zp-column-summary-widget.tmpl.html',
      bindings: {
        widgetData: '<'
      }
    })
    .controller('ColumnSummaryWidgetComponentController', ColumnSummaryWidgetComponentController);

  ColumnSummaryWidgetComponentController.$inject = ['$location', 'ReportModel', 'ResponseAggregationModel'];
  /* ng-inject */
  function ColumnSummaryWidgetComponentController($location, ReportModel, ResponseAggregationModel) {

    var vm = this;

    vm.$onInit = function () {
      ResponseAggregationModel.bindWidgetToFactory(vm.widgetData);
    };

    vm.tooltip = function () {
      return ReportModel.checkReportForWidget(vm.widgetData.id) ? 'Widget is in report' : 'Add widget to report';
    };

    vm.goTo = function () {
      var columnid = vm.widgetData.id;
      $location.path('/forms/reporting/widgetsArray/' + vm.widgetData._id + '/' + columnid);
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('ColumnSummaryMetadataFactory', ColumnSummaryMetadataFactory);

  ColumnSummaryMetadataFactory.$inject = ['FormMetadataFactory', 'ListsGeneralFactory', '$q', 'MessageService', '$log', 'ValidationHelperFactory', 'SessionService'];
  /* ng-inject */
  function ColumnSummaryMetadataFactory(FormMetadataFactory, ListsGeneralFactory, $q, MessageService, $log, ValidationHelperFactory, SessionService) {

    var factoryData = {};
    buildFactory();

    return {
      getData: getData,
      buildColumnSummaryWidgets: buildColumnSummaryWidgets,
      getWidgetById: getWidgetById,
      resetFactory: buildFactory
    };

    function getData() {
      return factoryData;
    }

    function buildFactory() {
      // $log.info('💣 Nuking ColumnSummaryMetadataFactory ! 💣');

      factoryData.category = 'columnSummaryWidgets';
      factoryData.items = [];
      factoryData.hiddenCount = 0;
      factoryData.itemsObject = {};
      factoryData.metadata = {
        artefactDependencies: []
      };
      factoryData.warnings = {
        missingArtefacts: []
      };
      factoryData.dataCache = {
        valid: false,
        lastServerTripTimestamp: null,
        clientId: null
      };
    }

    function getWidgetById(id) {
      return factoryData.itemsObject[id];
    }

    function buildColumnSummaryWidgets(formId) {
      // $log.info('buildColumnSummaryWidgets');
      var chartmetadata = FormMetadataFactory.getData().arrayOfChartableColumns;
      // $log.info('arrayOfChartableColumns.length: ' + chartmetadata.length);
      return $q(function q(resolve, reject) {

        if (ValidationHelperFactory.dataCacheIsStillValid(factoryData.dataCache, formId)) {
          // $log.info('ColumnSummaryMetadataFactory cache is valid. resolving local copy');
          resolve({
            columnWidgetItems: factoryData.items,
            columnWidgetItemsObject: factoryData.itemsObject,
            hiddenCount: factoryData.hiddenCount
          });
        } else {
          buildFactory();
          // $log.info('ColumnSummaryMetadataFactory cache is invalid. off to server');
          var arrayOfPromises = [];
          _.each(chartmetadata, function (obj) {
            arrayOfPromises.push(buildChartDataObject(obj));
          });
          $q.all(arrayOfPromises)
            .then(function (res) {
              _.each(res, function (chart) {
                if (chart.status === 404) return; // if a list wasn't found we don't want to add it
                factoryData.items.push(chart);
                factoryData.itemsObject[chart.id] = chart;
              });
              factoryData.dataCache.valid = true;
              factoryData.dataCache.lastServerTripTimestamp = new Date();
              factoryData.dataCache.requestedObjectId = formId;
              factoryData.dataCache.clientId = SessionService.getUserData().clientId;
              resolve({
                columnWidgetItems: factoryData.items,
                columnWidgetItemsObject: factoryData.itemsObject,
                hiddenCount: factoryData.hiddenCount
              });
            })
            .catch(function (err) {
              reject(err);
            });
        }
      });
    }

    function buildChartDataObject(columnmetadata) {
      // grabs remote list if necessary and resolves to hydration function
      return $q(function (resolve) {
        if (columnmetadata.customListId) {
          factoryData.metadata.artefactDependencies.push({
            column: columnmetadata.object +'_'+ columnmetadata.databasefieldname,
            listId: columnmetadata.customListId
          });
          ListsGeneralFactory.getListById(columnmetadata.customListId)
            .then(function (res) {
              // $log.info('remote list');
              resolve(buildWidgetShell(res.itemsForSelectControl));
            })
            .catch(function (err) {
              factoryData.warnings.missingArtefacts.push(columnmetadata.customListId);
              factoryData.warnings.errorMessage = err.statusMessage;
              MessageService.writeLog({
                level: 'info',
                msg: 'Unable to find list this form is using. ListId: ' + columnmetadata.customListId
              });
              resolve(err);
            });
        } else {
          // $log.info('local list');
          resolve(buildWidgetShell(columnmetadata.answers));
        }
      });

      function buildWidgetShell(arrayOfAnswers) {

        var answersShell = {};
        // build answers
        _.each(arrayOfAnswers, function (ans) {
          answersShell[ans.keyValue] = {
            caption: ans.displayValue,
            code: ans.keyValue,
            points: ans.points,
            count: 0,
            arrayOfResponseIds: []
          };
        });

        // this object is the widget shell for a column summary widget. It's data will be filled by the ResponseAggregationModel
        return {
          id: columnmetadata.object + '_' + columnmetadata.databasefieldname,
          title: columnmetadata.label,
          keys: [{
            value: columnmetadata.object + '.' + columnmetadata.databasefieldname
          }],
          questionWidget: true,
          chart: {
            labels: answersShell,
            data: null,
            type: 'bar',
            options: {
              legend: {}
            }
          },
          labels: answersShell,
          percentageAnswered: 0,
          topAnswer: null,
          answerCount: 0,
          linkedResponseIds: [],
          metadata: {
            category: 'columnSummaryWidgets',
            type: columnmetadata.type,
            allowMultiple: columnmetadata.allowMultiple,
            object: columnmetadata.object,
            databasefieldname: columnmetadata.databasefieldname,
            icon: 'help'
          },
          query: {
            field: columnmetadata.object + '.' + columnmetadata.databasefieldname,
            groupBy: 'question',
            sortBy: '',
            limit: null
          },
          inReport: true,
          header: {
            label: 'Caption'
          }
        };
      }
    }

  }
}());

(function () {
  'use strict';
    
  angular
    .module('forms')
    .factory('RevenueWidgetAggregationFactory', factory);
    
  factory.$inject = ['AggregationBuildersFactory', 'AggregationBuilderHelperFactory', 'CurrencyHelperService'];
    
  function factory(AggregationBuildersFactory, AggregationBuilderHelperFactory, CurrencyHelperService) {
    
    var factoryData;
    
    return {
      processRevenueWidget: processRevenueWidget,
      updateRevenueWidgets: updateRevenueWidgets
    };

    function processRevenueWidget(paramsObj) {
      factoryData = paramsObj.factoryData;
      if (!paramsObj.rawValue.length) return;

      if (paramsObj.rawValue.length > 1 && Array.isArray(paramsObj.rawValue)){
        const combined = _.reduce(paramsObj.rawValue, function(rollingValue, value){
          const numericValue = CurrencyHelperService.convertStringToNumber(value);
          if (!numericValue) return rollingValue;
          return rollingValue + numericValue;
        }, 0);

        paramsObj.rawValue = combined;
      }
      
      AggregationBuildersFactory.incrementCountAndRecordResponseId(paramsObj);
    }
  
    function updateRevenueWidgets(widget, trimLength, factoryDataParam) {
  
      factoryData = factoryDataParam;
    
      var data = [],
        chartDataObj,
        valuesObject,
        enumerationKey,
        grouped;
    
      _.each(widget.query.metrics, function (metric) {
        if (trimLength && widget.id != 'revenueTopPerformer') {
          metric.limit = trimLength; // pop a limit in for the metric
          if (widget.id == 'revenueTeamPerformance') widget.subtitle = 'Top 10';
        }
        enumerationKey = AggregationBuilderHelperFactory.findEnumerationKey(metric);
        valuesObject = AggregationBuilderHelperFactory.sliceAndDiceRelevantPresetAndBuildWorkingRevenueObject(factoryData, metric, enumerationKey);
        if (widget.chart) {
  
          grouped = buildGroupedObjectReadyForCharting(metric, widget, valuesObject);
          chartDataObj = buildChartDataObject(grouped, metric, widget);
  
          if (metric.countUpToProperty) {
            widget.countupto = chartDataObj.data[0]; // getting overwritten by the form counts which only want to be added to the chart data...
            if (!widget.countupto) widget.countupto = 0;
          }
          if (metric.setWidgetProperty) {
            widget[metric.propertyToSet] = chartDataObj.labels[0];
          }
          // pushes counts onto data array for busiestDay widget chart (only widget using it)
          data.push(chartDataObj.data[0]);
        }
      });
      // end loop
  
      if (widget.chart) {
        widget.chart.labels = chartDataObj.labels;
        widget.chart.data = chartDataObj.data;
        widget.chart.series = chartDataObj.series;
        widget.linkedResponseIds = chartDataObj.linkedResponseIds;
      }
      widget.isEmpty = _.isEqual(valuesObject, {}) ? true : false;
      widget.limitTableSize = trimLength;
      AggregationBuildersFactory.computeWidgetTableData(widget, valuesObject);
    }

    function buildGroupedObjectReadyForCharting(metric, widget, valuesObject) {
    // slices grouped data i.e 10/10/19_Opened and 
      var primaryMetric, // x-axis label
        seriesMetric, // inner metric (date or person)
        grouped = {},
        split;
  
      _.each(valuesObject, function (obj, key) {
      // emailactivity
        if (metric.groupBy == 'mmddyy_user') {
          split = key.split('_');
          primaryMetric = split[0]; // day
          seriesMetric = split[1]; // user || activity
        }
        if (metric.groupBy == 'mmddyyhh') {
          primaryMetric = key.substring(9); // date with hr (0-24)
          seriesMetric = key.substring(0, 8); // date only dd/mm/yy
        }
        if (metric.groupBy == 'mmddyy' ||
          metric.groupBy == 'user' ||
          metric.groupBy == '_formid' ||
          metric.groupBy == '_literature' ||
          metric.groupBy == '_initialcreatedate' ||
          metric.groupBy == 'estimatedRevenue') {
          primaryMetric = key;
          seriesMetric = 'Total';
        }
  
        if (!grouped[primaryMetric]) {
          grouped[primaryMetric] = {};
        }
  
        if (widget.chart.series) {
          grouped[primaryMetric][seriesMetric] = {
            caption: obj.caption,
            count: obj.count,
            arrayOfResponseIds: obj.arrayOfResponseIds
          };
        } else {
          grouped[primaryMetric] = {
            caption: obj.caption,
            count: obj.count,
            arrayOfResponseIds: obj.arrayOfResponseIds
          };
        }
  
      });
  
      return grouped;
    }
  
    function buildChartDataObject(grouped, metric, widget) {
  
      if (widget.id == 'revenueByHour') {
      // pre-populate hours of the day buckets
        for (var i = metric.rangeFill.min, j = metric.rangeFill.max; i < j; i++) {
          var key = ('0' + i).slice(-2);
          if (!grouped[key]) {
            grouped[key] = {};
          }
        }
      }
      var arr = _.chain(grouped)
        .map(function (obj, key) {
          var sortValue = obj[metric.sortBy];
          if (metric.sortBy == 'groupedObjectKey') {
            if (key.length == 8 && moment(key).isValid()) { // key length should be 8: mm/dd/yy
              sortValue = moment(key); // if value is a valid date then create moment date object so it sorts correctly
            } else {
              sortValue = key;
            }
          } else if (metric.sortBy === 'mmddyy') {
            sortValue = moment(key); // if value is a valid date then create moment date object so it sorts correctly
          }
          return {
            primaryLabel: key,
            members: obj,
            sortValue: sortValue
          };
        }).sortBy('sortValue')
        .value();
  
      if (metric.sortDirection == 'desc') {
        arr = _.sortBy(arr, 'sortValue').reverse();
      }
  
      if (widget.chart.series) {
        return AggregationBuilderHelperFactory.buildSeriesChartData(arr, metric);
      } else {
        return AggregationBuilderHelperFactory.buildSingleSeriesChartData(arr, metric);
      }
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('forms')
    .factory('ResponseAggregationModel', ResponseAggregationModel);

  ResponseAggregationModel.$inject = ['ResponseAggregationModelPresets', 'LeadDataFactory', 'FormMetadataFactory', 'QuestionWidgetAggregationFactory', 'AggregationBuildersFactory', 'LiteratureWidgetAggregationFactory', 'PerformanceWidgetsAggregationFactory', 'EmailWidgetAggregationFactory', 'RevenueWidgetAggregationFactory'];
  /* ng-inject */
  function ResponseAggregationModel(ResponseAggregationModelPresets, LeadDataFactory, FormMetadataFactory, QuestionWidgetAggregationFactory, AggregationBuildersFactory, LiteratureWidgetAggregationFactory, PerformanceWidgetsAggregationFactory, EmailWidgetAggregationFactory, RevenueWidgetAggregationFactory) {

    const factoryData = {
      timeIndeces: {
        mmddyyhh: {},
        mmddyy: {}
      },
      sortedLeadsArray: [],
      formTimezone: '',
      emailTemplate: '',
      arrayOfFactoryPresets: [],
      arrayOfBoundWidgets: [],
      loading: true
    };

    return {
      init: init,
      bindWidgetToFactory: bindWidgetToFactory,
      changeDate: changeDate,
      dateRange: factoryData.timeIndeces,
      updateWidgets: updateWidgets,
      resetFactory: buildFactory,
      hydrateWidgetData: hydrateWidgetData,
      trimAnswers: trimAnswers,
      factoryData: factoryData
    };

    function buildFactory() {

      _.each(factoryData, function (val, prop) {
        if (prop === 'timeIndeces') {
          factoryData.timeIndeces = {
            mmddyyhh: {},
            mmddyy: {}
          };
        } else if (prop === 'sortedLeadsArray') {
          factoryData[prop] = [];
        } else if (prop === 'formTimezone') {
          factoryData[prop] = '';
        } else if (prop === 'emailTemplate') {
          factoryData[prop] = '';
        } else if (prop === 'arrayOfFactoryPresets') {
          factoryData[prop] = [];
        } else if (prop === 'arrayOfBoundWidgets') {
          factoryData[prop] = [];
        } else {
          delete factoryData[prop];
        }
      });

    }

    function init(formId) {
      factoryData.presetsBuilt = false;
      emptyPresets();
      buildFactory();

      const options = {
        skip: 0,
        collection: 'responses',
        sort: {
          _initialcreatedatelocalutc: 1
        },
        includeArchived: false
      };

      return LeadDataFactory.getGridDataForForm(formId, options)
        .then(function (responseData) {
          const config = {
            startIndex: 0,
            endIndex: responseData.leadData.rawData.length - 1,
          };
          factoryData.sortedLeadsArray = responseData.leadData.rawData; // sets factory data for leads
          factoryData.formTimezone = FormMetadataFactory.getData().formProperties.formTimezone || '(GMT-00:00)'; // default to GMT if no formTimezone set
          factoryData.emailTemplate = FormMetadataFactory.getData().formProperties.emailTemplate || '';
          factoryData.parkedLeadData = responseData.parkedLeadData;

          hydrateFactory(config);

          return factoryData.timeIndeces;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function changeDate(startdate, enddate, metric) {
      // user has interacted with the UI to change the date range.

      let endIx = 0;
      
      if (factoryData.sortedLeadsArray.length) endIx = factoryData.sortedLeadsArray.length - 1;

      const config = {
        startIndex: 0,
        endIndex: endIx
      };

      if (startdate) config.startIndex = factoryData.timeIndeces[metric][startdate].start;
      if (enddate) config.endIndex = factoryData.timeIndeces[metric][enddate].end;

      emptyPresets();

      // hydrate the factory for the new date range. Data is already in factory (sortedLeadsArray).
      hydrateFactory(config);
      updateWidgets(); // factory presets have been calculcated, now process the widgets

    }

    function hydrateFactory(config) {
      const presets = ResponseAggregationModelPresets.getData();

      AggregationBuildersFactory.resetPresetCounts(presets);

      for (let i = config.startIndex, ei = config.endIndex; i <= ei; i++) {
        // the leadObj is a moving target depending on the start and end index of the report
        const leadObj = factoryData.sortedLeadsArray[i];

        const paramsObj = {
          leadObj: leadObj,
          factoryData: factoryData
        };

        AggregationBuildersFactory.convertTimestamps(paramsObj);

        _.each(presets, function (preset) {

          const values = [];
          _.each(preset.keys, function (key) {

            let val = key.value.split('.').reduce(function (a, b) {
              return a[b];
            }, leadObj);

            if (key.type == 'date') {
              // format the value as a date
              val = moment(val).format(preset.timeFormat);
            }

            if (val) {
              // push the key onto an array
              values.push(val);
            }

          });
          // concatenate the key values
          const rawValue = _.reduce(values, function (acc, curr) {
            return acc + '_' + curr;
          });

          if (typeof rawValue == 'undefined') return;

          // create the factory preset object if needed
          if (!factoryData[preset.id]) {
            factoryData[preset.id] = {};
            factoryData.arrayOfFactoryPresets.push(preset.id); // store the presets so we can empty them when necessary i.e. date range changes
          }

          if (preset.drilldown) {
            // preset requires further drilldown
            AggregationBuildersFactory.processDrillDown({ preset: preset, leadObj: leadObj, rawValue: rawValue, index: i, factoryData: factoryData });
          } else if (preset.questionWidget) {
            // preset is a question and requires specific processing
            QuestionWidgetAggregationFactory.processQuestionWidget({ preset: preset, leadObj: leadObj, rawValue: rawValue, index: i, factoryData: factoryData });
          } else if (preset.breakoutAnswers) {
            // array of answers each need individual counts (_literature)
            AggregationBuildersFactory.processBreakout({ preset: preset, leadObj: leadObj, rawValue: rawValue, index: i, factoryData: factoryData });
          } else if (preset.revenueWidget){
            RevenueWidgetAggregationFactory.processRevenueWidget({ preset: preset, leadObj: leadObj, rawValue: rawValue, index: i, factoryData: factoryData });
          } else {
            // basic count
            AggregationBuildersFactory.incrementCountAndRecordResponseId({ preset: preset, leadObj: leadObj, rawValue: rawValue, index: i, factoryData: factoryData });
          }
        }); // end presets loop
      } // end main leads loop

      factoryData.presetsBuilt = true;
    }

    function bindWidgetToFactory(widget) {
      // the entry point for any widget into the factory

      if (factoryData.arrayOfBoundWidgets.indexOf(widget) == -1) {
        widget.loading = true;
        factoryData.arrayOfBoundWidgets.push(widget);
        hydrateWidgetData(widget);
        widget.loading = false; // widget processed, turn off spinner
      }
    }

    function trimAnswers(trimLength) {
      updateWidgets(trimLength);
    }

    function updateWidgets(trimLength) {
      // loop the array of widgets that are bound to this factory
      _.each(factoryData.arrayOfBoundWidgets, function (widget) {
        hydrateWidgetData(widget, trimLength);
      });
    }

    function hydrateWidgetData(widget, trimLength) {
      // console.log('hydrateWidgetData: ', widget );
      // here is where the various different widgets part ways for slightly different building/processing of the data they hold.
      // this area would benefit greatly from refactoring to make more generic
      if (widget.id == 'busiestDay' ||
        widget.id == 'totalLeads' ||
        widget.id == 'leadsTopPerformer' ||
        widget.id == 'leadsTeamPerformance' ||
        widget.id == 'leadsByDay' ||
        widget.id == 'leadsByDayByUser' ||
        widget.id == 'revenueByDayByUser' ||
        widget.id == 'prizeDrawStatus' ||
        widget.id == 'leadsByHour') {

        PerformanceWidgetsAggregationFactory.updatePerformanceWidgets(widget, trimLength, factoryData);
        
      }

      if (widget.id == 'totalEstimatedRevenue' ||
        widget.id == 'revenueTopPerformer' ||
        widget.id == 'revenueTeamPerformance' ||
        widget.id == 'revenueByDay' ||
        widget.id == 'revenueByDayByUser' ||
        widget.id == 'revenueByHour'
      ) {

        RevenueWidgetAggregationFactory.updateRevenueWidgets(widget, trimLength, factoryData);
        
      }

      if (widget.id == 'emailEvents' ||
        widget.id == 'emailEventsGrouped' ||
        widget.id == 'deliveredVsOpened' ||
        widget.id == 'openedVsClicked' ||
        widget.id == 'emailSendsByTemplate' ||
        widget.id == 'emailsSentTotal' ||
        widget.id == 'failedTotal' ||
        widget.id == 'emailEventsGroupedByTemplate' ||
        widget.id == 'emailsSentDailyTotal') {

        EmailWidgetAggregationFactory.updateEmailWidgets(widget, trimLength, factoryData);

      }

      if (widget.id == '_parkedLeadsWidget') {
        widget.countupto = factoryData.parkedLeadData.items.length;
      }

      if (widget.query.groupBy == 'question') {
        QuestionWidgetAggregationFactory.updateQuestionWidgets(widget, trimLength, factoryData);
      }

      if (widget.id == 'showroomItemsSelected' ||
        widget.id == '_literature' ||
        widget.id == '_tagCategories' ||
        widget.id == '_tags') {
        LiteratureWidgetAggregationFactory.updateLiteratureWidgets(widget, trimLength, factoryData);
      }
    }

    function emptyPresets() {
      // empty all factory presets ready to refill
      _.each(factoryData.arrayOfFactoryPresets, function (preset) {
        for (const member in factoryData[preset]) {
          factoryData[preset][member].count = 0;
          factoryData[preset][member].arrayOfResponseIds = [];
        }
      });
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('ResponseAggregationModelPresets', factory);

  factory.$inject = ['ColumnSummaryMetadataFactory'];
  /* ng-inject */
  function factory(ColumnSummaryMetadataFactory) {

    let factoryData = {};
    buildFactory();

    return {
      resetFactory: buildFactory,
      getData: getData
    };

    function getData() {
      return factoryData;
    }

    function buildFactory() {
      factoryData = getPresets();
      const ColumWidgetPresets = ColumnSummaryMetadataFactory.getData().items;
      factoryData = factoryData.concat(ColumWidgetPresets); // merge column presets with the default presets
    }

    function getPresets() {
      return [{
        id: '_formid',
        keys: [{
          type: 'string',
          value: 'response._formid'
        }]
      }, {
        id: 'estimatedRevenue',
        revenueWidget: true,
        keys: [{
          type: 'number',
          value: 'response.estimatedRevenue'
        }]
      }, {
        id: '_initialcreatedate',
        keys: [{
          type: 'date',
          value: 'response._initialcreatedateadjusted'
        }],
        timeFormat: 'MM/DD/YY'
      }, {
        id: '_literature',
        breakoutAnswers: true,
        keys: [{
          value: 'response._literature'
        }]
      }, {
        id: 'mmddyy_user',
        timeFormat: 'MM/DD/YY',
        keys: [{
          type: 'date',
          value: 'response._initialcreatedateadjusted'
        }, {
          value: 'response._initialuser'
        }]
      }, {
        id: 'mmddyyhh',
        timeFormat: 'MM/DD/YY HH',
        keys: [{
          type: 'date',
          value: 'response._initialcreatedateadjusted'
        }]
      }, {
        id: 'emailEventsGroupedByEvent',
        breakoutAnswers: true,
        keys: [{
          type: 'event',
          value: 'response.emailEvents'
        }]
      }, {
        id: 'emailEventsGroupedByDay',
        breakoutAnswers: true,
        keys: [{
          type: 'event',
          value: 'response.emailEvents'
        }]
      }, {
        id: 'emailsSentTotal',
        breakoutAnswers: true,
        keys: [{
          value: 'response.templatesSentForForm'
        }]
      }, {
        id: 'mmddyy_template',
        breakoutAnswers: true,
        keys: [{
          value: 'response.templatesSentForForm'
        }]
      }, {
        id: 'mmddyy_email_sends',
        breakoutAnswers: true,
        keys: [{
          value: 'response.templatesSentForForm'
        }]
      }, {
        id: 'template_event',
        breakoutAnswers: true,
        keys: [{
          value: 'response.emailEvents'
        }]
      }];
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('QuestionWidgetAggregationFactory', factory);

  factory.$inject = ['AggregationBuildersFactory'];
  /* ng-inject */
  function factory(AggregationBuildersFactory) {

    var factoryData;

    return {
      processQuestionWidget: processQuestionWidget,
      updateQuestionWidgets: updateQuestionWidgets
    };

    function processQuestionWidget(paramsObj) {
      factoryData = paramsObj.factoryData;
      if (!paramsObj.rawValue.length) return;
      paramsObj.preset.answerCount++;
      if (!(Array.isArray(paramsObj.rawValue))) return processQuestionAnswer(paramsObj.rawValue, paramsObj);

      _.each(paramsObj.rawValue, function (val) {
        processQuestionAnswer(val, paramsObj);
      });
    }

    function processQuestionAnswer(val, paramsObj) {
      const answerVal = AggregationBuildersFactory.processAnswer(val);
      paramsObj.rawValue = answerVal;
      paramsObj.addCaption = true;
      AggregationBuildersFactory.incrementCountAndRecordResponseId(paramsObj);
    }

    function updateQuestionWidgets(widget, trimLength, factoryDataParam) {
      factoryData = factoryDataParam;
      // creates an array of objects with counts and captions in descending order
      var sortedAndTrimmedArray = _.chain(factoryData[widget.id])
        .reject(function (widg) {
          // weed out any answers that have a count of 0
          return widg.count === 0;
        })
        .sortBy('count') //sort on count prop
        .reverse() // reverse the order (default is ascending)
        .value(); // spit out the value (array)

      if (sortedAndTrimmedArray.length) {
        widget.isEmpty = false;
        widget.topAnswer = {
          caption: sortedAndTrimmedArray[0].caption,
          count: sortedAndTrimmedArray[0].count
        };
      } else {
        widget.isEmpty = true;
      }

      if (trimLength) {
        sortedAndTrimmedArray.splice(trimLength, sortedAndTrimmedArray.length);
        widget.subtitle = 'Top 10 Answers';
      } else {
        widget.subtitle = '';
      }
      widget.linkedResponseIds = _.map(sortedAndTrimmedArray, 'arrayOfResponseIds');
      widget.chart.labels = _.map(sortedAndTrimmedArray, 'caption');
      widget.chart.data = _.map(sortedAndTrimmedArray, 'count');
      var totalLeadsForRange = _.reduce(factoryData._initialcreatedate, function (rollingCount, obj) {
        return rollingCount + obj.count;
      }, 0);
      widget.percentageAnswered = (widget.answerCount / totalLeadsForRange) * 100 | 0;
      AggregationBuildersFactory.computeWidgetTableData(widget, sortedAndTrimmedArray);
      if (widget.chart.data.length == 1) {
        // subtracting single answer values from total number of leads for range. (to see how many didn't answer it)
        widget.chart.data.push(totalLeadsForRange - widget.chart.data[0]);
        widget.chart.labels.push('Unanswered');
      }
    }

    
  }

}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('PerformanceWidgetsAggregationFactory', factory);

  factory.$inject = ['AggregationBuilderHelperFactory', 'AggregationBuildersFactory'];

  function factory(AggregationBuilderHelperFactory, AggregationBuildersFactory) {

    var factoryData = {};

    return {
      updatePerformanceWidgets: updateWorkerWidgets,
    };

    // UPDATE WIDGETS HELPER FUNCTIONS
    function updateWorkerWidgets(widget, trimLength, factoryDataParam) {

      factoryData = factoryDataParam;

      var data = [],
        chartDataObj,
        valuesObject,
        enumerationKey,
        grouped;

      _.each(widget.query.metrics, function (metric) {
        if (trimLength && widget.id != 'leadsTopPerformer') {
          metric.limit = trimLength; // pop a limit in for the metric
          if (widget.id == 'leadsTeamPerformance') widget.subtitle = 'Top 10';
        }
        enumerationKey = AggregationBuilderHelperFactory.findEnumerationKey(metric);
        valuesObject = AggregationBuilderHelperFactory.sliceAndDiceRelevantPresetAndBuildWorkingObject(factoryData, metric, enumerationKey);
        if (widget.chart) {

          grouped = buildGroupedObjectReadyForCharting(metric, widget, valuesObject);
          chartDataObj = buildChartDataObject(grouped, metric, widget);

          if (metric.countUpToProperty) {
            widget.countupto = chartDataObj.data[0]; // getting overwritten by the form counts which only want to be added to the chart data...
            if (!widget.countupto) widget.countupto = 0;
          }
          if (metric.setWidgetProperty) {
            widget[metric.propertyToSet] = chartDataObj.labels[0];
          }
          // pushes counts onto data array for busiestDay widget chart (only widget using it)
          data.push(chartDataObj.data[0]);
        }
      });
      // end loop

      if (widget.chart) {
        widget.chart.labels = chartDataObj.labels;
        widget.chart.data = chartDataObj.data;
        widget.chart.series = chartDataObj.series;
        widget.linkedResponseIds = chartDataObj.linkedResponseIds;
      }
      widget.isEmpty = _.isEqual(valuesObject, {}) ? true : false;
      widget.limitTableSize = trimLength;
      AggregationBuildersFactory.computeWidgetTableData(widget, valuesObject);

      if (widget.id == 'busiestDay') {
        // TODO currently showing busiest half day vs all leads for that chart.
        data[1] = data[1] - data[0];
        widget.chart.data = data;
      }

    }

    function buildGroupedObjectReadyForCharting(metric, widget, valuesObject) {
      // slices grouped data i.e 10/10/19_Opened and 
      var primaryMetric, // x-axis label
        seriesMetric, // inner metric (date or person)
        grouped = {},
        split;

      _.each(valuesObject, function (obj, key) {
        // emailactivity
        if (metric.groupBy == 'mmddyy_user') {
          split = key.split('_');
          primaryMetric = split[0]; // day
          seriesMetric = split[1]; // user || activity
        }
        if (metric.groupBy == 'mmddyyhh') {
          primaryMetric = key.substring(9); // date with hr (0-24)
          seriesMetric = key.substring(0, 8); // date only dd/mm/yy
        }
        if (metric.groupBy == 'mmddyy' ||
          metric.groupBy == 'user' ||
          metric.groupBy == '_formid' ||
          metric.groupBy == '_literature' ||
          metric.groupBy == '_initialcreatedate') {
          primaryMetric = key;
          seriesMetric = 'Total';
        }

        if (!grouped[primaryMetric]) {
          grouped[primaryMetric] = {};
        }

        if (widget.chart.series) {
          grouped[primaryMetric][seriesMetric] = {
            caption: obj.caption,
            count: obj.count,
            arrayOfResponseIds: obj.arrayOfResponseIds
          };
        } else {
          grouped[primaryMetric] = {
            caption: obj.caption,
            count: obj.count,
            arrayOfResponseIds: obj.arrayOfResponseIds
          };
        }

      });

      return grouped;
    }

    function buildChartDataObject(grouped, metric, widget) {

      if (widget.id == 'leadsByHour') {
        // pre-populate hours of the day buckets
        for (var i = metric.rangeFill.min, j = metric.rangeFill.max; i < j; i++) {
          var key = ('0' + i).slice(-2);
          if (!grouped[key]) {
            grouped[key] = {};
          }
        }
      }
      var arr = _.chain(grouped)
        .map(function (obj, key) {
          var sortValue = obj[metric.sortBy];
          if (metric.sortBy == 'groupedObjectKey') {
            if (key.length == 8 && moment(key).isValid()) { // key length should be 8: mm/dd/yy
              sortValue = moment(key); // if value is a valid date then create moment date object so it sorts correctly
            } else {
              sortValue = key;
            }
          } else if (metric.sortBy === 'mmddyy') {
            sortValue = moment(key); // if value is a valid date then create moment date object so it sorts correctly
          }
          return {
            primaryLabel: key,
            members: obj,
            sortValue: sortValue
          };
        }).sortBy('sortValue')
        .value();

      if (metric.sortDirection == 'desc') {
        arr = _.sortBy(arr, 'sortValue').reverse();
      }

      if (widget.chart.series) {
        return AggregationBuilderHelperFactory.buildSeriesChartData(arr, metric);
      } else {
        return AggregationBuilderHelperFactory.buildSingleSeriesChartData(arr, metric);
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('LiteratureWidgetAggregationFactory', factory);

  factory.$inject = ['AggregationBuildersFactory', 'MessageService'];

  function factory(AggregationBuildersFactory, MessageService) {

    var factoryData;

    return {
      updateLiteratureWidgets: updateLiteratureWidgets
    };

    function updateLiteratureWidgets(widget, trimLength, aggregationFactoryData) {

      factoryData = aggregationFactoryData;

      var data = [], enumKey, valuesArray;

      try {
        _.each(widget.query.metrics, function (metric) {
          enumKey = metric.groupBy;

          if (widget.id == '_literature') {
            if (trimLength) {
              widget.subtitle = 'Top 10 Answers';
            }
            // var count = 0;
            valuesArray = _.map(factoryData[enumKey], function (doc, docId) {
              if (widget.labels[docId]) {
                return {
                  caption: widget.labels[docId].caption,
                  count: doc.count,
                  arrayOfResponseIds: doc.arrayOfResponseIds
                };
              } else {
                MessageService.writeLog({
                  level: 'error',
                  msg: 'Missing literature: ' + docId
                });
                return {
                  caption: 'Missing literature',
                  count: doc.count,
                  arrayOfResponseIds: doc.arrayOfResponseIds
                };
              }
            });
          }

          if (widget.id == 'showroomItemsSelected') {

            valuesArray = _.map(factoryData[enumKey], function (doc) {
              return {
                count: doc.count,
                arrayOfResponseIds: doc.arrayOfResponseIds
              };
            });
          }

          if (widget.id == '_tags' || widget.id == '_tagCategories') {
            if (trimLength) {
              widget.subtitle = 'Top 10 Answers';
            }
            enumKey = '_literature';
            var countsObj = {};
            _.each(widget.tagDocs, function (tagDoc) {
              _.each(tagDoc.literatureIds, function (litId) {
                if (factoryData[enumKey]) {
                  if (factoryData[enumKey][litId]) {
                    if (!countsObj[tagDoc[metric.groupBy]]) {
                      countsObj[tagDoc[metric.groupBy]] = {
                        caption: tagDoc[metric.groupBy],
                        count: factoryData[enumKey][litId].count,
                        arrayOfResponseIds: factoryData[enumKey][litId].arrayOfResponseIds
                      };
                    } else {
                      countsObj[tagDoc[metric.groupBy]].count += factoryData[enumKey][litId].count;
                      countsObj[tagDoc[metric.groupBy]].arrayOfResponseIds = countsObj[tagDoc[metric.groupBy]].arrayOfResponseIds.concat(factoryData[enumKey][litId].arrayOfResponseIds);
                    }
                  }
                }
              });
            });

            valuesArray = _.map(countsObj, function (value, key) {
              return {
                caption: key,
                count: value.count,
                arrayOfResponseIds: value.arrayOfResponseIds
              };
            });
          }

          if (metric.reduceTotalsToSingleValue) {
            // only showroom totals widget uses this
            var totalValueForGroup = _.reduce(factoryData._literature, function (a, b) {
              return a + b.count;
            }, 0);
            widget.countupto = totalValueForGroup;
          }

          if (metric.sortBy) {
            valuesArray = _.sortBy(valuesArray, metric.sortBy);
            if (metric.sortDirection == 'desc') {
              valuesArray = _.sortBy(valuesArray, metric.sortBy).reverse();
            }
          }

          if (metric.limit) {
            // how many values to add to the chart data array
            for (var i = 0, j = metric.limit; i < j; i++) {
              data.push(valuesArray[i]);
            }
          } else {
            data = valuesArray;
          }

        });
        // end loop
      } catch (e) {
        // console.log(e);
      }

      if (trimLength) {
        data.splice(trimLength, data.length);
      }
      if (widget.chart) {
        widget.chart.labels = _.map(data, 'caption');
        widget.chart.data = _.map(data, 'count');
      }
      widget.linkedResponseIds = _.map(data, 'arrayOfResponseIds');
      widget.isEmpty = valuesArray.length ? false : true;
      AggregationBuildersFactory.computeWidgetTableData(widget, valuesArray);
    }
  }
})();
(function () {
  'use strict';
  
  angular
    .module('forms')
    .factory('EmailWidgetAggregationFactory', factory);
  
  factory.$inject = ['AggregationBuildersFactory', 'AggregationBuilderHelperFactory'];
  
  function factory(AggregationBuildersFactory, AggregationBuilderHelperFactory) {
  
    var factoryData;
  
    return {
      updateEmailWidgets: updateEmailWidgets
    };

    function updateEmailWidgets(widget, trimLength, factoryDataParam) {

      factoryData = factoryDataParam;
  
      var data = [],
        chartDataObj,
        valuesObject,
        enumerationKey,
        grouped;
  
      _.each(widget.query.metrics, function (metric) {
  
        enumerationKey = AggregationBuilderHelperFactory.findEnumerationKey(metric);
        valuesObject = AggregationBuilderHelperFactory.sliceAndDiceRelevantPresetAndBuildWorkingObject(factoryData, metric, enumerationKey);
        if (widget.chart) {
          grouped = buildGroupedObjectReadyForCharting(metric, widget, valuesObject);
          chartDataObj = buildChartDataObject(grouped, metric, widget);
  
          if (metric.countUpToProperty) {
            widget.countupto = chartDataObj.data[0]; // getting overwritten by the form counts which only want to be added to the chart data...
            if (!widget.countupto) widget.countupto = 0;
          }
          if (metric.setWidgetProperty) {
            widget[metric.propertyToSet] = chartDataObj.labels[0];
          }
  
          // pushes counts onto data array for busiestDay widget chart (only widget using it)
          data.push(chartDataObj.data[0]);
        }
      });
      // end loop
  
      // bit of a dirty hack to get aggregated email counts into this report event loop
      if (widget.metadata.subCategory && widget.metadata.subCategory === 'comparison') {
        if (widget.id === 'deliveredVsOpened' || widget.id === 'openedVsClicked') {
          groupEventsForCounting();
        }
        buildComparisonWidget(widget);
      }
      if (widget.id == 'failedTotal') {
        buildFailedTotalCount(widget);
      }
  
      if (widget.chart) {
        widget.chart.labels = chartDataObj.labels;
        widget.chart.data = chartDataObj.data;
        widget.chart.series = chartDataObj.series;
        widget.linkedResponseIds = chartDataObj.linkedResponseIds;
      }
      if (widget.id === 'emailEvents') {
        widget.isEmpty = checkIfAllEventsAreZero(valuesObject);
      } else {
        widget.isEmpty = angular.equals(valuesObject, {}) ? true : false;
      }
      widget.limitTableSize = trimLength;
      AggregationBuildersFactory.computeWidgetTableData(widget, valuesObject);
  
      if (widget.id === 'emailsSentTotal') {
        var totalValueForGroup = _.reduce(factoryData.mmddyy_template, function (a, b) {
          return a + b.count;
        }, 0);
        widget.countupto = totalValueForGroup;
      }
  
    }
  
  
    // HELPERS
    function groupEventsForCounting() {
      if (!_.isEmpty(factoryData.template_event_combined_totals)) return;
      var metric = { groupBy: 'template_event' };
      var enumerationKey = AggregationBuilderHelperFactory.findEnumerationKey(metric);
      var valuesObject = AggregationBuilderHelperFactory.sliceAndDiceRelevantPresetAndBuildWorkingObject(factoryData, metric, enumerationKey);
      var groupedObject = buildGroupedObjectReadyForCharting(metric, { chart: { series: [] } }, valuesObject);
      buildGroupedEventCounts(groupedObject);
    }
    
    function buildGroupedEventCounts(groupedObject) {
      // builds the template_event_combined_totals object for delivered/opened/clicked wigets to get their counts from
  
      var combinedEvents = {
        Delivered: { count: 0 },
        Opened: { count: 0 },
        Clicked: { count: 0 },
        Failed: { count: 0 }
      };
  
      _.each(groupedObject, function (valObj, key) {
        _.each(valObj, function (val) {
          combinedEvents[key].count += val.count;
        });
      });
  
      factoryData.template_event_combined_totals = combinedEvents;
    }
  
    function checkIfAllEventsAreZero(valuesObject) {
      var isEmpty = true;
      if (valuesObject.Delivered && valuesObject.Delivered.count > 0) isEmpty = false;
      if (valuesObject.Opened && valuesObject.Opened.count > 0) isEmpty = false;
      if (valuesObject.Clicked && valuesObject.Clicked.count > 0) isEmpty = false;
      if (valuesObject.Failed && valuesObject.Failed.count > 0) isEmpty = false;
      return isEmpty;
    }
  
    function buildFailedTotalCount(widget) {
      var count = 0;
      if (factoryData.emailEventsGroupedByEvent.Failed) {
        count = factoryData.emailEventsGroupedByEvent.Failed.count;
      }
      widget.countupto = count;
      return;
    }


    function buildComparisonWidget(widget) {
      if (!factoryData[widget.comparison.grouping]) factoryData[widget.comparison.grouping] = {};
      if (!factoryData[widget.comparison.grouping][widget.comparison.figure1Field]) {
        factoryData[widget.comparison.grouping][widget.comparison.figure1Field] = {
          caption: widget.comparison.figure1Field,
          count: 0,
          arrayOfResponseIds: []
        };
      }
      if (!factoryData[widget.comparison.grouping][widget.comparison.figure2Field]) {
        factoryData[widget.comparison.grouping][widget.comparison.figure2Field] = {
          caption: widget.comparison.figure2Field,
          count: 0,
          arrayOfResponseIds: []
        };
      }
      widget.comparison.figure1 = factoryData[widget.comparison.grouping][widget.comparison.figure1Field].count;
      widget.comparison.figure2 = factoryData[widget.comparison.grouping][widget.comparison.figure2Field].count;
      if (factoryData[widget.comparison.grouping][widget.comparison.figure1Field].count === 0) {
        widget.comparison.percentage = 0;
      } else {
        widget.comparison.percentage = (factoryData[widget.comparison.grouping][widget.comparison.figure1Field].count / factoryData[widget.comparison.grouping][widget.comparison.figure2Field].count) * 100;
      }
    }

    function buildGroupedObjectReadyForCharting(metric, widget, valuesObject) {
    // slices grouped data i.e 10/10/19_Opened and 
      var primaryMetric, // x-axis label
        seriesMetric, // inner metric (date or person)
        grouped = {},
        split;

      _.each(valuesObject, function (obj, key) {
        if (metric.groupBy == 'mmddyy_event' || metric.groupBy == 'mmddyy_template') {
          split = key.split('_');
          primaryMetric = split[0]; // day
          seriesMetric = split[1]; //email template title
        }
        if (metric.groupBy == 'template_event') {
          split = key.split('_');
          primaryMetric = split[0]; // event
          seriesMetric = split[1]; // template
        }

        if (metric.groupBy == 'mmddyy' ||
        metric.groupBy == 'mmddyy_email_sends' ||
        metric.groupBy == 'eventName') {
          primaryMetric = key;
          seriesMetric = 'Total';
        }

        if (!grouped[primaryMetric]) {
          grouped[primaryMetric] = {};
        }

        if (widget.chart.series) {
          grouped[primaryMetric][seriesMetric] = {
            caption: obj.caption,
            count: obj.count,
            arrayOfResponseIds: obj.arrayOfResponseIds
          };
        } else {
          grouped[primaryMetric] = {
            caption: obj.caption,
            count: obj.count,
            arrayOfResponseIds: obj.arrayOfResponseIds
          };
        }

      });

      return grouped;
    }

    function buildChartDataObject(grouped, metric, widget) {

      var arr = _.chain(grouped)
        .map(function (obj, key) {
          var sortValue = obj[metric.sortBy];
          if (metric.sortBy == 'groupedObjectKey') {
            if (key.length == 8 && moment(key).isValid()) { // key length should be 8: mm/dd/yy
              sortValue = moment(key); // if value is a valid date then create moment date object so it sorts correctly
            } else {
              sortValue = key;
            }
          } else if (metric.sortBy === 'mmddyy') {
            sortValue = moment(key); // if value is a valid date then create moment date object so it sorts correctly
          }
          return {
            primaryLabel: key,
            members: obj,
            sortValue: sortValue
          };
        }).sortBy('sortValue')
        .value();

      if (metric.sortDirection == 'desc') {
        arr = _.sortBy(arr, 'sortValue').reverse();
      }

      if (widget.chart.series) {
        return AggregationBuilderHelperFactory.buildSeriesChartData(arr, metric);
      } else {
        return AggregationBuilderHelperFactory.buildSingleSeriesChartData(arr, metric);
      }
    }

  }
})();
(function () {
  'use strict';

  /***
   * @description This factory aggregates the data in different ways as defines by the presets for widgets to then consume and build their counts from
   */

  angular
    .module('forms')
    .factory('AggregationBuildersFactory', factory);

  factory.$inject = ['stringHelper', '$filter'];

  function factory(stringHelper, $filter) {

    var factoryData;

    return {
      incrementCountAndRecordResponseId: incrementCountAndRecordResponseId,
      processDrillDown: processDrillDown,
      processBreakout: processBreakout,
      convertTimestamps: convertTimestamps,
      processAnswer: processAnswer,
      resetPresetCounts: resetPresetCounts,
      computeWidgetTableData: computeWidgetTableData
    };

    function incrementCountAndRecordResponseId(paramsObj) {

      // sets smelly global for this factory
      factoryData = paramsObj.factoryData;

      if (!paramsObj.drilledDownValue) {
        if (!factoryData[paramsObj.preset.id][paramsObj.rawValue]) {
          factoryData[paramsObj.preset.id][paramsObj.rawValue] = {
            count: 1,
            arrayOfResponseIds: [paramsObj.leadObj.response._id]
          };
          if (paramsObj.addCaption) addCaptionToObject(paramsObj.preset, paramsObj.rawValue);
          if (paramsObj.preset.id == 'mmddyyhh' && !factoryData.presetsBuilt) {
            factoryData.timeIndeces.mmddyyhh[paramsObj.rawValue] = {
              start: paramsObj.index,
              end: paramsObj.index
            };
          }
          if (paramsObj.preset.id == '_initialcreatedate' && !factoryData.presetsBuilt) {
            factoryData.timeIndeces.mmddyy[paramsObj.rawValue] = {
              start: paramsObj.index,
              end: paramsObj.index
            };
          }
        } else {
          // check this response id isn't already in the array of response id's as only want to record one per response
          if (!factoryData[paramsObj.preset.id][paramsObj.rawValue].arrayOfResponseIds) factoryData[paramsObj.preset.id][paramsObj.rawValue].arrayOfResponseIds = [];
          if (responseAlreadyRecorded(paramsObj)) return;
          factoryData[paramsObj.preset.id][paramsObj.rawValue].arrayOfResponseIds.push(paramsObj.leadObj.response._id);
          factoryData[paramsObj.preset.id][paramsObj.rawValue].count++;

          if (paramsObj.addCaption) addCaptionToObject(paramsObj.preset, paramsObj.rawValue);
          if (paramsObj.preset.id == '_initialcreatedate' && !factoryData.presetsBuilt) {
            factoryData.timeIndeces.mmddyy[paramsObj.rawValue].end = paramsObj.index;
          }
          if (paramsObj.preset.id == 'mmddyyhh' && !factoryData.presetsBuilt) {
            factoryData.timeIndeces.mmddyyhh[paramsObj.rawValue].end = paramsObj.index;
          }
        }
      } else {
        if (!factoryData[paramsObj.preset.id][paramsObj.rawValue][paramsObj.drilledDownValue]) {
          factoryData[paramsObj.preset.id][paramsObj.rawValue][paramsObj.drilledDownValue] = {
            count: 1,
            arrayOfResponseIds: [paramsObj.leadObj.response._id]
          };
        } else {
          factoryData[paramsObj.preset.id][paramsObj.rawValue][paramsObj.drilledDownValue].count++;
          factoryData[paramsObj.preset.id][paramsObj.rawValue][paramsObj.drilledDownValue].arrayOfResponseIds.push(paramsObj.leadObj.response._id);
        }
      }
    }

    function responseAlreadyRecorded(paramsObj) {
      // stops presets from having more than one entry per response (email activity capped at 1 per person/template)
      if (paramsObj.preset.id == 'template_event' || paramsObj.preset.id == 'emailEventsGroupedByEvent') {
        var responseIdAlreadyRecorded = factoryData[paramsObj.preset.id][paramsObj.rawValue].arrayOfResponseIds.includes(paramsObj.leadObj.response._id);
        return responseIdAlreadyRecorded;
      }
    }

    function processDrillDown(paramsObj) {

      factoryData = paramsObj.factoryData;
      if (!factoryData[paramsObj.preset.id][paramsObj.rawValue]) factoryData[paramsObj.preset.id][paramsObj.rawValue] = {};

      var drilledDownValue = paramsObj.preset.drilldown.value.split('.').reduce(function (a, b) {
        return a[b];
      }, paramsObj.leadObj);
      if (paramsObj.preset.drilldown.type == 'date') {
        drilledDownValue = moment(drilledDownValue).format(paramsObj.preset.drilldown.format);
      }
      paramsObj.rawValue = drilledDownValue;
      incrementCountAndRecordResponseId(paramsObj);
    }

    function processBreakout(paramsObj) {

      factoryData = paramsObj.factoryData;

      // answer is an array and we want to break these counts apart (_literature and email stats use this at the moment)
      if (!paramsObj.rawValue.length) return;
      var valuesToIterate = angular.copy(paramsObj.rawValue);
      _.each(valuesToIterate, function (val) {
        if (paramsObj.preset.id == 'emailsSentTotal') {
          paramsObj.rawValue = val._emailTemplateId;
          incrementCountAndRecordResponseId(paramsObj);
        } else if (paramsObj.preset.id == 'mmddyy_email_sends') {
          paramsObj.rawValue = moment(val._initialcreatedatelocalutc).format('MM/DD/YY');
          incrementCountAndRecordResponseId(paramsObj);
        } else if (paramsObj.preset.id == 'mmddyy_template') {
          paramsObj.rawValue = moment(val._initialcreatedatelocalutc).format('MM/DD/YY') + '_' + $filter('zpEmailTemplateTitle')(val._emailTemplateId);
          incrementCountAndRecordResponseId(paramsObj);
        } else if (paramsObj.preset.id === 'emailEventsGroupedByDay' || paramsObj.preset.id === 'emailActivityGroupedByDay' || paramsObj.preset.id === 'emailEventsGrouped') {
          paramsObj.rawValue = moment(val.dt).format('MM/DD/YY') + '_' + val.event;
          incrementCountAndRecordResponseId(paramsObj);
        } else if (paramsObj.preset.id === 'emailEventsGroupedByEvent') {
          paramsObj.rawValue = val.event;
          incrementCountAndRecordResponseId(paramsObj);
        } else if (paramsObj.preset.id === 'template_event') {
          paramsObj.rawValue = val.event + '_' + $filter('zpEmailTemplateTitle')(val._emailTemplateId);
          incrementCountAndRecordResponseId(paramsObj);
        } else {
          paramsObj.rawValue = val;
          incrementCountAndRecordResponseId(paramsObj);
        }
      });
    }

    function convertTimestamps(paramsObj) {
      factoryData = paramsObj.factoryData;
      var timestampsAdjustedToFormTimezone = moment(stringHelper.convertDateToNeutralTimezone(paramsObj.leadObj.response._initialcreatedatelocalutc)).utcOffset(stringHelper.calcTimezoneOffset(factoryData.formTimezone)); // converting _initialcreatedatelocalutc to formTimezone format for reporting use
      paramsObj.leadObj.response._initialcreatedateadjusted = timestampsAdjustedToFormTimezone;
    }

    function addCaptionToObject(preset, value) {
      try {
        factoryData[preset.id][value].caption = preset.labels[value].caption;
      } catch (e) {
        // no label with this value so make one
        preset.labels[value] = {
          caption: value,
          code: value,
        };
      } finally {
        factoryData[preset.id][value].caption = preset.labels[value].caption;
      }
    }

    function processAnswer(val) {
      var processedVal = val.trim();
      var colonPresentInAnswer = val.indexOf(':');
      if (colonPresentInAnswer != -1) {
        processedVal = val.split(':', 1)[0];
      }
      return processedVal;
    }

    function resetPresetCounts(presets) {
      _.each(presets, function (preset) {
        if (preset.answerCount) {
          preset.answerCount = 0;
        }
      });
    }

    function computeWidgetTableData(widget, valuesObject) {
      // put data into format for table to consume
      widget.tableData = _.chain(valuesObject)
        .map(function (valueObj) {
          return {
            count: valueObj.count,
            caption: valueObj.caption
          };
        })
        .sortBy('count')
        .reverse()
        .value();
      if (widget.limitTableSize) {
        // var tableLimit = figureOutHowManyRowsToDisplayInTotalsTable(widget.chart.labels.length);
        widget.tableData.splice(widget.limitTableSize, widget.tableData.length);
      }
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpSideChartFormsHome', {
      templateUrl: 'app/forms/main-page/widget-container/widget-container.tmpl.html',
      controller: 'FormsHomeSideChartsCtrl',
      bindings: {}
    })
    .controller('FormsHomeSideChartsCtrl', controller);

  controller.$inject = ['ChartsFactory', 'ChartsExportFactory', 'MessageService', 'FormsFactory', 'localStorageService'];
  /* ng-inject */
  function controller(ChartsFactory, ChartsExportFactory, MessageService, FormsFactory, localStorage) {

    var vm = this;
    vm.bucketLoading = false;
    vm.loading = true;
    vm.showTitle = true;
    vm.chartInfo = {
      total: 0,
      weektotal: 0,
      metadata: {
        title: 'Total leads chart loading...',
        subtitle: 'COUNTING LEADS'
      },
      chartOptions: {
        legend: { display: false }
      }
    };
    vm.currentSchema = 'Days';
    vm.pickerSchema = 'day';

    vm.aggregatedResponses = ChartsFactory.getChartOptions();
   
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    
    vm.customRange = {
      startdate: new Date(),
      enddate: new Date(),
      maxdate: tomorrow
    };

    vm.mindate = new Date(moment('01/01/2000'));

    vm.$onInit = function () {
      getChartData();
      vm.data = FormsFactory.factoryData.dateSortedArrays;
      vm.blankSlate = (vm.data.previous.items.length == 0 && vm.data.current.items.length == 0 && vm.data.upcoming.items.length == 0);
    };

    function getChartData() {
      const chartParams = localStorage.get('aggregated_responses');
      if (chartParams) {
        if (!chartParams.currentSchema) chartParams.currentSchema = vm.currentSchema;
        return getChartDataFor(chartParams.chartId, new Date(chartParams.rangeStart), new Date(chartParams.rangeEnd), chartParams.currentSchema);
      }

      const initParams = {
        chartId: 'aggregated_responses',
        rangeStart: getPreviousMonthDate(),
        rangeEnd: daysAgoToDate(0),
        currentSchema: vm.currentSchema
      };
      vm.showTitle = true;
      return getChartDataFor(initParams.chartId, new Date(initParams.rangeStart), new Date(initParams.rangeEnd), initParams.currentSchema);
    }

    function setLocalStorage(chartId, rangeStart, rangeEnd, schema) {
      localStorage.set(chartId, { chartId: chartId, rangeStart: rangeStart, rangeEnd: rangeEnd, currentSchema: schema });
    }

    function getChartDataFor(chartId, rangeStart, rangeEnd, schema) {
      vm.currentSchema = schema;
      ChartsFactory.getChartData(chartId, rangeStart, rangeEnd, null, schema)
        .then(function (res) {
          setLocalStorage(chartId, rangeStart, rangeEnd, schema);
          vm.customRange.startdate = rangeStart;
          vm.customRange.enddate = rangeEnd;
          vm.chartInfo = _.extend(vm.chartInfo, res);
          vm.chartInfo.metadata.title = buildTitle();
          vm.chartInfo.chartOptions = {
            legend: {}
          };
          vm.loading = false;
          vm.bucketLoading = false;
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    }

    function buildTitle() {
      let correctSchemaTense = vm.currentSchema.toLowerCase();
      if (vm.chartInfo.labels.length == 1) correctSchemaTense = correctSchemaTense.substring(0, correctSchemaTense.length - 1);
      return 'Total leads for past ' + vm.chartInfo.labels.length + ' ' + correctSchemaTense;
    }

    vm.changeChartRange = function (parameters) {
      // menu callback function
      if (parameters.selectedMenuItem.menuCommand == 'Export') {
        //export here
        ChartsExportFactory.downloadChartExport(vm.customRange.startdate, vm.customRange.enddate, null, vm.currentSchema, 'aggregated_responses', 'Events');
      }
      else {
        vm.bucketLoading = true;
        vm.showCustomDates = true;
        vm.showTitle = true;
        vm.currentSchema = parameters.selectedMenuItem.menuCommand;
        getChartDataFor('aggregated_responses', vm.customRange.startdate, vm.customRange.enddate, vm.currentSchema);
        if (vm.currentSchema == 'Months' || vm.currentSchema == 'Quarters' || vm.currentSchema == 'Years') {
          vm.pickerSchema = 'month';
        }
        else {
          vm.pickerSchema = 'day';
        }
      }
    };

    vm.applyCustomDates = function () {
      vm.bucketLoading = true;
      vm.customRange.startdate = new Date(moment(vm.customRange.startdate).startOf('day').toISOString());
      vm.customRange.enddate = new Date(moment(vm.customRange.enddate).endOf('day').toISOString());
      getChartDataFor('aggregated_responses', vm.customRange.startdate, vm.customRange.enddate, vm.currentSchema);
    };

    function daysAgoToDate(days) {
      const date = moment().subtract(days, 'days').startOf('day');
      return new Date(date);
    }

    function getPreviousMonthDate() {
      const date = moment().subtract(1, 'months').add(1, 'days').startOf('day');
      return new Date(date);
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpFormsSearchToolbar', {
      templateUrl: 'app/forms/main-page/search-toolbar/tmpl.html',
      controller: 'FormSearchToolbarCtrl',
      bindings: {}
    })
    .controller('FormSearchToolbarCtrl', controller);

  controller.$inject = ['FormsFactory', 'MessageService', 'FormListMetadata', 'localStorageService'];
  /* ng-inject */
  function controller(FormsFactory, MessageService, FormListMetadata, localStorageService) {

    var vm = this;

    vm.$onInit = function () {
      vm.metadata = FormListMetadata.getData();
      vm.hideArchivedForms = localStorageService.get('hideArchivedForms');
    };
    vm.openPostShowEmailSendDialog = function () {
      var dialogConfig = {
        controller: ExportCSVDialogCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'app/forms/main-page/dialogs/export-csv-dialog/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: null,
        clickOutsideToClose: true,
        locals: {
          
        }
      };

      MessageService.showDialog(null, dialogConfig);
    };

    vm.onMenuClick = function (args) {
      if (args.action === 'toggleShowArchived') {
        vm.hideArchivedForms = !vm.hideArchivedForms;
        FormsFactory.toggleShowArchivedSwitch(vm.hideArchivedForms);
      } else if (args.action === 'toggleShowParked'){
        FormsFactory.toggleShowParkedColumn(vm.metadata.widgets);
      } else if (args.action === 'exportCSV'){
        vm.openPostShowEmailSendDialog();
      }
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpFormsMainPage', {
      templateUrl: 'app/forms/main-page/form-main-page-component/forms.main.tmpl.html',
      controller: 'zpFormsMainController'
    })
    .controller('zpFormsMainController', zpFormsMainController);

  zpFormsMainController.$inject = ['FormListMetadata', 'FormsFactory', 'localStorageService', '$timeout', 'MasterPermissionsDefinitionFactory', 'SearchValFactory'];
  /* ng-inject */
  function zpFormsMainController(FormListMetadata, FormsFactory, localStorageService, $timeout, MasterPermissionsDefinitionFactory, SearchValFactory) {

    var vm = this;

    vm.leadsThisMonth = 0;
    vm.leadsThisWeek = 0;

    vm.$onInit = function () {
      vm.search = SearchValFactory.get('forms_main');
      vm.metadata = FormListMetadata.getData();

      showParkedLeadCountColumnCheck();
      vm.data = FormsFactory.factoryData.dateSortedArrays;
      vm.dataForSideCharts = {
        current: {
          items: vm.data.current.items
        }
      };
      vm.permissions = MasterPermissionsDefinitionFactory;
    };

    function showParkedLeadCountColumnCheck() {
      var hideParkedColumn = localStorageService.get('hideParkedColumn') || false;
      var parkedLeadColumnCurrent = _.find(vm.metadata.widgets.current.columnsData.items, function (column) {
        return column.databasefieldname === 'parkedcount';
      });
      var parkedLeadColumnUpcoming = _.find(vm.metadata.widgets.upcoming.columnsData.items, function (column) {
        return column.databasefieldname === 'parkedcount';
      });
      var parkedLeadColumnPrevious = _.find(vm.metadata.widgets.previous.columnsData.items, function (column) {
        return column.databasefieldname === 'parkedcount';
      });
      parkedLeadColumnCurrent.showCol = !hideParkedColumn;
      parkedLeadColumnUpcoming.showCol = !hideParkedColumn;
      parkedLeadColumnPrevious.showCol = !hideParkedColumn;

    }


    vm.blankSlate = function () {
      return vm.data.previous.items.length == 0 && vm.data.current.items.length == 0 && vm.data.upcoming.items.length == 0;
    };

    vm.showCardCheck = function (arrayName) {
      return vm.data[arrayName].items.length;
    };




  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('FormListMetadata', FormListMetadata);

  FormListMetadata.$inject = ['localStorageService'];
  /* ng-inject */
  function FormListMetadata(localStorageService) {

    var factoryData = {};
    buildFactory();

    return {
      getData: getData
    };

    function getData() {
      return factoryData;
    }

    // PRIVATE

    function buildFactory() {
      factoryData = {
        id: 'forms_main',
        title: {
          label: 'Events',
          editable: false,
          filterLabel: 'Filter events'
        },
        widgets: {
          previous: {
            id: 'previous_forms_list',
            title: 'Previous Events',
            columnsData: buildColumnsData(),
            query: buildQuery(),
            paginationOptions: buildPaginationOptions(),
            gridOptions: buildGridOptions()
          },
          current: {
            id: 'current_forms_list',
            title: 'Current Events',
            columnsData: buildColumnsData(),
            query: buildQuery(),
            paginationOptions: buildPaginationOptions(),
            gridOptions: buildGridOptions()
          },
          upcoming: {
            id: 'upcoming_forms_list',
            title: 'Upcoming Events',
            columnsData: buildColumnsData(),
            query: buildQuery(),
            paginationOptions: buildPaginationOptions(),
            gridOptions: buildGridOptions()
          }
        },
        columnsData: buildColumnsData(),
        fabDialogConfig: {
          description: 'New Event',
          controller: 'AddFormDialogController as vm',
          templateUrl: 'app/forms/main-page/add-form-dialog.tmpl.html',
          locals: {},
          ariaLabel: 'Create new event'
        },
        menuOptions: [{
          onClick: 'toggleShowArchived',
          ariaLabel: function () {
            return 'Toggle Archived Forms';
          },
          icon: function () {
            return localStorageService.get('hideArchivedForms') ? 'zmdi zmdi-eye' : 'zmdi zmdi-eye-off';
          },
          label: function () {
            return localStorageService.get('hideArchivedForms') ? 'Show Archived Events' : 'Hide Archived Events';
          }
        }, {
          onClick: 'toggleShowParked',
          ariaLabel: function () {
            return 'toggle show parked leads column';
          },
          icon: function () {
            return 'zmdi zmdi-parking';
          },
          label: function(){
            return localStorageService.get('hideParkedColumn') ? 'Show Parked Lead Counts' : 'Hide Parked Lead Counts';
          }
        },
        {
          onClick: 'exportCSV',
          ariaLabel: function () {
            return 'download event stats';
          },
          icon: function () {
            return 'zmdi zmdi-download';
          },
          label: function(){
            return 'Download Event Stats';
          }
        }]
      };
    }

    function buildQuery() {
      return {
        order: {
          id: 'form._lastmodifiedonservertime',
          expression: '-form._lastmodifiedonservertime.raw'
        },
        limit: undefined,
        page: 1
      };
    }

    function buildPaginationOptions() {
      return {
        boundaryLinks: true,
        limitSelect: true,
        pageSelect: true,
        pagination: true,
        limitOptions: [5, 10, 20, 50, 75, 100],
        limit: undefined,
        page: 1
      };
    }

    function buildGridOptions() {
      return {
        rowSelection: false,
        multiSelect: false,
        sortable: true,
        interactive: false
      };
    }

    function buildColumnsData() {
      return {
        primaryIdentifier: {
          object: 'form',
          field: '_id'
        },
        items: [{
          object: 'form',
          databasefieldname: 'icn',
          label: 'Status',
          showCol: true,
          type: 'Status',
          cellFilter: 'gridButton',
          sortOn: 'rawValue'
        }, {
          object: 'form',
          databasefieldname: 'formname',
          type: 'Textfield',
          name: 'formname',
          label: 'Event name',
          showCol: true,
          sortOn: 'rawValue',
        }, {
          object: 'form',
          databasefieldname: 'startdate',
          label: 'Start date',
          showCol: true,
          sortOn: 'rawValue',
          cellDefaultValue: 0,
          cellFilter: 'zpDateDDMMMyy'
        }, {
          object: 'form',
          databasefieldname: 'enddate',
          label: 'End date',
          showCol: true,
          sortOn: 'rawValue',
          cellDefaultValue: 0,
          cellFilter: 'zpDateDDMMMyy'
        }, {
          object: 'form',
          databasefieldname: 'responsecount',
          label: 'Leads',
          showCol: true,
          sortOn: 'rawValue',
          cellDefaultValue: 0
        }, {
          object: 'form',
          databasefieldname: 'parkedcount',
          label: '🅿️',
          showCol: true,
          sortOn: 'rawValue',
          cellDefaultValue: 0
        }, {
          object: 'form',
          databasefieldname: 'pastPresentFuture',
          label: 'ppf',
          showCol: false
        }, {
          object: 'form',
          databasefieldname: 'isAvailableAsFormTemplate',
          label: 'template',
          showCol: false
        }, {
          object: 'form',
          databasefieldname: 'emailTemplate',
          label: 'emailTemplate',
          showCol: false
        }]
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpFormList', {
      templateUrl: 'app/forms/main-page/form-list-component/form-list.tmpl.html',
      controller: 'zpFormListCtrl',
      bindings: {
        data: '<',
        metadata: '<',
        searchVal: '<',
      }
    })
    .controller('zpFormListCtrl', zpFormListCtrl);

  zpFormListCtrl.$inject = ['$state', 'PaginationManager', '$timeout', 'EncodingService', '$rootScope'];
  /* ng-inject */
  function zpFormListCtrl($state, PaginationManager, $timeout, encoder, $rootScope) {

    var vm = this;

    vm.$onInit = function () {
      vm.loading = true;
      $timeout(function () {
        vm.loading = false;
      }, 500);
      configurePagination();
    };

    function configurePagination() {
      var pageSize = 10000;
      vm.metadata.query.limit = pageSize;
      vm.metadata.paginationOptions.limit = pageSize;
      PaginationManager.setQuery(vm.metadata.query, vm.metadata.id);
    }

    vm.goto = function (formid) {
      if ($rootScope.loading) return;
      $state.go('app.tabbed_app_framework.single_form.dashboard', { _id: encoder.encode(formid) }, {reload: true});
    };

    vm.logPagination = function (page, limit) {
      PaginationManager.setQuery({
        page: page,
        limit: limit
      }, vm.metadata.id);
      $('md-content').animate({ scrollTop: 0 }, 0);
    };
    // end pagination and sort

  }

}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpFormsMainPageFab', {
      templateUrl: 'app/forms/main-page/fab/fab.tmpl.html',
      controller: 'zpFormsMainController'
    });

})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('PollServerForPushDocs', factory);

  factory.$inject = ['GridAPI'];
  /* ng-inject */
  function factory(GridApi) {
    return function (arrayOfResponses, options) {
      const queryObj = buildQuery(arrayOfResponses, options);
      return GridApi.getDistilledIntegrationStates(queryObj)
        .then(function (res) {
          return res;
        })
        .catch(function (err) {
          throw err;
        });
    };

    function buildQuery(responses, options) {
      const arrayOfDocsWithResponseIds = _.map(responses, function (doc) {
        return {
          _id: doc[options.responseIdKey]
        };
      });
      return {
        responseIds: arrayOfDocsWithResponseIds
      };
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('ShowLeadReleaseHistory', factory);

  factory.$inject = ['MessageService', 'GridAPI', 'CellInteractionFactory'];
  /* ng-inject */
  function factory(MessageService, GridApi, CellInteractionFactory) {

    return function (ev, leadData) {
      CellInteractionFactory.closeRelevantDialog();

      if (leadHasPushDocsToFetch(leadData)) {
        return GridApi.getPushAttemptDocs({
          responseId: leadData.response._id
        })
          .then(function (res) {
            showDialog(ev, res, leadData);
          })
          .catch(function (err) {
            throw (err);
          });
      } else {
        Promise.resolve(showDialog(ev, {}, leadData));
      }
    };

    function leadHasPushDocsToFetch(leadData) {
      return (leadData.response._integrationState !== 'unreleased');
    }

    function showDialog(ev, res, leadData) {
      MessageService.showDialog(ev, {
        controller: 'PushHistoryDialogCtrl as $ctrl',
        templateUrl: 'app/forms/lead-release-grid/dialogs/push-history/dialog.tmpl.html',
        locals: {
          res: res,
          leadData: leadData
        },
        clickOutsideToClose: true
      })
        .then(function () {})
        .catch(function () {});
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('EmbellishReleaseAttempts', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    return function aggregateData(data) {
      return Promise.resolve({
        embellishedReleaseAttempts: embellishReleaseAttemtps(data)
      });
    };

    function embellishReleaseAttemtps(arrayOfResponses) {
      let arrayOfOrderedReleaseAttempts = [];
      const mainResponse = _.find(arrayOfResponses, function (response) {
        // find the main response amongst the push doc responses
        return response._releaseAttempts;
      });
      if (mainResponse) {
        arrayOfOrderedReleaseAttempts = _.chain(mainResponse._releaseAttempts)
          .map(function (ra) {
            ra.showDetail = false;
            ra.pushDocs = buildDocs(ra._id, arrayOfResponses);
            return ra;
          })
          .sortBy('dt')
          .reverse()
          .value();
        arrayOfOrderedReleaseAttempts[0].showDetail = true;
      }
      return arrayOfOrderedReleaseAttempts;
    }

    function buildDocs(releaseAttemptId, docs) {
      return _.filter(docs, function (doc) {
        return doc._releaseAttemptId == releaseAttemptId;
      });
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpLeadStatusBtn', {
      templateUrl: 'app/forms/lead-release-grid/lead-status-btn/tmpl.html',
      controller: 'LeadStatusBtnCtrl',
      bindings: {
        clickCallback: '&',
        responseId: '<'
      }
    })
    .controller('LeadStatusBtnCtrl', ctrl);

  ctrl.$inject = ['GridDataFactory', 'ShowLeadReleaseHistory'];
  /* ng-inject */
  function ctrl(GridDataFactory, ShowLeadReleaseHistory) {

    var vm = this;

    vm.$onInit = function () {

      let leadId = vm.responseId;
      if (_.isObject(leadId) && _.has(leadId, 'raw')) {
        leadId = _.get(vm, 'responseId.raw');
      }

      vm.leadData = GridDataFactory.locateCellRowDataById(leadId, 'lead_release');
      vm.iconFill = iconFill;
      iconFill();
    };

    function iconFill() {
      if (vm.leadData) {
        if (_.isUndefined(vm.leadData.response._integrationState)) {
          return '';
        } else if (
          vm.leadData.response._integrationState === 'locked' ||
          vm.leadData.response._integrationState === 'lockLeads' ||
          vm.leadData.response._integrationState === 'unreleased' ||
          vm.leadData.response._integrationState === 'unlockLeads' ||
          vm.leadData.response._integrationState === 'indeterminate' ||
          vm.leadData.response._integrationState === 'unlocked') {
          return {
            fill: '#949CA1'
          };
        } else if (vm.leadData.response._integrationState === 'released' ||
          vm.leadData.response._integrationState === 'processed') {
          // a CSS class rule sets the colour in this instance
          return {
            fill: '#5B88B5'
          };
        } else if (vm.leadData.response._integrationState === 'failed' ||
          vm.leadData.response._integrationState === 'no-machines-ran' ||
          vm.leadData.response._integrationState === 'mixed' ||
          vm.leadData.response._integrationState === 'timedOut') {
          return {
            fill: '#F99D33'
          };
        } else if (vm.leadData.response._integrationState === 'waiting') {
          return {
            fill: '#78cdd1'
          };
        } else if (vm.leadData.response._integrationState === 'queued') {
          return {
            fill: '#78cdd1'
          };
        }
      }
    }

    vm.cellClick = function (ev) {
      ShowLeadReleaseHistory(ev, vm.leadData);
    };
  }

}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('LeadReleaseToolbarFactory', factory);

  factory.$inject = ['ReleaseLeadsFactory', 'GridDataFactory', 'ChangeDelta'];
  /* ng-inject */
  function factory(ReleaseLeadsFactory, GridDataFactory, ChangeDelta) {

    return {
      releaseLeads: releaseLeads,
      clearSelectedArray: clearSelectedArray,
      changeDelta: ChangeDelta
    };

    function clearSelectedArray(widgetId) {
      GridDataFactory.clearSelectedArray(widgetId);
    }

    function releaseLeads(ev, selectedRows, action) {
      const params = {
        selectedRows: selectedRows,
        action: action
      };
      return ReleaseLeadsFactory(ev, params)
        .then(function () {
          clearSelectedArray('lead_release');
        })
        .catch(function () {
          // clearSelectedArray('lead_release');
        });
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpLeadReleaseToolbar', {
      templateUrl: 'app/forms/lead-release-grid/lead-release-toolbar/tmpl.html',
      controller: 'LeadReleaseToolbarCtrl',
      bindings: {
        buttons: '<'
      }
    })
    .controller('LeadReleaseToolbarCtrl', controller);

  controller.$inject = ['LeadReleaseToolbarFactory', 'GridDataFactory'];
  /* ng-inject */
  function controller(LeadReleaseToolbarFactory, GridDataFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.gridIsDirty = LeadReleaseToolbarFactory.changeDelta.isDirty;
      vm.data = GridDataFactory.getDataForGrid('lead_release');
    };

    vm.prepareAndDispatchServerShuttle = function (ev, action) {
      if (!vm.disableToolbarButtons) {
        vm.disableToolbarButtons = true;
        
        LeadReleaseToolbarFactory.releaseLeads(ev, vm.data.selectedItems, action)
          .then(function () {
            vm.disableToolbarButtons = false;
          })
          .catch(function () {
            vm.disableToolbarButtons = false;
          });
      }
    };

    vm.clearSelectedCheckboxClicked = function () {
      LeadReleaseToolbarFactory.clearSelectedArray('lead_release');
    };

    vm.unlockButtonShouldBeVisible = function () {
      // we only show the unlock button if there's at least 1 locked lead in the selection
      const atLeastOneSelectedLeadIsLocked = _.find(vm.data.selectedItems, function (item) {
        return item.response._integrationState === 'locked';
      });
      return atLeastOneSelectedLeadIsLocked;
    };

    vm.releaseButtonDisabled = function () {
      return (vm.unlockButtonShouldBeVisible() && vm.gridIsDirty);
    };
  }
}());

(function () {
  'use strict';

  angular.module('forms')
    .factory('IntegrationHeadlineWidgetsMetaData', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    return function getWidgets() {
      return [{
        name: 'total',
        datakey: 'totalLeads',
        countupto: 0,
        icon: 'zmdi zmdi-inbox'
      }, {
        name: 'locked',
        datakey: 'lockedLeads',
        countupto: 0,
        icon: 'zmdi zmdi-lock'
      }, {
        name: 'unreleased',
        datakey: 'unreleasedLeads',
        countupto: 0,
        icon: 'zmdi zmdi-cloud-off'
      }, {
        name: 'queued',
        datakey: 'queuedLeads',
        countupto: 0,
        icon: 'zmdi zmdi-hourglass-outline'
      }, {
        name: 'issues',
        datakey: 'leadsWithIssues',
        countupto: 0,
        icon: 'zmdi zmdi-alert-triangle'
      }, {
        name: 'indeterminate',
        datakey: 'indeterminateLeads',
        countupto: 0,
        icon: 'zmdi zmdi-help'
      }, {
        name: 'processed',
        datakey: 'processedLeads',
        countupto: 0,
        icon: 'zmdi zmdi-cloud-done'
      }];
    };
  }
}());

(function () {
  'use strict';

  /**
  this factory is used at both page load to make the initial counts and used when the server is polled after a release action

  */
  angular.module('forms')
    .factory('IntegrationHeadlineWidgetsData', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    const factoryData = {
      totalLeads: {
        count: 0,
        icon: 'inbox'
      },
      lockedLeads: {
        count: 0,
        icon: 'lock'
      },
      unreleasedLeads: {
        count: 0,
        icon: 'cloud_off'
      },
      queuedLeads: {
        count: 0,
        icon: 'hourglass_empty'
      },
      leadsWithIssues: {
        count: 0,
        icon: 'warning'
      },
      indeterminateLeads: {
        count: 0,
        icon: 'foo'
      },
      processedLeads: {
        count: 0,
        icon: 'cloud_done'
      }
    };

    return {
      setInitialWidgetCounts: setInitialWidgetCounts,
      updateIntegrationWidgetCounts: updateIntegrationWidgetCounts,
      factoryData: factoryData
    };

    function setInitialWidgetCounts(rawLeadData) {
      resetCounts();
      factoryData.totalLeads.count = rawLeadData.length;
      setCounts(rawLeadData);
    }

    function updateIntegrationWidgetCounts(rawLeadData) {
      resetCounts();
      factoryData.totalLeads.count = rawLeadData.length; // shouldn't this be updated here too?
      setCounts(rawLeadData);
    }

    function setCounts(rawLeadData) {
      _.each(rawLeadData, function (lead) {
        incrementAppropriateCount(lead.response);
      });
    }

    function incrementAppropriateCount(response) {
      if (!response._distilledIntegrationState || !response._integrationState) return;
      if (response._distilledIntegrationState.locked) factoryData.lockedLeads.count += 1;
      if (!response._distilledIntegrationState.released) factoryData.unreleasedLeads.count += 1;
      if (response._integrationState === 'waiting' ||
        response._integrationState === 'queued') {
        factoryData.queuedLeads.count += 1;
        if (factoryData.queuedLeads.icon === 'hourglass_empty') {
          factoryData.queuedLeads.icon = 'hourglass_full';
        } else {
          factoryData.queuedLeads.icon = 'hourglass_empty';
        }
      }
      if (response._distilledIntegrationState.issue) factoryData.leadsWithIssues.count += 1;
      if (response._distilledIntegrationState.mixed) factoryData.leadsWithIssues.count += 1;
      if (response._distilledIntegrationState.indeterminate) factoryData.indeterminateLeads.count += 1;
      if (response._distilledIntegrationState.processed) factoryData.processedLeads.count += 1;
    }

    function resetCounts() {
      factoryData.lockedLeads.count = 0;
      factoryData.queuedLeads.count = 0;
      factoryData.leadsWithIssues.count = 0;
      factoryData.unreleasedLeads.count = 0;
      factoryData.indeterminateLeads.count = 0;
      factoryData.processedLeads.count = 0;
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpIntegrationHeadlineWidget', {
      templateUrl: 'app/forms/lead-release-grid/integration-headline-widget/tmpl.html',
      controller: 'zpIntegrationHeadlineWidgetCtrl',
      bindings: {
        widgetData: '<'
      }
    })
    .controller('zpIntegrationHeadlineWidgetCtrl', controller);

  controller.$inject = ['IntegrationHeadlineWidgetsData'];
  /* ng-inject */
  function controller(IntegrationHeadlineWidgetsData) {

    var vm = this;
    vm.$onInit = function () {
      vm.factoryData = IntegrationHeadlineWidgetsData.factoryData;
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpParkedLeadGrid', {
      controller: 'ParkedLeadsCtrl',
      templateUrl: 'app/forms/grid-page/parked-lead-grid/zp-parked-lead-grid.tmpl.html',
      bindings: {}
    })
    .controller('ParkedLeadsCtrl', ctrl);

  ctrl.$inject = ['MessageService', 'PaginationManager', 'GridDataFactory', '$state', 'LeadDataFactory', 'FormMetadataFactory', 'EncodingService', 'GridMetaDataFactory', 'localStorageService', 'PermPermissionStore', 'DeleteAResponseColumn'];
  /* ng-inject */
  function ctrl(MessageService, PaginationManager, GridDataFactory, $state, LeadDataFactory, FormMetadataFactory, encoder, GridMetaDataFactory, localStorage, PermPermissionStore, DeleteAResponseColumn) {

    var vm = this;

    vm.$onInit = function () {

      vm.metadata = angular.copy(FormMetadataFactory.getData());
      vm.title = vm.metadata.formProperties.formname;
      vm.metadata.toolbarButtons.showEdit = true;
      vm.metadata.toolbarButtons.showUnpark = true;
      vm.metadata.toolbarButtons.showParkedLeads = false;
      vm.metadata.toolbarButtons.showLeadBreakout = false;
      vm.metadata.toolbarButtons.showDataRefreshButton = false;

      vm.metadata.id = 'parked_leads';
      vm.metadata.csvFileLabel = 'parked_leads_report';
      vm.widgetId = 'parked_leads';

      gridEditPermissionsCheck(vm.metadata); // another check of users permissions to see if they have sufficient privs to edit the grid
      
      GridMetaDataFactory.hydrateData(vm.metadata.columnsData, vm.metadata.id);
      vm.data = GridDataFactory.getDataForGrid(vm.metadata.id);
      vm.totalRows = vm.data.length;
      PaginationManager.setQuery(vm.metadata.query, vm.metadata.id);
      columnsTidyUp();

      vm.hideHelpToolbar = localStorage.get('hideParkedLeadHelpToolbar');
      pingEventToIntercom();
    };

    vm.setHideHelpToolbar = function (){
      localStorage.set('hideParkedLeadHelpToolbar', true);
      vm.hideHelpToolbar = true;
    };

    vm.goBack = function () {
      $state.go('app.tabbed_app_framework.single_form.grid', {
        _id: encoder.encode(LeadDataFactory.getData()._formid)
      });
    };

    vm.logPagination = function (page, limit) {
      PaginationManager.setQuery({
        page: page,
        limit: limit
      }, vm.metadata.id);
      $('md-content').animate({ scrollTop: 0 }, 0);
    };

    function pingEventToIntercom(){
      MessageService.pushEventToIntercom('accessed_park_lead_grid', {
        parkedLeadCount: vm.data.items.length,
        formname: vm.title
      });
      MessageService.updateIntercom();
    }

    function gridEditPermissionsCheck(metadata) {
      const gridEditPerm = PermPermissionStore.getPermissionDefinition('LEADS_EDITGRID');
      gridEditPerm.validatePermission()
        .then(function () {
          metadata.gridOptions.rowSelection = true;
          metadata.gridOptions.multiSelect = true;
          metadata.gridOptions.interactive = true;
        })
        .catch(function () {
          metadata.gridOptions.rowSelection = false;
          metadata.gridOptions.multiSelect = false;
          metadata.gridOptions.interactive = false;
        });
    }

    function columnsTidyUp() {
      DeleteAResponseColumn(vm.metadata.columnsData, '_aiProfile');
      DeleteAResponseColumn(vm.metadata.columnsData, '_leadIsValid');
      DeleteAResponseColumn(vm.metadata.columnsData, '_parkedlead');
      DeleteAResponseColumn(vm.metadata.columnsData, '_integrationState');
      DeleteAResponseColumn(vm.metadata.columnsData, '_distilledIntegrationState');
      DeleteAResponseColumn(vm.metadata.columnsData, '_latestDetailedReleaseAttempt');
    }

  }
}());

/**
 * Created by davidbeazer on 31/05/2017.
 */
(function () {
  'use strict';

  angular
    .module('forms')
    .factory('DownloadsFactory', factory);

  factory.$inject = ['DownloadLeadDataToCSV', 'DownloadLeadDataToXLSX'];
  /* ng-inject */
  function factory(DownloadLeadDataToCSV, DownloadLeadDataToXLSX) {

    return {
      downloadLeads: DownloadLeadDataToCSV,
      downloadLeadBreakoutReport: DownloadLeadDataToCSV,
      downloadLeadsAsExcel: DownloadLeadDataToXLSX,
      downloadLeadBreakoutReportAsExcel: DownloadLeadDataToXLSX
    };

  }
})();

/**
 * Created by davidbeazer on 27/09/2016.
 */
/**
 * The email template tool
 * @module email
 */

(function() {
  'use strict';

  angular
    .module('email', ['ui.router', 'common', 'zp.api', 'zp.encoding', 'zp.env', 'ck']);
})();

(function () {
  'use strict';

  angular
    .module('email')
    .controller('ConfirmArchiveEmailTemplate', ctrl);

  ctrl.$inject = ['MessageService', 'EmailTemplatesFactory', 'CurrentTemplateFactory'];
  /* ng-inject */
  function ctrl(MessageService, EmailTemplatesFactory, CurrentTemplateFactory) {

    var vm = this;

    EmailTemplatesFactory.getFormsListCached()
      .then(function (res) {
        vm.forms = res.formsList;
      });

    vm.currentEmailTemplateId = CurrentTemplateFactory.getCurrentTemplateCache()._id;
    
    vm.cancelDialog = function (){
      MessageService.cancelDialog();
    };

    vm.continueArchiving = function (){
      MessageService.closeDialog();
    };
  }
}());

/**
 * Created by Dave Beazer on 18/12/2015.
 */
angular
  .module('email')
  .controller('FormsUsedDialogController', FormsUsedDialogController);
FormsUsedDialogController.$inject = ['$scope', '$mdDialog', 'EmailTemplatesFactory', 'CurrentTemplateFactory', 'MessageService'];
/* @ngInject */
function FormsUsedDialogController($scope, $mdDialog, EmailTemplatesFactory, CurrentTemplateFactory, MessageService) {

  var vm = this;
  vm.forms = [];
  vm.toggleEmailTemplateForForm = toggleEmailTemplateForForm;

  vm.$onInit = function () {
    EmailTemplatesFactory.getFormsListCached()
      .then(function (res) {
        vm.forms = res.formsList;
      });

    vm.currentEmailTemplateId = CurrentTemplateFactory.getCurrentTemplateCache()._id;
    vm.templateTitle = CurrentTemplateFactory.getCurrentTemplateCache().title;
  };

  vm.hide = function () {
    $mdDialog.hide();
  };

  vm.cancel = function () {
    $mdDialog.cancel();
  };

  vm.answer = function () {
    $mdDialog.hide();
  };

  function toggleEmailTemplateForForm(form, promptUser) {
    if (promptUser) {
      if (!confirm('🤠 Woah there bessie!\n\nThe ' + form.formname + ' form will no longer use the ' + form.emailtemplatetitle + ' email template and use this one instead.\n\nClick OK to confirm or cancel to leave as is')) {
        return;
      }
    }
    CurrentTemplateFactory.toggleEmailTemplateForForm(form)
      .then(function () {
        $scope.$emit('zp.message', {
          level: 'info',
          message: 'form template changed'
        });

      })
      .catch(function (err) {
        MessageService.showMessage(err.data.data.message);
        MessageService.writeLog({
          level: 'error',
          msg: err
        });
      });
  }

}

/**
 * Created by davidbeazer on 21/11s/2016.
 */
(function () {
  'use strict';

  angular
    .module('email')
    .component('zpEmailList', {
      controller: 'EmailTemplatesListController',
      templateUrl: 'app/email/main/zp-email-list/tmpl.html',
      bindings: {
        // model: '<'
      }
    })
    .controller('EmailTemplatesListController', ctrl);

  ctrl.$inject = ['EmailTemplatesFactory', '$state', 'EmailMainMetadata', 'PaginationManager', 'GridDataFactory', 'localStorageService', 'SearchValFactory', 'PermPermissionStore'];
  /* ng-inject */
  function ctrl(EmailTemplatesFactory, state, EmailMainMetadata, PaginationManager, GridDataFactory, localStorageService, SearchValFactory, PermPermissionStore) {

    var vm = this;

    vm.data = {
      items: []
    };

    vm.$onInit = function () {
      vm.data = _.extend({}, vm.data, EmailTemplatesFactory.getData());
      vm.blankSlate = !vm.data.items.length;
      vm.totalRows = vm.data.items.length;
      vm.hideArchivedTemplates = localStorageService.get('hideArchivedTemplates');
      vm.metadata = EmailMainMetadata.getData();
      vm.search = SearchValFactory.get(vm.metadata.id);
      GridDataFactory.hydrateData(EmailTemplatesFactory.factoryData, vm.metadata.id);
      PaginationManager.setQuery(vm.metadata.query, vm.metadata.id);


      const canEditTYEPermission = PermPermissionStore.getPermissionDefinition('TYE_EDIT');
      canEditTYEPermission.validatePermission()
        .then(function (){
          vm.canEditTYE = true;
        })
        .catch(function (){
          vm.canEditTYE = false;
        });

    };

    vm.goto = function (_id) {
      if (vm.canEditTYE) return state.go('app.tabbed_app_framework.email_edit.settings', { _id: _id});
      state.go('app.tabbed_app_framework.email_edit.insights', { _id: _id});
    };

    // PAGINATION
    vm.logPagination = function (page, limit) {
      vm.metadata.query.page = page;
      vm.metadata.query.limit = limit;
      PaginationManager.setQuery(vm.metadata.query, vm.metadata.id);
      $('md-content').animate({ scrollTop: 0 }, 0);
    };


  }
})();

(function () {
  'use strict';

  angular
    .module('email')
    .component('zpEmailHomepageWidgetContainer', {
      templateUrl: 'app/email/main/widget-container/widget-container.tmpl.html',
      controller: 'EmailWidgetContainerCtrl',
      bindings: {}
    })
    .controller('EmailWidgetContainerCtrl', controller);

  controller.$inject = ['EmailTemplatesFactory', 'ChartsFactory', 'ChartsExportFactory', 'MessageService', 'localStorageService'];
  /* ng-inject */
  function controller(EmailTemplatesFactory, ChartsFactory, ChartsExportFactory, MessageService, localStorage) {

    var vm = this;
    vm.loading = true;
    vm.showTitle = true;
    vm.chartInfo = {
      total: 0,
      weektotal: 0,
      chartOptions: {
        legend: { display: false }
      }
    };
    vm.currentSchema = 'Days';
    vm.pickerSchema = 'day';

    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    vm.customRange = {
      startdate: new Date(),
      enddate: new Date(),
      maxdate: tomorrow
    };

    vm.mindate = new Date(moment('01/01/2000'));

    vm.$onInit = function () {
      vm.data = EmailTemplatesFactory.getData();
      vm.blankSlate = !vm.data.items.length;
      vm.aggregatedResponses = ChartsFactory.getChartOptions();
      getChartData();
    };

    function getChartData() {
      const chartParams = localStorage.get('aggregated_email_template_sends');
      if (chartParams) {
        if (!chartParams.currentSchema) chartParams.currentSchema = vm.currentSchema;
        return getChartDataFor(chartParams.chartId, new Date(chartParams.rangeStart), new Date(chartParams.rangeEnd), chartParams.currentSchema);

      }
      
      const initParams = {
        chartId: 'aggregated_email_template_sends',
        rangeStart: getPreviousMonthDate(),
        rangeEnd: daysAgoToDate(0),
        currentSchema: vm.currentSchema
      };
      vm.showTitle = true;
      return getChartDataFor(initParams.chartId, new Date(initParams.rangeStart), new Date(initParams.rangeEnd), initParams.currentSchema);
    }

    function getChartDataFor(chartId, rangeStart, rangeEnd, schema) {
      vm.currentSchema = schema;
      ChartsFactory.getChartData(chartId, rangeStart, rangeEnd, null, schema)
        .then(function (res) {
          setLocalStorage(chartId, rangeStart, rangeEnd, schema);
          vm.customRange.startdate = rangeStart;
          vm.customRange.enddate = rangeEnd;
          vm.chartInfo = _.extend(vm.chartInfo, res);
          vm.chartInfo.metadata.title = buildTitle();
          vm.leadTotalForQuery = res.total;
          vm.loading = false;
          vm.bucketLoading = false;
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    }

    function buildTitle() {
      let correctSchemaTense = vm.currentSchema.toLowerCase();
      if (vm.chartInfo.labels.length == 1) correctSchemaTense = correctSchemaTense.substring(0, correctSchemaTense.length - 1);
      return 'Total emails sent for past ' + vm.chartInfo.labels.length + ' ' + correctSchemaTense;
    }

    vm.changeChartRange = function (parameters) {
      // menu callback function
      if (parameters.selectedMenuItem.menuCommand == 'Export') {
        //export here
        ChartsExportFactory.downloadChartExport(vm.customRange.startdate, vm.customRange.enddate, null, vm.currentSchema, 'aggregated_email_template_sends', 'Emails');
      }
      else {
        vm.bucketLoading = true;
        vm.showCustomDates = true;
        vm.showTitle = true;
        vm.currentSchema = parameters.selectedMenuItem.menuCommand;
        getChartDataFor('aggregated_email_template_sends', vm.customRange.startdate, vm.customRange.enddate, vm.currentSchema);
        if (vm.currentSchema == 'Months' || vm.currentSchema == 'Quarters' || vm.currentSchema == 'Years') {
          vm.pickerSchema = 'month';
        }
        else {
          vm.pickerSchema = 'day';
        }
      }
    };

    vm.applyCustomDates = function () {
      if (moment(vm.customRange.startdate, 'MM/DD/YYYY', true).isValid() && moment(vm.customRange.enddate, 'MM/DD/YYYY', true).isValid())
        vm.bucketLoading = true;
      vm.customRange.startdate = new Date(moment(vm.customRange.startdate).startOf('day').toISOString());
      vm.customRange.enddate = new Date(moment(vm.customRange.enddate).endOf('day').toISOString());

      getChartDataFor('aggregated_email_template_sends', vm.customRange.startdate, vm.customRange.enddate, vm.currentSchema);
    };

    function daysAgoToDate(days) {
      const date = moment().subtract(days, 'days').startOf('day');
      return new Date(date);
    }

    function getPreviousMonthDate() {
      const date = moment().subtract(1, 'months').add(1, 'days').startOf('day');
      return new Date(date);
    }

    function setLocalStorage(chartId, rangeStart, rangeEnd, schema) {
      localStorage.set(chartId, { chartId: chartId, rangeStart: rangeStart, rangeEnd: rangeEnd, currentSchema: schema });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('email')
    .component('zpEmailSearchToolbar', {
      templateUrl: 'app/email/main/search-toolbar/tmpl.html',
      controller: 'EmailSearchToolbarCtrl',
      bindings: {}
    })
    .controller('EmailSearchToolbarCtrl', controller);

  controller.$inject = ['EmailMainMetadata', 'EmailTemplatesFactory'];
  /* ng-inject */
  function controller(EmailMainMetadata, EmailTemplatesFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.metadata = EmailMainMetadata.getData();
    };

    vm.onMenuClick = function(){
      vm.hideArchivedTemplates = !vm.hideArchivedTemplates;
      EmailTemplatesFactory.toggleShowArchivedSwitch(vm.hideArchivedTemplates);
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('email')
    .component('zpAddEmailFab', {
      templateUrl: 'app/email/main/fab/fab.tmpl.html',
      controller: 'zpAddEmailFabCtrl'
    })
    .controller('zpAddEmailFabCtrl', ctrl);

  ctrl.$inject = ['EmailTemplatesFactory', 'EmailMainMetadata', 'MasterPermissionsDefinitionFactory'];
  /* nj-inject */
  function ctrl(EmailTemplatesFactory, EmailMainMetadata, MasterPermissionsDefinitionFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.data = EmailTemplatesFactory.getData();
      vm.metadata = EmailMainMetadata.getData();
      vm.permissions = MasterPermissionsDefinitionFactory;
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('email')
    .component('zpTemplateSettings', {
      controller: 'EmailTemplateSettingsController',
      templateUrl: 'app/email/detail/zp-template-settings/zp-template-settings.tmpl.html'
    })
    .controller('EmailTemplateSettingsController', ctrl);

  ctrl.$inject = ['$scope', 'CurrentTemplateFactory', 'MessageService', 'hotkeys', 'ChangeDelta', 'EnvService', '$state', 'MasterPermissionsDefinitionFactory', 'PermPermissionStore', 'ToolbarFactory'];
  /* ng-inject */
  function ctrl($scope, CurrentTemplateFactory, MessageService, hotkeys, ChangeDelta, EnvService, $state, MasterPermissionsDefinitionFactory, PermPermissionStore, ToolbarFactory) {

    var vm = this;
    vm.copyOfEditorText;

    vm.$onInit = function () {
      vm.emailTemplate = CurrentTemplateFactory.getCurrentTemplateCache();
      vm.deleteTemplate = deleteTemplate;
      vm.isDev = EnvService.isDev;
      vm.save = save;
      checkPermissions();
      // setup change delta
      ChangeDelta.clear();
      vm.changeDelta = ChangeDelta;
      vm.lastSavedStateOfEmailTemplate = angular.copy(vm.emailTemplate);
      vm.sendTestEmail = sendTestEmail;
      vm.manageFormsUsedDialog = manageFormsUsedDialog;
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.formsUsedCount = CurrentTemplateFactory.getFormsUsedCountForTemplate();
      $scope.$on('deleteTemplate', deleteTemplate);
      $scope.$on('zpSaveEmailTemplate', function () {
        save();
      });

      hotkeys.bindTo($scope)
        .add({
          combo: 'ctrl+s',
          description: 'Save template',
          allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
          callback: function () {
            vm.save();
          }
        });

      // INSTANCE TOOLBAR CONFIG
      vm.menuOptions = [{
        onClick: 'deleteTemplate',
        ariaLabel: function () {
          return 'Delete Template';
        },
        icon: function () {
          return 'zmdi zmdi-delete';
        },
        label: function () {
          return 'Delete Template';
        }
      }];
    };

    function save(ev) {
      CurrentTemplateFactory.postData(ev)
        .then(function () {
          vm.copyOfEditorText = vm.emailTemplate.emailtemplatetext;
          vm.lastSavedStateOfEmailTemplate = angular.copy(vm.emailTemplate);
        })
        .catch(function (err) {
          if (err.saveCancelled) MessageService.showMessage('Save cancelled');
        });
    }

    function checkPermissions() {
      const permission = PermPermissionStore.getPermissionDefinition('TYE_EDIT');
      permission.validatePermission()
        .then(function () {
          vm.permissionToEdit = true;
        })
        .catch(function () {
          const permission2 = PermPermissionStore.getPermissionDefinition('TRUMP');
          permission2.validatePermission()
            .then(function () {
              vm.permissionToEdit = true;
            })
            .catch(function () {
              vm.permissionToEdit = false;
            });
        });

    }

    vm.updateChangeDelta = function (property, newValue) {
      if (property === 'title') {
        ToolbarFactory.set({ title: newValue });
      }
      const oldValue = vm.lastSavedStateOfEmailTemplate[property];
      ChangeDelta.recordValueChange({
        oldval: oldValue,
        newval: newValue,
        objectid: vm.emailTemplate._id,
        collection: 'emailtemplates',
        databasefieldname: property
      });
    };

    function deleteTemplate(zpEvent, srcEvent) {
      MessageService
        .confirm(srcEvent)
        .delete('Are you sure you want to delete this template?')
        .then(function () {
          CurrentTemplateFactory.deleteTemplate(vm.emailTemplate._id)
            .then(function () {
              $state.go('app.homescreen_app_framework.email_home');
            });
        });
    }

    function sendTestEmail() {
      vm.emailTemplate._lastTestEmailSentDate = new Date();
      const dataToSave = {
        _id: vm.emailTemplate._id,
        _lastTestEmailSentDate: vm.emailTemplate._lastTestEmailSentDate
      };
      
      CurrentTemplateFactory
        .sendTestEmail(dataToSave)
        .then(function () {
          MessageService.showMessage('Test email sent');
        })
        .catch(function (err) {
          MessageService.showMessage('Error sending test email: ' + err);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    }

    function manageFormsUsedDialog(ev) {

      MessageService.showDialog(ev, {
        controller: FormsUsedDialogController,
        controllerAs: 'vm',
        templateUrl: 'app/email/detail/forms-used-dialog/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      })
        .then(function () {
          // $log.info('Forms used dialog closed with answer: ' + answer);
          vm.formsUsedCount = CurrentTemplateFactory.getFormsUsedCountForTemplate();

        }, function () {
          // $log.info('User cancelled out of the forms used dialog');
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    }
  }
})();

(function () {

  'use strict';

  angular
    .module('email')
    .component('zpEmailTemplateInsights', {
      templateUrl: 'app/email/detail/zp-template-insights/zp-template-insights.tmpl.html',
      controller: 'EmailTemplateInsightsCtrl',
      bindings: {
        emailTemplateId: '<'
      }
    })
    .controller('EmailTemplateInsightsCtrl', controller);

  controller.$inject = ['ChartsFactory', 'ChartsExportFactory', 'CurrentTemplateFactory', 'MessageService', 'localStorageService'];
  /* ng-inject */
  function controller(ChartsFactory, ChartsExportFactory, CurrentTemplateFactory, MessageService, localStorage) {

    var vm = this;
    vm.loading = true;

    vm.showTitle = true;
    vm.currentSchema = 'Days';
    vm.pickerSchema = 'day';

    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    vm.customRange = {
      startdate: new Date(),
      enddate: new Date(),
      maxdate: tomorrow
    };

    vm.mindate = new Date(moment('01/01/2000'));

    vm.chartInfo = {
      total: 0,
      events: {
        delivered: 0,
        opened: 0,
        clicked: 0,
        unsubscribed: 0,
        permanent_fail: 0,
        temporary_fail: 0,
        complained: 0,
        failed: 0
      },
      chartOptions: {
        legend: { display: true }
      }
    };

    vm.$onInit = function () {
      MessageService.pushEventToIntercom('email_insights_tab', {
        emailTemplateId: vm.emailTemplateId
      });
      vm.aggregatedResponses = ChartsFactory.getChartOptions();
      getChartData();
    };

    function getChartData() {
      const chartParams = localStorage.get('individual_email_template_sends');
      if (chartParams) {
        if (!chartParams.currentSchema) chartParams.currentSchema = vm.currentSchema;
        return getChartDataFor(chartParams.chartId, new Date(chartParams.rangeStart), new Date(chartParams.rangeEnd), chartParams.currentSchema);
      }

      const initParams = {
        chartId: 'individual_email_template_sends',
        rangeStart: getPreviousMonthDate(),
        rangeEnd: daysAgoToDate(0),
        currentSchema: vm.currentSchema
      };
      vm.showTitle = true;
      return getChartDataFor(initParams.chartId, new Date(initParams.rangeStart), new Date(initParams.rangeEnd), initParams.currentSchema);
    }

    function getChartDataFor(chartId, rangeStart, rangeEnd, schema) {
      vm.currentSchema = schema;
      ChartsFactory.getChartData(chartId, rangeStart, rangeEnd, vm.emailTemplateId, schema)
        .then(function (res) {
          setLocalStorage(chartId, rangeStart, rangeEnd, schema);
          vm.customRange.startdate = rangeStart;
          vm.customRange.enddate = rangeEnd;
          vm.chartInfo = _.extend(vm.chartInfo, res);
          vm.chartInfo.metadata.title = 'Total emails sent with this template for past ' + vm.chartInfo.metadata.title + ' days';
          vm.loading = false;
          vm.bucketLoading = false;
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    }

    vm.changeChartRange = function (parameters) {

      // menu callback function
      if (parameters.selectedMenuItem.menuCommand == 'Export') {
        //get chart title from cache
        const template_name = (CurrentTemplateFactory.getCurrentTemplateCache().title).replace(' ', '_');
        //export here
        ChartsExportFactory.downloadChartExport(vm.customRange.startdate, vm.customRange.enddate, vm.emailTemplateId, vm.currentSchema, 'individual_email_template_sends', 'Emails sent for template ' + template_name);
      }
      else {
        vm.bucketLoading = true;
        vm.showCustomDates = true;
        vm.showTitle = true;
        vm.currentSchema = parameters.selectedMenuItem.menuCommand;
        getChartDataFor('individual_email_template_sends', vm.customRange.startdate, vm.customRange.enddate, vm.currentSchema);
        if (vm.currentSchema == 'Months' || vm.currentSchema == 'Quarters' || vm.currentSchema == 'Years') {
          vm.pickerSchema = 'month';
        }
        else {
          vm.pickerSchema = 'day';
        }
      }

    };

    vm.applyCustomDates = function () {
      vm.bucketLoading = true;
      vm.customRange.startdate = new Date(moment(vm.customRange.startdate).startOf('day').toISOString());
      vm.customRange.enddate = new Date(moment(vm.customRange.enddate).endOf('day').toISOString());
      getChartDataFor('individual_email_template_sends', vm.customRange.startdate, vm.customRange.enddate, vm.currentSchema);
    };

    function daysAgoToDate(days) {
      const date = moment().subtract(days, 'days').startOf('day');
      return new Date(date);
    }

    function getPreviousMonthDate() {
      const date = moment().subtract(1, 'months').add(1, 'days').startOf('day');
      return new Date(date);
    }

    function setLocalStorage(chartId, rangeStart, rangeEnd, scheme) {
      localStorage.set(chartId, { chartId: chartId, rangeStart: rangeStart, rangeEnd: rangeEnd, currentSchema: scheme });
    }
  }

})();
(function () {
  'use strict';

  angular
    .module('email')
    .component('zpTemplateEditor', {
      controller: 'EmailEditorCtrl',
      templateUrl: 'app/email/detail/zp-template-editor/zp-template-editor.tmpl.html'
    })
    .controller('EmailEditorCtrl', ctrl);

  ctrl.$inject = ['$sce', '$scope', 'CurrentTemplateFactory', 'hotkeys', 'ChangeDelta', '$timeout', 'PermPermissionStore'];
  /* ng-inject */
  function ctrl($sce, $scope, CurrentTemplateFactory, hotkeys, ChangeDelta, $timeout, PermPermissionStore) {

    var vm = this,
      ckEditorDirtyFlag = false,
      copyOfEditorText;

    vm.editorPlugins = ['logo','literature','autogrow','placeholder','font','colorbutton','stickyToolbar','contentEditable'];

    vm.$onInit = function () {
      vm.emailTemplate = CurrentTemplateFactory.getCurrentTemplateCache();
      vm.templateAsHtml = $sce.trustAsHtml(vm.emailTemplate.emailtemplatetext);
      checkPermissions();
      // setup change delta
      ChangeDelta.clear();
      vm.changeDelta = ChangeDelta;
      vm.lastSavedStateOfEmailTemplate = angular.copy(vm.emailTemplate);

      hotkeys.bindTo($scope)
        .add({
          combo: 'ctrl+s',
          description: 'Save template',
          allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
          callback: function () {
            vm.save();
          }
        });
    };

    vm.editorChange = function() {
      if (!ckEditorDirtyFlag) {
        copyOfEditorText = angular.copy(vm.emailTemplate.emailtemplatetext);
        ckEditorDirtyFlag = true;
        return;
      }

      const oldValue = copyOfEditorText;
      ChangeDelta.recordValueChange({
        oldval: oldValue,
        newval: vm.emailTemplate.emailtemplatetext,
        objectid: vm.emailTemplate._id,
        collection: 'emailtemplates',
        databasefieldname: 'emailtemplatetext'
      });
    };

    $scope.$on('zp.ckEditorMode', function (e, params) {
      $timeout(function () {
        vm.saveDisabled = params.message == 'source' ? true : false;
      }, 50);
    });

    $scope.$on('zpSaveEmailTemplate', function () {
      vm.save();
    });

    vm.save = function () {
      CurrentTemplateFactory.postData()
        .then(function () {
          copyOfEditorText = vm.emailTemplate.emailtemplatetext;
          vm.lastSavedStateOfEmailTemplate = angular.copy(vm.emailTemplate);
        });
    };

    function checkPermissions() {
      const permission = PermPermissionStore.getPermissionDefinition('TYE_EDIT');
      permission.validatePermission()
        .then(function () {
          vm.permissionToEdit = true;
        })
        .catch(function () {
          vm.permissionToEdit = false;
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('email')
    .component('zpSaveEmailTemplateFab', {
      templateUrl: 'app/email/detail/fab/fab.tmpl.html',
      controller: 'zpSaveEmailTemplateFabCtrl'
    })
    .controller('zpSaveEmailTemplateFabCtrl', ctrl);

  ctrl.$inject = ['$scope', 'ChangeDelta', 'MasterPermissionsDefinitionFactory'];
  /* nj-inject */
  function ctrl($scope, ChangeDelta, MasterPermissionsDefinitionFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.changeDelta = ChangeDelta;
      vm.permissions = MasterPermissionsDefinitionFactory;
    };

    vm.save = function (){
      $scope.$emit('zp.message', {
        level: 'broadcast',
        page: 'foo',
        eventName: 'zpSaveEmailTemplate'
      });
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpWebsummitPartnerIdSelect', {
      templateUrl: 'app/common/widgets/websummit-partner-id-select/tmpl.html',
      bindings: {
        onItemChange: '&'
      },
      controller: 'WebsummitPartnerIdSelectCtrl'
    })
    .controller('WebsummitPartnerIdSelectCtrl', controller);

  controller.$inject = ['$log', 'WebsummitPartnerIdsFactory'];
  /* ng-inject */
  function controller($log, WebsummitPartnerIdsFactory) {

    var vm = this;

    vm.$onInit = function () {};

    vm.partners = loadAll();
    vm.querySearch = querySearch;
    vm.selectedItemChange = selectedItemChange;
    vm.searchTextChange = searchTextChange;

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for partners... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
      var results = query ? vm.partners.filter(createFilterFor(query)) : vm.partners;

      return results;
    }

    function searchTextChange(text) {
      $log.info('Text changed to ' + text);
    }

    function selectedItemChange(item) {
      $log.info('Item changed to ' + JSON.stringify(item));
      vm.onItemChange({
        item: item
      });
    }

    /**
     * Build `components` list of key/value pairs
     */
    function loadAll() {
      var partners = WebsummitPartnerIdsFactory();

      return partners.map(function (partner) {
        partner.value = partner.name.toLowerCase();
        return partner;
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = query.toLowerCase();
      return function filterFn(item) {
        return (item.name.toLowerCase().indexOf(lowercaseQuery) === 0 || item.id.toLowerCase().indexOf(lowercaseQuery) === 0);
      };

    }
  }

}());

(function () {

  angular
    .module('common')
    .factory('WebsummitPartnerIdsFactory', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    return function () {
      /* eslint-disable */
      return [{ "id": "b0464833-2e55-491f-a419-c5f421df85a2", "name": "Bidroom " }, { "id": "b1349eb4-92cd-43b3-b685-70305d7ea293", "name": "Atlas Quantum" }, { "id": "b2424942-13bb-49bc-87b2-6597958cbf82", "name": "Regional Development Fund of Attica Region" }, { "id": "cb4f7108-d0d0-415c-8f0a-fdc9a96120dc", "name": "Draper" }, { "id": "dc65abb3-7728-4a91-bb29-27813fcfa170", "name": "NIU" }, { "id": "420a928f-9b31-4592-b860-2e5c0a7ded8a", "name": "Delta Cafés" }, { "id": "5e28ec55-ee95-46cc-a728-0e2ceb59923c", "name": "Railwaymen Sp. z o.o." }, { "id": "e6323a45-4b43-4f62-ac47-908020614566", "name": "Nylas" }, { "id": "be1e50a9-bbad-4a02-9286-6923dcf0a382", "name": "The Coca-Cola Company" }, { "id": "cd899773-58a9-4cb6-b6ff-c3a621085a80", "name": "Xpand IT" }, { "id": "89e5853c-30be-4572-956e-ba1e44f591a5", "name": "Toptal" }, { "id": "cd6836a3-4745-49c3-8790-e1dffa37b897", "name": "everis" }, { "id": "03a8f677-d797-4490-bd87-e5f26415b298", "name": "NeoSOFT Technologies" }, { "id": "c0a26337-c09d-4aa2-9df2-421ac96a6400", "name": "tagSpace" }, { "id": "3dd0e845-ee56-4bcc-8f3d-f0aa85016d4b", "name": "Atlassian" }, { "id": "5df102bc-e374-4932-989a-163cce27bd14", "name": "Konica Minolta Business Solutions Europe " }, { "id": "018599d6-4f21-4741-bb2d-58780d829c32", "name": "Gremlin" }, { "id": "89045ff4-8aed-4bd9-98f3-2b3df2e1a407", "name": "Cloudflare" }, { "id": "02106e4f-ea9e-4dc4-bbf8-15a0706f01d5", "name": "British Embassy Lisbon" }, { "id": "2c684755-f6ba-4fba-92d5-dc8cd0bf0d6c", "name": "Symbiosy by HB Reavis" }, { "id": "20b16cc9-6337-43e7-b1b5-16ab1351601b", "name": "Shell" }, { "id": "afec20b7-b859-455f-87c3-b03a1bbc5366", "name": "Esplendor Group S.A." }, { "id": "82bb4c02-f3ca-4d14-84f6-fb455087ec51", "name": "Católica Lisbon School of Business \u0026 Economics" }, { "id": "2c40ce10-18ca-4f07-b280-6702085429c0", "name": "Entrepreneurs' Organization (EO)" }, { "id": "6383fb3b-8908-4067-88cf-f3406b1c0d08", "name": "Performante" }, { "id": "8ddf84a2-40ef-452c-809b-a5caa912dfc6", "name": "KPMG" }, { "id": "b9e3be0b-b4a5-4bcd-aa63-e044cf707bfa", "name": "CI\u0026T" }, { "id": "48ab986c-94b6-4ee5-87ad-0a9d89e8b1ea", "name": "Egypt" }, { "id": "c8bf7ce8-db1b-47a0-af8c-37f8a24631fc", "name": "BOLD by Devoteam" }, { "id": "27a7c4b6-4d7b-46c7-b725-3cf62df4e7fb", "name": "Zilingo" }, { "id": "c92e954a-522c-4f3a-b6dd-2db6b2b61363", "name": "CodeControl" }, { "id": "24d8d79d-5166-42fd-b806-635491e8d8f0", "name": "DiRWA" }, { "id": "a106bc59-405a-42eb-85be-a23e515de145", "name": "Blockstack" }, { "id": "38daf4cf-31a2-49e7-85a2-cbd5671dbf3c", "name": "J-Startup / JETRO" }, { "id": "ad34c879-5629-4d0b-ad4a-1c908b9b825a", "name": "Gamekit S.A." }, { "id": "931433b4-7e64-464a-a1c5-3eb00ed54047", "name": "Bureau van Dijk" }, { "id": "b49badfc-e192-47c8-97bf-a62f3b76bd63", "name": "Lego Ventures" }, { "id": "1a2ab39f-0452-414f-8426-98502b35f68d", "name": "SAP" }, { "id": "1257b194-c47b-4f5d-8ef4-88776b7cfe6f", "name": "Squirrel AI" }, { "id": "1c8ec8fb-e3e9-4dc4-9911-682eca7adcff", "name": "Crossbeam" }, { "id": "76b0fb7c-288f-4e89-8e4e-1e49057654d8", "name": "Madeira Islands" }, { "id": "c5362971-e55e-4a96-8403-f587293f2944", "name": "TripActions" }, { "id": "234bf2bc-4b80-4e53-9f28-ec4b428dfbe6", "name": "AD’OCC – Région Occitanie" }, { "id": "a31cd474-38f4-4a6f-a648-7bd5c1c31982", "name": "SIBS" }, { "id": "877da4df-7819-4978-badf-30e09e1c92f7", "name": "Locate Guernsey" }, { "id": "79b5dc03-9c1b-441e-808f-c46fc301ad1b", "name": "Microsoft" }, { "id": "411a7e92-697f-4c72-a41e-aa4f53c6d3c8", "name": "Setapp" }, { "id": "90c848e2-f788-4f5f-9ba8-11869fea5aaa", "name": "Velocity Global" }, { "id": "593fbc1e-9872-4ed9-aa3c-7532595b9c25", "name": "Zoom Video Communications" }, { "id": "12ad091c-5092-45f9-8f95-c0521a75bb12", "name": "Upsales Nordic AB" }, { "id": "4dc6da0d-edab-43b8-a89f-a64a49bbf19b", "name": "BTG Pactual" }, { "id": "c1e16e10-34e9-46c5-88e1-99bfdbe47d2b", "name": "Polish IT Promotion Program" }, { "id": "8108cc0d-8128-4f40-b085-d45336c2036c", "name": "PitchBook" }, { "id": "c3339481-ace1-46f2-b072-4bab9c0bc7f5", "name": "Twilio" }, { "id": "1b2b3c12-afa9-43da-a0ff-35aa6788ce87", "name": "Vakt" }, { "id": "75d13464-cd89-45a5-a4b7-06d7712745fa", "name": "Business France" }, { "id": "1d891bd3-e164-443a-887b-ba0035e3d6d1", "name": "Mastercard" }, { "id": "3e8aeb85-34e5-4f63-b786-7994f738f35b", "name": "Sardegna Ricerche" }, { "id": "9da1a3ba-a1db-46de-9642-7428f1357876", "name": "Falcon.io" }, { "id": "6b5b0cd4-9b3f-493b-90cd-f5f6e6960c60", "name": "Skolkovo" }, { "id": "e37f683e-523c-43bd-9aa4-4a4704de4b17", "name": "INSTANDA" }, { "id": "7e41b4c4-0490-460d-baea-85686ba1f8a3", "name": "Shutterstock" }, { "id": "667e1c23-890f-48de-89d0-3830d7407257", "name": "Evolution Equity Partners" }, { "id": "2c9981bc-f7aa-4e3f-913d-203c4b532201", "name": "Agile Fuel" }, { "id": "57d40a8f-90a0-41e6-924b-3b3462ac7411", "name": "Amdocs" }, { "id": "07258f21-da71-4d19-a0e0-c24881009d9b", "name": "Segment" }, { "id": "59695323-7cc7-4517-9e12-0752de8df083", "name": "LetsBab" }, { "id": "661440a8-d981-48b0-93b2-2e0260d773dd", "name": "DocSend" }, { "id": "3f4f6880-fb01-4c45-a605-18a16831787a", "name": "European Patent Office" }, { "id": "9735e0f8-0469-4c5e-a97f-9c90919d0849", "name": "Chargify" }, { "id": "c7f4298f-3913-4626-af2c-92771a161d73", "name": "eToro" }, { "id": "8bcba93a-31d6-4c58-be63-b246ce41b7eb", "name": "Freshfields Bruckhaus Deringer" }, { "id": "48ae2eb1-a808-4882-9738-4245730f7aaa", "name": "Siemens" }, { "id": "21f86489-76d4-4e34-96f3-0cf52416beea", "name": "Hugo" }, { "id": "1c78d61f-5f6e-4dab-aa1b-028367c53dd2", "name": "AID - Autonomous Intelligent Driving GmbH" }, { "id": "8df52028-c439-450b-b4b2-32148057a4d8", "name": "HUUB" }, { "id": "d12de872-5b2d-4162-bee9-993952db81c0", "name": "Wirecard AG" }, { "id": "6c78ce79-029e-4509-ada4-30bc238605de", "name": "Moscow export centre" }, { "id": "833ad742-6d18-40a1-868a-3af2151848bd", "name": "Roistat" }, { "id": "852a915c-768b-4e2c-9cfc-48fae5d79fe7", "name": "Glassbox Digital" }, { "id": "54648943-1f0d-4967-8a6e-26b5299f8f97", "name": "moey!" }, { "id": "46676c8f-5346-46ca-b420-59328bb44cc4", "name": "Lenovo" }, { "id": "f3974e70-9c4d-47da-b808-bf168a5b6c0c", "name": "LUSH" }, { "id": "028a4684-fca2-4646-b4e0-1cbf30bbf1b2", "name": "European Commission" }, { "id": "64633859-a00a-46d3-a914-6aadffa8a7b9", "name": "Russian Export Center" }, { "id": "facd5cc2-b682-4ca1-a5b5-a87d76ec1965", "name": "Hedera Hashgraph" }, { "id": "358a2c81-6936-4421-aa04-6268d78378aa", "name": "Governo de Cabo Verde" }, { "id": "172ff399-82c1-4e2d-888b-927eab200b21", "name": "ENGIE" }, { "id": "67ddd938-c7c7-4d9b-94ef-0582ed83a8e3", "name": "Atlas Biomed " }, { "id": "0494aeaf-1f61-4000-96da-8edc638314ec", "name": "EDP" }, { "id": "a57f888e-3eea-4646-9a3e-cc50eab87ed8", "name": "Joulica" }, { "id": "a054f9bb-6391-4425-8c7f-e47ad8c18b82", "name": "Brightline™ Initiative" }, { "id": "7db9beb3-e2e8-4be2-bea1-2ba80ea330a1", "name": "Volkswagen Group" }, { "id": "dcef4b25-d474-4bcd-a7bd-70bbd9f57357", "name": "Bitpanda GmbH" }, { "id": "4f2d7192-d9d4-472a-a709-2dafbb266f0e", "name": "Porsche" }, { "id": "54a61870-a272-4a6d-b3e0-59fc763a7383", "name": "Critical TechWorks" }, { "id": "1d383373-1844-476c-a20f-51dcd041ae4b", "name": "Multicert" }, { "id": "1d750a80-86a5-44ef-a569-a28a9cffaed2", "name": "Leveris" }, { "id": "ec1a4cbc-20d5-44d9-9e35-497cb9ace603", "name": "UNDP ImpactAim Accelerator" }, { "id": "30b88796-61f7-4461-b841-26cb64509e80", "name": "Unitel" }, { "id": "dde5cd3b-27ac-4afb-b797-7baacc076c00", "name": "ZETA Inc" }, { "id": "a4a0b423-f965-49d8-a4d5-4a30ffc4885d", "name": "Macao Young Entrepreneur Incubation Centre" }, { "id": "6de95d03-8fa1-4768-83a5-ffe179f2f3c1", "name": "Open-Xchange" }, { "id": "063af525-d5cc-4afb-bcb9-5720cbc0bd41", "name": "Wowza Media Systems" }, { "id": "cf0a86d3-747c-4363-aab5-f696eb34c23c", "name": "AirWayBill" }, { "id": "c1dec4ad-2736-4ff1-818a-0a28774a0b7a", "name": "Astana Hub" }, { "id": "27d00cbe-d124-4308-a40d-32efb969452e", "name": "Martal Group" }, { "id": "8b394ec7-ae8d-4a4b-8238-92856a77bec9", "name": "Eurowings Digital GmbH" }, { "id": "a869554e-3ff0-459b-b37d-02e85d8370ec", "name": "agap2IT" }, { "id": "85753132-0f02-4c33-9d92-f5cd58519918", "name": "Domo" }, { "id": "3259b61b-8878-47e4-80e5-06ea2e95f9ea", "name": "Decred" }, { "id": "f8e9a9d5-31c7-4730-8f26-e043678f7d87", "name": "PLMJ" }, { "id": "247b0849-9ef1-430e-9123-67217e71d929", "name": "SAGIA" }, { "id": "6dc77f51-1f43-4a5f-905d-5eec1d2463b5", "name": "United Nations Global Compact" }, { "id": "e1d47700-058c-4c35-a505-f45d97b0dbac", "name": "Calouste Gulbenkian Foundation" }, { "id": "5be8fc11-35be-44be-b09b-0b98c1b9659f", "name": "Business Sweden" }, { "id": "9a0eed13-0dd7-4dc9-bb2e-a71d0bd96d81", "name": "HERE Technologies" }, { "id": "5a82eb9b-fe6e-44c3-bf2f-7d8fb5be97b9", "name": "Lisbon Nearshore" }, { "id": "2da4a4d7-ae9d-4ce8-97b2-e7d6ed1055ed", "name": "UiPath" }, { "id": "7752fc77-2e0c-4e2d-aeec-0d5a25139c85", "name": "JetBrains" }, { "id": "536ffb16-fd4c-4975-9709-455c0134ea8b", "name": "Digital Hub Denmark" }, { "id": "5878ce80-9b63-4edb-8dc7-8fb474916e82", "name": "Berlin Partner for Business and Technology" }, { "id": "544eabdd-3909-4a6f-89c7-20e79dccd2d2", "name": "Cisco" }, { "id": "0c03152d-2162-4718-86f2-715ec935bcef", "name": "Volterra Inc." }, { "id": "a3410597-4a71-4eab-839c-5992aa46b707", "name": "Airbus" }, { "id": "679dbc67-988d-4635-ae0b-bf8c6b187efe", "name": "Dexai Robotics" }, { "id": "08c685bb-d142-4c78-bfc7-1dcf0d38f5c3", "name": "Accenture" }, { "id": "d4687524-064c-4528-8853-6e8f906c36f8", "name": "ALTER SOLUTIONS" }, { "id": "84b40bc1-b382-4f44-becd-80c23fb20c18", "name": "SurveyMonkey" }, { "id": "62b0306f-3bc0-4857-9d7e-b59a3e497b3b", "name": "Invest In Azores" }, { "id": "6e91e11a-a5d5-465b-95fa-32a3ced06fbc", "name": "Modex Blockchain Database" }, { "id": "8ae67785-7add-403a-bbfa-a223b7dd4131", "name": "Plaid" }, 
      { "id": "e332bf00-4215-4fcc-8b04-a207cba74351", "name": "Florianópolis" }, { "id": "d800f12f-c31d-4888-ba40-c7b445cff211", "name": "Appidea " }, { "id": "79474852-cfa4-4921-8e89-4f4f20ca64f1", "name": "KOCCA" }, { "id": "fccb8b79-ed3f-4b2e-93f1-58cd4abe1255", "name": "Inter-American Development Bank" }, { "id": "5b18d1f4-497d-4ae6-a459-638a7fc44ff6", "name": "European Investment Bank Group" }, { "id": "a225f92d-0fb3-4d15-90e1-fc8c89223921", "name": "IST Instituto Superior Técnico, Universidade de Lisboa" }, { "id": "02136f74-8e90-40bc-95bf-c0de520ee4f9", "name": "Cyprus Research and Innovation Foundation" }, { "id": "21258417-c037-40f1-9085-90eb17a1c23f", "name": "Ucraft" }, { "id": "a865067d-be32-4393-8c57-03e16243ab74", "name": "Courbon Software" }, { "id": "ce8f3dcb-d7cd-49bb-97ba-2182770acbb5", "name": "WordPress.com" }, { "id": "20991bab-7415-4623-ab44-961c9ac3c5b8", "name": "Netguru" }, { "id": "074a25d0-2325-49b3-817c-960843efa1df", "name": "Element AI" }, { "id": "d9d046c0-bdf7-4e2b-b4cb-b92ed6a9fb17", "name": "HKSTP " }, { "id": "743489b5-5fa8-4e71-a297-bec0ee5d8aac", "name": "Voximplant" }, { "id": "4a876bba-d0e1-405e-a2b1-6614a2b666cb", "name": "Italian Trade Agency" }, { "id": "256cca91-2d34-44a6-a692-75ec5228673d", "name": "Budapest Enterprise Agency" }, { "id": "3f0dfdce-48a1-4da1-878f-d515e89eea38", "name": "SelectUSA" }, { "id": "60eb0b00-c71e-4dd0-870a-6ae06bd635f8", "name": "Dubai Investment Development Agency (Dubai FDI)" }, { "id": "1f2c11ea-5fd3-429d-97e5-4a0f74ec2176", "name": "VULOG" }, { "id": "94072bb3-fae3-4a1a-a8bf-ba0ec0fcaf61", "name": "DigitalOcean" }, { "id": "e593439d-66fd-47db-ad49-d76cc5644490", "name": "Futrli" }, { "id": "711c47bd-a57a-4e8a-ada1-e9268f3f06c0", "name": "Wizaplace" }, { "id": "d53756ef-4986-4fd3-b207-5eb722a00a72", "name": "Google" }, { "id": "22be2935-155a-48c8-a6fb-e968b99bdc35", "name": "Samsung NEXT" }, { "id": "fff8ffda-6a96-45d3-90ff-c13b4d5279c0", "name": "Booking.com" }, { "id": "bf3c8837-5c34-421b-aa23-a2ef52d27ea1", "name": "Via Verde" }, { "id": "cd1aafde-8afa-4157-a7f5-21993a23c339", "name": "Skipjack Corporation Inc" }, { "id": "b888575d-8398-4f0f-9938-b50a36d0db46", "name": "A-to-Be" }, { "id": "f537562b-b065-40be-b238-4e63f7fa58bc", "name": "tb.lx by Daimler Trucks \u0026 Buses" }, { "id": "edeea013-d958-46e3-a956-003796ee7328", "name": "Hire Me" }, { "id": "aa5b3185-048e-4086-82ef-76d561b0b33b", "name": "Startup Portugal" }, { "id": "16e6af0a-61b3-4d30-8330-701d50acfd11", "name": "FREE NOW (formerly mytaxi)" }, { "id": "4bb68f5c-c0d6-4d90-9952-d19884471d18", "name": "Boston Consulting Group" }, { "id": "f17e6c31-5250-445b-a808-6a69626deeb6", "name": "PVH Europe B.V." }, { "id": "1f42b20f-5992-47f9-b053-2b4725f94eef", "name": "inFullMobile" }, { "id": "b1945ca6-0322-492b-b590-ea43bdd12331", "name": "Order Group" }, { "id": "92f949e7-551a-4017-8ee0-9cc930811827", "name": "Quora" }, { "id": "62f9be31-93c4-4055-97d7-6867f5d97a6b", "name": "Cappasity" }, { "id": "1bc77112-fb4d-45b9-be0e-a1cd039f6c31", "name": "Thales Digital Factory" }, { "id": "3270f910-0bdb-4632-8199-fab195f47567", "name": "CM.com" }, { "id": "a874dbaf-3b33-44be-8f96-0f3ea511c089", "name": "Splyt" }, { "id": "34816935-e643-45ae-b280-1f8f73d3ce43", "name": "Magnus Stellar " }, { "id": "2ae0024e-dda6-444a-84f8-458a575a79c9", "name": "Huawei" }, { "id": "aef85958-ab88-4d02-be0f-361dfe31caa6", "name": "OSRAM" }, { "id": "540ecd33-1476-4225-818c-865b721ca160", "name": "Huawei Consumer Business Group" }, { "id": "01db805f-6939-4a10-8a3b-b2b7586f7c38", "name": "ESOMAR" }, { "id": "9dc00b3d-bb55-4a8a-be4b-6866a1d91066", "name": "DHL Express" }, { "id": "99afe85d-d22f-48f8-ba2a-b0c9bed8989d", "name": "ADAPT Centre" }, { "id": "2ccfe783-8344-4e8a-8e61-3687ce23d213", "name": "Sephora" }, { "id": "62f0aea9-4744-4393-b38c-91657f8a433c", "name": "hub.brussels/AWEX" }, { "id": "a6c58dfd-23c5-45ab-8217-686293a2fa2e", "name": "Allsoft Ecommerce" }, { "id": "4050cad2-4c30-443a-bd8a-9b1d820863da", "name": "Coach4Charity" }, { "id": "c67b8e5c-3d31-4d3e-bd99-4771b6c21486", "name": "Startup Leiria" }, { "id": "0c785035-832a-4823-a09b-a83d80927ede", "name": "The City of Brampton" }, { "id": "f59eb121-2e8c-43f9-97af-e69935cb3ebd", "name": "Invest Northern Ireland" }, { "id": "fea3978b-8a1c-4ce5-9b62-123c0c987649", "name": "Stripe" }, { "id": "74ef8666-817d-48db-bb18-713b365b3872", "name": ".com" }, { "id": "9e03db71-7cc9-4d76-a329-dff1bf599af0", "name": "Embassy of the Kingdom of the Netherlands" }, { "id": "604cc7c7-683e-4c76-bd4d-a29b4b15f4b1", "name": "Bounce Share" }, { "id": "bfa94dc1-9dab-4fdf-ae06-d500899fbbf7", "name": "Mailchimp" }, { "id": "70c98e98-c4d2-4aec-bf30-ae46f686c92c", "name": "City of Fundão" }, { "id": "bb5b1d9b-7324-43c0-b39a-e25c75314b5a", "name": "Xerox Portugal" }, { "id": "16975079-d6f6-4781-93f9-16c9282def46", "name": "Beltrão Coelho" }, { "id": "d83adccb-536b-4c1a-b56d-15aff7d82fd2", "name": "Spendesk" }, { "id": "eeb48b81-0464-4ec3-9577-6666279b71b2", "name": "Talkin' Things" }, { "id": "f40c7ba2-192e-4860-9b84-92296074c85c", "name": "Abu Dhabi Digital Authority" }, { "id": "0787b290-8773-4166-b6f1-ada0b5cf88c6", "name": "Casa do Impacto | Santa Casa da Misericórdia de Lisboa" }, { "id": "f23a1079-d8d1-4076-bcb3-57756367d0bd", "name": "NFON AG" }, { "id": "4c4dd4dc-d0ac-4cab-b7f4-03bef71c57c9", "name": "Builder" }, { "id": "a51691c0-b30c-4e95-a61a-f193789e8451", "name": "WeWork" }, { "id": "b7240231-17a5-48ab-bc39-0ab9c4072f53", "name": "La French Tech" }, { "id": "a422d659-67e4-4542-9208-b477c826a6b2", "name": "FUJITSU LIMITED" }, { "id": "ae661035-d177-4f0e-a6c2-ed1752a66374", "name": "Schneider Electric" }, { "id": "41f19eca-6ce9-4066-ae02-497ad5debe11", "name": "PCCW Global" }, { "id": "82b13c64-f7dd-431d-80fa-f2f0a830508a", "name": "T-Bull S.A." }, { "id": "a0e42a4d-5003-41e8-9cd3-98f676d9005d", "name": "Zadarma" }, { "id": "53454a8b-a448-4447-a844-8af1b77e9ecf", "name": "SPMS - Serviços Partilhados do Ministério da Saúde, E.P.E." }, { "id": "6032f174-2b76-47f7-bc27-bcfdd41c631e", "name": "Qatar Development Bank" }, { "id": "bc849a31-8162-4e79-8d23-b0bba6e1a501", "name": "Spain Pavilion" }, { "id": "853376ec-8d05-4a1b-9ba6-72d0f9403d15", "name": "StartUp Bahrain" }, { "id": "5177d055-df75-4f55-9470-3fe77209c017", "name": "Dentons Global Venture Tech Group" }, { "id": "af84006d-0ae5-4573-8c4d-59d33b11efa0", "name": "Thai Tech Startup Association" }, { "id": "31320d70-2a45-44b7-92ad-419425f3a85f", "name": "IESE Business School" }, { "id": "78017734-492a-431e-9e2a-c43ab9e29444", "name": "Ville de Montréal" }, { "id": "76c628ee-f4aa-4904-a08a-b3a3646446f3", "name": "VIC Properties" }, { "id": "abb7bc87-d9aa-46c9-91a4-1206854f8db2", "name": "Euroconsumers " }, { "id": "e5bf6839-8669-44fc-8426-e209df867294", "name": "Belgorod region, Russia" }, { "id": "3341c217-2039-4ac4-adc3-8fd94508bc9e", "name": "VINCI AIRPORTS" }, { "id": "87f5fc55-21c0-4a7c-ba23-d11633e92080", "name": "Freshworks " }, { "id": "79a54273-e56c-4203-aace-ced06c0dfbea", "name": "Altice Portugal" }, { "id": "beedc064-e499-4d26-ba50-2385215f17eb", "name": "App Annie" }, { "id": "557fad00-5234-47a4-8a1f-c8739127f5aa", "name": "Neo4j" }, { "id": "e8939ee4-2f37-46cf-8238-85ccd37c459c", "name": "Taguspark SA" }, { "id": "1c6c53a5-8a55-44e8-9b41-25d0fe473f5f", "name": "Airly" }, { "id": "10e0fa05-98ae-435d-8b1d-50f45493a46a", "name": "StartUp Sintra" }, { "id": "22973324-c07a-40b2-9c8f-ab311fd5868a", "name": "VideoMill" }, { "id": "6174d24e-cdcc-4535-965b-63c01b7aca4e", "name": "Mercedes-Benz.io GmbH" }, { "id": "0bffe6db-5588-4665-95a4-28006cb8eec1", "name": "Devskiller" }, { "id": "f63b4778-7ebd-499b-be6d-776e4d459134", "name": "Crios Group " }];
      /* eslint-enable */
    };
  }
}());

(function () {
  'use strict';

  /***
   * an md-card with toolbar title and menu, plus a single chart
   */
  angular
    .module('common')
    .component('zpChart', {
      templateUrl: 'app/common/widgets/zp-chart-component/zp-chart.tmpl.html',
      controller: 'zpChartCtrl',
      bindings: {
        chartId: '<',
        chartData: '<',
        chartSeries: '<',
        chartLabels: '<',
        chartType: '<',
        chartOptions: '<',
        chartClick: '&',
        menuOptions: '<',
        metadata: '<',
        menuItemClicked: '&',
        legendClick: '&',
        loading: '<'
      }
    })
    .controller('zpChartCtrl', chartController);

  chartController.$inject = ['$scope'];
  /* ng-inject */
  function chartController($scope) {

    var vm = this;

    function calculateStepSize(widgetData) {
      const maxVal = calculateRoundedMaxValue(widgetData);
      const desiredSteps = 10;
      const stepValue = Math.ceil(maxVal/desiredSteps);

      return stepValue;
    }

    function calculateRoundedMaxValue(widgetData){
      if (!widgetData || widgetData.length < 1) return 10;

      const maxValFromData = _.max(_.flatten(widgetData));
      const maxValWithoutDecimals = maxValFromData.toFixed(0);
      let digitLength = maxValWithoutDecimals.toString().length;

      if (digitLength === 0){
        digitLength = 1;
      }

      const zeroPlaceHolders = '0'.repeat(digitLength);

      let roundingGranularity = 1;

      if (zeroPlaceHolders.length > 1 && zeroPlaceHolders.length <= 2){
        roundingGranularity = 1;
      } else if (zeroPlaceHolders.length > 2 && zeroPlaceHolders.length <= 4){
        roundingGranularity = 2;
      } else if (zeroPlaceHolders.length > 4) {
        roundingGranularity = zeroPlaceHolders.length - 2;
      }

      const roundingStr = `1${zeroPlaceHolders.substring(0, roundingGranularity)}`;
      const roundingInt = parseInt(roundingStr);

      const maxVal = Math.ceil(maxValFromData/roundingInt) * roundingInt;

      return maxVal == 0 ? 10 : maxVal;
    }

    vm.$onChanges = function (changes) {
      if (changes.chartData && changes.chartData.isFirstChange()) {
        return;
      }
      if (changes.chartData) {
        vm.chartData = changes.chartData.currentValue;
        vm.$onInit();
      }
      if (changes.chartOptions && !_.isEqual(changes.chartOptions.previousValue, changes.chartOptions.currentValue)) {
        vm.chartOptionDefaults = _.extend({}, vm.chartOptionDefaults, changes.chartOptions.currentValue);
        if (changes.chartOptions.currentValue.scales) {
          delete vm.chartOptionDefaults.scale;
        } else {
          delete vm.chartOptionDefaults.scales;
        }
      }
    };

    vm.$onInit = function () {
      vm.chartOptionDefaults = {
        tooltips: {
          enabled: true
        },
        hover: {
          animationDuration: 1
        },
        animation: {
          duration: 1500,
          onComplete: function () {
            $scope.$emit('chartAnimation_onComplete');
          }
        },
        events: ['click', 'mousemove']
      };

      if (vm.chartType === 'line' || vm.chartType === 'bar') {
        vm.chartOptionDefaults.scales = {
          yAxes: [{
            type:'linear',
            ticks: {
              beginAtZero: true,
              steps: 10,
              stepSize: calculateStepSize(vm.chartData),
              min: 0,
              max: calculateRoundedMaxValue(vm.chartData)
            }
          }],
          xAxes: [{
          }]
        };
      }

      if (vm.chartOptions.legend.interactive) {
        vm.chartOptionDefaults.legend = {
          display: false,
          onClick: function (ev, legend) {
            vm.legendClick({ legendItem: legend });
          }
        };
      }

      angular.merge(vm.chartOptionDefaults, vm.chartOptions);
    };

    vm.chartClicked = function (points, MouseEvent, chartElement) {
      if (points.length) {
        vm.chartClick({
          chartEl: chartElement
        });
      }
    };
  }

}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpUserSelectChips', {
      templateUrl: 'app/common/widgets/zp-user-select-chips/user-select-chips.tmpl.html',
      controller: 'UserSelectChipsCtrl',
      bindings: {
        technicalContacts: '<',
        onChange: '&'
      }
    })
    .controller('UserSelectChipsCtrl', controller);

  controller.$inject = ['MessageService', 'UserFactory'];
  /* ng-inject */
  function controller(MessageService, UserFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.querySearch = querySearch;

      UserFactory.getUserList()
        .then(function (resp) {
          vm.items = _.chain(resp.items)
            .map(function (obj) {
              return {
                _id: obj.user._id,
                email: obj.user.email.raw,
                name: obj.user.firstname.raw + ' ' + obj.user.surname.raw
              };
            })
            .sortBy('email')
            .reverse()
            .value();

          buildModel();
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };

    function buildModel() {
      vm.model = [];
      
      // first map the existing model so that any recipients not in the user list are included
      var mappedExistingModel = _.map(vm.technicalContacts, function (obj){
        return {
          email: obj,
          name: obj
        };
      });

      var concattedItems = vm.items.concat(mappedExistingModel);


      var uniqueList = _.uniq(concattedItems, function (item, ix, items) { // eslint-disable-line no-unused-vars
        return item.email;
      });

      vm.model = _.filter(uniqueList, function (o) {
        return vm.technicalContacts.indexOf(o.email) > -1;
      });


    }

    // md-autocomplete function
    function querySearch(query) {
      return query ? vm.items.filter(createFilter(query)) : vm.items;
    }

    /**
     * Create filter function for a query string
     */
    function createFilter(query) {
      var lowercaseQuery = query.toLowerCase();
      return function filterFn(item) {
        return (item.email.toLowerCase().search(lowercaseQuery) != -1);
      };
    }

    vm.onModelChange = function (items) {
      vm.onChange({ items: items });
    };

  }
}());

(function() {
  angular
    .module('common')
    .component('zpTotalsTable', {
      templateUrl: 'app/common/widgets/zp-totals-table/zp-totals-table.tmpl.html',
      controller: 'zpTotalsTableCtrl',
      bindings: {
        header: '<',
        data: '<',
        id: '<'
      }
    })
    .controller('zpTotalsTableCtrl', zpTotalsTableCtrl);

  zpTotalsTableCtrl.$inject = ['FormMetadataFactory', 'CurrencyHelperService'];
  /* ng-inject */
  function zpTotalsTableCtrl(FormMetadataFactory, CurrencyHelperService) {

    var vm = this;
    var formMetadata = FormMetadataFactory.getData();

    var currencyCode = 'USD'; //set default to US Dollar

    if (formMetadata.formProperties && formMetadata.formProperties.currencyCode){
      currencyCode = formMetadata.formProperties.currencyCode;
    }

    vm.$onInit = function () {
      // $log.info('totals table vm.$onInit');
    };

    vm.processCount = function (value){
      if (vm.id == 'revenueTeamPerformance'){

        return CurrencyHelperService.formatViaCurrencyCode(value, currencyCode);
      }

      return value;
    };

    vm.$onChanges = function (changes) {
      if (changes.data) {
        vm.data = changes.data.currentValue;
        vm.loading = false;
      }
    };


  }
}());

(function() {
  angular
    .module('common')
    .component('zpStatChart', {
      templateUrl: 'app/common/widgets/zp-stat-chart/zp-stat-chart.tmpl.html',
      controller: 'zpStatChartCtrl',
      bindings: {
        chartData: '<',
        chartLabels: '<',
        chartOptions: '<',
        metadata: '<'
      }
    })
    .controller('zpStatChartCtrl', zpStatChartCtrl);

  zpStatChartCtrl.$inject = ['$log'];
  /* ng-inject */
  function zpStatChartCtrl($log) {

    var vm = this;

    vm.$onInit = function () {
      angular.merge(vm.chartOptionDefaults, vm.chartOptions);
      vm.chartType='doughnut';
    };

    vm.$onChanges = function (changes) {
      if (changes.chartData) {
        vm.chartData = changes.chartData.currentValue;
        vm.loading = false;
      }
    };

    vm.chartClicked = function (points) {
      vm.chartClick({
        index: points[0]._index
      });
    };

    vm.chartOptionDefaults = {
      tooltips: {
        enabled: true
      },
      hover: {
        animationDuration: 1
      },
      animation: {
        duration: 1500,
        onComplete: function () {
          $log.info('chart animation complete');
          // $scope.$emit('chartAnimation_onComplete');
        }
      }
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpSelectControl', {
      templateUrl: 'app/common/widgets/zp-select-control/zp-select-control.tmpl.html',
      controller: 'ZuantSelectCtrl',
      bindings: {
        model: '<',
        onChange: '&',
        config: '<',
        formname: '<'
      }
    })
    .controller('ZuantSelectCtrl', controller);

  controller.$inject = ['TimezonesFactory'];
  /* ng-inject */
  function controller(TimezonesFactory) {

    var vm = this;
    vm.items = TimezonesFactory;
    vm.searchText = '';
    vm.querySearch = querySearch;
    vm.searchText = null;
    vm.selectedItem = [];

    vm.$onInit = function () {
      locateSelectedItem();
    };

    vm.$onChanges = function (changes) {
      if (changes.model && changes.model.isFirstChange()) {
        return;
      }
      if (changes.model) {
        vm.model = changes.model.currentValue;
        locateSelectedItem();
      }
    };

    function locateSelectedItem() {
      var selectedItem = _.filter(vm.items, function (o) {
        return o.title == vm.model;
      });
      vm.selectedItem = selectedItem[0];
    }

    // md-autocomplete function
    function querySearch(query) {
      return query ? vm.items.filter(createFilter(query)) : vm.items;
    }

    /**
     * Create filter function for a query string
     */
    function createFilter(query) {
      try {
        var lowercaseQuery = query.toLowerCase();
        return function filterFn(item) {
          return (item.title.toLowerCase().search(lowercaseQuery) != -1);
        };
      } catch (e) {
        //
      }
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpPrivacyStatementsSelectControl', {
      templateUrl: 'app/common/widgets/zp-privacy-statements/zp-privacy-statements.tmpl.html',
      controller: 'PrivacyStatementSelectCtrl',
      bindings: {
        model: '<',
        onChange: '&',
        config: '<'
      }
    })
    .controller('PrivacyStatementSelectCtrl', controller);

  controller.$inject = ['PrivacyStatementsApiFactory', 'MessageService'];
  /* ng-inject */
  function controller(PrivacyStatementsApiFactory, MessageService) {

    var vm = this;

    vm.$onInit = function () {
      vm.searchText = '';
      vm.querySearch = querySearch;
      vm.searchText = '';
      vm.selectedItem;
      vm.items = [];

      var params = {
        options: {
          includeVersionHistory: 0
        },
        queryObj: {
          parameters: {
            artefactType: 'PrivacyStatement'
          },
          fields: {
            _lastmodifieddatelocalutc: 1,
            _deletedatelocalutc: 1,
            isPrimaryStatement: 1,
            title: 1
          }
        }
      };

      PrivacyStatementsApiFactory.fetchPrivacyStatementsFromServer(params)
        .then(function (resp) {
          vm.items = _.extend(vm.items, _.chain(resp)
            .map(function (obj) {
              return {
                _id: obj._id,
                icn: obj.isPrimaryStatement,
                title: obj.title,
                modified: obj._lastmodifieddatelocalutchey
              };
            })
            .sortBy('icn')
            .reverse()
            .value());
          locateSelectedItem();
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };

    vm.$onChanges = function (changes) {
      if (changes.model && changes.model.isFirstChange()) {
        return;
      }
      if (changes.model) {
        vm.model = changes.model.currentValue;
        locateSelectedItem();
      }
    };

    function locateSelectedItem() {
      if (!vm.model) return;
      var selectedItem = _.filter(vm.items, function (o) {
        return o._id == vm.model;
      });
      vm.selectedItem = selectedItem[0];

    }

    // md-autocomplete function
    function querySearch(query) {
      return query ? vm.items.filter(createFilter(query)) : vm.items;
    }

    /**
     * Create filter function for a query string
     */
    function createFilter(query) {
      var lowercaseQuery = query.toLowerCase();
      return function filterFn(item) {
        return (item.title.toLowerCase().search(lowercaseQuery) != -1);
      };
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpOcrTemplatesList', {
      templateUrl: 'app/common/widgets/zp-ocr-templates-select/zp-ocr-templates.tmpl.html',
      controller: 'OCRTemplatesListCtrl',
      bindings: {
        model: '<',
        onChange: '&',
        config: '<'
      }
    })
    .controller('OCRTemplatesListCtrl', controller);

  controller.$inject = ['OCRTemplatesFactory'];
  /* ng-inject */
  function controller(OCRTemplatesFactory) {

    var vm = this;
    vm.items = [];
    vm.searchText = '';
    vm.querySearch = querySearch;
    vm.searchText = '';
    vm.selectedItem;

    vm.$onInit = function () {
      OCRTemplatesFactory.getOCRtemplates()
        .then(function (resp) {
          vm.items = _.map(resp.itemsObject, function (obj) {
            return {
              _id: obj.list._id,
              title: obj.list.title
            };
          });
          locateSelectedItem();
        });
    };

    function locateSelectedItem() {
      if(!vm.model) return;
      var selectedItem = _.filter(vm.items, function (o){
        return o._id == vm.model;
      });
      vm.selectedItem = selectedItem[0];
    }

    // md-autocomplete function
    function querySearch(query) {
      return query ? vm.items.filter(createFilter(query)) : vm.items;
    }

    /**
     * Create filter function for a query string
     */
    function createFilter(query) {
      var lowercaseQuery = query.toLowerCase();
      return function filterFn(item) {
        return (item.title.toLowerCase().search(lowercaseQuery) != -1);
      };
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpListTemplatesSelectControl', {
      templateUrl: 'app/common/widgets/zp-list-templates-select/zp-list-templates-select.tmpl.html',
      controller: 'ListTemplatesSelectCtrl',
      bindings: {
        model: '=',
        onChange: '&',
        config: '<'
      }
    })
    .controller('ListTemplatesSelectCtrl', controller);

  controller.$inject = ['ListApiFactory'];
  /* ng-inject */
  function controller(ListApiFactory) {

    var vm = this;
    vm.items = [];
    vm.searchText = '';
    vm.selectedItem = null;

    vm.$onInit = function () {
      ListApiFactory.getListTemplates()
        .then(function (resp) {
          vm.items = resp;
          locateSelectedItem();
        });
    };

    function locateSelectedItem() {
      if (!vm.model) return;
      const selectedItem = _.filter(vm.items, function (o) {
        return o._id == vm.model;
      });
      vm.selectedItem = selectedItem[0];
    }

    vm.selectedItemChanged = function (selection) {
      vm.model = selection ? selection._id : null;
    };

    // md-autocomplete function
    vm.querySearch = function (query) {
      return query ? vm.items.filter(createFilter(query)) : vm.items;
    };

    /**
     * Create filter function for a query string
     */
    function createFilter(query) {
      const lowercaseQuery = query.toLowerCase();
      return function filterFn(item) {
        return (item.title.toLowerCase().search(lowercaseQuery) != -1);
      };
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpListAutocompleteControl', {
      templateUrl: 'app/common/widgets/zp-list-autocomplete/zp-list-autocomplete.tmpl.html',
      controller: 'ListAutocompleteCtrl',
      bindings: {
        model: '=',
        items: '=',
        onChange: '&',
        config: '<'
      }
    })
    .controller('ListAutocompleteCtrl', controller);

  controller.$inject = [];
  /* ng-inject */
  function controller() {

    var vm = this;

    vm.searchText = '';
    vm.selectedItem = null;

    vm.$onInit = function (){
      locateSelectedItem();
    };

    vm.selectedItemChanged = function (selection) {
      vm.model = selection ? selection._id : null;
    };

    function locateSelectedItem() {
      if (!vm.model) return;
      const selectedItem = _.filter(vm.items, function (o) {
        return o._id == vm.model;
      });
      vm.selectedItem = selectedItem[0];
    }

    // md-autocomplete function
    vm.querySearch = function(query) {
      return query ? vm.items.filter(createFilter(query)) : vm.items;
    };

    /**
     * Create filter function for a query string
     */
    function createFilter(query) {
      const lowercaseQuery = query.toLowerCase();
      return function filterFn(item) {
        return (item.title.toLowerCase().search(lowercaseQuery) != -1);
      };
    }
  }
}());

(function () {
  'use strict';

  /** Used in mappings transform dialog to show a list of widget answers
   */

  angular
    .module('common')
    .component('zpFormWidgetSelectControl', {
      templateUrl: 'app/common/widgets/zp-form-widget-select/zp-form-widget-select.tmpl.html',
      controller: 'FormWidgetSelectCtrl',
      bindings: {
        model: '<',
        onChange: '&',
        config: '<',
        selectedItem: '<'
      }
    })
    .controller('FormWidgetSelectCtrl', controller);

  controller.$inject = ['FormMetadataFactory', 'ListsGeneralFactory', 'MessageService'];
  /* ng-inject */
  function controller(FormMetadataFactory, ListsGeneralFactory, MessageService) {

    var vm = this;

    vm.$onInit = function () {
      vm.searchText = '';
      vm.querySearch = querySearch;
      vm.items = [];
      vm.formMetaData = FormMetadataFactory.getData();
      if (vm.formMetaData.formProperties._id !== vm.config.formId) alert('the form doesn\'t match the machine form!');
      buildAnswerItems();
      locateSelectedItem();
    };

    function buildAnswerItems() {
      var widget = vm.formMetaData.columnsData.itemsObject[[vm.config.widgetId.collection] + '_' + [vm.config.widgetId.element]];
      vm.floatingLabel = widget.label;
      if (widget.requiresCustomList) {
        ListsGeneralFactory.getListById(widget.customListId)
          .then(function (res) {
            vm.items = _.chain(res.itemsForSelectControl)
              .sortBy('displayValue')
              .value();
          })
          .catch(function (err) {
            MessageService.writeLog({
              level: 'error',
              msg: err,
              tags: ['load_remote_list', 'integration_transform_dialog']
            });
          });
      } else {
        vm.items = _.chain(widget.answers)
          .sortBy('displayValue')
          .value();
      }
    }

    function locateSelectedItem() {
      if (!vm.model) return;
      var selectedItem = _.filter(vm.items, function (o) {
        return o._id == vm.model;
      });
      vm.selectedItem = selectedItem[0];
    }

    // md-autocomplete function
    function querySearch(query) {
      return query ? vm.items.filter(createFilter(query)) : vm.items;
    }

    /**
     * Create filter function for a query string
     */
    function createFilter(query) {
      const lowercaseQuery = query.toLowerCase();
      return function filterFn(item) {
        return (item.title.toLowerCase().search(lowercaseQuery) != -1);
      };
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpFormSelectControl', {
      templateUrl: 'app/common/widgets/zp-form-select/zp-form-select.tmpl.html',
      controller: 'FormSelectCtrl',
      bindings: {
        model: '<',
        onChange: '&',
        config: '<'
      }
    })
    .controller('FormSelectCtrl', controller);

  controller.$inject = ['FormsFactory', 'MessageService', 'ZuantAccountManagersFactory'];
  /* ng-inject */
  function controller(FormsFactory, MessageService, ZuantAccountManagersFactory) {

    var vm = this;

    vm.$onChanges = function (changes) {
      if (changes.model) {
        if (changes.model.currentValue) {
          try {
            if (changes.model.currentValue.item) {
              if (changes.model.currentValue.item._id === 'websummit_2024') {
                const templateInList = _.find(vm.items, function (item) {
                  return item._id === 'websummit_2024';
                });
                if (!templateInList) {
                  vm.items.unshift(vm.model.item);
                }
                vm.model = 'websummit_2024';
                locateSelectedItem();
              }
              if (changes.model.currentValue.item._id === 'ieee_2022') {
                const templateInListIEEE = _.find(vm.items, function (item) {
                  return item._id === 'ieee_2022';
                });
                if (!templateInListIEEE) {
                  vm.items.unshift(vm.model.item);
                }
                vm.model = 'ieee_2022';
                locateSelectedItem();
              }
              if (changes.model.currentValue.item._id === 'ieee_2026_esw') {
                const templateInListIEEE23 = _.find(vm.items, function (item) {
                  return item._id === 'ieee_2026_esw';
                });
                if (!templateInListIEEE23) {
                  vm.items.unshift(vm.model.item);
                }
                vm.model = 'ieee_2026_esw';
                locateSelectedItem();
              }
              if (changes.model.currentValue.item._id === 'ieee_2023_selections_congress') {
                const templateInListIEEE23QR = _.find(vm.items, function (item) {
                  return item._id === 'ieee_2023_selections_congress';
                });
                if (!templateInListIEEE23QR) {
                  vm.items.unshift(vm.model.item);
                }
                vm.model = 'ieee_2023_selections_congress';
                locateSelectedItem();
              }
              if (changes.model.currentValue.item._id === 'collision_2023') {
                const templateInListCollision = _.find(vm.items, function (item) {
                  return item._id === 'collision_2023';
                });
                if (!templateInListCollision) {
                  vm.items.unshift(vm.model.item);
                }
                vm.model = 'collision_2023';
                locateSelectedItem();
              }
              if (changes.model.currentValue.item._id === 'thenextweb_2022') {
                const templateInListTheNextWeb = _.find(vm.items, function (item) {
                  return item._id === 'thenextweb_2022';
                });
                if (!templateInListTheNextWeb) {
                  vm.items.unshift(vm.model.item);
                }
                vm.model = 'thenextweb_2022';
                locateSelectedItem();
              }
              if (changes.model.currentValue.item._id === 'sibs_2022') {
                const templateInListSouthhamptonBoatShow = _.find(vm.items, function (item) {
                  return item._id === 'sibs_2022';
                });
                if (!templateInListSouthhamptonBoatShow) {
                  vm.items.unshift(vm.model.item);
                }
                vm.model = 'sibs_2022';
                locateSelectedItem();
              }
              if (changes.model.currentValue.item._id === 'esgct_2024') {
                const templateInListESGCT2024 = _.find(vm.items, function (item) {
                  return item._id === 'esgct_2024';
                });
                if (!templateInListESGCT2024) {
                  vm.items.unshift(vm.model.item);
                }
                vm.model = 'esgct_2024';
                locateSelectedItem();
              }
              if (changes.model.currentValue.item._id === 'iemdc_2025') {
                const templateInListIEMDC2025 = _.find(vm.items, function (item) {
                  return item._id === 'iemdc_2025';
                });
                if (!templateInListIEMDC2025) {
                  vm.items.unshift(vm.model.item);
                }
                vm.model = 'iemdc_2025';
                locateSelectedItem();
              }
              if (changes.model.currentValue.item._id === 'nls_2026_days') {
                const templateInListNLSDays2026 = _.find(vm.items, function (item) {
                  return item._id === 'nls_2026_days';
                });
                if (!templateInListNLSDays2026) {
                  vm.items.unshift(vm.model.item);
                }
                vm.model = 'nls_2026_days';
                locateSelectedItem();
              }
            }
          } catch (e) {
            //
          }
        }
      }
    };

    vm.$onInit = function () {
      vm.searchText = '';
      vm.querySearch = querySearch;
      vm.searchText = '';
      vm.selectedItem;
      vm.items = [];
      vm.userIsAZam = ZuantAccountManagersFactory.loggedInUserIsAZam();
      let includeArchivedForms = true;
      FormsFactory.getAllForms(includeArchivedForms)
        .then(function (resp) {
          vm.items = _.chain(resp.items)
            .map(function (obj) {
              return {
                _id: obj.form._id,
                title: obj.form.formname.raw,
                icn: obj.form.icn.raw,
                isAvailableAsFormTemplate: obj.form.isAvailableAsFormTemplate.raw
              };
            })
            .sortBy('icn')
            .reverse()
            .value();
          if (vm.config) {
            if (vm.config.filter == 'formTemplates') {
              vm.items = _.filter(vm.items, function (form) {
                return form.isAvailableAsFormTemplate;
              });
              // add the 2 standard templates that all accounts have (see zuant_back_end/models for their json)
              vm.items.unshift({
                _id: 'scan_n_go',
                title: 'Scan n go template'
              });
              vm.items.unshift({
                _id: 'standard_template',
                title: 'Standard template'
              });
              if (vm.userIsAZam) {
                /** POTATO */
                // vm.items.unshift({
                //   _id: 'websummit_2019',
                //   title: 'WebSummit 2019 Template'
                // });
              }
            } else if (vm.config.filter == 'accountCreation') {
              vm.items = [];
              // add the 2 standard templates that all accounts have (see zuant_back_end/models for their json)
              vm.items.push({
                _id: 'scan_n_go',
                title: 'Scan n go template'
              });
              vm.items.push({
                _id: 'standard_template',
                title: 'Standard template'
              });
            }
          }

          locateSelectedItem();
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };

    function locateSelectedItem() {
      if (!vm.model) return;
      const selectedItem = _.filter(vm.items, function (o) {
        return o._id == vm.model;
      });
      vm.selectedItem = selectedItem[0];
    }

    // md-autocomplete function
    function querySearch(query) {
      return query ? vm.items.filter(createFilter(query)) : vm.items;
    }

    /**
     * Create filter function for a query string
     */
    function createFilter(query) {
      const lowercaseQuery = query.toLowerCase();
      return function filterFn(item) {
        return (item.title.toLowerCase().search(lowercaseQuery) != -1);
      };
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .component('zpFormFiltersControl', {
      templateUrl: 'app/common/widgets/zp-form-filters-control/form-filters.tmpl.html',
      controller: 'FormFiltersControlCtrl',
      bindings: {
        rawFilters: '<',
        onChange: '&',
        onClearFilters: '&'
      }
    })
    .controller('FormFiltersControlCtrl', controller);

  controller.$inject = ['MessageService', 'FormsFactory', 'PermPermissionStore'];
  /* ng-inject */
  function controller(MessageService, FormsFactory, PermPermissionStore) {

    var vm = this;

    vm.$onInit = function () {
      vm.showMissMatchWarning = false;
      vm.showClearConfirmation = false;
      vm.querySearch = querySearch;

      checkPermissions();
      validateFilters();

      FormsFactory.getAllForms()
        .then(function (resp) {
          vm.items = _.chain(resp.items)
            .map(function (obj) {
              return {
                _id: obj.form._id,
                title: obj.form.formname.raw,
                icn: obj.form.icn.raw,
                isSelected: vm.rawFilters.indexOf(obj.form._id) > -1
              };
            })
            .sortBy('icn')
            .reverse()
            .value();

          buildModel();
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };

    function validateFilters() {
      if (!vm.rawFilters) vm.rawFilters = [];
    }

    function buildModel() {
      vm.filtersHydrated = [];
      var selectedItems = _.filter(vm.items, function (o) {
        return vm.rawFilters.indexOf(o._id) > -1;
      });
      vm.filtersHydrated = selectedItems;
      vm.showMissMatchWarning = (vm.rawFilters.length !== vm.filtersHydrated.length);
    }

    // md-autocomplete function
    function querySearch(query) {
      return query ? vm.items.filter(createFilter(query)) : vm.items;
    }

    /**
     * Create filter function for a query string
     */
    function createFilter(query) {
      const lowercaseQuery = query.toLowerCase();
      return function filterFn(item) {
        return (item.title.toLowerCase().search(lowercaseQuery) != -1);
      };
    }

    vm.onAdd = function (chip) {

      vm.rawFilters.push(chip._id);
      chip.isSelected = true;
      vm.onChange({
        filters: vm.rawFilters
      });
    };

    vm.onRemove = function (chip) {
      if (typeof chip === 'object') {
        var ix = vm.rawFilters.indexOf(chip._id);
        vm.rawFilters.splice(ix, 1);
        chip.isSelected = false;
        vm.onChange({
          filters: vm.rawFilters
        });
      }
    };

    vm.onClear = function () {
      vm.showClearConfirmation = true;
    };

    vm.clearConfirmation = function () {
      vm.filtersHydrated.forEach(filter => {
        vm.onRemove(filter);
      });
      vm.rawFilters.length = 0;
      vm.filtersHydrated.length = 0;
      vm.onClearFilters();
      vm.showClearConfirmation = false;
    };

    vm.updateFilters = function () {
      vm.onChange({
        filters: vm.rawFilters
      });
    };

    function checkPermissions() {
      var permission = PermPermissionStore.getPermissionDefinition('INTEGRATION_MACHINES_EDIT');
      permission.validatePermission()
        .then(function () {
          vm.readonly = false;
        })
        .catch(function () {
          vm.readonly = true;
        });
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpEmailTemplateSelectControl', {
      templateUrl: 'app/common/widgets/zp-email-templates/zp-email-templates.tmpl.html',
      controller: 'EmailTemplateSelectCtrl',
      bindings: {
        model: '<',
        onChange: '&',
        config: '<',
        disabled: '<',
        context: '<',
        items: '=?'
      }
    })
    .controller('EmailTemplateSelectCtrl', controller);

  controller.$inject = ['EmailTemplatesFactory', 'MessageService', 'SessionService'];
  /* ng-inject */
  function controller(EmailTemplatesFactory, MessageService, SessionService) {

    var vm = this;
    vm.searchText = '';
    vm.selectedItem = null;

    vm.$onInit = function () {
      vm.session = SessionService;

      //if items have been passed in we don't want to call the server again for what we already have
      if (vm.items) {
        return locateSelectedItem();
      }
      vm.items = [];

      EmailTemplatesFactory.getTemplatesList()
        .then(function (resp) {
          vm.items = _.extend(vm.items, _.chain(resp.items)
            .map(function (obj) {
              return {
                _id: obj.emailtemplate._id,
                icn: obj.emailtemplate.icn.raw,
                title: obj.emailtemplate.title.raw
              };
            })
            .sortBy('icn')
            .reverse()
            .value());
          if (vm.context == 'formSettings') {
            vm.items.unshift({ _id: '', icn: 'power', title: 'No email template attached' });
          }
          locateSelectedItem();
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };

    vm.$onChanges = function (changes) {
      if (changes.model && changes.model.isFirstChange()) {
        return;
      }
      if (changes.model) {
        vm.model = changes.model.currentValue;
        locateSelectedItem();
      }
    };

    vm.onChangeLocal = function (item) {
      // if (!item.item) item.item = { _id: '', label: 'clear' };
      vm.onChange(item);
    };

    function locateSelectedItem() {
      const selectedItem = _.filter(vm.items, function (o) {
        return o._id == vm.model;
      });
      vm.selectedItem = selectedItem[0];

    }

    // md-autocomplete function
    vm.querySearch = function(query) {
      return query ? vm.items.filter(createFilter(query)) : vm.items;
    };

    /**
     * Create filter function for a query string
     */
    function createFilter(query) {
      const lowercaseQuery = query.toLowerCase();
      return function filterFn(item) {
        return (item.title.toLowerCase().search(lowercaseQuery) != -1);
      };
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpBlocksList', {
      templateUrl: 'app/common/widgets/zp-blocks-select/zp-blocks.tmpl.html',
      controller: 'BlocksListCtrl',
      bindings: {
        model: '<',
        onChange: '&',
        config: '<',
        loadItems: '<'
      }
    })
    .controller('BlocksListCtrl', BlocksListCtrl);

  BlocksListCtrl.$inject = ['ShowroomBlocksFactory'];

  function BlocksListCtrl(ShowroomBlocksFactory) {
    const vm = this;

    vm.items = [];
    vm.searchText = '';
    vm.selectedItem = null;
    vm.loading = false;

    vm.$onInit = () => {};

    vm.$onChanges = (changes) => {
      const change = changes && changes.loadItems;
      if (!change) return;
      if (_.isFunction(change.isFirstChange) && change.isFirstChange()) return;
      if (change.currentValue) loadBlocks();
    };

    vm.querySearch = (query) => {
      if (!query) return vm.items;

      const q = _.toLower(_.trim(_.toString(query)));
      return _.filter(vm.items, (item) => includesNameplate(item, q));
    };

    vm.onChangeLocal = (item) => {
      vm.onChange({
        property1: 'blocksMenu',
        property2: 'entryBlock',
        newValue: getId(item)
      });
    };

    function loadBlocks() {
      vm.loading = true;

      return ShowroomBlocksFactory.getShowroomBlocks()
        .then((res) => {
          const items = res && res.items;
          vm.items = _.isArray(items) ? items : [];
          syncSelectedItem();
        })
        .finally(() => {
          vm.loading = false;
        });
    }

    function syncSelectedItem() {
      const selectedId = vm.model;
      if (!selectedId) {
        vm.selectedItem = null;
        return;
      }

      vm.selectedItem =
        _.find(vm.items, (item) => item && _.toString(item._id) === _.toString(selectedId)) || null;
    }

    function includesNameplate(item, lowercaseQuery) {
      const nameplate = item && item.nameplate;
      if (!nameplate) return false;

      const haystack = _.toLower(_.toString(nameplate));
      return _.includes(haystack, lowercaseQuery);
    }

    function getId(item) {
      return item && item._id ? item._id : '';
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpNewBadge', {
      bindings: {},
      controller: componentController,
      templateUrl: 'app/common/user-helpers/zp-new-badge/zp-new-badge.tmpl.html'
    });

  function componentController() {
    var vm = this;

    vm.$onInit = function () {};

  }

}());
/**
 * Created by davidbeazer on 19/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('common')
    .component('zpInstanceToolbar', {
      templateUrl: 'app/common/toolbars/instance-toolbar/zp-instance-toolbar.tmpl.html',
      bindings: {
        title: '@',
        navigateTo: '<',
        menuOptions: '<'
      }
    })
    .controller('zpInstanceToolbarController', zpInstanceToolbarController);

  zpInstanceToolbarController.$inject = [];
  /* ng-inject */
  function zpInstanceToolbarController() {

  }

})();

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpTitleToolbar', {
      templateUrl: 'app/common/toolbars/title-toolbar/zp-title-toolbar.tmpl.html',
      controller: 'zpTitleToolbarCtrl',
      bindings: {}
    })
    .controller('zpTitleToolbarCtrl', zpTitleToolbarCtrl);

  zpTitleToolbarCtrl.$inject = ['ToolbarFactory'];
  /* ng-inject */
  function zpTitleToolbarCtrl(ToolbarFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.toolbar = ToolbarFactory.factoryData;
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .factory('ToolbarFactory', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    var factoryData = {
      title: '',
      navigationPath: '',
      showBackButton: false,
      customStateParams: {
        isDirtyCheck: false
      }
    };

    return {
      set: set,
      factoryData: factoryData
    };

    function set(toolbarConfig) {
      factoryData = _.extend(factoryData, toolbarConfig);
    }

  }

}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpSearchToolbar', {
      controller: 'SearchToolbarController',
      templateUrl: 'app/common/toolbars/search-toolbar/zp-search-toolbar.tmpl.html',
      bindings: {
        metadata: '<',
        menuOptions: '<',
        onMenuClick: '&'
      }
    })
    .controller('SearchToolbarController', controller);

  controller.$inject = ['SearchValFactory'];
  /* ng-inject */
  function controller(SearchValFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.searchVal = SearchValFactory.get(vm.metadata.id);
      vm.showSearch = vm.searchVal.searchVal;
    };

    vm.toggleShowSearchBar = function () {
      vm.showSearch = !vm.showSearch;
      SearchValFactory.set(vm.metadata.id, '');
    };
  }

}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('SearchValFactory', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    var factoryData = {};

    return {
      set: set,
      get: get,
      factoryData: factoryData
    };

    function set(id, val) {
      if (!factoryData[id]) {
        factoryData[id] = {
          searchVal: ''
        };
      }
      factoryData[id].searchVal = val;
    }

    function get(id) {
      if (!factoryData[id]) {
        factoryData[id] = {
          searchVal: ''
        };
      }
      return factoryData[id];
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpElevatedSecurityToolbar', {
      bindings: {},
      controller: 'ElevatedSecurityToolbarCtrl',
      templateUrl: 'app/common/toolbars/elevated-security-toolbar/zp-elevated-security-toolbar.tmpl.html'
    })
    .controller('ElevatedSecurityToolbarCtrl', controller);

  controller.$inject = ['CurrentClientModelFactory', '$interval', 'ChangeDelta', '$timeout', 'MessageService', '$state'];
  /* ng-inject */
  function controller(CurrentClientModel, $interval, ChangeDelta, $timeout, MessageService, $state) {
    var vm = this;

    vm.$onInit = function () {
      vm.factoryData = CurrentClientModel.factoryData;
      vm.timeExpiryWarning = false;
      vm.timeExpired = false;
      vm.disableBtn = false;
      $interval(function () {
        if (CurrentClientModel.factoryData.userPermittedToMakeGDPREdits.permitted) {
          vm.countdown = moment().to(CurrentClientModel.factoryData.userPermittedToMakeGDPREdits.expires);
          const nowDate = new moment();
          const expiryDate = new moment(CurrentClientModel.factoryData.userPermittedToMakeGDPREdits.expires);
          const duration = moment.duration(nowDate.diff(expiryDate)).as('minutes');
          vm.timeExpiryWarning = (duration > -10);
          const expired = nowDate.isAfter(expiryDate);
          vm.timeExpired = expired;
        }
        vm.userIsOnAccountSettingsPages = ($state.current.name.indexOf('app.tabbed_app_framework.client_detail') !== -1) ? true : false;
      }, 1000);
    };

    vm.endEditSession = function () {
      if (ChangeDelta.isDirty()) {
        if (!confirm('👋 Heads up!\nYou have some unsaved changes.\n\nClick OK to continue without saving or Cancel to stay put.')) {
          return;
        }
      }

      MessageService.writeLog({
        level: 'info',
        msg: 'ending GDPR edit session',
        tags: ['GDPR edit']
      });
      vm.disableBtn = true;
      $timeout(function () {
        CurrentClientModel.endElevatedEditSession();
        vm.disableBtn = false;
      }, 1000);
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpAppToolbar', {
      controller: 'MenuCtrl',
      templateUrl: 'app/common/toolbars/app-toolbar/zp-app-toolbar.tmpl.html',
      bindings: {}
    });
})();

(function () {
  'use strict';

  angular
    .module('common')
    .factory('RowSelectionManager', RowSelectionManager);

  RowSelectionManager.$inject = ['MessageService', '$q', 'LeadDataFactory', 'ChangeDelta', 'GridDataFactory'];
  /* ng-inject */
  function RowSelectionManager(MessageService, $q, LeadDataFactory, ChangeDelta, GridDataFactory) {

    return {
      deleteRows: deleteRows
    };

    function deleteRows(ev, widgetId) {

      MessageService
        .confirm(ev)
        .delete('Sure to delete ' + GridDataFactory.factoryData[widgetId].selectedItems.length + ' items?')
        .then(function () {
          GridDataFactory.removeSelectedItemsFromFactory(widgetId);
          // return performDeletion(rowsToDelete);
        })
        .then(function () {
          // archiveTidyUp(leadsToArchive);
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: 'error archiving leads: ' + err,
            tags: ['lead_archive']
          });
          throw (err);
        });
    }

  }
}());

angular.module('md.table.templates', ['md-table-pagination.html', 'md-table-progress.html', 'arrow-up.svg', 'navigate-before.svg', 'navigate-first.svg', 'navigate-last.svg', 'navigate-next.svg']);

angular.module('md-table-pagination.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('md-table-pagination.html',
    '<div class="page-select" ng-if="$pagination.showPageSelect()">\n' +
    '  <div class="label">{{$pagination.label.page}}</div>\n' +
    '\n' +
    '  <md-select virtual-page-select total="{{$pagination.pages()}}" class="md-table-select" ng-model="$pagination.page" md-container-class="md-pagination-select" ng-change="$pagination.onPaginationChange()" ng-disabled="$pagination.disabled" aria-label="Page">\n' +
    '    <md-content>\n' +
    '      <md-option ng-repeat="page in $pageSelect.pages" ng-value="page">{{page}}</md-option>\n' +
    '    </md-content>\n' +
    '  </md-select>\n' +
    '</div>\n' +
    '\n' +
    '<div class="limit-select" ng-if="$pagination.limitOptions">\n' +
    '  <div class="label">{{$pagination.label.rowsPerPage}}</div>\n' +
    '\n' +
    '  <md-select class="md-table-select" ng-model="$pagination.limit" md-container-class="md-pagination-select" ng-disabled="$pagination.disabled" aria-label="Rows" placeholder="{{ $pagination.limitOptions[0] }}">\n' +
    '    <md-option ng-repeat="option in $pagination.limitOptions" ng-value="option.value ? $pagination.eval(option.value) : option">{{::option.label ? option.label : option}}</md-option>\n' +
    '  </md-select>\n' +
    '</div>\n' +
    '\n' +
    '<div class="buttons">\n' +
    '  <div class="label">{{$pagination.min()}} - {{$pagination.max()}} {{$pagination.label.of}} {{$pagination.total}}</div>\n' +
    '\n' +
    '  <md-button class="md-icon-button" type="button" ng-if="$pagination.showBoundaryLinks()" ng-click="$pagination.first()" ng-disabled="$pagination.disabled || !$pagination.hasPrevious()" aria-label="First">\n' +
    '    <md-icon md-svg-icon="navigate-first.svg"></md-icon>\n' +
    '  </md-button>\n' +
    '\n' +
    '  <md-button class="md-icon-button" type="button" ng-click="$pagination.previous()" ng-disabled="$pagination.disabled || !$pagination.hasPrevious()" aria-label="Previous">\n' +
    '    <md-icon md-svg-icon="navigate-before.svg"></md-icon>\n' +
    '  </md-button>\n' +
    '\n' +
    '  <md-button class="md-icon-button" type="button" ng-click="$pagination.next()" ng-disabled="$pagination.disabled || !$pagination.hasNext()" aria-label="Next">\n' +
    '    <md-icon md-svg-icon="navigate-next.svg"></md-icon>\n' +
    '  </md-button>\n' +
    '\n' +
    '  <md-button class="md-icon-button" type="button" ng-if="$pagination.showBoundaryLinks()" ng-click="$pagination.last()" ng-disabled="$pagination.disabled || !$pagination.hasNext()" aria-label="Last">\n' +
    '    <md-icon md-svg-icon="navigate-last.svg"></md-icon>\n' +
    '  </md-button>\n' +
    '</div>');
}]);

angular.module('md-table-progress.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('md-table-progress.html',
    '<tr>\n' +
    '  <th colspan="{{columnCount()}}">\n' +
    '    <md-progress-linear ng-show="deferred()" md-mode="indeterminate"></md-progress-linear>\n' +
    '  </th>\n' +
    '</tr>');
}]);

angular.module('arrow-up.svg', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('arrow-up.svg',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/></svg>');
}]);

angular.module('navigate-before.svg', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('navigate-before.svg',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>');
}]);

angular.module('navigate-first.svg', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('navigate-first.svg',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7 6 v12 h2 v-12 h-2z M17.41 7.41L16 6l-6 6 6 6 1.41-1.41L12.83 12z"/></svg>');
}]);

angular.module('navigate-last.svg', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('navigate-last.svg',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15 6 v12 h2 v-12 h-2z M8 6L6.59 7.41 11.17 12l-4.58 4.59L8 18l6-6z"/></svg>');
}]);

angular.module('navigate-next.svg', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('navigate-next.svg',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>');
}]);

(function () {
  'use strict';

  angular
    .module('common')
    .factory('PaginationManager', PaginationManager);

  PaginationManager.$inject = ['localStorageService'];
  /* ng-inject */
  function PaginationManager(localStorage) {

    var queryObj = {};

    return {
      getQuery: getQuery,
      setQuery: setQuery
    };

    function setQuery(obj, widgetId) {
      if (!queryObj[widgetId]) {
        queryObj[widgetId] = obj;
      } else {
        queryObj[widgetId].page = obj.page;
        queryObj[widgetId].limit = obj.limit;
      }

      if (widgetId) {
        localStorage.set(widgetId, obj.limit);
      }
    }

    function getQuery(widgetId) {
      return queryObj[widgetId];
    }
  }

}());

// used in the pagination component to jump to a certain page
angular.module('common').directive('virtualPageSelect', virtualPageSelect);

function virtualPageSelect() {

  function Controller($element, $scope) {
    var self = this;
    var content = $element.find('md-content');

    self.pages = [];

    function getMin(pages, total) {
      return Math.min(pages, isFinite(total) && isPositive(total) ? total : 1);
    }

    function isPositive(number) {
      return number > 0;
    }

    function setPages(max) {
      if(self.pages.length > max) {
        return self.pages.splice(max);
      }

      for(var i = self.pages.length; i < max; i++) {
        self.pages.push(i + 1);
      }
    }

    content.on('scroll', function () {
      if((content.prop('clientHeight') + content.prop('scrollTop')) >= content.prop('scrollHeight')) {
        $scope.$applyAsync(function () {
          setPages(getMin(self.pages.length + 10, self.total));
        });
      }
    });

    $scope.$watch('$pageSelect.total', function (total) {
      setPages(getMin(Math.max(self.pages.length, 10), total));
    });

    $scope.$watch('$pagination.page', function (page) {
      for(var i = self.pages.length; i < page; i++) {
        self.pages.push(i + 1);
      }
    });
  }

  Controller.$inject = ['$element', '$scope'];

  return {
    bindToController: {
      total: '@'
    },
    controller: Controller,
    controllerAs: '$pageSelect'
  };
}

/*
Lifted out of md-data-table for handling pagination
*/

angular.module('common').component('mdTablePagination', {
  controller: 'PaginationController',
  controllerAs: '$pagination',
  templateUrl: 'md-table-pagination.html',
  bindings: {
    boundaryLinks: '<mdBoundaryLinks',
    disabled: '<ngDisabled',
    limit: '<mdLimit',
    page: '<mdPage',
    pageSelect: '<?mdPageSelect',
    onPaginate: '&mdOnPaginate',
    limitOptions: '<mdLimitOptions',
    total: '@mdTotal'
  }

});

angular.module('common').controller('PaginationController', Controller);

Controller.$inject = ['$attrs', '$mdUtil', '$scope'];

function Controller($attrs, $mdUtil, $scope) {
  var self = this;

  self.$onInit = function () {
    self;
  };

  var defaultLabel = {
    page: 'Page:',
    rowsPerPage: 'Rows per page:',
    of: 'of'
  };

  self.label = angular.copy(defaultLabel);

  function isPositive(number) {
    return parseInt(number, 10) > 0;
  }

  self.eval = function (expression) {
    return $scope.$eval(expression);
  };

  self.first = function () {
    self.page = 1;
    self.onPaginationChange();
  };

  self.hasNext = function () {
    return self.page * self.limit < self.total;
  };

  self.hasPrevious = function () {
    return self.page > 1;
  };

  self.last = function () {
    self.page = self.pages();
    self.onPaginationChange();
  };

  self.max = function () {
    return self.hasNext() ? self.page * self.limit : self.total;
  };

  self.min = function () {
    return isPositive(self.total) ? self.page * self.limit - self.limit + 1 : 0;
  };

  self.next = function () {
    self.page++;
    self.onPaginationChange();
  };

  self.onPaginationChange = function () {
    if (angular.isFunction(self.onPaginate)) {
      $mdUtil.nextTick(function () {
        self.onPaginate({page:self.page, limit: self.limit});
      });
    }
  };

  self.pages = function () {
    return isPositive(self.total) ? Math.ceil(self.total / (isPositive(self.limit) ? self.limit : 1)) : 1;
  };

  self.previous = function () {
    self.page--;
    self.onPaginationChange();
  };

  self.showBoundaryLinks = function () {
    return self.mdBoundaryLinks === '' || self.boundaryLinks;
    // return $attrs.mdBoundaryLinks === '' || self.boundaryLinks;
  };

  self.showPageSelect = function () {
    return self.mdPageSelect === '' || self.pageSelect;
    // return $attrs.mdPageSelect === '' || self.pageSelect;
  };

  $scope.$watch('$pagination.limit', function (newValue, oldValue) {
    if (isNaN(newValue) || isNaN(oldValue) || newValue === oldValue) {
      return;
    }

    // find closest page from previous min
    self.page = Math.floor(((self.page * oldValue - oldValue) + newValue) / (isPositive(newValue) ? newValue : 1));
    self.onPaginationChange();
  });

  $attrs.$observe('mdLabel', function (label) {
    angular.extend(self.label, defaultLabel, $scope.$eval(label));
  });

  $scope.$watch('$pagination.total', function (newValue, oldValue) {
    if (isNaN(newValue) || newValue === oldValue) {
      return;
    }

    if (self.page > self.pages()) {
      self.last();
    }
  });

}

/**
 * Created by davidbeazer on 05/09/2016.
 */
(function () {
  'use strict';

  zpTableColumn.$inject = ['$parse'];
  angular
    .module('common')
    .directive('zpTableColumn', zpTableColumn);

  zpTableColumn.inject = ['$parse'];

  function zpTableColumn($parse) {
    return {
      restrict: 'A',
      templateUrl: 'app/common/tables/zp-table-column.tmpl.html',
      link: function (scope, element, attrs) {
        var getMetadata = $parse(attrs['mdata']);
        var metadata = getMetadata(scope);

        if (metadata.reportingLabel) {
          // if the question has a reportingLabel value it'll use that as the column header instead
          scope.label = metadata.reportingLabel;
        } else {
          scope.label = metadata.label;
        }
        scope.showCol = metadata.showCol;
      }
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpMainMenuNav', {
      controller: 'zpMainMenuNavCtrl',
      bindings: {},
      templateUrl: 'app/common/sidenav/main-menu-nav/zp-main-menu-nav.tmpl.html'
    })
    .controller('zpMainMenuNavCtrl', zpMainMenuNavCtrl);

  zpMainMenuNavCtrl.$inject = ['$scope', 'ZPPages', 'CurrentClientModelFactory', 'SessionService', 'appSettings', '$state', '$filter'];
  /* ng-inject */
  function zpMainMenuNavCtrl($scope, zpPages, CurrentClientModelFactory, SessionService, appSettings, $state, $filter) {

    var vm = this;
    vm.zuantLogoFill = '#949CA1';

    vm.$onInit = function () {
      vm.clientDoc = CurrentClientModelFactory.getCurrentClientCache();
      vm.userData = SessionService.getUserData();

      vm.zuantLogoURL = $filter('cdnAssets')('/images/svgs/logos/zuant/ZUANT_CUSTOM_FILL.svg');
      vm.primaryNavItems = zpPages.getPrimaryNavItems();
      vm.secondaryNavItems = zpPages.getSecondaryNavItems();
      vm.appVersion = appSettings.version;

      $scope.$on('zp.account.change', function (ev, params) {
        vm.primaryNavItems = angular.copy(zpPages.getPrimaryNavItems());
        vm.secondaryNavItems = angular.copy(zpPages.getSecondaryNavItems());
      });
    };

    vm.openLink = function (href, openInNew){
      const target = openInNew ? '_blank': '_self';
      window.open(href, target);
    };

    vm.goOrExpand = function (item) {
      if (item.subLinks) {
        item.expanded = !item.expanded;
        return;
      }

      $state.go(item.sref, item.srefObj);
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('zp.message')
    .component('zpActionableToast', {
      templateUrl: 'app/common/message/zp-actionable-toast/toast-with-action.tmpl.html',
      bindings: {
      },
      controller: 'zpActionableToastCtrl'
    })
    .controller('zpActionableToastCtrl', Controller);

  Controller.$inject = ['MessageService', 'title'];
  /* ng-inject */
  function Controller(MessageService, title) {

    var vm = this;
    vm.title = title;

    vm.$onInit = function () {
    };

    vm.openMoreInfo = function () {
      MessageService.confirm().showErrorMessage();
    };

    vm.closeToast = function () {
      MessageService.closeToast();
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .controller('MenuCtrl', AppMenuController)
    .controller('BottomSheetCtrl', BottomSheetCtrl);

  BottomSheetCtrl.$inject = ['ZPPages', '$mdBottomSheet'];
  /* ng-inject */
  function BottomSheetCtrl(zpPages, $mdBottomSheet) {
    var vm = this;
    vm.items = zpPages;

    vm.listItemClick = function () {
      $mdBottomSheet.hide();
    };
  }

  AppMenuController.$inject = ['$scope', '$mdBottomSheet', '$mdSidenav', 'hotkeys', 'EnvService', 'SessionService', 'UserAvatarFactory', 'SendThankYouEmailIntegrityCheck', '$filter'];
  /* ng-inject */
  function AppMenuController($scope, $mdBottomSheet, $mdSidenav, hotkeys, EnvService, session, UserAvatarFactory, SendThankYouEmailIntegrityCheck, $filter) {

    var vm = this;

    vm.$onInit = function () {
      vm.sheetVisible = false;
      vm.showGridBottomSheet = showGridBottomSheet;
      vm.showSettings = showSettings;
      vm.user = session.getUserData();
      vm.notificationsCount = SendThankYouEmailIntegrityCheck.factoryData;

      UserAvatarFactory.getAvatar(vm.user.email)
        .then(function (res){
          vm.avatarBackgroundStyle = {
            backgroundImage: 'url('+res.avatar+')',
            backgroundSize: 'contain',
            width:'35px',
            height:'35px',
            borderRadius:'50%',
            display:'block'
          };
        })
        .catch(function (){
          vm.user.avatar = '';
        });

      vm.zuantLogoFill = '#fff';
      vm.zuantLogoURL = $filter('cdnAssets')('/images/svgs/logos/zuant/ZUANT_CUSTOM_FILL.svg');
      vm.isDev = EnvService.isDev;
      hotkeys.add({
        combo: 'shift+right',
        description: 'Show / hide Zuant menu',
        callback: function () {
          vm.showSideNav();
        }
      });
      hotkeys.add({
        combo: 'shift+left',
        description: 'Show / hide dev menu',
        callback: function () {
          vm.showDevSideNav();
        }
      });
    };

    function showGridBottomSheet() {

      vm.sheetVisible = !vm.sheetVisible;
      if (vm.sheetVisible) {
        $mdBottomSheet
          .show({
            templateUrl: 'app/common/menus/app-menu/bottom-sheet-grid-template.tmpl.html',
            controller: 'BottomSheetCtrl as $ctrl'
          })
          .catch(function () {
            /* capture hiding of the bottom sheet via escape or click-outside, etc */
            vm.sheetVisible = false;
          });
      } else {
        $mdBottomSheet.hide();
      }
    }

    function showSettings() {
      $mdSidenav('settingsPanel')
        .toggle();
    }

    vm.showSideNav = function () {
      $mdSidenav('mainNavigation')
        .toggle();
    };

    vm.showDevSideNav = function () {
      $mdSidenav('settingsPanel')
        .toggle();
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('common')
    .factory('LayoutsFactory', factory);

  factory.$inject = [];
  /* ng-inject */

  function factory() {

    var factoryData = {
      showLeftSidebar: false,
      rightHandContainerWidth: '0'
    };

    return {
      setProperty: setProperty,
      factoryData: factoryData
    };

    function setProperty(prop, value) {
      factoryData[prop] = value;
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpAppHomescreenFramework', {
      templateUrl: 'app/common/layouts/frameworks/app-homescreen-framework.tmpl.html',
      bindings: {}
    })
    .component('zpAppHomescreenFrameworkNoSidebar', {
      templateUrl: 'app/common/layouts/frameworks/app-homescreen-framework-no-sidebar.tmpl.html',
      bindings: {}
    })
    .component('zpSingleViewFramework', {
      templateUrl: 'app/common/layouts/frameworks/single-view-framework.tmpl.html',
      bindings: {}
    })
    .component('zpTabbedAppFramework', {
      templateUrl: 'app/common/layouts/frameworks/tabbed-app-view-framework.tmpl.html',
      controller: 'LayoutsCtrl',
      bindings: {}
    })
    .component('zpTabbedAppTallToolbarFramework', {
      templateUrl: 'app/common/layouts/frameworks/tabbed-app-tall-toolbar-view-framework.tmpl.html',
      controller: 'LayoutsCtrl',
      bindings: {}
    })
    .component('zpTabbedAppWithSidebarFramework', {
      templateUrl: 'app/common/layouts/frameworks/tabbed-app-view-with-sidebar-framework.tmpl.html',
      bindings: {}
    })
    .component('zpToolbarAppFramework', {
      templateUrl: 'app/common/layouts/frameworks/toolbar-app-view-framework.tmpl.html',
      bindings: {}
    })
    .component('zpCustomToolbarAppFramework', {
      templateUrl: 'app/common/layouts/frameworks/custom-toolbar-app-view-framework.tmpl.html',
      bindings: {}
    })
    .controller('LayoutsCtrl', controller);

  controller.$inject = ['LayoutsFactory'];
  /* ng-inject */
  function controller(LayoutsFactory) {
    var vm = this;

    vm.views = LayoutsFactory.factoryData;
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .directive('errSrc', function () {
      return {
        link: function (scope, element, attrs) {
          element.bind('error', function () {
            if (attrs.src != attrs.errSrc) {
              attrs.$set('src', attrs.errSrc);
            }
          });
        }
      };
    });
}());

(function () {
  'use strict';

  /**
   * @module common
   * @function InteractionHelperFactory
   * @description A helper factory to handle the nitty gritty of cell interactions
   */

  angular
    .module('common')
    .factory('InteractionHelperFactory', InteractionHelperFactory);

  InteractionHelperFactory.$inject = ['$rootScope', '$window', '$compile', '$q', '$document', '$timeout'];
  /* ng-inject */
  function InteractionHelperFactory($rootScope, $window, $compile, $q, $document, $timeout) {

    return {
      compileCellElement: compileCellElement,
      positionDialog: positionDialog,
      addElementToDom: addElementToDom,
      focusElementIfNecessary: focusElementIfNecessary
    };

    function compileCellElement(scope, metadata) {
      const dfd = $q.defer();
      if ((metadata.type == 'ChoiceView' ||
        metadata.type == 'Tableview' ||
        metadata.type == 'Lookup' ||
        metadata.type == 'Grid') &&
        !metadata.allowMultiple) {
        dfd.resolve($compile('<zp-radio-button-cell-editor class="cell-editor"></zp-radio-button-cell-editor>')(scope));
      } else if ((metadata.type == 'ChoiceView' ||
        metadata.type == 'Tableview' ||
        metadata.type == 'Lookup' ||
        metadata.type == 'Consent' ||
        metadata.type == 'Privacy' ||
        metadata.type == 'Grid') &&
        metadata.allowMultiple) {
        dfd.resolve($compile('<zp-checkbox-cell-editor class="cell-editor"></zp-checkbox-cell-editor>')(scope));
      } else if (metadata.type == 'Textfield' ||
        metadata.type == 'Textview') {
        dfd.resolve($compile('<zp-text-cell-editor class="cell-editor"></zp-text-cell-editor>')(scope));
      } else if (metadata.type == 'Image' || metadata.type === 'Drawing') {
        scope.dragOptions = {
          container: document.body.getBoundingClientRect()
        };
        dfd.resolve($compile('<zp-image-cell-viewer zp-draggable="dragOptions" class="cell-editor"></zp-image-cell-viewer>')(scope));
      } else if (metadata.type == 'Literature') {
        dfd.resolve($compile('<zp-literature-cell-viewer class="cell-editor"></zp-literature-cell-viewer>')(scope));
      } else if (metadata.type == 'MessageComposer') {
        dfd.resolve($compile('<zp-message-composer-cell-viewer class="cell-editor"></zp-message-composer-cell-viewer>')(scope));
      } else if (metadata.type === 'EmailEvents'){
        dfd.resolve($compile('<zp-email-events-cell-viewer class="cell-editor"></zp-email-events-cell-viewer>')(scope));
      } else if (metadata.type === 'TemplatesSent'){
        dfd.resolve($compile('<zp-templates-sent-cell-viewer class="cell-editor"></zp-templates-sent-cell-viewer>')(scope));
      }
      return dfd.promise;
    }

    function positionDialog(element, target, tableElement) {
      const table = angular.element(tableElement);

      const getEditorElementSize = function () {
        return {
          width: getWidth(),
          height: getHeight()
        };
      };

      const getWidth = function () {
        return element.prop('clientWidth');
      };

      const getHeight = function () {
        return element.prop('clientHeight');
      };

      const getTbodyBounds = function () {
        const parent = table.parent()
          .parent();

        return parent[0].getBoundingClientRect();
      };

      const reposition = function () {
        const editorElement = getEditorElementSize();
        const cellBounds = target.getBoundingClientRect();
        const tableBounds = getTbodyBounds();
        let topCssValue;

        if (editorElement.width > (tableBounds.right - cellBounds.left)) {
          element.css('left', tableBounds.right - editorElement.width + 'px');
        } else {
          element.css('left', cellBounds.left + 'px');
        }

        if ((editorElement.height + cellBounds.top) > tableBounds.bottom) {
          topCssValue = tableBounds.bottom - editorElement.height + 15 + 'px';
          element.css('top', topCssValue);
        } else {
          topCssValue = cellBounds.top + 'px';
          element.css('top', topCssValue);
        }

        element.css('maxWidth', '50vw');
        element.css('minWidth', cellBounds.width + 'px');
        // element.css('zIndex', 80);
      };

      const watchWidth = $rootScope.$watch(getWidth, reposition);
      const watchHeight = $rootScope.$watch(getHeight, reposition);

      $window.addEventListener('resize', reposition);

      element.on('$destroy', function () {
        watchWidth();
        watchHeight();

        $window.removeEventListener('resize', reposition);
      });
    }

    function addElementToDom(elementToAppend) {
      return new Promise(function (resolve) {
        const body = angular.element($document.prop('body'));
        body.append(elementToAppend);
        resolve();
      });
    }

    function focusElementIfNecessary(tableCellProps) {
      if (tableCellProps.metadata.type == 'Textfield' || tableCellProps.metadata.type == 'Textview') {
        $timeout(function () {
          document.getElementById('focusMe').focus();
        }, 100);
      }
    }

  }

})();

(function () {
  'use strict';

  /**
   * @module common
   * @function CellInteractionFactory
   * @description A factory to handle interactions with a table cell. The various cell editor/viewer controllers share this for getting/setting cell data.
   */

  angular
    .module('common')
    .factory('CellInteractionFactory', CellInteractionFactory);

  CellInteractionFactory.$inject = ['ChangeDelta', 'GridDataFactory', 'GridMetaDataFactory', 'InteractionHelperFactory', 'EndCellEditSessionFunction', 'MessageService'];
  /* ng-inject */
  function CellInteractionFactory(ChangeDelta, GridDataFactory, GridMetaDataFactory, InteractionHelperFactory, EndCellEditSessionFunction, MessageService) {

    const factoryData = {
      tableCellInFocus: undefined,
      scopeProps: undefined,
      cellEditorElement: undefined,
      imageViewerElement: undefined,
      dataForCellInFocus: undefined,
      directiveElement: undefined,
      activeController: undefined
    };

    return {
      setElementForDirective: setElementForDirective,

      setCellInFocus: setCellInFocus,
      getCellInFocus: getCellInFocus,
      getCellValue: getCellValue,

      enterKeyPressed: enterKeyPressed,
      closeRelevantDialog: closeRelevantDialog,
      beginEditSession: beginEditSession,
      closeEditSessionIfNecessary: closeEditSessionIfNecessary,
      endEditSession: endEditSession,

      getScopeProps: getScopeProps,

      openImageViewer: openImageViewer,
      closeImageDialogIfOpen: closeImageDialogIfOpen,

      toggleBooleanValue: toggleBooleanValue,
      setActiveController: setActiveController,
      unsetActiveController: unsetActiveController,
      factoryData: factoryData
    };

    //////////////////////////////////////////////

    function setElementForDirective(element) {
      factoryData.directiveElement = element;
    }

    /**
     * @module common
     * @function setCellInFocus
     * @description a table cell has been clicked and so we tee up the factory with it's relevant properties. Gets called by a cell click event and also by keyboard navigation event.
     */
    function setCellInFocus(cellProps) {
      setViewElement(cellProps); // updates view to highlight the clicked cell. Sets the tableCellInFocus variable for the entire factory to use.
      setDataForElement(); // updates factory data to the clicked cell. Factory is now poised for further interaction
    }

    function setViewElement(targetCell) {
      if (factoryData.tableCellInFocus) {
        angular.element(factoryData.tableCellInFocus)
          .removeClass('cell-highlight');
      }
      factoryData.tableCellInFocus = targetCell;
      angular.element(factoryData.tableCellInFocus)
        .addClass('cell-highlight');
    }

    function setDataForElement() {
      factoryData.dataForCellInFocus = {
        targetCell: factoryData.tableCellInFocus,
        metadata: GridMetaDataFactory.locateCellMetaDataById(factoryData.tableCellInFocus.attributes['zp-column-id'].value, factoryData.tableCellInFocus.attributes['zp-widget-id'].value),
        rowData: GridDataFactory.locateCellRowDataById(factoryData.tableCellInFocus.attributes['zp-row-id'].value, factoryData.tableCellInFocus.attributes['zp-widget-id'].value)
      };
      if (factoryData.dataForCellInFocus.metadata && factoryData.dataForCellInFocus.metadata.object == 'response' && factoryData.dataForCellInFocus.metadata.databasefieldname === '_images') {
        factoryData.dataForCellInFocus.isImageCell = true;
        if (!factoryData.dataForCellInFocus.rowData.response._images) factoryData.dataForCellInFocus.isEmptyImageCell = true;
      }
    }

    function getCellInFocus() {
      return angular.element(factoryData.tableCellInFocus);
    }

    function getCellValue() {
      const cellValue = factoryData.dataForCellInFocus.rowData[factoryData.dataForCellInFocus.metadata.object][factoryData.dataForCellInFocus.metadata.databasefieldname];
      return cellValue;
    }

    function beginEditSession(controllerScope) {
      closeRelevantDialog();
      let elementToAppend;
      return InteractionHelperFactory.compileCellElement(controllerScope, factoryData.dataForCellInFocus.metadata)
        .then(function (element) {
          elementToAppend = element;
          bindPropsToScope(factoryData.dataForCellInFocus);
          factoryData.cellEditorElement = elementToAppend;
          return InteractionHelperFactory.addElementToDom(elementToAppend);
        })
        .then(function () {
          InteractionHelperFactory.focusElementIfNecessary(factoryData.dataForCellInFocus);
          InteractionHelperFactory.positionDialog(elementToAppend, factoryData.tableCellInFocus, factoryData.directiveElement[0].parentElement);
          wireUpPageScrollEvents();
          return;
        });
    }

    function closeEditSessionIfNecessary() {
      if (factoryData.cellEditorElement) {
        return endEditSession(false);
      }
    }

    function openImageViewer(controllerScope) {

      if (factoryData.dataForCellInFocus.isEmptyImageCell) return;
      closeRelevantDialog();
      let elementToAppend;
      InteractionHelperFactory.compileCellElement(controllerScope, factoryData.dataForCellInFocus.metadata)
        .then(function (element) {
          elementToAppend = element;
          bindPropsToScope(factoryData.dataForCellInFocus);
          return InteractionHelperFactory.addElementToDom(elementToAppend);
        })
        .then(function () {
          InteractionHelperFactory.focusElementIfNecessary(factoryData.dataForCellInFocus);
          InteractionHelperFactory.positionDialog(elementToAppend, factoryData.tableCellInFocus, factoryData.directiveElement[0].parentElement);
          factoryData.imageViewerElement = elementToAppend;
          wireUpPageScrollEvents();
          angular.element(factoryData.tableCellInFocus.parentElement).addClass('row-highlight');
          return;
        });
    }

    function closeImageDialogIfOpen() {
      if (factoryData.imageViewerElement) {
        angular.element(factoryData.imageViewerElement).remove();
        factoryData.imageViewerElement = undefined;
        angular.element(factoryData.tableCellInFocus.parentElement).removeClass('row-highlight');
        return true;
      }
      return false;
    }

    function endEditSession(saveChanges, newValue) {
      const cellValidation = EndCellEditSessionFunction(saveChanges, newValue, factoryData);
      return cellValidation;
    }

    function getScopeProps() {
      return factoryData.scopeProps;
    }

    function toggleBooleanValue() {
      const object = factoryData.dataForCellInFocus.metadata.object;
      const databasefieldname = factoryData.dataForCellInFocus.metadata.databasefieldname;
      const objectIdentifier = factoryData.dataForCellInFocus.rowData[factoryData.dataForCellInFocus.metadata.object]._id;
      const currentValue = factoryData.dataForCellInFocus.rowData[object][databasefieldname];
      const newValue = !factoryData.dataForCellInFocus.rowData[object][databasefieldname];

      GridDataFactory.updateCellValue({
        newValue: newValue,
        objectId: objectIdentifier,
        metadata: factoryData.dataForCellInFocus.metadata,
        widgetId: factoryData.tableCellInFocus.attributes['zp-widget-id'].value
      });
      ChangeDelta.recordValueChange({
        oldval: currentValue,
        newval: newValue,
        objectid: objectIdentifier,
        collection: object,
        databasefieldname: databasefieldname
      });
    }

    function editableCheckPassed() {
      return factoryData.dataForCellInFocus.metadata.editable;
    }

    function enterKeyPressed(controllerScope) {
      if (!editableCheckPassed()) return;
      if (factoryData.dataForCellInFocus.isImageCell) {
        openImageViewer(controllerScope);
      } else {
        beginEditSession(controllerScope);
      }
    }


    // PRIVATE HELPERS

    function bindPropsToScope(tableCellProps) {
      factoryData.scopeProps = {
        zpMetadata: tableCellProps.metadata,
        zpModel: tableCellProps.rowData[tableCellProps.metadata.object][tableCellProps.metadata.databasefieldname],
        zpRowData: tableCellProps.rowData,
        originalValue: buildOriginalValue()
      };

      function buildOriginalValue() {
        const rawCellValue = tableCellProps.rowData[tableCellProps.metadata.object][tableCellProps.metadata.databasefieldname];
        const strippedCellValue = [];
        if (tableCellProps.metadata.databasefieldname === '_grantedConsents') {
          _.each(rawCellValue, function (val) {
            strippedCellValue.push(val.token);
          });
          return strippedCellValue;
        } else {
          return angular.copy(rawCellValue);
        }
      }
    }

    function closeRelevantDialog() {
      //09/01/2025 - added extra conditions to prevent image closing when editing textfields
      if (factoryData.imageViewerElement) {
        if (
          (
            factoryData.dataForCellInFocus.metadata.type !== 'Textfield' &&
            factoryData.dataForCellInFocus.metadata.type !== 'Textview'
          ) ||
          factoryData.dataForCellInFocus.metadata.databasefieldname === 'notes'
        ) return closeImageDialogIfOpen();
      }

      return endEditSession(false);
    }

    function wireUpPageScrollEvents() {
      const tableContainers = document.getElementsByClassName('tableContainer');
      const elements = [];
      _.each(tableContainers, function (container, i) {
        elements[i] = angular.element(container);
        elements[i].on('scroll', function () {
          if (factoryData.activeController) {
            factoryData.activeController.scrollEvent();
          }
        });
      });
    }

    function setActiveController(ctrl) {
      factoryData.activeController = ctrl;
    }

    function unsetActiveController() {
      factoryData.activeController = undefined;
    }

  }

}());

(function () {
  'use strict';

  angular
    .module('common')
    .directive('zpCellInteraction', function () {
      return {
        restrict: 'A',
        controller: 'zpCellInteractionController',
        controllerAs: 'cellCtrl',
        link: link
      };
    })
    .controller('zpCellInteractionController', zpCellInteractionController);

  function link(scope, element) {
    element.on('$destroy', function () {
      // this event handler is required to remove any editor elements from the page when the zp-cell-interaction element is $destroyed.
      scope.$broadcast('zp.CellInteractionElement.destroy');
    });
  }

  zpCellInteractionController.$inject = ['$scope', '$element', 'CellInteractionFactory'];

  function zpCellInteractionController($scope, $element, CellInteractionFactory) {

    function init() {
      $scope.$on('zp.cell-clicked', prepareCellForInteraction);
      $scope.$on('zp.CellInteractionElement.destroy', endEditSession);
      CellInteractionFactory.setElementForDirective($element);
    }

    init();

    function prepareCellForInteraction(ev, tableCellProps) {
      if (tableCellProps.targetEvent.code !== 'Space' && tableCellProps.targetEvent.code !== 'Enter') {
        // do not want to run the code if a spacebar or enter key event has fired because they are taken care of elsewhere.
        CellInteractionFactory.setCellInFocus(tableCellProps.targetCell);
        if (tableCellProps.mdata.editable) {
          CellInteractionFactory.beginEditSession($scope);
        } else if (tableCellProps.mdata.type == 'Image' || tableCellProps.mdata.type == 'Drawing') {
          CellInteractionFactory.openImageViewer($scope);
        } else if (tableCellProps.mdata.boolean) {
          CellInteractionFactory.toggleBooleanValue();
        }
      }
    }

    function endEditSession() {
      // $log.info('ending edit session');
      CellInteractionFactory.closeEditSessionIfNecessary();
      CellInteractionFactory.closeImageDialogIfOpen();
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('common')
    .controller('ZPTextCellEditorCtrl', ZPTextCellEditorCtrl);

  ZPTextCellEditorCtrl.$inject = ['$scope', 'CellInteractionFactory', '$timeout'];
  /* ng-inject */
  function ZPTextCellEditorCtrl($scope, CellInteractionFactory, $timeout) {

    var vm = this;

    vm.$onInit = function () {
      var scopeProps = CellInteractionFactory.getScopeProps();
      vm.zpMetadata = scopeProps.zpMetadata;
      vm.zpModel = scopeProps.zpModel;
      vm.zpRowData = scopeProps.zpRowData;
      vm.originalValue = scopeProps.originalValue;

      $(document).bind('mouseup');

      CellInteractionFactory.setActiveController(this);
    };

    vm.updateValue = function (modelData) {
      vm.zpModel = modelData;
    };

    vm.inputLostFocus = function () {
      // $log.info('inputLostFocus ' + JSON.stringify(vm.zpModel));
      vm.closeDialog(true);
    };

    vm.cancelEdit = function () {
      // $log.info('cancelEdit');
      CellInteractionFactory.endEditSession(false);
    };

    vm.scrollEvent = function () {
      // $log.info('scrollEvent' + JSON.stringify(vm.zpModel));
      $timeout(function () {
        vm.closeDialog(true);
        CellInteractionFactory.unsetActiveController();
      }, 10);
    };

    vm.closeDialog = function (save) {
      // $log.info('closing dialog');
      var validationObj = CellInteractionFactory.endEditSession(save, vm.zpModel);
      if(validationObj){
        vm.formErrors = validationObj.errors;
      }
    };
    $(document).mouseup(function (e) { 
      // rest code here 
      var container = $('.container'); 

      if(!container.is(e.target) && container.has(e.target).length === 0) { 
        vm.closeDialog(true);
        $(document).unbind('mouseup');
      } 
    }); 
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpTextCellEditor', {
      controller: 'ZPTextCellEditorCtrl',
      controllerAs: 'textCellCtrl',
      templateUrl: 'app/common/editor/text-cell/text-cell-editor.tmpl.html',
      bindings: {}
    });

})();

(function () {
  'use strict';

  angular
    .module('common')
    .controller('SelectionCellEditorController', SelectionCellEditorController);

  SelectionCellEditorController.$inject = ['CellInteractionFactory', 'ListsGeneralFactory', 'MessageService', '$timeout', 'SessionService', 'CurrentClientModelFactory', 'PrivacyStatementsApiFactory', 'FormMetadataFactory', 'stringHelper', 'ChangeDelta'];
  /* ng-inject */
  function SelectionCellEditorController(CellInteractionFactory, ListsGeneralFactory, MessageService, $timeout, session, CurrentClientModelFactory, PrivacyStatementsApiFactory, FormMetadataFactory, stringHelper, ChangeDelta) {

    var vm = this;

    vm.$onInit = function () {
      CellInteractionFactory.setActiveController(this);
      const scopeProps = CellInteractionFactory.getScopeProps();
      vm.zpMetadata = angular.copy(scopeProps.zpMetadata); // requires making a copy of the metadata here to break the binding to factory.
      vm.zpModel = scopeProps.zpModel;
      vm.zpRowData = scopeProps.zpRowData;
      vm.originalValue = scopeProps.originalValue;
      vm.zpRadioModel;
      vm.widgetIsAList = vm.zpMetadata.type === 'Lookup' || vm.zpMetadata.type === 'Tableview' || vm.zpMetadata.type === 'ChoiceView' || vm.zpMetadata.type === 'Grid';
      vm.formTimezone = stringHelper.calcTimezoneOffset(FormMetadataFactory.getData().formProperties.formTimezone);

      if (vm.zpMetadata.customListId) {
        vm.loading = true;
        ListsGeneralFactory.getListById(vm.zpMetadata.customListId)
          .then(function (res) {
            vm.zpMetadata.answers = res.itemsForSelectControl;
            vm.loading = false;
            if (vm.zpModel) {
              buildModel();
            }
          })
          .catch(function (err) {
            MessageService.showMessage('Error: ' + err.statusText || 'Unknown error occured');
            MessageService.writeLog({
              level: 'error',
              msg: err
            });
            vm.loading = false;
            vm.errorMessage = 'List error: ' + err.statusText;
          });
      } else if (vm.zpMetadata.type === 'Consent') {
        CurrentClientModelFactory.getClientById(session.getUserData().clientId)
          .then(function (currentClientData) {
            vm.zpMetadata.answers = angular.copy(currentClientData.consentModel);
            // vm.zpMetadata.answers = activeAccountConsentModelTokens(currentClientData);
            vm.loading = false;
            buildConsentModelForView();
          })
          .catch(function (err) {
            MessageService.writeLog({
              level: 'error',
              msg: err,
              tags: ['error']
            });
          });
      } else if (vm.zpMetadata.type === 'Privacy') {
        const params = {
          options: {
            includeVersionHistory: 0
          },
          queryObj: {
            parameters: {
              artefactType: 'PrivacyStatement'
            },
            fields: {
              _lastmodifieddatelocalutc: 1,
              _deletedatelocalutc: 1,
              isPrimaryStatement: 1,
              title: 1
            }
          }
        };
        PrivacyStatementsApiFactory.fetchPrivacyStatementsFromServer(params)
          .then(function (res) {
            vm.zpMetadata.answers = res;
            buildPrivacyStatementsModelForView();
          })
          .catch(function () {
            MessageService.showMessage('Error fetching privacy statements');
            MessageService.writeLog({
              level: 'error',
              msg: err,
              tags: ['selection_cell_fetch_privacy_statements']
            });
          });
      } else {
        if (vm.zpModel) {
          buildModel();
        }
      }
    };

    vm.closeDialog = function () {
      vm.formErrors = CellInteractionFactory.endEditSession(!vm.zpMetadata.readOnly, buildNewCellValue());
    };

    vm.toggleAll = function (add) {
      vm.zpModel = [];
      ChangeDelta.recordValueChange({
        collection: vm.zpMetadata.object,
        objectid: vm.zpRowData[vm.zpMetadata.object]._id,
        databasefieldname: vm.zpMetadata.databasefieldname,
        oldval: vm.originalValue,
        newval: vm.zpModel
      });

      for (const ans of vm.zpMetadata.answers){
        ans.selected = add;
        if (add) {
          vm.zpModel.push(ans.keyValue);
          ChangeDelta.recordValueChange({
            collection: vm.zpMetadata.object,
            objectid: vm.zpRowData[vm.zpMetadata.object]._id,
            databasefieldname: vm.zpMetadata.databasefieldname,
            oldval: vm.originalValue,
            newval: vm.zpModel
          });
        }
      }
    };

    vm.updateRadioButtonSelection = function (answerObj) {

      if (typeof(answerObj) === 'string' && answerObj === 'custom.lookup.value'){
        //clears input if you switch from current lookup selection to custom
        vm.zpModel = '';
        return;
      }

      for (const ans of vm.zpMetadata.answers){
        if (ans.keyValue == answerObj.keyValue) {
          // if it matches then select it
          ans.selected = true;
        } else {
          // as its a radio there can only ever be one selected item
          ans.selected = false;
        }
      }
    };

    function buildModel() {
      if (vm.zpModel == '') return;
      if (vm.zpMetadata.allowMultiple) {
        buildModelForMultipleChoice();
      } else {
        buildModelForSingleChoice();
      }
    }

    function buildModelForMultipleChoice() {
      for (const ans of vm.zpMetadata.answers){
        for (const answerdata of vm.zpModel){
          if (ans.showMoreInfoTextfield) {
            // checkIfAnswerDataMatches(ans, answerdata);
            const stringToMatch = ans.keyValue + ':';
            if (~answerdata.indexOf(stringToMatch)) {
              ans.selected = true;
              ans.moreInfo = answerdata.split(stringToMatch)[1];
            }
          }
          if (answerdata === ans.keyValue) {
            ans.selected = true;
          }
        }
      }
    }

    function buildModelForSingleChoice() {
      for (const ans of vm.zpMetadata.answers){
        if (ans.showMoreInfoTextfield) {
          const stringToMatch = ans.keyValue + ':';
          if (~vm.zpModel[0].indexOf(stringToMatch)) { // handy trick to turn the result of indexOf into a truthy/falsey value. http://bit.ly/1wdtZkB
            ans.selected = true;
            ans.moreInfo = vm.zpModel[0].split(stringToMatch)[1];
            if (!vm.zpMetadata.allowMultiple) {
              vm.zpRadioModel = ans.keyValue;
            }
          }
        }

        // radio is a single choice array, lookup is a string. check for a match either way
        if (vm.zpModel[0] === ans.keyValue || vm.zpModel === ans.keyValue) {
          ans.selected = true;
          vm.zpRadioModel = ans.keyValue;
        }
      }

      if (vm.zpMetadata.type === 'Lookup' && !vm.zpRadioModel){
        vm.zpRadioModel = 'custom.lookup.value';
      }
    }

    function buildConsentModelForView() {
      _.each(vm.zpMetadata.answers, function (answer) {
        answer.displayValue = answer.token;
        answer.keyValue = answer.token;
      });
      _.each(vm.zpModel, function (model) {
        const matchedAnswer = _.find(vm.zpMetadata.answers, function (ans) {
          return model.token === ans.token;
        });
        if (matchedAnswer) {
          matchedAnswer.selected = true;
          matchedAnswer.dateAcquired = stringHelper.convertDateToNeutralTimezone(model.dateAcquired);
        } else {
          vm.zpMetadata.answers.push({
            _id: model.token,
            selected: true,
            dateRead: stringHelper.convertDateToNeutralTimezone(model.dateAcquired),
            displayValue: 'Consent token is no longer available'
          });
        }
      });
    }

    function buildPrivacyStatementsModelForView() {
      _.each(vm.zpMetadata.answers, function (answer) {
        answer.displayValue = answer.title;
      });
      _.each(vm.zpModel, function (model) {
        const matchedAnswer = _.find(vm.zpMetadata.answers, function (ans) {
          return model.id === ans._id;
        });
        if (matchedAnswer) {
          matchedAnswer.selected = true;
          matchedAnswer.dateRead = stringHelper.convertDateToNeutralTimezone(model.dateRead);
        } else {
          vm.zpMetadata.answers.push({
            _id: model.id,
            selected: true,
            dateRead: stringHelper.convertDateToNeutralTimezone(model.dateRead),
            displayValue: 'Missing statement'
          });
        }
      });
    }

    function buildNewCellValue() {
      let newCellValue;
      if (vm.zpMetadata.readOnly) return;
      if (!vm.zpMetadata.allowMultiple) {
        newCellValue = buildValueForSingleChoice();
      } else {
        newCellValue = buildValueForMultipleChoice();
      }
      if (!angular.equals(vm.originalValue, newCellValue)) {
        ChangeDelta.recordValueChange({
          collection: vm.zpMetadata.object,
          objectid: vm.zpRowData[vm.zpMetadata.object]._id,
          databasefieldname: vm.zpMetadata.databasefieldname,
          oldval: vm.originalValue,
          newval: newCellValue
        });
      }
      return newCellValue;
    }

    function buildValueForSingleChoice() {
      for (const ans of vm.zpMetadata.answers){
        if (vm.zpRadioModel == ans.keyValue) {
          if (ans.showMoreInfoTextfield) {
            vm.zpRadioModel = ans.keyValue + ':' + ans.moreInfo;
          }
        }
      }

      if (vm.zpMetadata.type == 'Lookup') {
        //custom value support for lookup
        if (vm.zpRadioModel === 'custom.lookup.value'){
          return vm.zpModel;
        }

        // Lookup value's are stored as a string
        return vm.zpRadioModel;
      } else {
        // answer needs to be a single member array
        if (vm.zpRadioModel === '') return [];
        if (_.isUndefined(vm.zpRadioModel)) return [];
        return [vm.zpRadioModel];
      }
    }

    function buildValueForMultipleChoice() {
      const cellValueArray = [];
      for (const answer of vm.zpMetadata.answers){
        if (answer.selected) {
          // game on we push this onto the model array
          let answerString;
          if (answer.showMoreInfoTextfield) {
            answerString = answer.keyValue + ':' + answer.moreInfo;
          } else {
            answerString = answer.keyValue;
          }
          cellValueArray.push(answerString);
        }
      }
      return cellValueArray;
    }

    vm.scrollEvent = function () {
      $timeout(function () {
        vm.closeDialog();
        CellInteractionFactory.unsetActiveController();
      }, 10);
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpTemplatesSentCellViewer', {
      controller: 'CellViewerController',
      controllerAs: 'ctrl',
      templateUrl: 'app/common/editor/read-only/templates-sent-cell.tmpl.html',
      bindings: {}
    });

})();

(function () {
  'use strict';

  angular
    .module('common')
    .controller('CellViewerController', CellViewerController);

  CellViewerController.$inject = ['CellInteractionFactory', 'LiteratureNamesFactory', '$timeout'];
  /* ng-inject */
  function CellViewerController(CellInteractionFactory, LiteratureNamesFactory, $timeout) {
    var vm = this;

    vm.$onInit = function () {
      const scopeProps = CellInteractionFactory.getScopeProps();
      CellInteractionFactory.setActiveController(this);
      vm.zpMetadata = angular.copy(scopeProps.zpMetadata);
      vm.zpModel = scopeProps.zpModel;

      if (vm.zpMetadata.type == 'Literature') {

        const rawLiteratureIdsArray = angular.copy(scopeProps.zpModel);
        if (!LiteratureNamesFactory.getCache()) {
          vm.loading = true;
          // $log.info('the lit docs cached is empty, we need to get the lit docs (page has refreshed without visiting the forms main screen (which is where then names are fetched!))');
          LiteratureNamesFactory.getAllLiteratureDocs()
            .then(function () {
              buildLiteratureModel(rawLiteratureIdsArray);
              vm.loading = false;
            });
        } else {
          buildLiteratureModel(rawLiteratureIdsArray);
        }
      } else if (vm.zpMetadata.type == 'MessageComposer') {
        // $log.info('MessageComposer viewer here');
      } else if (vm.zpMetadata.type == 'EmailEvents') {
        vm.zpModel = vm.zpModel.sort(function (a, b){
          return new Date(a.dt) - new Date(b.dt);
        });
      }
    };

    vm.closeDialog = function () {
      CellInteractionFactory.endEditSession(false);
    };

    vm.scrollEvent = function () {
      $timeout(function () {
        vm.closeDialog();
        CellInteractionFactory.unsetActiveController();
      }, 10);
    };

    function buildLiteratureModel(literatureIds) {
      vm.zpModel = literatureIds.map(function (litId) {
        return LiteratureNamesFactory.getLiteratureDocById(litId);
      });
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpMessageComposerCellViewer', {
      controller: 'CellViewerController',
      controllerAs: 'ctrl',
      templateUrl: 'app/common/editor/read-only/message-composer-cell.tmpl.html',
      bindings: {}
    });

})();

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpLiteratureCellViewer', {
      controller: 'CellViewerController',
      controllerAs: 'ctrl',
      templateUrl: 'app/common/editor/read-only/literature-cell.tmpl.html',
      bindings: {}
    });

})();

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpEmailEventsCellViewer', {
      controller: 'CellViewerController',
      controllerAs: 'ctrl',
      templateUrl: 'app/common/editor/read-only/email-events-cell.tmpl.html',
      bindings: {}
    });

})();

(function () {
  'use strict';

  angular
    .module('common')
    .controller('MultiEditCtrl', MultiEditCtrl);

  MultiEditCtrl.$inject = ['selected', 'widgetId', 'MessageService', 'GridDataFactory', 'FormMetadataFactory', 'ChangeDelta'];
  /* ng-inject */
  function MultiEditCtrl(selectedRows, widgetId, MessageService, GridDataFactory, FormMetadataFactory, ChangeDelta) {

    var vm = this;
    vm.changesToBeApplied = {};
    vm.showHiddenFieldLabels = true;
    vm.selectedRecordsCount = selectedRows.length;

    vm.$onInit = function() {
      vm.metadata = FormMetadataFactory.getMetaDataForMultiEditSession();
    };

    vm.openMenu = function ($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    };

    vm.updateChangeDelta = function (mdata, value, clearFlag) {
      if (typeof(value) === 'string' && value.length === 0 && !clearFlag){
        delete vm.changesToBeApplied[mdata.object + '_' + mdata.databasefieldname];
        return;
      }

      vm.changesToBeApplied[mdata.object + '_' + mdata.databasefieldname] = {
        mdata: mdata,
        value: value
      };
    };

    vm.cancel = function () {
      MessageService.cancelDialog();
    };

    vm.submit = function () {
      // user has confirmed the mass edit session by clicking done button. Apply session changes to lead data and change delta factories.
      _.each(selectedRows, function (row) {
        _.each(vm.changesToBeApplied, function (prop) {
          const updateObj = {
            newValue: prop.value,
            objectId: row[prop.mdata.object]._id,
            metadata: prop.mdata,
            widgetId: widgetId,
          };

          GridDataFactory.updateCellValue(updateObj);

          ChangeDelta.recordValueChange({
            oldval: null,
            newval: updateObj.newValue,
            objectid: updateObj.objectId,
            collection: prop.mdata.object,
            databasefieldname: prop.mdata.databasefieldname
          });
        });
      });

      MessageService.closeDialog();
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpImageCellViewer', {
      controller: 'ZPImageCellViewerCtrl',
      controllerAs: 'imageCellCtrl',
      templateUrl: 'app/common/editor/image-cell/image-cell-viewer.tmpl.html',
      bindings: {}
    })
    .controller('ZPImageCellViewerCtrl', ZPImageCellViewerCtrl);

  ZPImageCellViewerCtrl.$inject = ['MessageService', 'CellInteractionFactory', 'ImagesFactory', '$timeout'];
  /* ng-inject */
  function ZPImageCellViewerCtrl(MessageService, CellInteractionFactory, ImagesFactory, $timeout) {
    var vm = this;
    vm.loading = true;
    vm.angle = 0;

    vm.$onInit = function () {
      MessageService.writeLog({
        level: 'info',
        msg: 'ZPImageCellViewerCtrl $onInit'
      });
      CellInteractionFactory.setActiveController(this);
      const arrayOfImageIds = CellInteractionFactory.getCellValue();
      if (_.isArray(arrayOfImageIds)) {
        vm.arrayOfImageIds = arrayOfImageIds;
      } else {
        vm.arrayOfImageIds = [arrayOfImageIds];
      }
      const imageId = vm.arrayOfImageIds[0];
      vm.getImageSrc(imageId);
    };

    vm.scrollEvent = function () {
      /*$timeout(function () {
        vm.closeImageDialog();
        CellInteractionFactory.unsetActiveController();
      }, 10);*/

      //added 9/01/2025 upon client request to keep image open when scrolling
      return;
    };

    vm.closeImageDialog = function() {
      MessageService.writeLog({
        level: 'info',
        msg: 'ZPImageCellViewerCtrl closeImageDialog'
      });
      CellInteractionFactory.closeImageDialogIfOpen();
    };

    vm.rotate = function (angle) {
      vm.angle = vm.angle + angle;
    };

    vm.getImageSrc = function (imageId) {
      vm.loading = true;
      vm.idOfImageInView = imageId;
      return ImagesFactory.getImageSrc(imageId)
        .then(function (src) {
          vm.loading = false;
          vm.src = src;
          vm.angle = 0;
          MessageService.writeLog({
            level: 'info',
            msg: 'assigned image src to view model property'
          });
        })
        .catch(function (err) {
          vm.src = err.src;
          MessageService.showMessage('Image ' + err.statusText);
          MessageService.pushEventToIntercom('image-404', {
            imageId: imageId
          });
        });
    };
  }

})();

(function () {
  'use strict';

  /**
   * @description This component is used for each form input that is built for a multi edit session.
   */

  angular
    .module('common')
    .component('zpFormInput', {
      controller: 'ZPForminputCtrl',
      controllerAs: 'formInputCtrl',
      templateUrl: 'app/common/editor/form-inputs/zp-forminput.tmpl.html',
      bindings: {
        zpMetadata: '=',
        showHiddenFieldLabel: '=',
        zpUpdateChangeDelta: '&'
      }
    })
    .controller('ZPForminputCtrl', ZPForminputCtrl);

  ZPForminputCtrl.$inject = ['ListApiFactory', 'CellInteractionFactory'];

  function ZPForminputCtrl(ListApiFactory, CellInteractionFactory) {
    const vm = this;

    vm.value = ''; // all cell values start empty because we're editing multiple rows!
    vm.clearFlag = false;

    vm.$onInit = () => {
      CellInteractionFactory.setActiveController(vm);
    };

    vm.mdOpening = () => {
      const { customListId, answers } = vm.zpMetadata;
      if (!customListId) return answers;

      return ListApiFactory.getArtefactById(customListId)
        .then(function (res) {
          const items = res.data.data.items.map(doc => ({
            displayValue: doc.reportingLabel || doc.caption || doc.code,
            keyValue: doc.code || doc.caption || doc.reportingLabel,
            showMoreInfoTextfield: doc.showMoreInfoTextfield,
            moreInfo: ''
          }));
          return vm.zpMetadata.answers = items;
        });
    };

    vm.mdClosing = () => {
      let updateValue = '';

      if (!vm.value) return;

      if (vm.zpMetadata.allowMultiple) {
        // process checkbox array
        updateValue = vm.value.map(item => 
          item.showMoreInfoTextfield ? `${item.keyValue}: ${item.moreInfo}` : item.keyValue
        );
      } else {
        // process radio button array
        if (vm.value.showMoreInfoTextfield) {
          updateValue = [`${vm.value.keyValue}: ${vm.value.moreInfo}`];
        } else {
          updateValue = [vm.value.keyValue];
        }
      }

      vm.updateChangeDelta(updateValue);
    };

    vm.toggleClearSelection = () => {
      vm.clearFlag = !vm.clearFlag;
      vm.value = '';
      vm.updateChangeDelta(vm.value);
    };

    vm.updateChangeDelta = (value) => {
      if (typeof(value) === 'string' && value.length > 0) vm.clearFlag = false;
      if (typeof(value) !== 'string' && Array.isArray(value) && value.length > 0) vm.clearFlag = false;

      vm.zpUpdateChangeDelta({
        mdata: vm.zpMetadata,
        value,
        clearFlag: vm.clearFlag
      });
    };

    vm.scrollEvent = () => {
      $timeout(() => {
        vm.zpUpdateChangeDelta({
          mdata: vm.zpMetadata,
          value: vm.value
        });
        CellInteractionFactory.unsetActiveController();
      }, 10);
    };

    vm.moreInfoCheck = (answer) => {
      return answer.showMoreInfoTextfield && answer.selected;
    };

    vm.handleRadioClickEvent = (ev, answer) => {
      answer.selected = !answer.selected;
      if (answer.showMoreInfoTextfield) {
        ev.stopPropagation();
        vm.value = answer;
      }
    };
  }
})();

/**
 * Created by Dave Beazer on 25/02/2015.
 */
/*
 Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
 For licensing, see LICENSE.md or http://ckeditor.com/license
 */


// CKEDITOR.addTemplates("default", {
//    imagesPath: CKEDITOR.getUrl(CKEDITOR.plugins.getPath("templates") + "templates/images/"),
//    templates: [{
//        title: "Simple Template",
//        image: "simple.png",
//        description: "Banner logo, single column text and social media icons.",
//        html: '<!DOCTYPE html> <head> <meta name="viewport" content="width=device-width"/>  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8"/> <title>Basic</title>  <style> * { margin: 0; padding: 0 }  * { font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif }  img { max-width: 100% }  .collapse { margin: 0; padding: 0 }  body { -webkit-font-smoothing: antialiased; -webkit-text-size-adjust: none; width: 100% !important; height: 100% }  a { color: #2ba6cb }  .btn { display: inline-block; padding: 6px 12px; margin-bottom: 0; font-size: 14px; font-weight: normal; line-height: 1.428571429; text-align: center; white-space: nowrap; vertical-align: middle; cursor: pointer; border: 1px solid transparent; border-radius: 4px; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; -o-user-select: none; user-select: none; color: #333; background-color: white; border-color: #CCC; }  p.callout { padding: 15px; background-color: #ecf8ff; margin-bottom: 15px }  .callout a { font-weight: bold; color: #2ba6cb }  table.social { background-color: #ebebeb }  .social .soc-btn { padding: 3px 7px; border-radius: 2px; -webkit-border-radius: 2px; -moz-border-radius: 2px; font-size: 12px; margin-bottom: 10px; text-decoration: none; color: #FFF; font-weight: bold; display: block; text-align: center }  a.fb { background-color: #3b5998 !important }  a.tw { background-color: #1daced !important }  a.gp { background-color: #db4a39 !important }  a.ms { background-color: #000 !important }  .sidebar .soc-btn { display: block; width: 100% }  table.head-wrap { width: 100% }  .header.container table td.logo { padding: 15px }  .header.container table td.label { padding: 15px; padding-left: 0 }  table.body-wrap { width: 100% }  table.footer-wrap { width: 100%; clear: both !important }  .footer-wrap .container td.content p { border-top: 1px solid #d7d7d7; padding-top: 15px }  .footer-wrap .container td.content p { font-size: 10px; font-weight: bold }  h1, h2, h3, h4, h5, h6 { font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; line-height: 1.1; margin-bottom: 15px; color: #000 }  h1 small, h2 small, h3 small, h4 small, h5 small, h6 small { font-size: 60%; color: #6f6f6f; line-height: 0; text-transform: none }  h1 { font-weight: 200; font-size: 44px }  h2 { font-weight: 200; font-size: 37px }  h3 { font-weight: 500; font-size: 27px }  h4 { font-weight: 500; font-size: 23px }  h5 { font-weight: 900; font-size: 17px }  h6 { font-weight: 900; font-size: 14px; text-transform: uppercase; color: #444 }  .collapse { margin: 0 !important }  p, ul { margin-bottom: 10px; font-weight: normal; font-size: 14px; line-height: 1.6 }  p.lead { font-size: 17px }  p.last { margin-bottom: 0 }  ul li { margin-left: 5px; list-style-position: inside }  ul.sidebar { background: #ebebeb; display: block; list-style-type: none }  ul.sidebar li { display: block; margin: 0 }  ul.sidebar li a { text-decoration: none; color: #666; padding: 10px 16px; margin-right: 10px; cursor: pointer; border-bottom: 1px solid #777; border-top: 1px solid #fff; display: block; margin: 0 }  ul.sidebar li a.last { border-bottom-width: 0 }  ul.sidebar li a h1, ul.sidebar li a h2, ul.sidebar li a h3, ul.sidebar li a h4, ul.sidebar li a h5, ul.sidebar li a h6, ul.sidebar li a p { margin-bottom: 0 !important }  .container { display: block !important; max-width: 600px !important; margin: 0 auto !important; clear: both !important }  .content { padding: 15px; max-width: 600px; margin: 0 auto; display: block }  .content table { width: 100% }  .column { width: 300px; float: left }  .column tr td { padding: 15px }  .column-wrap { padding: 0 !important; margin: 0 auto; max-width: 600px !important }  .column table { width: 100% }  .social .column { width: 280px; min-width: 279px; float: left }  .clear { display: block; clear: both }  @media only screen and (max-width: 600px) { a[class="btn"] { display: block !important; margin-bottom: 10px !important; background-image: none !important; margin-right: 0 !important }  div[class="column"] { width: auto !important; float: none !important }  table.social div[class="column"] { width: auto !important } } </style>  </head>  <body bgcolor="#FFFFFF">  <!-- HEADER --> <table class="head-wrap" background="border.png"> <tr> <td></td> <td class="header container">  <div class="content"> <table> <tr> <td><img src="http://i.imgur.com/JKU9lzE.jpg" /></td> </tr> </table> </div>  </td> <td></td> </tr> </table> <!-- /HEADER -->   <!-- BODY --> <table class="body-wrap"> <tr> <td></td> <td class="container" bgcolor="#FFFFFF">  <div class="content"> <table> <tr> <td> <h3>Hi [[firstname]]</h3>  <p class="lead">This is a simple html example template.</p>  <p>Phasellus dictum sapien a neque luctus cursus. Pellentesque sem dolor, fringilla et pharetra vitae. consequat vel lacus. Sed iaculis pulvinar ligula, ornare fringilla ante viverra et. In hac habitasse platea dictumst. Donec vel orci mi, eu congue justo. Integer eget odio est, eget malesuada lorem. Aenean sed tellus dui, vitae viverra risus. Nullam massa sapien, pulvinar eleifend fringilla id, convallis eget nisi. Mauris a sagittis dui. Pellentesque non lacinia mi. Fusce sit amet libero sit amet erat venenatis sollicitudin vitae vel eros. Cras nunc sapien, interdum sit amet porttitor ut, congue quis urna.</p> <!-- Callout Panel --> <p class="callout"> Phasellus dictum sapien a neque luctus cursus. Pellentesque sem dolor, fringilla et pharetra vitae. <a href="#">Click it! &raquo;</a> </p><!-- /Callout Panel -->  <!-- social & contact --> <table class="social" width="100%"> <tr> <td>  <!-- column 1 --> <table align="left" class="column"> <tr> <td>  <h5 class="">Connect with Us:</h5>  <p class=""> <a href="#"><img src="http://i.imgur.com/IQQWcY2.png" /></a> <a href="#"><img src="http://i.imgur.com/5giiVxA.png" /></a> <a href="#"><img src="http://i.imgur.com/ztWaVT1.png" /></a> </p> </td> </tr> </table> <!-- /column 1 -->  <!-- column 2 --> <table align="left" class="column"> <tr> <td>  <h5 class="">Contact Info:</h5>  <p>Phone: <strong>+44 1344.350.250</strong><br/> Email: <strong><a href="emailto:info@zuant.com">info@zuant.com</a></strong> </p>  </td> </tr> </table> <!-- /column 2 -->  <span class="clear"></span>  </td> </tr> </table> <!-- /social & contact -->  </td> </tr> </table> </div> <!-- /content -->  </td> <td></td> </tr> </table> <!-- /BODY -->  <!-- FOOTER --> <table class="footer-wrap"> <tr> <td></td> <td class="container">  <!-- content --> <div class="content"> <table> <tr> <td align="center"> <p> <a href="#">Terms</a> | <a href="#">Privacy</a> | <a href="#"> <unsubscribe>Unsubscribe</unsubscribe> </a> </p> </td> </tr> </table> </div> <!-- /content -->  </td> <td></td> </tr> </table> <!-- /FOOTER -->  </body> </html>'
//    }
//, {
//    title: "Strange Template",
//    image: "template2.gif",
//    description: "A template that defines two colums, each one with a title, and some text.",
//    html: '<table cellspacing="0" cellpadding="0" style="width:100%" border="0"><tr><td style="width:50%"><h3>Title 1</h3></td><td></td><td style="width:50%"><h3>Title 2</h3></td></tr><tr><td>Text 1</td><td></td><td>Text 2</td></tr></table><p>More text goes here.</p>'
//}, {
//    title: "Text and Table",
//    image: "template3.gif",
//    description: "A title with some text and a table.",
//    html: '<div style="width: 80%"><h3>Title goes here</h3><table style="width:150px;float: right" cellspacing="0" cellpadding="0" border="1"><caption style="border:solid 1px black"><strong>Table title</strong></caption><tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr><tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr><tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr></table><p>Type the text here</p></div>'
//}]
//  ]
// });

'use strict';
angular.module('zp.auth', [
  'LocalStorageModule',
  'ngCookies',
  'zp.websocket'
])
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('TokenFactory');
  }]);

(function () {
  'use strict';
  angular
    .module('zp.auth')
    .component('zpLoginForm', {
      templateUrl: 'app/common/auth/login-form-component/login-form.tmpl.html',
      controller: 'LoginFormController',
      bindings: {
        loading: '<',
        onLoginClicked: '&',
        user: '<'
      }
    })
    .controller('LoginFormController', LoginFormController);

  LoginFormController.$inject = ['localStorageService'];

  function LoginFormController(localStorageService) {

    var vm = this;
    vm.notPermittedToEnterCloud = false;
    vm.passwordFieldIcon = 'zmdi-eye-off';
    vm.passwordFieldType = 'password';
    vm.passwordFieldTooltip = 'Show password';

    vm.toggleViewPasswordField = function () {
      vm.passwordFieldType = vm.passwordFieldType === 'password' ? 'text' : 'password';
      vm.passwordFieldIcon = vm.passwordFieldIcon === 'zmdi-eye-off' ? 'zmdi-eye' : 'zmdi-eye-off';
      vm.passwordFieldTooltip = vm.passwordFieldTooltip === 'Show password' ? 'Hide password' : 'Show password';
    };

    vm.updateRememberMe = function() {
      localStorageService.set('rememberMe', !vm.user.rememberMe);
    };

    vm.setRememberMe = function () {
      vm.user.rememberMe = !vm.user.rememberMe;
      localStorageService.set('rememberMe', vm.user.rememberMe);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpThemesLibrary', {
      templateUrl: 'app/clients/theming/zp-themes-library/zp-themes-library.tmpl.html',
      controller: 'zpThemesLibraryCtrl',
      bindings: {
        clientDoc: '<',
        customSkinEditorStatePath: '@',
        clientDetailStatePath: '@',
        layout: '@',
        layoutFill: '@'
      }
    })
    .controller('zpThemesLibraryCtrl', ctrl);

  ctrl.$inject = ['MessageService', '$state', 'MasterPermissionsDefinitionFactory', 'ChangeDelta', 'ThemingFactory', 'PrimaryThemeFactory', '$window', '$timeout', 'ThemingMetadataFactory'];
  /* ng-inject */
  function ctrl(MessageService, $state, MasterPermissionsDefinitionFactory, ChangeDelta, ThemingFactory, PrimaryThemeFactory, $window, $timeout, ThemingMetadataFactory) {

    var vm = this;

    vm.permissions = MasterPermissionsDefinitionFactory;

    vm.data = {
      items: []
    };

    vm.$onInit = function () {
      ThemingFactory.factoryData.showAddThemeHelperArrow = false;
      vm.changeDelta = ChangeDelta;
      ChangeDelta.clear();
      vm.loadThemes();
    };

    vm.dismissWelcomeMessage = function () {
      vm.hingeWelcomeMessage = true;
      $timeout(function () {
        ThemingFactory.factoryData.showAddThemeHelperArrow = true;
      }, 2000);
    };

    vm.learnMore = function (ev) {
      const config = ThemingMetadataFactory.factoryData.customSkinsLearnMoreDialog;

      MessageService.showDialog(ev, config)
        .then(function () {})
        .catch(function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'user cancelled show more dialog'
          });
        });
    };

    vm.loadThemes = function () {
      ThemingFactory.getThemesForAccount()
        .then(function () {
          vm.data = ThemingFactory.factoryData;
          if (!vm.data.items.length) {
            vm.showWelcomeMessage = true;
          }
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
          MessageService.showMessage(err);
        });
    };

    vm.cancel = function () {
      $state.go(vm.clientDetailStatePath, {
        _id: vm.clientDoc._id
      });
    };

    vm.openMenu = function ($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    };

    vm.editTheme = function (ev, themeId) {
      $state.go(vm.customSkinEditorStatePath, {
        _id: vm.clientDoc._id,
        _themeId: themeId,
        customSkinLibraryStatePath: $state.current.name,
        clientDetailStatePath: vm.clientDetailStatePath
      });
    };

    vm.deleteTheme = function (ev, theme) {

      ThemingFactory.deleteTheme(ev, theme)
        .then(function (res) {
          MessageService.writeLog({
            level: 'info',
            msg: 'back from deleting theme ' + JSON.stringify(res)
          });
          MessageService.writeLog({
            level: 'info',
            msg: theme._id + ' theme deleted'
          });
          if (res.pageReloadRequired) {
            MessageService.showMessage('Reloading to refresh skin');
            $timeout(function () {
              $window.location.reload();
            }, 1500);
          }
          if (!vm.data.items.length) {
            vm.showWelcomeMessage = true;
          }
        })
        .catch(function (err) {
          const msg = err ? err : 'user cancelled deleting theme';
          MessageService.writeLog({
            level: 'error',
            msg: msg
          });
        });

    };

    vm.makePrimaryTheme = function (ev, themeDoc) {
      PrimaryThemeFactory.promptUserIfNecessary(ev)
        .then(function (res) {
          if (res.success) {
            return PrimaryThemeFactory.setPrimaryTheme(themeDoc);
          } else {
            throw (res.message);
          }
        })
        .then(function (res) {
          MessageService.writeLog({
            level: 'info',
            msg: res
          });
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };

  }
}());

(function () {
  'use strict';

  /**
* Component show a preview of the current primary theme. Used on the client detail page
*/

  angular
    .module('clients')
    .component('zpThemeOverview', {
      templateUrl: 'app/clients/theming/zp-theme-overview/zp-theme-overview.tmpl.html',
      controller: 'zpThemeOverviewCtrl',
      bindings: {
        clientId: '<',
        clientLogoObj: '<',
        customSkinLibraryStatePath: '@',
        customSkinEditorStatePath: '@',
        clientDetailStatePath: '@'
      }
    })
    .controller('zpThemeOverviewCtrl', ctrl);

  ctrl.$inject = ['$state', 'PrimaryThemeFactory', 'ThemingMetadataFactory'];
  /* ng-inject */
  function ctrl($state, PrimaryThemeFactory, ThemingMetadataFactory) {
    var vm = this;

    vm.$onInit = function () {
      PrimaryThemeFactory.getPrimaryTheme()
        .then(function (theme){
          if (_.isEmpty(theme)) {
            vm.message = 'Custom Skins is switched on for this account but there is no default theme set.';
            vm.theme = ThemingMetadataFactory.newThemeDoc();
            return;
          }

          vm.theme = theme;
        });
      
    };

    vm.openThemeDialog = function() {
      $state.go(vm.customSkinLibraryStatePath, {
        _id: vm.clientId,
        customSkinEditorStatePath: vm.customSkinEditorStatePath,
        clientDetailStatePath: vm.clientDetailStatePath,
        customSkinLibraryStatePath: vm.customSkinLibraryStatePath
      });
    };
  }

}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpThemeEditor', {
      templateUrl: 'app/clients/theming/zp-theme-editor/zp-theme-editor.tmpl.html',
      controller: 'zpThemeEditorCtrl',
      bindings: {
        clientId: '<',
        theme: '<',
        layout: '@',
        layoutFill: '@',
        clientDetailStatePath: '@',
        customSkinLibraryStatePath: '@'
      }
    })
    .controller('zpThemeEditorCtrl', ctrl);

  ctrl.$inject = ['$scope', 'MessageService', '$state', 'MasterPermissionsDefinitionFactory', 'CurrentClientModelFactory', 'ChangeDelta', 'ThemingFactory', 'CurrentThemeFactory', 'ThemingMetadataFactory', 'PrimaryThemeFactory', '$window', '$timeout'];
  /* ng-inject */
  function ctrl($scope, MessageService, $state, MasterPermissionsDefinitionFactory, CurrentClientModel, ChangeDelta, ThemingFactory, CurrentThemeFactory, ThemingMetadataFactory, PrimaryThemeFactory, $window, $timeout) {

    var vm = this;

    vm.permissions = MasterPermissionsDefinitionFactory;
    vm.deviceFillColor = '#CED8DD';

    vm.$onInit = function () {
      vm.changeDelta = ChangeDelta;
      vm.themeNameEditableHeader = ThemingMetadataFactory.factoryData.themeNameEditableHeaderMetadata;
      vm.clientDoc = CurrentClientModel.getCurrentClientCache();
      vm.factoryData = CurrentThemeFactory.factoryData;
      vm.copyOfThemeDoc = angular.copy(vm.theme);

      $scope.$on('zpSaveTheme', vm.saveChanges);
      ChangeDelta.clear();

    };


    vm.updateChangeDelta = function (prop1, prop2, newValue) {
      let oldValue = vm.copyOfThemeDoc[prop1];
      if (!prop2) {
        ChangeDelta.recordValueChange({
          oldval: oldValue,
          newval: newValue,
          objectid: vm.copyOfThemeDoc._id,
          collection: 'artefacts',
          databasefieldname: prop1
        });

        return; 
      }

      oldValue = vm.copyOfThemeDoc[prop1][prop2];
      if (prop1 === 'images') {

        const oldValueTrimmed = {
          _id: oldValue._id,
          weburi: oldValue.weburi,
          _s3key: oldValue._s3key,
          title: oldValue.title
        };

        ChangeDelta.recordValueChange({
          oldval: oldValueTrimmed,
          newval: newValue,
          objectid: vm.copyOfThemeDoc._id,
          collection: 'artefacts',
          databasefieldname: prop2
        });

      } else if (prop1 === 'blocks') {
        vm.theme.blocks[prop2] = newValue;

        ChangeDelta.recordValueChange({
          oldval: oldValue,
          newval: newValue,
          objectid: vm.copyOfThemeDoc._id,
          collection: 'artefacts',
          databasefieldname: prop2
        });
      }

    };

    // image control buttons found under each device (upload, library view, clear)
    vm.imageDialogButtonClicked = function (ev, imageObj) {
      const config = ThemingMetadataFactory.factoryData.imageSelectionDialogConfig;
      config.locals.imageObj = imageObj;
      config.locals.currentThemeImageDocs = vm.theme.images;

      MessageService.showDialog(ev, config)
        .then(function (res) {
          if (res.selectedImage) {
            updateThemeImage(res.selectedImage, res.themeImage.themeProp);
            return;
          }

          vm.updateChangeDelta('images', imageObj.themeProp, {
            _id: undefined,
            weburi: undefined,
            _s3key: undefined,
            title: undefined
          });
          CurrentThemeFactory.clearImageButtonClicked(imageObj.themeProp);
        })
        .catch(function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'user cancelled image selection dialog'
          });
        });
    };

    function updateThemeImage(selectedImage, themeImageProperty) {
      const imagename = selectedImage.title || selectedImage.name;
      MessageService.showMessage(imagename + ' selected');

      const delta = {
        _id: selectedImage._id,
        weburi: selectedImage.weburi,
        _s3key: selectedImage._s3key,
        title: imagename
      };

      vm.updateChangeDelta('images', themeImageProperty, delta);

      vm.theme.images[themeImageProperty]._id = selectedImage._id;
      vm.theme.images[themeImageProperty]._s3key = selectedImage._s3key;
      vm.theme.images[themeImageProperty].weburi = selectedImage.weburi;

      vm.theme.images[themeImageProperty].metadata = {
        title: imagename,
        filename: selectedImage.filename,
        width: selectedImage.width,
        height: selectedImage.height,
        size: selectedImage.size,
        type: selectedImage.type,
        _lastmodifieddatelocalutc: selectedImage._lastmodifieddatelocalutc
      };
    }

    // end image control button functions

    vm.cancel = function () {
      $state.go(vm.clientDetailStatePath, {
        _id: vm.clientId
      },
      {
        custom: {
          isDirtyCheck: true
        }
      });
    };

    vm.openMenu = function ($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    };

    vm.navBack = function () {
      $state.go(vm.customSkinLibraryStatePath, {
        _id: vm.clientId
      },
      {
        custom: {
          isDirtyCheck: true
        }
      });
    };

    vm.updateThemeName = function (value) {
      vm.updateChangeDelta('themeName', null, value);
      vm.theme.name = value;
    };

    vm.deleteTheme = function (ev) {
      ThemingFactory.deleteTheme(ev, vm.theme)
        .then(function (res) {
          if (res.pageReloadRequired) {
            MessageService.showMessage('Reloading to refresh skin');
            $timeout(function () {
              $window.location.reload();
            }, 1500);
          }
          vm.navBack();
        })
        .catch(function (err) {
          MessageService.showMessage(err);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };

    vm.makePrimaryTheme = function (ev) {
      PrimaryThemeFactory.promptUserIfNecessary(ev)
        .then(function (res) {
          if (res.success) {
            vm.theme.isPrimaryTheme = true;
            return PrimaryThemeFactory.setPrimaryTheme(vm.theme);
          } else {
            throw (res.message);
          }
        })
        .then(function (res) {
          MessageService.writeLog({
            level: 'info',
            msg: res
          });
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };

    vm.saveChanges = function saveChanges() {
      vm.factoryData.saveBtnDisabled = true;
      const changeDeltaObj = ChangeDelta.getDeltaObject();
      CurrentThemeFactory.saveTheme(vm.theme, changeDeltaObj)
        .then(function (res) {
          MessageService.writeLog({
            level: 'info',
            msg: 'back from saving theme ' + JSON.stringify(res)
          });
          vm.copyOfThemeDoc = angular.copy(vm.theme);
          pageReloadCheck(changeDeltaObj);
          ChangeDelta.clear();
          vm.factoryData.saveBtnDisabled = false;
          MessageService.showMessage('Changes saved');
        })
        .catch(function (e) {
          vm.factoryData.saveBtnDisabled = false;
          MessageService.showMessage(e);
          MessageService.writeLog({
            level: 'error',
            msg: e
          });
        });


      function pageReloadCheck(changeDeltaObj) {
        if (!vm.theme.isPrimaryTheme) return;

        try {
          let reloadRequired = false;
          if (changeDeltaObj.hasOwnProperty('cloudPrimaryColor')) {
            if (changeDeltaObj.cloudPrimaryColor.newvalue) {
              reloadRequired = true;
            }
          }

          if (changeDeltaObj.hasOwnProperty('cloudAccentColor')) {
            if (changeDeltaObj.cloudAccentColor.newValue) {
              reloadRequired = true;
            }
          }

          if (reloadRequired) {
            MessageService.showMessage('Cloud skin palette changed, reloading...');
            $timeout(function () {
              $window.location.reload();
            }, 1500);
          }
        } catch (e) {
          vm.factoryData.saveBtnDisabled = false;
        }

      }
    };

    vm.syncBlockColors = function (newValue) {
      _.each(vm.theme.blocks, function (color, key) {
        if (key == 'mainMenuBlocksAlpha' || key == 'mainMenuBlocksHolderAlpha' || key == 'blurEffect') return;
        vm.updateChangeDelta('blocks', key, newValue);
        vm.theme.blocks[key] = newValue;
      });
    };

    vm.setBlurEffect = function (effect) {
      vm.updateChangeDelta('blocks', 'blurEffect', effect);
      vm.theme.blocks.blurEffect = effect;
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .controller('AddThemeDialogController', ctrl);

  ctrl.$inject = ['clientId', 'MessageService', 'CurrentThemeFactory', '$state', 'ThemingMetadataFactory', 'ThemingFactory'];
  /* ng-inject */
  function ctrl(clientId, MessageService, CurrentThemeFactory, $state, ThemingMetadataFactory, ThemingFactory) {

    var vm = this;
    vm.theme = ThemingMetadataFactory.newThemeDoc();

    vm.cancelDialog = function () {
      MessageService.cancelDialog();
    };

    vm.submit = function () {
      if (themeInvalid()) return;
      CurrentThemeFactory.saveTheme(vm.theme)
        .then(function () {
          MessageService.showMessage(vm.theme.name + ' created');
          MessageService.pushEventToIntercom('created_custom_skin', {
            name: vm.theme.name
          });
          ThemingFactory.invalidateCache();
          $state.go('app.single_view_framework.customSkins.theme_editor', {
            _id: clientId,
            _themeId: vm.theme._id
          });
          MessageService.closeDialog();
        })
        .catch(function (err) {
          throw new Error(err);
        });
    };

    function themeInvalid() {
      return !vm.theme.name;
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpThemeDevice',{
      templateUrl: 'app/clients/theming/theming-components/zp-theme-device.tmpl.html',
      bindings: {
        deviceType: '@',
        theme: '<',
        height: '@',
        width: '@',
        bezelColor: '@',
        clientLogoObj: '<'
      },
      controller: 'zpThemeDeviceCtrl'
    })
    .controller('zpThemeDeviceCtrl', zpThemeDeviceCtrl)
    .component('zpImageInfoTable', {
      templateUrl: 'app/clients/theming/theming-components/zp-image-info-table.tmpl.html',
      bindings: {
        metadata: '<'
      }
    })
    .component('zpImageControlButtons', {
      templateUrl: 'app/clients/theming/theming-components/zp-image-control-buttons.tmpl.html',
      bindings: {
        imageObj: '<',
        openSelectDialog: '&'
      }
    })
    .component('zpThemeSnapshot', {
      templateUrl: 'app/clients/theming/theming-components/zp-theme-snapshot.tmpl.html',
      bindings: {
        theme: '<',
        clientLogoObj: '<'
      }
    })
    .component('zpMainMenuConfigurator', {
      templateUrl: 'app/clients/theming/theming-components/zp-main-menu-configurator.tmpl.html',
      bindings: {
        theme: '<',
        updateChangeDelta: '&',
        syncBlockColors: '&'
      }
    });


  zpThemeDeviceCtrl.$inject = ['$scope', 'AWS_STORAGE_REGION', 'AWS_STORAGE_BUCKET_NAME'];
  function zpThemeDeviceCtrl($scope, awsStorageRegion, awsStorageBucketName){
    var vm = this;
    vm.adjustedImageUrls = {};

    vm.$onInit = function () {
      vm.bezelColor = vm.bezelColor || '#535353';
      $scope.$watch('$ctrl.theme', adjustImageUrls, true);
      $scope.$on('zp.client-logo-updated', adjustImageUrls);
    };

    function adjustImageUrls() {

      if (vm.clientLogoObj && vm.clientLogoObj.base64) {
        vm.clientLogo = 'data:image/png;base64,' + vm.clientLogoObj.base64;
      } else if (vm.clientLogoObj && vm.clientLogoObj._s3key){
        vm.clientLogo = `https://s3.${awsStorageRegion}.amazonaws.com/${awsStorageBucketName}/${vm.clientLogoObj._s3key}?timestamp=${vm.clientLogoObj._lastmodifiedonservertime}`;
      } else {
        vm.clientLogo = null;
      }
      
      const imageDefinitions = {
        cloudDashboardBackgroundImage: vm.theme.images.cloudDashboardBackgroundImage.weburi || '',
        mainMenuImageiPadPortrait: vm.theme.images.mainMenuImageiPadPortrait.weburi || '',
        mainMenuImageiPadLandscape: vm.theme.images.mainMenuImageiPadLandscape.weburi || '',
        mainMenuImageiPhone: vm.theme.images.mainMenuImageiPhone.weburi || '',
        mainMenuImageiPhone67: vm.theme.images.mainMenuImageiPhone67.weburi || ''
      };

      vm.adjustedImageUrls = {};

      for (const key of Object.keys(imageDefinitions)){
        if (vm.theme.images[key]._s3key){
          vm.adjustedImageUrls[key] = `https://s3.${awsStorageRegion}.amazonaws.com/${awsStorageBucketName}/${vm.theme.images[key]._s3key}`;
          continue;
        }

        vm.adjustedImageUrls[key] = imageDefinitions[key].replace('www.dropbox', 'dl.dropboxusercontent');
      }

    }
  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .controller('CustomSkinsInformationDialogCtrl', ctrl);

  ctrl.$inject = ['MessageService'];
  /* ng-inject */
  function ctrl(MessageService) {
    var vm = this;

    vm.cancelDialog = function (){
      MessageService.closeDialog();
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpSaveThemeFab', {
      templateUrl: 'app/clients/theming/fab-save/fab.tmpl.html',
      controller: 'zpSaveThemeFabCtrl'
    })
    .controller('zpSaveThemeFabCtrl', ctrl);

  ctrl.$inject = ['$scope', 'ChangeDelta', 'MasterPermissionsDefinitionFactory', 'CurrentThemeFactory'];
  /* nj-inject */
  function ctrl($scope, ChangeDelta, MasterPermissionsDefinitionFactory, CurrentThemeFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.changeDelta = ChangeDelta;
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.disableSaveButton = CurrentThemeFactory.factoryData;
    };

    vm.save = function (){
      $scope.$emit('zp.message', {
        level: 'broadcast',
        page: 'foo',
        eventName: 'zpSaveTheme'
      });
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpAddThemeFab', {
      templateUrl: 'app/clients/theming/fab-add/fab.tmpl.html',
      controller: 'zpAddThemeFabCtrl',
      bindings: {
        clientId: '<'
      }
    })
    .controller('zpAddThemeFabCtrl', ctrl);

  ctrl.$inject = ['MasterPermissionsDefinitionFactory', 'ThemingMetadataFactory', 'ThemingFactory'];
  /* nj-inject */
  function ctrl(MasterPermissionsDefinitionFactory, ThemingMetadataFactory, ThemingFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.metadata = ThemingMetadataFactory.factoryData;
      vm.metadata.fabAddDialogConfig.locals.clientId = vm.clientId;
      vm.data = ThemingFactory.factoryData;
      vm.themingFactoryData = ThemingFactory.factoryData;
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpCloudThemeCard', {
      templateUrl: 'app/clients/theming/cloud-theme-card/cloud-theme.tmpl.html',
      controller: 'zpCloudThemeCardCtrl',
      bindings: {
        theme: '<',
        openImageSelectDialog: '&',
        updateChangeDelta: '&',
        clientLogoObj: '<'
      }
    })
    .controller('zpCloudThemeCardCtrl', zpCloudThemeCardCtrl)
    .directive('themePreview', function () {
      return {
        restrict: 'E',
        templateUrl: 'app/clients/theming/cloud-theme-card/theme-preview.tmpl.html',
        scope: {
          primary: '=',
          accent: '='
        },
        controller: ['$scope', '$mdColors', '$mdColorUtil', function ($scope, $mdColors, $mdColorUtil) {
          $scope.getColor = function (color) {
            return $mdColorUtil.rgbaToHex($mdColors.getThemeColor(color));
          };
        }]
      };
    })
    .directive('mdJustified', function () {
      return {
        restrict: 'A',
        compile: function (element, attrs) {
          var layoutDirection = 'layout-' + (attrs.mdJustified || 'row');

          element.removeAttr('md-justified');
          element.addClass(layoutDirection);
          element.addClass('layout-align-space-between-stretch');

          return angular.noop;
        }
      };
    });

  zpCloudThemeCardCtrl.$inject = ['$mdTheming'];
  /* ng-inject */
  function zpCloudThemeCardCtrl($mdTheming) {

    var vm = this;

    vm.$onInit = function () {
      // vm.mdURL = 'https://material.google.com/style/color.html#color-color-palette';
      // vm.colors2 = Object.keys($mdColorPalette); // default material design palettes

      vm.colors = Object.keys($mdTheming.PALETTES); // includes palettes defined in app/themes/config.zuant.theme.js
      vm.primary = vm.theme.cloudPrimaryColor || 'purple';
      vm.accent = vm.theme.cloudAccentColor || 'green';
      vm.isPrimary = true;
    };

    vm.selectTheme = function (color) {
      if (vm.isPrimary) {
        vm.primary = color;
        vm.theme.cloudPrimaryColor = color;
        vm.updateChangeDelta({
          prop1: 'cloudPrimaryColor',
          prop2: null,
          newValue: color
        });
        vm.isPrimary = false;
        return;
      }

      vm.accent = color;
      vm.theme.cloudAccentColor = color;
      vm.updateChangeDelta({
        prop1: 'cloudAccentColor',
        prop2: null,
        newValue: color
      });
      vm.isPrimary = true;
    };

    vm.getBackgroundImageStyle = function(imagepath){
      return {
        'background-image':'url(' + imagepath || '' + ')'
      };
    };

    vm.triggerSizeAlert = function (imageDims) {
      vm.triggerSizeAlertFunction({imageDims: imageDims});
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('teamsTree', {
      templateUrl: 'app/clients/teams/tree/view.tmpl.html',
      controller: 'TeamsTreeCtrl',
      bindings: {
        teams: '<',
        addTeam: '&',
        selectTeam: '&',
        toggleChevron: '&',
        filterTeams: '&',
        searchValue: '='
      },
      controllerAs: 'vm'
    })
    .controller('TeamsTreeCtrl', ctrl);

  ctrl.$inject = ['TeamsAPI', 'MessageService', 'SessionService'];
  /* ng-inject */
  function ctrl(TeamsAPI, MessageService) {

    var vm = this;

    vm.showAddTeamDialog = (ev) => {
      MessageService.showDialog(ev, {
        controller: AddTeamCtrl,
        controllerAs: 'vm',
        templateUrl: 'app/clients/teams/dialogs/add-team/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          team: {
            name: ''
          },
          parentTeam: {},
          teams: vm.teams
        }
      })
        .then((obj) => {
          TeamsAPI.updateOrCreateTeam(obj.team)
            .then((res) => {
              vm.addTeam({ team: res.data.data });
            })
            .catch((err) => {
              MessageService.writeLog({
                level: 'error',
                msg: 'Error from updateOrCreateTeam(): ' + JSON.stringify(err),
                tags: ['teams']
              });
              MessageService.showMessage('Server could not create team, please try again later');
            });
        })
        .catch(() => {
          // cancelled modal, no need to worry
        });
    };

    return vm;
  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('updateTeamsWithRemovedTeamAsSubteam', updateTeamsWithRemovedTeamAsSubteam);

  updateTeamsWithRemovedTeamAsSubteam.$inject = ['TeamsAPI'];
  /* ng-inject */
  function updateTeamsWithRemovedTeamAsSubteam(TeamsAPI) {

    return (teams, id) => {
      return new Promise((resolve, reject) => {
        const promiseArray = [];

        for (const team of teams) {
          const subteams = [];
          let needsUpdating = false;

          for (let subteam of team.subteams) {
            if (subteam === id) {
              needsUpdating = true;
            } else {
              subteams.push(subteam);
            }
          }

          if (needsUpdating) {
            promiseArray.push(TeamsAPI.updateOrCreateTeam({
              _id: team._id,
              name: team.name,
              subteams: subteams,
              members: team.members
            }));
          }
        }

        Promise.all(promiseArray).then(resolve).catch(reject);
      });
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('updateTeamsInfo', updateTeamsInfo);

  updateTeamsInfo.$inject = ['getIdsFromSubteams'];
  /* ng-inject */
  function updateTeamsInfo(getIdsFromSubteams) {

    return (teams, selectedTeam) => {
      for (const team of teams) {
        if (team._id === selectedTeam._id) {
          team.subteams.splice(0);
          team.subteams.push.apply(team.subteams, getIdsFromSubteams(selectedTeam));
          team.members.splice(0);
          team.members.push.apply(team.members, selectedTeam.members);
          break;
        }
      }
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('updateSubteamsWithIds', updateSubteamsWithIds);

  updateSubteamsWithIds.$inject = [];
  /* ng-inject */
  function updateSubteamsWithIds() {

    return (res, selectedTeam) => {
      for (const r of res) {
        for (const subteam of selectedTeam.subteams) {
          if (subteam.name === r.data.data.name && !subteam._id) {
            subteam._id = r.data.data._id;
            break;
          }
        }
      }
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('updateAnyParentChanges', updateAnyParentChanges);

  updateAnyParentChanges.$inject = ['TeamsAPI', 'transformMembersForSave'];
  /* ng-inject */
  function updateAnyParentChanges(TeamsAPI, transformMembersForSave) {

    return (teams, newParentId, selectedTeamId) => {
      return new Promise((resolve, reject) => {
        const promiseArray = [];

        outterTeamLoop:
        for (const team of teams) {
          for (let j = 0; j < team.subteams.length; j++) {
            if (team.subteams[j] !== selectedTeamId) continue;
            
            team.subteams.splice(j, 1);
            promiseArray.push(TeamsAPI.updateOrCreateTeam({
              _id: team._id,
              name: team.name,
              subteams: team.subteams,
              members: transformMembersForSave(team)
            }));
            break outterTeamLoop;
          }
        }

        if (newParentId) {
          for (const team of teams) {
            if (team._id !== newParentId) continue;
            
            team.subteams.push(selectedTeamId);
            promiseArray.push(TeamsAPI.updateOrCreateTeam({
              _id: team._id,
              name: team.name,
              subteams: team.subteams,
              members: transformMembersForSave(team)
            }));
            break;
          }
        }

        Promise.all(promiseArray).then(resolve).catch(reject);
      });
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('transformTeamForSave', transformTeamForSave);

  transformTeamForSave.$inject = ['getIdsFromSubteams', 'transformMembersForSave'];
  /* ng-inject */
  function transformTeamForSave(getIdsFromSubteams, transformMembersForSave) {

    return (selectedTeam) => {
      const subteams = getIdsFromSubteams(selectedTeam);
      const members = transformMembersForSave(selectedTeam);

      return {
        _id: selectedTeam._id,
        name: selectedTeam.name,
        subteams: subteams,
        members: members
      };
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('transformTeamForDelete', transformTeamForDelete);

  transformTeamForDelete.$inject = [];
  /* ng-inject */
  function transformTeamForDelete() {

    return (selectedTeam) => {
      return {
        _id: selectedTeam._id,
        name: selectedTeam.name,
        subteams: [],
        members: []
      };
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('transformSubteamForSave', transformSubteamForSave);

  transformSubteamForSave.$inject = [];
  /* ng-inject */
  function transformSubteamForSave() {

    return (team) => {
      return {
        name: team.name
      };
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('transformMembersForTeams', transformMembersForTeams);

  transformMembersForTeams.$inject = [];
  /* ng-inject */
  function transformMembersForTeams() {

    const userIsStaffMember = (user) => {
      const email = _.get(user, 'email', '');
      return email.includes('@zuant.com') ||
        email.includes('@evoite.com') ||
        email.includes('@mktpoint.com');
    };


    return (usersObj, teams) => {
      for (const team of teams) {
        for (const member of team.members) {
          member.private = member.roles ? member.roles.indexOf('privateLeads') > -1 : false;
          member.manager = member.roles ? member.roles.indexOf('manager') > -1 : false;

          const user = _.get(usersObj, [member.userid, 'user']);
          member.name = user ? `${user.firstname} ${user.surname}` : 'Unknown user';

          if (userIsStaffMember(user)) member.staffUser = true;
        }
      }
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('transformMembersForSave', transformMembersForSave);

  transformMembersForSave.$inject = [];
  /* ng-inject */
  function transformMembersForSave() {

    return (selectedTeam) => {
      const members = [];

      for (const member of selectedTeam.members) {
        const roles = [];
        if (member.private) roles.push('privateLeads');
        
        if (member.manager) roles.push('manager');
        
        members.push({
          vtag: member.vtag,
          userid: member.userid,
          roles: roles
        });
      }
      return members;
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('transformIdsToSubteams', transformIdsToSubteams);

  transformIdsToSubteams.$inject = [];
  /* ng-inject */
  function transformIdsToSubteams() {

    return (teams, subteams) => {
      const transformedSubteams = [];

      for (const subteam of subteams) {
        for (const team of teams) {
          if (team._id !== subteam) continue;
          
          transformedSubteams.push({
            _id: team._id,
            name: team.name
          });
          break;

        }
      }

      return transformedSubteams;
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('saveSubteams', saveSubteams);

  saveSubteams.$inject = ['TeamsAPI', 'transformSubteamForSave'];
  /* ng-inject */
  function saveSubteams(TeamsAPI, transformSubteamForSave) {

    return (selectedTeam) => {
      return new Promise((resolve, reject) => {
        const promiseArray = [];

        for (const subteam of selectedTeam.subteams) {
          if (subteam._id) continue;
            
          promiseArray.push(TeamsAPI.updateOrCreateTeam(transformSubteamForSave(subteam)));
        }

        Promise.all(promiseArray).then(resolve).catch(reject);
      });
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('removeSubTeamsOfSubTeams', removeSubTeamsOfSubTeams);

  removeSubTeamsOfSubTeams.$inject = ['TeamsAPI', 'transformTeamForDelete'];
  /* ng-inject */
  function removeSubTeamsOfSubTeams(TeamsAPI, transformTeamForDelete) {

    const func = (id, teams) => {
      const promiseArray = [];
      for (const team of teams) {
        if (team._id !== id) continue;

        for (const subteamid of team.subteams) {
          for (const t2 of teams) {
            if (t2._id !== subteamid) continue;
            
            promiseArray.push(TeamsAPI.updateFormVtags([t2._id]));
            promiseArray.push(TeamsAPI.deleteTeam(transformTeamForDelete(t2)));
            promiseArray.push.apply(promiseArray, func(subteamid, teams));
            break;
            
          }
        }
        break;
      }

      return promiseArray;
    };

    return func;

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('removeSubTeamsIfNecessary', removeSubTeamsIfNecessary);

  removeSubTeamsIfNecessary.$inject = ['TeamsAPI', 'getIdsFromSubteams', 'removeSubTeamsOfSubTeams', 'transformTeamForDelete'];
  /* ng-inject */
  function removeSubTeamsIfNecessary(TeamsAPI, getIdsFromSubteams, removeSubTeamsOfSubTeams, transformTeamForDelete) {

    return (removeAllTeams, selectedTeam, teams) => {
      if (removeAllTeams) {
        const subteams = getIdsFromSubteams(selectedTeam);
        const promiseArray = [];

        for (const subteam of subteams) {
          for (const team of teams) {
            if (team._id !== subteam) continue;
            
            promiseArray.push(TeamsAPI.updateFormVtags([team._id]));
            promiseArray.push(TeamsAPI.deleteTeam(transformTeamForDelete(team)));
            promiseArray.push.apply(promiseArray, removeSubTeamsOfSubTeams(subteam, teams));
            break;
          }
        }

        return Promise.all(promiseArray);
      } else {
        return Promise.resolve();
      }
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('common')
    .service('removeRootTeamsThatHaveParents', removeRootTeamsThatHaveParents);

  removeRootTeamsThatHaveParents.$inject = [];
  /* ng-inject */
  function removeRootTeamsThatHaveParents() {

    return (treeStructuredTeams, idsWithParents) => {
      const indexesToSplice = [];

      for (const id of idsWithParents) {

        for (let j = 0; j < treeStructuredTeams.length; j++) {
          if (id !== treeStructuredTeams[j]._id) continue;

          indexesToSplice.push(j);
          break;
        }
      }

      indexesToSplice.sort((a, b) => b - a);

      for (const i of indexesToSplice) {
        treeStructuredTeams.splice(i, 1);
      }
      
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('common')
    .service('recalculateTreeStructureForTeams', recalculateTreeStructureForTeams);

  recalculateTreeStructureForTeams.$inject = ['insertSubteams', 'removeRootTeamsThatHaveParents', 'markTeamsThatMatchSearchValue', '$timeout'];
  /* ng-inject */
  function recalculateTreeStructureForTeams(insertSubteams, removeRootTeamsThatHaveParents, markTeamsThatMatchSearchValue, $timeout) {

    return (teams, treeStructuredTeams, searchValue) => {
      const teamContainer = document.querySelector('#team-container');
      const scrollTopForTreeElement = teamContainer ? angular.element(teamContainer)[0].scrollTop : 0;
      treeStructuredTeams.splice(0);
      const idsWithParents = [];

      for (const team of teams) {
        const copiedTeam = angular.copy(team);
        treeStructuredTeams.push(copiedTeam);
        insertSubteams(teams, copiedTeam, treeStructuredTeams, idsWithParents);
      }

      removeRootTeamsThatHaveParents(treeStructuredTeams, idsWithParents);
      markTeamsThatMatchSearchValue(treeStructuredTeams, searchValue);
      $timeout(function () {
        if (teamContainer) {
          angular.element(document.querySelector('#team-container'))[0].scrollTop = scrollTopForTreeElement;
        }
      }, 0, false);
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('reapplyOpenPropertiesToTeams', reapplyOpenPropertiesToTeams);

  reapplyOpenPropertiesToTeams.$inject = [];
  /* ng-inject */
  function reapplyOpenPropertiesToTeams() {

    return (oldTeams, newTeams) => {
      for (const newTeam of newTeams) {

        for (const oldTeam of oldTeams) {
          if (oldTeam._id !== newTeam._id || !oldTeam.open) continue;
          
          newTeam.open = true;
          break;
        }

      }
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('common')
    .service('markTeamsThatMatchSearchValue', markTeamsThatMatchSearchValue);

  markTeamsThatMatchSearchValue.$inject = [];
  /* ng-inject */
  function markTeamsThatMatchSearchValue() {

    const func = (treeStructuredTeams, searchValue, override) => {
      for (const team of treeStructuredTeams) {
        if (team.name.match(new RegExp(searchValue, 'ig')) || override) {
          team.shouldShow = true;
        }
        if (team.treeSubteams) {
          func(team.treeSubteams, searchValue, team.shouldShow);
        }
      }
    };

    return func;

  }

})();

(function () {
  'use strict';

  angular
    .module('common')
    .service('insertSubteams', insertSubteams);

  insertSubteams.$inject = [];
  /* ng-inject */
  function insertSubteams() {

    const func = (teams, team, treeStructuredTeams, idsWithParents) => {
      for (const subteam of team.subteams) {
        for (const t of teams) {
          if (t._id !== subteam) continue;

          if (idsWithParents.indexOf(subteam) === -1) idsWithParents.push(subteam);
          
          team.treeSubteams = team.treeSubteams || [];
          const copiedTeam = angular.copy(t);
          team.treeSubteams.push(copiedTeam);
          func(teams, copiedTeam, treeStructuredTeams, idsWithParents);
          break;
        }

      }
    };

    return func;

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('getTeams', getTeams);

  getTeams.$inject = ['TeamsAPI', 'UserFactory', 'MessageService', 'reapplyOpenPropertiesToTeams', 'transformMembersForTeams', 'recalculateTreeStructureForTeams'];
  /* ng-inject */
  function getTeams(TeamsAPI, UserFactory, MessageService, reapplyOpenPropertiesToTeams, transformMembersForTeams, recalculateTreeStructureForTeams) {

    return (teams, treeStructuredTeams, searchValue) => {
      const oldTeams = angular.copy(teams);
      return new Promise((resolve) => {
        return TeamsAPI.getTeams()
          .then((res) => {
            teams.splice(0);
            teams.push.apply(teams, res.data.data);
            reapplyOpenPropertiesToTeams(oldTeams, teams);
            return UserFactory.getUserList();
          })
          .then((factoryData) => {
            transformMembersForTeams(factoryData.combinedUsersObject, teams);
            recalculateTreeStructureForTeams(teams, treeStructuredTeams, searchValue);
            return resolve();
          })
          .catch((err) => {
            MessageService.writeLog({
              level: 'error',
              msg: 'Error from getTeams(): ' + JSON.stringify(err),
              tags: ['teams']
            });
            MessageService.showMessage('Server could not retrieve teams, please try again later');
            return resolve();
          });
      });
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('getIdsFromSubteams', getIdsFromSubteams);

  getIdsFromSubteams.$inject = [];
  /* ng-inject */
  function getIdsFromSubteams() {

    return selectedTeam => {
      const subteams = [];
      for (const subteam of selectedTeam.subteams) {
        subteams.push(subteam._id);
      }
      return subteams;
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .service('addSubteamsToTeams', addSubteamsToTeams);

  addSubteamsToTeams.$inject = [];
  /* ng-inject */
  function addSubteamsToTeams() {

    return (res, teams) => {
      for (const r of res) {
        teams.push(r.data.data);
      }
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpTeamsFab', {
      templateUrl: 'app/clients/teams/fab/fab.tmpl.html',
      controller: 'zpTeamsFabCtrl',
      bindings: {
        teams: '<',
        selectedTeam: '<',
        save: '&',
        removeTeam: '&',
        editTeam: '&'
      },
      controllerAs: 'vm'
    })
    .controller('zpTeamsFabCtrl', ctrl);

  ctrl.$inject = ['MessageService'];
  /* nj-inject */
  function ctrl(MessageService) {

    var vm = this;
    vm.isOpen = true;

    vm.showRemoveTeamDialog = (ev) => {
      MessageService.showDialog(ev, {
        controller: RemoveTeamCtrl,
        controllerAs: 'vm',
        templateUrl: 'app/clients/teams/dialogs/remove-team/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          team: vm.selectedTeam
        }
      })
        .then((removeOption) => {
          vm.removeTeam({ removeAllTeams: removeOption });
        })
        .catch(() => {
          // cancelled modal, no need to worry
        });
    };

    vm.showEditTeamDialog = (ev) => {
      MessageService.showDialog(ev, {
        controller: EditTeamCtrl,
        controllerAs: 'vm',
        templateUrl: 'app/clients/teams/dialogs/edit-team/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          team: vm.selectedTeam,
          teams: vm.teams
        }
      })
        .then((team) => {
          vm.editTeam({ team: team });
        })
        .catch(() => {
          // cancelled modal, no need to worry
        });
    };

    return vm;
  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .component('teamsDetail', {
      templateUrl: 'app/clients/teams/detail/view.tmpl.html',
      controller: 'TeamsDetailCtrl',
      bindings: {
        selectedTeam: '<',
        teams: '<',
        addSubteam: '&',
        addUsers: '&',
        removeSubteam: '&',
        updateDirty: '&',
        setAllMembersFlag: '&',
        selectAllSubteams: '&',
        removeSelectedTeams: '&',
        removeSelectedUsers: '&'
      },
      controllerAs: 'vm'
    })
    .controller('TeamsDetailCtrl', ctrl);

  ctrl.$inject = ['MessageService', 'TeamsAPI', 'PermPermissionStore', 'transformTeamForSave', 'uuidService'];
  /* ng-inject */
  function ctrl(MessageService, TeamsAPI, PermPermissionStore, transformTeamForSave, uuidService) {

    var vm = this;
    vm.privateSelectAll = false;
    vm.managerSelectAll = false;
    vm.userSelectAll = false;
    vm.showSubTeamPanel = true;
    vm.showUserPanel = true;
    vm.isZuantAdmin = false;

    vm.$onInit = () => {
      const isZuantAdminPermissionPromise = PermPermissionStore.getPermissionDefinition('ZUANT_ADMIN');
      isZuantAdminPermissionPromise.validatePermission()
        .then(() => vm.isZuantAdmin = true)
        .catch(() => vm.isZuantAdmin = false);
    };

    vm.openMenu = (func, ev) => {
      func(ev);
    };

    vm.showAddSubteamDialog = (ev) => {
      MessageService.showDialog(ev, {
        controller: AddTeamCtrl,
        controllerAs: 'vm',
        templateUrl: 'app/clients/teams/dialogs/add-team/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          team: {
            name: ''
          },
          parentTeam: vm.selectedTeam,
          teams: vm.teams
        }
      })
        .then((obj) => {
          if (!obj.copy) return vm.addSubteam({ team: obj.team });

          // Don't copy the subteams because that would be ridiculous and we'd have recursion problems
          obj.team.subteams = [];
          obj.team.name = obj.team.name.length > 0 ? obj.team.name : obj.copy.name;
          obj.team.members = obj.copy.members;
          for (const member of obj.team.members) {
            member.vtag = uuidService.getSingleNewBase64Key();
          }

          TeamsAPI.updateOrCreateTeam(transformTeamForSave(obj.team))
            .then((res) => {
              obj.team._id = res.data.data._id;
              vm.addSubteam({ team: obj.team, addToTeams: true });
            })
            .catch((err) => {
              MessageService.writeLog({
                level: 'error',
                msg: 'Error from updateOrCreateTeam(): ' + JSON.stringify(err),
                tags: ['teams']
              });
              MessageService.showMessage('Server could not create team, please try again later');
            });

        })  
        .catch(() => {
          // cancelled modal, no need to worry
        });
    };

    vm.showAddUsersDialog = ev => {
      MessageService.showDialog(ev, {
        controller: AddUsersCtrl,
        controllerAs: 'vm',
        templateUrl: 'app/clients/teams/dialogs/add-users/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          team: vm.selectedTeam
        }
      })
        .then((users) => {
          vm.userSelectAll = false;
          vm.addUsers({ users: users });
        })
        .catch(() => {
          // cancelled modal, no need to worry
        });
    };

    vm.showRemoveSelectedTeamsDialog = (ev) => {
      let canRemove = false;
      for (const subteam of vm.selectedTeam.subteams) {
        if (!subteam.selected) continue;

        canRemove = true;
        break;
      }

      if (!canRemove){
        MessageService.showMessage('You must select some subteams if you want to remove them');
        return;
      }

      MessageService.showDialog(ev, {
        controller: RemoveSelectedTeamsCtrl,
        controllerAs: 'vm',
        templateUrl: 'app/clients/teams/dialogs/remove-selected-teams/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          team: vm.selectedTeam
        }
      })
        .then(removeOption => {
          vm.removeSelectedTeams({ removeAllTeams: removeOption });
        })
        .catch(() => {
          // cancelled modal, no need to worry
        });


    };

    return vm;
  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpPrivacyManagementPage', {
      templateUrl: 'app/clients/privacy-statements-manager/privacy-statement-page/privacy-statement-page.tmpl.html',
      controller: 'PrivacyStatementPageController',
      bindings: {}
    })
    .controller('PrivacyStatementPageController', controller);

  controller.$inject = ['SinglePrivacyStatementFactory', 'PrivacyStatementListFactory'];
  /* ng-inject */
  function controller(SinglePrivacyStatementFactory, PrivacyStatementListFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.auditDoc = SinglePrivacyStatementFactory.factoryData.modelForAuditCollection;
      vm.activePrivacyStatements = PrivacyStatementListFactory.factoryData.items;
      vm.archivedPrivacyStatements = PrivacyStatementListFactory.factoryData.archivedItems;
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpPrivacyStatement', {
      templateUrl: 'app/clients/privacy-statements-manager/privacy-statement-list-item/privacy-statement-list-item.tmpl.html',
      controller: 'zpPrivacyStatementCtrl',
      bindings: {
        data: '<'
      }
    })
    .controller('zpPrivacyStatementCtrl', controller);

  controller.$inject = ['PrivacyStatementsViewModel', 'EnvService'];
  /* ng-inject */
  function controller(PrivacyStatementsViewModel, EnvService) {

    var vm = this;

    vm.$onInit = function () {
      vm.data._lastmodifieddatelocalutc = new Date(vm.data._lastmodifieddatelocalutc);
      vm.isDev = EnvService.isDev;
    };

    vm.editStatement = function (ev) {
      const params = {
        ev: ev,
        createNewStatement: false,
        viewOnly: false,
        collection: 'artefact',
        title: 'editing',
        query: {
          _id: vm.data._id
        },
        itemInArchivedArray: vm.data._deletedatelocalutc ? true : false
      };

      return PrivacyStatementsViewModel.loadPrivacyStatementDialog(params);
    };

    vm.viewVersionHistory = function (ev, versionId) {
      const params = {
        ev: ev,
        createNewStatement: false,
        viewOnly: true,
        collection: 'audit',
        title: 'viewing version',
        query: {
          _id: versionId
        }
      };

      return PrivacyStatementsViewModel.loadPrivacyStatementDialog(params);
    };

    vm.archiveStatement = function(ev){
      const params = {
        ev: ev,
        _id: vm.data._id,
      };

      return PrivacyStatementsViewModel.archiveStatement(params);
    };

    vm.unarchiveStatement = function(ev){
      const params = {
        ev: ev,
        _id: vm.data._id
      };

      return PrivacyStatementsViewModel.unarchiveStatement(params);
    };

    vm.deleteStatement = function (ev) {
      const params = {
        ev: ev,
        _id: vm.data._id,
        itemInArchivedArray: vm.data._deletedatelocalutc ? true : false
      };

      return PrivacyStatementsViewModel.deleteStatement(params);
    };

    vm.iconStyle = function (){
      return {
        color: vm.data.isPrimaryStatement ? '#FEC353' : '#ECF1F4',
        backgroundColor: '#fff'
      };
    };


  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('SinglePrivacyStatementFactory', factory);

  factory.$inject = ['NewPrivacyStatementModel'];
  /* ng-inject */
  function factory(NewPrivacyStatementModel) {

    const factoryData = {
      model: {}
    };

    return {
      factoryData: factoryData,
      hydrateWithNewModel: hydrateWithNewModel,
      hydrateWithModel: hydrateWithModel,
      returnStatementToSave: returnStatementToSave,
    };

    function hydrateWithNewModel() {
      deleteDeleteDateIfNecessary();
      factoryData.model = _.extend(factoryData.model, {}, NewPrivacyStatementModel());
    }

    function hydrateWithModel(model) {
      deleteDeleteDateIfNecessary();
      factoryData.model = _.extend(factoryData.model, {}, model);
    }

    function deleteDeleteDateIfNecessary() {
      if (factoryData.model._deletedatelocalutc) {
        delete factoryData.model._deletedatelocalutc;
      }
    }

    function returnStatementToSave() {
      return {
        _id: factoryData.model._id,
        title: factoryData.model.title,
        isPrimaryStatement: factoryData.model.isPrimaryStatement,
        text: factoryData.model.text,
        artefactType: 'PrivacyStatement',
        _lastmodifieddatelocalutc: new Date(),
        archived: factoryData.model.archived
      };
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('PrivacyStatementsViewModel', factory);

  factory.$inject = ['PrivacyStatementsApiFactory', '$q', 'MessageService', 'PrivacyStatementListFactory', 'SinglePrivacyStatementFactory', 'PrivacyStatementAuditModel', 'uuidService', 'ChangeDelta'];
  /* ng-inject */
  function factory(PrivacyStatementsApiFactory, $q, MessageService, PrivacyStatementListFactory, SinglePrivacyStatementFactory, PrivacyStatementAuditModel, uuid, ChangeDelta) {

    const factoryData = {
      cacheValid: false,
      privacyStatementFormObject: {}
    };

    return {
      hydrateFactoryWithPrivacyStatements: hydrateFactoryWithPrivacyStatements,
      loadPrivacyStatementDialog: loadPrivacyStatementDialog,
      deleteStatement: deleteStatement,
      archiveStatement: archiveStatement,
      unarchiveStatement: unarchiveStatement,
      factoryData: factoryData,
      // public for testing purposes
      showDialog: showDialog,
      checkIfUserPromptIsRequired: checkIfUserPromptIsRequired,
      promptUserToSwitchPrimaryStatement: promptUserToSwitchPrimaryStatement,
      savePrivacyStatement: savePrivacyStatement,
      saveStatementToAudit: saveStatementToAudit,
      addToLocalModel: addToLocalModel,
      invalidateCache: invalidateCache
    };

    function invalidateCache() {
      factoryData.cacheValid = false;
      PrivacyStatementListFactory.resetFactory();
    }

    // used by config file to load all statements on the route resolve
    function hydrateFactoryWithPrivacyStatements(props) {
      return $q(
        function q(resolve, reject) {
          if (factoryData.cacheValid) {
            buildPrivacyStatementFastLookup(PrivacyStatementListFactory.factoryData.items || []);
            resolve(PrivacyStatementListFactory.factoryData.items);
          } else {
            return PrivacyStatementsApiFactory.fetchPrivacyStatementsFromServer(props)
              .then(function (res) {
                factoryData.cacheValid = true;
                PrivacyStatementListFactory.hydrateModel(res);
                buildPrivacyStatementFastLookup(res);
                resolve(res);
              })
              .catch(function (err) {
                reject(err);
              });
          }
        });
    }

    function buildPrivacyStatementFastLookup(privacyStatementsArray) {
      const ro = {};
      _.each(privacyStatementsArray, function (statement) {
        ro[statement._id] = statement;
      });
      factoryData.privacyStatementsFastLookup = ro;
    }

    function loadPrivacyStatementDialog(params) {

      const dialogConfig = {
        controller: 'SingleStatementDialogCtrl as $ctrl',
        templateUrl: 'app/clients/privacy-statements-manager/dialogs/single-privacy-statement-dialog.tmpl.html',
        clickOutsideToClose: true,
        fullscreen: false,
        locals: {
          toolbarTitle: params.title,
          viewOnly: params.viewOnly,
          newStatement: params.createNewStatement
        }
      };

      return prepareModelForDialog(params, dialogConfig)
        .then(function () {
          showDialog(params, dialogConfig);
        })
        .catch(function () {
          showDialog(params, dialogConfig);
        });
    }

    function prepareModelForDialog(params) {
      return $q(function q(resolve, reject) {
        if (params.createNewStatement) {
          SinglePrivacyStatementFactory.hydrateWithNewModel();
          if (!PrivacyStatementListFactory.factoryData.items.length) SinglePrivacyStatementFactory.factoryData.model.isPrimaryStatement = true; // if no statements then default first one to primary
          resolve();
        } else {
          return PrivacyStatementsApiFactory.getPrivacyStatementDocByQuery(params)
            .then(function (res) {
              SinglePrivacyStatementFactory.hydrateWithModel(res);
              PrivacyStatementAuditModel.setModelForAudit(res);
              resolve(res);
            })
            .catch(function (err) {
              reject(err);
            });
        }
      });
    }

    function showDialog(params, dialogConfig) {
      return MessageService.showDialog(params.ev, dialogConfig)
        .then(function (res) {
          if (res.save) {
            return checkIfUserPromptIsRequired(params, res);
          }
        });
    }

    function checkIfUserPromptIsRequired(params, resultFromDialog) {
      if (resultFromDialog.validation.requiresUserPromptToChangePrimary) {
        return promptUserToSwitchPrimaryStatement(params.ev, resultFromDialog.validation.existingPrimaryStatement)
          .then(function () {
            savePrivacyStatement(params.createNewStatement);
          });
      }

      return savePrivacyStatement(params.createNewStatement);
    }

    function promptUserToSwitchPrimaryStatement(ev, existingPrimaryStatement) {
      const oldPrimaryStatementToSave = {
          _id: existingPrimaryStatement._id,
          title: existingPrimaryStatement.title,
          isPrimaryStatement: false, // tell server it's not longer primary
          _lastmodifieddatelocalutc: new Date()
        },
        oldPrimaryStatementAuditDoc = {
          _id: uuid.getSingleNewBase64Key(),
          _iid: existingPrimaryStatement._id,
          title: existingPrimaryStatement.title,
          isPrimaryStatement: true, // last hurrah!
          _lastmodifieddatelocalutc: new Date()
        };

      return MessageService.confirm(ev)
        .confirmAction({
          title: existingPrimaryStatement.title + ' is currently the primary statement for the account',
          content: 'Do you want to make this template the primary one?',
          okBtn: 'Yes',
          cancelBtn: 'No'
        })
        .then(function () {
          PrivacyStatementListFactory.addAuditDocToItemVersionHistory(oldPrimaryStatementAuditDoc);
          PrivacyStatementListFactory.updateItemAfterEdit({
            _id: existingPrimaryStatement._id,
            title: existingPrimaryStatement.title,
            isPrimaryStatement: false,
          });
          const promises = [];
          promises.push(PrivacyStatementsApiFactory.savePrivacyStatement(oldPrimaryStatementToSave));
          promises.push(PrivacyStatementsApiFactory.saveStatementToAudit(oldPrimaryStatementAuditDoc));
          return $q.all(promises);
        })
        .catch(function () {
          SinglePrivacyStatementFactory.factoryData.model.isPrimaryStatement = false; // user doesn't want to change primary so unset this one as primary
          return;
        });
    }

    function savePrivacyStatement(createNewStatement) {
      const statementToSave = SinglePrivacyStatementFactory.returnStatementToSave();
      return PrivacyStatementsApiFactory.savePrivacyStatement(statementToSave)
        .then(function () {
          factoryData.cacheValid = false;
          ChangeDelta.clear();
          PrivacyStatementListFactory.updateItemAfterEdit(statementToSave);
          MessageService.pushEventToIntercom('privacy_statement_saved', {
            statementId: statementToSave._id,
            title: statementToSave.title,
            isPrimaryStatement: statementToSave.isPrimaryStatement
          });
          if (createNewStatement) {
            return addToLocalModel(statementToSave);
          } else {
            return saveStatementToAudit();
          }
        })
        .catch(function (err) {
          MessageService.showMessage(err.message);
        });
    }

    function saveStatementToAudit() {
      const auditDocToSave = PrivacyStatementAuditModel.returnAuditStatementToSave();
      return PrivacyStatementsApiFactory.saveStatementToAudit(auditDocToSave)
        .then(function () {
          PrivacyStatementListFactory.addAuditDocToItemVersionHistory(auditDocToSave);
          MessageService.showMessage('Privacy statement saved');
        })
        .catch(function (err) {
          throw err;
        });
    }

    function addToLocalModel(statementToSave) {
      MessageService.writeLog({
        level: 'info',
        msg: 'saved a newStatement, adding to local model',
        tags: ['privacy_statement']
      });
      statementToSave.versions = [];
      PrivacyStatementListFactory.addItem(statementToSave);
      return;
    }

    function archiveStatement(params) {
      const targetItem = _.find(PrivacyStatementListFactory.factoryData.items, function (item) {
        return item._id === params._id;
      });

      const update = {
        _id: targetItem._id,
        archived: true
      };

      return MessageService.confirm(params.ev)
        .confirmAction({
          title: 'Are you sure you wish to archive this privacy statement?',
          okBtn: 'YES',
          cancelBtn: 'NO'
        })
        .then(function () {
          return PrivacyStatementsApiFactory.savePrivacyStatement(update);
        })
        .then(function () {
          targetItem._lastmodifieddatelocalutc = new Date();
          PrivacyStatementListFactory.updateItemAfterEdit(update);
        })
        .catch(function (err) {
          throw err;
        });
    }

    function unarchiveStatement(params) {
      const targetItem = _.find(PrivacyStatementListFactory.factoryData.archivedItems, function (item) {
        return item._id === params._id;
      });

      const update = {
        _id: targetItem._id,
        archived: false
      };
      return MessageService.confirm(params.ev)
        .confirmAction({
          title: 'Are you sure you wish to unarchive this privacy statement?',
          okBtn: 'YES',
          cancelBtn: 'NO'
        })
        .then(function () {
          return PrivacyStatementsApiFactory.savePrivacyStatement(update);
        })
        .then(function () {
          targetItem._lastmodifieddatelocalutc = new Date();
          PrivacyStatementListFactory.updateItemAfterEdit(update);
        })
        .catch(function (err) {
          throw err;
        });
    }

    function deleteStatement(params) {
      return MessageService.confirm(params.ev)
        .delete('Sure to delete this privacy statement?')
        .then(function () {
          return PrivacyStatementsApiFactory.deleteStatement(params._id);
        })
        .then(function () {
          if (params.itemInArchivedArray) {
            PrivacyStatementListFactory.spliceItemFromModel(params._id, PrivacyStatementListFactory.factoryData.archivedItems);
          } else {
            PrivacyStatementListFactory.spliceItemFromModel(params._id, PrivacyStatementListFactory.factoryData.items);
          }
        })
        .catch(function (err) {
          throw err;
        });
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('PrivacyStatementValidationFactory', factory);

  factory.$inject = ['PrivacyStatementListFactory', 'SinglePrivacyStatementFactory'];
  /* ng-inject */
  function factory(PrivacyStatementListFactory, SinglePrivacyStatementFactory) {

    return {
      validatePrimaryStatement: validatePrimaryStatement
    };

    function validatePrimaryStatement() {

      const itemToValidate = SinglePrivacyStatementFactory.factoryData.model;
      const allPrivacyStatements = PrivacyStatementListFactory.factoryData.items;

      const currentPrimaryStatement = _.find(allPrivacyStatements, function (item) {
        return item.isPrimaryStatement;
      });
      if (currentPrimaryStatement) {
        return primaryStatementSetAlreadyContinueValidating(currentPrimaryStatement, itemToValidate);
      } else {
        return noCurrentPrimarySetContinueValidating(itemToValidate);
      }
    }

    function primaryStatementSetAlreadyContinueValidating(currentPrimaryStatement, itemToValidate) {
      if (currentPrimaryStatement._id == itemToValidate._id) {
        if (itemToValidate.isPrimaryStatement) {
          return {
            valid: true,
            existingPrimaryStatement: itemToValidate
          };
        } else {
          return {
            valid: false,
            existingPrimaryStatement: undefined,
            errorMessage: 'Your account must have a primary privacy statement at all times'
          };
        }
      } else if (itemToValidate.isPrimaryStatement) {
        return {
          valid: true,
          existingPrimaryStatement: currentPrimaryStatement,
          requiresUserPromptToChangePrimary: true
        };
      } else {
        return {
          valid: true,
          existingPrimaryStatement: currentPrimaryStatement
        };
      }
    }

    function noCurrentPrimarySetContinueValidating(itemToValidate) {
      if (itemToValidate.isPrimaryStatement) {
        return {
          valid: true,
          existingPrimaryStatement: itemToValidate
        };
      } else {
        return {
          valid: false,
          existingPrimaryStatement: undefined,
          errorMessage: 'Your account must have a primary privacy statement at all times'
        };
      }
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('PrivacyStatementListFactory', factory);

  factory.$inject = ['SpliceItemFromModel'];
  /* ng-inject */
  function factory(SpliceItemFromModel) {

    const factoryData = {
      items: [],
      archivedItems: []
    };

    return {
      factoryData: factoryData,
      hydrateModel: hydrateModel,
      addItem: addItem,
      addAuditDocToItemVersionHistory: addAuditDocToItemVersionHistory,
      updateItemAfterEdit: updateItemAfterEdit,
      spliceItemFromModel: SpliceItemFromModel,
      resetFactory: resetFactory
    };

    function resetFactory(){
      factoryData.items = [];
      factoryData.archivedItems = [];
    }

    function hydrateModel(list) {
      const listOfActiveItems = _.filter(list, function (itm) {
        return !itm._deletedatelocalutc;
      });
      factoryData.items = _.extend(factoryData.items, [], listOfActiveItems);

      const listOfArchivedItems = _.filter(list, function (itm) {
        return itm._deletedatelocalutc;
      });
      factoryData.archivedItems = _.extend(factoryData.archivedItems, [], listOfArchivedItems);

    }

    function addItem(privacyStatement) {
      factoryData.items.push(privacyStatement);
    }

    function addAuditDocToItemVersionHistory(auditDoc) {
      const targetItem = _.find(factoryData.items, function (item) {
        return item._id === auditDoc._iid;
      });
      if (targetItem) {
        if (typeof targetItem.versions === 'undefined') targetItem.versions = [];
        targetItem.versions.unshift(angular.copy(auditDoc)); // push a copy onto the array else the save fails due to $$ keys angular adds to the object. (when in switching primary statement flow)
      }
    }

    function updateItemAfterEdit(updatedItem) {

      let targetItem = _.find(factoryData.items, function (item) {
        return item._id === updatedItem._id;
      });

      if (targetItem) {
        if (updatedItem.archived) {
          targetItem._deletedatelocalutc = new Date();
          SpliceItemFromModel(targetItem._id, factoryData.items);
          addToModel(targetItem, factoryData.archivedItems);
        }
        _.extend(targetItem, {}, updatedItem);
      } else {
        targetItem = _.find(factoryData.archivedItems, function (item) {
          return item._id === updatedItem._id;
        });
        if (targetItem) {
          if (targetItem._deletedatelocalutc && !updatedItem.archived) {
            delete targetItem._deletedatelocalutc;
            SpliceItemFromModel(targetItem._id, factoryData.archivedItems);
            addToModel(targetItem, factoryData.items);
          }
          _.extend(targetItem, {}, updatedItem);
        }
      }

    }

    function addToModel(item, model) {
      model.push(item);
    }

    // function spliceItemFromModel(_id, model) {
    //   var index;
    //   _.find(model, function (itm, ix) {
    //     if (itm._id == _id) {
    //       index = ix;
    //       return;
    //     }
    //   });
    //   model.splice(index, 1);
    // }
  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('PrivacyStatementsApiFactory', factory);

  factory.$inject = ['ListApiFactory', 'MessageService'];
  /* ng-inject */
  function factory(ListApiFactory, MessageService) {

    return {
      fetchPrivacyStatementsFromServer: fetchPrivacyStatementsFromServer,
      getPrivacyStatementDocByQuery: getPrivacyStatementDocByQuery,
      savePrivacyStatement: savePrivacyStatement,
      saveStatementToAudit: saveStatementToAudit,
      deleteStatement: deleteStatement
    };

    function fetchPrivacyStatementsFromServer(props) {
      return ListApiFactory.getPrivacyStatements(props)
        .then(function (res) {
          MessageService.writeLog({
            level: 'info',
            msg: 'loaded all privacy statements',
            tags: ['privacy_statement']
          });
          return res.data.data;
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: 'error fetching artefacts by type: ' + err,
            tags: ['privacy_statement']
          });
          throw err;
        });
    }

    function getPrivacyStatementDocByQuery(params) {
      return fetchDocument(params)
        .then(function (res) {
          if (res.data.data[0]) {
            MessageService.writeLog({
              level: 'info',
              msg: 'getPrivacyStatementDocByQuery success: ' + res.data.data[0]._id,
              tags: ['privacy_statement']
            });
            return res.data.data[0];
          } else {
            return '404 not found';
          }
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: 'getPrivacyStatementDocByQuery error: ' + params.query._id,
            tags: ['privacy_statement']
          });
          throw err;
        });
    }

    function fetchDocument(params) {
      if (params.collection === 'artefact') {
        return ListApiFactory.getArtefactsByQuery(params.query, {
          _deletedatelocalutc: 1,
          _lastmodifieddatelocalutc: 1,
          _lastmodifiedonservertime: 1,
          text: 1,
          isPrimaryStatement: 1,
          title: 1
        });
      } else if (params.collection === 'audit') {
        return ListApiFactory.getAuditDocByQuery(params.query, {});
      }
    }

    function savePrivacyStatement(statementToSave) {
      return ListApiFactory.saveList(statementToSave)
        .then(function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'savePrivacyStatement success: ' + statementToSave._id,
            tags: ['privacy_statement']
          });
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: 'savePrivacyStatement error: ' + err,
            tags: ['privacy_statement']
          });
          throw err;
        });
    }

    function saveStatementToAudit(docToSave) {
      return ListApiFactory.savePrivacyStatementAudit(docToSave)
        .then(function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'saveStatementToAudit success: ' + docToSave._id,
            tags: ['privacy_statement']
          });
          return {
            message: 'Privacy statement audit saved'
          };
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: 'saveStatementToAudit error: ' + err,
            tags: ['privacy_statement']
          });
          throw err;
        });
    }

    function deleteStatement(_id) {
      return ListApiFactory.deletePrivacyStatement(_id)
        .then(function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'deleteStatement success: ' + _id,
            tags: ['privacy_statement']
          });
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: 'deleteStatement error: ' + err,
            tags: ['privacy_statement']
          });
          throw err;
        });
    }

  }
}());

angular
  .module('clients')
  .factory('NewPrivacyStatementModel', factory);

factory.$inject = ['uuidService'];
/* ng-inject */
function factory(uuid) {

  return function newModel() {
    return {
      _id: uuid.getSingleNewBase64Key(),
      title: '',
      isPrimaryStatement: false,
      text: '',
      artefactType: 'PrivacyStatement',
      versions: []
    };
  };
}

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('PrivacyStatementAuditModel', factory);

  factory.$inject = ['uuidService'];
  /* ng-inject */
  function factory(uuid) {

    const factoryData = {
      modelForAuditCollection: {}
    };

    return {
      factoryData: factoryData,
      setModelForAudit: setModelForAudit,
      returnAuditStatementToSave: returnAuditStatementToSave
    };

    function setModelForAudit(model) {
      factoryData.modelForAuditCollection = _.extend(factoryData.modelForAuditCollection, {}, angular.copy(model));
      factoryData.modelForAuditCollection._timestampSnapshot = angular.copy(model._lastmodifiedonservertime);
      factoryData.modelForAuditCollection._iid = angular.copy(model._id);
    }

    function returnAuditStatementToSave() {
      return {
        _id: uuid.getSingleNewBase64Key(),
        _iid: factoryData.modelForAuditCollection._id,
        title: factoryData.modelForAuditCollection.title,
        text: factoryData.modelForAuditCollection.text,
        isPrimaryStatement: factoryData.modelForAuditCollection.isPrimaryStatement,
        _timestampSnapshot: factoryData.modelForAuditCollection._timestampSnapshot,
        _lastmodifieddatelocalutc: new Date(),
        archived: factoryData.modelForAuditCollection.archived
      };
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpPrivacyStatementForm', {
      templateUrl: 'app/clients/privacy-statements-manager/privacy-statement-form/privacy-statement-form.tmpl.html',
      controller: 'zpPrivacyStatementFormCtrl',
      bindings: {
        privacyStatement: '<',
        viewOnly: '<',
        privacyStatementFormObject: '='
      }
    })
    .controller('zpPrivacyStatementFormCtrl', controller);

  controller.$inject = ['PrivacyStatementListFactory', 'ChangeDelta'];
  /* ng-inject */
  function controller(PrivacyStatementListFactory, ChangeDelta) {

    var vm = this;

    vm.$onInit = function () {
      vm.copyOfPrivacyStatement = angular.copy(vm.privacyStatement);
    };

    vm.iconStyle = function () {
      return {
        color: vm.privacyStatement.isPrimaryStatement ? '#FEC353' : '#ECF1F4'
      };
    };

    vm.updateChangeDelta = function (prop, newval){
      var oldval = vm.copyOfPrivacyStatement[prop];
      ChangeDelta.recordValueChange({
        oldval: oldval,
        newval: newval,
        objectid: '',
        collection: 'PrivacyStatement',
        databasefieldname: prop
      });
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpPrivacyStatementFabButtons', {
      templateUrl: 'app/clients/privacy-statements-manager/fabs/add-fab.tmpl.html',
      controller: 'zpPrivacyFabsCtrl',
      bindings: {}
    })
    .controller('zpPrivacyFabsCtrl', ctrl);

  ctrl.$inject = ['PrivacyStatementsViewModel'];
  /* ng-inject */
  function ctrl(PrivacyStatementsViewModel) {

    var vm = this;

    vm.issueNewPrivacyStatement = function (ev) {
      var params = {
        ev: ev,
        createNewStatement: true
      };
      PrivacyStatementsViewModel.loadPrivacyStatementDialog(params);
    };

  }

})();

/**
 * Created by davidbeazer on 26/07/2018.
 */

'use strict';

angular
  .module('clients')
  .controller('SingleStatementDialogCtrl', CreateStatementDialogCtrl);

CreateStatementDialogCtrl.$inject = ['locals', 'MessageService', 'SinglePrivacyStatementFactory', '$filter', 'PrivacyStatementsViewModel', 'ChangeDelta', 'PrivacyStatementValidationFactory'];
/* ng-inject */
function CreateStatementDialogCtrl(locals, MessageService, SinglePrivacyStatementFactory, $filter, PrivacyStatementsViewModel, ChangeDelta, PrivacyStatementValidationFactory) {

  var vm = this;
  ChangeDelta.clear();
  vm.changeDelta = ChangeDelta;
  vm.privacyStatement = SinglePrivacyStatementFactory.factoryData.model;
  vm.copyOfPrivacyStatement = angular.copy(vm.privacyStatement);
  vm.viewModel = PrivacyStatementsViewModel.factoryData;
  vm.toolbarTitle = buildToolbarTitle();
  vm.viewOnly = locals.viewOnly;

  vm.cancelDialog = function () {
    MessageService.cancelDialog();
  };

  vm.updateChangeDelta = function (prop, newval) {
    const oldval = vm.copyOfPrivacyStatement[prop];
    ChangeDelta.recordValueChange({
      oldval: oldval,
      newval: newval,
      objectid: '',
      collection: 'PrivacyStatement',
      databasefieldname: prop
    });
  };

  vm.submit = function () {
    const primaryStatementValidation = PrivacyStatementValidationFactory.validatePrimaryStatement();
    if (primaryStatementValidation.valid) {
      vm.errorMessage = '';
      MessageService.closeDialog({
        save: true,
        validation: primaryStatementValidation
      });
    } else {
      vm.errorMessage = primaryStatementValidation.errorMessage;
    }
  };

  function buildToolbarTitle() {
    const privacyStatement = SinglePrivacyStatementFactory.factoryData.model;
    if (locals.viewOnly) {
      return 'Viewing "' + privacyStatement.title + '" as at ' + $filter('zpDateCustom')(privacyStatement._lastmodifiedonservertime);
    } else if (!locals.viewOnly && !locals.newStatement) {
      return 'Editing "' + privacyStatement.title + '" Privacy Statement';
    } else if (locals.newStatement) {
      return 'Create new Privacy Statement';
    }
  }

}

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpUserPoolWithControls', {
      templateUrl: 'app/clients/permissions/zp-user-pool-with-controls/user-pool-with-controls.tmpl.html',
      controller: 'UserPoolWithControlsCtrl',
      bindings: {
        chips: '<',
        setViewTo: '&',
        viewActive: '<',
        pulsePresetBtn: '<',
        pulseCustomBtn: '<',
      }
    })
    .controller('UserPoolWithControlsCtrl', controller);

  controller.$inject = ['$filter'];
  /* ng-inject */
  function controller($filter) {

    var vm = this;

    vm.$onInit = function () {
      vm.dottedUpArrowImageSvg = $filter('cdnAssets')('/images/svgs/utilities/arrows/dotted_up_arr.svg');
    };
  }

}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpPermissionsPresetWidget', {
      templateUrl: 'app/clients/permissions/zp-permissions-preset-widget/permissions-preset-widget.tmpl.html',
      controller: 'PermissionsPresetWidgetCtrl',
      bindings: {
        resetUserPool: '&'
      }
    })
    .controller('PermissionsPresetWidgetCtrl', controller);

  controller.$inject = ['MessageService', 'UserPermissionsHelperFactory', 'PermissionsManagerFactory'];
  /* ng-inject */
  function controller(MessageService, UserPermissionsHelperFactory, PermissionsManagerFactory) {

    var vm = this;

    vm.$onInit = function () {
      MessageService.writeLog({
        level: 'info',
        msg: 'user on Permissions preset page',
        tags: ['permissions']
      });
    };

    vm.applyPreset = function (preset) {
      vm.activePreset = preset;
      UserPermissionsHelperFactory.getPermissionsPreset(preset)
        .then(function (res) {
          vm.presetData = res;
          vm.showApplyPresetPrompt = true;
          vm.pulsateApplyPresetBtn = true;
        })
        .catch(function (err) {
          MessageService.showMessage('Error!: ' + err.msg);
        });
    };

    vm.confirmApplyPreset = function () {
      if (!vm.presetData) MessageService.showMessage('Preset is missing');
      MessageService.writeLog({
        level: 'info',
        msg: 'applying preset to user pool',
        tags: ['permissions']
      });
      PermissionsManagerFactory.applyPresetToPool(vm.presetData);
      PermissionsManagerFactory.savePermissions()
        .then(function () {
          vm.confirmationMessage = 'The ' + vm.activePreset + ' preset has been applied to the selected users';
          vm.pulsateApplyPresetBtn = false;
          vm.showConfirmation = true;
          MessageService.showMessage('Presets Applied');
        })
        .catch(function () {});
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpUserPoolSelector', {
      templateUrl: 'app/clients/permissions/zp-user-pool-selector/zp-user-pool-selector.tmpl.html',
      controller: 'zpUserPoolSelectorCtrl',
      bindings: {}
    })
    .controller('zpUserPoolSelectorCtrl', ctrl);

  ctrl.$inject = ['UserFactory', 'PermissionsManagerFactory', 'SessionService', '$filter'];
  /* ng-inject */
  function ctrl(UserFactory, PermissionsManagerFactory, SessionService, $filter) {

    var vm = this;
    vm.users = [];

    vm.$onInit = function () {
      vm.PermissionsManagerFactory = PermissionsManagerFactory.factoryData;
      vm.permissions = PermissionsManagerFactory.permissions;
      vm.icon = 'check_box_outline_blank';
      vm.showUserList = true;
      vm.tooltip = 'Select all';
      UserFactory.getUserList(SessionService.getUserData().clientId)
        .then(function (res) {
          vm.users = _.map(res.activeUsersObject, mapUserObj);
          vm.staffUsers = _.map(res.staffUsersObject, mapUserObj);
        });
    };

    function mapUserObj(userObj){
      return {
        _id: userObj.user._id,
        firstname: userObj.user.firstname,
        surname: userObj.user.surname,
        email: userObj.user.email,
        permissions: userObj.user.permissions,
        typeofuser: userObj.user.typeofuser,
        roleorcustom: userObj.user.roleorcustom,
        inactive: userObj.user.inactive,
        avatar: userObj.user.avatar || $filter('cdnAssets')('/images/pngs/placeholders/users/avatar-placeholder.png'),
      };
    }

    vm.toggleSelectUser = function (userObj) {
      PermissionsManagerFactory.toggleUser(userObj);
    };

    vm.toggleAllUsers = function () {
      var override = vm.allUsersSelected ? 'remove' : 'add';
      _.each(vm.users, function (user) {
        PermissionsManagerFactory.toggleUser(user, override);
      });
    };

    vm.allUsersSelectedCheck = function () {
      if (_.isEmpty(PermissionsManagerFactory.factoryData.usersObject)) {
        vm.allUsersSelected = false;
        vm.toggleAllTooltip = 'Add all users to pool';
        vm.toggleAllStyle = 'fill: #949CA1;';
        return 'check_box_outline_blank';
      }
      if (Object.keys(PermissionsManagerFactory.factoryData.usersObject).length === vm.users.length) {
        vm.allUsersSelected = true;
        vm.toggleAllTooltip = 'Remove all users from pool';
        vm.toggleAllStyle = 'fill: #fec353;';
        return 'check_box';
      } else if (Object.keys(PermissionsManagerFactory.factoryData.usersObject).length > 0 && Object.keys(PermissionsManagerFactory.factoryData.usersObject).length !== vm.users.length) {
        vm.allUsersSelected = false;
        vm.toggleAllTooltip = 'Add all users to pool';
        vm.toggleAllStyle = 'fill: #5b88b5;';
        return 'indeterminate_check_box';
      } else {
        vm.allUsersSelected = false;
        vm.toggleAllTooltip = 'Add all users to pool';
        vm.toggleAllStyle = 'fill: #949CA1;';
        return 'check_box_outline_blank';
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpCustomPermissionsWidget', {
      templateUrl: 'app/clients/permissions/zp-custom-permissions-widget/custom-permissions-widget.tmpl.html',
      controller: 'CustomPermissionsWidgetCtrl',
      bindings: {}
    })
    .controller('CustomPermissionsWidgetCtrl', controller);

  controller.$inject = ['PermissionsMetadataFactory', 'PermissionsManagerFactory', 'BoltOnsFactory', 'ChangeDelta', 'CurrentClientModelFactory', '$timeout', 'MessageService'];
  /* ng-inject */
  function controller(PermissionsMetadataFactory, PermissionsManagerFactory, BoltOnsFactory, ChangeDelta, CurrentClientModelFactory, $timeout, MessageService) {

    var vm = this;

    vm.$onInit = function () {
      vm.metadata = PermissionsMetadataFactory.permissions;
      vm.permissions = PermissionsManagerFactory.factoryData.permissions;
      vm.accountBoltOns = BoltOnsFactory.factoryData.permissions;
      vm.permissionStates = PermissionsMetadataFactory.states;
      vm.PermissionsManagerFactory = PermissionsManagerFactory;
      vm.allCardsExpanded = false;
      vm.expandAllCardsIcon = 'expand_more';
      vm.expandAll(true);
    };

    vm.permissionClicked = function (block, card, group, item) {
      if (_.isEmpty(PermissionsManagerFactory.factoryData.usersObject)) {
        alert('No users selected');
        return;
      }
      var newVal = PermissionsManagerFactory.applyPermissionToPool(block, card, group, item);
      recordValueChange(block, card, group, item, newVal);
      if (group.property == 'trump' && newVal == 'allow') {
        smileDonald(card);
      }
    };

    vm.switchValueChange = function (user) {
      PermissionsManagerFactory.toggleUser(user);
    };

    vm.saveChanges = function (saveMsg) {
      PermissionsManagerFactory.savePermissions()
        .then(function () {
          if (!saveMsg) saveMsg = 'Changes saved';
          MessageService.showMessage(saveMsg);
        })
        .catch(function (err) {
          MessageService.showMessage('Error!: ' + err.msg);
        });
    };

    vm.setIcon = function (block, card, group, item, iconOrStyle) {
      try {
        if (card.property == group.property) {
          return vm.permissionStates[vm.permissions[card.property][item.key]][iconOrStyle];
        } else {
          return vm.permissionStates[vm.permissions[block.property][card.property][group.property][item.key]][iconOrStyle];
        }
      } catch (e) {
        MessageService.writeLog({
          level: 'error',
          msg: e,
          tags: ['setting_permissions_icon']
        });
      }
    };

    vm.expandAllBtnClicked = function (card) {
      card.showPermissions = !card.showPermissions;
      card.expandAllIcon = card.showPermissions ? 'expand_less' : 'expand_more';
    };

    vm.expandAll = function (toggleValue) {
      vm.allCardsExpanded = toggleValue;
      _.each(vm.metadata, function (permission) {
        _.each(permission.cards, function (card) {
          card.expandAllIcon = vm.allCardsExpanded ? 'expand_less' : 'expand_more';
          card.showPermissions = vm.allCardsExpanded;
        });
      });
      vm.expandAllCardsIcon = vm.allCardsExpanded ? 'expand_less' : 'expand_more';
    };

    function recordValueChange(block, card, group, item, newVal) {
      ChangeDelta.recordValueChange({
        oldval: workOutCurrentPoolValue(block, card, group, item),
        newval: newVal,
        collection: 'clients',
        objectid: CurrentClientModelFactory.factoryData.currentClient._id,
        databasefieldname: computeIdentifierForChangeDelta(block, card, group, item)
      });
    }

    function workOutCurrentPoolValue(block, card, group, item) {
      if (block.property === card.property && card.property === group.property) {
        return vm.permissions[group.property][item.key];
      }
      if (block.property !== card.property) {
        return vm.permissions[block.property][card.property][group.property][item.key];
      }
    }

    function smileDonald(card) {
      card.showImg = true;
      $timeout(function () {
        card.showImg = false;
      }, 2500);
    }

    function computeIdentifierForChangeDelta(block, card, group, item) {
      return block.property + '_' + card.property + '_' + group.property + '_' + item.key;
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpActionSelector', {
      templateUrl: 'app/clients/permissions/zp-action-selector/action-selector.tmpl.html',
      controller: 'ActionSelectorCtrl',
      bindings: {}
    })
    .controller('ActionSelectorCtrl', controller);

  controller.$inject = ['PermissionsManagerFactory', '$timeout', 'ChangeDelta', 'PermissionsMetadataFactory', '$filter'];
  /* ng-inject */
  function controller(PermissionsManagerFactory, $timeout, ChangeDelta, PermissionsMetadataFactory, $filter) {

    var vm = this;

    vm.$onInit = function () {
      vm.viewActive;
      vm.showUserNextStepButton = true;
      vm.showUserPoolView = false;
      vm.PermissionsManagerFactory = PermissionsManagerFactory;
      vm.metadata = PermissionsMetadataFactory.permissions;
      PermissionsManagerFactory.resetFactory();

      vm.dottedDownArrowImageSvg = $filter('cdnAssets')('/images/svgs/utilities/arrows/dotted_down2.svg');
      vm.angledLeftArrowImageSvg = $filter('cdnAssets')('/images/svgs/utilities/arrows/angled2_left.svg');
      vm.angledUpArrowImageSvg = $filter('cdnAssets')('/images/svgs/utilities/arrows/angled2UP_99.svg');

    };

    vm.noUsersInPool = function () {
      return _.isEmpty(PermissionsManagerFactory.factoryData.usersObject);
    };

    vm.resetUserPool = function () {
      PermissionsManagerFactory.resetFactory();
      vm.viewActive = null;
      vm.showUserPoolView = false;
      vm.showUserNextStepButton = true;
    };

    vm.setViewTo = function (view) {
      if (vm.viewActive == 'custom' && ChangeDelta.isDirty()) {
        if (!confirm('👋 Heads up!\nYou have some unsaved changes.\n\nClick OK to continue without saving or Cancel to stay put.')) {
          return;
        }
      }

      if (view == 'presetAndCustomButtons') {
        // vm.showUserPermissionsView = false;
        vm.showUserPoolView = true;
        vm.showUserNextStepButton = false;
        $timeout(function () {
          vm.pulsePresetBtn = true;
          vm.pulseCustomBtn = true;
          $timeout(function () {
            vm.pulsePresetBtn = false;
            vm.pulseCustomBtn = false;
          }, 1500);
        }, 600);
      }

      vm.viewActive = view;
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpPermissionsFab', {
      templateUrl: 'app/clients/permissions/fab/fab.tmpl.html',
      controller: 'zpPermissionsFabCtrl'
    })
    .controller('zpPermissionsFabCtrl', ctrl);

  ctrl.$inject = ['PermissionsManagerFactory', 'ChangeDelta', 'MessageService'];
  /* ng-inject */
  function ctrl(PermissionsManagerFactory, ChangeDelta, MessageService) {

    var vm = this;

    vm.$onInit = function () {
      vm.changeDelta = ChangeDelta;
      vm.saveChanges = saveChanges;
    };

    function saveChanges() {
      PermissionsManagerFactory.savePermissions()
        .then(function () {
          MessageService.showMessage('Changes saved');
        })
        .catch(function (err) {
          MessageService.showMessage('Error!: ' + err.msg);
        });
    }
  }
})();

/**
 * Created by davidbeazer on 27/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpClientsList', {
      controller: 'zpClientsListComponentController',
      templateUrl: 'app/clients/main/clients-list-component/zp-clients-list.tmpl.html',
      bindings: {
        metadata: '<',
        model: '<',
        search: '<'
      }
    })
    .controller('zpClientsListComponentController', Controller);

  Controller.$inject = ['$scope', 'PaginationManager', 'MessageService', '$mdMedia', '$document', 'ClientsDataFactory'];
  /* ng-inject */
  function Controller($scope, PaginationManager, MessageService, $mdMedia, $document, ClientsDataFactory) {
    var vm = this;
    vm.selectedChips = [];

    $scope.$watch('$ctrl.metadata.filterOptions.filters', function (){
      const selectedFilters = vm.metadata.filterOptions.filters.filter((filter)=> !!filter.selected);
      vm.selectedChips = selectedFilters;

      if (selectedFilters.length > 0){
        $scope.$broadcast('zp.table-rows.refresh', { widgetId: vm.metadata.id });

        ClientsDataFactory.getClientList(selectedFilters).then(function() {
          $scope.$broadcast('zp.table-rows.refreshed', { widgetId: vm.metadata.id });
        });
      }
    }, true);

    // PAGINATION
    vm.logPagination = function (page, limit) {
      vm.metadata.query.page = page;
      vm.metadata.query.limit = limit;
      PaginationManager.setQuery(vm.metadata.query, vm.metadata.id);
      $('md-content').animate({ scrollTop: 0 }, 0);
    };

    vm.primaryAction = function(ev, _id) {
      // primary table row action - enters client/user mgmt screens
      const useFullScreen = ($mdMedia('sm') || $mdMedia('xs'));
      MessageService.showDialog(ev, {
        controller: vm.metadata.manageClientDialogConfig.controller,
        templateUrl: vm.metadata.manageClientDialogConfig.templateUrl,
        parent: angular.element($document.body),
        locals: {
          clientId: _id,
          metadata: vm.metadata
        },
        clickOutsideToClose: false,
        fullscreen: useFullScreen
      })
        .then(
          function () {
            MessageService.writeLog({
              level: 'info',
              msg: 'Manage account dialog closed'
            });
          })
        .catch(function (){
          // user cancelled out of mamage client dialog
        });
    };
  }
})();

/**
 * Created by davidbeazer on 23/02/2017.
 */
(function () {
  'use strict';

  angular
    .module('clients')
    .factory('ClientsMainMetadata', ClientsMainMetadata);

  ClientsMainMetadata.$inject = ['localStorageService'];

  function ClientsMainMetadata(localStorage) {

    var factoryData = {};
    buildFactory();

    return {
      getData: getData,
      buildDialogDataForArchiveOperation: buildDialogDataForArchiveOperation,
      buildDialogDataForRedactOperation: buildDialogDataForRedactOperation,
      buildDialogDataForUnarchiveOperation: buildDialogDataForUnarchiveOperation,
      buildDialogDataForDeleteOperation: buildDialogDataForDeleteOperation
    };

    function getData() {
      return factoryData;
    }

    // PRIVATE

    function buildFactory() {

      factoryData = {
        id: 'clients_list',
        title: {
          label: 'Accounts',
          filterLabel: 'Search accounts'
        },
        columnsData: buildColumnsData(),
        query: {
          order: {
            id: 'client.companyname',
            expression: 'client.companyname.raw'
          },
          limit: localStorage.get('clients_list') || 50,
          page: 1
        },
        filterOptions: {
          filters: [
            {
              id: 'unarchived_client_list_filter',
              name: 'Unarchived',
              label: 'Show Unarchived',
              icon: 'unarchive',
              ariaLabel: 'Show Unarchived',
              storageKey: 'clients_list_show_unarchived',
              selected: localStorage.get('clients_list_show_unarchived') !== null ? localStorage.get('clients_list_show_unarchived') : true,
              query: { clientArchived: false },
              action: updateFilterSelectedValue
            },
            {
              id: 'archived_client_list_filter',
              name: 'Archived',
              label: 'Show Archived',
              icon: 'archive',
              ariaLabel: 'Show archived',
              storageKey: 'clients_list_show_archived',
              selected: localStorage.get('clients_list_show_archived') !== null ? localStorage.get('clients_list_show_archived') : false,
              query: { clientArchived: true },
              action: updateFilterSelectedValue
            }
          ]
        },
        paginationOptions: {
          boundaryLinks: true,
          limitSelect: true,
          pageSelect: true,
          pagination: true,
          limitOptions: [5, 10, 20, 50, 75, 100],
          limit: localStorage.get('clients_list') || 50,
          page: 1
        },
        gridOptions: {
          rowSelection: false,
          multiSelect: false,
          sortable: true,
          interactive: false
        },
        fabDialogConfig: {
          description: 'New client',
          controller: 'AddClientDialogController as vm',
          templateUrl: 'app/clients/dialogs/add-client-dialog/add-client-dialog.tmpl.html',
          // controller: 'GDPREnabledInfoCtrl as $ctrl',
          // templateUrl: 'app/clients/dialogs/gdpr-enabled-courtesy-info/dialog.tmpl.html',
          locals: {},
          ariaLabel: 'Create new client',
          clickOutsideToClose: false
        },
        manageClientDialogConfig: {
          description: 'Manage client',
          controller: 'ManageClientDialogController as vm',
          templateUrl: 'app/clients/dialogs/manage-client-dialog/manage-client-dialog.tmpl.html',
          locals: {},
          ariaLabel: 'Manage client'
        },
        archiveClientDialogConfig: {
          description: 'Archive client',
          controller: 'ClientOperationsDialogController as vm',
          templateUrl: 'app/clients/dialogs/client-operations-dialog/archive-client-dialog.tmpl.html',
          locals: {},
          ariaLabel: 'Arhive client'
        },
        unarchiveClientDialogConfig: {
          description: 'Unarchive client',
          controller: 'ClientOperationsDialogController as vm',
          templateUrl: 'app/clients/dialogs/client-operations-dialog/unarchive-client-dialog.tmpl.html',
          locals: {},
          ariaLabel: 'Unarchive client'
        },
        deleteClientDialogConfig: {
          description: 'Delete client',
          controller: 'ClientOperationsDialogController as vm',
          templateUrl: 'app/clients/dialogs/client-operations-dialog/delete-client-dialog.tmpl.html',
          locals: {},
          ariaLabel: 'Delete client'
        },
        redactClientDialogConfig: {
          description: 'Redact all crm',
          controller: 'ClientOperationsDialogController as vm',
          templateUrl: 'app/clients/dialogs/client-operations-dialog/redact-client-dialog.tmpl.html',
          locals: {},
          ariaLabel: 'Redact all crm',
          allowMultiple: true
        }
      };
    }

    function updateFilterSelectedValue() {
      const currentIndex = factoryData.filterOptions.filters.indexOf(this);
      let currentFilter = factoryData.filterOptions.filters[currentIndex];

      let selectedFilterCount = 0;
      for (let index = 0; index < factoryData.filterOptions.filters.length; index++) {
        if (index === currentIndex) continue;
        const filter = factoryData.filterOptions.filters[index];
        if (filter.selected) selectedFilterCount++;
      }

      if (currentFilter.selected && selectedFilterCount > 0){
        currentFilter.selected = false;
      } else if (!currentFilter.selected){
        currentFilter.selected = true;
      }

      localStorage.set(currentFilter.storageKey, currentFilter.selected);
    }

    function buildDialogDataForArchiveOperation(clientDoc){
      return{
        databasename: clientDoc.databasename,
        task: {
          mission: {
            type: 'archiveClient',
            activationRules: {
              remoteNodesShouldWaitForServerCompletion: true,
              remoteNodesShouldWaitForSyncCompletion: false
            }
          },
          cards: []
        },
        steps: [
          { 
            step: 1,
            label: 'Introduction',
            busy: false,
            completed: false,
            optional: false,
            editable: true,
            data: {}
          },
          {
            step: 2,
            label: 'Confirmation',
            busy: false,
            completed: false,
            optional: false,
            editable: true,
            data: {
              confirmationText: clientDoc.databasename,
              confirmationFieldValue: ''
            }
          },
          {
            step: 3,
            label: 'Summary',
            busy: false,
            completed: false,
            optional: false,
            editable: true,
            data: {
              zubotProgress: {
                progress: 0,
                currentStep: 0,
                totalSteps: 0,
                caption: 'Pending',
                operation: 'archiveClient'
              }
            }
          }
        ]
      };
    }

    function buildDialogDataForRedactOperation(clientDoc){
      return{
        databasename: clientDoc.databasename,
        task: {
          mission: {
            type: 'compliance',
            subType: 'redact',
            activationRules: {
              remoteNodesShouldWaitForServerCompletion: true,
              remoteNodesShouldWaitForSyncCompletion: false
            }
          },
          cards: []
        },
        steps: [
          { 
            step: 1,
            label: 'Introduction',
            busy: false,
            completed: false,
            optional: false,
            editable: true,
            data: {}
          },
          {
            step: 2,
            label: 'Configuration',
            busy: false,
            completed: false,
            optional: false,
            editable: true,
            data: {}
          },
          {
            step: 3,
            label: 'Confirmation',
            busy: false,
            completed: false,
            optional: false,
            editable: true,
            data: {
              confirmationText: clientDoc.databasename,
              confirmationFieldValue: ''
            }
          },
          {
            step: 4,
            label: 'Summary',
            busy: false,
            completed: false,
            optional: false,
            editable: true,
            data: {
              zubotProgress: {
                progress: 0,
                currentStep: 0,
                totalSteps: 0,
                caption: 'Pending',
                operation: 'redactt'
              }
            }
          }
        ]
      };
    }

    function buildDialogDataForUnarchiveOperation(clientDoc){
      return{
        databasename: clientDoc.databasename,
        task: {
          mission: {
            type: 'unarchiveClient',
            activationRules: {
              remoteNodesShouldWaitForServerCompletion: true,
              remoteNodesShouldWaitForSyncCompletion: false
            }
          },
          cards: [
            {
              type: 'options',
              unarchiveUsers: false
            }
          ]
        },
        steps: [
          { 
            step: 1,
            label: 'Configure Unarchive',
            busy: false,
            completed: false,
            optional: false,
            editable: true,
            data: {
              options: [
                {
                  name: 'Unarchive users',
                  description: 'Unarchive all users that are archived within the account',
                  subOptions: []
                }
              ]
            }
          },
          {
            step: 2,
            label: 'Confirmation',
            busy: false,
            completed: false,
            optional: false,
            editable: true,
            data: {
              confirmationText: clientDoc.databasename,
              confirmationFieldValue: ''
            }
          },
          {
            step: 3,
            label: 'Summary',
            busy: false,
            completed: false,
            optional: false,
            editable: true,
            data: {
              zubotProgress: {
                progress: 0,
                currentStep: 0,
                totalSteps: 0,
                caption: 'Pending',
                operation: 'archiveClient'
              }
            }
          }
        ]
      };
    }

    function buildDialogDataForDeleteOperation(clientDoc){
      return{
        databasename: clientDoc.databasename,
        task: {
          mission: {
            type: 'deleteClient',
            activationRules: {
              remoteNodesShouldWaitForServerCompletion: true,
              remoteNodesShouldWaitForSyncCompletion: false
            }
          },
          cards: []
        },
        steps: [
          { 
            step: 1,
            label: 'Introduction',
            busy: false,
            completed: false,
            optional: false,
            editable: true,
            data: {
              options: []
            }
          },
          {
            step: 2,
            label: 'Confirmation',
            busy: false,
            completed: false,
            optional: false,
            editable: true,
            data: {
              confirmationText: clientDoc.databasename,
              confirmationFieldValue: ''
            }
          },
          {
            step: 3,
            label: 'Summary',
            busy: false,
            completed: false,
            optional: false,
            editable: true,
            data: {
              zubotProgress: {
                progress: 0,
                currentStep: 0,
                totalSteps: 0,
                caption: 'Pending',
                operation: 'archiveClient'
              }
            }
          }
        ]
      };
    }

    function buildColumnsData() {
      var showArchivedClientsColumn = localStorage.get('showClientArchived') || false;

      return {
        primaryIdentifier: {
          object: 'client',
          field: '_id'
        },
        items: [{
          object: 'client',
          databasefieldname: 'zuantaccountmanager',
          label: 'ZAM',
          type: 'ZAM',
          showCol: true,
          editable: false,
          downloadCol: true,
          sortOn: 'rawValue',
          cellDefaultValue: '',
          cellFilter: 'gridButton'
        }, {
          object: 'client',
          databasefieldname: 'zuantcustomersuccessmanager',
          label: 'CSM',
          type: 'CSM',
          showCol: true,
          editable: false,
          downloadCol: true,
          sortOn: 'rawValue',
          cellDefaultValue: '',
          cellFilter: 'gridButton'
        }, {
          object: 'client',
          databasefieldname: 'accountStatus',
          label: 'Status',
          type: 'Textfield',
          downloadCol: true,
          showCol: false,
          editable: false,
          sortOn: 'rawValue'
        }, {
          object: 'client',
          databasefieldname: 'accountStatus',
          label: 'Status',
          cellFilter: 'gridButton',
          type: 'AccountStatus',
          downloadCol: false,
          showCol: true,
          editable: false,
          sortOn: 'rawValue'
        },{
          object: 'client',
          databasefieldname: 'pricingPlan',
          label: 'Price Plan',
          type: 'Textfield',
          downloadCol: true,
          showCol: false,
          editable: false,
          sortOn: 'rawValue'
        }, {
          object: 'client',
          databasefieldname: 'activeusers',
          label: 'Users',
          downloadCol: true,
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: 0
        }, {
          object: 'client',
          databasefieldname: 'clientArchived',
          label: 'Archived',
          type: 'Textfield',
          downloadCol: true,
          showCol: false,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: false
        }, {
          object: 'client',
          databasefieldname: 'clientArchived',
          label: 'Archived',
          cellFilter: 'gridButton',
          type: 'Archived',
          downloadCol: false,
          showCol: showArchivedClientsColumn,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: false
        }, {
          object: 'client',
          databasefieldname: 'archivedusers',
          label: 'Archived Users',
          downloadCol: true,
          showCol: false,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: 0
        }, {
          object: 'client',
          databasefieldname: 'companyname',
          label: 'Company name',
          type: 'Textfield',
          downloadCol: true,
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: ''
        }, {
          object: 'client',
          databasefieldname: 'databasename',
          label: 'db name',
          type: 'Textfield',
          downloadCol: true,
          showCol: true,
          editable: false,
          sortOn: 'rawValue'
        }, {
          object: 'client',
          databasefieldname: 'notes',
          label: 'Notes',
          type: 'Textfield',
          downloadCol: false,
          showCol: true,
          editable: false,
          sortOn: 'rawValue'
        }]
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpClientsWidgetContainer', {
      templateUrl: 'app/clients/main/widget-container/clients-widget-container.tmpl.html',
      controller: 'ClientsWidgetContainerCtrl',
      bindings: {}
    })
    .controller('ClientsWidgetContainerCtrl', controller);

  controller.$inject = ['SessionService', '$state', 'MessageService', 'ClientsDataFactory', 'AccountExportsFactory'];
  /* ng-inject */
  function controller(SessionService, $state, MessageService, ClientsDataFactory, AccountExportsFactory) {

    var vm = this;
    vm.counter = 0;
    vm.activeAccountsInfo = {
      count: 0,
      labels: ['ACCOUNTS ACTIVE TODAY', 'ACCOUNTS ACTIVE ' + moment().format('MMM').toUpperCase(), 'ACCOUNTS ACTIVE THIS YEAR'],
      groupSize: ['day', 'month', 'year']
    };

    vm.$onInit = function () {
      vm.data = ClientsDataFactory.getData();
      vm.activeUserLabel = vm.activeAccountsInfo.labels[1];
      vm.groupSize = vm.activeAccountsInfo.groupSize[1];
      vm.runActiveAccountsCount();
    };

    vm.toggleReportSize = function () {
      var groupSizeIx = vm.activeAccountsInfo.groupSize.indexOf(vm.groupSize);
      if (groupSizeIx == vm.activeAccountsInfo.groupSize.length - 1) groupSizeIx = -1;
      var labelIx = vm.activeAccountsInfo.labels.indexOf(vm.activeUserLabel);
      if (labelIx == vm.activeAccountsInfo.labels.length - 1) labelIx = -1;
      vm.groupSize = vm.activeAccountsInfo.groupSize[groupSizeIx + 1];
      vm.activeUserLabel = vm.activeAccountsInfo.labels[labelIx + 1];

      vm.runActiveAccountsCount();
    };

    vm.runActiveAccountsCount = function () {

      AccountExportsFactory.aggregateActiveAccounts({ groupSize: vm.groupSize })
        .then(res => {
          vm.activeAccountsInfo.count = res.length;
        });
    };

    vm.manageClient = function manageClient() {
      var clientId = SessionService.getUserData().clientId;
      $state.go('app.tabbed_app_framework.client_detail.account_settings', { _id: clientId });
    };

    vm.downloadUserCounts = function () {
      return AccountExportsFactory.downloadAccountExport({ groupSize: vm.groupSize });
    };

    vm.downloadUsers = function () {
      return AccountExportsFactory.downloadUsers({ groupSize: vm.groupSize });
    };

    vm.viewUsageCharts = function (ev) {
      var config = {
        controller: 'AdminChartsDashboardCtrl as vm',
        templateUrl: 'app/clients/dialogs/admin-charts/dialog.tmpl.html',
        useFullScreen: true,
        locals: {}
      };
      MessageService.showDialog(ev, config)
        .then(function (response) {
          MessageService.pushDevLog(response);
        })
        .catch(function (err) {
          MessageService.pushDevLog(err);
        });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpAddClientFab', {
      templateUrl: 'app/clients/main/fab/fab.tmpl.html',
      bindings: {
        metadata: '<'
      }
    });

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpClientListPage', {
      controller: 'zpClientListPageCtrl',
      templateUrl: 'app/clients/main/client-list-page-component/zp-client-list-page.tmpl.html',
      bindings: {
        metadata: '<',
        model: '<'
      }
    })
    .controller('zpClientListPageCtrl', Controller);

  Controller.$inject = ['PaginationManager', 'SearchValFactory'];
  /* ng-inject */
  function Controller(PaginationManager, SearchValFactory) {
    var vm = this;

    vm.$onInit = function () {
      PaginationManager.setQuery(vm.metadata.query, vm.metadata.id);
      vm.search = SearchValFactory.get(vm.metadata.id);
    };
  }

}());

/**
   * Created by davidbeazer on 21/11/2016.
   */
(function () {
  'use strict';
  angular
    .module('clients')
    .factory('CurrentClientEmailTemplateFactory', CurrentClientEmailTemplateFactory);

  CurrentClientEmailTemplateFactory.$inject = ['ClientEmailTemplatesAPI', 'ClientEmailTemplatesFactory', 'ZPModel', 'MessageService', 'ChangeDelta'];
  /* ng-inject */
  function CurrentClientEmailTemplateFactory(ClientEmailTemplatesAPI, ClientEmailTemplatesFactory, ZPModel, MessageService, ChangeDelta) {

    var storedModel;
    var currentTemplate = {};

    /* this factory inherits from ZPModel */
    var services = Object.create(ZPModel);

    services.getTemplateById = getTemplateById;
    services.getCurrentTemplateCache = getData;
    services.deleteTemplate = deleteTemplate;
    services.updateData = updateData;
    services.sendTestEmail = sendTestEmail;
    services.isStale = isStale;

    return services;

    //////////////////////////////

    function getTemplateById(_id) {
      storedModel = {};
      currentTemplate = {};
      var self = this;
      return ClientEmailTemplatesAPI.getTemplateById(_id)
        .then(function (response) {
          currentTemplate = response.data.data;
          storedModel = self.cleanObject(angular.copy(currentTemplate));
          ClientEmailTemplatesFactory.invalidateCache();
          return currentTemplate;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function getData() {
      return currentTemplate;
    }

    function deleteTemplate(id) {
      return ClientEmailTemplatesFactory.deleteTemplate(id)
        .then(function () {
          ChangeDelta.clear();
          MessageService.showMessage('Template deleted');
          return;
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    }

    function updateData() {
      var self = this;
      var saveObj = angular.copy(currentTemplate);
      saveObj.emailtemplatetext = saveObj.emailtemplatetext.replace(/(\r\n|\n|\r|\t)/gm, '').replace('<html style="overflow-y: hidden;">', '<html>');
      return ClientEmailTemplatesFactory.updateTemplate(saveObj)
        .then(function (response) {
          storedModel = self.cleanObject(angular.copy(currentTemplate));
          if (response.data.data._id) {
            return response.data.data._id;
          }
          MessageService.showMessage('Changes saved');
          ChangeDelta.clear();
          return true;
        })
        .catch(function (err) {
          MessageService.showMessage('Error: ' + err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    }

    
    function isStale(newModel) {
      /* method inherited from ZPModel */
      return !this.equalObjects(storedModel, newModel);
    }

    function sendTestEmail(emailTemplate) {
      return ClientEmailTemplatesAPI.sendTemplateTestEmail(emailTemplate)
        .then(function (response) {
          return response;
        })
        .catch(function (err) {
          throw (err);
        });
    }

  }
})();

/**
 * Created by davidbeazer on 10/10/2016.
 */
(function () {
  'use strict';

  angular
    .module('clients')
    .factory('ClientEmailTemplatesMainMetadata', ClientEmailTemplatesMainMetadata);

  ClientEmailTemplatesMainMetadata.$inject = ['localStorageService'];

  function ClientEmailTemplatesMainMetadata(localStorage) {
    const factoryData = {
      id: 'client_email_templates',
      title: {
        label: 'Email templates',
        filterLabel: 'Search templates'
      },
      columnsData: buildColumnsData(),
      query: {
        order: {
          id: 'emailtemplate._lastmodifiedonservertime',
          expression: 'emailtemplate._lastmodifiedonservertime.raw'
        },
        limit: localStorage.get('client_email_templates') || 20,
        page: 1
      },
      paginationOptions: {
        boundaryLinks: true,
        limitSelect: true,
        pageSelect: true,
        pagination: true,
        limitOptions: [5, 10, 20, 50, 75, 100],
        limit: localStorage.get('client_email_templates') || 20,
        page: 1
      },
      gridOptions: {
        rowSelection: false,
        multiSelect: false,
        sortable: true,
        interactive: false
      },
      fabDialogConfig: {
        description: 'New Email Template',
        controller: 'AddClientEmailTemplateDialogController as vm',
        templateUrl: 'app/clients/email-templates/main/dialog/add-client-email-template-dialog.tmpl.html',
        locals: {},
        ariaLabel: 'Create new email template'
      }
    };

    return {
      getData: getData
    };

    function getData() {
      return factoryData;
    }

    // PRIVATE

    function buildColumnsData() {
      return {
        primaryIdentifier: {
          object: 'emailtemplate',
          field: '_id'
        },
        items: [{
          object: 'emailtemplate',
          databasefieldname: 'type',
          name: 'title',
          label: 'Type',
          type: 'Status',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: '',
          cellFilter: 'gridButton'
        }, {
          object: 'emailtemplate',
          databasefieldname: 'title',
          name: 'title',
          label: 'Title',
          type: 'Textfield',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: ''
        }, {
          object: 'emailtemplate',
          databasefieldname: '_lastmodifiedonservertime',
          name: 'Modified date',
          label: 'Last modified',
          type: 'Textfield',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: '',
          cellFilter: 'zpDateMedium'
        }]
      };
    }
  }
})();

angular
  .module('clients')
  .controller('RequestPasscodeController', controller);

controller.$inject = ['MessageService', 'CurrentClientModelFactory', 'UserService'];
/* ng-inject */
function controller(MessageService, CurrentClientModel, UserService) {

  var vm = this;
  vm.showActions = true;
  vm.toolbarTitle = 'GDPR Passcode';
  vm.passcode;
  vm.passcodeValid = false;
  vm.factoryData = CurrentClientModel.factoryData;
  vm.userDoc = UserService.getUserData();

  vm.closeDialog = function () {
    MessageService.closeDialog();
  };

  vm.cancelDialog = function () {
    if (!CurrentClientModel.factoryData.userPermittedToMakeGDPREdits.permitted) {
      MessageService.cancelDialog();
    } else {
      MessageService.closeDialog();
    }
  };

  vm.verifyPasscode = function () {
    vm.disableVerifyBtn = true;
    CurrentClientModel.verifyPasscode(vm.passcode)
      .then(function (res) {
        vm.passcodeValid = res;
        vm.hideVerifyBtn = true;
      })
      .catch(function (err) {
        vm.passcodeValidationError = err;
        vm.disableVerifyBtn = false;
      });
  };

  vm.contactZuantSupport = function () {
    alert('You can contact Zuant Support by clicking the speech bubble icon in the top right of the screen.');
  };

  vm.resetCount = function () {
    CurrentClientModel.resetFailedAttemptsCount();
  };

  vm.resetForm = function () {
    vm.passcode = '';
    vm.focusInput0 = true;
  };

  vm.verifyBtnDisabled = function () {
    if (!vm.passcode) return false;
    return vm.passcode.toString().length < 6;
  };

}

/**
 * Created by davidbeazer on 19/07/2017.
 */
'use strict';

angular
  .module('clients')
  .controller('ManageClientDialogController', ManageClientDialogController);

ManageClientDialogController.$inject = ['locals', 'MessageService', 'ClientsDataFactory', 'ZPPages', '$state', '$window', '$document', 'CurrentClientModelFactory', 'ClientsMainMetadata', 'ClientOperationsDialogMetadataFactory', 'ZuantAccountManagersFactory', 'EnvService', 'MARKETPOINT_CLIENT_ID'];
/* ng-inject */
function ManageClientDialogController(locals, MessageService, ClientsDataFactory, zpPages, $state, $window, $document, CurrentClientModelFactory, ClientsMainMetadata, ClientOperationsDialogMetadataFactory, ZuantAccountManagersFactory, EnvService, MARKETPOINT_CLIENT_ID) {

  var vm = this;

  vm.isDev = EnvService.isDev;
  vm.loading = true;

  vm.$onInit = function () {
    vm.clientDoc = CurrentClientModelFactory.getCurrentClientCache();
    vm.superZams = ZuantAccountManagersFactory.superZams;
    if (CurrentClientModelFactory.factoryData.userPermittedToMakeGDPREdits.permitted && locals.clientId !== CurrentClientModelFactory.factoryData.currentClient._id) {
      CurrentClientModelFactory.endElevatedEditSession();
    }

    return switchAccount(locals.clientId);
  };

  vm.isClientMarketpoint = function () {
    return vm.clientDoc.clientId === MARKETPOINT_CLIENT_ID;
  };


  function switchAccount(clientId){
    return ClientsDataFactory.switchAccount({ clientId })
      .then(function (clientDoc) {
        MessageService.showMessage('Now managing: ' + clientDoc.databasename);
        vm.clientDoc = clientDoc;
        vm.items = zpPages.getManageAccountDialogItems();
        vm.loading = false;
      })
      .catch(function (err) {
        MessageService.writeLog({
          level: 'error',
          msg: err
        });
        MessageService.showMessage(err.message);
      });
  }

  // modal dismiss functions
  vm.hide = function (answer) {
    MessageService.closeDialog(answer);
  };

  vm.cancelDialog = function() {
    MessageService.cancelDialog();
  };

  vm.go = function (item) {
    $state.go(item.sref, item.srefObj);
    vm.hide();
  };

  vm.redirect = function redirect(href) {
    $window.location = href;
  };

  vm.deleteClient = function (event) {
    const deleteOperation = ClientsMainMetadata.buildDialogDataForDeleteOperation(vm.clientDoc);
    ClientOperationsDialogMetadataFactory.buildFactoryForOperation(deleteOperation);

    MessageService.showDialog(event, {
      controller: locals.metadata.deleteClientDialogConfig.controller,
      templateUrl: locals.metadata.deleteClientDialogConfig.templateUrl,
      parent: angular.element($document.body),
      locals: {
        clientDoc: vm.clientDoc
      },
      clickOutsideToClose: false
    })
      .then(
        function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'Delete account dialog closed'
          });
        })
      .catch(function (){
        // user cancelled out of mamage client dialog
      });
  };

  vm.archiveClient = function (event) {
    const archiveOperation = ClientsMainMetadata.buildDialogDataForArchiveOperation(vm.clientDoc);
    ClientOperationsDialogMetadataFactory.buildFactoryForOperation(archiveOperation);

    MessageService.showDialog(event, {
      controller: locals.metadata.archiveClientDialogConfig.controller,
      templateUrl: locals.metadata.archiveClientDialogConfig.templateUrl,
      parent: angular.element($document.body),
      locals: {
        clientDoc: vm.clientDoc
      },
      clickOutsideToClose: false
    })
      .then(
        function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'Archive account dialog closed'
          });
        })
      .catch(function (){
        // user cancelled out of mamage client dialog
      });
  };

  vm.unarchiveClient = function (event) {
    const unArchiveOperation = ClientsMainMetadata.buildDialogDataForUnarchiveOperation(vm.clientDoc);
    ClientOperationsDialogMetadataFactory.buildFactoryForOperation(unArchiveOperation);
  
    MessageService.showDialog(event, {
      controller: locals.metadata.unarchiveClientDialogConfig.controller,
      templateUrl: locals.metadata.unarchiveClientDialogConfig.templateUrl,
      parent: angular.element($document.body),
      locals: {
        clientDoc: vm.clientDoc
      },
      clickOutsideToClose: false
    })
      .then(
        function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'Unarchive account dialog closed'
          });
        })
      .catch(function (){
        // user cancelled out of mamage client dialog
      });
  };


  vm.redactClient = function (event) {
    const redactCRMOperation = ClientsMainMetadata.buildDialogDataForRedactOperation(vm.clientDoc);
    ClientOperationsDialogMetadataFactory.buildFactoryForOperation(redactCRMOperation);
  
    MessageService.showDialog(event, {
      controller: locals.metadata.redactClientDialogConfig.controller,
      templateUrl: locals.metadata.redactClientDialogConfig.templateUrl,
      parent: angular.element($document.body),
      locals: {
        clientDoc: vm.clientDoc
      },
      clickOutsideToClose: false
    })
      .then(
        function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'Redact account dialog closed'
          });
        })
      .catch(function (){
        // user cancelled out of mamage client dialog
      });
  };

}

(function () {
  'use strict';

  angular
    .module('clients')
    .controller('GDPREnabledInfoCtrl', ctrl);

  ctrl.$inject = ['locals', 'MessageService', '$state'];
  /* ng-inject */
  function ctrl(locals, MessageService, $state) {

    var vm = this;

    vm.navigate = function () {
      MessageService.closeDialog();
      $state.go('app.tabbed_app_framework.client_detail.consent_management', {
        _id: locals._id
      });
    };

    vm.cancelDialog = function () {
      MessageService.cancelDialog();
    };
  }

}());

angular
  .module('clients')
  .controller('AddConsentTokenDialogCtrl', ctrl);

ctrl.$inject = ['locals', 'ConsentViewModelFactory'];
/* ng-inject */
function ctrl(locals, ConsentViewModelFactory) {

  var vm = this;

  vm.toolbartitle = locals.toolbartitle;
  vm.readOnly = locals.readOnly;
  vm.validationFactoryData = ConsentViewModelFactory.validationFactoryData;
  vm.dataModelFactoryData = ConsentViewModelFactory.dataModelFactoryData;

  vm.saveAndClose = function () {
    ConsentViewModelFactory.saveConsentModel()
      .then(function () {})
      .catch(function (err) {
        vm.errorMessages = err.issues;
      });
  };

  vm.cancelDialog = function () {
    ConsentViewModelFactory.cancelDialog();
  };
}

/**
 * Created by Tom Stone on 11/09/2023.
 */
'use strict';

angular
  .module('clients')
  .controller('ClientOperationsDialogController', ClientOperationsDialogController);

ClientOperationsDialogController.$inject = ['$scope', 'locals', 'workflowFactory', 'ClientOperationsDialogMetadataFactory', 'ClientsDataFactory', 'MessageService', 'DATA_BACKEND_WSURL'];
/* ng-inject */
function ClientOperationsDialogController($scope, locals, workflowFactory, ClientOperationsDialogMetadataFactory, ClientsDataFactory, MessageService, DATA_BACKEND_WSURL) {

  var vm = this;
  vm.metaData = ClientOperationsDialogMetadataFactory.factoryData;
  vm.workflowFactory = workflowFactory;
  
  vm.$onInit = function (){
    if (locals.clientDoc && locals.clientDoc.clientOperationStatus) {
      const currentOp = locals.clientDoc.clientOperationStatus;
      switch (currentOp.operation){
        case 'archiveClient':
        case 'unarchiveClient':
        case 'redactAllCRM':
        case 'deleteClient':{
          if (
            !(vm.metaData.task.mission.type === 'archiveClient' && currentOp.operation === 'archiveClient') &&
            !(vm.metaData.task.mission.type === 'unarchiveClient' && currentOp.operation === 'unarchiveClient') &&
            !(vm.metaData.task.mission.type === 'deleteClient' && currentOp.operation === 'deleteClient') &&
            !(vm.metaData.task.mission.subType === 'redact' && currentOp.operation === 'redactAllCRM')
          ){
            break;
          }

          for (let index = 0; index < vm.metaData.stepData.length -1; index++) {
            const step = vm.metaData.stepData[index];
            step.editable = false;
            step.completed = true;
          }

          vm.metaData.selectedStep = vm.metaData.maxStep;
          vm.metaData.stepProgress = vm.metaData.maxStep;
          vm.metaData.stepData[vm.metaData.stepData.length -1].data.zubotProgress = currentOp;
          vm.metaData.task.zubot = currentOp.zubot.name;
          vm.metaData.task.outfit = currentOp.zubot.outfit;

        }
      }
    }

    $scope.$on('zp.websocket.messageRecieved', function(event, props){
      if (props.connection !== DATA_BACKEND_WSURL) return;
      const messageObj = JSON.parse(props.message);
      switch (messageObj.type){
        case 'activateZubot':{
          const zubot = messageObj.data.zubot;
          if (
            !(vm.metaData.task.mission.type === 'archiveClient' && zubot.mission.type === 'archiveClient') &&
              !(vm.metaData.task.mission.type === 'unarchiveClient' && zubot.mission.type === 'unarchiveClient') &&
              !(vm.metaData.task.mission.type === 'deleteClient' && zubot.mission.type=== 'deleteClient') &&
              !(vm.metaData.task.mission.subType === 'redact' && zubot.mission.type === 'redactAllCRM')
          ){
            break;
          }

          vm.metaData.stepData[vm.metaData.stepData.length -1].data.zubotProgress = messageObj.data.delta.clientOperationStatus;
          vm.metaData.task.zubot = zubot.name;
          vm.metaData.task.outfit = zubot.outfit;

          $scope.$digest();
          break;
        }
        case 'archiveClient':
        case 'unarchiveClient':
        case 'redactAllCRM':
        case 'deleteClient':{
          if (
            !(vm.metaData.task.mission.type === 'archiveClient' && messageObj.type === 'archiveClient') &&
              !(vm.metaData.task.mission.type === 'unarchiveClient' && messageObj.type === 'unarchiveClient') &&
              !(vm.metaData.task.mission.type === 'deleteClient' && messageObj.type === 'deleteClient') &&
              !(vm.metaData.task.mission.subType === 'redact' && messageObj.type === 'redactAllCRM')
          ){
            break;
          }
          
          vm.metaData.stepData[vm.metaData.stepData.length -1].data.zubotProgress = messageObj.data;
          vm.metaData.task.zubot = messageObj.data.zubot.name;
          vm.metaData.task.outfit = messageObj.data.zubot.outfit;

          $scope.$digest();

        }
      }
    });

  };


  vm.cancelDialog = function() {
    MessageService.cancelDialog();
  };

  vm.refreshZubot = function (){
    ClientOperationsDialogMetadataFactory.refreshZubot();
  };


  vm.enableNextStep = function nextStep() {
    //do not exceed into max step
    if (vm.metaData.selectedStep >= vm.metaData.maxStep) {
      return;
    }

    if (vm.metaData.selectedStep === vm.metaData.stepProgress - 1) {
      vm.metaData.stepProgress = vm.metaData.stepProgress + 1;
    }
    vm.metaData.selectedStep = vm.metaData.selectedStep + 1;
  };

  vm.moveToPreviousStep = function moveToPreviousStep() {
    if (vm.metaData.selectedStep > 0) {
      vm.metaData.selectedStep = vm.metaData.selectedStep - 1;
    }
  };

  vm.submitCurrentStep = function submitCurrentStep(stepData) {

    stepData.completed = true;

    const missionType = vm.metaData.task.mission.type;
    const missionSubType = vm.metaData.task.mission.subType;
    //if current step is not the second from last step
    if (vm.metaData.selectedStep !== ((vm.metaData.stepData.length-1) -1)){
      vm.enableNextStep();

      if (missionType === 'compliance' && missionSubType === 'redact' && vm.workflowFactory.selectedStep.valid && vm.workflowFactory.selectedCard){
        vm.metaData.task.steps[0].cards = [vm.workflowFactory.selectedCard];
      }
      return;
    }

    vm.metaData.stepData[vm.metaData.selectedStep].busy = true;

    for (let index = 0; index < vm.metaData.stepData.length -1; index++) {
      const step = vm.metaData.stepData[index];
      step.editable = false;

      if (!step.data || !step.data.options) continue;

      for (const option of step.data.options){

        switch (missionType){
          case 'unarchiveClient':{
            if (option.name === 'Unarchive users'){
              vm.metaData.task.steps[0].cards[0].unarchiveUsers = option.value;
            }
            break;
          }
          default:
            break;
        }
      }

    }

    switch (missionType){
      case 'archiveClient':
        ClientsDataFactory.archiveClient(vm.metaData.task)
          .then(function (){
            vm.metaData.stepData[vm.metaData.selectedStep].busy = false;
            vm.enableNextStep();
          })
          .catch(function (){

          });
        break;
      case 'unarchiveClient':
        ClientsDataFactory.unarchiveClient(vm.metaData.task)
          .then(function (){
            vm.metaData.stepData[vm.metaData.selectedStep].busy = false;
            vm.enableNextStep();
          })
          .catch(function (){
            
          });
        break;
      case 'compliance':{
        if (missionSubType !== 'redact') break;
        ClientsDataFactory.redactAllCRM(vm.metaData.task)
          .then(function (){
            vm.metaData.stepData[vm.metaData.selectedStep].busy = false;
            vm.enableNextStep();
          })
          .catch(function (){
            
          });
        break;
      }
      case 'deleteClient':
        ClientsDataFactory.deleteClient(vm.metaData.task)
          .then(function (){
            vm.metaData.stepData[vm.metaData.selectedStep].busy = false;
            vm.enableNextStep();
          })
          .catch(function (){
            
          });
        break;
    }
  };
}
(function () {
  'use strict';
  
  angular
    .module('clients')
    .factory('ClientOperationsDialogMetadataFactory', factory);
  
  factory.$inject = ['generateZubot'];
  /* ng-inject */
  function factory(generateZubot) {
  
    var vm = this;  
  
    vm.buildFactory = function() {
      return {
        databasename: '',
        selectedStep: 0,
        stepProgress: 1,
        maxStep: 0,
        stepData: [],
        task: {
          zubot: '',
          mission: {
            type: '',
            activationRules: {}
          },
          steps: [{
            cards: []
          }]
        }
      };
    };

    vm.factoryData = vm.buildFactory();

    vm.resetFactory = function() {
      vm.factoryData = vm.buildFactory();
    };

    vm.buildFactoryForOperation = function(operation) {
      //clear anything currently in factory data
      vm.resetFactory();

      //generates a zubot for factorydata
      vm.refreshZubot();

      vm.setDatabaseName(operation.databasename);
      vm.setMaxSteps(operation.steps.length);

      vm.setMission(operation.task.mission);
      for (const card of operation.task.cards){
        vm.addCardToTask(card);
      }

      for (const [stepIndex, step] of operation.steps.entries()){
        vm.addStep(stepIndex, step);

        if (step.data.options && step.data.options.length > 0){
          for (const [optionIndex, option] of step.data.options.entries()){
            vm.addStepOption(stepIndex, option);
            if (option.subOptions && option.subOptions.length > 0){
              for (const subOption of option.subOptions){
                vm.addStepSubOptions(stepIndex, optionIndex, subOption);
              }
            }
          }
        }
      }
    };

    vm.setDatabaseName = function(databasename) {
      vm.factoryData.databasename = databasename;
    };

    vm.setMission = function(mission) {
      vm.factoryData.task.mission = mission;
    };

    vm.addCardToTask = function(card) {
      vm.factoryData.task.steps[0].cards.push(card);
    };

    vm.setSelectedStep = function(stepIndex) {
      vm.factoryData.setSelectedStep = stepIndex;
    };

    vm.setMaxSteps = function(maxStepNum) {
      vm.factoryData.maxStep = maxStepNum;
    };

    vm.addStep = function(stepIndex, stepToAdd) {
      const step = {
        step: stepIndex,
        label: stepToAdd.label,
        busy: stepToAdd.busy,
        editable: stepToAdd.editable,
        optional: stepToAdd.optional,
        completed: stepToAdd.completed,
        data: Object.assign({}, stepToAdd.data, { options: [] })
      };

      vm.factoryData.stepData.push(step);
    };

    vm.addStepOption = function(stepIndex, optionDefintion) {
      const step = vm.factoryData.stepData[stepIndex];

      const option = {
        name: optionDefintion.name,
        description: optionDefintion.description,
        category: optionDefintion.category,
        value: false,
        disabled: false,
        toggleCount: 0,
        subOptions: []
      };

      if (optionDefintion.category){
        option.category = optionDefintion.category;
      }

      step.data.options.push(option);
    };

    vm.addStepSubOptions = function(stepIndex, parentStepOptionsIndex, optionDefintion) {
      const step = vm.factoryData.stepData[stepIndex];
      const parentOption = step.data.options[parentStepOptionsIndex];

      parentOption.subOptions.push({
        name: optionDefintion.name,
        category: optionDefintion.category,
        value: false,
        disabled: false,
        toggleCount: 0,
        properties: optionDefintion.properties,
        subOptions: []
      });
    };

    vm.refreshZubot = function() {
      generateZubot(vm.factoryData.task);
    };

    return vm;

  }

})();
  
(function () {
  'use strict';

  angular
    .module('clients')
    .controller('AdminChartsDashboardCtrl', ControllerCtrl);

  ControllerCtrl.$inject = ['MessageService', 'AccountExportsFactory'];
  /** @ngInject */
  function ControllerCtrl(MessageService, AccountExportsFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.loading = true;
      vm.showQueryBuilder = true;
      vm.groupSize = 'day';
      vm.groupSizeOptions = ['day', 'month', 'year'];

      vm.run();
    };

    vm.cancelDialog = function () {
      MessageService.closeDialog();
    };

    vm.export = function () {
      vm.loading = true;
      AccountExportsFactory.downloadAccountExport({ groupSize: vm.groupSize })
        .then(csv => {
          vm.csv = csv;
          vm.loading = false;
        })
        .catch(() => vm.loading = false);
    };

    vm.run = function () {
      vm.loading = true;
      AccountExportsFactory.aggregateActiveUsers({ groupSize: vm.groupSize })
        .then(function (res) {
          // console.log('res: ', res);
          vm.loading = false;
          vm.content = res.data;
        })
        .catch(function (err) {
          // console.error('err:');
          vm.loading = false;
          vm.content = err;
        });
    };

    vm.deleteAccountActivityLogs = function (){
      AccountExportsFactory.deleteAccountActivityLogs();
    };
  }
}());
/**
 * Created by davidbeazer on 27/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('clients')
    .controller('AddClientDialogController', AddClientDialogController);

  AddClientDialogController.$inject = ['CreateAccountViewModel', 'CreateAccountMetadata'];
  /* ng-inject */
  function AddClientDialogController(CreateAccountViewModel, CreateAccountMetadata) {

    var vm = this;

    vm.$onInit = function() {
      vm.clientFormObj = CreateAccountMetadata.clientFormObj();
      vm.uxhelpers = CreateAccountMetadata.uxhelpers();
      vm.accountTemplates = CreateAccountMetadata.accountTemplates();
      vm.passwordPolicies = CreateAccountMetadata.passwordPolicies;
      vm.users = CreateAccountMetadata.users();
      vm.accountMeta = CreateAccountMetadata.accountMeta();
      vm.newFormDoc = CreateAccountMetadata.newFormDoc();
      vm.formTemplatesConfig = CreateAccountMetadata.formTemplatesConfig();

      CreateAccountViewModel.init(vm);
    };

    vm.updateTemplateSearch = function ($event){
      $event.stopPropagation();
    };

    // modal dismiss functions
    vm.hide = function (answer) {
      CreateAccountViewModel.hideDialog(answer);
    };

    vm.cancelDialog = function () {
      CreateAccountViewModel.cancelDialog();
    };

    vm.accountTemplateSelected = function () {
      CreateAccountViewModel.accountTemplateSelected(vm.accountMeta.template);
    };

    vm.iconCheck = function (panel) {
      return CreateAccountViewModel.iconCheck(panel);
    };

    vm.showPanel = function (panel) {
      CreateAccountViewModel.showPanel(panel);
    };

    vm.addUser = function () {
      CreateAccountViewModel.addUser();
    };

    vm.removeUser = function (index) {
      CreateAccountViewModel.removeUser(index);
    };

    vm.setFormTemplateToUse = function (item) {
      CreateAccountViewModel.setFormTemplateToUse(item);
    };

    vm.saveNewAccount = function (action) {
      vm.saveInProgress = true;
      CreateAccountViewModel.saveNewAccount(action)
        .then(function () {
          vm.saveInProgress = false;
        })
        .catch(function () {
          vm.saveInProgress = false;
        });
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpSaveClientDocFab', {
      templateUrl: 'app/clients/detail/fab-save/fab.tmpl.html',
      controller: 'zpSaveClientDocFabCtrl'
    })
    .controller('zpSaveClientDocFabCtrl', ctrl);

  ctrl.$inject = ['$scope', 'ChangeDelta', 'MasterPermissionsDefinitionFactory'];
  /* nj-inject */
  function ctrl($scope, ChangeDelta, MasterPermissionsDefinitionFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.changeDelta = ChangeDelta;
      vm.permissions = MasterPermissionsDefinitionFactory;
    };

    vm.save = function (){
      $scope.$emit('zp.message', {
        level: 'broadcast',
        page: 'foo',
        eventName: 'zp.save-client-form-button-clicked'
      });
    };

  }

})();

(function () {
  'use strict';

  /***
   * a component called zpCreateAccountForm already exists in signup. this component will only be used internally by Zuant Admins
   */

  angular
    .module('clients')
    .component('zpCreateAccountFormInternal', {
      templateUrl: 'app/clients/create-account/zp-create-account-form-internal/create-account-form-internal.tmpl.html',
      controller: 'CreateAccountFormCtrl',
      bindings: {
        clientFormObj: '=',
        clientDoc: '<',
        accountMeta: '<'
      }
    })
    .controller('CreateAccountFormCtrl', controller);

  controller.$inject = ['ClientsDataFactory', 'MessageService', 'CurrentClientModelFactory'];
  /* ng-inject */
  function controller(ClientsDataFactory, MessageService, CurrentClientModelFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.timezonesConfig = {
        placeholder: 'Pick a timezone for the account',
        floatingLabel: 'Account timezone',
        required: true,
        name: 'timezone'
      };
      vm.disableDatabaseName = !!vm.clientDoc.companyname;
      vm.updateChangeDelta = CurrentClientModelFactory.updateChangeDelta;
    };

    vm.onCompanyNameKeyUp = function () {
      if (!(vm.disableDatabaseName) && vm.clientDoc.companyname) {
        vm.clientDoc.databasename = vm.clientDoc.companyname.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

        ClientsDataFactory.checkClientDatabasename(vm.clientDoc.databasename)
          .then(function (res) {
            if (res.data.length) {
              $log.info('client document with db name found');
              vm.clientFormObj.databaseName.$setValidity('databaseExists', false);
            } else {
              vm.clientFormObj.databaseName.$setValidity('databaseExists', true);
            }
          })
          .catch(function (err) {
            // MessageService.showMessage(err.data.data.message);
            MessageService.writeLog({
              level: 'error',
              msg: err,
              tags: ['checking new name error']
            });
            $scope.$emit('zp.message', {
              level: 'error',
              message: 'Error checking dbname exists: ' + err
            });
          });
      }
    };

    vm.updateTimezone = function (selected) {
      if (selected.item) {
        if (selected.item !== vm.clientDoc.timezone) {
          vm.clientDoc.timezone = selected.item || '';
          vm.updateChangeDelta('timezone', vm.clientDoc.timezone);
        }
      } else {
        vm.clientDoc.timezone = '';
        vm.updateChangeDelta('timezone', '');
      }
    };

    vm.updatePartnerId = function (selected) {
      if (selected.item) {
        var partnerId = selected.item.id;
        vm.updateChangeDelta('partnerId', partnerId);
        vm.clientDoc.partnerId = partnerId;
      } else {
        vm.clientDoc.partnerId = '';
        vm.updateChangeDelta('partnerId', '');
      }
    };
  }
}());

(function () {
  'use strict';

  /***
   * a component called zpCreateAccountForm already exists in signup. this component will only be used internally by Zuant Admins
   */

  angular
    .module('clients')
    .component('zpCreateAccountFormGeneric', {
      templateUrl: 'app/clients/create-account/zp-create-account-form-generic/create-account-form-generic.tmpl.html',
      controller: 'CreateAccountFormCtrl',
      bindings: {
        clientFormObj: '=',
        clientDoc: '<',
        accountMeta: '<'
      }
    })
    .controller('CreateAccountFormCtrl', controller);

  controller.$inject = ['ClientsDataFactory', 'MessageService', 'CurrentClientModelFactory'];
  /* ng-inject */
  function controller(ClientsDataFactory, MessageService, CurrentClientModelFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.timezonesConfig = {
        placeholder: 'Pick a timezone for the account',
        floatingLabel: 'Account timezone',
        required: true,
        name: 'timezone'
      };
      vm.disableDatabaseName = !!vm.clientDoc.companyname;
      vm.updateChangeDelta = CurrentClientModelFactory.updateChangeDelta;
    };

    vm.onCompanyNameKeyUp = function () {
      if (!(vm.disableDatabaseName) && vm.clientDoc.companyname) {
        vm.clientDoc.databasename = vm.clientDoc.companyname.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

        ClientsDataFactory.checkClientDatabasename(vm.clientDoc.databasename)
          .then(function (res) {
            if (res.data.length) {
              $log.info('client document with db name found');
              vm.clientFormObj.databaseName.$setValidity('databaseExists', false);
            } else {
              vm.clientFormObj.databaseName.$setValidity('databaseExists', true);
            }
          })
          .catch(function (err) {
            // MessageService.showMessage(err.data.data.message);
            MessageService.writeLog({
              level: 'error',
              msg: err,
              tags: ['checking new name error']
            });
            $scope.$emit('zp.message', {
              level: 'error',
              message: 'Error checking dbname exists: ' + err
            });
          });
      }
    };

    vm.updateTimezone = function (selected) {
      if (selected.item) {
        if (selected.item !== vm.clientDoc.timezone) {
          vm.clientDoc.timezone = selected.item || '';
          vm.updateChangeDelta('timezone', vm.clientDoc.timezone);
        }
      } else {
        vm.clientDoc.timezone = '';
        vm.updateChangeDelta('timezone', '');
      }
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpConsentWelcome', {
      bindings: {
        getStarted: '&',
        hasConsentTokens: '<',
        permittedToMakeGdrpEdits: '<'
      },
      templateUrl: 'app/clients/consent/welcome/zp-consent-welcome.tmpl.html',
      controller: 'ConsentWelcomeController'
    })
    .controller('ConsentWelcomeController', controller);

  controller.$inject = [];
  /* ng-inject*/
  function controller() {
    var vm = this;

    vm.callback = function (ev){
      vm.getStarted({ev: ev});
    };
  }
}());

(function() {
  'use strict';

  angular
    .module('clients')
    .component('zpConsentTokensList', {
      bindings: {},
      templateUrl: 'app/clients/consent/tokens-list/zp-consent-tokens-list.tmpl.html',
      controller: 'zpConsentPageCtrl'
    });
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpConsentPage', {
      templateUrl: 'app/clients/consent/main-page/page.tmpl.html',
      controller: 'zpConsentPageCtrl',
      bindings: {}
    })
    .controller('zpConsentPageCtrl', ctrl);

  ctrl.$inject = ['ConsentViewModelFactory', 'MessageService'];
  /* ng-inject */
  function ctrl(ConsentViewModelFactory, MessageService) {

    var vm = this;

    vm.$onInit = function () {
      vm.functions = ConsentViewModelFactory.consentFunctions();
      vm.exampleTokens = ConsentViewModelFactory.defaultConsentModel();
      vm.factoryData = ConsentViewModelFactory.dataModelFactoryData;
      vm.currentClientFactoryData = ConsentViewModelFactory.currentClientFactoryData;
      vm.copyOfNewWidget = angular.copy(vm.factoryData.newConsentToken);
      vm.isDev = ConsentViewModelFactory.isDev;
      vm.showGetStarted = false;
    };

    vm.viewToken = function (widget, ev) {
      const params = {
        widget: widget,
        description: 'View token',
        readOnly: true,
        ev: ev
      };
      ConsentViewModelFactory.loadConsentFormDialog(params);
    };

    vm.tokenAtiveStatusChange = function(widget) {
      return ConsentViewModelFactory.saveConsentModel()
        .catch(function (){
          widget.active = !widget.active;
        });
    };

    vm.toggleReorder = function () {
      ConsentViewModelFactory.toggleReorderTokens()
        .then(function () {});
    };

    vm.resetAccountConsentModel = function (ev) {
      ConsentViewModelFactory.resetAccountConsentModel(ev)
        .then(function () {});
    };

    vm.requestPasscode = function (ev) {
      ConsentViewModelFactory.requestPasscode(ev);
    };

    vm.loadNewTokenDialog = function (ev) {
      const params = {
        widget: vm.exampleTokens[0],
        description: 'Add new consent token',
        readOnly: false,
        ev: ev
      };
      ConsentViewModelFactory.loadConsentFormDialog(params);
      MessageService.pushEventToIntercom('onboarding_consent_begun');
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpReadOnlyConsentModel', {
      templateUrl: 'app/clients/consent/forms/read-only-form.tmpl.html',
      controller: 'ReadOnlyConsentModelCtrl',
      bindings: {}
    })
    .controller('ReadOnlyConsentModelCtrl', ctrl);

  ctrl.$inject = ['ConsentViewModelFactory'];
  /* ng-inject */
  function ctrl(ConsentViewModelFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.factoryData = ConsentViewModelFactory.dataModelFactoryData;
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpConsentTokenForm', {
      templateUrl: 'app/clients/consent/forms/consent-form.tmpl.html',
      controller: 'ConsentTokenFormController',
      bindings: {
        tokenObj: '<',
        readOnly: '<',
        formObj: '='
      }
    })
    .directive('customChip', function () {
      return {
        restrict: 'EA',
        link: function (scope, elem) {
          elem.bind('click', function () {
            applyChipBackgroundColor(scope, elem);
          });

          function applyChipBackgroundColor(scope, elem) {
            const chipTemplateClass = scope.$chip.activeClass;
            elem.removeClass(chipTemplateClass);
            const mdChip = elem.parent().parent();
            mdChip.removeClass('active');
            mdChip.addClass(chipTemplateClass);
          }

          applyChipBackgroundColor(scope, elem);
        }
      };
    })
    .controller('ConsentTokenFormController', ctrl);

  ctrl.$inject = ['ConsentViewModelFactory'];
  /* ng-inject */
  function ctrl(ConsentViewModelFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.zuantFunctions = buildFunctions();
      toggleOnSymbols();
      vm.isDev = ConsentViewModelFactory.isDev;
    };

    function toggleOnSymbols() {
      if (vm.tokenObj.symbols) {
        _.each(vm.tokenObj.symbols, function (symb) {
          const symbolPreset = _.find(vm.zuantFunctions, function (func) {
            return func.name === symb.name;
          });
          symbolPreset.activeClass = symbolPreset ? 'active' : '';
          symbolPreset.active = symbolPreset ? true : false;
        });
      }
    }

    vm.toggleChip = function (chip) {
      if (!vm.readOnly) {
        const matchingChip = _.find(vm.zuantFunctions, function (sym) {
          return sym._id === chip._id;
        });
        matchingChip.active = !matchingChip.active;
        matchingChip.activeClass = matchingChip.active ? 'active' : '';

        vm.tokenObj.symbols = _.filter(vm.zuantFunctions, function (symb) {
          return symb.active;
        });
      }
    };

    function buildFunctions() {
      return ConsentViewModelFactory.consentFunctions().map(function (zFunc) {
        zFunc._lowername = zFunc.name.toLowerCase();
        return zFunc;
      });
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpConsentModelFabButtons', {
      templateUrl: 'app/clients/consent/fabs/fabs.tmpl.html',
      controller: 'zpConsentModelFabsCtrl'
    })
    .controller('zpConsentModelFabsCtrl', ctrl);

  ctrl.$inject = ['ConsentViewModelFactory', 'hotkeys'];
  /* ng-inject */
  function ctrl(ConsentViewModelFactory, hotkeys) {

    var vm = this;

    vm.$onInit = function () {
      vm.currentClientFactoryData = ConsentViewModelFactory.currentClientFactoryData;
      vm.consentDataFactoryData = ConsentViewModelFactory.dataModelFactoryData;
      vm.viewModelFactoryData = ConsentViewModelFactory.factoryData;

      hotkeys.add({
        combo: 'ctrl+n',
        description: 'Issue new consent token',
        callback: function () {
          vm.issueNewConsentToken();
        }
      });
    };

    vm.issueNewConsentToken = function (ev){
      const params = {
        description: 'Add new consent token',
        widget: null,
        readOnly: false,
        ev: ev
      };
      ConsentViewModelFactory.loadConsentFormDialog(params);
    };

    vm.blankSlate = function (){
      return !vm.consentDataFactoryData.accountConsentModel.length && vm.viewModelFactoryData.allowFabToDisplay;
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpAccountComplianceSettings', {
      templateUrl: 'app/clients/compliance/account-settings-widget/widget.tmpl.html',
      controller: 'AccountComplianceSettingsCtrl',
      bindings: {}
    })
    .controller('AccountComplianceSettingsCtrl', ctrl);

  ctrl.$inject = ['CurrentClientModelFactory', 'DATA_API_CONFIG'];
  /* ng-inject */
  function ctrl(CurrentClientModel, DATA_API_CONFIG) {

    var vm = this;

    vm.$onInit = function () {
      vm.factoryData = CurrentClientModel.factoryData;
      vm.defaultDataUrl = DATA_API_CONFIG.url;
    };

    vm.updateChangeDelta = CurrentClientModel.updateChangeDelta;
    vm.updateChangeDeltaNested = CurrentClientModel.updateChangeDeltaNested;

  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpBoltOnsControl', {
      templateUrl: 'app/clients/boltons/zp-boltons-control/zp-boltons-control.tmpl.html',
      controller: 'zpBoltOnsControlCtrl',
      bindings: {
        newClientDoc: '<',
        permissions: '<'
      }
    })
    .controller('zpBoltOnsControlCtrl', ctrl);

  ctrl.$inject = ['BoltOnsMetadataFactory'];
  /* ng-inject */
  function ctrl(BoltOnsMetadataFactory) {

    var vm = this;

    vm.$onInit = function () {
      // get boltons for view from boltOns factory used to be here. seems naff mixing data into the metadata
      vm.availableBoltOns = BoltOnsMetadataFactory.arrayOfBoltOns;
    };

    vm.toggleBoltOn = function (ev, boltOnClicked) {

      vm.permissions.boltOns[boltOnClicked.property] = {
        enabled: !vm.permissions.boltOns[boltOnClicked.property].enabled
      };
      return;

    };

  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpBoltOnsList', {
      templateUrl: 'app/clients/boltons/zp-bolt-ons-list/list.tmpl.html',
      controller: 'BoltOnsListCtrl',
      bindings: {
        model: '<',
        selected: '&'
      }
    })
    .controller('BoltOnsListCtrl', ctrl);

  ctrl.$inject = [];
  /* ng-inject */
  function ctrl() {}
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpBoltOnsCards', {
      templateUrl: 'app/clients/boltons/zp-bolt-ons-cards/cards.tmpl.html',
      controller: 'BoltOnsCardsCtrl',
      bindings: {
        model: '<',
        selected: '&'
      }
    })
    .controller('BoltOnsCardsCtrl', ctrl);

  ctrl.$inject = [];
  /* ng-inject */
  function ctrl() {}
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpBoltOnManagementView', {
      templateUrl: 'app/clients/boltons/zp-bolt-on-management-view/view.tmpl.html',
      controller: 'BoltOnManagementViewCtrl',
      bindings: {
        boltOnSelected: '<',
        closeDialog: '&'
      }
    })
    .controller('BoltOnManagementViewCtrl', ctrl);

  ctrl.$inject = ['BoltOnsFactory', 'BoltOnsMetadataFactory', 'MessageService', 'SessionService'];
  /* ng-inject */
  function ctrl(BoltOnsFactory, BoltOnsMetadataFactory, MessageService, SessionService) {

    var vm = this;
    vm.changes = [];
    vm.userData = SessionService.getUserData();

    vm.$onInit = function () {
      // re shapes the boltons to be keyed off their property
      const metadataMap = _.fromPairs(_.map(BoltOnsMetadataFactory.arrayOfBoltOns, function (item) {
        return [
          item.property, {
            icon: item.icon,
            svgicon: item.svgicon,
            property: item.property,
            label: item.label,
            permission: item.permission
          }
        ];
      }));

      vm.boltOns = _.map(BoltOnsFactory.factoryData.permissions.boltOns, function (boltOn, key) {
        return _.extend(metadataMap[key], boltOn);
      });
    };

    vm.toggleBoltOn = function (boltOn) {
      vm.updateSuccess = false;
      vm.persistedChanges = [];
      boltOn.selected = !boltOn.selected; // selected prop is for view (prior to save)
      const inChanges = _.find(vm.changes, function (el) {
        return el.property === boltOn.property;
      });
      if (inChanges) {
        // remove it
        vm.changes = _.filter(vm.changes, function (el) {
          return el.property !== boltOn.property;
        });

        return;
      }

      vm.pulseSaveBtn = true;
      vm.changes.push({
        label: boltOn.label,
        property: boltOn.property,
        enabled: boltOn.enabled
      });
    };

    vm.clearChanges = function (reset) {
      _.each(vm.changes, function (changeItm) {
        _.each(vm.boltOns, function (itm) {
          if (changeItm.property === itm.property) {
            itm.selected = false;
            if (reset) {
              itm.enabled = !itm.enabled;
            }
          }
        });
      });
      vm.changes = [];
    };

    vm.postChanges = function () {
      vm.saving = true;
      vm.pulseSaveBtn = false;
      return BoltOnsFactory.updateBoltons(vm.changes)
        .then(function () {
          MessageService.showMessage(vm.changes.length + ' bolt-ons updated');
          vm.persistedChanges = angular.copy(vm.changes);
          vm.updateSuccess = true;
          vm.clearChanges();
          vm.saving = false;
        })
        .catch(function (err) {
          MessageService.showMessage(err);
        });
    };
  }

}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpBoltOnsFab', {
      templateUrl: 'app/clients/boltons/fab/fab.tmpl.html',
      controller: 'zpBoltOnsPageCtrl'
    });
})();

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('WebsummitHelpersFactory', factory);
  factory.$inject = [];
  /* ng-inject */
  function factory() {

    return {
      setScannerSettings: setScannerSettings
    };

    function setScannerSettings(vm) {
      vm.newFormDoc.zuantWebLookupToken2 = setScanToken(vm.accountTemplateSettings);
      delete vm.accountTemplateSettings.clientDoc.partnerId;
    }

    function setScanToken(templateSettings) {
      return templateSettings.scanToken2 + templateSettings.clientDoc.partnerId;
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('bizcard', ['chart.js', 'ui.router', 'common', 'zp.api', 'zp.encoding', 'zp.env']);
})();

(function () {
  'use strict';

  angular
    .module('bizcard')
    .component('zpBizcardHome', {
      templateUrl: 'app/biz-card/page-components/zp-bizcard-home/page.tmpl.html',
      controller: 'BizcardHomeController',
      bindings: {}
    })
    .controller('BizcardHomeController', controller);

  controller.$inject = ['$state', 'BusinessCardModelFactory', 'enumsSvc', 'MessageService'];
  /* ng-inject */
  function controller($state, BusinessCardModelFactory, enumsSvc, MessageService) {

    var vm = this;

    vm.$onInit = function () {
      vm.toggleViewIcon = 'zmdi zmdi-eye';
      vm.showList = BusinessCardModelFactory.factoryData.showCardCountsCard;
      vm.loadingCardData = false;
      vm.model = BusinessCardModelFactory;
      vm.data = BusinessCardModelFactory.factoryData.cardsCountsByClient;
      vm.enums = enumsSvc;
      vm.filter = {};
      vm.filter.show = true;
      MessageService.writeLog({
        level: 'info',
        msg: 'loaded biz card home page',
        tags: ['biz_card']
      });
      MessageService.pushEventToIntercom('loaded_biz_card_tool');
    };

    vm.toggleViewCardList = function () {
      BusinessCardModelFactory.factoryData.showCardCountsCard = !BusinessCardModelFactory.factoryData.showCardCountsCard;
      vm.toggleViewIcon = vm.showList ? 'zmdi zmdi-eye' : 'zmdi zmdi-eye-off';
    };

    vm.navigateToGroupedCardsView = function (processType) {
      $state.go('app.homescreen_app_framework_no_sidebar.bizcard.grouped-cards-view', {
        processType: processType
      });
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('bizcard')
    .component('zpBizcardGroupedCards', {
      templateUrl: 'app/biz-card/page-components/zp-grouped-cards/page.tmpl.html',
      controller: 'GroupedCardsController',
      bindings: {
        processType: '<'
      }
    })
    .controller('GroupedCardsController', controller);

  controller.$inject = ['$state', 'BusinessCardModelFactory', 'SessionService'];
  /* @ngInject */
  function controller($state, BusinessCardModelFactory, SessionService) {

    var vm = this;

    vm.$onInit = function () {

      vm.processType = 0;
      vm.model = BusinessCardModelFactory;

      vm.formCardGroup = BusinessCardModelFactory.factoryData.cardsGroupedByForm;
      vm.userCardGroup = BusinessCardModelFactory.factoryData.cardsGroupedByUser;

    };

    vm.refreshData = function () {
      vm.loading = true;
      BusinessCardModelFactory.getBusinessCardDataAggregation([SessionService.getUserData().clientId])
        .then(function () {
          vm.loading = false;
          vm.formCardGroup = BusinessCardModelFactory.factoryData.cardsGroupedByForm;
          vm.userCardGroup = BusinessCardModelFactory.factoryData.cardsGroupedByUser;    
        })
        .catch(function (){
          vm.loading = false;
        });
    };

    vm.goToCardProcessingPage = function () {
      $state.go('app.homescreen_app_framework_no_sidebar.bizcard.card-processing-view', {
        processType: vm.processType
      });
    };

    vm.home = function () {
      $state.go('app.homescreen_app_framework_no_sidebar.bizcard.grouped-cards-view');
    };

    vm.clearCurrentSelection = function () {
      BusinessCardModelFactory.clearAllSelectedCards();
    };

    vm.toggleCardSelected = function (widget, groupType) {
      widget.selected = !widget.selected;
      BusinessCardModelFactory.setFactoryCardSelectionParamaters(widget, groupType);
    };
  }

}());

(function () {
  'use strict';

  angular
    .module('bizcard')
    .component('zpBizcardProcessorPage', {
      templateUrl: 'app/biz-card/page-components/zp-card-processing/page.tmpl.html',
      controller: 'BizcardProcessorPageCtrl',
      bindings: {
        leadData: '<'
      }
    })
    .controller('BizcardProcessorPageCtrl', controller);

  controller.$inject = ['$log', '$state', 'BusinessCardModelFactory', 'ChangeDelta', 'MessageService', '$mdMedia', 'SessionService', 'AWS_STORAGE_REGION', 'AWS_STORAGE_BUCKET_NAME'];
  /* ng-inject */
  function controller($log, $state, BusinessCardModelFactory, ChangeDelta, MessageService, $mdMedia, session, awsStorageRegion, awsStorageBucketName) {

    var vm = this;

    vm.$onInit = function () {
      $log.info('zpBizcardProcessorPage $onInit');
      vm.userName = session.getUserData().email;
      vm.showWidgets = true;
      vm.loadingCardData = true;
      vm.changeDelta = ChangeDelta;
      vm.menuWidth = 5;
      vm.menuOptions = [{
        onClick: 'toggleShowWidgets',
        ariaLabel: function () {
          return 'Toggle show widgets';
        },
        icon: function () {
          return 'zmdi zmdi-eye';
        },
        label: function () {
          return 'Toggle Widgets';
        }
      }];

      vm.getContactImages();

      // vm.leadData.createddate = new Date(vm.leadData._initialcreatedatelocalutc);
      vm.cardDataStyles = calculateStyles('cardDataCard');
      vm.imageContainerStyles = calculateStyles('imageContainerStyles');
      vm.copyOfBizcardData = angular.copy(vm.leadData);
    };

    function calculateStyles(widgetId, showWidgets) {
      var screenSize, styles = {};
      if ($mdMedia('xs')) {
        screenSize = 'xs';
      } else if ($mdMedia('sm')) {
        screenSize = 'sm';
      } else if ($mdMedia('md')) {
        screenSize = 'md';
      } else if ($mdMedia('lg')) {
        screenSize = 'lg';
      } else if ($mdMedia('xl')) {
        screenSize = 'xl';
      }

      if (widgetId === 'cardDataCard') {
        if (screenSize === 'xs' || screenSize === 'sm') {
          if (showWidgets) {
            styles = {
              minHeight: '21vh',
              maxHeight: '21vh'
            };
          } else {
            styles = {
              minHeight: '41vh',
              maxHeight: '41vh'
            };
          }
        }
        if (screenSize === 'md') {
          styles = {
            minHeight: '41vh',
            maxHeight: '41vh'
          };
        }
        if (screenSize === 'lg') {
          styles = {
            minHeight: '72vh',
            maxHeight: '72vh'
          };
        }
        if (screenSize === 'xl') {
          styles = {
            minHeight: '79vh',
            maxHeight: '79vh'
          };
        }
        styles.overflowY = 'scroll';
      } else if (widgetId === 'imageContainerStyles') {
        if (screenSize === 'xs' || screenSize === 'sm') {
          styles = {
            minHeight: '20vh',
            maxHeight: '20vh',
            minWidth: '90vw',
            maxWidth: '90vw'
          };
        }
        if (screenSize === 'md') {
          styles = {
            minHeight: '15vh',
            maxHeight: '15vh',
            minWidth: '20vw',
            maxWidth: '20vw'
          };
        }
        if (screenSize === 'lg') {
          styles = {
            minHeight: '40vh',
            maxHeight: '40vh',
            minWidth: '35vw',
            maxWidth: '35vw'
          };
        }
        if (screenSize === 'xl') styles = {
          minHeight: '40vh',
          maxHeight: '40vh',
          minWidth: '30vw',
          maxWidth: '30vw'
        };
      }
      return styles;
    }

    vm.onMenuClick = function (ev) {
      if (ev.action === 'toggleShowWidgets') vm.toggleShowWidgets();
    };

    vm.toggleShowWidgets = function () {
      vm.showWidgets = !vm.showWidgets;
      vm.cardDataStyles = calculateStyles('cardDataCard', vm.showWidgets);
      vm.imageContainerStyles = calculateStyles('imageContainerStyles', vm.showWidgets);
    };

    vm.exit = function () {

      if (!BusinessCardModelFactory.factoryData.cardCurrentlyBeingEdited) {
        return goToGroupedCardsPage();
      }

      BusinessCardModelFactory.deallocateBizCard(BusinessCardModelFactory.factoryData.cardCurrentlyBeingEdited.bizcardId)
        .then(function () {
          goToGroupedCardsPage();
        })
        .catch(function () {
          goToGroupedCardsPage();
        });
    };

    function goToGroupedCardsPage() {
      $state.go('app.homescreen_app_framework_no_sidebar.bizcard.grouped-cards-view');
    }

    vm.updateChangeDelta = function (collection, databasefieldname, newval) {
      var changeObj = {
        oldval: vm.copyOfBizcardData[databasefieldname] || '',
        objectid: vm.copyOfBizcardData._id,
        collection: collection,
        databasefieldname: databasefieldname,
        newval: newval
      };

      if (changeObj.collection === 'company') {
        changeObj.objectid = vm.copyOfBizcardData._companyid;
      }

      ChangeDelta.recordValueChange(changeObj);
    };

    vm.getNextCard = function (skip) {
      vm.skip = skip;
      vm.loadingCardData = true;
      vm.showNoCardsLeftToProcessMessage = false;
      vm.bizcardimage = '';
      ChangeDelta.clear();
      BusinessCardModelFactory.getNextCardToProcess(skip)
        .then(function (cardData) {
          vm.angle = 0;
          vm.leadData = cardData;
          vm.copyOfBizcardData = angular.copy(cardData);
          vm.getContactImages();
          if (BusinessCardModelFactory.factoryData.zeroCardsLeftToProcess) {
            vm.showNoCardsLeftToProcessMessage = true;
          }
        })
        .catch(function (err) {
          if (err.message === 'No cards left to process') {
            vm.loadingCardData = true;
            vm.showNoCardsLeftToProcessMessage = true;
          }
          if (err.status === 500) {
            $state.go('app.500');
          }
        });
    };

    vm.saveCardDetails = function (imageQuality, andFetchNextCard) {

      if (!vm.leadData.bizcardId) return;
      vm.leadData.imageQuality = imageQuality;

      ChangeDelta.recordValueChange({
        oldval: '',
        newval: true,
        objectid: vm.leadData.bizcardId,
        collection: 'response',
        databasefieldname: '_imageprocessed'
      });
      ChangeDelta.recordValueChange({
        oldval: '',
        newval: new Date(),
        objectid: vm.leadData.bizcardId,
        collection: 'response',
        databasefieldname: '_cardprocesseddatelocalutc'
      });
      ChangeDelta.recordValueChange({
        oldval: '',
        newval: new Date(),
        objectid: vm.leadData.bizcardId,
        collection: 'response',
        databasefieldname: '_lastbureaumodifieddatelocalutc'
      });
      ChangeDelta.recordValueChange({
        oldval: '',
        newval: false,
        objectid: vm.leadData.bizcardId,
        collection: 'response',
        databasefieldname: '_unprocessable'
      });
      ChangeDelta.recordValueChange({
        oldval: '',
        newval: vm.userName,
        objectid: vm.leadData.bizcardId,
        collection: 'response',
        databasefieldname: '_bureauuseremail'
      });
      ChangeDelta.recordValueChange({
        oldval: '',
        newval: ['Processed'],
        objectid: vm.leadData.bizcardId,
        collection: 'response',
        databasefieldname: 'bureaustatus'
      });
      // these params map to the mark-card-as-complete module in zuant_back_end
      var params = {
        cardId: vm.leadData.bizcardId,
        clientDb: vm.leadData.db,
        companyId: vm.leadData._companyid,
        companyData: {
          name: vm.leadData.companyname
        },
        contactId: vm.leadData._id,
        contactData: {
          salutation: vm.leadData.salutation,
          firstname: vm.leadData.firstname,
          lastname: vm.leadData.lastname,
          jobtitle: vm.leadData.jobtitle,
          phone: vm.leadData.phone,
          mobile: vm.leadData.mobile,
          email: vm.leadData.email,
          address1: vm.leadData.address1,
          address2: vm.leadData.address2,
          address3: vm.leadData.address3,
          city: vm.leadData.city,
          state: vm.leadData.state,
          country: vm.leadData.country,
          zipcode: vm.leadData.zipcode
        },
        responseId: vm.leadData.bizcardId,
        cardMetadata: {
          bureautag: vm.userName,
          timeallocated: vm.leadData.timeallocated,
          processType: 2,
          imageQuality: 'ok',
          bureaustatus: 'Processed'
        },
        // the below is used for GDPR enabled accounts
        clientId: vm.leadData.clientid,
        changeDeltas: ChangeDelta.getDeltaObject()
      };

      BusinessCardModelFactory.saveBizcardData(params)
        .then(function () {
          MessageService.showMessage('Changes saved');
          ChangeDelta.clear();
          if (andFetchNextCard) {
            vm.getNextCard();
          }
        })
        .catch(function (err) {
          MessageService.showMessage('error: ' + err);
        });
    };

    vm.resetForm = function () {
      vm.leadData = _.extend({}, vm.copyOfBizcardData, {});
    };

    vm.getContactImages = function () {
      vm.responseImages = [];

      if (vm.leadData.businessCardFront) {
        BusinessCardModelFactory.getImage(vm.leadData.db, vm.leadData.businessCardFront)
          .then(function (imgDetailsFront) {
            if ('imagebase64' in imgDetailsFront) {
              vm.bizcardimage = 'data:image/jpg;base64,' + imgDetailsFront.imagebase64;
              vm.responseImages.push('data:image/jpg;base64,' + imgDetailsFront.imagebase64);
            } else if ('_s3key' in imgDetailsFront) {
              const s3Url = 'https://s3.' + awsStorageRegion + '.amazonaws.com/' + awsStorageBucketName + '/' + imgDetailsFront._s3key;
              vm.bizcardimage = s3Url;
              vm.responseImages.push(s3Url);
            }

            vm.leadData.images.forEach(function (image) {
              if (image != vm.leadData.businessCardFront) {
                BusinessCardModelFactory.getImage(vm.leadData.db, image)
                  .then(function (imgDetailsBack) {
                    if ('imagebase64' in imgDetailsBack) {
                      vm.responseImages.push('data:image/jpg;base64,' + imgDetailsBack.imagebase64);
                    } else if ('_s3key' in imgDetailsBack) {
                      const s3Url = 'https://s3.' + awsStorageRegion + '.amazonaws.com/' + awsStorageBucketName + '/' + imgDetailsBack._s3key;
                      vm.responseImages.push(s3Url);
                    }
                  });
              }
            });
            vm.loadingCardData = false;
          })
          .catch(function (data, status) {
            MessageService.showMessage('error', 'Get Business Card Images', 'Failed to get business card image');
            $log.error('Failed to get the images for the business card: ' + status);
            vm.loadingCardData = false;
          });
      } else {
        $log.info('There are no images for this business card');
        vm.loadingCardData = false;
      }
    };

    vm.rejectCard = function (ev) {
      MessageService.showDialog(ev, {
        controller: cardRejectDialogController,
        controllerAs: '$ctrl',
        templateUrl: 'app/biz-card/dialogs/card-reject-dialog.tmpl.html',
        clickOutsideToClose: false
      })
        .then(function (imageRejectionReason) {
          var params = {
            cardMetadata: {
              timeallocated: vm.leadData.timeallocated,
              processType: 1,
              imageQuality: imageRejectionReason,
              bureautag: vm.userName
            },
            responseId: vm.leadData.bizcardId,
            cardId: vm.leadData.bizcardId,
            clientDb: vm.leadData.db,
            clientId: vm.leadData.clientid,
            changeDeltas: ChangeDelta.getDeltaObject()
          };
          ChangeDelta.recordValueChange({
            oldval: '',
            newval: true,
            objectid: vm.leadData.bizcardId,
            collection: 'response',
            databasefieldname: '_imageprocessed'
          });
          ChangeDelta.recordValueChange({
            oldval: '',
            newval: true,
            objectid: vm.leadData.bizcardId,
            collection: 'response',
            databasefieldname: '_unprocessable'
          });
          BusinessCardModelFactory.rejectBizCard(params)
            .then(function () {

              MessageService.showMessage('Card marked as reject: ' + imageRejectionReason);
              ChangeDelta.clear();
              vm.getNextCard();
            })
            .catch(function (err) {
              MessageService.showMessage('error: ' + err);
            });
        });
    };

  }

  cardRejectDialogController.$inject = ['MessageService'];
  /* ng-inject */
  function cardRejectDialogController(MessageService) {

    var vm = this;

    vm.cancel = function () {
      MessageService.cancelDialog();
    };

    vm.clearRejectText = function () {
      vm.data = {
        rejectText: ''
      };
    };

    vm.answer = function (answer) {
      if (answer.rejectText) {
        answer = answer.rejectText;
      } else {
        answer = answer.rejectReason;
      }
      MessageService.closeDialog(answer);
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('bizcard')
    .component('zpBizcardReporting', {
      templateUrl: 'app/biz-card/page-components/zp-bizcard-reports/page.tmpl.html',
      controller: 'ReportsController',
      bindings: {}
    })
    .controller('ReportsController', controller);

  controller.$inject = ['$state', 'BusinessCardModelFactory', 'dbAccessSvc', 'enumsSvc'];
  /* ng-inject */
  function controller($state, BusinessCardModelFactory, dbAccessSvc, enumsSvc) {

    var vm = this;
    vm.model = BusinessCardModelFactory;
    vm.chart = {};
    vm.chart.series = ['Processed', 'Unprocessable'];
    vm.minall = true;
    vm.maxDateReport = false;
    vm.maxEventReport = false;
    vm.maxClientReport = false;
    vm.maxUserReport = false;
    vm.isStandalone = true;
    vm.clientList = [];
    vm.angle = 0;
    vm.cardsAlreadyViewed = [];
    Chart.defaults.global.responsive = true;

    vm.query = {
      order: 'timecompleted',
      limit: 5,
      page: 1
    };

    vm.onLogout = function () {
      $state.go('authentication.login');
    };

    vm.prevPage = function () {
      $state.go('app.homescreen_app_framework_no_sidebar.bizcard.grouped-cards-view', {
        processType: enumsSvc.processType.PROCESSED
      });
    };

    vm.toggleDateReportDisplay = function () {
      if (vm.minall === true) {
        vm.minall = false;
        vm.maxDateReport = true;
      } else {
        vm.minall = true;
        vm.maxDateReport = false;
      }
    };

    vm.toggleEventReportDisplay = function () {
      if (vm.minall === true) {
        vm.minall = false;
        vm.maxEventReport = true;
      } else {
        vm.minall = true;
        vm.maxEventReport = false;
      }
    };

    vm.toggleClientReportDisplay = function () {
      if (vm.minall === true) {
        vm.minall = false;
        vm.maxClientReport = true;
      } else {
        vm.minall = true;
        vm.maxClientReport = false;
      }
    };

    vm.toggleUserReportDisplay = function () {
      if (vm.minall === true) {
        vm.minall = false;
        vm.maxUserReport = true;
      } else {
        vm.minall = true;
        vm.maxUserReport = false;
      }
    };

    function buildUserReportData() {
      var labels = [];
      var chartData = [];
      var index;
      var index2;

      var userReportData = {};

      vm.cardsForReport.forEach(function (card) {
        if (labels.indexOf(card._bureauuseremail) === -1) {
          labels.push(card._bureauuseremail);
        }
      });

      labels.sort();

      chartData[0] = []; // for processed results
      chartData[1] = []; // for unprocessable results

      for (index = 0; index < labels.length; index++) {
        for (index2 = 0; index2 < chartData.length; index2++) {
          chartData[index2][index] = 0;
        }
      }

      vm.cardsForReport.forEach(function (card) {
        if (card.processtype === 2) { // Processed
          for (index = 0; index < labels.length; index++) {
            if (card._bureauuseremail === labels[index]) {
              chartData[0][index]++;
            }
          }
        } else
          if (card.processtype === 1) { // Unprocessable
            for (index = 0; index < labels.length; index++) {
              if (card._bureauuseremail === labels[index]) {
                chartData[1][index]++;
              }
            }
          }
      });
      userReportData.labels = labels;
      userReportData.chartData = chartData;

      return userReportData;
    }

    function buildClientReportData() {
      var labels = [];
      var chartData = [];
      var index;
      var index2;

      var clientReportData = {};

      vm.cardsForReport.forEach(function (card) {
        if (labels.indexOf(card.clientname) === -1) {
          labels.push(card.clientname);
        }
      });

      labels.sort();

      chartData[0] = []; // for processed results
      chartData[1] = []; // for unprocessable results

      for (index = 0; index < labels.length; index++) {
        for (index2 = 0; index2 < chartData.length; index2++) {
          chartData[index2][index] = 0;
        }
      }

      vm.cardsForReport.forEach(function (card) {
        if (card.processtype === 2) { // Processed
          for (index = 0; index < labels.length; index++) {
            if (card.clientname === labels[index]) {
              chartData[0][index]++;
            }
          }
        } else
          if (card.processtype === 1) { // Unprocessable
            for (index = 0; index < labels.length; index++) {
              if (card.clientname === labels[index]) {
                chartData[1][index]++;
              }
            }
          }
      });
      clientReportData.labels = labels;
      clientReportData.chartData = chartData;

      return clientReportData;
    }

    function buildEventReportData() {
      var labels = [];
      var chartData = [];
      var index;
      var index2;

      var eventReportData = {};

      vm.cardsForReport.forEach(function (card) {
        if (labels.indexOf(card.eventname) === -1) {
          labels.push(card.eventname);
        }
      });

      labels.sort();

      chartData[0] = []; // for processed results
      chartData[1] = []; // for unprocessable results

      for (index = 0; index < labels.length; index++) {
        for (index2 = 0; index2 < chartData.length; index2++) {
          chartData[index2][index] = 0;
        }
      }

      vm.cardsForReport.forEach(function (card) {
        if (card.processtype === 2) { // Processed
          for (index = 0; index < labels.length; index++) {
            if (card.eventname === labels[index]) {
              chartData[0][index]++;
            }
          }
        } else
          if (card.processtype === 1) { // Unprocessable
            for (index = 0; index < labels.length; index++) {
              if (card.eventname === labels[index]) {
                chartData[1][index]++;
              }
            }
          }
      });

      eventReportData.labels = labels;
      eventReportData.chartData = chartData;

      return eventReportData;
    }

    function buildDateReportData() {
      var labels = [];
      var labelsText = [];
      var chartData = [];
      var index;
      var index2;

      var dateReportData = {};

      vm.cardsForReport.forEach(function (card) {
        if (!containsObject(card.allocatedDate, labels)) {
          labels.push(card.allocatedDate);
        }
      });

      labels.sort(sortFunction);

      chartData[0] = []; // for processed results
      chartData[1] = []; // for unprocessable results

      for (index = 0; index < labels.length; index++) {
        for (index2 = 0; index2 < chartData.length; index2++) {
          chartData[index2][index] = 0;
        }
        /* eslint no-useless-escape:0 */
        labelsText[index] = labels[index].day + '\/' + labels[index].month + '\/' + labels[index].year;
      }

      vm.cardsForReport.forEach(function (card) {
        if (card.processtype === 2) { // Processed
          for (index = 0; index < labels.length; index++) {
            if (dateMatch(card.allocatedDate, labels[index])) {
              chartData[0][index]++;
            }
          }
        } else
          if (card.processtype === 1) { // Unprocessable
            for (index = 0; index < labels.length; index++) {
              if (dateMatch(card.allocatedDate, labels[index])) {
                chartData[1][index]++;
              }
            }
          }
      });

      dateReportData.labels = labelsText;
      dateReportData.chartData = chartData;

      return dateReportData;

      function dateMatch(d1, d2) {
        if (d1.year === d2.year && d1.month === d2.month && d1.day === d2.day) return true;
        else return false;
      }

      function sortFunction(a, b) {
        var y1 = a.year;
        var y2 = b.year;

        if (y1 < y2) return -1;
        if (y1 > y2) return 1;

        y1 = a.month;
        y2 = b.month;

        if (y1 < y2) return -1;
        if (y1 > y2) return 1;

        y1 = a.day;
        y2 = b.day;

        if (y1 < y2) return -1;
        if (y1 > y2) return 1;

        return 0;
      }
    }

    function containsObject(obj, list) {
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i].year === obj.year && list[i].month === obj.month && list[i].day === obj.day) {
          return true;
        }
      }
      return false;
    }

    activate();

    function activate() {
      vm.cardsForReport = vm.model.getAllCardsForReport();
      vm.dateReport = buildDateReportData();
      vm.eventReport = buildEventReportData();
      vm.clientReport = buildClientReportData();
      vm.userReport = buildUserReportData();
      vm.dbAccess = dbAccessSvc;
    }

  }
}());

/**
 * Provides authentication services for the application
 * @module authentication
 */

(function () {
  'use strict';

  angular
    .module('authentication', ['ui.router', 'common', 'zp.api']);
})();

(function() {
  'use strict';
        
  angular
    .module('authentication')
    .component('zpMfaVerification', {
      templateUrl: 'app/authentication/mfa/verification/mfa-verification.tmpl.html',
      controller: 'MfaVerificationController',
      bindings: {
        layout: '@',
        layoutFill: '@',
        zuantLogoURL: '@',
        email: '@',
        userId: '@',
        databasename: '@'
      }
    })
    .controller('MfaVerificationController', ctrl);

  ctrl.$inject = ['$state', 'MfaFactory', 'MessageService'];
  function ctrl($state, MfaFactory, MessageService) {
    
    const vm = this;
    vm.passcode = null;
    vm.passcodeInvalid = false;
    vm.disableForm = false;

    vm.submitVerificationForm = function (){
      if (!vm.passcode) return;

      vm.disableForm = true;
      return MfaFactory.verifyPasscode({ databasename: vm.databasename, userId: vm.userId, passcode: vm.passcode })
        .then(function (){
          $state.go('app.single_view_framework.dashboard');
        })
        .catch(function (error){
          const msg = _.get(error, ['data', 'error'], 'MFA verification failed');
          MessageService.showMessage(msg);
          vm.passcodeInvalid = true;
          vm.passcodeError = msg;
          vm.disableForm = false;
        });
    };

  }
        
}());
(function() {
  'use strict';
        
  angular
    .module('authentication')
    .component('zpMfaSetup', {
      templateUrl: 'app/authentication/mfa/setup/mfa-setup.tmpl.html',
      controller: 'MfaSetupController',
      bindings: {
        layout: '@',
        layoutFill: '@',
        zuantLogoURL: '@',
        userId: '@',
        databasename: '@',
        email: '@'
      }
    })
    .controller('MfaSetupController', ctrl);

  ctrl.$inject = ['MfaFactory', 'MessageService'];
  function ctrl(MfaFactory, MessageService) {
    
    const vm = this;
    vm.disableResendBtn = false;
  
    vm.resendSetupEmail = function (){
      vm.disableResendBtn = true;

      return MfaFactory.resendSetupEmail(vm.databasename, vm.userId)
        .then(function(){
          MessageService.showMessage('Email resent succesfully');
        })
        .catch(function(error){
          const msg = _.get(error, ['data', 'error'], 'Email failed to resend');
          MessageService.showMessage(msg);
        });
    };

  }
        
}());
(function() {
  'use strict';
      
  angular
    .module('authentication')
    .component('zpMfaRecovery', {
      templateUrl: 'app/authentication/mfa/recovery/mfa-recovery.tmpl.html',
      controller: 'MfaRecoveryController',
      bindings: {
        layout: '@',
        layoutFill: '@',
        zuantLogoURL: '@',
        email: '@',
        databasename: '@',
        userId: '@'
      }
    })
    .controller('MfaRecoveryController', ctrl);

  ctrl.$inject = [];
  function ctrl() {}
      
}());
(function() {
  'use strict';
    
  angular
    .module('authentication')
    .component('zpMfaConfirmSetup', {
      templateUrl: 'app/authentication/mfa/confirm-setup/mfa-confirm-setup.component.tmpl.html',
      controller: 'MfaConfirmSetupController',
      bindings: {
        layout: '@',
        layoutFill: '@',
        zuantLogoURL: '@',
        resolvedToken: '<'
      }
    })
    .controller('MfaConfirmSetupController', ctrl);

  ctrl.$inject = ['MfaFactory', 'MessageService'];
  function ctrl(MfaFactory, MessageService) {
    
    const vm = this;
    vm.passcode = null;
    vm.invalidPasscode = false;
    vm.disableForm = false;
    vm.setupComplete = false;

    vm.confirmOtp = function (){
      if (!vm.passcode) return;

      vm.disableForm = true;
      return MfaFactory.validatePasscode(vm.passcode, vm.resolvedToken._id)
        .then(function (){
          MessageService.showMessage('Code successfully validated.');
          vm.setupComplete = true;
        })
        .catch(function (error){
          if (error.status === -1) return MessageService.showMessage('Server Error: server returned status code -1.');

          const msg = _.get(error, ['data', 'error'], 'Failed to validate token');
          MessageService.showMessage(msg);
          vm.passcodeError = msg;
          vm.disableForm = false;
        });
    };
  
    vm.openAppStore = function () {
      window.open('https://apps.apple.com/us/app/google-authenticator/id388497605', '_blank');
    };

    vm.openPlayStore = function () {
      window.open('https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2', '_blank');
    };

  }
    
}());

(function() {
  'use strict';
    
  angular
    .module('authentication')
    .component('zpMfaConfirmReset', {
      templateUrl: 'app/authentication/mfa/confirm-reset/mfa-confirm-reset.component.tmpl.html',
      controller: 'MfaConfirmResetController',
      bindings: {
        layout: '@',
        layoutFill: '@',
        zuantLogoURL: '@',
        email: '@',
        type: '@',
        message: '@',
        error: '@'
      }
    })
    .controller('MfaConfirmResetController', ctrl);

  ctrl.$inject = ['AuthService'];
  function ctrl(AuthService) {
    var vm = this;
    vm.userIsLoggedIn = false;

    vm.$onInit = function (){
      AuthService.authoriseUser()
        .then(function (){
          vm.userIsLoggedIn = true;
        })
        .catch(function (){
          vm.userIsLoggedIn = false;
        });
    };
  }
    
}());

/**
 * Created by dbeazer on 20/11/2017.
 */
/**
 * Provides functionality for administering artefacts in Zuant
 * @module artefacts
 */
(function () {
  angular
    .module('artefacts', [
      'ngMaterial',      
      'common'
    ]);
})();

(function () {
  'use strict';

  angular
    .module('artefacts')
    .component('zpImageArtefactForm', {
      templateUrl: 'app/artefacts/images/image-artefact-form/zp-image-artefact-form.tmpl.html',
      controller: 'zpImageArtefactFormCtrl',
      bindings: {
        loading: '<',
        formType: '<',
        imageType: '<',
        setImageType: '&',
        imageDoc: '<',
        formObject: '=',
        dropboxCallbackLocation: '<'
      }
    })
    .controller('zpImageArtefactFormCtrl', ctrl);

  ctrl.$inject = ['$scope', 'MessageService', 'dropboxApiService', 'localStorageService'];
  /* ng-inject */
  function ctrl($scope, MessageService, dropboxApiService, localStorageService) {

    var vm = this;
    vm.busy = true;
    vm.fileUploaded = false;
    vm.fileErrors = [];

    vm.$onInit = function () {
      const dbToken = dropboxApiService.getBearerToken();
      if (dbToken === 'Bearer null') {
        vm.showConnectMessage = true;
        vm.busy = false;
      } else {
        dropboxApiService.getCurrentAccount()
          .then(function (){
            vm.showConnectMessage = false;
          })
          .catch(function (){
            vm.showConnectMessage = true;
          })
          .finally(function (){
            vm.busy = false;
          });
      }
    };

    vm.selectFile = function() {
      if (vm.fileUploaded) {
        vm.fileName = '';
        vm.fileErrors = [];
        vm.fileUploaded = false;
        angular.element(document).find('#imageUploadInput').val(null);
        return;
      }
      
      angular.element(document).find('#imageUploadInput').click();
    };
  
    vm.fileChanged = function ($event) {
      vm.fileUploaded = true;
      vm.fileName = $event.target.files[0].name;
      const splits = vm.fileName.split('.');
      const fileExtension = splits.pop();
      const validFileTypes = ['jpg', 'png', 'jpeg', 'bmp'];
      
      if (validFileTypes.indexOf(fileExtension) === -1) {
        vm.fileErrors.push({
          type: 'invalid_file_type',
          error: 'Invalid File Type: ' + `"${fileExtension}" is not valid. Only the following image types are valid - ${validFileTypes.map(function (type){
            return `.${type}`;
          }).toString()} `,
        });
        return MessageService.showMessage('Invalid file type. Please select a valid image.');
      }

      const reader = new FileReader();
      reader.onload = function(event) {
        //ImagesApiFactory.setFile(e.target.result);
        const arrayBuffer = event.target.result;

        const img = new Image();
            
        img.onload = function() {
          $scope.$apply(function() {

            if (!vm.imageDoc.filename){
              vm.imageDoc.filename = vm.fileName;
            }

            vm.imageDoc.type = `.${fileExtension}`;
            vm.imageDoc.height = img.height;
            vm.imageDoc.width = img.width;
            vm.imageDoc.size = $event.target.files[0].size;
            vm.imageDoc.imageDataAsArrayBuffer = arrayBuffer;
          });
        };
            
        img.src = arrayBufferToBase64(arrayBuffer);
      };
      reader.readAsArrayBuffer($event.target.files[0]); // changed to readAsArrayBuffer for saving to Dropbox
    };

    function arrayBufferToBase64(arrayBuffer) {
      let binary = '';
      const bytes = new Uint8Array(arrayBuffer);
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return 'data:image/jpeg;base64,' + window.btoa(binary);
    }

    vm.connectToDropbox = function (){
      localStorageService.set('dropboxRedirectPath', vm.dropboxCallbackLocation);
      dropboxApiService.connectToDropbox();
    };

    vm.closeDropboxConnectMessage = function (){
      vm.showConnectMessage = false;
    };
  }
}());

/**
 * Created by davidhickson on 02/05/2017.
 */
(function () {
  'use strict';
  angular
    .module('artefacts')
    .controller('ImageArtefactDialogController', ctrl);

  ctrl.$inject = ['imageDoc', '$log', 'ImagesApiFactory', 'uuidService', 'MessageService', 'ChangeDelta', 'hotkeys', 'locals', 'dropboxApiService'];
  /* ng-inject */
  function ctrl(imageDoc, $log, ImagesApiFactory, uuidService, MessageService, ChangeDelta, hotkeys, locals, dropboxApiService) {

    var vm = this;

    vm.disableSaveButton = false;
    vm.loading = false;

    vm.$onInit = function (){

      vm.formType = locals.formType;
      vm.imageType = locals.imageType;
      vm.imageDoc = angular.copy(imageDoc);
      vm.dropboxCallbackLocation = locals.dropboxCallbackLocation;

      if (imageDoc.dropboxPath) {
        dropboxApiService.getImageMetadata(imageDoc.dropboxPath)
          .then(function (res) {
            MessageService.writeLog({
              level: 'info',
              msg: 'back from dropbox with image metadata ' + res,
              tags: ['showroom']
            });
          })
          .catch(function (err) {
            MessageService.writeLog({
              level: 'error',
              msg: 'back from dropbox with image metadata error: ' + err,
              tags: ['showroom']
            });
          });
      }
    };

    vm.setImageType = function(type) {
      vm.imageType = type;
      if (type === 'weburi') {
        delete vm.filename;
      }
    };

    vm.submitImageForm = function(formData) {
      if (!formData._id) {
        formData._id = uuidService.getSingleNewBase64Key();
      }

      vm.disableSaveButton = true;
      vm.loading = true;
      ImagesApiFactory.ingestChangedImageItem(formData, vm.imageType)
        .then(function () {
          MessageService.showMessage('Image Item added');
          vm.disableSaveButton = false;
          vm.loading = false;
          ChangeDelta.clear();
          vm.hide({
            selectedImage: formData
          });
        })
        .catch(function (err) {
          vm.loading = false;
          vm.disableSaveButton = false;
          $log.error(err);
          MessageService.writeLog({
            level: 'error',
            msg: err,
            tags: ['showroom']
          });
          if (err.message === 'shared_link_already_exists') {
            vm.userMessage = 'Dropbox has notified us that it already has this image in the account Zuant is currently connected to. If you close this dialog and open the image viewer you should find it in there. (If you really want to load it anyway, change the filename and Dropbox will comply)';
          }
        });
    };

    // modal dismiss functions
    vm.hide = function  (answer) {
      hotkeys.del('enter');
      MessageService.closeDialog(answer);
    };

    vm.cancelDialog = function () {
      hotkeys.del('enter');
      MessageService.cancelDialog();
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('users')
    .component('zpUsersAppHomepage', {
      templateUrl: 'app/users/main/user-app-page.tmpl.html',
      controller: 'zpUsersAppController'
    })
    .controller('zpUsersAppController', ctrl);

  ctrl.$inject = ['UserMetadataFactory', 'UserFactory', 'MasterPermissionsDefinitionFactory'];
  /* ng-inject */
  function ctrl(UserMetadataFactory, UserFactory, MasterPermissionsDefinitionFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.customerUsersMetadata = angular.copy(UserMetadataFactory.getData());
      vm.staffUsersMetadata = angular.copy(UserMetadataFactory.getData());
      vm.staffUsersMetadata.id = 'staff_user_list';
      vm.blankSlate = UserFactory;
      vm.permissions = MasterPermissionsDefinitionFactory;
      const factoryData = UserFactory.getData();
      vm.staffUsersData = {
        items: factoryData.activeStaffUsers,
        itemsObject: factoryData.itemsObject
      };
      vm.customerUsersData = {
        items: factoryData.activeUsers,
        itemsObject: factoryData.itemsObject
      };
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('users')
    .component('zpUserDetailPage', {
      templateUrl: 'app/users/detail/user-detail-page.tmpl.html',
      controller: 'UserDetailController'
    })
    .controller('UserDetailController', UserDetailController);

  UserDetailController.$inject = ['$state', 'MessageService', 'EncodingService', 'hotkeys', 'ChangeDelta', 'SessionService', 'UserFactory', 'CurrentClientModelFactory', 'MfaFactory', 'MasterPermissionsDefinitionFactory'];
  /* ng-inject */
  function UserDetailController(state, MessageService, encoder, hotkeys, ChangeDelta, session, UserFactory, CurrentClientModelFactory, MfaFactory, MasterPermissionsDefinitionFactory) {

    const clientId = {
      _id: encoder.encode(session.getUserData().clientId)
    };

    var vm = this;
    vm.title = 'Edit user';

    vm.$onInit = function () {
      vm.clientDoc = CurrentClientModelFactory.getCurrentClientCache();
      const userProps = UserFactory.getCurrentUserCache();

      vm.userDoc = {
        _id: userProps._id,
        firstname: userProps.firstname,
        surname: userProps.surname,
        email: userProps.email,
        typeofuser: userProps.typeofuser,
        inactive: userProps.inactive,
        permissions: userProps.permissions,
        company: userProps.company,
        jobtitle: userProps.jobtitle,
        avatar: userProps.avatar,
        userHasBeenSentWelcomeEmail: userProps.userHasBeenSentWelcomeEmail,
        mfaResetRequest: userProps.mfaResetRequest,
        mfaSetup: userProps.mfaSetup
      };

      vm.menuOptions = [
        {
          onClick: 'setPassword',
          ariaLabel: function () {
            return 'Set Password';
          },
          icon: function () {
            return 'zmdi zmdi-key';
          },
          label: function () {
            return 'Set Password';
          }

        },
        {
          onClick: 'resetMFA',
          ariaLabel: 'Reset MFA',
          icon: function () {
            return 'zmdi zmdi-lock';
          },
          label: function () {
            return 'Reset MFA';
          },
          permissions: ['MFA_ENABLED'],
          disable: false,
          visible: vm.userDoc.mfaSetup && vm.userDoc.mfaResetRequest
        },
        {
          onClick: 'toggleArchiveUser',
          ariaLabel: function () {
            return'Archive User';
          },
          icon: function () {
            return 'zmdi zmdi-close';
          },
          label: function () {
            return 'Toggle Archive User';
          },
          permissions: MasterPermissionsDefinitionFactory.liteFeatures.users.archive
        },
        {
          onClick: 'deleteUser',
          ariaLabel: function () {
            return 'Delete User';
          },
          icon: function () {
            return 'zmdi zmdi-delete';
          },
          label: function () {
            return 'Delete User';
          }
        }
      ];

      if (!vm.clientDoc.ispreventuserwelcomeemail || vm.clientDoc.ispreventuserwelcomeemail === 0){
        vm.menuOptions.unshift({
          onClick: 'resendWelcomeEmail',
          ariaLabel: function () {
            return vm.userDoc.userHasBeenSentWelcomeEmail ? 'Resend Welcome Email' : 'Send Welcome Email';
          },
          icon: function () {
            return 'zmdi zmdi-email';
          },
          label: function () {
            return vm.userDoc.userHasBeenSentWelcomeEmail ? 'Resend Welcome Email' : 'Send Welcome Email';
          }
        });
      }

    };

    vm.onMenuClick = function (ev) {
      if (ev.action == 'resendWelcomeEmail') vm.resendWelcomeEmail();
      if (ev.action == 'deleteUser') vm.deleteUser();
      if (ev.action == 'setPassword') vm.setPassword();
      if (ev.action == 'toggleArchiveUser') vm.toggleArchiveUser();
      if (ev.action == 'resetMFA') vm.resetMFA();
    };

    vm.deleteUser = function(zpEvent, srcEvent) {
      MessageService
        .confirm(srcEvent)
        .delete('Are you sure you want to delete ' + vm.userDoc.firstname + ' ' + vm.userDoc.surname + '?')
        .then(function () {
          UserFactory.deleteUser(vm.userDoc._id)
            .then(function (res) {
              if (res) {
                state.go('app.homescreen_app_framework.users_home', clientId);
                MessageService.showMessage(vm.userDoc.firstname + ' successfully deleted');
              }
            });
        })
        .catch(function (err) {
          if (err)
          {
            MessageService.showMessage('Error deleting user');
            MessageService.writeLog({
              level: 'error',
              msg: err
            });
          }
        });
    };

    vm.resendWelcomeEmail = function(zpEvent, srcEvent) {
      MessageService
        .confirm(srcEvent)
        .confirmAction({
          title: 'Are you sure you want to send a welcome email?',
          content: 'Are you sure you want to send a welcome email to ' + vm.userDoc.email + '?',
          okBtn: 'YES',
          cancelBtn: 'NO'
        })
        .then(function () {
          UserFactory.resendWelcomeEmail()
            .then(function () {
              MessageService.showMessage('Welcome Email Sent');
              vm.userDoc.userHasBeenSentWelcomeEmail = true;
            });
        
        })
        .catch(function (err) {
          if (err)
          {
            MessageService.showMessage('Error sending welocme email');
            MessageService.writeLog({
              level: 'error',
              msg: err
            });
          }
        });
    };

    vm.saveForm = function() {
      const updateObj = UserFactory.cleanseUserUpdatePayload(vm.userDoc);

      if (!UserFactory.userDocValid(updateObj)) {
        MessageService.showMessage('Form invalid. Please fill out required fields');
        return;
      }

      UserFactory.postUserUpdate(updateObj)
        .then(function (response) {
          if (response) {
            MessageService.showMessage('Changes saved');
            ChangeDelta.clear();
            state.go('app.homescreen_app_framework.users_home', clientId);
          }
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });

    };

    vm.setPassword = function(zpEvent, srcEvent) {
      const config = {
        controller: 'SetPasswordController as vm',
        templateUrl: 'app/users/detail/set-password/dialog.tmpl.html',
        locals: {
          userEmail: vm.userDoc.email
        }
      };

      MessageService
        .showDialog(srcEvent, config)
        .then(
          function (success) {
            if (success) {
              MessageService.showMessage('Password change successful');
            }
            hotkeys.del('enter');
          },
          function () {
            /* cancelled */
            hotkeys.del('enter');
          }
        )
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
          hotkeys.del('enter');
        });
    };

    vm.resetMFA = function() {
      const resetItm = vm.menuOptions.find(function(itm){
        return itm.onClick === 'resetMFA';
      });

      resetItm.disable = true;

      return MfaFactory.triggerReset(vm.userDoc._id)
        .then(function (resp){
          MessageService.showMessage(resp.data.message);
        })
        .catch(function (error){
          resetItm.disable = false;

          if (error.status === -1) return MessageService.showMessage('Server Error: server returned status code -1.');

          const msg = _.get(error, ['data', 'error'], 'Invalid token - The submitted token is invalid');

          if (msg.code && msg.code === 'MFA_TOKEN_EXPIRED'){
            MessageService.showMessage(msg.message);
            return;
          }

          vm.userDoc.mfaSetup = false;
          MessageService.showMessage(msg);

        });
    };

    vm.toggleArchiveUser = function() {
      vm.userDoc.inactive = !vm.userDoc.inactive;
      const updatePackage = {
        _id: vm.userDoc._id,
        inactive: vm.userDoc.inactive
      };
      UserFactory.toggleArchiveUser(updatePackage)
        .then(function () {
          const msg = vm.userDoc.inactive ? 'archived' : 'unarchived';
          MessageService.showMessage('User has been ' + msg);
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };

  }
})();

/**
 * Created by davidbeazer on 23/02/2017.
 */
(function () {
  'use strict';

  angular
    .module('showroom')
    .factory('DropboxMetadataFactory', DropboxMetadataFactory);

  DropboxMetadataFactory.$inject = [];

  function DropboxMetadataFactory() {

    var factoryData = {};
    buildFactory();

    return {
      getData: getData
    };

    function getData() {
      return factoryData;
    }

    // PRIVATE

    function buildFactory() {

      factoryData = {
        id: 'dropbox_list',
        title: {
          label: 'Dropbox',
          filterLabel: 'Search dropbox items'
        },
        // columnsData: buildColumnsData(),
        // query: {
        //   order: {
        //     id: 'user.surname',
        //     expression: 'user.surname.raw'
        //   },
        //   limit: localStorage.get('user_list') || 50,
        //   page: 1
        // },
        // paginationOptions: {
        //   boundaryLinks: true,
        //   limitSelect: true,
        //   pageSelect: true,
        //   pagination: true,
        //   limitOptions: [5, 10, 20, 50, 75, 100],
        //   limit: localStorage.get('user_list') || 50,
        //   page: 1
        // },
        // gridOptions: {
        //   rowSelection: false,
        //   multiSelect: false,
        //   sortable: true,
        //   interactive: false
        // },
        fabDialogConfig: {
          description: 'Switch Dropbox Accounts',
          controller: 'SwitchDropboxAccountDialogController as vm',
          templateUrl: 'app/showroom/third-party/switch-accounts/dialog/switch-dropbox-account-dialog.tmpl.html',
          locals: {},
          ariaLabel: 'Switch dropbox account'
        }
      };
    }
  }
})();

/**
 * Created by davidhickson on 22/12/2016.
 */

/*
    If you share a folder but not individual files, then it is not possible to get a link to a file within the folder where the link results in the correct content-disposition value
     e.g. content-disposition →inline; filename="AMT813 Sell Sheet(1).pdf"; filename*=UTF-8''AMT813%20Sell%20Sheet%281%29.pdf
     This means that shareing folders isn't a practical mechanism for sharing files.
     DH therefore chose to adopt a strategy that requires individual files to be shared to support individual file links.
 */

(function () {
  'use strict';
  angular
    .module('showroom')
    .factory('dropboxApiService', ['$http', '$q', '$location', '$window', '$log', 'MessageService', 'localStorageService', 'SessionService', 'DROPBOX_CLIENT_ID', function ($http, $q, $location, $window, $log, MessageService, localStorageService, SessionService, DROPBOX_CLIENT_ID) {

      var vm = this;

      // $log.info('dropboxAPIService factory is instantiating - this will only happen once for each full-page refresh');

      vm.sharedLinks = {}; // Fast lookup object for all dropbox shared links (fully hydrated during service instantiation)
      vm.nodes = [];
      vm.arrayOfDropboxFolders = [];
      vm.stats = {
        addShowroomPhrase: 'Select a file to add',
        fileSelectionInfo: ''
      };
      vm.showFilterBar = false;
      vm.hideUnshared = false;
      vm.hideShared = false;
      vm.removeFileExtension = true;
      vm.replaceUnderscores = true;
      vm.capitaliseWords = true;
      vm.loadedBearerToken = '';
      vm.connectLocation = 'https://www.dropbox.com/1/oauth2/authorize?client_id=' + DROPBOX_CLIENT_ID + '&response_type=token&redirect_uri=' + $location.protocol() + '://' + $location.host() + ':' + $location.port() + '/thirdparty/dropboxCallback';

      vm.connectToDropbox = function () {
        if ($window.location.protocol === 'http:' && $window.location.href.indexOf('localhost') === -1) {
          MessageService.showMessage('You can only link an account to Dropbox if you are using a secure connection. Please change your browser url to https:// rather than http://');
        } else {
          $window.location = vm.connectLocation;
        }
      };

      vm.connectionMessage = {
        showMessage: false
      };

      vm.setShowConnectedMessage = function (val) {
        vm.connectionMessage.showMessage = val;
      };

      /*
       var factoryData = {
         sharedLinks: {}, // Fast lookup object for all dropbox shared links (fully hydrated during service instantiation)
         nodes: [],
         arrayOfDropboxFolders: [],
         stats: {
           addShowroomPhrase: 'Select a file to add',
           fileSelectionInfo: ''
         },
         showFilterBar: false,
         hideUnshared: false,
         hideShared: false,
         removeFileExtension: true,
         replaceUnderscore: true,
         capitaliseWords: true,
         loadedBearerToken: '',
         connectLocation: 'https://www.dropbox.com/1/oauth2/authorize?client_id=' + DROPBOX_CLIENT_ID + '&response_type=token&redirect_uri=' + $location.protocol() + '://' + $location.host() + ':' + $location.port() + '/showroom/dropboxCallback'
       };

       return {
          factoryData: factoryData,
          getThumbnailBatch: getThumbnailBatch,
          deleteBatch: deleteBatch,
          deleteBatchCheck: deleteBatchCheck,
          getImageMetadata: getImageMetadata,
          uploadImageToDropbox: uploadImageToDropbox,
          getImportOptions
          hydrateService
          initialiseTreeModel
          ensureNodeIsHydrated
          getBearerToken
          setBearerToken
          getCurrentAccount
          resetNodes
          setFoldersPosition
          getAccountInfo
          ensureFileIsShared
          getCurrentlySelectedFilesAsExportPackage
          propagateNodeSelectionState
          toggleExpandSelectedNodes
          refreshDisplay
          toggleNodeExpansion
          unshareNode
          toggleShareForSelectedNodes
          shareNode
          switchAllNodes
       };
       */
      /** Testing Dropbox API for creating images  function recursivelyGetSharedLinks(defer, cursor) {

          var token = vm.getBearerToken();
          var url = 'https://api.dropboxapi.com/2/sharing/list_shared_links';
          var body = {};
          if (cursor) {
            body = {
              'cursor': cursor
            };
          }

          $http({
            method: 'POST',
            url: url,
            headers: {
              'Authorization': token,
              'Content-type': 'application/json'
            },
            data: body
          })
          .then(function (data) {
            $log.info('recursivelyGetSharedLinks has ' + JSON.stringify(data));
            hydrateSharedLinks(data);
            if (data.data.has_more && data.data.cursor !== cursor && !vm.stopLoading) {
              recursivelyGetSharedLinks(defer, data.data.cursor);
            } else {
              defer.resolve({});
            }
          });
        }
      *
      */

      vm.getThumbnailBatch = function (entries) {
        var requestObj = {
          method: 'POST',
          url: 'https://content.dropboxapi.com/2/files/get_thumbnail_batch',
          headers: {
            'Authorization': vm.getBearerToken(),
            'Content-type': 'application/json'
          },
          data: JSON.stringify({
            entries: entries
          }),
          transformRequest: []
        };

        return $http(requestObj)
          .then(function (data) {
            return data;
          })
          .catch(function (err) {
            throw (err);
          });
      };

      vm.deleteBatch = function (entries) {
        var requestObj = {
          method: 'POST',
          url: 'https://api.dropboxapi.com/2/files/delete_batch',
          headers: {
            'Authorization': vm.getBearerToken(),
            'Content-type': 'application/json'
          },
          data: JSON.stringify({
            entries: entries
          }),
          transformRequest: []
        };

        return $http(requestObj)
          .then(function (data) {
            return data;
          })
          .catch(function (err) {
            throw (err);
          });
      };

      vm.deleteBatchCheck = function (jobId) {
        var requestObj = {
          method: 'POST',
          url: 'https://api.dropboxapi.com/2/files/delete_batch/check',
          headers: {
            'Authorization': vm.getBearerToken(),
            'Content-type': 'application/json'
          },
          data: JSON.stringify({
            async_job_id: jobId
          }),
          transformRequest: []
        };

        return $http(requestObj)
          .then(function (data) {
            return data;
          })
          .catch(function (err) {
            throw (err);
          });
      };

      vm.getImageMetadata = function (path) {

        var requestObj = {
          method: 'POST',
          url: 'https://api.dropboxapi.com/2/files/get_metadata',
          headers: {
            'Authorization': vm.getBearerToken(),
            'Content-type': 'application/json'
          },
          data: JSON.stringify({
            path: path,
            include_media_info: true,
            include_deleted: false,
            include_has_explicit_shared_members: false
          }),
          transformRequest: []
        };

        return $http(requestObj)
          .then(function (data) {
            return data;
          })
          .catch(function (err) {
            throw (err);
          });

      };

      vm.uploadImageToDropbox = function (imageData) {
        var filename = imageData.filename || imageData.title || imageData.name;
        var requestObj = {
          method: 'POST',
          url: 'https://content.dropboxapi.com/2/files/upload',
          headers: {
            'Authorization': vm.getBearerToken(),
            'Content-type': 'application/octet-stream',
            'Dropbox-API-Arg': JSON.stringify({
              path: '/images-uploaded-from-Zuant/' + filename + '.png',
              mode: 'add',
              autorename: true,
              mute: false
            })
          },
          data: imageData.imageDataAsArrayBuffer,
          transformRequest: []
        };

        return $http(requestObj)
          .then(function (data) {
            return data;
          })
          .catch(function (err) {
            throw (err);
          });
      };

      vm.getImportOptions = function () {
        return {
          removeFileExtension: vm.removeFileExtension,
          replaceUnderscores: vm.replaceUnderscores,
          capitaliseWords: vm.capitaliseWords
        };
      };

      vm.hydrateService = function () {
        var defer = $q.defer();
        if (vm.getBearerToken() !== vm.loadedBearerToken) {
          getAllDropboxSharedLinks()
            .then(vm.initialiseTreeModel)
            .then(function () {
              $log.info('dropboxAPIService hydrateService now resolving');
              vm.loadedBearerToken = vm.getBearerToken();
              defer.resolve();
            });
        } else {
          defer.resolve();
        }

        return defer.promise;
      };

      vm.initialiseTreeModel = function () {
        vm.nodes.length = 0;
        var defer = $q.defer();
        var recursionSetting = true;
        getFolderContents(recursionSetting, defer);
        return defer.promise;
      };

      vm.ensureNodeIsHydrated = function (node) {
        if (!node.isHydrated) {
          var defer = $q.defer();
          var recursionSetting = false;
          getFolderContents(recursionSetting, defer, node);
          return defer.promise;
        }

        $log.info('AFTER hydration event, data=' + JSON.stringify(vm.nodes));
      };

      vm.getBearerToken = function () {
        var existingAccounts = localStorageService.get('dropbox-accounts-' + SessionService.getUserData().databasename);
        var token = localStorageService.get('dropbox-access-token');
        if (token && Array.isArray(existingAccounts)) {
          if (Array.isArray(existingAccounts)) {
            var existsInAccount = existingAccounts.some(function (element) {
              return element.token === token;
            });
            if (!existsInAccount) {
              token = existingAccounts[0].token;
            }
          } else {
            token = null;
          }
        } else {
          token = null;
        }

        return 'Bearer ' + token;
      };

      vm.clearBearerToken = function () {
        localStorageService.remove('dropbox-accounts-' + SessionService.getUserData().databasename);
        localStorageService.remove('dropbox-access-token');
      };

      vm.setBearerToken = function (token) {
        localStorageService.set('dropbox-access-token', token);
      };

      function getFolderContents(recursionSetting, defer, node, cursor, stagingArray) {
        if (!cursor) {
          stagingArray = [];
        }

        var url = 'https://api.dropboxapi.com/2/files/list_folder';
        var path = node ? node.path : '';
        var parameters = {
          'path': path,
          'recursive': recursionSetting
        };

        if (cursor) {
          url = 'https://api.dropboxapi.com/2/files/list_folder/continue';
          parameters = {
            'cursor': cursor
          };
        }

        $log.info('getFolderContents POST data=' + JSON.stringify(parameters));
        var requestObj = {
          method: 'POST',
          url: url,
          headers: {
            'Authorization': vm.getBearerToken(),
            'Content-type': 'application/json'
          },
          data: parameters
        };

        $http(requestObj)
          .then(function (data) {
            pushFolderContentsOnToStagingArray(data.data, stagingArray);

            if (data.data.has_more && !vm.stopLoading) {
              $log.info('dropboxAPIService recursivelyGetFolders is repeating with count:' + data.data.entries.length + ' and cursor:' + data.data.cursor + ' and last entry:' + data.data.entries[data.data.entries.length - 1].path_lower);
              getFolderContents(recursionSetting, defer, node, data.data.cursor, stagingArray);
            } else {
              $log.info('dropboxAPIService recursivelyGetFolders is concluding flat stage for ' + (node ? node.path : 'root'));

              convertStagingArrayIntoTree(stagingArray, node);

              $log.info('dropboxAPIservice getFolderContents resolving with nodes=' + JSON.stringify(vm.nodes));
              defer.resolve(vm.nodes);
            }
          });
      }

      function pushFolderContentsOnToStagingArray(folderContents, stagingArray) {
        folderContents.entries.forEach(function (entry) {
          var mappedObject = createMappedObject(entry);
          stagingArray.push(mappedObject);
        });
      }

      function convertStagingArrayIntoTree(stagingArray) {
        // For the sort, put all folders above files, then sort alphabetically
        stagingArray.sort(function (a, b) {
          if (a.type === b.type) {
            return a.path < b.path ? -1 : 1;
          } else {
            return a.type > b.type ? -1 : 1;
          }
        });

        var currentNode = vm;
        var rollingParentPath;

        stagingArray.forEach(function (mappedObject) {
          var parentPath = mappedObject.path.split('/').slice(0, -1).join('/');
          $log.info('convertStagingArrayIntoTree path=' + mappedObject.path + ' and parent=' + parentPath);

          if (parentPath !== rollingParentPath) {
            rollingParentPath = parentPath;
            // We've hit a new path.
            currentNode = navigateToCorrectPath(mappedObject, currentNode, parentPath);
            $log.info('navigateToCorrectPath has set the currentNode to ' + currentNode.path + ' and isHydrated=' + currentNode.isHydrated);
          }

          var alreadyAdded = false;
          for (var i = 0; i < currentNode.nodes.length; i++) {
            if (currentNode.nodes[i].path === mappedObject.path) {
              alreadyAdded = true;
              break;
            }
          }

          if (!alreadyAdded) {
            currentNode.nodes.push(mappedObject);
            currentNode.isHydrated = true;
          }
        });

      }

      function navigateToCorrectPath(mappedObject, currentNode, parentPath) {
        if (currentNode.path === parentPath) {
          return currentNode;
        } else {
          var x = nodeTraverse(vm, mappedObject, parentPath);

          if (!x) {
            x = vm;
          }

          return x;
        }
      }

      function nodeTraverse(node, mappedObject, soughtPath) {
        if (node.nodes) {
          for (var i = 0; i < node.nodes.length; i++) {
            if (node.nodes[i].path === soughtPath) {
              return node.nodes[i];
            }

            var node2 = nodeTraverse(node.nodes[i], mappedObject, soughtPath);
            if (node2) {
              return node2;
            }
          }
        }
      }

      function createMappedObject(entry) {
        // Set basic properties
        var mappedObject = {
          'title': entry.name,
          'path': entry.path_lower,
          'display': entry.path_display,
          'type': entry['.tag'],
          'isShouldBeDisplayed': true
        };

        if (mappedObject.type === 'folder') {
          mappedObject.nodes = [];
        }

        // Lookup sharedLinks to see if the entry has been shared in dropbox
        if (vm.sharedLinks[entry.path_lower]) {
          mappedObject.isShared = true;
          mappedObject.shareInfo = vm.sharedLinks[entry.path_lower];
        }

        return mappedObject;
      }

      //YOU NEED TO CALL get_shared_links and build a lookup object keyed off the paths which will allow matching up as nav occurs  - you will just have to read all links at the start of the whole process, this is because DH could not find a 'path-based' get_shared_links call
      function getAllDropboxSharedLinks() {
        // This will read all shared links and hydrate a fast lookup structure so that subsequent folder unveiling can reference this structure and mark as shared accordingly.
        $log.info('INIT getAllDropboxSharedLinks()');
        var defer = $q.defer();
        recursivelyGetSharedLinks(defer);
        return defer.promise;
      }

      function recursivelyGetSharedLinks(defer, cursor) {

        var body = {};
        if (cursor) {
          body = {
            'cursor': cursor
          };
        }
        var requestObj = {
          method: 'POST',
          url: 'https://api.dropboxapi.com/2/sharing/list_shared_links',
          headers: {
            'Authorization': vm.getBearerToken(),
            'Content-type': 'application/json'
          },
          data: body
        };

        $http(requestObj)
          .then(function (data) {
            $log.info('recursivelyGetSharedLinks has ' + JSON.stringify(data));
            hydrateSharedLinks(data);
            if (data.data.has_more && data.data.cursor !== cursor && !vm.stopLoading) {
              recursivelyGetSharedLinks(defer, data.data.cursor);
            } else {
              defer.resolve({});
            }
          });
      }

      function hydrateSharedLinks(data) {
        $log.info('hydrateSharedLinks has data:' + JSON.stringify(data));
        data.data.links.forEach(function (link) {
          // We're only interested in shared file links because we can't seamlessly share files via shared folder links anyway, so they are useless to us.
          if (link['.tag'] === 'file') {
            vm.sharedLinks[link.path_lower] = {
              'url': link.url,
              'link_permissions': data.data.link_permissions
            };
          }
        });

        $log.info('hydrateSharedLinks = ' + JSON.stringify(vm.sharedLinks));
      }

      vm.switchAllNodes = function (select) {
        recurseSwitchAllNodes(vm.nodes, select);
      };

      function recurseSwitchAllNodes(nodes, select) {
        var i = 0;
        var len = nodes.length;

        for (i; i < len; i++) {
          if (nodes[i].type === 'folder' && nodes[i].nodes && nodes[i].nodes.length > 0) {
            recurseSwitchAllNodes(nodes[i].nodes, select);
          }
          nodes[i].isSelected = select;
        }
      }

      vm.shareNode = function (node) {
        setNodeShare(node, true);
      };

      vm.toggleShareForSelectedNodes = function (shareFlag) {
        var initialFileShareCount = Object.keys(vm.sharedLinks).length;

        recurseToggleShareForSelectedNodes(vm.nodes, shareFlag).then(function () {
          MessageService.showMessage((Object.keys(vm.sharedLinks).length - initialFileShareCount) + ' files have been shared');
        });
      };

      function recurseToggleShareForSelectedNodes(nodes, shareFlag) {
        var i = 0;
        var len = nodes.length;
        var pArr = [];

        for (i; i < len; i++) {
          if (!nodes[i].isSelected && nodes[i].type === 'folder' && nodes[i].nodes && nodes[i].nodes.length > 0) {
            pArr.push(recurseToggleShareForSelectedNodes(nodes[i].nodes, shareFlag));
          } else if (nodes[i].isSelected) {
            pArr.push(setNodeShare(nodes[i], shareFlag));
          }
        }

        return $q.all(pArr);
      }

      vm.unshareNode = function (node) {
        setNodeShare(node, false);
      };

      vm.toggleNodeExpansion = function (node, recurse) {
        if (node.isExpanded) {
          node.isExpanded = false;
        } else {
          this.expandOrShrinkNode(node, true, recurse);
        }
      };

      vm.expandOrShrinkNode = function (node, expand, recurse) {
        if (expand) {
          ensureNodeIsFullyHydrated(node, recurse)
            .then(function () {
              ensureNodeIsExpandedOrShrunk(node, expand, recurse);
            });
        } else {
          ensureNodeIsExpandedOrShrunk(node, expand, recurse);
        }
      };

      vm.refreshDisplay = function () {
        recurseRefreshNodes(vm.nodes);
        recalculateInternalStats();
      };

      function recurseRefreshNodes(nodes, parent) {
        var i = 0;
        var len = nodes.length;
        var displayedItems = 0;

        for (i; i < len; i++) {
          if (nodes[i].type === 'folder' && nodes[i].nodes && nodes[i].nodes.length > 0) {
            nodes[i].isShouldBeDisplayed = true;
            if (parent && parent.isSelected) {
              nodes[i].isSelected = true;
            }

            var childrenDisplayed = recurseRefreshNodes(nodes[i].nodes, nodes[i]);

            if (childrenDisplayed === 0) {
              nodes[i].isSelected = false;
              nodes[i].isShouldBeDisplayed = false;
            } else {
              displayedItems++;
            }
          } else {
            nodes[i].isShouldBeDisplayed = true;
            if (parent && parent.isSelected) {
              nodes[i].isSelected = true;
            }

            if (nodes[i].isShared && vm.hideShared) {
              nodes[i].isShouldBeDisplayed = false;
              nodes[i].isSelected = false;
            }
            if (!nodes[i].isShared && vm.hideUnshared) {
              nodes[i].isShouldBeDisplayed = false;
              nodes[i].isSelected = false;
            }

            if (nodes[i].isShouldBeDisplayed) {
              displayedItems++;
            }
          }
        }
        return displayedItems;
      }

      vm.toggleExpandSelectedNodes = function (expand) {
        recurseToggleExpandSelectedNodes(vm.nodes, expand);
      };

      function recurseToggleExpandSelectedNodes(nodes, expand) {
        var i = 0;
        var len = nodes.length;

        for (i; i < len; i++) {
          if (nodes[i].type === 'folder') {
            if (nodes[i].nodes && nodes[i].nodes.length > 0 && !nodes[i].isSelected) {
              recurseToggleExpandSelectedNodes(nodes[i].nodes, expand);
            } else if (nodes[i].isSelected) {
              vm.expandOrShrinkNode(nodes[i], expand, true);
            }
          }
        }
      }

      vm.propagateNodeSelectionState = function (node) {
        if (node.isSelected) {
          var recurseTrue = true;
          ensureNodeIsFullyHydrated(node, recurseTrue)
            .then(function () {
              var selectedTrue = true;
              ensureAllChildrenAreSelected(node, selectedTrue);
              recalculateInternalStats();
            });
        } else {
          var selectedFalse = false;
          ensureAllChildrenAreSelected(node, selectedFalse);
          recalculateInternalStats();
        }
      };

      vm.getCurrentlySelectedFilesAsExportPackage = function () {
        var importPackageArray = [];
        vm.nodes.forEach(function (node) {
          addNodesToExportPackage(node, importPackageArray);
        });
        return importPackageArray;
      };

      function addNodesToExportPackage(node, importPackageArray) {
        if (node.isSelected && node.type === 'file' && node.shareInfo) {
          var fileAsExportPackageItem = createExportPackageItemFromFileNode(node);
          importPackageArray.push(fileAsExportPackageItem);
        }

        if (node.nodes) {
          for (var i = 0; i < node.nodes.length; i++) {
            addNodesToExportPackage(node.nodes[i], importPackageArray);
          }
        }
      }

      function createExportPackageItemFromFileNode(node) {
        var ix = node.title.lastIndexOf('.');
        var fileType = node.title.substring(ix + 1, ix + 4).toLowerCase();
        var contenttype;

        switch (fileType) {
          case 'pdf':
            contenttype = 'application/pdf';
            break;
          case 'mp4':
            contenttype = 'application/mp4';
            break;
          case 'mov':
            contenttype = 'application/mov';
            break;
          case 'jpg':
            contenttype = 'image/jpg';
            break;
          case 'png':
            contenttype = 'image/png';
            break;

        }
        $log.info(node);
        var tweakedUrl = createValidDropboxInlineAttachmentLink(node.shareInfo.url, fileType);

        var item = {
          'title': node.title,
          'url': tweakedUrl,
          'isSelected': true,
          'contenttype': contenttype || 'unknown',
          'dropboxPath': node.path // add the path so we can grab bits and pieces for the item from the DropboxAPI in future (thumbs/previews etc)
        };

        generateTagInfoForItemWithNode(item, node);
        return item;
      }

      function generateTagInfoForItemWithNode(item, node) {
        if (node.display) {
          var arrayOfParts = node.display.split('/');
          if (arrayOfParts.length > 3) {
            item.category = arrayOfParts[arrayOfParts.length - 3];
            item.tag = arrayOfParts[arrayOfParts.length - 2];
          }
        }
      }

      function createValidDropboxInlineAttachmentLink(url, fileType) {
        // We need to generate something like this: https://www.dropbox.com/s/nh1s90u38cs4uaw/AMT813%20Sell%20Sheet%281%29.pdf?raw=1&forcetype=pdf

        // raw=1 will force the attachment to be someting like this: content-disposition →inline; filename="AMT813 Sell Sheet(1).pdf"; filename*=UTF-8''AMT813%20Sell%20Sheet%281%29.pdf
        // forcetype=pdf will allow the Zuant iOS app to use the last three chars as the content-type
        return url.replace('dl=0', 'raw=1') + '&forcetype=' + fileType;
      }

      function recalculateInternalStats() {
        var ref = {
          'countOfSelectedFiles': 0,
          countOfSelectedFilesWithPublicLink: 0
        }; // We need to pass an object anyway, because a primitive value won't be passed by reference
        for (var i = 0; i < vm.nodes.length; i++) {
          recalculateInternalStatsRecurse(vm.nodes[i], ref);
        }

        Object.getOwnPropertyNames(ref).forEach(function (key) {
          vm.stats[key] = ref[key];
        });

        if (vm.stats.countOfSelectedFilesWithPublicLink > 0) {
          if (vm.stats.countOfSelectedFilesWithPublicLink === 1) {
            vm.stats.addShowroomPhrase = 'Add 1 item to Showroom';
          } else {
            vm.stats.addShowroomPhrase = 'Add ' + vm.stats.countOfSelectedFilesWithPublicLink + ' items to Showroom';
          }
        } else {
          vm.stats.addShowroomPhrase = 'Select a file to add';
        }

        if (vm.stats.countOfSelectedFiles !== vm.stats.countOfSelectedFilesWithPublicLink) {
          vm.stats.fileSelectionInfo = (vm.stats.countOfSelectedFiles - vm.stats.countOfSelectedFilesWithPublicLink) + ' files are not shared but are selected';
        } else {
          vm.stats.fileSelectionInfo = '';
        }
      }

      function recalculateInternalStatsRecurse(node, ref) {
        if (node.isSelected && node.type === 'file') {
          ref.countOfSelectedFiles++;
          if (!!node.shareInfo && !!node.shareInfo.url) {
            ref.countOfSelectedFilesWithPublicLink++;
          }
        }
        if (node.nodes) {
          for (var i = 0; i < node.nodes.length; i++) {
            recalculateInternalStatsRecurse(node.nodes[i], ref);
          }
        }
      }

      function setNodeShare(node, shouldBeShared) {
        var defer = $q.defer();
        if (node.type === 'folder') {
          $log.info('shareNode will share folder node:' + node.title);
          var recurseTrue = true;
          ensureNodeIsFullyHydrated(node, recurseTrue)
            .then(function (rc) {
              $log.info('shareNode ensureNodeIsFullyExpanded has ' + JSON.stringify(rc));
              ensureAllFilesAreShared(node, shouldBeShared)
                .then(function (rc) {
                  $log.info('shareNode ensureAllFilesAreShared has ' + JSON.stringify(rc));
                  recalculateInternalStats();
                  defer.resolve();
                });
            });
        } else {
          $log.info('shareNode will share file node:' + node.title);
          ensureFileIsShared(node, shouldBeShared)
            .then(function (rc) {
              $log.info('shareNode file share has ' + JSON.stringify(rc));
              recalculateInternalStats();
              defer.resolve();
            });
        }
        return defer.promise;
      }

      function ensureNodeIsFullyHydrated(node, recurse) {
        // So, we need to ensure the node is fully expanded, but this means recursively.
        var defer = $q.defer();
        if (node.type === 'folder') {
          if (node.isHydrated) {
            var arrayOfPromises = [];

            node.nodes.forEach(function (childNode) {
              arrayOfPromises.push(ensureNodeIsFullyHydrated(childNode, recurse));
            });

            $q.all(arrayOfPromises)
              .then(function () {
                defer.resolve({
                  'scilla': 'is looking with node:' + node.title
                });
              });
          } else {
            getFolderContents(recurse, defer, node);
          }
        } else {
          defer.resolve({});
        }
        return defer.promise;
      }

      function ensureNodeIsExpandedOrShrunk(node, expand, recurse) {
        node.isExpanded = expand;

        if (recurse && node.nodes) {
          for (var i = 0; i < node.nodes.length; i++) {
            ensureNodeIsExpandedOrShrunk(node.nodes[i], expand, recurse);
          }
        }
      }

      function ensureAllChildrenAreSelected(node, selectedState) {
        if (node.isShouldBeDisplayed) {
          node.isSelected = selectedState;
          if (node.nodes) {
            for (var i = 0; i < node.nodes.length; i++) {
              ensureAllChildrenAreSelected(node.nodes[i], selectedState);
            }
          }
        }
      }

      function ensureAllFilesAreShared(node, shouldBeShared) {
        var defer = $q.defer();
        if (node.type === 'folder' && node.nodes) {
          var arrayOfPromises = [];

          node.nodes.forEach(function (childNode) {
            if (childNode.type === 'folder') {
              arrayOfPromises.push(ensureAllFilesAreShared(childNode, shouldBeShared));
            } else {
              // Share this file node
              if ((shouldBeShared && !childNode.isShared) || !shouldBeShared && childNode.isShared) {
                arrayOfPromises.push(ensureFileIsShared(childNode, shouldBeShared));
              }
            }
          });

          $q.all(arrayOfPromises).then(function () {
            $log.info('dropboxAPIService ensureAllFilesAreShared now resolving with node:' + node.title);
            defer.resolve();
          });
        } else {
          defer.resolve(vm);
        }
        return defer.promise;
      }

      vm.ensureFileIsShared = ensureFileIsShared;

      function ensureFileIsShared(node, shouldBeShared) {
        $log.info('dropboxAPIService.ensureFileIsShared starting for ' + JSON.stringify(node));

        var defer = $q.defer();

        var url = 'https://api.dropboxapi.com/2/sharing/create_shared_link_with_settings';
        var body = {
          'path': node.path
        };

        if (shouldBeShared === false) {
          url = 'https://api.dropboxapi.com/2/sharing/revoke_shared_link';
          body = {
            'url': node.shareInfo.url
          };
        }

        $log.info('share/unshare body=' + JSON.stringify(body) + ', and url=' + url);
        var requestObj = {
          method: 'POST',
          url: url,
          headers: {
            'Authorization': vm.getBearerToken(),
            'Content-type': 'application/json'
          },
          data: body
        };

        $http(requestObj)
          .then(function (data) {
            $log.info('ensureFileIsShared (' + shouldBeShared + ') has ' + JSON.stringify(data));

            node.isShared = shouldBeShared;
            node.shareInfo = shouldBeShared ? {
              'url': data.data.url,
              'link_permissions': data.data.link_permissions
            } : {};

            if (shouldBeShared) {
              vm.sharedLinks[node.path] = node.shareInfo;
            } else {
              delete vm.sharedLinks[node.path];
            }

            defer.resolve(data);
          })
          .catch(function (err) {
            $log.info(err);
            if (err.data.error['.tag'] === 'email_not_verified') {
              MessageService.showMessageWithAction('Dropbox email is not verified', 'Please check your Dropbox account settings and verify the email address.');
            }
            defer.reject({
              message: err.data.error['.tag']
            });
          });

        return defer.promise;
      }

      vm.getCurrentAccount = function (token) {
        var defer = $q.defer();
        var requestObj = {
          method: 'POST',
          url: 'https://api.dropboxapi.com/2/users/get_current_account',
          headers: {
            'Authorization': (token && token.length > 0) ? 'Bearer ' + token : vm.getBearerToken(),
            'Content-type': 'application/json'
          }
        };

        $http(requestObj)
          .then(function (data) {
            $log.info('dropboxAPIService.getCurrentAccount has data=' + JSON.stringify(data));
            defer.resolve(data);
          })
          .catch(function (error){
            vm.clearBearerToken();
            defer.reject(error);
          });

        return defer.promise;
      };

      vm.setFoldersPosition = function () {
        var defer = $q.defer();

        vm.arrayOfDropboxFolders = [];
        var requestObj = {
          method: 'POST',
          url: 'https://api.dropboxapi.com/2/files/list_folder',
          headers: {
            'Authorization': vm.getBearerToken(),
            'Content-type': 'application/json'
          },
          data: {
            'path': ''
          }
        };

        $http(requestObj)
          .then(function (data) {
            $log.info('dropboxAPIService.setFoldersPosition has data=' + JSON.stringify(data));

            vm.arrayOfDropboxFolders = data.data.entries.map(function (entry) {
              return {
                'title': entry.name
              };
            });

            defer.resolve({});
          });
        return defer.promise;
      };

      vm.resetNodes = function () {
        vm.nodes = [];
      };

      return vm;
    }]);
})();

/**
 * Created by davidhickson on 08/06/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').factory('tagsManager', tagsManager);

  tagsManager.$inject = [
    'APIService',
    '$log',
    '$q',
    'tagsModel',
    'createDeltaFromAddTag',
    'createDeltaFromTagCategoryTitleChange',
    'createNewTagCategory',
    'ingestArrayOfTagDeltas',
    'createDeltaFromDeleteTag',
    'createDeltaFromTagCaptionChange',
    'createDeltaFromTagReordering',
    'createDeltaFromTagCategoryReordering',
    'toggleTagSelectionState',
    'ingestTagCategoryArchiveDelta'
  ];

  function tagsManager(
    api,
    $log,
    $q,
    model,
    createDeltaFromAddTag,
    createDeltaFromTagCategoryTitleChange,
    createNewTagCategory,
    ingestArrayOfTagDeltas,
    createDeltaFromDeleteTag,
    createDeltaFromTagCaptionChange,
    createDeltaFromTagReordering,
    createDeltaFromTagCategoryReordering,
    toggleTagSelectionState,
    ingestTagCategoryArchiveDelta
  ) {

    var factoryData = {
      tagSelectedCount: 0
    };

    var hydrateOrRefresh = function () {
      var defer = $q.defer();

      api.get('showroom/tags/')
        .then(function (response) {
          model.replaceEntireTagCategoriesArrayWith(response.data.data);

          $log.info('TagsManager.hydrateOrRefresh has data, model.tagCategories logged below');
          $log.info(model.tagCategories);
          defer.resolve();
        }, function (err) {
          $log.error('TagsManager.hydrateOrRefresh nasty');
          $log.error(err);
          defer.reject();
        });

      return defer.promise;
    };

    var tagTitle = function (tagId) {
      return model.tagTitle(tagId);
    };

    var tagTitleWithCategory = function (tagId) {
      return model.tagTitleWithCategory(tagId);
    };

    var toggleTag = function (toggledTag) {
      $log.info('TagsManager toggleTag starting');
      var arrayReflectingToggledTag = toggleTagSelectionState(model.tagCategories, toggledTag);
      model.replaceEntireTagCategoriesArrayWith(arrayReflectingToggledTag);
    };

    var addTagCategory = function (newTagCategoryTitle) {
      var newTagCategory = createNewTagCategory(newTagCategoryTitle, model);

      api.post('showroom/tags/many', [newTagCategory])
        .then(
          function () {
            ingestArrayOfTagDeltas(model.tagCategories, [newTagCategory]);
          },
          function () {});
    };

    var applyTagCategoryTitleChange = function (tagcategory, newTitle) {

      var singleDelta = createDeltaFromTagCategoryTitleChange(tagcategory, newTitle);
      api.post('showroom/tags/many', [singleDelta])
        .then(
          function () {
            ingestArrayOfTagDeltas(model.tagCategories, [singleDelta]);
          },
          function () {});
    };

    var addTagToCategory = function (tagCategory, newTagTitle) {

      var defer = $q.defer();

      var singleDelta = createDeltaFromAddTag(tagCategory, newTagTitle);
      api.post('showroom/tags/many', [singleDelta])
        .then(
          function () {
            ingestArrayOfTagDeltas(model.tagCategories, [singleDelta]);
            defer.resolve();
          },
          function () {
            defer.reject();
          });

      return defer.promise;
    };

    var deleteTag = function (tagToDelete, tagCategory) {
      var defer = $q.defer();

      var singleDelta = createDeltaFromDeleteTag(tagToDelete, tagCategory);
      api.post('showroom/tags/many', [singleDelta])
        .then(
          function () {
            ingestArrayOfTagDeltas(model.tagCategories, [singleDelta]);
            defer.resolve();
          },
          function () {
            defer.reject();
          });

      return defer.promise;
    };

    var applyTagCaptionChange = function (tag, newTagTitle, tagcategory) {
      var defer = $q.defer();

      var singleDelta = createDeltaFromTagCaptionChange(tag, newTagTitle, tagcategory);
      api.post('showroom/tags/many', [singleDelta])
        .then(
          function () {
            ingestArrayOfTagDeltas(model.tagCategories, [singleDelta]);
            defer.resolve();
          },
          function () {
            defer.reject();
          });

      return defer.promise;
    };

    var deselectAllTagBlockTags = function () {
      model.tagCategories.forEach(function (tagCategory) {
        tagCategory.tags.forEach(function (tag) {
          tag.isSelected = false;
        });
      });
      model.updateStats();
    };

    var tagWasDragDropped = function (idOfSourceCategory, idOfTargetCategory, sourceIndex, dropIndex) {
      var defer = $q.defer();
      var arrayOfDeltas = createDeltaFromTagReordering(model.tagCategories, idOfSourceCategory, idOfTargetCategory, sourceIndex, dropIndex);

      // Naughty to be updating the model before the database update, but otherwise the delay makes the drag-drop seem very sluggish.
      ingestArrayOfTagDeltas(model.tagCategories, arrayOfDeltas);

      api.post('showroom/tags/many', arrayOfDeltas)
        .then(
          function () {
            //ingestArrayOfTagDeltas(model.tagCategories,arrayOfDeltas);
            defer.resolve();

          },
          function () {
            defer.reject();
          });

      return defer.promise;
    };

    var tagCategoryWasDragDropped = function (startIndex, dropIndex) {
      var defer = $q.defer();
      var arrayOfDeltas = createDeltaFromTagCategoryReordering(model.tagCategories, startIndex, dropIndex);

      // Naughty to be updating the model before the database update, but otherwise the delay makes the drag-drop seem very sluggish.
      ingestArrayOfTagDeltas(model.tagCategories, arrayOfDeltas);

      api.post('showroom/tags/many', arrayOfDeltas)
        .then(
          function () {
            //ingestArrayOfTagDeltas(model.tagCategories,arrayOfDeltas);
            defer.resolve();
          },
          function () {
            defer.reject();
          });

      return defer.promise;
    };

    var archiveTagCategory = function (tagCategory) {
      var arrayOfItemsToArchive = [{
        _id: tagCategory._id
      }];
      return api.post('showroom/tags/removeMany', arrayOfItemsToArchive)
        .then(function () {
          ingestTagCategoryArchiveDelta(model.tagCategories, arrayOfItemsToArchive);
        });
    };

    return {
      tagCategories: model.tagCategories,
      stats: model.stats,
      hydrateOrRefresh: hydrateOrRefresh,
      toggleTag: toggleTag,
      addTagCategory: addTagCategory,
      applyTagCategoryTitleChange: applyTagCategoryTitleChange,
      addTagToCategory: addTagToCategory,
      deleteTag: deleteTag,
      applyTagCaptionChange: applyTagCaptionChange,
      tagTitle: tagTitle,
      tagTitleWithCategory: tagTitleWithCategory,
      deselectAllTagBlockTags: deselectAllTagBlockTags,
      tagWasDragDropped: tagWasDragDropped,
      tagCategoryWasDragDropped: tagCategoryWasDragDropped,
      archiveTagCategory: archiveTagCategory,
      factoryData: factoryData
    };
  }
}());

(function () {
  'use strict';
  angular.module('showroom').factory('literatureXrefTagsManager', literatureXrefTagsManager);

  literatureXrefTagsManager.$inject = [
    'literatureManager',
    'APIService',
    'literatureTagFilter',
    'assertTagReferencedByLiteratureItem',
    'deselectLiteratureTags',
    'createDeltasFromDeselectedItems',
    'createDeltasFromSelectedItems',
    'ingestArrayOfTagXrefLiteratureDeltas',
    'tagsModel',
    'literatureModel',
    '$log'
  ];

  function literatureXrefTagsManager(
    literatureManager,
    api,
    literatureTagFilter,
    assertTagReferencedByLiteratureItem,
    deselectLiteratureTags,
    createDeltasFromDeselectedItems,
    createDeltasFromSelectedItems,
    ingestArrayOfTagXrefLiteratureDeltas,
    tagsModel,
    literatureModel,
    $log) {

    var applySelectedTagsToSelectedLiterature = function () {

      var changeDelta = createDeltasFromSelectedItems(tagsModel.tagCategories, literatureModel.literatureItems); // PURE

      api.post('showroom/literature/many', changeDelta)
        .then(function () {
          ingestArrayOfTagXrefLiteratureDeltas(literatureModel.literatureItems, changeDelta);
        }, function () {
          // Don't apply the change to the model because the persist did not work
        });

    };

    var removeSelectedTagsFromLiterature = function () {

      $log.info('literature.xref.tags/manager removeSelectedTagsFromLiterature HERE');

      var changeDelta = createDeltasFromDeselectedItems(literatureModel.literatureItems); // PURE

      api.post('showroom/literature/many', changeDelta)
        .then(function () {
          ingestArrayOfTagXrefLiteratureDeltas(literatureModel.literatureItems, changeDelta);
          literatureModel.requestLitStatsUpdate();
        }, function () {
          // Don't apply the change to the model because the persist did not work
        });

    };

    var deselectAllLiteratureTags = function () {
      deselectLiteratureTags(literatureModel.literatureItems);
      literatureModel.requestLitStatsUpdate();
    };

    var assertTagIsBeingReferencedByAtLeastOneLiteratureItem = function (tag) {
      return assertTagReferencedByLiteratureItem(literatureModel, tag);
    };

    var toggleFilterTagSelection = function (tag) {
      literatureTagFilter.toggleTagInFilter(tag);
      literatureManager.triggerDisplayRefresh();
    };

    var isTagSelected = function (tag) {
      return literatureTagFilter.isTagSelected(tag);
    };

    var deselectAllTagsExcept = function (exceptTag) {
      for (var tag in literatureTagFilter.tags) {
        if (exceptTag._id !== tag) {
          delete literatureTagFilter.tags[tag];
        }
      }
      literatureManager.triggerDisplayRefresh();
    };

    return {
      deselectAllTagsExcept: deselectAllTagsExcept,
      applySelectedTagsToSelectedLiterature: applySelectedTagsToSelectedLiterature,
      removeSelectedTagsFromLiterature: removeSelectedTagsFromLiterature,
      deselectAllLiteratureTags: deselectAllLiteratureTags,
      assertTagIsBeingReferencedByAtLeastOneLiteratureItem: assertTagIsBeingReferencedByAtLeastOneLiteratureItem,
      toggleFilterTagSelection: toggleFilterTagSelection,
      isTagSelected: isTagSelected,
      tags: literatureTagFilter.tags
    };
  }
}());

/**
 * Created by davidbeazer on 23/02/2017.
 */
(function () {
  'use strict';

  angular
    .module('showroom')
    .factory('LiteratureMetadataFactory', LiteratureMetadataFactory);

  LiteratureMetadataFactory.$inject = [];

  function LiteratureMetadataFactory() {

    var factoryData = {};
    buildFactory();

    return {
      getData: getData
    };

    function getData() {
      return factoryData;
    }

    // PRIVATE

    function buildFactory() {

      factoryData = {
        id: 'literature_list',
        title: {
          label: 'Literature',
          filterLabel: 'Search literature items'
        },
        // columnsData: buildColumnsData(),
        // query: {
        //   order: {
        //     id: 'user.surname',
        //     expression: 'user.surname.raw'
        //   },
        //   limit: localStorage.get('user_list') || 50,
        //   page: 1
        // },
        // paginationOptions: {
        //   boundaryLinks: true,
        //   limitSelect: true,
        //   pageSelect: true,
        //   pagination: true,
        //   limitOptions: [5, 10, 20, 50, 75, 100],
        //   limit: localStorage.get('user_list') || 50,
        //   page: 1
        // },
        // gridOptions: {
        //   rowSelection: false,
        //   multiSelect: false,
        //   sortable: true,
        //   interactive: false
        // },
        fabDialogConfig: {
          description: 'New literature item',
          controller: 'AddLiteratureDialogController as vm',
          templateUrl: 'app/showroom/literature/add-or-edit-literature/dialog/add-literature-dialog.tmpl.html',
          locals: {
            litDoc: {
              // _id: null, << server creates that
              title: '',
              weburi: '',
              keywordsAsSingleString: '',
              allowAddToBasket: 1
            }
          },
          ariaLabel: 'Create new literature'
        }
      };
    }
  }
})();

/**
 * Created by davidhickson on 08/06/2017.
 */

(function () {
  'use strict';
  angular
    .module('showroom')
    .factory('literatureManager', literatureManager);

  literatureManager.$inject = [
    'APIService',
    '$q',
    '$log',
    'literatureModel',
    'literatureTagFilter',
    'stampViewAttributes',
    'stampTagInfo',
    'stampDropboxThumbs',
    'toggleLitItemSelectionState',
    'toggleLitItemTagSelectionState',
    'createDeltasFromLiteratureItems',
    'ingestArrayOfDeltas',
    'getSelectedLiteratureIds',
    'ingestArchiveDelta',
    'getLitIdsSatisfyingDisplayFilters',
    'MessageService'
  ];

  function literatureManager(
    api,
    $q,
    $log,
    model,
    literatureTagFilter,
    stampViewAttributes,
    stampTagInfo,
    stampDropboxThumbs,
    toggleLitItemSelectionState,
    toggleLitItemTagSelectionState,
    createDeltasFromLiteratureItems,
    ingestArrayOfDeltas,
    getSelectedLiteratureIds,
    ingestArchiveDelta,
    getLitIdsSatisfyingDisplayFilters,
    MessageService
  ) {

    var shouldTagFilterBeDisplayed = false;
    var treeInLitMode = true;
    var factoryData = {
      emptyState: undefined,
      inCardView: false,
      litTagSelectedCount: 0
    };

    var hydrateOrRefresh = function () {
      var defer = $q.defer();

      api.get('showroom/literature/')
        .then(function (response) {
          var arrayEmbellishedWithViewAttributes = stampViewAttributes(response.data.data);
          var arrayEmbellishedWithTagInfo = stampTagInfo(arrayEmbellishedWithViewAttributes);
          // var arrayEmbellishedWithThumnailImages = stampDropboxThumbs(arrayEmbellishedWithTagInfo); // TODO finish

          model.replaceEntireLiteratureItemsArrayWith(arrayEmbellishedWithTagInfo);

          // Used to apply filters to list
          triggerDisplayRefresh();

          factoryData.emptyState = !model.literatureItems.length; // at this point we will know if there's 0 lit items or not as we've made a server trip to check

          $log.info('LiteratureManager.hydrateFromCloud has data, model.literatureItems logged below');
          $log.info(model.literatureItems);
          defer.resolve(model.literatureItems);
        }, function (err) {
          $log.error('LiteratureManager.hydrateFromCloud nasty');
          $log.error(err);
          defer.reject();
        });

      return defer.promise;
    };

    var toggleItemSelection = function (toggledlitItem) {
      var arrayReflectingToggledItem = toggleLitItemSelectionState(model.literatureItems, toggledlitItem);
      model.replaceEntireLiteratureItemsArrayWith(arrayReflectingToggledItem);
    };

    var tagWasToggledForLitItem = function (toggledTag, toggledLitItem) {
      var arrayReflectingToggledTag = toggleLitItemTagSelectionState(model.literatureItems, toggledLitItem, toggledTag);
      model.replaceEntireLiteratureItemsArrayWith(arrayReflectingToggledTag);
    };

    var requestLitStatsUpdate = function () {
      model.requestLitStatsUpdate();
    };

    var ingestChangedLiteratureItem = function (inboundLiteratureItem) {
      var changeDeltas = createDeltasFromLiteratureItems(model.literatureItems, [inboundLiteratureItem]);

      $log.info('literatureManager.ingestChangedLiteratureItem has changeDeltas:%s', changeDeltas);
      return api.post('showroom/literature/many', changeDeltas)
        .then(function () {
          ingestArrayOfDeltas(model.literatureItems, changeDeltas);
          triggerDisplayRefresh();
          model.requestLitStatsUpdate();
        });
    };

    var archiveSelectedLiterature = function () {

      $log.info('literatureManager archiveSelectedLiterature archive lit');

      var arrayOfItemsToArchive = getSelectedLiteratureIds(model.literatureItems);
      var countOfArchivedItems = arrayOfItemsToArchive.length;
      var arrayOfItemsToArchiveCopy = arrayOfItemsToArchive.slice();

      if (arrayOfItemsToArchive.length > 0) {

        var arrays = [];
        if (arrayOfItemsToArchive.length > 1000) {
          while (arrayOfItemsToArchive.length > 1000) {
            arrays.push(arrayOfItemsToArchive.splice(0, 1000));
          }
        }
        arrays.push(arrayOfItemsToArchive);

        var pArr = [];
        var i = 0;
        var len = arrays.length;

        for (i; i < len; i++) {
          pArr.push(api.post('showroom/literature/removeMany', arrays[i]));
        }

        $q.all(pArr)
          .then(function (res) {
            $log.info('removeSelectedLiterature returned from postDeleteFilePackageToServer with ' + JSON.stringify(res));
            MessageService.showMessage(countOfArchivedItems + ' items have been removed');
            ingestArchiveDelta(model.literatureItems, arrayOfItemsToArchiveCopy);

            model.requestLitStatsUpdate();
          }, function (err) {
            $log.error('removeSelectedLiterature returned NASTY from postDeleteFilePackageToServer with ' + JSON.stringify(err));
          });
      }
    };

    var literatureTextSearchTermChanged = function (searchtext) {
      model.currentSearchTerm = searchtext;
      triggerDisplayRefresh();
    };

    var selectAllVisibleLit = function () {
      model.literatureItems.forEach(function (literatureItem) {
        if (literatureItem.isShouldBeDisplayed) {
          literatureItem.selected = true;
        }
      });
      model.requestLitStatsUpdate();
    };

    var deselectAllLit = function () {
      model.literatureItems.forEach(function (literatureItem) {
        literatureItem.selected = false;
      });
      model.requestLitStatsUpdate();
    };

    var invertCurrentLitSelection = function () {
      model.literatureItems.forEach(function (literatureItem) {
        if (literatureItem.isShouldBeDisplayed) {
          literatureItem.selected = !literatureItem.selected;
        }
      });
      model.requestLitStatsUpdate();
    };

    var triggerDisplayRefresh = function (block) {
      var litIdDisplayObject = getLitIdsSatisfyingDisplayFilters(model.literatureItems, literatureTagFilter.tags, model.currentSearchTerm, block);
      model.adjustDisplayedItems(litIdDisplayObject);
    };

    return {
      factoryData: factoryData,
      literatureItems: model.literatureItems,
      stats: model.stats,
      treeInLitMode: treeInLitMode,
      hydrateOrRefresh: hydrateOrRefresh,
      ingestChangedLiteratureItem: ingestChangedLiteratureItem,
      archiveSelectedLiterature: archiveSelectedLiterature,
      toggleItemSelection: toggleItemSelection,
      tagWasToggledForLitItem: tagWasToggledForLitItem,
      requestLitStatsUpdate: requestLitStatsUpdate,
      triggerDisplayRefresh: triggerDisplayRefresh,
      literatureTextSearchTermChanged: literatureTextSearchTermChanged,
      selectAllVisibleLit: selectAllVisibleLit,
      deselectAllLit: deselectAllLit,
      invertCurrentLitSelection: invertCurrentLitSelection,
      shouldTagFilterBeDisplayed: shouldTagFilterBeDisplayed
    };
  }
})();

/**
 * Created by davidhickson on 25/01/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('zpShowroomFab', {
      templateUrl: 'app/showroom/layouts/zp-showroom-fab.tmpl.html',
      controller: function () {

      },
      bindings: {}
    });
})();

/**
 * Created by davidhickson on 16/01/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('showroomView', {
      templateUrl: 'app/showroom/layouts/showroom-view.tmpl.html',
      controller: function () {

      },
      bindings: {}
    });
})();
/**
 * Created by davidhickson on 02/03/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .factory('fileImportService', ['$q', '$log', 'tagsManager', 'tagAnalyserService', 'literatureHelperService', 'literatureIngestorService', 'literatureModel', function ($q, $log, tagsManager, tagAnalyserService, literatureHelperService, literatureIngestorService, literatureModel) {

      var vm = this;

      vm.isFileLoaded = false;
      vm.meta = {}; // Will become e.g.  {"title":{"index":2,"originalHeader":"Title"}}
      vm.arrayOfItems = []; // [{"title":"Brochure One"},{"title":"Brochure One"},{"title":"Brochure Two"},{"title":"Brochure Three"},{"title":"Brochure Four"}]
      vm.isEssentialHeadersArePresent = false;
      vm.isTagHeadersExistedInImportFile = false;
      vm.isTagsShouldBeLinked = false;
      vm.isNewTagsShouldBeCreatedIfNecessary = false;
      vm.isBlocksShouldBeCreated = false;

      vm.stats = {
        'countOfSelectedItemsPhrase': 'Please select a file to import'
      };

      vm.hydrateWithCSVObject = function (CSVObject) {
        $log.info('fileImportService hydrateWithCSVObject literatureModel visibility test: lit count=' + literatureModel.literatureItems.length);
        hydrateInternalStructuresWithInboundObject(CSVObject);
      };

      function hydrateInternalStructuresWithInboundObject(CSVObject) {
        hydrateHeadersWithInboundObject(CSVObject);

        if (vm.isEssentialHeadersArePresent) {
          hydrateRowsWithInboundObject(CSVObject);
        } else {
          vm.arrayOfItems = [];
        }

        updateStats();
        vm.isFileLoaded = true;
      }

      function hydrateHeadersWithInboundObject(CSVObject) {
        vm.meta = {}; // Reset meta
        var arrayOfColumnHeaders = CSVObject.data[0];
        var arrayOfExpressions = ['title', 'url', 'category', 'tag'];

        arrayOfColumnHeaders.forEach(function (possibleHeader, index) {
          arrayOfExpressions.forEach(function (expression) {
            if (possibleHeader.toLowerCase() === expression) {
              vm.meta[expression] = {
                'index': index,
                'originalHeader': possibleHeader
              };
            }
          });
        });

        vm.isEssentialHeadersArePresent = (vm.meta.title && vm.meta.url);
        vm.isTagHeadersExistedInImportFile = (vm.meta.category && vm.meta.tag);
        vm.isTagsShouldBeLinked = vm.isTagHeadersExistedInImportFile;
        vm.isNewTagsShouldBeCreatedIfNecessary = vm.isTagHeadersExistedInImportFile;
      }

      function hydrateRowsWithInboundObject(CSVObject) {
        vm.arrayOfItems = [];

        for (var i = 1; i < CSVObject.data.length; i++) {
          if (CSVObject.data[i].length > 2 && CSVObject.data[i][vm.meta.title.index].length > 0) {
            var newEntry = {
              'title': CSVObject.data[i][vm.meta.title.index],
              'url': CSVObject.data[i][vm.meta.url.index]
            };

            if (vm.isTagHeadersExistedInImportFile) {
              newEntry.category = cleanTagCaption(CSVObject.data[i][vm.meta.category.index]);
              newEntry.tag = cleanTagCaption(CSVObject.data[i][vm.meta.tag.index]);
            }

            newEntry.isSelected = true;

            if (newEntry.url && newEntry.url !== '') {
              vm.arrayOfItems.push(newEntry);
            }
          }
        }
      }

      function cleanTagCaption(originalCaption) {
        return originalCaption.replace('\'', '');
      }

      function updateStats() {
        var countOfSeletedItems = 0;

        vm.arrayOfItems.forEach(function (item) {
          if (item.isSelected) {
            countOfSeletedItems++;
          }
        });

        vm.stats = {};
        vm.stats.countOfSelectedItems = countOfSeletedItems;
        vm.stats.countOfSelectedItemsPhrase = 'Count of selected items = ' + countOfSeletedItems;

        if (countOfSeletedItems == 0) vm.stats.importItemsButtonCaption = 'Import';
        else if (countOfSeletedItems == 1) vm.stats.importItemsButtonCaption = 'Import 1 Item';
        else vm.stats.importItemsButtonCaption = 'Import ' + countOfSeletedItems + ' Items';

        determineNewTagRequirement();
      }

      function determineNewTagRequirement() {
        var tasRC = tagAnalyserService.determineRequiredTags(vm.arrayOfItems, tagsManager.tagCategories);

        vm.arrayOfCategoriesWhichAreMissingFromTagLibrary = tasRC.arrayOfCategoriesWhichAreMissingFromTagLibrary;
        vm.arrayOfTagsWhichAreMissingFromTagLibrary = tasRC.arrayOfTagsWhichAreMissingFromTagLibrary;
      }

      vm.toggleImportListItemSelection = function (item) {
        item.isSelected = !item.isSelected;
        updateStats();
      };

      vm.requestListStatsUpdate = function () {
        updateStats();
      };

      vm.importSelectedItemsToLiteratureLibrary = function () {
        $log.info('fileImportService importSelectedItemsToLiteratureLibrary here');

        var arrayOfSelectedItems = vm.arrayOfItems.filter(function (item) {
          return !!item.isSelected;
        });

        literatureIngestorService.importLiteratureViaImportedList(arrayOfSelectedItems, vm.isTagsShouldBeLinked, vm.isNewTagsShouldBeCreatedIfNecessary, vm.isBlocksShouldBeCreated);
      };

      vm.getServiceReference = function () {
        var defer = $q.defer();
        $log.info('fileImportService getServiceReference running');
        defer.resolve(vm);
        return defer.promise;
      };

      return vm;
    }]);
})();

/**
 * Created by davidfm on 25/09/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .component('dashboardMain', {
      templateUrl: 'app/showroom/dashboard/dashboard-main.tmpl.html',
      controller: 'dashboardMainCtrl'
    })
    .controller('dashboardMainCtrl', ctrl);

  ctrl.$inject = ['dropboxApiService', 'MasterPermissionsDefinitionFactory'];
  /* ng-inject */
  function ctrl(dropboxApiService, MasterPermissionsDefinitionFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.permissions = MasterPermissionsDefinitionFactory;
    };

    vm.dropboxStatus = function () {
      var token = dropboxApiService.getBearerToken();
      if (token == 'Bearer null'){
        return 'not connected';
      } else {
        return 'Connected';
      }
    };

  }
})();

(function () {
  'use strict';
  angular.module('showroom')
    .factory('viewStateNotificationService', ['$log', function ($log) {

      $log.info('viewStateNotificationService factory is instantiating - this will only happen once for each full-page refresh');
      // Used to store viewStates to support things like view updating when toolbars are clicked
      var viewState = {
        'tagblocksMode': 'select',
        'blocksMode': 'select'
      };
      var arrayOfViewStateNotificationDelegates = [];

      var registerForViewStateNotifications = function (delegateFunctionBeingRegistered) {
        arrayOfViewStateNotificationDelegates.push(delegateFunctionBeingRegistered);
      };

      var transitionToViewState = function (viewStateAdjustment) {
        // Merge the adjustment into the current viewState
        for (var attrname in viewStateAdjustment) {
          viewState[attrname] = viewStateAdjustment[attrname];
        }

        // Notify any listeners of the change
        arrayOfViewStateNotificationDelegates.forEach(function (delegate) {
          // Call the delegate:
          delegate(viewState);
        });
      };

      return {
        viewState: viewState,
        arrayOfViewStateNotificationDelegates: arrayOfViewStateNotificationDelegates,
        registerForViewStateNotifications: registerForViewStateNotifications,
        transitionToViewState: transitionToViewState
      };
    }]);
})();

/**
 * Created by davidhickson on 14/03/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .factory('tagAnalyserService', ['$log', 'uuidService', 'stringHelper', function ($log, uuidService, stringHelper) {

      var determineRequiredTags = function (arrayOfItemsToIngest, existingTagCategoryArray) {
        var rc = {
          arrayOfCategoriesWhichAreMissingFromTagLibrary: [],
          arrayOfTagsWhichAreMissingFromTagLibrary: []
        };
        var objectHoldingRequiredTags = {};

        arrayOfItemsToIngest.forEach(function (item) {
          if (item.isSelected && item.category && item.tag) {
            objectHoldingRequiredTags[item.category] = objectHoldingRequiredTags[item.category] || {};
            objectHoldingRequiredTags[item.category][item.tag] = 1;
          }
        });

        Object.getOwnPropertyNames(objectHoldingRequiredTags).forEach(function (propertyName) {
          $log.info('determineNewTagRequirement has property ' + propertyName + ' with value ' + objectHoldingRequiredTags[propertyName]);

          var arrayOfMatchingCategories = existingTagCategoryArray.filter(function (item) {
            return item.category.toLowerCase() === propertyName.toLowerCase();
          });

          $log.info('determineNewTagRequirement has arrayOfMatchingCategories= ' + JSON.stringify(arrayOfMatchingCategories));

          if (arrayOfMatchingCategories.length == 1) {
            Object.getOwnPropertyNames(objectHoldingRequiredTags[propertyName]).forEach(function (tagTitle) {

              var tagExists = false;
              arrayOfMatchingCategories[0].tags.forEach(function (existingTag) {
                if (tagTitle.toLowerCase() === existingTag.title.toLowerCase()) {
                  tagExists = true;
                }
              });
              if (!tagExists) {
                $log.info('We need to add tag ' + tagTitle + ' to existing category of ' + propertyName);
                var newTagId = uuidService.getSingleNewBase64Key();
                rc.arrayOfTagsWhichAreMissingFromTagLibrary.push({
                  'title': stringHelper.toTitleCase(tagTitle),
                  '_id': newTagId,
                  'categoryId': arrayOfMatchingCategories[0]._id
                });

              } else {
                $log.info('' + tagTitle + ' was found in existing category ' + propertyName);
              }
            });

          } else {
            // No matching category found, we need to add one.
            $log.info('We need to add the entire category of ' + propertyName);
            var newCategoryId = uuidService.getSingleNewBase64Key();
            rc.arrayOfCategoriesWhichAreMissingFromTagLibrary.push({
              '_id': newCategoryId,
              'title': stringHelper.toTitleCase(propertyName)
            });
            Object.getOwnPropertyNames(objectHoldingRequiredTags[propertyName]).forEach(function (tagTitle) {
              var newTagId = uuidService.getSingleNewBase64Key();
              rc.arrayOfTagsWhichAreMissingFromTagLibrary.push({
                'title': stringHelper.toTitleCase(tagTitle),
                '_id': newTagId,
                'categoryId': newCategoryId
              });
            });
          }
        });

        return rc;
      };

      return {
        determineRequiredTags: determineRequiredTags
      };
    }]);
})();

/**
 * Created by davidhickson on 01/03/2017.
 */

(function () {
  'use strict';
  angular.module('showroom').directive('ngUploadChange', function () {
    return {
      scope: {
        ngUploadChange: '&'
      },
      link: function ($scope, $element) {
        
        $element.on('change', function (ev) {
          $scope.ngUploadChange({
            $event: ev
          });
        });
        
        $scope.$on('$destroy', function () {
          $element.off();
        });
      }
    };
  });
})();
(function () {
  'use strict';
  angular.module('showroom')
    .factory('literatureIngestorService', ['$q', '$log', 'APIService', 'MessageService', 'tagAnalyserService', 'literatureHelperService', 'tagsManager', 'uuidService', 'literatureManager', 'stringHelper', function ($q, $log, APIService, MessageService, tagAnalyserService, literatureHelperService, tagsManager, uuidService, literatureManager, stringHelper) {

      var addExternalFiles = function (filesAsPackage, options) {
        ingestPackage(filesAsPackage, true, true, options);
      };

      var importLiteratureViaImportedList = function (arrayOfItemsToIngest, isTagsShouldBeLinked, isNewTagsShouldBeCreatedIfNecessary, isBlocksShouldBeCreated) {
        $log.info('literatureManager.importLiteratureViaImportedList arrayOfItemsToImport is shown below');
        $log.info(arrayOfItemsToIngest);
        ingestPackage(arrayOfItemsToIngest, isTagsShouldBeLinked, isNewTagsShouldBeCreatedIfNecessary, null, isBlocksShouldBeCreated);
      };

      function ingestPackage(arrayOfItemsToIngest, isTagsShouldBeLinked, isNewTagsShouldBeCreatedIfNecessary, options, isBlocksShouldBeCreated) {
        AddNewTagsIfNecessary(isNewTagsShouldBeCreatedIfNecessary, arrayOfItemsToIngest)
          .then(function () {
            validateInboundExternalFilePackage(arrayOfItemsToIngest)
              .then(function (pkg) {
                // $log.info('addExternalFiles after keys has pkg:' + JSON.stringify(pkg));
                var updatedPackage = updateLocalModelWithPackage(pkg, options);
                var packageCopy = Object.assign({}, updatedPackage);
                postLiteratureDeltasToServer(updatedPackage)
                  .then(function () {
                    MessageService.showMessage(updatedPackage.length + ' items have been added. Remember to sync your devices!');
                    // $log.info('addExternalFiles returned from postNewFilePackageToServer with ' + JSON.stringify(res));
                    createBlocksFromTagsIfNecessary(isBlocksShouldBeCreated, packageCopy)
                      .then(function () {

                      });
                  });
              });
          });
      }

      function createBlocksFromTagsIfNecessary(isBlocksShouldBeCreated, arrayOfLiteratureDeltas) {
        var defer = $q.defer();

        if (isBlocksShouldBeCreated) {
          var rootBlock = {
            '_id': uuidService.getSingleNewBase64Key(),
            'nameplate': new Date().toLocaleDateString(),
            'artefactType': 'Block',
            blocks: []
          };
          var blocks = [rootBlock];

          for (var key in arrayOfLiteratureDeltas) {
            addLiteratureToBlock(arrayOfLiteratureDeltas[key], blocks, rootBlock);
          }

          postBlocksToServer(blocks).then(function () {
            MessageService.showMessage('Block structure successfully created!');
            defer.resolve();
          });
        } else {
          defer.resolve();
        }

        return defer.promise;
      }

      function addLiteratureToBlock(literatureItem, arrayOfBlocks, rootBlock) {
        if (literatureItem.tags.length > 0) {
          tagsManager.tagCategories.forEach(function (category) {
            category.tags.forEach(function (tag) {
              if (tag._id === literatureItem.tags[0]) {
                var rootBlockNameplate = category.category;
                var subBlockNameplate = tag.title;

                var titleSubBlock = getBlockFromNameplate(tag._id, false, arrayOfBlocks);

                if (titleSubBlock === null) {
                  titleSubBlock = {
                    '_id': uuidService.getSingleNewBase64Key(),
                    'nameplate': subBlockNameplate,
                    'tagTitleId': tag._id,
                    'artefactType': 'Block',
                    literatures: []
                  };
                  arrayOfBlocks.push(titleSubBlock);
                }

                var categoryRootBlock = getBlockFromNameplate(category._id, true, arrayOfBlocks);
                if (categoryRootBlock === null) {
                  categoryRootBlock = {
                    '_id': uuidService.getSingleNewBase64Key(),
                    'nameplate': rootBlockNameplate,
                    'tagCategoryId': category._id,
                    'artefactType': 'Block',
                    blocks: []
                  };
                  arrayOfBlocks.push(categoryRootBlock);
                }

                if (categoryRootBlock.blocks.indexOf(titleSubBlock._id) === -1) {
                  categoryRootBlock.blocks.push(titleSubBlock._id);
                }
                if (titleSubBlock.literatures.indexOf(literatureItem._id) === -1) {
                  titleSubBlock.literatures.push(literatureItem._id);
                }
                if (rootBlock.blocks.indexOf(categoryRootBlock._id) === -1) {
                  rootBlock.blocks.push(categoryRootBlock._id);
                }
              }
            });
          });
        }
      }

      function getBlockFromNameplate(id, isCategory, arrayOfBlocks) {
        var i = 0;
        var len = arrayOfBlocks.length;

        for (i; i < len; i++) {
          if (isCategory) {
            if (arrayOfBlocks[i].tagCategoryId === id && arrayOfBlocks[i].blocks) {
              return arrayOfBlocks[i];
            }
          } else {
            if (arrayOfBlocks[i].tagTitleId === id && arrayOfBlocks[i].literatures) {
              return arrayOfBlocks[i];
            }
          }
        }

        return null;
      }

      function AddNewTagsIfNecessary(isNewTagsShouldBeCreatedIfNecessary, arrayOfItemsToIngest) {
        var defer = $q.defer();

        if (isNewTagsShouldBeCreatedIfNecessary) {
          var flaggedCategories = {};
          var objectContainingRequiredNewTags = tagAnalyserService.determineRequiredTags(arrayOfItemsToIngest, tagsManager.tagCategories);

          if (objectContainingRequiredNewTags.arrayOfCategoriesWhichAreMissingFromTagLibrary.length > 0) {
            $log.info('AddNewTagsIfNecessary will add Categories logged below');
            $log.info(objectContainingRequiredNewTags.arrayOfCategoriesWhichAreMissingFromTagLibrary);

            objectContainingRequiredNewTags.arrayOfCategoriesWhichAreMissingFromTagLibrary.forEach(function (newCategory) {
              tagsManager.tagCategories.push({
                '_id': newCategory._id,
                'category': newCategory.title,
                'tags': [],
                'sortorder': tagsManager.tagCategories.length
              });
              flaggedCategories[newCategory._id] = true;
            });
          }

          if (objectContainingRequiredNewTags.arrayOfTagsWhichAreMissingFromTagLibrary.length > 0) {
            $log.info('AddNewTagsIfNecessary will add Tags logged below');
            $log.info(objectContainingRequiredNewTags.arrayOfTagsWhichAreMissingFromTagLibrary);

            objectContainingRequiredNewTags.arrayOfTagsWhichAreMissingFromTagLibrary.forEach(function (newTag) {
              tagsManager.tagCategories.forEach(function (existingCategory) {
                if (existingCategory._id === newTag.categoryId) {
                  existingCategory.tags.push({
                    '_id': newTag._id,
                    'title': newTag.title
                  });

                  flaggedCategories[existingCategory._id] = true;
                }
              });
            });
          }

          var arrayOfTagCategoriesThatRequirePersistence = tagsManager.tagCategories.filter(function (item) {
            return !!flaggedCategories[item._id];
          });

          $log.info('AddNewTagsIfNecessary arrayOfTagCategoriesThatRequirePersistence logged below');
          $log.info(arrayOfTagCategoriesThatRequirePersistence);

          if (arrayOfTagCategoriesThatRequirePersistence.length > 0) {
            postArrayOfTagCategoryPartialUpdatesToServer(arrayOfTagCategoriesThatRequirePersistence)
              .then(function () {
                $log.info('server update was fine for AddNewTagsIfNecessary, about to resolve.');
                defer.resolve({});
              });
          } else {
            defer.resolve({});
          }
        } else {
          defer.resolve({});
        }

        return defer.promise;
      }

      function postArrayOfTagCategoryPartialUpdatesToServer(arrayOfPartialUpdates) {
        var arrays = [];
        if (arrayOfPartialUpdates.length > 200) {
          while (arrayOfPartialUpdates.length > 200) {
            arrays.push(arrayOfPartialUpdates.splice(0, 200));
          }

        }
        arrays.push(arrayOfPartialUpdates);

        var pArr = [];
        var i = 0;
        var len = arrays.length;
        for (i; i < len; i++) {
          pArr.push(APIService.post('showroom/tags/many', arrays[i]));
        }
        return $q.all(pArr);
      }

      function transformTitle(title, options) {
        if (options) {
          if (options.removeFileExtension) {
            /* eslint no-useless-escape:0 */
            title = stringHelper.removeStrings(title, ['\.pdf', '\.png', '\.jpg', '\.mp4', '\.mov']);
          }
          if (options.replaceUnderscores) {
            title = title.replace(/_/g, ' ');
          }
          if (options.capitaliseWords) {
            title = stringHelper.toTitleCase(title);
          }
        }
        return title;
      }

      function updateLocalModelWithPackage(pkg, options) {
        var modifiedPackage = [];
        var messageTitles = [];

        pkg.forEach(function (inboundItem) {

          var newEntry = {
            '_id': inboundItem._id,
            'title': transformTitle(inboundItem.title, options),
            'tags': [],
            'weburi': inboundItem.url,
            'mediatype': 'url',
            'dropboxPath': inboundItem.dropboxPath
          };

          newEntry.contenttype = literatureHelperService.getContentTypeForItem(inboundItem);

          if (inboundItem.tags) {
            newEntry.tags = inboundItem.tags;
            newEntry.extendedTags = inboundItem.tags.map(function (itm) {
              return {
                '_id': itm,
                'isSelected': false
              };
            });
          }

          newEntry.isDirty = true;
          newEntry.isShouldBeDisplayed = true; // This drives the literatureTreeComponent filter, if we don't set to true then it won't be displayed

          if (newEntry.contenttype !== 'unknown' ) {
            if (isUnique(newEntry)) {
              literatureManager.literatureItems.push(newEntry);
              modifiedPackage.push(newEntry);
            } else {
              messageTitles.push(newEntry.title);
            }
          }
        });

        if (messageTitles.length > 0) {
          MessageService.showMessageWithAction('Duplicate items found', 'The following items have not been added as they already exist in the library:<br /> ' + messageTitles.join('<br />'));
        }
        return modifiedPackage;
      }

      function isUnique(newEntry) {
        var isUnique = true;

        literatureManager.literatureItems.forEach(function (item) {
          if (item.title === newEntry.title) {
            isUnique = false;
          }
        });

        return isUnique;
      }

      function validateInboundExternalFilePackage(pkg) {
        var defer = $q.defer();

        uuidService.getArrayOfNewBase64Keys(pkg.length)
          .then(function (res) {
          // $log.info('validateInboundExternalFilePackage has res = ' + JSON.stringify(res));

            pkg.forEach(function (packageItem) {
            // $log.info('validateInboundExternalFilePackage has item BEFORE:' + JSON.stringify(packageItem));

              if (!packageItem._id) {
                var ky = res.data.keys.splice(0, 1)[0];
                packageItem._id = ky;
              }

              if (packageItem.category && packageItem.tag) {
                packageItem.tags = getNewTagsArrayForNewItem(packageItem);
              }

            // $log.info('validateInboundExternalFilePackage has item AFTER:' + JSON.stringify(packageItem));
            });
            $log.info('got ' + pkg.length + ' items to add');
            defer.resolve(pkg);
          });

        return defer.promise;
      }

      function getNewTagsArrayForNewItem(packageItem) {
        var newArray = [];
        tagsManager.tagCategories.forEach(function (existingCategory) {
          existingCategory.tags.forEach(function (existingTag) {
            if (packageItem.category.toLowerCase() === existingCategory.category.toLowerCase() && packageItem.tag.toLowerCase() === existingTag.title.toLowerCase()) {
              newArray.push(existingTag._id);
            }
          });
        });

        return newArray;
      }

      function stripLocalPropertiesFromLiteratureDeltas(arrayOfLiteratureDeltas) {
        return arrayOfLiteratureDeltas.map(function (item) {
          return JSON.parse(JSON.stringify(item, function (key, value) {
            if (key == 'extendedTags' ||
              key == 'isDirty' ||
              key == 'isShouldBeDisplayed' ||
              key == 'selected'
            ) {
              return undefined;
            } else {
              return value;
            }
          }));
        });
      }

      function postBlocksToServer(arrayOfBlockDeltas) {
        var arrays = [];
        if (arrayOfBlockDeltas.length > 1000) {
          while (arrayOfBlockDeltas.length > 1000) {
            arrays.push(arrayOfBlockDeltas.splice(0, 1000));
          }

        }
        arrays.push(arrayOfBlockDeltas);

        var pArr = [];
        var i = 0;
        var len = arrays.length;
        for (i; i < len; i++) {
          pArr.push(APIService.post('showroom/blocks/updateBlocks', arrays[i]));
        }
        return $q.all(pArr);
      }

      function postLiteratureDeltasToServer(arrayOfLiteratureDeltas) {
        arrayOfLiteratureDeltas = stripLocalPropertiesFromLiteratureDeltas(arrayOfLiteratureDeltas);

        var arrays = [];
        if (arrayOfLiteratureDeltas.length > 1000) {
          while (arrayOfLiteratureDeltas.length > 1000) {
            arrays.push(arrayOfLiteratureDeltas.splice(0, 1000));
          }

        }
        arrays.push(arrayOfLiteratureDeltas);

        var pArr = [];
        var i = 0;
        var len = arrays.length;
        for (i; i < len; i++) {
          pArr.push(APIService.post('showroom/literature/many', arrays[i]));
        }
        return $q.all(pArr);
      }

      return {
        importLiteratureViaImportedList: importLiteratureViaImportedList,
        addExternalFiles: addExternalFiles
      };

    }]);
})();

/**
 * Created by davidhickson on 12/04/2017.
 */

(function () {
  'use strict';
  angular.module('showroom')
    .factory('literatureHelperService', function () {

      var getContentTypeForItem = function (item) {

        if (item.contenttype) {
          return item.contenttype;

        } else {
          if (item.url) {

            if (item.url.indexOf('.pdf?') > -1) {
              return 'application/pdf';
            }
            if (item.url.indexOf('.mov?') > -1) {
              return 'application/mov';
            }
            if (item.url.indexOf('.mp4?') > -1) {
              return 'application/mp4';
            }
            if (item.url.indexOf('.png?') > -1) {
              return 'image/png';
            }
            if (item.url.indexOf('.jpg?') > -1) {
              return 'image/jpeg';
            }

            var ix = item.url.lastIndexOf('.');
            if (ix + 4 <= item.url.length) {
              var threeChars = item.url.substring(ix + 1, ix + 4).toLowerCase();
              switch (threeChars) {
                case 'pdf':
                  threeChars = 'application/pdf';
                  break;
                case 'mov':
                  threeChars = 'application/mov';
                  break;
                case 'mp4':
                  threeChars = 'application/mp4';
                  break;
                case 'png':
                  threeChars = 'image/png';
                  break;
                case 'jpg':
                  threeChars = 'image/jpeg';
                  break;
                default:
                  threeChars = 'unknown';
                  break;
              }
              return threeChars;
            }
          }
        }
        return 'unknown';
      };

      return {
        getContentTypeForItem: getContentTypeForItem
      };

    });
})();

/**
 * Created by davidbeazer on 23/02/2017.
 */
(function () {
  'use strict';

  angular
    .module('showroom')
    .factory('BlocksMetadataFactory', BlocksMetadataFactory);

  BlocksMetadataFactory.$inject = [];

  function BlocksMetadataFactory() {

    var factoryData = {};
    buildFactory();

    return {
      getData: getData
    };

    function getData() {
      return factoryData;
    }

    // PRIVATE

    function buildFactory() {

      factoryData = {
        id: 'block',
        title: {
          label: 'Blocks',
          filterLabel: 'Search block items'
        },
        removeDialogConfig: {
          description: 'Remove Block',
          controller: 'RemoveBlockDialogController as vm',
          templateUrl: 'app/showroom/blocks/dialogs/remove-block.dialog.tmpl.html',
          locals: {
            blockDoc: {
              // _id: null, << server creates that
            }
          },
          ariaLabel: 'Remove block item'
        },
        removeLiteratureDialogConfig: {
          description: 'Remove Literature',
          controller: 'RemoveLiteratureFromBlockDialogController as vm',
          templateUrl: 'app/showroom/blocks/dialogs/remove-literature-from-block.dialog.tmpl.html',
          locals: {
            litDoc: {
              // _id: null, << server creates that
            }
          },
          ariaLabel: 'Remove literature item'
        },
        addDialogConfig: {
          description: 'Add Block',
          controller: 'AddBlockDialogController as vm',
          templateUrl: 'app/showroom/blocks/dialogs/add-edit-block.dialog.tmpl.html',
          locals: {
            blockDoc: {

            },
            parentBlockDoc: {
              // _id: null, << server creates that
            }
          },
          ariaLabel: 'Add block item'
        },
        editParentDialogConfig: {
          description: 'Edit Block',
          controller: 'EditParentBlockDialogController as vm',
          templateUrl: 'app/showroom/blocks/dialogs/add-edit-parent-block.dialog.tmpl.html',
          locals: {
            blockDoc: {

            }
          },
          ariaLabel: 'Edit block item'
        },
        editParentVisualsDialogConfig: {
          description: 'Edit Block Visuals',
          controller: 'EditParentBlockVisualsDialogController as vm',
          templateUrl: 'app/showroom/blocks/dialogs/add-edit-parent-block-visuals.dialog.tmpl.html',
          locals: {
            blockDoc: {

            }
          },
          ariaLabel: 'Edit block visuals'
        },
        addLiteratureDialogConfig: {
          description: 'Add Literature',
          controller: 'AddLiteratureBlockDialogController as vm',
          templateUrl: 'app/showroom/blocks/dialogs/add-literature-to-block.dialog.tmpl.html',
          locals: {
            blockDoc: {

            }
          },
          ariaLabel: 'Add literature to block'
        },
        addSubBlocksDialogConfig: {
          description: 'Add Blocks',
          controller: 'AddExistingBlocksBlockDialogController as vm',
          templateUrl: 'app/showroom/blocks/dialogs/add-existing-blocks-to-block.dialog.tmpl.html',
          locals: {
            blockDoc: {

            }
          },
          ariaLabel: 'Add blocks to block'
        }
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('showroom')
    .factory('blocksManager', blocksManager);

  blocksManager.$inject = [
    'APIService',
    '$q',
    '$log',
    'blockModel',
    'hydrateBlockBlocksArray',
    'selectionProcesses',
    'deselectSelectedBlocks',
    'createDeltasByApplyingBlockSelections',
    'ingestArrayOfBlockDeltas',
    'createNewBlock',
    'createDeltaByRemovingChildBlock',
    'refreshDerivedProperties',
    'applySearchTermToBlocks',
    'ingestArchiveBlockDelta',
    'createDeltasByApplyingBlockSelectionsToBlock',
    'uuidService',
    'MessageService'
  ];

  function blocksManager(
    api,
    $q,
    $log,
    model,
    hydrateBlockBlocksArray,
    selectionProcesses,
    deselectSelectedBlocks,
    createDeltasByApplyingBlockSelections,
    ingestArrayOfBlockDeltas,
    createNewBlock,
    createDeltaByRemovingChildBlock,
    refreshDerivedProperties,
    applySearchTermToBlocks,
    ingestArchiveBlockDelta,
    createDeltasByApplyingBlockSelectionsToBlock,
    uuidService,
    MessageService
  ) {

    var isBlockToBlockMode = false;

    var hydrateOrRefresh = function () {
      var defer = $q.defer();

      api.get('showroom/blocks/blocks')
        .then(function (response) {
          // It is essential that we MODIFY the EXISTING model.blocks array, rather than simply assigning a brand-new array to model.blocks.
          // This is because we may have other references elsewhere (via require(./model/blocks.model) that are pointing to the CURRENT model.blocks array, and these will be left hanging if we blast the original
          model.blocks.length = 0; // Clear the array, but leave existing references alone
          response.data.data.forEach(function (block) {
            block.isRootBlock = true;
            block.arrayOfParentBlocks = [];
            block.isShouldBeDisplayed = true;
            model.blocks.push(block);
          });

          $log.info('BlocksManager.hydrateFromCloud has data, model.blocks logged below');
          $log.info(model.blocks);
          defer.resolve();
        }, function (err) {
          $log.error('BlocksManager.hydrateFromCloud nasty');
          $log.error(err);
          defer.reject();
        });

      return defer.promise;
    };

    var secondStageHydrateModel = function () {
      hydrateBlockBlocksArray(model.blocks);
      // refreshDerivedProperties(model.blocks);
    };

    var deselectAllBlocksForPush = function () {
      $log.info('BlocksManager about to pass task to lieutenant, model.blocks logged below ');
      $log.info(model.blocks);

      selectionProcesses.deselectAllBlocksForPush(model.blocks);
      model.requestStatsUpdate();
    };

    var requestBlockStatsUpdate = function () {
      model.requestStatsUpdate();
    };

    var ingestBlockDelta = function (blockDelta) {
      var found = false;

      model.blocks.forEach(function (existingBlock) {
        if (blockDelta._id == existingBlock._id) {
          found = true;
          Object.getOwnPropertyNames(blockDelta).forEach(function (propertyName) {
            existingBlock[propertyName] = blockDelta[propertyName];
          });
        }
      });

      if (!found) {
        // Must be a brand-new block
        blockDelta.isShouldBeDisplayed = true;
        blockDelta.isRootBlock = true;
        model.blocks.push(blockDelta);
      }

      var apiDelta = getCleanDelta([blockDelta]);

      return api.post('showroom/blocks/updateBlocks', apiDelta);
    };

    var applySelectedBlocksToSelectedBlocks = function () {
      var changeDelta = createDeltasByApplyingBlockSelections(model.blocks); // PURE

      api.post('showroom/blocks/updateBlocks', changeDelta)
        .then(function () {
          ingestArrayOfBlockDeltas(model.blocks, changeDelta);
          refreshDerivedProperties(model.blocks);
        }, function () {
          // Don't apply the change to the model because the persist did not work
        });
    };

    var applySelectedBlockToCurrentBlock = function (toBlock) {
      var changeDelta = createDeltasByApplyingBlockSelectionsToBlock(model.blocks, toBlock); // PURE

      return api.post('showroom/blocks/updateBlocks', changeDelta)
        .then(function () {
          ingestArrayOfBlockDeltas(model.blocks, changeDelta);
          refreshDerivedProperties(model.blocks);
        });
    };

    var addBlock = function (newBlockNameplate) {

      var newBlock = createNewBlock(newBlockNameplate, model);
      return api.post('showroom/blocks/updateBlocks', [newBlock])
        .then(
          function () {
            ingestArrayOfBlockDeltas(model.blocks, [newBlock]);
          },
          function () {});
    };

    var addBlockWithParent = function (delta) {

      return api.post('showroom/blocks/updateBlocks', delta)
        .then(function () {
          ingestArrayOfBlockDeltas(model.blocks, delta);
          refreshDerivedProperties(model.blocks);
        });
    };

    var getCleanDelta = function (delta) {
      var cleanDelta = [];
      delta.forEach(function (block) {
        var cleanBlock = angular.copy(block);
        if (cleanBlock.blocks) {
          delete cleanBlock['blocks'];
        }
        cleanDelta.push(cleanBlock);
      });
      return cleanDelta;
    };

    var removeBlockFromBlock = function (childBlock, parentBlock) {

      var changeDelta = createDeltaByRemovingChildBlock(childBlock, parentBlock); // PURE

      return api.post('showroom/blocks/updateBlocks', [changeDelta])
        .then(function () {
          ingestArrayOfBlockDeltas(model.blocks, [changeDelta]);
          refreshDerivedProperties(model.blocks);
        }, function () {
          // Don't apply the change to the model because the persist did not work
        });
    };

    var getDelta = function (block) {
      var delta = {};
      delta._id = block._id || uuidService.getSingleNewBase64Key();
      delta.description = block.description;
      delta.nameplate = block.nameplate;
      delta.caption = block.caption;
      delta.nameplateImage = block.nameplateImage == 'None' ? '' : block.nameplateImage;
      delta.nameplateHidden = block.nameplateHidden;
      delta.heightOfBlocks = block.heightOfBlocks;
      delta.padding = block.padding;
      delta.blocksPerRow = block.blocksPerRow;
      delta.backgroundImage = block.backgroundImage == 'None' ? '' : block.backgroundImage;
      delta.artefactType = block.artefactType || 'Block';
      delta.blocks = block.blocks || [];
      return delta;
    };

    var archiveBlock = function (block, archiveAll) {
      var req;
      if (archiveAll) {
        req = _.map(model.blocks, function (b) {
          return {
            _id: b._id
          };
        });
      } else {
        req = [{
          _id: block._id
        }];
      }
      return api.post('showroom/blocks/removeMany', req)
        .then(function () {
          if (!archiveAll) {
            ingestArchiveBlockDelta(model.blocks, block._id);
            refreshDerivedProperties(model.blocks);
          } else {
            // remove all blocks but keep reference in tact.
            model.blocks.length = 0;
          }
          MessageService.writeLog({
            level: 'info',
            msg: 'archiveBlock call returned.',
            tags: ['blocksManager.factory', 'archiveBlock']
          });
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            err: err,
            msg: 'archiveBlock error',
            tags: ['error', 'blocksManager.factory']
          });
        });

    };

    var blocksTextSearchTermChanged = function (searchTerm) {
      applySearchTermToBlocks(searchTerm, model.blocks);
    };

    var deselectAllBlocks = function (options) {
      deselectSelectedBlocks(model.blocks, options);
    };

    return {
      blocks: model.blocks,
      stats: model.stats,
      isBlockToBlockMode: isBlockToBlockMode,
      hydrateOrRefresh: hydrateOrRefresh,
      secondStageHydrateModel: secondStageHydrateModel,
      deselectAllBlocksForPush: deselectAllBlocksForPush,
      ingestBlockDelta: ingestBlockDelta,
      applySelectedBlocksToSelectedBlocks: applySelectedBlocksToSelectedBlocks,
      addBlock: addBlock,
      removeBlockFromBlock: removeBlockFromBlock,
      requestBlockStatsUpdate: requestBlockStatsUpdate,
      blocksTextSearchTermChanged: blocksTextSearchTermChanged,
      deselectAllBlocks: deselectAllBlocks,
      archiveBlock: archiveBlock,
      addBlockWithParent: addBlockWithParent,
      applySelectedBlockToCurrentBlock: applySelectedBlockToCurrentBlock,
      getDelta: getDelta
    };
  }
})();

/**
 * Created by davidhickson on 05/06/2017.
 */
(function () {
  'use strict';
  angular.module('showroom').factory('blocksXrefLiteratureManager', blocksXrefLiteratureManager);

  blocksXrefLiteratureManager.$inject = [
    'APIService',
    'hydrateBlockLiteraturesArray',
    'createDeltasByApplyingSelectedLit',
    'createDeltaByRemovingLitFromBlock',
    'ingestArrayOfBlockLiteratureDeltas',
    'createDeltasByApplyingLiteratureToCurrentBlock',
    'literatureModel',
    'blockModel'
  ];

  function blocksXrefLiteratureManager(
    api,
    hydrateBlockLiteraturesArray,
    createDeltasByApplyingSelectedLit,
    createDeltaByRemovingLitFromBlock,
    ingestArrayOfBlockLiteratureDeltas,
    createDeltasByApplyingLiteratureToCurrentBlock,
    literatureModel,
    blockModel
  ) {

    var applySelectedLiteratureToSelectedBlocks = function () {

      var changeDelta = createDeltasByApplyingSelectedLit(blockModel.blocks, literatureModel.literatureItems); // PURE

      api.post('showroom/blocks/updateBlocks', changeDelta)
        .then(function () {
          ingestArrayOfBlockLiteratureDeltas(blockModel.blocks, changeDelta, literatureModel.literatureItems);
        }, function () {
          // Don't apply the change to the model because the persist did not work
        });
    };

    var applySelectedLiteratureToCurrentBlock = function (block) {

      var changeDelta = createDeltasByApplyingLiteratureToCurrentBlock(block, literatureModel.literatureItems); // PURE

      return api.post('showroom/blocks/updateBlocks', changeDelta)
        .then(function () {
          ingestArrayOfBlockLiteratureDeltas(blockModel.blocks, changeDelta, literatureModel.literatureItems);
        });
    };

    var removeLitFromBlock = function (litItemToRemove, blockToRemoveItemFrom) {
      var changeDelta = createDeltaByRemovingLitFromBlock(litItemToRemove, blockToRemoveItemFrom); // PURE

      return api.post('showroom/blocks/updateBlocks', [changeDelta])
        .then(function () {
          ingestArrayOfBlockLiteratureDeltas(blockModel.blocks, [changeDelta], literatureModel.literatureItems);
        }, function () {
          // Don't apply the change to the model because the persist did not work
        });
    };

    var secondStageHydrateModel = function () {
      hydrateBlockLiteraturesArray(blockModel.blocks, literatureModel.literatureItems);
    };

    return {
      applySelectedLiteratureToSelectedBlocks: applySelectedLiteratureToSelectedBlocks,
      secondStageHydrateModel: secondStageHydrateModel,
      removeLitFromBlock: removeLitFromBlock,
      applySelectedLiteratureToCurrentBlock: applySelectedLiteratureToCurrentBlock
    };
  }
})();

angular.module('lists')
  .controller('AddListDialogController', AddListDialogController);

AddListDialogController.$inject = ['$rootScope', '$state', 'MessageService', 'ListApiFactory', 'ListOfListsFactory', 'uuidService', '$log', 'hotkeys', '$scope'];
/* ng-inject */
function AddListDialogController($rootScope, state, MessageService, ListApiFactory, ListOfListsFactory, uuid, $log, hotkeys, $scope) {

  var vm = this;

  vm.fileName = '';
  vm.fileEncoding = '';
  vm.fileUploaded = false;
  vm.fileErrors = [];
  vm.fileWarnings = [];
  vm.processErrors = [];
  vm.fileItems = [];
  vm.recognisedCsvHeaders = [];

  vm.avaliableCsvHeaders = [
    { name: 'caption', required: true, description: '(mandatory)' }, 
    { name: 'code', required: false, description: '(optional)' },
    { name: 'reportingLabel', required: false, description: '(optional)' },
    { name: 'points', required: false, description: '(optional integer value)' },
    { name: 'showMoreInfoTextField', required: false, description: '(optional value of "1" or "0")' },
  ];

  vm.validShowMoreInfoRawValues = ['on', 'ON', 'true', 'TRUE', '1', 'off', 'OFF', 'false', 'FALSE', '0'];

  vm.source = 'new';
  vm.listTitle = '';
  vm.cloneSourceArtefactId = null;
  vm.listTemplateId = null;

  vm.currentLists = _.chain(ListOfListsFactory.getData().itemsObject)
    .map(function (item) {
      return {
        _id: item.list._id,
        title: item.list.title,
        icn: item.list.icn
      };
    })
    .sortBy('icn')
    .reverse()
    .value();

  vm.listAutocompleteConfig = {
    placeholder: 'Pick a list',
    floatingLabel: 'List to clone',
    name: 'cloneList',
    position: 'bottom'
  };

  vm.templateAutocompleteConfig = {
    placeholder: 'Pick a template',
    floatingLabel: 'List template',
    name: 'template'
  };

  vm.$onInit = function () {
    bindhotkeys();
  };

  function bindhotkeys() {
    hotkeys.bindTo($scope)
      .add({
        combo: 'enter',
        description: 'Save',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function () {
          vm.submit();
        }
      });
  }

  vm.listTitleChanged = function() {
    if (!vm.listTitle) {
      vm.newListForm.listTitle.$setValidity('listTitleExists', false);
      return;
    }

    for (const listItm of vm.currentLists) {
      if (listItm.title.toLowerCase() === vm.listTitle.toLowerCase()) {
        vm.newListForm.listTitle.$setValidity('listTitleExists', false);
        return;
      }
    }

    vm.newListForm.listTitle.$setValidity('listTitleExists', true);

  };

  vm.selectFile = function() {
    if (vm.fileUploaded) {
      vm.fileName = '';
      vm.fileUploaded = false;
      vm.recognisedCsvHeaders = [];
      vm.fileErrors = [];
      vm.fileWarnings = [];
      vm.processErrors = [];
      vm.fileItems = [];
      angular.element(document).find('#listUploadInput').val(null);
      return;
    }
    
    angular.element(document).find('#listUploadInput').click();
  };

  vm.fileChanged = function ($event) {
    const file = $event.target.files[0];
    vm.fileName = file.name;
    const splits = vm.fileName.split('.');

    if (splits.pop() !== 'csv') {
      return MessageService.showMessage('Invalid file type. Please select a CSV.');
    }

    return getFileEncoding(file)
      .then(function (meta){
        vm.fileEncoding = meta.encoding;
        if (vm.fileEncoding !== 'UTF-8'){
          vm.fileWarnings.push({
            type: 'fileType',
            message: 'Non-UTF-8 encoded file detected. We recommend saving your CSV file with UTF-8 encoding to support extended Unicode character sets. If you continue, non-ASCII characters (such as letters with accents) may not be processed correctly.'
          });
        }
        Papa.parse(file, {
          delimiter: ',',
          newline: '',// auto detect
          skipEmptyLines: true,
          encoding: meta.encoding,
          complete: function (results) {
            if (results.data && results.data.length > 0) {
              const columns = results.data[0];
                
              for (const column of columns){
                if (vm.avaliableCsvHeaders.findIndex((header)=> header.name === column) > -1){
                  vm.recognisedCsvHeaders.push(column);
                } else {
                  const existingErrorIndex = vm.fileErrors.findIndex((err)=> err.type === 'unknown_csv_header');
    
                  if (existingErrorIndex === -1){
                    vm.fileErrors.push({
                      type: 'unknown_csv_header',
                      error: 'Unknown CSV Headers: ' + `"${column}"`,
                    });
                  } else {
                    vm.fileErrors[existingErrorIndex].error += `, "${column}"`;
                  }
                  
                }
              }
    
              for (const avaliableCsvHeader of vm.avaliableCsvHeaders){
                if (vm.recognisedCsvHeaders.indexOf(avaliableCsvHeader.name) === -1 && avaliableCsvHeader.required){
                  const existingErrorIndex = vm.fileErrors.findIndex((err)=> err.type === 'missing_required_csv_header');
    
                  if (existingErrorIndex === -1){
                    vm.fileErrors.push({
                      type: 'missing_required_csv_header',
                      error: 'Missing CSV Headers: ' + `"${avaliableCsvHeader.name}"`,
                    });
                  } else {
                    vm.fileErrors[existingErrorIndex].error += `, "${avaliableCsvHeader.name}"`;
                  }
                }
              }
    
              //row
              for (let i = 1; i < results.data.length; i++) {
                const item = {
                  code: '',
                  reportingLabel: '',
                  showMoreInfoTextField: 0
                };
                //column
                for (let j = 0; j < results.data[i].length; j++) {
                  let value = results.data[i][j];
                  
                  if (typeof(value) === 'string'){
                    //this basically removes any extra new line or return Carriage characters
                    value = value.replace(/[\r\n]/g, '');
                  }
    
                  item[results.data[0][j]] = value;
                }
    
                vm.fileItems.push(item);
              }
    
              for (const recognisedCsvHeader of vm.recognisedCsvHeaders){
                for (const [index, rawItm] of vm.fileItems.entries()){
                  const rowNum = index;
                  const prettyRowNum = index + 1;
    
                  if (!rawItm[recognisedCsvHeader] || rawItm[recognisedCsvHeader].length === 0){
                    vm.fileErrors.push({
                      type: 'missing_data_for_csv_header',
                      error: 'Missing Data For Header: ' + `"${recognisedCsvHeader}" at row ${prettyRowNum}.`,
                    });
                  } else if (recognisedCsvHeader === 'showMoreInfoTextField'){
                    if (vm.validShowMoreInfoRawValues.indexOf(rawItm[recognisedCsvHeader]) === -1){
                      vm.fileErrors.push({
                        type: 'invalid_showMoreInfoTextField_within_csv_data',
                        error: 'Invalid ' + `"${rawItm[recognisedCsvHeader]}" Value at row ${prettyRowNum} - please use a 1 or 0 to toggle this on/off.`,
                      });
                    } else {
                      if (rawItm[recognisedCsvHeader] === '1' || rawItm[recognisedCsvHeader].toLowerCase() === 'on' || rawItm[recognisedCsvHeader].toLowerCase() === 'true'){
                        rawItm['showMoreInfoTextfield'] = true;
                      } else {
                        rawItm['showMoreInfoTextfield'] = 0;
                      }
                    }
                    
                  } else if (recognisedCsvHeader === 'points'){
                    if (!isInteger(rawItm[recognisedCsvHeader])){
                      vm.fileErrors.push({
                        type: 'invalid_showMoreInfoTextField_within_csv_data',
                        error: 'Invalid ' + `"${rawItm[recognisedCsvHeader]}" Value at row ${prettyRowNum} - please use an integer value.`,
                      });
                    } else {
                      rawItm[recognisedCsvHeader] = Number(rawItm[recognisedCsvHeader]);
                    }
                  } else if (recognisedCsvHeader === 'caption' || recognisedCsvHeader === 'code' || recognisedCsvHeader === 'reportingLabel'){
                    const dupeDataItmIndex = vm.fileItems
                      .filter(function (itm, index){
                        return index > rowNum;
                      })
                      .findIndex(function (itm) {
                        return itm[recognisedCsvHeader] === rawItm[recognisedCsvHeader];
                      });
                    
                    if (dupeDataItmIndex > -1){
                      vm.fileErrors.push({
                        type: 'dupe_' + recognisedCsvHeader + '_within_csv_data',
                        error: 'An item with that ' + recognisedCsvHeader + ' already exists: ' + `"${rawItm[recognisedCsvHeader]}" at row ${prettyRowNum + dupeDataItmIndex}.`,
                      });
                    }
                  }
    
                  //check to see if fields contain colon
                  if (!isInteger(rawItm[recognisedCsvHeader]) && typeof(rawItm[recognisedCsvHeader]) !== 'boolean' && rawItm[recognisedCsvHeader].indexOf(':') > -1) {
                    vm.fileErrors.push({
                      type: 'invalid_' + recognisedCsvHeader + '_within_csv_data',
                      error: 'Invalid ' + `"${rawItm[recognisedCsvHeader]}" Value at row ${prettyRowNum} - data must NOT contain colon.`,
                    });
                  }
                }
              }
    
              vm.fileUploaded = true;
        
            } else {
              vm.fileUploaded = false;
              MessageService.showMessage(vm.fileName + ' has no data');
            }
    
            //Papaparse seems to operate such that Angular does not see the changes when applied here, hence wrap the update in $scope.$apply:
            $rootScope.$digest();
          }
        });
      });
  };

  function isInteger(str) {
    return /^\d+$/.test(str);
  }

  vm.submit = function submit($event) {

    if (vm.fileWarnings.length === 0) return createList();
    //if we have warning we want to make 100% sure the user is aware so it's on their head if they continue...
    return MessageService.confirm($event)
      .confirmAction({
        title: 'Confirm List Creation',
        htmlContent: '<p>Are you sure you want to continue with creating the list?</p> <p> There are warnings present, and continuing may result in incorrect processing of the CSV file.</p>',
        okBtn: 'YES',
        cancelBtn: 'NO'
      })
      .then(function () {
        return createList();
      })
      .catch(function () {
        return;
      });

  };

  // modal dismiss functions
  vm.hide = function () {
    MessageService.closeDialog();
  };

  vm.cancel = function () {
    MessageService.cancelDialog();
  };

  /**
   * @param answer - value to send back to the scope that called this modal.
   */
  vm.answer = function (answer) {
    MessageService.closeDialog(answer);
  };

  function getFileEncoding(file) {
    const reader = new FileReader();

    return new Promise(function (resolve){
      reader.onload = function(event) {
        const arrayBuffer = new Uint8Array(event.target.result);
        let binaryString = '';
        for (let i = 0; i < arrayBuffer.byteLength; i++) {
          binaryString += String.fromCharCode(arrayBuffer[i]);
        }
        const detectedEncoding = jschardet.detect(binaryString);
        resolve(detectedEncoding);
      };

      // Read the file as a binary string
      reader.readAsArrayBuffer(file);
    });

  }

  function createList(){
    const newListObj = {
      _id: uuid.getSingleNewBase64Key(),
      _cloneSourceArtefactId: vm.cloneSourceArtefactId,
      _listTemplateId: vm.listTemplateId,
      title: vm.listTitle
    };

    if (vm.source === 'new') {
      delete newListObj._cloneSourceArtefactId;
      if (!newListObj._listTemplateId) delete newListObj._listTemplateId;
    } else if (vm.source === 'clone') {
      delete newListObj._listTemplateId;
    } else if (vm.source === 'upload') {
      delete newListObj._cloneSourceArtefactId;
      delete newListObj._listTemplateId;

      newListObj.items = vm.fileItems;
    }


    return ListApiFactory.saveNewList(newListObj)
      .then(function () {
        MessageService.pushEventToIntercom('created_list', {
          _id: newListObj._id,
          title: newListObj.title,
        });
        MessageService.closeDialog(true);
        state.go('app.toolbar_app_framework.list_detail', {
          _id: newListObj._id
        });
        ListOfListsFactory.invalidateCache();
      })
      .catch(function (err) {
        $log.error('Save new list error: ' + err);
        MessageService.closeDialog(false);
        MessageService.showMessage('Error adding list: ' + err);
      });
  }
}

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('IntegrationHomePageRouteResolve', factory);

  factory.$inject = ['MachinesFactory', 'GlobalAccessFactory', 'ConnectionStatusService', 'MachinesMetadata', 'MessageService'];
  /* ng-inject */
  function factory(MachinesFactory, GlobalAccessFactory, ConnectionStatusService, MachinesMetadata, MessageService) {

    return function () {
      return new Promise(function (resolve, reject) {
        const promisesArray = [];
        promisesArray.push(grabMachinesForAccount());
        promisesArray.push(getThirdPartyLoginDetails());
        promisesArray.push(MachinesMetadata.getData());

        Promise.all(promisesArray)
          .then(function (res) {
            MessageService.writeLog({
              level: 'info',
              msg: 'resolving integration homepage route',
              tags: ['integration']
            });
            resolve({
              machines: res[0],
              getThirdPartyLoginDetails: res[1],
              metadata: res[2]
            });
          })
          .catch(function (err) {
            MessageService.showMessage(err);
            MessageService.writeLog({
              level: 'error',
              msg: 'error resolving integration homepage: ' + JSON.stringify(err),
              tags: ['integration']
            });
            reject(err);
          });
      });
    };

    function grabMachinesForAccount() {
      return MachinesFactory.getMachines()
        .then(function (res) {
          return {
            items: res.machines
          };
        })
        .catch(function (err) {
          throw err;
        });
    }

    function getThirdPartyLoginDetails() {
      ConnectionStatusService.hydrateFactory();
      GlobalAccessFactory.init();
      return GlobalAccessFactory.getGlobalAccessObjects()
        .then(function (res) {
          return ConnectionStatusService.updatePropsBoundToViewModel(res);
        })
        .then(function (res) {
          return res;
        })
        .catch(function (err) {
          throw err;
        });
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('MachinesMetadata', metadataFactory);

  metadataFactory.$inject = [];
  /* ng-inject */
  function metadataFactory() {

    var factoryData = {};
    buildFactory();

    return {
      getData: getData
    };

    function getData() {
      return factoryData;
    }

    function buildFactory() {
      factoryData = {
        id: 'integration_machines_list',
        title: {
          label: 'Machines',
          editable: false,
          filterLabel: 'Filter machines'
        },
        orderBy: '-machineInfo.lastEditedTimeStamp',
        fabDialogConfig: {
          description: 'New Machine',
          controller: 'AddMachineDialogController as $ctrl',
          templateUrl: 'app/integration/dialogs/zp-add-machine-dialog/tmpl.html',
          ariaLabel: 'Create new machine',
          locals: {}
        }
      };
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('FieldMappingsPageRouteResolve', factory);

  factory.$inject = ['MachinesFactory', 'GlobalAccessFactory', 'MachineMappingsViewModel', 'MessageService'];
  /* ng-inject */
  function factory(MachinesFactory, GlobalAccessFactory, MachineMappingsViewModel, MessageService) {

    return function (_machineid) {
      return new Promise(function (resolve, reject) {
        const promiseArr = [];
        promiseArr.push(currentMachine(_machineid));
        promiseArr.push(buildViewModel());
        promiseArr.push(getThirdPartyLoginDetails());

        Promise.all(promiseArr)
          .then(function (res) {
            MessageService.writeLog({
              level: 'info',
              msg: 'resolving integration mappings page',
              tags: ['integration']
            });
            resolve({
              currentMachine: res[0],
              viewModel: res[1],
              getThirdPartyLoginDetails: res[2]
            });
          })
          .catch(function (err) {
            MessageService.showMessage(err);
            MessageService.writeLog({
              level: 'error',
              msg: 'error resolving integration mappings: ' + JSON.stringify(err),
              tags: ['integration']
            });
            reject(err);
          });
      });
    };

    function currentMachine(_machineid) {
      return MachinesFactory.getMachines()
        .then(function () {
          return MachinesFactory.getSingleMachineDoc(_machineid);
        })
        .then(function (res) {
          const machine = res.machine;
          MachineMappingsViewModel.init(machine);
          return machine;
        })
        .catch(function (err) {
          throw err;
        });
    }

    function buildViewModel() {
      return Promise.resolve(MachineMappingsViewModel.viewModel);
    }

    function getThirdPartyLoginDetails() {
      return GlobalAccessFactory.getGlobalAccessObjects()
        .then(function (res) {
          return res;
        })
        .catch(function (err) {
          throw err;
        });
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('MachineMappingsViewModel', factory);

  factory.$inject = ['BuildMachineViewModel', 'HydrateZuantFieldsColumn', 'ChangeDelta', 'MessageService', 'MachinesFactory', 'SessionService', 'localStorageService', 'GrabThirdPartyFieldsSvc', 'FinishBuildingMappingModel', 'UpdateMapping', 'AdjustZuantFieldMappingCount'];
  /* ng-inject */
  function factory(BuildMachineViewModel, HydrateZuantFieldsColumn, ChangeDelta, MessageService, MachinesFactory, SessionService, localStorage, GrabThirdPartyFieldsSvc, FinishBuildingMappingModel, UpdateMapping, AdjustZuantFieldMappingCount) {

    // factoryData and viewModel are globals within this factory
    const factoryData = {
        currentMachine: {}
      },
      viewModel = {
        zuantFields: {
          companies: [],
          contacts: [],
          responses: [],
          static: []
        },
        zuantFieldsLoading: false,
        zuantFieldMappingCounts: {}, // contact_lastname: 2
        mappingFastLookup: {}, // CompanyName: name // object keyed off third party fields showing which Zuant field is mapped to it.
        mappedFields: {},
        transformsExist: {},
        showDropArea: false,
        proxyMappings: [], // proxyMappings contain the mappings data as well as other properties used by the view (dirty flag and metadata)
        showFieldDataTypeIcons: false,
        showMachineInfo: false,
        loadingForeignFieldsIndicator: false,
        errorMessage: '',
        showFormSelect: false,
        showThirdPartyConnectionError: false,
        connectionError: {}
      },
      sourceFormConfig = {
        name: 'sourceFormId',
        placeholder: 'Choose a form containing fields to map',
        floatingLabel: 'Zuant source form',
        filter: null
      };

    return {
      init: buildMachineModelForView,
      changeDelta: ChangeDelta,
      sourceFormConfig: sourceFormConfig,
      grabSourceFormFields: grabSourceFormFields,
      deleteMachine: deleteMachine,
      grabThirdPartyFields: grabThirdPartyFields,
      manageMappingTransforms: manageMappingTransforms,
      showMachineSettingsDialog: showMachineSettingsDialog,
      saveMachine: saveMachine,
      updateMapping: updateMapping,
      deleteMappings: deleteMappings,
      clearUnmappedFieldsPrompt: clearUnmappedFieldsPrompt,
      factoryData: factoryData,
      viewModel: viewModel,
      addNewMappingRow: addNewMappingRow,
      checkForCachedFields: checkForCachedFields,
      showMachineJSONDialog: showMachineJSONDialog,
      addNewZuantField: addNewZuantField
    };


    function addNewZuantField(newFieldData) {
      viewModel.zuantFields[newFieldData.object].push({
        element: newFieldData.dbname,
        label: newFieldData.dbname,
        collection: newFieldData.object
      });

      AdjustZuantFieldMappingCount({
        collection: newFieldData.object,
        element: newFieldData.dbname
      }, null, viewModel);
      addFieldToLocalStorageForThisMachine(newFieldData);
    }

    function buildMachineModelForView(machine) {
      return BuildMachineViewModel(machine, viewModel, factoryData);
    }

    function grabSourceFormFields(selected) {
      const deltaConfig = {
        collection: 'machines',
        objectid: 'info',
        databasefieldname: 'sourceZuantFormId',
        oldval: factoryData.currentMachineCopy.sourceZuantFormId,
        newval: ''
      };

      if (selected.item) {
        if (selected.item._id === factoryData.currentMachine.sourceZuantFormId) return;
        viewModel.zuantFieldsLoading = true;
        factoryData.currentMachine.sourceZuantFormId = selected.item._id;
        deltaConfig.newval = selected.item._id;
        ChangeDelta.recordValueChange(deltaConfig);
        HydrateZuantFieldsColumn(selected.item._id, viewModel, factoryData);
      } else {
        factoryData.currentMachine.sourceZuantFormId = '';
        ChangeDelta.recordValueChange(deltaConfig);
        viewModel.zuantFields.companies.length = 0;
        viewModel.zuantFields.contacts.length = 0;
        viewModel.zuantFields.responses.length = 0;
        viewModel.zuantFields.static.length = 0;
        viewModel.zuantFieldsLoading = false;
      }
    }

    function deleteMachine(ev, machineIdToDelete) {
      return MessageService.confirm(ev)
        .delete()
        .then(function () {
          return MachinesFactory.deleteMachine(machineIdToDelete);
        });
    }

    function grabThirdPartyFields() {
      GrabThirdPartyFieldsSvc(factoryData, viewModel);
    }

    function manageMappingTransforms(config) {
      const oldTransformValue = angular.copy(config.locals.transform);
      return MessageService.showDialog(config.ev, config)
        .then(function (mapping) {
          updateChangeDelta(oldTransformValue, mapping);
        })
        .catch(function () {
          config.locals.transform = oldTransformValue;
        });
    }

    function updateChangeDelta(oldTransformValue, mapping) {
      const newTransformValue = angular.copy(mapping.transform);
      if (!angular.equals(oldTransformValue, newTransformValue)) {
        ChangeDelta.recordValueChange({
          collection: 'transform',
          objectid: mapping.hps.collection + '_' + mapping.hps.element,
          databasefieldname: mapping.hps.element,
          oldval: oldTransformValue,
          newval: mapping.transform
        });
        adjustTransformsExistLookup(mapping);
      }
    }

    function showMachineSettingsDialog(config) {
      const oldMachineInfoValues = angular.copy({
        name: factoryData.currentMachine.name,
        sourceZuantFormId: factoryData.currentMachine.sourceZuantFormId,
        machineInfo: factoryData.currentMachine.machineInfo,
        actuator: factoryData.currentMachine.actuator,
        useWildcardMapping: factoryData.currentMachine.useWildcardMapping,
        filters: factoryData.currentMachine.sensor.filters
      });
      return MessageService.showDialog(config.ev, config)
        .then(function (updatedMachineInfo) {
          if (!angular.equals(oldMachineInfoValues, updatedMachineInfo)) {
            ChangeDelta.recordValueChange({
              collection: 'machineInfo',
              objectid: 'info',
              databasefieldname: 'machineInfo',
              oldval: oldMachineInfoValues,
              newval: updatedMachineInfo
            });
          }
        })
        .catch(function () {
          factoryData.currentMachine.name = oldMachineInfoValues.name;
          factoryData.currentMachine.sourceZuantFormId = oldMachineInfoValues.sourceZuantFormId;
          factoryData.currentMachine.machineInfo = oldMachineInfoValues.machineInfo;
          factoryData.currentMachine.useWildcardMapping = oldMachineInfoValues.useWildcardMapping;
        });
    }

    function saveMachine() {
      const userData = SessionService.getUserData();
      factoryData.currentMachine.mappings = buildMappingsForSaving();
      factoryData.currentMachine.machineInfo.lastEditedBy = userData.firstname + ' ' + userData.surname;
      factoryData.currentMachine.machineInfo.lastEditedTimeStamp = new Date();

      MachinesFactory.saveMachine(factoryData.currentMachine, 'Machine saved')
        .then(function () {
          removeDirtyFlagFromRows();
          ChangeDelta.clear();
        });
    }

    function updateMapping(ix, itm, sourceCellConfig, unmappingField) {
      const fieldIdentifier = viewModel.proxyMappings[ix].mapping[0][viewModel.thirdPartyMappingKey].field;
      UpdateMapping(ix, itm, fieldIdentifier, viewModel, sourceCellConfig, unmappingField);
    }

    function deleteMappings(ev) {
      MessageService.confirm(ev)
        .confirmAction({
          title: 'Clear all mappings',
          content: 'Are you sure you want to clear your mappings and start again?',
          okBtn: 'Nuke em!',
          cancelBtn: 'Cancel'
        })
        .then(function () {

          _.each(viewModel.proxyMappings, function (item) {
            item.mapping[0].hps.collection = '';
            item.mapping[0].hps.element = '';
            item.mapping[0].transform = {};
          });

          viewModel.mappedFields = {};
          viewModel.transformsExist = {};
          viewModel.zuantFieldMappingCounts = {};

          const deltaConfig = {
            collection: 'machines',
            objectid: 'mappings',
            databasefieldname: 'deleteAll',
            oldval: 'mappings array',
            newval: ''
          };

          ChangeDelta.recordValueChange(deltaConfig);
          MessageService.writeLog({
            level: 'info',
            msg: 'user has deleted all mappings in this machine',
            tags: ['integration', '_machineid: ' + factoryData.currentMachine._machineid]
          });
        });
    }

    function clearUnmappedFieldsPrompt(ev) {
      MessageService.confirm(ev)
        .confirmAction({
          title: 'Clear unmapped fields',
          content: 'Mapped fields will remain',
          okBtn: 'Clear',
          cancelBtn: 'Cancel'
        })
        .then(function () {
          clearUnmappedFields();
          MessageService.writeLog({
            level: 'info',
            msg: 'user has cleared all unmapped fields in this machine',
            tags: ['integration', '_machineid: ' + factoryData.currentMachine._machineid]
          });
        });
    }

    function addNewMappingRow(newField) {
      const fieldExistsAlready = checkFieldExistsAlready(newField);
      if (!fieldExistsAlready) {
        pushFieldOntoProxyMappings(newField);
        addForeignFieldToLocalStorageForThisMachine({
          name: newField,
          caption: newField,
          object: 'Lead' // hardcoded here as only an HttpPost machine can add a field mapping
        });
        MessageService.writeLog({
          level: 'info',
          msg: 'addNewMappingRow',
          tags: ['integration', '_machineid: ' + factoryData.currentMachine._machineid]
        });
        return true;
      } else {
        MessageService.showMessage('That field already exists');
      }
    }

    function checkForCachedFields() {
      const localCopyOfForeignFields = localStorage.get('foreignFields_' + factoryData.currentMachine._machineid);
      if (localCopyOfForeignFields) {
        FinishBuildingMappingModel(localCopyOfForeignFields.fields, viewModel, factoryData);
      }
    }

    function showMachineJSONDialog(config) {

      return MessageService.showDialog(config.ev, config)
        .then(function () { })
        .catch(function () { });
    }

    //
    // PRIVATE TO THIS FACTORY
    //

    function pushFieldOntoProxyMappings(newField) {
      viewModel.proxyMappings.push({
        isDirty: false,
        mapping: [{
          hps: {
            element: '',
            collection: ''
          },
          transform: {},
          foreign: {
            field: newField,
            caption: newField,
            object: 'Lead'
          }
        }],
        mdata: {
          required: false,
          datatype: ''
        }
      });
    }

    function checkFieldExistsAlready(fieldname) {
      const fieldExists = _.find(viewModel.proxyMappings, function (obj) {
        return obj.mapping[0].foreign.field === fieldname;
      });
      return fieldExists;
    }

    function removeDirtyFlagFromRows() {
      _.each(viewModel.proxyMappings, function (mapping) {
        mapping.isDirty = false;
      });
    }

    function buildMappingsForSaving() {
      const updatedMappingsArray = _.chain(viewModel.proxyMappings)
        .reject(function (row) {
          return !row.mapping[0].hps.element; // remove unmapped fields
        })
        .map(function (row) {
          const ro = {
            hps: row.mapping[0].hps,
            transform: row.mapping[0].transform,
          };
          ro[viewModel.thirdPartyMappingKey] = buildThirdPartyMappingObjectStore(row.mapping[0][viewModel.thirdPartyMappingKey]);
          return ro; // return only the props we want to save
        })
        .value(); // spit out the mappings for saving

      return updatedMappingsArray;
    }

    function buildThirdPartyMappingObjectStore(mappingObj) {
      if (viewModel.thirdPartyMappingKey === 'eloqua') {
        if (factoryData.currentMachine.actuator.action === 'replicate') {
          // SOAP machines are required to save the `htmlName` value of the Eloqua field
          return _.extend({}, {
            field: mappingObj.field,
            object: mappingObj.object,
            fieldReference: mappingObj.fieldReference
          }, _.identity);
        } else {
          // whereas REST machines are required to save the `name` value of the Elqoua field
          return _.extend({}, {
            field: mappingObj.field, // TODO
            object: mappingObj.object,
            fieldReference: mappingObj.fieldReference
          }, _.identity);
        }
      } else if (viewModel.thirdPartyMappingKey === 'sfdc') {
        return {
          field: mappingObj.field,
          object: mappingObj.object
        };
      } else {
        // http post
        return {
          field: mappingObj.field,
          object: mappingObj.object
        };
      }
    }

    function clearUnmappedFields() {
      updateProxyMappings();
      localStorage.set('foreignFields_' + factoryData.currentMachine._machineid, {
        fields: [],
        timestamp: new Date()
      });
      MessageService.showMessage('Fields cleared');
    }

    function updateProxyMappings() {
      // find items that do have a mapping
      const itemsToKeep = _.filter(viewModel.proxyMappings, function (obj) {
        return obj.mapping[0].hps.element !== '' && obj.mapping[0].hps.collection !== '';
      });
      // empty array, keep view binding
      viewModel.proxyMappings.length = 0;
      // rebuild array with only mapped rows
      _.each(itemsToKeep, function (item) {
        viewModel.proxyMappings.push(item);
      });
    }

    function adjustTransformsExistLookup(mapping) {
      if (!_.isEmpty(mapping.transform)) {
        viewModel.transformsExist[mapping[viewModel.thirdPartyMappingKey].field] = true;
      }
      if (_.isEmpty(mapping.transform) && viewModel.transformsExist[mapping[viewModel.thirdPartyMappingKey].field]) {
        delete viewModel.transformsExist[mapping[viewModel.thirdPartyMappingKey].field];
      }
    }

    function addForeignFieldToLocalStorageForThisMachine(field) {
      MessageService.writeLog({
        level: 'info',
        msg: 'adding new foreign field for this machine: object = ' + field.object + ', dbname = ' + field.name,
        tags: ['integration', 'column_B_fields']
      });
      const extraForeignFieldsForThisMachine = localStorage.get('foreignFields_' + factoryData.currentMachine._machineid) || {
        fields: [],
        timestamp: ''
      };
      extraForeignFieldsForThisMachine.fields.push(field);
      extraForeignFieldsForThisMachine.timestamp = new Date();
      localStorage.set('foreignFields_' + factoryData.currentMachine._machineid, extraForeignFieldsForThisMachine);
    }

    function addFieldToLocalStorageForThisMachine(field) {
      MessageService.writeLog({
        level: 'info',
        msg: 'adding new field to column A: object = ' + field.object + ', dbname = ' + field.dbname,
        tags: ['column_A_fields']
      });
      const extraFieldsForThisMachine = localStorage.get('extraFields_' + factoryData.currentMachine._machineid) || [];
      extraFieldsForThisMachine.push(field);
      localStorage.set('extraFields_' + factoryData.currentMachine._machineid, extraFieldsForThisMachine);
    }

  }

}());

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('GlobalAccessFactory', GlobalAccessFactory);

  GlobalAccessFactory.$inject = ['MessageService', 'SessionService', 'ClientsAPI', '$filter'];

  function GlobalAccessFactory(MessageService, SessionService, ClientsAPI, $filter) {
    const factoryData = {
      globalAccessObjects: {
        eloquaGlobalAccess: createEmptyEloquaCreds(),
        sfdcglobalaccess: createEmptySfdcCreds()
      },
      globalAccessModificationHistory: [],
      hasEloquaLogin: false,
      hasSfdcLogin: false
    };

    const platforms = {
      ELOQUA: 'Eloqua',
      SFDC: 'SFDC'
    };

    return {
      init: resetFactory,
      factoryData,
      getGlobalAccessObjects,
      getLoginCredentials,
      deleteLogin,
      saveConnection,
      updateEloquaBaseUrl,
      getListOfAvailableIntegrations,
      getListOfConfiguredIntegrations,
      setConnectionResult,
      saveSuccessfulConnectionTimestamp,
      updatePlatformConnectedValue
    };

    function resetFactory() {
      _.assign(factoryData, {
        globalAccessObjects: {
          eloquaGlobalAccess: createEmptyEloquaCreds(),
          sfdcglobalaccess: createEmptySfdcCreds()
        },
        globalAccessModificationHistory: [],
        hasEloquaLogin: false,
        hasSfdcLogin: false
      });
    }

    function createEmptyEloquaCreds() {
      return {
        baseUrl: '',
        rootURL: '',
        instancename: '',
        username: '',
        password: '',
        _lastSuccessfulConnection: ''
      };
    }

    function createEmptySfdcCreds() {
      return {
        uri: '',
        clientid: '',
        clientsecret: '',
        securitytoken: '',
        username: '',
        password: '',
        _lastSuccessfulConnection: ''
      };
    }

    function updatePlatformConnectedValue(platform) {
      if (platform === platforms.ELOQUA) factoryData.hasEloquaLogin = true;
      if (platform === platforms.SFDC) factoryData.hasSfdcLogin = true;
    }

    function getGlobalAccessObjects() {
      return ClientsAPI.getClientGlobalAccessObjectsByClientId(SessionService.getUserData().clientId)
        .then(res => {
          processGlobalAccessObjectsResponse(res);
          return 'logins loaded';
        });
    }

    function getLoginCredentials(platform) {
      return platform === platforms.SFDC
        ? factoryData.globalAccessObjects.sfdcglobalaccess
        : factoryData.globalAccessObjects.eloquaGlobalAccess;
    }

    function saveConnection(platform) {
      const clientId = SessionService.getUserData().clientId;
      const data = { _id: clientId };

      const delta = {};
      const rawDelta = {};

      if (platform === platforms.SFDC) {
        rawDelta.sfdcglobalaccess = factoryData.globalAccessObjects.sfdcglobalaccess;
        delta.sfdcglobalaccess = _.omit(rawDelta.sfdcglobalaccess, ['_lastSuccessfulConnection', '_lastConnectionAttempt']);
      } else if (platform === platforms.ELOQUA) {
        rawDelta.eloquaGlobalAccess = factoryData.globalAccessObjects.eloquaGlobalAccess;
        delta.eloquaGlobalAccess = _.omit(rawDelta.eloquaGlobalAccess, ['_lastSuccessfulConnection', '_lastConnectionAttempt']);
      }

      const user = SessionService.getUserData();

      const history = factoryData.globalAccessModificationHistory;
      const lastEntry = _.find(history, function (entry) {
        return entry.platform === platform;
      });

      if (lastEntry && _.isEqual(lastEntry.delta, delta)) {
        MessageService.writeLog({
          level: 'info',
          msg: `🔁 No change in ${platform} integration access cedentials — skipping DB write.`,
          tags: ['integration']
        });
        return Promise.resolve();
      }

      history.unshift({
        platform,
        timestamp: new Date(),
        user: {
          _id: user._id,
          username: user.username
        },
        delta
      });

      data.globalAccessModificationHistory = factoryData.globalAccessModificationHistory;

      _.assign(data, rawDelta);

      writeSaveConnectionLog(platform, data);

      return ClientsAPI.postClientData(data)
        .then(response => {
          MessageService.writeLog({ level: 'info', msg: '💾 client integration credentials save success', tags: ['integration'] });
          return response.data.data;
        })
        .catch(err => {
          MessageService.writeLog({ level: 'error', msg: '💾 error saving client data for integration credentials' + JSON.stringify(err), tags: ['integration'] });
          throw err;
        });
    }

    function updateEloquaBaseUrl(baseUrl) {
      factoryData.globalAccessObjects.eloquaGlobalAccess.baseUrl = baseUrl;
    }

    function processGlobalAccessObjectsResponse(data) {
      const eloqua = data.eloquaGlobalAccess;
      const sfdc = data.sfdcglobalaccess;
      const globalAccessModificationHistory = data.globalAccessModificationHistory || [];

      factoryData.hasEloquaLogin = eloquaConnectionIsConfigured(eloqua);
      factoryData.globalAccessObjects.eloquaGlobalAccess = _.extend({}, factoryData.globalAccessObjects.eloquaGlobalAccess, eloqua || {});

      factoryData.hasSfdcLogin = sfdcConnectionIsConfigured(sfdc);
      factoryData.globalAccessObjects.sfdcglobalaccess = _.extend({}, factoryData.globalAccessObjects.sfdcglobalaccess, sfdc || {});

      factoryData.globalAccessModificationHistory = globalAccessModificationHistory;
    }

    function eloquaConnectionIsConfigured(config) {
      return !!config && (config.rootURL || config.baseUrl) && config.instancename && config.username && config.password;
    }

    function sfdcConnectionIsConfigured(config) {
      return !!config && config.clientid && config.clientsecret && config.securitytoken && config.username && config.password;
    }

    function getListOfConfiguredIntegrations() {
      const integrations = [];

      if (factoryData.hasEloquaLogin) {
        integrations.push({
          name: 'eloqua',
          value: 'eloqua',
          img: $filter('cdnAssets')('/images/pngs/icons/third-party/eloqua-square.png'),
          creds: factoryData.globalAccessObjects.eloquaGlobalAccess
        });
      }

      if (factoryData.hasSfdcLogin) {
        integrations.push({
          name: 'sfdc',
          value: 'sfdc',
          img: $filter('cdnAssets')('/images/pngs/icons/third-party/salesforce-square.png')
        });
      }

      return integrations;
    }

    function getListOfAvailableIntegrations() {
      return [
        {
          name: 'Http Post',
          value: 'HttpPost',
          img: $filter('cdnAssets')('/images/pngs/icons/third-party/http.png'),
          configurable: false,
          configured: true,
          _lastSuccessfulConnection: 'N/A',
          hasMachines: true
        },
        {
          name: 'Salesforce.com',
          value: platforms.SFDC,
          img: $filter('cdnAssets')('/images/pngs/icons/third-party/salesforce-square.png'),
          configurable: true,
          configured: factoryData.hasSfdcLogin,
          _lastSuccessfulConnection: factoryData.globalAccessObjects.sfdcglobalaccess._lastSuccessfulConnection || 'Never',
          hasMachines: true
        },
        {
          name: 'Eloqua',
          value: platforms.ELOQUA,
          img: $filter('cdnAssets')('/images/pngs/icons/third-party/eloqua-square.png'),
          configurable: true,
          configured: factoryData.hasEloquaLogin,
          _lastSuccessfulConnection: factoryData.globalAccessObjects.eloquaGlobalAccess._lastSuccessfulConnection || 'Never',
          hasMachines: true
        }
      ];
    }

    function setConnectionResult(platform, statusObj) {
      const creds = getLoginCredentials(platform);
      const hasLoginKey = platform === platforms.ELOQUA ? 'hasEloquaLogin' : 'hasSfdcLogin';
      factoryData[hasLoginKey] = true;

      if (statusObj.status === 'success') {
        creds._lastSuccessfulConnection = creds._lastConnectionAttempt = statusObj.timestamp;
      } else if (statusObj.status === 'failure') {
        creds._lastConnectionAttempt = statusObj.timestamp;
      }
    }

    function saveSuccessfulConnectionTimestamp(platform) {
      const data = {
        _id: SessionService.getUserData().clientId
      };

      if (platform === 'sfdc') {
        data.sfdcglobalaccess = factoryData.globalAccessObjects.sfdcglobalaccess;
      } else if (platform === 'eloqua') {
        data.eloquaGlobalAccess = factoryData.globalAccessObjects.eloquaGlobalAccess;
      }

      return ClientsAPI.postClientData(data)
        .then(response => response.data.data);
    }

    function deleteLogin(platform) {
      const key = platform.value;
      if (key === platforms.ELOQUA) {
        factoryData.globalAccessObjects.eloquaGlobalAccess = createEmptyEloquaCreds();
        factoryData.hasEloquaLogin = false;
      } else if (key === platforms.SFDC) {
        factoryData.globalAccessObjects.sfdcglobalaccess = createEmptySfdcCreds();
        factoryData.hasSfdcLogin = false;
      }

      return saveConnection(key)
        .then(() => {
          MessageService.writeLog({ level: 'info', msg: 'login deleted for ' + key, tags: ['integration', 'logins_deleted'] });
          MessageService.showMessage(key + ' login deleted');
        })
        .catch(() => {});
    }

    function writeSaveConnectionLog(platform, data) {
      if (platform === platforms.SFDC) {
        const logData = _.omit(data.sfdcglobalaccess, ['username', 'password']);
        MessageService.writeLog({
          level: 'info',
          msg: 'Saving global access for SFDC. data: ' + JSON.stringify(logData),
          tags: ['integration']
        });
      } else if (platform === platforms.ELOQUA) {
        const logData = _.omit(data.eloquaGlobalAccess, ['username', 'password']);
        MessageService.writeLog({
          level: 'info',
          msg: 'Saving global access for Eloqua. data: ' + JSON.stringify(logData),
          tags: ['integration']
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('integration')
    .service('EloquaConnectionService', EloquaConnectionService);

  EloquaConnectionService.$inject = ['IntegrationApiFactory', 'GlobalAccessFactory', 'MessageService'];

  function EloquaConnectionService(IntegrationApiFactory, GlobalAccessFactory, MessageService) {
    return {
      testConnection,
      getEloquaForms,
      getEloquaFormById,
      queryEloquaForms
    };

    function testConnection(eloquaLoginCreds) {
      const validatedCreds = _.pickBy(eloquaLoginCreds, _.identity);
      if (_.isEmpty(validatedCreds)) return;

      return IntegrationApiFactory.testEloquaConnection(validatedCreds)
        .then(res => ({
          status: 'ok',
          baseUrl: res.base
        }))
        .catch(handleError);
    }

    function getEloquaForms() {
      const creds = GlobalAccessFactory.getLoginCredentials('Eloqua');
      return IntegrationApiFactory.getAllEloquaForms(creds)
        .then(res => res.elements)
        .catch(handleError);
    }

    function getEloquaFormById(formId) {
      const creds = GlobalAccessFactory.getLoginCredentials('Eloqua');
      const payload = Object.assign({ formId }, creds);

      return IntegrationApiFactory.getEloquaFormById(payload)
        .then(res => res.elements.filter(el => el.type === 'FormField'))
        .catch(handleError);
    }

    function queryEloquaForms(query) {
      const creds = GlobalAccessFactory.getLoginCredentials('Eloqua');
      const payload = Object.assign({}, creds, { query });

      return IntegrationApiFactory.queryEloquaForms(payload)
        .then(res => res.elements)
        .catch(handleError);
    }

    function handleError(err) {
      MessageService.writeLog({
        level: 'error',
        msg: err,
        tags: ['integration', 'eloquaREST']
      });
      // Swallow error for get/query functions but propagate for testConnection
      if (err && err.status !== 'ok') throw err;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('integration')
    .config(moduleConfig);

  moduleConfig.$inject = ['$stateProvider'];
  /* @ngInject */
  function moduleConfig($stateProvider) {

    $stateProvider
      .state('app.homescreen_app_framework.integration-home', {
        title: 'Integration Home',
        url: '/integration',
        views: {
          toolbarSection: {
            component: 'zpSearchToolbar',
            bindings: {
              metadata: 'resolveObj.metadata'
            }
          },
          spof: {
            component: 'zpMachinesListView',
            bindings: {
              machines: 'resolveObj.machines',
              metadata: 'resolveObj.metadata'
            }
          },
          'right-hand-container': {
            component: 'zpMachineListPageSideContainer',
            bindings: {
              machines: 'resolveObj.machines'
            }
          },
          'fab-container': {
            component: 'zpAddMachineFab',
            bindings: {
              machines: 'resolveObj.machines',
              metadata: 'resolveObj.metadata'
            }
          }
        },
        resolve: {
          resolveObj: ['IntegrationHomePageRouteResolve', function (IntegrationHomePageRouteResolve) {
            return IntegrationHomePageRouteResolve()
              .then(function (res) {
                return res;
              })
              .catch(function (err) {
                return err;
              });
          }]
        },
        data: {
          permissions: {
            only: ['INTEGRATION_MACHINES_VIEW']
          }
        }
      })
      .state('app.custom_toolbar_app_framework.mappings-view', {
        url: '/machines/mapping/:?_machineid',
        title: 'Integration Machine',
        views: {
          spof: {
            component: 'zpMappingsComponent',
            bindings: {
              currentMachine: 'resolveObj.currentMachine'
            }
          },
          'spofSibling': {
            component: 'zpMappingScreenSidebar',
            bindings: {
              currentMachine: 'resolveObj.currentMachine'
            }
          },
          'custom-toolbar': {
            component: 'zpMappingsToolbarComponent',
            bindings: {
              currentMachine: 'resolveObj.currentMachine'
            }
          },
          'fab-container': {
            component: 'saveMachineFab'
          }
        },
        resolve: {
          resolveObj: ['FieldMappingsPageRouteResolve', '$stateParams', function (FieldMappingsPageRouteResolve, $stateParams) {
            const _machineid = decodeURIComponent($stateParams._machineid);
            return FieldMappingsPageRouteResolve(_machineid)
              .then(function (res) {
                return res;
              })
              .catch(function (err) {
                return err;
              });
          }]
        },
        data: {
          permissions: {
            only: ['INTEGRATION_MACHINES_VIEW']
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpSettingsPage', {
      templateUrl: 'app/forms/settings-page/settings.tmpl.html',
      controller: 'zpFormSettingsController',
      bindings: {
        machinesThatWillRunForThisForm: '<',
        formId: '<',
        formProperties: '<'
      }
    })
    .controller('zpFormSettingsController', zpFormSettingsController)
    .directive('whenscrollends',whenscrollends);

  zpFormSettingsController.$inject = ['EventZubot', '$log', '$scope', 'ChangeDelta', 'FormMetadataFactory', 'MessageService', 'EZMenuItems', 'EmailTemplatesFactory', 'SingleFormFactory', 'hotkeys', 'EnvService', 'ColumnSummaryMetadataFactory', '$timeout', '$state', 'ToolbarFactory', 'MasterPermissionsDefinitionFactory', 'FormPropertyHelpersFactory', 'ClientsAPI', 'SessionService', 'FormsFactory', 'TeamsAPI', 'recalculateTreeStructureForTeams', 'ZuantAccountManagersFactory', 'PostShowEmailFactory', 'CurrencyHelperFactory'];
  /* ng-inject */
  function zpFormSettingsController(EventZubot, $log, $scope, ChangeDelta, FormMetadataFactory, MessageService, EZMenuItems, EmailTemplatesFactory, SingleFormFactory, hotkeys, EnvService, ColumnSummaryMetadataFactory, $timeout, $state, toolbarfactory, MasterPermissionsDefinitionFactory, FormPropertyHelpersFactory, ClientsAPI, session, FormsFactory, TeamsAPI, recalculateTreeStructureForTeams, ZuantAccountManagersFactory, PostShowEmailFactory, CurrencyHelperFactory) {

    var vm = this;

    vm.loading = true;
    vm.currencyScrollIndex = 0;
    vm.ezMenuItems = [];
    vm.emailTemplates = [];
    vm.formDocs = [];
    vm.metadata = {};
    vm.changeDelta = ChangeDelta;
    vm.showHints = false;
    vm.showTips = false;
    vm.currentNavItem = 'settings';
    vm.teams = [];
    vm.treeStructuredTeams = [];
    vm.teamFilter = '';
    vm.currencyList = [];
    vm.showShowroomPanel = false;

    vm.data = {
      items: []
    };

    vm.ezMenuSortableConfig = {
      sort: true
    };

    vm.formTimezonesConfig = {
      placeholder: 'Pick a timezone for this form',
      floatingLabel: 'Form timezone',
      required: true,
      name: 'formTimezone'
    };

    vm.showroomFormConfig = {
      name: 'showroomFormId',
      placeholder: 'Choose a showroom form',
      floatingLabel: 'Showroom form',
      required: false
    };

    vm.emailTemplateConfig = {
      placeholder: 'Pick an email template for this form',
      floatingLabel: 'Email template',
      label: 'Email template'
    };

    vm.ocrTemplateConfig = {
      placeholder: 'Pick a biz card scanning template for this form',
      floatingLabel: 'Business card scanning template',
      label: 'Biz card scanning template'
    };

    vm.blocksListConfig = {
      placeholder: 'Pick an entry block for this form',
      floatingLabel: 'Entry block',
      label: 'Entry block'
    };

    vm.privacyStatementConfig = {
      placeholder: 'Pick a privacy statement for this form',
      floatingLabel: 'Form Privacy statement',
      label: 'Privacy statement for form'
    };

    vm.$onInit = function () {
      vm.userIsZAM = ZuantAccountManagersFactory.loggedInUserIsAZam();
      vm.postShowFactoryData = PostShowEmailFactory.factoryData;
      vm.availableEzMenuItems = EZMenuItems;
      vm.isDev = EnvService.isDev;
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.formPropertyHelpers = FormPropertyHelpersFactory;
      // get form settings data and do necessary bits and bobs to get it setup for the view
      vm.gridColumnWarnings = ColumnSummaryMetadataFactory.getData().warnings.missingArtefacts;
      vm.formDependencies = ColumnSummaryMetadataFactory.getData().metadata.artefactDependencies;

      if (!vm.formProperties.technicalContacts) vm.formProperties.technicalContacts = [];
      if (vm.formProperties.emailTemplate) {
        const matchedTemplateObj = EmailTemplatesFactory.factoryData.allItemsObject[vm.formProperties.emailTemplate];
        if (matchedTemplateObj) {
          vm.emailTemplateTitle = matchedTemplateObj.emailtemplate.title;
          vm.emailTemplate = matchedTemplateObj.emailtemplate;
        } else {
          vm.emailTemplateTitle = '';
        }
      } else {
        vm.emailTemplateTitle = '';
      }

      resetEzMenuItems();
      getFormSettingsReadyForView();

      $timeout(function () {
        vm.stopShouting = true; // alert box shake if there's missing artefacts referenced within the form.
      }, 1500);

      ClientsAPI.getClientById(session.getUserData().clientId)
        .then(function (res) {
          vm.accountIsPermittedToWaiveGDPRCompliance = res.data.data.GDPR.waiveForNominatedForms ? res.data.data.GDPR.waiveForNominatedForms : false;
        });

      hotkeys.add({
        combo: 'ctrl+s',
        description: 'Save form settings',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function () {
          vm.onSave();
        }
      });

    };
    // end onInit

    vm.availableTeamFilter = function (item) {
      if (!item.name) {
        return false;
      }
      return item.name.toLowerCase().indexOf(vm.teamFilter.toLowerCase()) > -1 || vm.teamFilter === '';
    };

    function resetEzMenuItems() {
      _.each(vm.availableEzMenuItems, function (item) {
        item.inMenu = false;
      });
    }

    vm.toggleShowroomPanel = function () {
      vm.showShowroomPanel = !vm.showShowroomPanel;
    };

    $scope.$on('zpSaveFormSettings', function () {
      vm.onSave();
    });

    vm.updateSelectControl = function (params) {
      let newValue;
      const selected = params.item;
      const formProp = params.formProp;

      try {
        if (formProp === 'emailTemplate' || formProp === 'showroomFormId' || formProp === 'privacyStatement') {
          newValue = selected._id;
          if (formProp === 'emailTemplate' && vm.emailTemplate) delete vm.emailTemplate; // clears emailTemplate flag that gets set if archived template is attached to the form
        } else if (formProp === 'formTimezone' || formProp === 'ocrTemplate') {
          newValue = selected || '';
        }
      } catch (e) {
        newValue = '';
      } finally {
        if (newValue !== vm.formProperties[formProp]) {
          vm.formProperties[formProp] = newValue;
          vm.updateChangeDelta(formProp, newValue);
        }
      }
    };

    function defaultValueFor(value) {
      if (_.isNumber(value)) return 0;
      if (_.isString(value)) return '';
      if (_.isArray(value)) return [];
      if (_.isBoolean(value)) return false;
      if (_.isPlainObject(value)) return {};
      return undefined;
    }

    vm.updateChangeDelta = function (property, newValue) {
      const lastSaved = vm.lastSavedStateOfFormProperties || {};
      const oldValue = _.isNil(lastSaved[property]) ? defaultValueFor(newValue) : lastSaved[property];

      ChangeDelta.recordValueChange({
        oldval: oldValue,
        newval: newValue,
        collection: 'forms',
        objectid: vm.formProperties._id,
        databasefieldname: property
      });
      if (property === 'startdate' && vm.formProperties.enddate < newValue) {
        vm.formSettingsForm.enddate.$error.mindate = true;
      }
    };

    vm.manuallyUpdateFormProp = function (property, newValue) {
      const oldValue = vm.lastSavedStateOfFormProperties[property];
      vm.formProperties[property] = newValue;
      ChangeDelta.recordValueChange({
        oldval: oldValue,
        newval: newValue,
        collection: 'forms',
        objectid: vm.formProperties._id,
        databasefieldname: property
      });
    };

    vm.updateChangeDeltaNested = function (property1, property2, newValue) {
      const oldValue = vm.lastSavedStateOfFormProperties[property1][property2];
      vm.formProperties[property1][property2] = newValue;
      ChangeDelta.recordValueChange({
        oldval: oldValue,
        newval: newValue,
        collection: 'forms',
        objectid: vm.formProperties._id,
        databasefieldname: property1 + '.' + property2
      });
    };

    vm.onSave = function () {
      if (!validateFormSettings()) return;

      const formId = vm.formProperties._id;
      const changeDeltas = ChangeDelta.getDeltaObject();
      const deltaPayload = ChangeDelta.buildChangesPayload(changeDeltas);

      const deltas = deltaPayload.forms[formId];

      toolbarfactory.set({
        title: vm.formProperties.formname
      });

      prepareFormPropertiesForSave(deltas);

      SingleFormFactory.saveForm(formId, deltas)
        .then(function () {
          return EventZubot.postUpdate(vm.formProperties._id);
        })
        .then(function () {
          return EventZubot.postExecutiveSummaryUpdate(vm.formProperties._id);
        })
        .then(function () {
          vm.lastSavedStateOfFormProperties = angular.copy(Object.assign(vm.lastSavedStateOfFormProperties, deltas));
          const invalidateFormsFactoryToo = true; // invalidates client side caches of forms and emailTemplate collections
          EmailTemplatesFactory.invalidateCache(invalidateFormsFactoryToo);
          FormMetadataFactory.invalidateCache();
          buildEmailPanelBlurb();
          ChangeDelta.clear();
          MessageService.showMessage('Changes saved');
          MessageService.writeLog({
            level: 'info',
            msg: 'form properties changes saved.',
            tags: ['saving_form_properties']
          });
        })
        .catch(function (err) {
          $log.error(err);
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err,
            tags: ['saving_form_properties']
          });
        });
    };

    vm.deleteForm = function () {
      vm.sureToBeSure = true;
    };

    vm.minDateCheck = function (date) {
      return date >= vm.formProperties.startdate;
    };

    vm.confirmDeleteForm = function () {
      FormsFactory.deleteForm(vm.formId)
        .then(function (resp) {
          if (resp.status == 204) {
            MessageService.showMessage('FORM DELETED');
            MessageService.pushEventToIntercom('form_deleted', {
              formId: vm.formId
            });
            FormsFactory.invalidateCache();
            $state.go('app.homescreen_app_framework.forms_home');
          }
        })
        .catch(function (err) {
          $log.error(err);
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };

    function validateFormSettings() {
      if (!vm.formSettingsForm.$valid) {
        MessageService.showMessage('Form invalid, please check required fields');
        return false;
      } else {
        return true;
      }
    }

    function prepareFormPropertiesForSave(rawValuesForServerSave) {
      prepBlocksMenuSave(rawValuesForServerSave);
      prepEzMenuItemsForSave(rawValuesForServerSave);
      prepTeamVisibilityItemsForSave(rawValuesForServerSave);
    }

    function prepBlocksMenuSave(formProperties) {
      if (!(Object.keys(formProperties).some((key) => key.includes('blocksMenu') || key.includes('blockText')))) return;
      if (vm.blocksMenuBackgroundColorAdjusted) {
        formProperties['blocksMenu.backgroundColor'] = tinycolor(vm.blocksMenuBackgroundColorAdjusted).toHex();
        delete formProperties['blocksMenuBackgroundColorAdjusted'];
      }
      if (vm.blocksMenuBackgroundColorAdjusted) {
        formProperties['blocksMenu.backgroundAlpha'] = tinycolor(vm.blocksMenuBackgroundColorAdjusted).getAlpha();
        formProperties['blocksMenu.backgroundAlpha'] = tinycolor(vm.blocksMenuBackgroundColorAdjusted).getAlpha().toString();
        delete formProperties['blocksMenuBackgroundColorAdjusted'];
      }
      if (vm.blocksMenuBackgroundColorAdjusted) {
        formProperties['blocksMenu.backgroundColor'] = tinycolor(vm.blocksMenuBackgroundColorAdjusted).toHex();
        delete formProperties['blocksMenuBackgroundColorAdjusted'];
      }
      if (vm.blocksMenuColorAdjusted) {
        formProperties['blocksMenu.blockColor'] = tinycolor(vm.blocksMenuColorAdjusted).toHex();
        delete formProperties['blocksMenuColorAdjusted'];
      }
      if (vm.blockTextColorAdjusted) {
        formProperties['blocksMenu.blockTextColor'] = tinycolor(vm.blockTextColorAdjusted).toHex();
        delete formProperties['blockTextColor'];
      }
      if (vm.blocksMenuColorAdjusted) {
        formProperties['blocksMenu.blockCaptionColor'] = tinycolor(vm.blockCaptionColorAdjusted).toHex();
        delete formProperties['blockCaptionColor'];
      }
    }

    function prepEzMenuItemsForSave(rawValuesForServerSave) {
      const objToSave = {};
      let notesMandatorySatisfied = true;
      let showroomMandatorySatisfied = true;

      if (vm.formProperties.requireNotes) {
        notesMandatorySatisfied = false;
      }
      if (vm.formProperties.requireLiterature) {
        showroomMandatorySatisfied = false;
      }

      const hasPendingMenuItemUpdates = Object.keys(rawValuesForServerSave).some((key) => key.includes('ezMenuItems'));
      _.each(vm.ezMenuItems, function (selectedItem, index) {
        if (hasPendingMenuItemUpdates) objToSave[index] = selectedItem.action;
        if (vm.formProperties.requireNotes && selectedItem.action === 'notesButtonTapped') {
          notesMandatorySatisfied = true;
        }
        if (vm.formProperties.requireLiterature && selectedItem.action === 'showroomButtonTapped') {
          showroomMandatorySatisfied = true;
        }
      });

      _.each(EZMenuItems, function (availableItem) {
        // loop entire available ezmenuitems so as to remove from the update doc as we will rebuild next
        delete rawValuesForServerSave['ezMenuItems.' + availableItem.action];
      });

      if (!notesMandatorySatisfied) {
        objToSave[vm.ezMenuItems.length] = 'notesButtonTapped';
        const itemToAdd = _.find(EZMenuItems, function (itm) {
          return itm.action === 'notesButtonTapped';
        });

        if (itemToAdd) {
          itemToAdd.inMenu = true;
          vm.ezMenuItems.push(itemToAdd);
        }
      }
      if (!showroomMandatorySatisfied) {
        objToSave[vm.ezMenuItems.length] = 'showroomButtonTapped';
        const itmToAdd = _.find(EZMenuItems, function (itm) {
          return itm.action === 'showroomButtonTapped';
        });

        if (itmToAdd) {
          itmToAdd.inMenu = true;
          vm.ezMenuItems.push(itmToAdd);
        }
      }

      if (Object.keys(objToSave).length > 0) rawValuesForServerSave.ezMenuItems = objToSave;
      return;
    }

    function prepTeamVisibilityItemsForSave(rawValuesForServerSave) {
      if (!(Object.keys(rawValuesForServerSave).some((key) => key.includes('_vtags')))) return;
      const objToSave = [];

      _.each(vm.teams, function (selectedItem) {
        if (selectedItem.selected) {
          objToSave.push(selectedItem._id);
        }
      });

      if (objToSave.length > 0) rawValuesForServerSave._vtags = objToSave;
      return;
    }

    function getFormSettingsReadyForView() {
      vm.formId = vm.formProperties._id;
      vm.formProperties.archived = vm.formProperties._deletedatelocalutc ? 1 : vm.formProperties.archived ? 1 : 0;
      setBlocksMenuPanel();
      setBarcodeSettings();
      buildEZMenu(vm.formProperties);
      buildTeamVisibilityItems(vm.formProperties);
      calculateCameraModesCount();
      setFormDates();
      buildEmailPanelBlurb();
      buildCurrencyList(vm.formProperties);
      // make a copy of form settings for dirty checking
      vm.lastSavedStateOfFormProperties = angular.copy(vm.formProperties);
    }

    function setBarcodeSettings() {
      if (!vm.formProperties.barcodeMappings) {
        vm.formProperties.barcodeMappings = [];
      }
      vm.countOfBarcodeFieldsMapped = vm.formProperties.barcodeMappings.length;
    }

    function setBlocksMenuPanel() {
      if (!vm.formProperties.blocksMenu || angular.equals(vm.formProperties.blocksMenu, {})) {
        vm.formProperties.blocksMenu = {
          useBlocksMenu: '0',
          backgroundAlpha: '.9',
          blockColor: '78CDD1',
          blockTextColor: 'ffffff',
          blockCaptionColor: 'D1A245',
          backgroundColor: 'FEC353',
          captureLeadText: 'Capture lead',
          backgroundImageContentMode: 'scaleAspectFill',
          navigationBackButtonAvailable: '1',
          showroomCanBeDismissed: '1',
          filtersAvailable: '1',
          blocksCanBeDismissed: '1'
        };
      } else {
        if (vm.formProperties.blocksMenu.useBlocksMenu) {
          // if blocks is enabled but below settings aren't explicitly set, default them to on so we match the app defaults
          if (!vm.formProperties.blocksMenu.navigationBackButtonAvailable) vm.formProperties.blocksMenu.navigationBackButtonAvailable = '1';
          if (!vm.formProperties.blocksMenu.showroomCanBeDismissed) vm.formProperties.blocksMenu.showroomCanBeDismissed = '1';
          if (!vm.formProperties.blocksMenu.filtersAvailable) vm.formProperties.blocksMenu.filtersAvailable = '1';
          if (!vm.formProperties.blocksMenu.blocksCanBeDismissed) vm.formProperties.blocksMenu.blocksCanBeDismissed = '1';
        }
        if (vm.formProperties.blocksMenu.backgroundColor) {
          const color = tinycolor(vm.formProperties.blocksMenu.backgroundColor).setAlpha(vm.formProperties.blocksMenu.backgroundTransparency).toRgbString();
          vm.blocksMenuBackgroundColorAdjusted = color;
        }
        if (vm.formProperties.blocksMenu.blockColor) {
          vm.blocksMenuColorAdjusted = '#' + vm.formProperties.blocksMenu.blockColor;
        }
        if (vm.formProperties.blocksMenu.blockTextColor) {
          vm.blockTextColorAdjusted = '#' + vm.formProperties.blocksMenu.blockTextColor;
        }
        if (vm.formProperties.blocksMenu.blockCaptionColor) {
          vm.blockCaptionColorAdjusted = '#' + vm.formProperties.blocksMenu.blockCaptionColor;
        }
      }
    }

    function setFormDates() {
      if (vm.formProperties.startdate) {
        vm.formProperties.startdate = new Date(vm.formProperties.startdate); // create a date object for cal picker
      }
      if (vm.formProperties.enddate) {
        vm.formProperties.enddate = new Date(vm.formProperties.enddate); // create a date object for cal picker
      }
    }

    function buildEmailPanelBlurb() {

      const formStartDate = moment(vm.formProperties.startdate),
        formEndDate = moment(vm.formProperties.enddate).endOf('day'),
        now = moment();

      if (formStartDate && formEndDate) {

        vm.isBeforeStartDate = now.isBefore(formStartDate);
        vm.isBetweenStartAndEndDate = now.isBetween(moment(formStartDate), formEndDate, 'days', '[]');
        vm.isAfterEndDate = now.isAfter(formEndDate);
        vm.daysTilEndDate = now.to(formEndDate);
        vm.daysTilStartDate = now.to(formEndDate);

      }

    }

    function buildCurrencyList (formProperties){
      vm.currencyList = CurrencyHelperFactory.getAllCurrenciesOrderedByRanking();

      if (formProperties && !formProperties.currencyCode){
        //sets default to USD if nothing exists.
        const usaCurrency = CurrencyHelperFactory.getCurrencyByCode('USD');

        if (usaCurrency){
          formProperties.currencyCode = usaCurrency.code;
        }
      }
    }

    vm.toggleItem = function (incomingItem) {
      if (incomingItem.inMenu) {
        // item is already in menu, need to remove it from ezMenuItems array
        vm.ezMenuItems = _.filter(vm.ezMenuItems, function (item) {
          return item.action !== incomingItem.action; // ezMenuItems are all items that don't have incomingItem's action
        });
      } else {
        vm.ezMenuItems.push(incomingItem);
      }
      incomingItem.inMenu = !incomingItem.inMenu;
      ChangeDelta.recordValueChange({
        oldval: !incomingItem.inMenu,
        newval: incomingItem.inMenu,
        collection: 'forms',
        objectid: vm.formProperties._id,
        databasefieldname: 'ezMenuItems.' + incomingItem.action
      });
    };

    function deselectTreeSubteams(teams) {
      if (teams) {
        for (const team of teams) {
          if (team.selected) {
            team.selected = false;
          }
          deselectTreeSubteams(team.treeSubteams);
        }
      }
    }

    function deselectParentsAndSelectRemainingChildren(id) {
      let parent = vm.teams.find(i => {
        return i.subteams.indexOf(id) > -1;
      });

      if (parent) {
        parent.selected = false;

        // keep going up the parent tree until we run out
        deselectParentsAndSelectRemainingChildren(parent._id);

        // select remaining children
        let children = vm.teams.filter(i => {
          return parent.subteams.indexOf(i._id) > -1;
        });

        for (let child of children) {
          if (child._id !== id) {
            child.selected = true;
          } else {
            child.selected = false;
          }
        }
      }
    }

    function deselectChildren(teams) {
      if (teams) {
        let children = vm.teams.filter(i => {
          return teams.indexOf(i._id) > -1;
        });

        for (let child of children) {
          child.selected = false;
          deselectChildren(child.subteams);
        }
      }
    }

    vm.toggleTeamItem = function (incomingItem, value, parent) {
      if (value !== undefined) {
        let newItems;
        const oldItems = _.map(_.filter(vm.teams, function (i) {
          return i.selected;
        }), function (i) {
          return i._id;
        });

        if (!parent) {
          const item = vm.teams.find(function (i) {
            return i._id === incomingItem._id;
          });
          item.selected = value;
          incomingItem.selected = value;

          newItems = _.map(_.filter(vm.teams, function (i) {
            return i.selected;
          }), function (i) {
            return i._id;
          });
          ChangeDelta.recordValueChange({
            oldval: oldItems,
            newval: newItems,
            collection: 'forms',
            objectid: vm.formProperties._id,
            databasefieldname: '_vtags'
          });

          if (!value) {
            deselectTreeSubteams(incomingItem.treeSubteams);
            deselectChildren(item.subteams);
          }
        } else if (parent) {
          if (!value) {
            deselectParentsAndSelectRemainingChildren(incomingItem._id);

            newItems = _.map(_.filter(vm.teams, function (i) {
              return i.selected;
            }), function (i) {
              return i._id;
            });
            ChangeDelta.recordValueChange({
              oldval: oldItems,
              newval: newItems,
              collection: 'forms',
              objectid: vm.formProperties._id,
              databasefieldname: '_vtags'
            });
            recalculateTreeStructureForTeams(vm.teams, vm.treeStructuredTeams, vm.teamFilter);
          }
          incomingItem.selected = value;
        }
      }
    };

    vm.filterTeams = () => {
      recalculateTreeStructureForTeams(vm.teams, vm.treeStructuredTeams, vm.teamFilter);
    };

    vm.toggleChevron = (team, $event) => {
      for (const t of vm.teams) {
        if (t._id === team._id) {
          t.open = !t.open;
          break;
        }
      }
      recalculateTreeStructureForTeams(vm.teams, vm.treeStructuredTeams, vm.teamFilter);
      $event.stopPropagation();
    };

    function calculateCameraModesCount() {
      let selectedCount = 0;
      if (vm.formProperties.allowCameraSymbology128) selectedCount++;
      if (vm.formProperties.allowCameraSymbology25) selectedCount++;
      if (vm.formProperties.allowCameraSymbology39) selectedCount++;
      if (vm.formProperties.allowCameraSymbologyAZTEC) selectedCount++;
      if (vm.formProperties.allowCameraSymbologyDM) selectedCount++;
      if (vm.formProperties.allowCameraSymbologyPDF417) selectedCount++;
      if (vm.formProperties.allowCameraSymbologyQRCODE) selectedCount++;
      vm.cameraSymbologiesCount = selectedCount;
    }

    function buildEZMenu(formProperties) {
      if (!formProperties.ezMenuInitialized) initializeEzMenu(formProperties);
      if (!formProperties.ezMenuItems) return;
      _.each(formProperties.ezMenuItems, function (value, key) {
        _.each(vm.availableEzMenuItems, function (ezPreset) {
          if (value == ezPreset.action) {
            ezPreset.index = key;
            ezPreset.inMenu = true;
            vm.ezMenuItems.push(ezPreset);
          }
        });
      });
      vm.ezMenuItems = _.sortBy(vm.ezMenuItems, 'index');
    }

    function buildTeamVisibilityItems(formProperties) {
      TeamsAPI.getTeams().then(function (res) {
        vm.teams.splice(0);
        vm.teams = res.data.data;
        if (formProperties._vtags) {
          _.each(formProperties._vtags, function (value) {
            _.each(vm.teams, function (team) {
              if (value == team._id) {
                team.selected = true;
              }
            });
          });
        }
        recalculateTreeStructureForTeams(vm.teams, vm.treeStructuredTeams, vm.teamFilter);
      });
    }

    function initializeEzMenu(formProperties) {
      /*
         if ezMenuInitialized != 1,
         then find the master panel view (it is a combination of parentViewTag == 100, elementType of “Frame” (case insensitive) and has uiEffects.
         Then check whether that view is hidden (you don’t want to get the elements if it is or do unnecessary loops),
         then I filter over all the elements in the form,
          checking the parent view is equal to the master panel view,
          element is not hidden and
         then sort them by X coordinate.
         Then create the ez menu item using the selectorName
      */
      const masterPanelElement = locateMasterPanel();

      const ezMenuItems = _.chain(formProperties.elements)
        .filter(function (element) {
          return element.parentViewTag == masterPanelElement.tag && !element.hidden;
        })
        .map(function (el) {
          const landscapeFrameXcoord = parseInt(el.landscapeFrame.substring((el.landscapeFrame.indexOf('{{') + 2), el.landscapeFrame.indexOf(',')));
          return {
            // "NSRect: {{30, 115}, {964, 2}}" we want '30' out of that string!
            xcoord: landscapeFrameXcoord,
            selectorName: el.selectorName
          };
        })
        .sortBy('xcoord')
        .map('selectorName')
        .value();
      // pop submit button in as old forms didn't have this btn in the buttons frame
      ezMenuItems[ezMenuItems.length] = 'submitButtonTapped';

      // build ezMenuItems for the form
      formProperties.ezMenuItems = {};
      _.each(ezMenuItems, function (value, key) {
        formProperties.ezMenuItems[key] = value;
      });
      formProperties.ezMenuInitialized = 1;
      return;

      function locateMasterPanel() {
        return _.find(formProperties.elements, function (element) {
          return element.parentViewTag == 100 &&
            (element.elementType === 'Frame' || element.elementType === 'frame') &&
            !element.hidden &&
            element.UIEffects;
        });
      }
    }

    vm.getCurrentContactFilterSummary = function (){
      const dataLoadsCount = vm.calculateContactFilterDataLoadsCount();
      const formsCount = vm.calculateContactFilterFormsCount();

      if (dataLoadsCount === 0 && formsCount === 0) {
        return 'No filter has been configured; all contacts are available for search.';
      }

      let responseStr = '';

      if (dataLoadsCount > 0) {
        responseStr += `${dataLoadsCount === 1 ? '1 data-load' : `${dataLoadsCount} data-loads`}`;
      }

      if (formsCount > 0) {
        responseStr += `${responseStr.length > 0 ? ' and ' : ''}${formsCount === 1 ? '1 form' : `${formsCount} forms`}`;
      }

      if (dataLoadsCount > 0 || formsCount > 0) {
        responseStr += ' selected, contact search will be restricted to selected';
      }

      if (dataLoadsCount > 0) {
        responseStr += ` data-loads and contacts created by the ${formsCount === 1 ? 'current form' : 'selected forms'} only.`;
      }
      
      if (dataLoadsCount === 0 && formsCount > 0){
        responseStr += ` contacts created by the ${formsCount === 1 ? 'current form' : 'selected forms'} only.`;
      }

      return responseStr;


    };

    vm.calculateContactFilterDataLoadsCount = function (){
      return Object.values(vm.formProperties.contactFilterDataLoads || {} ).length;
    };

    vm.calculateContactFilterFormsCount = function (){
      return Object.values(vm.formProperties.contactFilterForms || {} ).length;
    };

    // various form settings dialogs config

    vm.openCameraModeDialog = function (ev) {
      const dialogConfig = {
        controller: CameraModesCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'app/forms/settings-page/dialogs/camera-modes-dialog/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          allowCameraSymbologyQRCODE: vm.formProperties.allowCameraSymbologyQRCODE,
          allowCameraSymbologyPDF417: vm.formProperties.allowCameraSymbologyPDF417,
          allowCameraSymbologyDM: vm.formProperties.allowCameraSymbologyDM,
          allowCameraSymbologyAZTEC: vm.formProperties.allowCameraSymbologyAZTEC,
          allowCameraSymbology128: vm.formProperties.allowCameraSymbology128,
          allowCameraSymbology25: vm.formProperties.allowCameraSymbology25,
          allowCameraSymbology39: vm.formProperties.allowCameraSymbology39,
          removeSymbology128CheckDigit: vm.formProperties.removeSymbology128CheckDigit,
          removeSymbology25CheckDigit: vm.formProperties.removeSymbology25CheckDigit,
          removeSymbology39CheckDigit: vm.formProperties.removeSymbology39CheckDigit,
          code25SymbologyMinLength: vm.formProperties.code25SymbologyMinLength,
          code39SymbologyMinLength: vm.formProperties.code39SymbologyMinLength
        }
      };

      MessageService.showDialog(ev, dialogConfig)
        .then(function (answer) {
          // $log.info('dialog closed with answer: ' + answer);
          _.each(answer, function (val, key) {
            if (_.isEqual(val, dialogConfig.locals[key])) return;
            vm.updateChangeDelta(key, val);
          });
          _.extend(vm.formProperties, answer);
          let selectedCount = 0;
          if (answer.allowCameraSymbology128) selectedCount++;
          if (answer.allowCameraSymbology25) selectedCount++;
          if (answer.allowCameraSymbology39) selectedCount++;
          if (answer.allowCameraSymbologyAZTEC) selectedCount++;
          if (answer.allowCameraSymbologyDM) selectedCount++;
          if (answer.allowCameraSymbologyPDF417) selectedCount++;
          if (answer.allowCameraSymbologyQRCODE) selectedCount++;
          vm.cameraSymbologiesCount = selectedCount;
          $log.info('ensure scan button is in ez menu if necessary');
          ensureScanButtonIsInEzMenu();

        })
        .catch(function (err) {
          $log.error(err);
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });

        });

      function ensureScanButtonIsInEzMenu() {
        const scanButtonPreset = _.find(EZMenuItems, function (item) {
          return item.action === 'scanButtonTapped';
        });
        if (vm.cameraSymbologiesCount !== 0) {
          // add scan button to ez menu items
          if (_.isEmpty(vm.formProperties.ezMenuItems)) {
            $log.info('creating ez menu items with scanButtonTapped');
            vm.updateChangeDeltaNested('ezMenuItems', '0', 'scanButtonTapped');
            scanButtonPreset.inMenu = true;
            vm.ezMenuItems.push(scanButtonPreset);
          } else {
            $log.info('already have ezMenuItems. ensure scanButton is included. Add it in to postion 0 if not present already');
            const scanButton = _.find(vm.ezMenuItems, function (item) {
              return item.action === 'scanButtonTapped';
            });
            if (scanButton) return; // scanButton already present
            $log.info('no scanButton found. lets add it in at first position');
            scanButtonPreset.inMenu = true;
            vm.ezMenuItems.unshift(scanButtonPreset);
          }
        } else {
          $log.info('find and remove scan button from ez menu items');
          const scanBtnIndex = _.findIndex(vm.ezMenuItems, function (item) {
            return item.action == 'scanButtonTapped';
          });
          vm.ezMenuItems[scanBtnIndex].inMenu = false;
          vm.ezMenuItems.splice(scanBtnIndex, 1);
        }
      }

    };

    vm.openScanLookupProvidersDialog = function (ev) {
      const dialogConfig = {
        controller: ScanLookupProvidersCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'app/forms/settings-page/dialogs/scan-lookup-providers-dialog/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          compusystemsBaseUrl: vm.formProperties.compusystemsBaseUrl,
          compusystemsEventId: vm.formProperties.compusystemsEventId,
          compusystemsOn: vm.formProperties.compusystemsOn,
          compusystemsTimeout: vm.formProperties.compusystemsTimeout,
          compusystemsToken: vm.formProperties.compusystemsToken,
          experientActCode: vm.formProperties.experientActCode,
          experientApiKey: vm.formProperties.experientApiKey,
          experientBadgeId: vm.formProperties.experientBadgeId,
          experientBaseUrl: vm.formProperties.experientBaseUrl,
          experientConcatenatePhone: vm.formProperties.experientConcatenatePhone,
          experientOn: vm.formProperties.experientOn,
          experientTimeout: vm.formProperties.experientTimeout,
          zuantWebLookupBaseUrl: vm.formProperties.zuantWebLookupBaseUrl,
          zuantWebLookupLeadCaptureStatus: vm.formProperties.zuantWebLookupLeadCaptureStatus,
          zuantWebLookupOn: vm.formProperties.zuantWebLookupOn,
          zuantWebLookupSystem: vm.formProperties.zuantWebLookupSystem,
          zuantWebLookupTimeout: vm.formProperties.zuantWebLookupTimeout,
          zuantWebLookupToken1: vm.formProperties.zuantWebLookupToken1,
          zuantWebLookupToken2: vm.formProperties.zuantWebLookupToken2
        }
      };

      MessageService.showDialog(ev, dialogConfig)
        .then(function (answer) {
          // $log.info('dialog closed with answer: ' + answer);
          _.each(answer, function (val, key) {
            if (_.isEqual(val, dialogConfig.locals[key])) return;
            vm.updateChangeDelta(key, val);
          });
          _.extend(vm.formProperties, answer);

        }, function () {
          // $log.info('User cancelled out of the dialog');
        })
        .catch(function (err) {
          $log.error(err);
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });

        });
    };

    vm.openScannerAutoSubmitDialog = function (ev) {
      const dialogConfig = {
        controller: ScanAutoSubmitDialogCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'app/forms/settings-page/dialogs/scan-auto-submit-dialog/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          allowDuplicateScansAfterScanning: vm.formProperties.allowDuplicateScansAfterScanning,
          automaticallySubmitLeadAfterScanning: vm.formProperties.automaticallySubmitLeadAfterScanning,
          ignoreFormValidationIssuesAfterScanning: vm.formProperties.ignoreFormValidationIssuesAfterScanning,
          ignoreLookupProvidersInternetConnectionIssuesAfterScanning: vm.formProperties.ignoreLookupProvidersInternetConnectionIssuesAfterScanning
        }
      };

      MessageService.showDialog(ev, dialogConfig)
        .then(function (answer) {
          // $log.info('dialog closed with answer: ' + answer);
          _.each(answer, function (val, key) {
            if (_.isEqual(val, dialogConfig.locals[key])) return;
            vm.updateChangeDelta(key, val);
          });
          _.extend(vm.formProperties, answer);

        }, function () {
          // $log.info('User cancelled out of the dialog');
        })
        .catch(function (err) {
          $log.error(err);
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });

        });
    };

    vm.openFormContactFiltersSettingsDialog = function (ev) {
      const contactFilterForms = vm.formProperties.contactFilterForms ? Object.values(vm.formProperties.contactFilterForms) : [];
      const dialogConfig = {
        controller: FormContactFiltersDialogCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'app/forms/settings-page/dialogs/form-contact-filters-dialog/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          contactFilterForms: contactFilterForms,
          formId: vm.formProperties._id
        }
      };
      MessageService.showDialog(ev, dialogConfig)
        .then(function (selectedFormIds) {
          const currentDeltas = ChangeDelta.getDeltaObject();

          const contactFilterFormsDeltas = _.get(currentDeltas, ['forms', vm.formProperties._id, 'contactFilterForms'], null);
          const selectedFormIdsObj = selectedFormIds.length > 0 ? Object.assign({}, selectedFormIds) : {};

          if (
            (
              (selectedFormIds.length === 0 && !vm.lastSavedStateOfFormProperties.contactFilterForms) ||
                _.isEqual(vm.lastSavedStateOfFormProperties.contactFilterForms, selectedFormIdsObj)
            ) && !contactFilterFormsDeltas
          ) return;
          
          ChangeDelta.recordValueChange({
            oldval: vm.formProperties.contactFilterForms,
            orignialvalue: vm.lastSavedStateOfFormProperties.contactFilterForms,
            newval: selectedFormIdsObj,
            objectid: vm.formProperties._id,
            collection: 'forms',
            databasefieldname: 'contactFilterForms'
          });

          vm.formProperties.contactFilterForms = selectedFormIdsObj;

        }, function () {
          // $log.info('User cancelled out of the dialog');
        })
        .catch(function (err) {
          $log.error(err);
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });

        });
    };

    vm.openDataLoadContactFiltersSettingsDialog = function (ev) {
      const contactFilterDataLoads = vm.formProperties.contactFilterDataLoads ? Object.values(vm.formProperties.contactFilterDataLoads) : [];

      const dialogConfig = {
        controller: DataLoadContactFiltersDialogCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'app/forms/settings-page/dialogs/data-load-contact-filters-dialog/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          contactFilterDataLoads: contactFilterDataLoads
        }
      };
      MessageService.showDialog(ev, dialogConfig)
        .then(function (selectedDataLoadIds) {
          const currentDeltas = ChangeDelta.getDeltaObject();

          const contactFilterDataLoadsDeltas = _.get(currentDeltas, ['forms', vm.formProperties._id, 'contactFilterDataLoads'], null);
          const selectedDataLoadIdsObj = selectedDataLoadIds.length > 0 ? Object.assign({}, selectedDataLoadIds) : {};

          if (
            (
              (selectedDataLoadIds.length === 0 && !vm.lastSavedStateOfFormProperties.contactFilterDataLoads) ||
                _.isEqual(vm.lastSavedStateOfFormProperties.contactFilterDataLoads, selectedDataLoadIdsObj)
            ) && !contactFilterDataLoadsDeltas
          ) return;
          
          ChangeDelta.recordValueChange({
            oldval: vm.formProperties.contactFilterDataLoads,
            orignialvalue: vm.lastSavedStateOfFormProperties.contactFilterDataLoads,
            newval: selectedDataLoadIdsObj,
            objectid: vm.formProperties._id,
            collection: 'forms',
            databasefieldname: 'contactFilterDataLoads'
          });

          vm.formProperties.contactFilterDataLoads = selectedDataLoadIdsObj;

        }, function () {
          // $log.info('User cancelled out of the dialog');
        })
        .catch(function (err) {
          $log.error(err);
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });

        });
    };

    vm.openAdvancedScannerSettingsDialog = function (ev) {
      const dialogConfig = {
        controller: AdvancedScannerSettingsDialogCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'app/forms/settings-page/dialogs/advanced-scanner-settings-dialog/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          barcodeExcludeChars: vm.formProperties.barcodeExcludeChars,
          barcodeStartSequence: vm.formProperties.barcodeStartSequence,
          barcodeDecryptionKey: vm.formProperties.barcodeDecryptionKey,
          barcodeDecryptionVector: vm.formProperties.barcodeDecryptionVector,
          NFCAutoDisplayPeripheralList: vm.formProperties.NFCAutoDisplayPeripheralList,
          NFCNDEFTypeName: vm.formProperties.NFCNDEFTypeName,
          NFCNDEFTypeNo: vm.formProperties.NFCNDEFTypeNo
        }
      };
      MessageService.showDialog(ev, dialogConfig)
        .then(function (answer) {
          // $log.info('dialog closed with answer: ' + answer);
          _.each(answer, function (val, key) {
            if (_.isEqual(val, dialogConfig.locals[key])) return;
            vm.updateChangeDelta(key, val);
          });
          _.extend(vm.formProperties, answer);

        }, function () {
          // $log.info('User cancelled out of the dialog');
        })
        .catch(function (err) {
          $log.error(err);
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });

        });
    };

    vm.openBarcodeFieldsDialog = function (ev) {
      const dialogConfig = {
        controller: BarcodeFieldsDialogCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'app/forms/settings-page/dialogs/barcode-fields-dialog/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          barcodeMappings: vm.formProperties.barcodeMappings || []
        }
      };

      MessageService.showDialog(ev, dialogConfig)
        .then(function (answer) {
          // $log.info('dialog closed with answer: ' + answer);
          ChangeDelta.recordValueChange({
            oldval: vm.lastSavedStateOfFormProperties.barcodeMappings,
            newval: answer,
            objectid: vm.formProperties._id,
            collection: 'forms',
            databasefieldname: 'barcodeMappings'
          });
          _.extend(vm.formProperties, {
            barcodeMappings: answer
          });
          vm.countOfBarcodeFieldsMapped = answer.length;
        }, function () {
          // $log.info('User cancelled out of the dialog');
        })
        .catch(function (err) {
          $log.error(err);
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });

        });
    };


    vm.showHelpDialog = function (ev, topic) {
      const dialogConfig = {
        controller: FormSettingsHelpDialogCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'app/forms/settings-page/dialogs/form-settings-help/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          topic: topic
        }
      };

      MessageService.showDialog(ev, dialogConfig)
        .then(function () {
          MessageService.showMessage('Help dialog closed');
        }, function () {
          MessageService.showMessage('Help dialog cancelled');
          // $log.info('User cancelled out of the dialog');
        });
    };

    vm.onTechnicalContactsChanged = function (technicalContacts) {
      vm.updateChangeDelta('technicalContacts', _.map(technicalContacts.items, 'email'));
    };

    vm.openPostShowEmailSendDialog = function (ev) {

      const dialogConfig = {
        controller: PostShowEmailSendDialogCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'app/forms/settings-page/dialogs/post-show-email-dialog/dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          emailTemplate: vm.formProperties.emailTemplate,
          emailTemplateTitle: vm.emailTemplateTitle,
          formId: vm.formId,
          waiveGDPRCompliance: vm.formProperties.waiveGDPRCompliance
        }
      };

      MessageService.showDialog(ev, dialogConfig)
        .then(function (emailTemplate) {
          vm.emailTemplateTitle = emailTemplate.title;
          vm.formProperties.emailTemplate = emailTemplate.id;
        });
    };

    vm.updateSearchCurrency = function ($event){
      $event.stopPropagation();
    };
  }

  function whenscrollends() {
    return {
      restrict: 'A',
      scope:{
        currencyScrollIndex: '='
      },
      link: function($scope, element, attrs) {

        const elem = element[0];

        if (elem && elem.children && elem.children.length > 1){
          const primaryContainer = elem.children[1];

          if (primaryContainer && primaryContainer.children && primaryContainer.children.length > 0){
            const selectContainer = primaryContainer.children[0];

            if (selectContainer && selectContainer.children && selectContainer.children.length > 0){
              const scrollContainer = selectContainer.children[0];

              angular.element(scrollContainer).on('scroll',function(event){
                const target = event.target;

                if (target){
                  const scrollHeight = target.scrollHeight;
                  const scrollTop = target.scrollTop;

                  if (target.children && target.children.length > 0){
                    const itemsOnly = Array.from(target.children).filter((node)=> node.id && node.id.includes('select_option'));

                    if (itemsOnly && itemsOnly.length> 0){
                      const listItem = itemsOnly[0];
                      const listItemHeight = listItem.clientHeight || 0;
                    
                      const index = Math.floor(scrollTop/listItemHeight);
  
                      $scope.currencyScrollIndex = index;
                    }
                  }
                }
              });
            }
          }
        }
      }
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('forms')
    .factory('FormPropertyHelpersFactory', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {
    return {
      blocksMenu: {
        useBlocksMenu: 'Switches showroom into Showroom Plus mode',
        filtersAvailable: 'Controls wether the Filters (Category/Tag) button is visible in the showroom',
        showroomCanBeDismissed: 'Sometimes you may want to keep the app in showroom mode',
        navigationBackButtonAvailable: 'You can hide the back nav button should you wish to stop the user moving off the set page',
        entryBlock: 'Select which page you would like to showroom to open on for this particular form'
      }
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpReportingPage', {
      templateUrl: 'app/forms/reporting/zp-reporting-page.tmpl.html',
      controller: 'zpReportingPageCtrl',
      bindings: {}
    })
    .controller('zpReportingPageCtrl', zpReportingPageCtrl);

  zpReportingPageCtrl.$inject = ['FormMetadataFactory', 'ResponseAggregationModel', 'TimeReportsMetadataFactory', 'RevenueReportsMetadataFactory', 'ColumnSummaryMetadataFactory', 'HeadlinesMetadataFactory', 'ShowroomWidgetsMetadataFactory', 'ReportModel', 'EmailPerformanceWidgetsMetadataFactory', 'EmailHeadlinesMetadataFactory', 'VisibilityPreferenceService'];
  /* ng-inject */
  function zpReportingPageCtrl(FormMetadataFactory, ResponseAggregationModel, TimeReportsMetadataFactory, RevenueReportsMetadataFactory, ColumnSummaryMetadataFactory, HeadlinesMetadataFactory, ShowroomWidgetsMetadataFactory, ReportModel, EmailPerformanceWidgetsMetadataFactory, EmailHeadlinesMetadataFactory, VisibilityPreferenceService) {

    var vm = this;
    vm.blankSlate = false;
    vm.showHints = false;
    vm.metadata = FormMetadataFactory.getData();
    vm.title = vm.metadata.formProperties.formname;
    vm.formId = vm.metadata.formProperties._id;
    vm.reportData = ReportModel.factoryData;

    vm.showEmailDeliveredPriorToLaunchMessage = showUserEmailLaunchMessage(vm.metadata.formProperties);
    // https://material.angularjs.org/latest/layout/introduction for CSS breakpoints thresholds
    vm.chartBreakPoints = {
      datapointThreshold: 10,
      viewPort_960_1280: {
        aboveThresholdFlex: 95,
        aboveThresholdFlexOffset: 5,
        belowThresholdFlex: 50,
        belowThresholdFlexOffset: 0
      },
      viewPort_gt_1280: {
        aboveThresholdFlex: 80,
        aboveThresholdFlexOffset: 10,
        belowThresholdFlex: 50,
        belowThresholdFlexOffset: 0
      },
      viewPort_gt_1920: {
        aboveThresholdFlex: 50,
        aboveThresholdFlexOffset: 0,
        belowThresholdFlex: 50,
        belowThresholdFlexOffset: 0
      }
    };

    vm.visibilityPreferences = {
      panels: {
        info: true,
        headlines: true,
        time: true,
        questions: true,
        showroom: true,
        email: true
      }
    };

    vm.$onInit = function () {
      vm.responseAggregationFactoryData = ResponseAggregationModel.factoryData;
      vm.headlineWidgets = HeadlinesMetadataFactory.getData();
      vm.timeWidgets = TimeReportsMetadataFactory.getData();
      vm.revenueWidgets = RevenueReportsMetadataFactory.getData();
      vm.questionChartWidgets = ColumnSummaryMetadataFactory.getData(); // copy columnSummaryWidgets to break reference - WHY?
      vm.showroomWidgets = ShowroomWidgetsMetadataFactory.getData();
      vm.emailPerformanceWidgets = EmailPerformanceWidgetsMetadataFactory.getData();
      vm.emailHeadlineWidgets = EmailHeadlinesMetadataFactory.getData();

      var preferences = VisibilityPreferenceService.getVisibilityPreferences('form_reporting' + '_' + vm.formId);
      if (preferences) {
        _.extend(vm.visibilityPreferences.panels, preferences);
      }
    };
    // end onInit

    vm.trackingFunction = function (item) {
      return item.id + Math.round(Math.random() * 1000);
    };

    vm.togglePanelVisibility = function (panel) {
      vm.visibilityPreferences.panels[panel] = !vm.visibilityPreferences.panels[panel];
      var params = {
        preferenceId: 'form_reporting_' + vm.formId,
        panels: vm.visibilityPreferences.panels
      };
      VisibilityPreferenceService.setPreference(params);
    };

    vm.widgetsHidden = function (widgetGroup, widgetGroup2) {
      vm[widgetGroup].hiddenCount = 0;
      _.each(vm[widgetGroup].items, function (widget) {
        if (!widget.inReport || widget.isEmpty) vm[widgetGroup].hiddenCount++;
      });

      if (widgetGroup2) {
        vm[widgetGroup2].hiddenCount = 0;
        _.each(vm[widgetGroup2].items, function (widget) {
          if (!widget.inReport || widget.isEmpty) vm[widgetGroup2].hiddenCount++;
        });
        vm.emailWidgetsCombinedHiddenCount = vm[widgetGroup].hiddenCount + vm[widgetGroup2].hiddenCount;
        return vm.emailWidgetsCombinedHiddenCount;
      }

      return vm[widgetGroup].hiddenCount;
    };

    function showUserEmailLaunchMessage(formProps) {
      var beforeLaunch = moment('2019-12-16 00:00:00'); // date the email reporting was launched. Emails delivered prior to this date won't have had their delivery webhooks recorded. Thus we show user a message saying counts may be out.
      var createDateIsBeforeLaunch = moment(formProps._initialcreatedatelocalutc).isBefore(beforeLaunch);
      if (formProps.startdate) {
        var startdateIsBeforeLaunch = moment(formProps.startdate).isBefore(beforeLaunch);
        return createDateIsBeforeLaunch && startdateIsBeforeLaunch;
      } else {
        return createDateIsBeforeLaunch;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('ReportModel', factory);

  factory.$inject = ['localStorageService'];
  /* ng-inject */
  function factory(localStorage) {

    var factoryData;
    var deltaObj = {};

    buildFactory();

    return {
      mergePresetsWithSavedModel: mergePresetsWithSavedModel,
      toggleWidgetInReport: toggleWidgetInReport,
      loadReport: loadReport,
      saveReport: saveReport,
      getData: getData,
      toggleAllWidgetsInReport: toggleAllWidgetsInReport,
      clearChangeDelta: clearChangeDelta,
      isDirty: isDirty,
      recordValueChange: recordValueChange,
      factoryData: factoryData
    };

    function buildFactory() {
      factoryData = {
        id: '',
        metadata: {
          title: '',
          startDate: {
            caption: '',
            value: '',
            dt: ''
          },
          endDate: {
            caption: '',
            value: '',
            dt: ''
          },
          limitAnswers: null
        },
        items: {}
      };
    }

    function mergePresetsWithSavedModel(_formid, items) {
      var mergeItems = loadReport(_formid); // loads saved report from localStorage and then we loop all widget items to turn them on or off in the UI according to the saved model
      _.each(items.headlineWidgets.items, function (item) {
        if (mergeItems) {
          item.inReport = factoryData.items[item.id] ? true : false;
        } else {
          factoryData.items[item.id] = 1;
        }
      });
      _.each(items.timeWidgets.items, function (item) {
        if (mergeItems) {
          item.inReport = factoryData.items[item.id] ? true : false;
        } else {
          factoryData.items[item.id] = 1;
        }
      });
      _.each(items.columnSummaryWidgets.items, function (item) {
        if (mergeItems) {
          item.inReport = factoryData.items[item.id] ? true : false;
        } else {
          factoryData.items[item.id] = 1;
        }
      });
      _.each(items.showroomWidgets.items, function (item) {
        if (mergeItems) {
          item.inReport = factoryData.items[item.id] ? true : false;
        } else {
          factoryData.items[item.id] = 1;
        }
      });
      _.each(items.emailPerformanceWidgets.items, function (item) {
        if (mergeItems) {
          item.inReport = factoryData.items[item.id] ? true : false;
        } else {
          factoryData.items[item.id] = 1;
        }
      });
      _.each(items.emailHeadlinePerformanceWidgets.items, function (item) {
        if (mergeItems) {
          item.inReport = factoryData.items[item.id] ? true : false;
        } else {
          factoryData.items[item.id] = 1;
        }
      });
      return factoryData;
    }

    function toggleWidgetInReport(widget) {
      recordValueChange(widget.inReport, !widget.inReport, widget.id);
      if (factoryData.items[widget.id]) {
        widget.inReport = false;
        delete factoryData.items[widget.id];
      } else {
        widget.inReport = true;
        factoryData.items[widget.id] = 1;
      }
    }

    function loadReport(formId) {
      var storedModel = localStorage.get('widget_report_definition_' + formId);
      if (storedModel) {
        var modelObj = JSON.parse(storedModel);
        var mergeObj = {
          metadata: {
            title: modelObj.metadata.title,
            limitAnswers: modelObj.metadata.limitAnswers,
            startDate: {},
            endDate: {}
          }
        };
        factoryData.id = 'widget_report_definition_' + formId;
        if (modelObj.metadata.startDate) {
          var startDate = new Date(modelObj.metadata.startDate);
          mergeObj.metadata.startDate = {
            dt: startDate,
            caption: moment(startDate).format('MMM Do YYYY'),
            value: moment(startDate).format('MM/DD/YY')
          };
        }
        if (modelObj.metadata.endDate) {
          var endDate = new Date(modelObj.metadata.endDate);
          mergeObj.metadata.endDate = {
            dt: endDate,
            caption: moment(endDate).format('MMM Do YYYY'),
            value: moment(endDate).format('MM/DD/YY')
          };
        }
        angular.merge(factoryData.metadata, mergeObj.metadata);
        factoryData.items = modelObj.items;
        return factoryData;
      } else {
        buildFactory();
        return false; // no merging required
      }
    }

    function saveReport(formId, metadata) {
      factoryData.id = 'widget_report_definition_' + formId;
      try {
        var savedReportData = {
          id: factoryData.id,
          metadata: {
            title: metadata.title,
            startDate: metadata.startDate ? metadata.startDate.value : '',
            endDate: metadata.endDate ? metadata.endDate.value : '',
            limitAnswers: metadata.limitAnswers
          },
          items: factoryData.items
        };
        localStorage.set(factoryData.id, JSON.stringify(savedReportData));
      } catch (e) {
        MessageService.writeLog({
          level: 'err',
          msg: e,
          tags: ['report_builder']
        });
      }
    }

    function getData() {
      return factoryData;
    }

    function toggleAllWidgetsInReport(widgets, addAllWidgets) {
      _.each(widgets, function (widget) {
        recordValueChange(widget.inReport, !widget.inReport, widget.id);
        if (addAllWidgets) {
          widget.inReport = true;
          factoryData.items[widget.id] = 1;
        } else {
          widget.inReport = false;
          delete factoryData.items[widget.id];
        }
      });
    }

    function clearChangeDelta() {
      deltaObj = {};
    }

    function isDirty() {
      return !angular.equals(deltaObj, {});
    }

    function recordValueChange(oldval, newval, widgetId) {
      if (deltaObj.hasOwnProperty(widgetId)) {
        if (newval !== deltaObj[widgetId].oldvalue) {
          deltaObj[widgetId].newvalue = newval;
        } else if (newval === deltaObj[widgetId].oldvalue) {
          delete deltaObj[widgetId];
        }
      } else {
        deltaObj[widgetId] = {
          oldvalue: oldval,
          newvalue: newval
        };
      }
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('ReportAPI', reportApi);

  reportApi.$inject = ['APIService'];
  /* ng-inject */
  function reportApi(api) {

    var services = {
      savePage: savePage
    };

    return services;

    //////////////////////////////////

    function savePage() {
      return api.get('reporting/savePage', { responseType: 'arraybuffer' })
        .then(function (res) {
          return res;
        })
        .catch(function (err) {
          throw(err);
        });
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('forms')
    .factory('AllReportWidgetsMetadataCombined', AllReportWidgetsMetadataCombined);

  AllReportWidgetsMetadataCombined.$inject = ['ReportModel', 'ColumnSummaryMetadataFactory', 'HeadlinesMetadataFactory', 'ShowroomWidgetsMetadataFactory', 'TimeReportsMetadataFactory', 'EmailPerformanceWidgetsMetadataFactory', 'EmailHeadlinesMetadataFactory', 'RevenueReportsMetadataFactory'];
  /* ng-inject */
  function AllReportWidgetsMetadataCombined(ReportModel, ColumnSummaryMetadataFactory, HeadlinesMetadataFactory, ShowroomWidgetsMetadataFactory, TimeReportsMetadataFactory, EmailPerformanceWidgetsMetadataFactory, EmailHeadlinesMetadataFactory, RevenueReportsMetadataFactory) {

    var factoryData;

    return {
      getData: getData,
      hydrateFactoryAndMergePresetsWithSavedModel: hydrateFactory
    };

    function getData() {
      return factoryData;
    }

    function hydrateFactory(_formid) {
      factoryData = {
        headlineWidgets: HeadlinesMetadataFactory.getData(),
        timeWidgets: TimeReportsMetadataFactory.getData(),
        revenueWidgets: RevenueReportsMetadataFactory.getData(),
        columnSummaryWidgets: ColumnSummaryMetadataFactory.getData(),
        showroomWidgets: ShowroomWidgetsMetadataFactory.getData(),
        emailPerformanceWidgets: EmailPerformanceWidgetsMetadataFactory.getData(),
        emailHeadlinePerformanceWidgets: EmailHeadlinesMetadataFactory.getData()
      };
      ReportModel.mergePresetsWithSavedModel(_formid, factoryData); // passes widget items by reference and turns on/off the inReport prop for each widget (this drives them showing in the UI or not)

    }
  }
}());

/**
 * Created by davidbeazer on 21/11/2016.
 */
'use strict';

angular
  .module('forms')
  .controller('AddFormDialogController', AddFormDialogController);

AddFormDialogController.$inject = ['EventZubot', '$log', 'MessageService', 'EmailTemplatesFactory', 'SingleFormFactory', 'uuidService', '$state', 'FormsFactory'];
/* ng-inject */
function AddFormDialogController(EventZubot, $log, MessageService, EmailTemplatesFactory, SingleFormFactory, uuid, $state, FormsFactory) {

  var vm = this;

  vm.disableSaveButton = false;
  vm.showStep3 = false;
  vm.emailTemplates = [];
  vm.showHints = true;
  
  vm.formTemplatesConfig = {
    name: 'formTemplate',
    placeholder: 'Choose a template to use',
    floatingLabel: 'Template name',
    filter: 'formTemplates'
  };

  vm.cloneFormConfig = {
    name: 'cloneSourceFormId',
    placeholder: 'Choose a form to clone',
    floatingLabel: 'Form to clone',
    filter: null
  };
  
  vm.formTimezonesConfig = {
    placeholder: 'Pick a timezone for this form',
    floatingLabel: 'Form timezone',
    required: true,
    name: 'formTimezone'
  };

  vm.emailTemplateConfig = {
    placeholder: 'Pick an email template for this form',
    floatingLabel: 'Email template'
  };

  $log.debug('AddFormDialogController');

  vm.$onInit = function () {
    initialiseNewFormObject();
  };

  vm.startDateChanged = function () {
    vm.newForm.enddate = vm.newForm.startdate;
  };

  vm.submit = function (continueToAdvancedSettings) {

    // delete props that are only relevant to the UI
    if (!vm.newFormForm.$valid) return;
    if (vm.newForm.formType) delete vm.newForm.formType;
    if (validateDates()) return;
    if (vm.newForm.formTemplateId === 'websummit_2024') {
      vm.newForm.startdate = '2024-11-11 08:00:00.000Z';
      vm.newForm.enddate = '2024-11-14 18:00:00.000Z';
      vm.newForm.published = 1;

      delete vm.newForm.emailTemplate;
      delete vm.newForm.formTimezone;
    } else if (vm.newForm.formTemplateId === 'ieee_2022') {
      vm.newForm.startdate = '2022-03-07T00:00:00.000Z';
      vm.newForm.enddate = '2022-03-11T00:00:00.000Z';
      vm.newForm.published = 1;

      delete vm.newForm.emailTemplate;
      delete vm.newForm.formTimezone;
    } else if (vm.newForm.formTemplateId === 'collision_2023') {
      
      vm.newForm.startdate = '2023-06-26T08:00:00.000Z';
      vm.newForm.enddate = '2023-06-29T08:00:00.000Z';
      vm.newForm.published = 1;

      delete vm.newForm.emailTemplate;
      delete vm.newForm.formTimezone;
    } else if (vm.newForm.formTemplateId === 'thenextweb_2022') {
      
      vm.newForm.startdate = '2022-06-16T08:00:00.000Z';
      vm.newForm.enddate = '2022-06-17T18:00:00.000Z';
      vm.newForm.published = 1;

      delete vm.newForm.emailTemplate;
      delete vm.newForm.formTimezone;
    } else if (vm.newForm.formTemplateId === 'sibs_2022') {
      
      vm.newForm.startdate = '2022-09-16T08:00:00.000Z';
      vm.newForm.enddate = '2022-09-25T18:00:00.000Z';
      vm.newForm.published = 1;

      delete vm.newForm.emailTemplate;
      delete vm.newForm.formTimezone;
    } else if (vm.newForm.formTemplateId === 'esgct_2024') {
      
      vm.newForm.startdate = '2023-10-23T23:00:00.000Z';
      vm.newForm.enddate = '2023-10-26T23:00:00.000Z';
      vm.newForm.published = 1;

      delete vm.newForm.emailTemplate;
      delete vm.newForm.formTimezone;
    } else if (vm.newForm.formTemplateId === 'iemdc_2025') {
      vm.newForm.startdate = '2025-05-18T23:00:00.000Z';
      vm.newForm.enddate = '2025-05-21T23:00:00.000Z';
      vm.newForm.published = 1;

      delete vm.newForm.emailTemplate;
      delete vm.newForm.formTimezone;
    } else if (vm.newForm.formTemplateId === 'nls_2026_days') {
      
      vm.newForm.startdate = '22026-09-07T23:00:00.000Z';
      vm.newForm.enddate = '2026-09-08T23:00:00.000Z';
      vm.newForm.published = 1;

      delete vm.newForm.emailTemplate;
      delete vm.newForm.formTimezone;
    }
    
    MessageService.writeLog({
      level: 'info',
      msg: 'Saving new form ' + vm.newForm._id + ' with email template: ' + vm.newForm.emailTemplate,
      tags: ['email_template', 'new_form_dialog']
    });

    vm.disableSaveButton = true;
    FormsFactory.saveNewForm(vm.newForm)
      .then(function () {
        return EventZubot.postUpdate(vm.newForm._id);
      })
      .then(function () {
        return EventZubot.postExecutiveSummaryUpdate(vm.newForm._id);
      })
      .then(function () {
        vm.hide();
        vm.disableSaveButton = false;
        MessageService.showMessage('Form saved');
        MessageService.pushEventToIntercom('form-created', {
          _formid: vm.newForm._id,
          formname: vm.newForm.formname
        });
        if (continueToAdvancedSettings) {
          $state.go('app.tabbed_app_framework.single_form.settings', {
            _id: vm.newForm._id
          });
        } else {
          $log.debug('form added to factory cache of forms');
        }
        $log.info('Save new form success');
        MessageService.writeLog({
          level: 'info',
          msg: 'new form creation success: _id ' + vm.newForm._id,
          tags: ['create_form']
        });
      })
      .catch(function (err) {
        $log.error(err);
        vm.disableSaveButton = false;
        MessageService.showMessage(err.data.data.message);
        MessageService.writeLog({
          level: 'error',
          msg: 'error creating new form: ' + JSON.stringify(err),
          tags: ['create_form']
        });
      });
  };

  function validateDates() {
    return (vm.newForm.startdate && vm.newForm.startdate) && (vm.newForm.startdate > vm.newForm.enddate);
  }

  function initialiseNewFormObject() {
    const newId = uuid.getSingleNewBase64Key();
    vm.newForm = {
      _id: newId,
      id: newId,
      formname: '',
      startdate: '',
      enddate: '',
      emailTemplate: '',
      formTimezone: '',
      published: 0
    };
  }

  vm.checkIfFieldIsRequired = function (fieldToCheck) {
    if (fieldToCheck == 'cloneSourceFormId') return vm.newForm.formType == 'cloneForm';
    if (fieldToCheck == 'formTemplate') return vm.newForm.formType == 'newForm';
  };

  vm.updateFormTimezone = function (selected) {
    if (!selected.item) return;
    setNewFormProperty('formTimezone', selected.item);
  };

  vm.updateEmailTemplate = function (selected) {
    if (selected.item) {
      if (selected.item._id !== vm.newForm.emailTemplate) {
        vm.emailTemplateTitle = selected.item.title;
        setNewFormProperty('emailTemplate', selected.item._id);
      }
    } else {
      vm.emailTemplateTitle = '';
      setNewFormProperty('emailTemplate', '');
    }
  };

  function setNewFormProperty(prop, value) {
    vm.newForm[prop] = value;
  }

  vm.setFormSeed = function (seed) {
    vm.newForm.formType = seed;
    resetForm();
  };

  vm.grabFormToClone = function (selected) {
    if (!selected.item){
      resetForm();
      return;
    }
    vm.cloneSourceFormTitle = selected.item.title;
    vm.newForm.cloneSourceFormId = selected.item._id;

    SingleFormFactory.getFormById(selected.item._id)
      .then(function (resp) {
        vm.showStep3 = true;
        vm.clonedFormProps = resp;
        MessageService.writeLog({
          level: 'info',
          msg: 'grabbed form to clone success',
          tags: ['create_form']
        });
      })
      .catch(function (err) {
        $log.error(err);
        MessageService.showMessage(err.data.data.message);
        MessageService.writeLog({
          level: 'error',
          msg: 'Error grabbing form to clone' + JSON.stringify(err),
          tags: ['create_form']
        });
      });
  };

  vm.setFormTemplateToUse = function (selected) {
    if (!selected.item){
      resetForm();
      return;
    }

    vm.formTemplateTitle = selected.item.title;
    vm.newForm.formTemplateId = selected.item._id;
    
    if (selected.item._id != 'scan_n_go' && selected.item._id != 'standard_template' && selected.item._id != 'websummit_2024' && selected.item._id != 'ieee_2022' && selected.item._id != 'ieee_2026_esw' && selected.item._id != 'ieee_2023_selections_congress' && selected.item._id != 'collision_2023' && selected.item._id != 'thenextweb_2022' && selected.item._id != 'sibs_2022' && selected.item._id != 'esgct2024') {
      vm.showUseFormSettingsSwitch = true;
      vm.showStep3 = true;
      // user has selected a custom template and so we need to fetch it incase they wish to use the settings for it (date, email template, timezone controls in UI)
      SingleFormFactory.getFormById(selected.item._id)
        .then(function (resp) {
          vm.formTemplateProps = resp;
        })
        .catch(function (err) {
          $log.error(err);
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    } else if (selected.item._id === 'websummit_2024' || selected.item._id === 'ieee_2022' || selected.item._id === 'collision_2023' || selected.item._id === 'thenextweb_2022' || selected.item._id === 'sibs_2022' || selected.item._id === 'esgct2024') {
      
      vm.showStep3 = false;
      if (vm.newFormForm.formname.$valid) {
        vm.newFormForm.$valid = true;
        vm.newFormForm.$invalid = false;
      }
    } else {
      vm.showStep3 = true;
    }
  };

  vm.cloneFormSettingsChange = function () {
    if (vm.newForm.cloneFormSettings && vm.clonedFormProps) {
      // user wants to clone settings too, we will set the visible ones here and flag for the rest to be done on the server (vm.newForm.cloneFormSettings)
      vm.newForm.startdate = new Date(vm.clonedFormProps.startdate);
      vm.newForm.enddate = new Date(vm.clonedFormProps.enddate);
      vm.newForm.formTimezone = vm.clonedFormProps.formTimezone;
      vm.newForm.emailTemplate = vm.clonedFormProps.emailTemplate;
      if (vm.clonedFormProps.emailTemplate) {
        const targetTemplateToClone = EmailTemplatesFactory.getData().itemsObject[vm.clonedFormProps.emailTemplate];
        if (targetTemplateToClone) {
          vm.emailTemplateTitle = targetTemplateToClone.emailtemplate.title;
        }
      }
    } else if (vm.newForm.cloneFormSettings && vm.formTemplateProps) {
      // user wants to use template settings as well as widgets, we will set the visible ones here and flag for the rest to be done on the server (vm.newForm.cloneFormSettings)
      vm.newForm.startdate = new Date(vm.formTemplateProps.startdate);
      vm.newForm.enddate = new Date(vm.formTemplateProps.enddate);
      vm.newForm.formTimezone = vm.formTemplateProps.formTimezone;
      vm.newForm.emailTemplate = vm.formTemplateProps.emailTemplate;
      vm.newForm.isAvailableAsFormTemplate = 0; // never clone this property
      if (vm.formTemplateProps.emailTemplate) {
        const targetTemplate = EmailTemplatesFactory.getData().itemsObject[vm.formTemplateProps.emailTemplate];
        if (targetTemplate) {
          vm.emailTemplateTitle = targetTemplate.emailtemplate.title;
        }
      }
    }
    if (!vm.newForm.cloneFormSettings) {
      // change of plan, reset visible settings and remove flag, defaults will be set on the server
      vm.newForm.startdate = '';
      vm.newForm.enddate = '';
      vm.newForm.formTimezone = '';
      vm.newForm.emailTemplate = '';
      vm.newForm.formTemplateId = '';
    }
  };

  // modal dismiss functions
  vm.hide = function () {
    MessageService.closeDialog();
  };

  vm.cancelDialog = function () {
    MessageService.cancelDialog();
  };


  function resetForm() {
    delete vm.newForm.formTemplateId;
    delete vm.newForm.formTemplate;
    delete vm.newForm.cloneSourceFormId;
    delete vm.newForm.cloneSourceForm;
    delete vm.newForm.emailTemplate;
    delete vm.newForm.startdate;
    delete vm.newForm.enddate;
    delete vm.newForm.formTimezone;
    delete vm.newForm.emailTemplate;
    vm.newForm.cloneFormSettings = false;
    vm.newForm.cloneBadgeSettings = false;

    delete vm.formTemplateTitle;
    delete vm.cloneSourceFormTitle;
    delete vm.clonedFormProps;
    delete vm.formTemplateProps;
    vm.showUseFormSettingsSwitch = false;
    vm.showStep3 = false;
  }

}

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpLeadReleaseGrid', {
      controller: 'LeadReleaseCtrl',
      templateUrl: 'app/forms/lead-release-grid/zp-lead-release-grid.tmpl.html',
      bindings: {
        countOfMachinesRunningForForm: '<',
        metadata: '<'
      }
    })
    .controller('LeadReleaseCtrl', ctrl);

  ctrl.$inject = ['MessageService', 'PaginationManager', 'GridDataFactory', '$state', 'LeadDataFactory', 'EncodingService', 'ChangeDelta', 'localStorageService', 'IntegrationHeadlineWidgetsMetaData', 'DeleteAResponseColumn', 'DotNetShuttleService', 'SyncReleasePushAttemptsToGrid', 'IntegrationHeadlineWidgetsData', 'ResponseAggregationModel', '$timeout'];
  /* ng-inject */
  function ctrl(MessageService, PaginationManager, GridDataFactory, $state, LeadDataFactory, encoder, ChangeDelta, localStorage, IntegrationHeadlineWidgetsMetaData, DeleteAResponseColumn, DotNetShuttleService, SyncReleasePushAttemptsToGrid, IntegrationHeadlineWidgetsData, ResponseAggregationModel, $timeout) {

    var vm = this;
    
    const options = {
      useLocalCache: true,
      skip: 0,
      collection: 'contacts',
      sort: {
        lastname: 1
      }
    };

    vm.$onInit = function () {
      vm.formname = vm.metadata.formProperties.formname;
      vm.metadata.toolbarButtons.showEdit = false;
      vm.metadata.toolbarButtons.showDelete = false;
      vm.metadata.toolbarButtons.showLeadDownload = false;
      vm.metadata.toolbarButtons.showLeadBreakout = false;
      vm.metadata.toolbarButtons.showParkedLeads = false;

      vm.widgetId = 'lead_release';
      vm.metadata.id = vm.widgetId;
      vm.data = GridDataFactory.getDataForGrid(vm.widgetId);
      vm.blankSlate = (vm.data.items.length == 0);
      vm.formId = vm.metadata.formProperties._id;
      getGridDataForForm(options);
      checkForDocsInQueue();
      const releaseGridPageSize = localStorage.get(vm.widgetId);
      if (releaseGridPageSize) {
        vm.metadata.query.limit = releaseGridPageSize;
        vm.metadata.paginationOptions.limit = releaseGridPageSize;
      }
      PaginationManager.setQuery(vm.metadata.query, vm.widgetId);
      vm.changeDeltaFactory = ChangeDelta;
      vm.hideHelpToolbar = localStorage.get('hideParkedLeadHelpToolbar');
      pingEventToIntercom();
      columnsTidyUp();
      IntegrationHeadlineWidgetsData.updateIntegrationWidgetCounts(vm.data.rawData);
      vm.headlineWidgets = IntegrationHeadlineWidgetsMetaData(); // each widget will bind to value stored in IntegrationHeadlineWidgetsData factory
      vm.headlineWidgetsFactory = IntegrationHeadlineWidgetsData;
      vm.leadGridFactoryData = GridDataFactory.factoryData;

      authenticateViaJwt();
    };



    function checkForDocsInQueue() {
      const responsesWithWaitingStatus = _.chain(vm.data.rawData)
        .filter(function (leadObj) {
          return leadObj.response._integrationState === 'waiting';
        })
        .map(function (pendingLead) {
          return {
            _id: pendingLead.response._id
          };
        })
        .value();
      // console.log(responsesWithWaitingStatus.length + ' responses have waiting status');
      if (responsesWithWaitingStatus.length) {
        SyncReleasePushAttemptsToGrid.fetchPushDocs(responsesWithWaitingStatus);
      }
    }

    function columnsTidyUp() {
      DeleteAResponseColumn(vm.metadata.columnsData, '_aiProfile');
      DeleteAResponseColumn(vm.metadata.columnsData, '_leadIsValid');
      DeleteAResponseColumn(vm.metadata.columnsData, '_distilledIntegrationState');
      DeleteAResponseColumn(vm.metadata.columnsData, '_parkedlead');
    }

    vm.setHideHelpToolbar = function () {
      localStorage.set('hideParkedLeadHelpToolbar', true);
      vm.hideHelpToolbar = true;
    };

    vm.goBack = function () {
      $state.go('app.tabbed_app_framework.single_form.grid', {
        _id: encoder.encode(vm.metadata.formProperties._id)
      });
    };

    vm.saveGridChanges = function () {
      vm.saveDisabled = true;
      const changeDeltas = ChangeDelta.getDeltaObject();
      if (_.isEmpty(changeDeltas)) return;
      LeadDataFactory.saveGridChanges(changeDeltas)
        .then(function () {
          ChangeDelta.clear();
          GridDataFactory.removeDirtyFlagFromAllRows(vm.widgetId);
          MessageService.showMessage('Grid changes saved');
          vm.saveDisabled = false;
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });

        });
    };

    vm.logPagination = function (page, limit) {
      PaginationManager.setQuery({
        page: page,
        limit: limit
      }, vm.widgetId);
      $('md-content').animate({ scrollTop: 0 }, 0);
    };

    function pingEventToIntercom() {
      MessageService.pushEventToIntercom('accessed_lead_release_grid', {
        formname: vm.formname
      });
      MessageService.updateIntercom();
    }

    // MENU FUNCTIONS
    vm.openMenu = function (func, ev) {
      func(ev);
    };

    function authenticateViaJwt() {
      vm.loading = true;
      DotNetShuttleService.authenticateViaJwt()
        .then(function () {
          vm.loading = false;
        })
        .catch(function () {
          vm.loading = false;
        });
    }

    vm.goToMachinesPage = function () {
      $state.go('app.homescreen_app_framework.integration-home');
    };

    vm.refreshGridData = function () {
      vm.loading = true;
      LeadDataFactory.invalidateFactoryCache();
      ResponseAggregationModel.init(vm.formId);
      options.useLocalCache = false;
      getGridDataForForm(options);
    };

    function getGridDataForForm(options) {
      LeadDataFactory.getGridDataForForm(vm.formId, options)
        .then(function (factoryData) {
          vm.data = factoryData.leadData;
          vm.blankSlate = (vm.data.items.length == 0);
          vm.totalRows = vm.data.items.length;
          $timeout(function () {
            vm.loading = false;
          }, 1000);

          if (!options.useLocalCache) {
            MessageService.showMessage('Grid data refreshed');
          }
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('LeadReleaseRouteResolve', factory);

  factory.$inject = ['FormMetadataFactory', 'GridMetaDataFactory', 'MachinesSetToRunForForm', 'PermPermissionStore'];
  /* ng-inject */
  function factory(FormMetadataFactory, GridMetaDataFactory, MachinesSetToRunForForm, PermPermissionStore) {

    return function () {
      const _formid = FormMetadataFactory.getData().formProperties._id;
      const resolveObj = {
        countOfMachinesRunningForForm: 0,
        metadata: {}
      };
      return MachinesSetToRunForForm(_formid)
        .then(function (arrayOfMachineNames) {
          resolveObj.countOfMachinesRunningForForm = arrayOfMachineNames.length;
          return hydrateGridWithMetadata();
        })
        .then(function (metadata){
          resolveObj.metadata = metadata;
          GridMetaDataFactory.hydrateData(metadata.columnsData, 'lead_release');
          return resolveObj;
        })
        .catch(function (err) {
          throw err;
        });
    };

    function hydrateGridWithMetadata() {
      const metadata = angular.copy(FormMetadataFactory.getData());
      return userHasPermissionsToReleaseLeads(metadata)
        .then(function () {
          return gridEditPermissionsCheck(metadata);
        })
        .then(function (){
          return metadata;
        });

    }

    function userHasPermissionsToReleaseLeads(metadata) {
      // console.log('check user has release leads permissions');
      const gridEditPerm = PermPermissionStore.getPermissionDefinition('INTEGRATION_LEAD_RELEASE_RELEASE');
      return new Promise(function (resolve) {
        return gridEditPerm.validatePermission()
          .then(function () {
            // console.log('user DOES have release permissions');
            metadata.gridOptions.rowSelection = true;
            return resolve();
          })
          .catch(function () {
            // console.log('user DOES NOT have release permissions');
            metadata.gridOptions.rowSelection = false;
            return resolve();
          });
      });

    }

    function gridEditPermissionsCheck(metadata) {
      // console.log('checking user has grid edit permissions');
      const gridEditPerm = PermPermissionStore.getPermissionDefinition('INTEGRATION_LEAD_RELEASE_EDIT');
      return new Promise(function (resolve) {
        return gridEditPerm.validatePermission()
          .then(function () {
            // console.log('user DOES have grid edit perms');
            metadata.gridOptions.interactive = true;
            return resolve();
          })
          .catch(function () {
            // console.log('user DOES NOT have grid edit perms');
            metadata.gridOptions.interactive = false;
            return resolve();
          });
      });
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .component('zpLeadGridPage', {
      templateUrl: 'app/forms/grid-page/zp-lead-grid-page.tmpl.html',
      controller: 'zpLeadGridPageController',
      bindings: {}
    })
    .controller('zpLeadGridPageController', zpLeadGridPageController);

  zpLeadGridPageController.$inject = ['$scope', 'LeadDataFactory', 'ChangeDelta', 'FormMetadataFactory', 'PaginationManager', 'MessageService', 'PermPermissionStore', 'MasterPermissionsDefinitionFactory', 'hotkeys', 'GridDataFactory', 'GridMetaDataFactory', 'DeleteAResponseColumn', '$timeout', 'ResponseAggregationModel', 'FormExtraColsFactory', 'ColumnSelectionSvc', 'EnvService'];
  /* ng-inject */
  function zpLeadGridPageController($scope, LeadDataFactory, ChangeDelta, FormMetadataFactory, PaginationManager, MessageService, PermPermissionStore, MasterPermissionsDefinitionFactory, hotkeys, GridDataFactory, GridMetaDataFactory, DeleteAResponseColumn, $timeout, ResponseAggregationModel, FormExtraColsFactory, ColumnSelectionSvc, EnvService) {

    var vm = this;

    vm.loading = true;
    vm.data = {
      items: []
    };
    // Fetch the grid data once the view has loaded so the UX is smoother. Grid loads headers and inidcator is displayed whilst the data is being fetched.

    vm.options = {
      useLocalCache: true,
      skip: 0,
      collection: 'contacts',
      sort: {
        lastname: 1
      },
      includeArchived: false
    };

    vm.$onInit = function () {
      vm.isDev = EnvService.isDev;
      vm.metadata = angular.copy(FormMetadataFactory.getData());
      vm.metadata.toolbarButtons.showEdit = true;
      vm.metadata.toolbarButtons.showDelete = true;
      vm.metadata.toolbarButtons.showUnarchive = false;

      vm.metadata.id = 'submitted_leads';
      vm.metadata.csvFileLabel = 'submitted_leads_report';
      GridMetaDataFactory.hydrateData(vm.metadata.columnsData, vm.metadata.id);
      gridEditPermissionsCheck(vm.metadata);
      vm.formname = vm.metadata.formProperties.formname;
      vm.formId = vm.metadata.formProperties._id;
      getGridDataForForm(vm.options);
      PaginationManager.setQuery(vm.metadata.query, vm.metadata.id);
      vm.changeDeltaFactory = ChangeDelta;
      vm.showHints = false;
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.leadGridFactoryData = GridDataFactory.factoryData;

      hotkeys.add({
        combo: 'ctrl+p',
        description: 'Manage parked leads',
        callback: function () {
          vm.openParkedLeadsDialog();
        }
      });
      columnsTidyUp();
    };
    // end onInit

    function columnsTidyUp() {
      DeleteAResponseColumn(vm.metadata.columnsData, '_leadIsValid');
      DeleteAResponseColumn(vm.metadata.columnsData, '_parkedlead');
      DeleteAResponseColumn(vm.metadata.columnsData, '_integrationState');
      DeleteAResponseColumn(vm.metadata.columnsData, '_distilledIntegrationState');
      DeleteAResponseColumn(vm.metadata.columnsData, '_latestDetailedReleaseAttempt');
    }

    vm.toggleShowArchivedLeads = function () {
      LeadDataFactory.invalidateFactoryCache();
      toggleDeleteDateColumnVisibility();
      toggleUnarchiveToolbarButtonVisibility();
      setGridSortOrder();
      getGridDataForForm(vm.options);
    };

    function setGridSortOrder() {
      if (vm.options.includeArchived) {
        vm.metadata.query.order = {
          id: 'response._deletedatelocalutc',
          expression: 'response._deletedatelocalutc.raw'
        };
      } else {
        vm.metadata.query.order = {
          id: 'contact.lastname',
          expression: 'contact.lastname.raw'
        };
      }
    }

    function toggleDeleteDateColumnVisibility() {
      const index = _.findIndex(vm.metadata.columnsData.items, function (col) { return col.databasefieldname === '_deletedatelocalutc'; });
      if (index > -1) {
        vm.metadata.columnsData.items[index].showCol = vm.options.includeArchived;
        if (!vm.options.includeArchived) {
          FormExtraColsFactory.removeDeleteDateCol(vm.metadata.columnsData.items, index);
          ColumnSelectionSvc.hydrateFactoryWithColumns(vm.metadata);
          FormMetadataFactory.setData(vm.metadata);
        }
      } else {
        if (vm.options.includeArchived) {
          FormExtraColsFactory.addDeleteDateCol(vm.metadata.columnsData.items);
          ColumnSelectionSvc.hydrateFactoryWithColumns(vm.metadata);
          FormMetadataFactory.setData(vm.metadata);
        }
      }
    }

    function toggleUnarchiveToolbarButtonVisibility() {
      vm.metadata.toolbarButtons.showUnarchive = vm.options.includeArchived;
    }

    function generateColumnLabel(meshDbField) {
      switch (meshDbField) {
        case 'meshSiteName':
          return 'QR site name';
        case 'meshPointName':
          return 'QR point name';
        case 'meshActivity':
          return 'QR activity';
        case 'meshAction':
          return 'QR action';
      }
    }

    function addMissingMeshColumns(meshDbFieldNames) {
      const items = vm.metadata.columnsData.items;
      const itemsObject = vm.metadata.columnsData.itemsObject;

      const existingColumnDatabaseFieldNames = new Set(items.map((col) => col.databasefieldname));

      //this just ensures that we try and put the columns somewhere more prominent than the end of the grid. 
      let insetionIndex = items.findIndex((col) => {
        const dbFieldName = _.get(col, 'databasefieldname', null);
        const dbObject = _.get(col, 'object', null);

        if (!dbFieldName || !dbObject) return false;

        if (dbFieldName === 'Follow-up Required?' && dbObject === 'response') return true;
      });

      if (insetionIndex === -1) insetionIndex = items.length > 0 ? items.length - 1 : 0;

      for (const meshDbField of meshDbFieldNames) {
        if (existingColumnDatabaseFieldNames.has(meshDbField)) continue;

        const label = generateColumnLabel(meshDbField);

        const col = {
          databasefieldname: meshDbField,
          label,
          object: 'response',
          type: 'Textfield',
          editable: false,
          showCol: true,
          sortOn: 'rawValue',
          cellDefaultValue: '',
        };

        const key = `response_${meshDbField}`;
        itemsObject[key] = col;

        existingColumnDatabaseFieldNames.add(meshDbField);
        items.splice(insetionIndex, 0, col);
        insetionIndex++;
      }
    }

    function checkIfLeadsContainMeshField(meshDbFieldNames) {
      const responseObjs = vm.data.rawData.filter((itm) => {
        if (_.has(itm, 'response') === false) return false;

        const response = _.get(itm, 'response', {});
        if (_.isEmpty(response)) return false;

        const responseObjKeys = Object.keys(response);

        const hasMeshKey = _.intersection(responseObjKeys, meshDbFieldNames).length > 0;
        if (!hasMeshKey) return false;

        return true;
      }).map((itm) => itm.response);

      if (responseObjs.length > 0) return true;

      return false;
    }

    function checkIfMeshColumnsAreRequired() {
      const meshDbFieldNames = ['meshSiteName', 'meshPointName', 'meshActivity', 'meshAction'];

      const leadsContainMeshField = checkIfLeadsContainMeshField(meshDbFieldNames);

      if (leadsContainMeshField) {
        addMissingMeshColumns(meshDbFieldNames);
        return;
      }

    }

    function getGridDataForForm(options) {
      LeadDataFactory.getGridDataForForm(vm.formId, options)
        .then(function (factoryData) {
          vm.data = factoryData.leadData;
          vm.metadata.toolbarButtons.showLeadBreakout = factoryData.showBreakoutDownloadButton;
          vm.blankSlate = (vm.data.items.length == 0);
          vm.totalRows = vm.data.items.length;
          
          checkIfMeshColumnsAreRequired();

          $timeout(function () {
            vm.loading = false;
          }, 1000);

          if (!options.useLocalCache) {
            MessageService.showMessage('Grid data refreshed');
          }
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    }

    function gridEditPermissionsCheck(metadata) {
      const gridEditPerm = PermPermissionStore.getPermissionDefinition('LEADS_EDITGRID');
      gridEditPerm.validatePermission()
        .then(function () {
          metadata.gridOptions.rowSelection = true;
          metadata.gridOptions.multiSelect = true;
          metadata.gridOptions.interactive = true;
        })
        .catch(function () {
          metadata.gridOptions.rowSelection = false;
          metadata.gridOptions.multiSelect = false;
          metadata.gridOptions.interactive = false;
        });
    }

    vm.refreshGridData = function () {
      vm.loading = true;
      LeadDataFactory.invalidateFactoryCache();
      ResponseAggregationModel.init(vm.formId);
      vm.options.useLocalCache = false;
      getGridDataForForm(vm.options);
    };

    vm.logPagination = function (page, limit) {
      PaginationManager.setQuery({
        page: page,
        limit: limit
      }, vm.metadata.id);
      $('md-content').animate({ scrollTop: 0 }, 0);
    };

    vm.fullScreenGrid = function (ev) {
      // const useFullScreen = ($mdMedia('sm') || $mdMedia('xs'));

      const dialogConfig = {
        description: 'Full screen grid',
        controller: 'FullScreenGrid as vm',
        templateUrl: 'app/forms/grid-page/full-screen-grid.tmpl.html',
        locals: {},
        ariaLabel: 'Full screen grid'
      };

      MessageService.showDialog(ev, dialogConfig)
        .then(function (data) {
          $scope.$emit('zp.fab.added', {
            data: data
          });
        })
        .catch(function () { });
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('SingleFormFactory', factory);
  factory.$inject = ['FormAPI'];
  /* ng-inject */
  function factory(FormAPI) {

    const factoryData = {
      saveBtnDisabled: false
    };

    return {
      getFormById: getFormById,
      saveForm: saveForm,
      deleteForm: FormAPI.delete,
      setFormSettingsCache: setFormSettingsRawCache,
      factoryData: factoryData
    };

    function getFormById(_id) {
      return FormAPI.getFormById(_id)
        .then(function (res) {
          setFormSettingsRawCache(res.data.data);
          const formSettingsWithDefaults = setDefaultsForViewModel(res.data.data);
          return formSettingsWithDefaults;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function setDefaultsForViewModel(serverFormProps) {

      const serverPropsMergedWithDefaults = Object.assign({
        archived: 0,
        showroomFormId: '',
        requireLiterature: 0,
        showroomFormIsMendatory: 0,
        displayWarningOnExitingShowroom: 0,
        clearShowroomForNewResponse: 0,
        blocksMenu: {
          useBlocksMenu: 0,
          showroomCanBeDismissed: 0,
          navigationBackButtonAvailable: 0,
          filtersAvailable: 0,
          entryBlock: '',
          backgroundImageContentMode: '',
          captureLeadText: ''
        },
        isLiveForIntegration: 0,
        ocrTemplate: '',
        // scanning
        barcodeDelimiter: '',
        allowCameraSymbology128: 0,
        allowCameraSymbology25: 0,
        allowCameraSymbology39: 0,
        allowCameraSymbologyAZTEC: 0,
        allowCameraSymbologyDM: 0,
        allowCameraSymbologyPDF417: 0,
        allowCameraSymbologyQRCODE: 0,
        urlDecodeValues: 0,
        assumeScanIsNewLead: 0,
        assumeScanIsNewContact: 0,
        removeSymbology128CheckDigit: 0,
        removeSymbology25CheckDigit: 0,
        removeSymbology39CheckDigit: 0,
        code25SymbologyMinLength: 0,
        code39SymbologyMinLength: 0,
        // api scanning
        compusystemsBaseUrl: '',
        compusystemsEventId: '',
        compusystemsOn: 0,
        compusystemsTimeout: 5,
        compusystemsToken: '',
        experientActCode: '',
        experientApiKey: '',
        experientBadgeId: '',
        experientBaseUrl: '',
        experientConcatenatePhone: 0,
        experientOn: 0,
        experientTimeout: 0,
        zuantWebLookupBaseUrl: '',
        zuantWebLookupLeadCaptureStatus: '',
        zuantWebLookupOn: 0,
        zuantWebLookupSystem: '',
        zuantWebLookupTimeout: 0,
        zuantWebLookupToken1: '',
        zuantWebLookupToken2: '',
        // advanced scanning settings
        barcodeExcludeChars: '',
        barcodeStartSequence: '',
        barcodeDecryptionVector: '',
        NFCAutoDisplayPeripheralList: 0,
        NFCNDEFTypeName: '',
        NFCNDEFTypeNo: '',
        // advanced settings
        requireSearchButtonPress: 0,
        showScanButtonInToolbar: 1,
        ezTouchEnabled: 1,
        ezMenuEnabled: 1,
        kioskMode: 'Form',
        isAvailableAsFormTemplate: 0,
        waiveGDPRCompliance: 0,
        privacyStatement: '',
        waivePrivacyStatement: 0,
        privacyStatementActionButtonText: '',
        allowEmptyFormSubmissions: 0,
        requireNotes: 0,
        scoreLead: 0,
        preventManualScrolling: 0,
        bypassConfigurationChecks: 0,
        excludeUsersFromRecipientLists: 0,
        keepLeadsPrivate: 0,
      }, serverFormProps);

      return serverPropsMergedWithDefaults;
    }

    function saveForm(formId, deltas) {

      factoryData.saveBtnDisabled = true;
      const updatedFormMerged = _.extend({}, factoryData.formSettingsCache, deltas);

      setFormSettingsRawCache(updatedFormMerged);

      return FormAPI.update(formId, deltas)
        .then(function () {
          factoryData.saveBtnDisabled = false;
        })
        .catch(function (err) {
          factoryData.saveBtnDisabled = false;
          throw (err);
        });
    }

    function setFormSettingsRawCache(formSettings) {
      factoryData.formSettingsCache = formSettings;
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('LiteratureNamesFactory', litNames);

  litNames.$inject = ['LiteratureAPI', 'TagsAPI', '$q', 'MessageService'];
  /* ng-inject */
  function litNames(LiteratureAPI, TagsAPI, $q, MessageService) {

    let factoryData;
    buildFactory();

    return {
      getAllLiteratureDocs: getAllLiteratureDocs,
      getCache: getCache,
      getLiteratureDocById: getLiteratureDocById,
      getDocsObject: getDocsObject,
      // tags stuff
      getAllTagDocs: getAllTagDocs,
      getTagsCache: getTagsCache,
      getTagDocById: getTagDocById,

      fillTagsLiteratureArray: fillTagsLiteratureArray,

      resetFactory: buildFactory,
      invalidateCache: invalidateCache
    };

    //////////////////////////////////

    function buildFactory() {
      factoryData = {
        litDocsObj: {},
        litDocsCache: [],
        tagDocsCache: [],
        tagDocsObj: {},
        cacheValid: null
      };
    }

    function invalidateCache() {
      factoryData.cacheValid = false;
    }

    function getAllLiteratureDocs() {
      return $q(function q(resolve, reject) {
        if (factoryData.cacheValid) {
          resolve(factoryData);
        } else {
          const query = {
              // _deletedatelocalutc: {
              //   $exists: false
              // }
            },
            fields = {
              _id: 1,
              title: 1,
              tags: 1,
              weburi: 1
            };
          return LiteratureAPI.getDocsByQuery(query, fields)
            .then(function (resp) {
              factoryData.litDocsCache = resp.data.data;
              buildLiteratureDocumentsObject(resp.data.data);
              factoryData.cacheValid = true;
              resolve();
            })
            .catch(function (err) {
              reject(err);
            });
        }
      });
    }

    function getCache() {
      return factoryData.litDocsCache;
    }

    function getDocsObject() {
      return factoryData.litDocsObj;
    }

    function getLiteratureDocById(docId) {
      if (factoryData.litDocsObj[docId]) {
        return factoryData.litDocsObj[docId];
      } else {
        MessageService.writeLog({
          level: 'error',
          msg: 'Missing literature: ' + docId
        });
        return {
          title: 'Missing literature'
        };
      }
    }

    function buildLiteratureDocumentsObject(litDocs) {
      _.each(litDocs, function (doc) {
        factoryData.litDocsObj[doc._id] = {
          caption: doc.title,
          title: doc.title,
          weburi: doc.weburi,
          tags: doc.tags
        };
      });
    }

    /***
    TAGS STUFF
    */
    function getAllTagDocs() {
      // $log.info('server trip to get all tag docs'); // TODO check cache
      return TagsAPI.getAllTagDocs()
        .then(function (resp) {
          factoryData.tagDocsCache = resp.data.data;
          buildTagsObject(resp.data.data);
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function buildTagsObject(tagDocs) {
      _.each(tagDocs, function (tagCat) {
        // $log.info(tagCat);
        _.each(tagCat.tags, function (tag) {
          factoryData.tagDocsObj[tag._id] = {
            tagCategory: tagCat.category,
            tagTitle: tag.title,
            literatureIds: []
          };
        });
      });
    }

    function getTagsCache() {
      factoryData.tagDocsCache;
    }

    function getTagDocById(tagId) {
      if (factoryData.tagDocsObj[tagId]) {
        return factoryData.tagDocsObj[tagId];
      } else {
        MessageService.writeLog({
          level: 'error',
          msg: 'Missing tag: ' + tagId
        });
        return {
          title: 'Missing tag'
        };
      }
    }

    function fillTagsLiteratureArray() {
      _.each(factoryData.litDocsObj, function (litDocument, key) {
        litDocument.tagsObj = {};
        _.each(litDocument.tags, function (tag) {
          if (!factoryData.tagDocsObj[tag]) {
            factoryData.tagDocsObj[tag] = {
              literatureIds: [key]
            };
          } else {
            factoryData.tagDocsObj[tag].literatureIds.push(key);
          }
        });
      });
      return factoryData.tagDocsObj;
    }

    //end of factory
  }
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('LiteratureAPI', litApi);

  litApi.$inject = ['APIFactory'];
  /* ng-inject */
  function litApi(apiFactory) {

    const litApi = apiFactory.route('literature');

    return {
      getAllLiteratureDocs: litApi.get,
      getLiteratureById: litApi.getById,
      getDocsByQuery: getDocsByQuery
    };

    //////////////////////////////////

    function getDocsByQuery(query, fields) {

      var apiUrl = 'query',
        queryObj = {
          parameters: query,
          fields: fields
        };

      return litApi.post(apiUrl, queryObj)
        .then(function (response) {
          return response;
        })
        .catch(function (err) {
          throw (err);
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('TagsAPI', tagsApi);

  tagsApi.$inject = ['APIService', 'APIFactory'];
  /* ng-inject */
  function tagsApi(api, apiFactory) {

    var tagsApi = apiFactory.route('tags');

    var services = {
      getAllTagDocs: tagsApi.get,
      getTagById: tagsApi.getById
    };

    return services;

    //////////////////////////////////

  }
})();

/**
 * Created by davidbeazer on 06/01/2017.
 */
(function () {
  'use strict';

  angular
    .module('forms')
    .factory('LeadDataFactory', LeadDataFactory);

  LeadDataFactory.$inject = ['GridAPI', '$filter', 'FormMetadataFactory', '$q', 'ValidationHelperFactory', 'SessionService', 'DeltaAPI', 'MessageService', 'GridDataFactory', 'LeadValidationFactory', 'IntegrationHeadlineWidgetsData', 'FormsFactory', 'CellInteractionFactory'];
  /* ng-inject */
  function LeadDataFactory(GridAPI, $filter, FormMetadataFactory, $q, ValidationHelperFactory, SessionService, DeltaAPI, MessageService, GridDataFactory, LeadValidationFactory, IntegrationHeadlineWidgetsData, FormsFactory, CellInteractionFactory) {

    let factoryData = {};
    buildFactory();

    return {
      getGridDataForForm: getGridDataForForm,
      saveGridChanges: saveGridChanges,
      archiveLeads: archiveLeads,
      unarchiveLeads: unarchiveLeads,
      getData: getData,
      hydrateLeadsSubsetFilteredByResponseId: hydrateLeadsSubsetFilteredByResponseId,
      flattenArraysOfResponseIds: flattenArraysOfResponseIds,
      clearFactoryData: buildFactory,
      factoryData: factoryData,
      invalidateFactoryCache: invalidateFactoryCache,
      factoryCacheIsValid: function (_formid) { return ValidationHelperFactory.dataCacheIsStillValid(factoryData.dataCache, _formid); },
      unparkLeads: unparkLeads
    };

    //////////////////////////////

    function getGridDataForForm(_formid, options) {
      factoryData.options = options;
      
      return $q(function q(resolve, reject) {
        if (ValidationHelperFactory.dataCacheIsStillValid(factoryData.dataCache, _formid)) {
          resolve(factoryData);
        } else {
          const starttime = moment();
          GridAPI.getResponsesForForm(_formid, options)
            .then(function (resp) {
              const endTime = moment();
              const duration = endTime.diff(starttime);
              MessageService.writeLog({
                level: 'info',
                msg: 'fetched leads for form. It took ' + duration + ' milliseconds',
                tags: ['getGridDataForForm']
              });
              const submittedLeadsObj = processLeads(resp.data.data.submittedLeads, 'submitted_leads');
              GridDataFactory.hydrateData(submittedLeadsObj, 'submitted_leads');
              GridDataFactory.hydrateData(submittedLeadsObj, 'lead_release');

              const parkedLeadsObj = processLeads(resp.data.data.parkedLeads, 'parked_leads');
              GridDataFactory.hydrateData(parkedLeadsObj, 'parked_leads');

              IntegrationHeadlineWidgetsData.setInitialWidgetCounts(resp.data.data.submittedLeads);
              setFactoryData({
                resp: resp.data.data,
                submittedLeadsObj: submittedLeadsObj,
                parkedLeadsObj: parkedLeadsObj,
                _formid: _formid,
                options: options
              });

              resolve(factoryData);
            })
            .catch(function (err) {
              reject(err);
            });
        }
      });
    }

    function setFactoryData(data) {
      factoryData.leadData = data.submittedLeadsObj; // used by reporting aggregation factory
      factoryData.parkedLeadData = data.parkedLeadsObj;
      factoryData.breakoutLookups = data.resp.breakoutLookups;
      factoryData.relatedLiteratures = data.resp.relatedLiteratures;
      factoryData.relatedTags = data.resp.relatedTags;
      factoryData.subresponses = data.resp.subresponses;
      factoryData.countOfEmailsSentForThisForm = data.resp.countOfEmailsSentForThisForm;
      factoryData.showBreakoutDownloadButton = checkIfAnyLiteratureAttached(data.submittedLeadsObj);
      factoryData.limit = data.options.limit;
      factoryData._formid = data._formid;
      factoryData.dataCache.lastServerTripTimestamp = new Date();
      factoryData.dataCache.valid = true;
      factoryData.dataCache.cachedObjectId = data._formid;
      factoryData.dataCache.clientId = SessionService.getUserData().clientId;
    }

    function invalidateFactoryCache() {
      factoryData.dataCache.lastServerTripTimestamp = '';
      factoryData.dataCache.valid = false;
      factoryData.dataCache.clientId = SessionService.getUserData().clientId;
    }

    function checkIfAnyLiteratureAttached(leadsObj) {
      // if literature is attached to a lead then breakout is possible, otherwise, don't show it as a download option
      // TODO check what the definitive condition is in order for breakout to work
      let literaturePresent;
      _.each(leadsObj.rawData, function (lead) {
        if (lead.response._literature) {
          if (lead.response._literature.length) literaturePresent = true;
        }
      });
      return literaturePresent;
    }

    function getData(downloadOptions) {
      if (downloadOptions) {
        if (downloadOptions.downloadSubset) {
          const rawData = factoryData.filteredLeadsSubset.items;
          return {
            leadData: {
              items: $filter('enhancedTableCells')(FormMetadataFactory.getData(), rawData),
              rawData
            }
          };
        }

        //handles just exporting grid selections. If no selections then export everything!
        if (downloadOptions.selectedRows && downloadOptions.selectedRows.length > 0){
          const rawLeadData = downloadOptions.parked ? factoryData.leadData.rawData : downloadOptions.selectedRows;
          const rawParkedLeadData = downloadOptions.parked ? downloadOptions.selectedRows : factoryData.parkedLeadData.rawData;
          return _.extend({}, factoryData, {
            leadData: {
              items:  $filter('enhancedTableCells')(FormMetadataFactory.getData(), rawLeadData),
              rawData: rawLeadData
            },
            parkedLeadData: {
              items:  $filter('enhancedTableCells')(FormMetadataFactory.getData(), rawParkedLeadData),
              rawData: rawParkedLeadData
            }
          });
        }
      }
      return factoryData;
    }

    function saveGridChanges(deltaObject) {

      return DeltaAPI.postDeltas(deltaObject)
        .then(function (response) {
          if (response.success) {
            MessageService.writeLog({
              level: 'info',
              msg: '🌍 NEW WORLD grid changes save success',
              tags: ['new_world_delta_save']
            });
            return response;
          }
        })
        .catch(function (err) {
          MessageService.showMessage('There was an error saving changes');
          MessageService.writeLog({
            level: 'error',
            msg: 'grid changes save error',
            tags: ['delta_save']
          });
          throw (err);
        });

    }


    function archiveLeads(ev, widgetId) {
      /*
      deltaObj[collection][objectid][databasefieldname] = {
        oldvalue: oldval,
        newvalue: newval
      };
      */
      let leadsToArchive;
      return MessageService
        .confirm(ev)
        .delete('Sure to delete ' + GridDataFactory.factoryData[widgetId].selectedItems.length + ' items?')
        .then(function () {
          CellInteractionFactory.closeRelevantDialog();
          leadsToArchive = GridDataFactory.factoryData[widgetId].selectedItems;
          if (!factoryData.options.includeArchived) GridDataFactory.removeSelectedItemsFromFactory(widgetId);
          FormsFactory.invalidateCache();
          invalidateFactoryCache();
          return performDeletion(leadsToArchive).then(function(){
            return archiveTidyUp(leadsToArchive);
          });
        })
        .catch(function () {
          //dialog canceled no worries
        });
    }

    function unarchiveLeads(ev, widgetId) {
      /*
      deltaObj[collection][objectid][databasefieldname] = {
        oldvalue: oldval,
        newvalue: newval
      };
      */
      let leadsToUnArchive;
      return MessageService
        .confirm(ev)
        .unarchive('This command will unarchive ' + GridDataFactory.factoryData[widgetId].selectedItems.length + ' items?')
        .then(function () {
          leadsToUnArchive = GridDataFactory.factoryData[widgetId].selectedItems;
          FormsFactory.invalidateCache();
          invalidateFactoryCache();
          return performUnarchive(leadsToUnArchive);
        })
        .catch(function () {
          //dialog canceled no worries
        });
    }

    function archiveTidyUp(leadsToArchive) {
      MessageService.showMessage(leadsToArchive.length + ' rows deleted');
      MessageService.writeLog({
        level: 'info',
        msg: leadsToArchive.length + ' leads archived successfully',
        tags: ['lead_archive']
      });
      MessageService.pushEventToIntercom('archived_leads', {
        count: factoryData.submittedCount,
        formname: FormMetadataFactory.getData().formProperties.formname
      });
      MessageService.updateIntercom();
    }

    function performDeletion(leadsToArchive) {
      return GridAPI.getDeleteDate()
        .then(function (res) {
          const deltaObject = {
            response: {}
          };
          _.each(leadsToArchive, function (lead) {
            deltaObject.response[lead.response._id] = {
              _deletedatelocalutc: {
                oldvalue: '',
                newvalue: res.data._deletedatelocalutc
              }
            };
          });
          return saveGridChanges(deltaObject);
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function performUnarchive(leadsToUnArchive) {

      const deltaObject = {
        response: {}
      };
      _.each(leadsToUnArchive, function (lead) {
        deltaObject.response[lead.response._id] = {
          _deletedatelocalutc: {
            oldvalue: lead.response._deletedatelocalutc,
            newvalue: ''
          }
        };
      });
      return saveGridChanges(deltaObject);
    }

    function flattenArraysOfResponseIds(arrayOfArrayOfResponseIds) {
      const flattenedArray = _.flatten(arrayOfArrayOfResponseIds);
      return _.uniq(flattenedArray);
    }

    /**
     * @description this is used for reporting when showing a grid via a question/widget chart
     * TODO breakout into separate factory
     */
    function hydrateLeadsSubsetFilteredByResponseId(arrayOfResponseIds) {
      setLeadSubsetArray(arrayOfResponseIds);
      const leadsDataSubset = processLeads(factoryData.filteredLeadsSubset.items, 'full_page_widget_grid');
      return GridDataFactory.hydrateData(leadsDataSubset, 'full_page_widget_grid');
    }

    function setLeadSubsetArray(arrayOfResponseIds) {
      factoryData.filteredLeadsSubset.items.length = 0;
      for (let i = 0, j = arrayOfResponseIds.length; i < j; i++) {
        const target = factoryData.leadData.itemsObject[arrayOfResponseIds[i]];
        if (target) {
          factoryData.filteredLeadsSubset.items.push(target);
        }
      }
    }

    // PRIVATE HELPER FUNCTIONS

    function processLeads(rawLeadData, widgetId) {

      const leadsObj = {
        items: [],
        rawData: [],
        itemsObject: {},
        selectedItems: [],
        validation: {},
        mostRecentPushAttempts: {}
      };

      preprocessEmailSendData(rawLeadData);
      leadsObj.validation = LeadValidationFactory.validateRows({
        rowsData: rawLeadData,
        widgetId: widgetId
      });

      leadsObj.items = $filter('enhancedTableCells')(FormMetadataFactory.getData(), rawLeadData);
      leadsObj.rawData = rawLeadData;

      _.each(leadsObj.rawData, function (lead) {
        // the lead object contains unfiltered raw data.
        buildLeadItemsObject(leadsObj, lead);
      });

      return leadsObj;
    }

    function buildLeadItemsObject(leadsObj, lead) {
      leadsObj.itemsObject[lead.response._id] = lead;
    }

    function preprocessEmailSendData(leadData) {
      // extracts the _time timestamp out of the emailmessagessent array for grid consumption
      const metadataFactoryData = FormMetadataFactory.getData().formProperties;
      if (metadataFactoryData.emailTemplate != '') {
        for (let i = 0, j = leadData.length; i < j; i++) {
          if (leadData[i].contact.emailmessagessent) {
            for (let k = 0, l = leadData[i].contact.emailmessagessent.length; k < l; k++) {
              if (leadData[i].contact.emailmessagessent[k].emailtemplateid == metadataFactoryData.emailTemplate) { // TODO need to know the form the tye was sent for was this one. Add formid to emailmessagessent data object? This currently breaks as soon as the email template is changed for the form. (see #pie-chat-zuant-cloudd 7May19 )
                leadData[i].contact.thankYouEmailSentForThisForm = leadData[i].contact.emailmessagessent[k]._time;
              }
            }
          }
        }
      }
    }

    function unparkLeads(ev) {
      factoryData.submittedCount = 0;
      factoryData.leadString = '';

      const rowsValdationObject = LeadValidationFactory.validateRows({
        rowsData: GridDataFactory.factoryData.parked_leads.selectedItems,
        widgetId: 'parked_leads'
      });

      if (_.isEmpty(rowsValdationObject)) {
        // game on, all leads are valid to unpark
        performUnparkOperations();
      } else {
        // some rows have validation issues, notify user
        notifyUserOfValidationIssues(ev, rowsValdationObject);
      }
    }

    function performUnparkOperations() {
      const deltasObject = {
        response: {}
      };
      _.each(GridDataFactory.factoryData.parked_leads.selectedItems, function (selectedRowData) {
        unparkLead(selectedRowData);
        addLeadToSubmittedLeadsPot(selectedRowData);
        deltasObject.response[selectedRowData.response._id] = {
          _parkedlead: {
            newvalue: false
          }
        };
        factoryData.submittedCount++;
      });
      if (factoryData.submittedCount > 0) {
        saveChangesAndTidy(deltasObject);
      }
    }

    function unparkLead(leadRawData) {
      leadRawData.response._parkedlead = false;
    }

    function addLeadToSubmittedLeadsPot(leadRawData) {
      const leadDataForGrid = $filter('enhancedTableCells')(FormMetadataFactory.getData(), [leadRawData]);
      leadDataForGrid[0].dirty = false;
      leadRawData.dirty = false;
      factoryData.leadData.items.push(leadDataForGrid[0]);
      factoryData.leadData.rawData.push(leadRawData);
      factoryData.leadData.itemsObject[leadRawData.response._id] = leadRawData;
    }

    function saveChangesAndTidy(deltas) {
      GridDataFactory.removeSelectedItemsFromFactory('parked_leads');
      showUserSaveConfirmation();
      pingEventToIntercom();
      logUnparkSuccess();
      return saveGridChanges(deltas);
    }

    function showUserSaveConfirmation() {
      factoryData.leadString = (factoryData.submittedCount === 1) ? 'Lead' : 'Leads';
      MessageService.showMessage(factoryData.submittedCount + ' ' + factoryData.leadString + ' Unparked');
    }

    function pingEventToIntercom() {
      MessageService.pushEventToIntercom('unparked_leads', {
        count: factoryData.submittedCount,
        formname: FormMetadataFactory.getData().formProperties.formname
      });
      MessageService.updateIntercom();
    }

    function notifyUserOfValidationIssues(ev, rowsValdationObject) {
      let title;
      const invalidRows = Object.keys(rowsValdationObject).length;
      if (invalidRows === 1 && GridDataFactory.factoryData.parked_leads.selectedItems.length === 1) {
        title = '🛑 The selected lead is invalid';
      } else if (invalidRows === 1 && GridDataFactory.factoryData.parked_leads.selectedItems.length > 1) {
        title = '🛑 One of the selected leads is invalid';
      } else {
        title = '🛑 ' + invalidRows + ' selected leads are invalid';
      }
      MessageService
        .confirm(ev)
        .confirmAction({
          title: title,
          content: 'Please check all required fields are completed',
          okBtn: 'Close'
        })
        .then(function () { })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: 'error archiving leads: ' + err,
            tags: ['lead_archive']
          });
          throw (err);
        });
    }

    function logUnparkSuccess() {
      MessageService.writeLog({
        level: 'info',
        msg: 'User unparked ' + factoryData.submittedCount + ' leads',
        tags: ['parked_leads']
      });
    }

    function buildFactory() {
      // console.log('💣 Nuking grid data factory! 💣');
      factoryData = {
        filteredLeadsSubset: {
          items: []
        },
        leadData: {
          items: [],
          rawData: [],
          itemsObject: {},
          selectedItems: []
        },
        dataCache: {
          valid: false,
          lastServerTripTimestamp: null
        }
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('GridAPI', gridApi);

  gridApi.$inject = ['APIService', 'APIFactory'];
  /* ng-inject */
  function gridApi(api, apiFactory) {

    const gridApi = apiFactory.route('responses');

    return {
      getAllResponses: gridApi.get,
      getFormById: gridApi.getById,
      getResponsesForForm: getResponsesForForm,
      getDeleteDate: getDeleteDate,
      getPushAttemptDocs: getPushAttemptDocs,
      getDistilledIntegrationStates: getDistilledIntegrationStates,
      aggregateEmailsSentByForms: aggregateEmailsSentByForms,
      aggregateEmailsSentBySingleForm: aggregateEmailsSentBySingleForm,
      aggregateResponses: aggregateResponses,
      aggregateMatchedPotentialRecipients: aggregateMatchedPotentialRecipients,
      getBatchValues: getBatchValues
    };

    //////////////////////////////////

    function getResponsesForForm(_formid, options) {

      const queryObj = {
        _formid: _formid,
        responseColsToExclude: [],
        contactColsToExclude: [],
        companyColsToExclude: [],
        options: options
      };

      return gridApi.query(queryObj);
    }

    function getDeleteDate() {
      const apiUrl = 'responses/getdeletedate';
      return api
        .get(apiUrl)
        .then(function (response) {
          return response.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function aggregateResponses(queryObj) {
      return api.post('responses/aggregate', queryObj)
        .then(function (res) {
          return res;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function aggregateEmailsSentByForms(queryObj) {
      return api.post('responses/aggregateEmailsSentByForms', queryObj)
        .then(function (res) {
          return res.data.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function aggregateEmailsSentBySingleForm(queryObj) {
      return api.post('responses/aggregateEmailsSentBySingleForm', queryObj)
        .then(function (res) {
          return res.data.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }
   
    function aggregateMatchedPotentialRecipients(queryObj) {
      return api.post('responses/aggregateMatchedPotentialRecipients', queryObj)
        .then(function (res) {
          return res.data.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }
   
    function getBatchValues(queryObj) {
      return api.post('responses/getBatchValuesForForm', queryObj)
        .then(function (res) {
          return res.data.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }


    function getPushAttemptDocs(queryObj) {
      return api.post('responses/get-push-attempts-for-single-response', queryObj)
        .then(function (res) {
          return res.data.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function getDistilledIntegrationStates(queryObj) {
      return api.post('responses/distilledintegrationstate', queryObj)
        .then(function (res) {
          return res.data.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('FormsFactory', formsFactory);

  formsFactory.$inject = ['FormAPI', 'FormListMetadata', '$filter', '$q', 'ValidationHelperFactory', 'localStorageService', 'SessionService', 'PermPermissionStore', 'MasterPermissionsDefinitionFactory', 'GridDataFactory'];
  /* ng-inject */
  function formsFactory(FormAPI, FormListMetadata, $filter, $q, ValidationHelperFactory, localStorageService, SessionService, PermPermissionStore, MasterPermissionsDefinitionFactory, GridDataFactory) {

    const factoryData = {
      items: [],
      itemsObject: {},
      dataCache: {
        valid: false,
        lastServerTripTimestamp: null,
        clientId: null
      },
      dateSortedArrays: {
        previous: {
          items: []
        },
        current: {
          items: []
        },
        upcoming: {
          items: []
        }
      }
    };

    return {
      getAllForms: getAllForms,
      getData: getData,
      saveNewForm: saveNewForm,
      toggleShowArchivedSwitch: toggleShowArchivedSwitch,
      pushFormsOntoDateSortedArrays: pushFormsOntoDateSortedArrays,
      invalidateCache: invalidateCache,
      factoryData: factoryData,
      deleteForm: FormAPI.delete,
      toggleShowParkedColumn: toggleShowParkedColumn
    };

    //////////////////////////

    function getAllForms(includeArchivedForms) {
      return $q(
        function q(resolve, reject) {
          if (ValidationHelperFactory.dataCacheIsStillValid(factoryData.dataCache)) {
            hydrateFactoryWithForms(factoryData.unprocessedFormsArray);
            resolve(factoryData);
          } else {
            let query;
            if (includeArchivedForms) {
              query = {};
            } else {
              query = archivedFormsCheck();
            }
            const fields = {
              _id: 1,
              formname: 1,
              startdate: 1,
              enddate: 1,
              published: 1,
              emailTemplate: 1,
              _deletedatelocalutc: 1,
              isAvailableAsFormTemplate: 1
            };
            FormAPI.getDocsByQuery(query, fields)
              .then(function (res) {
                hydrateFactoryWithForms(res.data.data);
                resolve(factoryData);
              })
              .catch(function (err) {
                reject(err);
              });
          }
        });
    }

    function archivedFormsCheck() {
      const hideArchivedForms = localStorageService.get('hideArchivedForms');
      if (hideArchivedForms) {
        return {
          _deletedatelocalutc: {
            $exists: false
          }
        };
      } else {
        return {};
      }
    }

    function hydrateFactoryWithForms(data) {
      factoryData.items = data;
      factoryData.unprocessedFormsArray = angular.copy(data); // used by email templates tool

      const shapedData = shapeFormsForViewModels(factoryData.items);

      factoryData.items.length = 0; // empty out factoryData items by setting length to 0 so as to not break pre-existing bindings to components
      shapedData.forEach(function (newItem) {
        factoryData.items.push(newItem);
      });

      const formsObject = _.reduce(shapedData, function (formsObject, v) {
        formsObject[v.form._id] = v;
        return formsObject;
      }, {});
      factoryData.itemsObject = formsObject; // forms object is used for fast lookup (keyed off _id)
      emptyDateSortedArrays();

      const dateSortedArrays = pushFormsOntoDateSortedArrays();
      GridDataFactory.hydrateData(dateSortedArrays.previous, 'previous_forms_list');
      GridDataFactory.hydrateData(dateSortedArrays.upcoming, 'upcoming_forms_list');
      GridDataFactory.hydrateData(dateSortedArrays.current, 'current_forms_list');

      factoryData.dataCache.valid = true;
      factoryData.dataCache.lastServerTripTimestamp = new Date();
      factoryData.dataCache.clientId = SessionService.getUserData().clientId;
    }

    /**
     * @description has to accept an array of form docs fresh from the server as this shapes it ready for angular world consumption
     */
    function shapeFormsForViewModels(items) {
      const gridReadyArrayOfForms = shapeDataForGrid(items),
        arrayOfFormsFilteredForView = $filter('enhancedTableCells')(FormListMetadata.getData(), gridReadyArrayOfForms); // this $filter builds the necessary DOM element for a grid cell (image, button, text etc)
      return arrayOfFormsFilteredForView;
    }

    function invalidateCache() {
      factoryData.dataCache.valid = false;
      factoryData.dataCache.lastServerTripTimestamp = null;
      factoryData.dataCache.clientId = null;
    }

    function getData() {
      return factoryData;
    }

    function saveNewForm(formData) {
      const aiPerm = PermPermissionStore.getPermissionDefinition(MasterPermissionsDefinitionFactory.boltOns.ai.view);
      const hasAIPersmissionProm = new Promise(function (resolve) {
        aiPerm.validatePermission()
          .then(function () { resolve(true); })
          .catch(function () { resolve(false); });
      });
      
      return hasAIPersmissionProm.then(function (hasAIPersmission) {
        //enable aiEnabled flag if account has bolton permission
        if (hasAIPersmission) formData.aiEnabled = 1;
        return FormAPI.saveNewForm(formData)
          .then(function () {
            const shapedData = shapeFormsForViewModels([formData]);
            factoryData.items.push(shapedData[0]);
            factoryData.itemsObject[formData._id] = formData;
            factoryData.unprocessedFormsArray.push(formData);
            hydrateFactoryWithForms(factoryData.unprocessedFormsArray);
            return 'form added';
          })
          .catch(function (err) {
            throw (err);
          });
      });
    }

    function shapeDataForGrid(arrayOfUnprocessedItems) {
      return _.map(arrayOfUnprocessedItems, function (item) {
        return {
          form: {
            _id: item._id,
            formname: item.formname || '',
            responsecount: item.responsecount || 0,
            parkedcount: item.parkedcount || 0,
            icn: setStringForIcon(item),
            startdate: item.startdate,
            enddate: item.enddate,
            isAvailableAsFormTemplate: item.isAvailableAsFormTemplate || 0,
            pastPresentFuture: sortFormByStartDate(item),
            emailTemplate: item.emailTemplate
          }
        };
      });
    }

    function pushFormsOntoDateSortedArrays() {
      emptyDateSortedArrays();
      const hideArchivedForms = localStorageService.get('hideArchivedForms');
      const filteredArray = _.filter(factoryData.items, function (obj) {
        if (obj.form.icn.raw == 'archived' && !hideArchivedForms) {
          return true;
        } else if (obj.form.icn.raw != 'archived') {
          return true;
        }
      });
      // groups all form documents by their pastPresentFuture property ready for their respective forms list component
      const groupedFormsObject = _.groupBy(filteredArray, function (obj) {
        return obj.form.pastPresentFuture.raw;
      });

      _.each(groupedFormsObject, function (arr, prop) {
        if (arr.length) {
          _.each(arr, function (form) {
            factoryData.dateSortedArrays[prop].items.push(form);
          });
        }
      });

      if (!filteredArray.length) emptyDateSortedArrays();

      return factoryData.dateSortedArrays;
    }

    function toggleShowArchivedSwitch(hideArchivedForms) {
      if (!hideArchivedForms) {
        factoryData.dataCache.valid = false; // invalidate to force server trip for forms
      }
      localStorageService.set('hideArchivedForms', hideArchivedForms);
      return getAllForms();
    }

    function toggleShowParkedColumn(widgets) {
      const parkedLeadColumnCurrent = _.find(widgets.current.columnsData.items, function (column) {
        return column.databasefieldname === 'parkedcount';
      });
      const parkedLeadColumnUpcoming = _.find(widgets.upcoming.columnsData.items, function (column) {
        return column.databasefieldname === 'parkedcount';
      });
      const parkedLeadColumnPrevious = _.find(widgets.previous.columnsData.items, function (column) {
        return column.databasefieldname === 'parkedcount';
      });
      parkedLeadColumnCurrent.showCol = !parkedLeadColumnCurrent.showCol;
      parkedLeadColumnUpcoming.showCol = !parkedLeadColumnUpcoming.showCol;
      parkedLeadColumnPrevious.showCol = !parkedLeadColumnPrevious.showCol;

      localStorageService.set('hideParkedColumn', !widgets.previous.columnsData.items[5].showCol);
    }

    function emptyDateSortedArrays() {
      factoryData.dateSortedArrays.previous.items.length = 0;
      factoryData.dateSortedArrays.current.items.length = 0;
      factoryData.dateSortedArrays.upcoming.items.length = 0;
    }

    function setStringForIcon(obj) {
      if (obj._deletedatelocalutc) {
        return 'archived';
      } else if (obj.published == 1) {
        return 'published';
      } else if (obj.published == 0) {
        return 'draft';
      }
    }

    function sortFormByStartDate(form) {
      const dateNow = new Date(),
        fortnightAgo = new Date(+dateNow - 12096e5),
        fortnightAway = new Date(+dateNow + 12096e5);

      if (form.hasOwnProperty('startdate') && form.startdate !== 'undefined') {
        let startDate, endDate;
        if (typeof form.startdate.$date == 'undefined') {
          startDate = new Date(form.startdate);
          endDate = new Date(form.enddate);
        } else {
          startDate = new Date(form.startdate.$date);
          endDate = new Date(form.enddate.$date);
        }
        if (startDate > fortnightAway) {
          return 'upcoming';
        }
        const fortnightAfterEndDate = new Date(+endDate + 12096e5);
        if (startDate < fortnightAway && dateNow < fortnightAfterEndDate) {
          return 'current';
        }
        if (typeof form.enddate == 'undefined' || typeof form.enddate == 'string') {
          if (typeof form.enddate == 'string') {
            //WriteLogToServerFactory.info('Uh oh. Please contact the tech team and let them know there is an issue with this forms enddate value type.');
          }
          return 'previous';
        } else if (endDate < fortnightAgo) {
          return 'previous';
        }
      } else {
        // Form does not have start date. Show in past events list by default.
        form.startdate = '';
        return 'previous';
      }
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('FormsHelperFactory', FormsHelperFactory);

  FormsHelperFactory.$inject = [];

  function FormsHelperFactory() {

    return {
      findAllListsInForm: findAllListsInForm
    };

    function findAllListsInForm(formColumns) {
      const arrOfListIds = [];

      _.each(formColumns, function (col) {
        if (col.customListId) {
          arrOfListIds.push(col.customListId);
        }
      });

      return arrOfListIds;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('FormAPI', formApi);

  formApi.$inject = ['APIService', 'APIFactory', 'MessageService'];
  /* ng-inject */
  function formApi(api, apiFactory, MessageService) {

    const formApi = apiFactory.route('form');

    return {
      getAllForms: formApi.get,
      getFormById: formApi.getById,
      saveNewForm: formApi.create,
      delete: formApi.delete,
      update: update,
      getDocsByQuery: getDocsByQuery
    };

    //////////////////////////////////

    function getDocsByQuery(query, fields) {

      const apiUrl = 'query';
      const queryObj = {
        parameters: query,
        fields: fields
      };

      return formApi.post(apiUrl, queryObj)
        .then(function (response) {
          return response;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function update(formId, deltas) {

      const data = {
        formId: formId,
        deltas: deltas
      };

      return api.postToDataApi('form/savechanges', data)
        .then(function (response) {
          MessageService.writeLog({
            level: 'info',
            msg: 'postToDataApi success',
            tags: ['deltas']
          });
          return response.data;
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: 'postToDataApi error',
            tags: ['deltas']
          });
          throw (err);
        });
    }

  }
})();

/**
 * Created by davidbeazer on 06/01/2017.
 */
(function () {
  'use strict';

  angular
    .module('forms')
    .factory('FormMetadataFactory', FormMetadataFactory);

  FormMetadataFactory.$inject = ['FormExtraColsFactory', 'localStorageService', '$q', 'GridMetaDataFactory', 'ValidationHelperFactory', 'SessionService', 'SingleFormFactory'];
  /* ng-inject */
  function FormMetadataFactory(FormExtraColsFactory, localStorage, $q, GridMetaDataFactory, ValidationHelperFactory, SessionService, SingleFormFactory) {

    let factoryData = {};
    buildFactory();

    return {
      getData: getData,
      setData: setData,
      getMetaDataForMultiEditSession: getMetaDataForMultiEditSession,
      locateCellMetaDataById: locateCellMetaDataById,
      buildGridColumns: buildGridColumns,
      clearFactoryData: buildFactory,
      invalidateCache: invalidateCache
    };

    //////////////////////////////

    function invalidateCache() {
      factoryData.dataCache.valid = false;
    }

    function getData() {
      return factoryData;
    }
    
    function setData(incoming) {
      _.extend(factoryData, incoming);
    }

    function buildGridColumns(_formid) {
      return $q(function q(resolve, reject) {
        if (ValidationHelperFactory.dataCacheIsStillValid(factoryData.dataCache, _formid)) {
          resolve(factoryData);
        } else {
          SingleFormFactory.getFormById(_formid)
            .then(function (resp) {
              factoryData.formProperties = resp;
              buildGridMetaData(factoryData.formProperties.elements);
              orderColumns();
              factoryData.pickAWinnerEnabledForForm = isPickAWinnerEnabled(factoryData.formProperties.ezMenuItems);
              factoryData.estimatedRevenueEnabledForForm = isEstimatedRevenueEnabled(factoryData.columnsData.items);
              const props = Object.assign({ pickAWinnerEnabledForForm: factoryData.pickAWinnerEnabledForForm }, factoryData.formProperties);
              FormExtraColsFactory.addExtraCols(factoryData.columnsData.items, props)
                .then(function () {
                  factoryData.columnsData.items.map(function (col) {
                    factoryData.columnsData.itemsObject[col.object + '_' + col.databasefieldname] = col;
                  });
                  GridMetaDataFactory.hydrateData(factoryData, 'submitted_leads');
                  factoryData.dataCache.valid = true;
                  factoryData.dataCache.lastServerTripTimestamp = new Date();
                  factoryData.dataCache.clientId = SessionService.getUserData().clientId;
                  factoryData.dataCache.cachedObjectId = _formid;
                  resolve(factoryData);
                });
            })
            .catch(function (err) {
              reject(err);
            });
        }
      });
    }

    function isPickAWinnerEnabled(ezMenuItems) {
      if (!ezMenuItems) return false;
      const enabled = _.find(ezMenuItems, function (item) {
        return item === 'pickAWinnerButtonTapped';
      });
      return enabled === 'pickAWinnerButtonTapped';
    }

    function isEstimatedRevenueEnabled(columns) {
      return columns.findIndex((col)=> col.databasefieldname == 'estimatedRevenue') > -1;
    }

    // we need to trim the form fields to only include editable fields (no images, timestamps etc)
    function getMetaDataForMultiEditSession() {
      return _.filter(factoryData.columnsData.items, function (col) {
        return col.editable;
      });
    }

    function locateCellMetaDataById(targetColumnId) {
      return factoryData.columnsData.itemsObject[targetColumnId];
    }

    // PRIVATE HELPER FUNCTIONS

    function buildFactory() {

      factoryData = {
        id: 'submitted_leads',
        type: 'form',
        formProperties: {},
        navigateTo: '/forms/home',
        columnsData: {
          primaryIdentifier: {
            object: 'response',
            field: '_id'
          },
          items: [],
          itemsObject: {}
        },
        toolbarButtons: {
          showDelete: true,
          showEdit: true,
          showParkedLeads: true,
          showLeadDownload: true,
          showLeadBreakout: false,
          showSave: true,
          showColumnSelect: true,
          showDataRefreshButton: true
        },
        query: {
          order: {
            id: 'contact.lastname',
            expression: 'contact.lastname.raw'
          },
          limit: localStorage.get('submitted_leads') || 20,
          page: 1
        },
        paginationOptions: {
          boundaryLinks: true,
          limitSelect: true,
          pageSelect: true,
          pagination: true,
          limitOptions: [
            5,
            10,
            20,
            50,
            75,
            100
          ],
          limit: localStorage.get('submitted_leads') || 20,
          page: 1
        },
        gridOptions: {
          rowSelection: null,
          multiSelect: true,
          sortable: true,
          interactive: null
        },
        parkedLeadsDialogConfig: {
          description: 'Parked leads',
          controller: 'ParkedLeadsDialogCtrl as vm',
          templateUrl: 'app/forms/grid-page/dialogs/parked-leads.dialog.tmpl.html',
          locals: {},
          ariaLabel: 'View parked leads',
          useFullScreen: true
        },
        dataCache: {
          valid: false,
          lastServerTripTimestamp: null,
          clientId: null,
          cachedObjectId: null
        }
      };
    }

    function buildGridMetaData(formElements) {
      const arrayOfGridColumns = [];
      const arrayOfChartableColumns = [];
      const answersArrayObj = {};
      let columnObj;

      for (const element in formElements) {

        if (formElements[element]) {

          if (formElements[element].dbObjectName && formElements[element].dbElementName && formElements[formElements[element].labelTag]) {
            // this form element belongs to a dbObject of some sort and requires a grid column

            columnObj = {
              databasefieldname: formElements[element].dbElementName,
              label: formElements[formElements[element].labelTag].captions.English,
              placeholder: formElements[formElements[element].labelTag].captions.English,
              object: formElements[element].dbObjectName.toLowerCase(),
              type: formElements[element].elementType,
              required: formElements[element].required,
              editable: true,
              cellDefaultValue: setCellDefaultValue(formElements[element].elementType),
              showCol: true,
              requiresCustomList: false,
              hiddenInForm: formElements[element].hidden,
              sortOn: 'rawValue',
              pageNo: formElements[element].pageNo,
              rollingXcoord: formElements[element].rollingXcoord,
              rollingYcoord: formElements[element].rollingYcoord,
              validation: {
                type: 'text',
                required: formElements[element].required || 0,
                validationIssue: formElements[element].validationIssue
              },
              chartable: isQuestionChartable(formElements[element])
            };
            if (formElements[element].isAnswerListNeeded && formElements[element].propertyDictionary.answerListId) {
              columnObj.requiresCustomList = true;
              columnObj.customListId = formElements[element].propertyDictionary.answerListId;
            }
            configureMultipleChoiceIfNecessary(formElements[element], columnObj, answersArrayObj, element);

            if (columnObj.chartable) {
              arrayOfChartableColumns.push(columnObj);
            }
            if (columnObj.databasefieldname === 'bureaustatus') columnObj.editable = false;
            if (columnObj.type == 'ChoiceView' || columnObj.type === 'Tableview') {
              columnObj.cellFilter = 'gridButton'; // switch to grid-button filter for view template so we can _.escape() potentially dodgy answer values.
            }
            if (columnObj.type === 'Drawing') {
              columnObj.cellFilter = 'gridButton';
              columnObj.editable = false;
            }

            arrayOfGridColumns.push(columnObj);
          }
          // if the element type is an answer, build an answers obj and assign it to it's parent (question)
          if (formElements[element].elementType == 'Answer') {
            const answerObj = {
              displayValue: formElements[element].reportingLabel || formElements[element].captions.English || formElements[element].elementData,
              keyValue: formElements[element].elementData || formElements[element].captions.English,
              points: assignPointsToAnswer(formElements[element]),
              showMoreInfoTextfield: formElements[element].showMoreInfoTextfield,
              moreInfo: '',
              selected: false
            };
            answerObj.displayValue = answerObj.displayValue.trim();
            answerObj.keyValue = answerObj.keyValue.trim();
            if (answersArrayObj[formElements[element].parentViewTag]) {
              answersArrayObj[formElements[element].parentViewTag].push(answerObj);
            } else {
              answersArrayObj[formElements[element].parentViewTag] = [answerObj];
            }
          }
        }
      } // end of form elements loop

      factoryData.columnsData.items = arrayOfGridColumns;
      factoryData.arrayOfChartableColumns = _.chain(arrayOfChartableColumns)
        .sortBy('rollingXcoord')
        .sortBy('rollingYcoord')
        .sortBy('pageNo')
        .sortBy('hiddenInForm')
        .sortBy('object').value();
    }

    function assignPointsToAnswer(element) {
      if (!_.isEmpty(element.propertyDictionary)) {
        return element.propertyDictionary.capturePoints;
      }
    }

    function setCellDefaultValue(elementType) {
      let defaultCellValue;
      switch (elementType) {
        case 'ChoiceView':
          defaultCellValue = undefined;
          break;

        case 'Tableview':
          defaultCellValue = undefined;
          break;

        case 'Lookup':
          defaultCellValue = undefined;
          break;

        case 'Textfield':
          defaultCellValue = undefined;
          break;

        default:
          defaultCellValue = undefined;
      }
      return defaultCellValue;
    }

    function orderColumns() {

      const defaultColsOrder = [
        'response_integrationState',
        'response__images',
        'contact_barcode',
        'company_name',
        'contact_salutation',
        'contact_firstname',
        'contact_lastname',
        'contact_jobtitle',
        'contact_email',
        'contact_phone',
        'contact_mobile',
        'contact_address1',
        'contact_address2',
        'contact_address3',
        'contact_city',
        'contact_state',
        'contact_zipcode',
        'contact_country',
        'contact_contactmethods',
        'response_latestDetailedReleaseAttempt'
      ];

      const sortObj = defaultColsOrder.reduce(function (acc, value, index) {
        acc[value] = index;
        return acc;
      }, {});

      // underscore chain method allows you to chain multiple functions together.
      // here we chain a bunch of sortBy's which gradually makes the sort more important.
      // handy SO post: http://bit.ly/2lr64la
      factoryData.columnsData.items =
        _.chain(factoryData.columnsData.items)
          .sortBy('rollingXcoord')
          .sortBy('rollingYcoord')
          .sortBy('pageNo')
          // .sortBy('hiddenInForm') // removed because Eaton need their fields to remain as they appear in the form. Maybe put these in as an option one day
          // .sortBy('object')
          .sortBy(function (col) {
            return sortObj[col.object + '_' + col.databasefieldname];
          })
          .value();

    }

    function isQuestionChartable(element) {
      return element.elementType != 'Textview' && element.elementType != 'Textfield' && element.elementType != 'Drawing';
    }

    function configureMultipleChoiceIfNecessary(element, columnObj, answersArrayObj, elementId) {
      if (element.elementType === 'ChoiceView' || element.elementType === 'Tableview' || element.elementType === 'Grid' || element.elementType === 'Lookup') {
        columnObj.answers = prepAnswersObjectForColumn(answersArrayObj, elementId);
        if (element.questionType == 'Multiple Choice Row' ||
          element.questionType == 'Multiple Selection' ||
          (!!element.propertyDictionary && element.propertyDictionary.allowMultipleSelections)) {
          columnObj.allowMultiple = true;
        } else {
          columnObj.allowMultiple = false;
        }
      }
    }

    function prepAnswersObjectForColumn(answersArrayObj, elementId) {
      if (answersArrayObj[elementId]) {
        return answersArrayObj[elementId];
      } else {
        return answersArrayObj[elementId] = [];
      }
    }

  }
})();

/**
 * Created by davidbeazer on 08/02/2017.
 */
(function () {
  'use strict';

  angular
    .module('forms')
    .factory('FormExtraColsFactory', FormExtraColsFactory);

  FormExtraColsFactory.$inject = ['SessionService'];
  /* ng-inject */
  function FormExtraColsFactory(SessionService) {

    return {
      addExtraCols: addExtraCols,
      addDeleteDateCol: addDeleteDateCol,
      removeDeleteDateCol: removeDeleteDateCol
    };

    function addExtraCols(arrayOfGridColumns, formProperties) {
      return new Promise(function (resolve){

        const _id = {
          databasefieldname: '_id',
          label: 'ID',
          object: 'response',
          type: 'Textfield',
          editable: false,
          showCol: true,
          // cellFilter: 'gridButton',
          sortOn: 'rawValue',
          cellDefaultValue: '',
        };
        arrayOfGridColumns.unshift(_id);

        const imagesCol = {
          databasefieldname: '_images',
          label: 'Images',
          object: 'response',
          type: 'Image',
          editable: false,
          showCol: true,
          cellFilter: 'gridButton',
          sortOn: 'arrayLength'
        };
        arrayOfGridColumns.unshift(imagesCol);

        const validationCol = {
          databasefieldname: '_leadIsValid',
          label: 'Lead Validation',
          object: 'response',
          type: '_validation',
          editable: false,
          showCol: true,
          cellFilter: 'gridButton',
          sortOn: 'rawValue',
          cellDefaultValue: '',
        };
        arrayOfGridColumns.unshift(validationCol);

        const _bureauuseremail = {
          databasefieldname: '_bureauuseremail',
          label: 'Bizcard processed by',
          object: 'response',
          type: 'Textfield',
          editable: false,
          showCol: true,
          cellDefaultValue: '',
          // cellFilter: 'rawValue',
          sortOn: 'rawValue'
        };
        arrayOfGridColumns.push(_bureauuseremail);

        const notesCol = {
          databasefieldname: 'notes',
          label: 'Notes',
          object: 'response',
          type: 'Textview',
          editable: true,
          showCol: true,
          sortOn: 'rawValue',
          cellDefaultValue: '',
          validation: {
            required: formProperties.notesRequired
          }
        };
        arrayOfGridColumns.push(notesCol);

        const createDateCol = {
          databasefieldname: '_initialcreatedatelocalutc',
          label: 'Create Date/Time',
          object: 'response',
          type: 'Textfield',
          editable: false,
          showCol: true,
          sortOn: 'rawValue',
          cellDefaultValue: '',
          cellFilter: 'zpDateOffset'
        };
        arrayOfGridColumns.push(createDateCol);

        const initialUserCol = {
          databasefieldname: '_initialuser',
          label: 'Created by user name',
          object: 'response',
          type: 'Textfield',
          editable: false,
          showCol: true,
          sortOn: 'rawValue',
          cellDefaultValue: ''
        };
        arrayOfGridColumns.push(initialUserCol);

        const initialUserEmailCol = {
          databasefieldname: '_initialuseremail',
          label: 'Created by user email',
          object: 'response',
          type: 'Textfield',
          editable: false,
          showCol: true,
          cellFilter: 'lowercase',
          sortOn: 'rawValue',
          cellDefaultValue: ''
        };
        arrayOfGridColumns.push(initialUserEmailCol);

        const lastModifiedDateCol = {
          databasefieldname: '_lastmodifieddatelocalutc',
          label: 'Last modified Date/Time',
          object: 'response',
          type: 'Textfield',
          editable: false,
          showCol: true,
          sortOn: 'rawValue',
          cellDefaultValue: '',
          cellFilter: 'zpDateOffset'
        };
        arrayOfGridColumns.push(lastModifiedDateCol);

        const lastModifiedEmailCol = {
          databasefieldname: '_useremail',
          label: 'Last modified user email',
          object: 'response',
          type: 'Textfield',
          editable: false,
          showCol: true,
          cellFilter: 'lowercase',
          sortOn: 'rawValue',
          cellDefaultValue: ''
        };
        arrayOfGridColumns.push(lastModifiedEmailCol);

        const literatureCol = {
          databasefieldname: '_literature',
          label: 'Literature',
          object: 'response',
          type: 'Literature',
          editable: true,
          showCol: true,
          cellFilter: 'gridButton',
          sortOn: 'arrayLength',
          cellDefaultValue: 0
        };
        arrayOfGridColumns.push(literatureCol);

        const emailSentCol = {
          databasefieldname: 'thankYouEmailSent',
          label: 'Thank you email sent',
          object: 'response',
          type: 'Textfield',
          editable: false,
          showCol: true,
          cellFilter: 'zpDateOffset',
          sortOn: 'rawValue',
          cellDefaultValue: ''
        };
        arrayOfGridColumns.push(emailSentCol);

        const templatesSentCol = {
          databasefieldname: 'templatesSentForForm',
          label: 'Templates sent',
          object: 'response',
          type: 'TemplatesSent',
          editable: true,
          showCol: true,
          cellFilter: 'gridButton',
          sortOn: 'arrayLength',
          cellDefaultValue: 0
        };
        arrayOfGridColumns.push(templatesSentCol);

        const emailEventsCol = {
          databasefieldname: 'emailEvents',
          label: 'Email activity',
          object: 'response',
          type: 'EmailEvents',
          editable: true,
          showCol: true,
          cellFilter: 'gridButton',
          sortOn: 'arrayLength',
          cellDefaultValue: 0
        };
        arrayOfGridColumns.push(emailEventsCol);

        if (SessionService.getUserData().gdprEnabled) {
          const consentCol = {
            databasefieldname: '_grantedConsents',
            label: 'Granted consents',
            object: 'contact',
            type: 'Consent',
            editable: true,
            showCol: true,
            readOnly: true,
            sortOn: 'rawValue',
            cellFilter: 'gridButton',
            cellDefaultValue: '',
            allowMultiple: true,
            validation: {
              required: false
            }
          };
          arrayOfGridColumns.push(consentCol);

          const privacyCol = {
            databasefieldname: '_readPrivacyStatements',
            label: 'Read Privacy Statements',
            object: 'contact',
            type: 'Privacy',
            editable: true,
            showCol: true,
            readOnly: true,
            sortOn: 'rawValue',
            cellFilter: 'gridButton',
            cellDefaultValue: '',
            allowMultiple: true,
            validation: {
              required: false
            }
          };
          arrayOfGridColumns.push(privacyCol);
        }

        const messageComposerCol = {
          databasefieldname: '_messageComposerMessages',
          label: 'Email Rep Sent',
          object: 'response',
          type: 'MessageComposer',
          editable: true,
          showCol: true,
          cellFilter: 'gridButton',
          sortOn: 'arrayLength',
          cellDefaultValue: 0
        };
        arrayOfGridColumns.push(messageComposerCol);

        const parkedLeadsCol = {
          databasefieldname: '_parkedlead',
          label: 'Parked Lead',
          object: 'response',
          type: 'Textfield',
          editable: false,
          showCol: false
        };
        arrayOfGridColumns.push(parkedLeadsCol);

        const pointsCol = {
          databasefieldname: 'LeadScore',
          label: 'Lead score',
          object: 'response',
          type: 'Textfield',
          editable: false,
          showCol: true,
          sortOn: 'rawValue',
          cellDefaultValue: 0
        };
        if (formProperties.scoreLead) arrayOfGridColumns.push(pointsCol);

        const statusCol = {
          databasefieldname: '_integrationState',
          label: 'Status',
          object: 'response',
          type: 'IntegrationStatus',
          editable: false,
          showCol: true,
          cellFilter: 'gridButton',
          sortOn: 'arrayLength'
        };
        arrayOfGridColumns.unshift(statusCol);

        const distilledStatusCol = {
          databasefieldname: '_distilledIntegrationState',
          label: 'Status',
          object: 'response',
          type: 'IntegrationStatus',
          editable: false,
          showCol: false,
          cellFilter: 'gridButton',
          sortOn: 'arrayLength'
        };
        arrayOfGridColumns.push(distilledStatusCol);

        if (formProperties.pickAWinnerEnabledForForm) {
          const pickAWinnerCol = {
            databasefieldname: 'prizeDrawStatus',
            label: 'Prize Draw Winner',
            object: 'response',
            type: 'Textfield',
            editable: false,
            showCol: true,
            sortOn: 'rawValue'
          };
          arrayOfGridColumns.push(pickAWinnerCol);
        }

        const latestDetailedReleaseAttemptCol = {
          databasefieldname: '_latestDetailedReleaseAttempt',
          label: 'Latest Release Attempt Message',
          object: 'response',
          type: 'Textfield',
          editable: false,
          showCol: true,
          sortOn: 'rawValue',
          cellFilter: 'zpReleaseNarrative'
        };
        arrayOfGridColumns.push(latestDetailedReleaseAttemptCol);

        return resolve();

      });

    }

    function addDeleteDateCol(arrayOfGridColumns) {
      const deleteDateCol = {
        databasefieldname: '_deletedatelocalutc',
        label: 'Delete date',
        object: 'response',
        type: 'Textfield',
        editable: false,
        showCol: true,
        sortOn: 'rawValue',
        cellFilter: 'zpDateOffset'
      };
      arrayOfGridColumns.push(deleteDateCol);
    }

    function removeDeleteDateCol(arrayOfGridColumns, index) {
      arrayOfGridColumns.splice(index, 1);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('EventsLeadsExportsFactory', Factory);

  Factory.$inject = ['UnparseData', 'DownloadCSV', 'MessageService', 'EventsExportDataFactory'];
  /** @ngInject */
  function Factory(UnparseData, DownloadCSV, MessageService, EventsExportDataFactory) {

    return {
      downloadFormExport: downloadFormExport
    };

    function downloadFormExport(startdate, enddate) {
      return EventsExportDataFactory.getData(startdate, enddate)
        .then(EventsData => {
          prepareAndDownloadCSV(startdate,enddate,EventsData.data);
        });
    }


    //// private helpers

    function prepareAndDownloadCSV(startdate, enddate, rawData) {
      const columnsData = buildColumnsDataObj();
      const exportData = breakoutDataForExport(rawData);
      const csv = UnparseData(columnsData ,exportData);
      const filename = 'Zuant Events Export:' +moment(startdate).format('MM/DD/YYYY') + '-' + moment(enddate).format('MM/DD/YYYY') + '.csv';
      DownloadCSV(filename, csv);

      MessageService.showMessage('Events Overview Export Complete');
      return csv;
    }

    function buildColumnsDataObj(){
      return [['Status'],['Form Name'],['Start Date'], ['End Date'], ['Submitted Lead Count'], ['Parked Lead Count'], ['Total Lead Count']];
    }

    function breakoutDataForExport(rawData){
      const breakoutData = [];
      for (let data of rawData){
        const singlecollection = [];
        Object.keys(data).forEach(key => {
          singlecollection.push(data[key]);
        });
        breakoutData.push(singlecollection);
      }
      return breakoutData;
    }

  }
}());

(function () {
  'use strict';
    
  angular
    .module('forms')
    .factory('EventsExportDataFactory', EventsExportDataFactory);
    
  EventsExportDataFactory.$inject = ['EventsExportAPI'];
  /* ng-inject */
  function EventsExportDataFactory(EventsExportAPI) {
    
    return {
      getData: GetData,
      GetExportStats: GetExportStats
    };
    
    //////////////////////////////////
    
    function GetData(startdate, enddate) {
      const queryObj = {
        fields: {
          _id:1,
          formname:1,
          startdate:1,
          enddate:1,
          published:1,
          _deletedatelocalutc:1
        },
        match: {
          datefield: '_initialcreatedatelocalutc',
          range: {
            $gte: moment(startdate).subtract(1, 'days'),
            $lte: enddate
          }
        }
      };
      return EventsExportAPI.aggregateExportResponses(queryObj)
        .then(function(response){
          return response.data;
        });
    }

    function GetExportStats(){
      const queryObj = {
        fields: {
          _id:1,
          formname:1,
          startdate:1,
          enddate:1,
          published:1,
          _deletedatelocalutc:1
        }
      };
      return EventsExportAPI.aggregateExportResponsesStats(queryObj)
        .then(function(response){
          return response.data.data;
        });
    }
    
  }
})();

(function () {
  'use strict';
  
  angular
    .module('forms')
    .factory('EventsExportAPI', EventsExportAPI);
  
  EventsExportAPI.$inject = ['APIService', 'APIFactory'];
  /* ng-inject */
  function EventsExportAPI(api) {

    return {
      aggregateExportResponses: aggregateExportResponses,
      aggregateExportResponsesStats: aggregateExportResponsesStats
    };
  
    //////////////////////////////////
  
    function aggregateExportResponses(queryObj) {
      return api.post('form/export', queryObj)
        .then(function (res) {
          return res;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function aggregateExportResponsesStats(queryObj) {
      return api.post('form/export-stats', queryObj)
        .then(function (res) {
          return res;
        })
        .catch(function (err) {
          throw (err);
        });
    }
  
  }
})();
  
(function () {
  'use strict';
  
  angular
    .module('forms')
    .factory('DataLoadsFactory', dataLoadsFactory);
  
  dataLoadsFactory.$inject = ['DataAPI', 'ValidationHelperFactory', 'SessionService'];
  /* ng-inject */
  function dataLoadsFactory(DataAPI, ValidationHelperFactory, SessionService) {
  
    const factoryData = {
      items: [],
      itemsObject: {},
      dataCache: {
        valid: false,
        lastServerTripTimestamp: null,
        clientId: null
      }
    };
  
    return {
      factoryData: factoryData,
      getDataLoads: getDataLoads
    };
    
    //////////////////////////
  
    function getDataLoads(){
      if (ValidationHelperFactory.dataCacheIsStillValid(factoryData.dataCache)) {
        hydrateFactoryWithDataLoads(factoryData.unprocessedDataloadsArray);
        return new Promise(function (resolve){
          resolve(factoryData);
        });
      }

      return DataAPI.getAllDataLoads()
        .then(function (res) {
          hydrateFactoryWithDataLoads(res.data.data);
          return factoryData;
        });
    }


    function hydrateFactoryWithDataLoads(data) {
      factoryData.items = data;
      factoryData.unprocessedDataloadsArray = angular.copy(data);
    
      const shapedData = shapeDataLoadsForViewModels(factoryData.items);
    
      factoryData.items.length = 0; // empty out factoryData items by setting length to 0 so as to not break pre-existing bindings to components
      shapedData.forEach(function (newItem) {
        factoryData.items.push(newItem);
      });
    
      const dataLoadsObject = _.reduce(shapedData, function (dataloadsObject, v) {
        dataloadsObject[v.dataload._id] = v;
        return dataloadsObject;
      }, {});
      factoryData.itemsObject = dataLoadsObject; // dataloads object is used for fast lookup (keyed off _id)
      
      factoryData.dataCache.valid = true;
      factoryData.dataCache.lastServerTripTimestamp = new Date();
      factoryData.dataCache.clientId = SessionService.getUserData().clientId;
    }
  
    function shapeDataLoadsForViewModels(arrayOfUnprocessedItems) {
      return _.map(arrayOfUnprocessedItems, function (item) {
        return {
          dataload: {
            _id: item._id,
            zubotName: item.zubotName,
            fileName: item.fileName,
            createdOn: item.createdOn,
            completedOn: item.completedOn,
            totalContacts: item.totalContacts
          }
        };
      });
    }

  }
}());
(function () {
  'use strict';
  
  angular
    .module('forms')
    .factory('DataAPI', dataApi);
  
  dataApi.$inject = ['APIService'];
  /* ng-inject */
  function dataApi(APIService) {
    
    return {
      getAllDataLoads: getAllDataLoads
    };
    
    //////////////////////////////////

    function getAllDataLoads() {
      return APIService.getFromDataApi('dataloads');
    }

  
  }
})();
  
(function () {
  'use strict';

  angular
    .module('forms')
    .factory('AddValidationColumn', factory);
  factory.$inject = [];
  /* ng-inject */
  function factory() {

    return function (formMetadataFactoryData) {
      if (columnInData(formMetadataFactoryData.columnsData)) return;
      
      return addValidationColumn(formMetadataFactoryData.columnsData);
    };

    function columnInData(columnsData) {
      return columnsData.itemsObject['response__leadIsValid'];
    }

    function addValidationColumn(columnsData) {
      const validationCol = {
        databasefieldname: '_leadIsValid',
        label: 'Lead Validation',
        object: 'response',
        type: '_validation',
        editable: false,
        showCol: true,
        cellFilter: 'gridButton',
        sortOn: 'rawValue',
        cellDefaultValue: '',
      };
      columnsData.items.unshift(validationCol);
      columnsData.itemsObject['response__leadIsValid'] = validationCol;
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('forms')
    .config(moduleConfig)
    .config(chartJsConfig);

  chartJsConfig.$inject = ['ChartJsProvider'];
  /* ng-inject */
  function chartJsConfig(ChartJsProvider) {
    ChartJsProvider.setOptions({
      responsive: true,
      maintainAspectRatio: true,
      chartColors: ['#FEC353', '#78CDD1', '#5B88B5', '#F99D33', '#F26529']
    });
  }

  moduleConfig.$inject = ['$stateProvider'];
  /* ng-inject */
  function moduleConfig($stateProvider) {

    $stateProvider
      .state('app.homescreen_app_framework.forms_home', {
        url: '/events/home',
        title: 'Events',
        views: {
          'toolbarSection': {
            template: '<zp-forms-search-toolbar></zp-forms-search-toolbar>'
          },
          'spof': {
            template: '<zp-forms-main-page layout="column" flex></zp-forms-main-page>'
          },
          'right-hand-container': {
            template: '<zp-side-chart-forms-home flex></zp-side-chart-forms-home>'
          },
          'fab-container': {
            component: 'zpFormsMainPageFab'
          }
        },
        data: {
          permissions: {
            only: ['FORMS_VIEW']
          }
        },
        resolve: {
          modelData: ['$q', 'LiteratureNamesFactory', 'FormsFactory', 'LeadDataFactory', 'FormMetadataFactory', 'ToolbarFactory', 'SendThankYouEmailIntegrityCheck',
            function (promise, litfactory, formsfactory, griddata, formmetadata, toolbarfactory, tyeintegritycheck) {
              return new promise(function (resolve, reject) {
                griddata.clearFactoryData();
                formmetadata.clearFactoryData();
                toolbarfactory.set({
                  title: 'Forms',
                  navigationPath: '',
                  showBackButton: false,
                  customStateParams: {
                    isDirtyCheck: true
                  }
                });
                return tyeintegritycheck.runCheckOnAccount()
                  .then(function () {
                    resolve(formsfactory.getAllForms());
                  })
                  .catch(reject);
              });
            }
          ]
        }
      })
      // STATES WITHIN A FORM
      .state('app.tabbed_app_framework.single_form', {
        abstract: true,
        url: '/events/:_id',
        views: {
          'tab-navbar': {
            component: 'zpTabNavbar',
            bindings: {
              stateParams: 'stateParams'
            }
          },
          'spof': {
            template: '<div ui-view="spof" flex></div>'
          },
          'right-hand-container': {
            template: '<div ui-view="right-hand-container"></div>'
          },
          'fab-container': {
            template: '<div ui-view="fab-container"></div>'
          }
        },
        data: {
          name: 'settings',
          permissions: {
            only: ['LEADS_DASHBOARD']
          }
        },
        resolve: {
          factory: ['$q', 'EncodingService', '$transition$', 'ColumnSummaryMetadataFactory', 'HeadlinesMetadataFactory', 'ResponseAggregationModel', 'ResponseAggregationModelPresets', 'TimeReportsMetadataFactory', 'LiteratureNamesFactory', 'ShowroomWidgetsMetadataFactory', 'AllReportWidgetsMetadataCombined', 'ToolbarFactory', 'LayoutsFactory', 'FormMetadataFactory', 'EmailTemplatesFactory',
            function (promise, encoder, $transition$, columnsummarymetadatafactory, headlinesmetadatafactory, responseaggregationmodel, responseaggregationmodelpresets, timereportsmetadata, literaturenamesfactory, showroomwidgetsmetadatafactory, allreportwidgetsmetadatacombined, toolbarfactory, layouts, formmetadatafactory, emailtemplatesfactory) {
              const formId = encoder.decode($transition$.params()._id);
              return new promise(function (resolve, reject) {
                responseaggregationmodel.resetFactory();
                showroomwidgetsmetadatafactory.resetFactory();
                return formmetadatafactory.buildGridColumns(formId)
                  .then(function (res) {
                    toolbarfactory.set({
                      title: res.formProperties.formname,
                      navigationPath: 'app.homescreen_app_framework.forms_home',
                      showBackButton: true,
                      customStateParams: {
                        isDirtyCheck: true
                      }
                    });
                    return literaturenamesfactory.getAllLiteratureDocs();
                  })
                  .then(function () {
                    return literaturenamesfactory.getAllTagDocs();
                  })
                  .then(function () {
                    headlinesmetadatafactory.resetFactory();
                    timereportsmetadata.resetFactory();
                    showroomwidgetsmetadatafactory.buildShowroomWidgets();
                    return columnsummarymetadatafactory.buildColumnSummaryWidgets(formId);
                  })
                  .then(function () {
                    responseaggregationmodelpresets.resetFactory();
                    allreportwidgetsmetadatacombined.hydrateFactoryAndMergePresetsWithSavedModel(formId);
                    return emailtemplatesfactory.init();
                  })
                  .then(function () {
                    return responseaggregationmodel.init(formId); // downstream from here the leads for the form are fetched. TOO BURIED!
                  })
                  .then(function () {
                    layouts.setProperty('rightHandContainerWidth', '0');
                    return resolve();
                  })
                  .catch(reject);
              });
            }
          ],
          stateParams: ['$transition$', 'EncodingService', function (transition, encoder) {
            return {
              _id: encoder.decode(transition.params()._id),
              transitionTo: transition.to(),
              items: [{
                state: 'app.tabbed_app_framework.single_form.dashboard',
                name: 'dashboard',
                label: 'Dashboard'
              }, {
                state: 'app.tabbed_app_framework.single_form.grid',
                name: 'grid',
                label: 'Lead Grid'
              }, {
                state: 'app.tabbed_app_framework.single_form.lead_release',
                name: 'leadrelease',
                label: 'Lead Release'
              }, {
                state: 'app.tabbed_app_framework.single_form.settings',
                name: 'settings',
                label: 'Settings'
              }]
            };
          }]
        }
      })

      .state('app.tabbed_app_framework.single_form.dashboard', {
        url: '/dashboard',
        title: 'Event Dashboard',
        views: {
          'spof': {
            component: 'zpReportingPage'
          },
          'right-hand-container': {
            component: 'zpPdfBuilderSidebar',
            bindings: {
              formid: 'stateParams._id'
            }
          },
          'fab-container': {
            component: 'zpPrintReportFab'
          }
        },
        data: {
          name: 'dashboard',
          permissions: {
            only: ['LEADS_DASHBOARD']
          }
        },
        resolve: {
          stateParams: ['$transition$', 'EncodingService', function (transition, encoder) {
            return {
              _id: encoder.decode(transition.params()._id)
            };
          }],
          factory: ['$q', '$transition$', 'ResponseAggregationModel', 'EncodingService', function (promise, transition, responseaggregationmodel, encoder) {
            const formId = encoder.decode(transition.params()._id);
            return new promise(function (resolve, reject) {
              return responseaggregationmodel.init(formId)
                .then(function () {
                  return resolve();
                })
                .catch(function (err) {
                  return reject(err);
                });
            });
          }]
        }
      })

      .state('app.tabbed_app_framework.single_form.grid', {
        url: '/grid',
        title: 'Lead Grid',
        views: {
          'spof': {
            component: 'zpLeadGridPage'
          }
        },
        data: {
          name: 'grid',
          permissions: {
            only: ['LEADS_VIEWGRID']
          }
        }
      })

      .state('app.single_view_framework.full_screen_grid', {
        url: '/grid/parked-leads/:_id',
        title: 'Parked Leads Grid',
        views: {
          'spof': {
            template: '<zp-parked-lead-grid flex layout="column"></zp-parked-lead-grid>'
          }
        },
        data: {
          permissions: {
            only: ['LEADS_EDITGRID']
          }
        },
        resolve: {
          gridData: ['$q', 'LeadDataFactory', 'FormMetadataFactory', '$transition$', 'EncodingService', 'AddValidationColumn', function ($q, leaddatafactory, formmetadatafactory, trans, encoder, addvalidationcolumn) {
            const options = {
                useLocalCache: true,
                skip: 0,
                collection: 'contacts',
                sort: {
                  lastname: 1
                }
              },
              formId = encoder.decode(trans.params()._id);

            return $q(function q(resolve, reject) {
              return formmetadatafactory.buildGridColumns(formId)
                .then(function (factoryData) {
                  addvalidationcolumn(factoryData);
                  return leaddatafactory.getGridDataForForm(formId, options);
                })
                .then(function () {
                  resolve();
                })
                .catch(function (err) {
                  reject(err);
                });
            });
          }]
        }
      })

      .state('app.tabbed_app_framework.single_form.lead_release', {
        url: '/grid/lead-release',
        title: 'Lead Release Grid',
        views: {
          'spof': {
            // template: '<zp-lead-release-grid flex layout="column" count-of-machines-running-for-form="$resolve.resolveObj.countOfMachinesRunningForForm"></zp-lead-release-grid>'
            component: 'zpLeadReleaseGrid',
            bindings: {
              countOfMachinesRunningForForm: 'resolveObj.countOfMachinesRunningForForm',
              metadata: 'resolveObj.metadata'
            }
          }
        },
        data: {
          name: 'leadrelease',
          permissions: {
            only: ['INTEGRATION_LEAD_RELEASE_EDIT', 'INTEGRATION_LEAD_RELEASE_RELEASE', 'TRUMP']
          }
        },
        resolve: {
          resolveObj: ['LeadReleaseRouteResolve', '$transition$', function (LeadReleaseRouteResolve, transitionObj) {
            return LeadReleaseRouteResolve(transitionObj)
              .then(function (res) {
                return res;
              })
              .catch(function (err) {
                throw err;
              });
          }]
        }
      })

      .state('app.tabbed_app_framework.single_form.settings', {
        url: '/settings',
        title: 'Form Settings',
        views: {
          'spof': {
            component: 'zpSettingsPage',
            bindings: {
              machinesThatWillRunForThisForm: 'resolveObj.machinesThatWillRunForThisForm',
              formId: 'resolveObj.formId',
              formProperties: 'resolveObj.formProperties'
            }
          },
          'fab-container': {
            component: 'zpSaveSettingsFab'
          }
        },
        data: {
          name: 'settings',
          permissions: {
            only: ['FORMS_EDIT']
          }
        },
        resolve: {
          init: ['UserPermissionsHelperFactory', function (UserPermissionsHelperFactory){
            return UserPermissionsHelperFactory.init();
          }],
          resolveObj: ['MachinesSetToRunForForm', '$transition$', 'EncodingService', 'FormMetadataFactory', 'EmailTemplatesFactory', function (factory, transition, encoder, FormMetadataFactory, EmailTemplatesFactory) {
            const formId = encoder.decode(transition.params()._id);
            const returnObj = {
              formId: formId,
              machinesThatWillRunForThisForm: [],
              formProperties: {}
            };
            return FormMetadataFactory.buildGridColumns(formId)
              .then(function (props) {
                returnObj.formProperties = props.formProperties;
                return factory(formId);
              })
              .then(function (namesOfMachinesToRunForThisForm) {
                returnObj.machinesThatWillRunForThisForm = namesOfMachinesToRunForThisForm;
                return EmailTemplatesFactory.init();
              })
              .then(function () {
                return returnObj;
              })
              .catch(function (err) {
                throw err;
              });
          }]
        }
      })

      .state('app.single_view_framework.pdf_download', {
        url: '/events/printable-page/:_id',
        title: 'Printable Reports',
        views: {
          'spof': {
            component: 'zpPrintablePage',
            bindings: {
              formid: 'factory.formid',
              userData: 'userData',
              clientDoc: 'clientDoc'
            }
          }
        },
        data: {
          // permissions: {
          //   only: ['LEADS_DOWNLOAD']
          // }
        },
        resolve: {
          userData: ['SessionService',
            function (SessionService) {
              return  SessionService.getUserData();
            }
          ],
          clientDoc: ['userData', 'CurrentClientModelFactory',
            function (userData, CurrentClientModelFactory) {
              return CurrentClientModelFactory.getClientById(userData.clientId)
                .then(function (resp) {
                  return resp;
                });
            }
          ], 
          factory: ['$q', 'EncodingService', '$transition$', 'FormMetadataFactory', 'ColumnSummaryMetadataFactory', 'HeadlinesMetadataFactory', 'ResponseAggregationModel', 'ResponseAggregationModelPresets', 'TimeReportsMetadataFactory', 'LiteratureNamesFactory', 'ShowroomWidgetsMetadataFactory', 'AllReportWidgetsMetadataCombined',
            function (promise, encoder, $transition$, formmetadata, columnsummarymetadatafactory, headlinesmetadatafactory, responseaggregationmodel, responseaggregationmodelpresets, timereportsmetadata, literaturenamesfactory, showroomwidgetsmetadatafactory, allreportwidgetsmetadatacombined) {
              const formid = encoder.decode($transition$.params()._id);
              return new promise(function (resolve, reject) {
                responseaggregationmodel.resetFactory();
                headlinesmetadatafactory.resetFactory();
                timereportsmetadata.resetFactory();
                showroomwidgetsmetadatafactory.resetFactory();
                return formmetadata.buildGridColumns(formid)
                  .then(function () {
                    return literaturenamesfactory.getAllLiteratureDocs();
                  })
                  .then(function () {
                    return literaturenamesfactory.getAllTagDocs();
                  })
                  .then(function () {
                    showroomwidgetsmetadatafactory.buildShowroomWidgets();
                    return columnsummarymetadatafactory.buildColumnSummaryWidgets(formid);
                  })
                  .then(function () {
                    responseaggregationmodelpresets.resetFactory();
                    allreportwidgetsmetadatacombined.hydrateFactoryAndMergePresetsWithSavedModel(formid);
                    return responseaggregationmodel.init(formid);
                  })
                  .then(function () {
                    resolve({
                      formid: formid
                    });
                  })
                  .catch(reject);
              });
            }
          ]
        }
      })

      .state('app.single_view_framework.forms_reporting_dashboard', {
        url: '/events/reporting/:navigationArray/:_id/:columnid/:chartcolumnid/:chartdatasetid',
        title: 'Event Reporting',
        views: {
          'spof': {
            template: '<zp-question-reporting-dashboard layout="column" flex widget-data="$resolve.data.widgetData" metadata="$resolve.data.metadata" nav-info="$resolve.data.navInfo" form-id="$resolve.data._id" filter="$resolve.data.filter"></zp-question-reporting-dashboard>'
          }
        },
        data: {
          permissions: {
            only: ['LEADS_DASHBOARD']
          }
        },
        resolve: {
          data: ['$q', 'EncodingService', '$transition$', 'FormMetadataFactory', 'ResponseAggregationModel', 'ResponseAggregationModelPresets', 'ReportModel', 'ColumnSummaryMetadataFactory', 'TimeReportsMetadataFactory', 'ShowroomWidgetsMetadataFactory', 'EmailPerformanceWidgetsMetadataFactory', 'EmailHeadlinesMetadataFactory', 'LiteratureNamesFactory', 'EmailTemplatesFactory',
            function (promise, encoder, $transition$, metadatafactory, responseaggregationmodel, responseaggregationmodelpresets, reportmodel, ColumnSummaryMetadataFactory, timereportsmetadata, showroomwidgetsmetadatafactory, EmailPerformanceWidgetsMetadataFactory, EmailHeadlinesMetadataFactory, literaturenamesfactory, emailtemplatesfactory) {
              const resolveObj = {
                widgetData: {},
                metadata: {},
                navInfo: {
                  prev: null,
                  next: null
                },
                _id: encoder.decode($transition$.params()._id)
              };
              const _index = $transition$.params().chartcolumnid;
              const _datasetIndex = $transition$.params().chartdatasetid;
              if (!_index) {
                resolveObj.filter = {
                  _index: undefined,
                  _datasetIndex: undefined
                };
              } else {
                resolveObj.filter = {
                  _index: parseInt(_index),
                  _datasetIndex: parseInt(_datasetIndex)
                };
              }
              const formId = encoder.decode($transition$.params()._id);
              const columnId = encoder.decode($transition$.params().columnid);
              const navigationArray = $transition$.params().navigationArray;

              return new promise(function (resolve, reject) {
                return metadatafactory.buildGridColumns(formId)
                  .then(function (metadataFactoryData) {
                    resolveObj.metadata = metadataFactoryData;
                    return ColumnSummaryMetadataFactory.buildColumnSummaryWidgets(formId);
                  })
                  .then(function (resp) {
                    // central to reporting. current entry point to kick off calculating chart data for questions in a form
                    resolveObj.widgetData = resp.columnWidgetItemsObject[formId];
                    responseaggregationmodelpresets.resetFactory();
                    responseaggregationmodel.resetFactory();
                    return literaturenamesfactory.getAllLiteratureDocs();
                  })
                  .then(function () {
                    return literaturenamesfactory.getAllTagDocs();
                  })
                  .then(function () {
                    showroomwidgetsmetadatafactory.buildShowroomWidgets();
                    return emailtemplatesfactory.init();
                  })
                  .then(function () {
                    return responseaggregationmodel.init(formId);
                  })
                  .then(function () {
                    const columnSummaryWidgetData = ColumnSummaryMetadataFactory.getData();
                    const timeWidgets = timereportsmetadata.getData();
                    const showroomWidgets = showroomwidgetsmetadatafactory.getData();
                    const emailWidgets = EmailPerformanceWidgetsMetadataFactory.getData();
                    const emailHeadlineWidgets = EmailHeadlinesMetadataFactory.getData();
                    const allWidgets = columnSummaryWidgetData.items.concat(timeWidgets.items).concat(showroomWidgets.items).concat(emailWidgets.items).concat(emailHeadlineWidgets.items);
                    const allWidgetsObject = _.extend({}, columnSummaryWidgetData.itemsObject, timeWidgets.itemsObject, showroomWidgets.itemsObject);

                    if (navigationArray == 'reportArray') {
                      resolveObj.navInfo.arrayToNav = 'reportArray';
                      const report = reportmodel.getData(formId);
                      let reportItemsArray = [];
                      _.each(report.categories, function (category) {
                        reportItemsArray = reportItemsArray.concat(category.items);
                      });
                      if (columnId === 'null') {
                        resolveObj.widgetData = allWidgetsObject[reportItemsArray[0].id];
                        if (reportItemsArray[1]) {
                          resolveObj.navInfo.next = allWidgetsObject[reportItemsArray[1].id];
                        }
                      } else {
                        _.find(reportItemsArray, function (obj, i) {
                          if (obj.id == columnId) {
                            if (i != 0) resolveObj.navInfo.prev = allWidgetsObject[reportItemsArray[i - 1].id];
                            if (i != (reportItemsArray.length - 1)) resolveObj.navInfo.next = allWidgetsObject[reportItemsArray[i + 1].id];
                            resolveObj.widgetData = allWidgetsObject[obj.id];
                            return;
                          }
                        });
                      }
                    } else if (navigationArray == 'widgetsArray') {
                      resolveObj.navInfo.arrayToNav = 'widgetsArray';
                      resolveObj.widgetData = _.find(allWidgets, function (obj, i) {
                        if (obj.id == columnId) {
                          if (i != 0) resolveObj.navInfo.prev = allWidgets[i - 1];
                          if (i != (allWidgets - 1)) resolveObj.navInfo.next = allWidgets[i + 1];
                          return obj;
                        }
                      });
                    }
                    resolve(resolveObj);
                  })
                  .catch(function (err) {
                    reject(err);
                  });
              });
            }
          ]
        }
      });

  }
})();

/**
 * Created by davidbeazer on 10/10/2016.
 */
(function () {
  'use strict';

  angular
    .module('email')
    .factory('EmailMainMetadata', EmailMainMetadata);

  EmailMainMetadata.$inject = ['localStorageService'];

  function EmailMainMetadata(localStorage) {
    var factoryData = {};
    buildFactory();

    return {
      getData: getData
    };

    function getData() {
      return factoryData;
    }

    // PRIVATE

    function buildFactory() {

      factoryData = {
        id: 'email_templates',
        title: {
          label: 'Email templates',
          filterLabel: 'Search templates'
        },
        columnsData: buildColumnsData(),
        query: {
          order: {
            id: 'emailtemplate._lastmodifiedonservertime',
            expression: '-emailtemplate._lastmodifiedonservertime.raw'
          },
          limit: localStorage.get('email_templates') || 20,
          page: 1
        },
        paginationOptions: {
          boundaryLinks: true,
          limitSelect: true,
          pageSelect: true,
          pagination: true,
          limitOptions: [5, 10, 20, 50, 75, 100],
          limit: localStorage.get('email_templates') || 20,
          page: 1
        },
        gridOptions: {
          rowSelection: false,
          multiSelect: false,
          sortable: true,
          interactive: false
        },
        fabDialogConfig: {
          description: 'New email template',
          controller: 'AddTemplateDialogController as vm',
          templateUrl: 'app/email/main/add-template-dialog.tmpl.html',
          locals: {},
          ariaLabel: 'Create new email template'
        },
        menuOptions: [{
          onClick: 'toggleShowArchived',
          ariaLabel: function () {
            return 'Toggle Archived Templates';
          },
          icon: function () {
            return localStorage.get('hideArchivedTemplates') ? 'zmdi zmdi-eye' : 'zmdi zmdi-eye-off';
          },
          label: function () {
            return localStorage.get('hideArchivedTemplates') ? 'Show Archived Templates' : 'Hide Archived Templates';
          }
        }]
      };
    }

    function buildColumnsData() {
      return {
        primaryIdentifier: {
          object: 'emailtemplate',
          field: '_id'
        },
        items: [{
          object: 'emailtemplate',
          databasefieldname: 'icn',
          name: 'title',
          label: 'Status',
          type: 'Status',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: '',
          cellFilter: 'gridButton'
        }, {
          object: 'emailtemplate',
          databasefieldname: 'title',
          name: 'title',
          label: 'Title',
          type: 'Textfield',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: ''
        }, {
          object: 'emailtemplate',
          databasefieldname: 'formsusedcount',
          name: 'items',
          label: 'Forms using',
          type: 'Textfield',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: 0
        }, {
          object: 'emailtemplate',
          databasefieldname: '_lastmodifiedonservertime',
          name: 'Modified date',
          label: 'Last modified',
          type: 'Textfield',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: '',
          cellFilter: 'zpDateMedium'
        }]
      };
    }
  }
})();

/**
 * Created by davidbeazer on 21/11/2016.
 */
'use strict';

angular
  .module('email')
  .controller('AddTemplateDialogController', AddTemplateDialogController);

AddTemplateDialogController.$inject = ['$scope', 'EmailTemplatesFactory', 'MessageService', 'uuidService', 'hotkeys', '$state'];
/* ng-inject */
function AddTemplateDialogController($scope, EmailTemplatesFactory, MessageService, uuid, hotkeys, $state) {

  var vm = this;
  vm.emailTemplates = [];

  vm.$onInit = function (){
    initialiseNewEmailTemplateObject();
    bindhotkeys();
    vm.emailTemplates = _.chain(EmailTemplatesFactory.getData().itemsObject)
      .map(function (item) {
        return {
          _id: item.emailtemplate._id,
          title: item.emailtemplate.title,
          icn: item.emailtemplate.icn
        };
      })
      .sortBy('icn')
      .reverse()
      .value();
  };

  function initialiseNewEmailTemplateObject() {
    const newId = uuid.getSingleNewBase64Key();
    vm.templateDoc = {
      _id: newId,
      title: '',
      emailtemplatesubject: '',
      emailtemplatetext: '',
      published: 0,
      archived: 0
    };
    vm.templateSource = 'new';
  }

  function bindhotkeys() {
    hotkeys.bindTo($scope)
      .add({
        combo: 'enter',
        description: 'Save',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function () {
          vm.submit();
        }
      });
  }

  vm.emailTemplateConfig = {
    placeholder: 'Pick an email template for this form',
    floatingLabel: 'Email template',
    required: true
  };

  vm.setCloneTemplateId = function (selected) {
    if (!selected.item){
      vm.templateDoc._cloneSourceTemplateId = '';
      return;
    }

    vm.templateDoc._cloneSourceTemplateId = selected.item._id;
  };

  vm.templateTitleChanged = function() {
    if (!vm.templateDoc.title) {
      vm.emailTemplateForm.title.$setValidity('templateTitleExists', false);
      return;
    }

    for (const templateItm of vm.emailTemplates) {
      if (templateItm.title.toLowerCase() === vm.templateDoc.title.toLowerCase()) {
        vm.emailTemplateForm.title.$setValidity('templateTitleExists', false);
        return;
      }
    }

    vm.emailTemplateForm.title.$setValidity('templateTitleExists', true);

  };

  vm.submit = function () {
    if (vm.templateSource === 'new'){
      delete vm.templateDoc._cloneSourceTemplateId;
    } else {
      vm.templateDoc.emailtemplatesubject = '';
    }

    vm.submitBtnDisabled = true;
    EmailTemplatesFactory.createNewTemplate(vm.templateDoc)
      .then(function () {
        MessageService.showMessage('Template added');
        MessageService.pushEventToIntercom('created-email-template', {
          _id: vm.templateDoc._id,
          title: vm.templateDoc.title
        });
        vm.submitBtnDisabled = false;
        $state.go('app.tabbed_app_framework.email_edit.settings', {
          _id: vm.templateDoc._id
        });
        vm.hide();
      })
      .catch(function (err) {
        MessageService.showMessage(err.data.data.message);
        MessageService.writeLog({
          level: 'error',
          msg: err
        });

      });
  };

  // modal dismiss functions
  vm.hide = function () {
    MessageService.closeDialog();
  };

  vm.cancelDialog = function () {
    MessageService.cancelDialog();
  };


}

/**
   * Created by davidbeazer on 21/11/2016.
   */
(function () {
  'use strict';
  angular
    .module('email')
    .factory('CurrentTemplateFactory', CurrentTemplateFactory);

  CurrentTemplateFactory.$inject = ['EmailAPI', 'ZPModel', 'EmailTemplatesFactory', 'MessageService', 'ChangeDelta'];
  /* ng-inject */
  function CurrentTemplateFactory(EmailAPI, ZPModel, EmailTemplatesFactory, MessageService, ChangeDelta) {

    var storedModel;
    var currentTemplate = {};

    /* this factory inherits from ZPModel */
    var services = Object.create(ZPModel);

    services.getTemplateById = getTemplateById;
    services.getCurrentTemplateCache = getData;
    services.deleteTemplate = deleteTemplate;
    services.postData = postData;
    services.sendTestEmail = sendTestEmail;
    services.isStale = isStale;
    services.toggleEmailTemplateForForm = toggleEmailTemplateForForm;
    services.getFormsUsedCountForTemplate = getFormsUsedCountForTemplate;

    return services;

    //////////////////////////////

    function getTemplateById(_id) {
      storedModel = {};
      currentTemplate = {};
      var self = this;
      return EmailAPI.getTemplateById(_id)
        .then(function (response) {
          currentTemplate = response.data.data;
          if (typeof response.data.data._deletedatelocalutc !== 'undefined') {
            currentTemplate.archived = 1;
          }
          storedModel = self.cleanObject(angular.copy(currentTemplate));
          EmailTemplatesFactory.invalidateCache();
          return currentTemplate;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function getData() {
      return currentTemplate;
    }

    function deleteTemplate(id) {
      return EmailAPI.deleteTemplate(id)
        .then(function () {
          ChangeDelta.clear();
          MessageService.showMessage('Template deleted');
          EmailTemplatesFactory.invalidateCache();
          return;
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    }

    function postData() {
      var self = this;
      // return preSaveChecks(ev)
      //   .then(function () {
      var saveObj = angular.copy(currentTemplate);
      saveObj.emailtemplatetext = saveObj.emailtemplatetext.replace(/(\r\n|\n|\r|\t)/gm, '').replace('<html style="overflow-y: hidden;">', '<html>');
      return EmailAPI.postTemplateData(saveObj)
        .then(function (response) {
          if (response.status == 200) {
            storedModel = self.cleanObject(angular.copy(currentTemplate));
            if (response.data.data._id) {
              return response.data.data._id;
            }
            MessageService.showMessage('Changes saved');
            ChangeDelta.clear();
            EmailTemplatesFactory.invalidateCache();
            return true;
          }
        })
        .catch(function (err) {
          MessageService.showMessage('Error: ' + err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
      // })
      // .catch(function (err) {
      //   throw ({
      //     saveCancelled: err
      //   });
      // });
    }

    // TODO implement alert user if archiving a form currently linked to a form. Should only alert user if form isn't archived.
    // function preSaveChecks(ev) {
    //   return new Promise(function (resolve, reject) {
    //     if (formDependencyCheck()) {
    //       archiveCheck(resolve, reject, ev);
    //     } else {
    //       resolve();
    //     }
    //   });
    // }
    
    // function formDependencyCheck() {
    //   var numberOfFormsUsingThisTemplate = getFormsUsedCountForTemplate();
    //   return numberOfFormsUsingThisTemplate;
    // }
    
    // function archiveCheck(resolve, reject, ev) {
    //   if (templateIsMarkedForArchiving()) {
    //     promptUser(resolve, reject, ev);
    //   } else {
    //     resolve();
    //   }
    // }
    
    // function templateIsMarkedForArchiving() {
    //   var deltaObj = ChangeDelta.getDeltaObject();
    //   if (!_.isEmpty(deltaObj)) {
    //     if (deltaObj.emailtemplates[currentTemplate._id].archived.newvalue) {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   } else {
    //     return false;
    //   }
    // }
    
    // function promptUser(resolve, reject, ev) {
    //   var dialogConfig = {
    //     controller: 'ConfirmArchiveEmailTemplate as $ctrl',
    //     templateUrl: 'app/email/detail/dialogs/confirm-archive-template.tmpl.html',
    //     clickOutsideToClose: false
    //   };
    //   MessageService.showDialog(ev, dialogConfig)
    //     .then(function () {
    //       resolve();
    //     })
    //     .catch(function () {
    //       reject('save cancelled');
    //     });
    // }

    function isStale(newModel) {
      /* method inherited from ZPModel */
      return !this.equalObjects(storedModel, newModel);
    }

    function sendTestEmail(emailTemplate) {
      return EmailAPI.sendTemplateTestEmail(emailTemplate)
        .then(function (response) {
          return response;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function toggleEmailTemplateForForm(form) {
      // $log.info('toggleEmailTemplateForForm: '+ form._id);
      var updateDoc = {};
      if (form.emailTemplate == currentTemplate._id) {
        // $log.info('removing template from form');
        MessageService.writeLog({
          level: 'info',
          msg: 'removing ' + currentTemplate._id + ' email template from form: ' + form._id,
          tags: ['email_template', 'email_tool']
        });
        form.emailTemplate = '';
        form.emailtemplatetitle = 'None set';
        updateDoc.emailTemplate = '';
      } else {
        // $log.info('adding template to form');
        MessageService.writeLog({
          level: 'info',
          msg: 'Adding ' + currentTemplate._id + ' email template to form: ' + form._id,
          tags: ['email_template', 'email_tool']
        });
        form.emailTemplate = currentTemplate._id;
        form.emailtemplatetitle = currentTemplate.title;
        updateDoc.emailTemplate = currentTemplate._id;
      }
      return EmailAPI.updateEmailTemplateForForm(form._id, updateDoc)
        .then(function (response) {
          if (response.status == 'ok') {
            if (form.emailTemplate !== currentTemplate._id) {
              EmailTemplatesFactory.removeFormIdFromFormsUsedArray(currentTemplate._id, form._id);
            } else {
              EmailTemplatesFactory.addFormIdToFormsUsedArray(currentTemplate._id, form._id);
            }
            return form.emailtemplatetitle;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function getFormsUsedCountForTemplate() {
      return EmailTemplatesFactory.getFormsUsedCountForTemplate(currentTemplate._id);
    }
  }
})();

/**
 * Created by davidfm on 12/03/2018.
 */
/**
  * Provides functionality for the new Data sync and pipelines
  * @module data
  */
(function () {
  angular
    .module('data', [
      'ui.router',
      'ngMaterial',
      'ngAnimate',
      'ui.sortable',
      'common'
    ]);
})();

/**
 * Created by Tom Stone on 8/09/2023.
 */

(function () {
  'use strict';
  angular.module('data')
    .component('zpZubot', zpZubot())
    .controller('ZubotController', ctrl);
  
  function zpZubot() {
    return {
      templateUrl: 'app/data/zubot/zubot.tmpl.html',
      controller: 'ZubotController',
      bindings: {
        height: '@',
        width: '@',
        outfit: '<'
      }
    };
  }
  
  ctrl.$inject = [];
  
  function ctrl() {
    var vm = this;

    vm.$onInit = function() {
      initialiseOutfit();
    };

    vm.$onChanges = function () {
      initialiseOutfit();
    };

    function initialiseOutfit(){
      vm.height = vm.height || '100px';
      vm.width = vm.width || '100px';
  
      if (angular.isUndefined(vm.outfit) || !vm.outfit){
        vm.outfit = {};
      }
  
      vm.outfit = {
        bodyColor: vm.outfit.bodyColor || '#4ecdba',
        bodyBackColor: vm.outfit.bodyBackColor || '#632324',
        verticalsColor: vm.outfit.verticalsColor || '#e6e5dc',
        eyeColor: vm.outfit.eyeColor || '#dbbb2d',
        eyeHighlightsColor: vm.outfit.eyeHighlightsColor || '#e6e5dc',
        zedColor: vm.outfit.logoColor || '#6c2b2b'
      };
    }
    
    return vm;
  }
})();
  
/**
 * Created by davidfm on 13/12/2018.
 */

(function () {
  'use strict';
  angular.module('data')
    .component('zpWorkflowPanel', {
      templateUrl: 'app/data/workflow/workflow-panel.tmpl.html',
      controller: ['workflowFactory', function (workflowFactory) {

        var vm = this;

        vm.workflowFactory = workflowFactory;

        return vm;
      }],
      controllerAs: 'vm',
      bindings: {
      }
    });
})();

/**
 * Created by davidfm on 13/12/2018.
 */

(function () {
  'use strict';
  angular.module('data')
    .component('zpWorkflowConfirmation', zpWorkflowConfirmation())
    .controller('WorkflowConfirmationController', WorkflowConfirmationController);

  function zpWorkflowConfirmation() {
    return {
      templateUrl: 'app/data/workflow/workflow-confirmation.tmpl.html',
      controller: 'WorkflowConfirmationController',
      controllerAs: 'vm',
      bindings: {
      }
    };
  }

  WorkflowConfirmationController.$inject = ['workflowFactory', '$scope', 'setSelectedCard', 'uuidService', 'checkStepIsValid', 'SessionService'];

  function WorkflowConfirmationController(workflowFactory, $scope, setSelectedCard, uuid, checkStepIsValid, SessionService) {
    var vm = this;

    vm.confirmationDb = '';
    vm.workflowFactory = workflowFactory;
    vm.userData = SessionService.getUserData();

    $scope.createCardIfValid = function () {
      if (vm.confirmationDb == vm.userData.databasename) {
        var card = {
          type: vm.workflowFactory.selectedStep.cardType,
          _id: uuid.getSingleNewBase64Key(),
          name: 'CONFIRMED',
          description: 'User has passed confirmation'
        };
        vm.workflowFactory.selectedStep.cards.push(card);
        setSelectedCard(card, vm.workflowFactory.selectedCard);
        vm.confirmationDb = '';
      }

      checkStepIsValid(vm.workflowFactory.selectedStep, vm.workflowFactory.selectedTask);
    };

    return vm;
  }
})();

/**
 * Created by davidfm on 13/03/2018.
 */

(function () {
  'use strict';
  angular.module('data')
    .component('zpMappingSystem', {
      templateUrl: 'app/data/workflow/mapping-system.tmpl.html',
      controller: ['workflowFactory', function (workflowFactory) {

        var vm = this;

        vm.workflowFactory = workflowFactory;
        // vm.$onInit = function () {
        //   workflowFactory.getSystemFields(vm.system).then(function (result) {
        //     vm.systemStructure = result.data.system;
        //   });
        // };

        return vm;
      }],
      bindings: {
        system: '<',
        sortableOptions: '<',
        name: '@'
      }
    });
})();

/**
 * Created by davidfm on 13/03/2018.
 */

(function () {
  'use strict';
  angular.module('data')
    .component('zpCard', {
      templateUrl: 'app/data/workflow/card.tmpl.html',
      controller: ['workflowFactory', function (workflowFactory) {

        var vm = this;

        vm.addCardToHand = function () {
          workflowFactory.addCardToHand(vm.card);
        };

        vm.removeCardFromHand = function () {
          workflowFactory.removeCardFromHand(vm.card);
        };

        vm.openCardSelection = function () {
          workflowFactory.openCardSelection(vm.card);
          if (vm.openCardSelectionCallBack) vm.openCardSelectionCallBack();
        };

        return vm;
      }],
      bindings: {
        card: '<',
        showRemove: '<',
        showAdd: '<',
        openCardSelectionCallBack: '&'
      }
    });
})();

/**
 * Created by davidfm on 27/11/2018.
 */

(function () {
  'use strict';
  angular.module('data')
    .component('subjectReportMain', {
      templateUrl: 'app/data/subject-report/subject-report-main.tmpl.html',
      controller: 'subjectReportMainCtrl',
      bindings: {
        zubotId: '@'
      },
      controllerAs: 'vm'
    })
    .controller('subjectReportMainCtrl', ctrl);

  ctrl.$inject = ['MasterPermissionsDefinitionFactory', 'APIService'];
  /* ng-inject */
  function ctrl(MasterPermissionsDefinitionFactory, APIService) {

    var vm = this;

    vm.busy = true;
    vm.hasData = false;
    vm.data = null;
    vm.subjectHeader = '';
    vm.reportTime = '';
    vm.finalContactRecord = null;

    vm.$onInit = function () {
      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.getZubot().then(function () {
        vm.busy = false;
      });
    };

    vm.getZubot = function () {
      return APIService.postToDataApi('zubot', { id: vm.zubotId }).then(function (result) {
        if (result.data.success) {
          if (result.data.zubot && result.data.zubot.controlInfo && result.data.zubot.controlInfo.subjectData && result.data.zubot.controlInfo.subjectData.length > 0) {
            vm.hasData = true;
            vm.data = result.data.zubot.controlInfo.subjectData;
            vm.subjectHeader = result.data.zubot.controlInfo.subjectHeader;
            vm.reportTime = result.data.zubot.milestones[result.data.zubot.milestones.length -1].dt;
            vm.finalContactRecord = result.data.zubot.controlInfo.finalContactRecord;
          }
        }
      });
    };

    return vm;
  }
})();

/**
 * Created by davidfm on 23/04/2018.
 */

(function () {
  'use strict';
  angular.module('data')
    .component('postShowMatchUp', {
      templateUrl: 'app/data/workflow/workflow-main.tmpl.html',
      controller: 'postShowMatchUpCtrl'
    })
    .controller('postShowMatchUpCtrl', ctrl);

  ctrl.$inject = ['MasterPermissionsDefinitionFactory', 'workflowFactory', 'uuidService'];
  /* ng-inject */
  function ctrl(MasterPermissionsDefinitionFactory, workflowFactory, uuid) {

    var vm = this;

    vm.workflowFactory = workflowFactory;

    vm.$onInit = function () {
      vm.permissions = MasterPermissionsDefinitionFactory;
      workflowFactory.setTasks(vm.tasks);
    };

    vm.title = 'Post-Show Match-Up';
    vm.description = 'Modify the data you have captured after an event';

    vm.tasks = [{
      title: '',
      intro: 'postshowmatchup',
      mission: {
        type: 'postshowmatchup',
        subType: '',
        activationRules: {
          remoteNodesShouldWaitForServerCompletion: false,
          remoteNodesShouldWaitForSyncCompletion: false
        }
      },
      description: '',
      dryrunAvailable: true,
      steps: [{
        title: 'Choose CSV',
        description: 'Load a file from your local computer',
        colour: 'turquoise',
        newText: 'Choose a FILE',
        cardType: 'file',
        fetchCards: false,
        singleCard: true,
        cardOptional: false,
        _id: uuid.getSingleNewBase64Key()
      }, {
        title: 'Post-show match-up Rules',
        description: 'Choose how you want to match',
        colour: 'red',
        newText: 'Choose RULES',
        cardName: 'Rules',
        cardType: 'PSMU',
        fetchCards: true,
        cardOptional: false,
        validation: [
          {
            group: 1,
            required: true,
            maxAmount: 1,
            failMessage: 'You must select one (and only one) rule card'
          },
          {
            group: 2,
            required: false,
            maxAmount: 1,
            failMessage: 'You can only select one optional card'
          },
          {
            condition: {
              cardType: 'PSMU',
              description: 'Match using multiple forms'
            },
            conflict: {
              cardType: 'PSMU',
              description: 'Generate missing responses'
            },
            failMessage: 'If you are matching using multiple forms you cannot generate missing responses'
          }
        ]
      }, {
        title: 'Select Form',
        description: 'Select the forms you want to match up',
        colour: 'blue',
        newText: 'Choose a FORM',
        cardType: 'form',
        fetchCards: true,
        validation: [
          {
            condition: {
              cardType: 'PSMU',
              description: 'Match against entire pool of contacts'
            },
            exception: [
              {
                cardType: 'PSMU',
                description: 'Generate missing responses'
              },
              {
                cardType: 'PSMU',
                description: 'Restrict contacts with existing responses'
              }
            ],
            maxAmount: 0,
            failMessage: 'If you are matching against the entire pool of contacts the form card is irrelevant'
          },
          {
            condition: {
              cardType: 'PSMU',
              description: 'Generate missing responses'
            },
            required: true,
            maxAmount: 1,
            failMessage: 'If you are generating missing responses you can only select one form card'
          },
          {
            condition: {
              cardType: 'PSMU',
              description: 'Restrict contacts with existing responses'
            },
            required: true,
            failMessage: 'If you are restricting matches on contacts having existing responses you must select at least one form card'
          },
          {
            condition: {
              cardType: 'PSMU',
              description: 'Match using a single form'
            },
            required: true,
            maxAmount: 1,
            failMessage: 'If you are matching using a single form you can only select one form card'
          },
          {
            condition: {
              cardType: 'PSMU',
              description: 'Match using multiple forms'
            },
            required: true,
            failMessage: 'If you are matching using multiple forms you must select at least one form card'
          }
        ]
      }, {
        title: 'Choose Field Mapping',
        description: 'Create new Field Mapping card',
        colour: 'green',
        newText: 'Choose a MAPPING',
        cardName: 'Field Mapping',
        cardType: 'mapping',
        fetchCards: false,
        singleCard: true,
        data: {
          systemA: 'file',
          systemB: 'form'
        },
        cardOptional: false
      }, {
        title: 'Choose Dedupe Mapping',
        description: 'Create new Dedupe Mapping card',
        colour: 'green',
        newText: 'Choose a DEDUPE MAPPING',
        cardName: 'Dedupe Mapping',
        cardType: 'dedupemapping',
        fetchCards: false,
        singleCard: true,
        data: {
          systemA: 'file',
          systemB: 'form'
        },
        cardOptional: false
      // }, {
      //   title: 'Notifications',
      //   description: 'How would you like to be kept informed of what\'s happening',
      //   colour: 'red',
      //   newText: 'Choose a NOTIFICATION',
      //   cardName: 'Notification',
      //   cardType: 'notification',
      //   fetchCards: true,
      //   cardOptional: true
      }]
    }];


  }
})();

(function () {
  'use strict';
  angular.module('data')
    .factory('zubotMissionControlFactory', ['APIService', 'workflowFactory', function (APIService, workflowFactory) {

      var zubots = [];

      function getZubots() {
        APIService.getFromDataApi('zubots').then(function (result) {
          if (result.data.success) {
            if (zubots.length === 0) {
              zubots.push.apply(zubots, result.data.zubots);
            } else {
              for (const newZubot of result.data.zubots) {
                let found = false;
                for (const zubot of zubots) {
                  if (zubot._id === newZubot._id) {
                    for (const k in newZubot) {
                      zubot[k] = newZubot[k];
                    }
                    found = true;
                    break;
                  }
                }

                if (!found) {
                  zubots.unshift(newZubot);
                }
              }
            }
          }
        });
      }

      function getZlogs(zubot) {
        return APIService.postToDataApi('zlogs', { _id: zubot._id });
      }

      function loadZubot(zubot) {
        workflowFactory.setLoadZubotId(zubot._id);
      }

      function retireZubot(zubot) {
        return APIService.postToDataApi('zubot/retire', { _id: zubot._id });
      }

      function killZubot(zubot) {
        return APIService.postToDataApi('zubot/kill', { _id: zubot._id });
      }

      return {
        zubots: zubots,
        getZubots: getZubots,
        getZlogs: getZlogs,
        loadZubot: loadZubot,
        retireZubot: retireZubot,
        killZubot
      };

    }]);
})();

/**
 * Created by davidfm on 11/10/2018.
 */

(function () {
  'use strict';
  angular.module('data')
    .controller('ZlogsDialogController', ['zlogs', 'MessageService', 'hotkeys', function (zlogs, MessageService, hotkeys) {

      var vm = this;
      vm.cancelDialog = cancelDialog;
      vm.hide = hide;
      vm.zlogs = zlogs;

      // modal dismiss functions
      function hide(answer) {
        hotkeys.del('enter');
        MessageService.closeDialog(answer);
      }

      function cancelDialog() {
        hotkeys.del('enter');
        MessageService.cancelDialog();
      }

    }]);
})();

/**
 * Created by davidfm on 23/05/2018.
 */

(function () {
  'use strict';
  angular.module('data')
    .component('missionControl', {
      templateUrl: 'app/data/mission-control/mission-control-main.tmpl.html',
      controller: 'missionControlCtrl'
    })
    .controller('missionControlCtrl', ctrl);

  ctrl.$inject = ['$scope', 'zubotMissionControlFactory', '$interval', '$location', 'MessageService', 'EncodingService', 'EnvService'];
  /* ng-inject */
  function ctrl($scope, zubotFactory, $interval, $location, MessageService, EncodingService, EnvService) {

    var vm = this;
    vm.EnvService = EnvService;

    $scope.stripHtmlTags = function(input) {
      if (!input) return '';
      return input.replace(/<\/?[^>]+(>|$)/g, '');
    };

    $scope.getType = function (type, subtype) {
      var friendlyType = '';
      if (!type) {
        return '';
      }
      switch (type.toLowerCase()) {
        case 'postshowmatchup':
          friendlyType = 'Post Show Match-up';
          break;
        case 'dataload':
          friendlyType = 'Data Load';
          break;
        case 'load':
          if (subtype){
            switch (subtype.toLowerCase()){
              case 'literature':
                friendlyType = 'Literature Load';
                break;
            }
          }
          break;
        case 'blast':
          if (subtype) {
            switch (subtype.toLowerCase()) {
              case 'dataload':
                friendlyType = 'Remove Data Load';
                break;
              case 'scoped':
                friendlyType = 'Remove CRM Data';
                break;
              case 'literature':
                friendlyType = 'Remove Literature Load';
                break;
            }
          }
          break;

        case 'prune':
          if (subtype) {
            switch (subtype.toLowerCase()) {
              case 'scoped':
                friendlyType = 'Prune CRM Data';
                break;
            }
          }
          break;

        

        case 'compliance':
          if (subtype) {
            switch (subtype.toLowerCase()) {
              case 'removecontact':
                friendlyType = 'Remove Contact';
                break;
              case 'removecontactbatch':
                friendlyType = 'Remove Contact Batch';
                break;
              case 'subjectaccessrequest':
                friendlyType = 'Subject Access Request';
                break;
              case 'redact':
                friendlyType = 'Redact All CRM Data';
                break;
            }
          }
          break;
        default:
          friendlyType = type;
          break;
      }
      
      return friendlyType;
    };

    $scope.hasInfo = function (zubot) {
      if (zubot.mission){
        var type = zubot.mission.type;
        var subType = zubot.mission.subType;
        switch (type){
          case 'blast':
            return true;
          case 'prune':
            return true;
          case 'compliance':
            switch (subType){
              case 'removeContactBatch':
                return true;
              case 'redact':
                return true;
              case 'compliance':
                switch (subType){
                  case 'removeContactBatch':
                    return true;
                }
                return false;
              case 'load':
                switch(subType){
                  case 'literature':
                    return true;
                }
                return false;
            }
        }
      }
      return false;
    };

    $scope.getInfo = function ($event, zubot) {
      zubotFactory.getZlogs(zubot).then(function (result) {
        if (result.data.success) {
          var dialogConfig = {
            description: 'Zlogs',
            controller: 'ZlogsDialogController as vm',
            templateUrl: 'app/data/mission-control/zlogs.dialog.tmpl.html',
            locals: {
              zlogs: result.data.zlogs
            },
            ariaLabel: 'Zlogs'
          };

          MessageService.showDialog($event, dialogConfig);
        }
      });
    };

    $scope.openLoadStatsDialog = function ($event,  controlInfo) {
      var dialogConfig = {
        description: 'Load Stats',
        controller: 'LoadStatsDialogController as vm',
        templateUrl: 'app/data/mission-control/load-stats.dialog.tmpl.html',
        locals: {
          stats: controlInfo
        },
        ariaLabel: 'Load Stats'
      };

      MessageService.showDialog($event, dialogConfig);
    };

    $scope.getServerComplete = function (milestones) {
      var i = 0;
      var len = milestones.length;
      var ret = '';
      for (i; i < len; i++) {
        if (milestones[i].milestone === 'serverComplete') {
          ret = $scope.getDate(milestones[i].dt);
          break;
        }
      }
      return ret;
    };

    $scope.getStatus = function (milestones, dryrun) {
      var status = 'Inactive';
      var i = 0;
      var len = milestones.length;

      for (i; i < len; i++) {
        if (milestones[i].milestone === 'activated') {
          status = 'Active';
        } else if (milestones[i].milestone === 'serverComplete') {
          status = 'Complete';
        }
      }

      if (dryrun) {
        status += ' (Dry run)';
      }
      return status;
    };

    $scope.getPercentageComplete = function (zubot) {
      return parseInt((parseFloat(zubot.completedPies || 0) / parseFloat(zubot.totalPies || 1)) * 100).toString() + '%';
    };

    $scope.getControlInfo = function (type, subtype, controlInfo, _id) {
      var info = '';
      if (!type) {
        return '';
      }
      switch (type.toLowerCase()) {
        case 'postshowmatchup':
          if (controlInfo) {
            info = controlInfo.filtered + ' matches found out of ' + controlInfo.total;
          }
          break;
        case 'dataload':
          if (controlInfo) {
            info = controlInfo.total + ' records loaded';
          }
          break;
        case 'compliance':
          if (subtype) {
            switch (subtype.toLowerCase()) {
              case 'removecontact':
                break;
              case 'removecontactbatch':
                if (controlInfo) {
                  info = controlInfo.redacted + ' contact(s) redacted from ' + controlInfo.total + ' emails';
                }
                break;
              case 'subjectaccessrequest':
                if (controlInfo) {
                  info = '<a href="data/subject-report/' + EncodingService.encode(_id) + '">View Report - ' + $scope.stripHtmlTags(controlInfo.subjectHeader) + '</a>';
                }
                break;
            }
          }
          break;
        case 'load':
          if (subtype) {
            switch (subtype.toLowerCase()){
              case 'literature':
                if (controlInfo){
                  info = `Proccessed ${controlInfo.counts.literatureProcess} literature items. <br> <a href="" ng-click='openLoadStatsDialog($event, zubot.controlInfo)'>Additional Breakdown</a>`;
                }
                break;
            }
          }
          break;
        case 'blast':
          if (subtype) {
            switch (subtype.toLowerCase()) {
              case 'dataload':
                if (controlInfo) {
                  info = controlInfo.total + ' records processed';
                }
                break;
              case 'literature':
                if (controlInfo) {
                  info = `${controlInfo.total} literature items processed. <br> ${controlInfo.deletedLiterature} literature items removed.`;
                }
                break;
              case 'scoped':
                break;
            }
          }
          break;          
        case 'prune':
          if (subtype) {
            switch (subtype.toLowerCase()){
              case 'scoped':
                if (controlInfo && controlInfo.total){
                  info = controlInfo.total + ' records removed';
                }
                break;
            }
          }
      }
      return info;
    };

    $scope.loadZubot = function (zubot) {
      zubotFactory.loadZubot(zubot);
      switch (zubot.mission.type.toLowerCase()) {
        case 'postshowmatchup':
          $location.path('/data/postshowmatchup');
          break;
        case 'dataload':
          $location.path('/data/load');
          break;
      }
    };

    $scope.retireZubot = function (zubot) {
      zubot.retiring = true;
      zubotFactory.retireZubot(zubot).then(function (result) {
        if (!result.data || !result.data.success) {
          MessageService.showMessage('Could not retire the zubot. Please try again later.');
        }
      }).catch(function () {
        MessageService.showMessage('An error occured trying to contact the server. Please try again later.');
      });
      try {
        MessageService.pushEventToIntercom('retire_zubot', _.pickBy({
          zubot: zubot.name,
          missionType: zubot.mission.type,
          missionSubtype: zubot.mission.subType,
          createdOn: zubot.createdOn,
          lastMilestone: zubot.milestones[zubot.milestones.length - 1].milestone,
          lastMilestoneTimestamp: zubot.milestones[zubot.milestones.length - 1].dt
        }, _.identity)); // underscore pick and identity combo removes any empty keys from the object: https://stackoverflow.com/questions/14058193/remove-empty-properties-falsy-values-from-object-with-underscore-js
      } catch (e) {
        MessageService.writeLog({
          level: 'error',
          msg: 'error posting retiring zubot event to Intercom',
          tags: ['intercom_events', 'retiring_zubot']
        });
      }
    };

    $scope.killZubot = function (zubot) {
      zubot.retiring = true;
      zubotFactory.killZubot(zubot).then(function (result) {
        if (!result.data || !result.data.success) {
          MessageService.showMessage('Could not kill the zubot. Please try again later.');
        }
      }).catch(function () {
        MessageService.showMessage('An error occured trying to contact the server. Please try again later.');
      });
    };

    $scope.getDate = function (createdOn) {
      return new Date(createdOn).toLocaleString();
    };

    vm.$onInit = function () {
      vm.zubots = zubotFactory.zubots;
      vm.getZubots = $interval(zubotFactory.getZubots, 2000);
      MessageService.pushEventToIntercom('mission_control_page_visit');
    };

    $scope.$on('$destroy', function () {
      $interval.cancel(vm.getZubots);
    });

    return vm;
  }

  angular
    .module('data')
    .directive('compile', ['$compile', function ($compile) {
      return function(scope, element, attrs) {
        scope.$watch(
          function(scope) {
            return scope.$eval(attrs.compile);
          },
          function(value) {
            element.html(value);
            $compile(element.contents())(scope);
          }
        );
      };
    }]);
})();

/**
 * Created by tom on 15/09/2022.
 */

(function () {
  'use strict';
  angular.module('data')
    .controller('LoadStatsDialogController', ['stats', 'MessageService', 'hotkeys', function (stats, MessageService, hotkeys) {
  
      var vm = this;
      vm.getSize = getSize;
      vm.cancelDialog = cancelDialog;
      vm.hide = hide;
      vm.stats = stats;

      function getSize(){
        if (stats.counts.dupes.literature === 0){
          return 30;
        }
        return 70;
      }
  
      // modal dismiss functions
      function hide(answer) {
        hotkeys.del('enter');
        MessageService.closeDialog(answer);
      }
  
      function cancelDialog() {
        hotkeys.del('enter');
        MessageService.cancelDialog();
      }
  
    }]);
})();
  
/**
 * Created by davidfm on 13/03/2018.
 */

(function () {
  'use strict';
  angular.module('data')
    .component('dataLoad', {
      templateUrl: 'app/data/workflow/workflow-main.tmpl.html',
      controller: 'dataLoadCtrl'
    })
    .controller('dataLoadCtrl', ctrl);

  ctrl.$inject = ['MasterPermissionsDefinitionFactory', 'workflowFactory', 'uuidService'];
  /* ng-inject */
  function ctrl(MasterPermissionsDefinitionFactory, workflowFactory, uuid) {

    var vm = this;

    vm.workflowFactory = workflowFactory;

    vm.$onInit = function () {
      vm.permissions = MasterPermissionsDefinitionFactory;
      workflowFactory.setTasks(vm.tasks);
    };

    vm.title = 'Load Data';
    vm.description = 'Bulk upload your data';

    vm.tasks = [{
      title: '',
      intro: 'dataload',
      mission: {
        type: 'dataload',
        subType: '',
        activationRules: {
          remoteNodesShouldWaitForServerCompletion: false,
          remoteNodesShouldWaitForSyncCompletion: false
        }
      },
      description: 'Select and load in a file of contacts into the Vault',
      steps: [{
        title: 'Choose CSV',
        description: 'Load a file from your local computer',
        colour: 'turquoise',
        newText: 'Choose a FILE',
        cardType: 'file',
        fetchCards: false,
        singleCard: true,
        cardOptional: false,
        _id: uuid.getSingleNewBase64Key()
      }, {
        title: 'Select Form',
        description: 'Select the forms you want to load into',
        colour: 'blue',
        newText: 'Choose a FORM',
        cardType: 'form',
        fetchCards: true,
        singleCard: true,
        cardOptional: true,
        zubotText: 'If you don\'t select a form, you can match from a set of standard Zuant fields in the next step',
        validation: [
          {
            maxAmount: 1,
            failMessage: 'You can select one (and only one) form card'
          }
        ]
      }, {
        title: 'Choose Field Mapping',
        description: 'Create new Field Mapping card',
        colour: 'green',
        newText: 'Choose a MAPPING',
        cardName: 'Field Mapping',
        cardType: 'mapping',
        fetchCards: false,
        singleCard: true,
        data: {
          systemA: 'file',
          systemB: 'form'
        },
        cardOptional: false
      // }, {
      //   title: 'Notifications',
      //   description: 'How would you like to be kept informed of what\'s happening',
      //   colour: 'red',
      //   newText: 'Choose a NOTIFICATION',
      //   cardName: 'Notification',
      //   cardType: 'notification',
      //   fetchCards: true,
      //   cardOptional: true
      }]
    }];


  }
})();

(function () {
  'use strict';

  function introText() {
    return {
      restrict: 'E',
      template: '<ng-include src="getTemplateUrl()"/>',
      scope: {
        zubot: '=zubot'
      },
      controller: function($scope) {
        $scope.getTemplateUrl = function() {
          return 'app/data/intro/' + $scope.zubot.intro + '.tmpl.html';
        };
      }
    };
  }

  angular
    .module('data')
    .directive('introText', [introText]);
})();

/**
 * Created by davidfm on 10/08/2018.
 */

(function () {
  'use strict';
  angular.module('data')
    .component('housekeeping', {
      templateUrl: 'app/data/workflow/workflow-main.tmpl.html',
      controller: 'housekeepingCtrl'
    })
    .controller('housekeepingCtrl', ctrl);

  ctrl.$inject = ['MasterPermissionsDefinitionFactory', 'workflowFactory'];
  /* ng-inject */
  function ctrl(MasterPermissionsDefinitionFactory, workflowFactory) {

    var vm = this;

    vm.workflowFactory = workflowFactory;
    vm.todaysDate = new Date();

    vm.$onInit = function () {
      vm.permissions = MasterPermissionsDefinitionFactory;
      workflowFactory.setTasks(vm.tasks);
    };

    vm.title = 'Housekeeping';
    vm.description = 'Keep within pesky GDPR regulations';
    vm.zubot = '';

    vm.tasks = [{
      title: 'Remove a Data Load',
      intro: 'housekeeping-removedataload',
      mission: {
        type: 'blast',
        subType: 'dataload',
        activationRules: {
          remoteNodesShouldWaitForServerCompletion: true,
          remoteNodesShouldWaitForSyncCompletion: true
        }
      },
      description: 'Archive data loaded at a previous date',
      steps: [{
        title: 'Choose Data Load',
        colour: 'turquoise',
        description: 'Choose a Data Load',
        singleCard: false,
        fetchCards: false,
        cardType: 'instanceReference',
        objectType: 'dataload',
        newText: 'Choose a DATA LOAD'
      // },
      // {
      //   title: 'Notifications',
      //   description: 'How would you like to be kept informed of what\'s happening',
      //   colour: 'red',
      //   newText: 'Choose a NOTIFICATION',
      //   cardName: 'Notification',
      //   cardType: 'notification',
      //   fetchCards: true,
      //   cardOptional: true
      }]
    },
    {
      title: 'Prune CRM Data',
      intro: 'housekeeping-prunecrm',
      mission: {
        type: 'prune',
        subType: 'scoped',
        activationRules: {
          remoteNodesShouldWaitForServerCompletion: true,
          remoteNodesShouldWaitForSyncCompletion: true
        }
      },
      description: 'Prune CRM data on all devices',
      steps: [{
        title: 'Confirmation',
        description: 'Confirm that you actually want to prune CRM data by typing the database name below',
        colour: 'blue',
        cardName: 'Confirmation',
        cardType: 'confirmation',
        fetchCards: false,
        singleCard: true,
        display: 'panel'
      }]
    },
    {
      title: 'Remove all CRM Data',
      intro: 'housekeeping-removecrm',
      mission: {
        type: 'blast',
        subType: 'scoped',
        activationRules: {
          remoteNodesShouldWaitForServerCompletion: true,
          remoteNodesShouldWaitForSyncCompletion: false
        }
      },
      description: 'Nuke all CRM data on all devices',
      // needsConfirmation: true,
      // confirmationText: 'Delete all CRM data from this account?',
      steps: [{
        title: 'Confirmation',
        description: 'Confirm that you actually want to delete all CRM data by typing the database name below',
        colour: 'blue',
        cardName: 'Confirmation',
        cardType: 'confirmation',
        fetchCards: false,
        singleCard: true,
        display: 'panel'
      // },
      // {
      //   title: 'Notifications',
      //   description: 'How would you like to be kept informed of what\'s happening',
      //   colour: 'red',
      //   newText: 'Choose a NOTIFICATION',
      //   cardName: 'Notification',
      //   cardType: 'notification',
      //   fetchCards: true,
      //   cardOptional: true
      }]
    }];
  }
})();

/**
 * Created by davidfm on 07/06/2018
 */

(function () {
  'use strict';
  angular
    .module('data')
    .controller('NotificationsDialogController', ctrl);

  ctrl.$inject = ['MessageService'];
  /* ng-inject */
  function ctrl(MessageService) {

    var vm = this;
    vm.cancelDialog = cancelDialog;
    vm.hide = hide;

    function hide() {
      MessageService.closeDialog();
    }

    function cancelDialog() {
      MessageService.cancelDialog();
    }

  }
})();

/**
 * Created by davidfm on 12/03/2018.
 */

(function () {
  'use strict';
  angular.module('data')
    .component('dataDashboardMain', {
      templateUrl: 'app/data/dashboard/dashboard-main.tmpl.html',
      controller: 'dataDashboardMainCtrl'
    })
    .controller('dataDashboardMainCtrl', ctrl);

  ctrl.$inject = ['MasterPermissionsDefinitionFactory'];
  /* ng-inject */
  function ctrl(MasterPermissionsDefinitionFactory) {

    var vm = this;

    vm.items = [];

    vm.$onInit = function () {
      vm.permissions = MasterPermissionsDefinitionFactory;

      vm.items = [{
        label: 'Manage',
        description: 'Load data. Tweak Data. Housekeeping.',
        items: [{
          label: 'Load',
          description: 'Load data into your account',
          icon: '',
          permission: vm.permissions.liteFeatures.data.load,
          sref: 'app.homescreen_app_framework_no_sidebar.data.dataload'
        }, {
          label: 'Post-Show Match-Up',
          description: 'Modify the data you have captured after an event',
          permission: vm.permissions.liteFeatures.data.load,
          sref: 'app.homescreen_app_framework_no_sidebar.data.postshowmatchup',
          icon: ''
        }, {
          label: 'Comply',
          description: 'Be a good citizen and comply with data privacy rules and requests',
          permission: vm.permissions.liteFeatures.data.comply,
          sref: 'app.homescreen_app_framework_no_sidebar.data.compliance',
          icon: ''
        }, {
          label: 'Housekeeping',
          description: 'Remove unwanted and stale data from your account',
          permission: 'ZAM',
          sref: 'app.homescreen_app_framework_no_sidebar.data.housekeeping',
          icon: ''
        }]
      }, {
        label: 'Review',
        description: 'What\'s happening out there?',
        items: [{
          label: 'Zubot Mission Control',
          description: 'See what\'s going on in the world of zubots',
          sref: 'app.homescreen_app_framework_no_sidebar.data.missioncontrol',
          icon: ''
        }]
      }
      /*, {
        label: 'Connect',
        description: 'Connect Zuant to other systems',
        items: [{
          label: 'Connect to third party systems',
          description: 'Coming Soon!',
          // sref: 'app.homescreen_app_framework_no_sidebar.data.postshowmatchup',
          icon: ''
        }]
      }
      */
      ];
    };

    vm.showSubItems = function (item) {
      var i = 0;
      var len = vm.items.length;

      for (i; i < len; i++) {
        if (vm.items[i].show) {
          vm.items[i].show = false;
        }
      }

      item.show = true;
    };

  }
})();

/**
 * Created by davidfm on 13/03/2018.
 */

(function () {
  'use strict';
  angular.module('data')
    .component('compliance', {
      templateUrl: 'app/data/workflow/workflow-main.tmpl.html',
      controller: 'complianceCtrl'
    })
    .controller('complianceCtrl', ctrl);

  ctrl.$inject = ['MasterPermissionsDefinitionFactory', 'workflowFactory', 'uuidService'];
  /* ng-inject */
  function ctrl(MasterPermissionsDefinitionFactory, workflowFactory, uuid) {

    var vm = this;

    vm.workflowFactory = workflowFactory;

    vm.$onInit = function () {
      vm.permissions = MasterPermissionsDefinitionFactory;
      workflowFactory.setTasks(vm.tasks);
    };

    vm.title = 'Compliance';
    vm.description = 'Keep within pesky GDPR regulations';
    vm.zubot = '';

    vm.tasks = [{
      title: 'Handle a Subject Access Request',
      intro: 'compliance-subjectaccessrequest',
      mission: {
        type: 'compliance',
        subType: 'subjectAccessRequest',
        activationRules: {
          remoteNodesShouldWaitForServerCompletion: false,
          remoteNodesShouldWaitForSyncCompletion: false
        }
      },
      description: 'Allow an individual to find out what we know about them',
      longDescription: 'Deal with a request from a contact regarding a privacy matter or GDPR subject access request',
      steps: [{
        title: 'Choose Person',
        colour: 'turquoise',
        description: 'Choose a Person',
        singleCard: true,
        fetchCards: false,
        cardType: 'instanceReference',
        objectType: 'contact',
        newText: 'Choose a PERSON'
      // }, {
      //   title: 'Notifications',
      //   description: 'How would you like to be kept informed of what\'s happening',
      //   colour: 'red',
      //   newText: 'Choose a NOTIFICATION',
      //   cardName: 'Notification',
      //   cardType: 'notification',
      //   fetchCards: true,
      //   cardOptional: true
      }]
    }, {
      title: 'Erase a contact',
      intro: 'compliance-erasecontact',
      mission: {
        type: 'compliance',
        subType: 'removeContact',
        activationRules: {
          remoteNodesShouldWaitForServerCompletion: false,
          remoteNodesShouldWaitForSyncCompletion: false
        }
      },
      description: 'Completely remove a contact from the system',
      steps: [{
        title: 'Choose Person',
        colour: 'turquoise',
        description: 'Choose a Person',
        singleCard: false,
        fetchCards: false,
        cardType: 'instanceReference',
        objectType: 'contact',
        newText: 'Choose a PERSON'
      // }, {
      //   title: 'Notifications',
      //   description: 'How would you like to be kept informed of what\'s happening',
      //   colour: 'red',
      //   newText: 'Choose a NOTIFICATION',
      //   cardName: 'Notification',
      //   cardType: 'notification',
      //   fetchCards: true,
      //   cardOptional: true
      }]
    }, {
      title: 'Erase a contact batch',
      intro: 'compliance-erasecontactbatch',
      mission: {
        type: 'compliance',
        subType: 'removeContactBatch',
        activationRules: {
          remoteNodesShouldWaitForServerCompletion: false,
          remoteNodesShouldWaitForSyncCompletion: false
        }
      },
      description: 'Completely remove a list of contacts from the system',
      steps: [{
        title: 'Choose CSV',
        description: 'Load a file from your local computer',
        colour: 'turquoise',
        newText: 'Choose a FILE',
        cardType: 'file',
        fetchCards: false,
        singleCard: true,
        cardOptional: false,
        // zubotText: 'Please ensure that your file contains no header line',
        _id: uuid.getSingleNewBase64Key()
      // }, {
      //   title: 'Notifications',
      //   description: 'How would you like to be kept informed of what\'s happening',
      //   colour: 'red',
      //   newText: 'Choose a NOTIFICATION',
      //   cardName: 'Notification',
      //   cardType: 'notification',
      //   fetchCards: true,
      //   cardOptional: true
      }]
    }, {
      title: 'Redact All CRM Data',
      intro: 'compliance-redactall',
      mission: {
        type: 'compliance',
        subType: 'redact',
        activationRules: {
          remoteNodesShouldWaitForServerCompletion: true,
          remoteNodesShouldWaitForSyncCompletion: false
        }
      },
      description: 'Redact CRM data on all devices',
      steps: [
        {
          title: 'Choose Field Mapping',
          description: 'Create new Field Mapping card',
          colour: 'green',
          newText: 'Choose a MAPPING',
          cardName: 'Field Mapping',
          cardType: 'redactionmapping',
          fetchCards: false,
          singleCard: true,
          data: {
            systemA: 'form',
            systemB: 'redact'
          },
          cardOptional: false
        },
        {
          title: 'Confirmation',
          description: 'Confirm that you actually want to Redact all CRM data by typing the database name below',
          colour: 'blue',
          cardName: 'Confirmation',
          cardType: 'confirmation',
          fetchCards: false,
          singleCard: true,
          display: 'panel'
        }]
    }];


  }
})();

(function () {
  'use strict';
  
  angular
    .module('data')
    .service('validateFieldMapping', validateFieldMapping);
  
  validateFieldMapping.$inject = ['MessageService'];
  /* ng-inject */
  function validateFieldMapping(MessageService) {
  
    return function (selectedCard, ui) {
      const itmToBeMapped = ui.item.sortable.model;
      const dropTargetModel = ui.item.sortable.droptargetModel;
      const dropIndex = ui.item.sortable.dropindex;

      if (dropTargetModel === undefined || dropIndex === undefined){
        ui.item.sortable.cancel();
        return;
      }
      const dropTargetElement = angular.element(ui.item.sortable.droptarget[0]);

      if (!dropTargetElement || !dropTargetElement.hasClass('field-drop-container') && !dropTargetElement.hasClass('drop-container')){
        //not in bounds of valid drop container
        ui.item.sortable.cancel();
        return;
      }

      const dropTargetContainerElement = dropTargetElement.parent()[0];
      const rowIndex = Number(dropTargetContainerElement.id);

      const newRowDrop = dropTargetElement.hasClass('drop-container');

      mappingsLoop:
      for (let i = 0; i < selectedCard.mappings.length; i++){
        for (const mappingSystemType of Object.keys(selectedCard.mappings[i])){
          if (mappingSystemType === '$$hashKey') continue;
          
          for (let j = 0; j < selectedCard.mappings[i][mappingSystemType].length; j++){
            const field = selectedCard.mappings[i][mappingSystemType][j];
            if (itmToBeMapped.name === field.name && field.selected && mappingSystemType === 'systemA'){

              if (newRowDrop){
                const indexToBlast = _.findIndex(selectedCard.mappings[selectedCard.mappings.length-1][mappingSystemType], function(mappedField){
                  mappedField.name === field.name;
                });
                  
                selectedCard.mappings[selectedCard.mappings.length-1][mappingSystemType].splice(indexToBlast, 1);
    
                const rowHasEmptyMappings = Object.keys(selectedCard.mappings[selectedCard.mappings.length-1]).every(key => selectedCard.mappings[selectedCard.mappings.length-1][key].length === 0);
                if (rowHasEmptyMappings){
                  selectedCard.mappings.splice(selectedCard.mappings.length-1, 1);
                }

                MessageService.showMessage('"'+ (field.friendly || field.name) + '" mapping already exists');

                ui.item.sortable.cancel();
                return;
              }


              if (selectedCard.previousMappings[rowIndex][mappingSystemType].length === 0 || selectedCard.previousMappings[rowIndex][mappingSystemType][0].name === field.name){
                //New or exact replacement! we are good
                break mappingsLoop;
              }
                
              MessageService.showMessage('"'+ (field.friendly || field.name) + '" mapping already exists');

              const indexToBlast = _.findIndex(selectedCard.mappings[rowIndex][mappingSystemType], function(mappedField){
                return mappedField.name === field.name;
              });

              selectedCard.mappings[rowIndex][mappingSystemType].splice(indexToBlast, 1);
    
              const rowHasEmptyMappings = Object.keys(selectedCard.mappings[rowIndex]).every(function (key) {
                if (!Array.isArray(selectedCard.mappings[rowIndex][key])) return true;
                return selectedCard.mappings[rowIndex][key].length === 0;
              });
              if (rowHasEmptyMappings){
                selectedCard.mappings.splice(rowIndex, 1);
              }
              ui.item.sortable.cancel();
              return;
              
            }
          }
        }
      }

      

      const systemAField = selectedCard.mappings[rowIndex].systemA[0];
      const systemBField = selectedCard.mappings[rowIndex].systemB[0];
      if (systemAField && systemBField){
        if (systemBField.category === 'redact' && ['company', 'contact', 'response'].indexOf(systemAField.object) === -1){
          MessageService.showMessage('"'+ (systemAField.friendly || systemAField.name) + '" cannot be mapped to Redact typed fields');
          selectedCard.mappings[rowIndex].systemB.splice(0, 1);

          itmToBeMapped.selected = false;

          mappingsLoop:
          for (let i = 0; i < selectedCard.mappings.length; i++){
            for (const mappingSystemType of Object.keys(selectedCard.mappings[i])){
              for (let j = 0; j < selectedCard.mappings[i][mappingSystemType].length; j++){
                const field = selectedCard.mappings[i][mappingSystemType][j];
                if (field.name === itmToBeMapped.name){
                  itmToBeMapped.selected = true;
                  break mappingsLoop;
                }
              }
            }
          }

          ui.item.sortable.cancel();
          return;
        }
      }

  
    };
  
  }
  
}());
  
(function () {
  'use strict';

  angular
    .module('data')
    .service('uploadFile', uploadFile);

  uploadFile.$inject = ['$rootScope', 'checkStepIsValid', 'MessageService', 'APIService', 'catchError', 'removeCardFromHand', '$q'];
  /* ng-inject */
  function uploadFile($rootScope, checkStepIsValid, MessageService, APIService, catchError, removeCardFromHand, $q) {

    function setProgress (selectedTask, progress, stepId) {

      for (let j = 0; j < selectedTask.steps.length; j++) {
        if (selectedTask.steps[j]._id === stepId) {
          if (progress < 100) {
            selectedTask.steps[j].progress = progress.toFixed(2).toString() + '%';
          } else {
            delete selectedTask.steps[j].progress;
            checkStepIsValid(selectedTask.steps[j], selectedTask);
          }
          break;
        }
      }
    }

    function resetProgress (selectedTask) {
      for (let j = 0; j < selectedTask.steps.length; j++) {
        delete selectedTask.steps[j].progress;
      }
    }

    return function ($event, selectedCard, containerShow, selectedStep, selectedTask, availableCards, cardId, filename) {
      const selectedStepId = selectedStep._id;
      const timeoutPromise = $q.defer();
      let manuallyCancelled = false;
      const deregisterEvent = $rootScope.$on('card-removed', function () {
        timeoutPromise.resolve();
        manuallyCancelled = true;
      });

      APIService.uploadFile('uploadFile', { name: filename }, { 'file': $event.target.files[0] }, timeoutPromise).then(function (result) {
        --containerShow.uploading;
        if (result.data && result.data.success) {
          let found = false;
          for (let j = 0; j < selectedTask.steps.length; j++) {
            if (selectedTask.steps[j].cards) {

              for (let i = 0; i < selectedTask.steps[j].cards.length; i++) {
                if (selectedTask.steps[j].cards[i]._id === cardId) {
                  found = true;
                  selectedTask.steps[j].cards[i].fileId = result.data.id;
                  break;
                }
              }
            }
          }

          if (!found) {

            for (let j = 0; j < selectedStep.cards.length; j++) {
              if (selectedStep.cards[j]._id === cardId) {
                selectedStep.cards[j].fileId = result.data.id;
                found = true;
                break;
              }
            }
          }
          if (selectedCard._id === cardId) {
            selectedCard.fileId = result.data.id;
          }
        } else {
          removeCardFromHand(selectedStep, selectedTask, null, { _id: cardId });
          catchError(containerShow, 'An error occurred when uploading the file you selected. Please reselect the file and try again.');
        }
      }, function () {
        deregisterEvent();
        resetProgress(selectedTask);
        --containerShow.uploading;
        if (!manuallyCancelled) {
          removeCardFromHand(selectedStep, selectedTask, null, { _id: cardId });
          catchError(containerShow, 'An error occurred when uploading the file you selected. Please reselect the file and try again.');
        }
      }, function (progress) {
        let found = false;
        for (let j = 0; j < selectedTask.steps.length; j++) {
          if (selectedTask.steps[j].cards) {
            for (let i = 0; i < selectedTask.steps[j].cards.length; i++) {
              if (selectedTask.steps[j].cards[i]._id === cardId) {
                found = true;
                if (progress < 100) {
                  selectedTask.steps[j].progress = progress.toFixed(2).toString() + '%';
                } else {
                  delete selectedTask.steps[j].progress;
                  checkStepIsValid(selectedTask.steps[j], selectedTask);
                }
                break;
              }
            }
          }
        }

        if (!found) {
          for (let j = 0; j < selectedTask.steps.length; j++) {
            if (selectedTask.steps[j]._id === selectedStepId) {
              if (progress < 100) {
                selectedTask.steps[j].progress = progress.toFixed(2).toString() + '%';
              } else {
                delete selectedTask.steps[j].progress;
                checkStepIsValid(selectedTask.steps[j], selectedTask);
              }
              break;
            }
          }
        }

        if (selectedCard._id === cardId) {
          setProgress(selectedTask, progress, selectedStepId);
        }
      });
    };

  }

}());

(function () {
  'use strict';
  
  angular
    .module('data')
    .factory('SystemFieldsFactory', SystemFieldsFactory);
  
  SystemFieldsFactory.$inject = ['findCardsInTask', 'APIService'];
  /* ng-inject */
  function SystemFieldsFactory(findCardsInTask, APIService) {

    var factoryData = {
      items: {}
    };
  
    return {
      factoryData: factoryData,
      getData: getData,
      invalidateCache: invalidateCache,
      invalidateCacheForCard: invalidateCacheForCard,
      getSystemFields: getSystemFields
    };

    //////////////////////////////////////////////////
    
    function getData() {
      return factoryData;
    }

    function invalidateCache() {
      factoryData.items = {};
    }

    function invalidateCacheForCard(card) {
      delete factoryData.items[card._id];
    }
   
    function getSystemFields(system, selectedTask, card) {

      if (factoryData.items[card._id]){
        const existingSystemIndex = _.findIndex(factoryData.items[card._id].systems, function (itm) {
          if (itm.name === system) return true;
          return false;
        });
        if (existingSystemIndex > -1) return factoryData.items[card._id].systems;
      }

      if (!factoryData.items[card._id]){
        factoryData.items[card._id] = {
          mission: selectedTask.mission.type,
          systems: []
        };
      }
        
      switch (system){
        case 'file':{
          factoryData.items[card._id].systems = getFileFields(selectedTask);
          break;
        }
        case 'redact':{
          factoryData.items[card._id].systems = [
            {
              name: 'redact',
              type: 'redact',
              iconType: 'icon',
              icon: 'zmdi-account-box-mail',
              fields: [
                {
                  name: 'redact',
                  friendly: 'REDACTED',
                  category: 'redact'
                },
                {
                  name: 'zuantaddcustomfield',
                  friendly: 'Add Custom field',
                  category: 'redact'
                }
              ]
            },
            {
              name: 'unset',
              type: 'redact',
              iconType: 'icon',
              icon: 'zmdi-account-box-mail',
              fields: [
                {
                  name: 'unset',
                  friendly: 'UNSET',
                  category: 'unset'
                }
              ]
            }
          ];

          break;
        }
        case 'form':{
          return APIService.postToDataApi('formMappings', { mission: selectedTask.mission, formCards: findCardsInTask('form', selectedTask), rules: findCardsInTask('PSMU', selectedTask) })
            .then(function(result){
              factoryData.items[card._id].systems = result.data.systems;
              return factoryData.items[card._id].systems;
            });
        }
        default: {
          return APIService.getFromDataApi('systems?type=' + system)
            .then(function(result){
              factoryData.items[card._id].systems = result.data.systems;
              return factoryData.items[card._id].systems;
            });
        }
      }

      return factoryData.items[card._id].systems;
  
    }

    //Private funcs

    function getFileFields(selectedTask) {
      const systems = [
        {
          name: 'file',
          type: 'file',
          iconType: 'icon',
          icon: 'zmdi-file-text',
          fields: []
        }
      ];
  
      for (let i = 0; i < selectedTask.steps.length; i++) {
        if (selectedTask.steps[i].cardType === 'file') {
          const fields = [];
          for (let j = 0; j < selectedTask.steps[i].cards.length; j++) {
            if (selectedTask.steps[i].cards[j].fields) {
  
              for (let k = 0; k < selectedTask.steps[i].cards[j].fields.length; k++) {
                let found = false;
                const name = selectedTask.steps[i].cards[j].fields[k].name;
  
                for (let f = 0; f < fields.length; f++) {
                  if (fields[f].name === name) {
                    found = true;
                  }
                }
  
                if (!found && name.length > 0) {
                  fields.push(angular.copy(selectedTask.steps[i].cards[j].fields[k]));
                }
              }
            }
          }
          systems[0].fields.push.apply(systems[0].fields, fields);
          break;
        }
      }
  
      return systems;
    }
  
  }
})();
  
(function () {
  'use strict';

  angular
    .module('data')
    .service('showNotificationModal', showNotificationModal);

  showNotificationModal.$inject = ['MessageService'];
  /* ng-inject */
  function showNotificationModal(MessageService) {

    return function () {
      MessageService.showDialog({}, {
        description: 'Notifications Info',
        controller: 'NotificationsDialogController as vm',
        templateUrl: 'app/data/dialogs/notifications-info.dialog.tmpl.html'
      });
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('setTasks', setTasks);

  setTasks.$inject = ['APIService', 'setSelectedTask', 'setSelectedStep', 'checkStepIsValid', 'catchError'];
  /* ng-inject */
  function setTasks(APIService, setSelectedTask, setSelectedStep, checkStepIsValid, catchError) {

    return function (tasks, selectedTask, containerShow, selectedStep, text) {
      if (selectedTask.originalZubotId) {
        APIService.postToDataApi('zubot', { id: selectedTask.originalZubotId }).then(function (result) {
          if (result.data.success) {
            for (let i = 0; i < tasks.length; i++) {
              if (tasks[i].mission.type === result.data.zubot.mission.type) {
                tasks[i].zubot = result.data.zubot.name;
                setSelectedTask(tasks[i], selectedTask, containerShow, selectedStep, text);
                let j = 0;
                let jlen = tasks[i].steps.length;

                for (j; j < jlen; j++) {
                  setSelectedStep(containerShow, tasks[i].steps[j], selectedStep, selectedTask, j !== jlen - 1);
                }

                for (let k = 0; k < result.data.zubot.cards.length; k++) {
                  j = 0;
                  for (j; j < jlen; j++) {
                    if (tasks[i].steps[j].cardType === result.data.zubot.cards[k].type) {
                      tasks[i].steps[j].cards = tasks[i].steps[j].cards || [];
                      tasks[i].steps[j].cards.push(result.data.zubot.cards[k]);
                    }
                  }
                }

                j = 0;
                for (j; j < jlen; j++) {
                  checkStepIsValid(tasks[i].steps[j], selectedTask);
                }

                return;
              }
            }
          }
        }).catch(catchError.bind(this, containerShow));
      } else {
        return setSelectedTask(tasks[0], selectedTask, containerShow, selectedStep, text);
      }
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('setStepProperties', setStepProperties);

  setStepProperties.$inject = ['checkStepIsValid', 'uuidService'];
  /* ng-inject */
  function setStepProperties(checkStepIsValid, uuid) {

    return function (step, selectedStep, selectedTask) {
      selectedStep.title = step.title;
      selectedStep.description = step.description;
      selectedStep.colour = step.colour;
      selectedStep.newText = step.newText;
      selectedStep.cardName = step.cardName;
      selectedStep.cardType = step.cardType;
      selectedStep.objectType = step.objectType;
      selectedStep.fetchCards = step.fetchCards;
      selectedStep.cardOptional = step.cardOptional;
      selectedStep.singleCard = step.singleCard;
      selectedStep.zubotText = step.zubotText;
      selectedStep.validation = selectedStep.validation || [];
      selectedStep.validation.length = 0;
      selectedStep.validation.push.apply(selectedStep.validation, step.validation);
      selectedStep.data = step.data;
      selectedStep.progress = step.progress || '';
      selectedStep.display = step.display;
      selectedStep._id = step._id || uuid.getSingleNewBase64Key();

      selectedStep.cards = selectedStep.cards || [];
      selectedStep.cards.length = 0;
      step.cards = step.cards || [];
      selectedStep.cards.push.apply(selectedStep.cards, step.cards);
      checkStepIsValid(selectedStep, selectedTask);
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('setSelectedTask', setSelectedTask);

  setSelectedTask.$inject = ['$rootScope', 'generateZubot', 'setSelectedStep', 'SystemFieldsFactory'];
  /* ng-inject */
  function setSelectedTask($rootScope, generateZubot, setSelectedStep, SystemFieldsFactory) {

    return function (task, selectedTask, containerShow, selectedStep, text) {
      if (task.steps) {
        $rootScope.$broadcast('card-removed');
        if (selectedTask.steps) {
          for (const step of selectedTask.steps) {
            delete step.progress;
          }
        }
        selectedTask.title = task.title;
        selectedTask.description = task.description;
        selectedTask.steps = task.steps;
        selectedTask.intro = task.intro;
        selectedTask.mission = angular.copy(task.mission);
        selectedTask.dryrunAvailable = task.dryrunAvailable;
        selectedTask.needsConfirmation = task.needsConfirmation || false;
        selectedTask.confirmationText = task.confirmationText || '';
        selectedTask.originalZubotId = selectedTask.originalZubotId || null;
        selectedTask.zubot = task.zubot;
        containerShow.zubotActivated = false;
        containerShow.dryrunActivated = false;
        containerShow.selectMapping = false;
        containerShow.selectContact = false;
        containerShow.selectCard = false;
        containerShow.buttonActivating = false;
        containerShow.selectDataload = false;
        containerShow.selectDataloadFile = false;
        containerShow.uploading = 0;
        if (selectedTask.intro && selectedTask.steps[0].cardType !== 'intro') {
          selectedTask.steps.unshift({
            title: 'intro',
            cardName: 'intro',
            cardType: 'intro',
            fetchCards: false,
            cardOptional: true,
            display: 'panel'
          });
        }
        for (let step of selectedTask.steps) {
          step.cards = [];
        }
        generateZubot(selectedTask);
        text.zubotActivateButtonText = 'Activate ' + selectedTask.zubot;
        setSelectedStep(containerShow, selectedTask.steps[0], selectedStep, selectedTask);
        SystemFieldsFactory.invalidateCache();
      }
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('setSelectedStep', setSelectedStep);

  setSelectedStep.$inject = ['$timeout', 'setStepProperties'];
  /* ng-inject */
  function setSelectedStep($timeout, setStepProperties) {

    return function (containerShow, step, selectedStep, selectedTask, ignoreTimeout) {
      containerShow.selectCards = false;
      if (ignoreTimeout) {
        setStepProperties(step, selectedStep, selectedTask);
      } else {
        $timeout(function () {
          setStepProperties(step, selectedStep, selectedTask);

          $timeout(function () { containerShow.selectCards = true; }, 0);
        }, 0);
      }
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('setSelectedCard', setSelectedCard);

  setSelectedCard.$inject = [];
  /* ng-inject */
  function setSelectedCard() {

    return function (card, selectedCard) {
      selectedCard.mappings = selectedCard.mappings || [];
      selectedCard.mappings.length = 0;
      card.mappings = card.mappings || [];
      selectedCard.mappings.push.apply(selectedCard.mappings, card.mappings);
      selectedCard.type = card.type;
      selectedCard.objectType = card.objectType;
      selectedCard.systemTypes = card.systemTypes;
      selectedCard._id = card._id;
      selectedCard.name = card.name;
      selectedCard.description = card.description;
      selectedCard.objectId = card.objectId;
      selectedCard.fields = card.fields;
      selectedCard.fileId = card.fileId;
      selectedCard.originalName = card.name;
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('setBusy', setBusy);

  setBusy.$inject = ['$timeout'];
  /* ng-inject */
  function setBusy($timeout) {

    return function (value, containerShow) {
      // Use timeout because sometimes the busy container doesn't show for longer than the animation time so it gets stuck in the wrong state
      $timeout(function () { containerShow.busy = value; }, 0);
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('dataloadfileChanged', dataloadfileChanged);

  dataloadfileChanged.$inject = ['$rootScope', 'MessageService', 'uploadFile', 'getFieldsFromFileData'];
  /* ng-inject */
  function dataloadfileChanged($rootScope, MessageService, uploadFile, getFieldsFromFileData) {

    return function ($event, selectedCard, containerShow, selectedStep, selectedTask, availableCards) {
      const reader = new FileReader();
      reader.onload = fileIsLoaded;
      let filename = $event.target.files[0].name;
      const splits = filename.split('.');

      if (splits.pop() !== 'csv') {
        MessageService.showMessage('Invalid file type. Please select a CSV.');
      } else {
        filename = splits.join('.');
        var cardId = selectedCard._id;
        selectedCard.name = filename;
        selectedCard.originalName = filename;
        selectedCard.description = 'File containing data for extraction';
        ++containerShow.uploading;
        containerShow.busy = true;
        reader.readAsDataURL($event.target.files[0]);

        $rootScope.$broadcast('card-removed');
        uploadFile($event, selectedCard, containerShow, selectedStep, selectedTask, availableCards, cardId, filename);
        $rootScope.$digest();
      }

      function fileIsLoaded(e) {
        containerShow.busy = false;
        selectedCard.fields = getFieldsFromFileData(e.target.result);
        // Reset so that file changed event is hit again even if the file is the same
        angular.element(document).find('#dataloadSpecialFile').val('');
      }
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('data')
    .service('selectDataload', selectDataload);

  selectDataload.$inject = [];
  /* ng-inject */
  function selectDataload() {

    return function (selectedCard, id, name) {
      selectedCard.name = name;
      selectedCard.description = 'Selected dataload';
      selectedCard.objectId = id;
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('data')
    .service('selectContact', selectContact);

  selectContact.$inject = [];
  /* ng-inject */
  function selectContact() {

    return function (selectedCard, id, firstname, lastname) {
      selectedCard.name = firstname + ' ' + lastname;
      selectedCard.description = 'Selected contact';
      selectedCard.objectId = id;
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('saveNewDataload', saveNewDataload);

  saveNewDataload.$inject = ['checkStepIsValid'];
  /* ng-inject */
  function saveNewDataload(checkStepIsValid) {

    return function (selectedTask, selectedStep, selectedCard, containerShow) {
      if (selectedStep.cards && !containerShow.busy) {
        let indexToRemove = -1;

        for (let i = 0; i < selectedStep.cards.length; i++) {
          if (selectedStep.cards[i]._id === selectedCard._id) {
            selectedStep.cards[i].name = selectedCard.name || selectedCard.originalName;
            selectedStep.cards[i].description = selectedCard.description;
            selectedStep.cards[i].fields = selectedCard.fields;
            selectedStep.cards[i].fileId = selectedCard.fileId;
            if (!selectedCard.fields) {
              indexToRemove = i;
            }
          }
        }

        if (indexToRemove > -1) {
          selectedStep.cards.splice(indexToRemove, 1);
        }
      }

      checkStepIsValid(selectedStep, selectedTask);
      containerShow.selectDataloadFile = false;
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('data')
    .service('saveInstanceValueCardSelection', saveInstanceValueCardSelection);

  saveInstanceValueCardSelection.$inject = ['checkStepIsValid'];
  /* ng-inject */
  function saveInstanceValueCardSelection(checkStepIsValid) {

    return function (selectedTask, selectedStep, selectedCard, containerShow) {
      if (selectedStep.cards) {
        let indexToRemove = -1;

        for (let i = 0; i < selectedStep.cards.length; i++) {
          if (selectedStep.cards[i]._id === selectedCard._id) {
            selectedStep.cards[i].name = selectedCard.name;
            selectedStep.cards[i].description = selectedCard.description;
            selectedStep.cards[i].objectId = selectedCard.objectId;
            if (!selectedCard.objectId) {
              indexToRemove = i;
            }
          }
        }

        if (indexToRemove > -1) {
          selectedStep.cards.splice(indexToRemove, 1);
        }
      }

      checkStepIsValid(selectedStep, selectedTask);
      containerShow.selectContact = false;
      containerShow.selectDataload = false;
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('data')
    .service('removeCardFromHand', removeCardFromHand);

  removeCardFromHand.$inject = ['checkStepIsValid', '$rootScope', 'SystemFieldsFactory'];
  /* ng-inject */
  function removeCardFromHand(checkStepIsValid, $rootScope, SystemFieldsFactory) {

    return function (selectedStep, selectedTask, availableCards, card) {
      for (let j = 0; j < selectedTask.steps.length; j++) {
        if (selectedTask.steps[j].cards) {

          for (let i = 0; i < selectedTask.steps[j].cards.length; i++) {
            if (selectedTask.steps[j].cards[i]._id === card._id) {
              selectedTask.steps[j].cards.splice(i, 1);
              break;
            }
          }
        }
      }


      for (let i = 0; i < selectedStep.cards.length; i++) {
        if (selectedStep.cards[i]._id === card._id) {
          selectedStep.cards.splice(i, 1);
          break;
        }
      }

      if (availableCards) {
        let shouldAdd = true;
        for (let k = 0; k < availableCards.length; k++) {
          if (availableCards[k]._id === card._id) {
            shouldAdd = false;
          }
        }

        if (shouldAdd) {
          availableCards.push(card);
        }
      }

      checkStepIsValid(selectedStep, selectedTask);
      $rootScope.$broadcast('card-removed');

      if (card){
        SystemFieldsFactory.invalidateCacheForCard(card);
      }
      
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('openMappingScreen', openMappingScreen);

  openMappingScreen.$inject = ['$q', 'SystemFieldsFactory', 'setBusy', 'setSelectedCard', 'attemptSystemAutoMap', 'highlightSelectedCardMappings', 'checkStepIsValid', 'catchError', 'uuidService'];
  /* ng-inject */
  function openMappingScreen($q, SystemFieldsFactory, setBusy, setSelectedCard, attemptSystemAutoMap, highlightSelectedCardMappings, checkStepIsValid, catchError, uuid) {

    return function (existingCard, cardType, containerShow, selectedStep, mappingSystems, selectedCard, selectedTask) {
      const promises = [];
      setBusy(true, containerShow);

      let card = existingCard;
      if (!existingCard) {
        card = {
          type: cardType,
          _id: uuid.getSingleNewBase64Key(),
          systemTypes: selectedStep.data,
          mappings: []
        };
      }

      promises.push(SystemFieldsFactory.getSystemFields(selectedStep.data.systemA, selectedTask, card));
      promises.push(SystemFieldsFactory.getSystemFields(selectedStep.data.systemB, selectedTask, card));
      $q.all(promises).then(function (result) {
        setBusy(false, containerShow);
        mappingSystems.systemA.length = 0;
        mappingSystems.systemA.push.apply(mappingSystems.systemA, result[0]);
        mappingSystems.systemB.length = 0;
        mappingSystems.systemB.push.apply(mappingSystems.systemB, result[1]);

        for (let i = 0; i < mappingSystems.systemB.length; i++) {
          if (mappingSystems.systemB[i].type !== 'redact'){
            mappingSystems.systemB[i].fields.push({ name: 'zuantautomap', friendly: 'Auto-map', automap: true, object: mappingSystems.systemB[i].name });
          }
        }

        if (!existingCard) {


          switch (cardType){
            case 'dedupemapping':
              card.name = 'Dedupe Mapping';
              card.description = 'Dedupe rules to match contacts';
              break;

            case 'redactionmapping':
              card.name = 'Redaction Mapping';
              card.description = 'Basic one-to-one mapping card for redaction';
              break;

            default:
              card.name = 'Field Mapping';
              card.description = 'Basic one-to-one mapping card for a data load';
              break;
          }

          selectedStep.cards.push(card);
          setSelectedCard(card, selectedCard);

          if (cardType === 'mapping' || cardType === 'redactionmapping') {
            attemptSystemAutoMap(mappingSystems, selectedCard);
          }

        } else {
          setSelectedCard(existingCard, selectedCard);
          highlightSelectedCardMappings(mappingSystems, selectedCard);
        }

        checkStepIsValid(selectedStep, selectedTask);
        containerShow.selectMapping = true;
      }).catch(catchError.bind(this, containerShow));
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('openDataloadScreen', openDataloadScreen);

  openDataloadScreen.$inject = ['uuidService', 'setSelectedCard', 'checkStepIsValid', 'catchError'];
  /* ng-inject */
  function openDataloadScreen(uuid, setSelectedCard, checkStepIsValid) {

    return function (existingCard, containerShow, selectedStep, selectedCard, selectedTask) {
      containerShow.selectDataload = true;
      selectedCard.searchResults = selectedCard.searchResults || [];
      selectedCard.searchResults.splice(0);
      selectedCard.filter = {
        name: '',
        startDate: '',
        endDate: '',
        ownerId: '',
        zubot: ''
      };

      if (!existingCard) {
        var card = {
          type: selectedStep.cardType,
          objectType: selectedStep.objectType,
          _id: uuid.getSingleNewBase64Key(),
          name: '',
          description: ''
        };
        selectedStep.cards.push(card);
        setSelectedCard(card, selectedCard);
      } else {
        setSelectedCard(existingCard, selectedCard);
      }

      checkStepIsValid(selectedStep, selectedTask);

    };
  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('openDataloadFileScreen', openDataloadFileScreen);

  openDataloadFileScreen.$inject = ['uuidService', 'setSelectedCard', 'checkStepIsValid', 'catchError'];
  /* ng-inject */
  function openDataloadFileScreen(uuid, setSelectedCard, checkStepIsValid) {

    return function (existingCard, containerShow, selectedStep, selectedCard, selectedTask) {
      containerShow.selectDataloadFile = true;

      if (!existingCard) {
        const card = {
          type: selectedStep.cardType,
          _id: uuid.getSingleNewBase64Key(),
          name: '',
          description: ''
        };
        selectedStep.cards.push(card);
        setSelectedCard(card, selectedCard);
      } else {
        setSelectedCard(existingCard, selectedCard);
      }

      checkStepIsValid(selectedStep, selectedTask);
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('data')
    .service('openContactScreen', openContactScreen);

  openContactScreen.$inject = ['APIService', 'setBusy', 'setSelectedCard', 'checkStepIsValid', 'catchError'];
  /* ng-inject */
  function openContactScreen(APIService, setBusy, setSelectedCard, checkStepIsValid, catchError) {

    return function (existingCard, containerShow, selectedStep, selectedCard, selectedTask, newContactFieldFilter) {
      containerShow.selectContact = true;
      selectedCard.searchResults = selectedCard.searchResults || [];
      selectedCard.searchResults.splice(0);
      setBusy(true, containerShow);
      const fields = [newContactFieldFilter.field];

      APIService.getFromDataApi('systems?type=vault').then(function (result) {
        setBusy(false, containerShow);

        if (result.data.success) {
          selectedCard.filters = selectedCard.filters || [];
          selectedCard.filters.splice(0);

          selectedStep.operators = ['is equal to', 'contains'];

          for (let i = 0; i < result.data.systems.length; i++) {
            for (let j = 0; j < result.data.systems[i].fields.length; j++) {
              const obj = { name: result.data.systems[i].fields[j].name, friendly: result.data.systems[i].fields[j].object.toUpperCase() + ' - ' + result.data.systems[i].fields[j].friendly, object: result.data.systems[i].fields[j].object };
              switch (obj.name) {
                case 'firstname':
                case 'lastname':
                case 'email':
                  selectedCard.filters.push({ field: obj, operator: 'is equal to', value: '' });
                  break;
              }
              fields.push(obj);
            }
          }
        }

        selectedStep.fields = fields;

        if (!existingCard) {
          const card = {
            type: selectedStep.cardType,
            objectType: selectedStep.objectType,
            _id: selectedStep.cards ? selectedStep.cards.length + 1 : 1,
            name: '',
            description: ''
          };
          selectedStep.cards.push(card);
          setSelectedCard(card, selectedCard);
        } else {
          setSelectedCard(existingCard, selectedCard);
        }

        checkStepIsValid(selectedStep, selectedTask);
        containerShow.selectContact = true;
      }).catch(catchError.bind(this, containerShow));
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('openCardSelection', openCardSelection);

  openCardSelection.$inject = ['APIService', 'showNotificationModal', 'setBusy', 'catchError', 'openMappingScreen', 'openContactScreen', 'openDataloadScreen', 'openDataloadFileScreen'];
  /* ng-inject */
  function openCardSelection(APIService, showNotificationModal, setBusy, catchError, openMappingScreen, openContactScreen, openDataloadScreen, openDataloadFileScreen) {

    return function (existingCard, selectedStep, containerShow, availableCards, mappingSystems, selectedCard, selectedTask, newContactFieldFilter, $cb) {
      if (containerShow.zubotActivated) {
        return;
      }

      if (selectedStep.fetchCards !== false) {
        if (selectedStep.cardType === 'notification') {
          showNotificationModal();
        } else {
          setBusy(true, containerShow);
          APIService.getFromDataApi('cards?type=' + selectedStep.cardType).then(function (result) {
            setBusy(false, containerShow);
            containerShow.selectCard = true;
            availableCards.length = 0;

            availableCards.push.apply(availableCards, result.data.cards);

            for (let i = 0; i < selectedStep.cards.length; i++) {
              for (let j = 0; j < availableCards.length; j++) {
                if (selectedStep.cards[i]._id === availableCards[j]._id) {
                  availableCards.splice(j, 1);
                  break;
                }
              }
            }
          }).catch(catchError.bind(this, containerShow));
        }
      } else {
        switch (selectedStep.cardType) {
          case 'file':
            if (selectedTask.mission.type === 'dataload') {
              openDataloadFileScreen(existingCard, containerShow, selectedStep, selectedCard, selectedTask);
            } else {
              angular.element(document).find('#workflowFileInput').click();
            }
            break;
          case 'instanceReference':
            switch (selectedStep.objectType) {
              case 'contact':
                openContactScreen(existingCard, containerShow, selectedStep, selectedCard, selectedTask, newContactFieldFilter);
                break;
              case 'dataload':
                openDataloadScreen(existingCard, containerShow, selectedStep, selectedCard, selectedTask);
                break;
            }
            break;
          case 'mapping':
          case 'redactionmapping':
          case 'dedupemapping':
            openMappingScreen(existingCard, selectedStep.cardType, containerShow, selectedStep, mappingSystems, selectedCard, selectedTask);
            break;
        }
      }

      if ($cb) $cb();
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('isBeforeSelectedStep', isBeforeSelectedStep);

  isBeforeSelectedStep.$inject = [];
  /* ng-inject */
  function isBeforeSelectedStep() {

    return function (step, selectedStep, selectedTask) {
      let selectedStepIndex = 0;
      let stepIndex = 0;

      for (let i = 0; i < selectedTask.steps.length; i++) {
        if (selectedTask.steps[i].title === step.title) {
          stepIndex = i;
        }
        if (selectedTask.steps[i].title === selectedStep.title) {
          selectedStepIndex = i;
        }
      }

      if (stepIndex < selectedStepIndex) {
        return true;
      }
      return false;
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('highlightSelectedCardMappings', highlightSelectedCardMappings);

  highlightSelectedCardMappings.$inject = [];
  /* ng-inject */
  function highlightSelectedCardMappings() {

    return function (mappingSystems, selectedCard) {

      for (let j = 0; j < mappingSystems.systemA.length; j++) {
        for (let k = 0; k < mappingSystems.systemA[j].fields.length; k++) {
          mappingSystems.systemA[j].fields[k].selected = false;

          for (let i = 0; i < selectedCard.mappings.length; i++) {
            const systemA = selectedCard.mappings[i].systemA[0];
            if (systemA && mappingSystems.systemA[j].fields[k] && systemA.name === mappingSystems.systemA[j].fields[k].name && systemA.object === mappingSystems.systemA[j].fields[k].object) {
              mappingSystems.systemA[j].fields[k].selected = true;
            }
          }
        }
      }

      for (let j = 0; j < mappingSystems.systemB.length; j++) {
        for (let m = 0; m < mappingSystems.systemB[j].fields.length; m++) {
          mappingSystems.systemB[j].fields[m].selected = false;

          for (let n = 0; n < selectedCard.mappings.length; n++) {
            const systemB = selectedCard.mappings[n].systemB[0];
            if (systemB && mappingSystems.systemB[j].fields[m] && systemB.name === mappingSystems.systemB[j].fields[m].name && systemB.name !=='zuantaddcustomfield' && systemB.object === mappingSystems.systemB[j].fields[m].object) {
              mappingSystems.systemB[j].fields[m].selected = true;
            }
          }
        }
      }
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('getStepClass', getStepClass);

  getStepClass.$inject = ['isBeforeSelectedStep'];
  /* ng-inject */
  function getStepClass(isBeforeSelectedStep) {

    return function (step, selectedStep, selectedTask) {
      var css = '';

      if (step && selectedStep.title === step.title) {
        css += ' active';
      }

      if (step && step.colour) {
        css += ' ' + step.colour;
      }

      if (step && step.valid && isBeforeSelectedStep(step, selectedStep, selectedTask)) {
        css += ' valid';
      }

      return css;
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('getFieldsFromFileData', getFieldsFromFileData);

  getFieldsFromFileData.$inject = [];
  /* ng-inject */
  function getFieldsFromFileData() {

    return function (data) {
      const fields = [];
      const plainTextData = atob(data.split(';base64,')[1]);
      let lineDelimiter = '\n';
      if (plainTextData.indexOf(lineDelimiter) == -1) {
        lineDelimiter = '\r';
      }
      if (plainTextData.indexOf('\r\n') > -1) {
        lineDelimiter = '\r\n';
      }

      const lines = plainTextData.replace('ï»¿', '').split(lineDelimiter);
      const rawFields = lines[0].match(/("[^"]*")|[^,]+/g) || [];

      for (let k = 0; k < rawFields.length; k++) {
        let found = false;
        const strippedField = rawFields[k].replace(/"/g, '');

        for (let f = 0; f < fields.length; f++) {
          if (fields[f].name === strippedField) {
            found = true;
          }
        }

        if (!found && strippedField.length > 0) {
          fields.push({ name: strippedField, friendly: strippedField });
        }
      }
      return fields;
    };

  }

}());

(function () {
  'use strict';
  
  angular
    .module('data')
    .service('generateZubotOutfit', generateZubotOutfit);
  
  generateZubotOutfit.$inject = ['zubotOutfitsFactory'];
  /* ng-inject */
  function generateZubotOutfit(zubotOutfitsFactory) {

    return function () {
      return {
        bodyColor: zubotOutfitsFactory.bodyColors[Math.floor(Math.random() * Math.floor(zubotOutfitsFactory.bodyColors.length))],
        bodyBackColor: zubotOutfitsFactory.bodyBackColors[Math.floor(Math.random() * Math.floor(zubotOutfitsFactory.bodyBackColors.length))],
        verticalColor: zubotOutfitsFactory.verticalColors[Math.floor(Math.random() * Math.floor(zubotOutfitsFactory.verticalColors.length))],
        eyeColor: zubotOutfitsFactory.eyeColors[Math.floor(Math.random() * Math.floor(zubotOutfitsFactory.eyeColors.length))],
        eyeHighlightColor: zubotOutfitsFactory.eyeHighlightColors[Math.floor(Math.random() * Math.floor(zubotOutfitsFactory.eyeHighlightColors.length))],
        zedColor: zubotOutfitsFactory.zedColors[Math.floor(Math.random() * Math.floor(zubotOutfitsFactory.zedColors.length))]
      };
    };
  
  }
  
}());
  
(function () {
  'use strict';

  angular
    .module('data')
    .service('generateZubotName', generateZubotName);

  generateZubotName.$inject = ['zubotNamesFactory', 'stringHelper'];
  /* ng-inject */
  function generateZubotName(zubotNamesFactory, stringHelper) {

    return function () {
      return zubotNamesFactory.names[Math.floor(Math.random() * zubotNamesFactory.names.length)] +
        stringHelper.getRandomInt().toString() + stringHelper.getRandomInt().toString() +
        stringHelper.getRandomInt().toString();
    };

  }

}());

(function () {
  'use strict';
    
  angular
    .module('data')
    .service('generateZubot', generateZubot);
    
  generateZubot.$inject = ['generateZubotOutfit', 'generateZubotName'];
  /* ng-inject */
  function generateZubot(generateZubotOutfit, generateZubotName) {
  
    return function (task) {
      var zubotName = generateZubotName();
      var zubotOutfit = generateZubotOutfit();
      if (task) {
        if (task.zubot && task.zubot.indexOf('(') > -1) {
          var idx = task.zubot.indexOf('(') + 1;
          var i = parseInt(task.zubot[idx]);
          zubotName = task.zubot.substr(0, idx) + ++i + task.zubot[idx + 1];
        }
      }

      task.zubot = zubotName;
      task.outfit = zubotOutfit;

      return {
        name: zubotName,
        outfit: zubotOutfit
      };
    };
    
  }
    
}());
    
(function () {
  'use strict';

  angular
    .module('data')
    .service('findCardsInTask', findCardsInTask);

  findCardsInTask.$inject = [];
  /* ng-inject */
  function findCardsInTask() {

    return function (cardType, selectedTask) {
      const cards = [];

      for (let i = 0; i < selectedTask.steps.length; i ++) {
        if (selectedTask.steps[i].cardType === cardType) {
          cards.push.apply(cards, selectedTask.steps[i].cards);
        }
      }

      return cards;
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('dataloadSearchChanged', dataloadSearchChanged);

  dataloadSearchChanged.$inject = ['APIService', 'catchError', '$timeout'];
  /* ng-inject */
  function dataloadSearchChanged(APIService, catchError, $timeout) {
    var t;

    return function (selectedStep, selectedCard, containerShow, text) {
      containerShow.contactSearchBusy = true;
      text.contactSearchText = 'Waiting for search criteria';

      const callApi = function () {
        text.contactSearchText = 'Searching...';

        APIService.postToDataApi('dataloads/search', { filter: selectedCard.filter }).then(function (result) {
          if (result.data.success) {
            selectedCard.searchResults = selectedCard.searchResults || [];
            selectedCard.searchResults.splice(0);
            for (const searchResult of result.data.searchResults) {
              let canSelect = true;
              for (const card of selectedStep.cards) {
                if (card.objectId === searchResult._id) {
                  canSelect = false;
                }
              }
              if (canSelect) {
                selectedCard.searchResults.push(searchResult);
              }
            }
            containerShow.contactSearchBusy = false;
            text.contactSearchText = 'Please refine your search criteria as not all dataloads are displayed';
          }
        }).catch(catchError.bind(this, containerShow));
      };

      if (t) {
        $timeout.cancel(t);
        t = null;
      }

      t = $timeout(callApi, 500);
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('contactSearchChanged', contactSearchChanged);

  contactSearchChanged.$inject = ['APIService', 'catchError', '$timeout'];
  /* ng-inject */
  function contactSearchChanged(APIService, catchError, $timeout) {
    var t;

    return function (selectedStep, selectedCard, containerShow, text) {
      containerShow.contactSearchBusy = true;
      text.contactSearchText = 'Waiting for search criteria';

      var callApi = function () {
        text.contactSearchText = 'Searching...';
        const filters = [];

        for (let i = 0; i < selectedCard.filters.length; i++) {
          var f = selectedCard.filters[i];
          filters.push({ name: f.field.name, object: f.field.object, operator: f.operator, value: f.value });
        }

        APIService.postToDataApi('contactSearch', { filters: filters }).then(function (result) {
          if (result.data.success) {
            selectedCard.searchResults = selectedCard.searchResults || [];
            selectedCard.searchResults.splice(0);
            for (const searchResult of result.data.searchResults) {
              let canSelect = true;
              for (const card of selectedStep.cards) {
                if (card.objectId === searchResult._id) {
                  canSelect = false;
                }
              }
              if (canSelect) {
                selectedCard.searchResults.push(searchResult);
              }
            }
            containerShow.contactSearchBusy = false;
            text.contactSearchText = 'Please refine your search criteria as not all contacts are displayed';
          }
        }).catch(catchError.bind(this, containerShow));
      };

      if (t) {
        $timeout.cancel(t);
        t = null;
      }

      t = $timeout(callApi, 500);
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('checkStepIsValid', checkStepIsValid);

  checkStepIsValid.$inject = [];
  /* ng-inject */
  function checkStepIsValid() {

    return function (step, selectedTask) {
      let isValid = false;
      if ((!step.cards && step.cardOptional) || (step.cards && step.cards.length === 0 && step.cardOptional)) {
        isValid = true;
      } else if (step.validation && step.validation.length > 0) {
        let validationRulesPass = true;

        validationLoop:
        for (let i = 0; i < step.validation.length; i++) {
          if (step.cards) {
            let count = 0;
            for (let j = 0; j < step.cards.length; j++) {
              if (!step.validation[i].group || step.cards[j].group === step.validation[i].group) {
                ++count;
              }
            }

            if (step.validation[i].condition) {
              for (let j = 0; j < selectedTask.steps.length; j++) {
                if (selectedTask.steps[j].cardType === step.validation[i].condition.cardType) {
                  let exceptionPassed = true;

                  if (step.validation[i].exception) {
                    exceptionLoop:
                    for (let k = 0; k < selectedTask.steps[j].cards.length; k++) {
                      for (let l = 0; l < step.validation[i].exception.length; l++) {
                        if (selectedTask.steps[j].cards[k].description === step.validation[i].exception[l].description) {
                          exceptionPassed = false;
                          break exceptionLoop;
                        }
                      }
                    }
                  }

                  if (step.validation[i].conflict) {
                    let hasConflictCard = false;
                    let hasConditionCard = false;
                    for (let l = 0; l < step.cards.length; l++) {
                      if (step.cards[l].description === step.validation[i].conflict.description) {
                        hasConflictCard = true;
                      }
                      if (step.cards[l].description === step.validation[i].condition.description) {
                        hasConditionCard = true;
                      }
                    }

                    if (hasConflictCard && hasConditionCard) {
                      validationRulesPass = false;
                      step.displayMessage = step.validation[i].failMessage;
                      break validationLoop;
                    }
                  }

                  if (exceptionPassed) {
                    for (let k = 0; k < selectedTask.steps[j].cards.length; k++) {
                      if (selectedTask.steps[j].cards[k].description === step.validation[i].condition.description) {
                        if ((count === 0 && step.validation[i].required) || (step.validation[i].maxAmount !== undefined && step.validation[i].maxAmount < count)) {
                          validationRulesPass = false;
                          step.displayMessage = step.validation[i].failMessage;
                          break validationLoop;
                        }
                      }
                    }
                  }
                }
              }
            } else if ((count === 0 && step.validation[i].required) || (step.validation[i].maxAmount !== undefined && step.validation[i].maxAmount < count)) {
              validationRulesPass = false;
              step.displayMessage = step.validation[i].failMessage;
              break validationLoop;
            }
          }
        }
        isValid = validationRulesPass;
      } else if (step.cards && step.cards.length > 0) {
        switch (step.cardType) {
          case 'instanceReference':{
            let allCardsHaveInstance = true;

            for (let m = 0; m < step.cards.length; m++) {
              if (!step.cards[m].objectId || step.cards[m].objectId === '') {
                allCardsHaveInstance = false;
                break;
              }
            }

            if (allCardsHaveInstance) {
              isValid = true;
            } else {
              step.displayMessage = 'The selected cards need an instance value';
            }
            break;
          }
          default:
            isValid = true;
            break;
        }
      } else {
        step.displayMessage = 'A card is required for this step';
      }

      if (isValid) {
        step.displayMessage = '';
      }

      step.valid = isValid;
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('checkAndUpdateAutomapFields', checkAndUpdateAutomapFields);

  checkAndUpdateAutomapFields.$inject = [];
  /* ng-inject */
  function checkAndUpdateAutomapFields() {

    return function (selectedCard) {
      let success = true;

      for (let i = 0; i < selectedCard.mappings.length; i++) {
        const systemA = selectedCard.mappings[i].systemA[0];
        const systemB = selectedCard.mappings[i].systemB[0];
        if (systemB && systemB.automap) {
          if (systemA && systemA.name) {
            systemB.automap = false;
            systemB.name = systemA.name;
            systemB.friendly = systemA.friendly;
          } else {
            success = false;
          }
        }
      }
      return success;
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('catchError', catchError);

  catchError.$inject = ['setBusy', 'MessageService'];
  /* ng-inject */
  function catchError(setBusy, MessageService) {

    return function (containerShow, message) {
      setBusy(false, containerShow);
      MessageService.showMessage(message || 'An error occured trying to contact the server. Please try again later.');
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('attemptSystemAutoMap', attemptSystemAutoMap);

  attemptSystemAutoMap.$inject = ['highlightSelectedCardMappings'];
  /* ng-inject */
  function attemptSystemAutoMap(highlightSelectedCardMappings) {

    return function (mappingSystems, selectedCard) {

      if (selectedCard.type === 'redactionmapping'){
        const redactionContactSchema = ['firstname', 'lastname', 'email', 'phone', 'mobile', 'address1', 'address2', 'address3', 'city', 'zipcode'];
        const redactionFieldIndex = _.findIndex(mappingSystems.systemB[0].fields, function (field){
          return field.name === 'redact';
        });

        const unsetImagesSchema = ['images', 'bizcards'];
        const unsetFieldIndex = _.findIndex(mappingSystems.systemB[1].fields, function (field){
          return field.name === 'unset';
        });

        for (let i = 0; i < mappingSystems.systemA.length; i++) {
          for (let j = 0; j < mappingSystems.systemA[i].fields.length; j++) {

            if (mappingSystems.systemA[i].fields[j].object === 'contact' && redactionContactSchema.indexOf(mappingSystems.systemA[i].fields[j].name) > -1){
              selectedCard.mappings.push({
                systemA: [mappingSystems.systemA[i].fields[j]],
                systemB: [mappingSystems.systemB[0].fields[redactionFieldIndex]]
              });
            } else if (mappingSystems.systemA[i].name === 'images' && unsetImagesSchema.indexOf(mappingSystems.systemA[i].fields[j].name) > -1){
              selectedCard.mappings.push({
                systemA: [mappingSystems.systemA[i].fields[j]],
                systemB: [mappingSystems.systemB[1].fields[unsetFieldIndex]]
              });
            }
          }
        }
      }

      if (selectedCard.type === 'mapping'){
        for (let i = 0; i < mappingSystems.systemA.length; i++) {

          for (let j = 0; j < mappingSystems.systemB.length; j++) {

            for (let k = 0; k < mappingSystems.systemA[i].fields.length; k++) {
            
              for (let l = 0; l < mappingSystems.systemB[j].fields.length; l++) {
                if (selectedCard.type === 'mapping' && mappingSystems.systemA[i].fields[k].name.replace(/ /g,'').toLowerCase() === mappingSystems.systemB[j].fields[l].name.replace(/ /g,'').toLowerCase()) {
                  selectedCard.mappings.push({
                    systemA: [mappingSystems.systemA[i].fields[k]],
                    systemB: [mappingSystems.systemB[j].fields[l]]
                  });
                }
              }
            }
          }
        }
      }

      highlightSelectedCardMappings(mappingSystems, selectedCard);
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('applyFieldMappingDragDropChange', applyFieldMappingDragDropChange);

  applyFieldMappingDragDropChange.$inject = ['$timeout', 'MessageService', 'checkAndUpdateAutomapFields', 'highlightSelectedCardMappings'];
  /* ng-inject */
  function applyFieldMappingDragDropChange($timeout, MessageService, checkAndUpdateAutomapFields, highlightSelectedCardMappings) {

    const displayError = (model)  => {
      MessageService.showMessage('The ' + model.friendly + ' field needs to be mapped to something. You can\'t add a new row with it!');
    };

    return function (e, ui, selectedCard, mappingSystems) {
      if (ui.item.sortable.isCanceled()) return;
      if (ui.item.sortable.source[0] === ui.item.sortable.droptarget[0]) {
        ui.item.sortable.cancel();
        return;
      }

      const newRowDrop = angular.element(ui.item.sortable.droptarget[0]).hasClass('drop-container');
      let model = ui.item.sortable.model;

      if (!ui.item.sortable.received && !newRowDrop) {
        const backup = Object.assign({}, ui.item.sortable.droptargetModel[0]);
        ui.item.sortable.droptargetModel.length = 0;
        if (ui.item.sortable.model.automap) {
          model = Object.assign({}, model);
        }
        ui.item.sortable.droptargetModel.push(model);
        if (!checkAndUpdateAutomapFields(selectedCard)) {
          displayError(model);
          ui.item.sortable.droptargetModel.length = 0;
          ui.item.sortable.droptargetModel.push(backup);
        }
        highlightSelectedCardMappings(mappingSystems, selectedCard);
        ui.item.sortable.cancel();

      } else if (!ui.item.sortable.received && newRowDrop) {
        const systemA = [];
        const systemB = [];

        if (ui.item.sortable.model.automap) {
          model = Object.assign({}, model);
        }

        if (angular.element(ui.item.sortable.source[0]).hasClass('systema') && ui.item.sortable.droptargetModel.length !== 0 && ui.item.sortable.droptargetModel[ui.item.sortable.droptargetModel.length-1].systemA.length === 0) {
          ui.item.sortable.droptargetModel[ui.item.sortable.droptargetModel.length-1].systemA.push(model);
          checkAndUpdateAutomapFields(selectedCard);
        } else if (angular.element(ui.item.sortable.source[0]).hasClass('systemb') && ui.item.sortable.droptargetModel.length !== 0 && ui.item.sortable.droptargetModel[ui.item.sortable.droptargetModel.length-1].systemB.length === 0) {
          ui.item.sortable.droptargetModel[ui.item.sortable.droptargetModel.length-1].systemB.push(model);
          checkAndUpdateAutomapFields(selectedCard);
        } else if (!ui.item.sortable.model.automap) {
          if (angular.element(ui.item.sortable.source[0]).hasClass('systema')) {
            systemA.push(ui.item.sortable.model);
          } else {
            systemB.push(ui.item.sortable.model);
          }
          ui.item.sortable.droptargetModel.push({ systemA: systemA, systemB: systemB});
          selectedCard.description = selectedCard.mappings.length  + ' fields currently mapped';
        } else {
          displayError(ui.item.sortable);
        }

        ui.item.sortable.cancel();

        $timeout(function () {
          angular.element('.card-content').scrollTop(angular.element('.card-content').height());
          highlightSelectedCardMappings(mappingSystems, selectedCard);
        }, 0);
      }
    };

  }

}());

(function () {
  'use strict';

  angular
    .module('data')
    .service('activateZubot', activateZubot);

  activateZubot.$inject = ['APIService', 'MessageService', 'SystemFieldsFactory'];
  /* ng-inject */
  function activateZubot(APIService, MessageService, SystemFieldsFactory) {

    return function (dryrun, selectedTask) {
      return APIService.postToDataApi('activateZubot', selectedTask)
        .then(function (result) {
          if (result.data && result.data.success) {
            try {
              MessageService.pushEventToIntercom('activated_zubot', {
                zubot: selectedTask.zubot,
                task: selectedTask.mission.type,
                subtype: selectedTask.mission.subType,
                dryrun: dryrun
              });
            } catch (e) {
              MessageService.writeLog({
                level: 'error',
                msg: e,
                tags: ['activate_zubot', 'push_event_to_intercom_error']
              });
            }
          }

          SystemFieldsFactory.invalidateCache();

          return result;
        }).catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: 'Error activating zubot' + JSON.stringify(err),
            tags: ['activate_zubot']
          });
          throw err;
        });
      
    };

  }

}());

/**
 * Created by davidbeazer on 18/08/2016.
 */
/**
 * The main dashboard for accessing the various Zuant portal tools
 * @module dashboard
 */

(function() {
  'use strict';

  angular
    .module('dashboard', [
      'common',
      'zp.auth',
      'ui.router'
    ]);
})();

/**
 * Created by davidbeazer on 24/08/2016.
 */
(function () {
  'use strict';

  angular
    .module('dashboard')
    .component('zpDashboardPage', {
      controller: 'DashboardController',
      templateUrl: 'app/dashboard/dashboard-page-component/dashboard.tmpl.html',
      bindings: {
        stateParams: '<'
      }
    })
    .controller('DashboardController', DashboardController);

  DashboardController.$inject = ['$scope', 'ZPPages', 'SessionService', 'MessageService', 'UserGreetingService', '$timeout', 'MasterPermissionsDefinitionFactory', '$state', 'localStorageService', 'CloudAppThemeFactory', '$window', 'hotkeys', '$mdSidenav', 'CurrentClientModelFactory', 'AWS_STORAGE_REGION', 'AWS_STORAGE_BUCKET_NAME', '$filter'];
  /* ng-inject*/
  function DashboardController($scope, zpPages, SessionService, MessageService, UserGreetingService, $timeout, MasterPermissionsDefinitionFactory, $state, localStorageService, CloudAppThemeFactory, $window, hotkeys, $mdSidenav, CurrentClientModelFactory, awsStorageRegion, awsStorageBucketName, $filter) {

    var vm = this;
    vm.loading = true;
    vm.useDefaultBackground = true;
    vm.useDefaultLogo = true;
    vm.clientDoc = CurrentClientModelFactory.getCurrentClientCache();

    vm.$onInit = function () {
      vm.clientLogoImage = buildLogoSrcString();

      const pageReload = localStorageService.get('reloadPage');
      if (pageReload) {
        if (pageReload.required) {
          $timeout(function () {
            localStorageService.set('reloadPage', {
              required: false
            });
            $window.location.reload();
          }, 500);
        }
      }

      vm.customSkinStyling = {
        'background-image': 'url("' + $filter('cdnAssets')('/images/jpgs/dashboard-background/background_1068.jpg') + '")',
        'background-position': 'center'
      };

      vm.permissions = MasterPermissionsDefinitionFactory;
      vm.userData = SessionService.getUserData();
      vm.userGreeting = UserGreetingService.getGreeting(vm.userData.firstname);
      vm.showGreeting = UserGreetingService.getDisplayUserGreeting();

      $scope.$on('zp.user_data.updated', function() {
        vm.userData = SessionService.getUserData();
      });


      if (!vm.showGreeting) {
        vm.loading = false;
      } else {
        $timeout(function () {
          vm.loading = false;
        }, 2000);
      }

      vm.primaryNavItems = zpPages.getPrimaryNavItems();
      vm.secondaryNavItems = zpPages.getSecondaryNavItems();
      vm.zuantFillColour = '#fff';
      vm.cloudFillColour = '#A37778';

      customSkinCheck();
      resizeBGImageWithWindow();

      hotkeys.add({
        combo: 'shift+left',
        description: 'Show / hide dev menu',
        callback: function () {
          vm.showDevSideNav();
        }
      });

      MessageService.writeLog({
        level: 'info',
        msg: 'User on dashboard page, they are currently managing: ' + vm.userData.databasename,
        tags: ['navigation']
      });

    };

    $scope.$on('$destroy', function () {
      angular.element($window).off('resize');
    });

    $scope.$watch('$viewContentLoaded', function () {

      $timeout(function (){
        resizeBGImageWithWindow();
        angular.element($window).on('resize', resizeBGImageWithWindow);
      }, 100);
    });

    vm.go = function (item) {
      $state.go(item.sref, item.srefObj);
    };

    vm.redirect = function (href) {
      $window.location = href;
    };

    vm.$onDestroy = function () {
      UserGreetingService.setDisplayUserGreeting(false);
    };

    function customSkinCheck() {
      if (!CloudAppThemeFactory.factoryData.skinCurrentlyEnabled) return;

      const userData = SessionService.getUserData();
      vm.clientLogoImage = buildLogoSrcString();

      const img = localStorageService.get('cloudDashboardBackgroundImage_' + SessionService.getUserData().databasename);
      if (!img || (!img.weburi && !img._s3key) || !userData.accountPermissions.boltOns.customSkins.enabled) {
        // no cloud image found so set default one
        vm.customSkinStyling = {
          'background-image': 'url("' + $filter('cdnAssets')('/images/jpgs/dashboard-background/background_1068.jpg') + '")',
          'background-position': 'center'
        };
        vm.useDefaultBackground = true;

        return;
      }

      vm.useDefaultBackground = false;
      vm.cloudDashboardBackgroundImage = img.weburi;

      if (img._s3key) {
        vm.cloudDashboardBackgroundImage = 'https://s3.' + awsStorageRegion + '.amazonaws.com/' + awsStorageBucketName + '/' + img._s3key;
      }

      vm.customSkinStyling = {
        'background-image': 'url(' + vm.cloudDashboardBackgroundImage + ')',
        'background-position': 'top'
      };

    }

    vm.showDevSideNav = function () {
      $mdSidenav('settingsPanel')
        .toggle();
    };

    function buildLogoSrcString() {
      vm.useDefaultLogo = false;
      if (vm.clientDoc.clientLogoImage && vm.clientDoc.clientLogoImage._s3key) {
        return `https://s3.${awsStorageRegion}.amazonaws.com/${awsStorageBucketName}/${vm.clientDoc.clientLogoImage._s3key}?timestamp=${vm.clientDoc.clientLogoImage._lastmodifiedonservertime}`;
      } else if (vm.clientDoc.clientLogoImage && vm.clientDoc.clientLogoImage.base64) {
        return 'data:image/jpeg;base64,' + vm.clientDoc.clientLogoImage.base64;
      } else {
        vm.useDefaultLogo = true;
        return $filter('cdnAssets')('/images/svgs/logos/zuant/ZUANT_CLOUD_ACCENT.svg');
      }
    }

    function resizeBGImageWithWindow(){
      const devicePixelRatio = window.devicePixelRatio;
      const background = angular.element(document).find('#dashboard')[0];
  
      let backgroundImageAssetUrl = '/images/jpgs/dashboard-background/background_1068.jpg';
  
      if (background && vm.useDefaultBackground){
        const clientWidth = background.clientWidth;

        if (clientWidth < 320){
          if (devicePixelRatio === 2){
            backgroundImageAssetUrl = '/images/jpgs/dashboard-background/background_800.jpg';
          } else {
            backgroundImageAssetUrl = '/images/jpgs/dashboard-background/background_500.jpg';
          }
        } else if (clientWidth > 320 && clientWidth < 538){
          if (devicePixelRatio === 2){
            backgroundImageAssetUrl = '/images/jpgs/dashboard-background/background_1068.jpg';
          } else {
            backgroundImageAssetUrl = '/images/jpgs/dashboard-background/background_800.jpg';
          }
        } else if (clientWidth > 538 && clientWidth < 1080){
          if (devicePixelRatio === 2){
            backgroundImageAssetUrl = '/images/jpgs/dashboard-background/background_2880.jpg';
          } else {
            backgroundImageAssetUrl = '/images/jpgs/dashboard-background/background_1068.jpg';
          }
        } else {
          backgroundImageAssetUrl = '/images/jpgs/dashboard-background/background_2880.jpg';
        }

        background.style.backgroundImage= 'url("' + $filter('cdnAssets')(backgroundImageAssetUrl) + '")';
      }
    
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('common')
    .factory('ZAMHelperFactory', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    var factoryData = {
      activityLog: []
    };
    return {
      factoryData: factoryData,
      addToActivityLog: addToActivityLog
    };

    function addToActivityLog(activity) {
      factoryData.activityLog.push(activity);
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zamHelper', {
      templateUrl: 'app/common/zam-helper/zam-helper.tmpl.html',
      controller: 'zamHelperCtrl'
    })
    .controller('zamHelperCtrl', ctrl);

  ctrl.$inject = ['ZAMHelperFactory'];
  /* ng-inject */
  function ctrl(ZAMHelperFactory) {
    var vm = this;

    vm.$onInit = function () {
      vm.data = ZAMHelperFactory.factoryData;
    };
  }

}());

'use strict';
/* eslint no-undef: 0 */
angular.module('zp.websocket', []);

(function () {
  'use strict';

  angular
    .module('zp.websocket')
    .service('WebSocketService', WebsocketService);

  WebsocketService.$inject = ['$rootScope', '$injector'];
  /* ng-inject */
  function WebsocketService($rootScope, $injector) {
    const service = this;
    service.connections = {};

    // Function to open a new WebSocket connection
    service.openConnection = function (url, props = { reconnect: true }) {
      const ws = new WebSocket(url);
      let heartBeatInterval;

      const WebSocketConnection = function (url, props, socket) {
        this.url = url;
        this.reconnect = props.reconnect;
        this.socket = socket;
        this.shouldIssueHeartbeat = true;
        this.heartBeatTimer = 60000;
        this.onHeartBeatEvent = null;
        this.onOpenEvent = null;
        this.onCloseEvent = null;
        this.onMessageEvent = null;
        this.onDisconnectEvent = null;
        this.messageQueue = [];
      };

      WebSocketConnection.prototype.onConnectionOpen = function (onOpenEvent) {
        this.onOpenEvent = onOpenEvent;
      };

      WebSocketConnection.prototype.onConnectionClosed = function (onCloseEvent) {
        this.onCloseEvent = onCloseEvent;
      };

      WebSocketConnection.prototype.onHeartBeat = function (onHeartBeatEvent) {
        this.onHeartBeatEvent = onHeartBeatEvent;
      };

      WebSocketConnection.prototype.onMessage = function (onMessageEvent) {
        this.onMessageEvent = onMessageEvent;
      };
  
      WebSocketConnection.prototype.sendMessage = function (message) {
        if (this.socket) {
          if (this.socket.readyState === WebSocket.OPEN){
            this.socket.send(message);
          } else {
            this.messageQueue ? this.messageQueue.push(message) : this.messageQueue = [message];
          }
        }
      };
  
      WebSocketConnection.prototype.closeConnection = function () {
        if (this.socket) {
          clearInterval(heartBeatInterval);
          this.socket.close();
          this.socket = null;
        }
      };

      if (service.connections[url] && (service.connections[url].socket.readyState === WebSocket.OPEN || service.connections[url].socket.readyState === WebSocket.CONNECTING)){
        return service.connections[url];
      } else if (service.connections[url]){
        service.connections[url].socket = ws;
      } else {
        service.connections[url] = new WebSocketConnection(url, props, ws);
      }

      ws.onopen = function () {
        if (service.connections[url].onOpenEvent && typeof service.connections[url].onOpenEvent === 'function') {
          service.connections[url].onOpenEvent();
        }

        if (service.connections[url].messageQueue && service.connections[url].messageQueue.length > 0){
          for (let i = 0; i < service.connections[url].messageQueue.length; i++){
            ws.send(service.connections[url].messageQueue[i]);
            service.connections[url].messageQueue.splice(i, 1);
          }
          delete service.connections[url].messageQueue;
        }

        setHeartbeat();

        $rootScope.$broadcast('zp.websocket.socketOpened', {
          connection: url
        });
      };

      function setHeartbeat(){
        clearInterval(heartBeatInterval);
        if (service.connections[url].socket.readyState === WebSocket.OPEN && service.connections[url].onHeartBeatEvent){
          heartBeatInterval = setInterval(service.connections[url].onHeartBeatEvent, service.connections[url].heartBeatTimer);
        }
      }

      ws.onmessage = function (event) {
        if (service.connections[url].onMessageEvent && typeof service.connections[url].onMessageEvent === 'function') {
          service.connections[url].onMessageEvent(event.data);
        }

        //resets it
        setHeartbeat();

        $rootScope.$broadcast('zp.websocket.messageRecieved', {
          connection: url,
          message: event.data,
        });
      };

      ws.onclose = function () {
        //prevents any more heartbeat attempt
        clearInterval(heartBeatInterval);

        if (service.connections[url].reconnect){
          setTimeout(function (){
            service.openConnection(url);
          }, 5000);
          return;
        }

        delete service.connections[url];

        if (service.connections[url].onCloseEvent && typeof service.connections[url].onCloseEvent === 'function') {
          service.connections[url].onCloseEvent();
        }

        $rootScope.$broadcast('zp.websocket.socketClosed', {
          connection: url
        });
      };

      ws.onerror = function (error) {
        const MessageService  = $injector.get('MessageService');
        MessageService.writeLog({
          level: 'error',
          msg: 'Websocket Error',
          err: error
        });
      };

      return service.connections[url];
    };

    // Function to send a message on a specific connection
    service.sendMessage = function (url, message) {
      if (service.connections[url]) {
        service.connections[url].send(message);
      }
    };

    // Function to close a specific connection
    service.closeConnection = function (url) {
      if (service.connections[url]) {
        service.connections[url].close();
      }
    };
  }
}());


(function () {
  'use strict';

  angular
    .module('common')
    .directive('visNetwork', visDirective);

  visDirective.$inject = [];
  /* @ngInject */
  
  function visDirective() {
    return {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=',
        options: '=',
        onInitialised: '<'
      },
      link: function($scope, $element, $attrs, ngModel) {
        const network = new vis.Network($element[0], $scope.ngModel, $scope.options || {});
        $scope.onInitialised(network);
      }

    };
  }

})();
(function () {
  'use strict';

  angular
    .module('common')
    .service('uuidService', uuidService);

  uuidService.$inject = ['$q', 'uuid', 'base64Service'];
  /* ng-inject */
  function uuidService($q, uuid, base64Service) {

    this.getSingleNewBase64Key = function() {
      const arr = new Array();
      const id = uuid.v1({}, arr, 0);
      return btoa(
        new Uint8Array(id)
          .reduce((data, byte) => data + String.fromCharCode(byte), '')
      );
    };
  

    this.getHashedId = function (){
      return new Promise((resolve) => {
        crypto.subtle.digest('SHA-512', new TextEncoder().encode(this.getSingleNewBase64Key())).then(buf => {
          const hash = Array.prototype.map.call(new Uint8Array(buf), x => (('00' + x.toString(16)).slice(-2))).join('');
          resolve(hash);
        });
      });
    };

    this.getHashedIdFromBase64Id = function (base64Str){
      return new Promise((resolve) => {
        crypto.subtle.digest('SHA-512', new TextEncoder().encode(base64Str)).then(buf => {
          const hash = Array.prototype.map.call(new Uint8Array(buf), x => (('00' + x.toString(16)).slice(-2))).join('');
          resolve(hash);
        });
      });
    };

    this.getArrayOfNewBase64Keys = function (numberOfKeysToGet) {

      var defer = $q.defer();

      var returnArray = [];

      for (var i = 0; i < numberOfKeysToGet; i++) {

        var buffer = [];
        uuid.v1({}, buffer);

        var base64String = base64Service.fromByteArray(buffer);

        returnArray.push(base64String);

      }

      //$log.info('uuidService has returnArray:'+JSON.stringify(returnArray));

      defer.resolve({
        'data': {
          'keys': returnArray
        }
      });

      return defer.promise;

    };

  }

}());

(function () {
  'use strict';

  angular
    .module('common')
    .service('stringHelper', stringHelperService);

  function stringHelperService() {

    this.removeControlChars = function (originalString) {
      return originalString.replace(/[\x00-\x1F\x7F-\x9F]/g, '');
    };

    this.clean = function (originalString) {
      return originalString.replace(/[\x00-\x1F\x7F-\x9F]/g, '').trim();
    };

    this.toTitleCase = function (str) {
      var words = str.split(' ');
      for (var i = 0; i < words.length; i++) {
        var j = words[i].charAt(0).toUpperCase();
        words[i] = j + words[i].substr(1);
      }
      return words.join(' ');
    };

    this.removeStrings = function (str, arr) {
      var i = 0;
      var len = arr.length;
      for (i; i < len; i++) {
        var expr = new RegExp(arr[i], 'gi');
        str = str.replace(expr, '');
      }
      return str;
    };

    this.hex2a = function (hexx) {
      var hex = hexx.toString(); //force conversion
      var str = '';
      for (var i = 0; i < hex.length; i += 2)
        str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
      return str;
    };

    this.getRandomInt = function () {
      return Math.floor(Math.random() * Math.floor(9));
    };

    this.convertDateToNeutralTimezone = function (str) {
      if (str.indexOf('Z') === -1) {
        return str.replace(' ', 'T') + 'Z';
      } else {
        return str;
      }
    };

    this.calcTimezoneOffset = function (formTimezone) {
      if (!formTimezone) formTimezone = '(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London';
      return formTimezone.substring(
        formTimezone.indexOf('(') + 1,
        formTimezone.indexOf(')')
      );
    };

    this.imageRegex = function() {
      return /(http(s?):)([/|.|\w|\s|-])*\.(?:jpe?g|gif|png|bmp)/g;
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('common')
    .factory('IsSubsetFactory', factory);

  factory.$inject = ['MessageService'];
  /* ng-inject */
  function factory(MessageService) {

    return {
      isSubset: isSubset
    };

    /**
     * Check if an object is contained within another object.
     *
     * Returns `true` if:
     * - all enumerable keys of *subset* are also enumerable in *superset*, and
     * - every value assigned to an enumerable key of *subset* strictly equals
     *   the value assigned to the same key of *superset* – or is a subset of it.
     *
     * @param  {Object}  superset
     * @param  {Object}  subset
     *
     * @returns  {Boolean}
     *
     * @module    is-subset
     * @function  default
     * @alias     isSubset
     */
    function isSubset(superset, subset) {
      if (
        (typeof superset !== 'object' || superset === null) ||
        (typeof subset !== 'object' || subset === null)
      ) {
        MessageService.writeLog({
          level: 'info',
          msg: 'user permissions are not a subset',
          tags: ['permissions', 'IsSubsetFactory']
        });
        return false;
      }

      // MEAT AND TATERS
      return Object.keys(subset).every(function (key) {
        
        if (!superset.propertyIsEnumerable(key)) return true;

        if (key === 'enabled') {
          if (superset[key] && !subset[key]) {
            return true;
          }
        }

        // arrays need each entry checked for presence of it in subset.
        if ((_.isArray(subset[key])) && (_.isArray(superset[key]))) {
          if (JSON.stringify(superset[key]) !== JSON.stringify(subset[key])) {
            /*
            at this point the subset and superset arrays are different.
            if there are items present in the subset that aren't found in supserset,
            then isSubset = false;
            */
            var diff = _.difference(subset[key], superset[key]);
            return diff.length === 0;
          }
        }

        var subsetItem = subset[key];
        var supersetItem = superset[key];
        if ((typeof subsetItem === 'object' && subsetItem !== null) ? !isSubset(supersetItem, subsetItem) : supersetItem !== subsetItem) {
          MessageService.writeLog({
            level: 'info',
            msg: 'user permission is not a subset. supersetItem: ' + JSON.stringify(supersetItem) + ', subsetItem:' + JSON.stringify(subsetItem),
            tags: ['permissions', 'IsSubsetFactory']
          });
          return false;
        }

        return true;
      });
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .service('base64Service', base64Service);

  function base64Service() {

    const exports = {
      byteLength: byteLength,
      toByteArray: toByteArray,
      fromByteArray: fromByteArray
    };

    const lookup = [];
    const revLookup = [];
    const Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

    const code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    for (let i = 0, len = code.length; i < len; ++i) {
      lookup[i] = code[i];
      revLookup[code.charCodeAt(i)] = i;
    }

    revLookup['-'.charCodeAt(0)] = 62;
    revLookup['_'.charCodeAt(0)] = 63;

    function placeHoldersCount(b64) {
      const len = b64.length;
      if (len % 4 > 0) {
        throw new Error('Invalid string. Length must be a multiple of 4');
      }

      // the number of equal signs (place holders)
      // if there are two placeholders, than the two characters before it
      // represent one byte
      // if there is only one, then the three characters before it represent 2 bytes
      // this is just a cheap hack to not do indexOf twice
      return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;
    }

    function byteLength(b64) {
      // base64 is 4/3 + up to two characters of the original data
      return (b64.length * 3 / 4) - placeHoldersCount(b64);
    }

    function toByteArray (b64) {
      let i, j, l, tmp, placeHolders, arr;
      const len = b64.length;
      placeHolders = placeHoldersCount(b64);

      arr = new Arr((len * 3 / 4) - placeHolders);

      // if there are placeholders, only get up to the last complete 4 chars
      l = placeHolders > 0 ? len - 4 : len;

      let L = 0;

      for (i = 0, j = 0; i < l; i += 4, j += 3) {
        tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
        arr[L++] = (tmp >> 16) & 0xFF;
        arr[L++] = (tmp >> 8) & 0xFF;
        arr[L++] = tmp & 0xFF;
      }

      if (placeHolders === 2) {
        tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
        arr[L++] = tmp & 0xFF;
      } else if (placeHolders === 1) {
        tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
        arr[L++] = (tmp >> 8) & 0xFF;
        arr[L++] = tmp & 0xFF;
      }

      return arr;
    }

    function tripletToBase64(num) {
      return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
    }

    function encodeChunk(uint8, start, end) {
      let tmp;
      const output = [];
      for (let i = start; i < end; i += 3) {
        tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
        output.push(tripletToBase64(tmp));
      }
      return output.join('');
    }

    function fromByteArray (uint8) {
      let tmp;
      const len = uint8.length;
      const extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
      let output = '';
      const parts = [];
      const maxChunkLength = 16383; // must be multiple of 3

      // go through the array every three bytes, we'll deal with trailing stuff later
      for (let i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
        parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
      }

      // pad the end with zeros, but make sure to not forget the extra bytes
      if (extraBytes === 1) {
        tmp = uint8[len - 1];
        output += lookup[tmp >> 2];
        output += lookup[(tmp << 4) & 0x3F];
        output += '==';
      } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
        output += lookup[tmp >> 10];
        output += lookup[(tmp >> 4) & 0x3F];
        output += lookup[(tmp << 2) & 0x3F];
        output += '=';
      }

      parts.push(output);

      return parts.join('');
    }

    return exports;

  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .service('ArrayMove', Service);

  /** @ngInject */
  function Service() {

    return function arraymove(arr, fromIndex, toIndex) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
      return arr;
    };
  }

}());
/**
 * The main app module that pulls everything together
 * @module app
 */

(function () {
  'use strict';

  angular
    .module('app', [
      'ui.router',
      'ngMaterial',
      'ngCookies',
      'ngSanitize',
      'ngMessages',
      'ngAnimate',
      /**
       * 3rd Party modules - Use sparingly
       */
      'cfp.hotkeys',
      'fixed.table.header',
      'chart.js',
      'ngMdIcons',// view available icons here https://klarsys.github.io/angular-material-icons/
      'mdColorPicker',
      'permission',
      'permission.ui',
      'LocalStorageModule',
      'panzoom',
      'dndLists',
      'ui.layout',
      /**
       *  Zuant Modules
       */
      'app.themes',
      'common',
      'Constants',
      'authentication',
      'dashboard',
      'users',
      'lists',
      'clients',
      'email',
      'forms',
      'showroom',
      'thirdparty',
      'bizcard',
      'data',
      'zp.api',
      'zp.auth',
      'zp.env',
      'zp.message',
      'zp.encoding',
      'artefacts',
      'integration'
    ]);
})();

(function () {
  'use strict';

  angular
    .module('app')
    .provider('ZpUserPrefs', ZpUserPrefs);

  function ZpUserPrefs() {
    var settings = {};

    this.$get = ['localStorageService', 'UserService', function (localStorageService, userService) {
      /* see if there are previously saved settings */
      var savedSettings = localStorageService.get('settings');

      /* there are, populate the provider with those settings */
      if (savedSettings) {
        Object.keys(savedSettings).forEach(function (e) {
          if (undefined !== savedSettings[e]) {
            settings[e] = savedSettings[e];
          }
        });
      }

      var save = function saveSettings() {
        userService.savePreferences(settings);
      };

      return {
        settings: settings,
        save: save
      };

    }];
  }
})();

(function () {
  'use strict';

  angular
    .module('common')
    .directive('zpUserPreferences', zpUserPreferences)
    .controller('UserPreferencesCtrl', UserPreferencesCtrl);


  UserPreferencesCtrl.$inject = ['$scope', '$timeout', 'ZpUserPrefs', 'localStorageService'];
  function UserPreferencesCtrl ($scope, $timeout, userPrefs, localStorage) {

    $scope.settingsData = userPrefs;
    $scope.settingsMetadata = {
      settings: [
        {name: 'globalPreferences', label: 'Apply to all of my devices', type: 'boolean', placeholder: '', editable: true, visible: true},
        {name: 'saveImmediately', label: 'Save immediately', type: 'boolean', placeholder: '', editable: true, visible: true}
      ]
    };


    $scope.set = function () { // was (key, value)
      $timeout(function set() { // ensures data-binding has completed before calling userPrefs.set

        /* settings are populated automatically by data-binding
        all we need to do here is act on them if appropriate */

        /* set may be called before any settings have initialised
        so ignore settings that are undefined */
        if (userPrefs.settings.hasOwnProperty('globalPreferences')) {
          if (userPrefs.settings.globalPreferences) {
            /* user has explicitly ticked 'Apply to all of my devices' */
            userPrefs.save();
          }
        }

        var rememberMe = localStorage.get('rememberMe');

        if (undefined !== rememberMe) {
          if (rememberMe) {
            /* user has explicitly ticked the rememberme box when logging in */
            localStorage.set('settings', userPrefs.settings);
          } else {
            /* user has not asked to be remembered, so no data will be stored in local storage */
            localStorage.set('settings', {});
          }
        }

      }, 0);
    };
  }

  function zpUserPreferences () {

    return {
      restrict: 'E',
      controller: 'UserPreferencesCtrl',
      templateUrl: 'app/common/user-preferences/zp-user-preferences.tmpl.html'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('common')
    .service('VisibilityPreferenceService', Service);

  Service.$inject = ['localStorageService'];
  /** @ngInject */
  function Service(localStorage) {

    var factoryData = {

    };

    return {
      getVisibilityPreferences: getVisibilityPreferences,
      setPreference: setPreference
    };

    function getVisibilityPreferences(preferenceId) {
      if (factoryData[preferenceId]) return factoryData[preferenceId].panels;

      var preferences = localStorage.get(preferenceId);
      if (preferences) {
        factoryData[preferenceId] = {
          panels: _.extend({}, preferences.panels)
        };
      }
      return preferences ? preferences.panels : false;
    }

    function setPreference(params) {
      if (!factoryData[params.preferenceId]) {
        factoryData[params.preferenceId] = {
          panels: {}
        };  
      }
      _.extend(factoryData[params.preferenceId].panels, params.panels);

      localStorage.set(params.preferenceId, factoryData[params.preferenceId]);
    }
  }

}());
/**
* Created by davidbeazer on 02/09/2016.
*/
(function () {

  angular
    .module('common')
    .directive('zpHelperArrow', zpHelperArrow);

  zpHelperArrow.$inject = ['$filter'];
  function zpHelperArrow ($filter) {
    return {
      restrict: 'E',
      templateUrl: 'app/common/user-helpers/zp-blank-slate-helper-arrow.tmpl.html',
      scope: {
        'helpMessage': '@',
        'showCondition': '='
      },
      link: function($scope) {
        $scope.bendyArrowImageSvg = $filter('cdnAssets')('/images/svgs/utilities/arrows/bendy-arrow.svg'); 
      },
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpNoData', {
      bindings: {
        header: '@',
        subhead: '@',
        body: '@',
        svgpath: '@',
        fontcolor: '@',
        svgid: '@',
        onclick: '&',
        showRefreshBtn: '<'
      },
      template: '<div layout="column" layout-padding layout-align="center center" layout-padding flex="60" flex-offset="20">' +
        '<div>' +
        '<p class="md-display-1 text-align-center margin-bottom-0" md-colors="::{color: \'primary-500\'}" zz-class="\'{{$ctrl.fontcolor}}\'">{{$ctrl.header}}</p>' +
        '<p class="md-headline margin-top-0 margin-bottom-0 text-align-center" md-colors="::{color: \'primary-500\'}" g-class="\'{{$ctrl.fontcolor}}\'">{{$ctrl.subhead}}</p>' +
        '<p class="md-body margin-top-0 margin-bottom-10 text-align-center" md-colors="::{color: \'primary-500\'}" g-class="\'{{$ctrl.fontcolor}}\'">{{$ctrl.body}}</p>' +
        '<p class="md-body margin-top-0 margin-bottom-10 text-align-center">'+
        '<md-button class="md-primary md-raised md-icon-button" ng-click="$ctrl.onclick()" ng-show="$ctrl.showRefreshBtn"><md-icon md-font-icon="zmdi zmdi-refresh"></md-icon><md-tooltip>Refresh data</md-tooltip></md-button>' +
        '</p>' +
        '</div>' +
        '<div show-gt-lg="" id="{{$ctrl.svgid}}" hide-xs hide-sm hide-md hide-lg layout-padding layout-margin ng-include="$ctrl.svgpath"></div>' +
        '</div>'
    });

})();

(function () {
  'use strict';

  angular
    .module('common')
    .factory('UserAvatarFactory', factory);

  factory.$inject = ['UsersAPI', '$q'];
  /* ng-inject */
  function factory(UsersAPI, $q) {

    var factoryData = {
      hydrated: false,
      users: {}
    };

    var services = {
      getAvatar: getAvatar
    };

    return services;

    function getAvatar(userEmail) {
      var deferred = $q.defer();

      if (factoryData.hydrated) {
        deferred.resolve(factoryData.users[userEmail]);
      } else {
        UsersAPI.getUsers()
          .then(function (res) {
            var rawResponse = res.data.data,
              usersWithAvatar = _.filter(rawResponse, function (user) {
                return user.avatar;
              });
            _.each(usersWithAvatar, function (userData) {
              factoryData.users[userData.email] = {
                avatar: userData.avatar
              };
            });
            factoryData.hydrated = true;
            deferred.resolve(factoryData.users[userEmail]);
          })
          .catch(function (err) {
            throw err;
          });
      }
      return deferred.promise;

    }

  }
}());

/**
 * Created by davidbeazer on 22/01/2017.
 */
(function () {
  'use strict';

  angular
    .module('common')
    .directive('zpKeyboardNavigatable', zpKeyboardNav)
    .controller('GridKeyboardNavController', GridKeyboardNavController);

  zpKeyboardNav.inject = [];

  function zpKeyboardNav() {
    return {
      restrict: 'A',
      controller: 'GridKeyboardNavController',
      scope: {
        zpInteractive: '@'
      }
    };
  }

  GridKeyboardNavController.$inject = ['$scope', 'CellInteractionFactory', 'hotkeys'];

  function GridKeyboardNavController($scope, CellInteractionFactory, hotkeys) {

    if ($scope.zpInteractive === 'false') return;

    hotkeys.bindTo($scope)
      .add({
        combo: 'left',
        description: 'nav left',
        callback: function () {
          // $log.info('left arrow key pressed');
          handleKeyboardNavigationEvent('left');
        }
      })
      .add({
        combo: 'right',
        description: 'nav right',
        callback: function () {
          // $log.info('right arrow key pressed');
          handleKeyboardNavigationEvent('right');
        }
      })
      .add({
        combo: 'up',
        description: 'nav up',
        callback: function () {
          // $log.info('up arrow key pressed');
          handleKeyboardNavigationEvent('up');
        }
      })
      .add({
        combo: 'down',
        description: 'nav down',
        callback: function () {
          // $log.info('down arrow key pressed');
          handleKeyboardNavigationEvent('down');
        }
      })
      .add({
        combo: 'enter',
        description: 'open edit session for highlighted cell',
        callback: function (e) {
          e.preventDefault();
          handleKeyboardNavigationEvent('enter');
        }
      })
      .add({
        combo: 'escape',
        description: 'close open edit dialog without saving',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function () {
          // $log.info('escape key pressed whilst edit dialog open. close dialog without saving');
          CellInteractionFactory.closeRelevantDialog();
        }
      });

    /**
     * @module common
     * @function handleKeyboardNavigationEvent
     * @description The user has navigated a table via the keyboard. This function traverses the table in the relevant direction and updates the cell interaction factory setting the new cell in focus.
     */
    function handleKeyboardNavigationEvent(hotkey) {
      var currentCellInFocus = CellInteractionFactory.getCellInFocus(),
        currentColumnNumber,
        elementSelector;
      if (currentCellInFocus.length == 0) return;
      currentColumnNumber = currentCellInFocus[0].cellIndex;

      if (hotkey == 'right') {
        if (currentCellInFocus[0].nextElementSibling) {
          elementSelector = currentCellInFocus[0].nextElementSibling;
        } else if (currentCellInFocus[0].parentElement.nextElementSibling) {
          elementSelector = currentCellInFocus[0].parentElement.nextElementSibling.children[1];
        } else {
          // can't go right of last row
          elementSelector = currentCellInFocus[0];
        }
      } else if (hotkey == 'left') {
        if (currentCellInFocus[0].previousElementSibling && currentCellInFocus[0].previousElementSibling.cellIndex != 0) {
          elementSelector = currentCellInFocus[0].previousElementSibling;
        } else if (currentCellInFocus[0].parentElement.rowIndex == 1) {
          // $log.info('cannot go left of row 1');
          elementSelector = currentCellInFocus[0];
        } else {
          elementSelector = currentCellInFocus[0].parentElement.previousElementSibling.lastElementChild;
        }
      } else if (hotkey == 'up') {
        if (currentCellInFocus[0].parentElement.previousElementSibling) {
          elementSelector = currentCellInFocus[0].parentElement.previousElementSibling.children[currentColumnNumber];
        } else {
          // $log.info('start of current page. not going anywhere');
          elementSelector = currentCellInFocus[0];
        }
      } else if (hotkey == 'down') {
        if (currentCellInFocus[0].parentElement.nextElementSibling) {
          elementSelector = currentCellInFocus[0].parentElement.nextElementSibling.children[currentColumnNumber];
        } else {
          // $log.info('end of the current page. not going anywhere');
          elementSelector = currentCellInFocus[0];
        }
      } else if (hotkey == 'enter') {
        // enter key pressed, toggle edit session for the current highlighted cell
        elementSelector = currentCellInFocus[0];
        CellInteractionFactory.enterKeyPressed($scope);
      }
      CellInteractionFactory.setCellInFocus(elementSelector);
    }

  }

})();

/**
 * Created by davidbeazer on 05/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('common')
    .component('zpDataGrid', {
      templateUrl: 'app/common/tables/zp-data-grid.tmpl.html',
      controller: 'ZpTableController',
      bindings: {
        metadata: '<',
        searchValue: '<',
        loadingIndicator: '<',
        options: '<',
        rowClick: '&',
        rowMousedown: '&',
        widgetId: '<',
        onSortChange: '&'
      }
    })
    .controller('ZpTableController', ZPTableController);

  ZPTableController.$inject = ['$scope', 'hotkeys', 'localStorageService', 'MessageService', 'GridDataFactory', 'PaginationManager', 'PermPermissionStore', 'SortingFactory'];

  function ZPTableController($scope, hotkeys, localStorage, MessageService, GridDataFactory, PaginationManager, PermPermissionStore, SortingFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm._ = _;
      vm.data = GridDataFactory.getDataForGrid(vm.widgetId);
      // query for ng-repeat to figure out what/how many rows to render
      vm.query = PaginationManager.getQuery(vm.widgetId);
      vm.rowCheckboxes = vm.options.rowSelection && vm.options.multiSelect;

      if (vm.options.interactive) {
        bindHotkeys();
      }

      GridDataFactory.clearSelectedArray(vm.widgetId);
    };

    $scope.$on('zp.table-rows.refresh', function (event, props) {
      if (props.widgetId === vm.widgetId){
        vm.loadingIndicator = true;
        $scope.$applyAsync(function (){
          vm.loadingIndicator = true;
        });
      }
    });

    $scope.$on('zp.table-rows.refreshed', function (event, props) {
      if (props.widgetId === vm.widgetId){
        $scope.$applyAsync(function (){
          vm.loadingIndicator = false;
          vm.$onInit();
        });
      }
    });

    $scope.$on('zp.table-rows.deleted', function () {
      GridDataFactory.clearSelectedArray(vm.widgetId);
    });

    vm.cellClicked = function (rowData, metadata, ev) {

      if (metadata.object !== 'company' && metadata.object !== 'contact' && metadata.object !== 'response' && vm.widgetId !== 'list_detail') return;

      const permissionToCheck = permissionCheck(metadata);
      const gridEditPerm = PermPermissionStore.getPermissionDefinition(permissionToCheck);

      gridEditPerm.validatePermission()
        .then(function () {
          const cellValue = _.get(rowData, `${metadata.object}.${metadata.databasefieldname}.raw`);
          let arrayLength;
          if (angular.isArray(cellValue)) {
            arrayLength = cellValue.length;
          }

          if (!checkCellCanBeEdited(metadata, cellValue)) return;

          const cellMeta = {
            level: 'broadcast',
            eventName: 'zp.cell-clicked',
            page: 'foo',
            targetEvent: ev,
            targetCell: ev.currentTarget,
            mdata: metadata,
            widgetId: vm.widgetId,
            widgetType: vm.metadata.type,
            arrayLength: arrayLength
          };

          $scope.$emit('zp.message', cellMeta);

        })
        .catch(function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'User does not have permissions to interact with this cell.'
          });
        });
    };

    // gateway to all cell interactions
    vm.mouseDown = function (rowData, metadata, ev) {
      switch(ev.which) {
        case 3:{
          // added timout so context menu is shown first by placing logic at the end of the call stack
          setTimeout(function () {
            vm.toggleRowSelected(rowData);
            rowData.selected = !rowData.selected;
            ev.stopPropagation();
            ev.preventDefault();
          }, 0);
          break;
        }
      }

    };

    function checkCellCanBeEdited(metadata, cellValue) {
      if (fieldsWithPopUp(metadata)) {
        if (!cellValue) return false;
        if (!cellValue.length) return false;
        if (metadata.databasefieldname === '_integrationState') return false;
      } else if(!vm.options.interactive){
        return false;
      }
      return true;
    }

    function fieldsWithPopUp(metadata) {
      return metadata.databasefieldname === '_images' ||
        metadata.databasefieldname === '_literature' ||
        metadata.databasefieldname === '_messageComposerMessages' ||
        metadata.databasefieldname === 'templatesSentForForm' ||
        metadata.databasefieldname === 'emailEvents' ||
        metadata.type === 'Drawing' ||
        metadata.type === 'IntegrationStatus';
    }

    function permissionCheck(metadata) {
      if (vm.metadata.id == 'lead_release') return 'INTEGRATION_LEAD_RELEASE_EDIT';
      if (fieldsWithPopUp(metadata)) {
        return 'LEADS_VIEWGRID';
      } else {
        return 'LEADS_EDITGRID';
      }
    }

    vm.ngRepeatTrackingFunction = function (rowData, rowIndex) {
      // the RowSelectionManager keeps a track of the rows that are currently rendered for easy access to row selected property. This is in the event of the user toggling the selected value for all rows on a page. (ng-repeat doesn't keep the items array in order)
      return GridDataFactory.updateRowsCurrentlyRendered(rowData, rowIndex, vm.metadata.columnsData.primaryIdentifier.object, vm.widgetId);
    };

    // COLUMN SORT FUNCTIONS
    vm.getSortDirection = function () {
      if (!vm.options.sortable) {
        return;
      }
      return vm
        .query
        .order
        .reverse ?
        'md-desc' :
        'md-asc'; // show the sort arrow in the correct direction (up or down)
    };

    vm.isColumnActive = function (object, dbfield) {
      if (!vm.options.sortable) {
        return;
      }
      if ((vm.query.order.id == object + '.' + dbfield)) {
        return 'md-active'; // locate the active column and show the sort icon
      }
    };

    vm.logOrder = function (metadata) {
      if (!vm.options.sortable) {
        return;
      }
      vm.query.order.id = metadata.object + '.' + metadata.databasefieldname;
      vm.query.order.reverse = vm.query.order.reverse ? false : true;
      vm.query.order.expression = function predicate(data) {
        const value = _.get(data, [metadata.object, metadata.databasefieldname, 'raw'], null);
        if (metadata.sortOn === 'arrayLength' || (Array.isArray(value) && value.length > 1)) {
          return value.length;
        }

        if (metadata.sortOn === 'rawValue') {
          return generateSortExpressionOnDataType(value);
        } 
        
      };
      localStorage.set('grid_sort_order', vm.query.order);

      vm.onSortChange({
        order: vm.query.order
      });
    };

    function generateSortExpressionOnDataType(value) {
      // Null/Undefined
      if (!value) return -1;

      // Array with length 1
      if (Array.isArray(value)) {
        return generateSortExpressionOnDataType(value[0]);
      }

      // Number
      if (typeof value === 'number') {
        return value;
      }

      // Boolean (convert to 0 or 1)
      if (typeof value === 'boolean') {
        return value ? 1 : 0;
      }

      // String (normalize case for consistent sorting)
      if (typeof value === 'string') {
        return value.toLowerCase();
      }

      // Date object
      if (value instanceof Date) {
        return value.getTime();
      }

      return value;
    }


    vm.comparatorFunction = function (item1, item2) {
      return SortingFactory.sortIndividualItems(item1, item2);
    };

    // MENU FUNCTIONS
    vm.openMenu = function (func, ev) {
      func(ev);
    };

    // ROW SELECTION FUNCTIONS
    vm.selectAllIsIndeterminate = function () {
      return (GridDataFactory.getSelectedRows(vm.widgetId).length !== 0 && GridDataFactory.getSelectedRows(vm.widgetId).length !== vm.data.items.length);
    };

    vm.toggleRowSelected = function (row) {
      GridDataFactory.toggleRowIsSelected(row, vm.widgetId);
    };

    /**
     *   @description: this function takes care of toggling the selected property for all rows. If the rows spread over more than 1 page then the user is prompted to see which rows they would like to toggle.
     */
    vm.toggleAllRowsSelected = function (ev) {
      const tableMetadata = {
        totalRowsCount: vm.data.items.length,
        currentPage: vm.query.page,
        pageSize: vm.query.limit,
        rowIdentifierObject: vm.metadata.columnsData.primaryIdentifier.object,
        searchValue: vm.searchValue
      };

      GridDataFactory.toggleAllRowsSelected(ev, tableMetadata, vm.data.items, vm.data.allItemsSelected, vm.widgetId);

    };

    function bindHotkeys() {

      hotkeys.bindTo($scope)
        .add({
          combo: 'ctrl+s',
          description: 'Save changes',
          callback: function () {
            $scope.$emit('zp.message', {
              level: 'broadcast',
              page: 'foo',
              eventName: 'zp.table.queueForSaving'
            });
          }
        })
        .add({
          combo: 'ctrl+a',
          description: 'Select / deselect all',
          callback: function () {
            vm.toggleAllRowsSelected();
          }
        });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('common')
    .factory('SortingFactory', factory);

  /* ng-inject */
  function factory() {

    return {
      sortIndividualItems: sortIndividualItems,
      sortEntireArray: sortEntireArray
    };

    function sortEntireArray(orderObj, itemsToBeSorted) {

      var helperObj = buildSortHelperObject(orderObj),
        sortItm1, sortItm2,
        sortedArray;

      try {
        if (stringLocaleSort(helperObj.sortAttrs, itemsToBeSorted[0])) {
          // sorting a string and need to do a locale comparison to accomodate Ãœ Ãª etc
          sortedArray = itemsToBeSorted.sort(function (a, b) {
            sortItm1 = a[helperObj.sortAttrs[0]][helperObj.sortAttrs[1]][helperObj.sortAttrs[2]] || '';
            sortItm2 = b[helperObj.sortAttrs[0]][helperObj.sortAttrs[1]][helperObj.sortAttrs[2]] || '';
            return sortItm1.localeCompare(sortItm2);
          });
        } else {
          // do a bog standard sort for non strings - aka numbers
          sortedArray = _.sortBy(itemsToBeSorted, function (item) {
            return item[helperObj.sortAttrs[0]][helperObj.sortAttrs[1]][helperObj.sortAttrs[2]] || '';
          });
        }

        if (helperObj.direction === 'desc') {
          sortedArray.reverse();
        }
      } catch (e) {
        // console.log(e);
      }

      return sortedArray;
    }

    function stringLocaleSort(sortAttrs, itemToBeSorted) {
      return typeof itemToBeSorted[sortAttrs[0]][sortAttrs[1]][sortAttrs[2]] === 'string';
    }

    function sortIndividualItems(v1, v2) {
      v1.value = v1.value || '';
      v2.value = v2.value || '';
      if (v1.type === 'string' && v2.type === 'string') {
        // Compare strings alphabetically, taking locale into account
        return v1.value.localeCompare(v2.value);
      } else if (v1.type === 'number' && v2.type === 'number') {
        // Compare numbers by value
        return (v1.value < v2.value) ? -1 : 1;
      } else {
        // If we don't get strings or numbers, just compare by index
        return (v1.index < v2.index) ? -1 : 1;
      }
    }

    // private
    function buildSortHelperObject(orderObj) {
      var expression, direction, sortAttrs;

      if (typeof orderObj === 'object') expression = orderObj.expression;

      direction = expression.charAt(0) === '-' ? 'desc' : 'asc';
      sortAttrs = expression.split('.');

      if (direction === 'desc') {
        sortAttrs[0] = sortAttrs[0].slice(1);
      }

      return {
        direction: direction,
        sortAttrs: sortAttrs
      };
    }

  }
}());

/*
 * Angular Fixed Table Header
 * https://github.com/daniel-nagy/fixed-table-header
 * @license MIT
 * v0.2.1
 */
(function (window, angular) {
  'use strict';

  angular.module('fixed.table.header', []).directive('fixHead', fixHead);

  function fixHead($compile, $window, $timeout) {

    function compile(tElement) {
      var table = {
        clone: tElement.parent().clone().empty(),
        original: tElement.parent()
      };

      var header = {
        clone: tElement.clone(),
        original: tElement
      };

      // prevent recursive compilation
      header.clone.removeAttr('fix-head').removeAttr('ng-if');

      table.clone.css({
        display: 'block',
        overflow: 'hidden'
      }).addClass('clone');
      header.clone.css('display', 'block');
      header.original.css('visibility', 'hidden');

      return function postLink(scope) {
        var scrollContainer = table.original.parent();

        // insert the element so when it is compiled it will link
        // with the correct scope and controllers
        header.original.after(header.clone);

        $compile(table.clone)(scope);
        $compile(header.clone)(scope);

        scrollContainer.parent()[0].insertBefore(table.clone.append(header.clone)[0], scrollContainer[0]);

        scrollContainer.on('scroll', function () {
          // use CSS transforms to move the cloned header when the table is scrolled horizontally
          header.clone.css('transform', 'translate3d(' + -(scrollContainer.prop('scrollLeft')) + 'px, 0, 0)');
        });
        header.clone.on('click', function () {
          // use CSS transforms to move the cloned header when the table is scrolled horizontally
          $timeout(function () {
            header.clone.css('transform', 'translate3d(' + -(scrollContainer.prop('scrollLeft')) + 'px, 0, 0)');
          }, 0);
        });

        function cells() {
          return header.clone.find('th').length;
        }

        function getCells(node) {
          return Array.prototype.map.call(node.find('th'), function (cell) {
            return jQLite(cell);
          });
        }

        function height() {
          return header.original.prop('clientHeight');
        }

        function jQLite(node) {
          return angular.element(node);
        }

        function marginTop(height) {
          table.original.css('marginTop', '-' + height + 'px');
        }

        function updateCells() {
          var cells = {
            clone: getCells(header.clone),
            original: getCells(header.original)
          };

          cells.clone.forEach(function (clone, index) {
            if (clone.data('isClone')) {
              return;
            }

            // prevent duplicating watch listeners
            clone.data('isClone', true);

            var cell = cells.original[index];
            var style = $window.getComputedStyle(cell[0]);

            var getWidth = function () {
              return style.width;
            };

            var setWidth = function () {
              marginTop(height());
              clone.css({
                minWidth: style.width,
                maxWidth: style.width
              });
            };

            var listener = scope.$watch(getWidth, setWidth);

            $window.addEventListener('resize', setWidth);

            clone.on('$destroy', function () {
              listener();
              $window.removeEventListener('resize', setWidth);
            });

            cell.on('$destroy', function () {
              clone.remove();
            });
          });
        }

        scope.$watch(cells, updateCells);

        header.original.on('$destroy', function () {
          header.clone.remove();
        });
      };
    }

    return {
      compile: compile
    };
  }

  fixHead.$inject = ['$compile', '$window', '$timeout'];

})(window, angular);

(function () {
  'use strict';

  angular.module('common')
    .factory('LeadValidationFactory', factory);

  factory.$inject = ['FormMetadataFactory'];
  /* ng-inject */
  function factory(FormMetadataFactory) {

    var services = {
      validateCell: validateCell,
      validateRows: validateRows
    };

    return services;

    function validateCell(paramsObj) {

      var validationObj = {
        label: paramsObj.metadata.label,
        valid: true,
        errors: []
      };

      if (paramsObj.metadata.validation) {
        validationObj.required = paramsObj.metadata.validation.required;
        if (noValue(paramsObj.newValue) && paramsObj.metadata.validation.required) {
          validationObj.valid = false;
          validationObj.required = true;
          validationObj.errors.push({
            type: 'required',
            message: paramsObj.metadata.validation.validationIssue || 'required field'
          });
        }
      }
      return validationObj;
    }

    function noValue(value) {
      if (!value) return true;
      if (value === undefined) return true;
      if (!value.length) return true;
    }

    function validateRows(paramsObj) {

      var returnObject = {},
        rowValidationObj,
        rowIsValid,
        cellValue,
        cellValidation,
        formWidgets = FormMetadataFactory.getData().columnsData.items;

      _.each(paramsObj.rowsData, function (rowData) {
        rowValidationObj = {
          valid: true,
          errors: {}
        };
        rowIsValid = true;
        _.each(formWidgets, function (formWidget) {
          try {
            cellValue = rowData[formWidget.object][formWidget.databasefieldname];
          } catch (e) {
            cellValue = '';
          }
          cellValidation = validateCell({
            newValue: cellValue,
            metadata: formWidget,
            widgetId: paramsObj.widgetId
          });
          if (!cellValidation.valid) {
            rowIsValid = false;
            rowValidationObj.valid = rowIsValid;
            rowValidationObj.errors[formWidget.object + '_' + formWidget.databasefieldname] = cellValidation;
          }
        });
        if (!rowIsValid) {
          returnObject[rowData.response._id] = rowValidationObj;
        }
        rowData.response._leadIsValid = rowIsValid;
      });
      return returnObject;
    }

  }
}());

(function () {
  'use strict';

  angular.module('common')
    .factory('GridMetaDataFactory', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    let factoryData = {};
    buildFactory();

    return {
      factoryData: factoryData,
      hydrateData: hydrateData,
      locateCellMetaDataById: locateCellMetaDataById,
      getCellRowMetaDataByWidgetid: getCellRowMetaDataByWidgetid,
      getPrimaryIdentifierForWidget: getPrimaryIdentifierForWidget
    };

    function buildFactory() {
      factoryData = {
        submitted_leads: {},
        parked_leads: {},
        list_main: {},
        list_detail: {},
        lead_release: {},
        integration_machines: {},
        full_page_widget_grid: {}
      };
    }

    function hydrateData(data, key) {
      _.extend(factoryData[key], {}, data);
    }

    function locateCellMetaDataById(metadataId, widgetId) {
      return factoryData[widgetId].itemsObject[metadataId];
    }

    function getCellRowMetaDataByWidgetid(widgetId){
      return factoryData[widgetId].itemsObject;
    }

    function getPrimaryIdentifierForWidget(object){
      return factoryData[object].primaryIdentifier;
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .factory('GridDataFactory', factory);

  factory.$inject = ['$filter', 'GridMetaDataFactory'];
  /* ng-inject */
  function factory($filter, GridMetaDataFactory) {

    let factoryData = {};
    buildFactory();

    return {
      factoryData: factoryData,
      hydrateData: hydrateData,
      getDataForGrid: getDataForGrid,
      locateCellRowDataById: locateCellRowDataById,
      clearSelectedArray: clearSelectedArray,
      removeSelectedItemsFromFactory: removeSelectedItemsFromFactory,
      toggleRowIsSelected: toggleRowIsSelected,
      toggleAllRowsSelected: toggleAllRowsSelected,
      removeDirtyFlagFromAllRows: removeDirtyFlagFromAllRows,
      getSelectedRows: getSelectedRows,
      updateRowsCurrentlyRendered: updateRowsCurrentlyRendered,
      updateCellValue: updateCellValue,
      leadIsValid: leadIsValid
    };

    function hydrateData(data, key) {
      // HACK to get lists and lead grid working as expected. TODO migrate list selected items tracking to this factory as opposed to list factory
      if (key === 'submitted_leads' || key === 'lead_release'|| key === 'full_page_widget_grid') {
        _.extend(factoryData[key], data);
      } else {
        factoryData[key] = data;
      }
      return factoryData[key];
    }

    function getDataForGrid(widgetId) {
      return factoryData[widgetId];
    }

    function locateCellRowDataById(targetRowId, widgetId) {
      let idx = targetRowId;
      if (targetRowId && targetRowId.indexOf('{') === 0) {
        idx = JSON.parse(targetRowId).raw;
      }
      return factoryData[widgetId].itemsObject[idx];
    }

    function clearSelectedArray(widgetId) {
      _.each(factoryData[widgetId].items, function (itm) {
        if (itm.selected) itm.selected = false;
      });
      factoryData[widgetId].selectedItems = [];
      factoryData[widgetId].allItemsSelected = false;
    }

    function removeSelectedItemsFromFactory(widgetId) {
      _.each(factoryData[widgetId].selectedItems, function (item) {
        removeItemFromFactory(item, widgetId);
      });
      clearSelectedArray(widgetId);
    }

    function removeItemFromFactory(item, widgetId) {
      const nestedObjKey = nestedObjectKey(item);
      const indexToSplice = findIndexOfSelectedObjectInArray(item, factoryData[widgetId].items, nestedObjKey);
      factoryData[widgetId].rawData.splice(indexToSplice, 1);
      factoryData[widgetId].items.splice(indexToSplice, 1);
      delete factoryData[widgetId].itemsObject[item[nestedObjKey]._id];
      delete factoryData[widgetId].validation[item[nestedObjKey]._id];
    }

    function removeDirtyFlagFromAllRows(widgetId) {
      _.each(factoryData[widgetId].items, function (row) {
        if (row.dirty) {
          row.dirty = false;
        }
      });
    }

    function findIndexOfSelectedObjectInArray(item, array, nestedObjKey) {
      const index = _.findIndex(array, function (itm) {
        let id = itm[nestedObjKey]._id;
        if (typeof id !== 'string' && 'raw' in id) {
          id = itm[nestedObjKey]._id.raw;
        }

        let compareId = item[nestedObjKey]._id;
        if (typeof compareId !== 'string' && 'raw' in compareId) {
          compareId = item[nestedObjKey]._id.raw;
        }

        if (id !== compareId) return false;
        return true;
      });
      return index;
    }

    function toggleRowIsSelected(row, widgetId) {
      const nestedObjKey = nestedObjectKey(row);
      const rowId = row[nestedObjKey]._id.raw ? row[nestedObjKey]._id.raw : row[nestedObjKey]._id;
      const rowRawData = factoryData[widgetId].itemsObject[rowId];
      if (row.selected) {
        const indexToSplice = findIndexOfSelectedObjectInArray(row, factoryData[widgetId].selectedItems, nestedObjKey);
        factoryData[widgetId].selectedItems.splice(indexToSplice, 1);
      } else {
        factoryData[widgetId].selectedItems.push(rowRawData);
      }
      allRowsSelectedCheck(widgetId);
    }

    function nestedObjectKey(object) {
      if (object.list) {
        return 'list';
      } else if (object.response) {
        return 'response';
      }
    }

    function getSelectedRows(widgetId) {
      return factoryData[widgetId].selectedItems;
    }

    function updateRowsCurrentlyRendered(rowData, rowIndex, rowIdentifierObject, widgetId) {
      // used to track the row id's of the rows currently in the view. Returns random number for ng-repeat tracking purposes (no duplicate keys allowed)
      if (rowIndex == 0) {
        // rendering a new page, ensure array is empty!
        factoryData[widgetId].rowsCurrentlyRendered = [];
      }

      let rowId = rowData[rowIdentifierObject]['_id'];
      if (typeof rowId !== 'string' && 'raw' in rowId) {
        rowId = rowId.raw;
      }
      factoryData[widgetId].rowsCurrentlyRendered.push(rowId);
      const randomNum = Math.round(Math.random() * 1000);
      const trackingKey = rowId + '_' + randomNum;
      return trackingKey;
    }

    function updateCellValue(paramsObj) {
      // Basic params
      const widgetId = _.get(paramsObj, 'widgetId');
      const objectId = _.get(paramsObj, 'objectId');
      const newValue = _.get(paramsObj, 'newValue');
      const metadata = _.get(paramsObj, 'metadata', {});

      // Metadata pieces
      const metadataObject = _.get(metadata, 'object');              // e.g. 'contact'
      const metadataField = _.get(metadata, 'databasefieldname');    // e.g. 'email'
      const metadataType = _.get(metadata, 'type');
      const cellFilterName = _.get(metadata, 'cellFilter');

      // Bail early if we don't even know what object/field to target
      if (!widgetId || !metadataObject || !metadataField) {
        return;
      }

      // Precompute some reusable paths
      const widgetPath = [widgetId];
      const itemsPath = widgetPath.concat('items');
      const cellBasePath = [metadataObject, metadataField]; // base path for raw/filtered

      // Primary identifier info for itemsObject map
      const primaryIdentifier = GridMetaDataFactory.getPrimaryIdentifierForWidget(widgetId);
      const primaryObject = _.get(primaryIdentifier, 'object');
      const primaryField = _.get(primaryIdentifier, 'field');

      // Widget data
      const items = _.get(factoryData, itemsPath, []);

      const hasCellFilter = !!cellFilterName;
      const cellFilterFn = hasCellFilter ? $filter(cellFilterName) : null;

      for (let i = 0, j = items.length; i < j; i++) {
        const row = items[i];

        // Get the _id for this row: row[metadataObject]._id (or ._id.raw)
        let id = _.get(row, [metadataObject, '_id']);
        if (typeof id !== 'string' && id && _.has(id, 'raw')) {
          id = _.get(id, 'raw');
        }

        if (id == objectId) {
          // --- Update in items (grid row) ---

          // raw value
          _.set(row, cellBasePath.concat('raw'), newValue);

          // filtered value
          const filteredValue = hasCellFilter
            ? cellFilterFn(newValue, metadataType)
            : newValue;

          _.set(row, cellBasePath.concat('filtered'), filteredValue);

          // --- Update in itemsObject map ---

          // Key for itemsObject: row[primaryObject][primaryField] (or .raw)
          let idx = _.get(row, [primaryObject, primaryField]);
          if (typeof idx !== 'string' && idx && _.has(idx, 'raw')) {
            idx = _.get(idx, 'raw');
          }

          const itemsObjectCellPath = widgetPath
            .concat(['itemsObject', idx, metadataObject, metadataField]);

          _.set(factoryData, itemsObjectCellPath, newValue);
        }
      }
    }


    function toggleAllRowsSelected(ev, tableMetadata, rowsData, toggleAllRowsSelected, widgetId) {

      if (tableMetadata.searchValue) {
        updateAllRows(rowsData, widgetId, toggleAllRowsSelected, tableMetadata.searchValue);
        allRowsSelectedCheck(widgetId);
      } else if (tableMetadata.totalRowsCount <= tableMetadata.totalRowsCount) {
        updateAllRows(rowsData, widgetId, toggleAllRowsSelected);
        allRowsSelectedCheck(widgetId);
      } else if (size > tableMetadata.pageSize) {
        updateCurrentPageRows(tableMetadata, widgetId);
      }
    }

    function allRowsSelectedCheck(widgetId) {
      factoryData[widgetId].allItemsSelected = factoryData[widgetId].selectedItems.length >= factoryData[widgetId].rowsCurrentlyRendered.length;
    }

    function updateAllRows(rowsData, widgetId, toggleAllRowsSelected, searchValue) {
      // toggle all rows
      const toggleOn = computeToggleValue(widgetId, toggleAllRowsSelected);
      factoryData[widgetId].selectedItems = [];
      rowsData.forEach(function (item) {
        const nestedObjKey = nestedObjectKey(item);
        if (searchValue) {
          const toggleMatchedSearchTerm = searchForMatch(item, searchValue);
          if (toggleMatchedSearchTerm) {
            toggle(item, toggleOn, nestedObjKey, widgetId);
          }
        } else {
          toggle(item, toggleOn, nestedObjKey, widgetId);
        }
      });
      // if all rows selected we need to empty seleced array
      if (!toggleOn) {
        factoryData[widgetId].selectedItems = [];
      }
    }

    function searchForMatch(item, searchValue) {
      const searchMatch = _.find(item, function (dbObj) {
        return _.find(dbObj, function (value) {
          try {
            let valTrimmedToLower;
            if (!_.isUndefined(value.raw)) {
              if (typeof (value.raw) === 'string') valTrimmedToLower = value.raw.toLowerCase().trim();
              if (typeof (value.raw) === 'boolean') valTrimmedToLower = value.raw;
            } else {
              if (_.isUndefined(value.raw)) return;
              valTrimmedToLower = value.toLowerCase().trim();
            }
            var searchTrimmedToLower = searchValue.toLowerCase().trim();
          } catch (e) {
            // console.error(e);
          }
          if (typeof valTrimmedToLower === 'string') {
            const substring = valTrimmedToLower.indexOf(searchTrimmedToLower) !== -1;
            return substring;
          } else {
            if (valTrimmedToLower === searchTrimmedToLower) {
              return true;
            }
          }
        });
      });
      return searchMatch;
    }

    function toggle(item, toggleOn, nestedObjKey, widgetId) {
      item.selected = toggleOn;
      let id = item[nestedObjKey]._id;
      if (typeof id !== 'string' && 'raw' in id) {
        id = id.raw;
      }
      const itemRawData = factoryData[widgetId].itemsObject[id];
      if (toggleOn) {
        factoryData[widgetId].selectedItems.push(itemRawData);
      }
    }

    function computeToggleValue(widgetId, toggleAllRowsSelected) {
      return (factoryData[widgetId].selectedItems.length <= factoryData[widgetId].rowsCurrentlyRendered.length) && !toggleAllRowsSelected;
    }

    function updateCurrentPageRows(tableMetadata, widgetId) {
      // the user is toggling the current page's rows. Locate and update them
      const toggleValue = computeToggleValueForCurrentRowsRendered();
      factoryData[widgetId].selectedItems = _.filter(factoryData[widgetId].items, function (row) {
        const found = factoryData[widgetId].rowsCurrentlyRendered.indexOf(row[tableMetadata.rowIdentifierObject]._id) !== -1;
        if (found) {
          // need to add or remove this row and update its selected property to the toggleValue.
          factoryData[widgetId].items[row[tableMetadata.rowIdentifierObject]['_id']].selected = !toggleValue;
          row.selected = !toggleValue;
        }
        return row.selected; // if the row is selected or not determines whether this row belongs in the selected array
      });
    }

    function computeToggleValueForCurrentRowsRendered(widgetId) {
      const selectedCopy = angular.copy(factoryData[widgetId].selectedItems);
      const currentRowsSelectedLength = selectedCopy.length;
      return currentRowsSelectedLength >= factoryData[widgetId].rowsCurrentlyRendered.length;
    }

    function leadIsValid(widgetId, responseId) {
      const paramsObj = {
        newValue: true,
        widgetId: widgetId,
        objectId: responseId,
        metadata: {
          object: 'response',
          databasefieldname: '_leadIsValid',
          cellFilter: 'gridButton',
          type: '_validation'
        }
      };
      updateCellValue(paramsObj);
      delete factoryData[widgetId].validation[responseId];
    }

    function buildFactory() {
      factoryData = {
        clients_list: {
          items: [],
          itemsObject: {},
          rawData: [],
          rowsCurrentlyRendered: []
        },
        user_list: {
          items: [],
          itemsObject: {},
          rawData: [],
          rowsCurrentlyRendered: []
        },
        staff_user_list: {
          items: [],
          itemsObject: {},
          rawData: [],
          rowsCurrentlyRendered: []
        },
        email_templates: {
          items: [],
          itemsObject: {},
          rawData: [],
          rowsCurrentlyRendered: []
        },
        lists_main: {
          items: [],
          itemsObject: {},
          rawData: [],
          rowsCurrentlyRendered: []
        },
        list_detail: {
          items: [],
          itemsObject: {},
          rawData: [],
          selectedItems: [],
          rowsCurrentlyRendered: []
        },
        submitted_leads: {
          items: [],
          itemsObject: {},
          rawData: [],
          selectedItems: [],
          rowsCurrentlyRendered: []
        },
        parked_leads: {
          items: [],
          itemsObject: {},
          rawData: [],
          selectedItems: [],
          rowsCurrentlyRendered: [],
          validationErrors: []
        },
        lead_release: {
          items: [],
          itemsObject: {},
          rawData: [],
          selectedItems: [],
          rowsCurrentlyRendered: [],
          validationErrors: []
        },
        previous_forms_list: {
          items: [],
          itemsObject: {},
          rawData: [],
          rowsCurrentlyRendered: []
        },
        current_forms_list: {
          items: [],
          itemsObject: {},
          rawData: [],
          rowsCurrentlyRendered: []
        },
        upcoming_forms_list: {
          items: [],
          itemsObject: {},
          rawData: [],
          rowsCurrentlyRendered: []
        },
        integration_machines_list: {
          items: [],
          itemsObject: {},
          rawData: [],
          rowsCurrentlyRendered: []
        },
        full_page_widget_grid: {
          items: [],
          itemsObject: {},
          rawData: [],
          rowsCurrentlyRendered: []
        }
      };
    }
  }
}());

(function () {
  'use strict';
  angular
    .module('common')
    .component('zpTabNavbar', {
      controller: 'zpTabNavbarCtrl',
      templateUrl: 'app/common/tab-navbar-component/zp-tab-navbar.tmpl.html',
      bindings: {
        stateParams: '<'
      }
    })
    .controller('zpTabNavbarCtrl', zpTabNavbarCtrl);

  zpTabNavbarCtrl.$inject = ['$state'];
  /* ng-inject */
  function zpTabNavbarCtrl($state) {

    var vm = this;

    vm.activeTabName = '';

    var activeNavItems = [];
    vm.$onInit = function () {

      activeNavItems.push($state.$current.data.name);

      let parent = $state.$current.parent;
      while (parent){
        if (parent.data && parent.data.name){
          activeNavItems.push(parent.data.name);
        }

        parent = parent.parent;
      }

      for (const itm of vm.stateParams.items){
        if (activeNavItems.indexOf(itm.name) > -1){
          vm.activeTabName = itm.name;
          return;
        }
      }

    };

  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .factory('mySocket', function () {

      // $log.info('mySocket factory born');

      var messages = [];
      // var myIoSocket = io.connect('localhost:4001');
      // var socket = socketFactory({
      //   ioSocket: myIoSocket,
      //   prefix: '',
      // });

      // socket.on('noconflict', function (data) {
      //   $log.info('CLIENT on.noconflict' + JSON.stringify(data));
      //   messages.push(data);
      //   $log.info('messages array length: ' + messages.length);
      // });
      // socket.on('server_message', function (data) {
      //   $log.info('CLIENT on.server_message' + JSON.stringify(data));
      // });


      return {
        getMessages: messages
      };

    });
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpSidenav', {
      controller: 'zpSidenavCtrl',
      templateUrl: 'app/common/sidenav/zp-sidenav.tmpl.html',
      bindings: {}
    })
    .controller('zpSidenavCtrl', zpSidenavCtrl);

  zpSidenavCtrl.$inject = ['EnvService'];

  function zpSidenavCtrl(EnvService) {
    var vm = this;

    vm.$onInit = function () {
      vm.isDev = EnvService.isDev;
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('common')
    .service('SendThankYouEmailIntegrityCheck', service);

  /***
   * If account has GDPR enabled
   * And a form has a thank you email attached to it
   * Ensure that there is a valid 'Send Email' token for the account.
   * Otherwise, Zuant will not send thank you emails (or any other emails to a contact!)
   */

  service.$inject = ['CurrentClientModelFactory', 'SessionService', 'EmailTemplatesFactory', '$filter'];
  /* ng-inject */
  function service(CurrentClientModelFactory, SessionService, EmailTemplatesFactory, $filter) {

    var factoryData = {
      valid: false,
      status: '',
      effectedForms: []
    };

    return {
      factoryData: factoryData,
      runCheckOnAccount: runCheckOnAccount
    };

    function runCheckOnAccount() {
      return new Promise(function (resolve, reject) {
        CurrentClientModelFactory.getClientById(SessionService.getUserData().clientId)
          .then(function (res) {
            resolve(accountStatus(res));
          })
          .catch(function (err) {
            reject(err);
          });
      });
    }

    function accountStatus(clientModel) {
      return new Promise(function (resolve, reject) {
        if (clientModel.GDPR.enabled) {
          if (checkForActiveSendEmailToken(clientModel.consentModel)) {
            factoryData.valid = true;
            factoryData.status = 'GDPR is enabled and there is an active Send Email token. TYE will send as expected.';
            factoryData.effectedForms = [];
            resolve();
          } else {
            return findFormsThatAreEffected()
              .then(function (effectedForms) {
                factoryData.valid = false;
                factoryData.status = 'Please ensure the account has an active \'Send Email\' token in order for Zuant to send emails.';
                factoryData.effectedForms = effectedForms;
                resolve();
              })
              .catch(function (err) {
                factoryData.effectedForms = [];
                reject(err);
              });
          }
        } else {
          factoryData.valid = true;
          factoryData.status = 'GDPR is not enabled for this account. No checks required';
          factoryData.effectedForms = [];
          resolve();
        }
      });
    }

    function checkForActiveSendEmailToken(accountConsentModel) {
      var result = _.chain(accountConsentModel)
        .filter(function (token) {
          return token.active;
        })
        .find(function (token) {
          return _.find(token.symbols, function (symbol) {
            return symbol === 'Send Email';
          });
        })
        .value();
      // above returns as soon as it finds an active token with a Send Email symbol.
      return !!result;
    }

    function findFormsThatAreEffected() {
      return EmailTemplatesFactory.init()
        .then(function (emailFactoryData) {

          // loop the forms and return those that have an emailTemplate set
          var effectedForms = _.chain(emailFactoryData.formsList)
            .filter(function (formObj) {
              return formObj.emailTemplate !== '';
            })
            .map(function (formObj) {
              return {
                icon: $filter('gridButton')(formObj.icn, 'Status'),
                formname: formObj.formname,
                startdate: formObj.startdate,
                emailTemplate: formObj.emailtemplatetitle
              };
            })
            .sortBy('startdate')
            .reverse()
            .value();

          return effectedForms;
        })
        .catch(function (err) {
          throw err;
        });
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpSendTYEChecker', {
      templateUrl: 'app/common/send-tye-trigger-checker/tmpl.html',
      controller: 'SendTYECheckerCtrl',
      bindings: {}
    })
    .controller('SendTYECheckerCtrl', ctrl);

  ctrl.$inject = ['SendThankYouEmailIntegrityCheck', '$state', 'SessionService'];
  /* ng-inject */
  function ctrl(SendThankYouEmailIntegrityCheck, $state, SessionService) {

    var vm = this;

    vm.$onInit = function () {
      vm.factoryData = SendThankYouEmailIntegrityCheck.factoryData;
    };

    vm.goToConsentSettings = function () {
      $state.go('app.tabbed_app_framework.client_detail.consent_management', {
        _id: SessionService.getUserData().clientId
      });
    };
  }
}());

(function () {

  'use strict';

  angular
    .module('common')
    .directive('scrollOnClick', function () {
      return {
        restrict: 'A',
        link: function (scope, $elm, attrs) {
          var idToScroll = attrs.href;
          $elm.on('click', function () {
            var $target;
            if (idToScroll) {
              $target = $(idToScroll);
            } else {
              $target = $elm;
            }
            $('md-content').animate({ scrollTop: $target.offset().top }, 'slow');
          });
        }
      };
    });
})();
(function () {

  'use strict';
  angular.module('common')
    .directive('zpRotate', function () {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          scope.$watch(attrs.degrees, function (rotateDegrees) {
            var r = 'rotate(' + rotateDegrees + 'deg)';
            element.css({
              '-moz-transform': r,
              '-webkit-transform': r,
              '-o-transform': r,
              '-ms-transform': r
            });
          });
        }
      };
    });
})();

/**
 * Created by davidbeazer on 13/10/2016.
 */
(function () {
  'use strict';

  angular
    .module('common')
    .component('zpReorderList', {
      templateUrl: 'app/common/reorder/reorder.tmpl.html',
      bindings: {
        items: '<',
        metadata: '<',
        onSort: '&',
        searchValue: '<'
      },
      controller: 'zpReorderCtrl'
    })
    .component('zpConsentTokensReorderList', {
      templateUrl: 'app/common/reorder/consent-tokens-reorder.tmpl.html',
      bindings: {
        items: '<'
      },
      controller: 'zpReorderCtrl'
    })
    .component('zpReorderColumns', {
      templateUrl: 'app/common/reorder/reorder-columns.tmpl.html',
      bindings: {
        items: '<',
        onSort: '&',
        onUpdate: '&'
      },
      controller: 'zpReorderCtrl'
    })
    .controller('zpReorderCtrl', Controller);

  Controller.$inject = ['ChangeDelta'];
  /* ng-inject */
  function Controller(ChangeDelta) {
    var vm = this;
    vm.$onInit = function () {
      vm.staticArray = Array.from(vm.items);

      vm.sortableConfig = {
        items: '> .list-item',
        cursor: 'move',
        tolerance: 'pointer',
        disabled: false,
        handle: '.list-item-handle',
        containment: 'parent',
        axis : 'y',
        helper:'clone',
        sort: function ($event) {
          if (vm.onSort) return vm.onSort({ $event });
          const scrollParent = $('zp-list-detail-page');
          if( scrollParent.scrollTop()>scrollParent.height()){
            scrollParent.scrollTop(scrollParent.height());
          }          
        },
        update: function ($event, ui) {
          if (vm.onUpdate) return vm.onUpdate({ $event, ui });

          const sourceIndex = ui.item.sortable.index;
          const dropIndex = ui.item.sortable.dropindex;

          const index = vm.staticArray.indexOf(vm.items[sourceIndex]);
          const id = vm.items[sourceIndex]._id || vm.items[sourceIndex].list._id;

          ChangeDelta.recordValueChange({
            oldval: sourceIndex,
            newval: dropIndex,
            orignialvalue: index,
            maxvalue: vm.items.length-1,
            objectid: 'listOrder',
            collection: 'foo',
            databasefieldname: id
          });
        }
      };
    };
  }
})();

(function(QRCode){
  'use strict';
  
  angular.module('common')
    .directive('qr', qr);
    
  qr.$inject = ['$timeout', '$window'];
  /* ng-inject */
  function qr($timeout, $window) {
  
    return {
      restrict: 'E',
      template: '<canvas ng-hide="image"></canvas><img ng-if="image" ng-src="{{canvasImage}}"/>',
      scope: {
        typeNumber: '=',
        correctionLevel: '=',
        inputMode: '=',
        size: '=',
        text: '=',
        image: '='
      },
      controller: 'QrCtrl',
      link: function postlink(scope, element, attrs){
  
        if (scope.text === undefined) {
          throw new Error('The `text` attribute is required.');
        }
  
        const canvas = element.find('canvas')[0];
        const canvas2D = !!$window.CanvasRenderingContext2D;
  
        scope.TYPE_NUMBER = scope.getTypeNumeber();
        scope.TEXT = scope.getText();
        scope.CORRECTION = scope.getCorrection();
        scope.SIZE = scope.getSize();
        scope.INPUT_MODE = scope.getInputMode(scope.TEXT);
        scope.canvasImage = '';
  
        const draw = function(context, qr, modules, tile){
          for (let row = 0; row < modules; row++) {
            for (let col = 0; col < modules; col++) {
              let w = (Math.ceil((col + 1) * tile) - Math.floor(col * tile)),
                h = (Math.ceil((row + 1) * tile) - Math.floor(row * tile));
              context.fillStyle = qr.isDark(row, col) ? '#000' : '#fff';
              context.fillRect(Math.round(col * tile), Math.round(row * tile), w, h);
            }
          }
        };
  
        const render = function(canvas, value, typeNumber, correction, size, inputMode){
          const trim = /^\s+|\s+$/g;
          const text = value.replace(trim, '');
  
          const qr = new QRCode(typeNumber, correction, inputMode);
          qr.addData(text);
          qr.make();
  
          const context = canvas.getContext('2d');
  
          const modules = qr.getModuleCount();
          const tile = size / modules;
          canvas.width = canvas.height = size;
  
          if (canvas2D) {
            draw(context, qr, modules, tile);
            scope.canvasImage = canvas.toDataURL() || '';
          }
        };
  
        render(canvas, scope.TEXT, scope.TYPE_NUMBER, scope.CORRECTION, scope.SIZE, scope.INPUT_MODE);
  
        $timeout(function(){
          scope.$watch('text', function(value, old){
            if (value !== old) {
              scope.TEXT = scope.getText();
              scope.INPUT_MODE = scope.getInputMode(scope.TEXT);
              render(canvas, scope.TEXT, scope.TYPE_NUMBER, scope.CORRECTION, scope.SIZE, scope.INPUT_MODE);
            }
          });
  
          scope.$watch('correctionLevel', function(value, old){
            if (value !== old) {
              scope.CORRECTION = scope.getCorrection();
              render(canvas, scope.TEXT, scope.TYPE_NUMBER, scope.CORRECTION, scope.SIZE, scope.INPUT_MODE);
            }
          });
  
          scope.$watch('typeNumber', function(value, old){
            if (value !== old) {
              scope.TYPE_NUMBER = scope.getTypeNumeber();
              render(canvas, scope.TEXT, scope.TYPE_NUMBER, scope.CORRECTION, scope.SIZE, scope.INPUT_MODE);
            }
          });
  
          scope.$watch('size', function(value, old){
            if (value !== old) {
              scope.SIZE = scope.getSize();
              render(canvas, scope.TEXT, scope.TYPE_NUMBER, scope.CORRECTION, scope.SIZE, scope.INPUT_MODE);
            }
          });
  
          scope.$watch('inputMode', function(value, old){
            if (value !== old) {
              scope.INPUT_MODE = scope.getInputMode(scope.TEXT);
              render(canvas, scope.TEXT, scope.TYPE_NUMBER, scope.CORRECTION, scope.SIZE, scope.INPUT_MODE);
            }
          });
        });
  
      }
    };
  }
  
})(window.QRCode);
(function(){
  'use strict';
    
  angular.module('common')
    .controller('QrCtrl', ctrl);
    
  ctrl.$inject = ['$scope'];
  /* ng-inject */
  function ctrl($scope) {

    $scope.getTypeNumeber = function(){
      return $scope.typeNumber || 0;
    };
    
    $scope.getCorrection = function(){
      const levels = {
        'L': 1,
        'M': 0,
        'Q': 3,
        'H': 2
      };
    
      const correctionLevel = $scope.correctionLevel || 0;
      return levels[correctionLevel] || 0;
    };
    
    $scope.getText = function(){
      return $scope.text || '';
    };
    
    $scope.getSize = function(){
      return $scope.size || 250;
    };
    
    $scope.isNUMBER = function(text){
      const ALLOWEDCHARS = /^[0-9]*$/;
      return ALLOWEDCHARS.test(text);
    };
    
    $scope.isALPHA_NUM = function(text){
      const ALLOWEDCHARS = /^[0-9A-Z $%*+\-./:]*$/;
      return ALLOWEDCHARS.test(text);
    };
    
    $scope.is8bit = function(text){
      for (let i = 0; i < text.length; i++) {
        const code = text.charCodeAt(i);
        if (code > 255) {
          return false;
        }
      }
      return true;
    };
    
    $scope.checkInputMode = function(inputMode, text){
      if (inputMode === 'NUMBER' && !$scope.isNUMBER(text)) {
        throw new Error('The `NUMBER` input mode is invalid for text.');
      }
      else if (inputMode === 'ALPHA_NUM' && !$scope.isALPHA_NUM(text)) {
        throw new Error('The `ALPHA_NUM` input mode is invalid for text.');
      }
      else if (inputMode === '8bit' && !$scope.is8bit(text)) {
        throw new Error('The `8bit` input mode is invalid for text.');
      }
      else if (!$scope.is8bit(text)) {
        throw new Error('Input mode is invalid for text.');
      }
    
      return true;
    };
    
    $scope.getInputMode = function(text){
      let inputMode = $scope.inputMode;
      inputMode = inputMode || ($scope.isNUMBER(text) ? 'NUMBER' : undefined);
      inputMode = inputMode || ($scope.isALPHA_NUM(text) ? 'ALPHA_NUM' : undefined);
      inputMode = inputMode || ($scope.is8bit(text) ? '8bit' : '');
    
      return $scope.checkInputMode(inputMode, text) ? inputMode : '';
    };
  }
    
})();
'use strict';

angular.module('ngXLSX', []);

(function() {
  'use strict';

  angular.module('ngXLSX').factory('XLSX', function() {
    if (typeof XLSX === 'undefined') {
      throw new Error('ngXLSX requires SheetJS XLSX library');
    }
    return XLSX;
  });

}).call(this);

'use strict';

/**
 * @ngdoc overview
 * @name ngPapaParse
 * @description
 * # ngPapaParse
 *
 * Main module of the application.
 */
angular.module('ngPapaParse', []);

(function() {
  'use strict';

  /**
    * @ngdoc service
    * @name ngPapaParse.Papa
    * @description
    * # Papa
    * Factory in the ngPapaParse.
   */
  angular.module('ngPapaParse').factory('Papa', function() {
    if (typeof Papa === 'undefined') {
      throw new Error('angular-PapaParse\'s JavaScript requires PapaParse');
    }
    return Papa;
  });

}).call(this);

(function () {
  'use strict';

  /* for now, we'll put metadata about available pages into a factory
     later we'll move this into a provider
     so that each application can register itself with the main app */
  angular
    .module('common')
    .factory('ZPPages', ZPPagesFactory);

  ZPPagesFactory.$inject = ['ZCLOUD_HOST', 'ZCLOUD_PORT', '$filter', 'UserService', 'PermPermissionStore'];

  function ZPPagesFactory(ZCLOUD_HOST, ZCLOUD_PORT, $filter, UserService, PermPermissionStore) {

    function getReferralLink() {
      const userData = UserService.getUserData();
      return `${userData.firstname}_${userData.surname}_${userData.company}`.replace(/ /gi, '_');
    }

    const factoryData = {
      manageClientPage: {
        name: 'Manage',
        icon: 'zmdi-city-alt',
        baseState: 'app.tabbed_app_framework.self_service_client_management_detail',
        sref: 'app.tabbed_app_framework.self_service_client_management_detail.account_settings',
        className: 'manage-account-link'
      },
      accountsPage: {
        name: 'Accounts',
        icon: 'zmdi-city-alt',
        baseState: 'app.homescreen_app_framework.clients',
        sref: 'app.homescreen_app_framework.clients.home',
        className: 'clients-link'
      },
      usersPage: {
        name: 'Users',
        icon: 'zmdi-accounts',
        baseState: 'app.homescreen_app_framework.users_home',
        sref: 'app.homescreen_app_framework.users_home',
        className: 'users-link'
      },
      formsPage: {
        name: 'Events',
        icon: 'zmdi-assignment-o',
        baseState: 'app.homescreen_app_framework.forms_home',
        sref: 'app.homescreen_app_framework.forms_home',
        className: 'events-link'
      },
      emailPage: {
        name: 'Emails',
        icon: 'zmdi-mail-send',
        baseState: 'app.homescreen_app_framework.email_home',
        sref: 'app.homescreen_app_framework.email_home',
        className: 'email-link'
      },
      listPage: {
        name: 'Lists',
        icon: 'zmdi-format-list-bulleted',
        baseState: 'app.homescreen_app_framework.lists_home',
        sref: 'app.homescreen_app_framework.lists_home',
        className: 'lists-link'
      },
      meshPage: {
        name: 'QR',
        icon: 'zmdi-remote-control',
        baseState: 'app.mesh',
        sref: null,
        href: `${ZCLOUD_HOST}:${ZCLOUD_PORT}/mesh`,
      },
      aiPage: {
        name: 'AI',
        svgicon: $filter('cdnAssets')('/images/svgs/icons/custom/ai-icon.svg'),
        baseState: null,
        sref: null,
        href: `${ZCLOUD_HOST}:${ZCLOUD_PORT}/ai/processor`,
      },
      showroomPage: {
        name: 'showroom',
        icon: 'zmdi-tv',
        baseState: 'app.showroom',
        sref: null,
        href: `${ZCLOUD_HOST}:${ZCLOUD_PORT}/showroom`,
      },
      oldShowroomPage: {
        name: 'Showroom',
        icon: 'zmdi-tv',
        baseState: 'app.oldshowroom.showroom',
        sref: 'app.oldshowroom.showroom.dashboard',
        className: ''
      },
      dataPage: {
        name: 'Data',
        icon: 'zmdi-storage',
        baseState: 'app.homescreen_app_framework_no_sidebar.data',
        sref: 'app.homescreen_app_framework_no_sidebar.data.dashboard',
        className: ''
      },
      bizcardPage: {
        name: 'Bizcard',
        icon: 'zmdi-account-box-mail',
        baseState: 'app.homescreen_app_framework_no_sidebar.bizcard.grouped-cards-view',
        sref: 'app.homescreen_app_framework_no_sidebar.bizcard.grouped-cards-view',
        className: ''
      },
      integrationPage: {
        name: 'Integration',
        icon: 'zmdi-swap',
        baseState: 'app.homescreen_app_framework.integration-home',
        sref: 'app.homescreen_app_framework.integration-home',
        className: ''
      },
      helpHubPage: {
        name: 'Help Hub',
        icon: 'zmdi-help',
        sref: null,
        href: 'http://help.zuant.com',
        className: 'help-hub-link',
        openInNew: true
      },
      referralPage: {
        name: 'Referral',
        icon: 'zmdi-link',
        sref: null,
        href: 'http://www.zuant.com/referral/?referral-code=' + getReferralLink(),
        className: 'help-hub-link',
        openInNew: true
      },
      logout: {
        name: 'Logout',
        icon: 'zmdi-sign-in',
        baseState: 'logout',
        sref: 'logout',
        className: 'logout-link'
      },
    };

    let primaryNavItems = [];
    let secondaryNavItems = [];
    let manageAccountDialogItems = [];

    init();

    function init(){
      const isClientMarketpoint = UserService.isClientMarketpoint();
      const isClientZuantAi = UserService.isClientZuantAI();
      if (isClientMarketpoint){
        primaryNavItems = [factoryData.accountsPage, factoryData.usersPage];
        secondaryNavItems = [factoryData.helpHubPage, factoryData.logout];
        manageAccountDialogItems = [
          factoryData.manageClientPage, factoryData.usersPage
        ];
        return;
      }

      if (isClientZuantAi){
        primaryNavItems = [factoryData.accountsPage, factoryData.usersPage, factoryData.aiPage];
        secondaryNavItems = [factoryData.helpHubPage, factoryData.logout];
        manageAccountDialogItems = [
          factoryData.manageClientPage, factoryData.usersPage, factoryData.aiPage
        ];
        return;
      }
      
      primaryNavItems = [factoryData.accountsPage, factoryData.manageClientPage, factoryData.usersPage, factoryData.formsPage, factoryData.emailPage, factoryData.listPage, factoryData.meshPage, factoryData.oldShowroomPage, factoryData.showroomPage, factoryData.bizcardPage, factoryData.dataPage, factoryData.integrationPage, factoryData.referralPage];
      secondaryNavItems = [factoryData.helpHubPage, factoryData.logout];
      manageAccountDialogItems = [
        factoryData.manageClientPage, factoryData.usersPage, factoryData.formsPage,
        factoryData.emailPage, factoryData.listPage, factoryData.showroomPage, 
        factoryData.oldShowroomPage, factoryData.bizcardPage, factoryData.dataPage,
        factoryData.integrationPage, factoryData.meshPage
      ];
    
    }

    return {
      getPrimaryNavItems: getPrimaryNavItems,
      getSecondaryNavItems: getSecondaryNavItems,
      getManageAccountDialogItems: getManageAccountDialogItems,
      updateVariablePagePaths: updateVariablePagePaths,
      factoryData: factoryData
    };

    function getPrimaryNavItems() {
      return primaryNavItems;
    }

    function getSecondaryNavItems() {
      return secondaryNavItems;
    }

    function getManageAccountDialogItems() {
      return manageAccountDialogItems;
    }
    

    function updateVariablePagePaths(clientId) {

      //reinitialise arrays incase of logout & back in.
      init();

      const permissionStore = PermPermissionStore.getStore();
      const manageClientPermissions = ['ZAM', 'ZUANT_ADMIN', 'ACC_MGMT_SETTINGS', 'ACC_MGMT_PERMISSIONS', 'ACC_MGMT_TOKENS', 'ACC_MGMT_PRIVACY_STATEMENTS', 'ACC_MGMT_TEAMS'];
      
      factoryData['manageClientPage'].srefObj = {
        _id: clientId
      };

      factoryData['usersPage'].srefObj = {
        _id: clientId
      };

      return Promise.all(
        Object.values(permissionStore)
          .filter(function (perm){
            return manageClientPermissions.indexOf(perm.permissionName) > -1;
          })
          .map(function (perm){
            return perm.validatePermission()
              .then(function (){
                return {
                  permissionName: perm.permissionName,
                  valid: true
                };
              })
              .catch(function (){
                return {
                  permissionName: perm.permissionName,
                  valid: false
                };
              });
          })
      )
        .then(function (clientPermissionsResults){
          const canManageAccount = clientPermissionsResults.filter(function (result){
            return result.valid;
          }).length > -1;

          //can't manage account so don't worry
          if (!canManageAccount) return;

          const isAccountManager = clientPermissionsResults.findIndex(function (result){
            return (result.permissionName === 'ZAM' && result.valid) || (result.permissionName === 'ZUANT_ADMIN' && result.valid);
          }) > -1;

          //user belongs to marketpoint need to show defualt manage button in dialog. Update base state too so permissions directive allows it to be displayed in dialog
          if (isAccountManager){
            factoryData.manageClientPage.sref = 'app.tabbed_app_framework.client_detail.account_settings';
            factoryData.manageClientPage.baseState = 'app.homescreen_app_framework.clients';

            const managePageIndex = primaryNavItems.findIndex(function (page){
              return page.name === 'Manage';
            });

            if (managePageIndex > -1){
              primaryNavItems.splice(managePageIndex, 1);
            }
            
            return;
          }

          const selfServiceManagementSettings = clientPermissionsResults.findIndex(function (result){
            return result.permissionName === 'ACC_MGMT_SETTINGS' && result.valid;
          }) > -1;


          const managePageIndex = primaryNavItems.findIndex(function (page){
            return page.name === 'Manage';
          });

          if (managePageIndex === -1){
            primaryNavItems.splice(1, 0, factoryData.manageClientPage);
          }
          
          //can manage settings so no need to tweak sref. Just return to default if tweaked previously
          if (selfServiceManagementSettings){
            factoryData.manageClientPage.sref = 'app.tabbed_app_framework.self_service_client_management_detail.account_settings';
            factoryData.manageClientPage.baseState = 'app.tabbed_app_framework.self_service_client_management_detail';
            return;
          }

          //cannot manage settings so we need to redirect
          for (const manageClientPermission of manageClientPermissions){
            const doesHaveManagementPermission = clientPermissionsResults.findIndex(function (result){
              return result.permissionName === manageClientPermission && result.valid;
            }) > -1;

            if (!doesHaveManagementPermission) continue;

            switch (manageClientPermission){
              case 'ACC_MGMT_PERMISSIONS':
                factoryData.manageClientPage.sref = 'app.tabbed_app_framework.self_service_client_management_detail.permissions.users-pool';
                return;
              case 'ACC_MGMT_TOKENS':
                factoryData.manageClientPage.sref = 'app.tabbed_app_framework.self_service_client_management_detail.consent_management';
                return;
              case 'ACC_MGMT_PRIVACY_STATEMENTS':
                factoryData.manageClientPage.sref = 'app.tabbed_app_framework.self_service_client_management_detail.privacy_statement_management';
                return;
              case 'ACC_MGMT_TEAMS':
                factoryData.manageClientPage.sref = 'app.tabbed_app_framework.self_service_client_management_detail.teams';
                return;
            }
          }

        });

    }
  }
})();

(function(){
  'use strict';
    
  angular
    .module('common')
    .component('zpOtp', {
      templateUrl: 'app/common/otp/otp.component.tmpl.html',
      controller: 'OtpController',
      bindings:{
        form: '<',
        otp: '=',
        invalid: '=',
        error: '='
      }
    })
    .controller('OtpController', ctrl);
  
  ctrl.$inject = [];
  /* ng-inject */
  function ctrl() {
  
    const vm = this;

    vm.otp1Value = null;
    vm.otp2Value = null;
    vm.otp3Value = null;
    vm.otp4Value = null;
    vm.otp5Value = null;
    vm.otp6Value = null;

    vm.otpChanged = function(){
      if (
        !vm.otp1Value || !vm.otp2Value || !vm.otp3Value ||
            !vm.otp4Value || !vm.otp5Value || !vm.otp6Value
      ){
        vm.otp = null;
        return;
      }

      vm.otp = parseInt(vm.otp1Value + vm.otp2Value + vm.otp3Value + vm.otp4Value + vm.otp5Value + vm.otp6Value);

    };

    vm.handlePaste = function($event){
      const pasteText = $event.originalEvent.clipboardData.getData('text/plain');
      for (let i = 0; i < pasteText.length; i++) {
        const char = pasteText[i];
        const nextIndex = i + 1;

        if (!/\d/.test(char) || i > 5) break;

        vm[`otp${nextIndex}Value`] = char;
        angular.forEach(vm.form.$$controls[i].$parsers, function (parser) {
          parser(char);
        });

        if (i < 6 && nextIndex === pasteText.length){
          const focusIndex = i === 5 ? nextIndex : nextIndex + 1;
          angular.element(document.getElementById(`otp-input-${focusIndex}`)).focus();
          vm.otpChanged();
        }

      }

      $event.preventDefault();
    };
  
  }
    
}());
    
(function(){
  'use strict';
    
  angular.module('common')
    .directive('numbersOnly', numbersOnly);
      
  numbersOnly.$inject = [];
  /* ng-inject */
  function numbersOnly() {
    
    return {
      require: 'ngModel',
      scope: {
        invalid: '='
      },
      link: function ($scope, element, attrs, ngModelCtrl){
        $scope.$watch('invalid', function (newValue){
          if (newValue){
            element.addClass('invalid');
            return;
          }

          element.removeClass('invalid');
        });

        function fromUser(text) {
          if (text) {
            const transformedInput = text.replace(/[^0-9]/g, '');

            element.addClass('active');
            $scope.invalid = false;

            if (transformedInput !== text) {
              ngModelCtrl.$setViewValue(transformedInput);
              ngModelCtrl.$render();
            }
            return transformedInput;
          }
          element.removeClass('active');
          return undefined;
        }            
        ngModelCtrl.$parsers.push(fromUser);
      }
    };
  }
})();
(function(){
  'use strict';
        
  angular.module('common')
    .directive('moveNextOnMax', moveNextOnMax);
          
  moveNextOnMax.$inject = [];
  /* ng-inject */
  function moveNextOnMax() {
        
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {

        function findFirstInput(){
          const inputs = element.siblings('input').addBack();
          const currentIndex = _.findIndex(inputs, function (input){
            return input.id === element[0].id;
          });

          let inputToFocus = inputs[currentIndex];
          for (let i = inputs.length - 1; i >= 0; i--) {
            if (inputs[i].value && inputs[i].value.length > 0) continue;

            inputToFocus = inputs[i];
          }

          inputToFocus.focus();
        }

        element.on('click', findFirstInput);

        element.on('input', function () {
          if (element.val().length === parseInt(attrs.maxlength, 10) && !attrs.lastinput) {
            const $nextElement = element.next('input');
            if ($nextElement.length) {
              $nextElement[0].focus();
            }
          }
        });

        element.on('keydown', function (e) {
          if (e.keyCode === 9 || e.keyCode === 32) { // Check if tab key or space is pressed
            e.preventDefault();
            return findFirstInput();
          }
            
          if (e.keyCode === 8 && element.val().length === 0) { // Check for delete key and empty input
            const $prevElement = element.prev('input');
            if ($prevElement.length) {
              $prevElement[0].focus();
            }
            return;
          }

          const selectionStart = element[0].selectionStart;
          const selectionEnd = element[0].selectionEnd;

          if (element.val().length === 1 && selectionStart === 0) {
            const inputVal = String.fromCharCode(e.keyCode);
            if (!(/^\d$/.test(inputVal))) return;

            element.val(inputVal);
            element.trigger('input');
            return;
          }

          if (element.val().length === 1 && selectionEnd === element.val().length && !attrs.lastinput){
            const $nextElement = element.next('input');
            if ($nextElement.length) {
              $nextElement[0].focus();
            }
          }
          
        });
      }
    };
        
  }
})();
(function(){
  'use strict';
      
  angular.module('common')
    .directive('countDown', countDown);
        
  countDown.$inject = ['$interval'];
  /* ng-inject */
  function countDown($interval) {
      
    return {
      scope: {
        timer: '=duration',
        callback: '&timeoutCallback'
      },
      restrict: 'E',
      template: '<span>{{minutes}}:{{seconds}}</span>',
      link: function (scope, element, attrs){
        
        scope.ipromise = $interval(function() {
          const minutes = parseInt(scope.timer / 60, 10);
          const seconds = parseInt(scope.timer % 60, 10);
          
          scope.minutes = minutes < 10 ? '0' + minutes : minutes;
          scope.seconds = seconds < 10 ? '0' + seconds : seconds;
          if(scope.timer > 0){
            scope.timer--;   
          }else{
            scope.callback();
            $interval.cancel(scope.ipromise);
          }
        }, 1000);
      }
    };
      
  }
})();
/**
 * Created by davidbeazer on 06/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('common')
    .directive('zpNavClick', zpNavClick);

  zpNavClick.$inject = ['$location', '$parse', 'EncodingService'];
  function zpNavClick($location, $parse, encoder) {
    return {
      link: link
    };

    function link ( scope, element, attr ) {

      element.bind( 'click', function () {
        scope.$apply( function () {
          if(attr.encodeUri){ // was (!!attr.encodeUri)
            // $log.info('have component to encode');
            var fn = $parse(attr['encodeUri']);
            // $log.info(fn(scope));
            $location.path(attr.zpNavClick + encoder.encode(fn(scope)));
          } else {
            $location.path(attr.zpNavClick);
          }
        });
      });
    }
  }

})();

(function (){
  'use strict';

  angular
    .module('common')
    .factory('ZPModel', Model);

  Model.$inject = [];
  function Model() {

    function cleanObject (obj) {
      for (var prop in obj){
        var p = obj[prop];
        if (undefined === p) {
          delete obj[prop];
        } else if (angular.isArray(p)) {
          obj[prop] = p.map(cleanObject);
        } else if (angular.isObject(p)) {
          obj[prop] = cleanObject[p];
        }
      }
      return obj;
    }

    function equalObjects(a, b){
      return angular.equals(cleanObject(a), cleanObject(b));
    }

    return {
      cleanObject: cleanObject,
      equalObjects: equalObjects
    };
  }
})();

/**
 * Created by davidbeazer on 08/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('common')
    .factory('RelayNotificationService', RelayNotificationService);

  RelayNotificationService.$inject = ['$rootScope'];
  /* ng-inject */
  function RelayNotificationService($rootScope) {

    var services = {
      relayEvent: relayEvent
    };

    return services;

    function relayEvent(msg) {
      if(msg.level === 'broadcast'){
        $rootScope.$broadcast(msg.eventName, msg);
      }
    }
  }

})();

(function () {
  'use strict';

  /* eslint no-undef: 0 */
  angular
    .module('zp.message')
    .service('MessageService', MessageService);

  MessageService.$inject = ['$mdToast', '$mdDialog', '$mdMedia', '$document', 'SessionService', 'WriteLogToServerFactory', '$timeout'];
  /* ng-inject */
  function MessageService($mdToast, $mdDialog, $mdMedia, $document, SessionService, WriteLogToServerFactory, $timeout) {

    const MessageService = function MessageSvc() {};
    let errorMessageToShowUser;
    const factoryData = {
      devLogs: []
    };

    MessageService.prototype.modalIsShown = false;

    // TODO rename to local log or something more descriptive!
    MessageService.prototype.pushDevLog = function (logObj) {
      factoryData.devLogs.push(logObj);
    };

    MessageService.prototype.clearDevLogs = function () {
      factoryData.devLogs.length = 0;
    };

    MessageService.prototype.factoryData = factoryData;

    MessageService.prototype.pushEventToIntercom = function (eventName, params) {
      params = _.extend(params, {
        db: SessionService.getUserData().databasename
      });
      window.Intercom('trackEvent', eventName, params);
    };

    /** simulate a page load (optionally update some user or company data), updates Intercom with that info and triggers any messages to send */
    MessageService.prototype.updateIntercom = function (optionalUpdateObj) {
      const updateObject = _.extend({}, {
        email: SessionService.getUserData().email
      }, optionalUpdateObj);
      window.Intercom('update', updateObject);
    };

    MessageService.prototype.writeLog = function (message) {
      message.msg = JSON.stringify(message.msg);
      WriteLogToServerFactory.writeLog(message);
    };

    MessageService.prototype.showMessageWithAction = function showMessage(title, message) {
      errorMessageToShowUser = message;
      $mdToast.show({
        hideDelay: 5000,
        position: 'top right',
        controller: 'zpActionableToastCtrl',
        controllerAs: 'vm',
        templateUrl: 'app/common/message/zp-actionable-toast/toast-with-action.tmpl.html',
        locals: {
          title: title
        }
      });
    };

    MessageService.prototype.confirm = function confirm(srcEvent) {
      return {
        delete: function confirmDelete(msg) {
          return $mdDialog.show(
            $mdDialog.confirm()
              .title(msg)
              .textContent('This cannot be undone')
              .multiple(true)
              .ariaLabel('Confirm Deletion')
              .targetEvent(srcEvent)
              .ok('Yes, delete')
              .cancel('Cancel')
          );
        },
        confirmAction: function confirmAction(msg) {
          return $mdDialog.show(
            $mdDialog.confirm()
              .title(msg.title)
              .textContent(msg.content)
              .htmlContent(msg.htmlContent)
              .multiple(true)
              .ariaLabel('Confirm Action')
              .targetEvent(srcEvent)
              .ok(msg.okBtn)
              .cancel(msg.cancelBtn)
          );
        },
        confirmActionWithInput: function confirmActionWithInput(msg) {
          return $mdDialog.show({
            templateUrl: 'app/common/message/custom-dialogs/confirm-action-with-input/confirm-action-with-input.tmpl.html',
            controller: ['$scope', function ($scope) {
              $scope.msg = msg;
              $scope.userInput = '';
            
              $scope.submit = function () {
                $mdDialog.hide();
              };
            
              $scope.cancel = function () {
                $mdDialog.cancel();
              };
            }]
          });
        },
        archive: function confirmArchive(msg) {
          return $mdDialog.show(
            $mdDialog.confirm()
              .title(msg)
              .textContent('')
              .multiple(true)
              .ariaLabel('Confirm Archive')
              .targetEvent(srcEvent)
              .ok('Yes, archive')
              .cancel('Cancel')
          );
        },
        unarchive: function confirmArchive(msg) {
          return $mdDialog.show(
            $mdDialog.confirm()
              .title(msg)
              .textContent('')
              .multiple(true)
              .ariaLabel('Confirm Unarchive')
              .targetEvent(srcEvent)
              .ok('Yes, unarchive')
              .cancel('Cancel')
          );
        },
        createItemWithInput: function createItemWithInput(msg) {
          return $mdDialog.show({
            templateUrl: 'app/common/message/custom-dialogs/create-item-with-input/create-item-with-input.tmpl.html',
            multiple: true,
            controller: ['$scope', function ($scope) {
              $scope.msg = msg;
              $scope.userInput = msg.userInput || '';
            
              $scope.submit = function () {
                $mdDialog.hide($scope.userInput);
              };
            
              $scope.cancel = function () {
                $mdDialog.cancel();
              };
            }]
          });
        },
        sendPassword: function confirmSend(msg) {
          return $mdDialog.show(
            $mdDialog.confirm()
              .title(msg)
              .textContent('This will send an email to them')
              .multiple(true)
              .ariaLabel('Confirm password email send')
              .targetEvent(srcEvent)
              .ok('Yes, send')
              .cancel('Cancel')
          );
        },
        promptUserForRowSelection: function promptUser(msg) {
          return $mdDialog.show(
            $mdDialog.confirm()
              .title('Please specify selection')
              .textContent('Would you like to ' + msg.action + ' only the ' + msg.querySize + ' rows from this page, or all rows?')
              .multiple(true)
              .ariaLabel('Selection')
              .targetEvent(srcEvent)
              .ok('All ' + msg.allDataLength + ' rows')
              .cancel(msg.querySize + ' rows only')
          );
        },
        showErrorMessage: function promptUser() {
          return $mdDialog.show(
            $mdDialog.confirm()
              .title('Error message:')
              .htmlContent(errorMessageToShowUser)
              .multiple(true)
              .ariaLabel('Selection')
              .targetEvent(srcEvent)
              .ok('Close')
          );
        },
        showInfoDialog: function infoDialog(msg, title) {
          return $mdDialog.show(
            $mdDialog.confirm()
              .title(title)
              .textContent(msg)
              .multiple(true)
              .ariaLabel(title)
              .targetEvent(srcEvent)
              .ok('Close')
          );
        }
      };
    };

    MessageService.prototype.showDialog = function showDialog(srcEvent, config) {
      const useFullScreen = ($mdMedia('sm') || $mdMedia('xs') || config.useFullScreen);
      this.modalIsShown = true;
      return $mdDialog.show({
        controller: config.controller,
        controllerAs: config.controllerAs,
        templateUrl: config.templateUrl,
        template: config.template,
        parent: angular.element($document.body),
        locals: config.locals,
        targetEvent: srcEvent,
        clickOutsideToClose: config.clickOutsideToClose,
        fullscreen: useFullScreen,
        multiple: config.allowMultiple || false,
        focusOnOpen: config.focusOnOpen === undefined ? true : config.focusOnOpen
      });

    };

    MessageService.prototype.cancelDialog = function cancelDialog() {
      this.modalIsShown = false;
      return $mdDialog.cancel();
    };

    MessageService.prototype.closeDialog = function closeDialog(returnValue) {
      this.modalIsShown = false;
      return $mdDialog.hide(returnValue);
    };

    MessageService.prototype.closeToast = function closeToast() {
      $mdToast.hide();
    };

    // grouping a bunch of toasts fired in quick succession and not displaying if they are same message. Place to get to is a more informative toast with a counter to show how many of same message are being displayed. Think app badge notification icon
    const stack = [];
    let debounce;
    let lastMsg;
    const cooldown = 500;

    MessageService.prototype.showMessage = function showMessage(message) {
      if (message !=null){
        const options = {
          message: message
        };
        hideDelay(options, 2500);
        internalShow(basicToast(options));
      }
    };

    function hideDelay(options, delay) {
      if (options.hideDelay == undefined) {
        options.hideDelay = delay;
      }
    }

    /**
     * We defer the showing in case too many toast are created in too little time (seems to be an issue with ng-material).
     *
     * @param toast
     */
    function internalShow(toast) {
      (function () {
        if (lastMsg === toast.locals.message) {
          $timeout.cancel(debounce);
        }
        lastMsg = toast.locals.message;
        debounce = $timeout(function () {
          lastMsg = null;
          // we stack toasts with different msg not showing within 500 millis (cooldown)
          stack.push(toast);
          if (stack.length === 1) {
            showStacked();
          }
        }, cooldown);
      })();
    }

    function showStacked() {
      if (!stack.length) return;
      const toast = stack[0];

      $mdToast.show(
        $mdToast.simple()
          .textContent(toast.locals.message)
          .position(toast.position)
          .hideDelay(toast.hideDelay)
      ).then(function () {
        stack.shift();
        showStacked();
      });
    }

    function basicToast(options) {
      return {
        locals: {
          message: options.message
        },
        position: 'bottom left',
        hideDelay: options.hideDelay
      };
    }

    return new MessageService();
  }
}());

/**
 * Created by davidbeazer on 06/06/17
 */
(function () {
  'use strict';

  angular
    .module('common')
    .factory('WriteLogToServerFactory', WriteLogToServerFactory);

  WriteLogToServerFactory.$inject = ['APIService', 'SessionService', 'EnvService', 'localStorageService'];
  /* ng-inject */
  function WriteLogToServerFactory(api, SessionService, envSvc, localStorageService) {

    var services = {
      writeLog: writeLog
    };

    return services;

    /* Logs come from the MessageService and look like
      MessageService.writeLog({
        level: 'info',
        msg: 'Z-log: user has successfully logged in',
        tags: ['an array of string tags', 'that might be helpful for debugging!']
      });
    */
    function writeLog(logMsg) {
      var userData = SessionService.getUserData(),
        data = buildLogData(logMsg, userData);

      var apiUrl = 'logs';
      return api.post(apiUrl, data)
        .then(function (res) {
          return res;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function buildLogData(logMsg, userData) {

      var concatenatedTagsArray = [],
        message,
        userLogTags = localStorageService.get('logTags');

      if (!userLogTags) userLogTags = [];
      if (!logMsg.tags) logMsg.tags = [];
      concatenatedTagsArray = logMsg.tags.concat(userLogTags);

      if (logMsg.level === 'info') {
        // message = '✅ ' + logMsg.msg;
        message = 'ℹ️ ' + logMsg.msg;
      }
      if (logMsg.level === 'warn') {
        message = '⚠️ ' + logMsg.msg;
      }
      if (logMsg.level === 'error') {
        message = '🛑 ' + logMsg.msg;
      }

      return {
        repo: 'zuant_front_end',
        ver: envSvc.app_version,
        host: envSvc.api.host,
        inf: envSvc.infrastructure,
        level: logMsg.level,
        user: userData.email,
        dbname: userData.databasename,
        msg: message,
        err: logMsg.err,
        tags: concatenatedTagsArray
      };
    }

  }

})();

/**
 * Created by davidbeazer on 06/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('common')
    .component('zpContextMenu', {
      templateUrl: 'app/common/menus/zp-context-menu.tmpl.html',
      bindings: {
        menuOptions: '<',
        menuWidth: '<',
        onMenuClick: '&'
      },
      controller: 'zpContextMenuCtrl'
    })
    .controller('zpContextMenuCtrl', zpContextMenuCtrl);

  zpContextMenuCtrl.$inject = [];
  /* ng-inject */
  function zpContextMenuCtrl() {

    var vm = this;

    vm.menuWidth = vm.menuWidth | 3;
    // MENU FUNCTIONS
    vm.openMenu = function (func, ev) {
      func(ev);
    };

    vm.onMenuItemClick = function (action, ev) {
      vm.onMenuClick(action, ev);
    };

    vm.$onInit = function () {};

  }
})();

/*
* Credit: Credit to angular md-tabs
*         All codes are based on md-tabs by angular material
* Reference: https://github.com/angular/material
*/

angular.module('md-steppers', [
  'material.core',
  'material.components.icon']);


/**
 * @ngdoc directive
 * @name mdSteppers
 * @module md-steppers
 *
 * @restrict E
 *
 * @description
 * TODO DOCS
 *
 */
angular
  .module('md-steppers')
  .directive('mdSteppers', MdSteppers);

function MdSteppers() {
  return {
    scope: {
      selectedIndex: '=?mdSelected',
      busy: '=?mdBusy',
      disableTabsBehavior: '=?mdDisableTabsBehavior'
    },
    template: function(element, attr) {
      attr['$mdSteppersTemplate'] = element.html();

      var ngClick = attr.mdDisableTabsBehavior ?
        '' :
        'ng-click="$mdSteppersCtrl.select(step.getIndex())" ';
      var mdStepClass = attr.mdDisableTabsBehavior ? 'class="md-step md-step-nopointer" ': 'class="md-step" ';
      return ['',
        '<md-steppers-wrapper> ',
        '<md-step-data></md-step-data> ' ,
        // '<md-prev-button ' ,
        //     'tabindex="-1" ' ,
        //     'role="button" ' ,
        //     'aria-label="Previous Page" ' ,
        //     'aria-disabled="{{!$mdSteppersCtrl.canPageBack()}}" ' ,
        //     'ng-class="{ \'md-disabled\': !$mdSteppersCtrl.canPageBack() }" ' ,
        //     'ng-if="$mdSteppersCtrl.shouldPaginate" ' ,
        //     'ng-click="$mdSteppersCtrl.previousPage()"> ' ,
        //   '<md-icon md-svg-icon="md-tabs-arrow"></md-icon> ' ,
        // '</md-prev-button> ' ,
        // '<md-next-button ' ,
        //     'tabindex="-1" ' ,
        //     'role="button" ' ,
        //     'aria-label="Next Page" ' ,
        //     'aria-disabled="{{!$mdSteppersCtrl.canPageForward()}}" ' ,
        //     'ng-class="{ \'md-disabled\': !$mdSteppersCtrl.canPageForward() }" ' ,
        //     'ng-if="$mdSteppersCtrl.shouldPaginate" ' ,
        //     'ng-click="$mdSteppersCtrl.nextPage()"> ' ,
        //   '<md-icon md-svg-icon="md-tabs-arrow"></md-icon> ' ,
        // '</md-next-button> ' ,
        '<md-steppers-canvas ',
        'tabindex="{{ $mdSteppersCtrl.hasFocus ? -1 : 0 }}" ',
        'aria-activedescendant="step-item-{{$mdSteppersCtrl.steppers[$mdSteppersCtrl.focusIndex].id}}" ',
        'ng-focus="$mdSteppersCtrl.redirectFocus()" ',
        'ng-class="{ ',
        '\'md-paginated\': $mdSteppersCtrl.shouldPaginate, ',
        '\'md-center-steppers\': $mdSteppersCtrl.shouldCenterSteppers ',
        '}" ',
        'ng-keydown="$mdSteppersCtrl.keydown($event)" ',
        'role="tablist"> ',
        '<md-pagination-wrapper ',
        'ng-class="{ \'md-center-steppers\': $mdSteppersCtrl.shouldCenterSteppers }" ',
        'md-step-scroll="$mdSteppersCtrl.scroll($event)"> ',
        '<md-step-item ',
        'tabindex="-1" ',
        mdStepClass,
        'style="max-width: {{ $mdSteppersCtrl.maxStepWidth + \'px\' }}" ',
        'ng-repeat="step in $mdSteppersCtrl.steppers" ',
        'role="tab" ',
        'aria-controls="step-content-{{::step.id}}" ',
        'aria-selected="{{step.isActive()}}" ',
        'aria-disabled="{{step.scope.disabled || \'false\'}}" ',
        ngClick,
        'ng-class="{ ',
        '\'md-active\':    step.isActive(), ',
        '\'md-focused\':   step.hasFocus(), ',
        '\'md-disabled\':  step.scope.disabled, ',
        '\'md-complete\':  step.scope.complete ',
        '}" ',
        'ng-disabled="step.scope.disabled" ',
        'md-swipe-left="$mdSteppersCtrl.nextPage()" ',
        'md-swipe-right="$mdSteppersCtrl.previousPage()" ',
        'md-scope="::step.parent"><md-step-label-wrapper ',
        'stepindex="{{::$index+1}}" ',
        'md-steppers-template="::step.label" ',
        'md-scope="::step.parent" ',
        '></md-step-label-wrapper>',
        '</md-step-item> ',
        //'<md-ink-bar></md-ink-bar> ' ,
        '</md-pagination-wrapper> ',
        '<div class="md-visually-hidden md-dummy-wrapper"> ',
        '<md-dummy-step ',
        'class="md-step" ',
        'tabindex="-1" ',
        'stepindex="{{::$index+1}}" ',
        'id="step-item-{{::step.id}}" ',
        'role="tab" ',
        'aria-controls="step-content-{{::step.id}}" ',
        'aria-selected="{{step.isActive()}}" ',
        'aria-disabled="{{step.scope.disabled || \'false\'}}" ',
        'ng-focus="$mdSteppersCtrl.hasFocus = true" ',
        'ng-blur="$mdSteppersCtrl.hasFocus = false" ',
        'ng-repeat="step in $mdSteppersCtrl.steppers" ',
        'md-scope="::step.parent"><md-step-label-wrapper ',
        'stepindex="{{::$index+1}}" ',
        'md-steppers-template="::step.label" ',
        'md-scope="::step.parent" ',
        '></md-step-label-wrapper></md-dummy-step> ',
        '</div> ',
        '</md-steppers-canvas> ',
        '</md-steppers-wrapper> ',
        '<md-steppers-content-wrapper ng-show="$mdSteppersCtrl.hasContent && $mdSteppersCtrl.selectedIndex >= 0"> ',
        '<md-step-content ',
        'id="step-content-{{::step.id}}" ',
        'role="tabpanel" ',
        'aria-labelledby="step-item-{{::step.id}}" ',
        'md-swipe-left="$mdSteppersCtrl.swipeContent && $mdSteppersCtrl.incrementIndex(1)" ',
        'md-swipe-right="$mdSteppersCtrl.swipeContent && $mdSteppersCtrl.incrementIndex(-1)" ',
        'ng-if="$mdSteppersCtrl.hasContent" ',
        'ng-repeat="(index, step) in $mdSteppersCtrl.steppers" ',
        'ng-class="{ ',
        '\'md-no-transition\': $mdSteppersCtrl.lastSelectedIndex == null, ',
        '\'md-active\':        step.isActive(), ',
        '\'md-left\':          step.isLeft(), ',
        '\'md-right\':         step.isRight(), ',
        '\'md-no-scroll\':     $mdSteppersCtrl.dynamicHeight ',
        '}"> ',
        '<md-busy ng-show="step.scope.busy">',
        '<md-progress-circular md-diameter="80px" md-mode="indeterminate" class="md-accent"></md-progress-circular>',
        '</md-busy>',
        '<div ',
        'md-steppers-template="::step.template" ',
        'md-connected-if="step.isActive()" ',
        'md-scope="::step.parent" ',
        'ng-if="$mdSteppersCtrl.enableDisconnect || step.shouldRender()"></div> ',
        '</md-step-content> ',
        '</md-steppers-content-wrapper>'].join('');
    },
    controller: 'MdSteppersController',
    controllerAs: '$mdSteppersCtrl',
    bindToController: true
  };
}

MdSteppersController.$inject = ['$scope', '$element', '$window', '$mdConstant', '$mdStepInkRipple', '$mdUtil', '$animateCss', '$attrs', '$compile', '$mdTheming'];angular
  .module('md-steppers')
  .controller('MdSteppersController', MdSteppersController);

/**
 * @ngInject
 */
function MdSteppersController($scope, $element, $window, $mdConstant, $mdStepInkRipple,
  $mdUtil, $animateCss, $attrs, $compile, $mdTheming) {
  // define private properties
  var ctrl = this,
    locked = false,
    elements = getElements(),
    queue = [],
    destroyed = false,
    loaded = false;

  // define one-way bindings
  defineOneWayBinding('stretchSteppers', handleStretchSteppers);

  // define public properties with change handlers
  defineProperty('focusIndex', handleFocusIndexChange, ctrl.selectedIndex || 0);
  defineProperty('offsetLeft', handleOffsetChange, 0);
  defineProperty('hasContent', handleHasContent, false);
  defineProperty('maxStepWidth', handleMaxStepWidth, getMaxStepWidth());
  defineProperty('shouldPaginate', handleShouldPaginate, false);

  // define boolean attributes
  defineBooleanAttribute('noInkBar', handleInkBar, true);
  defineBooleanAttribute('dynamicHeight', handleDynamicHeight);
  defineBooleanAttribute('noPagination');
  defineBooleanAttribute('swipeContent');
  defineBooleanAttribute('noDisconnect');
  defineBooleanAttribute('autoselect');
  defineBooleanAttribute('centerSteppers', handleCenterSteppers, true);
  defineBooleanAttribute('enableDisconnect');

  // define public properties
  ctrl.scope = $scope;
  ctrl.parent = $scope.$parent;
  ctrl.steppers = [];
  ctrl.lastSelectedIndex = null;
  ctrl.hasFocus = false;
  ctrl.lastClick = true;
  ctrl.shouldCenterSteppers = shouldCenterSteppers();

  // define public methods
  ctrl.updatePagination = $mdUtil.debounce(updatePagination, 100);
  ctrl.redirectFocus = redirectFocus;
  ctrl.attachRipple = attachRipple;
  ctrl.insertStep = insertStep;
  ctrl.removeStep = removeStep;
  ctrl.select = select;
  ctrl.scroll = scroll;
  ctrl.nextPage = nextPage;
  ctrl.previousPage = previousPage;
  ctrl.keydown = keydown;
  ctrl.canPageForward = canPageForward;
  ctrl.canPageBack = canPageBack;
  ctrl.refreshIndex = refreshIndex;
  ctrl.incrementIndex = incrementIndex;
  ctrl.getStepElementIndex = getStepElementIndex;
  ctrl.updateInkBarStyles = $mdUtil.debounce(updateInkBarStyles, 100);
  ctrl.updateStepOrder = $mdUtil.debounce(updateStepOrder, 100);

  init();

  /**
   * Perform initialization for the controller, setup events and watcher(s)
   */
  function init() {
    ctrl.selectedIndex = ctrl.selectedIndex || 0;
    compileTemplate();
    configureWatchers();
    bindEvents();
    $mdTheming($element);
    $mdUtil.nextTick(function() {
      updateHeightFromContent();
      adjustOffset();
      updateInkBarStyles();
      ctrl.steppers[ctrl.selectedIndex] && ctrl.steppers[ctrl.selectedIndex].scope.select();
      loaded = true;
      updatePagination();
    });
  }

  /**
   * Compiles the template provided by the user.  This is passed as an attribute from the steppers
   * directive's template function.
   */
  function compileTemplate() {
    var template = $attrs.$mdSteppersTemplate,
      element = angular.element(elements.data);
    element.html(template);
    $compile(element.contents())(ctrl.parent);
    delete $attrs.$mdSteppersTemplate;
  }

  /**
   * Binds events used by the steppers component.
   */
  function bindEvents() {
    angular.element($window).on('resize', handleWindowResize);
    $scope.$on('$destroy', cleanup);
  }

  /**
   * Configure watcher(s) used by Steppers
   */
  function configureWatchers() {
    $scope.$watch('$mdSteppersCtrl.selectedIndex', handleSelectedIndexChange);
  }

  /**
   * Creates a one-way binding manually rather than relying on Angular's isolated scope
   * @param key
   * @param handler
   */
  function defineOneWayBinding(key, handler) {
    var attr = $attrs.$normalize('md-' + key);
    if (handler) defineProperty(key, handler);
    $attrs.$observe(attr, function(newValue) {
      ctrl[key] = newValue;
    });
  }

  /**
   * Defines boolean attributes with default value set to true.  (ie. md-stretch-steppers with no value
   * will be treated as being truthy)
   * @param key
   * @param handler
   */
  function defineBooleanAttribute(key, handler) {
    var attr = $attrs.$normalize('md-' + key);
    if (handler) defineProperty(key, handler);
    if ($attrs.hasOwnProperty(attr)) updateValue($attrs[attr]);
    $attrs.$observe(attr, updateValue);
    function updateValue(newValue) {
      ctrl[key] = newValue !== 'false';
    }
  }

  /**
   * Remove any events defined by this controller
   */
  function cleanup() {
    destroyed = true;
    angular.element($window).off('resize', handleWindowResize);
  }

  // Change handlers

  /**
   * Toggles stretch steppers class and updates inkbar when step stretching changes
   * @param stretchSteppers
   */
  function handleStretchSteppers(stretchSteppers) {
    angular.element(elements.wrapper).toggleClass('md-stretch-steppers', shouldStretchSteppers());
    updateInkBarStyles();
  }

  function handleCenterSteppers(newValue) {
    ctrl.shouldCenterSteppers = shouldCenterSteppers();
  }

  function handleMaxStepWidth(newWidth, oldWidth) {
    if (newWidth !== oldWidth) {
      $mdUtil.nextTick(ctrl.updateInkBarStyles);
    }
  }

  function handleShouldPaginate(newValue, oldValue) {
    if (newValue !== oldValue) {
      ctrl.maxStepWidth = getMaxStepWidth();
      ctrl.shouldCenterSteppers = shouldCenterSteppers();
      $mdUtil.nextTick(function() {
        ctrl.maxStepWidth = getMaxStepWidth();
        adjustOffset(ctrl.selectedIndex);
      });
    }
  }

  /**
   * Add/remove the `md-no-step-content` class depending on `ctrl.hasContent`
   * @param hasContent
   */
  function handleHasContent(hasContent) {
    $element[hasContent ? 'removeClass' : 'addClass']('md-no-step-content');
  }

  /**
   * Apply ctrl.offsetLeft to the paging element when it changes
   * @param left
   */
  function handleOffsetChange(left) {
    var newValue = ctrl.shouldCenterSteppers ? '' : '-' + left + 'px';
    angular.element(elements.paging).css($mdConstant.CSS.TRANSFORM, 'translate3d(' + newValue + ', 0, 0)');
    $scope.$broadcast('$mdSteppersPaginationChanged');
  }

  /**
   * Update the UI whenever `ctrl.focusIndex` is updated
   * @param newIndex
   * @param oldIndex
   */
  function handleFocusIndexChange(newIndex, oldIndex) {
    if (newIndex === oldIndex) return;
    if (!elements.steppers[newIndex]) return;
    adjustOffset();
    redirectFocus();
  }

  /**
   * Update the UI whenever the selected index changes. Calls user-defined select/deselect methods.
   * @param newValue
   * @param oldValue
   */
  function handleSelectedIndexChange(newValue, oldValue) {
    if (newValue === oldValue) return;

    ctrl.selectedIndex = getNearestSafeIndex(newValue);
    ctrl.lastSelectedIndex = oldValue;
    ctrl.updateInkBarStyles();
    updateHeightFromContent();
    adjustOffset(newValue);
    $scope.$broadcast('$mdSteppersChanged');
    ctrl.steppers[oldValue] && ctrl.steppers[oldValue].scope.deselect();
    ctrl.steppers[newValue] && ctrl.steppers[newValue].scope.select();
  }

  function getStepElementIndex(stepEl) {
    var steppers = $element[0].getElementsByTagName('md-step');
    return Array.prototype.indexOf.call(steppers, stepEl[0]);
  }

  /**
   * Queues up a call to `handleWindowResize` when a resize occurs while the steppers component is
   * hidden.
   */
  function handleResizeWhenVisible() {
    // if there is already a watcher waiting for resize, do nothing
    if (handleResizeWhenVisible.watcher) return;
    // otherwise, we will abuse the $watch function to check for visible
    handleResizeWhenVisible.watcher = $scope.$watch(function() {
      // since we are checking for DOM size, we use $mdUtil.nextTick() to wait for after the DOM updates
      $mdUtil.nextTick(function() {
        // if the watcher has already run (ie. multiple digests in one cycle), do nothing
        if (!handleResizeWhenVisible.watcher) return;

        if ($element.prop('offsetParent')) {
          handleResizeWhenVisible.watcher();
          handleResizeWhenVisible.watcher = null;

          handleWindowResize();
        }
      }, false);
    });
  }

  // Event handlers / actions

  /**
   * Handle user keyboard interactions
   * @param event
   */
  function keydown(event) {
    switch (event.keyCode) {
      case $mdConstant.KEY_CODE.LEFT_ARROW:
        event.preventDefault();
        incrementIndex(-1, true);
        break;
      case $mdConstant.KEY_CODE.RIGHT_ARROW:
        event.preventDefault();
        incrementIndex(1, true);
        break;
      case $mdConstant.KEY_CODE.SPACE:
      case $mdConstant.KEY_CODE.ENTER:
        event.preventDefault();
        if (!locked)
          ctrl.selectedIndex = ctrl.focusIndex;
        break;
    }
    ctrl.lastClick = false;
  }

  /**
   * Update the selected index and trigger a click event on the original `md-step` element in order
   * to fire user-added click events.
   * @param index
   */
  function select(index) {
    const step = ctrl.steppers[index];
    const isAnyStepBusy = ctrl.steppers.findIndex((step)=> !!step.scope.busy) > -1;
    if (!locked && !(step.scope.complete && !step.scope.editable) && !isAnyStepBusy)
      ctrl.focusIndex = ctrl.selectedIndex = index;
    ctrl.lastClick = true;
    // nextTick is required to prevent errors in user-defined click events
    $mdUtil.nextTick(function() {
      ctrl.steppers[index].element.triggerHandler('click');
    }, false);
  }

  /**
   * When pagination is on, this makes sure the selected index is in view.
   * @param event
   */
  function scroll(event) {
    if (!ctrl.shouldPaginate) return;
    event.preventDefault();
    ctrl.offsetLeft = fixOffset(ctrl.offsetLeft - event.wheelDelta);
  }

  /**
   * Slides the steppers over approximately one page forward.
   */
  function nextPage() {
    var viewportWidth = elements.canvas.clientWidth,
      totalWidth = viewportWidth + ctrl.offsetLeft,
      i,
      step;
    for (i = 0; i < elements.steppers.length; i++) {
      step = elements.steppers[i];
      if (step.offsetLeft + step.offsetWidth > totalWidth) break;
    }
    ctrl.offsetLeft = fixOffset(step.offsetLeft);
  }

  /**
   * Slides the steppers over approximately one page backward.
   */
  function previousPage() {
    var i,
      step;
    for (i = 0; i < elements.steppers.length; i++) {
      step = elements.steppers[i];
      if (step.offsetLeft + step.offsetWidth >= ctrl.offsetLeft) break;
    }
    ctrl.offsetLeft = fixOffset(step.offsetLeft + step.offsetWidth - elements.canvas.clientWidth);
  }

  /**
   * Update size calculations when the window is resized.
   */
  function handleWindowResize() {
    ctrl.lastSelectedIndex = ctrl.selectedIndex;
    ctrl.offsetLeft = fixOffset(ctrl.offsetLeft);
    $mdUtil.nextTick(function() {
      ctrl.updateInkBarStyles();
      updatePagination();
    });
  }

  function handleInkBar(hide) {
    angular.element(elements.inkBar).toggleClass('ng-hide', hide);
  }

  /**
   * Toggle dynamic height class when value changes
   * @param value
   */
  function handleDynamicHeight(value) {
    $element.toggleClass('md-dynamic-height', value);
  }

  /**
   * Remove a step from the data and select the nearest valid step.
   * @param stepData
   */
  function removeStep(stepData) {
    if (destroyed) return;
    var selectedIndex = ctrl.selectedIndex,
      step = ctrl.steppers.splice(stepData.getIndex(), 1)[0];
    refreshIndex();
    // when removing a step, if the selected index did not change, we have to manually trigger the
    //   step select/deselect events
    if (ctrl.selectedIndex === selectedIndex) {
      step.scope.deselect();
      ctrl.steppers[ctrl.selectedIndex] && ctrl.steppers[ctrl.selectedIndex].scope.select();
    }
    $mdUtil.nextTick(function() {
      updatePagination();
      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft);
    });
  }

  /**
   * Create an entry in the steppers array for a new step at the specified index.
   * @param stepData
   * @param index
   * @returns {*}
   */
  function insertStep(stepData, index) {
    var hasLoaded = loaded;
    var proto = {
        getIndex: function() {
          return ctrl.steppers.indexOf(step);
        },
        isActive: function() {
          return this.getIndex() === ctrl.selectedIndex;
        },
        isLeft: function() {
          return this.getIndex() < ctrl.selectedIndex;
        },
        isRight: function() {
          return this.getIndex() > ctrl.selectedIndex;
        },
        shouldRender: function() {
          return !ctrl.noDisconnect || this.isActive();
        },
        hasFocus: function() {
          return !ctrl.lastClick
            && ctrl.hasFocus && this.getIndex() === ctrl.focusIndex;
        },
        id: $mdUtil.nextUid()
      },
      step = angular.extend(proto, stepData);
    if (angular.isDefined(index)) {
      ctrl.steppers.splice(index, 0, step);
    } else {
      ctrl.steppers.push(step);
    }
    processQueue();
    updateHasContent();
    $mdUtil.nextTick(function() {
      updatePagination();
      // if autoselect is enabled, select the newly added step
      if (hasLoaded && ctrl.autoselect) $mdUtil.nextTick(function() {
        $mdUtil.nextTick(function() {
          select(ctrl.steppers.indexOf(step));
        });
      });
    });
    return step;
  }

  // Getter methods

  /**
   * Gathers references to all of the DOM elements used by this controller.
   * @returns {{}}
   */
  function getElements() {
    var elements = {};

    // gather step bar elements
    elements.wrapper = $element[0].getElementsByTagName('md-steppers-wrapper')[0];
    elements.data = $element[0].getElementsByTagName('md-step-data')[0];
    elements.canvas = elements.wrapper.getElementsByTagName('md-steppers-canvas')[0];
    elements.paging = elements.canvas.getElementsByTagName('md-pagination-wrapper')[0];
    elements.steppers = elements.paging.getElementsByTagName('md-step-item');
    elements.dummies = elements.canvas.getElementsByTagName('md-dummy-step');
    elements.inkBar = elements.paging.getElementsByTagName('md-ink-bar')[0];

    // gather step content elements
    elements.contentsWrapper = $element[0].getElementsByTagName('md-steppers-content-wrapper')[0];
    elements.contents = elements.contentsWrapper.getElementsByTagName('md-step-content');

    return elements;
  }

  /**
   * Determines whether or not the left pagination arrow should be enabled.
   * @returns {boolean}
   */
  function canPageBack() {
    return ctrl.offsetLeft > 0;
  }

  /**
   * Determines whether or not the right pagination arrow should be enabled.
   * @returns {*|boolean}
   */
  function canPageForward() {
    var lastStep = elements.steppers[elements.steppers.length - 1];
    return lastStep && lastStep.offsetLeft + lastStep.offsetWidth > elements.canvas.clientWidth +
      ctrl.offsetLeft;
  }

  /**
   * Determines if the UI should stretch the steppers to fill the available space.
   * @returns {*}
   */
  function shouldStretchSteppers() {
    switch (ctrl.stretchSteppers) {
      case 'always':
        return true;
      case 'never':
        return false;
      default:
        return !ctrl.shouldPaginate
          && $window.matchMedia('(max-width: 600px)').matches;
    }
  }

  /**
   * Determines if the steppers should appear centered.
   * @returns {string|boolean}
   */
  function shouldCenterSteppers() {
    return ctrl.centerSteppers && !ctrl.shouldPaginate;
  }

  /**
   * Determines if pagination is necessary to display the steppers within the available space.
   * @returns {boolean}
   */
  function shouldPaginate() {
    if (ctrl.noPagination || !loaded) return false;
    var canvasWidth = $element.prop('clientWidth');
    angular.forEach(getElements().dummies, function(step) {
      canvasWidth -= step.offsetWidth;
    });
    return canvasWidth < 0;
  }

  /**
   * Finds the nearest step index that is available.  This is primarily used for when the active
   * step is removed.
   * @param newIndex
   * @returns {*}
   */
  function getNearestSafeIndex(newIndex) {
    if (newIndex === -1) return -1;
    var maxOffset = Math.max(ctrl.steppers.length - newIndex, newIndex),
      i,
      step;
    for (i = 0; i <= maxOffset; i++) {
      step = ctrl.steppers[newIndex + i];
      if (step && (step.scope.disabled !== true)) return step.getIndex();
      step = ctrl.steppers[newIndex - i];
      if (step && (step.scope.disabled !== true)) return step.getIndex();
    }
    return newIndex;
  }

  // Utility methods

  /**
   * Defines a property using a getter and setter in order to trigger a change handler without
   * using `$watch` to observe changes.
   * @param key
   * @param handler
   * @param value
   */
  function defineProperty(key, handler, value) {
    Object.defineProperty(ctrl, key, {
      get: function() {
        return value;
      },
      set: function(newValue) {
        var oldValue = value;
        value = newValue;
        handler && handler(newValue, oldValue);
      }
    });
  }

  /**
   * Updates whether or not pagination should be displayed.
   */
  function updatePagination() {
    if (!shouldStretchSteppers()) updatePagingWidth();
    ctrl.maxStepWidth = getMaxStepWidth();
    ctrl.shouldPaginate = shouldPaginate();
  }

  function updatePagingWidth() {
    var width = 1;
    angular.forEach(getElements().dummies, function(element) {
      width += Math.ceil(element.offsetWidth);
    });
    angular.element(elements.paging).css('width', width + 'px');
  }

  function getMaxStepWidth() {
    return $element.prop('clientWidth');
  }

  /**
   * Re-orders the steppers and updates the selected and focus indexes to their new positions.
   * This is triggered by `stepDirective.js` when the user's steppers have been re-ordered.
   */
  function updateStepOrder() {
    var selectedItem = ctrl.steppers[ctrl.selectedIndex],
      focusItem = ctrl.steppers[ctrl.focusIndex];
    ctrl.steppers = ctrl.steppers.sort(function(a, b) {
      return a.index - b.index;
    });
    ctrl.selectedIndex = ctrl.steppers.indexOf(selectedItem);
    ctrl.focusIndex = ctrl.steppers.indexOf(focusItem);
  }

  /**
   * This moves the selected or focus index left or right.  This is used by the keydown handler.
   * @param inc
   */
  function incrementIndex(inc, focus) {
    var newIndex,
      key = focus ? 'focusIndex' : 'selectedIndex';
    if (ctrl.steppers[newIndex]) {
      ctrl[key] = newIndex;
    }
  }

  /**
   * This is used to forward focus to dummy elements.  This method is necessary to avoid animation
   * issues when attempting to focus an item that is out of view.
   */
  function redirectFocus() {
    getElements().dummies[ctrl.focusIndex].focus();
  }

  /**
   * Forces the pagination to move the focused step into view.
   */
  function adjustOffset(index) {
    if (index == null)
      index = ctrl.focusIndex;
    if (!elements.steppers[index]) return;
    if (ctrl.shouldCenterSteppers) return;
    var step = elements.steppers[index],
      left = step.offsetLeft,
      right = step.offsetWidth + left;
    ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(right - elements.canvas.clientWidth + 32 * 2));
    ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(left));
  }

  /**
   * Iterates through all queued functions and clears the queue.  This is used for functions that
   * are called before the UI is ready, such as size calculations.
   */
  function processQueue() {
    queue.forEach(function(func) {
      $mdUtil.nextTick(func);
    });
    queue = [];
  }

  /**
   * Determines if the step content area is needed.
   */
  function updateHasContent() {
    var hasContent = false;
    angular.forEach(ctrl.steppers, function(step) {
      if (step.template)
        hasContent = true;
    });
    ctrl.hasContent = hasContent;
  }

  /**
   * Moves the indexes to their nearest valid values.
   */
  function refreshIndex() {
    ctrl.selectedIndex = getNearestSafeIndex(ctrl.selectedIndex);
    ctrl.focusIndex = getNearestSafeIndex(ctrl.focusIndex);
  }

  /**
   * Calculates the content height of the current step.
   * @returns {*}
   */
  function updateHeightFromContent() {
    if (!ctrl.dynamicHeight) return $element.css('height', '');
    if (!ctrl.steppers.length) return queue.push(updateHeightFromContent);

    var stepContent = elements.contents[ctrl.selectedIndex],
      contentHeight = stepContent ? stepContent.offsetHeight : 0,
      steppersHeight = elements.wrapper.offsetHeight,
      newHeight = contentHeight + steppersHeight,
      currentHeight = $element.prop('offsetHeight');

    // Adjusts calculations for when the buttons are bottom-aligned since this relies on absolute
    // positioning.  This should probably be cleaned up if a cleaner solution is possible.
    if ($element.attr('md-align-steppers') === 'bottom') {
      currentHeight -= steppersHeight;
      newHeight -= steppersHeight;
      // Need to include bottom border in these calculations
      if ($element.attr('md-border-bottom') !== undefined) ++currentHeight;
    }

    // Lock during animation so the user can't change steppers
    locked = true;

    var fromHeight = {
        height: currentHeight + 'px'
      },
      toHeight = {
        height: newHeight + 'px'
      };

    // Set the height to the current, specific pixel height to fix a bug on iOS where the height
    // first animates to 0, then back to the proper height causing a visual glitch
    $element.css(fromHeight);

    // Animate the height from the old to the new
    $animateCss($element, {
      from: fromHeight,
      to: toHeight,
      easing: 'cubic-bezier(0.35, 0, 0.25, 1)',
      duration: 0.5
    }).start().done(function() {
      // Then (to fix the same iOS issue as above), disable transitions and remove the specific
      // pixel height so the height can size with browser width/content changes, etc.
      $element.css({
        transition: 'none',
        height: ''
      });

      // In the next tick, re-allow transitions (if we do it all at once, $element.css is "smart"
      // enough to batch it for us instead of doing it immediately, which undoes the original
      // transition: none)
      $mdUtil.nextTick(function() {
        $element.css('transition', '');
      });

      // And unlock so step changes can occur
      locked = false;
    });
  }

  /**
   * Repositions the ink bar to the selected step.
   * @returns {*}
   */
  function updateInkBarStyles() {
    if (!elements.steppers[ctrl.selectedIndex]) {
      angular.element(elements.inkBar).css({
        left: 'auto',
        right: 'auto'
      });
      return;
    }
    if (!ctrl.steppers.length) return queue.push(ctrl.updateInkBarStyles);
    // if the element is not visible, we will not be able to calculate sizes until it is
    // we should treat that as a resize event rather than just updating the ink bar
    if (!$element.prop('offsetParent')) return handleResizeWhenVisible();
    var index = ctrl.selectedIndex,
      totalWidth = elements.paging.offsetWidth,
      step = elements.steppers[index],
      left = step.offsetLeft,
      right = totalWidth - left - step.offsetWidth,
      stepWidth;
    if (ctrl.shouldCenterSteppers) {
      stepWidth = Array.prototype.slice.call(elements.steppers).reduce(function(value, element) {
        return value + element.offsetWidth;
      }, 0);
      if (totalWidth > stepWidth) $mdUtil.nextTick(updateInkBarStyles, false);
    }
    updateInkBarClassName();
    //angular.element(elements.inkBar).css({ left: left + 'px', right: right + 'px' });
    angular.element(elements.inkBar).css({
      left: 32 + 'px',
      right: totalWidth - left + 'px'
    });
  }

  /**
   * Adds left/right classes so that the ink bar will animate properly.
   */
  function updateInkBarClassName() {
    var newIndex = ctrl.selectedIndex,
      oldIndex = ctrl.lastSelectedIndex,
      ink = angular.element(elements.inkBar);
    if (!angular.isNumber(oldIndex)) return;
    ink
      .toggleClass('md-left', newIndex < oldIndex)
      .toggleClass('md-right', newIndex > oldIndex);
  }

  /**
   * Takes an offset value and makes sure that it is within the min/max allowed values.
   * @param value
   * @returns {*}
   */
  function fixOffset(value) {
    if (!elements.steppers.length || !ctrl.shouldPaginate) return 0;
    var lastStep = elements.steppers[elements.steppers.length - 1],
      totalWidth = lastStep.offsetLeft + lastStep.offsetWidth;
    value = Math.max(0, value);
    value = Math.min(totalWidth - elements.canvas.clientWidth, value);
    return value;
  }

  /**
   * Attaches a ripple to the step item element.
   * @param scope
   * @param element
   */
  function attachRipple(scope, element) {
    if (!ctrl.disableTabsBehavior) {
      var options = {
        colorElement: angular.element(elements.inkBar)
      };
      $mdStepInkRipple.attach(scope, element, options);
    }
  }
}


MdSteppersTemplate.$inject = ['$compile', '$mdUtil'];angular
  .module('md-steppers')
  .directive('mdSteppersTemplate', MdSteppersTemplate);

function MdSteppersTemplate($compile, $mdUtil) {
  return {
    restrict: 'A',
    link: link,
    scope: {
      template: '=mdSteppersTemplate',
      connected: '=?mdConnectedIf',
      compileScope: '=mdScope'
    },
    require: '^?mdSteppers'
  };
  function link(scope, element, attr, ctrl) {
    if (!ctrl) return;
    var compileScope = ctrl.enableDisconnect ? scope.compileScope.$new() : scope.compileScope;
    element.html(scope.template);
    $compile(element.contents())(compileScope);
    element.on('DOMSubtreeModified', function () {
      ctrl.updatePagination();
      ctrl.updateInkBarStyles();
    });
    return $mdUtil.nextTick(handleScope);

    function handleScope() {
      scope.$watch('connected', function (value) { value === false ? disconnect() : reconnect(); });
      scope.$on('$destroy', reconnect);
    }

    function disconnect() {
      if (ctrl.enableDisconnect) $mdUtil.disconnectScope(compileScope);
    }

    function reconnect() {
      if (ctrl.enableDisconnect) $mdUtil.reconnectScope(compileScope);
    }
  }
}

/**
 * @ngdoc directive
 * @name mdStep
 * @module md-steppers
 *
 * @restrict E
 *
 * @description TODO DOCS
 * Based on md-tabs by angular material https://github.com/angular/material
 *
 */
angular
  .module('md-steppers')
  .directive('mdStep', MdStep);

function MdStep() {
  return {
    require: '^?mdSteppers',
    terminal: true,
    compile: function (element, attr) {
      var label = firstChild(element, 'md-step-label'),
        body = firstChild(element, 'md-step-body'),
        actions = firstChild(element, 'md-step-actions');

      if (label.length == 0) {
        label = angular.element('<md-step-label></md-step-label>');
        if (attr.label) label.text(attr.label);
        else label.append(element.contents());

        if (body.length == 0) {
          var contents = element.contents().detach();
          body = angular.element('<md-step-body></md-step-body>');
          body.append(contents);
        }
      }

      element.append(label);
      if (body.html()) element.append(body);

      return postLink;
    },
    scope: {
      busy: '=?mdBusy',
      complete: '=?mdComplete',
      editable: '=?mdEditable',
      active: '=?mdActive',
      disabled: '=?ngDisabled',
      select: '&?mdOnSelect',
      deselect: '&?mdOnDeselect'
    }
  };

  function postLink(scope, element, attr, ctrl) {
    if (!ctrl) return;
    var index = ctrl.getStepElementIndex(element),
      body = firstChild(element, 'md-step-body').remove(),
      label = firstChild(element, 'md-step-label').remove(),
      data = ctrl.insertStep({
        scope: scope,
        parent: scope.$parent,
        index: index,
        element: element,
        template: body.html(),
        label: label.html()
      }, index);

    scope.select = scope.select || angular.noop;
    scope.deselect = scope.deselect || angular.noop;
    scope.editable = scope.editable === undefined ? true : scope.editable;
    scope.complete = scope.complete || false;
    scope.busy = scope.busy || false;

    scope.$watch('active', function (active) { if (active) ctrl.select(data.getIndex()); });
    scope.$watch('editable', function () { ctrl.refreshIndex(); });
    scope.$watch('busy', function () { ctrl.refreshIndex(); });
    scope.$watch('complete', function () { ctrl.refreshIndex(); });
    scope.$watch('disabled', function () { ctrl.refreshIndex(); });
    scope.$watch(
      function () {
        return ctrl.getStepElementIndex(element);
      },
      function (newIndex) {
        data.index = newIndex;
        ctrl.updateStepOrder();
      }
    );
    scope.$on('$destroy', function () { ctrl.removeStep(data); });
  }

  function firstChild(element, tagName) {
    var children = element[0].children;
    for (var i = 0, len = children.length; i < len; i++) {
      var child = children[i];
      if (child.tagName === tagName.toUpperCase()) return angular.element(child);
    }
    return angular.element();
  }
}


MdStepScroll.$inject = ['$parse'];angular.module('md-steppers')
  .directive('mdStepScroll', MdStepScroll);

function MdStepScroll($parse) {
  return {
    restrict: 'A',
    compile: function ($element, attr) {
      var fn = $parse(attr.mdStepScroll, null, true);
      return function ngEventHandler(scope, element) {
        element.on('mousewheel', function (event) {
          scope.$apply(function () { fn(scope, { $event: event }); });
        });
      };
    }
  };
}

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name $mdStepInkRipple
   * @module md-steppers
   *
   * @description
   * TODO DOCS
   *
   */

  MdStepInkRipple.$inject = ['$mdInkRipple'];
  angular.module('md-steppers')
    .factory('$mdStepInkRipple', MdStepInkRipple);

  /**
    * @ngInject
    */
  function MdStepInkRipple($mdInkRipple) {
    return {
      attach: attach
    };

    function attach(scope, element, options) {
      return $mdInkRipple.attach(scope, element, angular.extend({
        center: false,
        dimBackground: true,
        outline: false,
        rippleSize: 'full'
      }, options));
    }
  }
})();

angular
  .module('md-steppers')
  .directive('mdStepLabel', MdStepLabel);

function MdStepLabel() {
  return { terminal: true };
}


angular
  .module('md-steppers')
  .directive('mdStepItem', MdStepItem);

function MdStepItem() {
  return {
    require: '^?mdSteppers',
    link: function link(scope, element, attr, ctrl) {
      if (!ctrl) return;
      ctrl.attachRipple(scope, element);
    }
  };
}

/**
 * Created by davidbeazer on 12/10/2016.
 */
(function () {
  'use strict';

  angular
    .module('common')
    .component('logoComponent', {
      templateUrl: 'app/common/logo-component/logo.component.html',
      bindings: {
        logoImage: '<',
        clientId: '<',
        onUpdate: '&',
        btnDisabled: '<',
        clearLogo: '&'
      },
      controller: componentController,
      controllerAs: 'vm'
    });

  componentController.$inject = ['$scope', 'MessageService', 'AWS_STORAGE_REGION', 'AWS_STORAGE_BUCKET_NAME', '$filter'];
  /* ng-inject */
  function componentController($scope, MessageService, awsStorageRegion, awsStorageBucketName, $filter) {

    var vm = this;
    
    vm.$onInit = function () {
      $scope.$on('zp.client-logo-updated', shapeLogoObj);
      $scope.$on('s3upload.progress', function ($event, progressPercentage){
        $scope.$applyAsync(function () {
          vm.workingLogoObj.metadata.progress = progressPercentage;
        });
      });

      shapeLogoObj();
    };

    vm.fileChanged = function ($event){
      const file = $event.target.files[0];
      const reader = new FileReader();

      reader.onload = function (event){
        const arrayBuffer = event.target.result;

        $scope.$apply(function () {
          vm.workingLogoObj.binary = file;
          delete vm.workingLogoObj._s3key;
          vm.workingLogoObj.base64 = arrayBufferToBase64(arrayBuffer);
          buildLogoSrcString();
        });

      };
      reader.readAsArrayBuffer(file);
    };

    vm.openFileSelector = function() {
      angular.element(document).find('#imageUploadInput').val(null);
      angular.element(document).find('#imageUploadInput').trigger('click');
    };

    vm.onClearLogo = function (ev) {
      MessageService.confirm(ev)
        .confirmAction({
          title: 'Clear account logo',
          content: 'This will remove the current logo, are you sure?',
          okBtn: 'Yes',
          cancelBtn: 'No'
        })
        .then(function () {
          vm.clearLogo();
        });
    };

    vm.triggerSizeAlert = function (imageDims) {
      $scope.$apply(function () {
        vm.workingLogoObj.metadata.imageWidth = imageDims.width;
        vm.workingLogoObj.metadata.imageHeight = imageDims.height;
      });
    };

    vm.saveLogoImage = function () {
      this.onUpdate({ logoObj: vm.workingLogoObj });
    };

    //PRIVATE

    function shapeLogoObj() {
      vm.workingLogoObj = angular.copy(vm.logoImage);
      if (!vm.workingLogoObj) vm.workingLogoObj = {};
      if (!vm.workingLogoObj.metadata) vm.workingLogoObj.metadata = {};
      buildLogoSrcString();
    }

    function buildLogoSrcString() {
      let src = $filter('cdnAssets')('/images/pngs/placeholders/account/logo_placeholder.png');
      let source = 'placeholder';

      if (vm.workingLogoObj._s3key || vm.workingLogoObj.base64) {
        source = 'uploaded';
        if (vm.workingLogoObj._s3key){
          src = `https://s3.${awsStorageRegion}.amazonaws.com/${awsStorageBucketName}/${vm.workingLogoObj._s3key}?timestamp=${vm.workingLogoObj._lastmodifiedonservertime}`;
        } else {
          src ='data:image/jpeg;base64,' + vm.workingLogoObj.base64;
        }
      }

      vm.workingLogoObj.src = src;
      vm.workingLogoObj.metadata.source = source;
    }

    function arrayBufferToBase64(arrayBuffer) {
      let binary = '';
      const bytes = new Uint8Array(arrayBuffer);
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('zpLink', ['$location', '$window', '$mdSidenav', function ($location, $window, $mdSidenav) {
      return function (scope, element, attrs) {
        var path = attrs.zpLink;

        element.bind('click', function () {
          // check to see if user is on a page which actually has mainNavigation sideNav on it (all routes with showAppToolbar have a sideNav)
          if ($mdSidenav('mainNavigation').isOpen()) {
            $mdSidenav('mainNavigation').close();
          }  

          if (scope.item && scope.item['openInNew']) {
            $window.open(path, '_blank');
          } else {
            scope.$apply(function () {
              $location.path(path);
            });
          }
        });

      };
    }]);
})();

(function () {
  'use strict';

  angular
    .module('common')
    .factory('ImagesFactory', ImagesFactory);

  ImagesFactory.$inject = ['ImageAPI', 'SessionService', 'EncodingService', 'AWS_STORAGE_REGION', 'AWS_STORAGE_BUCKET_NAME', '$filter'];

  function ImagesFactory(ImageAPI, session, encoder, awsStorageRegion, awsStorageBucketName, $filter) {

    return {
      getImageSrc: getImageSrc,
      getImageUrl: getImageUrl
    };

    function getImageSrc(imageId) {
      return ImageAPI.getImageById(imageId)
        .then(function (resp) {
          var image = new Image();
          if (resp.data.data.base64 || resp.data.data.imagebase64) {
            image.src = 'data:image/png;base64,' + (resp.data.data.base64 || resp.data.data.imagebase64);
          } else if (resp.data.data._s3key) {
            const s3Url = 'https://s3.' + awsStorageRegion + '.amazonaws.com/' + awsStorageBucketName + '/' + resp.data.data._s3key;
            image.src = s3Url;
          }
          return image.src;
        })
        .catch(function (err) {
          err.src = $filter('cdnAssets')('/images/svgs/utilities/404/image-404.svg');
          throw (err);
        });
    }

    function getImageUrl(imageId) {
      return 'https://portal.zuant.com/Imageserver/Image?clientdatabasename=' + session.getUserData().databasename + '&imageid='+ encoder.singleEncode(imageId) +'&rotation=0';
    }
  }

}());

(function () {
  'use strict';

  angular
    .module('common')
    .factory('ImageAPI', imageApi);

  imageApi.$inject = ['APIService','APIFactory'];
  /* ng-inject */
  function imageApi(api, apiFactory) {

    var imageApi = apiFactory.route('images');

    var services = {
      getAllImageDocs: imageApi.get,
      getImageById: imageApi.getById
    };

    return services;

    //////////////////////////////////

  }
})();

/**
 * Created by davidbeazer on 12/10/2016.
 */
(function () {
  'use strict';

  angular
    .module('common')
    .directive('imageSizeChecker', imageSizeChecker);

  function imageSizeChecker() {
    return {
      restrict: 'A',
      scope: {
        triggerSizeAlert: '='
      },
      link: function(scope, elem) {
        elem.on('load', function () {
          scope.triggerSizeAlert({
            width: elem[0].naturalWidth,
            height: elem[0].naturalHeight
          });
        });
      }
    };
  }

})();

/**
 * Created by davidbeazer on 09/01/2017.
 */
(function () {
  'use strict';

  angular
    .module('common')
    .component('imageComponent', {
      templateUrl: 'app/common/image-component/image.tmpl.html',
      bindings: {
        imgSrc: '<',
        show: '<'
      },
      controller: ['$scope', componentController],
      controllerAs: 'vm'
    });

  function componentController() {

    var vm = this;
    vm.$onInit = function () {
      // $log.info('$onInit: vm.imgSrc' + vm.imgSrc + ', vm.show: ' + vm.show);
    };
    // $log.info(imgSrc);
    // vm.imgSrc = imgSrc;

  }
})();

/**
 * Created by davidbeazer on 24/08/2016.
 */
(function () {
  angular
    .module('common')
    .filter('iconify', function () {
      return function (input) {

        // for lead release icons
        if (typeof input === 'string') {
          if (input === 'unreleased') {
            return 'cloud_off';
          } else if (input === 'processed') {
            return 'cloud_done';
          } else if (input === 'success') {
            return 'cloud_done';
          } else if (input === 'indeterminate') {
            return 'help';
          } else if (input === 'queued') {
            return 'hourglass_empty';
          } else if (input === 'waiting') {
            return 'hourglass_full';
          } else if (input === 'timedOut') {
            return 'warning';
          } else if (input === 'lockLeads') {
            return 'lock';
          } else if (input === 'locked') {
            return 'lock';
          } else if (input === 'failed') {
            return 'error';
          } else if (input === 'mixed') {
            return 'warning';
          } else if (input === 'no-machines-ran') {
            return 'warning';
          } else if (input === 'unlockLeads') {
            return 'lock_open';
          } else if (input == 'image/jpg') {
            return '<i class="zmdi zmdi-image md-hue-3"></i>';
          } else if (input == 'application/pdf') {
            return '<i class="zmdi zmdi-file md-hue-3"></i>';
          } else if (input == 'draft') {
            return '<i class="zmdi zmdi-settings zuantPollen"></i>';
          } else if (input == 'archived') {
            return '<i class="zmdi zmdi-close zuantSaffron"></i>';
          } else if (input == 'published') {
            return '<i class="zmdi zmdi-check zuantAqua"></i>';
          }
        }
      };
    });
})();

(function() {
  'use strict';
  angular
    .module('common')
    .directive('focusMe', ['$timeout', function($timeout) {
      return {
        link: function(scope, element, attrs) {
          scope.$watch(attrs.focusMe, function(value) {
            if(value === true) {
              $timeout(function() {
                element[0].focus();
                scope[attrs.focusMe] = false;
              });
            }
          });
        }
      };
    }]);
}());

(function () {
  'use strict';

  angular
    .module('common')
    .filter('placeholder', Placeholder);

  Placeholder.$inject = [];
  function Placeholder() {
    return function (input, scope) {
      var rv = '' + input;
      if (input === undefined || rv === '') {
        rv = scope.getPlaceholder() || '';
      }
      return rv;
    };
  }
})();

(function () {
  'use strict';

  /** @description cells with a gridButton filter will have their value and cell type passed in here in order to return the correct button
   * filter
   * @param value - the value for the cell
   * @param cellType - the type of cell this is, Literature, Image, MessageComposer
   */
  angular
    .module('common')
    .filter('gridButton', gridButton);

  gridButton.$inject = ['$sce', '$filter', 'ZuantAccountManagersFactory'];

  function gridButton($sce, $filter, ZuantAccountManagersFactory) {
    return function (value, cellType) {

      if (cellType == 'Drawing') {
        if (value && value.length) {
          return $sce.trustAsHtml('<button class="md-icon-button md-button md-zuant-aqua-theme-theme md-ink-ripple" style="background: #f7f7f7;"><i class="zmdi zmdi-gesture lit-icon"></i></button>');
        }
      } else if (cellType == 'Image') {
        if (value && value.length) {
          return $sce.trustAsHtml('<button class="md-icon-button md-button md-zuant-aqua-theme-theme md-ink-ripple" style="background: #f7f7f7;"><i class="zmdi zmdi-camera lit-icon"></i></button>');
        }
      } else if (cellType == 'Literature') {
        if (value && value.length) {
          const itm = value.length > 1 ? 'items' : 'item';
          return $sce.trustAsHtml('' + value.length + ' ' + itm + ' attached ' + '&nbsp; &nbsp;<i class="zmdi zmdi-collection-pdf lit-icon"></i>');
        }
      } else if (cellType == 'MessageComposer') {
        if (value && value.length) {
          const itms = value.length > 1 ? 'messages' : 'message';
          return $sce.trustAsHtml('<i class="zmdi zmdi-mail-send lit-icon"></i> ' + value.length + ' ' + itms + ' sent');
        } else {
          return $sce.trustAsHtml('<span></span>');
        }
      } else if (cellType == 'OCRrequiresVerification') {
        if (value) {
          return $sce.trustAsHtml('<i class="zmdi zmdi zmdi-eye zuantThyme"></i>');
        } else {
          // return $sce.trustAsHtml('<i class="zmdi zmdi zmdi-eye-off zuant-thyme"></i>');
        }
      } else if (cellType == 'OCRisImportant') {
        if (value) {
          return $sce.trustAsHtml('<i class="zmdi zmdi-star-circle zuantPollen"></i>');
        }
      } else if (cellType == 'showMoreInfo') {
        if (value) {
          return $sce.trustAsHtml('<i class="zmdi zmdi-info-outline zuantAqua"></i>');
        }
      } else if (cellType == 'Status') {
        if (value == 'published' || value === 'active') {
          return $sce.trustAsHtml('<i class="zmdi zmdi-check zuantAqua"></i>');
        } else if (value == 'draft') {
          return $sce.trustAsHtml('<i class="zmdi zmdi-settings zuantPollen"></i>');
        } else if (value == 'archived' || value == 'inactive') {
          return $sce.trustAsHtml('<i class="zmdi zmdi-close zuantSaffron"></i>');
          // return $sce.trustAsHtml('<md-button class="md-icon-button"><md-icon md-font-icon="zmdi zmdi-close zuantSaffron"></md-icon><md-tooltip>form archived</md-tooltip></md-button>'); // TODO get a compiled directive into the table and we've cracked a good nut!
        } else if (value == 'welcome_template_active') {
          return $sce.trustAsHtml('<i class="material-icons zuantAqua" data-icon="contact_mail"></>');
        } else if (value == 'welcome_template_inactive') {
          return $sce.trustAsHtml('<i class="material-icons zuantSaffron" data-icon="contact_mail"></>');
        } else if (value == 'password_reset_template_active') {
          return $sce.trustAsHtml('<i class="material-icons zuantAqua" data-icon="password"></>');
        } else if (value == 'password_reset_template_inactive') {
          return $sce.trustAsHtml('<i class="material-icons zuantSaffron" data-icon="password"></>');
        } else if (value == 'global_welcome_template_active') {
          return $sce.trustAsHtml('<i class="material-icons zuantAqua" data-icon="public"></>');
        } else if (value == 'global_welcome_template_inactive') {
          return $sce.trustAsHtml('<i class="material-icons zuantSaffron" data-icon="public"></>');
        } else if (value == 'global_password_reset_template_active') {
          return $sce.trustAsHtml('<i class="material-icons zuantAqua" data-icon="vpn_lock"></>');
        } else if (value == 'global_password_reset_template_inactive') {
          return $sce.trustAsHtml('<i class="material-icons zuantSaffron" data-icon="vpn_lock"></>');
        }

      } else if (cellType == '_validation') {
        if (value) {
          return $sce.trustAsHtml('<i class="zmdi zmdi-check zuantAqua"></i>');
        } else {
          // return $sce.trustAsHtml('<i class="zmdi zmdi-alert-triangle zuantPollen"></i>');
          return $sce.trustAsHtml('<i class="zmdi zmdi-alert-octagon zuantSaffron"></i>');
        }
      } else if (cellType == 'ZAM') {
        if (value){
          var zam = ZuantAccountManagersFactory.allZams.find((zam) => zam.email === value);

          if (zam){
            return $sce.trustAsHtml('<img class="zam-initials-svg" src="' + zam.iconURL + '"' + ' />');
          } else if (value == 'Z_MASTER') {
            return $sce.trustAsHtml('<svg width="28px" height="28px" viewBox="0 0 58 58" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
              '<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
              '<g id="Marketpoint" stroke="#F99D33" fill="#FEC353">' +
              '<polygon id="Star" points="28.5 44.25 12.3359056 52.7479673 15.4229729 34.7489837 2.3459458 22.0020327 20.4179528 19.3760163 28.5 3 36.5820472 19.3760163 54.6540542 22.0020327 41.5770271 34.7489837 44.6640944 52.7479673"></polygon>' +
              '</g>' +
              '</g>' +
              '</svg>');
          }
        }
      } else if (cellType === 'CSM') {
        if (value){
          var csm = ZuantAccountManagersFactory.customerSuccessManagers.find((csm) => csm.email === value);

          if (csm){
            return $sce.trustAsHtml('<img class="zam-initials-svg" src="' + csm.iconURL + '"' + ' />');
          }
        }
      } else if (cellType === 'Consent') {
        if (value) {
          var str = value.length > 1 ? 'tokens' : 'token';
          return $sce.trustAsHtml('<i class="zmdi zmdi-shield-check lit-icon"></i> ' + value.length + ' ' + str + ' consented');
        }
      } else if (cellType === 'Privacy') {
        if (value) {
          var str2 = value.length > 1 ? 'statements' : 'statement';
          return $sce.trustAsHtml('<i class="zmdi zmdi-lock-outline lit-icon"></i> ' + value.length + ' ' + str2 + ' read');
        }
      } else if (cellType === 'AccountStatus') {
        if (value === 'live_client') {
          return $sce.trustAsHtml('<i class="zmdi zmdi-account-circle"></i>');
        } else if (value === 'test_account') {
          return $sce.trustAsHtml('<i class="zmdi zmdi-codepen"></i>');
        } else if (value === 'sales_demo') {
          return $sce.trustAsHtml('<i class="zmdi zmdi-run"></i>');
        } else if (value === 'internal') {
          return $sce.trustAsHtml('<i class="zmdi zmdi-home"></i>');
        } else if (value === 'reseller') {
          return $sce.trustAsHtml('<i class="zmdi zmdi-label-heart"></i>');
        } else if (value === 'external_contractor') {
          return $sce.trustAsHtml('<i class="zmdi zmdi-store"></i>');
        } else if (value === 'exhibitor'){
          return $sce.trustAsHtml('<i class="zmdi zmdi-account-box-phone"></i>');
        } else if (value === 'client_gone_away') {
          return $sce.trustAsHtml('<i class="zmdi zmdi-block"></i>');
        } else if (value === 'hold') {
          return $sce.trustAsHtml('<i class="zmdi zmdi-pause"></i>');
        } else if (value === 'delete') {
          return $sce.trustAsHtml('<i class="zmdi zmdi-delete"></i>');
        }
      } else if (cellType === 'Archived') {
        if (!value) {
          return $sce.trustAsHtml('');
        } else  {
          return $sce.trustAsHtml('<i class="zmdi zmdi-archive"></i>');
        }
      } else if (cellType === 'EmailEvents') {
        if (value.length) {
          var mostRecentEvent = value[value.length - 1];
          return $sce.trustAsHtml('<i class="zmdi ' + mostRecentEvent.icon + ' lit-icon"></i> &nbsp; ' + mostRecentEvent.event);
        } else {
          return $sce.trustAsHtml('<span></span>');
        }
      } else if (cellType === 'TemplatesSent') {
        if (value.length) {
          const mostRecent = value[value.length - 1];
          const cellValue = $sce.trustAsHtml('<i class="zmdi zmdi-mail-send lit-icon"></i>') +
           _.escape($filter('zpEmailTemplateTitle')(mostRecent._emailTemplateId)) + ' ' +
            (value.length > 1 ? ' + ' + (value.length - 1) + ' other ' + (value.length - 1 == 1 ? 'template' : 'templates') + ' sent' : ' sent.');
          return cellValue;
        } else {
          return $sce.trustAsHtml('<span></span>');
        }
      } else if (cellType === 'ChoiceView' || cellType === 'Tableview') {
        if (!value) return '';
        return value.map(v => _.escape(v));
      } else {
        return $sce.trustAsHtml('<span></span>');
      }
    };
  }
}());

(function () {
  'use strict';

  /**
   * @description the enhancedTableCells filter modifies each row in the factory data to have two new properties: the raw value (is just that and used by the various models) and the filtered value (which is for the view to use)
   * if the column has a filter type defined then it will apply the filter as specified in the column metadata cellFilter property.
   */
  angular
    .module('common')
    .filter('enhancedTableCells', enhancedTableCells);

  enhancedTableCells.$inject = ['$filter', 'MessageService', 'stringHelper'];

  function enhancedTableCells($filter, MessageService, stringHelper) {
    return function (metadata, rowsData) {
      rowsData = Array.isArray(rowsData) ? rowsData : [];

      // Build lookup: columns by object + field
      const colIndex = {};
      try {
        const items = (metadata && metadata.columnsData && metadata.columnsData.items) || [];
        for (const col of items) {
          if (!colIndex[col.object]) colIndex[col.object] = {};
          colIndex[col.object][col.databasefieldname] = col;
        }
      } catch (e) {
        MessageService.writeLog({
          level: 'error',
          msg: e,
          tags: ['enhancedTableCellsFilter', 'buildColIndex']
        });
      }

      const primaryIdField =
        metadata && metadata.columnsData && metadata.columnsData.primaryIdentifier
          ? metadata.columnsData.primaryIdentifier.field
          : undefined;

      function applyFilterIfNecessary(rowObj, mdata) {
        try {
          const obj = rowObj && rowObj[mdata.object];
          const rawValue = obj ? obj[mdata.databasefieldname] : undefined;

          if (mdata.cellFilter) {
            if (mdata.cellFilter === 'zpDateOffset') {
              if (!rawValue) return;
              const tzOffset =
                stringHelper.calcTimezoneOffset(
                  metadata && metadata.formProperties
                    ? metadata.formProperties.formTimezone
                    : undefined
                );
              return $filter(mdata.cellFilter)(rawValue, tzOffset);
            }
            return $filter(mdata.cellFilter)(rawValue, mdata.type);
          } else {
            return (typeof rawValue === 'undefined') ? mdata.cellDefaultValue : rawValue;
          }
        } catch (e) {
          MessageService.writeLog({
            level: 'error',
            msg: e,
            tags: ['enhancedTableCellsFilter', 'applyFilterIfNecessary']
          });
        }
      }

      // Single-pass over each row
      return rowsData.map(function (row) {
        const enhancedCell = {};

        try {
          const objNames = Object.keys(row || {});
          for (const objName of objNames) {
            const sourceObj = row[objName];
            if (!sourceObj || typeof sourceObj !== 'object') {
              continue;
            }

            // Ensure target bucket and _id
            if (!enhancedCell[objName]) {
              enhancedCell[objName] = {};
            }
            if (primaryIdField && typeof enhancedCell[objName]._id === 'undefined') {
              enhancedCell[objName]._id = sourceObj[primaryIdField];
            }

            const fieldNames = Object.keys(sourceObj);
            for (const fieldName of fieldNames) {
              if (primaryIdField && fieldName === primaryIdField) {
                continue;
              }

              const meta =
                (colIndex[objName] && colIndex[objName][fieldName])
                  ? colIndex[objName][fieldName]
                  : null;

              try {
                if (meta) {
                  const rawVal =
                    (typeof sourceObj[fieldName] !== 'undefined' && sourceObj[fieldName] !== null)
                      ? sourceObj[fieldName]
                      : meta.cellDefaultValue;

                  enhancedCell[objName][fieldName] = {
                    raw: rawVal,
                    filtered: applyFilterIfNecessary(row, meta)
                  };
                } else {
                  const rawVal = sourceObj[fieldName];
                  enhancedCell[objName][fieldName] = {
                    raw: rawVal,
                    filtered: rawVal
                  };
                }
              } catch (e) {
                MessageService.writeLog({
                  level: 'error',
                  msg: e,
                  tags: ['enhancedTableCellsFilter', 'singlePass', meta ? 'configured' : 'unconfigured']
                });
              }
            }
          }
        } catch (e) {
          MessageService.writeLog({
            level: 'error',
            msg: e,
            tags: ['enhancedTableCellsFilter', 'rowsData.singlePass.outer']
          });
        }

        return enhancedCell;
      });
    };
  }

}());

(function () {
  'use strict';

  angular
    .module('common')
    .filter('zpDateCustom', zpDateCustom)
    .filter('zpDateDDMMMyy', zpDateDDMMMyy)
    .filter('zpDateMedium', zpDateMedium)
    .filter('zpDateOffset', zpDateOffset)
    .filter('zpBytes', bytes)
    .filter('zpDropboxRaw', dropboxUrl)
    .filter('zpUserAvatarEmail', zpUserAvatarEmail)
    .filter('zpMomentFromNow', zpMomentFromNow)
    .filter('zpCapitalizeWord', zpCapitalizeWord)
    .filter('zpEmailTemplateTitle', zpEmailTemplateTitle)
    .filter('zpReleaseNarrative', zpReleaseNarrative)
    .filter('numKeys', numKeys)
    .filter('cdnAssets', cdnAssets);

  cdnAssets.$inject = ['$sce', 'CDN_ASSETS_URL'];

  function cdnAssets($sce, assetURL) {
    return function (path) {
      return $sce.trustAsResourceUrl(assetURL + path);
    };
  }

  numKeys.$inject = [];

  function numKeys() {
    return function (json) {
      var keys = Object.keys(json);
      return keys.length;
    };
  }

  zpCapitalizeWord.$inject = [];

  function zpCapitalizeWord() {
    return function (text) {
      return (text) ? text.charAt(0).toUpperCase() + text.substr(1).toLowerCase() : '';
    };
  }

  zpEmailTemplateTitle.$inject = ['EmailTemplatesFactory'];

  function zpEmailTemplateTitle(EmailTemplatesFactory) {
    return function (templateId) {
      try {
        return EmailTemplatesFactory.factoryData.itemsObject[templateId].emailtemplate.title;
      } catch (e) {
        return 'Missing template';
      }
    };
  }

  zpMomentFromNow.$inject = [];

  function zpMomentFromNow() {
    var fromNow = function (input) {
      return moment(input).fromNow();
    };
    fromNow.$stateful = true;
    return fromNow;
  }

  zpDateCustom.$inject = ['dateFilter'];

  function zpDateCustom(dateFilter) {
    return function (theDate) {
      return dateFilter(theDate, 'dd MMMM yy @ HH:mm:ss');
    };
  }

  zpDateMedium.$inject = ['dateFilter'];

  function zpDateMedium(dateFilter) {
    return function (theDate) {
      return dateFilter(theDate, 'dd MMM yy, HH:mm');
    };
  }

  zpDateOffset.$inject = ['dateFilter', 'stringHelper'];

  function zpDateOffset(dateFilter, stringHelper) {
    return function (theDate, timeOffsetValue) {
      theDate = stringHelper.convertDateToNeutralTimezone(theDate);
      var dateAsObj = new Date(theDate);
      // return dateFilter(dateAsObj, 'short', timeOffsetValue);
      return dateFilter(dateAsObj, 'yyyy-MM-dd HH:mm:ss', timeOffsetValue);
    };
  }

  zpDateDDMMMyy.$inject = ['dateFilter'];

  function zpDateDDMMMyy(dateFilter) {
    return function (theDate) {
      return dateFilter(theDate, 'dd MMM yy');
    };
  }
  
  zpReleaseNarrative.$inject = [];

  function zpReleaseNarrative() {
    return function (rawValue) {
      if (rawValue){
        if (rawValue.narrative) return rawValue.narrative;
      }

      return 'N/A';
    };
  }

  function bytes() {
    return function (bytes, precision) {
      if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
      if (typeof precision === 'undefined') precision = 1;
      var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
        number = Math.floor(Math.log(bytes) / Math.log(1024));
      return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
    };
  }

  function dropboxUrl() {
    return function (url) {
      if (!url) return;
      var newUrl = url.replace('dl=0', 'raw=1');
      return newUrl;
    };
  }

  function zpUserAvatarEmail() {
    return function (emailAddress) {
      return emailAddress ? emailAddress.charAt(0).toUpperCase() + emailAddress.charAt(1).toLowerCase() : '';
    };
  }

}());

/**
 * Created by davidbeazer on 31/08/2016.
 */
(function () {
  'use strict';

  angular
    .module('common')
    .component('zpFabAdd', zpFabAdd())
    .controller('FabAddController', FabAddController);

  function zpFabAdd() {
    return {
      controller: 'FabAddController',
      templateUrl: 'app/common/fab/zp-fab-add.tmpl.html',
      bindings: {
        pulseClassCheck: '<', // used for applying pulse class to button if length = 0. User call to action
        dialogConfig: '<', // which templateUrl and controller to use for the dialog
        defaultPosition: '<'
      }
    };
  }

  FabAddController.$inject = ['$scope', '$mdMedia', 'MessageService', '$document', 'hotkeys'];
  /* ng-inject */
  function FabAddController($scope, $mdMedia, MessageService, $document, hotkeys) {
    var vm = this;

    vm.$onInit = function () {
      vm.ariaLabel = vm.dialogConfig.ariaLabel;
      if (!vm.defaultPosition){
        vm.defaultPosition = 'bottom-right';
      }
      bindHotkeys();
    };

    function bindHotkeys() {
      hotkeys.bindTo($scope)
        .add({
          combo: 'ctrl+n',
          description: vm.dialogConfig.description,
          callback: function () {
            vm.add();
          }
        });
      $scope.$emit('zp.message', {
        level: 'broadcast',
        eventName: 'zp.bindHotkeys.broadcast',
        page: '',
        message: ''
      });
    }

    vm.add = function (ev) {

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'));
      var dialogConfig = {
        controller: vm.dialogConfig.controller,
        templateUrl: vm.dialogConfig.templateUrl,
        template: vm.dialogConfig.template,
        parent: angular.element($document.body),
        locals: vm.dialogConfig.locals,
        targetEvent: ev,
        clickOutsideToClose: vm.dialogConfig.clickOutsideToClose,
        fullscreen: useFullScreen
      };

      MessageService.showDialog(ev, dialogConfig)
        .then(
          function (success, data) {
            if (success) {
              $scope.$emit('zp.fab.added', {
                data: data
              });
            }
          },
          function () {
            /* cancelled */
          }
        );
    };

  }

})();

/**
* @description fires when mouse click releases or touch ends
*/
(function () {
  'use strict';
  angular.module('common')
    .directive('pressUp', ['$parse', function($parse) {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          element.on('$md.pressup', function() {
            $parse(attrs.pressUp)(scope);
          });
        }
      };
    }]);
})();

'use strict';
/* eslint no-undef: 0 */
angular.module('common').service('EventZubot', ['APIService', function EventZubot(api) {
  var EventZubotService = function EventZubotService() {};

  EventZubotService.prototype.postUpdate = function postUpdate(eventId) {
    return api.postToDataApi('events/zubot', { id: eventId });
  };

  EventZubotService.prototype.postExecutiveSummaryUpdate = function postExecutiveSummaryUpdate(eventId) {
    return api.postToDataApi('events/executive-summary-zubot', { id: eventId });
  };

  return new EventZubotService();
}]);

angular
  .module('common')
  .config(exceptionConfig);

exceptionConfig.$inject = ['$provide'];

function exceptionConfig($provide) {
  $provide.decorator('$exceptionHandler', extendExceptionHandler);
}

extendExceptionHandler.$inject = ['$delegate', '$injector', '$log'];

function extendExceptionHandler($delegate, $injector, $log) {
  return function (exception, cause) {
    $delegate(exception, cause);
    var errorData = {
      exception: exception,
      cause: cause
    };
    // var MessageService = $injector.get('MessageService');
    // MessageService.showMessageWithAction(errorData.exception.message);
    /**
     * Could add the error to a service's collection,
     * add errors to $rootScope, log errors to remote web server,
     * or log locally. Or throw hard. It is entirely up to you.
     * throw exception;
     */
    $log.error(errorData.exception.message);
  };
}

'use strict';
/* eslint no-undef: 0 */
angular.module('zp.env', ['Constants']);

'use strict';
/* eslint no-undef: 0 */
angular
  .module('zp.env')
  .service('EnvService', ['API_CONFIG', 'ENV_VAR', 'INTERCOM_APP_ID', 'INFRASTRUCTURE', 'APP_VERSION', function Env(apiConfig, env_var, intercom_id, infrastructure, app_version) {
    let isDev = env_var.indexOf('AWS') === -1;
    return {
      api: {
        host: apiConfig.url,
        port: apiConfig.port
      },
      env: env_var,
      intercomAppId: intercom_id,
      infrastructure: infrastructure,
      app_version: app_version,
      isDev: isDev
    };
  }]);

'use strict';
angular.module('zp.encoding', []);

'use strict';
/* eslint no-undef: 0 */
angular.module('zp.encoding').service('EncodingService', [function EncodingService() {
  var Encoding = function Encoding() {};

  Encoding.prototype.encode = function (str) {
    /* eslint no-useless-escape:0 */
    var re = new RegExp('\/', 'g');
    return encodeURIComponent(str.replace(re, '%2F'));
  };

  Encoding.prototype.singleEncode = function (str) {
    return encodeURIComponent(str);
  };

  Encoding.prototype.decode = function (str) {
    var re = new RegExp('%2F', 'g');
    return decodeURIComponent(str).replace(re, '/');
  };

  return new Encoding();
}]);

// /**
//  * Created by davidbeazer on 19/09/2016.
//  * @function zpValue
//  * zpValue directive is an attribute directive that creates an isolated scope controller for a table cell.
//  * zpEditable uses functions in this controller to tee up it's edit controls
//  * look @ zp-table.tmpl.html to see these scope properties being created
//  */
//
// (function () {
//   'use strict';
//
//   angular
//     .module('common')
//     .directive('zpValue', zpValue)
//     .controller('zpValueController', zpValueController);
//
//   zpValueController.$inject = ['$scope'];
//
//   function zpValueController($scope) {
//
//     /** below functions operate on a individual table cell level */
//
//     this.getMetadata = function getMetadata() {
//       return $scope.zpMetadata;
//     };
//
//     this.getKey = function getKey() {
//       return $scope.zpKey;
//     };
//
//     this.getIndex = function getIndex() {
//       return $scope.zpIndex;
//     };
//
//     this.getItem = function getItem() {
//       return $scope.zpItem;
//     };
//
//     this.getValue = function getValue() {
//       return $scope.zpData;
//     };
//
//     this.setValue = function setValue(val) {
//       // $log.info('val: ' + val);
//       $scope.zpData = val;
//       // TODO: this calls a function in zpTableCtrl but I can't see why.
//       // $scope.zpOnChange({
//       //   key: $scope.metadata.databasefieldname,
//       //   value: val
//       // });
//     };
//
//     // $scope.$watch('zpData', function () {
//     //   // after pagination $scope.zpData is the correct value. Need to get this value change to trigger zp-editable to grab it. Emitting event does the trick, not sure if it's best though!
//     //   $scope.$emit('zp.value-changed');
//     // }, true);
//
//   }
//
//   zpValue.$inject = [];
//
//   function zpValue() {
//     return {
//       restrict: 'A',
//       templateUrl: 'app/common/editor/zp-value.tmpl.html',
//       scope: {
//         zpData: '=',
//         zpMetadata: '=',
//         zpIndex: '=',
//         zpKey: '=',
//         zpOnChange: '&',
//         zpItem: '='
//       },
//       controller: 'zpValueController'
//     };
//   }
//
// })();

// /**
//  * Created by davidbeazer on 19/09/2016.
//  @function zpValidator directive
//  validationFunctions returns a unique and required function to be called by the ngModelCtrl $parsers (assuming this is just passing off custom validators to be run by built in angular validation methods ?!)
//
//  */
// (function () {
//   'use strict';
//
//   angular
//     .module('common')
//     .directive('zpValidator', Validator);
//
//   function validationFunctions(modelCtrl, metadata) {
//     return {
//       unique: function (data, key, index) {
//         return function (value) {
//           /* get other existing values and ensure
//              the passed in value is unique amongst its peers */
//           var valid = true;
//           if (index || index === 0) {
//             var haystack = data[key].reduce(function (m, e, i) {
//               if (i !== index) {
//                 m.push(e[metadata.databasefieldname]);
//               }
//               return m;
//             }, []);
//             if (haystack.indexOf(value) > -1) {
//               valid = false;
//             }
//           }
//           modelCtrl.$setValidity('unique', valid);
//           return value;
//         };
//       },
//       required: function (value) {
//         var valid = true;
//         if (value === undefined || '' + value === '') {
//           valid = false;
//         }
//         modelCtrl.$setValidity('required', valid);
//         return value;
//       }
//     };
//   }
//
//   Validator.$inject = [];
//
//   function Validator() {
//     return {
//       restrict: 'A',
//       require: ['^zpValue', '^zpEditable', 'ngModel'],
//       link: function (scope, element, attrs, ctrl) {
//         var valueCtrl = ctrl[0];
//         var editableCtrl = ctrl[1];
//         var ngModelCtrl = ctrl[2];
//
//         var metadata = valueCtrl.getMetadata();
//         var key = valueCtrl.getKey();
//         var index = valueCtrl.getIndex();
//         var validators = validationFunctions(ngModelCtrl, metadata);
//
//         if (metadata.unique) {
//           var data = editableCtrl.getModel();
//           ngModelCtrl.$parsers.push(validators.unique(data, key, index));
//         }
//
//         if (metadata.required) {
//           ngModelCtrl.$parsers.push(validators.required);
//         }
//
//       }
//     };
//   }
// })();

(function () {
  'use strict';

  angular
    .module('common')
    .controller('zpEditableHeaderCtrl', zpEditableHeaderCtrl)
    .component('zpEditableHeader', {
      controller: 'zpEditableHeaderCtrl',
      templateUrl: 'app/common/editable-header/zp-editable-header.tmpl.html',
      bindings: {
        metadata: '<',
        value: '<',
        doneFunction: '&',
        fontClass: '<'
      }
    });

  zpEditableHeaderCtrl.$inject = [];
  /* ng-inject */
  function zpEditableHeaderCtrl() {
    var vm = this;

    vm.$onInit = function () {
      vm.showInput = false;
    };

    vm.done = function () {
      vm.doneFunction({
        value: vm.value
      });
      vm.showInput = false;
    };

  }
}());

/*
* half-inched from http://jsfiddle.net/zargyle/35z4J/1/
*/
(function () {
  'use strict';

  angular.module('common')
    .directive('zpDraggable', ['$document', function ($document) {
      return {
        restrict: 'A',
        scope: false,
        link: function (scope, elem) {
          let startX;
          let startY;
          let x = 0;
          let y = 0;
          let start;
          let stop;
          let drag;
          let container;

          // Obtain drag options
          if (scope.dragOptions) {
            start = scope.dragOptions.start;
            drag = scope.dragOptions.drag;
            stop = scope.dragOptions.stop;
            container = scope.dragOptions.container;
          }

          // Bind mousedown event
          elem.on('mousedown', function (e) {
            e.preventDefault();
            //check if mouse is right click and ignore.
            if (e.which === 3) return;
            startX = e.clientX - elem[0].offsetLeft;
            startY = e.clientY - elem[0].offsetTop;
            $document.on('mousemove', mousemove);
            $document.on('mouseup', mouseup);
            if (start) start(e);
          });

          // Handle drag event
          function mousemove(e) {
            y = e.clientY - startY;
            x = e.clientX - startX;
            setPosition();
            if (drag) drag(e);
          }

          // Unbind drag events
          function mouseup(e) {
            $document.unbind('mousemove', mousemove);
            $document.unbind('mouseup', mouseup);
            if (stop) stop(e);
          }

          // Move element, within container if provided
          function setPosition() {
            const width = elem[0].offsetWidth;
            const height = elem[0].offsetHeight;

            if (container) {
              if (x < container.left) {
                x = container.left;
              } else if (x > (container.right - width)) {
                x = container.right - width;
              }
              if (y < container.top) {
                y = container.top;
              } else if (y > container.bottom - height) {
                y = container.bottom - height;
              }
            }

            elem.css({
              top: y + 'px',
              left: x + 'px'
            });
          }
        }
      };

    }]);

})();

(function () {
  'use strict';

  angular
    .module('app')
    .provider('DevHelperProvider', DevHelperProvider);

  function DevHelperProvider() {
    this.$get = ['localStorageService', function (localStorageService) {

      var factoryData = {
        currentLogTags: []
      };

      var pushLogTag = function (tagValue) {
        var currentLogTags = localStorageService.get('logTags');
        if (!currentLogTags) currentLogTags = [];
        var alreadyPresent = _.find(currentLogTags, function (val){
          return val.trim().toLowerCase() === tagValue.trim().toLowerCase();
        });
        if (alreadyPresent) return;
        currentLogTags.push(tagValue);
        localStorageService.set('logTags', currentLogTags);
        factoryData.currentLogTags = currentLogTags;
      };

      var clearLogTags = function () {
        localStorageService.set('logTags', []);
      };

      var getLogTags = function () {
        this.currentLogTags = localStorageService.get('logTags');
        factoryData.currentLogTags = this.currentLogTags;
      };


      return {
        pushLogTag: pushLogTag,
        clearLogTags: clearLogTags,
        getLogTags: getLogTags,
        factoryData: factoryData
      };

    }];
  }
})();

(function () {
  'use strict';

  angular
    .module('common')
    .component('zpDevHelper', {
      controller: 'DevHelperCtrl',
      templateUrl: 'app/common/dev-helper/dev-helper.tmpl.html',
      bindings: {}
    })
    .controller('DevHelperCtrl', ctrl);

  ctrl.$inject = ['SessionService', 'PermPermissionStore', 'DevHelperProvider', 'MONITOR_URL', 'EnvService'];
  /* nginject */
  function ctrl(session, PermPermissionStore, DevHelperProvider, MONITOR_URL, EnvService) {

    var vm = this;
    vm.EnvService = EnvService;

    vm.$onInit = function (){
      DevHelperProvider.getLogTags();
      vm.devHelperStore = DevHelperProvider.factoryData;
      vm.session = session;
      vm.permissions = PermPermissionStore.getStore();
      vm.MONITOR_URL = MONITOR_URL;
    };

    vm.pushLogValue = function () {
      if(!vm.logTagValue) return;
      DevHelperProvider.pushLogTag(vm.logTagValue);
      DevHelperProvider.getLogTags();
      vm.logTagValue = '';
    };

    vm.clearLogTags = function (){
      DevHelperProvider.clearLogTags();
      DevHelperProvider.getLogTags();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('common')
    .factory('DeltaAPI', factory);

  factory.$inject = ['APIService', 'MessageService', 'ChangeDelta', 'SessionService'];
  /* ng-inject */
  function factory(api, MessageService, ChangeDelta, SessionService) {

    return {
      postDeltas: postDeltas
    };

    function postDeltas(changeDeltas) {

      const data = {
        clientId: SessionService.getUserData().clientId,
        deltas: ChangeDelta.buildChangesPayload(changeDeltas)
      };

      return api.postToDataApi('responses/savechanges', data)
        .then(function (response) {
          MessageService.writeLog({
            level: 'info',
            msg: 'postToDataApi success',
            tags: ['deltas']
          });
          return response.data;
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: 'postToDataApi error',
            tags: ['deltas']
          });
          throw (err);
        });
    }
  }
}());


(function () {
  'use strict';

  angular
    .module('common')
    .factory('ChangeDelta', ChangeDelta);

  ChangeDelta.$inject = ['$log'];

  function ChangeDelta($log) {

    var deltaObj = {};
    var services = {
      recordValueChange: recordValueChange,
      getDeltaObject: getDeltaObject,
      clear: clear,
      isDirty: isDirty,
      buildChangesPayload: buildChangesPayload
    };

    return services;
    /////////////////////////////

    function getDeltaObject() {
      //$log.info('returning deltaObj: ' + JSON.stringify(deltaObj));
      return deltaObj;
    }

    function clear() {
      $log.info('nuking the change delta object');
      deltaObj = {};
    }

    function isDirty() {
      return !angular.equals(deltaObj, {});
    }

    /**
     * @function recordValueChange
     * @description adds a record to the change delta
     * @param {object} changeObj an object containing the necessary metadata for the change
     * @param changeObj.collection the collection the change belongs to
     * @param changeObj.objectid the _id of the doc being changed
     * @param changeObj.databasefieldname the databasefieldname of the field
     * @param changeObj.oldval the old value of the field
     * @param changeObj.newval the new value of the field
     * @returns this function doesn't return anything
     */

    function recordValueChange(changeObj) {
      // $log.info('recordValueChange in changeDelta: ');
      // $log.info(changeObj);
      if (deltaObj.hasOwnProperty(changeObj.collection)) {
        if (deltaObj[changeObj.collection][changeObj.objectid]) {
          if (deltaObj[changeObj.collection][changeObj.objectid][changeObj.databasefieldname]) {
            if (JSON.stringify(changeObj.newval) !== JSON.stringify(deltaObj[changeObj.collection][changeObj.objectid][changeObj.databasefieldname].oldvalue)) {
              deltaObj[changeObj.collection][changeObj.objectid][changeObj.databasefieldname].newvalue = changeObj.newval;
            } else if (JSON.stringify(changeObj.newval) === JSON.stringify(deltaObj[changeObj.collection][changeObj.objectid][changeObj.databasefieldname].oldvalue)) {
              delete deltaObj[changeObj.collection][changeObj.objectid][changeObj.databasefieldname];
              if (angular.equals(deltaObj[changeObj.collection][changeObj.objectid], {})) delete deltaObj[changeObj.collection][changeObj.objectid];
              if (angular.equals(deltaObj[changeObj.collection], {})) delete deltaObj[changeObj.collection];
              if (angular.equals(deltaObj, {})) deltaObj = {};
            }
          } else {
            deltaObj[changeObj.collection][changeObj.objectid][changeObj.databasefieldname] = {
              oldvalue: changeObj.oldval,
              newvalue: changeObj.newval,
              orignialvalue: changeObj.orignialvalue
            };
          }
        } else {
          deltaObj[changeObj.collection][changeObj.objectid] = {};
          deltaObj[changeObj.collection][changeObj.objectid][changeObj.databasefieldname] = {
            oldvalue: changeObj.oldval,
            newvalue: changeObj.newval,
            orignialvalue: changeObj.orignialvalue
          };
        }
      } else {
        deltaObj[changeObj.collection] = {};
        deltaObj[changeObj.collection][changeObj.objectid] = {};
        deltaObj[changeObj.collection][changeObj.objectid][changeObj.databasefieldname] = {};
        if (changeObj.oldval) {
          deltaObj[changeObj.collection][changeObj.objectid][changeObj.databasefieldname].oldvalue = changeObj.oldval;
        } else {
          deltaObj[changeObj.collection][changeObj.objectid][changeObj.databasefieldname].oldvalue = changeObj.oldval;
        }
        deltaObj[changeObj.collection][changeObj.objectid][changeObj.databasefieldname].newvalue = changeObj.newval;
        deltaObj[changeObj.collection][changeObj.objectid][changeObj.databasefieldname].orignialvalue = changeObj.orignialvalue;

      }

      //ZP-920 removed as caused TS-161
      // if (Object.keys(deltaObj).length !=0)
      // {
      //   for (let dbfield of Object.keys(deltaObj[changeObj.collection]))
      //   {
      //     var obj = deltaObj[changeObj.collection][dbfield];
      //     for (let field of Object.keys(obj))
      //     {
      //       var diff = changeObj.newval - changeObj.oldval;
      //       //positive = drag down 
      //       if (changeObj.databasefieldname !=field){
      //         var inbounds = changeObj.oldval +diff;
      //         if (diff > 0){
      //           //drag down
      //           if (obj[field].newvalue <= inbounds)
      //           {
      //             if (obj[field].newvalue-1 !=-1){
      //               obj[field].newvalue = obj[field].newvalue-1;
      //             }
      //           }
      //         }
      //         else
      //         {
      //           //drag up
      //           if (obj[field].newvalue >= inbounds) {

      //             obj[field].newvalue = obj[field].newvalue+1;
      //           }
      //         }

      //       }
      //       if (obj[field].newvalue == obj[field].orignialvalue){
      //         delete obj[field];
      //         if (angular.equals(deltaObj[changeObj.collection][changeObj.objectid], {})) delete deltaObj[changeObj.collection][changeObj.objectid];
      //         if (angular.equals(deltaObj[changeObj.collection], {})) delete deltaObj[changeObj.collection];
      //         if (angular.equals(deltaObj, {})) deltaObj = {};
      //       }
      //     }
      //   }
      // }
    }

    function buildChangesPayload(changeDeltas) {
      var deltas = {};
      try {
        _.each(changeDeltas, function (objVal, objKey) {
          _.each(changeDeltas[objKey], function (changeObj, objId) {
            if (!deltas[objKey]) {
              deltas[objKey] = {};
              deltas[objKey][objId] = {};
            }
            if (!deltas[objKey][objId]) {
              deltas[objKey][objId] = {};
            }
            _.each(changeDeltas[objKey][objId], function (dbObj, databasefieldname) {
              if (typeof (dbObj) === 'object') {
                if (dbObj.newvalue !== null && dbObj.newvalue !== undefined) {
                  deltas[objKey][objId][databasefieldname] = dbObj.newvalue;
                  return;
                }
                deltas[objKey][objId][databasefieldname] = dbObj;
                return;

              } else if (typeof (dbObj) === 'string') {
                deltas[objKey][objId][databasefieldname] = dbObj;
                return;
              }

              deltas[objKey][objId][databasefieldname] = undefined;
            });
          });
        });
      } catch (e) {
        MessageService.writeLog({
          level: 'error',
          msg: e,
          tags: ['change_delta_factory']
        });
      }
      return deltas;
    }
  }
}());

(function () {
  'use strict';
  
  angular
    .module('common')
    .service('CurrencyHelperService', currencyHelperService);

  currencyHelperService.$inject = ['CurrencyHelperFactory'];
  
  function currencyHelperService(CurrencyHelperFactory) {

    this.parseString = function (currencyString) {
      const numericValue = this.convertStringToNumber(currencyString);
      const currencySymbol = this.convertStringToCurrencySymbol(currencyString);

      const currency = CurrencyHelperFactory.getCurrencyBySymbol(currencySymbol);
      const formattedValue = this.formatViaCurrencyCode(numericValue, currency.code);

      return {
        numericValue,
        formattedValue,
        currency
      };
    };

    this.convertStringToNumber = function (str) {
      try {
        const numericValue = Number(str.match(/\d|\.|-/g).join(''));
        return numericValue;
      } catch (_err) {
        return null;
      }
    };

    this.convertStringToCurrencySymbol = function (str) {
      try {
        const currencySymbol = str.replace(/[\d., ]/g, '');
        return currencySymbol;
      } catch (_err) {
        return null;
      }

    };

    this.formatViaCurrencyCode = function (value, code, props) {
      if (!props) props = {};
      let options = Object.assign({
        maximumFractionDigits: 2,
        style: 'currency',
        currency: code,
        currencyDisplay: 'narrowSymbol'
      }, props);

      //check for decimal value, if 0 ditch it.
      if (options.maximumFractionDigits > 0){
        const parts = value.toLocaleString('en-US', { maximumSignificantDigits: 18 }).split('.');
        const decimal = parts.length > 1 ? Number('0.' + parts[1]) : 0;
        if (decimal == 0){
          options.maximumFractionDigits = 0;
        }
      }

      return new Intl.NumberFormat(undefined, options).format(value);
    };

  }
})();
  
(function () {
  'use strict';

  angular
    .module('common')
    .factory('CurrencyHelperFactory', currencyHelperFactory);

  currencyHelperFactory.$inject = [];

  function currencyHelperFactory() {

    var factoryData = [
      { name: 'Afghan Afghani', code: 'AFN', symbol:'؋', id: 1 },
      { name: 'Albanian Lek', code: 'ALL', symbol:'Lek', id: 2 },
      { name: 'Algerian Dinar', code: 'DZD', symbol:'دج', id: 3 },
      { name: 'Angolan Kwanza', code: 'AOA', symbol:'Kz', id: 4 },
      { name: 'Argentine Peso', code: 'ARS', symbol:'$', id: 5 },
      { name: 'Armenian Dram', code: 'AMD', symbol:'֏', id: 6 },
      { name: 'Aruban Florin', code: 'AWG', symbol:'ƒ', id: 7 },
      { name: 'Australian Dollar', code: 'AUD', symbol:'$', id: 8, ranking: 5 },
      { name: 'Azerbaijani Manat', code: 'AZN', symbol:'m', id: 9 },
      { name: 'Bahamian Dollar', code: 'BSD', symbol:'B$', id: 10 },
      { name: 'Bahraini Dinar', code: 'BHD', symbol:'.د.ب', id: 11 },
      { name: 'Bangladeshi Taka', code: 'BDT', symbol:'৳', id: 12 },
      { name: 'Barbadian Dollar', code: 'BBD', symbol:'Bds$', id: 13 },
      { name: 'Belarusian Ruble', code: 'BYR', symbol:'Br', id: 14 },
      { name: 'Belgian Franc', code: 'BEF', symbol:'fr', id: 15 },
      { name: 'Belize Dollar', code: 'BZD', symbol:'$', id: 16 },
      { name: 'Bermudan Dollar', code: 'BMD', symbol:'$', id: 17 },
      { name: 'Bhutanese Ngultrum', code: 'BTN', symbol:'Nu.', id: 18 },
      { name: 'Bitcoin', code: 'BTC', symbol:'฿', id: 19 },
      { name: 'Bolivian Boliviano', code: 'BOB', symbol:'Bs.', id: 20 },
      { name: 'Bosnia-Herzegovina Convertible Mark', code: 'BAM', symbol:'KM', id: 21 },
      { name: 'Botswanan Pula', code: 'BWP', symbol:'P', id: 22 },
      { name: 'Brazilian Real', code: 'BRL', symbol:'R$', id: 23 },
      { name: 'British Pound Sterling', code: 'GBP', symbol:'£', id: 24, ranking: 3 },
      { name: 'Brunei Dollar', code: 'BND', symbol:'B$', id: 25 },
      { name: 'Bulgarian Lev', code: 'BGN', symbol:'Лв.', id: 26 },
      { name: 'Burundian Franc', code: 'BIF', symbol:'FBu', id: 27 },
      { name: 'Cambodian Riel', code: 'KHR', symbol:'KHR', id: 28 },
      { name: 'Canadian Dollar', code: 'CAD', symbol:'$', id: 29, ranking: 6 },
      { name: 'Cape Verdean Escudo', code: 'CVE', symbol:'$', id: 30 },
      { name: 'Cayman Islands Dollar', code: 'KYD', symbol:'$', id: 31 },
      { name: 'CFA Franc BCEAO', code: 'XOF', symbol:'CFA', id: 32 },
      { name: 'CFA Franc BEAC', code: 'XAF', symbol:'FCFA', id: 33 },
      { name: 'CFP Franc', code: 'XPF', symbol:'₣', id: 34 },
      { name: 'Chilean Peso', code: 'CLP', symbol:'$', id: 35 },
      { name: 'Chinese Yuan', code: 'CNY', symbol:'¥', id: 36, ranking: 11 },
      { name: 'Colombian Peso', code: 'COP', symbol:'$', id: 37 },
      { name: 'Comorian Franc', code: 'KMF', symbol:'CF', id: 38 },
      { name: 'Congolese Franc', code: 'CDF', symbol:'FC', id: 39 },
      { name: 'Costa Rican ColÃ³n', code: 'CRC', symbol:'₡', id: 40 },
      { name: 'Croatian Kuna', code: 'HRK', symbol:'kn', id: 41 },
      { name: 'Cuban Convertible Peso', code: 'CUC', symbol:'$, CUC', id: 42 },
      { name: 'Czech Republic Koruna', code: 'CZK', symbol:'Kč', id: 43 },
      { name: 'Danish Krone', code: 'DKK', symbol:'Kr.', id: 44 },
      { name: 'Djiboutian Franc', code: 'DJF', symbol:'Fdj', id: 45 },
      { name: 'Dominican Peso', code: 'DOP', symbol:'$', id: 46 },
      { name: 'East Caribbean Dollar', code: 'XCD', symbol:'$', id: 47 },
      { name: 'Egyptian Pound', code: 'EGP', symbol:'ج.م', id: 48 },
      { name: 'Eritrean Nakfa', code: 'ERN', symbol:'Nfk', id: 49 },
      { name: 'Estonian Kroon', code: 'EEK', symbol:'kr', id: 50 },
      { name: 'Ethiopian Birr', code: 'ETB', symbol:'Nkf', id: 51 },
      { name: 'Euro', code: 'EUR', symbol:'€', id: 52, ranking: 2 },
      { name: 'Falkland Islands Pound', code: 'FKP', symbol:'£', id: 53 },
      { name: 'Fijian Dollar', code: 'FJD', symbol:'FJ$', id: 54 },
      { name: 'Gambian Dalasi', code: 'GMD', symbol:'D', id: 55 },
      { name: 'Georgian Lari', code: 'GEL', symbol:'ლ', id: 56 },
      { name: 'German Mark', code: 'DEM', symbol:'DM', id: 57 },
      { name: 'Ghanaian Cedi', code: 'GHS', symbol:'GH₵', id: 58 },
      { name: 'Gibraltar Pound', code: 'GIP', symbol:'£', id: 59 },
      { name: 'Greek Drachma', code: 'GRD', symbol:'₯, Δρχ, Δρ', id: 60 },
      { name: 'Guatemalan Quetzal', code: 'GTQ', symbol:'Q', id: 61 },
      { name: 'Guinean Franc', code: 'GNF', symbol:'FG', id: 62 },
      { name: 'Guyanaese Dollar', code: 'GYD', symbol:'$', id: 63 },
      { name: 'Haitian Gourde', code: 'HTG', symbol:'G', id: 64 },
      { name: 'Honduran Lempira', code: 'HNL', symbol:'L', id: 65 },
      { name: 'Hong Kong Dollar', code: 'HKD', symbol:'$', id: 66, ranking: 15 },
      { name: 'Hungarian Forint', code: 'HUF', symbol:'Ft', id: 67, ranking: 14 },
      { name: 'Icelandic KrÃ³na', code: 'ISK', symbol:'kr', id: 68 },
      { name: 'Indian Rupee', code: 'INR', symbol:'₹', id: 69, ranking: 4 },
      { name: 'Indonesian Rupiah', code: 'IDR', symbol:'Rp', id: 70 },
      { name: 'Iranian Rial', code: 'IRR', symbol:'﷼', id: 71 },
      { name: 'Iraqi Dinar', code: 'IQD', symbol:'د.ع', id: 72 },
      { name: 'Israeli New Sheqel', code: 'ILS', symbol:'₪', id: 73 },
      { name: 'Italian Lira', code: 'ITL', symbol:'L,£', id: 74 },
      { name: 'Jamaican Dollar', code: 'JMD', symbol:'J$', id: 75 },
      { name: 'Japanese Yen', code: 'JPY', symbol:'¥', id: 76, ranking: 9 },
      { name: 'Jordanian Dinar', code: 'JOD', symbol:'ا.د', id: 77 },
      { name: 'Kazakhstani Tenge', code: 'KZT', symbol:'лв', id: 78 },
      { name: 'Kenyan Shilling', code: 'KES', symbol:'KSh', id: 79 },
      { name: 'Kuwaiti Dinar', code: 'KWD', symbol:'ك.د', id: 80 },
      { name: 'Kyrgystani Som', code: 'KGS', symbol:'лв', id: 81 },
      { name: 'Laotian Kip', code: 'LAK', symbol:'₭', id: 82 },
      { name: 'Latvian Lats', code: 'LVL', symbol:'Ls', id: 83 },
      { name: 'Lebanese Pound', code: 'LBP', symbol:'£', id: 84 },
      { name: 'Lesotho Loti', code: 'LSL', symbol:'L', id: 85 },
      { name: 'Liberian Dollar', code: 'LRD', symbol:'$', id: 86 },
      { name: 'Libyan Dinar', code: 'LYD', symbol:'د.ل', id: 87 },
      { name: 'Lithuanian Litas', code: 'LTL', symbol:'Lt', id: 88 },
      { name: 'Macanese Pataca', code: 'MOP', symbol:'$', id: 89 },
      { name: 'Macedonian Denar', code: 'MKD', symbol:'ден', id: 90 },
      { name: 'Malagasy Ariary', code: 'MGA', symbol:'Ar', id: 91 },
      { name: 'Malawian Kwacha', code: 'MWK', symbol:'MK', id: 92 },
      { name: 'Malaysian Ringgit', code: 'MYR', symbol:'RM', id: 93, ranking: 13 },
      { name: 'Maldivian Rufiyaa', code: 'MVR', symbol:'Rf', id: 94 },
      { name: 'Mauritanian Ouguiya', code: 'MRO', symbol:'MRU', id: 95 },
      { name: 'Mauritian Rupee', code: 'MUR', symbol:'₨', id: 96 },
      { name: 'Mexican Peso', code: 'MXN', symbol:'$', id: 97 },
      { name: 'Moldovan Leu', code: 'MDL', symbol:'L', id: 98 },
      { name: 'Mongolian Tugrik', code: 'MNT', symbol:'₮', id: 99 },
      { name: 'Moroccan Dirham', code: 'MAD', symbol:'MAD', id: 100 },
      { name: 'Mozambican Metical', code: 'MZM', symbol:'MT', id: 101 },
      { name: 'Myanmar Kyat', code: 'MMK', symbol:'K', id: 102 },
      { name: 'Namibian Dollar', code: 'NAD', symbol:'$', id: 103 },
      { name: 'Nepalese Rupee', code: 'NPR', symbol:'₨', id: 104 },
      { name: 'Netherlands Antillean Guilder', code: 'ANG', symbol:'ƒ', id: 105 },
      { name: 'New Taiwan Dollar', code: 'TWD', symbol:'$', id: 106 },
      { name: 'New Zealand Dollar', code: 'NZD', symbol:'$', id: 107, ranking: 8 },
      { name: 'Nicaraguan CÃ³rdoba', code: 'NIO', symbol:'C$', id: 108 },
      { name: 'Nigerian Naira', code: 'NGN', symbol:'₦', id: 109 },
      { name: 'North Korean Won', code: 'KPW', symbol:'₩', id: 110 },
      { name: 'Norwegian Krone', code: 'NOK', symbol:'kr', id: 111 },
      { name: 'Omani Rial', code: 'OMR', symbol:'.ع.ر', id: 112 },
      { name: 'Pakistani Rupee', code: 'PKR', symbol:'₨', id: 113 },
      { name: 'Panamanian Balboa', code: 'PAB', symbol:'B/.', id: 114 },
      { name: 'Papua New Guinean Kina', code: 'PGK', symbol:'K', id: 115 },
      { name: 'Paraguayan Guarani', code: 'PYG', symbol:'₲', id: 116 },
      { name: 'Peruvian Nuevo Sol', code: 'PEN', symbol:'S/.', id: 117 },
      { name: 'Philippine Peso', code: 'PHP', symbol:'₱', id: 118, ranking: 20 },
      { name: 'Polish Zloty', code: 'PLN', symbol:'zł', id: 119 },
      { name: 'Qatari Rial', code: 'QAR', symbol:'ق.ر', id: 120 },
      { name: 'Romanian Leu', code: 'RON', symbol:'lei', id: 121 },
      { name: 'Russian Ruble', code: 'RUB', symbol:'₽', id: 122 },
      { name: 'Rwandan Franc', code: 'RWF', symbol:'FRw', id: 123 },
      { name: 'Salvadoran ColÃ³n', code: 'SVC', symbol:'₡', id: 124 },
      { name: 'Samoan Tala', code: 'WST', symbol:'SAT', id: 125 },
      { name: 'Saudi Riyal', code: 'SAR', symbol:'﷼', id: 126, ranking: 5 },
      { name: 'Serbian Dinar', code: 'RSD', symbol:'din', id: 127 },
      { name: 'Seychellois Rupee', code: 'SCR', symbol:'SRe', id: 128 },
      { name: 'Sierra Leonean Leone', code: 'SLL', symbol:'Le', id: 129 },
      { name: 'Singapore Dollar', code: 'SGD', symbol:'$', id: 130, ranking: 10 },
      { name: 'Slovak Koruna', code: 'SKK', symbol:'Sk', id: 131 },
      { name: 'Solomon Islands Dollar', code: 'SBD', symbol:'Si$', id: 132 },
      { name: 'Somali Shilling', code: 'SOS', symbol:'Sh.so.', id: 133 },
      { name: 'South African Rand', code: 'ZAR', symbol:'R', id: 134, ranking: 7 },
      { name: 'South Korean Won', code: 'KRW', symbol:'₩', id: 135, ranking: 18 },
      { name: 'Special Drawing Rights', code: 'XDR', symbol:'SDR', id: 136 },
      { name: 'Sri Lankan Rupee', code: 'LKR', symbol:'Rs', id: 137 },
      { name: 'St. Helena Pound', code: 'SHP', symbol:'£', id: 138 },
      { name: 'Sudanese Pound', code: 'SDG', symbol:'.س.ج', id: 139 },
      { name: 'Surinamese Dollar', code: 'SRD', symbol:'$', id: 140 },
      { name: 'Swazi Lilangeni', code: 'SZL', symbol:'E', id: 141 },
      { name: 'Swedish Krona', code: 'SEK', symbol:'kr', id: 142, ranking: 19 },
      { name: 'Swiss Franc', code: 'CHF', symbol:'CHf', id: 143, ranking: 12 },
      { name: 'Syrian Pound', code: 'SYP', symbol:'LS', id: 144 },
      { name: 'São Tomé and Príncipe Dobra', code: 'STD', symbol:'Db', id: 145 },
      { name: 'Tajikistani Somoni', code: 'TJS', symbol:'SM', id: 146 },
      { name: 'Tanzanian Shilling', code: 'TZS', symbol:'TSh', id: 147 },
      { name: 'Thai Baht', code: 'THB', symbol:'฿', id: 148, ranking: 17 },
      { name: 'Tongan Pa\'anga', code: 'TOP', symbol:'$', id: 149 },
      { name: 'Trinidad & Tobago Dollar', code: 'TTD', symbol:'$', id: 150 },
      { name: 'Tunisian Dinar', code: 'TND', symbol:'ت.د', id: 151 },
      { name: 'Turkish Lira', code: 'TRY', symbol:'₺', id: 152 },
      { name: 'Turkmenistani Manat', code: 'TMT', symbol:'T', id: 153 },
      { name: 'Ugandan Shilling', code: 'UGX', symbol:'USh', id: 154 },
      { name: 'Ukrainian Hryvnia', code: 'UAH', symbol:'₴', id: 155 },
      { name: 'United Arab Emirates Dirham', code: 'AED', symbol:'إ.د', id: 156, ranking: 16 },
      { name: 'Uruguayan Peso', code: 'UYU', symbol:'$', id: 157 },
      { name: 'US Dollar', code: 'USD', symbol:'$', id: 158, ranking: 1 },
      { name: 'Uzbekistan Som', code: 'UZS', symbol:'лв', id: 159 },
      { name: 'Vanuatu Vatu', code: 'VUV', symbol:'VT', id: 160 },
      { name: 'Venezuelan BolÃvar', code: 'VEF', symbol:'Bs', id: 161 },
      { name: 'Vietnamese Dong', code: 'VND', symbol:'₫', id: 162 },
      { name: 'Yemeni Rial', code: 'YER', symbol:'﷼', id: 163 },
      { name: 'Zambian Kwacha', code: 'ZMK', symbol:'ZK', id: 164}
    ];

    return {
      getAllCurrencies: getAllCurrencies,
      getAllCurrenciesOrderedByRanking: getAllCurrenciesOrderedByRanking,
      getCurrencyByCode: getCurrencyByCode,
      getCurrencyByRanking: getCurrencyByRanking,
      getCurrencyById:  getCurrencyByID,
      getCurrencyByName: getCurrencyByName,
      getCurrencyBySymbol: getCurrencyBySymbol
    };

    function getAllCurrencies() {
      return factoryData;
    }

    function getAllCurrenciesOrderedByRanking() {
      const top20 = factoryData.filter((currency) => !!currency.ranking);
      const filteredTop20 = top20.sort((a, b) => {
        return a.ranking < b.ranking ? -1 : 1;
      });

      const nonTop20 = factoryData.filter((currency) => !currency.ranking);
      const filterednonTop20 = nonTop20.sort((a, b) => {
        return a.id < b.id ? -1 : 1;
      });

      const combined = filteredTop20.concat(filterednonTop20);
      return combined;
    }

    function getCurrencyByCode(code) {
      return factoryData.find(function (currency){
        return currency.code == code;
      });
    }

    function getCurrencyByRanking(rank) {
      return factoryData.find(function (currency){
        return currency.ranking == rank;
      });
    }

    function getCurrencyByID(id) {
      return factoryData.find(function (currency){
        return currency.id == id;
      });
    }

    function getCurrencyByName(name) {
      return factoryData.find(function (currency){
        return currency.name == name;
      });
    }

    function getCurrencyBySymbol(symbol) {
      return factoryData.find(function (currency){
        return currency.symbol == symbol;
      });
    }
  }
}());
/**
 * Created by davidbeazer on 02/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('common')
    .component('zpCountWidget', {
      templateUrl: 'app/common/count-widget/zp-count-widget.tmpl.html',
      bindings: {
        count: '<',
        label: '@',
        icon: '@',
        loading: '<'
      }
    });



})();

(function () {
  'use strict';
  angular
    .module('common')
    .directive('ngCounter', ngCounter);

  ngCounter.$inject = ['CurrencyHelperService', 'FormMetadataFactory', '$interval'];


  function ngCounter(CurrencyHelperService, FormMetadataFactory, $interval) {
    var directive = {
      restrict: 'A',
      link: link,
      scope: {
        target: '<',
        start: '@',
        duration: '@',
        currencyMode: '='
      }
    };

    return directive;

    
    function link ($scope, $element) {
      $scope.start = parseInt($scope.start);
      $scope.duration = parseInt($scope.duration);
      $scope.durationInMS = $scope.duration * 1000;
      $scope.value = 0;
      $scope.currencyCode = 'USD'; //set default to US Dollar

      if ($scope.currencyMode){
        const formMetadata = FormMetadataFactory.getData();
        if (formMetadata.formProperties && formMetadata.formProperties.currencyCode){
          $scope.currencyCode = formMetadata.formProperties.currencyCode;
        }
      }

      $scope.updateNumber = function () {
        const value = $scope.interpolate($scope.endTime, $scope.durationInMS, $scope.range, $scope.target, $scope.currencyMode);
        $scope.value = value;

        let formatted;
        if ($scope.currencyMode){
          formatted = CurrencyHelperService.formatViaCurrencyCode(value, $scope.currencyCode);
        } else {
          formatted = new Intl.NumberFormat('en-US').format(value);
        }
        $element[0].textContent = formatted;

      };

      $scope.interpolate = function(endTime, durationInMS, range, end, currencyMode){
        const now = new Date().getTime();
        const remaining = Math.max((endTime - now) / durationInMS, 0);
        var value = end - (remaining * range);

        if (!currencyMode){
          value = Math.round(value);
        }
        return value;
      };

      $scope.setTimer = function () {
        $scope.range = $scope.target - $scope.start;
        $scope.stepTime = Math.abs(Math.floor($scope.durationInMS / $scope.range));
    
        // never go below minTimer
        $scope.minTimer = 50; //no timer shorter than 50ms (not really visible any way)
        $scope.stepTime = Math.max($scope.stepTime, $scope.minTimer);
        
        // get current time and calculate desired end time
        $scope.startTime = new Date().getTime();
        $scope.endTime = $scope.startTime + $scope.durationInMS;

        if ($scope.timer) {
          $interval.cancel($scope.timer);
        }

        $scope.updateNumber();
        $scope.tickNumber();
      };

      $scope.tickNumber = function () {
        const remaining = Math.abs($scope.value - $scope.target);
        if(remaining > 0) {
          $scope.updateNumber();
          $scope.timer = $interval($scope.tickNumber, $scope.stepTime, 1);
        }
      };

      $scope.setTimer();
    }
  }

})();
/**
 * Created by davidbeazer on 24/08/2016.
 */
(function () {
  'use strict';

  angular
    .module('common')
    .directive('countupto', countupto);

  /* @ngInject */
  function countupto() {
    // Usage:
    //
    // ```html
    // <h1 countupto="100"></h1>
    // ```
    // Creates:
    //
    var directive = {
      link: link,
      restrict: 'A',
      scope: {
        'countupto': '<',
        'options': '<'
      }
    };
    return directive;

    function link($scope, $element, attrs) {
      var options = {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: '.',
        prefix: '',
        suffix: ''
      };

      // override default options?
      if ($scope.options) {
        for (var option in options) {
          if (angular.isDefined($scope.options[option])) {
            options[option] = $scope.options[option];
          }
        }
      }

      attrs.from = angular.isUndefined(attrs.from) ? 0 : parseInt(attrs.from);
      attrs.decimals = angular.isUndefined(attrs.decimals) ? 2 : parseFloat(attrs.decimals);
      attrs.duration = angular.isUndefined(attrs.duration) ? 5 : parseFloat(attrs.duration);

      var numberAnimation = new CountUp($element[0], attrs.from, $scope.countupto, attrs.decimals, attrs.duration, options);
      numberAnimation.start(function () {
        numberAnimation.update($scope.countupto);
      });
      $scope.$watch('countupto', function () {
        numberAnimation.update($scope.countupto);
      });

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('common')
    .component('zpControlWidget', {
      templateUrl: 'app/common/control-widget/zp-widget.tmpl.html',
      bindings: {},
      controller: ['$scope', zpControlWidgetController],
      controllerAs: 'vm'
    });

  function zpControlWidgetController () {
  }
}());

(function () {
  'use strict';
  
  angular.module('common')
    .directive('zpContextmenu', function () {
      return {
        restrict: 'A',
        scope: false,
        link: function (scope, elem) {
          elem.on('contextmenu', function (e) {
            if (window.getSelection().toString().length === 0) {
              e.stopPropagation();   
              e.preventDefault(); 
            }  
          });
        }
      };
  
    });
  
})();
  
/**
* Created by Dave Beazer on 23/11/2016.
*/

(function () {
  'use strict';

  angular.module('ck', []);

})();


(function () {
  'use strict';

  angular
    .module('ck')
    .directive('zpCkEditor', ckEditor);

  ckEditor.$inject = ['AuthService', 'SYNC_URL', '$filter'];
  /* @ngInject */
  function ckEditor(AuthService, SYNC_URL, $filter) {
    return {
      require: '?ngModel',
      scope: {
        plugins: '='
      },
      restrict: 'A',
      link: function ($scope, elm, attr, ngModel) {

        // CKEDITOR.replace method attaches an instance of ckeditor to an html element.
        const ck = CKEDITOR.replace(elm[0], {
          // Define changes to default configuration here.
          // For complete reference see:
          // http://docs.ckeditor.com/#!/api/CKEDITOR.config
          allowedContent: true,
          fullPage: true,
          protectedTags: 'html|head|body',
          templates_files: ['templates/templates.js'],
          autoGrow_onStartup: true,
          versionCheck: false,
          // The toolbar groups arrangement, optimized for two toolbar rows.
          toolbarGroups: [
            { name: 'inject', groups: ['logo', 'literature', 'contentEditable']},
            '/',
            { name: 'document', groups: ['mode', 'document', 'doctools']},
            { name: 'others'},
            { name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
            { name: 'paragraph',groups: ['list', 'indent', 'blocks', 'align', 'bidi']},
            { name: 'styles'},
            { name: 'colors'},
            '/',
            // { name: 'clipboard', groups: ['clipboard', 'undo']},
            { name: 'editing', groups: ['find', 'selection', 'spellchecker']},
            { name: 'links'},
            { name: 'insert'},
            { name: 'forms'},
            { name: 'tools' }
          ],

          // Remove some buttons provided by the standard plugins, which are
          // not needed in the Standard(s) toolbar.
          removeButtons: 'Maximize,About',

          // Set the most common block elements.
          format_tags: 'p;h1;h2;h3;pre'
        });

        CKEDITOR.plugins.addExternal('literature', '', 'plugins.js');
        CKEDITOR.plugins.addExternal('logo', '', 'plugins.js');
        CKEDITOR.plugins.addExternal('stickyToolbar', '', 'plugins.js');
        CKEDITOR.plugins.addExternal('contentEditable', '', 'plugins.js');
        
        ck.on('instanceReady', function (event) {
          var editor = event.editor;
        });

        CKEDITOR.injectLiteratureLogoImage = $filter('cdnAssets')('/images/pngs/icons/ckeditor/mail_links.png').$$unwrapTrustedValue();
        CKEDITOR.injectClientLogoImage = $filter('cdnAssets')('/images/pngs/icons/ckeditor/logo_icn.png').$$unwrapTrustedValue();
        CKEDITOR.stickyToolbarLogoImage = $filter('cdnAssets')('/images/pngs/icons/ckeditor/pin_icn.png').$$unwrapTrustedValue();
        CKEDITOR.injectContentEditableLogoImage = $filter('cdnAssets')('/images/pngs/icons/ckeditor/content_editable.png').$$unwrapTrustedValue();

        if ($scope.plugins && $scope.plugins.length > 0){
          CKEDITOR.config.extraPlugins = $scope.plugins.join(',');
        }

        AuthService.authoriseUser()
          .then(function (res) {
            CKEDITOR.zuantDatabasename = res.databasename; // setting the current users databasename for the inject logo button
            CKEDITOR.zuantSyncUrl = SYNC_URL;
          });

        if (!ngModel) return;

        ck.on('loaded', function () {
          ck.setData(ngModel.$viewValue);
        });

        function updateModel() {
          $scope.$applyAsync(function () {
            ngModel.$setViewValue(ck.getData());
          });
        }

        ck.on('change', updateModel);
        
        ck.on('key', updateModel);
        // ck.on('dataReady', updateModel); // cocks up change delta as doesn't contain inline body style ckeditor applies
        ck.on('pasteState', updateModel);

        ck.on('mode', function (ev) {
          $scope.$emit('zp.message', {
            level: 'broadcast',
            eventName: 'zp.ckEditorMode',
            page: 'editor',
            message: ev.editor.mode
          });
        });

        ngModel.$render = function () {
          ck.setData(ngModel.$viewValue);
        };

      }
    };
  }
})();

/**
 * Created by davidbeazer on 11/02/2016.
 */
(function () {
  'use strict';

  CKEDITOR.plugins.add('literature', {
    init: function (editor) {
      editor.ui.addButton('literature', {
        label: 'Inject literature',
        command: 'AddText1',
        icon: CKEDITOR.injectLiteratureLogoImage
      });
      editor.addCommand('AddText1', {
        exec: injectLiterature
      });
    }
  });

  function injectLiterature(e) {
    e.insertHtml('[[-- zuantinject: literature --]]<br/>[[literaturelinks]]<br />[[-- endinject --]]');
  }

  CKEDITOR.plugins.add('logo', {
    init: function (editor) {
      editor.ui.addButton('logo', {
        label: 'Add logo image',
        command: 'AddText2',
        icon: CKEDITOR.injectClientLogoImage
      });
      editor.addCommand('AddText2', {
        exec: injectLogo
      });
    }
  });

  function injectLogo(e) {
    e.fire('saved.ckeditor');
    var databaseName = CKEDITOR.zuantDatabasename;

    //local storage userData.database
    e.insertHtml('<img src="' + CKEDITOR.zuantSyncUrl + '/Imageserver/Logo/' + databaseName + '" /><br/>');
  }

  CKEDITOR.plugins.add('stickyToolbar', {
    init: function (editor) {
      // var pluginName = 'stickyToolbar';
      editor.ui.addButton('stickyToolbar', {
        label: 'Pin Toolbar',
        command: 'AddText3',
        icon: CKEDITOR.stickyToolbarLogoImage
      });
      editor.addCommand('AddText3', {
        exec: toggleStickyClass
      });
    }
  });

  // CKEDITOR.plugins.add('leadinfo',{
  //   init: function (editor) {
  //     editor.ui.addButton('leadinfo', {
  //       label: 'Inject lead data',
  //       command: 'AddText4',
  //       icon: '/assets/images/ckeditor_icons/lead_data.png'
  //     });
  //     editor.addCommand('AddText4', {exec: injectLeadData});
  //   }
  // });
  //
  // function injectLeadData(e) {
  //   e.insertHtml('[[-- zuantinject: leadinfo --]]<br/>[[leadinfo]]<br />[[-- endinject --]]');
  // }

  CKEDITOR.plugins.add('contentEditable', {
    init: function (editor) {
      editor.ui.addButton('contentEditable', {
        label: 'Inject editable content',
        command: 'AddText4',
        icon: CKEDITOR.injectContentEditableLogoImage
      });
      editor.addCommand('AddText4', {
        exec: injectContentEditable
      });
    }
  });

  function injectContentEditable(e) {
    e.insertHtml('<div contenteditable="true" style="min-height:80px; border:1px solid #EFEFEF; padding: 5px;">' +
      '<p style="color: #EFEFEF;">Add personal note</p>' +
      '</div>');
  }

  function toggleStickyClass() {
    // $log.info('toggling sticky class to ckeditor toolbar.');
    var toolbar = document.getElementsByClassName('cke_top').item(0);
    var isPinned = toolbar.classList.contains('stickyToolbar');

    if (isPinned) {
      toolbar.className = toolbar.className.replace(/(?:^|\s)stickyToolbar(?!\S)/g, '');
    } else {
      toolbar.className = toolbar.className + ' stickyToolbar';
    }

  }

}());

(function () {
  'use strict';

  angular
    .module('common')
    .factory('IndividualEmailTemplateAggregationFactory', Factory);

  Factory.$inject = ['EmailAPI', 'ClientEmailTemplatesAPI', 'ChartBuilderFactory'];
  /** @ngInject */
  function Factory(EmailAPI, ClientEmailTemplatesAPI, ChartBuilderFactory) {

    let factoryData = {};

    return {
      factoryData: factoryData,
      fetchData: fetchData,
      invalidateCache: invalidateCache
    };

    function invalidateCache() {
      factoryData = {};
    }

    /***
    @description this is used for the chart displayed on email detail page
    */

    function fetchData(chartId, rangeStart, rangeEnd, emailtemplateid, schema) {

      const key = `${emailtemplateid}_${chartId}_${rangeStart.toISOString()}_${rangeEnd.toISOString()}_${schema}`;
      if (key in factoryData){
        const cachedData = factoryData[key];
        const now = moment();
        if (now.diff(cachedData.creationMoment, 'hour') < 4){
          return new Promise(function (resolve) {
            resolve(cachedData);
          });
        }

        delete factoryData[key];
      }
      
      if (chartId === 'individual_email_template_sends'){

        return EmailAPI.aggregateTemplateActivity(rangeStart, rangeEnd, emailtemplateid)
          .then(function (res) {
            const templateInteractions = {
              counts: res.data.counts,
              sent: res.data.sent
            };

            const queryObj = {
              match: {
                range: {
                  $gte: rangeStart,
                  $lte: rangeEnd                
                }
              }
            };
            return ChartBuilderFactory.buildChartData(chartId, templateInteractions, queryObj, schema)
              .then(function (data){
                factoryData[key] = data;
                return factoryData[key];
              });
          })
          .catch(function (err) {
            throw (err);
          });

      } else if (chartId === 'individual_client_email_template_sends') {

        return ClientEmailTemplatesAPI.aggregateTemplateActivity(rangeStart, rangeEnd, emailtemplateid)
          .then(function (res) {
            const templateInteractions = {
              counts: res.data.counts,
              sent: res.data.sent
            };

            const queryObj = {
              match: {
                range: {
                  $gte: rangeStart,
                  $lte: rangeEnd                
                }
              }
            };
            return ChartBuilderFactory.buildChartData(chartId, templateInteractions, queryObj, schema)
              .then(function (data){
                factoryData[key] = data;
                return factoryData[key];
              });
          })
          .catch(function (err) {
            throw (err);
          });
      }
  
    }
  }

}());
(function () {
  'use strict';

  angular
    .module('common')
    .factory('ChartsFactory', ChartsFactory);

  ChartsFactory.$inject = ['AggregateResponsesFactory', 'AggregatedEmailTemplateSendsFactory', 'IndividualEmailTemplateAggregationFactory'];
  /* ng-inject */
  function ChartsFactory(AggregateResponsesFactory, AggregatedEmailTemplateSends, IndividualEmailTemplateAggregationFactory) {

    return {
      getChartData: getChartData,
      getChartOptions: getChartOptions,
      paramToDate: paramToDate
    };

    /***
    @description this is entry point for various charts
    */

    function getChartData(chartId, rangeStart, rangeEnd, emailTemplateId, schema) {
      if (chartId === 'aggregated_responses') {
        return AggregateResponsesFactory.fetchData(chartId, rangeStart, rangeEnd, schema);
      }
      if (chartId === 'aggregated_email_template_sends' || chartId === 'aggregated_client_email_template_sends') {
        return AggregatedEmailTemplateSends.fetchData(chartId, rangeStart, rangeEnd, emailTemplateId, schema);
      }
      if (chartId === 'individual_email_template_sends' || chartId === 'individual_client_email_template_sends') {
        return IndividualEmailTemplateAggregationFactory.fetchData(chartId, rangeStart, rangeEnd, emailTemplateId, schema);
      }
    }

    function getChartOptions() {
      return {
        menuOptions: [{
          menuCommand: 'Days',
          ariaLabel: function () {
            return 'days';
          },
          fonticon: 'zmdi zmdi-calendar-alt',
          label: function () {
            return 'Days';
          }
        }, {
          menuCommand: 'Weeks',
          ariaLabel: function () {
            return 'weeks';
          },
          fonticon: 'zmdi zmdi-calendar',
          label: function () {
            return 'Weeks';
          }
        },{
          menuCommand: 'Months',
          ariaLabel: function () {
            return 'months';
          },
          fonticon:'zmdi zmdi-calendar-note',
          label: function () {
            return 'Months';
          }
        }, {
          menuCommand: 'Quarters',
          fonticon:'zmdi zmdi-time-interval',
          ariaLabel: function () {
            return 'quaters';
          },
          label: function () {
            return 'Quarters';
          }
        },{
          menuCommand: 'Years',
          ariaLabel: function () {
            return 'Years';
          },
          fonticon:'zmdi zmdi-calendar-check',
          label: function () {
            return 'Years';
          }
        }, {
          menuCommand: 'Export',
          ariaLabel: function () {
            return 'export csv';
          },
          fonticon: 'zmdi zmdi-download',
          label: function () {
            return 'Export csv';
          }
        }]
      };
    }

    function paramToDate(param) {
      if (param === 'week') {
        return moment().startOf('week');
      } else if (param === 'lastMonth') {
        const prevMonthFirstDay = moment().subtract(1, 'months').startOf('month');
        return prevMonthFirstDay;
      } else if (param === 'month') {
        return moment().startOf('month');
      } else if (param === 'quarter') {
        return moment().startOf('quarter');
      } else if (param === 'year') {
        return moment().startOf('year');
      }
    }
  }
}());


(function () {
  'use strict';

  angular
    .module('common')
    .factory('ChartsExportFactory', ChartsExportFactory);

  ChartsExportFactory.$inject = ['AggregateResponsesFactory', 'AggregatedEmailTemplateSendsFactory', 'IndividualEmailTemplateAggregationFactory', 'UnparseData', 'DownloadCSV', 'MessageService'];

  function ChartsExportFactory(AggregateResponsesFactory, AggregatedEmailTemplateSendsFactory, IndividualEmailTemplateAggregationFactory, UnparseData, DownloadCSV, MessageService) {
    
    return {
      downloadChartExport: downloadChartExport
    };

    function downloadChartExport(startdate, enddate, params, schema, type, filename) {
      if (type === 'aggregated_responses'){
        return AggregateResponsesFactory.fetchData(type, startdate, enddate, schema)
          .then(function (chartData) {
            prepareAndDownloadCSV(startdate, enddate, chartData, filename);
          });
      }
      else if (type === 'aggregated_email_template_sends' || type === 'aggregated_client_email_template_sends'){
        return AggregatedEmailTemplateSendsFactory.fetchData(type, startdate, enddate, params, schema)
          .then(function (chartData) {
            prepareAndDownloadCSV(startdate, enddate, chartData, filename);
          });
      }
      else if (type === 'individual_email_template_sends' || type === 'individual_client_email_template_sends'){
        return IndividualEmailTemplateAggregationFactory.fetchData(type, startdate, enddate, params, schema)
          .then(function (chartData) {
            prepareAndDownloadCSV(startdate, enddate, chartData, filename);
          });
      }
    }

    function prepareAndDownloadCSV(startdate, enddate, chartData, export_type) {
      const headers = buildHeaders(chartData, export_type);
      const dataRows = breakoutDataForExport(chartData);
      const csv = UnparseData(headers, dataRows);
      const filename = 'Zuant ' + export_type + ' ' +
        moment(startdate).format('MM_DD_YYYY') + '-' +
        moment(enddate).format('MM_DD_YYYY') + '.csv';

      DownloadCSV(filename, csv);
      MessageService.showMessage(export_type + ' Export Complete');
      return csv;
    }

    function extractStructureInfo(rawData, exportType) {
      const categories = new Set();
      const nestedFieldsMap = {};

      const supportedSubFields = [
        'count',
        'userEmails',
        'clientDatabasenames',
        'userIds',
        'clientIds',
        'emailAddresses'
      ];
    
      for (const item of rawData) {
        if (!item || typeof item !== 'object') continue;
    
        for (const [primaryKey, subObj] of Object.entries(item)) {
          let mainKey = primaryKey;
          if (mainKey.includes(':test')) continue;

          if (exportType === 'Events' && mainKey === 'count') {
            mainKey = 'totalLeadCount';
          }

          categories.add(mainKey);
    
          if (!nestedFieldsMap[mainKey]) nestedFieldsMap[mainKey] = new Set();
    
          if (typeof subObj !== 'object' || subObj == null) continue;
          
          for (const field of Object.keys(subObj)) {
            if (supportedSubFields.includes(field)) {
              nestedFieldsMap[mainKey].add(field);
            }
          }
        }
      }
    
      return {
        categories: Array.from(categories),
        nestedFieldsMap: nestedFieldsMap
      };
    }    
    
    function buildHeaders(chartData, exportType) {
      const { categories, nestedFieldsMap } = extractStructureInfo(chartData.rawData, exportType);
      const headers = [['Date']];

      for (const category of categories) {
        const fields = nestedFieldsMap[category];
        if (!fields || fields.size === 0) headers.push([`${formatCategory(category, exportType)}`]);

        for (const field of fields){
          headers.push([`${formatCategory(category, exportType)} ${formatField(field)}`]);
        }
      }

      return headers;
    }
    
    function breakoutDataForExport(chartData) {
      const { categories, nestedFieldsMap } = extractStructureInfo(chartData.rawData);
      const rows = [];
    
      for (let i = 0; i < chartData.rawData.length; i++) {
        const row = [chartData.labels[i] || ''];
        const item = chartData.rawData[i];
    
        for (const category of categories) {
          const val = item[category];
    
          if (typeof val !== 'object' || val == null) {
            if (val == null){
              row.push('');
              continue;
            }

            row.push(val);
            continue;
          }

          const fields = nestedFieldsMap[category];
          for (const field of fields) {
            const fieldVal = val[field];

            if (Array.isArray(fieldVal)) {
              row.push(fieldVal.join(', '));
              continue;
            }
              
            if (fieldVal !== undefined) {
              row.push(fieldVal);
              continue;
            }

            row.push('');

          }

        }
    
        rows.push(row);
      }
    
      return rows;
    }
    
    function formatCategory(category, exportType) {
      switch (category) {
        case 'count': {
          if (exportType === 'Emails') return 'Sent Emails';
          return 'Count';
        }
        case 'sent': return 'Sent';
        case 'delivered': return 'Delivered';
        case 'opened': return 'Opened';
        case 'clicked': return 'Clicked';
        case 'failed': return 'Failed';
        default: return category;
      }
    }
    
    function formatField(field) {
      switch (field) {
        case 'count': return 'Count';
        case 'clientDatabasenames': return 'Client Databasenames';
        case 'userEmails': return 'User Emails';
        case 'userIds': return 'User Ids';
        case 'clientIds': return 'Client Ids';
        case 'emailAddresses': return 'Lead Email Addresses';
        default: return field;
      }
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .factory('ChartBuilderFactory', Factory);

  Factory.$inject = [];
  /** @ngInject */
  function Factory() {

    return {
      buildChartData: buildChartData
    };

    function buildChartData(chartId, filteredResponses, queryObj, schema) {

      return new Promise(function (resolve){
        const startdate = moment(queryObj.match.range.$gte);
        const enddate = moment(queryObj.match.range.$lte);
        const days = enddate.diff(startdate, 'days');
        const containerObjects = buildContainers(chartId, days, queryObj, filteredResponses);
        const bucket = schema;
        let countsObj;
        let total;
        let weektotal;
        let filtered;

        function resolveData(){
          const labels = getLabelsByBucket(filtered);
          const series = getSeriesByBucket(chartId, filteredResponses);
          const data = getDataByBucket(series, filtered);
          const rawData = getRawDataByBucket(filtered);
        
          return resolve({
            metadata: {
              title: days + 1, // + 1 as days start at 0
              subtitle: 'TOTAL: ' + startdate.format('MM/DD/YYYY') + ' - ' + enddate.format('MM/DD/YYYY'),
              icon: 'zmdi-time-restore'
            },
            total,
            weektotal,
            events: countsObj.events,
            labels,
            data,
            rawData,
            series,
            chartType: 'line',
            countStats: countsObj.stats ? countsObj.stats : {},
            creationMoment: moment()
          });
        }
  
        if (chartId === 'aggregated_responses') {
          return loopAndIncrementDailyLeadCounts(filteredResponses, containerObjects)
            .then(function (data){
              countsObj = data;
              filtered = groupByBucket(countsObj.data, bucket);
              weektotal = countsObj.events.weeklyTotal;
              total = countsObj.events.totalLeads;

              return resolveData();
            });
          
        } else if (chartId === 'aggregated_email_template_sends' || chartId === 'aggregated_client_email_template_sends') {
          countsObj = applyCountsToBuckets(filteredResponses, containerObjects);
          filtered = groupByBucket(countsObj.data, bucket);
          total = countsObj.events.totalSends;
          weektotal = countsObj.events.weeklyTotal;
        } else if (chartId === 'individual_email_template_sends' || chartId === 'individual_client_email_template_sends') {
          countsObj = applyCountsToEmailBuckets(filteredResponses, containerObjects);
          filtered = groupByBucket(countsObj.data, bucket);
          total = countsObj.totalSends;
        }

        return resolveData();
      });
    }

    function groupByBucket(unfiltered, bucket){
      return _.groupBy(unfiltered, function (object) {
        if (bucket === 'Days') return moment(object.date , 'DD/MM/YYYY', true).format('MM/DD/YYYY');
        if (bucket === 'Weeks') {
          const moment_date =  moment(object.date , 'DD/MM/YYYY', true);
          return moment_date.week() + ' ' + moment_date.format('YYYY');
        }
        if (bucket === 'Months') return moment(object.date , 'DD/MM/YYYY', true).format('MM/YYYY');
        if (bucket === 'Quarters'){
          const moment_date =  moment(object.date , 'DD/MM/YYYY', true);
          return 'Q' + moment_date.quarter() + ' ' + moment_date.format('YYYY');
        } 
        if (bucket === 'Years') return moment(object.date , 'DD/MM/YYYY', true).format('YYYY');
      });
    }

    function getLabelsByBucket(filtered){
      return Object.keys(filtered);
    }

    function getDataByBucket(seriesLabels, filtered){
      const counts = [];


      for (const label in filtered) {
        const seriesCounts = {};

        for (const seriesLabel of seriesLabels) {
          seriesCounts[seriesLabel.toLowerCase()] = 0;
        }

        for (const recordeddata of filtered[label]) {
          if (typeof(recordeddata.counts) === 'object' && recordeddata.counts) {
            for (const key of Object.keys(recordeddata.counts)) {
              const lowerKey = key.toLowerCase();
              if (seriesCounts.hasOwnProperty(lowerKey)) {
                seriesCounts[lowerKey] += recordeddata.counts[key].count;
              }
            }
          } else if (recordeddata.count !== undefined) {
            seriesCounts['total'] = seriesCounts['total'] || 0;
            seriesCounts['total'] += recordeddata.count;
          }
        }

        for (const seriesLabel of seriesLabels) {
          if (!counts[seriesLabels.indexOf(seriesLabel)]) {
            counts[seriesLabels.indexOf(seriesLabel)] = [];
          }
          counts[seriesLabels.indexOf(seriesLabel)].push(seriesCounts[seriesLabel.toLowerCase()] || 0);
        }
      }

      return counts;
    }

    function getRawDataByBucket(filtered){
      const counts = [];

      for (const label in filtered){
        const raw = {};
        const existingIds = [];

        for (const recordeddata of filtered[label]){

          if (recordeddata.counts) {
            for (const key of Object.keys(recordeddata.counts)) {
              const newKey = key.toLowerCase();
              const existingValue = raw[newKey];
              const newValue = recordeddata.counts[key];
        
              if (existingValue) {
                _.set(
                  raw, newKey, _.mergeWith({}, existingValue, newValue,
                    function (objVal, srcVal) {
                      if (_.isNumber(objVal) && _.isNumber(srcVal)) return objVal + srcVal;
                      if (_.isArray(objVal) && _.isArray(srcVal)) return objVal.concat(srcVal);
                      return undefined;
                    }
                  )
                );
                continue;
              }

              _.set(raw, newKey, newValue);
              continue;
            }

            continue;
          }

          for (const key of Object.keys(recordeddata)){
            let newKey = key;
            if (key === 'activeEventIds') newKey = 'activeEventCount';
            if (typeof(recordeddata[key]) !== 'number' && !Array.isArray(recordeddata[key])) continue;
            if (!raw[newKey]) raw[newKey] = 0;

            if (typeof(recordeddata[key]) === 'number' && recordeddata[key] > 0) raw[newKey] += recordeddata[key];
            if (Array.isArray(recordeddata[key])){
              for (const id of recordeddata[key]){
                if (existingIds.indexOf(id) > -1) continue;
                raw[newKey]++;
                existingIds.push(id);
              }
            }
          }

        }

        counts.push(raw);

      }
      return counts;
    }

    function getSeriesByBucket(chartId, filteredResponses){
      if (chartId !== 'individual_email_template_sends' && chartId !== 'individual_client_email_template_sends') return ['Total'];
      return Object.keys(filteredResponses.counts).filter((key) => !key.includes(':TEST'));
    }

    function buildContainers(chartId, days, queryObj, filteredResponses) {
      // firstDate is the number of days to go back as stated in the query. Will increment this when computing each days lead count.
      const firstDate = moment(queryObj.match.range.$gte);
      const firstDateFormatted = firstDate.format('DD/MM/YYYY');
      const dayContainerObject = {};

      dayContainerObject[firstDateFormatted] = {
        dateAsMomentObj: firstDate
      };
      
      if (chartId === 'individual_email_template_sends' || chartId === 'individual_client_email_template_sends') {
        for (const key of Object.keys(filteredResponses.counts)) {
          _.set(dayContainerObject[firstDateFormatted], `counts.${key.toLowerCase()}.count`, 0);
        }
      } else {
        dayContainerObject[firstDateFormatted].count = 0;
      }
      
      for (let i = 0; i < days; i++) {
        const nextDay = moment(firstDate).add((i + 1), 'days');
        const formattedNextDay = nextDay.format('DD/MM/YYYY');
      
        dayContainerObject[formattedNextDay] = {
          dateAsMomentObj: nextDay
        };
      
        if (chartId === 'individual_email_template_sends' || chartId === 'individual_client_email_template_sends') {
          for (const key of Object.keys(filteredResponses.counts)) {
            _.set(dayContainerObject[formattedNextDay], `counts.${key.toLowerCase()}.count`, 0);
          }
        } else {
          dayContainerObject[formattedNextDay].count = 0;
        }
      }
      

      return dayContainerObject;
    }

    function loopAndIncrementDailyLeadCounts(filteredResponses, countByDayObj) {
      return new Promise(function (resolve) {
        const eventsObj = {
          totalActiveEvents: 0,
          totalLeads: 0,
          weeklyTotal: filteredResponses.weeklyCount
        };
    
        const dateResults = filteredResponses.dateResults;
        const activeForms = filteredResponses.activeForms;
    
        const batchSize = 100;
        let index = 0;
    
        function processBatch() {
          setTimeout(function() {
            const batchResults = dateResults.slice(index, index + batchSize);
            for (const obj of batchResults){
              const initCreateDate = moment(obj._initialcreatedatelocalutc).format('DD/MM/YYYY');
              if (countByDayObj[initCreateDate]) {
                countByDayObj[initCreateDate].count++;
              }
              eventsObj.totalLeads++;
            }
    
            index += batchSize;
    
            if (index < dateResults.length) {
              processBatch();
            } else {
              handleActiveEvents();
            }
          }, 0);
        }
    
        function handleActiveEvents() {
          const activeEventsBatchSize = 10;
          const uniqueActiveEventIds = new Set();
          let activeEventsIndex = 0;
    
          function processActiveEventsBatch() {
            setTimeout(function () {
              const batchActiveForms = activeForms.slice(activeEventsIndex, activeEventsIndex + activeEventsBatchSize);
              for (const evt of batchActiveForms) {
                const startDate = moment(evt.startdate);
                const endDate = moment(evt.enddate);

                for (const date of Object.keys(countByDayObj)){
                  const obj = countByDayObj[date];
                  if (!obj.activeEventIds) obj.activeEventIds = [];
                  
                  const dateMoment = obj.dateAsMomentObj;
                  if (
                    dateMoment.isBetween(startDate, endDate, null, '[]') ||
                    dateMoment.isSame(startDate, 'day') ||
                    dateMoment.isSame(endDate, 'day')
                  ) {
                    if (obj.activeEventIds.indexOf(evt._id) > -1) continue;
                    obj.activeEventIds.push(evt._id);
                    uniqueActiveEventIds.add(evt._id);
                  }
                }
              }
    
              activeEventsIndex += activeEventsBatchSize;
    
              if (activeEventsIndex < activeForms.length) {
                processActiveEventsBatch(); // Process next batch
              } else {
                // All activeForms processed, resolve the promise with the processed data
                eventsObj.totalActiveEvents = uniqueActiveEventIds.size;
                resolve({
                  data: Object.keys(countByDayObj).map(function (date) {
                    const obj = countByDayObj[date];
                    return {
                      date,
                      count: obj.count,
                      activeEventIds: obj.activeEventIds
                    };
                  }),
                  events: eventsObj
                });
              }
            }, 0);
          }
    
          // Start processing active events in batches
          processActiveEventsBatch();
        }
    
        // Start processing the batches
        processBatch();
      });
    }

    function applyCountsToBuckets(filteredResponses, countByDayObj) {

      const eventsObj = {
        totalSends: 0,
        weeklyTotal: filteredResponses.weeklyCount
      };

      _.each(filteredResponses.dateResults, function (obj) {
        if (!obj._id.interactionSubType) return;
        const initCreateDate = moment(obj._id.date).format('DD/MM/YYYY');
        if (countByDayObj[initCreateDate] && obj._id.interactionType == 'Email'
          && obj._id.interactionSubType === 'Sent'
          || obj._id.interactionSubType === 'SentTest') {
          countByDayObj[initCreateDate].count = obj.count;
          eventsObj.totalSends += obj.count;
        } else {
          if (!eventsObj[obj._id.interactionSubType.toLowerCase()]) eventsObj[obj._id.interactionSubType.toLowerCase()] = 0;
          eventsObj[obj._id.interactionSubType.toLowerCase()] += obj.count;
        }
      });

      return {
        data: _.map(countByDayObj, function (obj, key) {
          return {
            date: key,
            count: obj.count
          };
        }),
        events: eventsObj
      };
    }

    function applyCountsToEmailBuckets(filteredResponses, countByDayObj) {

      const eventsObj = {
        totalSends: 0
      };

      _.each(filteredResponses.sent, function (obj) {
        const initCreateDate = moment(obj.date).format('DD/MM/YYYY');
        if (!countByDayObj[initCreateDate]) return;

        for (const key of Object.keys(obj.counts)){
          countByDayObj[initCreateDate].counts[key.toLocaleLowerCase()] = obj.counts[key];
          if (key.toLocaleLowerCase() !== 'sent') continue;
          eventsObj.totalSends += obj.counts[key].count;
        }
      });

      return {
        data: _.map(countByDayObj, function (obj, key) {
          return {
            date: key,
            counts: obj.counts
          };
        }),
        events: _.fromPairs(_.map(filteredResponses.counts, function (item) {
          return [item.event.toLowerCase(), item.count];
        })),
        totalSends: eventsObj.totalSends
      };
    }

  }

}());
(function () {
  'use strict';

  angular
    .module('common')
    .factory('AggregatedEmailTemplateSendsFactory', Factory);

  Factory.$inject = ['GridAPI', 'ClientEmailTemplatesAPI', 'ChartBuilderFactory'];
  /** @ngInject */
  function Factory(GridAPI, ClientEmailTemplatesAPI, ChartBuilderFactory) {

    let factoryData = {};

    return {
      factoryData: factoryData,
      fetchData: fetchData,
      invalidateCache: invalidateCache
    };

    function invalidateCache() {
      factoryData = {};
    }

    /***
    @description this is used for the chart displayed on email main page
    */

    function fetchData(chartId, rangeStart, rangeEnd, param, schema) {

      const key = `${chartId}_${rangeStart.toISOString()}_${rangeEnd.toISOString()}_${schema}`;
      if (key in factoryData){
        const cachedData = factoryData[key];
        const now = moment();
        if (now.diff(cachedData.creationMoment, 'hour') < 4){
          return new Promise(function (resolve) {
            resolve(cachedData);
          });
        }

        delete factoryData[key];
      }

      const queryObj = {
        match: {
          datefield: '_initialcreatedatelocalutc',
          range: {
            $gte: rangeStart,
            $lte: rangeEnd
          }
        }
      };

      if (param) queryObj.match._templateType = param;

      if (chartId === 'aggregated_email_template_sends'){
        return GridAPI.aggregateEmailsSentByForms(queryObj)
          .then(function (sendInteractions) {
            return ChartBuilderFactory.buildChartData(chartId, sendInteractions, queryObj, schema)
              .then(function (data){
                factoryData[key] = data;
                return factoryData[key];
              });
          })
          .catch(function (err) {
            throw (err);
          });

      } else if (chartId === 'aggregated_client_email_template_sends'){
        return ClientEmailTemplatesAPI.aggregateTotalTemplateActivity(queryObj)
          .then(function (sendInteractions) {
            return ChartBuilderFactory.buildChartData(chartId, sendInteractions, queryObj, schema)
              .then(function (data){
                factoryData[key] = data;
                return factoryData[key];
              });
          })
          .catch(function (err) {
            throw (err);
          });

      }

    }
  }

}());
(function () {
  'use strict';

  angular
    .module('common')
    .factory('AggregateResponsesFactory', Factory);

  Factory.$inject = ['GridAPI', 'ChartBuilderFactory'];
  /** @ngInject */
  function Factory(GridAPI, ChartBuilderFactory) {

    let factoryData = {};

    return {
      factoryData: factoryData,
      fetchData: fetchData,
      invalidateCache: invalidateCache
    };

    function invalidateCache() {
      factoryData = {};
    }

    /***
    @description this is used for the chart displayed on events main page
    */

    function fetchData(widgetId, rangeStart, rangeEnd, schema) {
      const key = `${widgetId}_${rangeStart.toISOString()}_${rangeEnd.toISOString()}_${schema}`;
      if (key in factoryData){
        const cachedData = factoryData[key];
        const now = moment();
        if (now.diff(cachedData.creationMoment, 'hour') < 4){
          return new Promise(function (resolve) {
            resolve(cachedData);
          });
        }

        delete factoryData[key];
      }

      const queryObj = {
        match: {
          datefield: '_initialcreatedatelocalutc',
          range: {
            $gte: rangeStart,
            $lte: rangeEnd
          }
        }
      };

      return GridAPI.aggregateResponses(queryObj)
        .then(function (res) {
          return ChartBuilderFactory.buildChartData(widgetId, res.data.data, queryObj, schema)
            .then(function (data){
              factoryData[key] = data;
              return factoryData[key];
            });
        })
        .catch(function (err) {
          throw (err);
        });
    }
  }

}());
(function () {
  'use strict';

  angular
    .module('common')
    .component('zpDeleteButton', DeleteButton())
    .component('zpArchiveButton', ArchiveButton())
    .component('zpUnarchiveButton', UnarchiveButton())
    .component('zpRedactCrmButton', RedactCRMButton())
    .component('zpEditButton', EditButton())
    .component('zpSaveButton', SaveButton())
    .component('zpClearButton', ClearButton())
    .component('zpReorderButton', ReorderButton())
    .component('zpFilterButton', FilterButton())
    .component('zpToggleJsonButton', ToggleJSONButton())
    .controller('ZPButtonCtrl', ButtonCtrl)
    .controller('ZPReorderButtonCtrl', ZPReorderButtonCtrl)
    .controller('ZPFilterButtonCtrl', ZPFilterButtonCtrl);

  ButtonCtrl.$inject = [];
  /* ng-inject */
  function ButtonCtrl() {
    var vm = this;

    vm.$onInit = function (){};
  }


  ZPReorderButtonCtrl.$inject = [];
  /* ng-inject */
  function ZPReorderButtonCtrl() {
    var vm = this;
    vm.$onInit = function (){

    };
  }


  ZPFilterButtonCtrl.$inject = ['$scope'];
  /* ng-inject */
  function ZPFilterButtonCtrl($scope) {
    var vm = this;
    vm.isOpen = true;

    vm.$onInit = () => {
      const interval = setInterval(() => {
        vm.isOpen = false;
        clearInterval(interval);
        $scope.$digest();
      }, 5000);
    };
  }

  function DeleteButton() {
    return {
      templateUrl: 'app/common/buttons/zp-delete-button.tmpl.html',
      controller: 'ZPButtonCtrl',
      bindings: {
        label: '@',
        selected: '<',
        onClick: '&',
        disabled: '<'
      }
    };
  }


  function ArchiveButton() {
    return {
      templateUrl: 'app/common/buttons/zp-archive-button.tmpl.html',
      controller: 'ZPButtonCtrl',
      bindings: {
        label: '@',
        selected: '<',
        onClick: '&',
        disabled: '<'
      }
    };
  }


  function UnarchiveButton() {
    return {
      templateUrl: 'app/common/buttons/zp-unarchive-button.tmpl.html',
      controller: 'ZPButtonCtrl',
      bindings: {
        label: '@',
        selected: '<',
        onClick: '&',
        disabled: '<'
      }
    };
  }

  function RedactCRMButton() {
    return {
      templateUrl: 'app/common/buttons/zp-redact-crm-button.tmpl.html',
      controller: 'ZPButtonCtrl',
      bindings: {
        label: '@',
        selected: '<',
        onClick: '&',
        disabled: '<'
      }
    };
  }

  function SaveButton() {
    return {
      templateUrl: 'app/common/buttons/zp-save-button.tmpl.html',
      controller: 'ZPButtonCtrl',
      bindings: {
        isdirty: '<',
        isfab: '<',
        label: '@',
        save: '&',
        israised: '<',
        disabled: '<'
      }
    };
  }

  function EditButton() {
    return {
      templateUrl: 'app/common/buttons/zp-edit-button.tmpl.html',
      controller: 'ZPButtonCtrl',
      bindings: {
        label: '@',
        onClick: '&'
      }
    };
  }

  function ClearButton() {
    return {
      templateUrl: 'app/common/buttons/zp-clear-button.tmpl.html',
      controller: 'ZPButtonCtrl',
      bindings: {
        label: '@',
        onClick: '&'
      }
    };
  }

  function ReorderButton() {
    return {
      templateUrl: 'app/common/buttons/zp-reorder-button.tmpl.html',
      controller: 'ZPReorderButtonCtrl',
      bindings: {
        isActive: '<',
        isDisabled: '<',
        onClick: '&'
      }
    };
  }

  function FilterButton(){
    return {
      templateUrl: 'app/common/buttons/zp-filter-button.tmpl.html',
      controller: 'ZPFilterButtonCtrl',
      bindings: {
        filterButtons: '<'
      }
    };
  }

  function ToggleJSONButton() {
    return {
      templateUrl: 'app/common/buttons/zp-toggle-JSON-button.tmpl.html',
      bindings: {
        showJson: '='
      }
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('common')
    .directive('bindHtmlCompile', ['$compile', function ($compile) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          scope.$watch(function () {
            return scope.$eval(attrs.bindHtmlCompile);
          }, function (value) {
            // In case value is a TrustedValueHolderType, sometimes it
            // needs to be explicitly called into a string in order to
            // get the HTML string.
            element.html(value && value.toString());
            // If scope is provided use it, otherwise use parent scope
            let compileScope = scope;
            if (attrs.bindHtmlScope) {
              compileScope = scope.$eval(attrs.bindHtmlScope);
            }
            $compile(element.contents())(compileScope);
          });
        }
      };
    }]);
}());
(function () {
  'use strict';

  angular
    .module('common')
    .directive('autoNext', function () {
      return {
        restrict: 'A',
        link: function (scope, element, attr) {
          var tabindex = parseInt(attr.tabindex);
          var maxLength = parseInt(attr.ngMaxlength);
          element.on('keyup', function (e) {
            var elementLength = element.val().length;
            if (elementLength == maxLength) {
              var next = angular.element(document.body).find('[tabindex=' + (tabindex + 1) + ']');
              if (next.length > 0) {
                next.focus();
                return next.triggerHandler('keypress', {
                  which: e.which
                });
              } else {
                return false;
              }
            }
            return true;
          });

        }
      };
    });

}());

'use strict';
/* eslint no-undef: 0 */
angular.module('zp.auth').service('UserService', ['SessionService', 'EncodingService', 'APIService', 'MARKETPOINT_CLIENT_ID', 'ZUANT_AI_CLIENT_ID',
  function UserService(session, encoder, api, MARKETPOINT_CLIENT_ID, ZUANT_AI_CLIENT_ID) {

    const User = function User() {};

    User.prototype.getClientId = function () {
      const userData = session.getUserData();
      return userData.clientId || undefined;
    };

    User.prototype.isClientMarketpoint = function () {
      const userData = session.getUserData();
      if (userData && userData.clientId && userData.clientId === MARKETPOINT_CLIENT_ID) return true;
      return false;
    };

    User.prototype.isClientZuantAI = function () {
      const userData = session.getUserData();
      if (userData && userData.clientId && userData.clientId === ZUANT_AI_CLIENT_ID) return true;
      return false;
    };

    User.prototype.isClientArchived = function () {
      const userData = session.getUserData();
      if (userData && userData.clientArchived) return true;
      return false;
    };

    User.prototype.hasClientOperation = function () {
      const userData = session.getUserData();
      if (userData && userData.clientOperationStatus && _.isEmpty(userData.clientOperationStatus) === false) return true;
      return false;
    };

    User.prototype.setUserData = function (data) {
      session.setUserData(data);
    };

    User.prototype.getUserData = function () {
      const userData = session.getUserData();
      return userData;
    };

    User.prototype.savePreferences = function (settings) {
      const userData = session.getUserData();
      if ((!userData.clientId) || angular.equals(settings, userData.preferences)) {
        return;
      }

      const apiUrl = 'client/' + encoder.encode(userData.clientId) + '/user/' + encoder.encode(userData._id);
      return api.post(apiUrl, { preferences: settings })
        .then(function () {
          userData.preferences = settings;
          session.setUserData(userData);
        });
    };

    return new User();
  }]);

'use strict';
/* eslint no-undef: 0 */
angular
  .module('zp.auth')
  .service('UserGreetingService', UserGreetingService);

function UserGreetingService() {

  var UserGreeting = function UserGreeting() {};
  var displayUserGreeting;

  UserGreeting.prototype.getGreeting = function (userfirstname) {
    var g = null; //return g
    var m = moment(); // new moment date object

    var split_afternoon = 12; //24hr time to split the afternoon
    var split_evening = 17; //24hr time to split the evening
    var currentHour = parseFloat(m.format('HH'));

    if (currentHour < split_afternoon) {
      g = 'morning';
    } else if (currentHour >= split_afternoon && currentHour <= split_evening) {
      g = 'afternoon';
    } else {
      g = 'evening';
    }

    return 'Good ' + g + ', ' + userfirstname + '.';

  };

  UserGreeting.prototype.setDisplayUserGreeting = function (v) {
    displayUserGreeting = v;
  };

  UserGreeting.prototype.getDisplayUserGreeting = function () {
    return displayUserGreeting;
  };

  return new UserGreeting();
}

(function(){
  'use strict';

  angular
    .module('zp.auth')
    .factory('TokenFactory', TokenFactory);

  TokenFactory.$inject = ['SessionService', 'DOT_NET_API_CONFIG'];

  function TokenFactory(session, DOT_NET_API_CONFIG) {

    function handleResponse (resp) {
      const headers = resp.headers();
      /* only API calls return an Authorization header
       we don't want to look for the token if this HTTP request is just for a frontend asset */
      if (Object.keys(headers).indexOf('authorization') > -1) {
        session.setToken(resp.headers('Authorization'));
      }
      return resp;
    }

    const tokenHandler = {
      request: function (config) {
        if (
          config.url.indexOf('.html') === -1 &&
          config.url.indexOf('.json') === -1 &&
          config.url.toLowerCase().indexOf('.svg') === -1 &&
          !config.noAuth
        ) {
          if (Object.keys(config.headers).indexOf('Authorization') === -1) {
            config.headers['Authorization'] = session.getToken();
          }

          /* only calls to the shuttle API require the withCredentials to be set. */
          if (config.url.indexOf(DOT_NET_API_CONFIG.url) > -1) {
            config['withCredentials'] = true;
          }
        }
        return config;
      },
      response: function (response) {
        return handleResponse(response);
      }
    };

    return tokenHandler;
  }
})();

(function () {
  'use strict';

  angular
    .module('zp.auth')
    .service('SessionService', service);

  service.$inject = ['$rootScope', '$cookies', 'localStorageService', 'DATA_BACKEND_WSURL', 'WebSocketService'];
  /* ng-inject */
  function service($rootScope, cookies, localStorageService, DATA_BACKEND_WSURL, WebSocketService) {

    const Session = function Session() {};
    let websocketAuthorised = false;
    let websocket;
    let userData = localStorageService.get('user') || {};

    Session.prototype.getWebsocket = function () {
      return websocket;
    };
    
    Session.prototype.setToken = function (token) {
      cookies.putObject('authToken', token);
    };

    Session.prototype.getToken = function () {
      return cookies.getObject('authToken') || '';
    };

    Session.prototype.hasToken = function () {
      const token = cookies.getObject('authToken') || '';
      return !!token;
    };

    Session.prototype.removeToken = function () {
      cookies.remove('authToken');
    };

    Session.prototype.setUserData = function (data) {
      if (data && userData && Object.keys(userData).length > 0){

        if (data.clientId !== userData.clientId || data._id !== userData._id){
          if (!websocketAuthorised){
            this.authWebsocket(this.getToken());
          } else {
            this.reauthWebsocket(this.getToken());
          }

        } else if (!websocketAuthorised){
          this.authWebsocket(this.getToken());
        }
      }
      
      localStorageService.set('user', data);
      userData = data;

      $rootScope.$broadcast('zp.user_data.updated', data);
    };

    Session.prototype.getUserData = function () {
      return userData;
    };

    Session.prototype.hasUserData = function () {
      const localStorageUserData = localStorageService.get('user') || '';
      return !!localStorageUserData;
    };

    Session.prototype.authWebsocket = function (jwtToken) {
      const socketDefinition = WebSocketService.connections[DATA_BACKEND_WSURL];
      if (!socketDefinition) {
        websocket = WebSocketService.openConnection(DATA_BACKEND_WSURL);

        websocket.onConnectionOpen(function (){
          websocket.sendMessage(JSON.stringify({ type: 'auth', data: jwtToken}));
          websocketAuthorised = true;
        });

        websocket.onHeartBeat(function (){
          websocket.sendMessage(JSON.stringify({ type: 'ping', data: {}}));
        });
        return;
      }

      websocket = socketDefinition;

      websocket.sendMessage(JSON.stringify({ type: 'auth', data: jwtToken}));
      websocketAuthorised = true;
    };

    Session.prototype.reauthWebsocket = function (jwtToken) {
      if (WebSocketService.connections[DATA_BACKEND_WSURL]) {
        websocket = WebSocketService.connections[DATA_BACKEND_WSURL];
        websocket.sendMessage(JSON.stringify({ type: 'update', data: jwtToken}));
      }
    };

    Session.prototype.deAuthWebsocket = function () {
      if (WebSocketService.connections[DATA_BACKEND_WSURL]) {
        websocket = WebSocketService.connections[DATA_BACKEND_WSURL];
        websocket.sendMessage(JSON.stringify({ type: 'logout', data: {}}));
      }
    };

    Session.prototype.removeUserData = function () {
      localStorageService.remove('user');
    };

    Session.prototype.destroy = function () {
      this.removeToken();
      this.removeUserData();
      this.deAuthWebsocket();
    };

    return new Session();
  }
}());

(function () {
  'use strict';

  angular
    .module('common')
    .factory('UserPermissionsHelperFactory', factory);

  factory.$inject = ['$q', 'ClientsAPI', 'MessageService', 'SessionService'];
  /*ng-inject*/
  function factory($q, ClientsAPI, MessageService, SessionService) {

    const factoryData = {};

    return {
      init: hydrateFactory,
      derivePresetOrCustomTextFromPermissions: derivePresetOrCustomTextFromPermissions,
      deriveTypeOfUserFromPermissionPermissions: deriveTypeOfUserFromPermissionPermissions,
      factoryData: factoryData,
      getPermissionsPreset: getPermissionsPreset,
      permittedPresetsUserCanAdminister: permittedPresetsUserCanAdminister
    };

    ///////////////////////////////

    function hydrateFactory() {

      return new Promise(function (resolve, reject) {
        if (factoryData.presets) return resolve(factoryData); // already hydrated
        if (SessionService.hasToken()) {
          const permissionsToGrabFromServer = ['admin', 'power', 'standard', 'account'],
            arrayOfPromises = [];
          _.each(permissionsToGrabFromServer, function (preset) {
            arrayOfPromises.push(ClientsAPI.getPresetFromServer(preset));
          });
          $q
            .all(arrayOfPromises)
            .then(function (res) {
              // REFACTOR brittle!
              factoryData.presets = {
                admin: res[0].data,
                power: res[1].data,
                standard: res[2].data,
                account: res[3].data
              };
              resolve(factoryData);
            })
            .catch(function (err) {
              MessageService.writeLog({
                level: 'error',
                msg: err
              });
              reject(err);
            });
        } else {
          MessageService.writeLog({
            level: 'info',
            msg: 'user currently not authenticated. cannot fetch presets from server yet'
          });
          resolve();
        }
      });
    }

    function derivePresetOrCustomTextFromPermissions(userData) {
      try {
        if (angular.equals(userData.permissions, factoryData.presets.admin)) {
          return 'Admin Preset';
        } else if (angular.equals(userData.permissions, factoryData.presets.power)) {
          return 'Power User Preset';
        } else if (angular.equals(userData.permissions, factoryData.presets.standard)) {
          return 'Standard User Preset';
        } else {
          switch (userData.typeofuser) {
            case 'Administrator':
              return 'Admin Preset (Custom)';
            case 'PowerUser':
              return 'Power User Preset (Custom)';
            case 'Standard User':
              return 'Standard User Preset (Custom)';
            default:
              return 'Custom Preset';
          }
        }
      } catch (err) {
        MessageService.writeLog({
          level: 'error',
          msg: err
        });
      }
    }

    function deriveTypeOfUserFromPermissionPermissions(userData) {
      try {
        if (angular.equals(userData.permissions, factoryData.presets.admin)) {
          return 'Administrator';
        } else if (angular.equals(userData.permissions, factoryData.presets.power)) {
          return 'PowerUser';
        } else if (angular.equals(userData.permissions, factoryData.presets.standard)) {
          return 'Standard User';
        } else {
          switch (userData.typeofuser) {
            case 'Administrator':
              return 'Administrator';
            case 'PowerUser':
              return 'PowerUser';
            case 'Standard User':
              return 'Standard User';
            default:
              return 'Custom';
          }
        }
      } catch (err) {
        MessageService.writeLog({
          level: 'error',
          msg: err
        });
      }
    }

    function getPermissionsPreset(preset) {
      return $q(function q(resolve, reject) {
        if (factoryData.presets[preset]) {
          resolve(factoryData.presets[preset]);
        } else {
          return ClientsAPI.getPresetFromServer(preset)
            .then(function (res) {
              factoryData.presets[preset] = res.data;
              resolve(res.data);
            })
            .catch(function (err) {
              reject(err);
            });
        }
      });
    }

    function permittedPresetsUserCanAdminister(currentlyLoggedInUser) {

      var userPermissions = currentlyLoggedInUser.permissions,
        permittedPresets = [],
        availablePresets = [{
          name: 'Standard User',
          value: 'Standard User'
        },
        {
          name: 'Power User',
          value: 'PowerUser'
        },
        {
          name: 'Administrator',
          value: 'Administrator'
        }];

      if (userHasTrumpCard(userPermissions)) {
        return availablePresets;
      }

      // the least they can administer is the Standard User preset
      permittedPresets.push(availablePresets[0]);

      // if (permissionsContains(userPermissions, 'power')) {
      //   permittedPresets.push(availablePresets[1]);
      // }
      // if (permissionsContains(userPermissions, 'admin')) {
      //   permittedPresets.push(availablePresets[2]);
      // }

      // DF - If the current user is a power user or admin then it shouldn't matter if they 
      // have missing specific permissions, they ARE a power user or admin and should be 
      // able to set other users as such
      if (currentlyLoggedInUser.role && (currentlyLoggedInUser.role.toLowerCase().indexOf('power') > -1 || currentlyLoggedInUser.role.toLowerCase().indexOf('admin') > -1)) {
        permittedPresets.push(availablePresets[1]);
      }
      if (currentlyLoggedInUser.role && currentlyLoggedInUser.role.toLowerCase().indexOf('admin') > -1) {
        permittedPresets.push(availablePresets[2]);
      }

      return permittedPresets;
    }

    // function permissionsContains(permissionsSuperset, permissionsPreset) {
    //   var permissionsSubset = factoryData.presets[permissionsPreset];
    //   return IsSubsetFactory.isSubset(permissionsSuperset, permissionsSubset);
    // }

    function userHasTrumpCard(userPermissions) {
      return userPermissions.trump;
    }

  }
}());

(function () {
  'use strict';
  angular
    .module('zp.auth')
    .factory('PasswordResetFactory', PasswordResetFactory);

  PasswordResetFactory.$inject = ['$q', 'APIService', 'EncodingService', 'stringHelper'];
  /* ngInject */
  function PasswordResetFactory($q, api, encoder, stringHelper) {


    return {
      generateResetEmail: generateResetEmail,
      checkLinkIsValid: checkLinkIsValid,
      postNewPassword: postNewPassword
    };

    ///////////////

    function generateResetEmail(email) {
      return $q(
        function q(resolve, reject) {
          const payload = {
            email: email
          };

          const apiUrl = 'user/forgotPassword';
          return api.post(apiUrl, payload)
            .then(function (resp) {
              resolve(resp.data.data);
            })
            .catch(reject);
        }
      );
    }

    function checkLinkIsValid(clientId, userId, resetId) {
      return $q(
        function q(resolve, reject) {

          const apiUrl = 'user/linkIsValid';
          return api.post(apiUrl, { clientId, userId, resetId })
            .then(function (resp) {
              resolve(resp.data.data);
            })
            .catch(reject);
        }
      );
    }

    function postNewPassword(clientId, userId, resetId, password, repeatpassword) {
      return $q(
        function q(resolve, reject) {

          const apiUrl = 'client/' + encoder.encode(stringHelper.hex2a(clientId)) + '/resetToken/' + encoder.encode(resetId) + '/resetpassword';
          return api.post(apiUrl, { userId, password, repeatpassword })
            .then(function (resp) {
              resolve(resp);
            })
            .catch(reject);
        }
      );
    }

  }

}());

(function () {
  'use strict';
  angular
    .module('zp.auth')
    .factory('MfaFactory', MfaFactory);
  
  MfaFactory.$inject = ['APIService', 'SessionService', 'ZPPages', 'MasterPermissionsFactory', 'SendThankYouEmailIntegrityCheck', 'UserPermissionsHelperFactory'];
  /* ngInject */
  function MfaFactory(APIService, SessionService, ZPPages, MasterPermissionsFactory, SendThankYouEmailIntegrityCheck, UserPermissionsHelperFactory) {
  
    return {
      checkUrlTokenIsValid: checkUrlTokenIsValid,
      resendSetupEmail: resendSetupEmail,
      validatePasscode: validatePasscode,
      requestReset: requestReset,
      triggerReset: triggerReset,
      triggerResetByToken: triggerResetByToken,
      verifyPasscode: verifyPasscode
    };
    ///////////////
  
     
    function checkUrlTokenIsValid(token) {
      return new Promise(function (resolve, reject){
        if (!token || token.length < 10) reject();
        return APIService.postToDataApi('auth/mfa/generate', { token })
          .then(function (resp) {
            resolve(resp);
          })
          .catch(reject);
      });
    }

    function resendSetupEmail(databasename, userId) {
      return new Promise(function (resolve, reject){
        return APIService.postToDataApi('auth/mfa/resend-setup-email', { databasename, userId })
          .then(function () {
            resolve(true);
          })
          .catch(reject);
      });
    }

    function validatePasscode(passcode, tokenId) {
      return new Promise(function (resolve, reject){
        return APIService.postToDataApi('auth/mfa/validate', { passcode, tokenId })
          .then(function () {
            resolve(true);
          })
          .catch(reject);
      });
    }

    function requestReset(databasename, userId) {
      return new Promise(function (resolve, reject){
        return APIService.postToDataApi('auth/mfa/request-reset', { databasename, userId })
          .then(function (resp) {
            resolve(resp);
          })
          .catch(reject);
      });
    }

    function triggerReset(userId) {
      return new Promise(function (resolve, reject){
        return APIService.postToDataApi('auth/mfa/trigger-reset', { userId })
          .then(function (resp) {
            resolve(resp);
          })
          .catch(reject);
      });
    }

    function triggerResetByToken(token) {
      return new Promise(function (resolve, reject){
        return APIService.postToDataApi('auth/mfa/trigger-reset-by-token', { token })
          .then(function (resp) {
            resolve(resp);
          })
          .catch(reject);
      });
    }

    function verifyPasscode(payload) {
      return new Promise(function (resolve, reject){
        return APIService.postToDataApi('auth/mfa/verify', payload)
          .then(function (resp) {
            const data = resp.data.data;
            const userData = data.user;
            
            SessionService.setUserData(userData);
            ZPPages.updateVariablePagePaths(userData.clientId);

            MasterPermissionsFactory.init();
            UserPermissionsHelperFactory.init();

            return SendThankYouEmailIntegrityCheck.runCheckOnAccount()
              .then(function () {
                resolve();
              })
              .catch(reject);
          })
          .catch(reject);
      });
    }
  }
  
}());
  
(function () {
  'use strict';

  angular
    .module('zp.auth')
    .factory('MasterPermissionsFactory', factory);

  factory.$inject = ['$q', 'PermRoleStore', 'PermPermissionStore', 'SessionService', 'AuthService', 'ZuantAccountManagersFactory', 'CurrentClientModelFactory'];
  /* ng-inject */
  function factory($q, PermRoleStore, PermPermissionStore, session, auth, ZuantAccountManagersFactory, CurrentClientModelFactory) {

    return {
      init: init
    };


    function getUserData() {
      return $q(
        function q(resolve, reject) {
          const userData = session.getUserData();
          if (_.isEmpty(userData)){
            auth.authoriseUser()
              .then(function (data){
                resolve(data);
              })
              .catch(function (){
                reject();
              });
          } else {
            resolve(userData);
          }
        }
      );
    }

    function init() {

      PermPermissionStore
        .definePermission('AUTHORIZED', function () {
          return auth.authoriseUser();
        });

      PermPermissionStore
        .definePermission('UNAUTHORIZED', function () {
          try {
            return $q(
              function q(resolve, reject) {
                return auth.authoriseUser()
                  .then(function (){
                    reject(false);
                  })
                  .catch(function (){
                    resolve(true);
                  });
              }
            );
          } catch (e) {
            return true;
          }
        });

      PermPermissionStore
        .definePermission('MFA_ENABLED', function () {
          return new Promise (function (resolve, reject){
            const currentClient = _.get(CurrentClientModelFactory.factoryData, ['currentClient'], {});
            if (currentClient.ismfaenabled) resolve(true);
            reject(false);
          });
        });

      PermRoleStore
        .defineRole('BETA_TESTER_ROLE', ['BETA_TESTER']);

      PermPermissionStore
        .definePermission('BETA_TESTER', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.isBetaTester){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      PermRoleStore
        .defineRole('OLD_SHOWROOM_ROLE', ['OLD_SHOWROOM']);

      PermPermissionStore
        .definePermission('OLD_SHOWROOM', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.isUsingOldShowroom){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      PermPermissionStore
        .definePermission('ZUANT_ADMIN', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.marketpoint === 'Administrator'){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      PermPermissionStore
        .definePermission('ZAM', function () {
          try {
            return ZuantAccountManagersFactory.loggedInUserIsAZam();
          } catch (e) {
            return false;
          }
        });

      PermPermissionStore
        .definePermission('SUPER_ZAM', function () {
          try {
            return ZuantAccountManagersFactory.loggedInUserIsASuperZam();
          } catch (e) {
            return false;
          }
        });

      PermPermissionStore
        .definePermission('TRUMP', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.permissions.trump){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      PermPermissionStore
        .definePermission('CLOUD_LOGIN', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (permissionCheck(userData.permissions.login, 'portal')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      // ACCOUNT MANAGEMENT
      
      PermPermissionStore
        .definePermission('ACC_MGMT_PERMISSIONS', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.permissions.accountManagement.general.enabled && permissionCheck(userData.permissions.accountManagement.general.basic, 'managePermissions')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject();
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      PermPermissionStore
        .definePermission('ACC_MGMT_SETTINGS', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.permissions.accountManagement.general.enabled && permissionCheck(userData.permissions.accountManagement.general.basic, 'manageSettings')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject();
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      PermPermissionStore
        .definePermission('ACC_MGMT_TOKENS', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.permissions.accountManagement.general.enabled && permissionCheck(userData.permissions.accountManagement.general.basic, 'manageConsentTokens')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      PermPermissionStore
        .definePermission('ACC_MGMT_PRIVACY_STATEMENTS', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.permissions.accountManagement.general.enabled && permissionCheck(userData.permissions.accountManagement.general.basic, 'managePrivacyStatements')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      PermPermissionStore
        .definePermission('ACC_MGMT_TEAMS', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.permissions.accountManagement.general.enabled && permissionCheck(userData.permissions.accountManagement.general.basic, 'manageTeams')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      PermPermissionStore
        .definePermission('ACC_MGMT_CLIENT_EMAIL_TEMPLATES', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.permissions.accountManagement.general.enabled && permissionCheck(userData.permissions.accountManagement.general.basic, 'manageClientEmailTemplates')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      // USERS
      PermPermissionStore
        .definePermission('USERS_VIEW', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.users.enabled && userData.permissions.liteFeatures.users.enabled && permissionCheck(userData.permissions.liteFeatures.users.basic, 'view')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('USERS_EDIT', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.users.enabled && userData.permissions.liteFeatures.users.enabled && permissionCheck(userData.permissions.liteFeatures.users.basic, 'edit')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('USERS_ARCHIVE', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.users.enabled && userData.permissions.liteFeatures.users.enabled && permissionCheck(userData.permissions.liteFeatures.users.basic, 'archive')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      PermPermissionStore
        .definePermission('MESH_ENABLED', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    resolve(userData.permissions.liteFeatures.mesh.enabled);
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      PermPermissionStore
        .definePermission('MESH_VIEW', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.mesh.enabled && userData.permissions.liteFeatures.mesh.enabled && permissionCheck(userData.permissions.liteFeatures.mesh.basic, 'view')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('MESH_EDIT', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.mesh.enabled && userData.permissions.liteFeatures.mesh.enabled && permissionCheck(userData.permissions.liteFeatures.mesh.basic, 'edit')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('MESH_DELETE', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.mesh.enabled && userData.permissions.liteFeatures.mesh.enabled && permissionCheck(userData.permissions.liteFeatures.mesh.basic, 'delete')){
                      resolve();
                    } else{
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
        
      // FORMS
      PermPermissionStore
        .definePermission('FORMS_VIEW', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.forms.enabled && userData.permissions.liteFeatures.forms.enabled && permissionCheck(userData.permissions.liteFeatures.forms.basic, 'view')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('FORMS_EDIT', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.forms.enabled && userData.permissions.liteFeatures.forms.enabled && permissionCheck(userData.permissions.liteFeatures.forms.basic, 'edit')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('FORMS_ARCHIVE', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.forms.enabled && userData.permissions.liteFeatures.forms.enabled && permissionCheck(userData.permissions.liteFeatures.forms.basic, 'archive')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('FORMS_BADGE_SETUP', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.forms.enabled && userData.permissions.liteFeatures.forms.enabled && permissionCheck(userData.permissions.liteFeatures.forms.advanced, 'badgeSetup')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('FORMS_VIEW_DRAFTS', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.forms.enabled && userData.permissions.liteFeatures.forms.enabled && permissionCheck(userData.permissions.liteFeatures.forms.advanced, 'viewDrafts')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      // LEAD MANAGEMENT
      PermPermissionStore
        .definePermission('LEADS_DASHBOARD', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.leadManagement.enabled && userData.permissions.liteFeatures.leadManagement.enabled && permissionCheck(userData.permissions.liteFeatures.leadManagement.basic, 'dashboard')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('LEADS_VIEWGRID', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.leadManagement.enabled && userData.permissions.liteFeatures.leadManagement.enabled && permissionCheck(userData.permissions.liteFeatures.leadManagement.basic, 'viewGrid')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('LEADS_EDITGRID', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.leadManagement.enabled && userData.permissions.liteFeatures.leadManagement.enabled && permissionCheck(userData.permissions.liteFeatures.leadManagement.basic, 'editGrid')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('LEADS_DOWNLOAD', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.leadManagement.enabled && userData.permissions.liteFeatures.leadManagement.enabled && permissionCheck(userData.permissions.liteFeatures.leadManagement.basic, 'download')){
                      resolve();
                    } else{
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      // PICK A WINNER
      PermPermissionStore
        .definePermission('PICK_A_WINNER_ENABLED', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.pickAWinner.enabled && userData.permissions.liteFeatures.pickAWinner.enabled){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      // DATA
      PermPermissionStore
        .definePermission('DATA_ENABLED', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.data.enabled && userData.permissions.liteFeatures.data.enabled){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('DATA_LOAD', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.data.enabled && userData.permissions.liteFeatures.data.enabled && permissionCheck(userData.permissions.liteFeatures.data.basic, 'load')){
                      resolve();
                    } else{
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('DATA_COMPLY', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.data.enabled && userData.permissions.liteFeatures.data.enabled && permissionCheck(userData.permissions.liteFeatures.data.basic, 'comply')){
                      resolve();
                    } else{
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('DATA_HOUSEKEEPING', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.liteFeatures.data.enabled && userData.permissions.liteFeatures.data.enabled && permissionCheck(userData.permissions.liteFeatures.data.basic, 'housekeep')){
                      resolve();
                    } else{
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      // BOLT ON PERMISSIONS
      // EDITOR > LISTS
      PermPermissionStore
        .definePermission('EDITOR_ENABLED', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.formManagement.enabled && userData.permissions.boltOns.formManagement.enabled && permissionCheck(userData.permissions.boltOns.formManagement.editor, 'view')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('LISTS_VIEW', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.formManagement.enabled && userData.permissions.boltOns.formManagement.enabled && permissionCheck(userData.permissions.boltOns.formManagement.predefinedLists, 'view')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('LISTS_EDIT', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.formManagement.enabled && userData.permissions.boltOns.formManagement.enabled && permissionCheck(userData.permissions.boltOns.formManagement.predefinedLists, 'edit')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('LISTS_ARCHIVE', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.formManagement.enabled && userData.permissions.boltOns.formManagement.enabled && permissionCheck(userData.permissions.boltOns.formManagement.predefinedLists, 'archive')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      // OCR
      PermPermissionStore
        .definePermission('OCR_ENABLED', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.ocr.enabled && userData.permissions.boltOns.ocr.enabled){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('OCR_VIEW', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.ocr.enabled && userData.permissions.boltOns.ocr.enabled && permissionCheck(userData.permissions.boltOns.ocr.basic, 'view')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('OCR_EDIT', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.ocr.enabled && userData.permissions.boltOns.ocr.enabled && permissionCheck(userData.permissions.boltOns.ocr.basic, 'edit')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      // AI BOLTON
      PermPermissionStore
        .definePermission('AI_ENABLED', function () {
          try {
            return $q(
              function q(resolve, reject) {
                return getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.ai.enabled && userData.permissions.boltOns.ai.enabled) return resolve();
                    return reject(false);
                  })
                  .catch(function (){
                    return reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('AI_VIEW', function () {
          try {
            return $q(
              function q(resolve, reject) {
                return getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.ai.enabled && userData.permissions.boltOns.ai.enabled && permissionCheck(userData.permissions.boltOns.ai.basic, 'view')) return resolve();
                    return reject(false);
                  })
                  .catch(function (){
                    return reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('AI_EDIT', function () {
          try {
            return $q(
              function q(resolve, reject) {
                return getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.ai.enabled && userData.permissions.boltOns.ai.enabled && permissionCheck(userData.permissions.boltOns.ai.basic, 'edit')) return resolve();
                    return reject(false);
                  })
                  .catch(function (){
                    return reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });


      // EMAILS BOLTON
      PermPermissionStore
        .definePermission('EMAILS_ENABLED', function () {
          try {
            return $q(
              function q(resolve, reject) {
                return getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.emails.enabled && userData.permissions.boltOns.emails.enabled) return resolve();
                    return reject(false);
                  })
                  .catch(function (){
                    return reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('TYE_VIEW', function () {
          try {
            return $q(
              function q(resolve, reject) {
                return getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.emails.enabled && userData.permissions.boltOns.emails.enabled && permissionCheck(userData.permissions.boltOns.emails.thankYouEmails, 'view')) return resolve();
                    return reject(false);
                  })
                  .catch(function (){
                    return reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('TYE_EDIT', function () {
          try {
            return $q(
              function q(resolve, reject) {
                return getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.emails.enabled && userData.permissions.boltOns.emails.enabled && permissionCheck(userData.permissions.boltOns.emails.thankYouEmails, 'edit')) return resolve();
                    return reject();
                  })
                  .catch(function (){
                    return reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('TYE_ARCHIVE', function () {
          try {
            return $q(
              function q(resolve, reject) {
                return getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.emails.enabled && userData.permissions.boltOns.emails.enabled && permissionCheck(userData.permissions.boltOns.emails.thankYouEmails, 'archive')) return resolve();
                    return reject();
                  })
                  .catch(function (){
                    return reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('MCM_VIEW', function () {
          try {
            return $q(
              function q(resolve, reject) {
                return getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.emails.enabled && userData.permissions.boltOns.emails.enabled && permissionCheck(userData.permissions.boltOns.emails.messageComposer, 'view')) return resolve();
                    return reject(false);
                  })
                  .catch(function (){
                    return reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      
      // SHOWROOM BOLTON
      PermPermissionStore
        .definePermission('SHOWROOM_ENABLED', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.showroom.enabled && userData.permissions.boltOns.showroom.enabled){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('SHOWROOM_VIEW', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.showroom.enabled && userData.permissions.boltOns.showroom.enabled && permissionCheck(userData.permissions.boltOns.showroom.basic, 'view')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('SHOWROOM_EDIT', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.showroom.enabled && userData.permissions.boltOns.showroom.enabled && permissionCheck(userData.permissions.boltOns.showroom.basic, 'edit')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('SHOWROOM_ARCHIVE', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.showroom.enabled && userData.permissions.boltOns.showroom.enabled && permissionCheck(userData.permissions.boltOns.showroom.basic, 'archive')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('SHOWROOM_BLOCKS', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.showroom.enabled && userData.permissions.boltOns.showroom.enabled && permissionCheck(userData.permissions.boltOns.showroom.advanced, 'blocks')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      // THEMING BOLTON
      PermPermissionStore
        .definePermission('CUSTOM_SKINS_ENABLED', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.customSkins.enabled && userData.permissions.boltOns.customSkins.enabled){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('CUSTOM_SKINS_VIEW', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.customSkins.enabled && userData.permissions.boltOns.customSkins.enabled && permissionCheck(userData.permissions.boltOns.customSkins.basic, 'view')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('CUSTOM_SKINS_EDIT', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.customSkins.enabled && userData.permissions.boltOns.customSkins.enabled && permissionCheck(userData.permissions.boltOns.customSkins.basic, 'edit')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('CUSTOM_SKINS_DELETE', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.customSkins.enabled && userData.permissions.boltOns.customSkins.enabled && permissionCheck(userData.permissions.boltOns.customSkins.basic, 'delete')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });

      // INTEGRATION BOLTON
      PermPermissionStore
        .definePermission('INTEGRATION_ENABLED', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.integration.enabled && userData.permissions.boltOns.integration.enabled){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('INTEGRATION_MACHINES_VIEW', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.integration.enabled && userData.permissions.boltOns.integration.enabled && permissionCheck(userData.permissions.boltOns.integration.machines, 'view')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('INTEGRATION_MACHINES_EDIT', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.integration.enabled && userData.permissions.boltOns.integration.enabled && permissionCheck(userData.permissions.boltOns.integration.machines, 'edit')) {
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('INTEGRATION_MACHINES_DELETE', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.integration.enabled && userData.permissions.boltOns.integration.enabled && permissionCheck(userData.permissions.boltOns.integration.machines, 'delete')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('INTEGRATION_LEAD_RELEASE_RELEASE', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.integration.enabled && userData.permissions.boltOns.integration.enabled && permissionCheck(userData.permissions.boltOns.integration.leadRelease, 'release')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('INTEGRATION_LEAD_RELEASE_EDIT', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.integration.enabled && userData.permissions.boltOns.integration.enabled && permissionCheck(userData.permissions.boltOns.integration.leadRelease, 'edit')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
      PermPermissionStore
        .definePermission('INTEGRATION_LOGINS_MANAGE', function () {
          try {
            return $q(
              function q(resolve, reject) {
                getUserData()
                  .then(function (userData){
                    if (userData.accountPermissions.boltOns.integration.enabled && userData.permissions.boltOns.integration.enabled && permissionCheck(userData.permissions.boltOns.integration.loginCredentials, 'manage')){
                      resolve();
                    } else {
                      reject();
                    }
                  })
                  .catch(function (){
                    reject(false);
                  });
              }
            );
          } catch (e) {
            return false;
          }
        });
    }

    function permissionCheck(permissionSet, permissionRequired) {
      const permitted = _.find(permissionSet, function (permission) {
        return permission == permissionRequired;
      });
      return !!permitted;
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('zp.auth')
    .factory('MasterPermissionsDefinitionFactory', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    return {
      zuant_admin: ['ZUANT_ADMIN'],
      trump: ['TRUMP'],
      isBetaTestingAccount: ['BETA_TESTER'],
      accountManagement: {
        general: {
          managePermissions: ['ZUANT_ADMIN', 'TRUMP', 'ACC_MGMT_PERMISSIONS'],
          manageSettings: ['ZUANT_ADMIN', 'TRUMP', 'ACC_MGMT_SETTINGS'],
          manageConsentTokens: ['ZUANT_ADMIN', 'TRUMP', 'ACC_MGMT_TOKENS'],
          managePrivacyStatements: ['ZUANT_ADMIN', 'TRUMP', 'ACC_MGMT_PRIVACY_STATEMENTS'],
          manageTeams: ['ZUANT_ADMIN', 'TRUMP', 'ACC_MGMT_TEAMS'],
          manageClientEmailTemplates: ['ZUANT_ADMIN', 'TRUMP', 'ACC_MGMT_CLIENT_EMAIL_TEMPLATES']
        }
      },
      liteFeatures: {
        users: {
          view: ['ZUANT_ADMIN', 'TRUMP', 'USERS_VIEW'],
          edit: ['ZUANT_ADMIN', 'TRUMP', 'USERS_EDIT'],
          archive: ['ZUANT_ADMIN', 'TRUMP', 'USERS_ARCHIVE']
        },
        forms: {
          view: ['ZUANT_ADMIN', 'TRUMP', 'FORMS_VIEW'],
          edit: ['ZUANT_ADMIN', 'TRUMP', 'FORMS_EDIT'],
          archive: ['ZUANT_ADMIN', 'TRUMP', 'FORMS_ARCHIVE'],
          advanced: {
            badgeSetup: ['ZUANT_ADMIN', 'TRUMP', 'FORMS_BADGE_SETUP'],
            viewDrafts: ['ZUANT_ADMIN', 'TRUMP', 'FORMS_VIEW_DRAFTS']
          }
        },
        leadManagement: {
          dashboard: ['ZUANT_ADMIN', 'TRUMP', 'LEADS_DASHBOARD'],
          viewGrid: ['ZUANT_ADMIN', 'TRUMP', 'LEADS_VIEWGRID'],
          editGrid: ['ZUANT_ADMIN', 'TRUMP', 'LEADS_EDITGRID'],
          download: ['ZUANT_ADMIN', 'TRUMP', 'LEADS_DOWNLOAD']
        },
        pickAWinner: {
          enabled: ['ZUANT_ADMIN', 'TRUMP', 'PICK_A_WINNER_ENABLED'],
          view: ['ZUANT_ADMIN', 'TRUMP', 'PICK_A_WINNER']
        },
        data: {
          enabled: ['ZUANT_ADMIN', 'TRUMP', 'DATA_ENABLED'],
          load: ['ZUANT_ADMIN', 'TRUMP', 'DATA_LOAD'],
          comply: ['ZUANT_ADMIN', 'TRUMP', 'DATA_COMPLY'],
          housekeep: ['ZUANT_ADMIN', 'TRUMP', 'DATA_HOUSEKEEPING'],
          admin: ['ZUANT_ADMIN']
        },
        mesh: {
          enabled: ['ZUANT_ADMIN', 'TRUMP', 'MESH_ENABLED'],
          view: ['ZUANT_ADMIN', 'TRUMP', 'MESH_VIEW'],
          edit: ['ZUANT_ADMIN', 'TRUMP', 'MESH_EDIT'],
          delete: ['ZUANT_ADMIN', 'TRUMP', 'MESH_DELETE'],
        }
      },
      boltOns: {
        formManagement: {
          enabled: ['ZUANT_ADMIN', 'TRUMP'],
          editor: ['ZUANT_ADMIN', 'TRUMP', 'EDITOR_ENABLED'],
          predefinedLists: {
            view: ['ZUANT_ADMIN', 'TRUMP', 'LISTS_VIEW'],
            edit: ['ZUANT_ADMIN', 'TRUMP', 'LISTS_EDIT'],
            archive: ['ZUANT_ADMIN', 'TRUMP', 'LISTS_ARCHIVE']
          },
          advanced: {
            databaseSettings: ['ZUANT_ADMIN', 'TRUMP', 'EDITOR_EDIT_DB_SETTINGS']
          }
        },
        ocr: {
          enabled: ['ZUANT_ADMIN', 'TRUMP', 'OCR_ENABLED'],
          view: ['ZUANT_ADMIN', 'TRUMP', 'OCR_VIEW'],
          edit: ['ZUANT_ADMIN', 'TRUMP', 'OCR_EDIT']
        },
        ai: {
          enabled: ['AI_ENABLED'],
          view: ['AI_VIEW'],
          edit: ['AI_EDIT']
        },
        emails: {
          enabled: ['ZUANT_ADMIN', 'TRUMP', 'EMAILS_ENABLED'],
          thankYouEmails: {
            view: ['ZUANT_ADMIN', 'TRUMP', 'TYE_VIEW'],
            edit: ['ZUANT_ADMIN', 'TRUMP', 'TYE_EDIT'],
            archive: ['ZUANT_ADMIN', 'TRUMP', 'TYE_ARCHIVE']
          },
          messageComposer: {
            view: ['ZUANT_ADMIN', 'TRUMP', 'MSG_VIEW'],
            edit: ['ZUANT_ADMIN', 'TRUMP', 'MSG_EDIT']
          }
        },
        showroom: {
          enabled: ['ZUANT_ADMIN', 'TRUMP', 'SHOWROOM_ENABLED'],
          view: ['ZUANT_ADMIN', 'TRUMP', 'SHOWROOM_VIEW'],
          edit: ['ZUANT_ADMIN', 'TRUMP', 'SHOWROOM_EDIT'],
          archive: ['ZUANT_ADMIN', 'TRUMP', 'SHOWROOM_ARCHIVE'],
          blocks: ['ZUANT_ADMIN', 'TRUMP', 'SHOWROOM_BLOCKS']
        },
        theming: {
          enabled: ['ZUANT_ADMIN', 'TRUMP', 'CUSTOM_SKINS_ENABLED'],
          view: ['ZUANT_ADMIN', 'TRUMP', 'CUSTOM_SKINS_VIEW'],
          edit: ['ZUANT_ADMIN', 'TRUMP', 'CUSTOM_SKINS_EDIT'],
          delete: ['ZUANT_ADMIN', 'TRUMP', 'CUSTOM_SKINS_DELETE']
        },
        integration: {
          enabled: ['ZUANT_ADMIN', 'TRUMP', 'INTEGRATION_ENABLED'],
          machines: {
            view: ['ZUANT_ADMIN', 'TRUMP', 'INTEGRATION_MACHINES_VIEW'],
            edit: ['ZUANT_ADMIN', 'TRUMP', 'INTEGRATION_MACHINES_EDIT'],
            delete: ['ZUANT_ADMIN', 'TRUMP', 'INTEGRATION_MACHINES_DELETE'],
          },
          leadRelease: {
            release:  ['ZUANT_ADMIN', 'TRUMP', 'INTEGRATION_LEAD_RELEASE_RELEASE'],
            edit: ['ZUANT_ADMIN', 'TRUMP', 'INTEGRATION_LEAD_RELEASE_EDIT']
          },
          loginCredentials: {
            manage: ['ZUANT_ADMIN', 'TRUMP', 'INTEGRATION_LOGINS_MANAGE']
          }
        }
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('zp.auth')
    .service('AuthService', service);

  service.$inject = ['$rootScope', '$state', '$q', 'SessionService', 'UserService', 'APIService', 'ZPPages', 'MessageService', 'DATA_BACKEND_WSURL', 'MARKETPOINT_CLIENT_ID'];
  /* ng-inject */
  function service($rootScope, $state, $q, SessionService, UserService, APIService, zpPages, MessageService, DATA_BACKEND_WSURL, MARKETPOINT_CLIENT_ID) {

    const Auth = function Auth() {};
    let token = null;
    let requestTime = moment();

    let authUserPromise;
    let checkAuthPromise;

    Auth.prototype.authenticateUser = function (email, password) {
      return $q(
        function q(resolve, reject) {

          if (!(email && password)) {
            reject(new Error('Username and password are required'));
          }

          APIService.postToDataApi('auth/login', {
            email: email,
            password: password
          })
            .then(resolve)
            .catch(reject);
        }
      );
    };

    Auth.prototype.deauthenticateUser = function () {
      return $q(
        function q(resolve, reject) {

          APIService.post('user/deauthorise')
            .then(resolve)
            .catch(reject);
        }
      );
    };

    Auth.prototype.authoriseUser = function () {

      if (authUserPromise && authUserPromise.$$state === 0){
        return authUserPromise;
      }

      authUserPromise = $q(
        function q(resolve, reject) {
          const prev_Token = SessionService.getToken();
          const diffTime = moment().diff(requestTime, 'seconds');

          if (SessionService.hasToken() && token !== prev_Token && (!token || diffTime > 30)){

            checkAuthStatus()
              .then(function(sessionData){
                resolve(sessionData);
              })
              .catch(function(){
                reject();
              });

          } else if (token) {

            if (SessionService.hasUserData()){
              const userData = UserService.getUserData();
              return resolve(userData);
            }

            checkAuthStatus()
              .then(function(sessionData){
                resolve(sessionData);
              })
              .catch(function(){
                reject();
              });

          } else {
            reject();
          }
        }
      );

      return authUserPromise;
    };

    const checkAuthStatus = function (){
      if (checkAuthPromise && checkAuthPromise.$$state === 0){
        return checkAuthPromise;
      }

      checkAuthPromise = $q(
        function q(resolve, reject) {
          requestTime = moment();

          APIService.getFromDataApi('auth/check-auth-status')
            .then( function(resp) {
              if (resp && resp.data && resp.data.userData){
                UserService.setUserData(resp.data.userData);
              }
              token = SessionService.getToken();
              const userData = UserService.getUserData();
              return resolve(userData);
            })
            .catch( function() {
              token = null;
              SessionService.destroy();
              return reject();
            });
        }
      );
      return checkAuthPromise;
    };
    
    function switchAccount (data) {
      const clientId = data._id;

      return $q(
        function q(resolve, reject) {
          APIService.post('user/switchAccount', {
            parameters: {
              databasename: data.databasename,
              companyname: data.companyname
            },
            fields: {
              users: 0,
              machines: 0
            }
          })
            .then(function (res) {
              const userData = UserService.getUserData();
              const userIsMarketpoint = angular.copy(userData.marketpoint);
              const updatedUserData = _.extend(userData, res.data.data);
              if (updatedUserData.clientOperationStatus && !res.data.data.clientOperationStatus){
                delete updatedUserData.clientOperationStatus;
              }
              updatedUserData.marketpoint = userIsMarketpoint;
              UserService.setUserData(updatedUserData);
              return zpPages.updateVariablePagePaths(clientId) // e.g /clients/edit/:_id/users
                .then(function () {
                  $rootScope.$broadcast('zp.account.change', {
                    databasename: userData.databasename
                  });
                  resolve(userData);
                })
                .catch(reject);
             
            })
            .catch(reject);
        }
      );
    }

    Auth.prototype.switchAccount = switchAccount;


    Auth.prototype.hasToken = function () {
      return SessionService.hasToken();
    };

    $rootScope.$on('zp.websocket.messageRecieved', function(event, props){
      if (props.connection !== DATA_BACKEND_WSURL) return;

      const message = JSON.parse(props.message);
      const userData = UserService.getUserData();

      switch (message.type){
        case 'unarchiveClient':
        case 'archiveClient':{
          if (userData.databasename !== message.data.databasename || !userData.marketpoint) break;
          if (message.data.milestone !== 'complete') break;

          const operation = message.type === 'archiveClient' ? 'archived' : 'unarchived';

          const deltas = {
            clientArchived: message.type === 'unarchiveClient' ? false : true
          };

          if (message.type === 'unarchiveClient') deltas.clientRedacted = false;

          const updatedUserData = Object.assign(userData, deltas);
          MessageService.showMessage(message.data.databasename + ' has been sucessfully ' + operation);

          UserService.setUserData(updatedUserData);

          break;
        }
        case 'redactAllCRM':{
          if (userData.databasename !== message.data.databasename || !userData.marketpoint) break;
          if (message.data.milestone !== 'complete') break;

          const deltas = {
            clientRedacted: true
          };

          const updatedUserData = Object.assign(userData, deltas);
          UserService.setUserData(updatedUserData);

          MessageService.showMessage(message.data.databasename + ' has been sucessfully redacted');
          
          break;
        }
        case 'deleteClient':{

          if (userData.databasename !== message.data.databasename || !userData.marketpoint) break;

          if (!SessionService.hasUserData()) break;

          if (message.data.milestone !== 'complete') break;
            
          return switchAccount({
            clientId: MARKETPOINT_CLIENT_ID,
            databasename: 'Marketpoint'
          }).then(function (clientDoc){
            if ($state.current.name !== 'app.homescreen_app_framework.clients.home') $state.go('app.homescreen_app_framework.clients.home');
            MessageService.showMessage(message.data.databasename + ' has been sucessfully deleted. Now managing: ' + clientDoc.databasename);
          });
        }
      }

    });

    Auth.prototype.updatePassword = function (databasename, userId, password){
      return new Promise(function (resolve, reject){
        return APIService.postToDataApi('auth/update-password', { databasename, userId, password })
          .then(function (resp) {
            resolve(resp);
          })
          .catch(reject);
      });
    };

    return new Auth();
  }
}());

'use strict';
angular.module('zp.api', []);

(function () {
  'use strict';

  angular
    .module('zp.api')
    .service('APIService', APIService);

  APIService.$inject = ['$rootScope', '$http', '$q', 'EnvService', 'DATA_API_CONFIG', 'AWS_STORAGE_REGION', 'AWS_STORAGE_BUCKET_NAME', 'SessionService', '$location'];

  function APIService($rootScope, $http, $q, env, dataApiConfig, awsStorageRegion, awsStorageBucketName, session, location) {
    return {
      get: httpGet,
      post: httpPost,
      delete: httpDelete,
      getFromDataApi: getFromDataApi,
      postToDataApi: postToDataApi,
      uploadFileToS3: uploadFileToS3,
      uploadFile: uploadFile,
    };

    function httpGet(source) {
      return $q(function q(resolve, reject) {

        const url = getUrl(source);

        $http.get(
          url,
          getHeader()
        )
          .then(resolve)
          .catch(function (err) {
            handleErrorResponse(reject, err);
          });
      });
    }

    function httpPost(source, data, files) {
      return $q(function q(resolve, reject) {

        const fd = new FormData();
        for (const key in data) {
          /* ignore any keys whose value is undefined */
          if (undefined !== data[key]) {
            if (typeof data[key] === 'string') {
              data[key].trim();
            }
            fd.append(key, angular.toJson(data[key]));
          }
        }

        if (files) {
          for (const k in files) {
            if (undefined !== files[k]) {
              fd.append(k, files[k]);
            }
          }
        }

        const url = getUrl(source);

        $http.post(
          url,
          fd,
          getHeader()
        )
          .then(resolve)
          .catch(function (err) {
            handleErrorResponse(reject, err);
          });
      });
    }

    function getFromDataApi(source) {
      return $q(function q(resolve, reject) {

        const url = getDataUrl(source);
        const options = getHeader();
        options.timeout = 30000;

        $http.get(
          url,
          options
        )
          .then(resolve)
          .catch(reject);
      });
    }

    function postToDataApi(source, data) {
      return $q(function q(resolve, reject) {

        const url = getDataUrl(source);

        $http.post(
          url,
          angular.toJson(data), {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )
          .then(resolve)
          .catch(reject);
      });
    }

    function getContentType(name) {
      switch (true) {
        case name.indexOf('.pdf') > -1:
          return this.imageOnly ? null : { contentType: 'application/pdf', extension: '.pdf' };
        case name.indexOf('.jpg') > -1 || name.indexOf('.jpeg') > -1:
          return { contentType: 'image/jpeg', extension: '.jpeg' };
        case name.indexOf('.png') > -1:
          return { contentType: 'image/png', extension: '.png' };
        case name.indexOf('.gif') > -1:
          return { contentType: 'image/gif', extension: '.gif' };
        case name.indexOf('.mp4') > -1:
          return this.imageOnly ? null : { contentType: 'video/mp4', extension: '.mp4' };
        case name.indexOf('.mov') > -1:
          return this.imageOnly ? null : { contentType: 'video/mov', extension: '.mov' };
        case name.indexOf('.3gp') > -1:
          return this.imageOnly ? null : { contentType: 'video/3gp', extension: '.3gp' };
        default:
          return null;
      }
    }

    function uploadFileToS3(data) {
      const contentType = getContentType(data.file.name);
      const url = getS3Url();

      return this.getFromDataApi('aws/s3/getS3UploadPolicy')
        .then(function (res) {
          const uploadPolicy = res.data.data;
          const s3Key = `${uploadPolicy.key}${data._id}${contentType.extension}`;
          const fd = {
            key: s3Key,
            'Content-Type': contentType.contentType,
            acl: 'public-read',
            success_action_status: '200',
            'x-amz-algorithm': 'AWS4-HMAC-SHA256',
            'x-amz-date': uploadPolicy.date,
            'x-amz-credential': uploadPolicy.credential,
            policy: uploadPolicy.policy,
            'x-amz-signature': uploadPolicy.signature,
            file: data.file
          };

          const formData = new FormData();
          for (const k in fd) {
            if (undefined !== fd[k]) {
              if (typeof fd[k] === 'string') {
                fd[k].trim();
              }
              formData.append(k, fd[k]);
            }
          }

          const options = getHeader();
          options.noAuth = true;
          options.uploadEventHandlers = {
            progress: function (e) {
              const percentage = Math.round((e.loaded / e.total) * 100);
              $rootScope.$broadcast('s3upload.progress', percentage);
            }
          };

          return $http.post(
            url,
            formData,
            options
          )
            .then(function () {
              return s3Key;
            })
            .catch(function (err) {
              return handleErrorResponse(defer.reject.bind(defer), err);
            });

        });

    }

    function uploadFile(source, data, files, timeoutPromise) {
      const defer = $q.defer();

      const fd = new FormData();
      for (const key in data) {
        /* ignore any keys whose value is undefined */
        if (undefined !== data[key]) {
          if (typeof data[key] === 'string') {
            data[key].trim();
          }
          fd.append(key, angular.toJson(data[key]));
        }
      }

      if (files) {
        for (const k in files) {
          if (undefined !== files[k]) {
            fd.append(k, files[k]);
          }
        }
      }

      const url = getDataUrl(source);
      const options = getHeader();
      options.uploadEventHandlers = {
        progress: function (e) {
          defer.notify(e.loaded * 100 / e.total);
        }
      };

      if (timeoutPromise) {
        options.timeout = timeoutPromise.promise;
      }

      $http.post(
        url,
        fd,
        options
      )
        .then(defer.resolve.bind(defer))
        .catch(function (err) {
          handleErrorResponse(defer.reject.bind(defer), err);
        });

      return defer.promise;
    }

    function httpDelete(source) {
      return $q(function q(resolve, reject) {
        const url = getUrl(source);

        $http.delete(
          url,
          getHeader()
        )
          .then(resolve)
          .catch(reject);
      });
    }

    //PRIVATE Functions

    function getHeader() {
      const rv = {
        headers: {
          'Content-Type': undefined
        }
      };
      return rv;
    }

    function getUrl(path) {
      return env.api.host + ':' + env.api.port + '/api/' + path;
    }

    function getDataUrl(path) {
      return dataApiConfig.url + ':' + dataApiConfig.port + '/api/' + path;
    }

    function getS3Url() {
      return 'https://s3.' + awsStorageRegion + '.amazonaws.com/' + awsStorageBucketName;
    }

    function handleErrorResponse(reject, err) {
      if (err.status === 401 && (err.config.url.indexOf('/api/user/authenticate') === -1)) {
        location.path('/login');
        session.destroy();
        return;
      }
      reject(err);
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('zp.api')
    .factory('APIFactory', APIFactory);

  APIFactory.$inject = ['APIModel'];
  function APIFactory(model) {

    return {
      route: function encloseRoute(route) {
        return new model(route);
      }
    };
  }
})();

(function(){
  'use strict';

  angular
    .module('zp.api')
    .factory('APIModel', APIModel);

  APIModel.$inject = ['APIService', 'EncodingService'];
  function APIModel(api, encoder) {

    const cloneWithoutId = function (data) {
      const newData = {};
      for (const prop in data) {
        if (prop !== '_id'){
          newData[prop] = data[prop];
        }
      }
      return newData;
    };

    const model = function (route) {

      this.get = function () {
        return api.get(route);
      };

      this.getById = function (id) {
        return api.get(route + '/' + encoder.encode(id));
      };

      this.create = function (data, files) {
        return api.post(route, data, files);
      };

      this.update = function (data, files) {
        const id = data._id;
        const newData = cloneWithoutId(data);
        return api.post(route + '/' + encoder.encode(id), newData, files);
      };

      this.updateProperty = function (property, id, data) {
        return api.post(route + '/' + encoder.encode(id) + '/' + property, data);
      };

      this.delete = function(id) {
        return api.delete(route + '/' + encoder.encode(id));
      };

      this.archive = function(id) {
        return api.post(route + '/archive/' + encoder.encode(id));
      };

      this.query = function(query) {
        return api.post(route + '/query', query);
      };

      this.post = function(apiUrl, query) {
        return api.post(route + '/' + apiUrl, query);
      };
    };

    return model;
  }
})();

/**
 * Created by davidbeazer on 10/10/2016.
 */
(function () {
  'use strict';

  angular
    .module('common')
    .component('zpAccountSelection', {
      controller: 'ZPAccountSelectionController',
      templateUrl: 'app/common/account-select/zp-account-select.tmpl.html'
    })
    .controller('ZPAccountSelectionController', AccountSelectionController);

  AccountSelectionController.$inject = ['$scope', 'AuthService', 'ClientsDataFactory', '$timeout', 'localStorageService', 'MessageService', 'SessionService', 'PermPermissionStore', '$state', 'CloudAppThemeFactory', 'CurrentClientModelFactory', 'SendThankYouEmailIntegrityCheck'];
  /* ng-inject*/
  function AccountSelectionController($scope, AuthService, ClientsDataFactory, $timeout, localStorageService, MessageService, SessionService, PermPermissionStore, $state, CloudAppThemeFactory, CurrentClientModelFactory, SendThankYouEmailIntegrityCheck) {

    var vm = this;

    vm.$onInit = function () {
    
      $scope.$on('zp.account.change', function (ev, params) {
        vm.userData = SessionService.getUserData();
      });

      vm.userData = SessionService.getUserData();
      vm.clientId = vm.userData.clientId;
      vm.inputVisible = false;
      vm.toggleInputVisibility = toggleInputVisibility;
      vm.querySearch = querySearch;
      vm.selectedItemChange = selectedItemChange;
      vm.dbs = [];
      vm.autoCompleteItems = [];
      vm.searchQuery = '';

      const permission = PermPermissionStore.getPermissionDefinition('ZUANT_ADMIN');
      permission.validatePermission().then(function () {
        loadClientsList();
      }).catch(function () {
        MessageService.writeLog({
          level: 'error',
          msg: 'User does not have permission to switch accounts',
          tags: ['switch_account', 'account_selection_controller']
        });
      });
    };

    vm.accountSettings = function () {
      $state.go('app.tabbed_app_framework.client_detail.account_settings', {
        _id: vm.clientId
      });
    };

    function querySearch() {
      if (vm.dbs.length > 0 ){
        vm.autoCompleteItems = vm.dbs.filter(createFilterFor(vm.searchQuery));
      } else {
        vm.autoCompleteItems = [{ loading: true }];
      }

    }

    function endGdprEditSessionIfNecessary() {
      if (CurrentClientModelFactory.factoryData.userPermittedToMakeGDPREdits.permitted) {
        CurrentClientModelFactory.endElevatedEditSession();
      }
    }

    function selectedItemChange(item) {
      if (item) {
        $scope.$emit('zp.message', {
          level: 'info',
          message: 'Account selection changed to: ' + item.databasename
        });

        MessageService.writeLog({
          level: 'info',
          msg: 'User requesting to change account to ' + item.databasename,
          tags: ['switch_account', 'account_selection_controller']
        });

        endGdprEditSessionIfNecessary();

        AuthService.switchAccount(item)
          .then(function (sessData) {
            vm.clientId = sessData.clientId;
            MessageService.writeLog({
              level: 'info',
              msg: 'user has switched account. now managing: ' + sessData.databasename,
              tags: ['switch_account']
            });

            return CloudAppThemeFactory.refreshThemeIfNecessary()
              .then(function (res) {
                stepTwo(res.pageReloadRequired);
              });
          })
          .catch(function (err) {
            MessageService.showMessage(err.data.data.message);
            MessageService.writeLog({
              level: 'error',
              msg: err.data.data.message,
              tags: ['switch_account']
            });
          });
      } else {
        MessageService.writeLog({
          level: 'error',
          msg: 'selectedItemChange returned no account item to change to...',
          tags: ['switch_account', 'account_selection_controller']
        });
      }
    }

    function stepTwo(pageReloadRequired) {

      SendThankYouEmailIntegrityCheck.runCheckOnAccount()
        .then(function () {
          MessageService.showMessage('Now managing ' + vm.userData.databasename);
          if (pageReloadRequired) {
            localStorageService.set('reloadPage', {
              required: true
            });
          }
          if ($state.current.name === 'app.single_view_framework.dashboard') $state.reload();
          $state.go('app.single_view_framework.dashboard');
        })
        .catch(function () {

        });

    }
    /**
     * Build `components` list of key/value pairs
     */
    function loadClientsList() {
      // TODO: tweak this to accomodate an API call returning all account user has access to so clients with multiple accounts can use it too.

      ClientsDataFactory.getClientListForAccountSelectControl()
        .then(function (res) {
          if (res) {
            vm.clientDocs = res.data.data;
            vm.dbs = vm.clientDocs.reduce(function (acc, db) {
              if (db.databasename && !db.clientArchived) {
                db.value = db.databasename.toLowerCase();
                acc.push(db);
              }
              return acc;
            }, []);

            if (vm.searchQuery && vm.searchQuery.length > 0){
              vm.autoCompleteItems = vm.dbs.filter(createFilterFor(vm.searchQuery));
              vm.searchQuery = new String(vm.searchQuery);
            }

          }
        })
        .catch(function (err) {
          MessageService.showMessage(err.data.data.message);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });

        });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      const lowercaseQuery = query.toLowerCase();

      return function filterFn(item) {
        return (item.value.toLowerCase().search(lowercaseQuery) != -1 || item.companyname.toLowerCase().search(lowercaseQuery) != -1);
      };
    }

    /**
     *  Auto focus the client select input when user clicks button
     */
    function toggleInputVisibility(state) {
      vm.inputVisible = state;
      if (state) {
        /* timeout to give input time to render */
        $timeout(function () {
          document.querySelector('#clientAutocomplete').focus();
        }, 0);
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('ThemingFactory', factory);

  factory.$inject = ['$q', 'ListApiFactory', 'MessageService', 'CloudAppThemeFactory', 'ThemingMetadataFactory', 'AWS_STORAGE_REGION', 'AWS_STORAGE_BUCKET_NAME'];
  /* ng-inject */
  function factory($q, ListApiFactory, MessageService, CloudAppThemeFactory, ThemingMetadataFactory, awsStorageRegion, awsStorageBucketName) {

    const factoryData = {
      items: [],
      cacheValid: false,
      showAddThemeHelperArrow: false
    };

    return {
      factoryData: factoryData,
      getThemesForAccount: getThemesForAccount,
      deleteTheme: deleteTheme,
      hydrateFactoryObjWithDoc: hydrateFactoryObjWithDoc,
      invalidateCache: invalidateCache
    };

    function getThemesForAccount() {
      return $q(function q(resolve, reject) {
        if (factoryData.cacheValid) {
          resolve(factoryData.items);
        } else {
          return ListApiFactory.getArtefactsByQuery({
            artefactType: 'Theme',
            _deletedatelocalutc: { $exists: false }
          })
            .then(function (res) {
              const itms = res.data.data;
              const promises = [];

              _.each(itms, function (itm){
                promises.push(hydrateFactoryObjWithDoc(itm, itm));
              });

              return $q.all(promises)
                .then(function(){
                  factoryData.items = itms;
                  factoryData.cacheValid = true;
                  resolve(factoryData.items);
                });
            })
            .catch(function (err) {
              reject(err);
            });
        }
      });
    }

    function deleteTheme(ev, themeDoc) {
      return $q(function q(resolve, reject) {
        return MessageService.confirm(ev)
          .delete('Delete selected theme')
          .then(function () {
            const themeDocUpdate = {
              _id: themeDoc._id,
              archived: 1
            };
            return ListApiFactory.saveTheme(themeDocUpdate)
              .then(function () {
                factoryData.items = _.filter(factoryData.items, function (theme) {
                  return theme._id !== themeDoc._id;
                });
                MessageService.showMessage('Theme deleted');
                invalidateCache();
                if (themeDoc.isPrimaryTheme) {
                  resolve(CloudAppThemeFactory.refreshThemeIfNecessary());
                }
                resolve({
                  pageReloadRequired: false
                });
              });
          })
          .catch(function (err) {
            MessageService.writeLog({
              level: 'error',
              msg: err
            });
            reject(err);
          });
      });

    }
    
    function hydrateFactoryObjWithDoc(factoryObj, themeDoc){
      _.extend(factoryObj, {
        _id: themeDoc._id,
        name: themeDoc.name,
        showLogo: themeDoc.showLogo,
        cloudPrimaryColor: themeDoc.cloudPrimaryColor,
        cloudAccentColor: themeDoc.cloudAccentColor,
        blocks: {
          formsColor: '#' + themeDoc.formsColor,
          contactsColor: '#' + themeDoc.contactsColor,
          imagesColor: '#' + themeDoc.imagesColor,
          artefactsColor: '#' + themeDoc.artefactsColor,
          showroomColor: '#' + themeDoc.showroomColor,
          mainMenuBlocksAlpha: themeDoc.mainMenuBlocksAlpha,
          mainMenuBlocksHolderAlpha: themeDoc.mainMenuBlocksHolderAlpha,
          blurEffect: themeDoc.blurEffect
        },
        images: ThemingMetadataFactory.imagesMetadata(),
        isPrimaryTheme: themeDoc.isPrimaryTheme || false // default to false if not set
      });

      return teeUpImageRequests(factoryObj, themeDoc);
    }

    function teeUpImageRequests(factoryObj, themeDoc) {
      factoryObj.images.cloudDashboardBackgroundImage._id = themeDoc.cloudDashboardBackgroundImage || undefined;
      factoryObj.images.mainMenuImageiPadLandscape._id = themeDoc.mainMenuImageiPadLandscape || undefined;
      factoryObj.images.mainMenuImageiPadPortrait._id = themeDoc.mainMenuImageiPadPortrait || undefined;
      factoryObj.images.mainMenuImageiPhone._id = themeDoc.mainMenuImageiPhone || undefined;
      factoryObj.images.mainMenuImageiPhone67._id = themeDoc.mainMenuImageiPhone67 || undefined;

      const arrayOfImagesInTheme = ['cloudDashboardBackgroundImage', 'mainMenuImageiPadLandscape', 'mainMenuImageiPadPortrait', 'mainMenuImageiPhone', 'mainMenuImageiPhone67'];

      const imgPromises = [];
      for (const imageName of arrayOfImagesInTheme) {
        if (!themeDoc[imageName]) continue;

        factoryObj.images[imageName].loading = true;
        const imgPromise = new Promise(function (resolve){
          
          return ListApiFactory.getArtefactById(themeDoc[imageName])
            .then(function (res) {
              if (res.data.data.imagebase64) {
                factoryObj.images[imageName].data = 'data:image/png;base64,' + res.data.data.imagebase64;
              }
              factoryObj.images[imageName]._s3key = res.data.data._s3key;
              factoryObj.images[imageName].weburi = res.data.data.weburi;
              factoryObj.images[imageName].metadata.title = res.data.data.title;
              factoryObj.images[imageName].metadata._lastmodifieddatelocalutc = res.data.data._lastmodifieddatelocalutc;
              factoryObj.images[imageName].loading = false;

              const img = new Image();
        
              img.onload = function () {
                factoryObj.images[imageName].metadata.width = img.width;
                factoryObj.images[imageName].metadata.height = img.height;
                resolve();
              };

              img.onerror = function () {
                factoryObj.images[imageName].loading = false;
                factoryObj.images[imageName].image404 = true;
                resolve();
              };
    
              if (factoryObj.images[imageName]._s3key){
                img.src = `https://s3.${awsStorageRegion}.amazonaws.com/${awsStorageBucketName}/${factoryObj.images[imageName]._s3key}`;
              } else if (factoryObj.images[imageName].weburi) {
                img.src = factoryObj.images[imageName].weburi;
              } else {
                img.src = factoryObj.images[imageName].data;
              }
  
            })
            .catch(function (err) {
              factoryObj.images[imageName].loading = false;
              if (err.status === 404) factoryObj.images[imageName].image404 = true;
            });
        });

        imgPromises.push(imgPromise);
      }

      return imgPromises;
    }

    function invalidateCache() {
      CloudAppThemeFactory.factoryData.currentCloudAppThemeId = '';
      factoryData.cacheValid = false;
    }


  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('ThemingMetadataFactory', factory);

  factory.$inject = ['uuidService'];
  /* ng-inject */
  function factory(uuidService) {

    const factoryData = buildFactory();

    return {
      factoryData: factoryData,
      newThemeDoc: newThemeDoc,
      imagesMetadata: imagesMetadata
    };

    function buildFactory() {
      return {
        themeNameEditableHeaderMetadata: {
          title: {
            name: 'title',
            label: 'Theme name',
            type: 'Text',
            placeholder: 'Name your theme',
            editable: true,
            required: false
          }
        },
        fabAddDialogConfig: {
          description: 'New theme',
          controller: 'AddThemeDialogController as vm',
          templateUrl: 'app/clients/theming/zp-add-theme-dialog/dialog.tmpl.html',
          locals: {},
          ariaLabel: 'Create new theme'
        },
        addImageDialogConfig: {
          description: 'New image',
          controller: 'ImageArtefactDialogController as vm',
          templateUrl: 'app/artefacts/images/image-artefact-dialog/image-detail.dialog.tmpl.html',
          locals: {
            imageDoc: {
              // _id: null, << server creates that
              title: ''
            },
            formType: 'new' // new or edit. Will always be new as user has clicked upload button
          },
          ariaLabel: 'Create new image item'
        },
        imageSelectionDialogConfig: {
          controller: 'ImageSelectionDialogCtrl',
          controllerAs: 'vm',
          templateUrl: 'app/clients/theming/images/image-selection-dialog/image-selection-dialog.tmpl.html',
          allowMultiple: true,
          locals: {}
        },
        customSkinsLearnMoreDialog: {
          controller: 'CustomSkinsInformationDialogCtrl',
          controllerAs: 'vm',
          templateUrl: 'app/clients/theming/info/custom-skins-information-dialog.tmpl.html',
          locals: {}
        }
      };
    }

    function newThemeDoc() {
      return {
        _id: uuidService.getSingleNewBase64Key(),
        name: '',
        artefactType: 'Theme',
        showLogo: true,
        cloudPrimaryColor: 'lagoon',
        cloudAccentColor: 'pollen',
        blocks: {
          mainMenuBlocksAlpha: .4,
          mainMenuBlocksHolderAlpha: .3,
          formsColor: '#5b88b5',
          contactsColor: '#78CDD1',
          imagesColor: '#FEC353',
          artefactsColor: '#F99D33',
          showroomColor: '#F26529',
          blurEffect: 'none'
        },
        images: imagesMetadata(),
        isPrimaryTheme: false
      };
    }

    function imagesMetadata() {
      return {
        cloudDashboardBackgroundImage: {
          _id: undefined,
          themeProp: 'cloudDashboardBackgroundImage',
          skinName: 'Cloud Dashboard',
          data: '',
          metadata: {}
        },
        mainMenuImageiPadLandscape: {
          _id: undefined,
          themeProp: 'mainMenuImageiPadLandscape',
          skinName: 'iPad Landscape',
          data: '',
          metadata: {}
        },
        mainMenuImageiPadPortrait: {
          _id: undefined,
          themeProp: 'mainMenuImageiPadPortrait',
          skinName: 'iPad Portrait',
          data: '',
          metadata: {}
        },
        mainMenuImageiPhone: {
          _id: undefined,
          themeProp: 'mainMenuImageiPhone',
          skinName: 'iPhone Portrait 5.5 inch',
          data: '',
          metadata: {}
        },
        mainMenuImageiPhone67: {
          _id: undefined,
          themeProp: 'mainMenuImageiPhone67',
          skinName: 'iPhone Portrait 6.7 inch',
          data: '',
          metadata: {}
        }
      };
    }
  }
})();

(function () {
  'use strict';

  /**
   * @description pertains to anything to do with a primary theme artefact ranging from getting the current primary theme to unsetting primary theme prop for all but one theme docs
   */

  angular
    .module('clients')
    .factory('PrimaryThemeFactory', factory);

  factory.$inject = ['$q', 'MessageService', 'ThemingFactory', 'ImagesApiFactory', 'localStorageService', 'ListApiFactory', '$timeout', '$window'];
  /* ng-inject */
  function factory($q, MessageService, ThemingFactory, ImagesApiFactory, localStorageService, ListApiFactory, $timeout, $window) {

    const factoryData = {
      primaryTheme: {},
      cacheValid: false
    };

    return {
      factoryData: factoryData,
      setPrimaryTheme: setPrimaryTheme,
      getPrimaryTheme: getPrimaryTheme,
      invalidateCache: invalidateCache,
      promptUserIfNecessary: promptUserIfNecessary
    };

    /**
     * @description sets the single theme doc to be used as the primary theme
     */

    function setPrimaryTheme(themeDoc) {
      return $q(function q(resolve, reject) {
        return ListApiFactory.setPrimaryTheme(themeDoc._id)
          .then(function (res) {
            factoryData.primaryTheme = themeDoc;
            MessageService.writeLog({
              level: 'info',
              msg: res.data.data
            });
            ImagesApiFactory.setDashboardImageToLocalStorage(themeDoc);
            setCloudSkinLocalStorage();
            resolve(res.data.data);
          })
          .catch(function (err) {
            MessageService.showMessage(err.data);
            MessageService.writeLog({
              level: 'error',
              msg: err
            });
            reject(err);
          });
      });
    }

    /**
     * @description gets the primary theme for the account by checking local caches and querying the db if none found locally
     */

    function getPrimaryTheme() {
      return $q(function q(resolve, reject) {
        if (factoryData.cacheValid) {
          MessageService.writeLog({
            level: 'info',
            msg: 'resolving cached primary theme object',
            tags: ['PrimaryThemeFactory']
          });
          resolve(factoryData.primaryTheme);
        }

        const query = {
          isPrimaryTheme: true,
          _deletedatelocalutc: { $exists: false }
        };

        MessageService.writeLog({
          level: 'info',
          msg: 'off to query isPrimaryTheme: true',
          tags: ['PrimaryThemeFactory']
        });

        return ListApiFactory.getArtefactsByQuery(query)
          .then(function (res) {
            if (res.data.data.length) {
              const primaryThemes = _.filter(res.data.data, function (doc) {
                // double check isPrimaryTheme is set for the doc
                return doc.isPrimaryTheme;
              });

              return $q.all(ThemingFactory.hydrateFactoryObjWithDoc(factoryData.primaryTheme, primaryThemes[0]))
                .then(function () {

                  MessageService.writeLog({
                    level: 'info',
                    msg: primaryThemes.length + ' primary theme docs found. returning the first one'
                  });
                  factoryData.cacheValid = true;
                  return resolve(factoryData.primaryTheme);
                });

            } else {
              MessageService.writeLog({
                level: 'info',
                msg: 'no primary theme found. clearing factory cache'
              });
              _.extend(factoryData.primaryTheme, {});
              return resolve(factoryData.primaryTheme);
            }
          })
          .catch(function (err) {
            MessageService.writeLog({
              level: 'error',
              msg: 'server error: ' + err
            });
            return reject(err);
          });
      });
    }

    function invalidateCache() {
      factoryData.cacheValid = false;
    }

    function promptUserIfNecessary(ev) {
      return $q(function q(resolve, reject) {

        const isPrimaryCheck = _.filter(ThemingFactory.factoryData.items, function (theme) {
          return theme.isPrimaryTheme;
        });

        if (isPrimaryCheck.length) {
          const msgObj = {
            title: 'Heads Up! ' + isPrimaryCheck[0].name + ' is currently the primary skin for this account.',
            content: 'Please confirm you wish to switch the default skin theme to this theme.',
            okBtn: 'Yes make this the primary theme',
            cancelBtn: 'Cancel'
          };
          return MessageService.confirm(ev)
            .confirmAction(msgObj)
            .then(function () {
              resolve({
                success: true,
                msg: 'user has confirmed making this the default theme'
              });
            })
            .catch(function () {
              MessageService.showMessage('No changes made');
              reject({
                success: false,
                msg: 'user changed their mind'
              });
            });
        } else {
          resolve({
            success: true,
            msg: 'green light to continue'
          });
        }
      });

    }

    // private helpers

    function setCloudSkinLocalStorage() {
      MessageService.showMessage('This skin is now active. Reloading...');
      // console.log('setting skin cookie having changed primary skin');
      // console.log(factoryData.primaryTheme);
      localStorageService.set('cloudSkin', angular.toJson({
        primary: factoryData.primaryTheme.cloudPrimaryColor,
        accent: factoryData.primaryTheme.cloudAccentColor
      }));
      $timeout(function () {
        // we reload the page here so angular can bootstrap the app with the newly changed cloud color palette
        $window.location.reload();
      }, 1000);
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('CurrentThemeFactory', factory);

  factory.$inject = ['ListApiFactory', 'ChangeDelta', '$q', 'ThemingMetadataFactory', 'CloudAppThemeFactory', 'MessageService', 'ThemingFactory'];
  /* ng-inject */
  function factory(ListApiFactory, ChangeDelta, $q, ThemingMetadataFactory, CloudAppThemeFactory, MessageService, ThemingFactory) {

    const factoryData = {
      currentThemeDoc: {},
      saveBtnDisabled: false
    };

    return {
      factoryData: factoryData,
      hydrateFactoryWithTheme: hydrateFactoryWithTheme,
      saveTheme: saveTheme,
      removeImageReferenceFromCurrentTheme: removeImageReferenceFromCurrentTheme,
      clearImageButtonClicked: clearImageButtonClickedObj
    };

    function hydrateFactoryWithTheme(themeId) {
      return $q(function q(resolve, reject) {
        return ListApiFactory.getArtefactById(themeId)
          .then(function (res) {
            const themeDoc = res.data.data;
            return $q.all(ThemingFactory.hydrateFactoryObjWithDoc(factoryData.currentThemeDoc, themeDoc))
              .then(function () {
                MessageService.writeLog({
                  level: 'info',
                  msg: 'CurrentThemeFactory is hydrated with ' + themeId + ' theme'
                });
  
                return resolve(factoryData.currentThemeDoc);
              });

          })
          .catch(function (err) {
            reject(err);
          });
      });
    }

    function saveTheme(themeDoc, changeDelta) {

      const themeToSave = {
        _id: themeDoc._id,
        name: themeDoc.name,
        artefactType: 'Theme',
        showLogo: themeDoc.showLogo,
        cloudPrimaryColor: themeDoc.cloudPrimaryColor,
        cloudAccentColor: themeDoc.cloudAccentColor,
        mainMenuBlocksAlpha: themeDoc.blocks.mainMenuBlocksAlpha,
        mainMenuBlocksHolderAlpha: themeDoc.blocks.mainMenuBlocksHolderAlpha,
        formsColor: formatColorToHex(themeDoc.blocks.formsColor),
        contactsColor: formatColorToHex(themeDoc.blocks.contactsColor),
        imagesColor: formatColorToHex(themeDoc.blocks.imagesColor),
        artefactsColor: formatColorToHex(themeDoc.blocks.artefactsColor),
        showroomColor: formatColorToHex(themeDoc.blocks.showroomColor),
        cloudDashboardBackgroundImage: themeDoc.images.cloudDashboardBackgroundImage._id || '',
        mainMenuImageiPadLandscape: themeDoc.images.mainMenuImageiPadLandscape._id || '',
        mainMenuImageiPadPortrait: themeDoc.images.mainMenuImageiPadPortrait._id || '',
        mainMenuImageiPhone: themeDoc.images.mainMenuImageiPhone._id || '',
        mainMenuImageiPhone67: themeDoc.images.mainMenuImageiPhone67._id || '',
        blurEffect: themeDoc.blocks.blurEffect,
        isPrimaryTheme: themeDoc.isPrimaryTheme || false // default to false if not set
      };

      // console.log(themeToSave);
      return ListApiFactory.saveTheme(themeToSave)
        .then(function () {

          const existingThemeIndex = _.findIndex(ThemingFactory.factoryData.items, function (theme){
            return theme._id === themeToSave._id;
          });

          const themeExistsInCache = existingThemeIndex > -1;
          if (!themeExistsInCache){
            ThemingFactory.invalidateCache();
            return;
          }
          
          ThemingFactory.factoryData.items[existingThemeIndex] = angular.copy(factoryData.currentThemeDoc);
          updateLocalStorageAndCookieIfNecessary(themeToSave, changeDelta);

        })
        .catch(function (err) {
          throw (err);
        });
    }

    function formatColorToHex(hexValue) {
      if (!hexValue) return 'ffffff';
      const col = tinycolor(hexValue);
      const hexVal = col.toHex();
      return hexVal;
    }

    function updateLocalStorageAndCookieIfNecessary(themeToSave, changeDelta) {
      if (themeToSave.hasOwnProperty('isPrimaryTheme') && themeToSave.isPrimaryTheme) {
        // this doc is the primary theme and so we check to see if cloud background image or cloud skin has changed
        const artefactsDelta = changeDelta.artefacts[themeToSave._id];
        if (artefactsDelta.cloudDashboardBackgroundImage) {
          updateCloudBackgoundImage(themeToSave, artefactsDelta);
        }
        if (artefactsDelta.cloudPrimaryColor || artefactsDelta.cloudAccentColor) {
          updateCloudSkinCookie(themeToSave, artefactsDelta);
        }
        return;

      } else {
        return;
      }
    }

    function updateCloudBackgoundImage(theme, changeDelta) {
      if (changeDelta.cloudDashboardBackgroundImage.newvalue) {
        // refresh theme storage with new cloud dashboard image
        CloudAppThemeFactory.setCloudDashboardImage({
          id: theme.cloudDashboardBackgroundImage._id,
          title: theme.cloudDashboardBackgroundImage.title,
          weburi: theme.cloudDashboardBackgroundImage.weburi,
          _s3key: theme.cloudDashboardBackgroundImage._s3key
        });
      } else {
        // remove image from local storage as change delta contains cloud image but no value is set. aka image has been cleared
        CloudAppThemeFactory.setCloudDashboardImage({
          id: '',
          title: '',
          weburi: '',
          _s3key: ''
        });
      }
    }

    function updateCloudSkinCookie(themeToSave, changeDelta) {
      // set new skin cookie and reload page to take effect.
      let cloudPrimaryColor, cloudAccentColor;
      if (changeDelta.cloudPrimaryColor && changeDelta.cloudAccentColor) {
        cloudPrimaryColor = changeDelta.cloudPrimaryColor.newvalue;
        cloudAccentColor = changeDelta.cloudAccentColor.newvalue;
      } else if (changeDelta.cloudPrimaryColor) {
        cloudPrimaryColor = changeDelta.cloudPrimaryColor.newvalue;
        cloudAccentColor = themeToSave.cloudAccentColor;
      } else if (changeDelta.cloudAccentColor) {
        cloudPrimaryColor = themeToSave.cloudPrimaryColor;
        cloudAccentColor = changeDelta.cloudAccentColor.newvalue;
      }
      CloudAppThemeFactory.setCloudSkinLocalStorage({
        primary: cloudPrimaryColor,
        accent: cloudAccentColor
      });
    }

    function removeImageReferenceFromCurrentTheme(imageId) {
      _.each(factoryData.currentThemeDoc.images, function (imageDoc, key) {
        if (imageDoc._id === imageId) {
          ChangeDelta.recordValueChange({
            oldval: imageId,
            newval: '',
            objectid: factoryData.currentThemeDoc._id,
            collection: 'artefacts',
            databasefieldname: key
          });
          clearImageButtonClickedObj(key);
        }
      });
    }

    function clearImageButtonClickedObj(imagePropertyName) {
      const flag404 = factoryData.currentThemeDoc.images[imagePropertyName].image404;
      const imagesMetadataObj = ThemingMetadataFactory.imagesMetadata();
      factoryData.currentThemeDoc.images[imagePropertyName] = imagesMetadataObj[imagePropertyName];
      if (flag404) {
        factoryData.currentThemeDoc.images[imagePropertyName].image404 = false;
      }
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpTeamsPage', {
      templateUrl: 'app/clients/teams/view.tmpl.html',
      controller: 'TeamsViewCtrl',
      bindings: {
      },
      controllerAs: 'vm'
    })
    .controller('TeamsViewCtrl', ctrl);

  ctrl.$inject = ['TeamsAPI', 'MessageService', 'uuidService', 'getTeams', 'recalculateTreeStructureForTeams', 'updateAnyParentChanges',
    'updateTeamsWithRemovedTeamAsSubteam', 'saveSubteams', 'updateSubteamsWithIds', 'addSubteamsToTeams', 'updateTeamsInfo', 'transformIdsToSubteams',
    'transformTeamForSave', 'removeSubTeamsIfNecessary', 'removeSubTeamsOfSubTeams', 'transformTeamForDelete'];
  /* ng-inject */
  function ctrl(TeamsAPI, MessageService, uuidService, getTeams, recalculateTreeStructureForTeams, updateAnyParentChanges,
    updateTeamsWithRemovedTeamAsSubteam, saveSubteams, updateSubteamsWithIds, addSubteamsToTeams, updateTeamsInfo, transformIdsToSubteams,
    transformTeamForSave, removeSubTeamsIfNecessary, removeSubTeamsOfSubTeams, transformTeamForDelete) {

    var vm = this;
    vm.teams = [];
    vm.treeStructuredTeams = [];
    vm.selectedTeam = {
      name: '',
      subteams: [],
      members: []
    };
    vm.searchValue = '';

    vm.$onInit = () => {
      getTeams(vm.teams, vm.treeStructuredTeams, vm.searchValue);
    };

    vm.addTeam = (team) => {
      vm.teams.unshift(team);
      recalculateTreeStructureForTeams(vm.teams, vm.treeStructuredTeams, vm.searchValue);
    };

    vm.addSubteam = (team, addToTeams) => {
      vm.selectedTeam.subteams.push(team);
      if (addToTeams) {
        vm.teams.push(team);
      }
      vm.updateDirty();
    };

    vm.removeSubteam = (idx) => {
      vm.selectedTeam.subteams.splice(idx, 1);
      vm.updateDirty();
    };

    vm.addUsers = (users) => {
      for (const user of users) {
        let found = false;

        for (const member of vm.selectedTeam.members) {
          if (user !== member) continue;
          
          found = true;
          break;
        }

        if (!found) {
          vm.selectedTeam.members.push({
            vtag: uuidService.getSingleNewBase64Key(),
            userid: user.id,
            name: user.name,
            private: user.private,
            manager: user.manager
          });
        }
      }
      vm.updateDirty();
    };

    vm.removeSelectedUsers = () => {
      let newMembers = [];
      for (const member of vm.selectedTeam.members) {
        if (!member.selected) {
          newMembers.push(member);
        }
      }
      vm.selectedTeam.members.splice(0);
      vm.selectedTeam.members.push.apply(vm.selectedTeam.members, newMembers);
      vm.updateDirty();
    };

    vm.editTeam = (team) => {
      TeamsAPI.updateOrCreateTeam(transformTeamForSave(team))
        .then(() => updateAnyParentChanges(vm.teams, team.parentId, team._id))
        .then(() => getTeams(vm.teams, vm.treeStructuredTeams, vm.searchValue))
        .then(() => {
          vm.selectTeam(team);
          MessageService.showMessage(vm.selectedTeam.name + ' was changed successfully');
        })
        .catch((err) => {
          MessageService.writeLog({
            level: 'error',
            msg: 'Error from editTeam(): ' + JSON.stringify(err),
            tags: ['teams']
          });
          MessageService.showMessage('Server could not edit team, please try again later');
        });
    };

    vm.removeTeam = (removeAllTeams) => {
      TeamsAPI.updateFormVtags([vm.selectedTeam._id])
        .then(() => removeSubTeamsIfNecessary(removeAllTeams, vm.selectedTeam, vm.teams))
        .then(() => TeamsAPI.deleteTeam(transformTeamForDelete(vm.selectedTeam)))
        .then(() => updateTeamsWithRemovedTeamAsSubteam(vm.teams, vm.selectedTeam._id))
        .then(() => {
          MessageService.showMessage(vm.selectedTeam.name + ' was removed successfully');
          getTeams(vm.teams, vm.treeStructuredTeams, vm.searchValue);
          vm.selectedTeam.name = '';
          vm.selectedTeam._id = '';
        })
        .catch((err) => {
          MessageService.writeLog({
            level: 'error',
            msg: 'Error from deleteTeam(): ' + JSON.stringify(err),
            tags: ['teams']
          });
          MessageService.showMessage('Server could not delete team, please try again later');
        });
    };

    vm.removeSelectedTeams = removeAllTeams => {
      const promiseArray = [];
      const newSubteams = [];

      if (removeAllTeams) {
        const vtagsToRemove = [];
        for (const subteam of vm.selectedTeam.subteams) {
          if (!subteam.selected) continue;
          
          vtagsToRemove.push(subteam._id);
        }

        if (vtagsToRemove.length > 0) {
          promiseArray.push.apply(promiseArray, TeamsAPI.updateFormVtags(vtagsToRemove));
        }
      }

      for (const subteam of vm.selectedTeam.subteams) {
        if (subteam.selected) {
          if (removeAllTeams) {
            promiseArray.push.apply(promiseArray, TeamsAPI.deleteTeam(transformTeamForDelete(subteam)));
            promiseArray.push.apply(promiseArray, removeSubTeamsOfSubTeams(subteam._id, vm.teams));
          }
        } else {
          newSubteams.push(subteam);
        }
      }
      vm.selectedTeam.subteams.splice(0);
      vm.selectedTeam.subteams.push.apply(vm.selectedTeam.subteams, newSubteams);
      
      promiseArray.push(TeamsAPI.updateOrCreateTeam(transformTeamForSave(vm.selectedTeam)));

      Promise.all(promiseArray)
        .then(() => getTeams(vm.teams, vm.treeStructuredTeams, vm.searchValue))
        .then(() => {
          MessageService.showMessage('Teams were removed successfully');
          vm.selectTeam(vm.selectedTeam);
        })
        .catch(err => {
          MessageService.writeLog({
            level: 'error',
            msg: 'Error from removeSelectedTeams(): ' + JSON.stringify(err),
            tags: ['teams']
          });
          MessageService.showMessage('Server could not delete selected teams, please try again later');
        });
    };

    vm.save = function () {
      saveSubteams(vm.selectedTeam)
        .then((res) => {
          updateSubteamsWithIds(res, vm.selectedTeam);
          addSubteamsToTeams(res, vm.teams);
          return TeamsAPI.updateOrCreateTeam(transformTeamForSave(vm.selectedTeam));
        })
        .then(() => {
          vm.selectedTeam.dirty = false;
          updateTeamsInfo(vm.teams, vm.selectedTeam);
          recalculateTreeStructureForTeams(vm.teams, vm.treeStructuredTeams, vm.searchValue);
          // MessageService.showMessage(vm.selectedTeam.name + ' was saved successfully');
        })
        .catch((err) => {
          MessageService.writeLog({
            level: 'error',
            msg: 'Error from updateOrCreateTeam(): ' + JSON.stringify(err),
            tags: ['teams']
          });
          MessageService.showMessage('Server could not save team, please try again later');
        });
    };

    vm.selectTeam = (team) => {
      for (const t of vm.teams) {
        t.selected = false;
        if (t._id !== team._id){
          t.selected = false;
          continue;
        }

        t.selected = true;
        vm.selectedTeam.name = t.name;
        vm.selectedTeam._id = t._id;
        vm.selectedTeam.subteams.splice(0);
        vm.selectedTeam.subteams.push.apply(vm.selectedTeam.subteams, transformIdsToSubteams(vm.teams, t.subteams));
        vm.selectedTeam.members.splice(0);
        vm.selectedTeam.members.push.apply(vm.selectedTeam.members, t.members);
        vm.selectedTeam.dirty = false;
      }

      recalculateTreeStructureForTeams(vm.teams, vm.treeStructuredTeams, vm.searchValue);
    };

    vm.toggleChevron = (team, $event) => {
      for (const t of vm.teams) {
        if (t._id !== team._id) continue;

        t.open = !t.open;
        break;
      }
      
      recalculateTreeStructureForTeams(vm.teams, vm.treeStructuredTeams, vm.searchValue);
      $event.stopPropagation();
    };

    vm.setAllMembersFlag = (flag, value) => {
      for (const member of vm.selectedTeam.members) {
        member[flag] = value;
      }
      vm.updateDirty();
    };

    vm.updateDirty = () => {
      // vm.selectedTeam.dirty = true;
      vm.save();
    };

    vm.filterTeams = () => {
      recalculateTreeStructureForTeams(vm.teams, vm.treeStructuredTeams, vm.searchValue);
    };

    vm.selectAllSubteams = (selectAll) => {
      for (let team of vm.selectedTeam.subteams) {
        team.selected = selectAll;
      }
    };

    return vm;
  }

})();

/**
 * Created by davidfm on 06/02/2018.
 */
(function () {
  'use strict';

  angular
    .module('clients')
    .factory('TeamsAPI', TeamsAPI);

  TeamsAPI.$inject = ['APIFactory'];
  /* ng-inject */
  function TeamsAPI(apiFactory) {

    const teamsApi = apiFactory.route('teams');

    const updateOrCreateTeam = (team) => {
      const id = team._id;
      if (id) return teamsApi.update(team);
      return teamsApi.create(team);
    };

    const deleteTeam = (team) => {
      team._deletedatelocalutc = new Date().toISOString().replace('T', ' ').replace('Z', '').split('.')[0];
      return teamsApi.update(team);
    };

    const updateFormVtags = (ids) => {
      return teamsApi.post('vtagRemoval', { vtags: ids });
    };

    return {
      getTeams: teamsApi.get,
      updateOrCreateTeam: updateOrCreateTeam,
      deleteTeam: deleteTeam,
      updateFormVtags: updateFormVtags
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('PermissionsMetadataFactory', factory);

  factory.$inject = ['BoltOnsMetadataFactory', '$filter'];
  /* ng-inject */
  function factory(BoltOnsMetadataFactory, $filter) {

    var factoryData = buildFactory();

    return factoryData;

    function buildFactory() {
      return {
        states: {
          initial: {
            id: 'initial',
            icon: 'check_box_outline_blank',
            style: 'fill: #949CA1;'
          },
          allow: {
            id: 'allow',
            icon: 'check_box',
            style: 'fill: #FEC353'
          },
          deny: {
            id: 'deny',
            icon: 'check_box_outline_blank',
            style: 'fill: #949CA1'
          },
          indeterminate: {
            id: 'indeterminate',
            icon: 'indeterminate_check_box',
            style: 'fill: #5B88B5;'
          }
        },
        permissions: [{
          property: 'accountManagement',
          label: 'Account Management',
          icon: 'zmdi zmdi-accounts',
          blurb: 'Permissions to manage account level settings',
          cards: [{
            property: 'general',
            showPermissions: true,
            expandAllIcon: 'expand_more',
            icon: 'zmdi zmdi-accounts-list',
            label: 'General',
            blurb: 'Control over general account settings',
            permissionGroups: [{
              property: 'basic',
              label: 'General',
              items: [{
                label: 'Manage Settings',
                key: 'manageSettings'
              }, {
                label: 'Manage Permissions',
                key: 'managePermissions'
              }, {
                label: 'Manage Consent Tokens',
                key: 'manageConsentTokens'
              }, {
                label: 'Manage Privacy Statements',
                key: 'managePrivacyStatements'
              }, {
                label: 'Manage Teams',
                key: 'manageTeams'
              }, {
                label: 'Manage Client Email Templates',
                key: 'manageClientEmailTemplates'
              }]
            }]
          }]
        }, {
          property: 'login',
          label: 'Login',
          icon: 'zmdi zmdi-home',
          blurb: 'Control where users can login to',
          cards: [{
            property: 'login',
            label: 'Login',
            showPermissions: false,
            expandAllIcon: 'expand_more',
            icon: 'zmdi zmdi-home',
            blurb: 'Control where users can login to',
            permissionGroups: [{
              property: 'login',
              label: '',
              items: [{
                label: 'iOS/Android App',
                key: 'app'
              }, {
                label: 'Web Portal',
                key: 'portal'
              }]
            }]
          }]
        }, {
          property: 'liteFeatures',
          label: 'Lite features',
          icon: 'zmdi zmdi-airplane',
          blurb: 'Grant your users specific powers for Lite features',
          cards: [{
            property: 'users',
            showPermissions: false,
            expandAllIcon: 'expand_more',
            icon: 'zmdi zmdi-accounts',
            label: 'User management',
            blurb: 'Control who can manage users in your account',
            permissionGroups: [{
              property: 'basic',
              label: 'Basic',
              items: [{
                label: 'View',
                key: 'view'
              }, {
                label: 'Edit',
                key: 'edit'
              }, {
                label: 'Archive',
                key: 'archive'
              }]
            }]
          }, {
            property: 'forms',
            showPermissions: false,
            expandAllIcon: 'expand_more',
            icon: 'zmdi zmdi-assignment-o',
            label: 'Forms',
            blurb: 'Control who can manage forms in your account',
            permissionGroups: [{
              property: 'basic',
              label: 'Basic',
              items: [{
                label: 'View',
                key: 'view'
              }, {
                label: 'Edit',
                key: 'edit'
              }, {
                label: 'Archive',
                key: 'archive'
              }]
            }, {
              property: 'advanced',
              label: 'Advanced',
              items: [{
                label: 'Badge setup',
                key: 'badgeSetup',
                permissionOnly: 'ZUANT_ADMIN',
              }, {
                label: 'View drafts',
                key: 'viewDrafts'
              }]
            }]
          }, {
            property: 'leadManagement',
            showPermissions: false,
            expandAllIcon: 'expand_more',
            icon: 'zmdi zmdi-face',
            blurb: 'Finer grain control over what users can do with leads',
            label: 'Leads',
            permissionGroups: [{
              property: 'basic',
              label: 'Basic',
              items: [{
                label: 'Dashboard',
                key: 'dashboard'
              }, {
                label: 'View Grid',
                key: 'viewGrid'
              }, {
                label: 'Edit Grid',
                key: 'editGrid'
              }, {
                label: 'Download',
                key: 'download'
              }]
            }]
          }, {
            property: 'pickAWinner',
            showPermissions: false,
            expandAllIcon: 'expand_more',
            icon: 'zmdi zmdi-ticket-star',
            blurb: 'Choose who can run the pick a winner feature',
            label: 'Pick a Winner',
            permissionGroups: [{
              property: 'basic',
              label: 'Basic',
              items: [{
                label: 'View',
                key: 'view'
              }]
            }]
          }, {
            property: 'data',
            showPermissions: false,
            expandAllIcon: 'expand_more',
            icon: 'zmdi zmdi-storage',
            blurb: 'Set how much a user can interact with Zuant Data',
            label: 'Data',
            permissionGroups: [{
              property: 'basic',
              label: 'Basic',
              items: [{
                label: 'Load',
                key: 'load'
              }, {
                label: 'Comply',
                key: 'comply'
              }, {
                label: 'Housekeeping',
                key: 'housekeep'
              }]
            }]
          }, {
            property: 'mesh',
            showPermissions: false,
            expandAllIcon: 'expand_more',
            icon: 'zmdi zmdi-remote-control',
            blurb: 'Set how much a user can interact with Zuant QR Posters',
            label: 'QR',
            permissionGroups: [{
              property: 'basic',
              label: 'Basic',
              items: [{
                label: 'View',
                key: 'view'
              }, {
                label: 'Edit',
                key: 'edit'
              }, {
                label: 'Delete',
                key: 'delete'
              }]
            }]
          }]
        }, {
          property: 'boltOns',
          label: 'Bolt-ons',
          icon: 'zmdi zmdi-flash',
          blurb: 'Control user access levels for account bolt-ons.',
          cards: BoltOnsMetadataFactory.arrayOfBoltOns
        }, {
          property: 'trump',
          booleanPermission: true,
          expandAllIcon: 'expand_more',
          label: 'Zuant Staff Only',
          permissionOnly: 'ZUANT_ADMIN',
          icon: 'zmdi zmdi-alert-octagon',
          blurb: 'Only flick this switch if you know what you doin\'!',
          cards: [{
            property: 'trump',
            showPermissions: false,
            icon: 'zmdi zmdi-star-outline',
            imgSrc: $filter('cdnAssets')('/images/jpgs/account/trump/Trump_416x416.jpg'),
            showImg: false,
            label: 'Trump all permissions',
            blurb: 'Users with this superpower bypass all permission checks and can do everything in Zuant',
            permissionGroups: [{
              property: 'trump',
              label: 'Trump permissions',
              items: [{
                label: '',
                key: 'true'
              }]
            }]
          }]
        }]
      };
    }
  }
})();

/**
 * Created by davidbeazer on 29/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('clients')
    .factory('PermissionsManagerFactory', factory);

  factory.$inject = ['$q', 'UsersAPI', 'PermissionsMetadataFactory', 'MessageService', 'ChangeDelta', 'ClientsAPI', 'UserPermissionsHelperFactory', '$log', 'UserFactory'];
  /* ng-inject */
  function factory($q, UsersAPI, PermissionsMetadataFactory, MessageService, ChangeDelta, ClientsAPI, UserPermissionsHelperFactory, $log, UserFactory) {

    var factoryData = {};

    buildFactory();

    function buildFactory() {
      factoryData = _.extend(factoryData, {
        usersObject: {},
        permissions: setInitialPermissionsPoolValues(PermissionsMetadataFactory),
        permissionsClone: {},
        presetData: {}
      });
    }

    var services = {
      toggleUser: toggleUser,
      savePermissions: savePermissions,
      factoryData: factoryData,
      applyPermissionToPool: applyPermissionToPool,
      resetFactory: buildFactory,
      applyPresetToPool: applyPresetToPool
    };

    return services;
    ////////////////////////////

    function toggleUser(user, toggleAllValue) {
      addOrRemoveUserFromFactoryStore(user, toggleAllValue);
      updatePermissionsPool();
      makeCloneOfCurrentPermissions(); // for dirty checker purposes
    }

    function updatePermissionsPool() {

      // called as users are added/removed from the pool
      factoryData.permissions = _.extend(factoryData.permissions, setInitialPermissionsPoolValues(PermissionsMetadataFactory));

      ChangeDelta.clear();

      _.each(factoryData.usersObject, function (userData, userId) {
        _.each(factoryData.permissions, function (permissionGroup, groupKey) {
          _.each(permissionGroup, function (permissionValue, key) {
            var existingPermissionValueForUser,
              currentPermissionPoolValue,
              reducedValue;

            if ((typeof permissionValue == 'object')) {
              _.each(permissionValue, function (arrayOfPermissions, permissionName) {
                _.each(arrayOfPermissions, function (permissionValue, k) {
                  existingPermissionValueForUser = findPermissionValueForUser(factoryData.usersObject[userId].permissions, permissionName, groupKey, key, k);
                  currentPermissionPoolValue = factoryData.permissions[groupKey][key][permissionName][k];
                  reducedValue = reducePermissionValue(currentPermissionPoolValue, existingPermissionValueForUser);
                  // this is setting the pool value
                  factoryData.permissions[groupKey][key][permissionName][k] = reducedValue;
                });
              });
            } else {
              existingPermissionValueForUser = findPermissionValueForUser(factoryData.usersObject[userId].permissions, null, groupKey, key);
              currentPermissionPoolValue = factoryData.permissions[groupKey][key];
              reducedValue = reducePermissionValue(currentPermissionPoolValue, existingPermissionValueForUser);
              // this is setting the pool value
              factoryData.permissions[groupKey][key] = reducedValue;
            }
          });
        });
      });
    }

    function findPermissionValueForUser(userPermissionObj, permissionName, groupKey, key, k) {

      var rc = PermissionsMetadataFactory.states.deny.id,
        permitted;
      if (!k) {
        permitted = _.find(userPermissionObj[groupKey], function (permission) {
          return permission === key;
        });
        if (groupKey == 'trump') permitted = userPermissionObj[groupKey]; // pretty smelly but due to it being a root level prop it's the best i've come up with thus far
      } else {
        try {
          if (!userPermissionObj[groupKey][key]) {
            userPermissionObj[groupKey][key] = {};
          }
          permitted = _.find(userPermissionObj[groupKey][key][permissionName], function (permission) {
            return permission === k;
          });
        } catch (e) {
          permitted = false;
          MessageService.writeLog({
            level: 'error',
            msg: e,
            tags: ['permissions']
          });
        }
      }
      if (permitted) rc = PermissionsMetadataFactory.states.allow.id;
      return rc;

    }

    // called when user clicks a permission in the matrix. updates the pool value for that permission
    function applyPermissionToPool(block, card, permissionGroup, item) {
      if (block.property == card.property && card.property == permissionGroup.property) {
        if (factoryData.permissions[permissionGroup.property][item.key] == PermissionsMetadataFactory.states.deny.id ||
          factoryData.permissions[permissionGroup.property][item.key] == PermissionsMetadataFactory.states.initial.id ||
          factoryData.permissions[permissionGroup.property][item.key] == PermissionsMetadataFactory.states.indeterminate.id) {
          if (permissionGroup.property === 'trump' &&
            !confirm('🚨⚠️ WOAH NOW ⚠️🚨\nYou are about to grant this user the ability to trump all permissions.\nAre you sure you want to do this?\nClick OK to continue')) {
            // user has decided against granting trump permission. return deny value
            factoryData.permissions[permissionGroup.property][item.key] = PermissionsMetadataFactory.states.deny.id;
            return PermissionsMetadataFactory.states.deny.id;
          }
          // console.log('setting pool value to allow');
          factoryData.permissions[permissionGroup.property][item.key] = PermissionsMetadataFactory.states.allow.id;
          return PermissionsMetadataFactory.states.allow.id;
        } else {
          // console.log('setting pool value to deny');
          factoryData.permissions[permissionGroup.property][item.key] = PermissionsMetadataFactory.states.deny.id;
          return PermissionsMetadataFactory.states.deny.id;
        }
      } else {
        if (factoryData.permissions[block.property][card.property][permissionGroup.property][item.key] == PermissionsMetadataFactory.states.deny.id ||
          factoryData.permissions[block.property][card.property][permissionGroup.property][item.key] == PermissionsMetadataFactory.states.initial.id ||
          factoryData.permissions[block.property][card.property][permissionGroup.property][item.key] == PermissionsMetadataFactory.states.indeterminate.id) {

          factoryData.permissions[block.property][card.property][permissionGroup.property][item.key] = PermissionsMetadataFactory.states.allow.id;
          return PermissionsMetadataFactory.states.allow.id;
        } else {
          // console.log('setting pool value to deny');
          factoryData.permissions[block.property][card.property][permissionGroup.property][item.key] = PermissionsMetadataFactory.states.deny.id;
          return PermissionsMetadataFactory.states.deny.id;
        }
      }
    }

    function savePermissions() {
      return $q(function q(resolve, reject) {
        $log.info('saving permissions');
        const userPermissionsUpdateRequests = [];
        const permissionsPool = factoryData.permissions;

        _.each(factoryData.usersObject, function (userData, userId) {
          $log.info('saving permissions for user with id ' + userId);

          const permissionDelta = mergePermissions(permissionsPool, userData.permissions);
          const factoryUser = factoryData.usersObject[userId];

          factoryUser.permissions = _.extend(userData.permissions, permissionDelta);
          factoryUser.roleorcustom = UserPermissionsHelperFactory.derivePresetOrCustomTextFromPermissions(factoryUser);

          const typeofuserDelta = UserPermissionsHelperFactory.deriveTypeOfUserFromPermissionPermissions(factoryUser);
          factoryUser.typeofuser = typeofuserDelta;

          const serverPayload = {
            _id: userId,
            permissions: permissionDelta,
            typeofuser: typeofuserDelta
          };

          MessageService.writeLog({
            level: 'info',
            msg: 'Saving user ID:' + userId + ' permissions: ' + JSON.stringify(serverPayload.permissions)
          });

          
          userPermissionsUpdateRequests.push(UsersAPI.postUserUpdate(angular.copy(serverPayload)));
        });

        $q
          .all(userPermissionsUpdateRequests)
          .then(function (res) {
            $log.info('saved all permissions');

            MessageService.writeLog({
              level: 'info',
              msg: userPermissionsUpdateRequests.length + ' users permissions successfully updated'
            });
            ChangeDelta.clear();
            UserFactory.invalidateCache();
            resolve(res);
          })
          .catch(function (err) {
            $log.error('error saving permissions: ' + JSON.stringify(err));
            MessageService.writeLog({
              level: 'error',
              msg: 'Error saving user permissions: ' + JSON.stringify(err)
            });
            reject(err);
          });
      });
    }

    function mergePermissions(permissionsPool, preexistingUserPermissions) {
      var path = '';
      var mergedPermissionsObjForUser = {};
      mergedPermissionsObjForUser = recursivelyMerge(permissionsPool, preexistingUserPermissions, path, mergedPermissionsObjForUser);
      preexistingUserPermissions = _.extend(preexistingUserPermissions, mergedPermissionsObjForUser);
      trumpScreening(mergedPermissionsObjForUser); // check if user has trump permission and shape it for server
      return mergedPermissionsObjForUser;
    }

    function recursivelyMerge(driverObject, preexistingUserPermissions, path, mergedPermissionsObjForUser) {
      _.each(driverObject, function (value, key) {
        if (typeof value === 'string') {
          setPermissionValue(mergedPermissionsObjForUser, preexistingUserPermissions, path, value, key);
        } else {
          if (path === '') {
            recursivelyMerge(value, preexistingUserPermissions, path + key, mergedPermissionsObjForUser);
          } else {
            recursivelyMerge(value, preexistingUserPermissions, path + '_' + key, mergedPermissionsObjForUser);
          }
        }
      });
      return mergedPermissionsObjForUser;
    }

    /**
     * @description used when saving a user's permissions to set permission values and shape ready for save to server
     *
     */
    function setPermissionValue(mergedPermissionsObjForUser, preexistingUserPermissions, path, value, key) {
      var existingValue,
        permissionPathAddress = path.split('_');
      if (permissionPathAddress.length == 1) {
        if (!mergedPermissionsObjForUser[permissionPathAddress[0]]) {
          mergedPermissionsObjForUser[permissionPathAddress[0]] = [];
        }
        if (value == 'allow') {
          mergedPermissionsObjForUser[permissionPathAddress[0]].push(key);
        }
        if (value == 'indeterminate') {
          existingValue = _.find(preexistingUserPermissions[permissionPathAddress[0]], function (k) {
            return k === key;
          });
          if (path === 'trump') {
            existingValue = preexistingUserPermissions[path];
          }
          if (existingValue) {
            mergedPermissionsObjForUser[permissionPathAddress[0]].push(key);
          }
        }
      } else {
        if (!mergedPermissionsObjForUser[permissionPathAddress[0]]) {
          mergedPermissionsObjForUser[permissionPathAddress[0]] = {};
        }
        if (!mergedPermissionsObjForUser[permissionPathAddress[0]][permissionPathAddress[1]]) {
          mergedPermissionsObjForUser[permissionPathAddress[0]][permissionPathAddress[1]] = {};
          mergedPermissionsObjForUser[permissionPathAddress[0]][permissionPathAddress[1]].enabled = false;
        }
        if (!mergedPermissionsObjForUser[permissionPathAddress[0]][permissionPathAddress[1]][permissionPathAddress[2]]) {
          mergedPermissionsObjForUser[permissionPathAddress[0]][permissionPathAddress[1]][permissionPathAddress[2]] = [];
        }
        if (value == 'allow') {
          mergedPermissionsObjForUser[permissionPathAddress[0]][permissionPathAddress[1]].enabled = true;
          mergedPermissionsObjForUser[permissionPathAddress[0]][permissionPathAddress[1]][permissionPathAddress[2]].push(key);
        }
        if (value == 'indeterminate') {
          try {
            existingValue = _.find(preexistingUserPermissions[permissionPathAddress[0]][permissionPathAddress[1]][permissionPathAddress[2]], function (k) {
              return k === key;
            });
            if (existingValue) {
              mergedPermissionsObjForUser[permissionPathAddress[0]][permissionPathAddress[1]].enabled = true;
              mergedPermissionsObjForUser[permissionPathAddress[0]][permissionPathAddress[1]][permissionPathAddress[2]].push(key);
            }
          } catch (e) {
            existingValue = false;
            MessageService.writeLog({
              level: 'error',
              msg: 'Error setting user permission value: ' + JSON.stringify(e),
              tags: ['permissions']
            });
          }
        }
      }
    }

    function trumpScreening(permissionsObjectDestinedForServer) {
      if (permissionsObjectDestinedForServer['trump'][0] == 'true') {
        permissionsObjectDestinedForServer['trump'] = true;
      } else {
        permissionsObjectDestinedForServer['trump'] = false;
      }
    }

    function setInitialPermissionsPoolValues(PermissionsMetadataFactory) {
      var ro = {};
      _.each(PermissionsMetadataFactory.permissions, function (block) {
        _.each(block.cards, function (card) {
          _.each(card.permissionGroups, function (permissionGroup) {
            _.each(permissionGroup.items, function (item) {
              setValue(block, card, permissionGroup, item, ro);
            });
          });
        });
      });
      return ro;
      // Private
      function setValue(block, card, permissionGroup, item, ro) {
        if (block.property == card.property && card.property == permissionGroup.property) {
          // each level's property is equal so bubble up to top level (zero nesting)
          if (!ro[permissionGroup.property]) ro[permissionGroup.property] = {};
          ro[permissionGroup.property][item.key] = PermissionsMetadataFactory.states.initial.id;
          return;
        }
        if (!ro[block.property]) ro[block.property] = {};
        if (!ro[block.property][card.property]) ro[block.property][card.property] = {};
        if (!ro[block.property][card.property][permissionGroup.property]) ro[block.property][card.property][permissionGroup.property] = {};
        ro[block.property][card.property][permissionGroup.property][item.key] = PermissionsMetadataFactory.states.initial.id;
      }
    }

    function applyPresetToPool(preset) {
      var viewModelPermissions = purePermissionsModelToViewModel(preset);
      factoryData.permissions = _.extend(factoryData.permissions, viewModelPermissions);
    }

    /**
     * @function purePermissionsModelToViewModel
     * @description takes a raw permissions model and shapes it for consumption by the view
     * @param {object} permissions raw permissions model either from a server preset or a user (straight outta mongo)
     * @returns {object} permissions object shaped for the view model - THE ORDER MATTERS!
     */
    function purePermissionsModelToViewModel(permissions) {
      var ro = {
        trump: {
          true: permissions['trump'] ? 'allow' : 'deny'
        },
        login: {
          app: setValue('app', 'login', permissions),
          portal: setValue('portal', 'login', permissions)
        },
        accountManagement: {
          general: {
            basic: {
              manageSettings: setValue('manageSettings', 'accountManagement.general.basic', permissions, 'accountManagement.general'),
              managePermissions: setValue('managePermissions', 'accountManagement.general.basic', permissions, 'accountManagement.general'),
              manageConsentTokens: setValue('manageConsentTokens', 'accountManagement.general.basic', permissions, 'accountManagement.general'),
              managePrivacyStatements: setValue('managePrivacyStatements', 'accountManagement.general.basic', permissions, 'accountManagement.general'),
              manageTeams: setValue('manageTeams', 'accountManagement.general.basic', permissions, 'accountManagement.general'),
              manageClientEmailTemplates: setValue('manageClientEmailTemplates', 'accountManagement.general.basic', permissions, 'accountManagement.general')
            }
          },
          billing: {
            basic: {
              manageBoltOns: setValue('manageBoltOns', 'accountManagement.billing.basic', permissions, 'accountManagement.billing'),
              manageUserLimit: setValue('manageUserLimit', 'accountManagement.billing.basic', permissions, 'accountManagement.billing'),
              manageBilling: setValue('manageBilling', 'accountManagement.billing.basic', permissions, 'accountManagement.billing'),
            }
          },
        },
        liteFeatures: {
          users: {
            basic: {
              view: setValue('view', 'liteFeatures.users.basic', permissions, 'liteFeatures.users'),
              edit: setValue('edit', 'liteFeatures.users.basic', permissions, 'liteFeatures.users'),
              archive: setValue('archive', 'liteFeatures.users.basic', permissions, 'liteFeatures.users')
            }
          },
          forms: {
            basic: {
              view: setValue('view', 'liteFeatures.forms.basic', permissions, 'liteFeatures.forms'),
              edit: setValue('edit', 'liteFeatures.forms.basic', permissions, 'liteFeatures.forms'),
              archive: setValue('archive', 'liteFeatures.forms.basic', permissions, 'liteFeatures.forms')
            },
            advanced: {
              badgeSetup: setValue('badgeSetup', 'liteFeatures.forms.advanced', permissions, 'liteFeatures.forms'),
              viewDrafts: setValue('viewDrafts', 'liteFeatures.forms.advanced', permissions, 'liteFeatures.forms')
            }
          },
          leadManagement: {
            basic: {
              dashboard: setValue('dashboard', 'liteFeatures.leadManagement.basic', permissions, 'liteFeatures.leadManagement'),
              viewGrid: setValue('viewGrid', 'liteFeatures.leadManagement.basic', permissions, 'liteFeatures.leadManagement'),
              editGrid: setValue('editGrid', 'liteFeatures.leadManagement.basic', permissions, 'liteFeatures.leadManagement'),
              download: setValue('download', 'liteFeatures.leadManagement.basic', permissions, 'liteFeatures.leadManagement')
            }
          },
          pickAWinner: {
            basic: {
              view: setValue('view', 'liteFeatures.pickAWinner.basic', permissions, 'liteFeatures.pickAWinner')
            }
          },
          data: {
            basic: {
              load: setValue('load', 'liteFeatures.data.basic', permissions, 'liteFeatures.data'),
              comply: setValue('comply', 'liteFeatures.data.basic', permissions, 'liteFeatures.data'),
              housekeep: setValue('housekeep', 'liteFeatures.data.basic', permissions, 'liteFeatures.data')
            }
          },
          mesh: {
            basic: {
              view: setValue('view', 'liteFeatures.mesh.basic', permissions, 'liteFeatures.mesh'),
              edit: setValue('edit', 'liteFeatures.mesh.basic', permissions, 'liteFeatures.mesh'),
              delete: setValue('delete', 'liteFeatures.mesh.basic', permissions, 'liteFeatures.mesh')
            }
          }
        },
        boltOns: {
          formManagement: {
            editor: {
              edit: setValue('edit', 'boltOns.formManagement.editor', permissions, 'boltOns.formManagement'),
            },
            predefinedLists: {
              view: setValue('view', 'boltOns.formManagement.predefinedLists', permissions, 'boltOns.formManagement'),
              edit: setValue('edit', 'boltOns.formManagement.predefinedLists', permissions, 'boltOns.formManagement'),
              archive: setValue('archive', 'boltOns.formManagement.predefinedLists', permissions, 'boltOns.formManagement')
            },
            advanced: {
              databaseSettings: setValue('databaseSettings', 'boltOns.formManagement.advanced', permissions, 'boltOns.formManagement')
            }
          },
          ocr: {
            basic: {
              view: setValue('view', 'boltOns.ocr.basic', permissions, 'boltOns.ocr'),
              edit: setValue('edit', 'boltOns.ocr.basic', permissions, 'boltOns.ocr')
            }
          },
          ai: {
            basic: {
              view: setValue('view', 'boltOns.ai.basic', permissions, 'boltOns.ai'),
              edit: setValue('edit', 'boltOns.ai.basic', permissions, 'boltOns.ai')
            }
          },
          emails: {
            thankYouEmails: {
              view: setValue('view', 'boltOns.emails.thankYouEmails', permissions, 'boltOns.emails'),
              edit: setValue('edit', 'boltOns.emails.thankYouEmails', permissions, 'boltOns.emails'),
              archive: setValue('archive', 'boltOns.emails.thankYouEmails', permissions, 'boltOns.emails')
            },
            messageComposer: {
              view: setValue('view', 'boltOns.emails.messageComposer', permissions, 'boltOns.emails')
            }
          },
          showroom: {
            basic: {
              view: setValue('view', 'boltOns.showroom.basic', permissions, 'boltOns.showroom'),
              edit: setValue('edit', 'boltOns.showroom.basic', permissions, 'boltOns.showroom'),
              archive: setValue('archive', 'boltOns.showroom.basic', permissions, 'boltOns.showroom')
            },
            advanced: {
              blocks: setValue('blocks', 'boltOns.showroom.advanced', permissions, 'boltOns.showroom')
            }
          },
          customSkins: {
            basic: {
              view: setValue('view', 'boltOns.customSkins.basic', permissions, 'boltOns.customSkins'),
              edit: setValue('edit', 'boltOns.customSkins.basic', permissions, 'boltOns.customSkins'),
              delete: setValue('delete', 'boltOns.customSkins.basic', permissions, 'boltOns.customSkins')
            }
          },
          integration: {
            machines: {
              view: setValue('view', 'boltOns.integration.machines', permissions, 'boltOns.integration'),
              edit: setValue('edit', 'boltOns.integration.machines', permissions, 'boltOns.integration'),
              delete: setValue('delete', 'boltOns.integration.machines', permissions, 'boltOns.integration'),
            },
            leadRelease: {
              release: setValue('release', 'boltOns.integration.leadRelease', permissions, 'boltOns.integration'),
              edit: setValue('edit', 'boltOns.integration.leadRelease', permissions, 'boltOns.integration')
            },
            loginCredentials: {
              manage: setValue('manage', 'boltOns.integration.loginCredentials', permissions, 'boltOns.integration')
            }
          }
        }
      };

      return ro;

      /**
       * @function setValue
       * @description sets the value of a permission to 'allow' or 'deny' based on a pure permissions model (i.e model straight outta mongo)
       * @param {string} propToFind the permission property to locate
       * @param {string} path where the permission property lives in the permissions tree (dot notated)
       * @param {object} permissions the raw permissions object
       * @param {string} featureToCheck the path to the feature to check if enabled or disabled. (1 level above the path)
       * @returns {string} string value of 'allow' or 'deny' for said permission
       */

      function setValue(propToFind, path, permissions, featureToCheck) {
        if (featureToCheck) {
          if (!featureEnabled()) return 'deny';
        }

        function index(obj, i) {
          return obj[i];
        }
        // drills into permissions at correct address and returns array of permission values
        const arrayToSearch = path.split('.').reduce(index, permissions);

        const valueFound = _.find(arrayToSearch, function (value) {
          return value === propToFind;
        });
        return valueFound ? 'allow' : 'deny';

        function featureEnabled() {
          const featureObj = featureToCheck.split('.').reduce(index, permissions);
          return featureObj ? featureObj.enabled : false;
        }
      }
    }

    /* PRIVATE HELPERS */
    function addOrRemoveUserFromFactoryStore(user, toggleAllValue) {
      if (!toggleAllValue && factoryData.usersObject[user._id] || toggleAllValue === 'remove') {
        delete factoryData.usersObject[user._id];
        MessageService.writeLog({
          level: 'info',
          msg: 'Removing ' + user.firstname + ' ' + user.surname + ' from permissions pool'
        });
      } else if (!factoryData.usersObject[user._id] && !toggleAllValue || toggleAllValue === 'add') {
        factoryData.usersObject[user._id] = user;
        MessageService.writeLog({
          level: 'info',
          msg: 'Adding ' + user.firstname + ' ' + user.surname + ' to permissions pool'
        });
      }
    }

    function makeCloneOfCurrentPermissions() {
      factoryData.permissionsClone = angular.copy(factoryData.permissions);
    }

    function reducePermissionValue(currentPermissionPoolValue, existingPermissionValueForUser) {
      if (currentPermissionPoolValue === PermissionsMetadataFactory.states.initial.id) {
        return existingPermissionValueForUser || PermissionsMetadataFactory.states.deny.id;
      }
      if (currentPermissionPoolValue === existingPermissionValueForUser) {
        return currentPermissionPoolValue;
      }
      return PermissionsMetadataFactory.states.indeterminate.id;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpExternalPartnersPage', {
      templateUrl: 'app/clients/external-partners/view.tmpl.html',
      controller: 'ExternalPartnersViewCtrl',
      bindings: {
        boltOnSelected: '<',
        closeDialog: '&'
      }
    })
    .controller('ExternalPartnersViewCtrl', ctrl);

  ctrl.$inject = ['ClientsAPI', 'MessageService', 'SessionService'];
  /* ng-inject */
  function ctrl(ClientsAPI, MessageService, SessionService) {

    var vm = this;
    vm.changes = [];
    vm.userData = SessionService.getUserData();

    vm.$onInit = function () {
      ClientsAPI.getClientById(vm.userData.clientId)
        .then(function (res) {
          vm.client = res.data.data;
          vm.storedpartners = res.data.data.externalPartnerOrgIds || [];
          vm.partners = vm.storedpartners;
          vm.addPartner();
        });
    };

    vm.addPartner = function () {
      if (!vm.partners.length) {
        vm.partners = [{
          partnerName: '',
          partnerId: ''
        }];
      }
      else
      {
        vm.partners.push({
          partnerName: '',
          partnerId: ''
        });
      }
      vm.disableSave = false;
    };

    vm.removePartner = function (partner) {
      var i = 0;
      var len = vm.partners.length;
      for (i; i < len; i++) {
        if (vm.partners[i].partnerName === partner.partnerName && vm.partners[i].partnerId === partner.partnerId) {
          vm.partners.splice(i, 1);
          break;
        }
      }
      vm.disableSave = false;
    };

    vm.postChanges = function () {
      vm.saving = true;
      vm.pulseSaveBtn = false;

      if (vm.partners.length){
        if (vm.partners[vm.partners.length-1].partnerName.length ==0 ||vm.partners[vm.partners.length-1].partnerId.length ==0) {
          vm.partners.splice(vm.partners.length-1,1);
        }
      }
      vm.client.externalPartnerOrgIds = vm.partners;
      ClientsAPI.postClientData(vm.client)
        .then(function () {
          MessageService.showMessage('Partners updated!');
          vm.updateSuccess = true;
          vm.saving = false;
          vm.storedpartners = vm.partners;
          if (vm.storedpartners.length==0){
            vm.disableSave = true;
          }
        })
        .catch(function (err) {
          MessageService.showMessage(err);
        });
    };
  }

}());

/**
 * Created by davidbeazer on 21/11/2016.
 */
(function () {
  'use strict';
  angular
    .module('clients')
    .factory('ClientEmailTemplatesFactory', ClientEmailTemplatesFactory);

  ClientEmailTemplatesFactory.$inject = ['ClientEmailTemplatesAPI', '$q', '$filter', 'ClientEmailTemplatesMainMetadata', 'MessageService', 'ValidationHelperFactory', 'SessionService', 'UserService'];
  /* ng-inject */
  function ClientEmailTemplatesFactory(ClientEmailTemplatesAPI, $q, $filter, ClientEmailTemplatesMainMetadata, MessageService, ValidationHelperFactory, SessionService, UserService) {

    const factoryData = {
      items: [],
      itemsObject: {},
      dataCache: {
        valid: false,
        lastServerTripTimestamp: null,
        clientId: null
      }
    };

    return {
      init: init,
      getTemplatesList: getTemplatesList,
      getData: getData,
      createNewTemplate: createNewTemplate,
      deleteTemplate: deleteTemplate,
      updateTemplate: updateTemplate,
      invalidateCache: invalidateCache,
      factoryData: factoryData
    };

    //////////////////////////////

    /**
     * @function init
     * @description initialises the factory, grabs the email templates from the server
     */
    function init() {
      return $q(
        function q(resolve, reject) {
          if (ValidationHelperFactory.dataCacheIsStillValid(factoryData.dataCache)) {
            resolve(factoryData);
          } else {
            getTemplatesList()
              .then(function () {
                factoryData.dataCache.valid = true;
                factoryData.dataCache.lastServerTripTimestamp = new Date();
                factoryData.dataCache.clientId = SessionService.getUserData().clientId;
                resolve(factoryData);
              })
              .catch(function (err) {
                MessageService.writeLog({
                  level: 'error',
                  msg: 'server trip for email templates error: ' + JSON.stringify(err),
                  tags: ['account_level_cache']
                });
                reject(err);
              });
          }
        });
    }

    /**
     * @function getData
     * @description simple getter for returning the contents of the factory data
     * @returns factoryData - an object containing pertinent data for this factory
     */

    function getData() {
      return factoryData;
    }

    /**
     * @function getTemplatesList
     * @description grabs all the email templates from the server and processes them for subsequent use in the portal (grid)
     */
    function getTemplatesList() {
      return $q(
        function q(resolve, reject) {
          if (ValidationHelperFactory.dataCacheIsStillValid(factoryData.dataCache)) {
            hydrateFactoryWithTemplates(factoryData.rawItemsArray);
            resolve(factoryData);
          } else {
            ClientEmailTemplatesAPI.getTemplatesList()
              .then(function (res) {
                hydrateFactoryWithTemplates(res.data.data);
                resolve(factoryData);
              })
              .catch(function (err) {
                MessageService.writeLog({
                  level: 'error',
                  msg: 'server trip for email templates error: ' + JSON.stringify(err),
                  tags: ['account_level_cache']
                });
                reject(err);
              });
          }
        });
    }

    function hydrateFactoryWithTemplates(data) {
      factoryData.items = data;
      factoryData.rawItemsArray = angular.copy(data);

      const shapedItemsArray = shapeDataForGrid(factoryData.items);
      const arrayToMap = angular.copy(shapedItemsArray);
      factoryData.items = $filter('enhancedTableCells')(ClientEmailTemplatesMainMetadata.getData(), shapedItemsArray);

      const templatesObject = _.reduce(arrayToMap, function (templatesObject, v) {
        templatesObject[v.emailtemplate._id] = v;
        return templatesObject;
      }, {});
      const allTemplatesObject = _.reduce(shapeDataForGrid(factoryData.rawItemsArray), function (templatesObject, v) {
        templatesObject[v.emailtemplate._id] = v;
        return templatesObject;
      }, {});
      factoryData.allItemsObject = allTemplatesObject;
      factoryData.itemsObject = templatesObject;
      factoryData.dataCache.valid = true;
      factoryData.dataCache.lastServerTripTimestamp = new Date();
      factoryData.dataCache.clientId = SessionService.getUserData().clientId;
    }

    /**
     * @function shapeDataForGrid
     * @description puts each email template into a the format required for them to be rendered in the zpGrid component
     * @param {array} arrayOfUnprocessedItems is the raw server data
     * @returns a new array of processed items ready to be filtered
     */
    function shapeDataForGrid(arrayOfUnprocessedItems) {
      return _.map(arrayOfUnprocessedItems, function (item) {
        return {
          emailtemplate: {
            _id: item._id,
            type: derriveTypeFromTemplate(item),
            title: item.title || '',
            _lastmodifiedonservertime: item._lastmodifiedonservertime || ''
          }
        };
      });
    }

    function createNewTemplate(doc) {
      return ClientEmailTemplatesAPI
        .createNewTemplate(doc)
        .then(function (response) {
          if (response.status == 200) {
            var template = shapeDataForGrid([doc]);
            var tempToAdd = $filter('enhancedTableCells')(ClientEmailTemplatesMainMetadata.getData(), template);
            factoryData.items[factoryData.items.length] = tempToAdd[0];
            factoryData.itemsObject[doc._id] = template[0];
            return;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function deleteTemplate(id) {
      return ClientEmailTemplatesAPI
        .deleteTemplate(id)
        .then(function (response) {
          if (response.status == 204) {
            const index = factoryData.items.findIndex((itm)=> itm.emailtemplate._id === id);
            if (index > -1){
              factoryData.items.splice(index, 1);
              delete factoryData.itemsObject[id];
            }

            return;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function updateTemplate(saveObj) {
      return ClientEmailTemplatesAPI
        .postTemplateData(saveObj)
        .then(function (response) {
          if (response.status == 200) {
            const index = factoryData.items.findIndex((itm)=> itm.emailtemplate._id === saveObj._id);
            if (index > -1){
              const updatedTemplate = angular.copy(factoryData.itemsObject[saveObj._id].emailtemplate);
              const clientIsMarketpoint = UserService.isClientMarketpoint();

              updatedTemplate.title = saveObj.title;
              updatedTemplate._lastmodifiedonservertime = saveObj._lastmodifiedonservertime;
              updatedTemplate.active = saveObj.active;
              updatedTemplate.global = clientIsMarketpoint;

              const shapedTemplate = shapeDataForGrid([updatedTemplate]);
              const enhancedShapedTemplate = $filter('enhancedTableCells')(ClientEmailTemplatesMainMetadata.getData(), shapedTemplate);

              factoryData.items[index] = enhancedShapedTemplate[0];
              factoryData.itemsObject[saveObj._id] = shapedTemplate[0];

              if (saveObj.active){
                const targetIcn = clientIsMarketpoint ? 'global_active' : 'active';
                const staleActiveIndex = factoryData.items.findIndex((itm, i)=> {
                  const icon = factoryData.itemsObject[itm.emailtemplate._id].emailtemplate.icn;
                  return i !== index &&
                  icon === targetIcn;
                });

                if (staleActiveIndex > -1){
                  const staleId = factoryData.items[staleActiveIndex].emailtemplate._id;
                  const updatedStaleTemplate = angular.copy(factoryData.itemsObject[staleId].emailtemplate);
                  updatedStaleTemplate.active = false;
                  updatedStaleTemplate.global = updatedTemplate.global;

                  const shapedStaleTemplate = shapeDataForGrid([updatedStaleTemplate]);
                  const enhancedStaleShapedTemplate = $filter('enhancedTableCells')(ClientEmailTemplatesMainMetadata.getData(), shapedStaleTemplate);

                  factoryData.items[staleActiveIndex] = enhancedStaleShapedTemplate[0];
                  factoryData.itemsObject[staleId] = shapedStaleTemplate[0];

                }

              }
            }
            return response;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function invalidateCache() {
      factoryData.dataCache.valid = false;
      factoryData.dataCache.lastServerTripTimestamp = null;
      return;
    }

    /////////////////// PRIVATE HELPER METHODS ///////////////////

    function derriveTypeFromTemplate(obj) {
      switch (obj.type){
        case 'welcome_template':{
          if (obj.active && obj.global){
            return 'global_welcome_template_active';
          } else if (obj.active && !obj.global){
            return 'welcome_template_active';
          } else if (!obj.active && obj.global){
            return 'global_welcome_template_inactive';
          } else if (!obj.active && !obj.global){
            return 'welcome_template_inactive';
          }
          break;
        }
        case 'password_reset_template':{
          if (obj.active && obj.global){
            return 'global_password_reset_template_active';
          } else if (obj.active && !obj.global){
            return 'password_reset_template_active';
          } else if (!obj.active && obj.global){
            return 'global_password_reset_template_inactive';
          } else if (!obj.active && !obj.global){
            return 'password_reset_template_inactive';
          }
          break;
        }
      }
     
    }

  }
})();

/**
* Created by davidbeazer on 27/11/2016.
*/
(function () {
  'use strict';

  angular
    .module('clients')
    .factory('ClientEmailTemplatesAPI', ClientEmailTemplatesAPI);

  ClientEmailTemplatesAPI.$inject = ['APIService', 'APIFactory', 'EncodingService'];
  /* ng-inject */
  function ClientEmailTemplatesAPI(api, apiFactory, encoder) {

    const clientEmailTemplatesApi = apiFactory.route('client/email-templates');

    const services = {
      getTemplatesList: clientEmailTemplatesApi.get,
      getTemplateById: clientEmailTemplatesApi.getById,
      postTemplateData: postTemplateData,
      createNewTemplate: clientEmailTemplatesApi.create,
      deleteTemplate: clientEmailTemplatesApi.delete,
      sendTemplateTestEmail: sendTemplateTestEmail,
      aggregateTemplateActivity: aggregateTemplateActivity,
      aggregateTotalTemplateActivity: aggregateTotalTemplateActivity
    };

    return services;
    ////////////////////////////


    function postTemplateData(data, files) {
      var id = data._id;
      if (id) {
        return clientEmailTemplatesApi.update(data, files);
      } else {
        return clientEmailTemplatesApi.create(data, files);
      }
    }

    function sendTemplateTestEmail(templateToTest) {
      return api.post('client/email-templates/' + encoder.encode(templateToTest._id) + '/sendTemplateTestEmail', templateToTest)
        .then(function (response) {
          if (response.status == 200) {
            return response.data;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function aggregateTemplateActivity(rangeStart, rangeEnd, emailtemplateid) {
      return api.post('client/email-templates/aggregate/' + encoder.encode(emailtemplateid), { $gte: rangeStart, $lte: rangeEnd })
        .then(function (response) {
          if (response.status === 200) {
            return response.data;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function aggregateTotalTemplateActivity(queryObj) {
      return api.post('client/email-templates/aggregate', queryObj)
        .then(function (response) {
          if (response.status === 200) {
            return response.data.data;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }
  }

})();

/**
 * Created by davidbeazer on 27/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('clients')
    .component('zpClientDetailPage', {
      controller: 'ClientDetailController',
      templateUrl: 'app/clients/detail/zp-client-detail.tmpl.html',
      bindings: {
        customSkinLibraryStatePath: '@',
        customSkinEditorStatePath: '@'
      }
    })
    .controller('ClientDetailController', ClientDetailController);

  ClientDetailController.$inject = ['$scope', '$document', 'CurrentClientModelFactory', 'MessageService', 'hotkeys', 'EnvService', '$state', 'BoltOnsFactory', 'ClientsMainMetadata', 'ClientOperationsDialogMetadataFactory', 'UserService', 'ZuantAccountManagersFactory', '$filter'];
  /* ng-inject */
  function ClientDetailController($scope, $document, CurrentClientModel, MessageService, hotkeys, EnvService, $state, BoltOnsFactory, ClientsMainMetadata, ClientOperationsDialogMetadataFactory, UserService, ZuantAccountManagersFactory, $filter) {

    var vm = this;
    vm.isClientMarketpoint = false;

    vm.$onInit = function () {
      vm.factoryData = CurrentClientModel.factoryData;
      vm.clientDoc = CurrentClientModel.getCurrentClientCache();
      vm.superZams = ZuantAccountManagersFactory.superZams;
      vm.metadata = ClientsMainMetadata.getData();
      vm.isClientMarketpoint = UserService.isClientMarketpoint();
      vm.imageURL = $filter('cdnAssets')('/images/pngs/icons/placeholder/logo-placeholder.png');
      vm.currentNavItem = 'account';
      hotkeys.del('ctrl+n');
      vm.isDev = EnvService.isDev;
      BoltOnsFactory.getAccountPermissions(vm.clientDoc._id, vm.clientDoc.databasename)
        .then(function (res) {
          // accountBoltOns required here to control if the zpThemeOverview component is shown or not
          vm.accountBoltOns = res;
        });
      vm.clientDetailStatePath = $state.current.name;
    };

    vm.clearLogo = function () {
      CurrentClientModel.clearLogoImgFromAccount()
        .then(function () {
          $scope.$applyAsync(function () {
            MessageService.showMessage('Logo cleared');
            $scope.$broadcast('zp.client-logo-updated');
          });
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: err,
            tags: ['error', 'logo']
          });
        });
    };

    vm.deleteClient = function (event) {
      const deleteOperation = ClientsMainMetadata.buildDialogDataForDeleteOperation(vm.clientDoc);
      ClientOperationsDialogMetadataFactory.buildFactoryForOperation(deleteOperation);
  
      MessageService.showDialog(event, {
        controller: vm.metadata.deleteClientDialogConfig.controller,
        templateUrl: vm.metadata.deleteClientDialogConfig.templateUrl,
        parent: angular.element($document.body),
        locals: {
          clientDoc: vm.clientDoc
        },
        clickOutsideToClose: false
      })
        .then(
          function () {
            MessageService.writeLog({
              level: 'info',
              msg: 'Delete account dialog closed'
            });
          })
        .catch(function (){
          // user cancelled out of mamage client dialog
        });
    };
  
    vm.archiveClient = function (event) {
      const archiveOperation = ClientsMainMetadata.buildDialogDataForArchiveOperation(vm.clientDoc);
      ClientOperationsDialogMetadataFactory.buildFactoryForOperation(archiveOperation);
  
      MessageService.showDialog(event, {
        controller: vm.metadata.archiveClientDialogConfig.controller,
        templateUrl: vm.metadata.archiveClientDialogConfig.templateUrl,
        parent: angular.element($document.body),
        locals: {
          clientDoc: vm.clientDoc
        },
        clickOutsideToClose: false
      })
        .then(
          function () {
            MessageService.writeLog({
              level: 'info',
              msg: 'Archive account dialog closed'
            });
          })
        .catch(function (){
          // user cancelled out of mamage client dialog
        });
    };
  
    vm.unarchiveClient = function (event) {
      const unArchiveOperation = ClientsMainMetadata.buildDialogDataForUnarchiveOperation(vm.clientDoc);
      ClientOperationsDialogMetadataFactory.buildFactoryForOperation(unArchiveOperation);
    
      MessageService.showDialog(event, {
        controller: vm.metadata.unarchiveClientDialogConfig.controller,
        templateUrl: vm.metadata.unarchiveClientDialogConfig.templateUrl,
        parent: angular.element($document.body),
        locals: {
          clientDoc: vm.clientDoc
        },
        clickOutsideToClose: false
      })
        .then(
          function () {
            MessageService.writeLog({
              level: 'info',
              msg: 'Unarchive account dialog closed'
            });
          })
        .catch(function (){
          // user cancelled out of mamage client dialog
        });
    };

    vm.redactClient = function (event) {
      const redactCRMOperation = ClientsMainMetadata.buildDialogDataForRedactOperation(vm.clientDoc);
      ClientOperationsDialogMetadataFactory.buildFactoryForOperation(redactCRMOperation);
    
      MessageService.showDialog(event, {
        controller: vm.metadata.redactClientDialogConfig.controller,
        templateUrl: vm.metadata.redactClientDialogConfig.templateUrl,
        parent: angular.element($document.body),
        locals: {
          clientDoc: vm.clientDoc
        },
        clickOutsideToClose: false
      })
        .then(
          function () {
            MessageService.writeLog({
              level: 'info',
              msg: 'Redact account dialog closed'
            });
          })
        .catch(function (){
          // user cancelled out of mamage client dialog
        });
    };

    vm.updateLogo = function (logoObj) {
      vm.disableSaveBtn = true;
      return CurrentClientModel.saveClientLogoImage(logoObj)
        .then(function () {
          $scope.$applyAsync(function () {
            vm.disableSaveBtn = false;
            MessageService.showMessage('Logo image saved');
            MessageService.writeLog({
              level: 'info',
              msg: 'Logo save success! 👍🏻'
            });

            $scope.$broadcast('zp.client-logo-updated');
          });

        })
        .catch(function (err) {
          vm.disableSaveBtn = false;
          MessageService.showMessage('Error:' + err.message || err.statusText);
          MessageService.writeLog({
            level: 'info',
            msg: '💥 Logo save error.. Err: ' + JSON.stringify(err)
          });
        });
    };

    vm.isStale = function (newVal) {
      vm.isdirty = CurrentClientModel.isStale(newVal);
    };

    vm.requestPasscode = function (ev) {
      CurrentClientModel.requestPasscode(ev);
    };
  }
})();

/**
 * Created by davidbeazer on 27/09/2016.
 */

(function () {
  'use strict';
  angular
    .module('clients')
    .factory('CurrentClientModelFactory', CurrentClientModel);

  CurrentClientModel.$inject = ['$rootScope', '$state', 'ClientsAPI', 'ZPModel', 'MessageService', 'ClientsDataFactory', 'ChangeDelta', 'localStorageService', '$q', 'DATA_API_CONFIG', 'ValidationHelperFactory', 'EndElevatedEditSession', 'UserPermittedToEditAccountOwner', 'UserPermittedToEditGDPRSettings', 'UserService', 'DATA_BACKEND_WSURL', 'AWS_STORAGE_REGION', 'AWS_STORAGE_BUCKET_NAME'];
  /* ng-inject */
  function CurrentClientModel($rootScope, $state, ClientsAPI, ZPModel, MessageService, ClientsDataFactory, ChangeDelta, localStorage, $q, DATA_API_CONFIG, ValidationHelperFactory, EndElevatedEditSession, UserPermittedToEditAccountOwner, UserPermittedToEditGDPRSettings, UserService, DATA_BACKEND_WSURL, AWS_STORAGE_REGION, AWS_STORAGE_BUCKET_NAME) {

    let factoryData = {};

    resetFactory();

    $rootScope.$on('zp.user_data.updated', function(event, data) {
      updatedCurrentClientCache(data);
    });

    $rootScope.$on('zp.websocket.messageRecieved', function(event, props){
      if (props.connection !== DATA_BACKEND_WSURL) return;
      
      const message = JSON.parse(props.message);
      const currentClient = _.get(factoryData, 'currentClient', {});
      if (currentClient.databasename !== message.data.databasename) return;
      const userData = UserService.getUserData();
      switch (message.type){
        case 'activateZubot':{
          const zubot =  message.data.zubot;
          switch (zubot.mission.type){
            case 'unarchiveClient':
            case 'archiveClient':
            case 'redactAllCRM':
            case 'deleteClient': {
              for (const key of Object.keys(message.data.delta)){
                currentClient[key] = message.data.delta[key];
              }
              $rootScope.$digest();
            }
          }
          break;
        }
        case 'unarchiveClient':
        case 'archiveClient':
        case 'redactAllCRM':
        case 'deleteClient':{

          currentClient.clientOperationStatus = {
            progress: message.data.progress,
            currentStep: message.data.currentStep,
            totalSteps: message.data.totalSteps,
            operation: message.type,
            zubot: message.data.zubot,
            milestone: message.data.milestone,
            caption: message.data.caption
          };

          switch (message.type){
            case 'unarchiveClient':
            case 'archiveClient': {
              if (message.data.milestone === 'complete') {
                delete currentClient.clientOperationStatus;
                currentClient.clientArchived = message.type === 'unarchiveClient' ? false : true;
              }
              break;
            }
            case 'redactAllCRM': {

              if (message.data.milestone === 'complete') {
                delete currentClient.clientOperationStatus;
                currentClient.clientRedacted = true;
              }

              break;
            }
            case 'deleteClient': {
              if (!userData.marketpoint) return $state.go('logout');
            }
          }

          $rootScope.$digest();
          break;
        }

      }
    });
    
    /* this factory inherits from ZPModel */
    const services = Object.create(ZPModel);

    services.getClientById = getClientById;
    services.getCurrentClientCache = getCurrentClientCache;
    services.saveClientLogoImage = saveClientLogoImage;
    services.clearLogoImgFromAccount = clearLogoImgFromAccount;
    services.isStale = isStale;
    services.postClientData = postClientData;
    services.updateChangeDelta = updateChangeDelta;
    services.updateChangeDeltaNested = updateChangeDeltaNested;
    services.requestPasscode = requestPasscode;
    services.verifyPasscode = verifyPasscode;
    services.factoryData = factoryData;
    services.endElevatedEditSession = endElevatedEditSession;
    services.resetFailedAttemptsCount = resetFailedAttemptsCount;
    services.endElevatedEditSessionIfExpired = endElevatedEditSessionIfExpired;
    services.gdprNotificationTidyUp = gdprNotificationTidyUp;
    services.invalidateCache = invalidateCache;
    services.resetFactory = resetFactory;

    return services;

    //////////////////////////////

    function resetFactory() {
      factoryData = {
        storedModel: {},
        copyOfCurrentClient: {},
        currentClient: {},
        invalidPasscodeCount: localStorage.get('ipc') || 0,
        encryptedPasscode: localStorage.get('ep') || '',
        dataCache: {
          valid: false,
          lastServerTripTimestamp: '',
          clientId: ''
        }
      };
      factoryData.userPermittedToEditAccountOwner = {};
      UserPermittedToEditAccountOwner.get(factoryData, false);
      factoryData.userPermittedToMakeGDPREdits = {};
      UserPermittedToEditGDPRSettings.get(factoryData, false);
    }

    function endElevatedEditSession() {
      EndElevatedEditSession(factoryData);
    }

    function updateChangeDelta(property, newValue) {
      const oldValue = factoryData.copyOfCurrentClient[property];
      ChangeDelta.recordValueChange({
        oldval: oldValue,
        newval: newValue,
        objectid: factoryData.currentClient._id,
        collection: 'clients',
        databasefieldname: property
      });
    }

    function updateChangeDeltaNested(prop1, prop2, newValue) {
      let oldValue;
      try {
        oldValue = factoryData.copyOfCurrentClient[prop1][prop2];
      } catch (e) {
        oldValue = undefined;
      } finally {
        if (prop1 === 'GDPR' && prop2 === 'enabled') {
          factoryData.enableGDPRModeFlag = newValue;
          factoryData.currentClient.dataUrlOverride = newValue ? DATA_API_CONFIG.url : '';
        }
        ChangeDelta.recordValueChange({
          oldval: oldValue,
          newval: newValue,
          objectid: factoryData.currentClient._id,
          collection: 'clients',
          databasefieldname: prop1 + '.' + prop2
        });
      }
    }

    function getClientById(_id) {
      return new Promise(function (resolve, reject) {
        if (ValidationHelperFactory.dataCacheIsStillValid(factoryData.dataCache)) {
          resolve(factoryData.currentClient);
        } else {
          return ClientsAPI.getClientById(_id)
            .then(function (response) {
              // console.log('got client by id: ', response.data.data);
              factoryData.currentClient = response.data.data;
              factoryData.copyOfCurrentClient = angular.copy(response.data.data);
              factoryData.storedModel = angular.copy(factoryData.currentClient);

              if (!response.data.data.accountOwner) {
                UserPermittedToEditAccountOwner.set(factoryData, true);
                response.data.data.accountOwner = '';
              }
              if (_.isUndefined(response.data.data.GDPR)) {
                response.data.data.GDPR = {
                  enabled: false,
                  waiveForNominatedForms: false
                };
              }
              if (_.isUndefined(response.data.data.consentModel)) {
                response.data.data.consentModel = [];
              }
              if (_.isUndefined(response.data.data.zuantaccountmanager)){
                response.data.data.zuantaccountmanager = '';
              }
              if (_.isUndefined(response.data.data.zuantcustomersuccessmanager)){
                response.data.data.zuantcustomersuccessmanager = '';
              }
              if (_.isUndefined(response.data.data.pricingPlan)){
                response.data.data.pricingPlan = '';
              }

              factoryData.userPermittedToMakeGDPREdits = UserPermittedToEditGDPRSettings.get(factoryData);
              factoryData.userPermittedToEditAccountOwner = UserPermittedToEditAccountOwner.get(factoryData);
              ChangeDelta.clear();
              factoryData.dataCache.valid = true;
              factoryData.dataCache.lastServerTripTimestamp = new Date();
              factoryData.dataCache.clientId = response.data.data._id;

              resolve(factoryData.currentClient);

            })
            .catch(function (err) {
              reject(err);
            });
        }
      });
    }

    function postClientData(data, files) {
      return ClientsAPI.postClientData(data, files)
        .then(function (response) {
          ChangeDelta.clear();
          ClientsDataFactory.invalidateCache();
          if (response.data.data._id) {
            factoryData.currentClient._id = response.data.data._id;
            UserPermittedToEditAccountOwner.set(factoryData, true);
            if (response.data.data.accountOwner) {
              // if an account owner is set then permit the user to make those level edits to save faff on getting an email. keep it flowing!
              const oneHourFromNow = moment().add(1, 'hours');
              UserPermittedToEditGDPRSettings.set(factoryData, {
                permitted: true,
                expires: oneHourFromNow
              });
            }
            ClientsDataFactory.addNewClientToLocalModel(response.data.data);
          }
          notifyIntercom(data);
          return response.data.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function notifyIntercom(data) {
      const intercomUpdate = {
        company: {
          ZAM: data.zuantaccountmanager,
          website: data.website,
          id: data.databasename,
          name: data.companyname,
          isBetaTester: data.isBetaTestingAccount,
          isZuant3Account: data.isZuant3Account,
          notes: data.notes,
          syncUrlOverride: data.syncUrlOverride,
          dataUrlOverride: data.dataUrlOverride
        }
      };
      MessageService.updateIntercom(intercomUpdate);
    }

    function getCurrentClientCache() {
      return factoryData.currentClient;
    }

    function updatedCurrentClientCache(deltas) {
      if (!factoryData.currentClient || !factoryData.currentClient._id) return;
      if (factoryData.currentClient._id !== deltas.clientId) return;
      for (const key of Object.keys(deltas)){
        if (key === '_id' || key === 'permissions' || key === 'clientId') continue;
        if (deltas[key] !== undefined && deltas[key] !== factoryData.currentClient[key]){
          factoryData.currentClient[key] = deltas[key];
        }
      }
    }

    function gdprNotificationTidyUp(newClientId) {
      MessageService.pushEventToIntercom('GDPR_enabled', {
        enabled: true
      });

      const dialogConfig = {
        controller: 'GDPREnabledInfoCtrl as $ctrl',
        templateUrl: 'app/clients/dialogs/gdpr-enabled-courtesy-info/dialog.tmpl.html',
        locals: {
          _id: newClientId
        }
      };

      return MessageService.showDialog(null, dialogConfig)
        .then(function () {
          factoryData.enableGDPRModeFlag = false;
        })
        .catch(function () {
          factoryData.enableGDPRModeFlag = false;
        });
    }

    function saveClientLogoImage(logoObj) {
      const file = logoObj.binary;
      return ClientsAPI.uploadClientLogo(file)
        .then(function (s3key) {

          const logoPayload = {
            filetype: file.type,
            filesize: file.size,
            filename: file.name,
            _s3key: s3key
          };

          return ClientsAPI.postClientLogo(logoPayload, factoryData.currentClient._id)
            .then(function (res) {

              const updatedLogo = Object.assign(logoPayload, res.data);

              updatedCurrentClientCache({
                clientId: factoryData.currentClient._id,
                clientLogoImage: updatedLogo
              });

            });
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function clearLogoImgFromAccount() {
      return ClientsAPI.clearLogoFromAccount(factoryData.currentClient._id)
        .then(function () {
          factoryData.currentClient.clientLogoImage = {};
        });
    }

    function requestPasscode(ev) {

      const userDoc = UserService.getUserData();

      const payload = {
        emailTo: [userDoc.email]
      };
    
      return ClientsAPI.requestPasscode(payload, factoryData.currentClient._id)
        .then(function (res) {
          factoryData.encryptedPasscode = res.data.passcode;
          localStorage.set('ep', factoryData.encryptedPasscode);
    
          const dialogconfig = {
            controller: 'RequestPasscodeController as vm',
            templateUrl: 'app/clients/dialogs/request-gdpr-passcode/dialog.tmpl.html',
            clickOutsideToClose: false
          };
    
          return MessageService.showDialog(ev, dialogconfig);
        })
        .then(function () {
          return true;
        })
        .catch(function (err) {
          throw err;
          // MessageService.showMessage(err);
        });     
    }

    function verifyPasscode(passcode) {
      if (!factoryData.encryptedPasscode) return;

      const payload = {
        userPasscode: passcode,
        encryptedPasscode: factoryData.encryptedPasscode
      };

      return $q(function q(resolve, reject) {
        // if (factoryData.invalidPasscodeCount >= 3) reject('too many invalid attempts');
        return ClientsAPI.verifyPasscode(payload, factoryData.currentClient._id)
          .then(function (res) {
            if (res.data.valid) {
              UserPermittedToEditAccountOwner.set(factoryData, true);
              UserPermittedToEditGDPRSettings.set(factoryData, {
                permitted: true,
                expires: res.data.expires
              });
              localStorage.set('ep', '');
              MessageService.showMessage('Passcode valid');
              if (factoryData.invalidPasscodeCount > 0) {
                resetFailedAttemptsCount();
              }
              resolve(true);
            } else {
              reject(false);
            }
          })
          .catch(function (err) {
            try {
              if (err.data.data.message === 'Invalid passcode') {
                factoryData.invalidPasscodeCount++;
                localStorage.set('ipc', factoryData.invalidPasscodeCount);
              }
            } catch (e) {
              reject('Unknown error');
            }
            reject(err.data.data.message);
          });
      });
    }

    function resetFailedAttemptsCount() {
      factoryData.invalidPasscodeCount = 0;
      localStorage.set('ipc', 0);
    }

    function isStale(newModel) {
      /* method inherited from ZPModel */
      return !this.equalObjects(storedModel, newModel);
    }

    function endElevatedEditSessionIfExpired() {
      if (factoryData.userPermittedToMakeGDPREdits.permitted) {
        const x = new moment();
        const y = new moment(factoryData.userPermittedToMakeGDPREdits.expires);
        const expired = x.isAfter(y);
        if (expired) {
          endElevatedEditSession();
        }
      }
    }

    function invalidateCache() {
      factoryData.dataCache = {
        valid: false,
        lastServerTripTimestamp: '',
        clientId: ''
      };
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('ValidateNewAccountFactory', factory);

  factory.$inject = ['$log', 'ClientsDataFactory', '$q', 'UsersAPI'];
  /* ng-inject */
  function factory($log, ClientsDataFactory, $q, UsersAPI) {

    var vm;

    return function validateNewAccount(viewModelToValidate) {
      vm = viewModelToValidate;
      $log.info('validation starting');
      return $q(function q(resolve, reject) {
        if (vm.clientFormObj.$invalid) {
          reject('Form Invalid');
        }
        return validateUsers()
          .then(function () {
            $log.info('users are valid');
            return ClientsDataFactory.checkClientDatabasename(vm.accountTemplateSettings.clientDoc.databasename);
          })
          .then(function (res) {
            if (res.data.length) {
              $log.error('dbname already exists');
              reject('Databasename already exists');
            } else {
              $log.info('databasename is valid');
              $log.info('new account validation complete, the account is valid');
              resolve('valid');
            }
          })
          .catch(function (err) {
            $log.error('account is not valid for saving: ' + JSON.stringify(err));
            reject(err);
          });
      });
    };

    function validateUsers() {
      return new Promise(function (resolve, reject) {
        if (vm.users.length) {
          var arrayOfValidUserDocs = _.filter(vm.users, function (userData) {
            return userdocValid(userData);
          });
          if (arrayOfValidUserDocs.length === vm.users.length) {
            $log.info('users docs are valid, now to validate login creds are unique');
            var arrayOfCredsCheckReq = [];
            _.each(vm.users, function (userDoc) {
              arrayOfCredsCheckReq.push(UsersAPI.validateCredentials({
                databasename: vm.accountTemplateSettings.clientDoc.databasename,
                email: userDoc.email,
                password: userDoc.password,
                repeatpassword: userDoc.repeatpassword
              }));
            });
            return $q.all(arrayOfCredsCheckReq)
              .then(function () {
                $log.info('all user logins are valid');
                resolve('users are all valid');
              })
              .catch(function (err) {
                $log.error('user login validation error' + JSON.stringify(err));
                reject(err.data.data.message);
              });
          } else {
            $log.error('user doc isn\'t valid');
            reject('Please check user required fields');
          }
        } else {
          $log.info('no users to validate');
          resolve();
        }
      });
    }

    function userdocValid(formData) {
      if (formData.firstname == '' ||
        formData.surname == '' ||
        formData.email == '' ||
        formData.typeofuser == '' ||
        formData.password == '' ||
        formData.repeatpassword == '') {
        $log.error('user doc is invalid');
        return false;
      } else {
        $log.info('user doc is valid');
        return true;
      }
    }
  }

}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('ProcessUsersAndForm', factory);

  factory.$inject = ['$q', 'uuidService', 'FormsFactory', 'UserFactory'];
  /* ng-inject  */
  function factory($q, uuid, FormsFactory, UserFactory) {

    return function (vm) {
      return new Promise(function (resolve, reject) {

        var arrayOfRequests = [];

        _.each(vm.users, function (user) {
          user.email = user.email.toLowerCase();
          arrayOfRequests.push(UserFactory.postNewUser(user));
        });

        if (vm.accountTemplateSettings.formTemplate.item._id) {
          var newId = uuid.getSingleNewBase64Key();
          vm.newFormDoc._id = newId;
          vm.newFormDoc.id = newId;
          vm.newFormDoc.formTemplateId = vm.accountTemplateSettings.formTemplate.item._id;
          arrayOfRequests.push(FormsFactory.saveNewForm(vm.newFormDoc));

          if (vm.accountTemplateSettings.formTemplate.item._id === 'ieee_2022') {
            var newId2 = uuid.getSingleNewBase64Key();
            var newFormDoc2 = Object.assign({}, vm.newFormDoc);
            newFormDoc2._id = newId2;
            newFormDoc2.id = newId2;
            newFormDoc2.formTemplateId = 'ieee_2022_qr';
            arrayOfRequests.push(FormsFactory.saveNewForm(newFormDoc2));
          }
        }

        return $q.all(arrayOfRequests)
          .then(function () {
            resolve(FormsFactory.invalidateCache());
          })
          .catch(function (err) {
            reject(err);
          });
      });
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('PerformAfterSaveNewAccountAction', factory);

  factory.$inject = ['CurrentClientModelFactory', 'CacheInvalidationFactory', '$log', 'CreateAccountMetadata', 'MessageService', '$state'];
  /* ng-inject */
  function factory(CurrentClientModelFactory, CacheInvalidationFactory, $log, CreateAccountMetadata, MessageService, $state) {

    return function (vm, action) {
      return new Promise(function (resolve) {

        // now do the after-save action the user selected
        if (CurrentClientModelFactory.factoryData.enableGDPRModeFlag && action !== 'add') {
          $log.info('pop a polite message up to manage GDPR consent model now');
          CurrentClientModelFactory.gdprNotificationTidyUp(vm.accountTemplateSettings.clientDoc._id);
        } else {
          $log.info('GDPR not set up, continue');
          if (action == 'close') {
            resolve({
              hideDialog: true
            });
          } else if (action == 'add') {
            // need to invalidate all the caches and create another new account. appears this has some bugs as Marketpoint db is having forms added to it
            CurrentClientModelFactory.resetFactory();
            CacheInvalidationFactory.invalidateAllCachedData();
            vm.accountTemplateSettings = _.extend(vm.accountTemplateSettings, {});
            vm.clientFormObj = _.extend(vm.clientFormObj, CreateAccountMetadata.clientFormObj());
            $log.info('CurrentClientModelFactory.factoryData,' + JSON.stringify(CurrentClientModelFactory.factoryData));

            vm.users = [];
            vm.accountMeta.template = '';
            vm.uxhelpers.panels.account.show = false;
            vm.uxhelpers.panels.boltons.show = false;
            vm.uxhelpers.panels.forms.show = false;
            vm.uxhelpers.panels.users.show = false;

            resolve({});
          } else if (action == 'manage') {
            $state.go('app.tabbed_app_framework.client_detail.account_settings', {
              _id: CurrentClientModelFactory.factoryData.currentClient._id
            });
            resolve({
              hideDialog: true
            });
          }
        }

        MessageService.showMessage('Account added');

      });
    };
  }
}());

(function () {
  'use strict';
  angular
    .module('clients')
    .factory('CreateAccountViewModel', factory);

  factory.$inject = ['UserPermissionsHelperFactory', 'CurrentClientModelFactory', 'MessageService', '$timeout', 'ChangeDelta', 'UserFactory', '$log', 'ClientsDataFactory', 'ZAMHelperFactory', 'AccountModelFactory', 'ValidateNewAccountFactory', 'WebsummitHelpersFactory', 'ProcessUsersAndForm', 'PerformAfterSaveNewAccountAction'];
  /* ng-inject */
  function factory(UserPermissionsHelperFactory, CurrentClientModelFactory, MessageService, $timeout, ChangeDelta, UserFactory, $log, ClientsDataFactory, ZAMHelperFactory, AccountModelFactory, ValidateNewAccount, WebsummitHelpersFactory, ProcessUsersAndForm, PerformAfterSaveNewAccountAction) {

    var factoryData = {
      vm: {}
    };

    return {
      init: init,
      accountTemplateSelected: accountTemplateSelected,
      hideDialog: hideDialog,
      cancelDialog: cancelDialog,
      iconCheck: iconCheck,
      showPanel: showPanel,
      addUser: addUser,
      removeUser: removeUser,
      setFormTemplateToUse: setFormTemplateToUse,
      saveNewAccount: saveNewAccount
    };

    function init(viewModel) {
      $log.info('CreateAccountViewModel init');
      factoryData.vm = viewModel; // bringing the viewModel in here to limit component controllers to function bindings only and have all logic in here.
            
      UserPermissionsHelperFactory.init()
        .catch(function (err) {
          MessageService.writeLog({
            level: 'err',
            msg: err,
            tags: ['init_permissions_factory']
          });
        });
    }

    function accountTemplateSelected(template) {
      makeViewAdjustments();
      factoryData.vm.accountTemplateSettings = AccountModelFactory(template, CurrentClientModelFactory.factoryData);
    }

    function makeViewAdjustments() {
      factoryData.vm.uxhelpers.fadeOutTemplateSelectText = true;
      $timeout(function () {
        factoryData.vm.uxhelpers.removePTag = true;
      }, 500);
      factoryData.vm.uxhelpers.panels.account.show = true;
      factoryData.vm.uxhelpers.panels.boltons.show = false;
      factoryData.vm.uxhelpers.panels.forms.show = true;
      factoryData.vm.uxhelpers.panels.users.show = true;
    }

    function hideDialog(answer) {
      MessageService.closeDialog(answer);
    }

    function cancelDialog() {
      if (ChangeDelta.isDirty()) ChangeDelta.clear();
      CurrentClientModelFactory.factoryData.currentClient = CurrentClientModelFactory.factoryData.copyOfCurrentClient;
      CurrentClientModelFactory.factoryData.userPermittedToEditAccountOwner.permitted = false;
      CurrentClientModelFactory.factoryData.userPermittedToMakeGDPREdits.permitted = false;
      MessageService.cancelDialog();
    }

    function iconCheck(panel) {
      return factoryData.vm.uxhelpers.panels[panel].show ? 'clear' : 'add';
    }

    function showPanel(panel) {
      if (!factoryData.vm.accountMeta.template) {
        factoryData.vm.uxhelpers.shakeTemplateWidget = true;
        $timeout(function () {
          factoryData.vm.uxhelpers.shakeTemplateWidget = false;
        }, 3000);
        return;
      }
      factoryData.vm.uxhelpers.panels[panel].show = !factoryData.vm.uxhelpers.panels[panel].show;
      if (panel === 'users') {
        if (!factoryData.vm.users.length) addUser();
      }
    }

    function addUser() {
      factoryData.vm.users.push(UserFactory.newUserModel());
    }

    function removeUser(index) {
      factoryData.vm.users.splice(index, 1);
    }

    function setFormTemplateToUse(item) {
      if (!_.isUndefined(item)) {
        if (_.isUndefined(item.item)) return;
        factoryData.vm.accountTemplateSettings.formTemplate = item;
      }
    }

    function saveNewAccount(action) {
      return ValidateNewAccount(factoryData.vm)
        .then(function () {
          $log.info('new client form is valid. continuing to post data');
          if (factoryData.vm.accountTemplateSettings.formTemplate.item._id === 'websummit_2024') {
            /** POTATO */
            WebsummitHelpersFactory.setScannerSettings(factoryData.vm);
          }
          return CurrentClientModelFactory.postClientData(factoryData.vm.accountTemplateSettings.clientDoc); // any error downstream of here will keep the form open and the model will be the same, however when clicking submit it won't be creating a new record since the id hasn't changed. Then the code will break when trying to switch account
        })
        .then(function (accountData) {
          $log.info('new account created. the id is ' + accountData._id + ' and the databasename is ' + accountData.databasename);
          $log.info('switching account to ' + accountData._id);
          return ClientsDataFactory.switchAccount({
            clientId: accountData._id
          });
        })
        .then(function () {
          $log.info('switched to new account, now to processUsersAndFormIfNecessary');
          return ProcessUsersAndForm(factoryData.vm);
        })
        .then(function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'Successfully created a new account with clientId: ' + factoryData.vm.accountTemplateSettings.clientDoc._id + ', form template id: ' + factoryData.vm.accountTemplateSettings.formTemplate.item._id + ', zuantWebLookupToken2 value of: ' + factoryData.vm.newFormDoc.zuantWebLookupToken2 + ', and ' + factoryData.vm.users.length + ' users',
            tags: ['create_account_success', 'websummit_2024']
          });
          addNewAccountToSidebar();
          return PerformAfterSaveNewAccountAction(factoryData.vm, action);
        })
        .then(function (response) {
          $log.info('account creation is complete');
          if (response.hideDialog) hideDialog(true);
        })
        .catch(function (msg) {
          $log.error('something went wrong saving new account: ' + JSON.stringify(msg));
          MessageService.showMessage(msg);
          MessageService.writeLog({
            level: 'error',
            msg: msg,
            tags: ['create_account']
          });
        });
    }

    function addNewAccountToSidebar() {
      ZAMHelperFactory.addToActivityLog({
        timeadded: moment().format('HH:mm:ss'),
        companyname: factoryData.vm.accountTemplateSettings.clientDoc.companyname
      });
    }

  }
}());

(function () {
  'use strict';
  angular
    .module('clients')
    .factory('CreateAccountMetadata', factory);

  factory.$inject = ['$filter'];
  /* ng-inject */
  function factory($filter) {

    return {
      init: init,
      accountTemplates: accountTemplates,
      uxhelpers: uxhelpers,
      users: users,
      accountMeta: accountMeta,
      newFormDoc: newFormDoc,
      clientDoc: clientDoc,
      clientFormObj: clientFormObj,
      formTemplatesConfig: formTemplatesConfig,
      formTemplate: formTemplate
    };

    function init() {

    }

    function accountTemplates() {
      return [{
        name: 'Standard Zuant Template',
        value: 'standard_template',
        img: $filter('cdnAssets')('/images/pngs/icons/form-templates/Z-80-sq.png')
      },
      /** POTATO */
      {
        name: 'WebSummit 2024 Template',
        value: 'websummit_2024',
        img: $filter('cdnAssets')('/images/pngs/icons/form-templates/websummit.png')
      },
      {
        name: 'IEEE 2026 ESW Template',
        value: 'ieee_2026_esw',
        img: $filter('cdnAssets')('/images/pngs/icons/form-templates/ieee.png')
      },
      {
        name: 'IEEE 2023 Sections Congress Template',
        value: 'ieee_2023_selections_congress',
        img: $filter('cdnAssets')('/images/pngs/icons/form-templates/ieee.png')
      },
      {
        name: 'NLS 2026 Days Template',
        value: 'nls_2026_days',
        img: $filter('cdnAssets')('/images/pngs/icons/form-templates/nls_days.png')
      },
      {
        name: 'Collision 2023 Template',
        value: 'collision_2023',
        img: $filter('cdnAssets')('/images/pngs/icons/form-templates/collision.png')
      },
      {
        name: 'The Next Web 2022 Template',
        value: 'thenextweb_2022',
        img: $filter('cdnAssets')('/images/pngs/icons/form-templates/tnw.png')
      },
      {
        name: 'ESGCT 2024 Template',
        value: 'esgct_2024',
        img: $filter('cdnAssets')('/images/pngs/icons/form-templates/esgct.png')
      },
      {
        name: 'IEMDC 2025 Template',
        value: 'iemdc_2025',
        img: $filter('cdnAssets')('/images/pngs/icons/form-templates/iemdc_2025.png')
      },
      {
        name: 'Southampton International Boat Show 2022 Template',
        value: 'sibs_2022',
        img: $filter('cdnAssets')('/images/pngs/icons/form-templates/sibs_2022.png')
      }];
    }

    function uxhelpers() {
      return {
        removePTag: false,
        fadeOutTemplateSelectText: false,
        shakeTemplateWidget: false,
        panels: {
          account: {
            show: false
          },
          boltons: {
            show: false
          },
          forms: {
            show: false
          },
          users: {
            show: false
          }
        }
      };
    }

    function users() {
      return [];
    }

    function accountMeta() {
      return {
        template: ''
      };
    }

    function newFormDoc() {
      return {};
    }

    function clientDoc() {
      return {
        companyname: '',
        databasename: ''
      };
    }

    function clientFormObj() {
      return {};
    }

    function formTemplatesConfig() {
      return {
        name: 'formTemplate',
        placeholder: 'Choose a template to use',
        floatingLabel: 'Template name',
        filter: 'accountCreation'
      };
    }

    function formTemplate() {
      return {
        item: {
          _id: '',
          title: ''
        }
      };
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('AccountModelFactory', factory);

  factory.$inject = ['UserPermissionsHelperFactory', 'UserPermittedToEditAccountOwner', 'UserPermittedToEditGDPRSettings'];
  /* ng-inject */
  function factory(UserPermissionsHelperFactory, UserPermittedToEditAccountOwner, UserPermittedToEditGDPRSettings) {

    return function newAccountTemplate(template, factoryData) {

      const returnObj = {
        clientDoc: {},
        formTemplate: {}
      };

      if (template === 'standard_template') {

        returnObj.clientDoc = {
          _id: '',
          accountTemplateId: 'standard_template',
          companyname: '',
          databasename: '',
          technicalContact: '',
          website: '',
          timezone: '',
          ispreventimagedownload: 1,
          copySupportEmailsToZuantTeam: 0,
          isBetaTestingAccount: 0,
          isZuant3Account: 0,
          notes: '',
          zuantaccountmanager: '',
          zuantcustomersuccessmanager: '',
          permissions: UserPermissionsHelperFactory.factoryData.presets.account,
          accountOwner: '',
          consentModel: [],
          GDPR: {
            enabled: false,
            waiveForNominatedForms: false
          },
          externalPartnerOrgIds: [],
          pricingPlan: ''
        };

        returnObj.formTemplate = {
          item: {
            _id: '',
            title: ''
          }
        };
        factoryData.enableGDPRModeFlag = false;
        UserPermittedToEditGDPRSettings.set(factoryData, {
          permitted: true,
          expires: ''
        });
      } else if (template === 'websummit_2024') {
        returnObj.clientDoc = {
          _id: '',
          accountTemplateId: 'websummit_2024',
          companyname: '',
          databasename: '',
          technicalContact: '',
          website: '',
          timezone: '(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
          ispreventimagedownload: 1,
          copySupportEmailsToZuantTeam: 0,
          notes: 'This account was creating using the websummit_2024 account template',
          zuantaccountmanager: '',
          zuantcustomersuccessmanager: '',
          permissions: UserPermissionsHelperFactory.factoryData.presets.account,
          accountOwner: '',
          consentModel: [],
          isBetaTestingAccount: 0,
          isZuant3Account: 0,
          GDPR: {
            enabled: false,
            waiveForNominatedForms: false
          },
          externalPartnerOrgIds: [],
          partnerId: '',
          pricingPlan: ''
        };

        returnObj.scanToken2 = 'japhuwracomabrecepecclobrukadivibovafracnaswadrubr_';
        returnObj.formTemplate = {
          item: {
            _id: 'websummit_2024',
            title: 'WebSummit 2024 Template'
          }
        };
        factoryData.enableGDPRModeFlag = false;
        UserPermittedToEditGDPRSettings.set(factoryData, {
          permitted: false,
          expires: ''
        });
      } else if (template === 'ieee_2022') {
        returnObj.clientDoc = {
          _id: '',
          accountTemplateId: 'ieee_2022',
          companyname: '',
          databasename: '',
          technicalContact: '',
          website: '',
          timezone: '(GMT-05:00) Eastern Time (US & Canada)',
          ispreventimagedownload: 1,
          copySupportEmailsToZuantTeam: 0,
          notes: 'This account was creating using the ieee_2022 account template',
          zuantaccountmanager: '',
          zuantcustomersuccessmanager: '',
          permissions: UserPermissionsHelperFactory.factoryData.presets.account,
          accountOwner: '',
          consentModel: [],
          isBetaTestingAccount: 0,
          isZuant3Account: 0,
          GDPR: {
            enabled: false,
            waiveForNominatedForms: false
          },
          externalPartnerOrgIds: [],
          partnerId: '',
          pricingPlan: ''
        };

        returnObj.formTemplate = {
          item: {
            _id: 'ieee_2022',
            title: 'IEEE 2022 Template'
          }
        };
        factoryData.enableGDPRModeFlag = false;
        UserPermittedToEditGDPRSettings.set(factoryData, {
          permitted: false,
          expires: ''
        });
      } else if (template === 'ieee_2026_esw') {
        returnObj.clientDoc = {
          _id: '',
          accountTemplateId: 'ieee_2026_esw',
          companyname: '',
          databasename: '',
          technicalContact: '',
          website: '',
          timezone: '(GMT-05:00) Eastern Time (US & Canada)',
          ispreventimagedownload: 1,
          copySupportEmailsToZuantTeam: 0,
          notes: 'This account was creating using the ieee_2026_esw account template',
          zuantaccountmanager: '',
          zuantcustomersuccessmanager: '',
          permissions: UserPermissionsHelperFactory.factoryData.presets.account,
          accountOwner: '',
          consentModel: [],
          isBetaTestingAccount: 0,
          isZuant3Account: 0,
          GDPR: {
            enabled: false,
            waiveForNominatedForms: false
          },
          externalPartnerOrgIds: [],
          partnerId: '',
          pricingPlan: ''
        };

        returnObj.formTemplate = {
          item: {
            _id: 'ieee_2026_esw',
            title: 'IEEE ESW 2026 Template'
          }
        };
        factoryData.enableGDPRModeFlag = false;
        UserPermittedToEditGDPRSettings.set(factoryData, {
          permitted: false,
          expires: ''
        });
      } else if (template === 'ieee_2023_selections_congress') {
        returnObj.clientDoc = {
          _id: '',
          accountTemplateId: 'ieee_2023_selections_congress',
          companyname: '',
          databasename: '',
          technicalContact: '',
          website: '',
          timezone: '(GMT-05:00) Eastern Time (US & Canada)',
          ispreventimagedownload: 1,
          copySupportEmailsToZuantTeam: 0,
          notes: 'This account was creating using the ieee_2023_selections_congress account template',
          zuantaccountmanager: '',
          zuantcustomersuccessmanager: '',
          permissions: UserPermissionsHelperFactory.factoryData.presets.account,
          accountOwner: '',
          consentModel: [],
          isBetaTestingAccount: 0,
          isZuant3Account: 0,
          GDPR: {
            enabled: false,
            waiveForNominatedForms: false
          },
          externalPartnerOrgIds: [],
          partnerId: '',
          pricingPlan: ''
        };

        returnObj.formTemplate = {
          item: {
            _id: 'ieee_2023_selections_congress',
            title: 'IEEE Sections Congress 2023 Template'
          }
        };
        factoryData.enableGDPRModeFlag = false;
        UserPermittedToEditGDPRSettings.set(factoryData, {
          permitted: false,
          expires: ''
        });
      } else if (template === 'collision_2023') {
        returnObj.clientDoc = {
          _id: '',
          accountTemplateId: 'collision_2023',
          companyname: '',
          databasename: '',
          technicalContact: '',
          website: '',
          timezone: '(GMT-05:00) Eastern Time (US & Canada)',
          ispreventimagedownload: 1,
          copySupportEmailsToZuantTeam: 0,
          notes: 'This account was creating using the collision_2023 account template',
          zuantaccountmanager: '',
          zuantcustomersuccessmanager: '',
          permissions: UserPermissionsHelperFactory.factoryData.presets.account,
          accountOwner: '',
          consentModel: [],
          isBetaTestingAccount: 0,
          isZuant3Account: 0,
          GDPR: {
            enabled: false,
            waiveForNominatedForms: false
          },
          externalPartnerOrgIds: [],
          partnerId: '',
          pricingPlan: ''
        };

        returnObj.formTemplate = {
          item: {
            _id: 'collision_2023',
            title: 'Collision 2023 Template'
          }
        };
        factoryData.enableGDPRModeFlag = false;
        UserPermittedToEditGDPRSettings.set(factoryData, {
          permitted: false,
          expires: ''
        });
      } else if (template === 'thenextweb_2022') {
        returnObj.clientDoc = {
          _id: '',
          accountTemplateId: 'thenextweb_2022',
          companyname: '',
          databasename: '',
          technicalContact: '',
          website: '',
          timezone: '(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
          ispreventimagedownload: 1,
          copySupportEmailsToZuantTeam: 0,
          notes: 'This account was creating using the thenextweb_2022 account template',
          zuantaccountmanager: '',
          zuantcustomersuccessmanager: '',
          permissions: UserPermissionsHelperFactory.factoryData.presets.account,
          accountOwner: '',
          consentModel: [],
          isBetaTestingAccount: 0,
          isZuant3Account: 0,
          GDPR: {
            enabled: false,
            waiveForNominatedForms: false
          },
          externalPartnerOrgIds: [],
          partnerId: '',
          pricingPlan: ''
        };

        returnObj.formTemplate = {
          item: {
            _id: 'thenextweb_2022',
            title: 'The Next Web 2022 Template'
          }
        };
        factoryData.enableGDPRModeFlag = false;
        UserPermittedToEditGDPRSettings.set(factoryData, {
          permitted: false,
          expires: ''
        });
      } else if (template === 'esgct_2024') {
        returnObj.clientDoc = {
          _id: '',
          accountTemplateId: 'esgct_2024',
          companyname: '',
          databasename: '',
          technicalContact: '',
          website: '',
          timezone: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris',
          ispreventimagedownload: 1,
          copySupportEmailsToZuantTeam: 0,
          notes: 'This account was creating using the esgct_2024 account template',
          zuantaccountmanager: '',
          zuantcustomersuccessmanager: '',
          permissions: UserPermissionsHelperFactory.factoryData.presets.account,
          accountOwner: '',
          consentModel: [],
          isBetaTestingAccount: 0,
          isZuant3Account: 0,
          GDPR: {
            enabled: false,
            waiveForNominatedForms: false
          },
          externalPartnerOrgIds: [],
          partnerId: '',
          pricingPlan: ''
        };

        returnObj.formTemplate = {
          item: {
            _id: 'esgct_2024',
            title: 'ESGCT 2024 Template'
          }
        };
        factoryData.enableGDPRModeFlag = false;
        UserPermittedToEditGDPRSettings.set(factoryData, {
          permitted: false,
          expires: ''
        });
      } else if (template === 'iemdc_2025') {
        returnObj.clientDoc = {
          _id: '',
          accountTemplateId: 'iemdc_2025',
          companyname: '',
          databasename: '',
          technicalContact: '',
          website: '',
          timezone: '(GMT-05:00) Eastern Time (US & Canada)',
          ispreventimagedownload: 1,
          copySupportEmailsToZuantTeam: 0,
          notes: 'This account was creating using the iemdc_2025 account template',
          zuantaccountmanager: '',
          zuantcustomersuccessmanager: '',
          permissions: UserPermissionsHelperFactory.factoryData.presets.account,
          accountOwner: '',
          consentModel: [],
          isBetaTestingAccount: 0,
          isZuant3Account: 0,
          GDPR: {
            enabled: false,
            waiveForNominatedForms: false
          },
          externalPartnerOrgIds: [],
          partnerId: '',
          pricingPlan: ''
        };

        returnObj.formTemplate = {
          item: {
            _id: 'iemdc_2025',
            title: 'IEMDC 2025 Template'
          }
        };
        factoryData.enableGDPRModeFlag = false;
        UserPermittedToEditGDPRSettings.set(factoryData, {
          permitted: false,
          expires: ''
        });
      } else if (template === 'nls_2026_days') {
        returnObj.clientDoc = {
          _id: '',
          accountTemplateId: 'nls_2026_days',
          companyname: '',
          databasename: '',
          technicalContact: '',
          website: '',
          timezone: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
          ispreventimagedownload: 1,
          copySupportEmailsToZuantTeam: 0,
          notes: 'This account was creating using the nls_2026_days account template',
          zuantaccountmanager: '',
          zuantcustomersuccessmanager: '',
          permissions: UserPermissionsHelperFactory.factoryData.presets.account,
          accountOwner: '',
          consentModel: [],
          isBetaTestingAccount: 0,
          isZuant3Account: 0,
          GDPR: {
            enabled: false,
            waiveForNominatedForms: false
          },
          externalPartnerOrgIds: [],
          partnerId: '',
          pricingPlan: ''
        };

        returnObj.formTemplate = {
          item: {
            _id: 'nls_2026_days',
            title: 'The NLS Days 2026 Template'
          }
        };
        factoryData.enableGDPRModeFlag = false;
        UserPermittedToEditGDPRSettings.set(factoryData, {
          permitted: false,
          expires: ''
        });
      } else if (template ==='sibs_2022') {
        returnObj.clientDoc = {
          _id: '',
          accountTemplateId: 'sibs_2022',
          companyname: '',
          databasename: '',
          technicalContact: '',
          website: '',
          timezone: '(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
          ispreventimagedownload: 1,
          copySupportEmailsToZuantTeam: 0,
          notes: 'This account was creating using the sibs_2022 account template',
          zuantaccountmanager: '',
          zuantcustomersuccessmanager: '',
          permissions: UserPermissionsHelperFactory.factoryData.presets.account,
          accountOwner: '',
          consentModel: [],
          isBetaTestingAccount: 0,
          isZuant3Account: 0,
          GDPR: {
            enabled: false,
            waiveForNominatedForms: false
          },
          externalPartnerOrgIds: [],
          partnerId: '',
          pricingPlan: ''
        };

        returnObj.formTemplate = {
          item: {
            _id: 'sibs_2022',
            title: 'Southampton International Boat Show 2022 Template'
          }
        };
        factoryData.enableGDPRModeFlag = false;
        UserPermittedToEditGDPRSettings.set(factoryData, {
          permitted: false,
          expires: ''
        });
      }
      UserPermittedToEditAccountOwner.set(factoryData, true);
      factoryData.currentClient = returnObj.clientDoc;

      return returnObj;

    };

  }

}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('ShapeConsentModelForView', factory);

  factory.$inject = ['ConsentModelDefaults', 'uuidService'];
  /* ng-inject */
  function factory(ConsentModelDefaults, uuid) {

    return function shapedConsentModel(consentModel) {

      const accountConsentModelShapedForView = [];
      if (!consentModel) return [];

      _.each(consentModel, function (tokenObj) {
        const viewReadyObj = {};
        const symbolObjArray = [];

        buildArrayOfSymbols(tokenObj, symbolObjArray);
        buildViewReadyObject(tokenObj, symbolObjArray, viewReadyObj, accountConsentModelShapedForView);

      });
      return accountConsentModelShapedForView;
    };

    function buildArrayOfSymbols(tokenObj, symbolObjArray) {
      _.each(tokenObj.symbols, function (symbolString) {
        const matchingSymbol = _.find(ConsentModelDefaults.zuantFunctions(), function (defaultFunc) {
          return symbolString === defaultFunc.name;
        });
        if (matchingSymbol) {
          symbolObjArray.push(matchingSymbol);
        }
      });
    }

    function buildViewReadyObject(tokenObj, symbolObjArray, viewReadyObj, returnArray) {
      viewReadyObj._id = uuid.getSingleNewBase64Key();
      viewReadyObj.token = tokenObj.token;
      viewReadyObj.heading = tokenObj.heading;
      viewReadyObj.text = tokenObj.text;
      viewReadyObj.symbols = symbolObjArray;
      viewReadyObj.active = tokenObj.active;
      returnArray.push(viewReadyObj);
    }

  }

}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('ConsentModelDefaults', factory);

  factory.$inject = ['uuidService'];
  /* ng-inject */
  function factory(uuid) {

    return {
      defaultConsentModel: defaultConsentModel,
      zuantFunctions: zuantFunctions,
      newTokenModel: newTokenModel
    };

    function defaultConsentModel() {
      return [{
        _id: uuid.getSingleNewBase64Key(),
        token: 'Store my data',
        heading: 'Hold information about you',
        text: 'I agree that you can store my personal information on your secure systems.  I understand that I can ask to have my information removed at any time by contacting you.',
        symbols: [{
          _id: 'zuant_function_001',
          name: 'Store PII'
        }],
        active: true
      }];
    }

    function zuantFunctions() {
      return [{
        _id: 'zuant_function_001',
        name: 'Store PII'
      }, {
        _id: 'zuant_function_002',
        name: 'Send Email'
      }, {
        _id: 'zuant_function_003',
        name: 'Pass to 3rd Party'
      }, {
        _id: 'zuant_function_004',
        name: 'Unassigned'
      }];
    }

    function newTokenModel() {
      return {
        _id: uuid.getSingleNewBase64Key(),
        token: '',
        heading: '',
        text: '',
        symbols: [],
        active: true
      };
    }

  }

}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('ConsentViewModelFactory', factory);

  factory.$inject = ['ConsentDataFactory', 'MessageService', '$document', '$mdMedia', 'CurrentClientModelFactory', 'EnvService', 'ConsentModelDefaults', 'ConsentAPIFactory', 'ConsentValidationFactory', 'localStorageService', 'ShapeConsentModelForView', 'SendThankYouEmailIntegrityCheck'];
  /* ng-inject */
  function factory(ConsentDataFactory, MessageService, $document, $mdMedia, CurrentClientModel, EnvService, ConsentModelDefaults, ConsentAPI, ConsentValidationFactory, localStorage, ShapeConsentModelForView, SendThankYouEmailIntegrityCheck) {

    const factoryData = {
      tokenSaveWarningShownToUser: getTokenWarningSaveValue()
    };

    return {
      hydrateFactory: hydrateFactory,
      hydrateDefaultConsentModel: ConsentDataFactory.hydrateDefaultConsentModel,
      consentFunctions: ConsentModelDefaults.zuantFunctions,
      defaultConsentModel: ConsentModelDefaults.defaultConsentModel,
      saveConsentModel: saveConsentModel,
      saveConsentDocument: saveConsentDocument,
      cancelDialog: cancelDialog,
      loadConsentFormDialog: loadConsentFormDialog,
      resetAccountConsentModel: resetAccountConsentModel,
      toggleReorderTokens: toggleReorderTokens,
      isDev: EnvService.isDev,
      requestPasscode: CurrentClientModel.requestPasscode,
      hideGetStartedText: hideGetStartedText,
      showGettingStartedHelpText: showGettingStartedHelpText,
      accountConsentModelIsValid: accountConsentModelIsValid,
      // factoryData stores
      factoryData: factoryData,
      dataModelFactoryData: ConsentDataFactory.factoryData,
      validationFactoryData: ConsentValidationFactory.factoryData,
      currentClientFactoryData: CurrentClientModel.factoryData
    };

    function hydrateFactory() {
      return ConsentAPI.getAccountConsentModel()
        .then(function (rawConsentModel) {
          const accountConsentModelShapedForView = ShapeConsentModelForView(rawConsentModel);
          ConsentDataFactory.hydrateFactory(accountConsentModelShapedForView);
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: err,
            tags: ['hydrating_consent_model']
          });
        });
    }

    function saveConsentDocument(update) {
      return ConsentAPI.saveAccountConsentModel(update)
        .then(function () {
          MessageService.showMessage('Consent token saved');
        })
        .catch(function (err) {
          MessageService.showMessage(err.message);
          reject(err);
        });
    }

    function saveConsentModel() {
      return new Promise(function (resolve, reject) {
        const tokenCreation = !(_.isEmpty(ConsentDataFactory.factoryData.tokenInEdit));
        if (tokenCreation){
          const validationObj = ConsentValidationFactory.validateAccountConsentModel(ConsentDataFactory.factoryData.accountConsentModel, ConsentDataFactory.factoryData.tokenInEdit);
          if (!validationObj.valid) {
            MessageService.writeLog({
              level: 'info',
              msg: 'Consent model is invalid, issues: ' + JSON.stringify(validationObj.issues),
              tags: ['consent_mgmt']
            });
            return reject(validationObj);
          }

          ConsentDataFactory.mergeEditsIntoModel();
        }

        return showUserSaveWarningIfNecessary(tokenCreation)
          .then(function () {
            const modelToSave = ConsentDataFactory.consentModelReadyForSave();
            return saveConsentDocument(modelToSave)
              .then(function () {
                MessageService.closeDialog();
                ConsentDataFactory.endEditSession();
                CurrentClientModel.invalidateCache();
                return SendThankYouEmailIntegrityCheck.runCheckOnAccount();
              })
              .then(function () {
                resolve();
              })
              .catch(function (err) {
                MessageService.showMessage(err.message);
                reject(err);
              });
          })
          .catch(function (err) {
            reject(err);
          });
      });
    }

    function showUserSaveWarningIfNecessary(tokenCreation) {
      return new Promise(function (resolve, reject) {
        if (!tokenCreation || factoryData.tokenSaveWarningShownToUser) return resolve();

        localStorage.set('tokenSaveWarningShownToUser', true);
        factoryData.tokenSaveWarningShownToUser = true;
        
        return MessageService.confirm()
          .confirmAction({
            title: 'One more thing to note',
            htmlContent: `Once a consent token is issued you can't makes edits to it.<br> 
              This is because a device may have synced the token in the time you decided you needed to make an edit.<br>
              In this scenario simply make the token inactive and create a new one.`,
            okBtn: 'Save',
            cancelBtn: 'Cancel'
          })
          .then(function () {
            resolve();
          })
          .catch(function () {
            reject('Double check you\'re happy then save');
          });
      });
    }

    function cancelDialog() {
      ConsentDataFactory.endEditSession();
      MessageService.cancelDialog();
    }

    function loadConsentFormDialog(params) {
      const useFullScreen = ($mdMedia('sm') || $mdMedia('xs'));
      const tokenToLoad = params.widget || ConsentModelDefaults.newTokenModel();

      ConsentDataFactory.beginEditSession(tokenToLoad);

      return MessageService.showDialog(params.ev, {
        controller: 'AddConsentTokenDialogCtrl as $ctrl',
        templateUrl: 'app/clients/dialogs/consent-token-dialog/dialog.tmpl.html',
        parent: angular.element($document.body),
        locals: {
          toolbartitle: params.description,
          readOnly: params.readOnly
        },
        clickOutsideToClose: false,
        fullscreen: useFullScreen,
        description: params.description,
        ariaLabel: params.description
      })
        .then(function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'User closed edit consent token dialog',
            tags: ['consent_mgmt']
          });
        })
        .catch(function () {
          MessageService.writeLog({
            level: 'info',
            msg: 'User cancelled out of edit consent token dialog',
            tags: ['consent_mgmt']
          });
        });
    }

    function resetAccountConsentModel(ev) {
      return MessageService.confirm(ev)
        .delete('Are you sure you want to delete the entire consent model?')
        .then(function () {
          const accountConsentModel = [];
          return ConsentAPI.saveAccountConsentModel(accountConsentModel)
            .then(function () {
              CurrentClientModel.invalidateCache();
              return ConsentDataFactory.resetAccountConsentModel();
            })
            .then(function () {
              MessageService.showMessage('Deletion complete');
              MessageService.pushEventToIntercom('cleared_account_consent_model');
              CurrentClientModel.invalidateCache();
              return SendThankYouEmailIntegrityCheck.runCheckOnAccount();
            })
            .catch(function () {
              MessageService.showMessage('Something went wrong');
            });
        })
        .catch(function (err) {
          throw err;
        });
    }

    function toggleReorderTokens() {
      return new Promise(function (resolve, reject) {
        ConsentDataFactory.toggleReorderTokens();
        if (!ConsentDataFactory.factoryData.reorderItems) {
          const modelToSave = ConsentDataFactory.consentModelReadyForSave();
          ConsentAPI.saveAccountConsentModel(modelToSave)
            .then(function () {
              MessageService.showMessage('Order saved');
              resolve();
            })
            .catch(function (err) {
              MessageService.showMessage(err.message);
              reject();
            });
        } else {
          resolve();
        }
      });
    }

    function getTokenWarningSaveValue() {
      const val = localStorage.get('tokenSaveWarningShownToUser') || false;
      return val;
    }

    function showGettingStartedHelpText() {
      const val = localStorage.get('hideConsentGetStartedText') || false;
      return val;
    }

    function hideGetStartedText() {
      localStorage.set('hideConsentGetStartedText', true);
    }

    function accountConsentModelIsValid() {
      const clientConsentModel = CurrentClientModel.getCurrentClientCache().consentModel;
      const shapedConsentModel = ShapeConsentModelForView(clientConsentModel);
      return ConsentValidationFactory.validateAccountConsentModel(shapedConsentModel);
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('ConsentValidationFactory', factory);
  /* nginject */
  factory.$inject = [];

  function factory() {

    const factoryData = {
      consentModelToValidate: {},
      validationObj: {
        valid: false,
        issues: [],
        activeTokenWithStorePiiPresent: false
      },
      tokenInEditForm: {} // angular binds form properties to this object which is exposed here for form validation across multiple components
    };

    return {
      validateAccountConsentModel: validateAccountConsentModel,
      factoryData: factoryData
    };

    function validateAccountConsentModel(accountConsentModel, tokenInEdit) {
      setFactoryData(accountConsentModel);
      prepConsentModelForValidation(tokenInEdit);
      validateTokens();
      validatePIITokenIsPresent();
      validateTokenNamesAreUnique();
      return factoryData.validationObj;
    }

    function setFactoryData(accountConsentModel) {
      factoryData.consentModelToValidate = angular.copy(accountConsentModel);
      factoryData.validationObj = {
        valid: true,
        issues: []
      };
      factoryData.validationObj.activeTokenWithStorePiiPresent = false;
    }

    function prepConsentModelForValidation(tokenInEdit) {
      let widgetInModel = _.find(factoryData.consentModelToValidate, function (token) {
        return token._id === tokenInEdit._id;
      });
      if (widgetInModel) {
        widgetInModel = _.extend(widgetInModel, tokenInEdit); // merge old with new
      } else {
        factoryData.consentModelToValidate.push(tokenInEdit); // pop new onto existing array
      }
    }

    function validateTokens() {
      _.each(factoryData.consentModelToValidate, function (token) {
        consentTokenIsValid(token);
      });
    }

    function validatePIITokenIsPresent() {
      const piiTokenIsPresent = ensureStorePIITokenIsPresentInModel();
      if (!piiTokenIsPresent) {
        factoryData.validationObj.valid = false;
        factoryData.validationObj.issues.push('No Store PII function/symbol is currently present in an active token');
      }
    }

    function validateTokenNamesAreUnique() {
      const namesAreUnique = ensureAllTokenNamesAreUnique();
      if (!namesAreUnique) {
        factoryData.validationObj.valid = false;
        factoryData.validationObj.issues.push('Token names must be unique');
      }
    }

    function consentTokenIsValid(token) {
      if (!token.token) {
        factoryData.validationObj.valid = false;
        factoryData.validationObj.issues.push('token missing');
      }
      if (!token.heading) {
        factoryData.validationObj.valid = false;
        factoryData.validationObj.issues.push('heading missing');
      }
      if (!token.text) {
        factoryData.validationObj.valid = false;
        factoryData.validationObj.issues.push('text missing');
      }
      if (token.symbols.length == 0) {
        factoryData.validationObj.valid = false;
        factoryData.validationObj.issues.push('no symbols');
      }
    }

    function ensureStorePIITokenIsPresentInModel() {
      const activeTokensWithStorePiiSymbol = _.chain(factoryData.consentModelToValidate)
        .filter(function (token) {
          return token.symbols.length && token.active;
        })
        .find(function (token) {
          return _.find(token.symbols, function (symbol) {
            return symbol.name == 'Store PII';
          });
        })
        .value(); // will find any active tokens that have a symbol with Store PII
      factoryData.validationObj.activeTokenWithStorePiiPresent = !!activeTokensWithStorePiiSymbol;
      return !!activeTokensWithStorePiiSymbol;
    }

    function ensureAllTokenNamesAreUnique() {
      const arrayOfTokenNames = _.map(factoryData.consentModelToValidate, 'token');
      const tokenNamesAreUnique = _.uniq(arrayOfTokenNames); // creates array of unique token names
      return tokenNamesAreUnique.length === factoryData.consentModelToValidate.length; // if that's not same length as consent model then there's dupes
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('ConsentDataFactory', factory);

  factory.$inject = [];
  /* ng-inject */
  function factory() {

    const factoryData = {};

    factoryDefaults();

    function factoryDefaults() {
      _.extend(factoryData, {
        sourceModelClone: [],
        accountConsentModel: [],
        consentModelClone: [],
        reorderItems: false,
        tokenInEdit: {},
        tokenInEditClone: {}
      });
    }

    return {
      hydrateFactory: hydrateFactory,
      beginEditSession: beginEditSession,
      endEditSession: endEditSession,
      consentModelReadyForSave: consentModelReadyForSave,
      resetAccountConsentModel: factoryDefaults,
      toggleReorderTokens: toggleReorderTokens,
      mergeEditsIntoModel: mergeEditsIntoModel,
      factoryData: factoryData
    };

    function hydrateFactory(currentClientConsentModel) {
      factoryDefaults();
      factoryData.accountConsentModel = currentClientConsentModel;
      factoryData.consentModelClone = angular.copy(currentClientConsentModel);
      splitTokensForSorting();
    }

    function beginEditSession(consentToken) {
      const consentTokenToEdit = angular.copy(consentToken);
      factoryData.tokenInEdit = consentTokenToEdit;
      factoryData.tokenInEditClone = angular.copy(consentTokenToEdit);
    }

    function endEditSession() {
      factoryData.tokenInEdit = {};
      factoryData.tokenInEditClone = {};
    }

    function toggleReorderTokens() {
      factoryData.reorderItems = !factoryData.reorderItems;
      if (!factoryData.reorderItems) {
        factoryData.accountConsentModel = reorderedAccountConsentModel();
      } else {
        splitTokensForSorting();
      }
    }

    function reorderedAccountConsentModel() {
      let newTokenOrder = [];
      _.each(factoryData.activeTokens, function (t1) {
        const tokenToMove = _.find(factoryData.accountConsentModel, function (t2) {
          return t1.token === t2.token;
        });
        if (tokenToMove) {
          newTokenOrder.push(tokenToMove);
        }
      });
      newTokenOrder = newTokenOrder.concat(factoryData.inactiveTokens);
      return newTokenOrder;
    }

    function splitTokensForSorting() {
      factoryData.activeTokens = _.filter(factoryData.accountConsentModel, function (token) {
        return token.active;
      });
      factoryData.inactiveTokens = _.filter(factoryData.accountConsentModel, function (token) {
        return !token.active;
      });
    }

    function mergeEditsIntoModel() {
      let tokenInModel = isTokenInEditAlreadyInModel();
      if (tokenInModel) {
        tokenInModel = _.extend(tokenInModel, factoryData.tokenInEdit); // new into old
      } else {
        factoryData.accountConsentModel.push(factoryData.tokenInEdit); // pop new token onto existing array of tokens
      }
    }

    function isTokenInEditAlreadyInModel() {
      return _.find(factoryData.accountConsentModel, function (token) {
        return token._id === factoryData.tokenInEdit._id;
      });
    }

    function consentModelReadyForSave() {
      const accountConsentModel = _.map(factoryData.accountConsentModel, function (token) {
        return {
          token: token.token,
          heading: token.heading,
          text: token.text,
          symbols: _.uniq(_.map(token.symbols, 'name')),
          active: token.active
        };
      });
      return accountConsentModel;
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('ConsentAPIFactory', factory);

  factory.$inject = ['CurrentClientModelFactory', 'ClientsAPI'];
  /* ng-inject */
  function factory(CurrentClientModel, ClientsAPI) {

    return {
      getAccountConsentModel: getAccountConsentModel,
      saveAccountConsentModel: saveAccountConsentModel
    };

    function getAccountConsentModel() {
      return ClientsAPI.getConsentModel(CurrentClientModel.getCurrentClientCache()._id)
        .then(function (currentClient) {
          const rawConsentModel = currentClient.consentModel || [];
          return rawConsentModel;
        })
        .catch(function (err) {
          throw {
            message: 'Error fetching consent model',
            err: err
          };
        });
    }

    function saveAccountConsentModel(model) {
      const payload = {
        _id: CurrentClientModel.getCurrentClientCache()._id,
        consentModel: model
      };
      return ClientsAPI.postClientData(payload)
        .then(function (res) {
          if (res.status == 200) {
            return 'Account Consent Model Saved';
          }
        })
        .catch(function (err) {
          throw {
            message: 'Error saving consent model',
            err: err
          };
        });
    }

  }

}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('UserPermittedToEditGDPRSettings', factory);

  factory.$inject = ['localStorageService'];
  /* ng-inject */
  function factory(localStorage) {
    return {
      get: function (factoryData, value) {
        const valueObj = localStorage.get('userPermittedToMakeGDPREdits');
        let currentDb;
        try {
          currentDb = factoryData.currentClient.databasename;
        } catch (e) {
          currentDb = undefined;
        }
        if(!valueObj){
          return {
            permitted: false,
            expires: ''
          };
        }
        if (!valueObj.permitted) {
          return {
            permitted: false,
            expires: '',
            db: currentDb
          };
        }
        if (value) {
          return {
            permitted: value,
            expires: valueObj.expires,
            db: currentDb
          };
        }
        if (valueObj.db === currentDb) {
          return {
            permitted: true,
            expires: valueObj.expires,
            db: currentDb
          };
        } else {
          return {
            permitted: false,
            expires: '',
            db: currentDb
          };
        }
      },
      set: function (factoryData, options) {
        factoryData.userPermittedToMakeGDPREdits = {
          permitted: options.permitted,
          expires: options.expires,
          db: factoryData.currentClient.databasename
        };
        localStorage.set('userPermittedToMakeGDPREdits', {
          permitted: options.permitted,
          expires: options.expires,
          db: factoryData.currentClient.databasename,
        });
      }
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('UserPermittedToEditAccountOwner', factory);

  factory.$inject = ['localStorageService'];
  /* ng-inject */
  function factory(localStorage) {
    return {
      get: function (factoryData, value) {
        const valueObj = localStorage.get('userPermittedToEditAccountOwner');
        let currentDb;
        try {
          currentDb = factoryData.currentClient.databasename;
        } catch (e) {
          currentDb = undefined;
        }
        if(!valueObj){
          return {
            permitted: false,
            expires: ''
          };
        }
        if (!valueObj.permitted) {
          return {
            permitted: false,
            db: currentDb
          };
        }
        if (value) {
          return {
            permitted: valueObj.permitted,
            db: currentDb
          };
        }
        if (valueObj.permitted && valueObj.db === currentDb) {
          return {
            permitted: true,
            db: currentDb
          };
        } else {
          return {
            permitted: false,
            db: currentDb
          };
        }
      },
      set: function (factoryData, value) {
        factoryData.userPermittedToEditAccountOwner = {
          permitted: value,
          db: factoryData.currentClient.databasename
        };
        localStorage.set('userPermittedToEditAccountOwner', {
          permitted: value,
          db: factoryData.currentClient.databasename
        });
      }
    };
  }

}());

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('EndElevatedEditSession', factory);

  factory.$inject = ['ClientsAPI', 'MessageService', 'localStorageService', 'UserPermittedToEditAccountOwner', 'UserPermittedToEditGDPRSettings'];
  /* ng-inject */
  function factory(ClientsAPI, MessageService, localStorage, UserPermittedToEditAccountOwner, UserPermittedToEditGDPRSettings) {

    return function (factoryData) {

      validateAccountOwnerExists(factoryData)
        .then(function () {
          UserPermittedToEditAccountOwner.set(factoryData, false);
          UserPermittedToEditGDPRSettings.set(factoryData, {permitted: false, expires: ''});
          resetFailedAttemptsCount(factoryData);

          ClientsAPI.emailConsentModelToAccountOwner(factoryData.currentClient._id)
            .then(function () {
              MessageService.showMessage('Edit session ended.');
              MessageService.writeLog({
                level: 'info',
                msg: 'Vault Edit session ended for ' + factoryData.currentClient.databasename,
                tags: ['vault', 'edit_session_ending']
              });
            })
            .catch(function () {
              MessageService.showMessage('An error occured, please refresh your page and try again');
              MessageService.writeLog({
                level: 'error',
                msg: 'Error ending vault edit session for ' + factoryData.currentClient.databasename,
                tags: ['vault', 'edit_session_ending']
              });
            });
        })
        .catch(function (err){
          MessageService.writeLog({
            level: 'error',
            msg: err,
            tags: ['end_elevated_edit_session']
          });
        });
    };

    function validateAccountOwnerExists(factoryData) {
      return new Promise(function (resolve, reject) {
        if (factoryData.currentClient.accountOwner) {
          resolve('account owner set, continue');
        } else {
          reject('you must have an account owner set');
        }
      });
    }

    function resetFailedAttemptsCount(factoryData) {
      factoryData.invalidPasscodeCount = 0;
      localStorage.set('ipc', 0);
    }

  }

}());

/**
 * Created by davidbeazer on 27/09/2016.
 */

/***
Used for both managing existing client docs as well as creating new ones (new client dialog)
*/
(function () {
  'use strict';
  angular
    .module('clients')
    .component('zpClientForm', {
      templateUrl: 'app/clients/client-form/zp-client-form.tmpl.html',
      controller: 'zpClientFormController',
      bindings: {
        clientFormObj: '=',
        clientDoc: '<',
        createAccountDialog: '<'
      }
    })
    .controller('zpClientFormController', zpClientFormController);

  zpClientFormController.$inject = ['$scope', 'PermPermissionStore', 'ZuantAccountManagersFactory', 'ClientsDataFactory', 'CurrentClientModelFactory', 'MessageService', 'EnvService', 'UserService', '$log', '$state', '$filter'];
  /* ng-inject */
  function zpClientFormController($scope, PermPermissionStore, ZuantAccountManagersFactory, ClientsDataFactory, CurrentClientModelFactory, MessageService, EnvService, UserService, $log, $state, $filter) {

    var vm = this;
    vm.isClientMarketpoint = false;

    vm.timezonesConfig = {
      placeholder: 'Pick a timezone for the account',
      floatingLabel: 'Account timezone',
      required: true,
      name: 'timezone'
    };

    vm.accountStates = [
      {
        label: 'Live Client',
        value: 'live_client',
        icn: 'zmdi-account-circle'
      }, {
        label: 'Test Account',
        value: 'test_account',
        icn: 'zmdi-codepen',
      }, {
        label: 'Sales Demo Account',
        value: 'sales_demo',
        icn: 'zmdi-run'
      }, {
        label: 'Internal',
        value: 'internal',
        icn: 'zmdi-home'
      }, {
        label: 'External Contractor',
        value: 'external_contractor',
        icn: 'zmdi-store'
      }, {
        label: 'Re-seller',
        value: 'reseller',
        icn: 'zmdi-label-heart'
      }, {
        label: 'Exhibitor Account',
        value: 'exhibitor',
        icn: 'zmdi-account-box-phone'
      }, {
        label: 'Client gone-away',
        value: 'client_gone_away',
        icn: 'zmdi-block'
      }, {
        label: 'On Hold',
        value: 'hold',
        icn: 'zmdi-pause'
      }, {
        label: 'Marked for Deletion',
        value: 'delete',
        icn: 'zmdi-delete'
      }];

    vm.pricingPlans = [{
      label: 'N/A',
      value: ''
    }, {
      label: 'Special',
      value: 'special'
    }, {
      label: '2023 Classic Package',
      value: '2023_classic_package'
    }, {
      label: '2023 Pro Package',
      value: '2023_pro_package'
    }, {
      label: '2023 Enterprise Package',
      value: '2023_enterprise_package'
    }, {
      label: 'Exhibitor Package',
      value: 'exhibitor_package'
    }, {
      label: 'Ad-Hoc',
      value: 'adhoc'
    }, {
      label: 'Device Licence',
      value: 'device_license'
    }, {
      label: 'User Licence',
      value: 'user_license'
    }, {
      label: 'User Licence - Multi Account',
      value: 'user_license_multi_account'
    }, {
      label: 'Web Summit Partner',
      value: 'web_summit_partner'
    }];

    vm.$onInit = function () {

      vm.userDoc = UserService.getUserData();
      
      vm.isClientMarketpoint = UserService.isClientMarketpoint();
      vm.isDev = EnvService.isDev;
      vm.threeArrowRightHeadImageSvg = $filter('cdnAssets')('/images/svgs/utilities/arrows/3arr-right-head-only.svg');
      vm.zuantAccountManagers = ZuantAccountManagersFactory.activeZams;
      vm.zuantCustomerSuccessManagers = ZuantAccountManagersFactory.customerSuccessManagers;
      vm.disableDatabaseName = !!vm.clientDoc.companyname;
      vm.factoryData = CurrentClientModelFactory.factoryData;

      const isZuantAdmin = PermPermissionStore.getPermissionDefinition('ZUANT_ADMIN');
      isZuantAdmin.validatePermission()
        .then(function () {
          vm.isZuantAdmin = true;
        })
        .catch(function () {
          vm.isZuantAdmin = false;
        });

      if (!vm.clientDoc.passwordPolicy){
        vm.clientDoc.passwordPolicy = {
          maxLength: 16,
          minLength: 4,
          minUppercase: 0,
          minLowercase: 0,
          minNumeric: 0,
          minSymbols: 0
        };
      }

      vm.passwordPolicy = {
        maxLength: {
          value: vm.clientDoc.passwordPolicy.maxLength,
          min: vm.clientDoc.passwordPolicy.minLength,
          max: 20
        },
        minLength: {
          value: vm.clientDoc.passwordPolicy.minLength,
          min: 4,
          max: vm.clientDoc.passwordPolicy.maxLength
        },
        minUppercase: {
          value: vm.clientDoc.passwordPolicy.minUppercase,
          min: 0,
          max: calculateInitialMaximum('minUppercase'),
        },
        minLowercase: {
          value: vm.clientDoc.passwordPolicy.minLowercase,
          min: 0,
          max: calculateInitialMaximum('minLowercase')
        },
        minNumeric: {
          value: vm.clientDoc.passwordPolicy.minNumeric,
          min: 0,
          max: calculateInitialMaximum('minNumeric')
        },
        minSymbols: {
          value: vm.clientDoc.passwordPolicy.minSymbols,
          min: 0,
          max: calculateInitialMaximum('minSymbols')
        }
      };

      vm.generatedPassword = generatePassword();
      
      $scope.$on('zp.save-client-form-button-clicked', function (ev, msg) {
        vm.submitClientForm(msg);
      });

      $scope.$watch(function () { return vm.passwordPolicy.maxLength.value; }, function (newValue, oldValue){
        if (oldValue === undefined || newValue === oldValue) return;

        vm.updateChangeDelta('password_policy_maxLength', newValue);
        vm.clientDoc.passwordPolicy.maxLength = newValue;

        vm.passwordPolicy.minLength.max = newValue;

        if (newValue > oldValue){
          //increased slider
          const diff = newValue - oldValue;
          for (const key of Object.keys(vm.passwordPolicy)){
            if (key === 'minLength' || key === 'maxLength') continue;
            vm.passwordPolicy[key].max += diff;
          }

          vm.generatedPassword = generatePassword();
          return;
        }
        
        //decreased slider
        const diff = oldValue - newValue;
        let currentTotalUsed = 0;
        for (const key of Object.keys(vm.passwordPolicy)){
          if (key === 'minLength' || key === 'maxLength') continue;
          if (vm.passwordPolicy[key].max === 0) continue;
            
          vm.passwordPolicy[key].max -=diff;
          currentTotalUsed += vm.passwordPolicy[key].value;
        }

        //using more than we have
        if (currentTotalUsed > newValue){
          vm.passwordPolicy.maxLength.value = oldValue;
        }

        vm.generatedPassword = generatePassword();

      });
    };

    $scope.$watch(function () { return vm.passwordPolicy.minLength.value; }, function (newValue, oldValue){
      if (oldValue === undefined || newValue === oldValue) return;
      vm.updateChangeDelta('password_policy_minLength', newValue);
      vm.clientDoc.passwordPolicy.minLength = newValue;

      let currentTotalUsed = 0;
      for (const key of Object.keys(vm.passwordPolicy)){
        if (key === 'minLength' || key === 'maxLength') continue;
        if (vm.passwordPolicy[key].max === 0) continue;
          
        currentTotalUsed += vm.passwordPolicy[key].value;
      }

      //using more than we have
      if (currentTotalUsed > newValue){
        vm.passwordPolicy.minLength.value = oldValue;
      }

      vm.passwordPolicy.maxLength.min = newValue;
      vm.generatedPassword = generatePassword();
    });

    $scope.$watch(function () { return vm.passwordPolicy.minUppercase.value; }, calculatePasswordPolicyMaximums.bind(null, 'minUppercase'));
    $scope.$watch(function () { return vm.passwordPolicy.minLowercase.value; }, calculatePasswordPolicyMaximums.bind(null, 'minLowercase'));
    $scope.$watch(function () { return vm.passwordPolicy.minNumeric.value; }, calculatePasswordPolicyMaximums.bind(null, 'minNumeric'));
    $scope.$watch(function () { return vm.passwordPolicy.minSymbols.value; }, calculatePasswordPolicyMaximums.bind(null, 'minSymbols'));

    vm.updateChangeDelta = CurrentClientModelFactory.updateChangeDelta;

    vm.submitClientForm = function () {
      if (vm.clientFormObj.$invalid) {
        MessageService.showMessage('Form invalid');
        return;
      }

      vm.clientDoc.passwordPolicy = {
        maxLength: vm.passwordPolicy.maxLength.value,
        minLength: vm.passwordPolicy.minLength.value,
        minUppercase: vm.passwordPolicy.minUppercase.value,
        minLowercase: vm.passwordPolicy.minLowercase.value,
        minNumeric: vm.passwordPolicy.minNumeric.value,
        minSymbols: vm.passwordPolicy.minSymbols.value
      };

      //prevents saving whole client doc which could have out dated users
      const payload = {
        _id: vm.clientDoc._id,
        companyname: vm.clientDoc.companyname,
        zuantcustomersuccessmanager: vm.clientDoc.zuantcustomersuccessmanager,
        zuantaccountmanager: vm.clientDoc.zuantaccountmanager,
        accountOwner: vm.clientDoc.accountOwner,
        executiveSummaryEmails: vm.clientDoc.executiveSummaryEmails,
        eventOwner: vm.clientDoc.eventOwner,
        technicalContact: vm.clientDoc.technicalContact,
        timezone: vm.clientDoc.timezone,
        website: vm.clientDoc.website,
        notes: vm.clientDoc.notes,
        accountStatus: vm.clientDoc.accountStatus,
        pricingPlan: vm.clientDoc.pricingPlan,
        ismfaenabled: vm.clientDoc.ismfaenabled,
        ispasswordpolicyenabled: vm.clientDoc.ispasswordpolicyenabled,
        ispreventglobaluserwelcomeemail: vm.clientDoc.ispreventglobaluserwelcomeemail,
        ispreventglobaluserpasswordresetemail: vm.clientDoc.ispreventglobaluserpasswordresetemail,
        copySupportEmailsToZuantTeam: vm.clientDoc.copySupportEmailsToZuantTeam,
        ispreventimagedownload: vm.clientDoc.ispreventimagedownload,
        ispreventuserwelcomeemail: vm.clientDoc.ispreventuserwelcomeemail,
        ispreventuserpasswordresetemail: vm.clientDoc.ispreventuserpasswordresetemail,
        isBetaTestingAccount: vm.clientDoc.isBetaTestingAccount,
        isZuant3Account: vm.clientDoc.isZuant3Account,
        isUsingOldShowroom: vm.clientDoc.isUsingOldShowroom,
        GDPR: vm.clientDoc.GDPR,
        passwordPolicy: vm.clientDoc.passwordPolicy
      };

      CurrentClientModelFactory.postClientData(payload)
        .then(function () {
          MessageService.showMessage('Changes saved to ' + vm.clientDoc.companyname);
        })
        .catch(function (err) {
          MessageService.showMessage('Error: ' + err);
          MessageService.writeLog({
            level: 'error',
            msg: err
          });
        });
    };

    function calculateInitialMaximum(fieldId){
      let maximum = vm.clientDoc.passwordPolicy.maxLength;
      for (const key of Object.keys(vm.clientDoc.passwordPolicy)){
        if (key === fieldId || key === 'maxLength' || key === 'minLength') continue;
        maximum -= vm.clientDoc.passwordPolicy[key];
      }
      return maximum;
    }

    function calculatePasswordPolicyMaximums(fieldId, newValue, oldValue){
      if (oldValue === undefined || newValue === oldValue) return;

      vm.updateChangeDelta(`password_policy_${fieldId}`, newValue);
      vm.clientDoc.passwordPolicy[fieldId] = newValue;

      vm.generatedPassword = generatePassword();

      if (newValue > oldValue){
        //increased slider
        const diff = newValue - oldValue;
        let currentTotalUsed = 0;
        for (const key of Object.keys(vm.passwordPolicy)){
          if (key === 'minLength' || key === 'maxLength') continue;
          currentTotalUsed += vm.passwordPolicy[key].value;
          if (key === fieldId || vm.passwordPolicy[key].max === 0) continue;
          
          vm.passwordPolicy[key].max -= diff;
          if (vm.passwordPolicy[key].min > 0){
            if ((vm.passwordPolicy[key].min - diff) > 0){
              vm.passwordPolicy[key].min -=diff;
            } else {
              vm.passwordPolicy[key].min = 0;
            }
          }
        }

        if (currentTotalUsed > vm.passwordPolicy.minLength.value){
          vm.passwordPolicy.minLength.value = currentTotalUsed;
        }
        return;
      }
      
      //decreased slider
      const diff = oldValue - newValue;
      for (const key of Object.keys(vm.passwordPolicy)){
        if (key === 'minLength' || key === 'maxLength' || key === fieldId) continue;
        vm.passwordPolicy[key].max += diff;
      }

    }

    function generatePassword(){
      
      const SYMBOLS = '!@#$%^&*-';
      const CAPITAL_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const LOWERCASE_LETTERS = 'abcdefghijklmnopqrstuvwxyz';
      const DIGITS = '0123456789';
    
      function getRandomChar(set) {
        if (!set) return;
        return set[Math.floor(Math.random() * set.length)];
      }

      let password = '';

      // Add required characters
      for (let i = 0; i < vm.passwordPolicy.minUppercase.value; i++) {
        password += getRandomChar(CAPITAL_LETTERS);
      }
      for (let i = 0; i < vm.passwordPolicy.minLowercase.value; i++) {
        password += getRandomChar(LOWERCASE_LETTERS);
      }
      for (let i = 0; i < vm.passwordPolicy.minNumeric.value; i++) {
        password += getRandomChar(DIGITS);
      }
      for (let i = 0; i < vm.passwordPolicy.minSymbols.value; i++) {
        password += getRandomChar(SYMBOLS);
      }

      // Determine which characters to use for padding
      const paddingChars = CAPITAL_LETTERS + LOWERCASE_LETTERS + DIGITS + SYMBOLS;

      // Pad the password if necessary
      const diff = vm.passwordPolicy.maxLength.value - password.length;
      const rnd = Math.floor(Math.random() * (diff - 2)) + 1; //random number between 1 and diff
      const remainingLength = rnd > 0 ? Math.max(vm.passwordPolicy.minLength.value - password.length, rnd) : 0;
      for (let i = 0; i < remainingLength; i++) {
        password += getRandomChar(paddingChars);
      }

      // Shuffle the password characters
      password = password.split('').sort(() => Math.random() - 0.5).join('');

      return password;
    }

    vm.cancel = function () {
      $state.go('app.homescreen_app_framework.clients.home');
      $scope.$emit('zp.client-form-cancelled');
    };

    // companyname one-way binding to databasename
    vm.onCompanyNameKeyUp = function () {
      if (!(vm.disableDatabaseName) && vm.clientDoc.companyname) {
        vm.clientDoc.databasename = vm.clientDoc.companyname.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

        return ClientsDataFactory.checkClientDatabasename(vm.clientDoc.databasename)
          .then(function (res) {
            if (res.data.length) {
              $log.info('client document with db name found');
              vm.clientFormObj.databaseName.$setValidity('databaseExists', false);
              return;
            }
            
            vm.clientFormObj.databaseName.$setValidity('databaseExists', true);
          })
          .catch(function (err) {
            // MessageService.showMessage(err.data.data.message);
            MessageService.writeLog({
              level: 'error',
              msg: err,
              tags: ['checking new name error']
            });
            $scope.$emit('zp.message', {
              level: 'error',
              message: 'Error checking dbname exists: ' + err
            });
          });
      }
    };

    vm.updateTimezone = function (selected) {
      if (selected.item) {
        if (selected.item !== vm.clientDoc.timezone) {
          vm.clientDoc.timezone = selected.item || '';
          vm.updateChangeDelta('timezone', vm.clientDoc.timezone);
        }
      } else {
        vm.clientDoc.timezone = '';
        vm.updateChangeDelta('timezone', '');
      }
    };

    vm.requestPasscode = function (ev) {
      CurrentClientModelFactory.requestPasscode(ev);
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('BoltOnsFactory', factory);

  factory.$inject = ['$q', 'ClientsAPI', 'APIService', 'EncodingService', 'CurrentClientModelFactory', 'MessageService', 'CloudAppThemeFactory', '$window', 'SessionService'];
  /* ng-inject */
  function factory($q, ClientsAPI, APIService, EncodingService, CurrentClientModelFactory, MessageService, CloudAppThemeFactory, $window, Session) {

    var factoryData = {};

    buildFactory();

    function buildFactory() {
      factoryData = _.extend({}, factoryData, {
        permissions: {},
        databasename: '',
        cacheValid: false
      });
    }

    return {
      getAccountPermissions: getAccountPermissions,
      updateBoltons: updateBoltons,
      factoryData: factoryData,
      resetFactory: buildFactory,
      invalidateCache: invalidateCache
    };
    ////////////////////////////

    function getAccountPermissions(clientId, databasename) {
      return $q(function q(resolve, reject) {
        if (factoryData.databasename === databasename && factoryData.cacheValid) {
          return resolve(factoryData.permissions);
        }

        return ClientsAPI.getClientById(clientId)
          .then(function (res) {
            factoryData.permissions = res.data.data.permissions;
            factoryData.databasename = res.data.data.databasename;
            factoryData.cacheValid = true;
            return resolve(factoryData.permissions);
          })
          .catch(function (err) {
            MessageService.writeLog({
              level: 'error',
              msg: err,
              tags: ['boltons_fetch_error']
            });
            reject();
          });
      });
    }

    function updateBoltons(boltonDeltas) {
      try {
        const accountData = CurrentClientModelFactory.getCurrentClientCache();
        let customSkinsRefreshFlag = false;

        const serverDBUpdatePayload = {};

        _.each(boltonDeltas, function (boltOn) {
          if (boltOn.property === 'customSkins' && !boltOn.enabled) customSkinsRefreshFlag = true;
          factoryData.permissions.boltOns[boltOn.property].enabled = boltOn.enabled;

          serverDBUpdatePayload[`permissions.boltOns.${boltOn.property}.enabled`] = boltOn.enabled;

        });

        return APIService.postToDataApi('client/'+ EncodingService.encode(accountData._id) + '/update-boltons', serverDBUpdatePayload)
          .then(function (res) {
            return res.data;
          })
          .then(function (data) {
            MessageService.writeLog({
              level: 'info',
              msg: 'Client permissions save success. ' + boltonDeltas.length + ' boltons changed : ' + JSON.stringify(serverDBUpdatePayload),
              tags: ['boltons', 'account']
            });
            updateLocalSessionData(data);
            invalidateCache();
            if (customSkinsRefreshFlag) return boltOnsCleanUp();
            return;
          })
          .catch(function (err) {
            throw (err);
          });

      } catch (e) {
        MessageService.writeLog({
          level: 'error',
          msg: 'Error updating account subscription: ' + e.msg,
          tags: ['boltons']
        });
        MessageService.showMessage(e);
      }
    }

    function updateLocalSessionData(res) {
      const currentSessData = Session.getUserData();
      const permissionsToMerge = res.permissions;
      _.extend(currentSessData.accountPermissions, permissionsToMerge);
      Session.setUserData(currentSessData);
      // MasterPermissionsFactory.init();
    }

    function invalidateCache() {
      factoryData.cacheValid = false;
    }

    /**  Resets cloud theme if switching off customSkins bolton
     *
     */
    function boltOnsCleanUp() {
      return $q(function q(resolve, reject) {
        return CloudAppThemeFactory.refreshThemeIfNecessary()
          .then(function (res) {
            if (res.pageReloadRequired) return resolve($window.location.reload());

            return resolve();
          })
          .catch(function (err) {
            return reject(err);
          });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('BoltOnsMetadataFactory', factory);

  factory.$inject = ['$filter'];
  /* ng-inject */
  function factory($filter) {

    const factoryData = buildFactory();
    return factoryData;

    function buildFactory() {
      return {
        arrayOfBoltOns: [{
          property: 'formManagement',
          showPermissions: false,
          expandAllIcon: 'expand_more',
          icon: 'zmdi zmdi-settings',
          blurb: 'Fully customise Zuant forms via the iPad app',
          label: 'Form management',
          permissionGroups: [{
            property: 'editor',
            label: 'Form editor',
            items: [{
              label: 'Edit',
              key: 'edit'
            }]
          }, {
            property: 'predefinedLists',
            label: 'Predefined lists',
            items: [{
              label: 'View',
              key: 'view'
            }, {
              label: 'Edit',
              key: 'edit'
            }, {
              label: 'Archive',
              key: 'archive'
            }]
          }, {
            property: 'advanced',
            label: 'Advanced settings',
            permissionOnly: 'ZUANT_ADMIN',
            items: [{
              label: 'Edit database settings',
              key: 'databaseSettings'
            }]
          }]
        }, {
          property: 'ocr',
          showPermissions: false,
          expandAllIcon: 'expand_more',
          icon: 'zmdi zmdi-filter-center-focus',
          label: 'Business card scan',
          blurb: 'Use the device camera to scan biz cards',
          permissionGroups: [{
            property: 'basic',
            label: 'Basic settings',
            items: [{
              label: 'View',
              key: 'view'
            }, {
              label: 'Edit',
              key: 'edit'
            }]
          }]
        }, {
          property: 'ai',
          showPermissions: false,
          expandAllIcon: 'expand_more',
          svgicon: $filter('cdnAssets')('/images/svgs/icons/custom/ai-icon.svg'),
          label: 'Zuant AI',
          blurb: 'Enable Zuant AI features within account',
          permission: 'SUPER_ZAM',
          permissionGroups: [{
            property: 'basic',
            label: 'Basic settings',
            items: [{
              label: 'View',
              key: 'view'
            }, {
              label: 'Edit',
              key: 'edit'
            }]
          }]
        }, {
          property: 'emails',
          showPermissions: false,
          expandAllIcon: 'expand_more',
          label: 'Email',
          icon: 'zmdi zmdi-mail-send',
          blurb: 'Thank you emails and email rep features',
          permissionGroups: [{
            property: 'thankYouEmails',
            label: 'Thank you emails',
            items: [{
              label: 'View',
              key: 'view'
            }, {
              label: 'Edit',
              key: 'edit'
            }, {
              label: 'Archive',
              key: 'archive'
            }]
          }, {
            property: 'messageComposer',
            expandAllIcon: 'expand_more',
            label: 'Email Composer',
            items: [{
              label: 'View',
              key: 'view'
            }]
          }]
        }, {
          property: 'showroom',
          showPermissions: false,
          expandAllIcon: 'expand_more',
          icon: 'zmdi zmdi-desktop-mac',
          label: 'Showroom',
          blurb: 'Control what users can do with the Zuant showroom',
          permissionGroups: [{
            property: 'basic',
            label: 'Basic permissions',
            items: [{
              label: 'View',
              key: 'view'
            }, {
              label: 'Edit',
              key: 'edit'
            }, {
              label: 'Archive',
              key: 'archive'
            }]
          },{
            property: 'advanced',
            label: 'Advanced',
            items: [{
              label: 'Blocks',
              key: 'blocks'
            }]
          }]
        }, {
          property: 'customSkins',
          showPermissions: false,
          expandAllIcon: 'expand_more',
          icon: 'zmdi zmdi-palette',
          label: 'Custom Skins',
          blurb: 'Put your own stamp on Zuant with customizable background images and color palettes',
          permissionGroups: [{
            property: 'basic',
            label: 'Basic permissions',
            items: [{
              label: 'View',
              key: 'view'
            }, {
              label: 'Edit',
              key: 'edit'
            }, {
              label: 'Delete',
              key: 'delete'
            }]
          }]
        }, {
          property: 'integration',
          showPermissions: false,
          expandAllIcon: 'expand_more',
          icon: 'zmdi zmdi-swap',
          label: 'Integration',
          blurb: 'Integrate with other systems and streamline your data processing',
          permissionGroups: [{
            property: 'machines',
            label: 'Machine permissions',
            items: [{
              label: 'View',
              key: 'view'
            }, {
              label: 'Edit',
              key: 'edit'
            }, {
              label: 'Delete',
              key: 'delete'
            }]
          },{
            property: 'leadRelease',
            label: 'Advanced',
            items: [{
              label: 'Release leads',
              key: 'release'
            },{
              label: 'Edit leads',
              key: 'edit'
            }]
          },{
            property: 'loginCredentials',
            label: 'Login credentials',
            items: [{
              label: 'Manage',
              key: 'manage'
            }]
          }]
        }]
      };
    }
  }
})();

/**
 * Created by davidbeazer on 21/01/2020.
 */

/***
Used for viewing active user chart across all accounts
*/
(function () {
  'use strict';
  angular
    .module('clients')
    .component('zpActiveUsersChart', {
      templateUrl: 'app/clients/active-user-counts/tmpl.html',
      controller: 'zpActiveUsersChartCtrl',
      bindings: {}
    })
    .controller('zpActiveUsersChartCtrl', controller);

  controller.$inject = ['AccountExportsFactory', 'SessionService'];
  /* ng-inject */
  function controller(AccountExportsFactory, SessionService) {

    var vm = this;

    vm.$onInit = function () {
      vm.groupSize = 'month';
      vm.groupSizeOptions = ['day', 'month', 'year'];
      vm.title = '2020';
      // vm.title = moment().format('MMMM');
      vm.chartInfo = {
        data: [],
        labels: [],
        series: [],
        chartType: 'bar',
        chartOptions: {
          legend: {
            interactive: true,
            display: false
          }
        }
      };
      vm.menuWidth = 3;
      vm.menuOptions = [{
        onClick: 'day',
        ariaLabel: function () {
          return 'Change group size';
        },
        label: function () {
          return 'Day';
        }
      }, {
        onClick: 'month',
        ariaLabel: function () {
          return 'Change group size';
        },
        label: function () {
          return 'Month';
        }
      }/*, {
        onClick: 'year',
        ariaLabel: function () {
          return 'Change group size';
        },
        label: function () {
          return 'Year';
        }
      }*/];

      vm.run();
    };

    vm.run = () => {
      vm.loading = true;
      AccountExportsFactory.createActiveUsersChart({ groupSize: vm.groupSize, ci: SessionService.getUserData().clientId })
        .then(res => {
          vm.loading = false;
          vm.content = res;
          vm.chartInfo = _.extend({}, vm.chartInfo, res);
        })
        .catch(err => {
          vm.loading = false;
          vm.content = err;
        });
    };

    vm.onMenuClick = function (opts) {

      switch (opts.action) {
        case 'day':
          vm.groupSize = 'day';

          break;

        case 'month':
          vm.groupSize = 'month';
      }

      vm.run();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('bizcard')
    .component('zpCardFilter', {
      controller: 'CardFilterCtrl',
      templateUrl: 'app/biz-card/zp-card-filter/zp-card-filter.tmpl.html',
      bindings: {}
    })
    .controller('CardFilterCtrl', controller);

  controller.$inject = ['BusinessCardModelFactory'];
  /* ng-inject */
  function controller(BusinessCardModelFactory) {

    var vm = this;

    vm.$onInit = function () {
      vm.factoryData = BusinessCardModelFactory.factoryData;
    };

  }
}());

(function() {
  'use strict';

  angular
    .module('bizcard')
    .component('zpCardCountsByClient', {
      templateUrl: 'app/biz-card/zp-card-counts-by-client/template.html',
      controller: 'zpCardCountsByClientCtrl',
      bindings: {}
    })
    .controller('zpCardCountsByClientCtrl', ctrl);

  ctrl.$inject = ['BusinessCardModelFactory'];
  /* ng-inject */
  function ctrl(BusinessCardModelFactory){

    var vm = this;

    vm.$onInit = function (){
      vm.data = BusinessCardModelFactory.factoryData.cardsCountsByClient;
      vm.showCard = BusinessCardModelFactory.factoryData;
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('bizcard')
    .component('zpBizcardStatWidgets', {
      controller: 'BizcardStatWidgetsCtrl',
      templateUrl: 'app/biz-card/zp-bizcard-stat-widgets/zp-bizcard-stat-widgets.tmpl.html',
      bindings: {}
    })
    .controller('BizcardStatWidgetsCtrl', controller);

  controller.$inject = ['BusinessCardModelFactory', 'UserAvatarFactory', '$timeout'];
  /* ng-inject */
  function controller(BusinessCardModelFactory, UserAvatarFactory, $timeout) {

    var vm = this;
    vm.loading = true;
    vm.$onInit = function () {

      vm.factoryData = BusinessCardModelFactory.factoryData;

      buildFilters();
      $timeout(function () {
        vm.loading = false;
      }, 500);
    };

    function buildFilters() {

      if (!_.isEmpty(BusinessCardModelFactory.factoryData.cardSelectionParamaters.users)) {
        vm.usersFilter = _.map(BusinessCardModelFactory.factoryData.cardSelectionParamaters.users, function (user) {
          return {
            email: user._id,
            username: user.username,
            avatar: ''
          };
        });

        vm.usersFilter.forEach(function (user) {
          UserAvatarFactory.getAvatar(user.email)
            .then(function (res) {
              user.userAvatarStyle = {
                backgroundColor: '#fec353',
                lineHeight: '40px',
                color: 'white',
                textAlign: 'center',
                backgroundSize: 'cover',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                display: 'block'
              };
              if (res) {
                user.userAvatarStyle.backgroundImage = 'url(' + res.avatar + ')';
              } else {
                user.textAvatar = 'Ka';
              }
            });
        });

      }

      if (!_.isEmpty(BusinessCardModelFactory.factoryData.cardSelectionParamaters.forms)) {
        vm.formsFilter = _.map(BusinessCardModelFactory.factoryData.cardSelectionParamaters.forms, function (form) {
          return {
            formname: form.formname
          };
        });
      }
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('bizcard')
    .component('zpBizcardProcessor', {
      templateUrl: 'app/biz-card/zp-bizcard-processor/zp-bizcard-processor.tmpl.html',
      controller: 'BizcardProcessorController',
      bindings: {
        leadData: '<',
        updateChangeDelta: '&',
        loadingCardData: '<',
        emptyPotMessage: '<',
        bizcardimage: '<',
        responseImages: '<',
        rejectCard: '&',
        cardDataStyles: '<',
        imageContainerStyles: '<',
        skip: '<',
        getNextCard: '&'
      }
    })
    .controller('BizcardProcessorController', controller);

  controller.$inject = ['PanZoomService', 'SessionService', '$state'];
  /* ng-inject */
  function controller(PanZoomService, session, $state) {

    var vm = this;

    vm.$onInit = function () {
      vm.angle = 0;
      vm.userName = session.getUserData().email;
    };

    // panzoomconfig and panzoommodel objects are required by the angular-pan-zoom directive
    vm.panzoomconfig = {
      zoomOnMouseWheel: false,
      zoomOnDoubleClick: false,
      panOnClickDrag: true,
      keepInBounds: false,
      scalePerZoomLevel: 1.4,
      zoomLevels: 7,
      neutralZoomLevel: 3
    };

    vm.panzoommodel = {};

    // you can now invoke the api
    vm.zoomIn = function () {
      PanZoomService.getAPI('panzoomId').then(function (api) {
        api.zoomIn();
      });
    };

    vm.zoomOut = function () {
      PanZoomService.getAPI('panzoomId').then(function (api) {
        api.zoomOut();
      });
    };

    vm.rotate = function (direction) {
      if (direction === 'left') {
        vm.angle -= 90;
      } else {
        vm.angle += 90;
      }
      if (vm.angle === -360 || vm.angle === 360) {
        vm.angle = 0;
      }
    };

    vm.selectImage = function (image) {
      vm.bizcardimage = image;
    };

    vm.goToCardFilterScreen = function (){
      $state.go('app.homescreen_app_framework_no_sidebar.bizcard.grouped-cards-view');
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('bizcard')
    .component('zpBizcardMetadata', {
      controller: 'BizcardMetadataController',
      templateUrl: 'app/biz-card/zp-bizcard-metadata/zp-bizcard-metadata.tmpl.html',
      bindings: {
        contact: '<'
      }
    })
    .controller('BizcardMetadataController', controller);

  controller.$inject = ['$log'];
  /* ng-inject */
  function controller($log) {
    var vm = this;

    vm.$onInit = function () {
      $log.info('onInit bizcard metadata');
    };
  }
}());

(function () {
  'use strict';

  function enumsSvc() {

    var processType = {
      UNPROCESSED: 0,
      UNPROCESSABLE: 1,
      PROCESSED: 2
    };

    var groupType = {
      CLIENT: 0,
      EVENT: 1,
      USER: 2
    };

    return {
      processType: processType,
      groupType: groupType
    };
  }

  angular
    .module('bizcard')
    .factory('enumsSvc', [enumsSvc]);
})();

(function () {
  'use strict';
  angular
    .module('bizcard')
    .factory('dbAccessSvc', dbAccess);

  dbAccess.$inject = ['APIService', 'APIFactory'];

  function dbAccess(api, apiFactory) {

    var bizcardApi = apiFactory.route('bizcard');

    return {
      deallocateBizCard: deallocateBizCard,
      cardStillAssignedToUser: cardStillAssignedToUser,
      getImage: getImage,
      getNextCardToProcess: getNextCardToProcess,
      getBusinessCardDataAggregation: getBusinessCardDataAggregation,
      saveBizCardData: saveBizCardData,
      rejectBizCard: rejectBizCard,
      aggregateCardsByClient: aggregateCardsByClient
    };

    function getBusinessCardDataAggregation(userClientList) {

      var params = {
          clientList: userClientList
        },
        apiUrl = 'businesscarddataAggregation';

      return bizcardApi.post(apiUrl, params);

    }

    function getNextCardToProcess(paramsObj) {

      var params = {
          dbQueryParams: paramsObj.dbQueryParams
        },
        apiUrl = 'nextcardtoprocess';
      return bizcardApi.post(apiUrl, params);
    }

    function deallocateBizCard(cardId) {
      var params = {
          cardId: cardId
        },
        apiUrl = 'deallocatecard';

      return bizcardApi.post(apiUrl, params);
    }

    //  check if the card is still allocated to the user
    function cardStillAssignedToUser(params) {
      var apiUrl = 'cardstillassignedtouser';
      return bizcardApi.post(apiUrl, params);
    }

    function getImage(db, imageId) {
      var params = {
          dbName: db,
          imageid: imageId
        },
        apiUrl = 'getimage';

      return bizcardApi.post(apiUrl, params);

    }

    function saveBizCardData(params) {
      var apiUrl = params.apiUrl;
      return bizcardApi.post(apiUrl, params);
    }

    function rejectBizCard(params) {
      var apiUrl = 'rejectBizCard';
      return bizcardApi.post(apiUrl, params);
    }

    function aggregateCardsByClient(params) {
      var apiUrl = 'aggregateCardsByClient';

      return bizcardApi.post(apiUrl, params);
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('bizcard')
    .factory('BusinessCardModelFactory', BusinessCardModelFactory);

  BusinessCardModelFactory.$inject = ['$log', '$q', 'dbAccessSvc', 'enumsSvc', 'MessageService', 'DeltaAPI', 'SessionService', '$cookies', 'UserAvatarFactory', 'localStorageService'];
  /* ng-inject */
  function BusinessCardModelFactory($log, $q, dbAccessSvc, enums, MessageService, DeltaAPI, session, $cookies, UserAvatarFactory, localStorageService) {

    var factoryData = {
      zeroCardsLeftToProcess: false,
      cardCurrentlyBeingEdited: {
        email: ''
      },
      cardSelectionParamaters: hydrateCardSelectionParamaters(),
      cardsLeftToProcessForCurrentSelectionQuery: null,
      cardViewFilters: {
        users: [],
        forms: []
      },
      cardsGroupedByUser: [],
      cardsGroupedByForm: [],
      cardsCountsByClient: [],
      showCardCountsCard: true
    };

    setCardSelectionFiltersForViews(); // hydrates the filters widget

    return {
      getBusinessCardDataAggregation: getBusinessCardDataAggregation,
      getNextCardToProcess: getNextCardToProcess,
      clearAllSelectedCards: clearAllSelectedCards,
      setFactoryCardSelectionParamaters: setFactoryCardSelectionParamaters,
      getImage: getImage,
      saveBizcardData: saveBizcardData,
      deallocateBizCard: deallocateBizCard,
      rejectBizCard: rejectBizCard,
      aggregateCardsByClient: aggregateCardsByClient,
      factoryData: factoryData
    };

    function getBusinessCardDataAggregation(userClientList) {

      // GET an aggregation of all biz cards to be processed (counts by event and counts by users)
      return $q(
        function q(resolve, reject) {
          dbAccessSvc.getBusinessCardDataAggregation(userClientList)
            .then(function (responseData) {
              factoryData.cardsGroupedByUser = responseData.data.users;
              factoryData.cardsGroupedByForm = responseData.data.forms;
              setCardSelectionFiltersForViews();
              resolve(factoryData);
            })
            .catch(function (err) {
              reject({
                msg: err
              });
            });
        }
      );

    }

    function getNextCardToProcess(skip) {

      var params = {
        dbQueryParams: buildQueryParams(skip)
      };

      return $q(
        function q(resolve, reject) {
          dbAccessSvc.getNextCardToProcess(params)
            .then(function (res) {

              factoryData.cardsLeftToProcessForCurrentSelectionQuery = res.data.stats;
              factoryData.zeroCardsLeftToProcess = res.data.stats === 0 ? true : false;

              MessageService.pushEventToIntercom('get_next_biz_card_to_process', {
                cardsLeftToProcess: res.data.stats
              });

              if (res.data.cardData === 'No cards left to process') {
                factoryData.cardCurrentlyBeingEdited = null;
                reject({
                  message: res.data.cardData
                });
              } else if (res.data.msg === 'Contact not found. Have you run a CRM data removal?') {
                factoryData.cardCurrentlyBeingEdited = {
                  bizcardId: res.data.cardData.cardToProcess._id,
                  _initialcreatedatelocalutc: res.data.cardData.cardToProcess.createddate
                };
                resolve({
                  bizcardId: res.data.cardData.cardToProcess._id,
                  clientid: res.data.cardData.cardToProcess.clientid,
                  clientdb: res.data.cardData.cardToProcess.clientdb
                });
              } else {
                factoryData.cardCurrentlyBeingEdited = _.extend({}, contactModel(), res.data.cardData);
                resolve(factoryData.cardCurrentlyBeingEdited);
              }
            })
            .catch(function (err) {
              if (err.data.data) {
                localStorageService.set('serverErrorObject', err.data.data);
                reject({
                  status: 500,
                  message: err.data.data.message
                });
              }
            });
        }
      );

    }

    function clearAllSelectedCards() {

      factoryData.cardSelectionParamaters.forms = {};
      factoryData.cardSelectionParamaters.users = {};

      $cookies.putObject('cardSelectionParamaters-forms', {});
      $cookies.putObject('cardSelectionParamaters-users', {});

      factoryData.cardsGroupedByForm.forEach(function (obj) {
        obj.selected = false;
      });

      factoryData.cardsGroupedByUser.forEach(function (obj) {
        obj.selected = false;
      });
      setCardSelectionFiltersForViews();
    }

    function setFactoryCardSelectionParamaters(widget, groupType) {

      var value = widget.selected;

      factoryData.cardSelectionParamaters.clientdbs = [session.getUserData().databasename];

      switch (groupType) {
        case enums.groupType.EVENT: // 1
          if (value) {
            $log.info('adding event with id: ' + widget._id + ' to filter object');
            factoryData.cardSelectionParamaters.forms[widget._id] = {
              _id: widget._id,
              formname: widget.formname,
              selected: true
            };
          } else {
            $log.info('removing event with id: ' + widget._id + ' from filter object');
            delete factoryData.cardSelectionParamaters.forms[widget._id];
          }
          break;

        case enums.groupType.USER: // 2
          if (value) {
            $log.info('adding user with email: ' + widget.email + ' to filter object');
            factoryData.cardSelectionParamaters.users[widget.email] = {
              _id: widget.email,
              username: widget.name,
              selected: true
            };
          } else {
            $log.info('removing user with email: ' + widget.email + ' from filter object');
            delete factoryData.cardSelectionParamaters.users[widget.email];
          }
          break;
      }

      $cookies.putObject('cardSelectionParamaters-client', factoryData.cardSelectionParamaters.clientdbs);
      $cookies.putObject('cardSelectionParamaters-forms', factoryData.cardSelectionParamaters.forms);
      $cookies.putObject('cardSelectionParamaters-users', factoryData.cardSelectionParamaters.users);

      $log.info('finished updating card selection paramaters');
      $log.info(factoryData.cardSelectionParamaters);

      setCardSelectionFiltersForViews();

    }

    function getImage(db, imageid) {

      MessageService.writeLog({
        level: 'info',
        msg: 'Web-client requesting image with id ' + imageid,
        tags: ['biz_card']
      });

      var requestStartTime = moment(); // for logging

      return $q(function q(resolve, reject) {
        dbAccessSvc.getImage(db, imageid)
          .then(function (res) {
            var requestEndTime = moment();
            var reqDuration = moment.duration(requestEndTime.diff(requestStartTime));
            MessageService.writeLog({
              level: 'info',
              msg: 'Web-client received image with id ' + imageid + ' after ' + reqDuration + ' milliseconds',
              tags: ['biz_card']
            });
            resolve(res.data);
          })
          .catch(function (err) {
            MessageService.writeLog({
              level: 'error',
              msg: 'Failed to getImage from server',
              err: err,
              tags: ['biz_card']
            });
            reject(err);
          });
      });
    }

    function saveBizcardData(params) {

      MessageService.writeLog({
        level: 'info',
        msg: 'Web-client requesting saveBizcardData: cardId = ' + params.cardId,
        tags: ['biz_card']
      });

      MessageService.pushEventToIntercom('save_biz_card', {
        world: 'new world'
      });

      var ro = {};
      params.apiUrl = 'saveBizCardDataNewWorld';
      return $q(
        function (resolve, reject) {

          return dbAccessSvc.saveBizCardData(params)
            .then(function (res) {
              ro.saveResponse = res;
              return DeltaAPI.postDeltas(params.changeDeltas);
            })
            .then(function (res) {
              ro.postDeltasResult = res;
              MessageService.writeLog({
                level: 'info',
                msg: '🌍 NEW WORLD biz card data saved to data API. cardId = ' + params.cardId,
                tags: ['biz_card']
              });
              resolve(ro);
            })
            .catch(function (err) {
              MessageService.writeLog({
                level: 'error',
                msg: 'Failed to saveBizCardData to server. cardId = ' + params.cardId,
                err: err,
                tags: ['biz_card']
              });
              reject(err);
            });
        }
      );
    }

    function rejectBizCard(params) {
      return $q(
        function q(resolve, reject) {
          dbAccessSvc.rejectBizCard(params)
            .then(function (res) {
              MessageService.writeLog({
                level: 'info',
                msg: 'bizcard rejected: ' + params.cardMetadata.imageQuality,
                tags: ['biz_card']
              });
              MessageService.pushEventToIntercom('reject_biz_card', {
                rejectReason: params.cardMetadata.imageQuality
              });
              resolve(res);
            })
            .catch(function (err) {
              MessageService.writeLog({
                level: 'error',
                msg: 'Failed to reject bizcard on server',
                err: err,
                tags: ['biz_card']
              });

              reject(err);
            });
        }
      );
    }

    function deallocateBizCard(id) {
      return $q(
        function q(resolve, reject) {
          dbAccessSvc.deallocateBizCard(id)
            .then(function (res) {
              MessageService.writeLog({
                level: 'info',
                msg: 'bizcard deallocated. cardId = ' + id,
                tags: ['biz_card']
              });
              resolve(res);
            })
            .catch(function (err) {
              MessageService.writeLog({
                level: 'error',
                msg: 'Failed to deallocate bizcard on server',
                err: err,
                tags: ['biz_card']
              });

              reject(err);
            });
        }
      );
    }

    function aggregateCardsByClient() {
      return $q(
        function q(resolve, reject) {
          dbAccessSvc.aggregateCardsByClient()
            .then(function (res) {
              MessageService.writeLog({
                level: 'info',
                msg: 'back from aggregate cards to process pot by client',
                tags: ['biz_card']
              });
              if (res.data[0]) {
                factoryData.cardsCountsByClient = res.data[0].counts;
              }
              resolve(res);
            })
            .catch(function (err) {
              MessageService.writeLog({
                level: 'error',
                msg: 'Failed to aggregate cards to processpot',
                err: err,
                tags: ['biz_card']
              });

              reject(err);
            });
        }
      );
    }

    // PRIVATE HELPER FUNCTIONS

    function hydrateCardSelectionParamaters() {
      var ro,
        clientdbscookie = $cookies.getObject('cardSelectionParamaters-client');
      if (!clientdbscookie) {
        ro = {
          clientdbs: [session.getUserData().databasename],
          users: {},
          forms: {}
        };
        return ro;
      }
      if (clientdbscookie[0] === session.getUserData().databasename) {
        ro = {
          clientdbs: $cookies.getObject('cardSelectionParamaters-client'),
          users: $cookies.getObject('cardSelectionParamaters-users') || {},
          forms: $cookies.getObject('cardSelectionParamaters-forms') || {}
        };
      } else {
        ro = {
          clientdbs: [session.getUserData().databasename],
          users: {},
          forms: {}
        };
      }
      return ro;
    }

    function setCardSelectionFiltersForViews() {
      var usersFilter = _.map(factoryData.cardSelectionParamaters.users, function (user) {
        return {
          email: user._id,
          username: user.username,
          avatar: '',
          selected: user.selected
        };
      });

      factoryData.cardViewFilters.users = usersFilter;

      factoryData.cardViewFilters.users = _.filter(usersFilter, function (user) {
        return _.find(factoryData.cardsGroupedByUser, function (u2) {
          if (user.email === u2.email) {
            u2.selected = true;
            return true;
          } else {
            return false;
          }
        });
      });

      usersFilter.forEach(function (user) {
        UserAvatarFactory.getAvatar(user.email)
          .then(function (res) {
            user.userAvatarStyle = {};
            if (res) {
              user.userAvatarStyle.backgroundImage = 'url(' + res.avatar + ')';
            } else {
              user.textAvatar = true;
            }
          });
      });

      factoryData.cardViewFilters.forms = _.map(factoryData.cardSelectionParamaters.forms, function (form) {
        return {
          formname: form.formname,
          selected: form.selected
        };
      });

      factoryData.cardViewFilters.forms = _.filter(factoryData.cardsGroupedByForm, function (form) {
        return _.find(factoryData.cardSelectionParamaters.forms, function (f2) {
          if (form.formname === f2.formname) {
            form.selected = true;
            return true;
          } else {
            return false;
          }
        });
      });

    }

    function buildQueryParams(skip) {
      // builds the query params shaped for the server
      var params = {
        _bureauuseremail: session.getUserData().email,
        clientdbs: factoryData.cardSelectionParamaters.clientdbs,
        forms: _.map(factoryData.cardSelectionParamaters.forms, function (form) {
          return form._id;
        }),
        users: _.map(factoryData.cardSelectionParamaters.users, function (user) {
          return user._id;
        })
      };

      if (skip) {
        params.skip = {
          _idofcardtoskip: factoryData.cardCurrentlyBeingEdited.bizcardId,
          _initialcreatedatelocalutc: factoryData.cardCurrentlyBeingEdited._initialcreatedatelocalutc
        };
      }
      return params;
    }

    function contactModel() {
      return {
        firstname: '',
        lastname: '',
        email: '',
        companyname: ''
      };
    }
  }
})();

(function () {
  'use strict';

  function rotate() {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        scope.$watch(attrs.degrees, function (rotateDegrees) {
          var r = 'rotate(' + rotateDegrees + 'deg)';
          element.css({
            '-moz-transform': r,
            '-webkit-transform': r,
            '-o-transform': r,
            '-ms-transform': r
          });
        });
      }
    };
  }

  angular
    .module('bizcard')
    .directive('rotate', ['$log', rotate]);
})();

/**
 * Created by davidbeazer on 06/11/2015.
 */
(function () {
  'use strict';

  ZuantWizardDialogController.$inject = ['$mdDialog'];
  angular
    .module('bizcard')
    .controller('ZuantWizardDialogController', ZuantWizardDialogController);

  /* @ngInject */
  function ZuantWizardDialogController($mdDialog) {
    var vm = this;
    vm.cancel = cancel;
    vm.title = 'Add dialog';
    vm.confirm = confirm;

    function cancel() {
      $mdDialog.cancel();
    }

    function confirm() {
      $mdDialog.hide();
    }

  }
})();

/**
 * Created by davidbeazer on 06/11/2015.
 */
(function () {
  'use strict';

  ZuantAddDialogController.$inject = ['$filter', '$mdDialog'];
  angular
    .module('bizcard')
    .controller('ZuantAddDialogController', ZuantAddDialogController);

  /* @ngInject */
  function ZuantAddDialogController($filter, $mdDialog) {
    var vm = this;
    vm.cancel = cancel;
    vm.title = 'Add dialog';
    vm.confirm = confirm;

    function cancel() {
      $mdDialog.cancel();
    }

    function confirm() {
      $mdDialog.hide();
    }

  }
})();

(function() {
  'use strict';
    
  angular
    .module('authentication')
    .component('zpUpdatePasswordPage', {
      templateUrl: 'app/authentication/update-password/update-password.component.tmpl.html',
      controller: 'UpdatePasswordController',
      bindings: {
        layout: '@',
        layoutFill: '@',
        zuantLogoURL: '@',
        databasename: '@',
        userId: '@',
        passwordPolicy: '<'
      }
    })
    .controller('UpdatePasswordController', ctrl);
  
  ctrl.$inject = ['AuthService', 'MessageService'];
  /* ng-inject */
  function ctrl(AuthService, MessageService) {
    
    const vm = this;
    vm.activePolicy = {};

    vm.passwordFieldIcon = 'zmdi-eye-off';
    vm.passwordFieldType = 'password';
    vm.passwordFieldTooltip = 'Show password';
    vm.passwordFormFieldValue = null;

    vm.confirmPasswordFieldIcon = 'zmdi-eye-off';
    vm.confirmPasswordFieldType = 'password';
    vm.confirmPasswordFieldTooltip = 'Show password';
    vm.confirmPasswordFormFieldValue = null;

    vm.passwordUpdateComplete = false;

    vm.$onInit = function () {
      for (const key of Object.keys(vm.passwordPolicy)){

        if (vm.passwordPolicy[key] > 0){

          let label = null;
          let regex = null;
          switch (key){
            case 'minLength':
              label = 'Minimum Password Length:';
              break;
            case 'maxLength':
              label = 'Maximum Password Length';
              break;
            case 'minUppercase':
              label = 'Minimum Number Of Upercase Characters:';
              regex = `^(?=(?:.*[A-Z]){${vm.passwordPolicy[key]},}).*$`;
              break;
            case 'minLowercase':
              label = 'Minimum Number Of Lowercase Characters:';
              regex = `^(?=(?:.*[a-z]){${vm.passwordPolicy[key]},}).*$`;
              break;
            case 'minNumeric':
              label = 'Minimum Number Of Numeric Characters ([0-9]):';
              // eslint-disable-next-line no-useless-escape
              regex = `^(?=(?:.*\\d){${vm.passwordPolicy[key]},}).*$`;
              break;
            case 'minSymbols':
              label = 'Minimum Number Of Symbol Characters (!@#$%^&*-):';
              regex = `^(?=(?:.*[!@#$%^&*-]){${vm.passwordPolicy[key]},}).*$`;
              break;
            default:
              throw new Error('Invalid Policy');
          }

          vm.activePolicy[key] = {
            key,
            label,
            regex,
            value: vm.passwordPolicy[key]
          };
        }
      }
    };

    vm.toggleViewPasswordField = function (field){
      vm[`${field}FieldIcon`] = vm[`${field}FieldIcon`] === 'zmdi-eye-off' ? 'zmdi-eye' : 'zmdi-eye-off';
      vm[`${field}FieldType`] = vm[`${field}FieldType`] === 'password' ? 'text' : 'password';
      vm[`${field}FieldTooltip `] = vm[`${field}FieldTooltip `] === 'Show password' ? 'Hide password' : 'Show password';
    };

    vm.checkAgainstPasswordPolicy = function (field){

      vm.updateFormObj.confirmpassword.$setValidity('nonMatch', true);
      vm.updateFormObj.password.$setValidity('nonMatch', true);
      vm.updateFormObj.password.$setValidity('invalidCharacters', true);

      if (field === 'confirmPassword'){
        if (vm.confirmPasswordFormFieldValue !== vm.passwordFormFieldValue && (!!vm.passwordFormFieldValue && vm.passwordFormFieldValue.length > 0)){
          vm.updateFormObj.confirmpassword.$setValidity('nonMatch', false);
        }
        return;
      }

      if (vm.passwordFormFieldValue !== vm.confirmPasswordFormFieldValue && (!!vm.confirmPasswordFormFieldValue && vm.confirmPasswordFormFieldValue.length > 0)){
        vm.updateFormObj.password.$setValidity('nonMatch', false);
        return;
      }

      const recognisedCharactersRegex = new RegExp(/^[A-Za-z\d!@#$%^&*-]*$/);

      if (!(recognisedCharactersRegex.test(vm.passwordFormFieldValue))){
        vm.updateFormObj.password.$setValidity('invalidCharacters', false);
        return;
      }

      for (const key of Object.keys(vm.activePolicy)){
        const policy = vm.activePolicy[key];
        vm.updateFormObj.password.$setValidity(key, false);

        if (!policy.regex){
          switch (key){
            case 'minLength':
              if (vm.passwordFormFieldValue && vm.passwordFormFieldValue.length >= policy.value){
                vm.updateFormObj.password.$setValidity(key, true);
              }
              break;
            case 'maxLength':
              if (vm.passwordFormFieldValue && vm.passwordFormFieldValue.length <= policy.value){
                vm.updateFormObj.password.$setValidity(key, true);
              }
              break;
          }
          continue;
        }

        const regex = new RegExp(policy.regex);
        const valid = regex.test(vm.passwordFormFieldValue);
        vm.updateFormObj.password.$setValidity(key, valid);
      }
    };
  
    vm.submitUpdatePasswordForm = function (){
      return AuthService.updatePassword(vm.databasename, vm.userId, vm.passwordFormFieldValue)
        .then(function (resp){
          MessageService.showMessage(resp.data.message);
          vm.passwordUpdateComplete = true;
        })
        .catch(function (error){
          if (error.status === -1) return MessageService.showMessage('Server Error: server returned status code -1.');

          const msg = _.get(error, ['data', 'error'], 'Failed to update password');
          MessageService.showMessage(msg);
        });
    };
  
  }
    
}());
    
(function() {
  'use strict';
  
  angular
    .module('authentication')
    .component('zpLoginPage', {
      templateUrl: 'app/authentication/login/login.tmpl.html',
      controller: 'LoginController',
      bindings: {
        layout: '@',
        layoutFill: '@',
        appSettings: '<',
        zuantLogoURL: '@'
      }
    })
    .controller('LoginController', ctrl);

  ctrl.$inject = ['$scope', '$state', 'ZPPages', 'AuthService', 'SessionService', 'UserGreetingService', 'MasterPermissionsFactory', 'UserPermissionsHelperFactory', 'SendThankYouEmailIntegrityCheck', 'MessageService', 'localStorageService'];
  /* ng-inject */
  function ctrl($scope, $state, ZPPages, AuthService, SessionService, UserGreetingService, MasterPermissionsFactory, UserPermissionsHelperFactory, SendThankYouEmailIntegrityCheck, MessageService, localStorageService) {

    const vm = this;
    vm.loading = false;

    vm.$onInit = function () {
      vm.user = {
        email: localStorageService.get('usernameStore') || '',
        password: '',
        passwordrepeat: '',
        rememberMe: localStorageService.get('rememberMe')
      };
    };

    vm.loginClick = function () {
      vm.loading = true;

      const value = localStorageService.get('rememberMe');
      if (value) {
        localStorageService.set('usernameStore', vm.user.email);
      } else if (!value && localStorageService.get('usernameStore')) {
        localStorageService.remove('usernameStore');
      }

      return AuthService.authenticateUser(vm.user.email, vm.user.password)
        .then(function (res) {
          const data = res.data.data;
          const userData = data.user;

          UserGreetingService.setDisplayUserGreeting(true);

          SessionService.setUserData(userData);
          ZPPages.updateVariablePagePaths(userData.clientId);

          MasterPermissionsFactory.init();
          UserPermissionsHelperFactory.init();

          MessageService.writeLog({
            level: 'info',
            msg: vm.user.email + ' has successfully logged in',
            tags: ['auth']
          });

          vm.loading = false;

          $scope.$emit('zp.login.success');
          $scope.$emit('zp.intercom-boot', userData);

          return SendThankYouEmailIntegrityCheck.runCheckOnAccount();
        })
        .catch(function (error) {
          vm.loading = false;

          if (error.status === -1) return MessageService.showMessage('Server Error: server returned status code -1.');

          const err = _.get(error, ['data', 'data', 'error'], { message: 'An unknown error occurred' });

          if (error.status === 403) {
            const data = _.get(error, ['data', 'data'], {});
            switch (err.code){
              case 'USER_NOT_PERMITTED_TO_LOGIN':
                vm.notPermittedToEnterCloud = true;
                MessageService.showMessage(err.message);
                break;
              case 'MFA_SETUP_REQUIRED':
                $state.go('mfa.setup', {
                  databasename: data.databasename,
                  userId: data.userId,
                  email: vm.user.email
                });
                break;
              case 'MFA_ACCESS_CODE_REQUIRED':
                $state.go('mfa.verification', {
                  databasename: data.databasename, 
                  userId: data.userId,
                  email: vm.user.email
                });
                break;
              case 'PASSWORD_UPDATE_DOES_NOT_MATCH_POLICY':
                $state.go('update-password', {
                  databasename: data.databasename, 
                  userId: data.userId,
                  passwordPolicy: data.passwordPolicy
                });
                break;
            }
            return;
          }

          MessageService.showMessage(err.message);
        });
  
    };

  }
  
}());
  
(function() {
  'use strict';
  
  angular
    .module('authentication')
    .component('zpResetPasswordPage', {
      templateUrl: 'app/authentication/forgot/reset.tmpl.html',
      controller: 'ResetPasswordController',
      bindings: {
        layout: '@',
        layoutFill: '@',
        zuantLogoURL: '@',
        linkIsValid: '<',
        passwordPolicy: '<',
        clientId: '<',
        userId: '<',
        resetId: '<'
      }
    })
    .controller('ResetPasswordController', ctrl);

  ctrl.$inject = ['PasswordResetFactory', 'MessageService'];
  /* ng-inject */
  function ctrl(PasswordResetFactory, MessageService) {
  
    const vm = this;
    vm.activePolicy = {};

    vm.passwordFieldIcon = 'zmdi-eye-off';
    vm.passwordFieldType = 'password';
    vm.passwordFieldTooltip = 'Show password';
    vm.passwordFormFieldValue = null;

    vm.confirmPasswordFieldIcon = 'zmdi-eye-off';
    vm.confirmPasswordFieldType = 'password';
    vm.confirmPasswordFieldTooltip = 'Show password';
    vm.confirmPasswordFormFieldValue = null;

    vm.passwordResetComplete = false;

    vm.$onInit = function(){
      vm.hasPasswordPolicy = Object.keys(vm.passwordPolicy).length > 0;
      for (const key of Object.keys(vm.passwordPolicy)){

        if (vm.passwordPolicy[key] > 0){

          let label = null;
          let regex = null;
          switch (key){
            case 'minLength':
              label = 'Minimum Password Length:';
              break;
            case 'maxLength':
              label = 'Maximum Password Length';
              break;
            case 'minUppercase':
              label = 'Minimum Number Of Upercase Characters:';
              regex = `^(?=(?:.*[A-Z]){${vm.passwordPolicy[key]},}).*$`;
              break;
            case 'minLowercase':
              label = 'Minimum Number Of Lowercase Characters:';
              regex = `^(?=(?:.*[a-z]){${vm.passwordPolicy[key]},}).*$`;
              break;
            case 'minNumeric':
              label = 'Minimum Number Of Numeric Characters ([0-9]):';
              // eslint-disable-next-line no-useless-escape
              regex = `^(?=(?:.*\\d){${vm.passwordPolicy[key]},}).*$`;
              break;
            case 'minSymbols':
              label = 'Minimum Number Of Symbol Characters (!@#$%^&*-):';
              regex = `^(?=(?:.*[!@#$%^&*-]){${vm.passwordPolicy[key]},}).*$`;
              break;
            default:
              throw new Error('Invalid Policy');
          }

          vm.activePolicy[key] = {
            key,
            label,
            regex,
            value: vm.passwordPolicy[key]
          };
        }
      }
    };

    vm.toggleViewPasswordField = function (field){
      vm[`${field}FieldIcon`] = vm[`${field}FieldIcon`] === 'zmdi-eye-off' ? 'zmdi-eye' : 'zmdi-eye-off';
      vm[`${field}FieldType`] = vm[`${field}FieldType`] === 'password' ? 'text' : 'password';
      vm[`${field}FieldTooltip `] = vm[`${field}FieldTooltip `] === 'Show password' ? 'Hide password' : 'Show password';
    };

    vm.checkAgainstPasswordPolicy = function (field){

      vm.resetFormObj.confirmpassword.$setValidity('nonMatch', true);
      vm.resetFormObj.password.$setValidity('nonMatch', true);
      vm.resetFormObj.password.$setValidity('invalidCharacters', true);

      if (field === 'confirmPassword'){
        if (vm.confirmPasswordFormFieldValue !== vm.passwordFormFieldValue && (!!vm.passwordFormFieldValue && vm.passwordFormFieldValue.length > 0)){
          vm.resetFormObj.confirmpassword.$setValidity('nonMatch', false);
        }
        return;
      }

      if (vm.passwordFormFieldValue !== vm.confirmPasswordFormFieldValue && (!!vm.confirmPasswordFormFieldValue && vm.confirmPasswordFormFieldValue.length > 0)){
        vm.resetFormObj.password.$setValidity('nonMatch', false);
        return;
      }

      const recognisedCharactersRegex = new RegExp(/^[A-Za-z\d!@#$%^&*-]*$/);

      if (!(recognisedCharactersRegex.test(vm.passwordFormFieldValue))){
        vm.resetFormObj.password.$setValidity('invalidCharacters', false);
        return;
      }

      for (const key of Object.keys(vm.activePolicy)){
        const policy = vm.activePolicy[key];
        vm.resetFormObj.password.$setValidity(key, false);

        if (!policy.regex){
          switch (key){
            case 'minLength':
              if (vm.passwordFormFieldValue && vm.passwordFormFieldValue.length >= policy.value){
                vm.resetFormObj.password.$setValidity(key, true);
              }
              break;
            case 'maxLength':
              if (vm.passwordFormFieldValue && vm.passwordFormFieldValue.length <= policy.value){
                vm.resetFormObj.password.$setValidity(key, true);
              }
              break;
          }
          continue;
        }

        const regex = new RegExp(policy.regex);
        const valid = regex.test(vm.passwordFormFieldValue);
        vm.resetFormObj.password.$setValidity(key, valid);
      }
    };

    vm.submitResetPasswordForm = function () {

      return PasswordResetFactory.postNewPassword(vm.clientId, vm.userId, vm.resetId, vm.passwordFormFieldValue, vm.confirmPasswordFormFieldValue)
        .then(function () {
          vm.passwordResetComplete = true;
          MessageService.showMessage('Your password has been successfully reset');
        })
        .catch(function (err) {
          MessageService.showMessage('Something went wrong: ' + err.data.data.message);
        });
    };

  }
  
}());
  
(function() {
  'use strict';
  
  angular
    .module('authentication')
    .component('zpForgotPasswordPage', {
      templateUrl: 'app/authentication/forgot/forgot.tmpl.html',
      controller: 'ForgotPasswordController',
      bindings: {}
    })
    .controller('ForgotPasswordController', ctrl);

  ctrl.$inject = ['$scope', 'PasswordResetFactory', 'MessageService', 'appSettings', '$timeout', '$filter'];
  /* ng-inject */
  function ctrl($scope, PasswordResetFactory, MessageService, appSettings, $timeout, $filter) {
  
    const vm = this;
    vm.showForm = true;

    vm.$onInit = function () {
      vm.zuantLogoURL = $filter('cdnAssets')('/images/svgs/logos/zuant/ZUANT_CLOUD.svg');
      vm.appSettings = appSettings;
    };

    vm.submitForgotPasswordForm = function() {
      vm.showForm = false;
      return PasswordResetFactory.generateResetEmail(vm.user.email)
        .then(function () {
          $scope.$emit('zp.intercom-boot', vm.user);
          $timeout(function () {
            MessageService.pushEventToIntercom('forgot_password', {
              email: vm.user.email
            });
          }, 100);
        })
        .catch(function () {
          MessageService.showMessage('Something went wrong sending the reset password email. Please try again');
        });
    };

  }
    
}());
  
/**
 * Created by davidhickson on 04/05/2017.
 */
(function () {
  'use strict';
  angular
    .module('artefacts')
    .factory('ImagesApiFactory', ImagesApiFactory);

  ImagesApiFactory.$inject = ['APIService', '$q', '$log', 'EncodingService', 'uuidService', 'dropboxApiService', '$interval', 'MessageService', '$filter', 'ListApiFactory', 'localStorageService', 'SessionService', 'ThemingFactory'];
  /* ng-inject */
  function ImagesApiFactory(api, $q, $log, encoder, uuidService, dropboxApiService, $interval, MessageService, $filter, ListApiFactory, localStorageService, session, ThemingFactory) {

    const factoryData = {
      arrayOfImageItems: [],
      searchTerm: '',
      file: undefined,
      imageCacheValid: false
    };

    return {
      factoryData: factoryData,
      getImageArtefactsForAccount: getImageArtefactsForAccount,
      getImages: getImages,
      getImage: getImage,
      uploadImageToS3: uploadImageToS3,
      ingestChangedImageItem: ingestChangedImageItem,
      updateImage: updateImage,
      removeSelectedImages: removeSelectedImages,
      deleteImage: deleteImage,
      searchTermChanged: searchTermChanged,
      markImagesInUse: markImagesInUse,
      invalidateCache: invalidateCache,
      setDashboardImageToLocalStorage: setDashboardImageToLocalStorage,
      migrateImageToDropboxStorage: migrateImageToDropboxStorage,
      grabImageBase64ValuesFromServer: grabImageBase64ValuesFromServer
    };

    /**
     * Fetches all image artefacts for the account and caches them in the factoryData
     * @function
     * @returns {array} factory cached array of image artefacts
     * @description currently being used by CustomSkins to grab all image artefacts for the account. Should eventually merge this and getImages()
     */
    function getImageArtefactsForAccount() {
      return $q(function q(resolve, reject) {
        if (factoryData.imageCacheValid) {
          return resolve(factoryData.arrayOfImageItems);
        } else {
          const query = {
            artefactType: 'Image',
            _deletedatelocalutc: {
              $exists: false
            }
          };
          return ListApiFactory.getArtefactsByQuery(query)
            .then(function (res) {
              _.extend(factoryData.arrayOfImageItems, res.data.data);
              factoryData.imageCacheValid = true;
              return resolve(factoryData.arrayOfImageItems);
            })
            .catch(function (err) {
              return reject(err);
            });
        }
      });
    }

    function getImages() {
      const defer = $q.defer();

      let arrayOfImageItems;
      api.get('showroom/images')
        .then(function (response) {
          $log.info('ImagesApiFactory.getServiceReference got literature, count=' + response.data.data.length);
          arrayOfImageItems = response.data.data;
          _.each(arrayOfImageItems, function (imageItem) {
            if(!imageItem.imagebase64 && !imageItem.weburi) imageItem.loading = true;
            imageItem.isShouldBeDisplayed = true;
          });
          factoryData.arrayOfImageItems = arrayOfImageItems; // sets factory array of images
          factoryData.imageCacheValid = true;
          defer.resolve(factoryData.arrayOfImageItems);
        });

      return defer.promise;
    }

    function getImage(id) {
      return api.get('showroom/images/' + encoder.encode(id));
    }

    function uploadImageToS3(imageTitle, file) {
      return uuidService.getHashedId()
        .then(function (id) {
          const payload = {
            _id: id,
            file: file
          };
  
          return api.uploadFileToS3(payload)
            .then(function (s3key){
              const inboundImageItem = {
                _id: uuidService.getSingleNewBase64Key(),
                title: imageTitle,
                filename: file.name,
                _s3key: s3key
              };

              factoryData.arrayOfImageItems.push(Object.assign({ size: file.size, type: file.type }, inboundImageItem));

              return api.post('showroom/images/upload', inboundImageItem);
            });
        });
    }

    function ingestChangedImageItem(inboundImageItem, uriOrFileUpload) {
      let found = false;

      factoryData.arrayOfImageItems.forEach(function (existingImageItem) {
        if (inboundImageItem._id == existingImageItem._id) {
          found = true;
          Object.getOwnPropertyNames(inboundImageItem).forEach(function (propertyName) {
            existingImageItem[propertyName] = inboundImageItem[propertyName];
          });
        }
      });

      if (!found) {
        inboundImageItem.isShouldBeDisplayed = true;
        factoryData.arrayOfImageItems.push(inboundImageItem);
      }

      return updateImage(inboundImageItem, uriOrFileUpload);
    }

    function updateImage(inboundImageItemToUpdate, uriOrFileUpload) {
      const defer = $q.defer();

      if (uriOrFileUpload === 'upload') {
        // user is uploading an image file to dropbox
        let dropboxImagePath;
        dropboxApiService.uploadImageToDropbox(inboundImageItemToUpdate)
          .then(function (res) {
            dropboxImagePath = res.data.path_lower;
            return dropboxApiService.ensureFileIsShared({
              path: res.data.path_lower
            }, true);
          })
          .then(function (res) {
            inboundImageItemToUpdate.weburi = $filter('zpDropboxRaw')(res.data.url); // $filter ensures url ends in raw=0 (if it had dl=0 to start with else just returns itself unadjusted)
            inboundImageItemToUpdate.dropboxPath = dropboxImagePath; // we store the dropboxPath so we can use dropbox API to get things such as thumbnail image etc

            delete inboundImageItemToUpdate.imageDataAsArrayBuffer;
            delete inboundImageItemToUpdate.isDirty;
            delete inboundImageItemToUpdate.isShouldBeDisplayed;
            delete inboundImageItemToUpdate.selected;
            delete inboundImageItemToUpdate.$$hashKey;

            const imageItemToUpdate = angular.copy(inboundImageItemToUpdate);
            delete imageItemToUpdate.height;
            delete imageItemToUpdate.width;
            delete imageItemToUpdate.type;
            delete imageItemToUpdate.size;

            return api.post('showroom/images/upload', imageItemToUpdate);
          })
          .then(function (res) {
            defer.resolve(res);
          })
          .catch(function (error) {
            defer.reject(error);
          });

      } else {
        // user has entered a weburi of an image on the interwebs. post image artefact to mongo
        delete inboundImageItemToUpdate.imageDataAsArrayBuffer;
        delete inboundImageItemToUpdate.isDirty;
        delete inboundImageItemToUpdate.isShouldBeDisplayed;
        delete inboundImageItemToUpdate.selected;
        delete inboundImageItemToUpdate.$$hashKey;

        const imageItemToUpdate = angular.copy(inboundImageItemToUpdate);

        return api.post('showroom/images/upload', imageItemToUpdate)
          .then(function (res) {
            defer.resolve(res);
          })
          .catch(function (error) {
            defer.reject(error);
          });
      }

      return defer.promise;
    }

    function removeSelectedImages() {
      // We have been informed that a tag has just been toggled.  The tag that was toggled was from a tab blocks component, NOT the literature list.
      $log.info('ImagesApiFactory Will remove lit');

      const changeDeltaPackage = [];
      const dropboxFilesToDelete = [];
      factoryData.arrayOfImageItems.forEach(function (imageItem) {
        if (imageItem.selected) {
          changeDeltaPackage.push({
            '_id': imageItem._id
          });
          if (imageItem.dropboxPath) {
            dropboxFilesToDelete.push({
              path: imageItem.dropboxPath
            });
          }
        }
      });

      if (changeDeltaPackage.length > 0) {
        postDeletePackageToServer(changeDeltaPackage)
          .then(function (res) {
            $log.info('removeSelectedImages returned from postDeletePackageToServer with ' + JSON.stringify(res));

            for (let i = factoryData.arrayOfImageItems.length - 1; i > -1; i--) {
              if (factoryData.arrayOfImageItems[i].selected) {
                factoryData.arrayOfImageItems.splice(i, 1);
              }
            }

            if (!dropboxFilesToDelete.length) {
              // no dropbox images to delete so we can notify user now that job is done
              MessageService.showMessage('Image deleted');
            }
          }, function () {
            $log.info('removeSelectedImages returned NASTY from postDeletePackageToServer with ' + JSON.stringify(res));
          });

        if (dropboxFilesToDelete.length) {
          processDropboxDeleteJob(dropboxFilesToDelete);
        }
      }
    }

    function deleteImage(imageId, dropboxData) {
      return api.delete('showroom/images/' + encoder.encode(imageId))
        .then(function () {
          factoryData.arrayOfImageItems = _.filter(factoryData.arrayOfImageItems, function (image) {
            return image._id !== imageId;
          });
          if (dropboxData && dropboxData.deleteFromDropbox) {
            processDropboxDeleteJob([{
              path: dropboxData.path
            }]);
          }
          return factoryData.arrayOfImageItems;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function processDropboxDeleteJob(dropboxFilesToDelete) {
      let async_job_id;
      dropboxApiService.deleteBatch(dropboxFilesToDelete)
        .then(function (res) {
          async_job_id = res.data.async_job_id;
          const checkBatchInterval = $interval(function () {
            dropboxApiService.deleteBatchCheck(async_job_id)
              .then(function (res) {
                if (res.data['.tag'] === 'complete') {
                  $interval.cancel(checkBatchInterval);
                  // uncomment when multi delete is supported again in the UI (currently 1 del button per image, no checkbox)
                  // var happyresults = 0;
                  // var unhappyresults = 0;
                  // _.each(res.data.entries, function (entry) {
                  //   if (entry['.tag'] === 'success') {
                  //     happyresults++;
                  //   } else if (entry['.tag'] === 'failure') {
                  //     unhappyresults++;
                  //   }
                  // });
                  // var messageToUser = happyresults + ' of ' + res.data.entries.length + ' files were successfully deleted';
                  // if(unhappyresults > 0){
                  //   messageToUser += ' and ' + unhappyresults + ' weren\'t deleted.';
                  // }
                  MessageService.showMessage('Image deleted from Dropbox');
                }
              })
              .catch(function (err) {
                MessageService.writeLog({
                  level: 'error',
                  msg: err,
                  tags: ['images']
                });
              });
          }, 1500);
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: err,
            tags: ['images']
          });
        });
    }

    function postDeletePackageToServer(pkg) {
      $log.info('ImagesApiFactory.postDeletePackageToServer starting');
      var defer = $q.defer();

      api.post('showroom/images/removeMany', pkg)
        .then(
          function (response) {
            $log.info('ImagesApiFactory.postDeletePackageToServer POST success has response:' + JSON.stringify(response));
            defer.resolve({
              'all': 'worked'
            });
          },
          function (err) {
            $log.info('ImagesApiFactory.postDeletePackageToServer put ERROR has response:' + JSON.stringify(err));
            defer.reject({
              'server': 'had a nasty',
              'err': err
            });
          }
        );

      return defer.promise;
    }

    function searchTermChanged() {
      for (let i = 0; i < factoryData.arrayOfImageItems.length; i++) {
        if (factoryData.arrayOfImageItems[i].name.toLowerCase().indexOf(factoryData.searchTerm) > -1 || factoryData.arrayOfImageItems[i].title.toLowerCase().indexOf(factoryData.searchTerm) > -1) {
          factoryData.arrayOfImageItems[i].isShouldBeDisplayed = true;
        } else {
          factoryData.arrayOfImageItems[i].isShouldBeDisplayed = false;
        }
      }
    }

    function markImagesInUse(arrayOfImageDocs) {
      _.each(arrayOfImageDocs, function (imageDoc) {
        imageDoc.inUseByThemes = checkThemesForImageReference(imageDoc._id);
      });

      // private helpers

      function checkThemesForImageReference(imageId) {
        const arrayOfThemesReferencingImageId = _.chain(ThemingFactory.factoryData.items)
          .filter(function (themeDoc){
            if (!('images' in themeDoc) || typeof(themeDoc.images) !== 'object') return false;

            for (const [i, key] of Object.keys(themeDoc.images).entries()) {
              if (!('_id' in themeDoc.images[key]) || themeDoc.images[key]._id !== imageId) {
                if (i === Object.keys(themeDoc.images).length - 1) return false;
                continue;
              }
              return true;
            }
          })
          .map(function (themeDoc){
            const usedin = Object.keys(themeDoc.images).filter(function (key){
              return themeDoc.images[key]._id === imageId;
            });
            return { _id: themeDoc._id, name: themeDoc.name, usedin };
          })
          .value();
      
        return arrayOfThemesReferencingImageId;
      }
      
    }

    function invalidateCache() {
      factoryData.imageCacheValid = false;
    }

    function setDashboardImageToLocalStorage(themeDoc) {
      return $q(function q(resolve, reject) {
        if (!themeDoc) resolve();
        const targetThemeDoc = _.find(ThemingFactory.factoryData.items, function (tdoc) {
          return tdoc._id === themeDoc._id;
        });
        if (targetThemeDoc.cloudDashboardBackgroundImage) {

          return ListApiFactory.getArtefactById(targetThemeDoc.cloudDashboardBackgroundImage)
            .then(function (res) {
              const cloudDashboardBackgroundImage = {
                name: res.data.data.name,
                weburi: res.data.data.weburi,
                _s3key: res.data.data._s3key
              };

              localStorageService.set('cloudDashboardBackgroundImage_' + session.getUserData().databasename, cloudDashboardBackgroundImage);
              return resolve({
                success: true
              });
            })
            .catch(function (err) {
              MessageService.writeLog({
                level: 'error',
                msg: err
              });
              return reject(err);
            });
        } else {
          localStorageService.set('cloudDashboardBackgroundImage_' + session.getUserData().databasename, {
            name: '',
            weburi: '',
            _s3key: ''
          });
          return resolve({
            success: true
          });
        }
      });
    }

    function migrateImageToDropboxStorage(imageObject) {
      const data = _base64ToArrayBuffer(imageObject.imagebase64);
      setFile(data);
      return ingestChangedImageItem(imageObject, 'upload');

      function _base64ToArrayBuffer(base64) {
        base64 = base64.split('data:image/png;base64,').join('');
        let binary_string = window.atob(base64),
          len = binary_string.length,
          bytes = new Uint8Array(len),
          i;

        for (i = 0; i < len; i++) {
          bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
      }
    }

    function grabImageBase64ValuesFromServer() {

      const promisesArray = [];

      _.each(factoryData.arrayOfImageItems, function (itm) {
        if (!itm.weburi) {
          promisesArray.push(api.get('showroom/images/base64/' + encoder.encode(itm._id)));
        }
      });

      $q.all(promisesArray)
        .then(function (res) {
          _.each(res, function (r) {
            locateImageAndSetBase64Val(r.data.data);
          });
          MessageService.writeLog({
            level: 'info',
            msg: 'all images now have their base64 value'
          });
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: 'error encountered when fetching imagebase64 values for images ' + JSON.stringify(err),
            tags: ['images']
          });
        });
    }

    function locateImageAndSetBase64Val(serverResponseObj) {
      const itemToBeUpdated = _.find(factoryData.arrayOfImageItems, function (item) {
        return item._id === serverResponseObj._id;
      });
      if (itemToBeUpdated) {
        itemToBeUpdated.loading = false;
        itemToBeUpdated.imagebase64 = serverResponseObj.imagebase64;
        itemToBeUpdated._s3key = serverResponseObj._s3key;
      }
    }

  }
})();

(function () {
  'use strict';
    
  angular
    .module('artefacts')
    .directive('zpImageUrlValidator', ImageURLValidator);

  ImageURLValidator.$inject = ['stringHelper'];

  function ImageURLValidator(stringHelperService) {
    return {
      require: 'ngModel',
      link: function(scope, element, attr, mCtrl) {
        function myValidation(value) {
          const imageRegex = stringHelperService.imageRegex();
          if (imageRegex.test(value)) {
            mCtrl.$setValidity('imageURL', true);
          } else {
            mCtrl.$setValidity('imageURL', false);
          }
          return value;
        }
        mCtrl.$parsers.push(myValidation);
      }
    };
  }

})();
/**
 * Created by davidbeazer on 23/02/2017.
 */
(function () {
  'use strict';

  angular
    .module('artefacts')
    .factory('ImageMetadataFactory', ImageMetadataFactory);

  ImageMetadataFactory.$inject = [];

  function ImageMetadataFactory() {

    var factoryData = {};
    buildFactory();

    return {
      getData: getData
    };

    function getData() {
      return factoryData;
    }

    // PRIVATE

    function buildFactory() {

      factoryData = {
        id: 'image',
        title: {
          label: 'Images',
          filterLabel: 'Search image items'
        },
        fabDialogConfig: {
          description: 'New image item',
          controller: 'ImageArtefactDialogController as vm',
          templateUrl: 'app/artefacts/images/image-artefact-dialog/image-detail.dialog.tmpl.html',
          locals: {
            imageDoc: {
              // _id: null, << server creates that
              title: '',
              name: ''
            }
          },
          ariaLabel: 'Create new image item'
        }
      };
    }
  }
})();

/**
 * Created by davidbeazer on 27/09/2016.
 */

(function () {
  'use strict';

  angular
    .module('users')
    .config(moduleConfig);

  moduleConfig.$inject = ['$stateProvider'];
  /* ng-inject */
  function moduleConfig($stateProvider) {

    $stateProvider
      .state('app.homescreen_app_framework.users_home', {
        url: '/users/:_id',
        title: 'Users',
        views: {
          'toolbarSection': {
            component: 'zpUserSearchToolbar'
          },
          'spof': {
            component: 'zpUsersAppHomepage'
          },
          'right-hand-container': {
            component: 'zpUsersWidgetContainer'
          },
          'fab-container': {
            component: 'zpAddUserFab'
          }
        },
        data: {
          permissions: {
            only: ['USERS_VIEW']
          }
        },
        resolve: {
          model: ['$q', 'CurrentClientModelFactory', 'MessageService', 'ToolbarFactory', 'EncodingService', '$transition$', 'UserFactory', 'UserPermissionsHelperFactory', function (promise, factory, message, toolbarfactory, encoder, transition, userfactory, UserPermissionsHelperFactory) {
            return new promise(function (resolve, reject) {
              var decodedClientId = encoder.decode(transition.params()._id);
              message.writeLog({
                level: 'info',
                msg: '/clients/edit/' + decodedClientId,
                tags: ['users_home']
              });

              return UserPermissionsHelperFactory.init()
                .then(function () {
                  return factory.getClientById(decodedClientId);
                })
                .then(function () {
                  return userfactory.getUserList(decodedClientId);
                })
                .then(function () {
                  toolbarfactory.set({
                    title: 'Users',
                    navigationPath: '',
                    showBackButton: false
                  });
                }).then(function () {
                  resolve();
                })
                .catch(reject);
            });
          }]
        }
      })
      .state('app.toolbar_app_framework.edit_user', {
        url: '/users/:_id/user/:_userId',
        title: 'Edit User',
        views: {
          'spof': {
            template: '<zp-user-detail-page></zp-user-detail-page>'
          }
        },
        data: {
          permissions: {
            only: ['USERS_EDIT']
          }
        },
        resolve: {
          model: ['$q', 'CurrentClientModelFactory', 'UserFactory', '$transition$', 'EncodingService', 'MessageService', 'ToolbarFactory', 'UserPermissionsHelperFactory', function (promise, clientFactory, userFactory, $transition$, encoder, message, toolbarfactory, userPermissionsHelperFactory) {
            return new promise(function (resolve, reject) {
              var decodedClientId = encoder.decode($transition$.params()._id);
              var decodedUserId = encoder.decode($transition$.params()._userId);
              message.writeLog({
                level: 'info',
                msg: '/clients/edit/' + decodedClientId + '/user/' + decodedUserId
              });

              return userPermissionsHelperFactory.init()
                .then(function () {
                  return clientFactory.getClientById(decodedClientId);
                })
                .then(function () {
                  return userFactory.getUserList(decodedClientId);
                })
                .then(function () {
                  return userFactory.getUserById(decodedUserId);
                })
                .then(function (res) {
                  toolbarfactory.set({
                    title: 'Editing ' + res.firstname + ' ' + res.surname,
                    navigationPath: 'app.homescreen_app_framework.users_home',
                    showBackButton: true,
                    stateParams: {
                      _id: decodedClientId,
                    },
                    customStateParams: {
                      isDirtyCheck: true
                    }
                  });
                  resolve(userFactory);
                })
                .catch(reject);
            });
          }]
        }
      })
      .state('app.tabbed_app_framework.permissions', {
        url: '/users/:_id/permissions',
        abstract: true,
        views: {
          'left-hand-container': {
            template: '<div ui-view="left-hand-container"></div>'
          },
          'spof': {
            template: '<div ui-view="spof" layout-fill></div>'
          },
          'fab-container': {
            template: '<div ui-view="fab-container"></div>'
          }
        },
        data: {
          name: 'permissions',
          permissions: {
            only: ['ZUANT_ADMIN']
          },
          showLeftSidebar: false
        },
        resolve: {
          clientId: ['$transition$', 'EncodingService', 'PermissionsManagerFactory', function (transition, encoder, permissionmanagerfactory) {
            var decodedClientId = encoder.decode(transition.params()._id);
            permissionmanagerfactory.resetFactory();
            return decodedClientId;
          }],
          layout: ['LayoutsFactory', function (layouts) {
            layouts.setProperty('rightHandContainerWidth', '0');
          }],
          toolbarConfig: ['$transition$', 'ToolbarFactory', 'EncodingService', function ($transition$, toolbarfactory, encoder) {
            var decodedClientId = encoder.encode($transition$.params()._id);
            toolbarfactory.set({
              title: 'Permissions Manager',
              navigationPath: 'app.homescreen_app_framework.users_home',
              showBackButton: true,
              stateParams: {
                _id: decodedClientId,
              },
              customStateParams: {
                isDirtyCheck: true
              }
            });
          }]
        }
      })
      .state('app.tabbed_app_framework.permissions.users-pool', {
        url: '/permissions-pool',
        title: 'Permissions pool',
        views: {
          'left-hand-container': {
            component: 'zpUserPoolSelector'
          },
          'spof': {
            template: '<zp-action-selector layout="column" layout-fill></zp-action-selector>'
          },
          'fab-container': {
            component: 'zpPermissionsFab'
          }
        },
        data: {
          name: 'permissions',
          permissions: {
            only: ['ZUANT_ADMIN']
          },
          showLeftSidebar: true
        }
      });
  }
})();

(function () {
  'use strict';
  
  angular
    .module('clients')
    .factory('UserExportFactory', Factory);
  
  Factory.$inject = ['UserFactory', 'UnparseData', 'DownloadCSV', 'MessageService'];
  /** @ngInject */
  function Factory(UserFactory, UnparseData, DownloadCSV, MessageService) {
  
    return {
      exportUsersCSV: exportUsersCSV
    };
  
    function exportUsersCSV(){
      return UserFactory.getUserList()
        .then(function (users){
          const columnsData = buildColumnsDataArr();
          const exportData = mergeDataForExport(users);
          const csv = UnparseData(columnsData, exportData);
  
          const filename = 'Zuant User Export: ' + moment().format('MM_DD_YYYY') + '.csv';
    
          DownloadCSV(filename, csv);
    
          MessageService.showMessage('User Export Complete');
  
          return csv;
        })
        .catch(function (err){
          MessageService.showMessage('User Export Failed');
        });

    }
  
    //// private helpers
  
    function buildColumnsDataArr() {
      return ['id', 'firstname', 'surname', 'email', 'permissions', 'archived'];
    }

    function mergeDataForExport(users) {
      const staffUserIds = Object.keys(users.staffUsersObject);

      return _.chain(Object.keys(users.itemsObject))
        .map(function (userId){
          return users.itemsObject[userId].user;
        })
        .filter(function (user){
          return staffUserIds.indexOf(user._id) === -1;
        })
        .map(function (user){
          return {
            id: user._id,
            firstname: user.firstname,
            surname: user.surname,
            email: user.email,
            permissions: user.typeofuser,
            archived: user.inactive || false
          };
        })
        .sortBy(function (user){
          return [user.archived, user.email];
        })
        .value();
    }

  }
  
}());
  
/**
 * Created by davidbeazer on 10/11/2016.
 */
(function () {
  'use strict';

  angular
    .module('users')
    .factory('UsersAPI', UsersAPI);

  UsersAPI.$inject = ['APIService', 'APIFactory', 'SessionService', 'EncodingService'];
  /* ng-inject */
  function UsersAPI(api, apiFactory, SessionService, encoder) {

    var userApi;

    var services = {

      getUsers: function () {
        changeApiFactoryRoute();
        return userApi.get();
      },
      getUserById: function (userId) {
        changeApiFactoryRoute();
        return userApi.getById(userId);
      },
      postNewUser: function (data, files) {
        changeApiFactoryRoute();
        return userApi.create(data, files);
      },
      postUsersImport: function (postObj) {
        var apiUrl = 'client/' + encoder.encode(SessionService.getUserData().clientId) + '/users/import';
        return api.post(apiUrl, postObj);
      },
      postUserUpdate: function (data, files) {
        changeApiFactoryRoute();
        return userApi.update(data, files);
      },
      deleteUser: function (userId) {
        changeApiFactoryRoute();
        return userApi.delete(userId);
      },
      resendWelcomeEmail: function (userId) {
        var apiUrl = 'client/' + encoder.encode(SessionService.getUserData().clientId) + '/user/' + encoder.encode(userId) + '/resendUserWelcomeEmail';
        return api.post(apiUrl);
      },
      changePassword: function (passwordObj, userId) {
        var apiUrl = 'client/' + encoder.encode(SessionService.getUserData().clientId) + '/user/' + encoder.encode(userId) + '/changepassword';
        return api.post(apiUrl, passwordObj);
      },
      validateCredentials: function (queryObj) {
        var apiUrl = 'client/user/validateCredentials';
        return api.post(apiUrl, queryObj);
      }
    };

    return services;

    function changeApiFactoryRoute() {
      userApi = apiFactory.route('client/' + encoder.encode(SessionService.getUserData().clientId) + '/user');
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('users')
    .factory('UserFactory', UserFactory);

  UserFactory.$inject = ['UsersAPI', '$filter', 'UserMetadataFactory', '$q', 'UserPermissionsHelperFactory', 'MessageService', 'uuidService', 'SessionService', 'ValidationHelperFactory'];
  /* ng-inject */
  function UserFactory(UsersAPI, $filter, UserMetadataFactory, $q, UserPermissionsHelperFactory, MessageService, uuidService, SessionService, ValidationHelperFactory) {

    const factoryData = {
      items: [],
      itemsObject: {},
      activeUsers: [],
      inactiveUsers: [],
      activeUsersObject: {},
      inactiveUsersObject: {},
      
      staffUsers: [],
      staffUsersObject: {},
      activeStaffUsers: [],
      inactiveStaffUsers: [],

      combinedUsers: [],
      combinedUsersObject: {},

      dataCache: {
        valid: false,
        lastServerTripTimestamp: null,
        clientId: null
      },
    };

    let currentUser;
    
    return  {
      getUserList: getUserList,
      getData: getData,
      getUserById: getUserById,
      getCurrentUserCache: getCurrentUserCache,
      postNewUser: postNewUser,
      postUsersImport: postUsersImport,
      postUserUpdate: postUserUpdate,
      toggleArchiveUser: toggleArchiveUser,
      deleteUser: deleteUser,
      resendWelcomeEmail: resendWelcomeEmail,
      changePassword: changePassword,
      getArchivedUserList: getArchivedUserList,
      setPermissions: setPermissions,
      userDocValid: userDocValid,
      cleanseUserUpdatePayload: cleanseUserUpdatePayload,
      newUserModel: newUserModel,
      invalidateCache: invalidateCache,
      factoryData: factoryData
    };

    ////////////////////

    function getUserList() {
      return $q(function q(resolve, reject) {
        if (ValidationHelperFactory.dataCacheIsStillValid(factoryData.dataCache)) {
          return resolve(factoryData);
        } else {
          return UsersAPI.getUsers()
            .then(function (res) {
              if (res.status == 200) {
                invalidateCache();

                if (res.data.data.customerUsers.length) {
                  processUsersArray(res.data.data.customerUsers);
                }

                if (res.data.data.internalUsers.length) {
                  processStaffUsersArray(res.data.data.internalUsers);
                }

                updateCacheStatus();
                resolve(factoryData);
              }
            })
            .catch(function (err) {
              reject(err);
            });
        }
      });
    }

    function updateCacheStatus() {
      factoryData.dataCache.valid = true;
      factoryData.dataCache.lastServerTripTimestamp = new Date();
      factoryData.dataCache.clientId = SessionService.getUserData().clientId;
    }

    function processStaffUsersArray(usersArray) {
      try {
        const shapedItemsArray = shapeDataForGrid(usersArray);
        const arrayOfActiveStaffUsers = _.filter(shapedItemsArray, function (item) {
          return !item.user.inactive;
        });

        const arrayOfInactiveStaffUsersArray = _.filter(shapedItemsArray, function (item) {
          return item.user.inactive;
        });

        applyViewFiltersToData(shapedItemsArray, 'staffUsers');
        applyViewFiltersToData(shapedItemsArray, 'combinedUsers');
        applyViewFiltersToData(arrayOfActiveStaffUsers, 'activeStaffUsers');
        applyViewFiltersToData(arrayOfInactiveStaffUsersArray, 'inactiveStaffUsers');

        addUsersFastLookupObject(shapedItemsArray, 'staffUsersObject');
        addUsersFastLookupObject(shapedItemsArray, 'combinedUsersObject');

      } catch (e) {
        MessageService.writeLog({
          level: 'error',
          msg: e,
          tags: ['process_staff_users_array']
        });
      }
    }

    function processUsersArray(usersArray) {
      try {
        const shapedItemsArray = shapeDataForGrid(usersArray);

        const activeUsersArray = _.filter(shapedItemsArray, function (item) {
          return !item.user.inactive;
        });

        const inactiveUsersArray = _.filter(shapedItemsArray, function (item) {
          return item.user.inactive;
        });

        applyViewFiltersToData(shapedItemsArray, 'items');
        applyViewFiltersToData(shapedItemsArray, 'combinedUsers');

        applyViewFiltersToData(activeUsersArray, 'activeUsers');
        applyViewFiltersToData(inactiveUsersArray, 'inactiveUsers');

        addUsersFastLookupObject(activeUsersArray, 'activeUsersObject');
        addUsersFastLookupObject(inactiveUsersArray, 'inactiveUsersObject');
        addUsersFastLookupObject(shapedItemsArray, 'itemsObject');
        addUsersFastLookupObject(shapedItemsArray, 'combinedUsersObject');

      } catch (e) {
        MessageService.writeLog({
          level: 'error',
          msg: e,
          tags: ['process_users_array']
        });
      }
    }

    function addUsersFastLookupObject(arrayOfUsers, key) {
      _.each(arrayOfUsers, function (item) {
        factoryData[key][item.user._id] = item;
      });
    }

    function applyViewFiltersToData(arrayOfUsers, key) {
      const filteredItems = $filter('enhancedTableCells')(UserMetadataFactory.getData(), arrayOfUsers); // applies angular fiters to field based on field metadata
      _.each(filteredItems, function (itm) {
        factoryData[key].push(itm);
      });
    }

    function shapeDataForGrid(arrayOfUnprocessedItems) {
      return _.map(arrayOfUnprocessedItems, function (item) {
        return {
          user: {
            _id: item._id,
            firstname: item.firstname,
            surname: item.surname,
            email: item.email,
            jobtitle: item.jobtitle,
            typeofuser: item.typeofuser,
            inactive: item.inactive,
            permissions: item.permissions,
            roleorcustom: UserPermissionsHelperFactory.derivePresetOrCustomTextFromPermissions(item),
            avatar: item.avatar,
            mfaResetRequest: item.mfaResetRequest,
            mfaSetup: item.mfaSetup
          }
        };
      });
    }

    function getData() {
      return factoryData;
    }


    function getUserById(userId) {
      return UsersAPI.getUserById(userId)
        .then(function (res) {
          if (res.status == 200) {
            currentUser = res.data.data;
            return currentUser;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function getCurrentUserCache() {
      return currentUser;
    }

    function postNewUser(userData) {
      return grabPermissionsFromServerIfNecessary(userData)
        .then(function (res) {
          return UsersAPI.postNewUser(res)
            .then(function (res) {
              if (res.status == 200) {
                /* response has an _id which means it's new. Probably should break postUser up into create and update so it's clearer */
                pushToLocalModels(userData);
              }
              return true;
            });
        })
        .catch(function (err) {
          throw err;
        });
    }

    function postUsersImport(postObj) {
      return UsersAPI.postUsersImport(postObj)
        .then(function (res) {
          if (res.status == 200) {
            /* response has an _id which means it's new. Probably should break postUser up into create and update so it's clearer */
            for (const userData of res.data.data.importedUsers){
              pushToLocalModels(userData);
            }
          }
          return true;
        });
    }

    function pushToLocalModels(userData) {
      const itemReadyForGrid = shapeDataForGrid([userData]);
      const itemToPush = $filter('enhancedTableCells')(UserMetadataFactory.getData(), itemReadyForGrid);
      const arrayToPushTo = figureOutUserArrayToAddTo(itemToPush[0].user.email.raw);
      const fastLookupObj = {
        user: userData
      };
      factoryData[arrayToPushTo].push(itemToPush[0]);
      factoryData.items.push(itemToPush[0]);
      factoryData.itemsObject[userData._id] = fastLookupObj;
      if (arrayToPushTo === 'staffUsers') {
        factoryData.staffUsersObject[userData._id] = fastLookupObj;
      } else {
        factoryData.activeUsersObject[userData._id] = fastLookupObj;
      }
    }

    function figureOutUserArrayToAddTo(userEmail) {
      return (
        userEmail.includes('@zuant.com') ||
        userEmail.includes('@evoite.com') ||
        userEmail.includes('@mktpoint.com')
      ) ? 'activeStaffUsers' : 'activeUsers';
    }

    function postUserUpdate(userData) {
      return UsersAPI.postUserUpdate(userData)
        .then(function () {
          invalidateCache();
          return true;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function determineUserPoolArrays(user) {
      const { email } = user;
      const userIsStaffMember = email.includes('@zuant.com') ||
        email.includes('@evoite.com') ||
        email.includes('@mktpoint.com');
      return {
        activeUserPool: userIsStaffMember ? factoryData.activeStaffUsers : factoryData.activeUsers,
        inactiveUserPool: userIsStaffMember ? factoryData.inactiveStaffUsers : factoryData.inactiveUsers,
        completeUserPool: userIsStaffMember ? factoryData.staffUsers : factoryData.items
      };
    }

    function toggleArchiveUser(userData) {
      return UsersAPI.postUserUpdate(userData)
        .then(function (res) {
          if (res.status == 200) {

            const userItm = _.get(factoryData.itemsObject, [userData._id, 'user']) || _.get(factoryData.staffUsersObject, [userData._id, 'user']);
            
            const { activeUserPool, inactiveUserPool, completeUserPool } = determineUserPoolArrays(userItm);

            const user = _.chain(completeUserPool)
              .map('user')
              .find(function (item) { return item._id === userData._id; })
              .value();
            user.inactive.raw = userData.inactive;

            //archive user
            if (userData.inactive) {
              const activeItemToMoveIndex = _.findIndex(activeUserPool, function (item) {
                return item.user._id == userData._id;
              });
              inactiveUserPool.push(activeUserPool[activeItemToMoveIndex]);
              activeUserPool.splice(activeItemToMoveIndex, 1);

              return;
            }

            //unarchive user
            const archivedItemToRemoveIndex = _.findIndex(inactiveUserPool, function (item) {
              return item.user._id == userData._id;
            });

            activeUserPool.push(inactiveUserPool[archivedItemToRemoveIndex]);
            inactiveUserPool.splice(archivedItemToRemoveIndex, 1);
          
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function deleteUser(userId) {
      return UsersAPI.deleteUser(userId)
        .then(function (res) {
          if (res.status == 200) {
            invalidateCache();
            return true;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function resendWelcomeEmail() {

      return UsersAPI.resendWelcomeEmail(currentUser._id)
        .then(function (res) {
          if (res.status == 200) {
            return res.data;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function changePassword(email, password, repeatpassword) {
      const dataObj = {
        email: email,
        password: password,
        repeatpassword: repeatpassword
      };
      return UsersAPI.changePassword(dataObj, currentUser._id)
        .then(function (res) {
          if (res.status == 200) {
            return res.data;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function getArchivedUserList() {
      let archivedUserCount = 0;
      factoryData.items.some(function (obj) {
        if (obj.user.inactive.raw == true) archivedUserCount++;
      });
      return archivedUserCount;
    }

    function setPermissions(userDoc) {
      return grabPermissionsFromServerIfNecessary(userDoc)
        .then(function (userData) {
          return userData.permissions;
        })
        .catch(function (err) {
          throw err;
        });
    }

    function grabPermissionsFromServerIfNecessary(userData) {
      return $q(function q(resolve, reject) {

        let preset;

        if (userData.typeofuser === 'Administrator') preset = 'admin';
        if (userData.typeofuser === 'PowerUser') preset = 'power';
        if (userData.typeofuser === 'Standard User') preset = 'standard';
        if (userData.typeofuser === 'Show worker') preset = 'standard';

        return UserPermissionsHelperFactory.getPermissionsPreset(preset)
          .then(function (res) {
            MessageService.writeLog({
              level: 'info',
              msg: 'grabbing permissions preset ' + preset
            });

            let trumpFlag = false;
            if (userData.permissions) trumpFlag = angular.copy(userData.permissions.trump);

            userData.permissions = _.extend({}, userData.permissions, res);
            if (trumpFlag) userData.permissions.trump = true;

            resolve(userData);
          })
          .catch(function (err) {
            reject(err);
          });
      });
    }

    function userDocValid(formData) {
      if (!formData.firstname ||
        !formData.surname ||
        !formData.email ||
        !formData.typeofuser) {
        return false;
      } else {
        return true;
      }
    }

    function cleanseUserUpdatePayload(payload) {
      return {
        _id: payload._id,
        firstname: payload.firstname,
        surname: payload.surname,
        email: payload.email,
        typeofuser: payload.typeofuser,
        permissions: payload.permissions
      };
    }
    
    function newUserModel() {
      return {
        _id: uuidService.getSingleNewBase64Key(),
        firstname: '',
        surname: '',
        email: '',
        typeofuser: '',
        password: '',
        repeatpassword: '',
        permissions: {}
      };
    }

    function invalidateCache() {
      factoryData.items = [];
      factoryData.itemsObject = {};
      factoryData.activeUsers = [];
      factoryData.inactiveUsers = [];
      factoryData.activeUsersObject = {};
      factoryData.inactiveUsersObject = {};

      factoryData.staffUsers = [];
      factoryData.staffUsersObject = {};
      factoryData.activeStaffUsers = [];
      factoryData.inactiveStaffUsers = [];

      factoryData.combinedUsers = [];
      factoryData.combinedUsersObject = {};

      factoryData.dataCache = {
        valid: false,
        lastServerTripTimestamp: null
      };
    }

  }
})();

/**
 * Created by davidbeazer on 23/02/2017.
 */
(function () {
  'use strict';

  angular
    .module('users')
    .factory('UserMetadataFactory', UserMetadataFactory);

  UserMetadataFactory.$inject = ['localStorageService'];

  function UserMetadataFactory(localStorage) {

    const factoryData = {
      id: 'user_list',
      title: {
        label: 'Users',
        filterLabel: 'Search users'
      },
      columnsData: buildColumnsData(),
      query: {
        order: {
          id: 'user.surname',
          expression: 'user.surname.raw'
        },
        limit: localStorage.get('user_list') || 50,
        page: 1
      },
      paginationOptions: {
        boundaryLinks: true,
        limitSelect: true,
        pageSelect: true,
        pagination: true,
        limitOptions: [5, 10, 20, 50, 75, 100],
        limit: localStorage.get('user_list') || 50,
        page: 1
      },
      gridOptions: {
        rowSelection: false,
        multiSelect: false,
        sortable: true,
        interactive: false
      },
      fabDialogConfig: {
        description: 'New user',
        controller: 'AddUserDialogController as vm',
        templateUrl: 'app/users/add-user/dialog/add-user-dialog.tmpl.html',
        locals: {},
        ariaLabel: 'Create new user'
      },
      menuOptions: [
        {
          onClick: 'viewArchivedUsers',
          ariaLabel: function () {
            return 'Manage Archived Users';
          },
          icon: function () {
            return 'zmdi zmdi-archive';
          },
          label: function () {
            return 'Manage Archived Users';
          }
        },
        {
          onClick: 'viewArchivedStaffUsers',
          ariaLabel: function () {
            return 'Manage Archived Staff Users';
          },
          icon: function () {
            return 'zmdi zmdi-archive';
          },
          label: function () {
            return 'Manage Archived Staff Users';
          },
          permissions: ['ZUANT_ADMIN']
        },
        {
          onClick: 'exportUsersAsCSV',
          ariaLabel: function () {
            return 'Export Users CSV';
          },
          icon: function () {
            return 'zmdi zmdi-download';
          },
          label: function () {
            return 'Export Users CSV';
          }
        }
      ]
    };

    return {
      getData: getData
    };

    function getData() {
      return factoryData;
    }

    // PRIVATE

    function buildColumnsData() {
      return {
        primaryIdentifier: {
          object: 'user',
          field: '_id'
        },
        items: [{
          object: 'user',
          databasefieldname: 'firstname',
          name: 'First name',
          label: 'First name',
          type: 'Textfield',
          showCol: true,
          editable: false,
          sortOn: 'rawValue'
        }, {
          object: 'user',
          databasefieldname: 'surname',
          name: 'surname',
          label: 'Surname',
          type: 'Textfield',
          showCol: true,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: ''
        }, {
          object: 'user',
          databasefieldname: 'email',
          name: 'Email',
          label: 'Email',
          type: 'Textfield',
          showCol: true,
          editable: false,
          sortOn: 'rawValue'
        }, {
          object: 'user',
          databasefieldname: 'jobtitle',
          name: 'Jobtitle',
          label: 'Jobtitle',
          type: 'Textfield',
          showCol: false,
          editable: false,
          sortOn: 'rawValue',
          cellDefaultValue: ''
        }, {
          object: 'user',
          databasefieldname: 'roleorcustom',
          name: 'Role/Preset',
          label: 'Role/Preset',
          type: 'Textfield',
          showCol: true,
          editable: false,
          sortOn: 'rawValue'
        }, {
          object: 'user',
          databasefieldname: 'inactive',
          name: 'Active user',
          label: 'Inactive',
          type: 'inactiveUser',
          showCol: false,
          editable: false,
          boolean: true,
          sortOn: 'rawValue'
        }, {
          object: 'user',
          databasefieldname: '_invitedAt',
          name: 'Invited at',
          label: 'Invited at',
          type: 'Textfield',
          showCol: false,
          editable: false,
          boolean: false,
          sortOn: 'rawValue'
        }, {
          object: 'user',
          databasefieldname: 'avatar',
          name: 'Avatar',
          label: 'Avatar',
          type: 'Image',
          showCol: false,
          editable: false,
          boolean: false,
          sortOn: 'rawValue',
          cellDefaultValue: ''
        }, {
          object: 'user',
          databasefieldname: '_inviteAccepted',
          name: 'Invite accepted',
          label: 'Invite accepted',
          type: 'Textfield',
          showCol: false,
          editable: false,
          boolean: false,
          sortOn: 'rawValue'
        }]
      };
    }
  }
})();

(function () {
  'use strict';
  
  angular.module('thirdparty').config(moduleConfig);
  
  moduleConfig.$inject = ['$stateProvider'];
  
  function moduleConfig($stateProvider) {
  
    $stateProvider.state('app.thirdparty.dropboxCallback', {
      url: '/thirdparty/dropboxCallback',
      views: {
        'spof': {
          component: 'zpThirdPartyDropboxCallback',
          bindings: {}
        }
      },
      resolve: {},
      data: {
      },
    });
  
  }
})();
  
/**
* Provides app-wide theming
* @module app.themes
*/
(function() {
  angular
    .module('app.themes', ['LocalStorageModule']);

})();

/**
* @function themingProvider
* @description Provides ability to build a theme out of color palettes that is then used as an app skin
*/
(function() {
  'use strict';

  themingProvider.$inject = ['$mdThemingProvider'];
  angular
    .module('app.themes')
    .provider('triTheming', themingProvider);


  /**
  * Provides an API for theming<br />
  * Overwrites default values where parsed or explicitly set values are provided
  */

  /* @ngInject */
  function themingProvider($mdThemingProvider) {
    var themes = {};

    return {
      theme: function(name) {
        if(angular.isDefined(themes[name])) {
          return themes[name];
        }

        var theme = new Theme(name);

        themes[name] = theme;

        return themes[name];

      },
      $get: function() {
        return {
          getTheme: function(themeName) {
            return themes[themeName];
          },
          getThemeHue: function(themeName, intentName, hue) {
            if(angular.isDefined($mdThemingProvider._THEMES[themeName]) && angular.isDefined($mdThemingProvider._THEMES[themeName].colors[intentName])) {
              var palette = $mdThemingProvider._THEMES[themeName].colors[intentName];
              if(angular.isDefined($mdThemingProvider._PALETTES[palette.name]) && angular.isDefined($mdThemingProvider._PALETTES[palette.name][palette.hues[hue]])) {
                return $mdThemingProvider._PALETTES[palette.name][palette.hues[hue]];
              }
            }
          },
          getPalette: function(name) {
            return $mdThemingProvider._PALETTES[name];
          },
          getPaletteColor: function(paletteName, hue) {
            if(angular.isDefined($mdThemingProvider._PALETTES[paletteName]) && angular.isDefined($mdThemingProvider._PALETTES[paletteName][hue])) {
              return $mdThemingProvider._PALETTES[paletteName][hue];
            }
          },
          rgba: $mdThemingProvider._rgba,
          palettes: $mdThemingProvider._PALETTES,
          themes: $mdThemingProvider._THEMES,
          parseRules: $mdThemingProvider._parseRules
        };
      }
    };
  }

  function Theme(name) {
    var THEME_COLOR_TYPES = ['primary', 'accent', 'warn', 'background'];
    var self = this;
    self.name = name;
    self.colors = {};
    self.isDark = false;

    THEME_COLOR_TYPES.forEach(function(colorType) {
      self[colorType + 'Palette'] = function setPaletteType(paletteName, hues) {
        self.colors[colorType] = {
          name: paletteName,
          hues: {}
        };
        if(angular.isDefined(hues)) {
          self.colors[colorType].hues = hues;
        }
        return self;
      };
    });

    self.dark = function(isDark) {
      // default setting when dark() is called is true
      self.isDark = angular.isUndefined(isDark) ? true : isDark;
    };
  }
})();

/**
* Provides skins configuration for theming
* @function skinsProvider
*/
(function() {
  'use strict';

  skinsProvider.$inject = ['$mdThemingProvider', 'triThemingProvider'];
  Skin.$inject = ['id', 'name', '$mdThemingProvider', 'triThemingProvider'];
  addSkinToScope.$inject = ['$rootScope', 'triSkins'];
  angular
    .module('app.themes')
    .provider('triSkins', skinsProvider)
    .run(addSkinToScope);

  /* @ngInject */
  function skinsProvider($mdThemingProvider, triThemingProvider) {
    var skins = {};
    var currentSkin = null;
    var useSkinCookie = false;

    return {
      skin: function(id, name) {
        if(angular.isDefined(skins[id])) {
          return skins[id];
        }

        var skin = new Skin(id, name, $mdThemingProvider, triThemingProvider);

        skins[id] = skin;

        return skins[id];
      },
      setSkin: function(id) {
        if(angular.isUndefined(skins[id])) {
          return;
        }

        // set skin to selected skin
        currentSkin = skins[id];

        // override the skin if cookie is enabled and has been set
        if(useSkinCookie) {
          // we need to check cookies to see if skin has been saved so inject it
          var $cookies;
          angular.injector(['ngCookies']).invoke(['$cookies', function(cookies) {
            $cookies = cookies;
          }]);
          // if we have a cookie set then override the currentSkin
          var triangularSkin = $cookies.get('triangular-skin');
          if(angular.isDefined(triangularSkin)) {
            var cookieTheme = angular.fromJson(triangularSkin);
            currentSkin = angular.isDefined(skins[cookieTheme.skin]) ? skins[cookieTheme.skin] : skins[0];
          }
        }

        // make material load the themes needed for the skin
        currentSkin.loadThemes();

        return currentSkin;
      },
      useSkinCookie: function(skinCookie) {
        useSkinCookie = skinCookie;
      },
      $get: function() {
        return {
          getCurrent: function() {
            return currentSkin;
          },
          getSkins: function() {
            return skins;
          }
        };
      }
    };
  }

  /* @ngInject */
  function Skin(id, name, $mdThemingProvider, triThemingProvider) {
    var THEMABLE_ELEMENTS = ['sidebar', 'logo', 'toolbar', 'content'];
    var self = this;
    self.id = id;
    self.name = name;
    self.elements = {};

    THEMABLE_ELEMENTS.forEach(function(element) {
      self[element + 'Theme'] = function setElementTheme(themeName) {
        self.elements[element] = themeName;
        return self;
      };
    });

    self.loadThemes = function() {
      // go through each element
      for (var element in self.elements) {
        // register theme with mdThemingProvider (will load css in the header)
        var theme = triThemingProvider.theme(self.elements[element]);
        // console.log('creating theme: ' + theme.name);
        $mdThemingProvider.theme(theme.name)
          .primaryPalette(theme.colors.primary.name, theme.colors.primary.hues)
          .accentPalette(theme.colors.accent.name, theme.colors.accent.hues)
          .warnPalette(theme.colors.warn.name, theme.colors.warn.hues)
          .dark(theme.isDark);

        if(angular.isDefined(theme.colors.background)) {
          $mdThemingProvider
            .theme(theme.name)
            .backgroundPalette(theme.colors.background.name, theme.colors.background.hues);
        }
      }

      $mdThemingProvider.setDefaultTheme(self.elements.content);
    };
  }

  /* @ngInject */
  function addSkinToScope($rootScope, triSkins) {
    $rootScope.triSkin = triSkins.getCurrent();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.themes')
    .directive('themeBackground', themeBackground);

  themeBackground.$inject = ['$mdTheming', 'triTheming'];
  /* @ngInject */
  function themeBackground($mdTheming, triTheming) {
    // Usage:
    // ```html
    // <div md-theme="cyan" theme-background="primary|accent|warn|background:default|hue-1|hue-2|hue-3">Coloured content</div>
    // ```
    // Creates:
    //
    var directive = {
      link: link,
      restrict: 'A'
    };
    return directive;

    function link($scope, $element, attrs) {
      $mdTheming($element);

      // make sure we have access to the theme - causes an eslint but nothing we can do about AM naming
      var $mdTheme = $element.controller('mdTheme'); //eslint-disable-line
      if (angular.isDefined($mdTheme)) {
        var intent = attrs.themeBackground;
        var hue = 'default';

        // check if we have a hue provided
        if (intent.indexOf(':') !== -1) {
          var splitIntent = attrs.themeBackground.split(':');
          intent = splitIntent[0];
          hue = splitIntent[1];
        }
        // get the color and apply it to the element
        var color = triTheming.getThemeHue($mdTheme.$mdTheme, intent, hue);
        if (angular.isDefined(color)) {
          $element.css({
            'background-color': triTheming.rgba(color.value),
            'border-color': triTheming.rgba(color.value),
            'color': triTheming.rgba(color.contrast)
          });
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.themes')
    .config(themesConfig);
  themesConfig.$inject = ['$mdThemingProvider', 'triThemingProvider', 'triSkinsProvider', '$provide'];
  /* @ngInject */
  function themesConfig($mdThemingProvider, triThemingProvider, triSkinsProvider, $provide) {

    function setTheme() {
      /**
       *  FOR DEMO PURPOSES ALLOW SKIN TO BE SAVED IN A COOKIE
       *  This overrides any skin set in a call to triSkinsProvider.setSkin if there is a cookie
       *  REMOVE LINE BELOW FOR PRODUCTION SITE
       */
      // triSkinsProvider.useSkinCookie(true);
      // $mdThemingProvider.generateThemesOnDemand(true);

      // This is the absolutely vital part, without this, changes will not cascade down through the DOM.
      $mdThemingProvider.alwaysWatchTheme(true);

      var skin = localStorage.getItem('ls.cloudSkin');
      // if (angular.isDefined(skin)) {
      skin = angular.fromJson(skin);
      if (typeof(skin) === 'string'){
        //deals with overstirngified strings
        skin = angular.fromJson(skin);
      }

      if (typeof skin !== 'undefined' && skin && skin.hasOwnProperty('primary')) {
        $mdThemingProvider.theme('zuantCloudSkin')
          .primaryPalette(skin.primary)
          .accentPalette(skin.accent)
          .warnPalette('coral');
        // console.log('setting zuantCloudSkin to: primary ' + skin.primary + ', accent: ' + skin.accent);

      } else {
        $mdThemingProvider.theme('zuantCloudSkin')
          .primaryPalette('lagoon')
          .accentPalette('pollen')
          .warnPalette('coral');

        triThemingProvider.theme('zuantCloudSkin')
          .primaryPalette('lagoon', {
            'default': '500',
            'hue-1': '400',
            'hue-2': '600',
            'hue-3': '700'
          })
          .accentPalette('pollen', {
            'default': '500',
            'hue-1': '400',
            'hue-2': '600',
            'hue-3': '700'
          })
          .warnPalette('coral');

        triSkinsProvider.skin('z-lagoon', 'Zuant Lagoon')
          .sidebarTheme('zuantCloudSkin')
          .toolbarTheme('lagoon-white')
          .logoTheme('zuantCloudSkin')
          .contentTheme('zuantCloudSkin');
      }
      $mdThemingProvider.setDefaultTheme('zuantCloudSkin');

      $provide.value('themeProvider', $mdThemingProvider);
      /**
       *  SETS DEFAULT SKIN FOR APPLICATION
       */

      triSkinsProvider.setSkin('z-lagoon');
      // triSkinsProvider.setSkin('z-aqua');
      // triSkinsProvider.setSkin('z-pollen');
      // triSkinsProvider.setSkin('z-coral');
      // triSkinsProvider.setSkin('z-saffron');

    }

    /**
     *  PALETTES
     */

    $mdThemingProvider.definePalette('lagoon', {
      '50': '#ffffff',
      '100': '#dde6f0',
      '200': '#b6cade',
      '300': '#85a7c8',
      '400': '#7097bf',
      '500': '#5b88b5',
      '600': '#4b79a6',
      '700': '#426991',
      '800': '#385a7c',
      '900': '#2f4b67',
      'A100': '#6392C1',
      'A200': '#6DA3D8',
      'A400': '#77B0E8',
      'A700': '#426991',
      'contrastDefaultColor': 'light',
      'contrastLightColors': 'A200'
    });

    $mdThemingProvider.definePalette('aqua', {

      '50': '#666',
      '100': '#dbf2f3',
      '200': '#dbf2f3',
      '300': '#a6dee1',
      '400': '#8fd5d9',
      '500': '#78cdd1',
      '600': '#61c5c9',
      '700': '#4abcc1',
      '800': '#3cacb1',
      '900': '#34959a',
      'A100': '#85E4E9',
      'A200': '#84E3E7',
      'A400': '#8fd5d9',
      'A700': '#4abcc1',
      'contrastDefaultColor': 'light'
    });

    $mdThemingProvider.definePalette('pollen', {
      '50': '#f7f7f7',
      '100': '#f7f7f7',
      '200': '#fff1d7',
      '300': '#fed890',
      '400': '#fece71',
      '500': '#fec353',
      '600': '#feb835',
      '700': '#feae16',
      '800': '#f4a001',
      '900': '#d58c01',
      'A100': '#f7f7f7',
      'A200': '#FFDD9C',
      'A400': '#fece71',
      'A700': '#feae16',
      'contrastDefaultColor': 'light',
      'contrastLightColors': '500 700 800 900',
      'contrastStrongLightColors': '500 700 800 900'
    });

    $mdThemingProvider.definePalette('coral', {
      '50': '#ffffff',
      '100': '#fef5ea',
      '200': '#fddbb4',
      '300': '#fbba6e',
      '400': '#faab51',
      '500': '#f99d33',
      '600': '#f88f15',
      '700': '#e87f07',
      '800': '#ca6f06',
      '900': '#ad5f05',
      'A100': '#ffffff',
      'A200': '#FAAB51',
      'A400': '#faab51',
      'A700': '#e87f07',
      'contrastDefaultColor': 'light'
    });

    $mdThemingProvider.definePalette('saffron', {
      '50': '#ffffff',
      '100': '#fde5db',
      '200': '#fabfa6',
      '300': '#f58f63',
      '400': '#f47a46',
      '500': '#f26529',
      '600': '#ee510e',
      '700': '#d1470d',
      '800': '#b43d0b',
      '900': '#973409',
      'A100': '#ffffff',
      'A200': '#FF783F',
      'A400': '#f47a46',
      'A700': '#d1470d',
      'contrastDefaultColor': 'light'
    });

    $mdThemingProvider.definePalette('titanium1', {
      '50': '#e0e6ea',
      '100': '#fff',
      '200': '#fff',
      '300': '#f2f5f6',
      '400': '#e0e6ea',
      '500': '#949ca1',
      '600': '#bccad0',
      '700': '#aabbc4',
      '800': '#98adb7',
      '900': '#869eab',
      'A100': '#fff',
      'A200': '#ABB4BA',
      'A400': '#e0e6ea',
      'A700': '#aabbc4'
    });

    $mdThemingProvider.definePalette('white', {
      '50': '#ffffff',
      '100': '#ffffff',
      '200': '#ffffff',
      '300': '#ffffff',
      '400': '#ffffff',
      '500': '#f8f8f8',
      '600': '#ffffff',
      '700': '#ffffff',
      '800': '#ffffff',
      '900': '#ffffff',
      'A100': '#ffffff',
      'A200': '#ffffff',
      'A400': '#ffffff',
      'A700': '#ffffff',
      'contrastDefaultColor': 'dark'
    });

    $mdThemingProvider.definePalette('black', {
      '50': '#858585',
      '100': '#5e5e5e',
      '200': '#424242',
      '300': '#1f1f1f',
      '400': '#0f0f0f',
      '500': '#000000',
      '600': '#000000',
      '700': '#000000',
      '800': '#000000',
      '900': '#000000',
      'A100': '#858585',
      'A200': '#5e5e5e',
      'A400': '#0f0f0f',
      'A700': '#000000',
      'contrastDefaultColor': 'light'
    });

    // var triCyanMap = $mdThemingProvider.extendPalette('cyan', {
    //   'contrastDefaultColor': 'light',
    //   'contrastLightColors': '500 700 800 900',
    //   'contrastStrongLightColors': '500 700 800 900'
    // });

    // Register the new color palette map with the name triCyan
    // $mdThemingProvider.definePalette('triCyan', triCyanMap);

    /**
     *  MD-THEMES
     **/

    // LAGOON THEME

    // AQUA THEME
    // triThemingProvider.theme('zuant-aqua-theme')
    //   .primaryPalette('zuant-aqua', {
    //     'default': '500',
    //     'hue-1': '400',
    //     'hue-2': '600',
    //     'hue-3': '700'
    //   })
    //   .accentPalette('zuant-pollen', {
    //     'default': '500'
    //   })
    //   .warnPalette('zuant-pollen')
    //   .backgroundPalette('zuant-titanium-1');

    // POLLEN THEME
    // triThemingProvider.theme('zuant-pollen-theme')
    //   .primaryPalette('zuant-pollen', {
    //     'default': '500'
    //   })
    //   .accentPalette('zuant-aqua', {
    //     'default': '500'
    //   })
    //   .warnPalette('zuant-saffron')
    //   .backgroundPalette('black');

    // CORAL THEME
    // triThemingProvider.theme('zuant-coral-theme')
    //   .primaryPalette('zuant-coral', {
    //     'default': '500'
    //   })
    //   .accentPalette('zuant-aqua', {
    //     'default': '500'
    //   })
    //   .warnPalette('zuant-saffron');

    // SAFFRON THEME
    // triThemingProvider.theme('zuant-saffron-theme')
    //   .primaryPalette('zuant-saffron', {
    //     'default': '500'
    //   })
    //   .accentPalette('zuant-saffron', {
    //     'default': '500'
    //   })
    //   .warnPalette('zuant-pollen');

    // triThemingProvider.theme('zuant-titanium1-theme')
    //   .primaryPalette('zuant-titanium-1', {
    //     'default': '500'
    //   })
    //   .accentPalette('zuant-titanium-1')
    //   .warnPalette('zuant-titanium-1');

    triThemingProvider.theme('lagoon-white')
      .primaryPalette('white')
      .accentPalette('lagoon', {
        'default': '500',
        'hue-1': '400'
      })
      .warnPalette('white');

    // triThemingProvider.theme('aqua-white')
    //   .primaryPalette('white', {
    //     'default': '500'
    //   })
    //   .accentPalette('zuant-aqua', {
    //     'default': '500',
    //     'hue-1': '400'
    //   })
    //   .warnPalette('zuant-pollen');

    // triThemingProvider.theme('pollen-white')
    //   .primaryPalette('white')
    //   .accentPalette('zuant-pollen', {
    //     'default': '500',
    //     'hue-1': '400'
    //   })
    //   .warnPalette('white');

    // triThemingProvider.theme('coral-white')
    //   .primaryPalette('white')
    //   .accentPalette('zuant-coral', {
    //     'default': '500',
    //     'hue-1': '400'
    //   })
    //   .warnPalette('white');

    // triThemingProvider.theme('saffron-white')
    //   .primaryPalette('white')
    //   .accentPalette('zuant-saffron', {
    //     'default': '500',
    //     'hue-1': '400'
    //   })
    //   .warnPalette('white');

    /**
    ZUANT BLOCK SIDEBAR SKINS
    **/
    // ZUANT LAGOON SKIN
    // triSkinsProvider.skin('z-lagoon', 'Zuant Lagoon')
    //   .sidebarTheme('zuantCloudSkin')
    //   .toolbarTheme('lagoon-white')
    //   .logoTheme('zuantCloudSkin')
    //   .contentTheme('zuantCloudSkin');

    // ZUANT AQUA SKIN
    // triSkinsProvider.skin('z-aqua', 'Zuant Aqua')
    //   .sidebarTheme('aqua-white')
    //   .toolbarTheme('zuant-aqua-theme')
    //   .logoTheme('aqua-white')
    //   .contentTheme('zuant-aqua-theme');

    // ZUANT POLLEN SKIN
    // triSkinsProvider.skin('z-pollen', 'Zuant Pollen')
    //   .sidebarTheme('zuant-pollen-theme')
    //   .toolbarTheme('pollen-white')
    //   .logoTheme('zuant-pollen-theme')
    //   .contentTheme('zuant-pollen-theme');

    // ZUANT CORAL SKIN
    // triSkinsProvider.skin('z-coral', 'Zuant Coral')
    //   .sidebarTheme('zuant-coral-theme')
    //   .toolbarTheme('coral-white')
    //   .logoTheme('zuant-coral-theme')
    //   .contentTheme('zuant-coral-theme');

    // ZUANT SAFFRON SKIN
    // triSkinsProvider.skin('z-saffron', 'Zuant Saffron')
    //   .sidebarTheme('zuant-saffron-theme')
    //   .toolbarTheme('saffron-white')
    //   .logoTheme('zuant-saffron-theme')
    //   .contentTheme('zuant-titanium1-theme');

    // END SIDEBAR BLOCK COLOR SKINS

    /**
     * ZUANT GREY SIDEBAR BLOCK HEADER SKINS
     *
     */
    // ZUANT LAGOON SKIN
    // triSkinsProvider.skin('z-lagoon-h', 'Zuant Lagoon Header')
    //   .sidebarTheme('zuant-titanium1-theme')
    //   .toolbarTheme('zuantCloudSkin')
    //   .logoTheme('zuantCloudSkin')
    //   .contentTheme('lagoon-white');

    // setTheme calls function up top that sets the theme. Moved up for easy access but breaks if called before the above has been set up.
    setTheme();

  }
})();

(function () {
  'use strict';

  angular
    .module('app.themes')
    .factory('CloudAppThemeFactory', factory);

  factory.$inject = ['ListApiFactory', '$q', 'localStorageService', 'SessionService', 'MessageService', 'triTheming'];
  /* ng-inject */
  function factory(ListApiFactory, $q, localStorageService, session, MessageService, triTheming) {

    var factoryData = {
      skinCurrentlyEnabled: false,
      currentCloudAppThemeId: localStorageService.get('cloudDashboardBackgroundImage_' + session.getUserData().databasename)
    };

    return {
      refreshThemeIfNecessary: refreshThemeIfNecessary,
      setCloudDashboardImage: setCloudDashboardImage,
      setCloudSkinLocalStorage: setCloudSkinLocalStorage,
      factoryData: factoryData
    };

    function refreshThemeIfNecessary() {
      return $q(function q(resolve, reject) {
        try {
          var clientDoc = session.getUserData(),
            primaryThemeDoc,
            img = localStorageService.get('cloudDashboardBackgroundImage_' + clientDoc.databasename);

          if (img) {
            if (img.id === factoryData.currentCloudAppThemeId) {
              // currently loaded theme is correct, no api trip required
              factoryData.skinCurrentlyEnabled = true;
              return resolve({
                pageReloadRequired: false
              });
            }
          }

          if (typeof clientDoc.permissions.boltOns.customSkins === 'undefined') {
            return resolve(setDefaultZuantThemes());
          }

          if (clientDoc.permissions.boltOns.customSkins.enabled) {
            // MessageService.writeLog({
            //   level: 'info',
            //   msg: 'off to query artefacts for { isPrimaryTheme: true }',
            //   tags: ['CloudAppThemeFactory']
            // });

            resolve(ListApiFactory.getArtefactsByQuery({
              isPrimaryTheme: true
            })
              .then(function (res) {
                primaryThemeDoc = res.data.data[0] || 'no primary theme set';
                if (primaryThemeDoc !== 'no primary theme set') {
                  factoryData.skinCurrentlyEnabled = true;
                }

                // MessageService.writeLog({
                //   level: 'info',
                //   msg: 'back with ' + res.data.data.length + ' primary theme docs.',
                //   tags: ['CloudAppThemeFactory']
                // });

                if (_.isObject(primaryThemeDoc)) {
                  factoryData.currentCloudAppThemeId = primaryThemeDoc.cloudDashboardBackgroundImage;
                }
                return updateLocalStorageAndDashboardImage({
                  theme: primaryThemeDoc,
                  dbname: clientDoc.databasename
                });
              })
              .catch(function (err) {
                throw (err);
              }));

          } else {
            resolve(setDefaultZuantThemes());
          }

        } catch (e) {
          MessageService.writeLog({
            level: 'error',
            msg: e,
            tags: ['custom_skins']
          });
          return reject(e);
        }
      });

      function setDefaultZuantThemes() {
        factoryData.skinCurrentlyEnabled = false;
        return updateLocalStorageAndDashboardImage({
          theme: {
            default: true
          }
        });
      }
    }

    function updateThemeCSSVars() {
      const themePrimaryColor = triTheming.getThemeHue('zuantCloudSkin', 'primary', 'default');
      const themeAccentColor = triTheming.getThemeHue('zuantCloudSkin', 'accent', 'default');
      const themeWarnColor = triTheming.getThemeHue('zuantCloudSkin', 'warn', 'default');
      document.documentElement.style.setProperty('--md-theme-primary-color', triTheming.rgba(themePrimaryColor.value));
      document.documentElement.style.setProperty('--md-theme-accent-color', triTheming.rgba(themeAccentColor.value));
      document.documentElement.style.setProperty('--md-theme-warn-color', triTheming.rgba(themeWarnColor.value));
    }

    function updateLocalStorageAndDashboardImage(details) {
      // returns if page requires reloading or not. (if cloud palette is changing then page needs to reload to take effect)
      return $q(function q(resolve, reject) {
        
        updateThemeCSSVars();

        var localStorageCheckResponse = localStorageCheck(details);
        if (details.theme === 'no primary theme set') {
          factoryData.noPrimaryThemeIsSet = true; // to show user that custom skins is enabled but no default theme is set
          factoryData.currentThemeId = '';
          return resolve(localStorageCheckResponse);
        }
        if (details.theme.default) {
          return resolve(localStorageCheckResponse);
        }
        // we have a theme that needs setting!
        factoryData.noPrimaryThemeIsSet = false;
        return dashboardImageCheck(details)
          .then(function () {
            var responseObject = {
              pageReloadRequired: localStorageCheckResponse.pageReloadRequired
            };
            return resolve(responseObject);
          })
          .catch(function (err) {
            reject(err);
          });

      });
    }

    function localStorageCheck(details) {
      var currentThemeLocalStorage = localStorageService.get('cloudSkin');
      currentThemeLocalStorage = angular.fromJson(currentThemeLocalStorage);
      if (angular.isDefined(currentThemeLocalStorage) && currentThemeLocalStorage) {
        if (details.default) {
          if (currentThemeLocalStorage.primary !== 'lagoon' || currentThemeLocalStorage.accent !== 'pollen') {
            return refreshLocalStorage('default');
          }
        }
      } else {
        // no theme cookie so set default and return
        return refreshLocalStorage('default');
      }

      if (details.theme.cloudPrimaryColor !== currentThemeLocalStorage.primary || details.theme.cloudAccentColor !== currentThemeLocalStorage.accent) {
        return refreshLocalStorage(details.theme);
      } else {
        return {
          pageReloadRequired: false
        };
      }

    }

    function refreshLocalStorage(theme) {
      if (theme.default || theme === 'no primary theme set') {
        localStorageService.set('cloudSkin', angular.toJson({
          primary: 'lagoon',
          accent: 'pollen'
        }));
      } else {
        localStorageService.set('cloudSkin', angular.toJson({
          primary: theme.cloudPrimaryColor,
          accent: theme.cloudAccentColor
        }));
      }

      return {
        pageReloadRequired: true
      };
    }

    function dashboardImageCheck(details) {
      return $q(function q(resolve, reject) {
        if (!details.theme.cloudDashboardBackgroundImage) {
          return resolve();
        }

        var existingImageForAccount = localStorageService.get('cloudDashboardBackgroundImage_' + session.getUserData().databasename);
        if (existingImageForAccount) {
          if (existingImageForAccount.id === details.theme.cloudDashboardBackgroundImage) {
            return resolve();
          }
        }
        return ListApiFactory.getArtefactById(details.theme.cloudDashboardBackgroundImage)
          .then(function (res) {
            setCloudDashboardImage({
              id: res.data.data._id,
              title: res.data.data.title,
              weburi: res.data.data.weburi,
              _s3key: res.data.data._s3key
            });
            return resolve();
          })
          .catch(function (err) {
            reject(err);
          });
      });
    }

    function setCloudDashboardImage(imageObj) {
      const objToStore = {
        id: imageObj.id,
        title: imageObj.title,
        weburi: imageObj.weburi,
        _s3key: imageObj._s3key
      };

      localStorageService.set('cloudDashboardBackgroundImage_' + session.getUserData().databasename, objToStore);
      factoryData.currentCloudAppThemeId = imageObj.id;
    }

    function setCloudSkinLocalStorage(cookieObj) {
      localStorageService.set('cloudSkin', angular.toJson(cookieObj));
    }
  }
}());

(function () {
  'use strict';

  angular.module('showroom').config(moduleConfig);

  moduleConfig.$inject = ['$stateProvider'];

  function moduleConfig($stateProvider) {

    $stateProvider.state('app.oldshowroom.showroom', {
      abstract: true,
      url: '/showroom',
      views: {
        'spof': {
          template: '<div ui-view="spof" layout-fill></div>'
        },
        'fab-container': {
          component: 'zpShowroomFab'
        }
      },
      data: {
        permissions: {
          only: ['SHOWROOM_EDIT']
        }
      }
    });

    $stateProvider.state('app.oldshowroom.showroom.dashboard', {
      url: '/dashboard',
      title: 'Showroom Dashboard',
      views: {
        'spof': {
          component: 'dashboardMain'
        }
      },
      data: {
        permissions: {
          only: ['SHOWROOM_EDIT']
        }
      }
    });

    $stateProvider.state('app.oldshowroom.showroom.literature', {
      url: '/literature',
      title: 'Showroom Literature',
      views: {
        'spof': {
          component: 'literatureCards'
        },
        'showroom-fab': {
          component: 'zpAddLiteratureFab'
        }
      },
      data: {
        permissions: {
          only: ['SHOWROOM_EDIT']
        }
      },
      resolve: {
        literature: ['literatureManager', 'tagsManager', '$q', 'ToolbarFactory', 'blocksManager', 'blocksXrefLiteratureManager', function (literatureManager, tagsManager, $q, ToolbarFactory, blocksManager, blocksXrefLiteratureManager) {
          ToolbarFactory.set({
            title: 'Literature library',
            navigationPath: 'app.oldshowroom.showroom.dashboard',
            showBackButton: true,
            customStateParams: {
              isDirtyCheck: true
            }
          });
          literatureManager.factoryData.inCardView = false;
          return $q.all([literatureManager.hydrateOrRefresh(), tagsManager.hydrateOrRefresh()])
            .then(blocksManager.hydrateOrRefresh)
            .then(function () {
              blocksXrefLiteratureManager.secondStageHydrateModel();
              blocksManager.secondStageHydrateModel();
              blocksManager.requestBlockStatsUpdate();
            });
        }]
      }
    });

    $stateProvider.state('app.oldshowroom.showroom.tags', {
      url: '/tags',
      title: 'Showroom Tags',
      views: {
        'spof': {
          component: 'tagsMain'
        }
      },
      data: {
        permissions: {
          only: ['SHOWROOM_EDIT']
        }
      },
      resolve: {
        literature: ['literatureManager', 'tagsManager', '$q', 'ToolbarFactory', function (literatureManager, tagsManager, $q, ToolbarFactory) {
          ToolbarFactory.set({
            title: 'Tags',
            navigationPath: 'app.oldshowroom.showroom.dashboard',
            showBackButton: true,
            customStateParams: {
              isDirtyCheck: true
            }
          });
          literatureManager.factoryData.inCardView = false;
          return $q.all([literatureManager.hydrateOrRefresh(), tagsManager.hydrateOrRefresh()]);
        }]
      }
    });

    $stateProvider.state('app.oldshowroom.showroom.blocks', {
      url: '/blocks',
      title: 'Showroom Plus',
      views: {
        'spof': {
          component: 'blocksMain'
        }
      },
      resolve: {
        blocksxreflitsvcreference: ['$q', '$log', 'literatureManager', 'tagsManager', 'ImagesApiFactory', 'blocksManager', 'blocksXrefLiteratureManager', 'ToolbarFactory', function ($q, $log, literatureManager, tagsManager, ImagesApiFactory, blocksManager, blocksXrefLiteratureManager, ToolbarFactory) {
          var defer = $q.defer();

          ToolbarFactory.set({
            title: 'Blocks',
            navigationPath: 'app.oldshowroom.showroom.dashboard',
            showBackButton: true,
            customStateParams: {
              isDirtyCheck: true
            }
          });

          literatureManager.hydrateOrRefresh()
            .then(tagsManager.hydrateOrRefresh)
            .then(blocksManager.hydrateOrRefresh)
            .then(ImagesApiFactory.getImages)
            .then(
              function () {
                blocksXrefLiteratureManager.secondStageHydrateModel();
                blocksManager.secondStageHydrateModel();
                blocksManager.requestBlockStatsUpdate();

                $log.info('EVERYTHING NOW RESOLVED, blocks logged below');
                $log.info(blocksManager.blocks);

                defer.resolve();
              },
              function (nasty) {
                $log.info('Nastiness occurred building the models');
                $log.info(nasty);
                defer.reject(nasty);
              }
            );

          return defer.promise;
        }]
      },
      data: {
        permissions: {
          only: ['SHOWROOM_BLOCKS']
        }
      }
    });

    $stateProvider.state('app.oldshowroom.showroom.images', {
      url: '/images',
      title: 'Showroom Images',
      views: {
        'spof': {
          component: 'imagesMain'
        },
        'showroom-fab': {
          component: 'zpAddImageFab'
        }
      },
      resolve: {
        imagesListSvcRef: ['ImagesApiFactory', 'ToolbarFactory', 'literatureManager', function (ImagesApiFactory, ToolbarFactory, literatureManager) {

          ToolbarFactory.set({
            title: 'Images',
            navigationPath: 'app.oldshowroom.showroom.dashboard',
            showBackButton: true,
            customStateParams: {
              isDirtyCheck: true
            }
          });
          literatureManager.factoryData.inCardView = false;
          return ImagesApiFactory.getImages();
        }]
      },
      data: {
        permissions: {
          only: ['SHOWROOM_EDIT']
        }
      },
    });

    $stateProvider.state('app.oldshowroom.showroom.dropbox', {
      url: '/dropbox',
      title: 'Showroom Dropbox Connector',
      views: {
        'spof': {
          component: 'dropboxMain',
          bindings: {
            message: 'message'
          }
        }
      },
      data: {
        permissions: {
          only: ['SHOWROOM_EDIT']
        }
      },
      resolve: {
        literature: ['literatureManager', '$q', 'tagsManager', 'ToolbarFactory', function (literatureManager, $q, tagsManager, ToolbarFactory) {
          ToolbarFactory.set({
            title: 'Dropbox',
            navigationPath: 'app.oldshowroom.showroom.dashboard',
            showBackButton: true,
            customStateParams: {
              isDirtyCheck: true
            }
          });
          literatureManager.factoryData.inCardView = false;
          return $q.all([literatureManager.hydrateOrRefresh(), tagsManager.hydrateOrRefresh()]);
        }]
      }
    });

    $stateProvider.state('app.oldshowroom.showroom.dropboxCallback', {
      url: '/dropboxCallback',
      views: {
        'spof': {
          component: 'zpDropboxCallback',
          bindings: {}
        }
      },
      resolve: {},
      data: {
        permissions: {
          only: ['SHOWROOM_EDIT']
        }
      },
    });

    $stateProvider.state('app.oldshowroom.showroom.import', {
      url: '/import',
      title: 'Showroom Import CSV',
      views: {
        'spof': {
          component: 'fileImportMain'
        }
      },
      data: {
        permissions: {
          only: ['SHOWROOM_EDIT']
        }
      },
      resolve: {
        literature: ['literatureManager', 'tagsManager', '$q', 'ToolbarFactory', function (literatureManager, tagsManager, $q, ToolbarFactory) {
          ToolbarFactory.set({
            title: 'Import',
            navigationPath: 'app.oldshowroom.showroom.dashboard',
            showBackButton: true,
            customStateParams: {
              isDirtyCheck: true
            }
          });
          literatureManager.factoryData.inCardView = false;
          return $q.all([literatureManager.hydrateOrRefresh(), tagsManager.hydrateOrRefresh()]);
        }]
      }
    });

    $stateProvider.state('app.oldshowroom.showroom.artefacts', {
      url: '/import-lookup-data',
      title: 'Showroom Import Lookup Data',
      views: {
        'spof': {
          component: 'artefactsMain'
        }
      },
      data: {
        permissions: {
          only: ['TRUMP']
        }
      },
      resolve: {
        literature: ['literatureManager', 'tagsManager', '$q', 'ToolbarFactory', function (literatureManager, tagsManager, $q, ToolbarFactory) {
          ToolbarFactory.set({
            title: 'Import Lookup Data',
            navigationPath: 'app.oldshowroom.showroom.dashboard',
            showBackButton: true,
            customStateParams: {
              isDirtyCheck: true
            }
          });
          literatureManager.factoryData.inCardView = false;
          return $q.all([literatureManager.hydrateOrRefresh(), tagsManager.hydrateOrRefresh()]);
        }]
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('lists')
    .config(moduleConfig);

  moduleConfig.$inject = ['$stateProvider'];
  /* ng-inject */
  function moduleConfig($stateProvider) {

    $stateProvider
      .state('app.homescreen_app_framework.lists_home', {
        url: '/lists/home',
        title: 'Lists',
        views: {
          'toolbarSection': {
            component: 'zpListSearchToolbar'
          },
          'spof': {
            component: 'zpLists'
          },
          'right-hand-container': {
            component: 'zpListsWidgetContainer'
          },
          'fab-container': {
            component: 'zpAddListFab'
          }
        },
        data: {
          permissions: {
            only: ['LISTS_VIEW']
          }
        },
        resolve: {
          model: ['$q', 'ListOfListsFactory', 'OCRTemplatesFactory', 'ToolbarFactory', function (promise, listsfactory, ocrfactory, toolbarfactory) {
            return new promise(function (resolve, reject) {
              return listsfactory.getListOfLists('ValueList')
                .then(function () {
                  return ocrfactory.getOCRtemplates();
                })
                .then(function () {
                  toolbarfactory.set({
                    title: 'Lists home',
                    navigationPath: '',
                    showBackButton: false
                  });
                  resolve(listsfactory);
                })
                .catch(reject); // where upstream does this surface so I can inspect?
            });
          }]
        }
      })
      .state('app.toolbar_app_framework.list_detail', {
        url: '/lists/add-items/:_id',
        title: 'List Detail',
        views: {
          'spof': {
            component: 'zpListDetailPage'
          },
          'fab-container': {
            component: 'zpAddListItemFab'
          }
        },
        data: {
          permissions: {
            only: ['LISTS_VIEW']
          }
        },
        resolve: {
          model: ['$q', 'CurrentListModel', '$transition$', 'ToolbarFactory', function (promise, factory, $transition$, toolbarfactory) {
            return new promise(function (resolve, reject) {
              return factory.hydrateWithCurrentList($transition$.params()._id)
                .then(function (res) {
                  toolbarfactory.set({
                    title: res.title,
                    navigationPath: 'app.homescreen_app_framework.lists_home',
                    showBackButton: true,
                    customStateParams: {
                      isDirtyCheck: true
                    }
                  });
                  resolve(factory);
                })
                .catch(reject);
            });
          }]
        }
      })
      .state('app.ocr_template', {
        url: '/lists/ocr-template/:_id',
        title: 'OCR Template',
        views: {
          'spof': {
            component: 'zpOcrTemplateDetailPage'
          }
        },
        data: {
          permissions: {
            only: ['LISTS_VIEW']
          }
        },
        resolve: {
          model: ['$q', 'OCRTemplateEditorDataFactory', '$transition$', 'ToolbarFactory', function (promise, factory, $transition$, toolbarfactory) {
            return new promise(function (resolve, reject) {
              return factory.fetchDataForComponent($transition$.params()._id)
                .then(function () {
                  toolbarfactory.set({
                    title: res.title,
                    navigationPath: 'app.homescreen_app_framework.lists_home',
                    showBackButton: true,
                    customStateParams: {
                      isDirtyCheck: true
                    }
                  });
                  resolve(factory);
                })
                .catch(reject);
            });
          }]
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('lists')
    .factory('ListsGeneralFactory', factory);

  factory.$inject = ['ListApiFactory', '$q', 'MessageService', 'FormsHelperFactory', 'FormMetadataFactory'];
  /* ng-inject */
  function factory(ListApiFactory, $q, MessageService, FormsHelperFactory, FormMetadataFactory) {

    var listsCache = {};
    return {
      getListById: getListById,
      invalidateCache: invalidateCache,
      resolveCellValue: resolveCellValue,
      ensureListCacheIsHydratedWithLists: ensureListCacheIsHydratedWithLists
    };

    function getListById(listId) {
      return $q(function q(resolve, reject) {
        if (listsCache[listId]) {
          resolve(listsCache[listId]);
        } else {
          ListApiFactory.getArtefactById(listId)
            .then(function (res) {
              var items = res.data.data.items.map(function (doc) {
                return {
                  displayValue: doc.reportingLabel || doc.caption || doc.code,
                  keyValue: doc.code || doc.caption,
                  points: doc.points,
                  showMoreInfoTextfield: doc.showMoreInfoTextfield
                };
              });
              listsCache[listId] = res.data.data;
              listsCache[listId].itemsForSelectControl = items;
              resolve(listsCache[listId]);
            })
            .catch(function (err) {
              reject(err);
            });
        }
      });
    }

    function invalidateCache() {
      listsCache = {};
    }

    function resolveCellValue(listId, cellValue) {
      var item = _.find(listsCache[listId].items, function (item) {
        return item.code == cellValue || item.caption == cellValue;
      });
      if (!item) return undefined;
      return item.code ? item.code : item.caption;
    }

    function ensureListCacheIsHydratedWithLists() {
      var form = FormMetadataFactory.getData(), // grab form metadata
        formColumns = angular.copy(form.columnsData.items),
        arrOfListIds = FormsHelperFactory.findAllListsInForm(formColumns);

      return $q(function q(resolve) {

        // if (arrOfListIds.length == 0) resolve(true); // no external lists required. carry on
        var arrOfPromises = [];
        _.each(arrOfListIds, function (listId) {
          arrOfPromises.push(getListById(listId));
        });

        resolve($q.all(arrOfPromises)
          .then(function () {
            return true;
          })
          .catch(function (err) {
            MessageService.writeLog({
              level: 'error',
              msg: err,
              tags: ['ListsGeneralFactory']
            });
            return true; // still need this to work despite list not being found
          }));

      });

    }

  }
}());

(function () {
  'use strict';

  angular
    .module('lists')
    .factory('ListApiFactory', ListApiFactory);

  ListApiFactory.$inject = ['APIService', 'APIFactory', 'EncodingService'];
  /* ng-inject */
  function ListApiFactory(api, apiFactory, encoder) {

    const listApi = apiFactory.route('list');

    return {
      getArtefactById: listApi.getById,
      getArtefactsByQuery: getArtefactsByQuery,
      getAuditDocByQuery: getAuditDocByQuery,
      saveList: listApi.update,
      deleteList: listApi.delete,
      addNewListItem: listApi.updateProperty.bind(null, 'item'),
      saveNewList: listApi.create,
      saveTheme: saveTheme,
      setPrimaryTheme: setPrimaryTheme,
      savePrivacyStatementAudit: savePrivacyStatementAudit,
      getPrivacyStatements: getPrivacyStatements,
      deletePrivacyStatement: deletePrivacyStatement,
      getListTemplates: getListTemplates
    };

    //////////////////////////////////


    function getListTemplates() {
      const apiUrl = 'list/templates';

      return api.get(apiUrl)
        .then(function (response) {
          return response.data.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function getArtefactsByQuery(query, fields) {

      const apiUrl = 'list/query',
        queryObj = {
          parameters: query,
          fields: fields
        };

      return api.post(apiUrl, queryObj)
        .then(function (response) {
          return response;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function getAuditDocByQuery(query, fields) {
      const url = 'list/getAuditDocByQuery';
      const queryObj = {
        parameters: query,
        fields: fields
      };
      return api.post(url, queryObj)
        .then(function (response) {
          return response;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function saveTheme(theme) {
      const apiUrl = 'list/saveTheme';
      return api.post(apiUrl, theme)
        .then(function (response) {
          return response;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function setPrimaryTheme(themeId) {
      const apiUrlEncoded = 'list/setPrimaryTheme/' + encoder.encode(themeId);
      return api.post(apiUrlEncoded)
        .then(function (response) {
          return response;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function getPrivacyStatements(props){
      const apiUrl = 'list/getPrivacyStatements';
      return api.post(apiUrl, props)
        .then(function (response) {
          return response;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function savePrivacyStatementAudit(data) {
      const apiUrlEncoded = 'list/savePrivacyStatementAudit/' + encoder.encode(data._id);
      return api.post(apiUrlEncoded, data)
        .then(function (response) {
          return response;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function deletePrivacyStatement(_id){
      const apiUrlEncoded = 'list/deletePrivacyStatement/' + encoder.encode(_id);
      return api.delete(apiUrlEncoded)
        .then(function (response) {
          return response;
        })
        .catch(function (err) {
          throw (err);
        });
    }

  }
})();

/**
 * Created by davidbeazer on 14/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('lists')
    .factory('ListOfListsFactory', ListOfListsFactory);

  ListOfListsFactory.$inject = ['ListApiFactory', '$filter', 'ListMainMetadata', '$q', 'MessageService', 'localStorageService'];
  /* ng-inject */
  function ListOfListsFactory(ListApiFactory, $filter, ListMainMetadata, $q, MessageService, localStorageService) {

    var factoryData = {
      items: [],
      itemsObject: {},
      cacheValid: false
    };

    return {
      getListOfLists: getListOfLists,
      getData: getData,
      invalidateCache: invalidateCache,
      toggleShowArchivedSwitch: toggleShowArchivedSwitch
    };

    function getListOfLists(artefactType) {
      return $q(
        function q(resolve, reject) {
          if (factoryData.cacheValid) {
            hydrateFactoryWithLists(factoryData.rawItemsArray);
            resolve(factoryData);
          } else {
            ListApiFactory.getArtefactsByQuery({
              artefactType: artefactType
            }, {})
              .then(function (res) {
                hydrateFactoryWithLists(res.data.data);
                resolve(factoryData);
              })
              .catch(function (err) {
                MessageService.writeLog({
                  level: 'error',
                  msg: 'error fetching artefacts by type: ' + err,
                  tags: ['lists']
                });
                reject(err);
              });
          }
        });
    }

    function hydrateFactoryWithLists(data){
      factoryData.items = data;
      factoryData.rawItemsArray = angular.copy(data);

      var filteredLists = filterListsToShow(factoryData.items);
      var shapedItemsArray = shapeDataForGrid(filteredLists);
      var arrayToMap = angular.copy(shapedItemsArray);
      factoryData.items = $filter('enhancedTableCells')(ListMainMetadata.getData(), shapedItemsArray);

      var listsObject = _.reduce(arrayToMap, function (listsObject, v) {
        listsObject[v.list._id] = v;
        return listsObject;
      }, {});
      factoryData.itemsObject = listsObject;
      factoryData.cacheValid = true;
    }

    function filterListsToShow(items){
      var hideArchivedLists = localStorageService.get('hideArchivedLists');
      var filteredArray = _.filter(items, function (obj) {
        if (obj._deletedatelocalutc && !hideArchivedLists) {
          return true;
        } else if (!obj._deletedatelocalutc) {
          return true;
        }
      });
      return filteredArray;
    }

    function getData() {
      return factoryData;
    }

    function shapeDataForGrid(arrayOfUnprocessedItems) {
      return _.map(arrayOfUnprocessedItems, function (item) {
        return {
          list: {
            _id: item._id,
            title: item.title || '',
            items: item.items.length || 0,
            _lastmodifiedonservertime: item._lastmodifiedonservertime || '',
            icn: setStringForIcon(item)
          }
        };
      });
    }

    function setStringForIcon(obj) {
      if (obj._deletedatelocalutc) {
        return 'archived';
      } else if (obj.published == 1) {
        return 'published';
      } else if (obj.published == 0) {
        return 'draft';
      } else {
        return 'published';
      }
    }

    function invalidateCache() {
      factoryData.cacheValid = false;
    }

    function toggleShowArchivedSwitch(value){
      if (!value) {
        factoryData.cacheValid = false; // invalidate to force server trip for forms
      }
      localStorageService.set('hideArchivedLists', value);
      return getListOfLists('ValueList');
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('SaveMachineFactory', factory);

  factory.$inject = ['IntegrationApiFactory', 'SessionService', 'MessageService'];
  /* ng-inject */
  function factory(IntegrationApiFactory, SessionService, MessageService) {

    return function saveMachine(machineToSave, savedMessage) {
      return IntegrationApiFactory.saveMachine({
        clientId: SessionService.getUserData().clientId,
        machine: machineToSave
      })
        .then(function (res) {
          if (res.status === 'ok') {
            if (savedMessage) MessageService.showMessage(savedMessage);
            MessageService.writeLog({
              level: 'info',
              msg: '💾 Save machine success: _machineid ' + machineToSave._machineid,
              tags: ['integration', 'machine_save']
            });
          }
        })
        .catch(function (err) {
          MessageService.showMessage(err);
          MessageService.writeLog({
            level: 'error',
            msg: err,
            tags: ['integration', 'machine_save']
          });
        });
    };

  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('NewMachineModel', factory);

  factory.$inject = ['uuidService', 'SessionService'];
  /* ng-inject */
  function factory(uuid, SessionService) {

    return function newMachineShell() {
      const userData = SessionService.getUserData();
      return {
        _machineid: uuid.getSingleNewBase64Key(),
        _createDate: new Date(),
        name: '',
        sourceZuantFormId: '',
        machinetype: 'QueueInExternalOut',
        machineInfo: {
          notes: '',
          lastEditedBy: userData.firstname + ' ' + userData.surname,
          lastEditedTimeStamp: new Date()
        },
        sensor: {
          system: 'HPS',
          collection: 'responses',
          filters: [{
            formids: []
          }]
        },
        actuator: {
          system: '',
          action: '',
          object: '',
          fundamentaltype: '',
          typeid: '',
          typename: ''
        },
        /*
        Correct actuator structures as of Octorber 17th 2018
          Eloqua example
            "system" : "Eloqua",
            "action" : "replicate",
            "fundamentaltype" : "Form",
            "typeid" : "31",
            "typename" : "ZuantPrimitive",

          SFDC example
            "system" : "SFDC",
            "action" : "replicatecontactandresponse",
            "object" : "Lead"

          HttpPost
            "system" : "HttpPost",
            "action" : "replicate",
            "uri" : "https://analytics.clickdimensions.com/forms/?visitor=lead"
        */
        mappings: [],
        /*
        mapping structures
        hps: {
          collection: 'companies | contacts | responses',
          element: 'dbname_of_element'
        }
        eloqua: {
          field: newField,
          object: 'Eloqua form name'
        }
        sfdc: {
          field: newField,
          object: 'Lead'
        }
        foreign: {
          field: newField,
          object: 'Lead'
        }
      }
        */
        useWildcardMapping: false
        /*
        bypasses field mappings and posts all fields from company, contact and response objects. Only works with HttpPost machines
        */
      };
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('MachinesFactory', factory);

  factory.$inject = ['SessionService', 'MessageService', 'IntegrationApiFactory', 'NewMachineModel', 'FormsFactory', 'GlobalAccessFactory', 'SaveMachineFactory'];
  /* ng-inject */
  function factory(SessionService, MessageService, IntegrationApiFactory, NewMachineModel, FormsFactory, GlobalAccessFactory, SaveMachineFactory) {

    const factoryData = {
      items: [],
      itemsObject: {},
      rawMachinesData: [],
      dataCache: {
        valid: false,
        lastServerTripTimestamp: null,
        clientId: null
      }
    };

    return {
      getMachines: getMachinesRawData,
      getCurrentMachine,
      getSingleMachineDoc,
      saveMachine,
      newMachineShell,
      deleteMachine,
      invalidateCache,
      setMachineAction,
      machinesSetToRunForForm,
      factoryData: factoryData
    };

    function invalidateCache() {
      factoryData.dataCache.valid = false;
    }

    function getCurrentMachine(machineId) {
      return factoryData.itemsObject[machineId];
    }

    function getMachinesRawData() {
      // TODO implement cache validation
      return IntegrationApiFactory.getMachinesForAccount(SessionService.getUserData().clientId)
        .then(function (res) {
          factoryData.rawMachinesData = ensureMachineModelsAreConsistent(res.data[0].machines);
          return FormsFactory.getAllForms(true);
        })
        .then(function (res) {
          _.each(factoryData.rawMachinesData, function (machine) {
            try {
              machine.sourceZuantFormname = res.itemsObject[machine.sourceZuantFormId].form.formname.raw;
            } catch (e) {
              machine.sourceZuantFormname = 'Missing form';
            }
          });
          return {
            machines: factoryData.rawMachinesData
          };
        })
        .catch(function (err) {
          // TODO handle this error!
          throw err;
        });
    }

    function getSingleMachineDoc(machineId) {
      return new Promise(function (resolve, reject) {
        if (!factoryData.rawMachinesData) reject('no machines loaded');
        const locatedMachine = _.find(factoryData.rawMachinesData, function (m) {
          return m._machineid === machineId;
        });
        if (locatedMachine) {
          resolve({
            machine: locatedMachine
          });
        } else {
          reject('machine not found');
        }
      });
    }

    function deleteMachine(machineIdToDelete) {
      MessageService.writeLog({
        level: 'info',
        msg: '🗑️ deleting machine with id ' + machineIdToDelete,
        tags: ['integration']
      });

      return IntegrationApiFactory.deleteMachine({
        clientId: SessionService.getUserData().clientId,
        machineIdToDelete: machineIdToDelete
      })
        .then(function () {
          MessageService.showMessage('Machine deleted');
          MessageService.writeLog({
            level: 'info',
            msg: '🗑️ machine deleted successfully ' + machineIdToDelete,
            tags: ['integration', 'delete_machine']
          });
          return Promise.resolve(invalidateCache());
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: '🗑️ machine deleted unsuccessfully ' + machineIdToDelete,
            tags: ['integration', 'delete_machine']
          });
          throw err;
        });
    }

    function newMachineShell() {
      return NewMachineModel();
    }

    function saveMachine(machine, savedMessage) {
      const validation = validateMachine(machine);
      if (validation.errMsg) return MessageService.showMessage(validation.errMsg);
      const machineReadyToSave = prepMachineForSave(validation.machine);

      return SaveMachineFactory(machineReadyToSave, savedMessage)
        .then(function (res) {
          invalidateCache();
          MessageService.writeLog({
            level: 'info',
            msg: 'Machine saved: savedMessage = ' + savedMessage,
            tags: ['integration', 'machine_save']
          });
          return res;
        })
        .catch(function (err) {
          MessageService.writeLog({
            level: 'error',
            msg: '💾 error saving new machine: ' + JSON.stringify(err),
            tags: ['integration', 'machine_save']
          });
          throw err;
        });
    }

    function validateMachine(machine) {
      if (!machine.actuator.system) return {
        errMsg: 'Please choose a platform'
      };
      return {
        machine: machine
      };
    }


    function setMachineAction(machine, action) {
      machine.locked = true;
      if (action === 'rest') {
        return applyFieldReferenceToMachineMappings(machine, action);
      } else {
        machine.actuator.action = 'replicate';
        const machineToSave = angular.copy(machine);
        delete machineToSave.locked;
        return saveMachine(machineToSave, 'Switched to use SOAP api')
          .then(function () {
            delete machine.locked;
          })
          .catch(function (){
            delete machine.locked;
          });
      }
    }

    function applyFieldReferenceToMachineMappings(machine, action) {

      const params = {
        clientId: SessionService.getUserData().clientId,
        machineId: machine._machineid,
        eloquaFormId: machine.actuator.typeid
      };

      return IntegrationApiFactory.applyFieldReferenceToMachineMappings(params)
        .then(function (updatedMachine) {

          machine.mappings = updatedMachine.mappings;
          machine.actuator = updatedMachine.actuator;
          machine.machineInfo = updatedMachine.machineInfo;
          delete machine.locked;

          MessageService.showMessage('Machine switched to ' + action + ' api');
          MessageService.writeLog({
            level: 'info',
            msg: 'Success setting machine action to ' + action + '. _machineid:  ' + machine._machineid,
            tags: ['integration', 'machine_action']
          });
        })
        .catch(function (err) {
          MessageService.showMessage('Something went wrong switching to ' + action);
          MessageService.writeLog({
            level: 'error',
            msg: 'Failure setting machine action to ' + action + '. _machineid:  ' + machine._machineid + ' Err: ' + JSON.stringify(err),
            tags: ['integration', 'machine_action']
          });
        });
    }


    function prepMachineForSave(machine) {
      const userData = SessionService.getUserData();
      machine.machineInfo.lastEditedBy = userData.firstname + ' ' + userData.surname;
      machine.machineInfo.lastEditedTimeStamp = new Date();
      machine.actuator = buildActuator(machine.actuator);
      machine.sensor = buildFilters(machine.sensor);
      return machine;
    }

    function buildActuator(actuator) {
      if (actuator.system === 'Eloqua') {
        const eloquaLoginCreds = GlobalAccessFactory.getLoginCredentials('Eloqua');
        return {
          system: 'Eloqua',
          uri: eloquaLoginCreds.baseUrl,
          action: actuator.action ? actuator.action : 'replicate',
          fundamentaltype: 'Form',
          typeid: actuator.typeid,
          typename: actuator.typename
        };
      } else if (actuator.system === 'SFDC') {
        return {
          system: 'SFDC',
          action: 'replicatecontactandresponse',
          object: 'Lead'
        };
      } else if (actuator.system === 'HttpPost') {
        return {
          system: 'HttpPost',
          action: 'replicate',
          uri: actuator.uri
        };
      }
    }

    function buildFilters(sensor) {
      try {
        if (!_.isUndefined(sensor.filters[0])) {
          // removes the formids array completely if form filters length is 0 (so that the machine runs for all forms)
          if (!sensor.filters[0].formids.length) {
            sensor.filters = [];
          }
        }
        return sensor;

      } catch (e) {
        MessageService.writeLog({
          level: 'error',
          msg: 'please check the filters on this machine',
          tags: ['integration', 'machine_filters']
        });
        return {
          filters: []
        };
      }
    }

    function ensureMachineModelsAreConsistent(rawMachinesData) {
      if (!rawMachinesData) return [];
      _.each(rawMachinesData, function (machineDoc) {
        if (!machineDoc.sensor.filters.length) {
          // because the form filters are a nested element we need to build out the shell if no form filters are present. this is so local models are on a level playing field
          machineDoc.sensor.filters = [{
            formids: []
          }];
        }
      });
      return rawMachinesData;
    }

    function machinesSetToRunForForm(machinesArray, formId) {
      const machinesContainingForm = machinesWithFormInFilter(machinesArray, formId);
      const machinesWithoutFilters = machinesWithNoFormFilters(machinesArray);
      return machinesContainingForm.concat(machinesWithoutFilters);
    }

    function machinesWithFormInFilter(machines, _formid) {
      try {
        const machineFiltersContainingThisFormId = _.filter(machines, function (machine) {
          return _.find(machine.sensor.filters[0].formids, function (id) {
            return id === _formid;
          });
        });
        return _.map(machineFiltersContainingThisFormId, 'name');
      } catch (e) {
        return [];
      }
    }

    function machinesWithNoFormFilters(machines) {
      try {
        const machinesWithNoFilters = _.filter(machines, function (machine) {
          return !machine.sensor.filters[0].formids.length; // don't panic! machines without any filters are given an empty shell poised for filling. They remain in correct shape in the db
        });
        return _.map(machinesWithNoFilters, 'name');
      } catch (e) {
        return [];
      }
    }

  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('MachinesSetToRunForForm', factory);

  factory.$inject = ['MachinesFactory'];
  /* ng-inject */
  function factory(MachinesFactory) {

    return function checkIfFormWillRunForIntegration(_formid) {
      return MachinesFactory.getMachines()
        .then(function (res) {
          const machinesSetToRunForForm = MachinesFactory.machinesSetToRunForForm(res.machines, _formid);
          return machinesSetToRunForForm;
        })
        .catch(function (err) {
          throw err;
        });
    };
  }
}());

(function () {
  'use strict';

  angular
    .module('integration')
    .factory('IntegrationApiFactory', IntegrationApiFactory);

  IntegrationApiFactory.$inject = ['APIService', 'EncodingService'];
  /* ng-inject */
  function IntegrationApiFactory(api, encoder) {

    return {
      testEloquaConnection,
      getAllEloquaForms,
      getEloquaFormById,
      getMachinesForAccount,
      saveMachine,
      deleteMachine,
      queryEloquaForms,
      applyFieldReferenceToMachineMappings
    };

    //////////////////////////////////

    function testEloquaConnection(payload) {
      return api.post('integration/eloqua-base-url', payload)
        .then(function (response) {
          if (!_.isEmpty(response.data.data)) {
            return response.data.data;
          } else {
            throw 'Error';
          }
        })
        .catch(function (err) {
          throw err.data.data.message;
        });
    }

    function getAllEloquaForms(payload) {
      return api.post('integration/get-eloqua-forms', payload)
        .then(function (response) {
          return response.data.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function getEloquaFormById(payload) {
      return api.post('integration/get-eloqua-form', payload)
        .then(function (response) {
          return response.data.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function queryEloquaForms(payload) {
      return api.post('integration/query-eloqua-forms', payload)
        .then(function (response) {
          return response.data.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function getMachinesForAccount(clientId) {
      const req = {
        parameters: {
          _id: clientId
        },
        fields: {
          databasename: 1,
          machines: 1
        }
      };

      return api.post('client/query', req)
        .then(function (res) {
          return res.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function saveMachine(params) {

      const encodedClientId = encoder.encode(params.clientId);
      if (!encodedClientId) return Promise.reject('invalid client id');

      return api.post('integration/' + encodedClientId + '/saveMachine', {
        machine: params.machine
      })
        .then(function (res) {
          return res.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function deleteMachine(params) {

      const encodedClientId = encoder.encode(params.clientId);
      const encodedMachineId = encoder.encode(params.machineIdToDelete);
      if (!encodedClientId) return Promise.reject('invalid client id');

      return api.post('integration/' + encodedClientId + '/' + encodedMachineId + '/deleteMachine')
        .then(function (res) {
          return res.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function applyFieldReferenceToMachineMappings(params) {
      const encodedClientId = encoder.encode(params.clientId);
      if (!encodedClientId) return Promise.reject('invalid client id');

      return api.post('integration/' + encodedClientId + '/setFieldReferences', {
        eloquaFormId: params.eloquaFormId,
        machineId: params.machineId
      })
        .then(function (res) {
          return res.data.data.updatedMachine;
        })
        .catch(function (err) {
          throw (err);
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('forms')
    .factory('DeleteAResponseColumn', factory);

  factory.$inject = [];
  /*ng-inject*/
  function factory() {

    return function(columnsData, columnToRemove){
      let ix;
      const item = _.find(columnsData.items, function (itm, i) {
        if (itm.databasefieldname === columnToRemove) {
          ix = i;
          return true;
        }
      });

      if (item) {
        columnsData.items.splice(ix, 1);
        delete columnsData.itemsObject['response_' + columnToRemove];
      }
      
    };
  }
}());

/**
 * Created by davidbeazer on 27/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('email')
    .config(moduleConfig);

  moduleConfig.$inject = ['$stateProvider'];
  /* ng-inject */
  function moduleConfig($stateProvider) {

    $stateProvider
      .state('app.homescreen_app_framework.email_home', {
        url: '/email/home',
        title: 'Email',
        views: {
          'toolbarSection': {
            component: 'zpEmailSearchToolbar'
          },
          'spof': {
            component: 'zpEmailList'
          },
          'right-hand-container': {
            component: 'zpEmailHomepageWidgetContainer'
          },
          'fab-container': {
            component: 'zpAddEmailFab'
          }
        },
        data: {
          permissions: {
            only: ['TYE_VIEW']
          }
        },
        resolve: {
          model: ['$q', 'EmailTemplatesFactory', 'ToolbarFactory', function (promise, factory, toolbarfactory) {
            return new promise(function (resolve, reject) {
              toolbarfactory.set({
                title: 'Email templates',
                navigationPath: '',
                showBackButton: false
              });
              return factory.init()
                .then(function () {
                  resolve(factory);
                })
                .catch(reject);
            });
          }]
        }
      })
      .state('app.tabbed_app_framework.email_edit', {
        url: '/emails/:_id',
        abstract: true,
        views: {
          'tab-navbar': {
            component: 'zpTabNavbar',
            bindings: {
              stateParams: 'stateParams'
            }
          },
          'spof': {
            template: '<div ui-view="spof"></div>'
          },
          'fab-container': {
            template: '<div ui-view="fab-container"></div>'
          }
        },
        data: {
          permissions: {
            only: ['TYE_VIEW']
          }
        },
        resolve: {
          stateParams: ['$transition$', function (transition) {

            var tabItems = [{
              state: 'app.tabbed_app_framework.email_edit.settings',
              name: 'settings',
              label: 'Settings'
            }, {
              state: 'app.tabbed_app_framework.email_edit.editor',
              name: 'editor',
              label: 'Editor'
            }, {
              state: 'app.tabbed_app_framework.email_edit.insights',
              name: 'insights',
              label: 'Insights'
            }];

            return {
              _id: transition.params()._id,
              transitionTo: transition.to(),
              items: tabItems
            };
          }],
          prepState: ['$q', 'EmailTemplatesFactory', 'CurrentTemplateFactory', '$transition$', 'EncodingService', 'ToolbarFactory', function (promise, templatesFactory, factory, $transition$, encoder, toolbarfactory) {
            return new promise(function (resolve, reject) {
              return templatesFactory.init()
                .then(function () {
                  return factory.getTemplateById(encoder.decode($transition$.params()._id));
                })
                .then(function (res) {
                  toolbarfactory.set({
                    title: res.title,
                    navigationPath: 'app.homescreen_app_framework.email_home',
                    showBackButton: true,
                    customStateParams: {
                      isDirtyCheck: true
                    }
                  });
                  resolve();
                })
                .catch(reject);
            });
          }]
        }
      })
      .state('app.tabbed_app_framework.email_edit.settings', {
        url: '/settings',
        title: 'Email Template Settings',
        views: {
          'spof': {
            component: 'zpTemplateSettings'
          }
        },
        data: {
          name: 'settings',
          permissions: {
            only: ['TYE_EDIT']
          }
        }
      })
      .state('app.tabbed_app_framework.email_edit.editor', {
        url: '/editor',
        title: 'Email Template Editor',
        views: {
          'spof': {
            component: 'zpTemplateEditor'
          },
          'fab-container': {
            component: 'zpSaveEmailTemplateFab'
          }
        },
        data: {
          name: 'editor',
          permissions: {
            only: ['TYE_EDIT']
          }
        }
      })
      .state('app.tabbed_app_framework.email_edit.insights', {
        url: '/insights',
        title: 'Email Template Insights',
        views: {
          'spof': {
            component: 'zpEmailTemplateInsights',
            bindings: {
              emailTemplateId: 'templateId'
            }
          }
        },
        data: {
          name: 'insights'
        },
        resolve: {
          templateId: ['$transition$', 'EncodingService', function (transition, encoder) {
            var templateId = encoder.decode(transition.params()._id);
            return templateId;
          }]
        }
      });
  }
})();

/**
 * Created by davidbeazer on 21/11/2016.
 */
(function () {
  'use strict';
  angular
    .module('email')
    .factory('EmailTemplatesFactory', EmailTemplatesFactory);

  EmailTemplatesFactory.$inject = ['EmailAPI', '$q', '$filter', 'EmailMainMetadata', 'FormsFactory', 'MessageService', 'ValidationHelperFactory', 'SessionService', 'localStorageService'];
  /* ng-inject */
  function EmailTemplatesFactory(EmailAPI, $q, $filter, EmailMainMetadata, FormsFactory, MessageService, ValidationHelperFactory, SessionService, localStorageService) {

    var factoryData = {
      formsList: [],
      items: [],
      itemsObject: {},
      dataCache: {
        valid: false,
        lastServerTripTimestamp: null,
        clientId: null
      }
    };

    var services = {
      init: init,
      getTemplatesList: getTemplatesList,
      getData: getData,
      getFormsListCached: getFormsListCached,
      getFormsUsedCountForTemplate: getFormsUsedCountForTemplate,
      removeFormIdFromFormsUsedArray: removeFormIdFromFormsUsedArray,
      addFormIdToFormsUsedArray: addFormIdToFormsUsedArray,
      arrayOfFormsUsingTemplate: arrayOfFormsUsingTemplate,
      createNewTemplate: createNewTemplate,
      invalidateCache: invalidateCache,
      toggleShowArchivedSwitch: toggleShowArchivedSwitch,
      factoryData: factoryData
    };

    return services;

    //////////////////////////////

    /**
     * @function init
     * @description initialises the factory, grabs the email templates from the server and then grabs the forms from the server in order to calculate which forms are using which templates
     */
    function init() {
      return $q(
        function q(resolve, reject) {
          if (ValidationHelperFactory.dataCacheIsStillValid(factoryData.dataCache)) {
            resolve(factoryData);
          } else {
            getTemplatesList()
              .then(function () {
                return FormsFactory
                  .getAllForms()
                  .then(function (response) {
                    factoryData.formsList = _.chain(response.unprocessedFormsArray)
                      .map(function (obj) {
                        return {
                          _id: obj._id,
                          formname: obj.formname,
                          emailTemplate: obj.emailTemplate,
                          emailtemplatetitle: formPropsHelper(obj),
                          icn: setStringForIcon(obj, 'form'),
                          startdate: obj.startdate
                        };
                      })
                      .value();
                    factoryData.dataCache.valid = true;
                    factoryData.dataCache.lastServerTripTimestamp = new Date();
                    factoryData.dataCache.clientId = SessionService.getUserData().clientId;
                    resolve(factoryData);
                  })
                  .catch(function (err) {
                    MessageService.writeLog({
                      level: 'error',
                      msg: 'server trip for forms error: ' + JSON.stringify(err)
                    });
                    reject(err);
                  });
              })
              .catch(function (err) {
                MessageService.writeLog({
                  level: 'error',
                  msg: 'server trip for email templates error: ' + JSON.stringify(err),
                  tags: ['account_level_cache']
                });
                reject(err);
              });
          }
        });
    }

    /**
     * @function getData
     * @description simple getter for returning the contents of the factory data
     * @returns factoryData - an object containing pertinent data for this factory
     */

    function getData() {
      return factoryData;
    }

    /**
     * @function getTemplatesList
     * @description grabs all the email templates from the server and processes them for subsequent use in the portal (grid)
     */
    function getTemplatesList() {
      return $q(
        function q(resolve, reject) {
          if (ValidationHelperFactory.dataCacheIsStillValid(factoryData.dataCache)) {
            hydrateFactoryWithTemplates(factoryData.rawItemsArray);
            resolve(factoryData);
          } else {
            EmailAPI.getTemplatesList()
              .then(function (res) {
                hydrateFactoryWithTemplates(res.data.data);
                resolve(factoryData);
              })
              .catch(function (err) {
                MessageService.writeLog({
                  level: 'error',
                  msg: 'server trip for email templates error: ' + JSON.stringify(err),
                  tags: ['account_level_cache']
                });
                reject(err);
              });
          }
        });
    }

    function hydrateFactoryWithTemplates(data) {
      factoryData.items = data;
      factoryData.rawItemsArray = angular.copy(data);

      var filteredTemplates = filterTemplatesToShow(factoryData.items);
      var shapedItemsArray = shapeDataForGrid(filteredTemplates);
      var arrayToMap = angular.copy(shapedItemsArray);
      factoryData.items = $filter('enhancedTableCells')(EmailMainMetadata.getData(), shapedItemsArray);

      var templatesObject = _.reduce(arrayToMap, function (templatesObject, v) {
        templatesObject[v.emailtemplate._id] = v;
        return templatesObject;
      }, {});
      var allTemplatesObject = _.reduce(shapeDataForGrid(factoryData.rawItemsArray), function (templatesObject, v) {
        templatesObject[v.emailtemplate._id] = v;
        return templatesObject;
      }, {});
      factoryData.allItemsObject = allTemplatesObject;
      factoryData.itemsObject = templatesObject;
      factoryData.dataCache.valid = true;
      factoryData.dataCache.lastServerTripTimestamp = new Date();
      factoryData.dataCache.clientId = SessionService.getUserData().clientId;
    }

    function filterTemplatesToShow(items) {
      var hideArchivedTemplates = localStorageService.get('hideArchivedTemplates');
      var filteredArray = _.filter(items, function (obj) {
        if (obj._deletedatelocalutc && !hideArchivedTemplates) {
          return true;
        } else if (!obj._deletedatelocalutc) {
          return true;
        }
      });
      return filteredArray;
    }

    /**
     * @function shapeDataForGrid
     * @description puts each email template into a the format required for them to be rendered in the zpGrid component
     * @param {array} arrayOfUnprocessedItems is the raw server data
     * @returns a new array of processed items ready to be filtered
     */
    function shapeDataForGrid(arrayOfUnprocessedItems) {
      return _.map(arrayOfUnprocessedItems, function (item) {
        return {
          emailtemplate: {
            _id: item._id,
            icn: setStringForIcon(item, 'template'),
            title: item.title || '',
            formsused: [],
            formsusedcount: 0,
            _lastmodifiedonservertime: item._lastmodifiedonservertime || '',
            archived: item._deletedatelocalutc || 0
          }
        };
      });
    }

    function getFormsListCached() {
      return $q(function q(resolve) {
        if (ValidationHelperFactory.dataCacheIsStillValid(factoryData.dataCache)) {
          resolve({
            formsList: factoryData.formsList
          });
        } else {
          resolve(init());
        }
      });
    }

    function getFormsUsedCountForTemplate(templateId) {
      return factoryData.itemsObject[templateId].emailtemplate.formsusedcount;
    }

    // FOR FORMS USED DIALOG
    function addFormIdToFormsUsedArray(templateId) {
      factoryData
        .items
        .forEach(function (template) {
          if (template.emailtemplate._id == templateId) {
            template.emailtemplate.formsusedcount.raw++;
            template.emailtemplate.formsusedcount.filtered++;
            factoryData.itemsObject[template.emailtemplate._id].emailtemplate.formsusedcount++;
          }
        });
      invalidateCache(true);
    }
    // FOR FORMS USED DIALOG
    function removeFormIdFromFormsUsedArray(templateId) {
      factoryData
        .items
        .forEach(function (template) {
          if (template.emailtemplate._id == templateId) {
            template.emailtemplate.formsusedcount.raw--;
            template.emailtemplate.formsusedcount.filtered--;
            factoryData.itemsObject[template.emailtemplate._id].emailtemplate.formsusedcount--;
          }
        });
      invalidateCache(true);
    }

    function arrayOfFormsUsingTemplate(templateId) {
      var arrayOfForms = [];
      factoryData.formsList.forEach(function (form) {
        if (templateId == form.emailTemplate) {
          arrayOfForms.push(form._id);
        }
      });
      return arrayOfForms;
    }

    function createNewTemplate(doc) {
      return EmailAPI
        .createNewTemplate(doc)
        .then(function (response) {
          if (response.status == 200) {
            var template = shapeDataForGrid([doc]);
            var tempToAdd = $filter('enhancedTableCells')(EmailMainMetadata.getData(), template);
            factoryData.items[factoryData.items.length] = tempToAdd[0];
            factoryData.itemsObject[doc._id] = template[0];
            return;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function invalidateCache(invalidateFormsFactoryToo) {
      factoryData.dataCache.valid = false;
      factoryData.dataCache.lastServerTripTimestamp = null;
      if (invalidateFormsFactoryToo) {
        FormsFactory.invalidateCache();
      }
      return;
    }

    function toggleShowArchivedSwitch(hideArchivedTemplates) {
      if (!hideArchivedTemplates) {
        factoryData.dataCache.valid = false; // invalidate to force server trip for forms
      }
      localStorageService.set('hideArchivedTemplates', hideArchivedTemplates);
      return getTemplatesList();
    }

    /////////////////// PRIVATE HELPER METHODS ///////////////////

    /**
     * @function formPropsHelper
     * @description finds the email template title for a form. Also increases the formsused count for a template so the user can see how many forms are using a particular template from the templates list page
     * @param {object} form an object that contains the form _id, emailTemplate _id
     * @returns {string} emailTemplateTitleForForm is viewed when the user is in the forms used screen.
     */
    function formPropsHelper(form) {

      var emailTemplateTitleForForm = 'None set';
      if (form.emailTemplate) {
        factoryData
          .items
          .forEach(function (template) {
            if (template.emailtemplate._id == form.emailTemplate) {
              template.emailtemplate.formsusedcount.raw++;
              template.emailtemplate.formsusedcount.filtered++;
              factoryData.itemsObject[template.emailtemplate._id].emailtemplate.formsusedcount++;
              emailTemplateTitleForForm = template.emailtemplate.title.raw;
            }
          });
      }
      return emailTemplateTitleForForm;
    }

    function setStringForIcon(obj, type) {
      if (type == 'template') {
        if (obj._deletedatelocalutc) {
          return 'archived';
        } else if (obj.published == 1) {
          return 'published';
        } else {
          return 'draft';
        }
      } else if (type == 'form') {
        if (obj._deletedatelocalutc) {
          return 'archived';
        } else if (obj.published == 1) {
          return 'published';
        } else if (obj.published == 0) {
          return 'draft';
        }
      }
    }

  }
})();

/**
* Created by davidbeazer on 27/11/2016.
*/
(function () {
  'use strict';

  angular
    .module('email')
    .factory('EmailAPI', EmailAPI);

  EmailAPI.$inject = ['APIService', 'APIFactory', 'EncodingService'];
  /* ng-inject */
  function EmailAPI(api, apiFactory, encoder) {

    var emailApi = apiFactory.route('email');

    var services = {
      getTemplatesList: emailApi.get,
      getTemplateById: emailApi.getById,
      postTemplateData: postTemplateData,
      createNewTemplate: emailApi.create,
      deleteTemplate: emailApi.delete,
      sendTemplateTestEmail: sendTemplateTestEmail,
      getFormsList: getFormsList,
      updateEmailTemplateForForm: updateEmailTemplateForForm,
      aggregateTemplateActivity: aggregateTemplateActivity,
      triggerAtomicEmailSend: triggerAtomicEmailSend
    };

    return services;
    ////////////////////////////

    function triggerAtomicEmailSend(payload) {
      var apiUrl = 'email/triggerAtomicEmailSend';
      return api
        .post(apiUrl, payload)
        .then(function (response) {
          return response.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function postTemplateData(data, files) {
      var id = data._id;
      if (id) {
        return emailApi.update(data, files);
      } else {
        return emailApi.create(data, files);
      }
    }

    function sendTemplateTestEmail(templateToTest) {
      return api.post('email/' + encoder.encode(templateToTest._id) + '/sendTemplateTestEmail', templateToTest)
        .then(function (response) {
          if (response.status == 200) {
            return response.data;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function getFormsList() {
      return api.get('form/')
        .then(function (response) {
          if (response.status == 200) {
            return response;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function updateEmailTemplateForForm(formId, updateDoc) {
      return api.post('form/' + encoder.encode(formId), updateDoc)
        .then(function (response) {
          if (response.status == 200) {
            return response.data;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function aggregateTemplateActivity(rangeStart, rangeEnd, emailtemplateid) {
      return api.post('email/aggregate/' + encoder.encode(emailtemplateid), { $gte: rangeStart, $lte: rangeEnd })
        .then(function (response) {
          if (response.status === 200) {
            return response.data;
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }
  }

})();

(function () {
  'use strict';
  angular.module('data')
    .factory('zubotOutfitsFactory', function () {

      var bodyColors = [
        '#f5a623',
        '#98a629',
        '#449752',
        '#00806e',
        '#006471',
        '#2f4858',
        '#4ecdba'
      ];

      var bodyBackColors = [
        '#632324'
      ];

      var verticalColors = [
        '#e6e5dc'
      ];

      var eyeColors = [
        '#dbbb2d'
      ];

      var eyeHighlightColors = [
        '#e6e5dc'
      ];

      var zedColors = [
        '#6c2b2b'
      ];
  
      return {
        bodyColors,
        bodyBackColors,
        verticalColors,
        eyeColors,
        eyeHighlightColors,
        zedColors
      };
  
    });
})();
  
(function () {
  'use strict';
  angular.module('data')
    .factory('zubotNamesFactory', function () {

      var names = [
        'Derek',
        'Prudence',
        'Trevor',
        'Percy',
        'Margaret',
        'Hans',
        'Jimbo',
        'Doc',
        'Gerald',
        'Patrick',
        'William',
        'Delores',
        'Terry',
        'Barry',
        'David',
        'Claire',
        'Susan',
        'Coleman',
        'Bobby',
        'Yoko',
        'Jonny',
        'Lenny',
        'Finn',
        'Steve',
        'Wolfie',
        'James',
        'Roger',
        'Marvin',
        'Richard',
        'Nick',
        'Danny',
        'Billy',
        'Samuel',
        'Rachel',
        'Joey',
        'Monica',
        'Mildred',
        'Harvey',
        'Felicity',
        'Elizabeth',
        'Erika',
        'Elliot',
        'Betty',
        'Sophia',
        'Amelia',
        'Evelyn',
        'Olivia',
        'Chloe',
        'Lillian',
        'Penelope',
        'Parker',
        'Alex',
        'Audrey',
        'Bella',
        'Hailey',
        'Willow',
        'Cora',
        'Lydia',
        'Walter',
        'Madeline',
        'Silas',
        'Oliver',
        'Wallace',
        'Max',
        'Owen',
        'Alfred',
        'Fredrick',
        'Archie',
        'Bernard',
        'Albert',
        'Clarence',
        'Claude',
        'Jean-Claude',
        'Edgar',
        'Elmer',
        'Samson',
        'Francis',
        'Augustine',
        'Cassius',
        'Abraham',
        'Calvin',
        'Elijah',
        'Chester',
        'Joseph',
        'Marjorie',
        'Warren',
        'Harold',
        'Raymond',
        'Floyd',
        'Henry',
        'Jack',
        'Luther',
        'Clara',
        'Alice',
        'Rose',
        'Nora',
        'Alma',
        'Blanche',
        'Cora',
        'Edith',
        'Fannie',
        'Florence',
        'Ida',
        'Hattie',
        'Harriet',
        'Lula',
        'Mabel',
        'Minnie',
        'Nelly',
        'Pearl',
        'Ruth',
        'Leona',
        'Charlotte',
        'Courtney',
        'Leanne',
        'Karen',
        'Kate',
        'Laura',
        'Rachel'
      ];

      return {
        names: names
      };

    });
})();

(function () {
  'use strict';
  angular.module('data')
    .factory('workflowFactory', WorkflowFactory);

  WorkflowFactory.$inject = ['$interval', '$rootScope', 'catchError', 'SystemFieldsFactory', 'dataloadfileChanged', 'removeCardFromHand', 'MessageService', 'getFieldsFromFileData', 'setTasks', 'openCardSelection', 'activateZubot', 'applyFieldMappingDragDropChange', 'validateFieldMapping', 'checkStepIsValid', 'highlightSelectedCardMappings', 'setSelectedStep', 'getStepClass', 'generateZubot', 'setSelectedTask', 'contactSearchChanged', 'selectContact', 'dataloadSearchChanged', 'selectDataload', 'saveInstanceValueCardSelection', 'saveNewDataload', 'uploadFile', 'uuidService'];
  /* ng-inject */
  function WorkflowFactory($interval, $rootScope, catchError, SystemFieldsFactory, dataloadfileChanged, removeCardFromHand, MessageService, getFieldsFromFileData, setTasks, openCardSelection, activateZubot, applyFieldMappingDragDropChange, validateFieldMapping, checkStepIsValid, highlightSelectedCardMappings, setSelectedStep, getStepClass, generateZubot, setSelectedTask, contactSearchChanged, selectContact, dataloadSearchChanged, selectDataload, saveInstanceValueCardSelection, saveNewDataload, uploadFile, uuidService) {

    var tasks = [];
    var selectedTask = {};
    var selectedStep = {};
    var containerShow = {
      selectCard: false,
      selectMapping: false,
      selectContact: false,
      selectDataload: false,
      selectDataloadFile: false,
      zubotActivated: false,
      dryrunActivated: false,
      busy: false,
      selectCards: false,
      buttonActivating: false,
      validationMessage: '',
      contactSearchBusy: false,
      uploading: 0
    };
    var newContactFieldFilter = {
      field: { friendly: 'Select field', name: 'noselection' },
      operator: '',
      value: ''
    };
    var text = {
      zubotActivateButtonText: 'Activate',
      contactSearchText: 'Searching'
    };
    var availableCards = [];
    var mappingSystems = { systemA: [], systemB: [] };
    var selectedCard = {};

    function getCardSelectionClass() {
      var css = '';

      if (selectedStep.colour) {
        css += ' ' + selectedStep.colour;
      }

      if (containerShow.selectCard) {
        css += ' show';
      }

      return css;
    }

    function getFieldMappingClass() {
      var css = '';

      if (selectedStep.colour) {
        css += ' ' + selectedStep.colour;
      }

      if (containerShow.selectMapping) {
        css += ' show';
      }

      return css;
    }

    function getContactSelectionClass() {
      var css = '';

      if (selectedStep.colour) {
        css += ' ' + selectedStep.colour;
      }

      if (containerShow.selectContact) {
        css += ' show';
      }

      return css;
    }

    function getDataloadSelectionClass() {
      var css = '';

      if (selectedStep.colour) {
        css += ' ' + selectedStep.colour;
      }

      if (containerShow.selectDataload) {
        css += ' show';
      }

      return css;
    }

    function getDataloadFileSelectionClass() {
      var css = '';

      if (selectedStep.colour) {
        css += ' ' + selectedStep.colour;
      }

      if (containerShow.selectDataloadFile) {
        css += ' show';
      }

      return css;
    }

    function goToNextStep() {

      for (let i = 0; i < selectedTask.steps.length; i++) {
        if (selectedTask.steps[i].title === selectedStep.title) {
          selectedTask.steps[i].cards = selectedTask.steps[i].cards || [];
          selectedTask.steps[i].cards.length = 0;
          selectedTask.steps[i].cards.push.apply(selectedTask.steps[i].cards, selectedStep.cards);
          selectedTask.steps[i].valid = selectedStep.valid;
          if (i + 1 < selectedTask.steps.length) {
            setSelectedStep(containerShow, selectedTask.steps[i + 1], selectedStep, selectedTask);
            break;
          }
        }
      }
    }

    function goToPreviousStep() {

      for (let i = 0; i < selectedTask.steps.length; i++) {
        if (selectedTask.steps[i].title === selectedStep.title) {
          selectedTask.steps[i].cards.length = 0;
          selectedTask.steps[i].cards.push.apply(selectedTask.steps[i].cards, selectedStep.cards);
          selectedTask.steps[i].valid = selectedStep.valid;
          if (i > 0) {
            setSelectedStep(containerShow, selectedTask.steps[i - 1], selectedStep, selectedTask);
            break;
          }
        }
      }
    }

    function moveToStep(step) {
      let currentStepIndex = 0;
      let destinationStepIndex = 0;

      for (let i = 0; i < selectedTask.steps.length; i++) {
        if (selectedTask.steps[i].title === step.title) {
          destinationStepIndex = i;
        }
        if (selectedTask.steps[i].title === selectedStep.title) {
          selectedTask.steps[i].cards.length = 0;
          selectedTask.steps[i].cards.push.apply(selectedTask.steps[i].cards, selectedStep.cards);
          currentStepIndex = i;
        }
      }

      if (currentStepIndex < destinationStepIndex) {
        let valid = true;
        for (currentStepIndex; currentStepIndex < destinationStepIndex; currentStepIndex++) {
          checkStepIsValid(selectedTask.steps[currentStepIndex], selectedTask);
          if (!selectedTask.steps[currentStepIndex].valid) {
            valid = false;
          }
        }

        if (valid) {
          setSelectedStep(containerShow, selectedTask.steps[destinationStepIndex], selectedStep, selectedTask);
        }
      } else if (currentStepIndex > destinationStepIndex) {
        setSelectedStep(containerShow, selectedTask.steps[destinationStepIndex], selectedStep, selectedTask);
      }
    }

    function addCardToHand(card) {

      for (let i = 0; i < availableCards.length; i++) {
        if (availableCards[i]._id === card._id) {
          availableCards.splice(i, 1);
          break;
        }
      }

      selectedStep.cards.push(card);
      checkStepIsValid(selectedStep, selectedTask);
    }

    function saveMapping() {

      return new Promise(function (resolve, reject){

        let shouldShowLeadWariningDialog = false;

        for (let i = 0; i < selectedCard.mappings.length; i++) {
          if (selectedCard.mappings[i].systemB.length === 0) {
            selectedCard.mappings.splice(i, 1);
            i--;
          }
          
          if (selectedCard.mappings[i].systemA.length > 0 && selectedCard.mappings[i].systemB[0].object === 'response'){
            shouldShowLeadWariningDialog = true;
          }
        }

        if (!shouldShowLeadWariningDialog) return resolve();

        return MessageService
          .confirm()
          .confirmActionWithInput({
            title: 'WARNING: RESPONSE FIELD MAPPED.',
            htmlContent: '<p>Proceeding with this mapping will load all contacts from this data load as leads.</p> <p>Are you sure you want to continue?</p>',
            confirmationText: 'create leads',
            okBtn: 'CONTINUE',
            cancelBtn: 'CANCEL'
          })
          .then(resolve)
          .catch(reject);
      })
        .then(function () {

          if (selectedStep.cards) {
            for (let i = 0; i < selectedStep.cards.length; i++) {
              if (selectedStep.cards[i]._id === selectedCard._id) {
                if (selectedCard.mappings.length === 0) {
                  SystemFieldsFactory.invalidateCacheForCard(selectedCard);
                  selectedStep.cards.splice(i, 1);
                  break;
                }
                selectedStep.cards[i].mappings.length = 0;
                selectedStep.cards[i].mappings.push.apply(selectedStep.cards[i].mappings, selectedCard.mappings);
                selectedStep.cards[i].mappings.name = selectedCard.name;
                selectedStep.cards[i].mappings.systemTypes = selectedCard.systemTypes;
                selectedStep.cards[i].mappings.description = selectedCard.description;
              }
            }
          }

          containerShow.selectMapping = false;
          checkStepIsValid(selectedStep, selectedTask);

          $rootScope.$digest();
        })
        .catch(function () {
          return;
        });

    }

    function removeFieldFromMapping(system, index) {
      selectedCard.mappings[index][system].length = 0;
      if (system === 'systemA' || selectedCard.mappings[index].systemA.length === 0 && selectedCard.mappings[index].systemB.length === 0) {
        selectedCard.mappings.splice(index, 1);
        selectedCard.description = selectedCard.mappings.length + ' field(s) currently mapped';
      }
      highlightSelectedCardMappings(mappingSystems, selectedCard);
    }

    var cardSortableOptions = {
      cursor: 'move',
      tolerance: 'pointer',
      disabled: false,
      connectWith: '.card-container',
      update: function (e, ui) {
        if (ui.item.sortable.isCanceled()) return;

        checkStepIsValid(selectedStep, selectedTask);
      }
    };

    function startSort() {
      selectedCard.previousMappings = angular.copy(selectedCard.mappings);
    }

    function updateSort(e, ui) {
      applyFieldMappingDragDropChange(e, ui, selectedCard, mappingSystems);
    }

    function stopSort(e, ui){
      if (selectedTask.mission.type !== 'compliance' && selectedTask.mission.subType !== 'redact') {
        delete selectedCard.previousMappings;
        return;
      }

      ui.item.sortable._isCanceled = false;
      validateFieldMapping(selectedCard, ui);

      delete selectedCard.previousMappings;

      if (ui.item.sortable.isCanceled()) return;

      if (ui.item.sortable.model.name === 'zuantaddcustomfield'){

        let mappingIndex = -1;
        let fieldIndex = -1;
        for (let i = 0; i < selectedCard.mappings.length; i++){
          const index = _.findIndex(selectedCard.mappings[i].systemB, function(field){
            return field.name === 'zuantaddcustomfield';
          });

          if (index > -1) {
            mappingIndex = i;
            fieldIndex = index;
          }
        }

      
        return MessageService
          .confirm()
          .createItemWithInput({
            title: 'Add Custom Field',
            inputLabel: 'New custom field value',
            okBtn: 'CREATE',
            cancelBtn: 'CANCEL'
          }).then(function (input) {

            const newMapping = {
              name: input,
              friendly: input,
              object: input.toLowerCase(),
              selected: true,
              category: 'redact'
            };

            for (let i = 0; i < selectedCard.mappings.length; i++){
              const index = _.findIndex(selectedCard.mappings[i].systemB, function(field){
                return field.object === newMapping.object;
              });
    
              if (index > -1) {
                MessageService.showMessage('Custom field mapping already exists within system. Use ' + selectedCard.mappings[i].systemB[index].friendly);

                if (selectedCard.mappings[mappingIndex].systemA.length > 0){
                  selectedCard.mappings[mappingIndex].systemB.splice(fieldIndex, 1);

                } else {
                  selectedCard.mappings.splice(mappingIndex, 1);
                }

                return;
              }
            }

            selectedCard.mappings[mappingIndex].systemB[fieldIndex] = newMapping;

            mappingSystems.systemB[0].fields.splice(fieldIndex, 0, newMapping);

            return;
          }).catch(function() {  
            
            selectedCard.mappings[mappingIndex].systemB.splice(fieldIndex, 1);

            const rowHasEmptyMappings = Object.keys(selectedCard.mappings[mappingIndex]).every(function (key) {
              if (!Array.isArray(selectedCard.mappings[mappingIndex][key])) return true;
              return selectedCard.mappings[mappingIndex][key].length === 0;
            });

            if (rowHasEmptyMappings){
              selectedCard.mappings.splice(mappingIndex, 1);
            }

            return;
          });
      }
    }

    var fieldMappingSortableOptionsA = {
      cursor: 'move',
      tolerance: 'pointer',
      disabled: false,
      connectWith: '.field-drop-container.systema, .drop-container',
      start: startSort,
      update: updateSort,
      stop: stopSort
    };

    var fieldMappingSortableOptionsB = {
      cursor: 'move',
      tolerance: 'pointer',
      disabled: false,
      connectWith: '.field-drop-container.systemb, .drop-container',
      start: startSort,
      update: updateSort,
      stop: stopSort
    };

    var mappingRowSortableOptions = {
      cursor: 'move',
      tolerance: 'pointer',
      disabled: false,
      update: updateSort
    };

    function fileChanged($event) {
      var reader = new FileReader();
      reader.onload = fileIsLoaded;
      var filename = $event.target.files[0].name;
      var splits = filename.split('.');

      if (splits.pop() !== 'csv') {
        MessageService.showMessage('Invalid file type. Please select a CSV.');
      } else {
        $rootScope.$broadcast('card-removed');
        filename = splits.join('.');
        selectedStep.cards.length = 0;
        var card = {
          type: 'file',
          _id: uuidService.getSingleNewBase64Key(),
          name: filename,
          description: 'File containing data for extraction'
        };
        selectedStep.cards.push(card);
        ++containerShow.uploading;
        reader.readAsDataURL($event.target.files[0]);
        checkStepIsValid(selectedStep, selectedTask);

        uploadFile($event, selectedCard, containerShow, selectedStep, selectedTask, availableCards, card._id, filename);
        $rootScope.$digest();
      }

      function fileIsLoaded(e) {
        card.fields = getFieldsFromFileData(e.target.result);
        // Reset so that file changed event is hit again even if the file is the same
        angular.element(document).find('#workflowFileInput').val('');
      }
    }

    function triggerActivateZubot(selectedTask, containerShow, text, dryrun){
      containerShow.buttonActivating = true;
      let idx = 0;
      const dots = ['.', '..', '...'];
      const p = $interval(function () {
        text.zubotActivateButtonText = 'Activating ' + dots[idx % 3];
        ++idx;
      }, 500);

      activateZubot(dryrun, selectedTask)
        .then(function (result) {
          containerShow.buttonActivating = false;
          $interval.cancel(p);
          if (result.data && result.data.success) {
            containerShow.dryrunActivated = dryrun;
            containerShow.zubotActivated = !dryrun;
          }
        })
        .catch(function () {
          containerShow.buttonActivating = false;
          $interval.cancel(p);
          text.zubotActivateButtonText = 'Activate ' + selectedTask.zubot;
          catchError(containerShow);
        });
    }

    return {
      refreshZubot: function () {
        generateZubot(selectedTask);
        text.zubotActivateButtonText = 'Activate ' + selectedTask.zubot;
      },
      setTasks: function (t) {
        tasks = t;
        setTasks(tasks, selectedTask, containerShow, selectedStep, text);
      },
      getStepClass: function (step) {
        return getStepClass(step, selectedStep, selectedTask);
      },
      getFieldMappingClass: getFieldMappingClass,
      getContactSelectionClass: getContactSelectionClass,
      getDataloadSelectionClass: getDataloadSelectionClass,
      getDataloadFileSelectionClass: getDataloadFileSelectionClass,
      isFirstStep: function () {
        return selectedStep.title === selectedTask.steps[0].title;
      },
      isLastStep: function () {
        return selectedStep.title === selectedTask.steps[selectedTask.steps.length - 1].title;
      },
      goToNextStep: goToNextStep,
      goToPreviousStep: goToPreviousStep,
      openCardSelection: function (existingCard, $cb) {
        return openCardSelection(existingCard, selectedStep, containerShow, availableCards, mappingSystems, selectedCard, selectedTask, newContactFieldFilter, $cb);
      },
      selectTask: function (task) {
        return setSelectedTask(task, selectedTask, containerShow, selectedStep, text);
      },
      selectedTask: selectedTask,
      selectedStep: selectedStep,
      selectedCard: selectedCard,
      containerShow: containerShow,
      availableCards: availableCards,
      cardSortableOptions: cardSortableOptions,
      getCardSelectionClass: getCardSelectionClass,
      removeCardFromHand: function (card) {
        return removeCardFromHand(selectedStep, selectedTask, availableCards, card);
      },
      addCardToHand: addCardToHand,
      fileChanged: fileChanged,
      mappingSystems: mappingSystems,
      fieldMappingSortableOptionsA: fieldMappingSortableOptionsA,
      fieldMappingSortableOptionsB: fieldMappingSortableOptionsB,
      mappingRowSortableOptions: mappingRowSortableOptions,
      removeFieldFromMapping: removeFieldFromMapping,
      saveMapping: saveMapping,
      saveContactSelection: function () {
        return saveInstanceValueCardSelection(selectedTask, selectedStep, selectedCard, containerShow);
      },
      saveDataloadSelection: function () {
        return saveInstanceValueCardSelection(selectedTask, selectedStep, selectedCard, containerShow);
      },
      saveNewDataload: function () {
        return saveNewDataload(selectedTask, selectedStep, selectedCard, containerShow);
      },
      newContactFieldFilter: newContactFieldFilter,
      activateZubot: function (dryrun) {
        for (let i = 0; i < selectedTask.steps.length; i++) {
          if (selectedTask.steps[i].title === selectedStep.title) {
            selectedTask.steps[i].cards = selectedTask.steps[i].cards || [];
            selectedTask.steps[i].cards.length = 0;
            selectedTask.steps[i].cards.push.apply(selectedTask.steps[i].cards, selectedStep.cards);
          }
        }
  
        selectedTask.dryrun = dryrun;
        if (selectedTask.dryrun && selectedTask.zubot.indexOf('(') === -1) {
          selectedTask.zubot += ' (1)';
        }
  
        if (selectedTask.needsConfirmation) {
          MessageService.confirm()
            .delete(selectedTask.confirmationText)
            .then(function () {
              triggerActivateZubot(selectedTask, containerShow, text, dryrun);
            })
            .catch(function (err) {
              MessageService.pushDevLog({
                status: 'error',
                title: 'Error confirming zubot',
                message: err
              });
            });
        } else {
          triggerActivateZubot(selectedTask, containerShow, text, dryrun);
        }
      },
      moveToStep: moveToStep,
      text: text,
      newContactFieldChanged: function () {
        if (newContactFieldFilter.field.name !== 'noselection') {
          
          for (let i = 0; i < selectedStep.fields.length; i++) {
            if (newContactFieldFilter.field.object === selectedStep.fields[i].object && newContactFieldFilter.field.name === selectedStep.fields[i].name) {
              selectedCard.filters.push({ field: selectedStep.fields[i], operator: newContactFieldFilter.operator, value: newContactFieldFilter.value });
              break;
            }
          }

          newContactFieldFilter.field = selectedStep.fields[0];
          newContactFieldFilter.operator = '';
          newContactFieldFilter.value = '';
        }
      },
      setLoadZubotId: function (id) {
        selectedTask.originalZubotId = id;
      },
      contactSearchChanged: function () {
        return contactSearchChanged(selectedStep, selectedCard, containerShow, text);
      },
      dataloadSearchChanged: function () {
        return dataloadSearchChanged(selectedStep, selectedCard, containerShow, text);
      },
      selectContact: function (id, firstname, lastname, email) {
        return selectContact(selectedCard, id, firstname, lastname, email);
      },
      selectDataload: function (id, name) {
        return selectDataload(selectedCard, id, name);
      },
      dataloadfileChanged: function ($event) {
        return dataloadfileChanged($event, selectedCard, containerShow, selectedStep, selectedTask, availableCards);
      },
      selectDataloadFile: function () {
        angular.element(document).find('#dataloadSpecialFile').click();
      }
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('data')
    .config(moduleConfig);

  moduleConfig.$inject = ['$stateProvider'];

  function moduleConfig($stateProvider) {

    $stateProvider.state('app.homescreen_app_framework_no_sidebar.data', {
      abstract: true,
      url: '/data',
      views: {
        'spof': {
          template: '<div ui-view="spof" layout-fill></div>'
        }
      },
      data: {
        permissions: {
          only: ['DATA_LOAD']
        }
      }
    });

    $stateProvider.state('app.homescreen_app_framework_no_sidebar.data.subject_report', {
      url: '/subject-report/:_id',
      views: {
        'spof': {
          component: 'subjectReportMain'
        },
      },
      data: {
        permissions: {
          only: ['TRUMP']
        }
      },
      resolve: {
        zubotId: ['$transition$', 'EncodingService', function ($transition$, EncodingService) {
          return EncodingService.decode($transition$.params()._id);
        }]
      }
    });

    $stateProvider.state('app.homescreen_app_framework_no_sidebar.data.dashboard', {
      url: '/dashboard',
      views: {
        'spof': {
          component: 'dataDashboardMain'
        },
      },
      data: {
        permissions: {
          only: ['DATA_LOAD']
        }
      }
    });

    $stateProvider.state('app.homescreen_app_framework_no_sidebar.data.dataload', {
      url: '/load',
      views: {
        'spof': {
          component: 'dataLoad'
        },
      },
      data: {
        permissions: {
          only: ['DATA_LOAD']
        }
      },
      resolve: {
        toolbarSetup: ['ToolbarFactory', function (toolbarfactory) {
          toolbarfactory.set({
            title: 'Load Data',
            navigationPath: 'app.homescreen_app_framework_no_sidebar.data.dashboard',
            showBackButton: true
          });
          return;
        }]
      }
    });

    $stateProvider.state('app.homescreen_app_framework_no_sidebar.data.postshowmatchup', {
      url: '/postshowmatchup',
      views: {
        'spof': {
          component: 'postShowMatchUp'
        },
      },
      data: {
        permissions: {
          only: ['DATA_LOAD']
        }
      },
      resolve: {
        toolbarSetup: ['ToolbarFactory', function (toolbarfactory) {
          toolbarfactory.set({
            title: 'Post-Show Match-Up',
            navigationPath: 'app.homescreen_app_framework_no_sidebar.data.dashboard',
            showBackButton: true
          });
          return;
        }]
      }
    });

    $stateProvider.state('app.homescreen_app_framework_no_sidebar.data.compliance', {
      url: '/compliance',
      views: {
        'spof': {
          component: 'compliance'
        },
      },
      data: {
        permissions: {
          only: ['DATA_COMPLY']
        }
      },
      resolve: {
        toolbarSetup: ['ToolbarFactory', function (toolbarfactory) {
          toolbarfactory.set({
            title: 'Comply',
            navigationPath: 'app.homescreen_app_framework_no_sidebar.data.dashboard',
            showBackButton: true
          });
          return;
        }]
      }
    });

    $stateProvider.state('app.homescreen_app_framework_no_sidebar.data.housekeeping', {
      url: '/housekeeping',
      views: {
        'spof': {
          component: 'housekeeping'
        },
      },
      data: {
        permissions: {
          only: ['ZUANT_ADMIN']
        }
      },
      resolve: {
        toolbarSetup: ['ToolbarFactory', function (toolbarfactory) {
          toolbarfactory.set({
            title: 'Housekeeping',
            navigationPath: 'app.homescreen_app_framework_no_sidebar.data.dashboard',
            showBackButton: true
          });
          return;
        }]
      }
    });

    $stateProvider.state('app.homescreen_app_framework_no_sidebar.data.missioncontrol', {
      url: '/mission-control',
      views: {
        'spof': {
          component: 'missionControl'
        },
      },
      data: {
        permissions: {
          only: ['DATA_LOAD']
        }
      },
      resolve: {
        toolbarSetup: ['ToolbarFactory', function (toolbarfactory) {
          toolbarfactory.set({
            title: 'Mission Control',
            navigationPath: 'app.homescreen_app_framework_no_sidebar.data.dashboard',
            showBackButton: true
          });
          return;
        }],
        zubots: ['zubotMissionControlFactory', function (zubotMissionControlFactory) {
          return zubotMissionControlFactory.getZubots();
        }]
      }
    });

  }
})();

/**
 * Created by davidbeazer on 18/08/2016.
 */
(function () {
  'use strict';

  angular
    .module('dashboard')
    .config(moduleConfig);

  moduleConfig.$inject = ['$stateProvider'];
  /* @ngInject */
  function moduleConfig($stateProvider) {

    // Home
    $stateProvider
      .state('app.single_view_framework.dashboard', {
        url: '/dashboard',
        title: 'Zuant Cloud',
        views: {
          'spof': {
            template: '<zp-dashboard-page layout-fill></zp-dashboard-page>'
          }
        },
        resolve: {
          model: ['CurrentClientModelFactory', 'SessionService', function (CurrentClientModelFactory, SessionService) {
            var userData = SessionService.getUserData();
            return CurrentClientModelFactory.getClientById(userData.clientId);
          }]
        }
      });
  }
})();

/**
 * @module app
 * @function ZPCtrl
 * @description the top-most controller in the Zuant portal
 */

(function () {
  'use strict';

  angular
    .module('app')
    .controller('ZPCtrl', ZPController);

  ZPController.$inject = ['$scope', '$rootScope', '$location', '$window', '$log', 'MessageService', 'appSettings', 'RelayNotificationService', 'SessionService', 'EnvService', 'APP_VERSION', 'ZPPages', '$state', '$transitions', 'AuthService'];

  function ZPController($scope, $rootScope, $location, $window, $log, MessageService, appSettings, RelayNotificationService, session, env, APP_VERSION, zpPages, $state, $transitions, auth) {

    var vm = this;

    vm.title = 'Zuant Cloud';
    vm.appSettings = appSettings;
    vm.unreadMessagesCount;

    vm.$onInit = function (){

      if (env.env === 'PRODUCTION' || env.env === 'EU_PRODUCTION' || env.env === 'RC_PRODUCTION') forceSSL();

      if (session.hasToken()) {
        let userData = {};
        if (session.hasUserData()){
          userData = session.getUserData();
          bootApp(userData);
        } else {
          auth.authoriseUser()
            .then(function () {
              userData = session.getUserData();
              bootApp(userData);
            });
        }
      }
      
      // $mdTheming.generateTheme('zuantCloudSkin');
      $scope.applicationTheme = 'zuant';
    };

    function bootApp(userData){
      intercomBoot(null, userData);

      const clientId = session.getUserData().clientId;
      if (clientId) {
        zpPages.updateVariablePagePaths(clientId);
      }
    }

    function forceSSL() {
      if ($location.protocol() !== 'https') {
        $window.location.href = $location.absUrl().replace('http', 'https');
      }
    }

    $rootScope.$on('zp.message', function onMessage(e, msg) {

      const level = msg.level || 'error';
      const message = msg.message || 'An unknown error occurred';

      if (level === 'feedback' && msg) {
        MessageService.showMessage(message);
      }

      if ($log[level]) {
        $log[level].call(null, message);
      }

      if (level == 'broadcast') {
        RelayNotificationService.relayEvent(msg);
      }
    });

    $rootScope.$on('zp.list-deleted', function listCDeleted() {
      $location.path('/lists/home');
    });

    $rootScope.$on('zp.location-change', function changeLocation(e, path, params) {
      if (params) {
        $location.path(path + params);
      } else {
        $location.path(path);
      }
    });

    function onLoginSuccess(e) {
      /* listen for successful login
      for now, just relocate to /dashboard
      at some point we need a more robust solution for redirection */
      $state.go('app.single_view_framework.dashboard');
    }

    $rootScope.$on('zp.login.success', onLoginSuccess);
    $rootScope.$on('zp.user.authenticated', onLoginSuccess);

    /*===== INTERCOM STUFF =====*/

    /** This event notifies intercom of a custom event that we're tracking in intercom. i.e. the user created an email template */
    $rootScope.$on('zp.intercom-event', function intercomEvent(e, eventName, params) {
      window.Intercom('trackEvent', eventName, params);
    });

    /** intercomBoot is called upon login or page refresh, it notifies intercom of who is using the app. */
    $rootScope.$on('zp.intercom-boot', intercomBoot);

    function intercomBoot(e, userData) {
      window.Intercom('boot', {
        company: {
          id: userData.databasename,
          name: userData.company,
          ZAM: userData.zam,
          plan: 'unset'
        },
        app_id: env.intercomAppId,
        user_id: userData._id,
        name: userData.firstname + ' ' + userData.surname,
        email: userData.email,
        isBureau: userData.isBureau,
        cloud_app_version: APP_VERSION,
        cloud_app_infrastructure: env.env,
        custom_launcher_selector: '#my_custom_link'
      });
      /*
       * Intercom will ping this each time the unread message count changes for a user.
       */
      Intercom('onUnreadCountChange', function (unreadCount) {
        vm.unreadMessagesCount = unreadCount;
      });
    }

    /** This notifies Intercom of the user logging out, ending their session. */
    $rootScope.$on('zp.intercom-shutdown', function intercomEnd() {
      // $log.info('zp.intercom-shutdown');
      window.Intercom('shutdown');
    });

    // TODO replace $locationChange events now we're using UI Router
    /** whenever a route change succeeds, update Intercom. */
    $rootScope.$on('$locationChangeSuccess', function () {
      window.Intercom('update');
    });


    $transitions.onSuccess({}, function (transition) {
      // console.log(
      //   'successfully transitioned from ' + transition.from().title +
      //   ' to ' + transition.to().title
      // );
      vm.title = transition.to().title || 'Zuant Cloud';
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('common')
    .factory('ValidationHelperFactory', ValidationHelperFactory);

  ValidationHelperFactory.$inject = ['$log', 'SessionService'];
  /* ng-inject */
  function ValidationHelperFactory($log, SessionService) {

    return {
      dataCacheIsStillValid: dataCacheIsStillValid
    };

    function dataCacheIsStillValid(dataCache, requestedObjectId) {
      var clientId = SessionService.getUserData().clientId;
      if (!dataCache.lastServerTripTimestamp ||
        !dataCache.valid ||
        dataCache.cachedObjectId !== requestedObjectId ||
        dataCache.clientId !== clientId) {
        return false;
      }
      var a = moment(dataCache.lastServerTripTimestamp);
      var now = moment();
      var difference = a.diff(now, 'seconds');
      if (-difference > 180) {
        // $log.info('💣 Cache is ' + -difference + ' seconds old. Off to get fresh data');
        dataCache.valid = false;
        return false;
      } else {
        // $log.info('👍 Data cache is still valid for clientId ' + clientId + ' ' + JSON.stringify(dataCache));
        return true;
      }
    }
  }
})();

/**
 * Created by davidbeazer on 27/09/2016.
 */
(function (){

  angular
    .module('common')
    .factory('TimezonesFactory', Timezones);

  Timezones.$inject = [];
  /* ng-inject */
  function Timezones() {
    return [
      {
        'title': '(GMT-12:00) International Date Line West'
        // 'code': 'International Date Line West (GMT-12:00)'
      }, {
        'title': '(GMT-11:00) Coordinated Universal Time-11)'
        // 'code': 'Coordinated Universal Time-11 (GMT-11:00)'
      }, {
        'title': '(GMT-11:00) Samoa'
        // 'code': 'Samoa (GMT-11:00)'
      }, {
        'title': '(GMT-10:00) Hawaii'
        // 'code': 'Hawaii (GMT-10:00)'
      }, {
        'title': '(GMT-09:00) Alaska'
        // 'code': 'Alaska (GMT-09:00)'
      }, {
        'title': '(GMT-08:00) Baja California'
        // 'code': 'Baja California (GMT-08:00)'
      }, {
        'title': '(GMT-08:00) Pacific Time (US & Canada)'
        // 'code': 'Pacific Time (US & Canada) (GMT-08:00)'
      }, {
        'title': '(GMT-07:00) Arizona'
        // 'code': 'Arizona (GMT-07:00)'
      }, {
        'title': '(GMT-07:00) Chihuahua, La Paz, Mazatlan'
        // 'code': 'Chihuahua, La Paz, Mazatlan (GMT-07:00)'
      }, {
        'title': '(GMT-07:00) Mountain Time (US & Canada)'
        // 'code': 'Mountain Time (US & Canada) (GMT-07:00)'
      }, {
        'title': '(GMT-06:00) Central America'
        // 'code': 'Central America (GMT-06:00)'
      }, {
        'title': '(GMT-06:00) Central Time (US & Canada)'
        // 'code': 'Central Time (US & Canada), Chicago (GMT-06:00)'
      }, {
        'title': '(GMT-06:00) Guadalajara, Mexico City, Monterrey'
        // 'code': 'Guadalajara, Mexico City, Monterrey (GMT-06:00)'
      }, {
        'title': '(GMT-06:00) Saskatchewan'
        // 'code': 'Saskatchewan (GMT-06:00)'
      }, {
        'title': '(GMT-05:00) Bogota, Lima, Quito'
        // 'code': 'Bogota, Lima, Quito (GMT-05:00)'
      },{
        'title': '(GMT-05:00) Eastern Time (US & Canada)'
        // 'code': 'Eastern Time (US & Canada), Orlando, New York (GMT-05:00)'
      },{
        'title': '(GMT-05:00) Indiana (East)'
        // 'code': 'Indiana (East) (GMT-05:00)'
      }, {
        'title': '(GMT-04:30) Caracas'
        // 'code': 'Caracas (GMT-04:30)'
      }, {
        'title': '(GMT-04:00) Asuncion'
        // 'code': 'Asuncion (GMT-04:00)'
      }, {
        'title': '(GMT-04:00) Atlantic Time (Canada)'
        // 'code': 'Atlantic Time (Canada) (GMT-04:00)'
      }, {
        'title': '(GMT-04:00) Cuiaba'
        // 'code': 'Cuiaba (GMT-04:00)'
      },{
        'title': '(GMT-04:00) Georgetown, La Paz, Manaus, San Juan'
        // 'code': 'Georgetown, La Paz, Manaus, San Juan (GMT-04:00)'
      },{
        'title': '(GMT-04:00) Santiago'
        // 'code': 'Santiago (GMT-04:00)'
      }, {
        'title': '(GMT-03:30) Newfoundland'
        // 'code': 'Newfoundland (GMT-03:30)'
      }, {
        'title': '(GMT-03:00) Brasilia'
        // 'code': 'Brasilia (GMT-03:00)'
      }, {
        'title': '(GMT-03:00) Buenos Aires'
        // 'code': 'Buenos Aires (GMT-03:00)'
      }, {
        'title': '(GMT-03:00) Cayenne, Fortaleza'
        // 'code': 'Cayenne, Fortaleza (GMT-03:00)'
      },{
        'title': '(GMT-03:00) Greenland'
        // 'code': 'Greenland (GMT-03:00)'
      }, {
        'title': '(GMT-03:00) Montevideo'
        // 'code': 'Montevideo (GMT-03:00)'
      },{
        'title': '(GMT-02:00) Coordinated Universal Time-02'
        // 'code': 'Coordinated Universal Time-02 (GMT-02:00)'
      }, {
        'title': '(GMT-02:00) Mid-Atlantic'
        // 'code': 'Mid-Atlantic (GMT-02:00)'
      }, {
        'title': '(GMT-01:00) Azores'
        // 'code': 'Azores (GMT-01:00)'
      }, {
        'title': '(GMT-01:00) Cape Verde Is.'
        // 'code': 'Cape Verde Is. (GMT-01:00)'
      }, {
        'title': '(GMT) Casablanca'
        // 'code': 'Casablanca (GMT)'
      },{
        'title': '(GMT) Coordinated Universal Time'
        // 'code': 'Coordinated Universal Time (GMT)'
      }, {
        'title': '(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London'
        // 'code': 'Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London (GMT)'
      }, {
        'title': '(GMT) Monrovia, Reykjavik'
        // 'code': 'Monrovia, Reykjavik (GMT)'
      },{
        'title': '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna'
        // 'code': 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna (GMT+01:00)'
      }, {
        'title': '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague'
        // 'code': 'Belgrade, Bratislava, Budapest, Ljubljana, Prague (GMT+01:00)'
      }, {
        'title': '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris'
        // 'code': 'Brussels, Copenhagen, Madrid, Paris (GMT+01:00)'
      }, {
        'title': '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb'
        // 'code': 'Sarajevo, Skopje, Warsaw, Zagreb (GMT+01:00)'
      }, {
        'title': '(GMT+01:00) West Central Africa'
        // 'code': 'West Central Africa (GMT+01:00)'
      },{
        'title': '(GMT+01:00) Windhoek'
        // 'code': 'Windhoek (GMT+01:00)'
      }, {
        'title': '(GMT+02:00) Amman'
        // 'code': 'Amman (GMT+02:00)'
      }, {
        'title': '(GMT+02:00) Athens, Bucharest, Istanbul'
        // 'code': 'Athens, Bucharest, Istanbul (GMT+02:00)'
      },{
        'title': '(GMT+02:00) Beirut'
        // 'code': 'Beirut (GMT+02:00)'
      }, {
        'title': '(GMT+02:00) Cairo'
        // 'code': 'Cairo (GMT+02:00)'
      }, {
        'title': '(GMT+02:00) Damascus'
        // 'code': 'Damascus (GMT+02:00)'
      }, {
        'title': '(GMT+02:00) Harare, Pretoria'
        // 'code': 'Harare, Pretoria (GMT+02:00)'
      }, {
        'title': '(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius'
        // 'code': 'Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius (GMT+02:00)'
      },{
        'title': '(GMT+02:00) Jerusalem'
        // 'code': 'Jerusalem (GMT+02:00)'
      }, {
        'title': '(GMT+02:00) Minsk'
        // 'code': 'Minsk (GMT+02:00)'
      }, {
        'title': '(GMT+03:00) Baghdad'
        // 'code': 'Baghdad (GMT+03:00)'
      }, {
        'title': '(GMT+03:00) Kuwait, Riyadh'
        // 'code': 'Kuwait, Riyadh (GMT+03:00)'
      }, {
        'title': '(GMT+03:00) Moscow, St. Petersburg, Volgograd'
        // 'code': 'Moscow, St. Petersburg, Volgograd (GMT+03:00)'
      }, {
        'title': '(GMT+03:00) Nairobi'
        // 'code': 'Nairobi (GMT+03:00)'
      },{
        'title': '(GMT+03:30) Tehran'
        // 'code': 'Tehran (GMT+03:00)'
      },{
        'title': '(GMT+04:00) Abu Dhabi, Muscat'
        // 'code': 'Abu Dhabi, Muscat (GMT+04:00)'
      }, {
        'title': '(GMT+04:00) Baku'
        // 'code': 'Baku (GMT+04:00)'
      },{
        'title': '(GMT+04:00) Port Louis'
        // 'code': 'Port Louis (GMT+04:00)'
      },{
        'title': '(GMT+04:00) Tbilisi'
        // 'code': 'Tbilisi (GMT+04:00)'
      }, {
        'title': '(GMT+04:00) Yerevan'
        // 'code': 'Yerevan (GMT+04:00)'
      },{
        'title': '(GMT+04:30) Kabul'
        // 'code': 'Kabul (GMT+04:30)'
      },{
        'title': '(GMT+05:00) Ekaterinburg'
        // 'code': 'Ekaterinburg (GMT+05:00)'
      }, {
        'title': '(GMT+05:00) Islamabad, Karachi'
        // 'code': 'Islamabad, Karachi (GMT+05:00)'
      },{
        'title': '(GMT+05:00) Tashkent'
        // 'code': 'Tashkent (GMT+05:00)'
      },{
        'title': '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi'
        // 'code': 'Chennai, Kolkata, Mumbai, New Delhi (GMT+05:30)'
      },{
        'title': '(GMT+05:30) Sri Jayawardenepura'
        // 'code': 'Sri Jayawardenepura (GMT+05:30)'
      }, {
        'title': '(GMT+05:45) Kathmandu'
        // 'code': 'Kathmandu (GMT+05:45)'
      },{
        'title': '(GMT+06:00) Astana'
        // 'code': 'Astana (GMT+06:00)'
      }, {
        'title': '(GMT+06:00) Dhaka'
        // 'code': 'Dhaka (GMT+06:00)'
      },{
        'title': '(GMT+06:00) Novosibirsk'
        // 'code': 'Novosibirsk (GMT+06:00)'
      }, {
        'title': '(GMT+06:30) Yangon (Rangoon)'
        // 'code': 'Yangon (Rangoon) (GMT+06:30)'
      },{
        'title': '(GMT+07:00) Bangkok, Hanoi, Jakarta'
        // 'code': 'Bangkok, Hanoi, Jakarta (GMT+07:00)'
      },{
        'title': '(GMT+07:00) Krasnoyarsk'
        // 'code': 'Krasnoyarsk (GMT+07:00)'
      },{
        'title': '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi'
        // 'code': 'Beijing, Chongqing, Hong Kong, Urumqi (GMT+08:00)'
      },{
        'title': '(GMT+08:00) Irkutsk'
        // 'code': 'Irkutsk (GMT+08:00)'
      },{
        'title': '(GMT+08:00) Kuala Lumpur, Singapore'
        // 'code': 'Kuala Lumpur, Singapore (GMT+08:00)'
      },{
        'title': '(GMT+08:00) Perth'
        // 'code': 'Perth (GMT+08:00)'
      },{
        'title': '(GMT+08:00) Taipei'
        // 'code': 'Taipei (GMT+08:00)'
      },{
        'title': '(GMT+08:00) Ulaanbaatar'
        // 'code': 'Ulaanbaatar (GMT+08:00)'
      }, {
        'title': '(GMT+09:00) Osaka, Sapporo, Tokyo'
        // 'code': 'Osaka, Sapporo, Tokyo (GMT+09:00)'
      }, {
        'title': '(GMT+09:00) Seoul'
        // 'code': 'Seoul (GMT+09:00)'
      }, {
        'title': '(GMT+09:00) Yakutsk'
        // 'code': 'Yakutsk (GMT+09:00)'
      }, {
        'title': '(GMT+09:30) Adelaide'
        // 'code': 'Adelaide (GMT+09:30)'
      }, {
        'title': '(GMT+09:30) Darwin'
        // 'code': 'Darwin (GMT+09:30)'
      }, {
        'title': '(GMT+10:00) Brisbane'
        // 'code': 'Brisbane (GMT+10:00)'
      }, {
        'title': '(GMT+10:00) Canberra, Melbourne, Sydney'
        // 'code': 'Canberra, Melbourne, Sydney (GMT+10:00)'
      }, {
        'title': '(GMT+10:00) Guam, Port Moresby'
        // 'code': 'Guam, Port Moresby (GMT+10:00)'
      }, {
        'title': '(GMT+10:00) Hobart'
        // 'code': 'Hobart (GMT+10:00)'
      }, {
        'title': '(GMT+10:00) Vladivostok'
        // 'code': 'Vladivostok (GMT+10:00)'
      },{
        'title': '(GMT+11:00) Magadan'
        // 'code': 'Magadan (GMT+11:00)'
      }, {
        'title': '(GMT+11:00) Solomon Is., New Caledonia'
        // 'code': 'Solomon Is., New Caledonia (GMT+11:00)'
      }, {
        'title': '(GMT+12:00) Auckland, Wellington'
        // 'code': 'Auckland, Wellington (GMT+12:00)'
      }, {
        'title': '(GMT+12:00) Coordinated Universal Time+12'
        // 'code': 'Coordinated Universal Time+12 (GMT+12:00)'
      },{
        'title': '(GMT+12:00) Fiji'
        // 'code': 'Fiji (GMT+12:00)'
      }];
  }
})();

(function () {
  'use strict';

  angular
    .module('common')
    .service('SpliceItemFromModel', service);

  service.$inject = [];
  /* ng-inject */
  function service() {

    return function spliceItemFromModel(_id, model) {
      var index;
      _.find(model, function (itm, ix) {
        if (itm._id == _id) {
          index = ix;
          return;
        }
      });
      model.splice(index, 1);
    };

  }

}());

(function(){
  'use strict';
      
  angular.module('common')
    .directive('positiveIntegerBetweenBoundary', positiveIntegerBetweenBoundary);
        
  positiveIntegerBetweenBoundary.$inject = [];
  /* ng-inject */
  function positiveIntegerBetweenBoundary() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ngModelCtrl) {

        element.on('keydown', function(event) {
          const keyCode = event.which || event.keyCode;
          const value = event.target.value;
          //has to be a text input otherwise this doesn't work
          const selectionStart = element[0].selectionStart;
          const selectionEnd = element[0].selectionEnd;
          
          // Allow only digits, backspace, and arrow keys
          if ((keyCode < 48 || keyCode > 57) && keyCode !== 8 && keyCode !== 37 && keyCode !== 38 && keyCode !== 39 && keyCode !== 40){
            event.preventDefault();
          }
      
          if (keyCode === 8 && value.length === 1){
            ngModelCtrl.$setViewValue(0);
            ngModelCtrl.$render();
            event.preventDefault();
            return;
          }
                
          // If the input is a digit, check if it's within the range
          if (keyCode >= 48 && keyCode <= 57) {
            const newValue = parseInt(value.slice(0, selectionStart) + String.fromCharCode(keyCode) + value.slice(selectionEnd));
            if (newValue < parseInt(attrs.min) || newValue > parseInt(attrs.max)) {
              event.preventDefault();
              return;
            }
      
            ngModelCtrl.$setViewValue(newValue);
            ngModelCtrl.$render();
            event.preventDefault();
            return;
          }
      
          if (keyCode === 38 || keyCode === 40){
            let newValue = parseInt(value);
            if (keyCode === 38) newValue++;
            if (keyCode === 40) newValue--;
      
            if (newValue < parseInt(attrs.min) || newValue > parseInt(attrs.max)) {
              event.preventDefault();
              return;
            }
      
            ngModelCtrl.$setViewValue(newValue);
            ngModelCtrl.$render();
            event.preventDefault();
            return;
          }
      
        });

      }
    };
  }
})();
(function () {
  'use strict';
  angular
    .module('common')
    .directive('focusOnShow', ['$timeout', function ($timeout) {
      return {
        restrict: 'A',
        link: function ($scope, $element, $attr) {
          if ($attr.ngShow) {
            $scope.$watch($attr.ngShow, function (newValue) {
              if (newValue) {
                $timeout(function () {
                  $element[0].focus();
                }, 100);
              }
            });
          }
          if ($attr.ngHide) {
            $scope.$watch($attr.ngHide, function (newValue) {
              if (!newValue) {
                $timeout(function () {
                  $element[0].focus();
                }, 100);
              }
            });
          }
        }
      };
    }]);
}());

(function () {
  'use strict';

  angular
    .module('common')
    .factory('CacheInvalidationFactory', CacheInvalidationFactory);

  CacheInvalidationFactory.$inject = [
    '$rootScope',
    'EmailTemplatesFactory',
    'FormsFactory',
    'ListsGeneralFactory',
    'ListOfListsFactory',
    'ThemingFactory',
    'ImagesApiFactory',
    'PrimaryThemeFactory',
    'LiteratureNamesFactory',
    'ShowroomBlocksFactory',
    'CurrentClientModelFactory',
    'ClientsDataFactory',
    'PrivacyStatementsViewModel',
    'SearchValFactory',
    'UserFactory',
    'PostShowEmailFactory',
    'AggregateResponsesFactory',
    'AggregatedEmailTemplateSendsFactory',
    'IndividualEmailTemplateAggregationFactory'
  ];
  /* ng-inject */
  function CacheInvalidationFactory(
    $rootScope,
    EmailTemplatesFactory,
    FormsFactory,
    ListsGeneralFactory,
    ListOfListsFactory,
    ThemingFactory,
    ImagesApiFactory,
    PrimaryThemeFactory,
    LiteratureNamesFactory,
    ShowroomBlocksFactory,
    CurrentClientModelFactory,
    ClientsDataFactory,
    PrivacyStatementsViewModel,
    SearchValFactory,
    UserFactory,
    PostShowEmailFactory,
    AggregateResponsesFactory,
    AggregatedEmailTemplateSendsFactory,
    IndividualEmailTemplateAggregationFactory
  ) {

    return {
      invalidateAllCachedData: invalidateAllCachedData,
      init: init
    };

    function init(){
      $rootScope.$on('zp.user.deauthenticated', invalidateAllCachedData);
      $rootScope.$on('zp.account.change', invalidateAllCachedData);
    }

    function invalidateAllCachedData() {
      EmailTemplatesFactory.invalidateCache();
      FormsFactory.invalidateCache();
      ListsGeneralFactory.invalidateCache();
      ListOfListsFactory.invalidateCache();
      ThemingFactory.invalidateCache();
      ImagesApiFactory.invalidateCache();
      PrimaryThemeFactory.invalidateCache();
      LiteratureNamesFactory.invalidateCache();
      ShowroomBlocksFactory.invalidateCache();
      CurrentClientModelFactory.invalidateCache();
      ClientsDataFactory.invalidateCache();
      PrivacyStatementsViewModel.invalidateCache();
      SearchValFactory.factoryData = {};
      UserFactory.invalidateCache();
      PostShowEmailFactory.factoryData.broadcast = undefined;

      AggregateResponsesFactory.invalidateCache();
      AggregatedEmailTemplateSendsFactory.invalidateCache();
      IndividualEmailTemplateAggregationFactory.invalidateCache();
    }
  }
})();

/**
 * Created by davidbeazer on 27/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('clients')
    .factory('ZuantAccountManagersFactory', ZAMS);

  ZAMS.$inject = ['SessionService', 'ENV_VAR', '$filter'];
  /* ng-inject */
  function ZAMS(SessionService, ENV_VAR, $filter) {

    const allZams = [{
      name: 'N/A',
      email: ''
    }, {
      name: 'Pete Gillett',
      email: 'pete@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/pg-initials.svg')
    }, {
      name: 'Cristina Gillett',
      email: 'cristina@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/cg-initials.svg')
    }, {
      name: 'Don Russell',
      email: 'don@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/dr-initials.svg')
    }, {
      name: 'Sian Evans',
      email: 'sian@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/se-initials.svg')
    }, {
      name: 'Dave Hickson',
      email: 'daveh@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/dh-initials.svg')
    }, {
      name: 'Valentin Kalchev',
      email: 'valentin@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/vk-initials.svg')
    }, {
      name: 'Shanesa Marraffa',
      email: 'shanesa@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/sm-initials.svg')
    }, {
      name: 'Georgie Turner',
      email: 'georgie@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/gt-initials.svg')
    }, {
      name: 'Charlotte Rimmer',
      email: 'charlotte@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/cr-initials.svg')
    }, {
      name: 'Kate Ballard',
      email: 'kate@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/kb-initials.svg')
    }, {
      name: 'Rachel Jeans',
      email: 'rachelj@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/rj-initials.svg')
    }, {
      name: 'Courtney Hill',
      email: 'courtney@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/ch-initials.svg')
    }, {
      name: 'Tom Stone',
      email: 'tom@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/ts-initials.svg')
    }, {
      name: 'Tia Dickenson',
      email: 'tia@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/td-initials.svg')
    }, {
      name: 'Will Ross',
      email: 'will@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/wr-initials.svg')
    }, {
      name: 'Zoe Carpentier',
      email: 'zoe@zuant.com',
      iconURL: $filter('cdnAssets')('/images/svgs/utilities/initials/zc-initials.svg')
    }, {
      name: 'Harvey Hickson',
      email: 'harvey@zuant.com'
    }, {
      name: 'Andy Knapp',
      email: 'andy@zuant.com'
    }];

    const activeZamEmailAddresses = [
      'tia@zuant.com',
      'will@zuant.com',
      'pete@zuant.com'
    ];

    const customerSuccessManagersEmailAddresses = [
      'charlotte@zuant.com',
      'shanesa@zuant.com',
      'georgie@zuant.com',
      'cristina@zuant.com',
      'don@zuant.com',
      'zoe@zuant.com'
    ];

    if (ENV_VAR !== 'AWS_PROD'){
      activeZamEmailAddresses.push('daveh@zuant.com');
      activeZamEmailAddresses.push('tom@zuant.com');
      activeZamEmailAddresses.push('harvey@zuant.com');

      customerSuccessManagersEmailAddresses.push('daveh@zuant.com');
      customerSuccessManagersEmailAddresses.push('tom@zuant.com');
      customerSuccessManagersEmailAddresses.push('harvey@zuant.com');
    }

    const superZamEmailAddresses = [
      'charlotte@zuant.com',
      'pete@zuant.com',
      'daveh@zuant.com',
      'tom@zuant.com',
      'harvey@zuant.com',
      'valentin@zuant.com',
      'andy@zuant.com'
    ];

    const customerSuccessManagers = allZams.filter((zam)=> {
      if (customerSuccessManagersEmailAddresses.indexOf(zam.email) > -1) return true;
      if (zam.name === 'N/A') return true;
      return false;
    });

    const activeZams = allZams.filter((zam) => {
      if (activeZamEmailAddresses.indexOf(zam.email) > -1) return true;
      if (zam.name === 'N/A') return true;
      return false;
    });

    const superZams = allZams.filter((zam) => {
      if (superZamEmailAddresses.indexOf(zam.email) > -1) return true;
      return false;
    });

    return {
      allZams,
      activeZams,
      customerSuccessManagers,
      superZams,
      loggedInUserIsAZam,
      loggedInUserIsASuperZam
    };

    function loggedInUserIsAZam() {
      const user = SessionService.getUserData();
      return _.findIndex(allZams, function (usr) {
        return usr.email == user.email;
      }) > -1;
    }

    function loggedInUserIsASuperZam() {
      const user = SessionService.getUserData();
      return _.findIndex(superZams, function (usr) {
        return usr.email == user.email;
      }) > -1;
    }

  }
})();

/**
 * Created by Tom Stone on 13/07/2023.
 */

(function () {
  'use strict';
  
  angular
    .module('clients')
    .provider('SelfServiceClientConfig', clientSelfServiceConfigProvider);
  
  function clientSelfServiceConfigProvider() {
    this.$get = function() {
      
      return [
        {
          statePath: 'app.tabbed_app_framework.self_service_client_management_detail',
          props: {
            url: '/client/:_id',
            abstract: true,
            views: {
              'left-hand-container': {
                template: '<uiview ui-view="left-hand-container"></uiview>'
              },
              'tab-navbar': {
                component: 'zpTabNavbar',
                bindings: {
                  stateParams: 'stateParams'
                }
              },
              'spof': {
                template: '<div ui-view="spof" layout-fill></div>'
              },
              'right-hand-container': {
                template: '<div ui-view="right-hand-container" layout-fill></div>'
              },
              'fab-container': {
                template: '<uiview ui-view="fab-container"></uiview>'
              }
            },
            data: {
              permissions: {
                only: ['ACC_MGMT_SETTINGS', 'ACC_MGMT_PERMISSIONS', 'ACC_MGMT_TOKENS', 'ACC_MGMT_PRIVACY_STATEMENTS', 'ACC_MGMT_TEAMS'],
                except: ['ZUANT_ADMIN']
              }
            },
            resolve: {
              model: ['$q', 'CurrentClientModelFactory', '$transition$', 'EncodingService', 'MessageService', 'ToolbarFactory', 'UserFactory', 'UserPermissionsHelperFactory', 'BoltOnsFactory', 'PrimaryThemeFactory', 'SendThankYouEmailIntegrityCheck', function (promise, factory, $transition$, encoder, message, toolbarfactory, userfactory, permissionscheckfactory, boltons, primarytheme, SendThankYouEmailIntegrityCheck) {
                return new promise(function (resolve, reject) {
                  const decodedClientId = encoder.decode($transition$.params()._id);
                  let databasename;
                  permissionscheckfactory.init();
                  message.writeLog({
                    level: 'info',
                    msg: '/client/' + decodedClientId + '/account'
                  });
      
                  return factory.getClientById(decodedClientId)
                    .then(function (res) {
                      databasename = res.databasename;
                      toolbarfactory.set({
                        title: res.companyname,
                        navigationPath: 'app.single_view_framework.dashboard',
                        showBackButton: true,
                        customStateParams: {
                          isDirtyCheck: true
                        }
                      });
                      return userfactory.getUserList(decodedClientId);
                    })
                    .then(function () {
                      return SendThankYouEmailIntegrityCheck.runCheckOnAccount();
                    })
                    .then(function () {
                      return boltons.getAccountPermissions(decodedClientId, databasename);
                    })
                    .then(function () {
                      if (boltons.factoryData.cacheValid) {
                        if (boltons.factoryData.permissions.boltOns.customSkins.enabled) {
                          return primarytheme.getPrimaryTheme(databasename);
                        } else {
                          resolve();
                        }
                      } else {
                        resolve();
                      }
                    })
                    .then(function () {
                      resolve();
                    })
                    .catch(reject);
                });
              }],
              stateParams: ['$transition$', function (transition) {
                return {
                  _id: transition.params()._id,
                  transitionTo: transition.to(),
                  items: [
                    {
                      state: 'app.tabbed_app_framework.self_service_client_management_detail.account_settings',
                      name: 'account_settings',
                      label: 'Account Settings'
                    },
                    {
                      state: 'app.tabbed_app_framework.self_service_client_management_detail.permissions.users-pool',
                      name: 'permissions',
                      label: 'Permissions'
                    },
                    {
                      state: 'app.tabbed_app_framework.self_service_client_management_detail.consent_management',
                      name: 'consent',
                      label: 'Consent'
                    },
                    {
                      state: 'app.tabbed_app_framework.self_service_client_management_detail.privacy_statement_management',
                      name: 'privacy',
                      label: 'Privacy'
                    },
                    {
                      state: 'app.tabbed_app_framework.self_service_client_management_detail.teams',
                      name: 'teams',
                      label: 'Teams'
                    },
                    {
                      state: 'app.tabbed_app_framework.self_service_client_management_detail.client_email_templates.home',
                      name: 'client_email_templates',
                      label: 'Email Templates'
                    }
                  ]
                };
              }],
              layout: ['LayoutsFactory', function (layouts) {
                layouts.setProperty('rightHandContainerWidth', '0');
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.self_service_client_management_detail.account_settings',
          props: {
            url: '/settings',
            title: 'Settings',
            views: {
              'left-hand-container': {
                template: ''
              },
              'spof': {
                component: 'zpClientDetailPage',
                bindings: {
                  customSkinLibraryStatePath: 'customSkinLibraryStatePath',
                  customSkinEditorStatePath: 'customSkinEditorStatePath'
                }
              },
              'fab-container': {
                component: 'zpSaveClientDocFab'
              }
            },
            data: {
              name: 'account_settings',
              permissions: {
                only: ['ACC_MGMT_SETTINGS']
              }
            },
            resolve: {
              customSkinLibraryStatePath: [function (){
                return 'app.single_view_framework.self_service_custom_skins.themes_library';
              }],
              customSkinEditorStatePath: [function (){
                return 'app.single_view_framework.self_service_custom_skins.theme_editor';
              }],
              prep: ['ConsentViewModelFactory', 'LayoutsFactory', function (consentviewmodelfactory, layouts) {
                return consentviewmodelfactory.hydrateFactory()
                  .then(function () {
                    layouts.setProperty('rightHandContainerWidth', '0');
                    return;
                  });
              }],
              gdprEditCheck: ['CurrentClientModelFactory', function (currentclientmodel) {
                currentclientmodel.endElevatedEditSessionIfExpired();
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.self_service_client_management_detail.permissions',
          props: {
            url: '/permissions',
            abstract: true,
            views: {
              'left-hand-container': {
                template: '<div ui-view="left-hand-container"></div>'
              },
              'spof': {
                template: '<div ui-view="spof" layout-fill></div>'
              },
              'fab-container': {
                template: '<div ui-view="fab-container"></div>'
              }
            },
            data: {
              name: 'permissions',
              permissions: {
                only: ['ACC_MGMT_PERMISSIONS']
              },
              showLeftSidebar: false
            },
            resolve: {
              clientId: ['$transition$', 'EncodingService', 'PermissionsManagerFactory', function (transition, encoder, permissionmanagerfactory) {
                const decodedClientId = encoder.decode(transition.params()._id);
                permissionmanagerfactory.resetFactory();
                return decodedClientId;
              }],
              layout: ['LayoutsFactory', function (layouts) {
                layouts.setProperty('rightHandContainerWidth', '0');
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.self_service_client_management_detail.permissions.users-pool',
          props: {
            url: '/users-pool',
            title: 'Permissions pool',
            views: {
              'left-hand-container': {
                component: 'zpUserPoolSelector'
              },
              'spof': {
                template: '<zp-action-selector layout="column" layout-fill></zp-action-selector>'
              },
              'fab-container': {
                component: 'zpPermissionsFab'
              }
            },
            data: {
              name: 'permissions',
              permissions: {
                only: ['ACC_MGMT_PERMISSIONS']
              },
              showLeftSidebar: true
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.self_service_client_management_detail.teams',
          props: {
            url: '/teams',
            views: {
              'spof': {
                component: 'zpTeamsPage'
              }
            },
            data: {
              name: 'teams',
              permissions: {
                only: ['ACC_MGMT_TEAMS']
              }
            },
            resolve: {
              layout: ['LayoutsFactory', function (layouts) {
                layouts.setProperty('rightHandContainerWidth', '0');
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.self_service_client_management_detail.consent_management',
          props: {
            url: '/consent-management',
            title: 'Consent Management',
            views: {
              'spof': {
                component: 'zpConsentPage'
              },
              'fab-container': {
                component: 'zpConsentModelFabButtons'
              }
            },
            data: {
              name: 'consent',
              permissions: {
                only: ['ACC_MGMT_TOKENS']
              }
            },
            resolve: {
              layout: ['ConsentViewModelFactory', function (consentViewModelFactory) {
                return consentViewModelFactory.hydrateFactory()
                  .then(function () {
                    return;
                  });
              }],
              gdprEditCheck: ['CurrentClientModelFactory', function (currentclientmodel) {
                currentclientmodel.endElevatedEditSessionIfExpired();
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.self_service_client_management_detail.privacy_statement_management',
          props: {
            url: '/privacy-statement-management',
            title: 'Privacy Management',
            views: {
              'spof': {
                component: 'zpPrivacyManagementPage',
                bindings: {
                  privacyStatements: 'privacyStatements'
                }
              },
              'fab-container': {
                component: 'zpPrivacyStatementFabButtons'
              }
            },
            data: {
              name: 'privacy',
              permissions: {
                only: ['ACC_MGMT_PRIVACY_STATEMENTS']
              }
            },
            resolve: {
              privacyStatements: ['PrivacyStatementsViewModel', function (PrivacyStatementsViewModel) {
                const params = {
                  options: {
                    includeVersionHistory: 1
                  },
                  queryObj: {
                    parameters: {
                      artefactType: 'PrivacyStatement'
                    },
                    fields: {
                      _lastmodifieddatelocalutc: 1,
                      _deletedatelocalutc: 1,
                      isPrimaryStatement: 1,
                      title: 1
                    }
                  }
                };
                return new Promise(function (resolve, reject) {
                  return PrivacyStatementsViewModel.hydrateFactoryWithPrivacyStatements(params)
                    .then(function () {
                      resolve();
                    })
                    .catch(function (err) {
                      reject(err);
                    });
                });
              }]
            }
          }
        },
        {
          statePath: 'app.single_view_framework.self_service_custom_skins',
          props: {
            abstract: true,
            url: '/client/theming/',
            views: {
              'spof': {
                template: '<div ui-view="spof" layout-fill></div>'
              },
              'fab-container': {
                template: '<uiview ui-view="fab-container"></uiview>'
              }
            },
            data: {
              permissions: {
                only: ['ACC_MGMT_SETTINGS']
              }
            },
            resolve: {
              model: ['$q', 'CurrentClientModelFactory', '$transition$', 'EncodingService', 'MessageService', 'ToolbarFactory', 'UserFactory', 'UserPermissionsHelperFactory', 'BoltOnsFactory', 'ThemingFactory', function (promise, factory, $transition$, encoder, message, toolbarfactory, userfactory, permissionscheckfactory, boltons, theming) {
                return new promise(function (resolve, reject) {
                  const decodedClientId = encoder.decode($transition$.params()._id);
                  let databasename;
                  permissionscheckfactory.init();
                  message.writeLog({
                    level: 'info',
                    msg: '/clients/edit/' + decodedClientId + '/account'
                  });
      
                  return factory.getClientById(decodedClientId)
                    .then(function (res) {
                      databasename = res.databasename;
                      return theming.getThemesForAccount();
                    })
                    .then(function () {
                      return boltons.getAccountPermissions(decodedClientId, databasename);
                    })
                    .then(function () {
                      resolve();
                    })
                    .catch(reject);
                });
              }]
            }
          }
        },
        {
          statePath: 'app.single_view_framework.self_service_custom_skins.themes_library',
          props: {
            url: '/:_id/library',
            title: 'Custom Skins Library',
            views: {
              'spof': {
                component: 'zpThemesLibrary',
                bindings: {
                  clientDoc: 'clientDoc',
                  customSkinEditorStatePath: 'customSkinEditorStatePath',
                  clientDetailStatePath: 'clientDetailStatePath',
                  layoutFill: true,
                  layout: 'column'
                }
              },
              'fab-container': {
                component: 'zpAddThemeFab',
                bindings: {
                  clientId: 'clientId'
                }
              }
            },
            params: {
              _id: null,
              customSkinEditorStatePath: null,
              clientDetailStatePath: null
            },
            data: {
              permissions: {
                only: ['ACC_MGMT_SETTINGS']
              }
            },
            resolve: {
              customSkinEditorStatePath: ['$stateParams', function ($stateParams) {
                return $stateParams.customSkinEditorStatePath || 'app.single_view_framework.self_service_custom_skins.theme_editor';
              }],
              clientDetailStatePath: ['$stateParams', function ($stateParams) {
                return $stateParams.clientDetailStatePath || 'app.tabbed_app_framework.self_service_client_management_detail.account_settings';
              }],
              clientId: ['$transition$', 'EncodingService', function (transition, encoder) {
                return encoder.decode(transition.params()._id);
              }],
              clientDoc: ['CurrentClientModelFactory', 'clientId', function (CurrentClientModelFactory, clientId){
                return CurrentClientModelFactory.getClientById(clientId);
              }]
            }
          }
        },
        {
          statePath: 'app.single_view_framework.self_service_custom_skins.theme_editor',
          props: {
            url: '/:_id/editor/:_themeId',
            title: 'Custom Skins Editor',
            views: {
              'spof': {
                component: 'zpThemeEditor',
                bindings: {
                  clientId: 'clientId',
                  theme: 'theme',
                  layoutFill: 'true',
                  layout: 'column'
                }
              },
              'fab-container': {
                component: 'zpSaveThemeFab'
              }
            },
            params: {
              _id: null,
              customSkinLibraryStatePath: null,
              clientDetailStatePath: null
            },
            data: {
              permissions: {
                only: ['ACC_MGMT_SETTINGS']
              }
            },
            resolve: {
              customSkinLibraryStatePath: ['$stateParams', function ($stateParams) {
                return $stateParams.customSkinLibraryStatePath || 'app.single_view_framework.self_service_custom_skins.themes_library';
              }],
              clientDetailStatePath: ['$stateParams', function ($stateParams) {
                return $stateParams.clientDetailStatePath || 'app.tabbed_app_framework.self_service_client_management_detail.account_settings';
              }],
              clientId: ['$transition$', function (transition) {
                return transition.params()._id;
              }],
              theme: ['$transition$', '$q', 'CurrentThemeFactory', 'EncodingService', function (transition, promise, currentthemefactory, encoder) {
                return new promise(function (resolve, reject) {
                  const themeId = encoder.decode(transition.params()._themeId);
                  return currentthemefactory.hydrateFactoryWithTheme(themeId)
                    .then(function (themeDoc) {
                      resolve(themeDoc);
                    })
                    .catch(reject);
                });
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.self_service_client_management_detail.client_email_templates',
          props: {
            url: '/email-templates',
            abstract: true,
            views: {
              'spof': {
                template: '<div ui-view="toolbarSection"></div><div ui-view="tab-navbar"></div><div ui-view="spof"></div>'
              },
              'right-hand-container': {
                template: '<div ui-view="right-hand-container"></div>'
              },
              'fab-container': {
                template: '<div ui-view="fab-container"></div>'
              }
            },
            data: {
              name: 'client_email_templates',
              permissions: {
                only: ['ACC_MGMT_CLIENT_EMAIL_TEMPLATES']
              }
            },
            resolve: {
              model: ['$q', 'ClientEmailTemplatesFactory', function (promise, factory) {
                return new promise(function (resolve, reject) {
                  return factory.init()
                    .then(function () {
                      resolve(factory);
                    })
                    .catch(reject);
                });
              }],
              rootStatePath: [function (){
                return 'app.tabbed_app_framework.self_service_client_management_detail.client_email_templates';
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.self_service_client_management_detail.client_email_templates.home',
          props: {
            url: '',
            views: {
              'toolbarSection': {
                component: 'zpClientEmailTemplatesSearchToolbar'
              },
              'spof': {
                component: 'zpClientEmailTemplateList'
              },
              'right-hand-container': {
                component: 'zpClientEmailTemplatesWidgetContainer'
              },
              'fab-container': {
                component: 'zpAddClientEmailTemplateFab'
              }
            },
            data: {},
            resolve: {
              layout: ['LayoutsFactory', function (layouts) {
                layouts.setProperty('rightHandContainerWidth', '40');
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.self_service_client_management_detail.client_email_templates.email_edit',
          props: {
            url: '/emails/:_emailid',
            abstract: true,
            views: {
              'tab-navbar': {
                component: 'zpTabNavbar',
                bindings: {
                  stateParams: 'stateParams'
                }
              },
              'spof': {
                template: '<div ui-view="spof" layout-fill></div>'
              },
              'fab-container': {
                template: '<div ui-view="fab-container"></div>'
              }
            },
            data: {
              name: 'client_email_templates'
            },
            resolve: {
              stateParams: ['$transition$', function (transition) {
  
                const tabItems = [{
                  state: 'app.tabbed_app_framework.self_service_client_management_detail.client_email_templates.email_edit.settings',
                  name: 'settings',
                  label: 'Settings'
                }, {
                  state: 'app.tabbed_app_framework.self_service_client_management_detail.client_email_templates.email_edit.editor',
                  name: 'editor',
                  label: 'Editor'
                }, {
                  state: 'app.tabbed_app_framework.self_service_client_management_detail.client_email_templates.email_edit.insights',
                  name: 'insights',
                  label: 'Insights'
                }];
  
                return {
                  _emailid: transition.params()._emailid,
                  transitionTo: transition.to(),
                  items: tabItems
                };
              }],
              prepState: ['$q', 'ClientEmailTemplatesFactory', 'CurrentClientEmailTemplateFactory', '$transition$', 'EncodingService', function (promise, ClientEmailTemplatesFactory, CurrentClientEmailTemplateFactory, $transition$, encoder) {
                return new promise(function (resolve, reject) {
                  return ClientEmailTemplatesFactory.init()
                    .then(function () {
                      return CurrentClientEmailTemplateFactory.getTemplateById(encoder.decode($transition$.params()._emailid))
                        .then(function (result) {
                          resolve(result);
                        });
                    })
                    .catch(reject);
                });
              }],
              layout: ['LayoutsFactory', function (layouts) {
                layouts.setProperty('rightHandContainerWidth', '0');
              }],
              rootStatePath: [function (){
                return 'app.tabbed_app_framework.self_service_client_management_detail.client_email_templates';
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.self_service_client_management_detail.client_email_templates.email_edit.settings',
          props: {
            url: '/settings',
            title: 'Email Template Settings',
            views: {
              'spof': {
                component: 'zpClientEmailTemplateSettings',
                bindings: {
                  rootStatePath: 'rootStatePath'
                }
              }
            },
            data: {
              name: 'settings'
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.self_service_client_management_detail.client_email_templates.email_edit.editor',
          props: {
            url: '/editor',
            title: 'Email Template Editor',
            views: {
              'spof': {
                component: 'zpClientEmailTemplateEditor',
                bindings: {
                  'rootStatePath': 'rootStatePath'
                }
              },
              'fab-container': {
                component: 'zpSaveClientEmailTemplateFab'
              }
            },
            data: {
              name: 'editor'
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.self_service_client_management_detail.client_email_templates.email_edit.insights',
          props: {
            url: '/insights',
            title: 'Email Template Insights',
            views: {
              'spof': {
                component: 'zpClientEmailTemplateInsights',
                bindings: {
                  emailTemplateId: 'templateId',
                  rootStatePath: 'rootStatePath'
                }
              }
            },
            data: {
              name: 'insights'
            },
            resolve: {
              templateId: ['$transition$', 'EncodingService', function (transition, encoder) {
                const templateId = encoder.decode(transition.params()._emailid);
                return templateId;
              }]
            }
          }
        },
      ];

    };
  }
})();

/**
 * Created by davidbeazer on 27/09/2016.
 */

(function () {
  'use strict';
  
  clientsConfig.$inject = ['$stateProvider', 'ClientsRouteConfigProvider'];
  selfServiceClientConfig.$inject = ['$stateProvider', 'SelfServiceClientConfigProvider'];
  angular
    .module('clients')
    .config(clientsConfig)
    .config(selfServiceClientConfig);

  function clientsConfig($stateProvider, ClientsRouteConfigProvider) {
    const routes = ClientsRouteConfigProvider.$get();

    routes.forEach((route)=> {
      $stateProvider.state(route.statePath, route.props);
    });
  }

  function selfServiceClientConfig($stateProvider, SelfServiceClientConfigProvider) {
    const routes = SelfServiceClientConfigProvider.$get();

    routes.forEach((route)=> {
      $stateProvider.state(route.statePath, route.props);
    });
  }
})();
  
/**
 * Created by davidbeazer on 27/09/2016.
 */
(function () {
  'use strict';
  angular
    .module('clients')
    .factory('ClientsDataFactory', ClientsDataFactory);

  ClientsDataFactory.$inject = ['$rootScope', 'ClientsAPI', 'ClientsMainMetadata', 'activateZubot', '$filter', 'AuthService', '$q', 'MessageService', 'GridDataFactory', 'DATA_BACKEND_WSURL'];
  /* ng-inject */
  function ClientsDataFactory($rootScope, ClientsAPI, ClientsMainMetadata, activateZubot, $filter, AuthService, $q, MessageService, GridDataFactory, DATA_BACKEND_WSURL) {

    $rootScope.$on('zp.websocket.messageRecieved', function(event, props){
      if (props.connection !== DATA_BACKEND_WSURL) return;

      const metadata = ClientsMainMetadata.getData();

      const message = JSON.parse(props.message);
      switch (message.type){
        case 'activateZubot':{
          const zubot =  message.data.zubot;
          switch (zubot.mission.type){
            case 'unarchiveClient':
            case 'archiveClient':
            case 'redactAllCRM':
            case 'deleteClient': {
              const clientId = getClientIdFromLocalModelViaDbName(message.data.databasename);
              $rootScope.$broadcast('zp.table-rows.refresh', { widgetId: metadata.id });

              updateClientInLocalModel(clientId, message.data.delta);
              
              $rootScope.$broadcast('zp.table-rows.refreshed', { widgetId: metadata.id });
            }
          }
          break;
        }
        case 'unarchiveClient':
        case 'archiveClient':
        case 'redactAllCRM':
        case 'deleteClient':{
          const clientId = getClientIdFromLocalModelViaDbName(message.data.databasename);
          $rootScope.$broadcast('zp.table-rows.refresh', { widgetId: metadata.id });

          const deltas = {
            clientOperationStatus: {
              progress: message.data.progress,
              currentStep: message.data.currentStep,
              totalSteps: message.data.totalSteps,
              operation: message.data.progress,
              zubot: message.data.zubot,
              milestone: message.data.milestone,
              caption: message.data.caption
            }
          };

          switch (message.type){
            case 'unarchiveClient':
            case 'archiveClient': {
              if (message.data.milestone === 'complete') {
                delete deltas.clientOperationStatus;
                deltas.clientArchived = message.type === 'unarchiveClient' ? false : true;
              }
              updateClientInLocalModel(clientId, deltas);
              break;
            }
            case 'redactAllCRM': {

              if (message.data.milestone === 'complete') {
                delete deltas.clientOperationStatus;
                deltas.clientRedacted = true;
              }

              updateClientInLocalModel(clientId, deltas);
              break;
            }
            case 'deleteClient': {
              if (message.data.milestone === 'complete') {
                removeClientDocFromViewModel(clientId);
                break;
              }

              updateClientInLocalModel(clientId, deltas);
              break;
            }
          }

          $rootScope.$broadcast('zp.table-rows.refreshed', { widgetId: metadata.id });
          break;
        }
        
      }
    });

    const factoryData = {
      items: [],
      itemsObject: {},
      cacheValid: false
    };

    return {
      getData: getData,
      getClientList: getClientList,
      getClientListForAccountSelectControl: getClientListForAccountSelectControl,
      checkClientDatabasename: checkClientDatabasename,
      switchAccount: switchAccount,
      invalidateCache: invalidateCache,
      addNewClientToLocalModel: addNewClientToLocalModel,
      updateClientInLocalModel: updateClientInLocalModel,
      removeClientDocFromViewModel: removeClientDocFromViewModel,
      deleteClient: deleteClient,
      archiveClient: archiveClient,
      unarchiveClient: unarchiveClient,
      redactAllCRM: redactAllCRM,
      factoryData: factoryData
    };

    //////////////////////////////

    function getData() {
      return factoryData;
    }

    function getClientList(filters) {
      return $q(
        function q(resolve, reject) {
          if (factoryData.cacheValid) {
            resolve(hydrateFactory(factoryData.rawData, filters));
          } else {
            try {
              resolve(makeServerCallToGetClientList(filters));
            } catch (e) {
              reject(e);
            }
          }
        });
    }

    function makeServerCallToGetClientList(filters) {
      return ClientsAPI.getClientList()
        .then(function (response) {
          hydrateFactory(response.data.data, filters);

          factoryData.cacheValid = true;
          return factoryData;
        })
        .catch(function (err) {
          throw err;
        });
    }

    function hydrateFactory(data, filters) {
      factoryData.items = data;
      factoryData.rawData = data;
      const shapedItemsArray = shapeDataForGrid(factoryData.items, filters);
      const arrayToMap = angular.copy(shapedItemsArray);
      factoryData.items = $filter('enhancedTableCells')(ClientsMainMetadata.getData(), shapedItemsArray);

      const clientObject = _.reduce(arrayToMap, function (clientObject, v) {
        clientObject[v.client._id] = v;
        return clientObject;
      }, {});
      factoryData.itemsObject = clientObject;
      GridDataFactory.hydrateData({
        items: factoryData.items,
        itemsObject: factoryData.itemsObject
      }, 'clients_list');

      return factoryData;
    }

    function shapeDataForGrid(arrayOfUnprocessedItems, filters) {
      const shapedArr = _.map(arrayOfUnprocessedItems, function (item) {
        return {
          client: {
            _id: item._id,
            companyname: item.companyname,
            databasename: item.databasename,
            notes: item.notes,
            zuantaccountmanager: item.zuantaccountmanager,
            zuantcustomersuccessmanager: item.zuantcustomersuccessmanager,
            activeusers: item.activeusers,
            accountStatus: item.accountStatus,
            clientArchived: item.clientArchived || false
          }
        };
      });

      if (!filters) return shapedArr;

      const filterQueries = filters.map((filter)=> filter.query);
      const cleansedFilters = mergeAndRemoveDuplicates(filterQueries);

      if (cleansedFilters.length === 0) return shapedArr;

      const filterPredicate = createFilterPredicate(cleansedFilters);

      const filteredArr = _.filter(shapedArr, filterPredicate);

      return filteredArr;
    }

    function createFilterPredicate(filters) {
      return (element) => {
        return filters.every(filter => {
          const key = Object.keys(filter)[0];
          const value = filter[key];
          return element.client[key] === value;
        });
      };
    }

    function mergeAndRemoveDuplicates(arr) {
      const merged = {};
      let result = [];
    
      outterloop:
      for (const obj of arr) {
        for (const key in obj) {
          const value = obj[key];
    
          if (key in merged) {
            if (merged[key] !== value) {
              // Remove the key from merged and result arrays
              delete merged[key];
              result = result.filter((query) => !query.hasOwnProperty(key));
              break outterloop;
            }
          } else {
            merged[key] = value;
          }
        }
    
        result.push(obj);
      }
    
      return result;
    }

    function checkClientDatabasename(nameToCheck) {
      return ClientsAPI.checkClientDatabasename(nameToCheck)
        .then(function (response) {
          return response;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function switchAccount(props) {
      const payload = {
        _id: props.clientId,
        databasename: factoryData.itemsObject[props.clientId].client.databasename
      };
      return AuthService.switchAccount(payload)
        .then(function (clientDoc) {
          return clientDoc;
        })
        .catch(function (err) {
          throw (err.data.data);
        });
    }

    function getClientListForAccountSelectControl() {
      return ClientsAPI.getClientList()
        .then(function (response) {
          return response;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function addNewClientToLocalModel(newClientData) {

      factoryData.itemsObject[newClientData._id] = {
        client: {
          databasename: newClientData.databasename
        }
      };
      const shapedItemToAdd = shapeDataForGrid([newClientData]);
      const filteredItem = $filter('enhancedTableCells')(ClientsMainMetadata.getData(), shapedItemToAdd);
      factoryData.items.push(filteredItem[0]);
      GridDataFactory.hydrateData({
        items: factoryData.items,
        itemsObject: factoryData.itemsObject
      }, 'clients_list');
    }

    function invalidateCache() {
      MessageService.writeLog({
        level: 'info',
        msg: 'invalidate clients list cache',
        tags: ['clients']
      });
      factoryData.cacheValid = false;
    }

    function getClientIdFromLocalModelViaDbName(dbName){
      const client = _.find(factoryData.rawData, function (itm) {
        if (itm.databasename == dbName) return true;
      });

      if (!client) return null;
      return client._id;
    }

    function updateClientInLocalModel(clientId, deltas){
      const factoryItemIndex = _.findIndex(factoryData.items, function (itm) {
        if (itm.client._id == clientId) return true;
      });

      const rawDataFactoryItemIndex = _.findIndex(factoryData.rawData, function (itm) {
        if (itm._id == clientId) return true;
      });

      if (rawDataFactoryItemIndex > - 1){
        factoryData.rawData.splice(rawDataFactoryItemIndex, 1, Object.assign(factoryData.rawData[rawDataFactoryItemIndex], deltas));

        const shapedItem = shapeDataForGrid([factoryData.rawData[rawDataFactoryItemIndex]]);

        if (factoryData.itemsObject[clientId]){
          factoryData.itemsObject[clientId].client = Object.assign(factoryData.itemsObject[clientId].client, deltas);
        } else {
          factoryData.itemsObject[clientId] = shapedItem[0];
        }
        
        const enhancedDeltas = $filter('enhancedTableCells')(ClientsMainMetadata.getData(), shapedItem);
        if (factoryItemIndex > -1){
          factoryData.items.splice(factoryItemIndex, 1, enhancedDeltas[0]);
        } else {
          factoryData.items.push(enhancedDeltas[0]);
        }

        GridDataFactory.hydrateData({
          items: factoryData.items,
          itemsObject: factoryData.itemsObject
        }, 'clients_list');
      }
    }

    function removeClientDocFromViewModel(clientId) {
      delete factoryData.itemsObject[clientId];
      spliceItemFromModel(clientId, factoryData.items);
      spliceItemFromModel(clientId, factoryData.rawData);

      GridDataFactory.hydrateData({
        items: factoryData.items,
        itemsObject: factoryData.itemsObject
      }, 'clients_list');
    }

    function spliceItemFromModel(_id, model) {
      const index = _.findIndex(model, function (itm) {
        return ((itm.client && itm.client._id === _id) || (itm._id && itm._id === _id));
      });
      model.splice(index, 1);
    }

    function deleteClient(task) {
      return activateZubot(false, task)
        .catch(function (err) {
          MessageService.showMessage('Error - ' + err.data.error);
          throw err;
        });
    }

    function archiveClient(task) {
      return activateZubot(false, task)
        .catch(function (err) {
          MessageService.showMessage('Error - ' + err.data.error);
          throw err;
        });
    }

    function unarchiveClient(task) {
      return activateZubot(false, task)
        .catch(function (err) {
          MessageService.showMessage('Error - ' + err.data.error);
          throw err;
        });
    }

    function redactAllCRM(task) {
      return activateZubot(false, task)
        .catch(function (err) {
          MessageService.showMessage('Error - ' + err.data.error);
          throw err;
        });
    }

  }
})();

/**
 * Created by davidbeazer on 27/09/2016.
 */

(function () {
  'use strict';

  angular
    .module('clients')
    .provider('ClientsRouteConfig', clientsRouteConfigProvider);
    
  function clientsRouteConfigProvider() {
    this.$get = function() {

      return [
        {
          statePath: 'app.homescreen_app_framework.clients',
          props: {
            url: '/clients',
            abstract: true,
            views: {
              'toolbarSection': {
                template: '<uiview ui-view="toolbarSection"></uiview>'
              },
              'spof': {
                template: '<uiview ui-view="spof"></uiview>'
              },
              'right-hand-container': {
                template: '<uiview ui-view="right-hand-container"></uiview>'
              },
              'fab-container': {
                component: 'zpAddClientFab'
              }
            },
            data: {
              permissions: {
                only: ['ZUANT_ADMIN']
              }
            },
            resolve: {
              metadata: ['ClientsMainMetadata', function (ClientsMainMetadata) {
                const metadata = ClientsMainMetadata.getData();
                return metadata;
              }]
            }
          }
        },
        {
          statePath: 'app.homescreen_app_framework.clients.home',
          props: {
            url: '/home',
            title: 'Accounts',
            views: {
              'toolbarSection': {
                component: 'zpSearchToolbar',
                bindings: {
                  metadata: 'metadata'
                }
              },
              'spof': {
                component: 'zpClientListPage'
              },
              'right-hand-container': {
                component: 'zpClientsWidgetContainer'
              }
            },
            data: {
              permissions: {
                only: ['ZUANT_ADMIN']
              }
            },
            resolve: {
              model: ['$q', 'ClientsDataFactory', 'MessageService', 'ToolbarFactory', 'UserPermissionsHelperFactory', function (promise, factory, message, toolbarfactory) {
                return new promise(function (resolve, reject) {
                  message.writeLog({
                    level: 'info',
                    msg: '/clients/home'
                  });
                  toolbarfactory.set({
                    title: 'Accounts',
                    navigationPath: '',
                    showBackButton: false
                  });
                  return factory.getClientList()
                    .then(function () {
                      resolve(factory);
                    })
                    .catch(reject);
                });
              }],
              metadata: ['ClientsMainMetadata', function (ClientsMainMetadata) {
                const metadata = ClientsMainMetadata.getData();
                return metadata;
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.client_detail',
          props: {
            url: '/clients/edit/:_id',
            abstract: true,
            views: {
              'left-hand-container': {
                template: '<uiview ui-view="left-hand-container"></uiview>'
              },
              'tab-navbar': {
                component: 'zpTabNavbar',
                bindings: {
                  stateParams: 'stateParams'
                }
              },
              'spof': {
                template: '<div ui-view="spof" layout-fill></div>'
              },
              'right-hand-container': {
                template: '<div ui-view="right-hand-container" layout-fill></div>'
              },
              'fab-container': {
                template: '<uiview ui-view="fab-container"></uiview>'
              }
            },
            data: {
              permissions: {
                only: ['ZUANT_ADMIN']
              }
            },
            resolve: {
              model: ['$q', 'CurrentClientModelFactory', '$transition$', 'EncodingService', 'MessageService', 'ToolbarFactory', 'UserFactory', 'UserPermissionsHelperFactory', 'BoltOnsFactory', 'PrimaryThemeFactory', 'SendThankYouEmailIntegrityCheck', function (promise, factory, $transition$, encoder, message, toolbarfactory, userfactory, permissionscheckfactory, boltons, primarytheme, SendThankYouEmailIntegrityCheck) {
                return new promise(function (resolve, reject) {
                  const decodedClientId = encoder.decode($transition$.params()._id);
                  let databasename;
                  permissionscheckfactory.init();
                  message.writeLog({
                    level: 'info',
                    msg: '/clients/edit/' + decodedClientId + '/account'
                  });
        
                  return factory.getClientById(decodedClientId)
                    .then(function (res) {
                      databasename = res.databasename;
                      toolbarfactory.set({
                        title: res.companyname,
                        navigationPath: 'app.homescreen_app_framework.clients.home',
                        showBackButton: true,
                        customStateParams: {
                          isDirtyCheck: true
                        }
                      });
                      return userfactory.getUserList(decodedClientId);
                    })
                    .then(function () {
                      return SendThankYouEmailIntegrityCheck.runCheckOnAccount();
                    })
                    .then(function () {
                      return boltons.getAccountPermissions(decodedClientId, databasename);
                    })
                    .then(function () {
                      if (boltons.factoryData.cacheValid) {
                        if (boltons.factoryData.permissions.boltOns.customSkins.enabled) {
                          return primarytheme.getPrimaryTheme(databasename);
                        } else {
                          resolve();
                        }
                      } else {
                        resolve();
                      }
                    })
                    .then(function () {
                      resolve();
                    })
                    .catch(reject);
                });
              }],
              stateParams: ['$transition$', 'UserService', function (transition, UserService) {
                const tabItems = [
                  {
                    state: 'app.tabbed_app_framework.client_detail.account_settings',
                    name: 'account_settings',
                    label: 'Account Settings'
                  },
                  {
                    state: 'app.tabbed_app_framework.client_detail.permissions.users-pool',
                    name: 'permissions',
                    label: 'Permissions'
                  },
                  {
                    state: 'app.tabbed_app_framework.client_detail.account_bolt_ons',
                    name: 'boltons',
                    label: 'Bolt-ons'
                  },
                  {
                    state: 'app.tabbed_app_framework.client_detail.consent_management',
                    name: 'consent',
                    label: 'Consent'
                  },
                  {
                    state: 'app.tabbed_app_framework.client_detail.privacy_statement_management',
                    name: 'privacy',
                    label: 'Privacy'
                  },
                  {
                    state: 'app.tabbed_app_framework.client_detail.external_partners',
                    name: 'external_partners',
                    label: 'External Partners'
                  },
                  {
                    state: 'app.tabbed_app_framework.client_detail.teams',
                    name: 'teams',
                    label: 'Teams'
                  },
                  {
                    state: 'app.tabbed_app_framework.client_detail.client_email_templates.home',
                    name: 'client_email_templates',
                    label: 'Email Templates'
                  }
                ];

                const isClientMarketpoint = UserService.isClientMarketpoint();
                const isClientArchived = UserService.isClientArchived();
                const hasClientOperation = UserService.hasClientOperation();
                const tabsToRemove = [];
                if (isClientMarketpoint){
                  tabsToRemove.push('boltons', 'consent', 'privacy', 'external_partners', 'teams');
                } else if (isClientArchived || hasClientOperation){
                  tabsToRemove.push('consent', 'privacy', 'external_partners', 'teams', 'client_email_templates');
                }

                if (tabsToRemove.length > 0){
                  for (let i = tabItems.length - 1; i >= 0; i--) {
                    if (tabsToRemove.indexOf(tabItems[i].name) > -1) tabItems.splice(i, 1);
                  }
                }

                return {
                  _id: transition.params()._id,
                  transitionTo: transition.to(),
                  items: tabItems
                };
              }],
              layout: ['LayoutsFactory', function (layouts) {
                layouts.setProperty('rightHandContainerWidth', '0');
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.client_detail.account_settings',
          props: {
            url: '/account',
            title: 'Account Settings',
            views: {
              'left-hand-container': {
                template: ''
              },
              'spof': {
                component: 'zpClientDetailPage',
                bindings: {
                  customSkinLibraryStatePath: 'customSkinLibraryStatePath',
                  customSkinEditorStatePath: 'customSkinEditorStatePath'
                }
              },
              'fab-container': {
                component: 'zpSaveClientDocFab'
              }
            },
            data: {
              name: 'account_settings',
              permissions: {
                only: ['ZUANT_ADMIN']
              }
            },
            resolve: {
              customSkinLibraryStatePath: [function (){
                return 'app.single_view_framework.customSkins.themes_library';
              }],
              customSkinEditorStatePath: [function (){
                return 'app.single_view_framework.customSkins.theme_editor';
              }],
              prep: ['ConsentViewModelFactory', 'LayoutsFactory', function (consentviewmodelfactory, layouts) {
                return consentviewmodelfactory.hydrateFactory()
                  .then(function () {
                    layouts.setProperty('rightHandContainerWidth', '0');
                    return;
                  });
              }],
              gdprEditCheck: ['CurrentClientModelFactory', function (currentclientmodel) {
                currentclientmodel.endElevatedEditSessionIfExpired();
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.client_detail.permissions',
          props: {
            url: '/permissions',
            abstract: true,
            views: {
              'left-hand-container': {
                template: '<div ui-view="left-hand-container"></div>'
              },
              'spof': {
                template: '<div ui-view="spof" layout-fill></div>'
              },
              'fab-container': {
                template: '<div ui-view="fab-container"></div>'
              }
            },
            data: {
              name: 'permissions',
              permissions: {
                only: ['ZUANT_ADMIN']
              },
              showLeftSidebar: false
            },
            resolve: {
              clientId: ['$transition$', 'EncodingService', 'PermissionsManagerFactory', function (transition, encoder, permissionmanagerfactory) {
                const decodedClientId = encoder.decode(transition.params()._id);
                permissionmanagerfactory.resetFactory();
                return decodedClientId;
              }],
              layout: ['LayoutsFactory', function (layouts) {
                layouts.setProperty('rightHandContainerWidth', '0');
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.client_detail.permissions.users-pool',
          props: {
            url: '/users-pool',
            title: 'Permissions pool',
            views: {
              'left-hand-container': {
                component: 'zpUserPoolSelector'
              },
              'spof': {
                template: '<zp-action-selector layout="column" layout-fill></zp-action-selector>'
              },
              'fab-container': {
                component: 'zpPermissionsFab'
              }
            },
            data: {
              name: 'permissions',
              permissions: {
                only: ['ZUANT_ADMIN']
              },
              showLeftSidebar: true
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.client_detail.account_bolt_ons',
          props: {
            url: '/account-bolt-ons',
            title: 'Account Bolt Ons',
            views: {
              'spof': {
                component: 'zpBoltOnManagementView',
                bindings: {
                  permissions: 'accountPermissions'
                }
              }
            },
            data: {
              name: 'boltons',
              permissions: {
                only: ['ZUANT_ADMIN']
              }
            },
            resolve: {
              accountPermissions: ['CurrentClientModelFactory', function (currentclientmodel) {
                return currentclientmodel.getCurrentClientCache().permissions;
              }],
              layout: ['LayoutsFactory', function (layouts) {
                layouts.setProperty('rightHandContainerWidth', '0');
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.client_detail.external_partners',
          props: {
            url: '/account-partners',
            title: 'External Partners',
            views: {
              'spof': {
                component: 'zpExternalPartnersPage'
              }
            },
            data: {
              name: 'external_partners',
              permissions: {
                only: ['ZUANT_ADMIN']
              }
            },
            resolve: {
              prep: ['ConsentViewModelFactory', 'LayoutsFactory', function (consentviewmodelfactory, layouts) {
                return consentviewmodelfactory.hydrateFactory()
                  .then(function () {
                    layouts.setProperty('rightHandContainerWidth', '0');
                    return;
                  });
              }],
              layout: ['LayoutsFactory', function (layouts) {
                layouts.setProperty('rightHandContainerWidth', '0');
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.client_detail.teams',
          props: {
            url: '/teams',
            views: {
              'spof': {
                component: 'zpTeamsPage'
              }
            },
            data: {
              name: 'teams',
              permissions: {
                only: ['ZUANT_ADMIN']
              }
            },
            resolve: {
              layout: ['LayoutsFactory', function (layouts) {
                layouts.setProperty('rightHandContainerWidth', '0');
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.client_detail.consent_management',
          props: {
            url: '/consent-management',
            title: 'Consent Management',
            views: {
              'spof': {
                component: 'zpConsentPage'
              },
              'fab-container': {
                component: 'zpConsentModelFabButtons'
              }
            },
            data: {
              name: 'consent',
              permissions: {
                only: ['ZUANT_ADMIN']
              }
            },
            resolve: {
              layout: ['ConsentViewModelFactory', function (consentViewModelFactory) {
                return consentViewModelFactory.hydrateFactory()
                  .then(function () {
                    return;
                  });
              }],
              gdprEditCheck: ['CurrentClientModelFactory', function (currentclientmodel) {
                currentclientmodel.endElevatedEditSessionIfExpired();
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.client_detail.privacy_statement_management',
          props: {
            url: '/privacy-statement-management',
            title: 'Privacy Management',
            views: {
              'spof': {
                component: 'zpPrivacyManagementPage',
                bindings: {
                  privacyStatements: 'privacyStatements'
                }
              },
              'fab-container': {
                component: 'zpPrivacyStatementFabButtons'
              }
            },
            data: {
              name: 'privacy',
              permissions: {
                only: ['ZUANT_ADMIN']
              }
            },
            resolve: {
              privacyStatements: ['PrivacyStatementsViewModel', function (PrivacyStatementsViewModel) {
                const params = {
                  options: {
                    includeVersionHistory: 1
                  },
                  queryObj: {
                    parameters: {
                      artefactType: 'PrivacyStatement'
                    },
                    fields: {
                      _lastmodifieddatelocalutc: 1,
                      _deletedatelocalutc: 1,
                      isPrimaryStatement: 1,
                      title: 1
                    }
                  }
                };
                return new Promise(function (resolve, reject) {
                  return PrivacyStatementsViewModel.hydrateFactoryWithPrivacyStatements(params)
                    .then(function () {
                      resolve();
                    })
                    .catch(function (err) {
                      reject(err);
                    });
                });
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.client_detail.client_email_templates',
          props: {
            url: '/email-templates',
            abstract: true,
            views: {
              'spof': {
                template: '<div ui-view="toolbarSection"></div><div ui-view="tab-navbar"></div><div ui-view="spof"></div>'
              },
              'right-hand-container': {
                template: '<div ui-view="right-hand-container"></div>'
              },
              'fab-container': {
                template: '<div ui-view="fab-container"></div>'
              }
            },
            data: {
              name: 'client_email_templates'
            },
            resolve: {
              model: ['$q', 'ClientEmailTemplatesFactory', function (promise, factory) {
                return new promise(function (resolve, reject) {
                  return factory.init()
                    .then(function () {
                      resolve(factory);
                    })
                    .catch(reject);
                });
              }],
              rootStatePath: [function (){
                return 'app.tabbed_app_framework.client_detail.client_email_templates';
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.client_detail.client_email_templates.home',
          props: {
            url: '',
            views: {
              'toolbarSection': {
                component: 'zpClientEmailTemplatesSearchToolbar'
              },
              'spof': {
                component: 'zpClientEmailTemplateList'
              },
              'right-hand-container': {
                component: 'zpClientEmailTemplatesWidgetContainer'
              },
              'fab-container': {
                component: 'zpAddClientEmailTemplateFab'
              }
            },
            data: {
              permissions: {
                only: function (transitionProperties) {
                  const isMarketpoint = transitionProperties.toState.data.isMarketpoint;
                  if (isMarketpoint) return ['SUPER_ZAM'];
  
                  return ['ZUANT_ADMIN'];
                }
              }
            },
            resolve: {
              layout: ['LayoutsFactory', function (layouts) {
                layouts.setProperty('rightHandContainerWidth', '40');
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.client_detail.client_email_templates.email_edit',
          props: {
            url: '/emails/:_emailid',
            abstract: true,
            views: {
              'tab-navbar': {
                component: 'zpTabNavbar',
                bindings: {
                  stateParams: 'stateParams'
                }
              },
              'spof': {
                template: '<div ui-view="spof" layout-fill></div>'
              },
              'fab-container': {
                template: '<div ui-view="fab-container"></div>'
              }
            },
            data: {
              name: 'client_email_templates'
            },
            resolve: {
              stateParams: ['$transition$', function (transition) {
  
                const tabItems = [{
                  state: 'app.tabbed_app_framework.client_detail.client_email_templates.email_edit.settings',
                  name: 'settings',
                  label: 'Settings'
                }, {
                  state: 'app.tabbed_app_framework.client_detail.client_email_templates.email_edit.editor',
                  name: 'editor',
                  label: 'Editor'
                }, {
                  state: 'app.tabbed_app_framework.client_detail.client_email_templates.email_edit.insights',
                  name: 'insights',
                  label: 'Insights'
                }];
  
                return {
                  _emailid: transition.params()._emailid,
                  transitionTo: transition.to(),
                  items: tabItems
                };
              }],
              prepState: ['$q', 'ClientEmailTemplatesFactory', 'CurrentClientEmailTemplateFactory', '$transition$', 'EncodingService', function (promise, ClientEmailTemplatesFactory, CurrentClientEmailTemplateFactory, $transition$, encoder) {
                return new promise(function (resolve, reject) {
                  return ClientEmailTemplatesFactory.init()
                    .then(function () {
                      return CurrentClientEmailTemplateFactory.getTemplateById(encoder.decode($transition$.params()._emailid))
                        .then(function (result) {
                          resolve(result);
                        });
                    })
                    .catch(reject);
                });
              }],
              layout: ['LayoutsFactory', function (layouts) {
                layouts.setProperty('rightHandContainerWidth', '0');
              }],
              rootStatePath: [function (){
                return 'app.tabbed_app_framework.client_detail.client_email_templates';
              }]
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.client_detail.client_email_templates.email_edit.settings',
          props: {
            url: '/settings',
            title: 'Email Template Settings',
            views: {
              'spof': {
                component: 'zpClientEmailTemplateSettings',
                bindings: {
                  rootStatePath: 'rootStatePath'
                }
              }
            },
            data: {
              name: 'settings'
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.client_detail.client_email_templates.email_edit.editor',
          props: {
            url: '/editor',
            title: 'Email Template Editor',
            views: {
              'spof': {
                component: 'zpClientEmailTemplateEditor',
                bindings: {
                  rootStatePath: 'rootStatePath'
                }
              },
              'fab-container': {
                component: 'zpSaveClientEmailTemplateFab'
              }
            },
            data: {
              name: 'editor'
            }
          }
        },
        {
          statePath: 'app.tabbed_app_framework.client_detail.client_email_templates.email_edit.insights',
          props: {
            url: '/insights',
            title: 'Email Template Insights',
            views: {
              'spof': {
                component: 'zpClientEmailTemplateInsights',
                bindings: {
                  emailTemplateId: 'templateId',
                  rootStatePath: 'rootStatePath'
                }
              }
            },
            data: {
              name: 'insights'
            },
            resolve: {
              templateId: ['$transition$', 'EncodingService', function (transition, encoder) {
                const templateId = encoder.decode(transition.params()._emailid);
                return templateId;
              }]
            }
          }
        },
        {
          statePath: 'app.single_view_framework.customSkins',
          props: {
            abstract: true,
            url: '/clients/theming/',
            views: {
              'spof': {
                template: '<div ui-view="spof" layout-fill></div>'
              },
              'fab-container': {
                template: '<uiview ui-view="fab-container"></uiview>'
              }
            },
            data: {
              permissions: {
                only: ['ZUANT_ADMIN']
              }
            },
            resolve: {
              model: ['$q', 'CurrentClientModelFactory', '$transition$', 'EncodingService', 'MessageService', 'ToolbarFactory', 'UserFactory', 'UserPermissionsHelperFactory', 'BoltOnsFactory', 'ThemingFactory', function (promise, factory, $transition$, encoder, message, toolbarfactory, userfactory, permissionscheckfactory, boltons, theming) {
                return new promise(function (resolve, reject) {
                  const decodedClientId = encoder.decode($transition$.params()._id);
                  let databasename;
                  permissionscheckfactory.init();
                  message.writeLog({
                    level: 'info',
                    msg: '/clients/edit/' + decodedClientId + '/account'
                  });
        
                  return factory.getClientById(decodedClientId)
                    .then(function (res) {
                      databasename = res.databasename;
                      return theming.getThemesForAccount();
                    })
                    .then(function () {
                      return boltons.getAccountPermissions(decodedClientId, databasename);
                    })
                    .then(function () {
                      resolve();
                    })
                    .catch(reject);
                });
              }]
            }
          }
        },
        {
          statePath: 'app.single_view_framework.customSkins.themes_library',
          props: {
            url: ':_id/library',
            title: 'Custom Skins Library',
            views: {
              'spof': {
                component: 'zpThemesLibrary',
                bindings: {
                  clientDoc: 'clientDoc',
                  customSkinEditorStatePath: 'customSkinEditorStatePath',
                  clientDetailStatePath: 'clientDetailStatePath',
                  layoutFill: true,
                  layout: 'column'
                }
              },
              'fab-container': {
                component: 'zpAddThemeFab',
                bindings: {
                  clientId: 'clientId'
                }
              }
            },
            params: {
              _id: null,
              customSkinEditorStatePath: null,
              clientDetailStatePath: null
            },
            data: {
              permissions: {
                only: ['ZUANT_ADMIN']
              }
            },
            resolve: {
              customSkinEditorStatePath: ['$stateParams', function ($stateParams) {
                return $stateParams.customSkinEditorStatePath || 'app.single_view_framework.customSkins.theme_editor';
              }],
              clientDetailStatePath: ['$stateParams', function ($stateParams) {
                return $stateParams.clientDetailStatePath || 'app.tabbed_app_framework.client_detail.account_settings';
              }],
              clientId: ['$transition$', 'EncodingService', function (transition, encoder) {
                return encoder.decode(transition.params()._id);
              }],
              clientDoc: ['CurrentClientModelFactory', 'clientId', function (CurrentClientModelFactory, clientId){
                return CurrentClientModelFactory.getClientById(clientId);
              }]
            }
          }
        },
        {
          statePath: 'app.single_view_framework.customSkins.theme_editor',
          props: {
            url: '/:_id/editor/:_themeId',
            title: 'Custom Skins Editor',
            views: {
              'spof': {
                component: 'zpThemeEditor',
                bindings: {
                  clientId: 'clientId',
                  theme: 'theme',
                  layoutFill: 'true',
                  layout: 'column'
                }
              },
              'fab-container': {
                component: 'zpSaveThemeFab'
              }
            },
            params: {
              _id: null,
              customSkinLibraryStatePath: null,
              clientDetailStatePath: null
            },
            data: {
              permissions: {
                only: ['ZUANT_ADMIN']
              }
            },
            resolve: {
              customSkinLibraryStatePath: ['$stateParams', function ($stateParams) {
                return $stateParams.customSkinLibraryStatePath || 'app.single_view_framework.customSkins.themes_library';
              }],
              clientDetailStatePath: ['$stateParams', function ($stateParams) {
                return $stateParams.clientDetailStatePath || 'app.tabbed_app_framework.client_detail.account_settings';
              }],
              clientId: ['$transition$', function (transition) {
                return transition.params()._id;
              }],
              theme: ['$transition$', '$q', 'CurrentThemeFactory', 'EncodingService', function (transition, promise, currentthemefactory, encoder) {
                return new promise(function (resolve, reject) {
                  const themeId = encoder.decode(transition.params()._themeId);
                  return currentthemefactory.hydrateFactoryWithTheme(themeId)
                    .then(function (themeDoc) {
                      resolve(themeDoc);
                    })
                    .catch(reject);
                });
              }]
            }
          }
        }
      ];
    };
  }
})();

/**
 * Created by davidbeazer on 29/09/2016.
 */
(function () {
  'use strict';

  angular
    .module('clients')
    .factory('ClientsAPI', ClientsAPI);

  ClientsAPI.$inject = ['APIService', 'APIFactory', 'EncodingService', 'uuidService'];
  /* ng-inject */
  function ClientsAPI(api, apiFactory, encoder, uuidService) {

    const clientApi = apiFactory.route('client');

    const services = {
      getClientList: clientApi.get,
      getClientById: clientApi.getById,
      getClientGlobalAccessObjectsByClientId,
      postClientData,
      checkClientDatabasename,
      uploadClientLogo,
      postClientLogo,
      clearLogoFromAccount,
      getPresetFromServer,
      requestPasscode,
      verifyPasscode,
      emailConsentModelToAccountOwner,
      getConsentModel,
      aggregateActiveUsers,
      aggregateActiveAccounts,
      deleteAccountActivityLogs,
      downloadUsers
    };

    return services;
    ////////////////////////////

    function getClientGlobalAccessObjectsByClientId(clientId) {

      const apiUrl = 'client/' + encoder.encode(clientId) + '/globalAccessObjects';
      return api.get(apiUrl)
        .then(function (res) {
          return res.data.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function postClientData(data, files) {
      const id = data._id;
      if (id) {
        return clientApi.update(data, files);
      } else {
        return clientApi.create(data, files);
      }
    }

    function downloadUsers(params) {
      return api.postToDataApi('client/getActiveUsers', params);
    }

    function checkClientDatabasename(nameToCheck) {

      const req = {
        parameters: {
          databasename: nameToCheck
        }
      };
      const apiUrl = 'client/query';
      return api.post(apiUrl, req)
        .then(function (res) {
          return res.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function uploadClientLogo(file){

      //portal logo id = yJa7zaTYQEKU8vouOtTnIw==
      return uuidService.getHashedIdFromBase64Id('yJa7zaTYQEKU8vouOtTnIw==')
        .then(function (id) {
          const payload = {
            _id: id,
            file: file
          };
  
          return api.uploadFileToS3(payload);
        });
    }

    function postClientLogo(data, clientId) {
      const apiUrl = 'client/' + encoder.encode(clientId) + '/logo';
      return api.post(apiUrl, data)
        .then(function (res) {
          return res.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function clearLogoFromAccount(clientId) {
      const apiUrl = 'client/' + encoder.encode(clientId) + '/clearlogo';
      return api.delete(apiUrl)
        .then(function (res) {
          return res.data;
        })
        .catch(function (err) {
          throw (err);
        });

    }

    function getPresetFromServer(preset) {
      const req = {
        presetId: preset
      };
      const apiUrl = 'client/permissionsPreset/' + preset;
      return api.post(apiUrl, req)
        .then(function (res) {
          return res.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function requestPasscode(req, clientId) {
      const apiUrl = 'client/' + encoder.encode(clientId) + '/requestPasscode';
      return api.post(apiUrl, req)
        .then(function (res) {
          return res.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function verifyPasscode(req, clientId) {
      const apiUrl = 'client/' + encoder.encode(clientId) + '/verifyPasscode';
      return api.post(apiUrl, req)
        .then(function (res) {
          return res.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function emailConsentModelToAccountOwner(clientId) {
      const encodedClientId = encoder.encode(clientId);
      if (!encodedClientId) return Promise.reject('invalid client id');
      const apiUrl = 'client/' + encodedClientId + '/emailConsentModelToAccountOwner';
      return api.post(apiUrl, {})
        .then(function (res) {
          return res.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function getConsentModel(clientId) {

      const req = {
        parameters: {
          _id: clientId
        },
        fields: {
          databasename: 1,
          consentModel: 1,
          GDPR: 1
        }
      };
      const apiUrl = 'client/query';
      return api.post(apiUrl, req)
        .then(function (res) {
          if (res.data.data.length) {
            return res.data.data[0];
          }
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function aggregateActiveUsers(payload) {
      return api.post('client-helper/aggregateActiveUsers', payload)
        .then(function (res) {
          return res.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function aggregateActiveAccounts(payload) {
      return api.post('client-helper/aggregateActiveAccounts', payload)
        .then(function (res) {
          return res.data;
        })
        .catch(function (err) {
          throw (err);
        });
    }

    function deleteAccountActivityLogs(clientId) {
      return api.post('client-helper/deleteAccountActivityLogs', { clientId: clientId })
        .then(resolve)
        .catch(reject);
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('clients')
    .factory('AccountExportsFactory', Factory);

  Factory.$inject = ['UnparseData', 'DownloadCSV', 'ClientsAPI', 'ClientsMainMetadata', 'MessageService'];
  /** @ngInject */
  function Factory(UnparseData, DownloadCSV, ClientsAPI, ClientsMainMetadata, MessageService) {

    return {
      downloadAccountExport: downloadAccountExport,
      aggregateActiveUsers: aggregateActiveUsers,
      aggregateActiveAccounts: aggregateActiveAccounts,
      createActiveUsersChart: createActiveUsersChart,
      deleteAccountActivityLogs: deleteAccountActivityLogs,
      downloadUsers: downloadUsers,
    };

    function downloadAccountExport(params) {
      var rawClientsData;
      return ClientsAPI.getClientList()
        .then(clientsData => {
          rawClientsData = clientsData.data.data;
          return aggregateActiveUsers(params);
        })
        .then(activeUserAggregation => {
          return prepareAndDownloadCSV(params.groupSize, rawClientsData, activeUserAggregation);
        });
    }

    function downloadUsers(params) {
      return ClientsAPI.downloadUsers(params)
        .then(res => {
          var cols = Object.keys(res.data.data[0]);
          var csv = UnparseData(cols, res.data.data);
          var filename = 'Zuant Modern Account Export: monthly totals.csv';
    
          DownloadCSV(filename, csv);
    
          MessageService.showMessage('Account Export Complete');
        });
    }

    function aggregateActiveUsers(payload) {
      return ClientsAPI.aggregateActiveUsers(payload)
        .then(res => {
          return res.data;
        })
        .catch(err => {
          throw err;
        });
    }

    function aggregateActiveAccounts(payload) {
      return ClientsAPI.aggregateActiveAccounts(payload)
        .then(res => {
          return res.data;
        })
        .catch(err => {
          throw err;
        });
    }

    function createActiveUsersChart(payload) {
      return aggregateActiveUsers(payload)
        .then(res => buildChartData(payload.groupSize, res));
    }

    //// private helpers

    function prepareAndDownloadCSV(groupSize, rawClientsData, activeUsersAggregation) {
      var columnsData = buildColumnsDataObj(groupSize);
      var exportData = mergeDataForExport(activeUsersAggregation, rawClientsData, groupSize);
      var csv = UnparseData(columnsData.mergedColumnLabels, exportData);
      var bucketSizeString = (groupSize == 'day') ? 'daily totals' : (groupSize == 'month') ? 'monthly totals' : 'year totals';
      var filename = 'Zuant Account Export:' + bucketSizeString + '.csv';

      DownloadCSV(filename, csv);

      MessageService.showMessage('Account Export Complete');
      return csv;
    }

    function buildColumnsDataObj(groupSize) {
      return {
        mergedColumnLabels: _.map(accountColumnsForExport(), 'label').concat(flattenLabelsForCSV(groupSize))
      };
    }

    function flattenLabelsForCSV(groupSize) {
      var flattenedLabels = [];
      _.each(buildDateLabels(groupSize), labelObj => {
        if (labelObj.app) {
          flattenedLabels.push(labelObj.app);
          flattenedLabels.push(labelObj.cloud);
          flattenedLabels.push(labelObj.total);
        } else {
          flattenedLabels.push(labelObj);
        }
      });
      return flattenedLabels;
    }

    function accountColumnsForExport() {
      var mdata = ClientsMainMetadata.getData();
      return _.filter(mdata.columnsData.items, col => {
        return col.downloadCol;
      });
    }

    function mergeDataForExport(activeUsersAggregation, rawClientsData, groupSize) {
      var columnLabelsDictionary = createLabelsDictionary(accountColumnsForExport());
      var labelObjects = buildDateLabels(groupSize);

      var ro = _.map(rawClientsData, clientDoc => {
        var rowData = {};
        var keys = Object.keys(columnLabelsDictionary);
        _.each(keys, key => rowData[columnLabelsDictionary[key]] = clientDoc[key]); // map values to object keyed off label values vs db fieldname values. This is for .csv headers

        var accountActivityData = _.find(activeUsersAggregation, acc => clientDoc._id === acc._id);
        // loop labels and fill rows from chartData
        _.each(labelObjects, label => {
          if (accountActivityData) {
            var matchingDateObj = _.find(accountActivityData.loginsGroupedByDate, logData => logData.dt === label.date);
            if (matchingDateObj) {
              rowData[label.app] = matchingDateObj.uniqueiOSUsers + matchingDateObj.uniqueAndroidUsers;
              rowData[label.cloud] = matchingDateObj.uniqueCloudUsers;
              rowData[label.total] = matchingDateObj.uniqueUsersSize;
            } else {
              rowData[label.app] = 0;
              rowData[label.cloud] = 0;
              rowData[label.total] = 0;
            }
          } else {
            rowData[label.app] = 0;
            rowData[label.cloud] = 0;
            rowData[label.total] = 0;
          }
        });

        return rowData;
      });

      return ro;
    }

    function createLabelsDictionary(columnLabels) {
      var objKeyedOffDbField = {};
      _.each(columnLabels, labelObj => {
        objKeyedOffDbField[labelObj.databasefieldname] = labelObj.label;
      });
      return objKeyedOffDbField;
    }


    function buildChartData(groupSize, serverData) {

      var labels = buildDateLabels(groupSize);
      var chartableData = buildChartDataArrays(serverData, labels);

      return {
        data: serverData,
        chartableData: chartableData,
        labels: _.map(labels, 'eye_friendly_date')
      };
    }

    function buildChartDataArrays(groupedAccountActivity, labels) {

      var outerShell = [], innerShell, rollingTotal;

      _.each(groupedAccountActivity, aggregatedData => {

        innerShell = [];
        rollingTotal = 0;
        _.each(labels, labelObj => {
          // ensures we loop long enough each time
          var matchingDateObj = _.find(aggregatedData.loginsGroupedByDate, group => group.dt == labelObj.date);
          if (matchingDateObj) {
            rollingTotal += matchingDateObj.uniqueUsersSize;
            innerShell.push(matchingDateObj.uniqueUsersSize);
          } else {
            innerShell.push(0);
          }
        });

        aggregatedData.activeUserTotal = rollingTotal;
        outerShell.push(innerShell);
      });

      return outerShell;
    }

    function buildDateLabels(timeGranularity) {
      // will go back in time and create empty date containers for chart data to fill
      var arrayOfDateLabels = [],
        now = moment(),
        startDate, diff;
      if (timeGranularity === 'day') {
        startDate = moment().startOf('month');
        diff = now.diff(startDate, 'days');
        for (var i = 0, j = diff; i <= j; i++) {
          var outputLabel = startDate.format('DD-MMM-YY'); // 01-Jan-20 etc
          arrayOfDateLabels.push({
            date: startDate.format('YYYY-MM-DD'),
            eye_friendly_date: outputLabel,
            app: outputLabel + '_app',
            cloud: outputLabel + '_cloud',
            total: outputLabel + '_total'
          });

          startDate = startDate.add(1, 'days');
        }
      } else if (timeGranularity === 'month') {
        startDate = moment().startOf('year');
        diff = 11;
        for (var ii = 0, jj = diff; ii <= jj; ii++) {
          var outputLabel2 = startDate.format('MMM-YY');  // Jan-20, Feb-20 etc
          arrayOfDateLabels.push({
            date: startDate.format('YYYY-MM'),
            eye_friendly_date: outputLabel2,
            app: outputLabel2 + '_app',
            cloud: outputLabel2 + '_cloud',
            total: outputLabel2 + '_total'
          });
          startDate = startDate.add(1, 'months');
        }
      } else if (timeGranularity === 'year') {
        arrayOfDateLabels.push({
          date: '2021',
          eye_friendly_date: '2021',
          app: '2021_app',
          cloud: '2021_cloud',
          total: '2021_total',
        });
        arrayOfDateLabels.push({
          date: '2022',
          eye_friendly_date: '2022',
          app: '2022_app',
          cloud: '2022_cloud',
          total: '2022_total',
        });
      }
      return arrayOfDateLabels;
    }

    function deleteAccountActivityLogs(accountId) {
      // console.log('deleteAccountActivityLogs running for accountId: ', accountId);
      ClientsAPI.deleteAccountActivityLogs(accountId);
      // .then(console.log)
      // .catch(console.error)
    }
  }

}());

(function () {
  'use strict';

  angular
    .module('bizcard')
    .config(moduleConfig);

  moduleConfig.$inject = ['$stateProvider'];
  /* @ngInject */
  function moduleConfig($stateProvider) {

    $stateProvider
      .state('app.homescreen_app_framework_no_sidebar.bizcard_home', {
        url: '/bizcard/home',
        title: 'Bizcard Processor Home',
        views: {
          'spof': {
            template: '<zp-bizcard-home layout-fill></zp-bizcard-home>'
          }
        },
        resolve: {
          model: ['BusinessCardModelFactory', '$q', function (BusinessCardModelFactory, $q) {
            return $q(
              function q(resolve, reject) {
                BusinessCardModelFactory.aggregateCardsByClient()
                  .then(resolve)
                  .catch(reject);
              }
            );
          }]
        }
      })
      .state('app.homescreen_app_framework_no_sidebar.bizcard', {
        abstract: true,
        url: '/business-card-processor',
        views: {
          'spof': {
            template: '<uiview ui-view="spof" flex></uiview>'
          },
          'right-hand-container': {
            template: '<uiview ui-view="right-hand-container"></uiview>'
          }
        }
      })
      .state('app.homescreen_app_framework_no_sidebar.bizcard.grouped-cards-view', {
        url: '/grouped-cards-view',
        title: 'Bizcard Processor Dashboard',
        views: {
          'spof': {
            component: 'zpBizcardGroupedCards',
            bindings: {}
          }
        },
        resolve: {
          model: ['SessionService', 'BusinessCardModelFactory', 'MessageService', '$q', function (session, BusinessCardModelFactory, messageService, $q) {
            var userClientList = [session.getUserData().clientId];
            return $q(
              function q(resolve, reject) {
                BusinessCardModelFactory.getBusinessCardDataAggregation(userClientList)
                  .then(resolve)
                  .catch(reject);
              }
            );
          }]
        },
        data: {
          permissions: {
            only: ['OCR_VIEW']
          }
        }
      })
      .state('app.homescreen_app_framework_no_sidebar.bizcard.card-processing-view', {
        url: '/card-processing-view',
        title: 'Bizcard Processor',
        views: {
          'spof': {
            component: 'zpBizcardProcessorPage',
            bindings: {
              leadData: 'leadData'
            }
          }
        },
        resolve: {
          leadData: ['BusinessCardModelFactory', '$q', 'MessageService', function (BusinessCardModelFactory, $q, MessageService) {
            return $q(
              function q(resolve) {
                BusinessCardModelFactory.getNextCardToProcess(false)
                  .then(function (leadData) {
                    resolve(leadData);
                  })
                  .catch(function (err) {
                    MessageService.showMessage('Error getting card data from server: ' + err.message);
                    resolve();
                  });
              }
            );
          }]
        },
        data: {
          permissions: {
            only: ['OCR_EDIT', 'LEADS_EDITGRID']
          }
        }
      })
      .state('app.homescreen_app_framework_no_sidebar.bizcard.card-reporting-view', {
        url: '/card-reporting-view',
        views: {
          'spof': {
            component: 'zpBizcardReporting'
          }
        },
        data: {
          permissions: {
            only: ['LEADS_EDITGRID']
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('authentication')
    .component('four03', {
      templateUrl: 'app/authentication/403.tmpl.html',
      bindings: {},
      controller: 'errorPageCtrl'
    })
    .component('four04', {
      templateUrl: 'app/authentication/404.tmpl.html',
      bindings: {},
      controller: 'errorPageCtrl'
    })
    .component('fiveHundo', {
      templateUrl: 'app/authentication/500.tmpl.html',
      bindings: {
        data: '<'
      },
      controller: 'errorPageCtrl'
    })
    .controller('errorPageCtrl', ctrl);

  ctrl.$inject = ['$location', '$log', 'localStorageService', '$window', '$filter'];
  /* ng-inject*/
  function ctrl($location, $log, localStorageService, $window, $filter) {

    var vm = this;

    vm.$onInit = function (){
      $log.error('theres been a server error');
      vm.errorObj = localStorageService.get('serverErrorObject');

      vm.fiveHundredErrorIconImageSvg = $filter('cdnAssets')('/images/svgs/utilities/500/500-error.svg');
    };

    vm.openIntercomChatPanel = function (){};

    vm.goHome = function () {
      $location.path('/dashboard');
    };

    vm.goBack = function () {
      $window.history.back();
    };
  }

}());

(function () {
  'use strict';

  angular
    .module('authentication')
    .config(moduleConfig);

  moduleConfig.$inject = ['$stateProvider'];
  /* @ngInject */
  function moduleConfig($stateProvider) {

    $stateProvider
      .state('login', {
        url: '/login',
        title: 'Welcome',
        views: {
          'master': {
            component: 'zpLoginPage',
            bindings: {
              layout: 'layout',
              layoutFill: 'layoutFill',
              appSettings: 'appSettings',
              zuantLogoURL: 'zuantLogoURL'
            }
          }
        },
        data: {
          permissions: {
            only: ['UNAUTHORIZED'],
            redirectTo: 'app.single_view_framework.dashboard'
          }
        },
        resolve: {
          layout: [function (){
            return 'column';
          }],
          layoutFill: [function (){
            return true;
          }],
          appSettings: ['appSettings', function (appSettings){
            return appSettings;
          }],
          zuantLogoURL: ['$filter', function ($filter){
            return $filter('cdnAssets')('/images/svgs/logos/zuant/ZUANT_CLOUD.svg');
          }]
        }
      })
      .state('mfa', {
        abstract: true,
        url: '/mfa',
        views: {
          'master': {
            template: '<div ui-view="master" flex layout="column"></div>'
          }
        },
        data: {},
        resolve: {
          layout: [function (){
            return 'column';
          }],
          layoutFill: [function (){
            return true;
          }],
          zuantLogoURL: ['$filter', function ($filter){
            return $filter('cdnAssets')('/images/svgs/logos/zuant/ZUANT_CLOUD.svg');
          }]
        }
      })
      .state('mfa.setup', {
        url: '/setup',
        title: 'MFA Setup',
        views: {
          'master': {
            component: 'zpMfaSetup',
            bindings: {
              layout: 'layout',
              layoutFill: 'layoutFill',
              zuantLogoURL: 'zuantLogoURL',
              databasename: 'databasename',
              userId: 'userId',
              email: 'email'
            }
          }
        },
        data: {
          permissions: {
            only: ['UNAUTHORIZED'],
            redirectTo: 'app.single_view_framework.dashboard'
          }
        },
        params: {
          databasename: null,
          userId: null,
          email: null
        },
        resolve: {
          checkHasParams: ['$state', '$stateParams', function ($state, $stateParams){
            return new Promise(function (resolve) {
              if ($stateParams.databasename && $stateParams.userId && $stateParams.email) return resolve(true);

              //redirect if they shouldn't be herer
              $state.dispose();
              $state.go('login');
            });
          }],
          databasename: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.databasename;
          }],
          userId: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.userId;
          }],
          email: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.email;
          }]
        }
      })
      .state('mfa.setup-confirm', {
        url: '/setup/confirm?token',
        title: 'MFA Setup Confirm',
        views: {
          'master': {
            component: 'zpMfaConfirmSetup',
            bindings: {
              layout: 'layout',
              layoutFill: 'layoutFill',
              zuantLogoURL: 'zuantLogoURL',
              resolvedToken: 'resolvedToken'
            }
          }
        },
        data: {},
        resolve: {
          deAuthenticate: ['$rootScope', 'AuthService', 'SessionService', 'PermPermissionStore', function ($rootScope, AuthService, SessionService, PermPermissionStore){
            const unauthenticated = PermPermissionStore.getPermissionDefinition('UNAUTHORIZED');
            return unauthenticated.validatePermission()
              .then(function(){
                return;
              })
              .catch(function (){
                return AuthService.deauthenticateUser()
                  .then(function () {
                    SessionService.destroy();

                    $rootScope.$emit('zp.intercom-shutdown');
                    $rootScope.$emit('zp.user.deauthenticated');
                  });
              });
          }],
          resolvedToken: ['deAuthenticate', '$state', '$transition$', 'MfaFactory', 'MessageService', function (_deAuthenticate, $state, $transition, MfaFactory, MessageService) {
            return new Promise(function (resolve) {
              const params = $transition.params();
              const token = params.token;

              return MfaFactory.checkUrlTokenIsValid(token)
                .then(function(resp) {
                  resolve(resp.data.data);
                })
                .catch(function(error) {
                  if (error.status === -1) return MessageService.showMessage('Server Error: server returned status code -1.');

                  const msg = _.get(error, ['data', 'error'], 'Invalid token - The submitted token is invalid');
                  MessageService.showMessage(msg);

                  //redirect if they shouldn't be here
                  $state.dispose();
                  $state.go('login');
                });
            });
          }]
        }
      })
      .state('mfa.verification', {
        url: '/verification',
        title: 'MFA Verification',
        views: {
          'master': {
            component: 'zpMfaVerification',
            bindings: {
              layout: 'layout',
              layoutFill: 'layoutFill',
              zuantLogoURL: 'zuantLogoURL',
              email: 'email',
              databasename: 'databasename',
              userId: 'userId'
            }
          }
        },
        data: {
          permissions: {
            only: ['UNAUTHORIZED'],
            redirectTo: 'app.single_view_framework.dashboard'
          }
        },
        params: {
          email: null,
          databasename: null, 
          userId: null
        },
        resolve: {
          checkHasParams: ['$state', '$stateParams', function ($state, $stateParams){
            return new Promise(function (resolve){
              if ($stateParams.email && $stateParams.databasename && $stateParams.userId) return resolve(true);
            
              //redirect if they shouldn't be here
              $state.dispose();
              $state.go('login');
            });
          }],
          email: ['checkHasParams', '$stateParams', function (_checkHasParams, $stateParams){
            return $stateParams.email;
          }],
          databasename: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.databasename;
          }],
          userId: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.userId;
          }]
        }
      })
      .state('mfa.recovery', {
        url: '/recovery',
        title: 'MFA Recovery',
        views: {
          'master': {
            component: 'zpMfaRecovery',
            bindings: {
              layout: 'layout',
              layoutFill: 'layoutFill',
              zuantLogoURL: 'zuantLogoURL',
              email: 'email',
              databasename: 'databasename',
              userId: 'userId'
            }
          }
        },
        data: {
          permissions: {
            only: ['UNAUTHORIZED'],
            redirectTo: 'app.single_view_framework.dashboard'
          }
        },
        params: {
          email: null,
          databasename: null,
          userId: null
        },
        resolve: {
          checkHasParams: ['$state', '$stateParams', function ($state, $stateParams){
            return new Promise(function (resolve){
              if ($stateParams.email && $stateParams.databasename && $stateParams.userId) return resolve(true);
            
              //redirect if they shouldn't be here
              $state.dispose();
              $state.go('login');
            });
            
          }],
          email: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.email;
          }],
          databasename: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.databasename;
          }],
          userId: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.userId;
          }],
          sendRecovery: ['checkHasParams', 'databasename', 'userId', '$state', 'MessageService', 'MfaFactory', function (_checkHasParams, databasename, userId, $state, MessageService, MfaFactory){
            return MfaFactory.requestReset(databasename, userId)
              .then(function (res){
                const msg = _.get(res, ['data', 'message'], 'Successfully sent reset request');

                MessageService.showMessage(msg);
              })
              .catch(function (error){
                if (error.status === -1) return MessageService.showMessage('Server Error: server returned status code -1.');

                const msg = _.get(error, ['data', 'error'], 'Reset Request Failed');
                MessageService.showMessage(msg);

                //redirect so they don't get generic unauth error popup dialog
                $state.dispose();
                $state.go('login');
              });
          }]
        }
      })
      .state('mfa.confirm-reset', {
        url: '/reset/confirm?:token&:type&:email',
        title: 'MFA Confirm Reset Request',
        views: {
          'master': {
            component: 'zpMfaConfirmReset',
            bindings: {
              layout: 'layout',
              layoutFill: 'layoutFill',
              zuantLogoURL: 'zuantLogoURL',
              type: 'type',
              email: 'email',
              message: 'message',
              error: 'error'
            }
          }
        },
        data: {},
        params: {
          type: null,
          email: null,
          message: null,
          error: null
        },
        resolve: {
          checkHasParams: ['$state', '$stateParams', function ($state, $stateParams){
            return new Promise(function (resolve){
              if ($stateParams.token && $stateParams.email && $stateParams.type) return resolve(true);
            
              //redirect if they shouldn't be here
              $state.dispose();
              $state.go('login');
            });
          }],
          token: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.token;
          }],
          email: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.email;
          }],
          type: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.type;
          }],
          tokenIsValid: ['checkHasParams', 'token', '$transition$', 'MfaFactory', 'MessageService', function (_checkHasParams, token, $state, MfaFactory, MessageService) {
            return new Promise(function (resolve) {

              return MfaFactory.triggerResetByToken(token)
                .then(function(resp) {
                  resolve({ message: resp.data.message });
                })
                .catch(function(error) {
                  if (error.status === -1) return MessageService.showMessage('Server Error: server returned status code -1.');

                  const msg = _.get(error, ['data', 'error'], 'Invalid token - The submitted token is invalid');

                  if (msg.code && msg.code === 'MFA_TOKEN_EXPIRED'){
                    MessageService.showMessage(msg.message);
                    return resolve({ error: msg.message });
                  }

                  MessageService.showMessage(msg);

                  //redirect if they shouldn't be here
                  $state.dispose();
                  $state.go('login');
                });
            });
          }],
          message: ['tokenIsValid', function (tokenIsValid){
            if (tokenIsValid.message) return tokenIsValid.message;
            return null;
          }],
          error: ['tokenIsValid', function (tokenIsValid){
            if (tokenIsValid.error) return tokenIsValid.error;
            return null;
          }]
        }
      })
      .state('update-password', {
        url: '/update-password',
        views: {
          'master': {
            component: 'zpUpdatePasswordPage',
            bindings: {
              layout: 'layout',
              layoutFill: 'layoutFill',
              zuantLogoURL: 'zuantLogoURL',
              userId: 'userId',
              databasename: 'databasename',
              passwordPolicy: 'passwordPolicy'
            }
          }
        },
        params: {
          databasename: null,
          userId: null,
          passwordPolicy: null
        },
        data: {},
        resolve: {
          checkHasParams: ['$state', '$stateParams', function ($state, $stateParams){
            return new Promise(function (resolve){
              if ($stateParams.databasename && $stateParams.userId && $stateParams.passwordPolicy) return resolve(true);
            
              //redirect if they shouldn't be here
              $state.dispose();
              $state.go('login');
            });
            
          }],
          databasename: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.databasename;
          }],
          userId: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.userId;
          }],
          passwordPolicy: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.passwordPolicy;
          }],
          layout: [function (){
            return 'column';
          }],
          layoutFill: [function (){
            return true;
          }],
          zuantLogoURL: ['$filter', function ($filter){
            return $filter('cdnAssets')('/images/svgs/logos/zuant/ZUANT_CLOUD.svg');
          }]
        }
      })
      .state('forgot', {
        url: '/forgot',
        views: {
          'master': {
            template: '<zp-forgot-password-page layout-fill></zp-forgot-password-page>'
          }
        },
        data: {
          permissions: {
            only: ['UNAUTHORIZED'],
            redirectTo: 'app.single_view_framework.dashboard'
          }
        }
      })
      .state('resetPassword', {
        url: '/resetPassword/:clientId/:resetId/:userId/:email',
        views: {
          'master': {
            component: 'zpResetPasswordPage',
            bindings: {
              layout: 'layout',
              layoutFill: 'layoutFill',
              appSettings: 'appSettings',
              zuantLogoURL: 'zuantLogoURL',
              passwordPolicy: 'passwordPolicy',
              clientId: 'clientId',
              userId: 'userId',
              resetId: 'resetId'
            }
          }
        },
        data: {
          permissions: {
            only: ['UNAUTHORIZED'],
            redirectTo: 'app.single_view_framework.dashboard'
          }
        },
        resolve: {
          appSettings: ['appSettings', function (appSettings){
            return appSettings;
          }],
          zuantLogoURL: ['$filter', function ($filter){
            return $filter('cdnAssets')('/images/svgs/logos/zuant/ZUANT_CLOUD.svg');
          }],
          checkHasParams: ['$state', '$stateParams', function ($state, $stateParams){
            return new Promise(function (resolve){
              if ($stateParams.clientId && $stateParams.resetId && $stateParams.userId) return resolve(true);
            
              //redirect if they shouldn't be here
              $state.dispose();
              $state.go('login');
            });
          }],
          clientId: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.clientId;
          }],
          userId: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.userId;
          }],
          resetId: ['checkHasParams', '$stateParams', function(_checkHasParams, $stateParams){
            return $stateParams.resetId;
          }],
          checkLink: ['PasswordResetFactory', 'clientId', 'resetId', 'userId', function (PasswordResetFactory, clientId, resetId, userId) {
            return new Promise(function (resolve) {

              return PasswordResetFactory.checkLinkIsValid(clientId, userId, resetId)
                .then(function (resp) {
                  return resolve({
                    valid: true,
                    passwordPolicy: resp.passwordPolicy || {}
                  });
                })
                .catch(function (){
                  resolve({ valid: false });
                });
            });
          }],
          linkIsValid: ['checkLink', function (checkLink){
            return checkLink.valid;
          }],
          passwordPolicy: ['checkLink', function (checkLink){
            if (checkLink.valid === false) return {};
            return checkLink.passwordPolicy;
          }]
        }
      })
      .state('logout', {
        url: '/logout',
        title: '👋',
        views: {
          'master': {
            component: 'zpLoginPage',
            bindings: {
              layout: 'layout',
              layoutFill: 'layoutFill',
              appSettings: 'appSettings',
              zuantLogoURL: 'zuantLogoURL'
            }
          }
        },
        resolve: {
          layout: [function (){
            return 'column';
          }],
          layoutFill: [function (){
            return true;
          }],
          endElevatedEditSession: ['CurrentClientModelFactory', function (CurrentClientModelFactory){
            if (CurrentClientModelFactory.factoryData.userPermittedToMakeGDPREdits.permitted) {
              return CurrentClientModelFactory.endElevatedEditSession();
            }
          }],
          deAuth: ['$rootScope', 'AuthService', 'SessionService', function ($rootScope, AuthService, SessionService) {

            return AuthService.deauthenticateUser()
              .then(function () {
                SessionService.destroy();

                $rootScope.$emit('zp.intercom-shutdown');
                $rootScope.$emit('zp.user.deauthenticated');
              });
          }],
          appSettings: ['appSettings', function (appSettings){
            return appSettings;
          }],
          zuantLogoURL: ['$filter', function ($filter){
            return $filter('cdnAssets')('/images/svgs/logos/zuant/ZUANT_CLOUD.svg');
          }]
        }
      });

  }
})();

/**
 * zuant-front-end - The front end project for the Zuant web portal
 * @version v2.8.4
 * @link https://bitbucket.org/Zuant/zuant_front_end#readme
 * @built Thu Oct 29 2026 14:57:35 GMT+0000 (Coordinated Universal Time)
 */
var awsStorageRegion = 'eu-west-2';
var awsStorageBucketName = 'testuploads.zuant.com';
var leadReleaseCallBaseTimeout = '1000';
var dotNetPort = '443';
var dotNetUrl = 'https://testmachineq-api.zuant.com';
var zuantAiClientId = 'LNdi0AAdEfCzviUo1jranQ==';
var marketpointClientId = 'eaYe4rOzQPiG5mAnd403gw==';
var cookieDomain = '.zuant.com';
var dataBackendWebsocketUrl = 'wss://testdata.zuant.com';
var zcloudPort = '443';
var zcloudHost = 'https://testzcloud.zuant.com';
var cdnAssetsUrl = 'https://staticassets.zuant.com';
var monitorUrl = 'https://monitor.testcloud.zuant.com';
var syncUrl = 'https://testsync.zuant.com/';
var infrastructure = 'AWS';
var dataApiUrl = 'https://testdata.zuant.com';
var dataApiPort = '443';
var app_version = '2.8.4';
var stripe_token = 'pk_test_WD9Iy4rPyOvu0COe2EugVgSG';
var dropbox_client_id = 'v9j20dd4lhqu02z';
var intercom_id = 'lecc1l4p';
var env = 'AWS_TEST';
var apiUrl = 'https://testapi.zuant.com';
var apiPort = '443';
angular.module('Constants', [])
  .constant('API_CONFIG', {
    url: apiUrl,
    port: apiPort
  })
  .constant('ENV_VAR', env)
  .constant('INTERCOM_APP_ID', intercom_id)
  .constant('DROPBOX_CLIENT_ID', dropbox_client_id)
  .constant('APP_VERSION', app_version)
  .constant('STRIPE_TOKEN', stripe_token)
  .constant('INFRASTRUCTURE', infrastructure)
  .constant('DATA_API_CONFIG', {
    url: dataApiUrl,
    port: dataApiPort
  })
  .constant('DOT_NET_API_CONFIG', {
    url: dotNetUrl,
    port: dotNetPort
  })
  .constant('MONITOR_URL', monitorUrl)
  .constant('CDN_ASSETS_URL', cdnAssetsUrl)
  .constant('ZCLOUD_HOST', zcloudHost)
  .constant('ZCLOUD_PORT', zcloudPort)
  .constant('DATA_BACKEND_WSURL', dataBackendWebsocketUrl)
  .constant('COOKIE_DOMAIN', cookieDomain)
  .constant('SYNC_URL', syncUrl)
  .constant('MARKETPOINT_CLIENT_ID', marketpointClientId)
  .constant('ZUANT_AI_CLIENT_ID', zuantAiClientId)
  .constant('LEAD_RELEASE_API_CALL_BASE_TIMEOUT', leadReleaseCallBaseTimeout)
  .constant('AWS_STORAGE_BUCKET_NAME', awsStorageBucketName)
  .constant('AWS_STORAGE_REGION', awsStorageRegion);

(function () {
  'use strict';

  angular
    .module('app')
    .config(routeConfig);

  routeConfig.$inject = ['$stateProvider', '$urlServiceProvider', '$locationProvider', '$cookiesProvider', 'COOKIE_DOMAIN'];

  function routeConfig($stateProvider, $urlServiceProvider, $locationProvider, $cookiesProvider, COOKIE_DOMAIN) {

    $urlServiceProvider.rules.otherwise({
      state: 'login'
    });

    // Home
    $stateProvider
      .state('app', {
        abstract: true,
        views: {
          'master': {
            template: '<div ui-view="master" flex layout="column"></div>'
          }
        },
        data: {
          permissions: {
            only: ['AUTHORIZED']
          }
        }
      })
      .state('app.mesh', {
        views: {
          'master': {
            template: '<div ui-view="master" flex layout="column"></div>'
          }
        },
        data: {
          permissions: {
            only: ['MESH_VIEW']
          }
        }
      })
      .state('app.showroom', {
        views: {
          'master': {
            template: '<div ui-view="master" flex layout="column"></div>'
          }
        },
        data: {
          permissions: {
            only: ['SHOWROOM_VIEW'],
            except: ['OLD_SHOWROOM_ROLE']
          }
        }
      })
      .state('app.oldshowroom', {
        abstract: true,
        views: {
          'master': {
            template: '<zp-app-homescreen-framework-no-sidebar layout="column" flex></zp-app-homescreen-framework-no-sidebar>'
          }
        },
        data: {
          permissions: {
            only: ['OLD_SHOWROOM_ROLE']
          }
        },
        resolve: {
          customSkinCheck: ['$q', 'CloudAppThemeFactory', function (promise, CloudAppThemeFactory) {
            return new promise(function (resolve, reject) {
              return CloudAppThemeFactory.refreshThemeIfNecessary()
                .then(function () {
                  resolve();
                })
                .catch(reject);
            });
          }]
        }
      })
      .state('app.thirdparty', {
        abstract: true,
        views: {
          'master': {
            template: '<zp-app-homescreen-framework-no-sidebar layout="column" flex></zp-app-homescreen-framework-no-sidebar>'
          }
        },
        data: {
          permissions: {
            only: ['AUTHORIZED']
          }
        },
        resolve: {
          customSkinCheck: ['$q', 'CloudAppThemeFactory', function (promise, CloudAppThemeFactory) {
            return new promise(function (resolve, reject) {
              return CloudAppThemeFactory.refreshThemeIfNecessary()
                .then(function () {
                  resolve();
                })
                .catch(reject);
            });
          }]
        }
      })
      .state('app.homescreen_app_framework', {
        abstract: true,
        views: {
          'master': {
            template: '<zp-app-homescreen-framework layout="column" flex></zp-app-homescreen-framework>'
          }
        },
        resolve: {
          customSkinCheck: ['$q', 'CloudAppThemeFactory', function (promise, CloudAppThemeFactory) {
            return new promise(function (resolve, reject) {
              return CloudAppThemeFactory.refreshThemeIfNecessary()
                .then(function () {
                  resolve();
                })
                .catch(reject);
            });
          }]
        }
      })
      .state('app.homescreen_app_framework_no_sidebar', {
        abstract: true,
        views: {
          'master': {
            template: '<zp-app-homescreen-framework-no-sidebar layout="column" flex></zp-app-homescreen-framework-no-sidebar>'
          }
        },
        resolve: {
          customSkinCheck: ['$q', 'CloudAppThemeFactory', function (promise, CloudAppThemeFactory) {
            return new promise(function (resolve, reject) {
              return CloudAppThemeFactory.refreshThemeIfNecessary()
                .then(function () {
                  resolve();
                })
                .catch(reject);
            });
          }]
        }
      })
      .state('app.tabbed_app_framework', {
        abstract: true,
        views: {
          'master': {
            template: '<zp-tabbed-app-framework layout="column" flex></zp-tabbed-app-framework>'
          }
        },
        resolve: {
          customSkinCheck: ['$q', 'CloudAppThemeFactory', function (promise, CloudAppThemeFactory) {
            return new promise(function (resolve, reject) {
              return CloudAppThemeFactory.refreshThemeIfNecessary()
                .then(function () {
                  resolve();
                })
                .catch(reject);
            });
          }]
        }
      })
      .state('app.tall_toolbar_tabbed_app_framework', {
        abstract: true,
        views: {
          'master': {
            template: '<zp-tabbed-app-tall-toolbar-framework layout="column" flex></zp-tabbed-app-tall-toolbar-framework>'
          }
        },
        resolve: {
          customSkinCheck: ['$q', 'CloudAppThemeFactory', function (promise, CloudAppThemeFactory) {
            return new promise(function (resolve, reject) {
              return CloudAppThemeFactory.refreshThemeIfNecessary()
                .then(function () {
                  resolve();
                })
                .catch(reject);
            });
          }]
        }
      })
      .state('app.toolbar_app_framework', {
        abstract: true,
        views: {
          'master': {
            template: '<zp-toolbar-app-framework layout="column" flex></zp-toolbar-app-framework>'
          }
        },
        resolve: {
          customSkinCheck: ['$q', 'CloudAppThemeFactory', function (promise, CloudAppThemeFactory) {
            return new promise(function (resolve, reject) {
              return CloudAppThemeFactory.refreshThemeIfNecessary()
                .then(function () {
                  resolve();
                })
                .catch(reject);
            });
          }]
        }
      })
      .state('app.custom_toolbar_app_framework', {
        abstract: true,
        views: {
          'master': {
            template: '<zp-custom-toolbar-app-framework layout="column" flex></zp-custom-toolbar-app-framework>'
          }
        },
        resolve: {
          customSkinCheck: ['$q', 'CloudAppThemeFactory', function (promise, CloudAppThemeFactory) {
            return new promise(function (resolve, reject) {
              return CloudAppThemeFactory.refreshThemeIfNecessary()
                .then(function () {
                  resolve();
                })
                .catch(reject);
            });
          }]
        }
      })
      .state('app.single_view_framework', {
        abstract: true,
        views: {
          'master': {
            template: '<zp-single-view-framework layout="column" flex></zp-single-view-framework>'
          }
        },
        resolve: {
          customSkinCheck: ['$q', 'CloudAppThemeFactory', function (promise, CloudAppThemeFactory) {
            return new promise(function (resolve, reject) {
              return CloudAppThemeFactory.refreshThemeIfNecessary()
                .then(function () {
                  resolve();
                })
                .catch(reject);
            });
          }]
        }
      })
      .state('app.403', {
        url: '/403',
        views: {
          'master': {
            component: 'four03'
          }
        }
      })
      .state('app.404', {
        url: '/404',
        views: {
          'master': {
            component: 'four04'
          }
        }
      })
      .state('app.500', {
        url: '/500',
        views: {
          'master': {
            component: 'fiveHundo'
          }
        }
        // TODO pass error info to user
        // resolve: {
        //   data: ['$transition$', function (trans) {
        //     var errorData = trans.error();
        //     return errorData;
        //   }]
        // }
      });

    $locationProvider
      .html5Mode(true);

    $cookiesProvider.defaults.path = '/'; // without this sucker cookies don't work!
    $cookiesProvider.defaults.domain = COOKIE_DOMAIN;
    $cookiesProvider.defaults.secure = true;
  }
})();

/**
* Created by davidbeazer on 22/08/2016.
*/
(function() {
  'use strict';

  appSettingsConfig.$inject = ['appSettingsProvider', 'APP_VERSION'];
  angular
    .module('app')
    .config(appSettingsConfig);

  /* @ngInject */
  function appSettingsConfig(appSettingsProvider, APP_VERSION) {
    var now = new Date();
    appSettingsProvider.setCopyright('&copy;' + now.getFullYear() + ' zuant.com');
    // set current version of app (shown at bottom of login page)
    appSettingsProvider.setVersion(APP_VERSION);
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .provider('appSettings', settingsProvider);

  /* @ngInject */
  function settingsProvider() {
    // Provider
    var settings = {
      languages: [],
      name: '',
      logo: '',
      copyright: '',
      version: ''
    };

    this.addLanguage = addLanguage;
    this.setLogo = setLogo;
    this.setName = setName;
    this.setCopyright = setCopyright;
    this.setVersion = setVersion;

    function addLanguage(newLanguage) {
      settings.languages.push(newLanguage);
    }

    function setLogo(logo) {
      settings.logo = logo;
    }

    function setName(name) {
      settings.name = name;
    }

    function setCopyright(copy) {
      settings.copyright = copy;
    }

    function setVersion(version) {
      settings.version = version;
    }
    
    // Service
    this.$get = function() {
      return {
        languages: settings.languages,
        name: settings.name,
        copyright: settings.copyright,
        logo: settings.logo,
        version: settings.version,
        defaultSkin: settings.defaultSkin
      };
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('app')
    .run(runFunction);

  runFunction.$inject = ['$rootScope', '$transitions', '$location', 'SessionService', '$trace', 'MessageService', 'EnvService', 'MasterPermissionsFactory', 'CacheInvalidationFactory'];

  function runFunction($rootScope, $transitions, $location, session, $trace, MessageService, env, MasterPermissionsFactory, CacheInvalidationFactory) {

    MasterPermissionsFactory.init();
    CacheInvalidationFactory.init();

    if (env.env === 'dev') {
      $trace.enable('TRANSITION');
    }

    $transitions.onBefore({}, function (trans) {
      const ChangeDelta = trans.injector().get('ChangeDelta');
      $rootScope.loading = true;

      const toState = trans.to();
      const toStateParams = trans.params();
      const fromState = trans.from();
      const fromStateParams = trans.params('from');
      const transitionOptions = trans.options();

      const fromHref = trans.router.stateService.href(fromState.name, fromStateParams);
      const toHref = trans.router.stateService.href(toState.name, toStateParams);

      const baseToHref = '/' + toHref.split('/')[1];

      const userData = session.getUserData();
      const permittedRoutes = ['/login', '/forgot', '/dashboard', '/client', '/logout'];
      if (
        userData.clientArchived && !permittedRoutes.some(function(route){
          return baseToHref.includes(route);
        })
      ){
        throw 'clientArchived';
      }

      const isDirtyCheck = transitionOptions.custom.isDirtyCheck || false;
      const unsavedChanges = ChangeDelta.isDirty();
      if (unsavedChanges && isDirtyCheck) {
        if (!confirm('👋 Heads up!\nYou have some unsaved changes.\n\nClick OK to continue without saving or Cancel to stay put.')) {
          // user cancelled and staying put.
          $rootScope.loading = false;
          trans.abort();
        } else {
          ChangeDelta.clear();
        }
      }

      if (MessageService.modalIsShown) {
        MessageService.cancelDialog();
      }
    });

    // useful transition hooks for debugging
    // $transitions.onExit({}, function (transition, state) {
    //   console.log('Transition #' + transition.$id + ' Exiting ' + state.name);
    // });

    //$transitions.onEnter({}, function (transition, state) {
    //   console.log('Transition #' + transition.$id + ' Entered ' + state.name);
    // });

    $transitions.onSuccess({}, function (trans) {
      // var ChangeDelta = trans.injector().get('ChangeDelta');

      const toState = trans.to();

      $rootScope.loading = false;
      // var unsavedChanges = ChangeDelta.isDirty();
      // if (unsavedChanges) ChangeDelta.clear();
      MessageService.updateIntercom();
      var mdSidenav = trans.injector().get('$mdSidenav');
      var sideBarPromise = mdSidenav('mainNavigation', true);
      // On first refresh the sideBarPromise will be a promise as it hasn't been loaded yet
      // When the app has loaded and we are transitioning around then it's a direct reference
      // and NOT a promise
      if (sideBarPromise.close) {
        sideBarPromise.close();
      } else {
        sideBarPromise.then(function (sideBarRef) {
          sideBarRef.close();
        });
      }
      if (toState.data) {
        const LayoutsFactory = trans.injector().get('LayoutsFactory');
        const showLeftSidebar = trans.to().data.showLeftSidebar;
        LayoutsFactory.setProperty('showLeftSidebar', showLeftSidebar);
      }
    });

    //debugging
    //$transitions.onStart({}, function(transition) {
    //console.log(transition);
    //})

    $transitions.onError({}, function (transition) {
      if ($rootScope.loading) {
        $rootScope.loading = false;
      }

      const error = transition.error();

      //this bit of disgustiness is to solve problems that occur from using redirectTo within router state. Not nice but stops errors logging to console
      //due to unexpected promise rejection - https://github.com/angular-ui/ui-router/issues/3309#issuecomment-407579020
      if (
        typeof error === 'object' &&
        typeof error.message === 'string' &&
        error.type === 2 &&
        error.message.match(/^The transition has been superseded by a different transition/)
      ) {
        return;
      }


      if (!error.detail && error.type == 6)
      {
        //bit hacky but upon debugging permissions errors are being returned as type 6 with no defining message features.
        //I belive this is a angular router issue so oprobably needs updating if this platform is in continued use.
        error.detail = {
          status: 403,
          message: 'Please login to view this content.'
        };
      } else if (error.detail === 'clientArchived' && error.type == 6){
        error.detail = {
          status: 403,
          message: 'This client is archived. Please Unarchive to access this page',
          clientArchived: true
        };
      }

      redirectError(error);
    });

    function redirectError(rejection) {
      /* TODO: standardise this with error codes */
      if (rejection.detail) {
        switch (rejection.detail.status) {
          case 401:
            session.destroy();
            $location.path('/login');
            break;

          case 403:
            MessageService.confirm().showInfoDialog(rejection.detail.message, 'Access denied');
            delete rejection.type; // so it doesn't catch login redirect below. bit of a HACK!
            if (rejection.detail.clientArchived){
              $location.path('/dashboard');
            }
            break;

          case 404:
          /* redirect to 404 page */
            $location.path('/404');
            break;

          case 405:
          /* redirect to 404 page */
            $location.path('/404');

            break;

          case 500:
            $location.path('/500');
            delete rejection.type; // so it doesn't catch login redirect below. bit of a HACK!
            break;

          case -1:
            MessageService.showMessage('Server not found');
            $location.path('/login');
            session.destroy();
            break;

          default:
          // $location.path('/dashboard');
            break;
        }
      }
      if (rejection.type == 6) {
        MessageService.showMessage('Logged Out');
        $location.path('/login');
        session.destroy();
        MessageService.writeLog({
          level: 'error',
          tags: ['state_transition', 'log_out'],
          msg: 'Transition rejected. user has been logged out',
          err: rejection
        });
        return;
      }

      MessageService.writeLog({
        level: 'error',
        tags: ['state_transition'],
        msg: 'unhandled transition error',
        err: rejection
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .config(moduleConfig);

  moduleConfig.$inject = ['$logProvider', 'ENV_VAR', '$sceDelegateProvider'];
  /* ng-inject */
  function moduleConfig($logProvider, ENV_VAR, $sceDelegateProvider) {

    $logProvider.debugEnabled(ENV_VAR === 'DBiMacDev');

    $sceDelegateProvider.resourceUrlWhitelist([
      // Allow same origin resource loads.
      'self',
      // Allow loading from our assets domain. **.
      'http://localhost:3800/**',
      'https://staticassets.zuant.com/**'
    ]);
  }

}());

angular.module('app').run(['$templateCache', function($templateCache) {$templateCache.put('app/authentication/401.tmpl.html','<div class="full-image-background mb-bg-21" layout="column" flex layout-align="center center">\n    <div layout="column">\n        <div layout="row" flex layout-align="center center">\n            <div flex="50" flex-xs="90" layout="row">\n                <div flex>\n                    <img ng-src="{{\'/images/pngs/font/material/material-font-4.png\' | cdnAssets}}">\n                </div>\n                <div flex>\n                    <img ng-src="{{\'/images/pngs/font/material/material-font-0.png\' | cdnAssets}}">\n                </div>\n                <div flex>\n                    <img ng-src="{{\'/images/pngs/font/material/material-font-1.png\' | cdnAssets}}">\n                </div>\n            </div>\n        </div>\n        <div layout="row" flex class="full-width" layout-align="center center">\n            <md-card flex="50" flex-xs="90">\n                <md-card-content class="text-align-center">\n                    <h1 class="md-display-1">Access Denied</h1>\n                    <p>You do not have permission to access this page.</p>\n                    <md-button class="md-primary md-raised" ng-click="$ctrl.goHome()" aria-label="Go Home">Go\n                        Home</md-button>\n                </md-card-content>\n            </md-card>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/authentication/403.tmpl.html','<div class="error-page-container" layout="column" flex layout-align="center center">\n  <div layout="column" layout-align="center center">\n    <div layout-align="center center">\n\n      <!-- <div id="Clouds">\n            <div class="Cloud Foreground"></div>\n            <div class="Cloud Background"></div>\n            <div class="Cloud Foreground"></div>\n            <div class="Cloud Background"></div>\n            <div class="Cloud Foreground"></div>\n            <div class="Cloud Background"></div>\n            <div class="Cloud Background"></div>\n            <div class="Cloud Foreground"></div>\n            <div class="Cloud Background"></div>\n            <div class="Cloud Background"></div>\n           <svg viewBox="0 0 40 24" class="Cloud"><use xlink:href="#Cloud"></use></svg>\n          </div> -->\n\n      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"\n        x="0px" y="0px" width="40px" height="24px" viewBox="0 0 40 24" enable- xml:space="preserve">\n        <defs>\n          <path id="Cloud" d="M33.85,14.388c-0.176,0-0.343,0.034-0.513,0.054c0.184-0.587,0.279-1.208,0.279-1.853c0-3.463-2.809-6.271-6.272-6.271\n            c-0.38,0-0.752,0.039-1.113,0.104C24.874,2.677,21.293,0,17.083,0c-5.379,0-9.739,4.361-9.739,9.738\n            c0,0.418,0.035,0.826,0.084,1.229c-0.375-0.069-0.761-0.11-1.155-0.11C2.811,10.856,0,13.665,0,17.126\n            c0,3.467,2.811,6.275,6.272,6.275c0.214,0,27.156,0.109,27.577,0.109c2.519,0,4.56-2.043,4.56-4.562\n            C38.409,16.43,36.368,14.388,33.85,14.388z" />\n        </defs>\n      </svg>\n      <div flex="70" flex-xs="90" layout="row" layout-margin style="padding-left:100px;">\n        <div flex>\n          <img ng-src="{{\'/images/pngs/font/material/material-font-4.png\' | cdnAssets}}" class="number-img">\n        </div>\n        <div flex>\n          <img ng-src="{{\'/images/pngs/font/material/material-font-0.png\' | cdnAssets}}" class="number-img">\n        </div>\n        <div flex>\n          <img ng-src="{{\'/images/pngs/font/material/material-font-3.png\' | cdnAssets}}" class="number-img">\n        </div>\n      </div>\n    </div>\n    <div layout="row" flex class="full-width" layout-align="center center">\n      <md-card flex>\n        <md-card-content class="text-align-center">\n          <h1 class="md-display-1">Not permitted</h1>\n          <p>Sorry you aren\'t permitted to view the page you requested. If you believe this is an error please\n            contact support.</p>\n          <div layout="column" flex="50" flex-offset="25">\n            <md-button class="md-primary md-raised" ng-click="$ctrl.goHome()" aria-label="Go Home">Go to\n              dashboard</md-button>\n            <!-- <div flex> -->\n            <md-button class="md-primary md-raised" aria-label="intercom">\n              <a id="my_custom_link" href="mailto:lecc1l4p@incoming.intercom.io"\n                style="text-decoration:none; color:#fff; display:block">\n                Contact support &nbsp;\n                <md-icon md-font-icon="zmdi zmdi-comment" style="color: #486D91;"></md-icon>\n              </a>\n            </md-button>\n            <!-- </div> -->\n          </div>\n        </md-card-content>\n      </md-card>\n    </div>\n  </div>\n</div>');
$templateCache.put('app/authentication/404.tmpl.html','<div class="error-page-container" layout="column" flex layout-align="center center">\n  <div layout="column" layout-align="center center">\n    <div layout-align="center center">\n\n      <!-- <div id="Clouds">\n            <div class="Cloud Foreground"></div>\n            <div class="Cloud Background"></div>\n            <div class="Cloud Foreground"></div>\n            <div class="Cloud Background"></div>\n            <div class="Cloud Foreground"></div>\n            <div class="Cloud Background"></div>\n            <div class="Cloud Background"></div>\n            <div class="Cloud Foreground"></div>\n            <div class="Cloud Background"></div>\n            <div class="Cloud Background"></div>\n           <svg viewBox="0 0 40 24" class="Cloud"><use xlink:href="#Cloud"></use></svg>\n          </div> -->\n\n      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"\n        x="0px" y="0px" width="40px" height="24px" viewBox="0 0 40 24" enable- xml:space="preserve">\n        <defs>\n          <path id="Cloud" d="M33.85,14.388c-0.176,0-0.343,0.034-0.513,0.054c0.184-0.587,0.279-1.208,0.279-1.853c0-3.463-2.809-6.271-6.272-6.271\n            c-0.38,0-0.752,0.039-1.113,0.104C24.874,2.677,21.293,0,17.083,0c-5.379,0-9.739,4.361-9.739,9.738\n            c0,0.418,0.035,0.826,0.084,1.229c-0.375-0.069-0.761-0.11-1.155-0.11C2.811,10.856,0,13.665,0,17.126\n            c0,3.467,2.811,6.275,6.272,6.275c0.214,0,27.156,0.109,27.577,0.109c2.519,0,4.56-2.043,4.56-4.562\n            C38.409,16.43,36.368,14.388,33.85,14.388z" />\n        </defs>\n      </svg>\n      <div flex="70" flex-xs="90" layout="row" layout-margin style="padding-left:100px;">\n        <div flex>\n          <img ng-src="{{\'/images/pngs/font/material/material-font-4.png\' | cdnAssets}}" class="number-img">\n        </div>\n        <div flex>\n          <img ng-src="{{\'/images/pngs/font/material/material-font-0.png\' | cdnAssets}}" class="number-img">\n        </div>\n        <div flex>\n          <img ng-src="{{\'/images/pngs/font/material/material-font-4.png\' | cdnAssets}}" class="number-img">\n        </div>\n      </div>\n    </div>\n    <div layout="row" flex class="full-width" layout-align="center center">\n      <md-card flex>\n        <md-card-content class="text-align-center">\n          <h1 class="md-display-1">Page not found</h1>\n          <p>Sorry the page you were looking for could not be found.</p>\n          <div layout="column" flex="50" flex-offset="25">\n            <md-button class="md-primary md-raised" ng-click="$ctrl.goHome()" aria-label="Go Home">Go to\n              dashboard</md-button>\n            <!-- <div flex> -->\n            <md-button class="md-primary md-raised" aria-label="intercom">\n              <a id="my_custom_link" href="mailto:lecc1l4p@incoming.intercom.io"\n                style="text-decoration:none; color:#fff; display:block">\n                Contact support &nbsp;\n                <md-icon md-font-icon="zmdi zmdi-comment" style="color: #486D91;"></md-icon>\n              </a>\n            </md-button>\n            <!-- </div> -->\n          </div>\n        </md-card-content>\n      </md-card>\n    </div>\n  </div>\n</div>');
$templateCache.put('app/authentication/500.tmpl.html','<div class="full-image-background mb-bg-21" layout="column" flex layout-align="center center">\n    <div layout="column">\n        <div layout="row" flex layout-align="center center" layout-margin>\n            <div ng-include="$ctrl.fiveHundredErrorIconImageSvg">\n            </div>\n        </div>\n        <div layout="row" flex class="full-width" layout-align="center center">\n            <md-card flex="50" flex-xs="90">\n                <md-card-content class="text-align-center">\n                    <h1 class="md-display-1">500</h1>\n                    <p>Oops looks like something has gone wrong. Please contact Zuant support providing the\n                        error message below and we\'ll be in touch asap.</p>\n                    <p class="md-subhead">Error message:</p>\n                    <pre>{{ $ctrl.errorObj.message | json }}</pre>\n\n                    <a id="my_custom_link" href="mailto:lecc1l4p@incoming.intercom.io" style="display: inline-block;">\n                        <md-button class="md-primary md-raised" ng-click="$ctrl.openIntercomChatPanel()"\n                            aria-label="Message Zuant Support">Message Zuant Team</md-button>\n                    </a>\n                    <md-button class="md-primary md-raised" ng-click="$ctrl.goHome()" aria-label="Go Home">Go\n                        Home</md-button>\n                    <md-button class="md-primary md-raised" ng-click="$ctrl.goBack()" aria-label="Go back">Go\n                        back</md-button>\n                </md-card-content>\n            </md-card>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/authentication/forgot/forgot.tmpl.html','<div class="lagoon-bg" layout-fill>\n  <div id="ui-login" style="height: 100%; width: 100%;" class="login-frame" layout="column"\n    layout-align="center center">\n\n    <div layout="row" layout-margin layout-align="center center">\n      <div ng-include class="cloud-logo-constrained" src="$ctrl.zuantLogoURL" zp-nav-click="/login"></div>\n    </div>\n\n    <div layout-margin="" layout-padding=""></div>\n\n    <div layout="row" style="width: 100%;" layout-align="center start">\n\n      <md-card ng-if="$ctrl.showForm" ng-cloak flex="30" flex-lg="30" flex-md="50" flex-sm="70" flex-xs="100">\n\n        <md-content class="md-padding" layout-padding>\n          <div layout-padding>\n            <p class="md-display-1 zuantTitanium1 thin-font" style="text-align: center;">Forgot your password?</p>\n            <p class="zuantTitanium1">Enter your email below and we\'ll email you instructions on how to\n              reset your password.</p>\n            <form name="forgot" ng-submit="$ctrl.submitForgotPasswordForm()">\n              <md-input-container class="md-block">\n                <label for="email">email</label>\n                <input id="email" label="email" name="email" type="email" ng-model="$ctrl.user.email" required />\n                <div ng-messages="forgot.email.$error" md-auto-hide="false" ng-show="forgot.email.$touched">\n                  <div ng-message when="required">\n                    <span>Please enter your email address.</span>\n                  </div>\n                  <div ng-message when="email">\n                    <span>Please enter a valid email address.</span>\n                  </div>\n                </div>\n              </md-input-container>\n              <md-button\n                class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10"\n                ng-disabled="forgot.$invalid" aria-label="Reset" type="submit">Request a password reset</md-button>\n              <md-button class="md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10"\n                href="/login" aria-label="Remembered it? Login in here">Remembered it? Login in here</md-button>\n              <input type="hidden" name="CSRFToken" value="1231234567890" />\n            </form>\n          </div>\n        </md-content>\n      </md-card>\n\n      <md-card ng-if="!$ctrl.showForm" ng-cloak flex="40" flex-lg="40" flex-md="60" flex-sm="80" flex-xs="100">\n        <md-content class="md-padding" layout-padding>\n          <div layout-padding>\n            <div layout-padding>\n              <p class="md-display-1 zuantTitanium1 thin-font" style="text-align: center;">Check your email</p>\n              <p class="md-subhead zuantTitanium1 margin-bottom-0 margin-top-0">We\'ve sent you an email to\n                <b>"{{$ctrl.user.email}}"</b>\n                with\n                instructions on how to reset your\n                password, please check your inbox.\n              </p>\n              <p class="md-subhead zuantTitanium1 margin-bottom-0 margin-top-0">Should you not be able to locate the\n                email,\n                please explore\n                alternative\n                locations such as your junk, spam, social, or other folders. Also double-check the\n                accuracy of the email address listed above. If it\'s incorrect, attempt to reset it again by clicking\n                on the <b>"RETURN TO RESET FORM"</b> button below.\n              </p>\n              <p class="md-subhead zuantTitanium1 margin-bottom-0 margin-top-0">\n                If you\'re still encountering difficulties, kindly reach out to your designated Customer Success Manager\n                or\n                contact <a href="mailto:support@zuant.com">support@zuant.com</a> for further assistance.\n              </p>\n              <md-button style="width: 100%;" class="md-body-2 md-primary" ng-click="$ctrl.showForm = true;">Return\n                to reset\n                form</md-button>\n            </div>\n        </md-content>\n      </md-card>\n\n    </div>\n\n  </div>\n</div>');
$templateCache.put('app/authentication/forgot/reset.tmpl.html','<div class="lagoon-bg" layout="column" layout-fill>\n  <div class="animate-wrapper" flex layout="row">\n    <div id="ui-login" class="login-frame" ui-view flex layout="column">\n\n      <div layout="row" flex layout-padding layout-fill layout-align="center center">\n        <div flex="40" flex-lg="40" flex-md="60" flex-sm="70" flex-xs="100">\n          <div layout="row" layout-margin layout-align="center center">\n            <div>\n              <div ng-include class="cloud-logo-constrained" src="$ctrl.zuantLogoURL" zp-nav-click="/login"></div>\n            </div>\n          </div>\n          <div layout-margin="" layout-padding=""></div>\n\n          <md-card ng-show="!$ctrl.linkIsValid">\n            <md-content class="md-padding" layout-padding layout="column" layout-align="center center">\n              <p class="md-display-1 zuantTitanium1 thin-font margin-bottom-0">Link Expired</p>\n              <md-icon class="big-icon zuantSaffron" md-font-icon="zmdi zmdi-close-circle"></md-icon>\n              <p class="md-subhead zuantTitanium1">The reset link provided seems to have expired. Use the button below\n                to return to the reset password page where you will be able to regenerate a reset email.</p>\n              <md-button\n                class="md-primary md-raised full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10"\n                href="/forgot">RETURN TO RESET PAGE</md-button>\n            </md-content>\n          </md-card>\n\n          <md-card ng-if="$ctrl.linkIsValid && !$ctrl.passwordResetComplete" ng-cloak>\n            <md-content class="md-padding" layout-padding>\n              <div>\n                <p class="md-display-1 zuantTitanium1 thin-font" style="text-align: center;">Pick a new password.</p>\n                <p class="zuantTitanium1 md-subhead">\n                  Please enter and confirm your new password into the fields below and then click the <b>"Reset"</b>\n                  button.\n                </p>\n\n                <div ng-if="$ctrl.hasPasswordPolicy">\n                  <p class="margin-bottom-0"><b>Password Requirements:</b></p>\n                  <ul class="margin-left-20">\n                    <li class="zuantTitanium1 margin-top-0 margin-bottom-0" ng-repeat="policy in $ctrl.activePolicy">\n                      {{policy.label}} <b>{{policy.value}}</b>\n                      <md-icon style="color: limegreen;" class="margin-left-5"\n                        ng-if="$ctrl.resetFormObj.password.$dirty && !$ctrl.resetFormObj.password.$error[policy.key]"\n                        md-font-icon="zmdi zmdi-check-circle"></md-icon>\n                      <md-icon class="margin-left-5 zuantSaffron"\n                        ng-if="$ctrl.resetFormObj.password.$touched && $ctrl.resetFormObj.password.$error[policy.key]"\n                        md-font-icon="zmdi zmdi-close-circle"></md-icon>\n                    </li>\n                  </ul>\n                </div>\n\n                <form name="$ctrl.resetFormObj" ng-submit="$ctrl.submitResetPasswordForm()">\n                  <md-input-container class="md-block">\n\n                    <label for="password">Password</label>\n\n                    <input id="password" label="password" name="password" type="{{$ctrl.passwordFieldType}}"\n                      ng-model="$ctrl.passwordFormFieldValue" ng-change="$ctrl.checkAgainstPasswordPolicy(\'password\')"\n                      required />\n\n                    <md-icon style="color:rgba(0,0,0,0.12);" md-font-icon="zmdi {{$ctrl.passwordFieldIcon}}"\n                      ng-click="$ctrl.toggleViewPasswordField(\'password\')">\n                      <md-tooltip>{{$ctrl.passwordFieldTooltip}}</md-tooltip>\n                    </md-icon>\n\n                    <div ng-messages="$ctrl.resetFormObj.password.$error" role="alert">\n                      <div ng-message when="required">\n                        <span>Please enter a password.</span>\n                      </div>\n                      <div ng-message when="minLength">\n                        <span>Please enter a password with a length greater than\n                          <b>{{$ctrl.activePolicy.minLength.value}}</b> characters.</span>\n                      </div>\n                      <div ng-message when="maxLength">\n                        <span>Please enter a password with a length less than\n                          <b>{{$ctrl.activePolicy.maxLength.value}}</b> characters.</span>\n                      </div>\n                      <div ng-message when="minLowercase">\n                        <span>Please enter a password with\n                          <b>{{$ctrl.activePolicy.minLowercase.value}}</b> or\n                          more <b>LOWERCASE</b> characters.</span>\n                      </div>\n                      <div ng-message when="minUppercase">\n                        <span>Please enter a password with\n                          <b>{{$ctrl.activePolicy.minUppercase.value}}</b> or\n                          more <b>UPPERCASE</b> characters.</span>\n                      </div>\n                      <div ng-message when="minNumeric">\n                        <span>Please enter a password with\n                          <b>{{$ctrl.activePolicy.minNumeric.value}}</b> or\n                          more <b>NUMERIC</b> characters.</span>\n                      </div>\n                      <div ng-message when="minSymbol">\n                        <span>Please enter a password with\n                          <b>{{$ctrl.activePolicy.minSymbol.value}}</b> or\n                          more <b>SYMBOL</b> characters.</span>\n                      </div>\n                      <div ng-message when="nonMatch">\n                        <span>Password does not match confirm field.</span>\n                      </div>\n                    </div>\n\n                  </md-input-container>\n\n                  <md-input-container class="md-block">\n                    <label for="confirmpassword">Confirm Password</label>\n\n                    <input id="confirmpassword" label="Confirm password" name="confirmpassword"\n                      type="{{$ctrl.confirmPasswordFieldType}}" ng-model="$ctrl.confirmPasswordFormFieldValue"\n                      ng-change="$ctrl.checkAgainstPasswordPolicy(\'confirmPassword\')" required />\n\n                    <md-icon style="color:rgba(0,0,0,0.12);" md-font-icon="zmdi {{$ctrl.confirmPasswordFieldIcon}}"\n                      ng-click="$ctrl.toggleViewPasswordField(\'confirmPassword\')">\n                      <md-tooltip>{{$ctrl.confirmPasswordFieldTooltip}}</md-tooltip>\n                    </md-icon>\n\n                    <div ng-messages="$ctrl.passwordSetFormObj.confirmpassword.$error" role="alert">\n                      <div ng-message when="required">\n                        <span>Please confirm your password.</span>\n                      </div>\n                      <div ng-message when="nonMatch">\n                        <span>Confirm field does not match password field.</span>\n                      </div>\n                    </div>\n                  </md-input-container>\n\n                  <md-button\n                    class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10"\n                    type="submit" ng-disabled="reset.$invalid" aria-label="Reset">RESET</md-button>\n\n                  <md-button class="md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10"\n                    href="/login"\n                    aria-label="Remembered it? Login in here">Remembered it? Login in here</md-button>\n                  <input type="hidden" name="CSRFToken" value="1231234567890" />\n                </form>\n              </div>\n            </md-content>\n          </md-card>\n\n          <md-card ng-if="$ctrl.passwordResetComplete" ng-cloak>\n            <md-content class="md-padding" layout-padding layout="column" layout-align="center center">\n              <p class="md-display-1 zuantTitanium1 thin-font">Reset successful!</p>\n              <md-icon class="big-icon" style="color: limegreen;" md-font-icon="zmdi zmdi-check-circle"></md-icon>\n              <p class="md-subhead zuantTitanium1">Your password has been successfully reset. Login to the Zuant Cloud\n                below, or close your browser window.</p>\n              <md-button\n                class="md-primary md-raised full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10"\n                ui-sref="login">Login to portal</md-button>\n            </md-content>\n          </md-card>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>');
$templateCache.put('app/authentication/login/login.tmpl.html','<div class="lagoon-bg" layout="column" layout-fill>\n  <div flex layout="column" layout-align="space-between center">\n    <div layout="row" flex layout-padding layout-fill layout-align="center center">\n      <div flex="30" flex-lg="50" flex-md="70" flex-sm="70" flex-xs="100">\n        <div layout="row" layout-fill layout-align="center center">\n          <div>\n            <div ng-include class="cloud-logo-constrained" src="$ctrl.zuantLogoURL"></div>\n          </div>\n        </div>\n        <div layout-margin layout-padding></div>\n\n        <zp-login-form loading="$ctrl.loading" user="$ctrl.user" on-login-clicked="$ctrl.loginClick()"></zp-login-form>\n      </div>\n    </div>\n    <p layout-padding class="md-body-2" style="color: #486D91; text-align:center;">V {{$ctrl.appSettings.version}}</p>\n  </div>\n</div>');
$templateCache.put('app/biz-card/zp-bizcard-metadata/zp-bizcard-metadata.tmpl.html','<div layout="column" layout-padding>\n  <p class="zp-caption margin-bottom-0 margin-top-0">CAPTURE INFO</p>\n  <div>\n    <span style="color: rgba(0,0,0,0.26);">\n      <i class="zmdi zmdi-widgets"></i>&nbsp;\n      <md-tooltip>Form name:</md-tooltip>\n    </span> {{$ctrl.contact.response.eventName}}\n  </div>\n  <div>\n    <span style="color: rgba(0,0,0,0.26);">\n      <i class="zmdi zmdi-accounts"></i>&nbsp;\n      <md-tooltip>Captured by:</md-tooltip>\n    </span> {{$ctrl.contact.response.userName}}\n  </div>\n  <div>\n    <span style="color: rgba(0,0,0,0.26);">\n      <i class="zmdi zmdi-calendar"></i>&nbsp;\n      <md-tooltip>Captured date:</md-tooltip>\n    </span> {{$ctrl.contact._initialcreatedatelocalutc}}\n  </div>\n</div>\n');
$templateCache.put('app/biz-card/zp-bizcard-processor/zp-bizcard-processor.tmpl.html','<div layout-sm="column" layout-gt-md="row">\n\n  <md-card ng-if="$ctrl.emptyPotMessage" layout-padding flex>\n    <p class="md-display-1">There are no business cards left to process for your current filters</p>\n    <p class="md-display-1" ng-show="$ctrl.skip">You have skipped through all the cards. <br>You can either get the next available card or go back to the card filters screen</p>\n    <md-card-actions>\n      <div flex layout="row" layout-align="end center">\n        <md-button ng-click="$ctrl.goToCardFilterScreen()" class="md-primary md-raised">Go to card filter screen</md-button>\n        <md-button ng-click="$ctrl.getNextCard({skip: false})" class="md-primary md-raised" ng-show="$ctrl.skip">Get next available card</md-button>\n      </div>\n    </md-card-actions>\n  </md-card>\n\n  <div ng-show="!$ctrl.emptyPotMessage">\n    <md-card>\n      <div>\n        <md-progress-linear ng-if="$ctrl.loadingCardData" class="md-accent" md-mode="indeterminate">\n        </md-progress-linear>\n\n        <panzoom id="panzoomId" config="$ctrl.panzoomconfig" model="$ctrl.panzoommodel" ng-style="$ctrl.imageContainerStyles">\n          <img ng-src="{{$ctrl.bizcardimage}}" ng-show="!$ctrl.loadingCardData" degrees="$ctrl.angle" rotate style="width:auto !important; max-width:none !important; -webkit-user-drag: none" />\n        </panzoom>\n      </div>\n      <md-toolbar>\n        <div class="md-toolbar-tools">\n          <md-button class="md-icon-button">\n            <md-tooltip>Rotate left</md-tooltip>\n            <md-icon md-font-icon="zmdi zmdi-rotate-left" ng-click="$ctrl.rotate(\'left\')"></md-icon>\n          </md-button>\n          <md-button class="md-icon-button">\n            <md-tooltip>Rotate right</md-tooltip>\n            <md-icon md-font-icon="zmdi zmdi-rotate-right" ng-click="$ctrl.rotate(\'right\')"></md-icon>\n          </md-button>\n          <md-button class="md-icon-button">\n            <md-tooltip>Zoom in</md-tooltip>\n            <md-icon md-font-icon="zmdi zmdi-zoom-in" ng-click=\'$ctrl.zoomIn()\'></md-icon>\n          </md-button>\n          <md-button class="md-icon-button">\n            <md-tooltip>Zoom out</md-tooltip>\n            <md-icon md-font-icon="zmdi zmdi-zoom-out" ng-click=\'$ctrl.zoomOut()\'></md-icon>\n          </md-button>\n          <md-button class="md-icon-button" ng-click="$ctrl.rejectCard({ev: $event})">\n            <md-tooltip>Reject card</md-tooltip>\n            <md-icon md-font-icon="zmdi zmdi-block"></md-icon>\n          </md-button>\n        </div>\n      </md-toolbar>\n\n      <!-- thumbnails and image controls container -->\n      <div layout-padding>\n        <p class="zp-caption margin-bottom-0 margin-top-0">LEAD IMAGES</p>\n        <div layout="row">\n          <md-progress-circular md-mode="indeterminate" class="md-accent" ng-if="$ctrl.loadingCardData"></md-progress-circular>\n          <div ng-repeat="cardimage in $ctrl.responseImages" ng-show="!$ctrl.loadingCardData">\n            <img ng-src="{{cardimage}}" ng-click="$ctrl.selectImage(cardimage)" style="height:50px; width:50px; display:inline-block;" />\n          </div>\n        </div>\n      </div>\n\n    <!-- <div layout-padding>\n      <p class="md-caption margin-bottom-0">Captured by:\n        <span class="md-body-1"> {{ $ctrl.leadData.response.userName }}</span>\n      </p>\n      <p class="md-caption margin-bottom-0">Form name:\n        <span class="md-body-1">{{ $ctrl.leadData.response.eventName }}</span>\n      </p>\n      <p class="md-caption margin-bottom-0">Create date:\n        <span class="md-body-1">{{ $ctrl.leadData.createddate | date }}</span>\n      </p>\n    </div> -->\n    </md-card>\n  </div>\n\n  <md-card layout="column" flex layout-align="space-between" ng-show="!$ctrl.emptyPotMessage">\n    <md-card-body id="cardDataCard" ng-style="$ctrl.cardDataStyles">\n      <md-progress-linear ng-if="$ctrl.loadingCardData" class="md-accent" md-mode="indeterminate">\n      </md-progress-linear>\n      <md-list ng-show="!$ctrl.loadingCardData">\n        <md-subheader layout-margin>Contact data</md-subheader>\n        <md-list-item>\n          <md-input-container flex="100">\n            <label>Salutation</label>\n            <input type="text" ng-model="$ctrl.leadData.salutation" name="Salutation" ng-change="$ctrl.updateChangeDelta({collection: \'contact\', dbfieldname: \'salutation\', newval: $ctrl.leadData.salutation})">\n          </md-input-container>\n        </md-list-item>\n        <md-list-item>\n          <md-input-container flex="100">\n            <label>First name</label>\n            <input type="text" ng-model="$ctrl.leadData.firstname" name="Firstname" ng-change="$ctrl.updateChangeDelta({collection: \'contact\', dbfieldname: \'firstname\', newval: $ctrl.leadData.firstname})">\n          </md-input-container>\n        </md-list-item>\n        <md-list-item>\n          <md-input-container flex="100">\n            <label>Last name</label>\n            <input type="text" ng-model="$ctrl.leadData.lastname" name="Lastname" ng-change="$ctrl.updateChangeDelta({collection: \'contact\', dbfieldname: \'lastname\', newval: $ctrl.leadData.lastname})">\n          </md-input-container>\n        </md-list-item>\n        <md-list-item>\n          <md-input-container flex="100">\n            <label>Job title</label>\n            <input type="text" ng-model="$ctrl.leadData.jobtitle" name="Jobtitle" ng-change="$ctrl.updateChangeDelta({collection: \'contact\', dbfieldname: \'jobtitle\', newval: $ctrl.leadData.jobtitle})">\n          </md-input-container>\n        </md-list-item>\n        <md-list-item>\n          <md-input-container flex="100">\n            <label>Phone number</label>\n            <input type="text" ng-model="$ctrl.leadData.phone" name="Phone" ng-change="$ctrl.updateChangeDelta({collection: \'contact\', dbfieldname: \'phone\', newval: $ctrl.leadData.phone})">\n          </md-input-container>\n        </md-list-item>\n        <md-list-item>\n          <md-input-container flex="100">\n            <label>Mobile phone</label>\n            <input type="text" ng-model="$ctrl.leadData.mobile" name="Mobile" ng-change="$ctrl.updateChangeDelta({collection: \'contact\', dbfieldname: \'mobile\', newval: $ctrl.leadData.mobile})">\n          </md-input-container>\n        </md-list-item>\n        <md-list-item>\n          <md-input-container flex="100">\n            <label>Email</label>\n            <input type="text" ng-model="$ctrl.leadData.email" name="Email" ng-change="$ctrl.updateChangeDelta({collection: \'contact\', dbfieldname: \'email\', newval: $ctrl.leadData.email})">\n          </md-input-container>\n        </md-list-item>\n        <md-subheader layout-margin>Company data</md-subheader>\n        <md-list-item>\n          <md-input-container flex="100">\n            <label>Company name</label>\n            <input type="text" ng-model="$ctrl.leadData.companyname" name="Company name" ng-change="$ctrl.updateChangeDelta({collection: \'company\', dbfieldname: \'name\', newval: $ctrl.leadData.companyname})">\n          </md-input-container>\n        </md-list-item>\n        <md-list-item>\n          <md-input-container flex="100">\n            <label>Address 1</label>\n            <input type="text" ng-model="$ctrl.leadData.address1" name="Address1" ng-change="$ctrl.updateChangeDelta({collection: \'contact\', dbfieldname: \'address1\', newval: $ctrl.leadData.address1})">\n          </md-input-container>\n        </md-list-item>\n        <md-list-item>\n          <md-input-container flex="100">\n            <label>Address 2</label>\n            <input type="text" ng-model="$ctrl.leadData.address2" name="Address2" ng-change="$ctrl.updateChangeDelta({collection: \'contact\', dbfieldname: \'address2\', newval: $ctrl.leadData.address2})">\n          </md-input-container>\n        </md-list-item>\n        <md-list-item>\n          <md-input-container flex="100">\n            <label>Address 3</label>\n            <input type="text" ng-model="$ctrl.leadData.address3" name="Address3" ng-change="$ctrl.updateChangeDelta({collection: \'contact\', dbfieldname: \'address3\', newval: $ctrl.leadData.address3})">\n          </md-input-container>\n        </md-list-item>\n        <md-list-item>\n          <md-input-container flex="100">\n            <label>City</label>\n            <input type="text" ng-model="$ctrl.leadData.city" name="City" ng-change="$ctrl.updateChangeDelta({collection: \'contact\', dbfieldname: \'city\', newval: $ctrl.leadData.city})">\n          </md-input-container>\n        </md-list-item>\n        <md-list-item>\n          <md-input-container flex="100">\n            <label>State</label>\n            <input type="text" ng-model="$ctrl.leadData.state" name="State" ng-change="$ctrl.updateChangeDelta({collection: \'contact\', dbfieldname: \'state\', newval: $ctrl.leadData.state})">\n          </md-input-container>\n        </md-list-item>\n        <md-list-item>\n          <md-input-container flex="100">\n            <label>Zip code</label>\n            <input type="text" ng-model="$ctrl.leadData.zipcode" name="Zipcode" ng-change="$ctrl.updateChangeDelta({collection: \'contact\', dbfieldname: \'zipcode\', newval: $ctrl.leadData.zipcode})">\n          </md-input-container>\n        </md-list-item>\n        <md-list-item>\n          <md-input-container flex="100">\n            <label>Country</label>\n            <input type="text" ng-model="$ctrl.leadData.country" name="Country" ng-change="$ctrl.updateChangeDelta({collection: \'contact\', dbfieldname: \'country\', newval: $ctrl.leadData.country})">\n          </md-input-container>\n        </md-list-item>\n      </md-list>\n    </md-card-body>\n  </md-card>\n</div>\n');
$templateCache.put('app/biz-card/zp-bizcard-stat-widgets/zp-bizcard-stat-widgets.tmpl.html','<md-card layout="column" layout-align="space-between end" layout="flex" palette-background="zuant-pollen:400" flex="100"\n  flex-sm="50" flex-md="50" layout-padding>\n  <p class="md-display-3 font-weight-100 margin-top-0 margin-bottom-0 text-ellipsis"\n    countupto="$ctrl.factoryData.cardsLeftToProcessForCurrentSelectionQuery" decimals="0" duration=".5"></p>\n  <p class="zp-caption margin-top-0 margin-bottom-0">LEFT TO GO</p>\n  <p ng-if="$ctrl.factoryData.zeroCardsLeftToProcess" class="md-display-3 animated tada margin-top-0 margin-bottom-0">\uD83C\uDF89\n  </p>\n</md-card>\n\n<md-card flex-sm="50" flex-md="50">\n  <zp-bizcard-metadata contact="$ctrl.factoryData.cardCurrentlyBeingEdited"></zp-bizcard-metadata>\n</md-card>\n\n<md-card>\n  <zp-card-filter></zp-card-filter>\n</md-card>');
$templateCache.put('app/biz-card/zp-card-counts-by-client/template.html','<div flex style="max-height: 80vh;" layout="column">\n  <md-card layout-padding ng-show="$ctrl.showCard.showCardCountsCard">\n    <!-- <h1 class="margin-bottom-0">The work!</h1> -->\n    <h4 class="margin-bottom-0">Quick view of cards to process counts</h4>\n    <p class="margin-bottom-0">This temporary list is for Zam quick reference to see what\'s out there left to process.</p>\n    <md-input-container flex>\n      <label>Type here to filter the list</label>\n      <input ng-model="filter" type="text" />\n    </md-input-container>\n    <md-card-content style="max-height: 60vh; overflow-y:scroll;">\n      <md-list class="md-2-line">\n        <md-subheader>Unprocessed cards grouped by client</md-subheader>\n        <md-list-item class="md-2-line" ng-repeat="row in $ctrl.data | filter: filter">\n          <div class="md-list-item-text">\n            <h4>{{ row.client }}</h4>\n            <h4><strong>{{ row.count }} </strong> cards</h4>\n          </div>\n        </md-list-item>\n      </md-list>\n    </md-card-content>\n  </md-card>\n</div>\n');
$templateCache.put('app/biz-card/zp-card-filter/zp-card-filter.tmpl.html','<md-list class="md-dense" flex>\n  <md-subheader lass="md-no-sticky" >\n    <span style="color: rgba(0,0,0,0.26);">\n      <span >{{$ctrl.factoryData.cardViewFilters.forms.length}} <span ng-if="$ctrl.factoryData.cardViewFilters.forms.length === 1">form</span> <span ng-if="$ctrl.factoryData.cardViewFilters.forms.length > 1 || $ctrl.factoryData.cardViewFilters.forms.length === 0">forms</span> filters applied</span>\n    </span>\n  </md-subheader>\n  <md-list-item\n    class="md-2-line"\n    ng-repeat="form in $ctrl.factoryData.cardViewFilters.forms">\n    <div class="md-avatar zp-avatar" >\n      <md-icon md-font-icon="zmdi zmdi-assignment-o"></md-icon>\n    </div>\n    <div class="md-list-item-text" layout="column">\n      <h4>Form name</h4>\n      <p>{{ form.formname }}</p>\n    </div>\n  </md-list-item>\n\n  <md-divider></md-divider>\n\n  <md-subheader lass="md-no-sticky">\n    <span style="color: rgba(0,0,0,0.26);">\n      <span> {{ $ctrl.factoryData.cardViewFilters.users.length }} <span ng-if="$ctrl.factoryData.cardViewFilters.users.length === 1">user</span> <span ng-if="$ctrl.factoryData.cardViewFilters.users.length > 1 || $ctrl.factoryData.cardViewFilters.users.length === 0">users</span> filters applied</span>\n    </span>\n  </md-subheader>\n  <md-list-item\n    class="md-2-line"\n    ng-repeat="user in $ctrl.factoryData.cardViewFilters.users">\n    <div class="md-avatar zp-avatar" ng-style="user.userAvatarStyle" ng-if="user.userAvatarStyle">\n      <span ng-if="user.textAvatar">{{user.username | limitTo: 2}}</span>\n    </div>\n    <div class="md-list-item-text" layout="column">\n      <h3>{{ user.username }}</h3>\n      <p>{{ user.email }}</p>\n    </div>\n  </md-list-item>\n</md-list>\n');
$templateCache.put('app/clients/active-user-counts/tmpl.html','<md-card layout-padding>\n  <md-card-header>\n    <!-- <md-card-avatar>\n      <md-icon md-font-icon="zmdi {{$ctrl.chartInfo.metadata.icon}}"></md-icon>\n    </md-card-avatar> -->\n    <md-card-header-text>\n      <span class="md-title"><b>Active users 2020</b></span>\n      <!-- <div flex="100" layout="row" style="padding:0px;">\n        <md-button class="md-icon-button"><md-icon md-font-icon="zmdi zmdi-chevron-left"></md-icon></md-button>\n        <md-button class="md-icon-button"><md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon></md-button class="md-icon-button">\n      </div>     -->\n    </md-card-header-text>\n    <!-- <span flex></span> -->\n    <!-- <zp-context-menu\n      menu-options="$ctrl.menuOptions"\n      menu-width="$ctrl.menuWidth"\n      on-menu-click="$ctrl.onMenuClick({action: action, ev: ev})">\n    </zp-context-menu> -->\n    <!-- <md-input-container flex="25">\n      <label>Bucket size: </label>\n      <md-select ng-model="$ctrl.groupSize" ng-change="$ctrl.run()" placeholder="Select time bucket size">\n        <md-option ng-value="opt" ng-repeat="opt in $ctrl.groupSizeOptions">{{ opt }}</md-option>\n      </md-select>\n    </md-input-container>\n  </div>  -->\n  </md-card-header>\n\n  <zp-chart \n    chart-data="$ctrl.chartInfo.chartableData"\n    chart-labels="$ctrl.chartInfo.labels"\n    chart-type="$ctrl.chartInfo.chartType"\n    chart-options="$ctrl.chartInfo.chartOptions">\n  </zp-chart>\n\n  <!-- <h4>Service res</h4>\n  <pre>{{ $ctrl.content }}</pre>\n\n  <h4>Chart Info</h4>\n  <pre>{{ $ctrl.chartInfo }}</pre> -->\n\n</md-card>');
$templateCache.put('app/clients/boltons/boltons.tmpl.html','<zp-bolt-on-management-view\n  bolt-on-selected="vm.boltOnClicked"\n  close-dialog="vm.hide()"\n  layout-fill>\n</zp-bolt-on-management-view>\n');
$templateCache.put('app/clients/client-form/zp-client-form.tmpl.html','<form name="$ctrl.clientFormObj" ng-submit="$ctrl.submitClientForm(true)">\n  <md-list>\n    <md-subheader class="md-no-sticky" ng-if="!$ctrl.createAccountDialog">\n      Account Info\n    </md-subheader>\n\n    <md-list-item class="margin-top-30">\n      <md-input-container class="no-padding no-margin" flex>\n        <label>Company name</label>\n        <input type="text" ng-model="$ctrl.clientDoc.companyname" name="companyName" aria-label="Company name"\n          ng-keyup="$ctrl.onCompanyNameKeyUp()" md-autofocus required\n          ng-change="$ctrl.updateChangeDelta(\'companyname\', $ctrl.clientDoc.companyname)">\n        <div ng-messages="$ctrl.clientFormObj.companyName.$error">\n          <div ng-message="required">Cannot be blank</div>\n          <div ng-if="$ctrl.validObj.exists">That name already exists</div>\n        </div>\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="companyNameHelper = !companyNameHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item class="hint" ng-show="companyNameHelper">\n      <p class="zuantTitanium1">\n        The clients company name. Does not need to be unique & can contain capitals, spaces & special characters.\n      </p>\n    </md-list-item>\n\n    <md-list-item class="margin-top-10" permission permission-only="\'ZUANT_ADMIN\'">\n      <md-input-container class="no-padding no-margin" flex>\n        <label>Database name</label>\n        <input type="text" ng-model="$ctrl.clientDoc.databasename" name="databaseName" aria-label="Database name"\n          disabled="$ctrl.disableDatabaseName" required>\n        <div ng-messages="$ctrl.clientFormObj.databaseName.$error">\n          <div ng-if="$ctrl.clientFormObj.databaseName.$error.databaseExists">That databasename already exists</div>\n        </div>\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="databaseNameHelper = !databaseNameHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item class="hint" ng-show="databaseNameHelper">\n      <p class="zuantTitanium1">\n        The clients database name. This is unique to the client, it is used to identify the client within the Zuant data\n        store.\n      </p>\n    </md-list-item>\n\n    <md-list-item class="margin-top-5" permission permission-only="\'ZUANT_ADMIN\'">\n      <md-input-container class="no-padding no-margin" flex>\n        <label>Customer Success Manager</label>\n        <md-select placeholder="Assign a customer success manager"\n          ng-model="$ctrl.clientDoc.zuantcustomersuccessmanager"\n          ng-change="$ctrl.updateChangeDelta(\'zuantcustomersuccessmanager\', $ctrl.clientDoc.zuantcustomersuccessmanager)"\n          required>\n          <md-optgroup label="Customer Success Managers">\n            <md-option ng-value="manager.email"\n              ng-repeat="manager in $ctrl.zuantCustomerSuccessManagers">{{manager.name}}\n            </md-option>\n          </md-optgroup>\n        </md-select>\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="zuantCustomerSuccessManagerHelper = !zuantCustomerSuccessManagerHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item class="hint extra-margin" ng-show="zuantCustomerSuccessManagerHelper">\n      <p class="zuantTitanium1">\n        The Customer Success Manager that looks after this account.\n      </p>\n    </md-list-item>\n\n    <md-list-item class="margin-top-15" permission permission-only="\'ZUANT_ADMIN\'">\n      <md-input-container class="no-padding no-margin" flex>\n        <label>Zuant Account Manager</label>\n        <md-select placeholder="Assign an account manager" ng-model="$ctrl.clientDoc.zuantaccountmanager"\n          ng-change="$ctrl.updateChangeDelta(\'zuantaccountmanager\', $ctrl.clientDoc.zuantaccountmanager)" required>\n          <md-optgroup label="Account Managers">\n            <md-option ng-value="manager.email" ng-repeat="manager in $ctrl.zuantAccountManagers">{{manager.name}}\n            </md-option>\n          </md-optgroup>\n        </md-select>\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="zuantAccountManagerHelper = !zuantAccountManagerHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item class="hint extra-margin" ng-show="zuantAccountManagerHelper">\n      <p class="zuantTitanium1">\n        The ZAM that looks after this account (if any).\n      </p>\n    </md-list-item>\n\n    <md-list-item class="margin-top-15" permission permission-only="\'ZUANT_ADMIN\'">\n      <md-input-container class="no-padding no-margin" flex>\n        <label>Account Status</label>\n        <md-select placeholder="What is the status of this account?" ng-model="$ctrl.clientDoc.accountStatus"\n          ng-change="$ctrl.updateChangeDelta(\'accountStatus\', $ctrl.clientDoc.accountStatus)">\n          <md-optgroup label="">\n            <md-option ng-value="state.value" ng-repeat="state in $ctrl.accountStates">\n              <md-icon md-font-icon="zmdi {{state.icn}}"></md-icon>\n              {{state.label}}\n            </md-option>\n          </md-optgroup>\n        </md-select>\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="accountStatusHelper = !accountStatusHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item class="hint extra-margin" ng-show="accountStatusHelper">\n      <p class="zuantTitanium1">\n        Internal use only to categorise/group accounts.\n      </p>\n    </md-list-item>\n\n    <md-list-item class="margin-top-15" permission permission-only="\'ZUANT_ADMIN\'">\n      <md-input-container class="no-padding no-margin" flex>\n        <label>Pricing Plan</label>\n        <md-select placeholder="What payment plan is this account on?" ng-model="$ctrl.clientDoc.pricingPlan"\n          ng-change="$ctrl.updateChangeDelta(\'pricingPlan\', $ctrl.clientDoc.pricingPlan)" required>\n          <md-optgroup label="">\n            <md-option ng-value="state.value" ng-repeat="state in $ctrl.pricingPlans">\n              <!-- <md-icon md-font-icon="zmdi {{state.icn}}"></md-icon> -->\n              {{state.label}}\n            </md-option>\n          </md-optgroup>\n        </md-select>\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="pricingPlanHelper = !pricingPlanHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item class="hint extra-margin" ng-show="pricingPlanHelper">\n      <p class="zuantTitanium1">\n        Internal use only to show pricing plan for the account.\n      </p>\n    </md-list-item>\n\n    <md-list-item flex class="margin-top-20" permission permission-only="\'ZUANT_ADMIN\'">\n      <md-input-container class="no-margin" flex layout="row">\n        <label>Account owner</label>\n        <input type="text" name="Account owner" placeholder="Enter email address of the account owner here"\n          aria-label="Account owner" ng-model="$ctrl.clientDoc.accountOwner"\n          ng-change="$ctrl.updateChangeDelta(\'accountOwner\', $ctrl.clientDoc.accountOwner)"\n          ng-disabled="!$ctrl.factoryData.userPermittedToEditAccountOwner.permitted"\n          ng-pattern="/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/" required>\n        <md-icon md-font-icon="zmdi zmdi-lock-open" class="md-accent"\n          ng-if="$ctrl.factoryData.userPermittedToEditAccountOwner.permitted"></md-icon>\n        <md-icon md-font-icon="zmdi zmdi-lock-outline" class="md-accent"\n          ng-if="!$ctrl.factoryData.userPermittedToEditAccountOwner.permitted && $ctrl.clientDoc.accountOwner"\n          ng-click="$ctrl.requestPasscode()"></md-icon>\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="accountOwnerHelper = !accountOwnerHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item class="hint extra-margin" ng-show="accountOwnerHelper">\n      <p class="zuantTitanium1">\n        The account owner is who will be sent a passcode for certain account admin functions.\n      </p>\n    </md-list-item>\n\n    <md-list-item class="margin-top-10">\n      <md-input-container class="no-padding no-margin" flex>\n        <label>Executive Summary Report contacts</label>\n        <input type="text" ng-model="$ctrl.clientDoc.executiveSummaryEmails" name="executiveSummaryEmails"\n          aria-label="Executive Summary Report contacts"\n          ng-change="$ctrl.updateChangeDelta(\'executiveSummaryEmails\', $ctrl.clientDoc.executiveSummaryEmails)">\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="executiveSummaryEmailsHelper = !executiveSummaryEmailsHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item class="hint" ng-show="executiveSummaryEmailsHelper">\n      <p class="zuantTitanium1">\n        Comma delimited list of email address that will automatically receive event executive summary emails.\n      </p>\n    </md-list-item>\n\n    <md-list-item class="margin-top-10">\n      <md-input-container class="no-padding no-margin" flex>\n        <label>Event Countdown contacts</label>\n        <input type="text" ng-model="$ctrl.clientDoc.eventOwner" name="eventOwner" aria-label="Event Countdown contact"\n          ng-change="$ctrl.updateChangeDelta(\'eventOwner\', $ctrl.clientDoc.eventOwner)">\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="eventCountdownHelper = !eventCountdownHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item class="hint" ng-show="eventCountdownHelper">\n      <p class="zuantTitanium1">\n        Comma delimited list of email address that will automatically receive event countdown emails.\n      </p>\n    </md-list-item>\n\n    <md-list-item class="margin-top-10">\n      <md-input-container class="no-padding no-margin" flex>\n        <label>Technical contact</label>\n        <input type="text" ng-model="$ctrl.clientDoc.technicalContact" name="technicalContact"\n          aria-label="Technical contact"\n          ng-change="$ctrl.updateChangeDelta(\'technicalContact\', $ctrl.clientDoc.technicalContact)">\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="technicalContactHelper = !technicalContactHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n\n    </md-list-item>\n\n    <md-list-item class="hint" ng-show="technicalContactHelper">\n      <p class="zuantTitanium1">\n        The technical contact will receive automatic notifications of technical errors. (Currently just integration\n        error emails)\n      </p>\n    </md-list-item>\n\n    <md-list-item class="margin-top-10">\n      <zp-select-control flex model="$ctrl.clientDoc.timezone" on-change="$ctrl.updateTimezone({item: item})"\n        config="$ctrl.timezonesConfig">\n      </zp-select-control>\n    </md-list-item>\n\n    <md-list-item class="margin-top-10">\n      <md-input-container class="no-padding no-margin" flex>\n        <label>Company website</label>\n        <input type="text" ng-model="$ctrl.clientDoc.website" name="websiteAddress" aria-label="Website"\n          ng-change="$ctrl.updateChangeDelta(\'website\', $ctrl.clientDoc.website)">\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="companyWebsiteHelper = !companyWebsiteHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item class="hint" ng-show="companyWebsiteHelper">\n      <p class="zuantTitanium1">\n        The clients company website where applicable.\n      </p>\n    </md-list-item>\n\n    <md-list-item class="margin-top-10" permission permission-only="\'ZUANT_ADMIN\'">\n      <md-input-container class="no-padding no-margin" flex>\n        <label>Notes</label>\n        <textarea ng-model="$ctrl.clientDoc.notes" rows="2" aria-label="Notes"\n          ng-change="$ctrl.updateChangeDelta(\'notes\', $ctrl.clientDoc.notes)"></textarea>\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="notesHelper = !notesHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item class="hint" ng-show="notesHelper">\n      <p class="zuantTitanium1">\n        Any client specific notes to help administration of the client.\n      </p>\n    </md-list-item>\n\n  </md-list>\n\n  <md-list>\n    <md-subheader class="md-no-sticky margin-top-10">MFA</md-subheader>\n    <md-list-item>\n      <md-checkbox ng-model="$ctrl.clientDoc.ismfaenabled" ng-true-value="1" ng-false-value="0"\n        ng-change="$ctrl.updateChangeDelta(\'ismfaenabled\', $ctrl.clientDoc.ismfaenabled)">\n      </md-checkbox>\n\n      <p>Enable MFA (Multi Factor Authentication)</p>\n\n      <md-icon class="md-secondary" ng-click="mfaHelper = !mfaHelper" md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n    <md-list-item ng-show="mfaHelper">\n      <p class="zuantTitanium1">\n        Enable this setting to enforce MFA (Multi Factor Authentication) for all users within the account.\n      </p>\n    </md-list-item>\n\n  </md-list>\n\n  <md-list>\n    <md-subheader class="md-no-sticky margin-top-10">Password Policy</md-subheader>\n\n    <md-list-item>\n      <md-checkbox ng-model="$ctrl.clientDoc.ispasswordpolicyenabled" ng-true-value="1" ng-false-value="0"\n        ng-change="$ctrl.updateChangeDelta(\'ispasswordpolicyenabled\', $ctrl.clientDoc.ispasswordpolicyenabled)">\n      </md-checkbox>\n\n      <p>Enable Password Policy</p>\n\n      <md-icon class="md-secondary" ng-click="passwordPolicyHelper = !passwordPolicyHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n    <md-list-item ng-show="passwordPolicyHelper">\n      <p class="zuantTitanium1">\n        Enable this setting to enforce a password policy for all users within the account. All new users added will have\n        to adhere to the defined policy. All existing Power Users will be instructed to update their password upon next\n        logging in to the Zuant Cloud. Existing Standard Users will not be effected.\n      </p>\n    </md-list-item>\n\n    <md-list-item>\n      <span flex="30">Maximum Length</span>\n\n      <md-slider-container flex flex-offset-gt-md="10">\n        <md-slider ng-disabled="!$ctrl.clientDoc.ispasswordpolicyenabled"\n          ng-model="$ctrl.passwordPolicy.maxLength.value" min="{{$ctrl.passwordPolicy.maxLength.min}}"\n          max="{{$ctrl.passwordPolicy.maxLength.max}}" step="1" aria-label="Maximum Length"></md-slider>\n      </md-slider-container>\n\n      <md-input-container flex="5" flex-offset-gt-md="2">\n        <input ng-disabled="!$ctrl.clientDoc.ispasswordpolicyenabled" style="text-align: center;" type="text"\n          ng-model="$ctrl.passwordPolicy.maxLength.value" min="{{$ctrl.passwordPolicy.maxLength.min}}"\n          max="{{$ctrl.passwordPolicy.maxLength.max}}" positive-integer-between-boundary>\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="maximumLengthHelper = !maximumLengthHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item ng-show="maximumLengthHelper">\n      <p class="zuantTitanium1">\n        This value is the maximum length of characters that will be permitted when a user creates a password.\n      </p>\n    </md-list-item>\n\n    <md-list-item>\n      <span flex="30">Minimum Length</span>\n\n      <md-slider-container flex flex-offset-gt-md="10">\n        <md-slider ng-disabled="!$ctrl.clientDoc.ispasswordpolicyenabled"\n          ng-model="$ctrl.passwordPolicy.minLength.value" min="{{$ctrl.passwordPolicy.minLength.min}}"\n          max="{{$ctrl.passwordPolicy.minLength.max}}" step="1" aria-label="Minimum Length"></md-slider>\n      </md-slider-container>\n\n      <md-input-container flex="5" flex-offset-gt-md="2">\n        <input ng-disabled="!$ctrl.clientDoc.ispasswordpolicyenabled" style="text-align: center;" type="text"\n          ng-model="$ctrl.passwordPolicy.minLength.value" min="{{$ctrl.passwordPolicy.minLength.min}}"\n          max="{{$ctrl.passwordPolicy.minLength.max}}" positive-integer-between-boundary>\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="minimumLengthHelper = !minimumLengthHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item ng-show="minimumLengthHelper">\n      <p class="zuantTitanium1">\n        This value is the minimum length of characters that will be required when a user creates a password.\n      </p>\n    </md-list-item>\n\n    <md-list-item>\n      <span flex="30">Minimum Uppercase Letters (A-Z)</span>\n\n      <md-slider-container flex flex-offset-gt-md="10">\n        <md-slider ng-disabled="!$ctrl.clientDoc.ispasswordpolicyenabled"\n          ng-model="$ctrl.passwordPolicy.minUppercase.value" min="{{$ctrl.passwordPolicy.minUppercase.min}}"\n          max="{{$ctrl.passwordPolicy.minUppercase.max}}" step="1" aria-label="Minimum Uppercase Letters"></md-slider>\n      </md-slider-container>\n\n      <md-input-container flex="5" flex-offset-gt-md="2">\n        <input ng-disabled="!$ctrl.clientDoc.ispasswordpolicyenabled" style="text-align: center;" type="text"\n          ng-model="$ctrl.passwordPolicy.minUppercase.value" min="{{$ctrl.passwordPolicy.minUppercase.min}}"\n          max="{{$ctrl.passwordPolicy.minUppercase.max}}" positive-integer-between-boundary>\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="minimumUppercaseHelper = !minimumUppercaseHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item ng-show="minimumUppercaseHelper">\n      <p class="zuantTitanium1">\n        This value is the minimum number of uppercase characters (A-Z) that will be required when a user creates a\n        password.\n      </p>\n    </md-list-item>\n\n    <md-list-item>\n      <span flex="30">Minimum Lowercase Letters (a-z)</span>\n\n      <md-slider-container flex flex-offset-gt-md="10">\n        <md-slider ng-disabled="!$ctrl.clientDoc.ispasswordpolicyenabled"\n          ng-model="$ctrl.passwordPolicy.minLowercase.value" min="{{$ctrl.passwordPolicy.minLowercase.min}}"\n          max="{{$ctrl.passwordPolicy.minLowercase.max}}" step="1" aria-label="Minimum Lowercase Letters"></md-slider>\n      </md-slider-container>\n\n      <md-input-container flex="5" flex-offset-gt-md="2">\n        <input ng-disabled="!$ctrl.clientDoc.ispasswordpolicyenabled" style="text-align: center;" type="text"\n          ng-model="$ctrl.passwordPolicy.minLowercase.value" min="{{$ctrl.passwordPolicy.minLowercase.min}}"\n          max="{{$ctrl.passwordPolicy.minLowercase.max}}" positive-integer-between-boundary>\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="minimumLowercaseHelper = !minimumLowercaseHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item ng-show="minimumLowercaseHelper">\n      <p class="zuantTitanium1">\n        This value is the minimum number of lowercase characters (a-z) that will be required when a user creates a\n        password.\n      </p>\n    </md-list-item>\n\n    <md-list-item>\n      <span flex="30">Minimum Numeric Characters (0-9)</span>\n\n      <md-slider-container flex flex-offset-gt-md="10">\n        <md-slider ng-disabled="!$ctrl.clientDoc.ispasswordpolicyenabled" class="md-accent" flex\n          ng-model="$ctrl.passwordPolicy.minNumeric.value" min="{{$ctrl.passwordPolicy.minNumeric.min}}"\n          max="{{$ctrl.passwordPolicy.minNumeric.max}}" step="1" aria-label="Minimum Numeric Characters"></md-slider>\n      </md-slider-container>\n\n      <md-input-container flex="5" flex-offset-gt-md="2">\n        <input ng-disabled="!$ctrl.clientDoc.ispasswordpolicyenabled" style="text-align: center;" type="text"\n          ng-model="$ctrl.passwordPolicy.minNumeric.value" min="{{$ctrl.passwordPolicy.minNumeric.min}}"\n          max="{{$ctrl.passwordPolicy.minNumeric.max}}" positive-integer-between-boundary>\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="minimumNumericHelper = !minimumNumericHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item ng-show="minimumNumericHelper">\n      <p class="zuantTitanium1">\n        This value is the minimum number of numeric characters (0-9) that will be required when a user creates a\n        password.\n      </p>\n    </md-list-item>\n\n    <md-list-item>\n      <span flex="30">Minimum Symbol Characters (!@#$%^&*-)</span>\n\n      <md-slider-container flex flex-offset-gt-md="10">\n        <md-slider ng-disabled="!$ctrl.clientDoc.ispasswordpolicyenabled"\n          ng-model="$ctrl.passwordPolicy.minSymbols.value" min="{{$ctrl.passwordPolicy.minSymbols.min}}"\n          max="{{$ctrl.passwordPolicy.minSymbols.max}}" step="1" aria-label="Minimum Symbols"></md-slider>\n      </md-slider-container>\n\n      <md-input-container flex="5" flex-offset-gt-md="2">\n        <input ng-disabled="!$ctrl.clientDoc.ispasswordpolicyenabled" style="text-align: center;" type="text"\n          ng-model="$ctrl.passwordPolicy.minSymbols.value" min="{{$ctrl.passwordPolicy.minSymbols.min}}"\n          max="{{$ctrl.passwordPolicy.minSymbols.max}}" positive-integer-between-boundary>\n      </md-input-container>\n\n      <md-icon class="md-secondary" ng-click="minimumSymbolHelper = !minimumSymbolHelper"\n        md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item ng-show="minimumSymbolHelper">\n      <p class="zuantTitanium1">\n        This value is the minimum number of symbol characters that will be required when a user creates a password. Only\n        the following symbols are permitted <b>!@#$%^&*-</b>.\n      </p>\n    </md-list-item>\n\n    <md-list-item ng-if="$ctrl.clientDoc.ispasswordpolicyenabled">\n      <p>Example Password based on configuration:</p>\n      <span flex></span>\n      <span flex="70" id="example-password"><b>{{$ctrl.generatedPassword}}</b></span>\n    </md-list-item>\n\n  </md-list>\n  <md-list ng-if="$ctrl.isClientMarketpoint || $ctrl.createAccountDialog || $ctrl.isDev || $ctrl.isZuantAdmin">\n\n    <md-subheader class="md-no-sticky margin-top-10">Extras</md-subheader>\n\n    <ng-container ng-if="!$ctrl.createAccountDialog && $ctrl.isClientMarketpoint">\n      <md-list-item>\n        <md-checkbox ng-model="$ctrl.clientDoc.ispreventglobaluserwelcomeemail" ng-true-value="1" ng-false-value="0"\n          ng-change="$ctrl.updateChangeDelta(\'ispreventglobaluserwelcomeemail\', $ctrl.clientDoc.ispreventglobaluserwelcomeemail)">\n        </md-checkbox>\n        <p>Prevent global user welcome emails</p>\n        <md-icon class="md-secondary"\n          ng-click="ispreventGlobalUserWelcomeEmailHelper = !ispreventGlobalUserWelcomeEmailHelper"\n          md-font-icon="zmdi zmdi-info-outline"></md-icon>\n      </md-list-item>\n\n      <md-list-item ng-show="ispreventGlobalUserWelcomeEmailHelper">\n        <p class="zuantTitanium1">\n          Enable this setting to prevent standard users from recieving welcome emails globally. This is a dev only\n          feature!\n        </p>\n      </md-list-item>\n\n      <md-list-item>\n        <md-checkbox ng-model="$ctrl.clientDoc.ispreventglobaluserpasswordresetemail" ng-true-value="1"\n          ng-false-value="0"\n          ng-change="$ctrl.updateChangeDelta(\'ispreventglobaluserpasswordresetemail\', $ctrl.clientDoc.ispreventglobaluserpasswordresetemail)">\n        </md-checkbox>\n        <p>Prevent global password reset emails</p>\n        <md-icon class="md-secondary"\n          ng-click="ispreventGlobalUserPasswordResetEmailHelper = !ispreventGlobalUserPasswordResetEmailHelper"\n          md-font-icon="zmdi zmdi-info-outline"></md-icon>\n      </md-list-item>\n\n      <md-list-item ng-show="ispreventGlobalUserPasswordResetEmailHelper">\n        <p class="zuantTitanium1">\n          Enable this setting to prevent standard users from recieving password reset emails globally. This is a dev\n          only feature!\n        </p>\n      </md-list-item>\n\n    </ng-container>\n\n    <ng-container ng-if="!$ctrl.isClientMarketpoint || $ctrl.createAccountDialog">\n\n      <md-list-item>\n        <md-checkbox ng-model="$ctrl.clientDoc.copySupportEmailsToZuantTeam"\n          ng-change="$ctrl.updateChangeDelta(\'copySupportEmailsToZuantTeam\', $ctrl.clientDoc.copySupportEmailsToZuantTeam)"\n          ng-true-value="1" ng-false-value="0"></md-checkbox>\n        <p>Copy support emails to Zuant team</p>\n        <md-icon class="md-secondary"\n          ng-click="copySupportEmailsToZuantTeamHelper = !copySupportEmailsToZuantTeamHelper" aria-label="More info"\n          md-font-icon="zmdi zmdi-info-outline"></md-icon>\n      </md-list-item>\n      <md-list-item ng-show="copySupportEmailsToZuantTeamHelper">\n        <p class="zuantTitanium1">\n          When switched on the support@zuant.com email address will receive account integration error emails.\n        </p>\n      </md-list-item>\n\n      <md-list-item>\n        <md-checkbox ng-model="$ctrl.clientDoc.ispreventimagedownload" ng-true-value="1" ng-false-value="0"\n          ng-change="$ctrl.updateChangeDelta(\'ispreventimagedownload\', $ctrl.clientDoc.ispreventimagedownload)">\n        </md-checkbox>\n        <p>Prevent image download</p>\n        <md-icon class="md-secondary" ng-click="ispreventimagedownloadHelper = !ispreventimagedownloadHelper"\n          md-font-icon="zmdi zmdi-info-outline"></md-icon>\n      </md-list-item>\n\n      <md-list-item ng-show="ispreventimagedownloadHelper">\n        <p class="zuantTitanium1">\n          Enable this setting to prevent images from downloading to all user devices. It will only download to users\n          tagged as bureau workers.\n        </p>\n      </md-list-item>\n\n      <md-list-item>\n        <md-checkbox ng-model="$ctrl.clientDoc.ispreventuserwelcomeemail" ng-true-value="1" ng-false-value="0"\n          ng-change="$ctrl.updateChangeDelta(\'ispreventuserwelcomeemail\', $ctrl.clientDoc.ispreventuserwelcomeemail)">\n        </md-checkbox>\n        <p>Prevent user welcome email</p>\n        <md-icon class="md-secondary" ng-click="ispreventUserWelcomeEmailHelper = !ispreventUserWelcomeEmailHelper"\n          md-font-icon="zmdi zmdi-info-outline"></md-icon>\n      </md-list-item>\n\n      <md-list-item ng-show="ispreventUserWelcomeEmailHelper">\n        <p class="zuantTitanium1">\n          Enable this setting to prevent users from recieving welcome emails that are defaultly sent out\n          upon new users being added on an individual basis or via csv import.\n        </p>\n      </md-list-item>\n\n      <md-list-item>\n        <md-checkbox ng-model="$ctrl.clientDoc.ispreventuserpasswordresetemail" ng-true-value="1" ng-false-value="0"\n          ng-change="$ctrl.updateChangeDelta(\'ispreventuserpasswordresetemail\', $ctrl.clientDoc.ispreventuserpasswordresetemail)">\n        </md-checkbox>\n        <p>Prevent user password reset email</p>\n        <md-icon class="md-secondary"\n          ng-click="ispreventUserPasswordResetEmailHelper = !ispreventUserPasswordResetEmailHelper"\n          md-font-icon="zmdi zmdi-info-outline"></md-icon>\n      </md-list-item>\n\n      <md-list-item ng-show="ispreventUserPasswordResetEmailHelper">\n        <p class="zuantTitanium1">\n          Enable this setting to prevent users from recieving password reset notification emails that are defaultly sent\n          out upon a users password being changed by an administrator.\n        </p>\n      </md-list-item>\n\n    </ng-container>\n\n    <ng-container ng-if="!$ctrl.isClientMarketpoint || $ctrl.createAccountDialog" permission\n      permission-only="\'ZUANT_ADMIN\'">\n\n      <md-list-item>\n        <md-checkbox ng-model="$ctrl.clientDoc.isBetaTestingAccount" ng-true-value="1" ng-false-value="0"\n          ng-change="$ctrl.updateChangeDelta(\'isBetaTestingAccount\', $ctrl.clientDoc.isBetaTestingAccount)"></md-checkbox>\n        <p>Beta tester</p>\n        <md-icon ng-class="{\'md-raised\': isBetaTestingAccountHelper }" class="md-secondary"\n          ng-click="isBetaTestingAccountHelper = !isBetaTestingAccountHelper" aria-label="More info"\n          md-font-icon="zmdi zmdi-info-outline"></md-icon>\n      </md-list-item>\n      <md-list-item ng-show="isBetaTestingAccountHelper">\n        <p class="zuantTitanium1">\n          When enabled the account is eligible to future beta releases of features.\n        </p>\n      </md-list-item>\n\n      <md-list-item>\n        <md-checkbox ng-model="$ctrl.clientDoc.isUsingOldShowroom" ng-true-value="1" ng-false-value="0"\n          ng-change="$ctrl.updateChangeDelta(\'isUsingOldShowroom\', $ctrl.clientDoc.isUsingOldShowroom)"></md-checkbox>\n        <p>Use old showroom</p>\n        <md-icon ng-class="{\'md-raised\': isUsingOldShowroomAccountHelper }" class="md-secondary"\n          ng-click="isUsingOldShowroomAccountHelper = !isUsingOldShowroomAccountHelper" aria-label="More info"\n          md-font-icon="zmdi zmdi-info-outline"></md-icon>\n      </md-list-item>\n\n      <md-list-item>\n        <md-checkbox ng-model="$ctrl.clientDoc.isZuant3Account" ng-true-value="1" ng-false-value="0"\n          ng-change="$ctrl.updateChangeDelta(\'isZuant3Account\', $ctrl.clientDoc.isZuant3Account)"></md-checkbox>\n        <p>Zuant 3.0</p>\n        <md-icon ng-class="{\'md-raised\': isZuant3AccountHelper }" class="md-secondary"\n          ng-click="isZuant3AccountHelper = !isZuant3AccountHelper" aria-label="More info"\n          md-font-icon="zmdi zmdi-info-outline"></md-icon>\n      </md-list-item>\n      <md-list-item ng-show="isZuant3AccountHelper">\n        <p class="zuantTitanium1">\n          When enabled the app will use the new Zuant 3.0 features and UI.\n        </p>\n      </md-list-item>\n\n      <md-list-item ng-show="isUsingOldShowroomAccountHelper">\n        <p class="zuantTitanium1">\n          When enabled the account will be set to use the old showroom editor within cloud\n        </p>\n      </md-list-item>\n    </ng-container>\n  </md-list>\n\n  <ng-container ng-if="!$ctrl.isClientMarketpoint || $ctrl.createAccountDialog">\n    <div layout="row" ng-if="!$ctrl.factoryData.userPermittedToMakeGDPREdits.permitted">\n      <div flex="90" layout="row" layout-align="center center">\n        <p class="md-title" flex>\n          You need a passcode in order to edit GDPR level settings. Click this button and we\'ll email a passcode to\n          ({{$ctrl.userDoc.email}}).\n        </p>\n        <div ng-include="$ctrl.threeArrowRightHeadImageSvg"></div>\n        <md-button class="md-raised md-primary" ng-click="$ctrl.requestPasscode($event)">Request passcode</md-button>\n      </div>\n    </div>\n    <zp-account-compliance-settings></zp-account-compliance-settings>\n  </ng-container>\n\n  <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>');
$templateCache.put('app/clients/detail/zp-client-detail.tmpl.html','<div layout="column" layout-fill>\n\n  <md-content ng-cloak flex layout-align="start start">\n    <div flex ng-if="!$ctrl.clientDoc.clientArchived && !$ctrl.clientDoc.clientOperationStatus">\n      <div layout="column" flex-gt-sm="80" flex-offset-gt-sm="10" flex-offset-gt-lg="10">\n        <logo-component on-update="$ctrl.updateLogo(logoObj)" logo-image="$ctrl.clientDoc.clientLogoImage"\n          client-id="$ctrl.clientDoc._id" flex-gt-md="30" btn-disabled="$ctrl.disableSaveBtn"\n          clear-logo="$ctrl.clearLogo()">\n        </logo-component>\n        <zp-theme-overview custom-skin-library-state-path="{{$ctrl.customSkinLibraryStatePath}}"\n          custom-skin-editor-state-path="{{$ctrl.customSkinEditorStatePath}}"\n          client-detail-state-path="{{$ctrl.clientDetailStatePath}}"\n          ng-if="$ctrl.accountBoltOns.boltOns.customSkins.enabled" client-id="$ctrl.clientDoc._id"\n          client-logo-obj="$ctrl.clientDoc.clientLogoImage" flex-gt-md="70">\n        </zp-theme-overview>\n      </div>\n    </div>\n\n    <div ng-if="!$ctrl.isClientMarketpoint && ($ctrl.clientDoc.clientArchived || $ctrl.clientDoc.clientOperationStatus)"\n      flex-gt-sm="80" flex-offset-gt-sm="10" flex-offset-gt-lg="10">\n      <md-card layout="column" layout-align="center center" layout-padding flex>\n\n        <span ng-if="$ctrl.clientDoc.clientArchived" class="stamp is-nope archived">ARCHIVED</span>\n        <span ng-if="!$ctrl.clientDoc.clientArchived && $ctrl.clientDoc.clientOperationStatus"\n          class="stamp is-nope operation">\n          CLIENT OPERATION IN PROGRESS\n        </span>\n\n        <span ng-if="$ctrl.clientDoc.clientArchived && !$ctrl.clientDoc.clientOperationStatus">\n          <md-icon md-font-icon="zmdi zmdi-alert-triangle zuantPollen"></md-icon>\n          <span permission permission-only="\'SUPER_ZAM\'">\n            This client is currently archived, please use the "UNARCHIVE CLIENT" button below to re-enable the account.\n          </span>\n          <span permission permission-except="\'SUPER_ZAM\'">\n            This client is currently archived, please ask an administrator to re-activate the account.\n          </span>\n\n          <div permission permission-except="\'SUPER_ZAM\'">\n            <p class="margin-bottom-0">Administrators permissioned to perform this operation:</p>\n            <ul class="super-zam-list">\n              <li ng-repeat="superZam in $ctrl.superZams">\n                {{superZam.name}} - {{superZam.email}}\n              </li>\n            </ul>\n          </div>\n        </span>\n\n        <ng-container ng-if="$ctrl.clientDoc.clientOperationStatus"\n          ng-switch="$ctrl.clientDoc.clientOperationStatus.operation">\n          <span>\n            <md-icon md-font-icon="zmdi zmdi-info-outline md-primary"></md-icon>\n            <ng-container ng-switch-when="archiveClient">\n              This client currently has an archive operation ongoing, you will be unable to access the account until\n              completion. <span permission permission-only="\'SUPER_ZAM\'">To see progress click on the "ARCHIVE CLIENT"\n                button.</span>\n            </ng-container>\n            <ng-container ng-switch-when="unarchiveClient">\n              This client currently has an unarchive operation ongoing, you will be unable to access the account until\n              completion. <span permission permission-only="\'SUPER_ZAM\'">To see progress click on the "UNARCHIVE\n                CLIENT" button.</span>\n            </ng-container>\n            <ng-container ng-switch-when="deleteClient">\n              This client currently has a deletion operation ongoing, you will be unable to access the account until\n              completion. <span permission permission-only="\'SUPER_ZAM\'">To see progress click on the "DELETE CLIENT"\n                button.</span>\n            </ng-container><ng-container ng-switch-when="redactAllCRM">\n              This client currently has a redaction operation ongoing, you will be unable to access the account until\n              completion. <span permission permission-only="\'SUPER_ZAM\'">To see progress click on the "REDACT ALL CRM"\n                button.</span>\n            </ng-container>\n          </span>\n        </ng-container>\n\n        <span\n          ng-if="$ctrl.clientDoc.clientArchived && !$ctrl.clientDoc.clientOperationStatus && $ctrl.clientDoc.clientRedacted">\n          <md-icon md-font-icon="zmdi zmdi-info-outline md-primary"></md-icon>\n          This client has been redacted.\n        </span>\n\n        <div layout-fill layout="row" layout-align="end center" permission permission-only="\'SUPER_ZAM\'">\n          <md-button ng-if="!$ctrl.clientDoc.clientArchived" class="md-primary" ng-click="$ctrl.archiveClient()"\n            ng-disabled="$ctrl.clientDoc.clientOperationStatus && $ctrl.clientDoc.clientOperationStatus.operation !== \'archiveClient\'">\n            ARCHIVE CLIENT\n          </md-button>\n          <md-button ng-if="$ctrl.clientDoc.clientArchived" class="md-primary" ng-click="$ctrl.unarchiveClient()"\n            ng-disabled="$ctrl.clientDoc.clientOperationStatus && $ctrl.clientDoc.clientOperationStatus.operation !== \'unarchiveClient\'">\n            UNARCHIVE CLIENT\n          </md-button>\n          <md-button ng-if="$ctrl.clientDoc.clientArchived && !$ctrl.clientDoc.clientRedacted" class="md-primary"\n            ng-click="$ctrl.redactClient()"\n            ng-disabled="$ctrl.clientDoc.clientOperationStatus && $ctrl.clientDoc.clientOperationStatus.operation !== \'redactAllCRM\'">\n            REDACT ALL CRM\n          </md-button>\n          <md-button class="md-warn"\n            ng-disabled="$ctrl.clientDoc.clientOperationStatus && $ctrl.clientDoc.clientOperationStatus.operation !== \'deleteClient\'"\n            ng-click="$ctrl.deleteClient()">\n            DELETE CLIENT\n          </md-button>\n        </div>\n      </md-card>\n    </div>\n\n    <div flex-gt-sm="80" flex-offset-gt-sm="10" flex-offset-gt-lg="10">\n      <md-card layout="column" layout-padding flex>\n        <zp-client-form submit-label="Save & Exit" show-secondary-save-btn="true" client-form-obj="$ctrl.clientFormObj"\n          client-doc="$ctrl.clientDoc" create-account-dialog="false">\n        </zp-client-form>\n      </md-card>\n\n      <div layout="row" ng-if="!$ctrl.isClientMarketpoint">\n        <zp-delete-button\n          disabled="$ctrl.clientDoc.clientOperationStatus && $ctrl.clientDoc.clientOperationStatus.operation !== \'deleteClient\'"\n          ng-click="$ctrl.deleteClient($event)" permission permission-only="\'SUPER_ZAM\'">\n        </zp-delete-button>\n\n        <zp-archive-button ng-if="!$ctrl.clientDoc.clientArchived"\n          disabled="$ctrl.clientDoc.clientOperationStatus && $ctrl.clientDoc.clientOperationStatus.operation !== \'archiveClient\'"\n          ng-click="$ctrl.archiveClient($event)" permission permission-only="\'SUPER_ZAM\'">\n        </zp-archive-button>\n\n        <zp-unarchive-button ng-if="$ctrl.clientDoc.clientArchived"\n          disabled="$ctrl.clientDoc.clientOperationStatus && $ctrl.clientDoc.clientOperationStatus.operation !== \'unarchiveClient\'"\n          ng-click="$ctrl.unarchiveClient($event)" permission permission-only="\'SUPER_ZAM\'">\n        </zp-unarchive-button>\n\n        <zp-redact-crm-button ng-if="$ctrl.clientDoc.clientArchived && !$ctrl.clientDoc.clientRedacted"\n          disabled="$ctrl.clientDoc.clientOperationStatus && $ctrl.clientDoc.clientOperationStatus.operation !== \'redactAllCRM\'"\n          ng-click="$ctrl.redactClient($event)" permission permission-only="\'SUPER_ZAM\'">\n        </zp-redact-crm-button>\n\n      </div>\n    </div>\n  </md-content>\n</div>\n\n<md-sidenav id="settingsPanel" md-component-id=\'settingsPanel\' class="md-sidenav-right">\n  <zp-user-preferences></zp-user-preferences>\n</md-sidenav>');
$templateCache.put('app/clients/external-partners/view.tmpl.html','<div flex-offset="20" flex="60">  \n  <p class="md-subhead">External partners are used to link a Zuant account to a 3rd party. They are currently used for API scan lookups such as WebSummit.</p>\n</div>\n\n<md-card flex="60" flex-offset="20">\n  <form ng-submit="$ctrl.postChanges()" name="$ctrl.partnerForm">\n    <md-card-content>\n      <div ng-repeat="partner in $ctrl.partners" layout="row">\n        <md-input-container flex>\n          <label>Partner Name</label>\n          <input ng-model="partner.partnerName" name="partnerName" type="text" required />\n          <div ng-messages="$ctrl.partnerForm.partnerName.$error">\n            <div ng-message when="required">\n              Partner name is required (e.g. Websummit)\n            </div>\n          </div>\n        </md-input-container>\n        <md-input-container flex>\n          <label>Partner ID</label>\n          <input ng-model="partner.partnerId" name="partnerId" type="text" required />\n          <div ng-messages="$ctrl.partnerForm.partnerId.$error">\n            <div ng-message when="required">\n              Partner ID is required\n            </div>\n          </div>\n        </md-input-container>\n        <md-button ng-click="$ctrl.removePartner(partner)" class="md-icon-button" ng-if="$ctrl.storedpartners.length>0">\n          <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n        </md-button>\n      </div>\n    </md-card-content>\n    <md-progress-linear ng-if="$ctrl.saving" class="md-accent" md-indeterminate></md-progress-linear>\n    <md-card-actions layout="row" layout-align="end center">\n      <md-button\n        class="md-accent"\n        ng-click="$ctrl.addPartner(true)"\n        ng-disabled="$ctrl.partnerForm.$invalid">\n        Add Partner\n      </md-button>\n      <md-button\n        class="md-primary md-raised"\n        ng-disabled="$ctrl.disableSave || $ctrl.saving || $ctrl.partnerForm.$invalid && $ctrl.storedpartners.length==0"\n        ng-class="{\'pulsate-aqua animated\': $ctrl.pulseSaveBtn}"\n        ng-click="$ctrl.postChanges()">\n        Save Changes\n      </md-button>\n    </md-card-actions>\n  <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n</md-card>\n');
$templateCache.put('app/clients/teams/view.tmpl.html','<div layout="row" layout-fill ui-layout>\n\n  <ui-layout options="{ flow: \'column\', disableToggle: true }">\n\n    <div ui-layout-container layout="row" layout-align="center stretch" size="25%" min-size="200px" max-size="50%">\n\n      <teams-tree teams="vm.treeStructuredTeams" add-team="vm.addTeam(team)" filter-teams="vm.filterTeams(searchValue)"\n        search-value="vm.searchValue" select-team="vm.selectTeam(team)" toggle-chevron="vm.toggleChevron(team, event)"\n        flex layout="row" layout-align="center stretch">\n      </teams-tree>\n\n    </div>\n\n    <div ui-layout-container="central" layout="row" layout-align="center stretch">\n\n      <teams-detail flex layout="row" layout-align="center stretch" teams="vm.teams"\n        remove-selected-users="vm.removeSelectedUsers()" select-all-subteams="vm.selectAllSubteams(selectAll)"\n        remove-selected-teams="vm.removeSelectedTeams(removeAllTeams)" selected-team="vm.selectedTeam"\n        add-subteam="vm.addSubteam(team, addToTeams)" remove-subteam="vm.removeSubteam(idx)"\n        add-users="vm.addUsers(users)" update-dirty="vm.updateDirty()"\n        set-all-members-flag="vm.setAllMembersFlag(flag, value)">\n      </teams-detail>\n\n    </div>\n\n  </ui-layout>\n\n</div>\n\n<zp-teams-fab teams="vm.teams" selected-team="vm.selectedTeam" save="vm.save()"\n  remove-team="vm.removeTeam(removeAllTeams)" edit-team="vm.editTeam(team)">\n</zp-teams-fab>');
$templateCache.put('app/common/account-select/zp-account-select.tmpl.html','<div layout="row" layout-align="end center">\n  <div ng-show="$ctrl.inputVisible" layout="row">\n    <md-autocomplete permission permission-only="\'ZUANT_ADMIN\'" md-input-id="clientAutocomplete" md-no-cache="true"\n      md-search-text="$ctrl.searchQuery" md-search-text-change="$ctrl.querySearch()"\n      md-selected-item-change="$ctrl.selectedItemChange(item)" md-items="item in $ctrl.autoCompleteItems"\n      md-item-text="item.databasename" placeholder="Pick an account to manage"\n      md-menu-class="autocomplete-custom-template" md-dropdown-items="8">\n      <md-item-template>\n        <div ng-click="$event.stopPropagation()" ng-if="item.loading" layout="column" layout-align="center center">\n          <md-progress-circular class="md-accent" md-mode="indeterminate" md-diameter="40px"></md-progress-circular>\n        </div>\n\n        <div ng-if="!item.loading" layout="row" layout-align="space-between">\n          <div>\n            <span class="item-title">\n              Company:\n              <strong>{{item.companyname}}</strong>\n            </span>\n            <span class="item-metadata">\n              <span class="item-metastat">\n                <span> database:\n                  <strong>{{item.databasename}}</strong>\n                </span>\n              </span>\n            </span>\n          </div>\n\n        </div>\n      </md-item-template>\n      <md-not-found>\n        <div ng-click="$event.stopPropagation()" layout="column" layout-align="center center">\n          No matches found.\n        </div>\n      </md-not-found>\n    </md-autocomplete>\n  </div>\n  <div>\n    <md-button class="md-icon-button" ng-click="$ctrl.accountSettings()" ng-show="$ctrl.inputVisible">\n      <md-icon class="zmdi zmdi-settings"></md-icon>\n      <md-tooltip md-direction="down">account settings</md-tooltip>\n    </md-button>\n    <span flex></span>\n    <md-button class="md-icon-button" ng-click="$ctrl.toggleInputVisibility(!$ctrl.inputVisible)" hide-gt-xs permission\n      permission-only="\'ZUANT_ADMIN\'">\n      <md-icon md-font-icon="zmdi zmdi-globe"></md-icon>\n      <md-tooltip md-direction="down">switch account</md-tooltip>\n    </md-button>\n    <md-button ng-click="$ctrl.toggleInputVisibility(!$ctrl.inputVisible)" hide-xs permission\n      permission-only="\'ZUANT_ADMIN\'">\n      <md-tooltip md-direction="down">switch account</md-tooltip>\n      <md-icon md-font-icon="zmdi zmdi-globe"></md-icon>\n      <span class="no-transform">{{$ctrl.userData.databasename}}</span>\n    </md-button>\n    <div permission permission-except="\'ZUANT_ADMIN\'">\n      <md-tooltip md-direction="down">db: {{$ctrl.userData.databasename}}</md-tooltip>\n      <md-icon md-font-icon="zmdi zmdi-globe"></md-icon>\n      <span class="no-transform md-body-2" style="color: white;">{{$ctrl.userData.company}}</span>\n    </div>\n  </div>\n</div>');
$templateCache.put('app/common/buttons/zp-archive-button.tmpl.html','<md-button class="md-icon-button" aria-label="{{$ctrl.label}}" ng-disabled="$ctrl.disabled"\n    ng-click="$ctrl.onClick({ev:$event})">\n    <md-icon md-font-icon="zmdi zmdi-archive"></md-icon>\n    <md-tooltip md-direction="down">Archive</md-tooltip>\n</md-button>');
$templateCache.put('app/common/buttons/zp-clear-button.tmpl.html','<md-button class="md-icon-button" ng-click="$ctrl.onClick({ev:$event})">\n  <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n  <md-tooltip md-direction="right"><small>Clear</small></md-tooltip>\n</md-button>\n');
$templateCache.put('app/common/buttons/zp-delete-button.tmpl.html','<md-button class="md-icon-button" aria-label="{{$ctrl.label}}" ng-disabled="$ctrl.disabled"\n  ng-click="$ctrl.onClick({ev:$event})">\n  <md-icon md-font-icon="zmdi zmdi-delete"></md-icon>\n  <md-tooltip md-direction="down">Delete</md-tooltip>\n</md-button>');
$templateCache.put('app/common/buttons/zp-edit-button.tmpl.html','<md-button class="md-icon-button" label="{{$ctrl.label}}" ng-click="$ctrl.onClick({ev: $event})">\n  <md-icon md-font-icon="zmdi zmdi-edit"></md-icon>\n  <md-tooltip md-direction="down">Edit</md-tooltip>\n</md-button>\n');
$templateCache.put('app/common/buttons/zp-filter-button.tmpl.html','<md-fab-speed-dial md-open="$ctrl.isOpen" md-direction="left" class="md-fling">\n    <md-fab-trigger>\n        <md-button aria-label="{{$ctrl.ariaLabel}}" class="md-fab md-accent">\n            <md-icon md-font-library="material-icons">filter_alt</md-icon>\n        </md-button>\n    </md-fab-trigger>\n\n    <md-fab-actions>\n        <div ng-repeat="button in $ctrl.filterButtons">\n            <md-button aria-label="button.ariaLabel" class="md-fab md-raised md-mini"\n                ng-class="{\'md-accent\' : button.selected}" ng-click="button.action()">\n                <md-tooltip md-direction="left">{{button.name}}</md-tooltip>\n                <md-icon md-font-library="material-icons" style="color: rgba(0,0,0,0.54);">\n                    {{button.icon}}\n                </md-icon>\n            </md-button>\n        </div>\n    </md-fab-actions>\n</md-fab-speed-dial>');
$templateCache.put('app/common/buttons/zp-redact-crm-button.tmpl.html','<md-button class="md-icon-button" ng-disabled="$ctrl.disabled" ng-click="$ctrl.onClick({ev:$event})">\n    <md-icon md-font-library="material-icons">edit_note</md-icon>\n    <md-tooltip md-direction="right"><small>Redact All CRM</small></md-tooltip>\n</md-button>');
$templateCache.put('app/common/buttons/zp-reorder-button.tmpl.html','<md-button class="md-icon-button" ng-class="{\'btn-active\': $ctrl.isActive}" ng-disabled="$ctrl.isDisabled"\n  ng-click="$ctrl.onClick()" md-prevent-menu-close>\n  <md-icon md-font-icon="zmdi zmdi-filter-list"></md-icon>\n  <md-tooltip md-direction="down">\n    Reorder items\n  </md-tooltip>\n</md-button>');
$templateCache.put('app/common/buttons/zp-save-button.tmpl.html','<md-button class="md-icon-button" aria-label="{{$ctrl.label}}" ng-click="$ctrl.save({ev: $event})"\n  ng-class="{\'pulsate-aqua\': $ctrl.isdirty && !$ctrl.disabled, \'md-fab md-fab-bottom-right\': $ctrl.isfab == \'true\', \'md-raised\': $ctrl.israised == \'true\' }"\n  ng-disabled="!$ctrl.isdirty || $ctrl.disabled">\n  <md-progress-circular style="left: -5px; top: -5px;" md-mode="indeterminate" ng-if="$ctrl.isfab && $ctrl.disabled"\n    class="md-accent"></md-progress-circular>\n  <md-icon md-font-icon="zmdi zmdi-save" ng-class="{\'zuantTitanium1\': $ctrl.israised == \'true\'}"></md-icon>\n  <md-tooltip md-direction="down">Save changes</md-tooltip>\n</md-button>');
$templateCache.put('app/common/buttons/zp-toggle-JSON-button.tmpl.html','<md-button ng-click="$ctrl.showJson = !$ctrl.showJson" ng-class="{\'md-raised\' : $ctrl.showJson}" class="md-icon-button" permission permission-only="\'TRUMP\'">\n  <ng-md-icon\n    icon="{{ showJson ? \'visibility\' : \'visibility_off\'}}"\n    size="24">\n  </ng-md-icon>\n  <md-tooltip>\n    {{ $ctrl.showJson ? \'hide JSON\' : \'show JSON\'}}\n  </md-tooltip>\n</md-button>\n');
$templateCache.put('app/common/buttons/zp-unarchive-button.tmpl.html','<md-button class="md-icon-button" aria-label="{{$ctrl.label}}" ng-disabled="$ctrl.disabled"\n  ng-click="$ctrl.onClick({ev:$event})">\n  <md-icon md-font-library="material-icons">\n    unarchive\n  </md-icon>\n  <md-tooltip md-direction="down">Unarchive</md-tooltip>\n</md-button>');
$templateCache.put('app/common/control-widget/zp-widget.tmpl.html','<md-card flex md-ink-ripple>\n  <div layout-padding layout="row" layout-align="space-between center">\n    <div>\n      <md-icon class="icn_4x" md-font-icon="zmdi {{icon}}"></md-icon>\n    </div>\n    <div layout="column" layout-align="center end">\n      <p class="md-body-2 opacity-60 margin-top-0 margin-bottom-0 text-right">Manage Archived Users</p>\n    </div>\n  </div>\n</md-card>\n');
$templateCache.put('app/common/count-widget/zp-count-widget.tmpl.html','<md-card flex>\n  <div layout-padding layout="row" layout-align="space-between center">\n    <div flex="15">\n      <md-icon class="icn_4x" md-font-icon="zmdi {{$ctrl.icon}}"></md-icon>\n    </div>\n\n    <md-progress-circular flex="85" ng-if="$ctrl.loading" class="md-accent"\n      md-mode="indeterminate"></md-progress-circular>\n\n    <div ng-if="!$ctrl.loading" flex="85" layout="column" layout-align="center end">\n      <p class="md-display-1 font-weight-100 margin-top-0 margin-bottom-0 text-ellipsis zuantTitanium1"\n        countupto="$ctrl.count" decimals="0" duration=".5"></p>\n      <p class="md-caption opacity-60 margin-top-0 margin-bottom-0 text-right"\n        style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden; width: 100%;">{{$ctrl.label}}</p>\n    </div>\n  </div>\n</md-card>');
$templateCache.put('app/common/dev-helper/dev-helper.tmpl.html','<div layout="column" layout-padding>\n  <h2 style="font-weight:300;" class="margin-bottom-0 padding-bottom-0">Zuant Admin/Dev Tools</h2>\n  <p>Don\'t panic, only Zuant peeps can see this tab!</p>\n  <a permission permission-only="$ctrl.permissions.liteFeatures.data.admin" href="{{$ctrl.MONITOR_URL}}" target="_blank" flex>\n    <md-button class=" monitor md-accent md-raised md-block" flex="100" layout-fill>\n      Open Monitor App\n      <md-icon md-font-icon="zmdi zmdi-chart"></md-icon>\n    </md-button>\n  </a>\n</div>\n<div>\n  <md-subheader class="md-no-sticky">Toggle Developer Mode</md-subheader>\n  <div layout-padding>\n    <md-switch class="md-primary" ng-model="$ctrl.EnvService.isDev" style="margin-top: 0;">\n      <md-tooltip md-direction="left">\n          Toggle to turn on or off dev mode\n      </md-tooltip>\n    </md-switch>\n  </div>\n</div>\n<md-list class="md-dense">\n  <md-subheader class="md-no-sticky">Account Info</md-subheader>\n  <md-list-item class="md-2-line">\n    <md-icon md-font-icon="zmdi zmdi-globe"></md-icon>\n    <div class="md-list-item-text">\n      <h3>Database: {{ $ctrl.session.getUserData().databasename }}</h3>\n    </div>\n  </md-list-item>\n  <md-list-item class="md-2-line">\n    <md-icon md-font-icon="{{ $ctrl.session.getUserData().gdprEnabled ? \'zmdi zmdi-check\' : \'zmdi zmdi-close\' }}"></md-icon>\n    <div class="md-list-item-text">\n      <h3 ng-show="$ctrl.session.getUserData().gdprEnabled">GDPR is enabled</h3>\n      <h3 ng-show="!$ctrl.session.getUserData().gdprEnabled">GDPR is not enabled</h3>\n    </div>\n  </md-list-item>\n  <md-divider></md-divider>\n  <div layout-padding>\n    <p>Be aware that the below permissions reflect the account you logged in to (likely Marketpoint) and so won\'t show correct reflection of account unless you logged in as a user to that account</p>\n  </div>\n  <md-subheader class="md-no-sticky">Bolt-ons</md-subheader>\n  <md-list-item class="md-2-line">\n    <md-icon md-font-icon="{{$ctrl.session.getUserData().accountPermissions.boltOns.formManagement.enabled ? \'zmdi zmdi-check\' : \'zmdi zmdi-close\'}}"></md-icon>\n    <div class="md-list-item-text">\n      <h3>Form management</h3>\n      <!-- <p ng-show="{{$ctrl.session.getUserData().accountPermissions.boltOns.formManagement.enabled}}">enabled</p>\n        <p ng-show="{{!$ctrl.session.getUserData().accountPermissions.boltOns.formManagement.enabled}}">disabled</p> -->\n    </div>\n  </md-list-item>\n  <md-list-item class="md-2-line">\n    <md-icon md-font-icon="{{$ctrl.session.getUserData().accountPermissions.boltOns.ocr.enabled ? \'zmdi zmdi-check\' : \'zmdi zmdi-close\'}}"></md-icon>\n    <div class="md-list-item-text">\n      <h3>OCR</h3>\n      <!-- <p ng-show="{{$ctrl.session.getUserData().accountPermissions.boltOns.ocr.enabled}}">enabled</p>\n        <p ng-show="{{!$ctrl.session.getUserData().accountPermissions.boltOns.ocr.enabled}}">disabled</p> -->\n    </div>\n  </md-list-item>\n  <md-list-item class="md-2-line">\n    <md-icon md-font-icon="{{$ctrl.session.getUserData().accountPermissions.boltOns.emails.enabled ? \'zmdi zmdi-check\' : \'zmdi zmdi-close\'}}"></md-icon>\n    <div class="md-list-item-text">\n      <h3>Emails</h3>\n      <!-- <p ng-show="{{$ctrl.session.getUserData().accountPermissions.boltOns.emails.enabled}}">enabled</p>\n        <p ng-show="{{!$ctrl.session.getUserData().accountPermissions.boltOns.emails.enabled}}">disabled</p> -->\n    </div>\n  </md-list-item>\n  <md-list-item class="md-2-line">\n    <md-icon md-font-icon="{{$ctrl.session.getUserData().accountPermissions.boltOns.showroom.enabled ? \'zmdi zmdi-check\' : \'zmdi zmdi-close\'}}"></md-icon>\n    <div class="md-list-item-text">\n      <h3>Showroom</h3>\n      <!-- <p ng-show="{{$ctrl.session.getUserData().accountPermissions.boltOns.showroom.enabled}}">enabled</p>\n        <p ng-show="{{!$ctrl.session.getUserData().accountPermissions.boltOns.showroom.enabled}}">disabled</p> -->\n    </div>\n  </md-list-item>\n  <md-list-item class="md-2-line">\n    <md-icon md-font-icon="{{$ctrl.session.getUserData().accountPermissions.boltOns.customSkins.enabled ? \'zmdi zmdi-check\' : \'zmdi zmdi-close\'}}"></md-icon>\n    <div class="md-list-item-text">\n      <h3>Custom Skins</h3>\n      <!-- <p ng-show="{{$ctrl.session.getUserData().accountPermissions.boltOns.customSkins.enabled}}">enabled</p>\n        <p ng-show="{{!$ctrl.session.getUserData().accountPermissions.boltOns.customSkins.enabled}}">disabled</p> -->\n    </div>\n  </md-list-item>\n\n  <md-list-item class="md-2-line">\n    <md-icon md-font-icon="{{$ctrl.session.getUserData().accountPermissions.boltOns.integration.enabled ? \'zmdi zmdi-check\' : \'zmdi zmdi-close\'}}"></md-icon>\n    <div class="md-list-item-text">\n      <h3>Integration</h3>\n      <!-- <p ng-show="{{$ctrl.session.getUserData().accountPermissions.boltOns.customSkins.enabled}}">enabled</p>\n        <p ng-show="{{!$ctrl.session.getUserData().accountPermissions.boltOns.customSkins.enabled}}">disabled</p> -->\n    </div>\n  </md-list-item>\n\n  <md-divider></md-divider>\n\n  <md-subheader class="md-no-sticky">Lite features</md-subheader>\n  <md-list-item class="md-2-line">\n    <md-icon md-font-icon="{{$ctrl.session.getUserData().accountPermissions.liteFeatures.users.enabled ? \'zmdi zmdi-check\' : \'zmdi zmdi-close\'}}"></md-icon>\n    <div class="md-list-item-text">\n      <h3>Users</h3>\n      <!-- <p ng-show="{{$ctrl.session.getUserData().accountPermissions.liteFeatures.users.enabled}}">enabled</p>\n        <p ng-show="{{!$ctrl.session.getUserData().accountPermissions.liteFeatures.users.enabled}}">disabled</p> -->\n    </div>\n  </md-list-item>\n  <md-list-item class="md-2-line">\n    <md-icon md-font-icon="{{$ctrl.session.getUserData().accountPermissions.liteFeatures.forms.enabled ? \'zmdi zmdi-check\' : \'zmdi zmdi-close\'}}"></md-icon>\n    <div class="md-list-item-text">\n      <h3>Forms</h3>\n      <!-- <p ng-show="{{$ctrl.session.getUserData().accountPermissions.liteFeatures.forms.enabled}}">enabled</p>\n        <p ng-show="{{!$ctrl.session.getUserData().accountPermissions.liteFeatures.forms.enabled}}">disabled</p> -->\n    </div>\n  </md-list-item>\n  <md-list-item class="md-2-line">\n    <md-icon md-font-icon="{{$ctrl.session.getUserData().accountPermissions.liteFeatures.leadManagement.enabled ? \'zmdi zmdi-check\' : \'zmdi zmdi-close\'}}"></md-icon>\n    <div class="md-list-item-text">\n      <h3>Lead Management</h3>\n      <!-- <p ng-show="{{$ctrl.session.getUserData().accountPermissions.liteFeatures.leadManagement.enabled}}">enabled</p>\n        <p ng-show="{{!$ctrl.session.getUserData().accountPermissions.liteFeatures.leadManagement.enabled}}">disabled</p> -->\n    </div>\n  </md-list-item>\n  <md-list-item class="md-2-line">\n    <md-icon md-font-icon="{{$ctrl.session.getUserData().accountPermissions.liteFeatures.pickAWinner.enabled ? \'zmdi zmdi-check\' : \'zmdi zmdi-close\'}}"></md-icon>\n    <div class="md-list-item-text">\n      <h3>Pick a Winner</h3>\n      <!-- <p ng-show="{{$ctrl.session.getUserData().accountPermissions.liteFeatures.pickAWinner.enabled}}">enabled</p>\n        <p ng-show="{{!$ctrl.session.getUserData().accountPermissions.liteFeatures.pickAWinners.enabled}}">disabled</p> -->\n    </div>\n  </md-list-item>\n  <md-list-item class="md-2-line">\n    <md-icon md-font-icon="{{$ctrl.session.getUserData().accountPermissions.liteFeatures.data.enabled ? \'zmdi zmdi-check\' : \'zmdi zmdi-close\'}}"></md-icon>\n    <div class="md-list-item-text">\n      <h3>Data</h3>\n      <!-- <p ng-show="{{$ctrl.session.getUserData().accountPermissions.liteFeatures.data.enabled}}">enabled</p>\n        <p ng-show="{{!$ctrl.session.getUserData().accountPermissions.liteFeatures.data.enabled}}">disabled</p> -->\n    </div>\n  </md-list-item>\n  <md-divider></md-divider>\n  <md-subheader>User Permissions</md-subheader>\n  <md-list-item class="md-2-line">\n    <div class="md-list-item-text">\n      {{ $ctrl.session.getUserData().permissions | json }}\n    </div>\n  </md-list-item>\n\n</md-list>\n\n<md-divider></md-divider>\n\n<div layout-padding>\n  <h4>Log tags</h4>\n  <p>Here you can add tags to log entries. Helpful for debugging when you want to isolate logs for some reason.</p>\n  <div>\n    Your current log tags:\n    <pre>\n      {{$ctrl.devHelperStore.currentLogTags | json}}\n    </pre>\n  </div>\n\n  <div layout="row" flex>\n\n    <md-input-container flex>\n      <label>Log tag</label>\n      <input type="text" placeholder="type a tag in here" ng-model="$ctrl.logTagValue" />\n    </md-input-container>\n\n    <md-button class="md-icon-button" ng-click="$ctrl.pushLogValue()">\n      <md-icon md-font-icon="zmdi zmdi-tag"></md-icon>\n      <md-tooltip>Add log tag</md-tooltip>\n    </md-button>\n    <md-button class="md-icon-button" ng-click="$ctrl.clearLogTags()">\n      <md-icon md-font-icon="zmdi zmdi-tag-close"></md-icon>\n      <md-tooltip>Flush log tags</md-tooltip>\n    </md-button>\n  </div>\n\n</div>\n');
$templateCache.put('app/common/editable-header/zp-editable-header.tmpl.html','<p style=" white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" class="md-header js-value-attr" ng-class="$ctrl.fontClass" ng-show="!$ctrl.showInput" ng-click="$ctrl.showInput = !$ctrl.showInput">{{$ctrl.value}}</p>\n<form name="headerform" ng-submit="$ctrl.done()">\n  <md-input-container ng-show="$ctrl.showInput" class="md-block">\n    <label class="js-label-attr" for="input">{{$ctrl.metadata.title.label}}</label>\n    <input name="input" ng-model="$ctrl.value" ng-required="$ctrl.metadata.title.required"/>\n    <md-icon md-font-icon="zmdi zmdi-check" class="js-done-btn" ng-click="$ctrl.done()"></md-icon>\n    <div ng-messages for="headerform.input.$error" ng-if="$ctrl.metadata.title.required">\n      <div ng-message when="required">\n        <spanThis field is required</span>\n      </div>\n    </div>\n  </md-input-container>\n<input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n');
$templateCache.put('app/common/editor/zp-editable.tmpl.html','<div ng-if="metadata.type == \'Textfield\' || metadata.type == \'textarea\' || metadata.type == \'number\'" ng-click="startEditingTextControl($event, value, metadata)" md-cell class="zp-editable">{{ value }}</div>\n\n<div ng-show="metadata.type == \'Image\'" md-cell class="zp-editable"><md-icon md-font-icon="zmdi zmdi-camera" ng-click="displayImage($event, value)" ng-if="value"></md-icon></div>\n<!-- <div ng-if="metadata.type == \'Image\' && value" ng-show="showImageViewer == true" draggable="true" class="image-viewing-panel"><md-icon md-font-icon="zmdi zmdi-close"></md-icon></div> -->\n\n<div ng-if="(metadata.type == \'ChoiceView\' || metadata.type == \'Tableview\' || metadata.type == \'Lookup\') && metadata.allowMultiple == false" md-cell>\n  <md-select ng-model="value" aria-label="{{metadata.databasefieldname}} select" md-on-open="mdOpening(value, metadata.customListId)" md-on-close="selectValueChange(metadata, value)" data-md-container-class="selectdemoSelectHeader" ng-change="selectValueChange(metadata, value)">\n    <md-select-header class="demo-select-header">\n      <input ng-keydown="$event.stopPropagation()" ng-model="searchTermSingle" type="search" placeholder="Filter answers" class="demo-header-searchbox md-text">\n      <md-button ng-click="value = \'\'"><small>clear</small></md-button>\n    </md-select-header>\n    <md-optgroup>\n      <md-option ng-value="answer.caption" ng-repeat="answer in metadata.answers | filter:searchTermSingle">{{answer.caption}}</md-option>\n    </md-optgroup>\n  </md-select>\n</div>\n\n<div ng-if="(metadata.type == \'ChoiceView\' || metadata.type == \'Tableview\' || metadata.type == \'Lookup\') && metadata.allowMultiple" md-cell>\n  <md-select ng-model="value"  aria-label="{{metadata.databasefieldname}} select" md-on-open="mdOpening(value, metadata.customListId)" md-on-close="selectValueChange(metadata, value)" data-md-container-class="selectdemoSelectHeader" multiple>\n    <md-select-header class="demo-select-header">\n      <input ng-keydown="$event.stopPropagation()" ng-model="searchTermMulti" type="search" placeholder="Filter answers" class="demo-header-searchbox md-text">\n      <md-button ng-click="value = \'\'"><small>clear</small></md-button>\n    </md-select-header>\n    <md-optgroup>\n      <md-option ng-value="answer.caption" ng-repeat="answer in metadata.answers | filter:searchTermMulti">{{answer.caption}}\n    </md-option>\n    </md-optgroup>\n  </md-select>\n</div>\n');
$templateCache.put('app/common/editor/zp-value.tmpl.html','<div zp-editable></div>\n');
$templateCache.put('app/common/fab/zp-fab-add.tmpl.html','<md-button class="md-fab" aria-label="{{$ctrl.ariaLabel}}" ng-click="$ctrl.add($event)"\n  ng-class="{\'pulsate-aqua\': $ctrl.pulseClassCheck, \'md-fab-bottom-right\': $ctrl.defaultPosition === \'bottom-right\'}">\n  <md-icon md-font-icon="zmdi zmdi-plus"></md-icon>\n</md-button>');
$templateCache.put('app/common/logo-component/logo.component.html','<md-card>\n  <md-card-header>\n    <md-card-header-text>\n      <span class="md-title">Account logo</span>\n      <span class="md-subhead">As featured in the Zuant app</span>\n    </md-card-header-text>\n  </md-card-header>\n\n  <md-card-content style="text-align: center;"> <!-- quick fix to center the image! -->\n    <!-- preview of current logo image -->\n    <img ng-src="{{ vm.workingLogoObj.src }}" id="currentLogo" image-size-checker\n      trigger-size-alert="vm.triggerSizeAlert" class="md-card-image" alt="Account logo" />\n\n    <md-progress-linear\n      ng-if="vm.workingLogoObj.metadata.progress && vm.workingLogoObj.metadata.progress > 0 && vm.workingLogoObj.metadata.progress < 100"\n      class="margin-top-10" md-mode="determinate"\n      value="{{ vm.workingLogoObj.metadata.progress }}"></md-progress-linear>\n\n\n    <div layout="column" layout-align="center center" ng-if="vm.workingLogoObj.metadata.source === \'uploaded\'">\n      <span class="md-subhead">width: {{vm.workingLogoObj.metadata.imageWidth}}px</span>\n      <span class="md-subhead">height: {{vm.workingLogoObj.metadata.imageHeight}}px</span>\n    </div>\n  </md-card-content>\n\n  <md-card-actions layout="row" layout-align="end center">\n    <md-button ng-click="vm.onClearLogo($event)"\n      ng-if="vm.workingLogoObj.metadata.source === \'uploaded\'">CLEAR</md-button>\n\n    <md-button ng-click="vm.openFileSelector()">\n      {{vm.workingLogoObj.metadata.source === \'uploaded\' ? \'CHANGE LOGO\' : \'ADD\n      LOGO\'}}\n    </md-button>\n\n    <input id="imageUploadInput" type="file" ng-upload-change="vm.fileChanged($event)"\n      accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*" style="display:none;">\n\n    <md-button ng-if="vm.workingLogoObj.binary" ng-click="vm.saveLogoImage()" class="md-primary"\n      ng-disabled="vm.btnDisabled">SAVE</md-button>\n  </md-card-actions>\n\n</md-card>');
$templateCache.put('app/common/menus/zp-context-menu.tmpl.html','<md-menu>\n\n  <md-button aria-label="Context menu" class="md-icon-button" ng-click="$ctrl.openMenu($mdOpenMenu, $event)">\n\n    <md-icon md-font-icon="zmdi zmdi-more-vert">\n    </md-icon>\n    <md-tooltip md-direction="down">\n      more\n    </md-tooltip>\n\n  </md-button>\n\n  <md-menu-content width="{{ $ctrl.menuWidth }}">\n\n    <md-menu-item ng-repeat="option in $ctrl.menuOptions" ng-if="option.visible === undefined || option.visible"\n      permission permission-only="option.permissions">\n\n      <md-button ng-disabled="option.disabled" ng-click="$ctrl.onMenuItemClick({action: option.onClick, ev: $event})"\n        aria-label="{{ option.ariaLabel }}">\n\n        <md-icon ng-if="option.icon" md-font-icon="{{ option.icon() }}">\n        </md-icon>\n        {{ option.label() }}\n\n      </md-button>\n\n    </md-menu-item>\n\n  </md-menu-content>\n\n</md-menu>');
$templateCache.put('app/common/otp/otp.component.tmpl.html','<div class="input-code">\n    <input autofocus type="tel" id="otp-input-1" class="otp-number-input" maxlength="1" autocomplete="off"\n        ng-paste="$ctrl.handlePaste($event)" ng-model="$ctrl.otp1Value" ng-change="$ctrl.otpChanged($event)"\n        numbers-only invalid="$ctrl.invalid" move-next-on-max>\n\n    <input type="tel" id="otp-input-2" class="otp-number-input" maxlength="1" autocomplete="off"\n        ng-model="$ctrl.otp2Value" ng-change="$ctrl.otpChanged($event)" numbers-only invalid="$ctrl.invalid"\n        move-next-on-max>\n\n    <input type="tel" id="otp-input-3" class="otp-number-input" maxlength="1" autocomplete="off"\n        ng-model="$ctrl.otp3Value" ng-change="$ctrl.otpChanged($event)" numbers-only invalid="$ctrl.invalid"\n        move-next-on-max>\n\n    <input type="tel" id="otp-input-4" class="otp-number-input" maxlength="1" autocomplete="off"\n        ng-model="$ctrl.otp4Value" ng-change="$ctrl.otpChanged($event)" numbers-only invalid="$ctrl.invalid"\n        move-next-on-max>\n\n    <input type="tel" id="otp-input-5" class="otp-number-input" maxlength="1" autocomplete="off"\n        ng-model="$ctrl.otp5Value" ng-change="$ctrl.otpChanged($event)" numbers-only invalid="$ctrl.invalid"\n        move-next-on-max>\n\n    <input type="tel" id="otp-input-6" class="otp-number-input" maxlength="1" autocomplete="off"\n        ng-model="$ctrl.otp6Value" ng-change="$ctrl.otpChanged($event)" numbers-only invalid="$ctrl.invalid"\n        move-next-on-max lastinput="true">\n</div>\n<p ng-if="$ctrl.invalid && $ctrl.error" class="zuantSaffron margin-top-0 margin-bottom-20">\n    Error: {{$ctrl.error}}\n</p>');
$templateCache.put('app/common/reorder/consent-tokens-reorder.tmpl.html','<md-list ng-cloak ui-sortable="$ctrl.sortableConfig" ng-model="$ctrl.items" layout-padding>\n  <md-list-item class="secondary-button-padding list-item" ng-repeat="item in $ctrl.items">\n    <p class="md-subhead">{{ item.token }}</p>\n    <div class="md-icon-button list-item-handle">\n      <md-icon md-font-icon="zmdi zmdi-blur"></md-icon>\n    </div>\n    <md-divider></md-divider>\n  </md-list-item>\n</md-list>\n');
$templateCache.put('app/common/reorder/reorder-columns.tmpl.html','<md-list id="column-list" ui-sortable="$ctrl.sortableConfig" ng-model="$ctrl.items">\n    <md-list-item class="list-item column-list-item" ng-repeat="item in $ctrl.items">\n      <p>{{ item.label }}</p>\n      <div class="md-icon-button list-item-handle">\n        <md-icon md-font-icon="zmdi zmdi-blur"></md-icon>\n      </div>\n      <md-divider></md-divider>\n    </md-list-item>\n</md-list>\n');
$templateCache.put('app/common/reorder/reorder.tmpl.html','<md-list ng-cloak ui-sortable="$ctrl.sortableConfig" ng-model="$ctrl.items" layout-padding>\n  <md-list-item class="secondary-button-padding list-item" ng-repeat="item in $ctrl.items ">\n    <p>{{item[$ctrl.metadata.columnsData.primaryIdentifier.object].caption.raw}}</p>\n    <div class="md-icon-button list-item-handle">\n      <md-icon md-font-icon="zmdi zmdi-blur"></md-icon>\n    </div>\n    <md-divider></md-divider>\n  </md-list-item>\n</md-list>\n');
$templateCache.put('app/common/reorder/report-builder-reorder.tmpl.html','<md-list ng-cloak ui-sortable="$ctrl.sortableConfig" layout-padding>\n  <md-subheader class="md-no-sticky"></md-subheader>\n\n  <md-list-item class="md-3-line animate-repeat" ng-repeat-start="item in $ctrl.items">\n    <div class="md-list-item-text" layout="column">\n    <p class="md-body-2"><ng-md-icon icon="{{item.metadata.icon}}" style="fill: #949ca1;" size="20"></ng-md-icon> <span class="">{{ item.title }}</span></p>\n    </div>\n    <md-button class="md-secondary md-icon-button" ng-click="$ctrl.removeWidgetFromReportingArray(item, \'headlineWidgets\')" aria-label="remove widget from report">\n      <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      <md-tooltip md-direction="left">Remove from report</md-tooltip>\n    </md-button>\n  </md-list-item>\n  <md-divider ng-repeat-end></md-divider>\n</md-list>\n');
$templateCache.put('app/common/send-tye-trigger-checker/tmpl.html','<p layout-padding>\n  <md-icon md-font-icon="zmdi zmdi-alert-triangle" ng-style="{ color: \'#f26529\'}" ng-show="!$ctrl.factoryData.valid"></md-icon>\n  <md-icon md-font-icon="zmdi zmdi-check-circle" ng-style="{ color: \'#78cdd1\'}" ng-show="$ctrl.factoryData.valid"></md-icon>\n  {{$ctrl.factoryData.status}}\n</p>\n<p layout-padding ng-show="!$ctrl.factoryData.valid && !$ctrl.factoryData.effectedForms.length">\n  Forms will currently not send TYE\n</p>\n\n<md-list class="md-dense" ng-if="$ctrl.factoryData.effectedForms.length">\n  <md-subheader class="md-no-sticky">{{$ctrl.factoryData.effectedForms.length}} forms will not send TYE</md-subheader>\n  <md-list-item class="md-3-line" ng-repeat="item in $ctrl.factoryData.effectedForms">\n    <div ng-bind-html="item.icon" class="md-avatar"></div>\n    <div class="md-list-item-text" layout="column">\n      <h3>Form: {{ item.formname }}</h3>\n      <h4>Startdate: {{ item.startdate | date: \'mediumDate\' }}</h4>\n      <h4>Email template: {{ item.emailTemplate }}</h4>\n    </div>\n    <md-divider></md-divider>\n  </md-list-item>\n\n</md-list>\n\n<div layout="column" layout-align="stretch" ng-if="$ctrl.factoryData.effectedForms.length">\n  <md-button class="md-primary md-raised" ng-click="$ctrl.goToConsentSettings()">Manage consent settings</md-button>\n</div>\n');
$templateCache.put('app/common/sidenav/zp-sidenav.tmpl.html','<div class="zp-app-settings">\n  <md-content>\n    <md-tabs md-dynamic-height md-border-bottom md-stretch-tabs="always">\n\n      <md-tab>\n        <md-tab-label>\n          <md-icon md-font-icon="zmdi zmdi-notifications"></md-icon>\n        </md-tab-label>\n        <md-tab-body layout-padding layout-fill>\n          <zp-send-t-y-e-checker></zp-send-t-y-e-checker>\n        </md-tab-body>\n      </md-tab>\n\n      <md-tab permission permission-only="\'ZUANT_ADMIN\'">\n        <md-tab-label>\n          <md-icon md-font-icon="zmdi zmdi-bug"></md-icon>\n        </md-tab-label>\n        <md-tab-body>\n          <zp-dev-helper></zp-dev-helper>\n        </md-tab-body>\n      </md-tab>\n\n    </md-tabs>\n  </md-content>\n</div>\n');
$templateCache.put('app/common/tab-navbar-component/zp-tab-navbar.tmpl.html','<md-nav-bar md-selected-nav-item="$ctrl.activeTabName" nav-bar-aria-label="navigation links">\n  <md-nav-item ng-repeat="item in $ctrl.stateParams.items" permission permission-sref="item.state"\n    md-nav-sref="{{item.state}}" sref-opts="{ custom: { isDirtyCheck: 1} }" name="{{item.name}}">{{item.label}}\n    <zp-new-badge ng-if="item.showNewBadge">\n    </zp-new-badge>\n  </md-nav-item>\n</md-nav-bar>');
$templateCache.put('app/common/tables/zp-data-grid.tmpl.html','<md-table-container id="tableContainer" class="tableContainer">\n\n  <table class="md-table" style="overflow-x:visible ;" zp-keyboard-navigatable\n    zp-interactive="{{$ctrl.options.interactive}}" zp-contextmenu>\n\n    <!-- table header  //-->\n    <thead class="md-head" fix-head>\n\n      <tr class="md-row" md-row>\n\n        <th class="md-column md-checkbox-column" ng-if="$ctrl.rowCheckboxes">\n\n          <md-checkbox aria-label="all rows selection checkbox" ng-click="$ctrl.toggleAllRowsSelected($event)"\n            ng-checked="$ctrl.data.allItemsSelected" md-indeterminate="$ctrl.selectAllIsIndeterminate()">\n          </md-checkbox>\n\n        </th>\n\n        <th class="md-column" ng-class="$ctrl.isColumnActive(mdata.object, mdata.databasefieldname)"\n          ng-click="$ctrl.logOrder(mdata)" ng-repeat="mdata in $ctrl.metadata.columnsData.items" ng-if="mdata.showCol">\n\n          <md-icon md-svg-icon="arrow-up.svg" ng-show="$ctrl.isColumnActive(mdata.object, mdata.databasefieldname)"\n            class="md-sort-icon" ng-class="$ctrl.getSortDirection()">\n          </md-icon>\n\n          <span ng-class="{\'required-field-col-header-label\' : mdata.validation.required}">\n            {{mdata.label}}\n          </span>\n\n          <md-icon class="hidden-field" md-font-icon="zmdi zmdi-eye-off" ng-if="mdata.hiddenInForm">\n\n            <md-tooltip md-direction="top">hidden field</md-tooltip>\n\n          </md-icon>\n\n        </th>\n\n      </tr>\n\n    </thead>\n    <!-- table body  //-->\n    <tbody class="md-body" zp-cell-interaction>\n\n      <tr>\n\n        <md-progress-linear class="md-accent" ng-show="$ctrl.loadingIndicator" md-mode="indeterminate">\n        </md-progress-linear>\n\n      </tr>\n\n      <tr\n        ng-repeat="item in $ctrl.data.items | filter: $ctrl.searchValue | orderBy: $ctrl.query.order.expression:$ctrl.query.order.reverse | limitTo: $ctrl.query.limit: ($ctrl.query.page - 1) * $ctrl.query.limit track by $ctrl.ngRepeatTrackingFunction(item, $index)"\n        class="md-row" ng-class="{ \'row-selected\' : item.selected, \'row-dirty\': item.dirty }"\n        ng-init="$rowIndex = $index" ng-if="!item.archived"\n        ng-click="$ctrl.rowClick({ev: $event, rowid: item[$ctrl.metadata.columnsData.primaryIdentifier.object][$ctrl.metadata.columnsData.primaryIdentifier.field], item: item })">\n\n        <td class="md-cell" ng-if="$ctrl.rowCheckboxes">\n\n          <md-checkbox aria-label="row selection checkbox" ng-click="$ctrl.toggleRowSelected(item)"\n            ng-model="item.selected">\n          </md-checkbox>\n\n        </td>\n\n        <td ng-repeat="mdata in $ctrl.metadata.columnsData.items" layout-align="center center"\n          class="md-cell highlight-on-hover_no"\n          ng-class="{\'readOnly\': !mdata.editable, \'row-invalid\' : $ctrl.data.validation[item.response._id].errors[mdata.object + \'_\' + mdata.databasefieldname]}"\n          zp-row-id="{{item[$ctrl.metadata.columnsData.primaryIdentifier.object]._id}}"\n          zp-column-id="{{mdata.object}}_{{mdata.databasefieldname}}" zp-widget-id="{{$ctrl.widgetId}}"\n          ng-click="$ctrl.cellClicked(item, mdata, $event)" ng-mousedown="$ctrl.mouseDown(item, mdata, $event)"\n          ng-if="mdata.showCol">\n\n          <div ng-switch on="mdata.type">\n\n            <div ng-switch-when="Textfield|Textview" ng-switch-when-separator="|">\n\n              <span ng-if="$ctrl._.has(item, [mdata.object, mdata.databasefieldname, \'filtered\'])"\n                ng-bind-template="{{item[mdata.object][mdata.databasefieldname].filtered}}">\n              </span>\n\n              <span\n                ng-if="$ctrl._.has(item, [mdata.object, mdata.databasefieldname]) && !$ctrl._.has(item, [mdata.object, mdata.databasefieldname, \'filtered\'])"\n                ng-bind-template="{{item[mdata.object][mdata.databasefieldname]}}">\n              </span>\n\n            </div>\n\n            <zp-lead-status-btn ng-switch-when="IntegrationStatus" response-id="item.response._id">\n            </zp-lead-status-btn>\n\n            <span ng-switch-default bind-html-compile="item[mdata.object][mdata.databasefieldname].filtered">\n            </span>\n\n          </div>\n\n        </td>\n\n      </tr>\n\n    </tbody>\n\n  </table>\n\n</md-table-container>');
$templateCache.put('app/common/user-helpers/zp-blank-slate-helper-arrow.tmpl.html','<div ng-if="showCondition" class="blank-slate" layout="column" layout-align="end end" ng-cloak>\n  <md-card show-lg hide-xs hide-gt-xs flex layout="column" layout-padding class="md-whiteframe-5dp blank-slate-body">\n    <p class="md-headline">{{helpMessage}}</p>\n  </md-card>\n  <div hide-lg flex layout="column" layout-padding class="blank-slate-body">\n    <p class="md-headline">{{helpMessage}}</p>\n  </div>\n  <div class="blank-slate-arrow">\n    <div ng-include src="bendyArrowImageSvg"></div>\n  </div>\n</div>');
$templateCache.put('app/common/user-preferences/zp-user-preferences.tmpl.html','<div layout-padding>\n  <h2>Settings</h2>\n  <div ng-repeat="mdata in settingsMetadata.settings">\n\n    <span ng-show="mdata.visible">\n      <div layout="row">\n        {{mdata.label}}\n      </div>\n\n      <div layout="row" zp-metadata="mdata" zp-item="settingsData.settings" zp-key="\'settings\'" zp-index="$index" zp-data="settingsData.settings[mdata.name]" ng-class="{\'md-placeholder\': !settingsData.settings[mdata.name]}" zp-value zp-on-change="set(key, value)">\n      </div>\n    </span>\n  </div>\n');
$templateCache.put('app/common/zam-helper/zam-helper.tmpl.html','<md-card layout-padding ng-show="$ctrl.data.activityLog.length">\n  <md-list class="md-dense" flex>\n    <md-subheader class="md-no-sticky">Accounts added by you this session</md-subheader>\n    <md-list-item class="md-3-line" ng-repeat="activity in $ctrl.data.activityLog">\n      <!-- <img ng-src="{{item.face}}?{{$index}}" class="md-avatar" alt="{{item.who}}" /> -->\n      <div class="md-list-item-text" layout="column">\n        <h3>Account name: {{activity.companyname}}</h3>\n        <p>Time added: {{activity.timeadded | date: \'short\'}}</p>\n      </div>\n    </md-list-item>\n    <md-divider></md-divider>\n  </md-list>\n\n\n</md-card>\n');
$templateCache.put('app/dashboard/dashboard-page-component/dashboard.tmpl.html','<div layout-fill layout="row" layout-align="center center" id="dashboardWrapper">\n  <md-progress-circular md-mode="indeterminate" ng-if="$ctrl.loading"></md-progress-circular>\n  <div id="dashboard" ng-if="!$ctrl.loading" ng-class="{\'imageBg\': !$ctrl.loading}" layout-fill class="animated fadeIn"\n    ng-style="$ctrl.customSkinStyling" layout="row">\n    <div flex="100" layout="column" layout-align="center stretch" layout-padding ng-style="$ctrl.containerStyling"\n      ng-cloak>\n\n      <div layout-padding layout-margin layout="row" layout-align="center">\n        <!--Have had to add in style hack to work with default logo when using firefox!-->\n        <div class="dashboardLogo backdrop-blur" ng-style="$ctrl.useDefaultLogo && {\'width\':\'100%\'}">\n          <img ng-src="{{$ctrl.clientLogoImage}}" />\n        </div>\n      </div>\n\n      <div layout="row" layout-align="center">\n        <zp-account-selection class="backdrop-blur"></zp-account-selection>\n      </div>\n\n      <div ng-if="$ctrl.showGreeting">\n        <p class="md-display-1 white-font margin-bottom-10 margin-top-10 text-align-center">{{$ctrl.userGreeting}}</p>\n      </div>\n\n      <div class="white-font" layout="column" layout-align="center center">\n\n        <span ng-if="$ctrl.clientDoc.clientArchived && !$ctrl.clientDoc.clientOperationStatus">\n          <md-icon md-font-icon="zmdi zmdi-alert-triangle zuantPollen"></md-icon>\n          <span permission permission-except="\'SUPER_ZAM\'">\n            This client is currently archived, please ask an administrator to re-activate the account.\n          </span>\n          <span permission permission-only="\'SUPER_ZAM\'">\n            This client is currently archived, use the "UNARCHIVE" button located in the "Manage Client Dialog" or\n            "Account Settings Page".\n          </span>\n        </span>\n\n        <ng-container ng-if="$ctrl.clientDoc.clientOperationStatus"\n          ng-switch="$ctrl.clientDoc.clientOperationStatus.operation">\n          <span>\n            <md-icon md-font-icon="zmdi zmdi-info-outline md-primary"></md-icon>\n            <ng-container ng-switch-when="archiveClient">\n              This client currently has an archive operation ongoing, you will be unable to access the account until\n              completion. <span permission permission-only="\'SUPER_ZAM\'"><br>To see progress click on the "ARCHIVE"\n                button\n                located in the "Manage Client Dialog" or "Account Settings Page".</span>\n            </ng-container>\n            <ng-container ng-switch-when="unarchiveClient">\n              This client currently has an unarchive operation ongoing, you will be unable to access the account until\n              completion. <span permission permission-only="\'SUPER_ZAM\'"><br>To see progress click on the "UNARCHIVE"\n                button\n                located in the "Manage Client Dialog" or "Account Settings Page".</span>\n            </ng-container>\n            <ng-container ng-switch-when="deleteClient">\n              This client currently has a deletion operation ongoing, you will be unable to access the account until\n              completion. <span permission permission-only="\'SUPER_ZAM\'"><br>To see progress click on the "DELETE"\n                button\n                located in the "Manage Client Dialog" or "Account Settings Page".</span>\n            </ng-container>\n            <ng-container ng-switch-when="redactAllCRM">\n              This client currently has a redaction operation ongoing, you will be unable to access the account until\n              completion. <span permission permission-only="\'SUPER_ZAM\'"><br>To see progress click on the "REDACT ALL\n                CRM"\n                located button in the "Manage Client Dialog" or "Account Settings Page".</span>\n            </ng-container>\n          </span>\n        </ng-container>\n\n        <span\n          ng-if="$ctrl.clientDoc.clientArchived && !$ctrl.clientDoc.clientOperationStatus && $ctrl.clientDoc.clientRedacted">\n          <md-icon md-font-icon="zmdi zmdi-info-outline md-primary"></md-icon>\n          This client has been redacted.\n        </span>\n\n      </div>\n\n      <div class="scrollable-container" layout="column" layout-align="start stretch">\n        <div class="flex-container" layout="row" layout-wrap layout-align="center start">\n          <div ng-repeat="item in $ctrl.primaryNavItems" permission permission-sref="item.baseState">\n            <div layout-margin>\n              <md-button ng-if="item.sref"\n                ng-disabled="($ctrl.clientDoc.clientArchived || $ctrl.clientDoc.clientOperationStatus) && (item.name !==\'Accounts\' && item.name !==\'Logout\')"\n                ng-click="$ctrl.go(item)"\n                class="md-grid-item-content md-primary {{item.className}} dashboard-btn backdrop-blur color"\n                style="background-color: rgba(255,255,255,.7);">\n                <md-icon ng-if="item.icon" md-font-icon="zmdi {{item.icon}}"></md-icon>\n                <md-icon ng-if="item.svgicon" md-svg-src="{{item.svgicon}}"></md-icon>\n                <div class="md-grid-text"> {{item.name}} </div>\n              </md-button>\n              <md-button ng-if="item.href"\n                ng-disabled="($ctrl.clientDoc.clientArchived || $ctrl.clientDoc.clientOperationStatus) && item.name !==\'Help Hub\'"\n                ng-click="$ctrl.redirect(item.href)"\n                class="md-grid-item-content md-primary {{item.className}} dashboard-btn backdrop-blur color"\n                style="background-color: rgba(255,255,255,.7);">\n                <md-icon ng-if="item.icon" md-font-icon="zmdi {{item.icon}}"></md-icon>\n                <md-icon ng-if="item.svgicon" md-svg-src="{{item.svgicon}}"></md-icon>\n                <div class="md-grid-text"> {{item.name}} </div>\n              </md-button>\n            </div>\n          </div>\n        </div>\n\n        <div class="secondary-items" layout="row" layout-align="center center">\n          <a ng-if="item.href" href="{{item.href}}" ng-repeat="item in $ctrl.secondaryNavItems" target="_blank">\n            <md-button class="md-primary {{item.className}} md-icon-button"\n              style="background-color: rgba(255,255,255,.7);">\n              <md-tooltip>{{ item.name }}</md-tooltip>\n              <md-icon md-font-icon="zmdi {{item.icon}}"></md-icon>\n            </md-button>\n          </a>\n          <md-button ng-if="item.sref" ui-sref="{{item.sref}}" class="md-primary {{item.className}} md-icon-button"\n            style="background-color: rgba(255,255,255,.7);" ng-repeat="item in $ctrl.secondaryNavItems">\n            <md-tooltip>{{ item.name }}</md-tooltip>\n            <md-icon md-font-icon="zmdi {{item.icon}}"></md-icon>\n          </md-button>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</div>');
$templateCache.put('app/data/dashboard/dashboard-main.tmpl.html','<md-content layout-fill layout-align="center start">\n  <div layout="column" layout-align="center stretch">\n    <p class="md-headline data-headline" flex="grow">\n      DATA\n    </p>\n\n    <div flex="grow" layout="row" layout-wrap layout-align="center start">\n      <div ng-repeat="item in $ctrl.items" class="data-dashboard" flex="25" flex-sm="40" flex-xs="50"\n        ng-click="$ctrl.showSubItems(item)">\n        <md-card md-ink-ripple="#bbb" class="card" permission permission-only="item.permission">\n          <div class="md-grid-item-content dashboard-btn">\n            <md-icon md-font-icon="zmdi zmdi-circle"></md-icon><span class="data-label"> {{item.label}}</span>\n            <p class="data-description-text" layout-wrap>\n              {{item.description}}\n            </p>\n          </div>\n        </md-card>\n\n        <md-card ng-show="item.show" class="data-dashboard-subitem-container">\n          <div ng-repeat="subitem in item.items" class="data-dashboard-subitem">\n            <div class="md-grid-item-content dashboard-btn" layout="row" layout-align="start stretch"\n              ui-sref="{{subitem.sref}}" permission permission-only="subitem.permission">\n              <div flex="none" class="zuant-bot">\n                <img ng-src="{{\'/images/pngs/zubots/zubot.png\' | cdnAssets}}">\n              </div>\n              <div flex layout-wrap>\n                <span class="data-label">{{subitem.label}}</span>\n                <div class="data-description-text" ng-bind-html="subitem.description">\n                </div>\n              </div>\n            </div>\n          </div>\n        </md-card>\n      </div>\n\n    </div>\n\n  </div>\n</md-content>');
$templateCache.put('app/data/dialogs/notifications-info.dialog.tmpl.html','<md-dialog aria-label="Notifications Info" flex="80" flex-gt-md="60">\n\n  <md-dialog-content layout-padding>\n    <h1>Notifications</h1>\n    <p>\n      In the future you will be able to select a variety of notification options that will keep you up to date with your Zubot\'s doings. For now you can track their progress in Zubot Mission Control!\n    </p>\n  </md-dialog-content>\n\n  <md-dialog-actions layout="row">\n    <md-button class="md-warn" ng-click="vm.cancelDialog()">Close</md-button>\n  </md-dialog-actions>\n\n</md-dialog>\n');
$templateCache.put('app/data/intro/compliance-erasecontact.tmpl.html','<div>\r\n    <h1>Erase a contact</h1>\r\n    <p>\r\n      Activating this zubot will redact a contact from the database, anonymising all their response information. This will fulfil a GDPR erasure request.\r\n    </p>\r\n    <h2>Steps</h2>\r\n    <ol>\r\n      <li>\r\n        Choose Person: Select a contact from the database using the search tool\r\n      </li>\r\n    </ol>\r\n    <p>\r\n      Click the NEXT button in the bottom right of this panel to proceed.\r\n    </p>\r\n</div>\r\n');
$templateCache.put('app/data/intro/compliance-erasecontactbatch.tmpl.html','<div>\r\n    <h1>Erase a contact batch</h1>\r\n    <p>\r\n      Activating this zubot will redact multiple contacts from the database, anonymising all their response information. This will fulfil a GDPR erasure request.\r\n    </p>\r\n    <h2>Steps</h2>\r\n    <ol>\r\n      <li>\r\n        Choose CSV: Select a single column CSV file of email addresses from your computer that contains all contacts that wish to be removed from the system. The CSV file should not have a header row and only contain email addresses with no other fields.\r\n      </li>\r\n    </ol>\r\n    <p>\r\n      Click the NEXT button in the bottom right of this panel to proceed.\r\n    </p>\r\n</div>\r\n');
$templateCache.put('app/data/intro/compliance-redactall.tmpl.html','<div>\n    <h1>Redact all CRM Data</h1>\n    <p>\n        This zubot systematically hides CRM data within the account, following GDPR standards. The tool eliminates\n        Contact CRM data without associated leads and replaces personally identifiable information (PII) in mapped\n        contact data with the default value "REDACTED" or custom selected value for analytical purposes. It also offers\n        the option to permanently\n        erase images or business cards linked to leads by mapping them to "UNSET". On the next page, you\'ll need to map\n        company, contact, and\n        response fields detected across all forms in the account. Following this, you\'ll be prompted to enter the\n        current database name as a security measure before\n        activating the zubot, ensuring awareness of the impending contact information cleansing.\n    </p>\n    <h2>Steps</h2>\n    <ol>\n        <li>\n            Field Mapping: Map the CRM fields you wish to cleanse.\n        </li>\n        <li>\n            Confirmation: Type the database name into the text input.\n        </li>\n    </ol>\n    <p>\n        Click the NEXT button in the bottom right of this panel to proceed.\n    </p>\n</div>');
$templateCache.put('app/data/intro/compliance-subjectaccessrequest.tmpl.html','<div>\r\n    <h1>Subject Access Request</h1>\r\n    <p>\r\n      Activating this zubot will generate a report for a selected contact held in the database. This will fulfil a GDPR subject access request.\r\n    </p>\r\n    <h2>Steps</h2>\r\n    <ol>\r\n      <li>\r\n        Choose Person: Select a contact from the database using the search tool\r\n      </li>\r\n    </ol>\r\n    <p>\r\n      Click the NEXT button in the bottom right of this panel to proceed.\r\n    </p>\r\n</div>\r\n');
$templateCache.put('app/data/intro/dataload.tmpl.html','<div>\r\n    <h1>Load Data</h1>\r\n    <p>\r\n      Activating this zubot will create company and contact records from a CSV file. The following steps will ask you to select a CSV file from your computer, and then create a set of field mappings to match the database field names to the header row in the CSV file.\r\n    </p>\r\n    <h2>Steps</h2>\r\n    <ol>\r\n      <li>\r\n        Choose CSV: Select a CSV file from your computer\r\n      </li>\r\n      <li>\r\n        Select Form (optional): If you have an event form with specific fields that you need to map to then you can select it to help in the Field Mapping step\r\n      </li>\r\n      <li>\r\n        Choose Field Mapping: If you have selected an event form then the fields from it will be shown and available to map to the CSV fields. Otherwise a generic set of fields will be shown instead. Use the automap field to create new fields.\r\n      </li>\r\n    </ol>\r\n    <p>\r\n      Click the NEXT button in the bottom right of this panel to proceed.\r\n    </p>\r\n</div>\r\n');
$templateCache.put('app/data/intro/housekeeping-prunecrm.tmpl.html','<div>\n    <h1>Prune CRM Data</h1>\n    <p>\n        This zubot removes CRM contacts & companies who have no leads associated with them. This is designed to reduce\n        the size of the database so it only contains contacts and companies directly linked to leads. On the next\n        page you will be required to enter the name of the current database before you will be allowed to activate the\n        zubot. This is a basic security measure to ensure that you are aware that all contact information will be\n        removed.\n    </p>\n    <h2>Steps</h2>\n    <ol>\n        <li>\n            Confirmation: Type the database name into the text input\n        </li>\n    </ol>\n    <p>\n        Click the NEXT button in the bottom right of this panel to proceed.\n    </p>\n</div>');
$templateCache.put('app/data/intro/housekeeping-removecrm.tmpl.html','<div>\r\n    <h1>Remove All CRM Data</h1>\r\n    <p>\r\n      Activating this zubot will remove all contact information from the server and all remote devices. On the next page you will be required to enter the name of the current database before you will be allowed to activate the zubot. This is a basic security measure to ensure that you are aware that all contact information will be removed.\r\n    </p>\r\n    <h2>Steps</h2>\r\n    <ol>\r\n      <li>\r\n        Confirmation: Type the database name into the text input\r\n      </li>\r\n    </ol>\r\n    <p>\r\n      Click the NEXT button in the bottom right of this panel to proceed.\r\n    </p>\r\n</div>\r\n');
$templateCache.put('app/data/intro/housekeeping-removedataload.tmpl.html','<div>\r\n    <h1>Remove a Data Load</h1>\r\n    <p>\r\n      Activating this zubot will remove all information from a selected data load from the server and all remote devices for <b>all contacts that have no leads</b>. On the next page you will be required to search for a data load that will be removed.\r\n    </p>\r\n    <h2>Steps</h2>\r\n    <ol>\r\n      <li>\r\n        Choose Data Load: Search for the data load and select the appropriate one\r\n      </li>\r\n    </ol>\r\n    <p>\r\n      Click the NEXT button in the bottom right of this panel to proceed.\r\n    </p>\r\n</div>\r\n');
$templateCache.put('app/data/intro/postshowmatchup.tmpl.html','<div>\r\n    <h1>Post Show Match-Up</h1>\r\n    <p>\r\n      Activating this zubot will add additional info to existing contact records based on the rules that you provide to match them on. This tool will typically be used when the only information you know about someone is their barcode that they used at an event. Once you have obtained more useful information, like their email address and contact information, you can match them against their barcode. The following steps will ask you to select a CSV file from your computer, and then create a set of field mappings to match the database field names to the header row in the CSV files, as well as the matching rule mapping.\r\n    </p>\r\n    <h2>Steps</h2>\r\n    <ol>\r\n      <li>\r\n        Choose CSV: Select a CSV file from your computer\r\n      </li>\r\n      <li>\r\n        Post-show match-up Rules: Select matching rules for the zubot to use. You can restrict it so that it only fills in the contact info if they have existing responses held against them, or generate missing responses automatically\r\n      </li>\r\n      <li>\r\n        Select Form (optional): Based on your previous selection, you may need to select a form that will be used to help you map the fields from your CSV file\r\n      </li>\r\n      <li>\r\n        Choose Field Mapping: If you have selected an event form then the fields from it will be shown and available to map to the CSV fields. Otherwise a generic set of fields will be shown instead. Use the automap field to create new fields\r\n      </li>\r\n      <li>\r\n        Choose Dedupe Mapping: Create the mapping to use to match the contact info against the existing information held against them in the database. Usually this will be a barcode or email address\r\n      </li>\r\n    </ol>\r\n    <p>\r\n      Click the NEXT button in the bottom right of this panel to proceed.\r\n    </p>\r\n</div>\r\n');
$templateCache.put('app/data/mission-control/load-stats.dialog.tmpl.html','<md-dialog aria-label="load stats dialog" flex="{{::vm.getSize()}}" class="load-stats-dialog">\n\n    <md-toolbar aria-label="Image item dialog toolbar">\n        <div layout="row" class="md-toolbar-tools">\n            <p class="md-subhead">\n                Load Stats\n            </p>\n            <span flex></span>\n            <md-button ng-click="vm.cancelDialog()">\n                <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n            </md-button>\n        </div>\n    </md-toolbar>\n\n    <md-dialog-content layout-padding>\n        <div class="load-stats-container" layout="row" layout-align="center start">\n            <div class="stats-section" ng-class="{ full: vm.stats.counts.dupes.literature === 0 }">\n\n                <div class="header">\n                    <h2>Stats</h2>\n                </div>\n\n                <ul>\n                    <li class="stat-header"><b>Overrided Dedupe Mechanism:</b> <span\n                            class="stat-value">{{vm.stats.overrideDedupe}}</span>\n                    </li>\n\n                    <li><b>Created:</b></li>\n\n                    <li class="stat-header exta-margin first">Literature - <span\n                            class="stat-value">{{vm.stats.counts.created.literature}}</span></li>\n                    <li class="stat-header exta-margin">Blocks - <span\n                            class="stat-value">{{vm.stats.counts.created.blocks}}</span>\n                    </li>\n                    <li class="stat-header exta-margin">Tags - <span\n                            class="stat-value">{{vm.stats.counts.created.tags}}</span></li>\n                    <li class="stat-header exta-margin">Folders - <span\n                            class="stat-value">{{vm.stats.counts.created.folders}}</span></li>\n\n                    <li><b>Updated:</b></li>\n\n                    <li class="stat-header exta-margin first">Literature - <span\n                            class="stat-value">{{vm.stats.counts.updated.literature}}</span></li>\n                    <li class="stat-header exta-margin">Blocks - <span\n                            class="stat-value">{{vm.stats.counts.updated.blocks}}</span>\n                    </li>\n                    <li class="stat-header exta-margin first">Tags - <span\n                            class="stat-value">{{vm.stats.counts.updated.tags}}</span></li>\n                    <li class="stat-header exta-margin first">Folders - <span\n                            class="stat-value">{{vm.stats.counts.updated.folders}}</span></li>\n                    <li><b>Deleted:</b></li>\n\n                    <li class="stat-header exta-margin">Literature - <span\n                            class="stat-value">{{vm.stats.counts.deleted.literature}}</span></li>\n                    <li class="stat-header exta-margin first">Blocks - <span\n                            class="stat-value">{{vm.stats.counts.deleted.blocks}}</span></li>\n                    <li class="stat-header exta-margin">Tags - <span\n                            class="stat-value">{{vm.stats.counts.deleted.tags}}</span></li>\n                    <li class="stat-header exta-margin">Folders - <span\n                            class="stat-value">{{vm.stats.counts.deleted.folders}}</span></li>\n\n                    <div ng-if="vm.stats.counts.dupes.literature === 0">\n                        <li><b>Dupes:</b></li>\n                        <li class="stat-header exta-margin first">Literature - <span\n                                class="stat-value">{{vm.stats.counts.dupes.literature}}</span></li>\n                    </div>\n\n                </ul>\n            </div>\n\n            <div ng-if="vm.stats.counts.dupes.literature > 0" class="vertical-divider"></div>\n\n            <div ng-if="vm.stats.counts.dupes.literature > 0" class="dupes-section" layout="column"\n                layout-align="start center">\n                <div class="header">\n                    <h2>Dupes</h2>\n                    <p>Discovered <b>{{vm.stats.counts.dupes.literature}}</b> literature dupes.</p>\n                </div>\n                <div class="dupes-scroller">\n                    <table>\n                        <tr>\n                            <th>ID</th>\n                            <th>TITLE</th>\n                            <th>URI</th>\n                        </tr>\n                        <tr ng-repeat="dupe in vm.stats.dupes">\n                            <td>{{dupe._id}}</td>\n                            <td>{{dupe.title}}</td>\n                            <td>{{dupe.weburi}}</td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n    </md-dialog-content>\n\n    <md-dialog-actions layout="row">\n        <md-button class="md-warn" ng-click="vm.cancelDialog()">Close</md-button>\n    </md-dialog-actions>\n\n</md-dialog>');
$templateCache.put('app/data/mission-control/mission-control-main.tmpl.html','<zp-title-toolbar></zp-title-toolbar>\n<md-content layout-fill layout-align="center start">\n  <div layout="column" layout-align="center stretch">\n    <p class="md-headline data-headline" flex="grow">\n      ZUBOT MISSION CONTROL\n    </p>\n\n    <div flex="grow" layout="row" layout-wrap layout-align="center start">\n      <table flex class="table table-striped">\n        <tr>\n          <th></th>\n          <th>Name</th>\n          <th>Type</th>\n          <th>Created</th>\n          <th class="hide-xs hide-sm">Finished</th>\n          <th>State</th>\n          <th>Complete Status</th>\n          <th>Information</th>\n          <th class="small-column"></th>\n          <th class="small-column"></th>\n        </tr>\n        <tr ng-repeat="zubot in $ctrl.zubots">\n          <td class="zubot-cell">\n            <zp-zubot height="50px" width="32px" outfit="zubot.outfit"></zp-zubot>\n            <md-icon ng-click="getInfo($event, zubot)" md-font-icon="zmdi zmdi-info" ng-show="hasInfo(zubot)"\n              class="zubot-info"></md-icon>\n          </td>\n          <td>{{zubot.name}}</td>\n          <td>{{getType(zubot.mission.type, zubot.mission.subType)}}</td>\n          <td>{{getDate(zubot.createdOn)}}</td>\n          <td class="hide-xs hide-sm">{{getServerComplete(zubot.milestones)}}</td>\n          <td>{{getStatus(zubot.milestones, zubot.dryrun)}}<md-icon ng-if="zubot.dryrun" md-font-icon="zmdi zmdi-help"\n              class="dryrun"></md-icon>\n          </td>\n          <td>{{getPercentageComplete(zubot)}}</td>\n          <td compile="getControlInfo(zubot.mission.type, zubot.mission.subType, zubot.controlInfo, zubot._id)"></td>\n          <td class="small-column">\n            <md-button ng-if="zubot.dryrun" ng-click="loadZubot(zubot)" class="md-raised md-primary full-width">Load\n              Zubot</md-button>\n          </td>\n          <td class="small-column">\n            <md-button ng-click="killZubot(zubot)" ng-show="$ctrl.EnvService.isDev" ng-disabled="zubot.retiring"\n              class="md-raised md-warn full-width">Kill</md-button>\n            <md-button ng-click="retireZubot(zubot)" ng-show="!$ctrl.EnvService.isDev" ng-disabled="zubot.retiring"\n              class="md-raised full-width">Hide</md-button>\n          </td>\n        </tr>\n      </table>\n\n    </div>\n\n  </div>\n</md-content>');
$templateCache.put('app/data/mission-control/zlogs.dialog.tmpl.html','<md-dialog aria-label="Zlogs dialog" flex="40" flex-gt-md="40">\n\n  <md-toolbar aria-label="Image item dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">\n        Zlogs\n      </p>\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content layout-padding>\n    <div ng-repeat="zlog in vm.zlogs">\n      <b>{{zlog.dt | date:\'yyyy-MM-dd HH:mm:ss\'}}</b>:&nbsp;<span ng-if="zlog._deviceId">Device {{zlog._deviceId}}. </span>{{zlog.narrative}}\n    </div>\n    <div ng-if="vm.zlogs.length === 0">\n      No zlogs available yet.\n    </div>\n  </md-dialog-content>\n\n  <md-dialog-actions layout="row">\n    <md-button class="md-warn" ng-click="vm.cancelDialog()">Close</md-button>\n</md-dialog-actions>\n\n</md-dialog>\n');
$templateCache.put('app/data/subject-report/subject-report-main.tmpl.html','<md-content>\n  <p class="md-headline report-headline" flex>\n    SUBJECT REPORT\n  </p>\n\n  <div flex="grow" layout="row" layout-wrap layout-align="center stretch">\n    <md-card flex="grow" class="card" flex-gt-sm="60">\n      <div ng-show="!vm.hasData" class="no-data">\n        There is no data on the Zuant system relating to this contact.\n      </div>\n      <div ng-show="vm.hasData">\n        <div class="subject-header">\n          {{vm.subjectHeader}}\n        </div>\n        <div class="report-info-text">\n          This report was generated on <b>{{vm.reportTime | date:\'dd MMM yyyy, HH:mm:ss\'}}</b> for the subject\n          <b>{{vm.subjectHeader}}</b>. The latest record on the Zuant system is as follows:\n        </div>\n        <div ng-repeat="(k, v) in vm.finalContactRecord" layout="row" layout-align="start start">\n          <span class="key" flex="25">{{k}}</span><span flex="grow">{{v}}</span>\n        </div>\n        <hr />\n        <div class="explanation-text">\n          In addition, the following updates to the subject record are available in chronological order:\n        </div>\n        <div ng-repeat="change in vm.data">\n          <div class="utc">\n            {{change.utc | date:\'dd MMM yyyy, HH:mm:ss\'}}<span> - {{change.description}}</span>\n          </div>\n          <div ng-repeat="delta in change.deltas">\n            <div ng-repeat="(k, v) in delta.sets" layout="row" layout-align="start start">\n              <span class="key" flex="25">{{k}}</span><span flex="grow">{{v}}</span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </md-card>\n  </div>\n</md-content>');
$templateCache.put('app/data/workflow/card.tmpl.html','<div layout="column" layout-align="start stretch" class="card-contents" ng-click="$ctrl.openCardSelection()">\n  <div flex="35" layout="column" layout-align="center center" class="card-title">\n    <span>\n      {{$ctrl.card.name || $ctrl.card.originalName}}\n    </span>\n  </div>\n  <div flex="65" layout="column" layout-align="start stretch" class="card-info">\n    <div flex="none" layout="row" layout-align="start stretch">\n      <div flex="30" class="card-header">Type</div>\n      <div flex="70" class="card-type-text">{{$ctrl.card.objectType || $ctrl.card.type}}</div>\n    </div>\n    <div flex layout="row" layout-align="start stretch">\n      <div flex="30" class="card-header">Notes</div>\n      <div flex="70">{{$ctrl.card.description}}</div>\n    </div>\n  </div>\n  <div class="card-action" ng-show="$ctrl.showAdd" ng-click="$ctrl.addCardToHand()">\n    <md-icon md-font-icon="zmdi zmdi-plus"></md-icon>\n  </div>\n  <div class="card-action" ng-show="$ctrl.showRemove" ng-click="$ctrl.removeCardFromHand()">\n    <md-icon md-font-icon="zmdi zmdi-minus"></md-icon>\n  </div>\n</div>');
$templateCache.put('app/data/workflow/mapping-system.tmpl.html','<md-card flex="grow" class="system-card">\n  <div ng-repeat="system in $ctrl.system">\n    <div class="system-name">\n      {{system.name}}\n      <md-icon class="system-icon" ng-if="system.iconType == \'icon\'" md-font-icon="zmdi {{system.icon}}">\n      </md-icon>\n\n      <img class="system-icon" ng-src="{{system.icon | cdnAssets}}" ng-if="system.iconType == \'png\'" />\n\n    </div>\n    <div class="field-container" ng-class="$ctrl.name" ui-sortable="$ctrl.sortableOptions" ng-model="system.fields">\n      <div ng-repeat="field in system.fields" class="system-field"\n        ng-class="{\'active\': field.selected, \'automap\': field.automap, \'addfield\': field.name===\'zuantaddcustomfield\'}">\n        {{field.friendly}}\n      </div>\n    </div>\n  </div>\n</md-card>');
$templateCache.put('app/data/workflow/workflow-confirmation.tmpl.html','<div layout="row" layout-align="space-between stretch" flex="grow" class="contact-selection-criteria">\n  <div flex class="selection-criteria-labels">\n    <div><span>{{vm.workflowFactory.selectedStep.description}}</span><b> ({{vm.userData.databasename}})</b></div>\n    <md-input-container class="contact-search-value full-width">\n      <input ng-model="vm.confirmationDb" ng-change="createCardIfValid()" aria-label="database name" />\n    </md-input-container>\n  </div>\n</div>\n');
$templateCache.put('app/data/workflow/workflow-main.tmpl.html','<div layout-fill layout="row" layout-align="start stretch">\n  <div flex="grow" layout="column" layout-align="start stretch">\n    <zp-title-toolbar></zp-title-toolbar>\n    <md-content flex="grow" layout="row" layout-align="start stretch" class="data-workflow">\n      <div flex="20" ng-hide="$ctrl.tasks.length <= 1">\n        <div layout="row" layout-align="start stretch">\n          <div flex="none" class="zuant-bot">\n            <img ng-src="{{\'/images/pngs/zubots/zubot.png\' | cdnAssets}}">\n          </div>\n\n          <div flex="grow">\n            <p class="md-headline data-workflow-headline">\n              {{$ctrl.title}}\n            </p>\n            <p class="data-workflow-description">\n              {{$ctrl.description}}\n            </p>\n          </div>\n        </div>\n        <p>\n          Please select a task from the list below\n        </p>\n        <md-card class="tasks">\n          <div ng-repeat="task in $ctrl.tasks" layout="row" layout-align="start stretch" class="task-card"\n            ng-class="{selected: $ctrl.workflowFactory.selectedTask.title == task.title}"\n            ng-click="$ctrl.workflowFactory.selectTask(task)">\n            <md-icon md-font-icon="zmdi zmdi-circle" flex="none"></md-icon>\n            <div flex="grow">\n              <span class="task-title">{{task.title}}</span>\n              <p class="task-description">\n                {{task.description}}\n              </p>\n            </div>\n          </div>\n        </md-card>\n      </div>\n\n      <div layout="column" layout-align="start stretch" flex="grow" class="workflow-steps"\n        ng-if="$ctrl.workflowFactory.selectedTask">\n        <div style="margin-top: 20px" layout="row" layout-align="start stretch" flex="grow">\n          <div flex="80" layout="column" layout-align="stretch">\n\n            <div flex="none" layout="row" layout-align="space-around center" class="step-title-container">\n              <div ng-repeat="step in $ctrl.workflowFactory.selectedTask.steps" flex class="step-circle-container"\n                ng-if="step.cardType !== \'intro\'">\n                <div class="step-circle" ng-class="$ctrl.workflowFactory.getStepClass(step)"\n                  ng-click="$ctrl.workflowFactory.moveToStep(step)">\n                  <span>{{step.title}}</span>\n                </div>\n                <div class="step-progress">{{step.progress}}</div>\n              </div>\n            </div>\n\n            <md-card flex="grow" layout="column" layout-align="space-between stretch" class="step-container"\n              ng-class="$ctrl.workflowFactory.getStepClass($ctrl.workflowFactory.selectedStep)">\n              <div flex="grow" layout="column" layout-align="space-between stretch">\n                <div flex="grow" class="card-container" layout-align="start center" layout="row"\n                  ng-show="$ctrl.workflowFactory.containerShow.selectCards && (($ctrl.workflowFactory.selectedStep.display == \'panel\' && $ctrl.workflowFactory.selectedStep.cards.length > 0) || $ctrl.workflowFactory.selectedStep.display != \'panel\')">\n                  <zp-card card="card" show-remove="!$ctrl.workflowFactory.containerShow.zubotActivated"\n                    ng-repeat="card in $ctrl.workflowFactory.selectedStep.cards" class="card"></zp-card>\n                  <div layout="column" class="new-card" ng-click="$ctrl.workflowFactory.openCardSelection()"\n                    ng-show="!($ctrl.workflowFactory.selectedStep.cards.length > 0 && $ctrl.workflowFactory.selectedStep.singleCard) && !$ctrl.workflowFactory.containerShow.zubotActivated">\n                    <div flex="grow" layout="column" layout-align="space-between stretch">\n                      <md-icon md-font-icon="zmdi zmdi-plus-circle-o"></md-icon>\n                      <p flex>{{$ctrl.workflowFactory.selectedStep.newText}} <span\n                          ng-show="$ctrl.workflowFactory.selectedStep.cardOptional"><br />(this is optional)</span></p>\n                    </div>\n                  </div>\n                </div>\n                <zp-workflow-panel flex="grow" class="card-container" layout-align="start center"\n                  layout-align-sm="end stretch" layout-align-xs="end stretch" layout="row"\n                  ng-show="$ctrl.workflowFactory.selectedStep.display == \'panel\' && $ctrl.workflowFactory.selectedStep.cards.length == 0"></zp-workflow-panel>\n              </div>\n              <div flex="none" class="action-bar" layout="row" layout-align="space-between stretch">\n                <div flex="50">\n                  <md-button class="md-primary previous" ng-hide="$ctrl.workflowFactory.isFirstStep()"\n                    ng-click="$ctrl.workflowFactory.goToPreviousStep()"><md-icon\n                      md-font-icon="zmdi zmdi-arrow-left"></md-icon> PREVIOUS</md-button>\n                </div>\n                <div flex="50">\n                  <md-button class="md-primary next" ng-hide="$ctrl.workflowFactory.isLastStep()"\n                    ng-disabled="!$ctrl.workflowFactory.selectedStep.valid"\n                    ng-click="$ctrl.workflowFactory.goToNextStep()">NEXT <md-icon\n                      md-font-icon="zmdi zmdi-arrow-right"></md-icon></md-button>\n                </div>\n              </div>\n            </md-card>\n\n          </div>\n          <div flex="20" class="activate-task">\n            <p class="zubot-task">\n              This {{$ctrl.title.toLowerCase()}} task will be handled by\n              <b>{{$ctrl.workflowFactory.selectedTask.zubot}}</b><md-icon\n                md-font-icon="zmdi zmdi-refresh zubot-name-refresh" ng-click="$ctrl.workflowFactory.refreshZubot()"\n                ng-show="!$ctrl.workflowFactory.containerShow.zubotActivated"></md-icon>\n            </p>\n            <div class="zuant-bot-activate">\n              <md-icon\n                ng-show="$ctrl.workflowFactory.selectedStep.displayMessage && $ctrl.workflowFactory.selectedStep.displayMessage != \'\'"\n                md-font-icon="zmdi zmdi-alert-triangle" class="zubot-alert"></md-icon>\n              <md-icon\n                ng-show="$ctrl.workflowFactory.selectedStep.zubotText && !$ctrl.workflowFactory.selectedStep.displayMessage && !$ctrl.workflowFactory.containerShow.zubotActivated"\n                md-font-icon="zmdi zmdi-info" class="zubot-info"></md-icon>\n              <zp-zubot height="150px" width="150px" outfit="$ctrl.workflowFactory.selectedTask.outfit"></zp-zubot>\n            </div>\n            <md-button\n              ng-show="!$ctrl.workflowFactory.containerShow.zubotActivated && !$ctrl.workflowFactory.containerShow.dryrunActivated"\n              class="md-primary md-raised zubot-activate-button" ng-click="$ctrl.workflowFactory.activateZubot()"\n              ng-disabled="!$ctrl.workflowFactory.isLastStep() || $ctrl.workflowFactory.containerShow.busy || $ctrl.workflowFactory.containerShow.buttonActivating || $ctrl.workflowFactory.containerShow.uploading > 0 || $ctrl.workflowFactory.selectedStep.displayMessage != \'\'">{{\n              $ctrl.workflowFactory.text.zubotActivateButtonText }}</md-button>\n            <p ng-show="$ctrl.workflowFactory.containerShow.zubotActivated" class="zubot-activated">\n              <b>{{$ctrl.workflowFactory.selectedTask.zubot}}</b> has been successfully activated! Check <a\n                href="/data/mission-control">zubot mission control</a> for information.\n            </p>\n            <div ng-if="$ctrl.workflowFactory.selectedTask.dryrunAvailable"\n              ng-show="$ctrl.workflowFactory.isLastStep() && !$ctrl.workflowFactory.containerShow.zubotActivated && !$ctrl.workflowFactory.containerShow.dryrunActivated && $ctrl.workflowFactory.containerShow.uploading == 0 && !($ctrl.workflowFactory.selectedStep.displayMessage && $ctrl.workflowFactory.selectedStep.displayMessage != \'\')"\n              style="margin-top:10px">\n              Alternatively try a<br />\n              <md-button class="md-primary" ng-click="$ctrl.workflowFactory.activateZubot(true)">dry run</md-button>\n            </div>\n            <p ng-show="$ctrl.workflowFactory.containerShow.dryrunActivated" class="zubot-activated">\n              Check <a href="/data/mission-control">zubot mission control</a> for information on your dry run!\n            </p>\n            <div class="validation-message"\n              ng-show="(($ctrl.workflowFactory.selectedStep.displayMessage && $ctrl.workflowFactory.selectedStep.displayMessage != \'\') || $ctrl.workflowFactory.selectedStep.zubotText) && !$ctrl.workflowFactory.containerShow.zubotActivated">\n              <span>{{$ctrl.workflowFactory.selectedStep.displayMessage ||\n                $ctrl.workflowFactory.selectedStep.zubotText}}</span>\n            </div>\n            <div class="validation-message"\n              ng-show="!($ctrl.workflowFactory.selectedStep.displayMessage && $ctrl.workflowFactory.selectedStep.displayMessage != \'\') && !$ctrl.workflowFactory.selectedStep.zubotText && $ctrl.workflowFactory.isLastStep() && $ctrl.workflowFactory.containerShow.uploading > 0">\n              <span>Your files are being uploaded. Please wait a little for them to finish before activating your\n                zubot</span>\n            </div>\n          </div>\n        </div>\n\n      </div>\n    </md-content>\n\n    <md-content class="select-card-container" ng-class="$ctrl.workflowFactory.getCardSelectionClass()" layout="row"\n      layout-align="stretch">\n      <div class="inner-content" flex layout="column" layout-align="stretch">\n        <div layout="row" layout-align="space-around center">\n          <p flex="80" class="selection-description">{{$ctrl.workflowFactory.selectedStep.description}}</p>\n          <md-button flex class="md-raised md-primary"\n            ng-click="$ctrl.workflowFactory.containerShow.selectCard = false">Save & Close</md-button>\n        </div>\n\n        <md-card layout="column" layout-align=" stretch" flex="grow" class="card-selection-row-container">\n          <div class="card-selection-row">\n            <p class="card-container-title">\n              Currently selected {{$ctrl.workflowFactory.selectedStep.cardName}} cards\n            </p>\n            <div class="validation-message"\n              ng-show="$ctrl.workflowFactory.selectedStep.displayMessage && $ctrl.workflowFactory.selectedStep.displayMessage != \'\'">\n              <md-icon md-font-icon="zmdi zmdi-alert-triangle"\n                class="zubot-alert"></md-icon>{{$ctrl.workflowFactory.selectedStep.displayMessage}}\n            </div>\n            <div class="card-container" ui-sortable="$ctrl.workflowFactory.cardSortableOptions"\n              ng-model="$ctrl.workflowFactory.selectedStep.cards">\n              <zp-card card="card" show-remove="true" ng-repeat="card in $ctrl.workflowFactory.selectedStep.cards"\n                class="card" layout="column" layout-align="start stretch"></zp-card>\n            </div>\n          </div>\n          <div class="card-selection-row">\n            <p class="card-container-title">Available {{$ctrl.workflowFactory.selectedStep.cardName}} cards</p>\n            <div class="card-container" ui-sortable="$ctrl.workflowFactory.cardSortableOptions"\n              ng-model="$ctrl.workflowFactory.availableCards">\n              <zp-card card="card" show-add="true" ng-repeat="card in $ctrl.workflowFactory.availableCards" class="card"\n                layout="column" layout-align="start stretch"></zp-card>\n            </div>\n          </div>\n        </md-card>\n      </div>\n    </md-content>\n\n    <md-content class="field-mapping-container" ng-class="$ctrl.workflowFactory.getDataloadFileSelectionClass()"\n      layout="row" layout-align="stretch">\n      <div class="inner-content" flex layout="column" layout-align="stretch">\n        <div layout="row" layout-align="space-around center">\n          <p flex="80" class="contact-selection-description">{{$ctrl.workflowFactory.selectedStep.description}}</p>\n          <md-button flex class="md-raised md-primary" ng-disabled="$ctrl.workflowFactory.containerShow.busy"\n            ng-click="$ctrl.workflowFactory.saveNewDataload()">Create & Close</md-button>\n        </div>\n\n        <div layout="row" layout-align="space-between stretch" flex="grow">\n          <div flex="50">\n            <div layout="row" layout-align="space-between stretch" flex="grow" class="contact-selection-criteria">\n              <div flex="30" class="selection-criteria-labels">\n                <div class="blank-line"></div>\n                <div>Name</div>\n              </div>\n              <div flex layout="column">\n                <md-button flex class="md-raised select-file"\n                  ng-click="$ctrl.workflowFactory.selectDataloadFile()">Select File</md-button>\n                <md-input-container class="contact-search-value full-width">\n                  <input ng-model="$ctrl.workflowFactory.selectedCard.name" aria-label="file name" />\n                </md-input-container>\n              </div>\n            </div>\n          </div>\n          <div flex="40" class="card-container contact-card-container"\n            ng-class="{\'valid-card\': $ctrl.workflowFactory.selectedCard.name || $ctrl.workflowFactory.selectedCard.originalName}">\n            <zp-card\n              ng-show="$ctrl.workflowFactory.selectedCard.name || $ctrl.workflowFactory.selectedCard.originalName"\n              card="$ctrl.workflowFactory.selectedCard" class="card"></zp-card>\n          </div>\n        </div>\n      </div>\n    </md-content>\n\n    <md-content class="field-mapping-container" ng-class="$ctrl.workflowFactory.getDataloadSelectionClass()"\n      layout="row" layout-align="stretch">\n      <div class="inner-content" flex layout="column" layout-align="stretch">\n        <div layout="row" layout-align="space-around center">\n          <p flex="80" class="contact-selection-description">{{$ctrl.workflowFactory.selectedStep.description}}</p>\n          <md-button flex class="md-raised md-primary" ng-click="$ctrl.workflowFactory.saveDataloadSelection()">Create &\n            Close</md-button>\n        </div>\n\n        <div layout="row" layout-wrap="" flex="grow">\n          <div flex="100" flex-gt-sm="35">\n            <div class="selection-criteria">\n              Select criteria:\n            </div>\n            <div layout="row" layout-align="space-between stretch" flex="grow" class="contact-selection-criteria">\n              <div flex="40" class="selection-criteria-labels">\n                <div>Dataload Name</div>\n                <div>Loaded After</div>\n                <div>Loaded Before</div>\n                <div>Loaded By User Name</div>\n                <div>Loaded By Zubot Name</div>\n              </div>\n              <div flex layout="column">\n                <md-input-container class="contact-search-value full-width">\n                  <input ng-model="$ctrl.workflowFactory.selectedCard.filter.name"\n                    ng-change="$ctrl.workflowFactory.dataloadSearchChanged()" aria-label="value filter" />\n                </md-input-container>\n                <md-input-container class="contact-search-value full-width">\n                  <md-datepicker name="startdate" ng-model="$ctrl.workflowFactory.selectedCard.filter.startDate"\n                    ng-change="$ctrl.workflowFactory.dataloadSearchChanged()"\n                    md-max-date="$ctrl.todaysDate"></md-datepicker>\n                </md-input-container>\n                <md-input-container class="contact-search-value full-width">\n                  <md-datepicker name="enddate" ng-model="$ctrl.workflowFactory.selectedCard.filter.endDate"\n                    ng-change="$ctrl.workflowFactory.dataloadSearchChanged()"\n                    md-max-date="$ctrl.todaysDate"></md-datepicker>\n                </md-input-container>\n                <md-input-container class="contact-search-value full-width">\n                  <input ng-model="$ctrl.workflowFactory.selectedCard.filter.ownerId"\n                    ng-change="$ctrl.workflowFactory.dataloadSearchChanged()" aria-label="value filter" />\n                </md-input-container>\n                <md-input-container class="contact-search-value full-width">\n                  <input ng-model="$ctrl.workflowFactory.selectedCard.filter.zubot"\n                    ng-change="$ctrl.workflowFactory.dataloadSearchChanged()" aria-label="value filter" />\n                </md-input-container>\n              </div>\n            </div>\n          </div>\n          <div flex="100" flex-gt-sm="45" layout="row" layout-wrap layout-align="center start"\n            class="contact-selection-table">\n            <div class="contact-select-instructions"\n              ng-hide="$ctrl.workflowFactory.selectedCard.searchResults && $ctrl.workflowFactory.selectedCard.searchResults.length > 0 || $ctrl.workflowFactory.containerShow.contactSearchBusy">\n              Enter in your search criteria to find a data load that will be removed. This section will be replaced by\n              search results so you can select them.\n            </div>\n            <div class="busy" ng-if="$ctrl.workflowFactory.containerShow.contactSearchBusy"></div>\n            <div class="contact-search-information"\n              ng-show="$ctrl.workflowFactory.containerShow.contactSearchBusy || ($ctrl.workflowFactory.selectedCard.searchResults && $ctrl.workflowFactory.selectedCard.searchResults.length > 70)">\n              {{$ctrl.workflowFactory.text.contactSearchText}}\n            </div>\n            <table\n              ng-show="$ctrl.workflowFactory.selectedCard.searchResults && $ctrl.workflowFactory.selectedCard.searchResults.length > 0 || $ctrl.workflowFactory.containerShow.contactSearchBusy"\n              flex class="table table-striped table-select-row">\n              <thead>\n                <tr>\n                  <th style="width:30%">Name</th>\n                  <th style="width:20%">Zubot</th>\n                  <th style="width:20%">Loaded By</th>\n                  <th style="width:30%;">Created On </th>\n                  <th></th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat="result in $ctrl.workflowFactory.selectedCard.searchResults"\n                  ng-click="$ctrl.workflowFactory.selectDataload(result._id, result.name)">\n                  <td style="width:30%">{{ result.name }}</td>\n                  <td style="width:20%">{{ result.zubot }}</td>\n                  <td style="width:20%">{{ result.owner }}</td>\n                  <td style="width:30%;">{{ result.createdOn | date: \'short\' }}</td>\n                  <td style="text-align:center;padding-left:0">></td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n          <div flex="100" flex-gt-sm="20" class="card-container contact-card-container"\n            ng-class="{\'valid-card\': $ctrl.workflowFactory.selectedCard.name}">\n            <zp-card ng-show="$ctrl.workflowFactory.selectedCard.name" card="$ctrl.workflowFactory.selectedCard"\n              class="card"></zp-card>\n          </div>\n        </div>\n      </div>\n    </md-content>\n\n    <md-content class="field-mapping-container" ng-class="$ctrl.workflowFactory.getContactSelectionClass()" layout="row"\n      layout-align="stretch">\n      <div class="inner-content" flex layout="column" layout-align="space-between stretch">\n        <div layout="row" layout-align="space-around center">\n          <p flex class="contact-selection-description">{{$ctrl.workflowFactory.selectedStep.description}}</p>\n          <md-button class="md-raised md-primary" ng-click="$ctrl.workflowFactory.saveContactSelection()">Create &\n            Close</md-button>\n        </div>\n\n        <div layout="row" layout-wrap="" flex="grow">\n          <div flex="100" flex-gt-sm="35">\n            <div class="selection-criteria">\n              Select criteria:\n            </div>\n            <div layout="row" layout-align="space-between stretch" flex="grow" class="contact-selection-criteria">\n              <div flex="50">\n                <div ng-repeat="filter in $ctrl.workflowFactory.selectedCard.filters">\n                  <md-select ng-model="filter.field" aria-label="field filter dropdown">\n                    <md-option ng-repeat="field in $ctrl.workflowFactory.selectedStep.fields" ng-value="field">\n                      {{field.friendly}}\n                    </md-option>\n                  </md-select>\n                </div>\n                <md-select ng-model="$ctrl.workflowFactory.newContactFieldFilter.field"\n                  aria-label="field filter dropdown" ng-change="$ctrl.workflowFactory.newContactFieldChanged()">\n                  <md-option ng-repeat="field in $ctrl.workflowFactory.selectedStep.fields" ng-value="field">\n                    {{field.friendly}}\n                  </md-option>\n                </md-select>\n              </div>\n              <div flex="25">\n                <div ng-repeat="filter in $ctrl.workflowFactory.selectedCard.filters">\n                  <md-select ng-model="filter.operator" aria-label="operator filter dropdown"\n                    ng-change="$ctrl.workflowFactory.contactSearchChanged()">\n                    <md-option ng-repeat="op in $ctrl.workflowFactory.selectedStep.operators" ng-value="op">\n                      {{op}}\n                    </md-option>\n                  </md-select>\n                </div>\n                <md-select ng-model="$ctrl.workflowFactory.newContactFieldFilter.operator"\n                  aria-label="operator filter dropdown" ng-change="$ctrl.workflowFactory.contactSearchChanged()">\n                  <md-option ng-repeat="op in $ctrl.workflowFactory.selectedStep.operators" ng-value="op">\n                    {{op}}\n                  </md-option>\n                </md-select>\n              </div>\n              <div flex>\n                <div ng-repeat="filter in $ctrl.workflowFactory.selectedCard.filters">\n                  <md-input-container class="contact-search-value">\n                    <input ng-model="filter.value" ng-change="$ctrl.workflowFactory.contactSearchChanged()"\n                      aria-label="value filter" />\n                  </md-input-container>\n                </div>\n                <md-input-container class="contact-search-value">\n                  <input ng-model="$ctrl.workflowFactory.newContactFieldFilter.value" aria-label="value filter" />\n                </md-input-container>\n              </div>\n            </div>\n          </div>\n          <div flex="100" flex-gt-sm="45" layout="row" layout-wrap layout-align="center start"\n            class="contact-selection-table">\n            <div class="contact-select-instructions"\n              ng-hide="$ctrl.workflowFactory.selectedCard.searchResults && $ctrl.workflowFactory.selectedCard.searchResults.length > 0 || $ctrl.workflowFactory.containerShow.contactSearchBusy">\n              Enter in your search criteria to find the person that wants to be removed. This section will be replaced\n              by search results so you can select them.\n            </div>\n            <div class="busy" ng-if="$ctrl.workflowFactory.containerShow.contactSearchBusy"></div>\n            <div class="contact-search-information"\n              ng-show="$ctrl.workflowFactory.containerShow.contactSearchBusy || ($ctrl.workflowFactory.selectedCard.searchResults && $ctrl.workflowFactory.selectedCard.searchResults.length > 70)">\n              {{$ctrl.workflowFactory.text.contactSearchText}}\n            </div>\n            <table\n              ng-show="$ctrl.workflowFactory.selectedCard.searchResults && $ctrl.workflowFactory.selectedCard.searchResults.length > 0 || $ctrl.workflowFactory.containerShow.contactSearchBusy"\n              flex class="table table-striped table-select-row">\n              <thead>\n                <tr>\n                  <th style="width:15%">First Name</th>\n                  <th style="width:20%">Last Name</th>\n                  <th style="width:35%">Email</th>\n                  <th style="width:20%">Company Name</th>\n                  <th></th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat="result in $ctrl.workflowFactory.selectedCard.searchResults"\n                  ng-click="$ctrl.workflowFactory.selectContact(result._id, result.firstname, result.lastname, result.email)">\n                  <td style="width:15%">{{ result.firstname }}</td>\n                  <td style="width:20%">{{ result.lastname }}</td>\n                  <td style="width:35%">{{ result.email }}</td>\n                  <td style="width:20%">{{ result.name }}</td>\n                  <td style="text-align:center;padding-left:0">></td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n          <div flex="100" flex-gt-sm="20" class="card-container contact-card-container"\n            ng-class="{\'valid-card\': $ctrl.workflowFactory.selectedCard.name}">\n            <zp-card ng-show="$ctrl.workflowFactory.selectedCard.name" card="$ctrl.workflowFactory.selectedCard"\n              class="card"></zp-card>\n          </div>\n        </div>\n      </div>\n    </md-content>\n\n    <md-content class="field-mapping-container" ng-class="$ctrl.workflowFactory.getFieldMappingClass()" layout="row"\n      layout-align="stretch">\n      <div class="inner-content" flex layout="column" layout-align="space-between stretch">\n        <div layout="row" layout-align="space-around center">\n          <p flex class="selection-description">{{$ctrl.workflowFactory.selectedStep.description}}</p>\n          <md-button class="md-raised md-primary" ng-click="$ctrl.workflowFactory.saveMapping()">Create &\n            Close</md-button>\n        </div>\n\n        <div layout="row" layout-align="space-between stretch" flex="grow" style="max-height:100%;">\n\n          <zp-mapping-system class="system-container" system="$ctrl.workflowFactory.mappingSystems.systemA"\n            name="systema" sortable-options="$ctrl.workflowFactory.fieldMappingSortableOptionsA" flex="25"\n            layout="row"></zp-mapping-system>\n          <div layout="row" layout-align="center stretch" class="field-mapping-container-middle">\n            <div class="mapping-row-container">\n              <div class="child-content" layout="column" layout-align="space-between stretch">\n                <div class="card-title" flex="none">\n                  {{$ctrl.workflowFactory.selectedStep.cardName}}\n                </div>\n                <div class="card-content drop-container">\n                  <div id="{{$index}}" ng-repeat="row in $ctrl.workflowFactory.selectedCard.mappings"\n                    class="mapping-row" layout="row" layout=" stretch">\n                    <div layout="column" layout-align="center stretch" flex="35" class="field-drop-container systema"\n                      ng-class="{\'active\': row.systemA.length > 0}"\n                      ui-sortable="$ctrl.workflowFactory.fieldMappingSortableOptionsA" ng-model="row.systemA">\n                      <div flex ng-repeat="field in row.systemA" class="field">\n                        <span>{{field.friendly}}</span>\n                        <div class="card-action"\n                          ng-click="$ctrl.workflowFactory.removeFieldFromMapping(\'systemA\', $parent.$index)">\n                          <md-icon md-font-icon="zmdi zmdi-minus"></md-icon>\n                        </div>\n                      </div>\n                    </div>\n                    <div flex class="cog-container"\n                      ng-class="{\'activeA\': row.systemA.length > 0, \'activeB\': row.systemB.length > 0}">\n                      <md-icon class="cog" md-font-icon="zmdi zmdi-settings"></md-icon>\n                    </div>\n                    <div layout="column" layout-align="center stretch" flex="35" class="field-drop-container systemb"\n                      ng-class="{\'active\': row.systemB.length > 0}"\n                      ui-sortable="$ctrl.workflowFactory.fieldMappingSortableOptionsB" ng-model="row.systemB">\n                      <div ng-repeat="field in row.systemB" class="field">\n                        <span>{{field.friendly}}</span>\n                        <div class="card-action"\n                          ng-click="$ctrl.workflowFactory.removeFieldFromMapping(\'systemB\', $parent.$index)">\n                          <md-icon md-font-icon="zmdi zmdi-minus"></md-icon>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class="mapping-drop-container drop-container"\n                  ui-sortable="$ctrl.workflowFactory.mappingRowSortableOptions"\n                  ng-model="$ctrl.workflowFactory.selectedCard.mappings">\n                </div>\n              </div>\n            </div>\n          </div>\n          <zp-mapping-system class="system-container" system="$ctrl.workflowFactory.mappingSystems.systemB"\n            name="systemb" sortable-options="$ctrl.workflowFactory.fieldMappingSortableOptionsB" flex="25"\n            layout="row"></zp-mapping-system>\n\n        </div>\n      </div>\n    </md-content>\n  </div>\n</div>\n<md-content class="workflow-busy" ng-show="$ctrl.workflowFactory.containerShow.busy"></md-content>\n\n<input id="workflowFileInput" type="file" ng-upload-change="$ctrl.workflowFactory.fileChanged($event)"\n  style="display:none" />\n<input id="dataloadSpecialFile" type="file" ng-upload-change="$ctrl.workflowFactory.dataloadfileChanged($event)"\n  style="display:none" />');
$templateCache.put('app/data/workflow/workflow-panel.tmpl.html','<zp-workflow-confirmation flex ng-if="vm.workflowFactory.selectedStep.cardType == \'confirmation\'"></zp-workflow-confirmation>\r\n<intro-text zubot="vm.workflowFactory.selectedTask" ng-if="vm.workflowFactory.selectedStep.cardType == \'intro\'"></intro-text>\r\n');
$templateCache.put('app/data/zubot/zubot.tmpl.html','<svg ng-attr-width="{{$ctrl.width}}" ng-attr-height="{{$ctrl.height}}" viewBox="0 0 566 860"\n    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <g id="zubot">\n        <g id="body_back" transform="translate(8.000000, 329.000000)" fill="{{$ctrl.outfit.bodyBackColor}}">\n            <polygon id=" Path-4" points="51.625 0 42 46.7070312 507.554687 46.7070312 494.042969 0">\n            </polygon>\n            <polyline id="Path-6" points="0.643222363 38.2845008 108.960914 377.171158 235.346183 475.504944">\n            </polyline>\n            <polyline id="Path-6"\n                transform="translate(431.994702, 256.894722) scale(-1, 1) translate(-431.994702, -256.894722) "\n                points="314.643222 38.2845008 422.960914 377.171158 549.346183 475.504944"></polyline>\n        </g>\n        <g id="body_front" fill="{{$ctrl.outfit.bodyColor}}">\n            <polygon id="Triangle"\n                transform="translate(283.000000, 607.636318) scale(1, -1) translate(-283.000000, -607.636318) "\n                points="314.786321 368 566 847.272636 0 847.272636 251.184929 368.057602"></polygon>\n            <path\n                d="M530.710938,338.867693 C530.710938,142.078125 455.792969,-5.68434189e-14 284.140625,-5.68434189e-14 C112.488281,-4.24441897e-14 36.1679688,143.761719 36,338.867693 C242.820313,338.867693 329.958991,338.867693 530.710938,338.867693 Z"\n                id="Oval-2"></path>\n        </g>\n        <g id="verticals" transform="translate(104.000000, 410.000000)" fill="{{$ctrl.outfit.verticalsColor}}">\n            <rect id="Rectangle-2" x="0" y="0" width="10" height="144"></rect>\n            <rect id="Rectangle-2" x="349" y="0" width="10" height="144"></rect>\n        </g>\n        <g id="eyes" transform="translate(147.000000, 168.000000)" fill="{{$ctrl.outfit.eyeColor}}">\n            <circle id="Oval-3" cx="47.5" cy="47.5" r="47.5"></circle>\n            <circle id="Oval-3" cx="225.5" cy="47.5" r="47.5"></circle>\n        </g>\n        <g id="zed" transform="translate(220.000000, 404.000000)" fill="{{$ctrl.outfit.zedColor}}">\n            <polygon id="Path-5"\n                points="0 0 126.280824 0 126.280824 21.2732233 29.5284702 168.355187 126.280824 168.355187 126.280824 190.598617 0 190.598617 0 165.421925 96.9278289 21.2732233 0 21.2732233">\n            </polygon>\n        </g>\n        <g id="eye_highlights" transform="translate(159.000000, 178.000000)" fill="{{$ctrl.outfit.eyeHighlightsColor}}">\n            <rect id="Rectangle-3"\n                transform="translate(200.471230, 24.789518) rotate(41.000000) translate(-200.471230, -24.789518) "\n                x="195.47123" y="-3.71048182" width="10" height="57"></rect>\n            <rect id="Rectangle-3"\n                transform="translate(22.471230, 24.789518) rotate(41.000000) translate(-22.471230, -24.789518) "\n                x="17.4712302" y="-3.71048182" width="10" height="57"></rect>\n        </g>\n    </g>\n</svg>');
$templateCache.put('app/email/main/add-template-dialog.tmpl.html','<md-dialog aria-label="Add new template dialog" flex="100" flex-gt-md="60">\n  <md-toolbar aria-label="Create template dialog toolbar">\n    <div class="md-toolbar-tools">\n      <p class="md-subhead">New email template</p>\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-dialog-content layout-padding>\n    <form name="vm.emailTemplateForm" novalidate flex="100">\n\n      <md-list flex="80" flex-offset="10">\n\n        <md-subheader>Begin by giving your template a title & subject</md-subheader>\n\n        <md-list-item style="margin-top: 30px;">\n          <md-input-container class="md-block" flex>\n            <label>Template title</label>\n            <input type="text" ng-model="vm.templateDoc.title" ng-change="vm.templateTitleChanged()" name="title"\n              aria-label="Template title" required md-autofocus />\n            <div ng-messages="vm.emailTemplateForm.title.$error" md-auto-hide="false"\n              ng-show="vm.emailTemplateForm.title.$touched">\n              <div ng-message="required">\n                <span>Please give your template a title</span>\n              </div>\n              <div ng-message="templateTitleExists">A template with that title already exists</div>\n            </div>\n          </md-input-container>\n        </md-list-item>\n\n        <md-list-item ng-if="vm.templateSource == \'new\'">\n          <md-input-container class="md-block" flex>\n            <label>Email subject</label>\n            <input type="text" ng-model="vm.templateDoc.emailtemplatesubject" name="subject" aria-label="Email subject"\n              required />\n            <div ng-messages="vm.emailTemplateForm.subject.$error" md-auto-hide="false"\n              ng-show="vm.emailTemplateForm.subject.$touched">\n              <div ng-message when="required">\n                <span>Please give your template a subject</span>\n              </div>\n            </div>\n          </md-input-container>\n        </md-list-item>\n\n        <md-list-item style="margin-top: 30px;" ng-if="vm.emailTemplates.length > 0">\n          <md-button class="md-primary zp-off-white-bg" ng-class="{\'md-raised md-primary\': vm.templateSource == \'new\'}"\n            ng-click="vm.templateSource = \'new\'" flex>New template</md-button>\n          <md-button class="md-primary zp-off-white-bg"\n            ng-class="{\'md-raised md-primary\': vm.templateSource == \'clone\'}" ng-click="vm.templateSource = \'clone\'"\n            flex>Clone template</md-button>\n        </md-list-item>\n\n        <div ng-if="vm.templateSource == \'clone\'">\n          <md-list-item style="margin-top: 25px;">\n            <zp-email-template-select-control flex="100" model="vm.templateDoc._cloneSourceTemplateId"\n              on-change="vm.setCloneTemplateId({item: item})" config="vm.emailTemplateConfig" items="vm.emailTemplates">\n            </zp-email-template-select-control>\n          </md-list-item>\n        </div>\n      </md-list>\n\n      <input type="hidden" name="CSRFToken" value="1231234567890" />\n    </form>\n\n    <md-dialog-actions layout="row">\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        Cancel\n      </md-button>\n      <md-button ng-click="vm.submit()" ng-disabled="vm.submitBtnDisabled || vm.emailTemplateForm.$invalid"\n        aria-label="Create template">\n        Save\n      </md-button>\n    </md-dialog-actions>\n  </md-dialog-content>\n</md-dialog>');
$templateCache.put('app/forms/grid-page/zp-lead-grid-page.tmpl.html','<md-content flex ng-cloak layout-align="start start" layout-padding>\n\n  <md-card flex>\n    <!-- table row selection manager  -->\n    <zp-selection-manager toolbar-buttons="$ctrl.metadata.toolbarButtons" widget-id="$ctrl.metadata.id">\n    </zp-selection-manager>\n\n    <zp-grid-toolbar ng-hide="$ctrl.data.selectedItems.length" buttons="$ctrl.metadata.toolbarButtons"\n      search-value="$ctrl.searchValue" widget-id="$ctrl.metadata.id" metadata="$ctrl.metadata"\n      refresh-grid-data="$ctrl.refreshGridData()">\n    </zp-grid-toolbar>\n\n    <zp-data-grid ng-show="$ctrl.data.items.length" data="$ctrl.data" metadata="$ctrl.metadata"\n      search-value="$ctrl.searchValue" loading-indicator="$ctrl.loading" total-rows="$ctrl.totalRows"\n      options="$ctrl.metadata.gridOptions" widget-id="$ctrl.metadata.id">\n    </zp-data-grid>\n\n    <zp-no-data ng-show="$ctrl.blankSlate" header="No leads have synced to the cloud yet."\n      subhead="(there are {{$ctrl.leadGridFactoryData.parked_leads.items.length}} parked leads)" svgpath=""\n      fontcolor="zuantLagoonRollover" svgid="submitted_leads_blank" onclick="$ctrl.refreshGridData()"\n      show-refresh-btn="true">\n    </zp-no-data>\n\n    <!-- WORKING AS A COMPONENT COPY THIS CONFIG -->\n    <md-table-pagination ng-show="$ctrl.data.items.length" class="md-table-pagination"\n      ng-if="$ctrl.metadata.paginationOptions.pagination" md-limit="$ctrl.metadata.paginationOptions.limit"\n      md-limit-options="$ctrl.metadata.paginationOptions.limitOptions" md-page="$ctrl.metadata.paginationOptions.page"\n      md-total="{{$ctrl.totalRows}}" md-page-select="$ctrl.metadata.paginationOptions.pageSelect"\n      md-boundary-links="$ctrl.metadata.paginationOptions.boundaryLinks"\n      md-on-paginate="$ctrl.logPagination(page, limit)">\n    </md-table-pagination>\n\n  </md-card>\n\n  <md-switch ng-if="$ctrl.isDev" ng-model="$ctrl.options.includeArchived"\n    ng-change="$ctrl.toggleShowArchivedLeads()">{{$ctrl.options.includeArchived ? \'hide\' : \'show\'}} archived\n    leads</md-switch>\n</md-content>\n\n<md-sidenav id="settingsPanel" md-component-id="settingsPanel" class="md-sidenav-right">\n  <zp-sidenav></zp-sidenav>\n</md-sidenav>');
$templateCache.put('app/forms/lead-release-grid/zp-lead-release-grid.tmpl.html','<md-content layout="column" flex layout-padding>\n\n  <md-toolbar class="md-table-toolbar md-warn" ng-show="$ctrl.countOfMachinesRunningForForm === 0">\n    <div class="md-toolbar-tools">\n      <p class="md-body">This form is not currently configured to run for any integration machines.</p>\n      <span flex></span>\n      <md-button class="md-raised" ng-click="$ctrl.goToMachinesPage()">Go to machines</md-button>\n    </div>\n  </md-toolbar>\n\n  <div layout="row" layout-align="space-around center" layout-wrap class="margin-top-10">\n    <zp-integration-headline-widget \n      ng-repeat="widget in $ctrl.headlineWidgets"\n      ng-if="widget.datakey !== \'indeterminateLeads\' || $ctrl.headlineWidgetsFactory.factoryData[\'indeterminateLeads\'].count > 0"\n      widget-data="widget">\n    </zp-integration-headline-widget>\n  </div>\n\n  <md-card>\n\n    <zp-lead-release-toolbar></zp-lead-release-toolbar>\n\n    <zp-grid-toolbar \n      ng-hide="$ctrl.data.selectedItems.length"\n      buttons="$ctrl.metadata.toolbarButtons" \n      search-value="$ctrl.searchValue" \n      widget-id="$ctrl.widgetId"\n      metadata="$ctrl.metadata">\n    </zp-grid-toolbar>\n\n    <zp-data-grid \n      layout="column" \n      ng-show="$ctrl.data.items.length" \n      loading-indicator="$ctrl.loading"\n      metadata="$ctrl.metadata" \n      search-value="$ctrl.searchValue" \n      options="$ctrl.metadata.gridOptions"\n      widget-id="$ctrl.widgetId">\n    </zp-data-grid>\n\n    <zp-no-data \n      ng-show="$ctrl.blankSlate" \n      header="No leads have synced to the cloud yet."\n      subhead="(there are {{$ctrl.leadGridFactoryData.parked_leads.items.length}} parked leads)" \n      svgpath=""\n      fontcolor="zuantLagoonRollover" \n      svgid="submitted_leads_blank" \n      onclick="$ctrl.refreshGridData()"\n      show-refresh-btn="true">\n    </zp-no-data>\n\n    <md-table-pagination \n      ng-show="$ctrl.data.items.length" \n      class="md-table-pagination"\n      ng-if="$ctrl.metadata.paginationOptions.pagination" \n      md-limit="$ctrl.metadata.paginationOptions.limit"\n      md-limit-options="$ctrl.metadata.paginationOptions.limitOptions" \n      md-page="$ctrl.metadata.paginationOptions.page"\n      md-total="{{$ctrl.data.items.length}}" \n      md-page-select="$ctrl.metadata.paginationOptions.pageSelect"\n      md-boundary-links="$ctrl.metadata.paginationOptions.boundaryLinks"\n      md-on-paginate="$ctrl.logPagination(page, limit)">\n    </md-table-pagination>\n  </md-card>\n</md-content>');
$templateCache.put('app/forms/main-page/add-form-dialog.tmpl.html','<md-dialog aria-label="Add new form dialog" flex="100" flex-gt-md="60" ng-cloak>\n  <md-toolbar aria-label="Create form dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">New form</p>\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-dialog-content layout-padding>\n\n    <form name="vm.newFormForm" ng-submit="vm.submit()" novalidate flex="100">\n      <md-list flex="80" flex-offset="10">\n\n        <md-subheader>Step 1: Give your form a suitably identifiable name and then choose to create from a template or\n          to clone an existing form.</md-subheader>\n\n        <md-list-item style="margin-top: 30px;">\n          <md-input-container class="md-block" flex>\n            <label>Form name</label>\n            <input type="text" ng-model="vm.newForm.formname" name="formname" aria-label="Form name" required\n              md-autofocus />\n            <div ng-messages="vm.newFormForm.formname.$error" md-auto-hide="false"\n              ng-show="vm.newFormForm.formname.$touched">\n              <div ng-message when="required">\n                <spanYour form is better with a name</span>\n              </div>\n            </div>\n          </md-input-container>\n        </md-list-item>\n\n        <md-list-item style="margin-top: 30px;" ng-hide="vm.cloneButtonDisabled">\n          <md-button class="md-primary zp-off-white-bg"\n            ng-class="{\'md-raised md-primary\': vm.newForm.formType == \'newForm\'}" ng-click="vm.setFormSeed(\'newForm\')"\n            flex>New form</md-button>\n          <md-button class="md-primary zp-off-white-bg"\n            ng-class="{\'md-raised md-primary\': vm.newForm.formType == \'cloneForm\'}"\n            ng-click="vm.setFormSeed(\'cloneForm\')" flex ng-disabled="vm.cloneButtonDisabled">Clone form</md-button>\n        </md-list-item>\n\n        <div ng-if="vm.newForm.formType == \'newForm\'">\n          <md-list-item style="margin-top: 25px;">\n            <zp-form-select-control flex config="vm.formTemplatesConfig" model="vm.newForm.formTemplate"\n              on-change="vm.setFormTemplateToUse({item: item})" required="vm.checkIfFieldIsRequired(\'formTemplate\')">\n            </zp-form-select-control>\n          </md-list-item>\n          <ng-container ng-if="vm.showUseFormSettingsSwitch">\n            <md-list-item>\n              <p>Clone Template Form Settings</p>\n              <md-switch ng-model="vm.newForm.cloneFormSettings" ng-change="vm.cloneFormSettingsChange()"\n                aria-label="Clone form settings" ng-true-value=1 ng-false-value=0 name="cloneFormSettings">\n              </md-switch>\n            </md-list-item>\n            <md-list-item>\n              <p>Clone Template Badge Settings</p>\n              <md-switch ng-model="vm.newForm.cloneBadgeSettings" aria-label="Clone badge settings" ng-true-value=1\n                ng-false-value=0 name="cloneBadgeSettings">\n              </md-switch>\n            </md-list-item>\n          </ng-container>\n        </div>\n\n        <div ng-if="vm.newForm.formType == \'cloneForm\'">\n          <md-list-item style="margin-top: 25px;">\n            <zp-form-select-control flex config="vm.cloneFormConfig" model="vm.newForm.cloneSourceForm"\n              on-change="vm.grabFormToClone({item: item})" aria-label="vm.formTemplatesConfig.label"\n              required="vm.checkIfFieldIsRequired(\'cloneSourceFormId\')">\n            </zp-form-select-control>\n          </md-list-item>\n          <md-list-item>\n            <p>Clone Form Settings</p>\n            <md-switch ng-model="vm.newForm.cloneFormSettings" ng-change="vm.cloneFormSettingsChange()"\n              aria-label="Clone form settings" ng-true-value=1 ng-false-value=0 name="cloneFormSettings">\n            </md-switch>\n          </md-list-item>\n          <md-list-item>\n            <p>Clone Badge Settings</p>\n            <md-switch ng-model="vm.newForm.cloneBadgeSettings" aria-label="Clone badge settings" ng-true-value=1\n              ng-false-value=0 name="cloneBadgeSettings">\n            </md-switch>\n          </md-list-item>\n        </div>\n\n        <div ng-show="vm.showStep3">\n          <md-subheader style="margin-top: 20px;">Step 2: Add the event dates and double check everything is correct.\n          </md-subheader>\n\n          <md-list-item style="margin-top: 30px;">\n            <md-input-container>\n              <label>Form start date</label>\n              <md-datepicker flex ng-model="vm.newForm.startdate" md-placeholder="Start date" ng-required="true"\n                name="startdate" ng-change="vm.startDateChanged()" md-open-on-focus\n                md-date-filter="vm.validateStartDate(vm.newForm.startdate)">\n              </md-datepicker>\n              <div ng-messages="vm.newFormForm.startdate.$error">\n                <div ng-message="required">Start date is required</div>\n              </div>\n            </md-input-container>\n            <span flex></span>\n            <md-input-container>\n              <label>Form end date</label>\n              <md-datepicker flex ng-model="vm.newForm.enddate" md-min-date="vm.newForm.startdate"\n                md-placeholder="End date" ng-required="true" name="enddate" md-open-on-focus>\n              </md-datepicker>\n              <div ng-messages="vm.newFormForm.enddate.$error">\n                <div ng-message="required">End date is required</div>\n              </div>\n            </md-input-container>\n          </md-list-item>\n\n          <md-list-item>\n            <zp-select-control flex="100" model="vm.newForm.formTimezone"\n              on-change="vm.updateFormTimezone({item: item})" config="vm.formTimezonesConfig">\n            </zp-select-control>\n          </md-list-item>\n\n          <md-list-item>\n            <zp-email-template-select-control flex="100" model="vm.newForm.emailTemplate"\n              on-change="vm.updateEmailTemplate({item: item})" config="vm.emailTemplateConfig" context="\'formSettings\'">\n            </zp-email-template-select-control>\n\n          </md-list-item>\n\n          <md-list-item>\n            <p>Publish form</p>\n            <md-switch ng-model="vm.newForm.published" aria-label="Publish form" ng-true-value=1 ng-false-value=0\n              name="published">\n            </md-switch>\n          </md-list-item>\n        </div>\n\n      </md-list>\n\n      <div flex="80" flex-offset="10" layout-padding ng-show="vm.newFormForm.$valid">\n        <p class="md-title ">You are about to create a new Zuant form called <strong>{{vm.newForm.formname}}</strong>\n          <span ng-show="vm.newForm.formType == \'newForm\'">using the <strong>{{vm.formTemplateTitle}}</strong>\n            template.</span>\n          <span ng-show="vm.newForm.formType == \'cloneForm\'">by cloning the <strong>{{vm.cloneSourceFormTitle}}</strong>\n            form.</span><br>\n          <span ng-if="vm.newForm.cloneSettings">You have selected to clone <strong>all</strong> the form\n            settings.<br></span>\n          <span\n            ng-if="vm.newForm.formTemplateId !== \'websummit_2024\' && vm.newForm.formTemplateId !== \'ieee_2022\' && vm.newForm.formTemplateId !== \'ieee_2026_esw\' && vm.newForm.formTemplateId !== \'collision_2023\' && vm.newForm.formTemplateId !== \'thenextweb_2022\' && vm.newForm.formTemplateId !== \'sibs_2022\' && vm.newForm.formTemplateId !== \'esgct_2024\' && vm.newForm.formTemplateId !== \'iemdc_2025\' && vm.newForm.formTemplateId !== \'nls_2026_days\'">\n            <!-- /** POTATO */ -->\n            The form runs from <strong>{{vm.newForm.startdate | date : \'longDate\'}}</strong> until\n            <strong>{{vm.newForm.enddate | date : \'longDate\'}}</strong>.<br>\n            The timezone for the form is set to <strong>{{vm.newForm.formTimezone}}</strong> and so all timestamps will\n            be adjusted accordingly. <br>\n            <span ng-show="vm.newForm.emailTemplate">Thank you emails will be sent using the\n              <strong>{{vm.emailTemplateTitle}}</strong> email template.</span>\n            <span ng-show="!vm.newForm.emailTemplate">No email template has been selected: no thank you emails will be\n              sent.</span>\n          </span>\n        </p>\n        <p class="md-subhead faded-text">Looking good? Click save and close to return to the forms screen or click the\n          other button to continue configuring the form further.</p>\n      </div>\n\n      <md-dialog-actions layout="row">\n        <span flex></span>\n        <!-- <md-button ng-click="vm.cancelDialog()">\n          Cancel\n        </md-button> -->\n        <md-button ng-disabled="vm.newFormForm.$invalid || vm.disableSaveButton" aria-label="Create form"\n          ng-click="vm.submit(true)">\n          <md-icon md-font-icon="zmdi zmdi-floppy"></md-icon>\n          <md-icon md-font-icon="zmdi zmdi-settings"></md-icon>\n          <md-tooltip md-direction="top">Save & go to settings</md-tooltip>\n        </md-button>\n\n        <md-button ng-disabled="vm.newFormForm.$invalid || vm.disableSaveButton" aria-label="Create form" type="submit"\n          class="md-primary" ng-class="{\'md-raised\' : vm.newFormForm.$valid}">\n          <md-progress-circular style="left: 5px;" md-mode="indeterminate" ng-if="vm.disableSaveButton"\n            class="md-accent"></md-progress-circular>\n          <span ng-if="!vm.disableSaveButton">Save & Close</span>\n        </md-button>\n      </md-dialog-actions>\n      <input type="hidden" name="CSRFToken" value="1231234567890" />\n    </form>\n  </md-dialog-content>\n</md-dialog>');
$templateCache.put('app/forms/reporting/zp-reporting-page.tmpl.html','<md-progress-linear ng-show="$ctrl.responseAggregationFactoryData.loading" md-mode="indeterminate" class="md-accent">\n</md-progress-linear>\n\n<zp-no-data ng-show="$ctrl.blankSlate" header="No charts yet." subhead=""\n  svgpath="{{\'/images/svgs/logos/zuant/cloud_logo_250.svg\' | cdnAssets}}" fontcolor="zuantLagoonRollover"\n  svgid="submitted_leads_blank">\n</zp-no-data>\n\n<md-content flex-gt-lg="90" flex-offset-gt-lg="5">\n  <div layout="column">\n    <!-- <div layout="row"\n      layout-align="space-between">\n      <p class="md-caption zp-caption uppercase">Report Info</p>\n        \n    </div> -->\n    <div layout-margin>\n      <p class="md-subhead margin-bottom-0 text-align-center" ng-show="!$ctrl.reportData.metadata.startDate">\n        No report range has been set. Report is showing all leads captured for this form.\n      </p>\n      <p class="md-subhead margin-top-0 margin-bottom-0 text-align-center"\n        ng-show="$ctrl.reportData.metadata.startDate">\n        <span class="zp-caption uppercase md-caption">Leads captured between</span><br>\n        <span class="md-title">\n          {{ $ctrl.reportData.metadata.startDate.caption }}</span>\n        -\n        <span class="md-title">\n          {{ $ctrl.reportData.metadata.endDate.caption }}\n        </span>\n      </p>\n      <p class="zp-caption uppercase md-caption margin-bottom-0 margin-top-10 text-align-center"\n        ng-show="($ctrl.ResponseAggregationModelFactoryData.sortedLeadsArray.length - $ctrl.headlineWidgets.items[0].countupto) >= 1">\n        There\'s a total of {{$ctrl.ResponseAggregationModelFactoryData.sortedLeadsArray.length}} leads for this event,\n        {{ $ctrl.ResponseAggregationModelFactoryData.sortedLeadsArray.length - $ctrl.headlineWidgets.items[0].countupto\n        }}\n        of which fall outside of the currently set reporting date range.</p>\n    </div>\n\n    <md-divider ng-show="$ctrl.visibilityPreferences.panels.info" style="margin-top:20px;"></md-divider>\n  </div>\n\n  <div layout="column">\n    <div layout="row" layout-align="space-between" ng-click="$ctrl.togglePanelVisibility(\'headlines\')" layout-padding\n      ng-mouseenter="headlinesHover = true" ng-mouseleave="headlinesHover = false"\n      ng-class="{\'hoverBackground\': headlinesHover}">\n      <p class="md-caption zp-caption">\n        <span class="uppercase">\n          The Headlines\n        </span>\n        <span ng-if="$ctrl.widgetsHidden(\'headlineWidgets\')">\n          ({{$ctrl.headlineWidgets.hiddenCount}} <span>{{$ctrl.headlineWidgets.hiddenCount > 1 ? \'widgets\':\n            \'widget\'}}</span> not in report - widgets with no data are automatically hidden)\n        </span>\n      </p>\n      <md-button class="md-icon-button">\n        <ng-md-icon icon="{{$ctrl.visibilityPreferences.panels.headlines ? \'expand_less\' : \'expand_more\'}}"\n          style="fill: #949ca1;"></ng-md-icon>\n      </md-button>\n    </div>\n\n    <div layout="row" layout-align="space-around center" layout-wrap\n      ng-show="$ctrl.visibilityPreferences.panels.headlines" layout-margin>\n      <zp-headline-widget ng-repeat="widget in $ctrl.headlineWidgets.items" id="{{widget.id}}"\n        ng-if="widget.inReport && !widget.isEmpty" widget-data="widget" layout-margin>\n      </zp-headline-widget>\n    </div>\n    <md-divider ng-show="$ctrl.visibilityPreferences.panels.headlines" style="margin-top:20px;"></md-divider>\n  </div>\n\n  <div layout="column">\n    <div layout="row" layout-align="space-between" ng-click="$ctrl.togglePanelVisibility(\'time\')" layout-padding\n      ng-mouseenter="timeHover = true" ng-mouseleave="timeHover = false" ng-class="{\'hoverBackground\': timeHover}">\n      <p class="md-caption zp-caption">\n        <span class="uppercase">Time Widgets</span>\n        <span ng-if="$ctrl.widgetsHidden(\'timeWidgets\') && $ctrl.widgetsHidden(\'revenueWidgets\')">\n          ({{$ctrl.timeWidgets.hiddenCount + $ctrl.revenueWidgets.hiddenCount}} <span>{{($ctrl.timeWidgets.hiddenCount +\n            $ctrl.revenueWidgete.hiddenCount) > 1 ? \'widgets\': \'widget\'}}</span>\n          not in report - widgets with no data are automatically hidden)\n        </span>\n      </p>\n      <md-button class="md-icon-button">\n        <ng-md-icon icon="{{$ctrl.visibilityPreferences.panels.time ? \'expand_less\' : \'expand_more\'}}"\n          style="fill: #949ca1;"></ng-md-icon>\n      </md-button>\n    </div>\n    <div layout="column" layout-gt-sm="row" ng-show="$ctrl.visibilityPreferences.panels.time" layout-fill>\n      <div layout="row" flex-order="2" flex-order-gt-sm="1" layout-wrap flex="70">\n        <zp-time-report-widget flex="90" flex-offset="5"\n          flex-md="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_960_1280.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_960_1280.belowThresholdFlex }}"\n          flex-offset-md="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_960_1280.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_960_1280.belowThresholdFlexOffset }}"\n          flex-gt-md="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1280.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_gt_1280.belowThresholdFlex }}"\n          flex-offset-gt-md="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1280.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_gt_1280.belowThresholdFlexOffset }}"\n          flex-gt-lg="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1920.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_gt_1920.belowThresholdFlex }}"\n          flex-offset-gt-lg="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1920.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_gt_1920.belowThresholdFlexOffset }}"\n          ng-show="$ctrl.timeWidgets.itemsObject.leadsByDay.inReport && !$ctrl.timeWidgets.itemsObject.leadsByDay.isEmpty"\n          widget-data="$ctrl.timeWidgets.itemsObject.leadsByDay" form-id="$ctrl.formId"\n          id="{{$ctrl.timeWidgets.itemsObject.leadsByDay.id}}">\n        </zp-time-report-widget>\n\n        <zp-time-report-widget flex="90" flex-offset="5"\n          flex-md="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_960_1280.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_960_1280.belowThresholdFlex }}"\n          flex-offset-md="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_960_1280.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_960_1280.belowThresholdFlexOffset }}"\n          flex-gt-md="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1280.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_gt_1280.belowThresholdFlex }}"\n          flex-offset-gt-md="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1280.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_gt_1280.belowThresholdFlexOffset }}"\n          flex-gt-lg="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1920.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_gt_1920.belowThresholdFlex }}"\n          flex-offset-gt-lg="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1920.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_gt_1920.belowThresholdFlexOffset }}"\n          ng-show="$ctrl.timeWidgets.itemsObject.leadsByDayByUser.inReport && ! $ctrl.timeWidgets.itemsObject.leadsByDayByUser.isEmpty"\n          widget-data="$ctrl.timeWidgets.itemsObject.leadsByDayByUser" form-id="$ctrl.formId"\n          id="{{$ctrl.timeWidgets.itemsObject.leadsByDayByUser.id}}">\n        </zp-time-report-widget>\n\n        <zp-time-report-widget flex="90" flex-offset="5"\n          flex-md="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_960_1280.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_960_1280.belowThresholdFlex }}"\n          flex-offset-md="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_960_1280.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_960_1280.belowThresholdFlexOffset }}"\n          flex-gt-md="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1280.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_gt_1280.belowThresholdFlex }}"\n          flex-offset-gt-md="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1280.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_gt_1280.belowThresholdFlexOffset }}"\n          flex-gt-lg="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1920.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_gt_1920.belowThresholdFlex }}"\n          flex-offset-gt-lg="{{ $ctrl.timeWidgets.itemsObject.leadsByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1920.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_gt_1920.belowThresholdFlexOffset }}"\n          ng-show="$ctrl.timeWidgets.itemsObject.leadsByHour.inReport && !$ctrl.timeWidgets.itemsObject.leadsByHour.isEmpty"\n          widget-data="$ctrl.timeWidgets.itemsObject.leadsByHour" form-id="$ctrl.formId"\n          id="{{$ctrl.timeWidgets.itemsObject.leadsByHour.id}}">\n        </zp-time-report-widget>\n\n      </div>\n\n      <div layout="column" layout-sm="row" flex="nogrow" flex-order="1" flex-order-gt-sm="2">\n\n        <zp-top-performer-widget flex-sm="50"\n          ng-show="$ctrl.timeWidgets.itemsObject.leadsTopPerformer.inReport && !$ctrl.timeWidgets.itemsObject.leadsTopPerformer.isEmpty"\n          widget-data="$ctrl.timeWidgets.itemsObject.leadsTopPerformer" id="leadsTopPerformer">\n        </zp-top-performer-widget>\n\n        <zp-team-performance-widget flex-sm="50"\n          ng-show="$ctrl.timeWidgets.itemsObject.leadsTeamPerformance.inReport && !$ctrl.timeWidgets.itemsObject.leadsTeamPerformance.isEmpty"\n          widget-data="$ctrl.timeWidgets.itemsObject.leadsTeamPerformance" id="leadsTeamPerformance">\n        </zp-team-performance-widget>\n\n      </div>\n    </div>\n\n    <md-divider ng-if="$ctrl.revenueWidgets.hiddenCount < 5" style="margin-top:20px; margin-bottom:10px"></md-divider>\n\n    <div layout="column" layout-gt-sm="row" ng-show="$ctrl.visibilityPreferences.panels.time" layout-fill>\n      <div layout="row" flex-order="2" flex-order-gt-sm="1" layout-wrap flex="70">\n\n        <zp-time-report-widget flex="90" flex-offset="5"\n          flex-md="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_960_1280.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_960_1280.belowThresholdFlex }}"\n          flex-offset-md="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_960_1280.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_960_1280.belowThresholdFlexOffset }}"\n          flex-gt-md="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1280.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_gt_1280.belowThresholdFlex }}"\n          flex-offset-gt-md="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1280.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_gt_1280.belowThresholdFlexOffset }}"\n          flex-gt-lg="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1920.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_gt_1920.belowThresholdFlex }}"\n          flex-offset-gt-lg="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1920.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_gt_1920.belowThresholdFlexOffset }}"\n          ng-show="$ctrl.revenueWidgets.itemsObject.revenueByDay.inReport && !$ctrl.revenueWidgets.itemsObject.revenueByDay.isEmpty"\n          widget-data="$ctrl.revenueWidgets.itemsObject.revenueByDay" form-id="$ctrl.formId"\n          id="{{$ctrl.revenueWidgets.itemsObject.revenueByDay.id}}">\n        </zp-time-report-widget>\n\n        <zp-time-report-widget flex="90" flex-offset="5"\n          flex-md="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_960_1280.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_960_1280.belowThresholdFlex }}"\n          flex-offset-md="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_960_1280.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_960_1280.belowThresholdFlexOffset }}"\n          flex-gt-md="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1280.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_gt_1280.belowThresholdFlex }}"\n          flex-offset-gt-md="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1280.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_gt_1280.belowThresholdFlexOffset }}"\n          flex-gt-lg="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1920.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_gt_1920.belowThresholdFlex }}"\n          flex-offset-gt-lg="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1920.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_gt_1920.belowThresholdFlexOffset }}"\n          ng-show="$ctrl.revenueWidgets.itemsObject.revenueByDayByUser.inReport && !$ctrl.revenueWidgets.itemsObject.revenueByDayByUser.isEmpty"\n          widget-data="$ctrl.revenueWidgets.itemsObject.revenueByDayByUser" form-id="$ctrl.formId"\n          id="{{$ctrl.revenueWidgets.itemsObject.revenueByDayByUser.id}}">\n        </zp-time-report-widget>\n\n        <zp-time-report-widget flex="90" flex-offset="5"\n          flex-md="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_960_1280.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_960_1280.belowThresholdFlex }}"\n          flex-offset-md="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_960_1280.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_960_1280.belowThresholdFlexOffset }}"\n          flex-gt-md="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1280.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_gt_1280.belowThresholdFlex }}"\n          flex-offset-gt-md="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1280.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_gt_1280.belowThresholdFlexOffset }}"\n          flex-gt-lg="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1920.aboveThresholdFlex : $ctrl.chartBreakPoints.viewPort_gt_1920.belowThresholdFlex }}"\n          flex-offset-gt-lg="{{ $ctrl.revenueWidgets.itemsObject.revenueByDay.tableData.length >= $ctrl.chartBreakPoints.datapointThreshold ? $ctrl.chartBreakPoints.viewPort_gt_1920.aboveThresholdFlexOffset : $ctrl.chartBreakPoints.viewPort_gt_1920.belowThresholdFlexOffset }}"\n          ng-show="$ctrl.revenueWidgets.itemsObject.revenueByHour.inReport && !$ctrl.revenueWidgets.itemsObject.revenueByHour.isEmpty"\n          widget-data="$ctrl.revenueWidgets.itemsObject.revenueByHour" form-id="$ctrl.formId"\n          id="{{$ctrl.revenueWidgets.itemsObject.revenueByHour.id}}">\n        </zp-time-report-widget>\n\n      </div>\n\n      <div layout="column" layout-sm="row" flex="nogrow" flex-order="1" flex-order-gt-sm="2">\n\n        <zp-top-performer-widget flex-sm="50"\n          ng-show="$ctrl.revenueWidgets.itemsObject.revenueTopPerformer.inReport && !$ctrl.revenueWidgets.itemsObject.revenueTopPerformer.isEmpty"\n          widget-data="$ctrl.revenueWidgets.itemsObject.revenueTopPerformer" id="revenueTopPerformer">\n        </zp-top-performer-widget>\n\n        <zp-team-performance-widget flex-sm="50"\n          ng-show="$ctrl.revenueWidgets.itemsObject.revenueTeamPerformance.inReport && !$ctrl.revenueWidgets.itemsObject.revenueTeamPerformance.isEmpty"\n          widget-data="$ctrl.revenueWidgets.itemsObject.revenueTeamPerformance" id="revenueTeamPerformance">\n        </zp-team-performance-widget>\n\n      </div>\n    </div>\n    <md-divider ng-show="$ctrl.visibilityPreferences.panels.time" style="margin-top:20px;"></md-divider>\n  </div>\n\n  <!--  QUESTION SUMMARY WIDGETS -->\n  <div layout="column">\n    <div layout="row" layout-align="space-between" ng-click="$ctrl.togglePanelVisibility(\'questions\')" layout-padding\n      ng-mouseenter="questionsHover = true" ng-mouseleave="questionsHover = false"\n      ng-class="{\'hoverBackground\': questionsHover}">\n      <p class="md-caption zp-caption">\n        <span class="uppercase">\n          Question Chart Widgets\n        </span>\n        <span ng-if="$ctrl.widgetsHidden(\'questionChartWidgets\')">\n          ({{$ctrl.questionChartWidgets.hiddenCount}} <span>{{$ctrl.questionChartWidgets.hiddenCount > 1 ? \'widgets\':\n            \'widget\'}}</span> not in report - widgets with no data are automatically hidden)\n        </span>\n      </p>\n      <md-button class="md-icon-button">\n        <ng-md-icon icon="{{$ctrl.visibilityPreferences.panels.questions ? \'expand_less\' : \'expand_more\'}}"\n          style="fill: #949ca1;"></ng-md-icon>\n      </md-button>\n    </div>\n    <div layout="row" layout-wrap ng-show="!$ctrl.blankSlate && $ctrl.visibilityPreferences.panels.questions">\n      <zp-question-chart-widget ng-if="item.inReport && !item.isEmpty"\n        ng-repeat="item in $ctrl.questionChartWidgets.items track by $ctrl.trackingFunction(item)"\n        form-id="$ctrl.formId" class="questionChartWidget" widget-data="item" flex="100" flex-offset="0"\n        flex-offset-gt-sm="5" flex-offset-gt-md="0" flex-gt-sm="90" flex-gt-md="50">\n      </zp-question-chart-widget>\n    </div>\n    <md-divider ng-show="$ctrl.visibilityPreferences.panels.questions" style="margin-top:20px;"></md-divider>\n  </div>\n\n  <!--  SHOWROOM WIDGETS -->\n  <div layout="column">\n    <div layout="row" layout-align="space-between" ng-click="$ctrl.togglePanelVisibility(\'showroom\')" layout-padding\n      ng-mouseenter="showroomHover = true" ng-mouseleave="showroomHover = false"\n      ng-class="{\'hoverBackground\': showroomHover}">\n      <p class="md-caption zp-caption">\n        <span class="uppercase">Showroom Widgets</span>\n        <span ng-if="$ctrl.widgetsHidden(\'showroomWidgets\')">\n          ({{$ctrl.showroomWidgets.hiddenCount}} <span>{{$ctrl.showroomWidgets.hiddenCount > 1 ? \'widgets\':\n            \'widget\'}}</span> not in report - widgets with no data are automatically hidden)\n        </span>\n      </p>\n\n      <md-button class="md-icon-button">\n        <ng-md-icon icon="{{$ctrl.visibilityPreferences.panels.showroom ? \'expand_less\' : \'expand_more\'}}"\n          style="fill: #949ca1;"></ng-md-icon>\n      </md-button>\n    </div>\n    <div layout="row" layout-wrap ng-show="!$ctrl.blankSlate && $ctrl.visibilityPreferences.panels.showroom">\n      <zp-showroom-report-widget ng-if="item.inReport && !item.isEmpty" ng-repeat="item in $ctrl.showroomWidgets.items"\n        form-id="$ctrl.formId" widget-data="item" flex="100" flex-offset="0" flex-offset-gt-sm="5" flex-gt-sm="90"\n        flex-offset-gt-lg="10" flex-gt-lg="80" class="showroomReportWidget">\n      </zp-showroom-report-widget>\n    </div>\n    <md-divider ng-show="$ctrl.visibilityPreferences.panels.showroom" style="margin-top:20px;"></md-divider>\n  </div>\n\n  <!-- EMAIL PERFORMANCE WIDGETS -->\n  <div layout="column" id="emailSection">\n    <div layout="row" layout-align="space-between" ng-click="$ctrl.togglePanelVisibility(\'email\')" layout-padding\n      ng-mouseenter="emailHover = true" ng-mouseleave="emailHover = false" ng-class="{\'hoverBackground\': emailHover}">\n      <p class="md-caption zp-caption" style="margin: 0px;">\n        <span class="uppercase">Email Performance</span>\n        <span ng-show="$ctrl.widgetsHidden(\'emailHeadlineWidgets\',\'emailPerformanceWidgets\')">\n          ({{$ctrl.emailWidgetsCombinedHiddenCount}} <span>{{$ctrl.emailWidgetsCombinedHiddenCount > 1 ? \'widgets\':\n            \'widget\'}}</span> not in report - widgets with no data are automatically hidden)\n        </span>\n        <a href="http://help.zuant.com/en/articles/3560012-follow-up-email-reporting" target="_blank">\n          <md-button class="md-icon-button">\n            <md-icon md-font-icon="zmdi zmdi-help" style="color: #C8CBCD;"></md-icon>\n          </md-button>\n        </a>\n      </p>\n      <div ng-show="$ctrl.showEmailDeliveredPriorToLaunchMessage">\n        <md-button class="md-icon-button">\n          <md-icon md-font-icon="zmdi zmdi-comment-alert" style="color: #FEC353;"></md-icon>\n        </md-button>\n        <span style="color: #949ca1"><strong>Please note: </strong>Emails sent prior to tracking going live on December\n          16th, 2019 won\'t have had the delivery event recorded.</span>\n      </div>\n      <md-button class="md-icon-button">\n        <ng-md-icon icon="{{$ctrl.visibilityPreferences.panels.email ? \'expand_less\' : \'expand_more\'}}"\n          style="fill: #949ca1;"></ng-md-icon>\n      </md-button>\n    </div>\n    <div ng-show="!$ctrl.blankSlate && $ctrl.visibilityPreferences.panels.email">\n      <div layout="column" layout-padding>\n        <div layout="row" layout-align="space-around center" layout-wrap>\n          <zp-email-headline-widget ng-repeat="item in $ctrl.emailHeadlineWidgets.items" id="{{item.id}}"\n            ng-if="item.inReport && !item.isEmpty" widget-data="item" form-id="$ctrl.formId" layout-margin>\n          </zp-email-headline-widget>\n        </div>\n      </div>\n      <div layout="row" layout-wrap>\n        <zp-email-report-widget ng-repeat="item in $ctrl.emailPerformanceWidgets.items"\n          ng-if="item.inReport && !item.isEmpty" form-id="$ctrl.formId" widget-data="item" id="{{item.id}}" flex="100"\n          flex-offset="0" flex-offset-gt-sm="5" flex-gt-sm="90" flex-gt-md="50" flex-offset-gt-md="0">\n        </zp-email-report-widget>\n      </div>\n    </div>\n    <md-divider ng-show="$ctrl.visibilityPreferences.panels.email" style="margin-top:80px;"></md-divider>\n  </div>\n\n</md-content>');
$templateCache.put('app/forms/settings-page/settings.tmpl.html','<div layout="column" layout-fill>\n\n  <md-content>\n    <md-card flex="100" flex-offset-gt-md="25" flex-gt-md="50" style="margin-top:30px;" class="animated tada"\n      ng-class="$ctrl.stopShouting ? \'md-whiteframe-2dp\': \'md-whiteframe-10dp\'" ng-if="$ctrl.gridColumnWarnings.length">\n      <div ng-include="\'app/forms/settings-page/cards/warnings.tmpl.html\'"></div>\n    </md-card>\n\n    <md-card flex="100" flex-offset-gt-md="25" flex-gt-md="50" style="margin-top:30px;">\n      <div ng-include="\'app/forms/settings-page/cards/form-info-tab.tmpl.html\'"></div>\n    </md-card>\n\n    <md-card flex="100" flex-offset-gt-md="25" flex-gt-md="50" style="margin-top:30px;">\n      <div ng-include="\'app/forms/settings-page/cards/email-settings.tmpl.html\'"></div>\n    </md-card>\n\n    <md-card flex="100" flex-offset-gt-md="25" flex-gt-md="50" style="margin-top:30px;" permission\n      permission-only="$ctrl.permissions.boltOns.ocr.enabled">\n      <div ng-include="\'app/forms/settings-page/cards/OCR-tab.tmpl.html\'"></div>\n    </md-card>\n\n    <md-card flex="100" flex-offset-gt-md="25" flex-gt-md="50" style="margin-top:30px;" permission\n      permission-only="$ctrl.permissions.boltOns.ai.enabled">\n      <div ng-include="\'app/forms/settings-page/cards/ai-settings.tmpl.html\'"></div>\n    </md-card>\n\n    <md-card flex="100" flex-offset-gt-md="25" flex-gt-md="50" style="margin-top:30px;" permission\n      permission-only="$ctrl.permissions.boltOns.showroom.enabled">\n      <div ng-include="\'app/forms/settings-page/cards/showroom-tab.tmpl.html\'"></div>\n    </md-card>\n\n    <md-card flex="100" flex-offset-gt-md="25" flex-gt-md="50" style="margin-top:30px;" permission\n      permission-only="$ctrl.permissions.zuant_admin">\n      <div ng-include="\'app/forms/settings-page/cards/scanner-tab.tmpl.html\'"></div>\n    </md-card>\n\n    <md-card flex="100" flex-offset-gt-md="25" flex-gt-md="50" style="margin-top:30px;" permission\n      permission-only="$ctrl.permissions.boltOns.integration.enabled">\n      <div ng-include="\'app/forms/settings-page/cards/integration-tab.tmpl.html\'"></div>\n    </md-card>\n\n    <md-card flex="100" flex-offset-gt-md="25" flex-gt-md="50" style="margin-top:30px;">\n      <div ng-include="\'app/forms/settings-page/cards/contact-filter-settings-tab.tmpl.html\'"></div>\n    </md-card>\n\n\n    <md-card flex="100" flex-offset-gt-md="25" flex-gt-md="50" style="margin-top:30px;">\n      <div ng-include="\'app/forms/settings-page/cards/e-z-menu.tmpl.html\'"></div>\n    </md-card>\n\n    <md-card flex="100" flex-offset-gt-md="25" flex-gt-md="50" style="margin-top:30px;" permission\n      permission-only="$ctrl.permissions.zuant_admin">\n      <div ng-include="\'app/forms/settings-page/cards/advanced-settings-tab.tmpl.html\'"></div>\n    </md-card>\n\n    <md-card flex="100" flex-offset-gt-md="25" flex-gt-md="50" style="margin-top:30px;">\n      <div ng-include="\'app/forms/settings-page/cards/compliance-tab.tmpl.html\'"></div>\n    </md-card>\n\n    <md-card ng-if="$ctrl.teams.length > 0" flex="100" flex-offset-gt-md="25" flex-gt-md="50" style="margin-top:30px;">\n      <div ng-include="\'app/forms/settings-page/cards/visibility-tab.tmpl.html\'"></div>\n    </md-card>\n\n    <div layout="column" layout-align="end center" style="height:200px;" layout-padding layout-margin>\n      <div ng-show="$ctrl.sureToBeSure">\n        <p class="md-subtitle text-align-center zp-caption">Are you absolutely sure?</p>\n        <div layout layout-align="center center">\n          <md-button class="md-warn md-raised md-icon-button" ng-click="$ctrl.confirmDeleteForm()">\n            <md-icon md-font-icon="zmdi zmdi-thumb-up"></md-icon>\n          </md-button>\n          <md-button class="md-raised md-icon-button" ng-click="$ctrl.sureToBeSure = false">\n            <md-icon md-font-icon="zmdi zmdi-thumb-down"></md-icon>\n          </md-button>\n        </div>\n        <p class="md-caption margin-top-10 margin-bottom-0" style="color: rgba(0,0,0,.5);">Delete\n          {{$ctrl.formProperties.formname}} ?</p>\n        <p class="md-caption margin-top-10" style="color: rgba(0,0,0,.5);">(DEV USE ONLY DELETION WONT SYNC TO DEVICES)\n        </p>\n\n      </div>\n      <md-button class="md-icon-button" ng-click="$ctrl.deleteForm()" ng-if="$ctrl.isDev">\n        <md-icon md-font-icon="zmdi zmdi-delete"></md-icon>\n        <md-tooltip md-direction="down">Delete form</md-tooltip>\n      </md-button>\n    </div>\n  </md-content>\n</div>\n\n<md-sidenav id="settingsPanel" md-component-id=\'settingsPanel\' class="md-sidenav-right">\n  <zp-user-preferences></zp-user-preferences>\n</md-sidenav>');
$templateCache.put('app/lists/main/_lists.add-list-dialog.tmpl.html','<md-dialog aria-label="Add a new list" flex="100" flex-gt-sm="60">\n  <md-toolbar aria-label="Create list dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">New list</p>\n      <span flex></span>\n      <md-button ng-click="vm.cancel()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-dialog-content layout-padding>\n\n    <form name="vm.newListForm" ng-submit="vm.submit()" novalidate flex="100">\n      <div layout="row" layout-align="center center">\n        <md-list flex="95">\n          <md-subheader>Step 1: Begin by giving your list a title</md-subheader>\n\n          <md-list-item style="margin-top: 15px;">\n            <md-input-container class="md-block" flex>\n              <label>List title</label>\n              <input type="text" ng-model="vm.listTitle" ng-change="vm.listTitleChanged()" name="listTitle"\n                aria-label="List title" md-autofocus required>\n              <div ng-messages="vm.newListForm.listTitle.$error" ng-if="vm.newListForm.listTitle.$touched">\n                <div ng-message="required">A list title is required</div>\n                <div ng-message="listTitleExists">A list with that title already exists</div>\n              </div>\n            </md-input-container>\n          </md-list-item>\n\n          <md-list-item style="margin-top: 15px;">\n            <md-button class="md-primary zp-off-white-bg" ng-class="{\'md-raised md-primary\': vm.source == \'new\'}"\n              ng-click="vm.source = \'new\'" flex>New list</md-button>\n            <md-button class="md-primary zp-off-white-bg" ng-show="vm.currentLists.length"\n              ng-class="{\'md-raised md-primary\': vm.source == \'clone\'}" ng-click="vm.source = \'clone\'" flex>Clone list\n            </md-button>\n            <md-button class="md-primary zp-off-white-bg" ng-class="{\'md-raised md-primary\': vm.source == \'upload\'}"\n              ng-click="vm.source = \'upload\'" flex>Upload list\n            </md-button>\n          </md-list-item>\n\n          <md-list-item style="margin-top: 15px;" ng-show="vm.source === \'clone\'">\n            <zp-list-autocomplete-control flex model="vm.cloneSourceArtefactId" items="vm.currentLists"\n              config="vm.listAutocompleteConfig">\n            </zp-list-autocomplete-control>\n          </md-list-item>\n\n          <md-list-item style="margin-top: 15px;" ng-show="vm.source === \'new\'">\n            <zp-list-templates-select-control flex model="vm.listTemplateId" config="vm.templateAutocompleteConfig">\n            </zp-list-templates-select-control>\n          </md-list-item>\n        </md-list>\n      </div>\n\n      <div style="margin-top: 5px;" layout="row" layout-align="center center" ng-show="vm.source == \'upload\'">\n        <div flex="95" class="zuantTitanium1" layout="column">\n          <p><b>Start the list creation process by uploading a CSV file. Make sure your CSV aligns with\n              the\n              provided \'Available CSV headers\' & then use the \'UPLOAD CSV\' button to proceed.</b></p>\n          <span>\n            Available CSV headers:\n            <span ng-repeat="availableHeader in vm.avaliableCsvHeaders track by $index">\n              <b>"{{ availableHeader.name }}"</b>{{ availableHeader.description }} {{ ($index <\n                vm.avaliableCsvHeaders.length - 1) ? \', \' : \'\' }} </span>\n            </span>\n\n            <a style="margin-top: 10px; width: fit-content;" class="zuantLagoon"\n              ng-href="{{\'/csvs/list-import/zuant-example-list-import.csv\' | cdnAssets}}">Download Example CSV\n              File</a>\n\n            <ul>\n              <li>caption = list value as it will appear in the Zuant App.</li>\n              <li>code = list value as it will appear in the Lead Grid.</li>\n              <li>reportingLabel = list value as it will appear in your Dashboard widgets.</li>\n              <li>points = value for Lead Scoring.</li>\n              <li>showMoreInfoTextField = put a "1" in this column to show a free text field when value is selected.\n              </li>\n            </ul>\n\n            <div style="margin-top: 5px; margin-bottom: 5px;" flex layout="row" layout-align="start start">\n\n              <div ng-if="vm.fileUploaded" flex="grow" layout="column">\n                <span>File Name: <b>{{ vm.fileName }}</b></span>\n                <span>\n                  File Encoding: <b>{{ vm.fileEncoding }}</b>\n                </span>\n                <div ng-if="vm.recognisedCsvHeaders.length > 0">\n                  Recognised CSV headers:\n                  <span ng-repeat="recognisedHeader in vm.recognisedCsvHeaders track by $index">\n                    <b>"{{ recognisedHeader }}"</b>{{ ($index < vm.recognisedCsvHeaders.length - 1) ? \', \' : \'\' }}\n                      </span>\n                </div>\n\n                <div ng-if="vm.fileErrors.length === 0 && vm.fileItems.length > 0">\n                  Number Of Items: <b>{{ vm.fileItems.length }}</b>\n                </div>\n\n                <div class="zuantPollen" ng-if="vm.fileErrors.length === 0 && vm.fileWarnings.length > 0">\n                  Warnings:\n                  <ul>\n                    <li ng-repeat="warningObj in vm.fileWarnings">\n                      {{ warningObj.message }}\n                    </li>\n                  </ul>\n                </div>\n\n                <div class="zuantSaffron" ng-if="vm.fileErrors.length > 0">\n                  Errors:\n                  <ul>\n                    <li ng-repeat="errorObj in vm.fileErrors">\n                      {{ errorObj.error }}\n                    </li>\n                  </ul>\n                </div>\n\n                <div class="zuantSaffron" ng-if="vm.processErrors.length > 0">\n                  Process Errors:\n                  <ul>\n                    <li ng-repeat="errorObj in vm.processErrors">\n                      {{ errorObj.error }}\n                      <ul ng-if="errorObj.conflicts && errorObj.conflicts.length > 0">\n                        <li ng-repeat="conflict in errorObj.conflicts">\n                          <b>"{{ conflict }}"</b>\n                        </li>\n                      </ul>\n                    </li>\n                  </ul>\n                </div>\n\n              </div>\n\n              <div flex>\n              </div>\n\n              <md-button ng-disabled="vm.loading" layout-align="end start"\n                ng-class="{\'md-primary\': !vm.fileUploaded, \'md-accent\': vm.fileUploaded}" class="md-raised"\n                ng-click="vm.selectFile()">\n                {{ vm.fileUploaded ? \'Clear File\' : \'Upload CSV\' }}\n              </md-button>\n            </div>\n\n        </div>\n\n      </div>\n\n      <input type="hidden" name="CSRFToken" value="1231234567890" />\n    </form>\n    <md-dialog-actions>\n      <md-button class="md-warn" ng-click="vm.cancel()">Cancel</md-button>\n      <md-button class="md-primary" aria-label="Create list" ng-click="vm.submit($event)"\n        ng-disabled="vm.newListForm.$invalid || (vm.source === \'clone\' && !vm.cloneSourceArtefactId) || (vm.source === \'upload\' && (vm.fileItems.length === 0 || vm.fileErrors.length > 0))">Create\n        List</md-button>\n    </md-dialog-actions>\n  </md-dialog-content>\n</md-dialog>\n\n<input id="listUploadInput" type="file" accept=".csv" ng-upload-change="vm.fileChanged($event)" style="display:none" />');
$templateCache.put('app/biz-card/dialogs/add-dialog.tmpl.html','<md-dialog class="mobile-fullwidth-dialog" flex>\n    <md-toolbar class="toolbar-default" md-theme="{{vm.triSkin.elements.toolbar}}">\n        <div class="md-toolbar-tools">\n            <h2>\n                <span>{{vm.title}}</span>\n            </h2>\n            <span flex></span>\n            <md-button class="md-icon-button" ng-click="vm.cancel()" aria-label="cancel">\n                <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n            </md-button>\n        </div>\n    </md-toolbar>\n\n    <md-divider></md-divider>\n\n    <md-dialog-content class="sticky-container">\n        <div class="md-dialog-content">\n            <!-- content goes in here for the dialog -->\n            <h3>Content for the dialog goes in here.</h3>\n\n            <div layout="row" layout-padding>\n                <md-input-container flex>\n                    <label>Field 1</label>\n                    <input type="text" ng-model="">\n                </md-input-container>\n                <md-input-container flex>\n                    <label>Field 2</label>\n                    <input type="password" ng-model="">\n                </md-input-container>\n            </div>\n            <div layout="row" layout-padding layout-align="center end">\n                <md-input-container flex>\n                    <md-select class="md-select-form" ng-model="vm.user.favouriteColor" placeholder="Dropdown" >\n                        <md-option ng-value="option" ng-repeat="option in [\'Option 1\', \'Option 2\', \'Option 3\']">{{option}}</md-option>\n                    </md-select>\n                </md-input-container>\n                <md-input-container flex>\n                    <label>Textarea</label>\n                    <textarea ng-model=""></textarea>\n                </md-input-container>\n            </div>\n\n        </div>\n    </md-dialog-content>\n\n    <div class="md-actions" layout="row">\n        <span flex></span>\n        <md-button ng-click="vm.confirm()" class="md-primary" ng-disabled="" aria-label="send">Confirm Action</md-button>\n    </div>\n</md-dialog>\n');
$templateCache.put('app/biz-card/dialogs/build-biz-card-db-dialog.tmpl.html','<md-dialog aria-label="Build Business Card Database">\n    <form>\n        <md-toolbar>\n            <div class="md-toolbar-tools">\n                <h2 ng-if="!updateOnly" >Build Business Card Database</h2>\n                <h2 ng-if="updateOnly" >Update Business Card Database</h2>\n            </div>\n        </md-toolbar>\n        <md-dialog-content>\n            <div class="md-dialog-content" ng-if="!loading">\n                <h2>Progress ({{clientsProcessed}} of {{numOfClients}} clients processed)<br /></h2>\n                <div layout="row" flex>\n                    <md-progress-linear class="margin-bottom-20" md-mode="determinate" value="{{clientsProcessedProgress}}"></md-progress-linear>\n                </div>\n                <md-toolbar class="md-warn" ng-if="terminate">\n                    <h2 class="md-toolbar-tools">\n                        <span>Database Update Complete!</span>\n                    </h2>\n                </md-toolbar>\n                <p class="opacity-20">\n                    <md-icon md-font-icon="zmdi zmdi-timer" ></md-icon>\n                      Time taken - {{timeTaken}}</p>\n            </div>\n            <div class="md-dialog-content" ng-if="loading">\n                <h2>Loading Current Business Card Database</h2>\n                <div layout="row" flex>\n                    <md-progress-linear class="margin-bottom-20" md-mode="indeterminate"></md-progress-linear>\n                </div>\n            </div>\n        </md-dialog-content>\n        <md-dialog-actions layout="row" style="order:2;">\n            <span flex></span>\n            <md-button class="md-warn" ng-click="cancel()">\n                Cancel\n            </md-button>\n            <md-button class="md-primary" ng-disabled="!terminate" ng-click="answer(data)" style="margin-right:20px;">\n                Ok\n            </md-button>\n        </md-dialog-actions>\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n</md-dialog>\n\n');
$templateCache.put('app/biz-card/dialogs/card-reject-dialog.tmpl.html','<md-dialog aria-label="Reject Business Card"  ng-cloak>\n    <form>\n        <md-toolbar>\n            <div class="md-toolbar-tools">\n                <h2>Reject Business Card</h2>\n            </div>\n        </md-toolbar>\n        <md-dialog-content>\n            <div class="md-dialog-content">\n                <h3>Please select a reason for rejecting the business card</h3>\n                <div layout="row" flex>\n                    <md-radio-group ng-model="$ctrl.data.rejectReason">\n                        <md-radio-button value="Not a Business Card">Not a Business Card</md-radio-button>\n                        <md-radio-button value="No Image">No Image</md-radio-button>\n                        <md-radio-button value="Not Clear">Not Clear</md-radio-button>\n                        <md-radio-button value="Something Else">Something Else</md-radio-button>\n                    </md-radio-group>\n                </div>\n                <div layout="row" flex>\n                    <md-input-container ng-show="$ctrl.data.rejectReason === \'Something Else\'" flex>\n                        <label>Reason for rejecting card</label>\n                        <input type="text" ng-model="$ctrl.data.rejectText" name="reasonText">\n                    </md-input-container>\n                </div>\n            </div>\n        </md-dialog-content>\n        <md-dialog-actions layout="row">\n            <span flex></span>\n            <md-button class="md-warn" ng-click="$ctrl.cancel()">\n                Cancel\n            </md-button>\n            <md-button class="md-primary" ng-disabled="!$ctrl.data.rejectReason" ng-click="$ctrl.answer($ctrl.data)" style="margin-right:20px;">\n                Save\n            </md-button>\n        </md-dialog-actions>\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n</md-dialog>\n');
$templateCache.put('app/biz-card/dialogs/remove-deleted-leads-dialog.tmpl.html','<md-dialog aria-label="Remove Deleted Leads From Buisiness Cards Database"  ng-cloak>\n    <form>\n        <md-toolbar>\n            <div class="md-toolbar-tools">\n                <h2>Remove Deleted Leads From Buisiness Cards Database</h2>\n            </div>\n        </md-toolbar>\n        <md-dialog-content>\n            <div class="md-dialog-content" ng-if="!loading">\n                <h2>Progress ({{clientsProcessed}} of {{numOfClients}} clients processed)<br /></h2>\n                <div layout="row" flex>\n                    <md-progress-linear class="margin-bottom-20" md-mode="determinate" value="{{clientsProcessedProgress}}"></md-progress-linear>\n                </div>\n                <md-toolbar class="md-warn" ng-if="terminate">\n                    <h2 class="md-toolbar-tools">\n                        <span>Removal of Deleted Leads Complete!</span>\n                    </h2>\n                </md-toolbar>\n                <p class="opacity-20">\n                    <md-icon md-font-icon="zmdi zmdi-timer" ></md-icon>\n                    Time taken - {{timeTaken}}</p>\n                <div>Deleted Leads {{deletedLeads}}</div>\n            </div>\n            <div class="md-dialog-content" ng-if="loading">\n                <h2>Loading Current Business Card Database</h2>\n                <div layout="row" flex>\n                    <md-progress-linear class="margin-bottom-20" md-mode="indeterminate"></md-progress-linear>\n                </div>\n            </div>\n        </md-dialog-content>\n        <md-dialog-actions layout="row" style="order:2;">\n            <span flex></span>\n            <md-button class="md-warn" ng-click="cancel()">\n                Cancel\n            </md-button>\n            <md-button class="md-primary" ng-disabled="!terminate" ng-click="answer(data)" style="margin-right:20px;">\n                Ok\n            </md-button>\n        </md-dialog-actions>\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n</md-dialog>\n');
$templateCache.put('app/biz-card/dialogs/remove-old-leads-dialog.tmpl.html','<md-dialog aria-label="Remove Leads Older than 6 Months From Buisiness Cards Database"  ng-cloak>\n    <form>\n        <md-toolbar>\n            <div class="md-toolbar-tools">\n                <h2>Remove Leads Older than 6 Months From Buisiness Cards Database</h2>\n            </div>\n        </md-toolbar>\n        <md-dialog-content>\n            <div class="md-dialog-content" ng-if="!loading">\n                <h2><span class="opacity-20">Number of leads removed:</span> {{numOfClients}}<br /><br /></h2>\n                <md-toolbar class="md-warn">\n                    <h2 class="md-toolbar-tools">\n                        <span>Removal of Deleted Leads Complete!</span>\n                    </h2>\n                </md-toolbar>\n            </div>\n            <div class="md-dialog-content" ng-if="loading">\n                <h2>Removing Old Leads from Business Card Database</h2>\n                <div layout="row" flex>\n                    <md-progress-linear class="margin-bottom-20" md-mode="indeterminate"></md-progress-linear>\n                </div>\n            </div>\n        </md-dialog-content>\n        <md-dialog-actions layout="row" style="order:2;">\n            <span flex></span>\n            <!--<md-button class="md-warn" ng-click="cancel()">-->\n                <!--Cancel-->\n            <!--</md-button>-->\n            <md-button class="md-primary" ng-disabled="!terminate" ng-click="answer(data)" style="margin-right:20px;">\n                Ok\n            </md-button>\n        </md-dialog-actions>\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n</md-dialog>\n');
$templateCache.put('app/biz-card/dialogs/update-status-db-dialog.tmpl.html','<md-dialog aria-label="Business Card Database"  ng-cloak>\n    <form>\n        <md-toolbar>\n            <div class="md-toolbar-tools">\n                <h2>Business Card Tool - Configuration</h2>\n            </div>\n        </md-toolbar>\n        <md-dialog-content>\n            <div class="md-dialog-content">\n                <h2><span style="color: rgba(0,0,0,0.26);">Database Name:</span> {{databaseName}}</h2>\n<!--\n                <h2>\n                    <span style="color: rgba(0,0,0,0.26);">Update in progress:</span>\n                    <span ng-if="inprogress"><i class="fa fa-check-circle" aria-hidden="true" style="color:green;"></i> (yes)</span>\n                    <span ng-if="!inprogress"><i class="fa fa-times-circle" aria-hidden="false" style="color:red;"></i> (no)</span><br />\n                </h2>\n                <h2><span style="color: rgba(0,0,0,0.26);">Last Updated:</span> {{lastupdatedtime}}<br /></h2>\n-->\n                <md-divider></md-divider>\n                <div layout="column">\n                    <div layout="row">\n                        <div flex="80" layout-align="start center" style="color: rgba(0,0,0,0.26);"><h2>Show Users Group</h2></div>\n                        <div flex="10" layout-align="end center">\n                            <md-switch class="md-primary" ng-true-value="1" ng-false-value="0" value="1" ng-model="displayUsers">\n                                <md-tooltip md-direction="left">\n                                    controls the display of the Users group in the Grouped Cards Page\n                                </md-tooltip>\n                            </md-switch>\n                        </div>\n                    </div>\n                    <md-divider></md-divider>\n                    <div style="color: rgba(0,0,0,0.26);"><h2>Set number of days for reports</h2></div>\n                    <div layout="row" layout-align="center center">\n                        <div flex="80">\n                            <md-slider md-discrete ng-model="reportDays" min="1" max="100" aria-label="Report Period in Days">\n                            </md-slider>\n                        </div>\n                        <div flex="20" style="margin-left: 3px;">{{reportDays}} day<span ng-if="reportDays > 1">s</span></div>\n                    </div>\n                </div>\n            </div>\n        </md-dialog-content>\n        <md-dialog-actions layout="row" style="order:2;">\n            <span flex></span>\n            <md-button class="md-warn" ng-click="cancel()">\n                Cancel\n            </md-button>\n            <md-button class="md-primary" ng-click="answer()" style="margin-right:20px;">\n                Ok\n            </md-button>\n        </md-dialog-actions>\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n</md-dialog>\n');
$templateCache.put('app/biz-card/dialogs/wizard-dialog.tmpl.html','<md-dialog class="mobile-fullwidth-dialog" flex>\n    <md-toolbar class="toolbar-default" md-theme="{{vm.triSkin.elements.toolbar}}">\n        <div class="md-toolbar-tools">\n            <h2>\n                Form Wizard\n            </h2>\n            <span flex></span>{{triWizard.progress}}% Complete\n            <md-button class="md-icon-button" ng-click="vm.cancel()" aria-label="cancel">\n                <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n            </md-button>\n        </div>\n        <md-progress-linear class="md-accent padding-bottom-10" md-mode="determinate" ng-value="triWizard.progress"></md-progress-linear>\n\n    </md-toolbar>\n\n\n    <md-dialog-content class="sticky-container">\n        <div class="md-dialog-content no-padding">\n            <!-- content goes in here for the dialog -->\n            <div layout="column" layout-align="center center">\n\n\n                <div flex layout="row" layout-align="center center" layout-fill>\n                    <div flex= class="md-whiteframe-z1 margin-bottom-100" tri-wizard>\n                        <!--<md-toolbar class="md-primary">-->\n                            <!--<div flex class="md-toolbar-tools" layout="row" layout-align="space-between center">-->\n                                <!--<h2>Form Wizard</h2><h2> <span>Complete</span></h2>-->\n                            <!--</div>-->\n\n                        <!--</md-toolbar>-->\n                        <md-tabs class="md-primary" layout-fill md-selected="triWizard.currentStep" md-dynamic-height md-stretch-tabs="always">\n                            <md-tab id="account">\n                                <md-tab-label>\n                                    <span class="oxy-step-label">1</span>\n                                    <span>Create Account</span>\n                                </md-tab-label>\n                                <md-tab-body>\n                                    <md-content class="md-padding">\n                                        <form name="accountForm" tri-wizard-form novalidate>\n                                            <div layout="column" flex>\n                                                <md-input-container>\n                                                    <label>Username</label>\n                                                    <input name="username" ng-model="wizardController.data.account.username" required>\n                                                    <div ng-messages="accountForm.username.$error">\n                                                        <div ng-message when="required">\n                                                            <span>This field is required</span>\n                                                        </div>\n                                                    </div>\n                                                </md-input-container>\n                                                <md-input-container>\n                                                    <label>Email</label>\n                                                    <input type="email" name="email" ng-model="wizardController.data.account.email" required>\n                                                    <div ng-messages="accountForm.email.$error">\n                                                        <div ng-message when="required">\n                                                            <span>This field is required</span>\n                                                        </div>\n                                                        <div ng-message when="email">\n                                                            <span>Please enter a valid email</span>\n                                                        </div>\n                                                    </div>\n                                                </md-input-container>\n                                                <div layout layout-sm="column" flex>\n                                                    <md-input-container flex>\n                                                        <label>Password</label>\n                                                        <input type="password" name="password" ng-model="wizardController.data.account.password" required>\n                                                        <div ng-messages="accountForm.password.$error">\n                                                            <div ng-message when="required">\n                                                                <span>This field is required</span>\n                                                            </div>\n                                                        </div>\n                                                    </md-input-container>\n                                                    <md-input-container flex>\n                                                        <label>Confirm Password</label>\n                                                        <input type="password" name="passwordConfirm" ng-model="wizardController.data.account.passwordConfirm" required>\n                                                        <div ng-messages="accountForm.passwordConfirm.$error">\n                                                            <div ng-message when="required">\n                                                                <span>This field is required</span>\n                                                            </div>\n                                                        </div>\n                                                    </md-input-container>\n                                                </div>\n                                            </div>\n                                        <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n                                    </md-content>\n                                </md-tab-body>\n                            </md-tab>\n                            <md-tab id="address" ng-disabled="accountForm.$invalid">\n                                <md-tab-label>\n                                    <span class="oxy-step-label">2</span>\n                                    <span>Your Address</span>\n                                </md-tab-label>\n                                <md-tab-body>\n                                    <md-content class="md-padding">\n                                        <form name="addressForm" tri-wizard-form>\n                                            <div layout="column" flex>\n                                                <div layout layout-sm="column" flex>\n                                                    <md-input-container flex>\n                                                        <label>First Name</label>\n                                                        <input name="firstName" ng-model="wizardController.data.address.firstName" required>\n                                                        <div ng-messages="addressForm.firstName.$error">\n                                                            <div ng-message when="required">\n                                                                <span>This field is required</span>\n                                                            </div>\n                                                        </div>\n                                                    </md-input-container>\n                                                    <md-input-container flex>\n                                                        <label>Last Name</label>\n                                                        <input name="lastName" ng-model="wizardController.data.address.lastName" required>\n                                                        <div ng-messages="addressForm.lastName.$error">\n                                                            <div ng-message when="required">\n                                                                <span>This field is required</span>\n                                                            </div>\n                                                        </div>\n                                                    </md-input-container>\n                                                </div>\n                                                <md-input-container>\n                                                    <label>Address</label>\n                                                    <input name="address1" ng-model="wizardController.data.address.line1" required>\n                                                    <div ng-messages="addressForm.address1.$error">\n                                                        <div ng-message when="required">\n                                                            <span>This field is required</span>\n                                                        </div>\n                                                    </div>\n                                                </md-input-container>\n                                                <md-input-container>\n                                                    <label>Address Line 2</label>\n                                                    <input ng-model="wizardController.data.address.line2">\n                                                </md-input-container>\n                                                <div layout layout-sm="column" flex>\n                                                    <md-input-container flex>\n                                                        <label>Town</label>\n                                                        <input ng-model="wizardController.data.address.town">\n                                                    </md-input-container>\n                                                    <md-input-container flex>\n                                                        <label>State</label>\n                                                        <input ng-model="wizardController.data.address.state">\n                                                    </md-input-container>\n                                                </div>\n                                                <div layout layout-sm="column" flex>\n                                                    <md-input-container flex>\n                                                        <label>Zip</label>\n                                                        <input name="zip" ng-model="wizardController.data.address.zip" required>\n                                                        <div ng-messages="addressForm.zip.$error">\n                                                            <div ng-message when="required">\n                                                                <span>This field is required</span>\n                                                            </div>\n                                                        </div>\n                                                    </md-input-container>\n                                                    <md-input-container flex>\n                                                        <label>Country</label>\n                                                        <md-select ng-change="triWizard.updateProgress()" name="country" ng-model="wizardController.data.address.country" required>\n                                                            <md-option value="US">United States</md-option>\n                                                        </md-select>\n                                                        <div ng-messages="addressForm.country.$error">\n                                                            <div ng-message when="required">\n                                                                <span>This field is required</span>\n                                                            </div>\n                                                        </div>\n                                                    </md-input-container>\n                                                </div>\n                                            </div>\n                                        <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n                                    </md-content>\n                                </md-tab-body>\n                            </md-tab>\n                            <md-tab id="billing" ng-disabled="addressForm.$invalid">\n                                <md-tab-label>\n                                    <span class="oxy-step-label">3</span>\n                                    <span>Billing Details</span>\n                                </md-tab-label>\n                                <md-tab-body>\n                                    <md-content class="md-padding">\n                                        <form name="billingForm" tri-wizard-form>\n                                            <div layout="column" flex>\n                                                <md-input-container>\n                                                    <label>Credit Card Number</label>\n                                                    <input name="cardNumber" ng-model="wizardController.data.billing.number" required>\n                                                    <div ng-messages="billingForm.cardNumber.$error">\n                                                        <div ng-message when="required">\n                                                            <span>This field is required</span>\n                                                        </div>\n                                                    </div>\n                                                </md-input-container>\n                                                <md-input-container>\n                                                    <label>Name on Card</label>\n                                                    <input name="cardName" ng-model="wizardController.data.billing.name" required>\n                                                    <div ng-messages="billingForm.cardName.$error">\n                                                        <div ng-message when="required">\n                                                            <span>This field is required</span>\n                                                        </div>\n                                                    </div>\n                                                </md-input-container>\n                                            </div>\n                                            <div layout layout-sm="column" flex>\n                                                <md-input-container flex>\n                                                    <label>Expiry Month (MM)</label>\n                                                    <input name="cardMonth" ng-model="wizardController.data.billing.cardMonth" ng-minlength="2" ng-maxlength="2" ng-pattern="/^(0?[1-9]|1[012])$/" required>\n                                                    <div ng-messages="billingForm.cardMonth.$error">\n                                                        <div ng-message when="required">\n                                                            <span>This field is required</span>\n                                                        </div>\n                                                        <div ng-message when="maxlength">\n                                                            <span>Month must be in the format MM</span>\n                                                        </div>\n                                                        <div ng-message when="minlength">\n                                                            <span>Month must be in the format MM</span>\n                                                        </div>\n                                                        <div ng-message when="pattern">\n                                                            <span>Month must be in the format MM</span>\n                                                        </div>\n                                                    </div>\n                                                </md-input-container>\n                                                <md-input-container flex>\n                                                    <label>Expiry Year (YYYY)</label>\n                                                    <input name="cardYear" ng-model="wizardController.data.billing.cardYear" ng-minlength="4" ng-maxlength="4" ng-pattern="/^[0-9]+$/" required>\n                                                    <div ng-messages="billingForm.cardYear.$error">\n                                                        <div ng-message when="required">\n                                                            <span>This field is required</span>\n                                                        </div>\n                                                        <div ng-message when="maxlength">\n                                                            <span>Year must be in the format YYYY</span>\n                                                        </div>\n                                                        <div ng-message when="minlength">\n                                                            <span>Year must be in the format YYYY</span>\n                                                        </div>\n                                                        <div ng-message when="pattern">\n                                                            <span>Year must be in the format YYYY</span>\n                                                        </div>\n                                                    </div>\n                                                </md-input-container>\n                                            </div>\n                                        <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n                                    </md-content>\n                                </md-tab-body>\n                            </md-tab>\n                            <md-tab id="confirm" ng-disabled="billingForm.$invalid">\n                                <md-tab-label>\n                                    <span class="oxy-step-label">4</span>\n                                    <span>Confirmation</span>\n                                </md-tab-label>\n                                <md-tab-body>\n                                    <md-content class="md-padding">\n                                        <div class="padding-40" flex layout="column" layout-align="center center">\n                                            <md-icon class="big-icon" md-font-icon="zmdi zmdi-cake"></md-icon>\n                                            <h2 class="md-display-2">Congratulations - we will be in touch</h2>\n                                            <md-button ng-click="vm.confirm()" class="md-primary" ng-disabled="" aria-label="send">Confirm Action</md-button>\n                                        </div>\n                                    </md-content>\n                                </md-tab-body>\n                            </md-tab>\n                        </md-tabs>\n                        <!--<div class="wizard-navbar" layout-fill layout-padding layout="row" layout-align="end center">-->\n                            <!--<md-button class="md-primary md-raised" ng-click="triWizard.prevStep()" ng-hide="triWizard.currentStep > 2" ng-disabled="triWizard.prevStepDisabled()">Previous</md-button>-->\n                            <!--<md-button class="md-primary md-raised" ng-click="triWizard.nextStep()" ng-hide="triWizard.progress == 100 && triWizard.currentStep > 1" ng-disabled="triWizard.nextStepDisabled()">Next</md-button>-->\n                            <!--<md-button class="md-accent md-raised" ng-click="triWizard.currentStep = 3" ng-show="triWizard.progress == 100 && triWizard.currentStep < 3">Send</md-button>-->\n                        <!--</div>-->\n                    </div>\n                </div>\n            </div>\n\n        </div>\n    </md-dialog-content>\n    <div class="md-actions wizard-navbar" layout-fill layout-padding layout="row" layout-align="end center">\n        <md-button class="md-primary md-raised" ng-click="triWizard.prevStep()" ng-hide="triWizard.currentStep > 2" ng-disabled="triWizard.prevStepDisabled()">Previous</md-button>\n        <md-button class="md-primary md-raised" ng-click="triWizard.nextStep()" ng-hide="triWizard.progress == 100 && triWizard.currentStep > 1" ng-disabled="triWizard.nextStepDisabled()">Next</md-button>\n        <md-button class="md-accent md-raised" ng-click="triWizard.currentStep = 3" ng-show="triWizard.progress == 100 && triWizard.currentStep < 3">Send</md-button>\n    </div>\n    <!--<div class="md-actions" layout="row">-->\n        <!--<span flex></span>-->\n        <!--<md-button ng-click="vm.confirm()" class="md-primary" ng-disabled="" aria-label="send">Confirm Action</md-button>-->\n    <!--</div>-->\n</md-dialog>\n');
$templateCache.put('app/showroom/dashboard/dashboard-main.tmpl.html','<md-content layout-fill ayout-align="center center">\n  <div class="showroom-dashboard-card" layout-padding layout-margin flex="100" flex-gt-sm="60" flex-offset-gt-sm="20"\n    flex-gt-md="50" flex-offset-gt-md="25" layout-align="center center" layout="row">\n    <!-- <md-card-header>\n        <md-card-avatar>\n          <md-icon md-font-icon="zmdi zmdi-tv">\n          </md-icon>\n        </md-card-avatar> -->\n    <!-- <md-card-header-text> -->\n    <div layout="column">\n      <div layout="row">\n        <div layout-padding>\n          <md-icon md-font-icon="zmdi zmdi-tv">\n          </md-icon>\n        </div>\n        <div layout="column">\n          <span class="md-headline">Welcome to Showroom Admin</span>\n          <span class="md-subhead">Use the tools below to configure your showroom assets</span>\n        </div>\n      </div>\n    </div>\n    <!-- </md-card-header-text> -->\n    <!-- <span flex></span>\n      </md-card-header>\n      <md-card-content layout="column">\n      </md-card-content> -->\n  </div>\n\n  <div layout="row" layout-wrap flex-offset-gt-sm="20" flex-offset-gt-md="25">\n    <md-card layout-padding layout-margin flex="50" flex-gt-sm="30" flex-gt-md="25"\n      ui-sref="app.oldshowroom.showroom.literature" md-whiteframe="{{libHovering}}" ng-init="libHovering = 1"\n      ng-mouseenter="libHovering = 5" ng-mouseleave="libHovering = 1" class="card-clickable" permission\n      permission-only="$ctrl.permissions.boltOns.showroom.view">\n      <md-card-header>\n        <md-card-avatar>\n          <md-icon md-font-icon="zmdi zmdi-library">\n          </md-icon>\n        </md-card-avatar>\n        <md-card-header-text>\n          <span class="md-title">Library</span>\n          <span class="md-subhead"></span>\n        </md-card-header-text>\n        <span flex></span>\n      </md-card-header>\n      <md-card-content layout="column">\n        <p class="md-body-1">Add, edit, and view your literature items in a single view.</p>\n      </md-card-content>\n    </md-card>\n\n    <md-card layout-padding layout-margin flex="50" flex-gt-sm="30" flex-gt-md="25"\n      ui-sref="app.oldshowroom.showroom.tags" md-whiteframe="{{tagsHovering}}" ng-init="tagsHovering = 1"\n      ng-mouseenter="tagsHovering = 5" ng-mouseleave="tagsHovering = 1" class="card-clickable" permission\n      permission-only="$ctrl.permissions.boltOns.showroom.edit">\n      <md-card-header>\n        <md-card-avatar>\n          <md-icon md-font-icon="zmdi zmdi-tag">\n          </md-icon>\n        </md-card-avatar>\n        <md-card-header-text>\n          <span class="md-title">Tags</span>\n          <span class="md-subhead"></span>\n        </md-card-header-text>\n        <span flex></span>\n      </md-card-header>\n      <md-card-content layout="column">\n        <p class="md-body-1">Add, edit, and organise your tags, and assign them to your literature items.</p>\n      </md-card-content>\n    </md-card>\n\n    <md-card layout-padding layout-margin flex="50" flex-gt-sm="30" flex-gt-md="25"\n      ui-sref="app.oldshowroom.showroom.blocks" md-whiteframe="{{blocksHovering}}" ng-init="blocksHovering = 1"\n      ng-mouseenter="blocksHovering = 5" ng-mouseleave="blocksHovering = 1" class="card-clickable" permission\n      permission-only="$ctrl.permissions.boltOns.showroom.blocks">\n      <md-card-header>\n        <md-card-avatar>\n          <md-icon md-font-icon="zmdi zmdi-collection-item">\n          </md-icon>\n        </md-card-avatar>\n        <md-card-header-text>\n          <span class="md-title">Blocks</span>\n          <span class="md-subhead"></span>\n        </md-card-header-text>\n        <span flex></span>\n      </md-card-header>\n      <md-card-content layout="column">\n        <p class="md-body-1">Add, edit, and organize blocks for block layout, also add literature items to your blocks.\n        </p>\n      </md-card-content>\n    </md-card>\n\n    <md-card layout-padding layout-margin flex="50" flex-gt-sm="30" flex-gt-md="25"\n      ui-sref="app.oldshowroom.showroom.images" md-whiteframe="{{imgHovering}}" ng-init="imgHovering = 1"\n      ng-mouseenter="imgHovering = 5" ng-mouseleave="imgHovering = 1" class="card-clickable" permission\n      permission-only="$ctrl.permissions.boltOns.showroom.view">\n      <md-card-header>\n        <md-card-avatar>\n          <md-icon md-font-icon="zmdi zmdi-collection-image-o">\n          </md-icon>\n        </md-card-avatar>\n        <md-card-header-text>\n          <span class="md-title">Images</span>\n          <span class="md-subhead"></span>\n        </md-card-header-text>\n        <span flex></span>\n      </md-card-header>\n      <md-card-content layout="column">\n        <p class="md-body-1">Add and edit images used for blocks (and custom skins too).</p>\n      </md-card-content>\n    </md-card>\n\n    <md-card layout-padding layout-margin flex="50" flex-gt-sm="30" flex-gt-md="25"\n      ui-sref="app.oldshowroom.showroom.dropbox" md-whiteframe="{{dbHovering}}" ng-init="dbHovering = 1"\n      ng-mouseenter="dbHovering = 5" ng-mouseleave="dbHovering = 1" class="card-clickable" permission\n      permission-only="$ctrl.permissions.boltOns.showroom.edit">\n      <md-card-header>\n        <md-card-avatar>\n          <md-icon md-font-icon="zmdi zmdi-dropbox">\n          </md-icon>\n        </md-card-avatar>\n        <md-card-header-text>\n          <span class="md-title">Dropbox</span>\n          <span class="md-caption">Status: {{$ctrl.dropboxStatus()}}</span>\n        </md-card-header-text>\n        <span flex></span>\n      </md-card-header>\n      <md-card-content layout="column">\n        <p class="md-body-1">Import files from Dropbox into your literature library.</p>\n      </md-card-content>\n    </md-card>\n\n    <md-card layout-padding layout-margin flex="50" flex-gt-sm="30" flex-gt-md="25"\n      ui-sref="app.oldshowroom.showroom.import" md-whiteframe="{{csvHovering}}" ng-init="csvHovering = 1"\n      ng-mouseenter="csvHovering = 5" ng-mouseleave="csvHovering = 1" class="card-clickable" permission\n      permission-only="$ctrl.permissions.boltOns.showroom.edit">\n      <md-card-header>\n        <md-card-avatar>\n          <md-icon md-font-icon="zmdi zmdi-file">\n          </md-icon>\n        </md-card-avatar>\n        <md-card-header-text>\n          <span class="md-title">Import CSV</span>\n          <span class="md-subhead"></span>\n        </md-card-header-text>\n        <span flex></span>\n      </md-card-header>\n      <md-card-content layout="column">\n        <p class="md-body-1">Import literature items using a CSV template.</p>\n      </md-card-content>\n    </md-card>\n\n    <md-card layout-padding layout-margin flex="50" flex-gt-sm="30" flex-gt-md="25"\n      ui-sref="app.oldshowroom.showroom.artefacts" md-whiteframe="{{artefactsHovering}}" ng-init="artefactsHovering = 1"\n      ng-mouseenter="artefactsHovering = 5" ng-mouseleave="artefactsHovering = 1" class="card-clickable" permission\n      permission-only="$ctrl.permissions.boltOns.showroom.admin">\n      <!-- Above permission can be removed later but Leanne wanted only admins to see it  -->\n      <md-card-header>\n        <md-card-avatar>\n          <md-icon md-font-icon="zmdi zmdi-file-plus">\n          </md-icon>\n        </md-card-avatar>\n        <md-card-header-text>\n          <span class="md-title">Import Lookup Data</span>\n        </md-card-header-text>\n        <span flex></span>\n      </md-card-header>\n      <md-card-content layout="column">\n        <p class="md-body-1">Import additional lookup values for lead breakout reporting.</p>\n      </md-card-content>\n    </md-card>\n  </div>\n</md-content>');
$templateCache.put('app/showroom/layouts/showroom-view.tmpl.html','<!-- <div layout="column" fle ayout-align="start stretch"> -->\n<div lex="grow" class="showroom-spof" ui-view="showroom-spof"></div>\n<!-- </div> -->\n');
$templateCache.put('app/showroom/layouts/zp-showroom-fab.tmpl.html','<div ui-view="showroom-fab"></div>\n');
$templateCache.put('app/users/detail/user-detail-page.tmpl.html','<div layout="column" layout-fill>\n\n  <md-content layout="row">\n    <md-card layout-padding flex="100" flex-gt-sm="60" flex-offset-gt-sm="20" flex-gt-md="50" flex-offset-gt-md="25">\n      <md-card-header>\n        <md-card-avatar ng-if="$ctrl.userDoc.avatar">\n          <img class="md-user-avatar" ng-src="{{$ctrl.userDoc.avatar}}" />\n        </md-card-avatar>\n        <md-card-header-text>\n          <span class="md-title">{{::$ctrl.userDoc.firstname}} {{::$ctrl.userDoc.surname}}</span>\n          <span class="md-subhead">{{::$ctrl.userDoc.jobtitle}}</span>\n        </md-card-header-text>\n        <span flex></span>\n        <zp-context-menu ng-if="!!$ctrl.menuOptions" menu-options="$ctrl.menuOptions"\n          on-menu-click="$ctrl.onMenuClick({action: action, ev: ev})">\n        </zp-context-menu>\n      </md-card-header>\n\n      <p permission permission-only="[\'MFA_ENABLED\']" class="zuantSaffron margin-bottom-0 margin-top-0"\n        ng-if="$ctrl.userDoc.mfaSetup && $ctrl.userDoc.mfaResetRequest">\n        <b>"{{$ctrl.userDoc.email}}"</b> - has requested an MFA (Multi Factor Authentication) reset. Please click on the\n        menu button (top right) to action this.\n      </p>\n\n      <p permission permission-only="[\'MFA_ENABLED\']" class="zuantSaffron margin-bottom-0 margin-top-0"\n        ng-if="!$ctrl.userDoc.mfaSetup && $ctrl.userDoc.permissions.login.includes(\'portal\')">\n        <b>"{{$ctrl.userDoc.email}}"</b> - does not have MFA (Multi Factor Authentication) setup. Please ask the user to\n        login to the cloud to begin the process of setting this additional security measure up.\n      </p>\n\n      <zp-user-form client-doc="$ctrl.clientDoc" user-form-obj="$ctrl.userFormObj"\n        user-doc="$ctrl.userDoc"></zp-user-form>\n      <div layout="row" layout-align="end center">\n        <md-button ng-click="$ctrl.saveForm()" aria-label="Save changes">Save changes</md-button>\n      </div>\n    </md-card>\n  </md-content>\n\n  <div ng-if="$ctrl.userDoc.inactive == true" layout-padding flex="100" flex-gt-sm="60" flex-gt-sm-offset="20"\n    flex-gt-md="50" flex-offset-gt-md="25">\n    <p>This user is currently archived\n      <md-button class="md-accent" ng-click="$ctrl.toggleArchiveUser()">unarchive</md-button>\n    </p>\n  </div>\n</div>');
$templateCache.put('app/users/main/user-app-page.tmpl.html','<div flex ng-show="$ctrl.blankSlate.getData().items.length == 0" layout-padding layout="row"\n  layout-align="center center">\n  <zp-no-data header="You don\'t have any users in your account yet" subhead="" body="" svgpath=""\n    fontcolor="zuantLagoonRollover" svgid="">\n  </zp-no-data>\n</div>\n\n<zp-user-list \n  flex \n  data="$ctrl.customerUsersData" \n  metadata="$ctrl.customerUsersMetadata">\n</zp-user-list>\n\n<section permission permission-only="\'ZUANT_ADMIN\'">\n  <div ng-style="{ marginTop: $ctrl.customerUsersData.items.length > 0 ? \'50px\' : \'0px\' }"></div>\n  <zp-user-list \n    flex \n    data="$ctrl.staffUsersData" \n    metadata="$ctrl.staffUsersMetadata" \n    title="\'Zuant Staff Users\'">\n  </zp-user-list>\n</section>\n');
$templateCache.put('app/authentication/update-password/update-password.component.tmpl.html','<div class="lagoon-bg" layout-fill>\n\n    <div layout="row" flex layout-padding layout-fill layout-align="center center">\n        <div flex="60" flex-lg="50" flex-md="70" flex-sm="80" flex-xs="100">\n            <div layout="row" layout-margin layout-align="center center">\n                <div ng-include class="cloud-logo-constrained" src="$ctrl.zuantLogoURL"></div>\n            </div>\n\n            <div layout-margin layout-padding></div>\n\n            <md-card>\n\n                <md-content class="md-padding" layout-padding>\n\n                    <div ng-if="!$ctrl.passwordUpdateComplete" layout-padding layout="column"\n                        layout-align="center center">\n\n                        <p class="md-display-1 zuantTitanium1 thin-font margin-bottom-10">\n                            Update Password</p>\n\n                        <md-icon class="big-icon" md-font-icon="zmdi zmdi-lock"></md-icon>\n\n                        <div layout="column" layout-align=" start">\n\n                            <p class="zuantTitanium1 margin-top-10 margin-bottom-5">\n                                Your administrator has recently implemented a new password policy to enhance security\n                                measures within our system. In order to comply with these updated standards and ensure\n                                the safety of your account, we kindly request that you update your password to meet the\n                                required criteria. This action is essential to continue accessing our services without\n                                interruption.\n                            </p>\n\n                            <ul>\n                                <li class="zuantTitanium1 margin-top-0 margin-bottom-0"\n                                    ng-repeat="policy in $ctrl.activePolicy">\n                                    {{policy.label}} <b>{{policy.value}}</b>\n                                    <md-icon style="color: limegreen;" class="margin-left-5"\n                                        ng-if="$ctrl.updateFormObj.password.$dirty && !$ctrl.updateFormObj.password.$error[policy.key]"\n                                        md-font-icon="zmdi zmdi-check-circle"></md-icon>\n                                    <md-icon class="margin-left-5 zuantSaffron"\n                                        ng-if="$ctrl.updateFormObj.password.$touched && $ctrl.updateFormObj.password.$error[policy.key]"\n                                        md-font-icon="zmdi zmdi-close-circle"></md-icon>\n                                </li>\n                            </ul>\n                        </div>\n\n                        <form class="full-width" name="$ctrl.updateFormObj"\n                            ng-submit="$ctrl.submitUpdatePasswordForm()">\n                            <md-input-container class="md-block">\n                                <label for="password">Password</label>\n                                <input id="password" label="password" name="password" type="{{$ctrl.passwordFieldType}}"\n                                    ng-model="$ctrl.passwordFormFieldValue"\n                                    ng-change="$ctrl.checkAgainstPasswordPolicy(\'password\')" required />\n\n                                <md-icon style="color:rgba(0,0,0,0.12);" md-font-icon="zmdi {{$ctrl.passwordFieldIcon}}"\n                                    ng-click="$ctrl.toggleViewPasswordField(\'password\')">\n                                    <md-tooltip>{{$ctrl.passwordFieldTooltip}}</md-tooltip>\n                                </md-icon>\n\n                                <div ng-messages="$ctrl.updateFormObj.password.$error" md-auto-hide="false"\n                                    ng-show="$ctrl.updateFormObj.password.$touched">\n                                    <div ng-message when="required">\n                                        <span>Please enter a password.</span>\n                                    </div>\n                                    <div ng-message when="minLength">\n                                        <span>Please enter a password with a length greater than\n                                            <b>{{$ctrl.activePolicy.minLength.value}}</b> characters.</span>\n                                    </div>\n                                    <div ng-message when="maxLength">\n                                        <span>Please enter a password with a length less than\n                                            <b>{{$ctrl.activePolicy.maxLength.value}}</b> characters.</span>\n                                    </div>\n                                    <div ng-message when="minLowercase">\n                                        <span>Please enter a password with\n                                            <b>{{$ctrl.activePolicy.minLowercase.value}}</b> or\n                                            more <b>LOWERCASE</b> characters.</span>\n                                    </div>\n                                    <div ng-message when="minUppercase">\n                                        <span>Please enter a password with\n                                            <b>{{$ctrl.activePolicy.minUppercase.value}}</b> or\n                                            more <b>UPPERCASE</b> characters.</span>\n                                    </div>\n                                    <div ng-message when="minNumeric">\n                                        <span>Please enter a password with\n                                            <b>{{$ctrl.activePolicy.minNumeric.value}}</b> or\n                                            more <b>NUMERIC</b> characters.</span>\n                                    </div>\n                                    <div ng-message when="minSymbol">\n                                        <span>Please enter a password with\n                                            <b>{{$ctrl.activePolicy.minSymbol.value}}</b> or\n                                            more <b>SYMBOL</b> characters.</span>\n                                    </div>\n                                    <div ng-message when="nonMatch">\n                                        <span>Password does not match confirm field.</span>\n                                    </div>\n                                </div>\n                            </md-input-container>\n\n                            <md-input-container class="md-block">\n                                <label for="confirmpassword">Confirm Password</label>\n                                <input id="confirmpassword" label="Confirm password" name="confirmpassword"\n                                    type="{{$ctrl.confirmPasswordFieldType}}"\n                                    ng-model="$ctrl.confirmPasswordFormFieldValue"\n                                    ng-change="$ctrl.checkAgainstPasswordPolicy(\'confirmPassword\')" required />\n\n                                <md-icon style="color:rgba(0,0,0,0.12);"\n                                    md-font-icon="zmdi {{$ctrl.confirmPasswordFieldIcon}}"\n                                    ng-click="$ctrl.toggleViewPasswordField(\'confirmPassword\')">\n                                    <md-tooltip>{{$ctrl.confirmPasswordFieldTooltip}}</md-tooltip>\n                                </md-icon>\n\n                                <div ng-messages="$ctrl.updateFormObj.confirmpassword.$error" md-auto-hide="false"\n                                    ng-show="$ctrl.updateFormObj.confirmpassword.$touched">\n                                    <div ng-message when="required">\n                                        <span>Please confirm your password.</span>\n                                    </div>\n                                    <div ng-message when="nonMatch">\n                                        <span>Confirm field does not match password field.</span>\n                                    </div>\n                                </div>\n                            </md-input-container>\n\n                            <md-button\n                                class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10"\n                                type="submit" ng-disabled="$ctrl.updateFormObj.$invalid" aria-label="Submit">\n                                SUBMIT\n                            </md-button>\n\n                            <input type="hidden" name="CSRFToken" value="1231234567890" />\n                        </form>\n                    </div>\n\n                    <div ng-if="$ctrl.passwordUpdateComplete" layout-padding layout="column"\n                        layout-align="center center">\n\n                        <p class="md-display-1 zuantTitanium1 thin-font margin-bottom-10">\n                            Successfully Updated Password</p>\n\n                        <md-icon style="color: limegreen;" class="big-icon"\n                            md-font-icon="zmdi zmdi-check-circle"></md-icon>\n\n                        <p class="zuantTitanium1 margin-top-10 margin-bottom-5">\n                            You have successfully updated your password! To proceed, click the <b>"CONTINUE TO\n                                LOGIN"</b> button below and access your account with your new credentials\n                        </p>\n\n                        <md-button\n                            class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10"\n                            type="button" ui-sref="login" aria-label="CONTINUE TO LOGIN">\n                            CONTINUE TO LOGIN\n                        </md-button>\n                    </div>\n\n                </md-content>\n            </md-card>\n\n\n        </div>\n    </div>\n</div>');
$templateCache.put('app/artefacts/images/image-artefact-dialog/image-detail.dialog.tmpl.html','<md-dialog aria-label="Image item dialog" flex="80" flex-gt-md="60">\n\n  <md-toolbar aria-label="Image item dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">\n        <span ng-if="vm.formType === \'new\'">Create a new</span>\n        <span ng-if="vm.formType === \'edit\'">Edit</span> image item\n      </p>\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-progress-linear class="md-accent" ng-if="vm.loading"></md-progress-linear>\n  <md-dialog-content layout-padding>\n    <div ng-show="vm.loading">\n      <p class="md-body-1 text-align-center">Saving...</p>\n    </div>\n\n    <zp-image-artefact-form loading="vm.loading" form-type="vm.formType" image-type="vm.imageType"\n      set-image-type="vm.setImageType(type)" image-doc="vm.imageDoc" form-object="vm.imageForm"\n      dropbox-callback-location="vm.dropboxCallbackLocation">\n    </zp-image-artefact-form>\n\n    <div ng-if="vm.userMessage && !vm.loading" layout-padding layout-margin\n      style="border-left: 3px solid; background-color: white;"\n      md-colors="::{color: \'primary\', \'borderColor\': \'primary-600\'}" layout-padding>\n      <p class="md-headline margin-bottom-0">\n        <md-icon md-font-icon="zmdi zmdi-dropbox"></md-icon> &nbsp; Heads up\n      </p>\n      <p class="md-subhead">{{vm.userMessage}}</p>\n    </div>\n  </md-dialog-content>\n\n  <md-dialog-actions layout="row">\n    <md-button class="md-warn" ng-click="vm.cancelDialog()">Cancel</md-button>\n    <md-button\n      ng-disabled="vm.imageForm.$invalid || vm.disableSaveButton || (vm.formType === \'new\' && !vm.imageType) || (vm.imageType === \'upload\' && !vm.imageDoc.imageDataAsArrayBuffer)"\n      class="md-primary" aria-label="save image form" ng-click="vm.submitImageForm(vm.imageDoc)">Save</md-button>\n  </md-dialog-actions>\n\n</md-dialog>');
$templateCache.put('app/artefacts/images/image-artefact-form/zp-image-artefact-form.tmpl.html','<md-progress-linear ng-if="$ctrl.busy" class="md-accent"></md-progress-linear>\n\n<form name="$ctrl.formObject" novalidate ng-show="!$ctrl.loading" ng-disabled="$ctrl.busy">\n\n  <div class="md-whiteframe-1dp" style="border-left: 3px solid;" md-colors="::{borderColor: \'primary-600\'}"\n    layout-margin ng-show="$ctrl.showConnectMessage">\n    <div layout="row">\n      <md-icon md-font-icon="zmdi zmdi-dropbox"></md-icon> &nbsp;\n      <span flex layout-padding class="md-title">Using Dropbox for file storage</span>\n      <md-button class="md-icon-button" ng-click="$ctrl.closeDropboxConnectMessage()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n    <div layout-padding>\n      <p class="md-body-1">It looks like there isn\'t a Dropbox account connected to Zuant yet. Connecting Zuant to\n        Dropbox makes managing your media files a breeze. That said, you can just use web links if you wish, no problem!\n      </p>\n      <div layout="row">\n        <span flex></span>\n        <md-button class="md-accent md-raised" ng-click="$ctrl.connectToDropbox()">Connect to Dropbox</md-button>\n      </div>\n    </div>\n  </div>\n\n  <div ng-show="$ctrl.formType === \'new\'">\n    <p class="md-body-1">Create a new image item by either uploading a file (which will save to your connected Dropbox\n      account) or entering a url to an image that lives out on the web somewhere.</p>\n\n    <div layout="row" layout-align="center center">\n      <md-button class="md-accent" ng-class="{\'md-raised\': $ctrl.imageType === \'upload\'}"\n        ng-click="$ctrl.setImageType({type: \'upload\'})" ng-disabled="$ctrl.showConnectMessage">\n        <md-tooltip ng-if="$ctrl.showConnectMessage">This uses Dropbox for storage so you\'ll need to connect to Dropbox\n          to use it</md-tooltip>\n        Upload Image File\n      </md-button>\n      <md-button class="md-accent" ng-class="{\'md-raised\': $ctrl.imageType === \'weburi\'}"\n        ng-click="$ctrl.setImageType({type: \'weburi\'})">Enter Image URL</md-button>\n    </div>\n  </div>\n\n  <div layout="column">\n    <md-input-container flex ng-if="$ctrl.imageType === \'weburi\' || $ctrl.formType === \'edit\'">\n      <label>Image Url</label>\n      <input type="text" name="weburi" ng-model="$ctrl.imageDoc.weburi" aria-label="Web Uri"\n        required="$ctrl.imageType === \'weburi\'" md-autofocus zp-image-url-validator>\n      <div ng-messages="$ctrl.formObject.weburi.$error" md-auto-hide="false" ng-show="$ctrl.formObject.weburi.$touched">\n        <div ng-message when="required">\n          <spanPlease enter an image url</span>\n        </div>\n\n        <div ng-message when="imageURL">\n          Image url is not valid. Only url\'s with the extensions .png, .jpg, .jpeg, .bmp & .gif are supported.\n        </div>\n      </div>\n    </md-input-container>\n\n    <div ng-if="$ctrl.imageType === \'upload\'" style="margin-top: 5px; margin-bottom: 5px;" flex layout="row"\n      layout-align="start start">\n\n      <div ng-if="$ctrl.fileUploaded" flex="grow" layout="column">\n        <span>File Name: <b>{{ $ctrl.fileName }}</b></span>\n        <span>File Size: <b>{{ $ctrl.imageDoc.size | zpBytes }}</b></span>\n        <span>File Type: <b>{{ $ctrl.imageDoc.type }}</b></span>\n        <span>Image Height: <b>{{ $ctrl.imageDoc.height }}px</b></span>\n        <span>Image Width: <b>{{ $ctrl.imageDoc.width }}px</b></span>\n\n        <div class="zuantSaffron" ng-if="$ctrl.fileErrors.length > 0">\n          Errors:\n          <ul>\n            <li ng-repeat="errorObj in $ctrl.fileErrors">\n              {{ errorObj.error }}\n            </li>\n          </ul>\n        </div>\n      </div>\n\n      <div flex></div>\n\n      <md-button ng-disabled="vm.loading" layout-align="end start"\n        ng-class="{\'md-primary\': !vm.fileUploaded, \'md-accent\': $ctrl.fileUploaded}" class="md-raised"\n        ng-click="$ctrl.selectFile()">\n        {{ $ctrl.fileUploaded ? \'Clear File\' : \'Upload Image\' }}\n      </md-button>\n    </div>\n\n    <md-input-container flex ng-if="$ctrl.imageType || $ctrl.formType === \'edit\'">\n      <label>Image Title</label>\n      <input type="text" name="title" ng-model="$ctrl.imageDoc.title" aria-label="Title" required md-autofocus>\n      <div ng-messages="$ctrl.formObject.title.$error" md-auto-hide="false" ng-show="$ctrl.formObject.title.$touched">\n        <div ng-message when="required">\n          <spanYour image item needs a title</span>\n        </div>\n      </div>\n    </md-input-container>\n\n\n    <md-input-container flex ng-if="$ctrl.imageType === \'upload\'">\n      <label>Filename</label>\n      <input type="text" name="filename" ng-model="$ctrl.imageDoc.filename" required="$ctrl.imageType === \'upload\'"\n        aria-label="Filename">\n      <div class="hint" ng-if="$ctrl.showHints">You can change the filename here if you like</div>\n      <div ng-messages="$ctrl.formObject.weburi.$error" md-auto-hide="false" ng-show="$ctrl.formObject.weburi.$touched">\n        <div ng-message when="required">\n          <spanPlease enter a Filename</span>\n        </div>\n      </div>\n    </md-input-container>\n\n  </div>\n  <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n\n<input id="imageUploadInput" type="file" ng-upload-change="$ctrl.fileChanged($event)"\n  accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*" style="display:none" />');
$templateCache.put('app/authentication/mfa/confirm-reset/mfa-confirm-reset.component.tmpl.html','<div class="lagoon-bg" layout-fill>\n    <div layout="row" flex layout-padding layout-fill layout-align="center center">\n\n        <div class="mfa-frame small">\n            <div layout="row" layout-margin layout-align="center center">\n\n                <div ng-include class="cloud-logo-constrained" src="$ctrl.zuantLogoURL"></div>\n\n            </div>\n\n            <div layout-margin layout-padding></div>\n\n            <md-card>\n\n                <md-content class="md-padding" layout-padding>\n\n                    <!-- ERROR CASE -->\n                    <div ng-if="$ctrl.error" layout="column" layout-align="center center" layout-padding>\n\n                        <p class="md-display-1 zuantTitanium1 thin-font margin-bottom-10 text-align-center">\n                            MFA Reset Error\n                        </p>\n\n                        <md-icon md-font-icon="zmdi zmdi-alert-triangle" class="error"></md-icon>\n\n                        <p class="zuantSaffron md-subhead margin-top-20 margin-bottom-10">\n                            <b>{{$ctrl.error}}</b>\n                        </p>\n\n                        <p class="zuantTitanium1 md-subhead margin-top-0 margin-bottom-0 text-align-center">\n                            Please try again, or contact <a href="mailto:support@zuant.com">support@zuant.com</a> if the\n                            issue persists.\n                        </p>\n\n                        <md-button\n                            class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-20 margin-bottom-10"\n                            aria-label="Login" type="button" ui-sref="login">\n                            RETURN TO LOGIN\n                        </md-button>\n\n                    </div>\n\n                    <div ng-if="!$ctrl.error" layout-padding ng-switch="$ctrl.type">\n\n                        <!-- ZUANT ADMIN CASE -->\n                        <div layout="column" layout-align="center center" ng-switch-when="zuant_admin">\n                            <p class="md-display-1 zuantTitanium1 thin-font margin-bottom-10 text-align-center">\n                                MFA Reset Request Confirmed\n                            </p>\n\n                            <p class="zuantTitanium1 md-subhead margin-top-0 margin-bottom-20 text-align-center">\n                                You have confirmed your MFA reset request and can now login using your newly established\n                                MFA token.\n                            </p>\n\n                            <md-icon md-font-icon="zmdi zmdi-check-circle"></md-icon>\n\n                            <md-button\n                                class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-20 margin-bottom-10"\n                                aria-label="Login" type="button" ui-sref="login">\n                                GO TO LOGIN\n                            </md-button>\n                        </div>\n\n                        <!-- DEFAULT CASE -->\n                        <div layout="column" layout-align="center center" ng-switch-default>\n                            <p class="md-display-1 zuantTitanium1 thin-font margin-bottom-10 text-align-center">\n                                MFA Reset Request Confirmed\n                            </p>\n\n                            <p class="zuantTitanium1 md-subhead margin-top-0 margin-bottom-0">\n                                The users requested reset has been confirmed.\n                            </p>\n\n                            <md-icon md-font-icon="zmdi zmdi-check-circle"></md-icon>\n\n                            <div layout-padding layout="column" layout-align=" start">\n\n                                <p ng-if="$ctrl.message" ng-bind-html="$ctrl.message"\n                                    class="zuantTitanium1 md-subhead margin-top-20 margin-bottom-0">\n                                </p>\n\n                                <p ng-if="$ctrl.error" class="zuantSaffron md-subhead margin-top-20 margin-bottom-0">\n                                    <b>{{$ctrl.error}}</b>\n                                </p>\n\n                                <p class="zuantTitanium1 md-subhead margin-top-0 margin-bottom-0">\n                                    Please regard this request as resolved. The user who requested the reset should have\n                                    received an email guiding them on how to re-establish their MFA. You can now close\n                                    this\n                                    window or navigate to the <b>"{{$ctrl.userIsLoggedIn ? \'Dashboard\' : \'Login\'}}"</b>\n                                    page\n                                    using the button below. Thank you for your\n                                    co-operation.\n                                </p>\n\n                            </div>\n\n                            <md-button ng-if="$ctrl.userIsLoggedIn"\n                                class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-20 margin-bottom-10"\n                                aria-label="Dashboard" type="button" ui-sref="app.single_view_framework.dashboard">\n                                GO TO DASHBOARD\n                            </md-button>\n\n                            <md-button ng-if="!$ctrl.userIsLoggedIn"\n                                class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-20 margin-bottom-10"\n                                aria-label="Login" type="button" ui-sref="login">\n                                GO TO LOGIN\n                            </md-button>\n\n                        </div>\n\n                </md-content>\n\n            </md-card>\n\n        </div>\n\n    </div>\n\n</div>');
$templateCache.put('app/authentication/mfa/confirm-setup/mfa-confirm-setup.component.tmpl.html','<div class="lagoon-bg" layout-fill>\n\n    <div layout="row" flex layout-padding layout-fill layout-align="center center">\n\n        <div class="mfa-frame">\n\n            <div layout="row" layout-margin layout-align="center center">\n                <div ng-include class="cloud-logo-constrained" src="$ctrl.zuantLogoURL"></div>\n            </div>\n\n            <div layout-margin layout-padding></div>\n\n            <md-card>\n                <md-content class="md-padding" layout-padding>\n                    <div ng-if="$ctrl.setupComplete" layout-padding layout="column" layout-align="center center">\n                        <p class="md-display-1 zuantTitanium1 thin-font margin-bottom-10 text-align-center">\n                            MFA Setup Complete\n                        </p>\n                        <p class="zuantTitanium1 md-subhead margin-top-0 margin-bottom-0">\n                            You\u2019re all setup!\n                        </p>\n\n                        <md-icon md-font-icon="zmdi zmdi-check-circle"></md-icon>\n\n                        <p class="zuantTitanium1 margin-top-20 margin-bottom-0">\n                            You\'ve successfully completed setting up Multi-Factor Authentication (MFA)\n                            for your account. With MFA in place, your account is now fortified with an extra layer of\n                            security, ensuring that your personal information and data remain safeguarded against\n                            unauthorized access. By implementing MFA, you\'ve taken a proactive step in enhancing the\n                            security posture of your online presence.\n                        </p>\n\n                        <p class="zuantTitanium1 margin-top-0 margin-bottom-0">\n                            Now that your MFA setup is complete, you can proceed to log in to your account confidently.\n                            Click the <b>"CONTINUE TO LOGIN"</b> button below to take you back to the login page.\n                        </p>\n\n                        <md-button\n                            class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-20 margin-bottom-10"\n                            aria-label="Login" type="button" ui-sref="login">CONTINUE TO LOGIN</md-button>\n                    </div>\n                    <div ng-if="!$ctrl.setupComplete" layout-padding layout="column" layout-align="center center">\n\n                        <p class="md-display-1 zuantTitanium1 thin-font margin-bottom-10 text-align-center">\n                            MFA Setup Confirmation\n                        </p>\n                        <p class="zuantTitanium1 margin-top-0 margin-bottom-0">\n                            Please complete MFA setup for your user login by following the steps below:\n                        </p>\n\n                        <div layout-fill layout="column" layout-align=" start">\n                            <p class="zuantTitanium1 margin-top-5 margin-bottom-0">\n                                Step 1: Download & Install the <b>Google Authenticator</b> App.\n                            </p>\n                            <p class="zuantTitanium1 margin-top-0 margin-bottom-0">\n                                Step 2: Use the app to scan the barcode below, or enter the <b>\u201CSECRET\u201D</b> code\n                            </p>\n                            <p class="zuantTitanium1 margin-top-0 margin-bottom-0">\n                                Step 3: Enter the 6-digit code provided by the app into the field below.\n                            </p>\n                            <p class="zuantTitanium1 margin-top-0 margin-bottom-10">\n                                Step 4: Click the <b>\u201CCONFIRM\u201D</b> button below.\n                            </p>\n\n                            <div layout="row" layout-align="start center">\n                                <div class="appstore-svg-container" ng-click="$ctrl.openAppStore()">\n                                    <img src="{{\'/images/svgs/logos/thirdparty/apple/appstore.svg\' | cdnAssets}}">\n                                </div>\n                                <div class="playstore-svg-container" ng-click="$ctrl.openPlayStore()">\n                                    <img src="{{\'/images/svgs/logos/thirdparty/android/playstore.svg\' | cdnAssets}}">\n                                </div>\n                            </div>\n                        </div>\n\n\n                        <qr class="margin-top-10 margin-bottom-0" type-number="0" correction-level="\'M\'" size="200"\n                            input-mode="\'AUTO\'" text="$ctrl.resolvedToken.qrUrl" image="true"></qr>\n\n                        <p class="zuantTitanium1 margin-top-0 margin-bottom-5">\n                            SECRET: <span class="secret-code">{{$ctrl.resolvedToken.secret}}</span>\n                        </p>\n\n                        <form name="$ctrl.otpForm" ng-submit="$ctrl.confirmOtp()">\n\n                            <div layout-align=" start">\n                                <label class="zuantTitanium1 code-label">\n                                    Enter Code Here:\n                                </label>\n                            </div>\n\n                            <zp-otp form="$ctrl.otpForm" invalid="$ctrl.invalidPasscode" error="$ctrl.passcodeError"\n                                otp="$ctrl.passcode"></zp-otp>\n\n                            <md-button\n                                class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10"\n                                ng-disabled="!$ctrl.passcode" aria-label="Submit" type="submit">Confirm</md-button>\n\n                            <input type="hidden" name="CSRFToken" value="1231234567890" />\n                        </form>\n                    </div>\n                </md-content>\n            </md-card>\n\n\n        </div>\n    </div>\n</div>');
$templateCache.put('app/authentication/mfa/recovery/mfa-recovery.tmpl.html','<div class="lagoon-bg" layout-fill>\n\n    <div layout="row" flex layout-padding layout-fill layout-align="center center">\n\n        <div class="mfa-frame small">\n\n            <div layout="row" layout-margin layout-align="center center">\n\n                <div ng-include class="cloud-logo-constrained" src="$ctrl.zuantLogoURL"></div>\n\n            </div>\n\n            <div layout-margin layout-padding></div>\n\n            <md-card>\n\n                <md-content class="md-padding" layout-padding>\n\n                    <div layout-padding ng-switch="$ctrl.databasename">\n\n                        <!-- Case for Marketpoint -->\n                        <div layout="column" layout-align="center center" ng-switch-when="Marketpoint">\n\n                            <p class="md-display-1 zuantTitanium1 thin-font margin-bottom-10 text-align-center">\n                                MFA Recovery\n                            </p>\n\n                            <p class="zuantTitanium1 margin-top-0 margin-bottom-0">\n                                An MFA reset email has been sent to:\n                                <strong>{{$ctrl.email}}</strong>.\n                            </p>\n\n                            <md-icon md-font-icon="zmdi zmdi-shield-check"></md-icon>\n\n                            <div layout="column" layout-align=" start">\n                                <p class="zuantTitanium1 margin-top-10 margin-bottom-5">\n                                    Please check your inbox for further instructions on how to reset your MFA.\n                                </p>\n                                <p class="zuantTitanium1 margin-top-0 margin-bottom-5">\n                                    If you can\'t find the email, please check alternative folders such as junk, spam,\n                                    social, or others.\n                                </p>\n                                <p class="zuantTitanium1 margin-top-0 margin-bottom-0">\n                                    For further assistance, reach out to your designated CSM, or email\n                                    <a href="mailto:support@zuant.com">support@zuant.com</a>\n                                </p>\n                            </div>\n\n                            <md-button ui-sref="login"\n                                class="md-primary md-raised full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10">\n                                Return To Login\n                            </md-button>\n\n                        </div>\n\n                        <!-- Default fallback (all other databases) -->\n                        <div layout="column" layout-align="center center" ng-switch-default>\n\n                            <p class="md-display-1 zuantTitanium1 thin-font margin-bottom-10 text-align-center">\n                                MFA Recovery\n                            </p>\n\n                            <p class="zuantTitanium1 margin-top-0 margin-bottom-0">\n                                Your Zuant Account Owner and CSM (Customer Success Manager) have been emailed regarding\n                                your\n                                need for an MFA reset. Instructions on resetting your MFA have been emailed to the\n                                account\n                                owner and CSM. Please be patient as this process involves manual human verification and\n                                therefore may take some time.\n                            </p>\n\n                            <md-icon md-font-icon="zmdi zmdi-shield-check"></md-icon>\n\n                            <div layout="column" layout-align=" start">\n                                <p class="zuantTitanium1 margin-top-10 margin-bottom-5">\n                                    When your administrator confirms your request you will receive an email with\n                                    instructions on how to get re-setup with MFA.\n                                </p>\n                                <p class="zuantTitanium1 margin-top-0 margin-bottom-5">\n                                    If you can\'t find the email, please check alternative folders such as junk, spam,\n                                    social, or others.\n                                </p>\n                                <p class="zuantTitanium1 margin-top-0 margin-bottom-0">\n                                    For further assistance, reach out to your designated CSM, or email\n                                    <a href="mailto:support@zuant.com">support@zuant.com</a>\n                                </p>\n                            </div>\n\n                            <md-button ui-sref="login"\n                                class="md-primary md-raised full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10">\n                                Return To Login\n                            </md-button>\n\n                        </div>\n\n                </md-content>\n\n            </md-card>\n\n\n        </div>\n    </div>\n</div>');
$templateCache.put('app/authentication/mfa/setup/mfa-setup.tmpl.html','<div class="lagoon-bg" layout-fill>\n\n    <div layout="row" flex layout-padding layout-fill layout-align="center center">\n\n        <div class="mfa-frame">\n\n            <div layout="row" layout-margin layout-align="center center">\n                <div ng-include class="cloud-logo-constrained" src="$ctrl.zuantLogoURL"></div>\n            </div>\n\n            <div layout-margin layout-padding></div>\n\n            <md-card>\n\n                <md-content class="md-padding" layout-padding>\n\n                    <div layout-padding layout="column" layout-align="center center">\n\n                        <p class="md-display-1 zuantTitanium1 thin-font margin-bottom-10 text-align-center">\n                            Setup MFA\n                        </p>\n\n                        <p class="zuantTitanium1 margin-top-0 margin-bottom-0">\n                            Your Zuant Account has MFA enabled. You will need to setup MFA before you can continue to\n                            login.\n                        </p>\n\n                        <div layout="column" layout-align=" start">\n                            <p class="zuantTitanium1 margin-top-5 margin-bottom-5">\n                                MFA (Multi Factor Authentication) is a way to enhance the security of the sign-in\n                                process. It does this by requiring the use of a secondary device issuing a time\n                                orientated single-use code that is validated upon signing in to the Cloud.\n                            </p>\n\n                            <p class="zuantTitanium1 margin-top-0 margin-bottom-5">\n                                We have sent an email to <b>"{{$ctrl.email}}"</b> with instructions on how to proceed\n                                with setting up MFA.\n                            </p>\n\n                            <p class="zuantTitanium1 margin-top-0 margin-bottom-5">\n                                If you don\'t see the email, check other places it might be, like your junk, spam,\n                                social, or other folders.\n                            </p>\n\n                            <p class="zuantTitanium1 margin-top-0 margin-bottom-0">\n                                Still no luck? Please confirm the email above is correct and click on the "Resend Email"\n                                button below. If your email is not correct or you need any further assistance then\n                                please contact your assigned CSM or <a\n                                    href="mailto:support@zuant.com">support@zuant.com</a>\n                            </p>\n\n                        </div>\n\n                        <md-button ng-disabled="$ctrl.disableResendBtn" ng-click="$ctrl.resendSetupEmail()"\n                            class="md-accent md-hue-2 md-raised full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-5">\n                            Resend Email\n                        </md-button>\n\n                        <md-button ui-sref="login"\n                            class="md-primary md-raised full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10">\n                            Finished setting up? Return To Login\n                        </md-button>\n                    </div>\n                </md-content>\n            </md-card>\n\n\n        </div>\n    </div>\n</div>');
$templateCache.put('app/authentication/mfa/verification/mfa-verification.tmpl.html','<div class="lagoon-bg" layout-fill>\n\n    <div layout="row" flex layout-padding layout-fill layout-align="center center">\n\n        <div class="mfa-frame">\n\n            <div layout="row" layout-margin layout-align="center center">\n                <div ng-include class="cloud-logo-constrained" src="$ctrl.zuantLogoURL"></div>\n            </div>\n\n            <div layout-margin layout-padding></div>\n\n            <md-card>\n\n                <md-content class="md-padding" layout-padding>\n                    <div layout-padding layout="column" layout-align="center center">\n\n                        <p class="md-display-1 zuantTitanium1 thin-font margin-bottom-10 text-align-center">\n                            MFA Verification\n                        </p>\n\n                        <p class="zuantTitanium1 margin-top-0 margin-bottom-0">\n                            Please enter the verification code provided by your authenticator app\n                        </p>\n\n                        <form name="$ctrl.otpForm" ng-submit="$ctrl.submitVerificationForm()"\n                            ng-disabled="$ctrl.disabledForm">\n                            <zp-otp form="$ctrl.otpForm" invalid="$ctrl.passcodeInvalid" error="$ctrl.passcodeError"\n                                otp="$ctrl.passcode"></zp-otp>\n\n                            <p class="zuantTitanium1 margin-top-0 margin-bottom-0">\n                                If you have lost access to your authenticator app, or no longer have your MFA Secret,\n                                please use the <b>\u201CRESET MFA\u201D</b> button to request a reset.\n                            </p>\n\n                            <div layout="row" layout-align="end center">\n                                <md-button\n                                    ui-sref="mfa.recovery({ email: $ctrl.email, userId: $ctrl.userId, databasename: $ctrl.databasename })"\n                                    class="md-primary">\n                                    Reset MFA\n                                </md-button>\n                            </div>\n\n                            <md-button\n                                class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10"\n                                ng-disabled="!$ctrl.passcode" aria-label="Submit" type="submit">Submit</md-button>\n\n                            <input type="hidden" name="CSRFToken" value="1231234567890" />\n                        </form>\n                    </div>\n                </md-content>\n            </md-card>\n\n\n        </div>\n\n    </div>\n\n</div>');
$templateCache.put('app/biz-card/page-components/zp-bizcard-home/page.tmpl.html','<!-- <md-toolbar class="zuant-page-toolbar md-primary">\n  <div layout="row" class="md-toolbar-tools" layout-align="start center">\n    <h1>Business Card Processor Tool</h1>\n    <span flex></span>\n    <md-menu>\n      <md-button class="md-icon-button" aria-label="open menu" ng-click="$mdOpenMenu()">\n        <md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon>\n        <md-tooltip md-direction="left">\n          Options\n        </md-tooltip>\n      </md-button>\n      <md-menu-content width="3">\n        <md-menu-item ng-click="$ctrl.toggleViewCardList($event)">\n          <md-button ng-click="$mdCloseMenu">\n            <md-icon md-font-icon="{{$ctrl.toggleViewIcon}}"></md-icon>\n            <span ng-show="$ctrl.showList">Hide</span>\n            <span ng-show="!$ctrl.showList">Show</span>\n             card counts list\n            <md-tooltip md-direction="left">\n              show/hide list of card counts\n            </md-tooltip>\n          </md-button>\n        </md-menu-item>\n      </md-menu-content>\n    </md-menu>\n  </div>\n</md-toolbar> -->\n\n<md-content layout-fill layout="column">\n\n    <div layout="row" layout-sm="column" layout-xs="column" layout-margin layout-align="space-around center" layout-padding>\n      <md-card style="margin-left: 10px; margin-right: 10px;" class="" title="Awaiting processing" subtitle="Ready when you are!" title-position="top" content-layout="column" content-layout-align="space-between center" layout-fill flex="50">\n        <div layout="row" layout-fill layout-align="end center" flex>\n          <div layout-padding layout-align="end end">\n            <md-icon class="font-size-8 opacity-20" md-font-icon="zmdi zmdi-time"></md-icon>\n          </div>\n          <div layout="column" layout-padding layout-align="end start">\n            <!-- <p ng-hide="$ctrl.loadingCardData" id="home-awaitingcount" class="md-display-3 font-weight-100 margin-top-0 margin-bottom-0 text-ellipsis"></p> -->\n            <md-progress-circular ng-show="$ctrl.loadingCardData" class="md-hue-2" md-mode="indeterminate"></md-progress-circular>\n            <p class="md-body-3 opacity-80 margin-top-0 margin-bottom-0">Click the button below to view cards to process grouped by form and user</p>\n          </div>\n        </div>\n        <div palette-background="zuant-aqua:400" layout-fill flex style="max-height:64px;">\n          <div layout-padding layout="row" layout-align="end center">\n            <md-button ng-click="$ctrl.navigateToGroupedCardsView($ctrl.enums.processType.UNPROCESSED)" ng-disabled="$ctrl.loadingCardData" class="md-raised md-accent">\n              VIEW CARD GROUPS\n              <md-icon class="font-size-2 opacity-50" md-font-icon="fa fa-chevron-right"></md-icon>\n            </md-button>\n          </div>\n        </div>\n      </md-card>\n\n      <!-- <md-card style="margin-left: 10px; margin-right: 10px;" class="" title="Couldn\'t be processed" subtitle="Needs Attention" title-position="top" content-layout="column" content-layout-align="space-between center" layout-fill flex>\n        <div layout="row" layout-fill layout-align="end center" flex>\n          <div layout-padding layout-align="end end">\n            <md-icon class="font-size-8 opacity-20" md-font-icon="zmdi zmdi-alert-triangle"></md-icon>\n          </div>\n          <div layout="column" layout-padding layout-align="end end">\n            <p ng-hide="$ctrl.loadingCardData" id="home-unprocessable" class="md-display-3 font-weight-100 margin-top-0 margin-bottom-0 text-ellipsis"></p>\n            <md-progress-circular ng-show="$ctrl.loadingCardData" class="md-hue-2" md-mode="indeterminate"></md-progress-circular>\n            <p class="md-body-3 opacity-80 margin-top-0 margin-bottom-0">CARDS</p>\n          </div>\n        </div>\n        <div palette-background="zuant-aqua:400" layout-fill flex style="max-height:64px;">\n          <div layout-padding layout="row" layout-align="end center">\n            <md-button ng-click="$ctrl.navigateToGroupedCardsView($ctrl.enums.processType.UNPROCESSABLE)" ng-disabled="$ctrl.loadingCardData">\n              TAKE A LOOK\n              <md-icon class="font-size-2 opacity-50" md-font-icon="fa fa-chevron-right"></md-icon>\n            </md-button>\n          </div>\n        </div>\n      </md-card>\n\n      <md-card style="margin-left: 10px; margin-right: 10px;" class="" title="Processed cards" subtitle="And fancy charts" content-layout="column" content-layout-align="space-between center" layout-fill flex>\n        <div layout="row" layout-fill layout-align="end center" flex>\n          <div layout-padding>\n            <md-icon class="font-size-8 opacity-20" md-font-icon="fa fa-bar-chart-o"></md-icon>\n          </div>\n          <div layout="column" layout-padding layout-align="end end">\n            <p ng-hide="$ctrl.loadingCardData" id="home-processed" class="md-display-3 font-weight-100 margin-top-0 margin-bottom-0 text-ellipsis"></p>\n            <md-progress-circular ng-show="$ctrl.loadingCardData" class="md-hue-2" md-mode="indeterminate"></md-progress-circular>\n            <p class="md-body-3 opacity-70 margin-top-0 margin-bottom-0">CARDS</p>\n          </div>\n        </div>\n        <div palette-background="zuant-aqua:400" layout-fill flex style="max-height:64px;">\n          <div layout-padding layout="row" layout-align="end center">\n            <md-button ng-click="$ctrl.navigateToGroupedCardsView($ctrl.enums.processType.PROCESSED)" ng-disabled="$ctrl.loadingCardData">\n              VIEW DATA\n              <md-icon class="font-size-2 opacity-50" md-font-icon="fa fa-chevron-right"></md-icon>\n            </md-button>\n          </div>\n        </div>\n      </md-card> -->\n    </div>\n\n</md-content>\n');
$templateCache.put('app/biz-card/page-components/zp-bizcard-reports/page.tmpl.html','<md-toolbar class="zuant-page-toolbar md-primary">\n  <div layout="row" class="md-toolbar-tools" layout-align="start center">\n\n    <md-button class="md-icon-button" ng-click="$ctrl.prevPage()">\n      <md-icon md-font-icon="zmdi zmdi-chevron-left" style="margin-right: 25px; font-size:30pt; margin-top: -10px;"></md-icon>\n      <md-tooltip md-direction="right">\n        Go to previous page\n      </md-tooltip>\n    </md-button>\n    <h1>Business Card Processor Tool</h1>\n\n    <span flex></span>\n  </div>\n</md-toolbar>\n<div class="sales-dashboard" layout="column">\n  <div layout="row" layout-margin ng-show="$ctrl.maxDateReport">\n    <md-card flex>\n      <div>\n        <div layout="row" layout-align="center end">\n          <div flex layout-margin>\n            <span>Business Cards Processed by Date</span>\n          </div>\n          <span flex></span>\n          <md-button class="md-icon-button" aria-label="open menu" ng-click="$ctrl.toggleDateReportDisplay()">\n            <md-icon md-font-icon="zmdi zmdi-fullscreen-exit"></md-icon>\n            <md-tooltip md-direction="top">\n              Reduce Display\n            </md-tooltip>\n          </md-button>\n        </div>\n      </div>\n      <md-card flex class="padding-left-40 padding-right-40 padding-top-20 padding-bottom-20 no-shadow">\n        <canvas height="100" class="chart chart-line" chart-data="$ctrl.dateReport.chartData" chart-legend="true" chart-labels="$ctrl.dateReport.labels" chart-series="$ctrl.chart.series"></canvas>\n      </md-card>\n    </md-card>\n  </div>\n  <div layout="row" layout-margin ng-show="$ctrl.maxEventReport">\n    <md-card flex>\n      <div>\n        <div layout="row" layout-align="center end">\n          <div flex layout-margin>\n            <span>Business Cards Processed by Event</span>\n          </div>\n          <span flex></span>\n          <md-button class="md-icon-button" aria-label="open menu" ng-click="$ctrl.toggleEventReportDisplay()">\n            <md-icon md-font-icon="zmdi zmdi-fullscreen-alt"></md-icon>\n            <md-tooltip md-direction="top">\n              Enlarge Display\n            </md-tooltip>\n          </md-button>\n        </div>\n      </div>\n      <md-card flex class="padding-left-40 padding-right-40 padding-top-20 padding-bottom-20 no-shadow">\n        <canvas height="100" class="chart chart-line" chart-data="$ctrl.eventReport.chartData" chart-legend="true" chart-labels="$ctrl.eventReport.labels" chart-series="$ctrl.chart.series"></canvas>\n      </md-card>\n    </md-card>\n  </div>\n\n\n  <div layout="row" layout-margin ng-show="$ctrl.maxClientReport">\n    <md-card flex>\n      <div>\n        <div layout="row" layout-align="center end">\n          <div flex layout-margin>\n            <span>Business Cards Processed by Client</span>\n          </div>\n          <span flex></span>\n          <md-button class="md-icon-button" aria-label="open menu" ng-click="$ctrl.toggleClientReportDisplay()">\n            <md-icon md-font-icon="zmdi zmdi-fullscreen-alt"></md-icon>\n            <md-tooltip md-direction="top">\n              Enlarge Display\n            </md-tooltip>\n          </md-button>\n        </div>\n      </div>\n      <md-card flex class="padding-left-40 padding-right-40 padding-top-20 padding-bottom-20 no-shadow">\n        <canvas height="100" class="chart chart-bar" chart-data="$ctrl.clientReport.chartData" chart-legend="true" chart-labels="$ctrl.clientReport.labels" chart-series="$ctrl.chart.series"></canvas>\n      </md-card>\n    </md-card>\n  </div>\n  <div layout="row" layout-margin ng-show="$ctrl.maxUserReport">\n    <md-card flex>\n      <div>\n        <div layout="row" layout-align="center end">\n          <div flex layout-margin>\n            <span>Business Cards Processed by User</span>\n          </div>\n          <span flex></span>\n          <md-button class="md-icon-button" aria-label="open menu" ng-click="$ctrl.toggleUserReportDisplay()">\n            <md-icon md-font-icon="zmdi zmdi-fullscreen-alt"></md-icon>\n            <md-tooltip md-direction="top">\n              Enlarge Display\n            </md-tooltip>\n          </md-button>\n        </div>\n      </div>\n      <md-card flex class="padding-left-40 padding-right-40 padding-top-20 padding-bottom-20 no-shadow">\n        <canvas height="100" class="chart chart-bar" chart-data="$ctrl.userReport.chartData" chart-legend="true" chart-labels="$ctrl.userReport.labels" chart-series="$ctrl.chart.series"></canvas>\n      </md-card>\n    </md-card>\n  </div>\n\n  <div layout="row" layout-xs="column" layout-margin ng-show="$ctrl.minall">\n    <md-card flex ng-show="$ctrl.minall || $ctrl.maxDateReport">\n      <div>\n        <div layout="row" layout-align="center end">\n          <div flex layout-margin>\n            <span>Business Cards Processed by Date</span>\n          </div>\n          <span flex></span>\n          <md-button class="md-icon-button" aria-label="open menu" ng-click="$ctrl.toggleDateReportDisplay()">\n            <md-icon md-font-icon="zmdi zmdi-fullscreen-alt"></md-icon>\n            <md-tooltip md-direction="top">\n              Enlarge Display\n            </md-tooltip>\n          </md-button>\n        </div>\n      </div>\n      <md-card flex class="padding-left-40 padding-right-40 padding-top-20 padding-bottom-20 no-shadow">\n        <canvas height="100" class="chart chart-line" ng-class="{\'chart-line\' : $ctrl.chartLine, \'chart-bar\' : $ctrl.chartBar}" chart-data="$ctrl.dateReport.chartData" chart-legend="true" chart-labels="$ctrl.dateReport.labels" chart-series="$ctrl.chart.series"></canvas>\n      </md-card>\n    </md-card>\n\n    <md-card flex ng-show="$ctrl.minall">\n      <div>\n        <div layout="row" layout-align="center end">\n          <div flex layout-margin>\n            <span>Business Cards Processed by Event</span>\n          </div>\n          <span flex></span>\n          <md-button class="md-icon-button" aria-label="open menu" ng-click="$ctrl.toggleEventReportDisplay()">\n            <md-icon md-font-icon="zmdi zmdi-fullscreen-alt"></md-icon>\n            <md-tooltip md-direction="top">\n              Enlarge Display\n            </md-tooltip>\n          </md-button>\n        </div>\n      </div>\n      <md-card flex class="padding-left-40 padding-right-40 padding-top-20 padding-bottom-20 no-shadow">\n        <canvas height="100" class="chart chart-line" chart-data="$ctrl.eventReport.chartData" chart-legend="true" chart-labels="$ctrl.eventReport.labels" chart-series="$ctrl.chart.series"></canvas>\n      </md-card>\n    </md-card>\n  </div>\n\n  <div layout="row" layout-xs="column" layout-margin ng-show="$ctrl.minall">\n    <md-card flex ng-show="$ctrl.minall">\n      <div>\n        <div layout="row" layout-align="center end">\n          <div flex layout-margin>\n            <span>Business Cards Processed by Client</span>\n          </div>\n          <span flex></span>\n          <md-button class="md-icon-button" aria-label="open menu" ng-click="$ctrl.toggleClientReportDisplay()">\n            <md-icon md-font-icon="zmdi zmdi-fullscreen-alt"></md-icon>\n            <md-tooltip md-direction="top">\n              Enlarge Display\n            </md-tooltip>\n          </md-button>\n        </div>\n      </div>\n      <md-card flex class="padding-left-40 padding-right-40 padding-top-20 padding-bottom-20 no-shadow">\n        <canvas height="100" class="chart chart-bar" chart-data="$ctrl.clientReport.chartData" chart-legend="true" chart-labels="$ctrl.clientReport.labels" chart-series="$ctrl.chart.series"></canvas>\n      </md-card>\n    </md-card>\n\n    <md-card flex ng-show="$ctrl.minall">\n      <div>\n        <div layout="row" layout-align="center end">\n          <div flex layout-margin>\n            <span>Business Cards Processed by User</span>\n          </div>\n          <span flex></span>\n          <md-button class="md-icon-button" aria-label="open menu" ng-click="$ctrl.toggleUserReportDisplay()">\n            <md-icon md-font-icon="zmdi zmdi-fullscreen-alt"></md-icon>\n            <md-tooltip md-direction="top">\n              Enlarge Display\n            </md-tooltip>\n          </md-button>\n        </div>\n      </div>\n      <md-card flex class="padding-left-40 padding-right-40 padding-top-20 padding-bottom-20 no-shadow">\n        <canvas height="100" class="chart chart-bar" chart-data="$ctrl.userReport.chartData" chart-legend="true" chart-labels="$ctrl.userReport.labels" chart-series="$ctrl.chart.series"></canvas>\n      </md-card>\n    </md-card>\n  </div>\n\n  <div layout="row" layout-sm="column" layout-margin>\n    <md-card flex title="Processed Business Cards" content-layout="column" content-layout-align="center">\n      <table class="md-data-table" md-progress="$ctrl.deferred">\n        <thead md-order="$ctrl.query.order" md-trigger="$ctrl.getUsers">\n          <tr>\n            <th name="Date Processed" order-by="date" decend-first></th>\n            <th name="Processing Time" order-by="date"></th>\n            <th name="Operator" order-by="buyer"></th>\n            <th name="Event" order-by="items.length"></th>\n            <th name="Client" order-by="status"></th>\n            <th name="Status" order-by="total"></th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat="card in $ctrl.cardsForReport">\n            <td>{{::card.timecompleted | date:\'MMMM Do YYYY, h:mm:ss a\'}}</td>\n            <td>{{::card.processingTime}}</td>\n            <td>{{::card.operator}}</td>\n            <td>{{::card.eventname}}</td>\n            <td>{{::card.clientname}}</td>\n            <td>\n              <span ng-if="::card.processtype === 2" class="status">\n                PROCESSED\n              </span>\n              <span ng-if="::card.processtype === 1" class="status">\n                UNPROCESSABLE\n              </span>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-card>\n  </div>\n\n</div>\n');
$templateCache.put('app/biz-card/page-components/zp-card-processing/page.tmpl.html','<div layout="column" layout-align="space-between" layout-fill>\n  <md-toolbar class="zuant-page-toolbar md-primary md-toolbar-shrink">\n    <div layout="row" class="md-toolbar-tools" layout-align="start center">\n      <md-button class="md-icon-button" ng-click="$ctrl.exit()">\n        <md-icon md-font-icon="zmdi zmdi-chevron-left"></md-icon>\n        <md-tooltip md-direction="right">\n          Go to previous page\n        </md-tooltip>\n      </md-button>\n      <!-- <span class="md-caption">Captured by: <span class="md-body-1">{{$ctrl.leadData.response.userName}}</span></span> |\n    <span class="md-caption">Capture date: <span class="md-body-1">{{$ctrl.leadData.createddate | date:\'medium\'}} </span></span> |\n    <span class="md-caption">Event: <span class="md-body-1">{{$ctrl.leadData.response.eventName}}</span></span> -->\n      <span flex></span>\n      <zp-context-menu\n        menu-options="$ctrl.menuOptions"\n        menu-width="$ctrl.menuWidth"\n        on-menu-click="$ctrl.onMenuClick({action: action, ev: ev})">\n      </zp-context-menu>\n    </div>\n  </md-toolbar>\n\n  <md-content flex>\n\n    <div layout="column">\n      <div layout="column" layout-gt-md="row">\n\n        <zp-bizcard-processor flex="grow"\n          lead-data="$ctrl.leadData"\n          update-change-delta="$ctrl.updateChangeDelta(collection, dbfieldname, newval)"\n          empty-pot-message="$ctrl.showNoCardsLeftToProcessMessage"\n          loading-card-data="$ctrl.loadingCardData"\n          bizcardimage="$ctrl.bizcardimage"\n          response-images="$ctrl.responseImages"\n          reject-card="$ctrl.rejectCard(ev)"\n          card-data-styles="$ctrl.cardDataStyles"\n          image-container-styles="$ctrl.imageContainerStyles"\n          get-next-card="$ctrl.getNextCard(skip)"\n          skip="$ctrl.skip"\n          flex-order-sm="2"\n          flex-order-md="2">\n        </zp-bizcard-processor>\n\n        <zp-bizcard-stat-widgets\n          ng-show="$ctrl.showWidgets"\n          layout-align="start start"\n          flex-order-sm="1"\n          flex-order-md="1"\n          layout-sm="row"\n          layout-md="row"\n          flex-sm="100"\n          flex-md="100"\n          flex-gt-md="20">\n        </zp-bizcard-stat-widgets>\n\n        <!-- <zp-card-filter>\n        </zp-card-filter> -->\n\n      </div>\n    </div>\n\n  </md-content>\n\n  <md-toolbar class="md-table-toolbar md-default">\n    <div class="md-toolbar-tools">\n      <div flex layout="row" layout-align="end center">\n        <md-button type="button" class="md-warn" ng-click="$ctrl.resetForm()" ng-disabled="$ctrl.loadingCardData">\n          <md-icon md-font-icon="zmdi zmdi-undo"></md-icon>\n          <md-tooltip md-direction="top">Reset</md-tooltip>\n        </md-button>\n        <!-- <md-button type="button" class="md-warn" ng-click="$ctrl.rejectCard($event)" ng-disabled="$ctrl.loadingCardData">Reject</md-button> -->\n        <md-button type="button" class="md-primary" ng-click="$ctrl.saveCardDetails(\'Good\', false)" ng-disabled="$ctrl.loadingCardData">\n          <md-icon md-font-icon="zmdi zmdi-save"></md-icon>\n          <md-tooltip md-direction="top">Save</md-tooltip>\n        </md-button>\n        <!-- <md-button type="button" class="md-primary" ng-click="$ctrl.getNextCard()" ng-disabled="$ctrl.loadingCardData">Next Card</md-button> -->\n        <md-button type="button" class="md-raised md-primary" ng-click="$ctrl.saveCardDetails(\'Good\', true)" ng-disabled="$ctrl.loadingCardData">\n          <md-icon md-font-icon="zmdi zmdi-save"></md-icon>\n          <md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon>\n          <md-tooltip md-direction="top">Save &amp; Next</md-tooltip>\n        </md-button>\n        <md-button type="button" class="md-icon-button" ng-click="$ctrl.getNextCard(true)" ng-disabled="$ctrl.loadingCardData">\n          <md-tooltip md-direction="top">Next card</md-tooltip>\n          <md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon>\n        </md-button>\n      </div>\n    </div>\n  </md-toolbar>\n</div>\n');
$templateCache.put('app/biz-card/page-components/zp-grouped-cards/page.tmpl.html','<div layout="column" layout-align="space-between" layout-fill>\n  <md-toolbar class="md-primary">\n    <div class="md-toolbar-tools">\n\n      <!-- <md-button class="md-icon-button" ng-click="$ctrl.home()">\n        <md-icon md-font-icon="zmdi zmdi-chevron-left" tyle="margin-right: 25px; font-size:30pt; margin-top: -10px;"></md-icon>\n        <md-tooltip md-direction="right">\n          Go to previous page\n        </md-tooltip>\n      </md-button> -->\n\n      <md-input-container>\n        <md-icon md-font-icon="zmdi zmdi-search"></md-icon>\n        <input type="text" placeholder="Filter" ng-model="$ctrl.filterlist">\n      </md-input-container>\n\n      <span flex></span>\n    </div>\n  </md-toolbar>\n  <md-progress-linear class="md-accent" ng-if="$ctrl.loading"></md-progress-linear>\n  <div layout="row" flex>\n    <md-content flex="75">\n\n      <div layout="row" layout-sm="column" layout-align="start start">\n        <div layout="column" flex-order-sm="2" layout-fill>\n\n          <div ng-if="$ctrl.processType == $ctrl.enums.processType.UNPROCESSED">\n            <h2><md-icon class="font-size-4 opacity-20" md-font-icon="zmdi zmdi-time"></md-icon> Cards Awaiting Processing</h2>\n          </div>\n\n          <div layout="column" layout-margin layout-align="start start">\n            <p class="md-subhead font-weight-100 margin-top-0 margin-bottom-0 ">Cards grouped by form:</p>\n            <div layout="row" layout-wrap layout-margin>\n              <md-card ng-repeat="form in $ctrl.formCardGroup | filter: $ctrl.filterlist | orderBy: \'createddate\': true "\n                ng-click="$ctrl.toggleCardSelected(form, 1)"\n                class="biz-card"\n                layout="column"\n                layout-align="space-between end"\n                flex-sm="25"\n                ng-class="{\'md-whiteframe-6dp\': form.selected, \'md-whiteframe-4dp\' : hovering}"\n                ng-mouseenter="hovering=true"\n                ng-mouseleave="hovering=false">\n                  <div layout-padding>\n                    <p class=" font-weight-100 margin-top-0 margin-bottom-0 ">{{::form.formname}}</p>\n                  </div>\n                  <div layout="row" layout-align="end center" layout-padding>\n                    <p class="md-display-1 font-weight-100 margin-top-0 margin-bottom-0 text-ellipsis">{{::form.count}}\n                      <span class="md-caption">available</span>\n                    </p>\n                  </div>\n              </md-card>\n            </div>\n          </div>\n\n          <md-divider></md-divider>\n\n          <div layout="column" layout-sm="column" layout-margin layout-align="start start">\n            <p class="md-subhead font-weight-100 margin-top-0 margin-bottom-0 ">Cards grouped by user:</p>\n            <div layout="row" layout-wrap layout-margin>\n              <md-card\n                ng-repeat="user in $ctrl.userCardGroup | filter: $ctrl.filterlist | orderBy: \'name\' | limitTo: $ctrl.userCardLimitTo"\n                ng-click="$ctrl.toggleCardSelected(user, 2)"\n                class="biz-card"\n                layout="column"\n                layout-align="space-between start"\n                flex-sm="50"\n                ng-class="{\'md-whiteframe-6dp\': user.selected, \'md-whiteframe-4dp\' : hovering}"\n                ng-mouseenter="hovering=true"\n                ng-mouseleave="hovering=false">\n                <div layout-margin>\n                  <div class="user-card" layout-fill>\n                    <div class="" layout-padding>\n                      <div class="user-initials" layout="column" layout-align="space-around center">\n                        <p class="margin-top-0 margin-bottom-0 ">{{::user.name | limitTo: 2}}</p>\n                      </div>\n                      <p class="font-white margin-top-0 margin-bottom-0 ">\n                        <span>\n                          <md-icon md-font-icon="zmdi zmdi-account">&nbsp;&nbsp;</md-icon>{{::user.email}}</span>\n                      </p>\n                    </div>\n                  </div>\n                </div>\n                <!-- <md-divider></md-divider> -->\n                <div layout-margin>\n                  <div layout-fill>\n                    <div layout="row" layout-align="end center" layout-padding>\n                      <p class="md-display-1 font-weight-100 margin-top-0 margin-bottom-0 text-ellipsis">{{::user.count}}\n                        <span class="md-caption">available</span>\n                      </p>\n                    </div>\n                  </div>\n                </div>\n              </md-card>\n            </div>\n          </div>\n\n          <md-divider></md-divider>\n          <!-- <h1>Current Filter</h1>\n          <pre>\n            {{$ctrl.model.factoryData.cardSelectionParamaters | json}}\n          </pre> -->\n\n          <!-- <div layout="row" layout-wrap>\n            <md-card flex="40" flex-offset="5">\n              <pre style="white-space: pre-wrap">\n                $ctrl.model.factoryData.cardsGroupedByUser | json\n                {{$ctrl.model.factoryData.cardsGroupedByUser | json}}\n              </pre>\n            </md-card>\n\n            <md-card flex="40" flex-offset="5">\n              <pre style="white-space: pre-wrap">\n                  $ctrl.model.factoryData.cardsGroupedByForm | json\n                {{$ctrl.model.factoryData.cardsGroupedByForm | json}}\n              </pre>\n            </md-card>\n\n            <md-card flex="40" flex-offset="5">\n              <pre style="white-space: pre-wrap">\n                $ctrl.model.factoryData.cardViewFilters.users | json\n                {{$ctrl.model.factoryData.cardViewFilters.users | json}}\n              </pre>\n            </md-card>\n\n            <md-card flex="40" flex-offset="5">\n              <pre style="white-space: pre-wrap">\n                $ctrl.model.factoryData.cardViewFilters.forms | json\n                {{$ctrl.model.factoryData.cardViewFilters.forms | json}}\n              </pre>\n            </md-card>\n\n            <md-card flex="40" flex-offset="5">\n              <pre style="white-space: pre-wrap">\n                $ctrl.model.factoryData.cardSelectionParamaters.users | json\n                {{$ctrl.model.factoryData.cardSelectionParamaters.users | json}}\n              </pre>\n            </md-card>\n\n            <md-card flex="40" flex-offset="5">\n              <pre style="white-space: pre-wrap">\n                $ctrl.model.factoryData.cardSelectionParamaters.forms | json\n                {{$ctrl.model.factoryData.cardSelectionParamaters.forms | json}}\n              </pre>\n            </md-card>\n\n          </div> -->\n\n        </div>\n      </div>\n    </md-content>\n\n    <md-content flex="25">\n      <div layout="column" layout-margin flex flex-order-sm="1">\n        <md-card layout="column" flex>\n          <md-card-content style="max-height:54vh; overflow-y: scroll;">\n            <zp-card-filter></zp-card-filter>\n\n            <md-divider></md-divider>\n\n          </md-card-content>\n          <div\n            ng-show="$ctrl.model.factoryData.cardViewFilters.users.length || $ctrl.model.factoryData.cardViewFilters.forms.length"\n            layout="column"\n            layout-align="end">\n            <md-button ng-if="$ctrl.processType === $ctrl.enums.processType.PROCESSED" class="go-button pulsate md-primary" ng-click="$ctrl.goToReportPage()">\n              CREATE REPORT\n            </md-button>\n            <md-button type="button" class="md-warn" ng-click="$ctrl.clearCurrentSelection()">\n              Clear Selection\n            </md-button>\n            <md-button ng-if="$ctrl.processType !== $ctrl.enums.processType.PROCESSED" class="go-button pulsate-aqua md-primary" style="color: white !important;" ng-click="$ctrl.goToCardProcessingPage()">\n              BEGIN PROCESSING\n            </md-button>\n          </div>\n        </md-card>\n\n        <div layout-padding ng-show="$ctrl.model.factoryData.cardViewFilters.forms.length === 0 && $ctrl.model.factoryData.cardViewFilters.users.length === 0">\n          <p class="md-headline">Select how you wish to filter the pot of cards to process by clicking various filters in the middle of the screen.</p>\n        </div>\n        <div layout-padding ng-show="$ctrl.model.factoryData.cardsGroupedByUser.length === 0 && $ctrl.model.factoryData.cardsGroupedByForm.length === 0">\n          <p class="md-headline">No cards available for processing.</p>\n          <md-button class="md-accent md-raised" layout-fill ng-click="$ctrl.refreshData()">Refresh</md-button>\n        </div>\n\n      </div>\n    </md-content>\n  </div>\n\n</div>\n');
$templateCache.put('app/clients/boltons/zp-bolt-on-management-view/view.tmpl.html','<!-- <div layout="column"> -->\n\n<div flex-offset-gt-sm="20" layout-padding>\n  <p class="md-headline">Manage account bolt-ons</p>\n  <!-- <p class="md-subhead">An email will be sent to the account owner confirming any changes made.</p> -->\n</div>\n\n<zp-bolt-ons-list model="$ctrl.boltOns" selected="$ctrl.toggleBoltOn(boltOn)">\n</zp-bolt-ons-list>\n\n<md-card ng-show="$ctrl.changes.length" flex="60" flex-offset="20">\n\n  <md-card-content>\n\n    <p class="md-headline text-align-center">Proposed Plan Changes</p>\n\n    <md-list>\n\n      <md-list-item ng-repeat-start="change in $ctrl.changes">\n        <p>\n\n          <md-icon md-font-icon="zmdi zmdi-check zuantAqua" ng-if="change.enabled"></md-icon>\n          <md-icon md-font-icon="zmdi zmdi-close zuantSaffron" ng-if="!change.enabled"></md-icon>\n\n          {{change.label}} will be\n          <span ng-show="{{change.enabled}}">enabled</span>\n          <span ng-show="{{!change.enabled}}">disabled</span>\n\n        </p>\n\n      </md-list-item>\n\n      <md-divider ng-repeat-end></md-divider>\n\n    </md-list>\n\n  </md-card-content>\n\n  <md-card-actions layout="column" layout-align="center">\n\n    <md-progress-linear ng-if="$ctrl.saving" class="md-accent" md-indeterminate></md-progress-linear>\n    <md-button ng-click="$ctrl.clearChanges(true)" ng-disabled="!$ctrl.changes.length">Undo</md-button>\n    <md-button class="md-primary md-raised" ng-disabled="$ctrl.saving"\n      ng-class="{\'pulsate-aqua animated\': $ctrl.pulseSaveBtn}" ng-click="$ctrl.postChanges()">\n      Save Changes\n    </md-button>\n  </md-card-actions>\n\n</md-card>\n\n<md-card ng-show="$ctrl.updateSuccess" flex="60" flex-offset="20">\n\n  <md-card-content>\n\n    <p class="md-headline text-align-center">\n      Account changes saved<br>\n      <!-- We\'ve sent an email confirmation to {{$ctrl.userData.email}}, too -->\n    </p>\n    <!-- <p class="md-headline">Plan Changes</p> -->\n\n    <md-list>\n\n      <md-list-item ng-repeat-start="change in $ctrl.persistedChanges">\n\n        <p>\n          <md-icon md-font-icon="zmdi zmdi-check zuantAqua" ng-if="change.enabled"></md-icon>\n          <md-icon md-font-icon="zmdi zmdi-close zuantSaffron" ng-if="!change.enabled"></md-icon>\n          {{change.label}} bolt-on was\n          <span ng-show="{{change.enabled}}">enabled</span>\n          <span ng-show="{{!change.enabled}}">disabled</span>\n        </p>\n\n      </md-list-item>\n\n      <md-divider ng-repeat-end></md-divider>\n\n    </md-list>\n\n    <md-card-actions layout="column" layout-align="center">\n      <!-- <md-button ng-click="$ctrl.closeDialog()">Close dialog</md-button> -->\n    </md-card-actions>\n\n  </md-card-content>\n\n</md-card>');
$templateCache.put('app/clients/boltons/zp-bolt-ons-cards/cards.tmpl.html','<div layout="row">\n  <md-card ng-repeat="boltOn in $ctrl.model" flex="30">\n    <md-card-header>\n      <md-card-avatar>\n        <img ng-src="{{boltOn.cardAvatar}}" />\n        <!-- <md-icon md-font-icon="zmdi {{boltOn.icon}}"></md-icon> -->\n      </md-card-avatar>\n      <md-card-header-text>\n        <span class="md-title">{{boltOn.title}}</span>\n        <span class="md-subhead">{{boltOn.subhead}}</span>\n      </md-card-header-text>\n    </md-card-header>\n    <div class="{{boltOn.property}}" layout="row" layout-align="end" show-gt-sm>\n      <div ng-include="boltOn.cardImageSrc"></div>\n    </div>\n    <!-- <md-card-content>\n  <p class="md-body-1">{{boltOn.boltOnManagerBlurb}}</p>\n</md-card-content> -->\n    <md-list>\n      <md-list-item>\n        <md-icon md-font-icon="zmdi zmdi-power" ng-class="{\'enabled\':boltOn.enabled}"></md-icon>\n        <p ng-if="boltOn.enabled">Enabled </p>\n        <p ng-if="!boltOn.enabled">Disabled </p>\n        <md-switch class="md-secondary" ng-model="boltOn.enabled" ng-change="$ctrl.toggleBoltOn(boltOn)"></md-switch>\n      </md-list-item>\n    </md-list>\n</md-card>\n</div>\n');
$templateCache.put('app/clients/boltons/zp-boltons-control/zp-boltons-control.tmpl.html','<div ng-repeat="boltOn in $ctrl.availableBoltOns" permission permission-only="boltOn.permission" flex-gt-sm="20"\n  layout-margin>\n  <md-button layout-fill class="md-grid-item-content dashboard-btn"\n    ng-class="{\'md-primary md-raised\' : $ctrl.permissions.boltOns[boltOn.property].enabled }" layout="column"\n    layout-padding ng-click="$ctrl.toggleBoltOn($event, boltOn)">\n\n    <md-icon ng-if="boltOn.icon" md-font-icon="{{boltOn.icon}}"></md-icon>\n    <md-icon ng-if="boltOn.svgicon" md-svg-src="{{boltOn.svgicon}}"></md-icon>\n\n    <div layout="row">\n      <span class="md-subhead">\n        {{boltOn.property}}\n      </span>\n      <md-icon style="position: absolute; right: 5px; bottom: 5px;"\n        ng-show="$ctrl.permissions.boltOns[boltOn.property].enabled" class="zuantPollen"\n        md-font-icon="zmdi zmdi-check-circle"></md-icon>\n    </div>\n\n  </md-button>\n</div>');
$templateCache.put('app/clients/compliance/account-settings-widget/widget.tmpl.html','<div layout="row" ng-show="$ctrl.factoryData.userPermittedToMakeGDPREdits.permitted">\n  <p class="md-subhead">You are currently permitted to make GDPR level edits to your account.</p>\n</div>\n<md-list>\n  <md-subheader class="md-no-sticky">\n    <span>GDPR Settings</span>\n    <div ng-show="!$ctrl.factoryData.userPermittedToMakeGDPREdits.permitted" class="margin-top-10">\n      <md-icon md-font-icon="zmdi zmdi-alert-triangle" class="zuantPollen"></md-icon>\n      <span>- You aren\'t currently permitted to make edits here</span>\n    </div>\n  </md-subheader>\n  <md-list-item>\n    <md-checkbox ng-model="$ctrl.factoryData.currentClient.GDPR.enabled"\n      ng-change="$ctrl.updateChangeDeltaNested(\'GDPR\',\'enabled\', $ctrl.factoryData.currentClient.GDPR.enabled)"\n      ng-disabled="!$ctrl.factoryData.userPermittedToMakeGDPREdits.permitted">\n    </md-checkbox>\n    <p>GDPR Enabled </p>\n    <md-icon class="md-secondary" ng-click="gdprEnabledHelper = !gdprEnabledHelper" aria-label="More info"\n      md-font-icon="zmdi zmdi-info-outline"></md-icon>\n  </md-list-item>\n\n  <md-list-item ng-show="gdprEnabledHelper">\n    <p>\n      Checking this box enables functionality for GDPR level compliance across your account. This includes your Consent\n      Tokens and Privacy Policy.\n    </p>\n  </md-list-item>\n\n  <md-list-item>\n    <md-checkbox ng-model="$ctrl.factoryData.currentClient.GDPR.waiveForNominatedForms"\n      ng-change="$ctrl.updateChangeDeltaNested(\'GDPR\',\'waiveForNominatedForms\', $ctrl.factoryData.currentClient.GDPR.waiveForNominatedForms)"\n      ng-disabled="!$ctrl.factoryData.userPermittedToMakeGDPREdits.permitted">\n    </md-checkbox>\n    <p>Waive GDPR for nominated forms</p>\n    <md-icon class="md-secondary" ng-click="waveFormsHelper = !waveFormsHelper"\n      md-font-icon="zmdi zmdi-info-outline"></md-icon>\n  </md-list-item>\n  <md-list-item ng-show="waveFormsHelper">\n    <p>Checking this box allows you to remove GDPR functionality for nominated forms. You can do this within the Form\n      Settings.</p>\n  </md-list-item>\n</md-list>');
$templateCache.put('app/clients/boltons/zp-bolt-ons-list/list.tmpl.html','<md-card flex="60" flex-offset="20">\n\n  <md-list class="">\n\n    <md-list-item class="md-2-line" ng-class="{\'selected\' : boltOn.selected}" ng-repeat-start="boltOn in $ctrl.model"\n      permission permission-only="boltOn.permission">\n\n      <md-icon ng-if="boltOn.icon" md-font-icon="{{boltOn.icon}}"></md-icon>\n      <md-icon ng-if="boltOn.svgicon" md-svg-src="{{boltOn.svgicon}}"></md-icon>\n\n      <div class="md-list-item-text" layout="column">\n        <h3>{{boltOn.label}}</h3>\n        <p class="md-subhead">{{boltOn.subhead}}</p>\n        <p class="md-caption" ng-if="boltOn.enabled">Enabled </p>\n        <p class="md-caption" ng-if="!boltOn.enabled">Disabled </p>\n      </div>\n\n      <md-switch class="md-secondary" ng-model="boltOn.enabled" ng-change="$ctrl.selected({boltOn: boltOn})">\n      </md-switch>\n\n    </md-list-item>\n\n    <md-divider ng-repeat-end ng-if="!$last"></md-divider>\n\n  </md-list>\n\n</md-card>');
$templateCache.put('app/clients/consent/forms/consent-form.tmpl.html','<div layout="row">\n\n  <div flex layout-margin>\n    <form name="$ctrl.formObj" class="consentTokenForm">\n      <md-input-container class="md-block">\n        <labelNAME</label>\n        <input name="token" ng-model="$ctrl.tokenObj.token" placeholder="Please give the token a unique name" required\n          ng-disabled="$ctrl.readOnly">\n        <div class="hint">\n          How the Consent Token appears to you in the Cloud. This isn\u2019t visible to your visitor, so this can be anything\n          to help you remember what the Token is for.\n        </div>\n        <div ng-messages="$ctrl.formObj.token.$error" role="alert">\n          <div ng-message="required" class="my-message">You must supply a token name.</div>\n        </div>\n      </md-input-container>\n      <md-input-container class="md-block">\n        <labelHEADING_LABEL</label>\n        <input name="heading" placeholder="The heading users will see in the app" ng-model="$ctrl.tokenObj.heading"\n          required ng-disabled="$ctrl.readOnly" />\n        <div class="hint">\n          The heading of the Consent Token as it appears to the visitor in the app. Make sure that this is clear and\n          concise, so that the visitor knows exactly what they are opting in to.\n        </div>\n        <div ng-messages="$ctrl.formObj.heading.$error" role="alert">\n          <div ng-message="required" class="my-message">Heading is required.</div>\n        </div>\n      </md-input-container>\n      <md-input-container class="md-block">\n        <labelTEXT_LABEL</label>\n        <textarea placeholder="Place your consent text block here" name="text" ng-model="$ctrl.tokenObj.text" rows="5"\n          md-select-on-focus required ng-disabled="$ctrl.readOnly"></textarea>\n        <div class="hint">\n          A descriptor of the Consent Token that will appear below the heading in the app. This should provide the\n          visitor with more information about what they will be opting in to if they choose to agree to the Consent\n          Token.\n        </div>\n        <div ng-messages="$ctrl.formObj.text.$error" role="alert">\n          <div ng-message="required" class="my-message">Consent text is required.</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class="md-block" g-if="$ctrl.readOnly">\n        <md-chips ng-model="$ctrl.zuantFunctions" name="functions" readonly="true" md-removable="false" required>\n          <md-chip-template active="{{$chip.activeClass}}" custom-chip ng-click="$ctrl.toggleChip($chip)">\n            <span>\n              <strong>{{$chip.name}}</strong>\n            </span>\n          </md-chip-template>\n        </md-chips>\n        <div class="md-chips-messages" ng-show="$ctrl.formObj.functions.$dirty"\n          ng-messages="$ctrl.formObj.functions.$error">\n          <div ng-message="required">At least one function is required</div>\n        </div>\n      </md-input-container>\n\n      <md-list flex ng-if="!$ctrl.readOnly">\n        <md-list-item>\n          <div>\n            <span>Token is: </span>\n            <span>&nbsp;</span>\n            <span ng-switch="$ctrl.tokenObj.active">\n              <span ng-switch-when="true"&nbsp;ACTIVE</span>\n              <span ng-switch-when="false"&nbsp;INACTIVE</span>\n            </span>\n            <div class="hint">\n              Toggle this on/off to make this Consent Token live in your account. It will appear in the app for a\n              visitor to\n              review upon attempting to submit the lead.\n            </div>\n          </div>\n          <span flex></span>\n          <md-switch ng-model="$ctrl.tokenObj.active"></md-switch>\n        </md-list-item>\n\n      </md-list>\n\n      <input type="hidden" name="CSRFToken" value="1231234567890" />\n    </form>\n  </div>\n</div>');
$templateCache.put('app/clients/consent/forms/read-only-form.tmpl.html','<div layout="row" layout-align="center center" layout-margin ng-if="!$ctrl.factoryData.accountConsentModel.length">\n      <p class="md-headline">No consent tokens have been configured for this account yet.</p>\n</div>\n\n<div layout="row" layout-align="center center">\n      <md-list layout="column" flex="70" flex-xs="100" flex-gt-xs="100" flex-gt-sm="80" flex-gt-md="70" flex-gt-lg="50"\n            ng-if="$ctrl.factoryData.accountConsentModel.length">\n            <md-subheader>Active tokens</md-subheader>\n            <md-list-item ng-repeat="token in $ctrl.factoryData.accountConsentModel" ng-if="token.active">\n                  <md-card layout-padding layout-margin flex>\n                        <md-card-title>\n                              <md-card-title-text>\n                                    <span class="md-headline">{{ token.token }}</span>\n                              </md-card-title-text>\n                        </md-card-title>\n                        <md-card-content>\n                              <md-input-container class="md-block">\n                                    <label>Heading</label>\n                                    <input class="token-heading" ng-model="token.heading" disabled>\n                              </md-input-container>\n\n                              <md-input-container class="md-block" flex-gt-sm>\n                                    <label>Text</label>\n                                    <textarea name="text" ng-model="token.text" rows="2" disabled></textarea>\n                              </md-input-container>\n\n                              <br> Symbols:\n                              <md-chips ng-model="token.symbols" readonly="true" md-removable="false">\n                                    <md-chip-template>{{ $chip.name }}</md-chip-template>\n                              </md-chips>\n                        </md-card-content>\n                  </md-card>\n            </md-list-item>\n            <md-subheader>Inactive tokens</md-subheader>\n            <md-list-item ng-repeat="token in $ctrl.factoryData.accountConsentModel" ng-if="!token.active">\n                  <md-card layout-padding layout-margin flex>\n                        <md-card-title>\n                              <md-card-title-text>\n                                    <span class="md-headline">{{ token.token }}</span>\n                              </md-card-title-text>\n                        </md-card-title>\n                        <md-card-content>\n                              <md-input-container class="md-block">\n                                    <label>Heading</label>\n                                    <input class="token-heading" ng-model="token.heading" disabled>\n                              </md-input-container>\n\n                              <md-input-container class="md-block" flex-gt-sm>\n                                    <label>Text</label>\n                                    <textarea name="text" ng-model="token.text" rows="2" disabled></textarea>\n                              </md-input-container>\n\n                              <br> Symbols:\n                              <md-chips ng-model="token.symbols" readonly="true" md-removable="false">\n                                    <md-chip-template>{{ $chip.name }}</md-chip-template>\n                              </md-chips>\n                        </md-card-content>\n                  </md-card>\n            </md-list-item>\n      </md-list>\n</div>');
$templateCache.put('app/clients/consent/main-page/page.tmpl.html','<div class="margin-top-40">\n\n  <div ng-if="!$ctrl.currentClientFactoryData.userPermittedToMakeGDPREdits.permitted" layout="column"\n    layout-align="stretch center">\n\n    <zp-consent-welcome get-started="$ctrl.loadNewTokenDialog(ev)"\n      has-consent-tokens="$ctrl.factoryData.accountConsentModel.length > 0"\n      permitted-to-make-gdrp-edits="$ctrl.currentClientFactoryData.userPermittedToMakeGDPREdits.permitted">\n    </zp-consent-welcome>\n\n    <div layout="row" layout-align="center center">\n      <div layout="row" flex="80" flex-xs="100" flex-gt-xs="100" flex-gt-sm="90" flex-gt-md="80" flex-gt-lg="60"\n        layout-margin md-theme="zuantCloudSkin" theme-background="accent:default">\n        <p class="md-title">Making edits to consent settings requires a passcode.</p>\n        <span flex></span>\n        <md-button ng-click="$ctrl.requestPasscode()" class="md-raised"><span>Request passcode</span></md-button>\n      </div>\n    </div>\n\n    <zp-read-only-consent-model>\n    </zp-read-only-consent-model>\n\n  </div>\n\n  <div ng-if="$ctrl.currentClientFactoryData.userPermittedToMakeGDPREdits.permitted">\n\n    <zp-consent-welcome get-started="$ctrl.loadNewTokenDialog(ev)"\n      has-consent-tokens="$ctrl.factoryData.accountConsentModel.length > 0"\n      permitted-to-make-gdrp-edits="$ctrl.currentClientFactoryData.userPermittedToMakeGDPREdits.permitted">\n    </zp-consent-welcome>\n\n    <zp-consent-tokens-list ng-if="$ctrl.factoryData.accountConsentModel.length"></zp-consent-tokens-list>\n  </div>\n</div>');
$templateCache.put('app/clients/consent/tokens-list/zp-consent-tokens-list.tmpl.html','<div layout="row" layout-align="center center">\n  <md-card flex="80" flex-xs="100" flex-gt-xs="100" flex-gt-sm="90" flex-gt-md="80" flex-gt-lg="60">\n    <md-toolbar class="md-table-toolbar md-default">\n      <div class="md-toolbar-tools">\n        <p class="md-header">Consent Tokens</p>\n        <div flex></div>\n        <zp-reorder-button on-click="$ctrl.toggleReorder()" is-active="$ctrl.factoryData.reorderItems">\n        </zp-reorder-button>\n        <md-button class="md-icon-button" ng-click="$ctrl.resetAccountConsentModel($event)" ng-if="$ctrl.isDev">\n          <md-icon md-font-icon="zmdi zmdi-delete"></md-icon>\n        </md-button>\n      </div>\n    </md-toolbar>\n\n    <!-- the list of tokens is visible by default -->\n\n    <md-list ng-if="!$ctrl.factoryData.reorderItems">\n      <md-divider></md-divider>\n      <md-subheader class="md-no-sticky"><span>Active account consent tokens</span></md-subheader>\n      <md-list-item ng-repeat="widget in $ctrl.factoryData.accountConsentModel track by widget._id"\n        ng-if="widget.active" class="md-3-line token-list"\n        ng-class="{\'md-active\' : $ctrl.factoryData.tokenInEdit.token == widget.token}">\n\n        <div class="md-list-item-text">\n          <h3>Token: {{ widget.token }}</h3>\n          <p>Heading: {{ widget.heading }}</p>\n          Symbols: <span ng-repeat="symbol in widget.symbols">{{symbol.name}} {{$last ? \'\' : \'| \'}}</span>\n        </div>\n\n        <div class="md-secondary" layout="row" layout-align="center center">\n          <span style="margin-right: 10px;">STATUS: Active</span>\n          <md-switch ng-model="widget.active" ng-change="$ctrl.tokenAtiveStatusChange(widget)"></md-switch>\n\n          <md-button ng-click="$ctrl.viewToken(widget)" class="md-icon-button md-primary margin-top-0 margin-bottom-0">\n            <md-icon md-font-icon="zmdi zmdi-eye"></md-icon>\n            <md-tooltip>\n              View token details\n            </md-tooltip>\n          </md-button>\n        </div>\n      </md-list-item>\n      <md-subheader class="md-no-sticky"><span>Inactive account consent tokens</span></md-subheader>\n      <md-list-item ng-repeat="widget in $ctrl.factoryData.accountConsentModel track by widget._id"\n        ng-if="!widget.active" class="md-3-line token-list"\n        ng-class="{\'md-active\' : $ctrl.factoryData.tokenInEdit.token == widget.token}">\n        <div class="md-list-item-text">\n          <h3>Token: {{ widget.token }}</h3>\n          <p>Heading: {{ widget.heading }}</p>\n          Symbols: <span ng-repeat="symbol in widget.symbols">{{symbol.name}} {{$last ? \'\' : \'| \'}}</span>\n        </div>\n\n        <div class="md-secondary" layout="row" layout-align="center center">\n          <span style="margin-right: 10px;">STATUS: Inactive</span>\n          <md-switch ng-model="widget.active" ng-change="$ctrl.tokenAtiveStatusChange(widget)"></md-switch>\n\n          <md-button ng-click="$ctrl.viewToken(widget)" class="md-icon-button md-primary">\n            <md-icon md-font-icon="zmdi zmdi-eye"></md-icon>\n            <md-tooltip>\n              View token details\n            </md-tooltip>\n          </md-button>\n        </div>\n\n      </md-list-item>\n    </md-list>\n\n    <zp-consent-tokens-reorder-list ng-if="$ctrl.factoryData.reorderItems" items="$ctrl.factoryData.activeTokens">\n    </zp-consent-tokens-reorder-list>\n\n  </md-card>\n</div>');
$templateCache.put('app/clients/consent/welcome/zp-consent-welcome.tmpl.html','<div layout="column">\n  <div ng-if="!$ctrl.hasConsentTokens" layout="row" layout-align="center center">\n    <img ng-src="{{\'/images/pngs/screenshots/consent-screenshot.png\' | cdnAssets}}" flex="50" flex-xs="80"\n      flex-gt-xs="70" flex-gt-sm="60" flex-gt-md="50" flex-gt-lg="40" />\n  </div>\n  <div layout="row" layout-align="center center">\n    <md-card flex="80" flex-xs="100" flex-gt-xs="100" flex-gt-sm="90" flex-gt-md="80" flex-gt-lg="60" layout-padding>\n\n      <md-card-content ng-if="!$ctrl.hasConsentTokens">\n        <p class="md-headline text-align-center margin-bottom-0">Consent Management in Zuant</p>\n        <div layout="row" layout-align="space-around center">\n          <p class="md-body-1" flex="70">\n            Welcome to the Consent Management tool. Here is where you configure Consent Tokens for your Zuant account.\n            Consent\n            Tokens are series of opt-in questions defined by you that are presented to each visitor at the point of\n            capture.\n            You can create as many as you like, in whichever format you like. It is recommended that you make the tokens\n            specific, so that it is clear to your visitor what they are opting into.<br>\n            <br>Under GDPR law, consent is required in order to store an EU Citizen\'s personal data. Therefore, as a\n            minimum,\n            you are required to have an active Token for storing Personally Identifiable Information (PII).<br>\n            Click the get started button to begin creating your first consent token.\n          </p>\n          <div layout="column" layout-align="end end">\n            <md-button class="md-raised md-primary" ng-click="$ctrl.callback($event)">Get Started</md-button>\n          </div>\n        </div>\n      </md-card-content>\n\n      <md-card-content ng-if="$ctrl.hasConsentTokens || !$ctrl.permittedToMakeGdrpEdits">\n        <div layout="row" layout-align="space-around center">\n          <img ng-src="{{\'/images/pngs/screenshots/consent-screenshot.png\' | cdnAssets}}" flex="35" />\n\n          <div class="margin-left-10" flex="65">\n            <p class="md-headline margin-bottom-0">Consent Management in Zuant</p>\n            <p class="md-body-1">\n              Welcome to the Consent Management tool. Here is where you configure Consent Tokens for your Zuant account.\n              Consent\n              Tokens are series of opt-in questions defined by you that are presented to each visitor at the point of\n              capture.\n              You can create as many as you like, in whichever format you like. It is recommended that you make the\n              tokens\n              specific, so that it is clear to your visitor what they are opting into.<br>\n              <br>Under GDPR law, consent is required in order to store an EU Citizen\'s personal data. Therefore, as a\n              minimum,\n              you are required to have an active Token for storing Personally Identifiable Information (PII).\n            </p>\n          </div>\n\n        </div>\n      </md-card-content>\n    </md-card>\n  </div>\n\n</div>');
$templateCache.put('app/clients/consent/fabs/fabs.tmpl.html','<zp-helper-arrow\n  help-message="Create consent tokens here"\n  show-condition="$ctrl.blankSlate()">\n</zp-helper-arrow>\n\n<md-button\n  class="md-fab md-fab-bottom-right md-accent"\n  ng-show="$ctrl.currentClientFactoryData.userPermittedToMakeGDPREdits.permitted && $ctrl.consentDataFactoryData.accountConsentModel.length"\n  ng-click="$ctrl.issueNewConsentToken($event)">\n  <md-icon md-font-icon="zmdi zmdi-plus"></md-icon>\n  <md-tooltip md-direction="bottom">\n    Add\n  </md-tooltip>\n</md-button>\n');
$templateCache.put('app/clients/create-account/zp-create-account-form-internal/create-account-form-internal.tmpl.html','<md-list>\n  <form name="$ctrl.clientFormObj">\n    <md-list-item>\n      <md-input-container flex style="margin-top: 40px;">\n        <label>Company name</label>\n        <input type="text" ng-model="$ctrl.clientDoc.companyname" name="companyName" aria-label="Company name" ng-keyup="$ctrl.onCompanyNameKeyUp()" md-autofocus required>\n        <div class="hint" ng-if="$ctrl.showHints">This is public</div>\n        <div ng-messages="$ctrl.clientFormObj.companyName.$error">\n          <div ng-message="required">Cannot be blank</div>\n          <div ng-if="$ctrl.validObj.exists">That name already exists</div>\n        </div>\n      </md-input-container>\n    </md-list-item>\n\n    <md-list-item>\n      <md-input-container flex>\n        <label>Database name</label>\n        <input type="text" ng-model="$ctrl.clientDoc.databasename" name="databaseName" aria-label="Database name" disabled="$ctrl.disableDatabaseName" required>\n        <div ng-messages="$ctrl.clientFormObj.databaseName.$error">\n          <div ng-if="$ctrl.clientFormObj.databaseName.$error.databaseExists">That databasename already exists</div>\n        </div>\n      </md-input-container>\n    </md-list-item>\n\n    <md-list-item>\n      <!-- <md-input-container flex>\n        <label>WebSummit Partner ID</label>\n        <input md-minlength="36" md-maxlength="36" type="text" name="websummitPartnerId" ng-model="$ctrl.clientDoc.partnerId" required />\n      </md-input-container> -->\n      <zp-websummit-partner-id-select\n      flex\n      on-item-change="$ctrl.updatePartnerId({item: item})">\n    </zp-websummit-partner-id-select>\n    </md-list-item>\n\n    <md-list-item>\n      <zp-select-control\n       model="$ctrl.clientDoc.timezone"\n       on-change="$ctrl.updateTimezone({item: item})"\n       config="$ctrl.timezonesConfig"\n       flex>\n      </zp-select-control>\n    </md-list-item>\n\n    <md-list-item>\n      <md-checkbox ng-model="$ctrl.clientDoc.ispreventimagedownload" ng-true-value="1" ng-false-value="0"></md-checkbox>\n      <p>Prevent image download</p>\n      <md-icon class="md-secondary" ng-click="ispreventimagedownloadHelper = !ispreventimagedownloadHelper" md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item ng-show="ispreventimagedownloadHelper">\n      <p>Enable this setting to prevent images from downloading to all user devices. It will only download to users tagged as bureau workers. DB votes to remove this as a setting and default to only bureau workers downloading all images (this setting seems redundant?)</p>\n    </md-list-item>\n\n    <!-- <md-list-item>\n      <md-checkbox ng-model="$ctrl.clientDoc.isBetaTestingAccount" ng-true-value="1" ng-false-value="0"></md-checkbox>\n      <p>Beta tester</p>\n      <md-icon ng-class="{\'md-raised\': isBetaTestingAccountHelper }" class="md-secondary" ng-click="isBetaTestingAccountHelper = !isBetaTestingAccountHelper" aria-label="More info" md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item ng-show="isBetaTestingAccountHelper">\n      <p>When enabled the account is eligible to future beta releases of features. (aka they\'re nice!)</p>\n    </md-list-item> -->\n  <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n</md-list>\n');
$templateCache.put('app/clients/detail/fab-save/fab.tmpl.html','<zp-save-button isfab="\'true\'" label="\'save template fab\'" isdirty="$ctrl.changeDelta.isDirty()" save="$ctrl.save()" disabled="$ctrl.saveDisabled" ng-show="$ctrl.changeDelta.isDirty()"></zp-save-button>\n');
$templateCache.put('app/clients/create-account/zp-create-account-form-generic/create-account-form-generic.tmpl.html','<md-list>\n  <form name="$ctrl.clientFormObj">\n    <md-list-item>\n      <md-input-container flex style="margin-top: 40px;">\n        <label>Company name</label>\n        <input type="text" ng-model="$ctrl.clientDoc.companyname" name="companyName" aria-label="Company name" ng-keyup="$ctrl.onCompanyNameKeyUp()" md-autofocus required>\n        <div class="hint" ng-if="$ctrl.showHints">This is public</div>\n        <div ng-messages="$ctrl.clientFormObj.companyName.$error">\n          <div ng-message="required">Cannot be blank</div>\n          <div ng-if="$ctrl.validObj.exists">That name already exists</div>\n        </div>\n      </md-input-container>\n    </md-list-item>\n\n    <md-list-item>\n      <md-input-container flex>\n        <label>Database name</label>\n        <input type="text" ng-model="$ctrl.clientDoc.databasename" name="databaseName" aria-label="Database name" disabled="$ctrl.disableDatabaseName" required>\n        <div ng-messages="$ctrl.clientFormObj.databaseName.$error">\n          <div ng-if="$ctrl.clientFormObj.databaseName.$error.databaseExists">That databasename already exists</div>\n        </div>\n      </md-input-container>\n    </md-list-item>\n\n    <md-list-item>\n      <zp-select-control\n       model="$ctrl.clientDoc.timezone"\n       on-change="$ctrl.updateTimezone({item: item})"\n       config="$ctrl.timezonesConfig"\n       flex>\n      </zp-select-control>\n    </md-list-item>\n\n    <md-list-item>\n      <md-checkbox ng-model="$ctrl.clientDoc.ispreventimagedownload" ng-true-value="1" ng-false-value="0"></md-checkbox>\n      <p>Prevent image download</p>\n      <md-icon class="md-secondary" ng-click="ispreventimagedownloadHelper = !ispreventimagedownloadHelper" md-font-icon="zmdi zmdi-info-outline"></md-icon>\n    </md-list-item>\n\n    <md-list-item ng-show="ispreventimagedownloadHelper">\n      <p>Enable this setting to prevent images from downloading to all user devices. It will only download to users tagged as bureau workers. DB votes to remove this as a setting and default to only bureau workers downloading all images (this setting seems redundant?)</p>\n    </md-list-item>\n\n  <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n</md-list>\n');
$templateCache.put('app/clients/dialogs/add-client-dialog/add-client-dialog.tmpl.html','<md-dialog aria-label="Add new client dialog" flex="80" flex-gt-lg="40">\n\n  <md-toolbar aria-label="Create client dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">Create a new Zuant Account</p>\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content>\n    <div layout="column" class="layout-padding">\n      <p class="md-body-1 animated" ng-class="{\'fadeOutUp\': vm.uxhelpers.fadeOutTemplateSelectText}"\n        ng-if="!vm.uxhelpers.removePTag" layout-align="center" layout="row">\n        Select an account template to use\n      </p>\n\n      <md-input-container class="account-template-field-container" layout="row" layout-align="center center">\n        <label>Account Template</label>\n        <md-select class="animated" ng-class="{\'shake\' : vm.uxhelpers.shakeTemplateWidget}"\n          ng-change="vm.accountTemplateSelected()" ng-model="vm.accountMeta.template" layout="row"\n          layout-align="space-between center">\n          <md-select-header>\n            <div layout="row" class="search">\n              <md-input-container md-no-float>\n                <md-icon md-font-icon="zmdi zmdi-search" class="name"></md-icon>\n                <input type="text" title="Search" placeholder="Search..."\n                  ng-model-options="{debounce: {\'default\': 1000, \'blur\': 0}}" ng-model="templateSearchTerm"\n                  ng-keydown="vm.updateTemplateSearch($event)">\n              </md-input-container>\n            </div>\n          </md-select-header>\n\n          <md-optgroup>\n\n            <md-option ng-repeat="template in vm.accountTemplates | filter:templateSearchTerm"\n              ng-value="template.value">\n              <div layout="row" layout-align="start center">\n                <img ng-src="{{ template.img }}"\n                  style="width: 48px; height: 48px; object-fit: contain; margin-right: 2px;" />\n                <span>{{ template.name }}</span>\n              </div>\n            </md-option>\n          </md-optgroup>\n        </md-select>\n      </md-input-container>\n\n    </div>\n\n    <div layout-padding>\n      <md-toolbar ng-click="vm.showPanel(\'account\')">\n        <div class="md-toolbar-tools">\n          <p class="md-title">Account Info</p>\n          <span flex></span>\n          <ng-md-icon icon="{{vm.iconCheck(\'account\')}}" style="fill: #fff;"></ng-md-icon>\n        </div>\n      </md-toolbar>\n      <div ng-show="vm.uxhelpers.panels.account.show">\n        <!-- zp-client-form component is used for standard zuant accounts -->\n        <zp-client-form client-form-obj="vm.clientFormObj" create-account-dialog="true"\n          client-doc="vm.accountTemplateSettings.clientDoc" account-meta="vm.accountMeta" submit-label="Create client"\n          ng-if="vm.accountMeta.template === \'standard_template\'">\n        </zp-client-form>\n        <!-- /** POTATO */ -->\n        <!-- zp-create-client-form is used for Websummit only at the moment but could eventually be used for all account types -->\n        <zp-create-account-form-internal client-form-obj="vm.clientFormObj"\n          client-doc="vm.accountTemplateSettings.clientDoc" account-meta="vm.accountMeta"\n          ng-if="vm.accountMeta.template === \'websummit_2024\'">\n        </zp-create-account-form-internal>\n        <zp-create-account-form-generic client-form-obj="vm.clientFormObj"\n          client-doc="vm.accountTemplateSettings.clientDoc" account-meta="vm.accountMeta"\n          ng-if="vm.accountMeta.template === \'ieee_2022\' || vm.accountMeta.template === \'ieee_2026_esw\' || vm.accountMeta.template === \'ieee_2023_selections_congress\' || vm.accountMeta.template === \'collision_2023\' || vm.accountMeta.template === \'thenextweb_2022\' || vm.accountMeta.template === \'sibs_2022\' || vm.accountMeta.template === \'esgct_2024\' || vm.accountMeta.template === \'nls_2026_days\' || vm.accountMeta.template === \'iemdc_2025\'">\n        </zp-create-account-form-generic>\n      </div>\n\n      <md-toolbar ng-click="vm.showPanel(\'boltons\')">\n        <div class="md-toolbar-tools">\n          <p class="md-title">Account Bolt-Ons</p>\n          <span flex></span>\n          <ng-md-icon icon="{{vm.iconCheck(\'boltons\')}}" style="fill: #fff;"></ng-md-icon>\n        </div>\n      </md-toolbar>\n      <div ng-show="vm.uxhelpers.panels.boltons.show" layout-padding>\n        <p class="md-subhead text-align-center">Select which bolt-ons this account has active</p>\n        <zp-bolt-ons-control permissions="vm.accountTemplateSettings.clientDoc.permissions" new-client-doc="true"\n          layout="column" layout-gt-sm="row" layout-align="start" layout-align-gt-sm="center center">\n        </zp-bolt-ons-control>\n      </div>\n\n      <md-toolbar ng-click="vm.showPanel(\'forms\')">\n        <div class="md-toolbar-tools">\n          <p class="md-title">Form Creation</p>\n          <span flex></span>\n          <ng-md-icon icon="{{vm.iconCheck(\'forms\')}}" style="fill: #fff;"></ng-md-icon>\n        </div>\n      </md-toolbar>\n      <div ng-show="vm.uxhelpers.panels.forms.show" layout-padding>\n        <md-list>\n          <md-list-item flex>\n            <div layout="column" layout-fill>\n              <p class="md-body-1"\n                ng-if="vm.formTemplate !== \'websummit_2024\' && vm.formTemplate !== \'ieee_2022\' && vm.formTemplate !== \'ieee_2026_esw\' && vm.formTemplate !== \'ieee_2023_selections_congress\' && vm.formTemplate !== \'collision_2023\' && vm.formTemplate !== \'thenextweb_2022\' && vm.formTemplate !== \'esgct_2024\' && vm.formTemplate !== \'iemdc_2025\' && vm.formTemplate !== \'nls_2026_days\' && vm.formTemplate !== \'sibs_2022\'">\n                Optionally select a form template to create a form in this account.</p>\n\n              <zp-form-select-control flex config="vm.formTemplatesConfig"\n                model="vm.accountTemplateSettings.formTemplate" on-change="vm.setFormTemplateToUse({item: item})">\n              </zp-form-select-control>\n\n              <div ng-show="vm.accountTemplateSettings.formTemplate.item._id === \'websummit_2024\'">\n                <p class="md-subhead">A form will be created using the template form for WebSummit 2024.\n                  The scan API settings will be set to the WebSummit API key + the PartnerId for you.</p>\n                <br>\n                <span\n                  class="zp-caption">{{vm.accountTemplateSettings.scanToken2}}{{vm.accountTemplateSettings.clientDoc.partnerId}}</span>\n                <span ng-show="vm.accountTemplateSettings.clientDoc.partnerId === \'\'" class="md-caption"\n                  style="color: red;">Please enter the partner id in the account info form</span>\n              </div>\n\n              <div ng-show="vm.accountTemplateSettings.formTemplate.item._id === \'ieee_2022\'">\n                <p class="md-subhead">A form will be created using the template form for IEEE 2022.</p>\n              </div>\n\n              <div ng-show="vm.accountTemplateSettings.formTemplate.item._id === \'ieee_2026_esw\'">\n                <p class="md-subhead">A form will be created using the template form for IEEE ESW 2026.</p>\n              </div>\n\n              <div ng-show="vm.accountTemplateSettings.formTemplate.item._id === \'ieee_2023_selections_congress\'">\n                <p class="md-subhead">A form will be created using the template form for IEEE Selections Congress 2023.\n                </p>\n              </div>\n\n              <div ng-show="vm.accountTemplateSettings.formTemplate.item._id === \'collision_2023\'">\n                <p class="md-subhead">A form will be created using the template form for Collision 2023.</p>\n              </div>\n\n              <div ng-show="vm.accountTemplateSettings.formTemplate.item._id === \'thenextweb_2022\'">\n                <p class="md-subhead">A form will be created using the template form for The Next Web 2022.</p>\n              </div>\n\n              <div ng-show="vm.accountTemplateSettings.formTemplate.item._id === \'sibs_2022\'">\n                <p class="md-subhead">A form will be created using the template form for SIBS 2022.</p>\n              </div>\n\n              <div ng-show="vm.accountTemplateSettings.formTemplate.item._id === \'esgct_2024\'">\n                <p class="md-subhead">A form will be created using the template form for ESGCT 2024.</p>\n              </div>\n\n              <div ng-show="vm.accountTemplateSettings.formTemplate.item._id === \'iemdc_2025\'">\n                <p class="md-subhead">A form will be created using the template form for IEMDC 2025.</p>\n              </div>\n\n              <div ng-show="vm.accountTemplateSettings.formTemplate.item._id === \'nls_2026_days\'">\n                <p class="md-subhead">A form will be created using the template form for NLS Days 2026.</p>\n              </div>\n            </div>\n          </md-list-item>\n        </md-list>\n      </div>\n\n      <md-toolbar ng-click="vm.showPanel(\'users\')">\n        <div class="md-toolbar-tools">\n          <p class="md-title">Users</p>\n          <span flex></span>\n          <ng-md-icon icon="{{vm.iconCheck(\'users\')}}" style="fill: #fff;"></ng-md-icon>\n        </div>\n      </md-toolbar>\n      <div ng-show="vm.uxhelpers.panels.users.show" layout-padding>\n        <p class="md-body-2">You can add account users here, they will be saved when you submit this dialog.\n          <span flex></span>\n          <md-button class="md-icon-button md-accent" ng-click="vm.addUser()">\n            <md-icon md-font-icon="zmdi zmdi-account-add"></md-icon>\n            <md-tooltip md-direction="top">Add another user</md-tooltip>\n          </md-button>\n        </p>\n        <div layout="row" ng-repeat-start="user in vm.users track by $index" flex>\n          <md-subheader flex class="md-primary">User {{$index +1}}</md-subheader>\n          <span flex></span>\n          <md-button class="md-icon-button" ng-click="vm.removeUser($index)">\n            <md-icon md-font-icon="zmdi zmdi-close-circle"></md-icon>\n            <md-tooltip md-direction="top">Remove User {{$index +1}}</md-tooltip>\n          </md-button>\n        </div>\n        <zp-user-form client-doc="vm.accountTemplateSettings.clientDoc" user-doc="user" password-fields="true"\n          user-form-obj="vm.userFormObj"></zp-user-form>\n        <md-divider ng-if="!$last" ng-repeat-end></md-divider>\n      </div>\n    </div>\n\n    <md-dialog-actions layout="row">\n      <div layout="row" layout-align="end center">\n\n        <md-button class="md-warn" ng-click="vm.cancelDialog()">\n          <md-tooltip md-direction="top">Cancel dialog</md-tooltip>\n          Cancel\n        </md-button>\n\n        <md-button class="md-primary" ng-click="vm.saveNewAccount(\'close\')"\n          ng-disabled="vm.clientFormObj.$invalid || vm.userFormObj.$invalid  || vm.saveInProgress"\n          aria-label="save client form">\n          <md-icon md-font-icon="zmdi zmdi-floppy">&nbsp;\n            <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n            <md-tooltip md-direction="top">Save & Close</md-tooltip>\n        </md-button>\n\n        <md-button class="md-primary" ng-click="vm.saveNewAccount(\'add\')"\n          ng-disabled="vm.clientFormObj.$invalid || vm.userFormObj.$invalid  || vm.saveInProgress"\n          aria-label="save client form">\n          <md-icon md-font-icon="zmdi zmdi-floppy"></md-icon>&nbsp;\n          <md-icon md-font-icon="zmdi zmdi-plus"></md-icon>\n          <md-tooltip md-direction="top">Save & Add Another</md-tooltip>\n        </md-button>\n\n        <md-button class="md-primary md-raised" ng-click="vm.saveNewAccount(\'manage\')"\n          ng-disabled="vm.clientFormObj.$invalid || vm.userFormObj.$invalid || vm.saveInProgress"\n          aria-label="save client form">\n          <md-icon md-font-icon="zmdi zmdi-floppy">&nbsp;\n            <md-icon md-font-icon="zmdi zmdi-settings"></md-icon>\n            <md-tooltip md-direction="top">Save & go to settings</md-tooltip>\n        </md-button>\n\n      </div>\n    </md-dialog-actions>\n  </md-dialog-content>\n</md-dialog>');
$templateCache.put('app/clients/dialogs/admin-charts/dialog.tmpl.html','<md-dialog aria-label="Add new client dialog" flex="100">\n\n  <md-toolbar aria-label="Create client dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">Account Charts</p>\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content>\n\n    <zp-active-users-chart ng-show="showChart"></zp-active-users-chart>\n\n    <md-progress-linear ng-if="vm.loading" class="md-accent"></md-progress-linear>\n\n    \n    <md-card flex>\n      <md-list>\n        <md-list-item ng-repeat="acc in vm.content" ng-click="acc.showPanel = !acc.showPanel">\n          <div layout="column" flex>\n            <span>\n              DB: <strong>{{ acc.db }} </strong><br>\n              Active users count ({{acc.loginsGroupedByDate[0].dt}}):\n              {{ acc.loginsGroupedByDate[0].uniqueUsersSize }}\n            </span>\n\n            <div ng-show="acc.showPanel" flex>\n              <div flex class="animated">\n                <label>Active users for {{acc.loginsGroupedByDate[0].dt}}</label>\n                <md-chips ng-model="acc.loginsGroupedByDate[acc.loginsGroupedByDate.length - 1].uniqueUsers"\n                  md-removable="false">\n                </md-chips>\n                <md-button class="md-icon-button" ng-click="acc.showJson = !acc.showJson" ng-class="{\'md-raised\' : acc.showJson }">\n                  <md-icon md-font-icon="zmdi zmdi-code-setting"></md-icon>\n                </md-button>\n                <div ng-repeat="logs in acc.loginsGroupedByDate" ng-show="acc.showJson">\n                  <pre style="line-height: 15px;">{{ logs | json}}</pre>\n                </div>\n              </div>\n            </div>\n          </div>\n          <md-divider></md-divider>\n        </md-list-item>\n      </md-list>\n    </md-card>\n\n    <md-button class="md-icon-button" ng-click="showJson = !showJson" ng-class="{\'md-raised\' : showJson }">\n      <md-icon md-font-icon="zmdi zmdi-code-setting"></md-icon>\n    </md-button>\n    <div ng-show="showJson">\n      <div flex>\n        <pre ng-if="!vm.loading">{{vm.content | json}}</pre>\n      </div>\n    </div>\n  </md-dialog-content>\n  <md-dialog-actions layout="row">\n    <md-button class="md-icon-button" ng-click="showChart = !showChart" ng-class="{\'md-raised md-accent\': showChart}">\n      <md-icon md-font-icon="zmdi zmdi-chart"></md-icon>\n    </md-button>\n\n    <span flex></span>\n\n    <md-button ng-click="vm.deleteAccountActivityLogs()" ng-disabled="vm.loading" class="md-raised md-accent md-icon-button">\n      <md-tooltip>Delete Account Logs</md-tooltip>\n      <md-icon md-font-icon="zmdi zmdi-delete"></md-icon>\n    </md-button>\n\n    <md-button ng-click="vm.run()" ng-disabled="vm.loading" class="md-raised md-accent md-icon-button">\n      <md-tooltip>Run</md-tooltip>\n      <md-icon md-font-icon="zmdi zmdi-refresh"></md-icon>\n    </md-button>\n\n    <md-button ng-click="vm.export()" ng-disabled="vm.loading" class="md-raised md-primary md-icon-button"\n      style="margin-left: 20px;">\n      <md-tooltip>Export .csv</md-tooltip>\n      <md-icon md-font-icon="zmdi zmdi-floppy"></md-icon>\n    </md-button>\n\n  </md-dialog-actions>\n</md-dialog>\n');
$templateCache.put('app/clients/dialogs/client-operations-dialog/archive-client-dialog.tmpl.html','<md-dialog aria-label="Archive client dialog" flex="60">\n    <md-toolbar aria-label="Archive client dialog toolbar">\n        <div layout="row" class="md-toolbar-tools">\n            <p class="md-subhead">Archive {{vm.metaData.databasename}}</p>\n            <span flex></span>\n            <md-button ng-click="vm.cancelDialog()">\n                <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n            </md-button>\n        </div>\n    </md-toolbar>\n    <md-dialog-content layout-padding>\n        <md-stepper-card-content class="md-no-padding">\n            <md-steppers md-dynamic-height md-stretch-steppers="always" md-selected="vm.metaData.selectedStep">\n                <md-step label="{{vm.metaData.stepData[0].label}}" md-complete="vm.metaData.stepData[0].completed"\n                    ng-disabled="vm.metaData.stepProgress < 1" md-editable="vm.metaData.stepData[0].editable"\n                    md-busy="vm.metaData.stepData[0].busy">\n                    <md-step-body>\n                        <form name="step1" ng-submit="vm.submitCurrentStep(vm.metaData.stepData[0])">\n                            <md-content class="md-padding" layout="row" layout-align="start start" flex>\n                                <div flex="20" layout="column" layout-align="center center" flex>\n                                    <zp-zubot height="150px" width="150px" outfit="vm.metaData.task.outfit"></zp-zubot>\n                                    <p class="zubot-task">\n                                        This task will be handled by\n                                        <b>{{vm.metaData.task.zubot}}</b><md-icon\n                                            md-font-icon="zmdi zmdi-refresh zubot-name-refresh"\n                                            ng-click="vm.refreshZubot()"\n                                            ng-show="!vm.metaData.task.zubotActivated"></md-icon>\n                                    </p>\n                                </div>\n\n                                <div class="intro-text">\n                                    <h1 class="no-margin">Archive Account</h1>\n                                    <p>\n                                        Activating this zubot will transfer the chosen client\'s data from the zuant data\n                                        store to AWS S3 storage for archiving purposes. After the archiving process is\n                                        finished, you can later "re-activate" the client and retrieve their data from\n                                        AWS\n                                        S3 using the un-archive tool, which can be accessed from the same location as\n                                        this tool.\n                                    </p>\n                                    <p>\n                                        Once a client has been archived users within the account will be set as archived\n                                        so they will no longer be able to login or sync.\n                                    </p>\n                                </div>\n                            </md-content>\n                            <md-step-actions layout="row">\n                                <div flex></div>\n                                <div flex layout="row" layout-align="end top">\n                                    <md-button ng-click="vm.cancelDialog()" class="md-warn">CANCEL</md-button>\n                                    <md-button type="submit">NEXT</md-button>\n                                </div>\n                            </md-step-actions>\n                        </form>\n                    </md-step-body>\n                </md-step>\n                <md-step label="{{vm.metaData.stepData[1].label}}" md-complete="vm.metaData.stepData[1].completed"\n                    ng-disabled="vm.metaData.stepProgress < 2" md-editable="vm.metaData.stepData[1].editable"\n                    md-busy="vm.metaData.stepData[1].busy">\n                    <md-step-body>\n                        <form name="step2" ng-submit="vm.submitCurrentStep(vm.metaData.stepData[1])">\n                            <md-content class="md-padding" layout="row" layout-align="start start" flex>\n                                <div flex="20" layout="column" layout-align="center center" flex>\n                                    <zp-zubot height="150px" width="150px" outfit="vm.metaData.task.outfit"></zp-zubot>\n                                    <p class="zubot-task">\n                                        This task will be handled by\n                                        <b>{{vm.metaData.task.zubot}}</b><md-icon\n                                            md-font-icon="zmdi zmdi-refresh zubot-name-refresh"\n                                            ng-click="vm.refreshZubot()"\n                                            ng-show="!vm.metaData.task.zubotActivated"></md-icon>\n                                    </p>\n                                </div>\n\n                                <div class="intro-text">\n                                    <h1 class="no-margin">Confirmation</h1>\n                                    <p>\n                                        Please confirm that you actually want to archive this client. Any configuration\n                                        chosen on the previous page will be irreversible upon activating the zubot. If\n                                        you have any\n                                        doubt, please close this dialog now!\n                                    </p>\n                                    <p>\n                                        Confirm by typing the database name below (<b>{{vm.metaData.databasename}}</b>).\n                                    </p>\n\n                                    <md-input-container class="md-icon-float md-block no-margin hide-validation-error">\n                                        <label>\n                                            Enter Database Name Here...\n                                        </label>\n                                        <input type="text"\n                                            ng-model="vm.metaData.stepData[1].data.confirmationFieldValue">\n                                    </md-input-container>\n\n                                </div>\n\n                            </md-content>\n\n                            <md-step-actions layout="row">\n                                <div flex layout="row" layout-align="end top">\n                                    <md-button ng-click="vm.moveToPreviousStep()">\n                                        PREVIOUS\n                                    </md-button>\n                                    <div flex></div>\n\n                                    <md-button\n                                        ng-disabled="vm.metaData.stepData[1].data.confirmationFieldValue !== vm.metaData.stepData[1].data.confirmationText"\n                                        type="submit" class="md-primary md-raised">\n                                        ACTIVATE\n                                    </md-button>\n                                </div>\n                            </md-step-actions>\n                        </form>\n                    </md-step-body>\n                </md-step>\n                <md-step label="{{vm.metaData.stepData[2].label}}" md-complete="vm.metaData.stepData[2].completed"\n                    ng-disabled="vm.metaData.stepProgress < 3" md-editable="vm.metaData.stepData[2].editable"\n                    md-busy="vm.metaData.stepData[2].busy">\n                    <md-step-body>\n                        <form name="step3">\n                            <md-content class="md-padding" layout="column" layout-align="start start" flex>\n\n                                <div layout="row" layout-align="start start" flex>\n\n                                    <div flex="20" layout="column" layout-align="center center" flex>\n                                        <zp-zubot height="150px" width="150px"\n                                            outfit="vm.metaData.task.outfit"></zp-zubot>\n                                        <p class="zubot-task">\n                                            <b>{{vm.metaData.task.zubot}}</b>\n                                        </p>\n                                    </div>\n\n                                    <div class="intro-text">\n                                        <h1 class="no-margin">Summary</h1>\n                                        <p>\n                                            <b>{{vm.metaData.task.zubot}}</b> has been tasked to archive\n                                            <b>{{vm.metaData.databasename}}</b>.\n                                        </p>\n                                        <p>\n                                            The archive process may take up to several\n                                            minutes to complete. The time the process takes is directly correlated to\n                                            the\n                                            size of the client database.\n                                        </p>\n                                        <p>\n                                            After finishing, the <b>{{vm.metaData.databasename}}</b> account will have\n                                            been\n                                            sucessfully\n                                            archived to AWS S3.\n                                        </p>\n\n                                    </div>\n                                </div>\n\n                                <div layout="row" layout-align="start center" layout-fill>\n\n                                    <div class="status-container" layout="column" layout-align="center center"\n                                        flex="20">\n                                        <p class="no-margin">\n                                            <b>Status</b>:\n                                        </p>\n\n\n                                        <span class="two-percent-top-margin">\n                                            <b>{{vm.metaData.stepData[2].data.zubotProgress.caption}}</b>\n                                        </span>\n\n\n                                    </div>\n\n                                    <div ng-if="vm.metaData.stepData[2].data.milestone!==\'complete\'"\n                                        class="spinner-container" layout="column" layout-align="center center">\n\n                                        <md-progress-circular\n                                            ng-if="vm.metaData.stepData[2].data.zubotProgress.progress == 0"\n                                            md-diameter="80px" md-mode="indeterminate"\n                                            class="md-accent"></md-progress-circular>\n\n                                        <md-progress-circular\n                                            ng-if="vm.metaData.stepData[2].data.zubotProgress.progress > 0"\n                                            md-diameter="80px" md-mode="determinate"\n                                            value="{{vm.metaData.stepData[2].data.zubotProgress.progress}}"\n                                            class="md-accent"></md-progress-circular>\n\n                                        <span><b>{{\n                                                vm.metaData.stepData[2].data.zubotProgress.progress }}%</b></span>\n\n                                    </div>\n                                </div>\n                            </md-content>\n                        </form>\n                        <md-step-actions layout="row">\n                            <div flex></div>\n                            <div flex layout="row" layout-align="end top">\n                                <md-button\n                                    ng-disabled="vm.metaData.stepData[2].data.zubotProgress.milestone!==\'complete\'"\n                                    ng-click="vm.cancelDialog()" class="md-primary md-raised">\n                                    Done\n                                </md-button>\n                            </div>\n                        </md-step-actions>\n                    </md-step-body>\n                </md-step>\n            </md-steppers>\n        </md-stepper-card-content>\n    </md-dialog-content>\n</md-dialog>');
$templateCache.put('app/clients/dialogs/client-operations-dialog/delete-client-dialog.tmpl.html','<md-dialog aria-label="Delete client dialog" flex="60">\n    <md-toolbar aria-label="Delete client dialog toolbar">\n        <div layout="row" class="md-toolbar-tools">\n            <p class="md-subhead">Delete {{vm.metaData.databasename}}</p>\n            <span flex></span>\n            <md-button ng-click="vm.cancelDialog()">\n                <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n            </md-button>\n        </div>\n    </md-toolbar>\n    <md-dialog-content layout-padding>\n        <md-stepper-card-content class="md-no-padding">\n            <md-steppers md-dynamic-height md-stretch-steppers="always" md-selected="vm.metaData.selectedStep">\n                <md-step label="{{vm.metaData.stepData[0].label}}" md-complete="vm.metaData.stepData[0].completed"\n                    ng-disabled="vm.metaData.stepProgress < 1" md-editable="vm.metaData.stepData[0].editable"\n                    md-busy="vm.metaData.stepData[0].busy">\n                    <md-step-body>\n                        <form name="step1" ng-submit="vm.submitCurrentStep(vm.metaData.stepData[0])">\n                            <md-content class="md-padding" layout="row" layout-align="start start" flex>\n                                <div flex="20" layout="column" layout-align="center center" flex>\n                                    <zp-zubot height="150px" width="150px" outfit="vm.metaData.task.outfit"></zp-zubot>\n                                    <p class="zubot-task">\n                                        This task will be handled by\n                                        <b>{{vm.metaData.task.zubot}}</b><md-icon\n                                            md-font-icon="zmdi zmdi-refresh zubot-name-refresh"\n                                            ng-click="vm.refreshZubot()"\n                                            ng-show="!vm.metaData.task.zubotActivated"></md-icon>\n                                    </p>\n                                </div>\n\n                                <div class="intro-text">\n                                    <h1 class="no-margin">Delete Account</h1>\n                                    <p>\n                                        Activating this Zubot will initiate the irreversible and non-recoverable process\n                                        of permanently deleting a client\'s account from the Zuant storage system. It\'s\n                                        essential to be fully aware that once this action is triggered, all client\n                                        information and associated data will be completely and permanently erased, with\n                                        no possibility of restoration.\n                                    </p>\n                                    <p>\n                                        Before proceeding, please ensure you have obtained the necessary authorization\n                                        and informed the client about the irreversible nature of this process.\n                                    </p>\n                                    <p>\n                                        You will need to confirm that you are sure you wish to proceed with this\n                                        operation in the next step.\n                                    </p>\n                                </div>\n                            </md-content>\n                            <md-step-actions layout="row">\n                                <div flex></div>\n                                <div flex layout="row" layout-align="end top">\n                                    <md-button ng-click="vm.cancelDialog()" class="md-warn">CANCEL</md-button>\n                                    <md-button type="submit">NEXT</md-button>\n                                </div>\n                            </md-step-actions>\n                        </form>\n                    </md-step-body>\n                </md-step>\n                <md-step label="{{vm.metaData.stepData[1].label}}" md-complete="vm.metaData.stepData[1].completed"\n                    ng-disabled="vm.metaData.stepProgress < 2" md-editable="vm.metaData.stepData[1].editable"\n                    md-busy="vm.metaData.stepData[1].busy">\n                    <md-step-body>\n                        <form name="step2" ng-submit="vm.submitCurrentStep(vm.metaData.stepData[1])">\n                            <md-content class="md-padding" layout="row" layout-align="start start" flex>\n                                <div flex="20" layout="column" layout-align="center center" flex>\n                                    <zp-zubot height="150px" width="150px" outfit="vm.metaData.task.outfit"></zp-zubot>\n                                    <p class="zubot-task">\n                                        This task will be handled by\n                                        <b>{{vm.metaData.task.zubot}}</b><md-icon\n                                            md-font-icon="zmdi zmdi-refresh zubot-name-refresh"\n                                            ng-click="vm.refreshZubot()"\n                                            ng-show="!vm.metaData.task.zubotActivated"></md-icon>\n                                    </p>\n                                </div>\n\n                                <div class="intro-text">\n                                    <h1 class="no-margin">Confirmation</h1>\n                                    <p>\n                                        Please confirm that you actually want to delete this client. If you have any\n                                        doubt, please close this dialog now! This operation is permanent and\n                                        irreversible.\n                                    </p>\n                                    <p>\n                                        Confirm by typing the database name below (<b>{{vm.metaData.databasename}}</b>).\n                                    </p>\n\n                                    <md-input-container\n                                        class="md-icon-float md-block no-margin datebase-field-name-input hide-validation-error">\n                                        <label>\n                                            Enter Database Name Here...\n                                        </label>\n                                        <input type="text"\n                                            ng-model="vm.metaData.stepData[1].data.confirmationFieldValue">\n                                    </md-input-container>\n\n                                </div>\n                            </md-content>\n\n                            <md-step-actions layout="row">\n                                <div flex layout="row" layout-align="end top">\n                                    <md-button ng-click="vm.moveToPreviousStep()">\n                                        PREVIOUS\n                                    </md-button>\n                                    <div flex></div>\n\n                                    <md-button\n                                        ng-disabled="vm.metaData.stepData[1].data.confirmationFieldValue !== vm.metaData.stepData[1].data.confirmationText"\n                                        type="submit" class="md-primary md-raised">\n                                        ACTIVATE\n                                    </md-button>\n                                </div>\n                            </md-step-actions>\n                        </form>\n                    </md-step-body>\n                </md-step>\n                <md-step label="{{vm.metaData.stepData[2].label}}" md-complete="vm.metaData.stepData[2].completed"\n                    ng-disabled="vm.metaData.stepProgress < 3" md-editable="vm.metaData.stepData[2].editable"\n                    md-busy="vm.metaData.stepData[2].busy">\n                    <md-step-body>\n                        <form name="step3">\n                            <md-content class="md-padding" layout="column" layout-align="start start" flex>\n\n                                <div layout="row" layout-align="start start" flex>\n                                    <div flex="20" layout="column" layout-align="center center" flex>\n                                        <zp-zubot height="150px" width="150px"\n                                            outfit="vm.metaData.task.outfit"></zp-zubot>\n                                        <p class="zubot-task">\n                                            <b>{{vm.metaData.task.zubot}}</b>\n                                        </p>\n                                    </div>\n\n                                    <div class="intro-text">\n                                        <h1 class="no-margin">Summary</h1>\n                                        <p>\n                                            <b>{{vm.metaData.task.zubot}}</b> has been tasked to archive\n                                            <b>{{vm.metaData.databasename}}</b>.\n                                        </p>\n                                        <p>\n                                            Please wait until the deletion process completes. This may take a few\n                                            momements.\n                                        </p>\n                                        <p>\n                                            Once complete, you will\n                                            be automatically switched to the <b>Marketpoint</b> account at which point\n                                            you\n                                            will be permitted to close the dialog.\n                                        </p>\n                                    </div>\n\n                                </div>\n\n                                <div layout="row" layout-align="start center" layout-fill>\n\n                                    <div class="status-container" layout="column" layout-align="center center"\n                                        flex="20">\n                                        <p class="no-margin">\n                                            <b>Status</b>:\n                                        </p>\n\n\n                                        <span class="two-percent-top-margin">\n                                            <b>{{vm.metaData.stepData[2].data.zubotProgress.caption}}</b>\n                                        </span>\n\n\n                                    </div>\n\n                                    <div ng-if="vm.metaData.stepData[2].data.milestone!==\'complete\'"\n                                        class="spinner-container" layout="column" layout-align="center center">\n\n                                        <md-progress-circular\n                                            ng-if="vm.metaData.stepData[2].data.zubotProgress.progress == 0"\n                                            md-diameter="80px" md-mode="indeterminate"\n                                            class="md-accent"></md-progress-circular>\n\n                                        <md-progress-circular\n                                            ng-if="vm.metaData.stepData[2].data.zubotProgress.progress > 0"\n                                            md-diameter="80px" md-mode="determinate"\n                                            value="{{vm.metaData.stepData[2].data.zubotProgress.progress}}"\n                                            class="md-accent"></md-progress-circular>\n\n                                        <span><b>{{\n                                                vm.metaData.stepData[2].data.zubotProgress.progress }}%</b></span>\n\n                                    </div>\n                                </div>\n\n                            </md-content>\n                        </form>\n                        <md-step-actions layout="row">\n                            <div flex></div>\n                            <div flex layout="row" layout-align="end top">\n                                <md-button\n                                    ng-disabled="vm.metaData.stepData[2].data.zubotProgress.milestone!==\'complete\'"\n                                    ng-click="vm.cancelDialog()" class="md-primary md-raised">\n                                    Done\n                                </md-button>\n                            </div>\n                        </md-step-actions>\n                    </md-step-body>\n                </md-step>\n            </md-steppers>\n        </md-stepper-card-content>\n    </md-dialog-content>\n</md-dialog>');
$templateCache.put('app/clients/dialogs/client-operations-dialog/redact-client-dialog.tmpl.html','<md-dialog aria-label="Redact client dialog" flex="60">\n    <md-toolbar aria-label="Archive client dialog toolbar">\n        <div layout="row" class="md-toolbar-tools">\n            <p class="md-subhead">Redact {{vm.metaData.databasename}}</p>\n            <span flex></span>\n            <md-button ng-click="vm.cancelDialog()">\n                <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n            </md-button>\n        </div>\n    </md-toolbar>\n    <md-dialog-content layout-padding>\n        <md-stepper-card-content class="md-no-padding">\n            <md-steppers md-dynamic-height md-stretch-steppers="always" md-selected="vm.metaData.selectedStep">\n                <md-step label="{{vm.metaData.stepData[0].label}}" md-complete="vm.metaData.stepData[0].completed"\n                    ng-disabled="vm.metaData.stepProgress < 1" md-editable="vm.metaData.stepData[0].editable"\n                    md-busy="vm.metaData.stepData[0].busy">\n                    <md-step-body>\n                        <form name="step1" ng-submit="vm.submitCurrentStep(vm.metaData.stepData[0])">\n                            <md-content class="md-padding" layout="row" layout-align="start start" flex>\n                                <div flex="20" layout="column" layout-align="center center" flex>\n                                    <zp-zubot height="150px" width="150px" outfit="vm.metaData.task.outfit"></zp-zubot>\n                                    <p class="zubot-task">\n                                        This task will be handled by\n                                        <b>{{vm.metaData.task.zubot}}</b><md-icon\n                                            md-font-icon="zmdi zmdi-refresh zubot-name-refresh"\n                                            ng-click="vm.refreshZubot()"\n                                            ng-show="!vm.metaData.task.zubotActivated"></md-icon>\n                                    </p>\n                                </div>\n\n                                <div class="intro-text">\n                                    <h1 class="no-margin">Redact All CRM Within Account</h1>\n                                    <p>This specialized tool enables the redaction of CRM data for archived clients. Its\n                                        primary purpose arises when an archived client requests their captured CRM data\n                                        to be redacted, yet we aim to retain their lead data for analytical purposes in\n                                        case the client returns in the future. Without the need to unarchive, redact &\n                                        re-archive.\n                                    </p>\n                                    <p>\n                                        Activating this zubot will methodically obscure CRM data within the account, in\n                                        accordance with GDPR standards. The tool will substitute personally identifiable\n                                        information (PII) in mapped contact data with either the default value\n                                        "REDACTED" or a custom-selected one. Additionally, it provides the choice to\n                                        permanently erase images or business cards associated with leads by mapping them\n                                        to "UNSET". Next, you\'ll be required to map company, contact, and response\n                                        fields identified across all forms in the account.\n                                    </p>\n                                    <p>\n                                        Once the redaction has complete the CRM data which has been cleansed will be\n                                        un-recoverable.\n                                    </p>\n                                </div>\n                            </md-content>\n                            <md-step-actions layout="row">\n                                <div flex></div>\n                                <div flex layout="row" layout-align="end top">\n                                    <md-button ng-click="vm.cancelDialog()" class="md-warn">CANCEL</md-button>\n                                    <md-button type="submit">NEXT</md-button>\n                                </div>\n                            </md-step-actions>\n                        </form>\n                    </md-step-body>\n                </md-step>\n\n                <md-step label="{{vm.metaData.stepData[1].label}}" md-complete="vm.metaData.stepData[1].completed"\n                    ng-disabled="vm.metaData.stepProgress < 2" md-editable="vm.metaData.stepData[1].editable"\n                    md-busy="vm.metaData.stepData[1].busy">\n                    <md-step-body>\n                        <form name="step2" ng-submit="vm.submitCurrentStep(vm.metaData.stepData[1])">\n                            <md-content class="md-padding" layout="row" layout-align="start stretch" flex>\n                                <div flex="20" layout="column" layout-align="center center" flex>\n                                    <zp-zubot height="150px" width="150px" outfit="vm.metaData.task.outfit"></zp-zubot>\n                                    <p class="zubot-task">\n                                        This task will be handled by\n                                        <b>{{vm.metaData.task.zubot}}</b><md-icon\n                                            md-font-icon="zmdi zmdi-refresh zubot-name-refresh"\n                                            ng-click="vm.refreshZubot()"\n                                            ng-show="!vm.metaData.task.zubotActivated"></md-icon>\n                                    </p>\n                                </div>\n\n                                <div layout="column" layout-align="start stretch" flex>\n                                    <div class="intro-text">\n                                        <h1 class="no-margin">Configuration</h1>\n                                        <p>\n                                            Select a mapping card below\n                                        </p>\n                                    </div>\n\n                                    <zp-data-Workflow></zp-data-workflow>\n                                </div>\n\n                            </md-content>\n\n                            <md-step-actions layout="row">\n                                <div flex layout="row" layout-align="end top">\n                                    <md-button ng-click="vm.moveToPreviousStep()">\n                                        PREVIOUS\n                                    </md-button>\n                                    <div flex></div>\n\n                                    <md-button type="submit" ng-disabled="!vm.workflowFactory.selectedStep.valid">\n                                        NEXT\n                                    </md-button>\n                                </div>\n                            </md-step-actions>\n                        </form>\n                    </md-step-body>\n                </md-step>\n\n                <md-step label="{{vm.metaData.stepData[2].label}}" md-complete="vm.metaData.stepData[2].completed"\n                    ng-disabled="vm.metaData.stepProgress < 3" md-editable="vm.metaData.stepData[2].editable"\n                    md-busy="vm.metaData.stepData[2].busy">\n                    <md-step-body>\n                        <form name="step2" ng-submit="vm.submitCurrentStep(vm.metaData.stepData[2])">\n                            <md-content class="md-padding" layout="row" layout-align="start start" flex>\n                                <div flex="20" layout="column" layout-align="center center" flex>\n                                    <zp-zubot height="150px" width="150px" outfit="vm.metaData.task.outfit"></zp-zubot>\n                                    <p class="zubot-task">\n                                        This task will be handled by\n                                        <b>{{vm.metaData.task.zubot}}</b><md-icon\n                                            md-font-icon="zmdi zmdi-refresh zubot-name-refresh"\n                                            ng-click="vm.refreshZubot()"\n                                            ng-show="!vm.metaData.task.zubotActivated"></md-icon>\n                                    </p>\n                                </div>\n\n                                <div class="intro-text">\n                                    <h1 class="no-margin">Confirmation</h1>\n                                    <p>\n                                        Please confirm that you actually want to archive this client. Any configuration\n                                        chosen on the previous page will be irreversible upon activating the zubot. If\n                                        you have any\n                                        doubt, please close this dialog now!\n                                    </p>\n                                    <p>\n                                        Confirm by typing the database name below (<b>{{vm.metaData.databasename}}</b>).\n                                    </p>\n\n                                    <md-input-container class="md-icon-float md-block no-margin hide-validation-error">\n                                        <label>\n                                            Enter Database Name Here...\n                                        </label>\n                                        <input type="text"\n                                            ng-model="vm.metaData.stepData[2].data.confirmationFieldValue">\n                                    </md-input-container>\n\n                                </div>\n\n                            </md-content>\n\n                            <md-step-actions layout="row">\n                                <div flex layout="row" layout-align="end top">\n                                    <md-button ng-click="vm.moveToPreviousStep()">\n                                        PREVIOUS\n                                    </md-button>\n                                    <div flex></div>\n\n                                    <md-button\n                                        ng-disabled="vm.metaData.stepData[2].data.confirmationFieldValue !== vm.metaData.stepData[2].data.confirmationText"\n                                        type="submit" class="md-primary md-raised">\n                                        ACTIVATE\n                                    </md-button>\n                                </div>\n                            </md-step-actions>\n                        </form>\n                    </md-step-body>\n                </md-step>\n\n                <md-step label="{{vm.metaData.stepData[3].label}}" md-complete="vm.metaData.stepData[3].completed"\n                    ng-disabled="vm.metaData.stepProgress < 4" md-editable="vm.metaData.stepData[3].editable"\n                    md-busy="vm.metaData.stepData[3].busy">\n                    <md-step-body>\n                        <form name="step3">\n                            <md-content class="md-padding" layout="column" layout-align="start start" flex>\n\n                                <div layout="row" layout-align="start start" flex>\n\n                                    <div flex="20" layout="column" layout-align="center center" flex>\n                                        <zp-zubot height="150px" width="150px"\n                                            outfit="vm.metaData.task.outfit"></zp-zubot>\n                                        <p class="zubot-task">\n                                            <b>{{vm.metaData.task.zubot}}</b>\n                                        </p>\n                                    </div>\n\n                                    <div class="intro-text">\n                                        <h1 class="no-margin">Summary</h1>\n                                        <p>\n                                            <b>{{vm.metaData.task.zubot}}</b> has been tasked for redaction\n                                            <b>{{vm.metaData.databasename}}</b>.\n                                        </p>\n                                        <p>\n                                            The Redaction process may take up to several\n                                            minutes to complete. The time the process takes is directly correlated to\n                                            the\n                                            size of the client database.\n                                        </p>\n                                        <p>\n                                            After finishing, the <b>{{vm.metaData.databasename}}</b> accounts CRM will\n                                            have\n                                            been\n                                            sucessfully\n                                            redacted.\n                                        </p>\n\n                                    </div>\n                                </div>\n\n                                <div layout="row" layout-align="start center" layout-fill>\n\n                                    <div class="status-container" layout="column" layout-align="center center"\n                                        flex="20">\n                                        <p class="no-margin">\n                                            <b>Status</b>:\n                                        </p>\n\n\n                                        <span class="two-percent-top-margin">\n                                            <b>{{vm.metaData.stepData[3].data.zubotProgress.caption}}</b>\n                                        </span>\n\n\n                                    </div>\n\n                                    <div ng-if="vm.metaData.stepData[3].data.milestone!==\'complete\'"\n                                        class="spinner-container" layout="column" layout-align="center center">\n\n                                        <md-progress-circular\n                                            ng-if="vm.metaData.stepData[3].data.zubotProgress.progress == 0"\n                                            md-diameter="80px" md-mode="indeterminate"\n                                            class="md-accent"></md-progress-circular>\n\n                                        <md-progress-circular\n                                            ng-if="vm.metaData.stepData[3].data.zubotProgress.progress > 0"\n                                            md-diameter="80px" md-mode="determinate"\n                                            value="{{vm.metaData.stepData[3].data.zubotProgress.progress}}"\n                                            class="md-accent"></md-progress-circular>\n\n                                        <span><b>{{\n                                                vm.metaData.stepData[3].data.zubotProgress.progress }}%</b></span>\n\n                                    </div>\n                                </div>\n                            </md-content>\n                        </form>\n                        <md-step-actions layout="row">\n                            <div flex></div>\n                            <div flex layout="row" layout-align="end top">\n                                <md-button\n                                    ng-disabled="vm.metaData.stepData[3].data.zubotProgress.milestone!==\'complete\'"\n                                    ng-click="vm.cancelDialog()" class="md-primary md-raised">\n                                    Done\n                                </md-button>\n                            </div>\n                        </md-step-actions>\n                    </md-step-body>\n                </md-step>\n            </md-steppers>\n        </md-stepper-card-content>\n    </md-dialog-content>\n</md-dialog>');
$templateCache.put('app/clients/dialogs/client-operations-dialog/unarchive-client-dialog.tmpl.html','<md-dialog aria-label="Unarchive client dialog" flex="60">\n    <md-toolbar aria-label="Unarchive client dialog toolbar">\n        <div layout="row" class="md-toolbar-tools">\n            <p class="md-subhead">Unarchive {{vm.metaData.databasename}}</p>\n            <span flex></span>\n            <md-button ng-click="vm.cancelDialog()">\n                <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n            </md-button>\n        </div>\n    </md-toolbar>\n    <md-dialog-content layout-padding>\n        <md-stepper-card-content class="md-no-padding">\n            <md-steppers md-dynamic-height md-stretch-steppers="always" md-selected="vm.metaData.selectedStep">\n                <md-step label="{{vm.metaData.stepData[0].label}}" md-complete="vm.metaData.stepData[0].completed"\n                    ng-disabled="vm.metaData.stepProgress < 1" md-editable="vm.metaData.stepData[0].editable"\n                    md-busy="vm.metaData.stepData[0].busy">\n                    <md-step-body>\n                        <form name="step1" ng-submit="vm.submitCurrentStep(vm.metaData.stepData[0])">\n                            <md-content class="md-padding" layout="row" layout-align="start start" flex>\n                                <div flex="20" layout="column" layout-align="center center" flex>\n                                    <zp-zubot height="150px" width="150px" outfit="vm.metaData.task.outfit"></zp-zubot>\n                                    <p class="zubot-task">\n                                        This task will be handled by\n                                        <b>{{vm.metaData.task.zubot}}</b><md-icon\n                                            md-font-icon="zmdi zmdi-refresh zubot-name-refresh"\n                                            ng-click="vm.refreshZubot()"\n                                            ng-show="!vm.metaData.task.zubotActivated"></md-icon>\n                                    </p>\n                                </div>\n\n                                <div class="intro-text">\n                                    <h1 class="no-margin">Unarchive Account</h1>\n                                    <p>\n                                        Activating this zubot will transfer the chosen client\'s data from back from AWS\n                                        S3 storage to the zuant data\n                                        store.\n                                    </p>\n                                    <h2 class="no-margin">Configuration</h2>\n                                    <p>\n                                        Here are some selectable options that specify the operations performed during\n                                        the unarchiving process. While these choices are not mandatory, depending on\n                                        requirements it may reduce the need for further account maintance post\n                                        unarchive.\n                                    </p>\n\n                                    <div ng-repeat="option in vm.metaData.stepData[0].data.options">\n                                        <div class="opions-container two-percent-top-margin"\n                                            ng-class="{\'has-sub-options\': option.subOptions && option.subOptions.length && option.value}">\n                                            <md-checkbox class="no-margin" ng-disabled="option.disabled"\n                                                ng-model="option.value" aria-label="{{ option.name }}"\n                                                ng-change="vm.primaryOptionToggled(option)">{{\n                                                option.name }} - {{ option.description }}</md-checkbox>\n\n                                            <div ng-if="option.subOptions && option.subOptions.length && option.value"\n                                                class="sub-options-container">\n\n                                                <div layout="row" layout-align="space-between start">\n                                                    <div\n                                                        ng-repeat="groupedCategory in vm.groupSubOptionsByCategory(option.name)">\n\n                                                        <div layout-align="start center" layout="row">\n                                                            <h4 class="no-margin two-percent-top-margin">{{\n                                                                groupedCategory[0] }}</h4>\n                                                            <md-button class="md-icon-button md-small"\n                                                                ng-disabled="!option.value"\n                                                                ng-click="vm.toggleDatabaseFieldNameField(groupedCategory[0])"\n                                                                ng-class="{\'toggled\': vm.metaData.stepData[0].data.databaseFieldNameSelectedCategory === groupedCategory[0]}">\n                                                                <md-icon md-font-icon="zmdi zmdi-plus"></md-icon>\n                                                            </md-button>\n                                                        </div>\n\n                                                        <div class="five-percent-top-margin"\n                                                            ng-repeat="subOption in groupedCategory[1]">\n                                                            <md-checkbox class="no-margin"\n                                                                ng-disabled="subOption.disabled"\n                                                                ng-model="subOption.value"\n                                                                aria-label="{{ subOption.name }}">{{\n                                                                subOption.name }}</md-checkbox>\n                                                        </div>\n                                                    </div>\n                                                </div>\n\n                                                <p class="hint-text">\n                                                    Hint - click on the plus button next to the category name to add\n                                                    additional database field names.\n                                                </p>\n\n                                                <div ng-if="vm.metaData.stepData[0].data.databaseFieldNameVisible"\n                                                    layout="row" layout-align="start center">\n                                                    <md-input-container\n                                                        class="md-icon-float md-block no-margin datebase-field-name-input hide-validation-error">\n                                                        <label>\n                                                            Add {{\n                                                            vm.metaData.stepData[0].data.databaseFieldNameSelectedCategory\n                                                            }} Database\n                                                            Field Name\n                                                        </label>\n                                                        <input type="text"\n                                                            ng-model="vm.metaData.stepData[0].data.databaseFieldName">\n                                                    </md-input-container>\n\n                                                    <md-button class="md-icon-button"\n                                                        ng-click="vm.submitDatabaseFieldNameField()"\n                                                        ng-disabled="vm.databaseFieldName.length === 0">\n                                                        <md-icon md-font-icon="zmdi zmdi-check"></md-icon>\n                                                    </md-button>\n\n                                                </div>\n\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </md-content>\n                            <md-step-actions layout="row">\n                                <div flex></div>\n                                <div flex layout="row" layout-align="end top">\n                                    <md-button ng-click="vm.cancelDialog()" class="md-warn">CANCEL</md-button>\n                                    <md-button type="submit">NEXT</md-button>\n                                </div>\n                            </md-step-actions>\n                        </form>\n                    </md-step-body>\n                </md-step>\n                <md-step label="{{vm.metaData.stepData[1].label}}" md-complete="vm.metaData.stepData[1].completed"\n                    ng-disabled="vm.metaData.stepProgress < 2" md-editable="vm.metaData.stepData[1].editable"\n                    md-busy="vm.metaData.stepData[1].busy">\n                    <md-step-body>\n                        <form name="step2" ng-submit="vm.submitCurrentStep(vm.metaData.stepData[1])">\n                            <md-content class="md-padding" layout="row" layout-align="start start" flex>\n                                <div flex="20" layout="column" layout-align="center center" flex>\n                                    <zp-zubot height="150px" width="150px" outfit="vm.metaData.task.outfit"></zp-zubot>\n                                    <p class="zubot-task">\n                                        This task will be handled by\n                                        <b>{{vm.metaData.task.zubot}}</b><md-icon\n                                            md-font-icon="zmdi zmdi-refresh zubot-name-refresh"\n                                            ng-click="vm.refreshZubot()"\n                                            ng-show="!vm.metaData.task.zubotActivated"></md-icon>\n                                    </p>\n                                </div>\n\n                                <div class="intro-text">\n                                    <h1 class="no-margin">Confirmation</h1>\n                                    <p>\n                                        Please confirm that you actually want to unarchive this client. You will be able\n                                        to re-archive the client at any time once this operation has complete.\n                                    </p>\n                                    <p>\n                                        Confirm by typing the database name below (<b>{{vm.metaData.databasename}}</b>).\n                                    </p>\n\n                                    <md-input-container\n                                        class="md-icon-float md-block no-margin datebase-field-name-input hide-validation-error">\n                                        <label>\n                                            Enter Database Name Here...\n                                        </label>\n                                        <input type="text"\n                                            ng-model="vm.metaData.stepData[1].data.confirmationFieldValue">\n                                    </md-input-container>\n\n                                </div>\n                            </md-content>\n\n                            <md-step-actions layout="row">\n                                <div flex layout="row" layout-align="end top">\n                                    <md-button ng-click="vm.moveToPreviousStep()">\n                                        PREVIOUS\n                                    </md-button>\n                                    <div flex></div>\n\n                                    <md-button\n                                        ng-disabled="vm.metaData.stepData[1].data.confirmationFieldValue !== vm.metaData.stepData[1].data.confirmationText"\n                                        type="submit" class="md-primary md-raised">\n                                        ACTIVATE\n                                    </md-button>\n                                </div>\n                            </md-step-actions>\n                        </form>\n                    </md-step-body>\n                </md-step>\n                <md-step label="{{vm.metaData.stepData[2].label}}" md-complete="vm.metaData.stepData[2].completed"\n                    ng-disabled="vm.metaData.stepProgress < 3" md-editable="vm.metaData.stepData[2].editable"\n                    md-busy="vm.metaData.stepData[2].busy">\n                    <md-step-body>\n                        <form name="step3">\n                            <md-content class="md-padding" layout="column" layout-align="start start" flex>\n                                <div layout="row" layout-align="start start" flex>\n                                    <div flex="20" layout="column" layout-align="center center" flex>\n                                        <zp-zubot height="150px" width="150px"\n                                            outfit="vm.metaData.task.outfit"></zp-zubot>\n                                        <p class="zubot-task">\n                                            <b>{{vm.metaData.task.zubot}}</b>\n                                        </p>\n                                    </div>\n\n                                    <div class="intro-text" layout="column" layout-align="start start" flex>\n                                        <h1 class="no-margin">Summary</h1>\n                                        <p>\n                                            <b>{{vm.metaData.task.zubot}}</b> has been tasked to unarchive\n                                            <b>{{vm.metaData.databasename}}</b>.\n                                        </p>\n                                        <p>\n                                            The unarchive process may take up to several\n                                            minutes to complete. The time the process takes is directly correlated to\n                                            the\n                                            size of the client.\n                                        </p>\n                                        <p>\n                                            After finishing, you can close this dialog, allowing you to gain full access\n                                            to\n                                            the <b>{{vm.metaData.databasename}}</b> account.\n                                        </p>\n                                    </div>\n\n                                </div>\n\n                                <div layout="row" layout-align="start center" layout-fill>\n\n                                    <div class="status-container" layout="column" layout-align="center center"\n                                        flex="20">\n                                        <p class="no-margin">\n                                            <b>Status</b>:\n                                        </p>\n\n\n                                        <span class="two-percent-top-margin">\n                                            <b>{{vm.metaData.stepData[2].data.zubotProgress.caption}}</b>\n                                        </span>\n\n\n                                    </div>\n\n                                    <div ng-if="vm.metaData.stepData[2].data.milestone!==\'complete\'"\n                                        class="spinner-container" layout="column" layout-align="center center">\n\n                                        <md-progress-circular\n                                            ng-if="vm.metaData.stepData[2].data.zubotProgress.progress == 0"\n                                            md-diameter="80px" md-mode="indeterminate"\n                                            class="md-accent"></md-progress-circular>\n\n                                        <md-progress-circular\n                                            ng-if="vm.metaData.stepData[2].data.zubotProgress.progress > 0"\n                                            md-diameter="80px" md-mode="determinate"\n                                            value="{{vm.metaData.stepData[2].data.zubotProgress.progress}}"\n                                            class="md-accent"></md-progress-circular>\n\n                                        <span><b>{{\n                                                vm.metaData.stepData[2].data.zubotProgress.progress }}%</b></span>\n\n                                    </div>\n                                </div>\n                            </md-content>\n                        </form>\n                        <md-step-actions layout="row">\n                            <div flex></div>\n                            <div flex layout="row" layout-align="end top">\n                                <md-button\n                                    ng-disabled="vm.metaData.stepData[2].data.zubotProgress.milestone!==\'complete\'"\n                                    ng-click="vm.cancelDialog()" class="md-primary md-raised">\n                                    Done\n                                </md-button>\n                            </div>\n                        </md-step-actions>\n                    </md-step-body>\n                </md-step>\n            </md-steppers>\n        </md-stepper-card-content>\n    </md-dialog-content>\n</md-dialog>');
$templateCache.put('app/clients/dialogs/consent-token-dialog/dialog.tmpl.html','<md-dialog aria-label="Add consent token dialog" flex="50">\n  <md-toolbar>\n    <div class="md-toolbar-tools">\n      <h2>{{$ctrl.toolbartitle}}</h2>\n      <span flex></span>\n      <md-button class="md-icon-button" ng-click="$ctrl.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-content layout-padding layout="column">\n    <div ng-show="$ctrl.errorMessages.length">\n      <p><md-icon md-font-icon="zmdi zmdi-alert-triangle zuantPollen"></md-icon>Please correct the errors below:</p>\n      <ul>\n        <li ng-repeat="message in $ctrl.errorMessages">{{message}}</li>\n      </ul>\n    </div>\n    <zp-consent-token-form token-obj="$ctrl.dataModelFactoryData.tokenInEdit"\n      form-obj="$ctrl.validationFactoryData.tokenInEditForm" read-only="$ctrl.readOnly">\n    </zp-consent-token-form>\n  </md-content>\n  <md-dialog-actions>\n    <div ng-if="!$ctrl.readOnly" layout="row" layout-align="end end" flex>\n      <md-button ng-click="$ctrl.cancelDialog()" class="md-primary">CANCEL</md-button>\n      <md-button ng-click="$ctrl.saveAndClose()" class="md-raised md-primary"\n        ng-disabled="!$ctrl.validationFactoryData.tokenInEditForm.$valid">SAVE</md-button>\n    </div>\n    <div ng-if="$ctrl.readOnly" layout="row" layout-align="end end" flex>\n      <md-button ng-click="$ctrl.cancelDialog()" class="md-primary">CLOSE</md-button>\n    </div>\n  </md-dialog-actions>\n</md-dialog>');
$templateCache.put('app/clients/dialogs/gdpr-enabled-courtesy-info/dialog.tmpl.html','<md-dialog aria-label="Request passcode dialog" flex="50">\n  <md-toolbar>\n    <div class="md-toolbar-tools">\n      <h2>Next Steps</h2>\n      <span flex></span>\n      <md-button class="md-icon-button" ng-click="$ctrl.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-content layout-padding layout="column">\n    <p>Now that GDPR is enabled, it\'s a good idea to configure your account consent model.</p>\n  </md-content>\n  <md-dialog-actions>\n    <div layout="row" layout-align="end end" flex>\n      <md-button ng-click="$ctrl.cancelDialog()" class="md-primary">Not now</md-button>\n      <md-button ng-click="$ctrl.navigate()" class="md-raised md-primary">Ok</md-button>\n    </div>\n  </md-dialog-actions>\n</md-dialog>\n');
$templateCache.put('app/clients/dialogs/manage-client-dialog/manage-client-dialog.tmpl.html','<md-dialog aria-label="Manage client dialog" flex="80">\n  <md-toolbar aria-label="Manage client dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">Where would you like to go?</p>\n      <span flex></span>\n\n      <ng-container ng-if="!vm.isClientMarketpoint()" hide-xs>\n        <zp-delete-button ng-if="!vm.loading"\n          disabled="vm.clientDoc.clientOperationStatus && vm.clientDoc.clientOperationStatus.operation !== \'deleteClient\'"\n          ng-click="vm.deleteClient($event)" permission permission-only="\'SUPER_ZAM\'">\n        </zp-delete-button>\n\n        <zp-redact-crm-button ng-if="!vm.loading && vm.clientDoc.clientArchived && !vm.clientDoc.clientRedacted"\n          disabled="vm.clientDoc.clientOperationStatus && vm.clientDoc.clientOperationStatus.operation !== \'redactAllCRM\'"\n          ng-click="vm.redactClient($event)" permission permission-only="\'SUPER_ZAM\'">\n        </zp-redact-crm-button>\n\n        <zp-archive-button ng-if="!vm.loading && !vm.clientDoc.clientArchived"\n          disabled="vm.clientDoc.clientOperationStatus && vm.clientDoc.clientOperationStatus.operation !== \'archiveClient\'"\n          ng-click="vm.archiveClient($event)" permission permission-only="\'SUPER_ZAM\'">\n        </zp-archive-button>\n\n        <zp-unarchive-button ng-if="!vm.loading && vm.clientDoc.clientArchived"\n          disabled="vm.clientDoc.clientOperationStatus && vm.clientDoc.clientOperationStatus.operation !== \'unarchiveClient\'"\n          ng-click="vm.unarchiveClient($event)" permission permission-only="\'SUPER_ZAM\'">\n        </zp-unarchive-button>\n      </ng-container>\n\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-dialog-content layout-padding>\n    <md-progress-linear class="md-accent" style="padding-left: 0px; padding-right: 0px;" ng-if="vm.loading"\n      md-mode="indeterminate"></md-progress-linear>\n\n    <md-list flex layout="row" layout-gt-xs="row" layout-wrap layout-align="center center">\n      <md-list-item layout-fill>\n        <div layout="column" layout-align="center center" layout-fill>\n\n          <span ng-if="vm.clientDoc.clientArchived && !vm.clientDoc.clientOperationStatus">\n            <md-icon md-font-icon="zmdi zmdi-alert-triangle zuantPollen"></md-icon>\n            <span permission permission-only="\'SUPER_ZAM\'">\n              This client is currently archived, please use the "UNARCHIVE" above below to re-enable the account.\n            </span>\n            <span permission permission-except="\'SUPER_ZAM\'">\n              This client is currently archived, please ask an administrator to re-enable the account.\n            </span>\n\n            <div permission permission-except="\'SUPER_ZAM\'">\n              <p class="margin-bottom-0">Administrators permissioned to perform this operation:</p>\n              <ul class="super-zam-list">\n                <li ng-repeat="superZam in $ctrl.superZams">\n                  {{superZam.name}} - {{superZam.email}}\n                </li>\n              </ul>\n            </div>\n          </span>\n\n          <span\n            ng-if="vm.clientDoc.clientArchived && !vm.clientDoc.clientOperationStatus && vm.clientDoc.clientRedacted">\n            <md-icon md-font-icon="zmdi zmdi-info-outline md-primary"></md-icon>\n            This client has also been redacted.\n          </span>\n\n          <ng-container ng-if="vm.clientDoc.clientOperationStatus"\n            ng-switch="vm.clientDoc.clientOperationStatus.operation">\n            <span>\n              <md-icon md-font-icon="zmdi zmdi-info-outline md-primary"></md-icon>\n              <ng-container ng-switch-when="archiveClient">\n                This client currently has an archive operation ongoing, you will be unable to access the account until\n                completion. <span permission permission-only="\'SUPER_ZAM\'">To see progress click on the "ARCHIVE" button\n                  in the dialogs toolbar above.</span>\n              </ng-container>\n              <ng-container ng-switch-when="unarchiveClient">\n                This client currently has an unarchive operation ongoing, you will be unable to access the account\n                until completion. <span permission permission-only="\'SUPER_ZAM\'">To see progress click on the\n                  "UNARCHIVE" button in the dialogs toolbar above.</span>\n              </ng-container>\n              <ng-container ng-switch-when="deleteClient">\n                This client currently has a deletion operation ongoing, you will be unable to access the account until\n                completion. <span permission permission-only="\'SUPER_ZAM\'">To see progress click on the "DELETE" button\n                  in the dialogs toolbar above.</span>\n              </ng-container><ng-container ng-switch-when="redactAllCRM">\n                This client currently has a redaction operation ongoing, you will be unable to access the account\n                until completion. <span permission permission-only="\'SUPER_ZAM\'">To see progress click on the "REDACT"\n                  All CRM" button in the dialogs toolbar above.</span>\n              </ng-container>\n            </span>\n          </ng-container>\n\n        </div>\n      </md-list-item>\n\n      <md-list-item ng-repeat="item in vm.items" flex-gt-xs="25" layout-align="center center" permission\n        permission-sref="item.baseState">\n        <md-button class="{{item.className}} client-action-button"\n          ng-disabled="(vm.clientDoc.clientOperationStatus || vm.clientDoc.clientArchived) && item.name !==\'Manage\'"\n          flex layout-fill ng-if="item.sref" ng-click="vm.go(item)">\n          <md-icon ng-if="item.icon" md-font-icon="zmdi {{item.icon}}"></md-icon>\n          <md-icon ng-if="item.svgicon" md-svg-src="{{item.svgicon}}"></md-icon>\n          <div class="md-grid-text">{{item.name}}</div>\n        </md-button>\n        <md-button class="{{item.className}} client-action-button"\n          ng-disabled="(vm.clientDoc.clientOperationStatus || vm.clientDoc.clientArchived)" flex layout-fill\n          ng-if="item.href" ng-click="vm.redirect(item.href)">\n          <md-icon ng-if="item.icon" md-font-icon="zmdi {{item.icon}}"></md-icon>\n          <md-icon ng-if="item.svgicon" md-svg-src="{{item.svgicon}}"></md-icon>\n          <div class="md-grid-text">{{item.name}}</div>\n        </md-button>\n      </md-list-item>\n    </md-list>\n  </md-dialog-content>\n</md-dialog>');
$templateCache.put('app/clients/dialogs/request-gdpr-passcode/dialog.tmpl.html','<md-dialog aria-label="Request passcode dialog" flex="50">\n  <md-toolbar>\n    <div class="md-toolbar-tools">\n      <h2>{{vm.toolbarTitle}}</h2>\n      <span flex></span>\n      <md-button class="md-icon-button" ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-content layout-padding layout="column">\n    <!-- TODO. show this dialog when user clicks padlock button on certain fields. breakout dialog from requesting passcode -->\n    <!-- <div ng-show="vm.requireUserInputToSendPasscode">\n      <p class="md-body-1">Changing this setting requires an elevated edit session. Click the button below to send the account owner ({{vm.factoryData.currentClient.accountOwner}}) a passcode.</p>\n      <md-button ng-click="vm.requestPasscode()"></md-button>\n    </div>  -->\n    <div ng-show="!vm.passcodeValid">\n      <div layout-align="center center" flex>\n        <p class="md-body-1">We have emailed a passcode to {{vm.userDoc.email}} .\n        </p>\n        <p class="md-body-1">Please enter the passcode into the form below.</p>\n        <p ng-show="vm.factoryData.invalidPasscodeCount > 0" class="md-body-1">That passcode is invalid.\n          {{vm.factoryData.invalidPasscodeCount}} failed attempts, you have {{ 3 - vm.factoryData.invalidPasscodeCount}}\n          attempt remaining.</p>\n        <p ng-show="vm.passcodeValidationError">{{ vm.passcodeValidationError }}</p>\n        <div layout="row" layout-margin>\n          <input type="number" ng-pattern="/^[0-9]*$/" ng-model="vm.passcode" class="big-input" ng-maxlength="6"\n            tabindex="1" md-autofocus focus-me="vm.focusInput0" />\n        </div>\n      </div>\n    </div>\n    <div layout-align="center center" flex ng-show="vm.passcodeValid">\n      <p class="md-headline">\n        <md-icon md-font-icon="zmdi zmdi-shield-check md-accent"></md-icon> Passcode valid\n      </p>\n      <p class="md-subhead">You now have a 60 minute window in which to make Vault Level account adjustments.</p>\n      <p class="md-body-1">Such as</p>\n      <ul>\n        <li>Change GDPR settings</li>\n        <li>Edit your account consent settings</li>\n        <li>Change the account owner</li>\n        <li>Change account sync urls</li>\n      </ul>\n      <p class="md-body-1">When you are happy with your changes click the end edit session button in the top toolbar, a\n        summary of your changes will be emailed to you.</p>\n    </div>\n\n  </md-content>\n  <md-dialog-actions>\n    <div layout="row" layout-align="end end" ng-show="vm.showActions" flex>\n      <md-button ng-click="vm.resetForm()" ng-show="vm.passcode.length >= 1" class="">Reset</md-button>\n      <span flex></span>\n      <md-button ng-click="vm.verifyPasscode()" class="md-raised md-primary animated slideInRight"\n        ng-hide="vm.hideVerifyBtn" ng-disabled="vm.verifyBtnDisabled(); vm.disableVerifyBtn">\n        Verify\n      </md-button>\n      <md-button ng-click="vm.closeDialog()" ng-show="vm.hideVerifyBtn" class="md-raised md-primary">Close</md-button>\n    </div>\n  </md-dialog-actions>\n</md-dialog>');
$templateCache.put('app/clients/main/clients-list-component/zp-clients-list.tmpl.html','<div class="chips-container">\n  <ng-container ng-if="($ctrl.metadata.filterOptions.filters | filter: {selected: true} ).length > 0" flex layout="row"\n    layout-align="start center">\n    <span class="md-subhead zuantTitanium1">Filters:</span>\n    <md-chips class="filter-chips" ng-model="$ctrl.selectedChips" readonly="true"\n      md-removable="$ctrl.selectedChips.length > 1" md-on-remove="$chip.action()">\n      <md-chip-template>\n        <span>{{$chip.name}}</span>\n      </md-chip-template>\n    </md-chips>\n  </ng-container>\n</div>\n\n<md-card flex-order-md="1" flex>\n  <zp-data-grid ng-cloak metadata="$ctrl.metadata" search-value="$ctrl.search.searchVal"\n    options="$ctrl.metadata.gridOptions" row-click="$ctrl.primaryAction(ev, rowid)" widget-id="$ctrl.metadata.id">\n  </zp-data-grid>\n\n  <md-table-pagination hide-xs hide-sm class="md-table-pagination" ng-if="$ctrl.metadata.paginationOptions.pagination"\n    md-limit="$ctrl.metadata.paginationOptions.limit" md-limit-options="$ctrl.metadata.paginationOptions.limitOptions"\n    md-page="$ctrl.metadata.paginationOptions.page" md-total="{{$ctrl.model.factoryData.items.length}}"\n    md-page-select="$ctrl.metadata.paginationOptions.pageSelect"\n    md-boundary-links="$ctrl.metadata.paginationOptions.boundaryLinks"\n    md-on-paginate="$ctrl.logPagination(page, limit)">\n  </md-table-pagination>\n\n</md-card>');
$templateCache.put('app/clients/main/fab/fab.tmpl.html','<div flex layout="column" layout-align="center end">\n    <zp-filter-button filter-buttons="$ctrl.metadata.filterOptions.filters"></zp-filter-button>\n\n    <zp-fab-add default-position="\'nothing\'" pulse-class-check="false"\n        dialog-config="$ctrl.metadata.fabDialogConfig"></zp-fab-add>\n</div>');
$templateCache.put('app/clients/main/widget-container/clients-widget-container.tmpl.html','<md-content layout-fill md-theme="zuantCloudSkin" theme-background="primary:hue-2" hide-xs hide-sm>\n  <div layout="row">\n    <zp-count-widget count="$ctrl.data.items.length" label="ACCOUNTS TOTAL" icon="zmdi-city-alt" flex="50"></zp-count-widget>\n    <zp-count-widget ng-click="$ctrl.toggleReportSize()" count="$ctrl.activeAccountsInfo.count" label="{{$ctrl.activeUserLabel}}" icon="zmdi-calendar-alt" flex="50"></zp-count-widget>\n  </div>\n  <!-- <div layout="row"> -->\n  <!-- </div> -->\n  <div layout="row">\n    <zam-helper></zam-helper>\n  </div>\n  <div layout="row">\n    <md-button flex class="md-raised md-accent" ng-click="$ctrl.manageClient()"><md-icon md-font-icon="zmdi zmdi-settings"></md-icon>Manage Client</md-button>\n    <md-button flex class="md-raised md-accent" ng-click="$ctrl.downloadUsers($event)"><md-icon md-font-icon="zmdi zmdi-download"></md-icon>Export .CSV</md-button>\n    <!-- <md-button flex="33" class="md-raised md-accent" ng-click="$ctrl.viewUsageCharts($event)"><md-icon md-font-icon="zmdi zmdi-chart"></md-icon>View Activity</md-button> -->\n  </div>\n\n</md-content>\n');
$templateCache.put('app/clients/permissions/fab/fab.tmpl.html','<zp-save-button isfab="\'true\'" label="\'save template fab\'" isdirty="$ctrl.changeDelta.isDirty()" save="$ctrl.saveChanges()" disabled="$ctrl.disableSaveButton" ng-show="$ctrl.changeDelta.isDirty()"></zp-save-button>\n');
$templateCache.put('app/clients/main/client-list-page-component/zp-client-list-page.tmpl.html','<zp-clients-list metadata="$ctrl.metadata" model="$ctrl.model" search="$ctrl.search" flex></zp-clients-list>');
$templateCache.put('app/clients/permissions/zp-permissions-preset-widget/permissions-preset-widget.tmpl.html','<md-card layout-margin flex flex-gt-md="80" flex-offset-gt-md="10" flex-gt-lg="70" flex-offset-gt-lg="15">\n  <md-card-header>\n    <md-card-avatar>\n      <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-accounts-list"></md-icon>\n    </md-card-avatar>\n    <md-card-header-text>\n      <span class="md-title">Permission Presets</span>\n      <span class="md-subhead">Apply predefined sets of permissions to selected users</span>\n    </md-card-header-text>\n  </md-card-header>\n  <md-card-content>\n    <div layout-margin>\n      <p class="md-body-2">Below are the permissions preset options you have to choose from.</p>\n      <div layout="column" layout-gt-sm="row" layout-align="center" layout-margin>\n        <md-button class="md-accent" ng-class="{\'md-raised\' : $ctrl.activePreset == \'admin\'}"\n          ng-click="$ctrl.applyPreset(\'admin\')">Admin Preset</md-button>\n        <md-button class="md-accent" ng-class="{\'md-raised\' : $ctrl.activePreset == \'power\'}"\n          ng-click="$ctrl.applyPreset(\'power\')">Power User Preset</md-button>\n        <md-button class="md-accent" ng-class="{\'md-raised\' : $ctrl.activePreset == \'standard\'}"\n          ng-click="$ctrl.applyPreset(\'standard\')">Standard User Preset</md-button>\n      </div>\n      <div ng-show="$ctrl.showApplyPresetPrompt" layout-margin>\n        <p>To apply the {{$ctrl.activePreset}} preset click the button below</p>\n        <div layout="row" layout-align="center">\n          <md-button class="md-accent" ng-class="{\'md-raised pulsate-aqua\': $ctrl.pulsateApplyPresetBtn}"\n            ng-click="$ctrl.confirmApplyPreset()" ng-hide="$ctrl.showConfirmation">Apply Preset</md-button>\n        </div>\n        <div layout="row" ng-show="$ctrl.showConfirmation">\n          <p>The {{$ctrl.activePreset}} preset was successfully applied to the selected users.</p>\n          <md-button class="md-accent animated" ng-class="{\'md-raised pulsate-aqua fadeIn\': $ctrl.showConfirmation}"\n            ng-click="$ctrl.resetUserPool()">Done</md-button>\n        </div>\n      </div>\n    </div>\n  </md-card-content>\n</md-card>');
$templateCache.put('app/clients/permissions/zp-user-pool-selector/zp-user-pool-selector.tmpl.html','<section style=" max-height: 85vh; overflow-y: scroll;" >\n<md-card layout-margin flex >\n  <md-card-header>\n    <!-- <md-card-avatar>\n      <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-accounts-list"></md-icon>\n    </md-card-avatar>\n    <md-card-header-text>\n      <span class="md-title">Account user list</span>\n      <span class="md-subhead"></span>\n    </md-card-header-text> -->\n  </md-card-header>\n  <md-card-content class=" padding-top-0">\n    <div layout="row" flex="100">\n      <md-input-container flex="70" class="margin-top-0 margin-bottom-0">\n        <md-icon md-font-icon="zmdi zmdi-search"></md-icon>\n        <label>Filter users</label>\n        <input ng-model="search" />\n      </md-input-container>\n\n      <md-button class="md-accent md-icon-button" ng-click="$ctrl.toggleAllUsers()">\n        <ng-md-icon icon="{{$ctrl.allUsersSelectedCheck()}}" style="{{$ctrl.toggleAllStyle}}" size="24"></ng-md-icon>\n        <md-tooltip show-xs show-sm>{{$ctrl.toggleAllTooltip}}</md-tooltip>\n      </md-button>\n    </div>\n\n      <md-list class="md-dense" xxstyle="max-height: 45vh; overflow-y: scroll;">\n        <md-list-item ng-repeat="item in $ctrl.users | filter: search" ng-if="!item.inactive" ng-click="$ctrl.toggleSelectUser(item)" class="md-2-line" style="padding: 0px;">\n          <ng-md-icon icon="{{$ctrl.PermissionsManagerFactory.usersObject[item._id] ? \'check_box\': \'check_box_outline_blank\'}}" style="{{$ctrl.PermissionsManagerFactory.usersObject[item._id] ? \'fill: #fec353;\': \'fill: #949ca1;\'}}; margin-right: 0px;" size="24" class="md-avatar"></ng-md-icon>\n          <img ng-src="{{item.avatar}}" class="md-avatar" hide-xs hide-sm hide-md />\n          <div class="md-list-item-text">\n            <h3>{{ item.firstname }} {{ item.surname }}</h3>\n            <h4>{{ item.email }}</h4>\n            <h4>{{ item.roleorcustom }}</h4>\n          </div>\n          <md-icon md-font-icon="zmdi zmdi-star-circle" ng-show="item.permissions.trump == true"></md-icon>\n          <md-divider ng-if="!$last"></md-divider>\n        </md-list-item>\n      </md-list>\n  </md-card-content>\n</md-card>\n\n<md-card layout-margin flex           \n  permission\n  permission-only="\'ZUANT_ADMIN\'">\n    <md-card-header>\n      <md-card-avatar>\n        <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-accounts-list"></md-icon>\n      </md-card-avatar>\n      <md-card-header-text>\n        <span class="md-title">Zuant Staff Users</span>\n        <!-- <span class="md-subhead"></span> -->\n      </md-card-header-text>\n    </md-card-header>\n    <md-card-content class=" padding-top-0">\n      <div layout="row" flex>\n        <md-input-container flex="70" class="margin-top-0 margin-bottom-0">\n          <md-icon md-font-icon="zmdi zmdi-search"></md-icon>\n          <label>Filter users</label>\n          <input ng-model="search" />\n        </md-input-container>\n  \n        <md-button class="md-accent md-icon-button" ng-click="$ctrl.toggleAllUsers()">\n          <ng-md-icon icon="{{$ctrl.allUsersSelectedCheck()}}" style="{{$ctrl.toggleAllStyle}}" size="24"></ng-md-icon>\n          <md-tooltip show-xs show-sm>{{$ctrl.toggleAllTooltip}}</md-tooltip>\n        </md-button>\n      </div>\n  \n        <md-list class="md-dense" xxstyle="max-height: 45vh; overflow-y: scroll;">\n          <md-list-item ng-repeat="item in $ctrl.staffUsers | filter: search" ng-if="!item.inactive" ng-click="$ctrl.toggleSelectUser(item)" class="md-2-line">\n            <ng-md-icon icon="{{$ctrl.PermissionsManagerFactory.usersObject[item._id] ? \'check_box\': \'check_box_outline_blank\'}}" style="{{$ctrl.PermissionsManagerFactory.usersObject[item._id] ? \'fill: #fec353;\': \'fill: #949ca1;\'}};  margin-right: 0px;" size="24" class="md-avatar"></ng-md-icon>\n            <img ng-src="{{item.avatar}}" class="md-avatar" hide-xs hide-sm hide-md/>\n            <div class="md-list-item-text">\n              <h3>{{ item.firstname }} {{ item.surname }}</h3>\n              <h4>{{ item.email }}</h4>\n              <h4>{{ item.roleorcustom }}</h4>\n            </div>\n            <md-icon md-font-icon="zmdi zmdi-star-circle" ng-show="item.permissions.trump == true"></md-icon>\n            <md-divider ng-if="!$last"></md-divider>\n          </md-list-item>\n        </md-list>\n    </md-card-content>\n  </md-card>\n</section>');
$templateCache.put('app/clients/permissions/zp-user-pool-with-controls/user-pool-with-controls.tmpl.html','<div layout="column" layout-align="center" layout-padding flex="100">\n  <md-chips>\n    <md-chip ng-repeat="chip in $ctrl.chips">\n      <strong>{{chip.email}}</strong>\n    </md-chip>\n  </md-chips>\n  <div layout="row" layout-align="center">\n    <md-button class="md-primary animated"\n      ng-class="{\'md-raised\': $ctrl.viewActive == \'presets\', \'pulsate-pollen\': $ctrl.pulsePresetBtn }"\n      ng-click="$ctrl.setViewTo({view:\'presets\'})">\n      Apply A Permissions Preset\n    </md-button>\n    <md-button class="md-primary animated"\n      ng-class="{\'md-raised\': $ctrl.viewActive == \'custom\', \'pulsate-pollen\': $ctrl.pulseCustomBtn }"\n      ng-click="$ctrl.setViewTo({view:\'custom\'})">\n      Apply Custom Permissions\n    </md-button>\n  </div>\n\n  <div layout-padding layout-margin flex="80" flex-gt-md="60" layout="row" layout-align="center center"\n    ng-hide="$ctrl.viewActive == \'presets\' || $ctrl.viewActive == \'custom\'">\n    <div layout="column" layout-align="center center" flex="60">\n      <div ng-include="$ctrl.dottedUpArrowImageSvg"></div>\n      <p class="md-title">Now that you have a pool of users selected you can do 1 of 2 things: select a predefined set\n        of permissions (preset), or take full control over individual permissions (custom).</p>\n    </div>\n  </div>\n</div>');
$templateCache.put('app/clients/privacy-statements-manager/dialogs/single-privacy-statement-dialog.tmpl.html','<md-dialog aria-label="Create privacy statement" flex="80">\n\n  <md-toolbar aria-label="Create privacy statement dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead" id=\'statement-title\'>{{$ctrl.toolbarTitle}}</p>\n      <span flex></span>\n      <md-button ng-click="$ctrl.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-toolbar class="md-warn" ng-show="$ctrl.errorMessage">\n    <div layout="row" class="md-toolbar-tools">\n      Error: {{$ctrl.errorMessage}}\n    </div>\n  </md-toolbar>\n  <md-dialog-content layout-padding>\n\n    <zp-privacy-statement-form privacy-statement-form-object="$ctrl.viewModel.privacyStatementFormObject"\n      privacy-statement="$ctrl.privacyStatement" view-only="$ctrl.viewOnly">\n    </zp-privacy-statement-form>\n\n  </md-dialog-content>\n\n  <md-dialog-actions layout="row">\n    <div layout="row" layout-align="start center">\n      <div flex></div>\n      <md-button class="md-warn" ng-click="$ctrl.cancelDialog()" ng-show="!$ctrl.viewOnly">\n        <md-tooltip md-direction="top">Cancel</md-tooltip>Cancel\n      </md-button>\n      <md-button class="md-primary" ng-disabled="$ctrl.viewModel.privacyStatementFormObject.$invalid"\n        ng-click="$ctrl.submit($event)" aria-label="save privacy statement form"\n        ng-show="!$ctrl.viewOnly && $ctrl.changeDelta.isDirty()"\n        ng-class="{\'md-raised md-primary\': $ctrl.viewModel.privacyStatementFormObject.$valid}">\n        <md-icon md-font-icon="zmdi zmdi-floppy">&nbsp;\n          <md-tooltip md-direction="top">Save</md-tooltip>\n      </md-button>\n    </div>\n  </md-dialog-actions>\n\n</md-dialog>');
$templateCache.put('app/clients/privacy-statements-manager/fabs/add-fab.tmpl.html','<md-button\n  class="md-fab md-fab-bottom-right md-accent"\n  ng-click="$ctrl.issueNewPrivacyStatement($event)">\n  <md-icon md-font-icon="zmdi zmdi-plus"></md-icon>\n  <md-tooltip md-direction="bottom">\n    Add\n  </md-tooltip>\n</md-button>\n');
$templateCache.put('app/clients/privacy-statements-manager/privacy-statement-form/privacy-statement-form.tmpl.html','<form name="$ctrl.privacyStatementFormObject" novalidate flex layout="column">\n  <md-list flex="100">\n    <md-list-item flex>\n      <md-input-container flex>\n        <label>Title</label>\n        <input ng-model="$ctrl.privacyStatement.title" ng-change="$ctrl.updateChangeDelta(\'title\', $ctrl.privacyStatement.title)" type="text" name="title" required ng-disabled="$ctrl.viewOnly"/>\n        <div ng-messages="$ctrl.privacyStatementFormObject.title.$error" md-auto-hide="false" ng-show="$ctrl.privacyStatementFormObject.title.$touched">\n          <div ng-message when="required">\n            <spanTitle is required</span>\n          </div>\n        </div>\n      </md-input-container>\n    </md-list-item>\n    <md-list-item flex>\n        <md-icon md-font-icon="zmdi zmdi-shield-check" ng-style="$ctrl.iconStyle()"></md-icon>\n        <p>Account default privacy statement:</p>\n        <md-switch ng-model="$ctrl.privacyStatement.isPrimaryStatement" ng-change="$ctrl.updateChangeDelta(\'isPrimaryStatement\', $ctrl.privacyStatement.isPrimaryStatement)" class="md-secondary" name="isPrimaryStatement" aria-label="isPrimaryStatement" ng-true-value="true" ng-false-value="false" ng-disabled="$ctrl.viewOnly">\n        </md-switch>\n    </md-list-item>\n    <md-list-item class="padding-top-20">\n      <md-input-container flex>\n        <label>Privacy statement text</label>\n        <textarea ng-model="$ctrl.privacyStatement.text" ng-change="$ctrl.updateChangeDelta(\'text\', $ctrl.privacyStatement.text)" type="text" name="privacyStatementText" required ng-disabled="$ctrl.viewOnly" rows="10"></textarea>\n        <div ng-messages="$ctrl.privacyStatementFormObject.privacyStatementText.$error" md-auto-hide="false" ng-show="$ctrl.privacyStatementFormObject.privacyStatementText.$touched">\n          <div ng-message when="required">\n            <spanWhat is a privacy statement without any text?!</span>\n          </div>\n        </div>\n      </md-input-container>\n    </md-list-item>\n  </md-list>\n<input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n');
$templateCache.put('app/clients/privacy-statements-manager/privacy-statement-list-item/privacy-statement-list-item.tmpl.html','<md-card>\n  <md-card-header>\n    <md-card-avatar>\n      <md-icon md-font-icon="zmdi zmdi-delete" ng-if="$ctrl.data._deletedatelocalutc"></md-icon>\n      <md-icon md-font-icon="zmdi zmdi-shield-check" ng-style="$ctrl.iconStyle()"\n        ng-if="!$ctrl.data._deletedatelocalutc"></md-icon>\n      <md-tooltip>{{ $ctrl.data.isPrimaryStatement ? \'Account primary statement\' : \'Not the primary statement\'\n        }}</md-tooltip>\n    </md-card-avatar>\n    <md-card-header-text style="overflow: hidden;">\n      <span class="md-title" id="statement-title">{{$ctrl.data.title}}</span>\n      <span class="md-subhead">Last modified: {{$ctrl.data._lastmodifieddatelocalutc | date: \'mediumDate\'}}</span>\n    </md-card-header-text>\n    <md-button class="md-icon-button" ng-click="$ctrl.deleteStatement($event)" ng-if="$ctrl.isDev">\n      <md-icon md-font-icon="zmdi zmdi-delete" style="margin-bottom: 0px;"></md-icon>\n      <md-tooltip md-direction="top">Delete</md-tooltip>\n    </md-button>\n\n\n    <md-button class="md-icon-button" ng-click="$ctrl.archiveStatement($event)" ng-if="!$ctrl.data._deletedatelocalutc">\n      <md-icon md-font-icon="zmdi zmdi-archive" style="margin-bottom: 0px;"></md-icon>\n      <md-tooltip md-direction="top">Archive</md-tooltip>\n    </md-button>\n\n    <md-button class="md-icon-button" ng-click="$ctrl.unarchiveStatement($event)"\n      ng-if="$ctrl.data._deletedatelocalutc">\n      <md-icon md-font-library="material-icons">\n        unarchive\n      </md-icon>\n      <md-tooltip md-direction="top">Unarchive</md-tooltip>\n    </md-button>\n\n    <md-button class="md-icon-button" ng-click="$ctrl.editStatement($event)">\n      <md-icon md-font-icon="zmdi zmdi-edit"></md-icon>\n    </md-button>\n  </md-card-header>\n  <md-card-content>\n    <div layout="row" ng-show="$ctrl.data.versions.length">\n      This privacy statement has {{$ctrl.data.versions.length}} {{($ctrl.data.versions.length > 1 ) ?\n      \'versions\':\'version\'}}</br>\n      <span flex></span>\n      <md-button class="md-icon-button" ng-click="$ctrl.data.showVersionList = !$ctrl.data.showVersionList">\n        <ng-md-icon icon="{{$ctrl.data.showVersionList ? \'expand_less\' : \'expand_more\'}}"\n          style="fill: #949ca1;"></ng-md-icon>\n      </md-button>\n    </div>\n    <div ng-if="$ctrl.data.showVersionList" ng-style="{background: \'#ECF1F4\'}">\n      <md-list>\n        <md-list-item ng-repeat="version in $ctrl.data.versions">\n          <p>Modified: {{version._lastmodifieddatelocalutc | date: \'medium\'}}</p>\n          <p class="list-item-title">Title: {{version.title}}</p>\n          <md-icon ng-if="version._deletedatelocalutc" md-font-icon="zmdi zmdi-delete"\n            style="color: #CED8DD"><md-tooltip>Archived: {{version._deletedatelocalutc}}</md-tooltip></md-icon>\n          <md-button ng-click="$ctrl.viewVersionHistory($event, version._id)" class="md-secondary"> View</md-button>\n        </md-list-item>\n      </md-list>\n    </div>\n  </md-card-content>\n</md-card>');
$templateCache.put('app/clients/privacy-statements-manager/privacy-statement-page/privacy-statement-page.tmpl.html','<div layout="column">\n\n  <div layout="row" layout-align="center center">\n\n    <md-card layout="column" flex="70" flex-xs="100" flex-gt-xs="100" flex-gt-sm="80" flex-gt-md="70" flex-gt-lg="50"\n      layout-padding>\n      <md-card-content>\n        <p class="md-display-1 margin-bottom-0">\n          Privacy Statement Manager\n        </p>\n        <p class="md-headline margin-bottom-0">\n          Create, view and edit your Privacy Statements right here!\n        </p>\n        <p class="md-body-1">\n          You can set an account level Privacy Statement which all forms will use by default. Optionally,\n          you can select a form level Privacy Statement or waive it all together if you wish. These settings are managed\n          in\n          the Form Settings page. All edits to existing Privacy Statements will be recorded for GDPR audit purposes.\n        </p>\n      </md-card-content>\n    </md-card>\n\n  </div>\n\n  <div layout="column" layout-align="stretch center">\n    <p ng-if="$ctrl.activePrivacyStatements.length" class="zp-caption text-align-center">\n      Active Privacy Statements\n    </p>\n\n    <div layout="row" layout-align="center center" ng-repeat="statement in $ctrl.activePrivacyStatements">\n      <zp-privacy-statement flex="70" flex-xs="100" flex-gt-xs="100" flex-gt-sm="80" flex-gt-md="70" flex-gt-lg="50"\n        data="statement">\n      </zp-privacy-statement>\n    </div>\n\n    <p ng-if="$ctrl.archivedPrivacyStatements.length" class="zp-caption text-align-center">\n      Archived Privacy Statments\n    </p>\n\n    <div layout="row" layout-align="center center" ng-repeat="statement in $ctrl.archivedPrivacyStatements">\n      <zp-privacy-statement flex="70" flex-xs="100" flex-gt-xs="100" flex-gt-sm="80" flex-gt-md="70" flex-gt-lg="50"\n        data="statement">\n      </zp-privacy-statement>\n    </div>\n\n  </div>\n\n</div>');
$templateCache.put('app/clients/teams/detail/view.tmpl.html','<div layout="column" ng-show="vm.selectedTeam.name !== \'\'" class="main-column">\r\n\r\n  <div class="team-detail-header">\r\n\r\n    <div layout="row">\r\n\r\n      <svg width="60" height="56" viewBox="0 0 60 56" fill="none" xmlns="http://www.w3.org/2000/svg">\r\n        <ellipse cx="30" cy="9.88235" rx="10" ry="9.88235" fill="#AAB6C1" fill-opacity="0.8" />\r\n        <ellipse cx="10" cy="19.7647" rx="10" ry="9.88235" fill="#AAB6C1" fill-opacity="0.8" />\r\n        <ellipse cx="50" cy="19.7647" rx="10" ry="9.88235" fill="#AAB6C1" fill-opacity="0.8" />\r\n        <path d="M10 31.2941L0.833333 32.9412L0 56H20L19.1667 32.9412L10 31.2941Z" fill="#AAB6C1" fill-opacity="0.8" />\r\n        <path d="M30 21.4117L20.8333 23.0588L20 46.1176H40L39.1667 23.0588L30 21.4117Z" fill="#AAB6C1"\r\n          fill-opacity="0.8" />\r\n        <path d="M50 31.2941L40.8333 32.9412L40 56H60L59.1667 32.9412L50 31.2941Z" fill="#AAB6C1" fill-opacity="0.8" />\r\n      </svg>\r\n\r\n      <div flex="grow" layout="column" class="team-info">\r\n\r\n        <span flex class="name">\r\n          {{vm.selectedTeam.name}}\r\n        </span>\r\n        <span flex class="info">\r\n          {{vm.selectedTeam.subteams.length}} subteams, {{vm.selectedTeam.members.length}} users\r\n        </span>\r\n\r\n      </div>\r\n\r\n    </div>\r\n\r\n  </div>\r\n\r\n  <md-card>\r\n\r\n    <md-card-header>\r\n\r\n      <md-card-avatar id="animateSpin">\r\n\r\n        <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-accounts-list"></md-icon>\r\n\r\n      </md-card-avatar>\r\n\r\n      <md-card-header-text>\r\n\r\n        <span class="md-title">Subteams</span>\r\n        <span class="md-subhead" hide-xs hide-sm>Control the hierachy of your organisation</span>\r\n\r\n      </md-card-header-text>\r\n\r\n      <div>\r\n\r\n        <md-button class="md-button md-primary" ng-click="vm.showAddSubteamDialog($event)">\r\n          Add Team\r\n        </md-button>\r\n\r\n        <md-button class="md-icon-button" ng-click="vm.showSubTeamPanel = !vm.showSubTeamPanel">\r\n\r\n          <ng-md-icon icon="{{vm.showSubTeamPanel ? \'expand_less\' : \'expand_more\'}}" style="fill: #949ca1;">\r\n          </ng-md-icon>\r\n\r\n        </md-button>\r\n\r\n      </div>\r\n\r\n    </md-card-header>\r\n\r\n    <md-card-content ng-show="vm.showSubTeamPanel">\r\n\r\n      <div class="no-subteams" ng-if="vm.selectedTeam.subteams.length === 0">\r\n        There are currently no subteams.\r\n      </div>\r\n\r\n      <div class="subteam-list" ng-if="vm.selectedTeam.subteams.length > 0">\r\n\r\n        <div layout="row">\r\n\r\n          <md-checkbox flex="none" class="select-all-checkbox" ng-model="vm.subteamSelectAll"\r\n            ng-change="vm.selectAllSubteams({ selectAll: vm.subteamSelectAll })"\r\n            aria-label="select all subteams checkbox">\r\n          </md-checkbox>\r\n\r\n          <div flex="grow" class="light select-all">\r\n            Select All\r\n          </div>\r\n\r\n          <div flex="none">\r\n\r\n            <md-menu>\r\n\r\n              <md-button aria-label="Context menu" class="md-icon-button" ng-click="vm.openMenu($mdOpenMenu, $event)">\r\n\r\n                <md-icon md-font-icon="zmdi zmdi-more-vert">\r\n                </md-icon>\r\n\r\n                <md-tooltip md-direction="down">\r\n                  more\r\n                </md-tooltip>\r\n\r\n              </md-button>\r\n\r\n              <md-menu-content>\r\n\r\n                <md-menu-item>\r\n\r\n                  <md-button class="md-button" ng-click="vm.showRemoveSelectedTeamsDialog($event)">\r\n\r\n                    <md-icon md-font-icon="zmdi zmdi-delete" aria-label="Remove selected teams">\r\n                    </md-icon>\r\n                    Remove Selected Teams\r\n\r\n                  </md-button>\r\n\r\n                </md-menu-item>\r\n\r\n              </md-menu-content>\r\n\r\n            </md-menu>\r\n\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div ng-repeat="subteam in vm.selectedTeam.subteams" layout="row" class="subteam">\r\n\r\n          <md-checkbox ng-model="subteam.selected" aria-label="select subteam checkbox">\r\n          </md-checkbox>\r\n\r\n          <div flex="grow" class="subteam-name">\r\n            {{subteam.name}}\r\n          </div>\r\n\r\n        </div>\r\n\r\n      </div>\r\n\r\n    </md-card-content>\r\n\r\n  </md-card>\r\n\r\n  <md-card>\r\n\r\n    <md-card-header>\r\n\r\n      <md-card-avatar id="animateSpin">\r\n\r\n        <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-accounts">\r\n        </md-icon>\r\n\r\n      </md-card-avatar>\r\n\r\n      <md-card-header-text>\r\n\r\n        <span class="md-title">\r\n          Users\r\n        </span>\r\n        <span class="md-subhead" hide-xs hide-sm>\r\n          Control who is part of this team\r\n        </span>\r\n\r\n      </md-card-header-text>\r\n\r\n      <div>\r\n\r\n        <md-button class="md-button md-primary" ng-click="vm.showAddUsersDialog($event)">\r\n          Add Users\r\n        </md-button>\r\n\r\n        <md-button class="md-icon-button" ng-click="vm.showUserPanel = !vm.showUserPanel">\r\n          <ng-md-icon icon="{{vm.showUserPanel ? \'expand_less\' : \'expand_more\'}}" style="fill: #949ca1;">\r\n          </ng-md-icon>\r\n        </md-button>\r\n\r\n      </div>\r\n\r\n    </md-card-header>\r\n\r\n    <md-card-content ng-show="vm.showUserPanel">\r\n\r\n      <div class="no-users" ng-if="vm.selectedTeam.members.length === 0">\r\n        There are currently no users.\r\n      </div>\r\n\r\n      <div class="user-list" ng-if="vm.selectedTeam.members.length > 0">\r\n\r\n        <div class="select-all" layout="column">\r\n\r\n          <div layout="row" class="header">\r\n\r\n            <div flex="grow" flex-gt-sm="30" class="user">\r\n            </div>\r\n\r\n            <div class="checkbox-column private-leads">\r\n              Private Leads <u>?</u>\r\n\r\n              <md-tooltip md-direction="top">\r\n                Private Leads will hide leads from other team members\r\n              </md-tooltip>\r\n\r\n            </div>\r\n\r\n            <div class="checkbox-column">\r\n              Manager\r\n            </div>\r\n\r\n          </div>\r\n\r\n          <div layout="row" class="values">\r\n\r\n            <md-checkbox flex="none" class="select-all-checkbox" ng-model="vm.userSelectAll"\r\n              ng-change="vm.setAllMembersFlag({ flag: \'selected\', value: vm.userSelectAll })"\r\n              aria-label="select all users checkbox">\r\n            </md-checkbox>\r\n\r\n            <div flex="grow" flex-gt-sm="30" class="light">\r\n              Select All\r\n            </div>\r\n\r\n            <div class="checkbox-column">\r\n\r\n              <md-checkbox aria-label="private select all" ng-model="vm.privateSelectAll"\r\n                ng-change="vm.setAllMembersFlag({ flag: \'private\', value: vm.privateSelectAll })">\r\n              </md-checkbox>\r\n\r\n            </div>\r\n\r\n            <div class="checkbox-column">\r\n\r\n              <md-checkbox aria-label="manager select all" ng-model="vm.managerSelectAll"\r\n                ng-change="vm.setAllMembersFlag({ flag: \'manager\', value: vm.managerSelectAll })">\r\n              </md-checkbox>\r\n\r\n            </div>\r\n\r\n            <md-menu class="more-users">\r\n\r\n              <md-button aria-label="Context menu" class="md-icon-button" ng-click="vm.openMenu($mdOpenMenu, $event)">\r\n\r\n                <md-icon md-font-icon="zmdi zmdi-more-vert">\r\n                </md-icon>\r\n\r\n                <md-tooltip md-direction="down">\r\n                  more\r\n                </md-tooltip>\r\n\r\n              </md-button>\r\n\r\n              <md-menu-content>\r\n\r\n                <md-menu-item>\r\n\r\n                  <md-button class="md-button" ng-click="vm.removeSelectedUsers()">\r\n\r\n                    <md-icon md-font-icon="zmdi zmdi-delete" aria-label="Remove selected users">\r\n                    </md-icon>\r\n                    Remove selected users\r\n\r\n                  </md-button>\r\n\r\n                </md-menu-item>\r\n\r\n              </md-menu-content>\r\n\r\n            </md-menu>\r\n\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <ng-container ng-repeat="member in vm.selectedTeam.members">\r\n\r\n          <div ng-if="!member.staffUser || vm.isZuantAdmin" layout="row" class="user">\r\n\r\n            <md-checkbox ng-model="member.selected" aria-label="select user checkbox">\r\n            </md-checkbox>\r\n\r\n            <div flex="grow" flex-gt-sm="30" class="member-name">\r\n              {{member.name}}\r\n            </div>\r\n\r\n            <div class="checkbox-column">\r\n\r\n              <md-checkbox aria-label="private" ng-model="member.private" ng-change="vm.updateDirty()">\r\n              </md-checkbox>\r\n\r\n            </div>\r\n\r\n            <div class="checkbox-column">\r\n\r\n              <md-checkbox aria-label="manager" ng-model="member.manager" ng-change="vm.updateDirty()">\r\n              </md-checkbox>\r\n\r\n            </div>\r\n\r\n          </div>\r\n\r\n        </ng-container>\r\n\r\n      </div>\r\n\r\n    </md-card-content>\r\n\r\n  </md-card>\r\n\r\n</div>\r\n\r\n<div layout="column" flex="60" ng-show="vm.selectedTeam.name == \'\'" class="no-selection">\r\n\r\n  Select a team from the left pane to view and make changes to it\r\n  <img ng-src="{{\'/images/pngs/arrows/squiggle_arr_right.png\' | cdnAssets}}" class="squiggle" show-gt-sm hide />\r\n\r\n</div>');
$templateCache.put('app/clients/teams/fab/fab.tmpl.html','<md-fab-speed-dial md-open="vm.isOpen" md-direction="up" ng-class="\'md-fling\'" class="md-fab md-fab-bottom-right"\n  ng-if="vm.selectedTeam.name !== \'\'">\n\n  <md-fab-trigger>\n\n    <md-button aria-label="menu" class="md-fab md-accent">\n\n      <md-tooltip md-direction="left">\n        Team options\n      </md-tooltip>\n\n      <md-icon md-font-icon="zmdi zmdi-more-vert">\n      </md-icon>\n\n    </md-button>\n\n  </md-fab-trigger>\n\n  <md-fab-actions>\n\n    <md-button aria-label="Remove team" class="md-fab md-raised md-mini" ng-click="vm.showRemoveTeamDialog($event)">\n\n      <md-tooltip md-direction="left">\n        Remove team\n      </md-tooltip>\n\n      <md-icon md-font-icon="zmdi zmdi-delete" aria-label="Remove team" style="color: rgba(0,0,0,0.54);">\n      </md-icon>\n\n    </md-button>\n\n    <md-button aria-label="Edit team" class="md-fab md-raised md-mini" ng-click="vm.showEditTeamDialog($event)">\n\n      <md-tooltip md-direction="left">\n        Edit team\n      </md-tooltip>\n\n      <md-icon md-font-icon="zmdi zmdi-edit" aria-label="Edit team" style="color: rgba(0,0,0,0.54);">\n      </md-icon>\n\n    </md-button>\n\n  </md-fab-actions>\n\n</md-fab-speed-dial>\n\n<zp-save-button isfab="\'true\'" label="\'Save Team\'" save="vm.save()" disabled="vm.singleFormFactory.saveBtnDisabled"\n  isdirty="vm.selectedTeam.dirty === true" ng-show="vm.selectedTeam.dirty === true">\n</zp-save-button>');
$templateCache.put('app/clients/teams/tree/view.tmpl.html','<md-card flex layout="column">\r\n\r\n  <div layout="row" class="filter-container">\r\n\r\n    <md-icon md-font-icon="zmdi zmdi-search" flex="initial" class="filter-icon">\r\n    </md-icon>\r\n\r\n    <md-input-container flex="grow">\r\n\r\n      <label>Filter teams</label>\r\n      <input ng-model="vm.searchValue" aria-label="Teams filter" ng-keyup="vm.filterTeams()" />\r\n\r\n    </md-input-container>\r\n\r\n  </div>\r\n\r\n  <div>\r\n\r\n    <md-button class="md-button md-raised" ng-click="vm.showAddTeamDialog($event)" aria-label="Create new team">\r\n      Create New Team\r\n    </md-button>\r\n\r\n  </div>\r\n\r\n  <div class="team-container" id="team-container">\r\n\r\n    <team-tree-element teams="vm.teams" select-team="vm.selectTeam({ team: team })" level="0" indexes-to-miss=""\r\n      toggle-chevron="vm.toggleChevron({ team: team, event: event })">\r\n    </team-tree-element>\r\n\r\n  </div>\r\n\r\n</md-card>');
$templateCache.put('app/clients/theming/cloud-theme-card/cloud-theme.tmpl.html','<div class="section-headline-container" layout="column">\n  <span class="md-title">Cloud Theme Settings</span>\n  <span class="md-subhead">Set a dashboard background image and pick a color palette for Cloud</span>\n</div>\n\n<md-list>\n  <md-subheader>Cloud Palette</md-subheader>\n  <md-list-item layout="column" layout-align="center center" flex>\n    <div layout="row" layout-wrap layout-align="center center">\n      <md-button ng-repeat="color in $ctrl.colors" flex-gt-md="15" flex="30" md-colors="{background: \'{{color}}\'}"\n        md-colors-watch="false" ng-disabled="$ctrl.primary === color && !$ctrl.isPrimary"\n        ng-click="$ctrl.selectTheme(color)">\n        {{color}}\n      </md-button>\n    </div>\n    <theme-preview primary="$ctrl.primary" accent="$ctrl.accent" layout-margin layout-fill></theme-preview>\n  </md-list-item>\n</md-list>\n\n<md-subheader>Cloud Background Image</md-subheader>\n<div class="theme-preview-container" layout-align="center center" layout="row" layout-margin flex>\n\n  <zp-theme-Device id="iMacPreview" device-type="imac" theme="$ctrl.theme"\n    client-logo-obj="$ctrl.clientLogoObj"></zp-theme-Device>\n\n  <div layout="column" layout-align="center center" flex>\n\n    <p class="md-subhead">Cloud Dashboard Background</p>\n\n    <zp-image-info-table metadata="$ctrl.theme.images.cloudDashboardBackgroundImage.metadata"\n      ng-hide="!$ctrl.theme.images.cloudDashboardBackgroundImage.metadata.title" layout="row" layout-fill\n      layout-align="center center">\n    </zp-image-info-table>\n\n    <zp-image-control-buttons image-obj="$ctrl.theme.images.cloudDashboardBackgroundImage"\n      open-select-dialog="$ctrl.openImageSelectDialog({$event: $event, imageObj: imageObj})" layout="row" layout-fill\n      layout-align="center center">\n    </zp-image-control-buttons>\n\n    <p class="md-caption zp-caption margin-bottom-0">Recommended Image Size</p>\n    <p class="md-caption zp-caption">2880px x 1800px (4:3 Landscape)</p>\n\n  </div>\n</div>');
$templateCache.put('app/clients/theming/cloud-theme-card/theme-preview.tmpl.html','<div layout="column">\n  <div md-colors="{background: \'{{primary}}-500\'}"  md-justified="column" class="primary line">\n    <span>Primary - {{primary}}</span>\n    <div md-justified >\n      <span>500</span>\n      <span>{{getColor(primary + \'-500\')}}</span>\n    </div>\n  </div>\n  <div md-colors="{background: \'{{primary}}-700\'}" md-justified class="line" >\n    <span>700</span>\n    <span>{{getColor(primary + \'-700\')}}</span>\n  </div>\n  <div md-colors="{background: \'{{primary}}-800\'}" md-justified class="line" >\n    <span>800</span>\n    <span>{{getColor(primary + \'-800\')}}</span>\n  </div>\n  <div md-colors="{background: \'{{accent}}-A200\'}" md-justified="column" class="accent line">\n    <span>Accent - {{accent}}</span>\n    <div md-justified>\n      <span>A200</span>\n      <span>{{getColor(accent + \'-A200\')}}</span>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('app/clients/theming/fab-add/fab.tmpl.html','<zp-helper-arrow ermission ermission-only="$ctrl.permissions.boltOns.theming.edit" help-message="Create a new theme here" show-condition="$ctrl.themingFactoryData.showAddThemeHelperArrow"></zp-helper-arrow>\n<zp-fab-add permission permission-only="$ctrl.permissions.boltOns.theming.edit" pulse-class-check="!$ctrl.data.items.length" dialog-config="$ctrl.metadata.fabAddDialogConfig"></zp-fab-add>\n');
$templateCache.put('app/clients/theming/fab-save/fab.tmpl.html','<zp-save-button isfab="\'true\'" label="\'save theme fab\'" isdirty="$ctrl.changeDelta.isDirty()" save="$ctrl.save()" disabled="$ctrl.disableSaveButton.saveBtnDisabled" ng-show="$ctrl.changeDelta.isDirty()"></zp-save-button>\n');
$templateCache.put('app/clients/theming/info/custom-skins-information-dialog.tmpl.html','<md-dialog aria-label="Custom Skins Information Dialog" flex="80">\n  <md-toolbar aria-label="Custom Skins Information dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">Custom Skins more info</p>\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-dialog-content layout-padding>\n    <p class="md-headline">Homescreen Backgrounds</p>\n    <p class="md-subhead">Specify up to 5 different background images; 4 for iOS (iPhone/iPod 5.5 inch Portrait, 6.7\n      inch iPhone Portrait, iPad Portrait, iPad\n      Landscape) and 1 for the Cloud dashboard.</p>\n    <img ng-src="{{\'/images/pngs/devices/devices-row.png\' | cdnAssets}}" flex="80" flex-offset="10" />\n    <p class="md-body-1">Tip: If for some reason an image is missing or you just want to use 1 or 2, the app will fall\n      back to which ever is available</p>\n\n    <p class="md-headline">Homescreen Block Colors</p>\n    <p class="md-subhead">Once in the editor you will also find the ability to change the color of the blocks on the\n      homescreen. The color you set the block will change the toolbars and buttons within that feature to your selected\n      color.</p>\n    <img ng-src="{{\'/images/pngs/placeholders/blocks/block-colors-explained.png\' | cdnAssets}}" flex="60"\n      flex-offset="20" />\n    <p class="md-body-1">You can have multiple themes configured and toggle which theme is the primary (active) theme\n      for the account.</p>\n    <md-dialog-actions layout="row">\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()" aria-label="Close info dialog">\n        Done\n      </md-button>\n    </md-dialog-actions>\n  </md-dialog-content>\n</md-dialog>');
$templateCache.put('app/clients/theming/theming-components/zp-image-control-buttons.tmpl.html','<div layout="column" flex="60">\n  <md-button class="md-raised md-accent" ng-click="$ctrl.openSelectDialog({$event: $event, imageObj: $ctrl.imageObj })">\n    <md-tooltip md-direction="top">Select image</md-tooltip>\n    <md-icon md-font-icon="zmdi zmdi-collection-folder-image"></md-icon>\n    Select Image\n  </md-button>\n</div>');
$templateCache.put('app/clients/theming/theming-components/zp-image-info-table.tmpl.html','<div class="image-info-container" flex="80" layout="column" layout-align="start center">\n\n  <div class="image-info-row" layout="row" layout-align="start center" layout-fill ng-if="$ctrl.metadata.title">\n    <span class="md-caption zuantTitanium1">Title: </span>\n    <span class="value">{{$ctrl.metadata.title}}</span>\n  </div>\n  <div class="image-info-row" layout="row" layout-align="start center" layout-fill ng-if="$ctrl.metadata.filename">\n    <span class="md-caption zuantTitanium1">Filename: </span>\n    <span class="value">{{$ctrl.metadata.filename}}</span>\n  </div>\n  <div class="image-info-row" layout="row" layout-align="start center" layout-fill ng-if="$ctrl.metadata.size">\n    <span class="md-caption zuantTitanium1">File size: </span>\n    <span class="value">{{$ctrl.metadata.size | zpBytes}}</span>\n  </div>\n  <div class="image-info-row" layout="row" layout-align="start center" layout-fill ng-if="$ctrl.metadata.type">\n    <span class="md-caption zuantTitanium1">File type: </span>\n    <span class="value">{{$ctrl.metadata.type}}</span>\n  </div>\n  <div class="image-info-row" layout="row" layout-align="start center" layout-fill\n    ng-if="$ctrl.metadata._lastmodifieddatelocalutc">\n    <span class="md-caption zuantTitanium1">Last modified: </span>\n    <span class="value">{{$ctrl.metadata._lastmodifieddatelocalutc | date: \'short\'}}</span>\n  </div>\n  <div class="image-info-row" layout="row" layout-align="start center" layout-fill ng-if="$ctrl.metadata.height">\n    <span class="md-caption zuantTitanium1">Image height: </span>\n    <span class="value">{{$ctrl.metadata.height}}px</span>\n  </div>\n  <div class="image-info-row" layout="row" layout-align="start center" layout-fill ng-if="$ctrl.metadata.width">\n    <span class="md-caption zuantTitanium1">Image width: </span>\n    <span class="value">{{$ctrl.metadata.width}}px</span>\n  </div>\n</div>');
$templateCache.put('app/clients/theming/theming-components/zp-main-menu-configurator.tmpl.html','<md-list id="blocks-color-picker-list">\n  <md-list-item>\n    <p>Show logo on homescreen<br>\n      <span class="hint" ng-show="$ctrl.showHints" md-colors="::{color: \'accent-500\', \'border-color\': \'primary-300\'}"\n        style="border-left: 2px solid; padding-left: 5px;"><span class="md-caption">Hint:</span> You may wish to hide\n        the logo if your backround image has one baked in</span>\n    </p>\n    <md-switch ng-model="$ctrl.theme.showLogo"\n      ng-change="$ctrl.updateChangeDelta({prop1:\'showLogo\', prop2: null,  val: $ctrl.theme.showLogo })"\n      aria-label="Show logo" ng-true-value="true" ng-false-value="false"></md-switch>\n  </md-list-item>\n  <md-subheader>Block colors</md-subheader>\n  <md-list-item style="margin-top: 20px;">\n    <div ng-model="$ctrl.theme.blocks.formsColor"\n      ng-change="$ctrl.updateChangeDelta({prop1:\'blocks\', prop2: \'formsColor\', val: $ctrl.theme.blocks.formsColor})"\n      md-color-picker label="Forms block color" md-color-alpha-channel="false" md-color-sliders="true"\n      md-color-rgb="true" md-color-hsl="false" md-color-history="false" flex></div>\n    <md-button class="md-icon-button">\n      <md-tooltip>Sync blocks to this color</md-tooltip>\n      <md-icon md-font-icon="zmdi zmdi-format-color-fill"\n        ng-click="$ctrl.syncBlockColors({color: $ctrl.theme.blocks.formsColor})"></md-icon>\n    </md-button>\n  </md-list-item>\n  <md-list-item>\n    <div ng-model="$ctrl.theme.blocks.contactsColor"\n      ng-change="$ctrl.updateChangeDelta({prop1: \'blocks\', prop2: \'contactsColor\', val: $ctrl.theme.blocks.contactsColor})"\n      md-color-picker label="Contacts block color" md-color-alpha-channel="false" md-color-sliders="false"\n      md-color-rgb="false" md-color-hsl="false" md-color-history="false" flex></div>\n    <md-button class="md-icon-button">\n      <md-tooltip>Sync blocks to this color</md-tooltip>\n      <md-icon md-font-icon="zmdi zmdi-format-color-fill"\n        ng-click="$ctrl.syncBlockColors({color: $ctrl.theme.blocks.contactsColor})"></md-icon>\n    </md-button>\n  </md-list-item>\n  <md-list-item>\n    <div ng-model="$ctrl.theme.blocks.imagesColor"\n      ng-change="$ctrl.updateChangeDelta({prop1: \'blocks\', prop2: \'imagesColor\', val:$ctrl.theme.blocks.imagesColor})"\n      md-color-picker label="Images block color" md-color-alpha-channel="false" md-color-sliders="false"\n      md-color-rgb="false" md-color-hsl="false" md-color-history="false" flex></div>\n    <md-button class="md-icon-button">\n      <md-tooltip>Sync blocks to this color</md-tooltip>\n      <md-icon md-font-icon="zmdi zmdi-format-color-fill"\n        ng-click="$ctrl.syncBlockColors({color: $ctrl.theme.blocks.imagesColor})"></md-icon>\n    </md-button>\n  </md-list-item>\n  <md-list-item>\n    <div ng-model="$ctrl.theme.blocks.artefactsColor"\n      ng-change="$ctrl.updateChangeDelta({prop1: \'blocks\', prop2: \'artefactsColor\', val:$ctrl.theme.blocks.artefactsColor})"\n      md-color-picker label="Artefacts block color" md-color-alpha-channel="false" md-color-sliders="false"\n      md-color-rgb="false" md-color-hsl="false" md-color-history="false" flex></div>\n    <md-button class="md-icon-button">\n      <md-tooltip>Sync blocks to this color</md-tooltip>\n      <md-icon md-font-icon="zmdi zmdi-format-color-fill"\n        ng-click="$ctrl.syncBlockColors({color: $ctrl.theme.blocks.artefactsColor})"></md-icon>\n    </md-button>\n  </md-list-item>\n  <md-list-item>\n    <div ng-model="$ctrl.theme.blocks.showroomColor"\n      ng-change="$ctrl.updateChangeDelta({prop1: \'blocks\', prop2: \'showroomColor\', val: $ctrl.theme.blocks.showroomColor})"\n      md-color-picker label="Showroom block color" md-color-alpha-channel="false" md-color-sliders="false"\n      md-color-rgb="false" md-color-hsl="false" md-color-history="false" flex></div>\n    <md-button class="md-icon-button">\n      <md-tooltip>Sync blocks to this color</md-tooltip>\n      <md-icon md-font-icon="zmdi zmdi-format-color-fill"\n        ng-click="$ctrl.syncBlockColors({color: $ctrl.theme.blocks.showroomColor})"></md-icon>\n    </md-button>\n  </md-list-item>\n  <md-subheader>Background transparency %<br>\n    <span class="hint" ng-show="$ctrl.showHints" md-colors="::{color: \'accent-500\', \'border-color\': \'primary-300\'}"\n      style="border-left: 2px solid; padding-left: 5px;"><span class="md-caption">Hint:</span> For fine tuning the look\n      of the homescreen</span>\n  </md-subheader>\n  <md-list-item>\n    <span class="md-body-1" flex="30">Blocks</span>\n    <md-slider-container flex flex-offset-gt-md="10">\n      <md-slider aria-label="blocks transparency" flex ng-model="$ctrl.theme.blocks.mainMenuBlocksAlpha"\n        ng-change="$ctrl.updateChangeDelta({prop1:\'blocks\', prop2: \'mainMenuBlocksAlpha\', val: $ctrl.theme.blocks.mainMenuBlocksAlpha})"\n        min="0" max="1" step=".1">\n      </md-slider>\n      <md-input-container>\n        <input flex type="number" ng-model="$ctrl.theme.blocks.mainMenuBlocksAlpha"\n          ng-change="$ctrl.updateChangeDelta({prop1:\'blocks\', prop2: \'mainMenuBlocksAlpha\', val: $ctrl.theme.blocks.mainMenuBlocksAlpha})"\n          aria-label="blocks transparency">\n      </md-input-container>\n    </md-slider-container>\n  </md-list-item>\n  <md-list-item>\n    <span class="md-body-1" flex="30">Blocks container</span>\n    <md-slider-container flex flex-offset-gt-md="10">\n      <md-slider aria-label="blocks container transparency" flex ng-model="$ctrl.theme.blocks.mainMenuBlocksHolderAlpha"\n        ng-change="$ctrl.updateChangeDelta({prop1:\'blocks\', prop2: \'mainMenuBlocksHolderAlpha\', val:$ctrl.theme.blocks.mainMenuBlocksHolderAlpha})"\n        min="0" max="1" step=".1">\n      </md-slider>\n      <md-input-container>\n        <input flex type="number" ng-model="$ctrl.theme.blocks.mainMenuBlocksHolderAlpha"\n          ng-change="$ctrl.updateChangeDelta({prop1:\'blocks\', prop2: \'mainMenuBlocksHolderAlpha\', val: $ctrl.theme.blocks.mainMenuBlocksHolderAlpha})"\n          aria-label="blocks container transparency">\n      </md-input-container>\n    </md-slider-container>\n  </md-list-item>\n</md-list>');
$templateCache.put('app/clients/theming/theming-components/zp-theme-device.tmpl.html','<ng-container ng-switch="$ctrl.deviceType">\n\n    <div class="imac" ng-switch-when="imac">\n        <svg ng-attr-width="{{$ctrl.width}}" ng-attr-height="{{$ctrl.height}}" viewBox="0 0 261 228" version="1.1"\n            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n            <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->\n            <title>iMac</title>\n            <desc>Created with Sketch.</desc>\n            <defs></defs>\n            <g id="UX-Ideas" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n                <g id="THEME-ENABLED-(PRESENT)" transform="translate(-985.000000, -1257.000000)">\n                    <g id="ZuantDefaultTheme" transform="translate(961.000000, 1257.000000)">\n                        <g id="iMac" transform="translate(24.000000, 0.000000)">\n                            <g id="device">\n                                <path\n                                    d="M85.5294987,227.871287 L173.894498,227.871287 C175.182877,227.871287 176.460154,226.748795 176.460154,225.416959 L176.460154,221.734875 C176.460154,221.029469 176.006161,220.634325 175.393877,220.522654 C175.17135,220.482068 174.948047,220.480338 174.73827,220.500513 C174.688316,220.505317 174.799932,221.72777 174.799932,221.72777 C174.960902,221.711494 175.088281,221.712482 175.194877,221.731923 C175.311203,221.753139 175.294377,225.416959 175.294377,225.416959 C175.294377,226.017001 174.580913,226.644005 173.894498,226.644005 L85.5294987,226.644005 C84.9026406,226.644005 84.3637211,226.084057 84.3637211,225.416959 L83.1979434,225.416959 C83.1979434,226.765501 84.2622025,227.871287 85.5294987,227.871287 Z"\n                                    id="Path" fill="#949CA1" fill-rule="nonzero"></path>\n                                <path\n                                    d="M174.128599,226.64358 L85.7635993,226.64358 C85.0771843,226.64358 84.3637211,226.01636 84.3637211,225.41611 L84.3637211,221.732754 C84.5698165,221.710352 84.6971955,221.709365 84.8137689,221.72058 C84.8388675,221.722995 85.0350539,220.512155 85.0350539,220.512155 C84.7100511,220.477782 84.4867475,220.479514 84.2642211,220.520113 C83.6519367,220.631823 83.1979434,221.027103 83.1979434,221.732754 L83.1979434,225.41611 C83.1979434,226.748406 84.4752205,227.871287 85.7635993,227.871287 L174.128599,227.871287 C175.395895,227.871287 176.460154,226.765119 176.460154,225.41611 L175.294377,225.41611 C175.294377,226.083439 174.755457,226.64358 174.128599,226.64358 Z"\n                                    id="Path" fill="#949CA1" fill-rule="nonzero"></path>\n                                <path\n                                    d="M101.728798,185.945386 C101.723867,186.226676 101.71658,186.553252 101.706478,186.921331 C101.677591,187.973968 101.631972,189.147306 101.565974,190.41105 C101.37747,194.020568 101.063787,197.629533 100.596222,200.994308 C99.9108986,205.926163 98.9524677,209.896141 97.693788,212.534953 C97.3910182,213.169708 95.8566658,214.317073 93.4770871,215.709232 C92.829876,216.087879 92.1270597,216.48146 91.3771529,216.88668 C89.9296465,217.668855 88.3771779,218.457225 86.8245043,219.212012 C86.2809233,219.476258 85.7762411,219.717383 85.3234894,219.930459 C85.0522909,220.058091 84.8590137,220.147854 84.7566749,220.194827 C82.4309324,221.30535 82.7744721,222.837161 85.3427033,222.837161 L174.32859,222.837161 C176.890247,222.837161 177.216716,221.316801 174.90624,220.223529 C174.7928,220.172646 174.599773,220.085153 174.328849,219.960495 C173.876463,219.752342 173.372164,219.516311 172.828987,219.257067 C171.277497,218.516582 169.726231,217.738959 168.279995,216.961897 C167.396157,216.487012 166.578687,216.026559 165.841267,215.585594 C163.669173,214.286716 162.27783,213.197887 161.977492,212.543044 C160.782256,209.93701 159.974603,205.921367 159.507939,200.894338 C159.06818,196.157133 158.972527,191.152295 159.071707,186.756815 C159.083897,186.216589 159.096058,185.83381 159.104104,185.632204 L157.93422,185.584627 C157.925907,185.792921 157.913528,186.182563 157.901177,186.729903 C157.801052,191.167245 157.89751,196.21414 158.342213,201.004603 C158.820316,206.15486 159.650497,210.282515 160.914999,213.039574 C161.35647,214.002135 162.847897,215.169287 165.244516,216.602427 C165.9984,217.053237 166.831164,217.522306 167.729859,218.005174 C169.194239,218.791983 170.76149,219.57762 172.328518,220.32552 C172.876821,220.587211 173.386041,220.825545 173.843222,221.035905 C174.118039,221.162354 174.314826,221.25155 174.420611,221.298864 C174.791663,221.474586 175.069989,221.644119 175.228774,221.783977 C175.328512,221.55813 175.351207,221.541262 175.280315,221.56191 C175.07812,221.620799 174.753773,221.655296 174.32859,221.655296 L85.3427033,221.655296 C84.9160789,221.655296 84.5898327,221.620104 84.3855611,221.559983 C84.309952,221.53773 84.3283594,221.55146 84.3554978,221.672467 C84.5874511,221.621838 84.8659001,221.450035 85.2493394,221.266933 C85.3469327,221.222212 85.5435642,221.130891 85.8182379,221.001624 C86.2752733,220.786532 86.7843537,220.543305 87.3325172,220.276832 C88.8991134,219.515277 90.4659146,218.719629 91.9297267,217.928642 C92.6906874,217.517449 93.4048854,217.117494 94.0641995,216.731766 C96.6835717,215.199318 98.2983729,213.991794 98.7487107,213.047665 C100.071766,210.273889 101.05495,206.20138 101.755705,201.158478 C102.228506,197.756013 102.545031,194.114364 102.735184,190.473267 C102.801715,189.199296 102.847715,188.016184 102.876863,186.954058 C102.887074,186.581971 102.894449,186.25146 102.899448,185.966296 C102.902458,185.794607 102.904009,185.675817 102.904559,185.613698 L101.733772,185.603133 C101.733252,185.661857 101.731747,185.777202 101.728798,185.945386 Z"\n                                    id="Path" fill="#949CA1"></path>\n                                <path\n                                    d="M260.837481,157.314522 L260.837481,177.054539 C260.837481,181.864721 256.907815,185.765981 252.064226,185.765981 L8.93577389,185.765981 C4.09129228,185.765981 0.16251928,181.864087 0.16251928,177.054539 L0.16251928,157.314522 L260.837481,157.314522 Z"\n                                    id="Combined-Shape" fill="#CED8DD" fill-rule="nonzero"></path>\n                                <path\n                                    d="M8.77325461,0.783145814 L251.901707,0.783145814 C256.746188,0.783145814 260.674961,4.08959344 260.674961,8.16518301 L260.674961,149.840266 C260.674961,153.916393 260.674961,157.222304 260.674961,157.222304 L7.7101933e-13,157.222304 C7.7101933e-13,157.222304 5.68434189e-13,153.915856 5.68434189e-13,149.840266 L5.68434189e-13,8.16518301 C5.68434189e-13,4.08905595 3.92966575,0.783145814 8.77325461,0.783145814 Z M8,13 L8,148 L252,148 L252,13 L8,13 Z"\n                                    id="Combined-Shape" fill="#3C3C3C" fill-rule="nonzero"></path>\n                                <path\n                                    d="M132.572306,165.619143 C133.106313,164.951963 133.4647,164.024885 133.36668,163.098863 C132.600385,163.13003 131.66868,163.629226 131.120378,164.293764 C130.628234,164.885932 130.196842,165.828858 130.311199,166.734278 C131.166836,166.802951 132.040851,166.285266 132.572306,165.619143 M135.481777,176.911009 C134.848218,177.872952 134.187601,178.831725 133.148176,178.850742 C132.129172,178.871344 131.800905,178.225294 130.63385,178.225294 C129.467304,178.225294 129.102791,178.831725 128.136881,178.871344 C127.133192,178.912019 126.372002,177.832277 125.730275,176.875088 C124.419762,174.916866 123.421178,171.340087 124.762323,168.928099 C125.431108,167.728972 126.622159,166.971462 127.916845,166.95086 C128.903176,166.933956 129.831307,167.636 130.433214,167.636 C131.035631,167.636 132.163377,166.787103 133.351364,166.91177 C133.846572,166.935013 135.242342,167.119372 136.139842,168.476446 C136.065816,168.525045 134.474005,169.482233 134.491363,171.478489 C134.511273,173.865121 136.515076,174.659609 136.53856,174.669117 C136.519671,174.722999 136.217441,175.801156 135.481777,176.911009 Z"\n                                    id="apple_logo" fill="#FFFFFF"></path>\n                                <polygon id="Line" fill="#535353" fill-rule="nonzero"\n                                    points="0.175929307 156.722304 0.175929307 157.593413 260.866531 157.593413 260.866531 156.722304">\n                                </polygon>\n                                <path\n                                    d="M130.332262,8.04777667 C130.980735,8.04777667 131.506427,7.52187716 131.506427,6.87314723 C131.506427,6.2244173 130.980735,5.69851778 130.332262,5.69851778 C129.683789,5.69851778 129.158098,6.2244173 129.158098,6.87314723 C129.158098,7.52187716 129.683789,8.04777667 130.332262,8.04777667 Z"\n                                    id="Oval" fill="#676D71"></path>\n                            </g>\n                            <g id="blocks" transform="translate(66.965246, 72.820200)" fill="#CED8DD">\n                                <rect id="Rectangle-5"\n                                    transform="translate(11.661189, 7.469243) rotate(-270.000000) translate(-11.661189, -7.469243) "\n                                    x="4.19490218" y="-4.06664163" width="14.932573" height="23.071769"></rect>\n                                <rect id="Rectangle-5-Copy"\n                                    transform="translate(37.157333, 7.469243) rotate(-270.000000) translate(-37.157333, -7.469243) "\n                                    x="29.6910461" y="-4.06664163" width="14.932573" height="23.071769"></rect>\n                                <rect id="Rectangle-5-Copy-2"\n                                    transform="translate(62.318001, 7.469243) rotate(-270.000000) translate(-62.318001, -7.469243) "\n                                    x="54.8517145" y="-4.06664163" width="14.932573" height="23.071769"></rect>\n                                <rect id="Rectangle-5-Copy-3"\n                                    transform="translate(87.814145, 7.469243) rotate(-270.000000) translate(-87.814145, -7.469243) "\n                                    x="80.3478585" y="-4.06664163" width="14.932573" height="23.071769"></rect>\n                                <rect id="Rectangle-5-Copy-4"\n                                    transform="translate(113.310289, 7.469243) rotate(-270.000000) translate(-113.310289, -7.469243) "\n                                    x="105.844002" y="-4.06664163" width="14.932573" height="23.071769"></rect>\n                            </g>\n                            <g id="LOGO" ng-if="!$ctrl.clientLogo" transform="translate(111.000000, 38.000000)">\n                                <polygon id="Shape" fill="#949CA1"\n                                    points="38.4155844 0 38.4155844 0.362800566 36.3677967 0.362800566 36.3677967 5.64356436 35.9504132 5.64356436 35.9504132 0.362800566 33.8961039 0.362800566 33.8961039 0">\n                                </polygon>\n                                <polygon id="Shape" fill="#949CA1"\n                                    points="29.3766234 0 29.3766234 5.64356436 29.0529471 5.64356436 25.2407592 0.698727016 25.2407592 5.61669024 24.8571429 5.61669024 24.8571429 0 25.1808192 0 28.993007 4.91796322 28.993007 0 29.3766234 0">\n                                </polygon>\n                                <polygon id="Shape" fill="#949CA1"\n                                    points="19.9002034 3.33150198 18.6324083 0.712941424 17.3855109 3.33150198 17.2113632 3.6913042 16.2918635 5.61691234 15.8181818 5.61691234 18.507022 0 18.7577946 0 21.4675325 5.64356436 20.9938508 5.64356436 20.074351 3.71795621">\n                                </polygon>\n                                <path\n                                    d="M12.0153618,-3.55271368e-15 L12.4285714,-3.55271368e-15 L12.4285714,3.03424578 C12.4285714,3.86418171 12.2219666,4.508212 11.808757,4.95305766 C11.3697217,5.40454281 10.8402968,5.64356436 10.1688312,5.64356436 C9.49736549,5.64356436 8.94857143,5.43110076 8.52890538,4.97961561 C8.11569573,4.52813046 7.90909091,3.91065812 7.90909091,3.15375655 L7.90909091,-3.55271368e-15 L8.32230056,-3.55271368e-15 L8.32230056,3.13383809 C8.32230056,3.79778684 8.48371058,4.32230635 8.83235622,4.70075713 C9.18100186,5.07920792 9.61358071,5.27175306 10.1688312,5.27175306 C10.7240816,5.27175306 11.1631169,5.07920792 11.5053061,4.70075713 C11.8474954,4.32230635 12.0153618,3.77786838 12.0153618,3.08736168 L12.0153618,-3.55271368e-15 L12.0153618,-3.55271368e-15 L12.0153618,-3.55271368e-15 Z"\n                                    id="Shape" fill="#949CA1"></path>\n                                <polygon id="Shape" fill="#949CA1"\n                                    points="0 0 0 0.356082037 4.04274207 0.356082037 0 5.30091938 0 5.64356436 4.51948052 5.64356436 4.51948052 5.28076379 0.52123404 5.28076379 4.51948052 0.33592645 4.51948052 0">\n                                </polygon>\n                                <path\n                                    d="M34.1728766,9.10530325 L36.0451693,9.10530325 C36.9921686,9.10530325 37.7151701,9.35914966 38.2141954,9.8668501 C38.7132207,10.3745505 38.9627296,11.0306459 38.9627296,11.8351558 C38.9627296,12.6240442 38.7157732,13.2755833 38.221853,13.7897927 C37.7279329,14.3040021 37.0266278,14.561103 36.1179168,14.561103 L34.1728766,14.561103 L34.1728766,9.10530325 Z M34.5863891,9.45678641 L34.5863891,14.2096198 L36.0949439,14.2096198 C36.7866874,14.2096198 37.3629189,13.992874 37.8236558,13.559376 C38.2843927,13.1258779 38.5147577,12.5511436 38.5147577,11.8351558 C38.5147577,11.1347896 38.2875834,10.5633097 37.8332279,10.120699 C37.3788724,9.67808841 36.7905164,9.45678641 36.0681422,9.45678641 L34.5863891,9.45678641 Z"\n                                    id="D" fill="#A37778"></path>\n                                <path\n                                    d="M29.7016068,9.10530325 L30.1151193,9.10530325 L30.1151193,12.081194 C30.1151193,12.8961183 29.9070889,13.5248763 29.4910217,13.967487 C29.0749546,14.4100976 28.5363728,14.6313996 27.87526,14.6313996 C27.2166998,14.6313996 26.6793942,14.4127012 26.2633271,13.9752977 C25.8472599,13.5378943 25.6392295,12.9390771 25.6392295,12.1788282 L25.6392295,9.10530325 L26.0565708,9.10530325 L26.0565708,12.1632067 C26.0565708,12.8141047 26.2256753,13.3230993 26.5638894,13.6902058 C26.9021034,14.0573123 27.3392226,14.2408628 27.87526,14.2408628 C28.4164025,14.2408628 28.8560742,14.0553596 29.1942882,13.6843478 C29.5325023,13.3133359 29.7016068,12.7867673 29.7016068,12.1046262 L29.7016068,9.10530325 Z"\n                                    id="U" fill="#A37778"></path>\n                                <path\n                                    d="M18.7443171,9.03500662 C19.5356104,9.03500662 20.2062852,9.30642701 20.7563616,9.84927594 C21.3064381,10.3921249 21.5814722,11.0540782 21.5814722,11.8351558 C21.5814722,12.6136298 21.3064381,13.2742814 20.7563616,13.8171303 C20.2062852,14.3599792 19.5356104,14.6313996 18.7443171,14.6313996 C17.9555763,14.6313996 17.2874541,14.3599792 16.7399302,13.8171303 C16.1924063,13.2742814 15.9186484,12.6136298 15.9186484,11.8351558 C15.9186484,11.0540782 16.1924063,10.3921249 16.7399302,9.84927594 C17.2874541,9.30642701 17.9555763,9.03500662 18.7443171,9.03500662 Z M18.7596323,14.2408628 C19.4258502,14.2408628 19.9880429,14.0084957 20.4462273,13.5437545 C20.9044116,13.0790133 21.1335003,12.5094861 21.1335003,11.8351558 C21.1335003,11.1582219 20.9044116,10.5873929 20.4462273,10.1226517 C19.9880429,9.65791056 19.4258502,9.42554347 18.7596323,9.42554347 C18.0908619,9.42554347 17.5248404,9.65791056 17.061551,10.1226517 C16.5982615,10.5873929 16.3666203,11.1582219 16.3666203,11.8351558 C16.3666203,12.5094861 16.5982615,13.0790133 17.061551,13.5437545 C17.5248404,14.0084957 18.0908619,14.2408628 18.7596323,14.2408628 Z"\n                                    id="O" fill="#A37778"></path>\n                                <polygon id="L" fill="#A37778"\n                                    points="9.21517694 9.10530325 9.21517694 14.2096198 11.8608911 14.2096198 11.8608911 14.561103 8.80166445 14.561103 8.80166445 9.10530325">\n                                </polygon>\n                                <path\n                                    d="M4.69030367,9.49193473 L4.69030367,9.95276821 C4.04195369,9.60128329 3.40637604,9.42554347 2.78355165,9.42554347 C2.11988631,9.42554347 1.56471306,9.6559579 1.11801524,10.1167937 C0.671317421,10.5776295 0.447971861,11.1530147 0.447971861,11.8429665 C0.447971861,12.5407292 0.672593681,13.1148126 1.12184406,13.565234 C1.57109444,14.0156554 2.14413534,14.2408628 2.84098394,14.2408628 C3.42296738,14.2408628 4.05726877,14.0547087 4.74390714,13.6823951 L4.74390714,14.1197963 C4.11087251,14.4608669 3.47912364,14.6313996 2.84864158,14.6313996 C2.03437526,14.6313996 1.35604289,14.3651863 0.813624106,13.8327518 C0.271205323,13.3003172 0,12.6370621 0,11.8429665 C0,11.0436638 0.276948495,10.3758525 0.830853793,9.83951252 C1.38475909,9.30317257 2.04458569,9.03500662 2.81035338,9.03500662 C3.4127573,9.03500662 4.03940113,9.18731447 4.69030367,9.49193473 Z"\n                                    id="C" fill="#A37778"></path>\n                            </g>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </svg>\n\n        <span class="background-image"\n            ng-style="{\'background-image\': \'url(&quot;\' + $ctrl.adjustedImageUrls.cloudDashboardBackgroundImage + \'&quot;)\', \'background-color\': \'white\'}"></span>\n\n        <img ng-if="$ctrl.clientLogo" ng-src="{{$ctrl.clientLogo}}" class="logo-image" />\n\n\n    </div>\n\n    <div class="ipadPortrait" ng-switch-when="ipad_portrait">\n        <svg ng-attr-width="{{$ctrl.width}}" ng-attr-height="{{$ctrl.height}}" viewBox="0 0 108 148" version="1.1"\n            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n            <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->\n            <title>iPad portrait</title>\n            <desc>Created with Sketch.</desc>\n            <defs></defs>\n            <g id="UX-Ideas" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n                <g id="THEME-ENABLED-(PRESENT)" transform="translate(-961.000000, -1350.000000)">\n                    <g id="ZuantDefaultTheme" transform="translate(961.000000, 1257.000000)">\n                        <g id="iPad-portrait" transform="translate(0.000000, 93.000000)">\n                            <path\n                                d="M3.82790084,-5.40012479e-13 L104.172099,-5.40012479e-13 C106.28619,-5.40012479e-13 108,1.71329137 108,3.80717534 L108,144.192825 C108,146.29547 106.281772,148 104.172099,148 L3.82790084,148 C1.71380958,148 8.52651283e-14,146.286709 8.52651283e-14,144.192825 L8.52651283e-14,3.80717534 C8.52651283e-14,1.70453046 1.71822823,-5.40012479e-13 3.82790084,-5.40012479e-13 Z M6,10 L6,138 L103,138 L103,10 L6,10 Z"\n                                id="Combined-Shape" fill="{{$ctrl.bezelColor}}" fill-rule="nonzero"></path>\n                            <ellipse id="Oval" fill="#BBC4CA" cx="53.8411215" cy="5.84090909" rx="1" ry="1"></ellipse>\n                            <g id="blocks" transform="translate(9.000000, 34.000000)">\n                                <rect id="blocksContainer" fill="#ffffff"\n                                    fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksHolderAlpha}}"\n                                    transform="translate(46.000000, 49.500000) rotate(-360.000000) translate(-46.000000, -49.500000) "\n                                    x="0" y="0" width="92" height="99"></rect>\n                                <rect id="showroomColor" fill="{{$ctrl.theme.blocks.showroomColor}}"\n                                    fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}"\n                                    transform="translate(80.500000, 52.500000) rotate(-360.000000) translate(-80.500000, -52.500000) "\n                                    x="69" y="45" width="23" height="15"></rect>\n                                <rect id="artefactsColor" fill="{{$ctrl.theme.blocks.artefactsColor}}"\n                                    fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}"\n                                    transform="translate(80.500000, 37.500000) rotate(-360.000000) translate(-80.500000, -37.500000) "\n                                    x="69" y="30" width="23" height="15"></rect>\n                                <rect id="imagesColor" fill="{{$ctrl.theme.blocks.imagesColor}}"\n                                    fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}"\n                                    transform="translate(57.500000, 22.500000) rotate(-360.000000) translate(-57.500000, -22.500000) "\n                                    x="46" y="15" width="23" height="15"></rect>\n                                <rect id="contactsColor" fill="{{$ctrl.theme.blocks.contactsColor}}"\n                                    fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}"\n                                    transform="translate(34.500000, 37.500000) rotate(-360.000000) translate(-34.500000, -37.500000) "\n                                    x="23" y="30" width="23" height="15"></rect>\n                                <rect id="formsColor" fill="{{$ctrl.theme.blocks.formsColor}}"\n                                    fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}"\n                                    transform="translate(11.500000, 22.790457) rotate(-360.000000) translate(-11.500000, -22.790457) "\n                                    x="0" y="15.2904574" width="23" height="15"></rect>\n                            </g>\n                            <g id="ZUANT" transform="translate(9.000000, 17.000000)" fill="#949CA1"\n                                ng-if="$ctrl.theme.showLogo && !$ctrl.clientLogo">\n                                <polygon id="Shape"\n                                    points="38.25 0 38.25 0.363140676 36.211039 0.363140676 36.211039 5.64885496 35.7954545 5.64885496 35.7954545 0.363140676 33.75 0.363140676 33.75 0">\n                                </polygon>\n                                <polygon id="Shape"\n                                    points="29.25 0 29.25 5.64885496 28.9277188 5.64885496 25.1319629 0.699382043 25.1319629 5.62195565 24.75 5.62195565 24.75 0 25.0722812 0 28.8680371 4.92257361 28.8680371 0 29.25 0">\n                                </polygon>\n                                <polygon id="Shape"\n                                    points="19.8144266 3.33462513 18.5520962 0.713609777 17.3105734 3.33462513 17.1371763 3.69476464 16.22164 5.62217796 15.75 5.62217796 18.4272503 0 18.676942 0 21.375 5.64885496 20.90336 5.64885496 19.9878237 3.72144164">\n                                </polygon>\n                                <path\n                                    d="M11.9635714,-3.55271368e-15 L12.375,-3.55271368e-15 L12.375,3.03709026 C12.375,3.86780422 12.1692857,4.51243826 11.7578571,4.95770094 C11.3207143,5.40960934 10.7935714,5.64885496 10.125,5.64885496 C9.45642857,5.64885496 8.91,5.43619219 8.49214286,4.98428379 C8.08071429,4.53237539 7.875,3.9143242 7.875,3.15671307 L7.875,-3.55271368e-15 L8.28642857,-3.55271368e-15 L8.28642857,3.13677593 C8.28642857,3.8013471 8.44714286,4.32635833 8.79428571,4.7051639 C9.14142857,5.08396947 9.57214286,5.27669511 10.125,5.27669511 C10.6778571,5.27669511 11.115,5.08396947 11.4557143,4.7051639 C11.7964286,4.32635833 11.9635714,3.78140997 11.9635714,3.09025595 L11.9635714,-3.55271368e-15 L11.9635714,-3.55271368e-15 L11.9635714,-3.55271368e-15 Z"\n                                    id="Shape"></path>\n                                <polygon id="Shape"\n                                    points="0 0 0 0.356415849 4.02531646 0.356415849 0 5.30588877 0 5.64885496 4.5 5.64885496 4.5 5.28571429 0.518987342 5.28571429 4.5 0.336241367 4.5 0">\n                                </polygon>\n                            </g>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </svg>\n\n        <span class="background-image"\n            ng-style="{\'background-image\': \'url(&quot;\' + $ctrl.adjustedImageUrls.mainMenuImageiPadPortrait + \'&quot;)\', \'background-color\': \'white\'}"></span>\n\n        <img ng-if="$ctrl.theme.showLogo && $ctrl.clientLogo" ng-src="{{$ctrl.clientLogo}}" class="logo-image" />\n\n    </div>\n\n    <div class="ipadLandscape" ng-switch-when="ipad_landscape">\n        <svg ng-attr-width="{{$ctrl.width}}" ng-attr-height="{{$ctrl.height}}" viewBox="0 0 255 186" version="1.1"\n            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n            <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->\n            <title>iPad Pro</title>\n            <desc>Created with Sketch.</desc>\n            <defs></defs>\n            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n                <g id="iPad-landscape">\n                    <g id="iPad-Pro">\n                        <path\n                            d="M6,0 L249,0 C252.313708,-6.08718376e-16 255,2.6862915 255,6 L255,179.575916 C255,182.889625 252.313708,185.575916 249,185.575916 L6,185.575916 C2.6862915,185.575916 4.05812251e-16,182.889625 0,179.575916 L0,6 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 L6,0 Z M18.9527027,10.3097731 L18.9527027,176.984439 L237.77027,176.984439 L237.77027,10.3097731 L18.9527027,10.3097731 Z"\n                            id="Combined-Shape" fill="{{$ctrl.bezelColor}}"></path>\n                        <ellipse id="Oval" fill="#BBC4CA" cx="10.0640945" cy="92.5145929" rx="1.4492296"\n                            ry="1.44493032"></ellipse>\n                        <g id="blocks" transform="translate(25.844595, 49.830570)">\n                            <rect id="blocks_container" fill="#ffffff"\n                                fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksHolderAlpha}}" x="0" y="0"\n                                width="206.756757" height="118.562391"></rect>\n                            <rect id="showroomColor" fill="{{$ctrl.theme.blocks.showroomColor}}"\n                                fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}" x="165.405405" y="75.6050029"\n                                width="41.3513514" height="25.7744328"></rect>\n                            <rect id="artefactsColor" fill="{{$ctrl.theme.blocks.artefactsColor}}"\n                                fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}" x="124.054054" y="49.8305701"\n                                width="41.3513514" height="25.7744328"></rect>\n                            <rect id="imagesColor" fill="{{$ctrl.theme.blocks.imagesColor}}"\n                                fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}" x="82.7027027" y="24.0561373"\n                                width="41.3513514" height="25.7744328"></rect>\n                            <rect id="contactsColor" fill="{{$ctrl.theme.blocks.contactsColor}}"\n                                fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}" x="41.3513514" y="49.8305701"\n                                width="41.3513514" height="25.7744328"></rect>\n                            <rect id="formsColor" fill="{{$ctrl.theme.blocks.formsColor}}"\n                                fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}" x="0" y="24.0561373"\n                                width="41.3513514" height="25.7744328"></rect>\n                        </g>\n                        <g id="ZUANT_LOGO" transform="translate(25.865145, 21.303257)" fill="#949CA1"\n                            ng-if="$ctrl.theme.showLogo && !$ctrl.clientLogo">\n                            <polygon id="Shape"\n                                points="65.9037162 0 65.9037162 0.623982997 62.3906415 0.623982997 62.3906415 9.70640218 61.6746007 9.70640218 61.6746007 0.623982997 58.1503378 0.623982997 58.1503378 0">\n                            </polygon>\n                            <polygon id="Shape"\n                                points="50.3969595 0 50.3969595 9.70640218 49.8416777 9.70640218 43.3016928 1.20174503 43.3016928 9.66018121 42.6435811 9.66018121 42.6435811 0 43.1988628 0 49.7388478 8.45843618 49.7388478 0 50.3969595 0">\n                            </polygon>\n                            <polygon id="Shape"\n                                points="34.1397216 5.72987142 31.9647603 1.22619248 29.8256501 5.72987142 29.5268916 6.34869753 27.9494472 9.66056321 27.1368243 9.66056321 31.7496542 0 32.1798664 0 36.8285473 9.70640218 36.0159244 9.70640218 34.43848 6.3945365">\n                            </polygon>\n                            <path\n                                d="M20.6129102,-3.55271368e-15 L21.3217905,-3.55271368e-15 L21.3217905,5.21861858 C21.3217905,6.64603067 20.9673504,7.75370245 20.2584701,8.51879532 C19.5052847,9.2953075 18.5970319,9.70640218 17.4451014,9.70640218 C16.2931708,9.70640218 15.3516892,9.34098468 14.6317326,8.56447251 C13.9228523,7.78796034 13.5684122,6.72596574 13.5684122,5.42416592 L13.5684122,-3.55271368e-15 L14.2772925,-3.55271368e-15 L14.2772925,5.38990803 C14.2772925,6.5318377 14.5541988,7.43396214 15.1523166,8.08486205 C15.7504344,8.73576196 16.4925434,9.06692156 17.4451014,9.06692156 C18.3976593,9.06692156 19.1508446,8.73576196 19.7378861,8.08486205 C20.3249276,7.43396214 20.6129102,6.49757981 20.6129102,5.30997296 L20.6129102,-3.55271368e-15 L20.6129102,-3.55271368e-15 L20.6129102,-3.55271368e-15 Z"\n                                id="Shape"></path>\n                            <polygon id="Shape"\n                                points="0 0 0 0.612427756 6.93551146 0.612427756 0 9.1170849 0 9.70640218 7.75337838 9.70640218 7.75337838 9.08241918 0.894201163 9.08241918 7.75337838 0.577762034 7.75337838 0">\n                            </polygon>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </svg>\n\n        <span class="background-image"\n            ng-style="{\'background-image\': \'url(&quot;\' + $ctrl.adjustedImageUrls.mainMenuImageiPadLandscape + \'&quot;)\', \'background-color\': \'white\'}"></span>\n\n        <img ng-if="$ctrl.theme.showLogo && $ctrl.clientLogo" ng-src="{{$ctrl.clientLogo}}" class="logo-image" />\n\n    </div>\n\n    <div class="iphone-xs-max-portrait" ng-switch-when="iphone_xs_max_portrait">\n        <svg ng-attr-width="{{$ctrl.width}}" ng-attr-height="{{$ctrl.height}}" viewBox="0 0 462 934" version="1.1"\n            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n            <title>iPhone XS Max</title>\n            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n                <g id="iphone-xs-max" transform="translate(7, 1)">\n                    <path\n                        d="M382.439,0 C418.76,0 448,29.342 448,65.788 L448,866.212 C448,902.658 418.76,932 382.439,932 L65.561,932 C29.24,932 0,902.658 0,866.212 L0,65.788 C0,29.342 29.24,0 65.561,0 L382.439,0 Z M17.92,63.099 L17.92,871.07 C17.92,897.367 39.448,915 62.081,915 L387.759,915 C417.016,915 431.92,889.652 431.92,871.07 L431.92,62.93 C431.92,36.097 408.736,19.015 388.01,19.015 L346.322,19.015 C344.152,19.015 340.288,21.632 340.305,25.282 L340.288,30.036 C340.288,42.247 330.44,52.078 318.208,52.078 L131.632,52.078 C119.4,52.078 109.552,42.247 109.552,30.036 L109.564,25.985 C109.552,21.219 105.826,19.015 103.249,19.015 L61.894,19.015 C43.312,18.464 17.92,32.791 17.92,63.099 Z"\n                        id="Combined-Shape" fill="{{$ctrl.bezelColor}}"></path>\n                    <path\n                        d="M156,895.5 C156,893.838 157.338,892.5 159,892.5 L291,892.5 C292.662,892.5 294,893.838 294,895.5 C294,897.162 292.662,898.5 291,898.5 L159,898.5 C157.338,898.5 156,897.162 156,895.5 Z"\n                        id="home-btn" fill="#FFFFFF"></path>\n                    <path\n                        d="M189,26 C189,24.338 190.338,23 192,23 L256,23 C257.662,23 259,24.338 259,26 C259,27.662 257.662,29 256,29 L192,29 C190.338,29 189,27.662 189,26 Z M266.5,26.5 C266.5,23.4624339 268.962434,21 272,21 C275.037566,21 277.5,23.4624339 277.5,26.5 C277.5,29.5375661 275.037566,32 272,32 C268.962434,32 266.5,29.5375661 266.5,26.5 Z"\n                        id="earphone" stroke="#C1C1C1" fill="#C1C1C1" stroke-linecap="round" stroke-linejoin="round">\n                    </path>\n                    <g id="blocks" transform="translate(34, 206)" fill-opacity="0" fill-rule="nonzero">\n                        <polygon id="blocksContainer" fill="#ffffff"\n                            fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksHolderAlpha}}"\n                            points="0 630 0 0 380 0 380 630"></polygon>\n                        <polygon id="showroomColor" fill="{{$ctrl.theme.blocks.showroomColor}}"\n                            fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}"\n                            points="190 630 190 473 380 473 380 630"></polygon>\n                        <polygon id="imagesColor" fill="{{$ctrl.theme.blocks.imagesColor}}"\n                            fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}"\n                            points="1 472 1 315 191 315 191 472"></polygon>\n                        <polygon id="contactsColor" fill="{{$ctrl.theme.blocks.contactsColor}}"\n                            fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}"\n                            points="190 314 190 157 380 157 380 314"></polygon>\n                        <polygon id="formColor" fill="{{$ctrl.theme.blocks.formsColor}}"\n                            fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}" points="1 157 1 0 191 0 191 157">\n                        </polygon>\n                    </g>\n                    <g id="ZUANT" transform="translate(35, 99)" fill="#949CA1"\n                        ng-if="$ctrl.theme.showLogo && !$ctrl.clientLogo" fill-rule="nonzero">\n                        <polygon id="Shape"\n                            points="201 0 201 1.99285714 190.119527 1.99285714 190.119527 31 187.90185 31 187.90185 1.99285714 176.986726 1.99285714 176.986726 0">\n                        </polygon>\n                        <polygon id="Shape"\n                            points="154.752212 0 154.752212 31 153.032429 31 132.7772 3.83809523 132.7772 30.852381 130.738938 30.852381 130.738938 0 132.458722 0 152.71395 27.0142857 152.71395 0">\n                        </polygon>\n                        <polygon id="Shape"\n                            points="105.698106 18.2998819 99.1116451 3.91617473 92.6337524 18.2998819 91.7290192 20.2762691 86.9520259 30.8536009 84.4911504 30.8536009 98.4602372 0 99.7630535 0 113.840708 31 111.379832 31 106.602839 20.4226682">\n                        </polygon>\n                        <path\n                            d="M60.9505184,0 L63.1460177,0 L63.1460177,16.6670588 C63.1460177,21.2258823 62.0482677,24.7635294 59.8527685,27.2070588 C57.5200504,29.6870588 54.7070669,31 51.1393805,31 C47.571694,31 44.6557964,29.8329412 42.4259924,27.3529412 C40.2304931,24.8729411 39.1327434,21.4811765 39.1327434,17.3235294 L39.1327434,0 L41.3282427,0 L41.3282427,17.2141177 C41.3282427,20.8611765 42.1858597,23.7423529 44.0383123,25.8211764 C45.8907648,27.9 48.1891782,28.957647 51.1393805,28.957647 C54.0895827,28.957647 56.4223008,27.9 58.2404486,25.8211764 C60.0585965,23.7423529 60.9505184,20.7517647 60.9505184,16.9588235 L60.9505184,0 L60.9505184,0 L60.9505184,0 Z"\n                            id="Shape"></path>\n                        <polygon id="Shape"\n                            points="0 0 0 1.95595238 21.4802286 1.95595238 0 29.1178571 0 31 24.0132743 31 24.0132743 29.0071429 2.76946343 29.0071429 24.0132743 1.84523809 24.0132743 0">\n                        </polygon>\n                    </g>\n                </g>\n            </g>\n        </svg>\n\n        <span class="background-image"\n            ng-style="{\'background-image\': \'url(&quot;\' + $ctrl.adjustedImageUrls.mainMenuImageiPhone67 + \'&quot;)\', \'background-color\': \'white\'}"></span>\n\n        <img ng-if="$ctrl.theme.showLogo && $ctrl.clientLogo" ng-src="{{$ctrl.clientLogo}}" class="logo-image" />\n    </div>\n\n    <div class="iphone" ng-switch-when="iphone_portrait">\n        <svg ng-attr-width="{{$ctrl.width}}" ng-attr-height="{{$ctrl.height}}" viewBox="0 0 70 147" version="1.1"\n            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n            <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->\n            <title>iPhone</title>\n            <desc>Created with Sketch.</desc>\n            <defs></defs>\n            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n                <g id="iPhone">\n                    <path\n                        d="M11.3054187,-1.42108547e-14 L58.6798459,-1.42108547e-14 C64.8424988,-1.42108547e-14 69.838316,4.96992288 69.838316,11.0823376 L69.838316,135.76218 C69.838316,141.882786 64.8542529,146.844518 58.6798459,146.844518 L11.3054187,146.844518 C5.14276582,146.844518 0.146948568,141.874595 0.146948568,135.76218 L0.146948568,11.0823376 C0.146948568,4.96173155 5.13101172,-1.42108547e-14 11.3054187,-1.42108547e-14 Z M3.88888889,19.3421053 L3.88888889,127.657895 L66.1111111,127.657895 L66.1111111,19.3421053 L3.88888889,19.3421053 Z"\n                        id="Combined-Shape" fill="{{$ctrl.bezelColor}}" fill-rule="nonzero"></path>\n                    <rect id="earphone" fill="#BBC4CA" x="26.8194821" y="11.0826051" width="12.5444461"\n                        height="1.38532564" rx="0.692662819"></rect>\n                    <g id="blocks" transform="translate(6.283706, 45.683670)">\n                        <polygon id="blocksContainer" fill="#ffffff"\n                            fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksHolderAlpha}}"\n                            points="0.0257010818 72.1535104 0.0257010818 0.0856801982 57.0627381 0.0856801982 57.0627381 72.1535104">\n                        </polygon>\n                        <polygon id="showroomColor" fill="{{$ctrl.theme.blocks.showroomColor}}"\n                            fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}"\n                            points="28.5185185 72.1535104 28.5185185 54.1578947 57.037037 54.1578947 57.037037 72.1535104">\n                        </polygon>\n                        <polygon id="imagesColor" fill="{{$ctrl.theme.blocks.imagesColor}}"\n                            fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}"\n                            points="4.81392703e-13 54.1008788 4.82494823e-13 36.1052632 28.5185185 36.1052632 28.5185185 54.1008788">\n                        </polygon>\n                        <polygon id="contactsColor" fill="{{$ctrl.theme.blocks.contactsColor}}"\n                            fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}"\n                            points="28.5185185 36.0482473 28.5185185 18.0526316 57.037037 18.0526316 57.037037 36.0482473">\n                        </polygon>\n                        <polygon id="formColor" fill="{{$ctrl.theme.blocks.formsColor}}"\n                            fill-opacity="{{$ctrl.theme.blocks.mainMenuBlocksAlpha}}"\n                            points="0.0257010818 18.0812959 0.0257010818 0.0856801982 28.5442196 0.0856801982 28.5442196 18.0812959">\n                        </polygon>\n                    </g>\n                    <g id="ZUANT" transform="translate(5.978836, 27.653465)" fill="#949CA1"\n                        ng-if="$ctrl.theme.showLogo && !$ctrl.clientLogo">\n                        <polygon id="Shape"\n                            points="32.010582 0 32.010582 0.302708212 30.3042205 0.302708212 30.3042205 4.70879441 29.956427 4.70879441 29.956427 0.302708212 28.2446312 0.302708212 28.2446312 0">\n                        </polygon>\n                        <polygon id="Shape"\n                            points="24.4786804 0 24.4786804 4.70879441 24.2089704 4.70879441 21.0323858 0.582993593 21.0323858 4.68637158 20.7127295 4.68637158 20.7127295 0 20.9824395 0 24.1590241 4.10337798 24.1590241 0 24.4786804 0">\n                        </polygon>\n                        <polygon id="Shape"\n                            points="16.582257 2.77968973 15.5258404 0.594853603 14.4868373 2.77968973 14.3417252 3.07989622 13.575533 4.68655689 13.1808279 4.68655689 15.4213597 0 15.6303212 0 17.8882664 4.70879441 17.4935613 4.70879441 16.7273691 3.10213374">\n                        </polygon>\n                        <path\n                            d="M10.0120493,-3.55271368e-15 L10.3563648,-3.55271368e-15 L10.3563648,2.53166946 C10.3563648,3.22413923 10.184207,3.76149577 9.83989151,4.13265956 C9.47405629,4.50936312 9.03290205,4.70879441 8.47338936,4.70879441 C7.91387666,4.70879441 7.45658263,4.53152215 7.1068872,4.1548186 C6.7625717,3.77811504 6.59041394,3.26291754 6.59041394,2.63138511 L6.59041394,-3.55271368e-15 L6.93472945,-3.55271368e-15 L6.93472945,2.61476584 C6.93472945,3.16874165 7.06922769,3.60638254 7.3597439,3.92214875 C7.6502601,4.23791497 8.0107154,4.39856795 8.47338936,4.39856795 C8.93606331,4.39856795 9.30189854,4.23791497 9.58703481,3.92214875 C9.87217109,3.60638254 10.0120493,3.15212237 10.0120493,2.57598753 L10.0120493,-3.55271368e-15 L10.0120493,-3.55271368e-15 L10.0120493,-3.55271368e-15 Z"\n                            id="Shape"></path>\n                        <polygon id="Shape"\n                            points="0 0 0 0.297102504 3.36869863 0.297102504 0 4.42290332 0 4.70879441 3.76595082 4.70879441 3.76595082 4.4060862 0.434329068 4.4060862 3.76595082 0.280285381 3.76595082 0">\n                        </polygon>\n                    </g>\n                </g>\n            </g>\n        </svg>\n\n        <span class="background-image"\n            ng-style="{\'background-image\': \'url(&quot;\' + $ctrl.adjustedImageUrls.mainMenuImageiPhone + \'&quot;)\', \'background-color\': \'white\'}"></span>\n\n        <img ng-if="$ctrl.theme.showLogo && $ctrl.clientLogo" ng-src="{{$ctrl.clientLogo}}" class="logo-image" />\n\n    </div>\n</ng-container>');
$templateCache.put('app/clients/theming/theming-components/zp-theme-snapshot.tmpl.html','<zp-theme-Device device-type="imac" theme="$ctrl.theme" client-logo-obj="$ctrl.clientLogoObj"></zp-theme-Device>\n\n<zp-theme-Device device-type="ipad_portrait" theme="$ctrl.theme"\n  client-logo-obj="$ctrl.clientLogoObj"></zp-theme-Device>\n\n<zp-theme-Device device-type="ipad_landscape" theme="$ctrl.theme"\n  client-logo-obj="$ctrl.clientLogoObj"></zp-theme-Device>\n\n<zp-theme-Device device-type="iphone_portrait" theme="$ctrl.theme"\n  client-logo-obj="$ctrl.clientLogoObj"></zp-theme-Device>\n\n<zp-theme-device device-type="iphone_xs_max_portrait" theme="$ctrl.theme"\n  client-logo-obj="$ctrl.clientLogoObj"></zp-theme-device>');
$templateCache.put('app/clients/theming/zp-add-theme-dialog/dialog.tmpl.html','<md-dialog aria-label="Add new theme dialog" flex="80">\n  <md-toolbar aria-label="Create theme dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">Fresh lick of paint coming right up</p>\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-dialog-content layout-padding>\n    <form name="vm.newThemeForm" ng-submit="vm.submit()" novalidate flex="100">\n      <md-list flex="80" flex-offset="10">\n        <md-list-item style="margin-top: 30px;">\n          <md-input-container class="md-block" flex>\n            <label>Skin name</label>\n            <input type="text" ng-model="vm.theme.name" name="name" aria-label="Skin name" required md-autofocus/>\n            <div ng-messages="vm.newThemeForm.name.$error" md-auto-hide="false" ng-show="vm.newThemeForm.name.$touched">\n              <div ng-message="required">\n                <spanPlease name your theme</span>\n              </div>\n            </div>\n          </md-input-container>\n        </md-list-item>\n      </md-list>\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n    <md-dialog-actions layout="row">\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        Cancel\n      </md-button>\n      <md-button ng-click="vm.submit()" aria-label="Create theme" ng-disabled="vm.newThemeForm.$invalid">\n        Save\n      </md-button>\n    </md-dialog-actions>\n  </md-dialog-content>\n</md-dialog>\n');
$templateCache.put('app/clients/theming/zp-theme-editor/zp-theme-editor.tmpl.html','<div layout="column" class="container">\n  <md-toolbar aria-label="Manage client dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">Custom Skins Editor</p>\n      <span flex></span>\n      <md-button ng-click="$ctrl.cancel()">\n        <md-tooltip>Exit back to library</md-tooltip>\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-toolbar aria-label="Manage client dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <md-button ng-click="$ctrl.navBack()">\n        <md-icon md-font-icon="zmdi zmdi-chevron-left"></md-icon>\n      </md-button>\n      <p class="md-body-1">Back to library view</p>\n    </div>\n  </md-toolbar>\n  <md-content layout="column">\n    <div flex layout-padding>\n      <div ng-if="$ctrl.theme.isPrimaryTheme" layout-padding>\n        <p class="md-subhead">\n          <md-icon md-font-icon="zmdi zmdi-alert-triangle zuantPollen"></md-icon> This is the primary skin for the\n          account. Any changes made will sync to all devices. Tread with care!\n        </p>\n      </div>\n      <md-toolbar class="md-menu-toolbar">\n        <div layout="row">\n          <md-toolbar-filler layout layout-align="center center">\n            <md-icon md-font-icon="zmdi zmdi-palette"></md-icon>\n          </md-toolbar-filler>\n          <div class="editable-toolbar">\n            <zp-editable-header class="md-toolbar-tools" metadata="$ctrl.themeNameEditableHeader"\n              value="$ctrl.theme.name" flex done-function="$ctrl.updateThemeName(value)" font-class="\'md-headline\'">\n            </zp-editable-header>\n\n            <md-menu-bar></md-menu-bar>\n          </div>\n\n          <span flex></span>\n\n          <md-menu>\n            <md-button aria-label="Context menu" class="md-icon-button" ng-click="$ctrl.openMenu($mdOpenMenu, $event)">\n              <md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon>\n            </md-button>\n\n            <md-menu-content width="4">\n              <md-menu-item>\n                <md-button ng-click="$ctrl.makePrimaryTheme($event)">\n                  <md-icon md-font-icon="zmdi zmdi-cloud-done" md-menu-align-target></md-icon>\n                  <span ng-show="!$ctrl.theme.isPrimaryTheme">Make this the primary skin</span>\n                  <span ng-show="$ctrl.theme.isPrimaryTheme">Deselect as primary skin</span>\n                </md-button>\n              </md-menu-item>\n\n              <md-menu-item permission permission-only="$ctrl.permissions.boltOns.theming.delete">\n                <md-button ng-click="$ctrl.deleteTheme($event)">\n                  <md-icon md-font-icon="zmdi zmdi-delete" md-menu-align-target></md-icon>\n                  Delete this skin\n                </md-button>\n              </md-menu-item>\n\n            </md-menu-content>\n          </md-menu>\n        </div>\n      </md-toolbar>\n\n      <md-card layout-padding layout-margin>\n        <md-card-header>\n          <md-card-header-text>\n            <span class="md-title">Android/IOS App</span>\n            <span class="md-subhead">Device specific background skins and app color settings</span>\n          </md-card-header-text>\n        </md-card-header>\n\n        <md-card-content>\n          <div layout="column">\n            <div>\n              <zp-main-menu-configurator theme="$ctrl.theme"\n                update-change-delta="$ctrl.updateChangeDelta(prop1, prop2, val)"\n                sync-block-colors="$ctrl.syncBlockColors(color)">\n              </zp-main-menu-configurator>\n            </div>\n\n            <div layout-align="center center" layout="column" flex>\n              <zp-theme-Device id="ipadThemePreview" device-type="ipad_landscape" theme="$ctrl.theme"\n                client-logo-obj="$ctrl.clientDoc.clientLogoImage"></zp-theme-Device>\n            </div>\n        </md-card-content>\n      </md-card>\n\n      <md-divider></md-divider>\n\n      <div class="section-headline-container" layout="column">\n        <span class="md-headline">Device specific background images</span>\n        <span class="md-subhead">Specify different sized images for different device sizes/orientations</span>\n      </div>\n\n      <md-subheader>iPad Portrait</md-subheader>\n\n      <div class="theme-preview-container" layout-align="center center" layout="row" layout-margin flex>\n        <zp-theme-Device id="iPadPortraitPreview" device-type="ipad_portrait" theme="$ctrl.theme" bezel-color="#CED8DD"\n          client-logo-obj="$ctrl.clientDoc.clientLogoImage"></zp-theme-Device>\n\n        <div flex="40" layout-align="center center" layout="column">\n          <p class="md-subhead margin-bottom-0">iPad Portrait</p>\n          <zp-image-info-table metadata="$ctrl.theme.images.mainMenuImageiPadPortrait.metadata"\n            ng-hide="!$ctrl.theme.images.mainMenuImageiPadPortrait.metadata.title" layout="row" layout-fill\n            layout-align="center center">\n          </zp-image-info-table>\n\n          <zp-image-control-buttons image-obj="$ctrl.theme.images.mainMenuImageiPadPortrait"\n            open-select-dialog="$ctrl.imageDialogButtonClicked($event, imageObj)" layout="row" layout-fill\n            layout-align="center center">\n          </zp-image-control-buttons>\n\n          <div flex></div>\n\n          <div class="device-info-container" layout="column" layout-align="start">\n            <p class="md-caption zp-caption margin-bottom-0"><b>Required Image Ratio: 3:4 Portrait</b></p>\n            <p class="md-caption zp-caption margin-bottom-0">An image set to a 3:4 Portrait aspect ratio will display\n              correctly on all devices on this list. You can choose any image size listed below for all iPad Portrait\n              displays:</p>\n\n            <ul class="md-caption zp-caption">\n              <li>iPad (1st generation) - 768 x 1024 pixels</li>\n              <li>iPad 2 - 768 x 1024 pixels</li>\n              <li>iPad (3rd generation) - 1536 x 2048 pixels</li>\n              <li>iPad (4th generation) - 1536 x 2048 pixels</li>\n              <li>iPad (5th generation) - 1536 x 2048 pixels</li>\n              <li>iPad (6th generation) - 1536 x 2048 pixels</li>\n              <li>iPad (7th generation) - 1536 x 2048 pixels</li>\n              <li>iPad (8th generation) - 1620 x 2160 pixels</li>\n              <li>iPad Air - 1536 x 2048 pixels</li>\n              <li>iPad Air 2 - 1536 x 2048 pixels</li>\n              <li>iPad Air (3rd generation) - 1668 x 2224 pixels</li>\n              <li>iPad Air (4th generation) - 1640 x 2360 pixels</li>\n              <li>iPad Pro (9.7-inch) - 1536 x 2048 pixels</li>\n              <li>iPad Pro (10.5-inch) - 1668 x 2224 pixels</li>\n              <li>iPad Pro 11-inch (1st generation) - 1668 x 2388 pixels</li>\n              <li>iPad Pro 11-inch (2nd generation) - 1668 x 2388 pixels</li>\n              <li>iPad Pro 11-inch (3rd generation) - 1668 x 2388 pixels</li>\n              <li>iPad Pro 12.9-inch (1st generation) - 2048 x 2732 pixels</li>\n              <li>iPad Pro 12.9-inch (2nd generation) - 2048 x 2732 pixels</li>\n              <li>iPad Pro 12.9-inch (3rd generation) - 2048 x 2732 pixels</li>\n              <li>iPad Pro 12.9-inch (4th generation) - 2048 x 2732 pixels</li>\n              <li>iPad Pro 12.9-inch (5th generation) - 2048 x 2732 pixels</li>\n            </ul>\n          </div>\n\n        </div>\n\n      </div>\n\n      <md-subheader>iPad Landscape</md-subheader>\n\n      <div class="theme-preview-container" layout-align="center center" layout="row" layout-margin flex>\n        <zp-theme-Device id="iPadLandscapePreview" device-type="ipad_landscape" theme="$ctrl.theme"\n          bezel-color="#CED8DD" client-logo-obj="$ctrl.clientDoc.clientLogoImage"></zp-theme-Device>\n\n        <div flex="40" layout-align="center center" layout="column">\n          <p class="md-subhead">iPad Landscape</p>\n\n          <zp-image-info-table metadata="$ctrl.theme.images.mainMenuImageiPadLandscape.metadata"\n            ng-hide="!$ctrl.theme.images.mainMenuImageiPadLandscape.metadata.title" layout="row" layout-fill\n            layout-align="center center">\n          </zp-image-info-table>\n\n          <zp-image-control-buttons image-obj="$ctrl.theme.images.mainMenuImageiPadLandscape"\n            open-select-dialog="$ctrl.imageDialogButtonClicked($event, imageObj)" layout="row" layout-fill\n            layout-align="center center">\n          </zp-image-control-buttons>\n\n          <div flex></div>\n\n          <div class="device-info-container" layout="column" layout-align="start">\n            <p class="md-caption zp-caption margin-bottom-0"><b>Required Image Ratio: 4:3 Landscape</b></p>\n            <p class="md-caption zp-caption margin-bottom-0">An image set to a 4:3 Landscape aspect ratio will display\n              correctly on all devices on this list. You can choose any image size listed below for all iPad Landscape\n              displays:</p>\n\n            <ul class="md-caption zp-caption">\n              <li>iPad (1st generation) - 1024 x 768 pixels</li>\n              <li>iPad 2 - 1024 x 768 pixels</li>\n              <li>iPad (3rd generation) - 2048 x 1536 pixels</li>\n              <li>iPad (4th generation) - 2048 x 1536 pixels</li>\n              <li>iPad (5th generation) - 2048 x 1536 pixels</li>\n              <li>iPad (6th generation) - 2048 x 1536 pixels</li>\n              <li>iPad (7th generation) - 2048 x 1536 pixels</li>\n              <li>iPad (8th generation) - 2160 x 1620 pixels</li>\n              <li>iPad Air - 2048 x 1536 pixels</li>\n              <li>iPad Air 2 - 2048 x 1536 pixels</li>\n              <li>iPad Air (3rd generation) - 2224 x 1668 pixels</li>\n              <li>iPad Air (4th generation) - 2360 x 1640 pixels</li>\n              <li>iPad Pro (9.7-inch) - 2048 x 1536 pixels</li>\n              <li>iPad Pro (10.5-inch) - 2224 x 1668 pixels</li>\n              <li>iPad Pro 11-inch (1st generation) - 2388 x 1668 pixels</li>\n              <li>iPad Pro 11-inch (2nd generation) - 2388 x 1668 pixels</li>\n              <li>iPad Pro 11-inch (3rd generation) - 2388 x 1668 pixels</li>\n              <li>iPad Pro 12.9-inch (1st generation) - 2732 x 2048 pixels</li>\n              <li>iPad Pro 12.9-inch (2nd generation) - 2732 x 2048 pixels</li>\n              <li>iPad Pro 12.9-inch (3rd generation) - 2732 x 2048 pixels</li>\n              <li>iPad Pro 12.9-inch (4th generation) - 2732 x 2048 pixels</li>\n              <li>iPad Pro 12.9-inch (5th generation) - 2732 x 2048 pixels</li>\n            </ul>\n          </div>\n\n        </div>\n      </div>\n\n      <md-subheader>iPhone/Andoid Portrait</md-subheader>\n\n      <div class="theme-preview-container" layout-align="center center" layout="column" flex>\n\n        <div flex="80" layout="column" layout-align="center center">\n          <p class="md-headline margin-bottom-5 margin-top-0">\n            <span><md-icon md-font-icon="zmdi zmdi-alert-triangle"></md-icon></span>\n\n            <span>Please note: Android Phones will use the images provided in this section.</span></span>\n          </p>\n\n          <p class="md-subhead margin-top-0">\n            Depending on the aspect ratio\n            of the\n            device being used, the app will choose the image which most closely matches the aspect ratio of the users\n            screen.\n          </p>\n        </div>\n\n        <div class="device-type-selection-container" layout-align="center center" layout="row">\n          <md-button class="md-primary zp-off-white-bg"\n            ng-class="{\'md-raised md-primary\': (!vm.selectedPortraitIphoneAspectRatio || vm.selectedPortraitIphoneAspectRatio === \'9:16\') }"\n            ng-click="vm.selectedPortraitIphoneAspectRatio = \'9:16\'" flex>iPhone 5 - iPhone 8 Plus</md-button>\n          <md-button class="md-primary zp-off-white-bg"\n            ng-class="{\'md-raised md-primary\':vm.selectedPortraitIphoneAspectRatio === \'9:19.5\'}"\n            ng-click="vm.selectedPortraitIphoneAspectRatio = \'9:19.5\'" flex>iPhone X - iPhone 15 Pro Max\n          </md-button>\n        </div>\n\n        <div layout-align="center center" layout="row" layout-fill layout-margin flex>\n\n          <zp-theme-device ng-if="vm.selectedPortraitIphoneAspectRatio === \'9:19.5\'" id="iPhoneXSPortraitPreview"\n            device-type="iphone_xs_max_portrait" theme="$ctrl.theme" bezel-color="#CED8DD"\n            client-logo-obj="$ctrl.clientDoc.clientLogoImage"></zp-theme-device>\n\n          <div ng-if="vm.selectedPortraitIphoneAspectRatio === \'9:19.5\'" layout-align="center center" layout="column"\n            flex="40">\n            <p class="md-subhead">iPhone X - iPhone 15 Pro Max Portrait</p>\n\n            <zp-image-info-table metadata="$ctrl.theme.images.mainMenuImageiPhone67.metadata"\n              ng-if="$ctrl.theme.images.mainMenuImageiPhone67.metadata.title" layout="row" layout-fill\n              layout-align="center center">\n            </zp-image-info-table>\n\n            <zp-image-control-buttons image-obj="$ctrl.theme.images.mainMenuImageiPhone67"\n              open-select-dialog="$ctrl.imageDialogButtonClicked($event, imageObj)" layout="row" layout-fill\n              layout-align="center center">\n            </zp-image-control-buttons>\n\n            <div class="device-info-container" layout="column" layout-align="start">\n              <p class="md-caption zp-caption margin-bottom-0"><b>Required Image Ratio: 9:19.5 Portrait</b></p>\n              <p class="md-caption zp-caption margin-bottom-0">An image set to a 9:19.5 Portrait aspect ratio will\n                display\n                correctly on all devices on this list. You can choose any image size listed below for all iPhone X\n                - 15\n                PRO MAX displays:</p>\n\n              <ul class="md-caption zp-caption">\n                <li>iPhone X - 1125 x 2436 pixels</li>\n                <li>iPhone XS - 1125 x 2436 pixels</li>\n                <li>iPhone XS Max - 1242 x 2688 pixels</li>\n                <li>iPhone XR - 828 x 1792 pixels</li>\n                <li>iPhone 11 - 828 x 1792 pixels</li>\n                <li>iPhone 11 Pro - 1125 x 2436 pixels</li>\n                <li>iPhone 11 Pro Max - 1242 x 2688 pixels</li>\n                <li>iPhone 12 mini - 1080 x 2340 pixels</li>\n                <li>iPhone 12 - 1170 x 2532 pixels</li>\n                <li>iPhone 12 Pro - 1170 x 2532 pixels</li>\n                <li>iPhone 12 Pro Max - 1284 x 2778 pixels</li>\n                <li>iPhone 14 mini - 1200 x 2592 pixels</li>\n                <li>iPhone 14 - 1200 x 2592 pixels</li>\n                <li>iPhone 14 Pro - 1179 x 2556 pixels</li>\n                <li>iPhone 14 Pro Max - 1290 x 2796 pixels</li>\n                <li>iPhone 15 mini - 1200 x 2592 pixels</li>\n                <li>iPhone 15 - 1200 x 2592 pixels</li>\n                <li>iPhone 15 Pro - 1179 x 2556 pixels</li>\n                <li>iPhone 15 Pro Max - 1290 x 2796 pixels</li>\n              </ul>\n            </div>\n\n          </div>\n\n\n          <zp-theme-Device\n            ng-if="(!vm.selectedPortraitIphoneAspectRatio || vm.selectedPortraitIphoneAspectRatio === \'9:16\')"\n            id="iPhonePortraitPreview" device-type="iphone_portrait" theme="$ctrl.theme" bezel-color="#CED8DD"\n            client-logo-obj="$ctrl.clientDoc.clientLogoImage"></zp-theme-Device>\n\n          <div ng-if="(!vm.selectedPortraitIphoneAspectRatio || vm.selectedPortraitIphoneAspectRatio === \'9:16\')"\n            layout-align="center center" layout="column" flex="40">\n            <p class="md-subhead">iPhone 5 - iPhone 8 PLUS Portrait</p>\n\n            <zp-image-info-table metadata="$ctrl.theme.images.mainMenuImageiPhone.metadata"\n              ng-hide="!$ctrl.theme.images.mainMenuImageiPhone.metadata.title" layout="row" layout-fill\n              layout-align="center center">\n            </zp-image-info-table>\n\n            <zp-image-control-buttons image-obj="$ctrl.theme.images.mainMenuImageiPhone"\n              open-select-dialog="$ctrl.imageDialogButtonClicked($event, imageObj)" layout="row" layout-fill\n              layout-align="center center">\n            </zp-image-control-buttons>\n\n            <div class="device-info-container" layout="column" layout-align="start">\n              <p class="md-caption zp-caption margin-bottom-0"><b>Required Image Ratio: 9:16 Portrait</b></p>\n              <p class="md-caption zp-caption margin-bottom-0">An image set to a 9:16 Portrait aspect ratio will\n                display\n                correctly on all devices on this list. You can choose any image size listed below for all iPhone 5\n                - 8\n                Plus displays:</p>\n\n              <ul class="md-caption zp-caption">\n                <li>iPhone 5 - 640 x 1136 pixels</li>\n                <li>iPhone 5s - 640 x 1136 pixels</li>\n                <li>iPhone SE (1st generation) - 640 x 1136 pixels</li>\n                <li>iPhone SE (2nd generation) - 750 x 1334 pixels</li>\n                <li>iPhone 6 - 750 x 1334 pixels</li>\n                <li>iPhone 6s - 750 x 1334 pixels</li>\n                <li>iPhone 7 - 750 x 1334 pixels</li>\n                <li>iPhone 8 - 750 x 1334 pixels</li>\n                <li>iPhone 6 Plus - 1080 x 1920 pixels</li>\n                <li>iPhone 6s Plus - 1080 x 1920 pixels</li>\n                <li>iPhone 7 Plus - 1080 x 1920 pixels</li>\n                <li>iPhone 8 Plus - 1080 x 1920 pixels</li>\n                <li>iPhone SE (2nd generation) - 750 x 1334 pixels</li>\n              </ul>\n            </div>\n\n          </div>\n\n        </div>\n      </div>\n\n      <md-divider></md-divider>\n\n      <zp-cloud-theme-card theme="$ctrl.theme" device-color="$ctrl.deviceFillColor"\n        open-image-select-dialog="$ctrl.imageDialogButtonClicked($event, imageObj)"\n        update-change-delta="$ctrl.updateChangeDelta(prop1, prop2, newValue)"\n        client-logo-obj="$ctrl.clientDoc.clientLogoImage">\n      </zp-cloud-theme-card>\n\n      <md-divider></md-divider>\n\n      <div layout-align="center center" layout="column">\n        <div class="section-headline-container" style="text-align: center;" layout="column">\n          <span class="md-headline">Theme Snapshot</span>\n          <span class="md-subhead">See how things are looking</span>\n        </div>\n        <zp-theme-snapshot id="theme-snapshot" theme="$ctrl.theme" client-logo-obj="$ctrl.clientDoc.clientLogoImage">\n        </zp-theme-snapshot>\n      </div>\n\n    </div>\n  </md-content>\n</div>');
$templateCache.put('app/clients/theming/zp-theme-overview/zp-theme-overview.tmpl.html','<md-card>\n  <md-card-header>\n    <md-card-header-text>\n      <span class="md-title">Custom Skins</span>\n      <span class="md-subhead">Personalize your Zuant experience</span>\n    </md-card-header-text>\n  </md-card-header>\n  <md-card-content layout-align="center center" layout="column">\n    <zp-theme-snapshot id="theme-snapshot" theme="$ctrl.theme" client-logo-obj="$ctrl.clientLogoObj">\n    </zp-theme-snapshot>\n    <div ng-show="$ctrl.message" layout-padding>\n      <p class="md-body-1"><md-icon md-font-icon="zmdi zmdi-alert-triangle zuantPollen"></md-icon> {{$ctrl.message}}</p>\n    </div>\n  </md-card-content>\n  <md-card-actions layout="row" layout-align="end center">\n    <md-button ng-click="$ctrl.openThemeDialog($event)" class="md-primary"\n      ng-class="{\'pulsate-pollen md-raised\': $ctrl.message}">Manage</md-button>\n  </md-card-actions>\n</md-card>');
$templateCache.put('app/clients/theming/zp-themes-library/zp-themes-library.tmpl.html','<div layout="column" flex>\n  <md-toolbar aria-label="Theme library toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">Custom Skins library</p>\n      <span flex></span>\n      <md-button ng-click="$ctrl.cancel()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-content layout="column" flex>\n\n    <div flex="5" ng-if="$ctrl.showWelcomeMessage"></div>\n    <div layout="row" ng-if="$ctrl.showWelcomeMessage">\n      <md-card layout-padding flex="80" flex-offset="10" flex-gt-sm="60" flex-offset-gt-sm="20"\n        ng-class="{\'hinge\' : $ctrl.hingeWelcomeMessage}" class="animated" ng-cloak>\n        <img ng-src="{{\'/images/pngs/placeholders/custom-skins/customSkinsPlaceholder.png\' | cdnAssets}}" flex="60"\n          flex-offset="20" class="md-card-image" alt="Custom Skins Placeholder Image">\n        <md-card-title>\n          <md-card-title-text>\n            <span class="md-headline">Welcome to Custom Skins</span>\n          </md-card-title-text>\n        </md-card-title>\n        <md-card-content>\n          <p class="md-subhead">\n            The Custom Skins bolt-on allows you to configure different visual themes for your Zuant account. Device\n            specific background images (skins) can be configured to add a visual impact that\'s on brand and looks the\n            part. Jump in and explore!\n          </p>\n        </md-card-content>\n        <md-card-actions layout="row" layout-align="end center">\n          <md-button ng-click="$ctrl.dismissWelcomeMessage()">Dismiss</md-button>\n          <md-button ng-click="$ctrl.learnMore($event)">Learn more</md-button>\n        </md-card-actions>\n      </md-card>\n    </div>\n\n    <div layout="row" layout-xs="column" layout-sm="column" layout-wrap flex-offset-md="5" flex-offset-lg="10"\n      flex-offset-gt-lg="10" layout-align="start stretch" style="margin-bottom: 64px;">\n\n      <md-card ng-repeat="theme in $ctrl.data.items track by theme._id" flex-lg="40" flex-gt-lg="30">\n        <md-card-header>\n          <md-card-header-text class="custom-skin-card-header-text">\n            <span class="md-title">{{theme.name}}</span>\n            <span class="md-subhead">Last edited: {{theme._lastmodifiedonservertime | date: \'short\'}}</span>\n\n          </md-card-header-text>\n          <span flex></span>\n          <md-menu>\n            <md-button aria-label="Context menu" class="md-icon-button" ng-click="$ctrl.openMenu($mdOpenMenu, $event)">\n              <md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon>\n            </md-button>\n            <md-menu-content width="4">\n              <md-menu-item>\n                <md-button ng-click="$ctrl.makePrimaryTheme($event, theme)" ng-disabled="theme.isPrimaryTheme">\n                  <md-icon md-font-icon="zmdi zmdi-palette" md-menu-align-target></md-icon>\n                  <span ng-hide="theme.isPrimaryTheme">Make Primary Skin</span>\n                  <span ng-show="theme.isPrimaryTheme">Primary skin</span>\n                </md-button>\n              </md-menu-item>\n              <md-menu-item permission permission-only="$ctrl.permissions.boltOns.theming.delete">\n                <md-button ng-click="$ctrl.deleteTheme($event, theme)" ng-disabled="theme.isPrimaryTheme">\n                  <md-icon md-font-icon="zmdi zmdi-delete" md-menu-align-target></md-icon>\n                  Delete\n                </md-button>\n              </md-menu-item>\n            </md-menu-content>\n          </md-menu>\n        </md-card-header>\n\n        <md-card-content flex="grow" layout="column">\n          <div layout="column" layout-padding layout-align="start center">\n            <zp-theme-snapshot class="theme-snapshot" theme="theme" client-logo-obj="$ctrl.clientDoc.clientLogoImage">\n            </zp-theme-snapshot>\n          </div>\n\n          <div flex="grow"></div>\n\n          <span ng-if="theme.isPrimaryTheme" class="md-subhead">\n            <md-icon class="md-accent" md-font-icon="zmdi zmdi-palette"></md-icon>Primary Skin\n          </span>\n\n          <div>\n            <p>Cloud Color Palette</p>\n            <theme-preview primary="theme.cloudPrimaryColor" accent="theme.cloudAccentColor" class="library-view">\n            </theme-preview>\n          </div>\n\n          <md-card-actions layout="row" layout-align="end center">\n            <md-button permission permission-only="$ctrl.permissions.boltOns.theming.edit" class="md-accent md-raised"\n              ng-click="$ctrl.editTheme($event, theme._id)">Edit</md-button>\n          </md-card-actions>\n\n        </md-card-content>\n      </md-card>\n    </div>\n  </md-content>\n</div>');
$templateCache.put('app/clients/permissions/zp-action-selector/action-selector.tmpl.html','<div layout-gt-md="row" layout-padding>\n  <div flex-order-gt-md="2">\n    <div layout="row" layout-align="start center">\n      <md-button ng-show="!$ctrl.noUsersInPool() && !$ctrl.showUserNextStepButton" class="md-icon-button"\n        ng-click="$ctrl.resetUserPool()">\n        <md-icon md-font-icon="zmdi zmdi-chevron-left">\n          <md-tooltip>Start over</md-tooltip>\n        </md-icon>\n      </md-button>\n      <p class="md-headline" ng-show="$ctrl.noUsersInPool()"> Select the users you wish to manage from the user list</p>\n      <p class="md-title" ng-show="!$ctrl.noUsersInPool() && !$ctrl.showUserNextStepButton">Pool of selected users:</p>\n    </div>\n    <div ng-show="$ctrl.noUsersInPool()" layout="row" layout-align="center center" layout-align-gt-sm="start center">\n      <div ng-include="$ctrl.dottedDownArrowImageSvg" show-xs show-sm hide-gt-sm></div>\n      <div ng-include="$ctrl.angledLeftArrowImageSvg" hide-xs hide-sm show-gt-md></div>\n    </div>\n  </div>\n  <zp-user-pool-selector hide-gt-sm></zp-user-pool-selector>\n</div>\n\n<div ng-show="!$ctrl.noUsersInPool() && $ctrl.showUserNextStepButton" layout-padding layout-margin flex="100"\n  layout="row" layout-align="center end" ng-class="{\'animated fadeInUp\': $ctrl.showUserNextStepButton}">\n  <div layout="column" layout-align="center center" flex="50">\n    <md-button class="pulsate-aqua animated" ng-click="$ctrl.setViewTo(\'presetAndCustomButtons\')">Next!</md-button>\n    <div ng-include="$ctrl.angledUpArrowImageSvg" layout-padding></div>\n    <p class="md-title">Click this button when you\'re happy with your selection and ready for the next step...</p>\n  </div>\n</div>\n\n<zp-user-pool-with-controls ng-show="$ctrl.showUserPoolView"\n  chips="$ctrl.PermissionsManagerFactory.factoryData.usersObject" set-view-to="$ctrl.setViewTo(view)"\n  view-active="$ctrl.viewActive" pulse-preset-btn="$ctrl.pulsePresetBtn" pulse-custom-btn="$ctrl.pulseCustomBtn"\n  ng-class="{\'animated fadeInUp\': $ctrl.showUserPoolView }">\n</zp-user-pool-with-controls>\n\n<zp-permissions-preset-widget ng-if="$ctrl.viewActive == \'presets\' && !$ctrl.noUsersInPool()"\n  ng-class="{\'animated fadeInUp\' : $ctrl.viewActive == \'presets\'}" reset-user-pool="$ctrl.resetUserPool()">\n</zp-permissions-preset-widget>\n\n<zp-custom-permissions-widget ng-if="$ctrl.viewActive == \'custom\' && !$ctrl.noUsersInPool()"\n  ng-class="{\'animated fadeInUp\' : $ctrl.viewActive == \'custom\'}" reset-user-pool="$ctrl.resetUserPool()">\n</zp-custom-permissions-widget>');
$templateCache.put('app/common/auth/login-form-component/login-form.tmpl.html','<div ng-if="$ctrl.notPermittedToEnterCloud" layout="column" layout-align="space-between center">\n  <md-card ng-cloak layout-padding layout-align="center center">\n    <p class="md-headline margin-bottom-0">You aren\'t permitted to login to the Zuant Cloud</p>\n    <p flex="80" class="md-subhead">Please contact your administrator and ask them to grant you permission</p>\n  </md-card>\n</div>\n\n<md-card ng-cloak ng-if="!$ctrl.notPermittedToEnterCloud">\n  <md-content class="md-padding" layout-padding>\n    <!-- <p class="md-display-1 thin-font zuantTitanium1">Welcome to the Zuant web portal.</p> -->\n    <form name="login" ng-submit="$ctrl.onLoginClicked()" layout-padding>\n      <md-input-container class="md-block">\n        <label for="email">Email</label>\n        <input label="email" name="email" type="email" ng-model="$ctrl.user.email" required tabindex="1" />\n\n        <md-icon style="color:rgba(0,0,0,0.12);" md-font-icon="zmdi zmdi-email"\n          ng-click="$ctrl.setRememberMe()"></md-icon>\n\n        <div ng-messages="login.email.$error" role="alert">\n          <div ng-message="required">\n            <span>Please enter your email</span>\n          </div>\n          <div ng-message="email">\n            <span>That\'s not a valid email address</span>\n          </div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class="md-block">\n        <label for="password">Password</label>\n        <input id="password" label="password" name="password" type="{{$ctrl.passwordFieldType}}"\n          ng-model="$ctrl.user.password" required tabindex="2" />\n        <!-- <md-button class="md-icon-button" > -->\n\n        <md-icon style="color:rgba(0,0,0,0.12);" md-font-icon="zmdi {{$ctrl.passwordFieldIcon}}"\n          ng-click="$ctrl.toggleViewPasswordField()">\n          <md-tooltip>{{$ctrl.passwordFieldTooltip}}</md-tooltip>\n        </md-icon>\n\n        <!-- </md-button> -->\n        <div ng-messages for="login.password.$error">\n          <div ng-message when="required">\n            <span>Please enter your password</span>\n          </div>\n        </div>\n      </md-input-container>\n\n      <div layout="row" layout-align="space-between center">\n        <md-input-container>\n          <md-checkbox ng-model="$ctrl.user.rememberMe" ng-click="$ctrl.updateRememberMe()">\n            <span>Remember email</span>\n          </md-checkbox>\n        </md-input-container>\n\n        <md-input-container>\n          <md-button flex class="md-primary" zp-nav-click="/forgot"\n            aria-label="Forgot your password?">Forgot your password?</md-button>\n        </md-input-container>\n      </div>\n\n      <md-progress-linear ng-if="$ctrl.loading" class="md-accent"></md-progress-linear>\n\n      <md-button class="md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10"\n        type="submit" ng-disabled="login.$invalid || $ctrl.loading"\n        aria-label="Log in">Log in</md-button>\n      <input type="hidden" name="CSRFToken" value="1231234567890" />\n    </form>\n  </md-content>\n</md-card>');
$templateCache.put('app/common/ckeditor/templates/simple.html','<!DOCTYPE html>\r\n<head>\r\n    <meta name="viewport" content="width=device-width"/>\r\n\r\n    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8"/>\r\n    <title>Basic</title>\r\n\r\n    <style>\r\n        * {\r\n            margin: 0;\r\n            padding: 0\r\n        }\r\n\r\n        * {\r\n            font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif\r\n        }\r\n\r\n        img {\r\n            max-width: 100%\r\n        }\r\n\r\n        .collapse {\r\n            margin: 0;\r\n            padding: 0\r\n        }\r\n\r\n        body {\r\n            -webkit-font-smoothing: antialiased;\r\n            -webkit-text-size-adjust: none;\r\n            width: 100% !important;\r\n            height: 100%\r\n        }\r\n\r\n        a {\r\n            color: #2ba6cb\r\n        }\r\n\r\n        .btn {\r\n            display: inline-block;\r\n            padding: 6px 12px;\r\n            margin-bottom: 0;\r\n            font-size: 14px;\r\n            font-weight: normal;\r\n            line-height: 1.428571429;\r\n            text-align: center;\r\n            white-space: nowrap;\r\n            vertical-align: middle;\r\n            cursor: pointer;\r\n            border: 1px solid transparent;\r\n            border-radius: 4px;\r\n            -webkit-user-select: none;\r\n            -moz-user-select: none;\r\n            -ms-user-select: none;\r\n            -o-user-select: none;\r\n            user-select: none;\r\n            color: #333;\r\n            background-color: white;\r\n            border-color: #CCC;\r\n        }\r\n\r\n        p.callout {\r\n            padding: 15px;\r\n            background-color: #ecf8ff;\r\n            margin-bottom: 15px\r\n        }\r\n\r\n        .callout a {\r\n            font-weight: bold;\r\n            color: #2ba6cb\r\n        }\r\n\r\n        table.social {\r\n            background-color: #ebebeb\r\n        }\r\n\r\n        .social .soc-btn {\r\n            padding: 3px 7px;\r\n            border-radius: 2px;\r\n            -webkit-border-radius: 2px;\r\n            -moz-border-radius: 2px;\r\n            font-size: 12px;\r\n            margin-bottom: 10px;\r\n            text-decoration: none;\r\n            color: #FFF;\r\n            font-weight: bold;\r\n            display: block;\r\n            text-align: center\r\n        }\r\n\r\n        a.fb {\r\n            background-color: #3b5998 !important\r\n        }\r\n\r\n        a.tw {\r\n            background-color: #1daced !important\r\n        }\r\n\r\n        a.gp {\r\n            background-color: #db4a39 !important\r\n        }\r\n\r\n        a.ms {\r\n            background-color: #000 !important\r\n        }\r\n\r\n        .sidebar .soc-btn {\r\n            display: block;\r\n            width: 100%\r\n        }\r\n\r\n        table.head-wrap {\r\n            width: 100%\r\n        }\r\n\r\n        .header.container table td.logo {\r\n            padding: 15px\r\n        }\r\n\r\n        .header.container table td.label {\r\n            padding: 15px;\r\n            padding-left: 0\r\n        }\r\n\r\n        table.body-wrap {\r\n            width: 100%\r\n        }\r\n\r\n        table.footer-wrap {\r\n            width: 100%;\r\n            clear: both !important\r\n        }\r\n\r\n        .footer-wrap .container td.content p {\r\n            border-top: 1px solid #d7d7d7;\r\n            padding-top: 15px\r\n        }\r\n\r\n        .footer-wrap .container td.content p {\r\n            font-size: 10px;\r\n            font-weight: bold\r\n        }\r\n\r\n        h1, h2, h3, h4, h5, h6 {\r\n            font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;\r\n            line-height: 1.1;\r\n            margin-bottom: 15px;\r\n            color: #000\r\n        }\r\n\r\n        h1 small, h2 small, h3 small, h4 small, h5 small, h6 small {\r\n            font-size: 60%;\r\n            color: #6f6f6f;\r\n            line-height: 0;\r\n            text-transform: none\r\n        }\r\n\r\n        h1 {\r\n            font-weight: 200;\r\n            font-size: 44px\r\n        }\r\n\r\n        h2 {\r\n            font-weight: 200;\r\n            font-size: 37px\r\n        }\r\n\r\n        h3 {\r\n            font-weight: 500;\r\n            font-size: 27px\r\n        }\r\n\r\n        h4 {\r\n            font-weight: 500;\r\n            font-size: 23px\r\n        }\r\n\r\n        h5 {\r\n            font-weight: 900;\r\n            font-size: 17px\r\n        }\r\n\r\n        h6 {\r\n            font-weight: 900;\r\n            font-size: 14px;\r\n            text-transform: uppercase;\r\n            color: #444\r\n        }\r\n\r\n        .collapse {\r\n            margin: 0 !important\r\n        }\r\n\r\n        p, ul {\r\n            margin-bottom: 10px;\r\n            font-weight: normal;\r\n            font-size: 14px;\r\n            line-height: 1.6\r\n        }\r\n\r\n        p.lead {\r\n            font-size: 17px\r\n        }\r\n\r\n        p.last {\r\n            margin-bottom: 0\r\n        }\r\n\r\n        ul li {\r\n            margin-left: 5px;\r\n            list-style-position: inside\r\n        }\r\n\r\n        ul.sidebar {\r\n            background: #ebebeb;\r\n            display: block;\r\n            list-style-type: none\r\n        }\r\n\r\n        ul.sidebar li {\r\n            display: block;\r\n            margin: 0\r\n        }\r\n\r\n        ul.sidebar li a {\r\n            text-decoration: none;\r\n            color: #666;\r\n            padding: 10px 16px;\r\n            margin-right: 10px;\r\n            cursor: pointer;\r\n            border-bottom: 1px solid #777;\r\n            border-top: 1px solid #fff;\r\n            display: block;\r\n            margin: 0\r\n        }\r\n\r\n        ul.sidebar li a.last {\r\n            border-bottom-width: 0\r\n        }\r\n\r\n        ul.sidebar li a h1, ul.sidebar li a h2, ul.sidebar li a h3, ul.sidebar li a h4, ul.sidebar li a h5, ul.sidebar li a h6, ul.sidebar li a p {\r\n            margin-bottom: 0 !important\r\n        }\r\n\r\n        .container {\r\n            display: block !important;\r\n            max-width: 600px !important;\r\n            margin: 0 auto !important;\r\n            clear: both !important\r\n        }\r\n\r\n        .content {\r\n            padding: 15px;\r\n            max-width: 600px;\r\n            margin: 0 auto;\r\n            display: block\r\n        }\r\n\r\n        .content table {\r\n            width: 100%\r\n        }\r\n\r\n        .column {\r\n            width: 300px;\r\n            float: left\r\n        }\r\n\r\n        .column tr td {\r\n            padding: 15px\r\n        }\r\n\r\n        .column-wrap {\r\n            padding: 0 !important;\r\n            margin: 0 auto;\r\n            max-width: 600px !important\r\n        }\r\n\r\n        .column table {\r\n            width: 100%\r\n        }\r\n\r\n        .social .column {\r\n            width: 280px;\r\n            min-width: 279px;\r\n            float: left\r\n        }\r\n\r\n        .clear {\r\n            display: block;\r\n            clear: both\r\n        }\r\n\r\n        @media only screen and (max-width: 600px) {\r\n            a[class="btn"] {\r\n                display: block !important;\r\n                margin-bottom: 10px !important;\r\n                background-image: none !important;\r\n                margin-right: 0 !important\r\n            }\r\n\r\n            div[class="column"] {\r\n                width: auto !important;\r\n                float: none !important\r\n            }\r\n\r\n            table.social div[class="column"] {\r\n                width: auto !important\r\n            }\r\n        }\r\n    </style>\r\n\r\n</head>\r\n\r\n<body bgcolor="#FFFFFF">\r\n\r\n<!-- HEADER -->\r\n<table class="head-wrap" background="border.png">\r\n    <tr>\r\n        <td></td>\r\n        <td class="header container">\r\n\r\n            <div class="content">\r\n                <table>\r\n                    <tr>\r\n                        <td><img src="http://i.imgur.com/JKU9lzE.jpg" /></td>\r\n                    </tr>\r\n                </table>\r\n            </div>\r\n\r\n        </td>\r\n        <td></td>\r\n    </tr>\r\n</table>\r\n<!-- /HEADER -->\r\n\r\n\r\n<!-- BODY -->\r\n<table class="body-wrap">\r\n    <tr>\r\n        <td></td>\r\n        <td class="container" bgcolor="#FFFFFF">\r\n\r\n            <div class="content">\r\n                <table>\r\n                    <tr>\r\n                        <td>\r\n                            <h3>Hi [[firstname]]</h3>\r\n\r\n                            <p class="lead">This is a simple html example template.</p>\r\n\r\n                            <p>Phasellus dictum sapien a neque luctus cursus. Pellentesque sem dolor, fringilla et\r\n                                pharetra vitae. consequat vel lacus. Sed iaculis pulvinar ligula, ornare fringilla ante\r\n                                viverra et. In hac habitasse platea dictumst. Donec vel orci mi, eu congue justo.\r\n                                Integer eget odio est, eget malesuada lorem. Aenean sed tellus dui, vitae viverra risus.\r\n                                Nullam massa sapien, pulvinar eleifend fringilla id, convallis eget nisi. Mauris a\r\n                                sagittis dui. Pellentesque non lacinia mi. Fusce sit amet libero sit amet erat venenatis\r\n                                sollicitudin vitae vel eros. Cras nunc sapien, interdum sit amet porttitor ut, congue\r\n                                quis urna.</p>\r\n                            <!-- Callout Panel -->\r\n                            <p class="callout">\r\n                                Phasellus dictum sapien a neque luctus cursus. Pellentesque sem dolor, fringilla et\r\n                                pharetra vitae. <a href="#">Click it! &raquo;</a>\r\n                            </p><!-- /Callout Panel -->\r\n\r\n                            <!-- social & contact -->\r\n                            <table class="social" width="100%">\r\n                                <tr>\r\n                                    <td>\r\n\r\n                                        <!-- column 1 -->\r\n                                        <table align="left" class="column">\r\n                                            <tr>\r\n                                                <td>\r\n\r\n                                                    <h5 class="">Connect with Us:</h5>\r\n\r\n                                                    <p class="">\r\n                                                        <a href="#"><img src="http://i.imgur.com/IQQWcY2.png" /></a>\r\n                                                        <a href="#"><img src="http://i.imgur.com/5giiVxA.png" /></a>\r\n                                                        <a href="#"><img src="http://i.imgur.com/ztWaVT1.png" /></a>\r\n                                                    </p>\r\n                                                </td>\r\n                                            </tr>\r\n                                        </table>\r\n                                        <!-- /column 1 -->\r\n\r\n                                        <!-- column 2 -->\r\n                                        <table align="left" class="column">\r\n                                            <tr>\r\n                                                <td>\r\n\r\n                                                    <h5 class="">Contact Info:</h5>\r\n\r\n                                                    <p>Phone: <strong>+44 1344.350.250</strong><br/>\r\n                                                        Email: <strong><a href="emailto:info@zuant.com">info@zuant.com</a></strong>\r\n                                                    </p>\r\n\r\n                                                </td>\r\n                                            </tr>\r\n                                        </table>\r\n                                        <!-- /column 2 -->\r\n\r\n                                        <span class="clear"></span>\r\n\r\n                                    </td>\r\n                                </tr>\r\n                            </table>\r\n                            <!-- /social & contact -->\r\n\r\n                        </td>\r\n                    </tr>\r\n                </table>\r\n            </div>\r\n            <!-- /content -->\r\n\r\n        </td>\r\n        <td></td>\r\n    </tr>\r\n</table>\r\n<!-- /BODY -->\r\n\r\n<!-- FOOTER -->\r\n<table class="footer-wrap">\r\n    <tr>\r\n        <td></td>\r\n        <td class="container">\r\n\r\n            <!-- content -->\r\n            <div class="content">\r\n                <table>\r\n                    <tr>\r\n                        <td align="center">\r\n                            <p>\r\n                                <a href="#">Terms</a> |\r\n                                <a href="#">Privacy</a> |\r\n                                <a href="#">\r\n                                    <unsubscribe>Unsubscribe</unsubscribe>\r\n                                </a>\r\n                            </p>\r\n                        </td>\r\n                    </tr>\r\n                </table>\r\n            </div>\r\n            <!-- /content -->\r\n\r\n        </td>\r\n        <td></td>\r\n    </tr>\r\n</table>\r\n<!-- /FOOTER -->\r\n\r\n</body>\r\n</html>');
$templateCache.put('app/common/editor/form-inputs/zp-forminput.tmpl.html','<!-- Template for text fields -->\n<div ng-if="formInputCtrl.zpMetadata.editable &&\n      formInputCtrl.zpMetadata.type == \'Textfield\' ||\n      formInputCtrl.zpMetadata.type == \'textarea\' ||\n      formInputCtrl.zpMetadata.type == \'number\'" layout-padding>\n  <md-input-container md-no-float class="md-block">\n    <label>{{formInputCtrl.zpMetadata.label}}</label>\n    <input type="text" ng-model="formInputCtrl.value" name="" aria-label="input"\n      ng-blur="formInputCtrl.updateChangeDelta(formInputCtrl.value)" />\n    <md-icon md-font-icon="zmdi zmdi-close" class="faded-text" ng-class="{\'zuantPollen\' : formInputCtrl.clearFlag}"\n      ng-click="formInputCtrl.toggleClearSelection(formInputCtrl.zpMetadata, formInputCtrl.value)">\n      <md-tooltip md-direction="bottom">clear selection</md-tooltip>\n    </md-icon>\n    <div class="hint" ng-if="formInputCtrl.zpMetadata.hiddenInForm" ng-show="formInputCtrl.showHiddenFieldLabel">\n      <md-icon md-font-icon="zmdi zmdi-eye-off" style="font-size:.9em;"></md-icon>\n      hidden field\n    </div>\n    <div class="hint" ng-show="formInputCtrl.clearFlag">\n      All values will be cleared for this field\n    </div>\n  </md-input-container>\n</div>\n\n<!-- Template for radio fields -->\n<div ng-if="formInputCtrl.zpMetadata.editable &&\n      (formInputCtrl.zpMetadata.type == \'ChoiceView\' ||\n      formInputCtrl.zpMetadata.type == \'Tableview\' ||\n      formInputCtrl.zpMetadata.type == \'Lookup\' ||\n      formInputCtrl.zpMetadata.type == \'Consent\' ||\n      formInputCtrl.zpMetadata.type == \'Privacy\' ||\n      formInputCtrl.zpMetadata.type == \'Grid\') &&\n      !formInputCtrl.zpMetadata.allowMultiple" layout-padding>\n  <md-input-container md-no-float class="md-block">\n    <md-select placeholder="{{formInputCtrl.zpMetadata.placeholder}}" ng-model="formInputCtrl.value"\n      aria-label="{{formInputCtrl.zpMetadata.databasefieldname}} select" md-on-open="formInputCtrl.mdOpening()"\n      md-on-close="formInputCtrl.mdClosing()" data-md-container-class="selectdemoSelectHeader">\n      <md-select-header class="demo-select-header">\n        <input ng-keydown="$event.stopPropagation()" ng-model="searchTermSingle" type="search"\n          placeholder="Filter answers" class="demo-header-searchbox md-text">\n        <md-button ng-click="formInputCtrl.value = \'\'">\n          <small>clear</small>\n        </md-button>\n      </md-select-header>\n      <md-optgroup>\n        <md-option ng-value="answer" ng-click="formInputCtrl.handleRadioClickEvent($event, answer)"\n          ng-repeat-start="answer in formInputCtrl.zpMetadata.answers | filter:searchTermSingle">{{answer.displayValue}}</md-option>\n        <div ng-repeat-end ng-if="formInputCtrl.moreInfoCheck(answer)" layout-fill layout-padding\n          style="margin-top:15px;">\n          <md-input-container layout-fill>\n            <label>More info</label>\n            <input ng-model="answer.moreInfo" ng-keydown="$event.stopPropagation()" />\n          </md-input-container>\n        </div>\n      </md-optgroup>\n    </md-select>\n    <md-icon md-font-icon="zmdi zmdi-close" class="faded-text" ng-class="{\'zuantPollen\' : formInputCtrl.clearFlag}"\n      ng-click="formInputCtrl.toggleClearSelection(formInputCtrl.zpMetadata, formInputCtrl.value)">\n      <md-tooltip md-direction="bottom">clear selection</md-tooltip>\n    </md-icon>\n  </md-input-container>\n\n  <div class="hint" ng-if="formInputCtrl.zpMetadata.hiddenInForm" ng-show="formInputCtrl.showHiddenFieldLabel">\n    <md-icon md-font-icon="zmdi zmdi-eye-off" style="font-size:.9em;"></md-icon>\n    hidden field\n  </div>\n  <div class="hint" ng-show="formInputCtrl.clearFlag">\n    Values will be cleared\n    </p>\n  </div>\n</div>\n\n<!-- Template for checkbox fields -->\n<div ng-if="formInputCtrl.zpMetadata.editable &&\n        (formInputCtrl.zpMetadata.type == \'ChoiceView\' ||\n        formInputCtrl.zpMetadata.type == \'Tableview\' ||\n        formInputCtrl.zpMetadata.type == \'Lookup\' ||\n        formInputCtrl.zpMetadata.type == \'Grid\') &&\n        formInputCtrl.zpMetadata.allowMultiple" layout-padding>\n  <md-input-container md-no-float class="md-block">\n    <md-select placeholder="{{formInputCtrl.zpMetadata.placeholder}}" ng-model="formInputCtrl.value"\n      aria-label="{{formInputCtrl.zpMetadata.databasefieldname}} select" md-on-open="formInputCtrl.mdOpening()"\n      md-on-close="formInputCtrl.mdClosing()" data-md-container-class="selectdemoSelectHeader" multiple>\n      <md-select-header class="demo-select-header">\n        <input ng-keydown="$event.stopPropagation()" ng-model="searchTermMulti" type="search"\n          placeholder="Filter answers" class="demo-header-searchbox md-text">\n        <md-button ng-click="formInputCtrl.value = \'\'">\n          <small>clear</small>\n        </md-button>\n      </md-select-header>\n      <md-optgroup>\n        <md-option ng-value="answer" ng-click="answer.selected = !answer.selected"\n          ng-repeat-start="answer in formInputCtrl.zpMetadata.answers | filter:searchTermMulti">{{answer.displayValue}}\n        </md-option>\n        <div ng-repeat-end ng-if="formInputCtrl.moreInfoCheck(answer)" layout-fill layout-padding\n          style="margin-top:15px;">\n          <md-input-container layout-fill>\n            <label>More info</label>\n            <input ng-model="answer.moreInfo" ng-keydown="$event.stopPropagation()" />\n          </md-input-container>\n        </div>\n      </md-optgroup>\n    </md-select>\n    <md-icon md-font-icon="zmdi zmdi-close" class="faded-text" ng-class="{\'zuantPollen\' : formInputCtrl.clearFlag}"\n      ng-click="formInputCtrl.toggleClearSelection(formInputCtrl.zpMetadata, formInputCtrl.value)">\n      <md-tooltip md-direction="bottom">clear selection</md-tooltip>\n    </md-icon>\n  </md-input-container>\n  <div class="hint" ng-if="formInputCtrl.zpMetadata.hiddenInForm" ng-show="formInputCtrl.showHiddenFieldLabel">\n    <md-icon md-font-icon="zmdi zmdi-eye-off" style="font-size:.9em;"></md-icon>\n    hidden field\n  </div>\n  <div class="hint" ng-show="formInputCtrl.clearFlag">\n    Values will be cleared\n  </div>\n</div>');
$templateCache.put('app/common/editor/image-cell/image-cell-viewer.tmpl.html','<md-edit-dialog class="md-whiteframe-1dp">\n  <div class="dialog-action-btn-container" layout="row" layout-padding>\n    <div layout="row" class="switch-img-btn-container">\n      <md-button ng-repeat="imageId in imageCellCtrl.arrayOfImageIds" ng-click="imageCellCtrl.getImageSrc(imageId)"\n        ng-class="{\'link-active\' : imageId == imageCellCtrl.idOfImageInView}"\n        ng-if="imageCellCtrl.arrayOfImageIds.length > 1">\n        Image {{$index + 1}}\n      </md-button>\n    </div>\n    <span flex></span>\n    <md-button class="md-icon-button" ng-click="imageCellCtrl.closeImageDialog()">\n      <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      <md-tooltip md-direction="bottom">Close dialog</md-tooltip>\n    </md-button>\n  </div>\n  <div layout="column" class="md-content" flex layout-fill id="grid-image-container">\n    <md-progress-linear ng-if="imageCellCtrl.loading" class="md-accent" md-mode="indeterminate"></md-progress-linear>\n    <img degrees="imageCellCtrl.angle" zp-rotate ng-src="{{imageCellCtrl.src}}" id="grid-image" />\n\n\n  </div>\n  <div layout="row" layout-align="center center">\n    <md-button class="md-icon-button" ng-click="imageCellCtrl.rotate(-90)">\n      <md-icon md-font-icon="zmdi zmdi-rotate-ccw"></md-icon>\n      <md-tooltip md-direction="top">Rotate left</md-tooltip>\n    </md-button>\n    <md-button class="md-icon-button" ng-click="imageCellCtrl.rotate(90)">\n      <md-icon md-font-icon="zmdi zmdi-rotate-cw"></md-icon>\n      <md-tooltip md-direction="top">Rotate right</md-tooltip>\n    </md-button>\n  </div>\n</md-edit-dialog>');
$templateCache.put('app/common/editor/multi-edit/dialog.tmpl.html','<md-dialog aria-label="Multi edit cells" flex="100" flex-gt-sm="90">\n  <md-toolbar aria-label="Create list dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">Multi edit values</p>\n      <span flex></span>\n      <md-menu>\n        <md-button aria-label="Context menu" class="md-icon-button" ng-click="ctrl.openMenu($mdOpenMenu, $event)">\n          <md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon>\n        </md-button>\n        <md-menu-content width="4">\n          <md-menu-item>\n            <md-button ng-click="ctrl.showHiddenFieldLabels = !ctrl.showHiddenFieldLabels"\n              aria-label="Toggle hidden field labels">\n              <span ng-show="ctrl.showHiddenFieldLabels">\n                <md-icon md-font-icon="zmdi zmdi-eye-off"></md-icon>\n                Hide hidden field labels\n              </span>\n              <span ng-show="!ctrl.showHiddenFieldLabels">\n                <md-icon md-font-icon="zmdi zmdi-eye"></md-icon>\n                Show hidden field labels\n              </span>\n            </md-button>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n      <md-button ng-click="ctrl.cancel()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-dialog-content layout-padding>\n    <form name="multEditForm" ng-submit="ctrl.submit()">\n\n      <div layout="column" layout-fill layout-padding layout-align="space-around center">\n\n        <p>You are currently in a multi-edit session, any values you change here will update all your selected rows. To\n          clear values click the\n          <md-icon md-font-icon="zmdi zmdi-close"></md-icon> icon next to the field you wish to clear. To clear the\n          selection for a multiple choice question, click the answer list and then the clear button.\n        </p>\n        <p>Selected records count: <b>{{ ctrl.selectedRecordsCount }}</b></p>\n\n        <div layout="row" layout-wrap layout-fill layout-padding>\n          <zp-form-input ng-repeat="mdata in ctrl.metadata" flex="100" flex-gt-xs="50" flex-gt-sm="33" flex-gt-md="20"\n            zp-metadata="mdata" zp-update-change-delta="ctrl.updateChangeDelta(mdata, value, clearFlag)"\n            show-hidden-field-label="ctrl.showHiddenFieldLabels" ng-if="mdata.showCol">\n          </zp-form-input>\n        </div>\n      </div>\n\n      <input type="hidden" name="CSRFToken" value="1231234567890" />\n    </form>\n  </md-dialog-content>\n  <md-dialog-actions>\n    <md-button class="md-warn" ng-click="ctrl.cancel()">Cancel</md-button>\n    <md-button class="md-primary" ng-click="ctrl.submit()" aria-label="Create list">Done editing</md-button>\n  </md-dialog-actions>\n\n</md-dialog>');
$templateCache.put('app/common/editor/read-only/email-events-cell.tmpl.html','<md-edit-dialog class="md-whiteframe-1dp" style="background: white;">\n\n  <md-content layout-fill style="max-height: 30vh; overflow: scroll; background: white">\n    <md-progress-linear ng-if="ctrl.loading" class="md-accent" md-mode="indeterminate"></md-progress-linear>\n\n    <md-list>\n      <md-list-item class="md-2-line" ng-repeat="item in ctrl.zpModel">\n        <div class="md-list-item-text">\n          <h3 style="white-space: normal; text-transform: capitalize;">\n            <md-icon md-font-icon="zmdi {{item.icon}}"></md-icon>\n            {{item.event}} <span style="font-size: 12px !important; color: rgba(0,0,0,.54) !important;"> {{item.dt | date: \'short\'}}</span>\n          </h3>\n          <p>{{item._emailTemplateId | zpEmailTemplateTitle}}</p>\n        </div>\n        <md-divider ng-if="!$last"></md-divider>\n      </md-list-item>\n\n    </md-list>\n  </md-content>\n\n  <md-divider></md-divider>\n\n  <div layout="column">\n    <md-button flex class="md-primary" ng-click="ctrl.closeDialog(true)">Done</md-button>\n  </div>\n\n</md-edit-dialog>');
$templateCache.put('app/common/editor/read-only/literature-cell.tmpl.html','<md-edit-dialog class="md-whiteframe-1dp" style="background: white;">\n\n  <md-content layout-fill style="max-height: 35vh; overflow: scroll; background: white">\n    <md-progress-linear ng-if="ctrl.loading" class="md-accent" md-mode="indeterminate"></md-progress-linear>\n\n    <md-list>\n      <md-list-item class="md-2-line" ng-repeat="item in ctrl.zpModel">\n        <div class="md-list-item-text">\n          <h3 style="white-space: normal;">{{item.title}}</h3>\n        </div>\n        <md-button class="md-secondary md-icon-button" ng-href="{{item.weburi}}" target="_blank">\n            <md-icon md-font-icon="zmdi zmdi-open-in-new"></md-icon>\n            <md-tooltip md-direction="top">Open link in new window</md-tooltip>\n          </md-button>\n      </md-list-item>\n\n    </md-list>\n  </md-content>\n\n  <md-divider></md-divider>\n\n  <div layout="column">\n    <md-button flex class="md-primary" ng-click="ctrl.closeDialog(true)">Done</md-button>\n  </div>\n\n</md-edit-dialog>\n');
$templateCache.put('app/common/editor/read-only/message-composer-cell.tmpl.html','<md-edit-dialog class="md-whiteframe-1dp" style="background: white;">\n  <md-content layout-fill style="max-height: 35vh; overflow: scroll; background: white">\n    <md-list>\n      <md-list-item ng-repeat="message in ctrl.zpModel" class="md-3-line">\n        <div class="md-list-item-text">\n          <h3>Subject: {{message.subject}}</h3>\n          <p>Sent: {{message.dateSent | date: \'medium\'}}</p>\n          <p>Recipients: <span ng-repeat="recipient in message.to">{{recipient.email}}, </span></p>\n        </div>\n      </md-list-item>\n    </md-list>\n\n  </md-content>\n\n  <md-divider></md-divider>\n\n  <div layout="column">\n    <md-button flex class="md-primary" ng-click="ctrl.closeDialog(true)">Done</md-button>\n  </div>\n\n</md-edit-dialog>\n');
$templateCache.put('app/common/editor/read-only/templates-sent-cell.tmpl.html','<md-edit-dialog class="md-whiteframe-1dp" style="background: white;">\n\n  <md-content layout-fill style="max-height: 30vh; overflow: scroll; background: white">\n    <md-progress-linear ng-if="ctrl.loading" class="md-accent" md-mode="indeterminate"></md-progress-linear>\n\n    <md-list>\n      <md-list-item class="md-2-line" ng-repeat="item in ctrl.zpModel">\n        <div class="md-list-item-text">\n          <h3 style="white-space: normal; text-transform: capitalize;">\n            <md-icon md-font-icon="zmdi zmdi-mail-send"></md-icon>{{item._emailTemplateId | zpEmailTemplateTitle}}\n          </h3>\n          <p>{{item._initialcreatedatelocalutc | date: \'short\'}}</p>\n        </div>\n      </md-list-item>\n\n    </md-list>\n  </md-content>\n\n  <md-divider></md-divider>\n\n  <div layout="column">\n    <md-button flex class="md-primary" ng-click="ctrl.closeDialog(true)">Done</md-button>\n  </div>\n\n</md-edit-dialog>');
$templateCache.put('app/common/editor/text-cell/text-cell-editor.tmpl.html','<div class="container">\n  <md-edit-dialog class="md-whiteframe-1dp">\n    <div layout="column" class="md-content">\n      <div ng-if="textCellCtrl.zpMetadata.type === \'Textview\'" class="md-title">{{textCellCtrl.zpMetadata.label ||\n        \'Editing\'}}</div>\n      <form name="editDialog" layout="column" ng-submit="textCellCtrl.closeDialog(true)">\n        <md-input-container md-no-float>\n          <input ng-blur="textCellCtrl.inputLostFocus(true)" name="table-cell"\n            ng-if="textCellCtrl.zpMetadata.type == \'Textfield\'"\n            aria-label="{{textCellCtrl.zpMetadata.databasefieldname}}" ng-model="textCellCtrl.zpModel"\n            ng-change="textCellCtrl.updateValue(textCellCtrl.zpModel)"\n            placeholder="{{ textCellCtrl.zpMetadata.placeholder }}" id="focusMe"\n            type="{{textCellCtrl.zpMetadata.validation.type}}" ng-pattern="textCellCtrl.zpMetadata.validation.pattern">\n          <textarea ng-if="textCellCtrl.zpMetadata.type == \'Textview\'"\n            aria-label="{{textCellCtrl.zpMetadata.databasefieldname}}" ng-model="textCellCtrl.zpModel"\n            ng-change="textCellCtrl.updateValue(textCellCtrl.zpModel)"\n            placeholder="{{ textCellCtrl.zpMetadata.placeholder }}" id="focusMe"></textarea>\n          <div ng-messages="editDialog.table-cell.$error">\n            <div ng-if="textCellCtrl.formErrors" ng-repeat="error in textCellCtrl.formErrors">{{error.message}}</div>\n          </div>\n        </md-input-container>\n        <input type="hidden" name="CSRFToken" value="1231234567890" />\n      </form>\n    </div>\n    <div ng-if="textCellCtrl.zpMetadata.type === \'Textview\'" layout="row" layout-align="end" class="md-actions">\n      <md-button class="md-primary" ng-click="textCellCtrl.closeDialog(false)">Cancel</md-button>\n      <md-button class="md-primary" ng-click="textCellCtrl.closeDialog(true)">OK</md-button>\n    </div>\n  </md-edit-dialog>\n</div>');
$templateCache.put('app/common/layouts/frameworks/app-homescreen-framework-no-sidebar.tmpl.html','<zp-app-toolbar></zp-app-toolbar>\n\n<md-content layout="row" layout-align="stretch" flex ui-view="spof" class="no-overflow"></md-content>\n\n<uiview ui-view="fab-container"></uiview>\n\n<md-sidenav id="mainNavigation" md-component-id="mainNavigation" class="md-sidenav-left">\n  <zp-main-menu-nav></zp-main-menu-nav>\n</md-sidenav>\n\n<md-sidenav id="settingsPanel"\n  md-component-id=\'settingsPanel\'\n  class="md-sidenav-right">\n      <zp-sidenav></zp-sidenav>\n</md-sidenav>\n');
$templateCache.put('app/common/layouts/frameworks/app-homescreen-framework.tmpl.html','<zp-app-toolbar></zp-app-toolbar>\n\n<md-content layout="column" layout-gt-md="row" flex>\n\n  <md-content\n    ui-view="right-hand-container"\n    md-theme="zuantCloudSkin"\n    theme-background="primary:hue-2"\n    flex-gt-md="40"\n    flex-order-gt-md="2"\n    hide-xs\n    hide-sm\n    layout="column"\n    style="overflow-y: hidden;">\n  </md-content>\n\n  <div layout="column" flex>\n    <div ui-view="toolbarSection"></div>\n    <md-content\n      flex-order-gt-md="1"\n      flex ui-view="spof">\n    </md-content>\n  </div>\n\n</md-content>\n\n<uiview ui-view="fab-container"></uiview>\n\n<md-sidenav id="mainNavigation" md-component-id="mainNavigation" class="md-sidenav-left">\n  <zp-main-menu-nav></zp-main-menu-nav>\n</md-sidenav>\n\n<md-sidenav\n  id="settingsPanel"\n  md-component-id=\'settingsPanel\'\n  class="md-sidenav-right">\n  <zp-sidenav></zp-sidenav>\n</md-sidenav>\n');
$templateCache.put('app/common/layouts/frameworks/custom-toolbar-app-view-framework.tmpl.html','<zp-app-toolbar></zp-app-toolbar>\n\n<div ui-view="custom-toolbar"></div>\n\n<div layout="row" flex>\n\n  <md-content\n    ui-view="spofSibling"\n    layout="column" flex="30">\n  </md-content>\n\n  <md-content\n    ui-view="spof"\n    layout="column"\n    flex>\n  </md-content>\n\n</div>\n\n<uiview ui-view="fab-container"></uiview>\n\n<md-sidenav md-component-id=\'mainNavigation\' class="md-sidenav-left">\n  <zp-main-menu-nav></zp-main-menu-nav>\n</md-sidenav>\n\n<md-sidenav id="settingsPanel" md-component-id=\'settingsPanel\' class="md-sidenav-right">\n  <zp-sidenav></zp-sidenav>\n</md-sidenav>\n');
$templateCache.put('app/common/layouts/frameworks/single-view-framework.tmpl.html','<uiview ui-view="spof" layout="column" flex></uiview>\n<uiview ui-view="fab-container"></uiview>\n<md-sidenav id="settingsPanel"\n  md-component-id=\'settingsPanel\'\n  class="md-sidenav-right">\n      <zp-sidenav></zp-sidenav>\n</md-sidenav>\n');
$templateCache.put('app/common/layouts/frameworks/tabbed-app-tall-toolbar-view-framework.tmpl.html','  <zp-app-toolbar></zp-app-toolbar>\n\n  <md-toolbar class="md-tall md-accen">\n    <span flex></span>\n    <div ui-view="tall-toolbar"></div>\n  </md-toolbar>\n\n  <div ui-view="tab-navbar"></div>\n\n  <div layout="row"\n    flex>\n\n        <div md-component-id=\'leftSidebar\'\n          ng-show="$ctrl.views.showLeftSidebar"\n          ui-view="left-hand-container"\n          hide-xs\n          hide-sm\n          flex-md="25"\n          flex-gt-lg="20"\n          style="background-color: rgb(250,250,250);"></div>\n\n        <md-content ui-view="spof"\n          flex>\n        </md-content>\n\n        <div ui-view="right-hand-container"></div>\n  </div>\n\n  <uiview ui-view="fab-container"></uiview>\n\n  <md-sidenav md-component-id=\'mainNavigation\'\n    class="md-sidenav-left">\n        <zp-main-menu-nav></zp-main-menu-nav>\n  </md-sidenav>\n\n  <md-sidenav id="settingsPanel"\n    md-component-id=\'settingsPanel\'\n    class="md-sidenav-right">\n        <zp-sidenav></zp-sidenav>\n  </md-sidenav>\n');
$templateCache.put('app/common/layouts/frameworks/tabbed-app-view-framework.tmpl.html','<zp-elevated-security-toolbar></zp-elevated-security-toolbar>\n<zp-app-toolbar></zp-app-toolbar>\n<zp-title-toolbar></zp-title-toolbar>\n\n<div class="no-scrollbars-visible">\n  <div ui-view="tab-navbar"></div>\n</div>\n\n\n<div layout="row" flex>\n\n  <div md-component-id=\'leftSidebar\' ui-view="left-hand-container" hide-xs hide-sm ng-show="$ctrl.views.showLeftSidebar"\n    flex-md="25" flex-gt-lg="20" style="background-color: rgb(250,250,250);"></div>\n\n  <md-content ui-view="spof" flex>\n  </md-content>\n\n  <div ui-view="right-hand-container" flex="{{$ctrl.views.rightHandContainerWidth}}" layout-fill\n    md-theme="zuantCloudSkin" theme-background="primary:hue-2" style="overflow-y: scroll;">\n  </div>\n</div>\n\n<uiview ui-view="fab-container"></uiview>\n\n<md-sidenav md-component-id=\'mainNavigation\' class="md-sidenav-left">\n  <zp-main-menu-nav></zp-main-menu-nav>\n</md-sidenav>\n\n<md-sidenav id="settingsPanel" md-component-id=\'settingsPanel\' class="md-sidenav-right">\n  <zp-sidenav></zp-sidenav>\n</md-sidenav>');
$templateCache.put('app/common/layouts/frameworks/toolbar-app-view-framework.tmpl.html','<zp-app-toolbar></zp-app-toolbar>\n\n<zp-title-toolbar></zp-title-toolbar>\n\n<md-content ui-view="spof" layout="column" flex></md-content>\n\n<uiview ui-view="fab-container"></uiview>\n\n<md-sidenav md-component-id=\'mainNavigation\' class="md-sidenav-left">\n  <zp-main-menu-nav></zp-main-menu-nav>\n</md-sidenav>\n\n<md-sidenav id="settingsPanel"\n  md-component-id=\'settingsPanel\'\n  class="md-sidenav-right">\n      <zp-sidenav></zp-sidenav>\n</md-sidenav>\n');
$templateCache.put('app/common/menus/app-menu/bottom-sheet-grid-template.tmpl.html','<md-bottom-sheet class="md-grid" layout="column">\n  <div layout="row" layout-align="center center" ng-cloak>\n    <h4>Where do you want to go fool?</h4>\n  </div>\n  <div ng-cloak>\n    <md-list flex layout="row" layout-align="center center">\n      <md-list-item ng-repeat="item in $ctrl.items">\n        <div>\n          <md-button zp-link="{{item.path}}" class="md-grid-item-content md-primary {{item.className}}" ng-click="$ctrl.listItemClick($index)">\n            <md-icon md-font-icon="zmdi {{item.icon}}"></md-icon>\n            <div class="md-grid-text"> {{item.name}} </div>\n          </md-button>\n        </div>\n      </md-list-item>\n    </md-list>\n  </div>\n</md-bottom-sheet>\n');
$templateCache.put('app/common/message/custom-dialogs/confirm-action-with-input.tmpl.html','<md-dialog aria-label="{{ msg.title }}">\n    <md-dialog-content class="md-dialog-content">\n        <h2 class="md-title">{{ msg.title }}</h2>\n\n        <div style="margin-top: 5%;" ng-bind-html="msg.htmlContent"></div>\n\n        <p>Please enter \'<b>{{ msg.confirmationText }}</b>\' to confirm you wish to continue.</p>\n\n        <form style="margin-top: 5%;" name="confirmationForm" novalidate>\n            <md-input-container layout-fill>\n                <label>Enter Confirmation Text Here</label>\n                <input name="confirmationInput" ng-model="userInput" zp-confirmation-text-validator\n                    target-confirmation-text="{{ msg.confirmationText }}" required>\n                <div ng-messages="confirmationForm.confirmationInput.$error" md-auto-hide="false"\n                    ng-show="confirmationForm.confirmationInput.$dirty">\n                    <div ng-message="required">Confirmation is required</div>\n                    <div ng-message when="confirmationText">\n                        Invalid confirmation text\n                    </div>\n                </div>\n            </md-input-container>\n        </form>\n    </md-dialog-content>\n    <md-dialog-actions layout="row">\n        <md-button ng-click="cancel()" class="md-primary">{{ msg.cancelBtn }}</md-button>\n        <md-button ng-disabled="userInput !== msg.confirmationText" ng-click="submit()" class="md-primary">{{\n            msg.okBtn }}</md-button>\n    </md-dialog-actions>\n</md-dialog>');
$templateCache.put('app/common/message/zp-actionable-toast/toast-with-action.tmpl.html','<md-toast md-theme class="md-zuantCloudSkin-theme md-bottom md-right">\n  <div class="md-toast-content">\n  <span class="md-toast-text" flex>{{vm.title}}</span>\n  <md-button class="md-highlight" ng-click="vm.openMoreInfo($event)">\n    More info\n  </md-button>\n  <!-- <md-button ng-click="$ctrl.closeToast()">\n    Close\n  </md-button> -->\n</div>\n</md-toast>\n');
$templateCache.put('app/common/sidenav/main-menu-nav/zp-main-menu-nav.tmpl.html','<div class="zp-app-settings" layout-fill>\n  <md-content layout-fill layout="column" style="min-height: calc(100vh - 113px);height: calc(100vh - 113px);">\n    <div layout-padding layout-align="center center">\n      <div ng-include src="$ctrl.zuantLogoURL" style="max-height:24px;"></div>\n    </div>\n    <ul style="padding: 0;min-height: calc(100vh - 167px);">\n      <li ng-repeat="item in $ctrl.primaryNavItems" permission permission-sref="item.baseState">\n\n        <md-button ng-if="item.href" ng-click="$ctrl.openLink(item.href, item.openInNew)"\n          ng-disabled="($ctrl.clientDoc.clientArchived || $ctrl.clientDoc.clientOperationStatus) && (item.name !==\'Accounts\' && item.name !==\'Logout\' && item.name !==\'Referral\')"\n          style="margin: 0px; width: 100%; text-align: left; padding: 10px 4px;"\n          class="{{item.className}} nav-list-item">\n          <md-icon ng-if="item.icon" md-font-icon="zmdi {{item.icon}}"\n            style="color: #949CA1; margin-left: 15px;"></md-icon>\n          <md-icon ng-if="item.svgicon" md-svg-src="{{item.svgicon}}"\n            style="color: #949CA1; margin-left: 15px;"></md-icon>\n\n          <span style="margin-left: 15px; color: #949CA1;"> {{item.name}} </span>\n          <md-icon ng-if="item.openInNew" md-font-icon="zmdi zmdi-open-in-new"\n            style="color: #CED8DD; position: absolute; right: 10px; top: 17px;"></md-icon>\n        </md-button>\n\n        <md-button ng-if="item.sref" style="margin: 0px; width: 100%; text-align: left; padding: 7px 4px;"\n          open-in-new="{{item.openInNew}}" class="{{item.className}} nav-list-item" ng-click="$ctrl.goOrExpand(item)"\n          ui-sref-active="active-nav-item"\n          ng-disabled="($ctrl.clientDoc.clientArchived || $ctrl.clientDoc.clientOperationStatus) && (item.name !==\'Accounts\' && item.name !==\'Logout\' && item.name !==\'Referral\')">\n          <md-icon md-font-icon="zmdi {{item.icon}}" style="color: #949CA1; margin-left: 15px;"></md-icon>\n          <span ng-class="{\'active\': $ctrl.isCurrentNavItem(item) }" class="navLabel animated"\n            style="margin-left: 15px; color: #949CA1;"> {{item.name}} </span>\n          <md-icon ng-if="item.openInNew" md-font-icon="zmdi zmdi-open-in-new"\n            style="color: #CED8DD; position: absolute; right: 10px; top: 17px;"></md-icon>\n          <md-icon ng-if="item.subLinks" ng-show="!item.expanded" md-font-icon="zmdi zmdi-chevron-left"\n            style="color: #CED8DD; position: absolute; right: 10px; top: 17px;"></md-icon>\n          <md-icon ng-if="item.subLinks" ng-show="item.expanded" md-font-icon="zmdi zmdi-chevron-down"\n            style="color: #CED8DD; position: absolute; right: 10px; top: 17px;"></md-icon>\n        </md-button>\n        <ul ng-if="item.subLinks" ng-show="item.expanded" style="padding: 0;background-color:#ECF2F5">\n          <li ng-repeat="subLink in item.subLinks">\n            <md-button style="margin: 0px; width: 100%; text-align: left; padding: 7px 4px;" class="nav-list-item"\n              ui-sref="{{subLink.sref}}" ui-sref-active="active-nav-item">\n              <md-icon md-font-icon="zmdi {{subLink.icon}}" style="color: #949CA1; margin-left: 15px;"></md-icon>\n              <span style="margin-left: 15px; color: #949CA1;">{{subLink.name}}</span>\n            </md-button>\n          </li>\n        </ul>\n        <md-divider></md-divider>\n      </li>\n    </ul>\n    <!-- <div flex></div> -->\n    <div style="position: fixed; bottom: 0; width: 100%; background: #fff;">\n      <md-divider></md-divider>\n      <md-list style="padding: 0;">\n        <md-list-item ng-repeat="item in $ctrl.secondaryNavItems" style="padding: 0;" class="visible-icons">\n          <md-button ng-if="item.href" style="margin: 0px; width: 100%; text-align: left; padding: 10px 4px;"\n            ng-click="$ctrl.openLink(item.href, item.openInNew)" class="{{item.className}} nav-list-item">\n            <md-icon md-font-icon="zmdi {{item.icon}}" style="color: #949CA1; margin-left: 15px;"></md-icon>\n            <span style="margin-left: 15px; color: #949CA1;"> {{item.name}} </span>\n            <md-icon ng-if="item.openInNew" md-font-icon="zmdi zmdi-open-in-new"\n              style="color: #CED8DD; position: absolute; right: 10px; top: 17px;"></md-icon>\n          </md-button>\n          <md-button ng-if="item.sref" style="margin: 0px; width: 100%; text-align: left; padding: 10px 4px;"\n            open-in-new="{{item.openInNew}}" class="{{item.className}} nav-list-item" ng-click="$ctrl.goOrExpand(item)">\n            <md-icon md-font-icon="zmdi {{item.icon}}" style="color: #949CA1; margin-left: 15px;"></md-icon>\n            <span style="margin-left: 15px; color: #949CA1;"> {{item.name}} </span>\n            <md-icon ng-if="item.openInNew" md-font-icon="zmdi zmdi-open-in-new"\n              style="color: #CED8DD; position: absolute; right: 10px; top: 17px;"></md-icon>\n          </md-button>\n        </md-list-item>\n      </md-list>\n    </div>\n  </md-content>\n</div>');
$templateCache.put('app/common/tables/column/zp-table-column.tmpl.html','<span>\n  <md-icon md-svg-icon="arrow-up.svg" ng-show="gridTableCtrl.showSortIcon(mdata.object, mdata.databasefieldname)" class="md-sort-icon" ng-class="gridTableCtrl.getSortDirection()"></md-icon>\n  <span>\n    {{mdata.label}}\n  </span>\n  <md-icon class="hidden-field" md-font-icon="zmdi zmdi-eye-off" ng-if="mdata.hiddenInForm">\n    <md-tooltip md-direction="top">hidden field</md-tooltip>\n  </md-icon>\n</span>\n');
$templateCache.put('app/common/toolbars/app-toolbar/zp-app-toolbar.tmpl.html','<md-toolbar class="primary-toolbar">\n  <div class="md-toolbar-tools">\n\n    <!-- app menu button -->\n    <md-button class="md-icon-button" ng-click="$ctrl.showSideNav()" aria-label="navigation">\n      <md-tooltip md-direction="">app menu</md-tooltip>\n      <ng-md-icon icon="menu" style="fill: #fff;" size="24"></ng-md-icon>\n    </md-button>\n\n    <!-- settings menu button/zuant logo -->\n    <md-button class="md-no-ripple" zp-link="dashboard" style="cursor:pointer" layout-align="center center"\n      aria-label="Go to dashboard page">\n      <md-tooltip md-direction="">Go to dashboard</md-tooltip>\n      <div ng-include src="$ctrl.zuantLogoURL" style="max-height:24px;"></div>\n    </md-button>\n\n    <!-- <p style="margin-left:20px;color: #486d91 ;">|</p> -->\n    <!-- <p class="md-subhead" style="margin-left: 20px;">{{ $ctrl.menuData.pageTitle }}</p> -->\n    <!-- <md-button flex="30" style="background: rgba(255,255,255,0.1); height: 46px;">\n      <md-input-container md-no-float class="md-block toolbar-input">\n        <md-icon md-font-icon="zmdi zmdi-search"></md-icon>\n        <input ng-model="user.phone" type="text" placeholder="Search">\n      </md-input-container>\n    </md-button> -->\n\n    <span flex></span>\n\n    <zp-account-selection>\n    </zp-account-selection>\n\n    <!-- TODO <zp-intercom/> -->\n    <a id="my_custom_link" href="mailto:lecc1l4p@incoming.intercom.io">\n      <md-button class="md-icon-button" aria-label="intercom">\n        <md-tooltip md-direction="">intercom</md-tooltip>\n        <md-icon md-font-icon="zmdi zmdi-comment-outline" ng-show="!unreadMessagesCount"></md-icon>\n        <md-icon md-font-icon="zmdi zmdi-comment" ng-show="unreadMessagesCount > 0"></md-icon>\n        <span ng-show="unreadMessagesCount > 0" class="toolbar-button-badge animated ng-scope md-cyan-white-theme"\n          theme-background="accent">{{unreadMessagesCount}}</span>\n      </md-button>\n    </a>\n\n    <!--  APP SETTINGS -->\n    <md-button class="md-icon-button open-menu" style="padding:0;" ng-click="$ctrl.showSettings()"\n      aria-label="notifications" permission permission-only="\'ZUANT_ADMIN\'">\n      <md-icon md-font-icon="zmdi zmdi-notifications-none"\n        ng-show="$ctrl.notificationsCount.effectedForms.length === 0"></md-icon>\n      <md-icon md-font-icon="zmdi zmdi-notifications"\n        ng-show="$ctrl.notificationsCount.effectedForms.length > 0"></md-icon>\n      <md-tooltip md-direction="">notifications</md-tooltip>\n      <span class="toolbar-button-badge animated ng-scope md-cyan-white-theme" theme-background="accent"\n        ng-show="$ctrl.notificationsCount.effectedForms.length > 0">{{$ctrl.notificationsCount.effectedForms.length}}</span>\n    </md-button>\n\n    <!-- <md-button class="md-icon-button open-menu" ng-click="$ctrl.showGridBottomSheet()" aria-label="navigation">\n      <md-tooltip md-direction="">menu</md-tooltip>\n      <md-icon md-font-icon="zmdi zmdi-menu"></md-icon>\n    </md-button> -->\n\n  </div>\n</md-toolbar>');
$templateCache.put('app/common/toolbars/elevated-security-toolbar/zp-elevated-security-toolbar.tmpl.html','<md-toolbar class="md-accent short-toolbar animated" ng-if="$ctrl.factoryData.userPermittedToMakeGDPREdits.permitted && $ctrl.userIsOnAccountSettingsPages" ng-class="{\'pulsate-pollen\' : $ctrl.timeExpiryWarning, \'pulsate-saffron\' : $ctrl.timeExpired, \'flipOutX\' : !$ctrl.factoryData.userPermittedToMakeGDPREdits.permitted}">\n  <div class="md-toolbar-tools">\n    <span ng-if="!$ctrl.timeExpired">Your Vault edit session expires {{$ctrl.countdown}}</span>\n    <span ng-if="$ctrl.timeExpired">Your edit session expired {{$ctrl.countdown}}. Please save any unsaved changes and end the edit session by clicking the button over there \uD83D\uDC49</span>\n    <span flex></span>\n    <md-button ng-click="$ctrl.endEditSession()" class="md-primary md-raised" ng-disabled="$ctrl.disableBtn">\n      <md-progress-linear tyle="left: -5px; top: -5px;" md-mode="indeterminate" ng-if="$ctrl.disableBtn" class="md-accent"></md-progress-linear>\n      <span ng-show="!$ctrl.disableBtn">End Edit Session</span>\n    </md-button>\n  </div>\n</md-toolbar>\n');
$templateCache.put('app/common/toolbars/instance-toolbar/zp-instance-toolbar.tmpl.html','<md-toolbar class="md-prmary md-hue-" layout="row" md-scroll-shrink flex="100">\n  <div class="md-toolbar-tools">\n    <md-button zp-nav-click="{{$ctrl.navigateTo}}" aria-label="Back button" class="md-icon-button">\n      <md-icon md-font-icon="zmdi zmdi-arrow-left"></md-icon>\n      <md-tooltip md-direction="right">go back</md-tooltip>\n    </md-button>\n    <p class="md-subhead margin-bottom-0 margin-top-0">{{$ctrl.title}}</p>\n    <span flex></span>\n    <zp-context-menu\n      ng-if="!!$ctrl.menuOptions"\n      menu-options="$ctrl.menuOptions">\n    </zp-context-menu>\n  </div>\n</md-toolbar>\n');
$templateCache.put('app/common/toolbars/search-toolbar/zp-search-toolbar.tmpl.html','<md-toolbar class="md-table-toolbar md-default">\n  <div class="md-toolbar-tools">\n    <md-button class="md-icon-button" ng-click="$ctrl.toggleShowSearchBar()" ng-class="{\'btn-active\': $ctrl.showSearch}" aria-label="toggle search">\n      <md-icon md-font-icon="zmdi zmdi-search"></md-icon>\n      <md-tooltip md-direction="down">{{$ctrl.metadata.title.filterLabel}}</md-tooltip>\n    </md-button>\n    <p class="md-subhead zuantTitanium1" ng-show="!$ctrl.showSearch">{{$ctrl.metadata.title.label}}</p>\n    <md-input-container ng-show="$ctrl.showSearch" flex class="margin-bottom-0 margin-top-40" style="margin-left:30px;">\n      <label>{{$ctrl.metadata.title.filterLabel}}</label>\n      <input ng-model="$ctrl.searchVal.searchVal" aria-label="{{$ctrl.metadata.title.label}}" ng-show="$ctrl.showSearch" ng-change="$ctrl.updateFilter({searchVal: $ctrl.searchVal.searchVal})" focus-on-show />\n    </md-input-container>\n    <div flex></div>\n    <zp-context-menu\n      ng-if="!!$ctrl.menuOptions"\n      menu-options="$ctrl.menuOptions"\n      on-menu-click="$ctrl.onMenuClick({action: action, ev: ev})">\n    </zp-context-menu>\n  </div>\n</md-toolbar>\n');
$templateCache.put('app/common/toolbars/title-toolbar/zp-title-toolbar.tmpl.html','<md-toolbar class="md-table-toolbar md-default">\n  <div class="md-toolbar-tools">\n    <md-button class="md-icon-button" style="margin-right:10px;"\n      ui-sref="{{$ctrl.toolbar.navigationPath}}($ctrl.toolbar.stateParams)"\n      ui-sref-opts="{ custom: $ctrl.toolbar.customStateParams }" \n      ng-if="$ctrl.toolbar.showBackButton">\n      <md-icon md-font-icon="zmdi zmdi-chevron-left"></md-icon>\n      <md-tooltip md-direcion="down">Go back</md-tooltip>\n    </md-button>\n    <p class="md-subhead zuantTitanium1" id="truncate">{{$ctrl.toolbar.title}}</p>\n  </div>\n</md-toolbar>');
$templateCache.put('app/common/user-helpers/zp-new-badge/zp-new-badge.tmpl.html','<span \n  class="pulsate-aqua"\n  style="color: #fff; line-height: 1.5rem; border-radius: 20%; text-align: center; display: inline-block; letter-spacing: .2px; padding: 3px; margin-left: .5rem; font-size:1.1rem;">\n  NEW\n</span>');
$templateCache.put('app/common/widgets/websummit-partner-id-select/tmpl.html','<p>Select the websummit partner from the dropdown below</p>\n<md-autocomplete\n          md-selected-item="$ctrl.selectedItem"\n          md-search-text-change="$ctrl.searchTextChange($ctrl.searchText)"\n          md-search-text="$ctrl.searchText"\n          md-selected-item-change="$ctrl.selectedItemChange(item)"\n          md-items="item in $ctrl.querySearch($ctrl.searchText)"\n          md-item-text="item.name"\n          md-min-length="0"\n          input-aria-label="Partner Id"\n          md-floating-label="Select the partner from the list">\n        <md-item-template>\n          <span class="item-title">\n            <span> {{item.name}} </span>\n          </span>\n          <span class="md-caption item-metadata">id: {{item.id}}</span>\n        </md-item-template>\n      </md-autocomplete>');
$templateCache.put('app/common/widgets/zp-blocks-select/zp-blocks.tmpl.html','<md-progress-linear ng-if="$ctrl.loading" md-mode="indeterminate" class="md-accent">\n</md-progress-linear>\n\n<md-autocomplete ng-if="!$ctrl.loading" md-no-cache="true" md-selected-item="$ctrl.selectedItem"\n  md-search-text="$ctrl.searchText" md-selected-item-change="$ctrl.onChangeLocal(item)"\n  md-items="item in $ctrl.querySearch($ctrl.searchText)" md-item-text="item.nameplate" md-min-length="0"\n  placeholder="{{$ctrl.config.placeholder}}" aria-label="Select control"\n  md-floating-label="{{$ctrl.config.floatingLabel}}" md-menu-class="autocomplete-custom-template"\n  ng-required="{{$ctrl.config.required}}" md-input-name="{{$ctrl.config.name}}" md-require-match md-clear-button="true"\n  ng-disabled="$ctrl.loading">\n\n  <md-item-template>\n    <span class="item-title">\n      <span md-highlight-text="searchText" md-highlight-flags="^i">\n        {{item.nameplate}}\n      </span>\n    </span>\n  </md-item-template>\n\n  <md-not-found>\n    No items matching "{{searchText}}" were found.\n  </md-not-found>\n\n  <div class="errors" ng-messages="$ctrl.formname[$ctrl.config.title].$error">\n    <div ng-message="required">Required</div>\n  </div>\n</md-autocomplete>');
$templateCache.put('app/common/widgets/zp-chart-component/zp-chart.tmpl.html','<div id="container">\n  <div id="overlap" ng-show="$ctrl.loading">\n    <div layout="row" layout-sm="column" layout-align="center center" aria-label="wait" style="height:100%;">\n      <md-progress-circular class="md-accent" md-mode="indeterminate"></md-progress-circular>\n    </div>\n  </div>\n  <canvas layout-padding class="chart-base" chart-data="$ctrl.chartData" chart-labels="$ctrl.chartLabels"\n    chart-series="$ctrl.chartSeries" chart-type="$ctrl.chartType" chart-click="$ctrl.chartClicked"\n    chart-options="$ctrl.chartOptionDefaults" loading="$ctrl.loading">\n  </canvas>\n</div>');
$templateCache.put('app/common/widgets/zp-email-templates/zp-email-templates.tmpl.html','<div\n  ng-if="$ctrl.session.getUserData().accountPermissions.boltOns.emails.enabled">\n  <md-autocomplete\n    md-no-cache="true"\n    md-selected-item="$ctrl.selectedItem"\n    md-search-text="$ctrl.searchText"\n    md-selected-item-change="$ctrl.onChangeLocal({ item: item })"\n    md-items="item in $ctrl.querySearch($ctrl.searchText)"\n    md-item-text="item.title"\n    md-min-length="0"\n    placeholder="{{$ctrl.config.placeholder}}"\n    aria-label="Select control"\n    md-floating-label="{{$ctrl.config.floatingLabel}}"\n    md-menu-class="autocomplete-custom-template"\n    ng-required="{{$ctrl.config.required}}"\n    md-input-name="{{$ctrl.config.name}}"\n    md-require-match="true"\n    md-select-on-match="true"\n    md-clear-button="!$ctrl.ddisabled"\n    ng-disabled="$ctrl.ddisabled">\n    <md-item-template>\n     <span class="item-title">\n       <md-icon md-font-icon="zmdi zmdi-check" class="zuantAqua" ng-if="item.icn == \'published\'"></md-icon>\n       <md-icon md-font-icon="zmdi zmdi-settings" class="zuantPollen" ng-if="item.icn == \'draft\'"></md-icon>\n       <md-icon md-font-icon="zmdi zmdi-close" class="zuantSaffron" ng-if="item.icn == \'archived\'"></md-icon>\n       <md-icon md-font-icon="zmdi zmdi-power" class="zuantSaffron" ng-if="item.icn == \'power\'"></md-icon>\n       <span md-highlight-text="searchText"\n        md-highlight-flags="^i">\n        {{item.title}}\n      </span>\n     </span>\n    </md-item-template>\n    <md-not-found>\n      No items matching "{{searchText}}" were found.\n    </md-not-found>\n    <div class="errors" ng-messages="$ctrl.formname[$ctrl.config.title].$error">\n      <div ng-message="required">Required</div>\n    </div>\n  </md-autocomplete>\n</div>\n');
$templateCache.put('app/common/widgets/zp-form-filters-control/form-filters.tmpl.html','<div layout="row"\n  layout="end end"\n  flex\n  ng-show="$ctrl.filtersHydrated.length">\n      <span flex></span>\n      <div ng-show="$ctrl.showClearConfirmation">\n        Clear {{$ctrl.filtersHydrated.length}} filters?\n        <md-button class="md-primary md-raised" ng-click="$ctrl.clearConfirmation()">YES \u2702\uFE0F</md-button>\n        <md-button class="md-accent" ng-click="$ctrl.showClearConfirmation = false">NO</md-button>\n      </div>\n      <md-button class="md-accent"\n        ng-show="!$ctrl.showClearConfirmation"\n        ng-click="$ctrl.onClear()"\n        permission\n        permission-only="\'INTEGRATION_MACHINES_EDIT\'">\n            Clear filters\n      </md-button>\n</div>\n<md-chips ng-model="$ctrl.filtersHydrated"\n  md-autocomplete-snap\n  md-require-match="true"\n  md-on-add="$ctrl.onAdd($chip)"\n  md-on-remove="$ctrl.onRemove($chip)"\n  readonly="$ctrl.readonly">\n      <md-autocomplete md-search-text="$ctrl.searchText"\n        md-items="item in $ctrl.querySearch($ctrl.searchText) | filter: { isSelected: false }"\n        md-item-text="item.title"\n        md-require-match\n        md-no-cache\n        md-min-length="0"\n        placeholder="This machine will run for the following forms, leave blank to run for all forms"\n        permission\n        permission-only="\'INTEGRATION_MACHINES_EDIT\'">\n            <span class="item-title">\n                  <md-icon md-font-icon="zmdi zmdi-check"\n                    class="zuantAqua"\n                    ng-if="item.icn == \'published\'"></md-icon>\n                  <md-icon md-font-icon="zmdi zmdi-settings"\n                    class="zuantPollen"\n                    ng-if="item.icn == \'draft\'"></md-icon>\n                  <md-icon md-font-icon="zmdi zmdi-close"\n                    class="zuantSaffron"\n                    ng-if="item.icn == \'archived\'"></md-icon>\n                  <span md-highlight-text="searchText"\n                    md-highlight-flags="^i">\n                        {{item.title}}\n                  </span>\n            </span>\n      </md-autocomplete>\n      <md-chip-template>\n            <span>\n                  <md-icon md-font-icon="zmdi zmdi-check"\n                    class="zuantAqua"\n                    ng-if="$chip.icn == \'published\'"></md-icon>\n                  <md-icon md-font-icon="zmdi zmdi-settings"\n                    class="zuantPollen"\n                    ng-if="$chip.icn == \'draft\'"></md-icon>\n                  <md-icon md-font-icon="zmdi zmdi-close"\n                    class="zuantSaffron"\n                    ng-if="$chip.icn == \'archived\'"></md-icon>\n                  <strong>{{$chip.title}}</strong>\n            </span>\n      </md-chip-template>\n</md-chips>\n<div ng-show="$ctrl.showMissMatchWarning">\n      <p>This machine contains form filters that couldn\'t be found. You can clear your machine filters by clicking the button below.</p>\n      <md-button class="md-accent md-raised"\n        ng-click="$ctrl.onClear($event)">Clear filters</md-button>\n</div>\n');
$templateCache.put('app/common/widgets/zp-form-select/zp-form-select.tmpl.html','<md-autocomplete\n  md-no-cache="true"\n  md-selected-item="$ctrl.selectedItem"\n  md-search-text="$ctrl.searchText"\n  md-selected-item-change="$ctrl.onChange({ item: item })"\n  md-items="item in $ctrl.querySearch($ctrl.searchText)"\n  md-item-text="item.title"\n  md-min-length="0"\n  placeholder="{{$ctrl.config.placeholder}}"\n  aria-label="Select control"\n  md-floating-label="{{$ctrl.config.floatingLabel}}"\n  md-menu-class="autocomplete-custom-template"\n  ng-required="{{$ctrl.config.required}}"\n  md-input-name="{{$ctrl.config.name}}"\n  md-require-match="true"\n  md-select-on-match="true"\n  md-clear-button="true">\n  <md-item-template>\n   <span class="item-title">\n     <md-icon md-font-icon="zmdi zmdi-check" class="zuantAqua" ng-if="item.icn == \'published\'"></md-icon>\n     <md-icon md-font-icon="zmdi zmdi-settings" class="zuantPollen" ng-if="item.icn == \'draft\'"></md-icon>\n     <md-icon md-font-icon="zmdi zmdi-close" class="zuantSaffron" ng-if="item.icn == \'archived\'"></md-icon>\n     <span md-highlight-text="searchText"\n      md-highlight-flags="^i">\n      {{item.title}}\n    </span>\n   </span>\n </md-item-template>\n  <md-not-found>\n    No items matching "{{searchText}}" were found.\n  </md-not-found>\n  <div class="errors" ng-messages="$ctrl.formname[$ctrl.config.title].$error">\n    <div ng-message="required">Required</div>\n  </div>\n</md-autocomplete>\n');
$templateCache.put('app/common/widgets/zp-form-widget-select/zp-form-widget-select.tmpl.html','<md-autocomplete\n  flex\n  md-no-cache="true"\n  md-selected-item="$ctrl.selectedItem"\n  md-search-text="$ctrl.searchText"\n  md-selected-item-change="$ctrl.onChange({ item: item.keyValue })"\n  md-items="item in $ctrl.querySearch($ctrl.searchText)"\n  md-item-text="item.displayValue"\n  md-min-length="0"\n  placeholder="{{$ctrl.config.placeholder}}"\n  aria-label="Select control"\n  md-floating-label="{{$ctrl.floatingLabel}}"\n  md-menu-class="autocomplete-custom-template"\n  ng-required="{{$ctrl.config.required}}"\n  md-input-name="{{$ctrl.config.name}}"\n  md-require-match\n  md-clear-button="true">\n  <md-item-template>\n   <span class="item-title">\n     <span md-highlight-text="searchText"\n      md-highlight-flags="^i">\n      {{item.displayValue}}\n    </span>\n   </span>\n </md-item-template>\n  <md-not-found>\n    No items matching "{{searchText}}" were found.\n  </md-not-found>\n  <div class="errors" ng-messages="$ctrl.formname[$ctrl.config.title].$error">\n    <div ng-message="required">Required</div>\n  </div>\n</md-autocomplete>\n');
$templateCache.put('app/common/widgets/zp-list-autocomplete/zp-list-autocomplete.tmpl.html','<md-autocomplete md-no-cache="true" md-selected-item="$ctrl.selectedItem" md-search-text="$ctrl.searchText"\n  md-selected-item-change="$ctrl.selectedItemChanged(item); $ctrl.onChange(item)"\n  md-items="item in $ctrl.querySearch($ctrl.searchText)" md-item-text="item.title" md-min-length="0"\n  placeholder="{{$ctrl.config.placeholder}}" aria-label="Select control"\n  md-floating-label="{{$ctrl.config.floatingLabel}}" md-menu-class="autocomplete-custom-template"\n  ng-required="{{$ctrl.config.required}}" md-input-name="{{$ctrl.config.name}}" md-require-match\n  md-dropdown-position="{{$ctrl.config.position}}" md-clear-button="true">\n  <md-item-template>\n    <span class="item-title">\n      <md-icon md-font-icon="zmdi zmdi-check" class="zuantAqua" ng-if="item.icn == \'published\'"></md-icon>\n      <md-icon md-font-icon="zmdi zmdi-settings" class="zuantPollen" ng-if="item.icn == \'draft\'"></md-icon>\n      <md-icon md-font-icon="zmdi zmdi-close" class="zuantSaffron" ng-if="item.icn == \'archived\'"></md-icon>\n      <span md-highlight-text="searchText" md-highlight-flags="^i">\n        {{item.title}}\n      </span>\n    </span>\n  </md-item-template>\n  <md-not-found>\n    No items matching "{{searchText}}" were found.\n  </md-not-found>\n  <div class="errors" ng-messages="$ctrl.formname[$ctrl.config.title].$error">\n    <div ng-message="required">Required</div>\n  </div>\n</md-autocomplete>');
$templateCache.put('app/common/widgets/zp-list-templates-select/zp-list-templates-select.tmpl.html','<md-autocomplete md-no-cache="true" md-selected-item="$ctrl.selectedItem" md-search-text="$ctrl.searchText"\n  md-selected-item-change="$ctrl.selectedItemChanged(item); $ctrl.onChange(item)"\n  md-items="item in $ctrl.querySearch(searchText)" md-item-text="item.title" md-min-length="0"\n  placeholder="{{$ctrl.config.placeholder}}" aria-label="Select control"\n  md-floating-label="{{$ctrl.config.floatingLabel}}" md-menu-class="autocomplete-custom-template"\n  ng-required="{{$ctrl.config.required}}" md-input-name="{{$ctrl.config.name}}" md-require-match md-clear-button="true">\n  <md-item-template>\n    <span class="item-title">\n      <span md-highlight-text="searchText" md-highlight-flags="^i">\n        {{item.title}}\n      </span>\n    </span>\n  </md-item-template>\n  <md-not-found>\n    No items matching "{{searchText}}" were found.\n  </md-not-found>\n  <div class="errors" ng-messages="$ctrl.formname[$ctrl.config.title].$error">\n    <div ng-message="required">Required</div>\n  </div>\n</md-autocomplete>');
$templateCache.put('app/common/widgets/zp-ocr-templates-select/zp-ocr-templates.tmpl.html','<!-- <md-input-container class="md-block">\n  <label>OCR Template </label>\n  <md-select placeholder="Choose a template for this form to use" ng-model="$ctrl.valueProperty" ng-change="$ctrl.onChange({templateId: $ctrl.valueProperty})">\n    <md-option value="">Please Select</md-option>\n    <md-option ng-value="template._id" ng-repeat="template in $ctrl.OCRTemplates" ng-show="!template._deletedatelocalutc">{{template.title}}</md-option>\n  </md-select>\n</md-input-container> -->\n<md-autocomplete\n  md-no-cache="true"\n  md-selected-item="$ctrl.selectedItem"\n  md-search-text="$ctrl.searchText"\n  md-selected-item-change="$ctrl.onChange({ item: item._id })"\n  md-items="item in $ctrl.querySearch(searchText)"\n  md-item-text="item.title"\n  md-min-length="0"\n  placeholder="{{$ctrl.config.placeholder}}"\n  aria-label="Select control"\n  md-floating-label="{{$ctrl.config.floatingLabel}}"\n  md-menu-class="autocomplete-custom-template"\n  ng-required="{{$ctrl.config.required}}"\n  md-input-name="{{$ctrl.config.name}}"\n  md-require-match\n  md-clear-button="true">\n  <md-item-template>\n   <span class="item-title">\n     <span md-highlight-text="searchText"\n      md-highlight-flags="^i">\n      {{item.title}}\n    </span>\n   </span>\n  </md-item-template>\n  <md-not-found>\n    No items matching "{{searchText}}" were found.\n  </md-not-found>\n  <div class="errors" ng-messages="$ctrl.formname[$ctrl.config.title].$error">\n    <div ng-message="required">Required</div>\n  </div>\n</md-autocomplete>\n');
$templateCache.put('app/common/widgets/zp-privacy-statements/zp-privacy-statements.tmpl.html','<md-autocomplete\n  md-no-cache="true"\n  md-selected-item="$ctrl.selectedItem"\n  md-search-text="$ctrl.searchText"\n  md-selected-item-change="$ctrl.onChange({ item: item })"\n  md-items="item in $ctrl.querySearch($ctrl.searchText)"\n  md-item-text="item.title"\n  md-min-length="0"\n  placeholder="{{$ctrl.config.placeholder}}"\n  aria-label="Select control"\n  md-floating-label="{{$ctrl.config.floatingLabel}}"\n  md-menu-class="autocomplete-custom-template"\n  ng-required="{{$ctrl.config.required}}"\n  md-input-name="{{$ctrl.config.name}}"\n  md-require-match\n  md-clear-button="true">\n  <md-item-template>\n   <span class="item-title">\n     <md-icon md-font-icon="zmdi zmdi-check" class="zuantAqua" ng-if="item.icn == \'published\'"></md-icon>\n     <md-icon md-font-icon="zmdi zmdi-settings" class="zuantPollen" ng-if="item.icn == \'draft\'"></md-icon>\n     <md-icon md-font-icon="zmdi zmdi-close" class="zuantSaffron" ng-if="item.icn == \'archived\'"></md-icon>\n     <span md-highlight-text="searchText"\n      md-highlight-flags="^i">\n      {{item.title}}\n    </span>\n   </span>\n  </md-item-template>\n  <md-not-found>\n    No items matching "{{searchText}}" were found.\n  </md-not-found>\n  <div class="errors" ng-messages="$ctrl.formname[$ctrl.config.title].$error">\n    <div ng-message="required">Required</div>\n  </div>\n</md-autocomplete>\n');
$templateCache.put('app/common/widgets/zp-select-control/zp-select-control.tmpl.html','<md-autocomplete\n  md-no-cache="true"\n  md-selected-item="$ctrl.selectedItem"\n  md-search-text="searchText"\n  md-selected-item-change="$ctrl.onChange({ item: item.title })"\n  md-items="item in $ctrl.querySearch(searchText)"\n  md-item-text="item.title"\n  md-min-length="0"\n  placeholder="{{$ctrl.config.placeholder}}"\n  aria-label="Select control"\n  md-floating-label="{{$ctrl.config.floatingLabel}}"\n  md-menu-class="autocomplete-custom-template"\n  ng-required="{{$ctrl.config.required}}"\n  md-input-name="{{$ctrl.config.name}}"\n  md-require-match="true"\n  md-select-on-match="true"\n  md-clear-button="true">\n  <md-item-template>\n   <span class="item-title">\n     <span md-highlight-text="searchText"\n      md-highlight-flags="^i">\n      {{item.title}}\n    </span>\n   </span>\n </md-item-template>\n  <md-not-found>\n    No items matching "{{searchText}}" were found.\n  </md-not-found>\n  <div class="errors" ng-messages="$ctrl.formname[$ctrl.config.title].$error">\n    <div ng-message="required">Required</div>\n  </div>\n</md-autocomplete>\n');
$templateCache.put('app/common/widgets/zp-stat-chart/zp-stat-chart.tmpl.html','<div flex>\n  <div layout-align="center center" layout="column" layout-fill>\n    <md-progress-circular ng-if="$ctrl.loading" class="md-accent" md-mode="indeterminate" ></md-progress-circular>\n    <div id="center_positioned_metadata" layout="column" layout-align="center center">\n      <p class="md-display-1 margin-bottom-0 margin-top-0" countupto="$ctrl.metadata.countUpTo" decimals="0" duration="1.4"></p>\n      <p class="md-caption">{{$ctrl.metadata.title}}</p>\n    </div>\n    <canvas\n      id="foo"\n      class="chart-base"\n      chart-data="$ctrl.chartData"\n      chart-labels="$ctrl.chartLabels"\n      chart-options="$ctrl.chartOptionDefaults"\n      chart-type="$ctrl.chartType">\n    </canvas>\n  </div>\n</div>\n');
$templateCache.put('app/common/widgets/zp-totals-table/zp-totals-table.tmpl.html','<md-table-container id="totalsTableContainer">\n  <table class="md-table">\n    <!-- table header  //-->\n    <thead class="md-head">\n      <tr class="md-row" md-row>\n        <th class="md-column">\n          #\n        </th>\n        <th class="md-column">\n          {{$ctrl.header.label}}\n        </th>\n        <th class="md-column">\n          {{$ctrl.header.countAlias}}\n        </th>\n      </tr>\n    </thead>\n    <!-- table body  //-->\n    <tbody class="md-body">\n\n      <tr ng-repeat="row in $ctrl.data" class="md-row">\n        <td class="md-cell">\n          {{ $index + 1 }}\n        </td>\n        <td class="md-cell">\n          {{row.caption}}\n        </td>\n        <td class="md-cell">\n          {{$ctrl.processCount(row.count)}}\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</md-table-container>');
$templateCache.put('app/common/widgets/zp-user-select-chips/user-select-chips.tmpl.html','<h3><md-icon md-font-icon="zmdi zmdi-mail-send" aria-label="Close dialog"></md-icon>Integration error email recipients</h3>\n<p ng-if="$ctrl.model.length == 0">If there\'s an integration error Zuant will send an email. Select which users you would like to receive them.</p>\n<p ng-if="$ctrl.model.length >= 1">The users below will receive integration error emails.</p>\n\n<md-contact-chips\n    ng-model="$ctrl.model"\n    ng-change="$ctrl.onModelChange($ctrl.model)"\n    md-contacts="$ctrl.querySearch($query)"\n    md-contact-name="name"\n    md-contact-image="image"\n    md-contact-email="email"\n    md-require-match="true"\n    md-separator-keys="ctrl.keys"\n    md-highlight-flags="i"\n    placeholder="Type name to see matches"\n    secondary-placeholder="Begin typing to add users"\n    input-aria-label="Integration error email recipients">\n</md-contact-chips>\n');
$templateCache.put('app/clients/permissions/zp-custom-permissions-widget/custom-permissions-widget.tmpl.html','<ng-container ng-repeat="block in $ctrl.metadata" permission permission-only="block.permissionOnly" layout-padding\n  layout-margin flex-gt-md="80" flex-offset-gt-md="10" flex-gt-lg="70" flex-offset-gt-lg="15">\n\n  <h3 ng-if="block.label">\n\n    <md-icon ng-if="block.icon" md-font-icon={{block.icon}}></md-icon>\n    <md-icon ng-if="block.svgicon" md-svg-src="{{block.svgicon}}"></md-icon>\n\n  </h3>\n\n  <p ng-if="block.blurb">{{block.blurb}}</p>\n\n  <md-card ng-repeat="card in block.cards" layout-padding layout-margin flex="100">\n\n    <md-card-header>\n\n      <md-card-avatar id="animateSpin">\n\n        <md-icon ng-if="card.icon" ng-hide="card.showImg" class="md-avatar-icon" md-font-icon="{{card.icon}}"></md-icon>\n        <md-icon ng-if="card.svgicon" ng-hide="card.showImg" md-svg-src="{{card.svgicon}}"></md-icon>\n\n        <img ng-show="card.showImg" class="md-avatar-icon" ng-src="{{card.imgSrc}}" />\n\n      </md-card-avatar>\n\n      <md-card-header-text>\n\n        <span class="md-title">{{card.label}}</span>\n        <span class="md-subhead">{{card.blurb}}</span>\n\n      </md-card-header-text>\n\n      <div>\n\n        <span class="md-body1 zp-caption"\n          ng-show="block.property == \'boltOns\' && !$ctrl.accountBoltOns[block.property][card.property].enabled">\n          BOLT-ON DISABLED\n        </span>\n\n        <md-button class="md-icon-button" ng-click="$ctrl.expandAllBtnClicked(card)"\n          ng-hide="block.property == \'boltOns\' && !$ctrl.accountBoltOns[block.property][card.property].enabled">\n\n          <ng-md-icon icon="{{card.expandAllIcon}}" style="fill: #949ca1;"></ng-md-icon>\n\n        </md-button>\n\n      </div>\n\n    </md-card-header>\n\n    <md-card-content layout="column" ng-show="card.showPermissions"\n      ng-if="$ctrl.accountBoltOns[block.property][card.property].enabled || block.property == \'trump\' || block.property == \'login\' || block.property == \'accountManagement\'">\n\n      <div layout flex="40" flex-offset="5" layout-align="end center" ng-repeat="group in card.permissionGroups"\n        permission permission-only="group.permissionOnly">\n\n        <p class="md-subtitle zp-caption" flex="10">{{group.label}}</p>\n\n        <md-list layout-fill>\n\n          <div flex layout="row" layout-wrap="" class="alternate-background-color">\n            <md-list-item flex="33" ng-repeat="item in group.items"\n              ng-click="$ctrl.permissionClicked(block, card, group, item)" permission\n              permission-only="item.permissionOnly">\n\n              <p>{{item.label}}</p>\n\n              <ng-md-icon icon="{{$ctrl.setIcon(block, card, group, item, \'icon\')}}"\n                style="{{$ctrl.setIcon(block, card, group, item, \'style\')}}" size="24"></ng-md-icon>\n\n            </md-list-item>\n\n          </div>\n\n        </md-list>\n\n      </div>\n\n    </md-card-content>\n\n  </md-card>\n\n</ng-container>');
$templateCache.put('app/email/detail/forms-used-dialog/dialog.tmpl.html','<md-dialog aria-label="?" class="fullscreen-dialog">\n  <form>\n    <md-toolbar style="min-height: auto; height: auto;">\n      <div class="md-toolbar-tools" style="height: auto; max-height: none;">\n        <p class="md-title" style="overflow: hidden; text-overflow: ellipsis;">Managing events using {{vm.templateTitle}} template</p>\n        <span flex></span>\n        <md-button ng-click="vm.cancel()">\n          <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n        </md-button>\n      </div>\n    </md-toolbar>\n    <md-toolbar class="md-table-toolbar md-default">\n      <div class="md-toolbar-tools">\n        <md-input-container flex="50" style="margin-top: 60px;">\n          <md-icon md-font-icon="md-primary zmdi zmdi-search"></md-icon>\n          <input type="text" ng-model="search.formname" placeholder="Search events">\n        </md-input-container>\n        <span flex></span>\n      </div>\n    </md-toolbar>\n    <div class="md-dialog-content" layout="column" layout-fill>\n\n      <!-- IMPORTANT!!! must have layout-fill for all parents of md-content in order for the scrolling to work properly. See this github thread for more info: https://github.com/angular/material/issues/4022 -->\n      <div layout="row" layout-fill>\n        <md-card flex-gt-xs="50">\n          <md-content>\n            <section>\n              <md-subheader class="md-primary pointer-cursor">\n                ALL EVENTS\n              </md-subheader>\n              <md-list>\n                <md-list-item class="md-2-line" ng-repeat="form in vm.forms | filter:search track by form._id" ng-click="vm.toggleEmailTemplateForForm(form, false)" ng-if="form.emailtemplatetitle == \'None set\'" aria-label="{{form.formname}}-list-item">\n                  <md-icon md-font-icon="fa fa-lg fa-plus" class="zuantTitanium1"></md-icon>\n                  <div class="md-list-item-text">\n                    <h3><i ng-bind-html="form.icn | iconify"></i> &nbsp;{{::form.formname}}</h3>\n                    <p>\n                      <md-icon md-font-icon="zmdi zmdi-mail-send" class="icn_1x"></md-icon> {{::form.emailtemplatetitle}}</p>\n                  </div>\n                </md-list-item>\n              </md-list>\n            </section>\n            <section>\n              <md-subheader class="md-primary pointer-cursor">\n                EVENTS USING A DIFFERENT TEMPLATE\n              </md-subheader>\n              <md-list>\n                <md-list-item ng-repeat="form in vm.forms | filter:search track by form._id" ng-click="vm.toggleEmailTemplateForForm(form, true)" class="md-2-line" ng-if="form.emailTemplate != \'\' && form.emailTemplate != vm.currentEmailTemplateId && form.emailtemplatetitle !== \'None set\'" aria-label="{{form.formname}}-list-item">\n                  <md-icon md-font-icon="fa fa-lg fa-plus" class="zuantTitanium1"></md-icon>\n                  <div class="md-list-item-text">\n                    <h3><i ng-bind-html="form.icn | iconify"></i> &nbsp;{{::form.formname}}</h3>\n                    <p>\n                      <md-icon md-font-icon="zmdi zmdi-mail-send" class="icn_1x"></md-icon> {{::form.emailtemplatetitle}}</p>\n                  </div>\n                </md-list-item>\n              </md-list>\n            </section>\n          </md-content>\n        </md-card>\n        <md-card flex-gt-xs="50">\n          <md-content>\n            <section>\n              <md-subheader class="md-primary pointer-cursor">EVENTS USING THIS EMAIL TEMPLATE</md-subheader>\n              <md-list>\n                <md-list-item ng-repeat="form in vm.forms | filter:search track by form._id" ng-click="vm.toggleEmailTemplateForForm(form, false)" class="md-2-line" ng-if="form.emailTemplate == vm.currentEmailTemplateId" aria-label="{{form.formname}}-list-item">\n                  <md-icon md-font-icon="fa fa-check" class="zuantThyme"></md-icon>\n                  <div class="md-list-item-text">\n                    <h3><i ng-bind-html="form.icn | iconify"></i> &nbsp;{{::form.formname}}</h3>\n                    <p>\n                      <md-icon md-font-icon="zmdi zmdi-mail-send" class="icn_1x"></md-icon> {{::form.emailtemplatetitle}}</p>\n                  </div>\n                </md-list-item>\n              </md-list>\n            </section>\n          </md-content>\n        </md-card>\n      </div>\n    </div>\n    <md-dialog-actions layout="row">\n      <span flex></span>\n      <md-button ng-click="vm.answer()" style="margin-right:20px;" aria-label="Done managing forms">\n        Done\n      </md-button>\n    </md-dialog-actions>\n  <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n</md-dialog>\n');
$templateCache.put('app/email/detail/zp-template-editor/zp-template-editor.tmpl.html','<md-card layout-margin ng-hide="!$ctrl.permissionToEdit">\n  <textarea zp-ck-editor plugins="$ctrl.editorPlugins" id="emailContentTextArea"\n    ng-model="$ctrl.emailTemplate.emailtemplatetext" ng-change="$ctrl.editorChange()"\n    aria-label="ck-editor textarea"></textarea>\n</md-card>\n\n<md-card layout-padding ng-hide="!$ctrl.permissionToEdit">\n  <p class="faded-text md-subhead" style="margin-bottom: 0px;">Helpful tips</p>\n  <p class="md-body-1">\n    <span class="faded-text">\n      Add a contenteditable="true" attribute to any div (in source mode) to make it editable from\n      within the email rep feature.\n    </span>\n    <br>\n    <br>\n    <img width="20px" ng-src="{{\'/images/pngs/icons/ckeditor/logo_icn.png\' | cdnAssets}}" />\n    <span class="faded-text md-body-1">\n      adds the account logo to the template\n    </span>\n    <br>\n    <img width="20px" ng-src="{{\'/images/pngs/icons/ckeditor/mail_links.png\' | cdnAssets}}" />\n    <span class="faded-text">\n      injects any selected literature links into the template\n    </span>\n    <br> [P]\n    <span class="faded-text">\n      adds a mail-merge field. Choose from: salutation, firstname, lastname, user.email,\n      user.firstname, user.lastname\n    </span>\n  </p>\n</md-card>');
$templateCache.put('app/email/detail/zp-template-insights/zp-template-insights.tmpl.html','<md-content>\n  <div layout="column" layout-gt-md="row">\n\n    <md-card style="min-width: 60vw;" flex-order="2" flex="75" flex-gt-lg="60" flex-offset-gt-lg="10" flex-order-lg="1"\n      flex-order-gt-lg="1">\n\n      <md-card-header>\n\n        <md-card-avatar>\n          <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-email"></md-icon>\n        </md-card-avatar>\n\n        <md-card-header-text>\n          <span class="md-title">Email Sends</span>\n          <span class="md-subhead">{{$ctrl.chartInfo.metadata.title}}</span>\n        </md-card-header-text>\n\n        <zp-widget-context-menu\n          menu-item-clicked="$ctrl.changeChartRange({event: event, selectedMenuItem: selectedMenuItem})"\n          menu-options="$ctrl.aggregatedResponses.menuOptions">\n        </zp-widget-context-menu>\n\n      </md-card-header>\n\n      <md-card-content layout-align="center center" layout="column">\n\n        <md-progress-circular ng-if="$ctrl.loading" class="md-accent" md-mode="indeterminate"></md-progress-circular>\n\n        <div ng-show="$ctrl.showCustomDates">\n          <form name="$ctrl.chartController">\n            Select start and end dates for the chart\n            <div layout="row" flex>\n              <md-input-container style="margin: 0px;" flex>\n                <md-datepicker flex ng-model="$ctrl.customRange.startdate" md-placeholder="Start date"\n                  md-open-on-focus="true" ng-change="$ctrl.applyCustomDates()" name="startdate"\n                  md-max-date="$ctrl.customRange.enddate" md-min-date="$ctrl.mindate" md-mode="{{$ctrl.pickerSchema}}"\n                  md-current-view="{{$ctrl.pickerSchema}}" required>\n                </md-datepicker>\n                <div ng-messages="$ctrl.chartController.startdate.$error">\n                  <div ng-message="valid">The entered value is not a date!</div>\n                  <div ng-message="mindate">Your start date is not in the correct format.</div>\n                  <div ng-message="maxdate">The entered value is greater than the available date boundaries</div>\n                  <div ng-message="required">This date is required!</div>\n                </div>\n              </md-input-container>\n\n              <md-input-container style="margin: 0px;" flex>\n                <md-datepicker flex ng-model="$ctrl.customRange.enddate" ng-change="$ctrl.applyCustomDates()"\n                  md-placeholder="End date" md-open-on-focus="true" md-min-date="$ctrl.customRange.startdate"\n                  md-max-date="$ctrl.customRange.maxdate" name="enddate" md-mode="{{$ctrl.pickerSchema}}"\n                  md-current-view="{{$ctrl.pickerSchema}}" required>\n                </md-datepicker>\n                <div ng-messages="$ctrl.chartController.enddate.$error">\n                  <div ng-message="valid">The entered value is not a date!</div>\n                  <div ng-message="mindate">Your start date is not in the correct format.</div>\n                  <div ng-message="maxdate">The entered value is greater than the available date boundaries</div>\n                  <div ng-message="required">This date is required!</div>\n                </div>\n              </md-input-container>\n              <md-button class="md-icon-button" ng-click="$ctrl.showCustomDates = false">\n                <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dates"></md-icon>\n              </md-button>\n            </div>\n          </form>\n        </div>\n\n        <zp-chart ng-show="!$ctrl.loading" layout-fill flex chartid="{{$ctrl.aggregatedResponses.chartId}}"\n          chart-data="$ctrl.chartInfo.data" chart-series="$ctrl.chartInfo.series" chart-labels="$ctrl.chartInfo.labels"\n          chart-type="$ctrl.chartInfo.chartType" chart-options="$ctrl.chartInfo.chartOptions"\n          loading="$ctrl.bucketLoading">\n        </zp-chart>\n\n      </md-card-content>\n\n    </md-card>\n\n    <div layout="row" flex="25" layout-wrap flex-order-gt-sm="1" flex-order="2" flex-order-gt-md="1">\n      <zp-count-widget flex-sm="50" flex-md="25" flex-lg="50" flex-gt-lg="30" flex="100" count="$ctrl.chartInfo.total"\n        label="TOTAL SENDS" icon="zmdi-mail-send"></zp-count-widget>\n      <zp-count-widget flex-sm="50" flex-md="25" flex-lg="50" flex-gt-lg="30" flex="100"\n        ng-show="$ctrl.chartInfo.events.delivered > 0" count="$ctrl.chartInfo.events.delivered" label="DELIVERED"\n        icon="zmdi-inbox"></zp-count-widget>\n      <zp-count-widget flex-sm="50" flex-md="25" flex-lg="50" flex-gt-lg="30" flex="100"\n        ng-show="$ctrl.chartInfo.events.opened > 0" count="$ctrl.chartInfo.events.opened" label="OPENED"\n        icon="zmdi-email-open"></zp-count-widget>\n      <zp-count-widget flex-sm="50" flex-md="25" flex-lg="50" flex-gt-lg="30" flex="100"\n        ng-show="$ctrl.chartInfo.events.clicked > 0" count="$ctrl.chartInfo.events.clicked" label="CLICKED"\n        icon="zmdi-mouse"> </zp-count-widget>\n      <!-- <zp-count-widget flex-sm="50" flex-md="25" flex-gt-xl="30" flex="100" count="$ctrl.chartInfo.events.unsubscribed" label="UNSUBSCRIBED" icon="zmdi-thumb-down"> </zp-count-widget> -->\n      <!-- <zp-count-widget flex-sm="50" flex-md="25" flex-gt-xl="30" flex="100" count="$ctrl.chartInfo.events.complained" label="COMPLAINED" icon="zmdi-flag"> </zp-count-widget> -->\n      <zp-count-widget flex-sm="50" flex-md="25" flex-lg="50" flex-gt-lg="30" flex="100"\n        ng-show="$ctrl.chartInfo.events.failed > 0" count="$ctrl.chartInfo.events.failed" label="FAILED"\n        icon="zmdi-alert-triangle"> </zp-count-widget>\n      <zp-count-widget flex-sm="50" flex-md="25" flex-lg="50" flex-gt-lg="30" flex="100"\n        ng-show="$ctrl.chartInfo.events.temporary_fail > 0" count="$ctrl.chartInfo.events.temporary_fail"\n        label="TEMP FAIL" icon="zmdi-alert-triangle"> </zp-count-widget>\n      <zp-count-widget flex-sm="50" flex-md="25" flex-lg="50" flex-gt-lg="30" flex="100"\n        ng-show="$ctrl.chartInfo.events.permanent_fail > 0" count="$ctrl.chartInfo.events.permanent_fail"\n        label="PERM FAIL" icon="zmdi-alert-polygon"> </zp-count-widget>\n    </div>\n\n  </div>\n</md-content>');
$templateCache.put('app/email/detail/zp-template-settings/zp-template-settings.tmpl.html','<md-content layout-fill layout="column" syle="height: 100%; overflow: auto;">\n  <div flex layout-xs="column" layout-sm="column" layout-md="column" layout="row">\n    <div layout-padding flex flex-gt-md="65" flex-order="1">\n      <md-card layout-padding>\n        <form name="$ctrl.settingsForm" id="" novalidate role="form" confirm-on-exit>\n          <div layout="row" layout-align="end center">\n            <md-button class="md-icon-button" ng-click="$ctrl.deleteTemplate()" ng-if="$ctrl.isDev">\n              <md-icon md-font-icon="zmdi zmdi-delete"></md-icon>\n              <md-tooltip md-direction="down">Delete template</md-tooltip>\n            </md-button>\n            <zp-save-button permission permission-only="$ctrl.permissions.boltOns.emails.thankYouEmails.edit"\n              label="\'save template\'" isdirty="$ctrl.changeDelta.isDirty()" disabled="$ctrl.settingsForm.$invalid"\n              save="$ctrl.save($event)">\n            </zp-save-button>\n          </div>\n          <div layout="column">\n            <md-input-container>\n              <label>Template title</label>\n              <input name="title" ng-model="$ctrl.emailTemplate.title"\n                ng-change="$ctrl.updateChangeDelta(\'title\', $ctrl.emailTemplate.title)" required\n                ng-attr-autofocus="true" ng-disabled="!$ctrl.permissionToEdit">\n              <div ng-messages="$ctrl.settingsForm.title.$error" ng-show="$ctrl.settingsForm.title.$error.required"\n                ng-if="$ctrl.settingsForm.title.$touched">\n                <div ng-message="required">Email templates require a title</div>\n              </div>\n            </md-input-container>\n            <md-input-container show-errors>\n              <label>Email subject</label>\n              <input name="subjectField" ng-model="$ctrl.emailTemplate.emailtemplatesubject"\n                ng-change="$ctrl.updateChangeDelta(\'emailtemplatesubject\', $ctrl.emailTemplate.emailtemplatesubject)"\n                aria-label="subject" required ng-disabled="!$ctrl.permissionToEdit">\n              <div ng-messages="$ctrl.settingsForm.subjectField.$error"\n                ng-show="$ctrl.settingsForm.subjectField.$error.required"\n                ng-if="$ctrl.settingsForm.subjectField.$touched">\n                <div ng-message="required">Email templates require a subject field</div>\n              </div>\n            </md-input-container>\n            <p>Template status:</p>\n            <md-list-item>\n              Published:\n              <md-switch class="md-secondary" aria-label="Published" ng-true-value=1 ng-false-value=0\n                ng-model="$ctrl.emailTemplate.published"\n                ng-change="$ctrl.updateChangeDelta(\'published\', $ctrl.emailTemplate.published)"\n                ng-disabled="!$ctrl.permissionToEdit"></md-switch>\n            </md-list-item>\n            <md-list-item permission permission-only="$ctrl.permissions.boltOns.emails.thankYouEmails.archive">\n              Archived:\n              <md-switch class="md-secondary" aria-label="Archived" ng-true-value=1 ng-false-value=0\n                ng-model="$ctrl.emailTemplate.archived"\n                ng-change="$ctrl.updateChangeDelta(\'archived\', $ctrl.emailTemplate.archived)"\n                ng-disabled="!$ctrl.permissionToEdit"></md-switch>\n            </md-list-item>\n          </div>\n          <input type="hidden" name="CSRFToken" value="1231234567890" />\n        </form>\n      </md-card>\n    </div>\n\n    <div flex flex-order="2" ng-hide="!$ctrl.permissionToEdit">\n\n      <div layout-padding layout-xs="column" layout-gt-md="column" layout="row">\n\n        <md-card layout-padding flex layout="row" layout-align="space-between center">\n          <div>\n            <md-icon class="icn_4x" md-font-icon="zmdi zmdi-mail-send"></md-icon>\n          </div>\n          <div layout="column" layout-align="center end">\n\n            <p class="md-headline font-weight-100 margin-top-0 margin-bottom-0 text-ellipsis">\n              SEND TEST\n            </p>\n\n            <p class="text-right"\n              ng-if="$ctrl.emailTemplate._lastTestEmailSentDate &&$ctrl.emailTemplate._lastTestEmailSentDate != \'\'">\n              Last test sent: {{$ctrl.emailTemplate._lastTestEmailSentDate | zpMomentFromNow }}\n            </p>\n\n            <span ng-if="!$ctrl.emailTemplate._lastTestEmailSentDate">\n              NEVER\n            </span>\n\n            <md-button aria-label="Click to send" class="md-button md-primary" ng-click="$ctrl.sendTestEmail()">\n              Click to Send\n            </md-button>\n\n          </div>\n        </md-card>\n\n        <md-card layout-padding ayout-margin flex layout="row" layout-align="space-between center">\n          <div>\n            <md-icon class="icn_4x" md-font-icon="zmdi zmdi-attachment-alt"></md-icon>\n          </div>\n          <div layout="column" layout-align="center end">\n            <!--<p class="md-display-3 font-weight-100 margin-top-0 margin-bottom-0 text-ellipsis" countupto="$ctrl.countFactory()" decimals="0"></p>-->\n            <p class="md-display-3 font-weight-100 margin-top-0 margin-bottom-0 text-ellipsis"\n              aria-label="Count of forms using this template">{{$ctrl.formsUsedCount}}</p>\n            <p class="md-body-2 opacity-60 margin-top-0 margin-bottom-0 text-right">FORMS</p>\n            <p class="md-body-2 opacity-60 margin-top-0 margin-bottom-0 text-right">Using this email template</p>\n            <md-button aria-label="Manage forms using this template" class="md-button md-primary"\n              ng-click="$ctrl.manageFormsUsedDialog($event)" flex="100" flex-gt-md="auto">\n              Click to Manage\n            </md-button>\n            <span ng-if="accountHasForms == false">No forms in your account yet.</span>\n          </div>\n        </md-card>\n      </div>\n    </div>\n  </div>\n</md-content>');
$templateCache.put('app/email/detail/fab/fab.tmpl.html','<zp-save-button ng-if="$ctrl.changeDelta.isDirty()" isfab="\'true\'" label="\'save template fab\'"\n    isdirty="$ctrl.changeDelta.isDirty()" save="$ctrl.save()" disabled="$ctrl.saveDisabled" permission\n    permission-only="$ctrl.permissions.boltOns.emails.thankYouEmails.edit"></zp-save-button>');
$templateCache.put('app/email/main/fab/fab.tmpl.html','<zp-helper-arrow permission permission-only="$ctrl.permissions.boltOns.emails.thankYouEmails.edit" help-message="Create an email template" show-condition="!$ctrl.data.items.length"></zp-helper-arrow>\n<zp-fab-add permission permission-only="$ctrl.permissions.boltOns.emails.thankYouEmails.edit" pulse-class-check="!$ctrl.data.items.length" dialog-config="$ctrl.metadata.fabDialogConfig"></zp-fab-add>\n');
$templateCache.put('app/email/main/search-toolbar/tmpl.html','<zp-search-toolbar\n  metadata="$ctrl.metadata"\n  menu-options="$ctrl.metadata.menuOptions"\n  on-menu-click="$ctrl.onMenuClick({action: action, ev:ev})">\n</zp-search-toolbar>\n');
$templateCache.put('app/email/main/zp-email-list/tmpl.html','<md-content flex layout="row" layout-gt-md="row" ng-cloak layout-align="start start" layout-fill>\n  <md-card flex ng-show="$ctrl.data.items.length">\n\n    <zp-data-grid\n      ng-cloak\n      data="$ctrl.data"\n      metadata="$ctrl.metadata"\n      search-value="$ctrl.search.searchVal"\n      options="$ctrl.metadata.gridOptions"\n      row-click="$ctrl.goto(rowid)"\n      widget-id="$ctrl.metadata.id">\n    </zp-data-grid>\n\n    <md-table-pagination\n      hide-xs\n      hide-sm\n      class="md-table-pagination"\n      ng-if="$ctrl.metadata.paginationOptions.pagination"\n      md-limit="$ctrl.metadata.paginationOptions.limit"\n      md-limit-options="$ctrl.metadata.paginationOptions.limitOptions"\n      md-page="$ctrl.metadata.paginationOptions.page" md-total="{{$ctrl.totalRows}}"\n      md-page-select="$ctrl.metadata.paginationOptions.pageSelect"\n      md-boundary-links="$ctrl.metadata.paginationOptions.boundaryLinks"\n      md-on-paginate="$ctrl.logPagination(page, limit)">\n    </md-table-pagination>\n  </md-card>\n\n  <!-- blank slate card -->\n  <div flex\n    ng-show="$ctrl.blankSlate"\n    layout-padding\n    layout="row"\n    layout-align="center center">\n        <zp-no-data ng-show="$ctrl.blankSlate"\n          header="Currently no email templates in your account"\n          subhead="Create email templates to use from Zuant for Thank You emails"\n          body=""\n          svgpath=""\n          fontcolor="zuantLagoonRollover"\n          svgid="">\n        </zp-no-data>\n  </div>\n\n</md-content>\n');
$templateCache.put('app/email/detail/dialogs/confirm-archive-template.tmpl.html','<md-dialog aria-label="confirm archive email template" flex="50">\n  <md-toolbar>\n    <div class="md-toolbar-tools">\n      <h2>Confirm Archive Template</h2>\n      <span flex></span>\n      <md-button class="md-icon-button" ng-click="$ctrl.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-content layout-padding layout="column">\n    <p>This email template is being used by the following forms. Please double check you still wish to archive this template and click the continue button if you\'re happy</p>\n    <md-list>\n      <md-list-item ng-repeat="form in $ctrl.forms" ng-if="form.emailTemplate == $ctrl.currentEmailTemplateId" class="md-2-line">\n        <md-icon md-font-icon="fa fa-check" class="zuantThyme"></md-icon>\n        <div class="md-list-item-text">\n          <h3><i ng-bind-html="form.icn | iconify"></i> &nbsp;{{::form.formname}}</h3>\n          <p>\n            <md-icon md-font-icon="zmdi zmdi-mail-send" class="icn_1x"></md-icon> {{::form.emailtemplatetitle}}</p>\n        </div>\n      </md-list-item>\n    </md-list>\n  </md-content>\n  <md-dialog-actions>\n    <div layout="row" layout-align="end end" flex>\n      <md-button ng-click="$ctrl.cancelDialog()" class="md-primary">Cancel</md-button>\n      <md-button ng-click="$ctrl.continueArchiving()" class="md-raised md-primary">Continue</md-button>\n    </div>\n  </md-dialog-actions>\n</md-dialog>\n');
$templateCache.put('app/email/main/widget-container/widget-container.tmpl.html','<md-content layout-fill md-theme="zuantCloudSkin" theme-background="primary:hue-2" hide-xs hide-sm>\n\n  <zp-no-data ng-show="$ctrl.blankSlate" header="No data to see yet." subhead="Standing by."\n    svgpath="{{\'/images/svgs/utilities/theme/rocket_lagoon_002.svg\' | cdnAssets}}" fontcolor="zuantLagoonRollover"\n    svgid="email_templates_blank">\n  </zp-no-data>\n\n  <div ng-show="!$ctrl.blankSlate">\n    <div layout="row" layout-wrap>\n\n      <zp-count-widget flex-lg="50" flex="33" count="$ctrl.data.items.length" label="EMAIL TEMPLATES"\n        icon="zmdi-mail-send" loading="$ctrl.loading">\n      </zp-count-widget>\n\n      <zp-count-widget flex-lg="50" flex="33" count="$ctrl.chartInfo.weektotal" label="EMAILS SENT THIS WEEK"\n        icon="zmdi-calendar" loading="$ctrl.loading">\n      </zp-count-widget>\n\n      <zp-count-widget flex-lg="100" flex="33" count="$ctrl.chartInfo.total"\n        label="{{$ctrl.chartInfo.metadata.subtitle}}" icon="zmdi-time-restore" loading="$ctrl.loading">\n      </zp-count-widget>\n\n    </div>\n\n    <md-card class="chart-card" hide-xs hide-sm hide-md>\n\n      <md-card-header>\n\n        <md-card-header-text>\n          <span class="md-title" ng-show="$ctrl.showTitle">{{$ctrl.chartInfo.metadata.title}}</span>\n          <span class="md-subhead">{{$ctrl.chartInfo.metadata.subtitle}}</span>\n        </md-card-header-text>\n\n        <zp-widget-context-menu\n          menu-item-clicked="$ctrl.changeChartRange({event: event, selectedMenuItem: selectedMenuItem})"\n          selected-item="$ctrl.currentSchema" menu-options="$ctrl.aggregatedResponses.menuOptions">\n        </zp-widget-context-menu>\n\n      </md-card-header>\n\n      <md-card-content layout-align="center center" layout="column" flex>\n\n        <div ng-show="$ctrl.showCustomDates" layout="row">\n\n          <form name="$ctrl.chartController">\n            Select start and end dates for the chart\n\n            <div layout="row" flex>\n\n              <md-input-container style="margin: 0px;" flex>\n\n                <md-datepicker flex ng-model="$ctrl.customRange.startdate" md-placeholder="Start date"\n                  md-open-on-focus="true" ng-change="$ctrl.applyCustomDates()" name="startdate"\n                  md-max-date="$ctrl.customRange.enddate" md-min-date="$ctrl.mindate" md-mode="{{$ctrl.pickerSchema}}"\n                  md-current-view="{{$ctrl.pickerSchema}}" required>\n                </md-datepicker>\n\n                <div ng-messages="$ctrl.chartController.startdate.$error">\n                  <div ng-message="valid">The entered value is not a date!</div>\n                  <div ng-message="mindate">Your start date is not in the correct format.</div>\n                  <div ng-message="maxdate">The entered value is greater than the available date boundaries</div>\n                  <div ng-message="required">This date is required!</div>\n                </div>\n\n              </md-input-container>\n\n              <md-input-container style="margin: 0px;" flex>\n\n                <md-datepicker flex ng-model="$ctrl.customRange.enddate" ng-change="$ctrl.applyCustomDates()"\n                  md-placeholder="End date" md-open-on-focus="true" md-min-date="$ctrl.customRange.startdate"\n                  md-max-date="$ctrl.customRange.maxdate" name="enddate" md-mode="{{$ctrl.pickerSchema}}"\n                  md-current-view="{{$ctrl.pickerSchema}}" required>\n                </md-datepicker>\n\n                <div ng-messages="$ctrl.chartController.enddate.$error">\n                  <div ng-message="valid">The entered value is not a date!</div>\n                  <div ng-message="mindate">Your start date is not in the correct format.</div>\n                  <div ng-message="maxdate">The entered value is greater than the available date boundaries</div>\n                  <div ng-message="required">This date is required!</div>\n                </div>\n\n              </md-input-container>\n\n              <md-button class="md-icon-button" ng-click="$ctrl.showCustomDates = false">\n                <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dates"></md-icon>\n              </md-button>\n\n            </div>\n\n          </form>\n\n        </div>\n\n        <md-progress-circular ng-if="$ctrl.loading" class="md-accent" md-mode="indeterminate"></md-progress-circular>\n\n        <zp-chart ng-show="!$ctrl.loading" layout-fill flex chartid="{{$ctrl.aggregatedResponses.chartId}}"\n          chart-data="$ctrl.chartInfo.data" chart-series="$ctrl.chartInfo.series" chart-labels="$ctrl.chartInfo.labels"\n          chart-type="$ctrl.chartInfo.chartType" chart-options="$ctrl.chartInfo.chartOptions"\n          loading="$ctrl.bucketLoading"></zp-chart>\n\n      </md-card-content>\n    </md-card>\n  </div>\n\n</md-content>');
$templateCache.put('app/forms/grid-page/parked-lead-grid/zp-parked-lead-grid.tmpl.html','<md-toolbar aria-label="Parked leads toolbar">\n  <div layout="row" class="md-toolbar-tools">\n    <md-icon md-font-icon="zmdi zmdi-alert-triangle zuantPollen"></md-icon>\n    <p class="md-subhead">&nbsp; Managing parked leads for {{$ctrl.title}}</p>\n    <span flex></span>\n    <md-button ng-click="$ctrl.goBack()">\n      <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n    </md-button>\n  </div>\n</md-toolbar>\n\n<zp-selection-manager toolbar-buttons="$ctrl.metadata.toolbarButtons" widget-id="$ctrl.metadata.id">\n</zp-selection-manager>\n\n<div theme-background="primary:hue-2"\n  ng-show="!$ctrl.data.validationErrors.length && $ctrl.data.items.length && !$ctrl.hideHelpToolbar" layout="row">\n  <div>\n    <p class="md-subhead" style="padding-left: 16px;">Select the rows you wish to manage and choose to either submit or\n      delete. Leads must be valid before submitting. Tip: Right click a row to toggle the selection!</p>\n  </div>\n  <span flex></span>\n  <md-button class="md-accent" ng-click="$ctrl.setHideHelpToolbar()">Ok</md-button>\n</div>\n\n<md-content layout="column" flex layout-padding>\n  <md-card>\n    <div ng-if="!$ctrl.data.items.length" flex layout-align="center center" layout="column">\n      <p class="md-headline text-align-center">\uD83D\uDE97 \uD83D\uDCA8 All parked leads have been managed</p>\n    </div>\n\n    <zp-grid-toolbar ng-if="$ctrl.data.items.length" buttons="$ctrl.metadata.toolbarButtons"\n    search-value="$ctrl.searchValue" widget-id="$ctrl.metadata.id" metadata="$ctrl.metadata">\n    </zp-grid-toolbar>\n\n    <zp-data-grid layout="column" ng-show="$ctrl.data.items.length" metadata="$ctrl.metadata"\n      search-value="$ctrl.searchValue" options="$ctrl.metadata.gridOptions" widget-id="$ctrl.metadata.id">\n    </zp-data-grid>\n\n    <md-table-pagination ng-show="$ctrl.data.items.length" class="md-table-pagination"\n      ng-if="$ctrl.metadata.paginationOptions.pagination" md-limit="$ctrl.metadata.paginationOptions.limit"\n      md-limit-options="$ctrl.metadata.paginationOptions.limitOptions" md-page="$ctrl.metadata.paginationOptions.page"\n      md-total="{{$ctrl.data.items.length}}" md-page-select="$ctrl.metadata.paginationOptions.pageSelect"\n      md-boundary-links="$ctrl.metadata.paginationOptions.boundaryLinks"\n      md-on-paginate="$ctrl.logPagination(page, limit)">\n    </md-table-pagination>\n  </md-card>\n</md-content>\n');
$templateCache.put('app/forms/grid-page/dialogs/full-screen-grid.tmpl.html','<md-dialog aria-label="Add new user dialog" flex="100">\n\n  <md-toolbar aria-label="Create user dialog toolbar">\n    <div class="md-toolbar-tools">\n      <zp-editable-header metadata="$ctrl.metadata" value="$ctrl.formname" ng-show="!$ctrl.showSearch" flex\n        done-function="$ctrl.updateTitle(value)"></zp-editable-header>\n      <md-input-container ng-show="$ctrl.showSearch" flex class="margin-bottom-0 margin-top-40">\n        <label>Filter data</label>\n        <input ng-model="$ctrl.searchValue" ng-show="$ctrl.showSearch" focus-on-show aria-label="Grid filter" />\n      </md-input-container>\n      <div flex></div>\n      <md-button class="md-icon-button" ng-click="$ctrl.showSearch = !$ctrl.showSearch"\n        ng-class="{\'btn-active\': $ctrl.showSearch}" aria-label="toggle search">\n        <md-icon md-font-icon="zmdi zmdi-search"></md-icon>\n        <md-tooltip md-direction="down">Filter data</md-tooltip>\n      </md-button>\n\n      <md-menu>\n        <md-button class="md-icon-button" ng-click="$ctrl.openMenu($mdOpenMenu, $event)">\n          <md-icon md-font-icon="zmdi zmdi-view-column"></md-icon>\n          <md-tooltip md-direction="down">Grid columns</md-tooltip>\n        </md-button>\n        <md-menu-content width="4">\n          <md-menu-item class="col-select-button">\n            <md-checkbox ng-model="$ctrl.allColsVisible" ng-change="$ctrl.toggleAllColsVisible($ctrl.allColsVisible)">\n              All columns\n          </md-menu-item>\n          <md-menu-item ng-repeat="item in $ctrl.metadata.columnsData.items" class="col-select-button">\n            <md-checkbox ng-model="item.showCol"\n              ng-change="$ctrl.updateColumnVisibilityInLocalStorage(item.databasefieldname, item.object, item.showCol)">\n              {{item.label}}\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n\n      <md-button class="md-icon-button" ng-click="$ctrl.downloadLeads()" aria-label="download leads">\n        <md-icon md-font-icon="zmdi zmdi-download"></md-icon>\n        <md-tooltip md-direction="down">Download lead data</md-tooltip>\n      </md-button>\n\n      <zp-save-button permission permission-except="\'STANDARD_USER\'" label="\'save template\'"\n        isdirty="$ctrl.changeDeltaFactory.isDirty()" save="$ctrl.saveGridChanges()"></zp-save-button>\n\n      <md-button class="md-icon-button" ng-click="$ctrl.fullScreenGrid($event)" aria-label="fullscreen grid">\n        <md-icon md-font-icon="zmdi zmdi-arrow-right-top"></md-icon>\n        <md-tooltip md-direction="down">Full screen grid</md-tooltip>\n      </md-button>\n\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content layout-padding>\n    <zp-selection-manager toolbar-buttons="$ctrl.metadata.toolbarButtons"></zp-selection-manager>\n\n    <zp-data-grid data="$ctrl.data" metadata="$ctrl.metadata" search-value="$ctrl.searchValue"\n      loading-indicator="$ctrl.loading" total-rows="$ctrl.totalRows" options="$ctrl.metadata.gridOptions"\n      widget-id="$ctrl.metadata.id">\n    </zp-data-grid>\n\n    <!-- WORKING AS A COMPONENT COPY THIS CONFIG -->\n    <md-table-pagination class="md-table-pagination" ng-if="$ctrl.metadata.paginationOptions.pagination"\n      md-limit="$ctrl.metadata.paginationOptions.limit" md-limit-options="$ctrl.metadata.paginationOptions.limitOptions"\n      md-page="$ctrl.metadata.paginationOptions.page" md-total="{{$ctrl.totalRows}}"\n      md-page-select="$ctrl.metadata.paginationOptions.pageSelect"\n      md-boundary-links="$ctrl.metadata.paginationOptions.boundaryLinks"\n      md-on-paginate="$ctrl.logPagination(page, limit)">\n    </md-table-pagination>\n  </md-dialog-content>\n\n  <md-dialog-actions layout="row">\n    <md-button class="md-warn" ng-click="vm.cancelDialog()">Cancel</md-button>\n    <md-button class="md-primary" aria-label="save user form" ng-click="vm.submitUserForm(vm.userDoc)">Create\n      user</md-button>\n  </md-dialog-actions>\n\n</md-dialog>');
$templateCache.put('app/forms/lead-release-grid/integration-headline-widget/tmpl.html','<div flex g-if="$ctrl.factoryData[$ctrl.widgetData.datakey].count > 0">\n  <div layout-align="center center" layout="column" layout-fill>\n    <!-- <p class="md-caption zp-caption">{{$ctrl.widgetData.title}}</p> -->\n      <md-progress-circular ng-if="$ctrl.widgetData.loading" class="md-accent" md-mode="indeterminate"></md-progress-circular>\n      <!-- <md-icon md-font-icon="{{$ctrl.factoryData[$ctrl.widgetData.datakey].icon}}" style="fill: #949ca1; font-size: 30px;"></md-icon> -->\n      <ng-md-icon icon="{{$ctrl.factoryData[$ctrl.widgetData.datakey].icon}}" style="fill: #949ca1;"></ng-md-icon>\n    <p class="md-display-1 zp-caption margin-bottom-0 margin-top-10" countupto="$ctrl.factoryData[$ctrl.widgetData.datakey].count" decimals="0" duration="1.8"></p>\n    <p class="md-caption zp-caption margin-bottom-0 margin-top-0">{{$ctrl.widgetData.name}}</p>\n  </div>\n</div>\n');
$templateCache.put('app/forms/lead-release-grid/lead-release-toolbar/tmpl.html','<md-toolbar class="md-table-toolbar md-accent" ng-if="$ctrl.data.selectedItems.length">\n  <div class="md-toolbar-tools">\n    <zp-clear-button\n      class="zp-button"\n      on-click="$ctrl.clearSelectedCheckboxClicked($event)"\n      ng-show="$ctrl.data.selectedItems.length">\n    </zp-clear-button>\n\n    <span>\n      <span>&nbsp;</span>\n      <span ng-show="$ctrl.data.selectedItems.length">{{$ctrl.data.selectedItems.length}} {{$ctrl.data.selectedItems.length > 1 ? \'leads\' : \'lead\'}} selected</span>\n      <span ng-show="!$ctrl.data.selectedItems.length">0 leads  selected, select some to manage</span>\n    </span>\n    <span flex></span>\n    <span flex="5"></span>\n    <span ng-show="$ctrl.gridIsDirty()">Please save your changes before altering release state</span>\n    <span ng-show="$ctrl.releaseButtonDisabled()">Unlock leads before releasing</span>\n    <span flex="5"></span>\n    \n    <md-button\n      class="md-icon-button"\n      ng-class="{\'md-raised md-primary\': $ctrl.data.selectedItems.length }"\n      ng-click="$ctrl.prepareAndDispatchServerShuttle($event, \'releaseLeads\')"\n      ng-disabled="$ctrl.disableToolbarButtons || $ctrl.releaseButtonDisabled() || $ctrl.gridIsDirty()">\n      <md-icon md-font-icon="zmdi zmdi-cloud-upload"></md-icon>\n      <md-tooltip>Release leads</md-tooltip>\n    </md-button>\n\n    <md-button\n      label="\'Lock selected leads\'"\n      ng-click="$ctrl.prepareAndDispatchServerShuttle($event, \'lockLeads\')"\n      ng-show="$ctrl.data.selectedItems.length"\n      ng-disabled="$ctrl.gridIsDirty() || $ctrl.disableToolbarButtons"\n      class="md-icon-button">\n      <md-icon md-font-icon="zmdi zmdi-lock"></md-icon>\n    </md-button>\n\n    <md-button\n      label="\'Unlock selected leads\'"\n      ng-click="$ctrl.prepareAndDispatchServerShuttle($event, \'unlockLeads\')"\n      ng-show="$ctrl.unlockButtonShouldBeVisible()"\n      ng-disabled="$ctrl.gridIsDirty()"\n      class="md-icon-button">\n      <md-icon md-font-icon="zmdi zmdi-lock-open"></md-icon>\n    </md-button>\n\n  </div>\n</md-toolbar>\n');
$templateCache.put('app/forms/lead-release-grid/lead-status-btn/tmpl.html','<md-button\n  ng-click="$ctrl.cellClick($event)"\n  class="md-icon-button"\n  ng-class="{\'md-raised\' : ($ctrl.leadData.response._integrationState === \'failed\' || $ctrl.leadData.response._integrationState === \'mixed\'), \'md-primary\' : $ctrl.leadData.response._integrationState === \'processed\', \'md-accent\' : $ctrl.leadData.response._integrationState === \'failed\'}"\n  aria-label="lead status button">\n  <ng-md-icon icon="{{$ctrl.leadData.response._integrationState | iconify}}"\n    ng-style="$ctrl.iconFill()"\n    size="24">\n  </ng-md-icon>\n</md-button>\n');
$templateCache.put('app/forms/main-page/fab/fab.tmpl.html','<zp-helper-arrow\n  help-message="Create your first form here."\n  permission permission-only="$ctrl.permissions.liteFeatures.forms.edit"\n  show-condition="$ctrl.blankSlate()">\n</zp-helper-arrow>\n\n<zp-fab-add pulse-class-check="$ctrl.blankSlate()"\n  dialog-config="$ctrl.metadata.fabDialogConfig"\n  permission permission-only="$ctrl.permissions.liteFeatures.forms.edit">\n</zp-fab-add>\n');
$templateCache.put('app/forms/main-page/form-list-component/form-list.tmpl.html','<md-card>\n<md-toolbar class="md-table-toolbar md-default">\n  <div class="md-toolbar-tools">\n    <p class="md-subhead zuantTitanium1">{{$ctrl.metadata.title}}\n      <md-tooltip direction="up">{{$ctrl.data.items.length}} {{$ctrl.metadata.title}}</md-tooltip>\n    </p>\n  </div>\n</md-toolbar>\n\n  <zp-data-grid\n    ng-show="$ctrl.data.items.length"\n    metadata="$ctrl.metadata"\n    widget-id="$ctrl.metadata.id"\n    loading-indicator="$ctrl.loading"\n    search-value="$ctrl.searchVal"\n    options="$ctrl.metadata.gridOptions"\n    row-click="$ctrl.goto(rowid)">\n  </zp-data-grid>\n\n  <div ng-show="!$ctrl.data.items.length">\n    <zp-no-data header="" subhead="" body="No forms" svgpath="" fontcolor="zuantLagoonRollover" svgid=""></zp-no-data>\n  </div>\n\n</md-card>\n');
$templateCache.put('app/forms/main-page/form-main-page-component/forms.main.tmpl.html','<!-- <div layout="column" layout-gt-md="row" flex="flex"> -->\n    <!-- <div layout="column" flex-order-gt-md="1" flex="flex"> -->\n\n      <md-content layout-fill>\n        <!-- <zp-search-toolbar update-filter="$ctrl.updateFilter(searchVal)" metadata="$ctrl.metadata.title" search-val="$ctrl.searchVal" menu-options="$ctrl.metadata.menuOptions" on-menu-click="$ctrl.onMenuClick({action: action, ev:ev})"></zp-search-toolbar> -->\n            <!-- blank slate card -->\n        <zp-no-data\n          ng-if="$ctrl.blankSlate()"\n          header="You don\'t have any events in your account yet"\n          subhead=""\n          body=""\n          svgpath=""\n          fontcolor="zuantLagoonRollover"\n          svgid="">\n        </zp-no-data>\n        <!-- current forms list -->\n        <zp-form-list\n          id="currentFormsListCard"\n          search-val="$ctrl.search.searchVal"\n          data="$ctrl.data.current"\n          metadata="$ctrl.metadata.widgets.current"\n          flex="100"\n          ng-show="$ctrl.showCardCheck(\'current\')">\n        </zp-form-list>\n\n        <div layout="column" flex="100">\n              <!-- upcoming form list -->\n          <zp-form-list\n            id="upcomingFormsListCard"\n            search-val="$ctrl.search.searchVal"\n            data="$ctrl.data.upcoming"\n            metadata="$ctrl.metadata.widgets.upcoming"\n            flex="100"\n            flex-gt-lg="50"\n            ng-show="$ctrl.showCardCheck(\'upcoming\')">\n          </zp-form-list>\n          <!-- previous form list -->\n          <zp-form-list\n            id="previousFormsListCard"\n            search-val="$ctrl.search.searchVal"\n            data="$ctrl.data.previous"\n            metadata="$ctrl.metadata.widgets.previous"\n            flex="100"\n            flex-gt-lg="50"\n            ng-show="$ctrl.showCardCheck(\'previous\')">\n          </zp-form-list>\n        </div>\n      </md-content>\n    <!-- </div> -->\n<!-- </div> -->\n');
$templateCache.put('app/forms/main-page/search-toolbar/tmpl.html','<zp-search-toolbar\n  metadata="$ctrl.metadata"\n  menu-options="$ctrl.metadata.menuOptions"\n  on-menu-click="$ctrl.onMenuClick({action: action, ev:ev})">\n</zp-search-toolbar>\n');
$templateCache.put('app/forms/main-page/widget-container/widget-container.tmpl.html','<div md-theme="zuantCloudSkin" theme-background="primary:hue-2" hide-xs hide-sm>\n\n  <zp-no-data ng-show="$ctrl.blankSlate" header="No data to see yet." subhead="Standing by."\n    svgpath="{{\'/images/svgs/utilities/theme/rocket_lagoon_002.svg\' | cdnAssets}}" svgid="submitted_leads_blank">\n  </zp-no-data>\n\n  <div ng-show="!$ctrl.blankSlate">\n\n    <div layout="row" layout-wrap>\n      <zp-count-widget flex-lg="50" flex="33" count="$ctrl.data.current.items.length" label="CURRENT EVENTS"\n        icon="zmdi-star">\n      </zp-count-widget>\n\n      <zp-count-widget flex-lg="50" flex="33" count="$ctrl.chartInfo.weektotal" label="LEADS THIS WEEK"\n        icon="zmdi-calendar" loading="$ctrl.loading">\n      </zp-count-widget>\n\n      <zp-count-widget flex-lg="100" flex="33" count="$ctrl.chartInfo.total"\n        label="{{$ctrl.chartInfo.metadata.subtitle}}" icon="zmdi-time-restore" loading="$ctrl.loading">\n      </zp-count-widget>\n\n    </div>\n\n    <md-card class="chart-card" hide-xs hide-sm hide-md flex>\n\n      <md-card-header>\n\n        <!-- <md-card-avatar>\n          <md-icon md-font-icon="zmdi {{$ctrl.chartInfo.metadata.icon}}"></md-icon>\n        </md-card-avatar> -->\n        <md-card-header-text>\n          <span class="md-title" ng-show="$ctrl.showTitle">{{$ctrl.chartInfo.metadata.title}}</span>\n          <span class="md-subhead">{{$ctrl.chartInfo.metadata.subtitle}}</span>\n        </md-card-header-text>\n        <!-- <span flex></span> -->\n\n        <zp-widget-context-menu\n          menu-item-clicked="$ctrl.changeChartRange({event: event, selectedMenuItem: selectedMenuItem})"\n          selected-item="$ctrl.currentSchema" menu-options="$ctrl.aggregatedResponses.menuOptions">\n        </zp-widget-context-menu>\n\n      </md-card-header>\n\n      <md-card-content layout-align="center center" layout="column">\n\n        <div ng-show="$ctrl.showCustomDates" layout="row">\n\n          <form name="$ctrl.chartController">\n\n            Select start and end dates for the chart\n            <div layout="row" flex>\n\n              <md-input-container style="margin: 0px;" flex>\n\n                <md-datepicker flex ng-model="$ctrl.customRange.startdate" md-placeholder="Start date"\n                  md-open-on-focus="true" ng-change="$ctrl.applyCustomDates()" name="startdate"\n                  md-max-date="$ctrl.customRange.enddate" md-min-date="$ctrl.mindate" md-mode="{{$ctrl.pickerSchema}}"\n                  md-current-view="{{$ctrl.pickerSchema}}" required>\n                </md-datepicker>\n\n                <div ng-messages="$ctrl.chartController.startdate.$error">\n\n                  <div ng-message="valid">The entered value is not a date!</div>\n                  <div ng-message="mindate">Your start date is not in the correct format.</div>\n                  <div ng-message="maxdate">The entered value is greater than the available date boundaries</div>\n                  <div ng-message="required">This date is required!</div>\n\n                </div>\n\n              </md-input-container>\n\n              <md-input-container style="margin: 0px;" flex>\n\n                <md-datepicker flex ng-model="$ctrl.customRange.enddate" ng-change="$ctrl.applyCustomDates()"\n                  md-placeholder="End date" md-open-on-focus="true" md-min-date="$ctrl.customRange.startdate"\n                  md-max-date="$ctrl.customRange.maxdate" name="enddate" md-mode="{{$ctrl.pickerSchema}}"\n                  md-current-view="{{$ctrl.pickerSchema}}" required>\n                </md-datepicker>\n\n                <div ng-messages="$ctrl.chartController.enddate.$error">\n\n                  <div ng-message="valid">The entered value is not a date!</div>\n                  <div ng-message="mindate">Your start date is not in the correct format.</div>\n                  <div ng-message="maxdate">The entered value is greater than the available date boundaries</div>\n                  <div ng-message="required">This date is required!</div>\n\n                </div>\n\n              </md-input-container>\n\n              <md-button class="md-icon-button" ng-click="$ctrl.showCustomDates = false" style="margin: 0px;">\n                <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dates"></md-icon>\n              </md-button>\n\n            </div>\n\n          </form>\n\n        </div>\n\n        <md-progress-circular ng-if="$ctrl.loading" class="md-accent" md-mode="indeterminate"></md-progress-circular>\n\n        <zp-chart layout-fill flex chartid="{{$ctrl.aggregatedResponses.chartId}}" chart-data="$ctrl.chartInfo.data"\n          chart-labels="$ctrl.chartInfo.labels" chart-series="$ctrl.chartInfo.series"\n          chart-type="$ctrl.chartInfo.chartType" chart-options="$ctrl.chartInfo.chartOptions"\n          loading="$ctrl.bucketLoading">\n        </zp-chart>\n\n      </md-card-content>\n    </md-card>\n  </div>\n</div>');
$templateCache.put('app/forms/reporting/email-performance/zp-email-report-widget.tmpl.html','<div layout="row">\n  <md-card flex class="chart-card">\n    <md-card-header layout="row">\n      <md-card-avatar>\n        <ng-md-icon ng-show="!!$ctrl.widgetData.metadata.icon" icon="{{$ctrl.widgetData.metadata.icon}}" size="30">\n        </ng-md-icon>\n        </md-icon>\n      </md-card-avatar>\n      <md-card-header-text>\n        <p class="md-body-2 zp-caption margin-top-0 margin-bottom-0 uppercase">{{$ctrl.widgetData.title}}</p>\n        <p class="md-caption zp-caption margin-top-0 margin-bottom-0">{{$ctrl.widgetData.subtitle}}</p>\n      </md-card-header-text>\n      <md-menu ng-if="$ctrl.widgetData.chart.options.availableChartTypes">\n        <md-button aria-label="Open chart menu" class="md-icon-button" ng-click="$mdMenu.open($event)">\n          <md-icon md-menu-origin md-font-icon="zmdi zmdi-more-vert"></md-icon>\n        </md-button>\n        <md-menu-content>\n          <md-menu-item ng-repeat="item in $ctrl.widgetData.chart.options.availableChartTypes">\n            <md-button ng-click="$ctrl.changeChartType($event, item.chart)">\n              <span md-menu-align-target>\n                <ng-md-icon icon="{{item.icon}}" style="fill: #949cad; margin-right: 16px;"></ng-md-icon>\n              </span>\n              <span style="text-transform: capitalize;">{{item.chart}} chart</span>\n            </md-button>\n          </md-menu-item>\n          <md-menu-item>\n            <md-button ng-click="$ctrl.widgetData.showTable = !$ctrl.widgetData.showTable">\n              <span md-menu-align-target>\n                <ng-md-icon icon="{{ $ctrl.widgetData.showTable ? \'visibility_off\' : \'visibility\' }}"\n                  style="fill: #949cad; margin-right: 16px;"></ng-md-icon>\n              </span>\n              <span ng-show="!$ctrl.widgetData.showTable">Show</span>\n              <span ng-show="$ctrl.widgetData.showTable">Hide</span> Table\n            </md-button>\n          </md-menu-item>\n          <md-menu-item>\n            <md-button ng-click="$ctrl.goTo($event)">\n              <span md-menu-align-target>\n                <md-icon md-font-icon="zmdi zmdi-chart" style="color: #949cad;"></md-icon>\n              </span> View Data\n            </md-button>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n    </md-card-header>\n    <md-card-content layout-align="center center">\n      <md-progress-linear ng-if="$ctrl.widgetData.loading" class="md-accent" md-mode="indeterminate">\n      </md-progress-linear>\n      <div ng-show="$ctrl.widgetData.isEmpty" layout-padding>\n        <p class="md-caption zp-caption margin-bottom-0 uppercase text-align-center">No Data</p>\n      </div>\n      <div layout="column">\n        <div layout="row" ng-show="!$ctrl.widgetData.isEmpty">\n          <zp-chart flex chart-data="$ctrl.widgetData.chart.data" chart-series="$ctrl.widgetData.chart.series"\n            chart-options="$ctrl.widgetData.chart.options" chart-labels="$ctrl.widgetData.chart.labels"\n            chart-type="$ctrl.widgetData.chart.type" chart-click="$ctrl.chartClicked(chartEl)">\n          </zp-chart>\n        </div>\n        <zp-totals-table ng-show="$ctrl.widgetData.showTable" data="$ctrl.widgetData.tableData"\n          header="$ctrl.widgetData.header" flex="30">\n        </zp-totals-table>\n      </div>\n    </md-card-content>\n  </md-card>\n</div>');
$templateCache.put('app/forms/reporting/fab/fab.tmpl.html','<md-fab-speed-dial md-open="$ctrl.isOpen" md-direction="up" ng-class="\'md-fling\'" class="md-fab md-fab-bottom-right">\n  <md-fab-trigger>\n    <md-button aria-label="menu" class="md-fab md-accent">\n      <md-tooltip md-direction="left">Report options</md-tooltip>\n      <md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon>\n    </md-button>\n  </md-fab-trigger>\n\n  <md-fab-actions>\n    <md-button aria-label="Report Builder" class="md-fab md-raised md-mini" ng-click="$ctrl.toggleBuilderSidebar()">\n      <md-tooltip md-direction="left">Show report builder sidebar</md-tooltip>\n      <md-icon md-font-icon="zmdi zmdi-wrench" aria-label="report builder" style="color: rgba(0,0,0,0.54);"></md-icon>\n    </md-button>\n    <md-button permission permission-only="$ctrl.permissions.liteFeatures.leadManagement.download" aria-label="Download PDF" class="md-fab md-raised md-mini" ui-sref="app.single_view_framework.pdf_download({_id: $ctrl.formid})">\n      <md-tooltip md-direction="left">View printable page</md-tooltip>\n      <md-icon md-font-icon="zmdi zmdi-download" aria-label="report builder" style="color: rgba(0,0,0,0.54);"></md-icon>\n    </md-button>\n  </md-fab-actions>\n</md-fab-speed-dial>\n\n<!-- <md-button hide-xs hide-sm hide-md show-gt-md aria-label="Download PDF" class="md-fab md-fab-bottom-right" ui-sref="app.single_view_framework.pdf_download({_id: $ctrl.formid})">\n  <md-icon md-font-icon="zmdi zmdi-download" aria-label="report builder"></md-icon>\n</md-button> -->\n');
$templateCache.put('app/forms/reporting/full-screen-report-component/zp-full-screen-report.tmpl.html','<md-toolbar aria-label="Create event dialog toolbar">\n  <div layout="row" class="md-toolbar-tools">\n    <md-icon md-font-icon="zmdi zmdi-chart"></md-icon>\n    &nbsp;\n    <p class="md-subhead">{{$ctrl.metadata.formProperties.formname}} > {{$ctrl.widgetData.title}} > Detail View</p>\n    <span flex></span>\n    <md-button ng-click="$ctrl.closeDialog()">\n      <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n    </md-button>\n  </div>\n  <md-progress-linear ng-if="$ctrl.loading" class="md-accent" md-mode="indeterminate"></md-progress-linear>\n</md-toolbar>\n<md-content flex>\n\n  <!-- UI LAYOUT -->\n  <div layout="row" layout-fill ui-layout>\n    <ui-layout options="{ flow: \'column\', disableToggle: true }">\n      <div ui-layout-container layout="column" layout-align="center stretch" size="50%" min-size="40%" max-size="70%">\n        <div flex layout-align="center center" layout="row">\n          <md-card flex="90">\n            <md-card-header>\n              <md-card-avatar>\n                <ng-md-icon ng-if="$ctrl.mainChart.icon" icon="{{$ctrl.mainChart.icon}}" style="fill: #a7b0b5;" size="24">\n                </ng-md-icon>\n              </md-card-avatar>\n              <md-card-header-text>\n                <span class="md-title zp-caption uppercase">{{$ctrl.widgetData.title}}</span>\n                <span class="md-subhead zp-caption">{{$ctrl.widgetData.subtitle}}</span>\n              </md-card-header-text>\n              <span flex></span>\n              <md-menu ng-if="$ctrl.widgetData.chart.options.availableChartTypes">\n                  <md-button aria-label="Open chart menu" class="md-icon-button" ng-click="$mdMenu.open($event)">\n                    <md-icon md-menu-origin md-font-icon="zmdi zmdi-more-vert"></md-icon>\n                  </md-button>\n                  <md-menu-content>\n                    <md-menu-item ng-repeat="item in $ctrl.widgetData.chart.options.availableChartTypes">\n                      <md-button ng-click="$ctrl.changeChartType($event, item.chart)">\n                        <span md-menu-align-target>\n                          <ng-md-icon icon="{{item.icon}}" style="fill: #949cad; margin-right: 16px;"></ng-md-icon>\n                        </span>\n                        <span style="text-transform: capitalize;">{{item.chart}} chart</span>\n                      </md-button>\n                    </md-menu-item>\n                    <md-menu-item>\n                      <md-button ng-click="$ctrl.widgetData.showTable = !$ctrl.widgetData.showTable">\n                        <span md-menu-align-target>\n                          <ng-md-icon icon="{{ $ctrl.widgetData.showTable ? \'visibility_off\' : \'visibility\' }}"\n                            style="fill: #949cad; margin-right: 16px;"></ng-md-icon>\n                        </span>\n                          <span ng-show="!$ctrl.widgetData.showTable">Show</span>\n                          <span ng-show="$ctrl.widgetData.showTable">Hide</span> Table\n                      </md-button>\n                    </md-menu-item>\n                  </md-menu-content>\n                </md-menu>\n            </md-card-header>\n            <md-progress-linear ng-if="$ctrl.loading" class="md-accent" md-mode="indeterminate"></md-progress-linear>\n            <zp-chart \n              chart-data="$ctrl.mainChart.data" \n              chart-labels="$ctrl.mainChart.labels"\n              chart-series="$ctrl.mainChart.series" \n              chart-type="$ctrl.mainChart.chart_type"\n              chart-click="$ctrl.chartClick(chartEl)" \n              chart-options="$ctrl.mainChart.chartOptions"\n              menu-options="$ctrl.menuOptions"\n              menu-item-clicked="$ctrl.menuItemClicked({event: event, selectedMenuItem: selectedMenuItem})"\n              metadata="$ctrl.mainChart.metadata"\n              legend-click="$ctrl.legendClick(legendItem)">\n            </zp-chart>\n            <zp-totals-table ng-show="$ctrl.widgetData.showTable" data="$ctrl.widgetData.tableData"\n            header="$ctrl.widgetData.header" flex>\n          </zp-totals-table>\n          </md-card>\n        </div>\n      </div>\n      <div ui-layout-container="central" layout="column" layout-align="start stretch">\n        <!--  THE RIGHT/BOTTOM CONTAINER -->\n          <p layout-padding class="md-subhead" ng-show="$ctrl.gridFilter.length == 0">\n            Click the chart to filter the grid\n          </p>\n    \n          <div layout-padding layout="row" layout-wrap ng-hide="$ctrl.gridFilter.length == 0">\n            <p class="md-subhead">Current filter:</p>\n            <div layout-margin class="grid_filter_chip" layout-align="space-between center" layout="row"\n              ng-repeat="item in $ctrl.gridFilter">\n              <p class="mc-caption">{{ item.label }}</p>\n              <span flex></span>\n              <md-icon md-font-icon="zmdi zmdi-close" ng-click="$ctrl.removeFilterAndRefresh(item)"></md-icon>\n            </div>\n          </div>\n    \n          <md-card>\n            <zp-grid-toolbar ng-if="$ctrl.data.items.length" buttons="$ctrl.metadata.toolbarButtons" \n            search-value="$ctrl.searchValue" widget-id="$ctrl.metadata.id" metadata="$ctrl.metadata">\n            </zp-grid-toolbar>\n\n            <zp-data-grid ng-show="$ctrl.data.items.length" metadata="$ctrl.metadata" search-value="$ctrl.searchValue"\n            total-rows="$ctrl.totalRows" options="$ctrl.metadata.gridOptions" widget-id="\'full_page_widget_grid\'">\n            </zp-data-grid>\n    \n            <md-table-pagination\n              class="md-table-pagination"\n              ng-if="$ctrl.metadata.paginationOptions.pagination"\n              md-limit="$ctrl.metadata.paginationOptions.limit"\n              md-limit-options="$ctrl.metadata.paginationOptions.limitOptions"\n              md-page="$ctrl.metadata.paginationOptions.page"\n              md-total="{{$ctrl.totalRows}}"\n              md-page-select="$ctrl.metadata.paginationOptions.pageSelect"\n              md-boundary-links="$ctrl.metadata.paginationOptions.boundaryLinks"\n              md-on-paginate="$ctrl.logPagination(page, limit)">\n            </md-table-pagination>\n    \n          </md-card>\n        <!-- </div> -->\n      </div>\n    </ui-layout>\n  </div>\n</md-content>\n');
$templateCache.put('app/forms/reporting/headline-widget/zp-headline-widget.tmpl.html','<div flex ng-if="$ctrl.widgetData.id !== \'prizeDrawStatus\'">\n  <div layout-align="center center" layout="column" layout-fill>\n    <p class="md-caption zp-caption">{{$ctrl.widgetData.title}}</p>\n    <md-progress-circular ng-if="$ctrl.widgetData.loading" class="md-accent" md-mode="indeterminate">\n    </md-progress-circular>\n    <ng-md-icon icon="{{$ctrl.widgetData.metadata.icon}}" style="fill: #5b88b5;" size="30"></ng-md-icon>\n    <p class="md-display-1 zp-caption margin-bottom-0 margin-top-10" ng-Counter start="0"\n      target="$ctrl.widgetData.countupto" duration="1.8" currency-mode="$ctrl.widgetData.id == \'totalEstimatedRevenue\'">\n    </p>\n    <p class="md-caption zp-caption margin-bottom-0 margin-top-0">{{$ctrl.widgetData.subtitle}}</p>\n  </div>\n</div>\n<!-- <div flex ng-if="$ctrl.widgetData.id == \'prizeDrawStatus\'"> -->\n<!-- {{$ctrl.widgetData}} -->\n<!-- Winner winner chicken dinner! -->\n<!-- </div> -->');
$templateCache.put('app/forms/reporting/pdf-builder-sidebar/zp-pdf-builder-sidebar.tmpl.html','<md-sidenav md-component-id="reportBuilderSideNav" class="md-sidenav-right" style="width:360px; max-width: 360px;">\n  <md-content md-theme="zuantCloudSkin" theme-background="primary:hue-2">\n    <md-card>\n      <md-card-content>\n        <p class="md-headline margin-top-20">Interactive Report Builder</p>\n        <p class="md-body-1">Use the controls below to change the date range as well as which widgets are visible in the\n          report. Dates where leads have been captured are available for selection.</p>\n        <p class="md-body-1">N.B. Widgets are automatically hidden if they have no data, even if the widget is selected\n          in this panel!</p>\n        <form name="reportSettings">\n          <div layout="column">\n            <div layout="row" layout-align="start start">\n              <md-input-container flex="70" style="margin:0;" class="margin-top-20">\n                <label>Start date</label>\n                <md-datepicker flex ng-model="$ctrl.report.metadata.startDate.dt" md-placeholder="Start date"\n                  ng-change="$ctrl.updateRange(\'startDate\')" name="startdate"\n                  md-min-date="$ctrl.startDateObjectsArr[0].dt" md-max-date="$ctrl.endDateObjectsArr[0].dt"\n                  md-date-filter="$ctrl.onlyActiveDaysPredicate" required>\n                </md-datepicker>\n              </md-input-container>\n              <md-button ng-click="$ctrl.resetStartDate()" class="md-icon-button md-accent">\n                <md-tooltip>Reset start date</md-tooltip>\n                <md-icon md-font-icon="zmdi zmdi-undo"></md-icon>\n              </md-button>\n            </div>\n            <div layout="row" layout-align="start start">\n              <md-input-container flex="70" style="margin:0;">\n                <label>End date</label>\n                <md-datepicker flex ng-model="$ctrl.report.metadata.endDate.dt" ng-change="$ctrl.updateRange(\'endDate\')"\n                  md-placeholder="End date" md-min-date="$ctrl.report.metadata.startDate.dt"\n                  md-max-date="$ctrl.endDateObjectsArr[0].dt" md-date-filter="$ctrl.onlyActiveDaysPredicate"\n                  name="enddate" required>\n                </md-datepicker>\n              </md-input-container>\n              <md-button ng-click="$ctrl.resetEndDate()" class="md-icon-button md-accent">\n                <md-tooltip>Reset end date</md-tooltip>\n                <md-icon md-font-icon="zmdi zmdi-redo"></md-icon>\n              </md-button>\n            </div>\n          </div>\n          <md-list>\n            <md-list-item>\n              <p> Top 10\'s </p>\n              <md-tooltip>Trim answers to top 10</md-tooltip>\n              <md-switch class="md-secondary" name="limitAnswers" ng-change="$ctrl.trimAnswers()"\n                ng-model="$ctrl.report.metadata.limitAnswers"></md-switch>\n            </md-list-item>\n          </md-list>\n          <input type="hidden" name="CSRFToken" value="1231234567890" />\n        </form>\n        <md-list class="md-dense example-animate-container" flex ng-sortable style="padding: 0;">\n          <md-subheader class="md-no-sticky">\n            <div layout="row" layout-align="start center">\n              Headline widgets\n              <span flex></span>\n              <md-button class="md-secondary md-icon-button"\n                ng-click="$ctrl.toggleAllWidgetsInReport(\'headlineWidgets\')" aria-label="toggle widgets from report">\n                <ng-md-icon icon="{{$ctrl.iconCheck(\'headlineWidgets\')}}" style="fill: #949ca1;" size="24"></ng-md-icon>\n              </md-button>\n            </div>\n          </md-subheader>\n          <md-list-item class="md-3-line animate-repeat"\n            ng-repeat-start="item in $ctrl.reportWidgets.headlineWidgets.items"\n            ng-click="$ctrl.toggleWidgetInReport(item)">\n            <div class="md-list-item-text" layout="column">\n              <p class="md-body-2">\n                <ng-md-icon icon="{{item.metadata.icon}}" style="fill: #949ca1;" size="20"></ng-md-icon>\n                <span class="">{{ item.title }}</span>\n              </p>\n            </div>\n            <ng-md-icon icon="{{item.inReport ? \'done\' : \'done\'}}"\n              style="fill: {{item.inReport ? \'#78cdd1\':\'#e8e8e8\'}};" size="24"></ng-md-icon>\n\n          </md-list-item>\n          <md-divider ng-repeat-end></md-divider>\n          <md-subheader class="md-no-sticky">\n            <div layout="row" layout-align="start center">\n              Time widgets\n              <span flex></span>\n              <md-button class="md-secondary md-icon-button"\n                ng-click="$ctrl.toggleAllWidgetsInReport(\'timeWidgets\'); $ctrl.toggleAllWidgetsInReport(\'revenueWidgets\')"\n                aria-label="toggle widgets from report">\n                <ng-md-icon icon="{{$ctrl.iconCheck(\'timeWidgets\')}}" style="fill: #949ca1;" size="24"></ng-md-icon>\n              </md-button>\n            </div>\n          </md-subheader>\n          <md-list-item class="md-3-line animate-repeat"\n            ng-repeat-start="item in $ctrl.reportWidgets.timeWidgets.items.concat($ctrl.reportWidgets.revenueWidgets.items)"\n            ng-click="$ctrl.toggleWidgetInReport(item)">\n            <div class="md-list-item-text" layout="column">\n              <p class="md-body-2">\n                <ng-md-icon icon="{{item.metadata.icon}}" style="fill: #949ca1;" size="20"></ng-md-icon>\n                <span class="">{{ item.title }}</span>\n              </p>\n            </div>\n            <ng-md-icon icon="{{item.inReport ? \'done\' : \'done\'}}"\n              style="fill: {{item.inReport ? \'#78cdd1\':\'#e8e8e8\'}};" size="24"></ng-md-icon>\n          </md-list-item>\n          <md-divider ng-repeat-end></md-divider>\n          <md-subheader class="md-no-sticky">\n            <div layout="row" layout-align="start center">\n              Question widgets\n              <span flex></span>\n              <md-button class="md-secondary md-icon-button"\n                ng-click="$ctrl.toggleAllWidgetsInReport(\'columnSummaryWidgets\')"\n                aria-label="toggle widgets from report">\n                <ng-md-icon icon="{{$ctrl.iconCheck(\'columnSummaryWidgets\')}}" style="fill: #949ca1;" size="24">\n                </ng-md-icon>\n              </md-button>\n            </div>\n          </md-subheader>\n          <md-list-item class="md-3-line animate-repeat"\n            ng-repeat-start="item in $ctrl.reportWidgets.columnSummaryWidgets.items"\n            ng-click="$ctrl.toggleWidgetInReport(item)">\n            <div class="md-list-item-text" layout="column">\n              <p class="md-body-2">\n                <ng-md-icon icon="{{item.metadata.icon}}" style="fill: #949ca1;" size="20"></ng-md-icon>\n                <span class="">{{ item.title }}</span>\n              </p>\n            </div>\n            <ng-md-icon icon="{{item.inReport ? \'done\' : \'done\'}}"\n              style="fill: {{item.inReport ? \'#78cdd1\':\'#e8e8e8\'}};" size="24"></ng-md-icon>\n          </md-list-item>\n          <md-divider ng-repeat-end></md-divider>\n          <md-subheader class="md-no-sticky">\n            <div layout="row" layout-align="start center">\n              Showroom widgets\n              <span flex></span>\n              <md-button class="md-secondary md-icon-button"\n                ng-click="$ctrl.toggleAllWidgetsInReport(\'showroomWidgets\')" aria-label="toggle widgets from report">\n                <ng-md-icon icon="{{$ctrl.iconCheck(\'showroomWidgets\')}}" style="fill: #949ca1;" size="24"></ng-md-icon>\n              </md-button>\n            </div>\n          </md-subheader>\n          <md-list-item class="md-3-line animate-repeat"\n            ng-repeat-start="item in $ctrl.reportWidgets.showroomWidgets.items"\n            ng-click="$ctrl.toggleWidgetInReport(item)">\n            <div class="md-list-item-text" layout="column">\n              <p class="md-body-2">\n                <ng-md-icon icon="{{item.metadata.icon}}" style="fill: #949ca1;" size="20"></ng-md-icon>\n                <span class="">{{ item.title }}</span>\n              </p>\n            </div>\n            <ng-md-icon icon="{{item.inReport ? \'done\' : \'done\'}}"\n              style="fill: {{item.inReport ? \'#78cdd1\':\'#e8e8e8\'}};" size="24"></ng-md-icon>\n          </md-list-item>\n          <md-divider ng-repeat-end></md-divider>\n          <md-subheader class="md-no-sticky" ng-show="$ctrl.userIsZAM">\n            <div layout="row" layout-align="start center">\n              Email Activity Headlines\n              <span flex></span>\n              <md-button class="md-secondary md-icon-button"\n                ng-click="$ctrl.toggleAllWidgetsInReport(\'emailHeadlinePerformanceWidgets\')"\n                aria-label="toggle widgets from report">\n                <ng-md-icon icon="{{$ctrl.iconCheck(\'emailHeadlinePerformanceWidgets\')}}" style="fill: #949ca1;"\n                  size="24"></ng-md-icon>\n              </md-button>\n            </div>\n          </md-subheader>\n          <md-list-item class="md-3-line animate-repeat"\n            ng-repeat-start="item in $ctrl.reportWidgets.emailHeadlinePerformanceWidgets.items"\n            ng-click="$ctrl.toggleWidgetInReport(item)" ng-show="$ctrl.userIsZAM">\n            <div class="md-list-item-text" layout="column">\n              <p class="md-body-2">\n                <ng-md-icon icon="{{item.metadata.icon}}" style="fill: #949ca1;" size="20"></ng-md-icon>\n                <span class="">{{ item.title }}</span>\n              </p>\n            </div>\n            <ng-md-icon icon="{{item.inReport ? \'done\' : \'done\'}}"\n              style="fill: {{item.inReport ? \'#78cdd1\':\'#e8e8e8\'}};" size="24"></ng-md-icon>\n          </md-list-item>\n          <md-divider ng-repeat-end ng-show="$ctrl.userIsZAM"></md-divider>\n          <md-subheader class="md-no-sticky" ng-show="$ctrl.userIsZAM">\n            <div layout="row" layout-align="start center">\n              Email Activity widgets\n              <span flex></span>\n              <md-button class="md-secondary md-icon-button"\n                ng-click="$ctrl.toggleAllWidgetsInReport(\'emailPerformanceWidgets\')"\n                aria-label="toggle widgets from report">\n                <ng-md-icon icon="{{$ctrl.iconCheck(\'emailPerformanceWidgets\')}}" style="fill: #949ca1;" size="24">\n                </ng-md-icon>\n              </md-button>\n            </div>\n          </md-subheader>\n          <md-list-item class="md-3-line animate-repeat"\n            ng-repeat-start="item in $ctrl.reportWidgets.emailPerformanceWidgets.items"\n            ng-click="$ctrl.toggleWidgetInReport(item)" ng-show="$ctrl.userIsZAM">\n            <div class="md-list-item-text" layout="column">\n              <p class="md-body-2">\n                <ng-md-icon icon="{{item.metadata.icon}}" style="fill: #949ca1;" size="20"></ng-md-icon>\n                <span class="">{{ item.title }}</span>\n              </p>\n            </div>\n            <ng-md-icon icon="{{item.inReport ? \'done\' : \'done\'}}"\n              style="fill: {{item.inReport ? \'#78cdd1\':\'#e8e8e8\'}};" size="24"></ng-md-icon>\n          </md-list-item>\n          <md-divider ng-repeat-end ng-show="$ctrl.userIsZAM"></md-divider>\n        </md-list>\n      </md-card-content>\n    </md-card>\n  </md-content>\n</md-sidenav>');
$templateCache.put('app/forms/reporting/printable-chart-widget/zp-printable-chart.tmpl.html','<md-card layout="column">\n  <md-card-header style="border-bottom: 1px solid rgba(0,0,0,0.12);" layout="row">\n    <md-card-avatar>\n      <ng-md-icon ng-show="!!$ctrl.widgetData.metadata.icon" icon="{{$ctrl.widgetData.metadata.icon}}"\n        style="fill: #5b88b5" size="30"></ng-md-icon>\n      </md-icon>\n    </md-card-avatar>\n    <md-card-header-text>\n      <p class="md-body-2 zp-caption margin-top-0 margin-bottom-0">{{$ctrl.widgetData.title}}</p>\n      <p class="md-caption zp-caption margin-top-0 margin-bottom-0">{{$ctrl.widgetData.subtitle}}</p>\n    </md-card-header-text>\n  </md-card-header>\n  <md-card-content layout="column" layout-align="center center">\n\n    <div layout="row" layout-align="center start" ng-hide="$ctrl.widgetData.isEmpty">\n      <zp-totals-table ng-if="$ctrl.chartOptions.totalsTable && $ctrl.chartOptions.totalsTable.display"\n        header="$ctrl.widgetData.header" data="$ctrl.widgetData.tableData">\n      </zp-totals-table>\n\n      <zp-chart flex chart-data="$ctrl.widgetData.chart.data" chart-labels="$ctrl.widgetData.chart.labels"\n        chart-series="$ctrl.widgetData.chart.series" chart-options="$ctrl.chartOptions"\n        chart-type="$ctrl.widgetData.chart.type" chart-click="$ctrl.chartClicked(chartEl)"\n        chart-id="$ctrl.widgetData.id">\n      </zp-chart>\n    </div>\n\n    <!--<canvas ng-show="!$ctrl.widgetData.singleBarAlternativeGraphic" class="chart-base"\n      chart-data="$ctrl.widgetData.chart.data" chart-labels="$ctrl.widgetData.chart.labels"\n      chart-series="$ctrl.widgetData.chart.series" chart-type="$ctrl.widgetData.chart.type"\n      chart-options="$ctrl.chartOptions">\n    </canvas>!-->\n    <!-- <div ng-show="$ctrl.widgetData.singleBarAlternativeGraphic" layout-padding>\n      <p class="md-headline zp-caption margin-bottom-0 uppercase text-align-center">{{$ctrl.widgetData.chart.data[0]}}</p>\n      <p class="md-title zp-caption margin-bottom-0 uppercase text-align-center">{{$ctrl.widgetData.chart.labels[0]}}</p>\n    </div> -->\n    <div ng-show="$ctrl.widgetData.isEmpty" layout-padding>\n      <p class="md-caption zp-caption margin-bottom-0 uppercase text-align-center">No Data</p>\n    </div>\n  </md-card-content>\n</md-card>');
$templateCache.put('app/forms/reporting/printable-page-component/zp-printable-page.tmpl.html','<style>\n  body {\n    margin: 0;\n    padding: 0;\n    background-color: #FAFAFA;\n    font: 12pt "Tahoma";\n  }\n\n  * {\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n  }\n</style>\n\n<md-toolbar class="dont-print">\n  <div class="md-toolbar-tools" layout="row">\n    <md-button class="md-no-ripple" zp-link="/dashboard" style="cursor:pointer" layout-align="center center">\n      <md-tooltip md-direction="">go to dashboard</md-tooltip>\n      <div ng-include src="$ctrl.zuantLogoURL" style="max-height:24px;"></div>\n    </md-button>\n    <div flex></div>\n    <md-button class="dont-print md-icon-button" ng-click="$ctrl.printReport()"><i\n        class="md-font-icon zmdi zmdi-print"></i>\n      <md-tooltip>Print PDF</md-tooltip>\n    </md-button>\n    <md-button class="dont-print md-icon-button"\n      ui-sref="app.tabbed_app_framework.single_form.dashboard({_id: $ctrl.formid})"><i\n        class="md-font-icon zmdi zmdi-close"></i>\n      <md-tooltip>back to dashboard</md-tooltip>\n    </md-button>\n  </div>\n</md-toolbar>\n<md-content style="max-height: 100vh;">\n  <div class="book">\n    <md-card class="page-full-bleed">\n      <div class="title_page" layout="column">\n        <div layout="row">\n          <div ng-include="$ctrl.twoBoxImageSvg"></div>\n          <div flex></div>\n          <div ng-include="$ctrl.twoBoxAlternateImageSvg"></div>\n        </div>\n\n        <div flex="20"></div>\n\n        <div flex="grow" layout="column" layout-align="start center">\n          <div class="client_logo" layout="row" layout-align="center start">\n            <img ng-if="$ctrl.clientLogoImage.type === \'custom\'" ng-src="{{$ctrl.clientLogoImage.url}}">\n            <div ng-if="$ctrl.clientLogoImage.type === \'default\'" ng-include src="$ctrl.clientLogoImage.url"></div>\n          </div>\n\n          <p class="md-caption zp-caption margin-bottom0">Executive Summary:</p>\n          <zp-editable-header metadata="$ctrl.title.metadata" value="$ctrl.report.metadata.title"\n            done-function="$ctrl.updateTitle(value)"></zp-editable-header>\n          <p><span class="md-caption zp-caption margin-top-0 margin-bottom-0">From:\n            </span> <span class="md-body">{{$ctrl.report.metadata.startDate.caption}}</span></p>\n          <p><span class="md-caption zp-caption margin-top-0">To: </span><span class="md-body">\n              {{$ctrl.report.metadata.endDate.caption}}</span></p>\n          <p ng-show="$ctrl.top10Answers"><span class="md-body-1">This report shows the top 10 answers to each\n              question</span></p>\n        </div>\n        <div flex></div>\n      </div>\n    </md-card>\n\n\n    <md-card class="page" ng-if="$ctrl.headlineWidgets.length">\n      <div class="subpage">\n        <p class="md-caption zp-caption uppercase">The Headlines</p>\n        <div layout="row" layout-align="space-around center">\n          <zp-headline-widget ng-repeat="widget in $ctrl.headlineWidgets" ng-if="widget.inReport && !widget.isEmpty"\n            widget-data="widget" on-click="$ctrl.toggleWidgetInReport($event)" layout-margin>\n          </zp-headline-widget>\n        </div>\n      </div>\n    </md-card>\n    <md-card class="page" class="page" ng-repeat="item in $ctrl.timeWidgets track by $ctrl.trackingFunction(item)">\n      <div ng-class="{\'subpage\' : item.id != \'leadsTeamPerformance\'}">\n        <zp-printable-chart ng-if="(item.id != \'leadsTopPerformer\' && item.id != \'leadsTeamPerformance\')"\n          widget-data="item">\n        </zp-printable-chart>\n        <div ng-if="item.id == \'leadsTopPerformer\'">\n          <zp-top-performer-widget widget-data=" item">\n          </zp-top-performer-widget>\n        </div>\n      </div>\n      <div ng-if="item.id == \'leadsTeamPerformance\'">\n        <zp-team-performance-widget widget-data=" item">\n        </zp-team-performance-widget>\n      </div>\n    </md-card>\n    <md-card class="page" class="page" ng-repeat="item in $ctrl.revenueWidgets track by $ctrl.trackingFunction(item)">\n      <div ng-class="{\'subpage\' : item.id != \'revenueTeamPerformance\'}">\n        <zp-printable-chart ng-if="(item.id != \'revenueTopPerformer\' && item.id != \'revenueTeamPerformance\')"\n          widget-data="item">\n        </zp-printable-chart>\n        <div ng-if="item.id == \'revenueTopPerformer\'">\n          <zp-top-performer-widget widget-data="item" id="revenueTopPerformer">\n          </zp-top-performer-widget>\n        </div>\n      </div>\n      <div ng-if="item.id == \'revenueTeamPerformance\'">\n        <zp-team-performance-widget widget-data="item" id="revenueTeamPerformance">\n        </zp-team-performance-widget>\n      </div>\n    </md-card>\n    <md-card class="page" class="page"\n      ng-repeat="item in $ctrl.columnSummaryWidgets track by $ctrl.trackingFunction(item)"\n      ng-if="item.inReport && !item.isEmpty">\n      <div class="subpage">\n        <zp-printable-chart widget-data="item">\n        </zp-printable-chart>\n      </div>\n    </md-card>\n    <md-card class="page" class="page" ng-repeat="item in $ctrl.showroomWidgets track by $ctrl.trackingFunction(item)"\n      ng-if="item.inReport && !item.isEmpty">\n      <div class="subpage">\n        <zp-printable-chart widget-data="item">\n        </zp-printable-chart>\n      </div>\n    </md-card>\n    <md-card class="page" ng-if="$ctrl.emailHeadlineWidgets.length">\n      <div class="subpage">\n        <p class="md-caption zp-caption uppercase">Email Activity Headlines</p>\n        <div layout="row" layout-align="space-around center">\n          <zp-email-headline-widget ng-repeat="widget in $ctrl.emailHeadlineWidgets" widget-data="widget"\n            on-click="$ctrl.toggleWidgetInReport($event)" layout-margin>\n          </zp-email-headline-widget>\n        </div>\n      </div>\n    </md-card>\n    <md-card class="page" class="page" ng-repeat="item in $ctrl.emailWidgets track by $ctrl.trackingFunction(item)"\n      ng-if="item.inReport && !item.isEmpty">\n      <div class="subpage">\n        <zp-printable-chart widget-data="item">\n        </zp-printable-chart>\n      </div>\n    </md-card>\n    <md-card class="page-full-bleed">\n      <div class="title_page" layout="column" layout-align="center space-between">\n        <div layout="row" layout-align="center center" flex>\n          <div layout="column">\n            <div ng-include src="$ctrl.poweredByZuantLogoURL"></div>\n          </div>\n        </div>\n        <div layout="row">\n          <div ng-include="$ctrl.twoBoxImageSvg"></div>\n          <div flex></div>\n          <div ng-include="$ctrl.twoBoxAlternateImageSvg"></div>\n        </div>\n      </div>\n    </md-card>\n  </div>\n</md-content>');
$templateCache.put('app/forms/reporting/question-chart-widget/zp-question-chart.tmpl.html','<md-card class="chart-card">\n  <md-card-header layout="row">\n    <md-card-avatar>\n      <ng-md-icon ng-show="!!$ctrl.widgetData.metadata.icon" icon="{{$ctrl.widgetData.metadata.icon}}" size="30">\n      </ng-md-icon>\n      </md-icon>\n    </md-card-avatar>\n    <md-card-header-text>\n      <p class="md-body-2 zp-caption margin-top-0 margin-bottom-0">{{$ctrl.widgetData.title}}</p>\n      <p class="md-caption zp-caption margin-top-0 margin-bottom-0">{{$ctrl.widgetData.subtitle}}</p>\n    </md-card-header-text>\n    <md-button ng-click="$ctrl.goTo($event)" ng-show="!$ctrl.widgetData.isEmpty">\n      <span md-menu-align-target>\n        <md-icon md-font-icon="zmdi zmdi-grid" style="color: #949cad;"></md-icon>\n      </span>\n      <md-tooltip>View Grid Data</md-tooltip>\n    </md-button>\n  </md-card-header>\n  <md-card-content layout-align="center center">\n    <md-progress-linear ng-if="$ctrl.widgetData.loading" class="md-accent" md-mode="indeterminate"></md-progress-linear>\n    <div ng-show="$ctrl.widgetData.isEmpty" layout-padding>\n      <p class="md-caption zp-caption margin-bottom-0 uppercase text-align-center">No Data</p>\n    </div>\n    <div layout="row" ng-show="!$ctrl.widgetData.isEmpty">\n      <div layout="column" flex="25" hide-xs hide-sm>\n        <div>\n          <p class="md-caption zp-caption">PERCENTAGE ANSWERED</p>\n          <div>\n            <p class="text-align-center"><span class="md-display-1 margin-bottom-0 "\n                countupto="$ctrl.widgetData.percentageAnswered" decimals="0" duration="1.5"></span><span>%</span></p>\n            <!-- <p class="md-caption margin-top-0 margin-bottom-0 text-align-center"></p> -->\n            <br>\n          </div>\n        </div>\n        <p class="md-caption zp-caption">ANSWER COUNTS</p>\n        <md-content style="max-height: 30vh;">\n          <zp-totals-table header="$ctrl.widgetData.header" data="$ctrl.widgetData.tableData">\n          </zp-totals-table>\n        </md-content>\n      </div>\n      <zp-chart flex chart-data="$ctrl.widgetData.chart.data" chart-labels="$ctrl.widgetData.chart.labels"\n        chart-series="$ctrl.widgetData.chart.series" chart-options="$ctrl.widgetData.chart.options"\n        chart-type="$ctrl.widgetData.chart.type" chart-click="$ctrl.chartClicked(chartEl)">\n      </zp-chart>\n    </div>\n  </md-card-content>\n  <md-card-actions layout="row" layout-align="end center" style="background: #ecedef;">\n    <md-button class="md-icon-button" ng-click="$ctrl.changeChartType(\'pie\')" style="width:auto">\n      Pie <md-icon md-font-icon="zmdi zmdi-chart" style="display:inline-block"></md-icon>\n    </md-button>\n    <md-button class="md-icon-button" ng-click="$ctrl.changeChartType(\'doughnut\')" style="width:auto">\n      Doughnut <md-icon md-font-icon="zmdi zmdi-chart" style="display:inline-block"></md-icon>\n    </md-button>\n    <md-button class="md-icon-button" ng-click="$ctrl.changeChartType(\'bar\')" style="width:auto">\n      Bar <md-icon md-font-icon="zmdi zmdi-chart" style="display:inline-block"></md-icon>\n    </md-button>\n    <md-button class="md-icon-button" ng-click="$ctrl.changeChartType(\'line\')" style="width:auto">\n      Line <md-icon md-font-icon="zmdi zmdi-chart" style="display:inline-block"></md-icon>\n    </md-button>\n    <md-button class="md-icon-button" ng-click="$ctrl.changeChartType(\'radar\')" style="width:auto">\n      Radar <md-icon md-font-icon="zmdi zmdi-chart" style="display:inline-block"></md-icon>\n    </md-button>\n    <md-button class="md-icon-button" ng-click="$ctrl.changeChartType(\'polarArea\')" style="width:auto">\n      Polar <md-icon md-font-icon="zmdi zmdi-chart" style="display:inline-block"></md-icon>\n    </md-button>\n  </md-card-actions>\n</md-card>');
$templateCache.put('app/forms/reporting/showroom-reports/zp-showroom-report.tmpl.html','<md-card>\n  <md-card-header layout="row">\n    <md-card-avatar>\n      <ng-md-icon icon="{{$ctrl.widgetData.metadata.icon}}" size="30"></ng-md-icon>\n    </md-card-avatar>\n    <md-card-header-text>\n      <p class="md-body-2 zp-caption margin-top-0 margin-bottom-0 uppercase">{{$ctrl.widgetData.title}}</p>\n      <p class="md-caption zp-caption margin-top-0 margin-bottom-0">{{$ctrl.widgetData.subtitle}}</p>\n    </md-card-header-text>\n    <!-- <md-button class="md-icon-button" ng-click="$ctrl.goTo($event)">\n      <md-icon md-font-icon="zmdi zmdi-chart"></md-icon>\n      <md-tooltip>View charts</md-tooltip>\n    </md-button> -->\n    <!-- <md-menu ng-show="!$ctrl.widgetData.isEmpty">\n      <md-button aria-label="Open chart menu" class="md-icon-button" ng-click="$mdMenu.open($event)">\n        <md-icon md-menu-origin md-font-icon="zmdi zmdi-more-vert"></md-icon>\n      </md-button>\n      <md-menu-content> -->\n    <!-- <md-menu-item>\n          <md-button ng-click="$ctrl.widgetData.showChart = !$ctrl.widgetData.showChart">\n            <span md-menu-align-target>\n              <ng-md-icon icon="{{ $ctrl.widgetData.showChart ? \'visibility_off\' : \'visibility\' }}"\n                style="fill: #949cad; margin-right: 16px;"></ng-md-icon>\n            </span>\n              <span ng-show="!$ctrl.widgetData.showChart">Show</span>\n              <span ng-show="$ctrl.widgetData.showChart">Hide</span> Chart\n          </md-button>\n        </md-menu-item> -->\n    <!-- <md-menu-item>\n          <md-button ng-click="$ctrl.widgetData.showTable = !$ctrl.widgetData.showTable">\n            <span md-menu-align-target>\n              <ng-md-icon icon="{{ $ctrl.widgetData.showTable ? \'visibility_off\' : \'visibility\' }}"\n                style="fill: #949cad; margin-right: 16px;"></ng-md-icon>\n            </span>\n              <span ng-show="!$ctrl.widgetData.showTable">Show</span>\n              <span ng-show="$ctrl.widgetData.showTable">Hide</span> Table\n          </md-button>\n        </md-menu-item> -->\n    <!-- <md-menu-item> -->\n    <md-button ng-click="$ctrl.goTo($event)">\n      <span md-menu-align-target>\n        <md-icon md-font-icon="zmdi zmdi-grid" style="color: #949cad;"></md-icon>\n      </span>\n      <md-tooltip>View Grid Data</md-tooltip>\n    </md-button>\n    <!-- </md-menu-item>\n      </md-menu-content>\n    </md-menu> -->\n  </md-card-header>\n  <md-card-content layout-align="center center">\n    <md-progress-circular ng-if="$ctrl.widgetData.loading" class="md-accent" md-mode="indeterminate">\n    </md-progress-circular>\n    <div ng-show="$ctrl.widgetData.isEmpty" layout-padding>\n      <p class="md-caption zp-caption margin-bottom-0 uppercase text-align-center">No Data</p>\n    </div>\n    <div layout="row" ng-show="!$ctrl.widgetData.isEmpty">\n      <div layout="column" flex="30" hide-xs hide-sm>\n        <!-- <div>\n          <p class="md-caption zp-caption">PERCENTAGE ANSWERED</p>\n          <div>\n            <p class="text-align-center">\n              <span class="md-display-1 margin-bottom-0 " \n                countupto="$ctrl.widgetData.percentageAnswered" \n                decimals="0" \n                duration="1.5">\n              </span>\n              <span>%</span>\n            </p>\n            <br>\n          </div>\n        </div> -->\n        <p class="md-caption zp-caption">ANSWER COUNTS</p>\n        <md-content style="max-height: 30vh;">\n          <zp-totals-table header="$ctrl.widgetData.header" data="$ctrl.widgetData.tableData">\n          </zp-totals-table>\n        </md-content>\n      </div>\n      <div layout="column" flex="70">\n        <zp-chart chart-data="$ctrl.widgetData.chart.data" chart-labels="$ctrl.widgetData.chart.labels"\n          chart-series="$ctrl.widgetData.chart.series" chart-options="$ctrl.widgetData.chart.options"\n          chart-type="$ctrl.widgetData.chart.type" chart-click="$ctrl.chartClicked(chartEl)"\n          g-show="$ctrl.widgetData.showChart">\n        </zp-chart>\n\n        <!-- <zp-totals-table\n          layout-fill\n          data="$ctrl.widgetData.tableData"\n          header="$ctrl.widgetData.header"\n          ng-show="$ctrl.widgetData.showTable">\n        </zp-totals-table> -->\n      </div>\n    </div>\n  </md-card-content>\n</md-card>');
$templateCache.put('app/forms/reporting/team-performance-component/zp-team-performance.tmpl.html','<md-card>\n  <md-card-header layout="row">\n    <md-card-avatar>\n      <ng-md-icon icon="{{$ctrl.widgetData.metadata.icon}}" size="30"></ng-md-icon>\n    </md-card-avatar>\n    <md-card-header-text>\n      <p class="md-body-2 zp-caption margin-top-0 margin-bottom-0 uppercase">{{$ctrl.widgetData.title}}</p>\n      <p class="md-caption zp-caption margin-top-0 margin-bottom-0">{{$ctrl.widgetData.subtitle}}</p>\n    </md-card-header-text>\n  </md-card-header>\n  <md-card-content layout-align="center center" layout="column">\n    <md-progress-circular ng-if="$ctrl.widgetData.loading" class="md-accent" md-mode="indeterminate">\n    </md-progress-circular>\n    <zp-totals-table ng-show="!$ctrl.widgetData.loading" data="$ctrl.widgetData.tableData"\n      header="$ctrl.widgetData.header" id="$ctrl.id" layout-fill>\n    </zp-totals-table>\n    <div ng-show="$ctrl.widgetData.isEmpty" layout-padding>\n      <p class="md-caption zp-caption margin-bottom-0 uppercase text-align-center">No Data</p>\n    </div>\n  </md-card-content>\n</md-card>');
$templateCache.put('app/forms/reporting/top-performer-component/zp-top-performer.tmpl.html','<md-card md-whiteframe="1">\n  <md-card-header layout="row">\n    <md-card-avatar>\n      <ng-md-icon icon="{{$ctrl.widgetData.metadata.icon}}" size="30"></ng-md-icon>\n    </md-card-avatar>\n    <md-card-header-text>\n      <p class="md-body-2 zp-caption margin-top-0 margin-bottom-0 uppercase">{{$ctrl.widgetData.title}}<span\n          ng-show="$ctrl.widgetData.chart.labels.length > 1">S</span></p>\n      <p class="md-caption zp-caption margin-top-0 margin-bottom-0">{{$ctrl.widgetData.subtitle}}</p>\n    </md-card-header-text>\n  </md-card-header>\n  <md-card-content layout-align="center center" layout="column">\n    <md-progress-circular ng-if="$ctrl.widgetData.loading" class="md-accent" md-mode="indeterminate">\n    </md-progress-circular>\n    <div ng-show="!$ctrl.widgetData.loading" ng-hide="$ctrl.widgetData.isEmpty">\n      <p class="md-headline text-align-center margin-bottom-0 margin-top-10"\n        ng-repeat="label in $ctrl.widgetData.chart.labels">{{label}}</p>\n      <p class="md-display-1 text-align-center margin-top-10 margin-bottom-0" ng-Counter start="0"\n        target="$ctrl.widgetData.countupto" duration="1.8" currency-mode="$ctrl.widgetData.id == \'revenueTopPerformer\'">\n      </p>\n      <p class="md-caption text-align-center margin-top-0 margin-bottom-0">\n        {{ $ctrl.widgetData.id == \'leadsTopPerformer\' ? \'Leads\' : \'Estimated Revenue\' }}\n      </p>\n    </div>\n    <div ng-show="$ctrl.widgetData.isEmpty" layout-padding>\n      <p class="md-caption zp-caption margin-bottom-0 uppercase text-align-center">No Data</p>\n    </div>\n  </md-card-content>\n</md-card>');
$templateCache.put('app/forms/reporting/widget-category-header-component/zp-widget-category-header.tmpl.html','<div layout="row">\n  <p class="md-caption zp-caption margin-bottom-0 uppercase" style="margin-top: 12px;">{{$ctrl.title}}</p>\n  <md-button class="md-icon-button" ng-click="$ctrl.toggleAllWidgets()">\n    <ng-md-icon icon="{{$ctrl.icon}}" style="fill: {{$ctrl.metadata.iconColor}}" size="20"></ng-md-icon>\n    <md-tooltip>{{$ctrl.metadata.tooltip}}</md-tooltip>\n  </md-button>\n</div>\n');
$templateCache.put('app/forms/reporting/column-summary-widget-component/zp-column-summary-widget.tmpl.html','<md-card style="ackground:#949ca1;" flex="auto">\n  <md-card-header style="border-bottom: 1px solid rgba(0,0,0,0.12);" layout="column">\n    <md-card-header-text>\n      <p class="md-subhead margin-bottom-0 margin-top-0">{{$ctrl.widgetData.title}}</p>\n    </md-card-header-text>\n    <!-- <div class="percentageAnsweredLine" style="width: {{$ctrl.widgetData.percentageAnswered}}pc;"> -->\n      <!-- <md-tooltip>{{$ctrl.widgetData.percentageAnswered | number:0}} % answered</md-tooltip> -->\n    <!-- </div> -->\n    <!-- <zp-widget-context-menu menu-item-clicked="$ctrl.menuItemClicked({event:event, selectedMenuItem: selectedMenuItem})" menu-options="$ctrl.menuOptions"></zp-widget-context-menu> -->\n  </md-card-header>\n  <md-card-content layout-align="center center" style="ackground:#78cdd1; padding:0px;">\n    <div layout="row" layout-fill>\n      <div layout="column" flex style="ackground:#f99d33;" layout-fill layout-padding>\n        <p class="md-caption margin-bottom-0 margin-top-0 zp-caption">TOP ANSWERS</p>\n        <p class="md-title margin-bottom-0 margin-top-0"><span class="md-caption">1st &nbsp;</span>{{$ctrl.widgetData.topAnswer.caption}} ({{$ctrl.widgetData.topAnswer.count}})</p>\n        <p class="md-body-1 margin-bottom-0 margin-top-0" ng-if="$ctrl.widgetData.chart.labels[1]"><span class="md-caption">2nd &nbsp;</span>{{$ctrl.widgetData.chart.labels[1]}} ({{$ctrl.widgetData.chart.data[1]}})</p>\n      </div>\n      <div layout="column" style="background:rgba(220,220,220,.25);" layout-align="center center" flex="20">\n         <!-- <svg>\n          <path id="arc1" fill="none" stroke="#f7f7f7" stroke-width="5" d="M 129.98922654601665 148.96210341024587 A 50 50 0 0 0 30 150" />\n          <path id="arc1" fill="none" stroke="{{$ctrl.widgetData.svg.strokeColour}}" stroke-width="5" ng-attr-d="{{$ctrl.widgetData.svg.dVal}}" />\n        </svg> -->\n        <p class="text-align-center margin-bottom-0 margin-top-0">\n          <span class="md-headline margin-bottom-0 margin-top-0" style="color: #868f95;" countupto="$ctrl.widgetData.percentageAnswered" decimals="0" duration="1.5"></span>\n          <span class="md-body text-align-center margin-top-0" style="color: #868f95;">%</span>\n        </p>\n        <p class="text-align-center margin-bottom-0 margin-top-0 md-caption" style="color: #868f95;">answered</p>\n      </div>\n    </div>\n  </md-card-content>\n  <md-card-actions layout="row" layout-align="end center" style="background: #ecedef;">\n    <md-button class="md-icon-button" ng-click="$ctrl.goTo($event)">\n      <md-icon md-font-icon="zmdi zmdi-chart"></md-icon>\n      <md-tooltip>View charts</md-tooltip>\n    </md-button>\n    \n    <md-button class="md-icon-button" ng-click="$ctrl.toggleWidgetInReport()">\n      <ng-md-icon icon="{{$ctrl.icon(\'icon\')}}" style="fill: {{$ctrl.icon(\'style\')}};" size="24"></ng-md-icon>\n      <md-tooltip>{{$ctrl.tooltip()}}</md-tooltip>\n      <!-- <md-icon ng-show="!$ctrl.widgetData.reportData.itemIsInReport" md-font-icon="zmdi zmdi-plus"></md-icon> -->\n      <!-- <md-icon ng-show="$ctrl.widgetData.reportData.itemIsInReport" md-font-icon="zmdi zmdi-check-circle zuantThyme"></md-icon> -->\n      <!-- <md-tooltip ng-show="$ctrl.widgetData.reportData.itemIsInReport">Widget is in report</md-tooltip> -->\n    </md-button>\n\n  </md-card-actions>\n</md-card>\n');
$templateCache.put('app/forms/reporting/email-headline-widget/zp-email-headline-widget.tmpl.html','<div flex>\n  <div layout-align="center center" layout="column" layout-fill>\n    <p class="md-caption zp-caption">{{$ctrl.widgetData.title}}</p>\n    <p class="md-subhead zp-caption margin-bottom-0 margin-top-0" ng-if="$ctrl.widgetData.metadata.subCategory === \'comparison\'">\n      <span countupto="$ctrl.widgetData.comparison.figure1" decimals="0" duration="1.8">\n        <md-tooltip direction="top">{{$ctrl.widgetData.comparison.figure1Field}}</md-tooltip>\n      </span>\n       / \n      <span countupto="$ctrl.widgetData.comparison.figure2" decimals="0" duration="1.8">\n        <md-tooltip direction="top">{{$ctrl.widgetData.comparison.figure2Field}}</md-tooltip>\n      </span>     \n    </p>  \n   \n    <md-progress-circular ng-if="$ctrl.widgetData.loading" class="md-accent" md-mode="indeterminate"></md-progress-circular>\n    \n    <!-- <md-button \n      class="md-icon-button" \n      ng-class="{\'md-raised md-primary\' : ($ctrl.widgetData.metadata.icon === \'visibility\')}"\n      ng-click="$ctrl.goToCharts()">  \n      \n      additional props for icon when button in use >>> \n      \n      style="position: absolute; top: 5px; left: 5px;"\n      ng-mouseenter="$ctrl.mouseEnter()"\n      ng-mouseleave="$ctrl.mouseLeave()"\n  -->\n   \n    <ng-md-icon \n        icon="{{$ctrl.widgetData.metadata.icon}}" \n        ng-style="{ fill: $ctrl.widgetData.metadata.iconColor }"\n        size="30">\n      </ng-md-icon>\n    <!-- </md-button> -->\n\n    <p ng-show="$ctrl.widgetData.metadata.subCategory !== \'comparison\'"\n      class="md-display-1 zp-caption margin-bottom-0 margin-top-10" \n      countupto="$ctrl.widgetData.countupto" \n      decimals="0"\n      duration="1.8"></p>\n    \n    <p ng-if="$ctrl.widgetData.metadata.subCategory === \'comparison\'"\n     class="md-display-1 margin-bottom-0 margin-top-10 zp-caption">\n     <span ng-if="$ctrl.widgetData.comparison.percentage == \'Infinity\'">0 %</span>\n     <span ng-if="$ctrl.widgetData.comparison.percentage != \'Infinity\'">\n      <span countupto="$ctrl.widgetData.comparison.percentage" decimals="0" duration="1.8"></span> %\n     </span> \n    </p>\n \n    <p class="md-caption zp-caption margin-bottom-0 margin-top-0">{{$ctrl.widgetData.subtitle}}</p>\n  </div>\n</div>\n');
$templateCache.put('app/forms/settings-page/cards/OCR-tab.tmpl.html','<md-card-header>\n  <md-card-avatar>\n    <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-spellcheck"></md-icon>\n  </md-card-avatar>\n  <md-card-header-text>\n    <span class="md-title">Business Card Scanning</span>\n    <span class="md-subhead">The contact fields template to use for Business Card Scanning in this form</span>\n  </md-card-header-text>\n  <md-button class="md-icon-button" ng-click="showOcrPanel = !showOcrPanel">\n    <ng-md-icon icon="{{showOcrPanel ? \'expand_less\' : \'expand_more\'}}" style="fill: #949ca1;"></ng-md-icon>\n  </md-button>\n</md-card-header>\n<md-card-content ng-show="showOcrPanel">\n  <zp-ocr-templates-list\n    flex="100"\n    model="$ctrl.formProperties.ocrTemplate"\n    on-change="$ctrl.updateSelectControl({formProp: \'ocrTemplate\', item: item })"\n    config="$ctrl.ocrTemplateConfig"\n    formname="$ctrl.formSettingsForm">\n  </zp-ocr-templates-list>\n</md-card-content>\n');
$templateCache.put('app/forms/settings-page/cards/advanced-settings-tab.tmpl.html','<md-card-header>\n  <md-card-avatar>\n    <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-settings"></md-icon>\n  </md-card-avatar>\n  <md-card-header-text>\n    <span class="md-title">Advanced settings</span>\n    <span class="md-subhead">Additional bells & whistles</span>\n  </md-card-header-text>\n  <md-button class="md-icon-button" ng-click="showAdvancedPanel = !showAdvancedPanel">\n    <ng-md-icon icon="{{showAdvancedPanel ? \'expand_less\' : \'expand_more\'}}" style="fill: #949ca1;"></ng-md-icon>\n  </md-button>\n</md-card-header>\n<md-card-content ng-show="showAdvancedPanel">\n  <md-list>\n    <md-list-item class="noright">\n      <p>Kiosk mode</p>\n      <md-button class="md-icon-button" ng-class="{\'md-accent md-raised\' : $ctrl.formProperties.kioskMode == \'Form\' }"\n        ng-click="$ctrl.manuallyUpdateFormProp(\'kioskMode\', \'Form\')">\n        <md-tooltip md-direction="top">Form</md-tooltip>\n        <md-icon md-font-icon="zmdi zmdi-file"></md-icon>\n      </md-button>\n      <md-button class="md-icon-button"\n        ng-class="{\'md-accent md-raised\' : $ctrl.formProperties.kioskMode == \'Showroom\' }"\n        ng-click="$ctrl.manuallyUpdateFormProp(\'kioskMode\', \'Showroom\')">\n        <md-tooltip md-direction="top">Showroom</md-tooltip>\n        <md-icon md-font-icon="zmdi zmdi-image-o"></md-icon>\n      </md-button>\n    </md-list-item>\n    <md-list-item>\n      <p>Executive Summary Autosend</p>\n      <md-switch ng-model="$ctrl.formProperties.sendExecutiveSummary"\n        ng-change="$ctrl.updateChangeDelta(\'sendExecutiveSummary\', $ctrl.formProperties.sendExecutiveSummary)"\n        aria-label="search button press" ng-true-value="1" ng-false-value="0"></md-switch>\n    </md-list-item>\n    <md-list-item>\n      <p>Event Countdown Send</p>\n      <md-switch ng-model="$ctrl.formProperties.sendEventCountdown"\n        ng-change="$ctrl.updateChangeDelta(\'sendEventCountdown\', $ctrl.formProperties.sendEventCountdown)"\n        aria-label="search button press" ng-true-value="1" ng-false-value="0"></md-switch>\n    </md-list-item>\n    <md-list-item>\n      <p>Require search button press</p>\n      <md-switch ng-model="$ctrl.formProperties.requireSearchButtonPress"\n        ng-change="$ctrl.updateChangeDelta(\'requireSearchButtonPress\', $ctrl.formProperties.requireSearchButtonPress)"\n        aria-label="search button press" ng-true-value="1" ng-false-value="0"></md-switch>\n    </md-list-item>\n    <md-list-item>\n      <p>Show scan button in toolbar</p>\n      <md-switch ng-model="$ctrl.formProperties.showScanButtonInToolbar"\n        ng-change="$ctrl.updateChangeDelta(\'showScanButtonInToolbar\', $ctrl.formProperties.showScanButtonInToolbar)"\n        aria-label="show scan button in toolbar" ng-true-value="1" ng-false-value="0"></md-switch>\n    </md-list-item>\n    <md-list-item>\n      <span class="md-body-1" flex="30">Photo Max Size</span>\n      <md-slider-container flex flex-offset-gt-md="10">\n        <md-slider aria-label="photoMaxDimension" flex ng-model="$ctrl.formProperties.photoMaxDimension"\n          ng-change="$ctrl.updateChangeDelta(\'photoMaxDimension\', $ctrl.formProperties.photoMaxDimension)" min="0"\n          max="1000">\n        </md-slider>\n        <md-input-container>\n          <input flex type="number" min="0" max="1000" step="1" ng-model="$ctrl.formProperties.photoMaxDimension"\n            ng-change="$ctrl.updateChangeDelta(\'photoMaxDimension\', $ctrl.formProperties.photoMaxDimension)"\n            aria-label="photoMaxDimension">\n        </md-input-container>\n      </md-slider-container>\n    </md-list-item>\n    <md-list-item>\n      <span class="md-body-1" flex="30">Photo Quality</span>\n      <md-slider-container flex flex-offset-gt-md="10">\n        <md-slider flex ng-model="$ctrl.formProperties.photoCompression"\n          ng-change="$ctrl.updateChangeDelta(\'photoCompression\', $ctrl.formProperties.photoCompression)" min="0.1"\n          max="1.0" step="0.1" aria-label="photoCompression">\n        </md-slider>\n        <md-input-container>\n          <input flex type="number" min="0.1" max="1.0" step="0.1" ng-model="$ctrl.formProperties.photoCompression"\n            ng-change="$ctrl.updateChangeDelta(\'photoCompression\', $ctrl.formProperties.photoCompression)"\n            aria-label="Photo compression">\n        </md-input-container>\n      </md-slider-container>\n    </md-list-item>\n    <md-list-item>\n      <p class="md-body-1" flex="30">Sync Interval (mins)</p>\n      <md-slider-container flex flex-offset-gt-md="10">\n        <md-slider ng-model="$ctrl.formProperties.delayInMinutesBetweenSyncAttempts"\n          ng-change="$ctrl.updateChangeDelta(\'delayInMinutesBetweenSyncAttempts\', $ctrl.formProperties.delayInMinutesBetweenSyncAttempts)"\n          min="0" max="30" aria-label="delayInMinutesBetweenSyncAttempts">\n        </md-slider>\n        <md-input-container>\n          <input type="number" min="0" max="30" step="1"\n            ng-model="$ctrl.formProperties.delayInMinutesBetweenSyncAttempts"\n            ng-change="$ctrl.updateChangeDelta(\'delayInMinutesBetweenSyncAttempts\', $ctrl.formProperties.delayInMinutesBetweenSyncAttempts)"\n            aria-label="delayInMinutesBetweenSyncAttempts">\n        </md-input-container>\n      </md-slider-container>\n    </md-list-item>\n    <md-list-item>\n      <p>Show required field indicators</p>\n      <md-switch ng-model="$ctrl.formProperties.showRequiredFieldIndicators"\n        ng-change="$ctrl.updateChangeDelta(\'showRequiredFieldIndicators\', $ctrl.formProperties.showRequiredFieldIndicators)"\n        aria-label="showRequiredFieldIndicators" ng-true-value="1" ng-false-value="0"></md-switch>\n    </md-list-item>\n    <md-list-item>\n      <p>Allow empty form submissions</p>\n      <md-switch ng-model="$ctrl.formProperties.allowEmptyFormSubmissions"\n        ng-change="$ctrl.updateChangeDelta(\'allowEmptyFormSubmissions\', $ctrl.formProperties.allowEmptyFormSubmissions)"\n        aria-label="allowEmptyFormSubmissions" ng-true-value="1" ng-false-value="0">\n      </md-switch>\n    </md-list-item>\n    <!-- <md-list-item>\n      <md-icon md-font-icon="zmdi zmdi-image-o"></md-icon>\n      <p>Require literature</p>\n      <md-switch\n        ng-model="$ctrl.formProperties.requireLiterature"\n        ng-change="$ctrl.updateChangeDelta(\'requireLiterature\', $ctrl.formProperties.requireLiterature)"\n        aria-label="Require literature"\n        ng-true-value="1"\n        ng-false-value="0">\n      </md-switch>\n    </md-list-item>-->\n    <md-list-item>\n      <p>Require notes</p>\n      <md-switch ng-model="$ctrl.formProperties.requireNotes"\n        ng-change="$ctrl.updateChangeDelta(\'requireNotes\', $ctrl.formProperties.requireNotes)" aria-label="requireNotes"\n        ng-true-value="1" ng-false-value="0">\n      </md-switch>\n    </md-list-item>\n    <md-list-item>\n      <p>Score lead</p>\n      <md-switch ng-model="$ctrl.formProperties.scoreLead"\n        ng-change="$ctrl.updateChangeDelta(\'scoreLead\', $ctrl.formProperties.scoreLead)" aria-label="Score lead"\n        ng-true-value="1" ng-false-value="0">\n      </md-switch>\n    </md-list-item>\n    <md-list-item>\n      <p>Disallow manual scrolling between pages</p>\n      <md-switch ng-model="$ctrl.formProperties.preventManualScrolling"\n        ng-change="$ctrl.updateChangeDelta(\'preventManualScrolling\', $ctrl.formProperties.preventManualScrolling)"\n        aria-label="Prevent manual scrolling" ng-true-value="1" ng-false-value="0">\n      </md-switch>\n    </md-list-item>\n    <md-list-item>\n      <p>Bypass configuration checks &nbsp;\n        <md-icon md-font-icon="zmdi zmdi-help-outline zuantTitanium1">\n          <md-tooltip direction="right">Bypasses checks for duplicate fields and such</md-tooltip>\n        </md-icon>\n      </p>\n      <md-switch ng-model="$ctrl.formProperties.bypassConfigurationChecks"\n        ng-change="$ctrl.updateChangeDelta(\'bypassConfigurationChecks\', $ctrl.formProperties.bypassConfigurationChecks)"\n        aria-label="Bypass config checks" ng-true-value="1" ng-false-value="0">\n      </md-switch>\n    </md-list-item>\n    <md-list-item>\n      <p>Allow duplicate email sends &nbsp;\n        <md-icon md-font-icon="zmdi zmdi-help-outline zuantTitanium1">\n          <md-tooltip direction="right">Allow duplicate thank you emails to be sent for each lead response\n            update.</md-tooltip>\n        </md-icon>\n      </p>\n      <md-switch ng-model="$ctrl.formProperties.allowDuplicateEmailSends"\n        ng-change="$ctrl.updateChangeDelta(\'allowDuplicateEmailSends\', $ctrl.formProperties.allowDuplicateEmailSends)"\n        aria-label="Allow Duplicate Email Sends" ng-true-value="true" ng-false-value="false">\n      </md-switch>\n    </md-list-item>\n    <md-list-item>\n      <p>Exclude users from Message Composer Recipients Lists</p>\n      <md-switch ng-model="$ctrl.formProperties.excludeUsersFromRecipientLists"\n        ng-change="$ctrl.updateChangeDelta(\'excludeUsersFromRecipientLists\', $ctrl.formProperties.excludeUsersFromRecipientLists)"\n        aria-label="Exclude users from recipients list" ng-true-value="1" ng-false-value="0">\n      </md-switch>\n    </md-list-item>\n    <md-list-item>\n      <p>Keep leads private</p>\n      <md-switch ng-model="$ctrl.formProperties.keepLeadsPrivate"\n        ng-change="$ctrl.updateChangeDelta(\'keepLeadsPrivate\', $ctrl.formProperties.keepLeadsPrivate)"\n        aria-label="Keep leads private" ng-true-value="1" ng-false-value="0">\n      </md-switch>\n    </md-list-item>\n    <md-list-item>\n      <p>Use form as a template</p>\n      <md-switch ng-model="$ctrl.formProperties.isAvailableAsFormTemplate"\n        ng-change="$ctrl.updateChangeDelta(\'isAvailableAsFormTemplate\', $ctrl.formProperties.isAvailableAsFormTemplate)"\n        aria-label="isAvailableAsFormTemplate" ng-true-value="1" ng-false-value="0">\n      </md-switch>\n    </md-list-item>\n    <md-list-item>\n      <p>Form Currency</p>\n      <md-input-container placeholder="Currency" class="md-no-underline" required md-no-asterisk="false"\n        class="md-block" flex-gt-sm>\n        <label>Currency</label>\n        <md-select whenscrollends currency-scroll-index="$ctrl.currencyScrollIndex"\n          ng-model="$ctrl.formProperties.currencyCode"\n          ng-change="$ctrl.updateChangeDelta(\'currencyCode\', $ctrl.formProperties.currencyCode)">\n          <div class="selection-list-header-container">\n            <md-select-header class="selection-list-header">\n              <md-icon md-font-icon="zmdi zmdi-search"></md-icon>\n              <input type="search" ng-model="searchTerm" placeholder="Search.." class="md-text"\n                ng-keydown="$ctrl.updateSearchCurrency($event)">\n            </md-select-header>\n            <md-select-header ng-if="!searchTerm || searchTerm.length == 0"\n              class="selection-list-header-current-section md-accent">\n              {{$ctrl.currencyScrollIndex > 20 ? \'Other\' : \'Most Popular\'}}\n            </md-select-header>\n          </div>\n          <md-option ng-repeat="currency in $ctrl.currencyList | filter:searchTerm" value="{{currency.code}}">\n            {{currency.name}} - <b>{{currency.symbol}}</b>\n          </md-option>\n        </md-select>\n      </md-input-container>\n    </md-list-item>\n  </md-list>\n</md-card-content>');
$templateCache.put('app/forms/settings-page/cards/ai-settings.tmpl.html','<md-card-header>\n    <md-card-avatar>\n        <md-icon class="md-avatar-icon" md-svg-src="{{\'/images/svgs/icons/custom/ai-icon.svg\' | cdnAssets}}"></md-icon>\n    </md-card-avatar>\n    <md-card-header-text>\n        <span class="md-title">AI</span>\n        <span class="md-subhead">General settings</span>\n    </md-card-header-text>\n    <md-button class="md-icon-button" ng-click="$ctrl.showAiPanel = !$ctrl.showAiPanel">\n        <ng-md-icon icon="{{$ctrl.showAiPanel ? \'expand_less\' : \'expand_more\'}}" style="fill: #949ca1;"></ng-md-icon>\n    </md-button>\n</md-card-header>\n\n<md-card-content ng-show="$ctrl.showAiPanel">\n\n    <md-subheader>General</md-subheader>\n    <form name="aiForm" novalidate>\n        <md-list>\n\n            <md-list-item>\n                <p>\n                    AI Enabled\n                    <md-icon md-font-icon="zmdi zmdi-help-outline zuantTitanium1">\n                        <md-tooltip direction="right">Enable/disable Zuant AI for this form.</md-tooltip>\n                    </md-icon>\n                </p>\n                <md-switch ng-model="$ctrl.formProperties.aiEnabled"\n                    ng-change="$ctrl.updateChangeDelta(\'aiEnabled\', $ctrl.formProperties.aiEnabled)"\n                    aria-label="AI Enabled" ng-true-value="1" ng-false-value="0">\n                </md-switch>\n            </md-list-item>\n\n        </md-list>\n        <input type="hidden" name="CSRFToken" value="1231234567890" />\n    </form>\n</md-card-content>');
$templateCache.put('app/forms/settings-page/cards/camera-modes.tmpl.html','<!-- <md-dialog aria-label="Camera Modes" style="min-width:700px;" ng-cloak>\r\n    <form>\r\n        <md-toolbar>\r\n            <div class="md-toolbar-tools">\r\n                <h2>Camera Modes!</h2>\r\n                <span flex></span>\r\n                <md-button class="md-icon-button" ng-click="cancel()">\r\n                    <md-icon md-svg-src="img/icons/ic_close_24px.svg" aria-label="Close dialog"></md-icon>\r\n                </md-button>\r\n            </div>\r\n        </md-toolbar>\r\n        <md-dialog-content>\r\n            <div class="md-dialog-content">\r\n                <md-list>\r\n                    <md-subheader class="md-no-sticky">2D Camera Modes</md-subheader>\r\n                    <md-list-item>\r\n                        <p>QR Code</p>\r\n                        <md-switch ng-model="formProperties.allowCameraSymbologyQRCODE" aria-label="" ng-true-value=1 ng-false-value=0></md-switch>\r\n                    </md-list-item>\r\n                    <md-list-item>\r\n                        <p>PDF417</p>\r\n                        <md-switch ng-model="formProperties.allowCameraSymbologyPDF417" aria-label="" ng-true-value=1 ng-false-value=0></md-switch>\r\n                    </md-list-item>\r\n                    <md-list-item>\r\n                        <p>Data Matrix</p>\r\n                        <md-switch ng-model="formProperties.allowCameraSymbologyDM" aria-label="" ng-true-value=1 ng-false-value=0></md-switch>\r\n                    </md-list-item>\r\n                    <md-list-item>\r\n                        <p>Aztec</p>\r\n                        <md-switch ng-model="formProperties.allowCameraSymbologyAZTEC" aria-label="" ng-true-value=1 ng-false-value=0></md-switch>\r\n                    </md-list-item>\r\n                    <md-divider></md-divider>\r\n                    <md-subheader class="md-no-sticky">1D Camera Modes</md-subheader>\r\n                    <md-list-item>\r\n                        <p>Code 25</p>\r\n                        <md-switch ng-model="formProperties.allowCameraSymbology25" aria-label="" ng-true-value=1 ng-false-value=0></md-switch>\r\n                    </md-list-item>\r\n                    <md-list-item ng-if="formProperties.allowCameraSymbology25">\r\n                        <p>Remove Code 25 check digit</p>\r\n                        <md-switch ng-model="vm.formProperties.removeSymbology25CheckDigit" aria-label="" ng-true-value=1 ng-false-value=0></md-switch>\r\n                    </md-list-item>\r\n                    <md-list-item ng-if="formProperties.allowCameraSymbology25" >\r\n                        <div layout="" layout-fill>\r\n                            <div flex="30" layout="" layout-align="center center">\r\n                                <span class="md-body-1">Code 25 min number of digits</span>\r\n                            </div>\r\n                            <md-slider flex="" ng-model="formProperties.code25SymbologyMinLength" min="0" max="100" aria-label="rating">\r\n                            </md-slider>\r\n                            <md-input-container>\r\n                                <input flex="" type="number" ng-model="formProperties.code25SymbologyMinLength" aria-label="" aria-controls="">\r\n                            </md-input-container>\r\n                        </div>\r\n                    </md-list-item>\r\n                    <md-list-item>\r\n                        <p>Code 39</p>\r\n                        <md-switch ng-model="formProperties.allowCameraSymbology39" aria-label="" ng-true-value=1 ng-false-value=0></md-switch>\r\n                    </md-list-item>\r\n                    <md-list-item ng-if="formProperties.allowCameraSymbology39" >\r\n                        <p>Remove Code 39 Check Digit</p>\r\n                        <md-switch ng-model="formProperties.removeSymbology39CheckDigit" aria-label="" ng-true-value=1 ng-false-value=0></md-switch>\r\n                    </md-list-item>\r\n                    <md-list-item>\r\n                        <p>Code 128</p>\r\n                        <md-switch ng-model="formProperties.allowCameraSymbology128" aria-label="" ng-true-value=1 ng-false-value=0></md-switch>\r\n                    </md-list-item>\r\n                    <md-list-item ng-if="formProperties.allowCameraSymbology128" >\r\n                        <p>Remove Code 39 Check Digit</p>\r\n                        <md-switch ng-model="formProperties.removeSymbology128CheckDigit" aria-label="" ng-true-value=1 ng-false-value=0></md-switch>\r\n                    </md-list-item>\r\n\r\n                </md-list>\r\n            </div>\r\n        </md-dialog-content>\r\n        <md-dialog-actions layout="row">\r\n            <span flex></span>\r\n            <md-button ng-click="answer(\'done\')" style="margin-right:20px;">\r\n                Done\r\n            </md-button>\r\n        </md-dialog-actions>\r\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\r\n</form>\r\n</md-dialog> -->\r\n');
$templateCache.put('app/forms/settings-page/cards/compliance-tab.tmpl.html','<md-card-header>\n  <md-card-avatar>\n    <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-shield-check"></md-icon>\n  </md-card-avatar>\n  <md-card-header-text>\n    <span class="md-title">Compliance settings</span>\n    <span class="md-subhead">All things GDPR & Privacy</span>\n  </md-card-header-text>\n  <md-button class="md-icon-button" ng-click="showCompliancePanel = !showCompliancePanel">\n    <ng-md-icon icon="{{showCompliancePanel ? \'expand_less\' : \'expand_more\'}}" style="fill: #949ca1;"></ng-md-icon>\n  </md-button>\n</md-card-header>\n<md-card-content ng-show="showCompliancePanel">\n  <md-list>\n    <md-subheader ng-show="$ctrl.accountIsPermittedToWaiveGDPRCompliance">GDPR</md-subheader>\n    <md-list-item ng-show="$ctrl.accountIsPermittedToWaiveGDPRCompliance">\n      <p>Waive all GDPR Settings</p>\n      <md-switch ng-model="$ctrl.formProperties.waiveGDPRCompliance"\n        ng-change="$ctrl.updateChangeDelta(\'waiveGDPRCompliance\', $ctrl.formProperties.waiveGDPRCompliance)"\n        aria-label="waive GDPR compliance" ng-true-value="1" ng-false-value="0">\n      </md-switch>\n    </md-list-item>\n    <md-subheader>Privacy Settings</md-subheader>\n    <md-list-item class="noright">\n      <zp-privacy-statements-select-control flex="100" model="$ctrl.formProperties.privacyStatement"\n        on-change="$ctrl.updateSelectControl({formProp: \'privacyStatement\', item: item})"\n        config="$ctrl.privacyStatementConfig" formname="$ctrl.formSettingsForm">\n      </zp-privacy-statements-select-control>\n    </md-list-item>\n    <md-list-item>\n      <p>Waive privacy statement</p>\n      <md-switch ng-model="$ctrl.formProperties.waivePrivacyStatement"\n        ng-change="$ctrl.updateChangeDelta(\'waivePrivacyStatement\', $ctrl.formProperties.waivePrivacyStatement)"\n        aria-label="waivePrivacyStatement" ng-true-value="1" ng-false-value="0">\n      </md-switch>\n    </md-list-item>\n    <md-list-item class="margin-top-10">\n      <md-input-container flex>\n        <label>Privacy statement action button text</label>\n        <input ng-model="$ctrl.formProperties.privacyStatementActionButtonText"\n          ng-change="$ctrl.updateChangeDelta(\'privacyStatementActionButtonText\', $ctrl.formProperties.privacyStatementActionButtonText)">\n      </md-input-container>\n    </md-list-item>\n  </md-list>\n</md-card-content>');
$templateCache.put('app/forms/settings-page/cards/contact-filter-settings-tab.tmpl.html','<md-card-header>\n    <md-card-avatar>\n        <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-accounts-list"></md-icon>\n    </md-card-avatar>\n    <md-card-header-text>\n        <span class="md-title">Contact Filter settings</span>\n        <span class="md-subhead">Setup filters to limit which contacts appear in the contact search</span>\n    </md-card-header-text>\n    <md-button class="md-icon-button" ng-click="showContactFilterSettingsPanel = !showContactFilterSettingsPanel">\n        <ng-md-icon icon="{{showContactFilterSettingsPanel ? \'expand_less\' : \'expand_more\'}}"\n            style="fill: #949ca1;"></ng-md-icon>\n    </md-button>\n</md-card-header>\n<md-card-content ng-show="showContactFilterSettingsPanel">\n    <md-list>\n        <md-list-item>\n            <div layout="column" flex="100" layout-align="center center">\n                <h4>\n                    {{$ctrl.getCurrentContactFilterSummary()}}\n                </h4>\n            </div>\n        </md-list-item>\n\n        <md-divider></md-divider>\n\n        <md-list-item>\n            <p class="md-body-1" flex="60">Data-loads filters</p>\n            <p class="md-caption">\n                <ng-pluralize class="md-caption" count="$ctrl.calculateContactFilterDataLoadsCount()" when="{\'0\': \'No dataload filters selected.\',\n                               \'1\': \'1 dataload filter selected.\',\n                               \'other\': \'{} dataload filters selected.\'}">\n                </ng-pluralize>\n            </p>\n            <md-button class="md-icon-button" ng-click="$ctrl.openDataLoadContactFiltersSettingsDialog()"\n                aria-label="Filter contacts visible for this form based on data loads">\n                <md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon>\n            </md-button>\n        </md-list-item>\n\n        <md-list-item>\n            <p class="md-body-1" flex="60">Forms Filters</p>\n            <p class="md-caption">\n                <ng-pluralize class="md-caption" count="$ctrl.calculateContactFilterFormsCount()" when="{\'0\': \'No contact form filters selected.\',\n                               \'1\': \'1 contact form filter selected.\',\n                               \'other\': \'{} contact form filters selected.\'}">\n                </ng-pluralize>\n            </p>\n            <md-button class="md-icon-button" ng-click="$ctrl.openFormContactFiltersSettingsDialog()"\n                aria-label="Filter contacts visible for this form, TODO make clear!">\n                <md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon>\n            </md-button>\n        </md-list-item>\n    </md-list>\n</md-card-content>');
$templateCache.put('app/forms/settings-page/cards/e-z-menu.tmpl.html','<md-card-header>\n  <md-card-avatar>\n    <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-more"></md-icon>\n  </md-card-avatar>\n  <md-card-header-text>\n    <span class="md-title">E-Z menu</span>\n    <span class="md-subhead">Form settings shortcuts</span>\n  </md-card-header-text>\n  <md-button class="md-icon-button" ng-click="showEzMenuPanel = !showEzMenuPanel">\n    <ng-md-icon icon="{{showEzMenuPanel ? \'expand_less\' : \'expand_more\'}}" style="fill: #949ca1;"></ng-md-icon>\n  </md-button>\n</md-card-header>\n<md-card-content ng-show="showEzMenuPanel">\n  <md-list>\n    <md-list-item>\n      <p>E-Z touch enabled</p>\n      <md-switch ng-model="$ctrl.formProperties.ezTouchEnabled"\n        ng-change="$ctrl.updateChangeDelta(\'ezTouchEnabled\', $ctrl.formProperties.ezTouchEnabled)"\n        aria-label="E-Z Touch enabled" ng-true-value=1 ng-false-value=0></md-switch>\n    </md-list-item>\n    <md-list-item>\n      <p>E-Z menu enabled</p>\n      <md-switch ng-model="$ctrl.formProperties.ezMenuEnabled"\n        ng-change="$ctrl.updateChangeDelta(\'ezMenuEnabled\', $ctrl.formProperties.ezMenuEnabled)"\n        aria-label="E-Z Menu enabled" ng-true-value=1 ng-false-value=0></md-switch>\n    </md-list-item>\n  </md-list>\n  <div layout="row">\n    <md-list flex style="border-right: 2px solid #FEC353;">\n      <md-subheader class="md-no-sticky">Zuant Lite E-Z menu items</md-subheader>\n      <md-list-item ng-repeat="item in $ctrl.availableEzMenuItems track by item.action"\n        ng-class="{\'selected\': item.inMenu}" ng-if="!item.isBoltOn" permission permission-only="item.permissions">\n        <md-icon md-font-icon="zmdi {{item.icon}}"></md-icon>\n        <p>{{item.name}}</p>\n        <md-button class="md-icon-button ez-menu-item" aria-label="add field" ng-click="$ctrl.toggleItem(item)"\n          ng-class="{\'ez-menu-item-selected\': item.inMenu}">\n          <ng-md-icon icon="{{item.inMenu ? \'remove\' : \'add\'}}" class="zuantTitaniumFill" size="24"></ng-md-icon>\n        </md-button>\n        <md-divider></md-divider>\n      </md-list-item>\n\n      <md-subheader class="md-no-sticky">BoltOn feature items</md-subheader>\n      <md-list-item ng-repeat="item in $ctrl.availableEzMenuItems track by item.action"\n        ng-class="{\'selected\': item.inMenu, \'isBoltOn\' : item.isBoltOn}" ng-if="item.isBoltOn" permission\n        permission-only="item.permissions">\n        <md-icon md-font-icon="zmdi {{item.icon}}"></md-icon>\n        <p>{{item.name}}</p>\n        <md-button class="md-icon-button ez-menu-item" aria-label="add field" ng-click="$ctrl.toggleItem(item)"\n          ng-class="{\'ez-menu-item-selected\': item.inMenu}">\n          <ng-md-icon icon="{{item.inMenu ? \'remove\' : \'add\'}}" class="zuantTitaniumFill" size="24"></ng-md-icon>\n        </md-button>\n        <md-divider></md-divider>\n      </md-list-item>\n\n    </md-list>\n    <md-list flex broken-ng-sortable="$ctrl.ezMenuSortableConfig">\n      <md-subheader class="md-no-sticky">Ordered list of E-Z menu items</md-subheader>\n      <div layout="row" layout-align="center center" ng-show="!$ctrl.ezMenuItems.length" flex layout-fill>\n        <img ng-src="{{\'/images/pngs/arrows/squiggle_arr_right.png\' | cdnAssets}}" id="rotate90" />\n        <p class="text-align-center">Click the plus icon to add an item</p>\n      </div>\n      <md-list-item ng-repeat="item in $ctrl.ezMenuItems track by item.action">\n        <md-icon md-font-icon="zmdi {{item.icon}}"></md-icon>\n        <p>{{item.name}}</p>\n        <md-divider></md-divider>\n      </md-list-item>\n    </md-list>\n  </div>\n</md-card-content>');
$templateCache.put('app/forms/settings-page/cards/email-settings.tmpl.html','<md-card-header>\n  <md-card-avatar style="position: relative;">\n    <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-mail-send"></md-icon>\n  </md-card-avatar>\n  <md-card-header-text>\n    <span class="md-title">Follow-up Email</span>\n    <span class="md-subhead">Manage thank you emails for this form and send emails in bulk</span>\n  </md-card-header-text>\n  <md-button class="md-icon-button" ng-click="showEmailSettingsPanel = !showEmailSettingsPanel">\n    <ng-md-icon icon="{{showEmailSettingsPanel ? \'expand_less\' : \'expand_more\'}}" style="fill: #949ca1;"></ng-md-icon>\n  </md-button>\n</md-card-header>\n\n<md-card-content ng-show="showEmailSettingsPanel">\n\n  <div ng-show="$ctrl.emailTemplateTitle !== \'No email template attached\' && $ctrl.emailTemplateTitle !== \'\'">\n    <h3 class="font-weight-400">\n      <md-icon md-font-icon="zmdi zmdi-check zuantAqua"></md-icon>\n      An email template is set\n    </h3>\n    <!-- <p class="md-body-1"><strong>{{$ctrl.emailTemplateTitle}}</strong> template is attached to this event.</p> -->\n    <md-input-container layout-fill class="margin-top-20">\n      <label>Email template</label>\n      <input type="text" ng-model="$ctrl.emailTemplateTitle" ng-disabled="true">\n    </md-input-container>\n  </div>\n\n  <div ng-show="$ctrl.isBeforeStartDate">\n    <h3 class="font-weight-400">The event hasn\'t started yet</h3>\n    <p>The show is set to begin {{$ctrl.daysTilStartDate}}.</p>\n    <p>Emails can either be sent to contacts as leads sync with the cloud, or you can opt to send them all at once\n      manually afterwards. Either attach a template so they can be sent live or leave blank to do post-show.</p>\n    <p>To change which email template gets used and when the emails are sent, click the button below.</p>\n  </div>\n\n  <div ng-show="$ctrl.isBetweenStartAndEndDate">\n    <h3 class="font-weight-400">The event is in progress</h3>\n    <p>It is scheduled to end {{$ctrl.daysTilEndDate}}.</p>\n  </div>\n\n  <div ng-show="$ctrl.isAfterEndDate">\n    <h3 class="font-weight-400">The event is over</h3>\n    <p>You can trigger emails to be sent out now as well as see which templates (if any) this event has used already by\n      clicking the\n      button below.</p>\n  </div>\n\n  <div ng-show="$ctrl.emailTemplateTitle == \'No email template attached\' || $ctrl.emailTemplateTitle == \'\'">\n    <h3 class="font-weight-400">\n      <md-icon md-font-icon="zmdi zmdi-close zuantSaffron"></md-icon>\n      No email template is set\n    </h3>\n    <p>Currently no template is attached to the event and so no emails will be sent as leads sync to the cloud.</p>\n    <p>You can make changes to this by clicking the button below.</p>\n  </div>\n\n  <div ng-show="$ctrl.postShowFactoryData.jobProcessing">\n    {{$ctrl.postShowFactoryData.loadingText}}\n  </div>\n  <div ng-show="$ctrl.postShowFactoryData.broadcast">\n    <h3 class="font-weight-400">Email batch send results</h3>\n    {{$ctrl.postShowFactoryData.broadcast.message}}\n  </div>\n\n  <div layout="row" layout-align="center center" flex="100">\n    <md-button ng-click="$ctrl.openPostShowEmailSendDialog($event)" class="md-raised" flex="33">\n      Make changes\n    </md-button>\n  </div>\n\n</md-card-content>');
$templateCache.put('app/forms/settings-page/cards/form-info-tab.tmpl.html','<md-card-header>\n  <md-card-avatar>\n    <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-calendar"></md-icon>\n  </md-card-avatar>\n  <md-card-header-text>\n    <span class="md-title">Form details</span>\n    <span class="md-subhead">Timezone, Dates, Form Status</span>\n  </md-card-header-text>\n</md-card-header>\n<md-card-content>\n\n  <form name="$ctrl.formSettingsForm">\n    <md-list ng-cloak style="margin-top: 20px;">\n      <md-list-item>\n        <md-input-container flex>\n          <label>Form Id</label>\n          <input ng-model="$ctrl.formProperties._id" disabled>\n        </md-input-container>\n      </md-list-item>\n      <md-list-item>\n        <md-input-container flex>\n          <label>Form name</label>\n          <input ng-model="$ctrl.formProperties.formname"\n            ng-change="$ctrl.updateChangeDelta(\'formname\', $ctrl.formProperties.formname)" required>\n        </md-input-container>\n      </md-list-item>\n      <md-list-item style="margin-top: 5px;">\n        <md-input-container flex>\n          <label>Startdate</label>\n          <md-datepicker flex ng-model="$ctrl.formProperties.startdate" md-placeholder="Start date"\n            md-open-on-focus="true" ng-change="$ctrl.updateChangeDelta(\'startdate\', $ctrl.formProperties.startdate)"\n            name="startdate" required>\n          </md-datepicker>\n          <div ng-messages="$ctrl.formSettingsForm.startdate.$error">\n            <div ng-message="valid">The entered value is not a date!</div>\n            <div ng-message="required">This date is required!</div>\n          </div>\n        </md-input-container>\n        <md-input-container flex>\n          <label>Enddate</label>\n          <md-datepicker flex ng-model="$ctrl.formProperties.enddate" md-placeholder="End date" md-open-on-focus="true"\n            ng-change="$ctrl.updateChangeDelta(\'enddate\', $ctrl.formProperties.enddate)"\n            md-min-date="$ctrl.formProperties.startdate" name="enddate" required>\n          </md-datepicker>\n          <div ng-messages="$ctrl.formSettingsForm.enddate.$error">\n            <div ng-message="mindate">Your end date has to be greater than or equal to your start date</div>\n            <div ng-message="valid">The entered value is not a date!</div>\n            <div ng-message="required">This date is required!</div>\n          </div>\n        </md-input-container>\n      </md-list-item>\n      <md-list-item>\n        <zp-select-control flex="100" model="$ctrl.formProperties.formTimezone"\n          on-change="$ctrl.updateSelectControl({formProp: \'formTimezone\', item: item})"\n          config="$ctrl.formTimezonesConfig" formname="$ctrl.formSettingsForm">\n        </zp-select-control>\n      </md-list-item>\n      <md-divider></md-divider>\n      </md-list-item>\n      <md-divider></md-divider>\n      <md-subheader class="md-no-sticky">Form Status</md-subheader>\n      <md-list-item>\n        <md-icon md-font-icon="zmdi zmdi-check" ng-class="{ \'zuantAqua\' : $ctrl.formProperties.published }"></md-icon>\n        <p>Published</p>\n        <md-switch ng-model="$ctrl.formProperties.published" aria-label="Form Published" ng-true-value=1\n          ng-false-value=0 ng-change="$ctrl.updateChangeDelta(\'published\', $ctrl.formProperties.published)"></md-switch>\n      </md-list-item>\n      <md-list-item permission permission-only="$ctrl.permissions.liteFeatures.forms.archive">\n        <md-icon md-font-icon="zmdi zmdi-close" ng-class="{ \'zuantSaffron\' : $ctrl.formProperties.archived }"></md-icon>\n        <p>Archived</p>\n        <md-switch ng-model="$ctrl.formProperties.archived" aria-label="Form Archived" ng-true-value=1 ng-false-value=0\n          ng-change="$ctrl.updateChangeDelta(\'archived\', $ctrl.formProperties.archived)"></md-switch>\n      </md-list-item>\n    </md-list>\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n  </form>\n</md-card-content>');
$templateCache.put('app/forms/settings-page/cards/integration-tab.tmpl.html','<md-card-header>\r\n  <md-card-avatar>\r\n    <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-share"></md-icon>\r\n  </md-card-avatar>\r\n  <md-card-header-text>\r\n    <span class="md-title">Integration settings</span>\r\n    <span class="md-subhead">For this form only</span>\r\n  </md-card-header-text>\r\n  <md-button class="md-icon-button" ng-click="showIntegrationPanel = !showIntegrationPanel">\r\n    <ng-md-icon icon="{{showIntegrationPanel ? \'expand_less\' : \'expand_more\'}}" style="fill: #949ca1;"></ng-md-icon>\r\n  </md-button>\r\n</md-card-header>\r\n<md-card-content ng-show="showIntegrationPanel">\r\n    <md-list>\r\n      <md-list-item style="margin: 25px 0px;" layout="column" layout-gt-xs="row">\r\n        <p>How would you like to release leads for this form?</p>\r\n        <md-button ng-class="{\'md-accent md-raised\' : $ctrl.formProperties.isLiveForIntegration == 1 }" ng-click="$ctrl.manuallyUpdateFormProp(\'isLiveForIntegration\', 1)">\r\n          In Real Time\r\n        </md-button>\r\n        <md-button ng-class="{\'md-accent md-raised\' : $ctrl.formProperties.isLiveForIntegration == 0 }" ng-click="$ctrl.manuallyUpdateFormProp(\'isLiveForIntegration\', 0)">\r\n          Manually\r\n        </md-button>\r\n      </md-list-item>\r\n      <md-divider></md-divider>\r\n      <md-list-item>\r\n        <h4><ng-pluralize count="$ctrl.machinesThatWillRunForThisForm.length"\r\n             when="{\'0\': \'No machines are configured to run for this form.\',\r\n                 \'1\': \'The below machine is set to run for this form\',\r\n                 \'other\': \'{{$ctrl.machinesThatWillRunForThisForm.length}} machines will run for this form, they are listed below.\'}">\r\n               </ng-pluralize>\r\n        </h4>\r\n      </md-list-item>\r\n      <md-list-item class="zebra-list" ng-repeat="machineName in $ctrl.machinesThatWillRunForThisForm">\r\n        <md-list-item-text>\r\n        {{machineName}}\r\n        </md-list-item-text>\r\n      </md-list-item>\r\n      <md-list-item flex="100">\r\n        <div layout="row" layout-align="end" flex="100">\r\n          <md-button zp-nav-click="/integration" class="md-accent">Integration Tools <md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon></md-button>\r\n        </div>        \r\n      </md-list-item>\r\n      <md-divider></md-divider>\r\n      <md-list-item>\r\n        <zp-user-select-chips \r\n          technical-contacts="$ctrl.formProperties.technicalContacts" \r\n          on-change="$ctrl.onTechnicalContactsChanged({items: items})"\r\n          flex="100">\r\n        </zp-user-select-chips>\r\n      </md-list-item>\r\n    </md-list>\r\n  </md-card-content>\r\n');
$templateCache.put('app/forms/settings-page/cards/scanner-tab.tmpl.html','<md-card-header>\n      <md-card-avatar>\n            <md-icon class="md-avatar-icon"\n              md-font-icon="zmdi zmdi-filter-center-focus"></md-icon>\n      </md-card-avatar>\n      <md-card-header-text>\n            <span class="md-title">Badge Scanning Configuration</span>\n            <span class="md-subhead">Field mappings, camera modes</span>\n      </md-card-header-text>\n      <md-button class="md-icon-button" ng-click="showScannerPanel = !showScannerPanel">\n        <ng-md-icon icon="{{showScannerPanel ? \'expand_less\' : \'expand_more\'}}" style="fill: #949ca1;"></ng-md-icon>\n      </md-button>\n</md-card-header>\n<md-card-content ng-show="showScannerPanel">\n      <md-input-container layout="row">\n            <input ng-model="$ctrl.formProperties.barcodeDelimiter"\n              ng-change="$ctrl.updateChangeDelta(\'barcodeDelimiter\', $ctrl.formProperties.barcodeDelimiter)"\n              placeholder="Barcode field delimeter character">\n      </md-input-container>\n      <md-list>\n            <md-list-item class="secondary-button-padding"\n              aria-label="camera modes">\n                  <p class="md-body-1"\n                    flex="60">Camera Modes</p>\n                  <p>\n                        <ng-pluralize class="md-caption"\n                          count="$ctrl.cameraSymbologiesCount"\n                          when="{\'0\': \'No camera modes selected\',\n                               \'1\': \'1 camera mode selected.\',\n                               \'other\': \'{} camera modes selected.\'}">\n                              <md-tooltip ng-show="$ctrl.cameraSymbologiesCount != 0" style="height:auto;">\n                                    <span ng-if="$ctrl.formProperties.allowCameraSymbology128">Code 128 <br></span>\n                                    <span ng-if="$ctrl.formProperties.allowCameraSymbology25">Code 25 <br></span>\n                                    <span ng-if="$ctrl.formProperties.allowCameraSymbology39">Code 39 <br></span>\n                                    <span ng-if="$ctrl.formProperties.allowCameraSymbologyAZTEC">Code AZTEC <br></span>\n                                    <span ng-if="$ctrl.formProperties.allowCameraSymbologyDM">Code DM <br></span>\n                                    <span ng-if="$ctrl.formProperties.allowCameraSymbologyPDF417">Code PDF 147 <br></span>\n                                    <span ng-if="$ctrl.formProperties.allowCameraSymbologyQRCODE">QR Code</span>\n                              </md-tooltip>\n                        </ng-pluralize>\n                  </p>\n                  <md-button class="md-icon-button"\n                    ng-click="$ctrl.openCameraModeDialog($event)"\n                    aria-label="Manage forms using this template">\n                        <md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon>\n                  </md-button>\n                  <!-- <md-button  class="md-primary" ng-click="$ctrl.openCameraModeDialog($event)">\n        Show Camera Modes\n      </md-button> -->\n            </md-list-item>\n            <md-list-item>\n                  <p>Scan Lookup Providers</p>\n                  <span flex\n                    layout\n                    layout-align="space-between">\n                        <span class="md-caption"\n                          ng-if="$ctrl.formProperties.experientOn">Experient on</span>\n                        <span class="md-caption"\n                          ng-if="$ctrl.formProperties.compusystemsOn">Compusystems on</span>\n                        <span class="md-caption"\n                          ng-if="$ctrl.formProperties.zuantWebLookupOn">Zuant on</span>\n                  </span>\n                  <md-button class="md-icon-button"\n                    ng-click="$ctrl.openScanLookupProvidersDialog($event)"\n                    aria-label="Configure scan lookup providers">\n                        <md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon>\n                  </md-button>\n                  <!-- <md-button class="md-primary" ng-click="$ctrl.openScanLookupProvidersDialog($event)">Configure</md-button> -->\n            </md-list-item>\n            <md-list-item>\n                  <p>Scanner auto-submit</p>\n                  <md-button class="md-icon-button"\n                    ng-click="$ctrl.openScannerAutoSubmitDialog($event)"\n                    aria-label="Auto submit">\n                        <md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon>\n                  </md-button>\n            </md-list-item>\n            <md-list-item>\n                  <p>Advanced</p>\n                  <md-button class="md-icon-button"\n                    ng-click="$ctrl.openAdvancedScannerSettingsDialog($event)"\n                    aria-label="Advanced settings">\n                        <md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon>\n                  </md-button>\n            </md-list-item>\n            <md-list-item>\n                  <p>Barcode fields</p>\n                  <span class="md-caption"\n                    ng-if="$ctrl.formProperties.barcodeMappings.length">{{$ctrl.countOfBarcodeFieldsMapped}} barcode fields mapped</span>\n                  <md-button class="md-icon-button"\n                    ng-click="$ctrl.openBarcodeFieldsDialog($event)"\n                    aria-label="Barcode field mappings">\n                        <md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon>\n                  </md-button>\n            </md-list-item>\n            <md-list-item>\n                  <p>URL encode/decode</p>\n                  <md-switch ng-model="$ctrl.formProperties.urlDecodeValues"\n                    ng-change="$ctrl.updateChangeDelta(\'urlDecodeValues\', $ctrl.formProperties.urlDecodeValues)"\n                    aria-label="encode decode"\n                    ng-true-value=1\n                    ng-false-value=0></md-switch>\n            </md-list-item>\n            <md-list-item>\n                  <p>Assume new lead</p>\n                  <md-switch ng-model="$ctrl.formProperties.assumeScanIsNewLead"\n                    ng-change="$ctrl.updateChangeDelta(\'assumeScanIsNewLead\', $ctrl.formProperties.assumeScanIsNewLead)"\n                    aria-label="Assume scan is new lead"\n                    ng-true-value=1\n                    ng-false-value=0>\n                  </md-switch>\n            </md-list-item>\n            <md-list-item>\n                  <p>Assume new contact</p>\n                  <md-switch ng-model="$ctrl.formProperties.assumeScanIsNewContact"\n                    ng-change="$ctrl.updateChangeDelta(\'assumeScanIsNewContact\', $ctrl.formProperties.assumeScanIsNewContact)"\n                    aria-label="Assume scan is new contact"\n                    ng-true-value=1\n                    ng-false-value=0>\n                  </md-switch>\n            </md-list-item>\n      </md-list>\n      <!-- <md-divider></md-divider>\n  --  API was here --\n  <md-subheader>Advanced</md-subheader>\n  <div layout-gt-xs="row" layout-padding>\n    <md-input-container flex="40">\n      <label>Start sequence</label>\n      <input ng-model="$ctrl.formProperties.barcodeStartSequence">\n    </md-input-container>\n    <md-input-container flex="40">\n      <label>Exclude chars</label>\n      <input ng-model="$ctrl.formProperties.barcodeExcludeChars">\n    </md-input-container>\n  </div>\n  <div layout-gt-xs="row" layout-padding>\n    <md-input-container flex="40">\n      <label>Decryption Key</label>\n      <input ng-model="$ctrl.formProperties.barcodeDecryptionKey">\n    </md-input-container>\n    <md-input-container flex="40">\n      <label>Decryption Vector</label>\n      <input ng-model="$ctrl.formProperties.barcodeDecryptionVector">\n    </md-input-container>\n  </div>\n  <md-divider></md-divider>\n  <md-subheader>NFC</md-subheader>\n  <div layout-gt-xs="row" layout-padding>\n    <md-input-container flex="40">\n      <label>Type Number</label>\n      <input ng-model="$ctrl.formProperties.NFCNDEFTypeNo">\n    </md-input-container>\n    <md-input-container flex="40">\n      <label>Type Name</label>\n      <input ng-model="$ctrl.formProperties.NFCNDEFTypeName">\n    </md-input-container>\n  </div>\n  <md-list>\n    <md-list-item>\n      <md-icon md-font-icon="zmdi zmdi-smartphone-info"></md-icon>\n      <p>Display devices when form loads?</p>\n      <md-switch ng-model="$ctrl.formProperties.NFCAutoDisplayPeripheralList" aria-label="" ng-true-value=1 ng-false-value=0></md-switch>\n    </md-list-item>\n  </md-list> -->\n</md-card-content>\n');
$templateCache.put('app/forms/settings-page/cards/showroom-tab.tmpl.html','<md-card-header>\n  <md-card-avatar>\n    <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-image-alt"></md-icon>\n  </md-card-avatar>\n  <md-card-header-text>\n    <span class="md-title">Showroom</span>\n    <span class="md-subhead">General settings, Showroom Plus</span>\n  </md-card-header-text>\n  <md-button class="md-icon-button" ng-click="$ctrl.toggleShowroomPanel()">\n    <ng-md-icon icon="{{$ctrl.showShowroomPanel ? \'expand_less\' : \'expand_more\'}}" style="fill: #949ca1;"></ng-md-icon>\n  </md-button>\n</md-card-header>\n\n<md-card-content ng-show="$ctrl.showShowroomPanel">\n\n  <md-subheader>General</md-subheader>\n  <form name="showroomForm" novalidate>\n    <md-list>\n\n      <md-list-item>\n        <p>Showroom is mandatory</p>\n        <md-switch ng-model="$ctrl.formProperties.requireLiterature"\n          ng-change="$ctrl.updateChangeDelta(\'requireLiterature\', $ctrl.formProperties.requireLiterature)"\n          aria-label="Require literature" ng-true-value="1" ng-false-value="0">\n        </md-switch>\n      </md-list-item>\n\n      <!-- Removed 05/12/2025 as per Charlottes request\n      <md-list-item>\n        <p>Display warning on exiting showroom</p>\n        <md-switch ng-model="$ctrl.formProperties.displayWarningOnExitingShowroom"\n          ng-change="$ctrl.updateChangeDelta(\'displayWarningOnExitingShowroom\', $ctrl.formProperties.displayWarningOnExitingShowroom)"\n          aria-label="Display warning on exiting showroom" ng-true-value="1" ng-false-value="0">\n        </md-switch>\n      </md-list-item>\n      --->\n\n      <md-list-item>\n        <p>Reset showroom for each new lead</p>\n        <md-switch ng-model="$ctrl.formProperties.clearShowroomForNewResponse"\n          ng-change="$ctrl.updateChangeDelta(\'clearShowroomForNewResponse\', $ctrl.formProperties.clearShowroomForNewResponse)"\n          aria-label="Clear showroom response for new response" ng-true-value="1" ng-false-value="0">\n        </md-switch>\n      </md-list-item>\n\n      <md-subheader>Sub Forms</md-subheader>\n      <md-list-item>\n        <div hide-xs flex="40" layout layout-align="start center">\n          <span class="md-body-1">Showroom form</span>\n        </div>\n        <zp-form-select-control flex="100" model="$ctrl.formProperties.showroomFormId"\n          on-change="$ctrl.updateSelectControl({formProp: \'showroomFormId\', item: item})"\n          config="$ctrl.showroomFormConfig" formname="$ctrl.formSettingsForm" aria-label="Showroom form id">\n        </zp-form-select-control>\n      </md-list-item>\n\n      <md-list-item>\n        <p>Showroom form is mandatory</p>\n        <md-switch ng-model="$ctrl.formProperties.showroomFormIsMendatory"\n          ng-change="$ctrl.updateChangeDelta(\'showroomFormIsMendatory\', $ctrl.formProperties.showroomFormIsMendatory)"\n          aria-label="Showroom form is mandatory" ng-true-value="1" ng-false-value="0">\n        </md-switch>\n      </md-list-item>\n\n      <div permission permission-only="\'SHOWROOM_BLOCKS\'">\n\n        <md-subheader>\n          Showroom Plus\n          <div layout="row">\n            <!-- <md-button ng-click="$ctrl.showTips = !$ctrl.showTips" class="md-icon-button">\n            <md-tooltip>View/hide tips</md-tooltip>\n            <md-icon md-font-icon="zmdi zmdi-help zuantTitanium4"></md-icon>\n          </md-button> -->\n            <!-- <md-button ng-click="$ctrl.showHelpDialog(\'blocks\')" class="md-icon-button">\n            <md-tooltip>Open help dialog for blocks</md-tooltip>\n            <md-icon md-font-icon="zmdi zmdi-help-outline zuantTitanium4"></md-icon>\n          </md-button> -->\n          </div>\n        </md-subheader>\n\n        <md-list-item>\n          <p>Use showroom plus menu system\n            <br>\n            <span class="md-caption zuantTitanium1"\n              ng-show="$ctrl.showTips">{{$ctrl.formPropertyHelpers.blocksMenu.useBlocksMenu}}</span>\n          </p>\n          <md-switch ng-model="$ctrl.formProperties.blocksMenu.useBlocksMenu"\n            ng-change="$ctrl.updateChangeDeltaNested(\'blocksMenu\', \'useBlocksMenu\', $ctrl.formProperties.blocksMenu.useBlocksMenu)"\n            aria-label="Use showroom plus menu" ng-true-value="\'1\'" ng-false-value="\'0\'">\n          </md-switch>\n        </md-list-item>\n\n        <div ng-show="$ctrl.formProperties.blocksMenu.useBlocksMenu == \'1\'">\n\n          <!-- Removed 05/12/2025 as per Charlottes request\n          <md-list-item>\n            <p>Showroom can be dismissed\n              <br>\n              <span class="md-caption zuantTitanium1"\n                ng-show="$ctrl.showTips">{{$ctrl.formPropertyHelpers.blocksMenu.showroomCanBeDismissed}}</span>\n            </p>\n            <md-switch ng-model="$ctrl.formProperties.blocksMenu.showroomCanBeDismissed"\n              ng-change="$ctrl.updateChangeDeltaNested(\'blocksMenu\', \'showroomCanBeDismissed\', $ctrl.formProperties.blocksMenu.showroomCanBeDismissed)"\n              aria-label="Showroom can be dismissed" ng-true-value="\'1\'" ng-false-value="\'0\'">\n            </md-switch>\n          </md-list-item>\n          -->\n\n          <!-- <md-list-item>\n          <p>Blocks can be dismissed</p>\n          <md-switch ng-model="$ctrl.formProperties.blocksMenu.blocksCanBeDismissed" ng-change="$ctrl.updateChangeDeltaNested(\'blocksMenu\', \'blocksCanBeDismissed\', $ctrl.formProperties.blocksMenu.blocksCanBeDismissed)" aria-label="Blocks can be dismissed" ng-true-value="\'1\'" ng-false-value="\'0\'">\n          </md-switch>\n        </md-list-item> -->\n\n          <md-list-item>\n            <p>Navigation back button available\n              <br>\n              <span class="md-caption zuantTitanium1"\n                ng-show="$ctrl.showTips">{{$ctrl.formPropertyHelpers.blocksMenu.navigationBackButtonAvailable}}</span>\n            </p>\n            <md-switch ng-model="$ctrl.formProperties.blocksMenu.navigationBackButtonAvailable"\n              ng-change="$ctrl.updateChangeDeltaNested(\'blocksMenu\', \'navigationBackButtonAvailable\', $ctrl.formProperties.blocksMenu.navigationBackButtonAvailable)"\n              aria-label="Navigation back button available" ng-true-value="\'1\'" ng-false-value="\'0\'">\n            </md-switch>\n          </md-list-item>\n\n          <md-list-item>\n            <p>Filters available\n              <br>\n              <span class="md-caption zuantTitanium1"\n                ng-show="$ctrl.showTips">{{$ctrl.formPropertyHelpers.blocksMenu.filtersAvailable}}</span>\n            </p>\n            <md-switch ng-model="$ctrl.formProperties.blocksMenu.filtersAvailable"\n              ng-change="$ctrl.updateChangeDeltaNested(\'blocksMenu\', \'filtersAvailable\', $ctrl.formProperties.blocksMenu.filtersAvailable)"\n              aria-label="Filters available" ng-true-value="\'1\'" ng-false-value="\'0\'">\n            </md-switch>\n          </md-list-item>\n\n          <md-list-item>\n\n            <zp-blocks-list flex="100" model="$ctrl.formProperties.blocksMenu.entryBlock"\n              on-change="$ctrl.updateChangeDeltaNested(property1, property2, newValue)" config="$ctrl.blocksListConfig"\n              formname="$ctrl.formSettingsForm" load-items="$ctrl.showShowroomPanel">\n            </zp-blocks-list>\n\n          </md-list-item>\n\n          <md-list-item style="margin: 25px 0px;" layout="column" layout-gt-xs="row">\n            <p>Background image content mode</p>\n            <md-button\n              ng-class="{\'md-accent md-raised\' : $ctrl.formProperties.blocksMenu.backgroundImageContentMode == \'scaleToFit\' }"\n              ng-click="$ctrl.updateChangeDeltaNested(\'blocksMenu\', \'backgroundImageContentMode\', \'scaleToFit\')">\n              Scale To Fit\n            </md-button>\n            <md-button\n              ng-class="{\'md-accent md-raised\' : $ctrl.formProperties.blocksMenu.backgroundImageContentMode == \'scaleAspectFit\' }"\n              ng-click="$ctrl.updateChangeDeltaNested(\'blocksMenu\', \'backgroundImageContentMode\', \'scaleAspectFit\')">\n              Scale Aspect Fit\n            </md-button>\n            <md-button\n              ng-class="{\'md-accent md-raised\' : $ctrl.formProperties.blocksMenu.backgroundImageContentMode == \'scaleAspectFill\' }"\n              ng-click="$ctrl.updateChangeDeltaNested(\'blocksMenu\', \'backgroundImageContentMode\', \'scaleAspectFill\')">\n              Scale Aspect Fill\n            </md-button>\n          </md-list-item>\n\n          <md-list-item>\n            <div ng-model="$ctrl.blocksMenuBackgroundColorAdjusted"\n              ng-change="$ctrl.updateChangeDelta(\'blocksMenuBackgroundColorAdjusted\', $ctrl.blocksMenuBackgroundColorAdjusted)"\n              md-color-picker label="Blocks background color" md-color-alpha-channel="true" md-color-sliders="false"\n              md-color-rgb="false" md-color-hsl="false" md-color-history="true" md-color-hex="false" flex></div>\n          </md-list-item>\n\n          <md-list-item>\n            <div ng-model="$ctrl.blocksMenuColorAdjusted"\n              ng-change="$ctrl.updateChangeDelta(\'blocksMenuColorAdjusted\', $ctrl.blocksMenuColorAdjusted)"\n              md-color-picker label="Blocks color" md-color-alpha-channel="false" md-color-sliders="false"\n              md-color-rgb="false" md-color-hsl="false" md-color-history="false" flex></div>\n          </md-list-item>\n\n          <md-list-item>\n            <div ng-model="$ctrl.blockTextColorAdjusted"\n              ng-change="$ctrl.updateChangeDelta(\'blockTextColorAdjusted\', $ctrl.blockTextColorAdjusted)"\n              md-color-picker label="Blocks text color" md-color-alpha-channel="false" md-color-sliders="false"\n              md-color-rgb="false" md-color-hsl="false" md-color-history="false" flex></div>\n          </md-list-item>\n\n          <md-list-item>\n            <div ng-model="$ctrl.blockCaptionColorAdjusted"\n              ng-change="$ctrl.updateChangeDelta(\'blockCaptionColorAdjusted\', $ctrl.blockCaptionColorAdjusted)"\n              md-color-picker label="Blocks caption color" md-color-alpha-channel="false" md-color-sliders="false"\n              md-color-rgb="false" md-color-hsl="false" md-color-history="false" flex></div>\n          </md-list-item>\n\n          <md-list-item ng-hide="shakeField">\n            <md-input-container class="md-block" flex>\n              <label>Capture lead text</label>\n              <input ng-model="$ctrl.formProperties.blocksMenu.captureLeadText"\n                ng-change="$ctrl.updateChangeDeltaNested(\'blocksMenu\', \'captureLeadText\', $ctrl.formProperties.blocksMenu.captureLeadText)"\n                placeholder="Button caption" type="text">\n            </md-input-container>\n          </md-list-item>\n          <md-list-item ng-class="{\'animated tada\': shakeField}" ng-show="shakeField">\n            <md-input-container class="md-block" flex>\n              <label>Capture lead text</label>\n              <input ng-model="$ctrl.formProperties.blocksMenu.captureLeadText"\n                ng-change="$ctrl.updateChangeDeltaNested(\'blocksMenu\', \'captureLeadText\', $ctrl.formProperties.blocksMenu.captureLeadText)"\n                placeholder="Button caption" type="text" ng-show="shakeField" focus-on-show>\n            </md-input-container>\n          </md-list-item>\n          <div layout-padding style="background: {{$ctrl.blocksMenuBackgroundColorAdjusted}};" layout="column"\n            layout-align="center center">\n            <p class="md-headline text-align-center margin-bottom-0"\n              style="color: {{$ctrl.blockCaptionColorAdjusted}};">Block caption sample text</p>\n            <div layout="row" layout-padding>\n              <div layout-padding layout-margin class="md-whiteframe-2dp"\n                style="background: {{$ctrl.blocksMenuColorAdjusted}}; color: {{$ctrl.blockTextColorAdjusted}};">\n                <p class="margin-botton-0 zp-cation md-caption">sample navigation block</p>\n              </div>\n              <div layout-padding layout-margin class="md-whiteframe-2dp"\n                style="background: {{$ctrl.blocksMenuColorAdjusted}}; color: {{$ctrl.blockTextColorAdjusted}};">\n                <p class="margin-botton-0 zp-cation md-caption">sample navigation block</p>\n              </div>\n            </div>\n            <md-button class="md-raised" ng-click="shakeField = true"\n              style="background: {{$ctrl.blocksMenuColorAdjusted}}; color: {{$ctrl.blockTextColorAdjusted}}; text-transform: none;">\n              {{ $ctrl.formProperties.blocksMenu.captureLeadText }}</md-button>\n          </div>\n        </div>\n      </div>\n    </md-list>\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n  </form>\n</md-card-content>');
$templateCache.put('app/forms/settings-page/cards/visibility-tab.tmpl.html','<md-card-header>\n  <md-card-avatar>\n    <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-accounts-list"></md-icon>\n  </md-card-avatar>\n  <md-card-header-text>\n    <span class="md-title">Visibility</span>\n    <span class="md-subhead">Form and Lead visibility settings for users</span>\n  </md-card-header-text>\n  <md-button class="md-icon-button" ng-click="showMenuPanel = !showMenuPanel">\n    <ng-md-icon icon="{{showMenuPanel ? \'expand_less\' : \'expand_more\'}}" style="fill: #949ca1;"></ng-md-icon>\n  </md-button>\n</md-card-header>\n<md-card-content ng-show="showMenuPanel">\n  <md-input-container style="width:calc(50% - 10px);margin-bottom:0">\n    <label style="margin-left: 5px">Filter</label>\n    <input type="text" ng-model="$ctrl.teamFilter" ng-keyup="$ctrl.filterTeams()" />\n  </md-input-container>\n  <div layout="row">\n    <form-settings-team-tree-element teams="$ctrl.treeStructuredTeams" select-team="$ctrl.toggleTeamItem(team, value, parent)" level="0"\n      toggle-chevron="$ctrl.toggleChevron(team, event)"></team-tree-element>\n  </div>\n</md-card-content>\n');
$templateCache.put('app/forms/settings-page/cards/warnings.tmpl.html','<md-card-header>\n  <md-card-avatar>\n    <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-alert-triangle"></md-icon>\n  </md-card-avatar>\n  <md-card-header-text>\n    <span class="md-title">Warnings</span>\n    <span class="md-subhead">Some things require your attention</span>\n  </md-card-header-text>\n</md-card-header>\n<md-card-content>\n\n<p>The following lists could not be found:</p>\n<ul>\n<li ng-repeat="warning in $ctrl.gridColumnWarnings">\n  {{warning}}\n</li>\n</ul>\n<p>Dependencies</p>\n<p>The following form widgets are dependent upon a list artefact</p>\n<ul>\n<li ng-repeat="d in $ctrl.formDependencies">\n  Colum id: {{d.column}}<br>\n  List id: {{d.listId}}\n</li>\n</ul>\n\n</md-card-content>\n');
$templateCache.put('app/forms/settings-page/fab/fab.tmpl.html','<zp-save-button\n  isfab="\'true\'"\n  label="\'save template fab\'"\n  isdirty="$ctrl.changeDelta.isDirty()"\n  ng-show="$ctrl.changeDelta.isDirty()"\n  save="$ctrl.onSave()"\n  disabled="$ctrl.singleFormFactory.saveBtnDisabled">\n</zp-save-button>\n');
$templateCache.put('app/integration/connections/zp-connection-status-widget/tmpl.html','<div layout="row" layout-gt-md="column">\n\n  <div ng-repeat="system in $ctrl.factoryData.configuredConnections" layout="row" layout-align="center center"\n    layout-align-gt-md="start center">\n\n    <div>\n\n      <ng-md-icon ng-class="{\'pulsate-aqua-fill\' : $ctrl.factoryData[system.value].testingConnection }"\n        icon="{{$ctrl.factoryData[system.value].testingConnection ? \'lens\' : $ctrl.factoryData[system.value].validConnection ? \'check_circle\' : \'report_problem\'}}"\n        size="18" style="fill: {{$ctrl.factoryData[system.value].validConnection ? \'#B8E986\' : \'#F99D33\'}}">\n      </ng-md-icon>\n\n      <md-tooltip md-direction="right">\n        {{ $ctrl.factoryData[system.value].msg }} : {{ $ctrl.factoryData[system.value].timestamp | date : \'short\' }}\n      </md-tooltip>\n\n    </div>\n\n    <div style="padding-left:15px;">\n\n      <div ng-if="system.svg" ng-include="system.svg" width="40px">\n      </div>\n\n      <img ng-if="system.img" ng-src="{{system.img}}" width="40px" />\n\n    </div>\n\n  </div>\n\n</div>\n\n<div layout="row" layout-align="start center">\n\n  <p class="zp-caption">\n    CONNECTION STATUS\n  </p>\n\n  <span flex></span>\n\n  <zp-context-menu menu-options="$ctrl.factoryData.menuOptions"\n    on-menu-click="$ctrl.onMenuClick({action:action, ev: ev})" permission permission-only="\'INTEGRATION_LOGINS_MANAGE\'">\n  </zp-context-menu>\n\n</div>');
$templateCache.put('app/integration/dialogs/manage-logins-dialog/tmpl.html','<md-dialog flex="80">\n\n  <md-toolbar aria-label="Manage client dialog toolbar">\n\n    <div layout="row" class="md-toolbar-tools">\n\n      <p class="md-subhead">{{$ctrl.toolbarTitle}}</p>\n      <span flex></span>\n\n      <md-button ng-click="$ctrl.deleteLogin($event)" aria-label="Delete Login" class="md-icon-button"\n        ng-disabled="$ctrl.disabledSaveBtn">\n\n        <md-tooltip>Delete connection</md-tooltip>\n\n        <md-icon md-font-icon="zmdi zmdi-delete"></md-icon>\n\n      </md-button>\n\n      <md-button ng-click="$ctrl.cancelDialog()">\n\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n\n      </md-button>\n\n    </div>\n\n  </md-toolbar>\n\n  <md-progress-linear ng-if="$ctrl.disabledSaveBtn" md-mode="indeterminate" class="md-accent">\n  </md-progress-linear>\n\n  <md-dialog-content layout-padding layout-sm="column" layout-gt-md="row" layout-align="center center">\n\n    <zp-sfdc-login-form flex="100" login-credentials="$ctrl.loginCredentials" ng-show="$ctrl.platform.value === \'SFDC\'"\n      error-message="$ctrl.errorMessage" connection-status-message="$ctrl.connectionStatusMessage"\n      connection-error-message="$ctrl.connectionErrorMessage" formname="SFDCForm">\n    </zp-sfdc-login-form>\n\n    <zp-eloqua-login-form flex="100" ng-show="$ctrl.platform.value === \'Eloqua\'"\n      login-credentials="$ctrl.loginCredentials" error-message="$ctrl.errorMessage"\n      connection-status-message="$ctrl.connectionStatusMessage" connection-error-message="$ctrl.connectionErrorMessage"\n      formname="EloquaForm">\n    </zp-eloqua-login-form>\n\n  </md-dialog-content>\n\n  <md-dialog-actions ng-cloak>\n\n    <md-button ng-click="$ctrl.saveAndTestConnection()" ng-if="EloquaForm.$valid || SFDCForm.$valid"\n      ng-hide="$ctrl.testConnectionSuccess" class="md-accent md-raised" ng-disabled="$ctrl.disabledSaveBtn">\n      {{$ctrl.saveBtnText}}\n    </md-button>\n\n    <md-button class="md-primary md-raised" ng-class="{\'animated slideInRight\' : $ctrl.testConnectionSuccess}"\n      ng-show="$ctrl.testConnectionSuccess" ng-click="$ctrl.cancelDialog()">\n      Close Dialog\n    </md-button>\n\n  </md-dialog-actions>\n</md-dialog>');
$templateCache.put('app/integration/dialogs/zp-add-machine-dialog/tmpl.html','<md-dialog flex="80">\n\n  <md-toolbar aria-label="Manage client dialog toolbar">\n\n    <div layout="row" class="md-toolbar-tools">\n\n      <p class="md-subhead">Create a new machine</p>\n      <span flex></span>\n\n      <md-button ng-click="$ctrl.cancelDialog()">\n\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n        \n      </md-button>\n\n    </div>\n\n  </md-toolbar>\n\n  <md-progress-linear ng-if="$ctrl.loading" md-mode="md-indeterminate" class="md-accent"></md-progress-linear>\n\n  <md-dialog-content layout="column" layout-padding>\n\n    <form name="$ctrl.newMachineForm" ng-submit="$ctrl.submitForm()" ng-hide="$ctrl.loading">\n\n      <md-input-container class="md-block">\n\n        <label>Machine name</label>\n\n        <input type="text" ng-model="$ctrl.newMachine.name" name="name" required md-autofocus />\n\n        <div ng-messages="$ctrl.newMachineForm.name.$error">\n\n          <div ng-message="required">\uD83E\uDD16 Please name me</div>\n\n        </div>\n\n      </md-input-container>\n\n      <md-list-item style="margin-top: 30px;">\n\n        <md-button class="md-primary zp-off-white-bg" ng-class="{\'md-raised md-primary\': $ctrl.seed == \'new\'}"\n          ng-click="$ctrl.seed = \'new\'" flex>New Machine</md-button>\n\n        <md-button class="md-primary zp-off-white-bg" ng-class="{\'md-raised md-primary\': $ctrl.seed == \'clone\'}"\n          ng-click="$ctrl.seed = \'clone\'" flex>Clone Machine</md-button>\n\n      </md-list-item>\n\n      <div ng-if="$ctrl.seed == \'new\'">\n\n        <p>Pick a Zuant form containing the fields you wish to map. (you can change this later if you wish)</p>\n\n        <zp-form-select-control model="$ctrl.newMachine.sourceZuantFormId"\n          on-change="$ctrl.setSourceZuantForm({item: item})" config="$ctrl.sourceZuantFormConfig">\n        </zp-form-select-control>\n\n        <p>Form filters</p>\n\n        <zp-form-filters-control raw-filters="$ctrl.newMachine.sensor.filters[0].formids">\n        </zp-form-filters-control>\n\n        <div layout="column" class="margin-top-10">\n\n          <p>Select which platform to connect to *</p>\n\n          <div layout="row" layout-align="center end">\n\n            <md-radio-group ng-model="$ctrl.newMachine.actuator.system" layout="row" layout-align="space-between center"\n              required>\n\n              <md-radio-button ng-repeat="platform in $ctrl.integrationPlatforms" ng-value="platform.value"\n                aria-label="{{platform.name}}">\n                <img ng-src="{{platform.img}}" style="width: 100px" />\n              </md-radio-button>\n\n            </md-radio-group>\n\n          </div>\n\n        </div>\n\n        <div ng-if="$ctrl.newMachine.actuator.system === \'SFDC\'">\n\n          This machine will map to the Lead object in Salesforce\n\n        </div>\n\n        <div ng-if="$ctrl.newMachine.actuator.system === \'Eloqua\'">\n\n          <zp-eloqua-form-select flex="40" model="$ctrl.newMachine.actuator.typeid"\n            on-change="$ctrl.eloquaFormSelectChange(item)" config="$ctrl.eloquaFormsConfig">\n          </zp-eloqua-form-select>\n\n        </div>\n\n        <div ng-if="$ctrl.newMachine.actuator.system === \'HttpPost\'" layout="column" flex>\n\n          Enter the url to post leads to\n\n          <md-input-container class="md-block">\n\n            <label>URL</label>\n\n            <input ng-model="$ctrl.newMachine.actuator.uri" type="text" name="uri"\n              required="{{$ctrl.newMachine.actuator.system === \'HttpPost\'}}" />\n\n            <div ng-messages="newMachineForm.uri.$error">\n              <div ng-message="required">Where should the leads be sent?</div>\n            </div>\n\n          </md-input-container>\n\n          <p>\n            When the wildcard mapping switch is on all lead data will be included in the http post, therefore machine\n            mappings aren\'t necessary.\n          </p>\n\n          <md-switch ng-model="$ctrl.newMachine.useWildcardMapping">\n            Use wildcard mapping\n          </md-switch>\n\n        </div>\n\n        <div style="height:20px;"></div>\n\n        <md-input-container class="md-block">\n\n          <label>Notes</label>\n\n          <textarea rows="3" ng-model="$ctrl.newMachine.machineInfo.notes"></textarea>\n\n        </md-input-container>\n\n        <div>\n\n          <md-input-container class="md-block" flex-gt-xs>\n\n            <label>Last edited by</label>\n\n            <input ng-model="$ctrl.newMachine.machineInfo.lastEditedBy" disabled>\n\n          </md-input-container>\n\n        </div>\n\n        <div>\n          <md-input-container class="md-block" flex-gt-xs>\n\n            <label>Last edited at</label>\n\n            <input ng-model="$ctrl.newMachine.machineInfo.lastEditedTimeStamp" disabled>\n\n          </md-input-container>\n\n        </div>\n\n      </div>\n\n      <div ng-if="$ctrl.seed == \'clone\'">\n\n        <md-input-container class="md-block" flex-gt-xs>\n\n          <label>Machine to Clone</label>\n\n          <md-select ng-model="$ctrl.machineToClone" required>\n\n            <md-option ng-repeat="m in $ctrl.availableMachines" ng-value="m._machineid">\n              {{m.name}}\n            </md-option>\n            \n          </md-select>\n\n        </md-input-container>\n\n      </div>\n\n      <input type="hidden" name="CSRFToken" value="1231234567890" />\n\n    </form>\n\n  </md-dialog-content>\n\n  <md-dialog-actions>\n\n    <!-- <md-button ng-click="$ctrl.cancelDialog()">Cancel</md-button> -->\n\n    <md-button type="submit" ng-if="$ctrl.seed == \'new\'" ng-class="{\'md-raised md-accent\': $ctrl.newMachineForm.$valid}"\n      ng-click="$ctrl.submitForm()" ng-disabled="$ctrl.newMachineForm.$invalid">Add Machine \uD83E\uDD16</md-button>\n\n    <md-button type="submit" ng-if="$ctrl.seed == \'clone\'"\n      ng-class="{\'md-raised md-accent\': $ctrl.newMachineForm.$valid}" ng-click="$ctrl.cloneMachine()"\n      ng-disabled="$ctrl.newMachineForm.$invalid">Clone Machine \uD83E\uDD16</md-button>\n\n  </md-dialog-actions>\n</md-dialog>');
$templateCache.put('app/integration/dialogs/zp-machine-form-filters-dialog/tmpl.html','<md-dialog flex="80">\n  <md-toolbar aria-label="Manage client dialog toolbar">\n    <div layout="row"\n      class="md-toolbar-tools">\n      <p class="md-subhead">Manage form filters for {{$ctrl.selectedMachine.name}}</p>\n      <span flex></span>\n      <md-button ng-click="$ctrl.closeDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content\n    layout="column"\n    layout-padding\n    flex>\n    <md-card-content>\n      <div\n        layout="column"\n        flex>\n\n        <zp-form-filters-control\n          raw-filters="$ctrl.selectedMachine.sensor.filters[0].formids"\n          on-change="$ctrl.onFilterChange({filters: filters})"\n          on-clear-filters="$ctrl.onClearFilters()">\n        </zp-form-filters-control>\n\n        <div\n          layout-padding\n          ng-show="$ctrl.viewModel.errorMessage">\n          <md-icon md-font-icon="zmdi zmdi-alert-triangle zuantPollen"></md-icon>{{$ctrl.viewModel.errorMessage}}\n        </div>\n      </div>\n    </md-card-content>\n  </md-dialog-content>\n\n  </md-dialog>\n');
$templateCache.put('app/integration/dialogs/zp-machine-info-dialog/tmpl.html','<md-dialog flex="80">\n\n  <md-toolbar aria-label="Machine info dialog">\n\n    <div layout="row" class="md-toolbar-tools">\n\n      <p class="md-subhead">Machine info</p>\n\n      <span flex></span>\n\n      <md-button ng-click="$ctrl.cancelDialog()">\n\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n\n      </md-button>\n\n    </div>\n\n  </md-toolbar>\n\n  <md-dialog-content layout="column" layout-padding flex>\n\n    <md-card-content>\n\n      <div layout="column" flex>\n\n        <form name="machineInfo" layout-padding>\n\n          <div layout="column" flex>\n\n            <md-input-container>\n\n              <label>Machine name</label>\n\n              <input ng-model="$ctrl.currentMachine.name" />\n\n            </md-input-container>\n\n            <md-input-container ng-if="$ctrl.currentMachine.actuator.system == \'HttpPost\'">\n\n              <label>URI</label>\n\n              <input ng-model="$ctrl.currentMachine.actuator.uri" />\n\n            </md-input-container>\n\n            <div ng-if="$ctrl.currentMachine.actuator.system == \'HttpPost\'">\n\n              <p>\n                When the wildcard mapping switch is on all lead data will be included in the http post.\n              </p>\n\n              <md-switch ng-model="$ctrl.currentMachine.useWildcardMapping">\n                Use wildcard mapping\n              </md-switch>\n\n            </div>\n\n            <zp-form-select-control flex="100" config="$ctrl.sourceFormConfig"\n              model="$ctrl.currentMachine.sourceZuantFormId" on-change="$ctrl.grabSourceForm({item: item})"\n              aria-label="$ctrl.cloneFormConfig.label">\n            </zp-form-select-control>\n\n            <div ng-if="$ctrl.currentMachine.actuator.system == \'Eloqua\'">\n\n              <md-input-container class="md-block">\n\n                <label>Destination Eloqua form</label>\n\n                <input ng-model="$ctrl.currentMachine.actuator.typename" disabled />\n\n              </md-input-container>\n\n            </div>\n\n            <div ng-if="$ctrl.currentMachine.actuator.system == \'SFDC\'">\n\n              <p>This machine targets the Lead object in SFDC</p>\n\n            </div>\n\n            <p>Forms filter</p>\n\n            <zp-form-filters-control raw-filters="$ctrl.currentMachine.sensor.filters[0].formids"\n              on-change="$ctrl.onFilterChange({filters: filters})" on-clear-filters="$ctrl.onClearFilters()">\n            </zp-form-filters-control>\n\n            <div style="height:20px;"></div>\n\n            <md-input-container>\n\n              <label>Notes</label>\n\n              <textarea rows="5" ng-model="$ctrl.currentMachine.machineInfo.notes"\n                ng-change="$ctrl.updateChangeDelta($ctrl.currentMachine.machineInfo.notes, \'machineInfo.notes\')">\n              </textarea>\n\n            </md-input-container>\n\n            <div layout="row">\n\n              <md-input-container flex="50">\n\n                <label>Last edited by</label>\n\n                <input ng-value="$ctrl.currentMachine.machineInfo.lastEditedBy" disabled />\n\n              </md-input-container>\n\n              <md-input-container flex="50">\n\n                <label>Last edited timestamp</label>\n                <input ng-value="$ctrl.currentMachine.machineInfo.lastEditedTimeStamp | date: \'short\'" disabled />\n\n              </md-input-container>\n\n            </div>\n\n            <div layout="row" ng-if="$ctrl.currentMachine.machineInfo.setFieldReferencesRun" permission\n              permission-only="\'TRUMP\'">\n\n              <span>\n                Migrated to rest: {{ $ctrl.currentMachine.machineInfo.setFieldReferencesRun | zpMomentFromNow }}\n              </span>\n            </div>\n\n          </div>\n\n          <input type="hidden" name="CSRFToken" value="1231234567890" />\n\n        </form>\n\n        <div layout-padding ng-show="$ctrl.viewModel.errorMessage">\n\n          <md-icon md-font-icon="zmdi zmdi-alert-triangle zuantPollen"></md-icon>{{$ctrl.viewModel.errorMessage}}\n\n        </div>\n\n      </div>\n\n    </md-card-content>\n\n  </md-dialog-content>\n\n  <md-dialog-actions>\n\n    <md-button ng-click="$ctrl.closeDialog()">Done</md-button>\n\n  </md-dialog-actions>\n\n</md-dialog>');
$templateCache.put('app/integration/dialogs/zp-machine-json-dialog/tmpl.html','<md-dialog flex="80">\n\n  <md-toolbar aria-label="Manage client dialog toolbar">\n\n    <div layout="row" class="md-toolbar-tools">\n\n      <p class="md-subhead">Machine JSON</p>\n      <span flex></span>\n\n      <md-button ng-click="$ctrl.cancelDialog()">\n\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n\n      </md-button>\n    </div>\n\n  </md-toolbar>\n\n  <md-dialog-content layout="column" layout-padding flex>\n\n    <md-card-content>\n\n      <code>\n        <pre>{{ $ctrl.currentMachine | json }}</pre>\n      </code>\n\n    </md-card-content>\n\n  </md-dialog-content>\n\n  <md-dialog-actions>\n\n    <md-button ng-click="$ctrl.closeDialog()">Done</md-button>\n\n  </md-dialog-actions>\n\n</md-dialog>');
$templateCache.put('app/integration/dialogs/zp-manage-field-mapping-dialog/tmpl.html','<md-dialog flex="80">\n\n  <md-toolbar aria-label="Manage client dialog toolbar">\n\n    <div layout="row" class="md-toolbar-tools">\n\n      <p class="md-subhead">\n\n        Answer transformations for the {{$ctrl.mapping.hps.element}} field\n\n      </p>\n\n      <span flex></span>\n\n      <zp-toggle-json-button show-json="showJson"></zp-toggle-json-button>\n\n      <md-button ng-click="$ctrl.cancelDialog()">\n\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n\n      </md-button>\n\n    </div>\n\n  </md-toolbar>\n\n  <md-progress-linear md-mode="determinate" value="{{$ctrl.determinateValue}}"></md-progress-linear>\n\n  <md-dialog-content layout="column" layout-padding flex="80" flex-offset="10">\n\n    <md-content ng-show="!showJson">\n\n      <md-input-container class="md-block">\n\n        <label>Answer delimiter</label>\n\n        <md-select ng-model="$ctrl.mapping.transform.delimiter" placeholder="You can set the answer delimiter here">\n\n          <md-option ng-value="">\n            None set\n          </md-option>\n\n          <md-option ng-repeat="delimiter in $ctrl.answerDelimiters" ng-value="delimiter.value">\n            {{ delimiter.label }}\n          </md-option>\n\n        </md-select>\n\n      </md-input-container>\n\n      <p>Choose a transformation type</p>\n\n      <div layout="row" layout-align="center end" flex>\n\n        <md-radio-group ng-model="$ctrl.mapping.transform.special" layout layout-align="space-between center">\n\n          <md-radio-button ng-value="\'transformValues\'">\n\n            <p>\n              Transform answer values\n            </p>\n\n            <p>\n              The most commmon transform type, useful for replacing known answers before posting to external systems.\n              i.e. change an email address to a user ID.\n            </p>\n          </md-radio-button>\n\n          <md-radio-button ng-value="\'questioncaption\'">\n\n            <p>\n              Send question caption\n            </p>\n\n            <p>The question caption will be sent instead of the answer. This is helpful if the receiving form is an\n              empty shell as you can post both questions and answers to the external system.</p>\n          </md-radio-button>\n        </md-radio-group>\n      </div>\n\n      <div ng-show="$ctrl.mapping.transform.special === \'transformValues\'" flex>\n\n        <div layout="row" layout-align="center" ng-if="$ctrl.showInputControls">\n\n          <md-button class="md-accent" ng-class="{\'md-raised\' : $ctrl.oldValInput == \'freeForm\'}"\n            ng-click="$ctrl.freeFormClicked()">\n            Free form\n          </md-button>\n\n          <md-button class="md-accent" ng-class="{\'md-raised\' : $ctrl.oldValInput == \'answerList\'}"\n            ng-click="$ctrl.answerListClicked()">\n            Answer List\n          </md-button>\n\n        </div>\n\n        <div layout="column" flex>\n\n          <form ng-submit="$ctrl.addNewTransform()" name="transformForm" flex layout="row">\n\n            <zp-form-widget-select-control ng-show="$ctrl.oldValInput === \'answerList\'" flex="40" model=""\n              on-change="$ctrl.answerChange(item)" config="$ctrl.answerListConfig" selected-item="$ctrl.selectedItem">\n            </zp-form-widget-select-control>\n\n            <md-input-container flex="40" ng-show="$ctrl.oldValInput == \'freeForm\'">\n\n              <label>Old value</label>\n\n              <input type="text" ng-model="$ctrl.newTransform.old" name="oldValue"\n                required="$ctrl.oldValInput == \'freeForm\'" md-autofocus id="focusMe" />\n\n              <div ng-messages="transformForm.oldValue.$error">\n\n                <div ng-message="required">\n                  This is required.\n                </div>\n\n              </div>\n\n            </md-input-container>\n\n            <div flex="5"></div>\n\n            <md-input-container flex="40">\n\n              <label>New value</label>\n\n              <input type="text" ng-model="$ctrl.newTransform.new" name="newValue" />\n\n              <div ng-messages="transformForm.newValue.$error">\n\n                <div ng-message="required">\n                  This is required.\n                </div>\n\n              </div>\n\n            </md-input-container>\n\n            <md-button class="md-primary md-icon-button md-raised" type="submit">\n\n              <md-icon md-font-icon="zmdi zmdi-plus"></md-icon>\n\n              <md-tooltip>Add transform</md-tooltip>\n\n            </md-button>\n\n            <input type="hidden" name="CSRFToken" value="1231234567890" />\n\n          </form>\n\n          <div layout="row" flex ng-repeat="transform in $ctrl.mapping.transform.valuetranslations">\n\n            <md-input-container flex="40">\n\n              <label>Old value</label>\n\n              <input type="text" ng-model="transform.old" />\n\n            </md-input-container>\n\n            <div flex="5"></div>\n\n            <md-input-container flex="40">\n\n              <label>New value</label>\n\n              <input type="text" ng-model="transform.new" />\n\n            </md-input-container>\n\n            <md-button class="md-icon-button" ng-click="$ctrl.deleteTransform($index)">\n\n              <md-icon>remove</md-icon>\n\n              <md-tooltip>Remove transform</md-tooltip>\n\n            </md-button>\n\n          </div>\n\n        </div>\n\n      </div>\n\n    </md-content>\n\n    <md-content ng-show="showJson" flex>\n\n      Mapping JSON\n      <pre>\n          {{ $ctrl.mapping | json }}\n      </pre>\n\n    </md-content>\n\n  </md-dialog-content>\n\n  <md-dialog-actions>\n\n    <md-button ng-click="$ctrl.closeDialog()">\n      Close\n    </md-button>\n\n  </md-dialog-actions>\n\n</md-dialog>');
$templateCache.put('app/integration/dialogs/zp-wildcard-mapping-dialog/tmpl.html','<md-dialog flex="80">\n\n  <md-toolbar aria-label="Manage client dialog toolbar">\n\n    <div layout="row" class="md-toolbar-tools">\n\n      <p class="md-subhead">\n        Machine settings\n      </p>\n\n      <span flex></span>\n\n      <md-button ng-click="$ctrl.cancelDialog()">\n\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n\n      </md-button>\n\n    </div>\n\n  </md-toolbar>\n\n  <md-dialog-content layout="column" layout-padding flex>\n\n    <md-card-content>\n\n      <div layout="column" flex>\n\n        <form name="machineInfo" layout-padding>\n\n          <div layout="column" flex>\n\n            <md-input-container>\n\n              <label>Machine name</label>\n\n              <input ng-model="$ctrl.currentMachine.name" ng-change="$ctrl.updateChangeDelta(\'name\')" />\n\n            </md-input-container>\n\n            <md-input-container ng-if="$ctrl.currentMachine.actuator.system == \'HttpPost\'">\n\n              <label>URI</label>\n              <input ng-model="$ctrl.currentMachine.actuator.uri"\n                ng-change="$ctrl.updateChangeDelta(\'actuator\', \'uri\')" />\n\n            </md-input-container>\n\n            <div ng-if="$ctrl.currentMachine.actuator.system == \'HttpPost\'">\n\n              <p>When the wildcard mapping switch is on all lead data will be included in the http post.</p>\n\n              <md-switch ng-model="$ctrl.currentMachine.useWildcardMapping"\n                ng-change="$ctrl.updateChangeDelta(\'useWildcardMapping\')">\n                Use wildcard mapping\n              </md-switch>\n\n            </div>\n\n            <div style="height:20px;"></div>\n\n            <md-input-container>\n\n              <label>Notes</label>\n\n              <textarea rows="3" ng-model="$ctrl.currentMachine.machineInfo.notes"\n                ng-change="$ctrl.updateChangeDelta(\'machineInfo\', \'notes\')">\n              </textarea>\n\n            </md-input-container>\n\n            <div layout="row">\n\n              <md-input-container flex="50">\n\n                <label>Last edited by</label>\n\n                <input ng-value="$ctrl.currentMachine.machineInfo.lastEditedBy" disabled />\n\n              </md-input-container>\n\n              <md-input-container flex="50">\n\n                <label>Last edited timestamp</label>\n\n                <input ng-value="$ctrl.currentMachine.machineInfo.lastEditedTimeStamp | date: \'short\'" disabled />\n\n              </md-input-container>\n\n            </div>\n\n          </div>\n\n          <input type="hidden" name="CSRFToken" value="1231234567890" />\n        </form>\n\n      </div>\n\n      <div ng-show="$ctrl.error">\n        {{ $ctrl.error | json }}\n      </div>\n\n    </md-card-content>\n\n  </md-dialog-content>\n\n  <md-dialog-actions>\n\n    <md-button ng-click="$ctrl.saveAndCloseDialog()" class="md-raised md-accent" ng-show="$ctrl.changeDelta.isDirty()">\n      Save & Close\n    </md-button>\n\n  </md-dialog-actions>\n\n</md-dialog>');
$templateCache.put('app/integration/fabs/add-machine/tmpl.html','<zp-helper-arrow permission permission-only="$ctrl.permissions.boltOns.integration.machines.edit"\n    help-message="2. Build integration machines" show-condition="!$ctrl.machines.items.length">\n</zp-helper-arrow>\n\n<zp-fab-add pulse-class-check="!$ctrl.machines.items.length" dialog-config="$ctrl.metadata.fabDialogConfig" permission\n    permission-only="\'INTEGRATION_MACHINES_EDIT\'">\n</zp-fab-add>');
$templateCache.put('app/integration/fabs/save-machine/tmpl.html','<zp-save-button isfab="\'true\'" label="\'save machine fab\'" isdirty="$ctrl.changeDelta.isDirty()"\n  ng-show="$ctrl.changeDelta.isDirty()" save="$ctrl.onSave()">\n</zp-save-button>');
$templateCache.put('app/integration/home-page/zp-eloqua-form-select/tmpl.html','<p ng-if="$ctrl.loading" layout="column">\n  <span flex layout="row" layout-align="end end">\n    <i>Fetching forms from Eloqua...</i>\n  </span>\n  <span></span>\n  <md-progress-linear md-mode="md-indeterminate" class="md-accent"></md-progress-linear>\n</p>\n<p ng-if="$ctrl.errorMessage">\n  <span flex layout="row" layout-align="end end">\n    <i>{{$ctrl.errorMessage}}</i>\n  </span>\n  <span></span>\n</p>\n\n<md-autocomplete\n  ng-show="!$ctrl.loading"\n  md-selected-item="$ctrl.selectedItem"\n  md-search-text="$ctrl.searchText"\n  md-selected-item-change="$ctrl.onChange({ item: item })"\n  md-items="item in $ctrl.querySearch($ctrl.searchText)"\n  md-item-text="item.name"\n  md-min-length="0"\n  placeholder="{{$ctrl.config.placeholder}}"\n  aria-label="Select control"\n  md-floating-label="{{$ctrl.config.floatingLabel}}"\n  md-menu-class="autocomplete-custom-template"\n  ng-required="{{$ctrl.config.required}}"\n  md-input-name="{{$ctrl.config.name}}"\n  md-require-match\n  md-clear-button="true">\n  <md-item-template>\n     <span md-highlight-text="searchText"\n      md-highlight-flags="^i">\n      {{item.id}} : {{item.name}}\n    </span>\n </md-item-template>\n  <md-not-found>\n    No items matching "{{$ctrl.searchText}}" were found.\n  </md-not-found>\n  <div class="errors" ng-messages="$ctrl.formname[$ctrl.config.title].$error">\n    <div ng-message="required">Required</div>\n  </div>\n</md-autocomplete>\n');
$templateCache.put('app/integration/home-page/zp-machine-list-item/tmpl.html','<md-card flex>\n  <md-card-header style="padding-bottom: 0px;">\n    <!-- <div layout="row" layout-align="space-around" flex> -->\n      <md-card-avatar>\n        <img class="md-user-avatar" ng-src="{{$ctrl.imgSrc}}" />\n      </md-card-avatar>\n      <md-card-header-text style="max-height: none !important">\n        <span class="md-title">Name: {{$ctrl.machine.name}}</span>\n        <span class="md-subhead" ng-if="$ctrl.machine.actuator.system === \'Eloqua\'">Eloqua form: {{$ctrl.machine.actuator.typeid}} {{$ctrl.machine.actuator.typename}}</span>\n        <span class="md-subhead" ng-if="$ctrl.machine.actuator.system === \'HttpPost\'">Post uri: {{$ctrl.machine.actuator.uri}}</span>\n        <span class="md-subhead" ng-if="$ctrl.machine.useWildcardMapping">*wildcard mapping</span>\n        <span class="md-subhead" ng-if="$ctrl.machine.actuator.system === \'SFDC\'">Mapped to Lead object</span>\n        <span class="md-subhead" ng-if="!$ctrl.machine.useWildcardMapping">Zuant form: {{$ctrl.machine.sourceZuantFormname}}</span>\n        <span class="md-subhead" >Last edited: {{$ctrl.machine.machineInfo.lastEditedTimeStamp | zpMomentFromNow}}</span>\n        <span class="md-subhead" ng-if="$ctrl.machine.machineInfo.setFieldReferencesRun" permission permission-only="\'TRUMP\'">Migrated to rest: {{$ctrl.machine.machineInfo.setFieldReferencesRun | zpMomentFromNow}}</span>\n      </md-card-header-text>\n      <!-- <div layout="row" layout-align="space-between" flex>\n        <div flex>\n          <div layout-align="center center" layout="column" layout-fill>\n              <md-progress-circular ng-if="$ctrl.widgetData.loading" class="md-accent" md-mode="indeterminate"></md-progress-circular>\n              <md-icon md-font-icon="zmdi zmdi-cloud-done" style="fill: #949ca1; font-size: 30px;"></md-icon>\n            <p class="md-display-1 zp-caption margin-bottom-0 margin-top-10" countupto="21" decimals="0" duration="1.8"></p>\n            <p class="md-caption zp-caption margin-bottom-0 margin-top-0">released</p>\n          </div>\n        </div>\n        <div flex>\n          <div layout-align="center center" layout="column" layout-fill>\n              <md-progress-circular ng-if="$ctrl.widgetData.loading" class="md-accent" md-mode="indeterminate"></md-progress-circular>\n              <md-icon md-font-icon="zmdi zmdi-alert-triangle" style="fill: #949ca1; font-size: 30px;"></md-icon>\n            <p class="md-display-1 zp-caption margin-bottom-0 margin-top-10" countupto="21" decimals="0" duration="1.8"></p>\n            <p class="md-caption zp-caption margin-bottom-0 margin-top-0">errors</p>\n          </div>\n        </div>\n      </div>\n    </div> -->\n  </md-card-header>\n  <md-card-actions layout="row" layout-align="end center">  \n\n    <md-menu ng-if="$ctrl.machine.actuator.system === \'Eloqua\'">\n     <md-button aria-label="Open action type menu" class="md-icon-button md-accent" ng-click="$ctrl.openMenu($mdOpenMenu, $event)" permission permission-only="\'TRUMP\'">\n       <md-icon md-menu-origin md-font-icon="zmdi zmdi-share"></md-icon>\n     </md-button>\n     <md-menu-content width="4">\n       <md-menu-item>\n         <md-button ng-click="$ctrl.setAction($event, \'rest\')" ng-class="{\'md-primary\' : $ctrl.machine.actuator.action === \'replicateViaREST\'}">\n           \uD83D\uDCA4 <span>{{$ctrl.machine.actuator.action === \'replicateViaREST\' ? \'using REST\' : \'switch to REST\'}}</span>\n         </md-button>\n       </md-menu-item>\n       <md-menu-item>\n         <md-button ng-click="$ctrl.setAction($event, \'soap\')" ng-class="{\'md-primary\' : $ctrl.machine.actuator.action === \'replicate\'}">\n           \uD83E\uDDFC <span>{{$ctrl.machine.actuator.action === \'replicate\' ? \'using SOAP\' : \'switch to SOAP\'}}</span>\n         </md-button>\n       </md-menu-item>\n     </md-menu-content>\n   </md-menu>\n\n    <md-button\n      class="md-accent"\n      aria-label="toggle"\n      ng-click="$ctrl.manageMachineFormFilters($event)">\n      <md-icon md-font-icon="zmdi zmdi-filter-list"></md-icon>\n      <span ng-if="$ctrl.machine.sensor.filters[0].formids.length">{{$ctrl.machine.sensor.filters[0].formids.length}} Filters</span>\n      <span ng-if="!$ctrl.machine.sensor.filters[0].formids.length">Manage filters</span>\n    </md-button>\n\n    <md-button class="md-accent"\n      ng-if="!$ctrl.machine.useWildcardMapping"\n      ng-class="{\'md-raised\' : !$ctrl.machine.mappings.length && !$ctrl.machine.useWildcardMapping}"\n      ng-click="$ctrl.manageMappings()"\n      ng-disabled="$ctrl.machine.locked">\n      <span ng-if="$ctrl.machine.mappings.length">{{$ctrl.machine.mappings.length}} Field Mappings</span>\n      <span ng-if="!$ctrl.machine.mappings.length && !$ctrl.machine.useWildcardMapping">Map fields</span>\n      <md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon>\n    </md-button>\n\n    <md-button class="md-accent"\n      ng-if="$ctrl.machine.useWildcardMapping"\n      ng-click="$ctrl.manageMachineSettings()">\n      <md-icon md-font-icon="zmdi zmdi-settings"></md-icon>\n      <span>settings</span>\n    </md-button>\n  </md-card-actions>\n</md-card>\n');
$templateCache.put('app/integration/home-page/zp-machine-list-page-side-shell/tmpl.html','<div layout="row" layout-lg="column">\n  <!-- <zp-no-data ng-show="!$ctrl.machines.items.length" header="Integration not setup yet" subhead="Standing by." svgpath="assets/svgs/rocket_lagoon_002.svg" svgid="submitted_leads_blank">\n  </zp-no-data> -->\n\n  <md-card flex="20" flex-gt-md="70" layout-padding ng-if="$ctrl.machines.items.length">\n    <p class="md-display-3 margin-bottom-0 margin-top-0" countupto="$ctrl.machines.items.length" decimals="0" duration="1.4"></p>\n    <p class="zp-caption">INTEGRATION MACHINES</p>\n  </md-card>\n\n  <md-card flex="25" flex-gt-md="70" layout-padding ng-show="$ctrl.configuredIntegrations.configuredConnections.length || $ctrl.machines.items.length">\n    <zp-connection-status></zp-connection-status>\n  </md-card>\n\n</div>\n');
$templateCache.put('app/integration/home-page/zp-machines-list-search-toolbar/tmpl.html','<zp-search-toolbar metadata="$ctrl.metadata.title" search-val="$ctrl.factoryData.searchVal" menu-options="$ctrl.metadata.menuOptions"></zp-search-toolbar>\n');
$templateCache.put('app/integration/home-page/zp-machines-list-view-shell/tmpl.html','<md-content layout-fill>\n  <md-list>\n    <md-card ng-if="!$ctrl.machines.items.length" layout-padding flex="80" flex-offset="10" class="margin-top-40">\n      <div layout="row" layout-align="center center" class="margin-top-40">\n        <div ng-include="$ctrl.integrationHubOverviewImageSvg"></div>\n      </div>\n      <div layout="row">\n        <div flex="100" flex-gt-md="70">\n          <p class="md-display-1 margin-bottom-0">Zuant Integration Hub</p>\n          <p class="md-title margin-top-10">Streamline your data processing by connecting Zuant to your other systems.\n          </p>\n          <p class="md-body-0 margin-top-0">\n            We currently offer native API integrations for Eloqua and Salesforce. All other integrations are handled via\n            a simple http post mechanism. Once you have successfully connected to your external system, you can build an\n            integration machine to control the data you send and where it gets sent to.\n          </p>\n        </div>\n      </div>\n      <div flex-gt-md="30" flex-offset-gt-md="70" flex="100" flex-md="50" flex-offset-md="50">\n        <p class="md-headline marker-felt"> Step 1: connect to a system</p>\n        <div layout="column">\n          <md-button class="md-accent md-raised" permission\n            permission-only="$ctrl.permissions.boltOns.integration.loginCredentials.manage"\n            ng-click="$ctrl.launchConnectionDialog($event, \'eloqua\')">\n            Connect Eloqua\n          </md-button>\n          <md-button class="md-accent md-raised" permission\n            permission-only="$ctrl.permissions.boltOns.integration.loginCredentials.manage"\n            ng-click="$ctrl.launchConnectionDialog($event, \'sfdc\')">\n            Connect SFDC\n          </md-button>\n          <md-button class="md-accent md-raised" ng-click="$ctrl.openNewMachineDialog($event)">Configure HTTP POST\n          </md-button>\n        </div>\n      </div>\n\n    </md-card>\n\n    <md-list ng-if="$ctrl.machines.items.length">\n      <md-subheader class="md-no-sticky" permission permission-only="\'TRUMP\'">Eloqua REST machines</md-subheader>\n      <md-list-item\n        ng-repeat="machine in $ctrl.machines.items | filter: $ctrl.search.searchVal | orderBy: $ctrl.factoryData.orderBy"\n        ng-if="machine.actuator.system === \'Eloqua\' && machine.actuator.action === \'replicateViaREST\'">\n        <zp-machine-list-item machine="machine" flex>\n        </zp-machine-list-item>\n      </md-list-item>\n\n      <md-subheader class="md-no-sticky" permission permission-only="\'TRUMP\'">Eloqua SOAP machines</md-subheader>\n      <md-list-item\n        ng-repeat="machine in $ctrl.machines.items | filter: $ctrl.search.searchVal | orderBy: $ctrl.factoryData.orderBy"\n        ng-if="machine.actuator.system === \'Eloqua\' && machine.actuator.action === \'replicate\'">\n        <zp-machine-list-item machine="machine" flex>\n        </zp-machine-list-item>\n      </md-list-item>\n\n      <md-subheader class="md-no-sticky">SFDC machines</md-subheader>\n      <md-list-item\n        ng-repeat="machine in $ctrl.machines.items | filter: $ctrl.search.searchVal | orderBy: $ctrl.factoryData.orderBy"\n        ng-if="machine.actuator.system === \'SFDC\'">\n        <zp-machine-list-item machine="machine" flex>\n        </zp-machine-list-item>\n      </md-list-item>\n\n      <md-subheader class="md-no-sticky">HTTP POST machines</md-subheader>\n      <md-list-item\n        ng-repeat="machine in $ctrl.machines.items | filter: $ctrl.search.searchVal | orderBy: $ctrl.factoryData.orderBy"\n        ng-if="machine.actuator.system === \'HttpPost\'">\n        <zp-machine-list-item machine="machine" flex>\n        </zp-machine-list-item>\n      </md-list-item>\n    </md-list>\n</md-content>');
$templateCache.put('app/lists/detail/fab/fab.tmpl.html','<zp-helper-arrow help-message="Start adding some items!" show-condition="!$ctrl.data.items.length"  permission permission-only="$ctrl.permissions.boltOns.formManagement.predefinedLists.edit"></zp-helper-arrow>\n<zp-fab-add ng-show="!$ctrl.metadata.reorderItems" pulse-class-check="!$ctrl.data.items.length" dialog-config="$ctrl.metadata.fabDialogConfig" permission permission-only="$ctrl.permissions.boltOns.formManagement.predefinedLists.edit"></zp-fab-add>\n');
$templateCache.put('app/lists/detail/list-detail-page-component/list.add-items.dialog.tmpl.html','<md-dialog flex="100" flex-gt-sm="60" aria-label="Add list item dialog">\n  <md-toolbar>\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">Enter a new list item</p>\n      <span flex></span>\n      <md-button ng-click="vm.cancel()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content ng-cloak layout-padding class="padding-top-20">\n    <p class="md-caption" ng-if="vm.showHints">\n      <span class="md-body-2">\n        <md-icon md-font-icon="zmdi zmdi-fire zuantPollen"></md-icon>\n      </span>Hit\n      <span class="code zuantPollen">\n        <code>Enter</code>\n      </span> key to save and add another item, and\n      <span class="code zuantPollen">\n        <code>Shift + Enter</code>\n      </span> to save and close.\n    </p>\n    <div ng-show="!vm.valid">\n      <p class="fade" ng-show="vm.formErrors.blank_code_blank_caption_Error">\n        <md-icon md-font-icon="zmdi zmdi-alert-triangle zuantPollen"></md-icon> List items need at least a caption or code value to be stored.\n      </p>\n      <p class="fade" ng-show="vm.formErrors.colon_char_Error">\n        <md-icon md-font-icon="zmdi zmdi-alert-triangle zuantPollen"></md-icon> Sorry, colon characters aren\'t allowed!\n      </p>\n      <p class="fade" ng-show="vm.formErrors.storable_value_exists_ErrorMessage">\n        <md-icon md-font-icon="zmdi zmdi-alert-triangle zuantPollen"></md-icon> {{vm.formErrors.storable_value_exists_ErrorMessage}}\n      </p>\n    </div>\n    <form name="vm.addItemsForm" novalidate>\n      <div layout="column" layout-gt-xs="row">\n        <md-input-container flex="50">\n          <label>Caption</label>\n          <input ng-model="vm.newItem.caption" name="caption" aria-label="Item caption" md-autofocus ng-blur="vm.validateForm()" ng-change="vm.validateForm()"  />\n          <div class="hint" ng-if="vm.showHints">Answer caption as seen by the user</div>\n          <div ng-messages="vm.addItemsForm.caption.$error">\n            <div ng-if="vm.formErrors.caption_label_exists_Error">An item with that caption already exists</div>\n          </div>\n        </md-input-container>\n        <md-input-container flex="50">\n          <label>Code</label>\n          <input ng-model="vm.newItem.code" name="code" aria-label="Item Code" ng-blur="vm.validateForm()" ng-change="vm.validateForm()"  />\n          <div class="hint" ng-if="vm.showHints">The value stored in the database</div>\n          <div ng-messages="vm.addItemsForm.code.$error">\n            <div ng-if="vm.formErrors.code_exists_Error">An item with that code already exists</div>\n          </div>\n        </md-input-container>\n      </div>\n      <div layout="column" layout-gt-xs="row">\n        <md-input-container flex="50">\n          <label>Reporting label</label>\n          <input ng-model="vm.newItem.reportingLabel" name="reportingLabel" aria-label="Reporting label" ng-blur="vm.validateForm()" ng-change="vm.validateForm()"  />\n          <div class="hint" ng-if="vm.showHints">For charts</div>\n          <div ng-messages="vm.addItemsForm.code.$error">\n            <div ng-if="vm.formErrors.reporting_label_exists_Error">An item with that reporting label already exists</div>\n          </div>\n        </md-input-container>\n        <md-input-container flex="50">\n          <label>Item points score</label>\n          <input ng-model="vm.newItem.points" name="points" type="number" aria-label="Points value" ng-keypress="vm.preventKeyStrokes($event)" />\n          <div class="hint" ng-if="vm.showHints">For lead scoring</div>\n        </md-input-container>\n      </div>\n      <div layout="row">\n        <md-switch ng-model="vm.newItem.showMoreInfoTextfield" ng-true-value="1" ng-false-value="0" aria-label="Show more info textfield">\n          Show more info textfield:\n        </md-switch>\n      </div>\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n\n  </md-dialog-content>\n\n  <md-dialog-actions>\n    <md-button ng-click="vm.submitForm(true)" aria-label="Save and close" ng-disabled="vm.disableSave">Save & Close</md-button>\n    <md-button ng-click="vm.submitForm(false)" aria-label="Save and add another item" ng-disabled="vm.disableSave">Save & Add Another</md-button>\n  </md-dialog-actions>\n\n</md-dialog>\n');
$templateCache.put('app/lists/detail/list-detail-page-component/list.detail-page.tmpl.html','<md-content flex layout="column" layout-fill>\n  <div layout="row" layout-gt-md="row" ng-cloak layout-align="start start">\n    <md-card flex layout-padding>\n      <!-- entity title editor -->\n      <md-toolbar class="md-table-toolbar md-default" ng-hide="$ctrl.data.selectedItems.length">\n        <div class="md-toolbar-tools">\n          <zp-editable-header metadata="$ctrl.metadata" value="$ctrl.data.title" ng-show="!$ctrl.showSearch"\n            done-function="$ctrl.updateTitle(value)"></zp-editable-header>\n          <md-input-container ng-show="$ctrl.showSearch" flex class="margin-bottom-0 margin-top-40">\n            <label>Filter items</label>\n            <input ng-model="$ctrl.searchValue" ng-show="$ctrl.showSearch" focus-on-show />\n          </md-input-container>\n          <div flex></div>\n          <md-button class="md-icon-button" ng-click="$ctrl.toggleSearch()" ng-class="{\'btn-active\': $ctrl.showSearch}"\n            ng-disabled="!$ctrl.data.items.length" aria-label="toggle search">\n            <md-icon md-font-icon="zmdi zmdi-search"></md-icon>\n          </md-button>\n          <zp-reorder-button permission permission-only="$ctrl.permissions.boltOns.formManagement.predefinedLists.edit"\n            on-click="$ctrl.reorderButtonClicked()" is-active="$ctrl.metadata.reorderItems"\n            is-disabled="!$ctrl.data.items.length"></zp-reorder-button>\n          <zp-save-button label="\'Save list\'" isdirty="$ctrl.changeDeltaFactory.isDirty()" save="$ctrl.saveChanges()"\n            permission permission-only="$ctrl.permissions.boltOns.formManagement.predefinedLists.edit"></zp-save-button>\n          <zp-context-menu permission permission-only="$ctrl.permissions.boltOns.formManagement.predefinedLists.edit"\n            menu-options="$ctrl.menuOptions" on-menu-click="$ctrl.onMenuClick({ action: action, ev:ev })">\n          </zp-context-menu>\n        </div>\n      </md-toolbar>\n\n      <!-- <div ng-show="$ctrl.showWarning" class="coral-bg" ng-class="{\'animated shake\': $ctrl.shakeField, \'animated hinge\': $ctrl.hingeOut}" style="color: white; text-transform: uppercase; font-weight: bold;">\n        <p class="md-subhead">\n          <md-icon md-font-icon="zmdi zmdi-alert-triangle zuantPollen"></md-icon> Code value error found. Save the list to fix it\n        </p>\n      </div> -->\n\n      <!-- <zp-selection-manager\n        toolbar-buttons="$ctrl.metadata.toolbarButtons"\n        delete-button-on-click="$ctrl.archiveItems(ev)"\n        widget-id="$ctrl.metadata.id">\n      </zp-selection-manager> -->\n\n      <md-toolbar class="md-table-toolbar alternate" ng-show="$ctrl.data.selectedItems.length">\n        <div class="md-toolbar-tools">\n          <zp-clear-button class="zp-button" on-click="$ctrl.clearSelectedCheckboxClicked($event)"></zp-clear-button>\n          <span>{{$ctrl.data.selectedItems.length}} {{$ctrl.data.selectedItems.length > 1 ? \'items\' : \'item\'}}\n            selected</span>\n          <span flex></span>\n          <zp-delete-button label="\'Delete selected items\'" ng-if="$ctrl.metadata.toolbarButtons.showDelete"\n            on-click="$ctrl.archiveItems(ev)"></zp-delete-button>\n        </div>\n      </md-toolbar>\n\n      <zp-data-grid ng-cloak data="$ctrl.data" metadata="$ctrl.metadata" search-value="$ctrl.searchValue"\n        options="$ctrl.metadata.gridOptions" ng-show="!$ctrl.metadata.reorderItems" widget-id="$ctrl.metadata.id"\n        on-sort-change="$ctrl.onSortChange(order)">\n      </zp-data-grid>\n\n      <zp-reorder-list ng-cloak ng-show="$ctrl.metadata.reorderItems" items="$ctrl.data.items"\n        search-value="$ctrl.searchValue" metadata="$ctrl.metadata">\n      </zp-reorder-list>\n\n    </md-card>\n\n    <md-card flex="30" ng-if="$ctrl.showHints && !$ctrl.metadata.reorderItems" layout-padding>\n      <div class="md-toolbar-tools">\n        <p class="md-header">Building a list</p>\n        <div flex></div>\n        <md-button class="md-icon-button">\n          <md-icon md-font-icon="zmdi zmdi-close" ng-click="$ctrl.toggleHints()"></md-icon>\n        </md-button>\n      </div>\n      <p>Create reusable answer lists for use throughout Zuant. The caption field is what the user will see when using\n        the App. The code is the value that will be stored in the database. Reporting label is for charts and the lead\n        grid. Points are for lead scoring. Show more info will display a textfield when selected, handy for capturing\n        \'other\' values.</p>\n    </md-card>\n    <md-card flex="30" ng-if="$ctrl.showHints && $ctrl.metadata.reorderItems" layout-padding>\n      <div class="md-toolbar-tools">\n        <p class="md-header">Reordering items</p>\n        <div flex></div>\n        <md-button class="md-icon-button" ng-click="$ctrl.toggleHints()">\n          <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n        </md-button>\n      </div>\n      <p>\n        List items are displayed in a stored order, drag and drop your items into your desired order and then save.</p>\n    </md-card>\n  </div>\n  <div layout-padding ng-show="$ctrl.data._deletedatelocalutc">\n    This list is currently archived <md-button ng-click="$ctrl.unarchiveList()">Unarchive</md-button>\n  </div>\n\n</md-content>');
$templateCache.put('app/lists/detail/ocr-detail-page-component/ocr-detail-page.tmpl.html','<md-content flex\n    layout="column">\n      <zp-instance-toolbar ng-controller="ListDetailInstanceToolbarController"></zp-instance-toolbar>\n\n      <div layout="row"\n          layout-gt-md="row"\n          ng-cloak\n          layout-align="start start">\n\n            <zp-ocr-template-editor></zp-ocr-template-editor>\n\n            <md-card flex="30"\n                ng-if="$ctrl.showHints && $ctrl.showListHint"\n                layout-padding>\n                  <div class="md-toolbar-tools">\n                        <p class="md-header">Building an OCR Template</p>\n                        <div flex></div>\n                        <md-button class="md-icon-button">\n                              <md-icon md-font-icon="zmdi zmdi-close"\n                                  ng-click="$ctrl.showListHint = false"></md-icon>\n                        </md-button>\n                  </div>\n                  <p>Create reusable answer lists for use throughout Zuant. The caption field is what the user will see when using the App. The code is the value that will be stored in the database. Reporting label is for charts and the lead grid. Points are for lead scoring. Show more info will display a textfield when selected, handy for capturing \'other\' values.</p>\n                  </md-card>\n\n                  </div>\n                  </md-content>\n\n                  <md-sidenav id="settingsPanel"\n                      md-component-id=\'settingsPanel\'\n                      class="md-sidenav-right">\n                        <zp-sidenav></zp-sidenav>\n                        </md-sidenav>\n');
$templateCache.put('app/lists/detail/ocr-template-editor-component/ocr.add-items-dialog.tmpl.html','<md-dialog flex="100" flex-gt-sm="60"  aria-label="Add list item dialog">\n  <md-toolbar>\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">Create a new OCR field mapping</p>\n      <span flex></span>\n      <md-button ng-click="cancel()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-dialog-content layout-padding class="padding-top-20">\n    <p class="md-caption" ng-if="showHints">\n      <span class="md-body-2">\n        <md-icon md-font-icon="zmdi zmdi-fire zuantPollen"></md-icon>\n      </span>Hit\n      <span class="code zuantPollen">\n        <code>Enter</code>\n      </span> key to save and add another item, and\n      <span class="code zuantPollen">\n        <code>Shift + Enter</code>\n      </span> to save and close.\n    </p>\n    <form name="addItemsForm">\n      <div layout="row">\n        <md-input-container layout-fill>\n          <label>OCR Field Name</label>\n          <input ng-model="newItem.OCRFieldName" aria-label="OCRFieldName" md-autofocus />\n          <div class="hint" ng-if="showHints">Field name as appears in OCR screen</div>\n          <div ng-messages="addItemsForm.OCRFieldName.$error">\n            <div ng-if="itemAlreadyExists">Already exists</div>\n            <div ng-if="blankcaptionError">Field cannot be blank</div>\n          </div>\n        </md-input-container>\n        <md-input-container layout-fill>\n          <label>Zuant Field Name</label>\n          <input ng-model="newItem.zuantFieldName" aria-label="zuantFieldName" />\n          <div class="hint" ng-if="showHints">The Zuant field to map to</div>\n          <div ng-messages="addItemsForm.zuantFieldName.$error">\n            <div ng-if="itemAlreadyExists">Already exists</div>\n            <div ng-if="blankcaptionError">Field cannot be blank</div>\n          </div>\n        </md-input-container>\n      </div>\n      <div layout="row">\n        <md-switch ng-model="newItem.isImportant" ng-true-value="true" ng-false-value="false" aria-label="Important field">\n          Important field\n        </md-switch>\n        <md-switch ng-model="newItem.requiresVerification" ng-true-value="true" ng-false-value="false" aria-label="Requires user verification">\n          Require verification\n        </md-switch>\n      </div>\n      <div ng-if="showHints">\n        <p>Important fields appear on the important fields tab</p>\n        <p>Field requiring verification have to be verfied by the user before they can close the OCR screen</p>\n      </div>\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n  </md-dialog-content>\n  <md-dialog-actions>\n    <md-button ng-click="submitForm(true)" aria-label="Save and close">Save & Close</md-button>\n    <md-button ng-click="submitForm(false)" aria-label="Save and add another item">Save & Add Another</md-button>\n  </md-dialog-actions>\n</md-dialog>\n');
$templateCache.put('app/lists/detail/ocr-template-editor-component/ocr.template-editor.tmpl.html','<md-card flex layout-padding class="padding-top-20">\n  <!-- entity title editor //-->\n  <md-toolbar class="md-table-toolbar md-default">\n    <div class="md-toolbar-tools">\n      <zp-editable-header ng-show="!showSearch" metadata="$ctrl.metadata" value="$ctrl.data.title" done-function="$ctrl.updateTitle(value)"></zp-editable-header>\n      <md-input-container ng-show="showSearch" flex class="margin-bottom-0 margin-top-40">\n        <label>Filter items</label>\n        <input ng-model="$ctrl.searchValue" />\n      </md-input-container>\n      <div flex></div>\n      <md-button class="md-icon-button" ng-click="showSearch = !showSearch" ng-class="{\'btn-active\': showSearch}" aria-label="toggle search">\n        <md-icon md-font-icon="zmdi zmdi-search"></md-icon>\n      </md-button>\n      <zp-reorder-button on-click="$ctrl.metadata.reorderItems = !$ctrl.metadata.reorderItems" is-active="$ctrl.metadata.reorderItems"></zp-reorder-button>\n      <zp-save-button label="\'Save list\'" isdirty="$ctrl.changeDeltaFactory.isDirty()" save="$ctrl.saveChanges()"></zp-save-button>\n    </div>\n  </md-toolbar>\n\n  <zp-selection-manager toolbar-buttons="$ctrl.metadata.toolbarButtons"></zp-selection-manager>\n\n  <zp-data-grid\n    ng-cloak\n    ng-show="!$ctrl.metadata.reorderItems"\n    data="$ctrl.data"\n    metadata="$ctrl.metadata"\n    search-value="$ctrl.searchValue"\n    options="$ctrl.metadata.gridOptions">\n  </zp-data-grid>\n\n  <zp-reorder-list\n    ng-cloak\n    ng-show="$ctrl.metadata.reorderItems"\n    items="$ctrl.data.items"\n    metadata="$ctrl.metadata">\n  </zp-reorder-list>\n\n  <zp-helper-arrow help-message="Start adding some items!" show-condition="!$ctrl.data.items.length"></zp-helper-arrow>\n\n  <zp-fab-add ng-show="!reorderItems" pulse-class-check="$ctrl.data.items.length == 0" dialog-config="$ctrl.metadata.fabDialogConfig"></zp-fab-add>\n\n</md-card>\n');
$templateCache.put('app/lists/main/fab/fab.tmpl.html','\n<zp-helper-arrow\n  help-message="Create your first list here"\n  show-condition="!$ctrl.data.items.length"\n  permission\n  permission-only="$ctrl.permissions.boltOns.formManagement.predefinedLists.edit">\n</zp-helper-arrow>\n\n <zp-fab-add\n  pulse-class-check="!$ctrl.data.items.length"\n  dialog-config="$ctrl.metadata.fabDialogConfig"\n  permission\n  permission-only="$ctrl.permissions.boltOns.formManagement.predefinedLists.edit">\n</zp-fab-add>\n');
$templateCache.put('app/lists/main/lists-list-component/lists.tmpl.html','<!-- blank slate card -->\n<div flex ng-show="$ctrl.blankSlate" layout-padding layout="row" layout-align="center center">\n  <zp-no-data header="Currently no lists in your account"\n    subhead="Lists provide a quick and convenient way of reusing lists of answers throughout Zuant." body="" svgpath=""\n    fontcolor="zuantLagoonRollover" svgid="">\n  </zp-no-data>\n</div>\n\n<md-card flex="auto" ng-show="!$ctrl.blankSlate" flex-order-md="1">\n\n  <zp-data-grid ng-cloak data="$ctrl.data" metadata="$ctrl.metadata" loading-indicator="$ctrl.loading"\n    search-value="$ctrl.search.searchVal" options="$ctrl.metadata.gridOptions" row-click="$ctrl.goto(rowid)"\n    widget-id="$ctrl.metadata.id">\n  </zp-data-grid>\n\n  <md-table-pagination hide-xs hide-sm class="md-table-pagination" ng-if="$ctrl.metadata.paginationOptions.pagination"\n    md-limit="$ctrl.metadata.paginationOptions.limit" md-limit-options="$ctrl.metadata.paginationOptions.limitOptions"\n    md-page="$ctrl.metadata.paginationOptions.page" md-total="{{$ctrl.totalRows}}"\n    md-page-select="$ctrl.metadata.paginationOptions.pageSelect"\n    md-boundary-links="$ctrl.metadata.paginationOptions.boundaryLinks"\n    md-on-paginate="$ctrl.logPagination(page, limit)">\n  </md-table-pagination>\n</md-card>');
$templateCache.put('app/lists/main/lists-main-page/lists-main-page.tmpl.html','<md-content flex\n  layout="row"\n  layout-gt-md="row"\n  ng-cloak\n  layout-align="start start"\n  layout-fill>\n    <zp-lists \n      flex-order-md="1"\n      layout-fill>\n    </zp-lists>\n</md-content>\n');
$templateCache.put('app/lists/main/ocr-list-component/ocr-templates-list.tmpl.html','<md-card flex="auto" ng-show="$ctrl.data.items.length" flex-order-md="1">\n  <md-toolbar class="md-table-toolbar md-default">\n    <div class="md-toolbar-tools">\n      <span ng-show="!showSearch">OCR Templates</span>\n      <md-input-container ng-show="showSearch" flex class="margin-bottom-0 margin-top-40">\n        <label>Search templates</label>\n        <input ng-model="search" ng-show="showSearch" focus-on-show />\n      </md-input-container>\n      <div flex></div>\n      <md-button class="md-icon-button" ng-click="showSearch = !showSearch" ng-class="{\'btn-active\': showSearch}" aria-label="toggle search">\n        <md-icon md-font-icon="zmdi zmdi-search"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <zp-data-grid\n    ng-cloak\n    data="$ctrl.data"\n    metadata="$ctrl.metadata"\n    search-value="search"\n    options="$ctrl.metadata.gridOptions"\n    row-click="$ctrl.goto(rowid)">\n  </zp-data-grid>\n\n  <md-table-pagination\n    class="md-table-pagination"\n    ng-if="$ctrl.metadata.paginationOptions.pagination"\n    md-limit="$ctrl.metadata.paginationOptions.limit"\n    md-limit-options="$ctrl.metadata.paginationOptions.limitOptions"\n    md-page="$ctrl.metadata.paginationOptions.page"\n    md-total="{{$ctrl.totalRows}}"\n    md-page-select="$ctrl.metadata.paginationOptions.pageSelect"\n    md-boundary-links="$ctrl.metadata.paginationOptions.boundaryLinks"\n    md-on-paginate="$ctrl.logPagination(page, limit)">\n  </md-table-pagination>\n </md-card>\n');
$templateCache.put('app/lists/main/search-toolbar/tmpl.html','<zp-search-toolbar\n  metadata="$ctrl.metadata"\n  menu-options="$ctrl.metadata.menuOptions"\n  on-menu-click="$ctrl.onMenuClick({action: action, ev:ev})">\n</zp-search-toolbar>\n');
$templateCache.put('app/lists/main/widget-container/widget-container.tmpl.html','<md-content layout-fill md-theme="zuantCloudSkin" theme-background="primary:hue-2" hide-xs hide-sm>\n\n  <zp-no-data ng-show="$ctrl.blankSlate" header="No data to see yet." subhead="Standing by."\n    svgpath="{{\'/images/svgs/utilities/theme/rocket_lagoon_002.svg\' | cdnAssets}}" fontcolor="zuantLagoonRollover"\n    svgid="submitted_leads_blank">\n  </zp-no-data>\n\n  <div layout="row" layout-lg="column" ng-show="!$ctrl.blankSlate">\n    <zp-count-widget count="$ctrl.data.items.length" label="LISTS" icon="zmdi-view-headline" flex="50">\n    </zp-count-widget>\n  </div>\n</md-content>');
$templateCache.put('app/showroom/artefacts/main/artefacts-main.tmpl.html','<zp-title-toolbar></zp-title-toolbar>\n<div layout="row" layout-align="start stretch" style="padding:15px" class="artefact-container">\n  <div flex="50" flex-offset="25">\n    <div class="lookup-header-info">\n      Upload any extra information that you want to appear in the Lead Breakout report. You can select which columns should be used as a lookup to match against the data in the report.\n    </div>\n    <md-card layout="column" layout-align="start stretch" style="margin-top:0">\n      <md-button class="md-raised md-primary" ng-click="$ctrl.activateFileInput()" ng-disabled="$ctrl.state.fileBusy">Upload CSV</md-button>\n      <input id="importArtefactInput" type="file" ng-upload-change="fileChanged($event)" style="display:none;" />\n\n      <div ng-show="$ctrl.columns" class="lookup-columns-container">\n        <span class="info">Select which columns will be used to match the lookup data:</span>\n        <div ng-repeat="(col, val) in $ctrl.columns" class="lookup-column" layout="row" layout-align="space-between stretch">\n          <div flex>\n            {{col}}\n          </div>\n          <div flex>\n            <md-checkbox ng-model="$ctrl.columns[col]" />\n          </div>\n        </div>\n\n        <md-input-container class="lookup-input">\n          <label>Select Object Type For Lookup</label>\n          <md-select ng-model="$ctrl.lookupobject" aria-label="Lookup object type">\n            <md-option value="company">\n              Company\n            </md-option>\n            <md-option value="contact">\n              Contact\n            </md-option>\n            <md-option value="response">\n              Response\n            </md-option>\n          </md-select>\n        </md-input-container>\n\n        <md-input-container class="lookup-input">\n          <label>Select Lookup Name</label>\n          <md-select ng-model="$ctrl.lookupname" aria-label="Existing lookups">\n            <md-option ng-repeat="lookup in $ctrl.existingLookups" ng-value="lookup">\n              {{lookup.lookupname}}\n            </md-option>\n          </md-select>\n        </md-input-container>\n\n        <md-input-container class="lookup-input" ng-show="$ctrl.lookupname.lookupname == \'Create new lookup\'">\n          <label>New Lookup Name</label>\n          <input ng-model="$ctrl.newlookupname" aria-label="New lookup value" />\n        </md-input-container>\n\n        <div layout="row" class="lookup-column" layout-align="space-between stretch" ng-show="$ctrl.lookupname.lookupname && $ctrl.lookupname.lookupname !== \'Create new lookup\'">\n          <div flex>\n            Overwrite existing lookup\n          </div>\n          <div flex>\n            <md-checkbox ng-model="$ctrl.lookupoverride" />\n          </div>\n        </div>\n      </div>\n\n      <md-button class="md-raised md-primary" ng-click="$ctrl.uploadLookup()" ng-show="$ctrl.lookupname.lookupname && ($ctrl.lookupname.lookupname !== \'Create new lookup\' || ($ctrl.lookupname.lookupname == \'Create new lookup\' && $ctrl.newlookupname))" ng-disabled="$ctrl.state.fileBusy">Upload Lookup</md-button>\n    </md-card>\n  </div>\n</div>\n');
$templateCache.put('app/showroom/blocks/dialogs/add-edit-block.dialog.tmpl.html','<md-dialog aria-label="Image item dialog" flex="80" flex-gt-md="60">\n\n  <md-toolbar aria-label="Image item dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">\n        <span ng-if="!vm.block._id">Add block</span>\n        <span ng-if="vm.block._id">Edit block</span>\n      </p>\n      <span flex></span>\n      <md-button class="md-icon-button" ng-class="{\'md-raised md-primary\': vm.showHints}" ng-click="vm.showHints = !vm.showHints">\n        <md-icon md-font-icon="zmdi zmdi-help-outline"></md-icon>\n      </md-button>\n      <md-button class="md-icon-button" ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-progress-linear class="md-accent" ng-if="vm.loading"></md-progress-linear>\n  <md-dialog-content layout-padding>\n    <div layout-padding ng-if="vm.loading">\n      Saving...\n    </div>\n    <form name="vm.blockForm" novalidate ng-if="!vm.loading">\n\n      <div layout="column" layout-gt-xs="row">\n        <md-input-container flex>\n          <label>Nameplate</label>\n          <input type="text" name="nameplate" ng-model="vm.block.nameplate" aria-label="Name" required md-autofocus>\n          <div class="hint" ng-if="vm.showHints">The nameplate appears on the block. Think of it like a car numberplate</div>\n          <div ng-messages="vm.blockForm.nameplate.$error" md-auto-hide="false" ng-show="vm.blockForm.nameplate.$touched">\n            <div ng-message when="required">\n              <spanYour block item needs a nameplate</span>\n            </div>\n          </div>\n        </md-input-container>\n      </div>\n\n      <div layout="column" layout-gt-xs="row">\n        <md-input-container flex>\n          <label>Description</label>\n          <input type="text" name="title" ng-model="vm.block.description" aria-label="Description">\n          <div class="hint" ng-if="vm.showHints"></div>\n        </md-input-container>\n      </div>\n\n      <div layout="column" layout-gt-xs="row">\n        <md-input-container flex>\n            <label>Caption</label>\n            <input type="text" name="caption" ng-model="vm.block.caption" aria-label="Caption">\n            <div class="hint" ng-if="vm.showHints">Appears at the top of the screen once inside the block</div>\n        </md-input-container>\n      </div>\n\n      <div layout="column" layout-gt-xs="row">\n        <md-input-container flex>\n          <label>Nameplate Image</label>\n          <md-select ng-model="vm.block.nameplateImage">\n            <md-option>\n              <em>None</em>\n            </md-option>\n            <md-option ng-repeat="image in vm.listOfImages" ng-value="image._id">\n              {{image.title}}\n            </md-option>\n            <md-option value="0_new">Upload new image...</md-option>\n          </md-select>\n          <div class="hint" ng-if="vm.showHints">Select an image that will appear for this block in the showroom</div>\n        </md-input-container>\n      </div>\n\n      <div ng-show="vm.block.nameplateImage == \'0_new\'" layout="column">\n\n        <zp-image-artefact-form\n          loading="vm.loading"\n          form-type="vm.formType"\n          image-type="vm.imageType"\n          set-image-type="vm.setImageType(type)"\n          set-logo-ready="vm.setLogoReady(val, filename)"\n          image-doc="vm.imageDoc"\n          form-object="vm.blockForm">\n        </zp-image-artefact-form>\n\n      </div>\n\n      <div layout="column" layout-gt-xs="row">\n        <md-tooltip>Hides caption so only image displays</md-tooltip>\n        <md-switch class="md-secondary list-switch" name="nameplateHidden" ng-model="vm.block.nameplateHidden">\n          Hide Nameplate Caption\n        </md-switch>\n      </div>\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n  </md-dialog-content>\n\n  <md-dialog-actions layout="row">    \n    <md-button class="md-warn" ng-click="vm.cancelDialog()">Cancel</md-button>\n    <md-button ng-disabled="vm.disableSaveButton || (!vm.logoReady && vm.block.nameplateImage == \'0_new\' && vm.imageType === \'upload\')" class="md-primary" aria-label="save block form" ng-click="vm.saveBlock()">Save</md-button>\n  </md-dialog-actions>\n\n</md-dialog>\n');
$templateCache.put('app/showroom/blocks/dialogs/add-edit-parent-block-visuals.dialog.tmpl.html','<md-dialog aria-label="Image item dialog" flex="30" flex-gt-md="30">\n\n  <md-toolbar aria-label="Image item dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">\n        <span ng-if="!vm.block._id">Add block</span>\n        <span ng-if="vm.block._id">Edit block</span>\n      </p>\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content layout-padding>\n    <form name="vm.blockForm" novalidate layout="row" layout-padding class="thirds">\n\n      <md-slider-container flex>\n        <md-input-container>\n          <input flex type="number" ng-model="vm.block.heightOfBlocks" aria-label="Height of child blocks" aria-controls="height-slider" />\n        </md-input-container>\n        <md-slider ng-discrete press-up="vm.modelChanged()" ng-model="vm.block.heightOfBlocks" min="40" max="500" id="height-slider" aria-label="Height of child blocks slider" md-vertical class="md-primary" md-range>\n        </md-slider>\n        <h5>Height of Child Blocks</h5>\n      </md-slider-container>\n\n      <md-slider-container flex>\n        <md-input-container>\n          <input flex type="number" ng-model="vm.block.padding" aria-label="Padding between child blocks" aria-controls="padding-slider" />\n        </md-input-container>\n        <md-slider ng-discrete press-up="vm.modelChanged()" ng-model="vm.block.padding" min="1" max="100" id="padding-slider" aria-label="Padding between child blocks slider" md-vertical class="md-primary" md-range>\n        </md-slider>\n        <h5>Padding between Child Blocks</h5>\n      </md-slider-container>\n\n      <md-slider-container flex>\n        <md-input-container>\n          <input flex type="number" ng-model="vm.block.blocksPerRow" aria-label="Number of blocks per row" aria-controls="row-slider" />\n        </md-input-container>\n        <md-slider ng-discrete press-up="vm.modelChanged()" ng-model="vm.block.blocksPerRow" min="1" max="10" id="row-slider" aria-label="Number of blocks per row slider" md-vertical class="md-primary" md-range>\n        </md-slider>\n        <h5>Number of Blocks per Row</h5>\n      </md-slider-container>\n\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n  </md-dialog-content>\n\n  <md-dialog-actions layout="row">\n    <md-button class="md-warn" ng-click="vm.cancelDialog()">Cancel</md-button>\n    <md-button ng-disabled="vm.disableSaveButton || (!vm.logoReady && vm.block.backgroundImage == \'0_new\')" class="md-primary" aria-label="save block form" ng-click="vm.saveBlock()">Save</md-button>\n  </md-dialog-actions>\n\n</md-dialog>\n<div flex="60">\n\n</div>\n');
$templateCache.put('app/showroom/blocks/dialogs/add-edit-parent-block.dialog.tmpl.html','<md-dialog aria-label="Image item dialog" flex="80" flex-gt-md="60">\n\n  <md-toolbar aria-label="Image item dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">\n        <span ng-if="!vm.block._id">Add parent block</span>\n        <span ng-if="vm.block._id">Edit parent block</span>\n      </p>\n      <span flex></span>\n      <md-button class="md-icon-button" ng-class="{\'md-raised md-primary\': vm.showHints}" ng-click="vm.showHints = !vm.showHints">\n        <md-icon md-font-icon="zmdi zmdi-help-outline"></md-icon>\n      </md-button>\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-progress-linear class="md-accent" ng-if="vm.loading"></md-progress-linear>\n  <md-dialog-content layout-padding>\n    <div layout-padding ng-if="vm.loading">\n      Saving...\n    </div>\n    <form name="vm.blockForm" novalidate ng-if="!vm.loading">\n\n      <div layout="column" layout-gt-xs="row">\n        <md-input-container flex>\n          <label>Nameplate</label>\n          <input type="text" name="nameplate" ng-model="vm.block.nameplate" aria-label="Name" required md-autofocus>\n          <div class="hint" ng-if="vm.showHints">The nameplate appears on the block. Think of it like a car numberplate</div>\n          <div ng-messages="vm.blockForm.nameplate.$error" md-auto-hide="false" ng-show="vm.blockForm.nameplate.$touched">\n            <div ng-message when="required">\n              <spanYour block item needs a nameplate</span>\n            </div>\n          </div>\n        </md-input-container>\n      </div>\n\n      <div layout="column" layout-gt-xs="row">\n        <md-input-container flex>\n          <label>Description</label>\n          <input type="text" name="description" ng-model="vm.block.description" aria-label="Description">\n          <div class="hint" ng-if="vm.showHints"></div>\n        </md-input-container>\n      </div>\n\n      <div layout="column" layout-gt-xs="row">\n        <md-input-container flex>\n          <label>Caption</label>\n          <input type="text" name="caption" ng-model="vm.block.caption" aria-label="Caption">\n          <div class="hint" ng-if="vm.showHints">Appears at the top of the screen once inside the block</div>\n        </md-input-container>\n      </div>\n\n      <div layout="column" layout-gt-xs="row">\n        <md-input-container flex>\n          <label>Background Image</label>\n          <md-select ng-model="vm.block.backgroundImage" ng-change="vm.imageChanged()">\n            <md-option>\n              <em>None</em>\n            </md-option>\n            <md-option ng-repeat="image in vm.listOfImages" ng-value="image._id">\n              {{image.title}}\n            </md-option>\n            <md-option value="0_new">Upload new image...</md-option>\n          </md-select>\n        </md-input-container>\n      </div>\n\n      <div ng-show="vm.block.backgroundImage == \'0_new\'" layout="column">\n\n        <zp-image-artefact-form\n          loading="vm.loading"\n          form-type="vm.formType"\n          image-type="vm.imageType"\n          set-image-type="vm.setImageType(type)"\n          set-logo-ready="vm.setLogoReady(val, filename)"\n          image-doc="vm.imageDoc"\n          form-object="vm.blockForm">\n        </zp-image-artefact-form>\n\n      </div>\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n  </md-dialog-content>\n\n  <md-dialog-actions layout="row">\n    <md-button class="md-warn" ng-click="vm.cancelDialog()">Cancel</md-button>\n    <md-button ng-disabled="vm.disableSaveButton || (!vm.logoReady && vm.block.backgroundImage == \'0_new\' && vm.imageType === \'upload\')" class="md-primary" aria-label="save block form" ng-click="vm.saveBlock()">Save</md-button>\n  </md-dialog-actions>\n\n</md-dialog>\n');
$templateCache.put('app/showroom/blocks/dialogs/add-existing-blocks-to-block.dialog.tmpl.html','<md-dialog aria-label="Add existing blocks dialog" flex="80" flex-gt-md="80">\n\n    <md-toolbar aria-label="Add existing blocks dialog toolbar">\n      <div layout="row" class="md-toolbar-tools">\n        <p class="md-subhead">\n        Add an existing block to this block\n        </p>\n        <span flex></span>\n        <md-button ng-click="vm.cancelDialog()">\n          <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n        </md-button>\n      </div>\n    </md-toolbar>\n\n    <md-dialog-content layout-padding>\n      <div layout="column" layout-align="start stretch" class="blocks-blocks-fixed-scrollable" flex>\n          <md-list flex ng-if="vm.blockList.length == 0">\n            <md-list-item style="margin-top: 30px;" flex>\n              <md-subheader>\n                Your block items will appear here, but you don\'t have any yet.\n              </md-subheader>\n            </md-list-item>\n          </md-list>\n\n          <md-input-container flex="none" style="margin:15px 10px 0" ng-if="vm.blockList.length > 0">\n              <label for="search">Search...</label>\n              <input name="search" id="search" type="search" ng-model="vm.searchTerm" ng-change="vm.searchTextChanged()" />\n          </md-input-container>\n\n          <div class="lit-library-detail cardish" layout="row" layout-align="space-between center"\n               ng-repeat="block in vm.blockList | filter: { isShouldBeDisplayed: true } track by block._id"\n               ng-class="{\'lit-tree-detail-selected\': block.selectedForPush}">\n\n              <div class="lit-lite-row-actions" flex="noshrink" layout="row" layout-align="space-around center">\n                <md-checkbox flex aria-label="Block selection checkbox"\n                   ng-model="block.selectedForPush" class="row-checkbox"\n                   ng-change="vm.requestBlockStatsUpdate()" />\n              </div>\n\n              <div style="margin-left: 10px;" flex="grow" ng-click="vm.toggleBlockSelection(block)">\n                <span ng-if="block.arrayOfParentBlocks && block.arrayOfParentBlocks.length > 0">{{block.arrayOfParentBlocks[0].nameplate}} - </span>\n                {{block.nameplate}}\n              </div>\n\n          </div>\n      </div>\n    </md-dialog-content>\n\n    <md-dialog-actions layout="row">\n      <md-button class="md-warn" ng-click="vm.cancelDialog()">Cancel</md-button>\n      <md-button ng-disabled="vm.disableSaveButton" class="md-primary" aria-label="save block form" ng-click="vm.applySelectedItemsToCurrentBlockClicked()">Add Blocks</md-button>\n    </md-dialog-actions>\n\n  </md-dialog>\n');
$templateCache.put('app/showroom/blocks/dialogs/add-literature-to-block.dialog.tmpl.html','<md-dialog aria-label="Add literature dialog" flex="80" flex-gt-md="80">\n\n  <md-toolbar aria-label="Add literature dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">\n        Add Literature\n      </p>\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content layout-padding>\n    <div ng-hide="vm.literaturesvc.factoryData.emptyState">\n      <literature-filter class="literature-library-filter" layout="column" layout-align="start stretch"></literature-filter>\n\n      <div flex="noshrink" class="lit-library-detail cardish" layout="row" layout-align="space-between">\n        <div class="lit-lite-row-actions" flex="noshrink" layout="row" layout-align="space-between center">\n          <md-checkbox flex aria-label="Select All checkbox" ng-model="vm.selectAll" class="row-checkbox" ng-change="vm.toggleSelectAll()" />\n        </div>\n\n        <md-input-container flex="grow" style="margin:15px 10px 0">\n          <label for="search">Search...</label>\n          <input name="search" id="search" type="search" ng-model="vm.searchTerm" ng-change="vm.searchTextChanged()" />\n        </md-input-container>\n      </div>\n    </div>\n    <div flex ng-if="vm.literaturesvc.factoryData.emptyState">\n      <p class="md-headline">\n        Your literature library items will appear here, but you don\'t have any yet.\n      </p>\n    </div>\n\n    <div flex="noshrink" class="lit-library-detail cardish" layout="row" layout-align="space-between stretch" ng-repeat="litItem in vm.literaturesvc.literatureItems | filter:{ isShouldBeDisplayed: true }" ng-class="{\'lit-tree-detail-selected\': litItem.selected}">\n\n      <div class="lit-lite-row-actions" flex="noshrink" layout="row" layout-align="space-between center">\n        <md-checkbox flex aria-label="Literature item checkbox" ng-model="litItem.selected" class="row-checkbox" ng-change="vm.requestLitStatsUpdate()" />\n      </div>\n\n      <div flex="grow" layout="column" layout-align="center stretch">\n        <div flex="none" ng-click="vm.toggleLitLibraryLitItemSelection(litItem)" class="lit-item-title">{{litItem.title}}</div>\n\n        <div flex>\n          <div ng-repeat="extendedTag in litItem.extendedTags" width="auto" class="chiptag2">\n            <span>{{vm.getTagTitle(extendedTag._id)}}</span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </md-dialog-content>\n\n  <md-dialog-actions layout="row">\n    <md-button class="md-warn" ng-click="vm.cancelDialog()">Cancel</md-button>\n    <md-button ng-if="vm.literaturesvc.factoryData.emptyState" class="md-raised md-accent animated pulsate-aqua" ng-click="vm.goToLiterature()">Go to literature</md-button>\n    <md-button ng-hide="vm.literaturesvc.factoryData.emptyState" ng-disabled="vm.disableSaveButton" class="md-primary" aria-label="save block form" ng-click="vm.applySelectedItemsToCurrentBlockClicked()">Add Literature</md-button>\n  </md-dialog-actions>\n\n</md-dialog>\n');
$templateCache.put('app/showroom/blocks/dialogs/remove-block.dialog.tmpl.html','<md-dialog aria-label="Image item dialog" flex="80" flex-gt-md="60">\n\n    <md-toolbar aria-label="Image item dialog toolbar">\n      <div layout="row" class="md-toolbar-tools">\n        <p class="md-subhead">\n          Remove block\n        </p>\n        <span flex></span>\n        <md-button ng-click="vm.cancelDialog()">\n          <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n        </md-button>\n      </div>\n    </md-toolbar>\n\n    <md-dialog-content layout-padding>\n      <md-list flex>\n        <md-list-item>\n          <md-subheader flex style="text-align:center">Select if you want to remove the block from its parent or remove the block completely. If you remove the block completely, you will lose all children blocks and literature too. If you remove a block from it\'s parent it will become a new root block.</md-subheader>\n        </md-list-item>\n      </md-list>\n\n      <md-list-item style="margin-top: 30px;">\n        <md-input-container class="md-block" flex>\n          <label>Select option</label>\n          <md-select ng-model="vm.removalOption" flex aria-label="Select removal option">\n            <md-option value="archive">Remove completely</md-option>\n            <md-option value="root">Remove from parent</md-option>\n          </md-select>\n        </md-input-container>\n      </md-list-item>\n    </md-dialog-content>\n\n    <md-dialog-actions layout="row">\n      <md-button class="md-warn" ng-click="vm.cancelDialog()">Cancel</md-button>\n      <md-button ng-disabled="vm.disableSaveButton" class="md-primary" aria-label="remove block" ng-click="vm.removeBlock()">Remove Block</md-button>\n    </md-dialog-actions>\n\n  </md-dialog>\n');
$templateCache.put('app/showroom/blocks/dialogs/remove-literature-from-block.dialog.tmpl.html','<md-dialog aria-label="Literature item dialog" flex="80" flex-gt-md="60">\n\n    <md-toolbar aria-label="Literature item dialog toolbar">\n      <div layout="row" class="md-toolbar-tools">\n        <p class="md-subhead">\n          Remove literature\n        </p>\n        <span flex></span>\n        <md-button ng-click="vm.cancelDialog()">\n          <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n        </md-button>\n      </div>\n    </md-toolbar>\n\n    <md-dialog-content layout-padding>\n      <md-list flex>\n        <md-list-item>\n          <md-subheader flex style="text-align:center">Are you sure you want to remove {{vm.litDoc.title}} from this block?</md-subheader>\n        </md-list-item>\n      </md-list>\n    </md-dialog-content>\n\n    <md-dialog-actions layout="row">\n      <md-button class="md-warn" ng-click="vm.cancelDialog()">No</md-button>\n      <md-button ng-disabled="vm.disableSaveButton" class="md-primary" aria-label="remove literature" ng-click="vm.removeLiterature()">Yes</md-button>\n    </md-dialog-actions>\n\n  </md-dialog>\n');
$templateCache.put('app/showroom/blocks/main/blocks-main.tmpl.html','<zp-title-toolbar></zp-title-toolbar>\n<md-content layout-fill>\n  <div layout="row" layout-align="start stretch" layout-fill>\n    <!-- <md-content layout-fill style="border: 1px solid green; display: block;" flex="30"> -->\n      <blocks-sidebar\n        flex="30"\n        tab-info="vm.tabInfo"\n        blocks="vm.blocks"\n        deselect-all-blocks="vm.deselectAllBlocks()"\n        refresh-tree="vm.refreshTree()"\n        update-current-block="vm.updateCurrentBlock()"\n        current-block="vm.currentBlock">\n      </blocks-sidebar>\n    <!-- </md-content> -->\n    <blocks-screen\n      refresh-tree="vm.refreshTree()"\n      tab-info="vm.tabInfo"\n      id="ipad-screen"\n      class="ipad-screen"\n      flex="70"\n      block="vm.currentBlock"\n      deselect-all-blocks="vm.deselectAllBlocks()"\n      update-current-block="vm.updateCurrentBlock()">\n    </blocks-screen>\n  </div>\n</md-content>\n');
$templateCache.put('app/showroom/images/main/images-main.tmpl.html','<zp-title-toolbar></zp-title-toolbar>\n<!-- <div layout="column" ayout-align="start stretch" tyle="padding:15px"> -->\n<md-content layout-fill>\n    <!-- <md-card flex layout="column" layout-align="start stretch" style="padding:15px;margin-top:0"> -->\n    <!-- <images-toolbar flex="none" style="padding:10px 20px 10px 20px; min-height:20px; overflow:hidden; border-radius:5px 5px 0px 0px;"></images-toolbar> -->\n    <images-list flex="grow" class="fixed-scrollable"></images-list>\n    <!-- </md-card> -->\n    <!-- </div> -->\n</md-content>\n');
$templateCache.put('app/showroom/import/main/file-import-main.tmpl.html','<zp-title-toolbar></zp-title-toolbar>\n<div layout="row" layout-align="start stretch" style="padding:15px">\n  <md-card layout="column" layout-align="start stretch" flex="40" style="margin-top:0">\n    <file-import-toolbar flex="none" style="padding:10px 20px 10px 20px; min-height:20px; overflow:hidden;"></file-import-toolbar>\n\n    <file-import-selector flex="none" style="padding:10px;"></file-import-selector>\n\n    <file-import-list flex="grow" class="fixed-scrollable file-import-list"></file-import-list>\n  </md-card>\n\n  <file-import-actions flex="60"></file-import-actions>\n\n</div>\n');
$templateCache.put('app/showroom/tags/main/tags-main.tmpl.html','<zp-title-toolbar></zp-title-toolbar>\n\n<div layout="row" layout-padding>\n\n  <md-card layout="column" flex="40">\n    <tags-toolbar flex></tags-toolbar>\n    <tags-list class="fixed-scrollable tags-list" layout-fill></tags-list>\n  </md-card>\n\n  <tag-actions flex="20" layout="column" layout-align="space-between stretch"></tag-actions>\n\n  <literature-main flex="40"></literature-main>\n\n</div>\n');
$templateCache.put('app/showroom/third-party/callback/dropbox-callback.tmpl.html','<h2 ng-if="!$ctrl.userDeniedAccess" style="padding:15px">Storing access details...</h2>\n<div ng-if="$ctrl.userDeniedAccess" layout-padding layout-margin style="border-left: 3px solid; background-color: white;" md-colors="::{color: \'primary\', \'border-color\': \'primary-600\'}">\n  <p class="md-headline margin-bottom-0">\n    <md-icon md-font-icon="zmdi zmdi-dropbox"></md-icon> &nbsp; Uh oh!\n    <br>\n    <p class "md-headline">You need to grant the Zuant Dropbox app permission in order to utilise Dropbox as storage for Zuant.</p>\n    <div layout="row" layout-align="center center">\n      <md-button class="md-accent md-raised" ng-click="$ctrl.navBack()">Back</md-button>\n      <md-button class="md-accent md-raised" ng-click="$ctrl.connectToDropbox()">Try again</md-button>\n    </div>\n</div>\n');
$templateCache.put('app/showroom/third-party/main/dropbox-main.tmpl.html','<zp-title-toolbar></zp-title-toolbar>\n\n<div layout-padding layout-margin style="border-left: 4px solid; background-color: white;" md-colors="::{color: \'accent-500\', \'border-color\': \'primary-600\'}"  ng-show="vm.dropboxsvcreference.connectionMessage.showMessage" layout-padding>\n  <p class="md-headline margin-bottom-0"><md-icon md-font-icon="zmdi zmdi-dropbox"></md-icon> &nbsp; Great success!<br>\n  <span class="md-subhead">Your Dropbox account is now connected to Zuant. Your files will appear in the list below. To get started select some files you wish to import in to Zuant.</span></p>\n</div>\n\n<div layout="row" layout-align="start stretch" style="padding:15px;">\n    <md-card layout="column" layout-align="start stretch" flex="40" style="margin-top:0">\n      <dropbox-toolbar flex="none" style="padding:10px 20px 10px 20px; min-height:10px; border-radius:5px 5px 0px 0px;"></dropbox-toolbar>\n\n      <div class="fixed-scrollable dropbox-list">\n        <dropbox-filter flex="none" class="literature-library-filter" ng-show="vm.dropboxsvcreference.showFilterBar"></dropbox-filter>\n\n        <dropbox-list flex="grow"></dropbox-list>\n      </div>\n    </md-card>\n\n    <dropbox-actions flex="20"></dropbox-actions>\n\n    <literature-main flex="40" ></literature-main>\n</div>\n');
$templateCache.put('app/thirdparty/dropbox/callback/dropbox-callback.tmpl.html','<h2 ng-if="!$ctrl.userDeniedAccess" style="padding:15px">Storing access details...</h2>\n<div ng-if="$ctrl.userDeniedAccess" layout-padding layout-margin\n  style="border-left: 3px solid; background-color: white;"\n  md-colors="::{color: \'primary\', \'border-color\': \'primary-600\'}">\n  <p class="md-headline margin-bottom-0">\n    <md-icon md-font-icon="zmdi zmdi-dropbox"></md-icon> &nbsp; Uh oh!\n    <br>\n  <p class "md-headline">You need to grant the Zuant Dropbox app permission in order to utilise Dropbox as storage for\n    Zuant.</p>\n  <div layout="row" layout-align="center center">\n    <md-button class="md-accent md-raised" ng-click="$ctrl.navBack()">Back</md-button>\n    <md-button class="md-accent md-raised" ng-click="$ctrl.connectToDropbox()">Try again</md-button>\n  </div>\n</div>');
$templateCache.put('app/users/add-user/dialog/add-user-dialog.tmpl.html','<md-dialog aria-label="Add new user dialog" flex="80" flex-gt-md="60">\n\n  <md-toolbar aria-label="Create user dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">Create a new user</p>\n      <span flex></span>\n      <md-button ng-disabled="vm.loading" ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content layout-padding>\n    <div ng-show="vm.loading">\n      <md-progress-linear class="md-accent" md-mode="indeterminate"></md-progress-linear>\n    </div>\n\n    <md-list>\n      <md-list-item style="margin-top: 30px;">\n        <md-button ng-disabled="vm.loading" class="md-primary zp-off-white-bg"\n          ng-class="{\'md-raised md-primary\': vm.source == \'new\'}" ng-click="vm.setSource(\'new\')" flex>Create Single\n          User</md-button>\n        <md-button ng-disabled="vm.loading" class="md-primary zp-off-white-bg"\n          ng-class="{\'md-raised md-primary\': vm.source == \'upload\'}" ng-click="vm.setSource(\'upload\')" flex>Upload User\n          List\n        </md-button>\n      </md-list-item>\n    </md-list>\n\n    <div style="margin-top: 25px;padding:0 25px" ng-show="vm.source == \'new\'">\n      <zp-user-form client-doc="vm.clientDoc" user-doc="vm.userDoc" password-fields="true" form-disabled="vm.loading"\n        user-form-obj="vm.userFormObj"></zp-user-form>\n    </div>\n\n\n    <div style="margin-top: 25px;padding:0 25px" ng-show="vm.source == \'upload\'">\n      <div flex class="zuantTitanium1" layout="column">\n        <p><b>Start the user import process for this account by uploading a CSV file. Make sure your CSV aligns with the\n            provided \'Available CSV headers\' & then use the \'UPLOAD CSV\' button to proceed.</b></p>\n        <span>\n          Available CSV headers:\n          <span ng-repeat="availableHeader in vm.avaliableCsvHeaders track by $index">\n            <b>"{{ availableHeader.name }}"</b>{{ availableHeader.description }} {{ ($index <\n              vm.avaliableCsvHeaders.length - 1) ? \', \' : \'\' }} </span>\n          </span>\n\n          <a style="margin-top: 10px; width: fit-content;" class="zuantLagoon"\n            ng-href="{{\'/csvs/user-import/zuant-example-user-import.csv\' | cdnAssets}}">Download Example CSV File</a>\n\n          <div ng-if="vm.isPasswordPolicyEnabled">\n            <p class="margin-bottom-0"><b>Password Requirements:</b></p>\n            <ul class="margin-left-20">\n              <li class="zuantTitanium1 margin-top-0 margin-bottom-0" ng-repeat="policy in vm.activePolicy">\n                {{policy.label}} <b>{{policy.value}}</b>\n                <md-icon style="color: limegreen;" class="margin-left-5"\n                  ng-if="vm.passwordSetFormObj.password.$dirty && !vm.passwordSetFormObj.password.$error[policy.key]"\n                  md-font-icon="zmdi zmdi-check-circle"></md-icon>\n                <md-icon class="margin-left-5 zuantSaffron"\n                  ng-if="vm.passwordSetFormObj.password.$touched && vm.passwordSetFormObj.password.$error[policy.key]"\n                  md-font-icon="zmdi zmdi-close-circle"></md-icon>\n              </li>\n            </ul>\n          </div>\n\n          <div style="margin-top: 5%; margin-bottom: 5%;" flex layout="row" layout-align="start start">\n\n            <div ng-if="vm.fileUploaded" flex="grow" layout="column">\n              <span>File Name: <b>{{ vm.fileName }}</b></span>\n              <span>\n                File Encoding: <b>{{ vm.fileEncoding }}</b>\n              </span>\n              <div ng-if="vm.recognisedCsvHeaders.length > 0">\n                Recognised CSV headers:\n                <span ng-repeat="recognisedHeader in vm.recognisedCsvHeaders track by $index">\n                  <b>"{{ recognisedHeader }}"</b>{{ ($index < vm.recognisedCsvHeaders.length - 1) ? \', \' : \'\' }} </span>\n              </div>\n\n              <div ng-if="vm.fileErrors.length === 0 && vm.fileItems.length > 0">\n                Number Of Users: <b>{{ vm.fileItems.length }}</b>\n              </div>\n\n              <div class="zuantPollen" ng-if="vm.fileErrors.length === 0 && vm.fileWarnings.length > 0">\n                Warnings:\n                <ul>\n                  <li ng-repeat="warningObj in vm.fileWarnings">\n                    {{ warningObj.message }}\n                  </li>\n                </ul>\n              </div>\n\n              <div class="zuantSaffron" ng-if="vm.fileErrors.length > 0">\n                Errors:\n                <ul>\n                  <li ng-repeat="errorObj in vm.fileErrors">\n                    {{ errorObj.error }}\n                  </li>\n                </ul>\n              </div>\n            </div>\n\n            <div flex>\n            </div>\n\n            <md-button ng-disabled="vm.loading" layout-align="end start"\n              ng-class="{\'md-primary\': !vm.fileUploaded, \'md-accent\': vm.fileUploaded}" class="md-raised"\n              ng-click="vm.selectFile()">\n              {{ vm.fileUploaded ? \'Clear File\' : \'Upload CSV\' }}\n            </md-button>\n          </div>\n\n      </div>\n\n      <form ng-if="vm.fileUploaded && vm.fileErrors.length === 0 && vm.recognisedCsvHeaders.indexOf(\'password\') === -1"\n        name="vm.passwordSetFormObj" ng-submit="vm.submitUploadUsers()">\n        "password" field not in use so enter a password to be applied to all uploaded users.\n\n        <md-input-container class="md-block">\n          <label>Password</label>\n          <input type="{{vm.passwordFieldType}}" ng-model="vm.passwordFormFieldValue"\n            ng-change="vm.checkAgainstPasswordPolicy(\'password\')" name="password" aria-label="password" required\n            focus-on-show>\n\n          <md-icon style="color:rgba(0,0,0,0.12);" md-font-icon="zmdi {{vm.passwordFieldIcon}}"\n            ng-click="vm.toggleViewPasswordField(\'password\')">\n            <md-tooltip>{{vm.passwordFieldTooltip}}</md-tooltip>\n          </md-icon>\n\n          <div ng-messages="vm.passwordSetFormObj.password.$error" role="alert">\n            <div ng-message when="required">\n              <span>Please enter a password.</span>\n            </div>\n            <div ng-message when="minLength">\n              <span>Please enter a password with a length greater than\n                <b>{{vm.activePolicy.minLength.value}}</b> characters.</span>\n            </div>\n            <div ng-message when="maxLength">\n              <span>Please enter a password with a length less than\n                <b>{{vm.activePolicy.maxLength.value}}</b> characters.</span>\n            </div>\n            <div ng-message when="minLowercase">\n              <span>Please enter a password with\n                <b>{{vm.activePolicy.minLowercase.value}}</b> or\n                more <b>LOWERCASE</b> characters.</span>\n            </div>\n            <div ng-message when="minUppercase">\n              <span>Please enter a password with\n                <b>{{vm.activePolicy.minUppercase.value}}</b> or\n                more <b>UPPERCASE</b> characters.</span>\n            </div>\n            <div ng-message when="minNumeric">\n              <span>Please enter a password with\n                <b>{{vm.activePolicy.minNumeric.value}}</b> or\n                more <b>NUMERIC</b> characters.</span>\n            </div>\n            <div ng-message when="minSymbol">\n              <span>Please enter a password with\n                <b>{{vm.activePolicy.minSymbol.value}}</b> or\n                more <b>SYMBOL</b> characters.</span>\n            </div>\n            <div ng-message when="nonMatch">\n              <span>Password does not match confirm field.</span>\n            </div>\n          </div>\n        </md-input-container>\n\n        <md-input-container class="md-block">\n          <label>Confirm Password</label>\n\n          <input type="{{vm.confirmPasswordFieldType}}" ng-model="vm.confirmPasswordFormFieldValue"\n            ng-change="vm.checkAgainstPasswordPolicy(\'confirmPassword\')" name="confirmpassword"\n            aria-label="Confirm Password" ng-model-options="{ debounce: 800}" required>\n\n          <md-icon style="color:rgba(0,0,0,0.12);" md-font-icon="zmdi {{vm.confirmPasswordFieldIcon}}"\n            ng-click="vm.toggleViewPasswordField(\'confirmPassword\')">\n            <md-tooltip>{{vm.confirmPasswordFieldTooltip}}</md-tooltip>\n          </md-icon>\n\n          <div ng-messages="vm.passwordSetFormObj.confirmpassword.$error" role="alert">\n            <div ng-message when="required">\n              <span>Please confirm your password.</span>\n            </div>\n            <div ng-message when="nonMatch">\n              <span>Confirm field does not match password field.</span>\n            </div>\n          </div>\n        </md-input-container>\n      </form>\n\n      <div class="zuantSaffron" ng-if="vm.processErrors.length > 0">\n        Process Errors:\n        <ul>\n          <li ng-repeat="errorObj in vm.processErrors">\n            {{ errorObj.error }}\n            <ul ng-if="errorObj.conflicts && errorObj.conflicts.length > 0">\n              <li ng-repeat="conflict in errorObj.conflicts">\n                <b>"{{ conflict }}"</b>\n              </li>\n            </ul>\n          </li>\n        </ul>\n      </div>\n\n    </div>\n\n  </md-dialog-content>\n\n  <md-dialog-actions layout="row">\n    <md-button class="md-warn" ng-click="vm.cancelDialog()" ng-disabled="vm.loading">Cancel</md-button>\n    <md-button class="md-primary" aria-label="save user form" ng-disabled="vm.loading || vm.userFormObj.$invalid"\n      ng-show="vm.source == \'new\'" ng-click="vm.submitUserForm(vm.userDoc)">Create user</md-button>\n    <md-button class="md-primary" aria-label="save user form"\n      ng-disabled="vm.loading || !vm.fileUploaded || vm.fileErrors.length > 0" ng-show="vm.source == \'upload\'"\n      ng-click="vm.submitUploadUsers($event)">Create users</md-button>\n  </md-dialog-actions>\n\n</md-dialog>\n\n<input id="userUploadInput" type="file" accept=".csv" ng-upload-change="vm.fileChanged($event)" style="display:none" />');
$templateCache.put('app/users/detail/set-password/dialog.tmpl.html','<md-dialog aria-label="Set user password" flex="80" flex-gt-md="50">\n      <md-toolbar aria-label="Set password dialog toolbar">\n            <div layout="row" class="md-toolbar-tools">\n                  <p class="md-subhead">Set user password</p>\n                  <span flex></span>\n                  <md-button ng-click="vm.cancelDialog()">\n                        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n                  </md-button>\n            </div>\n      </md-toolbar>\n\n      <md-dialog-content layout-padding>\n\n            <div layout-padding layout="column" layout-align=" start">\n\n                  <p class="zuantTitanium1 margin-top-10 margin-bottom-0">\n                        Simply enter the new password in the designated field and retype it for confirmation. Once both\n                        fields match and you submit, the user\'s password will be updated.\n                  </p>\n\n                  <p ng-if="vm.isPasswordPolicyEnabled" class="zuantTitanium1 margin-top-0 margin-bottom-0">\n                        Your administrator has implemented a password policy for this account so please comply with the\n                        regulations listed below in order to successfuly update the password.\n                  </p>\n\n                  <ul ng-if="vm.isPasswordPolicyEnabled" class="margin-left-20">\n                        <li class="zuantTitanium1 margin-top-0 margin-bottom-0" ng-repeat="policy in vm.activePolicy">\n                              {{policy.label}} <b>{{policy.value}}</b>\n                              <md-icon style="color: limegreen;"\n                                    ng-if="vm.passwordSetFormObj.password.$dirty && !vm.passwordSetFormObj.password.$error[policy.key]"\n                                    md-font-icon="zmdi zmdi-check-circle"></md-icon>\n                              <md-icon class="margin-left-5 zuantSaffron"\n                                    ng-if="vm.passwordSetFormObj.password.$touched && vm.passwordSetFormObj.password.$error[policy.key]"\n                                    md-font-icon="zmdi zmdi-close-circle"></md-icon>\n                        </li>\n                  </ul>\n            </div>\n            <form name="vm.passwordSetFormObj" ng-submit="vm.submitForm(userDoc)">\n                  <md-input-container class="md-block">\n                        <label>Password</label>\n                        <input type="{{vm.passwordFieldType}}" ng-model="vm.passwordFormFieldValue"\n                              ng-change="vm.checkAgainstPasswordPolicy(\'password\')" name="password"\n                              aria-label="password" required focus-on-show>\n\n                        <md-icon style="color:rgba(0,0,0,0.12);" md-font-icon="zmdi {{vm.passwordFieldIcon}}"\n                              ng-click="vm.toggleViewPasswordField(\'password\')">\n                              <md-tooltip>{{vm.passwordFieldTooltip}}</md-tooltip>\n                        </md-icon>\n\n                        <div ng-messages="vm.passwordSetFormObj.password.$error" role="alert">\n                              <div ng-message when="required">\n                                    <span>Please enter a password.</span>\n                              </div>\n                              <div ng-message when="minLength">\n                                    <span>Please enter a password with a length greater than\n                                          <b>{{vm.activePolicy.minLength.value}}</b> characters.</span>\n                              </div>\n                              <div ng-message when="maxLength">\n                                    <span>Please enter a password with a length less than\n                                          <b>{{vm.activePolicy.maxLength.value}}</b> characters.</span>\n                              </div>\n                              <div ng-message when="minLowercase">\n                                    <span>Please enter a password with\n                                          <b>{{vm.activePolicy.minLowercase.value}}</b> or\n                                          more <b>LOWERCASE</b> characters.</span>\n                              </div>\n                              <div ng-message when="minUppercase">\n                                    <span>Please enter a password with\n                                          <b>{{vm.activePolicy.minUppercase.value}}</b> or\n                                          more <b>UPPERCASE</b> characters.</span>\n                              </div>\n                              <div ng-message when="minNumeric">\n                                    <span>Please enter a password with\n                                          <b>{{vm.activePolicy.minNumeric.value}}</b> or\n                                          more <b>NUMERIC</b> characters.</span>\n                              </div>\n                              <div ng-message when="minSymbol">\n                                    <span>Please enter a password with\n                                          <b>{{vm.activePolicy.minSymbol.value}}</b> or\n                                          more <b>SYMBOL</b> characters.</span>\n                              </div>\n                              <div ng-message when="nonMatch">\n                                    <span>Password does not match confirm field.</span>\n                              </div>\n                        </div>\n                  </md-input-container>\n\n                  <md-input-container class="md-block">\n                        <label>Confirm Password</label>\n\n                        <input type="{{vm.confirmPasswordFieldType}}" ng-model="vm.confirmPasswordFormFieldValue"\n                              ng-change="vm.checkAgainstPasswordPolicy(\'confirmPassword\')" name="confirmpassword"\n                              aria-label="Confirm Password" ng-model-options="{ debounce: 800}" required>\n\n                        <md-icon style="color:rgba(0,0,0,0.12);" md-font-icon="zmdi {{vm.confirmPasswordFieldIcon}}"\n                              ng-click="vm.toggleViewPasswordField(\'confirmPassword\')">\n                              <md-tooltip>{{vm.confirmPasswordFieldTooltip}}</md-tooltip>\n                        </md-icon>\n\n                        <div ng-messages="vm.passwordSetFormObj.confirmpassword.$error" role="alert">\n                              <div ng-message when="required">\n                                    <span>Please confirm your password.</span>\n                              </div>\n                              <div ng-message when="nonMatch">\n                                    <span>Confirm field does not match password field.</span>\n                              </div>\n                        </div>\n                  </md-input-container>\n                  <input type="hidden" name="CSRFToken" value="1231234567890" />\n            </form>\n      </md-dialog-content>\n\n      <md-dialog-actions layout="row">\n            <md-button class="md-warn" ng-click="vm.cancelDialog()">Cancel</md-button>\n            <md-button class="md-primary" type="submit" form="vm.passwordSet" aria-label="save user form"\n                  ng-click="vm.submitForm()" ng-disabled="vm.passwordSetFormObj.$invalid">Set\n                  password</md-button>\n      </md-dialog-actions>\n</md-dialog>');
$templateCache.put('app/users/detail/zp-user-form/zp-user-form.tmpl.html','<form name="vm.userFormObj" ng-submit="vm.onSave()">\n  <div layout="column" layout-gt-xs="row">\n    <md-input-container flex="50">\n      <label>First name</label>\n      <input type="text" ng-model="vm.userDoc.firstname" name="firstname" aria-label="firstname" md-autofocus required\n        ng-disabled="vm.userDoc.inactive || vm.formDisabled"\n        ng-change="vm.updateChangeDelta(\'firstname\', vm.userDoc.firstname)">\n      <div class="hint" ng-if="showHints"></div>\n      <div ng-messages="vm.userFormObj.firstname.$error">\n        <div ng-if="vm.userFormObj.firstname.$error.required  && vm.userFormObj.firstname.$touched">Cannot be blank\n        </div>\n      </div>\n    </md-input-container>\n\n    <md-input-container flex="50">\n      <label>Lastname</label>\n      <input type="text" ng-model="vm.userDoc.surname" name="surname" aria-label="surname" required\n        ng-disabled="vm.userDoc.inactive || vm.formDisabled"\n        ng-change="vm.updateChangeDelta(\'surname\', vm.userDoc.surname)">\n      <div ng-messages="vm.userFormObj.surname.$error">\n        <div ng-if="vm.userFormObj.surname.$error.required && vm.userFormObj.surname.$touched">Cannot be blank</div>\n      </div>\n    </md-input-container>\n  </div>\n\n  <div layout="column" layout-gt-xs="row">\n    <md-input-container flex="50">\n      <label>Email</label>\n      <input type="email" ng-model="vm.userDoc.email" name="email" aria-label="email" required\n        ng-disabled="vm.userDoc.inactive || vm.formDisabled"\n        ng-change="vm.updateChangeDelta(\'email\', vm.userDoc.email)">\n      <div ng-messages="vm.userFormObj.email.$error">\n        <div ng-if="vm.userFormObj.email.$error.required && vm.userFormObj.email.$touched">Cannot be blank</div>\n      </div>\n    </md-input-container>\n\n    <md-input-container flex="50">\n      <label>Permissions preset</label>\n      <md-select placeholder="Select a preset for this user" ng-model="vm.userDoc.typeofuser" name="typeofuser" required\n        ng-disabled="vm.userDoc.inactive || vm.typeofuserdisabled || vm.formDisabled"\n        ng-change="vm.updateChangeDelta(\'typeofuser\', vm.userDoc.typeofuser)">\n        <md-optgroup label="Available Presets">\n          <md-option ng-value="type.value"\n            ng-repeat="type in vm.availableUserPermissionsPresets">{{type.name}}</md-option>\n        </md-optgroup>\n      </md-select>\n      <div ng-messages="vm.userFormObj.typeofuser.$error">\n        <div ng-if="vm.userFormObj.typeofuser.$error.required && vm.userFormObj.typeofuser.$touched">Cannot be blank\n        </div>\n      </div>\n      <!-- <div class="hint" ng-if="vm.showHints">See permissions matrix <u>here</u></div> -->\n    </md-input-container>\n  </div>\n\n  <div ng-if="vm.isPasswordPolicyEnabled && vm.passwordFields">\n    <p class="margin-bottom-0"><b>Password Requirements:</b></p>\n    <ul ng-if="vm.isPasswordPolicyEnabled" class="margin-left-20">\n      <li class="zuantTitanium1 margin-top-0 margin-bottom-5" ng-repeat="policy in vm.activePolicy">\n        {{policy.label}} <b>{{policy.value}}</b>\n        <md-icon style="color: limegreen;" class="margin-left-5"\n          ng-if="vm.userFormObj.password.$dirty && !vm.userFormObj.password.$error[policy.key]"\n          md-font-icon="zmdi zmdi-check-circle"></md-icon>\n        <md-icon class="margin-left-5 zuantSaffron"\n          ng-if="vm.userFormObj.password.$touched && vm.userFormObj.password.$error[policy.key]"\n          md-font-icon="zmdi zmdi-close-circle"></md-icon>\n      </li>\n    </ul>\n  </div>\n\n  <ng-container ng-if="vm.passwordFields">\n    <md-input-container class="md-block">\n      <label>Password</label>\n      <input type="{{vm.passwordFieldType}}" ng-model="vm.userDoc.password"\n        ng-change="vm.checkAgainstPasswordPolicy(\'password\')" name="password" aria-label="password" required\n        focus-on-show>\n\n      <md-icon style="color:rgba(0,0,0,0.12);" md-font-icon="zmdi {{vm.passwordFieldIcon}}"\n        ng-click="vm.toggleViewPasswordField(\'password\')">\n        <md-tooltip>{{vm.passwordFieldTooltip}}</md-tooltip>\n      </md-icon>\n\n      <div ng-messages="vm.userFormObj.password.$error" role="alert">\n        <div ng-message when="required">\n          <span>Please enter a password.</span>\n        </div>\n        <div ng-message when="minLength">\n          <span>Please enter a password with a length greater than\n            <b>{{vm.activePolicy.minLength.value}}</b> characters.</span>\n        </div>\n        <div ng-message when="maxLength">\n          <span>Please enter a password with a length less than\n            <b>{{vm.activePolicy.maxLength.value}}</b> characters.</span>\n        </div>\n        <div ng-message when="minLowercase">\n          <span>Please enter a password with\n            <b>{{vm.activePolicy.minLowercase.value}}</b> or\n            more <b>LOWERCASE</b> characters.</span>\n        </div>\n        <div ng-message when="minUppercase">\n          <span>Please enter a password with\n            <b>{{vm.activePolicy.minUppercase.value}}</b> or\n            more <b>UPPERCASE</b> characters.</span>\n        </div>\n        <div ng-message when="minNumeric">\n          <span>Please enter a password with\n            <b>{{vm.activePolicy.minNumeric.value}}</b> or\n            more <b>NUMERIC</b> characters.</span>\n        </div>\n        <div ng-message when="minSymbol">\n          <span>Please enter a password with\n            <b>{{vm.activePolicy.minSymbol.value}}</b> or\n            more <b>SYMBOL</b> characters.</span>\n        </div>\n        <div ng-message when="nonMatch">\n          <span>Password does not match confirm field.</span>\n        </div>\n      </div>\n    </md-input-container>\n\n    <md-input-container class="md-block">\n      <label>Confirm Password</label>\n\n      <input type="{{vm.confirmPasswordFieldType}}" ng-model="vm.userDoc.repeatpassword"\n        ng-change="vm.checkAgainstPasswordPolicy(\'confirmPassword\')" name="confirmpassword"\n        aria-label="Confirm Password" ng-model-options="{ debounce: 800}" required>\n\n      <md-icon style="color:rgba(0,0,0,0.12);" md-font-icon="zmdi {{vm.confirmPasswordFieldIcon}}"\n        ng-click="vm.toggleViewPasswordField(\'confirmPassword\')">\n        <md-tooltip>{{vm.confirmPasswordFieldTooltip}}</md-tooltip>\n      </md-icon>\n\n      <div ng-messages="vm.userFormObj.confirmpassword.$error" role="alert">\n        <div ng-message when="required">\n          <span>Please confirm your password.</span>\n        </div>\n        <div ng-message when="nonMatch">\n          <span>Confirm field does not match password field.</span>\n        </div>\n      </div>\n    </md-input-container>\n  </ng-container>\n\n  <md-switch ng-model="vm.userDoc.permissions.trump" ng-disabled="vm.formDisabled"\n    ng-if="vm.showTrumpPermissionsControl">Trump User</md-switch>\n\n  <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n\n<p class="md-headline-1" ng-show="vm.typeofuserdisabled">The currently logged in user does not have sufficient\n  permissions to edit this user\'s user type</p>\n<p class="md-headline-1" ng-show="vm.vm.roleorcustomforuserbeingedited === \'Custom\'">This user has a custom set of\n  permissions. Please not that changing their user type will nuke their custom permissions.</p>\n\n<!-- <p class="md-headline-1" ng-show="vm.isDev">\n  The currently logged in user is\n  <strong>{{vm.session.getUserData().firstname}} {{vm.session.getUserData().surname}}</strong> and their typeofuser level is\n  <strong>{{vm.session.getUserData().typeofuser}}</strong>.\n  <br>Therefore, {{vm.session.getUserData().firstname}} should only be able to adjust the user level for the following presets:\n  <strong>\n    <span ng-repeat="preset in vm.userTypes">{{preset.value}}, </span>\n  </strong>\n  <br> {{vm.session.getUserData().firstname}} should also only be able to set their own typeOfUser level to\n  <strong>\n    <span ng-repeat="preset in vm.userTypes">{{preset.value}}, </span>.</strong>\nroleorcustomforcurrentlyloggedinuser: {{vm.roleorcustomforcurrentlyloggedinuser}} <br>\nroleorcustomforuserbeingedited: {{vm.roleorcustomforuserbeingedited}}\n</p> -->');
$templateCache.put('app/users/main/archived-users/archived-users.dialog.tmpl.html','<md-dialog aria-label="Manage Archive Users Dialog" flex="100" flex-gt-md="60" ng-cloak>\n  <md-toolbar aria-label="Unarchive users dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">Manage Archived Users</p>\n      <span flex></span>\n      <md-button ng-click="vm.hide()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-dialog-content style="width: 100%;">\n    <div layout="row" layout-fill>\n      <div flex="" layout-padding>\n        <md-input-container class="md-block">\n          <!-- Use floating placeholder instead of label -->\n          <md-icon md-font-icon="md-primary zmdi zmdi-search"></md-icon>\n          <input type="text" ng-model="search" placeholder="Search users" ng-show="vm.showSearch" focus-on-show>\n        </md-input-container>\n      </div>\n    </div>\n    <section>\n      <md-list>\n        <md-subheader class="md-no-sticky">Toggle users archive state by clicking their row</md-subheader>\n        <md-subheader class="md-no-sticky" permission permission-only="\'ZUANT_ADMIN\'">Users</md-subheader>\n        <md-list-item ng-repeat="item in vm.users | filter: search" class="md-2-line">\n          <ng-md-icon icon="{{vm.iconCheck(item.user)}}" style="fill: #888;" size="24"></ng-md-icon>\n          <div class="md-list-item-text">\n            <p> {{ item.user.firstname.filtered }} {{ item.user.surname.filtered }} </p>\n            <p> {{ item.user.email.filtered }} </p>\n          </div>\n          <md-switch class="md-secondary" ng-model="item.user.inactive.raw"\n            ng-change="vm.toggleArchiveUser(item.user)"></md-switch>\n        </md-list-item>\n      </md-list>\n    </section>\n  </md-dialog-content>\n  <md-dialog-actions layout="row">\n    <md-button class="md-warn" ng-click="vm.hide(true)">Close</md-button>\n  </md-dialog-actions>\n</md-dialog>');
$templateCache.put('app/users/main/fab/fab.tmpl.html','<zp-helper-arrow help-message="Add users to your account here" show-condition="$ctrl.blankSlate.getData().items.length == 0">\n</zp-helper-arrow>\n\n<zp-fab-add permission permission-only="$ctrl.permissions.liteFeatures.users.edit" pulse-class-check="$ctrl.blankSlate.getData().items.length == 0" dialog-config="$ctrl.customerUsersMetadata.fabDialogConfig">\n</zp-fab-add>\n');
$templateCache.put('app/users/main/search-toolbar/tmpl.html','<zp-search-toolbar metadata="$ctrl.metadata" menu-options="$ctrl.metadata.menuOptions"\n  on-menu-click="$ctrl.onMenuClick({ action: action, ev:ev })">\n</zp-search-toolbar>');
$templateCache.put('app/users/main/widget-container/widget-container.tmpl.html','<md-content layout-fill md-theme="zuantCloudSkin" theme-background="primary:hue-2" hide-xs hide-sm>\n\n  <zp-no-data ng-show="$ctrl.blankSlate.getData().items.length == 0" header="No data to see yet." subhead="Standing by."\n    svgpath="{{\'/images/svgs/utilities/theme/rocket_lagoon_002.svg\' | cdnAssets}}" fontcolor="zuantLagoonRollover"\n    svgid="submitted_leads_blank">\n  </zp-no-data>\n\n  <div layout="row" ng-show="$ctrl.blankSlate.getData().items.length">\n    <zp-count-widget flex count="$ctrl.data.activeUsers.length" label="ACTIVE USERS" icon="zmdi-accounts"\n      class="md-no-ripple">\n    </zp-count-widget>\n    <zp-count-widget flex ng-show="$ctrl.data.inactiveUsers.length" count="$ctrl.inactiveUsersCount()"\n      label="ARCHIVED USERS" icon="zmdi-archive">\n    </zp-count-widget>\n    <md-card flex>\n      <div layout-padding layout="row" layout-align="space-between center" style="min-height:100%">\n        <div layout-align="center center" layout="column">\n          <md-icon class="icn_4x" md-font-icon="zmdi zmdi-code"></md-icon>\n        </div>\n        <div layout="column" layout-align="space-between end">\n          <p flex class="font-weight-100 margin-top-0 margin-bottom-0 text-ellipsis zuantTitanium1"\n            style="font-size: 24px;word-break:break-all;">{{$ctrl.clientId()}}</p>\n          <p flex class="md-caption opacity-60 margin-top-0 margin-bottom-0 text-right">CLIENT ID</p>\n        </div>\n      </div>\n    </md-card>\n\n  </div>\n\n  <!-- <zp-active-users-chart hide-xs hide-sm hide-md></zp-active-users-chart> -->\n\n</md-content>');
$templateCache.put('app/users/main/zp-user-list/zp-user-list.tmpl.html','<md-card ng-show="$ctrl.data.items.length" flex>\n\n  <div layout-margin>\n    <p class="zp-caption margin-top-20 margin-bottom-0">{{$ctrl.title}}</p>\n  </div>\n\n  <zp-data-grid ng-cloak metadata="$ctrl.metadata" search-value="$ctrl.search.searchVal"\n    options="$ctrl.metadata.gridOptions" row-click="$ctrl.primaryAction(rowid)" widget-id="$ctrl.metadata.id">\n  </zp-data-grid>\n\n  <md-table-pagination hide-xs hide-sm class="md-table-pagination" ng-if="$ctrl.metadata.paginationOptions.pagination"\n    md-limit="$ctrl.metadata.paginationOptions.limit" md-limit-options="$ctrl.metadata.paginationOptions.limitOptions"\n    md-page="$ctrl.metadata.paginationOptions.page" md-total="{{$ctrl.totalRows}}"\n    md-page-select="$ctrl.metadata.paginationOptions.pageSelect"\n    md-boundary-links="$ctrl.metadata.paginationOptions.boundaryLinks"\n    md-on-paginate="$ctrl.logPagination(page, limit)">\n  </md-table-pagination>\n\n</md-card>');
$templateCache.put('app/showroom/literature/main/literature-cards.tmpl.html','<zp-title-toolbar></zp-title-toolbar>\n\n<div layout="row" layout-fill>\n  <md-content flex="20">\n    <literature-tree-toolbar></literature-tree-toolbar>\n    <literature-tree class="lit-library-tree" flex="grow" ng-if="vm.litsvcreference.treeInLitMode"></literature-tree>\n    <literature-tree-blocks class="lit-library-tree" flex="grow" ng-if="!vm.litsvcreference.treeInLitMode"></literature-tree-blocks>\n  </md-content>\n\n  <md-content layout-fill>\n    <md-card flex="90" flex-offset="5">\n      <div layout="row">\n        <div flex layout="column">\n          <literature-toolbar flex="none"></literature-toolbar>\n\n          <div class="fixed-scrollable literature-list">\n            <literature-filter class="literature-library-filter slideInOut" flex="none" ng-show="vm.litsvcreference.shouldTagFilterBeDisplayed"></literature-filter>\n\n            <div class="literature-message">\n              <span class="select-all-checkbox">\n                <md-checkbox flex aria-label="Select All checkbox" ng-model="vm.selectAll" class="row-checkbox" ng-change="vm.toggleSelectAll()" permission permission-only="vm.permissions.boltOns.showroom.edit" />\n              </span>\n\n              <span class="show-untagged" ng-if="vm.litsvcreference.stats.countOfLitItemsWithNoTag > 0">\n                <md-checkbox ng-model="vm.showUntagged" permission permission-only="vm.permissions.boltOns.showroom.edit">\n                  <span>Show Untagged</span>\n                </md-checkbox>\n              </span>\n\n              <span class="remove-filter" ng-if="vm.hasTagsSelected()">\n                <span class="filter-link" ng-click="vm.removeFilters()">Remove filters</span>\n              </span>\n            </div>\n            <literature-card-list class="slideInOut"></literature-card-list>\n            <!-- <literature-list flex class="slideInOut" ng-show="!vm.litsvcreference.factoryData.inCardView"></literature-list> -->\n          </div>\n        </div>\n      </div>\n    </md-card>\n  </md-content>\n</div>\n');
$templateCache.put('app/showroom/literature/main/literature-main.tmpl.html','<md-card layout="column" layout-align="start stretch" style="margin-top:0;">\n    <literature-toolbar flex="none" style="padding:10px 20px 10px 20px; min-height:20px; overflow:hidden; border-radius:5px 5px 0px 0px;"></literature-toolbar>\n\n    <div class="fixed-scrollable literature-list">\n\n      <literature-filter class="literature-library-filter" flex="none" ng-if="vm.litsvcreference.shouldTagFilterBeDisplayed"></literature-filter>\n\n      <div class="literature-message" >\n        <span class="select-all-checkbox" permission permission-only="vm.permissions.boltOns.showroom.edit">\n          <md-checkbox flex aria-label="Select All checkbox"\n             ng-model="vm.selectAll" class="row-checkbox"\n             ng-change="vm.toggleSelectAll()" />\n        </span>\n\n        <span class="show-untagged" ng-if="vm.litsvcreference.stats.countOfLitItemsWithNoTag > 0">\n          <md-checkbox ng-model="vm.showUntagged">\n            <span>Show Untagged</span>\n          </md-checkbox>\n        </span>\n\n        <span class="remove-filter" ng-if="vm.hasTagsSelected()">\n          <span class="filter-link" ng-click="vm.removeFilters()">Remove filters</span>\n        </span>\n      </div>\n\n      <literature-card-list flex></literature-card-list>\n      <!-- <literature-list flex class="slideInOut" ng-show="!vm.litsvcreference.factoryData.inCardView"></literature-list> -->\n    </div>\n</md-card>\n');
$templateCache.put('app/clients/dialogs/client-operations-dialog/data-workflow/data-workflow-field-mapping.component.tmpl.html','<md-dialog aria-label="Redact client dialog" flex="100">\n    <md-toolbar aria-label="Archive client dialog toolbar">\n        <div layout="row" class="md-toolbar-tools">\n            <p class="md-subhead">Mapping Card</p>\n            <span flex></span>\n            <md-button ng-click="$ctrl.cancelDialog()">\n                <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n            </md-button>\n        </div>\n    </md-toolbar>\n    <md-dialog-content>\n\n        <div layout-fill layout="row" layout-align="start stretch">\n            <div flex="grow" layout="column" layout-align="start stretch">\n\n                <md-content class="field-mapping-container" ng-class="$ctrl.workflowFactory.getFieldMappingClass()"\n                    layout="row" layout-align="stretch">\n                    <div class="inner-content" flex layout="column" layout-align="space-between stretch">\n                        <div layout="row" layout-align="space-around center">\n                            <p flex class="selection-description">{{$ctrl.workflowFactory.selectedStep.description}}</p>\n                            <md-button class="md-raised md-primary" ng-click="$ctrl.saveMapping()">Create &\n                                Close</md-button>\n                        </div>\n\n                        <div layout="row" layout-align="space-between stretch" flex="grow" style="max-height:100%;">\n\n                            <zp-mapping-system class="system-container"\n                                system="$ctrl.workflowFactory.mappingSystems.systemA" name="systema"\n                                sortable-options="$ctrl.workflowFactory.fieldMappingSortableOptionsA" flex="25"\n                                layout="row"></zp-mapping-system>\n                            <div layout="row" layout-align="center stretch" class="field-mapping-container-middle">\n                                <div class="mapping-row-container">\n                                    <div class="child-content" layout="column" layout-align="space-between stretch">\n                                        <div class="card-title" flex="none">\n                                            {{$ctrl.workflowFactory.selectedStep.cardName}}\n                                        </div>\n                                        <div class="card-content drop-container">\n                                            <div id="{{$index}}"\n                                                ng-repeat="row in $ctrl.workflowFactory.selectedCard.mappings"\n                                                class="mapping-row" layout="row" layout=" stretch">\n                                                <div layout="column" layout-align="center stretch" flex="35"\n                                                    class="field-drop-container systema"\n                                                    ng-class="{\'active\': row.systemA.length > 0}"\n                                                    ui-sortable="$ctrl.workflowFactory.fieldMappingSortableOptionsA"\n                                                    ng-model="row.systemA">\n                                                    <div flex ng-repeat="field in row.systemA" class="field">\n                                                        <span>{{field.friendly}}</span>\n                                                        <div class="card-action"\n                                                            ng-click="$ctrl.workflowFactory.removeFieldFromMapping(\'systemA\', $parent.$index)">\n                                                            <md-icon md-font-icon="zmdi zmdi-minus"></md-icon>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                                <div flex class="cog-container"\n                                                    ng-class="{\'activeA\': row.systemA.length > 0, \'activeB\': row.systemB.length > 0}">\n                                                    <md-icon class="cog" md-font-icon="zmdi zmdi-settings"></md-icon>\n                                                </div>\n                                                <div layout="column" layout-align="center stretch" flex="35"\n                                                    class="field-drop-container systemb"\n                                                    ng-class="{\'active\': row.systemB.length > 0}"\n                                                    ui-sortable="$ctrl.workflowFactory.fieldMappingSortableOptionsB"\n                                                    ng-model="row.systemB">\n                                                    <div ng-repeat="field in row.systemB" class="field">\n                                                        <span>{{field.friendly}}</span>\n                                                        <div class="card-action"\n                                                            ng-click="$ctrl.workflowFactory.removeFieldFromMapping(\'systemB\', $parent.$index)">\n                                                            <md-icon md-font-icon="zmdi zmdi-minus"></md-icon>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class="mapping-drop-container drop-container"\n                                            ui-sortable="$ctrl.workflowFactory.mappingRowSortableOptions"\n                                            ng-model="$ctrl.workflowFactory.selectedCard.mappings">\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <zp-mapping-system class="system-container"\n                                system="$ctrl.workflowFactory.mappingSystems.systemB" name="systemb"\n                                sortable-options="$ctrl.workflowFactory.fieldMappingSortableOptionsB" flex="25"\n                                layout="row"></zp-mapping-system>\n\n                        </div>\n                    </div>\n                </md-content>\n            </div>\n        </div>\n\n    </md-dialog-content>\n\n</md-dialog>');
$templateCache.put('app/clients/dialogs/client-operations-dialog/data-workflow/data-workflow.component.tmpl.html','<div layout-fill class="data-workflow">\n\n    <div layout="column" layout-align="stretch" class="workflow-steps">\n\n        <md-card layout="column" layout-align="space-between stretch" class="step-container"\n            ng-class="$ctrl.workflowFactory.getStepClass($ctrl.workflowFactory.selectedStep)">\n            <div layout="column" layout-align="space-between stretch">\n                <div class="card-container" layout-align="start center" layout="row"\n                    ng-show="$ctrl.workflowFactory.containerShow.selectCards && (($ctrl.workflowFactory.selectedStep.display == \'panel\' && $ctrl.workflowFactory.selectedStep.cards.length > 0) || $ctrl.workflowFactory.selectedStep.display != \'panel\')">\n                    <zp-card card="card" show-remove="!$ctrl.workflowFactory.containerShow.zubotActivated"\n                        open-card-selection-call-back="$ctrl.onCardPopulated()"\n                        ng-repeat="card in $ctrl.workflowFactory.selectedStep.cards" class="card"></zp-card>\n\n                    <div class="new-card" layout="column"\n                        ng-click="$ctrl.workflowFactory.openCardSelection(null, $ctrl.onCardPopulated)"\n                        ng-show="!($ctrl.workflowFactory.selectedStep.cards.length > 0 && $ctrl.workflowFactory.selectedStep.singleCard) && !$ctrl.workflowFactory.containerShow.zubotActivated">\n                        <div flex="grow" layout="column" layout-align="space-between stretch">\n                            <md-icon md-font-icon="zmdi zmdi-plus-circle-o"></md-icon>\n                            <p flex>{{$ctrl.workflowFactory.selectedStep.newText}} <span\n                                    ng-show="$ctrl.workflowFactory.selectedStep.cardOptional"><br />(this\n                                    is optional)</span></p>\n                        </div>\n                    </div>\n                </div>\n\n            </div>\n\n        </md-card>\n\n    </div>\n</div>');
$templateCache.put('app/clients/email-templates/main/zp-add-client-email-template-fab/zp-add-client-email-template-fab.tmpl.html','<zp-fab-add pulse-class-check="!$ctrl.data.items.length" dialog-config="$ctrl.metadata.fabDialogConfig"></zp-fab-add>');
$templateCache.put('app/clients/email-templates/main/zp-client-email-template-list/zp-client-email-template-list.tmpl.html','<md-content flex layout="row" layout-gt-md="row" ng-cloak layout-align="start start" layout-fill>\n  <md-card flex ng-show="$ctrl.data.items.length">\n\n    <zp-data-grid ng-cloak data="$ctrl.data" metadata="$ctrl.metadata" search-value="$ctrl.search.searchVal"\n      options="$ctrl.metadata.gridOptions" row-click="$ctrl.goto(rowid)" widget-id="$ctrl.metadata.id">\n    </zp-data-grid>\n\n    <md-table-pagination hide-xs hide-sm class="md-table-pagination" ng-if="$ctrl.metadata.paginationOptions.pagination"\n      md-limit="$ctrl.metadata.paginationOptions.limit" md-limit-options="$ctrl.metadata.paginationOptions.limitOptions"\n      md-page="$ctrl.metadata.paginationOptions.page" md-total="{{$ctrl.totalRows}}"\n      md-page-select="$ctrl.metadata.paginationOptions.pageSelect"\n      md-boundary-links="$ctrl.metadata.paginationOptions.boundaryLinks"\n      md-on-paginate="$ctrl.logPagination(page, limit)">\n    </md-table-pagination>\n  </md-card>\n\n  <!-- blank slate card -->\n  <div flex ng-show="$ctrl.blankSlate" layout-padding layout="row" layout-align="center center">\n    <zp-no-data ng-show="$ctrl.blankSlate" header="Currently no client email templates in your account"\n      subhead="Create client email templates using plus button" body="" svgpath="" fontcolor="zuantLagoonRollover"\n      svgid="">\n    </zp-no-data>\n  </div>\n\n</md-content>\n\n<md-card layout-padding>\n  <p class="faded-text md-subhead" style="margin-bottom: 0px;">Helpful tips</p>\n\n  <div flex layout="row" layout-wrap="">\n    <div flex="50" class="md-body-1 margin-bottom-5">\n      <md-icon class="zuantAqua">\n        contact_mail\n      </md-icon>\n      <span class="faded-text">\n        Active Local Welcome Email Template\n      </span>\n    </div>\n\n    <div flex="50" class="md-body-1 margin-bottom-5">\n      <md-icon class="zuantSaffron">\n        contact_mail\n      </md-icon>\n      <span class="faded-text">\n        Inactive Local Welcome Email Template\n      </span>\n    </div>\n\n    <div flex="50" class="md-body-1 margin-bottom-5">\n      <md-icon class="zuantAqua">\n        public\n      </md-icon>\n      <span class="faded-text">\n        Active Global Welcome Email Template\n      </span>\n    </div>\n\n    <div flex="50" class="md-body-1 margin-bottom-5">\n      <md-icon class="zuantSaffron">\n        public\n      </md-icon>\n      <span class="faded-text">\n        Inactive Global Welcome Email Template\n      </span>\n    </div>\n\n    <div flex="50" class="md-body-1 margin-bottom-5">\n      <md-icon class="zuantAqua">\n        password\n      </md-icon>\n      <span class="faded-text">\n        Active Local Password Reset Email Template\n      </span>\n    </div>\n\n    <div flex="50" class="md-body-1 margin-bottom-5">\n      <md-icon class="zuantSaffron">\n        password\n      </md-icon>\n      <span class="faded-text">\n        Inactive Local Password Reset Email Template\n      </span>\n    </div>\n\n    <div flex="50" class="md-body-1 margin-bottom-5">\n      <md-icon class="zuantAqua">\n        vpn_lock\n      </md-icon>\n      <span class="faded-text">\n        Active Global Password Reset Email Template\n      </span>\n    </div>\n\n    <div flex="50" class="md-body-1 margin-bottom-5">\n      <md-icon class="zuantSaffron">\n        vpn_lock\n      </md-icon>\n      <span class="faded-text">\n        Inactive Global Password Reset Email Template\n      </span>\n    </div>\n\n  </div>\n</md-card>');
$templateCache.put('app/clients/email-templates/main/zp-client-email-template-select-control/zp-client-email-template-select-control.tmpl.html','<div>\n  <md-autocomplete md-no-cache="true" md-selected-item="$ctrl.selectedItem" md-search-text="$ctrl.searchText"\n    md-selected-item-change="$ctrl.onChangeLocal({ item: item })" md-items="item in $ctrl.querySearch($ctrl.searchText)"\n    md-item-text="item.title" md-min-length="0" placeholder="{{$ctrl.config.placeholder}}" aria-label="Select control"\n    md-floating-label="{{$ctrl.config.floatingLabel}}" md-menu-class="autocomplete-custom-template"\n    ng-required="{{$ctrl.config.required}}" md-input-name="{{$ctrl.config.name}}" md-require-match="true"\n    md-select-on-match="true" md-clear-button="!$ctrl.ddisabled" ng-disabled="$ctrl.ddisabled">\n    <md-item-template>\n      <span class="item-title">\n\n        <ng-container ng-switch="item.type">\n          <md-icon class="zuantAqua" ng-switch-when="welcome_template_active">\n            contact_mail\n          </md-icon>\n\n          <md-icon class="zuantSaffron" ng-switch-when="welcome_template_inactive">\n            contact_mail\n          </md-icon>\n\n          <md-icon class="zuantAqua" ng-switch-when="password_reset_template_active">\n            password\n          </md-icon>\n\n          <md-icon class="zuantSaffron" ng-switch-when="password_reset_template_inactive">\n            password\n          </md-icon>\n\n          <md-icon class="zuantAqua" ng-switch-when="global_welcome_template_active">\n            public\n          </md-icon>\n\n          <md-icon class="zuantSaffron" ng-switch-when="global_welcome_template_inactive">\n            public\n          </md-icon>\n\n          <md-icon class="zuantAqua" ng-switch-when="global_password_reset_template_active">\n            vpn_lock\n          </md-icon>\n\n          <md-icon class="zuantSaffron" ng-switch-when="global_password_reset_template_inactive">\n            vpn_lock\n          </md-icon>\n        </ng-container>\n\n        <span md-highlight-text="searchText" md-highlight-flags="^i">\n          {{item.title}}\n        </span>\n      </span>\n    </md-item-template>\n    <md-not-found>\n      No items matching "{{searchText}}" were found.\n    </md-not-found>\n    <div class="errors" ng-messages="$ctrl.formname[$ctrl.config.title].$error">\n      <div ng-message="required">Required</div>\n    </div>\n  </md-autocomplete>\n</div>');
$templateCache.put('app/clients/email-templates/main/zp-client-email-templates-search-toolbar/zp-client-email-templates-search-toolbar.component.tmpl.html','<zp-search-toolbar metadata="$ctrl.metadata">\n</zp-search-toolbar>');
$templateCache.put('app/clients/email-templates/main/zp-client-email-templates-widget-container/zp-client-email-templates-widget-container.tmpl.html','<md-content layout-fill md-theme="zuantCloudSkin" theme-background="primary:hue-2" hide-xs hide-sm>\n\n  <div>\n\n    <div layout="row" layout-wrap>\n\n      <zp-count-widget flex-lg="50" flex="33" count="$ctrl.data.items.length" label="EMAIL TEMPLATES"\n        icon="zmdi-mail-send" loading="$ctrl.loading">\n      </zp-count-widget>\n\n      <zp-count-widget ng-click="$ctrl.toggleReportSize()" flex-lg="50" flex="33" count="$ctrl.chartInfo.weektotal"\n        label="{{$ctrl.weekTotalWidgetTitle}}" icon="zmdi-calendar" loading="$ctrl.loading">\n      </zp-count-widget>\n\n      <zp-count-widget ng-click="$ctrl.toggleReportSize()" flex-lg="100" flex="33" count="$ctrl.chartInfo.total"\n        label="{{$ctrl.chartInfo.metadata.subtitle}}" icon="zmdi-time-restore" loading="$ctrl.loading">\n      </zp-count-widget>\n\n    </div>\n\n    <md-card class="chart-card" hide-xs hide-sm hide-md>\n\n      <md-card-header>\n\n        <md-card-header-text>\n          <span class="md-title" ng-show="$ctrl.showTitle">{{$ctrl.chartInfo.metadata.title}}</span>\n          <span class="md-subhead">{{$ctrl.chartInfo.metadata.subtitle}}</span>\n        </md-card-header-text>\n\n        <zp-widget-context-menu\n          menu-item-clicked="$ctrl.changeChartRange({event: event, selectedMenuItem: selectedMenuItem})"\n          selected-item="$ctrl.currentSchema" menu-options="$ctrl.aggregatedResponses.menuOptions">\n        </zp-widget-context-menu>\n\n      </md-card-header>\n\n      <md-card-content layout-align="center center" layout="column" flex>\n\n        <div ng-show="$ctrl.showCustomDates" layout="row">\n\n          <form name="$ctrl.chartController">\n            Select start and end dates for the chart\n\n            <div layout="row" flex>\n\n              <md-input-container style="margin: 0px;" flex>\n\n                <md-datepicker flex ng-model="$ctrl.customRange.startdate" md-placeholder="Start date"\n                  md-open-on-focus="true" ng-change="$ctrl.applyCustomDates()" name="startdate"\n                  md-max-date="$ctrl.customRange.enddate" md-min-date="$ctrl.mindate" md-mode="{{$ctrl.pickerSchema}}"\n                  md-current-view="{{$ctrl.pickerSchema}}" required>\n                </md-datepicker>\n\n                <div ng-messages="$ctrl.chartController.startdate.$error">\n                  <div ng-message="valid">The entered value is not a date!</div>\n                  <div ng-message="mindate">Your start date is not in the correct format.</div>\n                  <div ng-message="maxdate">The entered value is greater than the available date boundaries</div>\n                  <div ng-message="required">This date is required!</div>\n                </div>\n\n              </md-input-container>\n\n              <md-input-container style="margin: 0px;" flex>\n\n                <md-datepicker flex ng-model="$ctrl.customRange.enddate" ng-change="$ctrl.applyCustomDates()"\n                  md-placeholder="End date" md-open-on-focus="true" md-min-date="$ctrl.customRange.startdate"\n                  md-max-date="$ctrl.customRange.maxdate" name="enddate" md-mode="{{$ctrl.pickerSchema}}"\n                  md-current-view="{{$ctrl.pickerSchema}}" required>\n                </md-datepicker>\n\n                <div ng-messages="$ctrl.chartController.enddate.$error">\n                  <div ng-message="valid">The entered value is not a date!</div>\n                  <div ng-message="mindate">Your start date is not in the correct format.</div>\n                  <div ng-message="maxdate">The entered value is greater than the available date boundaries</div>\n                  <div ng-message="required">This date is required!</div>\n                </div>\n              </md-input-container>\n\n              <md-button class="md-icon-button" ng-click="$ctrl.showCustomDates = false">\n                <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dates"></md-icon>\n              </md-button>\n\n            </div>\n\n          </form>\n\n        </div>\n\n        <md-progress-circular ng-if="$ctrl.loading" class="md-accent" md-mode="indeterminate"></md-progress-circular>\n\n        <zp-chart ng-show="!$ctrl.loading" layout-fill flex chartid="{{$ctrl.aggregatedResponses.chartId}}"\n          chart-data="$ctrl.chartInfo.data" chart-series="$ctrl.chartInfo.series" chart-labels=" $ctrl.chartInfo.labels"\n          chart-type="$ctrl.chartInfo.chartType" chart-options="$ctrl.chartInfo.chartOptions"\n          loading="$ctrl.bucketLoading"></zp-chart>\n\n      </md-card-content>\n    </md-card>\n  </div>\n\n</md-content>');
$templateCache.put('app/clients/email-templates/main/dialog/add-client-email-template-dialog.tmpl.html','<md-dialog aria-label="Add new template dialog" flex="100" flex-gt-md="60">\n  <md-toolbar aria-label="Create template dialog toolbar">\n    <div class="md-toolbar-tools">\n      <p class="md-subhead">New email template</p>\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-dialog-content layout-padding>\n    <form name="vm.emailTemplateForm" novalidate flex="100">\n\n      <md-list flex="80" flex-offset="10">\n\n        <md-subheader>Step 1: Begin by giving your template a title.</md-subheader>\n\n        <md-list-item style="margin-top: 30px;">\n          <md-input-container class="md-block" flex>\n            <label>Template title</label>\n            <input type="text" ng-model="vm.templateDoc.title" name="title" aria-label="Template title"\n              ng-change="vm.templateTitleChanged()" required md-autofocus />\n            <div ng-messages="vm.emailTemplateForm.title.$error" md-auto-hide="false"\n              ng-show="vm.emailTemplateForm.title.$touched">\n              <div ng-message="required">\n                <spanPlease give your template a title.</span>\n              </div>\n              <div ng-message="templateTitleExists">A template with that title already exists</div>\n            </div>\n          </md-input-container>\n        </md-list-item>\n\n        <md-list-item ng-if="vm.templateSource === \'new\'">\n          <md-input-container class="md-block" flex>\n            <label>Email subject</label>\n            <input type="text" ng-model="vm.templateDoc.emailtemplatesubject" name="subject" aria-label="Email subject"\n              required />\n            <div ng-messages="vm.emailTemplateForm.subject.$error" md-auto-hide="false"\n              ng-show="vm.emailTemplateForm.subject.$touched">\n              <div ng-message when="required">\n                <spanPlease give your template a subject</span>\n              </div>\n            </div>\n          </md-input-container>\n        </md-list-item>\n\n        <md-subheader>Step 2: Select the type of template you wish to create.</md-subheader>\n\n        <md-list-item style="margin-top: 30px;">\n          <md-input-container class="md-block" flex>\n            <label>Template Type</label>\n            <md-select required class="md-select-form" name="type" ng-model="vm.templateDoc.type"\n              placeholder="Select template type">\n              <md-option ng-value="type.value" ng-repeat="type in vm.templateOptionTypes">{{type.name}}</md-option>\n            </md-select>\n            <div ng-messages="vm.emailTemplateForm.type.$error" md-auto-hide="false"\n              ng-show="vm.emailTemplateForm.type.$touched">\n              <div ng-message when="required">\n                <spanPlease select the type for this template.</span>\n              </div>\n            </div>\n          </md-input-container>\n        </md-list-item>\n\n        <md-subheader>Step 3: Select if you wish to reuse an existing template\'s html & subject.</md-subheader>\n\n        <md-list-item style="margin-top: 30px;" ng-if="vm.clientEmailTemplates.length > 0">\n          <md-button class="md-primary zp-off-white-bg" ng-class="{\'md-raised md-primary\': vm.templateSource == \'new\'}"\n            ng-click="vm.templateSource = \'new\'" flex>New template</md-button>\n          <md-button class="md-primary zp-off-white-bg" ng-disabled="!vm.clientEmailTemplates.length"\n            ng-class="{\'md-raised md-primary\': vm.templateSource == \'clone\'}" ng-click="vm.templateSource = \'clone\'"\n            flex>Clone template</md-button>\n        </md-list-item>\n\n        <div ng-if="vm.templateSource == \'clone\'">\n          <md-list-item style="margin-top: 25px;">\n            <zp-client-email-template-select-control flex="100" model="vm.emailTemplateForm.cloneSourceTemplate"\n              on-change="vm.setCloneTemplateId({item: item})" config="vm.emailTemplateConfig"\n              items="vm.clientEmailTemplates">\n            </zp-client-email-template-select-control>\n          </md-list-item>\n        </div>\n      </md-list>\n\n      <input type="hidden" name="CSRFToken" value="1231234567890" />\n    </form>\n\n    <md-dialog-actions layout="row">\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        Cancel\n      </md-button>\n      <md-button ng-click="vm.submit()" ng-disabled="vm.submitBtnDisabled || vm.emailTemplateForm.$invalid"\n        aria-label="Create template">\n        Save\n      </md-button>\n    </md-dialog-actions>\n  </md-dialog-content>\n</md-dialog>');
$templateCache.put('app/clients/email-templates/detail/zp-client-email-template/zp-client-email-template.tmpl.html','<md-button style="margin-left: 15px;" ng-click="$ctrl.goBack()" class="md-primary">\n    BACK\n</md-button>');
$templateCache.put('app/clients/email-templates/detail/zp-client-email-template-editor/zp-client-email-template-editor.tmpl.html','<zp-client-email-template-navigation root-state-path="{{$ctrl.rootStatePath}}"></zp-client-email-template-navigation>\n<md-card layout-margin>\n  <textarea zp-ck-editor plugins="$ctrl.editorPlugins" id="emailContentTextArea"\n    ng-model="$ctrl.emailTemplate.emailtemplatetext" ng-change="$ctrl.editorChange()" aria-label="ck-editor textarea"\n    ng-readonly="!$ctrl.isClientMarketpoint && $ctrl.emailTemplate.global"></textarea>\n</md-card>\n\n<md-card layout-padding>\n  <p class="faded-text md-subhead" style="margin-bottom: 0px;">Helpful tips</p>\n  <p class="md-body-1">\n    <img width="20px" ng-src="{{\'/images/pngs/icons/ckeditor/logo_icn.png\' | cdnAssets}}" />\n    <span class="faded-text md-body-1">\n      adds the account logo to the template\n    </span>\n    <br>\n    <br>[P]\n    <span class="faded-text">\n      adds a mail-merge field. Choose from: company.name, user.email, user.password, user.firstname, user.surname\n    </span>\n  </p>\n</md-card>');
$templateCache.put('app/clients/email-templates/detail/zp-client-email-template-insights/zp-client-email-template-insights.tmpl.html','<zp-client-email-template-navigation root-state-path="{{$ctrl.rootStatePath}}"></zp-client-email-template-navigation>\n\n<md-content>\n  <div layout="column" layout-gt-md="row">\n\n    <md-card style="min-width: 60vw;" flex-order="2" flex="75" flex-gt-lg="60" flex-offset-gt-lg="10" flex-order-lg="1"\n      flex-order-gt-lg="1">\n\n      <md-card-header>\n\n        <md-card-avatar>\n          <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-email"></md-icon>\n        </md-card-avatar>\n\n        <md-card-header-text>\n          <span class="md-title">Email Sends</span>\n          <span class="md-subhead">{{$ctrl.chartInfo.metadata.title}}</span>\n        </md-card-header-text>\n\n        <zp-widget-context-menu\n          menu-item-clicked="$ctrl.changeChartRange({event: event, selectedMenuItem: selectedMenuItem})"\n          menu-options="$ctrl.aggregatedResponses.menuOptions">\n        </zp-widget-context-menu>\n\n      </md-card-header>\n\n      <md-card-content layout-align="center center" layout="column">\n\n        <md-progress-circular ng-if="$ctrl.loading" class="md-accent" md-mode="indeterminate"></md-progress-circular>\n\n        <div ng-show="$ctrl.showCustomDates">\n\n          <form name="$ctrl.chartController">\n            Select start and end dates for the chart\n\n            <div layout="row" flex>\n\n              <md-input-container style="margin: 0px;" flex>\n\n                <md-datepicker flex ng-model="$ctrl.customRange.startdate" md-placeholder="Start date"\n                  md-open-on-focus="true" ng-change="$ctrl.applyCustomDates()" name="startdate"\n                  md-max-date="$ctrl.customRange.enddate" md-min-date="$ctrl.mindate" md-mode="{{$ctrl.pickerSchema}}"\n                  md-current-view="{{$ctrl.pickerSchema}}" required>\n                </md-datepicker>\n\n                <div ng-messages="$ctrl.chartController.startdate.$error">\n\n                  <div ng-message="valid">The entered value is not a date!</div>\n                  <div ng-message="mindate">Your start date is not in the correct format.</div>\n                  <div ng-message="maxdate">The entered value is greater than the available date boundaries</div>\n                  <div ng-message="required">This date is required!</div>\n\n                </div>\n\n              </md-input-container>\n\n              <md-input-container style="margin: 0px;" flex>\n\n                <md-datepicker flex ng-model="$ctrl.customRange.enddate" ng-change="$ctrl.applyCustomDates()"\n                  md-placeholder="End date" md-open-on-focus="true" md-min-date="$ctrl.customRange.startdate"\n                  md-max-date="$ctrl.customRange.maxdate" name="enddate" md-mode="{{$ctrl.pickerSchema}}"\n                  md-current-view="{{$ctrl.pickerSchema}}" required>\n                </md-datepicker>\n\n                <div ng-messages="$ctrl.chartController.enddate.$error">\n\n                  <div ng-message="valid">The entered value is not a date!</div>\n                  <div ng-message="mindate">Your start date is not in the correct format.</div>\n                  <div ng-message="maxdate">The entered value is greater than the available date boundaries</div>\n                  <div ng-message="required">This date is required!</div>\n\n                </div>\n\n              </md-input-container>\n\n              <md-button class="md-icon-button" ng-click="$ctrl.showCustomDates = false">\n                <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dates"></md-icon>\n              </md-button>\n\n            </div>\n\n          </form>\n\n        </div>\n\n        <zp-chart ng-show="!$ctrl.loading" layout-fill flex chartid="{{$ctrl.aggregatedResponses.chartId}}"\n          chart-data="$ctrl.chartInfo.data" chart-series="$ctrl.chartInfo.series" chart-labels="$ctrl.chartInfo.labels"\n          chart-type="$ctrl.chartInfo.chartType" chart-options="$ctrl.chartInfo.chartOptions"\n          loading="$ctrl.bucketLoading">\n        </zp-chart>\n\n      </md-card-content>\n\n    </md-card>\n\n    <div layout="row" flex="25" layout-wrap flex-order-gt-sm="1" flex-order="2" flex-order-gt-md="1">\n\n      <zp-count-widget flex-sm="50" flex-md="25" flex-lg="50" flex-gt-lg="30" flex="100" count="$ctrl.chartInfo.total"\n        label="TOTAL SENDS" icon="zmdi-mail-send">\n      </zp-count-widget>\n\n      <zp-count-widget flex-sm="50" flex-md="25" flex-lg="50" flex-gt-lg="30" flex="100"\n        ng-show="$ctrl.chartInfo.events.delivered > 0" count="$ctrl.chartInfo.events.delivered" label="DELIVERED"\n        icon="zmdi-inbox">\n      </zp-count-widget>\n\n      <zp-count-widget flex-sm="50" flex-md="25" flex-lg="50" flex-gt-lg="30" flex="100"\n        ng-show="$ctrl.chartInfo.events.opened > 0" count="$ctrl.chartInfo.events.opened" label="OPENED"\n        icon="zmdi-email-open">\n      </zp-count-widget>\n\n      <zp-count-widget flex-sm="50" flex-md="25" flex-lg="50" flex-gt-lg="30" flex="100"\n        ng-show="$ctrl.chartInfo.events.clicked > 0" count="$ctrl.chartInfo.events.clicked" label="CLICKED"\n        icon="zmdi-mouse">\n      </zp-count-widget>\n\n      <!-- <zp-count-widget flex-sm="50" flex-md="25" flex-gt-xl="30" flex="100" count="$ctrl.chartInfo.events.unsubscribed" label="UNSUBSCRIBED" icon="zmdi-thumb-down"> </zp-count-widget> -->\n      <!-- <zp-count-widget flex-sm="50" flex-md="25" flex-gt-xl="30" flex="100" count="$ctrl.chartInfo.events.complained" label="COMPLAINED" icon="zmdi-flag"> </zp-count-widget> -->\n\n      <zp-count-widget flex-sm="50" flex-md="25" flex-lg="50" flex-gt-lg="30" flex="100"\n        ng-show="$ctrl.chartInfo.events.failed > 0" count="$ctrl.chartInfo.events.failed" label="FAILED"\n        icon="zmdi-alert-triangle">\n      </zp-count-widget>\n\n      <zp-count-widget flex-sm="50" flex-md="25" flex-lg="50" flex-gt-lg="30" flex="100"\n        ng-show="$ctrl.chartInfo.events.temporary_fail > 0" count="$ctrl.chartInfo.events.temporary_fail"\n        label="TEMP FAIL" icon="zmdi-alert-triangle">\n      </zp-count-widget>\n\n      <zp-count-widget flex-sm="50" flex-md="25" flex-lg="50" flex-gt-lg="30" flex="100"\n        ng-show="$ctrl.chartInfo.events.permanent_fail > 0" count="$ctrl.chartInfo.events.permanent_fail"\n        label="PERM FAIL" icon="zmdi-alert-polygon">\n      </zp-count-widget>\n\n    </div>\n\n  </div>\n\n</md-content>');
$templateCache.put('app/clients/email-templates/detail/fab/fab.tmpl.html','<zp-save-button ng-if="$ctrl.changeDelta.isDirty()" isfab="\'true\'" label="\'save template fab\'"\n    isdirty="$ctrl.changeDelta.isDirty()" save="$ctrl.save()" disabled="$ctrl.saveDisabled"></zp-save-button>');
$templateCache.put('app/clients/email-templates/detail/zp-client-email-template-settings/zp-client-email-template-settings.tmpl.html','<zp-client-email-template-navigation root-state-path="{{$ctrl.rootStatePath}}"></zp-client-email-template-navigation>\n<md-content layout-fill layout="column" syle="height: 100%; overflow: auto;">\n  <div flex layout-xs="column" layout-sm="column" layout-md="column" layout="row">\n    <div layout-padding flex flex-gt-md="65" flex-order="1">\n      <md-card layout-padding>\n        <form name="$ctrl.settingsForm" id="" novalidate role="form" confirm-on-exit>\n          <div layout="row" layout-align="end center">\n            <zp-delete-button label="\'delete template\'"\n              disabled="$ctrl.clientEmailTemplate.global || ($ctrl.isClientMarketpoint && $ctrl.clientEmailTemplate.active)"\n              isdirty="$ctrl.changeDelta.isDirty()" on-click="$ctrl.deleteTemplate()">\n            </zp-delete-button>\n\n            <zp-save-button label="\'save template\'"\n              disabled="(!$ctrl.isClientMarketpoint && $ctrl.clientEmailTemplate.global) || $ctrl.settingsForm.$invalid"\n              isdirty="$ctrl.changeDelta.isDirty()" save="$ctrl.save($event)">\n            </zp-save-button>\n          </div>\n          <div layout="column">\n            <md-input-container>\n              <label>Template title</label>\n              <input name="title" ng-model="$ctrl.clientEmailTemplate.title"\n                ng-change="$ctrl.updateChangeDelta(\'title\', $ctrl.clientEmailTemplate.title)" required\n                ng-attr-autofocus="true" ng-disabled="!$ctrl.isClientMarketpoint && $ctrl.clientEmailTemplate.global">\n              <div ng-messages="$ctrl.settingsForm.title.$error" ng-show="$ctrl.settingsForm.title.$error.required"\n                ng-if="$ctrl.settingsForm.title.$touched">\n                <div ng-message="required">Email templates require a title</div>\n              </div>\n            </md-input-container>\n\n            <div flex layout="column" class="template-type-container">\n              <label>Template type</label>\n              <div class="template-type-border-container">\n                <div layout="row" layout-align="start center">\n                  <md-icon\n                    ng-class="{ zuantAqua: $ctrl.clientEmailTemplate.active === 1 , zuantSaffron: $ctrl.clientEmailTemplate.active === 0 }">\n                    {{$ctrl.prettyTemplateLogo}}\n                  </md-icon>\n                  <span>{{$ctrl.prettyTemplateName}}</span>\n                </div>\n              </div>\n              <div style="margin-bottom: 10px;"></div>\n            </div>\n\n            <md-input-container show-errors>\n              <label>Email subject</label>\n              <input name="subjectField" ng-model="$ctrl.clientEmailTemplate.emailtemplatesubject"\n                ng-change="$ctrl.updateChangeDelta(\'emailtemplatesubject\', $ctrl.clientEmailTemplate.emailtemplatesubject)"\n                aria-label="subject" required\n                ng-disabled="!$ctrl.isClientMarketpoint && $ctrl.clientEmailTemplate.global">\n              <div ng-messages="$ctrl.settingsForm.subjectField.$error"\n                ng-show="$ctrl.settingsForm.subjectField.$error.required"\n                ng-if="$ctrl.settingsForm.subjectField.$touched">\n                <div ng-message="required">Email templates require a subject field</div>\n              </div>\n            </md-input-container>\n            <p>Template status:</p>\n            <div class="zuantSaffron"\n              ng-if="$ctrl.isClientMarketpoint && $ctrl.clientEmailTemplate.active && !$ctrl.changes.emailtemplates[$ctrl.lastSavedStateOfEmailTemplate._id].active">\n              A single active template is required for global {{ $ctrl.clientEmailTemplate.type ===\n              \'welcome_template\' ? \'welcome\' : \'password reset\' }} email templates. Consequently, you cannot\n              deactivate\n              this template; you must activate an alternative {{ $ctrl.clientEmailTemplate.type ===\n              \'welcome_template\' ? \'welcome\' : \'password reset\' }} email template, which will automatically\n              deactivate the current one.\n            </div>\n\n            <md-list-item>\n              Active:\n              <md-switch class="md-secondary" aria-label="Active" ng-true-value=1 ng-false-value=0\n                ng-model="$ctrl.clientEmailTemplate.active"\n                ng-change="$ctrl.updateChangeDelta(\'active\', $ctrl.clientEmailTemplate.active)"\n                ng-disabled="$ctrl.isClientMarketpoint && $ctrl.clientEmailTemplate.active && !$ctrl.changes.emailtemplates[$ctrl.lastSavedStateOfEmailTemplate._id].active"></md-switch>\n            </md-list-item>\n\n            <div style="padding: 0px 16px" class="hint"\n              ng-if="!$ctrl.clientEmailTemplate.active || ($ctrl.clientEmailTemplate.active && $ctrl.changes.emailtemplates[$ctrl.lastSavedStateOfEmailTemplate._id].active)">\n              Only a single template can be active at one time. If there is already an active template associated with\n              the account, activating the new template will automatically deactivate the existing one.\n            </div>\n          </div>\n          <input type="hidden" name="CSRFToken" value="1231234567890" />\n        </form>\n      </md-card>\n    </div>\n\n    <div flex flex-order="2">\n\n      <div layout-padding layout-xs="column" layout-gt-md="column" layout="row">\n\n        <md-card layout-padding flex layout="row" layout-align="space-between center">\n          <div>\n            <md-icon class="icn_4x" md-font-icon="zmdi zmdi-mail-send"></md-icon>\n          </div>\n          <div layout="column" layout-align="center end">\n            <p class="md-headline font-weight-100 margin-top-0 margin-bottom-0 text-ellipsis">SEND TEST</p>\n            <p class="text-right">\n              Last test sent:\n\n              <span\n                ng-if="$ctrl.clientEmailTemplate._lastTestEmailSentDate && $ctrl.clientEmailTemplate._lastTestEmailSentDate != \'\'">\n                {{$ctrl.clientEmailTemplate._lastTestEmailSentDate | zpMomentFromNow }}\n              </span>\n\n              <span ng-if="!$ctrl.clientEmailTemplate._lastTestEmailSentDate">\n                NEVER\n              </span>\n            </p>\n            <md-button aria-label="Click to send" class="md-button md-primary" ng-click="$ctrl.sendTestEmail()">Click\n              to\n              Send</md-button>\n          </div>\n        </md-card>\n\n      </div>\n    </div>\n  </div>\n</md-content>');
$templateCache.put('app/clients/teams/dialogs/add-users/dialog.tmpl.html','<md-dialog aria-label="Create new team dialog" flex="100" flex-gt-md="60" class="add-user-team-dialog">\n\n  <form>\n\n    <md-toolbar>\n\n      <div class="md-toolbar-tools">\n\n        <p class="md-title">\n          Add Users to {{vm.team.name}}\n        </p>\n\n        <span flex></span>\n\n        <md-button class="md-icon-button" ng-click="vm.cancel()">\n\n          <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog">\n          </md-icon>\n\n        </md-button>\n\n      </div>\n\n    </md-toolbar>\n\n    <md-dialog-content>\n\n      <div layout-padding layout="column">\n\n        <md-input-container flex class="filter">\n\n          <label style="margin-left: 5px">\n            Filter\n          </label>\n\n          <input type="text" ng-model="vm.filter" md-autofocus />\n\n        </md-input-container>\n\n        <div>\n\n          <div layout="row" class="header">\n\n            <div flex="grow" class="user">\n            </div>\n\n            <div class="checkbox-column">\n\n              Private Leads <u>?</u>\n\n              <md-tooltip md-direction="top">\n                Private Leads will hide leads from other team members\n              </md-tooltip>\n\n            </div>\n\n            <div class="checkbox-column">\n              Manager\n            </div>\n\n          </div>\n\n          <div layout="row">\n\n            <md-checkbox ng-model="vm.userSelectAll" ng-change="vm.selectAllUsers()"\n              aria-label="select all users checkbox">\n            </md-checkbox>\n\n            <div flex="grow" class="light">\n              Select All\n            </div>\n\n            <div class="checkbox-column">\n\n              <md-checkbox aria-label="private select all" ng-model="vm.privateSelectAll"\n                ng-change="vm.setAllMembersFlag(\'private\', vm.privateSelectAll)">\n              </md-checkbox>\n\n            </div>\n            <div class="checkbox-column">\n\n              <md-checkbox aria-label="manager select all" ng-model="vm.managerSelectAll"\n                ng-change="vm.setAllMembersFlag(\'manager\', vm.managerSelectAll)">\n              </md-checkbox>\n\n            </div>\n\n          </div>\n\n          <div ng-repeat="user in vm.users | filter: {name: vm.filter}" layout="row">\n\n            <md-checkbox ng-model="user.selected" ng-change="vm.checkSelectAllState(user)" ng-disabled="user.disabled"\n              aria-label="select user checkbox">\n            </md-checkbox>\n\n            <div ng-click="vm.selectUser(user)" style="line-height:18px;" flex="grow">\n\n              {{user.name}}\n\n            </div>\n\n            <div class="checkbox-column">\n\n              <md-checkbox aria-label="private" ng-model="user.private" ng-disabled="user.disabled">\n              </md-checkbox>\n\n            </div>\n\n            <div class="checkbox-column"><md-checkbox aria-label="manager" ng-model="user.manager"\n                ng-disabled="user.disabled"></md-checkbox>\n            </div>\n\n          </div>\n\n        </div>\n\n      </div>\n\n    </md-dialog-content>\n\n    <md-dialog-actions layout="row">\n\n      <span flex></span>\n      <md-button ng-click="vm.done()" aria-label="Done" class="md-primary md-raised">\n        Add Users\n      </md-button>\n\n    </md-dialog-actions>\n\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n\n  </form>\n\n</md-dialog>');
$templateCache.put('app/clients/teams/dialogs/edit-team/dialog.tmpl.html','<md-dialog aria-label="Edit team dialog" flex="100" flex-gt-md="60" class="edit-team-dialog">\n\n  <form>\n\n    <md-toolbar>\n\n      <div class="md-toolbar-tools">\n\n        <p class="md-title edit-team-title">\n          Edit Team {{vm.originalName}}\n        </p>\n\n        <span flex></span>\n\n        <md-button class="md-icon-button" ng-click="vm.cancel()">\n          <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog">\n          </md-icon>\n\n        </md-button>\n\n      </div>\n\n    </md-toolbar>\n\n    <md-dialog-content>\n\n      <div layout-padding layout="column">\n\n        <md-input-container flex>\n\n          <label style="margin-left: 5px">\n            Name\n          </label>\n\n          <input type="text" ng-model="vm.team.name" md-autofocus required />\n\n        </md-input-container>\n\n\n        <md-autocomplete flex md-floating-label="Parent" md-no-cache="ctrl.noCache" md-selected-item="vm.parent"\n          md-items="team in vm.querySearch(vm.searchText)" md-item-text="team.name" placeholder="No parent"\n          md-selected-item-change="vm.selectedItemChange(team)" md-search-text="vm.searchText" md-min-length="0">\n\n          <md-item-template>\n\n            <span md-highlight-text="vm.searchText" md-highlight-flags="^i">\n              {{team.name}}\n            </span>\n\n          </md-item-template>\n\n          <md-not-found>\n            No teams "{{vm.searchText}}" were found.\n          </md-not-found>\n\n        </md-autocomplete>\n\n      </div>\n\n    </md-dialog-content>\n\n    <md-dialog-actions layout="row">\n\n      <span flex></span>\n\n      <md-button ng-click="vm.done()" aria-label="Done" class="md-primary md-raised">\n        Edit Team\n      </md-button>\n\n    </md-dialog-actions>\n\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n\n  </form>\n\n</md-dialog>');
$templateCache.put('app/clients/teams/dialogs/add-team/dialog.tmpl.html','<md-dialog aria-label="Create new team dialog" flex="100" flex-gt-md="60" class="add-team-dialog">\n  <form name="vm.editTeamForm">\n    <md-toolbar>\n      <div class="md-toolbar-tools">\n        <p class="md-title" ng-if="!vm.parent.name">Create New Team</p>\n        <p class="md-title add-team-title" ng-if="vm.parent.name">Add New Subteam for {{vm.parent.name}}</p>\n        <span flex></span>\n        <md-button class="md-icon-button"\n          ng-click="vm.cancel()">\n          <md-icon md-font-icon="zmdi zmdi-close"\n              aria-label="Close dialog"></md-icon>\n        </md-button>\n      </div>\n    </md-toolbar>\n\n    <md-dialog-content>\n      <div layout-padding layout="column">\n        <div ng-if="vm.parent.name">\n          <div>Choose to make a copy of an existing team</div>\n          <md-autocomplete flex md-floating-label="Existing Team" md-no-cache="true" md-selected-item="vm.copy"\n            md-items="team in vm.querySearch(vm.searchText)" md-item-text="team.name" placeholder=""\n            md-search-text="vm.searchText" md-min-length="0" md-selected-item-change="vm.selectedItemChange(team)">\n            <md-item-template>\n              <span md-highlight-text="vm.searchText" md-highlight-flags="^i">{{team.name}}</span>\n            </md-item-template>\n            <md-not-found>\n              No teams "{{vm.searchText}}" were found.\n            </md-not-found>\n          </md-autocomplete>\n          <div ng-hide="vm.copy">Or create a brand new team</div>\n          <div ng-show="vm.copy">Call your copied team something different</div>\n        </div>\n        <md-input-container flex>\n          <label style="margin-left: 5px">Name</label>\n          <input type="text" name="teamname" ng-model="vm.team.name" md-autofocus required ng-change="vm.checkName(vm.editTeamForm)" />\n          <div ng-messages="vm.editTeamForm.teamname.$error" ng-if="vm.editTeamForm.teamname.$dirty && vm.editTeamForm.teamname.$error">\n            <div ng-message="required">This is required!</div>\n            <div ng-message="name">The name of the team must be different from the other teams in the same group!</div>\n          </div>\n        </md-input-container>\n      </div>\n    </md-dialog-content>\n\n    <md-dialog-actions layout="row">\n      <span flex></span>\n      <md-button ng-click="vm.done(vm.editTeamForm)" ng-disabled="!vm.editTeamForm.$valid"\n        aria-label="Done" class="md-primary md-raised">\n        Create Team\n      </md-button>\n    </md-dialog-actions>\n  <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n</md-dialog>\n');
$templateCache.put('app/clients/teams/dialogs/remove-team/dialog.tmpl.html','<md-dialog aria-label="Create new team dialog" flex="100" flex-gt-md="60" class="remove-team-dialog">\n\n  <form>\n\n    <md-toolbar>\n\n      <div class="md-toolbar-tools">\n\n        <p class="md-title remove-team-title">\n          Remove team {{vm.team.name}}\n        </p>\n\n        <span flex></span>\n\n        <md-button class="md-icon-button" ng-click="vm.cancel()">\n\n          <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog">\n          </md-icon>\n\n        </md-button>\n\n      </div>\n\n    </md-toolbar>\n\n    <md-dialog-content>\n\n      <div layout-padding layout="column">\n\n        <p style="font-size:14px">\n          Team {{vm.team.name}} has <b>{{vm.team.subteams.length}} subteams</b> and <b>{{vm.team.members.length}}\n            users</b>.\n        </p>\n\n        <md-input-container class="md-block" flex style="margin:0 8px;padding-left:0">\n\n          <label>\n            Select option\n          </label>\n\n          <md-select ng-model="vm.removalOption" flex aria-label="Select removal option">\n\n            <md-option value="removeall">\n              Remove this team and all its subteams and remove from form visibility settings\n            </md-option>\n\n            <md-option value="removeone">\n              Remove just this team and remove from form visibility settings and convert subteams to top level teams\n            </md-option>\n\n          </md-select>\n\n        </md-input-container>\n\n      </div>\n\n    </md-dialog-content>\n\n    <md-dialog-actions layout="row">\n\n      <span flex></span>\n      <md-button ng-click="vm.done()" aria-label="Done" class="md-primary md-raised">\n        Remove Team\n      </md-button>\n\n    </md-dialog-actions>\n\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n\n  </form>\n\n</md-dialog>');
$templateCache.put('app/clients/teams/dialogs/remove-selected-teams/dialog.tmpl.html','<md-dialog aria-label="Remove selected teams dialog" flex="100" flex-gt-md="60">\n\n  <form>\n\n    <md-toolbar>\n\n      <div class="md-toolbar-tools">\n\n        <p class="md-title">\n          Remove selected teams from {{vm.team.name}}\n        </p>\n\n        <span flex></span>\n\n        <md-button class="md-icon-button" ng-click="vm.cancel()">\n          <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog">\n          </md-icon>\n\n        </md-button>\n\n      </div>\n\n    </md-toolbar>\n\n    <md-dialog-content>\n\n      <div layout-padding layout="column">\n\n        <div style="font-size:14px">\n          You have selected the following subteams for removal:\n        </div>\n\n        <ul style="list-style: none;">\n\n          <li ng-repeat="subteam in vm.team.subteams | filter: { selected: true }">\n            {{subteam.name}}\n          </li>\n\n        </ul>\n\n        <md-input-container class="md-block" flex style="margin:20px 8px 0;padding-left:0">\n\n          <label>\n            Select option\n          </label>\n\n          <md-select ng-model="vm.removalOption" flex aria-label="Select removal option">\n\n            <md-option value="removeall">\n              Remove these teams and all their subteams and remove from form visibility settings\n            </md-option>\n\n            <md-option value="removeone">\n              Remove these teams from {{vm.team.name}} and convert them to top level teams\n            </md-option>\n\n          </md-select>\n\n        </md-input-container>\n\n      </div>\n\n    </md-dialog-content>\n\n    <md-dialog-actions layout="row">\n\n      <span flex></span>\n\n      <md-button ng-click="vm.done()" aria-label="Done" class="md-primary md-raised">\n        Remove Teams\n      </md-button>\n\n    </md-dialog-actions>\n\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n\n  </form>\n\n</md-dialog>');
$templateCache.put('app/clients/teams/tree/team-tree-element/view.tmpl.html','<div ng-repeat="team in vm.teams"\r\n  ng-show="(vm.level == 0 || vm.parent.open) && (team.shouldShow || vm.subTeamShouldShow(team.treeSubteams))">\r\n\r\n  <div class="team" layout="row" layout-align="space-between" ng-click="vm.selectTeam({ team: team })"\r\n    ng-class="{\'active\': team.selected}">\r\n\r\n    <div flex="none" class="subteam-opener" ng-style="{\'margin-left\': vm.chevronMargin}"\r\n      ng-click="vm.toggleChevron({ team: team, event: $event })">\r\n\r\n      <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-chevron-right"\r\n        ng-show="team.subteams.length > 0 && !team.open">\r\n      </md-icon>\r\n\r\n      <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-chevron-down"\r\n        ng-show="team.subteams.length > 0 && team.open">\r\n      </md-icon>\r\n\r\n    </div>\r\n\r\n    <div layout="column" flex="grow" class="team-name-container">\r\n\r\n      <span flex class="name">\r\n        {{team.name}}\r\n      </span>\r\n\r\n      <span flex class="info">\r\n        {{team.subteams.length}} subteams, {{ vm.calculateTeamMembersCount(team) }} users\r\n      </span>\r\n\r\n    </div>\r\n\r\n    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"\r\n      ng-show="team.selected" flex="none">\r\n      <path d="M0 0L7.03159 11.7447L0 24L24.9302 11.7447L0 0Z" fill="#FFC75B" />\r\n    </svg>\r\n\r\n    <div ng-show="vm.level > 0" class="horizontal-line"\r\n      ng-style="team.subteams.length > 0 ? {\'width\': \'15px\', \'margin-left\': vm.chevronMargin} : {\'margin-left\': vm.chevronMargin}">\r\n    </div>\r\n\r\n    <div ng-repeat="i in vm.loopArray track by $index" ng-show="vm.shouldVerticalLineShow($index)" class="vertical-line"\r\n      ng-style="{\'margin-left\': vm.calculateMargin($index)}">\r\n    </div>\r\n\r\n  </div>\r\n\r\n  <team-tree-element teams="team.treeSubteams" parent="team" select-team="vm.selectTeam({ team: team })"\r\n    level="vm.myLevel" toggle-chevron="vm.toggleChevron({ team: team, event: event })"\r\n    indexes-to-miss="vm.calculateIndexesToMiss($last, vm.myLevel)">\r\n  </team-tree-element>\r\n\r\n</div>');
$templateCache.put('app/clients/theming/images/image-selection-dialog/image-selection-dialog.tmpl.html','<md-dialog aria-label="Add new theme dialog" flex="60">\n\n  <md-toolbar aria-label="Select theme image dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">Select an image for the {{vm.skinName}} skin</p>\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content layout-padding layout="column" layout-align="start">\n    <form novalidate layout="row" flex="80">\n      <md-input-container layout-fill>\n        <md-icon md-font-icon="md-primary zmdi zmdi-search"></md-icon>\n        <input type="text" aria-label="Image name search" placeholder="Search" ng-model="vm.imageSearchValue"\n          ng-change="vm.searchForImage($event)" ng-model-options=\'{ debounce: 1000 }\' />\n      </md-input-container>\n    </form>\n\n    <md-toolbar ng-if="vm.selectedImageId && !vm.loading" layout="row" layout-align="start center" class="md-primary">\n      <span class="top-bar-text">Selected Image - {{\n        vm.getImageById(vm.selectedImageId).title }}</span>\n      <div flex></div>\n      <div layout="row" layout-align="end center" layout-gap="1.5%">\n        <md-button class="md-fab md-mini md-accent md-hue-3" aria-label="Edit image button" ng-click="vm.onEditImage()">\n          <md-icon>edit</md-icon>\n        </md-button>\n        <md-button class="md-fab md-mini md-accent md-hue-3" aria-label="Delete image button"\n          ng-click="vm.onDeleteImage()">\n          <md-icon>delete</md-icon>\n        </md-button>\n      </div>\n    </md-toolbar>\n\n    <md-progress-linear flex="80" md-mode="indeterminate" ng-if="vm.loading" class="md-accent"></md-progress-linear>\n\n    <div class="images-container">\n      <div layout="column" layout-align="center center" ng-if="!vm.loading && vm.groupedImages.length === 0"\n        class="overlay">\n\n        <p class="md-headline zuantTitanium1 margin-bottom-5">No images within the account!</p>\n        <p class="md-subhead zuantTitanium1 margin-top-0">Please use the buttons below to create/upload new images.</p>\n\n        </p>\n      </div>\n      <md-virtual-repeat-container md-top-index="0" class="md-virtual-scroll-viewport">\n        <div md-virtual-repeat="group in vm.groupedImages" md-item-size="150">\n          <div ng-repeat="image in group track by $index" class="image-container"\n            ng-class="{\'primary-highlight\': image._id == vm.selectedImageId}" ng-click="vm.selectImage(image)">\n            <div layout="column" layout-align="center center" ng-if="!image.loaded" class="image-loading-container">\n              <md-progress-circular md-mode="indeterminate" class="md-accent"></md-progress-circular>\n            </div>\n            <img ng-src="{{ image.src }}" title="{{ image.name }}" ng-show="image.loaded" />\n            <span class="image-name">{{ image.title }}</span>\n          </div>\n        </div>\n      </md-virtual-repeat-container>\n    </div>\n\n    <div layout="row" layout-align="start center" layout-gap="2%">\n      <md-button class="md-primary" ng-click="vm.openFileSelector()" ng-disabled="vm.fileCurrentlyUploading">\n        <md-icon>file_upload</md-icon>\n        Upload\n      </md-button>\n      <md-button class="md-primary" ng-click="vm.showCreateImageDialog($event)">\n        <md-icon>add</md-icon>\n        Create Image From URL\n      </md-button>\n\n      <ng-container ng-if="vm.fileUploadProgress > 0 && vm.fileUploadProgress < 100">\n        <div flex></div>\n        <md-progress-linear flex="60" md-mode="determinate" value="100" class="md-accent"></md-progress-linear>\n        <div flex></div>\n      </ng-container>\n\n    </div>\n\n    <md-dialog-actions layout="row">\n      <span flex></span>\n      <md-button class="md-accent" ng-click="vm.closeDialog()" aria-label="Close image select dialog">\n        Cancel\n      </md-button>\n      <md-button class="md-primary" ng-disabled="!vm.selectionDirty" ng-click="vm.applySelection()">Apply</md-button>\n    </md-dialog-actions>\n\n  </md-dialog-content>\n</md-dialog>\n\n<input id="imageUploadInput" type="file" ng-upload-change="vm.fileChanged($event)"\n  accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*" style="display:none;">');
$templateCache.put('app/clients/theming/images/weburi-image-form-dialog/weburi-image-form-dialog.tmpl.html','<md-dialog aria-label="WebUri Image Dialog" flex="40">\n\n    <md-toolbar aria-label="WebUri Image Dialog Toolbar" class="md-primary">\n        <div layout="row" class="md-toolbar-tools">\n            <p class="md-subhead">{{vm.locals.image ? \'Edit Image - \' + vm.locals.image.title : \'Create New Image\'}}</p>\n            <div flex></div>\n            <md-button class="md-icon-button" ng-click="vm.closeDialog()">\n                <md-icon>clear</md-icon>\n            </md-button>\n        </div>\n    </md-toolbar>\n\n    <md-dialog-content layout-padding layout="column" layout-align="start">\n        <form flex="80" layout-align="start center" name="vm.weburiImageForm" ng-submit="onCreate()">\n            <md-input-container layout-fill>\n                <label>Image Title</label>\n                <md-icon class="md-primary">local_offer</md-icon>\n                <input name="imageTitle" type="text" ng-model="vm.imageTitle" ng-disabled="vm.disableWebUriImageForm"\n                    required>\n                <div ng-messages="vm.weburiImageForm.imageTitle.$error" ng-if="vm.weburiImageForm.imageTitle.$touched">\n                    <div ng-message when="required">Image Title is <b>required</b>.</div>\n                </div>\n            </md-input-container>\n\n            <md-input-container class="margin-top-10" layout-fill ng-if="!vm.locals.image._s3key">\n                <label>Enter Image URL</label>\n                <md-icon class="md-primary">link</md-icon>\n                <input name="imageURL" type="text" ng-model="vm.imageURL" ng-change="vm.imageURLChanged($event)"\n                    ng-disabled="vm.disableWebUriImageForm" required>\n                <div ng-messages="vm.weburiImageForm.imageURL.$error" ng-if="vm.weburiImageForm.imageURL.$touched">\n                    <div ng-message when="required">Image URL is <b>required</b>.</div>\n                    <div ng-message when="invalid_url"><b>Invalid</b> URL.</div>\n                    <div ng-message when="invalid_extension"><b>\n                            Invalid image extension, only .jpg, .jpeg, .png, .gif, .bmp are supported.\n                    </div>\n                </div>\n                <div class="hint margin-top-10">This is the URL of the image. It needs to include the file extension.\n                    For example :\n                    https://sample-videos.com/img/Sample-jpg-image-2mb.jpg</div>\n            </md-input-container>\n        </form>\n\n        <div layout="row" layout-align="start stretch" class="margin-top-20">\n            <div flex></div>\n            <md-button class="md-accent" ng-click="vm.closeDialog()">Cancel</md-button>\n            <md-button class="md-raised md-primary"\n                ng-disabled="!vm.weburiImageForm.$valid || !vm.weburiImageForm.$dirty || !vm.checkFormForDeltas()"\n                ng-click="vm.saveForm()">\n                {{vm.locals.image ? \'Save Changes\' : \'Create\'}}\n            </md-button>\n        </div>\n    </md-dialog-content>\n\n</md-dialog>');
$templateCache.put('app/common/editor/select-controls/checkbox-cell/checkbox-cell-editor.tmpl.html','<md-edit-dialog class="md-whiteframe-1dp" style="background: white;">\n\n  <div layout="column" layout-padding>\n    <md-input-container style="margin-bottom: -15px;">\n      <input ng-model="filterAnswers" placeholder="Filter answers" />\n    </md-input-container>\n    <div ng-if="ctrl.formErrors" class="fade">\n      <div ng-repeat="error in ctrl.formErrors.errors"><md-icon\n          md-font-icon="zmdi zmdi-alert-triangle zuantPollen"></md-icon> {{error.message}}</div>\n    </div>\n  </div>\n\n  <md-content layout-fill style="max-height: 35vh; overflow: auto; background: white">\n    <md-progress-linear ng-if="ctrl.loading" class="md-accent" md-mode="indeterminate"></md-progress-linear>\n    <div layout-padding ng-if="ctrl.errorMessage">{{ctrl.errorMessage}}</div>\n    <md-list>\n      <md-list-item class="md-no-proxy md-2-line" ng-repeat="answer in ctrl.zpMetadata.answers | filter: filterAnswers">\n        <div class="md-primary-container" flex="{{answer.showMoreInfoTextfield && answer.selected ? 40 : 100}}"\n          layout="row" md-ink-ripple ng-click="answer.selected = !answer.selected">\n          <md-checkbox ng-click="$event.stopPropagation();" ng-model="answer.selected"\n            ng-disabled="ctrl.zpMetadata.readOnly"></md-checkbox>\n          <div class="md-list-item-text">\n            <h3 style="white-space: normal;">{{answer.displayValue}}</h3>\n            <span ng-if="ctrl.widgetIsAList">\n              <p ng-if="answer.keyValue !== answer.displayValue">Code: {{answer.keyValue}}</p>\n              <p ng-if="answer.points">Points: {{answer.points}}</p>\n            </span>\n            <p ng-if="answer.heading">Heading: {{answer.heading}}</p>\n            <p ng-if="answer.dateAcquired">Date acquired: {{answer.dateAcquired | date: \'short\' : ctrl.formTimezone}}\n            </p>\n            <p ng-if="answer.dateRead">Date read: {{answer.dateRead | date: \'short\' : ctrl.formTimezone}}</p>\n          </div>\n        </div>\n\n        <div class="md-secondary more-info-textfield" ng-if="answer.showMoreInfoTextfield && answer.selected">\n          <md-input-container>\n            <label>More info</label>\n            <input type="text" ng-model="answer.moreInfo" md-placeholder="Please enter more info">\n          </md-input-container>\n        </div>\n      </md-list-item>\n    </md-list>\n  </md-content>\n\n  <md-divider></md-divider>\n\n  <div layout="row" layout-align="space-between center" layout-padding>\n    <md-button class="" ng-click="ctrl.toggleAll(true)" ng-disabled="ctrl.zpMetadata.readOnly">\n      <md-icon md-font-icon="zmdi zmdi-check-square"></md-icon>\n      Select all\n      <!-- <md-tooltip md-direction="down">Select all</md-tooltip> -->\n    </md-button>\n    <md-button class="" ng-click="ctrl.toggleAll(false)" ng-disabled="ctrl.zpMetadata.readOnly">\n      <md-icon md-font-icon="zmdi zmdi-square-o"></md-icon>\n      Deselect all\n      <!-- <md-tooltip md-direction="down">Deselect all</md-tooltip> -->\n    </md-button>\n    <md-button class="md-primary" ng-click="ctrl.closeDialog()">Done</md-button>\n  </div>\n\n</md-edit-dialog>');
$templateCache.put('app/common/editor/select-controls/radio-button-cell/radio-button-cell-editor.tmpl.html','<md-edit-dialog class="md-whiteframe-1dp" style="background: white;">\n\n  <div layout="column" layout-padding>\n    <md-input-container style="margin-bottom: -15px;">\n      <input ng-model="filterAnswers" placeholder="Filter answers" />\n    </md-input-container>\n    <div ng-if="ctrl.formErrors" class="fade">\n      <div ng-repeat="error in ctrl.formErrors.errors"><md-icon\n          md-font-icon="zmdi zmdi-alert-triangle zuantPollen"></md-icon> {{error.message}}</div>\n    </div>\n  </div>\n\n  <md-content layout-fill style="max-height: 35vh; overflow: auto; background: white">\n    <md-progress-linear ng-if="ctrl.loading" class="md-accent" md-mode="indeterminate"></md-progress-linear>\n    <div layout-padding ng-if="ctrl.errorMessage">{{ctrl.errorMessage}}</div>\n    <md-list>\n\n      <md-list-item class="md-no-proxy md-2-line" ng-if="ctrl.zpMetadata.type === \'Lookup\'">\n\n        <div class="md-primary-container" flex="{{ctrl.zpRadioModel === \'custom.lookup.value\' ? 40 : 100}}" layout="row"\n          md-ink-ripple>\n          <md-radio-group ng-model="ctrl.zpRadioModel"\n            ng-change="ctrl.updateRadioButtonSelection(\'custom.lookup.value\')">\n            <md-radio-button ng-value="\'custom.lookup.value\'">\n              <div class="md-list-item-text">\n                <h3 style="white-space: normal;">Custom</h3>\n              </div>\n            </md-radio-button>\n          </md-radio-group>\n        </div>\n\n        <div class="md-secondary more-info-textfield" ng-if="ctrl.zpRadioModel === \'custom.lookup.value\'">\n          <md-input-container>\n            <label>Lookup value</label>\n            <input type="text" ng-model="ctrl.zpModel" md-placeholder="Please enter custom lookup value">\n          </md-input-container>\n        </div>\n      </md-list-item>\n\n      <md-list-item class="md-no-proxy md-2-line" ng-repeat="answer in ctrl.zpMetadata.answers | filter: filterAnswers">\n\n        <div class="md-primary-container" flex="{{answer.showMoreInfoTextfield && answer.selected ? 40 : 100}}"\n          layout="row" md-ink-ripple>\n          <md-radio-group ng-model="ctrl.zpRadioModel" ng-change="ctrl.updateRadioButtonSelection(answer)">\n            <md-radio-button ng-value="answer.keyValue">\n              <div class="md-list-item-text">\n                <h3 style="white-space: normal;">{{answer.displayValue}}</h3>\n                <p ng-if="answer.keyValue !== answer.displayValue">Code: {{answer.keyValue}}</p>\n                <p ng-if="answer.points">Points: {{answer.points}}</p>\n                <!-- <p>Selected: {{answer.selected}}</p> -->\n              </div>\n            </md-radio-button>\n          </md-radio-group>\n        </div>\n\n        <div class="md-secondary more-info-textfield" ng-if="answer.showMoreInfoTextfield && answer.selected">\n          <md-input-container>\n            <label>More info</label>\n            <input type="text" ng-model="answer.moreInfo" md-placeholder="Please enter more info">\n          </md-input-container>\n        </div>\n      </md-list-item>\n\n    </md-list>\n  </md-content>\n\n  <md-divider></md-divider>\n\n  <div layout="row" layout-align="space-between center" layout-padding>\n    <md-button ng-click="ctrl.zpRadioModel = \'\'" ng-disabled="ctrl.zpMetadata.readOnly">Deselect</md-button>\n    <md-button class="md-primary" ng-click="ctrl.closeDialog()">Done</md-button>\n  </div>\n\n</md-edit-dialog>');
$templateCache.put('app/common/message/custom-dialogs/confirm-action-with-input/confirm-action-with-input.tmpl.html','<md-dialog aria-label="{{ msg.title }}">\n    <md-dialog-content class="md-dialog-content">\n        <h2 class="md-title">{{ msg.title }}</h2>\n\n        <div style="margin-top: 5%;" ng-bind-html="msg.htmlContent"></div>\n\n        <p>Please enter \'<b>{{ msg.confirmationText }}</b>\' to confirm you wish to continue.</p>\n\n        <form ng-submit="submit()" style="margin-top: 5%;" name="confirmationForm" novalidate>\n            <md-input-container layout-fill>\n                <label>Enter Confirmation Text Here</label>\n                <input name="confirmationInput" ng-model="userInput" zp-confirmation-text-validator\n                    target-confirmation-text="{{ msg.confirmationText }}" required>\n                <div ng-messages="confirmationForm.confirmationInput.$error" md-auto-hide="false"\n                    ng-show="confirmationForm.confirmationInput.$dirty">\n                    <div ng-message="required">Confirmation is required</div>\n                    <div ng-message when="confirmationText">\n                        Invalid confirmation text\n                    </div>\n                </div>\n            </md-input-container>\n        </form>\n    </md-dialog-content>\n    <md-dialog-actions layout="row">\n        <md-button ng-click="cancel()" class="md-primary">{{ msg.cancelBtn }}</md-button>\n        <md-button ng-disabled="userInput !== msg.confirmationText" ng-click="submit()" class="md-primary">{{\n            msg.okBtn }}</md-button>\n    </md-dialog-actions>\n</md-dialog>');
$templateCache.put('app/common/message/custom-dialogs/create-item-with-input/create-item-with-input.tmpl.html','<md-dialog aria-label="{{ msg.title }}">\n    <md-dialog-content style="padding-bottom: 0;" class="md-dialog-content">\n        <h2 class="md-title">{{ msg.title }}</h2>\n\n        <form ng-submit="submit()" style="min-width: 300px; margin-top: 5%;" name="confirmationForm" novalidate>\n            <md-input-container layout-fill>\n                <label>{{ msg.inputLabel }}</label>\n                <input name="confirmationInput" ng-model="userInput" required>\n                <div ng-messages="confirmationForm.confirmationInput.$error" md-auto-hide="false"\n                    ng-show="confirmationForm.confirmationInput.$dirty">\n                    <div ng-message="required">Confirmation is required</div>\n                </div>\n            </md-input-container>\n        </form>\n    </md-dialog-content>\n    <md-dialog-actions layout="row">\n        <md-button ng-click="cancel()" class="md-primary">{{ msg.cancelBtn }}</md-button>\n        <md-button type="submit" ng-disabled="!userInput || userInput.length === 0" ng-click="submit()"\n            class="md-primary">{{\n            msg.okBtn }}</md-button>\n    </md-dialog-actions>\n</md-dialog>');
$templateCache.put('app/common/tables/toolbars/grid/tmpl.html','<md-toolbar class="md-table-toolbar md-default">\n      <div class="md-toolbar-tools">\n            <p class="md-tagline" ng-if="!$ctrl.showSearch"\n                  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">\n                  {{$ctrl.formname}}\n            </p>\n            <!-- <zp-editable-header metadata="$ctrl.metadata" value="$ctrl.formname" ng-show="!$ctrl.showSearch" flex done-function="$ctrl.updateTitle(value)"></zp-editable-header> -->\n            <md-input-container ng-if="$ctrl.showSearch" flex="flex" class="margin-bottom-0 margin-top-40">\n                  <label>Filter data</label>\n                  <input ng-model="$ctrl.searchValue" ng-if="$ctrl.showSearch" focus-on-show="focus-on-show"\n                        aria-label="Grid filter" input-clear="input-clear" />\n            </md-input-container>\n\n            <md-button class="md-icon-button" ng-if="$ctrl.showSearch && $ctrl.widgetId === \'lead_release\'"\n                  ng-click="$ctrl.searchValue = \'locked\'" ng-class="{\'md-raised\' : $ctrl.searchValue === \'locked\'}">\n                  <md-icon md-font-icon="zmdi zmdi-lock"></md-icon>\n                  <md-tooltip md-direction="down">Set filter to locked leads</md-tooltip>\n            </md-button>\n\n            <md-button class="md-icon-button" ng-if="$ctrl.showSearch && $ctrl.widgetId === \'lead_release\'"\n                  ng-click="$ctrl.searchValue = \'unreleased\'"\n                  ng-class="{\'md-raised\' : $ctrl.searchValue === \'unreleased\'}">\n                  <md-icon md-font-icon="zmdi zmdi-cloud-off"></md-icon>\n                  <md-tooltip md-direction="down">Set filter to unreleased leads</md-tooltip>\n            </md-button>\n\n            <md-button class="md-icon-button" ng-if="$ctrl.showSearch && $ctrl.widgetId === \'lead_release\'"\n                  ng-click="$ctrl.searchValue = \'failed\'" ng-class="{\'md-raised\' : $ctrl.searchValue === \'failed\'}">\n                  <md-icon md-font-icon="zmdi zmdi-alert-circle"></md-icon>\n                  <md-tooltip md-direction="down">Set filter to leads with errors</md-tooltip>\n            </md-button>\n\n            <md-button class="md-icon-button" ng-if="$ctrl.showSearch && $ctrl.widgetId === \'lead_release\'"\n                  ng-click="$ctrl.searchValue = \'mixed\'" ng-class="{\'md-raised\' : $ctrl.searchValue === \'mixed\'}">\n                  <md-icon md-font-icon="zmdi zmdi-alert-triangle"></md-icon>\n                  <md-tooltip md-direction="down">Set filter to leads with a mix of success and errors</md-tooltip>\n            </md-button>\n\n            <md-button class="md-icon-button" ng-if="$ctrl.showSearch && $ctrl.widgetId === \'lead_release\'"\n                  ng-click="$ctrl.searchValue = \'processed\'"\n                  ng-class="{\'md-raised\' : $ctrl.searchValue === \'processed\'}">\n                  <md-icon md-font-icon="zmdi zmdi-cloud-done"></md-icon>\n                  <md-tooltip md-direction="down">Set filter to processed leads</md-tooltip>\n            </md-button>\n\n            <div flex="flex"></div>\n\n            <md-button class="md-icon-button" ng-click="$ctrl.toggleShowSearch()"\n                  ng-class="{\'btn-active\': $ctrl.showSearch}" aria-label="toggle search">\n                  <md-icon md-font-icon="zmdi zmdi-search"></md-icon>\n                  <md-tooltip md-direction="down">Filter data</md-tooltip>\n            </md-button>\n\n            <md-button class="md-icon-button" ng-if="$ctrl.buttons.showDataRefreshButton"\n                  ng-disabled="$ctrl.changeDeltaFactory.isDirty()" ng-click="$ctrl.refreshGridData()"\n                  aria-label="refresh grid data">\n                  <md-icon md-font-icon="zmdi zmdi-refresh"></md-icon>\n                  <md-tooltip md-direction="down">Refresh grid data</md-tooltip>\n            </md-button>\n\n            <md-menu ng-if="$ctrl.buttons.showColumnSelect" id="colum-select-menu">\n                  <md-button class="md-icon-button" ng-click="$ctrl.openMenu($mdOpenMenu, $event)"\n                        ng-class="{ \'btn-active\' : !$ctrl.columnSelectionSvc.factoryData.allColumnsVisibleValue }">\n                        <md-icon md-font-icon="zmdi zmdi-view-column"></md-icon>\n                        <md-tooltip md-direction="down">Grid columns</md-tooltip>\n                  </md-button>\n\n                  <md-menu-content width="4">\n\n                        <md-menu-item>\n                              <div style="padding: 0;" layout="row" layout-align="start start">\n                                    <!--Need this ridiculous hack to prevent auto focus of md-button and tooltip display -->\n                                    <md-button style="display: none;">\n                                    </md-button>\n\n                                    <md-button class="md-icon-button"\n                                          ng-if="$ctrl.columnSelectionSvc.factoryData.reorderModeEnabled"\n                                          ng-click="$ctrl.columnSelectionSvc.resetColumnOrder()" md-prevent-menu-close>\n                                          <md-icon md-font-icon="zmdi zmdi-refresh"></md-icon>\n                                          <md-tooltip md-direction="down">Reset</md-tooltip>\n                                    </md-button>\n\n                                    <span flex></span>\n\n\n                                    <md-button class="md-icon-button"\n                                          ng-class="{\'btn-active\': $ctrl.columnSelectionSvc.factoryData.reorderModeEnabled}"\n                                          ng-click="$ctrl.columnSelectionSvc.toggleReorderColumns()"\n                                          md-prevent-menu-close>\n                                          <md-icon md-font-icon="zmdi zmdi-filter-list"></md-icon>\n                                          <md-tooltip md-direction="down">\n                                                Reorder items\n                                          </md-tooltip>\n                                    </md-button>\n\n                              </div>\n                        </md-menu-item>\n\n                        <zp-reorder-columns ng-if="$ctrl.columnSelectionSvc.factoryData.reorderModeEnabled"\n                              items="$ctrl.columnSelectionSvc.fetchReorderColumsList()"\n                              on-update="$ctrl.columnSelectionSvc.reorderColumns($event, ui)"></zp-reorder-columns>\n\n                        <ng-container ng-if="!$ctrl.columnSelectionSvc.factoryData.reorderModeEnabled">\n                              <md-menu-item class="col-select-button">\n                                    <md-checkbox ng-model="$ctrl.columnSelectionSvc.factoryData.allColumnsVisibleValue"\n                                          ng-change="$ctrl.toggleAllColsVisible()">\n                                          All columns\n                              </md-menu-item>\n                              <md-menu-item ng-repeat="item in $ctrl.columnSelectionSvc.fetchColumsVisibilityList()"\n                                    class="col-select-button">\n                                    <md-checkbox ng-model="item.showCol" ng-change="$ctrl.toggleColumnVisibility(item)">\n                                          {{item.label}}\n                              </md-menu-item>\n                        </ng-container>\n                  </md-menu-content>\n            </md-menu>\n\n            <span permission permission-only="$ctrl.permissions.liteFeatures.leadManagement.editGrid"\n                  ng-if="$ctrl.buttons.showParkedLeads">\n                  <md-button ng-if="$ctrl.leadGridFactoryData.parked_leads.items.length > 0" class="md-icon-button"\n                        ng-click="$ctrl.openParkedLeadsDialog($event)" aria-label="view parked leads dialog">\n                        <md-icon md-font-icon="zmdi zmdi-parking"></md-icon>\n                        <md-tooltip md-direction="down">Manage\n                              {{$ctrl.leadGridFactoryData.parked_leads.items.length}}\n                              parked leads</md-tooltip>\n                        <!-- <span class="toolbar-button-badge animated ng-scope md-cyan-white-theme" theme-background="accent">{{ $ctrl.leadGridFactoryData.parked_leads.items.length }}</span> -->\n                        <span class="toolbar-button-icon">\n                              <md-icon md-font-icon="zmdi zmdi-alert-triangle zuantPollen" style="font-size:20px;">\n                              </md-icon>\n                        </span>\n                  </md-button>\n            </span>\n\n            <md-menu ng-if="$ctrl.buttons.showLeadBreakout">\n                  <md-button class="md-icon-button" ng-click="$ctrl.openMenu($mdOpenMenu, $event)"\n                        aria-label="download reports" permission\n                        permission-only="$ctrl.permissions.liteFeatures.leadManagement.download">\n                        <md-icon md-font-icon="zmdi zmdi-download"></md-icon>\n                        <md-tooltip md-direction="down">Download Leads</md-tooltip>\n                  </md-button>\n                  <md-menu-content width="4">\n                        <md-menu-item class="sub-menu-button" ng-click="$ctrl.downloadLeads($event)">\n                              Download lead data (CSV)\n                        </md-menu-item>\n                        <md-menu-item class="sub-menu-button" ng-click="$ctrl.downloadLeadsAsExcel($event)">\n                              Download lead data (Excel)\n                        </md-menu-item>\n                        <md-menu-item class="sub-menu-button" ng-click="$ctrl.downloadLeadBreakoutReport($event)">\n                              Download lead breakout data (CSV)\n                        </md-menu-item>\n                        <md-menu-item class="sub-menu-button"\n                              ng-click="$ctrl.downloadLeadBreakoutReportAsExcel($event)">\n                              Download lead breakout data (Excel)\n                        </md-menu-item>\n                  </md-menu-content>\n            </md-menu>\n\n            <md-menu ng-hide="$ctrl.buttons.showLeadBreakout">\n                  <md-button class="md-icon-button" ng-click="$ctrl.openMenu($mdOpenMenu, $event)"\n                        aria-label="download leads" permission\n                        permission-only="$ctrl.permissions.liteFeatures.leadManagement.download">\n                        <md-icon md-font-icon="zmdi zmdi-download"></md-icon>\n                        <md-tooltip md-direction="down">Download Leads</md-tooltip>\n                  </md-button>\n                  <md-menu-content width="4">\n                        <md-menu-item class="sub-menu-button" ng-click="$ctrl.downloadLeads($event)">\n                              Download lead data (CSV)\n                        </md-menu-item>\n                        <md-menu-item class="sub-menu-button" ng-click="$ctrl.downloadLeadsAsExcel($event)">\n                              Download lead data (Excel)\n                        </md-menu-item>\n                  </md-menu-content>\n            </md-menu>\n\n            <zp-save-button ng-if="$ctrl.buttons.showSave" permission\n                  permission-only="$ctrl.permissions.liteFeatures.leadManagement.editGrid" label="\'save changes\'"\n                  isdirty="$ctrl.changeDeltaFactory.isDirty()" save="$ctrl.saveGridChanges()"></zp-save-button>\n      </div>\n</md-toolbar>');
$templateCache.put('app/common/tables/toolbars/filter/zp-filter-toolbar.tmpl.html','<md-toolbar class="md-table-toolbar md-default">\n  <div class="md-toolbar-tools">\n    <span ng-show="!vm.showSearch">{{ data.name }}</span>\n    <md-input-container ng-show="vm.showSearch" flex class="margin-bottom-0 margin-top-40">\n      <label>Filter data</label>\n      <input ng-model="vm.searchVal" aria-label="filter"/>\n    </md-input-container>\n    <div flex></div>\n    <md-button class="md-icon-button" ng-click="vm.showSearch = !vm.showSearch" ng-class="{\'btn-active\': vm.showSearch}" aria-label="toggle search">\n      <md-icon md-font-icon="zmdi zmdi-search"></md-icon>\n    </md-button>\n  </div>\n</md-toolbar>\n');
$templateCache.put('app/common/tables/toolbars/selection-manager/zp-selection-manager.tmpl.html','<md-toolbar class="md-table-toolbar alternate" ng-show="$ctrl.itemsSelected() || $ctrl.widgetId === \'parked_leads\'">\n  <div class="md-toolbar-tools">\n    <zp-clear-button ng-if="$ctrl.itemsSelected() > 0" class="zp-button"\n      on-click="$ctrl.clearSelectedCheckboxClicked($event)"></zp-clear-button>\n\n    <span ng-if="$ctrl.widgetId !== \'parked_leads\' && $ctrl.itemsSelected() > 0">{{$ctrl.itemsSelected()}}\n      {{$ctrl.itemsSelected() > 1 ? \'items\' : \'item\'}} selected</span>\n    <span ng-if="$ctrl.widgetId === \'parked_leads\' && $ctrl.itemsSelected() > 0">{{$ctrl.itemsSelected()}}\n      {{$ctrl.itemsSelected() > 1 ? \'leads\' : \'lead\'}} selected</span>\n    <span ng-if="$ctrl.widgetId === \'parked_leads\' && $ctrl.itemsSelected() === 0">0 leads currently selected, check\n      some rows you wish to unpark</span>\n\n    <span flex></span>\n    <ng-container ng-if="$ctrl.itemsSelected() > 0">\n      <md-button class="md-icon-button md-raised md-accent" ng-if="$ctrl.toolbarButtons.showUnpark"\n        ng-click="$ctrl.unparkLeadsButtonClicked($event)">\n        <md-icon md-font-icon="zmdi zmdi-check"></md-icon>\n        <md-tooltip>Unpark lead</md-tooltip>\n      </md-button>\n      <zp-edit-button label="\'Edit selected rows\'" ng-if="$ctrl.toolbarButtons.showEdit"\n        on-click="$ctrl.editButtonClicked($event)"></zp-edit-button>\n      <!-- <zp-unarchive-button label="\'Unarchive selected items\'" ng-if="$ctrl.toolbarButtons.showUnarchive" on-click="$ctrl.unarchiveButtonClicked($event)"></zp-unarchive-button> -->\n      <zp-delete-button label="\'Delete selected items\'" ng-if="$ctrl.toolbarButtons.showDelete"\n        on-click="$ctrl.deleteButtonClicked($event)"></zp-delete-button>\n    </ng-container>\n  </div>\n</md-toolbar>');
$templateCache.put('app/forms/lead-release-grid/dialogs/release-confirmation/release-lead-confirmation-prompt.tmpl.html','<md-dialog aria-label="Add new user dialog" flex="70">\n\n  <md-toolbar aria-label="Create user dialog toolbar">\n    <div class="md-toolbar-tools">\n      Your selection has a mix of integration states.\n    </div>\n  </md-toolbar>\n  <md-toolbar aria-label="stat counts">\n    <div class="md-toolbar-tools">\n      <div flex="33" style="text-align: center;">\n        <md-icon md-font-icon="zmdi zmdi-cloud-off"></md-icon> {{$ctrl.stats.unreleasedCount}} unreleased {{$ctrl.stats.unreleasedCount != 1 ? \'leads\' : \'lead\'}}\n      </div>\n      <div flex="33" style="text-align: center;">\n        <md-icon md-font-icon="zmdi zmdi-cloud-done"></md-icon> {{$ctrl.stats.releasedCount}} released {{$ctrl.stats.releasedCount != 1 ? \'leads\' : \'lead\'}}\n      </div>\n      <div flex="33" style="text-align: center;">\n        <md-icon md-font-icon="zmdi zmdi-alert-triangle"></md-icon> {{$ctrl.stats.failedCount}} failed {{$ctrl.stats.failedCount != 1 ? \'leads\' : \'lead\'}}\n      </div>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content layout-padding>\n    <div layout="column">\n      <p class="md-headline text-align-center">\n        Please confirm the actions you wish to take below.\n      </p>\n\n          <div layout="column" layout-align="center" flex-offset="30" layout-padding>\n            <!-- <p>A total of {{$ctrl.stats.totalSelected}} leads are selected, please confirm the actions you wish to take below.</p> -->\n            <md-checkbox ng-if="$ctrl.stats.unreleasedCount" ng-model="$ctrl.actionsToPerform.includeUnreleased"> include {{$ctrl.stats.unreleasedCount}} leads not yet pushed</md-checkbox>\n            <md-checkbox ng-if="$ctrl.stats.releasedCount" ng-model="$ctrl.actionsToPerform.includeReleased"> include {{$ctrl.stats.releasedCount}} leads successfully pushed already</md-checkbox>\n            <md-checkbox ng-if="$ctrl.stats.failedCount" ng-model="$ctrl.actionsToPerform.includeFailed"> include {{$ctrl.stats.failedCount}} failed leads</md-checkbox>\n          </div>\n          <!-- <pre>{{$ctrl.actionsToPerform}}</pre> -->\n\n        <div flex="20" layout-align="center center" layout="column" ng-hide="!$ctrl.actionsToPerform.includeUnreleased && !$ctrl.actionsToPerform.includeReleased && !$ctrl.actionsToPerform.includeFailed">\n            <md-icon\n              md-font-icon="zmdi zmdi-chevron-down"\n              ng-class="{\'fadeInDown\' : ($ctrl.actionsToPerform.includeUnreleased || $ctrl.actionsToPerform.includeReleased || $ctrl.actionsToPerform.includeFailed)}"\n              class="animated">\n            </md-icon>\n            <md-icon\n              md-font-icon="zmdi zmdi-chevron-down"\n              ng-class="{\'fadeInDown\' : ($ctrl.actionsToPerform.includeUnreleased || $ctrl.actionsToPerform.includeReleased || $ctrl.actionsToPerform.includeFailed)}"\n              class="animated">\n            </md-icon>\n        </div>\n        <div flex="40" flex-offset-gt-sm="20">\n          <p class="md-subhead margin-top-0" ng-show="($ctrl.actionsToPerform.includeUnreleased || $ctrl.actionsToPerform.includeReleased || $ctrl.actionsToPerform.includeFailed)">\n            Resulting actions will be...\n          </p>\n          <div ng-show="$ctrl.stats.unreleasedCount && $ctrl.actionsToPerform.includeUnreleased" >\n            <md-icon md-font-icon="zmdi zmdi-check zuantAqua" class="animated" ng-class="{\'rollIn\' : ($ctrl.stats.unreleasedCount && $ctrl.actionsToPerform.includeUnreleased)}"></md-icon>\n            {{$ctrl.stats.unreleasedCount}} unreleased {{$ctrl.stats.unreleasedCount >1 ? \'leads\' : \'lead\'}} being released\n          </div>\n          <div ng-show="$ctrl.stats.releasedCount && $ctrl.actionsToPerform.includeReleased" >\n            <md-icon md-font-icon="zmdi zmdi-check zuantAqua" class="animated" ng-class="{\'rollIn\' : ($ctrl.stats.releasedCount && $ctrl.actionsToPerform.includeReleased)}"></md-icon>\n            {{$ctrl.stats.releasedCount}} released {{$ctrl.stats.releasedCount >1 ? \'leads\' : \'lead\'}} being re-released\n          </div>\n          <div ng-show="$ctrl.stats.failedCount && $ctrl.actionsToPerform.includeFailed">\n            <md-icon md-font-icon="zmdi zmdi-check zuantAqua" class="animated" ng-class="{\'rollIn\' : ($ctrl.stats.failedCount &&$ctrl.actionsToPerform.includeFailed)}"></md-icon>\n            {{$ctrl.stats.failedCount}} {{$ctrl.stats.failedCount >1 ? \'leads\' : \'lead\'}} that failed will be re-released\n          </div>\n      </div>\n    </div>\n  </md-dialog-content>\n\n  <md-dialog-actions layout="row">\n    <md-button class="md-warn" ng-click="$ctrl.cancelDialog()">Cancel</md-button>\n    <md-button class="md-raised md-primary" aria-label="continue" ng-disabled="!$ctrl.actionsToPerform.includeReleased && !$ctrl.actionsToPerform.includeUnreleased && !$ctrl.actionsToPerform.includeFailed" ng-click="$ctrl.submit()">Confirm</md-button>\n  </md-dialog-actions>\n\n</md-dialog>\n');
$templateCache.put('app/forms/lead-release-grid/dialogs/push-history/dialog.tmpl.html','<md-dialog aria-label="Add new user dialog" flex="100">\n      <md-toolbar aria-label="Create user dialog toolbar">\n            <div class="md-toolbar-tools">\n                  Release history for lead:\n                  {{$ctrl.title}}\n                  <span flex="flex"></span>\n                  <zp-toggle-json-button show-json="$ctrl.showJson"></zp-toggle-json-button>\n                  <md-button aria-label="Close dialog" ng-click="$ctrl.closeDialog()">\n                        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n                  </md-button>\n            </div>\n      </md-toolbar>\n      <md-toolbar aria-label="stat counts">\n            <div class="md-toolbar-tools">\n                  <h2>This lead has been released\n                        {{$ctrl.orderedArrayOfReleaseAttempts.length}}\n                        <span>{{$ctrl.orderedArrayOfReleaseAttempts.length == 1 ? \' time\' : \' times\'}}</span>\n                        <span ng-if="$ctrl.orderedArrayOfReleaseAttempts[0]">, most recently\n                              {{$ctrl.orderedArrayOfReleaseAttempts[0].dtMachinesFinishedRunning | zpMomentFromNow\n                              }}.</span>\n                  </h2>\n                  <!-- <div flex="33" style="text-align: center;">\n            <md-icon md-font-icon="zmdi zmdi-cloud-off"></md-icon> {{$ctrl.stats.unreleasedCount}} unreleased {{$ctrl.stats.unreleasedCount != 1 ? \'leads\' : \'lead\'}}\n          </div>\n          <div flex="33" style="text-align: center;">\n            <md-icon md-font-icon="zmdi zmdi-cloud-done"></md-icon> {{$ctrl.stats.releasedCount}} released {{$ctrl.stats.releasedCount != 1 ? \'leads\' : \'lead\'}}\n          </div>\n          <div flex="33" style="text-align: center;">\n            <md-icon md-font-icon="zmdi zmdi-alert-triangle"></md-icon> {{$ctrl.stats.failedCount}} failed {{$ctrl.stats.failedCount != 1 ? \'leads\' : \'lead\'}}\n          </div> -->\n            </div>\n      </md-toolbar>\n      <md-dialog-content layout-padding="layout-padding">\n            <!-- <div>\n                  <h2>This lead has been released\n                        {{$ctrl.orderedArrayOfReleaseAttempts.length}}\n                        <span>{{$ctrl.orderedArrayOfReleaseAttempts.length == 1 ? \' time\' : \' times\'}}</span>\n                        <span ng-if="$ctrl.orderedArrayOfReleaseAttempts[0].countOfMachineRuns > 0">, most recently\n                              {{$ctrl.orderedArrayOfReleaseAttempts[0].dtMachinesFinishedRunning | zpMomentFromNow }}.</span>\n                  </h2>\n            </div> -->\n\n            <div ng-if="$ctrl.locals.leadData.response._integrationState === \'indeterminate\'">\n                  <p> <md-icon md-font-icon="zmdi zmdi-help"></md-icon> Zuant is unable to determine if the lead\n                        successfully made it through to the third party system.</p>\n            </div>\n\n            <div ng-if="!$ctrl.orderedArrayOfReleaseAttempts.length">\n                  <p>This lead is currently {{$ctrl.locals.leadData.response._integrationState}}</p>\n            </div>\n\n            <md-card ng-repeat="ra in $ctrl.orderedArrayOfReleaseAttempts" class="bground">\n                  <div layout="column" flex="flex" layout-padding="layout-padding">\n                        <div layout="row" flex="flex" layout-align="space-between center">\n                              <div layout-align="center center" layout="column" layout-fill="layout-fill"\n                                    ng-if="ra.countOfMachineRuns > 0">\n                                    <!-- <p class="md-caption zp-caption">Machines</p> -->\n                                    <md-icon md-font-icon="zmdi zmdi-http"\n                                          style="fill: #949ca1; font-size: 30px;"></md-icon>\n                                    <!-- <md-icon md-font-icon="zmdi zmdi-android-alt" style="fill: #949ca1; font-size: 30px;"></md-icon> -->\n                                    <p class="md-display-1 zp-caption margin-bottom-0 margin-top-10"\n                                          countupto="ra.countOfMachineRuns" decimals="0" duration="1.8"></p>\n                                    <p class="md-caption zp-caption margin-bottom-0 margin-top-0">Machines ran</p>\n                                    <!-- <md-tooltip>Machines ran</md-tooltip> -->\n                              </div>\n\n                              <div layout-align="center center" layout="column" layout-fill="layout-fill"\n                                    ng-if="ra.countOfMachineRuns > 0">\n                                    <!-- <p class="md-caption zp-caption">Successful runs</p> -->\n                                    <md-icon md-font-icon="zmdi zmdi-thumb-up"\n                                          style="fill: #949ca1; font-size: 30px;"></md-icon>\n                                    <p class="md-display-1 zp-caption margin-bottom-0 margin-top-10"\n                                          countupto="(ra.countOfMachineRuns - ra.countOfUnsuccessfulPushAttempts)"\n                                          decimals="0" duration="1.8"></p>\n                                    <p class="md-caption zp-caption margin-bottom-0 margin-top-0">Successful push\n                                          attempts</p>\n                                    <!-- <md-tooltip>Successful machine runs</md-tooltip> -->\n                              </div>\n\n                              <div layout-align="center center" layout="column" layout-fill="layout-fill"\n                                    ng-if="ra.countOfMachineRuns > 0">\n                                    <!-- <p class="md-caption zp-caption">Unsuccessful runs</p> -->\n                                    <md-icon md-font-icon="zmdi zmdi-thumb-down"\n                                          style="fill: #949ca1; font-size: 30px;"></md-icon>\n                                    <p class="md-display-1 zp-caption margin-bottom-0 margin-top-10"\n                                          countupto="ra.countOfUnsuccessfulPushAttempts" decimals="0" duration="1.8">\n                                    </p>\n                                    <p class="md-caption zp-caption margin-bottom-0 margin-top-0">Unsuccessful push\n                                          attempts</p>\n                                    <!-- <md-tooltip>unSuccessful machine runs</md-tooltip> -->\n                              </div>\n                              <div ng-if="ra.countOfMachineRuns == 0" layout-fill="layout-fill">\n                                    <p>No machines ran as a result of this release attempt</p>\n                              </div>\n                              <div layout-align="center center" layout="column" layout-fill="layout-fill">\n                                    <md-icon md-font-icon="zmdi zmdi-time-restore"\n                                          style="fill: #949ca1; font-size: 30px;"></md-icon>\n                                    <p class="md-caption zp-caption">Released</p>\n                                    <p class="md-caption zp-caption margin-bottom-0 margin-top-0">{{\n                                          ra.dtMachinesFinishedRunning | zpMomentFromNow }}</p>\n                              </div>\n                              <div flex="flex"></div>\n                              <div>\n                                    <md-button class="md-icon-button" ng-click="ra.showDetail = !ra.showDetail"\n                                          ng-class="{\'md-raised md-primary\' : ra.showDetail}">\n                                          <ng-md-icon\n                                                icon="{{ra.showDetail ? \'expand_more\': \'expand_less\'}}"></ng-md-icon>\n                                    </md-button>\n                              </div>\n                        </div>\n                        <md-content ng-show="ra.showDetail" layout="column" class="margin-top-10">\n                              <div ng-if="ra.countOfMachineRuns === 0" layout="row">\n                                    <p>If no machines ran, this is either because the form is set to manual release or\n                                          there were no matching conditions for a machine to run.</p>\n                                    <md-button ng-click="$ctrl.goToMachinesPage()" class="md-accent md-raised">\n                                          integration tool <md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon>\n                                    </md-button>\n                              </div>\n                              <div ng-if="ra.countOfMachineCrashes">\n                                    <h3 class="margin-bottom-0">\n                                          <md-icon md-font-icon="zmdi zmdi-alert-octagon"></md-icon>\n                                          Integration machine crash info\n                                    </h3>\n                                    <span>\n                                          {{ra.countOfMachineCrashes}}\n                                          machines crashed<br>\n                                          Most recent crash info:\n                                          {{ ra.mostRecentCrashInfo }}\n                                    </span>\n                              </div>\n\n                              <div>\n                                    <h3 class="margin-bottom-0">\n                                          <md-icon md-font-icon="zmdi zmdi-mail-reply"></md-icon>\n                                          {{ra.pushDocs.length}}\n                                          response\n                                          {{ ra.pushDocs.length == 1 ? \'doc\' : \'docs\' }}\n                                          created by this release attempt\n                                    </h3>\n                                    <div ng-repeat="doc in ra.pushDocs" layout-padding="layout-padding">\n                                          <div layout="row">\n                                                <div layout="row" layout-align="center center">\n                                                      <div style="margin-right: 10px;">\n                                                            <md-icon md-font-icon="zmdi zmdi-alert-triangle zuantPollen"\n                                                                  ng-if="!doc.success"></md-icon>\n                                                            <md-icon md-font-icon="zmdi zmdi-check zuantAqua"\n                                                                  ng-if="doc.success"></md-icon>\n                                                      </div>\n                                                      <img ng-src="{{\'/images/pngs/icons/third-party/salesforce-square.png\' | cdnAssets}}"\n                                                            style="max-width:40px;"\n                                                            ng-if="doc.interactionSubType === \'SFDC\'" />\n                                                      <img ng-src="{{\'/images/pngs/icons/third-party/eloqua-square.png\' | cdnAssets}}"\n                                                            style="max-width:40px;"\n                                                            ng-if="doc.interactionSubType === \'EloquaForm\'" />\n                                                      <img ng-src="{{\'/images/pngs/icons/third-party/http.png\' | cdnAssets}}"\n                                                            style="max-width:40px;"\n                                                            ng-if="doc.interactionSubType === \'HTTPPost\'" />\n                                                </div>\n                                                <span flex="flex"></span>\n                                                {{doc._lastmodifiedonservertime | date: \'medium\'}}\n                                          </div>\n                                          <p class="margin-top-0">\n                                                <b>Message:</b>\n                                                {{doc.narrative}}\n                                          </p>\n                                          <div ng-show="$ctrl.showJson">\n                                                <h3>Push doc JSON</h3>\n                                                <pre class="pre">{{doc | json}}</pre>\n                                          </div>\n                                          <md-divider ng-if="!$last"></md-divider>\n                                    </div>\n                              </div>\n                              <div ng-if="ra.recallDocs.length">\n                                    {{ ra.recallDocs.length }}\n                                    recalls\n                                    <div ng-repeat="doc in ra.recallDocs">\n                                          <div ng-show="$ctrl.showJson">\n                                                <h3>Recall doc JSON</h3>\n                                                <pre class="pre">{{doc | json}}</pre>\n                                          </div>\n                                    </div>\n                              </div>\n                              <div ng-if="ra.timeoutDocs.length">\n                                    {{ ra.timeoutDocs.length }}\n                                    timeouts\n                                    <div ng-repeat="doc in ra.timeoutDocs">\n                                          <div ng-show="$ctrl.showJson">\n                                                <h3>Timeout doc JSON</h3>\n                                                <pre class="pre">{{doc | json}}</pre>\n                                          </div>\n                                    </div>\n                              </div>\n                        </md-content>\n                        <div ng-show="$ctrl.showJson">\n                              <h1>Release attempt JSON</h1>\n                              <pre class="pre">{{ra | json}}</pre>\n                        </div>\n                  </div>\n            </md-card>\n      </md-dialog-content>\n\n</md-dialog>');
$templateCache.put('app/forms/main-page/dialogs/export-csv-dialog/dialog.tmpl.html','<md-dialog aria-label="CSV export dialog" flex="100" flex-gt-md="45">\n      <md-toolbar>\n        <div class="md-toolbar-tools">\n          <p class="md-title">Download Event Stats</p>\n          <span flex></span>\n          <md-button class="md-icon-button" ng-click="$ctrl.cancel()">\n            <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n          </md-button>\n        </div>\n      </md-toolbar>\n      <md-dialog-content layout-padding>\n        <form name="$ctrl.CSVExport">\n          <md-subheader>Events Overview</md-subheader>\n          <p>There are <strong class="ng-binding">{{$ctrl.leadcount}}</strong> leads and <strong class="ng-binding">{{$ctrl.parkedcount}}</strong> parked leads in this account spread out across <strong class="ng-binding">{{$ctrl.activeformscount}}</strong> of your <strong class="ng-binding">{{$ctrl.formscount}}</strong> events. </p>\n          <p ng-show=\'$ctrl.leadcount || $ctrl.parkedcount\'>The first lead was created on the <strong class="ng-binding">{{$ctrl.firstleadreceived}}</strong> and the most recently created on the <strong class="ng-binding">{{$ctrl.lastleadreceived}}</strong>.</p>\n          <md-card style="background-color: rgb(250,250,250); margin: 0px; box-shadow: none;">\n          <md-card-header>\n            <md-card-avatar>\n              <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-filter-list" style="background-color: rgba(0,0,0,0.20);"></md-icon>\n            </md-card-avatar>\n            <md-card-header-text flex>\n              <span class="md-title" style="color: rgba(0,0,0,0.54); font-size: 14px;"> Filter your lead count by date range</span>\n              <span class="md-subhead">All events will be exported. Set a date range to filter the lead count stats.</span>\n            </md-card-header-text>\n            <md-button class="md-icon-button" ng-click="$ctrl.showFiltersEvent()">\n              <ng-md-icon icon="{{$ctrl.showFilters ? \'expand_less\' : \'expand_more\'}}" style="fill: #949ca1;"></ng-md-icon>\n            </md-button>\n          </md-card-header>\n          <md-card-content ng-show="$ctrl.showFilters">\n            <md-list ng-cloak style="margin-top: 20px;">\n              <md-list-item style="margin-top: 5px;">\n                <md-input-container flex>\n                  <label>Startdate</label>\n                <md-datepicker\n                  flex\n                  ng-model="$ctrl.formProperties.startdate"\n                  md-placeholder="Start date"\n                  md-open-on-focus="true"\n                  ng-change="$ctrl.updateChangeDelta(\'startdate\', $ctrl.formProperties.startdate)"\n                  name="startdate"\n                  md-min-date="$ctrl.minDate"\n                  md-max-date="$ctrl.maxDate"\n                  required>\n                </md-datepicker>\n                <div ng-messages="$ctrl.CSVExport.startdate.$error">\n                  <div ng-message="valid">The entered value is not a date!</div>\n                  <div ng-message="mindate">Your start date has to be greater than or equal to the date at which the first lead was captured.</div>\n                  <div ng-message="maxdate">The entered value is greater than the available date boundaries</div>\n                  <div ng-message="required">This date is required!</div>\n                </div>\n              </md-input-container>\n              <md-input-container flex>\n                <label>Enddate</label>\n                <md-datepicker\n                  flex\n                  ng-model="$ctrl.formProperties.enddate"\n                  md-placeholder="End date"\n                  md-open-on-focus="true"\n                  ng-change="$ctrl.updateChangeDelta(\'enddate\', $ctrl.formProperties.enddate)"\n                  md-min-date="$ctrl.formProperties.startdate||$ctrl.minDate"\n                  md-max-date="$ctrl.maxDate"\n                  name="enddate"\n                  required>\n                </md-datepicker>\n                <div ng-messages="$ctrl.CSVExport.enddate.$error">\n                  <div ng-message="mindate">Your end date has to be greater than or equal to your start date</div>\n                  <div ng-message="valid">The entered value is not a date!</div>\n                  <div ng-message="maxdate">The entered value is greater than the available date boundaries</div>\n                  <div ng-message="required">This date is required!</div>\n                </div>\n              </md-input-container>\n            </md-list-item>\n            </md-list>\n            </md-card-content>\n            </md-card>\n          \n          <div ng-show="!$ctrl.showFilters || !$ctrl.CSVExport.$invalid">\n              <md-subheader class="md-no-sticky" style="margin-top: 10px;">Preview</md-subheader>\n              <div layout="row" layout-align="start center" ng-hide="$ctrl.simulating">\n                <md-button aria-label="Context menu" class="md-icon-button"\n                  ng-disabled="true">\n                  <md-icon md-font-icon="zmdi zmdi-account-box-mail"></md-icon>\n                </md-button>\n                \n                <p class="md-subhead" style="margin-left: 10px;">\n                  <strong>{{$ctrl.filtered_totalleads}}</strong> Leads\n                </p>\n              </div>\n            <div layout="row" layout-align="start center" ng-hide="$ctrl.simulating">\n              <md-button aria-label="Context menu" class="md-icon-button"\n                ng-disabled="true">\n                <md-icon md-font-icon="zmdi zmdi-parking"></md-icon>\n              </md-button>\n              \n                <p class="md-subhead" style="margin-left: 10px;">\n                  <strong>{{$ctrl.filtered_totalparkedleads}}</strong> Parked Leads\n                </p>\n            </div>\n\n            <div layout="row" layout-align="start center" ng-hide="$ctrl.simulating">\n              <md-button aria-label="Context menu" class="md-icon-button"\n                ng-disabled="true">\n                <md-icon md-font-icon="zmdi zmdi-assignment-o"></md-icon>\n              </md-button>\n              \n              <p class="md-subhead" style="margin-left: 10px;">\n                <strong>{{$ctrl.filtered_formcount}}</strong> Events with Leads\n              </p>\n            </div>\n          </div>\n          <md-list> \n          <md-list-item>\n            <md-button \n            ng-click="$ctrl.export($event)" \n            ng-disabled="$ctrl.loading || $ctrl.showFilters && $ctrl.CSVExport.$invalid"\n            layout-fill\n            class="md-raised md-accent">\n            <md-icon md-font-icon="zmdi zmdi-download"></md-icon>\n            Export CSV\n          </md-button>\n        </md-list-item>\n      <md-list-item>\n        <md-progress-linear ng-if="$ctrl.loading" class="md-accent"></md-progress-linear>\n      </md-list-item>\n      </md-list>\n    </md-dialog-content>\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n  </form>\n  </md-dialog>\n  \n');
$templateCache.put('app/forms/reporting/time-reports/time-report-widget/zp-time-report-widget.tmpl.html','<md-card flex class="chart-card">\n  <md-card-header layout="row">\n    <md-card-avatar>\n      <ng-md-icon ng-show="!!$ctrl.widgetData.metadata.icon" icon="{{$ctrl.widgetData.metadata.icon}}" size="30">\n      </ng-md-icon>\n      </md-icon>\n    </md-card-avatar>\n    <md-card-header-text>\n      <p class="md-body-2 zp-caption margin-top-0 margin-bottom-0 uppercase">{{$ctrl.widgetData.title}}</p>\n      <p class="md-caption zp-caption margin-top-0 margin-bottom-0">{{$ctrl.widgetData.subtitle}}</p>\n    </md-card-header-text>\n    <md-menu ng-if="$ctrl.widgetData.chart.options.availableChartTypes">\n      <md-button aria-label="Open chart menu" class="md-icon-button" ng-click="$mdMenu.open($event)">\n        <md-icon md-menu-origin md-font-icon="zmdi zmdi-more-vert"></md-icon>\n      </md-button>\n      <md-menu-content>\n        <md-menu-item ng-repeat="item in $ctrl.widgetData.chart.options.availableChartTypes">\n          <md-button ng-click="$ctrl.changeChartType($event, item.chart)">\n            <span md-menu-align-target>\n              <ng-md-icon icon="{{item.icon}}" style="fill: #949cad; margin-right: 16px;"></ng-md-icon>\n            </span>\n            <span style="text-transform: capitalize;">{{item.chart}} chart</span>\n          </md-button>\n        </md-menu-item>\n        <md-menu-item>\n          <md-button ng-click="$ctrl.widgetData.showTable = !$ctrl.widgetData.showTable">\n            <span md-menu-align-target>\n              <ng-md-icon icon="{{ $ctrl.widgetData.showTable ? \'visibility_off\' : \'visibility\' }}"\n                style="fill: #949cad; margin-right: 16px;"></ng-md-icon>\n            </span>\n            <span ng-show="!$ctrl.widgetData.showTable">Show</span>\n            <span ng-show="$ctrl.widgetData.showTable">Hide</span> Table\n          </md-button>\n        </md-menu-item>\n        <md-menu-item>\n          <md-button ng-click="$ctrl.goTo($event)">\n            <span md-menu-align-target>\n              <md-icon md-font-icon="zmdi zmdi-grid" style="color: #949cad;"></md-icon>\n            </span> View Grid Data\n          </md-button>\n        </md-menu-item>\n      </md-menu-content>\n    </md-menu>\n  </md-card-header>\n  <md-card-content layout-align="center center">\n    <md-progress-linear ng-if="$ctrl.widgetData.loading" class="md-accent" md-mode="indeterminate"></md-progress-linear>\n    <div ng-show="$ctrl.widgetData.isEmpty" layout-padding>\n      <p class="md-caption zp-caption margin-bottom-0 uppercase text-align-center">No Data</p>\n    </div>\n    <div layout="row">\n      <zp-chart ng-hide="$ctrl.widgetData.isEmpty" flex chart-data="$ctrl.widgetData.chart.data"\n        chart-labels="$ctrl.widgetData.chart.labels" chart-series="$ctrl.widgetData.chart.series"\n        chart-options="$ctrl.widgetData.chart.options" chart-type="$ctrl.widgetData.chart.type"\n        chart-click="$ctrl.chartClicked(chartEl)" chart-id="$ctrl.widgetData.id">\n      </zp-chart>\n    </div>\n    <zp-totals-table ng-show="$ctrl.widgetData.showTable" data="$ctrl.widgetData.tableData"\n      header="$ctrl.widgetData.header" flex="100">\n    </zp-totals-table>\n  </md-card-content>\n  <!-- <md-card-actions layout="row" layout-align="end center" style="background: #ecedef;">\n   <md-button class="md-icon-button" ng-click="$ctrl.goTo($event)">\n     <md-icon md-font-icon="zmdi zmdi-chart"></md-icon>\n     <md-tooltip>View charts</md-tooltip>\n   </md-button> -->\n  <!--\n  <md-button class="md-icon-button" ng-click="$ctrl.changeReportParamTo(\'MM/DD\')">\n    <md-icon md-font-icon="zmdi zmdi-plus"></md-icon>\n    <md-tooltip>By Day</md-tooltip>\n  </md-button>\n\n   <md-button class="md-icon-button" ng-click="$ctrl.changeReportParamTo(\'HH\')">\n      <md-icon md-font-icon="zmdi zmdi-plus"></md-icon>\n      <md-tooltip>By Hour</md-tooltip>\n    </md-button>\n    <md-button class="md-icon-button" ng-click="$ctrl.changeReportParamTo(\'mm\')">\n      <md-icon md-font-icon="zmdi zmdi-plus"></md-icon>\n      <md-tooltip>By Minute</md-tooltip>\n    </md-button> -->\n  <!-- </md-card-actions> -->\n</md-card>');
$templateCache.put('app/forms/reporting/column-summary-widget-component/widget-context-menu-component/zp-widget-context-menu.tmpl.html','<md-menu>\n  <md-button aria-label="Context menu" class="md-icon-button" ng-click="$ctrl.openMenu($mdOpenMenu, $event)">\n    <md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon>\n    <md-tooltip md-direction="down">more</md-tooltip>\n  </md-button>\n  <md-menu-content width="3">\n    <md-menu-item ng-repeat="item in $ctrl.menuOptions" ng-class="{\'selected\': item.label() == $ctrl.selectedItem }">\n      <md-button ng-click="$ctrl.menuItemClicked({event: $event, selectedMenuItem: item })" aria-label="{{item.ariaLabel}}">\n        <ng-md-icon ng-if="item.icon" icon="{{item.icon}}" style="fill: #555;" size="24"></ng-md-icon>\n         <md-icon ng-if="item.fonticon" md-font-icon="{{item.fonticon}}"></md-icon>\n        <!-- <md-icon ng-if="item.icon" md-font-icon="zmdi {{item.icon}}"></md-icon> -->\n        {{item.label()}}\n      </md-button>\n    </md-menu-item>\n  </md-menu-content>\n</md-menu>\n');
$templateCache.put('app/forms/settings-page/cards/team-tree-element/view.tmpl.html','<div ng-repeat="team in vm.teams" ng-show="(vm.level == 0 || vm.parent.open) && (team.shouldShow || vm.subTeamShouldShow(team.treeSubteams))">\r\n  <div class="team" layout="row" layout-align="space-between" ng-click="vm.selectTeam({ team: team })" ng-class="{\'active\': team.selected}">\r\n    <div flex="none" class="subteam-opener" ng-style="{\'margin-left\': vm.chevronMargin}" ng-click="vm.toggleChevron({ team: team, event: $event })">\r\n      <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-chevron-right" ng-show="team.subteams.length > 0 && !team.open"></md-icon>\r\n      <md-icon class="md-avatar-icon" md-font-icon="zmdi zmdi-chevron-down" ng-show="team.subteams.length > 0 && team.open"></md-icon>\r\n    </div>\r\n    <div flex="none">\r\n      <md-checkbox ng-model="team.selected" md-indeterminate="vm.isChildSelected(team)" ng-disabled="vm.parentSelected && vm.teams.length == 1" ng-checked="vm.parentSelected || team.selected" aria-label="select team checkbox" ng-change="vm.selectTeam({ team: team, value: team.selected, parent: vm.parentSelected })"></md-checkbox>\r\n    </div>\r\n    <div layout="column" flex="grow" class="team-name-container" ng-style="{\'max-width\': vm.calculateMaxWidth(vm.level)}">\r\n      <span flex class="name">{{team.name}}</span>\r\n      <span flex class="info">{{team.subteams.length}} subteams, {{team.members.length}} users</span>\r\n    </div>\r\n    <div ng-show="vm.level > 0" class="horizontal-line"\r\n      ng-style="team.subteams.length > 0 ? {\'width\': \'15px\', \'margin-left\': vm.chevronMargin} : {\'margin-left\': vm.chevronMargin}">\r\n    </div>\r\n    <div ng-repeat="i in vm.loopArray track by $index" ng-show="vm.shouldVerticalLineShow($index)" class="vertical-line"\r\n      ng-style="{\'margin-left\': vm.calculateMargin($index)}"></div>\r\n  </div>\r\n  <form-settings-team-tree-element teams="team.treeSubteams" parent="team" parent-selected="vm.parent.selected || team.selected" select-team="vm.selectTeam({ team: team, value: value, parent: parent })" level="vm.myLevel" toggle-chevron="vm.toggleChevron({ team: team, event: event })" indexes-to-miss="vm.calculateIndexesToMiss($last, vm.myLevel)"></team-tree-element>\r\n</div>\r\n');
$templateCache.put('app/forms/settings-page/dialogs/advanced-scanner-settings-dialog/dialog.tmpl.html','<md-dialog aria-label="Advanced scanner settings dialog dialog" flex="100" flex-gt-md="60">\n  <form>\n    <md-toolbar>\n      <div class="md-toolbar-tools">\n        <p class="md-title">Advanced scanner settings dialog</p>\n        <span flex></span>\n        <md-button class="md-icon-button" ng-click="$ctrl.cancel()">\n          <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n        </md-button>\n      </div>\n    </md-toolbar>\n    <md-dialog-content>\n      <md-subheader>Format</md-subheader>\n      <div layout-padding>\n        <md-input-container class="md-block">\n          <label>Start sequence</label>\n          <input type="text" ng-model="$ctrl.advancedScannerSettings.barcodeStartSequence" />\n        </md-input-container>\n        <md-input-container class="md-block">\n          <label>Exclude characters</label>\n          <input type="text" ng-model="$ctrl.advancedScannerSettings.barcodeExcludeChars" />\n        </md-input-container>\n        <md-input-container class="md-block">\n          <label>Decryption key</label>\n          <input type="text" ng-model="$ctrl.advancedScannerSettings.barcodeDecryptionKey" />\n        </md-input-container>\n        <md-input-container class="md-block">\n          <label>Decryption vector</label>\n          <input type="text" ng-model="$ctrl.advancedScannerSettings.barcodeDecryptionVector" />\n        </md-input-container>\n      </div>\n      <md-subheader>NFC</md-subheader>\n      <div layout-padding>\n        <md-input-container class="md-block">\n          <label>Type number</label>\n          <input type="text" ng-model="$ctrl.advancedScannerSettings.NFCNDEFTypeNo" />\n        </md-input-container>\n        <md-input-container class="md-block">\n          <label>Type name</label>\n          <input type="text" ng-model="$ctrl.advancedScannerSettings.NFCNDEFTypeName" />\n        </md-input-container>\n        <md-list>\n          <md-list-item>\n            <p>Display devices when form loads</p>\n            <md-switch\n              ng-model="$ctrl.advancedScannerSettings.NFCAutoDisplayPeripheralList"\n              aria-label="Automatically show NFC readers when form loads"\n              ng-true-value=1\n              ng-false-value=0>\n            </md-switch>\n          </md-list-item>\n        </md-list>\n      </div>\n    </md-dialog-content>\n    <md-dialog-actions layout="row">\n      <span flex></span>\n      <md-button ng-click="$ctrl.done()" aria-label="Done">\n        Done\n      </md-button>\n    </md-dialog-actions>\n  <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n</md-dialog>\n');
$templateCache.put('app/forms/settings-page/dialogs/barcode-fields-dialog/dialog.tmpl.html','<style>\n  .sortable-chosen {\n    background-color: none;\n  }\n</style>\n<md-dialog aria-label="Barcode field mappings dialog" flex="100" flex-gt-md="60">\n  <form>\n    <md-toolbar>\n      <div class="md-toolbar-tools">\n        <p class="md-title">Barcode Field Mappings</p>\n        <span flex></span>\n        <md-button class="md-icon-button" ng-click="$ctrl.cancel()">\n          <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n        </md-button>\n      </div>\n    </md-toolbar>\n    <md-dialog-content>\n      <div layout="row">\n        <div flex="50" style="border-right: 2px solid #FEC353;">\n          <md-subheader>Click the plus icon to add Zuant form fields to your barcode mapping</md-subheader>\n          <div layout-padding>\n            <md-list layout-padding z-ng-sortable="$ctrl.presetConfig">\n              <md-list-item ng-repeat="item in $ctrl.barcodePresetFields track by $index" aria-label="Preset field">\n                <p>{{item.dbElementName}}</p>\n                <md-icon></md-icon>\n                <span ng-show="item.count != 0" layout-margin class="badge">{{item.count}}</span>\n                <span class="md-caption zp-caption">{{item.dbObjectName}}</span>\n                <md-button class="md-icon-button" aria-label="add field" ng-click="$ctrl.addFieldToMappings(item)">\n                  <md-icon md-font-icon="zmdi zmdi-plus"></md-icon>\n                </md-button>\n                <md-divider></md-divider>\n              </md-list-item>\n            </md-list>\n          </div>\n        </div>\n        <div flex="50">\n          <md-subheader>Ordered list of fields within the barcode</md-subheader>\n          <div layout="row">\n            <span flex></span>\n            <md-button class="md-mini" ng-click="$ctrl.editingList = !$ctrl.editingList" ng-class="{\'md-raised md-accent\' : $ctrl.editingList}">Edit</md-button>\n          </div>\n          <div layout-padding>\n            <md-list ng-cloak ng-sortable="$ctrl.mappingsConfig" layout-padding>\n              <md-list-item ng-repeat="item in $ctrl.barcodeFieldMappings track by $index" class="draggable" aria-label="Barcode field mapping">\n                <p>{{item.dbElementName}}</p>\n                <md-icon></md-icon>\n                <span class="md-caption zp-caption">{{item.dbObjectName}}</span>\n                <md-button ng-show="$ctrl.editingList" class="md-icon-button" aria-label="drag handle" ng-click="$ctrl.removeMapping(item, $index)">\n                  <ng-md-icon icon="remove" style="fill: #949ca1;" size="24"></ng-md-icon>\n                </md-button>\n                <md-divider></md-divider>\n              </md-list-item>\n            </md-list>\n          </div>\n          <!-- <md-subheader>3rd list</md-subheader>\n          <div layout-padding>\n            <md-list ng-cloak ng-sortable="$ctrl.mappingsConfig2" layout-padding id="mappingsList">\n              <md-list-item ng-repeat="item in $ctrl.barcodeFieldMappings2 track by $index" aria-label="Barcode field mapping">\n                <p>{{item.dbElementName}}</p>\n                <md-icon></md-icon>\n                <span class="md-caption zp-caption">{{item.dbObjectName}}</span>\n                <md-button class="md-icon-button" aria-label="drag handle">\n                  <md-icon md-font-icon="zmdi zmdi-blur"></md-icon>\n                </md-button>\n                <md-divider></md-divider>\n              </md-list-item>\n            </md-list> -->\n          <!-- </div> -->\n        </div>\n      </div>\n    </md-dialog-content>\n    <md-dialog-actions layout="row">\n      <span flex></span>\n      <md-button ng-click="$ctrl.done()" aria-label="Done">\n        Done\n      </md-button>\n    </md-dialog-actions>\n  <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n</md-dialog>\n');
$templateCache.put('app/forms/settings-page/dialogs/camera-modes-dialog/dialog.tmpl.html','<md-dialog aria-label="Camera modes dialog" flex="100" flex-gt-md="60">\n      <form>\n            <md-toolbar>\n                  <div class="md-toolbar-tools">\n                        <p class="md-title">Camera Modes</p>\n                        <span flex></span>\n                        <md-button class="md-icon-button" ng-click="$ctrl.cancel()">\n                              <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n                        </md-button>\n                  </div>\n            </md-toolbar>\n            <md-dialog-content>\n                  <md-list>\n                        <md-subheader>2D Camera Modes</md-subheader>\n                        <md-list-item>\n                              <p>QR Code</p>\n                              <md-switch ng-model="$ctrl.cameraModes.allowCameraSymbologyQRCODE" aria-label="QR Code"\n                                    ng-true-value=1 ng-false-value=0></md-switch>\n                        </md-list-item>\n                        <md-divider></md-divider>\n                        <md-list-item>\n                              <p>PDF417</p>\n                              <md-switch ng-model="$ctrl.cameraModes.allowCameraSymbologyPDF417" aria-label="PDF417"\n                                    ng-true-value=1 ng-false-value=0></md-switch>\n                        </md-list-item>\n                        <md-divider></md-divider>\n                        <md-list-item>\n                              <p>Data Matrix</p>\n                              <md-switch ng-model="$ctrl.cameraModes.allowCameraSymbologyDM" aria-label="Data Matrix"\n                                    ng-true-value=1 ng-false-value=0></md-switch>\n                        </md-list-item>\n                        <md-divider></md-divider>\n                        <md-list-item>\n                              <p>Aztec</p>\n                              <md-switch ng-model="$ctrl.cameraModes.allowCameraSymbologyAZTEC" aria-label="Aztec"\n                                    ng-true-value=1 ng-false-value=0></md-switch>\n                        </md-list-item>\n                        <md-subheader>1D Camera Modes</md-subheader>\n                        <md-list-item>\n                              <p>Code 25</p>\n                              <md-switch ng-model="$ctrl.cameraModes.allowCameraSymbology25" aria-label="Code 25"\n                                    ng-true-value=1 ng-false-value=0></md-switch>\n                        </md-list-item>\n                        <div ng-show="$ctrl.cameraModes.allowCameraSymbology25">\n                              <md-list-item>\n                                    <p>Remove Code 25 check digit</p>\n                                    <md-switch ng-model="$ctrl.cameraModes.removeSymbology25CheckDigit"\n                                          aria-label="Remove Code 25 digit check" ng-true-value=1\n                                          ng-false-value=0></md-switch>\n                              </md-list-item>\n                              <md-list-item>\n                                    <span class="md-body-1" flex="30">Code 25 minimum digits</span>\n                                    <md-slider-container flex flex-offset-gt-md="10">\n                                          <md-slider flex="" ng-model="$ctrl.cameraModes.code25SymbologyMinLength"\n                                                min="0" max="100" aria-label="Code 25 min digits">\n                                          </md-slider>\n                                          <md-input-container>\n                                                <input flex="" type="number" min="0" max="100" step="1"\n                                                      ng-model="$ctrl.cameraModes.code25SymbologyMinLength"\n                                                      aria-label="Code 25 min digits">\n                                          </md-input-container>\n                                    </md-slider-container>\n                              </md-list-item>\n                        </div>\n                        <md-divider></md-divider>\n                        <md-list-item>\n                              <p>Code 39</p>\n                              <md-switch ng-model="$ctrl.cameraModes.allowCameraSymbology39" aria-label="Code 39"\n                                    ng-true-value=1 ng-false-value=0></md-switch>\n                        </md-list-item>\n                        <div ng-show="$ctrl.cameraModes.allowCameraSymbology39">\n                              <md-list-item>\n                                    <p>Remove Code 39 check digit</p>\n                                    <md-switch ng-model="$ctrl.cameraModes.removeSymbology39CheckDigit"\n                                          aria-label="Remove Code 39 digit check" ng-true-value=1\n                                          ng-false-value=0></md-switch>\n                              </md-list-item>\n                        </div>\n                        <md-divider></md-divider>\n                        <md-list-item>\n                              <p>Code 128</p>\n                              <md-switch ng-model="$ctrl.cameraModes.allowCameraSymbology128" aria-label="Code 128"\n                                    ng-true-value=1 ng-false-value=0></md-switch>\n                        </md-list-item>\n                        <div ng-show="$ctrl.cameraModes.allowCameraSymbology128">\n                              <md-list-item>\n                                    <p>Remove Code 128 check digit</p>\n                                    <md-switch ng-model="$ctrl.cameraModes.removeSymbology128CheckDigit"\n                                          aria-label="Remove Code 128 digit check" ng-true-value=1\n                                          ng-false-value=0></md-switch>\n                              </md-list-item>\n                        </div>\n                  </md-list>\n\n            </md-dialog-content>\n            <md-dialog-actions layout="row">\n                  <span flex></span>\n                  <md-button ng-click="$ctrl.done()" aria-label="Done">\n                        Done\n                  </md-button>\n            </md-dialog-actions>\n            <input type="hidden" name="CSRFToken" value="1231234567890" />\n      </form>\n</md-dialog>');
$templateCache.put('app/forms/settings-page/dialogs/data-load-contact-filters-dialog/dialog.tmpl.html','<md-dialog class="data-loads-contact-filters-dialog" aria-label="Data-load Filters Dialog" flex="100" flex-gt-md="60">\n    <form>\n        <md-toolbar>\n            <div class="md-toolbar-tools">\n                <p class="md-title">Data-load Contact Filters</p>\n                <span flex></span>\n                <md-button class="md-icon-button" ng-click="$ctrl.cancel()">\n                    <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n                </md-button>\n            </div>\n        </md-toolbar>\n        <md-dialog-content>\n            <md-list>\n                <md-subheader>Data-loads</md-subheader>\n                <div layout="column" layout-align="center center" ng-if="$ctrl.dataLoads.length === 0"\n                    class="no-loads-placeholder">\n                    <h2>\n                        No Data-loads exist within the account.\n                    </h2>\n                </div>\n                <md-list-item ng-repeat="load in $ctrl.dataLoads">\n                    <div flex layout="row" layout-align="space-between center">\n                        <div layout="column">\n                            <p class="margin-top-0 margin-bottom-0 md-body-1">Data-load Name: {{load.fileName}}\n                            </p>\n                            <p class="margin-top-0 margin-bottom-0 md-caption">Contacts: {{load.totalContacts}}</p>\n                            <p class="margin-top-0 margin-bottom-10 md-caption">Loaded by Zubot: {{load.zubotName}} on\n                                {{load.completedOn\n                                | date:\'MM/dd/yyyy\'}}</p>\n                        </div>\n\n                        <md-switch ng-model="load.isSelected" aria-label="{{load.fileName}}" ng-true-value=1\n                            ng-false-value=0></md-switch>\n                    </div>\n\n                    <md-divider></md-divider>\n\n                </md-list-item>\n            </md-list>\n\n        </md-dialog-content>\n        <md-dialog-actions layout="row">\n            <span flex></span>\n            <md-button ng-click="$ctrl.done()" aria-label="Done">\n                Done\n            </md-button>\n        </md-dialog-actions>\n        <input type="hidden" name="CSRFToken" value="1231234567890" />\n    </form>\n</md-dialog>');
$templateCache.put('app/forms/settings-page/dialogs/form-contact-filters-dialog/dialog.tmpl.html','<md-dialog class="form-contact-filters-dialog" aria-label="Form Contact Filters Dialog" flex="100" flex-gt-md="60">\n    <form>\n        <md-toolbar>\n            <div class="md-toolbar-tools">\n                <p class="md-title">Form Contact Filters</p>\n                <span flex></span>\n                <md-button class="md-icon-button" ng-click="$ctrl.cancel()">\n                    <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n                </md-button>\n            </div>\n        </md-toolbar>\n        <md-dialog-content>\n\n            <md-list>\n                <md-subheader>Settings</md-subheader>\n\n                <md-radio-group ng-change="$ctrl.selectedFilterSettingChanged()" ng-model="$ctrl.selectedFilterSetting"\n                    layout="column">\n                    <md-list-item ng-click="$ctrl.selectedFilterSettingChanged(\'no_filters\')" md-ink-ripple\n                        class="md-clickable">\n                        <p>No filters</p>\n                        <md-radio-button value="no_filters"></md-radio-button>\n                    </md-list-item>\n\n                    <md-divider></md-divider>\n\n                    <md-list-item ng-click="$ctrl.selectedFilterSettingChanged(\'current_form_only\')" md-ink-ripple\n                        class="md-clickable">\n                        <p>Current form only</p>\n                        <md-radio-button value="current_form_only"></md-radio-button>\n                    </md-list-item>\n\n                    <md-divider></md-divider>\n\n                    <md-list-item ng-click="$ctrl.selectedFilterSettingChanged(\'current_and_additional_forms\')"\n                        md-ink-ripple class="md-clickable">\n                        <p>Current form and additional forms from the list below</p>\n                        <md-radio-button value="current_and_additional_forms"></md-radio-button>\n                    </md-list-item>\n\n                </md-radio-group>\n            </md-list>\n\n            <md-list>\n                <md-subheader>Available forms</md-subheader>\n                <md-list-item ng-repeat="form in $ctrl.forms">\n                    <div flex layout="row" layout-align="space-between center">\n                        <div layout="column">\n                            <p class="margin-top-0 margin-bottom-0 md-body-1">Form Name: {{form.title}}</p>\n                            <p class="margin-top-0 margin-bottom-0 md-caption">Contacts: {{form.responseCount}}</p>\n                            <p class="margin-top-0 margin-bottom-0 md-caption">Start Date: {{form.startdate |\n                                date:\'MM/dd/yyyy\'}}</p>\n                            <p class="margin-top-0 margin-bottom-10 md-caption">End Date: {{form.enddate |\n                                date:\'MM/dd/yyyy\'}}</p>\n                        </div>\n\n                        <md-switch ng-model="form.isSelected"\n                            ng-disabled="form.disabled || $ctrl.selectedFilterSetting !== \'current_and_additional_forms\'"\n                            aria-label="{{form.title}}" ng-true-value=1 ng-false-value=0></md-switch>\n                    </div>\n                    <md-divider></md-divider>\n\n                </md-list-item>\n            </md-list>\n\n        </md-dialog-content>\n        <md-dialog-actions layout="row">\n            <span flex></span>\n            <md-button ng-click="$ctrl.done()" aria-label="Done">\n                Done\n            </md-button>\n        </md-dialog-actions>\n        <input type="hidden" name="CSRFToken" value="1231234567890" />\n    </form>\n</md-dialog>');
$templateCache.put('app/forms/settings-page/dialogs/form-settings-help/dialog.tmpl.html','<md-dialog aria-label="Scanner auto submit dialog" flex="100" flex-gt-md="60">\n  <form>\n    <md-toolbar>\n      <div class="md-toolbar-tools">\n        <p class="md-title">Form settings help</p>\n        <span flex></span>\n        <md-button class="md-icon-button" ng-click="$ctrl.cancel()">\n          <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n        </md-button>\n      </div>\n    </md-toolbar>\n    <md-dialog-content>\n      <div ng-show="$ctrl.topic === \'blocks\'" layout-padding>\n        <p class="md-body-1">\n          {{$ctrl.formPropertyHelpers.blocksMenu.useBlocksMenu}} <br>\n          There are some settings to note for the blocks showroom configuration which are detailed below\n        </p>\n        <md-list>\n          <md-list-item>\n            Showroom can be dismissed: {{$ctrl.formPropertyHelpers.blocksMenu.showroomCanBeDismissed}}\n          </md-list-item>\n          <md-list-item>\n            Navigation back button available: {{$ctrl.formPropertyHelpers.blocksMenu.navigationBackButtonAvailable}}\n          </md-list-item>\n          <md-list-item>\n            Filters available: {{$ctrl.formPropertyHelpers.blocksMenu.filtersAvailable}}\n          </md-list-item>\n          <md-list-item>\n            Entry block: {{$ctrl.formPropertyHelpers.blocksMenu.entryBlock}}\n          </md-list-item>\n        </md-list>\n        <p class="md-body-2">The rest of the settings are presentational and will live update in the preview pane when adjusted.</p>\n      </div>\n\n    </md-dialog-content>\n    <md-dialog-actions layout="row">\n      <span flex></span>\n      <md-button ng-click="$ctrl.done()" aria-label="Done">\n        Done\n      </md-button>\n    </md-dialog-actions>\n  <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n</md-dialog>\n');
$templateCache.put('app/forms/settings-page/dialogs/post-show-email-dialog/dialog.tmpl.html','<md-dialog aria-label="Post-show email send dialog" flex="100" flex-gt-md="50">\n  <md-toolbar aria-label="post-show email send dialog toolbar">\n    <div class="md-toolbar-tools">\n      <p class="md-subhead">Configure and Send Emails</p>\n      <span flex></span>\n      <zp-context-menu ng-show="$ctrl.tabInView == \'sendEmails\'" menu-options="$ctrl.menuOptions"\n        on-menu-click="$ctrl.onMenuClick({action:action, ev: ev})" permission permission-only="\'ZUANT_ADMIN\'">\n      </zp-context-menu>\n      <md-button ng-click="$ctrl.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-dialog-content>\n    <md-tabs md-dynamic-height md-border-bottom>\n      <md-tab label="Change Template" ng-click="$ctrl.tabInView = \'changeTemplate\'">\n        <div ng-include="\'app/forms/settings-page/dialogs/post-show-email-dialog/change-template/tmpl.html\'">\n        </div>\n      </md-tab>\n      <md-tab label="Send Emails" ng-click="$ctrl.tabInView = \'sendEmails\'">\n        <div ng-include="\'app/forms/settings-page/dialogs/post-show-email-dialog/post-show-email-send/tmpl.html\'">\n        </div>\n      </md-tab>\n      <md-tab label="Past Activity" ng-show="$ctrl.templatesSentInfo.templatesSent.length > 0"\n        ng-click="$ctrl.tabInView = \'previousActivity\'">\n        <div ng-include="\'app/forms/settings-page/dialogs/post-show-email-dialog/previous-activity/tmpl.html\'"></div>\n      </md-tab>\n    </md-tabs>\n\n    <md-dialog-actions layout="column" layout-fill>\n      <md-progress-linear ng-if="$ctrl.sending"></md-progress-linear>\n\n      <md-button ng-show="$ctrl.showSendBtn && $ctrl.tabInView == \'sendEmails\'" ng-click="$ctrl.send($event)"\n        layout-fill ng-disabled="!$ctrl.emailTemplate || $ctrl.disableSendButton"\n        ng-class="{\'md-raised\' : $ctrl.emailTemplate}" class="md-raised md-accent">\n        <md-icon md-font-icon="zmdi zmdi-mail-send"></md-icon>\n        &nbsp; Send {{$ctrl.countOfContactsThatWillReceiveEmail.length}}\n        <ng-pluralize count="$ctrl.countOfContactsThatWillReceiveEmail.length" when="{\'0\': \' emails now\',\n              \'1\': \' email now\',\n              \'other\': \' emails now\'}">\n        </ng-pluralize>\n      </md-button>\n      <div layout="row" layout-align="center center" layout-fill>\n        <md-button flex="33"\n          ng-show="$ctrl.showDoneBtn && ($ctrl.tabInView === \'changeTemplate\' || $ctrl.tabInView == \'sendEmails\')"\n          ng-click="$ctrl.cancelDialog()" layout-fill class="md-primary md-raised">\n          Close\n        </md-button>\n      </div>\n    </md-dialog-actions>\n  </md-dialog-content>\n</md-dialog>');
$templateCache.put('app/forms/settings-page/dialogs/scan-auto-submit-dialog/dialog.tmpl.html','<md-dialog aria-label="Scanner auto submit dialog" flex="100" flex-gt-md="60">\n  <form>\n    <md-toolbar>\n      <div class="md-toolbar-tools">\n        <p class="md-title">Scanner auto-submit</p>\n        <span flex></span>\n        <md-button class="md-icon-button" ng-click="$ctrl.cancel()">\n          <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n        </md-button>\n      </div>\n    </md-toolbar>\n    <md-dialog-content>\n      <md-list>\n        <md-list-item>\n          <p>Automatically submit a lead after scanning</p>\n          <md-switch\n            ng-model="$ctrl.scanAutoSubmitSettings.automaticallySubmitLeadAfterScanning"\n            aria-label="Automatically submit lead after scanning"\n            ng-true-value=1\n            ng-false-value=0>\n          </md-switch>\n        </md-list-item>\n        <md-divider></md-divider>\n        <md-list-item>\n          <p>Allow duplicate scans</p>\n          <md-switch\n            ng-model="$ctrl.scanAutoSubmitSettings.allowDuplicateScansAfterScanning"\n            aria-label="Allow duplicate scans after scanning"\n            ng-true-value=1\n            ng-false-value=0\n            ng-disabled="!$ctrl.scanAutoSubmitSettings.automaticallySubmitLeadAfterScanning">\n          </md-switch>\n        </md-list-item>\n        <!-- <md-divider></md-divider> -->\n        <md-list-item>\n          <p>Ignore lookup providers internet connection issues</p>\n          <md-switch\n            ng-model="$ctrl.scanAutoSubmitSettings.ignoreLookupProvidersInternetConnectionIssuesAfterScanning"\n            aria-label="Code 128"\n            ng-true-value=1\n            ng-false-value=0\n            ng-disabled="!$ctrl.scanAutoSubmitSettings.automaticallySubmitLeadAfterScanning">\n          </md-switch>\n        </md-list-item>\n        <!-- <md-divider></md-divider> -->\n        <md-list-item>\n          <p>Ignore form validation issues</p>\n          <md-switch\n            ng-model="$ctrl.scanAutoSubmitSettings.ignoreFormValidationIssuesAfterScanning"\n            aria-label="Ignore form validation issues after scanning"\n            ng-true-value=1\n            ng-false-value=0\n            ng-disabled="!$ctrl.scanAutoSubmitSettings.automaticallySubmitLeadAfterScanning">\n          </md-switch>\n        </md-list-item>\n      </md-list>\n    </md-dialog-content>\n    <md-dialog-actions layout="row">\n      <span flex></span>\n      <md-button ng-click="$ctrl.done()" aria-label="Done">\n        Done\n      </md-button>\n    </md-dialog-actions>\n  <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n</md-dialog>\n');
$templateCache.put('app/forms/settings-page/dialogs/scan-lookup-providers-dialog/dialog.tmpl.html','<md-dialog aria-label="Scan Lookup Providers dialog" flex="100" flex-gt-md="60">\n  <md-toolbar>\n    <div class="md-toolbar-tools">\n      <p class="md-title">Scan Lookup Providers</p>\n      <span flex></span>\n      <md-button class="md-icon-button" ng-click="$ctrl.cancel()">\n        <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-dialog-content>\n    <form name="$ctrl.formObject">\n\n      <md-tabs md-dynamic-height md-border-bottom layout-align="center center">\n        <md-tab label="Experient">\n          <div layout-padding>\n            <md-list>\n              <md-list-item>\n                <md-icon md-font-icon="zmdi zmdi-leak"></md-icon>\n                <p>Use Experient API service?</p>\n                <md-switch ng-model="$ctrl.scanSettings.experientOn" ng-true-value=1 ng-false-value=0\n                  aria-label=""></md-switch>\n              </md-list-item>\n            </md-list>\n            <div layout="row">\n              <md-input-container flex="70">\n                <label>API Key</label>\n                <input name="experientApiKey" ng-model="$ctrl.scanSettings.experientApiKey"\n                  ng-disabled="!$ctrl.scanSettings.experientOn">\n              </md-input-container>\n              <md-input-container flex="30">\n                <label>Activation Code</label>\n                <input name="experientActCode" ng-model="$ctrl.scanSettings.experientActCode"\n                  ng-disabled="!$ctrl.scanSettings.experientOn">\n              </md-input-container>\n            </div>\n            <div layout="row">\n              <md-input-container flex="30">\n                <label>Badge ID</label>\n                <input name="experientBadgeId" ng-model="$ctrl.scanSettings.experientBadgeId"\n                  ng-disabled="!$ctrl.scanSettings.experientOn">\n              </md-input-container>\n              <md-input-container flex="70">\n                <label>Base URL</label>\n                <input name="experientBaseUrl" ng-model="$ctrl.scanSettings.experientBaseUrl"\n                  ng-disabled="!$ctrl.scanSettings.experientOn">\n              </md-input-container>\n            </div>\n            <md-list>\n              <md-list-item>\n                <p>Concatenate Phone Extension</p>\n                <md-switch name="experientConcatenatePhone" ng-model="$ctrl.scanSettings.experientConcatenatePhone"\n                  ng-disabled="!$ctrl.scanSettings.experientOn" aria-label="" ng-true-value=1\n                  ng-false-value=0></md-switch>\n              </md-list-item>\n              <md-list-item>\n                <div flex="20" layout layout-align="start center">\n                  <span class="md-body-1">Experient timeout</span>\n                </div>\n                <md-slider-container flex flex-offset-gt-md="10">\n                  <md-slider ng-disabled="!$ctrl.scanSettings.experientOn" flex\n                    ng-model="$ctrl.scanSettings.experientTimeout" min="0" max="15" aria-label="Experient timeout">\n                  </md-slider>\n                  <md-input-container>\n                    <input name="experientTimeout" flex type="number" min="0" max="15" step="1"\n                      ng-model="$ctrl.scanSettings.experientTimeout" aria-label="Experient timeout"\n                      ng-disabled="!$ctrl.scanSettings.experientOn">\n                  </md-input-container>\n                </md-slider-container>\n              </md-list-item>\n            </md-list>\n          </div>\n        </md-tab>\n        <md-tab label="Compusystems">\n          <div layout-padding>\n            <md-list>\n              <md-list-item>\n                <md-icon md-font-icon="zmdi zmdi-leak"></md-icon>\n                <p>Use Compusystems API service?</p>\n                <md-switch ng-model="$ctrl.scanSettings.compusystemsOn" ng-true-value=1 ng-false-value=0\n                  aria-label=""></md-switch>\n              </md-list-item>\n            </md-list>\n            <div layout="row">\n              <md-input-container flex="30">\n                <label>Event ID</label>\n                <input name="compusystemsEventId" ng-model="$ctrl.scanSettings.compusystemsEventId"\n                  ng-disabled="!$ctrl.scanSettings.compusystemsOn">\n              </md-input-container>\n              <md-input-container flex="70">\n                <label>Token</label>\n                <input name="compusystemsToken" ng-model="$ctrl.scanSettings.compusystemsToken"\n                  ng-disabled="!$ctrl.scanSettings.compusystemsOn">\n              </md-input-container>\n            </div>\n            <md-input-container class="md-block">\n              <label>Base URL</label>\n              <input name="compusystemsBaseUrl" ng-model="$ctrl.scanSettings.compusystemsBaseUrl"\n                ng-disabled="!$ctrl.scanSettings.compusystemsOn">\n            </md-input-container>\n            <div layout="row">\n              <div flex="20" layout layout-align="center center">\n                <span class="md-body-1">Compusystems timeout</span>\n              </div>\n              <md-slider-container flex flex-offset-gt-md="10">\n                <md-slider flex min="0" max="15" ng-model="$ctrl.scanSettings.compusystemsTimeout"\n                  ng-disabled="!$ctrl.scanSettings.compusystemsOn">\n                </md-slider>\n                <md-input-container>\n                  <input name="compusystemsTimeout" flex type="number" min="0" max="15" step="1"\n                    ng-model="$ctrl.scanSettings.compusystemsTimeout" ng-disabled="!$ctrl.scanSettings.compusystemsOn">\n                </md-input-container>\n              </md-slider-container>\n            </div>\n          </div>\n        </md-tab>\n        <md-tab label="Zuant">\n          <div layout-padding>\n            <md-list>\n              <md-list-item>\n                <md-icon md-font-icon="zmdi zmdi-leak"></md-icon>\n                <p>Use Zuant API service?</p>\n                <md-switch ng-model="$ctrl.scanSettings.zuantWebLookupOn" ng-true-value=1 ng-false-value=0\n                  aria-label=""></md-switch>\n              </md-list-item>\n            </md-list>\n            <div layout="row" layout-align="space-between center">\n              <md-input-container flex="30">\n                <label>System name</label>\n                <input name="zuantWebLookupSystem" ng-model="$ctrl.scanSettings.zuantWebLookupSystem"\n                  ng-disabled="!$ctrl.scanSettings.zuantWebLookupOn">\n              </md-input-container>\n              <md-input-container flex="30">\n                <label>Token 1</label>\n                <input name="zuantWebLookupToken1" ng-model="$ctrl.scanSettings.zuantWebLookupToken1"\n                  ng-disabled="!$ctrl.scanSettings.zuantWebLookupOn">\n              </md-input-container>\n              <md-input-container flex="30">\n                <label>Token 2</label>\n                <input name="zuantWebLookupToken2" ng-model="$ctrl.scanSettings.zuantWebLookupToken2"\n                  ng-disabled="!$ctrl.scanSettings.zuantWebLookupOn">\n              </md-input-container>\n            </div>\n            <md-input-container class="md-block">\n              <label>Base URL</label>\n              <input name="zuantWebLookupBaseUrl" ng-model="$ctrl.scanSettings.zuantWebLookupBaseUrl"\n                ng-disabled="!$ctrl.scanSettings.zuantWebLookupOn">\n            </md-input-container>\n            <div layout="row">\n              <div layout-align="center center">\n                <span class="md-body-1">Zuant timeout</span>\n              </div>\n              <md-slider-container layout-margin="" flex>\n                <md-slider flex min="0" max="15" ng-model="$ctrl.scanSettings.zuantWebLookupTimeout"\n                  ng-disabled="!$ctrl.scanSettings.zuantWebLookupOn">\n                </md-slider>\n                <md-input-container>\n                  <input name="zuantWebLookupTimeout" flex type="number" min="0" max="15" step="1"\n                    ng-model="$ctrl.scanSettings.zuantWebLookupTimeout"\n                    ng-disabled="!$ctrl.scanSettings.zuantWebLookupOn">\n                </md-input-container>\n              </md-slider-container>\n            </div>\n          </div>\n\n        </md-tab>\n      </md-tabs>\n\n      <div ng-if="$ctrl.formObject.$invalid" class="scan-lookup-providers-error-list zuantSaffron" layout-padding>\n        Errors:\n        <ul>\n          <li ng-if="$ctrl.formObject.experientTimeout.$invalid" ng-messages="$ctrl.formObject.experientTimeout.$error">\n            <span ng-message="min">Experient - A minimum timeout of 0 seconds or more is required</span>\n            <span ng-message="max">Experient - A maximum timeout of 15 seconds or less is required</span>\n          </li>\n          <li ng-if="$ctrl.formObject.compusystemsTimeout.$invalid"\n            ng-messages="$ctrl.formObject.compusystemsTimeout.$error">\n            <span ng-message="min">Compusystems - A minimum timeout of 0 seconds or more is required</span>\n            <span ng-message="max">Compusystems - A maximum timeout of 15 seconds or less is required</span>\n          </li>\n          <li ng-if="$ctrl.formObject.zuantWebLookupTimeout.$invalid"\n            ng-messages="$ctrl.formObject.zuantWebLookupTimeout.$error">\n            <span ng-message="min">Zuant - A minimum timeout of 0 seconds or more is required</span>\n            <span ng-message="max">Zuant - A maximum timeout of 15 seconds or less is required</span>\n          </li>\n        </ul>\n      </div>\n\n    </form>\n  </md-dialog-content>\n  <md-dialog-actions layout="row">\n    <span flex></span>\n    <md-button ng-disabled="$ctrl.formObject.$invalid" ng-click="$ctrl.done()" aria-label="Done">\n      Done\n    </md-button>\n  </md-dialog-actions>\n  <input type="hidden" name="CSRFToken" value="1231234567890" />\n</md-dialog>');
$templateCache.put('app/forms/settings-page/dialogs/showroom-entry-block-dialog/dialog.tmpl.html','<md-dialog aria-label="Showroom entry block dialog" flex="100" flex-gt-md="60">\n  <form>\n    <md-toolbar>\n      <div class="md-toolbar-tools">\n        <p class="md-title">Blocks</p>\n        <span flex></span>\n        <md-button class="md-icon-button" ng-click="$ctrl.cancel()">\n          <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n        </md-button>\n      </div>\n    </md-toolbar>\n    <md-dialog-content>\n      <md-progress-linear class="md-accent" md-mode="indeterminate" ng-if="$ctrl.loading"></md-progress-linear>\n      <md-list>\n        <md-subheader>Select the entry block for the showroom when entered via this form</md-subheader>\n        <md-list-item ng-repeat-start="block in $ctrl.blocks track by block._id" ng-click="$ctrl.setEntryBlock(block)">\n          <p>{{ block.nameplate }}</p>\n          <p>{{ block.caption }}</p>\n\n        </md-list-item>\n        <md-divider ng-repeat-end></md-divider>\n    </md-dialog-content>\n    <md-dialog-actions layout="row">\n      <span flex></span>\n      <md-button ng-click="$ctrl.done()" aria-label="Done">\n        Done\n      </md-button>\n    </md-dialog-actions>\n  <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n</md-dialog>\n');
$templateCache.put('app/integration/dialogs/manage-logins-dialog/sfdc/tmpl.html','<div layout="row" flex layout-align="start center">\n\n  <div flex="40" layout-padding>\n\n    <div ng-include="$ctrl.zuantToSfdcSVG"></div>\n    <div>{{$ctrl.connectionStatusMessage}}</div>\n    <div style="color: red;">{{$ctrl.connectionErrorMessage}}</div>\n\n  </div>\n\n  <div flex>\n\n    <form layout="column" name="$ctrl.formname">\n\n      <md-input-container>\n        <label>URI</label>\n        <input ng-model="$ctrl.loginCredentials.uri" type="text" name="uri"\n          equired="{{$ctrl.platform.value === \'SFDC\'}}" />\n        <!-- <div class="hint">Note: This is typically </div> -->\n        <div ng-messages="$ctrl.formname.uri.$error">\n          <div ng-message="required">This is required.</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container>\n        <label>Client Id</label>\n        <input ng-model="$ctrl.loginCredentials.clientid" type="text" name="clientid"\n          required="{{$ctrl.platform.value === \'SFDC\'}}" />\n        <div ng-messages="$ctrl.formname.clientid.$error">\n          <div ng-message="required">This is required.</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container>\n        <label>Client secret</label>\n        <input ng-model="$ctrl.loginCredentials.clientsecret" type="text" name="clientsecret"\n          required="{{$ctrl.platform.value === \'SFDC\'}}" />\n        <div ng-messages="$ctrl.formname.clientsecret.$error">\n          <div ng-message="required">This is required.</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container>\n        <label>Security token</label>\n        <input ng-model="$ctrl.loginCredentials.securitytoken" type="text" name="securitytoken"\n          required="{{$ctrl.platform.value === \'SFDC\'}}" />\n        <div ng-messages="$ctrl.formname.securitytoken.$error">\n          <div ng-message="required">This is required.</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container>\n        <label>Username</label>\n        <input ng-model="$ctrl.loginCredentials.username" type="text" name="username"\n          required="{{$ctrl.platform.value === \'SFDC\'}}" />\n        <div ng-messages="$ctrl.formname.username.$error">\n          <div ng-message="required">This is required.</div>\n        </div>\n      </md-input-container>\n\n      <md-input-container>\n        <label>Password</label>\n        <input ng-model="$ctrl.loginCredentials.password"\n          type="{{$ctrl.passwordFieldTypeIsPassword == true ? \'password\' : \'text\'}}" name="password"\n          required="{{$ctrl.platform.value === \'SFDC\'}}" />\n        <md-icon ng-if="$ctrl.userIsAZam" style="color: rgba(0,0,0,0.12);"\n          md-font-icon="zmdi {{$ctrl.passwordFieldTypeIsPassword === true ? \'zmdi-eye-off\' : \'zmdi-eye\'}}"\n          ng-click="$ctrl.passwordFieldTypeIsPassword = !$ctrl.passwordFieldTypeIsPassword">\n          <md-tooltip>{{$ctrl.passwordFieldTypeIsPassword == true ? \'show passord\' : \'hide password\'}}</md-tooltip>\n        </md-icon>\n        <div ng-messages="$ctrl.formname.password.$error">\n          <div ng-message="required">This is required.</div>\n        </div>\n      </md-input-container>\n\n      <input type="hidden" name="CSRFToken" value="1231234567890" />\n\n    </form>\n\n  </div>');
$templateCache.put('app/integration/dialogs/manage-logins-dialog/eloqua/tmpl.html','<div layout="row" flex layout-align="start center">\n\n  <div flex="40" layout-padding>\n\n    <div ng-include="$ctrl.zuantToEloquaSVG"></div>\n\n    <div>{{$ctrl.connectionStatusMessage}}</div>\n\n    <div style="color: red;">{{$ctrl.connectionErrorMessage}}</div>\n\n  </div>\n\n  <div flex>\n\n    <form layout="column" name="$ctrl.formname">\n\n      <md-input-container>\n\n        <label>Instance Name</label>\n\n        <input ng-model="$ctrl.loginCredentials.instancename" type="text" name="instancename"\n          required="{{$ctrl.platform.value === \'Eloqua\'}}" />\n        <div ng-messages="$ctrl.formname.instancename.$error">\n\n          <div ng-message="required">This is required.</div>\n        </div>\n\n      </md-input-container>\n\n      <md-input-container>\n\n        <label>Username</label>\n\n        <input ng-model="$ctrl.loginCredentials.username" type="text" name="username"\n          required="{{$ctrl.platform.value === \'Eloqua\'}}" />\n\n        <div ng-messages="$ctrl.formname.username.$error">\n\n          <div ng-message="required">This is required.</div>\n\n        </div>\n\n      </md-input-container>\n\n      <md-input-container>\n\n        <label>Password</label>\n\n        <input ng-model="$ctrl.loginCredentials.password"\n          type="{{$ctrl.passwordFieldTypeIsPassword == true ? \'password\' : \'text\'}}" name="password"\n          required="{{$ctrl.platform.value === \'Eloqua\'}}" />\n\n        <md-icon ng-if="$ctrl.userIsAZam" style="color: rgba(0,0,0,0.12);"\n          md-font-icon="zmdi {{$ctrl.passwordFieldTypeIsPassword === true ? \'zmdi-eye-off\' : \'zmdi-eye\'}}"\n          ng-click="$ctrl.passwordFieldTypeIsPassword = !$ctrl.passwordFieldTypeIsPassword">\n\n          <md-tooltip>{{$ctrl.passwordFieldTypeIsPassword == true ? \'show passord\' : \'hide password\'}}</md-tooltip>\n\n        </md-icon>\n\n        <div ng-messages="$ctrl.formname.password.$error">\n\n          <div ng-message="required">This is required.</div>\n\n        </div>\n\n      </md-input-container>\n\n      <input type="hidden" name="CSRFToken" value="1231234567890" />\n\n    </form>\n\n  </div>\n\n</div>');
$templateCache.put('app/integration/field-mappings-page/left-sidebar/zp-sidebar/tmpl.html','<md-card\n  permission permission-only="\'INTEGRATION_MACHINES_EDIT\'">\n  <div ng-show="$ctrl.viewModel.showDropArea"\n    layout-padding\n    layout="column"\n    layout-align="center center">\n    <md-icon md-font-icon="zmdi zmdi-delete"></md-icon>\n    <p class="zp-caption">Drop fields below to unmap</p>\n    <div layout-fill dnd-list="$ctrl.trash" style="border: 2px dotted #949ca1; min-height: 52px;"></div>\n  </div>\n\n  <md-list class="no-padding">\n    <zp-zuant-fields-list items="$ctrl.viewModel.zuantFields.companies" collection="\'companies\'" icon="\'zmdi-city-alt\'"></zp-zuant-fields-list>\n    <zp-zuant-fields-list items="$ctrl.viewModel.zuantFields.contacts" collection="\'contacts\'" icon="\'zmdi-account\'"></zp-zuant-fields-list>\n    <zp-zuant-fields-list items="$ctrl.viewModel.zuantFields.responses" collection="\'responses\'" icon="\'zmdi-edit\'"></zp-zuant-fields-list>\n    <zp-zuant-fields-list items="$ctrl.viewModel.zuantFields.static" collection="\'static\'" icon="\'zmdi-info\'"></zp-zuant-fields-list>\n  </md-list>\n</md-card>\n');
$templateCache.put('app/integration/field-mappings-page/left-sidebar/zp-zuant-fields-list/tmpl.html','<md-subheader>\n  <div layout="row" layout-align="center center">\n    <md-icon md-font-icon="zmdi {{$ctrl.icon}}" class="mappingIcn"></md-icon>\n    <span>{{$ctrl.collection | zpCapitalizeWord}} fields</span>\n    <span flex></span>\n    <md-button class="md-icon-button" ng-click="$ctrl.showList = !$ctrl.showList" aria-label="show list">\n      <ng-md-icon icon="{{ $ctrl.showList ? \'expand_less\' : \'expand_more\'}}"></ng-md-icon>\n    </md-button>\n  </div>\n</md-subheader>\n\n<md-list-item\n  ng-repeat="item in $ctrl.items"\n  dnd-draggable="item"\n  class="list-item secondary-button-padding animated"\n  ng-class="{\'fadeOutUp\' : !$ctrl.showList, \'fadeInDown\' : $ctrl.showList}"\n  ng-show="$ctrl.showList">\n  <p class="md-subhead">{{item.element}}</p>\n  <span\n    ng-show="$ctrl.viewModel.zuantFieldMappingCounts[[item.collection] +\'_\'+ [item.element]] >= 1"\n    class="mapping-count-badge">\n    {{$ctrl.viewModel.zuantFieldMappingCounts[[item.collection] +\'_\'+ [item.element]]}}\n  </span>\n  <div class="md-icon-button list-item-handle" ng-if="$ctrl.viewModel.zuantFieldMappingCounts[[item.collection] +\'_\'+ [item.element]] === 0">\n    <md-icon md-font-icon="zmdi zmdi-blur"></md-icon>\n  </div>\n  <md-divider ng-if="!$last"></md-divider>\n</md-list-item>\n <md-button class="md-accent" ng-click="$ctrl.toggleShowNewFieldForm()" ng-show="$ctrl.showList" aria-label="show form">\n    <ng-md-icon icon="{{ $ctrl.showNewFieldForm ? \'expand_less\' : \'expand_more\'}}"></ng-md-icon>      \n    <span ng-show="!$ctrl.showNewFieldForm">Add {{$ctrl.collection | zpCapitalizeWord}} field</span>\n    <span ng-show="$ctrl.showNewFieldForm">Close form</span>\n  </md-button>\n<md-list-item class="margin-top-10" ng-show="$ctrl.showList && $ctrl.showNewFieldForm">\n    <form ng-submit="$ctrl.submitAddFieldForm()" layout="column" flex name="$ctrl.newFieldForm">\n      <p ng-show="$ctrl.collection !== \'static\'">Use the input control below to add a field to this db collection. It will then be available for mapping.</p>\n      <p ng-show="$ctrl.collection === \'static\'">Mapping a field with a static value is handy for values you want to appear in every lead. Think of it as an alterantive to a hidden field with a default value.</p>\n\n      <md-input-container>\n        <label>New {{$ctrl.collection | zpCapitalizeWord}} field</label>\n        <input type="text" ng-model="$ctrl.newField.dbname" name="field" required="true" md-autofocus />\n        <div class="hint"  ng-show="$ctrl.collection !== \'static\'">Use the database fieldname</div>\n        <div class="hint"  ng-show="$ctrl.collection === \'static\'">The value will map exactly as you enter it here</div>\n      </md-input-container>\n      <md-button class="md-raised md-accent" type="submit" ng-disabled="$ctrl.newFieldForm.$invalid">Add field</md-button>\n    <input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n  </md-list-item>\n  ');
$templateCache.put('app/integration/field-mappings-page/spof/zp-add-mapping-row/tmpl.html','<p>Add new mapping rows here by entering the foreign field names into the form below.</p>\n\n<form ng-submit="$ctrl.addRow()" name="$ctrl.form">\n  <div layout="row" layout-padding="">\n\n    <md-input-container flex>\n      <label>Foreign fieldname</label>\n      <input ng-model="$ctrl.formObj.newField" placeholder="name of field you wish to map to" name="newField" required />\n      <div ng-messages="$ctrl.form.newField.$error" md-auto-hide="true">\n        <div ng-message when="required">\n          <spanThis cannot be blank</span>\n        </div>\n      </div>\n    </md-input-container>\n\n    <div>\n      <md-button type="submit" class="md-accent" ng-class="{\'md-raised\' : $ctrl.form.$valid}" ng-disabled="!$ctrl.form.$valid">Add field</md-button>\n    </div>\n  </div>\n<input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n');
$templateCache.put('app/integration/field-mappings-page/spof/zp-mappings/tmpl.html','<md-content layout="column" layout-fill>\n  <div layout="row">\n    <!-- <md-card ng-if="$ctrl.viewModel.showThirdPartyConnectionError" flex="80" flex-gt-md="20" flex-offset-md="10" flex-lg="90" flex-offset-lg="5" palette-background="zuant-pollen:400" background="primary"> -->\n    <md-card ng-if="$ctrl.viewModel.showThirdPartyConnectionError" flex palette-background="zuant-pollen:400"\n      background="primary">\n      <md-card-content>\n        <h2>Something went wrong... The connection to {{$ctrl.currentMachine.actuator.system}} failed</h2>\n        <p ng-if="$ctrl.viewModel.loadedFromCache">\n          Showing {{$ctrl.currentMachine.actuator.system}} fields that were cached at\n          {{$ctrl.viewModel.cachedFieldsTimestamp | date: \'medium\'}}\n        </p>\n        <h3>Error message: </h3>\n        {{ $ctrl.viewModel.connectionError | json }}\n      </md-card-content>\n    </md-card>\n  </div>\n  <div layout-margin ng-if="$ctrl.currentMachine.actuator.system === \'Eloqua\'" permission permission-only="\'TRUMP\'">\n    <p>This machine is set to use the {{$ctrl.currentMachine.actuator.action === \'replicate\' ? \'SOAP\' : \'REST\'}} api</p>\n  </div>\n  <div layout="row">\n    <!-- <md-card flex="80" flex-gt-md="20" flex-offset-md="10" flex-lg="90" flex-offset-lg="5"> -->\n    <md-card flex>\n      <md-card-content>\n        <zp-add-mapping-row ng-if="$ctrl.currentMachine.actuator.system === \'HttpPost\'">\n        </zp-add-mapping-row>\n\n        <md-table-container flex>\n          <table class="md-table">\n            <thead class="md-head" fix-head>\n              <tr class="md-row" md-row>\n                <th class="md-column">\n                  <span class="zp-caption">\n                    {{$ctrl.viewModel.mappedFields | numKeys}} ZUANT FIELD<span\n                      ng-show="($ctrl.viewModel.mappedFields | numKeys) === 0 || ($ctrl.viewModel.mappedFields | numKeys) > 1">S</span>\n                    MAPPED\n                    <span ng-show="($ctrl.viewModel.mappedFields | numKeys) === 0">, DRAG FIELDS BELOW TO MAP\n                      THEM</span>\n                  </span>\n                </th>\n                <th class="icon-cell"></th>\n                <th class="icon-cell"></th>\n                <th layout="row" layout-align="end center">\n                  <img ng-src="{{\'/images/pngs/icons/third-party/salesforce-square.png\' | cdnAssets}}"\n                    ng-show="$ctrl.currentMachine.actuator.system == \'SFDC\'" width="50px" />\n                  <img ng-src="{{\'/images/pngs/icons/third-party/eloqua-square.png\' | cdnAssets}}"\n                    ng-show="$ctrl.currentMachine.actuator.system == \'Eloqua\'" width="50px" />\n                  <img ng-src="{{\'/images/pngs/icons/third-party/http.png\' | cdnAssets}}"\n                    ng-show="$ctrl.currentMachine.actuator.system == \'HttpPost\'" width="50px" />\n                  <span class="zp-caption">\n                    FIELDS\n                  </span>\n                </th>\n              </tr>\n            </thead>\n            <!-- table body  //-->\n            <tbody class="md-body">\n              <tr>\n                <md-progress-linear md-mode="indeterminate" class="md-accent"\n                  ng-if="$ctrl.viewModel.loadingForeignFieldsIndicator">\n                </md-progress-linear>\n              </tr>\n              <tr ng-repeat="row in $ctrl.proxyMappings" class="md-row" ng-class="{\'isDirty\' : row.isDirty}">\n                <td class="md-cell" dnd-list="$ctrl.proxyMappings[$index].mapping"\n                  dnd-draggable="$ctrl.proxyMappings[$index].mapping[0].hps" dnd-moved="$ctrl.unmapField($index, item)"\n                  dnd-dragstart="$ctrl.dragStart(event, $index)" dnd-dragend="$ctrl.dragEnd()"\n                  dnd-drop="$ctrl.dropped($index, item)" dnd-disable-if="$ctrl.dndDisabled">\n                  <span class="cell-container">\n                    <md-icon md-font-icon="zmdi zmdi-city-alt" class="mappingIcn"\n                      ng-if="row.mapping[0].hps.collection === \'companies\'"></md-icon>\n                    <md-icon md-font-icon="zmdi zmdi-account" class="mappingIcn"\n                      ng-if="row.mapping[0].hps.collection === \'contacts\'"></md-icon>\n                    <md-icon md-font-icon="zmdi zmdi-edit" class="mappingIcn"\n                      ng-if="row.mapping[0].hps.collection === \'responses\'"></md-icon>\n                    <md-icon md-font-icon="zmdi zmdi-pause" class="mappingIcn"\n                      ng-if="row.mapping[0].hps.collection === \'static\'"></md-icon>\n                    {{row.mapping[0].hps.element}}\n                  </span>\n                </td>\n                <td class="md-cell icon-cell">\n                  <div\n                    ng-show="$ctrl.viewModel.mappedFields[row.mapping[0][$ctrl.viewModel.thirdPartyMappingKey].field]">\n                    <md-button class="md-icon-button"\n                      ng-class="{\'md-accent\' : $ctrl.viewModel.transformsExist[row.mapping[0][$ctrl.viewModel.thirdPartyMappingKey].field], \'md-raised\' : $ctrl.transformInEdit == row.mapping[0][$ctrl.viewModel.thirdPartyMappingKey].field}"\n                      ng-click="$ctrl.manageMappingTransforms($event, row)" permission\n                      permission-only="$ctrl.permissions.boltOns.integration.machines.edit">\n                      <md-icon md-font-icon="zmdi zmdi-settings" class="faded"></md-icon>\n                    </md-button>\n                  </div>\n                </td>\n                <td class="md-cell icon-cell">\n                  <md-icon md-font-icon="zmdi zmdi-chevron-right"></md-icon>\n                </td>\n                <td class="md-cell">\n                  <zp-third-party-mapping-field field-info="row.mapping[0][$ctrl.viewModel.thirdPartyMappingKey]"\n                    index="$index">\n                  </zp-third-party-mapping-field>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </md-table-container>\n      </md-card-content>\n    </md-card>\n  </div>\n  <!-- <pre>\n      $ctrl.viewModel.mappingFastLookup\n      {{$ctrl.viewModel.mappingFastLookup | json}}\n  </pre>\n  <pre>\n      $ctrl.viewModel.mappedFields\n    {{$ctrl.viewModel.mappedFields | json}}\n  </pre> -->\n</md-content>');
$templateCache.put('app/integration/field-mappings-page/spof/zp-mappings-toolbar/tmpl.html','<md-toolbar class="zuant-slim-toolbar md-primary md-scroll-shrink">\n  <div class="md-toolbar-tools">\n    <md-button class="md-icon-button" ui-sref="app.homescreen_app_framework.integration-home">\n      <md-tooltip md-direction="bottom">Back to alt view</md-tooltip>\n      <md-icon>chevron_left</md-icon>\n    </md-button>\n    {{$ctrl.currentMachine.name}}\n    <span flex=""></span>\n\n    <md-menu permission permission-only="$ctrl.permissions.boltOns.integration.machines.edit">\n      <md-button aria-label="1" class="md-icon-button" aria-label="open menu" ng-click="$mdOpenMenu()">\n        <md-icon md-font-icon="zmdi zmdi-more-vert"></md-icon>\n      </md-button>\n      <md-menu-content width="3">\n        <md-menu-item>\n          <md-button ng-click="$ctrl.showMachineSettingsDialog($event)">\n            <md-icon>settings</md-icon> Machine settings\n          </md-button>\n        </md-menu-item>\n        <md-menu-item>\n          <md-button ng-click="$ctrl.showMachineJSON($event)">\n            <md-icon>code</md-icon> Machine JSON\n          </md-button>\n        </md-menu-item>\n        <md-menu-item ng-if="$ctrl.currentMachine.actuator.system !== \'HttpPost\'">\n          <md-button aria-label="3"\n            ng-click="$ctrl.viewModel.showFieldDataTypeIcons = !$ctrl.viewModel.showFieldDataTypeIcons">\n            <md-icon>info_outline</md-icon>\n            <span ng-if="$ctrl.viewModel.showFieldDataTypeIcons">Hide field extra info</span>\n            <span ng-if="!$ctrl.viewModel.showFieldDataTypeIcons">Show field extra info</span>\n          </md-button>\n        </md-menu-item>\n        <md-menu-divider ng-if="$ctrl.currentMachine.actuator.system !== \'HttpPost\'"></md-menu-divider>\n        <md-menu-item>\n          <md-button aria-label="3" ng-click="$ctrl.deleteMappings($event)">\n            <md-icon>close</md-icon>\n            <span>Clear all mappings</span>\n          </md-button>\n        </md-menu-item>\n        <md-menu-item ng-if="$ctrl.currentMachine.actuator.system === \'HttpPost\'">\n          <md-button aria-label="3" ng-click="$ctrl.clearUnmappedFields($event)">\n            <md-icon>close</md-icon>\n            Clear unmapped fields\n          </md-button>\n        </md-menu-item>\n        <md-menu-item permission permission-only="$ctrl.permissions.boltOns.integration.machines.delete">\n          <md-button ng-click="$ctrl.deleteMachine($event)">\n            <md-icon>delete</md-icon>\n            <span>Delete machine</span>\n          </md-button>\n        </md-menu-item>\n      </md-menu-content>\n    </md-menu>\n  </div>\n</md-toolbar>');
$templateCache.put('app/integration/field-mappings-page/spof/zp-third-party-mapping-field/tmpl.html','<div ng-style="$ctrl.mdata.required && {\'border-right\' : \'2px solid red\'}" style="padding-right: 10px;" layout="row"\n  layout-align="space-between center">\n  <div flex layout-margin>\n    <p ng-class="{\'slideInRight text-align-left\' : $ctrl.viewModel.mappedFields[$ctrl.fieldInfo.field]}"\n      class="animated fadeInRight" style="text-align: right; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">\n      <span>\n        <span class="md-caption animated" ng-show="$ctrl.viewModel.showFieldDataTypeIcons">Field name:</span>\n        <span class="md-subhead">{{$ctrl.fieldInfo.caption}}</span>\n      </span>\n    </p>\n    <div ng-show="$ctrl.viewModel.showFieldDataTypeIcons"\n      ng-class="{ \'slideInRight text-align-left\' : $ctrl.viewModel.mappedFields[$ctrl.fieldInfo.field]}"\n      style="text-align: right;" class="animated">\n      <span class="md-caption" ng-show="$ctrl.viewModel.thirdPartyMappingKey !== \'eloqua\'">name:</span>\n      <span class="md-caption" ng-show="$ctrl.viewModel.thirdPartyMappingKey === \'eloqua\'">HTML name:</span>\n      <span class="md-subhead">{{$ctrl.fieldInfo.field}}</span>\n    </div>\n  </div>\n  <div ng-show="$ctrl.viewModel.showFieldDataTypeIcons" class="animated fadeIn">\n    <md-icon class="faded" md-font-icon="zmdi {{$ctrl.buildIcon()}}"></md-icon>\n    <md-tooltip>datatype: {{$ctrl.mdata.datatype}}</md-tooltip>\n  </div>\n  <div ng-show="$ctrl.viewModel.showFieldDataTypeIcons && $ctrl.mdata.id" class="animated fadeIn">\n    <pre>id: {{$ctrl.mdata.id}}</pre>\n    <md-tooltip>id: {{$ctrl.mdata.id}}</md-tooltip>\n  </div>\n</div>');
$templateCache.put('app/showroom/blocks/main/sidebar/blocks-sidebar.tmpl.html','<div layout="row" layout-align="end center">\n  <md-button\n    class="md-icon-button"\n    ng-click="vm.addNewBlock($event)"\n    permission\n    permission-only="vm.permissions.boltOns.showroom.edit">\n      <md-icon md-font-icon="zmdi zmdi-plus-circle-o" class="full-icon"></md-icon>\n      <md-tooltip>Add New Root Block</md-tooltip>\n  </md-button>\n\n  <!-- <md-button class="md-icon-button"\n    ng-click="vm.deleteAllBlocks($event)"\n    permission\n    permission-only="vm.permissions.boltOns.showroom.archive">\n      <md-icon md-font-icon="zmdi zmdi-delete"></md-icon>\n      <md-tooltip>Remove All Blocks</md-tooltip>\n  </md-button> -->\n</div>\n\n<md-content layout-fill flex>\n\n  <block-tree\n    flex\n    blocks="vm.blocks"\n    deselect-all-blocks="vm.deselectAllBlocks()"\n    refresh-tree="vm.refreshTree()"\n    update-current-block="vm.updateCurrentBlock()">\n  </block-tree>\n\n  <h1 layout-margin>&nbsp;</h1>\n  <h1 layout-margin>&nbsp;</h1>\n  <md-divider></md-divider>\n\n</md-content>\n');
$templateCache.put('app/showroom/blocks/main/screen/blocks-screen.tmpl.html','<div ng-style="vm.overlay">\n</div>\n<div ng-style="vm.innerScreenStyle" class="ipad-inner-screen" layout="column" layout="center stretch">\n  <div flex="none" class="screen-toolbar" layout="row">\n    <div flex="none">\n      Actions for block: {{vm.getSelectedNameplate()}}\n    </div>\n    <div class="screen-actions" flex="grow">\n      <div ng-if="vm.tabInfo.literature && !vm.selectedBlock" permission\n        permission-only="vm.permissions.boltOns.showroom.edit" ng-style="vm.backStyle">\n        <md-tooltip>Add Literature</md-tooltip>\n        <md-icon md-svg-src="{{\'/images/svgs/icons/custom/collection-plus.svg\' | cdnAssets}}" class="full-icon"\n          ng-click="vm.addLiterature($event)"></md-icon>\n      </div>\n      <div ng-if="vm.tabInfo.blocks && !vm.selectedBlock" permission\n        permission-only="vm.permissions.boltOns.showroom.edit" ng-style="vm.backStyle">\n        <md-tooltip>Add New Block</md-tooltip>\n        <md-icon md-svg-src="{{\'/images/svgs/icons/custom/plus-circle-o.svg\' | cdnAssets}}" class="full-icon"\n          ng-click="vm.addNewBlock($event)"></md-icon>\n      </div>\n      <div ng-if="vm.tabInfo.blocks && !vm.selectedBlock && vm.blockssvcreference.blocks.length > 1" permission\n        permission-only="vm.permissions.boltOns.showroom.edit" ng-style="vm.backStyle">\n        <md-tooltip>Add Existing Blocks</md-tooltip>\n        <md-icon md-svg-src="{{\'/images/svgs/icons/custom/plus-circle-o-duplicate.svg\' | cdnAssets}}" class="full-icon"\n          ng-click="vm.addBlock($event)"></md-icon>\n      </div>\n      <div ng-if="!vm.selectedBlock" permission permission-only="vm.permissions.boltOns.showroom.edit"\n        ng-style="vm.backStyle">\n        <md-tooltip>Edit Current Block</md-tooltip>\n        <md-icon md-svg-src="{{\'/images/svgs/icons/custom/edit.svg\' | cdnAssets}}" class="full-icon"\n          ng-click="vm.editCurrentBlock($event)"></md-icon>\n      </div>\n      <div ng-if="vm.tabInfo.blocks && !vm.selectedBlock" permission\n        permission-only="vm.permissions.boltOns.showroom.edit" ng-style="vm.backStyle">\n        <md-tooltip>Edit Visuals</md-tooltip>\n        <md-icon md-svg-src="{{\'/images/svgs/icons/custom/brush.svg\' | cdnAssets}}" class="full-icon"\n          ng-click="vm.editVisuals($event)"></md-icon>\n      </div>\n      <div ng-if="vm.selectedBlock" ng-style="vm.backStyle">\n        <md-tooltip>Go to Selected Block</md-tooltip>\n        <md-icon md-svg-src="{{\'/images/svgs/icons/custom/mail-reply.svg\' | cdnAssets}}" class="full-icon"\n          ng-click="vm.goToBlock()"></md-icon>\n      </div>\n      <div ng-if="vm.selectedBlock" permission permission-only="vm.permissions.boltOns.showroom.edit"\n        ng-style="vm.backStyle">\n        <md-tooltip>Edit Selected Block</md-tooltip>\n        <md-icon md-svg-src="{{\'/images/svgs/icons/custom/edit.svg\' | cdnAssets}}" class="full-icon"\n          ng-click="vm.editBlock($event)"></md-icon>\n      </div>\n      <div ng-if="vm.selectedBlock" permission permission-only="vm.permissions.boltOns.showroom.archive"\n        ng-style="vm.backStyle">\n        <md-tooltip>Remove Selected Block</md-tooltip>\n        <md-icon md-svg-src="{{\'/images/svgs/icons/custom/delete.svg\' | cdnAssets}}" class="full-icon"\n          ng-click="vm.removeBlock($event)"></md-icon>\n      </div>\n    </div>\n  </div>\n  <div flex layout="row" layout-align="center center" class="ipad-content">\n    <div flex="100">\n      <div class="caption" ng-style="vm.captionStyle">\n        {{vm.block.caption}}\n      </div>\n      <div ng-repeat="row in vm.displayBlocks" layout="row" layout-align="center end">\n        <div ng-repeat="block in row" ng-class="{\'selectedBloc md-whiteframe-20dp\': block._id == vm.selectedBlock._id}"\n          ng-style="vm.style" class="whole-block" layout="column" layout-align="end stretch"\n          ng-click="vm.selectBlock(block)">\n          <div ng-if="block.title" class="block-actions" flex="none">\n            <md-icon permission permission-only="vm.permissions.boltOns.showroom.edit" md-font-icon="zmdi zmdi-delete"\n              ng-click="vm.removeLiterature($event, block)"></md-icon>\n          </div>\n          <div flex="grow" class="nameplate-image-container">\n            <img ng-if="block.nameplateImage" ng-src="{{vm.getKnownImageUri(block.nameplateImage)}}"\n              err-src="{{\'/images/pngs/utilities/404/cloud-404.png\' | cdnAssets}}" ng-style="vm.imageStyle"\n              class="nameplate-image" />\n          </div>\n          <div layout="row" layout-align="center center" class="showroom-block" ng-style="vm.nameplateBlockStyle"\n            flex="none" ng-if="block.nameplate && !block.nameplateHidden">\n            <div ng-style="vm.nameplateStyle" class="block-nameplate" flex="100">\n              {{block.nameplate}}\n            </div>\n          </div>\n          <div layout="row" layout-align="center center" class="showroom-block" ng-style="vm.nameplateBlockStyle"\n            flex="none" ng-if="block.title">\n            <div ng-style="vm.nameplateStyle" class="block-nameplate" flex="100">\n              {{block.title}}\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <md-button flex="none" class="md-icon-button back-button md-raised" ng-if="!vm.block.isRootBlock"\n    ng-style="vm.backStyle" ng-click="vm.goToParentBlock()">\n    <md-icon md-svg-src="{{\'images/svgs/utilities/arrows/arrow-left.svg\' | cdnAssets}}" class="full-icon"></md-icon>\n  </md-button>\n</div>');
$templateCache.put('app/showroom/images/main/fab-add/fab.tmpl.html','<zp-helper-arrow permission permission-only="$ctrl.permissions.boltOns.showroom.edit" help-message="Add an image here" show-condition="!$ctrl.data.items.length"></zp-helper-arrow>\n<zp-fab-add permission permission-only="$ctrl.permissions.boltOns.showroom.edit" pulse-class-check="!$ctrl.data.items.length" dialog-config="$ctrl.metadata.fabAddDialogConfig"></zp-fab-add>\n');
$templateCache.put('app/showroom/images/main/list/images-list.tmpl.html','<!-- <md-toolbar class="md-table-toolbar md-default">\n  <div class="md-toolbar-tools">\n    <div flex></div>\n    <md-button class="md-icon-button" ng-click="$ctrl.toggleLayout()">\n      <ng-md-icon icon="{{$ctrl.layout === \'list\' && \'list\' || \'view_module\'}}" style="fill: #949ca1;"></ng-md-icon>\n    </md-button>\n  </div>\n</md-toolbar> -->\n<md-list ng-if="!$ctrl.imgsvcreference.factoryData.arrayOfImageItems.length">\n  <md-list-item style="margin-top: 30px;" flex>\n    <md-subheader>\n      Your image library items will appear here, but you don\'t have any yet.\n    </md-subheader>\n  </md-list-item>\n</md-list>\n\n<div layout="row" layout-wrap style="padding-bottom: 140px;" ng-if="$ctrl.layout === \'cards\'">\n  <md-card\n    ng-repeat="imgItem in $ctrl.imgsvcreference.factoryData.arrayOfImageItems | filter: imgItem.isShouldBeDisplayed"\n    ng-class="{\'lit-tree-detail-selected\': litItem.selected}" flex-xs="100" flex-sm="45" flex-md="40" flex-gt-md="30">\n    <md-card-header>\n      <md-card-header-text>\n        <span class="md-title" id="truncate" ng-click="$ctrl.toggleImageItemSelection(imgItem)">Title:\n          {{imgItem.title}}</span>\n        <span class="md-subhead zuantTitanium2">Last modified: {{imgItem._lastmodifiedonservertime | date:\n          \'medium\'}}</span>\n      </md-card-header-text>\n    </md-card-header>\n    <img ng-if="imgItem.imagebase64" ng-src="data:image/png;base64,{{imgItem.imagebase64}}"\n      err-src="{{\'/images/pngs/utilities/404/cloud-404.png\' | cdnAssets}}" />\n    <img ng-if="imgItem._s3key" ng-src="{{$ctrl.s3BaseUrl}}/{{imgItem._s3key}}"\n      err-src="{{\'/images/pngs/utilities/404/cloud-404.png\' | cdnAssets}}" />\n    <img ng-if="imgItem.weburi" ng-src="{{imgItem.weburi | zpDropboxRaw}}"\n      err-src="{{\'/images/pngs/utilities/404/cloud-404.png\' | cdnAssets}}" />\n    <md-progress-linear md-indeterminate layout-align="center center" ng-if="imgItem.loading"></md-progress-linear>\n    <md-card-content>\n      <div layout="column" ng-if="imgItem.imagebase64"\n        ng-init="imgItem.showMigrateToDropboxBtn = true; imgItem.showMigrateText = true; imgItem.imageMigratedToDropbox = false; imgItem.loading = false; imgItem.icon = \'cloud_upload\'">\n        <div layout="row">\n          <md-button class="md-raised md-accent md-icon-button animated pulsate-aqua"\n            ng-click="$ctrl.migrateImageToDropboxStorage(imgItem)" layout-align="center center">\n            <ng-md-icon icon="{{imgItem.icon}}" style="fill: #fff;"></ng-md-icon>\n          </md-button>\n\n          <p ng-show="imgItem.showMigrateText">Migrate image to Dropbox</p>\n          <p ng-show="imgItem.imageMigratedToDropbox">Image is now stored in Dropbox</p>\n          <p ng-show="imgItem.loading">Moving image...</p>\n        </div>\n        <md-progress-linear ng-if="imgItem.loading" md-indeterminate class="md-accent"></md-progress-linear>\n      </div>\n\n    </md-card-content>\n    <md-card-actions layout="row" layout-align="end center">\n      <!-- <md-checkbox flex aria-label="Image item selected"\n              ng-model="imgItem.selected" class="row-checkbox" /> -->\n      <md-button class="md-icon-button" permission permission-only="$ctrl.permissions.boltOns.showroom.archive"\n        ng-click="$ctrl.archiveClicked(imgItem)">\n        <md-icon md-font-icon="zmdi zmdi-delete"></md-icon>\n      </md-button>\n      <md-button class="md-icon-button" permission permission-only="$ctrl.permissions.boltOns.showroom.edit"\n        ng-click="$ctrl.editButtonClicked(imgItem, $event)">\n        <md-icon md-font-icon="zmdi zmdi-edit"></md-icon>\n      </md-button>\n    </md-card-actions>\n  </md-card>\n\n  <!-- <div class="image-row-actions" flex="noshrink" width="120px" layout="row" layout-align="space-between center">\n          <md-checkbox flex aria-label="Image item selected"\n                  ng-model="imgItem.selected" class="row-checkbox" />\n\n          <md-icon permission permission-only="$ctrl.permissions.boltOns.showroom.edit" flex md-font-icon="zmdi zmdi-edit" style="margin-left:6px" ng-click="$ctrl.editButtonClicked(imgItem,$event)"  />\n      </div> -->\n\n  <!-- <div flex="grow" class="image-item-title" ng-click="$ctrl.toggleImageItemSelection(imgItem)">{{imgItem.title}}</div> -->\n\n</div>\n\n<md-table-container ng-if="$ctrl.layout === \'list\'" layout-padding>\n  <table class="md-table">\n    <th>\n      <!-- <td></td> -->\n    <td></td>\n    <td>Title</td>\n    <td>Last modified</td>\n    <td>Edit</td>\n    </th>\n    <tbody class="md-body">\n      <tr\n        ng-repeat="imgItem in $ctrl.imgsvcreference.factoryData.arrayOfImageItems | filter:{ isShouldBeDisplayed: true }">\n        <td>\n          <md-checkbox flex aria-label="Image item selected" ng-model="imgItem.selected" class="row-checkbox" />\n        </td>\n        <td>\n          <img ng-src="data:image/png;base64,{{imgItem.thumbnail}}" class="md-card-image" />\n        </td>\n        <td>\n          <span class="md-body-1" ng-click="$ctrl.toggleImageItemSelection(imgItem)">Title: {{imgItem.title}}</span>\n        </td>\n        <td>\n          <span class="md-caption zuantTitanium2">Last modified: {{imgItem._lastmodifiedonservertime | date:\n            \'medium\'}}</span>\n        </td>\n        <td>\n          <md-button class="md-icon-button" permission permission-only="$ctrl.permissions.boltOns.showroom.edit"\n            ng-click="$ctrl.editButtonClicked(imgItem, $event)">\n            <md-icon md-font-icon="zmdi zmdi-edit"></md-icon>\n          </md-button>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</md-table-container>');
$templateCache.put('app/showroom/images/main/toolbar/images-toolbar.tmpl.html','<div class=" flexcolumn">\n    <div layout="row" layout-align="space-between center">\n        <div class="toolbar-title" flex="none">\n            Images Library\n        </div>\n\n        <div flex="grow" style="text-align:right">\n            <input type="search" class="search-textbox" placeholder="&#x1F50D;"\n                ng-model="$ctrl.ImagesApiFactory.factoryData.searchTerm" ng-change="$ctrl.searchTextChanged()" />\n\n            <md-icon permission permission-only="$ctrl.permissions.boltOns.showroom.archive"\n                md-svg-src="{{\'/images/svgs/icons/showroom/delete.svg\' | cdnAssets}}" class="toolbar-icon"\n                ng-click="$ctrl.archiveClicked()" title="Delete selected images" />\n            <md-icon permission permission-only="$ctrl.permissions.boltOns.showroom.edit"\n                md-svg-src="{{\'/images/svgs/icons/showroom/plus.svg\' | cdnAssets}}" class="toolbar-icon"\n                ng-click="$ctrl.addButtonClicked()" title="Add a new image" />\n        </div>\n    </div>\n</div>');
$templateCache.put('app/showroom/import/main/actions/file-import-actions.tmpl.html','<div class="import-action-menu" layout="column" layout-align="start stretch">\n  <div flex>{{$ctrl.mappedImportListSvc.stats.countOfSelectedItemsPhrase}}</div>\n\n  <div flex ng-if="!$ctrl.mappedImportListSvc.isFileLoaded" style="padding:10px;">\n    The expected column headings for the CSV file are: title, url, category, tag.\n    <br />\n    <br />These must appear as the first line of the file and only these columns will be read.\n  </div>\n\n  <div flex ng-if="$ctrl.mappedImportListSvc.isFileLoaded && $ctrl.mappedImportListSvc.isEssentialHeadersArePresent" class="headers">\n    The file contains valid headers\n    <md-button class="md-raised" ng-click="$ctrl.importSelectedItemsToLiteratureLibrary()">{{$ctrl.mappedImportListSvc.stats.importItemsButtonCaption}}</md-button>\n  </div>\n\n  <div flex ng-if="$ctrl.mappedImportListSvc.isFileLoaded && !$ctrl.mappedImportListSvc.isEssentialHeadersArePresent" class="headers">\n    The file does not contain valid headers and can\'t be imported. An import file must contain \'title\' and \'url\' column headers in the first line of the file.\n  </div>\n\n  <div flex ng-if="$ctrl.mappedImportListSvc.isFileLoaded && !$ctrl.mappedImportListSvc.isTagHeadersExistedInImportFile" class="headers">\n    The file does not contain any recognised tag columns. An import file must contain \'category\' and \'tag\' columns headers in the first line of the file to enable automatic tagging of the inbound literature.\n  </div>\n\n\n  <div flex ng-show="$ctrl.mappedImportListSvc.isFileLoaded && $ctrl.mappedImportListSvc.isTagHeadersExistedInImportFile" class="tag-items">\n    Do you want to tag the new items with the category/tag columns from the import file?\n    <div class="checkbox-container">\n      <md-checkbox ng-model="$ctrl.mappedImportListSvc.isTagsShouldBeLinked" />Yes, tag the items\n    </div>\n\n    Do you want to create a blocks structure from the tags?\n    <div class="checkbox-container">\n      <md-checkbox ng-model="$ctrl.mappedImportListSvc.isBlocksShouldBeCreated" />Yes, create blocks\n    </div>\n\n    <div ng-show="$ctrl.mappedImportListSvc.arrayOfTagsWhichAreMissingFromTagLibrary.length>0">\n      Do you want to create the required new tags below?\n      <div class="checkbox-container">\n        <md-checkbox ng-model="$ctrl.mappedImportListSvc.isNewTagsShouldBeCreatedIfNecessary" />Yes, create new tags\n      </div>\n\n      <div class="wrappingflexcontainer">\n\n        <div ng-class="{\'chiptag2\': true}" ng-repeat="missingTag in $ctrl.mappedImportListSvc.arrayOfTagsWhichAreMissingFromTagLibrary" ng-click="$ctrl.onToggleTagForImportItem(item)">\n          {{missingTag.title}}\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('app/showroom/import/main/selector/file-import-selector.tmpl.html','<div permission permission-only="$ctrl.permissions.boltOns.showroom.edit">\n    <input type="file" ng-upload-change="fileChanged($event)" />\n</div>\n');
$templateCache.put('app/showroom/import/main/toolbar/file-import-toolbar.tmpl.html','<div class=" flexrow" style="justify-content: space-between;">\n  <div class="toolbar-title">\n    CSV File Import\n  </div>\n</div>\n');
$templateCache.put('app/showroom/import/main/list/file-import-list.tmpl.html','\n<md-virtual-repeat-container class="list" >\n  <div class="lit-library-detail cardish" md-item-size="50" flex layout="row"  layout-align="space-between stretch"\n       md-virtual-repeat="item in $ctrl.importFileListSvc.arrayOfItems">\n\n        <md-checkbox\n               ng-model="item.isSelected"\n               ng-change="$ctrl.requestListStatsUpdate(item)" />\n\n        <div flex="grow" layout="column" layout-align="center stretch">\n          <div flex="none" ng-click="$ctrl.toggleImportListItemSelection(item)" class="lit-item-title" >{{item.title}}</div>\n\n          <div flex>\n            <div ng-class="{\'chiptag2\': true}" ng-click="$ctrl.onToggleTagForImportItem(item)">\n                <span>{{item.tag}}</span>\n            </div>\n          </div>\n        </div>\n    </div>\n  </md-virtual-repeat-container>\n');
$templateCache.put('app/showroom/literature/add-or-edit-literature/dialog/add-literature-dialog.tmpl.html','<md-dialog aria-label="Literature item dialog" flex="80" flex-gt-md="60">\n\n  <md-toolbar aria-label="Literature item dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">\n        <span ng-if="!vm.litDoc._id">Create a new</span><span ng-if="vm.litDoc._id">Edit</span> literature item\n      </p>\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content layout-padding>\n    <zp-literature-form lit-doc="vm.litDoc" lit-form="vm.litForm"></zp-literature-form>\n  </md-dialog-content>\n\n  <md-dialog-actions layout="row">\n    <md-button class="md-warn" ng-click="vm.cancelDialog()">Cancel</md-button>\n    <md-button ng-disabled="vm.disableSaveButton" class="md-primary" aria-label="save literature form" ng-click="vm.submitLiteratureForm(vm.litDoc)">Save</md-button>\n  </md-dialog-actions>\n\n</md-dialog>\n');
$templateCache.put('app/showroom/literature/add-or-edit-literature/zp-literature-form/zp-literature-form.tmpl.html','\n<form name="vm.litForm" novalidate>\n  <div layout="column" layout-gt-xs="row">\n    <md-input-container flex>\n        <label>Title</label>\n        <input type="text" name="title" ng-model="vm.litDoc.title" aria-label="Title" required md-autofocus>\n        <div ng-messages="vm.litForm.title.$error" md-auto-hide="false" ng-show="vm.litForm.title.$touched">\n          <div ng-message when="required">\n            <spanYour literature item needs a title</span>\n          </div>\n        </div>\n    </md-input-container>\n  </div>\n\n  <div layout="column" layout-gt-xs="row">\n    <md-input-container flex>\n        <label>Web URI</label>\n        <input type="text" name="weburi" ng-model="vm.litDoc.weburi" aria-label="Web URI" required ng-pattern="vm.weburiregexp">\n        <div ng-messages="vm.litForm.weburi.$error" md-auto-hide="false" ng-show="vm.litForm.weburi.$touched">\n          <div ng-message when="required">\n            <spanYou need to have a link to the resource for your literature item</span>\n          </div>\n        </div>\n    </md-input-container>\n  </div>\n\n  <div layout="column" layout-gt-xs="row">\n    <md-input-container flex>\n        <label>Keywords</label>\n        <input type="text" ng-model="vm.litDoc.keywordsAsSingleString">\n        <div class="hint">Add comma delimited keywords to help locate this item in showroom search</div>\n    </md-input-container>\n  </div>\n\n  <div layout="column" layout-gt-xs="row">\n    <md-switch ng-model="vm.litDoc.allowAddToBasket" aria-label="Disallow \'Add to Cart\'" ng-true-value="0" ng-false-value="1" class="md-warn">\n        Disallow \'Add to Cart\' : {{ vm.litDoc.allowAddToBasket!=1 ? \'Yes\':\'No\' }}\n    </md-switch>\n  </div>\n\n  <div layout="column" layout-gt-xs="row">\n    <md-switch ng-model="vm.litDoc.removeTyeLink" aria-label="Remove link from Thank You Email" ng-true-value="1" ng-false-value="0" class="md-warn">\n        Remove link from Thank You Email : {{ vm.litDoc.removeTyeLink ==1 ? \'Yes\':\'No\' }}\n    </md-switch>\n  </div>\n<input type="hidden" name="CSRFToken" value="1231234567890" />\n</form>\n');
$templateCache.put('app/showroom/tags/main/list/editable-tag-chip.tmpl.html','\n\n<div ng-if="$ctrl.viewstatesvc.viewState.tagblocksMode==\'select\'"\n    ng-class="{\'chiptag2\': !$ctrl.tag.isNew, \'chiptag-placeholder\': $ctrl.tag.isNew, \'highlighted-tag\': $ctrl.tag.isSelected}"\n    ng-click="$ctrl.onChipClick($ctrl.tag)">\n        <span>{{$ctrl.tag.title}}</span>\n</div>\n\n<div ng-if="$ctrl.viewstatesvc.viewState.tagblocksMode==\'edit\'"\n     class="chiptag2">\n        <span contenteditable\n              ng-focus="$ctrl.onChipFocus($ctrl.tag)"\n              ng-blur="$ctrl.onChipBlur($ctrl.tag)"\n              ng-keypress="($event.which === 13)?$ctrl.onChipEnter($event):0">{{$ctrl.tag.title}}</span>\n\n        <md-icon md-font-icon="zmdi zmdi-close" class="chiptag-delete-cross"  ng-click="$ctrl.deleteButtonClicked($event)"  />\n</div>\n\n<div ng-if="$ctrl.viewstatesvc.viewState.tagblocksMode==\'drag\'"\n     class="chiptag2 chip-draggable">\n        <span>{{$ctrl.tag.title}}</span>\n</div>\n');
$templateCache.put('app/showroom/tags/main/list/tags-list.tmpl.html','\n<div layout="row" layout-wrap id="sorttest"\n     ui-sortable="sortableOptionsForTagCategories" ng-model="$ctrl.tagssvc.tagCategories" >\n\n     <div flex="none" style="padding: 10px;" >\n         Click one or more tags below to enable the literature tagging process\n     </div>\n\n    <div class="tag-block-container cardish" layout="column" flex="100" ng-repeat="tagcategory in $ctrl.tagssvc.tagCategories" id="l1_{{tagcategory._id}}"  >\n        <div class="tag-section-header">\n            <md-icon md-font-icon="zmdi zmdi-tag" class="tag-section-header-icon" ></md-icon>\n\n            <span id="l2_{{tagcategory._id}}"\n                  class="tag-section-header-text"\n                  ng-focus="$ctrl.onCategoryFocus(tagcategory)"\n                  ng-blur="$ctrl.onCategoryBlur(tagcategory)"\n                  ng-keypress="($event.which === 13)?$ctrl.onCategoryEnter($event, tagcategory):0"\n                  ng-attr-contenteditable="{{$ctrl.viewstatesvc.viewState.tagblocksMode==\'edit\' ? \'true\' : undefined }}">\n                {{tagcategory.category}}\n            </span>\n            <md-icon md-font-icon="zmdi zmdi-close" ng-show="$ctrl.viewstatesvc.viewState.tagblocksMode==\'edit\'" class="chiptag-category-delete-cross"  ng-click="$ctrl.deleteCategoryClicked($event, tagcategory)" />\n        </div>\n\n        <div class="chipTagContainer" id="ctc_{{tagcategory._id}}"  ui-sortable="sortableOptionsForTags"  ng-model="tagcategory.tags" >\n            <editable-tag-chip\n                    ng-repeat="tag in tagcategory.tags track by tag._id"\n                    tag="tag"\n                    tagcategory="tagcategory"\n                    bluemoon="$ctrl.toggleTagSelection(tag)"\n                    litsvcreference="$ctrl.litsvcreference">\n            </editable-tag-chip>\n\n            <input permission permission-only="$ctrl.permissions.boltOns.showroom.edit" class="chiptag2 chipinput"  type="text"\n                   ng-focus="$ctrl.onNewChipFocus(tagcategory)"\n                   ng-blur="$ctrl.onNewChipBlur(tagcategory,$event)"\n                   ng-keypress="($event.which === 13)?$ctrl.onNewChipEnter(tagcategory,$event):0"\n                   placeholder="Add tag..."/>\n        </div>\n    </div>\n\n    <div permission permission-only="$ctrl.permissions.boltOns.showroom.edit" class="tag-block-container" layout="column" flex="100">\n        <input class="tag-section-header"  type="text"\n               ng-model="$ctrl.newCategoryTitle"\n               ng-blur="$ctrl.onNewCategoryBlur(tagcategory)"\n               ng-keypress="($event.which === 13)?$ctrl.onNewCategoryEnter(tagcategory):0"\n               placeholder="Type here to add a new category..."/>\n    </div>\n</div>\n');
$templateCache.put('app/showroom/tags/main/actions/tag-actions.tmpl.html','\n\n<div flex>\n    <div class="action-tip narrativefont">\n        {{$ctrl.litsvc.stats.applyTagsToLitPhrase}}\n\n        <div layout="row" style="justify-content: space-around; padding-top:10px;">\n            <div  style="align-self:center; text-align: center;">{{$ctrl.tagssvc.stats.countOfSelectedTags}}</div>\n            <div  style="align-self:center; text-align: center;">{{$ctrl.litsvc.stats.countOfSelectedLiteratureItems}}</div>\n        </div>\n        <div layout="row" style="justify-content: space-around;">\n            <div style="align-self:center; text-align: center;">TAGS</div>\n            <div style="align-self:center; text-align: center;">ITEMS</div>\n        </div>\n    </div>\n\n    <div style="text-align:center" permission permission-only="$ctrl.permissions.boltOns.showroom.edit">\n        <md-button class="md-raised apply-tags-button fadeInOut"\n                   ng-show="$ctrl.tagssvc.stats.countOfSelectedTags>0 && $ctrl.litsvc.stats.countOfSelectedLiteratureItems>0"\n                   ng-click="$ctrl.applySelectedTagsToSelectedLiteratureClicked()">Apply Tags</md-button>\n    </div>\n</div>\n\n<div flex>\n    <div class="action-tip narrativefont" >\n        {{$ctrl.litsvc.stats.removeTagsFromLitPhrase}}\n    </div>\n\n    <div style="text-align:center" permission permission-only="$ctrl.permissions.boltOns.showroom.edit">\n        <md-button class="md-raised disconnect-tags-button fadeInOut"\n                   ng-show="$ctrl.litsvc.stats.countOfSelectedLitItemTags>0"\n                   ng-click="$ctrl.removeSelectedTagsFromLiteratureClicked()">Disconnect Tags</md-button>\n    </div>\n</div>\n');
$templateCache.put('app/showroom/tags/main/toolbar/tags-toolbar.tmpl.html','<md-toolbar class="md-table-toolbar md-default">\n      <div class="md-toolbar-tools">\n            <div class="md-subhead"\n              flex="none">\n                  Tags\n            </div>\n\n            <span flex></span>\n\n            <md-button class="md-icon-button fadeRight"\n              ng-show="$ctrl.tagsManager.factoryData.tagSelectedCount > 0">\n                  <md-icon md-font-icon="zmdi zmdi-tag-close"\n                    ng-click="$ctrl.deselectAllTagsClicked()">\n                  </md-icon>\n                  <md-tooltip>De-select highlighted tags</md-tooltip>\n            </md-button>\n\n            <md-button class="md-icon-button"\n              ng-class="{\'md-raised md-accent\': ($ctrl.viewStateNotificationService.viewState.tagblocksMode==\'drag\')}">\n                  <md-icon permission\n                    permission-only="$ctrl.permissions.boltOns.showroom.edit"\n                    md-font-icon="zmdi zmdi-arrows"\n                    ng-click="$ctrl.dragDropButtonClicked()">\n                  </md-icon>\n                  <md-tooltip>Move/Order tags</md-tooltip>\n            </md-button>\n\n            <md-button class="md-icon-button"\n              ng-class="{\'md-raised md-accent\': ($ctrl.viewStateNotificationService.viewState.tagblocksMode==\'edit\')}">\n                  <md-icon permission\n                    permission-only="$ctrl.permissions.boltOns.showroom.edit"\n                    md-font-icon="zmdi zmdi-edit"\n                    ng-click="$ctrl.settingsButtonClicked()">\n                  </md-icon>\n                  <md-tooltip>Edit tags and categories</md-tooltip>\n            </md-button>\n      </div>\n</md-toolbar>\n');
$templateCache.put('app/showroom/third-party/main/actions/dropbox-actions.tmpl.html','<div class="dropbox-action-menu" layout="column" layout-align="start stretch">\n    <div flex permission permission-only="$ctrl.permissions.boltOns.showroom.edit">\n        <md-button class="md-raised" ng-click="$ctrl.addToShowroomClicked()">{{$ctrl.dropboxApiService.stats.addShowroomPhrase}}</md-button>\n    </div>\n\n    <div flex>\n      {{$ctrl.dropboxApiService.stats.fileSelectionInfo}}\n    </div>\n\n\n    <div flex permission permission-only="$ctrl.permissions.boltOns.showroom.edit" style="margin-top:20px">\n\n          <div>\n              <md-checkbox aria-label="Remove file extension"\n                ng-model="$ctrl.dropboxApiService.removeFileExtension" class="row-checkbox">Remove file extension</md-checkbox>\n          </div>\n\n          <div>\n              <md-checkbox aria-label="Replace underscores with spaces"\n                ng-model="$ctrl.dropboxApiService.replaceUnderscores" class="row-checkbox">Replace underscores</md-checkbox>\n          </div>\n\n          <div>\n              <md-checkbox aria-label="Capitalise words"\n                ng-model="$ctrl.dropboxApiService.capitaliseWords" class="row-checkbox">Capitalise words</md-checkbox>\n          </div>\n\n    </div>\n\n</div>\n');
$templateCache.put('app/showroom/third-party/main/filter/dropbox-filter.tmpl.html','\n<div class="filter-row" layout="column">\n    <div layout="row">\n        <div flex="20" class="tagfiltercategory" style="align-self:center">Filter Switches</div>\n\n        <div flex="80">\n            <div class="chiptag2 tagfilterchip"\n                 ng-click="$ctrl.toggleUnshare()"\n                 ng-class="{\'highlighted-tag\': $ctrl.dropboxsvcreference.hideUnshared}">\n                Hide Unshared\n            </div>\n            <div class="chiptag2 tagfilterchip"\n                 ng-click="$ctrl.toggleShare()"\n                 ng-class="{\'highlighted-tag\': $ctrl.dropboxsvcreference.hideShared}">\n                Hide Shared\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/showroom/third-party/main/toolbar/dropbox-toolbar.tmpl.html','<div layout="row" layout-align="space-between center">\n    <div class="toolbar-title" flex="none">\n        Dropbox Files & Folders\n    </div>\n\n    <div flex="grow" style="text-align:right">\n\n        <md-icon md-svg-src="{{\'/images/svgs/icons/showroom/flip.svg\' | cdnAssets}}" class="toolbar-icon"\n            ng-click="$ctrl.switchAccounts()" title="Switch Accounts"></md-icon>\n        <md-icon md-svg-src="{{\'/images/svgs/icons/showroom/filter-list.svg\' | cdnAssets}}" class="toolbar-icon"\n            ng-click="$ctrl.filterButtonClicked()" title="Toggle the dropbox filter panel"></md-icon>\n        <md-icon md-svg-src="{{\'/images/svgs/icons/showroom/share.svg\' | cdnAssets}}" class="toolbar-icon"\n            ng-click="$ctrl.share()" title="Share Selected Items"></md-icon>\n        <md-icon md-svg-src="{{\'/images/svgs/icons/showroom/block.svg\' | cdnAssets}}" class="toolbar-icon"\n            ng-click="$ctrl.unshare()" title="Unshare Selected Items"></md-icon>\n        <md-icon md-svg-src="{{\'/images/svgs/icons/showroom/minus-square.svg\' | cdnAssets}}" class="toolbar-icon"\n            ng-click="$ctrl.deselectAllClicked()" title="De-select all items"></md-icon>\n        <md-icon md-svg-src="{{\'/images/svgs/icons/showroom/plus-square.svg\' | cdnAssets}}" class="toolbar-icon"\n            ng-click="$ctrl.selectAllVisibleClicked()" title="Select all visible items"></md-icon>\n        <md-icon md-svg-src="{{\'/images/svgs/icons/showroom/unfold-more.svg\' | cdnAssets}}" class="toolbar-icon"\n            ng-click="$ctrl.expand()" title="Fully Expand Selected Items"></md-icon>\n        <md-icon md-svg-src="{{\'/images/svgs/icons/showroom/unfold-less.svg\' | cdnAssets}}" class="toolbar-icon"\n            ng-click="$ctrl.shrink()" title="Fully Close Selected Items"></md-icon>\n\n    </div>\n</div>');
$templateCache.put('app/showroom/third-party/switch-accounts/dialog/switch-dropbox-account-dialog.tmpl.html','<md-dialog aria-label="Switch dropbox account dialog" flex="80" flex-gt-md="60">\n\n  <md-toolbar aria-label="Switch dropbox account dialog toolbar">\n    <div layout="row" class="md-toolbar-tools">\n      <p class="md-subhead">\n        Switch dropbox account\n      </p>\n      <span flex></span>\n      <md-button ng-click="vm.cancelDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content layout-padding>\n    <md-list flex="80" flex-offset="10">\n      <md-list-item style="margin-top: 30px;">\n        <md-input-container class="md-block" flex>\n          <label>Select account</label>\n          <md-select ng-model="vm.account.selectedAccount" ng-change="vm.onSelectionChange()" flex aria-label="Select account">\n            <md-option ng-value="account.token" ng-repeat="account in vm.existingAccounts">{{account.display_name}}</md-option>\n          </md-select>\n        </md-input-container>\n      </md-list-item>\n\n      <md-list-item style="margin-top: 30px;" ng-show="vm.showLinkNewAccountText" >\n        <md-subheader flex style="text-align:center">When you click \'Switch Account\' you will be navigated to the Dropbox website. You may need to logout of your Dropbox account if you are already logged in.</md-subheader>\n      </md-list-item>\n    </md-list>\n  </md-dialog-content>\n\n  <md-dialog-actions layout="row">\n    <md-button class="md-warn" ng-click="vm.cancelDialog()">Cancel</md-button>\n    <md-button ng-disabled="vm.disableSaveButton" class="md-primary" aria-label="switch account" ng-click="vm.switchAccount()">Switch Account</md-button>\n  </md-dialog-actions>\n\n</md-dialog>\n');
$templateCache.put('app/showroom/third-party/main/list/dropbox-list.tmpl.html','<div style="flex:1 1 auto; padding: 5px">\n  <md-progress-linear ng-if="$ctrl.busy" class="md-accent"></md-progress-linear>\n  <div layout="column" flex>\n    <md-list flex ng-if="$ctrl.busy && !$ctrl.showConnectLink">\n      <md-list-item style="margin-top: 30px;" flex>\n        <md-subheader>\n          Please wait while we obtain all the Dropbox file information from your account.\n          <br /><br />\n          If you have a lot of files this may take a while.\n        </md-subheader>\n      </md-list-item>\n    </md-list>\n\n    <div ng-repeat="node in $ctrl.dropboxzuantsvcreference.nodes | filter:{ isShouldBeDisplayed: true }">\n      <dropbox-node node="node"></dropbox-node>\n    </div>\n\n    <md-list flex ng-if="$ctrl.showConnectLink">\n      <md-list-item style="margin-top: 30px;" flex>\n        <md-subheader>\n          Your Dropbox files will be available here once you have authorised the Zuant application.\n          <br /><br />\n          Please click the \'Connect\' button below to be sent to the Dropbox website in order to authorise the Zuant\n          application to access your Dropbox files.\n        </md-subheader>\n      </md-list-item>\n\n      <md-list-item style="margin-top: 30px;" flex>\n        <md-button flex style="margin: 10px 0;" class="md-primary animated pulsate-aqua"\n          ng-click="$ctrl.connectToDropbox()">\n          <md-icon md-svg-src="{{\'/images/svgs/logos/thirdparty/dropbox/dropbox_alt.svg\' | cdnAssets}}"\n            aria-label="Dropbox" style="width: 100px;"></md-icon><span\n            style="line-height:60px; vertical-align:sub">&nbsp;Connect</span>\n        </md-button>\n      </md-list-item>\n    </md-list>\n  </div>\n</div>c');
$templateCache.put('app/showroom/third-party/main/list/dropbox-node.tmpl.html','<div class="linedlitcontainer" ng-class="{\'tree-node-selected\': $ctrl.node.isSelected}">\n\n    <span ng-if="$ctrl.node.type===\'folder\'">\n        <img class="linedlittriangle" ng-click="$ctrl.toggleNodeExpanded($ctrl.node)"\n            ng-src="{{$ctrl.node.isExpanded && (\'/images/pngs/icons/showroom/down-triangle.png\' | cdnAssets) || (\'/images/pngs/icons/showroom/right-triangle.png\' | cdnAssets)}}" />\n    </span>\n\n    <span ng-if="$ctrl.node.type===\'file\'">\n        <img class="linedlittriangle" ng-src="{{\'/images/pngs/gradients/transparent.png\' | cdnAssets}}" />\n    </span>\n\n\n    <md-checkbox aria-label="Dropbox node selection state" ng-model="$ctrl.node.isSelected" class="row-checkbox"\n        ng-change="$ctrl.selectNodeChanged($ctrl.node)" />\n\n    <span ng-click="$ctrl.toggleNodeSelected($ctrl.node)" class="dropbox-node">\n        <md-icon aria-label="Shared icon" ng-show="$ctrl.node.type===\'file\' && $ctrl.node.isShared"\n            md-font-icon="zmdi zmdi-share" style="color: #4caf50" class="linedlitimg"></md-icon>\n\n        <span>\n            {{$ctrl.node.title}}\n        </span>\n    </span>\n</div>\n\n<div ng-repeat="node in $ctrl.node.nodes | filter:{ isShouldBeDisplayed: true }" ng-show="$ctrl.node.isExpanded"\n    class="tree-node-content">\n    <dropbox-node node="node"></dropbox-node>\n</div>');
$templateCache.put('app/showroom/literature/main/fab/fab.tmpl.html','<zp-helper-arrow help-message="Add literature to your account here" show-condition="$ctrl.blankSlate"\n  permission permission-only="$ctrl.permissions.boltOns.showroom.edit">\n</zp-helper-arrow>\n\n<zp-fab-add pulse-class-check="$ctrl.blankSlate" dialog-config="$ctrl.metadata.fabDialogConfig"\n  permission permission-only="$ctrl.permissions.boltOns.showroom.edit">\n</zp-fab-add>\n');
$templateCache.put('app/showroom/literature/main/list/literature-list.tmpl.html','<!--\n<md-list ng-if="$ctrl.literaturesvc.literatureItems.length == 0">\n  <md-list-item style="margin-top: 30px;" flex>\n    <md-subheader>\n      Your literature library items will appear here, but you don\'t have any yet.\n    </md-subheader>\n  </md-list-item>\n</md-list>\n&nbsp; <!-- no idea why but need something here in order to force virtual container to full-width available --\n<md-virtual-repeat-container class="list" >\n\n  <div class="lit-library-detail cardish" md-item-size="50" flex layout="row" layout-align="space-between stretch"\n       md-virtual-repeat="litItem in $ctrl.literaturesvc.literatureItems | filter:{ isShouldBeDisplayed: true }"\n       ng-class="{\'lit-tree-detail-selected\': litItem.selected}">\n\n      <div class="row-actions" flex="noshrink" width="120px" layout="row" layout-align="space-between center">\n\n        <md-icon class="content-icon" md-font-icon="zmdi zmdi-collection-video" flex ng-if="$ctrl.isVideo(litItem.weburi)"></md-icon>\n        <md-icon class="content-icon" md-font-icon="zmdi zmdi-collection-pdf" flex ng-if="$ctrl.isPdf(litItem.weburi)"></md-icon>\n        <md-icon class="content-icon" md-font-icon="zmdi zmdi-collection-image" flex ng-if="$ctrl.isImage(litItem.weburi)"></md-icon>\n        <md-icon class="content-icon" md-font-icon="zmdi zmdi-collection-item" flex ng-if="$ctrl.isUnknown(litItem.weburi)"></md-icon>\n\n        <md-checkbox flex aria-label="Literature item selected"\n               ng-model="litItem.selected" class="row-checkbox"\n               ng-change="$ctrl.requestLitStatsUpdate(litItem)" />\n\n        <md-icon permission permission-only="$ctrl.permissions.boltOns.showroom.edit" flex md-font-icon="zmdi zmdi-edit" style="margin-left:6px" ng-click="$ctrl.editButtonClicked(litItem,$event)"  />\n      </div>\n\n      <div flex="grow" layout="column" layout-align="center stretch">\n          <div flex="none" ng-click="$ctrl.toggleLitLibraryLitItemSelection(litItem)" class="lit-item-title">{{litItem.title}}</div>\n\n          <div flex>\n              <div ng-repeat="extendedTag in litItem.extendedTags" width="auto"\n                   ng-class="{\'chiptag2\': true, \'highlighted-tag\': extendedTag.isSelected}"\n                   ng-click="$ctrl.onToggleTagForLitItem(extendedTag,litItem)">\n                  <span>{{$ctrl.getTagTitle(extendedTag._id)}}</span>\n              </div>\n          </div>\n      </div>\n    </div>\n  </md-virtual-repeat-container> -->\n');
$templateCache.put('app/showroom/literature/main/filter/literature-filter.tmpl.html','<div class="filter-row" layout="column" ng-repeat="tagcategory in $ctrl.tagssvcreference.tagCategories">\n  <div layout="row">\n    <div flex="20" class="tagfiltercategory" style="align-self:center">{{tagcategory.category}}</div>\n\n    <div flex="80">\n      <div class="chiptag2 tagfilterchip" ng-repeat="tag in tagcategory.tags" ng-click="$ctrl.onToggleFilterTagSelection(tag)" ng-class="{\'highlighted-tag\': $ctrl.isTagSelected(tag)}">\n        {{tag.title}}\n      </div>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('app/showroom/literature/main/card-list/literature-card-list.tmpl.html','<md-list ng-if="$ctrl.literaturesvc.literatureItems.length == 0">\n  <md-list-item style="margin-top: 30px;" flex>\n    <md-subheader>\n      Your literature library items will appear here, but you don\'t have any yet.\n    </md-subheader>\n  </md-list-item>\n</md-list>\n\n<md-virtual-repeat-container class="lit-library-detail" md-auto-shrink="false" layout="column"\n  layout-align="center stretch" class="slideInOut" ng-show="$ctrl.literaturesvc.factoryData.inCardView">\n\n  <div md-virtual-repeat="row in $ctrl.rows" flex="grow" md-item-size="200" layout="row" layout-wrap\n    layout-align="center none">\n\n    <md-card flex="20" class="flex23" layout-margin layout-padding\n      ng-repeat="litItem in row | filter:{ isShouldBeDisplayed: true }"\n      ng-class="{\'lit-card-detail-selected\': litItem.selected}">\n\n      <md-card-content>\n        <img ng-src="{{litItem.thumbnail}}" err-src="{{\'/images/pngs/utilities/404/cloud-404.png\' | cdnAssets}}"\n          style="max-width:100%;" />\n\n        <md-icon class="large content-icon" md-font-icon="zmdi zmdi-collection-video" flex\n          ng-if="$ctrl.isVideo(litItem.weburi)" ng-click="$ctrl.toggleLitLibraryLitItemSelection(litItem)"></md-icon>\n        <md-icon class="large content-icon" md-font-icon="zmdi zmdi-collection-pdf" flex\n          ng-if="$ctrl.isPdf(litItem.weburi)" ng-click="$ctrl.toggleLitLibraryLitItemSelection(litItem)"></md-icon>\n        <md-icon class="large content-icon" md-font-icon="zmdi zmdi-collection-image" flex\n          ng-if="$ctrl.isImage(litItem.weburi)" ng-click="$ctrl.toggleLitLibraryLitItemSelection(litItem)"></md-icon>\n        <md-icon class="large content-icon" md-font-icon="zmdi zmdi-collection-item" flex\n          ng-if="$ctrl.isUnknown(litItem.weburi)" ng-click="$ctrl.toggleLitLibraryLitItemSelection(litItem)"></md-icon>\n        <div layout="row">\n          <div flex="none">\n            <md-checkbox flex aria-label="Literature item selected" ng-model="litItem.selected" class="row-checkbox"\n              ng-change="$ctrl.requestLitStatsUpdate(litItem)" permission\n              permission-only="$ctrl.permissions.boltOns.showroom.edit" />\n            <md-icon permission permission-only="$ctrl.permissions.boltOns.showroom.edit" flex\n              md-font-icon="zmdi zmdi-edit" style="margin-right:6px"\n              ng-click="$ctrl.editButtonClicked(litItem,$event)" />\n          </div>\n          <div flex style="text-align:left;" ng-click="$ctrl.toggleLitLibraryLitItemSelection(litItem)">\n            {{litItem.title}}\n          </div>\n        </div>\n      </md-card-content>\n    </md-card>\n  </div>\n</md-virtual-repeat-container>\n\n<md-virtual-repeat-container md-auto-shrink="false" layout="column" layout-align="center stretch"\n  class="list slideInOut" layout-fill ng-show="!$ctrl.literaturesvc.factoryData.inCardView">\n\n  <div class="lit-library-detail" flex layout="row" layout-align="space-between"\n    md-virtual-repeat="litItem in $ctrl.literaturesvc.literatureItems | filter:{ isShouldBeDisplayed: true }"\n    ng-class="{\'lit-tree-detail-selected\': litItem.selected}">\n\n    <div class="row-actions" flex="noshrink" width="120px" layout="row" layout-align="space-between center">\n      <md-icon class="content-icon" md-font-icon="zmdi zmdi-collection-video" flex\n        ng-if="$ctrl.isVideo(litItem.weburi)"></md-icon>\n      <md-icon class="content-icon" md-font-icon="zmdi zmdi-collection-pdf" flex\n        ng-if="$ctrl.isPdf(litItem.weburi)"></md-icon>\n      <md-icon class="content-icon" md-font-icon="zmdi zmdi-collection-image" flex\n        ng-if="$ctrl.isImage(litItem.weburi)"></md-icon>\n      <md-icon class="content-icon" md-font-icon="zmdi zmdi-collection-item" flex\n        ng-if="$ctrl.isUnknown(litItem.weburi)"></md-icon>\n      <md-checkbox flex aria-label="Literature item selected" ng-model="litItem.selected" class="row-checkbox"\n        ng-change="$ctrl.requestLitStatsUpdate(litItem)" />\n    </div>\n\n    <div flex="grow" layout="column" layout-align="center stretch">\n      <div flex="none" ng-click="$ctrl.toggleLitLibraryLitItemSelection(litItem)" class="lit-item-title">\n        {{litItem.title}}</div>\n      <div flex>\n        <div ng-repeat="extendedTag in litItem.extendedTags" width="auto"\n          ng-class="{\'chiptag2\': true, \'highlighted-tag\': extendedTag.isSelected}"\n          ng-click="$ctrl.onToggleTagForLitItem(extendedTag,litItem)">\n          <span>{{$ctrl.getTagTitle(extendedTag._id)}}</span>\n        </div>\n      </div>\n    </div>\n\n    <md-button class="md-icon-button" flex="10" ng-click="$ctrl.editButtonClicked(litItem, $event)">\n      <md-icon permission permission-only="$ctrl.permissions.boltOns.showroom.edit" flex md-font-icon="zmdi zmdi-edit"\n        style="fill: #ff0000;" />\n    </md-button>\n\n  </div>\n\n  <md-divider></md-divider>\n\n</md-virtual-repeat-container>');
$templateCache.put('app/showroom/literature/main/toolbar/literature-toolbar.tmpl.html','<md-toolbar class="md-table-toolbar md-default">\n  <div class="md-toolbar-tools">\n    <div class="md-subhead" flex="none" ng-show="!showSearch">\n      Library\n    </div>\n\n    <md-input-container ng-show="showSearch" flex class="margin-bottom-0 margin-top-40" zzstyle="margin-left:30px;">\n      <label>Search items</label>\n      <input ng-model="$ctrl.searchtext" aria-label="{{$ctrl.metadata.label}}" ng-show="showSearch"\n        ng-change="$ctrl.searchTextChanged()" focus-on-show />\n    </md-input-container>\n\n    <div flex style="text-align:right">\n\n      <md-button class="md-icon-button fadeRight" permission\n        permission-only="$ctrl.permissions.boltOns.showroom.archive" ng-click="$ctrl.archiveClicked()"\n        ng-show="$ctrl.anythingSelected()">\n        <md-icon style="fill: rgba(0,0,0,0.54);" md-svg-src="{{\'/images/svgs/icons/showroom/delete.svg\' | cdnAssets}}"\n          class="toolbar-ico" />\n        <md-tooltip md-direction="bottom">Archive selected items</md-tooltip>\n      </md-button>\n\n      <md-button class="md-icon-button fadeRight" ng-click="$ctrl.invertCurrentLitSelectionClicked()"\n        ng-show="$ctrl.anythingSelected()">\n        <md-icon style="fill: rgba(0,0,0,0.54);" md-svg-src="{{\'/images/svgs/icons/showroom/flip.svg\' | cdnAssets}}"\n          class="toolbar-ico" />\n        <md-tooltip md-direction="bottom">Invert the current selection</md-tooltip>\n      </md-button>\n\n      <md-button class="md-icon-button fadeRight" ng-click="$ctrl.deselectAllTagsClicked()"\n        ng-show="$ctrl.literatureManager.factoryData.litTagSelectedCount > 0">\n        <md-icon style="fill: rgba(0,0,0,0.54);"\n          md-svg-src="{{\'/images/svgs/icons/showroom/tag-close.svg\' | cdnAssets}}" class="toolbar-ico" />\n        <md-tooltip md-direction="bottom">De-select highlighted tags</md-tooltip>\n      </md-button>\n\n      <md-button class="md-icon-button" ng-click="showSearch = !showSearch" ng-class="{\'md-raised\': showSearch}">\n        <md-icon md-font-icon="zmdi zmdi-search"></md-icon>\n      </md-button>\n\n      <md-button class="md-icon-button" ng-click="$ctrl.filterButtonClicked()"\n        ng-class="{\'md-raised\' : $ctrl.literatureManager.shouldTagFilterBeDisplayed }">\n        <md-icon style="fill: rgba(0,0,0,0.54);"\n          md-svg-src="{{\'/images/svgs/icons/showroom/filter-list.svg\' | cdnAssets}}" class="toolbar-ico" />\n        <md-tooltip md-direction="bottom">Toggle the library filter panel</md-tooltip>\n      </md-button>\n\n      <md-button class="md-icon-button" ng-click="$ctrl.toggleLibraryView()">\n        <ng-md-icon icon="{{$ctrl.literatureManager.factoryData.inCardView ? \'view_module\' : \'view_list\'}}"\n          style="fill: rgba(0,0,0,0.54);"></ng-md-icon>\n        <md-tooltip md-direction="bottom">Toggle view mode</md-tooltip>\n      </md-button>\n\n    </div>\n  </div>\n</md-toolbar>');
$templateCache.put('app/showroom/literature/main/toolbar/literature-tree-toolbar.tmpl.html','<div layout="row" layout-align="space-between center" layout-padding>\n  <div class="toolbar-title" flex="none">\n    <span ng-if="$ctrl.litsvcreference.treeInLitMode">Tag Tree View</span>\n    <span ng-if="!$ctrl.litsvcreference.treeInLitMode">Block Tree View</span>\n  </div>\n\n  <div flex="grow" style="text-align:right">\n    <md-icon md-svg-src="{{\'/images/svgs/icons/showroom/view-module.svg\' | cdnAssets}}" class="toolbar-icon"\n      ng-click="$ctrl.toggleTreeView()" title="Toggle the tree view" />\n  </div>\n</div>');
$templateCache.put('app/showroom/literature/main/tree/literature-block-tree.tmpl.html','<div ng-repeat="block in vm.blocks" class="block-tree">\n  <div ng-click="vm.toggleExpanded(block)" class="category" layout-align="space-between center" layout="row">\n    <div ng-if="block.blocks.length > 0" flex="none">\n      <img class="linedlittriangle"\n        ng-src="{{block.isExpanded && (\'/images/pngs/icons/showroom/down-triangle.png\' | cdnAssets) || (\'/images/pngs/icons/showroom/right-triangle.png\' | cdnAssets)}}" />\n    </div>\n    <div class="block" flex ng-class="{\'highlighted-tag\': block.isSelected}">{{block.nameplate}} <span\n        ng-if="block.literatures && block.literatures.length > 0">({{block.literatures.length}} items)</span></div>\n  </div>\n  <lit-block-tree ng-show="block.isExpanded && block.blocks && block.blocks.length > 0" blocks="block.blocks"\n    class="sub-blocks"></lit-block-tree>\n</div>');
$templateCache.put('app/showroom/literature/main/tree/literature-tree-blocks.tmpl.html','<div ng-repeat="block in vm.blocks" class="block-tree">\n  <div ng-click="vm.toggleExpanded(block)" class="category" layout-align="space-between center" layout="row">\n    <div ng-if="block.blocks.length > 0" flex="none">\n      <img class="linedlittriangle"\n        ng-src="{{block.isExpanded && (\'/images/pngs/icons/showroom/down-triangle.png\' | cdnAssets) || (\'/images/pngs/icons/showroom/right-triangle.png\' | cdnAssets)}}" />\n    </div>\n    <div class="nameplate" flex ng-class="{\'highlighted-tag\': block.isSelected}">{{block.nameplate}} <span\n        ng-if="block.literatures && block.literatures.length > 0">({{block.literatures.length}} items)</span></div>\n  </div>\n  <lit-block-tree ng-show="block.isExpanded && block.blocks && block.blocks.length > 0" blocks="block.blocks"\n    class="sub-blocks"></lit-block-tree>\n</div>');
$templateCache.put('app/showroom/literature/main/tree/literature-tree.tmpl.html','<div ng-repeat="tagcategory in $ctrl.tagssvcreference.tagCategories">\n  <div class="category" ng-click="tagcategory.isExpanded = !tagcategory.isExpanded">\n    <img class="linedlittriangle"\n      ng-src="{{tagcategory.isExpanded && (\'/images/pngs/icons/showroom/down-triangle.png\' | cdnAssets) || (\'/images/pngs/icons/showroom/right-triangle.png\' | cdnAssets)}}" />\n    {{tagcategory.category}}\n  </div>\n  <div class="tag" ng-class="{\'highlighted-tag\': $ctrl.isTagSelected(tag)}" ng-show="tagcategory.isExpanded"\n    ng-repeat="tag in tagcategory.tags" ng-click="$ctrl.onToggleFilterTagSelection(tag)">\n    {{tag.title}}\n  </div>\n</div>');
$templateCache.put('app/forms/settings-page/dialogs/post-show-email-dialog/change-template/tmpl.html','<md-subheader>Email template for this form</md-subheader>\n<zp-email-template-select-control \n  layout-fill \n  layout-padding\n  model="$ctrl.emailTemplate"\n  on-change="$ctrl.updateSelectControl({formProp: \'emailTemplate\', item: item})"\n  config="$ctrl.emailTemplateConfig" \n  formname="$ctrl.formSettingsForm"\n  context="\'formSettings\'">\n</zp-email-template-select-control>');
$templateCache.put('app/forms/settings-page/dialogs/post-show-email-dialog/post-show-email-send/tmpl.html','<div ng-hide="$ctrl.hideBlurb" layout-padding>\n  <div layout="row">\n    <h3>A little about triggering email sends</h3>\n    <span flex></span>\n    <md-button class="md-icon-button">\n      <md-icon md-font-icon="zmdi zmdi-thumb-up" ng-click="$ctrl.setHideBlurb()"></md-icon>\n    </md-button>\n  </div>\n  <p ng-show="$ctrl.templatesSentInfo.templatesSent.length > 0" class="margin-top-0 margin-bottom-0">Below is a list of\n    any previous\n    email send activity for this event. This shows the template name and number of recipients for any email templates\n    used for this event in the past, whether a manual send from here or via app event submissions.\n  </p>\n  <p class="margin-top-0">\n    Changing the email template control below will trigger a preview to run that shows you some counts for who\n    will/won\'t be sent the template.<br>\n    If you wish to use the batch send facility you can do so by clicking the button in the toolbar above and the batch\n    options\n    will appear. This too will run a query and show you counts each time you select a new batch value.\n  </p>\n</div>\n\n<div layout-padding ng-show="!$ctrl.emailTemplate">\n  <p class="md-body-1">\n    Since no template is currently attached to the event, you can\n    attach one and send all your emails in one go here. Select the template you wish to use below.\n  </p>\n</div>\n\n<div layout="column" layout-align="start start">\n\n  <md-subheader layout-fill>Live Template</md-subheader>\n\n  <div layout="row" layout-fill>\n    <zp-email-template-select-control flex="100" layout-padding model="$ctrl.emailTemplate"\n      on-change="$ctrl.updateSelectControl({formProp: \'emailTemplate\', item: item})" config="$ctrl.emailTemplateConfig"\n      formname="$ctrl.formSettingsForm" context="\'formSettings\'">\n    </zp-email-template-select-control>\n  </div>\n\n  <div ng-if="$ctrl.showEmailBatchField" layout-fill>\n    <md-subheader>Sending Email Batches </md-subheader>\n    <div layout-padding>\n      <p class="md-body-1 margin-top-0 margin-bottom-0">Select a batch value below to only send emails to contacts with\n        a matching emailBatch field value.</p>\n      <div layout="row" layout-fill>\n        <md-input-container flex="100" layout-padding>\n          <label>Email batch value</label>\n          <md-select ng-model="$ctrl.batchValue" ng-change="$ctrl.simulateEmailSend()"\n            ng-disabled="!$ctrl.batchSendValues.length || !$ctrl.emailTemplate">\n            <md-option ng-repeat="value in $ctrl.batchSendValues" ng-value="value">\n              {{value}}\n            </md-option>\n          </md-select>\n          <div ng-messages ng-show="$ctrl.showNoBatchValuesWarningMessage" class="animated fadeIn">\n            <span>No email batch values were found for contacts with a response for this event. <br>Be sure to have a\n              field with a databasename of <span class="inline-pre">emailBatch</span> on the contact object</span>\n          </div>\n        </md-input-container>\n      </div>\n    </div>\n  </div>\n\n  <div ng-show="$ctrl.showSendPreviewCounts && !$ctrl.psesResponse" layout="column" layout-align="start start" layout-fill\n    style="margin-top:-25px;">\n    <md-subheader layout-fill>Send Preview</md-subheader>\n    <md-progress-linear ng-if="$ctrl.simulating"></md-progress-linear>\n    <div layout="row" layout-align="start center" ng-hide="$ctrl.simulating">\n      <md-menu>\n        <md-button aria-label="Context menu" class="md-icon-button"\n          ng-disabled="!$ctrl.countOfContactsThatWillReceiveEmail.length"\n          ng-click="$ctrl.openMenu($mdOpenMenu, $event)">\n          <md-icon md-font-icon="zmdi zmdi-account-box-mail"></md-icon>\n        </md-button>\n        <md-menu-content width="3" class="dense">\n          <md-menu-item ng-repeat="contact in $ctrl.countOfContactsThatWillReceiveEmail track by contact.contactid">\n            <div>{{contact.email}}</div>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n      <p class="md-subhead" style="margin-left: 10px; overflow: hidden; text-overflow: ellipsis;">\n        <strong>{{$ctrl.countOfContactsThatWillReceiveEmail.length}}</strong>\n        <ng-pluralize count="$ctrl.countOfContactsThatWillReceiveEmail.length" when="{\'0\': \' contacts will be sent an email using the\',\n              \'1\': \' contact will be sent an email using the \',\n              \'other\': \' contacts will be sent an email using the\'}">\n        </ng-pluralize>\n        <strong>{{$ctrl.emailTemplateTitle}}</strong>\n        template\n      </p>\n    </div>\n    <div layout="row" layout-align="start center" ng-if="$ctrl.countOfContactsAlreadyReceivedThisTemplate.length"\n      ng-hide="$ctrl.simulating">\n      <md-menu>\n        <md-button aria-label="Context menu" class="md-icon-button"\n          ng-disabled="!$ctrl.countOfContactsAlreadyReceivedThisTemplate.length"\n          ng-click="$ctrl.openMenu($mdOpenMenu, $event)">\n          <md-icon md-font-icon="zmdi zmdi-block"></md-icon>\n        </md-button>\n        <md-menu-content width="3" class="dense">\n          <md-menu-item\n            ng-repeat="contact in $ctrl.countOfContactsAlreadyReceivedThisTemplate track by contact.contactid">\n            <div>{{contact.email}}</div>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n      <p class="md-subhead" style="margin-left: 10px;">\n        <strong>{{$ctrl.countOfContactsAlreadyReceivedThisTemplate.length}}</strong>\n        <ng-pluralize count="$ctrl.countOfContactsAlreadyReceivedThisTemplate.length" when="{\'0\': \' contacts will be sent an email because they\\\'ve been sent this template in the past.\',\n              \'1\': \' contact won\\\'t be sent an email because they\\\'ve been sent this template in the past.\',\n              \'other\': \' contacts won\\\'t be sent an email because they\\\'ve been sent this template in the past. \'}">\n        </ng-pluralize>\n      </p>\n    </div>\n    <div layout="row" layout-align="start center" ng-hide="$ctrl.simulating">\n      <md-menu>\n        <md-button aria-label="Context menu" class="md-icon-button"\n          ng-disabled="!$ctrl.countOfContactsWithoutEmailConsentToken.length"\n          ng-click="$ctrl.openMenu($mdOpenMenu, $event)">\n          <md-icon md-font-icon="zmdi zmdi-thumb-down"></md-icon>\n        </md-button>\n        <md-menu-content width="3" class="dense">\n          <md-menu-item ng-repeat="contact in $ctrl.countOfContactsWithoutEmailConsentToken track by contact.contactid">\n            <div>{{contact.email}}</div>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n      <p class="md-subhead" style="margin-left: 10px;">\n        <strong>{{$ctrl.countOfContactsWithoutEmailConsentToken.length}}</strong>\n        <ng-pluralize count="$ctrl.countOfContactsWithoutEmailConsentToken.length" when="{\'0\': \' contacts will be sent an emails because they opted not to.\',\n              \'1\': \' contact won\\\'t be sent an email because they opted not to.\',\n              \'other\': \' contacts won\\\'t be sent an email because they opted not to.\'}">\n        </ng-pluralize>\n      </p>\n    </div>\n  </div>\n\n  <div ng-show="$ctrl.emailSendFactoryData.jobProcessing" layout-fill>\n    <md-subheader layout-fill>{{$ctrl.emailSendFactoryData.loadingText}}</md-subheader>\n  </div>\n  <div ng-show="$ctrl.psesResponse" layout-fill>\n    <md-subheader layout-fill>Send Results</md-subheader>\n    <div layout="row" layout-align="start center">\n      <md-menu>\n        <md-button aria-label="Context menu" class="md-icon-button" ng-disabled="!$ctrl.psesResponse.recipients.length"\n          ng-click="$ctrl.openMenu($mdOpenMenu, $event)">\n          <md-icon md-font-icon="zmdi zmdi-mail-send"></md-icon>\n        </md-button>\n        <md-menu-content width="3" class="dense">\n          <md-menu-item ng-repeat="email in $ctrl.psesResponse.recipients track by $index">\n            <div>{{email}}</div>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n      <p class="md-subhead" style="margin-left: 10px;">\n        <strong>{{$ctrl.psesResponse.recipients.length}}</strong>\n        <ng-pluralize count="$ctrl.psesResponse.recipients.length" when="{\'0\': \' contacts were sent an email.\',\n              \'1\': \' contact was sent an email.\',\n              \'other\': \' contacts were sent an email.\'}">\n        </ng-pluralize>\n      </p>\n    </div>\n    <div layout="row" layout-align="start center" ng-show="$ctrl.invalidEmails.length">\n      <md-menu>\n        <md-button aria-label="Context menu" class="md-icon-button" ng-disabled="!$ctrl.invalidEmails.length"\n          ng-click="$ctrl.openMenu($mdOpenMenu, $event)">\n          <md-icon md-font-icon="zmdi zmdi-mail-send"></md-icon>\n        </md-button>\n        <md-menu-content width="3" class="dense">\n          <md-menu-item ng-repeat="email in $ctrl.invalidEmails track by $index">\n            <div>{{email}}</div>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n      <p class="md-subhead" style="margin-left: 10px;">\n        <strong>{{$ctrl.invalidEmails.length}}</strong>\n        <ng-pluralize count="$ctrl.invalidEmails.length" when="{\'0\': \' were not sent an email due to an invalid email address.\',\n              \'1\': \' wasn\\\'t sent an email due to an invalid email address.\',\n              \'other\': \' contacts were not sent an email due to invalid address.\'}">\n        </ng-pluralize>\n      </p>\n    </div>\n    <p class="md-caption text-align-center">Click the icon to see the respective email addresses</p>\n  </div>\n</div>\n');
$templateCache.put('app/forms/settings-page/dialogs/post-show-email-dialog/previous-activity/tmpl.html','<md-subheader flex="100">\n  <ng-pluralize count="$ctrl.templatesSentInfo.templatesSent.length"\n    when="{\'1\': \'1 template has been used to send emails for this event in the past.\',\n            \'other\': \'{{$ctrl.templatesSentInfo.templatesSent.length}} templates have been used to send emails for this event in the past.\'}">\n  </ng-pluralize>\n</md-subheader>\n<div layout-padding>\n  <div>\n    <div ng-repeat="item in $ctrl.templatesSentInfo.templatesSent" ng-show="$ctrl.showPrevSendsInfo">\n      <div class="cell">\n        <ng-pluralize count="item.countOfSends" when="{\'1\': \'1 contact was sent the \',\n                 \'other\': \'{{item.countOfSends}} contacts were sent the \'}">\n        </ng-pluralize>\n        <strong>{{item._id | zpEmailTemplateTitle }}</strong> template\n      </div>\n      <md-divider ng-if="!$last"></md-divider>\n    </div>\n  </div>\n</div>');
$templateCache.put('app/showroom/blocks/main/sidebar/blocks/add-blocks.tmpl.html','\r\n\r\n<div layout="column" layout-align="start stretch">\n  <div layout="column" layout-align="start stretch" class="blocks-blocks-fixed-scrollable" flex>\r\n      <md-list flex ng-if="vm.blockList.length == 0">\r\n        <md-list-item style="margin-top: 30px;" flex>\r\n          <md-subheader>\r\n            Your block items will appear here, but you don\'t have any yet.\r\n          </md-subheader>\r\n        </md-list-item>\r\n      </md-list>\r\n\r\n      <md-input-container flex="none" style="margin:15px 10px 0" ng-if="vm.blockList.length > 0">\r\n          <label for="search">Search...</label>\r\n          <input name="search" id="search" type="search" ng-model="vm.searchTerm" ng-change="vm.searchTextChanged()" />\r\n      </md-input-container>\r\n\r\n      <div class="lit-library-detail cardish" layout="row" layout-align="space-between center"\r\n           ng-repeat="block in vm.blockList | filter: { isShouldBeDisplayed: true } track by block._id"\r\n           ng-class="{\'lit-tree-detail-selected\': block.selectedForPush}">\r\n\r\n          <div class="lit-lite-row-actions" flex="noshrink" layout="row" layout-align="space-around center">\r\n            <md-checkbox flex aria-label="Block selection checkbox"\r\n               ng-model="block.selectedForPush" class="row-checkbox"\r\n               ng-change="vm.requestBlockStatsUpdate()" />\r\n          </div>\r\n\r\n          <div style="margin-left: 10px;" flex="grow" ng-click="vm.toggleBlockSelection(block)">\r\n            <span ng-if="block.arrayOfParentBlocks && block.arrayOfParentBlocks.length > 0">{{block.arrayOfParentBlocks[0].nameplate}} - </span>\r\n            {{block.nameplate}}\r\n          </div>\r\n\r\n      </div>\r\n  </div>\r\n\r\n  <div flex="none" class="sidebar-actions" layout="column" layout-align="start stretch">\r\n    <md-button class="md-primary md-raised" flex ng-click="vm.applySelectedItemsToCurrentBlockClicked()" ng-disabled="vm.blockssvcreference.stats.countOfBlocksSelectedForPush == 0">Add Selected Items</md-button>\r\n    <md-button class="md-primary md-raised" flex ng-click="vm.addNewBlock()">Create and Add New Block</md-button>\r\n  </div>\n</div>\n');
$templateCache.put('app/showroom/blocks/main/sidebar/literature/add-literature.tmpl.html','\r\n\r\n<div layout="column" layout-align="start stretch">\n  <md-list flex ng-if="vm.literaturesvc.literatureItems.length == 0">\n    <md-list-item style="margin-top: 30px;" flex>\n      <md-subheader>\n        Your literature library items will appear here, but you don\'t have any yet.\n      </md-subheader>\n    </md-list-item>\n  </md-list>\n\n  <div layout="column" layout-align="start stretch" class="blocks-literature-fixed-scrollable" flex>\n      <literature-filter class="literature-library-filter"></literature-filter>\r\n\r\n      <div flex="noshrink" class="lit-library-detail cardish" layout="row" layout-align="space-between">\r\n          <div class="lit-lite-row-actions" flex="noshrink" layout="row" layout-align="space-between center">\r\n            <md-checkbox flex aria-label="Select All checkbox"\r\n               ng-model="vm.selectAll" class="row-checkbox"\r\n               ng-change="vm.toggleSelectAll()" />\r\n          </div>\r\n\r\n          <md-input-container flex="grow" style="margin:15px 10px 0">\r\n              <label for="search">Search...</label>\r\n              <input name="search" id="search" type="search" ng-model="vm.searchTerm" ng-change="vm.searchTextChanged()" />\r\n          </md-input-container>\r\n      </div>\r\n\r\n      <div flex="noshrink" class="lit-library-detail cardish" layout="row" layout-align="space-between stretch"\r\n           ng-repeat="litItem in vm.literaturesvc.literatureItems | filter:{ isShouldBeDisplayed: true }"\r\n           ng-class="{\'lit-tree-detail-selected\': litItem.selected}">\r\n\r\n          <div class="lit-lite-row-actions" flex="noshrink" layout="row" layout-align="space-between center">\r\n            <md-checkbox flex aria-label="Literature item checkbox"\r\n               ng-model="litItem.selected" class="row-checkbox"\r\n               ng-change="vm.requestLitStatsUpdate()" />\r\n          </div>\r\n\r\n          <div flex="grow" layout="column" layout-align="center stretch">\r\n              <div flex="none" ng-click="vm.toggleLitLibraryLitItemSelection(litItem)" class="lit-item-title">{{litItem.title}}</div>\r\n\r\n              <div flex>\r\n                  <div ng-repeat="extendedTag in litItem.extendedTags" width="auto"\r\n                       class="chiptag2">\r\n                      <span>{{vm.getTagTitle(extendedTag._id)}}</span>\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n  </div>\r\n\r\n  <div flex="none" class="sidebar-actions" layout="column" layout-align="start stretch">\r\n    <md-button class="md-primary md-raised" flex ng-click="vm.applySelectedItemsToCurrentBlockClicked()" ng-disabled="vm.literaturesvc.stats.countOfSelectedLiteratureItems == 0">Add Selected Items</md-button>\r\n    <!-- <md-button class="md-primary" flex>Create and Add New Literature Item</md-button> -->\r\n  </div>\n</div>\n');
$templateCache.put('app/showroom/blocks/main/sidebar/options/block-options.tmpl.html','\n<md-content layout="row" layout-padding class="thirds">\n  <md-slider-container flex>\n    <md-input-container>\n      <input flex type="number" ng-model="vm.currentBlock.heightOfBlocks" aria-label="Height of child blocks" aria-controls="height-slider" />\n    </md-input-container>\n    <md-slider ng-discrete press-up="vm.modelChanged()" ng-model="vm.currentBlock.heightOfBlocks" min="40" max="500" id="height-slider" aria-label="Height of child blocks slider" md-vertical class="md-primary" md-range >\n    </md-slider>\n    <h5>Height of Child Blocks</h5>\n  </md-slider-container>\n\n  <md-slider-container flex>\n    <md-input-container>\n      <input flex type="number" ng-model="vm.currentBlock.padding" aria-label="Padding between child blocks" aria-controls="padding-slider" />\n    </md-input-container>\n    <md-slider ng-discrete press-up="vm.modelChanged()" ng-model="vm.currentBlock.padding" min="1" max="100" id="padding-slider" aria-label="Padding between child blocks slider" md-vertical class="md-primary" md-range >\n    </md-slider>\n    <h5>Padding between Child Blocks</h5>\n  </md-slider-container>\n\n  <md-slider-container flex>\n    <md-input-container>\n      <input flex type="number" ng-model="vm.currentBlock.blocksPerRow" aria-label="Number of blocks per row" aria-controls="row-slider" />\n    </md-input-container>\n    <md-slider ng-discrete press-up="vm.modelChanged()" ng-model="vm.currentBlock.blocksPerRow" min="1" max="10" id="row-slider" aria-label="Number of blocks per row slider" md-vertical class="md-primary" md-range >\n    </md-slider>\n    <h5>Number of Blocks per Row</h5>\n  </md-slider-container>\n</md-content>\n\n<md-list ng-cloak>\n  <md-list-item>\n    <md-input-container flex>\n      <label>Name</label>\n      <input ng-change="vm.modelChanged()"\n        ng-model="vm.currentBlock.nameplate" />\n    </md-input-container>\n  </md-list-item>\n\n  <md-list-item>\n    <md-input-container flex>\n      <label>Description</label>\n      <input ng-change="vm.modelChanged()"\n        ng-model="vm.currentBlock.description" />\n    </md-input-container>\n  </md-list-item>\n\n  <md-list-item>\n    <md-input-container flex>\n      <label>Caption</label>\n      <input ng-change="vm.modelChanged()"\n        ng-model="vm.currentBlock.caption" />\n    </md-input-container>\n  </md-list-item>\n\n  <md-list-item>\n    <md-input-container flex>\n        <label>Background Image</label>\n        <md-select ng-model="vm.currentBlock.backgroundImage" ng-change="vm.imageChanged(\'background\')">\n            <md-option><em>None</em></md-option>\n            <md-option ng-repeat="image in vm.listOfImages" ng-value="image._id" >\n                {{image.title}}\n            </md-option>\n            <md-option value="0_new">Upload new image...</md-option>\n        </md-select>\n    </md-input-container>\n  </md-list-item>\n\n  <md-list-item>\n    <md-input-container flex>\n        <label>Nameplate Image</label>\n        <md-select ng-model="vm.currentBlock.nameplateImage" ng-change="vm.imageChanged(\'nameplate\')">\n            <md-option><em>None</em></md-option>\n            <md-option ng-repeat="image in vm.listOfImages" ng-value="image._id" >\n                {{image.title}}\n            </md-option>\n            <md-option value="0_new">Upload new image...</md-option>\n        </md-select>\n    </md-input-container>\n  </md-list-item>\n\n  <md-list-item>\n    <p class="switch-label">Hide Nameplate Caption</p>\n    <md-tooltip>Hides caption so only image displays</md-tooltip>\n    <md-switch class="md-secondary list-switch"\n      name="nameplateHidden" ng-change="vm.modelChanged()"\n      ng-model="vm.currentBlock.nameplateHidden"></md-switch>\n  </md-list-item>\n\n</md-list>\n');
$templateCache.put('app/showroom/blocks/main/sidebar/tree/block-tree.tmpl.html','\n  <div ng-repeat="block in vm.blocks" class="block-tree">\n    <div class="root-block" ng-class="{\'selected\': block.isSelected}" layout-align="space-between center" layout="row">\n      <md-button class="md-icon-button" ng-click="vm.toggleExpanded(block)" ng-if="block.blocks.length > 0" flex="none">\n        <ng-md-icon icon="{{block.isExpanded !== false && \'expand_more\' || \'chevron_right\'}}" style="fill: #949ca1;"></ng-md-icon>\n      </md-button>\n      <div ng-click="vm.selectBlock(block, $event)" class="nameplate" flex>{{block.nameplate}}</div>\n      <div ng-if="(!block.blocks || block.blocks.length == 0) && block.isRootBlock" flex="none" class="tree-button">\n        <md-button ng-click="vm.removeRootBlock(block, $event)" aria-label="Archive block"\n          permission permission-only="vm.permissions.boltOns.showroom.archive">\n          <md-icon class="zmdi zmdi-delete"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <block-tree\n      ng-show="block.isExpanded !== false && block.blocks && block.blocks.length > 0"\n      blocks="block.blocks"\n      deselect-all-blocks="vm.deselectAllBlocks()"\n      update-current-block="vm.updateCurrentBlock(block)"\n      class="sub-blocks">\n    </block-tree>\n\n  </div>\n');
$templateCache.put('app/forms/grid-page/downloads/json-to-csv/getDataReadyForCSV/PrepareModelsForDownload/filename-dialog/filename-dialog.tmpl.html','<md-dialog aria-label="Filename dialog" flex="60">\n  <md-toolbar>\n    <div class="md-toolbar-tools">\n      <h2>{{vm.toolbarTitle}}</h2>\n      <span flex></span>\n      <md-button class="md-icon-button" ng-click="vm.closeDialog()">\n        <md-icon md-font-icon="zmdi zmdi-close" aria-label="Close dialog"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-content layout-fill>\n    <form name="filenameForm" ng-submit="vm.done()">\n      <div layout="column" layout-fill layout-padding layout-align="center center">\n        <md-input-container layout-fill layout-margin class="margin-top-20">\n          <label>Filename</label>\n          <input ng-model="vm.filename" ng-required="!vm.isMac" name="WINfilename" type="text" md-maxlength="175" md-autofocus />\n        </md-input-container>\n        <div ng-messages="filenameForm.WINfilename.$error" ng-if="filenameForm.$error">\n          <div ng-message="md-maxlength">Heads up! Windows doesn\'t like filenames longer than 175 characters. Please shorten your filename.</div>\n        </div>\n        <input type="hidden" name="CSRFToken" value="1231234567890" />\n      </div>\n    </form>\n    <md-dialog-actions layout-align="center center">\n      <md-button ng-click="vm.done()" type="submit" ng-disabled="filenameForm.$invalid" class="md-raised md-accent" flex="100">Download</md-button>\n    </md-dialog-actions>\n</md-dialog>');}]);